/* eslint-disable */
// @ts-nocheck
const value: any =
{
    "name": "Tyria",
    "id": "tyria",
    "texture_dims": [
      81920,
      114688
    ],
    "clamped_view": [
      [
        6800,
        13000
      ],
      [
        81920,
        111000
      ]
    ],
    "regions": {
      "1": {
        "name": "Shiverpeak Mountains",
        "label_coord": [
          52608,
          29952
        ],
        "continent_rect": [
          [
            50432,
            24448
          ],
          [
            56576,
            37760
          ]
        ],
        "maps": {
          "26": {
            "name": "Dredgehaunt Cliffs",
            "min_level": 40,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              53376,
              32960
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                52224,
                31360
              ],
              [
                54528,
                34560
              ]
            ],
            "points_of_interest": {
              "554": {
                "name": "Leaning Grade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52657.7,
                  32978.8
                ],
                "id": 554,
                "chat_link": "[&BCoCAAA=]"
              },
              "555": {
                "name": "Fridgardr Lodge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53607.2,
                  33741.9
                ],
                "id": 555,
                "chat_link": "[&BCsCAAA=]"
              },
              "556": {
                "name": "Mantelet Refuge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53695.3,
                  34226.1
                ],
                "id": 556,
                "chat_link": "[&BCwCAAA=]"
              },
              "557": {
                "name": "Esjudare Scratch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52424.2,
                  33655.3
                ],
                "id": 557,
                "chat_link": "[&BC0CAAA=]"
              },
              "558": {
                "name": "Shelter Pointe",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52377,
                  32976.9
                ],
                "id": 558,
                "chat_link": "[&BC4CAAA=]"
              },
              "559": {
                "name": "Vpered Drill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53270.8,
                  33154
                ],
                "id": 559,
                "chat_link": "[&BC8CAAA=]"
              },
              "560": {
                "name": "Theign Kenning",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53505.7,
                  32286.6
                ],
                "id": 560,
                "chat_link": "[&BDACAAA=]"
              },
              "561": {
                "name": "Landslide Lee",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52770.2,
                  32512.5
                ],
                "id": 561,
                "chat_link": "[&BDECAAA=]"
              },
              "562": {
                "name": "Travelen's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52803.6,
                  31776.8
                ],
                "id": 562,
                "chat_link": "[&BDICAAA=]"
              },
              "563": {
                "name": "Bergtrolde",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53226.5,
                  32130
                ],
                "id": 563,
                "chat_link": "[&BDMCAAA=]"
              },
              "564": {
                "name": "Skovtrolde Hearthstead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53415.6,
                  31629.6
                ],
                "id": 564,
                "chat_link": "[&BDQCAAA=]"
              },
              "565": {
                "name": "Talecrafting Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53825.5,
                  31804.4
                ],
                "id": 565,
                "chat_link": "[&BDUCAAA=]"
              },
              "566": {
                "name": "The Speaking Place",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54343.8,
                  32355.2
                ],
                "id": 566,
                "chat_link": "[&BDYCAAA=]"
              },
              "598": {
                "name": "Tribulation Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52889.5,
                  34117.4
                ],
                "id": 598,
                "chat_link": "[&BFYCAAA=]"
              },
              "599": {
                "name": "Frostland Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53427.1,
                  34290.6
                ],
                "id": 599,
                "chat_link": "[&BFcCAAA=]"
              },
              "600": {
                "name": "Dociu Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54008.3,
                  34034.7
                ],
                "id": 600,
                "chat_link": "[&BFgCAAA=]"
              },
              "601": {
                "name": "Seven Pines Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53816.4,
                  33263.4
                ],
                "id": 601,
                "chat_link": "[&BFkCAAA=]"
              },
              "602": {
                "name": "Grey Road Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53452.6,
                  33489.3
                ],
                "id": 602,
                "chat_link": "[&BFoCAAA=]"
              },
              "603": {
                "name": "Steelbrachen Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52704.6,
                  33489
                ],
                "id": 603,
                "chat_link": "[&BFsCAAA=]"
              },
              "604": {
                "name": "Toran Hollow Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52451.1,
                  32695
                ],
                "id": 604,
                "chat_link": "[&BFwCAAA=]"
              },
              "605": {
                "name": "Hessdallen Kenning Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53075.5,
                  32429
                ],
                "id": 605,
                "chat_link": "[&BF0CAAA=]"
              },
              "606": {
                "name": "Kenning Testing Ground Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53574.8,
                  32721.3
                ],
                "id": 606,
                "chat_link": "[&BF4CAAA=]"
              },
              "607": {
                "name": "Wide Expanse Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54151.4,
                  32611.5
                ],
                "id": 607,
                "chat_link": "[&BF8CAAA=]"
              },
              "608": {
                "name": "Nottowr Fault Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54326,
                  32033.7
                ],
                "id": 608,
                "chat_link": "[&BGACAAA=]"
              },
              "609": {
                "name": "Mountain's Tail Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53932.7,
                  32128
                ],
                "id": 609,
                "chat_link": "[&BGECAAA=]"
              },
              "610": {
                "name": "Graupel Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53573.7,
                  31649.5
                ],
                "id": 610,
                "chat_link": "[&BGICAAA=]"
              },
              "611": {
                "name": "Havfrue Basin Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53272,
                  31898.2
                ],
                "id": 611,
                "chat_link": "[&BGMCAAA=]"
              },
              "612": {
                "name": "Travelen's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52909.4,
                  31809.3
                ],
                "id": 612,
                "chat_link": "[&BGQCAAA=]"
              },
              "613": {
                "name": "Wyrmblood Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52690.2,
                  32156.4
                ],
                "id": 613,
                "chat_link": "[&BGUCAAA=]"
              },
              "1262": {
                "name": "Granite Citadel Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54213.2,
                  33707.6
                ],
                "id": 1262,
                "chat_link": "[&BO4EAAA=]"
              },
              "1266": {
                "name": "Firebase Molek",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53377.6,
                  33990
                ],
                "id": 1266,
                "chat_link": "[&BPIEAAA=]"
              },
              "1267": {
                "name": "Tomb of Morlog",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52470.7,
                  34404.4
                ],
                "id": 1267,
                "chat_link": "[&BPMEAAA=]"
              },
              "1268": {
                "name": "Tomb of Blackpowder",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52856.6,
                  33765.5
                ],
                "id": 1268,
                "chat_link": "[&BPQEAAA=]"
              },
              "1269": {
                "name": "Tomb of Stoneskin",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53377.9,
                  33289.7
                ],
                "id": 1269,
                "chat_link": "[&BPUEAAA=]"
              },
              "1291": {
                "name": "Brandalf's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53710.5,
                  31605.8
                ],
                "id": 1291,
                "chat_link": "[&BAsFAAA=]"
              },
              "1343": {
                "name": "Sorrow's Embrace Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52536.4,
                  34075.8
                ],
                "id": 1343,
                "chat_link": "[&BD8FAAA=]"
              },
              "1486": {
                "name": "Falooaloo",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52528.9,
                  31763.5
                ],
                "id": 1486,
                "chat_link": "[&BM4FAAA=]"
              },
              "1569": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  53139,
                  32387.8
                ],
                "id": 1569,
                "chat_link": "[&BCEGAAA=]"
              },
              "1570": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  53443.2,
                  31642.4
                ],
                "id": 1570,
                "chat_link": "[&BCIGAAA=]"
              },
              "1571": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  52477.6,
                  34432
                ],
                "id": 1571,
                "chat_link": "[&BCMGAAA=]"
              },
              "1572": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  52435,
                  32510.6
                ],
                "id": 1572,
                "chat_link": "[&BCQGAAA=]"
              },
              "1573": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  53292.4,
                  33080.5
                ],
                "id": 1573,
                "chat_link": "[&BCUGAAA=]"
              },
              "1574": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  52664.3,
                  31757
                ],
                "id": 1574,
                "chat_link": "[&BCYGAAA=]"
              },
              "1575": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  53715.7,
                  34145.8
                ],
                "id": 1575,
                "chat_link": "[&BCcGAAA=]"
              },
              "1576": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  54036.3,
                  34281.9
                ],
                "id": 1576,
                "chat_link": "[&BCgGAAA=]"
              },
              "1577": {
                "name": "Bear's Jaws Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52533.9,
                  32623.2
                ],
                "id": 1577,
                "chat_link": "[&BCkGAAA=]"
              },
              "1578": {
                "name": "Leopard's Snarl Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52393.9,
                  31646.8
                ],
                "id": 1578,
                "chat_link": "[&BCoGAAA=]"
              },
              "1579": {
                "name": "Raven's Wing Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54345.7,
                  32889.6
                ],
                "id": 1579,
                "chat_link": "[&BCsGAAA=]"
              },
              "1580": {
                "name": "Wolf's Lair Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53491.6,
                  31388.4
                ],
                "id": 1580,
                "chat_link": "[&BCwGAAA=]"
              },
              "1700": {
                "name": "Ghost Stones",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52692.2,
                  32353.2
                ],
                "id": 1700,
                "chat_link": "[&BKQGAAA=]"
              },
              "1732": {
                "name": "Sorrow's Embrace",
                "type": "unlock",
                "floor": 1,
                "coord": [
                  52444.3,
                  34103.4
                ],
                "id": 1732,
                "chat_link": "[&BMQGAAA=]",
                "icon": "https://render.guildwars2.com/file/943538394A94A491C8632FBEF6203C2013443555/102478.png"
              }
            },
            "tasks": {
              "1": {
                "objective": "Assist Daphne in halting the encroaching corruption.",
                "level": 40,
                "coord": [
                  52412.7,
                  32988.2
                ],
                "bounds": [
                  [
                    52647.3,
                    32760.9
                  ],
                  [
                    52593.6,
                    32714.5
                  ],
                  [
                    52526.2,
                    32718.6
                  ],
                  [
                    52365,
                    32812.5
                  ],
                  [
                    52315.8,
                    32879.6
                  ],
                  [
                    52313.2,
                    33065.1
                  ],
                  [
                    52352.7,
                    33296
                  ],
                  [
                    52443.6,
                    33476.4
                  ],
                  [
                    52733.5,
                    33445.1
                  ],
                  [
                    52924.7,
                    33198.3
                  ],
                  [
                    52804.3,
                    32921.6
                  ],
                  [
                    52647.3,
                    32760.9
                  ]
                ],
                "id": 1,
                "chat_link": "[&BAEAAAA=]"
              },
              "2": {
                "objective": "Assist the skritt of Ratatosk.",
                "level": 45,
                "coord": [
                  54163.6,
                  32112.6
                ],
                "bounds": [
                  [
                    54504.5,
                    31985.3
                  ],
                  [
                    54395.6,
                    31844.7
                  ],
                  [
                    54268.4,
                    31884.2
                  ],
                  [
                    54201,
                    31973.4
                  ],
                  [
                    54175.5,
                    32018.3
                  ],
                  [
                    54111.3,
                    32053.4
                  ],
                  [
                    54050.7,
                    32047.1
                  ],
                  [
                    54011.3,
                    32097.3
                  ],
                  [
                    53996.9,
                    32194.2
                  ],
                  [
                    54011.4,
                    32402.4
                  ],
                  [
                    54161.2,
                    32518
                  ],
                  [
                    54206.4,
                    32594
                  ],
                  [
                    54271.3,
                    32609.4
                  ],
                  [
                    54390.6,
                    32553.4
                  ],
                  [
                    54516.2,
                    32391.4
                  ],
                  [
                    54504.5,
                    31985.3
                  ]
                ],
                "id": 2,
                "chat_link": "[&BAIAAAA=]"
              },
              "3": {
                "objective": "Help Antal the Patient impress the skritt in Kolkorensburg.",
                "level": 41,
                "coord": [
                  52903.5,
                  32422.7
                ],
                "bounds": [
                  [
                    53189.4,
                    32181.4
                  ],
                  [
                    53136.9,
                    31994.2
                  ],
                  [
                    52989.7,
                    31952.2
                  ],
                  [
                    52754.6,
                    32036.2
                  ],
                  [
                    52785,
                    32173.8
                  ],
                  [
                    52726.3,
                    32244
                  ],
                  [
                    52603.6,
                    32284.1
                  ],
                  [
                    52577.8,
                    32452.6
                  ],
                  [
                    52614.1,
                    32557.4
                  ],
                  [
                    52705,
                    32559.4
                  ],
                  [
                    52796.6,
                    32570.2
                  ],
                  [
                    52930.2,
                    32511.9
                  ],
                  [
                    52971.9,
                    32394.5
                  ],
                  [
                    53070.2,
                    32317
                  ],
                  [
                    53189.4,
                    32181.4
                  ]
                ],
                "id": 3,
                "chat_link": "[&BAMAAAA=]"
              },
              "4": {
                "objective": "Help the Priory thwart dredge excavation in Dostoev Sky Peak.",
                "level": 46,
                "coord": [
                  53394.2,
                  33046.7
                ],
                "bounds": [
                  [
                    53483.8,
                    33421
                  ],
                  [
                    53358,
                    33455.2
                  ],
                  [
                    53243.4,
                    33544.3
                  ],
                  [
                    53132.9,
                    33430.4
                  ],
                  [
                    52992.8,
                    33388.7
                  ],
                  [
                    52916.9,
                    33218.6
                  ],
                  [
                    52837.4,
                    33061.3
                  ],
                  [
                    52867.6,
                    32946
                  ],
                  [
                    53010,
                    32882.6
                  ],
                  [
                    53111,
                    32813.1
                  ],
                  [
                    53239.6,
                    32785.8
                  ],
                  [
                    53340.9,
                    32810.1
                  ],
                  [
                    53429.1,
                    32873.2
                  ],
                  [
                    53544.7,
                    32914
                  ],
                  [
                    53636.6,
                    32891.5
                  ],
                  [
                    53694.6,
                    32982
                  ],
                  [
                    53726.3,
                    33121.5
                  ],
                  [
                    53726.6,
                    33286.5
                  ],
                  [
                    53631.3,
                    33336.8
                  ],
                  [
                    53560.7,
                    33369.2
                  ],
                  [
                    53483.8,
                    33421
                  ]
                ],
                "id": 4,
                "chat_link": "[&BAQAAAA=]"
              },
              "5": {
                "objective": "Help Arcanist Vance study dwarven relics at Granite Citadel.",
                "level": 47,
                "coord": [
                  54217.1,
                  33882.8
                ],
                "bounds": [
                  [
                    54168.2,
                    33462.1
                  ],
                  [
                    54228.1,
                    33483
                  ],
                  [
                    54255.6,
                    33612.7
                  ],
                  [
                    54332.9,
                    33580.6
                  ],
                  [
                    54382.5,
                    33718.9
                  ],
                  [
                    54388.3,
                    33948.4
                  ],
                  [
                    54375.8,
                    34044
                  ],
                  [
                    54305.1,
                    34082.3
                  ],
                  [
                    54248,
                    34096.4
                  ],
                  [
                    54172.7,
                    34094.1
                  ],
                  [
                    54141.1,
                    34087.3
                  ],
                  [
                    54110.2,
                    34043.6
                  ],
                  [
                    54056.7,
                    33994.5
                  ],
                  [
                    54079.5,
                    33911.7
                  ],
                  [
                    54003.3,
                    33768.3
                  ],
                  [
                    54074.6,
                    33628.8
                  ],
                  [
                    54126.9,
                    33537
                  ],
                  [
                    54168.2,
                    33462.1
                  ]
                ],
                "id": 5,
                "chat_link": "[&BAUAAAA=]"
              },
              "6": {
                "objective": "Help Magister Roslin infiltrate Black Earth Mine.",
                "level": 48,
                "coord": [
                  54050.4,
                  34042.3
                ],
                "bounds": [
                  [
                    54245.8,
                    34540.9
                  ],
                  [
                    54376.8,
                    34553.7
                  ],
                  [
                    54519.5,
                    34462.5
                  ],
                  [
                    54516.7,
                    34134.5
                  ],
                  [
                    54369.6,
                    34059.8
                  ],
                  [
                    54302.9,
                    34097.9
                  ],
                  [
                    54182.2,
                    34113.3
                  ],
                  [
                    54133.6,
                    34098.2
                  ],
                  [
                    54101,
                    34052.6
                  ],
                  [
                    54039.9,
                    33998.1
                  ],
                  [
                    53948.1,
                    33971.1
                  ],
                  [
                    53885.3,
                    34090.8
                  ],
                  [
                    53805,
                    34164.9
                  ],
                  [
                    53790,
                    34223.7
                  ],
                  [
                    53762.3,
                    34302.7
                  ],
                  [
                    53751.7,
                    34359.5
                  ],
                  [
                    53922.1,
                    34526.9
                  ],
                  [
                    54114,
                    34575.1
                  ],
                  [
                    54245.8,
                    34540.9
                  ]
                ],
                "id": 6,
                "chat_link": "[&BAYAAAA=]"
              },
              "7": {
                "objective": "Help Explorer Brokkar sabotage dredge munitions.",
                "level": 49,
                "coord": [
                  53182.9,
                  34145.3
                ],
                "bounds": [
                  [
                    53250.3,
                    34123.6
                  ],
                  [
                    53154.4,
                    34094.4
                  ],
                  [
                    53093.1,
                    34108.4
                  ],
                  [
                    53088.2,
                    34152.7
                  ],
                  [
                    53083.9,
                    34196.6
                  ],
                  [
                    53080.6,
                    34238.9
                  ],
                  [
                    53016.7,
                    34269.9
                  ],
                  [
                    52960.9,
                    34337.1
                  ],
                  [
                    52943.9,
                    34452.4
                  ],
                  [
                    53000.2,
                    34482.9
                  ],
                  [
                    53068.6,
                    34472
                  ],
                  [
                    53123.8,
                    34416.8
                  ],
                  [
                    53217.6,
                    34396.5
                  ],
                  [
                    53312.7,
                    34335.1
                  ],
                  [
                    53312.4,
                    34190.1
                  ],
                  [
                    53250.3,
                    34123.6
                  ]
                ],
                "id": 7,
                "chat_link": "[&BAcAAAA=]"
              },
              "8": {
                "objective": "Help Magister Kathryn wound dredge forces.",
                "level": 50,
                "coord": [
                  52869.6,
                  34177.3
                ],
                "bounds": [
                  [
                    52411.6,
                    34502.3
                  ],
                  [
                    52573.3,
                    34542
                  ],
                  [
                    52714.4,
                    34487.7
                  ],
                  [
                    52823.8,
                    34406.9
                  ],
                  [
                    52938.6,
                    34265.1
                  ],
                  [
                    52918,
                    34144.8
                  ],
                  [
                    52809.9,
                    34077.3
                  ],
                  [
                    52688.5,
                    34037.2
                  ],
                  [
                    52618.2,
                    34090.2
                  ],
                  [
                    52485.2,
                    34165.1
                  ],
                  [
                    52394.8,
                    34301.4
                  ],
                  [
                    52411.6,
                    34502.3
                  ]
                ],
                "id": 8,
                "chat_link": "[&BAgAAAA=]"
              },
              "9": {
                "objective": "Protect the Snow Leopard shrine from the Svanir.",
                "level": 42,
                "coord": [
                  52619.5,
                  31987
                ],
                "bounds": [
                  [
                    52351.6,
                    31821.8
                  ],
                  [
                    52312.4,
                    31684.4
                  ],
                  [
                    52400.3,
                    31565.9
                  ],
                  [
                    52663.3,
                    31558.5
                  ],
                  [
                    52757.4,
                    31647.8
                  ],
                  [
                    52753,
                    31722.7
                  ],
                  [
                    52633.2,
                    31770.9
                  ],
                  [
                    52601.7,
                    31840.5
                  ],
                  [
                    52661.8,
                    31977.5
                  ],
                  [
                    52532.6,
                    32071.5
                  ],
                  [
                    52361.6,
                    31994.9
                  ],
                  [
                    52351.6,
                    31821.8
                  ]
                ],
                "id": 9,
                "chat_link": "[&BAkAAAA=]"
              },
              "10": {
                "objective": "Defend Travelen's Steading against Svanir attacks.",
                "level": 43,
                "coord": [
                  52781.3,
                  31794.2
                ],
                "bounds": [
                  [
                    52745.5,
                    31734.7
                  ],
                  [
                    52639.7,
                    31773.3
                  ],
                  [
                    52611.8,
                    31838.8
                  ],
                  [
                    52645.3,
                    31902.2
                  ],
                  [
                    52826,
                    31988.8
                  ],
                  [
                    53060.8,
                    31928.2
                  ],
                  [
                    53146.2,
                    31743.2
                  ],
                  [
                    53041.6,
                    31664.2
                  ],
                  [
                    52745.5,
                    31734.7
                  ]
                ],
                "id": 10,
                "chat_link": "[&BAoAAAA=]"
              },
              "11": {
                "objective": "Help the grawl stave off Svanir attacks.",
                "level": 44,
                "coord": [
                  53612.3,
                  32065.8
                ],
                "bounds": [
                  [
                    53504.7,
                    32088
                  ],
                  [
                    53497.6,
                    31851.7
                  ],
                  [
                    53760.6,
                    31671.7
                  ],
                  [
                    54152.6,
                    31779.6
                  ],
                  [
                    54209.1,
                    31876
                  ],
                  [
                    54148.9,
                    31992.8
                  ],
                  [
                    54024.3,
                    31995.4
                  ],
                  [
                    53911.9,
                    32139.1
                  ],
                  [
                    53587.2,
                    32157.5
                  ],
                  [
                    53504.7,
                    32088
                  ]
                ],
                "id": 11,
                "chat_link": "[&BAsAAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  53149.6,
                  32997.8
                ],
                "id": "0-29"
              },
              {
                "coord": [
                  54055.3,
                  32781.8
                ],
                "id": "0-33"
              },
              {
                "coord": [
                  54427.2,
                  34466.4
                ],
                "id": "0-89"
              },
              {
                "coord": [
                  52340.7,
                  33646.6
                ],
                "id": "0-91"
              },
              {
                "coord": [
                  53436.7,
                  32267.5
                ],
                "id": "0-58"
              },
              {
                "coord": [
                  54366.7,
                  32335.9
                ],
                "id": "0-90"
              }
            ],
            "sectors": {
              "513": {
                "name": "Tribulation Rift",
                "level": 50,
                "coord": [
                  52584,
                  34298.8
                ],
                "bounds": [
                  [
                    52958.2,
                    34291.2
                  ],
                  [
                    52837.4,
                    34445.1
                  ],
                  [
                    52840.8,
                    34659.1
                  ],
                  [
                    52639.2,
                    34694.9
                  ],
                  [
                    52367.6,
                    34641.9
                  ],
                  [
                    52451.3,
                    34504.9
                  ],
                  [
                    52375.3,
                    34444.1
                  ],
                  [
                    52379,
                    34388.7
                  ],
                  [
                    52456,
                    34336.2
                  ],
                  [
                    52443.4,
                    34171.7
                  ],
                  [
                    52385.4,
                    34129.2
                  ],
                  [
                    52400.6,
                    34080.1
                  ],
                  [
                    52487.6,
                    34043.5
                  ],
                  [
                    52486.7,
                    34004.1
                  ],
                  [
                    52609.8,
                    34001.6
                  ],
                  [
                    52876.6,
                    34089
                  ],
                  [
                    52933.4,
                    34153.8
                  ],
                  [
                    52958.2,
                    34291.2
                  ]
                ],
                "id": 513,
                "chat_link": "[&BAECAAA=]"
              },
              "514": {
                "name": "De Molish Post",
                "level": 50,
                "coord": [
                  53016.1,
                  34454.5
                ],
                "bounds": [
                  [
                    52838.5,
                    34660.4
                  ],
                  [
                    53170.2,
                    34564.7
                  ],
                  [
                    53154.3,
                    34455.5
                  ],
                  [
                    53140.9,
                    34308
                  ],
                  [
                    52956.2,
                    34291.6
                  ],
                  [
                    52836.3,
                    34446.5
                  ],
                  [
                    52838.5,
                    34660.4
                  ]
                ],
                "id": 514,
                "chat_link": "[&BAICAAA=]"
              },
              "515": {
                "name": "Dissun's Mine",
                "level": 41,
                "coord": [
                  52396.9,
                  33667.1
                ],
                "bounds": [
                  [
                    52608.3,
                    34003.8
                  ],
                  [
                    52505.9,
                    33913.1
                  ],
                  [
                    52562.9,
                    33652.3
                  ],
                  [
                    52539.6,
                    33515.9
                  ],
                  [
                    52453.5,
                    33401.1
                  ],
                  [
                    52341.5,
                    33312.7
                  ],
                  [
                    52298.2,
                    33343.3
                  ],
                  [
                    52225,
                    33352.6
                  ],
                  [
                    52144.6,
                    33806.7
                  ],
                  [
                    52250.1,
                    34030.6
                  ],
                  [
                    52436.2,
                    34005.8
                  ],
                  [
                    52608.3,
                    34003.8
                  ]
                ],
                "id": 515,
                "chat_link": "[&BAMCAAA=]"
              },
              "516": {
                "name": "Heimdahl's Last Stand",
                "level": 49,
                "coord": [
                  52803.3,
                  33923.4
                ],
                "bounds": [
                  [
                    52956.2,
                    34291.6
                  ],
                  [
                    53145.8,
                    34308.3
                  ],
                  [
                    53172.6,
                    33931.8
                  ],
                  [
                    52855.8,
                    33898.1
                  ],
                  [
                    52754.8,
                    33802.5
                  ],
                  [
                    52734.5,
                    33521.4
                  ],
                  [
                    52540.1,
                    33515
                  ],
                  [
                    52563.2,
                    33652
                  ],
                  [
                    52501.3,
                    33912.1
                  ],
                  [
                    52608.6,
                    34002.8
                  ],
                  [
                    52876.4,
                    34091.2
                  ],
                  [
                    52930.6,
                    34154.5
                  ],
                  [
                    52956.2,
                    34291.6
                  ]
                ],
                "id": 516,
                "chat_link": "[&BAQCAAA=]"
              },
              "517": {
                "name": "Kapellenburg",
                "level": 49,
                "coord": [
                  52928.8,
                  33705.1
                ],
                "bounds": [
                  [
                    52823.7,
                    33426.7
                  ],
                  [
                    52993.5,
                    33641.7
                  ],
                  [
                    53177,
                    33711.4
                  ],
                  [
                    53164,
                    33933.6
                  ],
                  [
                    52855,
                    33898.4
                  ],
                  [
                    52753.9,
                    33802.9
                  ],
                  [
                    52734.4,
                    33521
                  ],
                  [
                    52823.7,
                    33426.7
                  ]
                ],
                "id": 517,
                "chat_link": "[&BAUCAAA=]"
              },
              "518": {
                "name": "Frostland Melt",
                "level": 49,
                "coord": [
                  53478,
                  34305.7
                ],
                "bounds": [
                  [
                    53183.5,
                    33541.8
                  ],
                  [
                    53296.7,
                    33608.4
                  ],
                  [
                    53847.3,
                    34137.5
                  ],
                  [
                    53850.1,
                    34188.1
                  ],
                  [
                    53742.4,
                    34302.9
                  ],
                  [
                    53759,
                    34537.3
                  ],
                  [
                    53549.2,
                    34580.5
                  ],
                  [
                    53489.4,
                    34657.9
                  ],
                  [
                    53388.7,
                    34664.5
                  ],
                  [
                    53329,
                    34580.6
                  ],
                  [
                    53164.2,
                    34564.9
                  ],
                  [
                    53136.8,
                    34304
                  ],
                  [
                    53183.5,
                    33541.8
                  ]
                ],
                "id": 518,
                "chat_link": "[&BAYCAAA=]"
              },
              "519": {
                "name": "Dociu Excavation",
                "level": 49,
                "coord": [
                  54077.4,
                  34185.7
                ],
                "bounds": [
                  [
                    53850.6,
                    34188.1
                  ],
                  [
                    53987.3,
                    34311.8
                  ],
                  [
                    54171.8,
                    34373.2
                  ],
                  [
                    54359.5,
                    34186.7
                  ],
                  [
                    54258.9,
                    34063.3
                  ],
                  [
                    54067.8,
                    34039.3
                  ],
                  [
                    53846.3,
                    34137.8
                  ],
                  [
                    53850.6,
                    34188.1
                  ]
                ],
                "id": 519,
                "chat_link": "[&BAcCAAA=]"
              },
              "520": {
                "name": "Black Earth Coalmine",
                "level": 49,
                "coord": [
                  54187.4,
                  34396.4
                ],
                "bounds": [
                  [
                    53757.2,
                    34542.2
                  ],
                  [
                    54009.2,
                    34542.2
                  ],
                  [
                    54245.5,
                    34660.4
                  ],
                  [
                    54379.9,
                    34653
                  ],
                  [
                    54467.5,
                    34529.5
                  ],
                  [
                    54497.1,
                    34414.3
                  ],
                  [
                    54473,
                    34262.8
                  ],
                  [
                    54495,
                    34187.1
                  ],
                  [
                    54359.7,
                    34186.1
                  ],
                  [
                    54172,
                    34372.5
                  ],
                  [
                    53988.4,
                    34311.4
                  ],
                  [
                    53849.5,
                    34188.4
                  ],
                  [
                    53742.1,
                    34302.8
                  ],
                  [
                    53757.2,
                    34542.2
                  ]
                ],
                "id": 520,
                "chat_link": "[&BAgCAAA=]"
              },
              "521": {
                "name": "Betrayal Grounds",
                "level": 48,
                "coord": [
                  54284.8,
                  33986.1
                ],
                "bounds": [
                  [
                    54067.7,
                    34039.1
                  ],
                  [
                    54258.8,
                    34063.4
                  ],
                  [
                    54359.3,
                    34186.6
                  ],
                  [
                    54493.1,
                    34190.7
                  ],
                  [
                    54414.2,
                    33814.8
                  ],
                  [
                    54387,
                    33828.5
                  ],
                  [
                    54225.3,
                    33913
                  ],
                  [
                    54073.6,
                    33853.1
                  ],
                  [
                    54067.7,
                    34039.1
                  ]
                ],
                "id": 521,
                "chat_link": "[&BAkCAAA=]"
              },
              "522": {
                "name": "Spearhead Bane",
                "level": 48,
                "coord": [
                  54229.2,
                  33660.3
                ],
                "bounds": [
                  [
                    53984.1,
                    33653.9
                  ],
                  [
                    54002,
                    33484.6
                  ],
                  [
                    54158.3,
                    33367.6
                  ],
                  [
                    54353,
                    33443.5
                  ],
                  [
                    54446.6,
                    33591.8
                  ],
                  [
                    54432.1,
                    33808.5
                  ],
                  [
                    54386.6,
                    33826.6
                  ],
                  [
                    54224.9,
                    33913.5
                  ],
                  [
                    54075.2,
                    33852.7
                  ],
                  [
                    53984.1,
                    33653.9
                  ]
                ],
                "id": 522,
                "chat_link": "[&BAoCAAA=]"
              },
              "523": {
                "name": "The Grey Road",
                "level": 48,
                "coord": [
                  53707.3,
                  33615
                ],
                "bounds": [
                  [
                    53183.5,
                    33541.8
                  ],
                  [
                    53378.3,
                    33430.1
                  ],
                  [
                    53575.6,
                    33350.8
                  ],
                  [
                    53665.2,
                    33369.4
                  ],
                  [
                    53702.7,
                    33293.3
                  ],
                  [
                    54002.8,
                    33485.1
                  ],
                  [
                    53985,
                    33654.4
                  ],
                  [
                    54075.5,
                    33853.7
                  ],
                  [
                    54067.3,
                    34039.3
                  ],
                  [
                    53847.8,
                    34137.8
                  ],
                  [
                    53296.8,
                    33609.1
                  ],
                  [
                    53183.5,
                    33541.8
                  ]
                ],
                "id": 523,
                "chat_link": "[&BAsCAAA=]"
              },
              "524": {
                "name": "Rat's Run",
                "level": 49,
                "coord": [
                  52988.1,
                  33496.5
                ],
                "bounds": [
                  [
                    53176.7,
                    33709.4
                  ],
                  [
                    53183.8,
                    33542.3
                  ],
                  [
                    52929.3,
                    33229
                  ],
                  [
                    52822.3,
                    33429.6
                  ],
                  [
                    52823.4,
                    33427.3
                  ],
                  [
                    52993.1,
                    33641.6
                  ],
                  [
                    53176.7,
                    33709.4
                  ]
                ],
                "id": 524,
                "chat_link": "[&BAwCAAA=]"
              },
              "525": {
                "name": "Steelbrachen",
                "level": 40,
                "coord": [
                  52584.8,
                  33227.1
                ],
                "bounds": [
                  [
                    52454.4,
                    33402.8
                  ],
                  [
                    52354,
                    33316.3
                  ],
                  [
                    52305.7,
                    33350
                  ],
                  [
                    52228.9,
                    33357
                  ],
                  [
                    52227,
                    32954.9
                  ],
                  [
                    52562.4,
                    32803.2
                  ],
                  [
                    52948.6,
                    32877.9
                  ],
                  [
                    52908.2,
                    32971.9
                  ],
                  [
                    52930.3,
                    33227.7
                  ],
                  [
                    52824.1,
                    33427.4
                  ],
                  [
                    52734.2,
                    33521.5
                  ],
                  [
                    52540.3,
                    33515.1
                  ],
                  [
                    52454.4,
                    33402.8
                  ]
                ],
                "id": 525,
                "chat_link": "[&BA0CAAA=]"
              },
              "526": {
                "name": "Dostoev Sky Peak",
                "level": 46,
                "coord": [
                  53332.9,
                  33110.1
                ],
                "bounds": [
                  [
                    52909.6,
                    32970.4
                  ],
                  [
                    52948.5,
                    32877.1
                  ],
                  [
                    53208.8,
                    32646.2
                  ],
                  [
                    53306.2,
                    32671.4
                  ],
                  [
                    53459.6,
                    32917.4
                  ],
                  [
                    53725.9,
                    33022.9
                  ],
                  [
                    53703.5,
                    33294.6
                  ],
                  [
                    53664.6,
                    33370.1
                  ],
                  [
                    53576.5,
                    33351
                  ],
                  [
                    53379.9,
                    33430
                  ],
                  [
                    53183.2,
                    33542.4
                  ],
                  [
                    52928.9,
                    33227.6
                  ],
                  [
                    52909.6,
                    32970.4
                  ]
                ],
                "id": 526,
                "chat_link": "[&BA4CAAA=]"
              },
              "527": {
                "name": "Nakrojos Pass",
                "level": 48,
                "coord": [
                  54193.2,
                  33273.5
                ],
                "bounds": [
                  [
                    54002.6,
                    33486
                  ],
                  [
                    54159.5,
                    33368
                  ],
                  [
                    54352.5,
                    33443.5
                  ],
                  [
                    54454,
                    33588
                  ],
                  [
                    54506.8,
                    33388.8
                  ],
                  [
                    54514.3,
                    33101
                  ],
                  [
                    54465.8,
                    32947.9
                  ],
                  [
                    54048.9,
                    33094.3
                  ],
                  [
                    53725.1,
                    33022.5
                  ],
                  [
                    53702.8,
                    33294.8
                  ],
                  [
                    54002.6,
                    33486
                  ]
                ],
                "id": 527,
                "chat_link": "[&BA8CAAA=]"
              },
              "528": {
                "name": "The Wide Expanse",
                "level": 46,
                "coord": [
                  54143.2,
                  32786.8
                ],
                "bounds": [
                  [
                    53725.5,
                    33024.6
                  ],
                  [
                    54049.2,
                    33094.9
                  ],
                  [
                    54464.5,
                    32949.2
                  ],
                  [
                    54561.2,
                    32807.2
                  ],
                  [
                    54617.4,
                    32644.2
                  ],
                  [
                    54686.5,
                    32572.4
                  ],
                  [
                    53986.1,
                    32504.5
                  ],
                  [
                    53737.8,
                    32566.4
                  ],
                  [
                    53460.9,
                    32917.5
                  ],
                  [
                    53725.5,
                    33024.6
                  ]
                ],
                "id": 528,
                "chat_link": "[&BBACAAA=]"
              },
              "529": {
                "name": "Theign Spiritwalk",
                "level": 44,
                "coord": [
                  53483.1,
                  32435.1
                ],
                "bounds": [
                  [
                    53209.9,
                    32645.9
                  ],
                  [
                    53376.5,
                    32370.6
                  ],
                  [
                    53381.7,
                    32253.4
                  ],
                  [
                    53463.7,
                    32107.2
                  ],
                  [
                    53643.2,
                    32096
                  ],
                  [
                    53769.1,
                    32285.8
                  ],
                  [
                    53738.1,
                    32567
                  ],
                  [
                    53460.6,
                    32917.7
                  ],
                  [
                    53305.1,
                    32672.7
                  ],
                  [
                    53209.9,
                    32645.9
                  ]
                ],
                "id": 529,
                "chat_link": "[&BBECAAA=]"
              },
              "530": {
                "name": "Troll's Teeth",
                "level": 42,
                "coord": [
                  52926.2,
                  32485
                ],
                "bounds": [
                  [
                    52562.3,
                    32803.9
                  ],
                  [
                    52949,
                    32878.3
                  ],
                  [
                    53209.5,
                    32647.3
                  ],
                  [
                    53377.6,
                    32371.2
                  ],
                  [
                    53381.7,
                    32253.2
                  ],
                  [
                    53129.3,
                    32147.4
                  ],
                  [
                    53061.8,
                    32296.7
                  ],
                  [
                    52726.3,
                    32445.3
                  ],
                  [
                    52568.1,
                    32432.5
                  ],
                  [
                    52558.7,
                    32475.5
                  ],
                  [
                    52663.8,
                    32584
                  ],
                  [
                    52562.3,
                    32803.9
                  ]
                ],
                "id": 530,
                "chat_link": "[&BBICAAA=]"
              },
              "531": {
                "name": "Toran Hollow",
                "level": 40,
                "coord": [
                  52395.2,
                  32614.9
                ],
                "bounds": [
                  [
                    52233.9,
                    32427.9
                  ],
                  [
                    52547.4,
                    32338.1
                  ],
                  [
                    52568,
                    32431.3
                  ],
                  [
                    52559.7,
                    32475.8
                  ],
                  [
                    52664.4,
                    32584.5
                  ],
                  [
                    52562.6,
                    32803.3
                  ],
                  [
                    52229.3,
                    32951.5
                  ],
                  [
                    52095.1,
                    32930.2
                  ],
                  [
                    52096.5,
                    32591.7
                  ],
                  [
                    52233.9,
                    32427.9
                  ]
                ],
                "id": 531,
                "chat_link": "[&BBMCAAA=]"
              },
              "532": {
                "name": "Wyrmblood Lake",
                "level": 42,
                "coord": [
                  52428.9,
                  31717.9
                ],
                "bounds": [
                  [
                    52706.7,
                    31305.5
                  ],
                  [
                    52695.8,
                    31728.3
                  ],
                  [
                    52706.9,
                    32138.8
                  ],
                  [
                    52547.2,
                    32339.9
                  ],
                  [
                    52233.8,
                    32431.1
                  ],
                  [
                    52205.6,
                    32022.7
                  ],
                  [
                    52180.1,
                    31739.4
                  ],
                  [
                    52143.2,
                    31517.7
                  ],
                  [
                    52235.1,
                    31243.7
                  ],
                  [
                    52450.9,
                    31193.8
                  ],
                  [
                    52612.5,
                    31235.7
                  ],
                  [
                    52706.7,
                    31305.5
                  ]
                ],
                "id": 532,
                "chat_link": "[&BBQCAAA=]"
              },
              "533": {
                "name": "Kolkorensburg",
                "level": 42,
                "coord": [
                  52811.1,
                  32209.9
                ],
                "bounds": [
                  [
                    52565.5,
                    32434
                  ],
                  [
                    52726.3,
                    32445.9
                  ],
                  [
                    53062.2,
                    32296.9
                  ],
                  [
                    53128.2,
                    32146.9
                  ],
                  [
                    53049.9,
                    31943.1
                  ],
                  [
                    52700.4,
                    31937.7
                  ],
                  [
                    52707.4,
                    32138.1
                  ],
                  [
                    52548.9,
                    32336.7
                  ],
                  [
                    52565.5,
                    32434
                  ]
                ],
                "id": 533,
                "chat_link": "[&BBUCAAA=]"
              },
              "534": {
                "name": "Snowslide Ravine",
                "level": 43,
                "coord": [
                  53000.8,
                  31575.4
                ],
                "bounds": [
                  [
                    53332.4,
                    31318.5
                  ],
                  [
                    53243.2,
                    31659.1
                  ],
                  [
                    53222.5,
                    31800.2
                  ],
                  [
                    53050.3,
                    31943
                  ],
                  [
                    52699.2,
                    31938.8
                  ],
                  [
                    52694.9,
                    31728
                  ],
                  [
                    52709.3,
                    31311.1
                  ],
                  [
                    52861.6,
                    31376.3
                  ],
                  [
                    53012.8,
                    31310.4
                  ],
                  [
                    53181.6,
                    31368.2
                  ],
                  [
                    53332.4,
                    31318.5
                  ]
                ],
                "id": 534,
                "chat_link": "[&BBYCAAA=]"
              },
              "535": {
                "name": "Graupel Kohn",
                "level": 44,
                "coord": [
                  53519.9,
                  31683.6
                ],
                "bounds": [
                  [
                    53381.6,
                    32253.9
                  ],
                  [
                    53463.6,
                    32107.5
                  ],
                  [
                    53642.7,
                    32096.5
                  ],
                  [
                    53735.5,
                    31756.3
                  ],
                  [
                    53994,
                    31644
                  ],
                  [
                    53957.4,
                    31366.6
                  ],
                  [
                    53756.3,
                    31368
                  ],
                  [
                    53733.9,
                    31238.8
                  ],
                  [
                    53602.2,
                    31248.8
                  ],
                  [
                    53555,
                    31306.4
                  ],
                  [
                    53333.2,
                    31318.6
                  ],
                  [
                    53243.3,
                    31658.9
                  ],
                  [
                    53222.1,
                    31799.3
                  ],
                  [
                    53049,
                    31942.9
                  ],
                  [
                    53128.9,
                    32147.3
                  ],
                  [
                    53381.6,
                    32253.9
                  ]
                ],
                "id": 535,
                "chat_link": "[&BBcCAAA=]"
              },
              "536": {
                "name": "Mountain's Tail",
                "level": 45,
                "coord": [
                  54013.6,
                  31978.6
                ],
                "bounds": [
                  [
                    53768.5,
                    32285.4
                  ],
                  [
                    53642.8,
                    32096
                  ],
                  [
                    53734.8,
                    31755.8
                  ],
                  [
                    53989.9,
                    31644.7
                  ],
                  [
                    54176.5,
                    31620
                  ],
                  [
                    54195.1,
                    31747.3
                  ],
                  [
                    54187.5,
                    31814.8
                  ],
                  [
                    54215.3,
                    31838.1
                  ],
                  [
                    54247.7,
                    31833.6
                  ],
                  [
                    54235.5,
                    31956.5
                  ],
                  [
                    54061.4,
                    32055.9
                  ],
                  [
                    53983.8,
                    32506.3
                  ],
                  [
                    53737.7,
                    32567.5
                  ],
                  [
                    53768.5,
                    32285.4
                  ]
                ],
                "id": 536,
                "chat_link": "[&BBgCAAA=]"
              },
              "537": {
                "name": "Ulukk's Hunger",
                "level": 45,
                "coord": [
                  54346,
                  31725.7
                ],
                "bounds": [
                  [
                    54402.4,
                    31803
                  ],
                  [
                    54536.1,
                    31716.6
                  ],
                  [
                    54557.6,
                    31668.8
                  ],
                  [
                    54526.3,
                    31578.1
                  ],
                  [
                    54173.7,
                    31619.7
                  ],
                  [
                    54190.5,
                    31748
                  ],
                  [
                    54176.2,
                    31823.1
                  ],
                  [
                    54205.2,
                    31847.9
                  ],
                  [
                    54402.4,
                    31803
                  ]
                ],
                "id": 537,
                "chat_link": "[&BBkCAAA=]"
              },
              "538": {
                "name": "Ratatosk",
                "level": 45,
                "coord": [
                  54445.7,
                  32103.4
                ],
                "bounds": [
                  [
                    54685.8,
                    32588.4
                  ],
                  [
                    54732.8,
                    32431.5
                  ],
                  [
                    54816.6,
                    32271.3
                  ],
                  [
                    54964.5,
                    32151.7
                  ],
                  [
                    54573.6,
                    31898.9
                  ],
                  [
                    54535,
                    31717.3
                  ],
                  [
                    54402.4,
                    31802.7
                  ],
                  [
                    54248.1,
                    31832.9
                  ],
                  [
                    54235,
                    31956.7
                  ],
                  [
                    54110.6,
                    32027.8
                  ],
                  [
                    54061.3,
                    32056
                  ],
                  [
                    53983.2,
                    32506.3
                  ],
                  [
                    54685.8,
                    32588.4
                  ]
                ],
                "id": 538,
                "chat_link": "[&BBoCAAA=]"
              },
              "1067": {
                "name": "Forsaken Halls",
                "level": 43,
                "coord": [
                  54242.9,
                  31494.5
                ],
                "bounds": [
                  [
                    54514.3,
                    31577.8
                  ],
                  [
                    54512.4,
                    31360.4
                  ],
                  [
                    53967.6,
                    31395.5
                  ],
                  [
                    53977.5,
                    31644.3
                  ],
                  [
                    54514.3,
                    31577.8
                  ]
                ],
                "id": 1067,
                "chat_link": "[&BCsEAAA=]"
              },
              "1075": {
                "name": "Tribulation Caverns",
                "level": 50,
                "coord": [
                  52371,
                  34263.5
                ],
                "bounds": [
                  [
                    52383.7,
                    34129.1
                  ],
                  [
                    52447.6,
                    34169.5
                  ],
                  [
                    52458.5,
                    34336.8
                  ],
                  [
                    52378.8,
                    34388
                  ],
                  [
                    52375.3,
                    34444.1
                  ],
                  [
                    52452.8,
                    34506.2
                  ],
                  [
                    52366.1,
                    34643.2
                  ],
                  [
                    52153.8,
                    34574.1
                  ],
                  [
                    52113.3,
                    34335.1
                  ],
                  [
                    52253.4,
                    34025.9
                  ],
                  [
                    52436.2,
                    34004.8
                  ],
                  [
                    52485.3,
                    34006
                  ],
                  [
                    52486.9,
                    34044.6
                  ],
                  [
                    52402.5,
                    34081.2
                  ],
                  [
                    52383.7,
                    34129.1
                  ]
                ],
                "id": 1075,
                "chat_link": "[&BDMEAAA=]"
              }
            },
            "adventures": [],
            "id": 26,
            "mastery_points": [
              {
                "coord": [
                  53190.8,
                  33232.3
                ],
                "id": 319,
                "region": "Tyria"
              }
            ]
          },
          "27": {
            "name": "Lornar's Pass",
            "min_level": 25,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {
              "229": {
                "name": "Vanjir's Stead Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51845.7,
                  34059.2
                ],
                "id": 229,
                "chat_link": "[&BOUAAAA=]"
              },
              "230": {
                "name": "Demon's Maw Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50668.5,
                  34081.7
                ],
                "id": 230,
                "chat_link": "[&BOYAAAA=]"
              },
              "231": {
                "name": "Winterthaw Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52020.8,
                  33007.3
                ],
                "id": 231,
                "chat_link": "[&BOcAAAA=]"
              },
              "232": {
                "name": "False Lake Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50784.6,
                  33228.2
                ],
                "id": 232,
                "chat_link": "[&BOgAAAA=]"
              },
              "233": {
                "name": "Durmand Priory Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50639.8,
                  31314.6
                ],
                "id": 233,
                "chat_link": "[&BOkAAAA=]"
              },
              "234": {
                "name": "Lamentation Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52056.5,
                  31606.6
                ],
                "id": 234,
                "chat_link": "[&BOoAAAA=]"
              },
              "235": {
                "name": "Thunderhorns Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51805.2,
                  29889.8
                ],
                "id": 235,
                "chat_link": "[&BOsAAAA=]"
              },
              "236": {
                "name": "Nentor Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50626.1,
                  30078.8
                ],
                "id": 236,
                "chat_link": "[&BOwAAAA=]"
              },
              "280": {
                "name": "Ettinworks Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51160.7,
                  34177.4
                ],
                "id": 280,
                "chat_link": "[&BBgBAAA=]"
              },
              "281": {
                "name": "Black Barl's Mill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50968.1,
                  34092.9
                ],
                "id": 281,
                "chat_link": "[&BBkBAAA=]"
              },
              "282": {
                "name": "Pinion Pass",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52025,
                  33094.5
                ],
                "id": 282,
                "chat_link": "[&BBoBAAA=]"
              },
              "283": {
                "name": "The Molitage Digs",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51430.2,
                  32852.3
                ],
                "id": 283,
                "chat_link": "[&BBsBAAA=]"
              },
              "284": {
                "name": "Cascade Bridge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51207.8,
                  32910.6
                ],
                "id": 284,
                "chat_link": "[&BBwBAAA=]"
              },
              "285": {
                "name": "Greybeard's Landing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50659.3,
                  33739
                ],
                "id": 285,
                "chat_link": "[&BB0BAAA=]"
              },
              "286": {
                "name": "Jetsam Isle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50980.5,
                  33245.2
                ],
                "id": 286,
                "chat_link": "[&BB4BAAA=]"
              },
              "287": {
                "name": "Koolookuu",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51122.5,
                  33211.1
                ],
                "id": 287,
                "chat_link": "[&BB8BAAA=]"
              },
              "288": {
                "name": "Olia's Clearing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50570.8,
                  32496.5
                ],
                "id": 288,
                "chat_link": "[&BCABAAA=]"
              },
              "289": {
                "name": "Afgar's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51325.1,
                  31783.2
                ],
                "id": 289,
                "chat_link": "[&BCEBAAA=]"
              },
              "290": {
                "name": "Grenth's Door",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52112.2,
                  32227.4
                ],
                "id": 290,
                "chat_link": "[&BCIBAAA=]"
              },
              "291": {
                "name": "Icebound Plunge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51643.4,
                  32061.9
                ],
                "id": 291,
                "chat_link": "[&BCMBAAA=]"
              },
              "292": {
                "name": "Molevon Portage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51488.3,
                  31922.6
                ],
                "id": 292,
                "chat_link": "[&BCQBAAA=]"
              },
              "293": {
                "name": "Priory Archives",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50509.3,
                  31048.7
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              },
              "294": {
                "name": "Ogden's Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50800.9,
                  31369.9
                ],
                "id": 294,
                "chat_link": "[&BCYBAAA=]"
              },
              "295": {
                "name": "The Dracon Steles",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52049,
                  30959.6
                ],
                "id": 295,
                "chat_link": "[&BCcBAAA=]"
              },
              "296": {
                "name": "Ironhammer's Crypt",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51918.9,
                  30849.6
                ],
                "id": 296,
                "chat_link": "[&BCgBAAA=]"
              },
              "297": {
                "name": "Korakatt's Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51523,
                  29879.4
                ],
                "id": 297,
                "chat_link": "[&BCkBAAA=]"
              },
              "298": {
                "name": "Nentor's Consolidated Mine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50694.9,
                  30360.6
                ],
                "id": 298,
                "chat_link": "[&BCoBAAA=]"
              },
              "299": {
                "name": "Belldron's Guardholme",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51312.1,
                  30777.3
                ],
                "id": 299,
                "chat_link": "[&BCsBAAA=]"
              },
              "406": {
                "name": "Guutra's Homestead Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51206.3,
                  33631.4
                ],
                "id": 406,
                "chat_link": "[&BJYBAAA=]"
              },
              "407": {
                "name": "Stonescatter Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50628.5,
                  32378.5
                ],
                "id": 407,
                "chat_link": "[&BJcBAAA=]"
              },
              "408": {
                "name": "Pinnacle Enclave Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51645.7,
                  30941.5
                ],
                "id": 408,
                "chat_link": "[&BJgBAAA=]"
              },
              "409": {
                "name": "Mistriven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51209.3,
                  30480.4
                ],
                "id": 409,
                "chat_link": "[&BJkBAAA=]"
              },
              "1221": {
                "name": "Windy Cave",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51050.3,
                  30561.5
                ],
                "id": 1221,
                "chat_link": "[&BMUEAAA=]"
              },
              "1293": {
                "name": "Lyot's Herd",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50812.1,
                  31869.7
                ],
                "id": 1293,
                "chat_link": "[&BA0FAAA=]"
              },
              "1550": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51071.3,
                  33172.5
                ],
                "id": 1550,
                "chat_link": "[&BA4GAAA=]"
              },
              "1551": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  50860.7,
                  30377.2
                ],
                "id": 1551,
                "chat_link": "[&BA8GAAA=]"
              },
              "1552": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51579.6,
                  32121.8
                ],
                "id": 1552,
                "chat_link": "[&BBAGAAA=]"
              },
              "1553": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51997.4,
                  32602.6
                ],
                "id": 1553,
                "chat_link": "[&BBEGAAA=]"
              },
              "1554": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  50618.4,
                  34167.7
                ],
                "id": 1554,
                "chat_link": "[&BBIGAAA=]"
              },
              "1555": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  50754.3,
                  31459.1
                ],
                "id": 1555,
                "chat_link": "[&BBMGAAA=]"
              },
              "1556": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51329.7,
                  33198.1
                ],
                "id": 1556,
                "chat_link": "[&BBQGAAA=]"
              },
              "1598": {
                "name": "Skritt Hill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51243.2,
                  29821.5
                ],
                "id": 1598,
                "chat_link": "[&BD4GAAA=]"
              },
              "1599": {
                "name": "Glorious Dredge Excavation #74",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52034.6,
                  29838.4
                ],
                "id": 1599,
                "chat_link": "[&BD8GAAA=]"
              },
              "1600": {
                "name": "Lost Owl Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52016.8,
                  30407.3
                ],
                "id": 1600,
                "chat_link": "[&BEAGAAA=]"
              },
              "1601": {
                "name": "Ravenbeak Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50824.5,
                  30574
                ],
                "id": 1601,
                "chat_link": "[&BEEGAAA=]"
              },
              "1602": {
                "name": "Bearstone Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50564.5,
                  32128.2
                ],
                "id": 1602,
                "chat_link": "[&BEIGAAA=]"
              },
              "1603": {
                "name": "Wolfpaw Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51491.9,
                  34328.5
                ],
                "id": 1603,
                "chat_link": "[&BEMGAAA=]"
              },
              "1604": {
                "name": "Leopardshadow Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51277.5,
                  30155.1
                ],
                "id": 1604,
                "chat_link": "[&BEQGAAA=]"
              },
              "1605": {
                "name": "The Riven Path",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51109.8,
                  30863.5
                ],
                "id": 1605,
                "chat_link": "[&BEUGAAA=]"
              },
              "1606": {
                "name": "Keddle Moraine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51080.5,
                  31083.2
                ],
                "id": 1606,
                "chat_link": "[&BEYGAAA=]"
              },
              "1607": {
                "name": "Priory Bridge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50951.3,
                  31373.4
                ],
                "id": 1607,
                "chat_link": "[&BEcGAAA=]"
              },
              "1608": {
                "name": "Steam Mechagate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51960.6,
                  31929
                ],
                "id": 1608,
                "chat_link": "[&BEgGAAA=]"
              },
              "1609": {
                "name": "Marionette's Landing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51891.4,
                  32669.1
                ],
                "id": 1609,
                "chat_link": "[&BEkGAAA=]"
              },
              "1610": {
                "name": "Skylady's Memory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51791.4,
                  32885.8
                ],
                "id": 1610,
                "chat_link": "[&BEoGAAA=]"
              },
              "1611": {
                "name": "Mette's Posting",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50765.2,
                  32857.8
                ],
                "id": 1611,
                "chat_link": "[&BEsGAAA=]"
              },
              "1612": {
                "name": "Dwarves' Gloaming",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50920.9,
                  33674.3
                ],
                "id": 1612,
                "chat_link": "[&BEwGAAA=]"
              },
              "1613": {
                "name": "Grogshadow Kenning",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52116.6,
                  33703.6
                ],
                "id": 1613,
                "chat_link": "[&BE0GAAA=]"
              },
              "1614": {
                "name": "Guutra's Secret",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51207.4,
                  33712
                ],
                "id": 1614,
                "chat_link": "[&BE4GAAA=]"
              },
              "1615": {
                "name": "Twoheaded Meadows",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51053.3,
                  34444.3
                ],
                "id": 1615,
                "chat_link": "[&BE8GAAA=]"
              },
              "1616": {
                "name": "Wonderous Drill Installation #73",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52075.6,
                  31335.7
                ],
                "id": 1616,
                "chat_link": "[&BFAGAAA=]"
              },
              "1617": {
                "name": "Icedevil's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51056.6,
                  30097.8
                ],
                "id": 1617,
                "chat_link": "[&BFEGAAA=]"
              },
              "1618": {
                "name": "Refuge Peak Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51039.1,
                  31474.2
                ],
                "id": 1618,
                "chat_link": "[&BFIGAAA=]"
              },
              "1619": {
                "name": "Afgar's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51275.9,
                  31883.9
                ],
                "id": 1619,
                "chat_link": "[&BFMGAAA=]"
              },
              "1620": {
                "name": "Cascade Bridge Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51134.7,
                  32776.7
                ],
                "id": 1620,
                "chat_link": "[&BFQGAAA=]"
              },
              "1628": {
                "name": "Posternus Caverns",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50494.9,
                  31253.6
                ],
                "id": 1628,
                "chat_link": "[&BFwGAAA=]"
              },
              "1629": {
                "name": "Rocklair",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51030.3,
                  32422.4
                ],
                "id": 1629,
                "chat_link": "[&BF0GAAA=]"
              },
              "1710": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51739.6,
                  30442.3
                ],
                "id": 1710,
                "chat_link": "[&BK4GAAA=]"
              },
              "1711": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51209.8,
                  29976.9
                ],
                "id": 1711,
                "chat_link": "[&BK8GAAA=]"
              },
              "1712": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51973.3,
                  34231.7
                ],
                "id": 1712,
                "chat_link": "[&BLAGAAA=]"
              },
              "1841": {
                "name": "False River Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51595.9,
                  32519.3
                ],
                "id": 1841,
                "chat_link": "[&BDEHAAA=]"
              },
              "2850": {
                "type": "unlock",
                "floor": 1,
                "coord": [
                  51935.2,
                  32267.7
                ],
                "id": 2850,
                "chat_link": "[&BCILAAA=]",
                "icon": "https://render.guildwars2.com/file/5866630DA52DCB5C423FB81ECF69FD071611E36B/1128644.png"
              }
            },
            "tasks": {
              "39": {
                "objective": "Help Queldip pillage pirates.",
                "level": 36,
                "coord": [
                  51022.8,
                  33177.3
                ],
                "bounds": [
                  [
                    50972.2,
                    33410.8
                  ],
                  [
                    50864.2,
                    33321.4
                  ],
                  [
                    50822.3,
                    33207.9
                  ],
                  [
                    50871.5,
                    33100.7
                  ],
                  [
                    50996.4,
                    33072.2
                  ],
                  [
                    51103.2,
                    33138
                  ],
                  [
                    51130.7,
                    33289.5
                  ],
                  [
                    51058.7,
                    33397.3
                  ],
                  [
                    50972.2,
                    33410.8
                  ]
                ],
                "id": 39,
                "chat_link": "[&BCcAAAA=]"
              },
              "40": {
                "objective": "Help Duidda hassle pirates.",
                "level": 37,
                "coord": [
                  50811.1,
                  33726.5
                ],
                "bounds": [
                  [
                    50501.2,
                    33767.5
                  ],
                  [
                    50524.7,
                    33677.2
                  ],
                  [
                    50593,
                    33633.9
                  ],
                  [
                    50798,
                    33548.1
                  ],
                  [
                    50845.6,
                    33569.4
                  ],
                  [
                    50874.4,
                    33721.6
                  ],
                  [
                    50758.5,
                    33916.2
                  ],
                  [
                    50626.5,
                    33910.3
                  ],
                  [
                    50501.2,
                    33767.5
                  ]
                ],
                "id": 40,
                "chat_link": "[&BCgAAAA=]"
              },
              "41": {
                "objective": "Help Researcher Bramm with his research equipment.",
                "level": 39,
                "coord": [
                  51236.1,
                  34200.8
                ],
                "bounds": [
                  [
                    51378.2,
                    34276
                  ],
                  [
                    51264.2,
                    34415.7
                  ],
                  [
                    51093.9,
                    34544.7
                  ],
                  [
                    50836.3,
                    34510.2
                  ],
                  [
                    50794,
                    34290.7
                  ],
                  [
                    50918,
                    34181.3
                  ],
                  [
                    51180.7,
                    34089.7
                  ],
                  [
                    51326.9,
                    34150.3
                  ],
                  [
                    51378.2,
                    34276
                  ]
                ],
                "id": 41,
                "chat_link": "[&BCkAAAA=]"
              },
              "42": {
                "objective": "Help Explorer Leandra find relics in Molitage Digs.",
                "level": 35,
                "coord": [
                  51538.2,
                  32973.3
                ],
                "bounds": [
                  [
                    51295.6,
                    32825.6
                  ],
                  [
                    51374.4,
                    32743.9
                  ],
                  [
                    51702.7,
                    32777.3
                  ],
                  [
                    51769.4,
                    32818.8
                  ],
                  [
                    51752,
                    32957
                  ],
                  [
                    51710.6,
                    33062
                  ],
                  [
                    51629.2,
                    33113.8
                  ],
                  [
                    51467.2,
                    33084.7
                  ],
                  [
                    51317.6,
                    32947.1
                  ],
                  [
                    51295.6,
                    32825.6
                  ]
                ],
                "id": 42,
                "chat_link": "[&BCoAAAA=]"
              },
              "43": {
                "objective": "Help Arcanist Kruppa with destroyers near Pinion Pass.",
                "level": 36,
                "coord": [
                  51918.3,
                  33077.6
                ],
                "bounds": [
                  [
                    51721.9,
                    33062.6
                  ],
                  [
                    51769.1,
                    33007.1
                  ],
                  [
                    51901.1,
                    32951.6
                  ],
                  [
                    51993.4,
                    32947.7
                  ],
                  [
                    52064.2,
                    33108.2
                  ],
                  [
                    51867.8,
                    33352.6
                  ],
                  [
                    51739.5,
                    33380.4
                  ],
                  [
                    51619.4,
                    33290.9
                  ],
                  [
                    51572.4,
                    33156.5
                  ],
                  [
                    51721.9,
                    33062.6
                  ]
                ],
                "id": 43,
                "chat_link": "[&BCsAAAA=]"
              },
              "44": {
                "objective": "Help Hunter Neida near Vanjir's Stead.",
                "level": 38,
                "coord": [
                  51925.9,
                  33913.8
                ],
                "bounds": [
                  [
                    52164,
                    33693.8
                  ],
                  [
                    52120.8,
                    33534
                  ],
                  [
                    52068.1,
                    33490.9
                  ],
                  [
                    51927,
                    33546.4
                  ],
                  [
                    51881.4,
                    33635.6
                  ],
                  [
                    51837.1,
                    33810.2
                  ],
                  [
                    51838,
                    33942.7
                  ],
                  [
                    51921.1,
                    34024.9
                  ],
                  [
                    51986.9,
                    34030.4
                  ],
                  [
                    52164,
                    33693.8
                  ]
                ],
                "id": 44,
                "chat_link": "[&BCwAAAA=]"
              },
              "45": {
                "objective": "Help Herder Lyot maintain her dolyak ranch.",
                "level": 33,
                "coord": [
                  50857.3,
                  31860.9
                ],
                "bounds": [
                  [
                    50781.3,
                    32025.8
                  ],
                  [
                    50888.3,
                    32038.9
                  ],
                  [
                    51001.6,
                    31923.6
                  ],
                  [
                    51036.5,
                    31844.3
                  ],
                  [
                    51032.5,
                    31768.5
                  ],
                  [
                    50940.5,
                    31691.4
                  ],
                  [
                    50798.6,
                    31702.6
                  ],
                  [
                    50708,
                    31834.1
                  ],
                  [
                    50704.8,
                    31927.6
                  ],
                  [
                    50781.3,
                    32025.8
                  ]
                ],
                "id": 45,
                "chat_link": "[&BC0AAAA=]"
              },
              "46": {
                "objective": "Make sure the mining camp maintains productivity.",
                "level": 27,
                "coord": [
                  50727.5,
                  30382.2
                ],
                "bounds": [
                  [
                    50891.8,
                    30327.4
                  ],
                  [
                    50936.5,
                    30238.4
                  ],
                  [
                    50768.1,
                    30120
                  ],
                  [
                    50702.4,
                    30172.4
                  ],
                  [
                    50641.7,
                    30272.2
                  ],
                  [
                    50611.9,
                    30357.8
                  ],
                  [
                    50616,
                    30434.3
                  ],
                  [
                    50683.8,
                    30478.3
                  ],
                  [
                    50801.3,
                    30453.6
                  ],
                  [
                    50834.1,
                    30387.9
                  ],
                  [
                    50851.3,
                    30321.4
                  ],
                  [
                    50891.8,
                    30327.4
                  ]
                ],
                "id": 46,
                "chat_link": "[&BC4AAAA=]"
              },
              "47": {
                "objective": "Help Kelgg with the mine's troubles.",
                "level": 28,
                "coord": [
                  51025.1,
                  30127.7
                ],
                "bounds": [
                  [
                    51040.3,
                    30189
                  ],
                  [
                    51182.2,
                    30205.5
                  ],
                  [
                    51287.3,
                    30166
                  ],
                  [
                    51372.6,
                    30109.2
                  ],
                  [
                    51384.4,
                    30052.9
                  ],
                  [
                    51392.9,
                    29976.1
                  ],
                  [
                    51401.9,
                    29873.7
                  ],
                  [
                    51474.7,
                    29776.5
                  ],
                  [
                    51430.9,
                    29701.1
                  ],
                  [
                    51287,
                    29591.9
                  ],
                  [
                    51114.7,
                    29562.9
                  ],
                  [
                    50945.5,
                    29570.5
                  ],
                  [
                    50841.1,
                    29594
                  ],
                  [
                    50770.9,
                    29714.2
                  ],
                  [
                    50729.3,
                    29795.2
                  ],
                  [
                    50730.7,
                    29899.6
                  ],
                  [
                    50830.8,
                    30029.4
                  ],
                  [
                    50892.4,
                    30087.4
                  ],
                  [
                    50965.4,
                    30155.9
                  ],
                  [
                    51040.3,
                    30189
                  ]
                ],
                "id": 47,
                "chat_link": "[&BC8AAAA=]"
              },
              "48": {
                "objective": "Help Hune manage the lodge.",
                "level": 26,
                "coord": [
                  51568.2,
                  29968.4
                ],
                "bounds": [
                  [
                    51717.7,
                    29890.6
                  ],
                  [
                    51734.1,
                    29853.9
                  ],
                  [
                    51705.9,
                    29815.2
                  ],
                  [
                    51610.9,
                    29794
                  ],
                  [
                    51495.5,
                    29761.3
                  ],
                  [
                    51414.4,
                    29886.9
                  ],
                  [
                    51412,
                    29945.1
                  ],
                  [
                    51401,
                    29996.1
                  ],
                  [
                    51423.1,
                    30016.3
                  ],
                  [
                    51494.1,
                    30040.9
                  ],
                  [
                    51537.6,
                    30032.6
                  ],
                  [
                    51566.3,
                    30040.3
                  ],
                  [
                    51593.6,
                    30043.8
                  ],
                  [
                    51618.8,
                    30043.2
                  ],
                  [
                    51669.4,
                    29988.4
                  ],
                  [
                    51704.1,
                    29931.4
                  ],
                  [
                    51717.7,
                    29890.6
                  ]
                ],
                "id": 48,
                "chat_link": "[&BDAAAAA=]"
              },
              "49": {
                "objective": "Help the Priory stop the dredge encroachment.",
                "level": 30,
                "coord": [
                  51996.6,
                  30820.5
                ],
                "bounds": [
                  [
                    52154.1,
                    31025.1
                  ],
                  [
                    52159.9,
                    30976.2
                  ],
                  [
                    52151.9,
                    30933
                  ],
                  [
                    52163.2,
                    30865.6
                  ],
                  [
                    52061.5,
                    30821.4
                  ],
                  [
                    51996.3,
                    30777.4
                  ],
                  [
                    51956.6,
                    30710.9
                  ],
                  [
                    51933.8,
                    30632
                  ],
                  [
                    51873,
                    30626.5
                  ],
                  [
                    51842.3,
                    30681.6
                  ],
                  [
                    51793.1,
                    30710.6
                  ],
                  [
                    51773.3,
                    30737.2
                  ],
                  [
                    51782.1,
                    30802.6
                  ],
                  [
                    51788.6,
                    30863.7
                  ],
                  [
                    51762.1,
                    30904
                  ],
                  [
                    51732,
                    30954
                  ],
                  [
                    51736.5,
                    31014.3
                  ],
                  [
                    51771.1,
                    31055.6
                  ],
                  [
                    51836.8,
                    31080.3
                  ],
                  [
                    51902.3,
                    31102.7
                  ],
                  [
                    51966.6,
                    31131.8
                  ],
                  [
                    52046.4,
                    31145.4
                  ],
                  [
                    52107.1,
                    31135.8
                  ],
                  [
                    52131.4,
                    31078.6
                  ],
                  [
                    52154.1,
                    31025.1
                  ]
                ],
                "id": 49,
                "chat_link": "[&BDEAAAA=]"
              },
              "50": {
                "objective": "Investigate and contain the expanding steam creature forces.",
                "level": 32,
                "coord": [
                  51932.1,
                  31693.2
                ],
                "bounds": [
                  [
                    51629.6,
                    31767.9
                  ],
                  [
                    51642.7,
                    31826.3
                  ],
                  [
                    51688.8,
                    31829.8
                  ],
                  [
                    51701.5,
                    31861.8
                  ],
                  [
                    51681,
                    31918.9
                  ],
                  [
                    51649.5,
                    31957.8
                  ],
                  [
                    51632.1,
                    32003.8
                  ],
                  [
                    51720.9,
                    32016.8
                  ],
                  [
                    51795.8,
                    32025.3
                  ],
                  [
                    51914.5,
                    32042.9
                  ],
                  [
                    52005.4,
                    32013.5
                  ],
                  [
                    52036.6,
                    31902.7
                  ],
                  [
                    52006.3,
                    31845.5
                  ],
                  [
                    51978.8,
                    31777.8
                  ],
                  [
                    51979.5,
                    31742.7
                  ],
                  [
                    51965.7,
                    31708.4
                  ],
                  [
                    51949.6,
                    31672.7
                  ],
                  [
                    51933.6,
                    31643.4
                  ],
                  [
                    51895.1,
                    31612.9
                  ],
                  [
                    51847.3,
                    31599.9
                  ],
                  [
                    51788.3,
                    31579.1
                  ],
                  [
                    51716.6,
                    31533
                  ],
                  [
                    51653.2,
                    31466.8
                  ],
                  [
                    51575.9,
                    31443.6
                  ],
                  [
                    51515.6,
                    31452.1
                  ],
                  [
                    51434.2,
                    31535.8
                  ],
                  [
                    51474.2,
                    31615.2
                  ],
                  [
                    51552,
                    31680.9
                  ],
                  [
                    51622.1,
                    31712.3
                  ],
                  [
                    51629.6,
                    31767.9
                  ]
                ],
                "id": 50,
                "chat_link": "[&BDIAAAA=]"
              },
              "51": {
                "objective": "Help Researcher Suki examine imps near Rocklair.",
                "level": 34,
                "coord": [
                  51187.1,
                  32393.2
                ],
                "bounds": [
                  [
                    51054.6,
                    32491.1
                  ],
                  [
                    51100.8,
                    32566.8
                  ],
                  [
                    51243.7,
                    32562.9
                  ],
                  [
                    51403.7,
                    32494.2
                  ],
                  [
                    51457.5,
                    32406.2
                  ],
                  [
                    51333,
                    32378.6
                  ],
                  [
                    51339.2,
                    32191.6
                  ],
                  [
                    51242,
                    32188.6
                  ],
                  [
                    51099.1,
                    32340.3
                  ],
                  [
                    51054.6,
                    32491.1
                  ]
                ],
                "id": 51,
                "chat_link": "[&BDMAAAA=]"
              },
              "52": {
                "objective": "Help Aurelio keep roads to the Priory safe from grawl.",
                "level": 29,
                "coord": [
                  51201.7,
                  30732.9
                ],
                "bounds": [
                  [
                    51336,
                    30807.7
                  ],
                  [
                    51496.1,
                    30906
                  ],
                  [
                    51541.6,
                    30973.8
                  ],
                  [
                    51449.6,
                    31140.3
                  ],
                  [
                    51189.9,
                    31420.9
                  ],
                  [
                    51117.5,
                    31376.2
                  ],
                  [
                    51179.2,
                    31240.5
                  ],
                  [
                    51085.2,
                    30869.6
                  ],
                  [
                    51114.5,
                    30804.8
                  ],
                  [
                    51161.1,
                    30728.7
                  ],
                  [
                    51210.9,
                    30718.1
                  ],
                  [
                    51336,
                    30807.7
                  ]
                ],
                "id": 52,
                "chat_link": "[&BDQAAAA=]"
              },
              "53": {
                "objective": "Help Agent Kaukiri trick the dredge into fighting steam creatures.",
                "level": 31,
                "coord": [
                  52076.3,
                  31601.8
                ],
                "bounds": [
                  [
                    51964.8,
                    31188.4
                  ],
                  [
                    51923.2,
                    31199.2
                  ],
                  [
                    51890.8,
                    31209.6
                  ],
                  [
                    51841,
                    31230.9
                  ],
                  [
                    51816.2,
                    31269.5
                  ],
                  [
                    51808.8,
                    31308.1
                  ],
                  [
                    51794.4,
                    31349.2
                  ],
                  [
                    51800.3,
                    31386.5
                  ],
                  [
                    51796.2,
                    31437.5
                  ],
                  [
                    51826.6,
                    31499.9
                  ],
                  [
                    51886.6,
                    31557.3
                  ],
                  [
                    51938.8,
                    31587.8
                  ],
                  [
                    51955.7,
                    31598
                  ],
                  [
                    52019.2,
                    31607.6
                  ],
                  [
                    52054.8,
                    31614.2
                  ],
                  [
                    52185.9,
                    31575.2
                  ],
                  [
                    52217.3,
                    31474.4
                  ],
                  [
                    52218.9,
                    31402.1
                  ],
                  [
                    52201.4,
                    31336.2
                  ],
                  [
                    52152.6,
                    31278.7
                  ],
                  [
                    52057.5,
                    31193
                  ],
                  [
                    52006.1,
                    31185.4
                  ],
                  [
                    51964.8,
                    31188.4
                  ]
                ],
                "id": 53,
                "chat_link": "[&BDUAAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  51656.5,
                  32015.3
                ],
                "id": "0-39"
              },
              {
                "coord": [
                  50515.1,
                  31062.1
                ],
                "id": "0-93"
              },
              {
                "coord": [
                  52067.1,
                  29792.4
                ],
                "id": "0-95"
              },
              {
                "coord": [
                  51120.3,
                  33192.8
                ],
                "id": "0-94"
              },
              {
                "coord": [
                  52087,
                  32228.9
                ],
                "id": "0-92"
              },
              {
                "coord": [
                  50987.3,
                  29766.9
                ],
                "id": "0-233"
              },
              {
                "coord": [
                  52080.4,
                  30234.9
                ],
                "id": "0-3"
              },
              {
                "coord": [
                  50764.2,
                  30796.8
                ],
                "id": "0-4"
              },
              {
                "coord": [
                  50800.1,
                  32849.7
                ],
                "id": "0-5"
              }
            ],
            "sectors": {
              "320": {
                "name": "Demon's Maw",
                "level": 39,
                "coord": [
                  50789.2,
                  34283.6
                ],
                "bounds": [
                  [
                    50346,
                    34168.2
                  ],
                  [
                    50439,
                    34246.6
                  ],
                  [
                    50467,
                    34355.7
                  ],
                  [
                    50573.2,
                    34473.8
                  ],
                  [
                    50722,
                    34503.7
                  ],
                  [
                    50910.7,
                    34465.6
                  ],
                  [
                    51043.3,
                    34502.3
                  ],
                  [
                    51108.9,
                    34496.7
                  ],
                  [
                    51270.3,
                    34453.7
                  ],
                  [
                    51395,
                    34482.1
                  ],
                  [
                    51415.6,
                    34124.1
                  ],
                  [
                    50886.5,
                    33913.9
                  ],
                  [
                    50439.4,
                    33952.7
                  ],
                  [
                    50451.5,
                    34068.3
                  ],
                  [
                    50369.4,
                    34046.4
                  ],
                  [
                    50346,
                    34168.2
                  ]
                ],
                "id": 320,
                "chat_link": "[&BEABAAA=]"
              },
              "321": {
                "name": "Venison Pass",
                "level": 40,
                "coord": [
                  51875.2,
                  34343.6
                ],
                "bounds": [
                  [
                    51407.1,
                    34128.8
                  ],
                  [
                    51643.1,
                    33942.8
                  ],
                  [
                    52231.3,
                    33780.1
                  ],
                  [
                    52293,
                    34182.1
                  ],
                  [
                    52269.2,
                    34548.5
                  ],
                  [
                    51996.8,
                    34573.6
                  ],
                  [
                    51961.5,
                    34650.3
                  ],
                  [
                    51833.4,
                    34655.3
                  ],
                  [
                    51733.2,
                    34477.3
                  ],
                  [
                    51383.8,
                    34496.8
                  ],
                  [
                    51407.1,
                    34128.8
                  ]
                ],
                "id": 321,
                "chat_link": "[&BEEBAAA=]"
              },
              "322": {
                "name": "Winterthaw Snowfield",
                "level": 36,
                "coord": [
                  51784.6,
                  32925.1
                ],
                "bounds": [
                  [
                    51623.1,
                    33220.3
                  ],
                  [
                    51222.5,
                    33073.8
                  ],
                  [
                    50977.3,
                    32853.2
                  ],
                  [
                    51388.2,
                    32609.3
                  ],
                  [
                    51390,
                    32633.5
                  ],
                  [
                    51639.6,
                    32805.4
                  ],
                  [
                    51705.4,
                    32818.6
                  ],
                  [
                    51782.5,
                    32940.7
                  ],
                  [
                    51862.9,
                    32974.6
                  ],
                  [
                    51893.1,
                    32960.5
                  ],
                  [
                    52010.2,
                    32969.1
                  ],
                  [
                    52043.4,
                    32942.1
                  ],
                  [
                    52259.1,
                    32838.1
                  ],
                  [
                    52266,
                    32936.2
                  ],
                  [
                    52211.6,
                    32980.2
                  ],
                  [
                    52279.1,
                    33245.6
                  ],
                  [
                    51623.1,
                    33220.3
                  ]
                ],
                "id": 322,
                "chat_link": "[&BEIBAAA=]"
              },
              "323": {
                "name": "Lost Delver's Ridge",
                "level": 37,
                "coord": [
                  51441.3,
                  33662.5
                ],
                "bounds": [
                  [
                    50878.3,
                    33920.2
                  ],
                  [
                    51155.9,
                    33686.5
                  ],
                  [
                    51221.3,
                    33071
                  ],
                  [
                    51622.9,
                    33220.6
                  ],
                  [
                    51648.5,
                    33469.8
                  ],
                  [
                    51952.9,
                    33858
                  ],
                  [
                    51643.7,
                    33943.9
                  ],
                  [
                    51407.3,
                    34129.7
                  ],
                  [
                    50878.3,
                    33920.2
                  ]
                ],
                "id": 323,
                "chat_link": "[&BEMBAAA=]"
              },
              "324": {
                "name": "False Lake",
                "level": 37,
                "coord": [
                  50766.3,
                  33442.3
                ],
                "bounds": [
                  [
                    50582,
                    33943.7
                  ],
                  [
                    50878.7,
                    33920
                  ],
                  [
                    51156.8,
                    33686.8
                  ],
                  [
                    51221.6,
                    33071
                  ],
                  [
                    50977.3,
                    32853.6
                  ],
                  [
                    50684.4,
                    32962.5
                  ],
                  [
                    50695.9,
                    33279
                  ],
                  [
                    50734.1,
                    33322.4
                  ],
                  [
                    50726.8,
                    33375.1
                  ],
                  [
                    50690.9,
                    33400.7
                  ],
                  [
                    50417.6,
                    33529.6
                  ],
                  [
                    50430,
                    33963.8
                  ],
                  [
                    50582,
                    33943.7
                  ]
                ],
                "id": 324,
                "chat_link": "[&BEQBAAA=]"
              },
              "325": {
                "name": "Stonescatter Wash",
                "level": 35,
                "coord": [
                  50541.9,
                  32586.7
                ],
                "bounds": [
                  [
                    50420.9,
                    32815.4
                  ],
                  [
                    50344,
                    32612.1
                  ],
                  [
                    50289.3,
                    32440.3
                  ],
                  [
                    50302.9,
                    32336.2
                  ],
                  [
                    50513,
                    32327.2
                  ],
                  [
                    50803.8,
                    32345.6
                  ],
                  [
                    50976.9,
                    32853.6
                  ],
                  [
                    50684.2,
                    32963
                  ],
                  [
                    50420.9,
                    32815.4
                  ]
                ],
                "id": 325,
                "chat_link": "[&BEUBAAA=]"
              },
              "326": {
                "name": "Bouldermouth Vale",
                "level": 33,
                "coord": [
                  50650.8,
                  31917.1
                ],
                "bounds": [
                  [
                    50367.1,
                    31538.2
                  ],
                  [
                    50781.6,
                    31387.8
                  ],
                  [
                    50726.9,
                    31654
                  ],
                  [
                    50934.3,
                    31712.5
                  ],
                  [
                    50925.4,
                    31907.6
                  ],
                  [
                    50803.9,
                    32347.5
                  ],
                  [
                    50513.7,
                    32328.8
                  ],
                  [
                    50413.9,
                    32330.6
                  ],
                  [
                    50390.5,
                    32047.4
                  ],
                  [
                    50367.1,
                    31538.2
                  ]
                ],
                "id": 326,
                "chat_link": "[&BEYBAAA=]"
              },
              "327": {
                "name": "Highfirn Passage",
                "level": 34,
                "coord": [
                  51142.5,
                  32333.2
                ],
                "bounds": [
                  [
                    51407.2,
                    32618.3
                  ],
                  [
                    51359.9,
                    32226.6
                  ],
                  [
                    51383.4,
                    32041.9
                  ],
                  [
                    50924.6,
                    31909.8
                  ],
                  [
                    50803.2,
                    32347.4
                  ],
                  [
                    50976.5,
                    32855.5
                  ],
                  [
                    51407.2,
                    32618.3
                  ]
                ],
                "id": 327,
                "chat_link": "[&BEcBAAA=]"
              },
              "328": {
                "name": "False River Valley",
                "level": 34,
                "coord": [
                  51868.1,
                  32641.9
                ],
                "bounds": [
                  [
                    51359.5,
                    32225.9
                  ],
                  [
                    51616.8,
                    32029.4
                  ],
                  [
                    51701.6,
                    32046.8
                  ],
                  [
                    52094.2,
                    32395.5
                  ],
                  [
                    52228.5,
                    32397.1
                  ],
                  [
                    52171.7,
                    32558.6
                  ],
                  [
                    52176.8,
                    32719.3
                  ],
                  [
                    52217.5,
                    32858.7
                  ],
                  [
                    52043.5,
                    32941.6
                  ],
                  [
                    52012,
                    32968.9
                  ],
                  [
                    51893.5,
                    32960.1
                  ],
                  [
                    51863.2,
                    32974.7
                  ],
                  [
                    51782.1,
                    32939.2
                  ],
                  [
                    51695.9,
                    32814.3
                  ],
                  [
                    51641.8,
                    32807.1
                  ],
                  [
                    51390.4,
                    32633.7
                  ],
                  [
                    51359.5,
                    32225.9
                  ]
                ],
                "id": 328,
                "chat_link": "[&BEgBAAA=]"
              },
              "329": {
                "name": "Reaper's Gate",
                "level": 34,
                "coord": [
                  52112,
                  32128.4
                ],
                "bounds": [
                  [
                    52094.3,
                    32396.4
                  ],
                  [
                    52224.8,
                    32397.6
                  ],
                  [
                    52246.8,
                    32193.3
                  ],
                  [
                    52230.7,
                    32027.7
                  ],
                  [
                    52186,
                    31926.6
                  ],
                  [
                    52100,
                    31910.2
                  ],
                  [
                    51701.4,
                    32047.3
                  ],
                  [
                    52094.3,
                    32396.4
                  ]
                ],
                "id": 329,
                "chat_link": "[&BEkBAAA=]"
              },
              "330": {
                "name": "Molent Summit",
                "level": 31,
                "coord": [
                  52160.1,
                  31385
                ],
                "bounds": [
                  [
                    51967.5,
                    31229
                  ],
                  [
                    52271.2,
                    31141.2
                  ],
                  [
                    52226.7,
                    31232.7
                  ],
                  [
                    52270.1,
                    31395.5
                  ],
                  [
                    52259.4,
                    31517.2
                  ],
                  [
                    52268.6,
                    31587.7
                  ],
                  [
                    52137.1,
                    31565.8
                  ],
                  [
                    51880.3,
                    31410.8
                  ],
                  [
                    51967.5,
                    31229
                  ]
                ],
                "id": 330,
                "chat_link": "[&BEoBAAA=]"
              },
              "331": {
                "name": "Refuge Peak",
                "level": 31,
                "coord": [
                  51067.6,
                  31532.6
                ],
                "bounds": [
                  [
                    50876.4,
                    30985.8
                  ],
                  [
                    51178.5,
                    31208.3
                  ],
                  [
                    51249.4,
                    31223.8
                  ],
                  [
                    51189.8,
                    31521.4
                  ],
                  [
                    51434.6,
                    31680.3
                  ],
                  [
                    51381,
                    32042.4
                  ],
                  [
                    50924.5,
                    31909.1
                  ],
                  [
                    50933.5,
                    31712.4
                  ],
                  [
                    50726.8,
                    31654.3
                  ],
                  [
                    50781.2,
                    31388
                  ],
                  [
                    50876.4,
                    30985.8
                  ]
                ],
                "id": 331,
                "chat_link": "[&BEsBAAA=]"
              },
              "332": {
                "name": "Mistriven Gorge",
                "level": 28,
                "coord": [
                  51098.2,
                  30808.6
                ],
                "bounds": [
                  [
                    51312,
                    30618.8
                  ],
                  [
                    51262.3,
                    30390.1
                  ],
                  [
                    50982,
                    30444
                  ],
                  [
                    50824.3,
                    30793.6
                  ],
                  [
                    50876.4,
                    30985.9
                  ],
                  [
                    51178.8,
                    31207.9
                  ],
                  [
                    51251.9,
                    31219.4
                  ],
                  [
                    51312,
                    30618.8
                  ]
                ],
                "id": 332,
                "chat_link": "[&BEwBAAA=]"
              },
              "333": {
                "name": "The Godspurs",
                "level": 29,
                "coord": [
                  51577.3,
                  30812.3
                ],
                "bounds": [
                  [
                    51248.8,
                    31223.2
                  ],
                  [
                    51755.1,
                    31011
                  ],
                  [
                    51825,
                    30686.8
                  ],
                  [
                    51745.2,
                    30520.5
                  ],
                  [
                    51312.3,
                    30619.7
                  ],
                  [
                    51248.8,
                    31223.2
                  ]
                ],
                "id": 333,
                "chat_link": "[&BE0BAAA=]"
              },
              "334": {
                "name": "Frostgate Falls",
                "level": 30,
                "coord": [
                  52100,
                  30917.7
                ],
                "bounds": [
                  [
                    51823.5,
                    30686.8
                  ],
                  [
                    52243.1,
                    30670.5
                  ],
                  [
                    52273.8,
                    30755.6
                  ],
                  [
                    52250.8,
                    30887.1
                  ],
                  [
                    52216.2,
                    30959.9
                  ],
                  [
                    52270.3,
                    31141.4
                  ],
                  [
                    51967.2,
                    31228.3
                  ],
                  [
                    51754.8,
                    31012.4
                  ],
                  [
                    51823.5,
                    30686.8
                  ]
                ],
                "id": 334,
                "chat_link": "[&BE4BAAA=]"
              },
              "335": {
                "name": "The Thunderhorns",
                "level": 27,
                "coord": [
                  51640.2,
                  30024.5
                ],
                "bounds": [
                  [
                    51745.2,
                    30521
                  ],
                  [
                    51311.8,
                    30622.5
                  ],
                  [
                    51261.8,
                    30389.6
                  ],
                  [
                    51396.2,
                    30081.8
                  ],
                  [
                    51337.3,
                    29604.3
                  ],
                  [
                    51728,
                    29689.3
                  ],
                  [
                    51851.9,
                    29646.5
                  ],
                  [
                    51967.2,
                    29663.4
                  ],
                  [
                    51840.4,
                    29860.8
                  ],
                  [
                    51962,
                    30166
                  ],
                  [
                    51745.2,
                    30521
                  ]
                ],
                "id": 335,
                "chat_link": "[&BE8BAAA=]"
              },
              "336": {
                "name": "Underburg",
                "level": 26,
                "coord": [
                  52104.1,
                  29908.4
                ],
                "bounds": [
                  [
                    51962.2,
                    30164.8
                  ],
                  [
                    52074.8,
                    30155.4
                  ],
                  [
                    52222.1,
                    30151.7
                  ],
                  [
                    52286.6,
                    30048.9
                  ],
                  [
                    52301.7,
                    29891.9
                  ],
                  [
                    52253.6,
                    29762.5
                  ],
                  [
                    52129.5,
                    29677
                  ],
                  [
                    52025.8,
                    29676.8
                  ],
                  [
                    51945.2,
                    29694.3
                  ],
                  [
                    51839.7,
                    29860.3
                  ],
                  [
                    51962.2,
                    30164.8
                  ]
                ],
                "id": 336,
                "chat_link": "[&BFABAAA=]"
              },
              "337": {
                "name": "Nentor Valley",
                "level": 27,
                "coord": [
                  50733.1,
                  30341.3
                ],
                "bounds": [
                  [
                    50824.7,
                    30793.9
                  ],
                  [
                    50981.9,
                    30445.4
                  ],
                  [
                    51261.5,
                    30390.8
                  ],
                  [
                    51395.8,
                    30082
                  ],
                  [
                    50962.4,
                    30175.1
                  ],
                  [
                    50702.1,
                    29956.9
                  ],
                  [
                    50293.4,
                    29822.3
                  ],
                  [
                    50275,
                    29972.5
                  ],
                  [
                    50371.3,
                    30194.9
                  ],
                  [
                    50337,
                    30742
                  ],
                  [
                    50660.2,
                    30721.7
                  ],
                  [
                    50731.3,
                    30797.7
                  ],
                  [
                    50824.7,
                    30793.9
                  ]
                ],
                "id": 337,
                "chat_link": "[&BFEBAAA=]"
              },
              "338": {
                "name": "Icedevil's Needle",
                "level": 28,
                "coord": [
                  50881.2,
                  29888.7
                ],
                "bounds": [
                  [
                    51396,
                    30082
                  ],
                  [
                    50961.9,
                    30174.9
                  ],
                  [
                    50702.1,
                    29957.4
                  ],
                  [
                    50359.8,
                    29843
                  ],
                  [
                    50526.9,
                    29649
                  ],
                  [
                    51340.4,
                    29626.1
                  ],
                  [
                    51396,
                    30082
                  ]
                ],
                "id": 338,
                "chat_link": "[&BFIBAAA=]"
              },
              "339": {
                "name": "Lake of Lamentation",
                "level": 32,
                "coord": [
                  51824.8,
                  31661.3
                ],
                "bounds": [
                  [
                    52100,
                    31910.1
                  ],
                  [
                    51700.7,
                    32046.6
                  ],
                  [
                    51615.8,
                    32029
                  ],
                  [
                    51360.2,
                    32224.5
                  ],
                  [
                    51434.5,
                    31680.1
                  ],
                  [
                    51189,
                    31519.8
                  ],
                  [
                    51248.9,
                    31223.6
                  ],
                  [
                    51755.3,
                    31012.2
                  ],
                  [
                    51967.2,
                    31228.5
                  ],
                  [
                    51881.1,
                    31410.6
                  ],
                  [
                    52137.9,
                    31566.1
                  ],
                  [
                    52255.5,
                    31584.7
                  ],
                  [
                    52290.6,
                    31717.6
                  ],
                  [
                    52249.2,
                    31838.7
                  ],
                  [
                    52186.2,
                    31926.9
                  ],
                  [
                    52100,
                    31910.1
                  ]
                ],
                "id": 339,
                "chat_link": "[&BFMBAAA=]"
              },
              "947": {
                "name": "Durmand Priory",
                "level": 31,
                "coord": [
                  50600.6,
                  31003.3
                ],
                "bounds": [
                  [
                    50368,
                    31537.9
                  ],
                  [
                    50781.9,
                    31388
                  ],
                  [
                    50876.9,
                    30987
                  ],
                  [
                    50824.2,
                    30793.6
                  ],
                  [
                    50731,
                    30797.9
                  ],
                  [
                    50659.6,
                    30721.1
                  ],
                  [
                    50338.2,
                    30741.7
                  ],
                  [
                    50224.6,
                    31059.4
                  ],
                  [
                    50368,
                    31537.9
                  ]
                ],
                "id": 947,
                "chat_link": "[&BLMDAAA=]"
              },
              "1028": {
                "name": "Griffonrook Run",
                "level": 35,
                "coord": [
                  50625.9,
                  33240.8
                ],
                "bounds": [
                  [
                    50419.1,
                    32813.5
                  ],
                  [
                    50682.7,
                    32961.7
                  ],
                  [
                    50698.2,
                    33280.2
                  ],
                  [
                    50735.1,
                    33322.4
                  ],
                  [
                    50728.3,
                    33376.4
                  ],
                  [
                    50691.9,
                    33402.2
                  ],
                  [
                    50425.9,
                    33529.3
                  ],
                  [
                    50419.1,
                    32813.5
                  ]
                ],
                "id": 1028,
                "chat_link": "[&BAQEAAA=]"
              },
              "1057": {
                "name": "Chillwing Perch",
                "level": 27,
                "coord": [
                  52074.7,
                  30411.1
                ],
                "bounds": [
                  [
                    51745.2,
                    30521
                  ],
                  [
                    51962,
                    30166
                  ],
                  [
                    52075,
                    30155.2
                  ],
                  [
                    52219.8,
                    30152.9
                  ],
                  [
                    52261.8,
                    30388
                  ],
                  [
                    52264.3,
                    30547.7
                  ],
                  [
                    52246.1,
                    30669.9
                  ],
                  [
                    51823.4,
                    30688.4
                  ],
                  [
                    51745.2,
                    30521
                  ]
                ],
                "id": 1057,
                "chat_link": "[&BCEEAAA=]"
              },
              "1058": {
                "name": "Jotun's Shoulders",
                "level": 38,
                "coord": [
                  51979.7,
                  33562.8
                ],
                "bounds": [
                  [
                    51649.1,
                    33469.1
                  ],
                  [
                    51623.1,
                    33220.3
                  ],
                  [
                    52279.6,
                    33247
                  ],
                  [
                    52198.3,
                    33789.7
                  ],
                  [
                    52174.7,
                    33793.4
                  ],
                  [
                    51953.6,
                    33857.7
                  ],
                  [
                    51649.1,
                    33469.1
                  ]
                ],
                "id": 1058,
                "chat_link": "[&BCIEAAA=]"
              }
            },
            "adventures": [],
            "id": 27,
            "mastery_points": []
          },
          "28": {
            "name": "Wayfarer Foothills",
            "min_level": 1,
            "max_level": 15,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {
              "357": {
                "name": "Heart of the Wolf",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55478.8,
                  31773.4
                ],
                "id": 357,
                "chat_link": "[&BGUBAAA=]"
              },
              "358": {
                "name": "Hirbadd's Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55588.5,
                  31974.5
                ],
                "id": 358,
                "chat_link": "[&BGYBAAA=]"
              },
              "359": {
                "name": "Drakkerjorg Pit",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56227.8,
                  31697
                ],
                "id": 359,
                "chat_link": "[&BGcBAAA=]"
              },
              "360": {
                "name": "Hostra's Refuge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56184,
                  31303.8
                ],
                "id": 360,
                "chat_link": "[&BGgBAAA=]"
              },
              "361": {
                "name": "Heart of the Bear",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55739.2,
                  31098.9
                ],
                "id": 361,
                "chat_link": "[&BGkBAAA=]"
              },
              "362": {
                "name": "Heart of the Raven",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55359.4,
                  30960
                ],
                "id": 362,
                "chat_link": "[&BGoBAAA=]"
              },
              "363": {
                "name": "Heart of the Snow Leopard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55077.5,
                  31518.7
                ],
                "id": 363,
                "chat_link": "[&BGsBAAA=]"
              },
              "364": {
                "name": "Alpenzure Cave",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55303.1,
                  32129.6
                ],
                "id": 364,
                "chat_link": "[&BGwBAAA=]"
              },
              "365": {
                "name": "Gaerta's Summit",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55146.1,
                  30687.5
                ],
                "id": 365,
                "chat_link": "[&BG0BAAA=]"
              },
              "366": {
                "name": "Hermit's Watch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56134.4,
                  30135.7
                ],
                "id": 366,
                "chat_link": "[&BG4BAAA=]"
              },
              "367": {
                "name": "Victor's Point",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55717.9,
                  30132.6
                ],
                "id": 367,
                "chat_link": "[&BG8BAAA=]"
              },
              "368": {
                "name": "Edenvar's Homestead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55177.4,
                  29147.3
                ],
                "id": 368,
                "chat_link": "[&BHABAAA=]"
              },
              "369": {
                "name": "Kevach's Homestead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55859.9,
                  28680.6
                ],
                "id": 369,
                "chat_link": "[&BHEBAAA=]"
              },
              "370": {
                "name": "Outcast's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55359.6,
                  31736.8
                ],
                "id": 370,
                "chat_link": "[&BHIBAAA=]"
              },
              "371": {
                "name": "Hero's Moot Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55448.9,
                  31216.7
                ],
                "id": 371,
                "chat_link": "[&BHMBAAA=]"
              },
              "372": {
                "name": "Horncall Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55046.6,
                  30964.6
                ],
                "id": 372,
                "chat_link": "[&BHQBAAA=]"
              },
              "373": {
                "name": "Darkriven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55963.4,
                  30568.8
                ],
                "id": 373,
                "chat_link": "[&BHUBAAA=]"
              },
              "374": {
                "name": "Taigan Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55498.1,
                  30284.9
                ],
                "id": 374,
                "chat_link": "[&BHYBAAA=]"
              },
              "375": {
                "name": "Zelechor Hot Springs Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54895.2,
                  29732.1
                ],
                "id": 375,
                "chat_link": "[&BHcBAAA=]"
              },
              "376": {
                "name": "Halvaunt Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55115.6,
                  29004.9
                ],
                "id": 376,
                "chat_link": "[&BHgBAAA=]"
              },
              "377": {
                "name": "Crossroads Haven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55215,
                  28608.5
                ],
                "id": 377,
                "chat_link": "[&BHkBAAA=]"
              },
              "378": {
                "name": "Dawnrise Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54887.3,
                  28256.2
                ],
                "id": 378,
                "chat_link": "[&BHoBAAA=]"
              },
              "379": {
                "name": "Dolyak Pass Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  56027.3,
                  28351
                ],
                "id": 379,
                "chat_link": "[&BHsBAAA=]"
              },
              "380": {
                "name": "Solitude Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55858.5,
                  27924.5
                ],
                "id": 380,
                "chat_link": "[&BHwBAAA=]"
              },
              "381": {
                "name": "Twinspur Haven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55447.5,
                  29750.6
                ],
                "id": 381,
                "chat_link": "[&BH0BAAA=]"
              },
              "382": {
                "name": "Vendrake's Homestead Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55920.1,
                  29598.3
                ],
                "id": 382,
                "chat_link": "[&BH4BAAA=]"
              },
              "961": {
                "name": "Lostvyrm Cave Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55653.5,
                  28713.6
                ],
                "id": 961,
                "chat_link": "[&BMEDAAA=]"
              },
              "962": {
                "name": "Krennak's Homestead Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55803.7,
                  29098
                ],
                "id": 962,
                "chat_link": "[&BMIDAAA=]"
              },
              "963": {
                "name": "Grawlenfjord Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55876.8,
                  31453.7
                ],
                "id": 963,
                "chat_link": "[&BMMDAAA=]"
              },
              "974": {
                "name": "Haivoissen Kenning",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54705.9,
                  30255.7
                ],
                "id": 974,
                "chat_link": "[&BM4DAAA=]"
              },
              "975": {
                "name": "Dragonblest Hold",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55459.8,
                  27996.1
                ],
                "id": 975,
                "chat_link": "[&BM8DAAA=]"
              },
              "976": {
                "name": "Frostcreek Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55350.6,
                  30114.3
                ],
                "id": 976,
                "chat_link": "[&BNADAAA=]"
              },
              "984": {
                "name": "The Frozen Maw",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56131.1,
                  29001.7
                ],
                "id": 984,
                "chat_link": "[&BNgDAAA=]"
              },
              "1025": {
                "name": "Osenfold Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54936.8,
                  30511.5
                ],
                "id": 1025,
                "chat_link": "[&BAEEAAA=]"
              },
              "1032": {
                "name": "Warmspring Grotto",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56115.3,
                  27939.2
                ],
                "id": 1032,
                "chat_link": "[&BAgEAAA=]"
              },
              "1362": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  55329.3,
                  31045.4
                ],
                "id": 1362,
                "chat_link": "[&BFIFAAA=]"
              },
              "1363": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  55804.1,
                  31037.1
                ],
                "id": 1363,
                "chat_link": "[&BFMFAAA=]"
              },
              "1364": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  55011.6,
                  30205.2
                ],
                "id": 1364,
                "chat_link": "[&BFQFAAA=]"
              },
              "1365": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  55736.9,
                  29830.8
                ],
                "id": 1365,
                "chat_link": "[&BFUFAAA=]"
              },
              "1366": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  54950.5,
                  29753.2
                ],
                "id": 1366,
                "chat_link": "[&BFYFAAA=]"
              },
              "1367": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  55050.2,
                  30657.1
                ],
                "id": 1367,
                "chat_link": "[&BFcFAAA=]"
              },
              "1368": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  55357.9,
                  28993.2
                ],
                "id": 1368,
                "chat_link": "[&BFgFAAA=]"
              },
              "1369": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  54656.2,
                  32011
                ],
                "id": 1369,
                "chat_link": "[&BFkFAAA=]"
              },
              "1370": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  56054.1,
                  30207.9
                ],
                "id": 1370,
                "chat_link": "[&BFoFAAA=]"
              },
              "1371": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  55486.7,
                  28197
                ],
                "id": 1371,
                "chat_link": "[&BFsFAAA=]"
              },
              "1691": {
                "name": "Heart of Corruption",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56138.9,
                  29381.4
                ],
                "id": 1691,
                "chat_link": "[&BJsGAAA=]"
              },
              "1792": {
                "name": "Rugnar's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56106.4,
                  28076.2
                ],
                "id": 1792,
                "chat_link": "[&BAAHAAA=]"
              }
            },
            "tasks": {
              "54": {
                "objective": "Honor the Spirit of Wolf.",
                "level": 4,
                "coord": [
                  55514.7,
                  31765.8
                ],
                "bounds": [
                  [
                    55546.3,
                    32029.8
                  ],
                  [
                    55443.2,
                    32016.8
                  ],
                  [
                    55368.5,
                    32038.3
                  ],
                  [
                    55365,
                    32115.2
                  ],
                  [
                    55321.4,
                    32199.6
                  ],
                  [
                    55239.8,
                    32182.6
                  ],
                  [
                    55239.7,
                    32100.5
                  ],
                  [
                    55258,
                    32041.2
                  ],
                  [
                    55261.8,
                    31973.3
                  ],
                  [
                    55265.3,
                    31896.9
                  ],
                  [
                    55386.2,
                    31801.6
                  ],
                  [
                    55512.1,
                    31718.1
                  ],
                  [
                    55645.5,
                    31691.7
                  ],
                  [
                    55700.9,
                    31856.3
                  ],
                  [
                    55691.9,
                    32005.3
                  ],
                  [
                    55546.3,
                    32029.8
                  ]
                ],
                "id": 54,
                "chat_link": "[&BDYAAAA=]"
              },
              "55": {
                "objective": "Honor the Spirit of Bear.",
                "level": 2,
                "coord": [
                  55804.1,
                  31126.8
                ],
                "bounds": [
                  [
                    55874.9,
                    31327.9
                  ],
                  [
                    55898.5,
                    31303.6
                  ],
                  [
                    55923.3,
                    31186.8
                  ],
                  [
                    55875.8,
                    31148.2
                  ],
                  [
                    55853,
                    31079.3
                  ],
                  [
                    55784.9,
                    31022.1
                  ],
                  [
                    55675.1,
                    31038.6
                  ],
                  [
                    55653.2,
                    31088.5
                  ],
                  [
                    55639.1,
                    31193.7
                  ],
                  [
                    55675.6,
                    31274
                  ],
                  [
                    55720.1,
                    31318.5
                  ],
                  [
                    55786.4,
                    31340
                  ],
                  [
                    55874.9,
                    31327.9
                  ]
                ],
                "id": 55,
                "chat_link": "[&BDcAAAA=]"
              },
              "56": {
                "objective": "Honor the Spirit of Raven.",
                "level": 2,
                "coord": [
                  55443.4,
                  31044.8
                ],
                "bounds": [
                  [
                    55245.2,
                    31072.7
                  ],
                  [
                    55316.2,
                    31092.9
                  ],
                  [
                    55361,
                    31084.4
                  ],
                  [
                    55372.4,
                    31058.1
                  ],
                  [
                    55364.1,
                    31006.9
                  ],
                  [
                    55303.4,
                    30962.1
                  ],
                  [
                    55374.7,
                    30948.1
                  ],
                  [
                    55550.1,
                    31056.3
                  ],
                  [
                    55533.5,
                    31151.5
                  ],
                  [
                    55498.3,
                    31181.6
                  ],
                  [
                    55424.8,
                    31201
                  ],
                  [
                    55351.8,
                    31218.8
                  ],
                  [
                    55315.2,
                    31199.5
                  ],
                  [
                    55267.7,
                    31163.5
                  ],
                  [
                    55222.6,
                    31125.6
                  ],
                  [
                    55224,
                    31097.9
                  ],
                  [
                    55245.2,
                    31072.7
                  ]
                ],
                "id": 56,
                "chat_link": "[&BDgAAAA=]"
              },
              "57": {
                "objective": "Honor the Spirit of Snow Leopard.",
                "level": 5,
                "coord": [
                  55062.6,
                  31488.1
                ],
                "bounds": [
                  [
                    55214.2,
                    31546.6
                  ],
                  [
                    55029.5,
                    31573.7
                  ],
                  [
                    54946.5,
                    31358.9
                  ],
                  [
                    55051.4,
                    31310.3
                  ],
                  [
                    55124.4,
                    31312.2
                  ],
                  [
                    55173.2,
                    31343.1
                  ],
                  [
                    55216.4,
                    31403
                  ],
                  [
                    55221,
                    31461.3
                  ],
                  [
                    55214.2,
                    31546.6
                  ]
                ],
                "id": 57,
                "chat_link": "[&BDkAAAA=]"
              },
              "59": {
                "objective": "Disrupt grawl worship.",
                "level": 3,
                "coord": [
                  55989,
                  31319
                ],
                "bounds": [
                  [
                    55928.3,
                    31287.9
                  ],
                  [
                    56172.8,
                    31216.1
                  ],
                  [
                    56296.8,
                    31526.2
                  ],
                  [
                    56126.8,
                    31492.2
                  ],
                  [
                    55888.1,
                    31376
                  ],
                  [
                    55928.3,
                    31287.9
                  ]
                ],
                "id": 59,
                "chat_link": "[&BDsAAAA=]"
              },
              "60": {
                "objective": "Help the Lionguard keep Crossroads Haven safe.",
                "level": 13,
                "coord": [
                  55240.1,
                  28696.5
                ],
                "bounds": [
                  [
                    55187.1,
                    28992.8
                  ],
                  [
                    55067.2,
                    28940.8
                  ],
                  [
                    54913.1,
                    28798
                  ],
                  [
                    54901.6,
                    28413.6
                  ],
                  [
                    54767.1,
                    28235.6
                  ],
                  [
                    54820.7,
                    28102.7
                  ],
                  [
                    55014.3,
                    28189.8
                  ],
                  [
                    55054.1,
                    28286.8
                  ],
                  [
                    55163.9,
                    28417.3
                  ],
                  [
                    55323.1,
                    28440.2
                  ],
                  [
                    55560.4,
                    28406.4
                  ],
                  [
                    55553.6,
                    28831.7
                  ],
                  [
                    55382.2,
                    28913.3
                  ],
                  [
                    55187.1,
                    28992.8
                  ]
                ],
                "id": 60,
                "chat_link": "[&BDwAAAA=]"
              },
              "61": {
                "objective": "Challenge the minions of Jormag, the ice dragon.",
                "level": 15,
                "coord": [
                  55691.3,
                  28127.8
                ],
                "bounds": [
                  [
                    54999.6,
                    28028.2
                  ],
                  [
                    54977.1,
                    28175.9
                  ],
                  [
                    55040.6,
                    28369.6
                  ],
                  [
                    55193.4,
                    28425.7
                  ],
                  [
                    55558.8,
                    28476.9
                  ],
                  [
                    55619,
                    28444
                  ],
                  [
                    55660.3,
                    28368.2
                  ],
                  [
                    55754.5,
                    28154
                  ],
                  [
                    55719.9,
                    27960.3
                  ],
                  [
                    55210.7,
                    27751.1
                  ],
                  [
                    54999.6,
                    28028.2
                  ]
                ],
                "id": 61,
                "chat_link": "[&BD0AAAA=]"
              },
              "62": {
                "objective": "Help Kevach maintain his lodge.",
                "level": 12,
                "coord": [
                  55869.5,
                  28673.1
                ],
                "bounds": [
                  [
                    55823.1,
                    28892.5
                  ],
                  [
                    55870.6,
                    28883.5
                  ],
                  [
                    55941.7,
                    28789.7
                  ],
                  [
                    55962.1,
                    28688.7
                  ],
                  [
                    55906,
                    28593.8
                  ],
                  [
                    55780.7,
                    28589.1
                  ],
                  [
                    55671.1,
                    28733.9
                  ],
                  [
                    55666.3,
                    28816.7
                  ],
                  [
                    55725,
                    28890.8
                  ],
                  [
                    55789.3,
                    28895.1
                  ],
                  [
                    55823.1,
                    28892.5
                  ]
                ],
                "id": 62,
                "chat_link": "[&BD4AAAA=]"
              },
              "63": {
                "objective": "Help Bjarni honor the Spirit of Hare.",
                "level": 6,
                "coord": [
                  55209.9,
                  30406.7
                ],
                "bounds": [
                  [
                    55539.9,
                    30338.4
                  ],
                  [
                    55373,
                    30150.2
                  ],
                  [
                    55235.9,
                    30209.3
                  ],
                  [
                    55144.9,
                    30378.8
                  ],
                  [
                    55189.6,
                    30500.7
                  ],
                  [
                    55427.8,
                    30506.8
                  ],
                  [
                    55539.9,
                    30338.4
                  ]
                ],
                "id": 63,
                "chat_link": "[&BD8AAAA=]"
              },
              "64": {
                "objective": "Entertain and protect the children.",
                "level": 7,
                "coord": [
                  55722.3,
                  30189.3
                ],
                "bounds": [
                  [
                    55743.3,
                    30063.4
                  ],
                  [
                    55715.1,
                    30060.4
                  ],
                  [
                    55678.4,
                    30077.8
                  ],
                  [
                    55648.2,
                    30117.7
                  ],
                  [
                    55635.5,
                    30172.5
                  ],
                  [
                    55627.8,
                    30244.3
                  ],
                  [
                    55628.4,
                    30295.3
                  ],
                  [
                    55671.6,
                    30332.5
                  ],
                  [
                    55745.9,
                    30348.2
                  ],
                  [
                    55795.9,
                    30313.8
                  ],
                  [
                    55855.6,
                    30321.9
                  ],
                  [
                    55885.5,
                    30282.7
                  ],
                  [
                    55893,
                    30240.4
                  ],
                  [
                    55880.8,
                    30181.5
                  ],
                  [
                    55854.4,
                    30115
                  ],
                  [
                    55743.3,
                    30063.4
                  ]
                ],
                "id": 64,
                "chat_link": "[&BEAAAAA=]"
              },
              "65": {
                "objective": "Help the Lionguard protect the road through the Icesteppes.",
                "level": 8,
                "coord": [
                  55519.2,
                  29678.9
                ],
                "bounds": [
                  [
                    55564.8,
                    29225.1
                  ],
                  [
                    55644.8,
                    29328.5
                  ],
                  [
                    55722.4,
                    29506.2
                  ],
                  [
                    55614,
                    29763
                  ],
                  [
                    55572.6,
                    29848.5
                  ],
                  [
                    55417.5,
                    29844.6
                  ],
                  [
                    55390.3,
                    29765.8
                  ],
                  [
                    55433.8,
                    29617
                  ],
                  [
                    55330.3,
                    29416.8
                  ],
                  [
                    55377.3,
                    29312.1
                  ],
                  [
                    55564.8,
                    29225.1
                  ]
                ],
                "id": 65,
                "chat_link": "[&BEEAAAA=]"
              },
              "66": {
                "objective": "Help the miners in their search for ore by fighting the dredge.",
                "level": 10,
                "coord": [
                  55011,
                  29348.6
                ],
                "bounds": [
                  [
                    54837.1,
                    29455
                  ],
                  [
                    54843.5,
                    29528.3
                  ],
                  [
                    54768,
                    29538.6
                  ],
                  [
                    54699.7,
                    29430.4
                  ],
                  [
                    54646,
                    29403.1
                  ],
                  [
                    54637.8,
                    29466.9
                  ],
                  [
                    54565,
                    29443.9
                  ],
                  [
                    54562.4,
                    29304.8
                  ],
                  [
                    54661.4,
                    29249.3
                  ],
                  [
                    54640.1,
                    29192.9
                  ],
                  [
                    54737.6,
                    29126.4
                  ],
                  [
                    54822.5,
                    29134.8
                  ],
                  [
                    54879.1,
                    29099.8
                  ],
                  [
                    55023,
                    28947
                  ],
                  [
                    55114.6,
                    29017
                  ],
                  [
                    55090.8,
                    29118.1
                  ],
                  [
                    54976.1,
                    29154
                  ],
                  [
                    54902,
                    29138.9
                  ],
                  [
                    54894.7,
                    29289.2
                  ],
                  [
                    55015.8,
                    29242.8
                  ],
                  [
                    55018.8,
                    29366.5
                  ],
                  [
                    54875.8,
                    29338.9
                  ],
                  [
                    54837.1,
                    29455
                  ]
                ],
                "id": 66,
                "chat_link": "[&BEIAAAA=]"
              },
              "67": {
                "objective": "Fight the ice dragon's corruption.",
                "level": 11,
                "coord": [
                  55767.3,
                  29033.2
                ],
                "bounds": [
                  [
                    55809.8,
                    29395.1
                  ],
                  [
                    55658.2,
                    29198.7
                  ],
                  [
                    55556.1,
                    29038.8
                  ],
                  [
                    56048.6,
                    28865.4
                  ],
                  [
                    56128.8,
                    28904.3
                  ],
                  [
                    56216.3,
                    28991.3
                  ],
                  [
                    56241.9,
                    29558.1
                  ],
                  [
                    56100.8,
                    29611.1
                  ],
                  [
                    55963.7,
                    29438.3
                  ],
                  [
                    55809.8,
                    29395.1
                  ]
                ],
                "id": 67,
                "chat_link": "[&BEMAAAA=]"
              },
              "68": {
                "objective": "Help Maxtar Rapidstep capture dolyaks.",
                "level": 14,
                "coord": [
                  56055.2,
                  28366.3
                ],
                "bounds": [
                  [
                    56120.7,
                    28307.7
                  ],
                  [
                    56068,
                    28478.7
                  ],
                  [
                    56001.2,
                    28558.4
                  ],
                  [
                    55776.8,
                    28496.4
                  ],
                  [
                    55752,
                    28364.5
                  ],
                  [
                    55720.3,
                    28197.4
                  ],
                  [
                    55717.2,
                    28077.3
                  ],
                  [
                    55742.2,
                    27952.7
                  ],
                  [
                    55793.3,
                    27900.5
                  ],
                  [
                    55845.2,
                    27875.4
                  ],
                  [
                    55913.4,
                    27878.1
                  ],
                  [
                    55952.7,
                    27970.9
                  ],
                  [
                    56120.7,
                    28307.7
                  ]
                ],
                "id": 68,
                "chat_link": "[&BEQAAAA=]"
              },
              "69": {
                "objective": "Help Albin Chronicler trade with the jotun tribe.",
                "level": 9,
                "coord": [
                  55256.6,
                  29616.9
                ],
                "bounds": [
                  [
                    55045.4,
                    29637.6
                  ],
                  [
                    55123.8,
                    29518.6
                  ],
                  [
                    55197.6,
                    29447.1
                  ],
                  [
                    55390.8,
                    29558.8
                  ],
                  [
                    55410.4,
                    29640.7
                  ],
                  [
                    55408.7,
                    29728.3
                  ],
                  [
                    55382.6,
                    29773.2
                  ],
                  [
                    55229.9,
                    29781.4
                  ],
                  [
                    55104.8,
                    29726.8
                  ],
                  [
                    55045.4,
                    29637.6
                  ]
                ],
                "id": 69,
                "chat_link": "[&BEUAAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  55298.3,
                  27996.5
                ],
                "id": "0-72"
              },
              {
                "coord": [
                  56076.2,
                  27909.9
                ],
                "id": "0-17"
              },
              {
                "coord": [
                  54778.7,
                  29728.4
                ],
                "id": "0-19"
              },
              {
                "coord": [
                  56180,
                  31347.4
                ],
                "id": "0-16"
              },
              {
                "coord": [
                  55726.6,
                  28806.3
                ],
                "id": "0-18"
              },
              {
                "coord": [
                  55293.2,
                  30793.7
                ],
                "id": "0-59"
              },
              {
                "coord": [
                  56121,
                  29038.2
                ],
                "id": "0-64"
              },
              {
                "coord": [
                  56170.1,
                  30132.4
                ],
                "id": "0-79"
              }
            ],
            "sectors": {
              "195": {
                "name": "Molensk",
                "level": 5,
                "coord": [
                  54854.9,
                  31843.1
                ],
                "bounds": [
                  [
                    54515.3,
                    31274.4
                  ],
                  [
                    54883.9,
                    31275.1
                  ],
                  [
                    54965.3,
                    31398.2
                  ],
                  [
                    54940,
                    31563.8
                  ],
                  [
                    55207.6,
                    31618
                  ],
                  [
                    55227,
                    31920.1
                  ],
                  [
                    54998.9,
                    32070
                  ],
                  [
                    55003.5,
                    32160.8
                  ],
                  [
                    54894.4,
                    32262.9
                  ],
                  [
                    54784.9,
                    32305.3
                  ],
                  [
                    54706.4,
                    32433.6
                  ],
                  [
                    54562.3,
                    32125.4
                  ],
                  [
                    54424.5,
                    31553.3
                  ],
                  [
                    54515.3,
                    31274.4
                  ]
                ],
                "id": 195,
                "chat_link": "[&BMMAAAA=]"
              },
              "196": {
                "name": "Outcast's Cleft",
                "level": 4,
                "coord": [
                  55456.1,
                  31954.3
                ],
                "bounds": [
                  [
                    56176.1,
                    32113.4
                  ],
                  [
                    55713.9,
                    31630.6
                  ],
                  [
                    55476.3,
                    31640
                  ],
                  [
                    55207.1,
                    31617.5
                  ],
                  [
                    55224.6,
                    31919.5
                  ],
                  [
                    54994.2,
                    32073.5
                  ],
                  [
                    55001.5,
                    32168.5
                  ],
                  [
                    55489.6,
                    32215.6
                  ],
                  [
                    55821.8,
                    32210.1
                  ],
                  [
                    56176.1,
                    32113.4
                  ]
                ],
                "id": 196,
                "chat_link": "[&BMQAAAA=]"
              },
              "197": {
                "name": "The Grekvelnn Burrows",
                "level": 4,
                "coord": [
                  56120.4,
                  31710
                ],
                "bounds": [
                  [
                    56050.5,
                    31711.5
                  ],
                  [
                    56067.3,
                    31361.3
                  ],
                  [
                    56294.3,
                    31416.3
                  ],
                  [
                    56303.8,
                    31894.3
                  ],
                  [
                    56170.4,
                    32113.7
                  ],
                  [
                    55836.3,
                    31762.9
                  ],
                  [
                    56050.5,
                    31711.5
                  ]
                ],
                "id": 197,
                "chat_link": "[&BMUAAAA=]"
              },
              "198": {
                "name": "Grawlenfjord",
                "level": 3,
                "coord": [
                  55900.5,
                  31298.1
                ],
                "bounds": [
                  [
                    55773.9,
                    31117.4
                  ],
                  [
                    55817,
                    31037.1
                  ],
                  [
                    55865.1,
                    31047.1
                  ],
                  [
                    55893.6,
                    30997.3
                  ],
                  [
                    56081,
                    30999.2
                  ],
                  [
                    56068.5,
                    31380.1
                  ],
                  [
                    56051.4,
                    31713
                  ],
                  [
                    55840.6,
                    31765.8
                  ],
                  [
                    55713.6,
                    31626.1
                  ],
                  [
                    55773.9,
                    31117.4
                  ]
                ],
                "id": 198,
                "chat_link": "[&BMYAAAA=]"
              },
              "199": {
                "name": "Kresdor Kenning",
                "level": 4,
                "coord": [
                  56190.7,
                  31094
                ],
                "bounds": [
                  [
                    56041.5,
                    30806.2
                  ],
                  [
                    56303.2,
                    30827
                  ],
                  [
                    56360.8,
                    31142.7
                  ],
                  [
                    56296.1,
                    31417.1
                  ],
                  [
                    56066.1,
                    31360.4
                  ],
                  [
                    56076.6,
                    31010.9
                  ],
                  [
                    56041.5,
                    30806.2
                  ]
                ],
                "id": 199,
                "chat_link": "[&BMcAAAA=]"
              },
              "200": {
                "name": "Borealis Forest",
                "level": 5,
                "coord": [
                  55458.4,
                  31311.6
                ],
                "bounds": [
                  [
                    54941.6,
                    31566.1
                  ],
                  [
                    54965.4,
                    31394.7
                  ],
                  [
                    55114.1,
                    31398.1
                  ],
                  [
                    55542.2,
                    31028.7
                  ],
                  [
                    55709.4,
                    30997.8
                  ],
                  [
                    55776.4,
                    30997.2
                  ],
                  [
                    55817.2,
                    31036.9
                  ],
                  [
                    55778.4,
                    31118.2
                  ],
                  [
                    55713.8,
                    31630.9
                  ],
                  [
                    55477.1,
                    31642.2
                  ],
                  [
                    55206.8,
                    31616.5
                  ],
                  [
                    54941.6,
                    31566.1
                  ]
                ],
                "id": 200,
                "chat_link": "[&BMgAAAA=]"
              },
              "201": {
                "name": "Snowlord's Gate",
                "level": 2,
                "coord": [
                  55057.6,
                  31036
                ],
                "bounds": [
                  [
                    55114.5,
                    31399.2
                  ],
                  [
                    55538.9,
                    31028.7
                  ],
                  [
                    55445,
                    30973.2
                  ],
                  [
                    55364.5,
                    30906.9
                  ],
                  [
                    55271.6,
                    30878.4
                  ],
                  [
                    55052.7,
                    30720.3
                  ],
                  [
                    54961.1,
                    30720.2
                  ],
                  [
                    54533,
                    30817.9
                  ],
                  [
                    54501.8,
                    31276.3
                  ],
                  [
                    54883.3,
                    31277.5
                  ],
                  [
                    54966.6,
                    31397.1
                  ],
                  [
                    55114.5,
                    31399.2
                  ]
                ],
                "id": 201,
                "chat_link": "[&BMkAAAA=]"
              },
              "202": {
                "name": "The Osenfold Shear",
                "level": 7,
                "coord": [
                  54845,
                  30296.8
                ],
                "bounds": [
                  [
                    54850.6,
                    30020.3
                  ],
                  [
                    54913.7,
                    29963.9
                  ],
                  [
                    55056.6,
                    30174.2
                  ],
                  [
                    55176.7,
                    30189.9
                  ],
                  [
                    55239.6,
                    30317.4
                  ],
                  [
                    54963.7,
                    30397.6
                  ],
                  [
                    54941.2,
                    30473
                  ],
                  [
                    54985,
                    30528
                  ],
                  [
                    54961.6,
                    30720.9
                  ],
                  [
                    54528.6,
                    30814.3
                  ],
                  [
                    54435.7,
                    30440.9
                  ],
                  [
                    54503.1,
                    30062.8
                  ],
                  [
                    54564.7,
                    30133.4
                  ],
                  [
                    54697.3,
                    30168
                  ],
                  [
                    54856.4,
                    30048.2
                  ],
                  [
                    54850.6,
                    30020.3
                  ]
                ],
                "id": 202,
                "chat_link": "[&BMoAAAA=]"
              },
              "203": {
                "name": "Doldenvan Passage",
                "level": 7,
                "coord": [
                  55792.9,
                  30825.7
                ],
                "bounds": [
                  [
                    55505.1,
                    30650.4
                  ],
                  [
                    55742.8,
                    30645.7
                  ],
                  [
                    55769.2,
                    30514.4
                  ],
                  [
                    55862.4,
                    30551.7
                  ],
                  [
                    55933.1,
                    30656.1
                  ],
                  [
                    56033,
                    30717.9
                  ],
                  [
                    56086.8,
                    31001.3
                  ],
                  [
                    55895.6,
                    31000.9
                  ],
                  [
                    55866.6,
                    31052.2
                  ],
                  [
                    55817.9,
                    31039.4
                  ],
                  [
                    55775.3,
                    30999
                  ],
                  [
                    55699.3,
                    31004.5
                  ],
                  [
                    55652.1,
                    30938.4
                  ],
                  [
                    55461.7,
                    30787.3
                  ],
                  [
                    55505.1,
                    30650.4
                  ]
                ],
                "id": 203,
                "chat_link": "[&BMsAAAA=]"
              },
              "204": {
                "name": "Darkriven Bluffs",
                "level": 7,
                "coord": [
                  55955.6,
                  30351.6
                ],
                "bounds": [
                  [
                    55880.8,
                    30268
                  ],
                  [
                    55860.3,
                    30127.2
                  ],
                  [
                    55742.2,
                    30062.1
                  ],
                  [
                    55656.6,
                    30067.7
                  ],
                  [
                    55613.4,
                    29949.7
                  ],
                  [
                    56125.5,
                    29962.5
                  ],
                  [
                    56333.6,
                    29933.5
                  ],
                  [
                    56391,
                    30454.1
                  ],
                  [
                    56306.6,
                    30827.8
                  ],
                  [
                    56056.2,
                    30817.2
                  ],
                  [
                    56025.5,
                    30713.1
                  ],
                  [
                    55930.1,
                    30656.3
                  ],
                  [
                    55859.5,
                    30552
                  ],
                  [
                    55767.9,
                    30517.6
                  ],
                  [
                    55785,
                    30365.6
                  ],
                  [
                    55880.8,
                    30268
                  ]
                ],
                "id": 204,
                "chat_link": "[&BMwAAAA=]"
              },
              "205": {
                "name": "Taigan Groves",
                "level": 7,
                "coord": [
                  55579,
                  30296.2
                ],
                "bounds": [
                  [
                    55239.7,
                    30317.3
                  ],
                  [
                    55174.7,
                    30189.8
                  ],
                  [
                    55307,
                    30205.3
                  ],
                  [
                    55656.8,
                    30068.6
                  ],
                  [
                    55744.6,
                    30060.7
                  ],
                  [
                    55864.3,
                    30127.9
                  ],
                  [
                    55880.8,
                    30268
                  ],
                  [
                    55787.7,
                    30365
                  ],
                  [
                    55742.3,
                    30647
                  ],
                  [
                    55562.3,
                    30484.1
                  ],
                  [
                    55408.7,
                    30524.3
                  ],
                  [
                    55239.7,
                    30317.3
                  ]
                ],
                "id": 205,
                "chat_link": "[&BM0AAAA=]"
              },
              "206": {
                "name": "Icevine Dale",
                "level": 7,
                "coord": [
                  55247.7,
                  29919.5
                ],
                "bounds": [
                  [
                    55309.7,
                    30208.8
                  ],
                  [
                    55658.8,
                    30070.7
                  ],
                  [
                    55598.8,
                    29852
                  ],
                  [
                    55412.4,
                    29841.5
                  ],
                  [
                    55308.6,
                    29697.2
                  ],
                  [
                    54989,
                    29681.1
                  ],
                  [
                    54985.2,
                    29781.4
                  ],
                  [
                    54914.2,
                    29967.1
                  ],
                  [
                    55052.2,
                    30175.8
                  ],
                  [
                    55309.7,
                    30208.8
                  ]
                ],
                "id": 206,
                "chat_link": "[&BM4AAAA=]"
              },
              "207": {
                "name": "The Shadowhorns",
                "level": 7,
                "coord": [
                  54788.7,
                  29777.4
                ],
                "bounds": [
                  [
                    54606.4,
                    29762.6
                  ],
                  [
                    54510.8,
                    29781
                  ],
                  [
                    54520.6,
                    29658.8
                  ],
                  [
                    54864.5,
                    29584.9
                  ],
                  [
                    55002.6,
                    29511.7
                  ],
                  [
                    54985,
                    29779.7
                  ],
                  [
                    54913,
                    29965.5
                  ],
                  [
                    54852.2,
                    30019.8
                  ],
                  [
                    54843,
                    29932.9
                  ],
                  [
                    54606.4,
                    29762.6
                  ]
                ],
                "id": 207,
                "chat_link": "[&BM8AAAA=]"
              },
              "208": {
                "name": "Moleberia",
                "level": 11,
                "coord": [
                  54753.9,
                  29330
                ],
                "bounds": [
                  [
                    54867.5,
                    29590.2
                  ],
                  [
                    55001.3,
                    29512.5
                  ],
                  [
                    54944.5,
                    29368.1
                  ],
                  [
                    54921.3,
                    29181.4
                  ],
                  [
                    54820.3,
                    28977.8
                  ],
                  [
                    54539.6,
                    29029.8
                  ],
                  [
                    54424.4,
                    29310.3
                  ],
                  [
                    54512,
                    29670.1
                  ],
                  [
                    54867.5,
                    29590.2
                  ]
                ],
                "id": 208,
                "chat_link": "[&BNAAAAA=]"
              },
              "209": {
                "name": "The Icesteppes",
                "level": 9,
                "coord": [
                  55480.9,
                  29639.8
                ],
                "bounds": [
                  [
                    54990.2,
                    29681.6
                  ],
                  [
                    55308.7,
                    29700.8
                  ],
                  [
                    55412.9,
                    29844.2
                  ],
                  [
                    55599.8,
                    29854
                  ],
                  [
                    55618.4,
                    29959.5
                  ],
                  [
                    55884,
                    29955
                  ],
                  [
                    55869.5,
                    29733.4
                  ],
                  [
                    55762.5,
                    29562.1
                  ],
                  [
                    55852.1,
                    29312
                  ],
                  [
                    55527.3,
                    29193.6
                  ],
                  [
                    54943.5,
                    29367.1
                  ],
                  [
                    55002.3,
                    29514.5
                  ],
                  [
                    54990.2,
                    29681.6
                  ]
                ],
                "id": 209,
                "chat_link": "[&BNEAAAA=]"
              },
              "210": {
                "name": "Frusenfell Creek",
                "level": 10,
                "coord": [
                  56072.3,
                  29581.1
                ],
                "bounds": [
                  [
                    56166.5,
                    29192.1
                  ],
                  [
                    56308.2,
                    29206.8
                  ],
                  [
                    56405.2,
                    29353.3
                  ],
                  [
                    56272.8,
                    29953
                  ],
                  [
                    56131.8,
                    29967.6
                  ],
                  [
                    55885.4,
                    29952.3
                  ],
                  [
                    55869.5,
                    29734.2
                  ],
                  [
                    55760.4,
                    29562.8
                  ],
                  [
                    55851.2,
                    29307.7
                  ],
                  [
                    56166.5,
                    29192.1
                  ]
                ],
                "id": 210,
                "chat_link": "[&BNIAAAA=]"
              },
              "211": {
                "name": "Hunter's Lake",
                "level": 11,
                "coord": [
                  56027.3,
                  28968
                ],
                "bounds": [
                  [
                    55530.8,
                    28840.6
                  ],
                  [
                    55739.3,
                    28708.9
                  ],
                  [
                    56015.5,
                    28728.1
                  ],
                  [
                    56303.8,
                    28676.6
                  ],
                  [
                    56368.2,
                    28741.2
                  ],
                  [
                    56462.3,
                    29073.9
                  ],
                  [
                    56309,
                    29209.9
                  ],
                  [
                    56166.6,
                    29196.4
                  ],
                  [
                    55850.5,
                    29308.4
                  ],
                  [
                    55526.7,
                    29196.2
                  ],
                  [
                    55530.8,
                    28840.6
                  ]
                ],
                "id": 211,
                "chat_link": "[&BNMAAAA=]"
              },
              "212": {
                "name": "Wurmhowl Spikes",
                "level": 12,
                "coord": [
                  55399.5,
                  28957.3
                ],
                "bounds": [
                  [
                    55531.2,
                    28839.7
                  ],
                  [
                    55525.8,
                    29195.2
                  ],
                  [
                    55445.2,
                    29219.6
                  ],
                  [
                    55255.1,
                    28925.4
                  ],
                  [
                    55230.8,
                    28790.8
                  ],
                  [
                    55409,
                    28773
                  ],
                  [
                    55531.2,
                    28839.7
                  ]
                ],
                "id": 212,
                "chat_link": "[&BNQAAAA=]"
              },
              "213": {
                "name": "Halvaunt Snowfield",
                "level": 13,
                "coord": [
                  55021.5,
                  28813.7
                ],
                "bounds": [
                  [
                    54818.6,
                    28978.2
                  ],
                  [
                    54596.2,
                    29018.3
                  ],
                  [
                    54512.3,
                    28621.4
                  ],
                  [
                    54595.9,
                    28486
                  ],
                  [
                    54970,
                    28441.6
                  ],
                  [
                    55114.2,
                    28368.8
                  ],
                  [
                    55465.7,
                    28412.2
                  ],
                  [
                    55411.3,
                    28768.4
                  ],
                  [
                    55231.8,
                    28790.3
                  ],
                  [
                    55255.6,
                    28924.1
                  ],
                  [
                    55446.7,
                    29219.4
                  ],
                  [
                    54943.3,
                    29366.4
                  ],
                  [
                    54918.3,
                    29182.6
                  ],
                  [
                    54818.6,
                    28978.2
                  ]
                ],
                "id": 213,
                "chat_link": "[&BNUAAAA=]"
              },
              "214": {
                "name": "Dawnrise Pass",
                "level": 15,
                "coord": [
                  54773.8,
                  27947.1
                ],
                "bounds": [
                  [
                    54969.4,
                    28443.9
                  ],
                  [
                    55113,
                    28369.5
                  ],
                  [
                    55023,
                    27955.6
                  ],
                  [
                    55053.8,
                    27664
                  ],
                  [
                    54961.7,
                    27473.8
                  ],
                  [
                    54639.9,
                    27546.1
                  ],
                  [
                    54478.5,
                    27699
                  ],
                  [
                    54444,
                    27856.7
                  ],
                  [
                    54466.3,
                    27979.3
                  ],
                  [
                    54588.3,
                    28482.7
                  ],
                  [
                    54969.4,
                    28443.9
                  ]
                ],
                "id": 214,
                "chat_link": "[&BNYAAAA=]"
              },
              "215": {
                "name": "Svanir's Dome",
                "level": 15,
                "coord": [
                  55287.5,
                  27907.9
                ],
                "bounds": [
                  [
                    55054.4,
                    27665.6
                  ],
                  [
                    55148.2,
                    27597.2
                  ],
                  [
                    55370,
                    27614
                  ],
                  [
                    55433.3,
                    27684.6
                  ],
                  [
                    55539.1,
                    27920.6
                  ],
                  [
                    55626.8,
                    28441.6
                  ],
                  [
                    55108.3,
                    28372.1
                  ],
                  [
                    55019.9,
                    27967.8
                  ],
                  [
                    55054.4,
                    27665.6
                  ]
                ],
                "id": 215,
                "chat_link": "[&BNcAAAA=]"
              },
              "216": {
                "name": "Dolyak Pass",
                "level": 14,
                "coord": [
                  55976.8,
                  28489.6
                ],
                "bounds": [
                  [
                    55980.1,
                    28299.1
                  ],
                  [
                    56114.7,
                    28305.4
                  ],
                  [
                    56218.1,
                    28356.6
                  ],
                  [
                    56347,
                    28354.6
                  ],
                  [
                    56380.1,
                    28331.2
                  ],
                  [
                    56383,
                    28451.9
                  ],
                  [
                    56354.7,
                    28640.8
                  ],
                  [
                    56300.1,
                    28676.3
                  ],
                  [
                    55988.1,
                    28727.3
                  ],
                  [
                    55738.9,
                    28710.6
                  ],
                  [
                    55530.8,
                    28839.7
                  ],
                  [
                    55408.1,
                    28771.4
                  ],
                  [
                    55463.7,
                    28417.8
                  ],
                  [
                    55619,
                    28449.9
                  ],
                  [
                    55822.6,
                    28257.2
                  ],
                  [
                    55979.4,
                    28244.4
                  ],
                  [
                    55980.1,
                    28299.1
                  ]
                ],
                "id": 216,
                "chat_link": "[&BNgAAAA=]"
              },
              "217": {
                "name": "Solitude Vale",
                "level": 15,
                "coord": [
                  55772.3,
                  27876.7
                ],
                "bounds": [
                  [
                    55536.3,
                    27920.9
                  ],
                  [
                    55623.6,
                    28455.1
                  ],
                  [
                    55827.4,
                    28260.3
                  ],
                  [
                    55977.8,
                    28244
                  ],
                  [
                    55995.9,
                    28009.5
                  ],
                  [
                    55920,
                    27655.8
                  ],
                  [
                    55920.4,
                    27654.9
                  ],
                  [
                    55863.2,
                    27557.7
                  ],
                  [
                    55753.7,
                    27546.4
                  ],
                  [
                    55648,
                    27649.9
                  ],
                  [
                    55429.2,
                    27688.8
                  ],
                  [
                    55536.3,
                    27920.9
                  ]
                ],
                "id": 217,
                "chat_link": "[&BNkAAAA=]"
              },
              "512": {
                "name": "Hangrammr Climb",
                "level": 7,
                "coord": [
                  55420.7,
                  30764.1
                ],
                "bounds": [
                  [
                    55542.3,
                    31033.3
                  ],
                  [
                    55441.4,
                    30971.9
                  ],
                  [
                    55364.3,
                    30909.9
                  ],
                  [
                    55270.8,
                    30882.8
                  ],
                  [
                    55052.9,
                    30720.8
                  ],
                  [
                    55058,
                    30601.9
                  ],
                  [
                    55124.3,
                    30544.6
                  ],
                  [
                    55410.5,
                    30525.2
                  ],
                  [
                    55558.1,
                    30482.5
                  ],
                  [
                    55742.3,
                    30642.4
                  ],
                  [
                    55505.8,
                    30651
                  ],
                  [
                    55461.3,
                    30788.4
                  ],
                  [
                    55648.9,
                    30936.3
                  ],
                  [
                    55708.7,
                    31006.5
                  ],
                  [
                    55542.3,
                    31033.3
                  ]
                ],
                "id": 512,
                "chat_link": "[&BAACAAA=]"
              },
              "829": {
                "name": "Breakneck Pass",
                "level": 6,
                "coord": [
                  55081.7,
                  30536.1
                ],
                "bounds": [
                  [
                    54986.1,
                    30527.5
                  ],
                  [
                    54941.3,
                    30472.7
                  ],
                  [
                    54963.7,
                    30397.4
                  ],
                  [
                    55239.9,
                    30316.5
                  ],
                  [
                    55408.2,
                    30524.3
                  ],
                  [
                    55123.8,
                    30544.2
                  ],
                  [
                    55058,
                    30601.3
                  ],
                  [
                    55053.3,
                    30721
                  ],
                  [
                    54961.5,
                    30720.2
                  ],
                  [
                    54986.1,
                    30527.5
                  ]
                ],
                "id": 829,
                "chat_link": "[&BD0DAAA=]"
              },
              "1017": {
                "name": "Shaman's Rookery",
                "level": 10,
                "coord": [
                  54631.9,
                  29976.4
                ],
                "bounds": [
                  [
                    54562.2,
                    30134.1
                  ],
                  [
                    54697.6,
                    30169.9
                  ],
                  [
                    54859.4,
                    30053.9
                  ],
                  [
                    54844,
                    29929.9
                  ],
                  [
                    54606.3,
                    29760.6
                  ],
                  [
                    54501.8,
                    29780.4
                  ],
                  [
                    54477,
                    29916.6
                  ],
                  [
                    54506.6,
                    30066.1
                  ],
                  [
                    54562.2,
                    30134.1
                  ]
                ],
                "id": 1017,
                "chat_link": "[&BPkDAAA=]"
              },
              "1108": {
                "name": "Cragstead",
                "level": 0,
                "coord": [
                  56190,
                  27978.9
                ],
                "bounds": [
                  [
                    56115.6,
                    28303.7
                  ],
                  [
                    56218.2,
                    28356.5
                  ],
                  [
                    56346.6,
                    28354.8
                  ],
                  [
                    56476.2,
                    28282.9
                  ],
                  [
                    56364.7,
                    28065.3
                  ],
                  [
                    56386,
                    27922.3
                  ],
                  [
                    56397.8,
                    27743.6
                  ],
                  [
                    56305.5,
                    27604.8
                  ],
                  [
                    56130.2,
                    27598.9
                  ],
                  [
                    56061.2,
                    27651.1
                  ],
                  [
                    55921.4,
                    27654.5
                  ],
                  [
                    55961.2,
                    27859.5
                  ],
                  [
                    55995.8,
                    28009.7
                  ],
                  [
                    55979.1,
                    28297
                  ],
                  [
                    56115.6,
                    28303.7
                  ]
                ],
                "id": 1108,
                "chat_link": "[&BFQEAAA=]"
              }
            },
            "adventures": [],
            "id": 28,
            "mastery_points": []
          },
          "29": {
            "name": "Timberline Falls",
            "min_level": 50,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              52864,
              36160
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                51712,
                34560
              ],
              [
                54016,
                37760
              ]
            ],
            "points_of_interest": {
              "567": {
                "name": "Caer Evermore",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52411.1,
                  37561.3
                ],
                "id": 567,
                "chat_link": "[&BDcCAAA=]"
              },
              "568": {
                "name": "Okarinoo",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53371,
                  37550.3
                ],
                "id": 568,
                "chat_link": "[&BDgCAAA=]"
              },
              "569": {
                "name": "Irenic Shoal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53083.5,
                  37661.8
                ],
                "id": 569,
                "chat_link": "[&BDkCAAA=]"
              },
              "570": {
                "name": "Sipedon Deeps",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53330.9,
                  37056.6
                ],
                "id": 570,
                "chat_link": "[&BDoCAAA=]"
              },
              "571": {
                "name": "Kiriel Rock",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53549.5,
                  36333.1
                ],
                "id": 571,
                "chat_link": "[&BDsCAAA=]"
              },
              "572": {
                "name": "The Great Oouo",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53819.4,
                  35920.2
                ],
                "id": 572,
                "chat_link": "[&BDwCAAA=]"
              },
              "573": {
                "name": "Whispering Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53755.3,
                  35978.9
                ],
                "id": 573,
                "chat_link": "[&BD0CAAA=]"
              },
              "574": {
                "name": "Stovepipe Pogue",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52715.1,
                  35758.2
                ],
                "id": 574,
                "chat_link": "[&BD4CAAA=]"
              },
              "575": {
                "name": "Goldenlight Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51941.8,
                  35987.2
                ],
                "id": 575,
                "chat_link": "[&BD8CAAA=]"
              },
              "576": {
                "name": "Thistlereed Grove",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52079.7,
                  35507.9
                ],
                "id": 576,
                "chat_link": "[&BEACAAA=]"
              },
              "577": {
                "name": "Kyesjard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52127.9,
                  35027.5
                ],
                "id": 577,
                "chat_link": "[&BEECAAA=]"
              },
              "578": {
                "name": "Balddistead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52934,
                  35056.4
                ],
                "id": 578,
                "chat_link": "[&BEICAAA=]"
              },
              "579": {
                "name": "Copperhammer Mines",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53616.5,
                  35198
                ],
                "id": 579,
                "chat_link": "[&BEMCAAA=]"
              },
              "580": {
                "name": "Talus Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52275,
                  37557
                ],
                "id": 580,
                "chat_link": "[&BEQCAAA=]"
              },
              "581": {
                "name": "Serpent Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52703.3,
                  37372.3
                ],
                "id": 581,
                "chat_link": "[&BEUCAAA=]"
              },
              "582": {
                "name": "Okarinoo Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53427.3,
                  37497.4
                ],
                "id": 582,
                "chat_link": "[&BEYCAAA=]"
              },
              "583": {
                "name": "Coil Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53745.1,
                  37076.3
                ],
                "id": 583,
                "chat_link": "[&BEcCAAA=]"
              },
              "584": {
                "name": "Scale Strand Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53743.5,
                  36599.4
                ],
                "id": 584,
                "chat_link": "[&BEgCAAA=]"
              },
              "585": {
                "name": "Nonmoa Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52965.4,
                  36940.2
                ],
                "id": 585,
                "chat_link": "[&BEkCAAA=]"
              },
              "586": {
                "name": "Eztlitl Grounds Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53209.3,
                  36483.8
                ],
                "id": 586,
                "chat_link": "[&BEoCAAA=]"
              },
              "587": {
                "name": "Gyre Rapids Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52444.4,
                  36753.5
                ],
                "id": 587,
                "chat_link": "[&BEsCAAA=]"
              },
              "588": {
                "name": "Valance Tutory Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52162.3,
                  35949.1
                ],
                "id": 588,
                "chat_link": "[&BEwCAAA=]"
              },
              "589": {
                "name": "Ogduk Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53439,
                  35899
                ],
                "id": 589,
                "chat_link": "[&BE0CAAA=]"
              },
              "590": {
                "name": "Foundation 86 Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53844.9,
                  35324.5
                ],
                "id": 590,
                "chat_link": "[&BE4CAAA=]"
              },
              "591": {
                "name": "White Paper Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53082.4,
                  35437.1
                ],
                "id": 591,
                "chat_link": "[&BE8CAAA=]"
              },
              "592": {
                "name": "Gentle River Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52594.4,
                  35193.1
                ],
                "id": 592,
                "chat_link": "[&BFACAAA=]"
              },
              "593": {
                "name": "Thistlereed Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52241.5,
                  35598
                ],
                "id": 593,
                "chat_link": "[&BFECAAA=]"
              },
              "594": {
                "name": "Krongar Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51953.9,
                  34727.6
                ],
                "id": 594,
                "chat_link": "[&BFICAAA=]"
              },
              "595": {
                "name": "Iron Veil Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53185.3,
                  34786.5
                ],
                "id": 595,
                "chat_link": "[&BFMCAAA=]"
              },
              "596": {
                "name": "Rankor Ruins Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52237.6,
                  37073
                ],
                "id": 596,
                "chat_link": "[&BFQCAAA=]"
              },
              "597": {
                "name": "Concordia Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52216.5,
                  36527.9
                ],
                "id": 597,
                "chat_link": "[&BFUCAAA=]"
              },
              "1094": {
                "name": "Stromkarl Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52877.6,
                  36203
                ],
                "id": 1094,
                "chat_link": "[&BEYEAAA=]"
              },
              "1633": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  52216.8,
                  35097.1
                ],
                "id": 1633,
                "chat_link": "[&BGEGAAA=]"
              },
              "1634": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  53534.5,
                  36290.6
                ],
                "id": 1634,
                "chat_link": "[&BGIGAAA=]"
              },
              "1635": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  53393.5,
                  37054.1
                ],
                "id": 1635,
                "chat_link": "[&BGMGAAA=]"
              },
              "1636": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  52165.9,
                  36022.8
                ],
                "id": 1636,
                "chat_link": "[&BGQGAAA=]"
              },
              "1637": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  52754.5,
                  34817.3
                ],
                "id": 1637,
                "chat_link": "[&BGUGAAA=]"
              },
              "1638": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  52353.8,
                  36265.6
                ],
                "id": 1638,
                "chat_link": "[&BGYGAAA=]"
              }
            },
            "tasks": {
              "70": {
                "objective": "Help make Stromkarl Heights safe for travelers.",
                "level": 55,
                "coord": [
                  52835.1,
                  36192.9
                ],
                "bounds": [
                  [
                    52437.2,
                    36302.1
                  ],
                  [
                    52443.4,
                    36346
                  ],
                  [
                    52459.4,
                    36394
                  ],
                  [
                    52502.5,
                    36458.3
                  ],
                  [
                    52559.9,
                    36457.1
                  ],
                  [
                    52607.4,
                    36472.5
                  ],
                  [
                    52632.5,
                    36537.4
                  ],
                  [
                    52637.2,
                    36602.9
                  ],
                  [
                    52606.9,
                    36666.1
                  ],
                  [
                    52585.7,
                    36707.9
                  ],
                  [
                    52602.3,
                    36761.8
                  ],
                  [
                    52615.7,
                    36816.9
                  ],
                  [
                    52642.7,
                    36856.1
                  ],
                  [
                    52705.4,
                    36872.2
                  ],
                  [
                    52775,
                    36872.9
                  ],
                  [
                    52827,
                    36874.1
                  ],
                  [
                    52870,
                    36851.5
                  ],
                  [
                    52901.4,
                    36813.8
                  ],
                  [
                    52918.2,
                    36769.7
                  ],
                  [
                    52926.3,
                    36713.6
                  ],
                  [
                    52924.7,
                    36624.1
                  ],
                  [
                    52933.5,
                    36538.3
                  ],
                  [
                    52953.7,
                    36449.7
                  ],
                  [
                    52967.3,
                    36325.1
                  ],
                  [
                    52949.3,
                    36209.8
                  ],
                  [
                    52813.7,
                    36151.8
                  ],
                  [
                    52707.2,
                    36183.1
                  ],
                  [
                    52620,
                    36183.7
                  ],
                  [
                    52549,
                    36222.4
                  ],
                  [
                    52473.3,
                    36264.6
                  ],
                  [
                    52437.2,
                    36302.1
                  ]
                ],
                "id": 70,
                "chat_link": "[&BEYAAAA=]"
              },
              "71": {
                "objective": "Help the alliance of the Vigil and Priory.",
                "level": 56,
                "coord": [
                  52212.5,
                  36331.5
                ],
                "bounds": [
                  [
                    52615.9,
                    36444.6
                  ],
                  [
                    52573.7,
                    36412.5
                  ],
                  [
                    52514,
                    36413.4
                  ],
                  [
                    52480.4,
                    36390.7
                  ],
                  [
                    52436.5,
                    36352.5
                  ],
                  [
                    52394.1,
                    36326.5
                  ],
                  [
                    52317.7,
                    36310.1
                  ],
                  [
                    52247.4,
                    36293.5
                  ],
                  [
                    52157.5,
                    36279.8
                  ],
                  [
                    52045.5,
                    36309.6
                  ],
                  [
                    51940.3,
                    36348.9
                  ],
                  [
                    51921,
                    36475.6
                  ],
                  [
                    51932.6,
                    36541.7
                  ],
                  [
                    51976.5,
                    36625.1
                  ],
                  [
                    52040.5,
                    36701.4
                  ],
                  [
                    52120.1,
                    36745.9
                  ],
                  [
                    52192.8,
                    36732.2
                  ],
                  [
                    52235.1,
                    36726.8
                  ],
                  [
                    52279,
                    36724.2
                  ],
                  [
                    52322.6,
                    36749
                  ],
                  [
                    52412.8,
                    36794.3
                  ],
                  [
                    52494.4,
                    36802.2
                  ],
                  [
                    52566.8,
                    36697.9
                  ],
                  [
                    52588,
                    36633.9
                  ],
                  [
                    52618.1,
                    36571.9
                  ],
                  [
                    52628.5,
                    36494.6
                  ],
                  [
                    52615.9,
                    36444.6
                  ]
                ],
                "id": 71,
                "chat_link": "[&BEcAAAA=]"
              },
              "72": {
                "objective": "Help Goldenlight Hallow with their experiments.",
                "level": 55,
                "coord": [
                  52155.5,
                  36012.9
                ],
                "bounds": [
                  [
                    52229.9,
                    35791.8
                  ],
                  [
                    52185.1,
                    35789.7
                  ],
                  [
                    52112.1,
                    35801.3
                  ],
                  [
                    52054.9,
                    35813
                  ],
                  [
                    51990.4,
                    35829.7
                  ],
                  [
                    51907,
                    35866
                  ],
                  [
                    51846.6,
                    35928.5
                  ],
                  [
                    51830.7,
                    36001.5
                  ],
                  [
                    51823.3,
                    36084.5
                  ],
                  [
                    51862.2,
                    36213.3
                  ],
                  [
                    51955,
                    36253.6
                  ],
                  [
                    52058.3,
                    36247
                  ],
                  [
                    52154,
                    36221.1
                  ],
                  [
                    52242.4,
                    36200.3
                  ],
                  [
                    52328.8,
                    36186.9
                  ],
                  [
                    52395.6,
                    36170.3
                  ],
                  [
                    52432.4,
                    36087.8
                  ],
                  [
                    52441.6,
                    35982.8
                  ],
                  [
                    52416.5,
                    35884
                  ],
                  [
                    52366,
                    35819.8
                  ],
                  [
                    52305,
                    35783.5
                  ],
                  [
                    52262.7,
                    35790.6
                  ],
                  [
                    52229.9,
                    35791.8
                  ]
                ],
                "id": 72,
                "chat_link": "[&BEgAAAA=]"
              },
              "73": {
                "objective": "Help Ichtaca.",
                "level": 59,
                "coord": [
                  53357.4,
                  36582.9
                ],
                "bounds": [
                  [
                    53312.7,
                    36717.1
                  ],
                  [
                    53465.8,
                    36699.5
                  ],
                  [
                    53571.1,
                    36695.8
                  ],
                  [
                    53717.5,
                    36747.8
                  ],
                  [
                    53754,
                    36692.9
                  ],
                  [
                    53790.8,
                    36605.7
                  ],
                  [
                    53809,
                    36470.4
                  ],
                  [
                    53811.6,
                    36412.7
                  ],
                  [
                    53797,
                    36362.5
                  ],
                  [
                    53750.3,
                    36304.6
                  ],
                  [
                    53663.4,
                    36235.3
                  ],
                  [
                    53578.6,
                    36200.9
                  ],
                  [
                    53481.4,
                    36158.8
                  ],
                  [
                    53360.8,
                    36160.2
                  ],
                  [
                    53278.2,
                    36316.5
                  ],
                  [
                    53157.1,
                    36318.7
                  ],
                  [
                    53061.2,
                    36437.3
                  ],
                  [
                    53077.1,
                    36534.4
                  ],
                  [
                    53046.6,
                    36738.9
                  ],
                  [
                    53221.5,
                    36721.3
                  ],
                  [
                    53312.7,
                    36717.1
                  ]
                ],
                "id": 73,
                "chat_link": "[&BEkAAAA=]"
              },
              "74": {
                "objective": "Help the endangered quaggans.",
                "level": 60,
                "coord": [
                  53659.6,
                  37159
                ],
                "bounds": [
                  [
                    53332.5,
                    37349.3
                  ],
                  [
                    53416.7,
                    37327.2
                  ],
                  [
                    53498.4,
                    37326
                  ],
                  [
                    53596.2,
                    37248.5
                  ],
                  [
                    53637.2,
                    37259.3
                  ],
                  [
                    53702,
                    37266.7
                  ],
                  [
                    53795.7,
                    37347.2
                  ],
                  [
                    53998.8,
                    37369.1
                  ],
                  [
                    54003.5,
                    37252.1
                  ],
                  [
                    54005.8,
                    37094.2
                  ],
                  [
                    53922.2,
                    36993.5
                  ],
                  [
                    53814.4,
                    36913.8
                  ],
                  [
                    53758.3,
                    36891
                  ],
                  [
                    53726.3,
                    36832.9
                  ],
                  [
                    53678.8,
                    36776.7
                  ],
                  [
                    53568.5,
                    36707.8
                  ],
                  [
                    53468.2,
                    36719
                  ],
                  [
                    53390.1,
                    36717.8
                  ],
                  [
                    53307.4,
                    36729.5
                  ],
                  [
                    53220.9,
                    36743.1
                  ],
                  [
                    53079.9,
                    36754.8
                  ],
                  [
                    53033.8,
                    36775.9
                  ],
                  [
                    52998.3,
                    36854
                  ],
                  [
                    52978.5,
                    36915.6
                  ],
                  [
                    52934.3,
                    37059.5
                  ],
                  [
                    52953.1,
                    37167.4
                  ],
                  [
                    53013.9,
                    37260.5
                  ],
                  [
                    53125.1,
                    37309.2
                  ],
                  [
                    53183.5,
                    37319.3
                  ],
                  [
                    53229.1,
                    37332.4
                  ],
                  [
                    53332.5,
                    37349.3
                  ]
                ],
                "id": 74,
                "chat_link": "[&BEoAAAA=]"
              },
              "75": {
                "objective": "Partake in the moot.",
                "level": 52,
                "coord": [
                  52142.1,
                  34959.6
                ],
                "bounds": [
                  [
                    52182.5,
                    34811.9
                  ],
                  [
                    52099,
                    34812
                  ],
                  [
                    52052.7,
                    34830.5
                  ],
                  [
                    52024,
                    34859.9
                  ],
                  [
                    51988.6,
                    34884.9
                  ],
                  [
                    51972.7,
                    34914
                  ],
                  [
                    51952.1,
                    34956.2
                  ],
                  [
                    51955.5,
                    35006.7
                  ],
                  [
                    51948.2,
                    35041.7
                  ],
                  [
                    51940.9,
                    35074.6
                  ],
                  [
                    51934.3,
                    35110.1
                  ],
                  [
                    51952.2,
                    35156.6
                  ],
                  [
                    51968,
                    35193.5
                  ],
                  [
                    52061.4,
                    35206.1
                  ],
                  [
                    52118.4,
                    35222.8
                  ],
                  [
                    52172.1,
                    35211.7
                  ],
                  [
                    52235.6,
                    35188.9
                  ],
                  [
                    52299.8,
                    35142.2
                  ],
                  [
                    52345.2,
                    35093.8
                  ],
                  [
                    52362.9,
                    34990.4
                  ],
                  [
                    52337.3,
                    34908.8
                  ],
                  [
                    52304.8,
                    34853.3
                  ],
                  [
                    52247.4,
                    34822.4
                  ],
                  [
                    52210.4,
                    34806.8
                  ],
                  [
                    52182.5,
                    34811.9
                  ]
                ],
                "id": 75,
                "chat_link": "[&BEsAAAA=]"
              },
              "76": {
                "objective": "Disrupt dredge mining operations for Order of Whispers operatives.",
                "level": 51,
                "coord": [
                  53277,
                  34780.5
                ],
                "bounds": [
                  [
                    53190.4,
                    35067.6
                  ],
                  [
                    53174.9,
                    34932.5
                  ],
                  [
                    53265.8,
                    34763.9
                  ],
                  [
                    53431.5,
                    34522.7
                  ],
                  [
                    53993.8,
                    34516.9
                  ],
                  [
                    54166.7,
                    34905.1
                  ],
                  [
                    54153.1,
                    35129.9
                  ],
                  [
                    54136.1,
                    35420.5
                  ],
                  [
                    54044.6,
                    35647.7
                  ],
                  [
                    53693.9,
                    35525.4
                  ],
                  [
                    53515.8,
                    35472.4
                  ],
                  [
                    53242.7,
                    35279
                  ],
                  [
                    53190.4,
                    35067.6
                  ]
                ],
                "id": 76,
                "chat_link": "[&BEwAAAA=]"
              },
              "77": {
                "objective": "Scatter the unusually aggressive grawl.",
                "level": 53,
                "coord": [
                  53557.4,
                  35727.2
                ],
                "bounds": [
                  [
                    54019.8,
                    35663.4
                  ],
                  [
                    53855.2,
                    35605.7
                  ],
                  [
                    53646.1,
                    35528.4
                  ],
                  [
                    53501.5,
                    35486.7
                  ],
                  [
                    53370,
                    35394.3
                  ],
                  [
                    53210.6,
                    35696.2
                  ],
                  [
                    53113.4,
                    35876.9
                  ],
                  [
                    53117.7,
                    35990.8
                  ],
                  [
                    53385.9,
                    36049.4
                  ],
                  [
                    53964.5,
                    36093.5
                  ],
                  [
                    54019.8,
                    35663.4
                  ]
                ],
                "id": 77,
                "chat_link": "[&BE0AAAA=]"
              },
              "78": {
                "objective": "Help Caer Evermore defeat the Risen in the region.",
                "level": 58,
                "coord": [
                  52250,
                  37333.3
                ],
                "bounds": [
                  [
                    52567,
                    37615.3
                  ],
                  [
                    52612.5,
                    37567.3
                  ],
                  [
                    52636,
                    37516.2
                  ],
                  [
                    52635.6,
                    37471.4
                  ],
                  [
                    52583.6,
                    37411.4
                  ],
                  [
                    52528.6,
                    37385.3
                  ],
                  [
                    52516.3,
                    37348.5
                  ],
                  [
                    52502.5,
                    37313.3
                  ],
                  [
                    52447.4,
                    37284.7
                  ],
                  [
                    52399.5,
                    37274.1
                  ],
                  [
                    52325.2,
                    37288.9
                  ],
                  [
                    52267.2,
                    37302.3
                  ],
                  [
                    52264.8,
                    37295.5
                  ],
                  [
                    52242.1,
                    37341.2
                  ],
                  [
                    52224.3,
                    37366
                  ],
                  [
                    52170.6,
                    37373.3
                  ],
                  [
                    52121.2,
                    37373.3
                  ],
                  [
                    52069.3,
                    37372.1
                  ],
                  [
                    52024.6,
                    37369.8
                  ],
                  [
                    51983.7,
                    37359
                  ],
                  [
                    51992.8,
                    37364.2
                  ],
                  [
                    51968.4,
                    37353.3
                  ],
                  [
                    51936.7,
                    37352.5
                  ],
                  [
                    51898.7,
                    37384
                  ],
                  [
                    51872.6,
                    37409.9
                  ],
                  [
                    51846.3,
                    37455.5
                  ],
                  [
                    51851.2,
                    37498.3
                  ],
                  [
                    51851.9,
                    37530
                  ],
                  [
                    51845.8,
                    37552.1
                  ],
                  [
                    51902.5,
                    37558.8
                  ],
                  [
                    51959.5,
                    37578
                  ],
                  [
                    52000.9,
                    37594.2
                  ],
                  [
                    52054.4,
                    37606.1
                  ],
                  [
                    52104.3,
                    37613.5
                  ],
                  [
                    52162.1,
                    37611.4
                  ],
                  [
                    52214.8,
                    37609
                  ],
                  [
                    52282,
                    37617.9
                  ],
                  [
                    52323.5,
                    37616.9
                  ],
                  [
                    52378.3,
                    37643
                  ],
                  [
                    52418.5,
                    37642
                  ],
                  [
                    52463.3,
                    37653.6
                  ],
                  [
                    52517.1,
                    37645.8
                  ],
                  [
                    52545.8,
                    37625.6
                  ],
                  [
                    52567,
                    37615.3
                  ]
                ],
                "id": 78,
                "chat_link": "[&BE4AAAA=]"
              },
              "79": {
                "objective": "Help the Priory's excavation of the ruins.",
                "level": 57,
                "coord": [
                  52229.1,
                  36782.6
                ],
                "bounds": [
                  [
                    52217.2,
                    36742.1
                  ],
                  [
                    52245.5,
                    36743.8
                  ],
                  [
                    52274.7,
                    36746
                  ],
                  [
                    52309.7,
                    36742.4
                  ],
                  [
                    52373.1,
                    36762.4
                  ],
                  [
                    52384.1,
                    36811.3
                  ],
                  [
                    52386.1,
                    36848.1
                  ],
                  [
                    52362,
                    36897.5
                  ],
                  [
                    52353.3,
                    36925.6
                  ],
                  [
                    52350.6,
                    36953.3
                  ],
                  [
                    52348.3,
                    36982.6
                  ],
                  [
                    52336.9,
                    37035.5
                  ],
                  [
                    52334.3,
                    37072.7
                  ],
                  [
                    52335.6,
                    37112.1
                  ],
                  [
                    52331.9,
                    37146.6
                  ],
                  [
                    52307.7,
                    37190.8
                  ],
                  [
                    52266.8,
                    37206.2
                  ],
                  [
                    52238.9,
                    37210
                  ],
                  [
                    52194.3,
                    37217.7
                  ],
                  [
                    52145.6,
                    37222
                  ],
                  [
                    52094.3,
                    37232
                  ],
                  [
                    52046,
                    37236.1
                  ],
                  [
                    51992.2,
                    37235.7
                  ],
                  [
                    51946.1,
                    37217.3
                  ],
                  [
                    51856.3,
                    37184.7
                  ],
                  [
                    51796,
                    37147.8
                  ],
                  [
                    51725.7,
                    37075.9
                  ],
                  [
                    51711,
                    36969.5
                  ],
                  [
                    51748,
                    36862.7
                  ],
                  [
                    51824.6,
                    36825
                  ],
                  [
                    51899.1,
                    36797.1
                  ],
                  [
                    51952.8,
                    36795.1
                  ],
                  [
                    52048.8,
                    36781.2
                  ],
                  [
                    52158.8,
                    36779
                  ],
                  [
                    52197.6,
                    36749.1
                  ],
                  [
                    52217.2,
                    36742.1
                  ]
                ],
                "id": 79,
                "chat_link": "[&BE8AAAA=]"
              },
              "80": {
                "objective": "Help Fionnghuala Scratch prepare their defenses.",
                "level": 54,
                "coord": [
                  52713.1,
                  35988.4
                ],
                "bounds": [
                  [
                    52919.9,
                    35219.7
                  ],
                  [
                    52843.3,
                    35233.4
                  ],
                  [
                    52790.1,
                    35260.9
                  ],
                  [
                    52770.6,
                    35280.3
                  ],
                  [
                    52705.9,
                    35290.9
                  ],
                  [
                    52683.4,
                    35335.2
                  ],
                  [
                    52624.7,
                    35443.1
                  ],
                  [
                    52562.2,
                    35486.1
                  ],
                  [
                    52516.8,
                    35561.4
                  ],
                  [
                    52439.8,
                    35609
                  ],
                  [
                    52416.8,
                    35657.7
                  ],
                  [
                    52404.9,
                    35722.6
                  ],
                  [
                    52409.2,
                    35785.4
                  ],
                  [
                    52443.5,
                    35863.5
                  ],
                  [
                    52459.9,
                    35942.6
                  ],
                  [
                    52446.6,
                    36014.7
                  ],
                  [
                    52416.8,
                    36070.2
                  ],
                  [
                    52396.1,
                    36103.2
                  ],
                  [
                    52411.5,
                    36149
                  ],
                  [
                    52449.5,
                    36191.9
                  ],
                  [
                    52506,
                    36200.8
                  ],
                  [
                    52598.3,
                    36193.6
                  ],
                  [
                    52689,
                    36177.7
                  ],
                  [
                    52820.2,
                    36160.2
                  ],
                  [
                    52883,
                    36093.7
                  ],
                  [
                    52915.4,
                    35995
                  ],
                  [
                    52893,
                    35888.3
                  ],
                  [
                    52867.3,
                    35790.1
                  ],
                  [
                    52882.6,
                    35705.9
                  ],
                  [
                    52937.4,
                    35573.1
                  ],
                  [
                    52961.6,
                    35487.7
                  ],
                  [
                    52929.2,
                    35363.5
                  ],
                  [
                    52923.4,
                    35269.9
                  ],
                  [
                    52919.9,
                    35219.7
                  ]
                ],
                "id": 80,
                "chat_link": "[&BFAAAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  53634.6,
                  36478.1
                ],
                "id": "0-81"
              },
              {
                "coord": [
                  53191.2,
                  37687.6
                ],
                "id": "0-83"
              },
              {
                "coord": [
                  51869.4,
                  36455.8
                ],
                "id": "0-82"
              },
              {
                "coord": [
                  53788.3,
                  35912
                ],
                "id": "0-84"
              },
              {
                "coord": [
                  51757.4,
                  37001.1
                ],
                "id": "0-205"
              }
            ],
            "sectors": {
              "539": {
                "name": "Talus Waterslide",
                "level": 60,
                "coord": [
                  52019.1,
                  37614
                ],
                "bounds": [
                  [
                    52134.8,
                    37860.4
                  ],
                  [
                    51848.6,
                    37818.3
                  ],
                  [
                    51816,
                    37670.9
                  ],
                  [
                    51736,
                    37507.2
                  ],
                  [
                    51822.5,
                    37346.7
                  ],
                  [
                    52046.8,
                    37436.5
                  ],
                  [
                    52312.1,
                    37443.5
                  ],
                  [
                    52229.3,
                    37682.8
                  ],
                  [
                    52225.7,
                    37759.3
                  ],
                  [
                    52134.8,
                    37860.4
                  ]
                ],
                "id": 539,
                "chat_link": "[&BBsCAAA=]"
              },
              "540": {
                "name": "Malorean Wilds",
                "level": 58,
                "coord": [
                  52450.5,
                  37608
                ],
                "bounds": [
                  [
                    52439.5,
                    37404.6
                  ],
                  [
                    52627.2,
                    37480.5
                  ],
                  [
                    52671.3,
                    37656.1
                  ],
                  [
                    52648.7,
                    37829.1
                  ],
                  [
                    52225.7,
                    37759.4
                  ],
                  [
                    52229.4,
                    37683
                  ],
                  [
                    52311.6,
                    37443.3
                  ],
                  [
                    52439.5,
                    37404.6
                  ]
                ],
                "id": 540,
                "chat_link": "[&BBwCAAA=]"
              },
              "541": {
                "name": "Serpent Stones",
                "level": 59,
                "coord": [
                  52758.9,
                  37436.8
                ],
                "bounds": [
                  [
                    52439.5,
                    37404.7
                  ],
                  [
                    52492.9,
                    37266.3
                  ],
                  [
                    52642.5,
                    37155.6
                  ],
                  [
                    52740,
                    37205
                  ],
                  [
                    52883.5,
                    37185.4
                  ],
                  [
                    53087.8,
                    37333.9
                  ],
                  [
                    53042.3,
                    37441.5
                  ],
                  [
                    52953.5,
                    37527
                  ],
                  [
                    52881.4,
                    37755.9
                  ],
                  [
                    52645.3,
                    37828.9
                  ],
                  [
                    52671.3,
                    37656.4
                  ],
                  [
                    52626.5,
                    37480.6
                  ],
                  [
                    52439.5,
                    37404.7
                  ]
                ],
                "id": 541,
                "chat_link": "[&BB0CAAA=]"
              },
              "542": {
                "name": "Mellaggan's Grotto",
                "level": 59,
                "coord": [
                  53329.3,
                  37571.3
                ],
                "bounds": [
                  [
                    53042.1,
                    37440.1
                  ],
                  [
                    53087.8,
                    37333.3
                  ],
                  [
                    53593,
                    37309
                  ],
                  [
                    53736.7,
                    37493.6
                  ],
                  [
                    53836.3,
                    37634.3
                  ],
                  [
                    53656.3,
                    37829.4
                  ],
                  [
                    53176.7,
                    37824.6
                  ],
                  [
                    52882.4,
                    37750.8
                  ],
                  [
                    52952.8,
                    37526.8
                  ],
                  [
                    53042.1,
                    37440.1
                  ]
                ],
                "id": 542,
                "chat_link": "[&BB4CAAA=]"
              },
              "543": {
                "name": "Lair of the Coil",
                "level": 60,
                "coord": [
                  53858.9,
                  37394.2
                ],
                "bounds": [
                  [
                    53736.2,
                    37494.3
                  ],
                  [
                    53825.5,
                    37616
                  ],
                  [
                    53938.5,
                    37532.7
                  ],
                  [
                    54050.7,
                    37417.1
                  ],
                  [
                    54049.1,
                    37299
                  ],
                  [
                    54007.7,
                    37262.9
                  ],
                  [
                    53671.3,
                    37221.8
                  ],
                  [
                    53592,
                    37309.5
                  ],
                  [
                    53736.2,
                    37494.3
                  ]
                ],
                "id": 543,
                "chat_link": "[&BB8CAAA=]"
              },
              "544": {
                "name": "Tail of the Serpent",
                "level": 60,
                "coord": [
                  53957.2,
                  37018.3
                ],
                "bounds": [
                  [
                    53927.5,
                    36975.4
                  ],
                  [
                    53931.7,
                    36721.5
                  ],
                  [
                    54010.1,
                    36773
                  ],
                  [
                    54051.4,
                    36870.5
                  ],
                  [
                    54055.3,
                    37184.3
                  ],
                  [
                    54007.1,
                    37263.9
                  ],
                  [
                    53794.4,
                    37237.9
                  ],
                  [
                    53880.4,
                    37119.8
                  ],
                  [
                    53927.5,
                    36975.4
                  ]
                ],
                "id": 544,
                "chat_link": "[&BCACAAA=]"
              },
              "545": {
                "name": "Scale Strand",
                "level": 60,
                "coord": [
                  53786.5,
                  36934.6
                ],
                "bounds": [
                  [
                    53932.3,
                    36721.4
                  ],
                  [
                    53849.8,
                    36583.3
                  ],
                  [
                    53637.4,
                    36586.1
                  ],
                  [
                    53666.5,
                    36835.1
                  ],
                  [
                    53758,
                    36931.9
                  ],
                  [
                    53745.6,
                    37133.6
                  ],
                  [
                    53671.7,
                    37220.2
                  ],
                  [
                    53794.5,
                    37238.4
                  ],
                  [
                    53880.1,
                    37120.2
                  ],
                  [
                    53928.8,
                    36975.4
                  ],
                  [
                    53932.3,
                    36721.4
                  ]
                ],
                "id": 545,
                "chat_link": "[&BCECAAA=]"
              },
              "546": {
                "name": "Nonmoa Lake",
                "level": 60,
                "coord": [
                  53362.7,
                  36957.2
                ],
                "bounds": [
                  [
                    53087.1,
                    37333.3
                  ],
                  [
                    53593.5,
                    37309.4
                  ],
                  [
                    53749.4,
                    37136.3
                  ],
                  [
                    53758.2,
                    36931.3
                  ],
                  [
                    53667.2,
                    36835.3
                  ],
                  [
                    53636.7,
                    36584.5
                  ],
                  [
                    53342,
                    36667.8
                  ],
                  [
                    53106.1,
                    36700
                  ],
                  [
                    52804,
                    36888.5
                  ],
                  [
                    52882.6,
                    37185.5
                  ],
                  [
                    53087.1,
                    37333.3
                  ]
                ],
                "id": 546,
                "chat_link": "[&BCICAAA=]"
              },
              "547": {
                "name": "Pythian Point",
                "level": 57,
                "coord": [
                  52544.2,
                  37099.9
                ],
                "bounds": [
                  [
                    52290.7,
                    36817.2
                  ],
                  [
                    52535.1,
                    36752.6
                  ],
                  [
                    52589.7,
                    36852.6
                  ],
                  [
                    52804.2,
                    36888
                  ],
                  [
                    52882.1,
                    37186.3
                  ],
                  [
                    52739.5,
                    37205
                  ],
                  [
                    52642.5,
                    37155.6
                  ],
                  [
                    52491.5,
                    37267.5
                  ],
                  [
                    52440.1,
                    37404.9
                  ],
                  [
                    52310.8,
                    37444
                  ],
                  [
                    52260.1,
                    37125.6
                  ],
                  [
                    52290.7,
                    36817.2
                  ]
                ],
                "id": 547,
                "chat_link": "[&BCMCAAA=]"
              },
              "548": {
                "name": "Tyrant's Mount",
                "level": 57,
                "coord": [
                  52082.8,
                  37109.1
                ],
                "bounds": [
                  [
                    52043.6,
                    37185
                  ],
                  [
                    52133.4,
                    37063.8
                  ],
                  [
                    52043.5,
                    36933.6
                  ],
                  [
                    52016.7,
                    36837.4
                  ],
                  [
                    52135,
                    36769.8
                  ],
                  [
                    52291.1,
                    36817.7
                  ],
                  [
                    52259.8,
                    37126.8
                  ],
                  [
                    52311,
                    37444.4
                  ],
                  [
                    52046.4,
                    37436.6
                  ],
                  [
                    51823.2,
                    37347
                  ],
                  [
                    51807.4,
                    37238
                  ],
                  [
                    52043.6,
                    37185
                  ]
                ],
                "id": 548,
                "chat_link": "[&BCQCAAA=]"
              },
              "549": {
                "name": "Ural's Delve",
                "level": 57,
                "coord": [
                  51917,
                  36994.8
                ],
                "bounds": [
                  [
                    51724.6,
                    36979.4
                  ],
                  [
                    51733,
                    36924.1
                  ],
                  [
                    51816.6,
                    36787.7
                  ],
                  [
                    52022.1,
                    36832.1
                  ],
                  [
                    52047.3,
                    36929.9
                  ],
                  [
                    52139.8,
                    37069.1
                  ],
                  [
                    52041.3,
                    37191.5
                  ],
                  [
                    51811.4,
                    37245
                  ],
                  [
                    51724.6,
                    36979.4
                  ]
                ],
                "id": 549,
                "chat_link": "[&BCUCAAA=]"
              },
              "550": {
                "name": "Candle Chimney",
                "level": 57,
                "coord": [
                  51917.2,
                  36552.6
                ],
                "bounds": [
                  [
                    51817.1,
                    36790.4
                  ],
                  [
                    51789,
                    36708.1
                  ],
                  [
                    51725.9,
                    36457.8
                  ],
                  [
                    51758,
                    36197.3
                  ],
                  [
                    51897.1,
                    36209.8
                  ],
                  [
                    51927.8,
                    36376
                  ],
                  [
                    52187,
                    36625.7
                  ],
                  [
                    52136,
                    36770.3
                  ],
                  [
                    52016.8,
                    36837.9
                  ],
                  [
                    51817.1,
                    36790.4
                  ]
                ],
                "id": 550,
                "chat_link": "[&BCYCAAA=]"
              },
              "551": {
                "name": "Gyre Rapids",
                "level": 56,
                "coord": [
                  52298.8,
                  36493.3
                ],
                "bounds": [
                  [
                    52135.5,
                    36770.5
                  ],
                  [
                    52290.4,
                    36817.6
                  ],
                  [
                    52534.5,
                    36752.8
                  ],
                  [
                    52645.5,
                    36622.8
                  ],
                  [
                    52643.6,
                    36453.4
                  ],
                  [
                    52529.8,
                    36347.9
                  ],
                  [
                    52485.8,
                    36229
                  ],
                  [
                    52013.4,
                    36223.1
                  ],
                  [
                    51894.3,
                    36205.5
                  ],
                  [
                    51927.4,
                    36377.4
                  ],
                  [
                    52186.5,
                    36625.9
                  ],
                  [
                    52135.5,
                    36770.5
                  ]
                ],
                "id": 551,
                "chat_link": "[&BCcCAAA=]"
              },
              "552": {
                "name": "Stromkarl Heights",
                "level": 55,
                "coord": [
                  52700.7,
                  36484.1
                ],
                "bounds": [
                  [
                    52643.8,
                    36622.6
                  ],
                  [
                    52643.8,
                    36454.4
                  ],
                  [
                    52530.3,
                    36347.8
                  ],
                  [
                    52484.3,
                    36230.8
                  ],
                  [
                    52540.8,
                    36076.3
                  ],
                  [
                    52870,
                    36114
                  ],
                  [
                    52929.3,
                    36172.5
                  ],
                  [
                    52907.3,
                    36487.3
                  ],
                  [
                    52931.5,
                    36809
                  ],
                  [
                    52801.8,
                    36890.4
                  ],
                  [
                    52589.7,
                    36851.3
                  ],
                  [
                    52535.6,
                    36752.5
                  ],
                  [
                    52643.8,
                    36622.6
                  ]
                ],
                "id": 552,
                "chat_link": "[&BCgCAAA=]"
              },
              "553": {
                "name": "Hunting Banks",
                "level": 59,
                "coord": [
                  53212.3,
                  36586.3
                ],
                "bounds": [
                  [
                    52930.9,
                    36809.2
                  ],
                  [
                    53106.1,
                    36700.7
                  ],
                  [
                    53343.5,
                    36671.7
                  ],
                  [
                    53634.3,
                    36588.2
                  ],
                  [
                    53383.5,
                    36447
                  ],
                  [
                    53181,
                    36401
                  ],
                  [
                    52906.9,
                    36486.5
                  ],
                  [
                    52930.9,
                    36809.2
                  ]
                ],
                "id": 553,
                "chat_link": "[&BCkCAAA=]"
              },
              "554": {
                "name": "Naui Waters",
                "level": 54,
                "coord": [
                  53675.6,
                  36304.8
                ],
                "bounds": [
                  [
                    53351.7,
                    36140.3
                  ],
                  [
                    53452.3,
                    36039.3
                  ],
                  [
                    53592.3,
                    36032.4
                  ],
                  [
                    53884.9,
                    36095.8
                  ],
                  [
                    53988.1,
                    36289.1
                  ],
                  [
                    53943.9,
                    36518
                  ],
                  [
                    53849,
                    36590.5
                  ],
                  [
                    53635.2,
                    36591.6
                  ],
                  [
                    53383.3,
                    36446.7
                  ],
                  [
                    53351.7,
                    36140.3
                  ]
                ],
                "id": 554,
                "chat_link": "[&BCoCAAA=]"
              },
              "555": {
                "name": "Guilty Tears",
                "level": 53,
                "coord": [
                  53584.5,
                  35825.5
                ],
                "bounds": [
                  [
                    53198.8,
                    35785.9
                  ],
                  [
                    53180,
                    36040.4
                  ],
                  [
                    53352.2,
                    36140.8
                  ],
                  [
                    53452,
                    36040.2
                  ],
                  [
                    53592.2,
                    36032.8
                  ],
                  [
                    53891,
                    36096.7
                  ],
                  [
                    54004.4,
                    35770.8
                  ],
                  [
                    53947.5,
                    35771.6
                  ],
                  [
                    53732.8,
                    35611.9
                  ],
                  [
                    53738.8,
                    35503.5
                  ],
                  [
                    53548.4,
                    35514.3
                  ],
                  [
                    53375.6,
                    35597.3
                  ],
                  [
                    53198.8,
                    35785.9
                  ]
                ],
                "id": 555,
                "chat_link": "[&BCsCAAA=]"
              },
              "556": {
                "name": "Bynebrachen",
                "level": 54,
                "coord": [
                  53111.2,
                  36026.7
                ],
                "bounds": [
                  [
                    52907,
                    36486.3
                  ],
                  [
                    53180.9,
                    36402.1
                  ],
                  [
                    53383.6,
                    36447.3
                  ],
                  [
                    53352.9,
                    36141
                  ],
                  [
                    53180.6,
                    36040.3
                  ],
                  [
                    53199,
                    35785.5
                  ],
                  [
                    53376.1,
                    35597.4
                  ],
                  [
                    52964.9,
                    35474.8
                  ],
                  [
                    52879.6,
                    35632.9
                  ],
                  [
                    52869.5,
                    36113.8
                  ],
                  [
                    52929.1,
                    36172
                  ],
                  [
                    52907,
                    36486.3
                  ]
                ],
                "id": 556,
                "chat_link": "[&BCwCAAA=]"
              },
              "557": {
                "name": "Fionnghuala Scratch",
                "level": 54,
                "coord": [
                  52698.6,
                  35749.5
                ],
                "bounds": [
                  [
                    52428,
                    35639.7
                  ],
                  [
                    52648.6,
                    35444.7
                  ],
                  [
                    52965.8,
                    35474.4
                  ],
                  [
                    52880.7,
                    35632.3
                  ],
                  [
                    52872.3,
                    36123.8
                  ],
                  [
                    52538.7,
                    36086.5
                  ],
                  [
                    52556.3,
                    35845.2
                  ],
                  [
                    52428,
                    35639.7
                  ]
                ],
                "id": 557,
                "chat_link": "[&BC0CAAA=]"
              },
              "558": {
                "name": "Fisher's Eye Bridges",
                "level": 55,
                "coord": [
                  52128.5,
                  35958.3
                ],
                "bounds": [
                  [
                    51759,
                    36201.6
                  ],
                  [
                    52013.3,
                    36223
                  ],
                  [
                    52485.8,
                    36228.8
                  ],
                  [
                    52544.9,
                    36081.1
                  ],
                  [
                    52556.9,
                    35845.5
                  ],
                  [
                    52428.2,
                    35639.3
                  ],
                  [
                    51887.8,
                    35707.4
                  ],
                  [
                    51730,
                    35712.8
                  ],
                  [
                    51750.5,
                    35984.7
                  ],
                  [
                    51759,
                    36201.6
                  ]
                ],
                "id": 558,
                "chat_link": "[&BC4CAAA=]"
              },
              "559": {
                "name": "Gentle River",
                "level": 53,
                "coord": [
                  52313.6,
                  35146.7
                ],
                "bounds": [
                  [
                    51824.6,
                    35283.9
                  ],
                  [
                    52096,
                    35280.7
                  ],
                  [
                    52333.8,
                    35083.8
                  ],
                  [
                    52387.9,
                    34592.4
                  ],
                  [
                    52504.8,
                    34544.4
                  ],
                  [
                    52760.2,
                    34569.3
                  ],
                  [
                    52902.4,
                    34514.1
                  ],
                  [
                    52898.9,
                    34889.6
                  ],
                  [
                    52822.9,
                    34871.1
                  ],
                  [
                    52651.1,
                    35445.8
                  ],
                  [
                    52428,
                    35640.5
                  ],
                  [
                    51887.7,
                    35707.3
                  ],
                  [
                    51739.2,
                    35713.7
                  ],
                  [
                    51711.1,
                    35625.2
                  ],
                  [
                    51755.5,
                    35439.4
                  ],
                  [
                    51824.6,
                    35283.9
                  ]
                ],
                "id": 559,
                "chat_link": "[&BC8CAAA=]"
              },
              "560": {
                "name": "Krongar Pass",
                "level": 53,
                "coord": [
                  51981.8,
                  34882.7
                ],
                "bounds": [
                  [
                    51730.4,
                    34910.8
                  ],
                  [
                    51745.9,
                    34639.2
                  ],
                  [
                    51836.8,
                    34504.2
                  ],
                  [
                    52112.8,
                    34499.3
                  ],
                  [
                    52395.1,
                    34567.7
                  ],
                  [
                    52333,
                    35085.4
                  ],
                  [
                    52095.2,
                    35281.8
                  ],
                  [
                    51824.7,
                    35283.8
                  ],
                  [
                    51762.3,
                    35172.6
                  ],
                  [
                    51730.4,
                    34910.8
                  ]
                ],
                "id": 560,
                "chat_link": "[&BDACAAA=]"
              },
              "561": {
                "name": "White Paper Hill",
                "level": 53,
                "coord": [
                  53107.1,
                  35301.8
                ],
                "bounds": [
                  [
                    52820.1,
                    34867.9
                  ],
                  [
                    52967.9,
                    34886.7
                  ],
                  [
                    53038.1,
                    35256.2
                  ],
                  [
                    53498.2,
                    35358.6
                  ],
                  [
                    53552.5,
                    35513.9
                  ],
                  [
                    53375.5,
                    35603.2
                  ],
                  [
                    52959.5,
                    35479
                  ],
                  [
                    52644.9,
                    35449.3
                  ],
                  [
                    52820.1,
                    34867.9
                  ]
                ],
                "id": 561,
                "chat_link": "[&BDECAAA=]"
              },
              "562": {
                "name": "The Iron Veil",
                "level": 52,
                "coord": [
                  53237,
                  34875.6
                ],
                "bounds": [
                  [
                    52902.6,
                    34515.3
                  ],
                  [
                    53198.2,
                    34602.6
                  ],
                  [
                    53298.9,
                    34479.7
                  ],
                  [
                    53445.5,
                    34462.8
                  ],
                  [
                    53539.9,
                    34761.4
                  ],
                  [
                    53277.7,
                    34876.7
                  ],
                  [
                    53283.8,
                    35132
                  ],
                  [
                    53512.3,
                    35282.5
                  ],
                  [
                    53497.9,
                    35362.3
                  ],
                  [
                    53030,
                    35257.6
                  ],
                  [
                    52963.6,
                    34890
                  ],
                  [
                    52893.5,
                    34883.8
                  ],
                  [
                    52902.6,
                    34515.3
                  ]
                ],
                "id": 562,
                "chat_link": "[&BDICAAA=]"
              },
              "564": {
                "name": "Molodets Excavation",
                "level": 52,
                "coord": [
                  53548.2,
                  35204.8
                ],
                "bounds": [
                  [
                    53497.6,
                    35361.6
                  ],
                  [
                    53512.4,
                    35282
                  ],
                  [
                    53283,
                    35133.3
                  ],
                  [
                    53277.7,
                    34876.8
                  ],
                  [
                    53540,
                    34760.9
                  ],
                  [
                    53725.1,
                    35054.8
                  ],
                  [
                    53811.7,
                    35356.3
                  ],
                  [
                    53738.4,
                    35503.9
                  ],
                  [
                    53547.8,
                    35513.8
                  ],
                  [
                    53497.6,
                    35361.6
                  ]
                ],
                "id": 564,
                "chat_link": "[&BDQCAAA=]"
              },
              "565": {
                "name": "The Foundation Stones",
                "level": 55,
                "coord": [
                  53877.2,
                  35470.2
                ],
                "bounds": [
                  [
                    53738.1,
                    35501.8
                  ],
                  [
                    53811.8,
                    35355.2
                  ],
                  [
                    53891.4,
                    35255
                  ],
                  [
                    53984.4,
                    35239.1
                  ],
                  [
                    53982.3,
                    35426.9
                  ],
                  [
                    53933.7,
                    35597.2
                  ],
                  [
                    53946.5,
                    35773.3
                  ],
                  [
                    53729.8,
                    35613
                  ],
                  [
                    53738.1,
                    35501.8
                  ]
                ],
                "id": 565,
                "chat_link": "[&BDUCAAA=]"
              },
              "1023": {
                "name": "Sector Zuhl",
                "level": 52,
                "coord": [
                  53895.5,
                  34837.3
                ],
                "bounds": [
                  [
                    53537.2,
                    34768
                  ],
                  [
                    53472.8,
                    34561.7
                  ],
                  [
                    53923,
                    34364.8
                  ],
                  [
                    54300.7,
                    34464.3
                  ],
                  [
                    54156.9,
                    34585
                  ],
                  [
                    54068.2,
                    34702.5
                  ],
                  [
                    54005.3,
                    34827.8
                  ],
                  [
                    53965.7,
                    35244.5
                  ],
                  [
                    53891.8,
                    35256.4
                  ],
                  [
                    53809.4,
                    35375.9
                  ],
                  [
                    53719.2,
                    35059.7
                  ],
                  [
                    53537.2,
                    34768
                  ]
                ],
                "id": 1023,
                "chat_link": "[&BP8DAAA=]"
              }
            },
            "adventures": [],
            "id": 29,
            "mastery_points": [
              {
                "coord": [
                  53466.1,
                  35256.2
                ],
                "id": 323,
                "region": "Tyria"
              }
            ]
          },
          "30": {
            "name": "Frostgorge Sound",
            "min_level": 70,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              55040,
              25984
            ],
            "map_rect": [
              [
                -36864,
                -36864
              ],
              [
                36864,
                36864
              ]
            ],
            "continent_rect": [
              [
                53504,
                24576
              ],
              [
                56576,
                27648
              ]
            ],
            "points_of_interest": {
              "618": {
                "name": "The Sonic Furnace",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53690.7,
                  27339.7
                ],
                "id": 618,
                "chat_link": "[&BGoCAAA=]"
              },
              "619": {
                "name": "Forgepits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54037.4,
                  27136.5
                ],
                "id": 619,
                "chat_link": "[&BGsCAAA=]"
              },
              "620": {
                "name": "Arkor's Tomb",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55316,
                  26384.6
                ],
                "id": 620,
                "chat_link": "[&BGwCAAA=]"
              },
              "621": {
                "name": "Krok's Ruin",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54103.6,
                  27452.1
                ],
                "id": 621,
                "chat_link": "[&BG0CAAA=]"
              },
              "622": {
                "name": "Sacred Trust",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55775.8,
                  26440.3
                ],
                "id": 622,
                "chat_link": "[&BG4CAAA=]"
              },
              "623": {
                "name": "Elder's Vale",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56361.1,
                  25769.6
                ],
                "id": 623,
                "chat_link": "[&BG8CAAA=]"
              },
              "624": {
                "name": "Safewatch Vale",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56065.9,
                  27244.2
                ],
                "id": 624,
                "chat_link": "[&BHACAAA=]"
              },
              "625": {
                "name": "Orsippus",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53794.2,
                  25478.5
                ],
                "id": 625,
                "chat_link": "[&BHECAAA=]"
              },
              "626": {
                "name": "Moshpoipoi",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55555.6,
                  25027
                ],
                "id": 626,
                "chat_link": "[&BHICAAA=]"
              },
              "627": {
                "name": "Zuckermaloo",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54081.7,
                  25912.7
                ],
                "id": 627,
                "chat_link": "[&BHMCAAA=]"
              },
              "628": {
                "name": "Deep and Troubled Waters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54383.5,
                  25388.8
                ],
                "id": 628,
                "chat_link": "[&BHQCAAA=]"
              },
              "629": {
                "name": "The Barrowstead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55104.5,
                  27407.7
                ],
                "id": 629,
                "chat_link": "[&BHUCAAA=]"
              },
              "630": {
                "name": "Coiled Watch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55552.7,
                  27169.1
                ],
                "id": 630,
                "chat_link": "[&BHYCAAA=]"
              },
              "631": {
                "name": "Claw Watch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55030.9,
                  27245.1
                ],
                "id": 631,
                "chat_link": "[&BHcCAAA=]"
              },
              "632": {
                "name": "Arundon Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55832.5,
                  27488.8
                ],
                "id": 632,
                "chat_link": "[&BHgCAAA=]"
              },
              "633": {
                "name": "Groznev Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53880.3,
                  27565.6
                ],
                "id": 633,
                "chat_link": "[&BHkCAAA=]"
              },
              "634": {
                "name": "Earthshake Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  56297.6,
                  25884.3
                ],
                "id": 634,
                "chat_link": "[&BHoCAAA=]"
              },
              "635": {
                "name": "Path of Starry Skies Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  56257,
                  24846.5
                ],
                "id": 635,
                "chat_link": "[&BHsCAAA=]"
              },
              "636": {
                "name": "Slough of Despond Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55232.5,
                  25529.5
                ],
                "id": 636,
                "chat_link": "[&BHwCAAA=]"
              },
              "637": {
                "name": "Watchful Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55565.2,
                  24986.9
                ],
                "id": 637,
                "chat_link": "[&BH0CAAA=]"
              },
              "638": {
                "name": "Ice Floe Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54544.7,
                  25299.3
                ],
                "id": 638,
                "chat_link": "[&BH4CAAA=]"
              },
              "639": {
                "name": "Dimotiki Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54000.9,
                  25497.3
                ],
                "id": 639,
                "chat_link": "[&BH8CAAA=]"
              },
              "640": {
                "name": "Twoloop Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54299.8,
                  26253.5
                ],
                "id": 640,
                "chat_link": "[&BIACAAA=]"
              },
              "641": {
                "name": "Skyheight Steading Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54678,
                  26989
                ],
                "id": 641,
                "chat_link": "[&BIECAAA=]"
              },
              "642": {
                "name": "Highpeaks Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55396.3,
                  27075.7
                ],
                "id": 642,
                "chat_link": "[&BIICAAA=]"
              },
              "643": {
                "name": "Ridgerock Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55253.1,
                  26550.2
                ],
                "id": 643,
                "chat_link": "[&BIMCAAA=]"
              },
              "644": {
                "name": "Yak's Bend Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  56003.8,
                  26623.4
                ],
                "id": 644,
                "chat_link": "[&BIQCAAA=]"
              },
              "645": {
                "name": "Blue Ice Shining Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54078.8,
                  26667
                ],
                "id": 645,
                "chat_link": "[&BIUCAAA=]"
              },
              "646": {
                "name": "Drakkar Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53572.2,
                  24661.7
                ],
                "id": 646,
                "chat_link": "[&BIYCAAA=]"
              },
              "841": {
                "name": "Firesnake's Tail",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55542.8,
                  25787.5
                ],
                "id": 841,
                "chat_link": "[&BEkDAAA=]"
              },
              "842": {
                "name": "Offering Stone",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56279.7,
                  27188.9
                ],
                "id": 842,
                "chat_link": "[&BEoDAAA=]"
              },
              "1261": {
                "name": "Ridgepost Sentry",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55304.7,
                  26773.8
                ],
                "id": 1261,
                "chat_link": "[&BO0EAAA=]"
              },
              "1347": {
                "name": "Honor of the Waves Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55227.5,
                  25187.3
                ],
                "id": 1347,
                "chat_link": "[&BEMFAAA=]"
              },
              "1511": {
                "name": "Iron Horse Mines",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54972.2,
                  25853.9
                ],
                "id": 1511,
                "chat_link": "[&BOcFAAA=]"
              },
              "1588": {
                "name": "Peloopoo Needle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53969.9,
                  25673.2
                ],
                "id": 1588,
                "chat_link": "[&BDQGAAA=]"
              },
              "1692": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  54299.5,
                  27014.6
                ],
                "id": 1692,
                "chat_link": "[&BJwGAAA=]"
              },
              "1693": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  55943.9,
                  26313.1
                ],
                "id": 1693,
                "chat_link": "[&BJ0GAAA=]"
              },
              "1694": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  53621.3,
                  26717.8
                ],
                "id": 1694,
                "chat_link": "[&BJ4GAAA=]"
              },
              "1695": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  53742.4,
                  27250.3
                ],
                "id": 1695,
                "chat_link": "[&BJ8GAAA=]"
              },
              "1696": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  56108.8,
                  26694
                ],
                "id": 1696,
                "chat_link": "[&BKAGAAA=]"
              },
              "1697": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  54427.8,
                  25574.4
                ],
                "id": 1697,
                "chat_link": "[&BKEGAAA=]"
              },
              "1698": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  53902.3,
                  25669.2
                ],
                "id": 1698,
                "chat_link": "[&BKIGAAA=]"
              },
              "1699": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  56116.4,
                  25691.5
                ],
                "id": 1699,
                "chat_link": "[&BKMGAAA=]"
              },
              "1701": {
                "name": "Blue Ice Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54648.1,
                  27468
                ],
                "id": 1701,
                "chat_link": "[&BKUGAAA=]"
              },
              "1739": {
                "name": "Honor of the Waves",
                "type": "unlock",
                "floor": 1,
                "coord": [
                  55207.6,
                  25189.8
                ],
                "id": 1739,
                "chat_link": "[&BMsGAAA=]",
                "icon": "https://render.guildwars2.com/file/943538394A94A491C8632FBEF6203C2013443555/102478.png"
              }
            },
            "tasks": {
              "12": {
                "objective": "Help Scholar Inka research imps.",
                "level": 73,
                "coord": [
                  55605.5,
                  26716.7
                ],
                "bounds": [
                  [
                    55317.5,
                    26508
                  ],
                  [
                    55387.2,
                    26328.7
                  ],
                  [
                    55475.6,
                    26394.5
                  ],
                  [
                    55657.2,
                    26524.5
                  ],
                  [
                    55734.7,
                    26631.3
                  ],
                  [
                    55657.7,
                    26848.5
                  ],
                  [
                    55403.6,
                    26725.9
                  ],
                  [
                    55317.5,
                    26508
                  ]
                ],
                "id": 12,
                "chat_link": "[&BAwAAAA=]"
              },
              "13": {
                "objective": "Help Tactician Sebastian against the Sons of Svanir.",
                "level": 74,
                "coord": [
                  55317.5,
                  26775.7
                ],
                "bounds": [
                  [
                    55320.3,
                    27031.5
                  ],
                  [
                    55387.9,
                    26758.6
                  ],
                  [
                    55300.2,
                    26514.5
                  ],
                  [
                    55044.4,
                    26466.4
                  ],
                  [
                    54942.4,
                    26976.7
                  ],
                  [
                    54994.4,
                    27106.3
                  ],
                  [
                    55174,
                    27127.4
                  ],
                  [
                    55320.3,
                    27031.5
                  ]
                ],
                "id": 13,
                "chat_link": "[&BA0AAAA=]"
              },
              "14": {
                "objective": "Learn the way of the kodan.",
                "level": 76,
                "coord": [
                  54119.4,
                  26550.5
                ],
                "bounds": [
                  [
                    54402.9,
                    26426
                  ],
                  [
                    54303.8,
                    26364.5
                  ],
                  [
                    54153,
                    26366.6
                  ],
                  [
                    53938,
                    26459.2
                  ],
                  [
                    53861.2,
                    26577.8
                  ],
                  [
                    53877.5,
                    26667.7
                  ],
                  [
                    53918.7,
                    26741.8
                  ],
                  [
                    54060.8,
                    26865
                  ],
                  [
                    54163,
                    26917.1
                  ],
                  [
                    54209.1,
                    26877.8
                  ],
                  [
                    54305.2,
                    26791.4
                  ],
                  [
                    54375.7,
                    26674.1
                  ],
                  [
                    54402.9,
                    26426
                  ]
                ],
                "id": 14,
                "chat_link": "[&BA4AAAA=]"
              },
              "15": {
                "objective": "Help Infinite Mind rally the forces of Blue Ice Station.",
                "level": 74,
                "coord": [
                  54668.6,
                  27472.3
                ],
                "bounds": [
                  [
                    54701.9,
                    27079
                  ],
                  [
                    54747.9,
                    27153
                  ],
                  [
                    54772.8,
                    27227
                  ],
                  [
                    54893.3,
                    27323.3
                  ],
                  [
                    54892.4,
                    27433.6
                  ],
                  [
                    54861.8,
                    27601.9
                  ],
                  [
                    54784.6,
                    27659.4
                  ],
                  [
                    54705.6,
                    27686.9
                  ],
                  [
                    54631.5,
                    27584.7
                  ],
                  [
                    54424.4,
                    27595.2
                  ],
                  [
                    54197.9,
                    27605.8
                  ],
                  [
                    53934.9,
                    27600.7
                  ],
                  [
                    53989.4,
                    27377
                  ],
                  [
                    54166.3,
                    27350.9
                  ],
                  [
                    54177.5,
                    27236.9
                  ],
                  [
                    54181.3,
                    27153.3
                  ],
                  [
                    54264.7,
                    26890.8
                  ],
                  [
                    54367.4,
                    26899.5
                  ],
                  [
                    54529.4,
                    27002
                  ],
                  [
                    54701.9,
                    27079
                  ]
                ],
                "id": 15,
                "chat_link": "[&BA8AAAA=]"
              },
              "16": {
                "objective": "Help Qualdup train Orsippus trainees for the Quaggan Games.",
                "level": 77,
                "coord": [
                  53895.5,
                  25473.4
                ],
                "bounds": [
                  [
                    53566.4,
                    25553.9
                  ],
                  [
                    53690.3,
                    25740.5
                  ],
                  [
                    53844.5,
                    25754.1
                  ],
                  [
                    54010.4,
                    25639
                  ],
                  [
                    54048.8,
                    25390.4
                  ],
                  [
                    53983.9,
                    25315.1
                  ],
                  [
                    53607.1,
                    25242.2
                  ],
                  [
                    53566.4,
                    25553.9
                  ]
                ],
                "id": 16,
                "chat_link": "[&BBAAAAA=]"
              },
              "17": {
                "objective": "Help Bladed Softness maintain Deep and Troubled Waters.",
                "level": 78,
                "coord": [
                  54245.6,
                  25513.2
                ],
                "bounds": [
                  [
                    54092,
                    25304.7
                  ],
                  [
                    54185.9,
                    25494.8
                  ],
                  [
                    54304.3,
                    25588
                  ],
                  [
                    54406.6,
                    25602.8
                  ],
                  [
                    54544.3,
                    25518.7
                  ],
                  [
                    54560.3,
                    25419.1
                  ],
                  [
                    54560.2,
                    25273.4
                  ],
                  [
                    54488.1,
                    25129.2
                  ],
                  [
                    54322,
                    25009.1
                  ],
                  [
                    54143.5,
                    25206.3
                  ],
                  [
                    54092,
                    25304.7
                  ]
                ],
                "id": 17,
                "chat_link": "[&BBEAAAA=]"
              },
              "19": {
                "objective": "Help Worthy Burden defeat icebrood in Drakkar Spurs.",
                "level": 79,
                "coord": [
                  53984.7,
                  25203.1
                ],
                "bounds": [
                  [
                    53573.9,
                    24858.3
                  ],
                  [
                    53617.6,
                    25020.1
                  ],
                  [
                    53767.1,
                    25216.4
                  ],
                  [
                    53850.6,
                    25274.9
                  ],
                  [
                    54060.1,
                    25295.6
                  ],
                  [
                    54121.9,
                    25184.2
                  ],
                  [
                    54214.8,
                    25094.8
                  ],
                  [
                    54306.8,
                    24865.2
                  ],
                  [
                    54249.6,
                    24616
                  ],
                  [
                    53771.9,
                    24559.8
                  ],
                  [
                    53571.5,
                    24608.6
                  ],
                  [
                    53573.9,
                    24858.3
                  ]
                ],
                "id": 19,
                "chat_link": "[&BBMAAAA=]"
              },
              "20": {
                "objective": "Help Pact Crusader D'Stolt fight the Sons of Svanir.",
                "level": 72,
                "coord": [
                  55328.6,
                  27277.8
                ],
                "bounds": [
                  [
                    55083.2,
                    27551.3
                  ],
                  [
                    54954.9,
                    27404.3
                  ],
                  [
                    54993.5,
                    27115.7
                  ],
                  [
                    55275.2,
                    27147.1
                  ],
                  [
                    55426,
                    27439
                  ],
                  [
                    55304.3,
                    27572.7
                  ],
                  [
                    55083.2,
                    27551.3
                  ]
                ],
                "id": 20,
                "chat_link": "[&BBQAAAA=]"
              },
              "21": {
                "objective": "Help Pact Explorer Erikk battle the Dragon Tribe grawl.",
                "level": 71,
                "coord": [
                  56068.1,
                  27207.1
                ],
                "bounds": [
                  [
                    56351.2,
                    27120.1
                  ],
                  [
                    56303.2,
                    27236
                  ],
                  [
                    56109.4,
                    27313.8
                  ],
                  [
                    55994.6,
                    27294.4
                  ],
                  [
                    55850.1,
                    27195
                  ],
                  [
                    55934.9,
                    26990.1
                  ],
                  [
                    56114.1,
                    26893.7
                  ],
                  [
                    56320.1,
                    26971.8
                  ],
                  [
                    56351.2,
                    27120.1
                  ]
                ],
                "id": 21,
                "chat_link": "[&BBUAAAA=]"
              },
              "24": {
                "objective": "Help Shifting Waves protect the kodan at Path of Starry Skies.",
                "level": 80,
                "coord": [
                  56276.9,
                  24857.2
                ],
                "bounds": [
                  [
                    56508.7,
                    24965.4
                  ],
                  [
                    56344.7,
                    25560.3
                  ],
                  [
                    56075.7,
                    25355.7
                  ],
                  [
                    56148.2,
                    24825.1
                  ],
                  [
                    56330.2,
                    24715.6
                  ],
                  [
                    56508.7,
                    24965.4
                  ]
                ],
                "id": 24,
                "chat_link": "[&BBgAAAA=]"
              },
              "25": {
                "objective": "Assist Rebel Isaak in sowing the seeds of dredge revolution.",
                "level": 75,
                "coord": [
                  53945,
                  27504.4
                ],
                "bounds": [
                  [
                    54015.3,
                    27596.8
                  ],
                  [
                    53797.5,
                    27588.9
                  ],
                  [
                    53592.1,
                    27536.8
                  ],
                  [
                    53517.2,
                    27339.4
                  ],
                  [
                    53542.7,
                    26950.5
                  ],
                  [
                    53895,
                    26981.8
                  ],
                  [
                    54170.8,
                    27159.8
                  ],
                  [
                    54221.3,
                    27401.5
                  ],
                  [
                    54043.1,
                    27424.5
                  ],
                  [
                    54015.3,
                    27596.8
                  ]
                ],
                "id": 25,
                "chat_link": "[&BBkAAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  53846.1,
                  24828.2
                ],
                "id": "0-37"
              },
              {
                "coord": [
                  55519.8,
                  25764
                ],
                "id": "0-97"
              },
              {
                "coord": [
                  54214.3,
                  26534.7
                ],
                "id": "0-96"
              },
              {
                "coord": [
                  53857.6,
                  27485.5
                ],
                "id": "0-15"
              },
              {
                "coord": [
                  55908.4,
                  26678.9
                ],
                "id": "0-10"
              },
              {
                "coord": [
                  55208.7,
                  25038.1
                ],
                "id": "0-191"
              },
              {
                "coord": [
                  54246.4,
                  26256.2
                ],
                "id": "0-196"
              }
            ],
            "sectors": {
              "568": {
                "name": "Bore Lynch",
                "level": 75,
                "coord": [
                  53687.9,
                  27300.8
                ],
                "bounds": [
                  [
                    53650.2,
                    27619.9
                  ],
                  [
                    53648.3,
                    27656
                  ],
                  [
                    53498.3,
                    27660.3
                  ],
                  [
                    53347.7,
                    27477.8
                  ],
                  [
                    53439,
                    27449.7
                  ],
                  [
                    53512.2,
                    27390.1
                  ],
                  [
                    53555.9,
                    27292.9
                  ],
                  [
                    53542.9,
                    27156.5
                  ],
                  [
                    53542.1,
                    27029.1
                  ],
                  [
                    53564,
                    26924.4
                  ],
                  [
                    53800.2,
                    26913.7
                  ],
                  [
                    53846.6,
                    27034.8
                  ],
                  [
                    54246.9,
                    27047.1
                  ],
                  [
                    54241.9,
                    27343.6
                  ],
                  [
                    53881.8,
                    27516.8
                  ],
                  [
                    53650.2,
                    27619.9
                  ]
                ],
                "id": 568,
                "chat_link": "[&BDgCAAA=]"
              },
              "569": {
                "name": "Groznev Delve",
                "level": 75,
                "coord": [
                  54317,
                  27417.7
                ],
                "bounds": [
                  [
                    53836.3,
                    27671.3
                  ],
                  [
                    53644.2,
                    27657.1
                  ],
                  [
                    53647,
                    27618.1
                  ],
                  [
                    53766.8,
                    27565.3
                  ],
                  [
                    54242,
                    27342.5
                  ],
                  [
                    54244.9,
                    27046.9
                  ],
                  [
                    54320.2,
                    27044.4
                  ],
                  [
                    54511.8,
                    26939.6
                  ],
                  [
                    54719.8,
                    27050.3
                  ],
                  [
                    54869.8,
                    27149.3
                  ],
                  [
                    54854.5,
                    27517.2
                  ],
                  [
                    54834.3,
                    27643.8
                  ],
                  [
                    54650.1,
                    27667.9
                  ],
                  [
                    54481.4,
                    27658.2
                  ],
                  [
                    54131.9,
                    27693
                  ],
                  [
                    53836.3,
                    27671.3
                  ]
                ],
                "id": 569,
                "chat_link": "[&BDkCAAA=]"
              },
              "570": {
                "name": "Glacial Collapse",
                "level": 73,
                "coord": [
                  55608.2,
                  26803.9
                ],
                "bounds": [
                  [
                    55490.6,
                    26982.5
                  ],
                  [
                    55401.5,
                    27001.6
                  ],
                  [
                    55442.1,
                    26700.5
                  ],
                  [
                    55499.8,
                    26790
                  ],
                  [
                    55670.3,
                    26471.1
                  ],
                  [
                    55837.2,
                    26554.2
                  ],
                  [
                    55845.4,
                    26916.7
                  ],
                  [
                    55678.7,
                    27014.4
                  ],
                  [
                    55490.6,
                    26982.5
                  ]
                ],
                "id": 570,
                "chat_link": "[&BDoCAAA=]"
              },
              "571": {
                "name": "Rime Moraine",
                "level": 73,
                "coord": [
                  55484.8,
                  26556.8
                ],
                "bounds": [
                  [
                    55367.2,
                    26707.8
                  ],
                  [
                    55365.9,
                    26510.9
                  ],
                  [
                    55418.1,
                    26363.6
                  ],
                  [
                    55624.8,
                    26356.3
                  ],
                  [
                    55673.8,
                    26470.9
                  ],
                  [
                    55500.2,
                    26790.7
                  ],
                  [
                    55443.6,
                    26697.1
                  ],
                  [
                    55367.2,
                    26707.8
                  ]
                ],
                "id": 571,
                "chat_link": "[&BDsCAAA=]"
              },
              "572": {
                "name": "Trionic Lattice",
                "level": 80,
                "coord": [
                  56201.8,
                  26204.4
                ],
                "bounds": [
                  [
                    55621.6,
                    26357.4
                  ],
                  [
                    55639.1,
                    25764.7
                  ],
                  [
                    55973.7,
                    25637.4
                  ],
                  [
                    56296,
                    25944.6
                  ],
                  [
                    56504.7,
                    26259.6
                  ],
                  [
                    56610,
                    26239.4
                  ],
                  [
                    56650.5,
                    26433.4
                  ],
                  [
                    56488.7,
                    26611.6
                  ],
                  [
                    56396.1,
                    26474.9
                  ],
                  [
                    55838,
                    26321.1
                  ],
                  [
                    55621.6,
                    26357.4
                  ]
                ],
                "id": 572,
                "chat_link": "[&BDwCAAA=]"
              },
              "573": {
                "name": "Arundon Vale",
                "level": 72,
                "coord": [
                  56196.1,
                  27309.7
                ],
                "bounds": [
                  [
                    55696.9,
                    27372.5
                  ],
                  [
                    55677.8,
                    27012.1
                  ],
                  [
                    55842.9,
                    26915.9
                  ],
                  [
                    55946.6,
                    27026.2
                  ],
                  [
                    56227.6,
                    26847
                  ],
                  [
                    56506.3,
                    26841.2
                  ],
                  [
                    56539.8,
                    26986.2
                  ],
                  [
                    56595,
                    27283.3
                  ],
                  [
                    56639.1,
                    27429
                  ],
                  [
                    56615.2,
                    27588.6
                  ],
                  [
                    56488.5,
                    27686.9
                  ],
                  [
                    56323.9,
                    27708.3
                  ],
                  [
                    56144.9,
                    27676.9
                  ],
                  [
                    55892.1,
                    27634.1
                  ],
                  [
                    55805,
                    27636.7
                  ],
                  [
                    55696.9,
                    27372.5
                  ]
                ],
                "id": 573,
                "chat_link": "[&BD0CAAA=]"
              },
              "574": {
                "name": "Yakkington's Toil",
                "level": 73,
                "coord": [
                  56037.5,
                  26641.2
                ],
                "bounds": [
                  [
                    55842.3,
                    26915.3
                  ],
                  [
                    55838.1,
                    26558.2
                  ],
                  [
                    55671.1,
                    26472
                  ],
                  [
                    55623,
                    26355.8
                  ],
                  [
                    55837.1,
                    26318.2
                  ],
                  [
                    56398.2,
                    26473.7
                  ],
                  [
                    56491.2,
                    26612.1
                  ],
                  [
                    56494.7,
                    26836.9
                  ],
                  [
                    56232.1,
                    26844.8
                  ],
                  [
                    55947,
                    27024.7
                  ],
                  [
                    55842.3,
                    26915.3
                  ]
                ],
                "id": 574,
                "chat_link": "[&BD4CAAA=]"
              },
              "575": {
                "name": "Highpeaks",
                "level": 73,
                "coord": [
                  55238.8,
                  27250.6
                ],
                "bounds": [
                  [
                    54851.3,
                    27518.4
                  ],
                  [
                    54868.9,
                    27150.8
                  ],
                  [
                    54974.3,
                    27013.3
                  ],
                  [
                    55072.5,
                    26936.4
                  ],
                  [
                    55162.7,
                    27020.4
                  ],
                  [
                    55332.2,
                    27010.7
                  ],
                  [
                    55489,
                    26983.3
                  ],
                  [
                    55678.1,
                    27010.6
                  ],
                  [
                    55698.2,
                    27372.3
                  ],
                  [
                    55802.4,
                    27631
                  ],
                  [
                    55106.5,
                    27713.5
                  ],
                  [
                    54829.4,
                    27646.2
                  ],
                  [
                    54851.3,
                    27518.4
                  ]
                ],
                "id": 575,
                "chat_link": "[&BD8CAAA=]"
              },
              "576": {
                "name": "Snow Climb",
                "level": 80,
                "coord": [
                  56354,
                  25069.9
                ],
                "bounds": [
                  [
                    56558.7,
                    25660.7
                  ],
                  [
                    55919.8,
                    25294.5
                  ],
                  [
                    55879.7,
                    25076.2
                  ],
                  [
                    56019.4,
                    24606.3
                  ],
                  [
                    56309.9,
                    24619.5
                  ],
                  [
                    56511.1,
                    24633.4
                  ],
                  [
                    56502.5,
                    24785.3
                  ],
                  [
                    56543.5,
                    24952
                  ],
                  [
                    56571.2,
                    25175.4
                  ],
                  [
                    56508.9,
                    25404.5
                  ],
                  [
                    56569.9,
                    25560.7
                  ],
                  [
                    56558.7,
                    25660.7
                  ]
                ],
                "id": 576,
                "chat_link": "[&BEACAAA=]"
              },
              "577": {
                "name": "Earthshake Basin",
                "level": 80,
                "coord": [
                  56386.3,
                  25830.6
                ],
                "bounds": [
                  [
                    55975.3,
                    25637.9
                  ],
                  [
                    55917.5,
                    25280
                  ],
                  [
                    56407.7,
                    25574.4
                  ],
                  [
                    56560.4,
                    25658.9
                  ],
                  [
                    56589.9,
                    25822.4
                  ],
                  [
                    56617.3,
                    26053.7
                  ],
                  [
                    56608.3,
                    26239.8
                  ],
                  [
                    56505.7,
                    26260.5
                  ],
                  [
                    56294.6,
                    25948
                  ],
                  [
                    55975.3,
                    25637.9
                  ]
                ],
                "id": 577,
                "chat_link": "[&BEECAAA=]"
              },
              "578": {
                "name": "Frostwalk Tundra",
                "level": 80,
                "coord": [
                  55465.4,
                  25538.2
                ],
                "bounds": [
                  [
                    55051.4,
                    25484.8
                  ],
                  [
                    55115.3,
                    25369.1
                  ],
                  [
                    55393.2,
                    25284.2
                  ],
                  [
                    55484.6,
                    25357
                  ],
                  [
                    55758,
                    25388.9
                  ],
                  [
                    55777.1,
                    25055.3
                  ],
                  [
                    55882,
                    25077.2
                  ],
                  [
                    55977.6,
                    25641.4
                  ],
                  [
                    55641.3,
                    25768.8
                  ],
                  [
                    55510.7,
                    25672.1
                  ],
                  [
                    55405.6,
                    25771
                  ],
                  [
                    55287.9,
                    25930.4
                  ],
                  [
                    55099,
                    25971
                  ],
                  [
                    55131.7,
                    25763.5
                  ],
                  [
                    55051.4,
                    25484.8
                  ]
                ],
                "id": 578,
                "chat_link": "[&BEICAAA=]"
              },
              "579": {
                "name": "Maladar's Inlet",
                "level": 77,
                "coord": [
                  54503.5,
                  25968.6
                ],
                "bounds": [
                  [
                    54478,
                    26302.3
                  ],
                  [
                    54240.7,
                    26064.4
                  ],
                  [
                    54164.7,
                    25578.2
                  ],
                  [
                    54225.4,
                    25500.1
                  ],
                  [
                    54344.5,
                    25576.1
                  ],
                  [
                    54557.1,
                    25562
                  ],
                  [
                    54564.9,
                    25615.2
                  ],
                  [
                    54491.1,
                    25921.1
                  ],
                  [
                    54665.5,
                    26045.9
                  ],
                  [
                    54896.4,
                    26235.8
                  ],
                  [
                    54723.6,
                    26329.7
                  ],
                  [
                    54685.5,
                    26447.2
                  ],
                  [
                    54507.8,
                    26414
                  ],
                  [
                    54478,
                    26302.3
                  ]
                ],
                "id": 579,
                "chat_link": "[&BEMCAAA=]"
              },
              "580": {
                "name": "Shattered Ice Floe",
                "level": 79,
                "coord": [
                  54683,
                  25431.5
                ],
                "bounds": [
                  [
                    54563.5,
                    25616.4
                  ],
                  [
                    54474.6,
                    25092.7
                  ],
                  [
                    54594.9,
                    25052.5
                  ],
                  [
                    54739.9,
                    25051.3
                  ],
                  [
                    54796.4,
                    25093.4
                  ],
                  [
                    54860.5,
                    25399.9
                  ],
                  [
                    54820.9,
                    25422.8
                  ],
                  [
                    54825.8,
                    25614.6
                  ],
                  [
                    54664.8,
                    26047.5
                  ],
                  [
                    54488.8,
                    25923.8
                  ],
                  [
                    54563.5,
                    25616.4
                  ]
                ],
                "id": 580,
                "chat_link": "[&BEQCAAA=]"
              },
              "581": {
                "name": "Drakkar Spurs",
                "level": 79,
                "coord": [
                  53834.9,
                  24812.8
                ],
                "bounds": [
                  [
                    53533.4,
                    25111.5
                  ],
                  [
                    53543.1,
                    24971.9
                  ],
                  [
                    53494.9,
                    24850.7
                  ],
                  [
                    53489,
                    24679.1
                  ],
                  [
                    53507.3,
                    24590.9
                  ],
                  [
                    53703.5,
                    24473.4
                  ],
                  [
                    53891.5,
                    24506
                  ],
                  [
                    53985.2,
                    24615.7
                  ],
                  [
                    54157.4,
                    24624
                  ],
                  [
                    54174.3,
                    24680.9
                  ],
                  [
                    54242.5,
                    24889.9
                  ],
                  [
                    54179.8,
                    25038.2
                  ],
                  [
                    53968.4,
                    24923.6
                  ],
                  [
                    53818.9,
                    24998.6
                  ],
                  [
                    53834.5,
                    25238.4
                  ],
                  [
                    53533.4,
                    25111.5
                  ]
                ],
                "id": 581,
                "chat_link": "[&BEUCAAA=]"
              },
              "582": {
                "name": "Watchful Fjord",
                "level": 80,
                "coord": [
                  55190.4,
                  25088.1
                ],
                "bounds": [
                  [
                    54588.4,
                    25053
                  ],
                  [
                    54600,
                    24862
                  ],
                  [
                    54737.3,
                    24611
                  ],
                  [
                    55045.2,
                    24613.2
                  ],
                  [
                    56021.9,
                    24605.5
                  ],
                  [
                    55881.7,
                    25081.5
                  ],
                  [
                    55775.9,
                    25058
                  ],
                  [
                    55758.2,
                    25388.6
                  ],
                  [
                    55487.4,
                    25359.1
                  ],
                  [
                    55393.3,
                    25287.6
                  ],
                  [
                    55123.9,
                    25362.7
                  ],
                  [
                    55056.6,
                    25488.7
                  ],
                  [
                    54858.7,
                    25400.6
                  ],
                  [
                    54791.1,
                    25095.9
                  ],
                  [
                    54735.8,
                    25053.7
                  ],
                  [
                    54588.4,
                    25053
                  ]
                ],
                "id": 582,
                "chat_link": "[&BEYCAAA=]"
              },
              "583": {
                "name": "The Sea of Lamentation",
                "level": 79,
                "coord": [
                  54297.2,
                  25038.1
                ],
                "bounds": [
                  [
                    53835.6,
                    25240.3
                  ],
                  [
                    53818.2,
                    24999.4
                  ],
                  [
                    53968.5,
                    24922.2
                  ],
                  [
                    54179.4,
                    25036.9
                  ],
                  [
                    54244.2,
                    24889.8
                  ],
                  [
                    54148.7,
                    24614.8
                  ],
                  [
                    54794.2,
                    24612.4
                  ],
                  [
                    54606.2,
                    24855.7
                  ],
                  [
                    54595.2,
                    25052.4
                  ],
                  [
                    54476.2,
                    25094.1
                  ],
                  [
                    54555.7,
                    25562.4
                  ],
                  [
                    54344.4,
                    25576.6
                  ],
                  [
                    53835.6,
                    25240.3
                  ]
                ],
                "id": 583,
                "chat_link": "[&BEcCAAA=]"
              },
              "584": {
                "name": "Despond Precipice",
                "level": 80,
                "coord": [
                  55394.9,
                  26044.5
                ],
                "bounds": [
                  [
                    55404.3,
                    25769.1
                  ],
                  [
                    55513.4,
                    25672.4
                  ],
                  [
                    55639.6,
                    25766.3
                  ],
                  [
                    55623,
                    26356.7
                  ],
                  [
                    55432.7,
                    26369.8
                  ],
                  [
                    55391.1,
                    26275.7
                  ],
                  [
                    55163.3,
                    26292.2
                  ],
                  [
                    55099.6,
                    25969.1
                  ],
                  [
                    55287.3,
                    25929.7
                  ],
                  [
                    55404.3,
                    25769.1
                  ]
                ],
                "id": 584,
                "chat_link": "[&BEgCAAA=]"
              },
              "585": {
                "name": "Refuge Shore",
                "level": 76,
                "coord": [
                  54330.8,
                  26831.3
                ],
                "bounds": [
                  [
                    54244.8,
                    27044.1
                  ],
                  [
                    54029,
                    27044.4
                  ],
                  [
                    54282.9,
                    26811.5
                  ],
                  [
                    54417.8,
                    26521.9
                  ],
                  [
                    54507.8,
                    26408.3
                  ],
                  [
                    54514.3,
                    26946.1
                  ],
                  [
                    54319,
                    27042.9
                  ],
                  [
                    54244.8,
                    27044.1
                  ]
                ],
                "id": 585,
                "chat_link": "[&BEkCAAA=]"
              },
              "586": {
                "name": "Stonesledge Draft",
                "level": 76,
                "coord": [
                  53753.8,
                  26617.1
                ],
                "bounds": [
                  [
                    53565.8,
                    26927.3
                  ],
                  [
                    53590.5,
                    26647.1
                  ],
                  [
                    53748.6,
                    26576.6
                  ],
                  [
                    53619.4,
                    26511.9
                  ],
                  [
                    53608.8,
                    26391.8
                  ],
                  [
                    53690.9,
                    26244
                  ],
                  [
                    53775.1,
                    26205.2
                  ],
                  [
                    53764.7,
                    26294
                  ],
                  [
                    53883.6,
                    26480.5
                  ],
                  [
                    54004.4,
                    26749.5
                  ],
                  [
                    53902,
                    27039.3
                  ],
                  [
                    53846.3,
                    27035.8
                  ],
                  [
                    53799.3,
                    26919.4
                  ],
                  [
                    53565.8,
                    26927.3
                  ]
                ],
                "id": 586,
                "chat_link": "[&BEoCAAA=]"
              },
              "587": {
                "name": "Talabaroop Waves",
                "level": 76,
                "coord": [
                  54116.2,
                  26537.5
                ],
                "bounds": [
                  [
                    53902.4,
                    27041
                  ],
                  [
                    54002,
                    26749.3
                  ],
                  [
                    53882.3,
                    26480.1
                  ],
                  [
                    53764.3,
                    26294.6
                  ],
                  [
                    53774.6,
                    26206.3
                  ],
                  [
                    54235.5,
                    26056.1
                  ],
                  [
                    54476.8,
                    26301.6
                  ],
                  [
                    54508.7,
                    26409.5
                  ],
                  [
                    54419.7,
                    26520.5
                  ],
                  [
                    54284.3,
                    26807.6
                  ],
                  [
                    54027.3,
                    27046.2
                  ],
                  [
                    53902.4,
                    27041
                  ]
                ],
                "id": 587,
                "chat_link": "[&BEsCAAA=]"
              },
              "588": {
                "name": "Grimstone Mol",
                "level": 78,
                "coord": [
                  54951.1,
                  25884.8
                ],
                "bounds": [
                  [
                    54891.1,
                    26238.3
                  ],
                  [
                    54664.5,
                    26045.8
                  ],
                  [
                    54824.5,
                    25613.6
                  ],
                  [
                    54820.5,
                    25422.1
                  ],
                  [
                    54862.3,
                    25401.7
                  ],
                  [
                    55056,
                    25485.2
                  ],
                  [
                    55132.7,
                    25762.7
                  ],
                  [
                    55100.1,
                    25968
                  ],
                  [
                    55163.8,
                    26297.4
                  ],
                  [
                    55003.4,
                    26291.4
                  ],
                  [
                    54943.8,
                    26206.4
                  ],
                  [
                    54891.1,
                    26238.3
                  ]
                ],
                "id": 588,
                "chat_link": "[&BEwCAAA=]"
              },
              "589": {
                "name": "Dimotiki Waters",
                "level": 77,
                "coord": [
                  53845.1,
                  25764.6
                ],
                "bounds": [
                  [
                    53775.6,
                    26205.2
                  ],
                  [
                    53690.5,
                    26244.8
                  ],
                  [
                    53612.6,
                    26038.7
                  ],
                  [
                    53686.4,
                    25853.4
                  ],
                  [
                    53595.9,
                    25769.7
                  ],
                  [
                    53621.9,
                    25155
                  ],
                  [
                    53836.5,
                    25239.5
                  ],
                  [
                    54227,
                    25500.2
                  ],
                  [
                    54164.6,
                    25578.3
                  ],
                  [
                    54239.9,
                    26061.1
                  ],
                  [
                    53775.6,
                    26205.2
                  ]
                ],
                "id": 589,
                "chat_link": "[&BE0CAAA=]"
              },
              "590": {
                "name": "Leopard's Tail Valley",
                "level": 74,
                "coord": [
                  54780.7,
                  26853.1
                ],
                "bounds": [
                  [
                    54508.6,
                    26945.1
                  ],
                  [
                    54506.9,
                    26411.7
                  ],
                  [
                    54816.5,
                    26457.4
                  ],
                  [
                    55071.9,
                    26938.9
                  ],
                  [
                    54974.1,
                    27011.8
                  ],
                  [
                    54870.1,
                    27153
                  ],
                  [
                    54716.8,
                    27054.1
                  ],
                  [
                    54508.6,
                    26945.1
                  ]
                ],
                "id": 590,
                "chat_link": "[&BE4CAAA=]"
              },
              "591": {
                "name": "Wayward Climb",
                "level": 74,
                "coord": [
                  55153.6,
                  26569.7
                ],
                "bounds": [
                  [
                    54821.3,
                    26457.6
                  ],
                  [
                    54682.5,
                    26446.8
                  ],
                  [
                    54721.7,
                    26329
                  ],
                  [
                    54946,
                    26198.7
                  ],
                  [
                    55004,
                    26289.4
                  ],
                  [
                    55167,
                    26293.2
                  ],
                  [
                    55389.2,
                    26273.2
                  ],
                  [
                    55422.7,
                    26363.4
                  ],
                  [
                    55366.8,
                    26511
                  ],
                  [
                    55370.1,
                    26708.3
                  ],
                  [
                    55441.9,
                    26698.3
                  ],
                  [
                    55403.6,
                    27002.5
                  ],
                  [
                    55332.4,
                    27014.6
                  ],
                  [
                    55162.1,
                    27022.2
                  ],
                  [
                    55072.5,
                    26937.9
                  ],
                  [
                    54821.3,
                    26457.6
                  ]
                ],
                "id": 591,
                "chat_link": "[&BE8CAAA=]"
              }
            },
            "adventures": [],
            "id": 30,
            "mastery_points": []
          },
          "31": {
            "name": "Snowden Drifts",
            "min_level": 15,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              52480,
              28672
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                50432,
                27648
              ],
              [
                54528,
                29696
              ]
            ],
            "points_of_interest": {
              "142": {
                "name": "Drakentelt",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54281.9,
                  28735.8
                ],
                "id": 142,
                "chat_link": "[&BI4AAAA=]"
              },
              "143": {
                "name": "Svannijem Hold",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53606.7,
                  29186.6
                ],
                "id": 143,
                "chat_link": "[&BI8AAAA=]"
              },
              "144": {
                "name": "Urgulp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52670.7,
                  29392.7
                ],
                "id": 144,
                "chat_link": "[&BJAAAAA=]"
              },
              "145": {
                "name": "Tala Point",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52946.8,
                  29327.9
                ],
                "id": 145,
                "chat_link": "[&BJEAAAA=]"
              },
              "146": {
                "name": "Lashoosh",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51941,
                  28019.5
                ],
                "id": 146,
                "chat_link": "[&BJIAAAA=]"
              },
              "147": {
                "name": "Durgar's Homestead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51707,
                  27785.4
                ],
                "id": 147,
                "chat_link": "[&BJMAAAA=]"
              },
              "163": {
                "name": "Owl Lodge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54218.9,
                  29393.3
                ],
                "id": 163,
                "chat_link": "[&BKMAAAA=]"
              },
              "164": {
                "name": "Blasted Haven",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53536.5,
                  28277.5
                ],
                "id": 164,
                "chat_link": "[&BKQAAAA=]"
              },
              "179": {
                "name": "Skradden Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50594.5,
                  29086.7
                ],
                "id": 179,
                "chat_link": "[&BLMAAAA=]"
              },
              "180": {
                "name": "Lornar's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51814.5,
                  29365.7
                ],
                "id": 180,
                "chat_link": "[&BLQAAAA=]"
              },
              "181": {
                "name": "Highpass Haven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54345,
                  28046.1
                ],
                "id": 181,
                "chat_link": "[&BLUAAAA=]"
              },
              "182": {
                "name": "Lost Child's Sorrow Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53547.3,
                  27818.1
                ],
                "id": 182,
                "chat_link": "[&BLYAAAA=]"
              },
              "183": {
                "name": "Scholar's Cleft Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50671.9,
                  28144.8
                ],
                "id": 183,
                "chat_link": "[&BLcAAAA=]"
              },
              "184": {
                "name": "Isenfall Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51750.4,
                  28038.1
                ],
                "id": 184,
                "chat_link": "[&BLgAAAA=]"
              },
              "185": {
                "name": "Snowdrift Haven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51949.2,
                  28780.2
                ],
                "id": 185,
                "chat_link": "[&BLkAAAA=]"
              },
              "186": {
                "name": "Seraph Outriders' Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50685.3,
                  28500
                ],
                "id": 186,
                "chat_link": "[&BLoAAAA=]"
              },
              "187": {
                "name": "Torstvedt Homestead Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52847.1,
                  28438.8
                ],
                "id": 187,
                "chat_link": "[&BLsAAAA=]"
              },
              "188": {
                "name": "Exile Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53033.4,
                  29370.5
                ],
                "id": 188,
                "chat_link": "[&BLwAAAA=]"
              },
              "189": {
                "name": "Njordstead Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53043.1,
                  27821.2
                ],
                "id": 189,
                "chat_link": "[&BL0AAAA=]"
              },
              "190": {
                "name": "Soderhem Steading Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53004.5,
                  28147.1
                ],
                "id": 190,
                "chat_link": "[&BL4AAAA=]"
              },
              "191": {
                "name": "Snowhawk Landing Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53674.4,
                  28568.6
                ],
                "id": 191,
                "chat_link": "[&BL8AAAA=]"
              },
              "192": {
                "name": "Reaver's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53976.1,
                  29098.1
                ],
                "id": 192,
                "chat_link": "[&BMAAAAA=]"
              },
              "193": {
                "name": "Owl Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54246.6,
                  29308.1
                ],
                "id": 193,
                "chat_link": "[&BMEAAAA=]"
              },
              "194": {
                "name": "Podaga Steading Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50879.9,
                  29308.6
                ],
                "id": 194,
                "chat_link": "[&BMIAAAA=]"
              },
              "824": {
                "name": "Mennerheim",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51528.8,
                  29380.8
                ],
                "id": 824,
                "chat_link": "[&BDgDAAA=]"
              },
              "959": {
                "name": "Frozen Sweeps Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51256.5,
                  28735.8
                ],
                "id": 959,
                "chat_link": "[&BL8DAAA=]"
              },
              "960": {
                "name": "Valslake Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52374.3,
                  29244.8
                ],
                "id": 960,
                "chat_link": "[&BMADAAA=]"
              },
              "1034": {
                "name": "Moldary Point",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52367.5,
                  29135.8
                ],
                "id": 1034,
                "chat_link": "[&BAoEAAA=]"
              },
              "1487": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  54148.4,
                  28900
                ],
                "id": 1487,
                "chat_link": "[&BM8FAAA=]"
              },
              "1488": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  50818.9,
                  29102.1
                ],
                "id": 1488,
                "chat_link": "[&BNAFAAA=]"
              },
              "1489": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  54108.5,
                  27807.1
                ],
                "id": 1489,
                "chat_link": "[&BNEFAAA=]"
              },
              "1490": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51382.7,
                  28334.3
                ],
                "id": 1490,
                "chat_link": "[&BNIFAAA=]"
              },
              "1491": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  54163,
                  29365.8
                ],
                "id": 1491,
                "chat_link": "[&BNMFAAA=]"
              },
              "1492": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  54353,
                  28554
                ],
                "id": 1492,
                "chat_link": "[&BNQFAAA=]"
              },
              "1597": {
                "name": "Jorand's Sluice",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52192,
                  28809.3
                ],
                "id": 1597,
                "chat_link": "[&BD0GAAA=]"
              },
              "1791": {
                "name": "Angvar's Trove Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50591.8,
                  28282.2
                ],
                "id": 1791,
                "chat_link": "[&BP8GAAA=]"
              }
            },
            "tasks": {
              "26": {
                "objective": "Support the crafters of Soderhem.",
                "level": 17,
                "coord": [
                  53164.1,
                  28110.9
                ],
                "bounds": [
                  [
                    52999.6,
                    27965.1
                  ],
                  [
                    52795.1,
                    28169.1
                  ],
                  [
                    52911.8,
                    28309.9
                  ],
                  [
                    53549.9,
                    28173.5
                  ],
                  [
                    53564,
                    27990.4
                  ],
                  [
                    52999.6,
                    27965.1
                  ]
                ],
                "id": 26,
                "chat_link": "[&BBoAAAA=]"
              },
              "27": {
                "objective": "Preserve the Njordstead hunting grounds.",
                "level": 17,
                "coord": [
                  52923.7,
                  27791.9
                ],
                "bounds": [
                  [
                    52623.2,
                    27706.5
                  ],
                  [
                    52978.8,
                    27719.1
                  ],
                  [
                    53189.5,
                    27764.2
                  ],
                  [
                    52791.8,
                    28164.5
                  ],
                  [
                    52573.2,
                    27967.5
                  ],
                  [
                    52623.2,
                    27706.5
                  ]
                ],
                "id": 27,
                "chat_link": "[&BBsAAAA=]"
              },
              "28": {
                "objective": "Help hunters and travelers near the road.",
                "level": 15,
                "coord": [
                  54094.4,
                  28366.8
                ],
                "bounds": [
                  [
                    53967.6,
                    28193.5
                  ],
                  [
                    53915.7,
                    28380
                  ],
                  [
                    53853.2,
                    28523.3
                  ],
                  [
                    53920,
                    28588.3
                  ],
                  [
                    54089,
                    28600.3
                  ],
                  [
                    54329.9,
                    28359.6
                  ],
                  [
                    54267.8,
                    27716.8
                  ],
                  [
                    54157.4,
                    27770.6
                  ],
                  [
                    53967.6,
                    28193.5
                  ]
                ],
                "id": 28,
                "chat_link": "[&BBwAAAA=]"
              },
              "29": {
                "objective": "Push back the corruption.",
                "level": 16,
                "coord": [
                  53357.1,
                  28502.5
                ],
                "bounds": [
                  [
                    53965.9,
                    28004
                  ],
                  [
                    54019.6,
                    28069.4
                  ],
                  [
                    53883.9,
                    28262.8
                  ],
                  [
                    53837.1,
                    28383.6
                  ],
                  [
                    53751.1,
                    28505.6
                  ],
                  [
                    53403.2,
                    28513.9
                  ],
                  [
                    53270.5,
                    28530.4
                  ],
                  [
                    53142.8,
                    28530.2
                  ],
                  [
                    53046.3,
                    28545.5
                  ],
                  [
                    53034.3,
                    28464.9
                  ],
                  [
                    53216.6,
                    28306.7
                  ],
                  [
                    53357.3,
                    28250.3
                  ],
                  [
                    53730.7,
                    28159.7
                  ],
                  [
                    53835.9,
                    28056.9
                  ],
                  [
                    53965.9,
                    28004
                  ]
                ],
                "id": 29,
                "chat_link": "[&BB0AAAA=]"
              },
              "30": {
                "objective": "Assist Lionguard Nadel.",
                "level": 18,
                "coord": [
                  53483.2,
                  28690.2
                ],
                "bounds": [
                  [
                    52951.2,
                    28811.3
                  ],
                  [
                    52905.6,
                    28618.3
                  ],
                  [
                    53303.4,
                    28538.9
                  ],
                  [
                    53424,
                    28525.2
                  ],
                  [
                    53590.3,
                    28667.4
                  ],
                  [
                    53468.9,
                    29000.6
                  ],
                  [
                    52951.2,
                    28811.3
                  ]
                ],
                "id": 30,
                "chat_link": "[&BB4AAAA=]"
              },
              "31": {
                "objective": "Help Owl's followers.",
                "level": 19,
                "coord": [
                  54060.8,
                  29497.2
                ],
                "bounds": [
                  [
                    54164.5,
                    29385
                  ],
                  [
                    52782.6,
                    28672
                  ],
                  [
                    54164.5,
                    29385
                  ]
                ],
                "id": 31,
                "chat_link": "[&BB8AAAA=]"
              },
              "32": {
                "objective": "Support the Durmand Priory against the centaurs.",
                "level": 25,
                "coord": [
                  51112.5,
                  28304.6
                ],
                "bounds": [
                  [
                    51036.6,
                    28285.8
                  ],
                  [
                    50985.5,
                    28119.4
                  ],
                  [
                    51041.6,
                    28036.3
                  ],
                  [
                    51291.5,
                    27938.2
                  ],
                  [
                    51390.2,
                    27947
                  ],
                  [
                    51424.9,
                    28088.6
                  ],
                  [
                    51424.5,
                    28135.9
                  ],
                  [
                    51379.2,
                    28186.6
                  ],
                  [
                    51353.5,
                    28217.1
                  ],
                  [
                    51324.1,
                    28258.3
                  ],
                  [
                    51155.4,
                    28340.9
                  ],
                  [
                    51036.6,
                    28285.8
                  ]
                ],
                "id": 32,
                "chat_link": "[&BCAAAAA=]"
              },
              "33": {
                "objective": "Help the Seraph outrider camp.",
                "level": 24,
                "coord": [
                  50764,
                  28513.4
                ],
                "bounds": [
                  [
                    51105,
                    28364.3
                  ],
                  [
                    51161.3,
                    28391.4
                  ],
                  [
                    51096.3,
                    28496.2
                  ],
                  [
                    51089.8,
                    28564.5
                  ],
                  [
                    51084.5,
                    28625
                  ],
                  [
                    51084,
                    28720.6
                  ],
                  [
                    51035.5,
                    28778
                  ],
                  [
                    50779.2,
                    28796.3
                  ],
                  [
                    50743.2,
                    28766.1
                  ],
                  [
                    50734.9,
                    28543
                  ],
                  [
                    50734.4,
                    28462.8
                  ],
                  [
                    50708.3,
                    28356.2
                  ],
                  [
                    50759.6,
                    28311.8
                  ],
                  [
                    50837.5,
                    28324.5
                  ],
                  [
                    50900.3,
                    28388.6
                  ],
                  [
                    51043.8,
                    28432
                  ],
                  [
                    51105,
                    28364.3
                  ]
                ],
                "id": 33,
                "chat_link": "[&BCEAAAA=]"
              },
              "34": {
                "objective": "Fight the denizens of Jormabakke Stead.",
                "level": 24,
                "coord": [
                  51440.7,
                  28508.8
                ],
                "bounds": [
                  [
                    51511.1,
                    28394.5
                  ],
                  [
                    51507.1,
                    28336.8
                  ],
                  [
                    51568.8,
                    28226.4
                  ],
                  [
                    51405,
                    28221
                  ],
                  [
                    51343.9,
                    28308.9
                  ],
                  [
                    51178.5,
                    28389
                  ],
                  [
                    51101.2,
                    28508.6
                  ],
                  [
                    51089.3,
                    28625.5
                  ],
                  [
                    51089.3,
                    28703.5
                  ],
                  [
                    51505.7,
                    28733.7
                  ],
                  [
                    51567.5,
                    28558.8
                  ],
                  [
                    51511.1,
                    28394.5
                  ]
                ],
                "id": 34,
                "chat_link": "[&BCIAAAA=]"
              },
              "35": {
                "objective": "Disrupt the dredge in Molengrad.",
                "level": 23,
                "coord": [
                  51395.9,
                  29365.5
                ],
                "bounds": [
                  [
                    51214.3,
                    29224.1
                  ],
                  [
                    51407.1,
                    29340.1
                  ],
                  [
                    51416,
                    29554.1
                  ],
                  [
                    51360.1,
                    29667.5
                  ],
                  [
                    50985.8,
                    29702.5
                  ],
                  [
                    50958.7,
                    29305
                  ],
                  [
                    51058.7,
                    29225.9
                  ],
                  [
                    51214.3,
                    29224.1
                  ]
                ],
                "id": 35,
                "chat_link": "[&BCMAAAA=]"
              },
              "36": {
                "objective": "Impress the Mennerheim steadholders.",
                "level": 22,
                "coord": [
                  51536.9,
                  29401.7
                ],
                "bounds": [
                  [
                    51408.3,
                    29313
                  ],
                  [
                    51233.2,
                    29214.5
                  ],
                  [
                    51044.7,
                    29003.7
                  ],
                  [
                    51095.7,
                    28851.8
                  ],
                  [
                    51265.5,
                    28834.8
                  ],
                  [
                    51661,
                    28959.7
                  ],
                  [
                    51737.8,
                    28981.6
                  ],
                  [
                    51880.2,
                    29120.3
                  ],
                  [
                    51876.1,
                    29611.4
                  ],
                  [
                    51431.8,
                    29652.3
                  ],
                  [
                    51339.6,
                    29579.5
                  ],
                  [
                    51424.3,
                    29469.6
                  ],
                  [
                    51408.3,
                    29313
                  ]
                ],
                "id": 36,
                "chat_link": "[&BCQAAAA=]"
              },
              "37": {
                "objective": "Oppose the thieving grawl.",
                "level": 21,
                "coord": [
                  52224.2,
                  28241.7
                ],
                "bounds": [
                  [
                    52115.5,
                    27900.3
                  ],
                  [
                    52190.1,
                    27875.7
                  ],
                  [
                    52252.6,
                    27893.7
                  ],
                  [
                    52308.8,
                    28079.9
                  ],
                  [
                    52259.5,
                    28241.7
                  ],
                  [
                    52092.6,
                    28378.2
                  ],
                  [
                    52080.1,
                    28527.5
                  ],
                  [
                    51994.6,
                    28541.2
                  ],
                  [
                    51955.2,
                    28454.3
                  ],
                  [
                    51975.5,
                    28149.8
                  ],
                  [
                    52024.7,
                    27989.7
                  ],
                  [
                    52074.8,
                    27951.2
                  ],
                  [
                    52115.5,
                    27900.3
                  ]
                ],
                "id": 37,
                "chat_link": "[&BCUAAAA=]"
              },
              "38": {
                "objective": "Help quaggans settle into Urgulp.",
                "level": 20,
                "coord": [
                  52722.4,
                  29352.9
                ],
                "bounds": [
                  [
                    52869.3,
                    29333.3
                  ],
                  [
                    52870.6,
                    29365.8
                  ],
                  [
                    52652.7,
                    29475.5
                  ],
                  [
                    52571.5,
                    29380.3
                  ],
                  [
                    52597.5,
                    29236.4
                  ],
                  [
                    52776.6,
                    29177.8
                  ],
                  [
                    52835.9,
                    29226.4
                  ],
                  [
                    52869.3,
                    29333.3
                  ]
                ],
                "id": 38,
                "chat_link": "[&BCYAAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  50727.1,
                  28293.4
                ],
                "id": "0-35"
              },
              {
                "coord": [
                  50605.5,
                  29392.2
                ],
                "id": "0-88"
              },
              {
                "coord": [
                  53538.8,
                  27732
                ],
                "id": "0-87"
              },
              {
                "coord": [
                  54299.9,
                  29506.1
                ],
                "id": "0-86"
              },
              {
                "coord": [
                  51690.3,
                  27829.5
                ],
                "id": "0-85"
              },
              {
                "coord": [
                  51003.4,
                  27843.3
                ],
                "id": "0-202"
              }
            ],
            "sectors": {
              "218": {
                "name": "Skradden Slopes",
                "level": 24,
                "coord": [
                  50795.2,
                  29007.4
                ],
                "bounds": [
                  [
                    51098.6,
                    28729.4
                  ],
                  [
                    51088.5,
                    28558.8
                  ],
                  [
                    50963.1,
                    28443.5
                  ],
                  [
                    50818.5,
                    28647.1
                  ],
                  [
                    50439.7,
                    28686.4
                  ],
                  [
                    50436.4,
                    29082.7
                  ],
                  [
                    50356.2,
                    29132.5
                  ],
                  [
                    50375.1,
                    29340.2
                  ],
                  [
                    50589.5,
                    29194.6
                  ],
                  [
                    50700.6,
                    29293.7
                  ],
                  [
                    50961,
                    29420.3
                  ],
                  [
                    51099.5,
                    29338.3
                  ],
                  [
                    51004.8,
                    29214.5
                  ],
                  [
                    51025.5,
                    29076.6
                  ],
                  [
                    50971.7,
                    28952.1
                  ],
                  [
                    51098.6,
                    28729.4
                  ]
                ],
                "id": 218,
                "chat_link": "[&BNoAAAA=]"
              },
              "219": {
                "name": "Glisterice Caves",
                "level": 24,
                "coord": [
                  50659,
                  29483.5
                ],
                "bounds": [
                  [
                    50961.3,
                    29414.1
                  ],
                  [
                    50697,
                    29288.8
                  ],
                  [
                    50593.8,
                    29191
                  ],
                  [
                    50372.6,
                    29336.8
                  ],
                  [
                    50312.3,
                    29661.3
                  ],
                  [
                    50659.4,
                    29796.2
                  ],
                  [
                    51016.6,
                    29696
                  ],
                  [
                    50961.3,
                    29414.1
                  ]
                ],
                "id": 219,
                "chat_link": "[&BNsAAAA=]"
              },
              "220": {
                "name": "The Frozen Sweeps",
                "level": 24,
                "coord": [
                  51359.9,
                  28989
                ],
                "bounds": [
                  [
                    51100.5,
                    29342.2
                  ],
                  [
                    51149.7,
                    29298.5
                  ],
                  [
                    51588.9,
                    29311.2
                  ],
                  [
                    51770.3,
                    29223.4
                  ],
                  [
                    51789.8,
                    28917.2
                  ],
                  [
                    51643.6,
                    28869.2
                  ],
                  [
                    51655.7,
                    28601.7
                  ],
                  [
                    51490.9,
                    28602
                  ],
                  [
                    51400.9,
                    28712.5
                  ],
                  [
                    51096,
                    28728.2
                  ],
                  [
                    50966.9,
                    28954.1
                  ],
                  [
                    51021.4,
                    29080.2
                  ],
                  [
                    51004,
                    29216.2
                  ],
                  [
                    51100.5,
                    29342.2
                  ]
                ],
                "id": 220,
                "chat_link": "[&BNwAAAA=]"
              },
              "221": {
                "name": "Molengrad",
                "level": 24,
                "coord": [
                  51212.2,
                  29527.5
                ],
                "bounds": [
                  [
                    51017.4,
                    29696
                  ],
                  [
                    50957.3,
                    29414.6
                  ],
                  [
                    51149.3,
                    29300.3
                  ],
                  [
                    51315.9,
                    29302
                  ],
                  [
                    51533.1,
                    29679.1
                  ],
                  [
                    51300.2,
                    29772.9
                  ],
                  [
                    51017.4,
                    29696
                  ]
                ],
                "id": 221,
                "chat_link": "[&BN0AAAA=]"
              },
              "222": {
                "name": "Jormabakke Stead",
                "level": 24,
                "coord": [
                  51304.6,
                  28552
                ],
                "bounds": [
                  [
                    51085.6,
                    28557.5
                  ],
                  [
                    51198,
                    28395.3
                  ],
                  [
                    51359.2,
                    28373.3
                  ],
                  [
                    51493.5,
                    28484
                  ],
                  [
                    51495.4,
                    28604.3
                  ],
                  [
                    51405.8,
                    28718.4
                  ],
                  [
                    51095,
                    28731.4
                  ],
                  [
                    51085.6,
                    28557.5
                  ]
                ],
                "id": 222,
                "chat_link": "[&BN4AAAA=]"
              },
              "223": {
                "name": "Isenfall Gullies",
                "level": 25,
                "coord": [
                  51274.5,
                  28320
                ],
                "bounds": [
                  [
                    51490.4,
                    28603.2
                  ],
                  [
                    51655.1,
                    28607.1
                  ],
                  [
                    51731,
                    28372.3
                  ],
                  [
                    51469.2,
                    28024
                  ],
                  [
                    51239.7,
                    28080.5
                  ],
                  [
                    51201.5,
                    28131.8
                  ],
                  [
                    50952,
                    28078.2
                  ],
                  [
                    50827.6,
                    28080.5
                  ],
                  [
                    50862.7,
                    28360.8
                  ],
                  [
                    51091.6,
                    28565.8
                  ],
                  [
                    51199,
                    28396
                  ],
                  [
                    51359.6,
                    28377.3
                  ],
                  [
                    51489.7,
                    28482.8
                  ],
                  [
                    51490.4,
                    28603.2
                  ]
                ],
                "id": 223,
                "chat_link": "[&BN8AAAA=]"
              },
              "224": {
                "name": "Darkhoof Heights",
                "level": 25,
                "coord": [
                  51176.4,
                  27940.2
                ],
                "bounds": [
                  [
                    50927.7,
                    27905.4
                  ],
                  [
                    50984.4,
                    27810.3
                  ],
                  [
                    51111.4,
                    27851.6
                  ],
                  [
                    51355.9,
                    27699.8
                  ],
                  [
                    51505.8,
                    27815.2
                  ],
                  [
                    51470.3,
                    28024.7
                  ],
                  [
                    51243.8,
                    28082.2
                  ],
                  [
                    51201.3,
                    28135.3
                  ],
                  [
                    50945.7,
                    28080.1
                  ],
                  [
                    51017.8,
                    27997.8
                  ],
                  [
                    50927.7,
                    27905.4
                  ]
                ],
                "id": 224,
                "chat_link": "[&BOAAAAA=]"
              },
              "226": {
                "name": "Lornar's Gate",
                "level": 22,
                "coord": [
                  51796,
                  29351
                ],
                "bounds": [
                  [
                    51309.3,
                    29301.4
                  ],
                  [
                    51590.7,
                    29307.5
                  ],
                  [
                    51768.4,
                    29222
                  ],
                  [
                    51786.2,
                    29007.7
                  ],
                  [
                    52044.5,
                    29069.3
                  ],
                  [
                    51982.1,
                    29272.8
                  ],
                  [
                    52091.8,
                    29506.2
                  ],
                  [
                    52066.2,
                    29798.1
                  ],
                  [
                    51524.6,
                    29673.9
                  ],
                  [
                    51309.3,
                    29301.4
                  ]
                ],
                "id": 226,
                "chat_link": "[&BOIAAAA=]"
              },
              "227": {
                "name": "Isenfall Lake",
                "level": 22,
                "coord": [
                  51866,
                  28185.4
                ],
                "bounds": [
                  [
                    52056.7,
                    28112.5
                  ],
                  [
                    52192.4,
                    27939.1
                  ],
                  [
                    52158.1,
                    27682.1
                  ],
                  [
                    52018.5,
                    27680.2
                  ],
                  [
                    52007,
                    27762.9
                  ],
                  [
                    51882.5,
                    27826.6
                  ],
                  [
                    51759.7,
                    27663.5
                  ],
                  [
                    51534.6,
                    27724.9
                  ],
                  [
                    51468,
                    28023.3
                  ],
                  [
                    51728.3,
                    28372.5
                  ],
                  [
                    51657.1,
                    28598
                  ],
                  [
                    51642.4,
                    28867.6
                  ],
                  [
                    51791.8,
                    28918.1
                  ],
                  [
                    51884,
                    28754.8
                  ],
                  [
                    52087.8,
                    28630.3
                  ],
                  [
                    51987.1,
                    28409.6
                  ],
                  [
                    52056.7,
                    28112.5
                  ]
                ],
                "id": 227,
                "chat_link": "[&BOMAAAA=]"
              },
              "228": {
                "name": "Hrothgar's Pass",
                "level": 22,
                "coord": [
                  52276,
                  28793.6
                ],
                "bounds": [
                  [
                    52461.1,
                    29023.5
                  ],
                  [
                    52291.1,
                    28967.1
                  ],
                  [
                    52049.6,
                    29069.2
                  ],
                  [
                    51785.3,
                    29008.9
                  ],
                  [
                    51787.1,
                    28915.1
                  ],
                  [
                    51884.2,
                    28755.3
                  ],
                  [
                    52087.1,
                    28629.8
                  ],
                  [
                    52040,
                    28528.3
                  ],
                  [
                    52476.2,
                    28451.5
                  ],
                  [
                    52646.5,
                    28737.1
                  ],
                  [
                    52852.2,
                    28651
                  ],
                  [
                    52950.9,
                    28786
                  ],
                  [
                    52461.1,
                    29023.5
                  ]
                ],
                "id": 228,
                "chat_link": "[&BOQAAAA=]"
              },
              "229": {
                "name": "Valslake",
                "level": 20,
                "coord": [
                  52628.5,
                  29295.9
                ],
                "bounds": [
                  [
                    52046,
                    29069
                  ],
                  [
                    52290.9,
                    28967.9
                  ],
                  [
                    52461.5,
                    29021.2
                  ],
                  [
                    52943.5,
                    28775.7
                  ],
                  [
                    53379.5,
                    29026.6
                  ],
                  [
                    53339,
                    29259.4
                  ],
                  [
                    53165.7,
                    29204.3
                  ],
                  [
                    52922.2,
                    29290
                  ],
                  [
                    52753.9,
                    29461.2
                  ],
                  [
                    52761.7,
                    29690.8
                  ],
                  [
                    52597,
                    29800.6
                  ],
                  [
                    52065.5,
                    29795
                  ],
                  [
                    52090.4,
                    29508.8
                  ],
                  [
                    51982,
                    29272.4
                  ],
                  [
                    52046,
                    29069
                  ]
                ],
                "id": 229,
                "chat_link": "[&BOUAAAA=]"
              },
              "230": {
                "name": "Oros Spurs",
                "level": 20,
                "coord": [
                  52333.9,
                  28115.7
                ],
                "bounds": [
                  [
                    52524.6,
                    28274.1
                  ],
                  [
                    52475.6,
                    28455
                  ],
                  [
                    52041.8,
                    28531.1
                  ],
                  [
                    51980.2,
                    28413.9
                  ],
                  [
                    52059,
                    28129.5
                  ],
                  [
                    52190.8,
                    27938.2
                  ],
                  [
                    52154.5,
                    27753.4
                  ],
                  [
                    52580.3,
                    27761.2
                  ],
                  [
                    52651.4,
                    27810.8
                  ],
                  [
                    52681.1,
                    28089.8
                  ],
                  [
                    52524.6,
                    28274.1
                  ]
                ],
                "id": 230,
                "chat_link": "[&BOYAAAA=]"
              },
              "231": {
                "name": "Vitpeln Hills",
                "level": 19,
                "coord": [
                  52872.5,
                  28413.4
                ],
                "bounds": [
                  [
                    53234.1,
                    28282.1
                  ],
                  [
                    53063.5,
                    28348
                  ],
                  [
                    52677,
                    28090.3
                  ],
                  [
                    52520.9,
                    28280.2
                  ],
                  [
                    52472.8,
                    28459.1
                  ],
                  [
                    52648.6,
                    28748.4
                  ],
                  [
                    53139.6,
                    28551.3
                  ],
                  [
                    53223.4,
                    28547.6
                  ],
                  [
                    53234.1,
                    28282.1
                  ]
                ],
                "id": 231,
                "chat_link": "[&BOcAAAA=]"
              },
              "232": {
                "name": "The Loneholme Range",
                "level": 17,
                "coord": [
                  52968.4,
                  27819.3
                ],
                "bounds": [
                  [
                    53148.6,
                    28078.7
                  ],
                  [
                    53284.8,
                    27774.5
                  ],
                  [
                    53164.9,
                    27568.5
                  ],
                  [
                    53112.1,
                    27613.9
                  ],
                  [
                    53024.1,
                    27651.3
                  ],
                  [
                    52921.9,
                    27681.2
                  ],
                  [
                    52824.8,
                    27691.5
                  ],
                  [
                    52642.7,
                    27809.9
                  ],
                  [
                    52677.1,
                    28091.6
                  ],
                  [
                    52883.3,
                    28231.6
                  ],
                  [
                    53148.6,
                    28078.7
                  ]
                ],
                "id": 232,
                "chat_link": "[&BOgAAAA=]"
              },
              "233": {
                "name": "Dragon's Rising",
                "level": 17,
                "coord": [
                  53362.2,
                  27751.4
                ],
                "bounds": [
                  [
                    53144.6,
                    28077.2
                  ],
                  [
                    53276,
                    27769.9
                  ],
                  [
                    53168.8,
                    27582.6
                  ],
                  [
                    53288.3,
                    27507.5
                  ],
                  [
                    53379,
                    27427.9
                  ],
                  [
                    53455,
                    27368.8
                  ],
                  [
                    53505.8,
                    27394.9
                  ],
                  [
                    53551.9,
                    27441.7
                  ],
                  [
                    53626.5,
                    27638.3
                  ],
                  [
                    53610.2,
                    27882.2
                  ],
                  [
                    53758.8,
                    28104.7
                  ],
                  [
                    53063.7,
                    28341.5
                  ],
                  [
                    52880.6,
                    28231.1
                  ],
                  [
                    53144.6,
                    28077.2
                  ]
                ],
                "id": 233,
                "chat_link": "[&BOkAAAA=]"
              },
              "234": {
                "name": "Jotun's Vista",
                "level": 18,
                "coord": [
                  53168.8,
                  28722.5
                ],
                "bounds": [
                  [
                    53502.1,
                    28776.6
                  ],
                  [
                    53222.8,
                    28538.7
                  ],
                  [
                    53142.3,
                    28545.6
                  ],
                  [
                    52833.2,
                    28659.9
                  ],
                  [
                    52935.4,
                    28786.6
                  ],
                  [
                    53376.8,
                    29027.5
                  ],
                  [
                    53502.1,
                    28776.6
                  ]
                ],
                "id": 234,
                "chat_link": "[&BOoAAAA=]"
              },
              "235": {
                "name": "Tromigar Valley",
                "level": 16,
                "coord": [
                  53857.4,
                  28354.8
                ],
                "bounds": [
                  [
                    53223.5,
                    28540.5
                  ],
                  [
                    53502.7,
                    28777.5
                  ],
                  [
                    53731.9,
                    28686.5
                  ],
                  [
                    54221.6,
                    28613.8
                  ],
                  [
                    54347.1,
                    28374
                  ],
                  [
                    54174.5,
                    28332.3
                  ],
                  [
                    54192.2,
                    28198.6
                  ],
                  [
                    54103.2,
                    28008.7
                  ],
                  [
                    53942.8,
                    27993.1
                  ],
                  [
                    53755.8,
                    28101
                  ],
                  [
                    53235.7,
                    28277
                  ],
                  [
                    53223.5,
                    28540.5
                  ]
                ],
                "id": 235,
                "chat_link": "[&BOsAAAA=]"
              },
              "236": {
                "name": "Song of Final Exile",
                "level": 20,
                "coord": [
                  53053.8,
                  29466.9
                ],
                "bounds": [
                  [
                    53166.5,
                    29202.5
                  ],
                  [
                    53343.4,
                    29256
                  ],
                  [
                    53188.9,
                    29562.9
                  ],
                  [
                    53242.6,
                    29819.5
                  ],
                  [
                    52759.6,
                    29689.7
                  ],
                  [
                    52756.3,
                    29447.7
                  ],
                  [
                    52919.3,
                    29289.7
                  ],
                  [
                    53166.5,
                    29202.5
                  ]
                ],
                "id": 236,
                "chat_link": "[&BOwAAAA=]"
              },
              "237": {
                "name": "Griffonfall",
                "level": 18,
                "coord": [
                  53563.9,
                  29459.6
                ],
                "bounds": [
                  [
                    53340.5,
                    29254.3
                  ],
                  [
                    53188,
                    29561.8
                  ],
                  [
                    53222.1,
                    29798.9
                  ],
                  [
                    53753.4,
                    29685.5
                  ],
                  [
                    53743.1,
                    29525
                  ],
                  [
                    53847.4,
                    29387.9
                  ],
                  [
                    53818.2,
                    29192.7
                  ],
                  [
                    53598.3,
                    29270.8
                  ],
                  [
                    53340.5,
                    29254.3
                  ]
                ],
                "id": 237,
                "chat_link": "[&BO0AAAA=]"
              },
              "238": {
                "name": "Reaver's Dale",
                "level": 18,
                "coord": [
                  53702.8,
                  29005.9
                ],
                "bounds": [
                  [
                    53493.4,
                    28768.2
                  ],
                  [
                    53725.8,
                    28680.7
                  ],
                  [
                    53803.3,
                    28806.9
                  ],
                  [
                    54159.2,
                    28947.5
                  ],
                  [
                    54014.3,
                    29093
                  ],
                  [
                    53817.9,
                    29195.6
                  ],
                  [
                    53596.5,
                    29277.4
                  ],
                  [
                    53340.3,
                    29256.5
                  ],
                  [
                    53374.8,
                    29027.7
                  ],
                  [
                    53493.4,
                    28768.2
                  ]
                ],
                "id": 238,
                "chat_link": "[&BO4AAAA=]"
              },
              "239": {
                "name": "Owl's Abattoir",
                "level": 19,
                "coord": [
                  54161.3,
                  29313.7
                ],
                "bounds": [
                  [
                    53742.3,
                    29524.6
                  ],
                  [
                    53749.2,
                    29690
                  ],
                  [
                    54265,
                    29883.3
                  ],
                  [
                    54580,
                    29724.4
                  ],
                  [
                    54697.2,
                    29253.6
                  ],
                  [
                    54576.5,
                    28623.7
                  ],
                  [
                    54322.5,
                    28764.6
                  ],
                  [
                    54014.1,
                    29092.3
                  ],
                  [
                    53817.4,
                    29192
                  ],
                  [
                    53848.6,
                    29388.1
                  ],
                  [
                    53742.3,
                    29524.6
                  ]
                ],
                "id": 239,
                "chat_link": "[&BO8AAAA=]"
              },
              "240": {
                "name": "Villmark Foothills",
                "level": 17,
                "coord": [
                  54043,
                  28764.2
                ],
                "bounds": [
                  [
                    54216.1,
                    28608.4
                  ],
                  [
                    54322.1,
                    28765.2
                  ],
                  [
                    54158.2,
                    28947.5
                  ],
                  [
                    53798.2,
                    28815.9
                  ],
                  [
                    53720.7,
                    28684.2
                  ],
                  [
                    54216.1,
                    28608.4
                  ]
                ],
                "id": 240,
                "chat_link": "[&BPAAAAA=]"
              },
              "241": {
                "name": "Hunter's Pitfalls",
                "level": 15,
                "coord": [
                  54406.9,
                  28026.6
                ],
                "bounds": [
                  [
                    54102.5,
                    28007.9
                  ],
                  [
                    54189.7,
                    28199.2
                  ],
                  [
                    54169.1,
                    28336.2
                  ],
                  [
                    54348.5,
                    28378.4
                  ],
                  [
                    54426.1,
                    28230.8
                  ],
                  [
                    54516.1,
                    28249.2
                  ],
                  [
                    54562.2,
                    28063.3
                  ],
                  [
                    54647.6,
                    27983.4
                  ],
                  [
                    54650,
                    27857.8
                  ],
                  [
                    54567.7,
                    27772.9
                  ],
                  [
                    54543.9,
                    27589.7
                  ],
                  [
                    54159.4,
                    27650.3
                  ],
                  [
                    54102.5,
                    28007.9
                  ]
                ],
                "id": 241,
                "chat_link": "[&BPEAAAA=]"
              },
              "242": {
                "name": "Trapper's Labyrinth",
                "level": 16,
                "coord": [
                  53848.1,
                  27821.1
                ],
                "bounds": [
                  [
                    53760.4,
                    28107.7
                  ],
                  [
                    53608.6,
                    27881.3
                  ],
                  [
                    53620.9,
                    27630.3
                  ],
                  [
                    53721.9,
                    27648
                  ],
                  [
                    53869.9,
                    27648
                  ],
                  [
                    54158.6,
                    27648.9
                  ],
                  [
                    54103.4,
                    28008.4
                  ],
                  [
                    53941,
                    27996.1
                  ],
                  [
                    53760.4,
                    28107.7
                  ]
                ],
                "id": 242,
                "chat_link": "[&BPIAAAA=]"
              },
              "340": {
                "name": "Ossencrest Climb",
                "level": 24,
                "coord": [
                  50616.3,
                  28310.2
                ],
                "bounds": [
                  [
                    50831.9,
                    28081.4
                  ],
                  [
                    50863.9,
                    28360.4
                  ],
                  [
                    50975.1,
                    28448.4
                  ],
                  [
                    50815,
                    28662.7
                  ],
                  [
                    50437.8,
                    28689.8
                  ],
                  [
                    50391,
                    28581.7
                  ],
                  [
                    50345,
                    28432.8
                  ],
                  [
                    50563.5,
                    28307.7
                  ],
                  [
                    50592,
                    28226.8
                  ],
                  [
                    50502.6,
                    28169
                  ],
                  [
                    50437.7,
                    28069.6
                  ],
                  [
                    50536.8,
                    27993.4
                  ],
                  [
                    50719.1,
                    28009.4
                  ],
                  [
                    50831.9,
                    28081.4
                  ]
                ],
                "id": 340,
                "chat_link": "[&BFQBAAA=]"
              },
              "1015": {
                "name": "King Jalis's Refuge",
                "level": 19,
                "coord": [
                  54441.8,
                  28495.8
                ],
                "bounds": [
                  [
                    54211.1,
                    28608.1
                  ],
                  [
                    54422.3,
                    28226.1
                  ],
                  [
                    54568.6,
                    28258.2
                  ],
                  [
                    54629.5,
                    28445.2
                  ],
                  [
                    54497.3,
                    28671.9
                  ],
                  [
                    54322.1,
                    28765.2
                  ],
                  [
                    54211.1,
                    28608.1
                  ]
                ],
                "id": 1015,
                "chat_link": "[&BPcDAAA=]"
              },
              "1106": {
                "name": "Angvar's Trove",
                "level": 0,
                "coord": [
                  50749.6,
                  27947.3
                ],
                "bounds": [
                  [
                    50593.2,
                    28225.8
                  ],
                  [
                    50562.2,
                    28313.3
                  ],
                  [
                    50346.7,
                    28220.2
                  ],
                  [
                    50265.4,
                    28037.3
                  ],
                  [
                    50282.2,
                    27608.1
                  ],
                  [
                    50698.1,
                    27415.3
                  ],
                  [
                    51340.7,
                    27543
                  ],
                  [
                    51357.3,
                    27705.4
                  ],
                  [
                    51114.3,
                    27856.9
                  ],
                  [
                    50984.3,
                    27820.7
                  ],
                  [
                    50933.5,
                    27906.5
                  ],
                  [
                    51021.9,
                    27998.5
                  ],
                  [
                    50952.6,
                    28069.6
                  ],
                  [
                    50833.9,
                    28083.8
                  ],
                  [
                    50721.5,
                    28012.2
                  ],
                  [
                    50538.3,
                    27996
                  ],
                  [
                    50439.8,
                    28070.5
                  ],
                  [
                    50506.7,
                    28167.9
                  ],
                  [
                    50593.2,
                    28225.8
                  ]
                ],
                "id": 1106,
                "chat_link": "[&BFIEAAA=]"
              }
            },
            "adventures": [],
            "id": 31,
            "mastery_points": []
          },
          "326": {
            "name": "Hoelbrak",
            "min_level": 0,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "881": {
                "name": "Courage Brewery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53009.3,
                  30196.3
                ],
                "id": 881,
                "chat_link": "[&BHEDAAA=]"
              },
              "882": {
                "name": "Fang of the Serpent",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53427.9,
                  31108.1
                ],
                "id": 882,
                "chat_link": "[&BHIDAAA=]"
              },
              "883": {
                "name": "Brawler's Bout",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53790.2,
                  30450.2
                ],
                "id": 883,
                "chat_link": "[&BHMDAAA=]"
              },
              "884": {
                "name": "The Great Rise",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53592.5,
                  30802.5
                ],
                "id": 884,
                "chat_link": "[&BHQDAAA=]"
              },
              "885": {
                "name": "Skarti's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54432.4,
                  30363.5
                ],
                "id": 885,
                "chat_link": "[&BHUDAAA=]"
              },
              "886": {
                "name": "Stonewright's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54015.6,
                  31159.6
                ],
                "id": 886,
                "chat_link": "[&BHYDAAA=]"
              },
              "887": {
                "name": "Sigfast's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53930.2,
                  29788.7
                ],
                "id": 887,
                "chat_link": "[&BHcDAAA=]"
              },
              "888": {
                "name": "Master Blackforge's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54378.9,
                  29844.9
                ],
                "id": 888,
                "chat_link": "[&BHgDAAA=]"
              },
              "889": {
                "name": "Old Fiach's Lorestead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54293.4,
                  31219.7
                ],
                "id": 889,
                "chat_link": "[&BHkDAAA=]"
              },
              "890": {
                "name": "Boasting Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54425.9,
                  31010.8
                ],
                "id": 890,
                "chat_link": "[&BHoDAAA=]"
              },
              "891": {
                "name": "Hrothbeir's Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52903.8,
                  30404.8
                ],
                "id": 891,
                "chat_link": "[&BHsDAAA=]"
              },
              "892": {
                "name": "Vheratha's Tavern",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54217.6,
                  30534.3
                ],
                "id": 892,
                "chat_link": "[&BHwDAAA=]"
              },
              "893": {
                "name": "Priory Encampment",
                "type": "landmark",
                "floor": 2,
                "coord": [
                  53308.7,
                  30792.3
                ],
                "id": 893,
                "chat_link": "[&BH0DAAA=]"
              },
              "894": {
                "name": "Dragon Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53310.8,
                  29861.1
                ],
                "id": 894,
                "chat_link": "[&BH4DAAA=]"
              },
              "895": {
                "name": "Vigil Billet",
                "type": "landmark",
                "floor": 2,
                "coord": [
                  53731.9,
                  30961.6
                ],
                "id": 895,
                "chat_link": "[&BH8DAAA=]"
              },
              "896": {
                "name": "Lost Spirits' Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54352.3,
                  30685.1
                ],
                "id": 896,
                "chat_link": "[&BIADAAA=]"
              },
              "897": {
                "name": "Bear Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54244.3,
                  30241.8
                ],
                "id": 897,
                "chat_link": "[&BIEDAAA=]"
              },
              "898": {
                "name": "Wolf Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54109.6,
                  30793.7
                ],
                "id": 898,
                "chat_link": "[&BIIDAAA=]"
              },
              "899": {
                "name": "Raven Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53711.2,
                  30026.5
                ],
                "id": 899,
                "chat_link": "[&BIMDAAA=]"
              },
              "900": {
                "name": "Snow Leopard Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53270.9,
                  30335.7
                ],
                "id": 900,
                "chat_link": "[&BIQDAAA=]"
              },
              "901": {
                "name": "Might and Main Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53776.2,
                  30500.3
                ],
                "id": 901,
                "chat_link": "[&BIUDAAA=]"
              },
              "902": {
                "name": "Trade Commons Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53676.8,
                  30665
                ],
                "id": 902,
                "chat_link": "[&BIYDAAA=]"
              },
              "903": {
                "name": "Snow Leopard Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53455.7,
                  30395.9
                ],
                "id": 903,
                "chat_link": "[&BIcDAAA=]"
              },
              "904": {
                "name": "Raven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53794,
                  30172.8
                ],
                "id": 904,
                "chat_link": "[&BIgDAAA=]"
              },
              "905": {
                "name": "Bear Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54089.7,
                  30286.9
                ],
                "id": 905,
                "chat_link": "[&BIkDAAA=]"
              },
              "906": {
                "name": "Wolf Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54035.5,
                  30693.3
                ],
                "id": 906,
                "chat_link": "[&BIoDAAA=]"
              },
              "907": {
                "name": "Shelter Rock Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54270.7,
                  30009.9
                ],
                "id": 907,
                "chat_link": "[&BIsDAAA=]"
              },
              "908": {
                "name": "Legends Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54262.6,
                  30542.3
                ],
                "id": 908,
                "chat_link": "[&BIwDAAA=]"
              },
              "909": {
                "name": "Eastern Watchpost Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54174,
                  30922.2
                ],
                "id": 909,
                "chat_link": "[&BI0DAAA=]"
              },
              "910": {
                "name": "Southern Watchpost Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53839.8,
                  31018.3
                ],
                "id": 910,
                "chat_link": "[&BI4DAAA=]"
              },
              "911": {
                "name": "Peeta's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53314,
                  30660.6
                ],
                "id": 911,
                "chat_link": "[&BI8DAAA=]"
              },
              "912": {
                "name": "Hero's Compass Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53048.7,
                  30340
                ],
                "id": 912,
                "chat_link": "[&BJADAAA=]"
              },
              "981": {
                "name": "Great Lodge Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53493.1,
                  30988.7
                ],
                "id": 981,
                "chat_link": "[&BNUDAAA=]"
              },
              "1136": {
                "name": "Bilrost Gallery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53993.7,
                  30872.9
                ],
                "id": 1136,
                "chat_link": "[&BHAEAAA=]"
              },
              "1263": {
                "name": "Raven Hearth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53823.9,
                  30015.7
                ],
                "id": 1263,
                "chat_link": "[&BO8EAAA=]"
              },
              "1288": {
                "name": "Upper Balcony Waypoint",
                "type": "waypoint",
                "floor": 2,
                "coord": [
                  53655.5,
                  30804.9
                ],
                "id": 1288,
                "chat_link": "[&BAgFAAA=]"
              },
              "1444": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  52710.3,
                  30523.5
                ],
                "id": 1444,
                "chat_link": "[&BKQFAAA=]"
              },
              "1445": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  54080.3,
                  30393
                ],
                "id": 1445,
                "chat_link": "[&BKUFAAA=]"
              },
              "1446": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  54155.6,
                  30981.6
                ],
                "id": 1446,
                "chat_link": "[&BKYFAAA=]"
              },
              "1447": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  53860.1,
                  30898.7
                ],
                "id": 1447,
                "chat_link": "[&BKcFAAA=]"
              },
              "1453": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  53513.5,
                  30198.5
                ],
                "id": 1453,
                "chat_link": "[&BK0FAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "792": {
                "name": "Hero's Compass",
                "level": 0,
                "coord": [
                  53118.5,
                  30439
                ],
                "bounds": [
                  [
                    53200.9,
                    30414.3
                  ],
                  [
                    53238.6,
                    30489.4
                  ],
                  [
                    53208,
                    30523.5
                  ],
                  [
                    53133,
                    30562.9
                  ],
                  [
                    52949.8,
                    30525.6
                  ],
                  [
                    53001.1,
                    30355
                  ],
                  [
                    53027.8,
                    30317.6
                  ],
                  [
                    53189,
                    30324
                  ],
                  [
                    53200.9,
                    30414.3
                  ]
                ],
                "id": 792,
                "chat_link": "[&BBgDAAA=]"
              },
              "793": {
                "name": "Bear Lodge",
                "level": 0,
                "coord": [
                  54195.2,
                  30266.4
                ],
                "bounds": [
                  [
                    54067.7,
                    30150.8
                  ],
                  [
                    54123.2,
                    30117.7
                  ],
                  [
                    54211.9,
                    30112.2
                  ],
                  [
                    54277.1,
                    30154.2
                  ],
                  [
                    54326.4,
                    30215
                  ],
                  [
                    54321.7,
                    30303.8
                  ],
                  [
                    54300.7,
                    30367.7
                  ],
                  [
                    54253.4,
                    30416.1
                  ],
                  [
                    54184.2,
                    30431
                  ],
                  [
                    54146.1,
                    30326
                  ],
                  [
                    54120.3,
                    30336.1
                  ],
                  [
                    54088.1,
                    30274.3
                  ],
                  [
                    54116.7,
                    30258.5
                  ],
                  [
                    54067.7,
                    30150.8
                  ]
                ],
                "id": 793,
                "chat_link": "[&BBkDAAA=]"
              },
              "794": {
                "name": "Biergarten",
                "level": 0,
                "coord": [
                  52885.1,
                  29973.1
                ],
                "bounds": [
                  [
                    52954.8,
                    30266.8
                  ],
                  [
                    52823.2,
                    30029.2
                  ],
                  [
                    52550.5,
                    29746.8
                  ],
                  [
                    52749.6,
                    29664.4
                  ],
                  [
                    52965,
                    29722.3
                  ],
                  [
                    53101.3,
                    30146.4
                  ],
                  [
                    53051.2,
                    30235.8
                  ],
                  [
                    52954.8,
                    30266.8
                  ]
                ],
                "id": 794,
                "chat_link": "[&BBoDAAA=]"
              },
              "795": {
                "name": "Eastern Watchpost",
                "level": 0,
                "coord": [
                  54220.2,
                  30823.3
                ],
                "bounds": [
                  [
                    54065.2,
                    31012.4
                  ],
                  [
                    54049.9,
                    30857.8
                  ],
                  [
                    54084.5,
                    30857.3
                  ],
                  [
                    54141,
                    30830.4
                  ],
                  [
                    54175.2,
                    30775
                  ],
                  [
                    54177.1,
                    30718.9
                  ],
                  [
                    54146.4,
                    30666.4
                  ],
                  [
                    54259.5,
                    30735.1
                  ],
                  [
                    54556.9,
                    30713.3
                  ],
                  [
                    54553.5,
                    30960.8
                  ],
                  [
                    54213.4,
                    30929.2
                  ],
                  [
                    54065.2,
                    31012.4
                  ]
                ],
                "id": 795,
                "chat_link": "[&BBsDAAA=]"
              },
              "796": {
                "name": "Trade Commons",
                "level": 0,
                "coord": [
                  53545,
                  30860
                ],
                "bounds": [
                  [
                    53777.4,
                    31044.9
                  ],
                  [
                    53744.2,
                    31105.4
                  ],
                  [
                    53549.6,
                    30993.1
                  ],
                  [
                    53574.2,
                    30944.8
                  ],
                  [
                    53482.7,
                    30899.5
                  ],
                  [
                    53457.6,
                    30943.2
                  ],
                  [
                    53315.2,
                    30873.4
                  ],
                  [
                    53284.4,
                    30889.4
                  ],
                  [
                    53177.6,
                    30933
                  ],
                  [
                    53399.4,
                    30596.8
                  ],
                  [
                    53542,
                    30599.2
                  ],
                  [
                    53673.8,
                    30648.3
                  ],
                  [
                    53784.7,
                    30727.3
                  ],
                  [
                    53867.6,
                    30841.1
                  ],
                  [
                    53777.4,
                    31044.9
                  ]
                ],
                "id": 796,
                "chat_link": "[&BBwDAAA=]"
              },
              "797": {
                "name": "Might and Main",
                "level": 0,
                "coord": [
                  53821.1,
                  30398.4
                ],
                "bounds": [
                  [
                    54184.5,
                    30431.1
                  ],
                  [
                    54144.6,
                    30443.3
                  ],
                  [
                    54087.9,
                    30559.6
                  ],
                  [
                    54131.3,
                    30597.5
                  ],
                  [
                    54118.8,
                    30657.7
                  ],
                  [
                    54062.4,
                    30699.1
                  ],
                  [
                    54048.6,
                    30691.1
                  ],
                  [
                    54011.9,
                    30722.8
                  ],
                  [
                    54019.3,
                    30734.2
                  ],
                  [
                    53976,
                    30783.2
                  ],
                  [
                    53964.2,
                    30822.1
                  ],
                  [
                    53866.7,
                    30845.7
                  ],
                  [
                    53780.8,
                    30722
                  ],
                  [
                    53675.4,
                    30645.9
                  ],
                  [
                    53542.9,
                    30597.3
                  ],
                  [
                    53466,
                    30601.3
                  ],
                  [
                    53491.2,
                    30526.9
                  ],
                  [
                    53389,
                    30508.3
                  ],
                  [
                    53410.7,
                    30402.4
                  ],
                  [
                    53442.6,
                    30404.5
                  ],
                  [
                    53455.2,
                    30336.2
                  ],
                  [
                    53419.3,
                    30328.2
                  ],
                  [
                    53440.7,
                    30219.1
                  ],
                  [
                    53456.4,
                    30174.3
                  ],
                  [
                    53598.6,
                    30065.5
                  ],
                  [
                    53610.4,
                    30111.6
                  ],
                  [
                    53629.4,
                    30140.5
                  ],
                  [
                    53738.1,
                    30136
                  ],
                  [
                    53741.5,
                    30163.8
                  ],
                  [
                    53806.2,
                    30155.6
                  ],
                  [
                    53802.3,
                    30121.3
                  ],
                  [
                    53921.6,
                    30116.4
                  ],
                  [
                    53938,
                    30081.4
                  ],
                  [
                    53940.4,
                    30044.5
                  ],
                  [
                    53999.2,
                    30027.4
                  ],
                  [
                    54058.5,
                    30125.7
                  ],
                  [
                    54116.7,
                    30258.5
                  ],
                  [
                    54088.1,
                    30273.8
                  ],
                  [
                    54120.6,
                    30336
                  ],
                  [
                    54145.9,
                    30326.2
                  ],
                  [
                    54184.5,
                    30431.1
                  ]
                ],
                "id": 797,
                "chat_link": "[&BB0DAAA=]"
              },
              "798": {
                "name": "The Great Lodge",
                "level": 0,
                "coord": [
                  53465.6,
                  31103.7
                ],
                "bounds": [
                  [
                    53691,
                    31069.9
                  ],
                  [
                    53750.3,
                    31112.7
                  ],
                  [
                    53698.6,
                    31247.4
                  ],
                  [
                    53703.5,
                    31364.2
                  ],
                  [
                    53437.6,
                    31414.9
                  ],
                  [
                    53121.8,
                    31375.4
                  ],
                  [
                    53084.2,
                    31183.7
                  ],
                  [
                    53179,
                    30929.1
                  ],
                  [
                    53317.2,
                    30872.5
                  ],
                  [
                    53460.8,
                    30942.7
                  ],
                  [
                    53483.3,
                    30897.3
                  ],
                  [
                    53576.1,
                    30944.3
                  ],
                  [
                    53549.3,
                    30994.4
                  ],
                  [
                    53691,
                    31069.9
                  ]
                ],
                "id": 798,
                "chat_link": "[&BB4DAAA=]"
              },
              "799": {
                "name": "Lake Mourn",
                "level": 0,
                "coord": [
                  52746.6,
                  30556.8
                ],
                "bounds": [
                  [
                    52825.3,
                    30025
                  ],
                  [
                    52957,
                    30262.5
                  ],
                  [
                    52986.9,
                    30257.1
                  ],
                  [
                    53026.8,
                    30324.9
                  ],
                  [
                    53003.8,
                    30353.8
                  ],
                  [
                    52951.8,
                    30526.7
                  ],
                  [
                    53134,
                    30558.6
                  ],
                  [
                    53168.1,
                    30540.1
                  ],
                  [
                    53180.2,
                    30817.5
                  ],
                  [
                    53183.7,
                    30931
                  ],
                  [
                    53088.9,
                    31179.1
                  ],
                  [
                    53122.6,
                    31361.8
                  ],
                  [
                    52895.6,
                    31373.6
                  ],
                  [
                    52599.8,
                    31381.4
                  ],
                  [
                    52370.6,
                    31304.6
                  ],
                  [
                    52205.1,
                    31122.9
                  ],
                  [
                    52143.3,
                    30810.2
                  ],
                  [
                    52149.5,
                    30123.1
                  ],
                  [
                    52199,
                    29885.4
                  ],
                  [
                    52262.2,
                    29700.7
                  ],
                  [
                    52417.5,
                    29665.4
                  ],
                  [
                    52552.8,
                    29745
                  ],
                  [
                    52825.3,
                    30025
                  ]
                ],
                "id": 799,
                "chat_link": "[&BB8DAAA=]"
              },
              "800": {
                "name": "Mourn's Tears",
                "level": 0,
                "coord": [
                  53121.2,
                  30237.6
                ],
                "bounds": [
                  [
                    53020.5,
                    30317.9
                  ],
                  [
                    52983.9,
                    30256
                  ],
                  [
                    53049.3,
                    30235.4
                  ],
                  [
                    53095.3,
                    30152.8
                  ],
                  [
                    53179.1,
                    30129.4
                  ],
                  [
                    53233.1,
                    30236.8
                  ],
                  [
                    53218.5,
                    30246.4
                  ],
                  [
                    53190.2,
                    30326.3
                  ],
                  [
                    53020.5,
                    30317.9
                  ]
                ],
                "id": 800,
                "chat_link": "[&BCADAAA=]"
              },
              "801": {
                "name": "Veins of the Dragon",
                "level": 0,
                "coord": [
                  53332.3,
                  30070.5
                ],
                "bounds": [
                  [
                    52958.9,
                    29726.7
                  ],
                  [
                    53438.5,
                    29695.9
                  ],
                  [
                    53592.5,
                    30001.4
                  ],
                  [
                    53599.1,
                    30066
                  ],
                  [
                    53456.5,
                    30173.8
                  ],
                  [
                    53439.1,
                    30218.4
                  ],
                  [
                    53364.8,
                    30184.7
                  ],
                  [
                    53292.7,
                    30195.4
                  ],
                  [
                    53233.2,
                    30236.7
                  ],
                  [
                    53179.4,
                    30129.1
                  ],
                  [
                    53100.6,
                    30147.1
                  ],
                  [
                    52958.9,
                    29726.7
                  ]
                ],
                "id": 801,
                "chat_link": "[&BCEDAAA=]"
              },
              "802": {
                "name": "Snow Leopard Lodge",
                "level": 0,
                "coord": [
                  53336.2,
                  30352.3
                ],
                "bounds": [
                  [
                    53390.2,
                    30508.7
                  ],
                  [
                    53308.7,
                    30516.7
                  ],
                  [
                    53239.7,
                    30490.3
                  ],
                  [
                    53202.7,
                    30414.9
                  ],
                  [
                    53186.8,
                    30330.5
                  ],
                  [
                    53215.3,
                    30248.3
                  ],
                  [
                    53292.8,
                    30195.4
                  ],
                  [
                    53364.9,
                    30185.2
                  ],
                  [
                    53440,
                    30219.1
                  ],
                  [
                    53419.5,
                    30328.2
                  ],
                  [
                    53456.7,
                    30335.7
                  ],
                  [
                    53442.2,
                    30404
                  ],
                  [
                    53410.6,
                    30402.5
                  ],
                  [
                    53390.2,
                    30508.7
                  ]
                ],
                "id": 802,
                "chat_link": "[&BCIDAAA=]"
              },
              "803": {
                "name": "Raven Lodge",
                "level": 0,
                "coord": [
                  53760.4,
                  30016.1
                ],
                "bounds": [
                  [
                    53629.3,
                    30140.8
                  ],
                  [
                    53610.8,
                    30110.9
                  ],
                  [
                    53598.9,
                    30066.2
                  ],
                  [
                    53592.4,
                    30001.3
                  ],
                  [
                    53437.7,
                    29695.9
                  ],
                  [
                    53862.7,
                    29696.9
                  ],
                  [
                    53875.9,
                    29808.2
                  ],
                  [
                    53912.2,
                    29903.6
                  ],
                  [
                    53940.8,
                    30044.9
                  ],
                  [
                    53937.9,
                    30080.9
                  ],
                  [
                    53922,
                    30115.5
                  ],
                  [
                    53802.1,
                    30121.5
                  ],
                  [
                    53805.2,
                    30155.1
                  ],
                  [
                    53741.5,
                    30163.4
                  ],
                  [
                    53737,
                    30135.7
                  ],
                  [
                    53629.3,
                    30140.8
                  ]
                ],
                "id": 803,
                "chat_link": "[&BCMDAAA=]"
              },
              "804": {
                "name": "Shelter Rock",
                "level": 0,
                "coord": [
                  54181.9,
                  30096.9
                ],
                "bounds": [
                  [
                    54283.8,
                    30384.9
                  ],
                  [
                    54299.8,
                    30366
                  ],
                  [
                    54319.8,
                    30301.8
                  ],
                  [
                    54322.8,
                    30214.7
                  ],
                  [
                    54274.8,
                    30154.9
                  ],
                  [
                    54213.2,
                    30114.2
                  ],
                  [
                    54121.4,
                    30119.6
                  ],
                  [
                    54066.8,
                    30152
                  ],
                  [
                    54057.1,
                    30125.5
                  ],
                  [
                    53999.5,
                    30027.6
                  ],
                  [
                    53941,
                    30044.1
                  ],
                  [
                    53912.8,
                    29903.5
                  ],
                  [
                    53876.7,
                    29807.5
                  ],
                  [
                    53862.9,
                    29696.7
                  ],
                  [
                    54282.5,
                    29687
                  ],
                  [
                    54538.2,
                    29685.8
                  ],
                  [
                    54553.6,
                    30480.7
                  ],
                  [
                    54347,
                    30478.5
                  ],
                  [
                    54283.8,
                    30384.9
                  ]
                ],
                "id": 804,
                "chat_link": "[&BCQDAAA=]"
              },
              "805": {
                "name": "Frost Basin",
                "level": 0,
                "coord": [
                  54220.9,
                  31207.1
                ],
                "bounds": [
                  [
                    53878,
                    31116.3
                  ],
                  [
                    54211.6,
                    30928.4
                  ],
                  [
                    54549.9,
                    30961
                  ],
                  [
                    54551.5,
                    31357.6
                  ],
                  [
                    54329.2,
                    31369.1
                  ],
                  [
                    54144.6,
                    31355.4
                  ],
                  [
                    53881.3,
                    31362.3
                  ],
                  [
                    53878,
                    31116.3
                  ]
                ],
                "id": 805,
                "chat_link": "[&BCUDAAA=]"
              },
              "806": {
                "name": "Southern Watchpost",
                "level": 0,
                "coord": [
                  53863.6,
                  31109.2
                ],
                "bounds": [
                  [
                    53970.8,
                    30825
                  ],
                  [
                    54019.1,
                    30855.8
                  ],
                  [
                    54054.5,
                    30856.9
                  ],
                  [
                    54066.3,
                    31009.8
                  ],
                  [
                    53878.6,
                    31118.3
                  ],
                  [
                    53882.9,
                    31353
                  ],
                  [
                    53789.4,
                    31353.5
                  ],
                  [
                    53780.4,
                    31395.1
                  ],
                  [
                    53700.3,
                    31400.8
                  ],
                  [
                    53694.4,
                    31244.7
                  ],
                  [
                    53747.4,
                    31112
                  ],
                  [
                    53777.3,
                    31044.5
                  ],
                  [
                    53866.1,
                    30850.6
                  ],
                  [
                    53970.8,
                    30825
                  ]
                ],
                "id": 806,
                "chat_link": "[&BCYDAAA=]"
              },
              "807": {
                "name": "Wolf Lodge",
                "level": 0,
                "coord": [
                  54072.5,
                  30755.5
                ],
                "bounds": [
                  [
                    54150.9,
                    30668.4
                  ],
                  [
                    54179.7,
                    30720.1
                  ],
                  [
                    54176.3,
                    30777
                  ],
                  [
                    54140.5,
                    30833.3
                  ],
                  [
                    54084.3,
                    30859.5
                  ],
                  [
                    54016,
                    30858.1
                  ],
                  [
                    53964,
                    30821.9
                  ],
                  [
                    53971.3,
                    30782.5
                  ],
                  [
                    54019.5,
                    30734.2
                  ],
                  [
                    54009.3,
                    30722.7
                  ],
                  [
                    54049.6,
                    30687.4
                  ],
                  [
                    54061.8,
                    30698.5
                  ],
                  [
                    54119.8,
                    30658.1
                  ],
                  [
                    54150.9,
                    30668.4
                  ]
                ],
                "id": 807,
                "chat_link": "[&BCcDAAA=]"
              },
              "808": {
                "name": "Hall of Legends",
                "level": 0,
                "coord": [
                  54254.9,
                  30547.7
                ],
                "bounds": [
                  [
                    54139.7,
                    30440.5
                  ],
                  [
                    54185.4,
                    30432.1
                  ],
                  [
                    54253.6,
                    30414
                  ],
                  [
                    54284.5,
                    30384.2
                  ],
                  [
                    54346,
                    30479.7
                  ],
                  [
                    54554,
                    30480.3
                  ],
                  [
                    54549,
                    30715.3
                  ],
                  [
                    54259.4,
                    30739.5
                  ],
                  [
                    54148,
                    30668.8
                  ],
                  [
                    54119.2,
                    30657
                  ],
                  [
                    54132.2,
                    30598.4
                  ],
                  [
                    54088.1,
                    30562.5
                  ],
                  [
                    54139.7,
                    30440.5
                  ]
                ],
                "id": 808,
                "chat_link": "[&BCgDAAA=]"
              },
              "809": {
                "name": "Peeta's Gate",
                "level": 0,
                "coord": [
                  53304,
                  30604.9
                ],
                "bounds": [
                  [
                    53241.3,
                    30488.6
                  ],
                  [
                    53310.2,
                    30516.8
                  ],
                  [
                    53390.2,
                    30505.8
                  ],
                  [
                    53493.2,
                    30527.8
                  ],
                  [
                    53465.4,
                    30600.8
                  ],
                  [
                    53401.4,
                    30597.3
                  ],
                  [
                    53182.8,
                    30932
                  ],
                  [
                    53177.8,
                    30817.1
                  ],
                  [
                    53167.4,
                    30540.4
                  ],
                  [
                    53210.1,
                    30522.9
                  ],
                  [
                    53241.3,
                    30488.6
                  ]
                ],
                "id": 809,
                "chat_link": "[&BCkDAAA=]"
              }
            },
            "adventures": [],
            "id": 326,
            "mastery_points": []
          },
          "334": {
            "name": "Keg Brawl",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "881": {
                "name": "Courage Brewery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53009.3,
                  30196.3
                ],
                "id": 881,
                "chat_link": "[&BHEDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "794": {
                "name": "Biergarten",
                "level": 0,
                "coord": [
                  52885.1,
                  29973.1
                ],
                "bounds": [
                  [
                    52954.8,
                    30266.8
                  ],
                  [
                    52823.2,
                    30029.2
                  ],
                  [
                    52550.5,
                    29746.8
                  ],
                  [
                    52749.6,
                    29664.4
                  ],
                  [
                    52965,
                    29722.3
                  ],
                  [
                    53101.3,
                    30146.4
                  ],
                  [
                    53051.2,
                    30235.8
                  ],
                  [
                    52954.8,
                    30266.8
                  ]
                ],
                "id": 794,
                "chat_link": "[&BBoDAAA=]"
              },
              "799": {
                "name": "Lake Mourn",
                "level": 0,
                "coord": [
                  52746.6,
                  30556.8
                ],
                "bounds": [
                  [
                    52825.3,
                    30025
                  ],
                  [
                    52957,
                    30262.5
                  ],
                  [
                    52986.9,
                    30257.1
                  ],
                  [
                    53026.8,
                    30324.9
                  ],
                  [
                    53003.8,
                    30353.8
                  ],
                  [
                    52951.8,
                    30526.7
                  ],
                  [
                    53134,
                    30558.6
                  ],
                  [
                    53168.1,
                    30540.1
                  ],
                  [
                    53180.2,
                    30817.5
                  ],
                  [
                    53183.7,
                    30931
                  ],
                  [
                    53088.9,
                    31179.1
                  ],
                  [
                    53122.6,
                    31361.8
                  ],
                  [
                    52895.6,
                    31373.6
                  ],
                  [
                    52599.8,
                    31381.4
                  ],
                  [
                    52370.6,
                    31304.6
                  ],
                  [
                    52205.1,
                    31122.9
                  ],
                  [
                    52143.3,
                    30810.2
                  ],
                  [
                    52149.5,
                    30123.1
                  ],
                  [
                    52199,
                    29885.4
                  ],
                  [
                    52262.2,
                    29700.7
                  ],
                  [
                    52417.5,
                    29665.4
                  ],
                  [
                    52552.8,
                    29745
                  ],
                  [
                    52825.3,
                    30025
                  ]
                ],
                "id": 799,
                "chat_link": "[&BB8DAAA=]"
              }
            },
            "adventures": [],
            "id": 334,
            "mastery_points": []
          },
          "374": {
            "name": "Knut Whitebear's Loft",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 2,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "id": 374,
            "mastery_points": [],
            "adventures": []
          },
          "375": {
            "name": "Hunter's Hearth (Home)",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 2,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "id": 375,
            "mastery_points": [],
            "adventures": []
          },
          "376": {
            "name": "Stonewright's Steading",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "886": {
                "name": "Stonewright's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54015.6,
                  31159.6
                ],
                "id": 886,
                "chat_link": "[&BHYDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "805": {
                "name": "Frost Basin",
                "level": 0,
                "coord": [
                  54220.9,
                  31207.1
                ],
                "bounds": [
                  [
                    53878,
                    31116.3
                  ],
                  [
                    54211.6,
                    30928.4
                  ],
                  [
                    54549.9,
                    30961
                  ],
                  [
                    54551.5,
                    31357.6
                  ],
                  [
                    54329.2,
                    31369.1
                  ],
                  [
                    54144.6,
                    31355.4
                  ],
                  [
                    53881.3,
                    31362.3
                  ],
                  [
                    53878,
                    31116.3
                  ]
                ],
                "id": 805,
                "chat_link": "[&BCUDAAA=]"
              }
            },
            "adventures": [],
            "id": 376,
            "mastery_points": []
          },
          "807": {
            "name": "Eye of the North",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              57984,
              21504
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                57344,
                21248
              ],
              [
                58624,
                22528
              ]
            ],
            "points_of_interest": {
              "1294": {
                "name": "Scrying Pool",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57601.7,
                  21592.2
                ],
                "id": 1294,
                "chat_link": "[&BA4FAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1021": {
                "name": "Hall of Monuments",
                "level": 0,
                "coord": [
                  57780,
                  21761.4
                ],
                "bounds": [
                  [
                    57696.9,
                    21933.5
                  ],
                  [
                    57742.9,
                    21933.4
                  ],
                  [
                    57750.1,
                    21915.1
                  ],
                  [
                    57826,
                    21932.4
                  ],
                  [
                    57899.8,
                    21909.7
                  ],
                  [
                    57906.2,
                    21925.5
                  ],
                  [
                    57953.6,
                    21925.9
                  ],
                  [
                    57959.2,
                    21877.1
                  ],
                  [
                    57926.4,
                    21869
                  ],
                  [
                    57953.7,
                    21799.9
                  ],
                  [
                    57924.5,
                    21726.5
                  ],
                  [
                    57948.7,
                    21717.9
                  ],
                  [
                    57949.7,
                    21672.8
                  ],
                  [
                    57902.2,
                    21671.8
                  ],
                  [
                    57895.1,
                    21697.7
                  ],
                  [
                    57821.8,
                    21674.4
                  ],
                  [
                    57756.1,
                    21694.1
                  ],
                  [
                    57709.9,
                    21646.9
                  ],
                  [
                    57729.7,
                    21624.6
                  ],
                  [
                    57692.7,
                    21496.9
                  ],
                  [
                    57566.6,
                    21468.5
                  ],
                  [
                    57476.6,
                    21562.4
                  ],
                  [
                    57513.8,
                    21685.8
                  ],
                  [
                    57639.6,
                    21719.4
                  ],
                  [
                    57662.4,
                    21690.2
                  ],
                  [
                    57707.1,
                    21737.4
                  ],
                  [
                    57690.1,
                    21803.7
                  ],
                  [
                    57721.3,
                    21880.7
                  ],
                  [
                    57696.9,
                    21887.1
                  ],
                  [
                    57696.9,
                    21933.5
                  ]
                ],
                "id": 1021,
                "chat_link": "[&BP0DAAA=]"
              }
            },
            "adventures": [],
            "id": 807,
            "mastery_points": []
          },
          "828": {
            "name": "The Durmand Priory",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {
              "293": {
                "name": "Priory Archives",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50509.3,
                  31048.7
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 828,
            "mastery_points": []
          },
          "964": {
            "name": "Scarlet's Secret Lair",
            "min_level": 1,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 964,
            "mastery_points": []
          },
          "1065": {
            "name": "Angvar's Trove",
            "min_level": 15,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              52480,
              28672
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                50432,
                27648
              ],
              [
                54528,
                29696
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "218": {
                "name": "Skradden Slopes",
                "level": 24,
                "coord": [
                  50795.2,
                  29007.4
                ],
                "bounds": [
                  [
                    51098.6,
                    28729.4
                  ],
                  [
                    51088.5,
                    28558.8
                  ],
                  [
                    50963.1,
                    28443.5
                  ],
                  [
                    50818.5,
                    28647.1
                  ],
                  [
                    50439.7,
                    28686.4
                  ],
                  [
                    50436.4,
                    29082.7
                  ],
                  [
                    50356.2,
                    29132.5
                  ],
                  [
                    50375.1,
                    29340.2
                  ],
                  [
                    50589.5,
                    29194.6
                  ],
                  [
                    50700.6,
                    29293.7
                  ],
                  [
                    50961,
                    29420.3
                  ],
                  [
                    51099.5,
                    29338.3
                  ],
                  [
                    51004.8,
                    29214.5
                  ],
                  [
                    51025.5,
                    29076.6
                  ],
                  [
                    50971.7,
                    28952.1
                  ],
                  [
                    51098.6,
                    28729.4
                  ]
                ],
                "id": 218,
                "chat_link": "[&BNoAAAA=]"
              },
              "219": {
                "name": "Glisterice Caves",
                "level": 24,
                "coord": [
                  50659,
                  29483.5
                ],
                "bounds": [
                  [
                    50961.3,
                    29414.1
                  ],
                  [
                    50697,
                    29288.8
                  ],
                  [
                    50593.8,
                    29191
                  ],
                  [
                    50372.6,
                    29336.8
                  ],
                  [
                    50312.3,
                    29661.3
                  ],
                  [
                    50659.4,
                    29796.2
                  ],
                  [
                    51016.6,
                    29696
                  ],
                  [
                    50961.3,
                    29414.1
                  ]
                ],
                "id": 219,
                "chat_link": "[&BNsAAAA=]"
              },
              "220": {
                "name": "The Frozen Sweeps",
                "level": 24,
                "coord": [
                  51359.9,
                  28989
                ],
                "bounds": [
                  [
                    51100.5,
                    29342.2
                  ],
                  [
                    51149.7,
                    29298.5
                  ],
                  [
                    51588.9,
                    29311.2
                  ],
                  [
                    51770.3,
                    29223.4
                  ],
                  [
                    51789.8,
                    28917.2
                  ],
                  [
                    51643.6,
                    28869.2
                  ],
                  [
                    51655.7,
                    28601.7
                  ],
                  [
                    51490.9,
                    28602
                  ],
                  [
                    51400.9,
                    28712.5
                  ],
                  [
                    51096,
                    28728.2
                  ],
                  [
                    50966.9,
                    28954.1
                  ],
                  [
                    51021.4,
                    29080.2
                  ],
                  [
                    51004,
                    29216.2
                  ],
                  [
                    51100.5,
                    29342.2
                  ]
                ],
                "id": 220,
                "chat_link": "[&BNwAAAA=]"
              },
              "221": {
                "name": "Molengrad",
                "level": 24,
                "coord": [
                  51212.2,
                  29527.5
                ],
                "bounds": [
                  [
                    51017.4,
                    29696
                  ],
                  [
                    50957.3,
                    29414.6
                  ],
                  [
                    51149.3,
                    29300.3
                  ],
                  [
                    51315.9,
                    29302
                  ],
                  [
                    51533.1,
                    29679.1
                  ],
                  [
                    51300.2,
                    29772.9
                  ],
                  [
                    51017.4,
                    29696
                  ]
                ],
                "id": 221,
                "chat_link": "[&BN0AAAA=]"
              },
              "222": {
                "name": "Jormabakke Stead",
                "level": 24,
                "coord": [
                  51304.6,
                  28552
                ],
                "bounds": [
                  [
                    51085.6,
                    28557.5
                  ],
                  [
                    51198,
                    28395.3
                  ],
                  [
                    51359.2,
                    28373.3
                  ],
                  [
                    51493.5,
                    28484
                  ],
                  [
                    51495.4,
                    28604.3
                  ],
                  [
                    51405.8,
                    28718.4
                  ],
                  [
                    51095,
                    28731.4
                  ],
                  [
                    51085.6,
                    28557.5
                  ]
                ],
                "id": 222,
                "chat_link": "[&BN4AAAA=]"
              },
              "223": {
                "name": "Isenfall Gullies",
                "level": 25,
                "coord": [
                  51274.5,
                  28320
                ],
                "bounds": [
                  [
                    51490.4,
                    28603.2
                  ],
                  [
                    51655.1,
                    28607.1
                  ],
                  [
                    51731,
                    28372.3
                  ],
                  [
                    51469.2,
                    28024
                  ],
                  [
                    51239.7,
                    28080.5
                  ],
                  [
                    51201.5,
                    28131.8
                  ],
                  [
                    50952,
                    28078.2
                  ],
                  [
                    50827.6,
                    28080.5
                  ],
                  [
                    50862.7,
                    28360.8
                  ],
                  [
                    51091.6,
                    28565.8
                  ],
                  [
                    51199,
                    28396
                  ],
                  [
                    51359.6,
                    28377.3
                  ],
                  [
                    51489.7,
                    28482.8
                  ],
                  [
                    51490.4,
                    28603.2
                  ]
                ],
                "id": 223,
                "chat_link": "[&BN8AAAA=]"
              },
              "224": {
                "name": "Darkhoof Heights",
                "level": 25,
                "coord": [
                  51176.4,
                  27940.2
                ],
                "bounds": [
                  [
                    50927.7,
                    27905.4
                  ],
                  [
                    50984.4,
                    27810.3
                  ],
                  [
                    51111.4,
                    27851.6
                  ],
                  [
                    51355.9,
                    27699.8
                  ],
                  [
                    51505.8,
                    27815.2
                  ],
                  [
                    51470.3,
                    28024.7
                  ],
                  [
                    51243.8,
                    28082.2
                  ],
                  [
                    51201.3,
                    28135.3
                  ],
                  [
                    50945.7,
                    28080.1
                  ],
                  [
                    51017.8,
                    27997.8
                  ],
                  [
                    50927.7,
                    27905.4
                  ]
                ],
                "id": 224,
                "chat_link": "[&BOAAAAA=]"
              },
              "226": {
                "name": "Lornar's Gate",
                "level": 22,
                "coord": [
                  51796,
                  29351
                ],
                "bounds": [
                  [
                    51309.3,
                    29301.4
                  ],
                  [
                    51590.7,
                    29307.5
                  ],
                  [
                    51768.4,
                    29222
                  ],
                  [
                    51786.2,
                    29007.7
                  ],
                  [
                    52044.5,
                    29069.3
                  ],
                  [
                    51982.1,
                    29272.8
                  ],
                  [
                    52091.8,
                    29506.2
                  ],
                  [
                    52066.2,
                    29798.1
                  ],
                  [
                    51524.6,
                    29673.9
                  ],
                  [
                    51309.3,
                    29301.4
                  ]
                ],
                "id": 226,
                "chat_link": "[&BOIAAAA=]"
              },
              "227": {
                "name": "Isenfall Lake",
                "level": 22,
                "coord": [
                  51866,
                  28185.4
                ],
                "bounds": [
                  [
                    52056.7,
                    28112.5
                  ],
                  [
                    52192.4,
                    27939.1
                  ],
                  [
                    52158.1,
                    27682.1
                  ],
                  [
                    52018.5,
                    27680.2
                  ],
                  [
                    52007,
                    27762.9
                  ],
                  [
                    51882.5,
                    27826.6
                  ],
                  [
                    51759.7,
                    27663.5
                  ],
                  [
                    51534.6,
                    27724.9
                  ],
                  [
                    51468,
                    28023.3
                  ],
                  [
                    51728.3,
                    28372.5
                  ],
                  [
                    51657.1,
                    28598
                  ],
                  [
                    51642.4,
                    28867.6
                  ],
                  [
                    51791.8,
                    28918.1
                  ],
                  [
                    51884,
                    28754.8
                  ],
                  [
                    52087.8,
                    28630.3
                  ],
                  [
                    51987.1,
                    28409.6
                  ],
                  [
                    52056.7,
                    28112.5
                  ]
                ],
                "id": 227,
                "chat_link": "[&BOMAAAA=]"
              },
              "228": {
                "name": "Hrothgar's Pass",
                "level": 22,
                "coord": [
                  52276,
                  28793.6
                ],
                "bounds": [
                  [
                    52461.1,
                    29023.5
                  ],
                  [
                    52291.1,
                    28967.1
                  ],
                  [
                    52049.6,
                    29069.2
                  ],
                  [
                    51785.3,
                    29008.9
                  ],
                  [
                    51787.1,
                    28915.1
                  ],
                  [
                    51884.2,
                    28755.3
                  ],
                  [
                    52087.1,
                    28629.8
                  ],
                  [
                    52040,
                    28528.3
                  ],
                  [
                    52476.2,
                    28451.5
                  ],
                  [
                    52646.5,
                    28737.1
                  ],
                  [
                    52852.2,
                    28651
                  ],
                  [
                    52950.9,
                    28786
                  ],
                  [
                    52461.1,
                    29023.5
                  ]
                ],
                "id": 228,
                "chat_link": "[&BOQAAAA=]"
              },
              "229": {
                "name": "Valslake",
                "level": 20,
                "coord": [
                  52628.5,
                  29295.9
                ],
                "bounds": [
                  [
                    52046,
                    29069
                  ],
                  [
                    52290.9,
                    28967.9
                  ],
                  [
                    52461.5,
                    29021.2
                  ],
                  [
                    52943.5,
                    28775.7
                  ],
                  [
                    53379.5,
                    29026.6
                  ],
                  [
                    53339,
                    29259.4
                  ],
                  [
                    53165.7,
                    29204.3
                  ],
                  [
                    52922.2,
                    29290
                  ],
                  [
                    52753.9,
                    29461.2
                  ],
                  [
                    52761.7,
                    29690.8
                  ],
                  [
                    52597,
                    29800.6
                  ],
                  [
                    52065.5,
                    29795
                  ],
                  [
                    52090.4,
                    29508.8
                  ],
                  [
                    51982,
                    29272.4
                  ],
                  [
                    52046,
                    29069
                  ]
                ],
                "id": 229,
                "chat_link": "[&BOUAAAA=]"
              },
              "230": {
                "name": "Oros Spurs",
                "level": 20,
                "coord": [
                  52333.9,
                  28115.7
                ],
                "bounds": [
                  [
                    52524.6,
                    28274.1
                  ],
                  [
                    52475.6,
                    28455
                  ],
                  [
                    52041.8,
                    28531.1
                  ],
                  [
                    51980.2,
                    28413.9
                  ],
                  [
                    52059,
                    28129.5
                  ],
                  [
                    52190.8,
                    27938.2
                  ],
                  [
                    52154.5,
                    27753.4
                  ],
                  [
                    52580.3,
                    27761.2
                  ],
                  [
                    52651.4,
                    27810.8
                  ],
                  [
                    52681.1,
                    28089.8
                  ],
                  [
                    52524.6,
                    28274.1
                  ]
                ],
                "id": 230,
                "chat_link": "[&BOYAAAA=]"
              },
              "231": {
                "name": "Vitpeln Hills",
                "level": 19,
                "coord": [
                  52872.5,
                  28413.4
                ],
                "bounds": [
                  [
                    53234.1,
                    28282.1
                  ],
                  [
                    53063.5,
                    28348
                  ],
                  [
                    52677,
                    28090.3
                  ],
                  [
                    52520.9,
                    28280.2
                  ],
                  [
                    52472.8,
                    28459.1
                  ],
                  [
                    52648.6,
                    28748.4
                  ],
                  [
                    53139.6,
                    28551.3
                  ],
                  [
                    53223.4,
                    28547.6
                  ],
                  [
                    53234.1,
                    28282.1
                  ]
                ],
                "id": 231,
                "chat_link": "[&BOcAAAA=]"
              },
              "232": {
                "name": "The Loneholme Range",
                "level": 17,
                "coord": [
                  52968.4,
                  27819.3
                ],
                "bounds": [
                  [
                    53148.6,
                    28078.7
                  ],
                  [
                    53284.8,
                    27774.5
                  ],
                  [
                    53164.9,
                    27568.5
                  ],
                  [
                    53112.1,
                    27613.9
                  ],
                  [
                    53024.1,
                    27651.3
                  ],
                  [
                    52921.9,
                    27681.2
                  ],
                  [
                    52824.8,
                    27691.5
                  ],
                  [
                    52642.7,
                    27809.9
                  ],
                  [
                    52677.1,
                    28091.6
                  ],
                  [
                    52883.3,
                    28231.6
                  ],
                  [
                    53148.6,
                    28078.7
                  ]
                ],
                "id": 232,
                "chat_link": "[&BOgAAAA=]"
              },
              "233": {
                "name": "Dragon's Rising",
                "level": 17,
                "coord": [
                  53362.2,
                  27751.4
                ],
                "bounds": [
                  [
                    53144.6,
                    28077.2
                  ],
                  [
                    53276,
                    27769.9
                  ],
                  [
                    53168.8,
                    27582.6
                  ],
                  [
                    53288.3,
                    27507.5
                  ],
                  [
                    53379,
                    27427.9
                  ],
                  [
                    53455,
                    27368.8
                  ],
                  [
                    53505.8,
                    27394.9
                  ],
                  [
                    53551.9,
                    27441.7
                  ],
                  [
                    53626.5,
                    27638.3
                  ],
                  [
                    53610.2,
                    27882.2
                  ],
                  [
                    53758.8,
                    28104.7
                  ],
                  [
                    53063.7,
                    28341.5
                  ],
                  [
                    52880.6,
                    28231.1
                  ],
                  [
                    53144.6,
                    28077.2
                  ]
                ],
                "id": 233,
                "chat_link": "[&BOkAAAA=]"
              },
              "234": {
                "name": "Jotun's Vista",
                "level": 18,
                "coord": [
                  53168.8,
                  28722.5
                ],
                "bounds": [
                  [
                    53502.1,
                    28776.6
                  ],
                  [
                    53222.8,
                    28538.7
                  ],
                  [
                    53142.3,
                    28545.6
                  ],
                  [
                    52833.2,
                    28659.9
                  ],
                  [
                    52935.4,
                    28786.6
                  ],
                  [
                    53376.8,
                    29027.5
                  ],
                  [
                    53502.1,
                    28776.6
                  ]
                ],
                "id": 234,
                "chat_link": "[&BOoAAAA=]"
              },
              "235": {
                "name": "Tromigar Valley",
                "level": 16,
                "coord": [
                  53857.4,
                  28354.8
                ],
                "bounds": [
                  [
                    53223.5,
                    28540.5
                  ],
                  [
                    53502.7,
                    28777.5
                  ],
                  [
                    53731.9,
                    28686.5
                  ],
                  [
                    54221.6,
                    28613.8
                  ],
                  [
                    54347.1,
                    28374
                  ],
                  [
                    54174.5,
                    28332.3
                  ],
                  [
                    54192.2,
                    28198.6
                  ],
                  [
                    54103.2,
                    28008.7
                  ],
                  [
                    53942.8,
                    27993.1
                  ],
                  [
                    53755.8,
                    28101
                  ],
                  [
                    53235.7,
                    28277
                  ],
                  [
                    53223.5,
                    28540.5
                  ]
                ],
                "id": 235,
                "chat_link": "[&BOsAAAA=]"
              },
              "236": {
                "name": "Song of Final Exile",
                "level": 20,
                "coord": [
                  53053.8,
                  29466.9
                ],
                "bounds": [
                  [
                    53166.5,
                    29202.5
                  ],
                  [
                    53343.4,
                    29256
                  ],
                  [
                    53188.9,
                    29562.9
                  ],
                  [
                    53242.6,
                    29819.5
                  ],
                  [
                    52759.6,
                    29689.7
                  ],
                  [
                    52756.3,
                    29447.7
                  ],
                  [
                    52919.3,
                    29289.7
                  ],
                  [
                    53166.5,
                    29202.5
                  ]
                ],
                "id": 236,
                "chat_link": "[&BOwAAAA=]"
              },
              "237": {
                "name": "Griffonfall",
                "level": 18,
                "coord": [
                  53563.9,
                  29459.6
                ],
                "bounds": [
                  [
                    53340.5,
                    29254.3
                  ],
                  [
                    53188,
                    29561.8
                  ],
                  [
                    53222.1,
                    29798.9
                  ],
                  [
                    53753.4,
                    29685.5
                  ],
                  [
                    53743.1,
                    29525
                  ],
                  [
                    53847.4,
                    29387.9
                  ],
                  [
                    53818.2,
                    29192.7
                  ],
                  [
                    53598.3,
                    29270.8
                  ],
                  [
                    53340.5,
                    29254.3
                  ]
                ],
                "id": 237,
                "chat_link": "[&BO0AAAA=]"
              },
              "238": {
                "name": "Reaver's Dale",
                "level": 18,
                "coord": [
                  53702.8,
                  29005.9
                ],
                "bounds": [
                  [
                    53493.4,
                    28768.2
                  ],
                  [
                    53725.8,
                    28680.7
                  ],
                  [
                    53803.3,
                    28806.9
                  ],
                  [
                    54159.2,
                    28947.5
                  ],
                  [
                    54014.3,
                    29093
                  ],
                  [
                    53817.9,
                    29195.6
                  ],
                  [
                    53596.5,
                    29277.4
                  ],
                  [
                    53340.3,
                    29256.5
                  ],
                  [
                    53374.8,
                    29027.7
                  ],
                  [
                    53493.4,
                    28768.2
                  ]
                ],
                "id": 238,
                "chat_link": "[&BO4AAAA=]"
              },
              "239": {
                "name": "Owl's Abattoir",
                "level": 19,
                "coord": [
                  54161.3,
                  29313.7
                ],
                "bounds": [
                  [
                    53742.3,
                    29524.6
                  ],
                  [
                    53749.2,
                    29690
                  ],
                  [
                    54265,
                    29883.3
                  ],
                  [
                    54580,
                    29724.4
                  ],
                  [
                    54697.2,
                    29253.6
                  ],
                  [
                    54576.5,
                    28623.7
                  ],
                  [
                    54322.5,
                    28764.6
                  ],
                  [
                    54014.1,
                    29092.3
                  ],
                  [
                    53817.4,
                    29192
                  ],
                  [
                    53848.6,
                    29388.1
                  ],
                  [
                    53742.3,
                    29524.6
                  ]
                ],
                "id": 239,
                "chat_link": "[&BO8AAAA=]"
              },
              "240": {
                "name": "Villmark Foothills",
                "level": 17,
                "coord": [
                  54043,
                  28764.2
                ],
                "bounds": [
                  [
                    54216.1,
                    28608.4
                  ],
                  [
                    54322.1,
                    28765.2
                  ],
                  [
                    54158.2,
                    28947.5
                  ],
                  [
                    53798.2,
                    28815.9
                  ],
                  [
                    53720.7,
                    28684.2
                  ],
                  [
                    54216.1,
                    28608.4
                  ]
                ],
                "id": 240,
                "chat_link": "[&BPAAAAA=]"
              },
              "241": {
                "name": "Hunter's Pitfalls",
                "level": 15,
                "coord": [
                  54406.9,
                  28026.6
                ],
                "bounds": [
                  [
                    54102.5,
                    28007.9
                  ],
                  [
                    54189.7,
                    28199.2
                  ],
                  [
                    54169.1,
                    28336.2
                  ],
                  [
                    54348.5,
                    28378.4
                  ],
                  [
                    54426.1,
                    28230.8
                  ],
                  [
                    54516.1,
                    28249.2
                  ],
                  [
                    54562.2,
                    28063.3
                  ],
                  [
                    54647.6,
                    27983.4
                  ],
                  [
                    54650,
                    27857.8
                  ],
                  [
                    54567.7,
                    27772.9
                  ],
                  [
                    54543.9,
                    27589.7
                  ],
                  [
                    54159.4,
                    27650.3
                  ],
                  [
                    54102.5,
                    28007.9
                  ]
                ],
                "id": 241,
                "chat_link": "[&BPEAAAA=]"
              },
              "242": {
                "name": "Trapper's Labyrinth",
                "level": 16,
                "coord": [
                  53848.1,
                  27821.1
                ],
                "bounds": [
                  [
                    53760.4,
                    28107.7
                  ],
                  [
                    53608.6,
                    27881.3
                  ],
                  [
                    53620.9,
                    27630.3
                  ],
                  [
                    53721.9,
                    27648
                  ],
                  [
                    53869.9,
                    27648
                  ],
                  [
                    54158.6,
                    27648.9
                  ],
                  [
                    54103.4,
                    28008.4
                  ],
                  [
                    53941,
                    27996.1
                  ],
                  [
                    53760.4,
                    28107.7
                  ]
                ],
                "id": 242,
                "chat_link": "[&BPIAAAA=]"
              },
              "340": {
                "name": "Ossencrest Climb",
                "level": 24,
                "coord": [
                  50616.3,
                  28310.2
                ],
                "bounds": [
                  [
                    50831.9,
                    28081.4
                  ],
                  [
                    50863.9,
                    28360.4
                  ],
                  [
                    50975.1,
                    28448.4
                  ],
                  [
                    50815,
                    28662.7
                  ],
                  [
                    50437.8,
                    28689.8
                  ],
                  [
                    50391,
                    28581.7
                  ],
                  [
                    50345,
                    28432.8
                  ],
                  [
                    50563.5,
                    28307.7
                  ],
                  [
                    50592,
                    28226.8
                  ],
                  [
                    50502.6,
                    28169
                  ],
                  [
                    50437.7,
                    28069.6
                  ],
                  [
                    50536.8,
                    27993.4
                  ],
                  [
                    50719.1,
                    28009.4
                  ],
                  [
                    50831.9,
                    28081.4
                  ]
                ],
                "id": 340,
                "chat_link": "[&BFQBAAA=]"
              },
              "1015": {
                "name": "King Jalis's Refuge",
                "level": 19,
                "coord": [
                  54441.8,
                  28495.8
                ],
                "bounds": [
                  [
                    54211.1,
                    28608.1
                  ],
                  [
                    54422.3,
                    28226.1
                  ],
                  [
                    54568.6,
                    28258.2
                  ],
                  [
                    54629.5,
                    28445.2
                  ],
                  [
                    54497.3,
                    28671.9
                  ],
                  [
                    54322.1,
                    28765.2
                  ],
                  [
                    54211.1,
                    28608.1
                  ]
                ],
                "id": 1015,
                "chat_link": "[&BPcDAAA=]"
              },
              "1106": {
                "name": "Angvar's Trove",
                "level": 0,
                "coord": [
                  50749.6,
                  27947.3
                ],
                "bounds": [
                  [
                    50593.2,
                    28225.8
                  ],
                  [
                    50562.2,
                    28313.3
                  ],
                  [
                    50346.7,
                    28220.2
                  ],
                  [
                    50265.4,
                    28037.3
                  ],
                  [
                    50282.2,
                    27608.1
                  ],
                  [
                    50698.1,
                    27415.3
                  ],
                  [
                    51340.7,
                    27543
                  ],
                  [
                    51357.3,
                    27705.4
                  ],
                  [
                    51114.3,
                    27856.9
                  ],
                  [
                    50984.3,
                    27820.7
                  ],
                  [
                    50933.5,
                    27906.5
                  ],
                  [
                    51021.9,
                    27998.5
                  ],
                  [
                    50952.6,
                    28069.6
                  ],
                  [
                    50833.9,
                    28083.8
                  ],
                  [
                    50721.5,
                    28012.2
                  ],
                  [
                    50538.3,
                    27996
                  ],
                  [
                    50439.8,
                    28070.5
                  ],
                  [
                    50506.7,
                    28167.9
                  ],
                  [
                    50593.2,
                    28225.8
                  ]
                ],
                "id": 1106,
                "chat_link": "[&BFIEAAA=]"
              }
            },
            "adventures": [],
            "id": 1065,
            "mastery_points": []
          },
          "1067": {
            "name": "Angvar's Trove",
            "min_level": 15,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              52480,
              28672
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                50432,
                27648
              ],
              [
                54528,
                29696
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "218": {
                "name": "Skradden Slopes",
                "level": 24,
                "coord": [
                  50795.2,
                  29007.4
                ],
                "bounds": [
                  [
                    51098.6,
                    28729.4
                  ],
                  [
                    51088.5,
                    28558.8
                  ],
                  [
                    50963.1,
                    28443.5
                  ],
                  [
                    50818.5,
                    28647.1
                  ],
                  [
                    50439.7,
                    28686.4
                  ],
                  [
                    50436.4,
                    29082.7
                  ],
                  [
                    50356.2,
                    29132.5
                  ],
                  [
                    50375.1,
                    29340.2
                  ],
                  [
                    50589.5,
                    29194.6
                  ],
                  [
                    50700.6,
                    29293.7
                  ],
                  [
                    50961,
                    29420.3
                  ],
                  [
                    51099.5,
                    29338.3
                  ],
                  [
                    51004.8,
                    29214.5
                  ],
                  [
                    51025.5,
                    29076.6
                  ],
                  [
                    50971.7,
                    28952.1
                  ],
                  [
                    51098.6,
                    28729.4
                  ]
                ],
                "id": 218,
                "chat_link": "[&BNoAAAA=]"
              },
              "219": {
                "name": "Glisterice Caves",
                "level": 24,
                "coord": [
                  50659,
                  29483.5
                ],
                "bounds": [
                  [
                    50961.3,
                    29414.1
                  ],
                  [
                    50697,
                    29288.8
                  ],
                  [
                    50593.8,
                    29191
                  ],
                  [
                    50372.6,
                    29336.8
                  ],
                  [
                    50312.3,
                    29661.3
                  ],
                  [
                    50659.4,
                    29796.2
                  ],
                  [
                    51016.6,
                    29696
                  ],
                  [
                    50961.3,
                    29414.1
                  ]
                ],
                "id": 219,
                "chat_link": "[&BNsAAAA=]"
              },
              "220": {
                "name": "The Frozen Sweeps",
                "level": 24,
                "coord": [
                  51359.9,
                  28989
                ],
                "bounds": [
                  [
                    51100.5,
                    29342.2
                  ],
                  [
                    51149.7,
                    29298.5
                  ],
                  [
                    51588.9,
                    29311.2
                  ],
                  [
                    51770.3,
                    29223.4
                  ],
                  [
                    51789.8,
                    28917.2
                  ],
                  [
                    51643.6,
                    28869.2
                  ],
                  [
                    51655.7,
                    28601.7
                  ],
                  [
                    51490.9,
                    28602
                  ],
                  [
                    51400.9,
                    28712.5
                  ],
                  [
                    51096,
                    28728.2
                  ],
                  [
                    50966.9,
                    28954.1
                  ],
                  [
                    51021.4,
                    29080.2
                  ],
                  [
                    51004,
                    29216.2
                  ],
                  [
                    51100.5,
                    29342.2
                  ]
                ],
                "id": 220,
                "chat_link": "[&BNwAAAA=]"
              },
              "221": {
                "name": "Molengrad",
                "level": 24,
                "coord": [
                  51212.2,
                  29527.5
                ],
                "bounds": [
                  [
                    51017.4,
                    29696
                  ],
                  [
                    50957.3,
                    29414.6
                  ],
                  [
                    51149.3,
                    29300.3
                  ],
                  [
                    51315.9,
                    29302
                  ],
                  [
                    51533.1,
                    29679.1
                  ],
                  [
                    51300.2,
                    29772.9
                  ],
                  [
                    51017.4,
                    29696
                  ]
                ],
                "id": 221,
                "chat_link": "[&BN0AAAA=]"
              },
              "222": {
                "name": "Jormabakke Stead",
                "level": 24,
                "coord": [
                  51304.6,
                  28552
                ],
                "bounds": [
                  [
                    51085.6,
                    28557.5
                  ],
                  [
                    51198,
                    28395.3
                  ],
                  [
                    51359.2,
                    28373.3
                  ],
                  [
                    51493.5,
                    28484
                  ],
                  [
                    51495.4,
                    28604.3
                  ],
                  [
                    51405.8,
                    28718.4
                  ],
                  [
                    51095,
                    28731.4
                  ],
                  [
                    51085.6,
                    28557.5
                  ]
                ],
                "id": 222,
                "chat_link": "[&BN4AAAA=]"
              },
              "223": {
                "name": "Isenfall Gullies",
                "level": 25,
                "coord": [
                  51274.5,
                  28320
                ],
                "bounds": [
                  [
                    51490.4,
                    28603.2
                  ],
                  [
                    51655.1,
                    28607.1
                  ],
                  [
                    51731,
                    28372.3
                  ],
                  [
                    51469.2,
                    28024
                  ],
                  [
                    51239.7,
                    28080.5
                  ],
                  [
                    51201.5,
                    28131.8
                  ],
                  [
                    50952,
                    28078.2
                  ],
                  [
                    50827.6,
                    28080.5
                  ],
                  [
                    50862.7,
                    28360.8
                  ],
                  [
                    51091.6,
                    28565.8
                  ],
                  [
                    51199,
                    28396
                  ],
                  [
                    51359.6,
                    28377.3
                  ],
                  [
                    51489.7,
                    28482.8
                  ],
                  [
                    51490.4,
                    28603.2
                  ]
                ],
                "id": 223,
                "chat_link": "[&BN8AAAA=]"
              },
              "224": {
                "name": "Darkhoof Heights",
                "level": 25,
                "coord": [
                  51176.4,
                  27940.2
                ],
                "bounds": [
                  [
                    50927.7,
                    27905.4
                  ],
                  [
                    50984.4,
                    27810.3
                  ],
                  [
                    51111.4,
                    27851.6
                  ],
                  [
                    51355.9,
                    27699.8
                  ],
                  [
                    51505.8,
                    27815.2
                  ],
                  [
                    51470.3,
                    28024.7
                  ],
                  [
                    51243.8,
                    28082.2
                  ],
                  [
                    51201.3,
                    28135.3
                  ],
                  [
                    50945.7,
                    28080.1
                  ],
                  [
                    51017.8,
                    27997.8
                  ],
                  [
                    50927.7,
                    27905.4
                  ]
                ],
                "id": 224,
                "chat_link": "[&BOAAAAA=]"
              },
              "226": {
                "name": "Lornar's Gate",
                "level": 22,
                "coord": [
                  51796,
                  29351
                ],
                "bounds": [
                  [
                    51309.3,
                    29301.4
                  ],
                  [
                    51590.7,
                    29307.5
                  ],
                  [
                    51768.4,
                    29222
                  ],
                  [
                    51786.2,
                    29007.7
                  ],
                  [
                    52044.5,
                    29069.3
                  ],
                  [
                    51982.1,
                    29272.8
                  ],
                  [
                    52091.8,
                    29506.2
                  ],
                  [
                    52066.2,
                    29798.1
                  ],
                  [
                    51524.6,
                    29673.9
                  ],
                  [
                    51309.3,
                    29301.4
                  ]
                ],
                "id": 226,
                "chat_link": "[&BOIAAAA=]"
              },
              "227": {
                "name": "Isenfall Lake",
                "level": 22,
                "coord": [
                  51866,
                  28185.4
                ],
                "bounds": [
                  [
                    52056.7,
                    28112.5
                  ],
                  [
                    52192.4,
                    27939.1
                  ],
                  [
                    52158.1,
                    27682.1
                  ],
                  [
                    52018.5,
                    27680.2
                  ],
                  [
                    52007,
                    27762.9
                  ],
                  [
                    51882.5,
                    27826.6
                  ],
                  [
                    51759.7,
                    27663.5
                  ],
                  [
                    51534.6,
                    27724.9
                  ],
                  [
                    51468,
                    28023.3
                  ],
                  [
                    51728.3,
                    28372.5
                  ],
                  [
                    51657.1,
                    28598
                  ],
                  [
                    51642.4,
                    28867.6
                  ],
                  [
                    51791.8,
                    28918.1
                  ],
                  [
                    51884,
                    28754.8
                  ],
                  [
                    52087.8,
                    28630.3
                  ],
                  [
                    51987.1,
                    28409.6
                  ],
                  [
                    52056.7,
                    28112.5
                  ]
                ],
                "id": 227,
                "chat_link": "[&BOMAAAA=]"
              },
              "228": {
                "name": "Hrothgar's Pass",
                "level": 22,
                "coord": [
                  52276,
                  28793.6
                ],
                "bounds": [
                  [
                    52461.1,
                    29023.5
                  ],
                  [
                    52291.1,
                    28967.1
                  ],
                  [
                    52049.6,
                    29069.2
                  ],
                  [
                    51785.3,
                    29008.9
                  ],
                  [
                    51787.1,
                    28915.1
                  ],
                  [
                    51884.2,
                    28755.3
                  ],
                  [
                    52087.1,
                    28629.8
                  ],
                  [
                    52040,
                    28528.3
                  ],
                  [
                    52476.2,
                    28451.5
                  ],
                  [
                    52646.5,
                    28737.1
                  ],
                  [
                    52852.2,
                    28651
                  ],
                  [
                    52950.9,
                    28786
                  ],
                  [
                    52461.1,
                    29023.5
                  ]
                ],
                "id": 228,
                "chat_link": "[&BOQAAAA=]"
              },
              "229": {
                "name": "Valslake",
                "level": 20,
                "coord": [
                  52628.5,
                  29295.9
                ],
                "bounds": [
                  [
                    52046,
                    29069
                  ],
                  [
                    52290.9,
                    28967.9
                  ],
                  [
                    52461.5,
                    29021.2
                  ],
                  [
                    52943.5,
                    28775.7
                  ],
                  [
                    53379.5,
                    29026.6
                  ],
                  [
                    53339,
                    29259.4
                  ],
                  [
                    53165.7,
                    29204.3
                  ],
                  [
                    52922.2,
                    29290
                  ],
                  [
                    52753.9,
                    29461.2
                  ],
                  [
                    52761.7,
                    29690.8
                  ],
                  [
                    52597,
                    29800.6
                  ],
                  [
                    52065.5,
                    29795
                  ],
                  [
                    52090.4,
                    29508.8
                  ],
                  [
                    51982,
                    29272.4
                  ],
                  [
                    52046,
                    29069
                  ]
                ],
                "id": 229,
                "chat_link": "[&BOUAAAA=]"
              },
              "230": {
                "name": "Oros Spurs",
                "level": 20,
                "coord": [
                  52333.9,
                  28115.7
                ],
                "bounds": [
                  [
                    52524.6,
                    28274.1
                  ],
                  [
                    52475.6,
                    28455
                  ],
                  [
                    52041.8,
                    28531.1
                  ],
                  [
                    51980.2,
                    28413.9
                  ],
                  [
                    52059,
                    28129.5
                  ],
                  [
                    52190.8,
                    27938.2
                  ],
                  [
                    52154.5,
                    27753.4
                  ],
                  [
                    52580.3,
                    27761.2
                  ],
                  [
                    52651.4,
                    27810.8
                  ],
                  [
                    52681.1,
                    28089.8
                  ],
                  [
                    52524.6,
                    28274.1
                  ]
                ],
                "id": 230,
                "chat_link": "[&BOYAAAA=]"
              },
              "231": {
                "name": "Vitpeln Hills",
                "level": 19,
                "coord": [
                  52872.5,
                  28413.4
                ],
                "bounds": [
                  [
                    53234.1,
                    28282.1
                  ],
                  [
                    53063.5,
                    28348
                  ],
                  [
                    52677,
                    28090.3
                  ],
                  [
                    52520.9,
                    28280.2
                  ],
                  [
                    52472.8,
                    28459.1
                  ],
                  [
                    52648.6,
                    28748.4
                  ],
                  [
                    53139.6,
                    28551.3
                  ],
                  [
                    53223.4,
                    28547.6
                  ],
                  [
                    53234.1,
                    28282.1
                  ]
                ],
                "id": 231,
                "chat_link": "[&BOcAAAA=]"
              },
              "232": {
                "name": "The Loneholme Range",
                "level": 17,
                "coord": [
                  52968.4,
                  27819.3
                ],
                "bounds": [
                  [
                    53148.6,
                    28078.7
                  ],
                  [
                    53284.8,
                    27774.5
                  ],
                  [
                    53164.9,
                    27568.5
                  ],
                  [
                    53112.1,
                    27613.9
                  ],
                  [
                    53024.1,
                    27651.3
                  ],
                  [
                    52921.9,
                    27681.2
                  ],
                  [
                    52824.8,
                    27691.5
                  ],
                  [
                    52642.7,
                    27809.9
                  ],
                  [
                    52677.1,
                    28091.6
                  ],
                  [
                    52883.3,
                    28231.6
                  ],
                  [
                    53148.6,
                    28078.7
                  ]
                ],
                "id": 232,
                "chat_link": "[&BOgAAAA=]"
              },
              "233": {
                "name": "Dragon's Rising",
                "level": 17,
                "coord": [
                  53362.2,
                  27751.4
                ],
                "bounds": [
                  [
                    53144.6,
                    28077.2
                  ],
                  [
                    53276,
                    27769.9
                  ],
                  [
                    53168.8,
                    27582.6
                  ],
                  [
                    53288.3,
                    27507.5
                  ],
                  [
                    53379,
                    27427.9
                  ],
                  [
                    53455,
                    27368.8
                  ],
                  [
                    53505.8,
                    27394.9
                  ],
                  [
                    53551.9,
                    27441.7
                  ],
                  [
                    53626.5,
                    27638.3
                  ],
                  [
                    53610.2,
                    27882.2
                  ],
                  [
                    53758.8,
                    28104.7
                  ],
                  [
                    53063.7,
                    28341.5
                  ],
                  [
                    52880.6,
                    28231.1
                  ],
                  [
                    53144.6,
                    28077.2
                  ]
                ],
                "id": 233,
                "chat_link": "[&BOkAAAA=]"
              },
              "234": {
                "name": "Jotun's Vista",
                "level": 18,
                "coord": [
                  53168.8,
                  28722.5
                ],
                "bounds": [
                  [
                    53502.1,
                    28776.6
                  ],
                  [
                    53222.8,
                    28538.7
                  ],
                  [
                    53142.3,
                    28545.6
                  ],
                  [
                    52833.2,
                    28659.9
                  ],
                  [
                    52935.4,
                    28786.6
                  ],
                  [
                    53376.8,
                    29027.5
                  ],
                  [
                    53502.1,
                    28776.6
                  ]
                ],
                "id": 234,
                "chat_link": "[&BOoAAAA=]"
              },
              "235": {
                "name": "Tromigar Valley",
                "level": 16,
                "coord": [
                  53857.4,
                  28354.8
                ],
                "bounds": [
                  [
                    53223.5,
                    28540.5
                  ],
                  [
                    53502.7,
                    28777.5
                  ],
                  [
                    53731.9,
                    28686.5
                  ],
                  [
                    54221.6,
                    28613.8
                  ],
                  [
                    54347.1,
                    28374
                  ],
                  [
                    54174.5,
                    28332.3
                  ],
                  [
                    54192.2,
                    28198.6
                  ],
                  [
                    54103.2,
                    28008.7
                  ],
                  [
                    53942.8,
                    27993.1
                  ],
                  [
                    53755.8,
                    28101
                  ],
                  [
                    53235.7,
                    28277
                  ],
                  [
                    53223.5,
                    28540.5
                  ]
                ],
                "id": 235,
                "chat_link": "[&BOsAAAA=]"
              },
              "236": {
                "name": "Song of Final Exile",
                "level": 20,
                "coord": [
                  53053.8,
                  29466.9
                ],
                "bounds": [
                  [
                    53166.5,
                    29202.5
                  ],
                  [
                    53343.4,
                    29256
                  ],
                  [
                    53188.9,
                    29562.9
                  ],
                  [
                    53242.6,
                    29819.5
                  ],
                  [
                    52759.6,
                    29689.7
                  ],
                  [
                    52756.3,
                    29447.7
                  ],
                  [
                    52919.3,
                    29289.7
                  ],
                  [
                    53166.5,
                    29202.5
                  ]
                ],
                "id": 236,
                "chat_link": "[&BOwAAAA=]"
              },
              "237": {
                "name": "Griffonfall",
                "level": 18,
                "coord": [
                  53563.9,
                  29459.6
                ],
                "bounds": [
                  [
                    53340.5,
                    29254.3
                  ],
                  [
                    53188,
                    29561.8
                  ],
                  [
                    53222.1,
                    29798.9
                  ],
                  [
                    53753.4,
                    29685.5
                  ],
                  [
                    53743.1,
                    29525
                  ],
                  [
                    53847.4,
                    29387.9
                  ],
                  [
                    53818.2,
                    29192.7
                  ],
                  [
                    53598.3,
                    29270.8
                  ],
                  [
                    53340.5,
                    29254.3
                  ]
                ],
                "id": 237,
                "chat_link": "[&BO0AAAA=]"
              },
              "238": {
                "name": "Reaver's Dale",
                "level": 18,
                "coord": [
                  53702.8,
                  29005.9
                ],
                "bounds": [
                  [
                    53493.4,
                    28768.2
                  ],
                  [
                    53725.8,
                    28680.7
                  ],
                  [
                    53803.3,
                    28806.9
                  ],
                  [
                    54159.2,
                    28947.5
                  ],
                  [
                    54014.3,
                    29093
                  ],
                  [
                    53817.9,
                    29195.6
                  ],
                  [
                    53596.5,
                    29277.4
                  ],
                  [
                    53340.3,
                    29256.5
                  ],
                  [
                    53374.8,
                    29027.7
                  ],
                  [
                    53493.4,
                    28768.2
                  ]
                ],
                "id": 238,
                "chat_link": "[&BO4AAAA=]"
              },
              "239": {
                "name": "Owl's Abattoir",
                "level": 19,
                "coord": [
                  54161.3,
                  29313.7
                ],
                "bounds": [
                  [
                    53742.3,
                    29524.6
                  ],
                  [
                    53749.2,
                    29690
                  ],
                  [
                    54265,
                    29883.3
                  ],
                  [
                    54580,
                    29724.4
                  ],
                  [
                    54697.2,
                    29253.6
                  ],
                  [
                    54576.5,
                    28623.7
                  ],
                  [
                    54322.5,
                    28764.6
                  ],
                  [
                    54014.1,
                    29092.3
                  ],
                  [
                    53817.4,
                    29192
                  ],
                  [
                    53848.6,
                    29388.1
                  ],
                  [
                    53742.3,
                    29524.6
                  ]
                ],
                "id": 239,
                "chat_link": "[&BO8AAAA=]"
              },
              "240": {
                "name": "Villmark Foothills",
                "level": 17,
                "coord": [
                  54043,
                  28764.2
                ],
                "bounds": [
                  [
                    54216.1,
                    28608.4
                  ],
                  [
                    54322.1,
                    28765.2
                  ],
                  [
                    54158.2,
                    28947.5
                  ],
                  [
                    53798.2,
                    28815.9
                  ],
                  [
                    53720.7,
                    28684.2
                  ],
                  [
                    54216.1,
                    28608.4
                  ]
                ],
                "id": 240,
                "chat_link": "[&BPAAAAA=]"
              },
              "241": {
                "name": "Hunter's Pitfalls",
                "level": 15,
                "coord": [
                  54406.9,
                  28026.6
                ],
                "bounds": [
                  [
                    54102.5,
                    28007.9
                  ],
                  [
                    54189.7,
                    28199.2
                  ],
                  [
                    54169.1,
                    28336.2
                  ],
                  [
                    54348.5,
                    28378.4
                  ],
                  [
                    54426.1,
                    28230.8
                  ],
                  [
                    54516.1,
                    28249.2
                  ],
                  [
                    54562.2,
                    28063.3
                  ],
                  [
                    54647.6,
                    27983.4
                  ],
                  [
                    54650,
                    27857.8
                  ],
                  [
                    54567.7,
                    27772.9
                  ],
                  [
                    54543.9,
                    27589.7
                  ],
                  [
                    54159.4,
                    27650.3
                  ],
                  [
                    54102.5,
                    28007.9
                  ]
                ],
                "id": 241,
                "chat_link": "[&BPEAAAA=]"
              },
              "242": {
                "name": "Trapper's Labyrinth",
                "level": 16,
                "coord": [
                  53848.1,
                  27821.1
                ],
                "bounds": [
                  [
                    53760.4,
                    28107.7
                  ],
                  [
                    53608.6,
                    27881.3
                  ],
                  [
                    53620.9,
                    27630.3
                  ],
                  [
                    53721.9,
                    27648
                  ],
                  [
                    53869.9,
                    27648
                  ],
                  [
                    54158.6,
                    27648.9
                  ],
                  [
                    54103.4,
                    28008.4
                  ],
                  [
                    53941,
                    27996.1
                  ],
                  [
                    53760.4,
                    28107.7
                  ]
                ],
                "id": 242,
                "chat_link": "[&BPIAAAA=]"
              },
              "340": {
                "name": "Ossencrest Climb",
                "level": 24,
                "coord": [
                  50616.3,
                  28310.2
                ],
                "bounds": [
                  [
                    50831.9,
                    28081.4
                  ],
                  [
                    50863.9,
                    28360.4
                  ],
                  [
                    50975.1,
                    28448.4
                  ],
                  [
                    50815,
                    28662.7
                  ],
                  [
                    50437.8,
                    28689.8
                  ],
                  [
                    50391,
                    28581.7
                  ],
                  [
                    50345,
                    28432.8
                  ],
                  [
                    50563.5,
                    28307.7
                  ],
                  [
                    50592,
                    28226.8
                  ],
                  [
                    50502.6,
                    28169
                  ],
                  [
                    50437.7,
                    28069.6
                  ],
                  [
                    50536.8,
                    27993.4
                  ],
                  [
                    50719.1,
                    28009.4
                  ],
                  [
                    50831.9,
                    28081.4
                  ]
                ],
                "id": 340,
                "chat_link": "[&BFQBAAA=]"
              },
              "1015": {
                "name": "King Jalis's Refuge",
                "level": 19,
                "coord": [
                  54441.8,
                  28495.8
                ],
                "bounds": [
                  [
                    54211.1,
                    28608.1
                  ],
                  [
                    54422.3,
                    28226.1
                  ],
                  [
                    54568.6,
                    28258.2
                  ],
                  [
                    54629.5,
                    28445.2
                  ],
                  [
                    54497.3,
                    28671.9
                  ],
                  [
                    54322.1,
                    28765.2
                  ],
                  [
                    54211.1,
                    28608.1
                  ]
                ],
                "id": 1015,
                "chat_link": "[&BPcDAAA=]"
              },
              "1106": {
                "name": "Angvar's Trove",
                "level": 0,
                "coord": [
                  50749.6,
                  27947.3
                ],
                "bounds": [
                  [
                    50593.2,
                    28225.8
                  ],
                  [
                    50562.2,
                    28313.3
                  ],
                  [
                    50346.7,
                    28220.2
                  ],
                  [
                    50265.4,
                    28037.3
                  ],
                  [
                    50282.2,
                    27608.1
                  ],
                  [
                    50698.1,
                    27415.3
                  ],
                  [
                    51340.7,
                    27543
                  ],
                  [
                    51357.3,
                    27705.4
                  ],
                  [
                    51114.3,
                    27856.9
                  ],
                  [
                    50984.3,
                    27820.7
                  ],
                  [
                    50933.5,
                    27906.5
                  ],
                  [
                    51021.9,
                    27998.5
                  ],
                  [
                    50952.6,
                    28069.6
                  ],
                  [
                    50833.9,
                    28083.8
                  ],
                  [
                    50721.5,
                    28012.2
                  ],
                  [
                    50538.3,
                    27996
                  ],
                  [
                    50439.8,
                    28070.5
                  ],
                  [
                    50506.7,
                    28167.9
                  ],
                  [
                    50593.2,
                    28225.8
                  ]
                ],
                "id": 1106,
                "chat_link": "[&BFIEAAA=]"
              }
            },
            "id": 1067,
            "mastery_points": [],
            "adventures": []
          },
          "1089": {
            "name": "Angvar's Trove",
            "min_level": 15,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              52480,
              28672
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                50432,
                27648
              ],
              [
                54528,
                29696
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "218": {
                "name": "Skradden Slopes",
                "level": 24,
                "coord": [
                  50795.2,
                  29007.4
                ],
                "bounds": [
                  [
                    51098.6,
                    28729.4
                  ],
                  [
                    51088.5,
                    28558.8
                  ],
                  [
                    50963.1,
                    28443.5
                  ],
                  [
                    50818.5,
                    28647.1
                  ],
                  [
                    50439.7,
                    28686.4
                  ],
                  [
                    50436.4,
                    29082.7
                  ],
                  [
                    50356.2,
                    29132.5
                  ],
                  [
                    50375.1,
                    29340.2
                  ],
                  [
                    50589.5,
                    29194.6
                  ],
                  [
                    50700.6,
                    29293.7
                  ],
                  [
                    50961,
                    29420.3
                  ],
                  [
                    51099.5,
                    29338.3
                  ],
                  [
                    51004.8,
                    29214.5
                  ],
                  [
                    51025.5,
                    29076.6
                  ],
                  [
                    50971.7,
                    28952.1
                  ],
                  [
                    51098.6,
                    28729.4
                  ]
                ],
                "id": 218,
                "chat_link": "[&BNoAAAA=]"
              },
              "219": {
                "name": "Glisterice Caves",
                "level": 24,
                "coord": [
                  50659,
                  29483.5
                ],
                "bounds": [
                  [
                    50961.3,
                    29414.1
                  ],
                  [
                    50697,
                    29288.8
                  ],
                  [
                    50593.8,
                    29191
                  ],
                  [
                    50372.6,
                    29336.8
                  ],
                  [
                    50312.3,
                    29661.3
                  ],
                  [
                    50659.4,
                    29796.2
                  ],
                  [
                    51016.6,
                    29696
                  ],
                  [
                    50961.3,
                    29414.1
                  ]
                ],
                "id": 219,
                "chat_link": "[&BNsAAAA=]"
              },
              "220": {
                "name": "The Frozen Sweeps",
                "level": 24,
                "coord": [
                  51359.9,
                  28989
                ],
                "bounds": [
                  [
                    51100.5,
                    29342.2
                  ],
                  [
                    51149.7,
                    29298.5
                  ],
                  [
                    51588.9,
                    29311.2
                  ],
                  [
                    51770.3,
                    29223.4
                  ],
                  [
                    51789.8,
                    28917.2
                  ],
                  [
                    51643.6,
                    28869.2
                  ],
                  [
                    51655.7,
                    28601.7
                  ],
                  [
                    51490.9,
                    28602
                  ],
                  [
                    51400.9,
                    28712.5
                  ],
                  [
                    51096,
                    28728.2
                  ],
                  [
                    50966.9,
                    28954.1
                  ],
                  [
                    51021.4,
                    29080.2
                  ],
                  [
                    51004,
                    29216.2
                  ],
                  [
                    51100.5,
                    29342.2
                  ]
                ],
                "id": 220,
                "chat_link": "[&BNwAAAA=]"
              },
              "221": {
                "name": "Molengrad",
                "level": 24,
                "coord": [
                  51212.2,
                  29527.5
                ],
                "bounds": [
                  [
                    51017.4,
                    29696
                  ],
                  [
                    50957.3,
                    29414.6
                  ],
                  [
                    51149.3,
                    29300.3
                  ],
                  [
                    51315.9,
                    29302
                  ],
                  [
                    51533.1,
                    29679.1
                  ],
                  [
                    51300.2,
                    29772.9
                  ],
                  [
                    51017.4,
                    29696
                  ]
                ],
                "id": 221,
                "chat_link": "[&BN0AAAA=]"
              },
              "222": {
                "name": "Jormabakke Stead",
                "level": 24,
                "coord": [
                  51304.6,
                  28552
                ],
                "bounds": [
                  [
                    51085.6,
                    28557.5
                  ],
                  [
                    51198,
                    28395.3
                  ],
                  [
                    51359.2,
                    28373.3
                  ],
                  [
                    51493.5,
                    28484
                  ],
                  [
                    51495.4,
                    28604.3
                  ],
                  [
                    51405.8,
                    28718.4
                  ],
                  [
                    51095,
                    28731.4
                  ],
                  [
                    51085.6,
                    28557.5
                  ]
                ],
                "id": 222,
                "chat_link": "[&BN4AAAA=]"
              },
              "223": {
                "name": "Isenfall Gullies",
                "level": 25,
                "coord": [
                  51274.5,
                  28320
                ],
                "bounds": [
                  [
                    51490.4,
                    28603.2
                  ],
                  [
                    51655.1,
                    28607.1
                  ],
                  [
                    51731,
                    28372.3
                  ],
                  [
                    51469.2,
                    28024
                  ],
                  [
                    51239.7,
                    28080.5
                  ],
                  [
                    51201.5,
                    28131.8
                  ],
                  [
                    50952,
                    28078.2
                  ],
                  [
                    50827.6,
                    28080.5
                  ],
                  [
                    50862.7,
                    28360.8
                  ],
                  [
                    51091.6,
                    28565.8
                  ],
                  [
                    51199,
                    28396
                  ],
                  [
                    51359.6,
                    28377.3
                  ],
                  [
                    51489.7,
                    28482.8
                  ],
                  [
                    51490.4,
                    28603.2
                  ]
                ],
                "id": 223,
                "chat_link": "[&BN8AAAA=]"
              },
              "224": {
                "name": "Darkhoof Heights",
                "level": 25,
                "coord": [
                  51176.4,
                  27940.2
                ],
                "bounds": [
                  [
                    50927.7,
                    27905.4
                  ],
                  [
                    50984.4,
                    27810.3
                  ],
                  [
                    51111.4,
                    27851.6
                  ],
                  [
                    51355.9,
                    27699.8
                  ],
                  [
                    51505.8,
                    27815.2
                  ],
                  [
                    51470.3,
                    28024.7
                  ],
                  [
                    51243.8,
                    28082.2
                  ],
                  [
                    51201.3,
                    28135.3
                  ],
                  [
                    50945.7,
                    28080.1
                  ],
                  [
                    51017.8,
                    27997.8
                  ],
                  [
                    50927.7,
                    27905.4
                  ]
                ],
                "id": 224,
                "chat_link": "[&BOAAAAA=]"
              },
              "226": {
                "name": "Lornar's Gate",
                "level": 22,
                "coord": [
                  51796,
                  29351
                ],
                "bounds": [
                  [
                    51309.3,
                    29301.4
                  ],
                  [
                    51590.7,
                    29307.5
                  ],
                  [
                    51768.4,
                    29222
                  ],
                  [
                    51786.2,
                    29007.7
                  ],
                  [
                    52044.5,
                    29069.3
                  ],
                  [
                    51982.1,
                    29272.8
                  ],
                  [
                    52091.8,
                    29506.2
                  ],
                  [
                    52066.2,
                    29798.1
                  ],
                  [
                    51524.6,
                    29673.9
                  ],
                  [
                    51309.3,
                    29301.4
                  ]
                ],
                "id": 226,
                "chat_link": "[&BOIAAAA=]"
              },
              "227": {
                "name": "Isenfall Lake",
                "level": 22,
                "coord": [
                  51866,
                  28185.4
                ],
                "bounds": [
                  [
                    52056.7,
                    28112.5
                  ],
                  [
                    52192.4,
                    27939.1
                  ],
                  [
                    52158.1,
                    27682.1
                  ],
                  [
                    52018.5,
                    27680.2
                  ],
                  [
                    52007,
                    27762.9
                  ],
                  [
                    51882.5,
                    27826.6
                  ],
                  [
                    51759.7,
                    27663.5
                  ],
                  [
                    51534.6,
                    27724.9
                  ],
                  [
                    51468,
                    28023.3
                  ],
                  [
                    51728.3,
                    28372.5
                  ],
                  [
                    51657.1,
                    28598
                  ],
                  [
                    51642.4,
                    28867.6
                  ],
                  [
                    51791.8,
                    28918.1
                  ],
                  [
                    51884,
                    28754.8
                  ],
                  [
                    52087.8,
                    28630.3
                  ],
                  [
                    51987.1,
                    28409.6
                  ],
                  [
                    52056.7,
                    28112.5
                  ]
                ],
                "id": 227,
                "chat_link": "[&BOMAAAA=]"
              },
              "228": {
                "name": "Hrothgar's Pass",
                "level": 22,
                "coord": [
                  52276,
                  28793.6
                ],
                "bounds": [
                  [
                    52461.1,
                    29023.5
                  ],
                  [
                    52291.1,
                    28967.1
                  ],
                  [
                    52049.6,
                    29069.2
                  ],
                  [
                    51785.3,
                    29008.9
                  ],
                  [
                    51787.1,
                    28915.1
                  ],
                  [
                    51884.2,
                    28755.3
                  ],
                  [
                    52087.1,
                    28629.8
                  ],
                  [
                    52040,
                    28528.3
                  ],
                  [
                    52476.2,
                    28451.5
                  ],
                  [
                    52646.5,
                    28737.1
                  ],
                  [
                    52852.2,
                    28651
                  ],
                  [
                    52950.9,
                    28786
                  ],
                  [
                    52461.1,
                    29023.5
                  ]
                ],
                "id": 228,
                "chat_link": "[&BOQAAAA=]"
              },
              "229": {
                "name": "Valslake",
                "level": 20,
                "coord": [
                  52628.5,
                  29295.9
                ],
                "bounds": [
                  [
                    52046,
                    29069
                  ],
                  [
                    52290.9,
                    28967.9
                  ],
                  [
                    52461.5,
                    29021.2
                  ],
                  [
                    52943.5,
                    28775.7
                  ],
                  [
                    53379.5,
                    29026.6
                  ],
                  [
                    53339,
                    29259.4
                  ],
                  [
                    53165.7,
                    29204.3
                  ],
                  [
                    52922.2,
                    29290
                  ],
                  [
                    52753.9,
                    29461.2
                  ],
                  [
                    52761.7,
                    29690.8
                  ],
                  [
                    52597,
                    29800.6
                  ],
                  [
                    52065.5,
                    29795
                  ],
                  [
                    52090.4,
                    29508.8
                  ],
                  [
                    51982,
                    29272.4
                  ],
                  [
                    52046,
                    29069
                  ]
                ],
                "id": 229,
                "chat_link": "[&BOUAAAA=]"
              },
              "230": {
                "name": "Oros Spurs",
                "level": 20,
                "coord": [
                  52333.9,
                  28115.7
                ],
                "bounds": [
                  [
                    52524.6,
                    28274.1
                  ],
                  [
                    52475.6,
                    28455
                  ],
                  [
                    52041.8,
                    28531.1
                  ],
                  [
                    51980.2,
                    28413.9
                  ],
                  [
                    52059,
                    28129.5
                  ],
                  [
                    52190.8,
                    27938.2
                  ],
                  [
                    52154.5,
                    27753.4
                  ],
                  [
                    52580.3,
                    27761.2
                  ],
                  [
                    52651.4,
                    27810.8
                  ],
                  [
                    52681.1,
                    28089.8
                  ],
                  [
                    52524.6,
                    28274.1
                  ]
                ],
                "id": 230,
                "chat_link": "[&BOYAAAA=]"
              },
              "231": {
                "name": "Vitpeln Hills",
                "level": 19,
                "coord": [
                  52872.5,
                  28413.4
                ],
                "bounds": [
                  [
                    53234.1,
                    28282.1
                  ],
                  [
                    53063.5,
                    28348
                  ],
                  [
                    52677,
                    28090.3
                  ],
                  [
                    52520.9,
                    28280.2
                  ],
                  [
                    52472.8,
                    28459.1
                  ],
                  [
                    52648.6,
                    28748.4
                  ],
                  [
                    53139.6,
                    28551.3
                  ],
                  [
                    53223.4,
                    28547.6
                  ],
                  [
                    53234.1,
                    28282.1
                  ]
                ],
                "id": 231,
                "chat_link": "[&BOcAAAA=]"
              },
              "232": {
                "name": "The Loneholme Range",
                "level": 17,
                "coord": [
                  52968.4,
                  27819.3
                ],
                "bounds": [
                  [
                    53148.6,
                    28078.7
                  ],
                  [
                    53284.8,
                    27774.5
                  ],
                  [
                    53164.9,
                    27568.5
                  ],
                  [
                    53112.1,
                    27613.9
                  ],
                  [
                    53024.1,
                    27651.3
                  ],
                  [
                    52921.9,
                    27681.2
                  ],
                  [
                    52824.8,
                    27691.5
                  ],
                  [
                    52642.7,
                    27809.9
                  ],
                  [
                    52677.1,
                    28091.6
                  ],
                  [
                    52883.3,
                    28231.6
                  ],
                  [
                    53148.6,
                    28078.7
                  ]
                ],
                "id": 232,
                "chat_link": "[&BOgAAAA=]"
              },
              "233": {
                "name": "Dragon's Rising",
                "level": 17,
                "coord": [
                  53362.2,
                  27751.4
                ],
                "bounds": [
                  [
                    53144.6,
                    28077.2
                  ],
                  [
                    53276,
                    27769.9
                  ],
                  [
                    53168.8,
                    27582.6
                  ],
                  [
                    53288.3,
                    27507.5
                  ],
                  [
                    53379,
                    27427.9
                  ],
                  [
                    53455,
                    27368.8
                  ],
                  [
                    53505.8,
                    27394.9
                  ],
                  [
                    53551.9,
                    27441.7
                  ],
                  [
                    53626.5,
                    27638.3
                  ],
                  [
                    53610.2,
                    27882.2
                  ],
                  [
                    53758.8,
                    28104.7
                  ],
                  [
                    53063.7,
                    28341.5
                  ],
                  [
                    52880.6,
                    28231.1
                  ],
                  [
                    53144.6,
                    28077.2
                  ]
                ],
                "id": 233,
                "chat_link": "[&BOkAAAA=]"
              },
              "234": {
                "name": "Jotun's Vista",
                "level": 18,
                "coord": [
                  53168.8,
                  28722.5
                ],
                "bounds": [
                  [
                    53502.1,
                    28776.6
                  ],
                  [
                    53222.8,
                    28538.7
                  ],
                  [
                    53142.3,
                    28545.6
                  ],
                  [
                    52833.2,
                    28659.9
                  ],
                  [
                    52935.4,
                    28786.6
                  ],
                  [
                    53376.8,
                    29027.5
                  ],
                  [
                    53502.1,
                    28776.6
                  ]
                ],
                "id": 234,
                "chat_link": "[&BOoAAAA=]"
              },
              "235": {
                "name": "Tromigar Valley",
                "level": 16,
                "coord": [
                  53857.4,
                  28354.8
                ],
                "bounds": [
                  [
                    53223.5,
                    28540.5
                  ],
                  [
                    53502.7,
                    28777.5
                  ],
                  [
                    53731.9,
                    28686.5
                  ],
                  [
                    54221.6,
                    28613.8
                  ],
                  [
                    54347.1,
                    28374
                  ],
                  [
                    54174.5,
                    28332.3
                  ],
                  [
                    54192.2,
                    28198.6
                  ],
                  [
                    54103.2,
                    28008.7
                  ],
                  [
                    53942.8,
                    27993.1
                  ],
                  [
                    53755.8,
                    28101
                  ],
                  [
                    53235.7,
                    28277
                  ],
                  [
                    53223.5,
                    28540.5
                  ]
                ],
                "id": 235,
                "chat_link": "[&BOsAAAA=]"
              },
              "236": {
                "name": "Song of Final Exile",
                "level": 20,
                "coord": [
                  53053.8,
                  29466.9
                ],
                "bounds": [
                  [
                    53166.5,
                    29202.5
                  ],
                  [
                    53343.4,
                    29256
                  ],
                  [
                    53188.9,
                    29562.9
                  ],
                  [
                    53242.6,
                    29819.5
                  ],
                  [
                    52759.6,
                    29689.7
                  ],
                  [
                    52756.3,
                    29447.7
                  ],
                  [
                    52919.3,
                    29289.7
                  ],
                  [
                    53166.5,
                    29202.5
                  ]
                ],
                "id": 236,
                "chat_link": "[&BOwAAAA=]"
              },
              "237": {
                "name": "Griffonfall",
                "level": 18,
                "coord": [
                  53563.9,
                  29459.6
                ],
                "bounds": [
                  [
                    53340.5,
                    29254.3
                  ],
                  [
                    53188,
                    29561.8
                  ],
                  [
                    53222.1,
                    29798.9
                  ],
                  [
                    53753.4,
                    29685.5
                  ],
                  [
                    53743.1,
                    29525
                  ],
                  [
                    53847.4,
                    29387.9
                  ],
                  [
                    53818.2,
                    29192.7
                  ],
                  [
                    53598.3,
                    29270.8
                  ],
                  [
                    53340.5,
                    29254.3
                  ]
                ],
                "id": 237,
                "chat_link": "[&BO0AAAA=]"
              },
              "238": {
                "name": "Reaver's Dale",
                "level": 18,
                "coord": [
                  53702.8,
                  29005.9
                ],
                "bounds": [
                  [
                    53493.4,
                    28768.2
                  ],
                  [
                    53725.8,
                    28680.7
                  ],
                  [
                    53803.3,
                    28806.9
                  ],
                  [
                    54159.2,
                    28947.5
                  ],
                  [
                    54014.3,
                    29093
                  ],
                  [
                    53817.9,
                    29195.6
                  ],
                  [
                    53596.5,
                    29277.4
                  ],
                  [
                    53340.3,
                    29256.5
                  ],
                  [
                    53374.8,
                    29027.7
                  ],
                  [
                    53493.4,
                    28768.2
                  ]
                ],
                "id": 238,
                "chat_link": "[&BO4AAAA=]"
              },
              "239": {
                "name": "Owl's Abattoir",
                "level": 19,
                "coord": [
                  54161.3,
                  29313.7
                ],
                "bounds": [
                  [
                    53742.3,
                    29524.6
                  ],
                  [
                    53749.2,
                    29690
                  ],
                  [
                    54265,
                    29883.3
                  ],
                  [
                    54580,
                    29724.4
                  ],
                  [
                    54697.2,
                    29253.6
                  ],
                  [
                    54576.5,
                    28623.7
                  ],
                  [
                    54322.5,
                    28764.6
                  ],
                  [
                    54014.1,
                    29092.3
                  ],
                  [
                    53817.4,
                    29192
                  ],
                  [
                    53848.6,
                    29388.1
                  ],
                  [
                    53742.3,
                    29524.6
                  ]
                ],
                "id": 239,
                "chat_link": "[&BO8AAAA=]"
              },
              "240": {
                "name": "Villmark Foothills",
                "level": 17,
                "coord": [
                  54043,
                  28764.2
                ],
                "bounds": [
                  [
                    54216.1,
                    28608.4
                  ],
                  [
                    54322.1,
                    28765.2
                  ],
                  [
                    54158.2,
                    28947.5
                  ],
                  [
                    53798.2,
                    28815.9
                  ],
                  [
                    53720.7,
                    28684.2
                  ],
                  [
                    54216.1,
                    28608.4
                  ]
                ],
                "id": 240,
                "chat_link": "[&BPAAAAA=]"
              },
              "241": {
                "name": "Hunter's Pitfalls",
                "level": 15,
                "coord": [
                  54406.9,
                  28026.6
                ],
                "bounds": [
                  [
                    54102.5,
                    28007.9
                  ],
                  [
                    54189.7,
                    28199.2
                  ],
                  [
                    54169.1,
                    28336.2
                  ],
                  [
                    54348.5,
                    28378.4
                  ],
                  [
                    54426.1,
                    28230.8
                  ],
                  [
                    54516.1,
                    28249.2
                  ],
                  [
                    54562.2,
                    28063.3
                  ],
                  [
                    54647.6,
                    27983.4
                  ],
                  [
                    54650,
                    27857.8
                  ],
                  [
                    54567.7,
                    27772.9
                  ],
                  [
                    54543.9,
                    27589.7
                  ],
                  [
                    54159.4,
                    27650.3
                  ],
                  [
                    54102.5,
                    28007.9
                  ]
                ],
                "id": 241,
                "chat_link": "[&BPEAAAA=]"
              },
              "242": {
                "name": "Trapper's Labyrinth",
                "level": 16,
                "coord": [
                  53848.1,
                  27821.1
                ],
                "bounds": [
                  [
                    53760.4,
                    28107.7
                  ],
                  [
                    53608.6,
                    27881.3
                  ],
                  [
                    53620.9,
                    27630.3
                  ],
                  [
                    53721.9,
                    27648
                  ],
                  [
                    53869.9,
                    27648
                  ],
                  [
                    54158.6,
                    27648.9
                  ],
                  [
                    54103.4,
                    28008.4
                  ],
                  [
                    53941,
                    27996.1
                  ],
                  [
                    53760.4,
                    28107.7
                  ]
                ],
                "id": 242,
                "chat_link": "[&BPIAAAA=]"
              },
              "340": {
                "name": "Ossencrest Climb",
                "level": 24,
                "coord": [
                  50616.3,
                  28310.2
                ],
                "bounds": [
                  [
                    50831.9,
                    28081.4
                  ],
                  [
                    50863.9,
                    28360.4
                  ],
                  [
                    50975.1,
                    28448.4
                  ],
                  [
                    50815,
                    28662.7
                  ],
                  [
                    50437.8,
                    28689.8
                  ],
                  [
                    50391,
                    28581.7
                  ],
                  [
                    50345,
                    28432.8
                  ],
                  [
                    50563.5,
                    28307.7
                  ],
                  [
                    50592,
                    28226.8
                  ],
                  [
                    50502.6,
                    28169
                  ],
                  [
                    50437.7,
                    28069.6
                  ],
                  [
                    50536.8,
                    27993.4
                  ],
                  [
                    50719.1,
                    28009.4
                  ],
                  [
                    50831.9,
                    28081.4
                  ]
                ],
                "id": 340,
                "chat_link": "[&BFQBAAA=]"
              },
              "1015": {
                "name": "King Jalis's Refuge",
                "level": 19,
                "coord": [
                  54441.8,
                  28495.8
                ],
                "bounds": [
                  [
                    54211.1,
                    28608.1
                  ],
                  [
                    54422.3,
                    28226.1
                  ],
                  [
                    54568.6,
                    28258.2
                  ],
                  [
                    54629.5,
                    28445.2
                  ],
                  [
                    54497.3,
                    28671.9
                  ],
                  [
                    54322.1,
                    28765.2
                  ],
                  [
                    54211.1,
                    28608.1
                  ]
                ],
                "id": 1015,
                "chat_link": "[&BPcDAAA=]"
              },
              "1106": {
                "name": "Angvar's Trove",
                "level": 0,
                "coord": [
                  50749.6,
                  27947.3
                ],
                "bounds": [
                  [
                    50593.2,
                    28225.8
                  ],
                  [
                    50562.2,
                    28313.3
                  ],
                  [
                    50346.7,
                    28220.2
                  ],
                  [
                    50265.4,
                    28037.3
                  ],
                  [
                    50282.2,
                    27608.1
                  ],
                  [
                    50698.1,
                    27415.3
                  ],
                  [
                    51340.7,
                    27543
                  ],
                  [
                    51357.3,
                    27705.4
                  ],
                  [
                    51114.3,
                    27856.9
                  ],
                  [
                    50984.3,
                    27820.7
                  ],
                  [
                    50933.5,
                    27906.5
                  ],
                  [
                    51021.9,
                    27998.5
                  ],
                  [
                    50952.6,
                    28069.6
                  ],
                  [
                    50833.9,
                    28083.8
                  ],
                  [
                    50721.5,
                    28012.2
                  ],
                  [
                    50538.3,
                    27996
                  ],
                  [
                    50439.8,
                    28070.5
                  ],
                  [
                    50506.7,
                    28167.9
                  ],
                  [
                    50593.2,
                    28225.8
                  ]
                ],
                "id": 1106,
                "chat_link": "[&BFIEAAA=]"
              }
            },
            "id": 1089,
            "mastery_points": [],
            "adventures": []
          },
          "1092": {
            "name": "Scratch Sentry Defense",
            "min_level": 50,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              52864,
              36160
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                51712,
                34560
              ],
              [
                54016,
                37760
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "539": {
                "name": "Talus Waterslide",
                "level": 60,
                "coord": [
                  52019.1,
                  37614
                ],
                "bounds": [
                  [
                    52134.8,
                    37860.4
                  ],
                  [
                    51848.6,
                    37818.3
                  ],
                  [
                    51816,
                    37670.9
                  ],
                  [
                    51736,
                    37507.2
                  ],
                  [
                    51822.5,
                    37346.7
                  ],
                  [
                    52046.8,
                    37436.5
                  ],
                  [
                    52312.1,
                    37443.5
                  ],
                  [
                    52229.3,
                    37682.8
                  ],
                  [
                    52225.7,
                    37759.3
                  ],
                  [
                    52134.8,
                    37860.4
                  ]
                ],
                "id": 539,
                "chat_link": "[&BBsCAAA=]"
              },
              "540": {
                "name": "Malorean Wilds",
                "level": 58,
                "coord": [
                  52450.5,
                  37608
                ],
                "bounds": [
                  [
                    52439.5,
                    37404.6
                  ],
                  [
                    52627.2,
                    37480.5
                  ],
                  [
                    52671.3,
                    37656.1
                  ],
                  [
                    52648.7,
                    37829.1
                  ],
                  [
                    52225.7,
                    37759.4
                  ],
                  [
                    52229.4,
                    37683
                  ],
                  [
                    52311.6,
                    37443.3
                  ],
                  [
                    52439.5,
                    37404.6
                  ]
                ],
                "id": 540,
                "chat_link": "[&BBwCAAA=]"
              },
              "541": {
                "name": "Serpent Stones",
                "level": 59,
                "coord": [
                  52758.9,
                  37436.8
                ],
                "bounds": [
                  [
                    52439.5,
                    37404.7
                  ],
                  [
                    52492.9,
                    37266.3
                  ],
                  [
                    52642.5,
                    37155.6
                  ],
                  [
                    52740,
                    37205
                  ],
                  [
                    52883.5,
                    37185.4
                  ],
                  [
                    53087.8,
                    37333.9
                  ],
                  [
                    53042.3,
                    37441.5
                  ],
                  [
                    52953.5,
                    37527
                  ],
                  [
                    52881.4,
                    37755.9
                  ],
                  [
                    52645.3,
                    37828.9
                  ],
                  [
                    52671.3,
                    37656.4
                  ],
                  [
                    52626.5,
                    37480.6
                  ],
                  [
                    52439.5,
                    37404.7
                  ]
                ],
                "id": 541,
                "chat_link": "[&BB0CAAA=]"
              },
              "542": {
                "name": "Mellaggan's Grotto",
                "level": 59,
                "coord": [
                  53329.3,
                  37571.3
                ],
                "bounds": [
                  [
                    53042.1,
                    37440.1
                  ],
                  [
                    53087.8,
                    37333.3
                  ],
                  [
                    53593,
                    37309
                  ],
                  [
                    53736.7,
                    37493.6
                  ],
                  [
                    53836.3,
                    37634.3
                  ],
                  [
                    53656.3,
                    37829.4
                  ],
                  [
                    53176.7,
                    37824.6
                  ],
                  [
                    52882.4,
                    37750.8
                  ],
                  [
                    52952.8,
                    37526.8
                  ],
                  [
                    53042.1,
                    37440.1
                  ]
                ],
                "id": 542,
                "chat_link": "[&BB4CAAA=]"
              },
              "543": {
                "name": "Lair of the Coil",
                "level": 60,
                "coord": [
                  53858.9,
                  37394.2
                ],
                "bounds": [
                  [
                    53736.2,
                    37494.3
                  ],
                  [
                    53825.5,
                    37616
                  ],
                  [
                    53938.5,
                    37532.7
                  ],
                  [
                    54050.7,
                    37417.1
                  ],
                  [
                    54049.1,
                    37299
                  ],
                  [
                    54007.7,
                    37262.9
                  ],
                  [
                    53671.3,
                    37221.8
                  ],
                  [
                    53592,
                    37309.5
                  ],
                  [
                    53736.2,
                    37494.3
                  ]
                ],
                "id": 543,
                "chat_link": "[&BB8CAAA=]"
              },
              "544": {
                "name": "Tail of the Serpent",
                "level": 60,
                "coord": [
                  53957.2,
                  37018.3
                ],
                "bounds": [
                  [
                    53927.5,
                    36975.4
                  ],
                  [
                    53931.7,
                    36721.5
                  ],
                  [
                    54010.1,
                    36773
                  ],
                  [
                    54051.4,
                    36870.5
                  ],
                  [
                    54055.3,
                    37184.3
                  ],
                  [
                    54007.1,
                    37263.9
                  ],
                  [
                    53794.4,
                    37237.9
                  ],
                  [
                    53880.4,
                    37119.8
                  ],
                  [
                    53927.5,
                    36975.4
                  ]
                ],
                "id": 544,
                "chat_link": "[&BCACAAA=]"
              },
              "545": {
                "name": "Scale Strand",
                "level": 60,
                "coord": [
                  53786.5,
                  36934.6
                ],
                "bounds": [
                  [
                    53932.3,
                    36721.4
                  ],
                  [
                    53849.8,
                    36583.3
                  ],
                  [
                    53637.4,
                    36586.1
                  ],
                  [
                    53666.5,
                    36835.1
                  ],
                  [
                    53758,
                    36931.9
                  ],
                  [
                    53745.6,
                    37133.6
                  ],
                  [
                    53671.7,
                    37220.2
                  ],
                  [
                    53794.5,
                    37238.4
                  ],
                  [
                    53880.1,
                    37120.2
                  ],
                  [
                    53928.8,
                    36975.4
                  ],
                  [
                    53932.3,
                    36721.4
                  ]
                ],
                "id": 545,
                "chat_link": "[&BCECAAA=]"
              },
              "546": {
                "name": "Nonmoa Lake",
                "level": 60,
                "coord": [
                  53362.7,
                  36957.2
                ],
                "bounds": [
                  [
                    53087.1,
                    37333.3
                  ],
                  [
                    53593.5,
                    37309.4
                  ],
                  [
                    53749.4,
                    37136.3
                  ],
                  [
                    53758.2,
                    36931.3
                  ],
                  [
                    53667.2,
                    36835.3
                  ],
                  [
                    53636.7,
                    36584.5
                  ],
                  [
                    53342,
                    36667.8
                  ],
                  [
                    53106.1,
                    36700
                  ],
                  [
                    52804,
                    36888.5
                  ],
                  [
                    52882.6,
                    37185.5
                  ],
                  [
                    53087.1,
                    37333.3
                  ]
                ],
                "id": 546,
                "chat_link": "[&BCICAAA=]"
              },
              "547": {
                "name": "Pythian Point",
                "level": 57,
                "coord": [
                  52544.2,
                  37099.9
                ],
                "bounds": [
                  [
                    52290.7,
                    36817.2
                  ],
                  [
                    52535.1,
                    36752.6
                  ],
                  [
                    52589.7,
                    36852.6
                  ],
                  [
                    52804.2,
                    36888
                  ],
                  [
                    52882.1,
                    37186.3
                  ],
                  [
                    52739.5,
                    37205
                  ],
                  [
                    52642.5,
                    37155.6
                  ],
                  [
                    52491.5,
                    37267.5
                  ],
                  [
                    52440.1,
                    37404.9
                  ],
                  [
                    52310.8,
                    37444
                  ],
                  [
                    52260.1,
                    37125.6
                  ],
                  [
                    52290.7,
                    36817.2
                  ]
                ],
                "id": 547,
                "chat_link": "[&BCMCAAA=]"
              },
              "548": {
                "name": "Tyrant's Mount",
                "level": 57,
                "coord": [
                  52082.8,
                  37109.1
                ],
                "bounds": [
                  [
                    52043.6,
                    37185
                  ],
                  [
                    52133.4,
                    37063.8
                  ],
                  [
                    52043.5,
                    36933.6
                  ],
                  [
                    52016.7,
                    36837.4
                  ],
                  [
                    52135,
                    36769.8
                  ],
                  [
                    52291.1,
                    36817.7
                  ],
                  [
                    52259.8,
                    37126.8
                  ],
                  [
                    52311,
                    37444.4
                  ],
                  [
                    52046.4,
                    37436.6
                  ],
                  [
                    51823.2,
                    37347
                  ],
                  [
                    51807.4,
                    37238
                  ],
                  [
                    52043.6,
                    37185
                  ]
                ],
                "id": 548,
                "chat_link": "[&BCQCAAA=]"
              },
              "549": {
                "name": "Ural's Delve",
                "level": 57,
                "coord": [
                  51917,
                  36994.8
                ],
                "bounds": [
                  [
                    51724.6,
                    36979.4
                  ],
                  [
                    51733,
                    36924.1
                  ],
                  [
                    51816.6,
                    36787.7
                  ],
                  [
                    52022.1,
                    36832.1
                  ],
                  [
                    52047.3,
                    36929.9
                  ],
                  [
                    52139.8,
                    37069.1
                  ],
                  [
                    52041.3,
                    37191.5
                  ],
                  [
                    51811.4,
                    37245
                  ],
                  [
                    51724.6,
                    36979.4
                  ]
                ],
                "id": 549,
                "chat_link": "[&BCUCAAA=]"
              },
              "550": {
                "name": "Candle Chimney",
                "level": 57,
                "coord": [
                  51917.2,
                  36552.6
                ],
                "bounds": [
                  [
                    51817.1,
                    36790.4
                  ],
                  [
                    51789,
                    36708.1
                  ],
                  [
                    51725.9,
                    36457.8
                  ],
                  [
                    51758,
                    36197.3
                  ],
                  [
                    51897.1,
                    36209.8
                  ],
                  [
                    51927.8,
                    36376
                  ],
                  [
                    52187,
                    36625.7
                  ],
                  [
                    52136,
                    36770.3
                  ],
                  [
                    52016.8,
                    36837.9
                  ],
                  [
                    51817.1,
                    36790.4
                  ]
                ],
                "id": 550,
                "chat_link": "[&BCYCAAA=]"
              },
              "551": {
                "name": "Gyre Rapids",
                "level": 56,
                "coord": [
                  52298.8,
                  36493.3
                ],
                "bounds": [
                  [
                    52135.5,
                    36770.5
                  ],
                  [
                    52290.4,
                    36817.6
                  ],
                  [
                    52534.5,
                    36752.8
                  ],
                  [
                    52645.5,
                    36622.8
                  ],
                  [
                    52643.6,
                    36453.4
                  ],
                  [
                    52529.8,
                    36347.9
                  ],
                  [
                    52485.8,
                    36229
                  ],
                  [
                    52013.4,
                    36223.1
                  ],
                  [
                    51894.3,
                    36205.5
                  ],
                  [
                    51927.4,
                    36377.4
                  ],
                  [
                    52186.5,
                    36625.9
                  ],
                  [
                    52135.5,
                    36770.5
                  ]
                ],
                "id": 551,
                "chat_link": "[&BCcCAAA=]"
              },
              "552": {
                "name": "Stromkarl Heights",
                "level": 55,
                "coord": [
                  52700.7,
                  36484.1
                ],
                "bounds": [
                  [
                    52643.8,
                    36622.6
                  ],
                  [
                    52643.8,
                    36454.4
                  ],
                  [
                    52530.3,
                    36347.8
                  ],
                  [
                    52484.3,
                    36230.8
                  ],
                  [
                    52540.8,
                    36076.3
                  ],
                  [
                    52870,
                    36114
                  ],
                  [
                    52929.3,
                    36172.5
                  ],
                  [
                    52907.3,
                    36487.3
                  ],
                  [
                    52931.5,
                    36809
                  ],
                  [
                    52801.8,
                    36890.4
                  ],
                  [
                    52589.7,
                    36851.3
                  ],
                  [
                    52535.6,
                    36752.5
                  ],
                  [
                    52643.8,
                    36622.6
                  ]
                ],
                "id": 552,
                "chat_link": "[&BCgCAAA=]"
              },
              "553": {
                "name": "Hunting Banks",
                "level": 59,
                "coord": [
                  53212.3,
                  36586.3
                ],
                "bounds": [
                  [
                    52930.9,
                    36809.2
                  ],
                  [
                    53106.1,
                    36700.7
                  ],
                  [
                    53343.5,
                    36671.7
                  ],
                  [
                    53634.3,
                    36588.2
                  ],
                  [
                    53383.5,
                    36447
                  ],
                  [
                    53181,
                    36401
                  ],
                  [
                    52906.9,
                    36486.5
                  ],
                  [
                    52930.9,
                    36809.2
                  ]
                ],
                "id": 553,
                "chat_link": "[&BCkCAAA=]"
              },
              "554": {
                "name": "Naui Waters",
                "level": 54,
                "coord": [
                  53675.6,
                  36304.8
                ],
                "bounds": [
                  [
                    53351.7,
                    36140.3
                  ],
                  [
                    53452.3,
                    36039.3
                  ],
                  [
                    53592.3,
                    36032.4
                  ],
                  [
                    53884.9,
                    36095.8
                  ],
                  [
                    53988.1,
                    36289.1
                  ],
                  [
                    53943.9,
                    36518
                  ],
                  [
                    53849,
                    36590.5
                  ],
                  [
                    53635.2,
                    36591.6
                  ],
                  [
                    53383.3,
                    36446.7
                  ],
                  [
                    53351.7,
                    36140.3
                  ]
                ],
                "id": 554,
                "chat_link": "[&BCoCAAA=]"
              },
              "555": {
                "name": "Guilty Tears",
                "level": 53,
                "coord": [
                  53584.5,
                  35825.5
                ],
                "bounds": [
                  [
                    53198.8,
                    35785.9
                  ],
                  [
                    53180,
                    36040.4
                  ],
                  [
                    53352.2,
                    36140.8
                  ],
                  [
                    53452,
                    36040.2
                  ],
                  [
                    53592.2,
                    36032.8
                  ],
                  [
                    53891,
                    36096.7
                  ],
                  [
                    54004.4,
                    35770.8
                  ],
                  [
                    53947.5,
                    35771.6
                  ],
                  [
                    53732.8,
                    35611.9
                  ],
                  [
                    53738.8,
                    35503.5
                  ],
                  [
                    53548.4,
                    35514.3
                  ],
                  [
                    53375.6,
                    35597.3
                  ],
                  [
                    53198.8,
                    35785.9
                  ]
                ],
                "id": 555,
                "chat_link": "[&BCsCAAA=]"
              },
              "556": {
                "name": "Bynebrachen",
                "level": 54,
                "coord": [
                  53111.2,
                  36026.7
                ],
                "bounds": [
                  [
                    52907,
                    36486.3
                  ],
                  [
                    53180.9,
                    36402.1
                  ],
                  [
                    53383.6,
                    36447.3
                  ],
                  [
                    53352.9,
                    36141
                  ],
                  [
                    53180.6,
                    36040.3
                  ],
                  [
                    53199,
                    35785.5
                  ],
                  [
                    53376.1,
                    35597.4
                  ],
                  [
                    52964.9,
                    35474.8
                  ],
                  [
                    52879.6,
                    35632.9
                  ],
                  [
                    52869.5,
                    36113.8
                  ],
                  [
                    52929.1,
                    36172
                  ],
                  [
                    52907,
                    36486.3
                  ]
                ],
                "id": 556,
                "chat_link": "[&BCwCAAA=]"
              },
              "557": {
                "name": "Fionnghuala Scratch",
                "level": 54,
                "coord": [
                  52698.6,
                  35749.5
                ],
                "bounds": [
                  [
                    52428,
                    35639.7
                  ],
                  [
                    52648.6,
                    35444.7
                  ],
                  [
                    52965.8,
                    35474.4
                  ],
                  [
                    52880.7,
                    35632.3
                  ],
                  [
                    52872.3,
                    36123.8
                  ],
                  [
                    52538.7,
                    36086.5
                  ],
                  [
                    52556.3,
                    35845.2
                  ],
                  [
                    52428,
                    35639.7
                  ]
                ],
                "id": 557,
                "chat_link": "[&BC0CAAA=]"
              },
              "558": {
                "name": "Fisher's Eye Bridges",
                "level": 55,
                "coord": [
                  52128.5,
                  35958.3
                ],
                "bounds": [
                  [
                    51759,
                    36201.6
                  ],
                  [
                    52013.3,
                    36223
                  ],
                  [
                    52485.8,
                    36228.8
                  ],
                  [
                    52544.9,
                    36081.1
                  ],
                  [
                    52556.9,
                    35845.5
                  ],
                  [
                    52428.2,
                    35639.3
                  ],
                  [
                    51887.8,
                    35707.4
                  ],
                  [
                    51730,
                    35712.8
                  ],
                  [
                    51750.5,
                    35984.7
                  ],
                  [
                    51759,
                    36201.6
                  ]
                ],
                "id": 558,
                "chat_link": "[&BC4CAAA=]"
              },
              "559": {
                "name": "Gentle River",
                "level": 53,
                "coord": [
                  52313.6,
                  35146.7
                ],
                "bounds": [
                  [
                    51824.6,
                    35283.9
                  ],
                  [
                    52096,
                    35280.7
                  ],
                  [
                    52333.8,
                    35083.8
                  ],
                  [
                    52387.9,
                    34592.4
                  ],
                  [
                    52504.8,
                    34544.4
                  ],
                  [
                    52760.2,
                    34569.3
                  ],
                  [
                    52902.4,
                    34514.1
                  ],
                  [
                    52898.9,
                    34889.6
                  ],
                  [
                    52822.9,
                    34871.1
                  ],
                  [
                    52651.1,
                    35445.8
                  ],
                  [
                    52428,
                    35640.5
                  ],
                  [
                    51887.7,
                    35707.3
                  ],
                  [
                    51739.2,
                    35713.7
                  ],
                  [
                    51711.1,
                    35625.2
                  ],
                  [
                    51755.5,
                    35439.4
                  ],
                  [
                    51824.6,
                    35283.9
                  ]
                ],
                "id": 559,
                "chat_link": "[&BC8CAAA=]"
              },
              "560": {
                "name": "Krongar Pass",
                "level": 53,
                "coord": [
                  51981.8,
                  34882.7
                ],
                "bounds": [
                  [
                    51730.4,
                    34910.8
                  ],
                  [
                    51745.9,
                    34639.2
                  ],
                  [
                    51836.8,
                    34504.2
                  ],
                  [
                    52112.8,
                    34499.3
                  ],
                  [
                    52395.1,
                    34567.7
                  ],
                  [
                    52333,
                    35085.4
                  ],
                  [
                    52095.2,
                    35281.8
                  ],
                  [
                    51824.7,
                    35283.8
                  ],
                  [
                    51762.3,
                    35172.6
                  ],
                  [
                    51730.4,
                    34910.8
                  ]
                ],
                "id": 560,
                "chat_link": "[&BDACAAA=]"
              },
              "561": {
                "name": "White Paper Hill",
                "level": 53,
                "coord": [
                  53107.1,
                  35301.8
                ],
                "bounds": [
                  [
                    52820.1,
                    34867.9
                  ],
                  [
                    52967.9,
                    34886.7
                  ],
                  [
                    53038.1,
                    35256.2
                  ],
                  [
                    53498.2,
                    35358.6
                  ],
                  [
                    53552.5,
                    35513.9
                  ],
                  [
                    53375.5,
                    35603.2
                  ],
                  [
                    52959.5,
                    35479
                  ],
                  [
                    52644.9,
                    35449.3
                  ],
                  [
                    52820.1,
                    34867.9
                  ]
                ],
                "id": 561,
                "chat_link": "[&BDECAAA=]"
              },
              "562": {
                "name": "The Iron Veil",
                "level": 52,
                "coord": [
                  53237,
                  34875.6
                ],
                "bounds": [
                  [
                    52902.6,
                    34515.3
                  ],
                  [
                    53198.2,
                    34602.6
                  ],
                  [
                    53298.9,
                    34479.7
                  ],
                  [
                    53445.5,
                    34462.8
                  ],
                  [
                    53539.9,
                    34761.4
                  ],
                  [
                    53277.7,
                    34876.7
                  ],
                  [
                    53283.8,
                    35132
                  ],
                  [
                    53512.3,
                    35282.5
                  ],
                  [
                    53497.9,
                    35362.3
                  ],
                  [
                    53030,
                    35257.6
                  ],
                  [
                    52963.6,
                    34890
                  ],
                  [
                    52893.5,
                    34883.8
                  ],
                  [
                    52902.6,
                    34515.3
                  ]
                ],
                "id": 562,
                "chat_link": "[&BDICAAA=]"
              },
              "564": {
                "name": "Molodets Excavation",
                "level": 52,
                "coord": [
                  53548.2,
                  35204.8
                ],
                "bounds": [
                  [
                    53497.6,
                    35361.6
                  ],
                  [
                    53512.4,
                    35282
                  ],
                  [
                    53283,
                    35133.3
                  ],
                  [
                    53277.7,
                    34876.8
                  ],
                  [
                    53540,
                    34760.9
                  ],
                  [
                    53725.1,
                    35054.8
                  ],
                  [
                    53811.7,
                    35356.3
                  ],
                  [
                    53738.4,
                    35503.9
                  ],
                  [
                    53547.8,
                    35513.8
                  ],
                  [
                    53497.6,
                    35361.6
                  ]
                ],
                "id": 564,
                "chat_link": "[&BDQCAAA=]"
              },
              "565": {
                "name": "The Foundation Stones",
                "level": 55,
                "coord": [
                  53877.2,
                  35470.2
                ],
                "bounds": [
                  [
                    53738.1,
                    35501.8
                  ],
                  [
                    53811.8,
                    35355.2
                  ],
                  [
                    53891.4,
                    35255
                  ],
                  [
                    53984.4,
                    35239.1
                  ],
                  [
                    53982.3,
                    35426.9
                  ],
                  [
                    53933.7,
                    35597.2
                  ],
                  [
                    53946.5,
                    35773.3
                  ],
                  [
                    53729.8,
                    35613
                  ],
                  [
                    53738.1,
                    35501.8
                  ]
                ],
                "id": 565,
                "chat_link": "[&BDUCAAA=]"
              },
              "1023": {
                "name": "Sector Zuhl",
                "level": 52,
                "coord": [
                  53895.5,
                  34837.3
                ],
                "bounds": [
                  [
                    53537.2,
                    34768
                  ],
                  [
                    53472.8,
                    34561.7
                  ],
                  [
                    53923,
                    34364.8
                  ],
                  [
                    54300.7,
                    34464.3
                  ],
                  [
                    54156.9,
                    34585
                  ],
                  [
                    54068.2,
                    34702.5
                  ],
                  [
                    54005.3,
                    34827.8
                  ],
                  [
                    53965.7,
                    35244.5
                  ],
                  [
                    53891.8,
                    35256.4
                  ],
                  [
                    53809.4,
                    35375.9
                  ],
                  [
                    53719.2,
                    35059.7
                  ],
                  [
                    53537.2,
                    34768
                  ]
                ],
                "id": 1023,
                "chat_link": "[&BP8DAAA=]"
              }
            },
            "adventures": [],
            "id": 1092,
            "mastery_points": []
          },
          "1093": {
            "name": "Angvar's Trove",
            "min_level": 15,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              52480,
              28672
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                50432,
                27648
              ],
              [
                54528,
                29696
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "218": {
                "name": "Skradden Slopes",
                "level": 24,
                "coord": [
                  50795.2,
                  29007.4
                ],
                "bounds": [
                  [
                    51098.6,
                    28729.4
                  ],
                  [
                    51088.5,
                    28558.8
                  ],
                  [
                    50963.1,
                    28443.5
                  ],
                  [
                    50818.5,
                    28647.1
                  ],
                  [
                    50439.7,
                    28686.4
                  ],
                  [
                    50436.4,
                    29082.7
                  ],
                  [
                    50356.2,
                    29132.5
                  ],
                  [
                    50375.1,
                    29340.2
                  ],
                  [
                    50589.5,
                    29194.6
                  ],
                  [
                    50700.6,
                    29293.7
                  ],
                  [
                    50961,
                    29420.3
                  ],
                  [
                    51099.5,
                    29338.3
                  ],
                  [
                    51004.8,
                    29214.5
                  ],
                  [
                    51025.5,
                    29076.6
                  ],
                  [
                    50971.7,
                    28952.1
                  ],
                  [
                    51098.6,
                    28729.4
                  ]
                ],
                "id": 218,
                "chat_link": "[&BNoAAAA=]"
              },
              "219": {
                "name": "Glisterice Caves",
                "level": 24,
                "coord": [
                  50659,
                  29483.5
                ],
                "bounds": [
                  [
                    50961.3,
                    29414.1
                  ],
                  [
                    50697,
                    29288.8
                  ],
                  [
                    50593.8,
                    29191
                  ],
                  [
                    50372.6,
                    29336.8
                  ],
                  [
                    50312.3,
                    29661.3
                  ],
                  [
                    50659.4,
                    29796.2
                  ],
                  [
                    51016.6,
                    29696
                  ],
                  [
                    50961.3,
                    29414.1
                  ]
                ],
                "id": 219,
                "chat_link": "[&BNsAAAA=]"
              },
              "220": {
                "name": "The Frozen Sweeps",
                "level": 24,
                "coord": [
                  51359.9,
                  28989
                ],
                "bounds": [
                  [
                    51100.5,
                    29342.2
                  ],
                  [
                    51149.7,
                    29298.5
                  ],
                  [
                    51588.9,
                    29311.2
                  ],
                  [
                    51770.3,
                    29223.4
                  ],
                  [
                    51789.8,
                    28917.2
                  ],
                  [
                    51643.6,
                    28869.2
                  ],
                  [
                    51655.7,
                    28601.7
                  ],
                  [
                    51490.9,
                    28602
                  ],
                  [
                    51400.9,
                    28712.5
                  ],
                  [
                    51096,
                    28728.2
                  ],
                  [
                    50966.9,
                    28954.1
                  ],
                  [
                    51021.4,
                    29080.2
                  ],
                  [
                    51004,
                    29216.2
                  ],
                  [
                    51100.5,
                    29342.2
                  ]
                ],
                "id": 220,
                "chat_link": "[&BNwAAAA=]"
              },
              "221": {
                "name": "Molengrad",
                "level": 24,
                "coord": [
                  51212.2,
                  29527.5
                ],
                "bounds": [
                  [
                    51017.4,
                    29696
                  ],
                  [
                    50957.3,
                    29414.6
                  ],
                  [
                    51149.3,
                    29300.3
                  ],
                  [
                    51315.9,
                    29302
                  ],
                  [
                    51533.1,
                    29679.1
                  ],
                  [
                    51300.2,
                    29772.9
                  ],
                  [
                    51017.4,
                    29696
                  ]
                ],
                "id": 221,
                "chat_link": "[&BN0AAAA=]"
              },
              "222": {
                "name": "Jormabakke Stead",
                "level": 24,
                "coord": [
                  51304.6,
                  28552
                ],
                "bounds": [
                  [
                    51085.6,
                    28557.5
                  ],
                  [
                    51198,
                    28395.3
                  ],
                  [
                    51359.2,
                    28373.3
                  ],
                  [
                    51493.5,
                    28484
                  ],
                  [
                    51495.4,
                    28604.3
                  ],
                  [
                    51405.8,
                    28718.4
                  ],
                  [
                    51095,
                    28731.4
                  ],
                  [
                    51085.6,
                    28557.5
                  ]
                ],
                "id": 222,
                "chat_link": "[&BN4AAAA=]"
              },
              "223": {
                "name": "Isenfall Gullies",
                "level": 25,
                "coord": [
                  51274.5,
                  28320
                ],
                "bounds": [
                  [
                    51490.4,
                    28603.2
                  ],
                  [
                    51655.1,
                    28607.1
                  ],
                  [
                    51731,
                    28372.3
                  ],
                  [
                    51469.2,
                    28024
                  ],
                  [
                    51239.7,
                    28080.5
                  ],
                  [
                    51201.5,
                    28131.8
                  ],
                  [
                    50952,
                    28078.2
                  ],
                  [
                    50827.6,
                    28080.5
                  ],
                  [
                    50862.7,
                    28360.8
                  ],
                  [
                    51091.6,
                    28565.8
                  ],
                  [
                    51199,
                    28396
                  ],
                  [
                    51359.6,
                    28377.3
                  ],
                  [
                    51489.7,
                    28482.8
                  ],
                  [
                    51490.4,
                    28603.2
                  ]
                ],
                "id": 223,
                "chat_link": "[&BN8AAAA=]"
              },
              "224": {
                "name": "Darkhoof Heights",
                "level": 25,
                "coord": [
                  51176.4,
                  27940.2
                ],
                "bounds": [
                  [
                    50927.7,
                    27905.4
                  ],
                  [
                    50984.4,
                    27810.3
                  ],
                  [
                    51111.4,
                    27851.6
                  ],
                  [
                    51355.9,
                    27699.8
                  ],
                  [
                    51505.8,
                    27815.2
                  ],
                  [
                    51470.3,
                    28024.7
                  ],
                  [
                    51243.8,
                    28082.2
                  ],
                  [
                    51201.3,
                    28135.3
                  ],
                  [
                    50945.7,
                    28080.1
                  ],
                  [
                    51017.8,
                    27997.8
                  ],
                  [
                    50927.7,
                    27905.4
                  ]
                ],
                "id": 224,
                "chat_link": "[&BOAAAAA=]"
              },
              "226": {
                "name": "Lornar's Gate",
                "level": 22,
                "coord": [
                  51796,
                  29351
                ],
                "bounds": [
                  [
                    51309.3,
                    29301.4
                  ],
                  [
                    51590.7,
                    29307.5
                  ],
                  [
                    51768.4,
                    29222
                  ],
                  [
                    51786.2,
                    29007.7
                  ],
                  [
                    52044.5,
                    29069.3
                  ],
                  [
                    51982.1,
                    29272.8
                  ],
                  [
                    52091.8,
                    29506.2
                  ],
                  [
                    52066.2,
                    29798.1
                  ],
                  [
                    51524.6,
                    29673.9
                  ],
                  [
                    51309.3,
                    29301.4
                  ]
                ],
                "id": 226,
                "chat_link": "[&BOIAAAA=]"
              },
              "227": {
                "name": "Isenfall Lake",
                "level": 22,
                "coord": [
                  51866,
                  28185.4
                ],
                "bounds": [
                  [
                    52056.7,
                    28112.5
                  ],
                  [
                    52192.4,
                    27939.1
                  ],
                  [
                    52158.1,
                    27682.1
                  ],
                  [
                    52018.5,
                    27680.2
                  ],
                  [
                    52007,
                    27762.9
                  ],
                  [
                    51882.5,
                    27826.6
                  ],
                  [
                    51759.7,
                    27663.5
                  ],
                  [
                    51534.6,
                    27724.9
                  ],
                  [
                    51468,
                    28023.3
                  ],
                  [
                    51728.3,
                    28372.5
                  ],
                  [
                    51657.1,
                    28598
                  ],
                  [
                    51642.4,
                    28867.6
                  ],
                  [
                    51791.8,
                    28918.1
                  ],
                  [
                    51884,
                    28754.8
                  ],
                  [
                    52087.8,
                    28630.3
                  ],
                  [
                    51987.1,
                    28409.6
                  ],
                  [
                    52056.7,
                    28112.5
                  ]
                ],
                "id": 227,
                "chat_link": "[&BOMAAAA=]"
              },
              "228": {
                "name": "Hrothgar's Pass",
                "level": 22,
                "coord": [
                  52276,
                  28793.6
                ],
                "bounds": [
                  [
                    52461.1,
                    29023.5
                  ],
                  [
                    52291.1,
                    28967.1
                  ],
                  [
                    52049.6,
                    29069.2
                  ],
                  [
                    51785.3,
                    29008.9
                  ],
                  [
                    51787.1,
                    28915.1
                  ],
                  [
                    51884.2,
                    28755.3
                  ],
                  [
                    52087.1,
                    28629.8
                  ],
                  [
                    52040,
                    28528.3
                  ],
                  [
                    52476.2,
                    28451.5
                  ],
                  [
                    52646.5,
                    28737.1
                  ],
                  [
                    52852.2,
                    28651
                  ],
                  [
                    52950.9,
                    28786
                  ],
                  [
                    52461.1,
                    29023.5
                  ]
                ],
                "id": 228,
                "chat_link": "[&BOQAAAA=]"
              },
              "229": {
                "name": "Valslake",
                "level": 20,
                "coord": [
                  52628.5,
                  29295.9
                ],
                "bounds": [
                  [
                    52046,
                    29069
                  ],
                  [
                    52290.9,
                    28967.9
                  ],
                  [
                    52461.5,
                    29021.2
                  ],
                  [
                    52943.5,
                    28775.7
                  ],
                  [
                    53379.5,
                    29026.6
                  ],
                  [
                    53339,
                    29259.4
                  ],
                  [
                    53165.7,
                    29204.3
                  ],
                  [
                    52922.2,
                    29290
                  ],
                  [
                    52753.9,
                    29461.2
                  ],
                  [
                    52761.7,
                    29690.8
                  ],
                  [
                    52597,
                    29800.6
                  ],
                  [
                    52065.5,
                    29795
                  ],
                  [
                    52090.4,
                    29508.8
                  ],
                  [
                    51982,
                    29272.4
                  ],
                  [
                    52046,
                    29069
                  ]
                ],
                "id": 229,
                "chat_link": "[&BOUAAAA=]"
              },
              "230": {
                "name": "Oros Spurs",
                "level": 20,
                "coord": [
                  52333.9,
                  28115.7
                ],
                "bounds": [
                  [
                    52524.6,
                    28274.1
                  ],
                  [
                    52475.6,
                    28455
                  ],
                  [
                    52041.8,
                    28531.1
                  ],
                  [
                    51980.2,
                    28413.9
                  ],
                  [
                    52059,
                    28129.5
                  ],
                  [
                    52190.8,
                    27938.2
                  ],
                  [
                    52154.5,
                    27753.4
                  ],
                  [
                    52580.3,
                    27761.2
                  ],
                  [
                    52651.4,
                    27810.8
                  ],
                  [
                    52681.1,
                    28089.8
                  ],
                  [
                    52524.6,
                    28274.1
                  ]
                ],
                "id": 230,
                "chat_link": "[&BOYAAAA=]"
              },
              "231": {
                "name": "Vitpeln Hills",
                "level": 19,
                "coord": [
                  52872.5,
                  28413.4
                ],
                "bounds": [
                  [
                    53234.1,
                    28282.1
                  ],
                  [
                    53063.5,
                    28348
                  ],
                  [
                    52677,
                    28090.3
                  ],
                  [
                    52520.9,
                    28280.2
                  ],
                  [
                    52472.8,
                    28459.1
                  ],
                  [
                    52648.6,
                    28748.4
                  ],
                  [
                    53139.6,
                    28551.3
                  ],
                  [
                    53223.4,
                    28547.6
                  ],
                  [
                    53234.1,
                    28282.1
                  ]
                ],
                "id": 231,
                "chat_link": "[&BOcAAAA=]"
              },
              "232": {
                "name": "The Loneholme Range",
                "level": 17,
                "coord": [
                  52968.4,
                  27819.3
                ],
                "bounds": [
                  [
                    53148.6,
                    28078.7
                  ],
                  [
                    53284.8,
                    27774.5
                  ],
                  [
                    53164.9,
                    27568.5
                  ],
                  [
                    53112.1,
                    27613.9
                  ],
                  [
                    53024.1,
                    27651.3
                  ],
                  [
                    52921.9,
                    27681.2
                  ],
                  [
                    52824.8,
                    27691.5
                  ],
                  [
                    52642.7,
                    27809.9
                  ],
                  [
                    52677.1,
                    28091.6
                  ],
                  [
                    52883.3,
                    28231.6
                  ],
                  [
                    53148.6,
                    28078.7
                  ]
                ],
                "id": 232,
                "chat_link": "[&BOgAAAA=]"
              },
              "233": {
                "name": "Dragon's Rising",
                "level": 17,
                "coord": [
                  53362.2,
                  27751.4
                ],
                "bounds": [
                  [
                    53144.6,
                    28077.2
                  ],
                  [
                    53276,
                    27769.9
                  ],
                  [
                    53168.8,
                    27582.6
                  ],
                  [
                    53288.3,
                    27507.5
                  ],
                  [
                    53379,
                    27427.9
                  ],
                  [
                    53455,
                    27368.8
                  ],
                  [
                    53505.8,
                    27394.9
                  ],
                  [
                    53551.9,
                    27441.7
                  ],
                  [
                    53626.5,
                    27638.3
                  ],
                  [
                    53610.2,
                    27882.2
                  ],
                  [
                    53758.8,
                    28104.7
                  ],
                  [
                    53063.7,
                    28341.5
                  ],
                  [
                    52880.6,
                    28231.1
                  ],
                  [
                    53144.6,
                    28077.2
                  ]
                ],
                "id": 233,
                "chat_link": "[&BOkAAAA=]"
              },
              "234": {
                "name": "Jotun's Vista",
                "level": 18,
                "coord": [
                  53168.8,
                  28722.5
                ],
                "bounds": [
                  [
                    53502.1,
                    28776.6
                  ],
                  [
                    53222.8,
                    28538.7
                  ],
                  [
                    53142.3,
                    28545.6
                  ],
                  [
                    52833.2,
                    28659.9
                  ],
                  [
                    52935.4,
                    28786.6
                  ],
                  [
                    53376.8,
                    29027.5
                  ],
                  [
                    53502.1,
                    28776.6
                  ]
                ],
                "id": 234,
                "chat_link": "[&BOoAAAA=]"
              },
              "235": {
                "name": "Tromigar Valley",
                "level": 16,
                "coord": [
                  53857.4,
                  28354.8
                ],
                "bounds": [
                  [
                    53223.5,
                    28540.5
                  ],
                  [
                    53502.7,
                    28777.5
                  ],
                  [
                    53731.9,
                    28686.5
                  ],
                  [
                    54221.6,
                    28613.8
                  ],
                  [
                    54347.1,
                    28374
                  ],
                  [
                    54174.5,
                    28332.3
                  ],
                  [
                    54192.2,
                    28198.6
                  ],
                  [
                    54103.2,
                    28008.7
                  ],
                  [
                    53942.8,
                    27993.1
                  ],
                  [
                    53755.8,
                    28101
                  ],
                  [
                    53235.7,
                    28277
                  ],
                  [
                    53223.5,
                    28540.5
                  ]
                ],
                "id": 235,
                "chat_link": "[&BOsAAAA=]"
              },
              "236": {
                "name": "Song of Final Exile",
                "level": 20,
                "coord": [
                  53053.8,
                  29466.9
                ],
                "bounds": [
                  [
                    53166.5,
                    29202.5
                  ],
                  [
                    53343.4,
                    29256
                  ],
                  [
                    53188.9,
                    29562.9
                  ],
                  [
                    53242.6,
                    29819.5
                  ],
                  [
                    52759.6,
                    29689.7
                  ],
                  [
                    52756.3,
                    29447.7
                  ],
                  [
                    52919.3,
                    29289.7
                  ],
                  [
                    53166.5,
                    29202.5
                  ]
                ],
                "id": 236,
                "chat_link": "[&BOwAAAA=]"
              },
              "237": {
                "name": "Griffonfall",
                "level": 18,
                "coord": [
                  53563.9,
                  29459.6
                ],
                "bounds": [
                  [
                    53340.5,
                    29254.3
                  ],
                  [
                    53188,
                    29561.8
                  ],
                  [
                    53222.1,
                    29798.9
                  ],
                  [
                    53753.4,
                    29685.5
                  ],
                  [
                    53743.1,
                    29525
                  ],
                  [
                    53847.4,
                    29387.9
                  ],
                  [
                    53818.2,
                    29192.7
                  ],
                  [
                    53598.3,
                    29270.8
                  ],
                  [
                    53340.5,
                    29254.3
                  ]
                ],
                "id": 237,
                "chat_link": "[&BO0AAAA=]"
              },
              "238": {
                "name": "Reaver's Dale",
                "level": 18,
                "coord": [
                  53702.8,
                  29005.9
                ],
                "bounds": [
                  [
                    53493.4,
                    28768.2
                  ],
                  [
                    53725.8,
                    28680.7
                  ],
                  [
                    53803.3,
                    28806.9
                  ],
                  [
                    54159.2,
                    28947.5
                  ],
                  [
                    54014.3,
                    29093
                  ],
                  [
                    53817.9,
                    29195.6
                  ],
                  [
                    53596.5,
                    29277.4
                  ],
                  [
                    53340.3,
                    29256.5
                  ],
                  [
                    53374.8,
                    29027.7
                  ],
                  [
                    53493.4,
                    28768.2
                  ]
                ],
                "id": 238,
                "chat_link": "[&BO4AAAA=]"
              },
              "239": {
                "name": "Owl's Abattoir",
                "level": 19,
                "coord": [
                  54161.3,
                  29313.7
                ],
                "bounds": [
                  [
                    53742.3,
                    29524.6
                  ],
                  [
                    53749.2,
                    29690
                  ],
                  [
                    54265,
                    29883.3
                  ],
                  [
                    54580,
                    29724.4
                  ],
                  [
                    54697.2,
                    29253.6
                  ],
                  [
                    54576.5,
                    28623.7
                  ],
                  [
                    54322.5,
                    28764.6
                  ],
                  [
                    54014.1,
                    29092.3
                  ],
                  [
                    53817.4,
                    29192
                  ],
                  [
                    53848.6,
                    29388.1
                  ],
                  [
                    53742.3,
                    29524.6
                  ]
                ],
                "id": 239,
                "chat_link": "[&BO8AAAA=]"
              },
              "240": {
                "name": "Villmark Foothills",
                "level": 17,
                "coord": [
                  54043,
                  28764.2
                ],
                "bounds": [
                  [
                    54216.1,
                    28608.4
                  ],
                  [
                    54322.1,
                    28765.2
                  ],
                  [
                    54158.2,
                    28947.5
                  ],
                  [
                    53798.2,
                    28815.9
                  ],
                  [
                    53720.7,
                    28684.2
                  ],
                  [
                    54216.1,
                    28608.4
                  ]
                ],
                "id": 240,
                "chat_link": "[&BPAAAAA=]"
              },
              "241": {
                "name": "Hunter's Pitfalls",
                "level": 15,
                "coord": [
                  54406.9,
                  28026.6
                ],
                "bounds": [
                  [
                    54102.5,
                    28007.9
                  ],
                  [
                    54189.7,
                    28199.2
                  ],
                  [
                    54169.1,
                    28336.2
                  ],
                  [
                    54348.5,
                    28378.4
                  ],
                  [
                    54426.1,
                    28230.8
                  ],
                  [
                    54516.1,
                    28249.2
                  ],
                  [
                    54562.2,
                    28063.3
                  ],
                  [
                    54647.6,
                    27983.4
                  ],
                  [
                    54650,
                    27857.8
                  ],
                  [
                    54567.7,
                    27772.9
                  ],
                  [
                    54543.9,
                    27589.7
                  ],
                  [
                    54159.4,
                    27650.3
                  ],
                  [
                    54102.5,
                    28007.9
                  ]
                ],
                "id": 241,
                "chat_link": "[&BPEAAAA=]"
              },
              "242": {
                "name": "Trapper's Labyrinth",
                "level": 16,
                "coord": [
                  53848.1,
                  27821.1
                ],
                "bounds": [
                  [
                    53760.4,
                    28107.7
                  ],
                  [
                    53608.6,
                    27881.3
                  ],
                  [
                    53620.9,
                    27630.3
                  ],
                  [
                    53721.9,
                    27648
                  ],
                  [
                    53869.9,
                    27648
                  ],
                  [
                    54158.6,
                    27648.9
                  ],
                  [
                    54103.4,
                    28008.4
                  ],
                  [
                    53941,
                    27996.1
                  ],
                  [
                    53760.4,
                    28107.7
                  ]
                ],
                "id": 242,
                "chat_link": "[&BPIAAAA=]"
              },
              "340": {
                "name": "Ossencrest Climb",
                "level": 24,
                "coord": [
                  50616.3,
                  28310.2
                ],
                "bounds": [
                  [
                    50831.9,
                    28081.4
                  ],
                  [
                    50863.9,
                    28360.4
                  ],
                  [
                    50975.1,
                    28448.4
                  ],
                  [
                    50815,
                    28662.7
                  ],
                  [
                    50437.8,
                    28689.8
                  ],
                  [
                    50391,
                    28581.7
                  ],
                  [
                    50345,
                    28432.8
                  ],
                  [
                    50563.5,
                    28307.7
                  ],
                  [
                    50592,
                    28226.8
                  ],
                  [
                    50502.6,
                    28169
                  ],
                  [
                    50437.7,
                    28069.6
                  ],
                  [
                    50536.8,
                    27993.4
                  ],
                  [
                    50719.1,
                    28009.4
                  ],
                  [
                    50831.9,
                    28081.4
                  ]
                ],
                "id": 340,
                "chat_link": "[&BFQBAAA=]"
              },
              "1015": {
                "name": "King Jalis's Refuge",
                "level": 19,
                "coord": [
                  54441.8,
                  28495.8
                ],
                "bounds": [
                  [
                    54211.1,
                    28608.1
                  ],
                  [
                    54422.3,
                    28226.1
                  ],
                  [
                    54568.6,
                    28258.2
                  ],
                  [
                    54629.5,
                    28445.2
                  ],
                  [
                    54497.3,
                    28671.9
                  ],
                  [
                    54322.1,
                    28765.2
                  ],
                  [
                    54211.1,
                    28608.1
                  ]
                ],
                "id": 1015,
                "chat_link": "[&BPcDAAA=]"
              },
              "1106": {
                "name": "Angvar's Trove",
                "level": 0,
                "coord": [
                  50749.6,
                  27947.3
                ],
                "bounds": [
                  [
                    50593.2,
                    28225.8
                  ],
                  [
                    50562.2,
                    28313.3
                  ],
                  [
                    50346.7,
                    28220.2
                  ],
                  [
                    50265.4,
                    28037.3
                  ],
                  [
                    50282.2,
                    27608.1
                  ],
                  [
                    50698.1,
                    27415.3
                  ],
                  [
                    51340.7,
                    27543
                  ],
                  [
                    51357.3,
                    27705.4
                  ],
                  [
                    51114.3,
                    27856.9
                  ],
                  [
                    50984.3,
                    27820.7
                  ],
                  [
                    50933.5,
                    27906.5
                  ],
                  [
                    51021.9,
                    27998.5
                  ],
                  [
                    50952.6,
                    28069.6
                  ],
                  [
                    50833.9,
                    28083.8
                  ],
                  [
                    50721.5,
                    28012.2
                  ],
                  [
                    50538.3,
                    27996
                  ],
                  [
                    50439.8,
                    28070.5
                  ],
                  [
                    50506.7,
                    28167.9
                  ],
                  [
                    50593.2,
                    28225.8
                  ]
                ],
                "id": 1106,
                "chat_link": "[&BFIEAAA=]"
              }
            },
            "id": 1093,
            "mastery_points": [],
            "adventures": []
          },
          "1100": {
            "name": "Scratch Sentry Defense",
            "min_level": 50,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              52864,
              36160
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                51712,
                34560
              ],
              [
                54016,
                37760
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "539": {
                "name": "Talus Waterslide",
                "level": 60,
                "coord": [
                  52019.1,
                  37614
                ],
                "bounds": [
                  [
                    52134.8,
                    37860.4
                  ],
                  [
                    51848.6,
                    37818.3
                  ],
                  [
                    51816,
                    37670.9
                  ],
                  [
                    51736,
                    37507.2
                  ],
                  [
                    51822.5,
                    37346.7
                  ],
                  [
                    52046.8,
                    37436.5
                  ],
                  [
                    52312.1,
                    37443.5
                  ],
                  [
                    52229.3,
                    37682.8
                  ],
                  [
                    52225.7,
                    37759.3
                  ],
                  [
                    52134.8,
                    37860.4
                  ]
                ],
                "id": 539,
                "chat_link": "[&BBsCAAA=]"
              },
              "540": {
                "name": "Malorean Wilds",
                "level": 58,
                "coord": [
                  52450.5,
                  37608
                ],
                "bounds": [
                  [
                    52439.5,
                    37404.6
                  ],
                  [
                    52627.2,
                    37480.5
                  ],
                  [
                    52671.3,
                    37656.1
                  ],
                  [
                    52648.7,
                    37829.1
                  ],
                  [
                    52225.7,
                    37759.4
                  ],
                  [
                    52229.4,
                    37683
                  ],
                  [
                    52311.6,
                    37443.3
                  ],
                  [
                    52439.5,
                    37404.6
                  ]
                ],
                "id": 540,
                "chat_link": "[&BBwCAAA=]"
              },
              "541": {
                "name": "Serpent Stones",
                "level": 59,
                "coord": [
                  52758.9,
                  37436.8
                ],
                "bounds": [
                  [
                    52439.5,
                    37404.7
                  ],
                  [
                    52492.9,
                    37266.3
                  ],
                  [
                    52642.5,
                    37155.6
                  ],
                  [
                    52740,
                    37205
                  ],
                  [
                    52883.5,
                    37185.4
                  ],
                  [
                    53087.8,
                    37333.9
                  ],
                  [
                    53042.3,
                    37441.5
                  ],
                  [
                    52953.5,
                    37527
                  ],
                  [
                    52881.4,
                    37755.9
                  ],
                  [
                    52645.3,
                    37828.9
                  ],
                  [
                    52671.3,
                    37656.4
                  ],
                  [
                    52626.5,
                    37480.6
                  ],
                  [
                    52439.5,
                    37404.7
                  ]
                ],
                "id": 541,
                "chat_link": "[&BB0CAAA=]"
              },
              "542": {
                "name": "Mellaggan's Grotto",
                "level": 59,
                "coord": [
                  53329.3,
                  37571.3
                ],
                "bounds": [
                  [
                    53042.1,
                    37440.1
                  ],
                  [
                    53087.8,
                    37333.3
                  ],
                  [
                    53593,
                    37309
                  ],
                  [
                    53736.7,
                    37493.6
                  ],
                  [
                    53836.3,
                    37634.3
                  ],
                  [
                    53656.3,
                    37829.4
                  ],
                  [
                    53176.7,
                    37824.6
                  ],
                  [
                    52882.4,
                    37750.8
                  ],
                  [
                    52952.8,
                    37526.8
                  ],
                  [
                    53042.1,
                    37440.1
                  ]
                ],
                "id": 542,
                "chat_link": "[&BB4CAAA=]"
              },
              "543": {
                "name": "Lair of the Coil",
                "level": 60,
                "coord": [
                  53858.9,
                  37394.2
                ],
                "bounds": [
                  [
                    53736.2,
                    37494.3
                  ],
                  [
                    53825.5,
                    37616
                  ],
                  [
                    53938.5,
                    37532.7
                  ],
                  [
                    54050.7,
                    37417.1
                  ],
                  [
                    54049.1,
                    37299
                  ],
                  [
                    54007.7,
                    37262.9
                  ],
                  [
                    53671.3,
                    37221.8
                  ],
                  [
                    53592,
                    37309.5
                  ],
                  [
                    53736.2,
                    37494.3
                  ]
                ],
                "id": 543,
                "chat_link": "[&BB8CAAA=]"
              },
              "544": {
                "name": "Tail of the Serpent",
                "level": 60,
                "coord": [
                  53957.2,
                  37018.3
                ],
                "bounds": [
                  [
                    53927.5,
                    36975.4
                  ],
                  [
                    53931.7,
                    36721.5
                  ],
                  [
                    54010.1,
                    36773
                  ],
                  [
                    54051.4,
                    36870.5
                  ],
                  [
                    54055.3,
                    37184.3
                  ],
                  [
                    54007.1,
                    37263.9
                  ],
                  [
                    53794.4,
                    37237.9
                  ],
                  [
                    53880.4,
                    37119.8
                  ],
                  [
                    53927.5,
                    36975.4
                  ]
                ],
                "id": 544,
                "chat_link": "[&BCACAAA=]"
              },
              "545": {
                "name": "Scale Strand",
                "level": 60,
                "coord": [
                  53786.5,
                  36934.6
                ],
                "bounds": [
                  [
                    53932.3,
                    36721.4
                  ],
                  [
                    53849.8,
                    36583.3
                  ],
                  [
                    53637.4,
                    36586.1
                  ],
                  [
                    53666.5,
                    36835.1
                  ],
                  [
                    53758,
                    36931.9
                  ],
                  [
                    53745.6,
                    37133.6
                  ],
                  [
                    53671.7,
                    37220.2
                  ],
                  [
                    53794.5,
                    37238.4
                  ],
                  [
                    53880.1,
                    37120.2
                  ],
                  [
                    53928.8,
                    36975.4
                  ],
                  [
                    53932.3,
                    36721.4
                  ]
                ],
                "id": 545,
                "chat_link": "[&BCECAAA=]"
              },
              "546": {
                "name": "Nonmoa Lake",
                "level": 60,
                "coord": [
                  53362.7,
                  36957.2
                ],
                "bounds": [
                  [
                    53087.1,
                    37333.3
                  ],
                  [
                    53593.5,
                    37309.4
                  ],
                  [
                    53749.4,
                    37136.3
                  ],
                  [
                    53758.2,
                    36931.3
                  ],
                  [
                    53667.2,
                    36835.3
                  ],
                  [
                    53636.7,
                    36584.5
                  ],
                  [
                    53342,
                    36667.8
                  ],
                  [
                    53106.1,
                    36700
                  ],
                  [
                    52804,
                    36888.5
                  ],
                  [
                    52882.6,
                    37185.5
                  ],
                  [
                    53087.1,
                    37333.3
                  ]
                ],
                "id": 546,
                "chat_link": "[&BCICAAA=]"
              },
              "547": {
                "name": "Pythian Point",
                "level": 57,
                "coord": [
                  52544.2,
                  37099.9
                ],
                "bounds": [
                  [
                    52290.7,
                    36817.2
                  ],
                  [
                    52535.1,
                    36752.6
                  ],
                  [
                    52589.7,
                    36852.6
                  ],
                  [
                    52804.2,
                    36888
                  ],
                  [
                    52882.1,
                    37186.3
                  ],
                  [
                    52739.5,
                    37205
                  ],
                  [
                    52642.5,
                    37155.6
                  ],
                  [
                    52491.5,
                    37267.5
                  ],
                  [
                    52440.1,
                    37404.9
                  ],
                  [
                    52310.8,
                    37444
                  ],
                  [
                    52260.1,
                    37125.6
                  ],
                  [
                    52290.7,
                    36817.2
                  ]
                ],
                "id": 547,
                "chat_link": "[&BCMCAAA=]"
              },
              "548": {
                "name": "Tyrant's Mount",
                "level": 57,
                "coord": [
                  52082.8,
                  37109.1
                ],
                "bounds": [
                  [
                    52043.6,
                    37185
                  ],
                  [
                    52133.4,
                    37063.8
                  ],
                  [
                    52043.5,
                    36933.6
                  ],
                  [
                    52016.7,
                    36837.4
                  ],
                  [
                    52135,
                    36769.8
                  ],
                  [
                    52291.1,
                    36817.7
                  ],
                  [
                    52259.8,
                    37126.8
                  ],
                  [
                    52311,
                    37444.4
                  ],
                  [
                    52046.4,
                    37436.6
                  ],
                  [
                    51823.2,
                    37347
                  ],
                  [
                    51807.4,
                    37238
                  ],
                  [
                    52043.6,
                    37185
                  ]
                ],
                "id": 548,
                "chat_link": "[&BCQCAAA=]"
              },
              "549": {
                "name": "Ural's Delve",
                "level": 57,
                "coord": [
                  51917,
                  36994.8
                ],
                "bounds": [
                  [
                    51724.6,
                    36979.4
                  ],
                  [
                    51733,
                    36924.1
                  ],
                  [
                    51816.6,
                    36787.7
                  ],
                  [
                    52022.1,
                    36832.1
                  ],
                  [
                    52047.3,
                    36929.9
                  ],
                  [
                    52139.8,
                    37069.1
                  ],
                  [
                    52041.3,
                    37191.5
                  ],
                  [
                    51811.4,
                    37245
                  ],
                  [
                    51724.6,
                    36979.4
                  ]
                ],
                "id": 549,
                "chat_link": "[&BCUCAAA=]"
              },
              "550": {
                "name": "Candle Chimney",
                "level": 57,
                "coord": [
                  51917.2,
                  36552.6
                ],
                "bounds": [
                  [
                    51817.1,
                    36790.4
                  ],
                  [
                    51789,
                    36708.1
                  ],
                  [
                    51725.9,
                    36457.8
                  ],
                  [
                    51758,
                    36197.3
                  ],
                  [
                    51897.1,
                    36209.8
                  ],
                  [
                    51927.8,
                    36376
                  ],
                  [
                    52187,
                    36625.7
                  ],
                  [
                    52136,
                    36770.3
                  ],
                  [
                    52016.8,
                    36837.9
                  ],
                  [
                    51817.1,
                    36790.4
                  ]
                ],
                "id": 550,
                "chat_link": "[&BCYCAAA=]"
              },
              "551": {
                "name": "Gyre Rapids",
                "level": 56,
                "coord": [
                  52298.8,
                  36493.3
                ],
                "bounds": [
                  [
                    52135.5,
                    36770.5
                  ],
                  [
                    52290.4,
                    36817.6
                  ],
                  [
                    52534.5,
                    36752.8
                  ],
                  [
                    52645.5,
                    36622.8
                  ],
                  [
                    52643.6,
                    36453.4
                  ],
                  [
                    52529.8,
                    36347.9
                  ],
                  [
                    52485.8,
                    36229
                  ],
                  [
                    52013.4,
                    36223.1
                  ],
                  [
                    51894.3,
                    36205.5
                  ],
                  [
                    51927.4,
                    36377.4
                  ],
                  [
                    52186.5,
                    36625.9
                  ],
                  [
                    52135.5,
                    36770.5
                  ]
                ],
                "id": 551,
                "chat_link": "[&BCcCAAA=]"
              },
              "552": {
                "name": "Stromkarl Heights",
                "level": 55,
                "coord": [
                  52700.7,
                  36484.1
                ],
                "bounds": [
                  [
                    52643.8,
                    36622.6
                  ],
                  [
                    52643.8,
                    36454.4
                  ],
                  [
                    52530.3,
                    36347.8
                  ],
                  [
                    52484.3,
                    36230.8
                  ],
                  [
                    52540.8,
                    36076.3
                  ],
                  [
                    52870,
                    36114
                  ],
                  [
                    52929.3,
                    36172.5
                  ],
                  [
                    52907.3,
                    36487.3
                  ],
                  [
                    52931.5,
                    36809
                  ],
                  [
                    52801.8,
                    36890.4
                  ],
                  [
                    52589.7,
                    36851.3
                  ],
                  [
                    52535.6,
                    36752.5
                  ],
                  [
                    52643.8,
                    36622.6
                  ]
                ],
                "id": 552,
                "chat_link": "[&BCgCAAA=]"
              },
              "553": {
                "name": "Hunting Banks",
                "level": 59,
                "coord": [
                  53212.3,
                  36586.3
                ],
                "bounds": [
                  [
                    52930.9,
                    36809.2
                  ],
                  [
                    53106.1,
                    36700.7
                  ],
                  [
                    53343.5,
                    36671.7
                  ],
                  [
                    53634.3,
                    36588.2
                  ],
                  [
                    53383.5,
                    36447
                  ],
                  [
                    53181,
                    36401
                  ],
                  [
                    52906.9,
                    36486.5
                  ],
                  [
                    52930.9,
                    36809.2
                  ]
                ],
                "id": 553,
                "chat_link": "[&BCkCAAA=]"
              },
              "554": {
                "name": "Naui Waters",
                "level": 54,
                "coord": [
                  53675.6,
                  36304.8
                ],
                "bounds": [
                  [
                    53351.7,
                    36140.3
                  ],
                  [
                    53452.3,
                    36039.3
                  ],
                  [
                    53592.3,
                    36032.4
                  ],
                  [
                    53884.9,
                    36095.8
                  ],
                  [
                    53988.1,
                    36289.1
                  ],
                  [
                    53943.9,
                    36518
                  ],
                  [
                    53849,
                    36590.5
                  ],
                  [
                    53635.2,
                    36591.6
                  ],
                  [
                    53383.3,
                    36446.7
                  ],
                  [
                    53351.7,
                    36140.3
                  ]
                ],
                "id": 554,
                "chat_link": "[&BCoCAAA=]"
              },
              "555": {
                "name": "Guilty Tears",
                "level": 53,
                "coord": [
                  53584.5,
                  35825.5
                ],
                "bounds": [
                  [
                    53198.8,
                    35785.9
                  ],
                  [
                    53180,
                    36040.4
                  ],
                  [
                    53352.2,
                    36140.8
                  ],
                  [
                    53452,
                    36040.2
                  ],
                  [
                    53592.2,
                    36032.8
                  ],
                  [
                    53891,
                    36096.7
                  ],
                  [
                    54004.4,
                    35770.8
                  ],
                  [
                    53947.5,
                    35771.6
                  ],
                  [
                    53732.8,
                    35611.9
                  ],
                  [
                    53738.8,
                    35503.5
                  ],
                  [
                    53548.4,
                    35514.3
                  ],
                  [
                    53375.6,
                    35597.3
                  ],
                  [
                    53198.8,
                    35785.9
                  ]
                ],
                "id": 555,
                "chat_link": "[&BCsCAAA=]"
              },
              "556": {
                "name": "Bynebrachen",
                "level": 54,
                "coord": [
                  53111.2,
                  36026.7
                ],
                "bounds": [
                  [
                    52907,
                    36486.3
                  ],
                  [
                    53180.9,
                    36402.1
                  ],
                  [
                    53383.6,
                    36447.3
                  ],
                  [
                    53352.9,
                    36141
                  ],
                  [
                    53180.6,
                    36040.3
                  ],
                  [
                    53199,
                    35785.5
                  ],
                  [
                    53376.1,
                    35597.4
                  ],
                  [
                    52964.9,
                    35474.8
                  ],
                  [
                    52879.6,
                    35632.9
                  ],
                  [
                    52869.5,
                    36113.8
                  ],
                  [
                    52929.1,
                    36172
                  ],
                  [
                    52907,
                    36486.3
                  ]
                ],
                "id": 556,
                "chat_link": "[&BCwCAAA=]"
              },
              "557": {
                "name": "Fionnghuala Scratch",
                "level": 54,
                "coord": [
                  52698.6,
                  35749.5
                ],
                "bounds": [
                  [
                    52428,
                    35639.7
                  ],
                  [
                    52648.6,
                    35444.7
                  ],
                  [
                    52965.8,
                    35474.4
                  ],
                  [
                    52880.7,
                    35632.3
                  ],
                  [
                    52872.3,
                    36123.8
                  ],
                  [
                    52538.7,
                    36086.5
                  ],
                  [
                    52556.3,
                    35845.2
                  ],
                  [
                    52428,
                    35639.7
                  ]
                ],
                "id": 557,
                "chat_link": "[&BC0CAAA=]"
              },
              "558": {
                "name": "Fisher's Eye Bridges",
                "level": 55,
                "coord": [
                  52128.5,
                  35958.3
                ],
                "bounds": [
                  [
                    51759,
                    36201.6
                  ],
                  [
                    52013.3,
                    36223
                  ],
                  [
                    52485.8,
                    36228.8
                  ],
                  [
                    52544.9,
                    36081.1
                  ],
                  [
                    52556.9,
                    35845.5
                  ],
                  [
                    52428.2,
                    35639.3
                  ],
                  [
                    51887.8,
                    35707.4
                  ],
                  [
                    51730,
                    35712.8
                  ],
                  [
                    51750.5,
                    35984.7
                  ],
                  [
                    51759,
                    36201.6
                  ]
                ],
                "id": 558,
                "chat_link": "[&BC4CAAA=]"
              },
              "559": {
                "name": "Gentle River",
                "level": 53,
                "coord": [
                  52313.6,
                  35146.7
                ],
                "bounds": [
                  [
                    51824.6,
                    35283.9
                  ],
                  [
                    52096,
                    35280.7
                  ],
                  [
                    52333.8,
                    35083.8
                  ],
                  [
                    52387.9,
                    34592.4
                  ],
                  [
                    52504.8,
                    34544.4
                  ],
                  [
                    52760.2,
                    34569.3
                  ],
                  [
                    52902.4,
                    34514.1
                  ],
                  [
                    52898.9,
                    34889.6
                  ],
                  [
                    52822.9,
                    34871.1
                  ],
                  [
                    52651.1,
                    35445.8
                  ],
                  [
                    52428,
                    35640.5
                  ],
                  [
                    51887.7,
                    35707.3
                  ],
                  [
                    51739.2,
                    35713.7
                  ],
                  [
                    51711.1,
                    35625.2
                  ],
                  [
                    51755.5,
                    35439.4
                  ],
                  [
                    51824.6,
                    35283.9
                  ]
                ],
                "id": 559,
                "chat_link": "[&BC8CAAA=]"
              },
              "560": {
                "name": "Krongar Pass",
                "level": 53,
                "coord": [
                  51981.8,
                  34882.7
                ],
                "bounds": [
                  [
                    51730.4,
                    34910.8
                  ],
                  [
                    51745.9,
                    34639.2
                  ],
                  [
                    51836.8,
                    34504.2
                  ],
                  [
                    52112.8,
                    34499.3
                  ],
                  [
                    52395.1,
                    34567.7
                  ],
                  [
                    52333,
                    35085.4
                  ],
                  [
                    52095.2,
                    35281.8
                  ],
                  [
                    51824.7,
                    35283.8
                  ],
                  [
                    51762.3,
                    35172.6
                  ],
                  [
                    51730.4,
                    34910.8
                  ]
                ],
                "id": 560,
                "chat_link": "[&BDACAAA=]"
              },
              "561": {
                "name": "White Paper Hill",
                "level": 53,
                "coord": [
                  53107.1,
                  35301.8
                ],
                "bounds": [
                  [
                    52820.1,
                    34867.9
                  ],
                  [
                    52967.9,
                    34886.7
                  ],
                  [
                    53038.1,
                    35256.2
                  ],
                  [
                    53498.2,
                    35358.6
                  ],
                  [
                    53552.5,
                    35513.9
                  ],
                  [
                    53375.5,
                    35603.2
                  ],
                  [
                    52959.5,
                    35479
                  ],
                  [
                    52644.9,
                    35449.3
                  ],
                  [
                    52820.1,
                    34867.9
                  ]
                ],
                "id": 561,
                "chat_link": "[&BDECAAA=]"
              },
              "562": {
                "name": "The Iron Veil",
                "level": 52,
                "coord": [
                  53237,
                  34875.6
                ],
                "bounds": [
                  [
                    52902.6,
                    34515.3
                  ],
                  [
                    53198.2,
                    34602.6
                  ],
                  [
                    53298.9,
                    34479.7
                  ],
                  [
                    53445.5,
                    34462.8
                  ],
                  [
                    53539.9,
                    34761.4
                  ],
                  [
                    53277.7,
                    34876.7
                  ],
                  [
                    53283.8,
                    35132
                  ],
                  [
                    53512.3,
                    35282.5
                  ],
                  [
                    53497.9,
                    35362.3
                  ],
                  [
                    53030,
                    35257.6
                  ],
                  [
                    52963.6,
                    34890
                  ],
                  [
                    52893.5,
                    34883.8
                  ],
                  [
                    52902.6,
                    34515.3
                  ]
                ],
                "id": 562,
                "chat_link": "[&BDICAAA=]"
              },
              "564": {
                "name": "Molodets Excavation",
                "level": 52,
                "coord": [
                  53548.2,
                  35204.8
                ],
                "bounds": [
                  [
                    53497.6,
                    35361.6
                  ],
                  [
                    53512.4,
                    35282
                  ],
                  [
                    53283,
                    35133.3
                  ],
                  [
                    53277.7,
                    34876.8
                  ],
                  [
                    53540,
                    34760.9
                  ],
                  [
                    53725.1,
                    35054.8
                  ],
                  [
                    53811.7,
                    35356.3
                  ],
                  [
                    53738.4,
                    35503.9
                  ],
                  [
                    53547.8,
                    35513.8
                  ],
                  [
                    53497.6,
                    35361.6
                  ]
                ],
                "id": 564,
                "chat_link": "[&BDQCAAA=]"
              },
              "565": {
                "name": "The Foundation Stones",
                "level": 55,
                "coord": [
                  53877.2,
                  35470.2
                ],
                "bounds": [
                  [
                    53738.1,
                    35501.8
                  ],
                  [
                    53811.8,
                    35355.2
                  ],
                  [
                    53891.4,
                    35255
                  ],
                  [
                    53984.4,
                    35239.1
                  ],
                  [
                    53982.3,
                    35426.9
                  ],
                  [
                    53933.7,
                    35597.2
                  ],
                  [
                    53946.5,
                    35773.3
                  ],
                  [
                    53729.8,
                    35613
                  ],
                  [
                    53738.1,
                    35501.8
                  ]
                ],
                "id": 565,
                "chat_link": "[&BDUCAAA=]"
              },
              "1023": {
                "name": "Sector Zuhl",
                "level": 52,
                "coord": [
                  53895.5,
                  34837.3
                ],
                "bounds": [
                  [
                    53537.2,
                    34768
                  ],
                  [
                    53472.8,
                    34561.7
                  ],
                  [
                    53923,
                    34364.8
                  ],
                  [
                    54300.7,
                    34464.3
                  ],
                  [
                    54156.9,
                    34585
                  ],
                  [
                    54068.2,
                    34702.5
                  ],
                  [
                    54005.3,
                    34827.8
                  ],
                  [
                    53965.7,
                    35244.5
                  ],
                  [
                    53891.8,
                    35256.4
                  ],
                  [
                    53809.4,
                    35375.9
                  ],
                  [
                    53719.2,
                    35059.7
                  ],
                  [
                    53537.2,
                    34768
                  ]
                ],
                "id": 1023,
                "chat_link": "[&BP8DAAA=]"
              }
            },
            "id": 1100,
            "mastery_points": [],
            "adventures": []
          },
          "1109": {
            "name": "Angvar's Trove",
            "min_level": 15,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              52480,
              28672
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                50432,
                27648
              ],
              [
                54528,
                29696
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "218": {
                "name": "Skradden Slopes",
                "level": 24,
                "coord": [
                  50795.2,
                  29007.4
                ],
                "bounds": [
                  [
                    51098.6,
                    28729.4
                  ],
                  [
                    51088.5,
                    28558.8
                  ],
                  [
                    50963.1,
                    28443.5
                  ],
                  [
                    50818.5,
                    28647.1
                  ],
                  [
                    50439.7,
                    28686.4
                  ],
                  [
                    50436.4,
                    29082.7
                  ],
                  [
                    50356.2,
                    29132.5
                  ],
                  [
                    50375.1,
                    29340.2
                  ],
                  [
                    50589.5,
                    29194.6
                  ],
                  [
                    50700.6,
                    29293.7
                  ],
                  [
                    50961,
                    29420.3
                  ],
                  [
                    51099.5,
                    29338.3
                  ],
                  [
                    51004.8,
                    29214.5
                  ],
                  [
                    51025.5,
                    29076.6
                  ],
                  [
                    50971.7,
                    28952.1
                  ],
                  [
                    51098.6,
                    28729.4
                  ]
                ],
                "id": 218,
                "chat_link": "[&BNoAAAA=]"
              },
              "219": {
                "name": "Glisterice Caves",
                "level": 24,
                "coord": [
                  50659,
                  29483.5
                ],
                "bounds": [
                  [
                    50961.3,
                    29414.1
                  ],
                  [
                    50697,
                    29288.8
                  ],
                  [
                    50593.8,
                    29191
                  ],
                  [
                    50372.6,
                    29336.8
                  ],
                  [
                    50312.3,
                    29661.3
                  ],
                  [
                    50659.4,
                    29796.2
                  ],
                  [
                    51016.6,
                    29696
                  ],
                  [
                    50961.3,
                    29414.1
                  ]
                ],
                "id": 219,
                "chat_link": "[&BNsAAAA=]"
              },
              "220": {
                "name": "The Frozen Sweeps",
                "level": 24,
                "coord": [
                  51359.9,
                  28989
                ],
                "bounds": [
                  [
                    51100.5,
                    29342.2
                  ],
                  [
                    51149.7,
                    29298.5
                  ],
                  [
                    51588.9,
                    29311.2
                  ],
                  [
                    51770.3,
                    29223.4
                  ],
                  [
                    51789.8,
                    28917.2
                  ],
                  [
                    51643.6,
                    28869.2
                  ],
                  [
                    51655.7,
                    28601.7
                  ],
                  [
                    51490.9,
                    28602
                  ],
                  [
                    51400.9,
                    28712.5
                  ],
                  [
                    51096,
                    28728.2
                  ],
                  [
                    50966.9,
                    28954.1
                  ],
                  [
                    51021.4,
                    29080.2
                  ],
                  [
                    51004,
                    29216.2
                  ],
                  [
                    51100.5,
                    29342.2
                  ]
                ],
                "id": 220,
                "chat_link": "[&BNwAAAA=]"
              },
              "221": {
                "name": "Molengrad",
                "level": 24,
                "coord": [
                  51212.2,
                  29527.5
                ],
                "bounds": [
                  [
                    51017.4,
                    29696
                  ],
                  [
                    50957.3,
                    29414.6
                  ],
                  [
                    51149.3,
                    29300.3
                  ],
                  [
                    51315.9,
                    29302
                  ],
                  [
                    51533.1,
                    29679.1
                  ],
                  [
                    51300.2,
                    29772.9
                  ],
                  [
                    51017.4,
                    29696
                  ]
                ],
                "id": 221,
                "chat_link": "[&BN0AAAA=]"
              },
              "222": {
                "name": "Jormabakke Stead",
                "level": 24,
                "coord": [
                  51304.6,
                  28552
                ],
                "bounds": [
                  [
                    51085.6,
                    28557.5
                  ],
                  [
                    51198,
                    28395.3
                  ],
                  [
                    51359.2,
                    28373.3
                  ],
                  [
                    51493.5,
                    28484
                  ],
                  [
                    51495.4,
                    28604.3
                  ],
                  [
                    51405.8,
                    28718.4
                  ],
                  [
                    51095,
                    28731.4
                  ],
                  [
                    51085.6,
                    28557.5
                  ]
                ],
                "id": 222,
                "chat_link": "[&BN4AAAA=]"
              },
              "223": {
                "name": "Isenfall Gullies",
                "level": 25,
                "coord": [
                  51274.5,
                  28320
                ],
                "bounds": [
                  [
                    51490.4,
                    28603.2
                  ],
                  [
                    51655.1,
                    28607.1
                  ],
                  [
                    51731,
                    28372.3
                  ],
                  [
                    51469.2,
                    28024
                  ],
                  [
                    51239.7,
                    28080.5
                  ],
                  [
                    51201.5,
                    28131.8
                  ],
                  [
                    50952,
                    28078.2
                  ],
                  [
                    50827.6,
                    28080.5
                  ],
                  [
                    50862.7,
                    28360.8
                  ],
                  [
                    51091.6,
                    28565.8
                  ],
                  [
                    51199,
                    28396
                  ],
                  [
                    51359.6,
                    28377.3
                  ],
                  [
                    51489.7,
                    28482.8
                  ],
                  [
                    51490.4,
                    28603.2
                  ]
                ],
                "id": 223,
                "chat_link": "[&BN8AAAA=]"
              },
              "224": {
                "name": "Darkhoof Heights",
                "level": 25,
                "coord": [
                  51176.4,
                  27940.2
                ],
                "bounds": [
                  [
                    50927.7,
                    27905.4
                  ],
                  [
                    50984.4,
                    27810.3
                  ],
                  [
                    51111.4,
                    27851.6
                  ],
                  [
                    51355.9,
                    27699.8
                  ],
                  [
                    51505.8,
                    27815.2
                  ],
                  [
                    51470.3,
                    28024.7
                  ],
                  [
                    51243.8,
                    28082.2
                  ],
                  [
                    51201.3,
                    28135.3
                  ],
                  [
                    50945.7,
                    28080.1
                  ],
                  [
                    51017.8,
                    27997.8
                  ],
                  [
                    50927.7,
                    27905.4
                  ]
                ],
                "id": 224,
                "chat_link": "[&BOAAAAA=]"
              },
              "226": {
                "name": "Lornar's Gate",
                "level": 22,
                "coord": [
                  51796,
                  29351
                ],
                "bounds": [
                  [
                    51309.3,
                    29301.4
                  ],
                  [
                    51590.7,
                    29307.5
                  ],
                  [
                    51768.4,
                    29222
                  ],
                  [
                    51786.2,
                    29007.7
                  ],
                  [
                    52044.5,
                    29069.3
                  ],
                  [
                    51982.1,
                    29272.8
                  ],
                  [
                    52091.8,
                    29506.2
                  ],
                  [
                    52066.2,
                    29798.1
                  ],
                  [
                    51524.6,
                    29673.9
                  ],
                  [
                    51309.3,
                    29301.4
                  ]
                ],
                "id": 226,
                "chat_link": "[&BOIAAAA=]"
              },
              "227": {
                "name": "Isenfall Lake",
                "level": 22,
                "coord": [
                  51866,
                  28185.4
                ],
                "bounds": [
                  [
                    52056.7,
                    28112.5
                  ],
                  [
                    52192.4,
                    27939.1
                  ],
                  [
                    52158.1,
                    27682.1
                  ],
                  [
                    52018.5,
                    27680.2
                  ],
                  [
                    52007,
                    27762.9
                  ],
                  [
                    51882.5,
                    27826.6
                  ],
                  [
                    51759.7,
                    27663.5
                  ],
                  [
                    51534.6,
                    27724.9
                  ],
                  [
                    51468,
                    28023.3
                  ],
                  [
                    51728.3,
                    28372.5
                  ],
                  [
                    51657.1,
                    28598
                  ],
                  [
                    51642.4,
                    28867.6
                  ],
                  [
                    51791.8,
                    28918.1
                  ],
                  [
                    51884,
                    28754.8
                  ],
                  [
                    52087.8,
                    28630.3
                  ],
                  [
                    51987.1,
                    28409.6
                  ],
                  [
                    52056.7,
                    28112.5
                  ]
                ],
                "id": 227,
                "chat_link": "[&BOMAAAA=]"
              },
              "228": {
                "name": "Hrothgar's Pass",
                "level": 22,
                "coord": [
                  52276,
                  28793.6
                ],
                "bounds": [
                  [
                    52461.1,
                    29023.5
                  ],
                  [
                    52291.1,
                    28967.1
                  ],
                  [
                    52049.6,
                    29069.2
                  ],
                  [
                    51785.3,
                    29008.9
                  ],
                  [
                    51787.1,
                    28915.1
                  ],
                  [
                    51884.2,
                    28755.3
                  ],
                  [
                    52087.1,
                    28629.8
                  ],
                  [
                    52040,
                    28528.3
                  ],
                  [
                    52476.2,
                    28451.5
                  ],
                  [
                    52646.5,
                    28737.1
                  ],
                  [
                    52852.2,
                    28651
                  ],
                  [
                    52950.9,
                    28786
                  ],
                  [
                    52461.1,
                    29023.5
                  ]
                ],
                "id": 228,
                "chat_link": "[&BOQAAAA=]"
              },
              "229": {
                "name": "Valslake",
                "level": 20,
                "coord": [
                  52628.5,
                  29295.9
                ],
                "bounds": [
                  [
                    52046,
                    29069
                  ],
                  [
                    52290.9,
                    28967.9
                  ],
                  [
                    52461.5,
                    29021.2
                  ],
                  [
                    52943.5,
                    28775.7
                  ],
                  [
                    53379.5,
                    29026.6
                  ],
                  [
                    53339,
                    29259.4
                  ],
                  [
                    53165.7,
                    29204.3
                  ],
                  [
                    52922.2,
                    29290
                  ],
                  [
                    52753.9,
                    29461.2
                  ],
                  [
                    52761.7,
                    29690.8
                  ],
                  [
                    52597,
                    29800.6
                  ],
                  [
                    52065.5,
                    29795
                  ],
                  [
                    52090.4,
                    29508.8
                  ],
                  [
                    51982,
                    29272.4
                  ],
                  [
                    52046,
                    29069
                  ]
                ],
                "id": 229,
                "chat_link": "[&BOUAAAA=]"
              },
              "230": {
                "name": "Oros Spurs",
                "level": 20,
                "coord": [
                  52333.9,
                  28115.7
                ],
                "bounds": [
                  [
                    52524.6,
                    28274.1
                  ],
                  [
                    52475.6,
                    28455
                  ],
                  [
                    52041.8,
                    28531.1
                  ],
                  [
                    51980.2,
                    28413.9
                  ],
                  [
                    52059,
                    28129.5
                  ],
                  [
                    52190.8,
                    27938.2
                  ],
                  [
                    52154.5,
                    27753.4
                  ],
                  [
                    52580.3,
                    27761.2
                  ],
                  [
                    52651.4,
                    27810.8
                  ],
                  [
                    52681.1,
                    28089.8
                  ],
                  [
                    52524.6,
                    28274.1
                  ]
                ],
                "id": 230,
                "chat_link": "[&BOYAAAA=]"
              },
              "231": {
                "name": "Vitpeln Hills",
                "level": 19,
                "coord": [
                  52872.5,
                  28413.4
                ],
                "bounds": [
                  [
                    53234.1,
                    28282.1
                  ],
                  [
                    53063.5,
                    28348
                  ],
                  [
                    52677,
                    28090.3
                  ],
                  [
                    52520.9,
                    28280.2
                  ],
                  [
                    52472.8,
                    28459.1
                  ],
                  [
                    52648.6,
                    28748.4
                  ],
                  [
                    53139.6,
                    28551.3
                  ],
                  [
                    53223.4,
                    28547.6
                  ],
                  [
                    53234.1,
                    28282.1
                  ]
                ],
                "id": 231,
                "chat_link": "[&BOcAAAA=]"
              },
              "232": {
                "name": "The Loneholme Range",
                "level": 17,
                "coord": [
                  52968.4,
                  27819.3
                ],
                "bounds": [
                  [
                    53148.6,
                    28078.7
                  ],
                  [
                    53284.8,
                    27774.5
                  ],
                  [
                    53164.9,
                    27568.5
                  ],
                  [
                    53112.1,
                    27613.9
                  ],
                  [
                    53024.1,
                    27651.3
                  ],
                  [
                    52921.9,
                    27681.2
                  ],
                  [
                    52824.8,
                    27691.5
                  ],
                  [
                    52642.7,
                    27809.9
                  ],
                  [
                    52677.1,
                    28091.6
                  ],
                  [
                    52883.3,
                    28231.6
                  ],
                  [
                    53148.6,
                    28078.7
                  ]
                ],
                "id": 232,
                "chat_link": "[&BOgAAAA=]"
              },
              "233": {
                "name": "Dragon's Rising",
                "level": 17,
                "coord": [
                  53362.2,
                  27751.4
                ],
                "bounds": [
                  [
                    53144.6,
                    28077.2
                  ],
                  [
                    53276,
                    27769.9
                  ],
                  [
                    53168.8,
                    27582.6
                  ],
                  [
                    53288.3,
                    27507.5
                  ],
                  [
                    53379,
                    27427.9
                  ],
                  [
                    53455,
                    27368.8
                  ],
                  [
                    53505.8,
                    27394.9
                  ],
                  [
                    53551.9,
                    27441.7
                  ],
                  [
                    53626.5,
                    27638.3
                  ],
                  [
                    53610.2,
                    27882.2
                  ],
                  [
                    53758.8,
                    28104.7
                  ],
                  [
                    53063.7,
                    28341.5
                  ],
                  [
                    52880.6,
                    28231.1
                  ],
                  [
                    53144.6,
                    28077.2
                  ]
                ],
                "id": 233,
                "chat_link": "[&BOkAAAA=]"
              },
              "234": {
                "name": "Jotun's Vista",
                "level": 18,
                "coord": [
                  53168.8,
                  28722.5
                ],
                "bounds": [
                  [
                    53502.1,
                    28776.6
                  ],
                  [
                    53222.8,
                    28538.7
                  ],
                  [
                    53142.3,
                    28545.6
                  ],
                  [
                    52833.2,
                    28659.9
                  ],
                  [
                    52935.4,
                    28786.6
                  ],
                  [
                    53376.8,
                    29027.5
                  ],
                  [
                    53502.1,
                    28776.6
                  ]
                ],
                "id": 234,
                "chat_link": "[&BOoAAAA=]"
              },
              "235": {
                "name": "Tromigar Valley",
                "level": 16,
                "coord": [
                  53857.4,
                  28354.8
                ],
                "bounds": [
                  [
                    53223.5,
                    28540.5
                  ],
                  [
                    53502.7,
                    28777.5
                  ],
                  [
                    53731.9,
                    28686.5
                  ],
                  [
                    54221.6,
                    28613.8
                  ],
                  [
                    54347.1,
                    28374
                  ],
                  [
                    54174.5,
                    28332.3
                  ],
                  [
                    54192.2,
                    28198.6
                  ],
                  [
                    54103.2,
                    28008.7
                  ],
                  [
                    53942.8,
                    27993.1
                  ],
                  [
                    53755.8,
                    28101
                  ],
                  [
                    53235.7,
                    28277
                  ],
                  [
                    53223.5,
                    28540.5
                  ]
                ],
                "id": 235,
                "chat_link": "[&BOsAAAA=]"
              },
              "236": {
                "name": "Song of Final Exile",
                "level": 20,
                "coord": [
                  53053.8,
                  29466.9
                ],
                "bounds": [
                  [
                    53166.5,
                    29202.5
                  ],
                  [
                    53343.4,
                    29256
                  ],
                  [
                    53188.9,
                    29562.9
                  ],
                  [
                    53242.6,
                    29819.5
                  ],
                  [
                    52759.6,
                    29689.7
                  ],
                  [
                    52756.3,
                    29447.7
                  ],
                  [
                    52919.3,
                    29289.7
                  ],
                  [
                    53166.5,
                    29202.5
                  ]
                ],
                "id": 236,
                "chat_link": "[&BOwAAAA=]"
              },
              "237": {
                "name": "Griffonfall",
                "level": 18,
                "coord": [
                  53563.9,
                  29459.6
                ],
                "bounds": [
                  [
                    53340.5,
                    29254.3
                  ],
                  [
                    53188,
                    29561.8
                  ],
                  [
                    53222.1,
                    29798.9
                  ],
                  [
                    53753.4,
                    29685.5
                  ],
                  [
                    53743.1,
                    29525
                  ],
                  [
                    53847.4,
                    29387.9
                  ],
                  [
                    53818.2,
                    29192.7
                  ],
                  [
                    53598.3,
                    29270.8
                  ],
                  [
                    53340.5,
                    29254.3
                  ]
                ],
                "id": 237,
                "chat_link": "[&BO0AAAA=]"
              },
              "238": {
                "name": "Reaver's Dale",
                "level": 18,
                "coord": [
                  53702.8,
                  29005.9
                ],
                "bounds": [
                  [
                    53493.4,
                    28768.2
                  ],
                  [
                    53725.8,
                    28680.7
                  ],
                  [
                    53803.3,
                    28806.9
                  ],
                  [
                    54159.2,
                    28947.5
                  ],
                  [
                    54014.3,
                    29093
                  ],
                  [
                    53817.9,
                    29195.6
                  ],
                  [
                    53596.5,
                    29277.4
                  ],
                  [
                    53340.3,
                    29256.5
                  ],
                  [
                    53374.8,
                    29027.7
                  ],
                  [
                    53493.4,
                    28768.2
                  ]
                ],
                "id": 238,
                "chat_link": "[&BO4AAAA=]"
              },
              "239": {
                "name": "Owl's Abattoir",
                "level": 19,
                "coord": [
                  54161.3,
                  29313.7
                ],
                "bounds": [
                  [
                    53742.3,
                    29524.6
                  ],
                  [
                    53749.2,
                    29690
                  ],
                  [
                    54265,
                    29883.3
                  ],
                  [
                    54580,
                    29724.4
                  ],
                  [
                    54697.2,
                    29253.6
                  ],
                  [
                    54576.5,
                    28623.7
                  ],
                  [
                    54322.5,
                    28764.6
                  ],
                  [
                    54014.1,
                    29092.3
                  ],
                  [
                    53817.4,
                    29192
                  ],
                  [
                    53848.6,
                    29388.1
                  ],
                  [
                    53742.3,
                    29524.6
                  ]
                ],
                "id": 239,
                "chat_link": "[&BO8AAAA=]"
              },
              "240": {
                "name": "Villmark Foothills",
                "level": 17,
                "coord": [
                  54043,
                  28764.2
                ],
                "bounds": [
                  [
                    54216.1,
                    28608.4
                  ],
                  [
                    54322.1,
                    28765.2
                  ],
                  [
                    54158.2,
                    28947.5
                  ],
                  [
                    53798.2,
                    28815.9
                  ],
                  [
                    53720.7,
                    28684.2
                  ],
                  [
                    54216.1,
                    28608.4
                  ]
                ],
                "id": 240,
                "chat_link": "[&BPAAAAA=]"
              },
              "241": {
                "name": "Hunter's Pitfalls",
                "level": 15,
                "coord": [
                  54406.9,
                  28026.6
                ],
                "bounds": [
                  [
                    54102.5,
                    28007.9
                  ],
                  [
                    54189.7,
                    28199.2
                  ],
                  [
                    54169.1,
                    28336.2
                  ],
                  [
                    54348.5,
                    28378.4
                  ],
                  [
                    54426.1,
                    28230.8
                  ],
                  [
                    54516.1,
                    28249.2
                  ],
                  [
                    54562.2,
                    28063.3
                  ],
                  [
                    54647.6,
                    27983.4
                  ],
                  [
                    54650,
                    27857.8
                  ],
                  [
                    54567.7,
                    27772.9
                  ],
                  [
                    54543.9,
                    27589.7
                  ],
                  [
                    54159.4,
                    27650.3
                  ],
                  [
                    54102.5,
                    28007.9
                  ]
                ],
                "id": 241,
                "chat_link": "[&BPEAAAA=]"
              },
              "242": {
                "name": "Trapper's Labyrinth",
                "level": 16,
                "coord": [
                  53848.1,
                  27821.1
                ],
                "bounds": [
                  [
                    53760.4,
                    28107.7
                  ],
                  [
                    53608.6,
                    27881.3
                  ],
                  [
                    53620.9,
                    27630.3
                  ],
                  [
                    53721.9,
                    27648
                  ],
                  [
                    53869.9,
                    27648
                  ],
                  [
                    54158.6,
                    27648.9
                  ],
                  [
                    54103.4,
                    28008.4
                  ],
                  [
                    53941,
                    27996.1
                  ],
                  [
                    53760.4,
                    28107.7
                  ]
                ],
                "id": 242,
                "chat_link": "[&BPIAAAA=]"
              },
              "340": {
                "name": "Ossencrest Climb",
                "level": 24,
                "coord": [
                  50616.3,
                  28310.2
                ],
                "bounds": [
                  [
                    50831.9,
                    28081.4
                  ],
                  [
                    50863.9,
                    28360.4
                  ],
                  [
                    50975.1,
                    28448.4
                  ],
                  [
                    50815,
                    28662.7
                  ],
                  [
                    50437.8,
                    28689.8
                  ],
                  [
                    50391,
                    28581.7
                  ],
                  [
                    50345,
                    28432.8
                  ],
                  [
                    50563.5,
                    28307.7
                  ],
                  [
                    50592,
                    28226.8
                  ],
                  [
                    50502.6,
                    28169
                  ],
                  [
                    50437.7,
                    28069.6
                  ],
                  [
                    50536.8,
                    27993.4
                  ],
                  [
                    50719.1,
                    28009.4
                  ],
                  [
                    50831.9,
                    28081.4
                  ]
                ],
                "id": 340,
                "chat_link": "[&BFQBAAA=]"
              },
              "1015": {
                "name": "King Jalis's Refuge",
                "level": 19,
                "coord": [
                  54441.8,
                  28495.8
                ],
                "bounds": [
                  [
                    54211.1,
                    28608.1
                  ],
                  [
                    54422.3,
                    28226.1
                  ],
                  [
                    54568.6,
                    28258.2
                  ],
                  [
                    54629.5,
                    28445.2
                  ],
                  [
                    54497.3,
                    28671.9
                  ],
                  [
                    54322.1,
                    28765.2
                  ],
                  [
                    54211.1,
                    28608.1
                  ]
                ],
                "id": 1015,
                "chat_link": "[&BPcDAAA=]"
              },
              "1106": {
                "name": "Angvar's Trove",
                "level": 0,
                "coord": [
                  50749.6,
                  27947.3
                ],
                "bounds": [
                  [
                    50593.2,
                    28225.8
                  ],
                  [
                    50562.2,
                    28313.3
                  ],
                  [
                    50346.7,
                    28220.2
                  ],
                  [
                    50265.4,
                    28037.3
                  ],
                  [
                    50282.2,
                    27608.1
                  ],
                  [
                    50698.1,
                    27415.3
                  ],
                  [
                    51340.7,
                    27543
                  ],
                  [
                    51357.3,
                    27705.4
                  ],
                  [
                    51114.3,
                    27856.9
                  ],
                  [
                    50984.3,
                    27820.7
                  ],
                  [
                    50933.5,
                    27906.5
                  ],
                  [
                    51021.9,
                    27998.5
                  ],
                  [
                    50952.6,
                    28069.6
                  ],
                  [
                    50833.9,
                    28083.8
                  ],
                  [
                    50721.5,
                    28012.2
                  ],
                  [
                    50538.3,
                    27996
                  ],
                  [
                    50439.8,
                    28070.5
                  ],
                  [
                    50506.7,
                    28167.9
                  ],
                  [
                    50593.2,
                    28225.8
                  ]
                ],
                "id": 1106,
                "chat_link": "[&BFIEAAA=]"
              }
            },
            "id": 1109,
            "mastery_points": [],
            "adventures": []
          },
          "1111": {
            "name": "Scratch Sentry Defense",
            "min_level": 50,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              52864,
              36160
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                51712,
                34560
              ],
              [
                54016,
                37760
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "539": {
                "name": "Talus Waterslide",
                "level": 60,
                "coord": [
                  52019.1,
                  37614
                ],
                "bounds": [
                  [
                    52134.8,
                    37860.4
                  ],
                  [
                    51848.6,
                    37818.3
                  ],
                  [
                    51816,
                    37670.9
                  ],
                  [
                    51736,
                    37507.2
                  ],
                  [
                    51822.5,
                    37346.7
                  ],
                  [
                    52046.8,
                    37436.5
                  ],
                  [
                    52312.1,
                    37443.5
                  ],
                  [
                    52229.3,
                    37682.8
                  ],
                  [
                    52225.7,
                    37759.3
                  ],
                  [
                    52134.8,
                    37860.4
                  ]
                ],
                "id": 539,
                "chat_link": "[&BBsCAAA=]"
              },
              "540": {
                "name": "Malorean Wilds",
                "level": 58,
                "coord": [
                  52450.5,
                  37608
                ],
                "bounds": [
                  [
                    52439.5,
                    37404.6
                  ],
                  [
                    52627.2,
                    37480.5
                  ],
                  [
                    52671.3,
                    37656.1
                  ],
                  [
                    52648.7,
                    37829.1
                  ],
                  [
                    52225.7,
                    37759.4
                  ],
                  [
                    52229.4,
                    37683
                  ],
                  [
                    52311.6,
                    37443.3
                  ],
                  [
                    52439.5,
                    37404.6
                  ]
                ],
                "id": 540,
                "chat_link": "[&BBwCAAA=]"
              },
              "541": {
                "name": "Serpent Stones",
                "level": 59,
                "coord": [
                  52758.9,
                  37436.8
                ],
                "bounds": [
                  [
                    52439.5,
                    37404.7
                  ],
                  [
                    52492.9,
                    37266.3
                  ],
                  [
                    52642.5,
                    37155.6
                  ],
                  [
                    52740,
                    37205
                  ],
                  [
                    52883.5,
                    37185.4
                  ],
                  [
                    53087.8,
                    37333.9
                  ],
                  [
                    53042.3,
                    37441.5
                  ],
                  [
                    52953.5,
                    37527
                  ],
                  [
                    52881.4,
                    37755.9
                  ],
                  [
                    52645.3,
                    37828.9
                  ],
                  [
                    52671.3,
                    37656.4
                  ],
                  [
                    52626.5,
                    37480.6
                  ],
                  [
                    52439.5,
                    37404.7
                  ]
                ],
                "id": 541,
                "chat_link": "[&BB0CAAA=]"
              },
              "542": {
                "name": "Mellaggan's Grotto",
                "level": 59,
                "coord": [
                  53329.3,
                  37571.3
                ],
                "bounds": [
                  [
                    53042.1,
                    37440.1
                  ],
                  [
                    53087.8,
                    37333.3
                  ],
                  [
                    53593,
                    37309
                  ],
                  [
                    53736.7,
                    37493.6
                  ],
                  [
                    53836.3,
                    37634.3
                  ],
                  [
                    53656.3,
                    37829.4
                  ],
                  [
                    53176.7,
                    37824.6
                  ],
                  [
                    52882.4,
                    37750.8
                  ],
                  [
                    52952.8,
                    37526.8
                  ],
                  [
                    53042.1,
                    37440.1
                  ]
                ],
                "id": 542,
                "chat_link": "[&BB4CAAA=]"
              },
              "543": {
                "name": "Lair of the Coil",
                "level": 60,
                "coord": [
                  53858.9,
                  37394.2
                ],
                "bounds": [
                  [
                    53736.2,
                    37494.3
                  ],
                  [
                    53825.5,
                    37616
                  ],
                  [
                    53938.5,
                    37532.7
                  ],
                  [
                    54050.7,
                    37417.1
                  ],
                  [
                    54049.1,
                    37299
                  ],
                  [
                    54007.7,
                    37262.9
                  ],
                  [
                    53671.3,
                    37221.8
                  ],
                  [
                    53592,
                    37309.5
                  ],
                  [
                    53736.2,
                    37494.3
                  ]
                ],
                "id": 543,
                "chat_link": "[&BB8CAAA=]"
              },
              "544": {
                "name": "Tail of the Serpent",
                "level": 60,
                "coord": [
                  53957.2,
                  37018.3
                ],
                "bounds": [
                  [
                    53927.5,
                    36975.4
                  ],
                  [
                    53931.7,
                    36721.5
                  ],
                  [
                    54010.1,
                    36773
                  ],
                  [
                    54051.4,
                    36870.5
                  ],
                  [
                    54055.3,
                    37184.3
                  ],
                  [
                    54007.1,
                    37263.9
                  ],
                  [
                    53794.4,
                    37237.9
                  ],
                  [
                    53880.4,
                    37119.8
                  ],
                  [
                    53927.5,
                    36975.4
                  ]
                ],
                "id": 544,
                "chat_link": "[&BCACAAA=]"
              },
              "545": {
                "name": "Scale Strand",
                "level": 60,
                "coord": [
                  53786.5,
                  36934.6
                ],
                "bounds": [
                  [
                    53932.3,
                    36721.4
                  ],
                  [
                    53849.8,
                    36583.3
                  ],
                  [
                    53637.4,
                    36586.1
                  ],
                  [
                    53666.5,
                    36835.1
                  ],
                  [
                    53758,
                    36931.9
                  ],
                  [
                    53745.6,
                    37133.6
                  ],
                  [
                    53671.7,
                    37220.2
                  ],
                  [
                    53794.5,
                    37238.4
                  ],
                  [
                    53880.1,
                    37120.2
                  ],
                  [
                    53928.8,
                    36975.4
                  ],
                  [
                    53932.3,
                    36721.4
                  ]
                ],
                "id": 545,
                "chat_link": "[&BCECAAA=]"
              },
              "546": {
                "name": "Nonmoa Lake",
                "level": 60,
                "coord": [
                  53362.7,
                  36957.2
                ],
                "bounds": [
                  [
                    53087.1,
                    37333.3
                  ],
                  [
                    53593.5,
                    37309.4
                  ],
                  [
                    53749.4,
                    37136.3
                  ],
                  [
                    53758.2,
                    36931.3
                  ],
                  [
                    53667.2,
                    36835.3
                  ],
                  [
                    53636.7,
                    36584.5
                  ],
                  [
                    53342,
                    36667.8
                  ],
                  [
                    53106.1,
                    36700
                  ],
                  [
                    52804,
                    36888.5
                  ],
                  [
                    52882.6,
                    37185.5
                  ],
                  [
                    53087.1,
                    37333.3
                  ]
                ],
                "id": 546,
                "chat_link": "[&BCICAAA=]"
              },
              "547": {
                "name": "Pythian Point",
                "level": 57,
                "coord": [
                  52544.2,
                  37099.9
                ],
                "bounds": [
                  [
                    52290.7,
                    36817.2
                  ],
                  [
                    52535.1,
                    36752.6
                  ],
                  [
                    52589.7,
                    36852.6
                  ],
                  [
                    52804.2,
                    36888
                  ],
                  [
                    52882.1,
                    37186.3
                  ],
                  [
                    52739.5,
                    37205
                  ],
                  [
                    52642.5,
                    37155.6
                  ],
                  [
                    52491.5,
                    37267.5
                  ],
                  [
                    52440.1,
                    37404.9
                  ],
                  [
                    52310.8,
                    37444
                  ],
                  [
                    52260.1,
                    37125.6
                  ],
                  [
                    52290.7,
                    36817.2
                  ]
                ],
                "id": 547,
                "chat_link": "[&BCMCAAA=]"
              },
              "548": {
                "name": "Tyrant's Mount",
                "level": 57,
                "coord": [
                  52082.8,
                  37109.1
                ],
                "bounds": [
                  [
                    52043.6,
                    37185
                  ],
                  [
                    52133.4,
                    37063.8
                  ],
                  [
                    52043.5,
                    36933.6
                  ],
                  [
                    52016.7,
                    36837.4
                  ],
                  [
                    52135,
                    36769.8
                  ],
                  [
                    52291.1,
                    36817.7
                  ],
                  [
                    52259.8,
                    37126.8
                  ],
                  [
                    52311,
                    37444.4
                  ],
                  [
                    52046.4,
                    37436.6
                  ],
                  [
                    51823.2,
                    37347
                  ],
                  [
                    51807.4,
                    37238
                  ],
                  [
                    52043.6,
                    37185
                  ]
                ],
                "id": 548,
                "chat_link": "[&BCQCAAA=]"
              },
              "549": {
                "name": "Ural's Delve",
                "level": 57,
                "coord": [
                  51917,
                  36994.8
                ],
                "bounds": [
                  [
                    51724.6,
                    36979.4
                  ],
                  [
                    51733,
                    36924.1
                  ],
                  [
                    51816.6,
                    36787.7
                  ],
                  [
                    52022.1,
                    36832.1
                  ],
                  [
                    52047.3,
                    36929.9
                  ],
                  [
                    52139.8,
                    37069.1
                  ],
                  [
                    52041.3,
                    37191.5
                  ],
                  [
                    51811.4,
                    37245
                  ],
                  [
                    51724.6,
                    36979.4
                  ]
                ],
                "id": 549,
                "chat_link": "[&BCUCAAA=]"
              },
              "550": {
                "name": "Candle Chimney",
                "level": 57,
                "coord": [
                  51917.2,
                  36552.6
                ],
                "bounds": [
                  [
                    51817.1,
                    36790.4
                  ],
                  [
                    51789,
                    36708.1
                  ],
                  [
                    51725.9,
                    36457.8
                  ],
                  [
                    51758,
                    36197.3
                  ],
                  [
                    51897.1,
                    36209.8
                  ],
                  [
                    51927.8,
                    36376
                  ],
                  [
                    52187,
                    36625.7
                  ],
                  [
                    52136,
                    36770.3
                  ],
                  [
                    52016.8,
                    36837.9
                  ],
                  [
                    51817.1,
                    36790.4
                  ]
                ],
                "id": 550,
                "chat_link": "[&BCYCAAA=]"
              },
              "551": {
                "name": "Gyre Rapids",
                "level": 56,
                "coord": [
                  52298.8,
                  36493.3
                ],
                "bounds": [
                  [
                    52135.5,
                    36770.5
                  ],
                  [
                    52290.4,
                    36817.6
                  ],
                  [
                    52534.5,
                    36752.8
                  ],
                  [
                    52645.5,
                    36622.8
                  ],
                  [
                    52643.6,
                    36453.4
                  ],
                  [
                    52529.8,
                    36347.9
                  ],
                  [
                    52485.8,
                    36229
                  ],
                  [
                    52013.4,
                    36223.1
                  ],
                  [
                    51894.3,
                    36205.5
                  ],
                  [
                    51927.4,
                    36377.4
                  ],
                  [
                    52186.5,
                    36625.9
                  ],
                  [
                    52135.5,
                    36770.5
                  ]
                ],
                "id": 551,
                "chat_link": "[&BCcCAAA=]"
              },
              "552": {
                "name": "Stromkarl Heights",
                "level": 55,
                "coord": [
                  52700.7,
                  36484.1
                ],
                "bounds": [
                  [
                    52643.8,
                    36622.6
                  ],
                  [
                    52643.8,
                    36454.4
                  ],
                  [
                    52530.3,
                    36347.8
                  ],
                  [
                    52484.3,
                    36230.8
                  ],
                  [
                    52540.8,
                    36076.3
                  ],
                  [
                    52870,
                    36114
                  ],
                  [
                    52929.3,
                    36172.5
                  ],
                  [
                    52907.3,
                    36487.3
                  ],
                  [
                    52931.5,
                    36809
                  ],
                  [
                    52801.8,
                    36890.4
                  ],
                  [
                    52589.7,
                    36851.3
                  ],
                  [
                    52535.6,
                    36752.5
                  ],
                  [
                    52643.8,
                    36622.6
                  ]
                ],
                "id": 552,
                "chat_link": "[&BCgCAAA=]"
              },
              "553": {
                "name": "Hunting Banks",
                "level": 59,
                "coord": [
                  53212.3,
                  36586.3
                ],
                "bounds": [
                  [
                    52930.9,
                    36809.2
                  ],
                  [
                    53106.1,
                    36700.7
                  ],
                  [
                    53343.5,
                    36671.7
                  ],
                  [
                    53634.3,
                    36588.2
                  ],
                  [
                    53383.5,
                    36447
                  ],
                  [
                    53181,
                    36401
                  ],
                  [
                    52906.9,
                    36486.5
                  ],
                  [
                    52930.9,
                    36809.2
                  ]
                ],
                "id": 553,
                "chat_link": "[&BCkCAAA=]"
              },
              "554": {
                "name": "Naui Waters",
                "level": 54,
                "coord": [
                  53675.6,
                  36304.8
                ],
                "bounds": [
                  [
                    53351.7,
                    36140.3
                  ],
                  [
                    53452.3,
                    36039.3
                  ],
                  [
                    53592.3,
                    36032.4
                  ],
                  [
                    53884.9,
                    36095.8
                  ],
                  [
                    53988.1,
                    36289.1
                  ],
                  [
                    53943.9,
                    36518
                  ],
                  [
                    53849,
                    36590.5
                  ],
                  [
                    53635.2,
                    36591.6
                  ],
                  [
                    53383.3,
                    36446.7
                  ],
                  [
                    53351.7,
                    36140.3
                  ]
                ],
                "id": 554,
                "chat_link": "[&BCoCAAA=]"
              },
              "555": {
                "name": "Guilty Tears",
                "level": 53,
                "coord": [
                  53584.5,
                  35825.5
                ],
                "bounds": [
                  [
                    53198.8,
                    35785.9
                  ],
                  [
                    53180,
                    36040.4
                  ],
                  [
                    53352.2,
                    36140.8
                  ],
                  [
                    53452,
                    36040.2
                  ],
                  [
                    53592.2,
                    36032.8
                  ],
                  [
                    53891,
                    36096.7
                  ],
                  [
                    54004.4,
                    35770.8
                  ],
                  [
                    53947.5,
                    35771.6
                  ],
                  [
                    53732.8,
                    35611.9
                  ],
                  [
                    53738.8,
                    35503.5
                  ],
                  [
                    53548.4,
                    35514.3
                  ],
                  [
                    53375.6,
                    35597.3
                  ],
                  [
                    53198.8,
                    35785.9
                  ]
                ],
                "id": 555,
                "chat_link": "[&BCsCAAA=]"
              },
              "556": {
                "name": "Bynebrachen",
                "level": 54,
                "coord": [
                  53111.2,
                  36026.7
                ],
                "bounds": [
                  [
                    52907,
                    36486.3
                  ],
                  [
                    53180.9,
                    36402.1
                  ],
                  [
                    53383.6,
                    36447.3
                  ],
                  [
                    53352.9,
                    36141
                  ],
                  [
                    53180.6,
                    36040.3
                  ],
                  [
                    53199,
                    35785.5
                  ],
                  [
                    53376.1,
                    35597.4
                  ],
                  [
                    52964.9,
                    35474.8
                  ],
                  [
                    52879.6,
                    35632.9
                  ],
                  [
                    52869.5,
                    36113.8
                  ],
                  [
                    52929.1,
                    36172
                  ],
                  [
                    52907,
                    36486.3
                  ]
                ],
                "id": 556,
                "chat_link": "[&BCwCAAA=]"
              },
              "557": {
                "name": "Fionnghuala Scratch",
                "level": 54,
                "coord": [
                  52698.6,
                  35749.5
                ],
                "bounds": [
                  [
                    52428,
                    35639.7
                  ],
                  [
                    52648.6,
                    35444.7
                  ],
                  [
                    52965.8,
                    35474.4
                  ],
                  [
                    52880.7,
                    35632.3
                  ],
                  [
                    52872.3,
                    36123.8
                  ],
                  [
                    52538.7,
                    36086.5
                  ],
                  [
                    52556.3,
                    35845.2
                  ],
                  [
                    52428,
                    35639.7
                  ]
                ],
                "id": 557,
                "chat_link": "[&BC0CAAA=]"
              },
              "558": {
                "name": "Fisher's Eye Bridges",
                "level": 55,
                "coord": [
                  52128.5,
                  35958.3
                ],
                "bounds": [
                  [
                    51759,
                    36201.6
                  ],
                  [
                    52013.3,
                    36223
                  ],
                  [
                    52485.8,
                    36228.8
                  ],
                  [
                    52544.9,
                    36081.1
                  ],
                  [
                    52556.9,
                    35845.5
                  ],
                  [
                    52428.2,
                    35639.3
                  ],
                  [
                    51887.8,
                    35707.4
                  ],
                  [
                    51730,
                    35712.8
                  ],
                  [
                    51750.5,
                    35984.7
                  ],
                  [
                    51759,
                    36201.6
                  ]
                ],
                "id": 558,
                "chat_link": "[&BC4CAAA=]"
              },
              "559": {
                "name": "Gentle River",
                "level": 53,
                "coord": [
                  52313.6,
                  35146.7
                ],
                "bounds": [
                  [
                    51824.6,
                    35283.9
                  ],
                  [
                    52096,
                    35280.7
                  ],
                  [
                    52333.8,
                    35083.8
                  ],
                  [
                    52387.9,
                    34592.4
                  ],
                  [
                    52504.8,
                    34544.4
                  ],
                  [
                    52760.2,
                    34569.3
                  ],
                  [
                    52902.4,
                    34514.1
                  ],
                  [
                    52898.9,
                    34889.6
                  ],
                  [
                    52822.9,
                    34871.1
                  ],
                  [
                    52651.1,
                    35445.8
                  ],
                  [
                    52428,
                    35640.5
                  ],
                  [
                    51887.7,
                    35707.3
                  ],
                  [
                    51739.2,
                    35713.7
                  ],
                  [
                    51711.1,
                    35625.2
                  ],
                  [
                    51755.5,
                    35439.4
                  ],
                  [
                    51824.6,
                    35283.9
                  ]
                ],
                "id": 559,
                "chat_link": "[&BC8CAAA=]"
              },
              "560": {
                "name": "Krongar Pass",
                "level": 53,
                "coord": [
                  51981.8,
                  34882.7
                ],
                "bounds": [
                  [
                    51730.4,
                    34910.8
                  ],
                  [
                    51745.9,
                    34639.2
                  ],
                  [
                    51836.8,
                    34504.2
                  ],
                  [
                    52112.8,
                    34499.3
                  ],
                  [
                    52395.1,
                    34567.7
                  ],
                  [
                    52333,
                    35085.4
                  ],
                  [
                    52095.2,
                    35281.8
                  ],
                  [
                    51824.7,
                    35283.8
                  ],
                  [
                    51762.3,
                    35172.6
                  ],
                  [
                    51730.4,
                    34910.8
                  ]
                ],
                "id": 560,
                "chat_link": "[&BDACAAA=]"
              },
              "561": {
                "name": "White Paper Hill",
                "level": 53,
                "coord": [
                  53107.1,
                  35301.8
                ],
                "bounds": [
                  [
                    52820.1,
                    34867.9
                  ],
                  [
                    52967.9,
                    34886.7
                  ],
                  [
                    53038.1,
                    35256.2
                  ],
                  [
                    53498.2,
                    35358.6
                  ],
                  [
                    53552.5,
                    35513.9
                  ],
                  [
                    53375.5,
                    35603.2
                  ],
                  [
                    52959.5,
                    35479
                  ],
                  [
                    52644.9,
                    35449.3
                  ],
                  [
                    52820.1,
                    34867.9
                  ]
                ],
                "id": 561,
                "chat_link": "[&BDECAAA=]"
              },
              "562": {
                "name": "The Iron Veil",
                "level": 52,
                "coord": [
                  53237,
                  34875.6
                ],
                "bounds": [
                  [
                    52902.6,
                    34515.3
                  ],
                  [
                    53198.2,
                    34602.6
                  ],
                  [
                    53298.9,
                    34479.7
                  ],
                  [
                    53445.5,
                    34462.8
                  ],
                  [
                    53539.9,
                    34761.4
                  ],
                  [
                    53277.7,
                    34876.7
                  ],
                  [
                    53283.8,
                    35132
                  ],
                  [
                    53512.3,
                    35282.5
                  ],
                  [
                    53497.9,
                    35362.3
                  ],
                  [
                    53030,
                    35257.6
                  ],
                  [
                    52963.6,
                    34890
                  ],
                  [
                    52893.5,
                    34883.8
                  ],
                  [
                    52902.6,
                    34515.3
                  ]
                ],
                "id": 562,
                "chat_link": "[&BDICAAA=]"
              },
              "564": {
                "name": "Molodets Excavation",
                "level": 52,
                "coord": [
                  53548.2,
                  35204.8
                ],
                "bounds": [
                  [
                    53497.6,
                    35361.6
                  ],
                  [
                    53512.4,
                    35282
                  ],
                  [
                    53283,
                    35133.3
                  ],
                  [
                    53277.7,
                    34876.8
                  ],
                  [
                    53540,
                    34760.9
                  ],
                  [
                    53725.1,
                    35054.8
                  ],
                  [
                    53811.7,
                    35356.3
                  ],
                  [
                    53738.4,
                    35503.9
                  ],
                  [
                    53547.8,
                    35513.8
                  ],
                  [
                    53497.6,
                    35361.6
                  ]
                ],
                "id": 564,
                "chat_link": "[&BDQCAAA=]"
              },
              "565": {
                "name": "The Foundation Stones",
                "level": 55,
                "coord": [
                  53877.2,
                  35470.2
                ],
                "bounds": [
                  [
                    53738.1,
                    35501.8
                  ],
                  [
                    53811.8,
                    35355.2
                  ],
                  [
                    53891.4,
                    35255
                  ],
                  [
                    53984.4,
                    35239.1
                  ],
                  [
                    53982.3,
                    35426.9
                  ],
                  [
                    53933.7,
                    35597.2
                  ],
                  [
                    53946.5,
                    35773.3
                  ],
                  [
                    53729.8,
                    35613
                  ],
                  [
                    53738.1,
                    35501.8
                  ]
                ],
                "id": 565,
                "chat_link": "[&BDUCAAA=]"
              },
              "1023": {
                "name": "Sector Zuhl",
                "level": 52,
                "coord": [
                  53895.5,
                  34837.3
                ],
                "bounds": [
                  [
                    53537.2,
                    34768
                  ],
                  [
                    53472.8,
                    34561.7
                  ],
                  [
                    53923,
                    34364.8
                  ],
                  [
                    54300.7,
                    34464.3
                  ],
                  [
                    54156.9,
                    34585
                  ],
                  [
                    54068.2,
                    34702.5
                  ],
                  [
                    54005.3,
                    34827.8
                  ],
                  [
                    53965.7,
                    35244.5
                  ],
                  [
                    53891.8,
                    35256.4
                  ],
                  [
                    53809.4,
                    35375.9
                  ],
                  [
                    53719.2,
                    35059.7
                  ],
                  [
                    53537.2,
                    34768
                  ]
                ],
                "id": 1023,
                "chat_link": "[&BP8DAAA=]"
              }
            },
            "id": 1111,
            "mastery_points": [],
            "adventures": []
          },
          "1113": {
            "name": "Scratch Sentry Defense",
            "min_level": 50,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              52864,
              36160
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                51712,
                34560
              ],
              [
                54016,
                37760
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "539": {
                "name": "Talus Waterslide",
                "level": 60,
                "coord": [
                  52019.1,
                  37614
                ],
                "bounds": [
                  [
                    52134.8,
                    37860.4
                  ],
                  [
                    51848.6,
                    37818.3
                  ],
                  [
                    51816,
                    37670.9
                  ],
                  [
                    51736,
                    37507.2
                  ],
                  [
                    51822.5,
                    37346.7
                  ],
                  [
                    52046.8,
                    37436.5
                  ],
                  [
                    52312.1,
                    37443.5
                  ],
                  [
                    52229.3,
                    37682.8
                  ],
                  [
                    52225.7,
                    37759.3
                  ],
                  [
                    52134.8,
                    37860.4
                  ]
                ],
                "id": 539,
                "chat_link": "[&BBsCAAA=]"
              },
              "540": {
                "name": "Malorean Wilds",
                "level": 58,
                "coord": [
                  52450.5,
                  37608
                ],
                "bounds": [
                  [
                    52439.5,
                    37404.6
                  ],
                  [
                    52627.2,
                    37480.5
                  ],
                  [
                    52671.3,
                    37656.1
                  ],
                  [
                    52648.7,
                    37829.1
                  ],
                  [
                    52225.7,
                    37759.4
                  ],
                  [
                    52229.4,
                    37683
                  ],
                  [
                    52311.6,
                    37443.3
                  ],
                  [
                    52439.5,
                    37404.6
                  ]
                ],
                "id": 540,
                "chat_link": "[&BBwCAAA=]"
              },
              "541": {
                "name": "Serpent Stones",
                "level": 59,
                "coord": [
                  52758.9,
                  37436.8
                ],
                "bounds": [
                  [
                    52439.5,
                    37404.7
                  ],
                  [
                    52492.9,
                    37266.3
                  ],
                  [
                    52642.5,
                    37155.6
                  ],
                  [
                    52740,
                    37205
                  ],
                  [
                    52883.5,
                    37185.4
                  ],
                  [
                    53087.8,
                    37333.9
                  ],
                  [
                    53042.3,
                    37441.5
                  ],
                  [
                    52953.5,
                    37527
                  ],
                  [
                    52881.4,
                    37755.9
                  ],
                  [
                    52645.3,
                    37828.9
                  ],
                  [
                    52671.3,
                    37656.4
                  ],
                  [
                    52626.5,
                    37480.6
                  ],
                  [
                    52439.5,
                    37404.7
                  ]
                ],
                "id": 541,
                "chat_link": "[&BB0CAAA=]"
              },
              "542": {
                "name": "Mellaggan's Grotto",
                "level": 59,
                "coord": [
                  53329.3,
                  37571.3
                ],
                "bounds": [
                  [
                    53042.1,
                    37440.1
                  ],
                  [
                    53087.8,
                    37333.3
                  ],
                  [
                    53593,
                    37309
                  ],
                  [
                    53736.7,
                    37493.6
                  ],
                  [
                    53836.3,
                    37634.3
                  ],
                  [
                    53656.3,
                    37829.4
                  ],
                  [
                    53176.7,
                    37824.6
                  ],
                  [
                    52882.4,
                    37750.8
                  ],
                  [
                    52952.8,
                    37526.8
                  ],
                  [
                    53042.1,
                    37440.1
                  ]
                ],
                "id": 542,
                "chat_link": "[&BB4CAAA=]"
              },
              "543": {
                "name": "Lair of the Coil",
                "level": 60,
                "coord": [
                  53858.9,
                  37394.2
                ],
                "bounds": [
                  [
                    53736.2,
                    37494.3
                  ],
                  [
                    53825.5,
                    37616
                  ],
                  [
                    53938.5,
                    37532.7
                  ],
                  [
                    54050.7,
                    37417.1
                  ],
                  [
                    54049.1,
                    37299
                  ],
                  [
                    54007.7,
                    37262.9
                  ],
                  [
                    53671.3,
                    37221.8
                  ],
                  [
                    53592,
                    37309.5
                  ],
                  [
                    53736.2,
                    37494.3
                  ]
                ],
                "id": 543,
                "chat_link": "[&BB8CAAA=]"
              },
              "544": {
                "name": "Tail of the Serpent",
                "level": 60,
                "coord": [
                  53957.2,
                  37018.3
                ],
                "bounds": [
                  [
                    53927.5,
                    36975.4
                  ],
                  [
                    53931.7,
                    36721.5
                  ],
                  [
                    54010.1,
                    36773
                  ],
                  [
                    54051.4,
                    36870.5
                  ],
                  [
                    54055.3,
                    37184.3
                  ],
                  [
                    54007.1,
                    37263.9
                  ],
                  [
                    53794.4,
                    37237.9
                  ],
                  [
                    53880.4,
                    37119.8
                  ],
                  [
                    53927.5,
                    36975.4
                  ]
                ],
                "id": 544,
                "chat_link": "[&BCACAAA=]"
              },
              "545": {
                "name": "Scale Strand",
                "level": 60,
                "coord": [
                  53786.5,
                  36934.6
                ],
                "bounds": [
                  [
                    53932.3,
                    36721.4
                  ],
                  [
                    53849.8,
                    36583.3
                  ],
                  [
                    53637.4,
                    36586.1
                  ],
                  [
                    53666.5,
                    36835.1
                  ],
                  [
                    53758,
                    36931.9
                  ],
                  [
                    53745.6,
                    37133.6
                  ],
                  [
                    53671.7,
                    37220.2
                  ],
                  [
                    53794.5,
                    37238.4
                  ],
                  [
                    53880.1,
                    37120.2
                  ],
                  [
                    53928.8,
                    36975.4
                  ],
                  [
                    53932.3,
                    36721.4
                  ]
                ],
                "id": 545,
                "chat_link": "[&BCECAAA=]"
              },
              "546": {
                "name": "Nonmoa Lake",
                "level": 60,
                "coord": [
                  53362.7,
                  36957.2
                ],
                "bounds": [
                  [
                    53087.1,
                    37333.3
                  ],
                  [
                    53593.5,
                    37309.4
                  ],
                  [
                    53749.4,
                    37136.3
                  ],
                  [
                    53758.2,
                    36931.3
                  ],
                  [
                    53667.2,
                    36835.3
                  ],
                  [
                    53636.7,
                    36584.5
                  ],
                  [
                    53342,
                    36667.8
                  ],
                  [
                    53106.1,
                    36700
                  ],
                  [
                    52804,
                    36888.5
                  ],
                  [
                    52882.6,
                    37185.5
                  ],
                  [
                    53087.1,
                    37333.3
                  ]
                ],
                "id": 546,
                "chat_link": "[&BCICAAA=]"
              },
              "547": {
                "name": "Pythian Point",
                "level": 57,
                "coord": [
                  52544.2,
                  37099.9
                ],
                "bounds": [
                  [
                    52290.7,
                    36817.2
                  ],
                  [
                    52535.1,
                    36752.6
                  ],
                  [
                    52589.7,
                    36852.6
                  ],
                  [
                    52804.2,
                    36888
                  ],
                  [
                    52882.1,
                    37186.3
                  ],
                  [
                    52739.5,
                    37205
                  ],
                  [
                    52642.5,
                    37155.6
                  ],
                  [
                    52491.5,
                    37267.5
                  ],
                  [
                    52440.1,
                    37404.9
                  ],
                  [
                    52310.8,
                    37444
                  ],
                  [
                    52260.1,
                    37125.6
                  ],
                  [
                    52290.7,
                    36817.2
                  ]
                ],
                "id": 547,
                "chat_link": "[&BCMCAAA=]"
              },
              "548": {
                "name": "Tyrant's Mount",
                "level": 57,
                "coord": [
                  52082.8,
                  37109.1
                ],
                "bounds": [
                  [
                    52043.6,
                    37185
                  ],
                  [
                    52133.4,
                    37063.8
                  ],
                  [
                    52043.5,
                    36933.6
                  ],
                  [
                    52016.7,
                    36837.4
                  ],
                  [
                    52135,
                    36769.8
                  ],
                  [
                    52291.1,
                    36817.7
                  ],
                  [
                    52259.8,
                    37126.8
                  ],
                  [
                    52311,
                    37444.4
                  ],
                  [
                    52046.4,
                    37436.6
                  ],
                  [
                    51823.2,
                    37347
                  ],
                  [
                    51807.4,
                    37238
                  ],
                  [
                    52043.6,
                    37185
                  ]
                ],
                "id": 548,
                "chat_link": "[&BCQCAAA=]"
              },
              "549": {
                "name": "Ural's Delve",
                "level": 57,
                "coord": [
                  51917,
                  36994.8
                ],
                "bounds": [
                  [
                    51724.6,
                    36979.4
                  ],
                  [
                    51733,
                    36924.1
                  ],
                  [
                    51816.6,
                    36787.7
                  ],
                  [
                    52022.1,
                    36832.1
                  ],
                  [
                    52047.3,
                    36929.9
                  ],
                  [
                    52139.8,
                    37069.1
                  ],
                  [
                    52041.3,
                    37191.5
                  ],
                  [
                    51811.4,
                    37245
                  ],
                  [
                    51724.6,
                    36979.4
                  ]
                ],
                "id": 549,
                "chat_link": "[&BCUCAAA=]"
              },
              "550": {
                "name": "Candle Chimney",
                "level": 57,
                "coord": [
                  51917.2,
                  36552.6
                ],
                "bounds": [
                  [
                    51817.1,
                    36790.4
                  ],
                  [
                    51789,
                    36708.1
                  ],
                  [
                    51725.9,
                    36457.8
                  ],
                  [
                    51758,
                    36197.3
                  ],
                  [
                    51897.1,
                    36209.8
                  ],
                  [
                    51927.8,
                    36376
                  ],
                  [
                    52187,
                    36625.7
                  ],
                  [
                    52136,
                    36770.3
                  ],
                  [
                    52016.8,
                    36837.9
                  ],
                  [
                    51817.1,
                    36790.4
                  ]
                ],
                "id": 550,
                "chat_link": "[&BCYCAAA=]"
              },
              "551": {
                "name": "Gyre Rapids",
                "level": 56,
                "coord": [
                  52298.8,
                  36493.3
                ],
                "bounds": [
                  [
                    52135.5,
                    36770.5
                  ],
                  [
                    52290.4,
                    36817.6
                  ],
                  [
                    52534.5,
                    36752.8
                  ],
                  [
                    52645.5,
                    36622.8
                  ],
                  [
                    52643.6,
                    36453.4
                  ],
                  [
                    52529.8,
                    36347.9
                  ],
                  [
                    52485.8,
                    36229
                  ],
                  [
                    52013.4,
                    36223.1
                  ],
                  [
                    51894.3,
                    36205.5
                  ],
                  [
                    51927.4,
                    36377.4
                  ],
                  [
                    52186.5,
                    36625.9
                  ],
                  [
                    52135.5,
                    36770.5
                  ]
                ],
                "id": 551,
                "chat_link": "[&BCcCAAA=]"
              },
              "552": {
                "name": "Stromkarl Heights",
                "level": 55,
                "coord": [
                  52700.7,
                  36484.1
                ],
                "bounds": [
                  [
                    52643.8,
                    36622.6
                  ],
                  [
                    52643.8,
                    36454.4
                  ],
                  [
                    52530.3,
                    36347.8
                  ],
                  [
                    52484.3,
                    36230.8
                  ],
                  [
                    52540.8,
                    36076.3
                  ],
                  [
                    52870,
                    36114
                  ],
                  [
                    52929.3,
                    36172.5
                  ],
                  [
                    52907.3,
                    36487.3
                  ],
                  [
                    52931.5,
                    36809
                  ],
                  [
                    52801.8,
                    36890.4
                  ],
                  [
                    52589.7,
                    36851.3
                  ],
                  [
                    52535.6,
                    36752.5
                  ],
                  [
                    52643.8,
                    36622.6
                  ]
                ],
                "id": 552,
                "chat_link": "[&BCgCAAA=]"
              },
              "553": {
                "name": "Hunting Banks",
                "level": 59,
                "coord": [
                  53212.3,
                  36586.3
                ],
                "bounds": [
                  [
                    52930.9,
                    36809.2
                  ],
                  [
                    53106.1,
                    36700.7
                  ],
                  [
                    53343.5,
                    36671.7
                  ],
                  [
                    53634.3,
                    36588.2
                  ],
                  [
                    53383.5,
                    36447
                  ],
                  [
                    53181,
                    36401
                  ],
                  [
                    52906.9,
                    36486.5
                  ],
                  [
                    52930.9,
                    36809.2
                  ]
                ],
                "id": 553,
                "chat_link": "[&BCkCAAA=]"
              },
              "554": {
                "name": "Naui Waters",
                "level": 54,
                "coord": [
                  53675.6,
                  36304.8
                ],
                "bounds": [
                  [
                    53351.7,
                    36140.3
                  ],
                  [
                    53452.3,
                    36039.3
                  ],
                  [
                    53592.3,
                    36032.4
                  ],
                  [
                    53884.9,
                    36095.8
                  ],
                  [
                    53988.1,
                    36289.1
                  ],
                  [
                    53943.9,
                    36518
                  ],
                  [
                    53849,
                    36590.5
                  ],
                  [
                    53635.2,
                    36591.6
                  ],
                  [
                    53383.3,
                    36446.7
                  ],
                  [
                    53351.7,
                    36140.3
                  ]
                ],
                "id": 554,
                "chat_link": "[&BCoCAAA=]"
              },
              "555": {
                "name": "Guilty Tears",
                "level": 53,
                "coord": [
                  53584.5,
                  35825.5
                ],
                "bounds": [
                  [
                    53198.8,
                    35785.9
                  ],
                  [
                    53180,
                    36040.4
                  ],
                  [
                    53352.2,
                    36140.8
                  ],
                  [
                    53452,
                    36040.2
                  ],
                  [
                    53592.2,
                    36032.8
                  ],
                  [
                    53891,
                    36096.7
                  ],
                  [
                    54004.4,
                    35770.8
                  ],
                  [
                    53947.5,
                    35771.6
                  ],
                  [
                    53732.8,
                    35611.9
                  ],
                  [
                    53738.8,
                    35503.5
                  ],
                  [
                    53548.4,
                    35514.3
                  ],
                  [
                    53375.6,
                    35597.3
                  ],
                  [
                    53198.8,
                    35785.9
                  ]
                ],
                "id": 555,
                "chat_link": "[&BCsCAAA=]"
              },
              "556": {
                "name": "Bynebrachen",
                "level": 54,
                "coord": [
                  53111.2,
                  36026.7
                ],
                "bounds": [
                  [
                    52907,
                    36486.3
                  ],
                  [
                    53180.9,
                    36402.1
                  ],
                  [
                    53383.6,
                    36447.3
                  ],
                  [
                    53352.9,
                    36141
                  ],
                  [
                    53180.6,
                    36040.3
                  ],
                  [
                    53199,
                    35785.5
                  ],
                  [
                    53376.1,
                    35597.4
                  ],
                  [
                    52964.9,
                    35474.8
                  ],
                  [
                    52879.6,
                    35632.9
                  ],
                  [
                    52869.5,
                    36113.8
                  ],
                  [
                    52929.1,
                    36172
                  ],
                  [
                    52907,
                    36486.3
                  ]
                ],
                "id": 556,
                "chat_link": "[&BCwCAAA=]"
              },
              "557": {
                "name": "Fionnghuala Scratch",
                "level": 54,
                "coord": [
                  52698.6,
                  35749.5
                ],
                "bounds": [
                  [
                    52428,
                    35639.7
                  ],
                  [
                    52648.6,
                    35444.7
                  ],
                  [
                    52965.8,
                    35474.4
                  ],
                  [
                    52880.7,
                    35632.3
                  ],
                  [
                    52872.3,
                    36123.8
                  ],
                  [
                    52538.7,
                    36086.5
                  ],
                  [
                    52556.3,
                    35845.2
                  ],
                  [
                    52428,
                    35639.7
                  ]
                ],
                "id": 557,
                "chat_link": "[&BC0CAAA=]"
              },
              "558": {
                "name": "Fisher's Eye Bridges",
                "level": 55,
                "coord": [
                  52128.5,
                  35958.3
                ],
                "bounds": [
                  [
                    51759,
                    36201.6
                  ],
                  [
                    52013.3,
                    36223
                  ],
                  [
                    52485.8,
                    36228.8
                  ],
                  [
                    52544.9,
                    36081.1
                  ],
                  [
                    52556.9,
                    35845.5
                  ],
                  [
                    52428.2,
                    35639.3
                  ],
                  [
                    51887.8,
                    35707.4
                  ],
                  [
                    51730,
                    35712.8
                  ],
                  [
                    51750.5,
                    35984.7
                  ],
                  [
                    51759,
                    36201.6
                  ]
                ],
                "id": 558,
                "chat_link": "[&BC4CAAA=]"
              },
              "559": {
                "name": "Gentle River",
                "level": 53,
                "coord": [
                  52313.6,
                  35146.7
                ],
                "bounds": [
                  [
                    51824.6,
                    35283.9
                  ],
                  [
                    52096,
                    35280.7
                  ],
                  [
                    52333.8,
                    35083.8
                  ],
                  [
                    52387.9,
                    34592.4
                  ],
                  [
                    52504.8,
                    34544.4
                  ],
                  [
                    52760.2,
                    34569.3
                  ],
                  [
                    52902.4,
                    34514.1
                  ],
                  [
                    52898.9,
                    34889.6
                  ],
                  [
                    52822.9,
                    34871.1
                  ],
                  [
                    52651.1,
                    35445.8
                  ],
                  [
                    52428,
                    35640.5
                  ],
                  [
                    51887.7,
                    35707.3
                  ],
                  [
                    51739.2,
                    35713.7
                  ],
                  [
                    51711.1,
                    35625.2
                  ],
                  [
                    51755.5,
                    35439.4
                  ],
                  [
                    51824.6,
                    35283.9
                  ]
                ],
                "id": 559,
                "chat_link": "[&BC8CAAA=]"
              },
              "560": {
                "name": "Krongar Pass",
                "level": 53,
                "coord": [
                  51981.8,
                  34882.7
                ],
                "bounds": [
                  [
                    51730.4,
                    34910.8
                  ],
                  [
                    51745.9,
                    34639.2
                  ],
                  [
                    51836.8,
                    34504.2
                  ],
                  [
                    52112.8,
                    34499.3
                  ],
                  [
                    52395.1,
                    34567.7
                  ],
                  [
                    52333,
                    35085.4
                  ],
                  [
                    52095.2,
                    35281.8
                  ],
                  [
                    51824.7,
                    35283.8
                  ],
                  [
                    51762.3,
                    35172.6
                  ],
                  [
                    51730.4,
                    34910.8
                  ]
                ],
                "id": 560,
                "chat_link": "[&BDACAAA=]"
              },
              "561": {
                "name": "White Paper Hill",
                "level": 53,
                "coord": [
                  53107.1,
                  35301.8
                ],
                "bounds": [
                  [
                    52820.1,
                    34867.9
                  ],
                  [
                    52967.9,
                    34886.7
                  ],
                  [
                    53038.1,
                    35256.2
                  ],
                  [
                    53498.2,
                    35358.6
                  ],
                  [
                    53552.5,
                    35513.9
                  ],
                  [
                    53375.5,
                    35603.2
                  ],
                  [
                    52959.5,
                    35479
                  ],
                  [
                    52644.9,
                    35449.3
                  ],
                  [
                    52820.1,
                    34867.9
                  ]
                ],
                "id": 561,
                "chat_link": "[&BDECAAA=]"
              },
              "562": {
                "name": "The Iron Veil",
                "level": 52,
                "coord": [
                  53237,
                  34875.6
                ],
                "bounds": [
                  [
                    52902.6,
                    34515.3
                  ],
                  [
                    53198.2,
                    34602.6
                  ],
                  [
                    53298.9,
                    34479.7
                  ],
                  [
                    53445.5,
                    34462.8
                  ],
                  [
                    53539.9,
                    34761.4
                  ],
                  [
                    53277.7,
                    34876.7
                  ],
                  [
                    53283.8,
                    35132
                  ],
                  [
                    53512.3,
                    35282.5
                  ],
                  [
                    53497.9,
                    35362.3
                  ],
                  [
                    53030,
                    35257.6
                  ],
                  [
                    52963.6,
                    34890
                  ],
                  [
                    52893.5,
                    34883.8
                  ],
                  [
                    52902.6,
                    34515.3
                  ]
                ],
                "id": 562,
                "chat_link": "[&BDICAAA=]"
              },
              "564": {
                "name": "Molodets Excavation",
                "level": 52,
                "coord": [
                  53548.2,
                  35204.8
                ],
                "bounds": [
                  [
                    53497.6,
                    35361.6
                  ],
                  [
                    53512.4,
                    35282
                  ],
                  [
                    53283,
                    35133.3
                  ],
                  [
                    53277.7,
                    34876.8
                  ],
                  [
                    53540,
                    34760.9
                  ],
                  [
                    53725.1,
                    35054.8
                  ],
                  [
                    53811.7,
                    35356.3
                  ],
                  [
                    53738.4,
                    35503.9
                  ],
                  [
                    53547.8,
                    35513.8
                  ],
                  [
                    53497.6,
                    35361.6
                  ]
                ],
                "id": 564,
                "chat_link": "[&BDQCAAA=]"
              },
              "565": {
                "name": "The Foundation Stones",
                "level": 55,
                "coord": [
                  53877.2,
                  35470.2
                ],
                "bounds": [
                  [
                    53738.1,
                    35501.8
                  ],
                  [
                    53811.8,
                    35355.2
                  ],
                  [
                    53891.4,
                    35255
                  ],
                  [
                    53984.4,
                    35239.1
                  ],
                  [
                    53982.3,
                    35426.9
                  ],
                  [
                    53933.7,
                    35597.2
                  ],
                  [
                    53946.5,
                    35773.3
                  ],
                  [
                    53729.8,
                    35613
                  ],
                  [
                    53738.1,
                    35501.8
                  ]
                ],
                "id": 565,
                "chat_link": "[&BDUCAAA=]"
              },
              "1023": {
                "name": "Sector Zuhl",
                "level": 52,
                "coord": [
                  53895.5,
                  34837.3
                ],
                "bounds": [
                  [
                    53537.2,
                    34768
                  ],
                  [
                    53472.8,
                    34561.7
                  ],
                  [
                    53923,
                    34364.8
                  ],
                  [
                    54300.7,
                    34464.3
                  ],
                  [
                    54156.9,
                    34585
                  ],
                  [
                    54068.2,
                    34702.5
                  ],
                  [
                    54005.3,
                    34827.8
                  ],
                  [
                    53965.7,
                    35244.5
                  ],
                  [
                    53891.8,
                    35256.4
                  ],
                  [
                    53809.4,
                    35375.9
                  ],
                  [
                    53719.2,
                    35059.7
                  ],
                  [
                    53537.2,
                    34768
                  ]
                ],
                "id": 1023,
                "chat_link": "[&BP8DAAA=]"
              }
            },
            "id": 1113,
            "mastery_points": [],
            "adventures": []
          },
          "1128": {
            "name": "Scratch Sentry Defense",
            "min_level": 50,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              52864,
              36160
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                51712,
                34560
              ],
              [
                54016,
                37760
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "539": {
                "name": "Talus Waterslide",
                "level": 60,
                "coord": [
                  52019.1,
                  37614
                ],
                "bounds": [
                  [
                    52134.8,
                    37860.4
                  ],
                  [
                    51848.6,
                    37818.3
                  ],
                  [
                    51816,
                    37670.9
                  ],
                  [
                    51736,
                    37507.2
                  ],
                  [
                    51822.5,
                    37346.7
                  ],
                  [
                    52046.8,
                    37436.5
                  ],
                  [
                    52312.1,
                    37443.5
                  ],
                  [
                    52229.3,
                    37682.8
                  ],
                  [
                    52225.7,
                    37759.3
                  ],
                  [
                    52134.8,
                    37860.4
                  ]
                ],
                "id": 539,
                "chat_link": "[&BBsCAAA=]"
              },
              "540": {
                "name": "Malorean Wilds",
                "level": 58,
                "coord": [
                  52450.5,
                  37608
                ],
                "bounds": [
                  [
                    52439.5,
                    37404.6
                  ],
                  [
                    52627.2,
                    37480.5
                  ],
                  [
                    52671.3,
                    37656.1
                  ],
                  [
                    52648.7,
                    37829.1
                  ],
                  [
                    52225.7,
                    37759.4
                  ],
                  [
                    52229.4,
                    37683
                  ],
                  [
                    52311.6,
                    37443.3
                  ],
                  [
                    52439.5,
                    37404.6
                  ]
                ],
                "id": 540,
                "chat_link": "[&BBwCAAA=]"
              },
              "541": {
                "name": "Serpent Stones",
                "level": 59,
                "coord": [
                  52758.9,
                  37436.8
                ],
                "bounds": [
                  [
                    52439.5,
                    37404.7
                  ],
                  [
                    52492.9,
                    37266.3
                  ],
                  [
                    52642.5,
                    37155.6
                  ],
                  [
                    52740,
                    37205
                  ],
                  [
                    52883.5,
                    37185.4
                  ],
                  [
                    53087.8,
                    37333.9
                  ],
                  [
                    53042.3,
                    37441.5
                  ],
                  [
                    52953.5,
                    37527
                  ],
                  [
                    52881.4,
                    37755.9
                  ],
                  [
                    52645.3,
                    37828.9
                  ],
                  [
                    52671.3,
                    37656.4
                  ],
                  [
                    52626.5,
                    37480.6
                  ],
                  [
                    52439.5,
                    37404.7
                  ]
                ],
                "id": 541,
                "chat_link": "[&BB0CAAA=]"
              },
              "542": {
                "name": "Mellaggan's Grotto",
                "level": 59,
                "coord": [
                  53329.3,
                  37571.3
                ],
                "bounds": [
                  [
                    53042.1,
                    37440.1
                  ],
                  [
                    53087.8,
                    37333.3
                  ],
                  [
                    53593,
                    37309
                  ],
                  [
                    53736.7,
                    37493.6
                  ],
                  [
                    53836.3,
                    37634.3
                  ],
                  [
                    53656.3,
                    37829.4
                  ],
                  [
                    53176.7,
                    37824.6
                  ],
                  [
                    52882.4,
                    37750.8
                  ],
                  [
                    52952.8,
                    37526.8
                  ],
                  [
                    53042.1,
                    37440.1
                  ]
                ],
                "id": 542,
                "chat_link": "[&BB4CAAA=]"
              },
              "543": {
                "name": "Lair of the Coil",
                "level": 60,
                "coord": [
                  53858.9,
                  37394.2
                ],
                "bounds": [
                  [
                    53736.2,
                    37494.3
                  ],
                  [
                    53825.5,
                    37616
                  ],
                  [
                    53938.5,
                    37532.7
                  ],
                  [
                    54050.7,
                    37417.1
                  ],
                  [
                    54049.1,
                    37299
                  ],
                  [
                    54007.7,
                    37262.9
                  ],
                  [
                    53671.3,
                    37221.8
                  ],
                  [
                    53592,
                    37309.5
                  ],
                  [
                    53736.2,
                    37494.3
                  ]
                ],
                "id": 543,
                "chat_link": "[&BB8CAAA=]"
              },
              "544": {
                "name": "Tail of the Serpent",
                "level": 60,
                "coord": [
                  53957.2,
                  37018.3
                ],
                "bounds": [
                  [
                    53927.5,
                    36975.4
                  ],
                  [
                    53931.7,
                    36721.5
                  ],
                  [
                    54010.1,
                    36773
                  ],
                  [
                    54051.4,
                    36870.5
                  ],
                  [
                    54055.3,
                    37184.3
                  ],
                  [
                    54007.1,
                    37263.9
                  ],
                  [
                    53794.4,
                    37237.9
                  ],
                  [
                    53880.4,
                    37119.8
                  ],
                  [
                    53927.5,
                    36975.4
                  ]
                ],
                "id": 544,
                "chat_link": "[&BCACAAA=]"
              },
              "545": {
                "name": "Scale Strand",
                "level": 60,
                "coord": [
                  53786.5,
                  36934.6
                ],
                "bounds": [
                  [
                    53932.3,
                    36721.4
                  ],
                  [
                    53849.8,
                    36583.3
                  ],
                  [
                    53637.4,
                    36586.1
                  ],
                  [
                    53666.5,
                    36835.1
                  ],
                  [
                    53758,
                    36931.9
                  ],
                  [
                    53745.6,
                    37133.6
                  ],
                  [
                    53671.7,
                    37220.2
                  ],
                  [
                    53794.5,
                    37238.4
                  ],
                  [
                    53880.1,
                    37120.2
                  ],
                  [
                    53928.8,
                    36975.4
                  ],
                  [
                    53932.3,
                    36721.4
                  ]
                ],
                "id": 545,
                "chat_link": "[&BCECAAA=]"
              },
              "546": {
                "name": "Nonmoa Lake",
                "level": 60,
                "coord": [
                  53362.7,
                  36957.2
                ],
                "bounds": [
                  [
                    53087.1,
                    37333.3
                  ],
                  [
                    53593.5,
                    37309.4
                  ],
                  [
                    53749.4,
                    37136.3
                  ],
                  [
                    53758.2,
                    36931.3
                  ],
                  [
                    53667.2,
                    36835.3
                  ],
                  [
                    53636.7,
                    36584.5
                  ],
                  [
                    53342,
                    36667.8
                  ],
                  [
                    53106.1,
                    36700
                  ],
                  [
                    52804,
                    36888.5
                  ],
                  [
                    52882.6,
                    37185.5
                  ],
                  [
                    53087.1,
                    37333.3
                  ]
                ],
                "id": 546,
                "chat_link": "[&BCICAAA=]"
              },
              "547": {
                "name": "Pythian Point",
                "level": 57,
                "coord": [
                  52544.2,
                  37099.9
                ],
                "bounds": [
                  [
                    52290.7,
                    36817.2
                  ],
                  [
                    52535.1,
                    36752.6
                  ],
                  [
                    52589.7,
                    36852.6
                  ],
                  [
                    52804.2,
                    36888
                  ],
                  [
                    52882.1,
                    37186.3
                  ],
                  [
                    52739.5,
                    37205
                  ],
                  [
                    52642.5,
                    37155.6
                  ],
                  [
                    52491.5,
                    37267.5
                  ],
                  [
                    52440.1,
                    37404.9
                  ],
                  [
                    52310.8,
                    37444
                  ],
                  [
                    52260.1,
                    37125.6
                  ],
                  [
                    52290.7,
                    36817.2
                  ]
                ],
                "id": 547,
                "chat_link": "[&BCMCAAA=]"
              },
              "548": {
                "name": "Tyrant's Mount",
                "level": 57,
                "coord": [
                  52082.8,
                  37109.1
                ],
                "bounds": [
                  [
                    52043.6,
                    37185
                  ],
                  [
                    52133.4,
                    37063.8
                  ],
                  [
                    52043.5,
                    36933.6
                  ],
                  [
                    52016.7,
                    36837.4
                  ],
                  [
                    52135,
                    36769.8
                  ],
                  [
                    52291.1,
                    36817.7
                  ],
                  [
                    52259.8,
                    37126.8
                  ],
                  [
                    52311,
                    37444.4
                  ],
                  [
                    52046.4,
                    37436.6
                  ],
                  [
                    51823.2,
                    37347
                  ],
                  [
                    51807.4,
                    37238
                  ],
                  [
                    52043.6,
                    37185
                  ]
                ],
                "id": 548,
                "chat_link": "[&BCQCAAA=]"
              },
              "549": {
                "name": "Ural's Delve",
                "level": 57,
                "coord": [
                  51917,
                  36994.8
                ],
                "bounds": [
                  [
                    51724.6,
                    36979.4
                  ],
                  [
                    51733,
                    36924.1
                  ],
                  [
                    51816.6,
                    36787.7
                  ],
                  [
                    52022.1,
                    36832.1
                  ],
                  [
                    52047.3,
                    36929.9
                  ],
                  [
                    52139.8,
                    37069.1
                  ],
                  [
                    52041.3,
                    37191.5
                  ],
                  [
                    51811.4,
                    37245
                  ],
                  [
                    51724.6,
                    36979.4
                  ]
                ],
                "id": 549,
                "chat_link": "[&BCUCAAA=]"
              },
              "550": {
                "name": "Candle Chimney",
                "level": 57,
                "coord": [
                  51917.2,
                  36552.6
                ],
                "bounds": [
                  [
                    51817.1,
                    36790.4
                  ],
                  [
                    51789,
                    36708.1
                  ],
                  [
                    51725.9,
                    36457.8
                  ],
                  [
                    51758,
                    36197.3
                  ],
                  [
                    51897.1,
                    36209.8
                  ],
                  [
                    51927.8,
                    36376
                  ],
                  [
                    52187,
                    36625.7
                  ],
                  [
                    52136,
                    36770.3
                  ],
                  [
                    52016.8,
                    36837.9
                  ],
                  [
                    51817.1,
                    36790.4
                  ]
                ],
                "id": 550,
                "chat_link": "[&BCYCAAA=]"
              },
              "551": {
                "name": "Gyre Rapids",
                "level": 56,
                "coord": [
                  52298.8,
                  36493.3
                ],
                "bounds": [
                  [
                    52135.5,
                    36770.5
                  ],
                  [
                    52290.4,
                    36817.6
                  ],
                  [
                    52534.5,
                    36752.8
                  ],
                  [
                    52645.5,
                    36622.8
                  ],
                  [
                    52643.6,
                    36453.4
                  ],
                  [
                    52529.8,
                    36347.9
                  ],
                  [
                    52485.8,
                    36229
                  ],
                  [
                    52013.4,
                    36223.1
                  ],
                  [
                    51894.3,
                    36205.5
                  ],
                  [
                    51927.4,
                    36377.4
                  ],
                  [
                    52186.5,
                    36625.9
                  ],
                  [
                    52135.5,
                    36770.5
                  ]
                ],
                "id": 551,
                "chat_link": "[&BCcCAAA=]"
              },
              "552": {
                "name": "Stromkarl Heights",
                "level": 55,
                "coord": [
                  52700.7,
                  36484.1
                ],
                "bounds": [
                  [
                    52643.8,
                    36622.6
                  ],
                  [
                    52643.8,
                    36454.4
                  ],
                  [
                    52530.3,
                    36347.8
                  ],
                  [
                    52484.3,
                    36230.8
                  ],
                  [
                    52540.8,
                    36076.3
                  ],
                  [
                    52870,
                    36114
                  ],
                  [
                    52929.3,
                    36172.5
                  ],
                  [
                    52907.3,
                    36487.3
                  ],
                  [
                    52931.5,
                    36809
                  ],
                  [
                    52801.8,
                    36890.4
                  ],
                  [
                    52589.7,
                    36851.3
                  ],
                  [
                    52535.6,
                    36752.5
                  ],
                  [
                    52643.8,
                    36622.6
                  ]
                ],
                "id": 552,
                "chat_link": "[&BCgCAAA=]"
              },
              "553": {
                "name": "Hunting Banks",
                "level": 59,
                "coord": [
                  53212.3,
                  36586.3
                ],
                "bounds": [
                  [
                    52930.9,
                    36809.2
                  ],
                  [
                    53106.1,
                    36700.7
                  ],
                  [
                    53343.5,
                    36671.7
                  ],
                  [
                    53634.3,
                    36588.2
                  ],
                  [
                    53383.5,
                    36447
                  ],
                  [
                    53181,
                    36401
                  ],
                  [
                    52906.9,
                    36486.5
                  ],
                  [
                    52930.9,
                    36809.2
                  ]
                ],
                "id": 553,
                "chat_link": "[&BCkCAAA=]"
              },
              "554": {
                "name": "Naui Waters",
                "level": 54,
                "coord": [
                  53675.6,
                  36304.8
                ],
                "bounds": [
                  [
                    53351.7,
                    36140.3
                  ],
                  [
                    53452.3,
                    36039.3
                  ],
                  [
                    53592.3,
                    36032.4
                  ],
                  [
                    53884.9,
                    36095.8
                  ],
                  [
                    53988.1,
                    36289.1
                  ],
                  [
                    53943.9,
                    36518
                  ],
                  [
                    53849,
                    36590.5
                  ],
                  [
                    53635.2,
                    36591.6
                  ],
                  [
                    53383.3,
                    36446.7
                  ],
                  [
                    53351.7,
                    36140.3
                  ]
                ],
                "id": 554,
                "chat_link": "[&BCoCAAA=]"
              },
              "555": {
                "name": "Guilty Tears",
                "level": 53,
                "coord": [
                  53584.5,
                  35825.5
                ],
                "bounds": [
                  [
                    53198.8,
                    35785.9
                  ],
                  [
                    53180,
                    36040.4
                  ],
                  [
                    53352.2,
                    36140.8
                  ],
                  [
                    53452,
                    36040.2
                  ],
                  [
                    53592.2,
                    36032.8
                  ],
                  [
                    53891,
                    36096.7
                  ],
                  [
                    54004.4,
                    35770.8
                  ],
                  [
                    53947.5,
                    35771.6
                  ],
                  [
                    53732.8,
                    35611.9
                  ],
                  [
                    53738.8,
                    35503.5
                  ],
                  [
                    53548.4,
                    35514.3
                  ],
                  [
                    53375.6,
                    35597.3
                  ],
                  [
                    53198.8,
                    35785.9
                  ]
                ],
                "id": 555,
                "chat_link": "[&BCsCAAA=]"
              },
              "556": {
                "name": "Bynebrachen",
                "level": 54,
                "coord": [
                  53111.2,
                  36026.7
                ],
                "bounds": [
                  [
                    52907,
                    36486.3
                  ],
                  [
                    53180.9,
                    36402.1
                  ],
                  [
                    53383.6,
                    36447.3
                  ],
                  [
                    53352.9,
                    36141
                  ],
                  [
                    53180.6,
                    36040.3
                  ],
                  [
                    53199,
                    35785.5
                  ],
                  [
                    53376.1,
                    35597.4
                  ],
                  [
                    52964.9,
                    35474.8
                  ],
                  [
                    52879.6,
                    35632.9
                  ],
                  [
                    52869.5,
                    36113.8
                  ],
                  [
                    52929.1,
                    36172
                  ],
                  [
                    52907,
                    36486.3
                  ]
                ],
                "id": 556,
                "chat_link": "[&BCwCAAA=]"
              },
              "557": {
                "name": "Fionnghuala Scratch",
                "level": 54,
                "coord": [
                  52698.6,
                  35749.5
                ],
                "bounds": [
                  [
                    52428,
                    35639.7
                  ],
                  [
                    52648.6,
                    35444.7
                  ],
                  [
                    52965.8,
                    35474.4
                  ],
                  [
                    52880.7,
                    35632.3
                  ],
                  [
                    52872.3,
                    36123.8
                  ],
                  [
                    52538.7,
                    36086.5
                  ],
                  [
                    52556.3,
                    35845.2
                  ],
                  [
                    52428,
                    35639.7
                  ]
                ],
                "id": 557,
                "chat_link": "[&BC0CAAA=]"
              },
              "558": {
                "name": "Fisher's Eye Bridges",
                "level": 55,
                "coord": [
                  52128.5,
                  35958.3
                ],
                "bounds": [
                  [
                    51759,
                    36201.6
                  ],
                  [
                    52013.3,
                    36223
                  ],
                  [
                    52485.8,
                    36228.8
                  ],
                  [
                    52544.9,
                    36081.1
                  ],
                  [
                    52556.9,
                    35845.5
                  ],
                  [
                    52428.2,
                    35639.3
                  ],
                  [
                    51887.8,
                    35707.4
                  ],
                  [
                    51730,
                    35712.8
                  ],
                  [
                    51750.5,
                    35984.7
                  ],
                  [
                    51759,
                    36201.6
                  ]
                ],
                "id": 558,
                "chat_link": "[&BC4CAAA=]"
              },
              "559": {
                "name": "Gentle River",
                "level": 53,
                "coord": [
                  52313.6,
                  35146.7
                ],
                "bounds": [
                  [
                    51824.6,
                    35283.9
                  ],
                  [
                    52096,
                    35280.7
                  ],
                  [
                    52333.8,
                    35083.8
                  ],
                  [
                    52387.9,
                    34592.4
                  ],
                  [
                    52504.8,
                    34544.4
                  ],
                  [
                    52760.2,
                    34569.3
                  ],
                  [
                    52902.4,
                    34514.1
                  ],
                  [
                    52898.9,
                    34889.6
                  ],
                  [
                    52822.9,
                    34871.1
                  ],
                  [
                    52651.1,
                    35445.8
                  ],
                  [
                    52428,
                    35640.5
                  ],
                  [
                    51887.7,
                    35707.3
                  ],
                  [
                    51739.2,
                    35713.7
                  ],
                  [
                    51711.1,
                    35625.2
                  ],
                  [
                    51755.5,
                    35439.4
                  ],
                  [
                    51824.6,
                    35283.9
                  ]
                ],
                "id": 559,
                "chat_link": "[&BC8CAAA=]"
              },
              "560": {
                "name": "Krongar Pass",
                "level": 53,
                "coord": [
                  51981.8,
                  34882.7
                ],
                "bounds": [
                  [
                    51730.4,
                    34910.8
                  ],
                  [
                    51745.9,
                    34639.2
                  ],
                  [
                    51836.8,
                    34504.2
                  ],
                  [
                    52112.8,
                    34499.3
                  ],
                  [
                    52395.1,
                    34567.7
                  ],
                  [
                    52333,
                    35085.4
                  ],
                  [
                    52095.2,
                    35281.8
                  ],
                  [
                    51824.7,
                    35283.8
                  ],
                  [
                    51762.3,
                    35172.6
                  ],
                  [
                    51730.4,
                    34910.8
                  ]
                ],
                "id": 560,
                "chat_link": "[&BDACAAA=]"
              },
              "561": {
                "name": "White Paper Hill",
                "level": 53,
                "coord": [
                  53107.1,
                  35301.8
                ],
                "bounds": [
                  [
                    52820.1,
                    34867.9
                  ],
                  [
                    52967.9,
                    34886.7
                  ],
                  [
                    53038.1,
                    35256.2
                  ],
                  [
                    53498.2,
                    35358.6
                  ],
                  [
                    53552.5,
                    35513.9
                  ],
                  [
                    53375.5,
                    35603.2
                  ],
                  [
                    52959.5,
                    35479
                  ],
                  [
                    52644.9,
                    35449.3
                  ],
                  [
                    52820.1,
                    34867.9
                  ]
                ],
                "id": 561,
                "chat_link": "[&BDECAAA=]"
              },
              "562": {
                "name": "The Iron Veil",
                "level": 52,
                "coord": [
                  53237,
                  34875.6
                ],
                "bounds": [
                  [
                    52902.6,
                    34515.3
                  ],
                  [
                    53198.2,
                    34602.6
                  ],
                  [
                    53298.9,
                    34479.7
                  ],
                  [
                    53445.5,
                    34462.8
                  ],
                  [
                    53539.9,
                    34761.4
                  ],
                  [
                    53277.7,
                    34876.7
                  ],
                  [
                    53283.8,
                    35132
                  ],
                  [
                    53512.3,
                    35282.5
                  ],
                  [
                    53497.9,
                    35362.3
                  ],
                  [
                    53030,
                    35257.6
                  ],
                  [
                    52963.6,
                    34890
                  ],
                  [
                    52893.5,
                    34883.8
                  ],
                  [
                    52902.6,
                    34515.3
                  ]
                ],
                "id": 562,
                "chat_link": "[&BDICAAA=]"
              },
              "564": {
                "name": "Molodets Excavation",
                "level": 52,
                "coord": [
                  53548.2,
                  35204.8
                ],
                "bounds": [
                  [
                    53497.6,
                    35361.6
                  ],
                  [
                    53512.4,
                    35282
                  ],
                  [
                    53283,
                    35133.3
                  ],
                  [
                    53277.7,
                    34876.8
                  ],
                  [
                    53540,
                    34760.9
                  ],
                  [
                    53725.1,
                    35054.8
                  ],
                  [
                    53811.7,
                    35356.3
                  ],
                  [
                    53738.4,
                    35503.9
                  ],
                  [
                    53547.8,
                    35513.8
                  ],
                  [
                    53497.6,
                    35361.6
                  ]
                ],
                "id": 564,
                "chat_link": "[&BDQCAAA=]"
              },
              "565": {
                "name": "The Foundation Stones",
                "level": 55,
                "coord": [
                  53877.2,
                  35470.2
                ],
                "bounds": [
                  [
                    53738.1,
                    35501.8
                  ],
                  [
                    53811.8,
                    35355.2
                  ],
                  [
                    53891.4,
                    35255
                  ],
                  [
                    53984.4,
                    35239.1
                  ],
                  [
                    53982.3,
                    35426.9
                  ],
                  [
                    53933.7,
                    35597.2
                  ],
                  [
                    53946.5,
                    35773.3
                  ],
                  [
                    53729.8,
                    35613
                  ],
                  [
                    53738.1,
                    35501.8
                  ]
                ],
                "id": 565,
                "chat_link": "[&BDUCAAA=]"
              },
              "1023": {
                "name": "Sector Zuhl",
                "level": 52,
                "coord": [
                  53895.5,
                  34837.3
                ],
                "bounds": [
                  [
                    53537.2,
                    34768
                  ],
                  [
                    53472.8,
                    34561.7
                  ],
                  [
                    53923,
                    34364.8
                  ],
                  [
                    54300.7,
                    34464.3
                  ],
                  [
                    54156.9,
                    34585
                  ],
                  [
                    54068.2,
                    34702.5
                  ],
                  [
                    54005.3,
                    34827.8
                  ],
                  [
                    53965.7,
                    35244.5
                  ],
                  [
                    53891.8,
                    35256.4
                  ],
                  [
                    53809.4,
                    35375.9
                  ],
                  [
                    53719.2,
                    35059.7
                  ],
                  [
                    53537.2,
                    34768
                  ]
                ],
                "id": 1023,
                "chat_link": "[&BP8DAAA=]"
              }
            },
            "id": 1128,
            "mastery_points": [],
            "adventures": []
          },
          "1161": {
            "name": "Eir's Homestead",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "886": {
                "name": "Stonewright's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54015.6,
                  31159.6
                ],
                "id": 886,
                "chat_link": "[&BHYDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "805": {
                "name": "Frost Basin",
                "level": 0,
                "coord": [
                  54220.9,
                  31207.1
                ],
                "bounds": [
                  [
                    53878,
                    31116.3
                  ],
                  [
                    54211.6,
                    30928.4
                  ],
                  [
                    54549.9,
                    30961
                  ],
                  [
                    54551.5,
                    31357.6
                  ],
                  [
                    54329.2,
                    31369.1
                  ],
                  [
                    54144.6,
                    31355.4
                  ],
                  [
                    53881.3,
                    31362.3
                  ],
                  [
                    53878,
                    31116.3
                  ]
                ],
                "id": 805,
                "chat_link": "[&BCUDAAA=]"
              }
            },
            "adventures": [],
            "id": 1161,
            "mastery_points": []
          },
          "1178": {
            "name": "Bitterfrost Frontier",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              55040,
              23854
            ],
            "map_rect": [
              [
                -36864,
                -18432
              ],
              [
                36864,
                18432
              ]
            ],
            "continent_rect": [
              [
                53504,
                23040
              ],
              [
                56576,
                24576
              ]
            ],
            "points_of_interest": {
              "2428": {
                "name": "Blister Cauldron",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56373,
                  24427
                ],
                "id": 2428,
                "chat_link": "[&BHwJAAA=]"
              },
              "2429": {
                "name": "Sorrow's Eclipse Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54983.6,
                  23969.6
                ],
                "id": 2429,
                "chat_link": "[&BH0JAAA=]"
              },
              "2430": {
                "name": "Whorl Lagoon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55928,
                  24298.5
                ],
                "id": 2430,
                "chat_link": "[&BH4JAAA=]"
              },
              "2431": {
                "name": "Chokocooka's Throne",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55050.3,
                  23486.9
                ],
                "id": 2431,
                "chat_link": "[&BH8JAAA=]"
              },
              "2432": {
                "name": "Lockflow Ice Fall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56231.3,
                  23349.4
                ],
                "id": 2432,
                "chat_link": "[&BIAJAAA=]"
              },
              "2433": {
                "name": "Koda's Welcome Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54151.6,
                  24385.5
                ],
                "id": 2433,
                "chat_link": "[&BIEJAAA=]"
              },
              "2434": {
                "name": "Gooloopa Deeps",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55053.1,
                  23979.9
                ],
                "id": 2434,
                "chat_link": "[&BIIJAAA=]"
              },
              "2435": {
                "name": "Joyless Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53981.1,
                  23370.2
                ],
                "id": 2435,
                "chat_link": "[&BIMJAAA=]"
              },
              "2436": {
                "name": "Black Cavern Junction",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54682.3,
                  24429.3
                ],
                "id": 2436,
                "chat_link": "[&BIQJAAA=]"
              },
              "2437": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  53676.5,
                  24218.7
                ],
                "id": 2437,
                "chat_link": "[&BIUJAAA=]"
              },
              "2438": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  55140.1,
                  23438.8
                ],
                "id": 2438,
                "chat_link": "[&BIYJAAA=]"
              },
              "2439": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  55119.3,
                  23972.2
                ],
                "id": 2439,
                "chat_link": "[&BIcJAAA=]"
              },
              "2440": {
                "name": "Maw of Corruption",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53986.2,
                  23863.3
                ],
                "id": 2440,
                "chat_link": "[&BIgJAAA=]"
              },
              "2441": {
                "name": "Dragon's Eye View",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53652.9,
                  24241.9
                ],
                "id": 2441,
                "chat_link": "[&BIkJAAA=]"
              },
              "2442": {
                "name": "Hollow Bone Den",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55305.1,
                  23247.6
                ],
                "id": 2442,
                "chat_link": "[&BIoJAAA=]"
              },
              "2443": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  53938.7,
                  23499.6
                ],
                "id": 2443,
                "chat_link": "[&BIsJAAA=]"
              },
              "2444": {
                "name": "Ice Vein Cavern",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54458.1,
                  24386.8
                ],
                "id": 2444,
                "chat_link": "[&BIwJAAA=]"
              },
              "2445": {
                "name": "Judgment Pass",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55267.9,
                  24527.9
                ],
                "id": 2445,
                "chat_link": "[&BI0JAAA=]"
              },
              "2446": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  55900.1,
                  24499.2
                ],
                "id": 2446,
                "chat_link": "[&BI4JAAA=]"
              },
              "2447": {
                "name": "The Titan Tree",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54435.3,
                  23457.7
                ],
                "id": 2447,
                "chat_link": "[&BI8JAAA=]"
              }
            },
            "tasks": {
              "368": {
                "objective": "Keep the grawl busy so they don't turn to Jormag.",
                "level": 80,
                "coord": [
                  54977.3,
                  23513.1
                ],
                "bounds": [
                  [
                    54442.1,
                    23446.6
                  ],
                  [
                    54493.8,
                    23196.9
                  ],
                  [
                    54782,
                    23281.2
                  ],
                  [
                    55254.6,
                    23073.1
                  ],
                  [
                    55318,
                    23082.3
                  ],
                  [
                    55530.5,
                    23301.3
                  ],
                  [
                    55409.7,
                    23756.9
                  ],
                  [
                    54476.5,
                    23850.3
                  ],
                  [
                    54442.1,
                    23446.6
                  ]
                ],
                "id": 368,
                "chat_link": "[&BHABAAA=]"
              },
              "369": {
                "objective": "Help the quaggan farmers harvest food.",
                "level": 80,
                "coord": [
                  55891.6,
                  24288.4
                ],
                "bounds": [
                  [
                    55769.4,
                    24185.3
                  ],
                  [
                    55848.4,
                    24016.4
                  ],
                  [
                    56170.8,
                    24070.9
                  ],
                  [
                    56363.6,
                    24368.5
                  ],
                  [
                    56415.1,
                    24390.7
                  ],
                  [
                    56420.7,
                    24463.6
                  ],
                  [
                    56369.2,
                    24507.1
                  ],
                  [
                    56165.9,
                    24483.4
                  ],
                  [
                    55939.6,
                    24503.5
                  ],
                  [
                    55829.3,
                    24428.9
                  ],
                  [
                    55771.2,
                    24329.9
                  ],
                  [
                    55769.4,
                    24185.3
                  ]
                ],
                "id": 369,
                "chat_link": "[&BHEBAAA=]"
              },
              "370": {
                "objective": "Help protect the endangered snow griffons.",
                "level": 80,
                "coord": [
                  54373.5,
                  23694
                ],
                "bounds": [
                  [
                    54325.1,
                    23939.4
                  ],
                  [
                    54481.2,
                    23880.1
                  ],
                  [
                    54455.9,
                    23644.2
                  ],
                  [
                    54422.2,
                    23265.9
                  ],
                  [
                    54310.5,
                    23268
                  ],
                  [
                    53640.5,
                    23431
                  ],
                  [
                    53749.8,
                    23800
                  ],
                  [
                    54325.1,
                    23939.4
                  ]
                ],
                "id": 370,
                "chat_link": "[&BHIBAAA=]"
              },
              "371": {
                "objective": "Disrupt the Svanir.",
                "level": 80,
                "coord": [
                  53646.7,
                  24354.1
                ],
                "bounds": [
                  [
                    53609.6,
                    24365.1
                  ],
                  [
                    53517.5,
                    24161.9
                  ],
                  [
                    53708.3,
                    23983.1
                  ],
                  [
                    53981.2,
                    23889.4
                  ],
                  [
                    54082.5,
                    24163.2
                  ],
                  [
                    54011.1,
                    24419
                  ],
                  [
                    53796.3,
                    24467.6
                  ],
                  [
                    53609.6,
                    24365.1
                  ]
                ],
                "id": 371,
                "chat_link": "[&BHMBAAA=]"
              }
            },
            "skill_challenges": [],
            "sectors": {
              "1409": {
                "name": "Griffon Old Growth",
                "level": 80,
                "coord": [
                  54088.9,
                  23455
                ],
                "bounds": [
                  [
                    54539.3,
                    23082.5
                  ],
                  [
                    54513,
                    23095.9
                  ],
                  [
                    54468.2,
                    23098.5
                  ],
                  [
                    54434.5,
                    23074.6
                  ],
                  [
                    53931,
                    23094.7
                  ],
                  [
                    53779.9,
                    23159.9
                  ],
                  [
                    53679.8,
                    23213.8
                  ],
                  [
                    53582.4,
                    23292.5
                  ],
                  [
                    53559.5,
                    23364.5
                  ],
                  [
                    53530.9,
                    23854.3
                  ],
                  [
                    53602.2,
                    23892.4
                  ],
                  [
                    53957.1,
                    23983.5
                  ],
                  [
                    54206.3,
                    23930.1
                  ],
                  [
                    54426.6,
                    23834.7
                  ],
                  [
                    54426.6,
                    23834.7
                  ],
                  [
                    54785.1,
                    23473.9
                  ],
                  [
                    54539.3,
                    23082.5
                  ]
                ],
                "id": 1409,
                "chat_link": "[&BIEFAAA=]"
              },
              "1410": {
                "name": "The Svanir Hive",
                "level": 80,
                "coord": [
                  53780.3,
                  24215.4
                ],
                "bounds": [
                  [
                    53536.3,
                    24580.2
                  ],
                  [
                    54004.8,
                    24612.1
                  ],
                  [
                    54049.3,
                    24250.6
                  ],
                  [
                    53956.9,
                    23983.6
                  ],
                  [
                    53601.3,
                    23891.4
                  ],
                  [
                    53532.8,
                    23974.5
                  ],
                  [
                    53536.3,
                    24580.2
                  ]
                ],
                "id": 1410,
                "chat_link": "[&BIIFAAA=]"
              },
              "1411": {
                "name": "Hailstone Floe",
                "level": 80,
                "coord": [
                  55401.4,
                  23885.2
                ],
                "bounds": [
                  [
                    55193.5,
                    23899.4
                  ],
                  [
                    55291.1,
                    23997.6
                  ],
                  [
                    55218.4,
                    24060.9
                  ],
                  [
                    55067.8,
                    24067.9
                  ],
                  [
                    54927.7,
                    24305.3
                  ],
                  [
                    54947.8,
                    24595.9
                  ],
                  [
                    55730.6,
                    24601.8
                  ],
                  [
                    55719.1,
                    24084.3
                  ],
                  [
                    56107.9,
                    23866.6
                  ],
                  [
                    55920.3,
                    23651.7
                  ],
                  [
                    55831.8,
                    23472.9
                  ],
                  [
                    55676,
                    23445.3
                  ],
                  [
                    55366.4,
                    23465.4
                  ],
                  [
                    55294.2,
                    23532
                  ],
                  [
                    55294.2,
                    23532
                  ],
                  [
                    55152.9,
                    23616.8
                  ],
                  [
                    55083.3,
                    23851.9
                  ],
                  [
                    55193.5,
                    23899.4
                  ]
                ],
                "id": 1411,
                "chat_link": "[&BIMFAAA=]"
              },
              "1413": {
                "name": "Brakbrak Ice Snarl",
                "level": 80,
                "coord": [
                  55208.3,
                  23351.8
                ],
                "bounds": [
                  [
                    55378.5,
                    23096
                  ],
                  [
                    54540.1,
                    23086.7
                  ],
                  [
                    54781,
                    23475.7
                  ],
                  [
                    55152.2,
                    23619.7
                  ],
                  [
                    55294.2,
                    23532
                  ],
                  [
                    55365.1,
                    23463.8
                  ],
                  [
                    55487.2,
                    23456.7
                  ],
                  [
                    55463,
                    23267.6
                  ],
                  [
                    55413.2,
                    23168.4
                  ],
                  [
                    55378.5,
                    23096
                  ]
                ],
                "id": 1413,
                "chat_link": "[&BIUFAAA=]"
              },
              "1414": {
                "name": "Blizzard Basin",
                "level": 80,
                "coord": [
                  54585.8,
                  24013.4
                ],
                "bounds": [
                  [
                    54785.1,
                    23473.9
                  ],
                  [
                    54426.6,
                    23834.7
                  ],
                  [
                    54206.4,
                    23929.4
                  ],
                  [
                    53958,
                    23983.6
                  ],
                  [
                    54049.3,
                    24250.6
                  ],
                  [
                    54115.5,
                    24218.5
                  ],
                  [
                    54253.7,
                    24270.4
                  ],
                  [
                    54259.9,
                    24220.8
                  ],
                  [
                    54340.7,
                    24148.6
                  ],
                  [
                    54399.4,
                    24125.8
                  ],
                  [
                    54664.9,
                    24128.8
                  ],
                  [
                    54927.7,
                    24305.3
                  ],
                  [
                    55067.8,
                    24067.9
                  ],
                  [
                    54943.2,
                    24005.1
                  ],
                  [
                    54922.5,
                    23933.4
                  ],
                  [
                    54988,
                    23876.5
                  ],
                  [
                    55083.3,
                    23851.9
                  ],
                  [
                    55152.9,
                    23616.8
                  ],
                  [
                    54785.1,
                    23473.9
                  ]
                ],
                "id": 1414,
                "chat_link": "[&BIYFAAA=]"
              },
              "1415": {
                "name": "Dragon's Teeth Hot Springs",
                "level": 80,
                "coord": [
                  56188,
                  24117.4
                ],
                "bounds": [
                  [
                    55721.1,
                    24086
                  ],
                  [
                    55731.4,
                    24603.3
                  ],
                  [
                    56511.9,
                    24580.2
                  ],
                  [
                    56518.1,
                    24013.6
                  ],
                  [
                    56403.7,
                    23867.1
                  ],
                  [
                    56321.5,
                    23804.8
                  ],
                  [
                    56107.9,
                    23866.6
                  ],
                  [
                    55721.1,
                    24086
                  ]
                ],
                "id": 1415,
                "chat_link": "[&BIcFAAA=]"
              },
              "1416": {
                "name": "The Bitter Cold",
                "level": 80,
                "coord": [
                  56298.1,
                  23414.9
                ],
                "bounds": [
                  [
                    56107.3,
                    23271.6
                  ],
                  [
                    55989.7,
                    23508.5
                  ],
                  [
                    55865.7,
                    23543.1
                  ],
                  [
                    55920.3,
                    23651.7
                  ],
                  [
                    56107.9,
                    23866.6
                  ],
                  [
                    56485.8,
                    23756.2
                  ],
                  [
                    56530.5,
                    23535.6
                  ],
                  [
                    56511.5,
                    23435
                  ],
                  [
                    56438.3,
                    23403.7
                  ],
                  [
                    56431.8,
                    23345.3
                  ],
                  [
                    56479.3,
                    23317.3
                  ],
                  [
                    56515.9,
                    23215.6
                  ],
                  [
                    56474.2,
                    23142.4
                  ],
                  [
                    56376.5,
                    23109.7
                  ],
                  [
                    56237.2,
                    23121.2
                  ],
                  [
                    56107.3,
                    23271.6
                  ]
                ],
                "id": 1416,
                "chat_link": "[&BIgFAAA=]"
              },
              "1417": {
                "name": "Black Ice Pass",
                "level": 80,
                "coord": [
                  54174.3,
                  24379
                ],
                "bounds": [
                  [
                    54049.3,
                    24250.6
                  ],
                  [
                    54004.4,
                    24610.4
                  ],
                  [
                    54260.9,
                    24601.1
                  ],
                  [
                    54279.8,
                    24429.1
                  ],
                  [
                    54255.1,
                    24271.7
                  ],
                  [
                    54255.1,
                    24271.7
                  ],
                  [
                    54115.6,
                    24218.7
                  ],
                  [
                    54049.3,
                    24250.6
                  ]
                ],
                "id": 1417,
                "chat_link": "[&BIkFAAA=]"
              },
              "1418": {
                "name": "Wayward Cave",
                "level": 80,
                "coord": [
                  54481.9,
                  24313.8
                ],
                "bounds": [
                  [
                    54255.1,
                    24271.7
                  ],
                  [
                    54279.6,
                    24429.1
                  ],
                  [
                    54259.8,
                    24600.7
                  ],
                  [
                    54948.3,
                    24595.2
                  ],
                  [
                    54927.7,
                    24305.3
                  ],
                  [
                    54665.8,
                    24128.2
                  ],
                  [
                    54399.8,
                    24125.7
                  ],
                  [
                    54340.7,
                    24148.4
                  ],
                  [
                    54260.2,
                    24220.3
                  ],
                  [
                    54255.1,
                    24271.7
                  ]
                ],
                "id": 1418,
                "chat_link": "[&BIoFAAA=]"
              },
              "1419": {
                "name": "Sorrow's Eclipse Sanctuary",
                "level": 80,
                "coord": [
                  55088.2,
                  23962.4
                ],
                "bounds": [
                  [
                    54988.8,
                    23876.8
                  ],
                  [
                    54920.3,
                    23937.1
                  ],
                  [
                    54943.5,
                    24006.4
                  ],
                  [
                    55067.8,
                    24067.9
                  ],
                  [
                    55216.9,
                    24062.4
                  ],
                  [
                    55291.1,
                    23997.6
                  ],
                  [
                    55193.5,
                    23899.4
                  ],
                  [
                    55083.3,
                    23851.9
                  ],
                  [
                    54988.8,
                    23876.8
                  ]
                ],
                "id": 1419,
                "chat_link": "[&BIsFAAA=]"
              }
            },
            "adventures": [],
            "id": 1178,
            "mastery_points": [
              {
                "coord": [
                  56433.8,
                  23233.6
                ],
                "id": 289,
                "region": "Maguuma"
              },
              {
                "coord": [
                  53704.1,
                  24196.3
                ],
                "id": 291,
                "region": "Maguuma"
              },
              {
                "coord": [
                  54183.5,
                  23755.9
                ],
                "id": 293,
                "region": "Maguuma"
              }
            ]
          },
          "1180": {
            "name": "The Bitter Cold",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              55040,
              25984
            ],
            "map_rect": [
              [
                -36864,
                -18432
              ],
              [
                36864,
                18432
              ]
            ],
            "continent_rect": [
              [
                53504,
                23040
              ],
              [
                56576,
                24576
              ]
            ],
            "points_of_interest": {
              "2428": {
                "name": "Blister Cauldron",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56373,
                  24427
                ],
                "id": 2428,
                "chat_link": "[&BHwJAAA=]"
              },
              "2430": {
                "name": "Whorl Lagoon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55928,
                  24298.5
                ],
                "id": 2430,
                "chat_link": "[&BH4JAAA=]"
              },
              "2431": {
                "name": "Chokocooka's Throne",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55050.3,
                  23486.9
                ],
                "id": 2431,
                "chat_link": "[&BH8JAAA=]"
              },
              "2432": {
                "name": "Lockflow Ice Fall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56231.3,
                  23349.4
                ],
                "id": 2432,
                "chat_link": "[&BIAJAAA=]"
              },
              "2434": {
                "name": "Gooloopa Deeps",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55053.1,
                  23979.9
                ],
                "id": 2434,
                "chat_link": "[&BIIJAAA=]"
              },
              "2435": {
                "name": "Joyless Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53981.1,
                  23370.2
                ],
                "id": 2435,
                "chat_link": "[&BIMJAAA=]"
              },
              "2436": {
                "name": "Black Cavern Junction",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54682.3,
                  24429.3
                ],
                "id": 2436,
                "chat_link": "[&BIQJAAA=]"
              },
              "2440": {
                "name": "Maw of Corruption",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53986.2,
                  23863.3
                ],
                "id": 2440,
                "chat_link": "[&BIgJAAA=]"
              },
              "2441": {
                "name": "Dragon's Eye View",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53652.9,
                  24241.9
                ],
                "id": 2441,
                "chat_link": "[&BIkJAAA=]"
              },
              "2442": {
                "name": "Hollow Bone Den",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55305.1,
                  23247.6
                ],
                "id": 2442,
                "chat_link": "[&BIoJAAA=]"
              },
              "2444": {
                "name": "Ice Vein Cavern",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54458.1,
                  24386.8
                ],
                "id": 2444,
                "chat_link": "[&BIwJAAA=]"
              },
              "2445": {
                "name": "Judgment Pass",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55267.9,
                  24527.9
                ],
                "id": 2445,
                "chat_link": "[&BI0JAAA=]"
              },
              "2447": {
                "name": "The Titan Tree",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54435.3,
                  23457.7
                ],
                "id": 2447,
                "chat_link": "[&BI8JAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1409": {
                "name": "Griffon Old Growth",
                "level": 80,
                "coord": [
                  54088.9,
                  23455
                ],
                "bounds": [
                  [
                    54539.3,
                    23082.5
                  ],
                  [
                    54513,
                    23095.9
                  ],
                  [
                    54468.2,
                    23098.5
                  ],
                  [
                    54434.5,
                    23074.6
                  ],
                  [
                    53931,
                    23094.7
                  ],
                  [
                    53779.9,
                    23159.9
                  ],
                  [
                    53679.8,
                    23213.8
                  ],
                  [
                    53582.4,
                    23292.5
                  ],
                  [
                    53559.5,
                    23364.5
                  ],
                  [
                    53530.9,
                    23854.3
                  ],
                  [
                    53602.2,
                    23892.4
                  ],
                  [
                    53957.1,
                    23983.5
                  ],
                  [
                    54206.3,
                    23930.1
                  ],
                  [
                    54426.6,
                    23834.7
                  ],
                  [
                    54426.6,
                    23834.7
                  ],
                  [
                    54785.1,
                    23473.9
                  ],
                  [
                    54539.3,
                    23082.5
                  ]
                ],
                "id": 1409,
                "chat_link": "[&BIEFAAA=]"
              },
              "1410": {
                "name": "The Svanir Hive",
                "level": 80,
                "coord": [
                  53780.3,
                  24215.4
                ],
                "bounds": [
                  [
                    53536.3,
                    24580.2
                  ],
                  [
                    54004.8,
                    24612.1
                  ],
                  [
                    54049.3,
                    24250.6
                  ],
                  [
                    53956.9,
                    23983.6
                  ],
                  [
                    53601.3,
                    23891.4
                  ],
                  [
                    53532.8,
                    23974.5
                  ],
                  [
                    53536.3,
                    24580.2
                  ]
                ],
                "id": 1410,
                "chat_link": "[&BIIFAAA=]"
              },
              "1411": {
                "name": "Hailstone Floe",
                "level": 80,
                "coord": [
                  55401.4,
                  23885.2
                ],
                "bounds": [
                  [
                    55193.5,
                    23899.4
                  ],
                  [
                    55291.1,
                    23997.6
                  ],
                  [
                    55218.4,
                    24060.9
                  ],
                  [
                    55067.8,
                    24067.9
                  ],
                  [
                    54927.7,
                    24305.3
                  ],
                  [
                    54947.8,
                    24595.9
                  ],
                  [
                    55730.6,
                    24601.8
                  ],
                  [
                    55719.1,
                    24084.3
                  ],
                  [
                    56107.9,
                    23866.6
                  ],
                  [
                    55920.3,
                    23651.7
                  ],
                  [
                    55831.8,
                    23472.9
                  ],
                  [
                    55676,
                    23445.3
                  ],
                  [
                    55366.4,
                    23465.4
                  ],
                  [
                    55294.2,
                    23532
                  ],
                  [
                    55294.2,
                    23532
                  ],
                  [
                    55152.9,
                    23616.8
                  ],
                  [
                    55083.3,
                    23851.9
                  ],
                  [
                    55193.5,
                    23899.4
                  ]
                ],
                "id": 1411,
                "chat_link": "[&BIMFAAA=]"
              },
              "1413": {
                "name": "Brakbrak Ice Snarl",
                "level": 80,
                "coord": [
                  55208.3,
                  23351.8
                ],
                "bounds": [
                  [
                    55378.5,
                    23096
                  ],
                  [
                    54540.1,
                    23086.7
                  ],
                  [
                    54781,
                    23475.7
                  ],
                  [
                    55152.2,
                    23619.7
                  ],
                  [
                    55294.2,
                    23532
                  ],
                  [
                    55365.1,
                    23463.8
                  ],
                  [
                    55487.2,
                    23456.7
                  ],
                  [
                    55463,
                    23267.6
                  ],
                  [
                    55413.2,
                    23168.4
                  ],
                  [
                    55378.5,
                    23096
                  ]
                ],
                "id": 1413,
                "chat_link": "[&BIUFAAA=]"
              },
              "1414": {
                "name": "Blizzard Basin",
                "level": 80,
                "coord": [
                  54585.8,
                  24013.4
                ],
                "bounds": [
                  [
                    54785.1,
                    23473.9
                  ],
                  [
                    54426.6,
                    23834.7
                  ],
                  [
                    54206.4,
                    23929.4
                  ],
                  [
                    53958,
                    23983.6
                  ],
                  [
                    54049.3,
                    24250.6
                  ],
                  [
                    54115.5,
                    24218.5
                  ],
                  [
                    54253.7,
                    24270.4
                  ],
                  [
                    54259.9,
                    24220.8
                  ],
                  [
                    54340.7,
                    24148.6
                  ],
                  [
                    54399.4,
                    24125.8
                  ],
                  [
                    54664.9,
                    24128.8
                  ],
                  [
                    54927.7,
                    24305.3
                  ],
                  [
                    55067.8,
                    24067.9
                  ],
                  [
                    54943.2,
                    24005.1
                  ],
                  [
                    54922.5,
                    23933.4
                  ],
                  [
                    54988,
                    23876.5
                  ],
                  [
                    55083.3,
                    23851.9
                  ],
                  [
                    55152.9,
                    23616.8
                  ],
                  [
                    54785.1,
                    23473.9
                  ]
                ],
                "id": 1414,
                "chat_link": "[&BIYFAAA=]"
              },
              "1415": {
                "name": "Dragon's Teeth Hot Springs",
                "level": 80,
                "coord": [
                  56188,
                  24117.4
                ],
                "bounds": [
                  [
                    55721.1,
                    24086
                  ],
                  [
                    55731.4,
                    24603.3
                  ],
                  [
                    56511.9,
                    24580.2
                  ],
                  [
                    56518.1,
                    24013.6
                  ],
                  [
                    56403.7,
                    23867.1
                  ],
                  [
                    56321.5,
                    23804.8
                  ],
                  [
                    56107.9,
                    23866.6
                  ],
                  [
                    55721.1,
                    24086
                  ]
                ],
                "id": 1415,
                "chat_link": "[&BIcFAAA=]"
              },
              "1416": {
                "name": "The Bitter Cold",
                "level": 80,
                "coord": [
                  56298.1,
                  23414.9
                ],
                "bounds": [
                  [
                    56107.3,
                    23271.6
                  ],
                  [
                    55989.7,
                    23508.5
                  ],
                  [
                    55865.7,
                    23543.1
                  ],
                  [
                    55920.3,
                    23651.7
                  ],
                  [
                    56107.9,
                    23866.6
                  ],
                  [
                    56485.8,
                    23756.2
                  ],
                  [
                    56530.5,
                    23535.6
                  ],
                  [
                    56511.5,
                    23435
                  ],
                  [
                    56438.3,
                    23403.7
                  ],
                  [
                    56431.8,
                    23345.3
                  ],
                  [
                    56479.3,
                    23317.3
                  ],
                  [
                    56515.9,
                    23215.6
                  ],
                  [
                    56474.2,
                    23142.4
                  ],
                  [
                    56376.5,
                    23109.7
                  ],
                  [
                    56237.2,
                    23121.2
                  ],
                  [
                    56107.3,
                    23271.6
                  ]
                ],
                "id": 1416,
                "chat_link": "[&BIgFAAA=]"
              },
              "1417": {
                "name": "Black Ice Pass",
                "level": 80,
                "coord": [
                  54174.3,
                  24379
                ],
                "bounds": [
                  [
                    54049.3,
                    24250.6
                  ],
                  [
                    54004.4,
                    24610.4
                  ],
                  [
                    54260.9,
                    24601.1
                  ],
                  [
                    54279.8,
                    24429.1
                  ],
                  [
                    54255.1,
                    24271.7
                  ],
                  [
                    54255.1,
                    24271.7
                  ],
                  [
                    54115.6,
                    24218.7
                  ],
                  [
                    54049.3,
                    24250.6
                  ]
                ],
                "id": 1417,
                "chat_link": "[&BIkFAAA=]"
              },
              "1418": {
                "name": "Wayward Cave",
                "level": 80,
                "coord": [
                  54481.9,
                  24313.8
                ],
                "bounds": [
                  [
                    54255.1,
                    24271.7
                  ],
                  [
                    54279.6,
                    24429.1
                  ],
                  [
                    54259.8,
                    24600.7
                  ],
                  [
                    54948.3,
                    24595.2
                  ],
                  [
                    54927.7,
                    24305.3
                  ],
                  [
                    54665.8,
                    24128.2
                  ],
                  [
                    54399.8,
                    24125.7
                  ],
                  [
                    54340.7,
                    24148.4
                  ],
                  [
                    54260.2,
                    24220.3
                  ],
                  [
                    54255.1,
                    24271.7
                  ]
                ],
                "id": 1418,
                "chat_link": "[&BIoFAAA=]"
              },
              "1419": {
                "name": "Sorrow's Eclipse Sanctuary",
                "level": 80,
                "coord": [
                  55088.2,
                  23962.4
                ],
                "bounds": [
                  [
                    54988.8,
                    23876.8
                  ],
                  [
                    54920.3,
                    23937.1
                  ],
                  [
                    54943.5,
                    24006.4
                  ],
                  [
                    55067.8,
                    24067.9
                  ],
                  [
                    55216.9,
                    24062.4
                  ],
                  [
                    55291.1,
                    23997.6
                  ],
                  [
                    55193.5,
                    23899.4
                  ],
                  [
                    55083.3,
                    23851.9
                  ],
                  [
                    54988.8,
                    23876.8
                  ]
                ],
                "id": 1419,
                "chat_link": "[&BIsFAAA=]"
              }
            },
            "adventures": [],
            "id": 1180,
            "mastery_points": []
          },
          "1181": {
            "name": "Frozen Out",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              55040,
              25984
            ],
            "map_rect": [
              [
                -36864,
                -18432
              ],
              [
                36864,
                18432
              ]
            ],
            "continent_rect": [
              [
                53504,
                23040
              ],
              [
                56576,
                24576
              ]
            ],
            "points_of_interest": {
              "2428": {
                "name": "Blister Cauldron",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56373,
                  24427
                ],
                "id": 2428,
                "chat_link": "[&BHwJAAA=]"
              },
              "2430": {
                "name": "Whorl Lagoon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55928,
                  24298.5
                ],
                "id": 2430,
                "chat_link": "[&BH4JAAA=]"
              },
              "2431": {
                "name": "Chokocooka's Throne",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55050.3,
                  23486.9
                ],
                "id": 2431,
                "chat_link": "[&BH8JAAA=]"
              },
              "2432": {
                "name": "Lockflow Ice Fall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56231.3,
                  23349.4
                ],
                "id": 2432,
                "chat_link": "[&BIAJAAA=]"
              },
              "2434": {
                "name": "Gooloopa Deeps",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55053.1,
                  23979.9
                ],
                "id": 2434,
                "chat_link": "[&BIIJAAA=]"
              },
              "2435": {
                "name": "Joyless Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53981.1,
                  23370.2
                ],
                "id": 2435,
                "chat_link": "[&BIMJAAA=]"
              },
              "2436": {
                "name": "Black Cavern Junction",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54682.3,
                  24429.3
                ],
                "id": 2436,
                "chat_link": "[&BIQJAAA=]"
              },
              "2440": {
                "name": "Maw of Corruption",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53986.2,
                  23863.3
                ],
                "id": 2440,
                "chat_link": "[&BIgJAAA=]"
              },
              "2441": {
                "name": "Dragon's Eye View",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53652.9,
                  24241.9
                ],
                "id": 2441,
                "chat_link": "[&BIkJAAA=]"
              },
              "2442": {
                "name": "Hollow Bone Den",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55305.1,
                  23247.6
                ],
                "id": 2442,
                "chat_link": "[&BIoJAAA=]"
              },
              "2444": {
                "name": "Ice Vein Cavern",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54458.1,
                  24386.8
                ],
                "id": 2444,
                "chat_link": "[&BIwJAAA=]"
              },
              "2445": {
                "name": "Judgment Pass",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55267.9,
                  24527.9
                ],
                "id": 2445,
                "chat_link": "[&BI0JAAA=]"
              },
              "2447": {
                "name": "The Titan Tree",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54435.3,
                  23457.7
                ],
                "id": 2447,
                "chat_link": "[&BI8JAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1409": {
                "name": "Griffon Old Growth",
                "level": 80,
                "coord": [
                  54088.9,
                  23455
                ],
                "bounds": [
                  [
                    54539.3,
                    23082.5
                  ],
                  [
                    54513,
                    23095.9
                  ],
                  [
                    54468.2,
                    23098.5
                  ],
                  [
                    54434.5,
                    23074.6
                  ],
                  [
                    53931,
                    23094.7
                  ],
                  [
                    53779.9,
                    23159.9
                  ],
                  [
                    53679.8,
                    23213.8
                  ],
                  [
                    53582.4,
                    23292.5
                  ],
                  [
                    53559.5,
                    23364.5
                  ],
                  [
                    53530.9,
                    23854.3
                  ],
                  [
                    53602.2,
                    23892.4
                  ],
                  [
                    53957.1,
                    23983.5
                  ],
                  [
                    54206.3,
                    23930.1
                  ],
                  [
                    54426.6,
                    23834.7
                  ],
                  [
                    54426.6,
                    23834.7
                  ],
                  [
                    54785.1,
                    23473.9
                  ],
                  [
                    54539.3,
                    23082.5
                  ]
                ],
                "id": 1409,
                "chat_link": "[&BIEFAAA=]"
              },
              "1410": {
                "name": "The Svanir Hive",
                "level": 80,
                "coord": [
                  53780.3,
                  24215.4
                ],
                "bounds": [
                  [
                    53536.3,
                    24580.2
                  ],
                  [
                    54004.8,
                    24612.1
                  ],
                  [
                    54049.3,
                    24250.6
                  ],
                  [
                    53956.9,
                    23983.6
                  ],
                  [
                    53601.3,
                    23891.4
                  ],
                  [
                    53532.8,
                    23974.5
                  ],
                  [
                    53536.3,
                    24580.2
                  ]
                ],
                "id": 1410,
                "chat_link": "[&BIIFAAA=]"
              },
              "1411": {
                "name": "Hailstone Floe",
                "level": 80,
                "coord": [
                  55401.4,
                  23885.2
                ],
                "bounds": [
                  [
                    55193.5,
                    23899.4
                  ],
                  [
                    55291.1,
                    23997.6
                  ],
                  [
                    55218.4,
                    24060.9
                  ],
                  [
                    55067.8,
                    24067.9
                  ],
                  [
                    54927.7,
                    24305.3
                  ],
                  [
                    54947.8,
                    24595.9
                  ],
                  [
                    55730.6,
                    24601.8
                  ],
                  [
                    55719.1,
                    24084.3
                  ],
                  [
                    56107.9,
                    23866.6
                  ],
                  [
                    55920.3,
                    23651.7
                  ],
                  [
                    55831.8,
                    23472.9
                  ],
                  [
                    55676,
                    23445.3
                  ],
                  [
                    55366.4,
                    23465.4
                  ],
                  [
                    55294.2,
                    23532
                  ],
                  [
                    55294.2,
                    23532
                  ],
                  [
                    55152.9,
                    23616.8
                  ],
                  [
                    55083.3,
                    23851.9
                  ],
                  [
                    55193.5,
                    23899.4
                  ]
                ],
                "id": 1411,
                "chat_link": "[&BIMFAAA=]"
              },
              "1413": {
                "name": "Brakbrak Ice Snarl",
                "level": 80,
                "coord": [
                  55208.3,
                  23351.8
                ],
                "bounds": [
                  [
                    55378.5,
                    23096
                  ],
                  [
                    54540.1,
                    23086.7
                  ],
                  [
                    54781,
                    23475.7
                  ],
                  [
                    55152.2,
                    23619.7
                  ],
                  [
                    55294.2,
                    23532
                  ],
                  [
                    55365.1,
                    23463.8
                  ],
                  [
                    55487.2,
                    23456.7
                  ],
                  [
                    55463,
                    23267.6
                  ],
                  [
                    55413.2,
                    23168.4
                  ],
                  [
                    55378.5,
                    23096
                  ]
                ],
                "id": 1413,
                "chat_link": "[&BIUFAAA=]"
              },
              "1414": {
                "name": "Blizzard Basin",
                "level": 80,
                "coord": [
                  54585.8,
                  24013.4
                ],
                "bounds": [
                  [
                    54785.1,
                    23473.9
                  ],
                  [
                    54426.6,
                    23834.7
                  ],
                  [
                    54206.4,
                    23929.4
                  ],
                  [
                    53958,
                    23983.6
                  ],
                  [
                    54049.3,
                    24250.6
                  ],
                  [
                    54115.5,
                    24218.5
                  ],
                  [
                    54253.7,
                    24270.4
                  ],
                  [
                    54259.9,
                    24220.8
                  ],
                  [
                    54340.7,
                    24148.6
                  ],
                  [
                    54399.4,
                    24125.8
                  ],
                  [
                    54664.9,
                    24128.8
                  ],
                  [
                    54927.7,
                    24305.3
                  ],
                  [
                    55067.8,
                    24067.9
                  ],
                  [
                    54943.2,
                    24005.1
                  ],
                  [
                    54922.5,
                    23933.4
                  ],
                  [
                    54988,
                    23876.5
                  ],
                  [
                    55083.3,
                    23851.9
                  ],
                  [
                    55152.9,
                    23616.8
                  ],
                  [
                    54785.1,
                    23473.9
                  ]
                ],
                "id": 1414,
                "chat_link": "[&BIYFAAA=]"
              },
              "1415": {
                "name": "Dragon's Teeth Hot Springs",
                "level": 80,
                "coord": [
                  56188,
                  24117.4
                ],
                "bounds": [
                  [
                    55721.1,
                    24086
                  ],
                  [
                    55731.4,
                    24603.3
                  ],
                  [
                    56511.9,
                    24580.2
                  ],
                  [
                    56518.1,
                    24013.6
                  ],
                  [
                    56403.7,
                    23867.1
                  ],
                  [
                    56321.5,
                    23804.8
                  ],
                  [
                    56107.9,
                    23866.6
                  ],
                  [
                    55721.1,
                    24086
                  ]
                ],
                "id": 1415,
                "chat_link": "[&BIcFAAA=]"
              },
              "1416": {
                "name": "The Bitter Cold",
                "level": 80,
                "coord": [
                  56298.1,
                  23414.9
                ],
                "bounds": [
                  [
                    56107.3,
                    23271.6
                  ],
                  [
                    55989.7,
                    23508.5
                  ],
                  [
                    55865.7,
                    23543.1
                  ],
                  [
                    55920.3,
                    23651.7
                  ],
                  [
                    56107.9,
                    23866.6
                  ],
                  [
                    56485.8,
                    23756.2
                  ],
                  [
                    56530.5,
                    23535.6
                  ],
                  [
                    56511.5,
                    23435
                  ],
                  [
                    56438.3,
                    23403.7
                  ],
                  [
                    56431.8,
                    23345.3
                  ],
                  [
                    56479.3,
                    23317.3
                  ],
                  [
                    56515.9,
                    23215.6
                  ],
                  [
                    56474.2,
                    23142.4
                  ],
                  [
                    56376.5,
                    23109.7
                  ],
                  [
                    56237.2,
                    23121.2
                  ],
                  [
                    56107.3,
                    23271.6
                  ]
                ],
                "id": 1416,
                "chat_link": "[&BIgFAAA=]"
              },
              "1417": {
                "name": "Black Ice Pass",
                "level": 80,
                "coord": [
                  54174.3,
                  24379
                ],
                "bounds": [
                  [
                    54049.3,
                    24250.6
                  ],
                  [
                    54004.4,
                    24610.4
                  ],
                  [
                    54260.9,
                    24601.1
                  ],
                  [
                    54279.8,
                    24429.1
                  ],
                  [
                    54255.1,
                    24271.7
                  ],
                  [
                    54255.1,
                    24271.7
                  ],
                  [
                    54115.6,
                    24218.7
                  ],
                  [
                    54049.3,
                    24250.6
                  ]
                ],
                "id": 1417,
                "chat_link": "[&BIkFAAA=]"
              },
              "1418": {
                "name": "Wayward Cave",
                "level": 80,
                "coord": [
                  54481.9,
                  24313.8
                ],
                "bounds": [
                  [
                    54255.1,
                    24271.7
                  ],
                  [
                    54279.6,
                    24429.1
                  ],
                  [
                    54259.8,
                    24600.7
                  ],
                  [
                    54948.3,
                    24595.2
                  ],
                  [
                    54927.7,
                    24305.3
                  ],
                  [
                    54665.8,
                    24128.2
                  ],
                  [
                    54399.8,
                    24125.7
                  ],
                  [
                    54340.7,
                    24148.4
                  ],
                  [
                    54260.2,
                    24220.3
                  ],
                  [
                    54255.1,
                    24271.7
                  ]
                ],
                "id": 1418,
                "chat_link": "[&BIoFAAA=]"
              },
              "1419": {
                "name": "Sorrow's Eclipse Sanctuary",
                "level": 80,
                "coord": [
                  55088.2,
                  23962.4
                ],
                "bounds": [
                  [
                    54988.8,
                    23876.8
                  ],
                  [
                    54920.3,
                    23937.1
                  ],
                  [
                    54943.5,
                    24006.4
                  ],
                  [
                    55067.8,
                    24067.9
                  ],
                  [
                    55216.9,
                    24062.4
                  ],
                  [
                    55291.1,
                    23997.6
                  ],
                  [
                    55193.5,
                    23899.4
                  ],
                  [
                    55083.3,
                    23851.9
                  ],
                  [
                    54988.8,
                    23876.8
                  ]
                ],
                "id": 1419,
                "chat_link": "[&BIsFAAA=]"
              }
            },
            "adventures": [],
            "id": 1181,
            "mastery_points": []
          },
          "1278": {
            "name": "???",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              54068,
              57384
            ],
            "map_rect": [
              [
                -36864,
                -36864
              ],
              [
                36864,
                36864
              ]
            ],
            "continent_rect": [
              [
                53504,
                24576
              ],
              [
                56576,
                27648
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1278,
            "mastery_points": []
          },
          "1310": {
            "name": "Thunderhead Peaks",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              57820,
              36936
            ],
            "map_rect": [
              [
                -39936,
                -43008
              ],
              [
                39936,
                46080
              ]
            ],
            "continent_rect": [
              [
                55820,
                34936
              ],
              [
                59148,
                38648
              ]
            ],
            "points_of_interest": {
              "2974": {
                "name": "Silent Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58105.2,
                  38257.3
                ],
                "id": 2974,
                "chat_link": "[&BJ4LAAA=]"
              },
              "2975": {
                "name": "Refiner's Joy",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56773.2,
                  37569
                ],
                "id": 2975,
                "chat_link": "[&BJ8LAAA=]"
              },
              "2976": {
                "name": "Brechnar's Gauntlet",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58893.1,
                  36156.9
                ],
                "id": 2976,
                "chat_link": "[&BKALAAA=]"
              },
              "2977": {
                "name": "Deldrimor Garrison",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57850.4,
                  36069.4
                ],
                "id": 2977,
                "chat_link": "[&BKELAAA=]"
              },
              "2978": {
                "name": "The Consul's Tomb",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59036.5,
                  36146.8
                ],
                "id": 2978,
                "chat_link": "[&BKILAAA=]"
              },
              "2979": {
                "name": "Forgotten Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57850.1,
                  36813.1
                ],
                "id": 2979,
                "chat_link": "[&BKMLAAA=]"
              },
              "2980": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57903.2,
                  37291.6
                ],
                "id": 2980,
                "chat_link": "[&BKQLAAA=]"
              },
              "2981": {
                "name": "Ironbridge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57854.3,
                  36603
                ],
                "id": 2981,
                "chat_link": "[&BKULAAA=]"
              },
              "2982": {
                "name": "Revolution's Heart Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  56733,
                  37407.9
                ],
                "id": 2982,
                "chat_link": "[&BKYLAAA=]"
              },
              "2983": {
                "name": "Maiden's Veil",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56705.8,
                  37199.8
                ],
                "id": 2983,
                "chat_link": "[&BKcLAAA=]"
              },
              "2984": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57588.4,
                  35308.9
                ],
                "id": 2984,
                "chat_link": "[&BKgLAAA=]"
              },
              "2985": {
                "name": "The Weeping Sisters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56620.7,
                  36614.3
                ],
                "id": 2985,
                "chat_link": "[&BKkLAAA=]"
              },
              "2986": {
                "name": "Ironhammer Crossing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58403.8,
                  35661.6
                ],
                "id": 2986,
                "chat_link": "[&BKoLAAA=]"
              },
              "2987": {
                "name": "The Scorchrazor III",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58485.3,
                  37149.3
                ],
                "id": 2987,
                "chat_link": "[&BKsLAAA=]"
              },
              "2988": {
                "name": "Corsair's Stand",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58078.7,
                  37315.6
                ],
                "id": 2988,
                "chat_link": "[&BKwLAAA=]"
              },
              "2989": {
                "name": "Melody's Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57764.1,
                  37217.7
                ],
                "id": 2989,
                "chat_link": "[&BK0LAAA=]"
              },
              "2990": {
                "name": "Stonebridge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58197.6,
                  36596.4
                ],
                "id": 2990,
                "chat_link": "[&BK4LAAA=]"
              },
              "2992": {
                "name": "Grand Lyceum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57905,
                  35092.2
                ],
                "id": 2992,
                "chat_link": "[&BLALAAA=]"
              },
              "2993": {
                "name": "Deldrimor Cellars",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57451.4,
                  35114.7
                ],
                "id": 2993,
                "chat_link": "[&BLELAAA=]"
              },
              "2994": {
                "name": "Sorrow's Cave",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57284.6,
                  36667.6
                ],
                "id": 2994,
                "chat_link": "[&BLILAAA=]"
              },
              "2995": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  56603.4,
                  38185.9
                ],
                "id": 2995,
                "chat_link": "[&BLMLAAA=]"
              },
              "2996": {
                "name": "Labyrinthine Mountains",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56027.6,
                  38492.4
                ],
                "id": 2996,
                "chat_link": "[&BLQLAAA=]"
              },
              "2997": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  56883.3,
                  37059.8
                ],
                "id": 2997,
                "chat_link": "[&BLULAAA=]"
              },
              "2998": {
                "name": "Path of the Exalted",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57719.7,
                  35339.5
                ],
                "id": 2998,
                "chat_link": "[&BLYLAAA=]"
              },
              "2999": {
                "name": "Dragon's Claw",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57322.4,
                  37250.6
                ],
                "id": 2999,
                "chat_link": "[&BLcLAAA=]"
              },
              "3000": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  56619.6,
                  35003.9
                ],
                "id": 3000,
                "chat_link": "[&BLgLAAA=]"
              },
              "3001": {
                "name": "Observation Deck Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  56677.9,
                  35196.4
                ],
                "id": 3001,
                "chat_link": "[&BLkLAAA=]"
              },
              "3002": {
                "name": "Moorage Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58149.9,
                  36959.7
                ],
                "id": 3002,
                "chat_link": "[&BLoLAAA=]"
              },
              "3003": {
                "name": "History's End Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58328.5,
                  35778.5
                ],
                "id": 3003,
                "chat_link": "[&BLsLAAA=]"
              },
              "3004": {
                "name": "Slag Pit",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58289.2,
                  36339.2
                ],
                "id": 3004,
                "chat_link": "[&BLwLAAA=]"
              },
              "3005": {
                "name": "The Hammer's Hoard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58969.5,
                  36009.6
                ],
                "id": 3005,
                "chat_link": "[&BL0LAAA=]"
              },
              "3006": {
                "name": "Heart of the Forge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56586.1,
                  35146.4
                ],
                "id": 3006,
                "chat_link": "[&BL4LAAA=]"
              },
              "3007": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58720.9,
                  35183.5
                ],
                "id": 3007,
                "chat_link": "[&BL8LAAA=]"
              },
              "3008": {
                "name": "Stonefall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58609.6,
                  35428.5
                ],
                "id": 3008,
                "chat_link": "[&BMALAAA=]"
              },
              "3009": {
                "name": "Freedom's Catchment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57038.5,
                  38322.2
                ],
                "id": 3009,
                "chat_link": "[&BMELAAA=]"
              },
              "3010": {
                "name": "Shattered Bay",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56116,
                  38192.5
                ],
                "id": 3010,
                "chat_link": "[&BMILAAA=]"
              },
              "3011": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57928.3,
                  36491.4
                ],
                "id": 3011,
                "chat_link": "[&BMMLAAA=]"
              },
              "3012": {
                "name": "Barracks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57077.2,
                  35127.6
                ],
                "id": 3012,
                "chat_link": "[&BMQLAAA=]"
              }
            },
            "tasks": {
              "437": {
                "objective": "Rally the Pact soldiers, corsairs, and Zephyrites.",
                "level": 80,
                "coord": [
                  58180.9,
                  37079.1
                ],
                "bounds": [
                  [
                    57970.6,
                    36945.3
                  ],
                  [
                    58056.5,
                    36928.7
                  ],
                  [
                    58144.2,
                    36895
                  ],
                  [
                    58310.6,
                    36867.1
                  ],
                  [
                    58441,
                    36930.8
                  ],
                  [
                    58552.8,
                    37010.2
                  ],
                  [
                    58671.2,
                    37152.7
                  ],
                  [
                    58665.6,
                    37313.9
                  ],
                  [
                    58602.5,
                    37468.8
                  ],
                  [
                    58462.5,
                    37662.8
                  ],
                  [
                    58300.4,
                    37693.1
                  ],
                  [
                    58273.6,
                    37676.9
                  ],
                  [
                    58110.4,
                    37768.7
                  ],
                  [
                    57949.4,
                    37891.5
                  ],
                  [
                    57795.8,
                    38037
                  ],
                  [
                    57461.6,
                    38016.5
                  ],
                  [
                    57296.2,
                    37892.2
                  ],
                  [
                    57369.8,
                    37611.6
                  ],
                  [
                    57435.9,
                    37529
                  ],
                  [
                    57534.7,
                    37502.1
                  ],
                  [
                    57650.4,
                    37486.7
                  ],
                  [
                    57723.9,
                    37477.6
                  ],
                  [
                    57743.5,
                    37388.2
                  ],
                  [
                    57732.5,
                    37324.2
                  ],
                  [
                    57710.5,
                    37250.5
                  ],
                  [
                    57698.4,
                    37206.8
                  ],
                  [
                    57734.9,
                    37135.6
                  ],
                  [
                    57775.7,
                    37074.2
                  ],
                  [
                    57863.6,
                    37067
                  ],
                  [
                    57919.8,
                    36998.1
                  ],
                  [
                    57970.6,
                    36945.3
                  ]
                ],
                "id": 437,
                "chat_link": "[&BLUBAAA=]"
              },
              "438": {
                "objective": "Help the Priory with their excavations.",
                "level": 80,
                "coord": [
                  58198.9,
                  35900
                ],
                "bounds": [
                  [
                    57591.4,
                    36475.6
                  ],
                  [
                    57783.2,
                    36548.9
                  ],
                  [
                    57850,
                    36567.4
                  ],
                  [
                    57932.8,
                    36556.4
                  ],
                  [
                    58072.1,
                    36519.7
                  ],
                  [
                    58155.5,
                    36553.3
                  ],
                  [
                    58199.8,
                    36542.3
                  ],
                  [
                    58303.5,
                    36520.5
                  ],
                  [
                    58389.7,
                    36462.1
                  ],
                  [
                    58687.2,
                    36098.9
                  ],
                  [
                    58484.1,
                    35870.4
                  ],
                  [
                    58251.8,
                    35680.6
                  ],
                  [
                    57943.6,
                    35766
                  ],
                  [
                    57802,
                    35608.3
                  ],
                  [
                    57611.8,
                    35910.6
                  ],
                  [
                    57590.5,
                    36123.1
                  ],
                  [
                    57600.7,
                    36263.9
                  ],
                  [
                    57591.7,
                    36379.2
                  ],
                  [
                    57591.4,
                    36475.6
                  ]
                ],
                "id": 438,
                "chat_link": "[&BLYBAAA=]"
              },
              "439": {
                "objective": "Ready your forces for the assault on Kralkatorrik.",
                "level": 80,
                "coord": [
                  57132.8,
                  35101.2
                ],
                "bounds": [
                  [
                    56887.9,
                    35635.6
                  ],
                  [
                    56761.9,
                    34948
                  ],
                  [
                    57281.2,
                    34951.5
                  ],
                  [
                    57449.2,
                    35793.2
                  ],
                  [
                    56825.8,
                    35684.9
                  ],
                  [
                    56887.9,
                    35635.6
                  ]
                ],
                "id": 439,
                "chat_link": "[&BLcBAAA=]"
              },
              "440": {
                "objective": "Help the cold and hungry dredge.",
                "level": 80,
                "coord": [
                  56719.9,
                  37616.2
                ],
                "bounds": [
                  [
                    56481.7,
                    37825.9
                  ],
                  [
                    56874,
                    37941.5
                  ],
                  [
                    57039.9,
                    37825.9
                  ],
                  [
                    57078,
                    37659.3
                  ],
                  [
                    56887.7,
                    37370.3
                  ],
                  [
                    56788.5,
                    37246.8
                  ],
                  [
                    56632.9,
                    37276.1
                  ],
                  [
                    56468.4,
                    37467
                  ],
                  [
                    56481.7,
                    37825.9
                  ]
                ],
                "id": 440,
                "chat_link": "[&BLgBAAA=]"
              }
            },
            "skill_challenges": [],
            "sectors": {
              "1696": {
                "name": "The Howling Cliffs",
                "level": 80,
                "coord": [
                  56238.6,
                  37188.9
                ],
                "bounds": [
                  [
                    56574.1,
                    37268.9
                  ],
                  [
                    56460,
                    37438.1
                  ],
                  [
                    56448,
                    37728.2
                  ],
                  [
                    55856,
                    38072.7
                  ],
                  [
                    55836.3,
                    37825.2
                  ],
                  [
                    55886,
                    37549.3
                  ],
                  [
                    55981.9,
                    37422.8
                  ],
                  [
                    55968.8,
                    37324.1
                  ],
                  [
                    55904.5,
                    37232.7
                  ],
                  [
                    55911.5,
                    37141.8
                  ],
                  [
                    55964.1,
                    36963.7
                  ],
                  [
                    56060.8,
                    36736.2
                  ],
                  [
                    56147.4,
                    36630.3
                  ],
                  [
                    56313.4,
                    36634.8
                  ],
                  [
                    56529.6,
                    36620
                  ],
                  [
                    56592.8,
                    36753
                  ],
                  [
                    56704.7,
                    36934.5
                  ],
                  [
                    56736.3,
                    37133.8
                  ],
                  [
                    56656.8,
                    37178.8
                  ],
                  [
                    56574.1,
                    37268.9
                  ]
                ],
                "id": 1696,
                "chat_link": "[&BKAGAAA=]"
              },
              "1698": {
                "name": "Deldrimor Ruins",
                "level": 80,
                "coord": [
                  58090.1,
                  36093.6
                ],
                "bounds": [
                  [
                    58198.8,
                    35540.1
                  ],
                  [
                    58254.5,
                    35520
                  ],
                  [
                    58319.6,
                    35695.8
                  ],
                  [
                    58401.3,
                    35756.8
                  ],
                  [
                    58582.3,
                    35773.8
                  ],
                  [
                    58587.7,
                    35931.4
                  ],
                  [
                    58547.5,
                    36137.3
                  ],
                  [
                    58472.1,
                    36305.3
                  ],
                  [
                    58425.1,
                    36385.8
                  ],
                  [
                    58376.3,
                    36446.6
                  ],
                  [
                    58331,
                    36479
                  ],
                  [
                    58274.6,
                    36521.3
                  ],
                  [
                    58182.5,
                    36543.1
                  ],
                  [
                    58066,
                    36533.3
                  ],
                  [
                    57884.7,
                    36553.3
                  ],
                  [
                    57710,
                    36500.4
                  ],
                  [
                    57685,
                    36460.5
                  ],
                  [
                    57666.7,
                    36404.3
                  ],
                  [
                    57637,
                    36314.6
                  ],
                  [
                    57598.8,
                    36151.5
                  ],
                  [
                    57655.1,
                    36017.5
                  ],
                  [
                    57722.2,
                    35876.2
                  ],
                  [
                    57800.2,
                    35796
                  ],
                  [
                    57873.5,
                    35781.8
                  ],
                  [
                    57954.5,
                    35766.4
                  ],
                  [
                    58065.1,
                    35730.8
                  ],
                  [
                    58160.6,
                    35603.8
                  ],
                  [
                    58198.8,
                    35540.1
                  ]
                ],
                "id": 1698,
                "chat_link": "[&BKIGAAA=]"
              },
              "1699": {
                "name": "Ice Floe",
                "level": 80,
                "coord": [
                  57331.6,
                  38151.7
                ],
                "bounds": [
                  [
                    57774.2,
                    37706.3
                  ],
                  [
                    57903.1,
                    37791.5
                  ],
                  [
                    57971.2,
                    37800.4
                  ],
                  [
                    58097.2,
                    37771.8
                  ],
                  [
                    58265.4,
                    37692.6
                  ],
                  [
                    58835,
                    37688.2
                  ],
                  [
                    58648.5,
                    38178.8
                  ],
                  [
                    58564.1,
                    38300.8
                  ],
                  [
                    58500.1,
                    38383.8
                  ],
                  [
                    58323.6,
                    38422.8
                  ],
                  [
                    58134.8,
                    38450.5
                  ],
                  [
                    57738.2,
                    38533.1
                  ],
                  [
                    57384.7,
                    38594
                  ],
                  [
                    57300.8,
                    38599.1
                  ],
                  [
                    56870.3,
                    38617.6
                  ],
                  [
                    56501.5,
                    38615.7
                  ],
                  [
                    56268.3,
                    38625.5
                  ],
                  [
                    56085.3,
                    38621.1
                  ],
                  [
                    55875.9,
                    38552.3
                  ],
                  [
                    55861.3,
                    38485.5
                  ],
                  [
                    55839.9,
                    38384.7
                  ],
                  [
                    55856,
                    38072.7
                  ],
                  [
                    56448,
                    37728.2
                  ],
                  [
                    56598.8,
                    37872
                  ],
                  [
                    56983.3,
                    37934.4
                  ],
                  [
                    57147.3,
                    37873.5
                  ],
                  [
                    57293.4,
                    37858.3
                  ],
                  [
                    57478.8,
                    37830.5
                  ],
                  [
                    57658.1,
                    37810.7
                  ],
                  [
                    57741.5,
                    37754.4
                  ],
                  [
                    57774.2,
                    37706.3
                  ]
                ],
                "id": 1699,
                "chat_link": "[&BKMGAAA=]"
              },
              "1701": {
                "name": "The Weeping Crest",
                "level": 80,
                "coord": [
                  57322.4,
                  36176.6
                ],
                "bounds": [
                  [
                    57873.5,
                    35781.8
                  ],
                  [
                    57800.2,
                    35796
                  ],
                  [
                    57722.2,
                    35876.2
                  ],
                  [
                    57655.1,
                    36017.5
                  ],
                  [
                    57598.8,
                    36151.5
                  ],
                  [
                    57637,
                    36314.6
                  ],
                  [
                    57666.7,
                    36404.3
                  ],
                  [
                    57685,
                    36460.5
                  ],
                  [
                    57529.6,
                    36498.7
                  ],
                  [
                    57441.9,
                    36570
                  ],
                  [
                    57376.1,
                    36584.6
                  ],
                  [
                    57141,
                    36567.2
                  ],
                  [
                    56716.4,
                    36577.4
                  ],
                  [
                    56529.6,
                    36620
                  ],
                  [
                    56742.1,
                    36209.5
                  ],
                  [
                    56960.1,
                    36047.8
                  ],
                  [
                    57058.4,
                    35907.6
                  ],
                  [
                    57092.9,
                    35830
                  ],
                  [
                    57129.5,
                    35716.5
                  ],
                  [
                    57091.7,
                    35599.8
                  ],
                  [
                    57873.5,
                    35781.8
                  ]
                ],
                "id": 1701,
                "chat_link": "[&BKUGAAA=]"
              },
              "1702": {
                "name": "The Auditorium",
                "level": 80,
                "coord": [
                  56575.7,
                  35886.5
                ],
                "bounds": [
                  [
                    56742.1,
                    36209.5
                  ],
                  [
                    56960.1,
                    36047.8
                  ],
                  [
                    57058.4,
                    35907.6
                  ],
                  [
                    57092.9,
                    35830
                  ],
                  [
                    57129.5,
                    35716.5
                  ],
                  [
                    57091.7,
                    35599.8
                  ],
                  [
                    56980.9,
                    35467.9
                  ],
                  [
                    56775.4,
                    35358.7
                  ],
                  [
                    56775.4,
                    35310.9
                  ],
                  [
                    56206.2,
                    35306.6
                  ],
                  [
                    56027,
                    35508.8
                  ],
                  [
                    55959.6,
                    35579.3
                  ],
                  [
                    55953.8,
                    36023.6
                  ],
                  [
                    56043.1,
                    36318.5
                  ],
                  [
                    56147.4,
                    36630.3
                  ],
                  [
                    56313.4,
                    36634.8
                  ],
                  [
                    56529.6,
                    36620
                  ],
                  [
                    56742.1,
                    36209.5
                  ]
                ],
                "id": 1702,
                "chat_link": "[&BKYGAAA=]"
              },
              "1703": {
                "name": "Thunderhead Keep",
                "level": 80,
                "coord": [
                  58661.2,
                  35366.7
                ],
                "bounds": [
                  [
                    58520.6,
                    34964.6
                  ],
                  [
                    58618.7,
                    34971.7
                  ],
                  [
                    58698.9,
                    34973.7
                  ],
                  [
                    58823.3,
                    34959.5
                  ],
                  [
                    58945.4,
                    34983
                  ],
                  [
                    59022.8,
                    35012.2
                  ],
                  [
                    59090.4,
                    35057
                  ],
                  [
                    59121.9,
                    35146.4
                  ],
                  [
                    59129.8,
                    35263.8
                  ],
                  [
                    59139,
                    35615.8
                  ],
                  [
                    59091.7,
                    35672.5
                  ],
                  [
                    58965.8,
                    35753.5
                  ],
                  [
                    58890.5,
                    35781.6
                  ],
                  [
                    58819.7,
                    35831.7
                  ],
                  [
                    58742,
                    35840.6
                  ],
                  [
                    58688.8,
                    35810.5
                  ],
                  [
                    58639.5,
                    35789
                  ],
                  [
                    58582.3,
                    35773.8
                  ],
                  [
                    58401.3,
                    35756.8
                  ],
                  [
                    58319.6,
                    35695.8
                  ],
                  [
                    58254.5,
                    35520
                  ],
                  [
                    58343.2,
                    35460.3
                  ],
                  [
                    58367.2,
                    35407
                  ],
                  [
                    58373.6,
                    35315.2
                  ],
                  [
                    58348.4,
                    35249.5
                  ],
                  [
                    58245.2,
                    35147.4
                  ],
                  [
                    58158.2,
                    35064.2
                  ],
                  [
                    58364.2,
                    34914.1
                  ],
                  [
                    58467.4,
                    34902.9
                  ],
                  [
                    58520.6,
                    34964.6
                  ]
                ],
                "id": 1703,
                "chat_link": "[&BKcGAAA=]"
              },
              "1704": {
                "name": "Hundar Pike",
                "level": 80,
                "coord": [
                  57526.4,
                  36881.3
                ],
                "bounds": [
                  [
                    58274.6,
                    36521.3
                  ],
                  [
                    58342.5,
                    36632.3
                  ],
                  [
                    58328.5,
                    36703.5
                  ],
                  [
                    58375.1,
                    36842.7
                  ],
                  [
                    58146,
                    36893.7
                  ],
                  [
                    57989.9,
                    36934.2
                  ],
                  [
                    57868.3,
                    37056.5
                  ],
                  [
                    57762.7,
                    37071.8
                  ],
                  [
                    57712.5,
                    37132.5
                  ],
                  [
                    57657.3,
                    37182.3
                  ],
                  [
                    57589,
                    37275.3
                  ],
                  [
                    57501.4,
                    37301.5
                  ],
                  [
                    57459.5,
                    37328.7
                  ],
                  [
                    57385.4,
                    37341.9
                  ],
                  [
                    57264.1,
                    37355.8
                  ],
                  [
                    57062.1,
                    37306.3
                  ],
                  [
                    56963.8,
                    37254.5
                  ],
                  [
                    56866.3,
                    37238.7
                  ],
                  [
                    56736.3,
                    37133.8
                  ],
                  [
                    56704.7,
                    36934.5
                  ],
                  [
                    56592.8,
                    36753
                  ],
                  [
                    56529.6,
                    36620
                  ],
                  [
                    56716.4,
                    36577.4
                  ],
                  [
                    57141,
                    36567.2
                  ],
                  [
                    57376.1,
                    36584.6
                  ],
                  [
                    57441.9,
                    36570
                  ],
                  [
                    57529.6,
                    36498.7
                  ],
                  [
                    57685,
                    36460.5
                  ],
                  [
                    57710,
                    36500.4
                  ],
                  [
                    57884.7,
                    36553.3
                  ],
                  [
                    58066,
                    36533.3
                  ],
                  [
                    58182.5,
                    36543.1
                  ],
                  [
                    58274.6,
                    36521.3
                  ]
                ],
                "id": 1704,
                "chat_link": "[&BKgGAAA=]"
              },
              "1705": {
                "name": "Symphony's Haven",
                "level": 80,
                "coord": [
                  58177,
                  37333.3
                ],
                "bounds": [
                  [
                    57989.9,
                    36934.2
                  ],
                  [
                    58146,
                    36893.7
                  ],
                  [
                    58375.1,
                    36842.7
                  ],
                  [
                    58445.5,
                    36930.9
                  ],
                  [
                    58557.6,
                    37011.7
                  ],
                  [
                    58992.6,
                    37328.9
                  ],
                  [
                    58968.4,
                    37432.4
                  ],
                  [
                    58932.3,
                    37508.7
                  ],
                  [
                    58835,
                    37688.2
                  ],
                  [
                    58265.4,
                    37692.6
                  ],
                  [
                    58097.2,
                    37771.8
                  ],
                  [
                    57971.2,
                    37800.4
                  ],
                  [
                    57903.1,
                    37791.5
                  ],
                  [
                    57774.2,
                    37706.3
                  ],
                  [
                    57696.9,
                    37613.3
                  ],
                  [
                    57589,
                    37275.3
                  ],
                  [
                    57657.3,
                    37182.3
                  ],
                  [
                    57712.5,
                    37132.5
                  ],
                  [
                    57762.7,
                    37071.8
                  ],
                  [
                    57868.3,
                    37056.5
                  ],
                  [
                    57989.9,
                    36934.2
                  ]
                ],
                "id": 1705,
                "chat_link": "[&BKkGAAA=]"
              },
              "1706": {
                "name": "Dredgeways",
                "level": 80,
                "coord": [
                  57151.8,
                  37518.3
                ],
                "bounds": [
                  [
                    56866.3,
                    37238.7
                  ],
                  [
                    56963.8,
                    37254.5
                  ],
                  [
                    57062.1,
                    37306.3
                  ],
                  [
                    57264.1,
                    37355.8
                  ],
                  [
                    57385.4,
                    37341.9
                  ],
                  [
                    57459.5,
                    37328.7
                  ],
                  [
                    57501.4,
                    37301.5
                  ],
                  [
                    57589,
                    37275.3
                  ],
                  [
                    57696.9,
                    37613.3
                  ],
                  [
                    57774.2,
                    37706.3
                  ],
                  [
                    57741.5,
                    37754.4
                  ],
                  [
                    57658.1,
                    37810.7
                  ],
                  [
                    57478.8,
                    37830.5
                  ],
                  [
                    57293.4,
                    37858.3
                  ],
                  [
                    57147.3,
                    37873.5
                  ],
                  [
                    56983.3,
                    37934.4
                  ],
                  [
                    56598.8,
                    37872
                  ],
                  [
                    56448,
                    37728.2
                  ],
                  [
                    56460,
                    37438.1
                  ],
                  [
                    56574.1,
                    37268.9
                  ],
                  [
                    56656.8,
                    37178.8
                  ],
                  [
                    56736.3,
                    37133.8
                  ],
                  [
                    56866.3,
                    37238.7
                  ]
                ],
                "id": 1706,
                "chat_link": "[&BKoGAAA=]"
              },
              "1707": {
                "name": "The Grotto",
                "level": 80,
                "coord": [
                  57700,
                  35279.1
                ],
                "bounds": [
                  [
                    58254.5,
                    35520
                  ],
                  [
                    58198.8,
                    35540.1
                  ],
                  [
                    58160.6,
                    35603.8
                  ],
                  [
                    58065.1,
                    35730.8
                  ],
                  [
                    57954.5,
                    35766.4
                  ],
                  [
                    57873.5,
                    35781.8
                  ],
                  [
                    57091.7,
                    35599.8
                  ],
                  [
                    56980.9,
                    35467.9
                  ],
                  [
                    56775.4,
                    35358.7
                  ],
                  [
                    56775.4,
                    35310.9
                  ],
                  [
                    56768.3,
                    35209.1
                  ],
                  [
                    56767.8,
                    34943
                  ],
                  [
                    56882,
                    34948.6
                  ],
                  [
                    57216.3,
                    34953.6
                  ],
                  [
                    57433.8,
                    34995.1
                  ],
                  [
                    57562.1,
                    34993.3
                  ],
                  [
                    57682.1,
                    35018.1
                  ],
                  [
                    57741.5,
                    35077.4
                  ],
                  [
                    57854.9,
                    34993
                  ],
                  [
                    57965,
                    34995.2
                  ],
                  [
                    58059.3,
                    35086.2
                  ],
                  [
                    58158.2,
                    35064.2
                  ],
                  [
                    58245.2,
                    35147.4
                  ],
                  [
                    58348.4,
                    35249.5
                  ],
                  [
                    58373.6,
                    35315.2
                  ],
                  [
                    58367.2,
                    35407
                  ],
                  [
                    58343.2,
                    35460.3
                  ],
                  [
                    58254.5,
                    35520
                  ]
                ],
                "id": 1707,
                "chat_link": "[&BKsGAAA=]"
              },
              "1708": {
                "name": "Dwarven Catacombs",
                "level": 80,
                "coord": [
                  58848.7,
                  36320.3
                ],
                "bounds": [
                  [
                    59091.7,
                    35672.5
                  ],
                  [
                    59139,
                    35615.8
                  ],
                  [
                    59133,
                    35733
                  ],
                  [
                    59115.8,
                    35823
                  ],
                  [
                    59108,
                    35895.8
                  ],
                  [
                    59117,
                    35976
                  ],
                  [
                    59111.3,
                    36051.3
                  ],
                  [
                    59103,
                    36104.2
                  ],
                  [
                    59104,
                    36172.4
                  ],
                  [
                    59093.1,
                    36250.3
                  ],
                  [
                    59104.4,
                    36309.9
                  ],
                  [
                    59119,
                    36380.4
                  ],
                  [
                    59126.7,
                    36465.2
                  ],
                  [
                    59122.3,
                    36530.5
                  ],
                  [
                    59132.4,
                    36585.5
                  ],
                  [
                    59136.9,
                    36672
                  ],
                  [
                    59119.5,
                    36754.1
                  ],
                  [
                    59112.2,
                    36834.2
                  ],
                  [
                    59114.5,
                    36907.6
                  ],
                  [
                    59127.3,
                    37009.4
                  ],
                  [
                    59079.4,
                    37151.8
                  ],
                  [
                    58992.6,
                    37328.9
                  ],
                  [
                    58557.6,
                    37011.7
                  ],
                  [
                    58445.5,
                    36930.9
                  ],
                  [
                    58375.1,
                    36842.7
                  ],
                  [
                    58328.5,
                    36703.5
                  ],
                  [
                    58342.5,
                    36632.3
                  ],
                  [
                    58274.6,
                    36521.3
                  ],
                  [
                    58331,
                    36479
                  ],
                  [
                    58376.3,
                    36446.6
                  ],
                  [
                    58425.1,
                    36385.8
                  ],
                  [
                    58472.1,
                    36305.3
                  ],
                  [
                    58547.5,
                    36137.3
                  ],
                  [
                    58587.7,
                    35931.4
                  ],
                  [
                    58582.3,
                    35773.8
                  ],
                  [
                    58639.5,
                    35789
                  ],
                  [
                    58688.8,
                    35810.5
                  ],
                  [
                    58742,
                    35840.6
                  ],
                  [
                    58819.7,
                    35831.7
                  ],
                  [
                    58890.5,
                    35781.6
                  ],
                  [
                    58965.8,
                    35753.5
                  ],
                  [
                    59091.7,
                    35672.5
                  ]
                ],
                "id": 1708,
                "chat_link": "[&BKwGAAA=]"
              },
              "1711": {
                "name": "The Forge",
                "level": 80,
                "coord": [
                  56490.7,
                  35094.7
                ],
                "bounds": [
                  [
                    56775.4,
                    35310.9
                  ],
                  [
                    56768.3,
                    35209.1
                  ],
                  [
                    56767.8,
                    34943
                  ],
                  [
                    56708.4,
                    34963
                  ],
                  [
                    56667.6,
                    34972.5
                  ],
                  [
                    56583.8,
                    34962.7
                  ],
                  [
                    56524,
                    34976
                  ],
                  [
                    56482.5,
                    34989
                  ],
                  [
                    56445.6,
                    35020.6
                  ],
                  [
                    56420,
                    35058.5
                  ],
                  [
                    56349.3,
                    35112.4
                  ],
                  [
                    56261,
                    35141.8
                  ],
                  [
                    56201.2,
                    35190.1
                  ],
                  [
                    56199,
                    35264.1
                  ],
                  [
                    56206.2,
                    35306.6
                  ],
                  [
                    56775.4,
                    35310.9
                  ]
                ],
                "id": 1711,
                "chat_link": "[&BK8GAAA=]"
              }
            },
            "adventures": [],
            "id": 1310,
            "mastery_points": [
              {
                "coord": [
                  57214.4,
                  36425.4
                ],
                "id": 451,
                "region": "Desert"
              },
              {
                "coord": [
                  57163.3,
                  35042.3
                ],
                "id": 448,
                "region": "Desert"
              },
              {
                "coord": [
                  58400.8,
                  36627.9
                ],
                "id": 447,
                "region": "Desert"
              },
              {
                "coord": [
                  55989.4,
                  38044.3
                ],
                "id": 449,
                "region": "Desert"
              },
              {
                "coord": [
                  57190.2,
                  37671.8
                ],
                "id": 455,
                "region": "Desert"
              }
            ]
          },
          "1326": {
            "name": "Dragon Bash Arena",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "881": {
                "name": "Courage Brewery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53009.3,
                  30196.3
                ],
                "id": 881,
                "chat_link": "[&BHEDAAA=]"
              },
              "882": {
                "name": "Fang of the Serpent",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53427.9,
                  31108.1
                ],
                "id": 882,
                "chat_link": "[&BHIDAAA=]"
              },
              "883": {
                "name": "Brawler's Bout",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53790.2,
                  30450.2
                ],
                "id": 883,
                "chat_link": "[&BHMDAAA=]"
              },
              "884": {
                "name": "The Great Rise",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53592.5,
                  30802.5
                ],
                "id": 884,
                "chat_link": "[&BHQDAAA=]"
              },
              "885": {
                "name": "Skarti's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54432.4,
                  30363.5
                ],
                "id": 885,
                "chat_link": "[&BHUDAAA=]"
              },
              "886": {
                "name": "Stonewright's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54015.6,
                  31159.6
                ],
                "id": 886,
                "chat_link": "[&BHYDAAA=]"
              },
              "887": {
                "name": "Sigfast's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53930.2,
                  29788.7
                ],
                "id": 887,
                "chat_link": "[&BHcDAAA=]"
              },
              "888": {
                "name": "Master Blackforge's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54378.9,
                  29844.9
                ],
                "id": 888,
                "chat_link": "[&BHgDAAA=]"
              },
              "889": {
                "name": "Old Fiach's Lorestead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54293.4,
                  31219.7
                ],
                "id": 889,
                "chat_link": "[&BHkDAAA=]"
              },
              "890": {
                "name": "Boasting Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54425.9,
                  31010.8
                ],
                "id": 890,
                "chat_link": "[&BHoDAAA=]"
              },
              "891": {
                "name": "Hrothbeir's Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52903.8,
                  30404.8
                ],
                "id": 891,
                "chat_link": "[&BHsDAAA=]"
              },
              "892": {
                "name": "Vheratha's Tavern",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54217.6,
                  30534.3
                ],
                "id": 892,
                "chat_link": "[&BHwDAAA=]"
              },
              "893": {
                "name": "Priory Encampment",
                "type": "landmark",
                "floor": 2,
                "coord": [
                  53308.7,
                  30792.3
                ],
                "id": 893,
                "chat_link": "[&BH0DAAA=]"
              },
              "894": {
                "name": "Dragon Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53310.8,
                  29861.1
                ],
                "id": 894,
                "chat_link": "[&BH4DAAA=]"
              },
              "895": {
                "name": "Vigil Billet",
                "type": "landmark",
                "floor": 2,
                "coord": [
                  53731.9,
                  30961.6
                ],
                "id": 895,
                "chat_link": "[&BH8DAAA=]"
              },
              "896": {
                "name": "Lost Spirits' Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54352.3,
                  30685.1
                ],
                "id": 896,
                "chat_link": "[&BIADAAA=]"
              },
              "897": {
                "name": "Bear Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54244.3,
                  30241.8
                ],
                "id": 897,
                "chat_link": "[&BIEDAAA=]"
              },
              "898": {
                "name": "Wolf Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54109.6,
                  30793.7
                ],
                "id": 898,
                "chat_link": "[&BIIDAAA=]"
              },
              "899": {
                "name": "Raven Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53711.2,
                  30026.5
                ],
                "id": 899,
                "chat_link": "[&BIMDAAA=]"
              },
              "900": {
                "name": "Snow Leopard Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53270.9,
                  30335.7
                ],
                "id": 900,
                "chat_link": "[&BIQDAAA=]"
              },
              "1136": {
                "name": "Bilrost Gallery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53993.7,
                  30872.9
                ],
                "id": 1136,
                "chat_link": "[&BHAEAAA=]"
              },
              "1263": {
                "name": "Raven Hearth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53823.9,
                  30015.7
                ],
                "id": 1263,
                "chat_link": "[&BO8EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "792": {
                "name": "Hero's Compass",
                "level": 0,
                "coord": [
                  53118.5,
                  30439
                ],
                "bounds": [
                  [
                    53200.9,
                    30414.3
                  ],
                  [
                    53238.6,
                    30489.4
                  ],
                  [
                    53208,
                    30523.5
                  ],
                  [
                    53133,
                    30562.9
                  ],
                  [
                    52949.8,
                    30525.6
                  ],
                  [
                    53001.1,
                    30355
                  ],
                  [
                    53027.8,
                    30317.6
                  ],
                  [
                    53189,
                    30324
                  ],
                  [
                    53200.9,
                    30414.3
                  ]
                ],
                "id": 792,
                "chat_link": "[&BBgDAAA=]"
              },
              "793": {
                "name": "Bear Lodge",
                "level": 0,
                "coord": [
                  54195.2,
                  30266.4
                ],
                "bounds": [
                  [
                    54067.7,
                    30150.8
                  ],
                  [
                    54123.2,
                    30117.7
                  ],
                  [
                    54211.9,
                    30112.2
                  ],
                  [
                    54277.1,
                    30154.2
                  ],
                  [
                    54326.4,
                    30215
                  ],
                  [
                    54321.7,
                    30303.8
                  ],
                  [
                    54300.7,
                    30367.7
                  ],
                  [
                    54253.4,
                    30416.1
                  ],
                  [
                    54184.2,
                    30431
                  ],
                  [
                    54146.1,
                    30326
                  ],
                  [
                    54120.3,
                    30336.1
                  ],
                  [
                    54088.1,
                    30274.3
                  ],
                  [
                    54116.7,
                    30258.5
                  ],
                  [
                    54067.7,
                    30150.8
                  ]
                ],
                "id": 793,
                "chat_link": "[&BBkDAAA=]"
              },
              "794": {
                "name": "Biergarten",
                "level": 0,
                "coord": [
                  52885.1,
                  29973.1
                ],
                "bounds": [
                  [
                    52954.8,
                    30266.8
                  ],
                  [
                    52823.2,
                    30029.2
                  ],
                  [
                    52550.5,
                    29746.8
                  ],
                  [
                    52749.6,
                    29664.4
                  ],
                  [
                    52965,
                    29722.3
                  ],
                  [
                    53101.3,
                    30146.4
                  ],
                  [
                    53051.2,
                    30235.8
                  ],
                  [
                    52954.8,
                    30266.8
                  ]
                ],
                "id": 794,
                "chat_link": "[&BBoDAAA=]"
              },
              "795": {
                "name": "Eastern Watchpost",
                "level": 0,
                "coord": [
                  54220.2,
                  30823.3
                ],
                "bounds": [
                  [
                    54065.2,
                    31012.4
                  ],
                  [
                    54049.9,
                    30857.8
                  ],
                  [
                    54084.5,
                    30857.3
                  ],
                  [
                    54141,
                    30830.4
                  ],
                  [
                    54175.2,
                    30775
                  ],
                  [
                    54177.1,
                    30718.9
                  ],
                  [
                    54146.4,
                    30666.4
                  ],
                  [
                    54259.5,
                    30735.1
                  ],
                  [
                    54556.9,
                    30713.3
                  ],
                  [
                    54553.5,
                    30960.8
                  ],
                  [
                    54213.4,
                    30929.2
                  ],
                  [
                    54065.2,
                    31012.4
                  ]
                ],
                "id": 795,
                "chat_link": "[&BBsDAAA=]"
              },
              "796": {
                "name": "Trade Commons",
                "level": 0,
                "coord": [
                  53545,
                  30860
                ],
                "bounds": [
                  [
                    53777.4,
                    31044.9
                  ],
                  [
                    53744.2,
                    31105.4
                  ],
                  [
                    53549.6,
                    30993.1
                  ],
                  [
                    53574.2,
                    30944.8
                  ],
                  [
                    53482.7,
                    30899.5
                  ],
                  [
                    53457.6,
                    30943.2
                  ],
                  [
                    53315.2,
                    30873.4
                  ],
                  [
                    53284.4,
                    30889.4
                  ],
                  [
                    53177.6,
                    30933
                  ],
                  [
                    53399.4,
                    30596.8
                  ],
                  [
                    53542,
                    30599.2
                  ],
                  [
                    53673.8,
                    30648.3
                  ],
                  [
                    53784.7,
                    30727.3
                  ],
                  [
                    53867.6,
                    30841.1
                  ],
                  [
                    53777.4,
                    31044.9
                  ]
                ],
                "id": 796,
                "chat_link": "[&BBwDAAA=]"
              },
              "797": {
                "name": "Might and Main",
                "level": 0,
                "coord": [
                  53821.1,
                  30398.4
                ],
                "bounds": [
                  [
                    54184.5,
                    30431.1
                  ],
                  [
                    54144.6,
                    30443.3
                  ],
                  [
                    54087.9,
                    30559.6
                  ],
                  [
                    54131.3,
                    30597.5
                  ],
                  [
                    54118.8,
                    30657.7
                  ],
                  [
                    54062.4,
                    30699.1
                  ],
                  [
                    54048.6,
                    30691.1
                  ],
                  [
                    54011.9,
                    30722.8
                  ],
                  [
                    54019.3,
                    30734.2
                  ],
                  [
                    53976,
                    30783.2
                  ],
                  [
                    53964.2,
                    30822.1
                  ],
                  [
                    53866.7,
                    30845.7
                  ],
                  [
                    53780.8,
                    30722
                  ],
                  [
                    53675.4,
                    30645.9
                  ],
                  [
                    53542.9,
                    30597.3
                  ],
                  [
                    53466,
                    30601.3
                  ],
                  [
                    53491.2,
                    30526.9
                  ],
                  [
                    53389,
                    30508.3
                  ],
                  [
                    53410.7,
                    30402.4
                  ],
                  [
                    53442.6,
                    30404.5
                  ],
                  [
                    53455.2,
                    30336.2
                  ],
                  [
                    53419.3,
                    30328.2
                  ],
                  [
                    53440.7,
                    30219.1
                  ],
                  [
                    53456.4,
                    30174.3
                  ],
                  [
                    53598.6,
                    30065.5
                  ],
                  [
                    53610.4,
                    30111.6
                  ],
                  [
                    53629.4,
                    30140.5
                  ],
                  [
                    53738.1,
                    30136
                  ],
                  [
                    53741.5,
                    30163.8
                  ],
                  [
                    53806.2,
                    30155.6
                  ],
                  [
                    53802.3,
                    30121.3
                  ],
                  [
                    53921.6,
                    30116.4
                  ],
                  [
                    53938,
                    30081.4
                  ],
                  [
                    53940.4,
                    30044.5
                  ],
                  [
                    53999.2,
                    30027.4
                  ],
                  [
                    54058.5,
                    30125.7
                  ],
                  [
                    54116.7,
                    30258.5
                  ],
                  [
                    54088.1,
                    30273.8
                  ],
                  [
                    54120.6,
                    30336
                  ],
                  [
                    54145.9,
                    30326.2
                  ],
                  [
                    54184.5,
                    30431.1
                  ]
                ],
                "id": 797,
                "chat_link": "[&BB0DAAA=]"
              },
              "798": {
                "name": "The Great Lodge",
                "level": 0,
                "coord": [
                  53465.6,
                  31103.7
                ],
                "bounds": [
                  [
                    53691,
                    31069.9
                  ],
                  [
                    53750.3,
                    31112.7
                  ],
                  [
                    53698.6,
                    31247.4
                  ],
                  [
                    53703.5,
                    31364.2
                  ],
                  [
                    53437.6,
                    31414.9
                  ],
                  [
                    53121.8,
                    31375.4
                  ],
                  [
                    53084.2,
                    31183.7
                  ],
                  [
                    53179,
                    30929.1
                  ],
                  [
                    53317.2,
                    30872.5
                  ],
                  [
                    53460.8,
                    30942.7
                  ],
                  [
                    53483.3,
                    30897.3
                  ],
                  [
                    53576.1,
                    30944.3
                  ],
                  [
                    53549.3,
                    30994.4
                  ],
                  [
                    53691,
                    31069.9
                  ]
                ],
                "id": 798,
                "chat_link": "[&BB4DAAA=]"
              },
              "799": {
                "name": "Lake Mourn",
                "level": 0,
                "coord": [
                  52746.6,
                  30556.8
                ],
                "bounds": [
                  [
                    52825.3,
                    30025
                  ],
                  [
                    52957,
                    30262.5
                  ],
                  [
                    52986.9,
                    30257.1
                  ],
                  [
                    53026.8,
                    30324.9
                  ],
                  [
                    53003.8,
                    30353.8
                  ],
                  [
                    52951.8,
                    30526.7
                  ],
                  [
                    53134,
                    30558.6
                  ],
                  [
                    53168.1,
                    30540.1
                  ],
                  [
                    53180.2,
                    30817.5
                  ],
                  [
                    53183.7,
                    30931
                  ],
                  [
                    53088.9,
                    31179.1
                  ],
                  [
                    53122.6,
                    31361.8
                  ],
                  [
                    52895.6,
                    31373.6
                  ],
                  [
                    52599.8,
                    31381.4
                  ],
                  [
                    52370.6,
                    31304.6
                  ],
                  [
                    52205.1,
                    31122.9
                  ],
                  [
                    52143.3,
                    30810.2
                  ],
                  [
                    52149.5,
                    30123.1
                  ],
                  [
                    52199,
                    29885.4
                  ],
                  [
                    52262.2,
                    29700.7
                  ],
                  [
                    52417.5,
                    29665.4
                  ],
                  [
                    52552.8,
                    29745
                  ],
                  [
                    52825.3,
                    30025
                  ]
                ],
                "id": 799,
                "chat_link": "[&BB8DAAA=]"
              },
              "800": {
                "name": "Mourn's Tears",
                "level": 0,
                "coord": [
                  53121.2,
                  30237.6
                ],
                "bounds": [
                  [
                    53020.5,
                    30317.9
                  ],
                  [
                    52983.9,
                    30256
                  ],
                  [
                    53049.3,
                    30235.4
                  ],
                  [
                    53095.3,
                    30152.8
                  ],
                  [
                    53179.1,
                    30129.4
                  ],
                  [
                    53233.1,
                    30236.8
                  ],
                  [
                    53218.5,
                    30246.4
                  ],
                  [
                    53190.2,
                    30326.3
                  ],
                  [
                    53020.5,
                    30317.9
                  ]
                ],
                "id": 800,
                "chat_link": "[&BCADAAA=]"
              },
              "801": {
                "name": "Veins of the Dragon",
                "level": 0,
                "coord": [
                  53332.3,
                  30070.5
                ],
                "bounds": [
                  [
                    52958.9,
                    29726.7
                  ],
                  [
                    53438.5,
                    29695.9
                  ],
                  [
                    53592.5,
                    30001.4
                  ],
                  [
                    53599.1,
                    30066
                  ],
                  [
                    53456.5,
                    30173.8
                  ],
                  [
                    53439.1,
                    30218.4
                  ],
                  [
                    53364.8,
                    30184.7
                  ],
                  [
                    53292.7,
                    30195.4
                  ],
                  [
                    53233.2,
                    30236.7
                  ],
                  [
                    53179.4,
                    30129.1
                  ],
                  [
                    53100.6,
                    30147.1
                  ],
                  [
                    52958.9,
                    29726.7
                  ]
                ],
                "id": 801,
                "chat_link": "[&BCEDAAA=]"
              },
              "802": {
                "name": "Snow Leopard Lodge",
                "level": 0,
                "coord": [
                  53336.2,
                  30352.3
                ],
                "bounds": [
                  [
                    53390.2,
                    30508.7
                  ],
                  [
                    53308.7,
                    30516.7
                  ],
                  [
                    53239.7,
                    30490.3
                  ],
                  [
                    53202.7,
                    30414.9
                  ],
                  [
                    53186.8,
                    30330.5
                  ],
                  [
                    53215.3,
                    30248.3
                  ],
                  [
                    53292.8,
                    30195.4
                  ],
                  [
                    53364.9,
                    30185.2
                  ],
                  [
                    53440,
                    30219.1
                  ],
                  [
                    53419.5,
                    30328.2
                  ],
                  [
                    53456.7,
                    30335.7
                  ],
                  [
                    53442.2,
                    30404
                  ],
                  [
                    53410.6,
                    30402.5
                  ],
                  [
                    53390.2,
                    30508.7
                  ]
                ],
                "id": 802,
                "chat_link": "[&BCIDAAA=]"
              },
              "803": {
                "name": "Raven Lodge",
                "level": 0,
                "coord": [
                  53760.4,
                  30016.1
                ],
                "bounds": [
                  [
                    53629.3,
                    30140.8
                  ],
                  [
                    53610.8,
                    30110.9
                  ],
                  [
                    53598.9,
                    30066.2
                  ],
                  [
                    53592.4,
                    30001.3
                  ],
                  [
                    53437.7,
                    29695.9
                  ],
                  [
                    53862.7,
                    29696.9
                  ],
                  [
                    53875.9,
                    29808.2
                  ],
                  [
                    53912.2,
                    29903.6
                  ],
                  [
                    53940.8,
                    30044.9
                  ],
                  [
                    53937.9,
                    30080.9
                  ],
                  [
                    53922,
                    30115.5
                  ],
                  [
                    53802.1,
                    30121.5
                  ],
                  [
                    53805.2,
                    30155.1
                  ],
                  [
                    53741.5,
                    30163.4
                  ],
                  [
                    53737,
                    30135.7
                  ],
                  [
                    53629.3,
                    30140.8
                  ]
                ],
                "id": 803,
                "chat_link": "[&BCMDAAA=]"
              },
              "804": {
                "name": "Shelter Rock",
                "level": 0,
                "coord": [
                  54181.9,
                  30096.9
                ],
                "bounds": [
                  [
                    54283.8,
                    30384.9
                  ],
                  [
                    54299.8,
                    30366
                  ],
                  [
                    54319.8,
                    30301.8
                  ],
                  [
                    54322.8,
                    30214.7
                  ],
                  [
                    54274.8,
                    30154.9
                  ],
                  [
                    54213.2,
                    30114.2
                  ],
                  [
                    54121.4,
                    30119.6
                  ],
                  [
                    54066.8,
                    30152
                  ],
                  [
                    54057.1,
                    30125.5
                  ],
                  [
                    53999.5,
                    30027.6
                  ],
                  [
                    53941,
                    30044.1
                  ],
                  [
                    53912.8,
                    29903.5
                  ],
                  [
                    53876.7,
                    29807.5
                  ],
                  [
                    53862.9,
                    29696.7
                  ],
                  [
                    54282.5,
                    29687
                  ],
                  [
                    54538.2,
                    29685.8
                  ],
                  [
                    54553.6,
                    30480.7
                  ],
                  [
                    54347,
                    30478.5
                  ],
                  [
                    54283.8,
                    30384.9
                  ]
                ],
                "id": 804,
                "chat_link": "[&BCQDAAA=]"
              },
              "805": {
                "name": "Frost Basin",
                "level": 0,
                "coord": [
                  54220.9,
                  31207.1
                ],
                "bounds": [
                  [
                    53878,
                    31116.3
                  ],
                  [
                    54211.6,
                    30928.4
                  ],
                  [
                    54549.9,
                    30961
                  ],
                  [
                    54551.5,
                    31357.6
                  ],
                  [
                    54329.2,
                    31369.1
                  ],
                  [
                    54144.6,
                    31355.4
                  ],
                  [
                    53881.3,
                    31362.3
                  ],
                  [
                    53878,
                    31116.3
                  ]
                ],
                "id": 805,
                "chat_link": "[&BCUDAAA=]"
              },
              "806": {
                "name": "Southern Watchpost",
                "level": 0,
                "coord": [
                  53863.6,
                  31109.2
                ],
                "bounds": [
                  [
                    53970.8,
                    30825
                  ],
                  [
                    54019.1,
                    30855.8
                  ],
                  [
                    54054.5,
                    30856.9
                  ],
                  [
                    54066.3,
                    31009.8
                  ],
                  [
                    53878.6,
                    31118.3
                  ],
                  [
                    53882.9,
                    31353
                  ],
                  [
                    53789.4,
                    31353.5
                  ],
                  [
                    53780.4,
                    31395.1
                  ],
                  [
                    53700.3,
                    31400.8
                  ],
                  [
                    53694.4,
                    31244.7
                  ],
                  [
                    53747.4,
                    31112
                  ],
                  [
                    53777.3,
                    31044.5
                  ],
                  [
                    53866.1,
                    30850.6
                  ],
                  [
                    53970.8,
                    30825
                  ]
                ],
                "id": 806,
                "chat_link": "[&BCYDAAA=]"
              },
              "807": {
                "name": "Wolf Lodge",
                "level": 0,
                "coord": [
                  54072.5,
                  30755.5
                ],
                "bounds": [
                  [
                    54150.9,
                    30668.4
                  ],
                  [
                    54179.7,
                    30720.1
                  ],
                  [
                    54176.3,
                    30777
                  ],
                  [
                    54140.5,
                    30833.3
                  ],
                  [
                    54084.3,
                    30859.5
                  ],
                  [
                    54016,
                    30858.1
                  ],
                  [
                    53964,
                    30821.9
                  ],
                  [
                    53971.3,
                    30782.5
                  ],
                  [
                    54019.5,
                    30734.2
                  ],
                  [
                    54009.3,
                    30722.7
                  ],
                  [
                    54049.6,
                    30687.4
                  ],
                  [
                    54061.8,
                    30698.5
                  ],
                  [
                    54119.8,
                    30658.1
                  ],
                  [
                    54150.9,
                    30668.4
                  ]
                ],
                "id": 807,
                "chat_link": "[&BCcDAAA=]"
              },
              "808": {
                "name": "Hall of Legends",
                "level": 0,
                "coord": [
                  54254.9,
                  30547.7
                ],
                "bounds": [
                  [
                    54139.7,
                    30440.5
                  ],
                  [
                    54185.4,
                    30432.1
                  ],
                  [
                    54253.6,
                    30414
                  ],
                  [
                    54284.5,
                    30384.2
                  ],
                  [
                    54346,
                    30479.7
                  ],
                  [
                    54554,
                    30480.3
                  ],
                  [
                    54549,
                    30715.3
                  ],
                  [
                    54259.4,
                    30739.5
                  ],
                  [
                    54148,
                    30668.8
                  ],
                  [
                    54119.2,
                    30657
                  ],
                  [
                    54132.2,
                    30598.4
                  ],
                  [
                    54088.1,
                    30562.5
                  ],
                  [
                    54139.7,
                    30440.5
                  ]
                ],
                "id": 808,
                "chat_link": "[&BCgDAAA=]"
              },
              "809": {
                "name": "Peeta's Gate",
                "level": 0,
                "coord": [
                  53304,
                  30604.9
                ],
                "bounds": [
                  [
                    53241.3,
                    30488.6
                  ],
                  [
                    53310.2,
                    30516.8
                  ],
                  [
                    53390.2,
                    30505.8
                  ],
                  [
                    53493.2,
                    30527.8
                  ],
                  [
                    53465.4,
                    30600.8
                  ],
                  [
                    53401.4,
                    30597.3
                  ],
                  [
                    53182.8,
                    30932
                  ],
                  [
                    53177.8,
                    30817.1
                  ],
                  [
                    53167.4,
                    30540.4
                  ],
                  [
                    53210.1,
                    30522.9
                  ],
                  [
                    53241.3,
                    30488.6
                  ]
                ],
                "id": 809,
                "chat_link": "[&BCkDAAA=]"
              }
            },
            "id": 1326,
            "mastery_points": [],
            "adventures": []
          },
          "1327": {
            "name": "Dragon Arena Survival",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "881": {
                "name": "Courage Brewery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53009.3,
                  30196.3
                ],
                "id": 881,
                "chat_link": "[&BHEDAAA=]"
              },
              "882": {
                "name": "Fang of the Serpent",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53427.9,
                  31108.1
                ],
                "id": 882,
                "chat_link": "[&BHIDAAA=]"
              },
              "883": {
                "name": "Brawler's Bout",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53790.2,
                  30450.2
                ],
                "id": 883,
                "chat_link": "[&BHMDAAA=]"
              },
              "884": {
                "name": "The Great Rise",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53592.5,
                  30802.5
                ],
                "id": 884,
                "chat_link": "[&BHQDAAA=]"
              },
              "885": {
                "name": "Skarti's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54432.4,
                  30363.5
                ],
                "id": 885,
                "chat_link": "[&BHUDAAA=]"
              },
              "886": {
                "name": "Stonewright's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54015.6,
                  31159.6
                ],
                "id": 886,
                "chat_link": "[&BHYDAAA=]"
              },
              "887": {
                "name": "Sigfast's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53930.2,
                  29788.7
                ],
                "id": 887,
                "chat_link": "[&BHcDAAA=]"
              },
              "888": {
                "name": "Master Blackforge's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54378.9,
                  29844.9
                ],
                "id": 888,
                "chat_link": "[&BHgDAAA=]"
              },
              "889": {
                "name": "Old Fiach's Lorestead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54293.4,
                  31219.7
                ],
                "id": 889,
                "chat_link": "[&BHkDAAA=]"
              },
              "890": {
                "name": "Boasting Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54425.9,
                  31010.8
                ],
                "id": 890,
                "chat_link": "[&BHoDAAA=]"
              },
              "891": {
                "name": "Hrothbeir's Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52903.8,
                  30404.8
                ],
                "id": 891,
                "chat_link": "[&BHsDAAA=]"
              },
              "892": {
                "name": "Vheratha's Tavern",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54217.6,
                  30534.3
                ],
                "id": 892,
                "chat_link": "[&BHwDAAA=]"
              },
              "893": {
                "name": "Priory Encampment",
                "type": "landmark",
                "floor": 2,
                "coord": [
                  53308.7,
                  30792.3
                ],
                "id": 893,
                "chat_link": "[&BH0DAAA=]"
              },
              "894": {
                "name": "Dragon Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53310.8,
                  29861.1
                ],
                "id": 894,
                "chat_link": "[&BH4DAAA=]"
              },
              "895": {
                "name": "Vigil Billet",
                "type": "landmark",
                "floor": 2,
                "coord": [
                  53731.9,
                  30961.6
                ],
                "id": 895,
                "chat_link": "[&BH8DAAA=]"
              },
              "896": {
                "name": "Lost Spirits' Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54352.3,
                  30685.1
                ],
                "id": 896,
                "chat_link": "[&BIADAAA=]"
              },
              "897": {
                "name": "Bear Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54244.3,
                  30241.8
                ],
                "id": 897,
                "chat_link": "[&BIEDAAA=]"
              },
              "898": {
                "name": "Wolf Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54109.6,
                  30793.7
                ],
                "id": 898,
                "chat_link": "[&BIIDAAA=]"
              },
              "899": {
                "name": "Raven Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53711.2,
                  30026.5
                ],
                "id": 899,
                "chat_link": "[&BIMDAAA=]"
              },
              "900": {
                "name": "Snow Leopard Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53270.9,
                  30335.7
                ],
                "id": 900,
                "chat_link": "[&BIQDAAA=]"
              },
              "1136": {
                "name": "Bilrost Gallery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53993.7,
                  30872.9
                ],
                "id": 1136,
                "chat_link": "[&BHAEAAA=]"
              },
              "1263": {
                "name": "Raven Hearth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53823.9,
                  30015.7
                ],
                "id": 1263,
                "chat_link": "[&BO8EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "792": {
                "name": "Hero's Compass",
                "level": 0,
                "coord": [
                  53118.5,
                  30439
                ],
                "bounds": [
                  [
                    53200.9,
                    30414.3
                  ],
                  [
                    53238.6,
                    30489.4
                  ],
                  [
                    53208,
                    30523.5
                  ],
                  [
                    53133,
                    30562.9
                  ],
                  [
                    52949.8,
                    30525.6
                  ],
                  [
                    53001.1,
                    30355
                  ],
                  [
                    53027.8,
                    30317.6
                  ],
                  [
                    53189,
                    30324
                  ],
                  [
                    53200.9,
                    30414.3
                  ]
                ],
                "id": 792,
                "chat_link": "[&BBgDAAA=]"
              },
              "793": {
                "name": "Bear Lodge",
                "level": 0,
                "coord": [
                  54195.2,
                  30266.4
                ],
                "bounds": [
                  [
                    54067.7,
                    30150.8
                  ],
                  [
                    54123.2,
                    30117.7
                  ],
                  [
                    54211.9,
                    30112.2
                  ],
                  [
                    54277.1,
                    30154.2
                  ],
                  [
                    54326.4,
                    30215
                  ],
                  [
                    54321.7,
                    30303.8
                  ],
                  [
                    54300.7,
                    30367.7
                  ],
                  [
                    54253.4,
                    30416.1
                  ],
                  [
                    54184.2,
                    30431
                  ],
                  [
                    54146.1,
                    30326
                  ],
                  [
                    54120.3,
                    30336.1
                  ],
                  [
                    54088.1,
                    30274.3
                  ],
                  [
                    54116.7,
                    30258.5
                  ],
                  [
                    54067.7,
                    30150.8
                  ]
                ],
                "id": 793,
                "chat_link": "[&BBkDAAA=]"
              },
              "794": {
                "name": "Biergarten",
                "level": 0,
                "coord": [
                  52885.1,
                  29973.1
                ],
                "bounds": [
                  [
                    52954.8,
                    30266.8
                  ],
                  [
                    52823.2,
                    30029.2
                  ],
                  [
                    52550.5,
                    29746.8
                  ],
                  [
                    52749.6,
                    29664.4
                  ],
                  [
                    52965,
                    29722.3
                  ],
                  [
                    53101.3,
                    30146.4
                  ],
                  [
                    53051.2,
                    30235.8
                  ],
                  [
                    52954.8,
                    30266.8
                  ]
                ],
                "id": 794,
                "chat_link": "[&BBoDAAA=]"
              },
              "795": {
                "name": "Eastern Watchpost",
                "level": 0,
                "coord": [
                  54220.2,
                  30823.3
                ],
                "bounds": [
                  [
                    54065.2,
                    31012.4
                  ],
                  [
                    54049.9,
                    30857.8
                  ],
                  [
                    54084.5,
                    30857.3
                  ],
                  [
                    54141,
                    30830.4
                  ],
                  [
                    54175.2,
                    30775
                  ],
                  [
                    54177.1,
                    30718.9
                  ],
                  [
                    54146.4,
                    30666.4
                  ],
                  [
                    54259.5,
                    30735.1
                  ],
                  [
                    54556.9,
                    30713.3
                  ],
                  [
                    54553.5,
                    30960.8
                  ],
                  [
                    54213.4,
                    30929.2
                  ],
                  [
                    54065.2,
                    31012.4
                  ]
                ],
                "id": 795,
                "chat_link": "[&BBsDAAA=]"
              },
              "796": {
                "name": "Trade Commons",
                "level": 0,
                "coord": [
                  53545,
                  30860
                ],
                "bounds": [
                  [
                    53777.4,
                    31044.9
                  ],
                  [
                    53744.2,
                    31105.4
                  ],
                  [
                    53549.6,
                    30993.1
                  ],
                  [
                    53574.2,
                    30944.8
                  ],
                  [
                    53482.7,
                    30899.5
                  ],
                  [
                    53457.6,
                    30943.2
                  ],
                  [
                    53315.2,
                    30873.4
                  ],
                  [
                    53284.4,
                    30889.4
                  ],
                  [
                    53177.6,
                    30933
                  ],
                  [
                    53399.4,
                    30596.8
                  ],
                  [
                    53542,
                    30599.2
                  ],
                  [
                    53673.8,
                    30648.3
                  ],
                  [
                    53784.7,
                    30727.3
                  ],
                  [
                    53867.6,
                    30841.1
                  ],
                  [
                    53777.4,
                    31044.9
                  ]
                ],
                "id": 796,
                "chat_link": "[&BBwDAAA=]"
              },
              "797": {
                "name": "Might and Main",
                "level": 0,
                "coord": [
                  53821.1,
                  30398.4
                ],
                "bounds": [
                  [
                    54184.5,
                    30431.1
                  ],
                  [
                    54144.6,
                    30443.3
                  ],
                  [
                    54087.9,
                    30559.6
                  ],
                  [
                    54131.3,
                    30597.5
                  ],
                  [
                    54118.8,
                    30657.7
                  ],
                  [
                    54062.4,
                    30699.1
                  ],
                  [
                    54048.6,
                    30691.1
                  ],
                  [
                    54011.9,
                    30722.8
                  ],
                  [
                    54019.3,
                    30734.2
                  ],
                  [
                    53976,
                    30783.2
                  ],
                  [
                    53964.2,
                    30822.1
                  ],
                  [
                    53866.7,
                    30845.7
                  ],
                  [
                    53780.8,
                    30722
                  ],
                  [
                    53675.4,
                    30645.9
                  ],
                  [
                    53542.9,
                    30597.3
                  ],
                  [
                    53466,
                    30601.3
                  ],
                  [
                    53491.2,
                    30526.9
                  ],
                  [
                    53389,
                    30508.3
                  ],
                  [
                    53410.7,
                    30402.4
                  ],
                  [
                    53442.6,
                    30404.5
                  ],
                  [
                    53455.2,
                    30336.2
                  ],
                  [
                    53419.3,
                    30328.2
                  ],
                  [
                    53440.7,
                    30219.1
                  ],
                  [
                    53456.4,
                    30174.3
                  ],
                  [
                    53598.6,
                    30065.5
                  ],
                  [
                    53610.4,
                    30111.6
                  ],
                  [
                    53629.4,
                    30140.5
                  ],
                  [
                    53738.1,
                    30136
                  ],
                  [
                    53741.5,
                    30163.8
                  ],
                  [
                    53806.2,
                    30155.6
                  ],
                  [
                    53802.3,
                    30121.3
                  ],
                  [
                    53921.6,
                    30116.4
                  ],
                  [
                    53938,
                    30081.4
                  ],
                  [
                    53940.4,
                    30044.5
                  ],
                  [
                    53999.2,
                    30027.4
                  ],
                  [
                    54058.5,
                    30125.7
                  ],
                  [
                    54116.7,
                    30258.5
                  ],
                  [
                    54088.1,
                    30273.8
                  ],
                  [
                    54120.6,
                    30336
                  ],
                  [
                    54145.9,
                    30326.2
                  ],
                  [
                    54184.5,
                    30431.1
                  ]
                ],
                "id": 797,
                "chat_link": "[&BB0DAAA=]"
              },
              "798": {
                "name": "The Great Lodge",
                "level": 0,
                "coord": [
                  53465.6,
                  31103.7
                ],
                "bounds": [
                  [
                    53691,
                    31069.9
                  ],
                  [
                    53750.3,
                    31112.7
                  ],
                  [
                    53698.6,
                    31247.4
                  ],
                  [
                    53703.5,
                    31364.2
                  ],
                  [
                    53437.6,
                    31414.9
                  ],
                  [
                    53121.8,
                    31375.4
                  ],
                  [
                    53084.2,
                    31183.7
                  ],
                  [
                    53179,
                    30929.1
                  ],
                  [
                    53317.2,
                    30872.5
                  ],
                  [
                    53460.8,
                    30942.7
                  ],
                  [
                    53483.3,
                    30897.3
                  ],
                  [
                    53576.1,
                    30944.3
                  ],
                  [
                    53549.3,
                    30994.4
                  ],
                  [
                    53691,
                    31069.9
                  ]
                ],
                "id": 798,
                "chat_link": "[&BB4DAAA=]"
              },
              "799": {
                "name": "Lake Mourn",
                "level": 0,
                "coord": [
                  52746.6,
                  30556.8
                ],
                "bounds": [
                  [
                    52825.3,
                    30025
                  ],
                  [
                    52957,
                    30262.5
                  ],
                  [
                    52986.9,
                    30257.1
                  ],
                  [
                    53026.8,
                    30324.9
                  ],
                  [
                    53003.8,
                    30353.8
                  ],
                  [
                    52951.8,
                    30526.7
                  ],
                  [
                    53134,
                    30558.6
                  ],
                  [
                    53168.1,
                    30540.1
                  ],
                  [
                    53180.2,
                    30817.5
                  ],
                  [
                    53183.7,
                    30931
                  ],
                  [
                    53088.9,
                    31179.1
                  ],
                  [
                    53122.6,
                    31361.8
                  ],
                  [
                    52895.6,
                    31373.6
                  ],
                  [
                    52599.8,
                    31381.4
                  ],
                  [
                    52370.6,
                    31304.6
                  ],
                  [
                    52205.1,
                    31122.9
                  ],
                  [
                    52143.3,
                    30810.2
                  ],
                  [
                    52149.5,
                    30123.1
                  ],
                  [
                    52199,
                    29885.4
                  ],
                  [
                    52262.2,
                    29700.7
                  ],
                  [
                    52417.5,
                    29665.4
                  ],
                  [
                    52552.8,
                    29745
                  ],
                  [
                    52825.3,
                    30025
                  ]
                ],
                "id": 799,
                "chat_link": "[&BB8DAAA=]"
              },
              "800": {
                "name": "Mourn's Tears",
                "level": 0,
                "coord": [
                  53121.2,
                  30237.6
                ],
                "bounds": [
                  [
                    53020.5,
                    30317.9
                  ],
                  [
                    52983.9,
                    30256
                  ],
                  [
                    53049.3,
                    30235.4
                  ],
                  [
                    53095.3,
                    30152.8
                  ],
                  [
                    53179.1,
                    30129.4
                  ],
                  [
                    53233.1,
                    30236.8
                  ],
                  [
                    53218.5,
                    30246.4
                  ],
                  [
                    53190.2,
                    30326.3
                  ],
                  [
                    53020.5,
                    30317.9
                  ]
                ],
                "id": 800,
                "chat_link": "[&BCADAAA=]"
              },
              "801": {
                "name": "Veins of the Dragon",
                "level": 0,
                "coord": [
                  53332.3,
                  30070.5
                ],
                "bounds": [
                  [
                    52958.9,
                    29726.7
                  ],
                  [
                    53438.5,
                    29695.9
                  ],
                  [
                    53592.5,
                    30001.4
                  ],
                  [
                    53599.1,
                    30066
                  ],
                  [
                    53456.5,
                    30173.8
                  ],
                  [
                    53439.1,
                    30218.4
                  ],
                  [
                    53364.8,
                    30184.7
                  ],
                  [
                    53292.7,
                    30195.4
                  ],
                  [
                    53233.2,
                    30236.7
                  ],
                  [
                    53179.4,
                    30129.1
                  ],
                  [
                    53100.6,
                    30147.1
                  ],
                  [
                    52958.9,
                    29726.7
                  ]
                ],
                "id": 801,
                "chat_link": "[&BCEDAAA=]"
              },
              "802": {
                "name": "Snow Leopard Lodge",
                "level": 0,
                "coord": [
                  53336.2,
                  30352.3
                ],
                "bounds": [
                  [
                    53390.2,
                    30508.7
                  ],
                  [
                    53308.7,
                    30516.7
                  ],
                  [
                    53239.7,
                    30490.3
                  ],
                  [
                    53202.7,
                    30414.9
                  ],
                  [
                    53186.8,
                    30330.5
                  ],
                  [
                    53215.3,
                    30248.3
                  ],
                  [
                    53292.8,
                    30195.4
                  ],
                  [
                    53364.9,
                    30185.2
                  ],
                  [
                    53440,
                    30219.1
                  ],
                  [
                    53419.5,
                    30328.2
                  ],
                  [
                    53456.7,
                    30335.7
                  ],
                  [
                    53442.2,
                    30404
                  ],
                  [
                    53410.6,
                    30402.5
                  ],
                  [
                    53390.2,
                    30508.7
                  ]
                ],
                "id": 802,
                "chat_link": "[&BCIDAAA=]"
              },
              "803": {
                "name": "Raven Lodge",
                "level": 0,
                "coord": [
                  53760.4,
                  30016.1
                ],
                "bounds": [
                  [
                    53629.3,
                    30140.8
                  ],
                  [
                    53610.8,
                    30110.9
                  ],
                  [
                    53598.9,
                    30066.2
                  ],
                  [
                    53592.4,
                    30001.3
                  ],
                  [
                    53437.7,
                    29695.9
                  ],
                  [
                    53862.7,
                    29696.9
                  ],
                  [
                    53875.9,
                    29808.2
                  ],
                  [
                    53912.2,
                    29903.6
                  ],
                  [
                    53940.8,
                    30044.9
                  ],
                  [
                    53937.9,
                    30080.9
                  ],
                  [
                    53922,
                    30115.5
                  ],
                  [
                    53802.1,
                    30121.5
                  ],
                  [
                    53805.2,
                    30155.1
                  ],
                  [
                    53741.5,
                    30163.4
                  ],
                  [
                    53737,
                    30135.7
                  ],
                  [
                    53629.3,
                    30140.8
                  ]
                ],
                "id": 803,
                "chat_link": "[&BCMDAAA=]"
              },
              "804": {
                "name": "Shelter Rock",
                "level": 0,
                "coord": [
                  54181.9,
                  30096.9
                ],
                "bounds": [
                  [
                    54283.8,
                    30384.9
                  ],
                  [
                    54299.8,
                    30366
                  ],
                  [
                    54319.8,
                    30301.8
                  ],
                  [
                    54322.8,
                    30214.7
                  ],
                  [
                    54274.8,
                    30154.9
                  ],
                  [
                    54213.2,
                    30114.2
                  ],
                  [
                    54121.4,
                    30119.6
                  ],
                  [
                    54066.8,
                    30152
                  ],
                  [
                    54057.1,
                    30125.5
                  ],
                  [
                    53999.5,
                    30027.6
                  ],
                  [
                    53941,
                    30044.1
                  ],
                  [
                    53912.8,
                    29903.5
                  ],
                  [
                    53876.7,
                    29807.5
                  ],
                  [
                    53862.9,
                    29696.7
                  ],
                  [
                    54282.5,
                    29687
                  ],
                  [
                    54538.2,
                    29685.8
                  ],
                  [
                    54553.6,
                    30480.7
                  ],
                  [
                    54347,
                    30478.5
                  ],
                  [
                    54283.8,
                    30384.9
                  ]
                ],
                "id": 804,
                "chat_link": "[&BCQDAAA=]"
              },
              "805": {
                "name": "Frost Basin",
                "level": 0,
                "coord": [
                  54220.9,
                  31207.1
                ],
                "bounds": [
                  [
                    53878,
                    31116.3
                  ],
                  [
                    54211.6,
                    30928.4
                  ],
                  [
                    54549.9,
                    30961
                  ],
                  [
                    54551.5,
                    31357.6
                  ],
                  [
                    54329.2,
                    31369.1
                  ],
                  [
                    54144.6,
                    31355.4
                  ],
                  [
                    53881.3,
                    31362.3
                  ],
                  [
                    53878,
                    31116.3
                  ]
                ],
                "id": 805,
                "chat_link": "[&BCUDAAA=]"
              },
              "806": {
                "name": "Southern Watchpost",
                "level": 0,
                "coord": [
                  53863.6,
                  31109.2
                ],
                "bounds": [
                  [
                    53970.8,
                    30825
                  ],
                  [
                    54019.1,
                    30855.8
                  ],
                  [
                    54054.5,
                    30856.9
                  ],
                  [
                    54066.3,
                    31009.8
                  ],
                  [
                    53878.6,
                    31118.3
                  ],
                  [
                    53882.9,
                    31353
                  ],
                  [
                    53789.4,
                    31353.5
                  ],
                  [
                    53780.4,
                    31395.1
                  ],
                  [
                    53700.3,
                    31400.8
                  ],
                  [
                    53694.4,
                    31244.7
                  ],
                  [
                    53747.4,
                    31112
                  ],
                  [
                    53777.3,
                    31044.5
                  ],
                  [
                    53866.1,
                    30850.6
                  ],
                  [
                    53970.8,
                    30825
                  ]
                ],
                "id": 806,
                "chat_link": "[&BCYDAAA=]"
              },
              "807": {
                "name": "Wolf Lodge",
                "level": 0,
                "coord": [
                  54072.5,
                  30755.5
                ],
                "bounds": [
                  [
                    54150.9,
                    30668.4
                  ],
                  [
                    54179.7,
                    30720.1
                  ],
                  [
                    54176.3,
                    30777
                  ],
                  [
                    54140.5,
                    30833.3
                  ],
                  [
                    54084.3,
                    30859.5
                  ],
                  [
                    54016,
                    30858.1
                  ],
                  [
                    53964,
                    30821.9
                  ],
                  [
                    53971.3,
                    30782.5
                  ],
                  [
                    54019.5,
                    30734.2
                  ],
                  [
                    54009.3,
                    30722.7
                  ],
                  [
                    54049.6,
                    30687.4
                  ],
                  [
                    54061.8,
                    30698.5
                  ],
                  [
                    54119.8,
                    30658.1
                  ],
                  [
                    54150.9,
                    30668.4
                  ]
                ],
                "id": 807,
                "chat_link": "[&BCcDAAA=]"
              },
              "808": {
                "name": "Hall of Legends",
                "level": 0,
                "coord": [
                  54254.9,
                  30547.7
                ],
                "bounds": [
                  [
                    54139.7,
                    30440.5
                  ],
                  [
                    54185.4,
                    30432.1
                  ],
                  [
                    54253.6,
                    30414
                  ],
                  [
                    54284.5,
                    30384.2
                  ],
                  [
                    54346,
                    30479.7
                  ],
                  [
                    54554,
                    30480.3
                  ],
                  [
                    54549,
                    30715.3
                  ],
                  [
                    54259.4,
                    30739.5
                  ],
                  [
                    54148,
                    30668.8
                  ],
                  [
                    54119.2,
                    30657
                  ],
                  [
                    54132.2,
                    30598.4
                  ],
                  [
                    54088.1,
                    30562.5
                  ],
                  [
                    54139.7,
                    30440.5
                  ]
                ],
                "id": 808,
                "chat_link": "[&BCgDAAA=]"
              },
              "809": {
                "name": "Peeta's Gate",
                "level": 0,
                "coord": [
                  53304,
                  30604.9
                ],
                "bounds": [
                  [
                    53241.3,
                    30488.6
                  ],
                  [
                    53310.2,
                    30516.8
                  ],
                  [
                    53390.2,
                    30505.8
                  ],
                  [
                    53493.2,
                    30527.8
                  ],
                  [
                    53465.4,
                    30600.8
                  ],
                  [
                    53401.4,
                    30597.3
                  ],
                  [
                    53182.8,
                    30932
                  ],
                  [
                    53177.8,
                    30817.1
                  ],
                  [
                    53167.4,
                    30540.4
                  ],
                  [
                    53210.1,
                    30522.9
                  ],
                  [
                    53241.3,
                    30488.6
                  ]
                ],
                "id": 809,
                "chat_link": "[&BCkDAAA=]"
              }
            },
            "adventures": [],
            "id": 1327,
            "mastery_points": []
          },
          "1342": {
            "name": "The Invitation",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -52224,
                -24576
              ],
              [
                55296,
                27648
              ]
            ],
            "continent_rect": [
              [
                54911,
                16972
              ],
              [
                59391,
                19148
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1773": {
                "name": "Southern Mountains",
                "level": 80,
                "coord": [
                  58970.4,
                  18749.8
                ],
                "bounds": [
                  [
                    58597.4,
                    18628.8
                  ],
                  [
                    58816.8,
                    18515.5
                  ],
                  [
                    58876.1,
                    18545.5
                  ],
                  [
                    58941.8,
                    18555.7
                  ],
                  [
                    59240.3,
                    18536
                  ],
                  [
                    59323.4,
                    18860.8
                  ],
                  [
                    59219.2,
                    19003.6
                  ],
                  [
                    59109,
                    19044.9
                  ],
                  [
                    58609.6,
                    19057.7
                  ],
                  [
                    58597.4,
                    18628.8
                  ]
                ],
                "id": 1773,
                "chat_link": "[&BO0GAAA=]"
              },
              "1774": {
                "name": "Aberrant Forest",
                "level": 80,
                "coord": [
                  57760.6,
                  18589.7
                ],
                "bounds": [
                  [
                    57307,
                    18536.7
                  ],
                  [
                    57577.9,
                    18552.7
                  ],
                  [
                    57693.4,
                    18523.6
                  ],
                  [
                    57764,
                    18479.3
                  ],
                  [
                    57787.2,
                    18372.8
                  ],
                  [
                    57782.8,
                    18240.7
                  ],
                  [
                    57973.1,
                    18247.6
                  ],
                  [
                    58072.4,
                    18292.2
                  ],
                  [
                    58179.1,
                    18369.6
                  ],
                  [
                    58066.4,
                    18666.3
                  ],
                  [
                    58040.1,
                    19001.3
                  ],
                  [
                    57630,
                    19046.3
                  ],
                  [
                    57506.8,
                    18959.5
                  ],
                  [
                    57268,
                    18967.2
                  ],
                  [
                    57307,
                    18536.7
                  ]
                ],
                "id": 1774,
                "chat_link": "[&BO4GAAA=]"
              },
              "1776": {
                "name": "Darkrime Delves",
                "level": 80,
                "coord": [
                  58391.4,
                  17321.1
                ],
                "bounds": [
                  [
                    58715.1,
                    17108.7
                  ],
                  [
                    58161.5,
                    17146.6
                  ],
                  [
                    58117.3,
                    17449.3
                  ],
                  [
                    58268.5,
                    17477.8
                  ],
                  [
                    58694.8,
                    17423
                  ],
                  [
                    58715.1,
                    17108.7
                  ]
                ],
                "id": 1776,
                "chat_link": "[&BPAGAAA=]"
              },
              "1777": {
                "name": "Raven Sanctum",
                "level": 80,
                "coord": [
                  57419.1,
                  17872.6
                ],
                "bounds": [
                  [
                    57644.4,
                    17624.6
                  ],
                  [
                    57771.8,
                    17883.7
                  ],
                  [
                    57630.4,
                    18121.5
                  ],
                  [
                    57189.3,
                    18121.5
                  ],
                  [
                    57147.4,
                    17797.4
                  ],
                  [
                    57131.1,
                    17687.1
                  ],
                  [
                    57644.4,
                    17624.6
                  ]
                ],
                "id": 1777,
                "chat_link": "[&BPEGAAA=]"
              },
              "1778": {
                "name": "Ravenfrost Caverns",
                "level": 80,
                "coord": [
                  58343.8,
                  18703.4
                ],
                "bounds": [
                  [
                    58179.1,
                    18369.6
                  ],
                  [
                    58570.5,
                    18496.5
                  ],
                  [
                    58597.4,
                    18628.8
                  ],
                  [
                    58609.6,
                    19057.7
                  ],
                  [
                    58040.1,
                    19001.3
                  ],
                  [
                    58066.4,
                    18666.3
                  ],
                  [
                    58179.1,
                    18369.6
                  ]
                ],
                "id": 1778,
                "chat_link": "[&BPIGAAA=]"
              },
              "1781": {
                "name": "Frozen Pass",
                "level": 80,
                "coord": [
                  58447.6,
                  18098.3
                ],
                "bounds": [
                  [
                    58570.5,
                    18496.5
                  ],
                  [
                    58179.1,
                    18369.6
                  ],
                  [
                    58072.4,
                    18292.2
                  ],
                  [
                    57973.1,
                    18247.6
                  ],
                  [
                    57782.8,
                    18240.7
                  ],
                  [
                    57724.3,
                    18179.2
                  ],
                  [
                    57630.4,
                    18121.5
                  ],
                  [
                    57771.8,
                    17883.7
                  ],
                  [
                    57644.4,
                    17624.6
                  ],
                  [
                    57940.4,
                    17585.8
                  ],
                  [
                    58031.1,
                    17866
                  ],
                  [
                    58177.4,
                    18047
                  ],
                  [
                    58382.5,
                    18033.1
                  ],
                  [
                    58546.1,
                    18042.3
                  ],
                  [
                    58810.8,
                    17733
                  ],
                  [
                    58857.4,
                    17786.9
                  ],
                  [
                    58936.5,
                    17792.1
                  ],
                  [
                    59018.6,
                    17814
                  ],
                  [
                    59061.9,
                    17910.3
                  ],
                  [
                    59058.8,
                    18103.7
                  ],
                  [
                    58906.5,
                    18132
                  ],
                  [
                    58851.2,
                    18146.2
                  ],
                  [
                    58814.9,
                    18170.3
                  ],
                  [
                    58797.3,
                    18208.1
                  ],
                  [
                    58790.4,
                    18297.7
                  ],
                  [
                    58788.7,
                    18482.7
                  ],
                  [
                    58816.8,
                    18515.5
                  ],
                  [
                    58597.4,
                    18628.8
                  ],
                  [
                    58570.5,
                    18496.5
                  ]
                ],
                "id": 1781,
                "chat_link": "[&BPUGAAA=]"
              },
              "1782": {
                "name": "Asgeir's Legacy",
                "level": 80,
                "coord": [
                  57603.6,
                  17366.3
                ],
                "bounds": [
                  [
                    57203.5,
                    17121
                  ],
                  [
                    58161.5,
                    17146.6
                  ],
                  [
                    58117.3,
                    17449.3
                  ],
                  [
                    57940.4,
                    17585.8
                  ],
                  [
                    57131.1,
                    17687.1
                  ],
                  [
                    57068,
                    17208
                  ],
                  [
                    57203.5,
                    17121
                  ]
                ],
                "id": 1782,
                "chat_link": "[&BPYGAAA=]"
              },
              "1784": {
                "name": "Svanir Plateau",
                "level": 80,
                "coord": [
                  58329.9,
                  17739.7
                ],
                "bounds": [
                  [
                    57940.4,
                    17585.8
                  ],
                  [
                    58117.3,
                    17449.3
                  ],
                  [
                    58268.5,
                    17477.8
                  ],
                  [
                    58694.8,
                    17423
                  ],
                  [
                    58810.8,
                    17733
                  ],
                  [
                    58546.1,
                    18042.3
                  ],
                  [
                    58382.5,
                    18033.1
                  ],
                  [
                    58177.4,
                    18047
                  ],
                  [
                    58031.1,
                    17866
                  ],
                  [
                    57940.4,
                    17585.8
                  ]
                ],
                "id": 1784,
                "chat_link": "[&BPgGAAA=]"
              },
              "1787": {
                "name": "Jora's Keep",
                "level": 80,
                "coord": [
                  58927.8,
                  18315.2
                ],
                "bounds": [
                  [
                    59251.5,
                    18089.3
                  ],
                  [
                    59240.3,
                    18536
                  ],
                  [
                    58941.8,
                    18555.7
                  ],
                  [
                    58876.1,
                    18545.5
                  ],
                  [
                    58816.8,
                    18515.5
                  ],
                  [
                    58788.7,
                    18482.7
                  ],
                  [
                    58790.4,
                    18297.7
                  ],
                  [
                    58797.3,
                    18208.1
                  ],
                  [
                    58814.9,
                    18170.3
                  ],
                  [
                    58851.2,
                    18146.2
                  ],
                  [
                    58906.5,
                    18132
                  ],
                  [
                    59058.8,
                    18103.7
                  ],
                  [
                    59251.5,
                    18089.3
                  ]
                ],
                "id": 1787,
                "chat_link": "[&BPsGAAA=]"
              },
              "1788": {
                "name": "Fallen Ruins",
                "level": 80,
                "coord": [
                  57565.3,
                  18335.2
                ],
                "bounds": [
                  [
                    57630.4,
                    18121.5
                  ],
                  [
                    57724.3,
                    18179.2
                  ],
                  [
                    57782.8,
                    18240.7
                  ],
                  [
                    57787.2,
                    18372.8
                  ],
                  [
                    57764,
                    18479.3
                  ],
                  [
                    57693.4,
                    18523.6
                  ],
                  [
                    57577.9,
                    18552.7
                  ],
                  [
                    57307,
                    18536.7
                  ],
                  [
                    57197,
                    18223.9
                  ],
                  [
                    57189.3,
                    18121.5
                  ],
                  [
                    57630.4,
                    18121.5
                  ]
                ],
                "id": 1788,
                "chat_link": "[&BPwGAAA=]"
              },
              "1789": {
                "name": "Fallen Mountains",
                "level": 80,
                "coord": [
                  59050.4,
                  17548.7
                ],
                "bounds": [
                  [
                    58715.1,
                    17108.7
                  ],
                  [
                    59186.5,
                    16974.8
                  ],
                  [
                    59315.6,
                    17017.8
                  ],
                  [
                    59370.3,
                    17103.1
                  ],
                  [
                    59377.2,
                    17276.3
                  ],
                  [
                    59251.5,
                    18089.3
                  ],
                  [
                    59058.8,
                    18103.7
                  ],
                  [
                    59061.9,
                    17910.3
                  ],
                  [
                    59018.6,
                    17814
                  ],
                  [
                    58936.5,
                    17792.1
                  ],
                  [
                    58857.4,
                    17786.9
                  ],
                  [
                    58810.8,
                    17733
                  ],
                  [
                    58694.8,
                    17423
                  ],
                  [
                    58715.1,
                    17108.7
                  ]
                ],
                "id": 1789,
                "chat_link": "[&BP0GAAA=]"
              }
            },
            "adventures": [],
            "id": 1342,
            "mastery_points": []
          },
          "1343": {
            "name": "Bjora Marches",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              57191,
              18009
            ],
            "map_rect": [
              [
                -52224,
                -24576
              ],
              [
                55296,
                27648
              ]
            ],
            "continent_rect": [
              [
                54911,
                16972
              ],
              [
                59391,
                19148
              ]
            ],
            "points_of_interest": {
              "3102": {
                "name": "Ruined Hut",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57658.4,
                  18689.1
                ],
                "id": 3102,
                "chat_link": "[&BB4MAAA=]"
              },
              "3103": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58821.7,
                  17722.1
                ],
                "id": 3103,
                "chat_link": "[&BB8MAAA=]"
              },
              "3104": {
                "name": "Vigil Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58893.3,
                  18338
                ],
                "id": 3104,
                "chat_link": "[&BCAMAAA=]"
              },
              "3105": {
                "name": "Claw's Perch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58401,
                  18214.5
                ],
                "id": 3105,
                "chat_link": "[&BCEMAAA=]"
              },
              "3106": {
                "name": "Raven's Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57737.9,
                  17942.9
                ],
                "id": 3106,
                "chat_link": "[&BCIMAAA=]"
              },
              "3108": {
                "name": "Raven Pass",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57322.8,
                  18101.2
                ],
                "id": 3108,
                "chat_link": "[&BCQMAAA=]"
              },
              "3109": {
                "name": "Darkrime Ruins",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58296.5,
                  17257.4
                ],
                "id": 3109,
                "chat_link": "[&BCUMAAA=]"
              },
              "3110": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  59147.4,
                  18559.2
                ],
                "id": 3110,
                "chat_link": "[&BCYMAAA=]"
              },
              "3111": {
                "name": "Jora's Keep Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58936.7,
                  18318.8
                ],
                "id": 3111,
                "chat_link": "[&BCcMAAA=]"
              },
              "3112": {
                "name": "Gates of Svanir",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57778.1,
                  17567.3
                ],
                "id": 3112,
                "chat_link": "[&BCgMAAA=]"
              },
              "3113": {
                "name": "Northwest Svanir Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58185,
                  17553.9
                ],
                "id": 3113,
                "chat_link": "[&BCkMAAA=]"
              },
              "3114": {
                "name": "General's Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58999,
                  18273.3
                ],
                "id": 3114,
                "chat_link": "[&BCoMAAA=]"
              },
              "3115": {
                "name": "Boneskinner Den",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58053.8,
                  18353.5
                ],
                "id": 3115,
                "chat_link": "[&BCsMAAA=]"
              },
              "3117": {
                "name": "Southeast Svanir Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58485.8,
                  17866.6
                ],
                "id": 3117,
                "chat_link": "[&BC0MAAA=]"
              },
              "3118": {
                "name": "Southwest Svanir Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58207.1,
                  17968.2
                ],
                "id": 3118,
                "chat_link": "[&BC4MAAA=]"
              },
              "3119": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57723.5,
                  17615.9
                ],
                "id": 3119,
                "chat_link": "[&BC8MAAA=]"
              },
              "3120": {
                "name": "Aberrant Den",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58305.3,
                  18552.3
                ],
                "id": 3120,
                "chat_link": "[&BDAMAAA=]"
              },
              "3121": {
                "name": "Northeast Svanir Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58584.6,
                  17494.2
                ],
                "id": 3121,
                "chat_link": "[&BDEMAAA=]"
              },
              "3122": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57493.7,
                  18380
                ],
                "id": 3122,
                "chat_link": "[&BDIMAAA=]"
              },
              "3124": {
                "name": "Bear Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58869.3,
                  17451.8
                ],
                "id": 3124,
                "chat_link": "[&BDQMAAA=]"
              },
              "3125": {
                "name": "Kodan Shipwreck",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56352,
                  17967.1
                ],
                "id": 3125,
                "chat_link": "[&BDUMAAA=]"
              },
              "3126": {
                "name": "Mystery of the Raven Gate Ruins",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56138.9,
                  17047.1
                ],
                "id": 3126,
                "chat_link": "[&BDYMAAA=]"
              },
              "3127": {
                "name": "Kodan's Leap",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56397.8,
                  18532.8
                ],
                "id": 3127,
                "chat_link": "[&BDcMAAA=]"
              },
              "3128": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  56466.7,
                  18832.8
                ],
                "id": 3128,
                "chat_link": "[&BDgMAAA=]"
              },
              "3129": {
                "name": "Still Waters Speaking Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  56616.3,
                  17814.7
                ],
                "id": 3129,
                "chat_link": "[&BDkMAAA=]"
              },
              "3130": {
                "name": "Mystery of the Labyrinth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59156.5,
                  17163.9
                ],
                "id": 3130,
                "chat_link": "[&BDoMAAA=]"
              },
              "3131": {
                "name": "Sifhalla Ruins",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55507.1,
                  17835.3
                ],
                "id": 3131,
                "chat_link": "[&BDsMAAA=]"
              },
              "3132": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  56201.2,
                  17296.3
                ],
                "id": 3132,
                "chat_link": "[&BDwMAAA=]"
              },
              "3133": {
                "name": "Shrine of the Valorous Wolverine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55950.8,
                  17522.9
                ],
                "id": 3133,
                "chat_link": "[&BD0MAAA=]"
              },
              "3134": {
                "name": "Shrine of the Resilient Ox",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56810.2,
                  17239.2
                ],
                "id": 3134,
                "chat_link": "[&BD4MAAA=]"
              },
              "3135": {
                "name": "Cavern of Lost Sons",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55805.6,
                  18715.3
                ],
                "id": 3135,
                "chat_link": "[&BD8MAAA=]"
              },
              "3136": {
                "name": "Shrine of the Vigilant Eagle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56762.4,
                  18778.4
                ],
                "id": 3136,
                "chat_link": "[&BEAMAAA=]"
              },
              "3137": {
                "name": "Den of Whispers",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55452.1,
                  18625.2
                ],
                "id": 3137,
                "chat_link": "[&BEEMAAA=]"
              },
              "3138": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  56688.6,
                  17741.7
                ],
                "id": 3138,
                "chat_link": "[&BEIMAAA=]"
              },
              "3139": {
                "name": "Koda's Tears",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56579.1,
                  18133.5
                ],
                "id": 3139,
                "chat_link": "[&BEMMAAA=]"
              },
              "3140": {
                "name": "Mystery of the Hidden Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56950.1,
                  19025.8
                ],
                "id": 3140,
                "chat_link": "[&BEQMAAA=]"
              },
              "3141": {
                "name": "Still Waters Speaking",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56636.6,
                  17795
                ],
                "id": 3141,
                "chat_link": "[&BEUMAAA=]"
              },
              "3142": {
                "name": "Whisperwind Grotto",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56334.8,
                  18989.8
                ],
                "id": 3142,
                "chat_link": "[&BEYMAAA=]"
              },
              "3143": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  56950.6,
                  17126
                ],
                "id": 3143,
                "chat_link": "[&BEcMAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1773": {
                "name": "Southern Mountains",
                "level": 80,
                "coord": [
                  58970.4,
                  18749.8
                ],
                "bounds": [
                  [
                    58597.4,
                    18628.8
                  ],
                  [
                    58816.8,
                    18515.5
                  ],
                  [
                    58876.1,
                    18545.5
                  ],
                  [
                    58941.8,
                    18555.7
                  ],
                  [
                    59240.3,
                    18536
                  ],
                  [
                    59323.4,
                    18860.8
                  ],
                  [
                    59219.2,
                    19003.6
                  ],
                  [
                    59109,
                    19044.9
                  ],
                  [
                    58609.6,
                    19057.7
                  ],
                  [
                    58597.4,
                    18628.8
                  ]
                ],
                "id": 1773,
                "chat_link": "[&BO0GAAA=]"
              },
              "1774": {
                "name": "Aberrant Forest",
                "level": 80,
                "coord": [
                  57760.6,
                  18589.7
                ],
                "bounds": [
                  [
                    57307,
                    18536.7
                  ],
                  [
                    57577.9,
                    18552.7
                  ],
                  [
                    57693.4,
                    18523.6
                  ],
                  [
                    57764,
                    18479.3
                  ],
                  [
                    57787.2,
                    18372.8
                  ],
                  [
                    57782.8,
                    18240.7
                  ],
                  [
                    57973.1,
                    18247.6
                  ],
                  [
                    58072.4,
                    18292.2
                  ],
                  [
                    58179.1,
                    18369.6
                  ],
                  [
                    58066.4,
                    18666.3
                  ],
                  [
                    58040.1,
                    19001.3
                  ],
                  [
                    57630,
                    19046.3
                  ],
                  [
                    57506.8,
                    18959.5
                  ],
                  [
                    57268,
                    18967.2
                  ],
                  [
                    57307,
                    18536.7
                  ]
                ],
                "id": 1774,
                "chat_link": "[&BO4GAAA=]"
              },
              "1776": {
                "name": "Darkrime Delves",
                "level": 80,
                "coord": [
                  58391.4,
                  17321.1
                ],
                "bounds": [
                  [
                    58715.1,
                    17108.7
                  ],
                  [
                    58161.5,
                    17146.6
                  ],
                  [
                    58117.3,
                    17449.3
                  ],
                  [
                    58268.5,
                    17477.8
                  ],
                  [
                    58694.8,
                    17423
                  ],
                  [
                    58715.1,
                    17108.7
                  ]
                ],
                "id": 1776,
                "chat_link": "[&BPAGAAA=]"
              },
              "1777": {
                "name": "Raven Sanctum",
                "level": 80,
                "coord": [
                  57419.1,
                  17872.6
                ],
                "bounds": [
                  [
                    57644.4,
                    17624.6
                  ],
                  [
                    57771.8,
                    17883.7
                  ],
                  [
                    57630.4,
                    18121.5
                  ],
                  [
                    57189.3,
                    18121.5
                  ],
                  [
                    57147.4,
                    17797.4
                  ],
                  [
                    57131.1,
                    17687.1
                  ],
                  [
                    57644.4,
                    17624.6
                  ]
                ],
                "id": 1777,
                "chat_link": "[&BPEGAAA=]"
              },
              "1778": {
                "name": "Ravenfrost Caverns",
                "level": 80,
                "coord": [
                  58343.8,
                  18703.4
                ],
                "bounds": [
                  [
                    58179.1,
                    18369.6
                  ],
                  [
                    58570.5,
                    18496.5
                  ],
                  [
                    58597.4,
                    18628.8
                  ],
                  [
                    58609.6,
                    19057.7
                  ],
                  [
                    58040.1,
                    19001.3
                  ],
                  [
                    58066.4,
                    18666.3
                  ],
                  [
                    58179.1,
                    18369.6
                  ]
                ],
                "id": 1778,
                "chat_link": "[&BPIGAAA=]"
              },
              "1781": {
                "name": "Frozen Pass",
                "level": 80,
                "coord": [
                  58447.6,
                  18098.3
                ],
                "bounds": [
                  [
                    58570.5,
                    18496.5
                  ],
                  [
                    58179.1,
                    18369.6
                  ],
                  [
                    58072.4,
                    18292.2
                  ],
                  [
                    57973.1,
                    18247.6
                  ],
                  [
                    57782.8,
                    18240.7
                  ],
                  [
                    57724.3,
                    18179.2
                  ],
                  [
                    57630.4,
                    18121.5
                  ],
                  [
                    57771.8,
                    17883.7
                  ],
                  [
                    57644.4,
                    17624.6
                  ],
                  [
                    57940.4,
                    17585.8
                  ],
                  [
                    58031.1,
                    17866
                  ],
                  [
                    58177.4,
                    18047
                  ],
                  [
                    58382.5,
                    18033.1
                  ],
                  [
                    58546.1,
                    18042.3
                  ],
                  [
                    58810.8,
                    17733
                  ],
                  [
                    58857.4,
                    17786.9
                  ],
                  [
                    58936.5,
                    17792.1
                  ],
                  [
                    59018.6,
                    17814
                  ],
                  [
                    59061.9,
                    17910.3
                  ],
                  [
                    59058.8,
                    18103.7
                  ],
                  [
                    58906.5,
                    18132
                  ],
                  [
                    58851.2,
                    18146.2
                  ],
                  [
                    58814.9,
                    18170.3
                  ],
                  [
                    58797.3,
                    18208.1
                  ],
                  [
                    58790.4,
                    18297.7
                  ],
                  [
                    58788.7,
                    18482.7
                  ],
                  [
                    58816.8,
                    18515.5
                  ],
                  [
                    58597.4,
                    18628.8
                  ],
                  [
                    58570.5,
                    18496.5
                  ]
                ],
                "id": 1781,
                "chat_link": "[&BPUGAAA=]"
              },
              "1782": {
                "name": "Asgeir's Legacy",
                "level": 80,
                "coord": [
                  57603.6,
                  17366.3
                ],
                "bounds": [
                  [
                    57203.5,
                    17121
                  ],
                  [
                    58161.5,
                    17146.6
                  ],
                  [
                    58117.3,
                    17449.3
                  ],
                  [
                    57940.4,
                    17585.8
                  ],
                  [
                    57131.1,
                    17687.1
                  ],
                  [
                    57068,
                    17208
                  ],
                  [
                    57203.5,
                    17121
                  ]
                ],
                "id": 1782,
                "chat_link": "[&BPYGAAA=]"
              },
              "1784": {
                "name": "Svanir Plateau",
                "level": 80,
                "coord": [
                  58329.9,
                  17739.7
                ],
                "bounds": [
                  [
                    57940.4,
                    17585.8
                  ],
                  [
                    58117.3,
                    17449.3
                  ],
                  [
                    58268.5,
                    17477.8
                  ],
                  [
                    58694.8,
                    17423
                  ],
                  [
                    58810.8,
                    17733
                  ],
                  [
                    58546.1,
                    18042.3
                  ],
                  [
                    58382.5,
                    18033.1
                  ],
                  [
                    58177.4,
                    18047
                  ],
                  [
                    58031.1,
                    17866
                  ],
                  [
                    57940.4,
                    17585.8
                  ]
                ],
                "id": 1784,
                "chat_link": "[&BPgGAAA=]"
              },
              "1787": {
                "name": "Jora's Keep",
                "level": 80,
                "coord": [
                  58927.8,
                  18315.2
                ],
                "bounds": [
                  [
                    59251.5,
                    18089.3
                  ],
                  [
                    59240.3,
                    18536
                  ],
                  [
                    58941.8,
                    18555.7
                  ],
                  [
                    58876.1,
                    18545.5
                  ],
                  [
                    58816.8,
                    18515.5
                  ],
                  [
                    58788.7,
                    18482.7
                  ],
                  [
                    58790.4,
                    18297.7
                  ],
                  [
                    58797.3,
                    18208.1
                  ],
                  [
                    58814.9,
                    18170.3
                  ],
                  [
                    58851.2,
                    18146.2
                  ],
                  [
                    58906.5,
                    18132
                  ],
                  [
                    59058.8,
                    18103.7
                  ],
                  [
                    59251.5,
                    18089.3
                  ]
                ],
                "id": 1787,
                "chat_link": "[&BPsGAAA=]"
              },
              "1788": {
                "name": "Fallen Ruins",
                "level": 80,
                "coord": [
                  57565.3,
                  18335.2
                ],
                "bounds": [
                  [
                    57630.4,
                    18121.5
                  ],
                  [
                    57724.3,
                    18179.2
                  ],
                  [
                    57782.8,
                    18240.7
                  ],
                  [
                    57787.2,
                    18372.8
                  ],
                  [
                    57764,
                    18479.3
                  ],
                  [
                    57693.4,
                    18523.6
                  ],
                  [
                    57577.9,
                    18552.7
                  ],
                  [
                    57307,
                    18536.7
                  ],
                  [
                    57197,
                    18223.9
                  ],
                  [
                    57189.3,
                    18121.5
                  ],
                  [
                    57630.4,
                    18121.5
                  ]
                ],
                "id": 1788,
                "chat_link": "[&BPwGAAA=]"
              },
              "1789": {
                "name": "Fallen Mountains",
                "level": 80,
                "coord": [
                  59050.4,
                  17548.7
                ],
                "bounds": [
                  [
                    58715.1,
                    17108.7
                  ],
                  [
                    59186.5,
                    16974.8
                  ],
                  [
                    59315.6,
                    17017.8
                  ],
                  [
                    59370.3,
                    17103.1
                  ],
                  [
                    59377.2,
                    17276.3
                  ],
                  [
                    59251.5,
                    18089.3
                  ],
                  [
                    59058.8,
                    18103.7
                  ],
                  [
                    59061.9,
                    17910.3
                  ],
                  [
                    59018.6,
                    17814
                  ],
                  [
                    58936.5,
                    17792.1
                  ],
                  [
                    58857.4,
                    17786.9
                  ],
                  [
                    58810.8,
                    17733
                  ],
                  [
                    58694.8,
                    17423
                  ],
                  [
                    58715.1,
                    17108.7
                  ]
                ],
                "id": 1789,
                "chat_link": "[&BP0GAAA=]"
              },
              "1791": {
                "name": "Eaglewatch Rise",
                "level": 80,
                "coord": [
                  56721.7,
                  18693.9
                ],
                "bounds": [
                  [
                    57268,
                    18967.2
                  ],
                  [
                    57307,
                    18536.7
                  ],
                  [
                    57197,
                    18223.9
                  ],
                  [
                    57048.4,
                    18248.7
                  ],
                  [
                    56858.2,
                    18267.2
                  ],
                  [
                    56708,
                    18296.8
                  ],
                  [
                    56669.8,
                    18459.2
                  ],
                  [
                    56560,
                    18558.5
                  ],
                  [
                    56494.8,
                    18611.9
                  ],
                  [
                    56471.6,
                    18679.4
                  ],
                  [
                    56387.8,
                    18776.4
                  ],
                  [
                    56379.3,
                    18863.4
                  ],
                  [
                    56362.5,
                    18944
                  ],
                  [
                    56352.1,
                    19033.4
                  ],
                  [
                    56421.6,
                    19060.8
                  ],
                  [
                    56768.9,
                    19133.1
                  ],
                  [
                    57014.4,
                    19136.5
                  ],
                  [
                    57268,
                    18967.2
                  ]
                ],
                "id": 1791,
                "chat_link": "[&BP8GAAA=]"
              },
              "1792": {
                "name": "Ice Spire Peaks",
                "level": 80,
                "coord": [
                  56011.8,
                  17584.4
                ],
                "bounds": [
                  [
                    56200.7,
                    17481.6
                  ],
                  [
                    56237.5,
                    17089
                  ],
                  [
                    56091.9,
                    17090.5
                  ],
                  [
                    55808.1,
                    17437.5
                  ],
                  [
                    55751.5,
                    17526.7
                  ],
                  [
                    55765,
                    17629.5
                  ],
                  [
                    55803.2,
                    17915.7
                  ],
                  [
                    56008.9,
                    17905
                  ],
                  [
                    56080.3,
                    17876.3
                  ],
                  [
                    56116.8,
                    17796.6
                  ],
                  [
                    56137.6,
                    17690.2
                  ],
                  [
                    56140.8,
                    17574
                  ],
                  [
                    56200.7,
                    17481.6
                  ]
                ],
                "id": 1792,
                "chat_link": "[&BAAHAAA=]"
              },
              "1793": {
                "name": "Frigid Dunes",
                "level": 80,
                "coord": [
                  56061.1,
                  18494.4
                ],
                "bounds": [
                  [
                    56426,
                    18541.5
                  ],
                  [
                    56452.9,
                    18580.8
                  ],
                  [
                    56494.8,
                    18611.9
                  ],
                  [
                    56560,
                    18558.5
                  ],
                  [
                    56669.8,
                    18459.2
                  ],
                  [
                    56708,
                    18296.8
                  ],
                  [
                    56468.5,
                    18202.6
                  ],
                  [
                    56405.7,
                    18130.8
                  ],
                  [
                    56205.9,
                    18245
                  ],
                  [
                    56064.3,
                    18276
                  ],
                  [
                    55801,
                    18132.7
                  ],
                  [
                    55732.8,
                    18195.6
                  ],
                  [
                    55758.2,
                    18320
                  ],
                  [
                    55783.6,
                    18372.8
                  ],
                  [
                    55780,
                    18455.8
                  ],
                  [
                    55765,
                    18533.8
                  ],
                  [
                    55727.8,
                    18590.5
                  ],
                  [
                    55675.4,
                    18612.8
                  ],
                  [
                    55675.9,
                    18693.2
                  ],
                  [
                    55678,
                    18757.2
                  ],
                  [
                    55717,
                    18872
                  ],
                  [
                    55830.9,
                    18885.3
                  ],
                  [
                    55898.2,
                    18780
                  ],
                  [
                    56021.2,
                    18612.1
                  ],
                  [
                    56119.3,
                    18587.6
                  ],
                  [
                    56167.5,
                    18550.8
                  ],
                  [
                    56426,
                    18541.5
                  ]
                ],
                "id": 1793,
                "chat_link": "[&BAEHAAA=]"
              },
              "1794": {
                "name": "Frostborn Cascades",
                "level": 80,
                "coord": [
                  56817.4,
                  17459.3
                ],
                "bounds": [
                  [
                    57147.4,
                    17797.4
                  ],
                  [
                    57131.1,
                    17687.1
                  ],
                  [
                    57068,
                    17208
                  ],
                  [
                    56980.3,
                    17058.7
                  ],
                  [
                    56849.3,
                    17021.2
                  ],
                  [
                    56727.6,
                    17028.8
                  ],
                  [
                    56602.8,
                    17073.8
                  ],
                  [
                    56550.2,
                    17129.2
                  ],
                  [
                    56575,
                    17386.5
                  ],
                  [
                    56645.2,
                    17516.8
                  ],
                  [
                    56669.9,
                    17609.9
                  ],
                  [
                    56708.4,
                    17738.9
                  ],
                  [
                    56743,
                    17908.9
                  ],
                  [
                    56836.2,
                    17884.2
                  ],
                  [
                    57027.1,
                    17840.4
                  ],
                  [
                    57147.4,
                    17797.4
                  ]
                ],
                "id": 1794,
                "chat_link": "[&BAIHAAA=]"
              },
              "1795": {
                "name": "Raven Ruins",
                "level": 80,
                "coord": [
                  55865.9,
                  17313.8
                ],
                "bounds": [
                  [
                    55808.1,
                    17437.5
                  ],
                  [
                    55751.5,
                    17526.7
                  ],
                  [
                    55771,
                    17684.6
                  ],
                  [
                    55711.5,
                    17720.5
                  ],
                  [
                    55502.7,
                    17724.8
                  ],
                  [
                    55481.4,
                    17413.4
                  ],
                  [
                    55572,
                    17017.9
                  ],
                  [
                    55911.8,
                    16970.9
                  ],
                  [
                    56227.1,
                    17007.4
                  ],
                  [
                    56324.7,
                    17081.8
                  ],
                  [
                    56237.5,
                    17089
                  ],
                  [
                    56091.9,
                    17090.5
                  ],
                  [
                    55808.1,
                    17437.5
                  ]
                ],
                "id": 1795,
                "chat_link": "[&BAMHAAA=]"
              },
              "1797": {
                "name": "Whispering Depths",
                "level": 80,
                "coord": [
                  55494.9,
                  18684.7
                ],
                "bounds": [
                  [
                    55675.4,
                    18612.8
                  ],
                  [
                    55727.8,
                    18590.5
                  ],
                  [
                    55765,
                    18533.8
                  ],
                  [
                    55780,
                    18455.8
                  ],
                  [
                    55783.6,
                    18372.8
                  ],
                  [
                    55758.2,
                    18320
                  ],
                  [
                    55529.7,
                    18338.8
                  ],
                  [
                    55376,
                    18340.3
                  ],
                  [
                    55369.3,
                    18432.1
                  ],
                  [
                    55336.5,
                    18471.5
                  ],
                  [
                    55307.5,
                    18516
                  ],
                  [
                    55271,
                    18588.7
                  ],
                  [
                    55263.2,
                    18733.5
                  ],
                  [
                    55243.3,
                    18799.3
                  ],
                  [
                    55214.3,
                    18859.6
                  ],
                  [
                    55223,
                    18959.5
                  ],
                  [
                    55270.9,
                    18993.1
                  ],
                  [
                    55320.4,
                    18999.2
                  ],
                  [
                    55407.3,
                    18995.3
                  ],
                  [
                    55479.2,
                    18954.4
                  ],
                  [
                    55560,
                    18961.1
                  ],
                  [
                    55640,
                    18966.3
                  ],
                  [
                    55717,
                    18872
                  ],
                  [
                    55678,
                    18757.2
                  ],
                  [
                    55675.9,
                    18693.2
                  ],
                  [
                    55675.4,
                    18612.8
                  ]
                ],
                "id": 1797,
                "chat_link": "[&BAUHAAA=]"
              },
              "1798": {
                "name": "Spirits' Refuge",
                "level": 80,
                "coord": [
                  56564.6,
                  17786.5
                ],
                "bounds": [
                  [
                    56494.9,
                    17647.8
                  ],
                  [
                    56467.7,
                    17722.3
                  ],
                  [
                    56405,
                    17805.4
                  ],
                  [
                    56435.9,
                    17896.8
                  ],
                  [
                    56527.3,
                    17958.2
                  ],
                  [
                    56607.4,
                    17963.5
                  ],
                  [
                    56743,
                    17908.9
                  ],
                  [
                    56708.4,
                    17738.9
                  ],
                  [
                    56669.9,
                    17609.9
                  ],
                  [
                    56586.2,
                    17613.3
                  ],
                  [
                    56494.9,
                    17647.8
                  ]
                ],
                "id": 1798,
                "chat_link": "[&BAYHAAA=]"
              },
              "1800": {
                "name": "Fractured Lake",
                "level": 80,
                "coord": [
                  56156.9,
                  17881.3
                ],
                "bounds": [
                  [
                    56405,
                    17805.4
                  ],
                  [
                    56272.8,
                    17565.3
                  ],
                  [
                    56200.7,
                    17481.6
                  ],
                  [
                    56140.8,
                    17574
                  ],
                  [
                    56137.6,
                    17690.2
                  ],
                  [
                    56116.8,
                    17796.6
                  ],
                  [
                    56080.3,
                    17876.3
                  ],
                  [
                    56008.9,
                    17905
                  ],
                  [
                    55803.2,
                    17915.7
                  ],
                  [
                    55801,
                    18132.7
                  ],
                  [
                    56064.3,
                    18276
                  ],
                  [
                    56205.9,
                    18245
                  ],
                  [
                    56405.7,
                    18130.8
                  ],
                  [
                    56241,
                    17976.7
                  ],
                  [
                    56281,
                    17897.1
                  ],
                  [
                    56345.3,
                    17833.1
                  ],
                  [
                    56405,
                    17805.4
                  ]
                ],
                "id": 1800,
                "chat_link": "[&BAgHAAA=]"
              },
              "1803": {
                "name": "Cerulean Hollows",
                "level": 80,
                "coord": [
                  55583,
                  18019.8
                ],
                "bounds": [
                  [
                    55801,
                    18132.7
                  ],
                  [
                    55803.2,
                    17915.7
                  ],
                  [
                    55771,
                    17684.6
                  ],
                  [
                    55711.5,
                    17720.5
                  ],
                  [
                    55502.7,
                    17724.8
                  ],
                  [
                    55397.7,
                    17749.8
                  ],
                  [
                    55390.8,
                    17920.2
                  ],
                  [
                    55409,
                    18049.8
                  ],
                  [
                    55395.2,
                    18164.6
                  ],
                  [
                    55376,
                    18340.3
                  ],
                  [
                    55529.7,
                    18338.8
                  ],
                  [
                    55758.2,
                    18320
                  ],
                  [
                    55732.8,
                    18195.6
                  ],
                  [
                    55801,
                    18132.7
                  ]
                ],
                "id": 1803,
                "chat_link": "[&BAsHAAA=]"
              },
              "1806": {
                "name": "Forest of a Thousand Voices",
                "level": 80,
                "coord": [
                  56452.8,
                  17441.4
                ],
                "bounds": [
                  [
                    56405,
                    17805.4
                  ],
                  [
                    56467.7,
                    17722.3
                  ],
                  [
                    56494.9,
                    17647.8
                  ],
                  [
                    56586.2,
                    17613.3
                  ],
                  [
                    56669.9,
                    17609.9
                  ],
                  [
                    56645.2,
                    17516.8
                  ],
                  [
                    56575,
                    17386.5
                  ],
                  [
                    56550.2,
                    17129.2
                  ],
                  [
                    56456.7,
                    17089.9
                  ],
                  [
                    56324.7,
                    17081.8
                  ],
                  [
                    56237.5,
                    17089
                  ],
                  [
                    56200.7,
                    17481.6
                  ],
                  [
                    56272.8,
                    17565.3
                  ],
                  [
                    56405,
                    17805.4
                  ]
                ],
                "id": 1806,
                "chat_link": "[&BA4HAAA=]"
              },
              "1807": {
                "name": "Rime Glen",
                "level": 80,
                "coord": [
                  56219.5,
                  18789.9
                ],
                "bounds": [
                  [
                    56362.5,
                    18944
                  ],
                  [
                    56379.3,
                    18863.4
                  ],
                  [
                    56387.8,
                    18776.4
                  ],
                  [
                    56471.6,
                    18679.4
                  ],
                  [
                    56494.8,
                    18611.9
                  ],
                  [
                    56452.9,
                    18580.8
                  ],
                  [
                    56426,
                    18541.5
                  ],
                  [
                    56167.5,
                    18550.8
                  ],
                  [
                    56119.3,
                    18587.6
                  ],
                  [
                    56021.2,
                    18612.1
                  ],
                  [
                    55898.2,
                    18780
                  ],
                  [
                    55830.9,
                    18885.3
                  ],
                  [
                    55902.7,
                    18917.3
                  ],
                  [
                    56003.9,
                    18997.1
                  ],
                  [
                    56174,
                    19018.1
                  ],
                  [
                    56286.6,
                    19049.7
                  ],
                  [
                    56352.1,
                    19033.4
                  ],
                  [
                    56362.5,
                    18944
                  ]
                ],
                "id": 1807,
                "chat_link": "[&BA8HAAA=]"
              },
              "1808": {
                "name": "Boreal Pass",
                "level": 80,
                "coord": [
                  56692.9,
                  18014.1
                ],
                "bounds": [
                  [
                    57197,
                    18223.9
                  ],
                  [
                    57189.3,
                    18121.5
                  ],
                  [
                    57147.4,
                    17797.4
                  ],
                  [
                    57027.1,
                    17840.4
                  ],
                  [
                    56836.2,
                    17884.2
                  ],
                  [
                    56743,
                    17908.9
                  ],
                  [
                    56607.4,
                    17963.5
                  ],
                  [
                    56527.3,
                    17958.2
                  ],
                  [
                    56435.9,
                    17896.8
                  ],
                  [
                    56405,
                    17805.4
                  ],
                  [
                    56345.3,
                    17833.1
                  ],
                  [
                    56281,
                    17897.1
                  ],
                  [
                    56241,
                    17976.7
                  ],
                  [
                    56405.7,
                    18130.8
                  ],
                  [
                    56468.5,
                    18202.6
                  ],
                  [
                    56708,
                    18296.8
                  ],
                  [
                    56858.2,
                    18267.2
                  ],
                  [
                    57048.4,
                    18248.7
                  ],
                  [
                    57197,
                    18223.9
                  ]
                ],
                "id": 1808,
                "chat_link": "[&BBAHAAA=]"
              }
            },
            "adventures": [],
            "id": 1343,
            "mastery_points": []
          },
          "1345": {
            "name": "What's Left Behind",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -52224,
                -24576
              ],
              [
                55296,
                27648
              ]
            ],
            "continent_rect": [
              [
                54911,
                16972
              ],
              [
                59391,
                19148
              ]
            ],
            "points_of_interest": {
              "3115": {
                "name": "Boneskinner Den",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58053.8,
                  18353.5
                ],
                "id": 3115,
                "chat_link": "[&BCsMAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1774": {
                "name": "Aberrant Forest",
                "level": 80,
                "coord": [
                  57760.6,
                  18589.7
                ],
                "bounds": [
                  [
                    57307,
                    18536.7
                  ],
                  [
                    57577.9,
                    18552.7
                  ],
                  [
                    57693.4,
                    18523.6
                  ],
                  [
                    57764,
                    18479.3
                  ],
                  [
                    57787.2,
                    18372.8
                  ],
                  [
                    57782.8,
                    18240.7
                  ],
                  [
                    57973.1,
                    18247.6
                  ],
                  [
                    58072.4,
                    18292.2
                  ],
                  [
                    58179.1,
                    18369.6
                  ],
                  [
                    58066.4,
                    18666.3
                  ],
                  [
                    58040.1,
                    19001.3
                  ],
                  [
                    57630,
                    19046.3
                  ],
                  [
                    57506.8,
                    18959.5
                  ],
                  [
                    57268,
                    18967.2
                  ],
                  [
                    57307,
                    18536.7
                  ]
                ],
                "id": 1774,
                "chat_link": "[&BO4GAAA=]"
              }
            },
            "adventures": [],
            "id": 1345,
            "mastery_points": []
          },
          "1349": {
            "name": "Silence",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -52224,
                -24576
              ],
              [
                55296,
                27648
              ]
            ],
            "continent_rect": [
              [
                54911,
                16972
              ],
              [
                59391,
                19148
              ]
            ],
            "points_of_interest": {
              "3104": {
                "name": "Vigil Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58893.3,
                  18338
                ],
                "id": 3104,
                "chat_link": "[&BCAMAAA=]"
              },
              "3114": {
                "name": "General's Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58999,
                  18273.3
                ],
                "id": 3114,
                "chat_link": "[&BCoMAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1774": {
                "name": "Aberrant Forest",
                "level": 80,
                "coord": [
                  57760.6,
                  18589.7
                ],
                "bounds": [
                  [
                    57307,
                    18536.7
                  ],
                  [
                    57577.9,
                    18552.7
                  ],
                  [
                    57693.4,
                    18523.6
                  ],
                  [
                    57764,
                    18479.3
                  ],
                  [
                    57787.2,
                    18372.8
                  ],
                  [
                    57782.8,
                    18240.7
                  ],
                  [
                    57973.1,
                    18247.6
                  ],
                  [
                    58072.4,
                    18292.2
                  ],
                  [
                    58179.1,
                    18369.6
                  ],
                  [
                    58066.4,
                    18666.3
                  ],
                  [
                    58040.1,
                    19001.3
                  ],
                  [
                    57630,
                    19046.3
                  ],
                  [
                    57506.8,
                    18959.5
                  ],
                  [
                    57268,
                    18967.2
                  ],
                  [
                    57307,
                    18536.7
                  ]
                ],
                "id": 1774,
                "chat_link": "[&BO4GAAA=]"
              },
              "1778": {
                "name": "Ravenfrost Caverns",
                "level": 80,
                "coord": [
                  58343.8,
                  18703.4
                ],
                "bounds": [
                  [
                    58179.1,
                    18369.6
                  ],
                  [
                    58570.5,
                    18496.5
                  ],
                  [
                    58597.4,
                    18628.8
                  ],
                  [
                    58609.6,
                    19057.7
                  ],
                  [
                    58040.1,
                    19001.3
                  ],
                  [
                    58066.4,
                    18666.3
                  ],
                  [
                    58179.1,
                    18369.6
                  ]
                ],
                "id": 1778,
                "chat_link": "[&BPIGAAA=]"
              },
              "1781": {
                "name": "Frozen Pass",
                "level": 80,
                "coord": [
                  58447.6,
                  18098.3
                ],
                "bounds": [
                  [
                    58570.5,
                    18496.5
                  ],
                  [
                    58179.1,
                    18369.6
                  ],
                  [
                    58072.4,
                    18292.2
                  ],
                  [
                    57973.1,
                    18247.6
                  ],
                  [
                    57782.8,
                    18240.7
                  ],
                  [
                    57724.3,
                    18179.2
                  ],
                  [
                    57630.4,
                    18121.5
                  ],
                  [
                    57771.8,
                    17883.7
                  ],
                  [
                    57644.4,
                    17624.6
                  ],
                  [
                    57940.4,
                    17585.8
                  ],
                  [
                    58031.1,
                    17866
                  ],
                  [
                    58177.4,
                    18047
                  ],
                  [
                    58382.5,
                    18033.1
                  ],
                  [
                    58546.1,
                    18042.3
                  ],
                  [
                    58810.8,
                    17733
                  ],
                  [
                    58857.4,
                    17786.9
                  ],
                  [
                    58936.5,
                    17792.1
                  ],
                  [
                    59018.6,
                    17814
                  ],
                  [
                    59061.9,
                    17910.3
                  ],
                  [
                    59058.8,
                    18103.7
                  ],
                  [
                    58906.5,
                    18132
                  ],
                  [
                    58851.2,
                    18146.2
                  ],
                  [
                    58814.9,
                    18170.3
                  ],
                  [
                    58797.3,
                    18208.1
                  ],
                  [
                    58790.4,
                    18297.7
                  ],
                  [
                    58788.7,
                    18482.7
                  ],
                  [
                    58816.8,
                    18515.5
                  ],
                  [
                    58597.4,
                    18628.8
                  ],
                  [
                    58570.5,
                    18496.5
                  ]
                ],
                "id": 1781,
                "chat_link": "[&BPUGAAA=]"
              },
              "1782": {
                "name": "Asgeir's Legacy",
                "level": 80,
                "coord": [
                  57603.6,
                  17366.3
                ],
                "bounds": [
                  [
                    57203.5,
                    17121
                  ],
                  [
                    58161.5,
                    17146.6
                  ],
                  [
                    58117.3,
                    17449.3
                  ],
                  [
                    57940.4,
                    17585.8
                  ],
                  [
                    57131.1,
                    17687.1
                  ],
                  [
                    57068,
                    17208
                  ],
                  [
                    57203.5,
                    17121
                  ]
                ],
                "id": 1782,
                "chat_link": "[&BPYGAAA=]"
              },
              "1784": {
                "name": "Svanir Plateau",
                "level": 80,
                "coord": [
                  58329.9,
                  17739.7
                ],
                "bounds": [
                  [
                    57940.4,
                    17585.8
                  ],
                  [
                    58117.3,
                    17449.3
                  ],
                  [
                    58268.5,
                    17477.8
                  ],
                  [
                    58694.8,
                    17423
                  ],
                  [
                    58810.8,
                    17733
                  ],
                  [
                    58546.1,
                    18042.3
                  ],
                  [
                    58382.5,
                    18033.1
                  ],
                  [
                    58177.4,
                    18047
                  ],
                  [
                    58031.1,
                    17866
                  ],
                  [
                    57940.4,
                    17585.8
                  ]
                ],
                "id": 1784,
                "chat_link": "[&BPgGAAA=]"
              },
              "1787": {
                "name": "Jora's Keep",
                "level": 80,
                "coord": [
                  58927.8,
                  18315.2
                ],
                "bounds": [
                  [
                    59251.5,
                    18089.3
                  ],
                  [
                    59240.3,
                    18536
                  ],
                  [
                    58941.8,
                    18555.7
                  ],
                  [
                    58876.1,
                    18545.5
                  ],
                  [
                    58816.8,
                    18515.5
                  ],
                  [
                    58788.7,
                    18482.7
                  ],
                  [
                    58790.4,
                    18297.7
                  ],
                  [
                    58797.3,
                    18208.1
                  ],
                  [
                    58814.9,
                    18170.3
                  ],
                  [
                    58851.2,
                    18146.2
                  ],
                  [
                    58906.5,
                    18132
                  ],
                  [
                    59058.8,
                    18103.7
                  ],
                  [
                    59251.5,
                    18089.3
                  ]
                ],
                "id": 1787,
                "chat_link": "[&BPsGAAA=]"
              },
              "1788": {
                "name": "Fallen Ruins",
                "level": 80,
                "coord": [
                  57565.3,
                  18335.2
                ],
                "bounds": [
                  [
                    57630.4,
                    18121.5
                  ],
                  [
                    57724.3,
                    18179.2
                  ],
                  [
                    57782.8,
                    18240.7
                  ],
                  [
                    57787.2,
                    18372.8
                  ],
                  [
                    57764,
                    18479.3
                  ],
                  [
                    57693.4,
                    18523.6
                  ],
                  [
                    57577.9,
                    18552.7
                  ],
                  [
                    57307,
                    18536.7
                  ],
                  [
                    57197,
                    18223.9
                  ],
                  [
                    57189.3,
                    18121.5
                  ],
                  [
                    57630.4,
                    18121.5
                  ]
                ],
                "id": 1788,
                "chat_link": "[&BPwGAAA=]"
              },
              "1789": {
                "name": "Fallen Mountains",
                "level": 80,
                "coord": [
                  59050.4,
                  17548.7
                ],
                "bounds": [
                  [
                    58715.1,
                    17108.7
                  ],
                  [
                    59186.5,
                    16974.8
                  ],
                  [
                    59315.6,
                    17017.8
                  ],
                  [
                    59370.3,
                    17103.1
                  ],
                  [
                    59377.2,
                    17276.3
                  ],
                  [
                    59251.5,
                    18089.3
                  ],
                  [
                    59058.8,
                    18103.7
                  ],
                  [
                    59061.9,
                    17910.3
                  ],
                  [
                    59018.6,
                    17814
                  ],
                  [
                    58936.5,
                    17792.1
                  ],
                  [
                    58857.4,
                    17786.9
                  ],
                  [
                    58810.8,
                    17733
                  ],
                  [
                    58694.8,
                    17423
                  ],
                  [
                    58715.1,
                    17108.7
                  ]
                ],
                "id": 1789,
                "chat_link": "[&BP0GAAA=]"
              }
            },
            "adventures": [],
            "id": 1349,
            "mastery_points": []
          },
          "1356": {
            "name": "Chasing Ghosts",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -52224,
                -24576
              ],
              [
                55296,
                27648
              ]
            ],
            "continent_rect": [
              [
                54911,
                16972
              ],
              [
                59391,
                19148
              ]
            ],
            "points_of_interest": {
              "3125": {
                "name": "Kodan Shipwreck",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56352,
                  17967.1
                ],
                "id": 3125,
                "chat_link": "[&BDUMAAA=]"
              },
              "3131": {
                "name": "Sifhalla Ruins",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55507.1,
                  17835.3
                ],
                "id": 3131,
                "chat_link": "[&BDsMAAA=]"
              },
              "3133": {
                "name": "Shrine of the Valorous Wolverine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55950.8,
                  17522.9
                ],
                "id": 3133,
                "chat_link": "[&BD0MAAA=]"
              },
              "3134": {
                "name": "Shrine of the Resilient Ox",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56810.2,
                  17239.2
                ],
                "id": 3134,
                "chat_link": "[&BD4MAAA=]"
              },
              "3136": {
                "name": "Shrine of the Vigilant Eagle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56762.4,
                  18778.4
                ],
                "id": 3136,
                "chat_link": "[&BEAMAAA=]"
              },
              "3137": {
                "name": "Den of Whispers",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55452.1,
                  18625.2
                ],
                "id": 3137,
                "chat_link": "[&BEEMAAA=]"
              },
              "3141": {
                "name": "Still Waters Speaking",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56636.6,
                  17795
                ],
                "id": 3141,
                "chat_link": "[&BEUMAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1773": {
                "name": "Southern Mountains",
                "level": 80,
                "coord": [
                  58970.4,
                  18749.8
                ],
                "bounds": [
                  [
                    58597.4,
                    18628.8
                  ],
                  [
                    58816.8,
                    18515.5
                  ],
                  [
                    58876.1,
                    18545.5
                  ],
                  [
                    58941.8,
                    18555.7
                  ],
                  [
                    59240.3,
                    18536
                  ],
                  [
                    59323.4,
                    18860.8
                  ],
                  [
                    59219.2,
                    19003.6
                  ],
                  [
                    59109,
                    19044.9
                  ],
                  [
                    58609.6,
                    19057.7
                  ],
                  [
                    58597.4,
                    18628.8
                  ]
                ],
                "id": 1773,
                "chat_link": "[&BO0GAAA=]"
              },
              "1774": {
                "name": "Aberrant Forest",
                "level": 80,
                "coord": [
                  57760.6,
                  18589.7
                ],
                "bounds": [
                  [
                    57307,
                    18536.7
                  ],
                  [
                    57577.9,
                    18552.7
                  ],
                  [
                    57693.4,
                    18523.6
                  ],
                  [
                    57764,
                    18479.3
                  ],
                  [
                    57787.2,
                    18372.8
                  ],
                  [
                    57782.8,
                    18240.7
                  ],
                  [
                    57973.1,
                    18247.6
                  ],
                  [
                    58072.4,
                    18292.2
                  ],
                  [
                    58179.1,
                    18369.6
                  ],
                  [
                    58066.4,
                    18666.3
                  ],
                  [
                    58040.1,
                    19001.3
                  ],
                  [
                    57630,
                    19046.3
                  ],
                  [
                    57506.8,
                    18959.5
                  ],
                  [
                    57268,
                    18967.2
                  ],
                  [
                    57307,
                    18536.7
                  ]
                ],
                "id": 1774,
                "chat_link": "[&BO4GAAA=]"
              },
              "1776": {
                "name": "Darkrime Delves",
                "level": 80,
                "coord": [
                  58391.4,
                  17321.1
                ],
                "bounds": [
                  [
                    58715.1,
                    17108.7
                  ],
                  [
                    58161.5,
                    17146.6
                  ],
                  [
                    58117.3,
                    17449.3
                  ],
                  [
                    58268.5,
                    17477.8
                  ],
                  [
                    58694.8,
                    17423
                  ],
                  [
                    58715.1,
                    17108.7
                  ]
                ],
                "id": 1776,
                "chat_link": "[&BPAGAAA=]"
              },
              "1777": {
                "name": "Raven Sanctum",
                "level": 80,
                "coord": [
                  57419.1,
                  17872.6
                ],
                "bounds": [
                  [
                    57644.4,
                    17624.6
                  ],
                  [
                    57771.8,
                    17883.7
                  ],
                  [
                    57630.4,
                    18121.5
                  ],
                  [
                    57189.3,
                    18121.5
                  ],
                  [
                    57147.4,
                    17797.4
                  ],
                  [
                    57131.1,
                    17687.1
                  ],
                  [
                    57644.4,
                    17624.6
                  ]
                ],
                "id": 1777,
                "chat_link": "[&BPEGAAA=]"
              },
              "1778": {
                "name": "Ravenfrost Caverns",
                "level": 80,
                "coord": [
                  58343.8,
                  18703.4
                ],
                "bounds": [
                  [
                    58179.1,
                    18369.6
                  ],
                  [
                    58570.5,
                    18496.5
                  ],
                  [
                    58597.4,
                    18628.8
                  ],
                  [
                    58609.6,
                    19057.7
                  ],
                  [
                    58040.1,
                    19001.3
                  ],
                  [
                    58066.4,
                    18666.3
                  ],
                  [
                    58179.1,
                    18369.6
                  ]
                ],
                "id": 1778,
                "chat_link": "[&BPIGAAA=]"
              },
              "1781": {
                "name": "Frozen Pass",
                "level": 80,
                "coord": [
                  58447.6,
                  18098.3
                ],
                "bounds": [
                  [
                    58570.5,
                    18496.5
                  ],
                  [
                    58179.1,
                    18369.6
                  ],
                  [
                    58072.4,
                    18292.2
                  ],
                  [
                    57973.1,
                    18247.6
                  ],
                  [
                    57782.8,
                    18240.7
                  ],
                  [
                    57724.3,
                    18179.2
                  ],
                  [
                    57630.4,
                    18121.5
                  ],
                  [
                    57771.8,
                    17883.7
                  ],
                  [
                    57644.4,
                    17624.6
                  ],
                  [
                    57940.4,
                    17585.8
                  ],
                  [
                    58031.1,
                    17866
                  ],
                  [
                    58177.4,
                    18047
                  ],
                  [
                    58382.5,
                    18033.1
                  ],
                  [
                    58546.1,
                    18042.3
                  ],
                  [
                    58810.8,
                    17733
                  ],
                  [
                    58857.4,
                    17786.9
                  ],
                  [
                    58936.5,
                    17792.1
                  ],
                  [
                    59018.6,
                    17814
                  ],
                  [
                    59061.9,
                    17910.3
                  ],
                  [
                    59058.8,
                    18103.7
                  ],
                  [
                    58906.5,
                    18132
                  ],
                  [
                    58851.2,
                    18146.2
                  ],
                  [
                    58814.9,
                    18170.3
                  ],
                  [
                    58797.3,
                    18208.1
                  ],
                  [
                    58790.4,
                    18297.7
                  ],
                  [
                    58788.7,
                    18482.7
                  ],
                  [
                    58816.8,
                    18515.5
                  ],
                  [
                    58597.4,
                    18628.8
                  ],
                  [
                    58570.5,
                    18496.5
                  ]
                ],
                "id": 1781,
                "chat_link": "[&BPUGAAA=]"
              },
              "1782": {
                "name": "Asgeir's Legacy",
                "level": 80,
                "coord": [
                  57603.6,
                  17366.3
                ],
                "bounds": [
                  [
                    57203.5,
                    17121
                  ],
                  [
                    58161.5,
                    17146.6
                  ],
                  [
                    58117.3,
                    17449.3
                  ],
                  [
                    57940.4,
                    17585.8
                  ],
                  [
                    57131.1,
                    17687.1
                  ],
                  [
                    57068,
                    17208
                  ],
                  [
                    57203.5,
                    17121
                  ]
                ],
                "id": 1782,
                "chat_link": "[&BPYGAAA=]"
              },
              "1784": {
                "name": "Svanir Plateau",
                "level": 80,
                "coord": [
                  58329.9,
                  17739.7
                ],
                "bounds": [
                  [
                    57940.4,
                    17585.8
                  ],
                  [
                    58117.3,
                    17449.3
                  ],
                  [
                    58268.5,
                    17477.8
                  ],
                  [
                    58694.8,
                    17423
                  ],
                  [
                    58810.8,
                    17733
                  ],
                  [
                    58546.1,
                    18042.3
                  ],
                  [
                    58382.5,
                    18033.1
                  ],
                  [
                    58177.4,
                    18047
                  ],
                  [
                    58031.1,
                    17866
                  ],
                  [
                    57940.4,
                    17585.8
                  ]
                ],
                "id": 1784,
                "chat_link": "[&BPgGAAA=]"
              },
              "1787": {
                "name": "Jora's Keep",
                "level": 80,
                "coord": [
                  58927.8,
                  18315.2
                ],
                "bounds": [
                  [
                    59251.5,
                    18089.3
                  ],
                  [
                    59240.3,
                    18536
                  ],
                  [
                    58941.8,
                    18555.7
                  ],
                  [
                    58876.1,
                    18545.5
                  ],
                  [
                    58816.8,
                    18515.5
                  ],
                  [
                    58788.7,
                    18482.7
                  ],
                  [
                    58790.4,
                    18297.7
                  ],
                  [
                    58797.3,
                    18208.1
                  ],
                  [
                    58814.9,
                    18170.3
                  ],
                  [
                    58851.2,
                    18146.2
                  ],
                  [
                    58906.5,
                    18132
                  ],
                  [
                    59058.8,
                    18103.7
                  ],
                  [
                    59251.5,
                    18089.3
                  ]
                ],
                "id": 1787,
                "chat_link": "[&BPsGAAA=]"
              },
              "1788": {
                "name": "Fallen Ruins",
                "level": 80,
                "coord": [
                  57565.3,
                  18335.2
                ],
                "bounds": [
                  [
                    57630.4,
                    18121.5
                  ],
                  [
                    57724.3,
                    18179.2
                  ],
                  [
                    57782.8,
                    18240.7
                  ],
                  [
                    57787.2,
                    18372.8
                  ],
                  [
                    57764,
                    18479.3
                  ],
                  [
                    57693.4,
                    18523.6
                  ],
                  [
                    57577.9,
                    18552.7
                  ],
                  [
                    57307,
                    18536.7
                  ],
                  [
                    57197,
                    18223.9
                  ],
                  [
                    57189.3,
                    18121.5
                  ],
                  [
                    57630.4,
                    18121.5
                  ]
                ],
                "id": 1788,
                "chat_link": "[&BPwGAAA=]"
              },
              "1789": {
                "name": "Fallen Mountains",
                "level": 80,
                "coord": [
                  59050.4,
                  17548.7
                ],
                "bounds": [
                  [
                    58715.1,
                    17108.7
                  ],
                  [
                    59186.5,
                    16974.8
                  ],
                  [
                    59315.6,
                    17017.8
                  ],
                  [
                    59370.3,
                    17103.1
                  ],
                  [
                    59377.2,
                    17276.3
                  ],
                  [
                    59251.5,
                    18089.3
                  ],
                  [
                    59058.8,
                    18103.7
                  ],
                  [
                    59061.9,
                    17910.3
                  ],
                  [
                    59018.6,
                    17814
                  ],
                  [
                    58936.5,
                    17792.1
                  ],
                  [
                    58857.4,
                    17786.9
                  ],
                  [
                    58810.8,
                    17733
                  ],
                  [
                    58694.8,
                    17423
                  ],
                  [
                    58715.1,
                    17108.7
                  ]
                ],
                "id": 1789,
                "chat_link": "[&BP0GAAA=]"
              },
              "1791": {
                "name": "Eaglewatch Rise",
                "level": 80,
                "coord": [
                  56721.7,
                  18693.9
                ],
                "bounds": [
                  [
                    57268,
                    18967.2
                  ],
                  [
                    57307,
                    18536.7
                  ],
                  [
                    57197,
                    18223.9
                  ],
                  [
                    57048.4,
                    18248.7
                  ],
                  [
                    56858.2,
                    18267.2
                  ],
                  [
                    56708,
                    18296.8
                  ],
                  [
                    56669.8,
                    18459.2
                  ],
                  [
                    56560,
                    18558.5
                  ],
                  [
                    56494.8,
                    18611.9
                  ],
                  [
                    56471.6,
                    18679.4
                  ],
                  [
                    56387.8,
                    18776.4
                  ],
                  [
                    56379.3,
                    18863.4
                  ],
                  [
                    56362.5,
                    18944
                  ],
                  [
                    56352.1,
                    19033.4
                  ],
                  [
                    56421.6,
                    19060.8
                  ],
                  [
                    56768.9,
                    19133.1
                  ],
                  [
                    57014.4,
                    19136.5
                  ],
                  [
                    57268,
                    18967.2
                  ]
                ],
                "id": 1791,
                "chat_link": "[&BP8GAAA=]"
              },
              "1792": {
                "name": "Ice Spire Peaks",
                "level": 80,
                "coord": [
                  56011.8,
                  17584.4
                ],
                "bounds": [
                  [
                    56200.7,
                    17481.6
                  ],
                  [
                    56237.5,
                    17089
                  ],
                  [
                    56091.9,
                    17090.5
                  ],
                  [
                    55808.1,
                    17437.5
                  ],
                  [
                    55751.5,
                    17526.7
                  ],
                  [
                    55765,
                    17629.5
                  ],
                  [
                    55803.2,
                    17915.7
                  ],
                  [
                    56008.9,
                    17905
                  ],
                  [
                    56080.3,
                    17876.3
                  ],
                  [
                    56116.8,
                    17796.6
                  ],
                  [
                    56137.6,
                    17690.2
                  ],
                  [
                    56140.8,
                    17574
                  ],
                  [
                    56200.7,
                    17481.6
                  ]
                ],
                "id": 1792,
                "chat_link": "[&BAAHAAA=]"
              },
              "1793": {
                "name": "Frigid Dunes",
                "level": 80,
                "coord": [
                  56061.1,
                  18494.4
                ],
                "bounds": [
                  [
                    56426,
                    18541.5
                  ],
                  [
                    56452.9,
                    18580.8
                  ],
                  [
                    56494.8,
                    18611.9
                  ],
                  [
                    56560,
                    18558.5
                  ],
                  [
                    56669.8,
                    18459.2
                  ],
                  [
                    56708,
                    18296.8
                  ],
                  [
                    56468.5,
                    18202.6
                  ],
                  [
                    56405.7,
                    18130.8
                  ],
                  [
                    56205.9,
                    18245
                  ],
                  [
                    56064.3,
                    18276
                  ],
                  [
                    55801,
                    18132.7
                  ],
                  [
                    55732.8,
                    18195.6
                  ],
                  [
                    55758.2,
                    18320
                  ],
                  [
                    55783.6,
                    18372.8
                  ],
                  [
                    55780,
                    18455.8
                  ],
                  [
                    55765,
                    18533.8
                  ],
                  [
                    55727.8,
                    18590.5
                  ],
                  [
                    55675.4,
                    18612.8
                  ],
                  [
                    55675.9,
                    18693.2
                  ],
                  [
                    55678,
                    18757.2
                  ],
                  [
                    55717,
                    18872
                  ],
                  [
                    55830.9,
                    18885.3
                  ],
                  [
                    55898.2,
                    18780
                  ],
                  [
                    56021.2,
                    18612.1
                  ],
                  [
                    56119.3,
                    18587.6
                  ],
                  [
                    56167.5,
                    18550.8
                  ],
                  [
                    56426,
                    18541.5
                  ]
                ],
                "id": 1793,
                "chat_link": "[&BAEHAAA=]"
              },
              "1794": {
                "name": "Frostborn Cascades",
                "level": 80,
                "coord": [
                  56817.4,
                  17459.3
                ],
                "bounds": [
                  [
                    57147.4,
                    17797.4
                  ],
                  [
                    57131.1,
                    17687.1
                  ],
                  [
                    57068,
                    17208
                  ],
                  [
                    56980.3,
                    17058.7
                  ],
                  [
                    56849.3,
                    17021.2
                  ],
                  [
                    56727.6,
                    17028.8
                  ],
                  [
                    56602.8,
                    17073.8
                  ],
                  [
                    56550.2,
                    17129.2
                  ],
                  [
                    56575,
                    17386.5
                  ],
                  [
                    56645.2,
                    17516.8
                  ],
                  [
                    56669.9,
                    17609.9
                  ],
                  [
                    56708.4,
                    17738.9
                  ],
                  [
                    56743,
                    17908.9
                  ],
                  [
                    56836.2,
                    17884.2
                  ],
                  [
                    57027.1,
                    17840.4
                  ],
                  [
                    57147.4,
                    17797.4
                  ]
                ],
                "id": 1794,
                "chat_link": "[&BAIHAAA=]"
              },
              "1795": {
                "name": "Raven Ruins",
                "level": 80,
                "coord": [
                  55865.9,
                  17313.8
                ],
                "bounds": [
                  [
                    55808.1,
                    17437.5
                  ],
                  [
                    55751.5,
                    17526.7
                  ],
                  [
                    55771,
                    17684.6
                  ],
                  [
                    55711.5,
                    17720.5
                  ],
                  [
                    55502.7,
                    17724.8
                  ],
                  [
                    55481.4,
                    17413.4
                  ],
                  [
                    55572,
                    17017.9
                  ],
                  [
                    55911.8,
                    16970.9
                  ],
                  [
                    56227.1,
                    17007.4
                  ],
                  [
                    56324.7,
                    17081.8
                  ],
                  [
                    56237.5,
                    17089
                  ],
                  [
                    56091.9,
                    17090.5
                  ],
                  [
                    55808.1,
                    17437.5
                  ]
                ],
                "id": 1795,
                "chat_link": "[&BAMHAAA=]"
              },
              "1797": {
                "name": "Whispering Depths",
                "level": 80,
                "coord": [
                  55494.9,
                  18684.7
                ],
                "bounds": [
                  [
                    55675.4,
                    18612.8
                  ],
                  [
                    55727.8,
                    18590.5
                  ],
                  [
                    55765,
                    18533.8
                  ],
                  [
                    55780,
                    18455.8
                  ],
                  [
                    55783.6,
                    18372.8
                  ],
                  [
                    55758.2,
                    18320
                  ],
                  [
                    55529.7,
                    18338.8
                  ],
                  [
                    55376,
                    18340.3
                  ],
                  [
                    55369.3,
                    18432.1
                  ],
                  [
                    55336.5,
                    18471.5
                  ],
                  [
                    55307.5,
                    18516
                  ],
                  [
                    55271,
                    18588.7
                  ],
                  [
                    55263.2,
                    18733.5
                  ],
                  [
                    55243.3,
                    18799.3
                  ],
                  [
                    55214.3,
                    18859.6
                  ],
                  [
                    55223,
                    18959.5
                  ],
                  [
                    55270.9,
                    18993.1
                  ],
                  [
                    55320.4,
                    18999.2
                  ],
                  [
                    55407.3,
                    18995.3
                  ],
                  [
                    55479.2,
                    18954.4
                  ],
                  [
                    55560,
                    18961.1
                  ],
                  [
                    55640,
                    18966.3
                  ],
                  [
                    55717,
                    18872
                  ],
                  [
                    55678,
                    18757.2
                  ],
                  [
                    55675.9,
                    18693.2
                  ],
                  [
                    55675.4,
                    18612.8
                  ]
                ],
                "id": 1797,
                "chat_link": "[&BAUHAAA=]"
              },
              "1798": {
                "name": "Spirits' Refuge",
                "level": 80,
                "coord": [
                  56564.6,
                  17786.5
                ],
                "bounds": [
                  [
                    56494.9,
                    17647.8
                  ],
                  [
                    56467.7,
                    17722.3
                  ],
                  [
                    56405,
                    17805.4
                  ],
                  [
                    56435.9,
                    17896.8
                  ],
                  [
                    56527.3,
                    17958.2
                  ],
                  [
                    56607.4,
                    17963.5
                  ],
                  [
                    56743,
                    17908.9
                  ],
                  [
                    56708.4,
                    17738.9
                  ],
                  [
                    56669.9,
                    17609.9
                  ],
                  [
                    56586.2,
                    17613.3
                  ],
                  [
                    56494.9,
                    17647.8
                  ]
                ],
                "id": 1798,
                "chat_link": "[&BAYHAAA=]"
              },
              "1800": {
                "name": "Fractured Lake",
                "level": 80,
                "coord": [
                  56156.9,
                  17881.3
                ],
                "bounds": [
                  [
                    56405,
                    17805.4
                  ],
                  [
                    56272.8,
                    17565.3
                  ],
                  [
                    56200.7,
                    17481.6
                  ],
                  [
                    56140.8,
                    17574
                  ],
                  [
                    56137.6,
                    17690.2
                  ],
                  [
                    56116.8,
                    17796.6
                  ],
                  [
                    56080.3,
                    17876.3
                  ],
                  [
                    56008.9,
                    17905
                  ],
                  [
                    55803.2,
                    17915.7
                  ],
                  [
                    55801,
                    18132.7
                  ],
                  [
                    56064.3,
                    18276
                  ],
                  [
                    56205.9,
                    18245
                  ],
                  [
                    56405.7,
                    18130.8
                  ],
                  [
                    56241,
                    17976.7
                  ],
                  [
                    56281,
                    17897.1
                  ],
                  [
                    56345.3,
                    17833.1
                  ],
                  [
                    56405,
                    17805.4
                  ]
                ],
                "id": 1800,
                "chat_link": "[&BAgHAAA=]"
              },
              "1803": {
                "name": "Cerulean Hollows",
                "level": 80,
                "coord": [
                  55583,
                  18019.8
                ],
                "bounds": [
                  [
                    55801,
                    18132.7
                  ],
                  [
                    55803.2,
                    17915.7
                  ],
                  [
                    55771,
                    17684.6
                  ],
                  [
                    55711.5,
                    17720.5
                  ],
                  [
                    55502.7,
                    17724.8
                  ],
                  [
                    55397.7,
                    17749.8
                  ],
                  [
                    55390.8,
                    17920.2
                  ],
                  [
                    55409,
                    18049.8
                  ],
                  [
                    55395.2,
                    18164.6
                  ],
                  [
                    55376,
                    18340.3
                  ],
                  [
                    55529.7,
                    18338.8
                  ],
                  [
                    55758.2,
                    18320
                  ],
                  [
                    55732.8,
                    18195.6
                  ],
                  [
                    55801,
                    18132.7
                  ]
                ],
                "id": 1803,
                "chat_link": "[&BAsHAAA=]"
              },
              "1806": {
                "name": "Forest of a Thousand Voices",
                "level": 80,
                "coord": [
                  56452.8,
                  17441.4
                ],
                "bounds": [
                  [
                    56405,
                    17805.4
                  ],
                  [
                    56467.7,
                    17722.3
                  ],
                  [
                    56494.9,
                    17647.8
                  ],
                  [
                    56586.2,
                    17613.3
                  ],
                  [
                    56669.9,
                    17609.9
                  ],
                  [
                    56645.2,
                    17516.8
                  ],
                  [
                    56575,
                    17386.5
                  ],
                  [
                    56550.2,
                    17129.2
                  ],
                  [
                    56456.7,
                    17089.9
                  ],
                  [
                    56324.7,
                    17081.8
                  ],
                  [
                    56237.5,
                    17089
                  ],
                  [
                    56200.7,
                    17481.6
                  ],
                  [
                    56272.8,
                    17565.3
                  ],
                  [
                    56405,
                    17805.4
                  ]
                ],
                "id": 1806,
                "chat_link": "[&BA4HAAA=]"
              },
              "1807": {
                "name": "Rime Glen",
                "level": 80,
                "coord": [
                  56219.5,
                  18789.9
                ],
                "bounds": [
                  [
                    56362.5,
                    18944
                  ],
                  [
                    56379.3,
                    18863.4
                  ],
                  [
                    56387.8,
                    18776.4
                  ],
                  [
                    56471.6,
                    18679.4
                  ],
                  [
                    56494.8,
                    18611.9
                  ],
                  [
                    56452.9,
                    18580.8
                  ],
                  [
                    56426,
                    18541.5
                  ],
                  [
                    56167.5,
                    18550.8
                  ],
                  [
                    56119.3,
                    18587.6
                  ],
                  [
                    56021.2,
                    18612.1
                  ],
                  [
                    55898.2,
                    18780
                  ],
                  [
                    55830.9,
                    18885.3
                  ],
                  [
                    55902.7,
                    18917.3
                  ],
                  [
                    56003.9,
                    18997.1
                  ],
                  [
                    56174,
                    19018.1
                  ],
                  [
                    56286.6,
                    19049.7
                  ],
                  [
                    56352.1,
                    19033.4
                  ],
                  [
                    56362.5,
                    18944
                  ]
                ],
                "id": 1807,
                "chat_link": "[&BA8HAAA=]"
              },
              "1808": {
                "name": "Boreal Pass",
                "level": 80,
                "coord": [
                  56692.9,
                  18014.1
                ],
                "bounds": [
                  [
                    57197,
                    18223.9
                  ],
                  [
                    57189.3,
                    18121.5
                  ],
                  [
                    57147.4,
                    17797.4
                  ],
                  [
                    57027.1,
                    17840.4
                  ],
                  [
                    56836.2,
                    17884.2
                  ],
                  [
                    56743,
                    17908.9
                  ],
                  [
                    56607.4,
                    17963.5
                  ],
                  [
                    56527.3,
                    17958.2
                  ],
                  [
                    56435.9,
                    17896.8
                  ],
                  [
                    56405,
                    17805.4
                  ],
                  [
                    56345.3,
                    17833.1
                  ],
                  [
                    56281,
                    17897.1
                  ],
                  [
                    56241,
                    17976.7
                  ],
                  [
                    56405.7,
                    18130.8
                  ],
                  [
                    56468.5,
                    18202.6
                  ],
                  [
                    56708,
                    18296.8
                  ],
                  [
                    56858.2,
                    18267.2
                  ],
                  [
                    57048.4,
                    18248.7
                  ],
                  [
                    57197,
                    18223.9
                  ]
                ],
                "id": 1808,
                "chat_link": "[&BBAHAAA=]"
              }
            },
            "adventures": [],
            "id": 1356,
            "mastery_points": []
          },
          "1358": {
            "name": "Eye of the North",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              57984,
              21504
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                57344,
                21248
              ],
              [
                58624,
                22528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1358,
            "mastery_points": []
          },
          "1370": {
            "name": "Eye of the North",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              57984,
              21504
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                57344,
                21248
              ],
              [
                58624,
                22528
              ]
            ],
            "points_of_interest": {
              "1294": {
                "name": "Scrying Pool",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57601.7,
                  21592.2
                ],
                "id": 1294,
                "chat_link": "[&BA4FAAA=]"
              },
              "3081": {
                "name": "Eye of the North Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57864.6,
                  21794.7
                ],
                "id": 3081,
                "chat_link": "[&BAkMAAA=]"
              },
              "3454": {
                "type": "unlock",
                "floor": 1,
                "coord": [
                  57853.3,
                  21830.8
                ],
                "id": 3454,
                "chat_link": "[&BH4NAAA=]",
                "icon": "https://render.guildwars2.com/file/59EE15E692D47BF90ECF02269F7DAE6751F56FAD/2200049.png"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1021": {
                "name": "Hall of Monuments",
                "level": 0,
                "coord": [
                  57780,
                  21761.4
                ],
                "bounds": [
                  [
                    57696.9,
                    21933.5
                  ],
                  [
                    57742.9,
                    21933.4
                  ],
                  [
                    57750.1,
                    21915.1
                  ],
                  [
                    57826,
                    21932.4
                  ],
                  [
                    57899.8,
                    21909.7
                  ],
                  [
                    57906.2,
                    21925.5
                  ],
                  [
                    57953.6,
                    21925.9
                  ],
                  [
                    57959.2,
                    21877.1
                  ],
                  [
                    57926.4,
                    21869
                  ],
                  [
                    57953.7,
                    21799.9
                  ],
                  [
                    57924.5,
                    21726.5
                  ],
                  [
                    57948.7,
                    21717.9
                  ],
                  [
                    57949.7,
                    21672.8
                  ],
                  [
                    57902.2,
                    21671.8
                  ],
                  [
                    57895.1,
                    21697.7
                  ],
                  [
                    57821.8,
                    21674.4
                  ],
                  [
                    57756.1,
                    21694.1
                  ],
                  [
                    57709.9,
                    21646.9
                  ],
                  [
                    57729.7,
                    21624.6
                  ],
                  [
                    57692.7,
                    21496.9
                  ],
                  [
                    57566.6,
                    21468.5
                  ],
                  [
                    57476.6,
                    21562.4
                  ],
                  [
                    57513.8,
                    21685.8
                  ],
                  [
                    57639.6,
                    21719.4
                  ],
                  [
                    57662.4,
                    21690.2
                  ],
                  [
                    57707.1,
                    21737.4
                  ],
                  [
                    57690.1,
                    21803.7
                  ],
                  [
                    57721.3,
                    21880.7
                  ],
                  [
                    57696.9,
                    21887.1
                  ],
                  [
                    57696.9,
                    21933.5
                  ]
                ],
                "id": 1021,
                "chat_link": "[&BP0DAAA=]"
              }
            },
            "adventures": [],
            "id": 1370,
            "mastery_points": []
          },
          "1371": {
            "name": "Drizzlewood Coast",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              51218,
              20334
            ],
            "map_rect": [
              [
                -24576,
                -52224
              ],
              [
                27648,
                55296
              ]
            ],
            "continent_rect": [
              [
                50128,
                17809
              ],
              [
                52304,
                22289
              ]
            ],
            "points_of_interest": {
              "3147": {
                "name": "Griefshadow Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52075.6,
                  22008.9
                ],
                "id": 3147,
                "chat_link": "[&BEsMAAA=]"
              },
              "3148": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  52035.7,
                  20483
                ],
                "id": 3148,
                "chat_link": "[&BEwMAAA=]"
              },
              "3149": {
                "name": "Wolf's Crossing Bridge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51310.1,
                  20512.9
                ],
                "id": 3149,
                "chat_link": "[&BE0MAAA=]"
              },
              "3150": {
                "name": "Greattree Hamlet",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51508.6,
                  21494.9
                ],
                "id": 3150,
                "chat_link": "[&BE4MAAA=]"
              },
              "3151": {
                "name": "Troop Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50778.1,
                  21236
                ],
                "id": 3151,
                "chat_link": "[&BE8MAAA=]"
              },
              "3152": {
                "name": "Submerged Scrapyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52129.3,
                  21158.2
                ],
                "id": 3152,
                "chat_link": "[&BFAMAAA=]"
              },
              "3153": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  50662.6,
                  20171.7
                ],
                "id": 3153,
                "chat_link": "[&BFEMAAA=]"
              },
              "3154": {
                "name": "Leadfoot Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50514.4,
                  20437.3
                ],
                "id": 3154,
                "chat_link": "[&BFIMAAA=]"
              },
              "3155": {
                "name": "Verdant Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50278.6,
                  21094.3
                ],
                "id": 3155,
                "chat_link": "[&BFMMAAA=]"
              },
              "3156": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  50818.2,
                  21168.3
                ],
                "id": 3156,
                "chat_link": "[&BFQMAAA=]"
              },
              "3157": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51859.2,
                  21374.6
                ],
                "id": 3157,
                "chat_link": "[&BFUMAAA=]"
              },
              "3158": {
                "name": "Port Cascadia",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51788.1,
                  21197.7
                ],
                "id": 3158,
                "chat_link": "[&BFYMAAA=]"
              },
              "3159": {
                "name": "Petraj Commons",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51664.6,
                  21736.1
                ],
                "id": 3159,
                "chat_link": "[&BFcMAAA=]"
              },
              "3160": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51488.4,
                  20715.3
                ],
                "id": 3160,
                "chat_link": "[&BFgMAAA=]"
              },
              "3161": {
                "name": "Petraj's Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51079,
                  21203.1
                ],
                "id": 3161,
                "chat_link": "[&BFkMAAA=]"
              },
              "3162": {
                "name": "Redsand Strand",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51968.6,
                  20928.3
                ],
                "id": 3162,
                "chat_link": "[&BFoMAAA=]"
              },
              "3163": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51063.6,
                  21951.5
                ],
                "id": 3163,
                "chat_link": "[&BFsMAAA=]"
              },
              "3164": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  50350.2,
                  21974.8
                ],
                "id": 3164,
                "chat_link": "[&BFwMAAA=]"
              },
              "3165": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51773.8,
                  21809.8
                ],
                "id": 3165,
                "chat_link": "[&BF0MAAA=]"
              },
              "3166": {
                "name": "Vloxen Mine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50444,
                  21973.4
                ],
                "id": 3166,
                "chat_link": "[&BF4MAAA=]"
              },
              "3167": {
                "name": "United Legions Base Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50950,
                  21987.6
                ],
                "id": 3167,
                "chat_link": "[&BF8MAAA=]"
              },
              "3168": {
                "name": "Iceshard Trail",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50412.3,
                  20024.4
                ],
                "id": 3168,
                "chat_link": "[&BGAMAAA=]"
              },
              "3169": {
                "name": "Griffon's Pillar",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52082.6,
                  21598
                ],
                "id": 3169,
                "chat_link": "[&BGEMAAA=]"
              },
              "3170": {
                "name": "Vloxen Shards",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50630.7,
                  21654.7
                ],
                "id": 3170,
                "chat_link": "[&BGIMAAA=]"
              },
              "3171": {
                "name": "Dwayna's Light",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51994.9,
                  20581.5
                ],
                "id": 3171,
                "chat_link": "[&BGMMAAA=]"
              },
              "3172": {
                "name": "Base Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50992.3,
                  21878.1
                ],
                "id": 3172,
                "chat_link": "[&BGQMAAA=]"
              },
              "3173": {
                "name": "Stone Root",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52007.3,
                  20304.7
                ],
                "id": 3173,
                "chat_link": "[&BGUMAAA=]"
              },
              "3174": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51226.6,
                  20990.6
                ],
                "id": 3174,
                "chat_link": "[&BGYMAAA=]"
              },
              "3175": {
                "name": "Mistgate Graveyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51743.5,
                  22058.4
                ],
                "id": 3175,
                "chat_link": "[&BGcMAAA=]"
              },
              "3176": {
                "name": "Olafson Farmstead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50263.4,
                  20358.2
                ],
                "id": 3176,
                "chat_link": "[&BGgMAAA=]"
              },
              "3177": {
                "name": "Pavilion of the Legions",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50999.1,
                  22069.5
                ],
                "id": 3177,
                "chat_link": "[&BGkMAAA=]"
              },
              "3178": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  50404.4,
                  20350.4
                ],
                "id": 3178,
                "chat_link": "[&BGoMAAA=]"
              },
              "3179": {
                "name": "Evergreen Pond",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51336.3,
                  20806.2
                ],
                "id": 3179,
                "chat_link": "[&BGsMAAA=]"
              },
              "3180": {
                "name": "Veins of Jormag",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51405.8,
                  18923.9
                ],
                "id": 3180,
                "chat_link": "[&BGwMAAA=]"
              },
              "3181": {
                "name": "Thermal Vent",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50403.3,
                  18950.5
                ],
                "id": 3181,
                "chat_link": "[&BG0MAAA=]"
              },
              "3182": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51724.2,
                  19594.2
                ],
                "id": 3182,
                "chat_link": "[&BG4MAAA=]"
              },
              "3183": {
                "name": "Archstone Dominion Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51631.9,
                  19499.8
                ],
                "id": 3183,
                "chat_link": "[&BG8MAAA=]"
              },
              "3184": {
                "name": "Iceblood Channel",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51439.1,
                  18168.1
                ],
                "id": 3184,
                "chat_link": "[&BHAMAAA=]"
              },
              "3185": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51113.8,
                  19074
                ],
                "id": 3185,
                "chat_link": "[&BHEMAAA=]"
              },
              "3186": {
                "name": "Forward Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50443.8,
                  19441.1
                ],
                "id": 3186,
                "chat_link": "[&BHIMAAA=]"
              },
              "3187": {
                "name": "Sanctum of the Wild",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50632.6,
                  18480.6
                ],
                "id": 3187,
                "chat_link": "[&BHMMAAA=]"
              },
              "3188": {
                "name": "The Spire",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51587.8,
                  18297.1
                ],
                "id": 3188,
                "chat_link": "[&BHQMAAA=]"
              },
              "3189": {
                "name": "Iron Lookout",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51080.7,
                  18901.4
                ],
                "id": 3189,
                "chat_link": "[&BHUMAAA=]"
              },
              "3190": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51201,
                  19495.9
                ],
                "id": 3190,
                "chat_link": "[&BHYMAAA=]"
              },
              "3191": {
                "name": "Canopy Overlook",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51288.5,
                  19466.3
                ],
                "id": 3191,
                "chat_link": "[&BHcMAAA=]"
              },
              "3192": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  50726.1,
                  19479.3
                ],
                "id": 3192,
                "chat_link": "[&BHgMAAA=]"
              },
              "3193": {
                "name": "United Legions Forward Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50423.2,
                  19428.1
                ],
                "id": 3193,
                "chat_link": "[&BHkMAAA=]"
              },
              "3194": {
                "name": "Sniper's Slope",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51227.1,
                  19829.4
                ],
                "id": 3194,
                "chat_link": "[&BHoMAAA=]"
              },
              "3195": {
                "name": "Ice Dragon's Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51120.7,
                  18371.7
                ],
                "id": 3195,
                "chat_link": "[&BHsMAAA=]"
              },
              "3196": {
                "name": "Shoreline Dominion Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51493.7,
                  19838.2
                ],
                "id": 3196,
                "chat_link": "[&BHwMAAA=]"
              },
              "3197": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51842.1,
                  18583.8
                ],
                "id": 3197,
                "chat_link": "[&BH0MAAA=]"
              },
              "3198": {
                "name": "Frostvein Dominion Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51682.1,
                  19056.4
                ],
                "id": 3198,
                "chat_link": "[&BH4MAAA=]"
              },
              "3199": {
                "name": "Cavern Entryway",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50821.8,
                  18734
                ],
                "id": 3199,
                "chat_link": "[&BH8MAAA=]"
              },
              "3200": {
                "name": "Stone Archways",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51950.9,
                  19619.8
                ],
                "id": 3200,
                "chat_link": "[&BIAMAAA=]"
              },
              "3201": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51030.1,
                  18511.3
                ],
                "id": 3201,
                "chat_link": "[&BIEMAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1816": {
                "name": "Umbral Grotto",
                "level": 80,
                "coord": [
                  50983.8,
                  21555.8
                ],
                "bounds": [
                  [
                    51217.5,
                    22233.4
                  ],
                  [
                    50734,
                    22225
                  ],
                  [
                    50740.4,
                    21518.8
                  ],
                  [
                    50851.6,
                    21437.2
                  ],
                  [
                    50914.7,
                    21360.8
                  ],
                  [
                    50932.7,
                    21289.3
                  ],
                  [
                    51056.1,
                    21313
                  ],
                  [
                    51160.9,
                    21320.8
                  ],
                  [
                    51246.3,
                    21303.9
                  ],
                  [
                    51217.5,
                    22233.4
                  ]
                ],
                "id": 1816,
                "chat_link": "[&BBgHAAA=]"
              },
              "1817": {
                "name": "Port Cascadia",
                "level": 80,
                "coord": [
                  51791.2,
                  21263.8
                ],
                "bounds": [
                  [
                    51997.4,
                    20899.7
                  ],
                  [
                    52212.7,
                    20885.7
                  ],
                  [
                    52208.3,
                    21550.5
                  ],
                  [
                    51726.4,
                    21539.7
                  ],
                  [
                    51688,
                    21509.7
                  ],
                  [
                    51661.4,
                    21424.3
                  ],
                  [
                    51578.9,
                    21344.8
                  ],
                  [
                    51511.7,
                    21184.7
                  ],
                  [
                    51535.8,
                    21035.4
                  ],
                  [
                    51997.4,
                    20899.7
                  ]
                ],
                "id": 1817,
                "chat_link": "[&BBkHAAA=]"
              },
              "1818": {
                "name": "Fort Defiance",
                "level": 80,
                "coord": [
                  50699.7,
                  21164.4
                ],
                "bounds": [
                  [
                    50859.3,
                    21053.3
                  ],
                  [
                    50900.2,
                    21222.4
                  ],
                  [
                    50932.7,
                    21289.3
                  ],
                  [
                    50914.7,
                    21360.8
                  ],
                  [
                    50851.6,
                    21437.2
                  ],
                  [
                    50740.4,
                    21518.8
                  ],
                  [
                    50203.3,
                    21353.5
                  ],
                  [
                    50192.6,
                    20790.6
                  ],
                  [
                    50530,
                    20811.7
                  ],
                  [
                    50872.6,
                    20806.2
                  ],
                  [
                    50859.3,
                    21053.3
                  ]
                ],
                "id": 1818,
                "chat_link": "[&BBoHAAA=]"
              },
              "1819": {
                "name": "Wolf's Crossing",
                "level": 80,
                "coord": [
                  51347.7,
                  20683.6
                ],
                "bounds": [
                  [
                    51535.8,
                    21035.4
                  ],
                  [
                    51384.3,
                    20971.1
                  ],
                  [
                    51283.8,
                    20884.3
                  ],
                  [
                    51098.6,
                    20699.5
                  ],
                  [
                    51057.8,
                    20256.6
                  ],
                  [
                    51476,
                    20252.1
                  ],
                  [
                    51597.6,
                    20686.5
                  ],
                  [
                    51535.8,
                    21035.4
                  ]
                ],
                "id": 1819,
                "chat_link": "[&BBsHAAA=]"
              },
              "1820": {
                "name": "Leadfoot Village",
                "level": 80,
                "coord": [
                  50627.1,
                  20418.4
                ],
                "bounds": [
                  [
                    50872.6,
                    20806.2
                  ],
                  [
                    50976,
                    20734.8
                  ],
                  [
                    51098.6,
                    20699.5
                  ],
                  [
                    51057.8,
                    20256.6
                  ],
                  [
                    50756.3,
                    20088
                  ],
                  [
                    50430.5,
                    19916.9
                  ],
                  [
                    50178.9,
                    19901.5
                  ],
                  [
                    50177.6,
                    20178.2
                  ],
                  [
                    50192.6,
                    20790.6
                  ],
                  [
                    50530,
                    20811.7
                  ],
                  [
                    50872.6,
                    20806.2
                  ]
                ],
                "id": 1820,
                "chat_link": "[&BBwHAAA=]"
              },
              "1821": {
                "name": "Petraj Overlook",
                "level": 80,
                "coord": [
                  51696.7,
                  21624.8
                ],
                "bounds": [
                  [
                    51217.5,
                    22233.4
                  ],
                  [
                    52118.9,
                    22235.7
                  ],
                  [
                    52180.4,
                    22205.4
                  ],
                  [
                    52210.6,
                    22148
                  ],
                  [
                    52208.3,
                    21550.5
                  ],
                  [
                    51726.4,
                    21539.7
                  ],
                  [
                    51688,
                    21509.7
                  ],
                  [
                    51661.4,
                    21424.3
                  ],
                  [
                    51578.9,
                    21344.8
                  ],
                  [
                    51511.7,
                    21184.7
                  ],
                  [
                    51402.5,
                    21197.5
                  ],
                  [
                    51305.7,
                    21244.6
                  ],
                  [
                    51246.3,
                    21303.9
                  ],
                  [
                    51217.5,
                    22233.4
                  ]
                ],
                "id": 1821,
                "chat_link": "[&BB0HAAA=]"
              },
              "1822": {
                "name": "Lighthouse Point",
                "level": 80,
                "coord": [
                  51843,
                  20641.5
                ],
                "bounds": [
                  [
                    51535.8,
                    21035.4
                  ],
                  [
                    51997.4,
                    20899.7
                  ],
                  [
                    52212.7,
                    20885.7
                  ],
                  [
                    52238.9,
                    20089.4
                  ],
                  [
                    51476,
                    20252.1
                  ],
                  [
                    51597.6,
                    20686.5
                  ],
                  [
                    51535.8,
                    21035.4
                  ]
                ],
                "id": 1822,
                "chat_link": "[&BB4HAAA=]"
              },
              "1823": {
                "name": "Vloxen Mine",
                "level": 80,
                "coord": [
                  50401.8,
                  21944
                ],
                "bounds": [
                  [
                    50285.6,
                    22218.6
                  ],
                  [
                    50734,
                    22225
                  ],
                  [
                    50740.4,
                    21518.8
                  ],
                  [
                    50203.3,
                    21353.5
                  ],
                  [
                    50213.4,
                    22149.5
                  ],
                  [
                    50233.8,
                    22198.5
                  ],
                  [
                    50285.6,
                    22218.6
                  ]
                ],
                "id": 1823,
                "chat_link": "[&BB8HAAA=]"
              },
              "1825": {
                "name": "Breakroot Basin",
                "level": 80,
                "coord": [
                  51168.4,
                  21084
                ],
                "bounds": [
                  [
                    50859.3,
                    21053.3
                  ],
                  [
                    50900.2,
                    21222.4
                  ],
                  [
                    50932.7,
                    21289.3
                  ],
                  [
                    51056.1,
                    21313
                  ],
                  [
                    51160.9,
                    21320.8
                  ],
                  [
                    51246.3,
                    21303.9
                  ],
                  [
                    51305.7,
                    21244.6
                  ],
                  [
                    51402.5,
                    21197.5
                  ],
                  [
                    51511.7,
                    21184.7
                  ],
                  [
                    51535.8,
                    21035.4
                  ],
                  [
                    51384.3,
                    20971.1
                  ],
                  [
                    51283.8,
                    20884.3
                  ],
                  [
                    51098.6,
                    20699.5
                  ],
                  [
                    50976,
                    20734.8
                  ],
                  [
                    50872.6,
                    20806.2
                  ],
                  [
                    50859.3,
                    21053.3
                  ]
                ],
                "id": 1825,
                "chat_link": "[&BCEHAAA=]"
              },
              "1827": {
                "name": "Archstone Coast",
                "level": 80,
                "coord": [
                  51685.4,
                  19733.3
                ],
                "bounds": [
                  [
                    52234.2,
                    19273.4
                  ],
                  [
                    52238.9,
                    20089.4
                  ],
                  [
                    51476,
                    20252.1
                  ],
                  [
                    51390.8,
                    19901.3
                  ],
                  [
                    51421.6,
                    19762.5
                  ],
                  [
                    51508.9,
                    19530.1
                  ],
                  [
                    51527.8,
                    19324.5
                  ],
                  [
                    52234.2,
                    19273.4
                  ]
                ],
                "id": 1827,
                "chat_link": "[&BCMHAAA=]"
              },
              "1828": {
                "name": "Canopy Crag",
                "level": 80,
                "coord": [
                  51250.9,
                  19602.7
                ],
                "bounds": [
                  [
                    51527.8,
                    19324.5
                  ],
                  [
                    51508.9,
                    19530.1
                  ],
                  [
                    51421.6,
                    19762.5
                  ],
                  [
                    51390.8,
                    19901.3
                  ],
                  [
                    51039.9,
                    19904.7
                  ],
                  [
                    51016.5,
                    19642.7
                  ],
                  [
                    51033.3,
                    19444.4
                  ],
                  [
                    51068.4,
                    19311.4
                  ],
                  [
                    51527.8,
                    19324.5
                  ]
                ],
                "id": 1828,
                "chat_link": "[&BCQHAAA=]"
              },
              "1830": {
                "name": "Cavern of Guiding Spirits",
                "level": 80,
                "coord": [
                  50521.7,
                  18818.4
                ],
                "bounds": [
                  [
                    50181.8,
                    18310.2
                  ],
                  [
                    50827.5,
                    18532
                  ],
                  [
                    50859.4,
                    18711.1
                  ],
                  [
                    50547.3,
                    19259.3
                  ],
                  [
                    50192.5,
                    19279.3
                  ],
                  [
                    50181.8,
                    18310.2
                  ]
                ],
                "id": 1830,
                "chat_link": "[&BCYHAAA=]"
              },
              "1831": {
                "name": "Dominion's Breach",
                "level": 80,
                "coord": [
                  51241.1,
                  20078.7
                ],
                "bounds": [
                  [
                    51390.8,
                    19901.3
                  ],
                  [
                    51476,
                    20252.1
                  ],
                  [
                    51057.8,
                    20256.6
                  ],
                  [
                    51039.9,
                    19904.7
                  ],
                  [
                    51390.8,
                    19901.3
                  ]
                ],
                "id": 1831,
                "chat_link": "[&BCcHAAA=]"
              },
              "1832": {
                "name": "Frost Citadel",
                "level": 80,
                "coord": [
                  50789.8,
                  18185.2
                ],
                "bounds": [
                  [
                    50293.3,
                    17933.1
                  ],
                  [
                    50429.7,
                    17863.6
                  ],
                  [
                    51394.4,
                    17878.6
                  ],
                  [
                    51374.3,
                    18238.2
                  ],
                  [
                    51311.6,
                    18386.4
                  ],
                  [
                    51080.1,
                    18482.8
                  ],
                  [
                    50827.5,
                    18532
                  ],
                  [
                    50181.8,
                    18310.2
                  ],
                  [
                    50215.7,
                    18041.8
                  ],
                  [
                    50293.3,
                    17933.1
                  ]
                ],
                "id": 1832,
                "chat_link": "[&BCgHAAA=]"
              },
              "1833": {
                "name": "Legions' Alcove",
                "level": 80,
                "coord": [
                  50337.3,
                  19589.3
                ],
                "bounds": [
                  [
                    50192.5,
                    19279.3
                  ],
                  [
                    50547.3,
                    19259.3
                  ],
                  [
                    50430.5,
                    19916.9
                  ],
                  [
                    50178.9,
                    19901.5
                  ],
                  [
                    50192.5,
                    19279.3
                  ]
                ],
                "id": 1833,
                "chat_link": "[&BCkHAAA=]"
              },
              "1834": {
                "name": "Frostvein Watch",
                "level": 80,
                "coord": [
                  51591.2,
                  19127.1
                ],
                "bounds": [
                  [
                    52211.1,
                    18928.3
                  ],
                  [
                    52234.2,
                    19273.4
                  ],
                  [
                    51527.8,
                    19324.5
                  ],
                  [
                    51068.4,
                    19311.4
                  ],
                  [
                    51200.8,
                    19108.3
                  ],
                  [
                    51213,
                    18993.8
                  ],
                  [
                    51683.3,
                    18949.7
                  ],
                  [
                    52211.1,
                    18928.3
                  ]
                ],
                "id": 1834,
                "chat_link": "[&BCoHAAA=]"
              },
              "1836": {
                "name": "Sentinel Bay",
                "level": 80,
                "coord": [
                  50868.7,
                  19728
                ],
                "bounds": [
                  [
                    50430.5,
                    19916.9
                  ],
                  [
                    50547.3,
                    19259.3
                  ],
                  [
                    51068.4,
                    19311.4
                  ],
                  [
                    51033.3,
                    19444.4
                  ],
                  [
                    51016.5,
                    19642.7
                  ],
                  [
                    51039.9,
                    19904.7
                  ],
                  [
                    51057.8,
                    20256.6
                  ],
                  [
                    50756.3,
                    20088
                  ],
                  [
                    50430.5,
                    19916.9
                  ]
                ],
                "id": 1836,
                "chat_link": "[&BCwHAAA=]"
              },
              "1837": {
                "name": "Drizzlewood Peak",
                "level": 80,
                "coord": [
                  50993,
                  19038.9
                ],
                "bounds": [
                  [
                    51213,
                    18993.8
                  ],
                  [
                    51200.8,
                    19108.3
                  ],
                  [
                    51068.4,
                    19311.4
                  ],
                  [
                    50547.3,
                    19259.3
                  ],
                  [
                    50859.4,
                    18711.1
                  ],
                  [
                    51069.1,
                    18849.3
                  ],
                  [
                    51213,
                    18993.8
                  ]
                ],
                "id": 1837,
                "chat_link": "[&BC0HAAA=]"
              },
              "1838": {
                "name": "The Bloodfield",
                "level": 80,
                "coord": [
                  51397.8,
                  18684.4
                ],
                "bounds": [
                  [
                    52155.5,
                    18544.1
                  ],
                  [
                    52211.1,
                    18928.3
                  ],
                  [
                    51683.3,
                    18949.7
                  ],
                  [
                    51213,
                    18993.8
                  ],
                  [
                    51069.1,
                    18849.3
                  ],
                  [
                    50859.4,
                    18711.1
                  ],
                  [
                    50827.5,
                    18532
                  ],
                  [
                    51080.1,
                    18482.8
                  ],
                  [
                    51311.6,
                    18386.4
                  ],
                  [
                    51567.4,
                    18466.6
                  ],
                  [
                    52155.5,
                    18544.1
                  ]
                ],
                "id": 1838,
                "chat_link": "[&BC4HAAA=]"
              },
              "1839": {
                "name": "Claw's Roost",
                "level": 80,
                "coord": [
                  51715.9,
                  18223.4
                ],
                "bounds": [
                  [
                    51394.4,
                    17878.6
                  ],
                  [
                    51857.8,
                    17963.8
                  ],
                  [
                    51992.1,
                    18067.6
                  ],
                  [
                    52074.2,
                    18241.5
                  ],
                  [
                    52155.5,
                    18544.1
                  ],
                  [
                    51567.4,
                    18466.6
                  ],
                  [
                    51311.6,
                    18386.4
                  ],
                  [
                    51374.3,
                    18238.2
                  ],
                  [
                    51394.4,
                    17878.6
                  ]
                ],
                "id": 1839,
                "chat_link": "[&BC8HAAA=]"
              }
            },
            "adventures": [],
            "id": 1371,
            "mastery_points": []
          },
          "1372": {
            "name": "Turnabout",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              51268,
              21484
            ],
            "map_rect": [
              [
                -24576,
                -52224
              ],
              [
                27648,
                55296
              ]
            ],
            "continent_rect": [
              [
                50128,
                17809
              ],
              [
                52304,
                22289
              ]
            ],
            "points_of_interest": {
              "3147": {
                "name": "Griefshadow Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52075.6,
                  22008.9
                ],
                "id": 3147,
                "chat_link": "[&BEsMAAA=]"
              },
              "3149": {
                "name": "Wolf's Crossing Bridge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51310.1,
                  20512.9
                ],
                "id": 3149,
                "chat_link": "[&BE0MAAA=]"
              },
              "3150": {
                "name": "Greattree Hamlet",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51508.6,
                  21494.9
                ],
                "id": 3150,
                "chat_link": "[&BE4MAAA=]"
              },
              "3151": {
                "name": "Troop Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50778.1,
                  21236
                ],
                "id": 3151,
                "chat_link": "[&BE8MAAA=]"
              },
              "3152": {
                "name": "Submerged Scrapyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52129.3,
                  21158.2
                ],
                "id": 3152,
                "chat_link": "[&BFAMAAA=]"
              },
              "3154": {
                "name": "Leadfoot Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50514.4,
                  20437.3
                ],
                "id": 3154,
                "chat_link": "[&BFIMAAA=]"
              },
              "3155": {
                "name": "Verdant Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50278.6,
                  21094.3
                ],
                "id": 3155,
                "chat_link": "[&BFMMAAA=]"
              },
              "3158": {
                "name": "Port Cascadia",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51788.1,
                  21197.7
                ],
                "id": 3158,
                "chat_link": "[&BFYMAAA=]"
              },
              "3159": {
                "name": "Petraj Commons",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51664.6,
                  21736.1
                ],
                "id": 3159,
                "chat_link": "[&BFcMAAA=]"
              },
              "3161": {
                "name": "Petraj's Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51079,
                  21203.1
                ],
                "id": 3161,
                "chat_link": "[&BFkMAAA=]"
              },
              "3162": {
                "name": "Redsand Strand",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51968.6,
                  20928.3
                ],
                "id": 3162,
                "chat_link": "[&BFoMAAA=]"
              },
              "3166": {
                "name": "Vloxen Mine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50444,
                  21973.4
                ],
                "id": 3166,
                "chat_link": "[&BF4MAAA=]"
              },
              "3167": {
                "name": "United Legions Base Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50950,
                  21987.6
                ],
                "id": 3167,
                "chat_link": "[&BF8MAAA=]"
              },
              "3168": {
                "name": "Iceshard Trail",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50412.3,
                  20024.4
                ],
                "id": 3168,
                "chat_link": "[&BGAMAAA=]"
              },
              "3169": {
                "name": "Griffon's Pillar",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52082.6,
                  21598
                ],
                "id": 3169,
                "chat_link": "[&BGEMAAA=]"
              },
              "3170": {
                "name": "Vloxen Shards",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50630.7,
                  21654.7
                ],
                "id": 3170,
                "chat_link": "[&BGIMAAA=]"
              },
              "3171": {
                "name": "Dwayna's Light",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51994.9,
                  20581.5
                ],
                "id": 3171,
                "chat_link": "[&BGMMAAA=]"
              },
              "3173": {
                "name": "Stone Root",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52007.3,
                  20304.7
                ],
                "id": 3173,
                "chat_link": "[&BGUMAAA=]"
              },
              "3175": {
                "name": "Mistgate Graveyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51743.5,
                  22058.4
                ],
                "id": 3175,
                "chat_link": "[&BGcMAAA=]"
              },
              "3176": {
                "name": "Olafson Farmstead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50263.4,
                  20358.2
                ],
                "id": 3176,
                "chat_link": "[&BGgMAAA=]"
              },
              "3177": {
                "name": "Pavilion of the Legions",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50999.1,
                  22069.5
                ],
                "id": 3177,
                "chat_link": "[&BGkMAAA=]"
              },
              "3179": {
                "name": "Evergreen Pond",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51336.3,
                  20806.2
                ],
                "id": 3179,
                "chat_link": "[&BGsMAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1816": {
                "name": "Umbral Grotto",
                "level": 80,
                "coord": [
                  50983.8,
                  21555.8
                ],
                "bounds": [
                  [
                    51217.5,
                    22233.4
                  ],
                  [
                    50734,
                    22225
                  ],
                  [
                    50740.4,
                    21518.8
                  ],
                  [
                    50851.6,
                    21437.2
                  ],
                  [
                    50914.7,
                    21360.8
                  ],
                  [
                    50932.7,
                    21289.3
                  ],
                  [
                    51056.1,
                    21313
                  ],
                  [
                    51160.9,
                    21320.8
                  ],
                  [
                    51246.3,
                    21303.9
                  ],
                  [
                    51217.5,
                    22233.4
                  ]
                ],
                "id": 1816,
                "chat_link": "[&BBgHAAA=]"
              },
              "1817": {
                "name": "Port Cascadia",
                "level": 80,
                "coord": [
                  51791.2,
                  21263.8
                ],
                "bounds": [
                  [
                    51997.4,
                    20899.7
                  ],
                  [
                    52212.7,
                    20885.7
                  ],
                  [
                    52208.3,
                    21550.5
                  ],
                  [
                    51726.4,
                    21539.7
                  ],
                  [
                    51688,
                    21509.7
                  ],
                  [
                    51661.4,
                    21424.3
                  ],
                  [
                    51578.9,
                    21344.8
                  ],
                  [
                    51511.7,
                    21184.7
                  ],
                  [
                    51535.8,
                    21035.4
                  ],
                  [
                    51997.4,
                    20899.7
                  ]
                ],
                "id": 1817,
                "chat_link": "[&BBkHAAA=]"
              },
              "1818": {
                "name": "Fort Defiance",
                "level": 80,
                "coord": [
                  50699.7,
                  21164.4
                ],
                "bounds": [
                  [
                    50859.3,
                    21053.3
                  ],
                  [
                    50900.2,
                    21222.4
                  ],
                  [
                    50932.7,
                    21289.3
                  ],
                  [
                    50914.7,
                    21360.8
                  ],
                  [
                    50851.6,
                    21437.2
                  ],
                  [
                    50740.4,
                    21518.8
                  ],
                  [
                    50203.3,
                    21353.5
                  ],
                  [
                    50192.6,
                    20790.6
                  ],
                  [
                    50530,
                    20811.7
                  ],
                  [
                    50872.6,
                    20806.2
                  ],
                  [
                    50859.3,
                    21053.3
                  ]
                ],
                "id": 1818,
                "chat_link": "[&BBoHAAA=]"
              },
              "1819": {
                "name": "Wolf's Crossing",
                "level": 80,
                "coord": [
                  51347.7,
                  20683.6
                ],
                "bounds": [
                  [
                    51535.8,
                    21035.4
                  ],
                  [
                    51384.3,
                    20971.1
                  ],
                  [
                    51283.8,
                    20884.3
                  ],
                  [
                    51098.6,
                    20699.5
                  ],
                  [
                    51057.8,
                    20256.6
                  ],
                  [
                    51476,
                    20252.1
                  ],
                  [
                    51597.6,
                    20686.5
                  ],
                  [
                    51535.8,
                    21035.4
                  ]
                ],
                "id": 1819,
                "chat_link": "[&BBsHAAA=]"
              },
              "1820": {
                "name": "Leadfoot Village",
                "level": 80,
                "coord": [
                  50627.1,
                  20418.4
                ],
                "bounds": [
                  [
                    50872.6,
                    20806.2
                  ],
                  [
                    50976,
                    20734.8
                  ],
                  [
                    51098.6,
                    20699.5
                  ],
                  [
                    51057.8,
                    20256.6
                  ],
                  [
                    50756.3,
                    20088
                  ],
                  [
                    50430.5,
                    19916.9
                  ],
                  [
                    50178.9,
                    19901.5
                  ],
                  [
                    50177.6,
                    20178.2
                  ],
                  [
                    50192.6,
                    20790.6
                  ],
                  [
                    50530,
                    20811.7
                  ],
                  [
                    50872.6,
                    20806.2
                  ]
                ],
                "id": 1820,
                "chat_link": "[&BBwHAAA=]"
              },
              "1821": {
                "name": "Petraj Overlook",
                "level": 80,
                "coord": [
                  51696.7,
                  21624.8
                ],
                "bounds": [
                  [
                    51217.5,
                    22233.4
                  ],
                  [
                    52118.9,
                    22235.7
                  ],
                  [
                    52180.4,
                    22205.4
                  ],
                  [
                    52210.6,
                    22148
                  ],
                  [
                    52208.3,
                    21550.5
                  ],
                  [
                    51726.4,
                    21539.7
                  ],
                  [
                    51688,
                    21509.7
                  ],
                  [
                    51661.4,
                    21424.3
                  ],
                  [
                    51578.9,
                    21344.8
                  ],
                  [
                    51511.7,
                    21184.7
                  ],
                  [
                    51402.5,
                    21197.5
                  ],
                  [
                    51305.7,
                    21244.6
                  ],
                  [
                    51246.3,
                    21303.9
                  ],
                  [
                    51217.5,
                    22233.4
                  ]
                ],
                "id": 1821,
                "chat_link": "[&BB0HAAA=]"
              },
              "1822": {
                "name": "Lighthouse Point",
                "level": 80,
                "coord": [
                  51843,
                  20641.5
                ],
                "bounds": [
                  [
                    51535.8,
                    21035.4
                  ],
                  [
                    51997.4,
                    20899.7
                  ],
                  [
                    52212.7,
                    20885.7
                  ],
                  [
                    52238.9,
                    20089.4
                  ],
                  [
                    51476,
                    20252.1
                  ],
                  [
                    51597.6,
                    20686.5
                  ],
                  [
                    51535.8,
                    21035.4
                  ]
                ],
                "id": 1822,
                "chat_link": "[&BB4HAAA=]"
              },
              "1823": {
                "name": "Vloxen Mine",
                "level": 80,
                "coord": [
                  50401.8,
                  21944
                ],
                "bounds": [
                  [
                    50285.6,
                    22218.6
                  ],
                  [
                    50734,
                    22225
                  ],
                  [
                    50740.4,
                    21518.8
                  ],
                  [
                    50203.3,
                    21353.5
                  ],
                  [
                    50213.4,
                    22149.5
                  ],
                  [
                    50233.8,
                    22198.5
                  ],
                  [
                    50285.6,
                    22218.6
                  ]
                ],
                "id": 1823,
                "chat_link": "[&BB8HAAA=]"
              },
              "1825": {
                "name": "Breakroot Basin",
                "level": 80,
                "coord": [
                  51168.4,
                  21084
                ],
                "bounds": [
                  [
                    50859.3,
                    21053.3
                  ],
                  [
                    50900.2,
                    21222.4
                  ],
                  [
                    50932.7,
                    21289.3
                  ],
                  [
                    51056.1,
                    21313
                  ],
                  [
                    51160.9,
                    21320.8
                  ],
                  [
                    51246.3,
                    21303.9
                  ],
                  [
                    51305.7,
                    21244.6
                  ],
                  [
                    51402.5,
                    21197.5
                  ],
                  [
                    51511.7,
                    21184.7
                  ],
                  [
                    51535.8,
                    21035.4
                  ],
                  [
                    51384.3,
                    20971.1
                  ],
                  [
                    51283.8,
                    20884.3
                  ],
                  [
                    51098.6,
                    20699.5
                  ],
                  [
                    50976,
                    20734.8
                  ],
                  [
                    50872.6,
                    20806.2
                  ],
                  [
                    50859.3,
                    21053.3
                  ]
                ],
                "id": 1825,
                "chat_link": "[&BCEHAAA=]"
              }
            },
            "adventures": [],
            "id": 1372,
            "mastery_points": []
          },
          "1373": {
            "name": "Pointed Parley",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              51268,
              21484
            ],
            "map_rect": [
              [
                -24576,
                -52224
              ],
              [
                27648,
                55296
              ]
            ],
            "continent_rect": [
              [
                50128,
                17809
              ],
              [
                52304,
                22289
              ]
            ],
            "points_of_interest": {
              "3147": {
                "name": "Griefshadow Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52075.6,
                  22008.9
                ],
                "id": 3147,
                "chat_link": "[&BEsMAAA=]"
              },
              "3149": {
                "name": "Wolf's Crossing Bridge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51310.1,
                  20512.9
                ],
                "id": 3149,
                "chat_link": "[&BE0MAAA=]"
              },
              "3150": {
                "name": "Greattree Hamlet",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51508.6,
                  21494.9
                ],
                "id": 3150,
                "chat_link": "[&BE4MAAA=]"
              },
              "3151": {
                "name": "Troop Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50778.1,
                  21236
                ],
                "id": 3151,
                "chat_link": "[&BE8MAAA=]"
              },
              "3152": {
                "name": "Submerged Scrapyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52129.3,
                  21158.2
                ],
                "id": 3152,
                "chat_link": "[&BFAMAAA=]"
              },
              "3154": {
                "name": "Leadfoot Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50514.4,
                  20437.3
                ],
                "id": 3154,
                "chat_link": "[&BFIMAAA=]"
              },
              "3155": {
                "name": "Verdant Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50278.6,
                  21094.3
                ],
                "id": 3155,
                "chat_link": "[&BFMMAAA=]"
              },
              "3158": {
                "name": "Port Cascadia",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51788.1,
                  21197.7
                ],
                "id": 3158,
                "chat_link": "[&BFYMAAA=]"
              },
              "3159": {
                "name": "Petraj Commons",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51664.6,
                  21736.1
                ],
                "id": 3159,
                "chat_link": "[&BFcMAAA=]"
              },
              "3161": {
                "name": "Petraj's Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51079,
                  21203.1
                ],
                "id": 3161,
                "chat_link": "[&BFkMAAA=]"
              },
              "3162": {
                "name": "Redsand Strand",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51968.6,
                  20928.3
                ],
                "id": 3162,
                "chat_link": "[&BFoMAAA=]"
              },
              "3166": {
                "name": "Vloxen Mine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50444,
                  21973.4
                ],
                "id": 3166,
                "chat_link": "[&BF4MAAA=]"
              },
              "3167": {
                "name": "United Legions Base Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50950,
                  21987.6
                ],
                "id": 3167,
                "chat_link": "[&BF8MAAA=]"
              },
              "3168": {
                "name": "Iceshard Trail",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50412.3,
                  20024.4
                ],
                "id": 3168,
                "chat_link": "[&BGAMAAA=]"
              },
              "3169": {
                "name": "Griffon's Pillar",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52082.6,
                  21598
                ],
                "id": 3169,
                "chat_link": "[&BGEMAAA=]"
              },
              "3170": {
                "name": "Vloxen Shards",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50630.7,
                  21654.7
                ],
                "id": 3170,
                "chat_link": "[&BGIMAAA=]"
              },
              "3171": {
                "name": "Dwayna's Light",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51994.9,
                  20581.5
                ],
                "id": 3171,
                "chat_link": "[&BGMMAAA=]"
              },
              "3173": {
                "name": "Stone Root",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52007.3,
                  20304.7
                ],
                "id": 3173,
                "chat_link": "[&BGUMAAA=]"
              },
              "3175": {
                "name": "Mistgate Graveyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51743.5,
                  22058.4
                ],
                "id": 3175,
                "chat_link": "[&BGcMAAA=]"
              },
              "3176": {
                "name": "Olafson Farmstead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50263.4,
                  20358.2
                ],
                "id": 3176,
                "chat_link": "[&BGgMAAA=]"
              },
              "3177": {
                "name": "Pavilion of the Legions",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50999.1,
                  22069.5
                ],
                "id": 3177,
                "chat_link": "[&BGkMAAA=]"
              },
              "3179": {
                "name": "Evergreen Pond",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51336.3,
                  20806.2
                ],
                "id": 3179,
                "chat_link": "[&BGsMAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1816": {
                "name": "Umbral Grotto",
                "level": 80,
                "coord": [
                  50983.8,
                  21555.8
                ],
                "bounds": [
                  [
                    51217.5,
                    22233.4
                  ],
                  [
                    50734,
                    22225
                  ],
                  [
                    50740.4,
                    21518.8
                  ],
                  [
                    50851.6,
                    21437.2
                  ],
                  [
                    50914.7,
                    21360.8
                  ],
                  [
                    50932.7,
                    21289.3
                  ],
                  [
                    51056.1,
                    21313
                  ],
                  [
                    51160.9,
                    21320.8
                  ],
                  [
                    51246.3,
                    21303.9
                  ],
                  [
                    51217.5,
                    22233.4
                  ]
                ],
                "id": 1816,
                "chat_link": "[&BBgHAAA=]"
              },
              "1817": {
                "name": "Port Cascadia",
                "level": 80,
                "coord": [
                  51791.2,
                  21263.8
                ],
                "bounds": [
                  [
                    51997.4,
                    20899.7
                  ],
                  [
                    52212.7,
                    20885.7
                  ],
                  [
                    52208.3,
                    21550.5
                  ],
                  [
                    51726.4,
                    21539.7
                  ],
                  [
                    51688,
                    21509.7
                  ],
                  [
                    51661.4,
                    21424.3
                  ],
                  [
                    51578.9,
                    21344.8
                  ],
                  [
                    51511.7,
                    21184.7
                  ],
                  [
                    51535.8,
                    21035.4
                  ],
                  [
                    51997.4,
                    20899.7
                  ]
                ],
                "id": 1817,
                "chat_link": "[&BBkHAAA=]"
              },
              "1818": {
                "name": "Fort Defiance",
                "level": 80,
                "coord": [
                  50699.7,
                  21164.4
                ],
                "bounds": [
                  [
                    50859.3,
                    21053.3
                  ],
                  [
                    50900.2,
                    21222.4
                  ],
                  [
                    50932.7,
                    21289.3
                  ],
                  [
                    50914.7,
                    21360.8
                  ],
                  [
                    50851.6,
                    21437.2
                  ],
                  [
                    50740.4,
                    21518.8
                  ],
                  [
                    50203.3,
                    21353.5
                  ],
                  [
                    50192.6,
                    20790.6
                  ],
                  [
                    50530,
                    20811.7
                  ],
                  [
                    50872.6,
                    20806.2
                  ],
                  [
                    50859.3,
                    21053.3
                  ]
                ],
                "id": 1818,
                "chat_link": "[&BBoHAAA=]"
              },
              "1819": {
                "name": "Wolf's Crossing",
                "level": 80,
                "coord": [
                  51347.7,
                  20683.6
                ],
                "bounds": [
                  [
                    51535.8,
                    21035.4
                  ],
                  [
                    51384.3,
                    20971.1
                  ],
                  [
                    51283.8,
                    20884.3
                  ],
                  [
                    51098.6,
                    20699.5
                  ],
                  [
                    51057.8,
                    20256.6
                  ],
                  [
                    51476,
                    20252.1
                  ],
                  [
                    51597.6,
                    20686.5
                  ],
                  [
                    51535.8,
                    21035.4
                  ]
                ],
                "id": 1819,
                "chat_link": "[&BBsHAAA=]"
              },
              "1820": {
                "name": "Leadfoot Village",
                "level": 80,
                "coord": [
                  50627.1,
                  20418.4
                ],
                "bounds": [
                  [
                    50872.6,
                    20806.2
                  ],
                  [
                    50976,
                    20734.8
                  ],
                  [
                    51098.6,
                    20699.5
                  ],
                  [
                    51057.8,
                    20256.6
                  ],
                  [
                    50756.3,
                    20088
                  ],
                  [
                    50430.5,
                    19916.9
                  ],
                  [
                    50178.9,
                    19901.5
                  ],
                  [
                    50177.6,
                    20178.2
                  ],
                  [
                    50192.6,
                    20790.6
                  ],
                  [
                    50530,
                    20811.7
                  ],
                  [
                    50872.6,
                    20806.2
                  ]
                ],
                "id": 1820,
                "chat_link": "[&BBwHAAA=]"
              },
              "1821": {
                "name": "Petraj Overlook",
                "level": 80,
                "coord": [
                  51696.7,
                  21624.8
                ],
                "bounds": [
                  [
                    51217.5,
                    22233.4
                  ],
                  [
                    52118.9,
                    22235.7
                  ],
                  [
                    52180.4,
                    22205.4
                  ],
                  [
                    52210.6,
                    22148
                  ],
                  [
                    52208.3,
                    21550.5
                  ],
                  [
                    51726.4,
                    21539.7
                  ],
                  [
                    51688,
                    21509.7
                  ],
                  [
                    51661.4,
                    21424.3
                  ],
                  [
                    51578.9,
                    21344.8
                  ],
                  [
                    51511.7,
                    21184.7
                  ],
                  [
                    51402.5,
                    21197.5
                  ],
                  [
                    51305.7,
                    21244.6
                  ],
                  [
                    51246.3,
                    21303.9
                  ],
                  [
                    51217.5,
                    22233.4
                  ]
                ],
                "id": 1821,
                "chat_link": "[&BB0HAAA=]"
              },
              "1822": {
                "name": "Lighthouse Point",
                "level": 80,
                "coord": [
                  51843,
                  20641.5
                ],
                "bounds": [
                  [
                    51535.8,
                    21035.4
                  ],
                  [
                    51997.4,
                    20899.7
                  ],
                  [
                    52212.7,
                    20885.7
                  ],
                  [
                    52238.9,
                    20089.4
                  ],
                  [
                    51476,
                    20252.1
                  ],
                  [
                    51597.6,
                    20686.5
                  ],
                  [
                    51535.8,
                    21035.4
                  ]
                ],
                "id": 1822,
                "chat_link": "[&BB4HAAA=]"
              },
              "1823": {
                "name": "Vloxen Mine",
                "level": 80,
                "coord": [
                  50401.8,
                  21944
                ],
                "bounds": [
                  [
                    50285.6,
                    22218.6
                  ],
                  [
                    50734,
                    22225
                  ],
                  [
                    50740.4,
                    21518.8
                  ],
                  [
                    50203.3,
                    21353.5
                  ],
                  [
                    50213.4,
                    22149.5
                  ],
                  [
                    50233.8,
                    22198.5
                  ],
                  [
                    50285.6,
                    22218.6
                  ]
                ],
                "id": 1823,
                "chat_link": "[&BB8HAAA=]"
              },
              "1825": {
                "name": "Breakroot Basin",
                "level": 80,
                "coord": [
                  51168.4,
                  21084
                ],
                "bounds": [
                  [
                    50859.3,
                    21053.3
                  ],
                  [
                    50900.2,
                    21222.4
                  ],
                  [
                    50932.7,
                    21289.3
                  ],
                  [
                    51056.1,
                    21313
                  ],
                  [
                    51160.9,
                    21320.8
                  ],
                  [
                    51246.3,
                    21303.9
                  ],
                  [
                    51305.7,
                    21244.6
                  ],
                  [
                    51402.5,
                    21197.5
                  ],
                  [
                    51511.7,
                    21184.7
                  ],
                  [
                    51535.8,
                    21035.4
                  ],
                  [
                    51384.3,
                    20971.1
                  ],
                  [
                    51283.8,
                    20884.3
                  ],
                  [
                    51098.6,
                    20699.5
                  ],
                  [
                    50976,
                    20734.8
                  ],
                  [
                    50872.6,
                    20806.2
                  ],
                  [
                    50859.3,
                    21053.3
                  ]
                ],
                "id": 1825,
                "chat_link": "[&BCEHAAA=]"
              }
            },
            "adventures": [],
            "id": 1373,
            "mastery_points": []
          },
          "1375": {
            "name": "Snapping Steel",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              51268,
              21484
            ],
            "map_rect": [
              [
                -24576,
                -52224
              ],
              [
                27648,
                55296
              ]
            ],
            "continent_rect": [
              [
                50128,
                17809
              ],
              [
                52304,
                22289
              ]
            ],
            "points_of_interest": {
              "3147": {
                "name": "Griefshadow Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52075.6,
                  22008.9
                ],
                "id": 3147,
                "chat_link": "[&BEsMAAA=]"
              },
              "3149": {
                "name": "Wolf's Crossing Bridge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51310.1,
                  20512.9
                ],
                "id": 3149,
                "chat_link": "[&BE0MAAA=]"
              },
              "3150": {
                "name": "Greattree Hamlet",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51508.6,
                  21494.9
                ],
                "id": 3150,
                "chat_link": "[&BE4MAAA=]"
              },
              "3151": {
                "name": "Troop Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50778.1,
                  21236
                ],
                "id": 3151,
                "chat_link": "[&BE8MAAA=]"
              },
              "3152": {
                "name": "Submerged Scrapyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52129.3,
                  21158.2
                ],
                "id": 3152,
                "chat_link": "[&BFAMAAA=]"
              },
              "3154": {
                "name": "Leadfoot Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50514.4,
                  20437.3
                ],
                "id": 3154,
                "chat_link": "[&BFIMAAA=]"
              },
              "3155": {
                "name": "Verdant Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50278.6,
                  21094.3
                ],
                "id": 3155,
                "chat_link": "[&BFMMAAA=]"
              },
              "3158": {
                "name": "Port Cascadia",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51788.1,
                  21197.7
                ],
                "id": 3158,
                "chat_link": "[&BFYMAAA=]"
              },
              "3159": {
                "name": "Petraj Commons",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51664.6,
                  21736.1
                ],
                "id": 3159,
                "chat_link": "[&BFcMAAA=]"
              },
              "3161": {
                "name": "Petraj's Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51079,
                  21203.1
                ],
                "id": 3161,
                "chat_link": "[&BFkMAAA=]"
              },
              "3162": {
                "name": "Redsand Strand",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51968.6,
                  20928.3
                ],
                "id": 3162,
                "chat_link": "[&BFoMAAA=]"
              },
              "3166": {
                "name": "Vloxen Mine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50444,
                  21973.4
                ],
                "id": 3166,
                "chat_link": "[&BF4MAAA=]"
              },
              "3167": {
                "name": "United Legions Base Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50950,
                  21987.6
                ],
                "id": 3167,
                "chat_link": "[&BF8MAAA=]"
              },
              "3168": {
                "name": "Iceshard Trail",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50412.3,
                  20024.4
                ],
                "id": 3168,
                "chat_link": "[&BGAMAAA=]"
              },
              "3169": {
                "name": "Griffon's Pillar",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52082.6,
                  21598
                ],
                "id": 3169,
                "chat_link": "[&BGEMAAA=]"
              },
              "3170": {
                "name": "Vloxen Shards",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50630.7,
                  21654.7
                ],
                "id": 3170,
                "chat_link": "[&BGIMAAA=]"
              },
              "3171": {
                "name": "Dwayna's Light",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51994.9,
                  20581.5
                ],
                "id": 3171,
                "chat_link": "[&BGMMAAA=]"
              },
              "3173": {
                "name": "Stone Root",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52007.3,
                  20304.7
                ],
                "id": 3173,
                "chat_link": "[&BGUMAAA=]"
              },
              "3175": {
                "name": "Mistgate Graveyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51743.5,
                  22058.4
                ],
                "id": 3175,
                "chat_link": "[&BGcMAAA=]"
              },
              "3176": {
                "name": "Olafson Farmstead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50263.4,
                  20358.2
                ],
                "id": 3176,
                "chat_link": "[&BGgMAAA=]"
              },
              "3177": {
                "name": "Pavilion of the Legions",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50999.1,
                  22069.5
                ],
                "id": 3177,
                "chat_link": "[&BGkMAAA=]"
              },
              "3179": {
                "name": "Evergreen Pond",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51336.3,
                  20806.2
                ],
                "id": 3179,
                "chat_link": "[&BGsMAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1816": {
                "name": "Umbral Grotto",
                "level": 80,
                "coord": [
                  50983.8,
                  21555.8
                ],
                "bounds": [
                  [
                    51217.5,
                    22233.4
                  ],
                  [
                    50734,
                    22225
                  ],
                  [
                    50740.4,
                    21518.8
                  ],
                  [
                    50851.6,
                    21437.2
                  ],
                  [
                    50914.7,
                    21360.8
                  ],
                  [
                    50932.7,
                    21289.3
                  ],
                  [
                    51056.1,
                    21313
                  ],
                  [
                    51160.9,
                    21320.8
                  ],
                  [
                    51246.3,
                    21303.9
                  ],
                  [
                    51217.5,
                    22233.4
                  ]
                ],
                "id": 1816,
                "chat_link": "[&BBgHAAA=]"
              },
              "1817": {
                "name": "Port Cascadia",
                "level": 80,
                "coord": [
                  51791.2,
                  21263.8
                ],
                "bounds": [
                  [
                    51997.4,
                    20899.7
                  ],
                  [
                    52212.7,
                    20885.7
                  ],
                  [
                    52208.3,
                    21550.5
                  ],
                  [
                    51726.4,
                    21539.7
                  ],
                  [
                    51688,
                    21509.7
                  ],
                  [
                    51661.4,
                    21424.3
                  ],
                  [
                    51578.9,
                    21344.8
                  ],
                  [
                    51511.7,
                    21184.7
                  ],
                  [
                    51535.8,
                    21035.4
                  ],
                  [
                    51997.4,
                    20899.7
                  ]
                ],
                "id": 1817,
                "chat_link": "[&BBkHAAA=]"
              },
              "1818": {
                "name": "Fort Defiance",
                "level": 80,
                "coord": [
                  50699.7,
                  21164.4
                ],
                "bounds": [
                  [
                    50859.3,
                    21053.3
                  ],
                  [
                    50900.2,
                    21222.4
                  ],
                  [
                    50932.7,
                    21289.3
                  ],
                  [
                    50914.7,
                    21360.8
                  ],
                  [
                    50851.6,
                    21437.2
                  ],
                  [
                    50740.4,
                    21518.8
                  ],
                  [
                    50203.3,
                    21353.5
                  ],
                  [
                    50192.6,
                    20790.6
                  ],
                  [
                    50530,
                    20811.7
                  ],
                  [
                    50872.6,
                    20806.2
                  ],
                  [
                    50859.3,
                    21053.3
                  ]
                ],
                "id": 1818,
                "chat_link": "[&BBoHAAA=]"
              },
              "1819": {
                "name": "Wolf's Crossing",
                "level": 80,
                "coord": [
                  51347.7,
                  20683.6
                ],
                "bounds": [
                  [
                    51535.8,
                    21035.4
                  ],
                  [
                    51384.3,
                    20971.1
                  ],
                  [
                    51283.8,
                    20884.3
                  ],
                  [
                    51098.6,
                    20699.5
                  ],
                  [
                    51057.8,
                    20256.6
                  ],
                  [
                    51476,
                    20252.1
                  ],
                  [
                    51597.6,
                    20686.5
                  ],
                  [
                    51535.8,
                    21035.4
                  ]
                ],
                "id": 1819,
                "chat_link": "[&BBsHAAA=]"
              },
              "1820": {
                "name": "Leadfoot Village",
                "level": 80,
                "coord": [
                  50627.1,
                  20418.4
                ],
                "bounds": [
                  [
                    50872.6,
                    20806.2
                  ],
                  [
                    50976,
                    20734.8
                  ],
                  [
                    51098.6,
                    20699.5
                  ],
                  [
                    51057.8,
                    20256.6
                  ],
                  [
                    50756.3,
                    20088
                  ],
                  [
                    50430.5,
                    19916.9
                  ],
                  [
                    50178.9,
                    19901.5
                  ],
                  [
                    50177.6,
                    20178.2
                  ],
                  [
                    50192.6,
                    20790.6
                  ],
                  [
                    50530,
                    20811.7
                  ],
                  [
                    50872.6,
                    20806.2
                  ]
                ],
                "id": 1820,
                "chat_link": "[&BBwHAAA=]"
              },
              "1821": {
                "name": "Petraj Overlook",
                "level": 80,
                "coord": [
                  51696.7,
                  21624.8
                ],
                "bounds": [
                  [
                    51217.5,
                    22233.4
                  ],
                  [
                    52118.9,
                    22235.7
                  ],
                  [
                    52180.4,
                    22205.4
                  ],
                  [
                    52210.6,
                    22148
                  ],
                  [
                    52208.3,
                    21550.5
                  ],
                  [
                    51726.4,
                    21539.7
                  ],
                  [
                    51688,
                    21509.7
                  ],
                  [
                    51661.4,
                    21424.3
                  ],
                  [
                    51578.9,
                    21344.8
                  ],
                  [
                    51511.7,
                    21184.7
                  ],
                  [
                    51402.5,
                    21197.5
                  ],
                  [
                    51305.7,
                    21244.6
                  ],
                  [
                    51246.3,
                    21303.9
                  ],
                  [
                    51217.5,
                    22233.4
                  ]
                ],
                "id": 1821,
                "chat_link": "[&BB0HAAA=]"
              },
              "1822": {
                "name": "Lighthouse Point",
                "level": 80,
                "coord": [
                  51843,
                  20641.5
                ],
                "bounds": [
                  [
                    51535.8,
                    21035.4
                  ],
                  [
                    51997.4,
                    20899.7
                  ],
                  [
                    52212.7,
                    20885.7
                  ],
                  [
                    52238.9,
                    20089.4
                  ],
                  [
                    51476,
                    20252.1
                  ],
                  [
                    51597.6,
                    20686.5
                  ],
                  [
                    51535.8,
                    21035.4
                  ]
                ],
                "id": 1822,
                "chat_link": "[&BB4HAAA=]"
              },
              "1823": {
                "name": "Vloxen Mine",
                "level": 80,
                "coord": [
                  50401.8,
                  21944
                ],
                "bounds": [
                  [
                    50285.6,
                    22218.6
                  ],
                  [
                    50734,
                    22225
                  ],
                  [
                    50740.4,
                    21518.8
                  ],
                  [
                    50203.3,
                    21353.5
                  ],
                  [
                    50213.4,
                    22149.5
                  ],
                  [
                    50233.8,
                    22198.5
                  ],
                  [
                    50285.6,
                    22218.6
                  ]
                ],
                "id": 1823,
                "chat_link": "[&BB8HAAA=]"
              },
              "1825": {
                "name": "Breakroot Basin",
                "level": 80,
                "coord": [
                  51168.4,
                  21084
                ],
                "bounds": [
                  [
                    50859.3,
                    21053.3
                  ],
                  [
                    50900.2,
                    21222.4
                  ],
                  [
                    50932.7,
                    21289.3
                  ],
                  [
                    51056.1,
                    21313
                  ],
                  [
                    51160.9,
                    21320.8
                  ],
                  [
                    51246.3,
                    21303.9
                  ],
                  [
                    51305.7,
                    21244.6
                  ],
                  [
                    51402.5,
                    21197.5
                  ],
                  [
                    51511.7,
                    21184.7
                  ],
                  [
                    51535.8,
                    21035.4
                  ],
                  [
                    51384.3,
                    20971.1
                  ],
                  [
                    51283.8,
                    20884.3
                  ],
                  [
                    51098.6,
                    20699.5
                  ],
                  [
                    50976,
                    20734.8
                  ],
                  [
                    50872.6,
                    20806.2
                  ],
                  [
                    50859.3,
                    21053.3
                  ]
                ],
                "id": 1825,
                "chat_link": "[&BCEHAAA=]"
              }
            },
            "adventures": [],
            "id": 1375,
            "mastery_points": []
          },
          "1378": {
            "name": "Behind Enemy Lines",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              51268,
              20084
            ],
            "map_rect": [
              [
                -24576,
                -52224
              ],
              [
                27648,
                55296
              ]
            ],
            "continent_rect": [
              [
                50128,
                17809
              ],
              [
                52304,
                22289
              ]
            ],
            "points_of_interest": {
              "3180": {
                "name": "Veins of Jormag",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51405.8,
                  18923.9
                ],
                "id": 3180,
                "chat_link": "[&BGwMAAA=]"
              },
              "3181": {
                "name": "Thermal Vent",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50403.3,
                  18950.5
                ],
                "id": 3181,
                "chat_link": "[&BG0MAAA=]"
              },
              "3183": {
                "name": "Archstone Dominion Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51631.9,
                  19499.8
                ],
                "id": 3183,
                "chat_link": "[&BG8MAAA=]"
              },
              "3184": {
                "name": "Iceblood Channel",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51439.1,
                  18168.1
                ],
                "id": 3184,
                "chat_link": "[&BHAMAAA=]"
              },
              "3187": {
                "name": "Sanctum of the Wild",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50632.6,
                  18480.6
                ],
                "id": 3187,
                "chat_link": "[&BHMMAAA=]"
              },
              "3188": {
                "name": "The Spire",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51587.8,
                  18297.1
                ],
                "id": 3188,
                "chat_link": "[&BHQMAAA=]"
              },
              "3189": {
                "name": "Iron Lookout",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51080.7,
                  18901.4
                ],
                "id": 3189,
                "chat_link": "[&BHUMAAA=]"
              },
              "3191": {
                "name": "Canopy Overlook",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51288.5,
                  19466.3
                ],
                "id": 3191,
                "chat_link": "[&BHcMAAA=]"
              },
              "3193": {
                "name": "United Legions Forward Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50423.2,
                  19428.1
                ],
                "id": 3193,
                "chat_link": "[&BHkMAAA=]"
              },
              "3194": {
                "name": "Sniper's Slope",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51227.1,
                  19829.4
                ],
                "id": 3194,
                "chat_link": "[&BHoMAAA=]"
              },
              "3195": {
                "name": "Ice Dragon's Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51120.7,
                  18371.7
                ],
                "id": 3195,
                "chat_link": "[&BHsMAAA=]"
              },
              "3196": {
                "name": "Shoreline Dominion Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51493.7,
                  19838.2
                ],
                "id": 3196,
                "chat_link": "[&BHwMAAA=]"
              },
              "3198": {
                "name": "Frostvein Dominion Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51682.1,
                  19056.4
                ],
                "id": 3198,
                "chat_link": "[&BH4MAAA=]"
              },
              "3199": {
                "name": "Cavern Entryway",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50821.8,
                  18734
                ],
                "id": 3199,
                "chat_link": "[&BH8MAAA=]"
              },
              "3200": {
                "name": "Stone Archways",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51950.9,
                  19619.8
                ],
                "id": 3200,
                "chat_link": "[&BIAMAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1827": {
                "name": "Archstone Coast",
                "level": 80,
                "coord": [
                  51685.4,
                  19733.3
                ],
                "bounds": [
                  [
                    52234.2,
                    19273.4
                  ],
                  [
                    52238.9,
                    20089.4
                  ],
                  [
                    51476,
                    20252.1
                  ],
                  [
                    51390.8,
                    19901.3
                  ],
                  [
                    51421.6,
                    19762.5
                  ],
                  [
                    51508.9,
                    19530.1
                  ],
                  [
                    51527.8,
                    19324.5
                  ],
                  [
                    52234.2,
                    19273.4
                  ]
                ],
                "id": 1827,
                "chat_link": "[&BCMHAAA=]"
              },
              "1828": {
                "name": "Canopy Crag",
                "level": 80,
                "coord": [
                  51250.9,
                  19602.7
                ],
                "bounds": [
                  [
                    51527.8,
                    19324.5
                  ],
                  [
                    51508.9,
                    19530.1
                  ],
                  [
                    51421.6,
                    19762.5
                  ],
                  [
                    51390.8,
                    19901.3
                  ],
                  [
                    51039.9,
                    19904.7
                  ],
                  [
                    51016.5,
                    19642.7
                  ],
                  [
                    51033.3,
                    19444.4
                  ],
                  [
                    51068.4,
                    19311.4
                  ],
                  [
                    51527.8,
                    19324.5
                  ]
                ],
                "id": 1828,
                "chat_link": "[&BCQHAAA=]"
              },
              "1830": {
                "name": "Cavern of Guiding Spirits",
                "level": 80,
                "coord": [
                  50521.7,
                  18818.4
                ],
                "bounds": [
                  [
                    50181.8,
                    18310.2
                  ],
                  [
                    50827.5,
                    18532
                  ],
                  [
                    50859.4,
                    18711.1
                  ],
                  [
                    50547.3,
                    19259.3
                  ],
                  [
                    50192.5,
                    19279.3
                  ],
                  [
                    50181.8,
                    18310.2
                  ]
                ],
                "id": 1830,
                "chat_link": "[&BCYHAAA=]"
              },
              "1831": {
                "name": "Dominion's Breach",
                "level": 80,
                "coord": [
                  51241.1,
                  20078.7
                ],
                "bounds": [
                  [
                    51390.8,
                    19901.3
                  ],
                  [
                    51476,
                    20252.1
                  ],
                  [
                    51057.8,
                    20256.6
                  ],
                  [
                    51039.9,
                    19904.7
                  ],
                  [
                    51390.8,
                    19901.3
                  ]
                ],
                "id": 1831,
                "chat_link": "[&BCcHAAA=]"
              },
              "1832": {
                "name": "Frost Citadel",
                "level": 80,
                "coord": [
                  50789.8,
                  18185.2
                ],
                "bounds": [
                  [
                    50293.3,
                    17933.1
                  ],
                  [
                    50429.7,
                    17863.6
                  ],
                  [
                    51394.4,
                    17878.6
                  ],
                  [
                    51374.3,
                    18238.2
                  ],
                  [
                    51311.6,
                    18386.4
                  ],
                  [
                    51080.1,
                    18482.8
                  ],
                  [
                    50827.5,
                    18532
                  ],
                  [
                    50181.8,
                    18310.2
                  ],
                  [
                    50215.7,
                    18041.8
                  ],
                  [
                    50293.3,
                    17933.1
                  ]
                ],
                "id": 1832,
                "chat_link": "[&BCgHAAA=]"
              },
              "1833": {
                "name": "Legions' Alcove",
                "level": 80,
                "coord": [
                  50337.3,
                  19589.3
                ],
                "bounds": [
                  [
                    50192.5,
                    19279.3
                  ],
                  [
                    50547.3,
                    19259.3
                  ],
                  [
                    50430.5,
                    19916.9
                  ],
                  [
                    50178.9,
                    19901.5
                  ],
                  [
                    50192.5,
                    19279.3
                  ]
                ],
                "id": 1833,
                "chat_link": "[&BCkHAAA=]"
              },
              "1834": {
                "name": "Frostvein Watch",
                "level": 80,
                "coord": [
                  51591.2,
                  19127.1
                ],
                "bounds": [
                  [
                    52211.1,
                    18928.3
                  ],
                  [
                    52234.2,
                    19273.4
                  ],
                  [
                    51527.8,
                    19324.5
                  ],
                  [
                    51068.4,
                    19311.4
                  ],
                  [
                    51200.8,
                    19108.3
                  ],
                  [
                    51213,
                    18993.8
                  ],
                  [
                    51683.3,
                    18949.7
                  ],
                  [
                    52211.1,
                    18928.3
                  ]
                ],
                "id": 1834,
                "chat_link": "[&BCoHAAA=]"
              },
              "1836": {
                "name": "Sentinel Bay",
                "level": 80,
                "coord": [
                  50868.7,
                  19728
                ],
                "bounds": [
                  [
                    50430.5,
                    19916.9
                  ],
                  [
                    50547.3,
                    19259.3
                  ],
                  [
                    51068.4,
                    19311.4
                  ],
                  [
                    51033.3,
                    19444.4
                  ],
                  [
                    51016.5,
                    19642.7
                  ],
                  [
                    51039.9,
                    19904.7
                  ],
                  [
                    51057.8,
                    20256.6
                  ],
                  [
                    50756.3,
                    20088
                  ],
                  [
                    50430.5,
                    19916.9
                  ]
                ],
                "id": 1836,
                "chat_link": "[&BCwHAAA=]"
              },
              "1837": {
                "name": "Drizzlewood Peak",
                "level": 80,
                "coord": [
                  50993,
                  19038.9
                ],
                "bounds": [
                  [
                    51213,
                    18993.8
                  ],
                  [
                    51200.8,
                    19108.3
                  ],
                  [
                    51068.4,
                    19311.4
                  ],
                  [
                    50547.3,
                    19259.3
                  ],
                  [
                    50859.4,
                    18711.1
                  ],
                  [
                    51069.1,
                    18849.3
                  ],
                  [
                    51213,
                    18993.8
                  ]
                ],
                "id": 1837,
                "chat_link": "[&BC0HAAA=]"
              },
              "1838": {
                "name": "The Bloodfield",
                "level": 80,
                "coord": [
                  51397.8,
                  18684.4
                ],
                "bounds": [
                  [
                    52155.5,
                    18544.1
                  ],
                  [
                    52211.1,
                    18928.3
                  ],
                  [
                    51683.3,
                    18949.7
                  ],
                  [
                    51213,
                    18993.8
                  ],
                  [
                    51069.1,
                    18849.3
                  ],
                  [
                    50859.4,
                    18711.1
                  ],
                  [
                    50827.5,
                    18532
                  ],
                  [
                    51080.1,
                    18482.8
                  ],
                  [
                    51311.6,
                    18386.4
                  ],
                  [
                    51567.4,
                    18466.6
                  ],
                  [
                    52155.5,
                    18544.1
                  ]
                ],
                "id": 1838,
                "chat_link": "[&BC4HAAA=]"
              },
              "1839": {
                "name": "Claw's Roost",
                "level": 80,
                "coord": [
                  51715.9,
                  18223.4
                ],
                "bounds": [
                  [
                    51394.4,
                    17878.6
                  ],
                  [
                    51857.8,
                    17963.8
                  ],
                  [
                    51992.1,
                    18067.6
                  ],
                  [
                    52074.2,
                    18241.5
                  ],
                  [
                    52155.5,
                    18544.1
                  ],
                  [
                    51567.4,
                    18466.6
                  ],
                  [
                    51311.6,
                    18386.4
                  ],
                  [
                    51374.3,
                    18238.2
                  ],
                  [
                    51394.4,
                    17878.6
                  ]
                ],
                "id": 1839,
                "chat_link": "[&BC8HAAA=]"
              }
            },
            "adventures": [],
            "id": 1378,
            "mastery_points": []
          },
          "1379": {
            "name": "One Charr, One Dragon, One Champion",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 0,
            "label_coord": [
              51268,
              21484
            ],
            "map_rect": [
              [
                -24576,
                -52224
              ],
              [
                27648,
                55296
              ]
            ],
            "continent_rect": [
              [
                50128,
                17809
              ],
              [
                52304,
                22289
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1832": {
                "name": "Frost Citadel",
                "level": 80,
                "coord": [
                  50789.8,
                  18185.2
                ],
                "bounds": [
                  [
                    50293.3,
                    17933.1
                  ],
                  [
                    50429.7,
                    17863.6
                  ],
                  [
                    51394.4,
                    17878.6
                  ],
                  [
                    51374.3,
                    18238.2
                  ],
                  [
                    51311.6,
                    18386.4
                  ],
                  [
                    51080.1,
                    18482.8
                  ],
                  [
                    50827.5,
                    18532
                  ],
                  [
                    50181.8,
                    18310.2
                  ],
                  [
                    50215.7,
                    18041.8
                  ],
                  [
                    50293.3,
                    17933.1
                  ]
                ],
                "id": 1832,
                "chat_link": "[&BCgHAAA=]"
              }
            },
            "adventures": [],
            "id": 1379,
            "mastery_points": []
          },
          "1380": {
            "name": "Epilogue",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              57984,
              21504
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                57344,
                21248
              ],
              [
                58624,
                22528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1380,
            "mastery_points": []
          },
          "1382": {
            "name": "Arena of the Wolverine",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              51268,
              21484
            ],
            "map_rect": [
              [
                -24576,
                -52224
              ],
              [
                27648,
                55296
              ]
            ],
            "continent_rect": [
              [
                50128,
                17809
              ],
              [
                52304,
                22289
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1827": {
                "name": "Archstone Coast",
                "level": 80,
                "coord": [
                  51685.4,
                  19733.3
                ],
                "bounds": [
                  [
                    52234.2,
                    19273.4
                  ],
                  [
                    52238.9,
                    20089.4
                  ],
                  [
                    51476,
                    20252.1
                  ],
                  [
                    51390.8,
                    19901.3
                  ],
                  [
                    51421.6,
                    19762.5
                  ],
                  [
                    51508.9,
                    19530.1
                  ],
                  [
                    51527.8,
                    19324.5
                  ],
                  [
                    52234.2,
                    19273.4
                  ]
                ],
                "id": 1827,
                "chat_link": "[&BCMHAAA=]"
              },
              "1828": {
                "name": "Canopy Crag",
                "level": 80,
                "coord": [
                  51250.9,
                  19602.7
                ],
                "bounds": [
                  [
                    51527.8,
                    19324.5
                  ],
                  [
                    51508.9,
                    19530.1
                  ],
                  [
                    51421.6,
                    19762.5
                  ],
                  [
                    51390.8,
                    19901.3
                  ],
                  [
                    51039.9,
                    19904.7
                  ],
                  [
                    51016.5,
                    19642.7
                  ],
                  [
                    51033.3,
                    19444.4
                  ],
                  [
                    51068.4,
                    19311.4
                  ],
                  [
                    51527.8,
                    19324.5
                  ]
                ],
                "id": 1828,
                "chat_link": "[&BCQHAAA=]"
              },
              "1830": {
                "name": "Cavern of Guiding Spirits",
                "level": 80,
                "coord": [
                  50521.7,
                  18818.4
                ],
                "bounds": [
                  [
                    50181.8,
                    18310.2
                  ],
                  [
                    50827.5,
                    18532
                  ],
                  [
                    50859.4,
                    18711.1
                  ],
                  [
                    50547.3,
                    19259.3
                  ],
                  [
                    50192.5,
                    19279.3
                  ],
                  [
                    50181.8,
                    18310.2
                  ]
                ],
                "id": 1830,
                "chat_link": "[&BCYHAAA=]"
              },
              "1831": {
                "name": "Dominion's Breach",
                "level": 80,
                "coord": [
                  51241.1,
                  20078.7
                ],
                "bounds": [
                  [
                    51390.8,
                    19901.3
                  ],
                  [
                    51476,
                    20252.1
                  ],
                  [
                    51057.8,
                    20256.6
                  ],
                  [
                    51039.9,
                    19904.7
                  ],
                  [
                    51390.8,
                    19901.3
                  ]
                ],
                "id": 1831,
                "chat_link": "[&BCcHAAA=]"
              },
              "1832": {
                "name": "Frost Citadel",
                "level": 80,
                "coord": [
                  50789.8,
                  18185.2
                ],
                "bounds": [
                  [
                    50293.3,
                    17933.1
                  ],
                  [
                    50429.7,
                    17863.6
                  ],
                  [
                    51394.4,
                    17878.6
                  ],
                  [
                    51374.3,
                    18238.2
                  ],
                  [
                    51311.6,
                    18386.4
                  ],
                  [
                    51080.1,
                    18482.8
                  ],
                  [
                    50827.5,
                    18532
                  ],
                  [
                    50181.8,
                    18310.2
                  ],
                  [
                    50215.7,
                    18041.8
                  ],
                  [
                    50293.3,
                    17933.1
                  ]
                ],
                "id": 1832,
                "chat_link": "[&BCgHAAA=]"
              },
              "1833": {
                "name": "Legions' Alcove",
                "level": 80,
                "coord": [
                  50337.3,
                  19589.3
                ],
                "bounds": [
                  [
                    50192.5,
                    19279.3
                  ],
                  [
                    50547.3,
                    19259.3
                  ],
                  [
                    50430.5,
                    19916.9
                  ],
                  [
                    50178.9,
                    19901.5
                  ],
                  [
                    50192.5,
                    19279.3
                  ]
                ],
                "id": 1833,
                "chat_link": "[&BCkHAAA=]"
              },
              "1834": {
                "name": "Frostvein Watch",
                "level": 80,
                "coord": [
                  51591.2,
                  19127.1
                ],
                "bounds": [
                  [
                    52211.1,
                    18928.3
                  ],
                  [
                    52234.2,
                    19273.4
                  ],
                  [
                    51527.8,
                    19324.5
                  ],
                  [
                    51068.4,
                    19311.4
                  ],
                  [
                    51200.8,
                    19108.3
                  ],
                  [
                    51213,
                    18993.8
                  ],
                  [
                    51683.3,
                    18949.7
                  ],
                  [
                    52211.1,
                    18928.3
                  ]
                ],
                "id": 1834,
                "chat_link": "[&BCoHAAA=]"
              },
              "1836": {
                "name": "Sentinel Bay",
                "level": 80,
                "coord": [
                  50868.7,
                  19728
                ],
                "bounds": [
                  [
                    50430.5,
                    19916.9
                  ],
                  [
                    50547.3,
                    19259.3
                  ],
                  [
                    51068.4,
                    19311.4
                  ],
                  [
                    51033.3,
                    19444.4
                  ],
                  [
                    51016.5,
                    19642.7
                  ],
                  [
                    51039.9,
                    19904.7
                  ],
                  [
                    51057.8,
                    20256.6
                  ],
                  [
                    50756.3,
                    20088
                  ],
                  [
                    50430.5,
                    19916.9
                  ]
                ],
                "id": 1836,
                "chat_link": "[&BCwHAAA=]"
              },
              "1837": {
                "name": "Drizzlewood Peak",
                "level": 80,
                "coord": [
                  50993,
                  19038.9
                ],
                "bounds": [
                  [
                    51213,
                    18993.8
                  ],
                  [
                    51200.8,
                    19108.3
                  ],
                  [
                    51068.4,
                    19311.4
                  ],
                  [
                    50547.3,
                    19259.3
                  ],
                  [
                    50859.4,
                    18711.1
                  ],
                  [
                    51069.1,
                    18849.3
                  ],
                  [
                    51213,
                    18993.8
                  ]
                ],
                "id": 1837,
                "chat_link": "[&BC0HAAA=]"
              },
              "1838": {
                "name": "The Bloodfield",
                "level": 80,
                "coord": [
                  51397.8,
                  18684.4
                ],
                "bounds": [
                  [
                    52155.5,
                    18544.1
                  ],
                  [
                    52211.1,
                    18928.3
                  ],
                  [
                    51683.3,
                    18949.7
                  ],
                  [
                    51213,
                    18993.8
                  ],
                  [
                    51069.1,
                    18849.3
                  ],
                  [
                    50859.4,
                    18711.1
                  ],
                  [
                    50827.5,
                    18532
                  ],
                  [
                    51080.1,
                    18482.8
                  ],
                  [
                    51311.6,
                    18386.4
                  ],
                  [
                    51567.4,
                    18466.6
                  ],
                  [
                    52155.5,
                    18544.1
                  ]
                ],
                "id": 1838,
                "chat_link": "[&BC4HAAA=]"
              },
              "1839": {
                "name": "Claw's Roost",
                "level": 80,
                "coord": [
                  51715.9,
                  18223.4
                ],
                "bounds": [
                  [
                    51394.4,
                    17878.6
                  ],
                  [
                    51857.8,
                    17963.8
                  ],
                  [
                    51992.1,
                    18067.6
                  ],
                  [
                    52074.2,
                    18241.5
                  ],
                  [
                    52155.5,
                    18544.1
                  ],
                  [
                    51567.4,
                    18466.6
                  ],
                  [
                    51311.6,
                    18386.4
                  ],
                  [
                    51374.3,
                    18238.2
                  ],
                  [
                    51394.4,
                    17878.6
                  ]
                ],
                "id": 1839,
                "chat_link": "[&BC8HAAA=]"
              }
            },
            "adventures": [],
            "id": 1382,
            "mastery_points": []
          },
          "1383": {
            "name": "A Simple Negotiation",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              18500,
              3700
            ],
            "map_rect": [
              [
                -24576,
                -52224
              ],
              [
                27648,
                55296
              ]
            ],
            "continent_rect": [
              [
                50128,
                17809
              ],
              [
                52304,
                22289
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1827": {
                "name": "Archstone Coast",
                "level": 80,
                "coord": [
                  51685.4,
                  19733.3
                ],
                "bounds": [
                  [
                    52234.2,
                    19273.4
                  ],
                  [
                    52238.9,
                    20089.4
                  ],
                  [
                    51476,
                    20252.1
                  ],
                  [
                    51390.8,
                    19901.3
                  ],
                  [
                    51421.6,
                    19762.5
                  ],
                  [
                    51508.9,
                    19530.1
                  ],
                  [
                    51527.8,
                    19324.5
                  ],
                  [
                    52234.2,
                    19273.4
                  ]
                ],
                "id": 1827,
                "chat_link": "[&BCMHAAA=]"
              },
              "1828": {
                "name": "Canopy Crag",
                "level": 80,
                "coord": [
                  51250.9,
                  19602.7
                ],
                "bounds": [
                  [
                    51527.8,
                    19324.5
                  ],
                  [
                    51508.9,
                    19530.1
                  ],
                  [
                    51421.6,
                    19762.5
                  ],
                  [
                    51390.8,
                    19901.3
                  ],
                  [
                    51039.9,
                    19904.7
                  ],
                  [
                    51016.5,
                    19642.7
                  ],
                  [
                    51033.3,
                    19444.4
                  ],
                  [
                    51068.4,
                    19311.4
                  ],
                  [
                    51527.8,
                    19324.5
                  ]
                ],
                "id": 1828,
                "chat_link": "[&BCQHAAA=]"
              },
              "1830": {
                "name": "Cavern of Guiding Spirits",
                "level": 80,
                "coord": [
                  50521.7,
                  18818.4
                ],
                "bounds": [
                  [
                    50181.8,
                    18310.2
                  ],
                  [
                    50827.5,
                    18532
                  ],
                  [
                    50859.4,
                    18711.1
                  ],
                  [
                    50547.3,
                    19259.3
                  ],
                  [
                    50192.5,
                    19279.3
                  ],
                  [
                    50181.8,
                    18310.2
                  ]
                ],
                "id": 1830,
                "chat_link": "[&BCYHAAA=]"
              },
              "1831": {
                "name": "Dominion's Breach",
                "level": 80,
                "coord": [
                  51241.1,
                  20078.7
                ],
                "bounds": [
                  [
                    51390.8,
                    19901.3
                  ],
                  [
                    51476,
                    20252.1
                  ],
                  [
                    51057.8,
                    20256.6
                  ],
                  [
                    51039.9,
                    19904.7
                  ],
                  [
                    51390.8,
                    19901.3
                  ]
                ],
                "id": 1831,
                "chat_link": "[&BCcHAAA=]"
              },
              "1832": {
                "name": "Frost Citadel",
                "level": 80,
                "coord": [
                  50789.8,
                  18185.2
                ],
                "bounds": [
                  [
                    50293.3,
                    17933.1
                  ],
                  [
                    50429.7,
                    17863.6
                  ],
                  [
                    51394.4,
                    17878.6
                  ],
                  [
                    51374.3,
                    18238.2
                  ],
                  [
                    51311.6,
                    18386.4
                  ],
                  [
                    51080.1,
                    18482.8
                  ],
                  [
                    50827.5,
                    18532
                  ],
                  [
                    50181.8,
                    18310.2
                  ],
                  [
                    50215.7,
                    18041.8
                  ],
                  [
                    50293.3,
                    17933.1
                  ]
                ],
                "id": 1832,
                "chat_link": "[&BCgHAAA=]"
              },
              "1833": {
                "name": "Legions' Alcove",
                "level": 80,
                "coord": [
                  50337.3,
                  19589.3
                ],
                "bounds": [
                  [
                    50192.5,
                    19279.3
                  ],
                  [
                    50547.3,
                    19259.3
                  ],
                  [
                    50430.5,
                    19916.9
                  ],
                  [
                    50178.9,
                    19901.5
                  ],
                  [
                    50192.5,
                    19279.3
                  ]
                ],
                "id": 1833,
                "chat_link": "[&BCkHAAA=]"
              },
              "1834": {
                "name": "Frostvein Watch",
                "level": 80,
                "coord": [
                  51591.2,
                  19127.1
                ],
                "bounds": [
                  [
                    52211.1,
                    18928.3
                  ],
                  [
                    52234.2,
                    19273.4
                  ],
                  [
                    51527.8,
                    19324.5
                  ],
                  [
                    51068.4,
                    19311.4
                  ],
                  [
                    51200.8,
                    19108.3
                  ],
                  [
                    51213,
                    18993.8
                  ],
                  [
                    51683.3,
                    18949.7
                  ],
                  [
                    52211.1,
                    18928.3
                  ]
                ],
                "id": 1834,
                "chat_link": "[&BCoHAAA=]"
              },
              "1836": {
                "name": "Sentinel Bay",
                "level": 80,
                "coord": [
                  50868.7,
                  19728
                ],
                "bounds": [
                  [
                    50430.5,
                    19916.9
                  ],
                  [
                    50547.3,
                    19259.3
                  ],
                  [
                    51068.4,
                    19311.4
                  ],
                  [
                    51033.3,
                    19444.4
                  ],
                  [
                    51016.5,
                    19642.7
                  ],
                  [
                    51039.9,
                    19904.7
                  ],
                  [
                    51057.8,
                    20256.6
                  ],
                  [
                    50756.3,
                    20088
                  ],
                  [
                    50430.5,
                    19916.9
                  ]
                ],
                "id": 1836,
                "chat_link": "[&BCwHAAA=]"
              },
              "1837": {
                "name": "Drizzlewood Peak",
                "level": 80,
                "coord": [
                  50993,
                  19038.9
                ],
                "bounds": [
                  [
                    51213,
                    18993.8
                  ],
                  [
                    51200.8,
                    19108.3
                  ],
                  [
                    51068.4,
                    19311.4
                  ],
                  [
                    50547.3,
                    19259.3
                  ],
                  [
                    50859.4,
                    18711.1
                  ],
                  [
                    51069.1,
                    18849.3
                  ],
                  [
                    51213,
                    18993.8
                  ]
                ],
                "id": 1837,
                "chat_link": "[&BC0HAAA=]"
              },
              "1838": {
                "name": "The Bloodfield",
                "level": 80,
                "coord": [
                  51397.8,
                  18684.4
                ],
                "bounds": [
                  [
                    52155.5,
                    18544.1
                  ],
                  [
                    52211.1,
                    18928.3
                  ],
                  [
                    51683.3,
                    18949.7
                  ],
                  [
                    51213,
                    18993.8
                  ],
                  [
                    51069.1,
                    18849.3
                  ],
                  [
                    50859.4,
                    18711.1
                  ],
                  [
                    50827.5,
                    18532
                  ],
                  [
                    51080.1,
                    18482.8
                  ],
                  [
                    51311.6,
                    18386.4
                  ],
                  [
                    51567.4,
                    18466.6
                  ],
                  [
                    52155.5,
                    18544.1
                  ]
                ],
                "id": 1838,
                "chat_link": "[&BC4HAAA=]"
              },
              "1839": {
                "name": "Claw's Roost",
                "level": 80,
                "coord": [
                  51715.9,
                  18223.4
                ],
                "bounds": [
                  [
                    51394.4,
                    17878.6
                  ],
                  [
                    51857.8,
                    17963.8
                  ],
                  [
                    51992.1,
                    18067.6
                  ],
                  [
                    52074.2,
                    18241.5
                  ],
                  [
                    52155.5,
                    18544.1
                  ],
                  [
                    51567.4,
                    18466.6
                  ],
                  [
                    51311.6,
                    18386.4
                  ],
                  [
                    51374.3,
                    18238.2
                  ],
                  [
                    51394.4,
                    17878.6
                  ]
                ],
                "id": 1839,
                "chat_link": "[&BC8HAAA=]"
              }
            },
            "adventures": [],
            "id": 1383,
            "mastery_points": []
          },
          "1433": {
            "name": "Old Friends",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              18560,
              15744
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                27648
              ]
            ],
            "continent_rect": [
              [
                50432,
                31484
              ],
              [
                51968,
                33660
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1433,
            "mastery_points": []
          },
          "1466": {
            "name": "A Quiet Celebration—Knut Whitebear's Loft",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 2,
            "label_coord": [
              52224,
              29696
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1466,
            "mastery_points": []
          },
          "1468": {
            "name": "The Battle for Cragstead—Knut Whitebear's Loft",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 2,
            "label_coord": [
              52224,
              29696
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1468,
            "mastery_points": []
          }
        },
        "id": 1
      },
      "2": {
        "name": "Ascalon",
        "label_coord": [
          59648,
          28928
        ],
        "continent_rect": [
          [
            56320,
            24832
          ],
          [
            64512,
            35712
          ]
        ],
        "maps": {
          "19": {
            "name": "Plains of Ashford",
            "min_level": 1,
            "max_level": 15,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {
              "338": {
                "name": "Swordcross Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60564.4,
                  30713
                ],
                "id": 338,
                "chat_link": "[&BFIBAAA=]"
              },
              "339": {
                "name": "Foefire's Heart",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61232.6,
                  30126.2
                ],
                "id": 339,
                "chat_link": "[&BFMBAAA=]"
              },
              "340": {
                "name": "The Viewing Hill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60721.4,
                  30279
                ],
                "id": 340,
                "chat_link": "[&BFQBAAA=]"
              },
              "341": {
                "name": "Calhaan's Haunt",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59141.3,
                  30400.2
                ],
                "id": 341,
                "chat_link": "[&BFUBAAA=]"
              },
              "342": {
                "name": "Victory Cenotaph",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59350.1,
                  31090
                ],
                "id": 342,
                "chat_link": "[&BFYBAAA=]"
              },
              "343": {
                "name": "The Wrecking Yard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58534,
                  30530
                ],
                "id": 343,
                "chat_link": "[&BFcBAAA=]"
              },
              "344": {
                "name": "Stonecrag Kraal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61731,
                  30546.2
                ],
                "id": 344,
                "chat_link": "[&BFgBAAA=]"
              },
              "345": {
                "name": "Sharptail Encampment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58456.2,
                  31336
                ],
                "id": 345,
                "chat_link": "[&BFkBAAA=]"
              },
              "346": {
                "name": "Igni Castrum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59090.5,
                  31638.2
                ],
                "id": 346,
                "chat_link": "[&BFoBAAA=]"
              },
              "347": {
                "name": "Exterminatus HQ",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59005,
                  31180.9
                ],
                "id": 347,
                "chat_link": "[&BFsBAAA=]"
              },
              "348": {
                "name": "Ghostsummit",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60275.9,
                  30428.3
                ],
                "id": 348,
                "chat_link": "[&BFwBAAA=]"
              },
              "349": {
                "name": "Deadgod's Lair",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59826.2,
                  30343.9
                ],
                "id": 349,
                "chat_link": "[&BF0BAAA=]"
              },
              "383": {
                "name": "Vir's Gate Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58481.7,
                  31031.6
                ],
                "id": 383,
                "chat_link": "[&BH8BAAA=]"
              },
              "384": {
                "name": "Smokestead Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58138.5,
                  30589.8
                ],
                "id": 384,
                "chat_link": "[&BIABAAA=]"
              },
              "385": {
                "name": "Greysteel Armory Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58121.9,
                  30173.2
                ],
                "id": 385,
                "chat_link": "[&BIEBAAA=]"
              },
              "386": {
                "name": "Martyr's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59561.4,
                  30217.7
                ],
                "id": 386,
                "chat_link": "[&BIIBAAA=]"
              },
              "387": {
                "name": "Temperus Point Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59160.5,
                  30929.8
                ],
                "id": 387,
                "chat_link": "[&BIMBAAA=]"
              },
              "388": {
                "name": "Ashford Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59821.2,
                  31407
                ],
                "id": 388,
                "chat_link": "[&BIQBAAA=]"
              },
              "389": {
                "name": "Adorea Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59366.9,
                  31491.5
                ],
                "id": 389,
                "chat_link": "[&BIUBAAA=]"
              },
              "390": {
                "name": "Ascalonian Catacombs Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60433,
                  30432.8
                ],
                "id": 390,
                "chat_link": "[&BIYBAAA=]"
              },
              "391": {
                "name": "Ascalon City Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60987.2,
                  30152.3
                ],
                "id": 391,
                "chat_link": "[&BIcBAAA=]"
              },
              "392": {
                "name": "Watchcrag Tower Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  61513.2,
                  30819
                ],
                "id": 392,
                "chat_link": "[&BIgBAAA=]"
              },
              "393": {
                "name": "Duskrend Overlook Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  61694.1,
                  31267.3
                ],
                "id": 393,
                "chat_link": "[&BIkBAAA=]"
              },
              "394": {
                "name": "Irondock Shipyard Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60860,
                  31342.2
                ],
                "id": 394,
                "chat_link": "[&BIoBAAA=]"
              },
              "915": {
                "name": "Camp Keiran",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60857.8,
                  31870.9
                ],
                "id": 915,
                "chat_link": "[&BJMDAAA=]"
              },
              "916": {
                "name": "Mock's Niche",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57973,
                  30047.8
                ],
                "id": 916,
                "chat_link": "[&BJQDAAA=]"
              },
              "917": {
                "name": "Three Legions Court",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58199.7,
                  30965.9
                ],
                "id": 917,
                "chat_link": "[&BJUDAAA=]"
              },
              "918": {
                "name": "Shards of War",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60022.6,
                  30432.7
                ],
                "id": 918,
                "chat_link": "[&BJYDAAA=]"
              },
              "919": {
                "name": "Feritas Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58845,
                  30602.5
                ],
                "id": 919,
                "chat_link": "[&BJcDAAA=]"
              },
              "920": {
                "name": "Guardpoint Decimus Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58482.8,
                  31545.8
                ],
                "id": 920,
                "chat_link": "[&BJgDAAA=]"
              },
              "921": {
                "name": "Spirit Hunter Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59896.2,
                  30718.6
                ],
                "id": 921,
                "chat_link": "[&BJkDAAA=]"
              },
              "967": {
                "name": "Loreclaw Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  61161.7,
                  31717.8
                ],
                "id": 967,
                "chat_link": "[&BMcDAAA=]"
              },
              "968": {
                "name": "Phasmatis Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60922.9,
                  30687.9
                ],
                "id": 968,
                "chat_link": "[&BMgDAAA=]"
              },
              "1372": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58848,
                  30260.8
                ],
                "id": 1372,
                "chat_link": "[&BFwFAAA=]"
              },
              "1373": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58547.2,
                  31267.2
                ],
                "id": 1373,
                "chat_link": "[&BF0FAAA=]"
              },
              "1374": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  59459.9,
                  31813.8
                ],
                "id": 1374,
                "chat_link": "[&BF4FAAA=]"
              },
              "1375": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  59392.6,
                  30824.9
                ],
                "id": 1375,
                "chat_link": "[&BF8FAAA=]"
              },
              "1376": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60088,
                  30260.5
                ],
                "id": 1376,
                "chat_link": "[&BGAFAAA=]"
              },
              "1377": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60898.2,
                  31606.5
                ],
                "id": 1377,
                "chat_link": "[&BGEFAAA=]"
              },
              "1378": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  61535,
                  30897.3
                ],
                "id": 1378,
                "chat_link": "[&BGIFAAA=]"
              },
              "1379": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  61797.1,
                  30080.6
                ],
                "id": 1379,
                "chat_link": "[&BGMFAAA=]"
              },
              "1380": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60492.4,
                  30833.9
                ],
                "id": 1380,
                "chat_link": "[&BGQFAAA=]"
              },
              "1381": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60864.1,
                  30205.3
                ],
                "id": 1381,
                "chat_link": "[&BGUFAAA=]"
              },
              "1458": {
                "name": "Barradin's Vaults",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58973.9,
                  30876.6
                ],
                "id": 1458,
                "chat_link": "[&BLIFAAA=]"
              },
              "1733": {
                "name": "Ascalonian Catacombs",
                "type": "unlock",
                "floor": 1,
                "coord": [
                  60421.5,
                  30348.2
                ],
                "id": 1733,
                "chat_link": "[&BMUGAAA=]",
                "icon": "https://render.guildwars2.com/file/943538394A94A491C8632FBEF6203C2013443555/102478.png"
              },
              "1784": {
                "name": "Langmar Estate Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58552.5,
                  31813.9
                ],
                "id": 1784,
                "chat_link": "[&BPgGAAA=]"
              }
            },
            "tasks": {
              "96": {
                "objective": "Help Bryllana Deepmind thin out ghosts.",
                "level": 6,
                "coord": [
                  58614.5,
                  30795.3
                ],
                "bounds": [
                  [
                    58537.4,
                    30817.8
                  ],
                  [
                    58466.2,
                    30996.6
                  ],
                  [
                    58726,
                    31066.7
                  ],
                  [
                    58892.3,
                    31072.9
                  ],
                  [
                    58969.4,
                    30993.6
                  ],
                  [
                    59034.9,
                    30821.9
                  ],
                  [
                    59104.4,
                    30761.9
                  ],
                  [
                    59066.8,
                    30613.9
                  ],
                  [
                    58861.8,
                    30554.5
                  ],
                  [
                    58655.1,
                    30648.6
                  ],
                  [
                    58537.4,
                    30817.8
                  ]
                ],
                "id": 96,
                "chat_link": "[&BGAAAAA=]"
              },
              "97": {
                "objective": "Help Kyra Sharptracker thin out ghosts.",
                "level": 6,
                "coord": [
                  58389.6,
                  31340.1
                ],
                "bounds": [
                  [
                    58446.6,
                    31141.9
                  ],
                  [
                    58276.5,
                    31209.1
                  ],
                  [
                    58126.2,
                    31358.2
                  ],
                  [
                    58112.3,
                    31753.7
                  ],
                  [
                    58264.3,
                    31773.8
                  ],
                  [
                    58534.8,
                    31868.1
                  ],
                  [
                    58803.3,
                    31654.2
                  ],
                  [
                    58955.6,
                    31447.7
                  ],
                  [
                    58871.5,
                    31101.2
                  ],
                  [
                    58731.7,
                    31073.7
                  ],
                  [
                    58607.1,
                    31045.9
                  ],
                  [
                    58446.6,
                    31141.9
                  ]
                ],
                "id": 97,
                "chat_link": "[&BGEAAAA=]"
              },
              "98": {
                "objective": "Help Crucibis Forgeweld run the armory.",
                "level": 2,
                "coord": [
                  58362.9,
                  30369.4
                ],
                "bounds": [
                  [
                    58136,
                    30327.7
                  ],
                  [
                    58222.1,
                    30484.5
                  ],
                  [
                    58302.1,
                    30464.2
                  ],
                  [
                    58399.5,
                    30432.3
                  ],
                  [
                    58460.7,
                    30408.2
                  ],
                  [
                    58572.7,
                    30364.6
                  ],
                  [
                    58650.6,
                    30319.9
                  ],
                  [
                    58673.1,
                    30190.7
                  ],
                  [
                    58632.5,
                    30068.8
                  ],
                  [
                    58270.2,
                    30243.9
                  ],
                  [
                    58136,
                    30327.7
                  ]
                ],
                "id": 98,
                "chat_link": "[&BGIAAAA=]"
              },
              "100": {
                "objective": "Help Strum Bassclash secure Lake Feritas.",
                "level": 4,
                "coord": [
                  58699.5,
                  30258.6
                ],
                "bounds": [
                  [
                    58878.3,
                    30452.6
                  ],
                  [
                    58933.2,
                    30382
                  ],
                  [
                    58889.8,
                    30043.8
                  ],
                  [
                    58671.1,
                    30020.5
                  ],
                  [
                    58613.9,
                    30062.3
                  ],
                  [
                    58651.3,
                    30191.6
                  ],
                  [
                    58627.7,
                    30323.7
                  ],
                  [
                    58722,
                    30387.8
                  ],
                  [
                    58878.3,
                    30452.6
                  ]
                ],
                "id": 100,
                "chat_link": "[&BGQAAAA=]"
              },
              "101": {
                "objective": "Help Scar Stripeclaw organize the wrecking yard.",
                "level": 3,
                "coord": [
                  58538.1,
                  30503.7
                ],
                "bounds": [
                  [
                    58867.8,
                    30470.9
                  ],
                  [
                    58696.9,
                    30393.9
                  ],
                  [
                    58635.1,
                    30328
                  ],
                  [
                    58555.7,
                    30372.6
                  ],
                  [
                    58296.5,
                    30472.5
                  ],
                  [
                    58486.6,
                    30728.5
                  ],
                  [
                    58685.5,
                    30549.1
                  ],
                  [
                    58828.8,
                    30562.3
                  ],
                  [
                    58867.8,
                    30470.9
                  ]
                ],
                "id": 101,
                "chat_link": "[&BGUAAAA=]"
              },
              "102": {
                "objective": "Help Latera Painstorm fight the Flame Legion.",
                "level": 5,
                "coord": [
                  58945.8,
                  30253.6
                ],
                "bounds": [
                  [
                    58933.1,
                    30375.1
                  ],
                  [
                    58890.4,
                    30032.7
                  ],
                  [
                    58990.5,
                    29954.1
                  ],
                  [
                    59149.4,
                    29967.5
                  ],
                  [
                    59230.5,
                    30153.1
                  ],
                  [
                    59084.6,
                    30322.6
                  ],
                  [
                    59066.9,
                    30338.6
                  ],
                  [
                    59070.8,
                    30352.5
                  ],
                  [
                    59058.8,
                    30410.5
                  ],
                  [
                    59012.3,
                    30431.8
                  ],
                  [
                    58933.1,
                    30375.1
                  ]
                ],
                "id": 102,
                "chat_link": "[&BGYAAAA=]"
              },
              "103": {
                "objective": "Defend the Iron Legion fort from Flame Legion.",
                "level": 8,
                "coord": [
                  59187.5,
                  31100.1
                ],
                "bounds": [
                  [
                    59037.3,
                    31044.2
                  ],
                  [
                    58897.8,
                    31136.9
                  ],
                  [
                    59023,
                    31342.7
                  ],
                  [
                    58904.3,
                    31551.5
                  ],
                  [
                    59038.6,
                    31762.5
                  ],
                  [
                    59139,
                    31815.8
                  ],
                  [
                    59242.6,
                    31766.2
                  ],
                  [
                    59256.1,
                    31619.3
                  ],
                  [
                    59276.8,
                    31532.5
                  ],
                  [
                    59262.6,
                    31380.8
                  ],
                  [
                    59475.9,
                    31022.7
                  ],
                  [
                    59371.5,
                    30973.3
                  ],
                  [
                    59128.6,
                    30995.6
                  ],
                  [
                    59037.3,
                    31044.2
                  ]
                ],
                "id": 103,
                "chat_link": "[&BGcAAAA=]"
              },
              "104": {
                "objective": "Help the Blood Legion thin out nuisances.",
                "level": 7,
                "coord": [
                  59193.8,
                  30666.8
                ],
                "bounds": [
                  [
                    59085.5,
                    30679.9
                  ],
                  [
                    59088.3,
                    30962.9
                  ],
                  [
                    59197.7,
                    30966.2
                  ],
                  [
                    59244.5,
                    30915.2
                  ],
                  [
                    59289.7,
                    30799.8
                  ],
                  [
                    59511.3,
                    30797.8
                  ],
                  [
                    59458.6,
                    30677.8
                  ],
                  [
                    59426.8,
                    30597.4
                  ],
                  [
                    59432.6,
                    30465.9
                  ],
                  [
                    59465.2,
                    30356.1
                  ],
                  [
                    59572.9,
                    30194.7
                  ],
                  [
                    59449.9,
                    30181.2
                  ],
                  [
                    59178.4,
                    30194.6
                  ],
                  [
                    59065.1,
                    30406.6
                  ],
                  [
                    59085.5,
                    30679.9
                  ]
                ],
                "id": 104,
                "chat_link": "[&BGgAAAA=]"
              },
              "105": {
                "objective": "Help Sagum Relicseeker with his research.",
                "level": 15,
                "coord": [
                  60153.6,
                  30257.6
                ],
                "bounds": [
                  [
                    60150.1,
                    30604.1
                  ],
                  [
                    60110.4,
                    30406.2
                  ],
                  [
                    59952.7,
                    30381.4
                  ],
                  [
                    59936,
                    30318.8
                  ],
                  [
                    59862.9,
                    30274.8
                  ],
                  [
                    59802.1,
                    30283.4
                  ],
                  [
                    59724.1,
                    30295.3
                  ],
                  [
                    59656.8,
                    30265.6
                  ],
                  [
                    59633,
                    30205.8
                  ],
                  [
                    59689.6,
                    30193
                  ],
                  [
                    59736,
                    30188.1
                  ],
                  [
                    59801.1,
                    30186
                  ],
                  [
                    59853.9,
                    30171.4
                  ],
                  [
                    59917.3,
                    30159.8
                  ],
                  [
                    59989.7,
                    30066.7
                  ],
                  [
                    60224.4,
                    29965.6
                  ],
                  [
                    60496.5,
                    30041.2
                  ],
                  [
                    60497.3,
                    30359.6
                  ],
                  [
                    60530,
                    30581.5
                  ],
                  [
                    60384.1,
                    30711.2
                  ],
                  [
                    60194.9,
                    30742.3
                  ],
                  [
                    60150.1,
                    30604.1
                  ]
                ],
                "id": 105,
                "chat_link": "[&BGkAAAA=]"
              },
              "106": {
                "objective": "Help Gavros Spiritfoe thin out ghosts.",
                "level": 10,
                "coord": [
                  60192.1,
                  31160.9
                ],
                "bounds": [
                  [
                    59858.1,
                    30656.7
                  ],
                  [
                    60194.3,
                    30723.9
                  ],
                  [
                    60425,
                    30993.2
                  ],
                  [
                    60298.5,
                    31244.1
                  ],
                  [
                    60090.9,
                    31395.8
                  ],
                  [
                    59731.3,
                    31144.8
                  ],
                  [
                    59729,
                    30998.9
                  ],
                  [
                    59858.1,
                    30656.7
                  ]
                ],
                "id": 106,
                "chat_link": "[&BGoAAAA=]"
              },
              "107": {
                "objective": "Help Paenula train troops.",
                "level": 9,
                "coord": [
                  59479.5,
                  31240.2
                ],
                "bounds": [
                  [
                    59262.6,
                    31612.9
                  ],
                  [
                    59282.1,
                    31528.6
                  ],
                  [
                    59267.5,
                    31381.4
                  ],
                  [
                    59484.8,
                    31011.7
                  ],
                  [
                    59741,
                    31237.5
                  ],
                  [
                    60104.7,
                    31429.2
                  ],
                  [
                    60170.9,
                    31518.9
                  ],
                  [
                    60160,
                    31656.3
                  ],
                  [
                    59870.6,
                    31804.6
                  ],
                  [
                    59746.3,
                    31874.6
                  ],
                  [
                    59643,
                    31887.7
                  ],
                  [
                    59510.7,
                    31799.5
                  ],
                  [
                    59432.9,
                    31768.4
                  ],
                  [
                    59384.2,
                    31734.3
                  ],
                  [
                    59262.6,
                    31612.9
                  ]
                ],
                "id": 107,
                "chat_link": "[&BGsAAAA=]"
              },
              "108": {
                "objective": "Help Mei Hawkslayer disrupt separatist activity.",
                "level": 12,
                "coord": [
                  60620.4,
                  31720.6
                ],
                "bounds": [
                  [
                    60701.4,
                    31935.3
                  ],
                  [
                    61113.1,
                    31917
                  ],
                  [
                    61174,
                    31892.8
                  ],
                  [
                    61230.4,
                    31836.1
                  ],
                  [
                    61250.2,
                    31589.7
                  ],
                  [
                    61008.5,
                    31530.3
                  ],
                  [
                    60634,
                    31662.7
                  ],
                  [
                    60494.1,
                    31806.7
                  ],
                  [
                    60701.4,
                    31935.3
                  ]
                ],
                "id": 108,
                "chat_link": "[&BGwAAAA=]"
              },
              "109": {
                "objective": "Assist Sesto Headsplitter with his work.",
                "level": 11,
                "coord": [
                  60926.3,
                  31295.2
                ],
                "bounds": [
                  [
                    61156.9,
                    31177.5
                  ],
                  [
                    61004.1,
                    31527.8
                  ],
                  [
                    60646.2,
                    31654.2
                  ],
                  [
                    60542,
                    31469.1
                  ],
                  [
                    60537.3,
                    31162.3
                  ],
                  [
                    60709.7,
                    30926.8
                  ],
                  [
                    61156.9,
                    31177.5
                  ]
                ],
                "id": 109,
                "chat_link": "[&BG0AAAA=]"
              },
              "110": {
                "objective": "Help Researcher Irkz study skale poison.",
                "level": 12,
                "coord": [
                  61743.1,
                  31738.7
                ],
                "bounds": [
                  [
                    61244.4,
                    31769.5
                  ],
                  [
                    61376.3,
                    31774.1
                  ],
                  [
                    61459.9,
                    31793.7
                  ],
                  [
                    61551.8,
                    31849.4
                  ],
                  [
                    61582.4,
                    31872.5
                  ],
                  [
                    61658.7,
                    31966.3
                  ],
                  [
                    61970.4,
                    31812.8
                  ],
                  [
                    61821.6,
                    31519.3
                  ],
                  [
                    61695.3,
                    31478.2
                  ],
                  [
                    61298.3,
                    31470
                  ],
                  [
                    61260.5,
                    31601.1
                  ],
                  [
                    61244.4,
                    31769.5
                  ]
                ],
                "id": 110,
                "chat_link": "[&BG4AAAA=]"
              },
              "111": {
                "objective": "Help Androchus thin out ogres.",
                "level": 13,
                "coord": [
                  61414.7,
                  31056.1
                ],
                "bounds": [
                  [
                    61961,
                    31137.4
                  ],
                  [
                    62014.9,
                    30556.3
                  ],
                  [
                    61976.9,
                    30419.8
                  ],
                  [
                    61821.5,
                    30347.9
                  ],
                  [
                    61680.1,
                    30354.2
                  ],
                  [
                    61435.9,
                    30483.1
                  ],
                  [
                    61270.3,
                    30833.3
                  ],
                  [
                    61267.9,
                    31114.1
                  ],
                  [
                    61961,
                    31137.4
                  ]
                ],
                "id": 111,
                "chat_link": "[&BG8AAAA=]"
              },
              "112": {
                "objective": "Help Ghyrtratus Fiendmauler retake Ascalon City.",
                "level": 14,
                "coord": [
                  60995.8,
                  30111.3
                ],
                "bounds": [
                  [
                    61372.7,
                    30620.7
                  ],
                  [
                    61438.2,
                    30486.6
                  ],
                  [
                    61517.3,
                    30174.9
                  ],
                  [
                    61441.9,
                    30004.1
                  ],
                  [
                    60882.2,
                    30016
                  ],
                  [
                    60778.4,
                    30022.2
                  ],
                  [
                    60618.2,
                    29941.2
                  ],
                  [
                    60600.5,
                    30312.1
                  ],
                  [
                    60774.9,
                    30669.9
                  ],
                  [
                    61319.9,
                    30700.6
                  ],
                  [
                    61372.7,
                    30620.7
                  ]
                ],
                "id": 112,
                "chat_link": "[&BHAAAAA=]"
              },
              "347": {
                "objective": "Rid the training area of pests.",
                "level": 3,
                "coord": [
                  58056.4,
                  30164.9
                ],
                "bounds": [
                  [
                    57842.3,
                    30133.4
                  ],
                  [
                    58027.1,
                    30364.9
                  ],
                  [
                    58382,
                    30165.1
                  ],
                  [
                    58330.5,
                    30055
                  ],
                  [
                    58184.1,
                    29933.4
                  ],
                  [
                    57842.3,
                    30133.4
                  ]
                ],
                "id": 347,
                "chat_link": "[&BFsBAAA=]"
              },
              "348": {
                "objective": "Help Tolona Ironrustler with her farm.",
                "level": 2,
                "coord": [
                  58093.8,
                  30516.1
                ],
                "bounds": [
                  [
                    58117.6,
                    30524.9
                  ],
                  [
                    58135.2,
                    30473.8
                  ],
                  [
                    58132.4,
                    30437.6
                  ],
                  [
                    58103.4,
                    30368.1
                  ],
                  [
                    58007.9,
                    30306.8
                  ],
                  [
                    58002.8,
                    30408.5
                  ],
                  [
                    58008.3,
                    30526.8
                  ],
                  [
                    58000.5,
                    30618.9
                  ],
                  [
                    58047.2,
                    30642.7
                  ],
                  [
                    58117.6,
                    30524.9
                  ]
                ],
                "id": 348,
                "chat_link": "[&BFwBAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  59961.1,
                  31202.9
                ],
                "id": "0-30"
              },
              {
                "coord": [
                  59687.9,
                  31293.5
                ],
                "id": "0-12"
              },
              {
                "coord": [
                  61198.2,
                  30422.3
                ],
                "id": "0-14"
              },
              {
                "coord": [
                  58093.2,
                  30128.3
                ],
                "id": "0-13"
              },
              {
                "coord": [
                  61425,
                  30034.2
                ],
                "id": "0-32"
              },
              {
                "coord": [
                  59273.7,
                  31978.2
                ],
                "id": "0-40"
              }
            ],
            "sectors": {
              "270": {
                "name": "Village of Smokestead",
                "level": 3,
                "coord": [
                  58156.3,
                  30833.9
                ],
                "bounds": [
                  [
                    57856,
                    30550.5
                  ],
                  [
                    57996.7,
                    30571
                  ],
                  [
                    58378.9,
                    30592.8
                  ],
                  [
                    58545.1,
                    30743.8
                  ],
                  [
                    58526.7,
                    30851.5
                  ],
                  [
                    58424.6,
                    31121.2
                  ],
                  [
                    58158.3,
                    31028.9
                  ],
                  [
                    58070.5,
                    31085.8
                  ],
                  [
                    57749.8,
                    31164.6
                  ],
                  [
                    57856,
                    30629.3
                  ],
                  [
                    57856,
                    30550.5
                  ]
                ],
                "id": 270,
                "chat_link": "[&BA4BAAA=]"
              },
              "271": {
                "name": "Tela Range",
                "level": 4,
                "coord": [
                  57985.5,
                  30119.3
                ],
                "bounds": [
                  [
                    57802.3,
                    30344.5
                  ],
                  [
                    57985.1,
                    30336.5
                  ],
                  [
                    58225.7,
                    30165
                  ],
                  [
                    58232.5,
                    30110.6
                  ],
                  [
                    58153.4,
                    30012.7
                  ],
                  [
                    58021.3,
                    29815.9
                  ],
                  [
                    57795.6,
                    29955.1
                  ],
                  [
                    57668.2,
                    30213.8
                  ],
                  [
                    57802.3,
                    30344.5
                  ]
                ],
                "id": 271,
                "chat_link": "[&BA8BAAA=]"
              },
              "272": {
                "name": "Victor's Presidium",
                "level": 6,
                "coord": [
                  58619.5,
                  31354.6
                ],
                "bounds": [
                  [
                    58377.7,
                    31462.3
                  ],
                  [
                    58107,
                    31444.8
                  ],
                  [
                    58067.5,
                    31084.7
                  ],
                  [
                    58154.6,
                    31026.6
                  ],
                  [
                    58424.9,
                    31119
                  ],
                  [
                    58528.8,
                    30853.1
                  ],
                  [
                    58778.9,
                    31012.2
                  ],
                  [
                    58956.4,
                    30865.6
                  ],
                  [
                    58960.7,
                    31165.8
                  ],
                  [
                    59145.5,
                    31508.3
                  ],
                  [
                    59152.1,
                    31641.5
                  ],
                  [
                    59030.3,
                    31713.5
                  ],
                  [
                    58675.4,
                    31650.2
                  ],
                  [
                    58573.1,
                    31815.7
                  ],
                  [
                    58477,
                    31779.6
                  ],
                  [
                    58501.8,
                    31530
                  ],
                  [
                    58377.7,
                    31462.3
                  ]
                ],
                "id": 272,
                "chat_link": "[&BBABAAA=]"
              },
              "273": {
                "name": "Lake Feritas",
                "level": 5,
                "coord": [
                  58714.1,
                  30124.2
                ],
                "bounds": [
                  [
                    58961.2,
                    30433.2
                  ],
                  [
                    59149.5,
                    30224.9
                  ],
                  [
                    58926.3,
                    30089.1
                  ],
                  [
                    58821.3,
                    29908.7
                  ],
                  [
                    58622.6,
                    29930.8
                  ],
                  [
                    58466.7,
                    29814.3
                  ],
                  [
                    58351.4,
                    29933.1
                  ],
                  [
                    58466.9,
                    30121.5
                  ],
                  [
                    58626.4,
                    30199
                  ],
                  [
                    58748.8,
                    30587.3
                  ],
                  [
                    58961.2,
                    30433.2
                  ]
                ],
                "id": 273,
                "chat_link": "[&BBEBAAA=]"
              },
              "274": {
                "name": "Old Duke's Estate",
                "level": 6,
                "coord": [
                  58786.2,
                  30721.7
                ],
                "bounds": [
                  [
                    58780.2,
                    31015.2
                  ],
                  [
                    58526.3,
                    30852.5
                  ],
                  [
                    58543.1,
                    30742.7
                  ],
                  [
                    58748,
                    30587
                  ],
                  [
                    58960.9,
                    30433.3
                  ],
                  [
                    59158.8,
                    30699.4
                  ],
                  [
                    58780.2,
                    31015.2
                  ]
                ],
                "id": 274,
                "chat_link": "[&BBIBAAA=]"
              },
              "275": {
                "name": "Decimus Stones",
                "level": 7,
                "coord": [
                  58311.8,
                  31605.8
                ],
                "bounds": [
                  [
                    58105.3,
                    31758
                  ],
                  [
                    58287.2,
                    31766.5
                  ],
                  [
                    58491.2,
                    31678.8
                  ],
                  [
                    58499,
                    31527.7
                  ],
                  [
                    58381,
                    31461.2
                  ],
                  [
                    58107.3,
                    31442.4
                  ],
                  [
                    58105.3,
                    31758
                  ]
                ],
                "id": 275,
                "chat_link": "[&BBMBAAA=]"
              },
              "276": {
                "name": "Charr's Triumph",
                "level": 8,
                "coord": [
                  59352.1,
                  31140.9
                ],
                "bounds": [
                  [
                    59776,
                    31147.4
                  ],
                  [
                    59708.5,
                    30981.9
                  ],
                  [
                    59186.8,
                    30702.1
                  ],
                  [
                    58984.7,
                    30868.8
                  ],
                  [
                    58987.7,
                    31167.6
                  ],
                  [
                    59173.9,
                    31511.9
                  ],
                  [
                    59488.5,
                    31461.5
                  ],
                  [
                    59510.7,
                    31286.2
                  ],
                  [
                    59776,
                    31147.4
                  ]
                ],
                "id": 276,
                "chat_link": "[&BBQBAAA=]"
              },
              "277": {
                "name": "Martyr's Woods",
                "level": 7,
                "coord": [
                  59590,
                  30474.5
                ],
                "bounds": [
                  [
                    59560.1,
                    30894.6
                  ],
                  [
                    59675.6,
                    30968.6
                  ],
                  [
                    59690.2,
                    30862
                  ],
                  [
                    59791.4,
                    30755.1
                  ],
                  [
                    59841.6,
                    30697.2
                  ],
                  [
                    59923.6,
                    30631.9
                  ],
                  [
                    60012.8,
                    30625.2
                  ],
                  [
                    60015.7,
                    30511
                  ],
                  [
                    59960.6,
                    30423.9
                  ],
                  [
                    59972.9,
                    30374.3
                  ],
                  [
                    59902.5,
                    30279.9
                  ],
                  [
                    59716.5,
                    30309.4
                  ],
                  [
                    59512,
                    30254.2
                  ],
                  [
                    59422,
                    30134.8
                  ],
                  [
                    59317.8,
                    30001
                  ],
                  [
                    59074.2,
                    30119.8
                  ],
                  [
                    59157.5,
                    30232.6
                  ],
                  [
                    59078,
                    30274.2
                  ],
                  [
                    59005.9,
                    30466.7
                  ],
                  [
                    59169.3,
                    30673.2
                  ],
                  [
                    59560.1,
                    30894.6
                  ]
                ],
                "id": 277,
                "chat_link": "[&BBUBAAA=]"
              },
              "278": {
                "name": "Ashford Forum",
                "level": 9,
                "coord": [
                  59745.5,
                  31407.1
                ],
                "bounds": [
                  [
                    59649.1,
                    31596.6
                  ],
                  [
                    59917.3,
                    31638.5
                  ],
                  [
                    60067.2,
                    31518.5
                  ],
                  [
                    59901,
                    31208.4
                  ],
                  [
                    59747.3,
                    31144.2
                  ],
                  [
                    59478.6,
                    31284.4
                  ],
                  [
                    59458,
                    31459.4
                  ],
                  [
                    59649.1,
                    31596.6
                  ]
                ],
                "id": 278,
                "chat_link": "[&BBYBAAA=]"
              },
              "279": {
                "name": "Lake Adorea",
                "level": 11,
                "coord": [
                  59592.8,
                  31705.8
                ],
                "bounds": [
                  [
                    59313.5,
                    31972.8
                  ],
                  [
                    59547.6,
                    31870.2
                  ],
                  [
                    59677,
                    31959.9
                  ],
                  [
                    59922.2,
                    31764.2
                  ],
                  [
                    60097.2,
                    31751.6
                  ],
                  [
                    60179.8,
                    31641.9
                  ],
                  [
                    60163.1,
                    31435
                  ],
                  [
                    59917.8,
                    31635.1
                  ],
                  [
                    59648.8,
                    31597.8
                  ],
                  [
                    59457.8,
                    31458.4
                  ],
                  [
                    59144.4,
                    31509
                  ],
                  [
                    59151.8,
                    31641.1
                  ],
                  [
                    59031.2,
                    31712.8
                  ],
                  [
                    59046.9,
                    31931.7
                  ],
                  [
                    59313.5,
                    31972.8
                  ]
                ],
                "id": 279,
                "chat_link": "[&BBcBAAA=]"
              },
              "280": {
                "name": "Devast District",
                "level": 10,
                "coord": [
                  60088.4,
                  30958.3
                ],
                "bounds": [
                  [
                    60162.1,
                    31435.7
                  ],
                  [
                    60312.4,
                    31323.5
                  ],
                  [
                    60386,
                    31100.6
                  ],
                  [
                    60581.8,
                    30907.5
                  ],
                  [
                    60453.8,
                    30759.5
                  ],
                  [
                    60333.2,
                    30734.4
                  ],
                  [
                    60099.5,
                    30677.9
                  ],
                  [
                    60012.7,
                    30620.1
                  ],
                  [
                    59921.3,
                    30628.9
                  ],
                  [
                    59841.7,
                    30691.9
                  ],
                  [
                    59686.2,
                    30861.1
                  ],
                  [
                    59672.6,
                    30983.1
                  ],
                  [
                    59900.2,
                    30926.3
                  ],
                  [
                    59897.9,
                    31205.3
                  ],
                  [
                    60065.1,
                    31517.9
                  ],
                  [
                    60162.1,
                    31435.7
                  ]
                ],
                "id": 280,
                "chat_link": "[&BBgBAAA=]"
              },
              "281": {
                "name": "Windrock Maze",
                "level": 12,
                "coord": [
                  60391.9,
                  31581.3
                ],
                "bounds": [
                  [
                    60180.3,
                    31642.1
                  ],
                  [
                    60161.7,
                    31435.4
                  ],
                  [
                    60315.7,
                    31322
                  ],
                  [
                    60466.2,
                    31377.5
                  ],
                  [
                    60666.9,
                    31649.1
                  ],
                  [
                    60541.7,
                    31790.9
                  ],
                  [
                    60411.3,
                    31851.8
                  ],
                  [
                    60180.3,
                    31642.1
                  ]
                ],
                "id": 281,
                "chat_link": "[&BBkBAAA=]"
              },
              "282": {
                "name": "Ascalon Basin",
                "level": 12,
                "coord": [
                  61215.8,
                  31531.5
                ],
                "bounds": [
                  [
                    60666,
                    31652.3
                  ],
                  [
                    60982.6,
                    31591.5
                  ],
                  [
                    61296.3,
                    31773.7
                  ],
                  [
                    61458.5,
                    31781.3
                  ],
                  [
                    61619.4,
                    31898.9
                  ],
                  [
                    61603.1,
                    32053.5
                  ],
                  [
                    61680.8,
                    32143
                  ],
                  [
                    61800.4,
                    32266.6
                  ],
                  [
                    62020.7,
                    31978.7
                  ],
                  [
                    62040.4,
                    31882.4
                  ],
                  [
                    61961.6,
                    31505.5
                  ],
                  [
                    61442.9,
                    31466.1
                  ],
                  [
                    61175.9,
                    31065.4
                  ],
                  [
                    61051.7,
                    31086
                  ],
                  [
                    60870.2,
                    30981.4
                  ],
                  [
                    60845.5,
                    30844.8
                  ],
                  [
                    60643.1,
                    30846.8
                  ],
                  [
                    60386,
                    31101.2
                  ],
                  [
                    60307.5,
                    31326.2
                  ],
                  [
                    60462.6,
                    31384.5
                  ],
                  [
                    60666,
                    31652.3
                  ]
                ],
                "id": 282,
                "chat_link": "[&BBoBAAA=]"
              },
              "283": {
                "name": "Phasmatis Corridor",
                "level": 13,
                "coord": [
                  60438.8,
                  30569.8
                ],
                "bounds": [
                  [
                    60640.3,
                    30858.9
                  ],
                  [
                    60582.4,
                    30915.2
                  ],
                  [
                    60450.9,
                    30771.6
                  ],
                  [
                    60096.5,
                    30681
                  ],
                  [
                    60122.2,
                    30628.4
                  ],
                  [
                    60142.1,
                    30578.6
                  ],
                  [
                    60145.5,
                    30519.8
                  ],
                  [
                    60090.6,
                    30365.1
                  ],
                  [
                    60196,
                    30311.9
                  ],
                  [
                    60368.2,
                    30355.2
                  ],
                  [
                    60478.5,
                    30343.4
                  ],
                  [
                    60716.8,
                    30224.2
                  ],
                  [
                    60700.7,
                    30400.6
                  ],
                  [
                    61009.4,
                    30738.8
                  ],
                  [
                    60842.4,
                    30854.7
                  ],
                  [
                    60640.3,
                    30858.9
                  ]
                ],
                "id": 283,
                "chat_link": "[&BBsBAAA=]"
              },
              "284": {
                "name": "The Toppled Wall",
                "level": 15,
                "coord": [
                  60142.8,
                  30218.1
                ],
                "bounds": [
                  [
                    60354.2,
                    30371.4
                  ],
                  [
                    60193.5,
                    30317.5
                  ],
                  [
                    60097.7,
                    30365.9
                  ],
                  [
                    60026.4,
                    30339.2
                  ],
                  [
                    59975.4,
                    30373.9
                  ],
                  [
                    59901.2,
                    30285.7
                  ],
                  [
                    59716.3,
                    30311.3
                  ],
                  [
                    59514.5,
                    30264.8
                  ],
                  [
                    59300.1,
                    29999.9
                  ],
                  [
                    60307.3,
                    29873.5
                  ],
                  [
                    60734.6,
                    29939
                  ],
                  [
                    60712.1,
                    30002.8
                  ],
                  [
                    60702.9,
                    30248.4
                  ],
                  [
                    60463.8,
                    30359.8
                  ],
                  [
                    60354.2,
                    30371.4
                  ]
                ],
                "id": 284,
                "chat_link": "[&BBwBAAA=]"
              },
              "285": {
                "name": "Lamia Mire",
                "level": 11,
                "coord": [
                  61089.9,
                  30885.5
                ],
                "bounds": [
                  [
                    61009.7,
                    30727.9
                  ],
                  [
                    61300.9,
                    30664.1
                  ],
                  [
                    61380.3,
                    30824.2
                  ],
                  [
                    61174.3,
                    31068.5
                  ],
                  [
                    61050.9,
                    31087.3
                  ],
                  [
                    60868.5,
                    30981.8
                  ],
                  [
                    60844.7,
                    30845
                  ],
                  [
                    61009.7,
                    30727.9
                  ]
                ],
                "id": 285,
                "chat_link": "[&BB0BAAA=]"
              },
              "286": {
                "name": "Loreclaw Expanse",
                "level": 11,
                "coord": [
                  61133.9,
                  31833.1
                ],
                "bounds": [
                  [
                    60541.3,
                    31790.3
                  ],
                  [
                    60666.8,
                    31648.9
                  ],
                  [
                    60981,
                    31590.2
                  ],
                  [
                    61303.5,
                    31774.6
                  ],
                  [
                    61462.3,
                    31777.7
                  ],
                  [
                    61624.9,
                    31894.9
                  ],
                  [
                    61608.9,
                    32048.5
                  ],
                  [
                    61163.5,
                    32020.7
                  ],
                  [
                    60853,
                    31952
                  ],
                  [
                    60541.3,
                    31790.3
                  ]
                ],
                "id": 286,
                "chat_link": "[&BB4BAAA=]"
              },
              "287": {
                "name": "Cadem Forest",
                "level": 13,
                "coord": [
                  61649.7,
                  30878.2
                ],
                "bounds": [
                  [
                    61175.7,
                    31066.7
                  ],
                  [
                    61382.4,
                    30824.6
                  ],
                  [
                    61302.4,
                    30665.2
                  ],
                  [
                    61292.9,
                    30588.2
                  ],
                  [
                    61470,
                    30418.9
                  ],
                  [
                    61659,
                    30457.1
                  ],
                  [
                    61934.2,
                    30370.9
                  ],
                  [
                    61939.4,
                    30675.2
                  ],
                  [
                    62008.4,
                    30866.8
                  ],
                  [
                    61943.6,
                    31211.3
                  ],
                  [
                    61956.3,
                    31299.2
                  ],
                  [
                    61939.3,
                    31504.9
                  ],
                  [
                    61442.5,
                    31467.4
                  ],
                  [
                    61175.7,
                    31066.7
                  ]
                ],
                "id": 287,
                "chat_link": "[&BB8BAAA=]"
              },
              "288": {
                "name": "Gunbreach Hills",
                "level": 3,
                "coord": [
                  58277,
                  30394.2
                ],
                "bounds": [
                  [
                    57811.7,
                    30326.9
                  ],
                  [
                    57985.1,
                    30336.6
                  ],
                  [
                    58139.5,
                    30216.8
                  ],
                  [
                    58197.3,
                    30260
                  ],
                  [
                    58466.1,
                    30120
                  ],
                  [
                    58627.1,
                    30196.5
                  ],
                  [
                    58748.3,
                    30586.6
                  ],
                  [
                    58543.3,
                    30743.6
                  ],
                  [
                    58379.7,
                    30589.3
                  ],
                  [
                    57871.7,
                    30565.2
                  ],
                  [
                    57811.7,
                    30326.9
                  ]
                ],
                "id": 288,
                "chat_link": "[&BCABAAA=]"
              },
              "289": {
                "name": "Ascalon City Ruins",
                "level": 14,
                "coord": [
                  61034.8,
                  30253.6
                ],
                "bounds": [
                  [
                    61011.7,
                    30731.4
                  ],
                  [
                    60697,
                    30393
                  ],
                  [
                    60723.5,
                    30048.4
                  ],
                  [
                    60727.4,
                    29978.6
                  ],
                  [
                    60743.3,
                    29921.7
                  ],
                  [
                    60963.8,
                    29895.4
                  ],
                  [
                    61426,
                    29892.3
                  ],
                  [
                    61466,
                    30421.3
                  ],
                  [
                    61289.4,
                    30588.3
                  ],
                  [
                    61300,
                    30665.6
                  ],
                  [
                    61011.7,
                    30731.4
                  ]
                ],
                "id": 289,
                "chat_link": "[&BCEBAAA=]"
              },
              "290": {
                "name": "Devourer's Mouth",
                "level": 3,
                "coord": [
                  58268,
                  30086
                ],
                "bounds": [
                  [
                    58467.2,
                    30120.9
                  ],
                  [
                    58200.9,
                    30259.5
                  ],
                  [
                    58140.9,
                    30220.5
                  ],
                  [
                    58229.3,
                    30157
                  ],
                  [
                    58229.8,
                    30114.4
                  ],
                  [
                    58152.3,
                    30016.7
                  ],
                  [
                    58208.3,
                    29891.4
                  ],
                  [
                    58368.6,
                    29949.9
                  ],
                  [
                    58414.6,
                    30043.9
                  ],
                  [
                    58467.2,
                    30120.9
                  ]
                ],
                "id": 290,
                "chat_link": "[&BCIBAAA=]"
              },
              "291": {
                "name": "Abbey Ruins",
                "level": 10,
                "coord": [
                  59808.3,
                  31063.9
                ],
                "bounds": [
                  [
                    59905.1,
                    30919.6
                  ],
                  [
                    59679.5,
                    30979.2
                  ],
                  [
                    59748.7,
                    31146.6
                  ],
                  [
                    59900.1,
                    31210.1
                  ],
                  [
                    59905.1,
                    30919.6
                  ]
                ],
                "id": 291,
                "chat_link": "[&BCMBAAA=]"
              },
              "292": {
                "name": "Agnos Gorge",
                "level": 15,
                "coord": [
                  60059.9,
                  30492.4
                ],
                "bounds": [
                  [
                    60015.7,
                    30543.8
                  ],
                  [
                    60000.2,
                    30494
                  ],
                  [
                    59953.9,
                    30423.6
                  ],
                  [
                    59971,
                    30374
                  ],
                  [
                    60017.9,
                    30334.5
                  ],
                  [
                    60099.9,
                    30364.6
                  ],
                  [
                    60111.6,
                    30418.3
                  ],
                  [
                    60148.1,
                    30515.3
                  ],
                  [
                    60147.1,
                    30549.7
                  ],
                  [
                    60145.2,
                    30581.8
                  ],
                  [
                    60102.4,
                    30680.4
                  ],
                  [
                    60005.7,
                    30628.6
                  ],
                  [
                    60015.7,
                    30543.8
                  ]
                ],
                "id": 292,
                "chat_link": "[&BCQBAAA=]"
              },
              "293": {
                "name": "Human's Lament",
                "level": 14,
                "coord": [
                  61730.5,
                  30125.3
                ],
                "bounds": [
                  [
                    61438.6,
                    30135.4
                  ],
                  [
                    61423.9,
                    29896.1
                  ],
                  [
                    61598.6,
                    29922.2
                  ],
                  [
                    61700.4,
                    29837.9
                  ],
                  [
                    61921.9,
                    29893.1
                  ],
                  [
                    62009.2,
                    29994.1
                  ],
                  [
                    61936.7,
                    30165.6
                  ],
                  [
                    61949.6,
                    30275
                  ],
                  [
                    61935.4,
                    30378.1
                  ],
                  [
                    61656,
                    30460.7
                  ],
                  [
                    61465.6,
                    30420.5
                  ],
                  [
                    61438.6,
                    30135.4
                  ]
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              },
              "567": {
                "name": "Facula Castrum",
                "level": 5,
                "coord": [
                  59121.5,
                  30024
                ],
                "bounds": [
                  [
                    59147.3,
                    30224.4
                  ],
                  [
                    59228.4,
                    30179.7
                  ],
                  [
                    59307.6,
                    30007.8
                  ],
                  [
                    59351.6,
                    29908.2
                  ],
                  [
                    59078.3,
                    29853.8
                  ],
                  [
                    58817.2,
                    29908.1
                  ],
                  [
                    58920.3,
                    30085.8
                  ],
                  [
                    59147.3,
                    30224.4
                  ]
                ],
                "id": 567,
                "chat_link": "[&BDcCAAA=]"
              },
              "1104": {
                "name": "Langmar Estate",
                "level": 15,
                "coord": [
                  58219.9,
                  31645.5
                ],
                "bounds": [
                  [
                    58484.8,
                    31778.8
                  ],
                  [
                    58575,
                    31811.5
                  ],
                  [
                    58489.1,
                    32027.1
                  ],
                  [
                    57798.1,
                    31991.6
                  ],
                  [
                    57779,
                    31145.6
                  ],
                  [
                    58072,
                    31078.3
                  ],
                  [
                    58112.6,
                    31438.4
                  ],
                  [
                    58110.3,
                    31754.6
                  ],
                  [
                    58287.9,
                    31762.2
                  ],
                  [
                    58490.1,
                    31666.8
                  ],
                  [
                    58484.8,
                    31778.8
                  ]
                ],
                "id": 1104,
                "chat_link": "[&BFAEAAA=]"
              }
            },
            "adventures": [],
            "id": 19,
            "mastery_points": []
          },
          "20": {
            "name": "Blazeridge Steppes",
            "min_level": 40,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              62998,
              30464
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                61952,
                28544
              ],
              [
                64000,
                32640
              ]
            ],
            "points_of_interest": {
              "496": {
                "name": "Tail of the Star God",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63195,
                  31008
                ],
                "id": 496,
                "chat_link": "[&BPABAAA=]"
              },
              "497": {
                "name": "Ferrusatos Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63114.5,
                  32393.7
                ],
                "id": 497,
                "chat_link": "[&BPEBAAA=]"
              },
              "498": {
                "name": "Sootpan Kraal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63233.5,
                  31560.9
                ],
                "id": 498,
                "chat_link": "[&BPIBAAA=]"
              },
              "499": {
                "name": "Behemian Grand Kraal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63614.8,
                  31184
                ],
                "id": 499,
                "chat_link": "[&BPMBAAA=]"
              },
              "500": {
                "name": "Griffonclaw Peak",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63734.6,
                  31785.9
                ],
                "id": 500,
                "chat_link": "[&BPQBAAA=]"
              },
              "501": {
                "name": "Skara Braevus",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62275.2,
                  28990.1
                ],
                "id": 501,
                "chat_link": "[&BPUBAAA=]"
              },
              "502": {
                "name": "Wreckage of Serenity",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62558.6,
                  30642.9
                ],
                "id": 502,
                "chat_link": "[&BPYBAAA=]"
              },
              "503": {
                "name": "Craze's Folly",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63589,
                  28855
                ],
                "id": 503,
                "chat_link": "[&BPcBAAA=]"
              },
              "504": {
                "name": "Foewatch Encampment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63711.5,
                  32291.1
                ],
                "id": 504,
                "chat_link": "[&BPgBAAA=]"
              },
              "505": {
                "name": "The Last Whiskey Bar Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62150.3,
                  31333
                ],
                "id": 505,
                "chat_link": "[&BPkBAAA=]"
              },
              "506": {
                "name": "Steeleye Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62510.5,
                  31608.6
                ],
                "id": 506,
                "chat_link": "[&BPoBAAA=]"
              },
              "507": {
                "name": "Tumok's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62505.5,
                  32210.4
                ],
                "id": 507,
                "chat_link": "[&BPsBAAA=]"
              },
              "508": {
                "name": "Twin Sisters Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  63630.5,
                  32491.7
                ],
                "id": 508,
                "chat_link": "[&BPwBAAA=]"
              },
              "509": {
                "name": "Behem Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  63393.2,
                  31557
                ],
                "id": 509,
                "chat_link": "[&BP0BAAA=]"
              },
              "510": {
                "name": "Expanse Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  63517.7,
                  30176.8
                ],
                "id": 510,
                "chat_link": "[&BP4BAAA=]"
              },
              "511": {
                "name": "Guardian Stone Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62905.8,
                  29835.6
                ],
                "id": 511,
                "chat_link": "[&BP8BAAA=]"
              },
              "512": {
                "name": "Lunk Kraal Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  63697.8,
                  29769
                ],
                "id": 512,
                "chat_link": "[&BAACAAA=]"
              },
              "513": {
                "name": "Terra Carorunda Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  63481,
                  29114.8
                ],
                "id": 513,
                "chat_link": "[&BAECAAA=]"
              },
              "514": {
                "name": "Brokentooth Maw Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62776,
                  29006.3
                ],
                "id": 514,
                "chat_link": "[&BAICAAA=]"
              },
              "515": {
                "name": "Kindling Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62128,
                  28960.8
                ],
                "id": 515,
                "chat_link": "[&BAMCAAA=]"
              },
              "516": {
                "name": "Brandview Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62222.5,
                  29920.2
                ],
                "id": 516,
                "chat_link": "[&BAQCAAA=]"
              },
              "517": {
                "name": "Refuge Sanctum Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62795.1,
                  30751.6
                ],
                "id": 517,
                "chat_link": "[&BAUCAAA=]"
              },
              "846": {
                "name": "Lowland Burns Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62591.4,
                  29268.3
                ],
                "id": 846,
                "chat_link": "[&BE4DAAA=]"
              },
              "847": {
                "name": "Gastor Gullet Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  63533,
                  30772.8
                ],
                "id": 847,
                "chat_link": "[&BE8DAAA=]"
              },
              "848": {
                "name": "Kinar Fort Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62378,
                  30660.8
                ],
                "id": 848,
                "chat_link": "[&BFADAAA=]"
              },
              "849": {
                "name": "Splintercrest Fort Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  63344.8,
                  32096.6
                ],
                "id": 849,
                "chat_link": "[&BFEDAAA=]"
              },
              "850": {
                "name": "Soot Road Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62872.7,
                  31804.3
                ],
                "id": 850,
                "chat_link": "[&BFIDAAA=]"
              },
              "852": {
                "name": "Drake Hollow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62721.4,
                  32066.1
                ],
                "id": 852,
                "chat_link": "[&BFQDAAA=]"
              },
              "1563": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  63080.3,
                  30873.8
                ],
                "id": 1563,
                "chat_link": "[&BBsGAAA=]"
              },
              "1564": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  62859.2,
                  29159.4
                ],
                "id": 1564,
                "chat_link": "[&BBwGAAA=]"
              },
              "1565": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  62355,
                  29516.9
                ],
                "id": 1565,
                "chat_link": "[&BB0GAAA=]"
              },
              "1566": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  63690.7,
                  32263
                ],
                "id": 1566,
                "chat_link": "[&BB4GAAA=]"
              },
              "1567": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  63799.8,
                  31828.1
                ],
                "id": 1567,
                "chat_link": "[&BB8GAAA=]"
              }
            },
            "tasks": {
              "113": {
                "objective": "Help Sentinel Liharn disrupt the Inquest.",
                "level": 46,
                "coord": [
                  62363.8,
                  30181.8
                ],
                "bounds": [
                  [
                    62442.5,
                    29727.1
                  ],
                  [
                    62754.4,
                    30265.1
                  ],
                  [
                    62504,
                    30370.2
                  ],
                  [
                    62060.6,
                    30264.2
                  ],
                  [
                    62100,
                    29842.6
                  ],
                  [
                    62140.5,
                    29701.8
                  ],
                  [
                    62442.5,
                    29727.1
                  ]
                ],
                "id": 113,
                "chat_link": "[&BHEAAAA=]"
              },
              "114": {
                "objective": "Help Scholar Olenn trick the grawl around the Tail of the Star God.",
                "level": 44,
                "coord": [
                  62989.5,
                  30729.1
                ],
                "bounds": [
                  [
                    62840.1,
                    30672.4
                  ],
                  [
                    62864.3,
                    30671
                  ],
                  [
                    63210.8,
                    30708
                  ],
                  [
                    63357.9,
                    30887.4
                  ],
                  [
                    63367.6,
                    31022.7
                  ],
                  [
                    63164.5,
                    31212
                  ],
                  [
                    63034.9,
                    31122.3
                  ],
                  [
                    62840.1,
                    30672.4
                  ]
                ],
                "id": 114,
                "chat_link": "[&BHIAAAA=]"
              },
              "115": {
                "objective": "Aid Historian Jinell's research at the Wreckage of Serenity.",
                "level": 45,
                "coord": [
                  62739,
                  30676.6
                ],
                "bounds": [
                  [
                    62462.5,
                    30853.4
                  ],
                  [
                    62487.2,
                    30571.6
                  ],
                  [
                    62664,
                    30534
                  ],
                  [
                    62865,
                    30728.9
                  ],
                  [
                    62886.6,
                    30786.2
                  ],
                  [
                    62588,
                    30862.9
                  ],
                  [
                    62462.5,
                    30853.4
                  ]
                ],
                "id": 115,
                "chat_link": "[&BHMAAAA=]"
              },
              "116": {
                "objective": "Assist Sentinel forces against dragonspawn.",
                "level": 50,
                "coord": [
                  62847.2,
                  29077.8
                ],
                "bounds": [
                  [
                    62865,
                    28932.6
                  ],
                  [
                    62889.3,
                    29258
                  ],
                  [
                    62775.3,
                    29333
                  ],
                  [
                    62541.8,
                    29350.8
                  ],
                  [
                    62419.3,
                    29341.9
                  ],
                  [
                    62338.3,
                    29278.1
                  ],
                  [
                    62188.9,
                    29005
                  ],
                  [
                    62215.1,
                    28864
                  ],
                  [
                    62249.5,
                    28650.4
                  ],
                  [
                    62418,
                    28619.2
                  ],
                  [
                    62597.1,
                    28561
                  ],
                  [
                    62601.2,
                    28689.2
                  ],
                  [
                    62582,
                    28816.4
                  ],
                  [
                    62628.1,
                    28846.3
                  ],
                  [
                    62865,
                    28932.6
                  ]
                ],
                "id": 116,
                "chat_link": "[&BHQAAAA=]"
              },
              "117": {
                "objective": "Help Sentinel Faithspotter deal with skritt.",
                "level": 45,
                "coord": [
                  62359.2,
                  30576.8
                ],
                "bounds": [
                  [
                    62110.3,
                    30278.5
                  ],
                  [
                    62519.9,
                    30378.6
                  ],
                  [
                    62456.5,
                    30909.2
                  ],
                  [
                    61995.7,
                    30822.5
                  ],
                  [
                    61938.4,
                    30422.8
                  ],
                  [
                    62110.3,
                    30278.5
                  ]
                ],
                "id": 117,
                "chat_link": "[&BHUAAAA=]"
              },
              "118": {
                "objective": "Help Wode with harpy research.",
                "level": 47,
                "coord": [
                  63024.6,
                  29343.7
                ],
                "bounds": [
                  [
                    62787.5,
                    29683.2
                  ],
                  [
                    62794.7,
                    29470.2
                  ],
                  [
                    62886.6,
                    29373.6
                  ],
                  [
                    63053.5,
                    29251.6
                  ],
                  [
                    63218.5,
                    29388.2
                  ],
                  [
                    63251.8,
                    29473.8
                  ],
                  [
                    63105.5,
                    29613.5
                  ],
                  [
                    62993,
                    29668.6
                  ],
                  [
                    62787.5,
                    29683.2
                  ]
                ],
                "id": 118,
                "chat_link": "[&BHYAAAA=]"
              },
              "119": {
                "objective": "Help the peaceful ogres of Degun Shun.",
                "level": 46,
                "coord": [
                  63508.1,
                  30208.8
                ],
                "bounds": [
                  [
                    63381,
                    29827.7
                  ],
                  [
                    63999.5,
                    29895.6
                  ],
                  [
                    63983,
                    30397.6
                  ],
                  [
                    63140.9,
                    30422.9
                  ],
                  [
                    63107.7,
                    30235.8
                  ],
                  [
                    63184.9,
                    30031
                  ],
                  [
                    63297.5,
                    29841.3
                  ],
                  [
                    63381,
                    29827.7
                  ]
                ],
                "id": 119,
                "chat_link": "[&BHcAAAA=]"
              },
              "120": {
                "objective": "Aid Ferrusatos Village's fishing operation and help them hunt down Separatists.",
                "level": 41,
                "coord": [
                  63172.7,
                  32422.8
                ],
                "bounds": [
                  [
                    62765.9,
                    32461.6
                  ],
                  [
                    62824.4,
                    32370.9
                  ],
                  [
                    62910.4,
                    32415.7
                  ],
                  [
                    62968.9,
                    32322.5
                  ],
                  [
                    62936.3,
                    32296.3
                  ],
                  [
                    62971.3,
                    32250.1
                  ],
                  [
                    63070.9,
                    32247
                  ],
                  [
                    63151,
                    32195.8
                  ],
                  [
                    63213.3,
                    32203.5
                  ],
                  [
                    63254.4,
                    32259.2
                  ],
                  [
                    63247,
                    32353.1
                  ],
                  [
                    63260,
                    32428.2
                  ],
                  [
                    63342.2,
                    32445.9
                  ],
                  [
                    63397.8,
                    32515.8
                  ],
                  [
                    63383.4,
                    32622.5
                  ],
                  [
                    63257.2,
                    32616.6
                  ],
                  [
                    63087.4,
                    32645.5
                  ],
                  [
                    62863.6,
                    32591.8
                  ],
                  [
                    62786.6,
                    32520.9
                  ],
                  [
                    62765.9,
                    32461.6
                  ]
                ],
                "id": 120,
                "chat_link": "[&BHgAAAA=]"
              },
              "121": {
                "objective": "Aid Legion and Ebon Vanguard soldiers against ogres.",
                "level": 40,
                "coord": [
                  63624,
                  32403.8
                ],
                "bounds": [
                  [
                    63437.6,
                    32405
                  ],
                  [
                    63296.8,
                    32419.5
                  ],
                  [
                    63258.1,
                    32386.6
                  ],
                  [
                    63260.3,
                    32219.1
                  ],
                  [
                    63219.8,
                    32109.9
                  ],
                  [
                    63175.2,
                    31977.8
                  ],
                  [
                    63199.3,
                    31903.2
                  ],
                  [
                    63278.3,
                    31891.9
                  ],
                  [
                    63379.7,
                    31849.4
                  ],
                  [
                    63472.5,
                    31853.3
                  ],
                  [
                    63582.1,
                    31897.5
                  ],
                  [
                    63695.7,
                    31882.5
                  ],
                  [
                    63794.7,
                    31944.3
                  ],
                  [
                    63826,
                    32041
                  ],
                  [
                    63870.2,
                    32118.9
                  ],
                  [
                    63958.9,
                    32113.7
                  ],
                  [
                    63894.5,
                    32505.5
                  ],
                  [
                    63648.3,
                    32445.5
                  ],
                  [
                    63437.6,
                    32405
                  ]
                ],
                "id": 121,
                "chat_link": "[&BHkAAAA=]"
              },
              "122": {
                "objective": "Help the Iron Legion protect Steeleye Span from Branded creatures.",
                "level": 43,
                "coord": [
                  62650.9,
                  31733.7
                ],
                "bounds": [
                  [
                    62591,
                    31818.9
                  ],
                  [
                    62323.3,
                    31729.8
                  ],
                  [
                    62291.2,
                    31594.4
                  ],
                  [
                    62347.4,
                    31423.5
                  ],
                  [
                    62721.8,
                    31531
                  ],
                  [
                    62740.7,
                    31731.9
                  ],
                  [
                    62591,
                    31818.9
                  ]
                ],
                "id": 122,
                "chat_link": "[&BHoAAAA=]"
              },
              "123": {
                "objective": "Help the Ash Legion take out ogres.",
                "level": 43,
                "coord": [
                  63406.8,
                  31528.3
                ],
                "bounds": [
                  [
                    63330.9,
                    31713.9
                  ],
                  [
                    63117.2,
                    31655.2
                  ],
                  [
                    63149.6,
                    31470.1
                  ],
                  [
                    63480.2,
                    31197
                  ],
                  [
                    63543.3,
                    31075.2
                  ],
                  [
                    63583,
                    31008
                  ],
                  [
                    63720.3,
                    31002.5
                  ],
                  [
                    63792.3,
                    31043.5
                  ],
                  [
                    63882.8,
                    31169.6
                  ],
                  [
                    63742.3,
                    31413.8
                  ],
                  [
                    63687,
                    31486.2
                  ],
                  [
                    63676,
                    31558.5
                  ],
                  [
                    63628.2,
                    31587.4
                  ],
                  [
                    63430.2,
                    31742.5
                  ],
                  [
                    63330.9,
                    31713.9
                  ]
                ],
                "id": 123,
                "chat_link": "[&BHsAAAA=]"
              },
              "124": {
                "objective": "Help Torruh Sweptweave disrupt Separatist activities.",
                "level": 42,
                "coord": [
                  62960.5,
                  32244
                ],
                "bounds": [
                  [
                    62920.8,
                    32303.2
                  ],
                  [
                    62972,
                    32247.3
                  ],
                  [
                    62995.5,
                    32206.7
                  ],
                  [
                    62934.6,
                    32099
                  ],
                  [
                    62906.5,
                    32008.4
                  ],
                  [
                    62905.9,
                    31956.9
                  ],
                  [
                    62835.8,
                    31935.5
                  ],
                  [
                    62698.5,
                    31916.7
                  ],
                  [
                    62600,
                    32025.4
                  ],
                  [
                    62621.3,
                    32157.3
                  ],
                  [
                    62729.8,
                    32195.9
                  ],
                  [
                    62832.4,
                    32202.2
                  ],
                  [
                    62920.8,
                    32303.2
                  ]
                ],
                "id": 124,
                "chat_link": "[&BHwAAAA=]"
              },
              "125": {
                "objective": "Help Sentinels instigate fights between ghosts and the Branded.",
                "level": 42,
                "coord": [
                  62187.6,
                  32440.9
                ],
                "bounds": [
                  [
                    62182.1,
                    32227.3
                  ],
                  [
                    62111,
                    32413.1
                  ],
                  [
                    62188.4,
                    32468.2
                  ],
                  [
                    62428.4,
                    32474.1
                  ],
                  [
                    62465.9,
                    32362.1
                  ],
                  [
                    62483.4,
                    32218.4
                  ],
                  [
                    62488.8,
                    32104.4
                  ],
                  [
                    62555,
                    32010
                  ],
                  [
                    62412.3,
                    31919.6
                  ],
                  [
                    62253.6,
                    31881.6
                  ],
                  [
                    62170.2,
                    31956.5
                  ],
                  [
                    62182.1,
                    32227.3
                  ]
                ],
                "id": 125,
                "chat_link": "[&BH0AAAA=]"
              },
              "126": {
                "objective": "Join the Ash Legion of Tawny Ridge in stealth operations.",
                "level": 48,
                "coord": [
                  63702.8,
                  29368.7
                ],
                "bounds": [
                  [
                    63718.8,
                    29303.7
                  ],
                  [
                    63702,
                    29198.2
                  ],
                  [
                    63693.7,
                    29177
                  ],
                  [
                    63840.2,
                    29153.2
                  ],
                  [
                    63944.4,
                    29224.6
                  ],
                  [
                    63893.3,
                    29473.6
                  ],
                  [
                    63659.7,
                    29385
                  ],
                  [
                    63646.2,
                    29307.8
                  ],
                  [
                    63718.8,
                    29303.7
                  ]
                ],
                "id": 126,
                "chat_link": "[&BH4AAAA=]"
              },
              "127": {
                "objective": "Help Jahr Duskrend disrupt Separatist activities.",
                "level": 49,
                "coord": [
                  63616.8,
                  29021.8
                ],
                "bounds": [
                  [
                    63640.9,
                    29062.1
                  ],
                  [
                    63495.2,
                    29043.1
                  ],
                  [
                    63463.2,
                    29036.6
                  ],
                  [
                    63435.5,
                    28976.8
                  ],
                  [
                    63460.4,
                    28795.5
                  ],
                  [
                    63552.3,
                    28698.9
                  ],
                  [
                    63917.5,
                    28799.1
                  ],
                  [
                    63771.2,
                    28938.8
                  ],
                  [
                    63700,
                    29044.9
                  ],
                  [
                    63640.9,
                    29062.1
                  ]
                ],
                "id": 127,
                "chat_link": "[&BH8AAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  63169,
                  31000
                ],
                "id": "0-45"
              },
              {
                "coord": [
                  62274.9,
                  28731.9
                ],
                "id": "0-48"
              },
              {
                "coord": [
                  62228.5,
                  29872.3
                ],
                "id": "0-130"
              },
              {
                "coord": [
                  63901.7,
                  29836.9
                ],
                "id": "0-129"
              },
              {
                "coord": [
                  62585.2,
                  30664.2
                ],
                "id": "0-128"
              }
            ],
            "sectors": {
              "484": {
                "name": "Tawny Ridge",
                "level": 49,
                "coord": [
                  63787.3,
                  29317.5
                ],
                "bounds": [
                  [
                    63834.3,
                    29385.9
                  ],
                  [
                    63878.9,
                    29286.7
                  ],
                  [
                    63836.8,
                    29212
                  ],
                  [
                    63745.4,
                    29237.2
                  ],
                  [
                    63699,
                    29364
                  ],
                  [
                    63729.6,
                    29419
                  ],
                  [
                    63834.3,
                    29385.9
                  ]
                ],
                "id": 484,
                "chat_link": "[&BOQBAAA=]"
              },
              "485": {
                "name": "Steeleye Span",
                "level": 43,
                "coord": [
                  62529.3,
                  31630.3
                ],
                "bounds": [
                  [
                    62334,
                    31493.3
                  ],
                  [
                    62569.1,
                    31511.8
                  ],
                  [
                    62764.5,
                    31653.4
                  ],
                  [
                    62647.5,
                    31807
                  ],
                  [
                    62331.5,
                    31685.8
                  ],
                  [
                    62334,
                    31493.3
                  ]
                ],
                "id": 485,
                "chat_link": "[&BOUBAAA=]"
              },
              "486": {
                "name": "Deserter Flats",
                "level": 45,
                "coord": [
                  62613.5,
                  30722.1
                ],
                "bounds": [
                  [
                    62439.6,
                    30695.3
                  ],
                  [
                    62452.9,
                    30472.3
                  ],
                  [
                    62598.7,
                    30334.8
                  ],
                  [
                    62811.9,
                    30457.6
                  ],
                  [
                    62958.3,
                    30707.9
                  ],
                  [
                    62839.8,
                    30912.9
                  ],
                  [
                    62726.3,
                    30877.3
                  ],
                  [
                    62641.9,
                    30973.8
                  ],
                  [
                    62351.8,
                    31035.3
                  ],
                  [
                    62313.7,
                    30754.1
                  ],
                  [
                    62439.6,
                    30695.3
                  ]
                ],
                "id": 486,
                "chat_link": "[&BOYBAAA=]"
              },
              "487": {
                "name": "Hazmagic Aggregate",
                "level": 48,
                "coord": [
                  62738.3,
                  30060.6
                ],
                "bounds": [
                  [
                    62811.3,
                    30462.7
                  ],
                  [
                    62929.5,
                    30273.1
                  ],
                  [
                    62928.1,
                    30070
                  ],
                  [
                    62816,
                    29773.8
                  ],
                  [
                    62843.9,
                    29606.6
                  ],
                  [
                    62492,
                    29699.6
                  ],
                  [
                    62573.5,
                    30053.8
                  ],
                  [
                    62658.6,
                    30065.7
                  ],
                  [
                    62730.9,
                    30263
                  ],
                  [
                    62598.8,
                    30337.7
                  ],
                  [
                    62811.3,
                    30462.7
                  ]
                ],
                "id": 487,
                "chat_link": "[&BOcBAAA=]"
              },
              "488": {
                "name": "Foulblain Expanse",
                "level": 43,
                "coord": [
                  62557.5,
                  31301.7
                ],
                "bounds": [
                  [
                    62337.1,
                    31156.7
                  ],
                  [
                    62350.8,
                    31028.3
                  ],
                  [
                    62645.7,
                    30961.6
                  ],
                  [
                    62603.2,
                    31125.8
                  ],
                  [
                    62658.3,
                    31339.5
                  ],
                  [
                    62753.8,
                    31420.5
                  ],
                  [
                    62762.4,
                    31655.3
                  ],
                  [
                    62568.6,
                    31523.9
                  ],
                  [
                    62337.9,
                    31504.2
                  ],
                  [
                    62337.1,
                    31156.7
                  ]
                ],
                "id": 488,
                "chat_link": "[&BOgBAAA=]"
              },
              "489": {
                "name": "Lowland Burns",
                "level": 50,
                "coord": [
                  62333.4,
                  28730.6
                ],
                "bounds": [
                  [
                    62331.1,
                    28939.1
                  ],
                  [
                    62257.1,
                    28819.7
                  ],
                  [
                    62090.8,
                    28826.8
                  ],
                  [
                    61794.4,
                    28687.8
                  ],
                  [
                    61938.5,
                    28177.5
                  ],
                  [
                    62027.6,
                    28190.3
                  ],
                  [
                    62106.3,
                    28274.4
                  ],
                  [
                    62222.5,
                    28337.8
                  ],
                  [
                    62320,
                    28413.6
                  ],
                  [
                    62385.2,
                    28509.2
                  ],
                  [
                    62435.3,
                    28600.1
                  ],
                  [
                    62517.2,
                    28640.4
                  ],
                  [
                    62670,
                    29018.7
                  ],
                  [
                    62922.2,
                    29225.1
                  ],
                  [
                    62890,
                    29333.1
                  ],
                  [
                    62446,
                    29308.9
                  ],
                  [
                    62313.5,
                    29117.5
                  ],
                  [
                    62331.1,
                    28939.1
                  ]
                ],
                "id": 489,
                "chat_link": "[&BOkBAAA=]"
              },
              "490": {
                "name": "Blightwater Basin",
                "level": 42,
                "coord": [
                  62087.1,
                  32282.7
                ],
                "bounds": [
                  [
                    62475.8,
                    32616.7
                  ],
                  [
                    62449.6,
                    32150.3
                  ],
                  [
                    62646.2,
                    31808.5
                  ],
                  [
                    62331.8,
                    31685.8
                  ],
                  [
                    62326.8,
                    31780.5
                  ],
                  [
                    61973.7,
                    31941.7
                  ],
                  [
                    61509.8,
                    32070.4
                  ],
                  [
                    61678.1,
                    32224.7
                  ],
                  [
                    61761.7,
                    32366.7
                  ],
                  [
                    61787.2,
                    32521.6
                  ],
                  [
                    61870.1,
                    32635.4
                  ],
                  [
                    62002.2,
                    32677.4
                  ],
                  [
                    62097.8,
                    32730.4
                  ],
                  [
                    62308.7,
                    32747.6
                  ],
                  [
                    62475.8,
                    32616.7
                  ]
                ],
                "id": 490,
                "chat_link": "[&BOoBAAA=]"
              },
              "491": {
                "name": "Tumok's Last Stand",
                "level": 42,
                "coord": [
                  62708.1,
                  32441.5
                ],
                "bounds": [
                  [
                    62475.4,
                    32613.9
                  ],
                  [
                    62574.8,
                    32661.6
                  ],
                  [
                    62807.9,
                    32713.7
                  ],
                  [
                    62940,
                    32662.1
                  ],
                  [
                    62957.1,
                    32598.9
                  ],
                  [
                    63050.1,
                    32235.4
                  ],
                  [
                    62644.3,
                    31809.7
                  ],
                  [
                    62452.7,
                    32155.4
                  ],
                  [
                    62470.8,
                    32522.3
                  ],
                  [
                    62475.4,
                    32613.9
                  ]
                ],
                "id": 491,
                "chat_link": "[&BOsBAAA=]"
              },
              "492": {
                "name": "Pockmark Roughs",
                "level": 45,
                "coord": [
                  63227.9,
                  31010.7
                ],
                "bounds": [
                  [
                    62841,
                    30913.6
                  ],
                  [
                    62955.5,
                    30712.2
                  ],
                  [
                    63229.3,
                    30638.3
                  ],
                  [
                    63447.8,
                    30736.4
                  ],
                  [
                    63538.4,
                    30885.5
                  ],
                  [
                    63527.2,
                    31093
                  ],
                  [
                    63443.4,
                    31236.1
                  ],
                  [
                    63307.8,
                    31352.4
                  ],
                  [
                    63109.2,
                    31370.7
                  ],
                  [
                    62879.8,
                    31168.8
                  ],
                  [
                    62841,
                    30913.6
                  ]
                ],
                "id": 492,
                "chat_link": "[&BOwBAAA=]"
              },
              "493": {
                "name": "Crater Rim",
                "level": 42,
                "coord": [
                  62868.6,
                  31245.7
                ],
                "bounds": [
                  [
                    62751.9,
                    31427.3
                  ],
                  [
                    62658.5,
                    31342.8
                  ],
                  [
                    62601,
                    31130.2
                  ],
                  [
                    62636.8,
                    30977.7
                  ],
                  [
                    62730.2,
                    30877.8
                  ],
                  [
                    62840.6,
                    30911.7
                  ],
                  [
                    62877.2,
                    31164.1
                  ],
                  [
                    63108.9,
                    31367.5
                  ],
                  [
                    63307.8,
                    31349.7
                  ],
                  [
                    63280.4,
                    31498.4
                  ],
                  [
                    62760.8,
                    31655
                  ],
                  [
                    62751.9,
                    31427.3
                  ]
                ],
                "id": 493,
                "chat_link": "[&BO0BAAA=]"
              },
              "494": {
                "name": "Behem Gauntlet",
                "level": 42,
                "coord": [
                  63694.3,
                  31526.8
                ],
                "bounds": [
                  [
                    63271.2,
                    31726
                  ],
                  [
                    63385.2,
                    31922
                  ],
                  [
                    63651.7,
                    31679.6
                  ],
                  [
                    63924.3,
                    31814.5
                  ],
                  [
                    64038.7,
                    31803.6
                  ],
                  [
                    64094,
                    31571.6
                  ],
                  [
                    64085.1,
                    31319.6
                  ],
                  [
                    63942.8,
                    31304.5
                  ],
                  [
                    63873.8,
                    31387.6
                  ],
                  [
                    63782,
                    31414.4
                  ],
                  [
                    63740.9,
                    31473.9
                  ],
                  [
                    63595.5,
                    31417.7
                  ],
                  [
                    63441.6,
                    31227.4
                  ],
                  [
                    63311.4,
                    31343.3
                  ],
                  [
                    63276.7,
                    31496.2
                  ],
                  [
                    63271.2,
                    31726
                  ]
                ],
                "id": 494,
                "chat_link": "[&BO4BAAA=]"
              },
              "495": {
                "name": "Unbroken Expanse",
                "level": 45,
                "coord": [
                  63211.9,
                  30390.3
                ],
                "bounds": [
                  [
                    63228.8,
                    30645.9
                  ],
                  [
                    63447.9,
                    30738.9
                  ],
                  [
                    63594.9,
                    30605.9
                  ],
                  [
                    63546,
                    30298.3
                  ],
                  [
                    63595.9,
                    30138.5
                  ],
                  [
                    63083,
                    29956.2
                  ],
                  [
                    62925.8,
                    30070.6
                  ],
                  [
                    62926.9,
                    30273.4
                  ],
                  [
                    62810.4,
                    30458.3
                  ],
                  [
                    62959.4,
                    30717.1
                  ],
                  [
                    63228.8,
                    30645.9
                  ]
                ],
                "id": 495,
                "chat_link": "[&BO8BAAA=]"
              },
              "496": {
                "name": "Gastor Gullet",
                "level": 45,
                "coord": [
                  63716,
                  31092.8
                ],
                "bounds": [
                  [
                    63527.8,
                    31091.7
                  ],
                  [
                    63538.8,
                    30886.2
                  ],
                  [
                    63447.1,
                    30737.8
                  ],
                  [
                    63593.5,
                    30606.3
                  ],
                  [
                    63767.3,
                    30670.9
                  ],
                  [
                    63870.3,
                    30901.8
                  ],
                  [
                    63918.4,
                    31019.5
                  ],
                  [
                    63979.9,
                    31145
                  ],
                  [
                    63944.9,
                    31306.2
                  ],
                  [
                    63875,
                    31387.9
                  ],
                  [
                    63782.4,
                    31416.7
                  ],
                  [
                    63740.2,
                    31476.7
                  ],
                  [
                    63594,
                    31418.9
                  ],
                  [
                    63445,
                    31233.4
                  ],
                  [
                    63527.8,
                    31091.7
                  ]
                ],
                "id": 496,
                "chat_link": "[&BPABAAA=]"
              },
              "497": {
                "name": "Degun Shun",
                "level": 45,
                "coord": [
                  63692.8,
                  30247.4
                ],
                "bounds": [
                  [
                    63695,
                    30391.3
                  ],
                  [
                    63851.2,
                    30298.3
                  ],
                  [
                    63781.1,
                    30177
                  ],
                  [
                    63698.5,
                    30183.2
                  ],
                  [
                    63586.8,
                    30135.9
                  ],
                  [
                    63544.1,
                    30298.9
                  ],
                  [
                    63695,
                    30391.3
                  ]
                ],
                "id": 497,
                "chat_link": "[&BPEBAAA=]"
              },
              "498": {
                "name": "Agrak Kraal",
                "level": 45,
                "coord": [
                  63888,
                  30702.1
                ],
                "bounds": [
                  [
                    63855.5,
                    30566.8
                  ],
                  [
                    63937.4,
                    30576.7
                  ],
                  [
                    63946.3,
                    30708
                  ],
                  [
                    63970,
                    30827.9
                  ],
                  [
                    63847.8,
                    30864
                  ],
                  [
                    63771.2,
                    30669.4
                  ],
                  [
                    63855.5,
                    30566.8
                  ]
                ],
                "id": 498,
                "chat_link": "[&BPIBAAA=]"
              },
              "499": {
                "name": "Twin Sisters Crossing",
                "level": 42,
                "coord": [
                  63862.8,
                  32402.3
                ],
                "bounds": [
                  [
                    63927,
                    32682.5
                  ],
                  [
                    63797.7,
                    32729.8
                  ],
                  [
                    63678.9,
                    32732
                  ],
                  [
                    63567.1,
                    32672.7
                  ],
                  [
                    63547.2,
                    32581.1
                  ],
                  [
                    63612.6,
                    32474.9
                  ],
                  [
                    63559.8,
                    32276.8
                  ],
                  [
                    63645.6,
                    32136.1
                  ],
                  [
                    63901.9,
                    31992.3
                  ],
                  [
                    63945,
                    32022
                  ],
                  [
                    63957.7,
                    32129.7
                  ],
                  [
                    64026.3,
                    32249.1
                  ],
                  [
                    64121.1,
                    32326.2
                  ],
                  [
                    64202.4,
                    32366.9
                  ],
                  [
                    64241,
                    32436.5
                  ],
                  [
                    64074.1,
                    32628.4
                  ],
                  [
                    63927,
                    32682.5
                  ]
                ],
                "id": 499,
                "chat_link": "[&BPMBAAA=]"
              },
              "500": {
                "name": "Splinter Hills",
                "level": 42,
                "coord": [
                  63436.8,
                  32369.6
                ],
                "bounds": [
                  [
                    63036.6,
                    32228.9
                  ],
                  [
                    63648.4,
                    31681.5
                  ],
                  [
                    63923.3,
                    31813.4
                  ],
                  [
                    63906.8,
                    31993.9
                  ],
                  [
                    63645.5,
                    32137.2
                  ],
                  [
                    63559.9,
                    32277.8
                  ],
                  [
                    63612.5,
                    32475.6
                  ],
                  [
                    63548.9,
                    32581.5
                  ],
                  [
                    63569.1,
                    32673.9
                  ],
                  [
                    63427,
                    32726.4
                  ],
                  [
                    63250.9,
                    32645.8
                  ],
                  [
                    63095.1,
                    32692.7
                  ],
                  [
                    62937.4,
                    32653.1
                  ],
                  [
                    62953.7,
                    32592.1
                  ],
                  [
                    63036.6,
                    32228.9
                  ]
                ],
                "id": 500,
                "chat_link": "[&BPQBAAA=]"
              },
              "501": {
                "name": "Soot Road",
                "level": 42,
                "coord": [
                  63065.7,
                  31805.3
                ],
                "bounds": [
                  [
                    62763.1,
                    31650.1
                  ],
                  [
                    63278.9,
                    31499.1
                  ],
                  [
                    63273,
                    31723.4
                  ],
                  [
                    63386.3,
                    31922.3
                  ],
                  [
                    63044.8,
                    32226.1
                  ],
                  [
                    62647.9,
                    31810.5
                  ],
                  [
                    62763.1,
                    31650.1
                  ]
                ],
                "id": 501,
                "chat_link": "[&BPUBAAA=]"
              },
              "502": {
                "name": "Tongue Rock",
                "level": 45,
                "coord": [
                  62007.1,
                  30517.7
                ],
                "bounds": [
                  [
                    62232.6,
                    30493.1
                  ],
                  [
                    62156,
                    30619.2
                  ],
                  [
                    61988.4,
                    30604.4
                  ],
                  [
                    61818.8,
                    30755.6
                  ],
                  [
                    61834,
                    30623.4
                  ],
                  [
                    61898.2,
                    30479.3
                  ],
                  [
                    61876.1,
                    30403.2
                  ],
                  [
                    62014.4,
                    30456.3
                  ],
                  [
                    62099.9,
                    30361.9
                  ],
                  [
                    62152.6,
                    30381
                  ],
                  [
                    62232.6,
                    30493.1
                  ]
                ],
                "id": 502,
                "chat_link": "[&BPYBAAA=]"
              },
              "503": {
                "name": "Terra Combusta",
                "level": 49,
                "coord": [
                  62967.3,
                  28959.5
                ],
                "bounds": [
                  [
                    62914.2,
                    29238.7
                  ],
                  [
                    62669.5,
                    29019
                  ],
                  [
                    62515.1,
                    28641.8
                  ],
                  [
                    62776.6,
                    28568.7
                  ],
                  [
                    63054.8,
                    28653
                  ],
                  [
                    63103.2,
                    28738.1
                  ],
                  [
                    63387,
                    28803.3
                  ],
                  [
                    63161.3,
                    29217.8
                  ],
                  [
                    63199,
                    29380.4
                  ],
                  [
                    62891.9,
                    29334.6
                  ],
                  [
                    62914.2,
                    29238.7
                  ]
                ],
                "id": 503,
                "chat_link": "[&BPcBAAA=]"
              },
              "504": {
                "name": "Terra Carorunda",
                "level": 49,
                "coord": [
                  63646.7,
                  29033.7
                ],
                "bounds": [
                  [
                    63201.7,
                    29381.4
                  ],
                  [
                    63409.6,
                    29507.8
                  ],
                  [
                    63750.9,
                    29457.3
                  ],
                  [
                    63700,
                    29362.1
                  ],
                  [
                    63748.1,
                    29237
                  ],
                  [
                    63838.9,
                    29214.4
                  ],
                  [
                    63881,
                    29161.8
                  ],
                  [
                    63872.6,
                    28991.6
                  ],
                  [
                    63962.4,
                    28839.9
                  ],
                  [
                    63943.6,
                    28602.4
                  ],
                  [
                    63754.8,
                    28591
                  ],
                  [
                    63640.6,
                    28555.1
                  ],
                  [
                    63447.2,
                    28584
                  ],
                  [
                    63389.2,
                    28801
                  ],
                  [
                    63160.3,
                    29218.5
                  ],
                  [
                    63201.7,
                    29381.4
                  ]
                ],
                "id": 504,
                "chat_link": "[&BPgBAAA=]"
              },
              "505": {
                "name": "Shattered Palisades",
                "level": 49,
                "coord": [
                  63287.8,
                  29508.3
                ],
                "bounds": [
                  [
                    63449.3,
                    29664.6
                  ],
                  [
                    63735.3,
                    29560.1
                  ],
                  [
                    63750.7,
                    29455.5
                  ],
                  [
                    63408.7,
                    29506
                  ],
                  [
                    63200.8,
                    29377.6
                  ],
                  [
                    62817.8,
                    29319.5
                  ],
                  [
                    62844.4,
                    29604.2
                  ],
                  [
                    63095.2,
                    29579.1
                  ],
                  [
                    63449.3,
                    29664.6
                  ]
                ],
                "id": 505,
                "chat_link": "[&BPkBAAA=]"
              },
              "506": {
                "name": "Monument Grounds",
                "level": 50,
                "coord": [
                  62337.5,
                  29448.3
                ],
                "bounds": [
                  [
                    62494,
                    29697.9
                  ],
                  [
                    62842.3,
                    29604.2
                  ],
                  [
                    62815.3,
                    29323.4
                  ],
                  [
                    62445,
                    29310.7
                  ],
                  [
                    62394.7,
                    29405.1
                  ],
                  [
                    62030.1,
                    29409.7
                  ],
                  [
                    61826.2,
                    29318.8
                  ],
                  [
                    61852.4,
                    29516.2
                  ],
                  [
                    62494,
                    29697.9
                  ]
                ],
                "id": 506,
                "chat_link": "[&BPoBAAA=]"
              },
              "507": {
                "name": "Heretic Plain",
                "level": 47,
                "coord": [
                  63435.8,
                  29829
                ],
                "bounds": [
                  [
                    62818.3,
                    29770.1
                  ],
                  [
                    62841.7,
                    29605.5
                  ],
                  [
                    63095.3,
                    29579.2
                  ],
                  [
                    63445.5,
                    29663.5
                  ],
                  [
                    63733,
                    29560.5
                  ],
                  [
                    63873.3,
                    29555.4
                  ],
                  [
                    63930,
                    29805.3
                  ],
                  [
                    63930.2,
                    30021.5
                  ],
                  [
                    63856.9,
                    30170.4
                  ],
                  [
                    63696.5,
                    30184.3
                  ],
                  [
                    63082.1,
                    29961.7
                  ],
                  [
                    62926.8,
                    30071.2
                  ],
                  [
                    62818.3,
                    29770.1
                  ]
                ],
                "id": 507,
                "chat_link": "[&BPsBAAA=]"
              },
              "508": {
                "name": "Kindling Bridge",
                "level": 50,
                "coord": [
                  62106.6,
                  29094
                ],
                "bounds": [
                  [
                    61831.5,
                    29315.7
                  ],
                  [
                    61875,
                    29191.1
                  ],
                  [
                    61781.9,
                    29002.1
                  ],
                  [
                    61799.7,
                    28689.3
                  ],
                  [
                    62091.7,
                    28823.8
                  ],
                  [
                    62261.8,
                    28824.8
                  ],
                  [
                    62335.3,
                    28942.4
                  ],
                  [
                    62313.2,
                    29121.6
                  ],
                  [
                    62450.6,
                    29310
                  ],
                  [
                    62398.5,
                    29405.6
                  ],
                  [
                    62033.3,
                    29407.7
                  ],
                  [
                    61831.5,
                    29315.7
                  ]
                ],
                "id": 508,
                "chat_link": "[&BPwBAAA=]"
              },
              "509": {
                "name": "Dragonwatch",
                "level": 43,
                "coord": [
                  62071,
                  31427.8
                ],
                "bounds": [
                  [
                    62326.5,
                    31774.7
                  ],
                  [
                    62338.5,
                    31506.3
                  ],
                  [
                    62339,
                    31156.7
                  ],
                  [
                    62107.7,
                    31209.2
                  ],
                  [
                    61953.1,
                    31186
                  ],
                  [
                    61952,
                    31215.8
                  ],
                  [
                    61944.9,
                    31281.9
                  ],
                  [
                    61954.3,
                    31359.3
                  ],
                  [
                    61819.8,
                    31647.2
                  ],
                  [
                    61974.8,
                    31940.8
                  ],
                  [
                    62326.5,
                    31774.7
                  ]
                ],
                "id": 509,
                "chat_link": "[&BP0BAAA=]"
              },
              "510": {
                "name": "Ratcatcher Knoll",
                "level": 45,
                "coord": [
                  62202.2,
                  30748
                ],
                "bounds": [
                  [
                    62107.6,
                    31211
                  ],
                  [
                    61958.7,
                    31186.4
                  ],
                  [
                    61818.8,
                    30757.4
                  ],
                  [
                    61993.7,
                    30604.6
                  ],
                  [
                    62153.8,
                    30620.1
                  ],
                  [
                    62231.2,
                    30491.7
                  ],
                  [
                    62150.8,
                    30381.6
                  ],
                  [
                    62310.9,
                    30344.7
                  ],
                  [
                    62456.3,
                    30474.6
                  ],
                  [
                    62442.6,
                    30698.2
                  ],
                  [
                    62314.6,
                    30758.1
                  ],
                  [
                    62354.1,
                    31035.8
                  ],
                  [
                    62334.9,
                    31159.4
                  ],
                  [
                    62107.6,
                    31211
                  ]
                ],
                "id": 510,
                "chat_link": "[&BP4BAAA=]"
              },
              "511": {
                "name": "Relliatus Canyon",
                "level": 47,
                "coord": [
                  62217.2,
                  30139.4
                ],
                "bounds": [
                  [
                    62010,
                    30457.9
                  ],
                  [
                    62100.9,
                    30361.2
                  ],
                  [
                    62151.1,
                    30381
                  ],
                  [
                    62311,
                    30347.8
                  ],
                  [
                    62455,
                    30476.1
                  ],
                  [
                    62600.2,
                    30334.8
                  ],
                  [
                    62464.6,
                    30156.9
                  ],
                  [
                    62476.8,
                    30058.2
                  ],
                  [
                    62573.8,
                    30052.6
                  ],
                  [
                    62494.1,
                    29698.1
                  ],
                  [
                    61853.7,
                    29509.6
                  ],
                  [
                    61831.6,
                    29761.8
                  ],
                  [
                    61837.2,
                    29956.5
                  ],
                  [
                    61880.5,
                    30399.3
                  ],
                  [
                    62010,
                    30457.9
                  ]
                ],
                "id": 511,
                "chat_link": "[&BP8BAAA=]"
              },
              "758": {
                "name": "InGenium Research Facility",
                "level": 48,
                "coord": [
                  62584.6,
                  30155.2
                ],
                "bounds": [
                  [
                    62463.8,
                    30156.9
                  ],
                  [
                    62476.9,
                    30056.9
                  ],
                  [
                    62577.4,
                    30050.8
                  ],
                  [
                    62660.6,
                    30065.2
                  ],
                  [
                    62729.8,
                    30264
                  ],
                  [
                    62599.3,
                    30337.5
                  ],
                  [
                    62463.8,
                    30156.9
                  ]
                ],
                "id": 758,
                "chat_link": "[&BPYCAAA=]"
              }
            },
            "adventures": [],
            "id": 20,
            "mastery_points": []
          },
          "21": {
            "name": "Fields of Ruin",
            "min_level": 30,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              62976,
              34176
            ],
            "map_rect": [
              [
                -36864,
                -36864
              ],
              [
                36864,
                36864
              ]
            ],
            "continent_rect": [
              [
                61440,
                32640
              ],
              [
                64512,
                35712
              ]
            ],
            "points_of_interest": {
              "196": {
                "name": "Desert Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62575.4,
                  35613.3
                ],
                "id": 196,
                "chat_link": "[&BMQAAAA=]"
              },
              "197": {
                "name": "The Hawkgates",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62219.4,
                  34727.8
                ],
                "id": 197,
                "chat_link": "[&BMUAAAA=]"
              },
              "198": {
                "name": "Postern Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62430.4,
                  35420.9
                ],
                "id": 198,
                "chat_link": "[&BMYAAAA=]"
              },
              "199": {
                "name": "Spotter's Base",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62811,
                  34857.5
                ],
                "id": 199,
                "chat_link": "[&BMcAAAA=]"
              },
              "200": {
                "name": "Sapper's Delve",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63249.1,
                  35330.1
                ],
                "id": 200,
                "chat_link": "[&BMgAAAA=]"
              },
              "201": {
                "name": "Cymbel's Rescue",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64135.2,
                  34952.1
                ],
                "id": 201,
                "chat_link": "[&BMkAAAA=]"
              },
              "202": {
                "name": "Otyugh's Kraal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64031.5,
                  35189.9
                ],
                "id": 202,
                "chat_link": "[&BMoAAAA=]"
              },
              "203": {
                "name": "Wreckage of Doomspy's Watch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62257,
                  33811.3
                ],
                "id": 203,
                "chat_link": "[&BMsAAAA=]"
              },
              "204": {
                "name": "Varimhold Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61873.3,
                  32881.5
                ],
                "id": 204,
                "chat_link": "[&BMwAAAA=]"
              },
              "205": {
                "name": "Ebonhawke Delegation",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63123.1,
                  33937.4
                ],
                "id": 205,
                "chat_link": "[&BM0AAAA=]"
              },
              "206": {
                "name": "Summit Peak",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63070.5,
                  33619.2
                ],
                "id": 206,
                "chat_link": "[&BM4AAAA=]"
              },
              "207": {
                "name": "Gillscale Pond",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63575.9,
                  33322.2
                ],
                "id": 207,
                "chat_link": "[&BM8AAAA=]"
              },
              "208": {
                "name": "Delegation of the Legions",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63429.5,
                  33644.1
                ],
                "id": 208,
                "chat_link": "[&BNAAAAA=]"
              },
              "209": {
                "name": "The Thunder Den",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63283.3,
                  32814.3
                ],
                "id": 209,
                "chat_link": "[&BNEAAAA=]"
              },
              "210": {
                "name": "Foulbear Kraal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63490.8,
                  34551.1
                ],
                "id": 210,
                "chat_link": "[&BNIAAAA=]"
              },
              "211": {
                "name": "Hawkgates Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62124,
                  34784.3
                ],
                "id": 211,
                "chat_link": "[&BNMAAAA=]"
              },
              "212": {
                "name": "Deathblade's Watch Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64080.4,
                  34496.6
                ],
                "id": 212,
                "chat_link": "[&BNQAAAA=]"
              },
              "213": {
                "name": "Summit Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  63103.9,
                  33728.1
                ],
                "id": 213,
                "chat_link": "[&BNUAAAA=]"
              },
              "214": {
                "name": "Tyler's Bivouac Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  61792.4,
                  34406.1
                ],
                "id": 214,
                "chat_link": "[&BNYAAAA=]"
              },
              "215": {
                "name": "Tenaebron Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62073.2,
                  32995.4
                ],
                "id": 215,
                "chat_link": "[&BNcAAAA=]"
              },
              "216": {
                "name": "Rosko's Campsite Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  63570.6,
                  32957.4
                ],
                "id": 216,
                "chat_link": "[&BNgAAAA=]"
              },
              "330": {
                "name": "Skoll's Bivouac Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62633.5,
                  33391.2
                ],
                "id": 330,
                "chat_link": "[&BEoBAAA=]"
              },
              "331": {
                "name": "Helliot Mine Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  61744.7,
                  33678.2
                ],
                "id": 331,
                "chat_link": "[&BEsBAAA=]"
              },
              "332": {
                "name": "Fangfury Watch Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  63866.4,
                  33374.5
                ],
                "id": 332,
                "chat_link": "[&BEwBAAA=]"
              },
              "333": {
                "name": "Vulture's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62564.3,
                  33973.4
                ],
                "id": 333,
                "chat_link": "[&BE0BAAA=]"
              },
              "334": {
                "name": "Wreckage of Bloodgorge Watch Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  63112.9,
                  34430.4
                ],
                "id": 334,
                "chat_link": "[&BE4BAAA=]"
              },
              "335": {
                "name": "Ogre Road Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  63654.3,
                  34933.9
                ],
                "id": 335,
                "chat_link": "[&BE8BAAA=]"
              },
              "336": {
                "name": "Forlorn Gate Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62942.9,
                  35338.2
                ],
                "id": 336,
                "chat_link": "[&BFABAAA=]"
              },
              "337": {
                "name": "Fallen Angels Garrison Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  61782.8,
                  35261.6
                ],
                "id": 337,
                "chat_link": "[&BFEBAAA=]"
              },
              "1051": {
                "name": "The Hawke Heart",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62003,
                  35192.7
                ],
                "id": 1051,
                "chat_link": "[&BBsEAAA=]"
              },
              "1077": {
                "name": "Kestrel Market",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62328.9,
                  35073
                ],
                "id": 1077,
                "chat_link": "[&BDUEAAA=]"
              },
              "1078": {
                "name": "Defender's Field",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62340.4,
                  35551.4
                ],
                "id": 1078,
                "chat_link": "[&BDYEAAA=]"
              },
              "1084": {
                "name": "Spotter's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62781.8,
                  34729.3
                ],
                "id": 1084,
                "chat_link": "[&BDwEAAA=]"
              },
              "1085": {
                "name": "Kestrel Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62364.5,
                  35184.1
                ],
                "id": 1085,
                "chat_link": "[&BD0EAAA=]"
              },
              "1086": {
                "name": "Thunderbreak Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  62592.5,
                  32994.5
                ],
                "id": 1086,
                "chat_link": "[&BD4EAAA=]"
              },
              "1092": {
                "name": "Sentinel's Perch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62435.4,
                  33210.5
                ],
                "id": 1092,
                "chat_link": "[&BEQEAAA=]"
              },
              "1536": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  62042.5,
                  35502.4
                ],
                "id": 1536,
                "chat_link": "[&BAAGAAA=]"
              },
              "1537": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  62422.1,
                  33176
                ],
                "id": 1537,
                "chat_link": "[&BAEGAAA=]"
              },
              "1538": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  63622.8,
                  33791.3
                ],
                "id": 1538,
                "chat_link": "[&BAIGAAA=]"
              },
              "1539": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  64021.9,
                  34696.1
                ],
                "id": 1539,
                "chat_link": "[&BAMGAAA=]"
              },
              "1540": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  62130.3,
                  34461.3
                ],
                "id": 1540,
                "chat_link": "[&BAQGAAA=]"
              },
              "1541": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  63310.7,
                  34496.7
                ],
                "id": 1541,
                "chat_link": "[&BAUGAAA=]"
              },
              "1709": {
                "name": "Bloodgorge Watch Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62999.4,
                  34521.9
                ],
                "id": 1709,
                "chat_link": "[&BK0GAAA=]"
              }
            },
            "tasks": {
              "155": {
                "objective": "Help pacify Tyler's Bivouac for settlers.",
                "level": 34,
                "coord": [
                  61802,
                  34353.5
                ],
                "bounds": [
                  [
                    61518.6,
                    34661.6
                  ],
                  [
                    62069.9,
                    34536.7
                  ],
                  [
                    62196.1,
                    34470.7
                  ],
                  [
                    62163.5,
                    34258.5
                  ],
                  [
                    62192.9,
                    34190.4
                  ],
                  [
                    62183.5,
                    34072.2
                  ],
                  [
                    61728.2,
                    33990.3
                  ],
                  [
                    61634.4,
                    34043.4
                  ],
                  [
                    61686.3,
                    34141.1
                  ],
                  [
                    61518.6,
                    34661.6
                  ]
                ],
                "id": 155,
                "chat_link": "[&BJsAAAA=]"
              },
              "156": {
                "objective": "Hold back the insurrectionists.",
                "level": 33,
                "coord": [
                  62489.3,
                  34325
                ],
                "bounds": [
                  [
                    62527.4,
                    34525.9
                  ],
                  [
                    62426.4,
                    34411.6
                  ],
                  [
                    62206.5,
                    34467
                  ],
                  [
                    62165.6,
                    34212.5
                  ],
                  [
                    62435.6,
                    34132.4
                  ],
                  [
                    62644.8,
                    33985.5
                  ],
                  [
                    62765.4,
                    34025.7
                  ],
                  [
                    62818.7,
                    34183.5
                  ],
                  [
                    62727.9,
                    34397.3
                  ],
                  [
                    62527.4,
                    34525.9
                  ]
                ],
                "id": 156,
                "chat_link": "[&BJwAAAA=]"
              },
              "157": {
                "objective": "Help the people of Ebonhawke.",
                "level": 30,
                "coord": [
                  62030.4,
                  35066.9
                ],
                "bounds": [
                  [
                    62136.5,
                    35405.9
                  ],
                  [
                    61975.9,
                    35398.2
                  ],
                  [
                    61834,
                    35231.6
                  ],
                  [
                    61851.9,
                    35045.1
                  ],
                  [
                    62255.5,
                    34734.3
                  ],
                  [
                    62472.3,
                    35021.2
                  ],
                  [
                    62447.9,
                    35381.9
                  ],
                  [
                    62136.5,
                    35405.9
                  ]
                ],
                "id": 157,
                "chat_link": "[&BJ0AAAA=]"
              },
              "158": {
                "objective": "Help Commander Varalyn and the Ebon Vanguard.",
                "level": 31,
                "coord": [
                  61710.4,
                  35329.3
                ],
                "bounds": [
                  [
                    61811.3,
                    34983
                  ],
                  [
                    61808.1,
                    35268.4
                  ],
                  [
                    61979.6,
                    35425.7
                  ],
                  [
                    61876.2,
                    35518.1
                  ],
                  [
                    61622.1,
                    35322.5
                  ],
                  [
                    61449.8,
                    34918
                  ],
                  [
                    61749.4,
                    34934.5
                  ],
                  [
                    61811.3,
                    34983
                  ]
                ],
                "id": 158,
                "chat_link": "[&BJ4AAAA=]"
              },
              "159": {
                "objective": "Help Foreman Boslo care for Blackwing Excavation.",
                "level": 31,
                "coord": [
                  62555.2,
                  35484.4
                ],
                "bounds": [
                  [
                    62710.6,
                    35688.9
                  ],
                  [
                    62845.9,
                    35368
                  ],
                  [
                    62794.8,
                    35278.3
                  ],
                  [
                    62433.7,
                    35235.7
                  ],
                  [
                    62428.2,
                    35694.6
                  ],
                  [
                    62710.6,
                    35688.9
                  ]
                ],
                "id": 159,
                "chat_link": "[&BJ8AAAA=]"
              },
              "160": {
                "objective": "Help the Iron Legion disrupt Renegade operations.",
                "level": 38,
                "coord": [
                  63062.2,
                  33114.6
                ],
                "bounds": [
                  [
                    63386.8,
                    32681.2
                  ],
                  [
                    63386.7,
                    32883.8
                  ],
                  [
                    63338.7,
                    32984.9
                  ],
                  [
                    63170.8,
                    33043.8
                  ],
                  [
                    63086.9,
                    33117.1
                  ],
                  [
                    63038.5,
                    33129.2
                  ],
                  [
                    62930.4,
                    33093.6
                  ],
                  [
                    62904.9,
                    32946.4
                  ],
                  [
                    62902.6,
                    32833.8
                  ],
                  [
                    63386.8,
                    32681.2
                  ]
                ],
                "id": 160,
                "chat_link": "[&BKAAAAA=]"
              },
              "161": {
                "objective": "Assist the charr delegation.",
                "level": 36,
                "coord": [
                  63395.8,
                  33625.3
                ],
                "bounds": [
                  [
                    63215.3,
                    33532.4
                  ],
                  [
                    63422,
                    33412
                  ],
                  [
                    63584.6,
                    33489.1
                  ],
                  [
                    63641.9,
                    33565
                  ],
                  [
                    63667.3,
                    33667.2
                  ],
                  [
                    63659.2,
                    33784.9
                  ],
                  [
                    63537.3,
                    34039.5
                  ],
                  [
                    63440.8,
                    34021.2
                  ],
                  [
                    63392.8,
                    33983.8
                  ],
                  [
                    63379.5,
                    33877.7
                  ],
                  [
                    63232.1,
                    33663.2
                  ],
                  [
                    63215.3,
                    33532.4
                  ]
                ],
                "id": 161,
                "chat_link": "[&BKEAAAA=]"
              },
              "162": {
                "objective": "Support the human delegation.",
                "level": 35,
                "coord": [
                  63092.5,
                  33933.1
                ],
                "bounds": [
                  [
                    62810.5,
                    33689.8
                  ],
                  [
                    62867.9,
                    33689.8
                  ],
                  [
                    63018.6,
                    33725.1
                  ],
                  [
                    63092,
                    33726.4
                  ],
                  [
                    63367.5,
                    33890
                  ],
                  [
                    63433.9,
                    34305.4
                  ],
                  [
                    63084.2,
                    34399.8
                  ],
                  [
                    62966.6,
                    34362.2
                  ],
                  [
                    62844.4,
                    34183.5
                  ],
                  [
                    62812,
                    34097
                  ],
                  [
                    62730.6,
                    33843.6
                  ],
                  [
                    62747,
                    33796.6
                  ],
                  [
                    62810.5,
                    33689.8
                  ]
                ],
                "id": 162,
                "chat_link": "[&BKIAAAA=]"
              },
              "163": {
                "objective": "Contain the growth of the Dragonbrand.",
                "level": 39,
                "coord": [
                  62364.1,
                  33049.8
                ],
                "bounds": [
                  [
                    61990.8,
                    32837.6
                  ],
                  [
                    62517.4,
                    32841.1
                  ],
                  [
                    62435.8,
                    33280.4
                  ],
                  [
                    62264.6,
                    33539
                  ],
                  [
                    61902.1,
                    33528.2
                  ],
                  [
                    61990.8,
                    32837.6
                  ]
                ],
                "id": 163,
                "chat_link": "[&BKMAAAA=]"
              },
              "164": {
                "objective": "Aid the researchers in their study of the Brand.",
                "level": 40,
                "coord": [
                  61872.1,
                  32945.7
                ],
                "bounds": [
                  [
                    61895.9,
                    33450
                  ],
                  [
                    61984.6,
                    32815.5
                  ],
                  [
                    61827.4,
                    32790.3
                  ],
                  [
                    61558.9,
                    32975.6
                  ],
                  [
                    61627.7,
                    33423.4
                  ],
                  [
                    61895.9,
                    33450
                  ]
                ],
                "id": 164,
                "chat_link": "[&BKQAAAA=]"
              },
              "165": {
                "objective": "Help Rosko's ranchers protect the village.",
                "level": 37,
                "coord": [
                  63904.3,
                  33088.9
                ],
                "bounds": [
                  [
                    64403.7,
                    32759.9
                  ],
                  [
                    64466.3,
                    32955.9
                  ],
                  [
                    64484.2,
                    33164.8
                  ],
                  [
                    64336.6,
                    33228.3
                  ],
                  [
                    64237.9,
                    33279.6
                  ],
                  [
                    64125.3,
                    33350.8
                  ],
                  [
                    63977.7,
                    33328.5
                  ],
                  [
                    63932.7,
                    33330.9
                  ],
                  [
                    63710,
                    33153.2
                  ],
                  [
                    63594.3,
                    33029.1
                  ],
                  [
                    63654.6,
                    32923.8
                  ],
                  [
                    63721.6,
                    32867.7
                  ],
                  [
                    63951.9,
                    32754.6
                  ],
                  [
                    64195.7,
                    32685
                  ],
                  [
                    64403.7,
                    32759.9
                  ]
                ],
                "id": 165,
                "chat_link": "[&BKUAAAA=]"
              },
              "166": {
                "objective": "Help the Vanguard stall the ogre advance.",
                "level": 32,
                "coord": [
                  63294.1,
                  35489.4
                ],
                "bounds": [
                  [
                    63114.2,
                    35230.8
                  ],
                  [
                    63162.6,
                    35064.6
                  ],
                  [
                    63509.3,
                    35052.8
                  ],
                  [
                    63666.1,
                    35158.6
                  ],
                  [
                    63563.9,
                    35455.3
                  ],
                  [
                    63345.7,
                    35568.4
                  ],
                  [
                    63198.4,
                    35565.5
                  ],
                  [
                    63064.7,
                    35467
                  ],
                  [
                    63114.2,
                    35230.8
                  ]
                ],
                "id": 166,
                "chat_link": "[&BKYAAAA=]"
              },
              "167": {
                "objective": "Harass the ogres of Foulbear Kraal.",
                "level": 33,
                "coord": [
                  63473.5,
                  34958.4
                ],
                "bounds": [
                  [
                    63491.9,
                    35048
                  ],
                  [
                    63201.1,
                    35053.5
                  ],
                  [
                    63092.1,
                    35009.9
                  ],
                  [
                    63086.2,
                    34663.7
                  ],
                  [
                    63193.7,
                    34373.4
                  ],
                  [
                    63576.8,
                    34271.6
                  ],
                  [
                    63753.1,
                    34306.8
                  ],
                  [
                    63792.8,
                    34491.5
                  ],
                  [
                    63787.1,
                    34730
                  ],
                  [
                    63743.8,
                    34934.7
                  ],
                  [
                    63491.9,
                    35048
                  ]
                ],
                "id": 167,
                "chat_link": "[&BKcAAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  63510.6,
                  35111.9
                ],
                "id": "0-43"
              },
              {
                "coord": [
                  62345.1,
                  35601.8
                ],
                "id": "0-126"
              },
              {
                "coord": [
                  64342,
                  33143.2
                ],
                "id": "0-61"
              },
              {
                "coord": [
                  61807.6,
                  35399.7
                ],
                "id": "0-125"
              },
              {
                "coord": [
                  61590,
                  32788.8
                ],
                "id": "0-127"
              }
            ],
            "sectors": {
              "365": {
                "name": "Last Stand Shelter",
                "level": 31,
                "coord": [
                  61657.9,
                  35015.4
                ],
                "bounds": [
                  [
                    61456.9,
                    34889.1
                  ],
                  [
                    61607.9,
                    34741.1
                  ],
                  [
                    61812.8,
                    34931.5
                  ],
                  [
                    61785.2,
                    35009.7
                  ],
                  [
                    61709.3,
                    35063.5
                  ],
                  [
                    61698.5,
                    35205.7
                  ],
                  [
                    61534.8,
                    35267.4
                  ],
                  [
                    61456.9,
                    34889.1
                  ]
                ],
                "id": 365,
                "chat_link": "[&BG0BAAA=]"
              },
              "366": {
                "name": "Blackwing Excavation",
                "level": 31,
                "coord": [
                  62641.1,
                  35403.7
                ],
                "bounds": [
                  [
                    62557.5,
                    35091.2
                  ],
                  [
                    62771.9,
                    35156.6
                  ],
                  [
                    62878.7,
                    35543.5
                  ],
                  [
                    62746.7,
                    35649.8
                  ],
                  [
                    62451.9,
                    35654.8
                  ],
                  [
                    62440,
                    35326.3
                  ],
                  [
                    62557.5,
                    35091.2
                  ]
                ],
                "id": 366,
                "chat_link": "[&BG4BAAA=]"
              },
              "367": {
                "name": "Stronghold of Ebonhawke",
                "level": 31,
                "coord": [
                  62008.8,
                  35138
                ],
                "bounds": [
                  [
                    61812.5,
                    34931.7
                  ],
                  [
                    61608.6,
                    34739.7
                  ],
                  [
                    61974.8,
                    34550.6
                  ],
                  [
                    62116.3,
                    34621.3
                  ],
                  [
                    62342,
                    34818.7
                  ],
                  [
                    62699,
                    34688.4
                  ],
                  [
                    62557.7,
                    35091.4
                  ],
                  [
                    62440.8,
                    35324.7
                  ],
                  [
                    62450.3,
                    35654.7
                  ],
                  [
                    62165.5,
                    35625.2
                  ],
                  [
                    61939.4,
                    35533.8
                  ],
                  [
                    61770.3,
                    35659.5
                  ],
                  [
                    61542.8,
                    35558.4
                  ],
                  [
                    61534.8,
                    35269.1
                  ],
                  [
                    61699,
                    35206.4
                  ],
                  [
                    61709.8,
                    35064.6
                  ],
                  [
                    61785.5,
                    35008.6
                  ],
                  [
                    61812.5,
                    34931.7
                  ]
                ],
                "id": 367,
                "chat_link": "[&BG8BAAA=]"
              },
              "368": {
                "name": "Grimm Hills",
                "level": 34,
                "coord": [
                  62913.6,
                  34678.1
                ],
                "bounds": [
                  [
                    62775,
                    35155.6
                  ],
                  [
                    63095.2,
                    34880.6
                  ],
                  [
                    63095,
                    34671.8
                  ],
                  [
                    63212.3,
                    34293.8
                  ],
                  [
                    63014.9,
                    34325.3
                  ],
                  [
                    62889.8,
                    34422.3
                  ],
                  [
                    62883.8,
                    34575
                  ],
                  [
                    62698.5,
                    34687.4
                  ],
                  [
                    62558.2,
                    35091.2
                  ],
                  [
                    62775,
                    35155.6
                  ]
                ],
                "id": 368,
                "chat_link": "[&BHABAAA=]"
              },
              "369": {
                "name": "The Ogre Road",
                "level": 33,
                "coord": [
                  63775.2,
                  34960.3
                ],
                "bounds": [
                  [
                    63818,
                    34775.5
                  ],
                  [
                    64049.9,
                    34874.6
                  ],
                  [
                    63983.2,
                    35117.8
                  ],
                  [
                    63650.4,
                    35343.8
                  ],
                  [
                    63469.1,
                    34973.7
                  ],
                  [
                    63680.8,
                    34676.6
                  ],
                  [
                    63818,
                    34775.5
                  ]
                ],
                "id": 369,
                "chat_link": "[&BHEBAAA=]"
              },
              "370": {
                "name": "Wildlin Narrows",
                "level": 34,
                "coord": [
                  64113.6,
                  35332.1
                ],
                "bounds": [
                  [
                    63981.4,
                    35119
                  ],
                  [
                    64047.3,
                    34879.9
                  ],
                  [
                    64446.4,
                    34880.2
                  ],
                  [
                    64454.7,
                    35016.9
                  ],
                  [
                    64482.5,
                    35162.6
                  ],
                  [
                    64437,
                    35419.7
                  ],
                  [
                    64379.4,
                    35572.2
                  ],
                  [
                    64266.7,
                    35658.7
                  ],
                  [
                    63887.2,
                    35684.1
                  ],
                  [
                    63726.7,
                    35630.3
                  ],
                  [
                    63602.3,
                    35623
                  ],
                  [
                    63651.7,
                    35338
                  ],
                  [
                    63981.4,
                    35119
                  ]
                ],
                "id": 370,
                "chat_link": "[&BHIBAAA=]"
              },
              "371": {
                "name": "Mithric Cliffs",
                "level": 35,
                "coord": [
                  64140.7,
                  34560.1
                ],
                "bounds": [
                  [
                    63873.1,
                    34199.8
                  ],
                  [
                    64439.5,
                    34200.8
                  ],
                  [
                    64522.9,
                    34271.7
                  ],
                  [
                    64421.7,
                    34550.9
                  ],
                  [
                    64486.2,
                    34796.1
                  ],
                  [
                    64446.4,
                    34880
                  ],
                  [
                    64049.8,
                    34881.8
                  ],
                  [
                    63817.7,
                    34776.3
                  ],
                  [
                    63679.6,
                    34676
                  ],
                  [
                    63670,
                    34367.5
                  ],
                  [
                    63873.1,
                    34199.8
                  ]
                ],
                "id": 371,
                "chat_link": "[&BHMBAAA=]"
              },
              "372": {
                "name": "Hunter's Gorge",
                "level": 35,
                "coord": [
                  63341.8,
                  34640.5
                ],
                "bounds": [
                  [
                    63669.7,
                    34367.2
                  ],
                  [
                    63679.1,
                    34676
                  ],
                  [
                    63470.3,
                    34973.3
                  ],
                  [
                    63163.9,
                    34985.8
                  ],
                  [
                    63094,
                    34882.4
                  ],
                  [
                    63095.7,
                    34672.5
                  ],
                  [
                    63212.8,
                    34294.4
                  ],
                  [
                    63348.8,
                    34272.4
                  ],
                  [
                    63669.7,
                    34367.2
                  ]
                ],
                "id": 372,
                "chat_link": "[&BHQBAAA=]"
              },
              "373": {
                "name": "The Siege Plains",
                "level": 33,
                "coord": [
                  62661.4,
                  34431.1
                ],
                "bounds": [
                  [
                    62342.5,
                    34820
                  ],
                  [
                    62698.4,
                    34688
                  ],
                  [
                    62884,
                    34573.7
                  ],
                  [
                    62895.1,
                    34415.3
                  ],
                  [
                    63015.8,
                    34325.2
                  ],
                  [
                    62807.6,
                    34052
                  ],
                  [
                    62532,
                    33954.3
                  ],
                  [
                    62115.9,
                    34620.7
                  ],
                  [
                    62342.5,
                    34820
                  ]
                ],
                "id": 373,
                "chat_link": "[&BHUBAAA=]"
              },
              "374": {
                "name": "Sniper's Woods",
                "level": 35,
                "coord": [
                  62135,
                  34190.4
                ],
                "bounds": [
                  [
                    61976.5,
                    34544.7
                  ],
                  [
                    62116.8,
                    34620
                  ],
                  [
                    62531.9,
                    33954
                  ],
                  [
                    62317,
                    33906.1
                  ],
                  [
                    62102.3,
                    34036.9
                  ],
                  [
                    61765.8,
                    34080.3
                  ],
                  [
                    61976.5,
                    34544.7
                  ]
                ],
                "id": 374,
                "chat_link": "[&BHYBAAA=]"
              },
              "375": {
                "name": "Bento Canyon",
                "level": 34,
                "coord": [
                  61654.1,
                  34397.7
                ],
                "bounds": [
                  [
                    61608.5,
                    34740
                  ],
                  [
                    61977.2,
                    34544.8
                  ],
                  [
                    61766,
                    34081.3
                  ],
                  [
                    61522.8,
                    34074.4
                  ],
                  [
                    61571.5,
                    34348
                  ],
                  [
                    61478.8,
                    34597.5
                  ],
                  [
                    61608.5,
                    34740
                  ]
                ],
                "id": 375,
                "chat_link": "[&BHcBAAA=]"
              },
              "376": {
                "name": "Dragonrot Domains",
                "level": 38,
                "coord": [
                  61711,
                  33852.5
                ],
                "bounds": [
                  [
                    61522.5,
                    34074.1
                  ],
                  [
                    61765.8,
                    34080.1
                  ],
                  [
                    62103,
                    34037.3
                  ],
                  [
                    61890.2,
                    33602.7
                  ],
                  [
                    61522.8,
                    33605.5
                  ],
                  [
                    61461.9,
                    33715.2
                  ],
                  [
                    61522.5,
                    34074.1
                  ]
                ],
                "id": 376,
                "chat_link": "[&BHgBAAA=]"
              },
              "377": {
                "name": "Varim's Run",
                "level": 40,
                "coord": [
                  61676.3,
                  33049.4
                ],
                "bounds": [
                  [
                    61684.6,
                    32846.2
                  ],
                  [
                    61627.8,
                    32689
                  ],
                  [
                    61783.8,
                    32640.9
                  ],
                  [
                    62037,
                    32658.6
                  ],
                  [
                    61927,
                    32793.8
                  ],
                  [
                    61888.9,
                    33603.3
                  ],
                  [
                    61521.8,
                    33606.4
                  ],
                  [
                    61568.4,
                    33387.3
                  ],
                  [
                    61411.7,
                    33325.3
                  ],
                  [
                    61408,
                    33080.2
                  ],
                  [
                    61580,
                    32912.1
                  ],
                  [
                    61684.6,
                    32846.2
                  ]
                ],
                "id": 377,
                "chat_link": "[&BHkBAAA=]"
              },
              "378": {
                "name": "Tenaebron Lake",
                "level": 39,
                "coord": [
                  62214.2,
                  33182.2
                ],
                "bounds": [
                  [
                    61884.8,
                    33603.9
                  ],
                  [
                    62102.9,
                    34046.4
                  ],
                  [
                    62317.7,
                    33899.6
                  ],
                  [
                    62262.7,
                    33569.9
                  ],
                  [
                    62495.3,
                    33233.3
                  ],
                  [
                    62442.7,
                    32764
                  ],
                  [
                    62420.4,
                    32651.8
                  ],
                  [
                    62238,
                    32617.8
                  ],
                  [
                    62046.1,
                    32647.3
                  ],
                  [
                    61931.3,
                    32787.9
                  ],
                  [
                    61884.8,
                    33603.9
                  ]
                ],
                "id": 378,
                "chat_link": "[&BHoBAAA=]"
              },
              "379": {
                "name": "Vulture's Sweep",
                "level": 37,
                "coord": [
                  62545.4,
                  33687.2
                ],
                "bounds": [
                  [
                    62315.8,
                    33906
                  ],
                  [
                    62530.4,
                    33952.9
                  ],
                  [
                    62805.8,
                    34052.8
                  ],
                  [
                    62867.3,
                    33390.9
                  ],
                  [
                    62492.3,
                    33242.2
                  ],
                  [
                    62260.7,
                    33578.4
                  ],
                  [
                    62315.8,
                    33906
                  ]
                ],
                "id": 379,
                "chat_link": "[&BHsBAAA=]"
              },
              "380": {
                "name": "Warrior's Crown",
                "level": 36,
                "coord": [
                  63286.9,
                  33885.3
                ],
                "bounds": [
                  [
                    62867.6,
                    33388
                  ],
                  [
                    63792.5,
                    33512.5
                  ],
                  [
                    63709.9,
                    33749.2
                  ],
                  [
                    63468.1,
                    33900.9
                  ],
                  [
                    63349.3,
                    34273.4
                  ],
                  [
                    63014.9,
                    34324.5
                  ],
                  [
                    62805.9,
                    34048.8
                  ],
                  [
                    62867.6,
                    33388
                  ]
                ],
                "id": 380,
                "chat_link": "[&BHwBAAA=]"
              },
              "381": {
                "name": "Belag Crossroads",
                "level": 35,
                "coord": [
                  63662.8,
                  34062.1
                ],
                "bounds": [
                  [
                    63348.9,
                    34273.4
                  ],
                  [
                    63669.7,
                    34368.1
                  ],
                  [
                    63873.3,
                    34199.3
                  ],
                  [
                    63905.5,
                    33881.5
                  ],
                  [
                    63711,
                    33749.6
                  ],
                  [
                    63468.4,
                    33900.9
                  ],
                  [
                    63348.9,
                    34273.4
                  ]
                ],
                "id": 381,
                "chat_link": "[&BH0BAAA=]"
              },
              "382": {
                "name": "Flameroot Caverns",
                "level": 36,
                "coord": [
                  64189.7,
                  33999.4
                ],
                "bounds": [
                  [
                    63872.4,
                    34199.8
                  ],
                  [
                    64439.4,
                    34201.8
                  ],
                  [
                    64395.5,
                    34050.3
                  ],
                  [
                    64466,
                    33931.9
                  ],
                  [
                    64059.3,
                    33731.8
                  ],
                  [
                    63905.5,
                    33880.9
                  ],
                  [
                    63872.4,
                    34199.8
                  ]
                ],
                "id": 382,
                "chat_link": "[&BH4BAAA=]"
              },
              "383": {
                "name": "Highden Caves",
                "level": 37,
                "coord": [
                  64321.2,
                  33581.6
                ],
                "bounds": [
                  [
                    64058.1,
                    33737.1
                  ],
                  [
                    64465.7,
                    33931.5
                  ],
                  [
                    64495.3,
                    33748.5
                  ],
                  [
                    64427.9,
                    33511.7
                  ],
                  [
                    64421.5,
                    33370.7
                  ],
                  [
                    64304.1,
                    33239.5
                  ],
                  [
                    64075.8,
                    33532.5
                  ],
                  [
                    64058.1,
                    33737.1
                  ]
                ],
                "id": 383,
                "chat_link": "[&BH8BAAA=]"
              },
              "384": {
                "name": "Axedrag Cut",
                "level": 37,
                "coord": [
                  63990.9,
                  33565.5
                ],
                "bounds": [
                  [
                    63881.1,
                    33256.4
                  ],
                  [
                    64304,
                    33239.1
                  ],
                  [
                    64083.4,
                    33532.1
                  ],
                  [
                    64061.1,
                    33735.1
                  ],
                  [
                    63905.5,
                    33881.2
                  ],
                  [
                    63710.1,
                    33748.8
                  ],
                  [
                    63881.1,
                    33256.4
                  ]
                ],
                "id": 384,
                "chat_link": "[&BIABAAA=]"
              },
              "385": {
                "name": "Tanglerot Hills",
                "level": 38,
                "coord": [
                  64171.4,
                  32762.6
                ],
                "bounds": [
                  [
                    63983.3,
                    32611.9
                  ],
                  [
                    63951.1,
                    32609.5
                  ],
                  [
                    64029.3,
                    32351.6
                  ],
                  [
                    64129.6,
                    32438.2
                  ],
                  [
                    64262.5,
                    32504.9
                  ],
                  [
                    64348,
                    32526.6
                  ],
                  [
                    64495,
                    32743.9
                  ],
                  [
                    64478.6,
                    33115.1
                  ],
                  [
                    64304,
                    33238.5
                  ],
                  [
                    63880,
                    33257.4
                  ],
                  [
                    64024.1,
                    32991.5
                  ],
                  [
                    63983.3,
                    32611.9
                  ]
                ],
                "id": 385,
                "chat_link": "[&BIEBAAA=]"
              },
              "386": {
                "name": "Halkor Meadows",
                "level": 38,
                "coord": [
                  63745.8,
                  32858
                ],
                "bounds": [
                  [
                    63566.3,
                    33004.5
                  ],
                  [
                    63855.8,
                    33329.6
                  ],
                  [
                    63879.9,
                    33259.8
                  ],
                  [
                    64024.2,
                    32991.6
                  ],
                  [
                    64008,
                    32735
                  ],
                  [
                    63986.5,
                    32610.7
                  ],
                  [
                    63759.8,
                    32579.6
                  ],
                  [
                    63522.4,
                    32646.3
                  ],
                  [
                    63394.6,
                    32629.6
                  ],
                  [
                    63460.5,
                    32793.5
                  ],
                  [
                    63566.3,
                    33004.5
                  ]
                ],
                "id": 386,
                "chat_link": "[&BIIBAAA=]"
              },
              "387": {
                "name": "Thunderbreak Hills",
                "level": 38,
                "coord": [
                  62924.8,
                  32849.6
                ],
                "bounds": [
                  [
                    63401.1,
                    32628
                  ],
                  [
                    63567,
                    33004.2
                  ],
                  [
                    63218.8,
                    33031.5
                  ],
                  [
                    62867.4,
                    33390
                  ],
                  [
                    62493,
                    33242.9
                  ],
                  [
                    62440,
                    32773.5
                  ],
                  [
                    62420.6,
                    32649
                  ],
                  [
                    62745,
                    32572
                  ],
                  [
                    62954.7,
                    32648.8
                  ],
                  [
                    63140.4,
                    32556.1
                  ],
                  [
                    63401.1,
                    32628
                  ]
                ],
                "id": 387,
                "chat_link": "[&BIMBAAA=]"
              },
              "388": {
                "name": "Hautclaire Vale",
                "level": 31,
                "coord": [
                  63239.6,
                  35319.1
                ],
                "bounds": [
                  [
                    63094.3,
                    34879.9
                  ],
                  [
                    63162.7,
                    34986.4
                  ],
                  [
                    63470.2,
                    34971.3
                  ],
                  [
                    63650.7,
                    35342.5
                  ],
                  [
                    63603.5,
                    35626.5
                  ],
                  [
                    63482.8,
                    35538.9
                  ],
                  [
                    63249.2,
                    35599.6
                  ],
                  [
                    63033.2,
                    35546.5
                  ],
                  [
                    62877.4,
                    35543.2
                  ],
                  [
                    62772.5,
                    35155.8
                  ],
                  [
                    63094.3,
                    34879.9
                  ]
                ],
                "id": 388,
                "chat_link": "[&BIQBAAA=]"
              },
              "389": {
                "name": "Gillfarn Plains",
                "level": 38,
                "coord": [
                  63459.3,
                  33253.3
                ],
                "bounds": [
                  [
                    62864.8,
                    33390.4
                  ],
                  [
                    63792.2,
                    33514.1
                  ],
                  [
                    63855.6,
                    33329
                  ],
                  [
                    63566.4,
                    33004.3
                  ],
                  [
                    63217.5,
                    33028.6
                  ],
                  [
                    62864.8,
                    33390.4
                  ]
                ],
                "id": 389,
                "chat_link": "[&BIUBAAA=]"
              },
              "877": {
                "name": "Secluded Glen",
                "level": 40,
                "coord": [
                  61571.1,
                  32795.5
                ],
                "bounds": [
                  [
                    61579.8,
                    32911.9
                  ],
                  [
                    61685,
                    32846.5
                  ],
                  [
                    61634.9,
                    32697
                  ],
                  [
                    61505.3,
                    32679.9
                  ],
                  [
                    61450.4,
                    32842.2
                  ],
                  [
                    61579.8,
                    32911.9
                  ]
                ],
                "id": 877,
                "chat_link": "[&BG0DAAA=]"
              }
            },
            "adventures": [],
            "id": 21,
            "mastery_points": []
          },
          "22": {
            "name": "Fireheart Rise",
            "min_level": 60,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              58240,
              26240
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                56576,
                24832
              ],
              [
                59904,
                27648
              ]
            ],
            "points_of_interest": {
              "518": {
                "name": "Coalpit Watchpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58460.3,
                  26464.9
                ],
                "id": 518,
                "chat_link": "[&BAYCAAA=]"
              },
              "519": {
                "name": "Shadow Cleft",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57884.8,
                  25738.1
                ],
                "id": 519,
                "chat_link": "[&BAcCAAA=]"
              },
              "520": {
                "name": "Veiled Cliff",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57836.3,
                  26176.5
                ],
                "id": 520,
                "chat_link": "[&BAgCAAA=]"
              },
              "521": {
                "name": "Piketooth Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58081.3,
                  25788.7
                ],
                "id": 521,
                "chat_link": "[&BAkCAAA=]"
              },
              "522": {
                "name": "Gates of Flame",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59321.5,
                  25339.2
                ],
                "id": 522,
                "chat_link": "[&BAoCAAA=]"
              },
              "523": {
                "name": "Termerarus Castrum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58750.1,
                  26917.7
                ],
                "id": 523,
                "chat_link": "[&BAsCAAA=]"
              },
              "524": {
                "name": "Provatum Castrum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58502.8,
                  26010.6
                ],
                "id": 524,
                "chat_link": "[&BAwCAAA=]"
              },
              "525": {
                "name": "Atrox Castrum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57382.9,
                  26941.3
                ],
                "id": 525,
                "chat_link": "[&BA0CAAA=]"
              },
              "526": {
                "name": "Noxious Castrum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59205.3,
                  26136.1
                ],
                "id": 526,
                "chat_link": "[&BA4CAAA=]"
              },
              "527": {
                "name": "Haymal Gore",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56882.9,
                  25646.9
                ],
                "id": 527,
                "chat_link": "[&BA8CAAA=]"
              },
              "528": {
                "name": "Heart Speaks Not",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57277.3,
                  26522.3
                ],
                "id": 528,
                "chat_link": "[&BBACAAA=]"
              },
              "529": {
                "name": "God's Eye",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56987.7,
                  26843.3
                ],
                "id": 529,
                "chat_link": "[&BBECAAA=]"
              },
              "530": {
                "name": "God's Skull",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57052.4,
                  27423.2
                ],
                "id": 530,
                "chat_link": "[&BBICAAA=]"
              },
              "531": {
                "name": "God's Hand",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56828,
                  27080.4
                ],
                "id": 531,
                "chat_link": "[&BBMCAAA=]"
              },
              "532": {
                "name": "Mangonel Bivouac",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57052.6,
                  24937.7
                ],
                "id": 532,
                "chat_link": "[&BBQCAAA=]"
              },
              "533": {
                "name": "Division Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58043.6,
                  26814.6
                ],
                "id": 533,
                "chat_link": "[&BBUCAAA=]"
              },
              "534": {
                "name": "Sati Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59744.8,
                  27162.5
                ],
                "id": 534,
                "chat_link": "[&BBYCAAA=]"
              },
              "535": {
                "name": "Pig Iron Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58967.9,
                  26938.7
                ],
                "id": 535,
                "chat_link": "[&BBcCAAA=]"
              },
              "536": {
                "name": "Tuyere Command Post Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59385.2,
                  27359.9
                ],
                "id": 536,
                "chat_link": "[&BBgCAAA=]"
              },
              "537": {
                "name": "Severed Breach Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58629.5,
                  27336.5
                ],
                "id": 537,
                "chat_link": "[&BBkCAAA=]"
              },
              "538": {
                "name": "Breaktooth's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59569.1,
                  26192.2
                ],
                "id": 538,
                "chat_link": "[&BBoCAAA=]"
              },
              "539": {
                "name": "Havoc Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57895.6,
                  26719.1
                ],
                "id": 539,
                "chat_link": "[&BBsCAAA=]"
              },
              "540": {
                "name": "Vidius Castrum Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58054.7,
                  27217.1
                ],
                "id": 540,
                "chat_link": "[&BBwCAAA=]"
              },
              "541": {
                "name": "Apostate Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57161.4,
                  26998.7
                ],
                "id": 541,
                "chat_link": "[&BB0CAAA=]"
              },
              "542": {
                "name": "Rustbowl Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  56822.4,
                  26176.7
                ],
                "id": 542,
                "chat_link": "[&BB4CAAA=]"
              },
              "543": {
                "name": "Switchback Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57651.7,
                  26176
                ],
                "id": 543,
                "chat_link": "[&BB8CAAA=]"
              },
              "544": {
                "name": "Icespear's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57120.7,
                  25165.5
                ],
                "id": 544,
                "chat_link": "[&BCACAAA=]"
              },
              "545": {
                "name": "Snow Ridge Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57537.6,
                  24911.1
                ],
                "id": 545,
                "chat_link": "[&BCECAAA=]"
              },
              "546": {
                "name": "Vorgas Garrison Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57974.5,
                  25299.2
                ],
                "id": 546,
                "chat_link": "[&BCICAAA=]"
              },
              "547": {
                "name": "Forlorn Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58498,
                  25047.9
                ],
                "id": 547,
                "chat_link": "[&BCMCAAA=]"
              },
              "548": {
                "name": "Senecus Castrum Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58584.2,
                  25384.2
                ],
                "id": 548,
                "chat_link": "[&BCQCAAA=]"
              },
              "549": {
                "name": "Simurgh Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58958.5,
                  25673.9
                ],
                "id": 549,
                "chat_link": "[&BCUCAAA=]"
              },
              "550": {
                "name": "Keeper's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58275.5,
                  25871.4
                ],
                "id": 550,
                "chat_link": "[&BCYCAAA=]"
              },
              "1344": {
                "name": "The Citadel of Flame Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59682.4,
                  25151.3
                ],
                "id": 1344,
                "chat_link": "[&BEAFAAA=]"
              },
              "1660": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57829.9,
                  27127.8
                ],
                "id": 1660,
                "chat_link": "[&BHwGAAA=]"
              },
              "1661": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57214.9,
                  25713
                ],
                "id": 1661,
                "chat_link": "[&BH0GAAA=]"
              },
              "1662": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  59525.3,
                  27350.5
                ],
                "id": 1662,
                "chat_link": "[&BH4GAAA=]"
              },
              "1663": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58632.8,
                  27190.6
                ],
                "id": 1663,
                "chat_link": "[&BH8GAAA=]"
              },
              "1664": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58439.8,
                  26376.6
                ],
                "id": 1664,
                "chat_link": "[&BIAGAAA=]"
              },
              "1665": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  59031.7,
                  25388.6
                ],
                "id": 1665,
                "chat_link": "[&BIEGAAA=]"
              },
              "1666": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58874.4,
                  26240.4
                ],
                "id": 1666,
                "chat_link": "[&BIIGAAA=]"
              },
              "1667": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57886.3,
                  25708.4
                ],
                "id": 1667,
                "chat_link": "[&BIMGAAA=]"
              },
              "1734": {
                "name": "Citadel of Flame",
                "type": "unlock",
                "floor": 1,
                "coord": [
                  59715.3,
                  25086
                ],
                "id": 1734,
                "chat_link": "[&BMYGAAA=]",
                "icon": "https://render.guildwars2.com/file/943538394A94A491C8632FBEF6203C2013443555/102478.png"
              }
            },
            "tasks": {
              "128": {
                "objective": "Assist with maintenance at Tuyere Command Post.",
                "level": 60,
                "coord": [
                  59515.8,
                  27409.7
                ],
                "bounds": [
                  [
                    59734.6,
                    27334
                  ],
                  [
                    59673.8,
                    27379.8
                  ],
                  [
                    59604.1,
                    27444.9
                  ],
                  [
                    59523,
                    27489.7
                  ],
                  [
                    59426.5,
                    27483.4
                  ],
                  [
                    59332.6,
                    27415.3
                  ],
                  [
                    59227.2,
                    27348.9
                  ],
                  [
                    59223.6,
                    27282.3
                  ],
                  [
                    59370.5,
                    27248.6
                  ],
                  [
                    59442.9,
                    27192
                  ],
                  [
                    59665.7,
                    27140.7
                  ],
                  [
                    59734.6,
                    27334
                  ]
                ],
                "id": 128,
                "chat_link": "[&BIAAAAA=]"
              },
              "129": {
                "objective": "Assist Engineer Verutum.",
                "level": 61,
                "coord": [
                  59387.8,
                  26849.7
                ],
                "bounds": [
                  [
                    59258.4,
                    26804
                  ],
                  [
                    59210.3,
                    26969.9
                  ],
                  [
                    59220.5,
                    27051.9
                  ],
                  [
                    59389.3,
                    27135
                  ],
                  [
                    59495.1,
                    27170.3
                  ],
                  [
                    59657.5,
                    27098.3
                  ],
                  [
                    59711.5,
                    27043.4
                  ],
                  [
                    59740.1,
                    26900.7
                  ],
                  [
                    59687.3,
                    26744.8
                  ],
                  [
                    59659.3,
                    26684.3
                  ],
                  [
                    59504.2,
                    26632
                  ],
                  [
                    59258.4,
                    26804
                  ]
                ],
                "id": 129,
                "chat_link": "[&BIEAAAA=]"
              },
              "130": {
                "objective": "Clean up the Flame Legion magic.",
                "level": 61,
                "coord": [
                  58759.3,
                  27479
                ],
                "bounds": [
                  [
                    59097.4,
                    27360.1
                  ],
                  [
                    59035.2,
                    27496.6
                  ],
                  [
                    58904.7,
                    27560.8
                  ],
                  [
                    58807.7,
                    27577.7
                  ],
                  [
                    58717,
                    27612.6
                  ],
                  [
                    58601.6,
                    27587.4
                  ],
                  [
                    58490.3,
                    27387.3
                  ],
                  [
                    58493.6,
                    27268.1
                  ],
                  [
                    58542.6,
                    27213.6
                  ],
                  [
                    58649.4,
                    27204.4
                  ],
                  [
                    58684.2,
                    27071.3
                  ],
                  [
                    58815.8,
                    27017
                  ],
                  [
                    58924.7,
                    27077.1
                  ],
                  [
                    59027.1,
                    27157.7
                  ],
                  [
                    59079.2,
                    27282.4
                  ],
                  [
                    59097.4,
                    27360.1
                  ]
                ],
                "id": 130,
                "chat_link": "[&BIIAAAA=]"
              },
              "132": {
                "objective": "Stop the Flame Legion from summoning embers.",
                "level": 62,
                "coord": [
                  57965.5,
                  26934.1
                ],
                "bounds": [
                  [
                    57881.1,
                    26997.4
                  ],
                  [
                    58136.5,
                    26953.7
                  ],
                  [
                    58296.1,
                    27083.1
                  ],
                  [
                    58354.3,
                    27041.6
                  ],
                  [
                    58472.1,
                    26859.2
                  ],
                  [
                    58193.8,
                    26606.6
                  ],
                  [
                    58011.7,
                    26630.5
                  ],
                  [
                    57842.4,
                    26744.1
                  ],
                  [
                    57800.2,
                    26896.6
                  ],
                  [
                    57881.1,
                    26997.4
                  ]
                ],
                "id": 132,
                "chat_link": "[&BIQAAAA=]"
              },
              "133": {
                "objective": "Help the Nrocroc tribe survive so close to Flame lands.",
                "level": 64,
                "coord": [
                  57100.6,
                  26711.3
                ],
                "bounds": [
                  [
                    57026,
                    26913
                  ],
                  [
                    56927.6,
                    26923.2
                  ],
                  [
                    56816,
                    26795.1
                  ],
                  [
                    56810.7,
                    26623.5
                  ],
                  [
                    56939,
                    26468.8
                  ],
                  [
                    57199.1,
                    26548.2
                  ],
                  [
                    57252.6,
                    26784.2
                  ],
                  [
                    57132.6,
                    26906.9
                  ],
                  [
                    57026,
                    26913
                  ]
                ],
                "id": 133,
                "chat_link": "[&BIUAAAA=]"
              },
              "134": {
                "objective": "Help the Tarstar tribe survive so close to Flame lands.",
                "level": 63,
                "coord": [
                  57015.9,
                  27078.2
                ],
                "bounds": [
                  [
                    57048.1,
                    26916.5
                  ],
                  [
                    57138,
                    26913.1
                  ],
                  [
                    57114.6,
                    27021.3
                  ],
                  [
                    57166.7,
                    27151.2
                  ],
                  [
                    57120.2,
                    27237.5
                  ],
                  [
                    56962.8,
                    27274.3
                  ],
                  [
                    56813.8,
                    27423.7
                  ],
                  [
                    56648.2,
                    27303.5
                  ],
                  [
                    56633.3,
                    27001.6
                  ],
                  [
                    56730.9,
                    26880.9
                  ],
                  [
                    56833.8,
                    26851.5
                  ],
                  [
                    56919.9,
                    26926.7
                  ],
                  [
                    57048.1,
                    26916.5
                  ]
                ],
                "id": 134,
                "chat_link": "[&BIYAAAA=]"
              },
              "135": {
                "objective": "Help the Wupwup tribe survive so close to Flame lands.",
                "level": 63,
                "coord": [
                  57080.2,
                  27331.4
                ],
                "bounds": [
                  [
                    57145.9,
                    27538.2
                  ],
                  [
                    57154.9,
                    27418.7
                  ],
                  [
                    57133.1,
                    27309.5
                  ],
                  [
                    57053.6,
                    27268.9
                  ],
                  [
                    56970.9,
                    27282.4
                  ],
                  [
                    56883.7,
                    27357.6
                  ],
                  [
                    56789.5,
                    27484.2
                  ],
                  [
                    56813.7,
                    27556.3
                  ],
                  [
                    57011.3,
                    27635.5
                  ],
                  [
                    57145.9,
                    27538.2
                  ]
                ],
                "id": 135,
                "chat_link": "[&BIcAAAA=]"
              },
              "136": {
                "objective": "Assist the Ash Legion soldiers of Shadow Cleft.",
                "level": 65,
                "coord": [
                  57866.3,
                  25777.1
                ],
                "bounds": [
                  [
                    57849.4,
                    25717.7
                  ],
                  [
                    58102.2,
                    25754.1
                  ],
                  [
                    58212.8,
                    25856.7
                  ],
                  [
                    58158,
                    26453
                  ],
                  [
                    58142,
                    26557.2
                  ],
                  [
                    57812.9,
                    26399.8
                  ],
                  [
                    57578.7,
                    26489.9
                  ],
                  [
                    57538,
                    26421.5
                  ],
                  [
                    57535.4,
                    26262.4
                  ],
                  [
                    57671.4,
                    25882.8
                  ],
                  [
                    57849.4,
                    25717.7
                  ]
                ],
                "id": 136,
                "chat_link": "[&BIgAAAA=]"
              },
              "137": {
                "objective": "Aid kodan refugees fleeing toward Haymal Gore.",
                "level": 66,
                "coord": [
                  57068.3,
                  25722.9
                ],
                "bounds": [
                  [
                    56647.3,
                    26191.4
                  ],
                  [
                    56951.4,
                    25353.8
                  ],
                  [
                    57105.3,
                    25308.8
                  ],
                  [
                    57219.5,
                    25380.8
                  ],
                  [
                    57294.5,
                    25697.1
                  ],
                  [
                    57326.7,
                    25994.3
                  ],
                  [
                    57174.8,
                    26153.3
                  ],
                  [
                    56971.2,
                    26261.6
                  ],
                  [
                    56647.3,
                    26191.4
                  ]
                ],
                "id": 137,
                "chat_link": "[&BIkAAAA=]"
              },
              "138": {
                "objective": "Help Pact researchers with their experimental weapons.",
                "level": 67,
                "coord": [
                  57162.6,
                  25156.3
                ],
                "bounds": [
                  [
                    56933.1,
                    25349.3
                  ],
                  [
                    56717.3,
                    25415.9
                  ],
                  [
                    56778.6,
                    25040.8
                  ],
                  [
                    56909.5,
                    24859.7
                  ],
                  [
                    57591.8,
                    24870.7
                  ],
                  [
                    57555,
                    25121.3
                  ],
                  [
                    57524.7,
                    25228.9
                  ],
                  [
                    57329.2,
                    25338.8
                  ],
                  [
                    57227.8,
                    25379.1
                  ],
                  [
                    57109.6,
                    25302.7
                  ],
                  [
                    56933.1,
                    25349.3
                  ]
                ],
                "id": 138,
                "chat_link": "[&BIoAAAA=]"
              },
              "140": {
                "objective": "Help the Ash Legion disrupt the Flame Legion.",
                "level": 68,
                "coord": [
                  58452.3,
                  25058
                ],
                "bounds": [
                  [
                    58184.3,
                    25039.7
                  ],
                  [
                    58386.6,
                    24958.1
                  ],
                  [
                    58467.7,
                    25026.3
                  ],
                  [
                    58538.7,
                    25182.1
                  ],
                  [
                    58691.5,
                    25119.6
                  ],
                  [
                    58765.2,
                    25143.1
                  ],
                  [
                    58835.1,
                    25358.1
                  ],
                  [
                    58963.4,
                    25427
                  ],
                  [
                    58925.3,
                    25656.4
                  ],
                  [
                    58959,
                    25832.4
                  ],
                  [
                    58688.4,
                    25854.1
                  ],
                  [
                    58426.1,
                    25645.1
                  ],
                  [
                    58255,
                    25724.7
                  ],
                  [
                    58192.7,
                    25396.5
                  ],
                  [
                    58184.3,
                    25039.7
                  ]
                ],
                "id": 140,
                "chat_link": "[&BIwAAAA=]"
              },
              "141": {
                "objective": "Help the Ash Legion strike at the heart of the Flame Legion.",
                "level": 69,
                "coord": [
                  59004,
                  25655.5
                ],
                "bounds": [
                  [
                    58930.6,
                    25659.7
                  ],
                  [
                    58966.3,
                    25839.6
                  ],
                  [
                    59518.4,
                    25862.6
                  ],
                  [
                    59591.2,
                    25684.4
                  ],
                  [
                    59410.3,
                    25601.3
                  ],
                  [
                    59368.3,
                    25484
                  ],
                  [
                    59462.4,
                    25260.2
                  ],
                  [
                    59173.2,
                    25237.4
                  ],
                  [
                    59154.6,
                    25137.1
                  ],
                  [
                    58940.9,
                    25029.2
                  ],
                  [
                    58797.3,
                    25082
                  ],
                  [
                    58772.5,
                    25142.5
                  ],
                  [
                    58838.5,
                    25353.6
                  ],
                  [
                    58972.5,
                    25425.6
                  ],
                  [
                    58930.6,
                    25659.7
                  ]
                ],
                "id": 141,
                "chat_link": "[&BI0AAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  58540.1,
                  26095.3
                ],
                "id": "0-46"
              },
              {
                "coord": [
                  58626.9,
                  25654.9
                ],
                "id": "0-133"
              },
              {
                "coord": [
                  56882.8,
                  26399.3
                ],
                "id": "0-34"
              },
              {
                "coord": [
                  57909.4,
                  26460.9
                ],
                "id": "0-131"
              },
              {
                "coord": [
                  59265.9,
                  26742.3
                ],
                "id": "0-132"
              },
              {
                "coord": [
                  58532.8,
                  24998.2
                ],
                "id": "0-2"
              },
              {
                "coord": [
                  59243.2,
                  26130
                ],
                "id": "0-0"
              }
            ],
            "sectors": {
              "459": {
                "name": "Burnt Hollow",
                "level": 65,
                "coord": [
                  57822.5,
                  26516.3
                ],
                "bounds": [
                  [
                    57689.2,
                    26540.7
                  ],
                  [
                    57781.5,
                    26402.1
                  ],
                  [
                    57917.7,
                    26374.9
                  ],
                  [
                    57975.7,
                    26460.9
                  ],
                  [
                    57894,
                    26660.5
                  ],
                  [
                    57677.1,
                    26659
                  ],
                  [
                    57689.2,
                    26540.7
                  ]
                ],
                "id": 459,
                "chat_link": "[&BMsBAAA=]"
              },
              "460": {
                "name": "Liberation Dell",
                "level": 68,
                "coord": [
                  58515.8,
                  25023.1
                ],
                "bounds": [
                  [
                    58560.1,
                    24893
                  ],
                  [
                    58745.6,
                    25072.1
                  ],
                  [
                    58582.5,
                    25159.3
                  ],
                  [
                    58400.3,
                    25080.5
                  ],
                  [
                    58290.3,
                    24910.6
                  ],
                  [
                    58560.1,
                    24893
                  ]
                ],
                "id": 460,
                "chat_link": "[&BMwBAAA=]"
              },
              "461": {
                "name": "Fuller Cistern",
                "level": 61,
                "coord": [
                  59497.5,
                  26749
                ],
                "bounds": [
                  [
                    59351.9,
                    27179.1
                  ],
                  [
                    59629,
                    27198.4
                  ],
                  [
                    59834.6,
                    26997.3
                  ],
                  [
                    59944.3,
                    26999.2
                  ],
                  [
                    59979.5,
                    26491.1
                  ],
                  [
                    59806.2,
                    26562.9
                  ],
                  [
                    59673.6,
                    26518.3
                  ],
                  [
                    59569.9,
                    26450.3
                  ],
                  [
                    59526.2,
                    26347.7
                  ],
                  [
                    59471,
                    26497.6
                  ],
                  [
                    59386.3,
                    26486.3
                  ],
                  [
                    59035.4,
                    26649.7
                  ],
                  [
                    59030.1,
                    26784.8
                  ],
                  [
                    59109.2,
                    26958.9
                  ],
                  [
                    59115.5,
                    27113.1
                  ],
                  [
                    59351.9,
                    27179.1
                  ]
                ],
                "id": 461,
                "chat_link": "[&BM0BAAA=]"
              },
              "462": {
                "name": "Forge Plains",
                "level": 62,
                "coord": [
                  58240.8,
                  26770.5
                ],
                "bounds": [
                  [
                    57991.5,
                    26993.8
                  ],
                  [
                    58219,
                    27017.3
                  ],
                  [
                    58378.3,
                    27168.8
                  ],
                  [
                    58395.3,
                    26899.3
                  ],
                  [
                    58626.2,
                    26796.9
                  ],
                  [
                    58496.9,
                    26542
                  ],
                  [
                    58187.6,
                    26393.1
                  ],
                  [
                    57976.5,
                    26461
                  ],
                  [
                    57895.9,
                    26662.3
                  ],
                  [
                    57991.5,
                    26993.8
                  ]
                ],
                "id": 462,
                "chat_link": "[&BM4BAAA=]"
              },
              "463": {
                "name": "Switchback Canyons",
                "level": 65,
                "coord": [
                  57786.1,
                  26196.5
                ],
                "bounds": [
                  [
                    57282.2,
                    26378.8
                  ],
                  [
                    57620,
                    26660.4
                  ],
                  [
                    57678.6,
                    26661.3
                  ],
                  [
                    57694.2,
                    26539.7
                  ],
                  [
                    57791.4,
                    26400.5
                  ],
                  [
                    57919.5,
                    26372.7
                  ],
                  [
                    57975.8,
                    26460.1
                  ],
                  [
                    58187.1,
                    26404.9
                  ],
                  [
                    58103.6,
                    26040
                  ],
                  [
                    58257.9,
                    25900.7
                  ],
                  [
                    58239,
                    25725.5
                  ],
                  [
                    58041.2,
                    25778.1
                  ],
                  [
                    57890.9,
                    25682.6
                  ],
                  [
                    57592,
                    25927.5
                  ],
                  [
                    57465.1,
                    26114
                  ],
                  [
                    57319.6,
                    26058.4
                  ],
                  [
                    57306.5,
                    26235.6
                  ],
                  [
                    57282.2,
                    26378.8
                  ]
                ],
                "id": 463,
                "chat_link": "[&BM8BAAA=]"
              },
              "464": {
                "name": "Havoc Steppes",
                "level": 63,
                "coord": [
                  57618.4,
                  26808.8
                ],
                "bounds": [
                  [
                    57283.9,
                    26376.1
                  ],
                  [
                    57619,
                    26656.8
                  ],
                  [
                    57896.3,
                    26665.8
                  ],
                  [
                    57987.5,
                    26991.8
                  ],
                  [
                    57815.5,
                    27051.3
                  ],
                  [
                    57647.9,
                    27289.6
                  ],
                  [
                    57078.9,
                    26630.3
                  ],
                  [
                    57283.9,
                    26376.1
                  ]
                ],
                "id": 464,
                "chat_link": "[&BNABAAA=]"
              },
              "465": {
                "name": "Amduat Point",
                "level": 70,
                "coord": [
                  59096.5,
                  25411.6
                ],
                "bounds": [
                  [
                    59015.5,
                    25802.8
                  ],
                  [
                    59024.3,
                    25637
                  ],
                  [
                    58915,
                    25295.3
                  ],
                  [
                    58746.3,
                    25072.5
                  ],
                  [
                    58906.9,
                    25076.4
                  ],
                  [
                    59162.6,
                    25207.4
                  ],
                  [
                    59250.2,
                    25324.7
                  ],
                  [
                    59368,
                    25300.8
                  ],
                  [
                    59317.7,
                    25622.2
                  ],
                  [
                    59258.7,
                    25776.8
                  ],
                  [
                    59015.5,
                    25802.8
                  ]
                ],
                "id": 465,
                "chat_link": "[&BNEBAAA=]"
              },
              "466": {
                "name": "The Baelfire",
                "level": 70,
                "coord": [
                  59606,
                  25324.1
                ],
                "bounds": [
                  [
                    59257.9,
                    25778.3
                  ],
                  [
                    59508.8,
                    25836.7
                  ],
                  [
                    59916.9,
                    25870.9
                  ],
                  [
                    60269.2,
                    25677.1
                  ],
                  [
                    60294.6,
                    25539.7
                  ],
                  [
                    60146.6,
                    25393.6
                  ],
                  [
                    60017.6,
                    25210.4
                  ],
                  [
                    59912.6,
                    25035
                  ],
                  [
                    59875.2,
                    24899.3
                  ],
                  [
                    59778.8,
                    24863.8
                  ],
                  [
                    59344.6,
                    24942.5
                  ],
                  [
                    58980.8,
                    24925.3
                  ],
                  [
                    58907.2,
                    25077.1
                  ],
                  [
                    59160,
                    25207.8
                  ],
                  [
                    59247.9,
                    25327.9
                  ],
                  [
                    59368,
                    25301.3
                  ],
                  [
                    59316,
                    25623.1
                  ],
                  [
                    59257.9,
                    25778.3
                  ]
                ],
                "id": 466,
                "chat_link": "[&BNIBAAA=]"
              },
              "467": {
                "name": "Simurgh Timberland",
                "level": 68,
                "coord": [
                  58576.9,
                  25467.4
                ],
                "bounds": [
                  [
                    58167.7,
                    25414.9
                  ],
                  [
                    58190.8,
                    25156.8
                  ],
                  [
                    58290.3,
                    24911.9
                  ],
                  [
                    58406.8,
                    25081.8
                  ],
                  [
                    58584.5,
                    25150.8
                  ],
                  [
                    58747.9,
                    25074.9
                  ],
                  [
                    58912.9,
                    25293.1
                  ],
                  [
                    59026,
                    25638.2
                  ],
                  [
                    59016.1,
                    25805.2
                  ],
                  [
                    58807,
                    26051.5
                  ],
                  [
                    58703,
                    25880.6
                  ],
                  [
                    58492.6,
                    25743.2
                  ],
                  [
                    58492.1,
                    25640
                  ],
                  [
                    58238.4,
                    25701.3
                  ],
                  [
                    58167.7,
                    25414.9
                  ]
                ],
                "id": 467,
                "chat_link": "[&BNMBAAA=]"
              },
              "468": {
                "name": "Sweltering Canyons",
                "level": 68,
                "coord": [
                  57845.4,
                  25609
                ],
                "bounds": [
                  [
                    57489.7,
                    25532.1
                  ],
                  [
                    57598.2,
                    25433
                  ],
                  [
                    57740.5,
                    25371.5
                  ],
                  [
                    58168.7,
                    25418.6
                  ],
                  [
                    58240.5,
                    25722.7
                  ],
                  [
                    58040.8,
                    25778.2
                  ],
                  [
                    57892.7,
                    25682.3
                  ],
                  [
                    57591.9,
                    25933.8
                  ],
                  [
                    57489.7,
                    25532.1
                  ]
                ],
                "id": 468,
                "chat_link": "[&BNQBAAA=]"
              },
              "470": {
                "name": "Apostate Wastes",
                "level": 64,
                "coord": [
                  57023.1,
                  27265.6
                ],
                "bounds": [
                  [
                    57564.3,
                    27425.6
                  ],
                  [
                    57648.3,
                    27291.5
                  ],
                  [
                    57085,
                    26631.6
                  ],
                  [
                    56966.4,
                    26761.8
                  ],
                  [
                    56479.9,
                    26615.8
                  ],
                  [
                    56517.9,
                    26988.3
                  ],
                  [
                    56524.3,
                    27572.3
                  ],
                  [
                    56666.6,
                    27674.9
                  ],
                  [
                    57031.4,
                    27692.3
                  ],
                  [
                    57366.9,
                    27702.7
                  ],
                  [
                    57402.7,
                    27564.3
                  ],
                  [
                    57564.3,
                    27425.6
                  ]
                ],
                "id": 470,
                "chat_link": "[&BNYBAAA=]"
              },
              "471": {
                "name": "Keeper's Sanctum",
                "level": 66,
                "coord": [
                  58458.9,
                  26007.8
                ],
                "bounds": [
                  [
                    58489.3,
                    26548.1
                  ],
                  [
                    58812.6,
                    26194
                  ],
                  [
                    58808,
                    26053.4
                  ],
                  [
                    58704.3,
                    25871.4
                  ],
                  [
                    58495.8,
                    25739.8
                  ],
                  [
                    58494.7,
                    25632.6
                  ],
                  [
                    58240.8,
                    25692.5
                  ],
                  [
                    58256.3,
                    25902
                  ],
                  [
                    58104,
                    26041.4
                  ],
                  [
                    58183,
                    26403.1
                  ],
                  [
                    58489.3,
                    26548.1
                  ]
                ],
                "id": 471,
                "chat_link": "[&BNcBAAA=]"
              },
              "472": {
                "name": "Onager Bivouac",
                "level": 67,
                "coord": [
                  57427.7,
                  25853.8
                ],
                "bounds": [
                  [
                    57465.8,
                    26114.9
                  ],
                  [
                    57592.3,
                    25932
                  ],
                  [
                    57489.9,
                    25531.3
                  ],
                  [
                    57423.9,
                    25589.4
                  ],
                  [
                    57301.2,
                    25902.3
                  ],
                  [
                    57293.1,
                    26052.6
                  ],
                  [
                    57465.8,
                    26114.9
                  ]
                ],
                "id": 472,
                "chat_link": "[&BNgBAAA=]"
              },
              "473": {
                "name": "Buloh Crossing",
                "level": 62,
                "coord": [
                  58088.7,
                  27301.6
                ],
                "bounds": [
                  [
                    57834.4,
                    27326.7
                  ],
                  [
                    57647.4,
                    27291.4
                  ],
                  [
                    57819.6,
                    27049.3
                  ],
                  [
                    57993.9,
                    26988.8
                  ],
                  [
                    58222.1,
                    27016.5
                  ],
                  [
                    58381.8,
                    27166.4
                  ],
                  [
                    58472.8,
                    27481.1
                  ],
                  [
                    58437.3,
                    27696.1
                  ],
                  [
                    57988.8,
                    27697.8
                  ],
                  [
                    57834.4,
                    27326.7
                  ]
                ],
                "id": 473,
                "chat_link": "[&BNkBAAA=]"
              },
              "474": {
                "name": "The Toughstone",
                "level": 68,
                "coord": [
                  57917.3,
                  25107
                ],
                "bounds": [
                  [
                    57732.8,
                    25380.3
                  ],
                  [
                    58169.8,
                    25426.2
                  ],
                  [
                    58192,
                    25176.6
                  ],
                  [
                    58286,
                    24917.8
                  ],
                  [
                    58230.5,
                    24864.8
                  ],
                  [
                    58014.8,
                    24856.4
                  ],
                  [
                    57789,
                    24896.3
                  ],
                  [
                    57614,
                    24798.3
                  ],
                  [
                    57546.6,
                    25315.8
                  ],
                  [
                    57596.9,
                    25437.5
                  ],
                  [
                    57732.8,
                    25380.3
                  ]
                ],
                "id": 474,
                "chat_link": "[&BNoBAAA=]"
              },
              "475": {
                "name": "Cozen Desolation",
                "level": 62,
                "coord": [
                  58873.8,
                  26560.5
                ],
                "bounds": [
                  [
                    58486.6,
                    26543.7
                  ],
                  [
                    58810.1,
                    26195.3
                  ],
                  [
                    59034,
                    26359.4
                  ],
                  [
                    59042.5,
                    26449.1
                  ],
                  [
                    58984.9,
                    26544.4
                  ],
                  [
                    59033,
                    26652.2
                  ],
                  [
                    59031.1,
                    26785.3
                  ],
                  [
                    58821.1,
                    26710.4
                  ],
                  [
                    58620.6,
                    26804.2
                  ],
                  [
                    58486.6,
                    26543.7
                  ]
                ],
                "id": 475,
                "chat_link": "[&BNsBAAA=]"
              },
              "477": {
                "name": "Sati Passage",
                "level": 61,
                "coord": [
                  59549.7,
                  27352.8
                ],
                "bounds": [
                  [
                    59058.4,
                    27397.9
                  ],
                  [
                    59138.2,
                    27715.5
                  ],
                  [
                    59561.7,
                    27658.9
                  ],
                  [
                    59700,
                    27708.7
                  ],
                  [
                    59905.6,
                    27619.9
                  ],
                  [
                    59970.1,
                    27409.8
                  ],
                  [
                    59918,
                    27272.5
                  ],
                  [
                    59946.1,
                    26999.3
                  ],
                  [
                    59838,
                    26992.4
                  ],
                  [
                    59630.8,
                    27192.9
                  ],
                  [
                    59350.7,
                    27178.6
                  ],
                  [
                    59115,
                    27108.7
                  ],
                  [
                    59013,
                    27331.6
                  ],
                  [
                    59058.4,
                    27397.9
                  ]
                ],
                "id": 477,
                "chat_link": "[&BN0BAAA=]"
              },
              "478": {
                "name": "Mangonel Cavern",
                "level": 67,
                "coord": [
                  56958.3,
                  25088.6
                ],
                "bounds": [
                  [
                    56531.1,
                    25444.9
                  ],
                  [
                    56643.9,
                    24972.6
                  ],
                  [
                    56837.3,
                    24890.6
                  ],
                  [
                    57088.3,
                    24893.4
                  ],
                  [
                    57340.6,
                    24987.4
                  ],
                  [
                    57295,
                    25085.7
                  ],
                  [
                    57047.6,
                    25124.4
                  ],
                  [
                    56883.2,
                    25309.5
                  ],
                  [
                    56531.1,
                    25444.9
                  ]
                ],
                "id": 478,
                "chat_link": "[&BN4BAAA=]"
              },
              "479": {
                "name": "Icespear's Shelf",
                "level": 67,
                "coord": [
                  57415.5,
                  25175.1
                ],
                "bounds": [
                  [
                    57425.7,
                    25603.5
                  ],
                  [
                    57602.5,
                    25431.7
                  ],
                  [
                    57551.7,
                    25309.2
                  ],
                  [
                    57615.4,
                    24798.2
                  ],
                  [
                    57382.1,
                    24875.1
                  ],
                  [
                    57294.7,
                    25085.7
                  ],
                  [
                    57036.6,
                    25122.2
                  ],
                  [
                    57425.7,
                    25603.5
                  ]
                ],
                "id": 479,
                "chat_link": "[&BN8BAAA=]"
              },
              "480": {
                "name": "Highland Thaw",
                "level": 67,
                "coord": [
                  56990.2,
                  25685.3
                ],
                "bounds": [
                  [
                    57303.7,
                    25901.6
                  ],
                  [
                    57423.1,
                    25590.8
                  ],
                  [
                    57281.8,
                    25405
                  ],
                  [
                    57046.7,
                    25124.7
                  ],
                  [
                    56891.3,
                    25300.2
                  ],
                  [
                    56550.9,
                    25442.4
                  ],
                  [
                    56472.5,
                    25960.9
                  ],
                  [
                    56529.2,
                    26086.2
                  ],
                  [
                    57109.5,
                    25989.5
                  ],
                  [
                    57293.1,
                    26051.9
                  ],
                  [
                    57303.7,
                    25901.6
                  ]
                ],
                "id": 480,
                "chat_link": "[&BOABAAA=]"
              },
              "481": {
                "name": "Sloven Pitch",
                "level": 70,
                "coord": [
                  59246.5,
                  26209.7
                ],
                "bounds": [
                  [
                    58807.8,
                    26197.9
                  ],
                  [
                    58806.6,
                    26051.9
                  ],
                  [
                    59013.9,
                    25802.2
                  ],
                  [
                    59258.6,
                    25770.5
                  ],
                  [
                    59504.2,
                    25835.8
                  ],
                  [
                    59920.1,
                    25869.1
                  ],
                  [
                    59677.2,
                    26040.2
                  ],
                  [
                    59526.6,
                    26347.2
                  ],
                  [
                    59469.7,
                    26505.1
                  ],
                  [
                    59382.9,
                    26489.7
                  ],
                  [
                    59030.3,
                    26653.8
                  ],
                  [
                    58982.8,
                    26549.4
                  ],
                  [
                    59039.6,
                    26457.1
                  ],
                  [
                    59030.9,
                    26365.3
                  ],
                  [
                    58807.8,
                    26197.9
                  ]
                ],
                "id": 481,
                "chat_link": "[&BOEBAAA=]"
              },
              "482": {
                "name": "Pig Iron Mine",
                "level": 61,
                "coord": [
                  58815.5,
                  27205.1
                ],
                "bounds": [
                  [
                    59028.6,
                    26792.1
                  ],
                  [
                    59109.5,
                    26958.6
                  ],
                  [
                    59115.4,
                    27110
                  ],
                  [
                    59012.3,
                    27331.4
                  ],
                  [
                    59057.7,
                    27398.6
                  ],
                  [
                    59138.6,
                    27719
                  ],
                  [
                    58436.4,
                    27697
                  ],
                  [
                    58473.3,
                    27479.7
                  ],
                  [
                    58379.8,
                    27167.1
                  ],
                  [
                    58394.7,
                    26899.6
                  ],
                  [
                    58824.2,
                    26703.5
                  ],
                  [
                    59028.6,
                    26792.1
                  ]
                ],
                "id": 482,
                "chat_link": "[&BOIBAAA=]"
              },
              "483": {
                "name": "Rustbowl",
                "level": 65,
                "coord": [
                  56884.1,
                  26322.8
                ],
                "bounds": [
                  [
                    56436.9,
                    26502.1
                  ],
                  [
                    56526.7,
                    26270
                  ],
                  [
                    56530.3,
                    26086.4
                  ],
                  [
                    57113.5,
                    25993
                  ],
                  [
                    57319,
                    26063.2
                  ],
                  [
                    57307.1,
                    26236.4
                  ],
                  [
                    57284.1,
                    26374
                  ],
                  [
                    56969.3,
                    26764.8
                  ],
                  [
                    56469.8,
                    26615.1
                  ],
                  [
                    56436.9,
                    26502.1
                  ]
                ],
                "id": 483,
                "chat_link": "[&BOMBAAA=]"
              },
              "1027": {
                "name": "Rebel's Seclusion",
                "level": 70,
                "coord": [
                  59769.5,
                  26317.9
                ],
                "bounds": [
                  [
                    59909.8,
                    25869.2
                  ],
                  [
                    59674.9,
                    26039.9
                  ],
                  [
                    59521.7,
                    26349.1
                  ],
                  [
                    59567.1,
                    26452.9
                  ],
                  [
                    59674.2,
                    26521.7
                  ],
                  [
                    59806.2,
                    26566.5
                  ],
                  [
                    59978.6,
                    26496.5
                  ],
                  [
                    60023.8,
                    26247.9
                  ],
                  [
                    59909.8,
                    25869.2
                  ]
                ],
                "id": 1027,
                "chat_link": "[&BAMEAAA=]"
              },
              "1068": {
                "name": "Vexa's Lab",
                "level": 70,
                "coord": [
                  57648.9,
                  27563.3
                ],
                "bounds": [
                  [
                    57564,
                    27425.4
                  ],
                  [
                    57404.1,
                    27569.3
                  ],
                  [
                    57364.1,
                    27691.3
                  ],
                  [
                    57502.8,
                    27757.7
                  ],
                  [
                    57883.4,
                    27750.6
                  ],
                  [
                    57990.1,
                    27694.4
                  ],
                  [
                    57835.1,
                    27327.7
                  ],
                  [
                    57647.6,
                    27290.1
                  ],
                  [
                    57564,
                    27425.4
                  ]
                ],
                "id": 1068,
                "chat_link": "[&BCwEAAA=]"
              }
            },
            "adventures": [],
            "id": 22,
            "mastery_points": [
              {
                "coord": [
                  58866.9,
                  26443.4
                ],
                "id": 320,
                "region": "Tyria"
              }
            ]
          },
          "25": {
            "name": "Iron Marches",
            "min_level": 50,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              60928,
              27904
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                59904,
                25856
              ],
              [
                61952,
                29952
              ]
            ],
            "points_of_interest": {
              "468": {
                "name": "Dewclaw Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60736.2,
                  29686.3
                ],
                "id": 468,
                "chat_link": "[&BNQBAAA=]"
              },
              "469": {
                "name": "The Cauldron of Searing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60924,
                  29570.8
                ],
                "id": 469,
                "chat_link": "[&BNUBAAA=]"
              },
              "470": {
                "name": "Herdsman's Bastion",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61715.5,
                  29661.9
                ],
                "id": 470,
                "chat_link": "[&BNYBAAA=]"
              },
              "471": {
                "name": "Bria's Manor",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61771.6,
                  29038.5
                ],
                "id": 471,
                "chat_link": "[&BNcBAAA=]"
              },
              "472": {
                "name": "Vermin's Folly",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60796,
                  28698.4
                ],
                "id": 472,
                "chat_link": "[&BNgBAAA=]"
              },
              "473": {
                "name": "Wreckage of Day's Labor",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61519.7,
                  27048.4
                ],
                "id": 473,
                "chat_link": "[&BNkBAAA=]"
              },
              "474": {
                "name": "Invictus Castrum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60428.6,
                  26787.8
                ],
                "id": 474,
                "chat_link": "[&BNoBAAA=]"
              },
              "475": {
                "name": "Newglade Kraal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60642.2,
                  26454.9
                ],
                "id": 475,
                "chat_link": "[&BNsBAAA=]"
              },
              "476": {
                "name": "The Blasted Hearth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60180.7,
                  26041.5
                ],
                "id": 476,
                "chat_link": "[&BNwBAAA=]"
              },
              "477": {
                "name": "Grundallion's Lair",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61006.9,
                  26054.9
                ],
                "id": 477,
                "chat_link": "[&BN0BAAA=]"
              },
              "478": {
                "name": "Fellmyst Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60451,
                  25933.6
                ],
                "id": 478,
                "chat_link": "[&BN4BAAA=]"
              },
              "479": {
                "name": "Heartsond Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61869.8,
                  25980.9
                ],
                "id": 479,
                "chat_link": "[&BN8BAAA=]"
              },
              "480": {
                "name": "Kilnn's Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61453.9,
                  28729.7
                ],
                "id": 480,
                "chat_link": "[&BOABAAA=]"
              },
              "481": {
                "name": "Spentlung Depth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61483.7,
                  27641.2
                ],
                "id": 481,
                "chat_link": "[&BOEBAAA=]"
              },
              "482": {
                "name": "Dewclaw Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60940.6,
                  29823.3
                ],
                "id": 482,
                "chat_link": "[&BOIBAAA=]"
              },
              "483": {
                "name": "Bloodfin Lake Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  61524,
                  29597.6
                ],
                "id": 483,
                "chat_link": "[&BOMBAAA=]"
              },
              "484": {
                "name": "Old Piken Ruins Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60281.4,
                  29394.2
                ],
                "id": 484,
                "chat_link": "[&BOQBAAA=]"
              },
              "485": {
                "name": "Warhound Village Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  61117.5,
                  28788.7
                ],
                "id": 485,
                "chat_link": "[&BOUBAAA=]"
              },
              "486": {
                "name": "Hellion Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  61816.4,
                  28806.8
                ],
                "id": 486,
                "chat_link": "[&BOYBAAA=]"
              },
              "487": {
                "name": "Village of Scalecatch Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60585.8,
                  28536.8
                ],
                "id": 487,
                "chat_link": "[&BOcBAAA=]"
              },
              "488": {
                "name": "Sleekfur Encampment Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60204.9,
                  28157.2
                ],
                "id": 488,
                "chat_link": "[&BOgBAAA=]"
              },
              "489": {
                "name": "Brandwatch Encampment Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  61229.2,
                  28081.3
                ],
                "id": 489,
                "chat_link": "[&BOkBAAA=]"
              },
              "490": {
                "name": "Viper's Run Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  61167.5,
                  26997
                ],
                "id": 490,
                "chat_link": "[&BOoBAAA=]"
              },
              "491": {
                "name": "Town of Cowlfang's Star Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60641.9,
                  27418.5
                ],
                "id": 491,
                "chat_link": "[&BOsBAAA=]"
              },
              "492": {
                "name": "Bulwark Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60046.1,
                  27207.5
                ],
                "id": 492,
                "chat_link": "[&BOwBAAA=]"
              },
              "493": {
                "name": "Firewatch Encampment Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60750.2,
                  26949.7
                ],
                "id": 493,
                "chat_link": "[&BO0BAAA=]"
              },
              "494": {
                "name": "Gladefall Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60676,
                  26282.4
                ],
                "id": 494,
                "chat_link": "[&BO4BAAA=]"
              },
              "495": {
                "name": "Grostogg's Kraal Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  61638.1,
                  26437.9
                ],
                "id": 495,
                "chat_link": "[&BO8BAAA=]"
              },
              "1589": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60606.1,
                  29702.6
                ],
                "id": 1589,
                "chat_link": "[&BDUGAAA=]"
              },
              "1590": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  61493.5,
                  28231.6
                ],
                "id": 1590,
                "chat_link": "[&BDYGAAA=]"
              },
              "1591": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60487.1,
                  26070
                ],
                "id": 1591,
                "chat_link": "[&BDcGAAA=]"
              },
              "1592": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  61257.2,
                  27293.4
                ],
                "id": 1592,
                "chat_link": "[&BDgGAAA=]"
              },
              "1593": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  61704.5,
                  26428.7
                ],
                "id": 1593,
                "chat_link": "[&BDkGAAA=]"
              },
              "1594": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60624.7,
                  27317.7
                ],
                "id": 1594,
                "chat_link": "[&BDoGAAA=]"
              },
              "1595": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60084.7,
                  29769.4
                ],
                "id": 1595,
                "chat_link": "[&BDsGAAA=]"
              },
              "1596": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60240.2,
                  26144
                ],
                "id": 1596,
                "chat_link": "[&BDwGAAA=]"
              }
            },
            "tasks": {
              "142": {
                "objective": "Fight the Branded in Lake Desolann with the Sentinels.",
                "level": 57,
                "coord": [
                  61393.1,
                  28184
                ],
                "bounds": [
                  [
                    61985.7,
                    27169.9
                  ],
                  [
                    61857.3,
                    28314.7
                  ],
                  [
                    61546.4,
                    28340.1
                  ],
                  [
                    61343.1,
                    28198.1
                  ],
                  [
                    61253.1,
                    27824.4
                  ],
                  [
                    61209.6,
                    27503.3
                  ],
                  [
                    61281.1,
                    27369.1
                  ],
                  [
                    61400.3,
                    27352.2
                  ],
                  [
                    61626.3,
                    27334.5
                  ],
                  [
                    61985.7,
                    27169.9
                  ]
                ],
                "id": 142,
                "chat_link": "[&BI4AAAA=]"
              },
              "143": {
                "objective": "Assist the Sentinels patrolling Crystalwept Groves.",
                "level": 58,
                "coord": [
                  61193.9,
                  27025.4
                ],
                "bounds": [
                  [
                    61975.7,
                    27170.5
                  ],
                  [
                    61628.7,
                    27330.2
                  ],
                  [
                    61405.1,
                    27349.3
                  ],
                  [
                    61279.4,
                    27366.2
                  ],
                  [
                    61274.8,
                    27212.2
                  ],
                  [
                    61253.3,
                    27179.2
                  ],
                  [
                    61200.5,
                    27135.5
                  ],
                  [
                    61185.2,
                    27066.3
                  ],
                  [
                    61182.9,
                    26936.1
                  ],
                  [
                    61201,
                    26842.2
                  ],
                  [
                    61164.9,
                    26745.1
                  ],
                  [
                    61223.2,
                    26714.8
                  ],
                  [
                    61359.1,
                    26552.9
                  ],
                  [
                    61503.4,
                    26531.5
                  ],
                  [
                    61588.7,
                    26530.3
                  ],
                  [
                    61667.7,
                    26592.8
                  ],
                  [
                    61742.1,
                    26645.6
                  ],
                  [
                    61887.5,
                    26801.6
                  ],
                  [
                    61975.7,
                    27170.5
                  ]
                ],
                "id": 143,
                "chat_link": "[&BI8AAAA=]"
              },
              "144": {
                "objective": "Help the ogres remove the Branded from their land.",
                "level": 59,
                "coord": [
                  61544.9,
                  26437.3
                ],
                "bounds": [
                  [
                    61552.7,
                    25924.2
                  ],
                  [
                    61729.7,
                    25913
                  ],
                  [
                    61891.5,
                    25969.4
                  ],
                  [
                    61897.3,
                    26285.4
                  ],
                  [
                    61849.6,
                    26465
                  ],
                  [
                    61632.4,
                    26463.7
                  ],
                  [
                    61579.6,
                    26525.6
                  ],
                  [
                    61326.1,
                    26544.9
                  ],
                  [
                    61163.4,
                    26709.6
                  ],
                  [
                    60996.8,
                    26651.2
                  ],
                  [
                    60904.5,
                    26547.3
                  ],
                  [
                    60867.5,
                    26326.3
                  ],
                  [
                    60853.3,
                    26174.8
                  ],
                  [
                    60868.8,
                    25986.3
                  ],
                  [
                    60970.3,
                    25917.4
                  ],
                  [
                    61342.9,
                    25913.4
                  ],
                  [
                    61552.7,
                    25924.2
                  ]
                ],
                "id": 144,
                "chat_link": "[&BJAAAAA=]"
              },
              "145": {
                "objective": "Fight life-stealing minions in Hellion Forest.",
                "level": 50,
                "coord": [
                  61688.2,
                  28870.1
                ],
                "bounds": [
                  [
                    61892.2,
                    28972.3
                  ],
                  [
                    61765.3,
                    29296.8
                  ],
                  [
                    61619.4,
                    29229.2
                  ],
                  [
                    61544.3,
                    29112
                  ],
                  [
                    61522.8,
                    29050.9
                  ],
                  [
                    61549.1,
                    28994.1
                  ],
                  [
                    61640.1,
                    29012.2
                  ],
                  [
                    61644.1,
                    28987.2
                  ],
                  [
                    61540.7,
                    28973.7
                  ],
                  [
                    61503,
                    28868.4
                  ],
                  [
                    61576,
                    28827.9
                  ],
                  [
                    61814,
                    28836.8
                  ],
                  [
                    61821.5,
                    28859.7
                  ],
                  [
                    61867.6,
                    28893.3
                  ],
                  [
                    61896.7,
                    28932.3
                  ],
                  [
                    61892.2,
                    28972.3
                  ]
                ],
                "id": 145,
                "chat_link": "[&BJEAAAA=]"
              },
              "146": {
                "objective": "Join the Iron Legion in tearing down the Ascalonian wall.",
                "level": 51,
                "coord": [
                  61536.8,
                  29632.3
                ],
                "bounds": [
                  [
                    61953.5,
                    29512.3
                  ],
                  [
                    61561.6,
                    29940.4
                  ],
                  [
                    61455.1,
                    29813.5
                  ],
                  [
                    61474.7,
                    29637.9
                  ],
                  [
                    61488.5,
                    29584.9
                  ],
                  [
                    61646.2,
                    29471.3
                  ],
                  [
                    61817.2,
                    29385.5
                  ],
                  [
                    61953.5,
                    29512.3
                  ]
                ],
                "id": 146,
                "chat_link": "[&BJIAAAA=]"
              },
              "147": {
                "objective": "Help Kennelmaster Warsnout track the Separatists.",
                "level": 52,
                "coord": [
                  61220.2,
                  29082.3
                ],
                "bounds": [
                  [
                    61410.2,
                    29020.7
                  ],
                  [
                    61458.8,
                    29190
                  ],
                  [
                    61476.9,
                    29235.2
                  ],
                  [
                    61412.1,
                    29305
                  ],
                  [
                    61336.7,
                    29337.2
                  ],
                  [
                    61225,
                    29289.9
                  ],
                  [
                    61138,
                    29313.4
                  ],
                  [
                    61102.3,
                    29314.4
                  ],
                  [
                    61064.3,
                    29228.5
                  ],
                  [
                    61108.8,
                    29109.6
                  ],
                  [
                    61140.9,
                    29079.6
                  ],
                  [
                    61189.9,
                    29013.7
                  ],
                  [
                    61193.3,
                    28990.5
                  ],
                  [
                    61216.5,
                    28990.4
                  ],
                  [
                    61233.5,
                    28976.3
                  ],
                  [
                    61242.5,
                    28959
                  ],
                  [
                    61239,
                    28942.9
                  ],
                  [
                    61234.3,
                    28927.8
                  ],
                  [
                    61213.7,
                    28912.3
                  ],
                  [
                    61205,
                    28889.2
                  ],
                  [
                    61194.5,
                    28868.8
                  ],
                  [
                    61258.3,
                    28847.7
                  ],
                  [
                    61297.6,
                    28853.8
                  ],
                  [
                    61330.1,
                    28898.2
                  ],
                  [
                    61327.6,
                    28968.2
                  ],
                  [
                    61410.2,
                    29020.7
                  ]
                ],
                "id": 147,
                "chat_link": "[&BJMAAAA=]"
              },
              "148": {
                "objective": "Help Warden Scourgejaw run the prison quarry.",
                "level": 55,
                "coord": [
                  60149.4,
                  28554.8
                ],
                "bounds": [
                  [
                    59992.3,
                    28595
                  ],
                  [
                    59947.1,
                    28319.4
                  ],
                  [
                    59972.3,
                    28311.3
                  ],
                  [
                    60122.6,
                    28406.7
                  ],
                  [
                    60160.6,
                    28537.3
                  ],
                  [
                    60160.5,
                    28570.2
                  ],
                  [
                    59992.3,
                    28595
                  ]
                ],
                "id": 148,
                "chat_link": "[&BJQAAAA=]"
              },
              "149": {
                "objective": "Help the Sleekfur Warband defend the road at Soldier Mesa.",
                "level": 56,
                "coord": [
                  60155.7,
                  28149.3
                ],
                "bounds": [
                  [
                    60069.5,
                    28190.7
                  ],
                  [
                    60127.4,
                    28241.2
                  ],
                  [
                    60248.2,
                    28267.1
                  ],
                  [
                    60307.8,
                    28256.4
                  ],
                  [
                    60433.7,
                    28188.2
                  ],
                  [
                    60612.9,
                    28168
                  ],
                  [
                    60648.5,
                    28097.6
                  ],
                  [
                    60624.8,
                    28055.6
                  ],
                  [
                    60594,
                    27956.2
                  ],
                  [
                    60541,
                    27914.9
                  ],
                  [
                    60455.1,
                    27841.3
                  ],
                  [
                    60405.7,
                    27812.4
                  ],
                  [
                    60320.5,
                    27817.5
                  ],
                  [
                    60266.2,
                    27833.4
                  ],
                  [
                    60259.4,
                    27892.6
                  ],
                  [
                    60240.5,
                    27940.8
                  ],
                  [
                    60062.5,
                    28083
                  ],
                  [
                    60061.4,
                    28135.1
                  ],
                  [
                    60069.5,
                    28190.7
                  ]
                ],
                "id": 149,
                "chat_link": "[&BJUAAAA=]"
              },
              "150": {
                "objective": "Aid Centurion Truthbringer in Echoslab Arches.",
                "level": 53,
                "coord": [
                  60279.6,
                  29622
                ],
                "bounds": [
                  [
                    60172.5,
                    29888.6
                  ],
                  [
                    59958.9,
                    29751.7
                  ],
                  [
                    59956.7,
                    29634.1
                  ],
                  [
                    60043,
                    29600.6
                  ],
                  [
                    60141.2,
                    29427.3
                  ],
                  [
                    60253,
                    29461.6
                  ],
                  [
                    60388.2,
                    29527.9
                  ],
                  [
                    60424.1,
                    29599.9
                  ],
                  [
                    60448.6,
                    29715.7
                  ],
                  [
                    60424.9,
                    29770.5
                  ],
                  [
                    60172.5,
                    29888.6
                  ]
                ],
                "id": 150,
                "chat_link": "[&BJYAAAA=]"
              },
              "151": {
                "objective": "Aid Magister Razermane with the preservation of the Old Piken Ruins.",
                "level": 54,
                "coord": [
                  60319.1,
                  29265.8
                ],
                "bounds": [
                  [
                    60207.2,
                    29229.3
                  ],
                  [
                    60268,
                    29217
                  ],
                  [
                    60345.4,
                    29224.8
                  ],
                  [
                    60363.3,
                    29281.6
                  ],
                  [
                    60344.8,
                    29379.7
                  ],
                  [
                    60290.1,
                    29410.5
                  ],
                  [
                    60203,
                    29379.2
                  ],
                  [
                    60187,
                    29307.1
                  ],
                  [
                    60207.2,
                    29229.3
                  ]
                ],
                "id": 151,
                "chat_link": "[&BJcAAAA=]"
              },
              "152": {
                "objective": "Aid the Allied Legions as they march on the Flame Legion's territory.",
                "level": 58,
                "coord": [
                  60723.1,
                  27228.4
                ],
                "bounds": [
                  [
                    60686.4,
                    27166.4
                  ],
                  [
                    60684.8,
                    27081.1
                  ],
                  [
                    60668.5,
                    27009.4
                  ],
                  [
                    60599.6,
                    26903.1
                  ],
                  [
                    60578.2,
                    26904.5
                  ],
                  [
                    60582,
                    26980
                  ],
                  [
                    60518.9,
                    27047.2
                  ],
                  [
                    60473.8,
                    27086.1
                  ],
                  [
                    60309.8,
                    27057.3
                  ],
                  [
                    60250.9,
                    27010.5
                  ],
                  [
                    60259.3,
                    26815.9
                  ],
                  [
                    60300.8,
                    26775.4
                  ],
                  [
                    60367.9,
                    26762.8
                  ],
                  [
                    60468.6,
                    26762.8
                  ],
                  [
                    60510.7,
                    26767.2
                  ],
                  [
                    60608.3,
                    26760.8
                  ],
                  [
                    60580,
                    26820.1
                  ],
                  [
                    60606.5,
                    26822.1
                  ],
                  [
                    60752.4,
                    26733.7
                  ],
                  [
                    60819,
                    26718.6
                  ],
                  [
                    60860.5,
                    26682.6
                  ],
                  [
                    60926.2,
                    26678.2
                  ],
                  [
                    61057,
                    26684.3
                  ],
                  [
                    61151.9,
                    26712.9
                  ],
                  [
                    61186.8,
                    26826.3
                  ],
                  [
                    61156,
                    27031.4
                  ],
                  [
                    61165.7,
                    27144.6
                  ],
                  [
                    61149.4,
                    27346.3
                  ],
                  [
                    61048.4,
                    27515.5
                  ],
                  [
                    60953.8,
                    27603.4
                  ],
                  [
                    60814.8,
                    27566.9
                  ],
                  [
                    60687.6,
                    27514.4
                  ],
                  [
                    60587.9,
                    27494.5
                  ],
                  [
                    60524.7,
                    27509
                  ],
                  [
                    60461,
                    27354.5
                  ],
                  [
                    60515.3,
                    27294.9
                  ],
                  [
                    60581.6,
                    27273.7
                  ],
                  [
                    60634.4,
                    27277.4
                  ],
                  [
                    60672.2,
                    27241.3
                  ],
                  [
                    60686.4,
                    27166.4
                  ]
                ],
                "id": 152,
                "chat_link": "[&BJgAAAA=]"
              },
              "153": {
                "objective": "Aid the Scorch Warband with their assault on the Flame Legion.",
                "level": 60,
                "coord": [
                  60510.8,
                  26594
                ],
                "bounds": [
                  [
                    60278.9,
                    25855.2
                  ],
                  [
                    60519.5,
                    26502.1
                  ],
                  [
                    60572.3,
                    26611.2
                  ],
                  [
                    60559,
                    26703.4
                  ],
                  [
                    60527.9,
                    26730.6
                  ],
                  [
                    60487.2,
                    26724.2
                  ],
                  [
                    60462.3,
                    26719.9
                  ],
                  [
                    60380.5,
                    26752.3
                  ],
                  [
                    60256.6,
                    26706.1
                  ],
                  [
                    60153.4,
                    26664.9
                  ],
                  [
                    60069,
                    26396.5
                  ],
                  [
                    59867.2,
                    25850.6
                  ],
                  [
                    60278.9,
                    25855.2
                  ]
                ],
                "id": 153,
                "chat_link": "[&BJkAAAA=]"
              },
              "154": {
                "objective": "Help Braxa Scalehunter tend to the devourer nests.",
                "level": 54,
                "coord": [
                  60598.2,
                  28908.3
                ],
                "bounds": [
                  [
                    60669.7,
                    28758.9
                  ],
                  [
                    60725,
                    28778.5
                  ],
                  [
                    60740.6,
                    28836
                  ],
                  [
                    60749.5,
                    28880.5
                  ],
                  [
                    60766.5,
                    28896.9
                  ],
                  [
                    60771.5,
                    28909.6
                  ],
                  [
                    60784.9,
                    28937.5
                  ],
                  [
                    60782.1,
                    28994.7
                  ],
                  [
                    60774.5,
                    29060.2
                  ],
                  [
                    60757.8,
                    29114.2
                  ],
                  [
                    60714.8,
                    29148.8
                  ],
                  [
                    60658.4,
                    29173.5
                  ],
                  [
                    60637.7,
                    29200.4
                  ],
                  [
                    60621.2,
                    29236.6
                  ],
                  [
                    60589.5,
                    29242.8
                  ],
                  [
                    60548.2,
                    29246.9
                  ],
                  [
                    60523.4,
                    29180.1
                  ],
                  [
                    60513.5,
                    29128.3
                  ],
                  [
                    60508.2,
                    29076.6
                  ],
                  [
                    60497.1,
                    28999.5
                  ],
                  [
                    60492.3,
                    28899.7
                  ],
                  [
                    60490,
                    28858.9
                  ],
                  [
                    60508.5,
                    28819.7
                  ],
                  [
                    60574.2,
                    28762.4
                  ],
                  [
                    60669.7,
                    28758.9
                  ]
                ],
                "id": 154,
                "chat_link": "[&BJoAAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  60408.3,
                  27889
                ],
                "id": "0-44"
              },
              {
                "coord": [
                  60998.7,
                  28304.9
                ],
                "id": "0-123"
              },
              {
                "coord": [
                  60433.6,
                  27141.2
                ],
                "id": "0-120"
              },
              {
                "coord": [
                  61196.6,
                  27820
                ],
                "id": "0-121"
              },
              {
                "coord": [
                  60935.5,
                  29598.9
                ],
                "id": "0-122"
              },
              {
                "coord": [
                  61875.4,
                  27354.4
                ],
                "id": "0-124"
              }
            ],
            "sectors": {
              "433": {
                "name": "Champion's Shield",
                "level": 54,
                "coord": [
                  60464.9,
                  29077.8
                ],
                "bounds": [
                  [
                    59906.5,
                    29535.9
                  ],
                  [
                    60142.4,
                    29465.2
                  ],
                  [
                    60332.5,
                    29597.5
                  ],
                  [
                    60589.6,
                    29543.2
                  ],
                  [
                    60718.4,
                    29291.3
                  ],
                  [
                    60835.9,
                    29115.6
                  ],
                  [
                    61091.2,
                    29074.5
                  ],
                  [
                    60957.3,
                    29006.4
                  ],
                  [
                    60913.8,
                    28942.5
                  ],
                  [
                    61002.8,
                    28761.8
                  ],
                  [
                    60951.1,
                    28708.4
                  ],
                  [
                    60683.9,
                    28904.1
                  ],
                  [
                    60427.7,
                    28910
                  ],
                  [
                    60185.8,
                    28739.6
                  ],
                  [
                    60010,
                    28837
                  ],
                  [
                    59916.2,
                    28765.3
                  ],
                  [
                    59857.7,
                    28954.8
                  ],
                  [
                    59845.2,
                    29247.4
                  ],
                  [
                    59906.5,
                    29535.9
                  ]
                ],
                "id": 433,
                "chat_link": "[&BLEBAAA=]"
              },
              "434": {
                "name": "Stonesheath Overlook",
                "level": 52,
                "coord": [
                  60716.9,
                  29831.6
                ],
                "bounds": [
                  [
                    60590,
                    29542.5
                  ],
                  [
                    60789.9,
                    29653.4
                  ],
                  [
                    60847,
                    29766
                  ],
                  [
                    61007.3,
                    29781.6
                  ],
                  [
                    61022.8,
                    29864.7
                  ],
                  [
                    61004.8,
                    30017.5
                  ],
                  [
                    60894.1,
                    30007.1
                  ],
                  [
                    60882.6,
                    29951
                  ],
                  [
                    60546.7,
                    29973.3
                  ],
                  [
                    60340.5,
                    29968.3
                  ],
                  [
                    60344.7,
                    29856.1
                  ],
                  [
                    60332.8,
                    29597.5
                  ],
                  [
                    60590,
                    29542.5
                  ]
                ],
                "id": 434,
                "chat_link": "[&BLIBAAA=]"
              },
              "435": {
                "name": "Ironhead Lake",
                "level": 53,
                "coord": [
                  60996,
                  29461.3
                ],
                "bounds": [
                  [
                    60590.1,
                    29543.3
                  ],
                  [
                    60717.6,
                    29291.3
                  ],
                  [
                    60841.1,
                    29124.2
                  ],
                  [
                    61093.5,
                    29078
                  ],
                  [
                    61068.2,
                    29273.4
                  ],
                  [
                    61217.3,
                    29440.5
                  ],
                  [
                    61345.6,
                    29440.3
                  ],
                  [
                    61300.9,
                    29540.5
                  ],
                  [
                    61133.8,
                    29602.9
                  ],
                  [
                    61006.7,
                    29782.2
                  ],
                  [
                    60847.3,
                    29765.4
                  ],
                  [
                    60789.4,
                    29654
                  ],
                  [
                    60590.1,
                    29543.3
                  ]
                ],
                "id": 435,
                "chat_link": "[&BLMBAAA=]"
              },
              "436": {
                "name": "Bloodfin Lake",
                "level": 51,
                "coord": [
                  61404.3,
                  29650.5
                ],
                "bounds": [
                  [
                    61022.8,
                    29864.5
                  ],
                  [
                    61004.7,
                    29985.7
                  ],
                  [
                    61350.3,
                    29943.7
                  ],
                  [
                    61760.3,
                    29939.8
                  ],
                  [
                    61940.2,
                    29782.8
                  ],
                  [
                    61910.7,
                    29321.9
                  ],
                  [
                    61623.8,
                    29354.3
                  ],
                  [
                    61450.5,
                    29244
                  ],
                  [
                    61345,
                    29444.2
                  ],
                  [
                    61301.4,
                    29542.6
                  ],
                  [
                    61134,
                    29601.3
                  ],
                  [
                    61007.8,
                    29781.6
                  ],
                  [
                    61022.8,
                    29864.5
                  ]
                ],
                "id": 436,
                "chat_link": "[&BLQBAAA=]"
              },
              "437": {
                "name": "Hellion Forest",
                "level": 50,
                "coord": [
                  61648.8,
                  28968.5
                ],
                "bounds": [
                  [
                    61910.6,
                    29321.8
                  ],
                  [
                    61931.3,
                    29157
                  ],
                  [
                    61883.4,
                    28921.1
                  ],
                  [
                    61948.3,
                    28935.3
                  ],
                  [
                    61942.7,
                    28820.8
                  ],
                  [
                    61845.8,
                    28768.9
                  ],
                  [
                    61552.7,
                    28703.4
                  ],
                  [
                    61535.9,
                    28658.7
                  ],
                  [
                    61334.8,
                    28784.4
                  ],
                  [
                    61369.3,
                    28879.6
                  ],
                  [
                    61280.9,
                    28993.9
                  ],
                  [
                    61472.2,
                    29014.5
                  ],
                  [
                    61450.3,
                    29243.6
                  ],
                  [
                    61624.8,
                    29356.3
                  ],
                  [
                    61910.6,
                    29321.8
                  ]
                ],
                "id": 437,
                "chat_link": "[&BLUBAAA=]"
              },
              "438": {
                "name": "Sunken Halls of Clarent",
                "level": 52,
                "coord": [
                  61277.8,
                  29213.2
                ],
                "bounds": [
                  [
                    61347.8,
                    29439.2
                  ],
                  [
                    61448.9,
                    29243.7
                  ],
                  [
                    61473,
                    29014
                  ],
                  [
                    61281.3,
                    28993.9
                  ],
                  [
                    61099.6,
                    29081
                  ],
                  [
                    61072.4,
                    29280.6
                  ],
                  [
                    61221.9,
                    29440.1
                  ],
                  [
                    61347.8,
                    29439.2
                  ]
                ],
                "id": 438,
                "chat_link": "[&BLYBAAA=]"
              },
              "439": {
                "name": "Monger's Sink",
                "level": 55,
                "coord": [
                  60560.7,
                  28563.1
                ],
                "bounds": [
                  [
                    60189.3,
                    28428.1
                  ],
                  [
                    60011.7,
                    28232.8
                  ],
                  [
                    60764,
                    28201
                  ],
                  [
                    60892.6,
                    28405.2
                  ],
                  [
                    60939.4,
                    28542
                  ],
                  [
                    60951.9,
                    28705.5
                  ],
                  [
                    60684.6,
                    28903.9
                  ],
                  [
                    60427.8,
                    28910.6
                  ],
                  [
                    60184.9,
                    28738.9
                  ],
                  [
                    60189.3,
                    28428.1
                  ]
                ],
                "id": 439,
                "chat_link": "[&BLcBAAA=]"
              },
              "440": {
                "name": "Scourgejaw's Vault",
                "level": 55,
                "coord": [
                  60036.3,
                  28558.1
                ],
                "bounds": [
                  [
                    60011.6,
                    28232.4
                  ],
                  [
                    60189.3,
                    28428.5
                  ],
                  [
                    60184.8,
                    28740.4
                  ],
                  [
                    60010,
                    28836.8
                  ],
                  [
                    59913,
                    28767.2
                  ],
                  [
                    59909,
                    28343.1
                  ],
                  [
                    60011.6,
                    28232.4
                  ]
                ],
                "id": 440,
                "chat_link": "[&BLgBAAA=]"
              },
              "441": {
                "name": "Soldier Mesa",
                "level": 56,
                "coord": [
                  60336.1,
                  27971.7
                ],
                "bounds": [
                  [
                    60342.5,
                    27696.9
                  ],
                  [
                    60462,
                    27843.7
                  ],
                  [
                    60730.2,
                    27835.2
                  ],
                  [
                    60827.7,
                    28010.1
                  ],
                  [
                    60762.2,
                    28202
                  ],
                  [
                    60009.8,
                    28235.3
                  ],
                  [
                    59853.3,
                    28177.5
                  ],
                  [
                    59917,
                    27885.5
                  ],
                  [
                    60120,
                    27858.8
                  ],
                  [
                    60342.5,
                    27696.9
                  ]
                ],
                "id": 441,
                "chat_link": "[&BLkBAAA=]"
              },
              "442": {
                "name": "Viper's Run",
                "level": 56,
                "coord": [
                  61057.5,
                  27950.7
                ],
                "bounds": [
                  [
                    60828.5,
                    28010
                  ],
                  [
                    60763.3,
                    28203.4
                  ],
                  [
                    60892.7,
                    28404.1
                  ],
                  [
                    60990,
                    28252
                  ],
                  [
                    61402.5,
                    28275.4
                  ],
                  [
                    61394.3,
                    28145.3
                  ],
                  [
                    61386.3,
                    27995.3
                  ],
                  [
                    61254.2,
                    27819.5
                  ],
                  [
                    61295,
                    27411.4
                  ],
                  [
                    60876.2,
                    27384.1
                  ],
                  [
                    60877.3,
                    27671.1
                  ],
                  [
                    60730.3,
                    27836.5
                  ],
                  [
                    60828.5,
                    28010
                  ]
                ],
                "id": 442,
                "chat_link": "[&BLoBAAA=]"
              },
              "443": {
                "name": "Lamprey Grottoes",
                "level": 56,
                "coord": [
                  61114.6,
                  28502.6
                ],
                "bounds": [
                  [
                    60990.4,
                    28252.6
                  ],
                  [
                    61401.3,
                    28274.3
                  ],
                  [
                    61445.5,
                    28409.8
                  ],
                  [
                    61254.6,
                    28584.5
                  ],
                  [
                    61146.7,
                    28580.1
                  ],
                  [
                    61006.6,
                    28765.4
                  ],
                  [
                    60955.8,
                    28710.1
                  ],
                  [
                    60939,
                    28542.5
                  ],
                  [
                    60891.7,
                    28403.9
                  ],
                  [
                    60990.4,
                    28252.6
                  ]
                ],
                "id": 443,
                "chat_link": "[&BLsBAAA=]"
              },
              "444": {
                "name": "Southshore Wastes",
                "level": 56,
                "coord": [
                  61648,
                  28463.3
                ],
                "bounds": [
                  [
                    61401.6,
                    28274
                  ],
                  [
                    61394.3,
                    28143.1
                  ],
                  [
                    61636.2,
                    28231.1
                  ],
                  [
                    61896.8,
                    28115.8
                  ],
                  [
                    62035.8,
                    28179.6
                  ],
                  [
                    62144.2,
                    28346.9
                  ],
                  [
                    61940.4,
                    28819.5
                  ],
                  [
                    61846.6,
                    28769.4
                  ],
                  [
                    61552.8,
                    28704.4
                  ],
                  [
                    61537.9,
                    28654.9
                  ],
                  [
                    61334.2,
                    28778.5
                  ],
                  [
                    61258.9,
                    28597.7
                  ],
                  [
                    61444,
                    28408
                  ],
                  [
                    61401.6,
                    28274
                  ]
                ],
                "id": 444,
                "chat_link": "[&BLwBAAA=]"
              },
              "445": {
                "name": "Lake Desolann",
                "level": 57,
                "coord": [
                  61677.4,
                  27859.6
                ],
                "bounds": [
                  [
                    61253.5,
                    27818.9
                  ],
                  [
                    61294.7,
                    27411
                  ],
                  [
                    61940.3,
                    27258.2
                  ],
                  [
                    61902.2,
                    27625.6
                  ],
                  [
                    62035.8,
                    27815.3
                  ],
                  [
                    62034.7,
                    28180
                  ],
                  [
                    61896.5,
                    28116.2
                  ],
                  [
                    61636.1,
                    28231.5
                  ],
                  [
                    61394.5,
                    28143.2
                  ],
                  [
                    61386,
                    27995.9
                  ],
                  [
                    61253.5,
                    27818.9
                  ]
                ],
                "id": 445,
                "chat_link": "[&BL0BAAA=]"
              },
              "446": {
                "name": "Crystalwept Groves",
                "level": 58,
                "coord": [
                  61545.3,
                  26843.5
                ],
                "bounds": [
                  [
                    61294.3,
                    27411.6
                  ],
                  [
                    61851.2,
                    27282.6
                  ],
                  [
                    61872.8,
                    26710.5
                  ],
                  [
                    61802,
                    26532
                  ],
                  [
                    61546.5,
                    26534.2
                  ],
                  [
                    61273.5,
                    26651.4
                  ],
                  [
                    61177.1,
                    26782
                  ],
                  [
                    61294.3,
                    27411.6
                  ]
                ],
                "id": 446,
                "chat_link": "[&BL4BAAA=]"
              },
              "447": {
                "name": "The Granite Front",
                "level": 58,
                "coord": [
                  61004.1,
                  27049.1
                ],
                "bounds": [
                  [
                    60876.1,
                    27385
                  ],
                  [
                    61295.3,
                    27411.9
                  ],
                  [
                    61177.9,
                    26781.8
                  ],
                  [
                    60932.1,
                    26584.9
                  ],
                  [
                    60739.2,
                    27082.1
                  ],
                  [
                    60876.1,
                    27385
                  ]
                ],
                "id": 447,
                "chat_link": "[&BL8BAAA=]"
              },
              "448": {
                "name": "Glory's Steps",
                "level": 57,
                "coord": [
                  60620.1,
                  27536.7
                ],
                "bounds": [
                  [
                    60308.2,
                    27433.8
                  ],
                  [
                    60624.5,
                    27348.8
                  ],
                  [
                    60739.3,
                    27080.1
                  ],
                  [
                    60876.6,
                    27384.6
                  ],
                  [
                    60877.8,
                    27671.5
                  ],
                  [
                    60730.3,
                    27835.7
                  ],
                  [
                    60462,
                    27843.3
                  ],
                  [
                    60342,
                    27696.3
                  ],
                  [
                    60308.2,
                    27433.8
                  ]
                ],
                "id": 448,
                "chat_link": "[&BMABAAA=]"
              },
              "449": {
                "name": "Western Bulwark",
                "level": 57,
                "coord": [
                  60014.2,
                  27381.5
                ],
                "bounds": [
                  [
                    60119.7,
                    27863.4
                  ],
                  [
                    60342.2,
                    27698
                  ],
                  [
                    60309.1,
                    27433.6
                  ],
                  [
                    59985.5,
                    27005.6
                  ],
                  [
                    59864.3,
                    26989.7
                  ],
                  [
                    59852.4,
                    27087
                  ],
                  [
                    59896,
                    27099.2
                  ],
                  [
                    59838.8,
                    27364.9
                  ],
                  [
                    59919.9,
                    27892.1
                  ],
                  [
                    60119.7,
                    27863.4
                  ]
                ],
                "id": 449,
                "chat_link": "[&BMEBAAA=]"
              },
              "450": {
                "name": "Lake Carnifex",
                "level": 58,
                "coord": [
                  60375.3,
                  27120.4
                ],
                "bounds": [
                  [
                    60624.4,
                    27348.9
                  ],
                  [
                    60308,
                    27433.5
                  ],
                  [
                    59985.2,
                    27004.8
                  ],
                  [
                    60065.8,
                    26901.1
                  ],
                  [
                    60260.5,
                    27113.3
                  ],
                  [
                    60474.8,
                    27109
                  ],
                  [
                    60543.6,
                    26971.8
                  ],
                  [
                    60740.1,
                    27080.7
                  ],
                  [
                    60624.4,
                    27348.9
                  ]
                ],
                "id": 450,
                "chat_link": "[&BMIBAAA=]"
              },
              "451": {
                "name": "Victium Moors",
                "level": 60,
                "coord": [
                  60173.8,
                  26726.5
                ],
                "bounds": [
                  [
                    59983.5,
                    27010.9
                  ],
                  [
                    59899.5,
                    26999.2
                  ],
                  [
                    59875,
                    26921
                  ],
                  [
                    59887.9,
                    26595
                  ],
                  [
                    59966.7,
                    26345.3
                  ],
                  [
                    60158.3,
                    26318.5
                  ],
                  [
                    60273.6,
                    26231.3
                  ],
                  [
                    60328.2,
                    26359.8
                  ],
                  [
                    60541.5,
                    26560.8
                  ],
                  [
                    60544,
                    26971.9
                  ],
                  [
                    60474.8,
                    27110
                  ],
                  [
                    60259.9,
                    27113.2
                  ],
                  [
                    60065.9,
                    26907.8
                  ],
                  [
                    59983.5,
                    27010.9
                  ]
                ],
                "id": 451,
                "chat_link": "[&BMMBAAA=]"
              },
              "452": {
                "name": "Scorchlands",
                "level": 60,
                "coord": [
                  60042.4,
                  25977.2
                ],
                "bounds": [
                  [
                    60171.5,
                    25625.1
                  ],
                  [
                    60283.7,
                    25687.9
                  ],
                  [
                    60333.1,
                    25796.2
                  ],
                  [
                    60273.9,
                    26235
                  ],
                  [
                    60158.3,
                    26319.1
                  ],
                  [
                    59966.3,
                    26344.6
                  ],
                  [
                    59897.8,
                    26229
                  ],
                  [
                    59797.4,
                    26127.7
                  ],
                  [
                    59775,
                    25897.4
                  ],
                  [
                    59876.6,
                    25791.2
                  ],
                  [
                    59932.9,
                    25696.3
                  ],
                  [
                    60171.5,
                    25625.1
                  ]
                ],
                "id": 452,
                "chat_link": "[&BMQBAAA=]"
              },
              "453": {
                "name": "Obsidian Run",
                "level": 59,
                "coord": [
                  61230.1,
                  26473.2
                ],
                "bounds": [
                  [
                    61176.9,
                    26781.6
                  ],
                  [
                    61273.7,
                    26651.1
                  ],
                  [
                    61546,
                    26535
                  ],
                  [
                    61526.2,
                    26278.5
                  ],
                  [
                    61290.3,
                    26324.3
                  ],
                  [
                    60865.4,
                    26157.2
                  ],
                  [
                    60932.6,
                    26584.8
                  ],
                  [
                    61176.9,
                    26781.6
                  ]
                ],
                "id": 453,
                "chat_link": "[&BMUBAAA=]"
              },
              "454": {
                "name": "The Infestation",
                "level": 59,
                "coord": [
                  61307.4,
                  26061.9
                ],
                "bounds": [
                  [
                    61726.4,
                    25954.6
                  ],
                  [
                    61663.6,
                    26216.9
                  ],
                  [
                    61525.3,
                    26279
                  ],
                  [
                    61289,
                    26324.7
                  ],
                  [
                    60863.7,
                    26156.3
                  ],
                  [
                    60851.5,
                    25979.2
                  ],
                  [
                    61007.2,
                    25889.4
                  ],
                  [
                    61267.5,
                    25860.3
                  ],
                  [
                    61572.7,
                    25896.6
                  ],
                  [
                    61726.4,
                    25954.6
                  ]
                ],
                "id": 454,
                "chat_link": "[&BMYBAAA=]"
              },
              "455": {
                "name": "Harvester's Glade",
                "level": 51,
                "coord": [
                  61129.8,
                  28853.7
                ],
                "bounds": [
                  [
                    61148.9,
                    28583.6
                  ],
                  [
                    61253.1,
                    28590.6
                  ],
                  [
                    61366.7,
                    28876.3
                  ],
                  [
                    61281.8,
                    28992.6
                  ],
                  [
                    61099.7,
                    29075.5
                  ],
                  [
                    60962.6,
                    29005.3
                  ],
                  [
                    60915.4,
                    28939.3
                  ],
                  [
                    61010.3,
                    28766.8
                  ],
                  [
                    61148.9,
                    28583.6
                  ]
                ],
                "id": 455,
                "chat_link": "[&BMcBAAA=]"
              },
              "456": {
                "name": "Echoslab Arches",
                "level": 53,
                "coord": [
                  60135,
                  29755.7
                ],
                "bounds": [
                  [
                    60345,
                    29856.3
                  ],
                  [
                    60332.8,
                    29597.4
                  ],
                  [
                    60142.5,
                    29464.5
                  ],
                  [
                    59952.3,
                    29518
                  ],
                  [
                    59868.9,
                    29711.8
                  ],
                  [
                    59919.6,
                    29932.4
                  ],
                  [
                    60173.9,
                    29989.8
                  ],
                  [
                    60345.5,
                    29975.1
                  ],
                  [
                    60345,
                    29856.3
                  ]
                ],
                "id": 456,
                "chat_link": "[&BMgBAAA=]"
              },
              "457": {
                "name": "Ebbing Heart Run",
                "level": 59,
                "coord": [
                  61761.6,
                  26193.5
                ],
                "bounds": [
                  [
                    61546.5,
                    26534.7
                  ],
                  [
                    61802.1,
                    26532.2
                  ],
                  [
                    61883,
                    26305.9
                  ],
                  [
                    61936.2,
                    26173.6
                  ],
                  [
                    61928.4,
                    25975
                  ],
                  [
                    61832,
                    25844.7
                  ],
                  [
                    61737.3,
                    25877.4
                  ],
                  [
                    61664.5,
                    26218.3
                  ],
                  [
                    61524.7,
                    26279.5
                  ],
                  [
                    61546.5,
                    26534.7
                  ]
                ],
                "id": 457,
                "chat_link": "[&BMkBAAA=]"
              },
              "458": {
                "name": "Gladefall Run",
                "level": 60,
                "coord": [
                  60602,
                  26324.4
                ],
                "bounds": [
                  [
                    60273.1,
                    26233.3
                  ],
                  [
                    60327.8,
                    26363.8
                  ],
                  [
                    60541.3,
                    26560.7
                  ],
                  [
                    60542.8,
                    26972
                  ],
                  [
                    60739.8,
                    27082.3
                  ],
                  [
                    60933.3,
                    26585.3
                  ],
                  [
                    60865,
                    26157.5
                  ],
                  [
                    60851.2,
                    25958.5
                  ],
                  [
                    60721.5,
                    25905.5
                  ],
                  [
                    60492.7,
                    25896.5
                  ],
                  [
                    60333.3,
                    25852.8
                  ],
                  [
                    60273.1,
                    26233.3
                  ]
                ],
                "id": 458,
                "chat_link": "[&BMoBAAA=]"
              }
            },
            "adventures": [],
            "id": 25,
            "mastery_points": [
              {
                "coord": [
                  61365.6,
                  29076.2
                ],
                "id": 315,
                "region": "Tyria"
              }
            ]
          },
          "32": {
            "name": "Diessa Plateau",
            "min_level": 15,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              58048,
              28760
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                27648
              ]
            ],
            "continent_rect": [
              [
                56320,
                27648
              ],
              [
                59904,
                29952
              ]
            ],
            "points_of_interest": {
              "217": {
                "name": "Charrgate Haven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  56554.4,
                  28444.8
                ],
                "id": 217,
                "chat_link": "[&BNkAAAA=]"
              },
              "218": {
                "name": "Blasted Moors Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57831,
                  28790.4
                ],
                "id": 218,
                "chat_link": "[&BNoAAAA=]"
              },
              "219": {
                "name": "Bloodsaw Mill Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58955.1,
                  28564.2
                ],
                "id": 219,
                "chat_link": "[&BNsAAAA=]"
              },
              "220": {
                "name": "Font of Rhand Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58763,
                  27859.9
                ],
                "id": 220,
                "chat_link": "[&BNwAAAA=]"
              },
              "221": {
                "name": "Nageling Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57747.5,
                  29572.9
                ],
                "id": 221,
                "chat_link": "[&BN0AAAA=]"
              },
              "222": {
                "name": "Nolan Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  56935.2,
                  29685.9
                ],
                "id": 222,
                "chat_link": "[&BN4AAAA=]"
              },
              "271": {
                "name": "Caravan Wreckage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57147.7,
                  29499.7
                ],
                "id": 271,
                "chat_link": "[&BA8BAAA=]"
              },
              "272": {
                "name": "Bovarin Estate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57238.5,
                  28791
                ],
                "id": 272,
                "chat_link": "[&BBABAAA=]"
              },
              "273": {
                "name": "Grendich Ruins",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57689,
                  28424.4
                ],
                "id": 273,
                "chat_link": "[&BBEBAAA=]"
              },
              "274": {
                "name": "Dunrock Gulch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57482.8,
                  29775.1
                ],
                "id": 274,
                "chat_link": "[&BBIBAAA=]"
              },
              "275": {
                "name": "Ritual Isle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58412.6,
                  28379.3
                ],
                "id": 275,
                "chat_link": "[&BBMBAAA=]"
              },
              "276": {
                "name": "Burntfur's Pool",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59707.5,
                  29541.2
                ],
                "id": 276,
                "chat_link": "[&BBQBAAA=]"
              },
              "277": {
                "name": "Raintimber Mill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59305.5,
                  29339.7
                ],
                "id": 277,
                "chat_link": "[&BBUBAAA=]"
              },
              "278": {
                "name": "Stonefall Estate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58380.5,
                  29393.1
                ],
                "id": 278,
                "chat_link": "[&BBYBAAA=]"
              },
              "279": {
                "name": "Old Holtimm Abbey",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59264.6,
                  28444.2
                ],
                "id": 279,
                "chat_link": "[&BBcBAAA=]"
              },
              "350": {
                "name": "Oldgate Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  56907.8,
                  29191.4
                ],
                "id": 350,
                "chat_link": "[&BF4BAAA=]"
              },
              "351": {
                "name": "Butcher's Block Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57093.4,
                  28347.1
                ],
                "id": 351,
                "chat_link": "[&BF8BAAA=]"
              },
              "352": {
                "name": "Charradis Estate Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57506.1,
                  29097.4
                ],
                "id": 352,
                "chat_link": "[&BGABAAA=]"
              },
              "353": {
                "name": "Breached Wall Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58484.2,
                  29675.7
                ],
                "id": 353,
                "chat_link": "[&BGEBAAA=]"
              },
              "354": {
                "name": "Incendio Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59357.6,
                  28078.3
                ],
                "id": 354,
                "chat_link": "[&BGIBAAA=]"
              },
              "355": {
                "name": "Nemus Grove Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59653.9,
                  29083.6
                ],
                "id": 355,
                "chat_link": "[&BGMBAAA=]"
              },
              "356": {
                "name": "Breachwater Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59470.4,
                  29828.4
                ],
                "id": 356,
                "chat_link": "[&BGQBAAA=]"
              },
              "417": {
                "name": "Silex Castrum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56492.8,
                  29097.2
                ],
                "id": 417,
                "chat_link": "[&BKEBAAA=]"
              },
              "418": {
                "name": "Phasma Castrum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57234.8,
                  29797.6
                ],
                "id": 418,
                "chat_link": "[&BKIBAAA=]"
              },
              "922": {
                "name": "Dawnright Estate Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58480.3,
                  28979.9
                ],
                "id": 922,
                "chat_link": "[&BJoDAAA=]"
              },
              "944": {
                "name": "Camp Althea",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58576.4,
                  29808.6
                ],
                "id": 944,
                "chat_link": "[&BLADAAA=]"
              },
              "964": {
                "name": "Bloodcliff Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57433.4,
                  28086.1
                ],
                "id": 964,
                "chat_link": "[&BMQDAAA=]"
              },
              "965": {
                "name": "Sanctum Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59490.3,
                  28565
                ],
                "id": 965,
                "chat_link": "[&BMUDAAA=]"
              },
              "966": {
                "name": "Redreave Mill Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58937.2,
                  29193.3
                ],
                "id": 966,
                "chat_link": "[&BMYDAAA=]"
              },
              "969": {
                "name": "Manbane's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58193.5,
                  28258
                ],
                "id": 969,
                "chat_link": "[&BMkDAAA=]"
              },
              "987": {
                "name": "Moorwatch Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57794.5,
                  28925.1
                ],
                "id": 987,
                "chat_link": "[&BNsDAAA=]"
              },
              "988": {
                "name": "Ebonshore Plant",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58323.2,
                  28592.6
                ],
                "id": 988,
                "chat_link": "[&BNwDAAA=]"
              },
              "1033": {
                "name": "Butcher's Yard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56720.2,
                  28358.5
                ],
                "id": 1033,
                "chat_link": "[&BAkEAAA=]"
              },
              "1090": {
                "name": "Blackblade Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58744.2,
                  28271.8
                ],
                "id": 1090,
                "chat_link": "[&BEIEAAA=]"
              },
              "1493": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58740.6,
                  29717.9
                ],
                "id": 1493,
                "chat_link": "[&BNUFAAA=]"
              },
              "1494": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57825.7,
                  28926
                ],
                "id": 1494,
                "chat_link": "[&BNYFAAA=]"
              },
              "1495": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  59092.3,
                  29196.7
                ],
                "id": 1495,
                "chat_link": "[&BNcFAAA=]"
              },
              "1496": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  56532.7,
                  29856.6
                ],
                "id": 1496,
                "chat_link": "[&BNgFAAA=]"
              },
              "1497": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57701,
                  29710.2
                ],
                "id": 1497,
                "chat_link": "[&BNkFAAA=]"
              },
              "1498": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  59648.7,
                  29356.6
                ],
                "id": 1498,
                "chat_link": "[&BNoFAAA=]"
              },
              "1499": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58636.3,
                  27859.8
                ],
                "id": 1499,
                "chat_link": "[&BNsFAAA=]"
              },
              "1500": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57888.8,
                  27914.1
                ],
                "id": 1500,
                "chat_link": "[&BNwFAAA=]"
              },
              "1501": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  59646,
                  27885.4
                ],
                "id": 1501,
                "chat_link": "[&BN0FAAA=]"
              },
              "1627": {
                "name": "Old Grendich Aqueduct",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57864.8,
                  28670.8
                ],
                "id": 1627,
                "chat_link": "[&BFsGAAA=]"
              },
              "1730": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  56875.9,
                  28461.7
                ],
                "id": 1730,
                "chat_link": "[&BMIGAAA=]"
              },
              "1793": {
                "name": "North Nolan Hatchery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56392.8,
                  29590
                ],
                "id": 1793,
                "chat_link": "[&BAEHAAA=]"
              }
            },
            "tasks": {
              "168": {
                "objective": "Assist the Iron Legion fighting ghosts.",
                "level": 16,
                "coord": [
                  56862.2,
                  29498.7
                ],
                "bounds": [
                  [
                    56582.8,
                    29515.5
                  ],
                  [
                    56586.3,
                    29065.2
                  ],
                  [
                    56957.5,
                    29038.4
                  ],
                  [
                    56977.5,
                    29458.8
                  ],
                  [
                    56902.3,
                    29516.9
                  ],
                  [
                    56582.8,
                    29515.5
                  ]
                ],
                "id": 168,
                "chat_link": "[&BKgAAAA=]"
              },
              "169": {
                "objective": "Assist the Blood Legion",
                "level": 15,
                "coord": [
                  56958.6,
                  29665.4
                ],
                "bounds": [
                  [
                    56916.5,
                    29697.7
                  ],
                  [
                    56863.2,
                    29550.8
                  ],
                  [
                    57081.8,
                    29381.4
                  ],
                  [
                    57221.3,
                    29384.6
                  ],
                  [
                    57277.8,
                    29423
                  ],
                  [
                    57370.3,
                    29523.3
                  ],
                  [
                    57358.6,
                    29584.8
                  ],
                  [
                    57322.2,
                    29640.7
                  ],
                  [
                    57252.1,
                    29724.3
                  ],
                  [
                    57162,
                    29734.4
                  ],
                  [
                    57037.6,
                    29750.9
                  ],
                  [
                    56916.5,
                    29697.7
                  ]
                ],
                "id": 169,
                "chat_link": "[&BKkAAAA=]"
              },
              "170": {
                "objective": "Assist Lakor Grizzlemouth in keeping Meatoberfest running smoothly.",
                "level": 16,
                "coord": [
                  56998.8,
                  28459
                ],
                "bounds": [
                  [
                    56465.1,
                    28679.9
                  ],
                  [
                    56562.2,
                    28420.5
                  ],
                  [
                    56642.5,
                    28287
                  ],
                  [
                    57193.3,
                    28306.7
                  ],
                  [
                    57325.2,
                    28441.3
                  ],
                  [
                    57334.5,
                    28856.7
                  ],
                  [
                    57216.3,
                    28869.7
                  ],
                  [
                    57146.7,
                    28876.6
                  ],
                  [
                    56928,
                    28921.2
                  ],
                  [
                    56726.3,
                    28973.4
                  ],
                  [
                    56379.6,
                    28969.7
                  ],
                  [
                    56465.1,
                    28679.9
                  ]
                ],
                "id": 170,
                "chat_link": "[&BKoAAAA=]"
              },
              "171": {
                "objective": "Assist the Iron Legion",
                "level": 16,
                "coord": [
                  56723.2,
                  28144.4
                ],
                "bounds": [
                  [
                    56586.8,
                    28312.3
                  ],
                  [
                    56451.5,
                    27731.2
                  ],
                  [
                    56827.5,
                    27725.1
                  ],
                  [
                    57202.1,
                    27682
                  ],
                  [
                    57121.1,
                    28085.4
                  ],
                  [
                    56974.1,
                    28312.1
                  ],
                  [
                    56586.8,
                    28312.3
                  ]
                ],
                "id": 171,
                "chat_link": "[&BKsAAAA=]"
              },
              "172": {
                "objective": "Assist the Quarry Workers",
                "level": 17,
                "coord": [
                  57798.2,
                  27971
                ],
                "bounds": [
                  [
                    57551.1,
                    28148.7
                  ],
                  [
                    57473.3,
                    28153.1
                  ],
                  [
                    57451.7,
                    27869.3
                  ],
                  [
                    57548.5,
                    27753.7
                  ],
                  [
                    57918.5,
                    27769.8
                  ],
                  [
                    57961.2,
                    27937.5
                  ],
                  [
                    57886.5,
                    28150.9
                  ],
                  [
                    57551.1,
                    28148.7
                  ]
                ],
                "id": 172,
                "chat_link": "[&BKwAAAA=]"
              },
              "173": {
                "objective": "Help Rak Deathmane maintain Stonefall Estate.",
                "level": 21,
                "coord": [
                  58295.1,
                  29445.5
                ],
                "bounds": [
                  [
                    58196.5,
                    29690.3
                  ],
                  [
                    58092.9,
                    29471.1
                  ],
                  [
                    58119.5,
                    29288.5
                  ],
                  [
                    58195.5,
                    29187
                  ],
                  [
                    58285.3,
                    29184
                  ],
                  [
                    58628.8,
                    29182.4
                  ],
                  [
                    58624.4,
                    29396.3
                  ],
                  [
                    58625.2,
                    29623.4
                  ],
                  [
                    58625.9,
                    29933.7
                  ],
                  [
                    58462,
                    29879.5
                  ],
                  [
                    58196.5,
                    29690.3
                  ]
                ],
                "id": 173,
                "chat_link": "[&BK0AAAA=]"
              },
              "174": {
                "objective": "Assist Stout Darkmind",
                "level": 20,
                "coord": [
                  58309.6,
                  28645.5
                ],
                "bounds": [
                  [
                    58328.6,
                    28699.4
                  ],
                  [
                    58245.8,
                    28646.3
                  ],
                  [
                    58063.3,
                    28432.5
                  ],
                  [
                    58200.7,
                    28334.8
                  ],
                  [
                    58338,
                    28199.2
                  ],
                  [
                    58442.4,
                    28182.6
                  ],
                  [
                    58573.7,
                    28253.3
                  ],
                  [
                    58601.3,
                    28446
                  ],
                  [
                    58395,
                    28690.5
                  ],
                  [
                    58328.6,
                    28699.4
                  ]
                ],
                "id": 174,
                "chat_link": "[&BK4AAAA=]"
              },
              "175": {
                "objective": "Protect Redreave Mill from Separatists.",
                "level": 22,
                "coord": [
                  58832.3,
                  29198.8
                ],
                "bounds": [
                  [
                    58674.9,
                    29361
                  ],
                  [
                    58699.4,
                    29122.5
                  ],
                  [
                    58823.2,
                    29036.4
                  ],
                  [
                    59028.1,
                    28998.3
                  ],
                  [
                    59123.1,
                    29038.4
                  ],
                  [
                    59142,
                    29434.5
                  ],
                  [
                    58674.9,
                    29361
                  ]
                ],
                "id": 175,
                "chat_link": "[&BK8AAAA=]"
              },
              "176": {
                "objective": "Help Raintimber Mill",
                "level": 23,
                "coord": [
                  59272.5,
                  29385.1
                ],
                "bounds": [
                  [
                    59147,
                    29434.4
                  ],
                  [
                    59130.9,
                    29095.4
                  ],
                  [
                    59380.2,
                    29083.6
                  ],
                  [
                    59472.8,
                    29185.4
                  ],
                  [
                    59473.8,
                    29375.4
                  ],
                  [
                    59367.3,
                    29498.7
                  ],
                  [
                    59147,
                    29434.4
                  ]
                ],
                "id": 176,
                "chat_link": "[&BLAAAAA=]"
              },
              "177": {
                "objective": "Assist Bloodsaw Mill workers",
                "level": 24,
                "coord": [
                  59141.8,
                  28527.7
                ],
                "bounds": [
                  [
                    59202.8,
                    28699.4
                  ],
                  [
                    59134.9,
                    28765.2
                  ],
                  [
                    58869.4,
                    28756.8
                  ],
                  [
                    58803.6,
                    28743.6
                  ],
                  [
                    58799.5,
                    28704.2
                  ],
                  [
                    58883.5,
                    28648.7
                  ],
                  [
                    58921.4,
                    28660.6
                  ],
                  [
                    58951.3,
                    28692.7
                  ],
                  [
                    59032.4,
                    28663.9
                  ],
                  [
                    59062.9,
                    28615.8
                  ],
                  [
                    59064.7,
                    28580.1
                  ],
                  [
                    59030.9,
                    28529.1
                  ],
                  [
                    58989.8,
                    28430.1
                  ],
                  [
                    59056.2,
                    28274.9
                  ],
                  [
                    59164.2,
                    28310.1
                  ],
                  [
                    59199.9,
                    28377.6
                  ],
                  [
                    59206.1,
                    28491
                  ],
                  [
                    59253.7,
                    28633
                  ],
                  [
                    59202.8,
                    28699.4
                  ]
                ],
                "id": 177,
                "chat_link": "[&BLEAAAA=]"
              },
              "178": {
                "objective": "Assist the Ash Legion",
                "level": 25,
                "coord": [
                  59247.4,
                  28157.4
                ],
                "bounds": [
                  [
                    59232.1,
                    28172.3
                  ],
                  [
                    59266.6,
                    27630.5
                  ],
                  [
                    59848.2,
                    27629
                  ],
                  [
                    59848.2,
                    28159.5
                  ],
                  [
                    59354.3,
                    28244.5
                  ],
                  [
                    59232.1,
                    28172.3
                  ]
                ],
                "id": 178,
                "chat_link": "[&BLIAAAA=]"
              },
              "179": {
                "objective": "Help Kastaz Strongpaw maintain his garden.",
                "level": 18,
                "coord": [
                  57864.1,
                  29810.7
                ],
                "bounds": [
                  [
                    57776,
                    29841.7
                  ],
                  [
                    57796.9,
                    29792.8
                  ],
                  [
                    57836.3,
                    29782.3
                  ],
                  [
                    57895.9,
                    29788.5
                  ],
                  [
                    57938.8,
                    29818.8
                  ],
                  [
                    57952.8,
                    29844.5
                  ],
                  [
                    57956.5,
                    29880.6
                  ],
                  [
                    57926,
                    29926.5
                  ],
                  [
                    57885.7,
                    29942.8
                  ],
                  [
                    57841.7,
                    29937.8
                  ],
                  [
                    57798.2,
                    29908.4
                  ],
                  [
                    57785,
                    29883
                  ],
                  [
                    57776,
                    29841.7
                  ]
                ],
                "id": 179,
                "chat_link": "[&BLMAAAA=]"
              },
              "180": {
                "objective": "Help the Ash Legion take out Separatists.",
                "level": 17,
                "coord": [
                  57444.3,
                  29680.3
                ],
                "bounds": [
                  [
                    57386.8,
                    29951.4
                  ],
                  [
                    57248.8,
                    29737.4
                  ],
                  [
                    57324.7,
                    29644.3
                  ],
                  [
                    57361.3,
                    29589.6
                  ],
                  [
                    57456.8,
                    29585
                  ],
                  [
                    57548.8,
                    29635.1
                  ],
                  [
                    57616.9,
                    29693.1
                  ],
                  [
                    57616.2,
                    29941.6
                  ],
                  [
                    57386.8,
                    29951.4
                  ]
                ],
                "id": 180,
                "chat_link": "[&BLQAAAA=]"
              },
              "181": {
                "objective": "Help Charradis Estate Ranchers attend to cattle",
                "level": 17,
                "coord": [
                  57368.7,
                  29232.2
                ],
                "bounds": [
                  [
                    57283.9,
                    29283.6
                  ],
                  [
                    57269.4,
                    29174.1
                  ],
                  [
                    57321.2,
                    29063.3
                  ],
                  [
                    57421.5,
                    29041.4
                  ],
                  [
                    57480.5,
                    29084.6
                  ],
                  [
                    57501.8,
                    29121.9
                  ],
                  [
                    57497.1,
                    29175.1
                  ],
                  [
                    57413.2,
                    29326.3
                  ],
                  [
                    57283.9,
                    29283.6
                  ]
                ],
                "id": 181,
                "chat_link": "[&BLUAAAA=]"
              },
              "182": {
                "objective": "Help the Blood Legion combat ghost siege weapons.",
                "level": 19,
                "coord": [
                  57943.1,
                  28805.4
                ],
                "bounds": [
                  [
                    57993,
                    28834.7
                  ],
                  [
                    57911,
                    28869.5
                  ],
                  [
                    57867.1,
                    28864
                  ],
                  [
                    57783.3,
                    28807
                  ],
                  [
                    57714.4,
                    28775
                  ],
                  [
                    57684.9,
                    28736.9
                  ],
                  [
                    57652.4,
                    28700.3
                  ],
                  [
                    57640,
                    28612.5
                  ],
                  [
                    57633.9,
                    28551.9
                  ],
                  [
                    57633.8,
                    28501.6
                  ],
                  [
                    57609.5,
                    28456.9
                  ],
                  [
                    57611.9,
                    28431.1
                  ],
                  [
                    57592.9,
                    28406
                  ],
                  [
                    57638.4,
                    28360.2
                  ],
                  [
                    57672.1,
                    28325.6
                  ],
                  [
                    57750.9,
                    28401.5
                  ],
                  [
                    57818.9,
                    28420.7
                  ],
                  [
                    57921.6,
                    28489.3
                  ],
                  [
                    58050.1,
                    28546.2
                  ],
                  [
                    58052.9,
                    28610.6
                  ],
                  [
                    58045.8,
                    28705.5
                  ],
                  [
                    57993,
                    28834.7
                  ]
                ],
                "id": 182,
                "chat_link": "[&BLYAAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  58857.8,
                  27994.8
                ],
                "id": "0-78"
              },
              {
                "coord": [
                  57872.8,
                  28935.1
                ],
                "id": "0-119"
              },
              {
                "coord": [
                  58400.3,
                  29022
                ],
                "id": "0-117"
              },
              {
                "coord": [
                  58329.3,
                  27772.9
                ],
                "id": "0-116"
              },
              {
                "coord": [
                  57862.2,
                  28642.7
                ],
                "id": "0-118"
              },
              {
                "coord": [
                  57305.7,
                  27852.9
                ],
                "id": "0-38"
              },
              {
                "coord": [
                  56487.7,
                  28455.4
                ],
                "id": "0-80"
              },
              {
                "coord": [
                  58714.1,
                  29731.6
                ],
                "id": "0-203"
              }
            ],
            "sectors": {
              "17": {
                "name": "The Blasted Moors",
                "level": 19,
                "coord": [
                  57863.6,
                  28720.1
                ],
                "bounds": [
                  [
                    57775.8,
                    28987.3
                  ],
                  [
                    57999.8,
                    29050.8
                  ],
                  [
                    58121.8,
                    28970.7
                  ],
                  [
                    58031.1,
                    28532.5
                  ],
                  [
                    57688.9,
                    28333.8
                  ],
                  [
                    57564.5,
                    28445.6
                  ],
                  [
                    57775.8,
                    28987.3
                  ]
                ],
                "id": 17,
                "chat_link": "[&BBEAAAA=]"
              },
              "18": {
                "name": "Freewain Pastures",
                "level": 19,
                "coord": [
                  57522.8,
                  28801.6
                ],
                "bounds": [
                  [
                    58001.1,
                    29051.9
                  ],
                  [
                    58069,
                    29289.4
                  ],
                  [
                    57564,
                    29249.3
                  ],
                  [
                    57533.7,
                    28941
                  ],
                  [
                    57279,
                    28959.3
                  ],
                  [
                    56986.9,
                    28758.5
                  ],
                  [
                    57204,
                    28587.6
                  ],
                  [
                    57189.8,
                    28429
                  ],
                  [
                    57584,
                    28118.1
                  ],
                  [
                    57563.3,
                    28444.7
                  ],
                  [
                    57775.8,
                    28989.1
                  ],
                  [
                    58001.1,
                    29051.9
                  ]
                ],
                "id": 18,
                "chat_link": "[&BBIAAAA=]"
              },
              "19": {
                "name": "Rancher's Wash",
                "level": 21,
                "coord": [
                  58334.8,
                  29042.1
                ],
                "bounds": [
                  [
                    58022.1,
                    29607.5
                  ],
                  [
                    58287,
                    29585.2
                  ],
                  [
                    58613.1,
                    29600.4
                  ],
                  [
                    58657.8,
                    29363.3
                  ],
                  [
                    58579,
                    28975
                  ],
                  [
                    58534.9,
                    28788.3
                  ],
                  [
                    58455.7,
                    28738.1
                  ],
                  [
                    58517.5,
                    28553.2
                  ],
                  [
                    58461.6,
                    28497.1
                  ],
                  [
                    58030.4,
                    28531.5
                  ],
                  [
                    58123.2,
                    28969.8
                  ],
                  [
                    58000.1,
                    29051
                  ],
                  [
                    58070.3,
                    29287.6
                  ],
                  [
                    58022.1,
                    29607.5
                  ]
                ],
                "id": 19,
                "chat_link": "[&BBMAAAA=]"
              },
              "20": {
                "name": "Reaper's Corridor",
                "level": 23,
                "coord": [
                  58831.6,
                  29008.8
                ],
                "bounds": [
                  [
                    58959.8,
                    28892
                  ],
                  [
                    59016.8,
                    28698.5
                  ],
                  [
                    58752.3,
                    28799.3
                  ],
                  [
                    58536.2,
                    28788.9
                  ],
                  [
                    58578,
                    28975.5
                  ],
                  [
                    58658.8,
                    29365.2
                  ],
                  [
                    59107,
                    29392.5
                  ],
                  [
                    59044.2,
                    29158.5
                  ],
                  [
                    58959.8,
                    28892
                  ]
                ],
                "id": 20,
                "chat_link": "[&BBQAAAA=]"
              },
              "21": {
                "name": "Bulliyak Arsenal",
                "level": 23,
                "coord": [
                  58768.2,
                  28667.8
                ],
                "bounds": [
                  [
                    58534.6,
                    28789.3
                  ],
                  [
                    58455.3,
                    28736.5
                  ],
                  [
                    58518.5,
                    28554.3
                  ],
                  [
                    59009.6,
                    28508.5
                  ],
                  [
                    59089.3,
                    28586.2
                  ],
                  [
                    59017,
                    28698.4
                  ],
                  [
                    58753.4,
                    28801.7
                  ],
                  [
                    58534.6,
                    28789.3
                  ]
                ],
                "id": 21,
                "chat_link": "[&BBUAAAA=]"
              },
              "22": {
                "name": "Oldgate Clearing",
                "level": 16,
                "coord": [
                  57173.7,
                  29674.2
                ],
                "bounds": [
                  [
                    56774.2,
                    29496.8
                  ],
                  [
                    56962.9,
                    29671.9
                  ],
                  [
                    56955.8,
                    29905.5
                  ],
                  [
                    57052.6,
                    29936.1
                  ],
                  [
                    57309.6,
                    30059.9
                  ],
                  [
                    57593.1,
                    29939.2
                  ],
                  [
                    57541,
                    29562.9
                  ],
                  [
                    57442.6,
                    29416.1
                  ],
                  [
                    57156.4,
                    29305.3
                  ],
                  [
                    56949,
                    29448.9
                  ],
                  [
                    56774.2,
                    29496.8
                  ]
                ],
                "id": 22,
                "chat_link": "[&BBYAAAA=]"
              },
              "23": {
                "name": "Burrows of Moledavia",
                "level": 17,
                "coord": [
                  56617.2,
                  27877
                ],
                "bounds": [
                  [
                    56462,
                    28229.1
                  ],
                  [
                    56811.3,
                    28168.3
                  ],
                  [
                    57140.4,
                    28013.6
                  ],
                  [
                    57219.2,
                    27648.9
                  ],
                  [
                    57082.5,
                    27638.7
                  ],
                  [
                    56823.9,
                    27526
                  ],
                  [
                    56564.9,
                    27537.5
                  ],
                  [
                    56300.6,
                    27643.9
                  ],
                  [
                    56226.7,
                    27789.4
                  ],
                  [
                    56201.5,
                    27950.5
                  ],
                  [
                    56239.4,
                    28114.3
                  ],
                  [
                    56334.3,
                    28263.3
                  ],
                  [
                    56462,
                    28229.1
                  ]
                ],
                "id": 23,
                "chat_link": "[&BBcAAAA=]"
              },
              "24": {
                "name": "Nemus Groves",
                "level": 25,
                "coord": [
                  59288.2,
                  29035.2
                ],
                "bounds": [
                  [
                    59036,
                    29162.6
                  ],
                  [
                    59169.9,
                    29623.2
                  ],
                  [
                    59739.5,
                    29343.2
                  ],
                  [
                    59732.5,
                    29244.8
                  ],
                  [
                    59560.1,
                    28733.6
                  ],
                  [
                    59095.4,
                    28581.5
                  ],
                  [
                    59018,
                    28698.7
                  ],
                  [
                    58954.5,
                    28893.9
                  ],
                  [
                    59036,
                    29162.6
                  ]
                ],
                "id": 24,
                "chat_link": "[&BBgAAAA=]"
              },
              "25": {
                "name": "Sanctum Way",
                "level": 25,
                "coord": [
                  59138.8,
                  28416.1
                ],
                "bounds": [
                  [
                    59282.9,
                    28062.4
                  ],
                  [
                    59615,
                    28312.5
                  ],
                  [
                    59569.5,
                    28380
                  ],
                  [
                    59568.1,
                    28741.2
                  ],
                  [
                    59091.9,
                    28585
                  ],
                  [
                    59010.5,
                    28509.3
                  ],
                  [
                    58518.2,
                    28551.5
                  ],
                  [
                    58461.8,
                    28494.9
                  ],
                  [
                    59131.8,
                    28107.8
                  ],
                  [
                    59282.9,
                    28062.4
                  ]
                ],
                "id": 25,
                "chat_link": "[&BBkAAAA=]"
              },
              "26": {
                "name": "Incendio Templum",
                "level": 25,
                "coord": [
                  59599.9,
                  27934
                ],
                "bounds": [
                  [
                    59227.6,
                    28083
                  ],
                  [
                    59131.7,
                    27673.6
                  ],
                  [
                    59377.6,
                    27648.8
                  ],
                  [
                    59650.5,
                    27515.9
                  ],
                  [
                    59838.9,
                    27554.3
                  ],
                  [
                    60021.6,
                    27735.3
                  ],
                  [
                    60041.6,
                    28088.5
                  ],
                  [
                    59921.4,
                    28377.4
                  ],
                  [
                    59612.1,
                    28314.9
                  ],
                  [
                    59488.8,
                    28216.3
                  ],
                  [
                    59287.2,
                    28065.5
                  ],
                  [
                    59227.6,
                    28083
                  ]
                ],
                "id": 26,
                "chat_link": "[&BBoAAAA=]"
              },
              "27": {
                "name": "Holystone Caves",
                "level": 25,
                "coord": [
                  59781.6,
                  28801.5
                ],
                "bounds": [
                  [
                    59564.1,
                    28383
                  ],
                  [
                    59613.3,
                    28312.5
                  ],
                  [
                    59947.5,
                    28377
                  ],
                  [
                    60004.9,
                    28609.4
                  ],
                  [
                    60008.2,
                    28977.3
                  ],
                  [
                    59873.7,
                    29284.2
                  ],
                  [
                    59733,
                    29290.9
                  ],
                  [
                    59733.8,
                    29245.5
                  ],
                  [
                    59556,
                    28734.2
                  ],
                  [
                    59564.1,
                    28383
                  ]
                ],
                "id": 27,
                "chat_link": "[&BBsAAAA=]"
              },
              "28": {
                "name": "Town of Nolan",
                "level": 16,
                "coord": [
                  56624.4,
                  29861.1
                ],
                "bounds": [
                  [
                    56574.7,
                    30040.8
                  ],
                  [
                    56701.8,
                    29924.1
                  ],
                  [
                    56787.3,
                    29947
                  ],
                  [
                    56874.3,
                    29949.2
                  ],
                  [
                    56955.7,
                    29913
                  ],
                  [
                    56959.6,
                    29675.6
                  ],
                  [
                    56770.1,
                    29501.4
                  ],
                  [
                    56338.4,
                    29720.9
                  ],
                  [
                    56278.6,
                    29779.2
                  ],
                  [
                    56256.9,
                    29950.2
                  ],
                  [
                    56371.4,
                    30070.6
                  ],
                  [
                    56574.7,
                    30040.8
                  ]
                ],
                "id": 28,
                "chat_link": "[&BBwAAAA=]"
              },
              "29": {
                "name": "Blackblade Lake",
                "level": 23,
                "coord": [
                  58696.5,
                  28099.4
                ],
                "bounds": [
                  [
                    58460.5,
                    28495.6
                  ],
                  [
                    59131.5,
                    28110.3
                  ],
                  [
                    59227.3,
                    28081.6
                  ],
                  [
                    59153.6,
                    27787.9
                  ],
                  [
                    59129.2,
                    27664.8
                  ],
                  [
                    58860.3,
                    27639.9
                  ],
                  [
                    58908.7,
                    27778
                  ],
                  [
                    58558.8,
                    28223
                  ],
                  [
                    58475.1,
                    28237
                  ],
                  [
                    58359,
                    28230.5
                  ],
                  [
                    58062.2,
                    28412.5
                  ],
                  [
                    58031.5,
                    28532.4
                  ],
                  [
                    58460.5,
                    28495.6
                  ]
                ],
                "id": 29,
                "chat_link": "[&BB0AAAA=]"
              },
              "30": {
                "name": "Gram Hills",
                "level": 18,
                "coord": [
                  57195.9,
                  28073.9
                ],
                "bounds": [
                  [
                    57090.8,
                    28330.7
                  ],
                  [
                    57192.7,
                    28434.8
                  ],
                  [
                    57587.9,
                    28121.2
                  ],
                  [
                    57478.8,
                    27938.3
                  ],
                  [
                    57333.4,
                    27687.1
                  ],
                  [
                    57219.4,
                    27649.5
                  ],
                  [
                    57139.8,
                    28012.8
                  ],
                  [
                    56810.9,
                    28168.5
                  ],
                  [
                    56909.3,
                    28322.2
                  ],
                  [
                    57090.8,
                    28330.7
                  ]
                ],
                "id": 30,
                "chat_link": "[&BB4AAAA=]"
              },
              "31": {
                "name": "Village of Butcher's Block",
                "level": 16,
                "coord": [
                  57011.2,
                  28496.7
                ],
                "bounds": [
                  [
                    56987.3,
                    28757.6
                  ],
                  [
                    57204.7,
                    28587.5
                  ],
                  [
                    57191.2,
                    28428.4
                  ],
                  [
                    57090.9,
                    28330.8
                  ],
                  [
                    56908.8,
                    28320.4
                  ],
                  [
                    56844.1,
                    28486.3
                  ],
                  [
                    56851.3,
                    28566.4
                  ],
                  [
                    56987.3,
                    28757.6
                  ]
                ],
                "id": 31,
                "chat_link": "[&BB8AAAA=]"
              },
              "32": {
                "name": "Bloodcliff Quarry",
                "level": 18,
                "coord": [
                  57656.4,
                  27874.3
                ],
                "bounds": [
                  [
                    57311.1,
                    27646.9
                  ],
                  [
                    58011,
                    27500
                  ],
                  [
                    57897.3,
                    28161.7
                  ],
                  [
                    57583.8,
                    28118.8
                  ],
                  [
                    57479,
                    27944.1
                  ],
                  [
                    57311.1,
                    27646.9
                  ]
                ],
                "id": 32,
                "chat_link": "[&BCAAAAA=]"
              },
              "33": {
                "name": "Breachwater Lake",
                "level": 24,
                "coord": [
                  59630.1,
                  29763.3
                ],
                "bounds": [
                  [
                    59301.6,
                    29991.1
                  ],
                  [
                    59415.1,
                    30019.8
                  ],
                  [
                    59572.8,
                    30070.2
                  ],
                  [
                    59695.8,
                    30070
                  ],
                  [
                    59816.7,
                    30025.1
                  ],
                  [
                    59994.1,
                    29927.5
                  ],
                  [
                    59877.6,
                    29283
                  ],
                  [
                    59725.5,
                    29287.1
                  ],
                  [
                    59732.6,
                    29338
                  ],
                  [
                    59169,
                    29620.8
                  ],
                  [
                    59301.6,
                    29991.1
                  ]
                ],
                "id": 33,
                "chat_link": "[&BCEAAAA=]"
              },
              "34": {
                "name": "Town of Nageling",
                "level": 19,
                "coord": [
                  57728.7,
                  29424.5
                ],
                "bounds": [
                  [
                    58070.5,
                    29287.2
                  ],
                  [
                    58022,
                    29608
                  ],
                  [
                    57539.8,
                    29561.6
                  ],
                  [
                    57447.8,
                    29412.2
                  ],
                  [
                    57563.5,
                    29253.5
                  ],
                  [
                    58070.5,
                    29287.2
                  ]
                ],
                "id": 34,
                "chat_link": "[&BCIAAAA=]"
              },
              "35": {
                "name": "Noxin Dells",
                "level": 19,
                "coord": [
                  57912.8,
                  29778.3
                ],
                "bounds": [
                  [
                    57539,
                    29560.5
                  ],
                  [
                    58022.4,
                    29607.7
                  ],
                  [
                    58288.3,
                    29585.5
                  ],
                  [
                    58149.4,
                    29947.9
                  ],
                  [
                    57887.6,
                    30031.1
                  ],
                  [
                    57590.2,
                    29937.2
                  ],
                  [
                    57539,
                    29560.5
                  ]
                ],
                "id": 35,
                "chat_link": "[&BCMAAAA=]"
              },
              "36": {
                "name": "Ruins of Oldgate",
                "level": 17,
                "coord": [
                  56780.1,
                  29281.8
                ],
                "bounds": [
                  [
                    56773.9,
                    29497
                  ],
                  [
                    56948,
                    29449.8
                  ],
                  [
                    56939.1,
                    29157.2
                  ],
                  [
                    56758.2,
                    29034.8
                  ],
                  [
                    56632.9,
                    29178
                  ],
                  [
                    56628.3,
                    29374.3
                  ],
                  [
                    56773.9,
                    29497
                  ]
                ],
                "id": 36,
                "chat_link": "[&BCQAAAA=]"
              },
              "37": {
                "name": "Wodron Glens",
                "level": 18,
                "coord": [
                  57179.3,
                  29141.1
                ],
                "bounds": [
                  [
                    56988.1,
                    28756.9
                  ],
                  [
                    57279.2,
                    28959.5
                  ],
                  [
                    57532.9,
                    28941.6
                  ],
                  [
                    57563.9,
                    29252.8
                  ],
                  [
                    57445.6,
                    29414.6
                  ],
                  [
                    57160.8,
                    29304.4
                  ],
                  [
                    56948,
                    29447.8
                  ],
                  [
                    56936.5,
                    29156.8
                  ],
                  [
                    56758.9,
                    29035.3
                  ],
                  [
                    56988.1,
                    28756.9
                  ]
                ],
                "id": 37,
                "chat_link": "[&BCUAAAA=]"
              },
              "38": {
                "name": "Spider Nest Cavern",
                "level": 22,
                "coord": [
                  58190.8,
                  27833.8
                ],
                "bounds": [
                  [
                    57893.1,
                    28167.6
                  ],
                  [
                    58453.6,
                    28055.1
                  ],
                  [
                    58332.9,
                    27719.3
                  ],
                  [
                    58294.9,
                    27644.3
                  ],
                  [
                    57979.5,
                    27582.8
                  ],
                  [
                    57893.1,
                    28167.6
                  ]
                ],
                "id": 38,
                "chat_link": "[&BCYAAAA=]"
              },
              "39": {
                "name": "The Breached Wall",
                "level": 23,
                "coord": [
                  58699.7,
                  29729.8
                ],
                "bounds": [
                  [
                    58286.2,
                    29586.4
                  ],
                  [
                    58613.9,
                    29597.8
                  ],
                  [
                    58663.2,
                    29357.2
                  ],
                  [
                    59106.1,
                    29391.2
                  ],
                  [
                    59170.5,
                    29623.1
                  ],
                  [
                    59305.8,
                    29989.1
                  ],
                  [
                    58776.5,
                    30094.3
                  ],
                  [
                    58229.4,
                    29982.6
                  ],
                  [
                    58146.1,
                    29946.5
                  ],
                  [
                    58286.2,
                    29586.4
                  ]
                ],
                "id": 39,
                "chat_link": "[&BCcAAAA=]"
              },
              "40": {
                "name": "Arcovian Foothills",
                "level": 17,
                "coord": [
                  56514.8,
                  29273
                ],
                "bounds": [
                  [
                    56345.7,
                    29718.1
                  ],
                  [
                    56775,
                    29495.9
                  ],
                  [
                    56629.5,
                    29371.7
                  ],
                  [
                    56632.1,
                    29179.1
                  ],
                  [
                    56758.9,
                    29036.8
                  ],
                  [
                    56665.3,
                    28867.1
                  ],
                  [
                    56344.9,
                    29015.9
                  ],
                  [
                    56247.1,
                    29213.1
                  ],
                  [
                    56235,
                    29559.6
                  ],
                  [
                    56345.7,
                    29718.1
                  ]
                ],
                "id": 40,
                "chat_link": "[&BCgAAAA=]"
              },
              "41": {
                "name": "Halrunting Plains",
                "level": 16,
                "coord": [
                  56651.4,
                  28511.7
                ],
                "bounds": [
                  [
                    56304.4,
                    28620.7
                  ],
                  [
                    56655.9,
                    28569.2
                  ],
                  [
                    56745,
                    28658.5
                  ],
                  [
                    56666,
                    28866.4
                  ],
                  [
                    56759.4,
                    29036.2
                  ],
                  [
                    56987,
                    28759.3
                  ],
                  [
                    56852,
                    28566.3
                  ],
                  [
                    56844.5,
                    28486.7
                  ],
                  [
                    56909.3,
                    28320.4
                  ],
                  [
                    56811.6,
                    28167.8
                  ],
                  [
                    56579,
                    28210
                  ],
                  [
                    56462.5,
                    28227.3
                  ],
                  [
                    56304.9,
                    28265.9
                  ],
                  [
                    56238.8,
                    28408.6
                  ],
                  [
                    56304.4,
                    28620.7
                  ]
                ],
                "id": 41,
                "chat_link": "[&BCkAAAA=]"
              },
              "294": {
                "name": "The Wurm's Gullet",
                "level": 16,
                "coord": [
                  56501.7,
                  28757.8
                ],
                "bounds": [
                  [
                    56344,
                    29018.9
                  ],
                  [
                    56665.8,
                    28867.6
                  ],
                  [
                    56745.3,
                    28659.9
                  ],
                  [
                    56658,
                    28563.6
                  ],
                  [
                    56306.1,
                    28616.2
                  ],
                  [
                    56291.3,
                    28820.5
                  ],
                  [
                    56344,
                    29018.9
                  ]
                ],
                "id": 294,
                "chat_link": "[&BCYBAAA=]"
              },
              "627": {
                "name": "Manbane's Outcrop",
                "level": 20,
                "coord": [
                  58011.7,
                  28279.6
                ],
                "bounds": [
                  [
                    57690.8,
                    28335
                  ],
                  [
                    58031.3,
                    28531.9
                  ],
                  [
                    58062,
                    28412.1
                  ],
                  [
                    58358.6,
                    28229.5
                  ],
                  [
                    58476,
                    28234.3
                  ],
                  [
                    58445.5,
                    28049.1
                  ],
                  [
                    57897.1,
                    28161.2
                  ],
                  [
                    57583.6,
                    28118.1
                  ],
                  [
                    57560.7,
                    28445.4
                  ],
                  [
                    57690.8,
                    28335
                  ]
                ],
                "id": 627,
                "chat_link": "[&BHMCAAA=]"
              },
              "824": {
                "name": "Flame Temple Tombs",
                "level": 28,
                "coord": [
                  58587.1,
                  27847.7
                ],
                "bounds": [
                  [
                    58454.8,
                    28056.2
                  ],
                  [
                    58324.6,
                    27694.6
                  ],
                  [
                    58471.7,
                    27578.4
                  ],
                  [
                    58640.7,
                    27567.1
                  ],
                  [
                    58861,
                    27640.5
                  ],
                  [
                    58908.9,
                    27783.5
                  ],
                  [
                    58558.4,
                    28223.6
                  ],
                  [
                    58476.4,
                    28238
                  ],
                  [
                    58454.8,
                    28056.2
                  ]
                ],
                "id": 824,
                "chat_link": "[&BDgDAAA=]"
              }
            },
            "adventures": [],
            "id": 32,
            "mastery_points": []
          },
          "218": {
            "name": "Black Citadel",
            "min_level": 0,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "827": {
                "name": "Ash Tribune Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57031.2,
                  30507.2
                ],
                "id": 827,
                "chat_link": "[&BDsDAAA=]"
              },
              "828": {
                "name": "Blood Tribune Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57061.9,
                  30687.5
                ],
                "id": 828,
                "chat_link": "[&BDwDAAA=]"
              },
              "829": {
                "name": "Fahrar of Young Heroes",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57785.7,
                  30416.9
                ],
                "id": 829,
                "chat_link": "[&BD0DAAA=]"
              },
              "830": {
                "name": "Abandoned Caverns (Access Prohibited)",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56545.4,
                  31364.3
                ],
                "id": 830,
                "chat_link": "[&BD4DAAA=]"
              },
              "831": {
                "name": "Iron Tribune Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57090.7,
                  30675.6
                ],
                "id": 831,
                "chat_link": "[&BD8DAAA=]"
              },
              "832": {
                "name": "Durmand Scriptorium",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57446,
                  30166.5
                ],
                "id": 832,
                "chat_link": "[&BEADAAA=]"
              },
              "833": {
                "name": "Vigil Chapterhouse",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57390.1,
                  30714
                ],
                "id": 833,
                "chat_link": "[&BEEDAAA=]"
              },
              "834": {
                "name": "Serrated Blade Tavern",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57268,
                  30262
                ],
                "id": 834,
                "chat_link": "[&BEIDAAA=]"
              },
              "924": {
                "name": "Ash Checkpoint 13",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57685.8,
                  30451
                ],
                "id": 924,
                "chat_link": "[&BJwDAAA=]"
              },
              "925": {
                "name": "Hero's Forum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57404.5,
                  30448.7
                ],
                "id": 925,
                "chat_link": "[&BJ0DAAA=]"
              },
              "926": {
                "name": "20th Blood Cohort",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57567.1,
                  30223.9
                ],
                "id": 926,
                "chat_link": "[&BJ4DAAA=]"
              },
              "927": {
                "name": "Ashford Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57814.7,
                  30611.5
                ],
                "id": 927,
                "chat_link": "[&BJ8DAAA=]"
              },
              "928": {
                "name": "12th Iron Maniple",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57754.3,
                  30227
                ],
                "id": 928,
                "chat_link": "[&BKADAAA=]"
              },
              "929": {
                "name": "Citadel Stockade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57151.1,
                  30615.6
                ],
                "id": 929,
                "chat_link": "[&BKEDAAA=]"
              },
              "930": {
                "name": "Storm Caller Triumph",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57057.3,
                  30828.5
                ],
                "id": 930,
                "chat_link": "[&BKIDAAA=]"
              },
              "931": {
                "name": "The War Council",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57093.3,
                  30609.7
                ],
                "id": 931,
                "chat_link": "[&BKMDAAA=]"
              },
              "932": {
                "name": "Gladium Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57120.3,
                  31106.3
                ],
                "id": 932,
                "chat_link": "[&BKQDAAA=]"
              },
              "933": {
                "name": "Mustering Ground Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57733.4,
                  30623.3
                ],
                "id": 933,
                "chat_link": "[&BKUDAAA=]"
              },
              "934": {
                "name": "Memorial Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57138,
                  30368.3
                ],
                "id": 934,
                "chat_link": "[&BKYDAAA=]"
              },
              "935": {
                "name": "Factorium Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57379.1,
                  30254.9
                ],
                "id": 935,
                "chat_link": "[&BKcDAAA=]"
              },
              "936": {
                "name": "Diessa Gate Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57030,
                  30146.9
                ],
                "id": 936,
                "chat_link": "[&BKgDAAA=]"
              },
              "937": {
                "name": "Ligacus Aquilo Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  56831.1,
                  30474.5
                ],
                "id": 937,
                "chat_link": "[&BKkDAAA=]"
              },
              "938": {
                "name": "Bane Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57039.2,
                  30536.1
                ],
                "id": 938,
                "chat_link": "[&BKoDAAA=]"
              },
              "939": {
                "name": "Hero's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57367.3,
                  30552.9
                ],
                "id": 939,
                "chat_link": "[&BKsDAAA=]"
              },
              "940": {
                "name": "Ruins of Rin Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  56879.8,
                  31208.5
                ],
                "id": 940,
                "chat_link": "[&BKwDAAA=]"
              },
              "941": {
                "name": "Imperator's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57089,
                  30642.5
                ],
                "id": 941,
                "chat_link": "[&BK0DAAA=]"
              },
              "1079": {
                "name": "Junker's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57222,
                  30898.1
                ],
                "id": 1079,
                "chat_link": "[&BDcEAAA=]"
              },
              "1140": {
                "name": "Plaza of Remembrance",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56984.6,
                  30295.5
                ],
                "id": 1140,
                "chat_link": "[&BHQEAAA=]"
              },
              "1448": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57510.7,
                  31014.1
                ],
                "id": 1448,
                "chat_link": "[&BKgFAAA=]"
              },
              "1449": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  56862.1,
                  31450.3
                ],
                "id": 1449,
                "chat_link": "[&BKkFAAA=]"
              },
              "1450": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  56618.5,
                  30814.6
                ],
                "id": 1450,
                "chat_link": "[&BKoFAAA=]"
              },
              "1451": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57170.7,
                  30240
                ],
                "id": 1451,
                "chat_link": "[&BKsFAAA=]"
              },
              "1452": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57018.4,
                  31063.8
                ],
                "id": 1452,
                "chat_link": "[&BKwFAAA=]"
              },
              "1833": {
                "name": "Haunted Nolani Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  56605.1,
                  30513.3
                ],
                "id": 1833,
                "chat_link": "[&BCkHAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "740": {
                "name": "The Bane",
                "level": 0,
                "coord": [
                  56926.4,
                  30597.2
                ],
                "bounds": [
                  [
                    56807.9,
                    30588.7
                  ],
                  [
                    56842.9,
                    30517.5
                  ],
                  [
                    56895.7,
                    30469.8
                  ],
                  [
                    56971.6,
                    30450.5
                  ],
                  [
                    57020.1,
                    30460.7
                  ],
                  [
                    57066.5,
                    30475.4
                  ],
                  [
                    57007.7,
                    30495.6
                  ],
                  [
                    57041.2,
                    30788.5
                  ],
                  [
                    56952.9,
                    30795.1
                  ],
                  [
                    56875,
                    30763.3
                  ],
                  [
                    56825.9,
                    30707.5
                  ],
                  [
                    56808.6,
                    30654.1
                  ],
                  [
                    56807.9,
                    30588.7
                  ]
                ],
                "id": 740,
                "chat_link": "[&BOQCAAA=]"
              },
              "744": {
                "name": "Mustering Ground",
                "level": 0,
                "coord": [
                  57622,
                  30648.7
                ],
                "bounds": [
                  [
                    57372.6,
                    30664.2
                  ],
                  [
                    57372.6,
                    30556.7
                  ],
                  [
                    57866.6,
                    30544.8
                  ],
                  [
                    57868.2,
                    30671.5
                  ],
                  [
                    57706.2,
                    30687.7
                  ],
                  [
                    57701.3,
                    30724.8
                  ],
                  [
                    57466.5,
                    30691.3
                  ],
                  [
                    57372.6,
                    30664.2
                  ]
                ],
                "id": 744,
                "chat_link": "[&BOgCAAA=]"
              },
              "746": {
                "name": "Gladium Canton",
                "level": 0,
                "coord": [
                  57068.5,
                  31033.3
                ],
                "bounds": [
                  [
                    56851.5,
                    31106.8
                  ],
                  [
                    56968.8,
                    30910.6
                  ],
                  [
                    57070,
                    30934.8
                  ],
                  [
                    57186.8,
                    30921.9
                  ],
                  [
                    57241.5,
                    31151.3
                  ],
                  [
                    57092.8,
                    31174.5
                  ],
                  [
                    56851.5,
                    31106.8
                  ]
                ],
                "id": 746,
                "chat_link": "[&BOoCAAA=]"
              },
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              },
              "811": {
                "name": "Haunted Nolani",
                "level": 0,
                "coord": [
                  56743,
                  30151
                ],
                "bounds": [
                  [
                    56592.2,
                    30043.2
                  ],
                  [
                    56747.6,
                    30044.9
                  ],
                  [
                    56840.4,
                    29937.4
                  ],
                  [
                    56952.6,
                    30301.9
                  ],
                  [
                    56787.3,
                    30307.6
                  ],
                  [
                    56538,
                    30271.2
                  ],
                  [
                    56592.2,
                    30043.2
                  ]
                ],
                "id": 811,
                "chat_link": "[&BCsDAAA=]"
              },
              "812": {
                "name": "Iron Legion Arsenal",
                "level": 0,
                "coord": [
                  57390.4,
                  30760
                ],
                "bounds": [
                  [
                    57308.4,
                    30786.6
                  ],
                  [
                    57368.6,
                    30668.2
                  ],
                  [
                    57466.3,
                    30691.7
                  ],
                  [
                    57423.2,
                    30795.8
                  ],
                  [
                    57385.3,
                    30857.5
                  ],
                  [
                    57308.4,
                    30786.6
                  ]
                ],
                "id": 812,
                "chat_link": "[&BCwDAAA=]"
              },
              "813": {
                "name": "Canton Factorium",
                "level": 0,
                "coord": [
                  57322.6,
                  30121
                ],
                "bounds": [
                  [
                    57154.9,
                    30356.3
                  ],
                  [
                    57126,
                    30087.8
                  ],
                  [
                    57107.3,
                    29895.6
                  ],
                  [
                    57313.2,
                    29870.1
                  ],
                  [
                    57531.9,
                    29917.1
                  ],
                  [
                    57667.1,
                    29971.6
                  ],
                  [
                    57468.5,
                    30209.8
                  ],
                  [
                    57305.1,
                    30407.1
                  ],
                  [
                    57229.5,
                    30373.6
                  ],
                  [
                    57154.9,
                    30356.3
                  ]
                ],
                "id": 813,
                "chat_link": "[&BC0DAAA=]"
              },
              "815": {
                "name": "Hero's Canton (Home)",
                "level": 0,
                "coord": [
                  57570.9,
                  30334.7
                ],
                "bounds": [
                  [
                    57299,
                    30404.2
                  ],
                  [
                    57460.8,
                    30205.5
                  ],
                  [
                    57724.4,
                    29900.3
                  ],
                  [
                    57905.2,
                    30080
                  ],
                  [
                    57862.9,
                    30402.6
                  ],
                  [
                    57861,
                    30539.9
                  ],
                  [
                    57372.5,
                    30556.6
                  ],
                  [
                    57324,
                    30487.1
                  ],
                  [
                    57328.4,
                    30436.3
                  ],
                  [
                    57299,
                    30404.2
                  ]
                ],
                "id": 815,
                "chat_link": "[&BC8DAAA=]"
              },
              "816": {
                "name": "Ligacus Notos",
                "level": 0,
                "coord": [
                  56676.8,
                  30846
                ],
                "bounds": [
                  [
                    56229.3,
                    31072.3
                  ],
                  [
                    56315.4,
                    30846.2
                  ],
                  [
                    56253.4,
                    30543.8
                  ],
                  [
                    56807.8,
                    30591.3
                  ],
                  [
                    56808.9,
                    30654.7
                  ],
                  [
                    56829.5,
                    30706.1
                  ],
                  [
                    56876.3,
                    30763.9
                  ],
                  [
                    56955.5,
                    30792.3
                  ],
                  [
                    57002.5,
                    30790.1
                  ],
                  [
                    56968.5,
                    30911.4
                  ],
                  [
                    56852.3,
                    31104.7
                  ],
                  [
                    56222.4,
                    31375.8
                  ],
                  [
                    56229.3,
                    31072.3
                  ]
                ],
                "id": 816,
                "chat_link": "[&BDADAAA=]"
              },
              "817": {
                "name": "Perimeter Loop",
                "level": 0,
                "coord": [
                  57187.5,
                  30628.6
                ],
                "bounds": [
                  [
                    56978.8,
                    30386.7
                  ],
                  [
                    57066.5,
                    30349.7
                  ],
                  [
                    57155.7,
                    30353.3
                  ],
                  [
                    57231.9,
                    30375.6
                  ],
                  [
                    57305.8,
                    30411.1
                  ],
                  [
                    57332.3,
                    30443.3
                  ],
                  [
                    57326.2,
                    30493.3
                  ],
                  [
                    57375.2,
                    30560
                  ],
                  [
                    57371.1,
                    30659.8
                  ],
                  [
                    57306.9,
                    30790.5
                  ],
                  [
                    57342.6,
                    30817
                  ],
                  [
                    57260.8,
                    30890.8
                  ],
                  [
                    57189.3,
                    30919.9
                  ],
                  [
                    57067.2,
                    30935.5
                  ],
                  [
                    56967.5,
                    30914.8
                  ],
                  [
                    56996.8,
                    30795.9
                  ],
                  [
                    57050.3,
                    30735.5
                  ],
                  [
                    57092,
                    30748.3
                  ],
                  [
                    57162.6,
                    30750.6
                  ],
                  [
                    57230.4,
                    30707.1
                  ],
                  [
                    57261.5,
                    30656.8
                  ],
                  [
                    57250.8,
                    30571.5
                  ],
                  [
                    57195.1,
                    30495.8
                  ],
                  [
                    57127,
                    30466.6
                  ],
                  [
                    57042.4,
                    30485.1
                  ],
                  [
                    56978.8,
                    30386.7
                  ]
                ],
                "id": 817,
                "chat_link": "[&BDEDAAA=]"
              },
              "818": {
                "name": "War Wagon Prep Deck",
                "level": 0,
                "coord": [
                  57572.7,
                  30801.2
                ],
                "bounds": [
                  [
                    57410.8,
                    30818.3
                  ],
                  [
                    57466.9,
                    30691.1
                  ],
                  [
                    57704.4,
                    30724
                  ],
                  [
                    57691.2,
                    30812
                  ],
                  [
                    57590.1,
                    30960.6
                  ],
                  [
                    57410.8,
                    30818.3
                  ]
                ],
                "id": 818,
                "chat_link": "[&BDIDAAA=]"
              },
              "819": {
                "name": "Memorial Quadrant",
                "level": 0,
                "coord": [
                  57004,
                  30096.5
                ],
                "bounds": [
                  [
                    57156,
                    30350.7
                  ],
                  [
                    57064,
                    30345.5
                  ],
                  [
                    56976.7,
                    30389.9
                  ],
                  [
                    56842.1,
                    29939.4
                  ],
                  [
                    56926.4,
                    29934
                  ],
                  [
                    56956,
                    29867.9
                  ],
                  [
                    57106.5,
                    29848.4
                  ],
                  [
                    57156,
                    30350.7
                  ]
                ],
                "id": 819,
                "chat_link": "[&BDMDAAA=]"
              },
              "821": {
                "name": "Praetor's Canton",
                "level": 0,
                "coord": [
                  57762.1,
                  30853.4
                ],
                "bounds": [
                  [
                    57706.4,
                    30686.2
                  ],
                  [
                    57878.3,
                    30675.8
                  ],
                  [
                    57919.9,
                    30877
                  ],
                  [
                    57788.5,
                    31108.4
                  ],
                  [
                    57589,
                    30958.2
                  ],
                  [
                    57690.5,
                    30815
                  ],
                  [
                    57706.4,
                    30686.2
                  ]
                ],
                "id": 821,
                "chat_link": "[&BDUDAAA=]"
              },
              "822": {
                "name": "Ruins of Rin",
                "level": 0,
                "coord": [
                  56655.8,
                  31441.9
                ],
                "bounds": [
                  [
                    56848.4,
                    31097.3
                  ],
                  [
                    57080.1,
                    31165.5
                  ],
                  [
                    56870.1,
                    31539.3
                  ],
                  [
                    56662.8,
                    31705.2
                  ],
                  [
                    56282.3,
                    31765.1
                  ],
                  [
                    56190.7,
                    31378.8
                  ],
                  [
                    56848.4,
                    31097.3
                  ]
                ],
                "id": 822,
                "chat_link": "[&BDYDAAA=]"
              },
              "823": {
                "name": "Ligacus Aquilo",
                "level": 0,
                "coord": [
                  56786.7,
                  30428.3
                ],
                "bounds": [
                  [
                    56251.5,
                    30544.9
                  ],
                  [
                    56328,
                    30244.3
                  ],
                  [
                    56788,
                    30310.5
                  ],
                  [
                    56957.3,
                    30301.6
                  ],
                  [
                    56983,
                    30393.2
                  ],
                  [
                    57031.7,
                    30469.6
                  ],
                  [
                    56973,
                    30450.5
                  ],
                  [
                    56897.5,
                    30470.5
                  ],
                  [
                    56846.1,
                    30509.1
                  ],
                  [
                    56810.5,
                    30589.3
                  ],
                  [
                    56251.5,
                    30544.9
                  ]
                ],
                "id": 823,
                "chat_link": "[&BDcDAAA=]"
              },
              "831": {
                "name": "Junker's Scrapyard",
                "level": 0,
                "coord": [
                  57339.5,
                  30907.4
                ],
                "bounds": [
                  [
                    57187.7,
                    30922.4
                  ],
                  [
                    57261.6,
                    30886.7
                  ],
                  [
                    57342.3,
                    30814.3
                  ],
                  [
                    57387.2,
                    30854.4
                  ],
                  [
                    57407.9,
                    30812.3
                  ],
                  [
                    57544.4,
                    30919.5
                  ],
                  [
                    57245.3,
                    31142.6
                  ],
                  [
                    57187.7,
                    30922.4
                  ]
                ],
                "id": 831,
                "chat_link": "[&BD8DAAA=]"
              },
              "832": {
                "name": "Great Imperial Smelter",
                "level": 0,
                "coord": [
                  57582.8,
                  31251.1
                ],
                "bounds": [
                  [
                    57239,
                    31148
                  ],
                  [
                    57378.9,
                    31432.9
                  ],
                  [
                    57805.6,
                    31533.4
                  ],
                  [
                    57946.8,
                    31220.7
                  ],
                  [
                    57543.4,
                    30920.6
                  ],
                  [
                    57239,
                    31148
                  ]
                ],
                "id": 832,
                "chat_link": "[&BEADAAA=]"
              },
              "1141": {
                "name": "Nolani Academy Ruins",
                "level": 0,
                "coord": [
                  56558.2,
                  30046.9
                ],
                "bounds": [
                  [
                    56329,
                    30243.3
                  ],
                  [
                    56540.7,
                    30272
                  ],
                  [
                    56599.2,
                    30046.8
                  ],
                  [
                    56747.1,
                    30047.9
                  ],
                  [
                    56844.1,
                    29936.4
                  ],
                  [
                    56730.9,
                    29867.3
                  ],
                  [
                    56415.5,
                    29891
                  ],
                  [
                    56258.9,
                    30070.9
                  ],
                  [
                    56329,
                    30243.3
                  ]
                ],
                "id": 1141,
                "chat_link": "[&BHUEAAA=]"
              }
            },
            "adventures": [],
            "id": 218,
            "mastery_points": []
          },
          "371": {
            "name": "Hero's Canton (Home)",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "829": {
                "name": "Fahrar of Young Heroes",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57785.7,
                  30416.9
                ],
                "id": 829,
                "chat_link": "[&BD0DAAA=]"
              },
              "924": {
                "name": "Ash Checkpoint 13",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57685.8,
                  30451
                ],
                "id": 924,
                "chat_link": "[&BJwDAAA=]"
              },
              "925": {
                "name": "Hero's Forum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57404.5,
                  30448.7
                ],
                "id": 925,
                "chat_link": "[&BJ0DAAA=]"
              },
              "926": {
                "name": "20th Blood Cohort",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57567.1,
                  30223.9
                ],
                "id": 926,
                "chat_link": "[&BJ4DAAA=]"
              },
              "928": {
                "name": "12th Iron Maniple",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57754.3,
                  30227
                ],
                "id": 928,
                "chat_link": "[&BKADAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "815": {
                "name": "Hero's Canton (Home)",
                "level": 0,
                "coord": [
                  57570.9,
                  30334.7
                ],
                "bounds": [
                  [
                    57299,
                    30404.2
                  ],
                  [
                    57460.8,
                    30205.5
                  ],
                  [
                    57724.4,
                    29900.3
                  ],
                  [
                    57905.2,
                    30080
                  ],
                  [
                    57862.9,
                    30402.6
                  ],
                  [
                    57861,
                    30539.9
                  ],
                  [
                    57372.5,
                    30556.6
                  ],
                  [
                    57324,
                    30487.1
                  ],
                  [
                    57328.4,
                    30436.3
                  ],
                  [
                    57299,
                    30404.2
                  ]
                ],
                "id": 815,
                "chat_link": "[&BC8DAAA=]"
              }
            },
            "id": 371,
            "mastery_points": [],
            "adventures": []
          },
          "372": {
            "name": "Blood Tribune Quarters",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "828": {
                "name": "Blood Tribune Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57061.9,
                  30687.5
                ],
                "id": 828,
                "chat_link": "[&BDwDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "id": 372,
            "mastery_points": [],
            "adventures": []
          },
          "373": {
            "name": "The Command Core",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "831": {
                "name": "Iron Tribune Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57090.7,
                  30675.6
                ],
                "id": 831,
                "chat_link": "[&BD8DAAA=]"
              },
              "931": {
                "name": "The War Council",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57093.3,
                  30609.7
                ],
                "id": 931,
                "chat_link": "[&BKMDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "adventures": [],
            "id": 373,
            "mastery_points": []
          },
          "460": {
            "name": "Citadel Stockade",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "929": {
                "name": "Citadel Stockade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57151.1,
                  30615.6
                ],
                "id": 929,
                "chat_link": "[&BKEDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "id": 460,
            "mastery_points": [],
            "adventures": []
          },
          "833": {
            "name": "Ash Tribune Quarters",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "827": {
                "name": "Ash Tribune Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57031.2,
                  30507.2
                ],
                "id": 827,
                "chat_link": "[&BDsDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "adventures": [],
            "id": 833,
            "mastery_points": []
          },
          "1074": {
            "name": "Blightwater Shatterstrike",
            "min_level": 40,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              62998,
              30464
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                61952,
                28544
              ],
              [
                64000,
                32640
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "484": {
                "name": "Tawny Ridge",
                "level": 49,
                "coord": [
                  63787.3,
                  29317.5
                ],
                "bounds": [
                  [
                    63834.3,
                    29385.9
                  ],
                  [
                    63878.9,
                    29286.7
                  ],
                  [
                    63836.8,
                    29212
                  ],
                  [
                    63745.4,
                    29237.2
                  ],
                  [
                    63699,
                    29364
                  ],
                  [
                    63729.6,
                    29419
                  ],
                  [
                    63834.3,
                    29385.9
                  ]
                ],
                "id": 484,
                "chat_link": "[&BOQBAAA=]"
              },
              "485": {
                "name": "Steeleye Span",
                "level": 43,
                "coord": [
                  62529.3,
                  31630.3
                ],
                "bounds": [
                  [
                    62334,
                    31493.3
                  ],
                  [
                    62569.1,
                    31511.8
                  ],
                  [
                    62764.5,
                    31653.4
                  ],
                  [
                    62647.5,
                    31807
                  ],
                  [
                    62331.5,
                    31685.8
                  ],
                  [
                    62334,
                    31493.3
                  ]
                ],
                "id": 485,
                "chat_link": "[&BOUBAAA=]"
              },
              "486": {
                "name": "Deserter Flats",
                "level": 45,
                "coord": [
                  62613.5,
                  30722.1
                ],
                "bounds": [
                  [
                    62439.6,
                    30695.3
                  ],
                  [
                    62452.9,
                    30472.3
                  ],
                  [
                    62598.7,
                    30334.8
                  ],
                  [
                    62811.9,
                    30457.6
                  ],
                  [
                    62958.3,
                    30707.9
                  ],
                  [
                    62839.8,
                    30912.9
                  ],
                  [
                    62726.3,
                    30877.3
                  ],
                  [
                    62641.9,
                    30973.8
                  ],
                  [
                    62351.8,
                    31035.3
                  ],
                  [
                    62313.7,
                    30754.1
                  ],
                  [
                    62439.6,
                    30695.3
                  ]
                ],
                "id": 486,
                "chat_link": "[&BOYBAAA=]"
              },
              "487": {
                "name": "Hazmagic Aggregate",
                "level": 48,
                "coord": [
                  62738.3,
                  30060.6
                ],
                "bounds": [
                  [
                    62811.3,
                    30462.7
                  ],
                  [
                    62929.5,
                    30273.1
                  ],
                  [
                    62928.1,
                    30070
                  ],
                  [
                    62816,
                    29773.8
                  ],
                  [
                    62843.9,
                    29606.6
                  ],
                  [
                    62492,
                    29699.6
                  ],
                  [
                    62573.5,
                    30053.8
                  ],
                  [
                    62658.6,
                    30065.7
                  ],
                  [
                    62730.9,
                    30263
                  ],
                  [
                    62598.8,
                    30337.7
                  ],
                  [
                    62811.3,
                    30462.7
                  ]
                ],
                "id": 487,
                "chat_link": "[&BOcBAAA=]"
              },
              "488": {
                "name": "Foulblain Expanse",
                "level": 43,
                "coord": [
                  62557.5,
                  31301.7
                ],
                "bounds": [
                  [
                    62337.1,
                    31156.7
                  ],
                  [
                    62350.8,
                    31028.3
                  ],
                  [
                    62645.7,
                    30961.6
                  ],
                  [
                    62603.2,
                    31125.8
                  ],
                  [
                    62658.3,
                    31339.5
                  ],
                  [
                    62753.8,
                    31420.5
                  ],
                  [
                    62762.4,
                    31655.3
                  ],
                  [
                    62568.6,
                    31523.9
                  ],
                  [
                    62337.9,
                    31504.2
                  ],
                  [
                    62337.1,
                    31156.7
                  ]
                ],
                "id": 488,
                "chat_link": "[&BOgBAAA=]"
              },
              "489": {
                "name": "Lowland Burns",
                "level": 50,
                "coord": [
                  62333.4,
                  28730.6
                ],
                "bounds": [
                  [
                    62331.1,
                    28939.1
                  ],
                  [
                    62257.1,
                    28819.7
                  ],
                  [
                    62090.8,
                    28826.8
                  ],
                  [
                    61794.4,
                    28687.8
                  ],
                  [
                    61938.5,
                    28177.5
                  ],
                  [
                    62027.6,
                    28190.3
                  ],
                  [
                    62106.3,
                    28274.4
                  ],
                  [
                    62222.5,
                    28337.8
                  ],
                  [
                    62320,
                    28413.6
                  ],
                  [
                    62385.2,
                    28509.2
                  ],
                  [
                    62435.3,
                    28600.1
                  ],
                  [
                    62517.2,
                    28640.4
                  ],
                  [
                    62670,
                    29018.7
                  ],
                  [
                    62922.2,
                    29225.1
                  ],
                  [
                    62890,
                    29333.1
                  ],
                  [
                    62446,
                    29308.9
                  ],
                  [
                    62313.5,
                    29117.5
                  ],
                  [
                    62331.1,
                    28939.1
                  ]
                ],
                "id": 489,
                "chat_link": "[&BOkBAAA=]"
              },
              "490": {
                "name": "Blightwater Basin",
                "level": 42,
                "coord": [
                  62087.1,
                  32282.7
                ],
                "bounds": [
                  [
                    62475.8,
                    32616.7
                  ],
                  [
                    62449.6,
                    32150.3
                  ],
                  [
                    62646.2,
                    31808.5
                  ],
                  [
                    62331.8,
                    31685.8
                  ],
                  [
                    62326.8,
                    31780.5
                  ],
                  [
                    61973.7,
                    31941.7
                  ],
                  [
                    61509.8,
                    32070.4
                  ],
                  [
                    61678.1,
                    32224.7
                  ],
                  [
                    61761.7,
                    32366.7
                  ],
                  [
                    61787.2,
                    32521.6
                  ],
                  [
                    61870.1,
                    32635.4
                  ],
                  [
                    62002.2,
                    32677.4
                  ],
                  [
                    62097.8,
                    32730.4
                  ],
                  [
                    62308.7,
                    32747.6
                  ],
                  [
                    62475.8,
                    32616.7
                  ]
                ],
                "id": 490,
                "chat_link": "[&BOoBAAA=]"
              },
              "491": {
                "name": "Tumok's Last Stand",
                "level": 42,
                "coord": [
                  62708.1,
                  32441.5
                ],
                "bounds": [
                  [
                    62475.4,
                    32613.9
                  ],
                  [
                    62574.8,
                    32661.6
                  ],
                  [
                    62807.9,
                    32713.7
                  ],
                  [
                    62940,
                    32662.1
                  ],
                  [
                    62957.1,
                    32598.9
                  ],
                  [
                    63050.1,
                    32235.4
                  ],
                  [
                    62644.3,
                    31809.7
                  ],
                  [
                    62452.7,
                    32155.4
                  ],
                  [
                    62470.8,
                    32522.3
                  ],
                  [
                    62475.4,
                    32613.9
                  ]
                ],
                "id": 491,
                "chat_link": "[&BOsBAAA=]"
              },
              "492": {
                "name": "Pockmark Roughs",
                "level": 45,
                "coord": [
                  63227.9,
                  31010.7
                ],
                "bounds": [
                  [
                    62841,
                    30913.6
                  ],
                  [
                    62955.5,
                    30712.2
                  ],
                  [
                    63229.3,
                    30638.3
                  ],
                  [
                    63447.8,
                    30736.4
                  ],
                  [
                    63538.4,
                    30885.5
                  ],
                  [
                    63527.2,
                    31093
                  ],
                  [
                    63443.4,
                    31236.1
                  ],
                  [
                    63307.8,
                    31352.4
                  ],
                  [
                    63109.2,
                    31370.7
                  ],
                  [
                    62879.8,
                    31168.8
                  ],
                  [
                    62841,
                    30913.6
                  ]
                ],
                "id": 492,
                "chat_link": "[&BOwBAAA=]"
              },
              "493": {
                "name": "Crater Rim",
                "level": 42,
                "coord": [
                  62868.6,
                  31245.7
                ],
                "bounds": [
                  [
                    62751.9,
                    31427.3
                  ],
                  [
                    62658.5,
                    31342.8
                  ],
                  [
                    62601,
                    31130.2
                  ],
                  [
                    62636.8,
                    30977.7
                  ],
                  [
                    62730.2,
                    30877.8
                  ],
                  [
                    62840.6,
                    30911.7
                  ],
                  [
                    62877.2,
                    31164.1
                  ],
                  [
                    63108.9,
                    31367.5
                  ],
                  [
                    63307.8,
                    31349.7
                  ],
                  [
                    63280.4,
                    31498.4
                  ],
                  [
                    62760.8,
                    31655
                  ],
                  [
                    62751.9,
                    31427.3
                  ]
                ],
                "id": 493,
                "chat_link": "[&BO0BAAA=]"
              },
              "494": {
                "name": "Behem Gauntlet",
                "level": 42,
                "coord": [
                  63694.3,
                  31526.8
                ],
                "bounds": [
                  [
                    63271.2,
                    31726
                  ],
                  [
                    63385.2,
                    31922
                  ],
                  [
                    63651.7,
                    31679.6
                  ],
                  [
                    63924.3,
                    31814.5
                  ],
                  [
                    64038.7,
                    31803.6
                  ],
                  [
                    64094,
                    31571.6
                  ],
                  [
                    64085.1,
                    31319.6
                  ],
                  [
                    63942.8,
                    31304.5
                  ],
                  [
                    63873.8,
                    31387.6
                  ],
                  [
                    63782,
                    31414.4
                  ],
                  [
                    63740.9,
                    31473.9
                  ],
                  [
                    63595.5,
                    31417.7
                  ],
                  [
                    63441.6,
                    31227.4
                  ],
                  [
                    63311.4,
                    31343.3
                  ],
                  [
                    63276.7,
                    31496.2
                  ],
                  [
                    63271.2,
                    31726
                  ]
                ],
                "id": 494,
                "chat_link": "[&BO4BAAA=]"
              },
              "495": {
                "name": "Unbroken Expanse",
                "level": 45,
                "coord": [
                  63211.9,
                  30390.3
                ],
                "bounds": [
                  [
                    63228.8,
                    30645.9
                  ],
                  [
                    63447.9,
                    30738.9
                  ],
                  [
                    63594.9,
                    30605.9
                  ],
                  [
                    63546,
                    30298.3
                  ],
                  [
                    63595.9,
                    30138.5
                  ],
                  [
                    63083,
                    29956.2
                  ],
                  [
                    62925.8,
                    30070.6
                  ],
                  [
                    62926.9,
                    30273.4
                  ],
                  [
                    62810.4,
                    30458.3
                  ],
                  [
                    62959.4,
                    30717.1
                  ],
                  [
                    63228.8,
                    30645.9
                  ]
                ],
                "id": 495,
                "chat_link": "[&BO8BAAA=]"
              },
              "496": {
                "name": "Gastor Gullet",
                "level": 45,
                "coord": [
                  63716,
                  31092.8
                ],
                "bounds": [
                  [
                    63527.8,
                    31091.7
                  ],
                  [
                    63538.8,
                    30886.2
                  ],
                  [
                    63447.1,
                    30737.8
                  ],
                  [
                    63593.5,
                    30606.3
                  ],
                  [
                    63767.3,
                    30670.9
                  ],
                  [
                    63870.3,
                    30901.8
                  ],
                  [
                    63918.4,
                    31019.5
                  ],
                  [
                    63979.9,
                    31145
                  ],
                  [
                    63944.9,
                    31306.2
                  ],
                  [
                    63875,
                    31387.9
                  ],
                  [
                    63782.4,
                    31416.7
                  ],
                  [
                    63740.2,
                    31476.7
                  ],
                  [
                    63594,
                    31418.9
                  ],
                  [
                    63445,
                    31233.4
                  ],
                  [
                    63527.8,
                    31091.7
                  ]
                ],
                "id": 496,
                "chat_link": "[&BPABAAA=]"
              },
              "497": {
                "name": "Degun Shun",
                "level": 45,
                "coord": [
                  63692.8,
                  30247.4
                ],
                "bounds": [
                  [
                    63695,
                    30391.3
                  ],
                  [
                    63851.2,
                    30298.3
                  ],
                  [
                    63781.1,
                    30177
                  ],
                  [
                    63698.5,
                    30183.2
                  ],
                  [
                    63586.8,
                    30135.9
                  ],
                  [
                    63544.1,
                    30298.9
                  ],
                  [
                    63695,
                    30391.3
                  ]
                ],
                "id": 497,
                "chat_link": "[&BPEBAAA=]"
              },
              "498": {
                "name": "Agrak Kraal",
                "level": 45,
                "coord": [
                  63888,
                  30702.1
                ],
                "bounds": [
                  [
                    63855.5,
                    30566.8
                  ],
                  [
                    63937.4,
                    30576.7
                  ],
                  [
                    63946.3,
                    30708
                  ],
                  [
                    63970,
                    30827.9
                  ],
                  [
                    63847.8,
                    30864
                  ],
                  [
                    63771.2,
                    30669.4
                  ],
                  [
                    63855.5,
                    30566.8
                  ]
                ],
                "id": 498,
                "chat_link": "[&BPIBAAA=]"
              },
              "499": {
                "name": "Twin Sisters Crossing",
                "level": 42,
                "coord": [
                  63862.8,
                  32402.3
                ],
                "bounds": [
                  [
                    63927,
                    32682.5
                  ],
                  [
                    63797.7,
                    32729.8
                  ],
                  [
                    63678.9,
                    32732
                  ],
                  [
                    63567.1,
                    32672.7
                  ],
                  [
                    63547.2,
                    32581.1
                  ],
                  [
                    63612.6,
                    32474.9
                  ],
                  [
                    63559.8,
                    32276.8
                  ],
                  [
                    63645.6,
                    32136.1
                  ],
                  [
                    63901.9,
                    31992.3
                  ],
                  [
                    63945,
                    32022
                  ],
                  [
                    63957.7,
                    32129.7
                  ],
                  [
                    64026.3,
                    32249.1
                  ],
                  [
                    64121.1,
                    32326.2
                  ],
                  [
                    64202.4,
                    32366.9
                  ],
                  [
                    64241,
                    32436.5
                  ],
                  [
                    64074.1,
                    32628.4
                  ],
                  [
                    63927,
                    32682.5
                  ]
                ],
                "id": 499,
                "chat_link": "[&BPMBAAA=]"
              },
              "500": {
                "name": "Splinter Hills",
                "level": 42,
                "coord": [
                  63436.8,
                  32369.6
                ],
                "bounds": [
                  [
                    63036.6,
                    32228.9
                  ],
                  [
                    63648.4,
                    31681.5
                  ],
                  [
                    63923.3,
                    31813.4
                  ],
                  [
                    63906.8,
                    31993.9
                  ],
                  [
                    63645.5,
                    32137.2
                  ],
                  [
                    63559.9,
                    32277.8
                  ],
                  [
                    63612.5,
                    32475.6
                  ],
                  [
                    63548.9,
                    32581.5
                  ],
                  [
                    63569.1,
                    32673.9
                  ],
                  [
                    63427,
                    32726.4
                  ],
                  [
                    63250.9,
                    32645.8
                  ],
                  [
                    63095.1,
                    32692.7
                  ],
                  [
                    62937.4,
                    32653.1
                  ],
                  [
                    62953.7,
                    32592.1
                  ],
                  [
                    63036.6,
                    32228.9
                  ]
                ],
                "id": 500,
                "chat_link": "[&BPQBAAA=]"
              },
              "501": {
                "name": "Soot Road",
                "level": 42,
                "coord": [
                  63065.7,
                  31805.3
                ],
                "bounds": [
                  [
                    62763.1,
                    31650.1
                  ],
                  [
                    63278.9,
                    31499.1
                  ],
                  [
                    63273,
                    31723.4
                  ],
                  [
                    63386.3,
                    31922.3
                  ],
                  [
                    63044.8,
                    32226.1
                  ],
                  [
                    62647.9,
                    31810.5
                  ],
                  [
                    62763.1,
                    31650.1
                  ]
                ],
                "id": 501,
                "chat_link": "[&BPUBAAA=]"
              },
              "502": {
                "name": "Tongue Rock",
                "level": 45,
                "coord": [
                  62007.1,
                  30517.7
                ],
                "bounds": [
                  [
                    62232.6,
                    30493.1
                  ],
                  [
                    62156,
                    30619.2
                  ],
                  [
                    61988.4,
                    30604.4
                  ],
                  [
                    61818.8,
                    30755.6
                  ],
                  [
                    61834,
                    30623.4
                  ],
                  [
                    61898.2,
                    30479.3
                  ],
                  [
                    61876.1,
                    30403.2
                  ],
                  [
                    62014.4,
                    30456.3
                  ],
                  [
                    62099.9,
                    30361.9
                  ],
                  [
                    62152.6,
                    30381
                  ],
                  [
                    62232.6,
                    30493.1
                  ]
                ],
                "id": 502,
                "chat_link": "[&BPYBAAA=]"
              },
              "503": {
                "name": "Terra Combusta",
                "level": 49,
                "coord": [
                  62967.3,
                  28959.5
                ],
                "bounds": [
                  [
                    62914.2,
                    29238.7
                  ],
                  [
                    62669.5,
                    29019
                  ],
                  [
                    62515.1,
                    28641.8
                  ],
                  [
                    62776.6,
                    28568.7
                  ],
                  [
                    63054.8,
                    28653
                  ],
                  [
                    63103.2,
                    28738.1
                  ],
                  [
                    63387,
                    28803.3
                  ],
                  [
                    63161.3,
                    29217.8
                  ],
                  [
                    63199,
                    29380.4
                  ],
                  [
                    62891.9,
                    29334.6
                  ],
                  [
                    62914.2,
                    29238.7
                  ]
                ],
                "id": 503,
                "chat_link": "[&BPcBAAA=]"
              },
              "504": {
                "name": "Terra Carorunda",
                "level": 49,
                "coord": [
                  63646.7,
                  29033.7
                ],
                "bounds": [
                  [
                    63201.7,
                    29381.4
                  ],
                  [
                    63409.6,
                    29507.8
                  ],
                  [
                    63750.9,
                    29457.3
                  ],
                  [
                    63700,
                    29362.1
                  ],
                  [
                    63748.1,
                    29237
                  ],
                  [
                    63838.9,
                    29214.4
                  ],
                  [
                    63881,
                    29161.8
                  ],
                  [
                    63872.6,
                    28991.6
                  ],
                  [
                    63962.4,
                    28839.9
                  ],
                  [
                    63943.6,
                    28602.4
                  ],
                  [
                    63754.8,
                    28591
                  ],
                  [
                    63640.6,
                    28555.1
                  ],
                  [
                    63447.2,
                    28584
                  ],
                  [
                    63389.2,
                    28801
                  ],
                  [
                    63160.3,
                    29218.5
                  ],
                  [
                    63201.7,
                    29381.4
                  ]
                ],
                "id": 504,
                "chat_link": "[&BPgBAAA=]"
              },
              "505": {
                "name": "Shattered Palisades",
                "level": 49,
                "coord": [
                  63287.8,
                  29508.3
                ],
                "bounds": [
                  [
                    63449.3,
                    29664.6
                  ],
                  [
                    63735.3,
                    29560.1
                  ],
                  [
                    63750.7,
                    29455.5
                  ],
                  [
                    63408.7,
                    29506
                  ],
                  [
                    63200.8,
                    29377.6
                  ],
                  [
                    62817.8,
                    29319.5
                  ],
                  [
                    62844.4,
                    29604.2
                  ],
                  [
                    63095.2,
                    29579.1
                  ],
                  [
                    63449.3,
                    29664.6
                  ]
                ],
                "id": 505,
                "chat_link": "[&BPkBAAA=]"
              },
              "506": {
                "name": "Monument Grounds",
                "level": 50,
                "coord": [
                  62337.5,
                  29448.3
                ],
                "bounds": [
                  [
                    62494,
                    29697.9
                  ],
                  [
                    62842.3,
                    29604.2
                  ],
                  [
                    62815.3,
                    29323.4
                  ],
                  [
                    62445,
                    29310.7
                  ],
                  [
                    62394.7,
                    29405.1
                  ],
                  [
                    62030.1,
                    29409.7
                  ],
                  [
                    61826.2,
                    29318.8
                  ],
                  [
                    61852.4,
                    29516.2
                  ],
                  [
                    62494,
                    29697.9
                  ]
                ],
                "id": 506,
                "chat_link": "[&BPoBAAA=]"
              },
              "507": {
                "name": "Heretic Plain",
                "level": 47,
                "coord": [
                  63435.8,
                  29829
                ],
                "bounds": [
                  [
                    62818.3,
                    29770.1
                  ],
                  [
                    62841.7,
                    29605.5
                  ],
                  [
                    63095.3,
                    29579.2
                  ],
                  [
                    63445.5,
                    29663.5
                  ],
                  [
                    63733,
                    29560.5
                  ],
                  [
                    63873.3,
                    29555.4
                  ],
                  [
                    63930,
                    29805.3
                  ],
                  [
                    63930.2,
                    30021.5
                  ],
                  [
                    63856.9,
                    30170.4
                  ],
                  [
                    63696.5,
                    30184.3
                  ],
                  [
                    63082.1,
                    29961.7
                  ],
                  [
                    62926.8,
                    30071.2
                  ],
                  [
                    62818.3,
                    29770.1
                  ]
                ],
                "id": 507,
                "chat_link": "[&BPsBAAA=]"
              },
              "508": {
                "name": "Kindling Bridge",
                "level": 50,
                "coord": [
                  62106.6,
                  29094
                ],
                "bounds": [
                  [
                    61831.5,
                    29315.7
                  ],
                  [
                    61875,
                    29191.1
                  ],
                  [
                    61781.9,
                    29002.1
                  ],
                  [
                    61799.7,
                    28689.3
                  ],
                  [
                    62091.7,
                    28823.8
                  ],
                  [
                    62261.8,
                    28824.8
                  ],
                  [
                    62335.3,
                    28942.4
                  ],
                  [
                    62313.2,
                    29121.6
                  ],
                  [
                    62450.6,
                    29310
                  ],
                  [
                    62398.5,
                    29405.6
                  ],
                  [
                    62033.3,
                    29407.7
                  ],
                  [
                    61831.5,
                    29315.7
                  ]
                ],
                "id": 508,
                "chat_link": "[&BPwBAAA=]"
              },
              "509": {
                "name": "Dragonwatch",
                "level": 43,
                "coord": [
                  62071,
                  31427.8
                ],
                "bounds": [
                  [
                    62326.5,
                    31774.7
                  ],
                  [
                    62338.5,
                    31506.3
                  ],
                  [
                    62339,
                    31156.7
                  ],
                  [
                    62107.7,
                    31209.2
                  ],
                  [
                    61953.1,
                    31186
                  ],
                  [
                    61952,
                    31215.8
                  ],
                  [
                    61944.9,
                    31281.9
                  ],
                  [
                    61954.3,
                    31359.3
                  ],
                  [
                    61819.8,
                    31647.2
                  ],
                  [
                    61974.8,
                    31940.8
                  ],
                  [
                    62326.5,
                    31774.7
                  ]
                ],
                "id": 509,
                "chat_link": "[&BP0BAAA=]"
              },
              "510": {
                "name": "Ratcatcher Knoll",
                "level": 45,
                "coord": [
                  62202.2,
                  30748
                ],
                "bounds": [
                  [
                    62107.6,
                    31211
                  ],
                  [
                    61958.7,
                    31186.4
                  ],
                  [
                    61818.8,
                    30757.4
                  ],
                  [
                    61993.7,
                    30604.6
                  ],
                  [
                    62153.8,
                    30620.1
                  ],
                  [
                    62231.2,
                    30491.7
                  ],
                  [
                    62150.8,
                    30381.6
                  ],
                  [
                    62310.9,
                    30344.7
                  ],
                  [
                    62456.3,
                    30474.6
                  ],
                  [
                    62442.6,
                    30698.2
                  ],
                  [
                    62314.6,
                    30758.1
                  ],
                  [
                    62354.1,
                    31035.8
                  ],
                  [
                    62334.9,
                    31159.4
                  ],
                  [
                    62107.6,
                    31211
                  ]
                ],
                "id": 510,
                "chat_link": "[&BP4BAAA=]"
              },
              "511": {
                "name": "Relliatus Canyon",
                "level": 47,
                "coord": [
                  62217.2,
                  30139.4
                ],
                "bounds": [
                  [
                    62010,
                    30457.9
                  ],
                  [
                    62100.9,
                    30361.2
                  ],
                  [
                    62151.1,
                    30381
                  ],
                  [
                    62311,
                    30347.8
                  ],
                  [
                    62455,
                    30476.1
                  ],
                  [
                    62600.2,
                    30334.8
                  ],
                  [
                    62464.6,
                    30156.9
                  ],
                  [
                    62476.8,
                    30058.2
                  ],
                  [
                    62573.8,
                    30052.6
                  ],
                  [
                    62494.1,
                    29698.1
                  ],
                  [
                    61853.7,
                    29509.6
                  ],
                  [
                    61831.6,
                    29761.8
                  ],
                  [
                    61837.2,
                    29956.5
                  ],
                  [
                    61880.5,
                    30399.3
                  ],
                  [
                    62010,
                    30457.9
                  ]
                ],
                "id": 511,
                "chat_link": "[&BP8BAAA=]"
              },
              "758": {
                "name": "InGenium Research Facility",
                "level": 48,
                "coord": [
                  62584.6,
                  30155.2
                ],
                "bounds": [
                  [
                    62463.8,
                    30156.9
                  ],
                  [
                    62476.9,
                    30056.9
                  ],
                  [
                    62577.4,
                    30050.8
                  ],
                  [
                    62660.6,
                    30065.2
                  ],
                  [
                    62729.8,
                    30264
                  ],
                  [
                    62599.3,
                    30337.5
                  ],
                  [
                    62463.8,
                    30156.9
                  ]
                ],
                "id": 758,
                "chat_link": "[&BPYCAAA=]"
              }
            },
            "adventures": [],
            "id": 1074,
            "mastery_points": []
          },
          "1080": {
            "name": "Branded for Termination",
            "min_level": 30,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              62976,
              34176
            ],
            "map_rect": [
              [
                -36864,
                -36864
              ],
              [
                36864,
                36864
              ]
            ],
            "continent_rect": [
              [
                61440,
                32640
              ],
              [
                64512,
                35712
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "365": {
                "name": "Last Stand Shelter",
                "level": 31,
                "coord": [
                  61657.9,
                  35015.4
                ],
                "bounds": [
                  [
                    61456.9,
                    34889.1
                  ],
                  [
                    61607.9,
                    34741.1
                  ],
                  [
                    61812.8,
                    34931.5
                  ],
                  [
                    61785.2,
                    35009.7
                  ],
                  [
                    61709.3,
                    35063.5
                  ],
                  [
                    61698.5,
                    35205.7
                  ],
                  [
                    61534.8,
                    35267.4
                  ],
                  [
                    61456.9,
                    34889.1
                  ]
                ],
                "id": 365,
                "chat_link": "[&BG0BAAA=]"
              },
              "366": {
                "name": "Blackwing Excavation",
                "level": 31,
                "coord": [
                  62641.1,
                  35403.7
                ],
                "bounds": [
                  [
                    62557.5,
                    35091.2
                  ],
                  [
                    62771.9,
                    35156.6
                  ],
                  [
                    62878.7,
                    35543.5
                  ],
                  [
                    62746.7,
                    35649.8
                  ],
                  [
                    62451.9,
                    35654.8
                  ],
                  [
                    62440,
                    35326.3
                  ],
                  [
                    62557.5,
                    35091.2
                  ]
                ],
                "id": 366,
                "chat_link": "[&BG4BAAA=]"
              },
              "367": {
                "name": "Stronghold of Ebonhawke",
                "level": 31,
                "coord": [
                  62008.8,
                  35138
                ],
                "bounds": [
                  [
                    61812.5,
                    34931.7
                  ],
                  [
                    61608.6,
                    34739.7
                  ],
                  [
                    61974.8,
                    34550.6
                  ],
                  [
                    62116.3,
                    34621.3
                  ],
                  [
                    62342,
                    34818.7
                  ],
                  [
                    62699,
                    34688.4
                  ],
                  [
                    62557.7,
                    35091.4
                  ],
                  [
                    62440.8,
                    35324.7
                  ],
                  [
                    62450.3,
                    35654.7
                  ],
                  [
                    62165.5,
                    35625.2
                  ],
                  [
                    61939.4,
                    35533.8
                  ],
                  [
                    61770.3,
                    35659.5
                  ],
                  [
                    61542.8,
                    35558.4
                  ],
                  [
                    61534.8,
                    35269.1
                  ],
                  [
                    61699,
                    35206.4
                  ],
                  [
                    61709.8,
                    35064.6
                  ],
                  [
                    61785.5,
                    35008.6
                  ],
                  [
                    61812.5,
                    34931.7
                  ]
                ],
                "id": 367,
                "chat_link": "[&BG8BAAA=]"
              },
              "368": {
                "name": "Grimm Hills",
                "level": 34,
                "coord": [
                  62913.6,
                  34678.1
                ],
                "bounds": [
                  [
                    62775,
                    35155.6
                  ],
                  [
                    63095.2,
                    34880.6
                  ],
                  [
                    63095,
                    34671.8
                  ],
                  [
                    63212.3,
                    34293.8
                  ],
                  [
                    63014.9,
                    34325.3
                  ],
                  [
                    62889.8,
                    34422.3
                  ],
                  [
                    62883.8,
                    34575
                  ],
                  [
                    62698.5,
                    34687.4
                  ],
                  [
                    62558.2,
                    35091.2
                  ],
                  [
                    62775,
                    35155.6
                  ]
                ],
                "id": 368,
                "chat_link": "[&BHABAAA=]"
              },
              "369": {
                "name": "The Ogre Road",
                "level": 33,
                "coord": [
                  63775.2,
                  34960.3
                ],
                "bounds": [
                  [
                    63818,
                    34775.5
                  ],
                  [
                    64049.9,
                    34874.6
                  ],
                  [
                    63983.2,
                    35117.8
                  ],
                  [
                    63650.4,
                    35343.8
                  ],
                  [
                    63469.1,
                    34973.7
                  ],
                  [
                    63680.8,
                    34676.6
                  ],
                  [
                    63818,
                    34775.5
                  ]
                ],
                "id": 369,
                "chat_link": "[&BHEBAAA=]"
              },
              "370": {
                "name": "Wildlin Narrows",
                "level": 34,
                "coord": [
                  64113.6,
                  35332.1
                ],
                "bounds": [
                  [
                    63981.4,
                    35119
                  ],
                  [
                    64047.3,
                    34879.9
                  ],
                  [
                    64446.4,
                    34880.2
                  ],
                  [
                    64454.7,
                    35016.9
                  ],
                  [
                    64482.5,
                    35162.6
                  ],
                  [
                    64437,
                    35419.7
                  ],
                  [
                    64379.4,
                    35572.2
                  ],
                  [
                    64266.7,
                    35658.7
                  ],
                  [
                    63887.2,
                    35684.1
                  ],
                  [
                    63726.7,
                    35630.3
                  ],
                  [
                    63602.3,
                    35623
                  ],
                  [
                    63651.7,
                    35338
                  ],
                  [
                    63981.4,
                    35119
                  ]
                ],
                "id": 370,
                "chat_link": "[&BHIBAAA=]"
              },
              "371": {
                "name": "Mithric Cliffs",
                "level": 35,
                "coord": [
                  64140.7,
                  34560.1
                ],
                "bounds": [
                  [
                    63873.1,
                    34199.8
                  ],
                  [
                    64439.5,
                    34200.8
                  ],
                  [
                    64522.9,
                    34271.7
                  ],
                  [
                    64421.7,
                    34550.9
                  ],
                  [
                    64486.2,
                    34796.1
                  ],
                  [
                    64446.4,
                    34880
                  ],
                  [
                    64049.8,
                    34881.8
                  ],
                  [
                    63817.7,
                    34776.3
                  ],
                  [
                    63679.6,
                    34676
                  ],
                  [
                    63670,
                    34367.5
                  ],
                  [
                    63873.1,
                    34199.8
                  ]
                ],
                "id": 371,
                "chat_link": "[&BHMBAAA=]"
              },
              "372": {
                "name": "Hunter's Gorge",
                "level": 35,
                "coord": [
                  63341.8,
                  34640.5
                ],
                "bounds": [
                  [
                    63669.7,
                    34367.2
                  ],
                  [
                    63679.1,
                    34676
                  ],
                  [
                    63470.3,
                    34973.3
                  ],
                  [
                    63163.9,
                    34985.8
                  ],
                  [
                    63094,
                    34882.4
                  ],
                  [
                    63095.7,
                    34672.5
                  ],
                  [
                    63212.8,
                    34294.4
                  ],
                  [
                    63348.8,
                    34272.4
                  ],
                  [
                    63669.7,
                    34367.2
                  ]
                ],
                "id": 372,
                "chat_link": "[&BHQBAAA=]"
              },
              "373": {
                "name": "The Siege Plains",
                "level": 33,
                "coord": [
                  62661.4,
                  34431.1
                ],
                "bounds": [
                  [
                    62342.5,
                    34820
                  ],
                  [
                    62698.4,
                    34688
                  ],
                  [
                    62884,
                    34573.7
                  ],
                  [
                    62895.1,
                    34415.3
                  ],
                  [
                    63015.8,
                    34325.2
                  ],
                  [
                    62807.6,
                    34052
                  ],
                  [
                    62532,
                    33954.3
                  ],
                  [
                    62115.9,
                    34620.7
                  ],
                  [
                    62342.5,
                    34820
                  ]
                ],
                "id": 373,
                "chat_link": "[&BHUBAAA=]"
              },
              "374": {
                "name": "Sniper's Woods",
                "level": 35,
                "coord": [
                  62135,
                  34190.4
                ],
                "bounds": [
                  [
                    61976.5,
                    34544.7
                  ],
                  [
                    62116.8,
                    34620
                  ],
                  [
                    62531.9,
                    33954
                  ],
                  [
                    62317,
                    33906.1
                  ],
                  [
                    62102.3,
                    34036.9
                  ],
                  [
                    61765.8,
                    34080.3
                  ],
                  [
                    61976.5,
                    34544.7
                  ]
                ],
                "id": 374,
                "chat_link": "[&BHYBAAA=]"
              },
              "375": {
                "name": "Bento Canyon",
                "level": 34,
                "coord": [
                  61654.1,
                  34397.7
                ],
                "bounds": [
                  [
                    61608.5,
                    34740
                  ],
                  [
                    61977.2,
                    34544.8
                  ],
                  [
                    61766,
                    34081.3
                  ],
                  [
                    61522.8,
                    34074.4
                  ],
                  [
                    61571.5,
                    34348
                  ],
                  [
                    61478.8,
                    34597.5
                  ],
                  [
                    61608.5,
                    34740
                  ]
                ],
                "id": 375,
                "chat_link": "[&BHcBAAA=]"
              },
              "376": {
                "name": "Dragonrot Domains",
                "level": 38,
                "coord": [
                  61711,
                  33852.5
                ],
                "bounds": [
                  [
                    61522.5,
                    34074.1
                  ],
                  [
                    61765.8,
                    34080.1
                  ],
                  [
                    62103,
                    34037.3
                  ],
                  [
                    61890.2,
                    33602.7
                  ],
                  [
                    61522.8,
                    33605.5
                  ],
                  [
                    61461.9,
                    33715.2
                  ],
                  [
                    61522.5,
                    34074.1
                  ]
                ],
                "id": 376,
                "chat_link": "[&BHgBAAA=]"
              },
              "377": {
                "name": "Varim's Run",
                "level": 40,
                "coord": [
                  61676.3,
                  33049.4
                ],
                "bounds": [
                  [
                    61684.6,
                    32846.2
                  ],
                  [
                    61627.8,
                    32689
                  ],
                  [
                    61783.8,
                    32640.9
                  ],
                  [
                    62037,
                    32658.6
                  ],
                  [
                    61927,
                    32793.8
                  ],
                  [
                    61888.9,
                    33603.3
                  ],
                  [
                    61521.8,
                    33606.4
                  ],
                  [
                    61568.4,
                    33387.3
                  ],
                  [
                    61411.7,
                    33325.3
                  ],
                  [
                    61408,
                    33080.2
                  ],
                  [
                    61580,
                    32912.1
                  ],
                  [
                    61684.6,
                    32846.2
                  ]
                ],
                "id": 377,
                "chat_link": "[&BHkBAAA=]"
              },
              "378": {
                "name": "Tenaebron Lake",
                "level": 39,
                "coord": [
                  62214.2,
                  33182.2
                ],
                "bounds": [
                  [
                    61884.8,
                    33603.9
                  ],
                  [
                    62102.9,
                    34046.4
                  ],
                  [
                    62317.7,
                    33899.6
                  ],
                  [
                    62262.7,
                    33569.9
                  ],
                  [
                    62495.3,
                    33233.3
                  ],
                  [
                    62442.7,
                    32764
                  ],
                  [
                    62420.4,
                    32651.8
                  ],
                  [
                    62238,
                    32617.8
                  ],
                  [
                    62046.1,
                    32647.3
                  ],
                  [
                    61931.3,
                    32787.9
                  ],
                  [
                    61884.8,
                    33603.9
                  ]
                ],
                "id": 378,
                "chat_link": "[&BHoBAAA=]"
              },
              "379": {
                "name": "Vulture's Sweep",
                "level": 37,
                "coord": [
                  62545.4,
                  33687.2
                ],
                "bounds": [
                  [
                    62315.8,
                    33906
                  ],
                  [
                    62530.4,
                    33952.9
                  ],
                  [
                    62805.8,
                    34052.8
                  ],
                  [
                    62867.3,
                    33390.9
                  ],
                  [
                    62492.3,
                    33242.2
                  ],
                  [
                    62260.7,
                    33578.4
                  ],
                  [
                    62315.8,
                    33906
                  ]
                ],
                "id": 379,
                "chat_link": "[&BHsBAAA=]"
              },
              "380": {
                "name": "Warrior's Crown",
                "level": 36,
                "coord": [
                  63286.9,
                  33885.3
                ],
                "bounds": [
                  [
                    62867.6,
                    33388
                  ],
                  [
                    63792.5,
                    33512.5
                  ],
                  [
                    63709.9,
                    33749.2
                  ],
                  [
                    63468.1,
                    33900.9
                  ],
                  [
                    63349.3,
                    34273.4
                  ],
                  [
                    63014.9,
                    34324.5
                  ],
                  [
                    62805.9,
                    34048.8
                  ],
                  [
                    62867.6,
                    33388
                  ]
                ],
                "id": 380,
                "chat_link": "[&BHwBAAA=]"
              },
              "381": {
                "name": "Belag Crossroads",
                "level": 35,
                "coord": [
                  63662.8,
                  34062.1
                ],
                "bounds": [
                  [
                    63348.9,
                    34273.4
                  ],
                  [
                    63669.7,
                    34368.1
                  ],
                  [
                    63873.3,
                    34199.3
                  ],
                  [
                    63905.5,
                    33881.5
                  ],
                  [
                    63711,
                    33749.6
                  ],
                  [
                    63468.4,
                    33900.9
                  ],
                  [
                    63348.9,
                    34273.4
                  ]
                ],
                "id": 381,
                "chat_link": "[&BH0BAAA=]"
              },
              "382": {
                "name": "Flameroot Caverns",
                "level": 36,
                "coord": [
                  64189.7,
                  33999.4
                ],
                "bounds": [
                  [
                    63872.4,
                    34199.8
                  ],
                  [
                    64439.4,
                    34201.8
                  ],
                  [
                    64395.5,
                    34050.3
                  ],
                  [
                    64466,
                    33931.9
                  ],
                  [
                    64059.3,
                    33731.8
                  ],
                  [
                    63905.5,
                    33880.9
                  ],
                  [
                    63872.4,
                    34199.8
                  ]
                ],
                "id": 382,
                "chat_link": "[&BH4BAAA=]"
              },
              "383": {
                "name": "Highden Caves",
                "level": 37,
                "coord": [
                  64321.2,
                  33581.6
                ],
                "bounds": [
                  [
                    64058.1,
                    33737.1
                  ],
                  [
                    64465.7,
                    33931.5
                  ],
                  [
                    64495.3,
                    33748.5
                  ],
                  [
                    64427.9,
                    33511.7
                  ],
                  [
                    64421.5,
                    33370.7
                  ],
                  [
                    64304.1,
                    33239.5
                  ],
                  [
                    64075.8,
                    33532.5
                  ],
                  [
                    64058.1,
                    33737.1
                  ]
                ],
                "id": 383,
                "chat_link": "[&BH8BAAA=]"
              },
              "384": {
                "name": "Axedrag Cut",
                "level": 37,
                "coord": [
                  63990.9,
                  33565.5
                ],
                "bounds": [
                  [
                    63881.1,
                    33256.4
                  ],
                  [
                    64304,
                    33239.1
                  ],
                  [
                    64083.4,
                    33532.1
                  ],
                  [
                    64061.1,
                    33735.1
                  ],
                  [
                    63905.5,
                    33881.2
                  ],
                  [
                    63710.1,
                    33748.8
                  ],
                  [
                    63881.1,
                    33256.4
                  ]
                ],
                "id": 384,
                "chat_link": "[&BIABAAA=]"
              },
              "385": {
                "name": "Tanglerot Hills",
                "level": 38,
                "coord": [
                  64171.4,
                  32762.6
                ],
                "bounds": [
                  [
                    63983.3,
                    32611.9
                  ],
                  [
                    63951.1,
                    32609.5
                  ],
                  [
                    64029.3,
                    32351.6
                  ],
                  [
                    64129.6,
                    32438.2
                  ],
                  [
                    64262.5,
                    32504.9
                  ],
                  [
                    64348,
                    32526.6
                  ],
                  [
                    64495,
                    32743.9
                  ],
                  [
                    64478.6,
                    33115.1
                  ],
                  [
                    64304,
                    33238.5
                  ],
                  [
                    63880,
                    33257.4
                  ],
                  [
                    64024.1,
                    32991.5
                  ],
                  [
                    63983.3,
                    32611.9
                  ]
                ],
                "id": 385,
                "chat_link": "[&BIEBAAA=]"
              },
              "386": {
                "name": "Halkor Meadows",
                "level": 38,
                "coord": [
                  63745.8,
                  32858
                ],
                "bounds": [
                  [
                    63566.3,
                    33004.5
                  ],
                  [
                    63855.8,
                    33329.6
                  ],
                  [
                    63879.9,
                    33259.8
                  ],
                  [
                    64024.2,
                    32991.6
                  ],
                  [
                    64008,
                    32735
                  ],
                  [
                    63986.5,
                    32610.7
                  ],
                  [
                    63759.8,
                    32579.6
                  ],
                  [
                    63522.4,
                    32646.3
                  ],
                  [
                    63394.6,
                    32629.6
                  ],
                  [
                    63460.5,
                    32793.5
                  ],
                  [
                    63566.3,
                    33004.5
                  ]
                ],
                "id": 386,
                "chat_link": "[&BIIBAAA=]"
              },
              "387": {
                "name": "Thunderbreak Hills",
                "level": 38,
                "coord": [
                  62924.8,
                  32849.6
                ],
                "bounds": [
                  [
                    63401.1,
                    32628
                  ],
                  [
                    63567,
                    33004.2
                  ],
                  [
                    63218.8,
                    33031.5
                  ],
                  [
                    62867.4,
                    33390
                  ],
                  [
                    62493,
                    33242.9
                  ],
                  [
                    62440,
                    32773.5
                  ],
                  [
                    62420.6,
                    32649
                  ],
                  [
                    62745,
                    32572
                  ],
                  [
                    62954.7,
                    32648.8
                  ],
                  [
                    63140.4,
                    32556.1
                  ],
                  [
                    63401.1,
                    32628
                  ]
                ],
                "id": 387,
                "chat_link": "[&BIMBAAA=]"
              },
              "388": {
                "name": "Hautclaire Vale",
                "level": 31,
                "coord": [
                  63239.6,
                  35319.1
                ],
                "bounds": [
                  [
                    63094.3,
                    34879.9
                  ],
                  [
                    63162.7,
                    34986.4
                  ],
                  [
                    63470.2,
                    34971.3
                  ],
                  [
                    63650.7,
                    35342.5
                  ],
                  [
                    63603.5,
                    35626.5
                  ],
                  [
                    63482.8,
                    35538.9
                  ],
                  [
                    63249.2,
                    35599.6
                  ],
                  [
                    63033.2,
                    35546.5
                  ],
                  [
                    62877.4,
                    35543.2
                  ],
                  [
                    62772.5,
                    35155.8
                  ],
                  [
                    63094.3,
                    34879.9
                  ]
                ],
                "id": 388,
                "chat_link": "[&BIQBAAA=]"
              },
              "389": {
                "name": "Gillfarn Plains",
                "level": 38,
                "coord": [
                  63459.3,
                  33253.3
                ],
                "bounds": [
                  [
                    62864.8,
                    33390.4
                  ],
                  [
                    63792.2,
                    33514.1
                  ],
                  [
                    63855.6,
                    33329
                  ],
                  [
                    63566.4,
                    33004.3
                  ],
                  [
                    63217.5,
                    33028.6
                  ],
                  [
                    62864.8,
                    33390.4
                  ]
                ],
                "id": 389,
                "chat_link": "[&BIUBAAA=]"
              },
              "877": {
                "name": "Secluded Glen",
                "level": 40,
                "coord": [
                  61571.1,
                  32795.5
                ],
                "bounds": [
                  [
                    61579.8,
                    32911.9
                  ],
                  [
                    61685,
                    32846.5
                  ],
                  [
                    61634.9,
                    32697
                  ],
                  [
                    61505.3,
                    32679.9
                  ],
                  [
                    61450.4,
                    32842.2
                  ],
                  [
                    61579.8,
                    32911.9
                  ]
                ],
                "id": 877,
                "chat_link": "[&BG0DAAA=]"
              }
            },
            "adventures": [],
            "id": 1080,
            "mastery_points": []
          },
          "1081": {
            "name": "Langmar Estate",
            "min_level": 1,
            "max_level": 15,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "270": {
                "name": "Village of Smokestead",
                "level": 3,
                "coord": [
                  58156.3,
                  30833.9
                ],
                "bounds": [
                  [
                    57856,
                    30550.5
                  ],
                  [
                    57996.7,
                    30571
                  ],
                  [
                    58378.9,
                    30592.8
                  ],
                  [
                    58545.1,
                    30743.8
                  ],
                  [
                    58526.7,
                    30851.5
                  ],
                  [
                    58424.6,
                    31121.2
                  ],
                  [
                    58158.3,
                    31028.9
                  ],
                  [
                    58070.5,
                    31085.8
                  ],
                  [
                    57749.8,
                    31164.6
                  ],
                  [
                    57856,
                    30629.3
                  ],
                  [
                    57856,
                    30550.5
                  ]
                ],
                "id": 270,
                "chat_link": "[&BA4BAAA=]"
              },
              "271": {
                "name": "Tela Range",
                "level": 4,
                "coord": [
                  57985.5,
                  30119.3
                ],
                "bounds": [
                  [
                    57802.3,
                    30344.5
                  ],
                  [
                    57985.1,
                    30336.5
                  ],
                  [
                    58225.7,
                    30165
                  ],
                  [
                    58232.5,
                    30110.6
                  ],
                  [
                    58153.4,
                    30012.7
                  ],
                  [
                    58021.3,
                    29815.9
                  ],
                  [
                    57795.6,
                    29955.1
                  ],
                  [
                    57668.2,
                    30213.8
                  ],
                  [
                    57802.3,
                    30344.5
                  ]
                ],
                "id": 271,
                "chat_link": "[&BA8BAAA=]"
              },
              "272": {
                "name": "Victor's Presidium",
                "level": 6,
                "coord": [
                  58619.5,
                  31354.6
                ],
                "bounds": [
                  [
                    58377.7,
                    31462.3
                  ],
                  [
                    58107,
                    31444.8
                  ],
                  [
                    58067.5,
                    31084.7
                  ],
                  [
                    58154.6,
                    31026.6
                  ],
                  [
                    58424.9,
                    31119
                  ],
                  [
                    58528.8,
                    30853.1
                  ],
                  [
                    58778.9,
                    31012.2
                  ],
                  [
                    58956.4,
                    30865.6
                  ],
                  [
                    58960.7,
                    31165.8
                  ],
                  [
                    59145.5,
                    31508.3
                  ],
                  [
                    59152.1,
                    31641.5
                  ],
                  [
                    59030.3,
                    31713.5
                  ],
                  [
                    58675.4,
                    31650.2
                  ],
                  [
                    58573.1,
                    31815.7
                  ],
                  [
                    58477,
                    31779.6
                  ],
                  [
                    58501.8,
                    31530
                  ],
                  [
                    58377.7,
                    31462.3
                  ]
                ],
                "id": 272,
                "chat_link": "[&BBABAAA=]"
              },
              "273": {
                "name": "Lake Feritas",
                "level": 5,
                "coord": [
                  58714.1,
                  30124.2
                ],
                "bounds": [
                  [
                    58961.2,
                    30433.2
                  ],
                  [
                    59149.5,
                    30224.9
                  ],
                  [
                    58926.3,
                    30089.1
                  ],
                  [
                    58821.3,
                    29908.7
                  ],
                  [
                    58622.6,
                    29930.8
                  ],
                  [
                    58466.7,
                    29814.3
                  ],
                  [
                    58351.4,
                    29933.1
                  ],
                  [
                    58466.9,
                    30121.5
                  ],
                  [
                    58626.4,
                    30199
                  ],
                  [
                    58748.8,
                    30587.3
                  ],
                  [
                    58961.2,
                    30433.2
                  ]
                ],
                "id": 273,
                "chat_link": "[&BBEBAAA=]"
              },
              "274": {
                "name": "Old Duke's Estate",
                "level": 6,
                "coord": [
                  58786.2,
                  30721.7
                ],
                "bounds": [
                  [
                    58780.2,
                    31015.2
                  ],
                  [
                    58526.3,
                    30852.5
                  ],
                  [
                    58543.1,
                    30742.7
                  ],
                  [
                    58748,
                    30587
                  ],
                  [
                    58960.9,
                    30433.3
                  ],
                  [
                    59158.8,
                    30699.4
                  ],
                  [
                    58780.2,
                    31015.2
                  ]
                ],
                "id": 274,
                "chat_link": "[&BBIBAAA=]"
              },
              "275": {
                "name": "Decimus Stones",
                "level": 7,
                "coord": [
                  58311.8,
                  31605.8
                ],
                "bounds": [
                  [
                    58105.3,
                    31758
                  ],
                  [
                    58287.2,
                    31766.5
                  ],
                  [
                    58491.2,
                    31678.8
                  ],
                  [
                    58499,
                    31527.7
                  ],
                  [
                    58381,
                    31461.2
                  ],
                  [
                    58107.3,
                    31442.4
                  ],
                  [
                    58105.3,
                    31758
                  ]
                ],
                "id": 275,
                "chat_link": "[&BBMBAAA=]"
              },
              "276": {
                "name": "Charr's Triumph",
                "level": 8,
                "coord": [
                  59352.1,
                  31140.9
                ],
                "bounds": [
                  [
                    59776,
                    31147.4
                  ],
                  [
                    59708.5,
                    30981.9
                  ],
                  [
                    59186.8,
                    30702.1
                  ],
                  [
                    58984.7,
                    30868.8
                  ],
                  [
                    58987.7,
                    31167.6
                  ],
                  [
                    59173.9,
                    31511.9
                  ],
                  [
                    59488.5,
                    31461.5
                  ],
                  [
                    59510.7,
                    31286.2
                  ],
                  [
                    59776,
                    31147.4
                  ]
                ],
                "id": 276,
                "chat_link": "[&BBQBAAA=]"
              },
              "277": {
                "name": "Martyr's Woods",
                "level": 7,
                "coord": [
                  59590,
                  30474.5
                ],
                "bounds": [
                  [
                    59560.1,
                    30894.6
                  ],
                  [
                    59675.6,
                    30968.6
                  ],
                  [
                    59690.2,
                    30862
                  ],
                  [
                    59791.4,
                    30755.1
                  ],
                  [
                    59841.6,
                    30697.2
                  ],
                  [
                    59923.6,
                    30631.9
                  ],
                  [
                    60012.8,
                    30625.2
                  ],
                  [
                    60015.7,
                    30511
                  ],
                  [
                    59960.6,
                    30423.9
                  ],
                  [
                    59972.9,
                    30374.3
                  ],
                  [
                    59902.5,
                    30279.9
                  ],
                  [
                    59716.5,
                    30309.4
                  ],
                  [
                    59512,
                    30254.2
                  ],
                  [
                    59422,
                    30134.8
                  ],
                  [
                    59317.8,
                    30001
                  ],
                  [
                    59074.2,
                    30119.8
                  ],
                  [
                    59157.5,
                    30232.6
                  ],
                  [
                    59078,
                    30274.2
                  ],
                  [
                    59005.9,
                    30466.7
                  ],
                  [
                    59169.3,
                    30673.2
                  ],
                  [
                    59560.1,
                    30894.6
                  ]
                ],
                "id": 277,
                "chat_link": "[&BBUBAAA=]"
              },
              "278": {
                "name": "Ashford Forum",
                "level": 9,
                "coord": [
                  59745.5,
                  31407.1
                ],
                "bounds": [
                  [
                    59649.1,
                    31596.6
                  ],
                  [
                    59917.3,
                    31638.5
                  ],
                  [
                    60067.2,
                    31518.5
                  ],
                  [
                    59901,
                    31208.4
                  ],
                  [
                    59747.3,
                    31144.2
                  ],
                  [
                    59478.6,
                    31284.4
                  ],
                  [
                    59458,
                    31459.4
                  ],
                  [
                    59649.1,
                    31596.6
                  ]
                ],
                "id": 278,
                "chat_link": "[&BBYBAAA=]"
              },
              "279": {
                "name": "Lake Adorea",
                "level": 11,
                "coord": [
                  59592.8,
                  31705.8
                ],
                "bounds": [
                  [
                    59313.5,
                    31972.8
                  ],
                  [
                    59547.6,
                    31870.2
                  ],
                  [
                    59677,
                    31959.9
                  ],
                  [
                    59922.2,
                    31764.2
                  ],
                  [
                    60097.2,
                    31751.6
                  ],
                  [
                    60179.8,
                    31641.9
                  ],
                  [
                    60163.1,
                    31435
                  ],
                  [
                    59917.8,
                    31635.1
                  ],
                  [
                    59648.8,
                    31597.8
                  ],
                  [
                    59457.8,
                    31458.4
                  ],
                  [
                    59144.4,
                    31509
                  ],
                  [
                    59151.8,
                    31641.1
                  ],
                  [
                    59031.2,
                    31712.8
                  ],
                  [
                    59046.9,
                    31931.7
                  ],
                  [
                    59313.5,
                    31972.8
                  ]
                ],
                "id": 279,
                "chat_link": "[&BBcBAAA=]"
              },
              "280": {
                "name": "Devast District",
                "level": 10,
                "coord": [
                  60088.4,
                  30958.3
                ],
                "bounds": [
                  [
                    60162.1,
                    31435.7
                  ],
                  [
                    60312.4,
                    31323.5
                  ],
                  [
                    60386,
                    31100.6
                  ],
                  [
                    60581.8,
                    30907.5
                  ],
                  [
                    60453.8,
                    30759.5
                  ],
                  [
                    60333.2,
                    30734.4
                  ],
                  [
                    60099.5,
                    30677.9
                  ],
                  [
                    60012.7,
                    30620.1
                  ],
                  [
                    59921.3,
                    30628.9
                  ],
                  [
                    59841.7,
                    30691.9
                  ],
                  [
                    59686.2,
                    30861.1
                  ],
                  [
                    59672.6,
                    30983.1
                  ],
                  [
                    59900.2,
                    30926.3
                  ],
                  [
                    59897.9,
                    31205.3
                  ],
                  [
                    60065.1,
                    31517.9
                  ],
                  [
                    60162.1,
                    31435.7
                  ]
                ],
                "id": 280,
                "chat_link": "[&BBgBAAA=]"
              },
              "281": {
                "name": "Windrock Maze",
                "level": 12,
                "coord": [
                  60391.9,
                  31581.3
                ],
                "bounds": [
                  [
                    60180.3,
                    31642.1
                  ],
                  [
                    60161.7,
                    31435.4
                  ],
                  [
                    60315.7,
                    31322
                  ],
                  [
                    60466.2,
                    31377.5
                  ],
                  [
                    60666.9,
                    31649.1
                  ],
                  [
                    60541.7,
                    31790.9
                  ],
                  [
                    60411.3,
                    31851.8
                  ],
                  [
                    60180.3,
                    31642.1
                  ]
                ],
                "id": 281,
                "chat_link": "[&BBkBAAA=]"
              },
              "282": {
                "name": "Ascalon Basin",
                "level": 12,
                "coord": [
                  61215.8,
                  31531.5
                ],
                "bounds": [
                  [
                    60666,
                    31652.3
                  ],
                  [
                    60982.6,
                    31591.5
                  ],
                  [
                    61296.3,
                    31773.7
                  ],
                  [
                    61458.5,
                    31781.3
                  ],
                  [
                    61619.4,
                    31898.9
                  ],
                  [
                    61603.1,
                    32053.5
                  ],
                  [
                    61680.8,
                    32143
                  ],
                  [
                    61800.4,
                    32266.6
                  ],
                  [
                    62020.7,
                    31978.7
                  ],
                  [
                    62040.4,
                    31882.4
                  ],
                  [
                    61961.6,
                    31505.5
                  ],
                  [
                    61442.9,
                    31466.1
                  ],
                  [
                    61175.9,
                    31065.4
                  ],
                  [
                    61051.7,
                    31086
                  ],
                  [
                    60870.2,
                    30981.4
                  ],
                  [
                    60845.5,
                    30844.8
                  ],
                  [
                    60643.1,
                    30846.8
                  ],
                  [
                    60386,
                    31101.2
                  ],
                  [
                    60307.5,
                    31326.2
                  ],
                  [
                    60462.6,
                    31384.5
                  ],
                  [
                    60666,
                    31652.3
                  ]
                ],
                "id": 282,
                "chat_link": "[&BBoBAAA=]"
              },
              "283": {
                "name": "Phasmatis Corridor",
                "level": 13,
                "coord": [
                  60438.8,
                  30569.8
                ],
                "bounds": [
                  [
                    60640.3,
                    30858.9
                  ],
                  [
                    60582.4,
                    30915.2
                  ],
                  [
                    60450.9,
                    30771.6
                  ],
                  [
                    60096.5,
                    30681
                  ],
                  [
                    60122.2,
                    30628.4
                  ],
                  [
                    60142.1,
                    30578.6
                  ],
                  [
                    60145.5,
                    30519.8
                  ],
                  [
                    60090.6,
                    30365.1
                  ],
                  [
                    60196,
                    30311.9
                  ],
                  [
                    60368.2,
                    30355.2
                  ],
                  [
                    60478.5,
                    30343.4
                  ],
                  [
                    60716.8,
                    30224.2
                  ],
                  [
                    60700.7,
                    30400.6
                  ],
                  [
                    61009.4,
                    30738.8
                  ],
                  [
                    60842.4,
                    30854.7
                  ],
                  [
                    60640.3,
                    30858.9
                  ]
                ],
                "id": 283,
                "chat_link": "[&BBsBAAA=]"
              },
              "284": {
                "name": "The Toppled Wall",
                "level": 15,
                "coord": [
                  60142.8,
                  30218.1
                ],
                "bounds": [
                  [
                    60354.2,
                    30371.4
                  ],
                  [
                    60193.5,
                    30317.5
                  ],
                  [
                    60097.7,
                    30365.9
                  ],
                  [
                    60026.4,
                    30339.2
                  ],
                  [
                    59975.4,
                    30373.9
                  ],
                  [
                    59901.2,
                    30285.7
                  ],
                  [
                    59716.3,
                    30311.3
                  ],
                  [
                    59514.5,
                    30264.8
                  ],
                  [
                    59300.1,
                    29999.9
                  ],
                  [
                    60307.3,
                    29873.5
                  ],
                  [
                    60734.6,
                    29939
                  ],
                  [
                    60712.1,
                    30002.8
                  ],
                  [
                    60702.9,
                    30248.4
                  ],
                  [
                    60463.8,
                    30359.8
                  ],
                  [
                    60354.2,
                    30371.4
                  ]
                ],
                "id": 284,
                "chat_link": "[&BBwBAAA=]"
              },
              "285": {
                "name": "Lamia Mire",
                "level": 11,
                "coord": [
                  61089.9,
                  30885.5
                ],
                "bounds": [
                  [
                    61009.7,
                    30727.9
                  ],
                  [
                    61300.9,
                    30664.1
                  ],
                  [
                    61380.3,
                    30824.2
                  ],
                  [
                    61174.3,
                    31068.5
                  ],
                  [
                    61050.9,
                    31087.3
                  ],
                  [
                    60868.5,
                    30981.8
                  ],
                  [
                    60844.7,
                    30845
                  ],
                  [
                    61009.7,
                    30727.9
                  ]
                ],
                "id": 285,
                "chat_link": "[&BB0BAAA=]"
              },
              "286": {
                "name": "Loreclaw Expanse",
                "level": 11,
                "coord": [
                  61133.9,
                  31833.1
                ],
                "bounds": [
                  [
                    60541.3,
                    31790.3
                  ],
                  [
                    60666.8,
                    31648.9
                  ],
                  [
                    60981,
                    31590.2
                  ],
                  [
                    61303.5,
                    31774.6
                  ],
                  [
                    61462.3,
                    31777.7
                  ],
                  [
                    61624.9,
                    31894.9
                  ],
                  [
                    61608.9,
                    32048.5
                  ],
                  [
                    61163.5,
                    32020.7
                  ],
                  [
                    60853,
                    31952
                  ],
                  [
                    60541.3,
                    31790.3
                  ]
                ],
                "id": 286,
                "chat_link": "[&BB4BAAA=]"
              },
              "287": {
                "name": "Cadem Forest",
                "level": 13,
                "coord": [
                  61649.7,
                  30878.2
                ],
                "bounds": [
                  [
                    61175.7,
                    31066.7
                  ],
                  [
                    61382.4,
                    30824.6
                  ],
                  [
                    61302.4,
                    30665.2
                  ],
                  [
                    61292.9,
                    30588.2
                  ],
                  [
                    61470,
                    30418.9
                  ],
                  [
                    61659,
                    30457.1
                  ],
                  [
                    61934.2,
                    30370.9
                  ],
                  [
                    61939.4,
                    30675.2
                  ],
                  [
                    62008.4,
                    30866.8
                  ],
                  [
                    61943.6,
                    31211.3
                  ],
                  [
                    61956.3,
                    31299.2
                  ],
                  [
                    61939.3,
                    31504.9
                  ],
                  [
                    61442.5,
                    31467.4
                  ],
                  [
                    61175.7,
                    31066.7
                  ]
                ],
                "id": 287,
                "chat_link": "[&BB8BAAA=]"
              },
              "288": {
                "name": "Gunbreach Hills",
                "level": 3,
                "coord": [
                  58277,
                  30394.2
                ],
                "bounds": [
                  [
                    57811.7,
                    30326.9
                  ],
                  [
                    57985.1,
                    30336.6
                  ],
                  [
                    58139.5,
                    30216.8
                  ],
                  [
                    58197.3,
                    30260
                  ],
                  [
                    58466.1,
                    30120
                  ],
                  [
                    58627.1,
                    30196.5
                  ],
                  [
                    58748.3,
                    30586.6
                  ],
                  [
                    58543.3,
                    30743.6
                  ],
                  [
                    58379.7,
                    30589.3
                  ],
                  [
                    57871.7,
                    30565.2
                  ],
                  [
                    57811.7,
                    30326.9
                  ]
                ],
                "id": 288,
                "chat_link": "[&BCABAAA=]"
              },
              "289": {
                "name": "Ascalon City Ruins",
                "level": 14,
                "coord": [
                  61034.8,
                  30253.6
                ],
                "bounds": [
                  [
                    61011.7,
                    30731.4
                  ],
                  [
                    60697,
                    30393
                  ],
                  [
                    60723.5,
                    30048.4
                  ],
                  [
                    60727.4,
                    29978.6
                  ],
                  [
                    60743.3,
                    29921.7
                  ],
                  [
                    60963.8,
                    29895.4
                  ],
                  [
                    61426,
                    29892.3
                  ],
                  [
                    61466,
                    30421.3
                  ],
                  [
                    61289.4,
                    30588.3
                  ],
                  [
                    61300,
                    30665.6
                  ],
                  [
                    61011.7,
                    30731.4
                  ]
                ],
                "id": 289,
                "chat_link": "[&BCEBAAA=]"
              },
              "290": {
                "name": "Devourer's Mouth",
                "level": 3,
                "coord": [
                  58268,
                  30086
                ],
                "bounds": [
                  [
                    58467.2,
                    30120.9
                  ],
                  [
                    58200.9,
                    30259.5
                  ],
                  [
                    58140.9,
                    30220.5
                  ],
                  [
                    58229.3,
                    30157
                  ],
                  [
                    58229.8,
                    30114.4
                  ],
                  [
                    58152.3,
                    30016.7
                  ],
                  [
                    58208.3,
                    29891.4
                  ],
                  [
                    58368.6,
                    29949.9
                  ],
                  [
                    58414.6,
                    30043.9
                  ],
                  [
                    58467.2,
                    30120.9
                  ]
                ],
                "id": 290,
                "chat_link": "[&BCIBAAA=]"
              },
              "291": {
                "name": "Abbey Ruins",
                "level": 10,
                "coord": [
                  59808.3,
                  31063.9
                ],
                "bounds": [
                  [
                    59905.1,
                    30919.6
                  ],
                  [
                    59679.5,
                    30979.2
                  ],
                  [
                    59748.7,
                    31146.6
                  ],
                  [
                    59900.1,
                    31210.1
                  ],
                  [
                    59905.1,
                    30919.6
                  ]
                ],
                "id": 291,
                "chat_link": "[&BCMBAAA=]"
              },
              "292": {
                "name": "Agnos Gorge",
                "level": 15,
                "coord": [
                  60059.9,
                  30492.4
                ],
                "bounds": [
                  [
                    60015.7,
                    30543.8
                  ],
                  [
                    60000.2,
                    30494
                  ],
                  [
                    59953.9,
                    30423.6
                  ],
                  [
                    59971,
                    30374
                  ],
                  [
                    60017.9,
                    30334.5
                  ],
                  [
                    60099.9,
                    30364.6
                  ],
                  [
                    60111.6,
                    30418.3
                  ],
                  [
                    60148.1,
                    30515.3
                  ],
                  [
                    60147.1,
                    30549.7
                  ],
                  [
                    60145.2,
                    30581.8
                  ],
                  [
                    60102.4,
                    30680.4
                  ],
                  [
                    60005.7,
                    30628.6
                  ],
                  [
                    60015.7,
                    30543.8
                  ]
                ],
                "id": 292,
                "chat_link": "[&BCQBAAA=]"
              },
              "293": {
                "name": "Human's Lament",
                "level": 14,
                "coord": [
                  61730.5,
                  30125.3
                ],
                "bounds": [
                  [
                    61438.6,
                    30135.4
                  ],
                  [
                    61423.9,
                    29896.1
                  ],
                  [
                    61598.6,
                    29922.2
                  ],
                  [
                    61700.4,
                    29837.9
                  ],
                  [
                    61921.9,
                    29893.1
                  ],
                  [
                    62009.2,
                    29994.1
                  ],
                  [
                    61936.7,
                    30165.6
                  ],
                  [
                    61949.6,
                    30275
                  ],
                  [
                    61935.4,
                    30378.1
                  ],
                  [
                    61656,
                    30460.7
                  ],
                  [
                    61465.6,
                    30420.5
                  ],
                  [
                    61438.6,
                    30135.4
                  ]
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              },
              "567": {
                "name": "Facula Castrum",
                "level": 5,
                "coord": [
                  59121.5,
                  30024
                ],
                "bounds": [
                  [
                    59147.3,
                    30224.4
                  ],
                  [
                    59228.4,
                    30179.7
                  ],
                  [
                    59307.6,
                    30007.8
                  ],
                  [
                    59351.6,
                    29908.2
                  ],
                  [
                    59078.3,
                    29853.8
                  ],
                  [
                    58817.2,
                    29908.1
                  ],
                  [
                    58920.3,
                    30085.8
                  ],
                  [
                    59147.3,
                    30224.4
                  ]
                ],
                "id": 567,
                "chat_link": "[&BDcCAAA=]"
              },
              "1104": {
                "name": "Langmar Estate",
                "level": 15,
                "coord": [
                  58219.9,
                  31645.5
                ],
                "bounds": [
                  [
                    58484.8,
                    31778.8
                  ],
                  [
                    58575,
                    31811.5
                  ],
                  [
                    58489.1,
                    32027.1
                  ],
                  [
                    57798.1,
                    31991.6
                  ],
                  [
                    57779,
                    31145.6
                  ],
                  [
                    58072,
                    31078.3
                  ],
                  [
                    58112.6,
                    31438.4
                  ],
                  [
                    58110.3,
                    31754.6
                  ],
                  [
                    58287.9,
                    31762.2
                  ],
                  [
                    58490.1,
                    31666.8
                  ],
                  [
                    58484.8,
                    31778.8
                  ]
                ],
                "id": 1104,
                "chat_link": "[&BFAEAAA=]"
              }
            },
            "adventures": [],
            "id": 1081,
            "mastery_points": []
          },
          "1082": {
            "name": "Langmar Estate",
            "min_level": 1,
            "max_level": 15,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "270": {
                "name": "Village of Smokestead",
                "level": 3,
                "coord": [
                  58156.3,
                  30833.9
                ],
                "bounds": [
                  [
                    57856,
                    30550.5
                  ],
                  [
                    57996.7,
                    30571
                  ],
                  [
                    58378.9,
                    30592.8
                  ],
                  [
                    58545.1,
                    30743.8
                  ],
                  [
                    58526.7,
                    30851.5
                  ],
                  [
                    58424.6,
                    31121.2
                  ],
                  [
                    58158.3,
                    31028.9
                  ],
                  [
                    58070.5,
                    31085.8
                  ],
                  [
                    57749.8,
                    31164.6
                  ],
                  [
                    57856,
                    30629.3
                  ],
                  [
                    57856,
                    30550.5
                  ]
                ],
                "id": 270,
                "chat_link": "[&BA4BAAA=]"
              },
              "271": {
                "name": "Tela Range",
                "level": 4,
                "coord": [
                  57985.5,
                  30119.3
                ],
                "bounds": [
                  [
                    57802.3,
                    30344.5
                  ],
                  [
                    57985.1,
                    30336.5
                  ],
                  [
                    58225.7,
                    30165
                  ],
                  [
                    58232.5,
                    30110.6
                  ],
                  [
                    58153.4,
                    30012.7
                  ],
                  [
                    58021.3,
                    29815.9
                  ],
                  [
                    57795.6,
                    29955.1
                  ],
                  [
                    57668.2,
                    30213.8
                  ],
                  [
                    57802.3,
                    30344.5
                  ]
                ],
                "id": 271,
                "chat_link": "[&BA8BAAA=]"
              },
              "272": {
                "name": "Victor's Presidium",
                "level": 6,
                "coord": [
                  58619.5,
                  31354.6
                ],
                "bounds": [
                  [
                    58377.7,
                    31462.3
                  ],
                  [
                    58107,
                    31444.8
                  ],
                  [
                    58067.5,
                    31084.7
                  ],
                  [
                    58154.6,
                    31026.6
                  ],
                  [
                    58424.9,
                    31119
                  ],
                  [
                    58528.8,
                    30853.1
                  ],
                  [
                    58778.9,
                    31012.2
                  ],
                  [
                    58956.4,
                    30865.6
                  ],
                  [
                    58960.7,
                    31165.8
                  ],
                  [
                    59145.5,
                    31508.3
                  ],
                  [
                    59152.1,
                    31641.5
                  ],
                  [
                    59030.3,
                    31713.5
                  ],
                  [
                    58675.4,
                    31650.2
                  ],
                  [
                    58573.1,
                    31815.7
                  ],
                  [
                    58477,
                    31779.6
                  ],
                  [
                    58501.8,
                    31530
                  ],
                  [
                    58377.7,
                    31462.3
                  ]
                ],
                "id": 272,
                "chat_link": "[&BBABAAA=]"
              },
              "273": {
                "name": "Lake Feritas",
                "level": 5,
                "coord": [
                  58714.1,
                  30124.2
                ],
                "bounds": [
                  [
                    58961.2,
                    30433.2
                  ],
                  [
                    59149.5,
                    30224.9
                  ],
                  [
                    58926.3,
                    30089.1
                  ],
                  [
                    58821.3,
                    29908.7
                  ],
                  [
                    58622.6,
                    29930.8
                  ],
                  [
                    58466.7,
                    29814.3
                  ],
                  [
                    58351.4,
                    29933.1
                  ],
                  [
                    58466.9,
                    30121.5
                  ],
                  [
                    58626.4,
                    30199
                  ],
                  [
                    58748.8,
                    30587.3
                  ],
                  [
                    58961.2,
                    30433.2
                  ]
                ],
                "id": 273,
                "chat_link": "[&BBEBAAA=]"
              },
              "274": {
                "name": "Old Duke's Estate",
                "level": 6,
                "coord": [
                  58786.2,
                  30721.7
                ],
                "bounds": [
                  [
                    58780.2,
                    31015.2
                  ],
                  [
                    58526.3,
                    30852.5
                  ],
                  [
                    58543.1,
                    30742.7
                  ],
                  [
                    58748,
                    30587
                  ],
                  [
                    58960.9,
                    30433.3
                  ],
                  [
                    59158.8,
                    30699.4
                  ],
                  [
                    58780.2,
                    31015.2
                  ]
                ],
                "id": 274,
                "chat_link": "[&BBIBAAA=]"
              },
              "275": {
                "name": "Decimus Stones",
                "level": 7,
                "coord": [
                  58311.8,
                  31605.8
                ],
                "bounds": [
                  [
                    58105.3,
                    31758
                  ],
                  [
                    58287.2,
                    31766.5
                  ],
                  [
                    58491.2,
                    31678.8
                  ],
                  [
                    58499,
                    31527.7
                  ],
                  [
                    58381,
                    31461.2
                  ],
                  [
                    58107.3,
                    31442.4
                  ],
                  [
                    58105.3,
                    31758
                  ]
                ],
                "id": 275,
                "chat_link": "[&BBMBAAA=]"
              },
              "276": {
                "name": "Charr's Triumph",
                "level": 8,
                "coord": [
                  59352.1,
                  31140.9
                ],
                "bounds": [
                  [
                    59776,
                    31147.4
                  ],
                  [
                    59708.5,
                    30981.9
                  ],
                  [
                    59186.8,
                    30702.1
                  ],
                  [
                    58984.7,
                    30868.8
                  ],
                  [
                    58987.7,
                    31167.6
                  ],
                  [
                    59173.9,
                    31511.9
                  ],
                  [
                    59488.5,
                    31461.5
                  ],
                  [
                    59510.7,
                    31286.2
                  ],
                  [
                    59776,
                    31147.4
                  ]
                ],
                "id": 276,
                "chat_link": "[&BBQBAAA=]"
              },
              "277": {
                "name": "Martyr's Woods",
                "level": 7,
                "coord": [
                  59590,
                  30474.5
                ],
                "bounds": [
                  [
                    59560.1,
                    30894.6
                  ],
                  [
                    59675.6,
                    30968.6
                  ],
                  [
                    59690.2,
                    30862
                  ],
                  [
                    59791.4,
                    30755.1
                  ],
                  [
                    59841.6,
                    30697.2
                  ],
                  [
                    59923.6,
                    30631.9
                  ],
                  [
                    60012.8,
                    30625.2
                  ],
                  [
                    60015.7,
                    30511
                  ],
                  [
                    59960.6,
                    30423.9
                  ],
                  [
                    59972.9,
                    30374.3
                  ],
                  [
                    59902.5,
                    30279.9
                  ],
                  [
                    59716.5,
                    30309.4
                  ],
                  [
                    59512,
                    30254.2
                  ],
                  [
                    59422,
                    30134.8
                  ],
                  [
                    59317.8,
                    30001
                  ],
                  [
                    59074.2,
                    30119.8
                  ],
                  [
                    59157.5,
                    30232.6
                  ],
                  [
                    59078,
                    30274.2
                  ],
                  [
                    59005.9,
                    30466.7
                  ],
                  [
                    59169.3,
                    30673.2
                  ],
                  [
                    59560.1,
                    30894.6
                  ]
                ],
                "id": 277,
                "chat_link": "[&BBUBAAA=]"
              },
              "278": {
                "name": "Ashford Forum",
                "level": 9,
                "coord": [
                  59745.5,
                  31407.1
                ],
                "bounds": [
                  [
                    59649.1,
                    31596.6
                  ],
                  [
                    59917.3,
                    31638.5
                  ],
                  [
                    60067.2,
                    31518.5
                  ],
                  [
                    59901,
                    31208.4
                  ],
                  [
                    59747.3,
                    31144.2
                  ],
                  [
                    59478.6,
                    31284.4
                  ],
                  [
                    59458,
                    31459.4
                  ],
                  [
                    59649.1,
                    31596.6
                  ]
                ],
                "id": 278,
                "chat_link": "[&BBYBAAA=]"
              },
              "279": {
                "name": "Lake Adorea",
                "level": 11,
                "coord": [
                  59592.8,
                  31705.8
                ],
                "bounds": [
                  [
                    59313.5,
                    31972.8
                  ],
                  [
                    59547.6,
                    31870.2
                  ],
                  [
                    59677,
                    31959.9
                  ],
                  [
                    59922.2,
                    31764.2
                  ],
                  [
                    60097.2,
                    31751.6
                  ],
                  [
                    60179.8,
                    31641.9
                  ],
                  [
                    60163.1,
                    31435
                  ],
                  [
                    59917.8,
                    31635.1
                  ],
                  [
                    59648.8,
                    31597.8
                  ],
                  [
                    59457.8,
                    31458.4
                  ],
                  [
                    59144.4,
                    31509
                  ],
                  [
                    59151.8,
                    31641.1
                  ],
                  [
                    59031.2,
                    31712.8
                  ],
                  [
                    59046.9,
                    31931.7
                  ],
                  [
                    59313.5,
                    31972.8
                  ]
                ],
                "id": 279,
                "chat_link": "[&BBcBAAA=]"
              },
              "280": {
                "name": "Devast District",
                "level": 10,
                "coord": [
                  60088.4,
                  30958.3
                ],
                "bounds": [
                  [
                    60162.1,
                    31435.7
                  ],
                  [
                    60312.4,
                    31323.5
                  ],
                  [
                    60386,
                    31100.6
                  ],
                  [
                    60581.8,
                    30907.5
                  ],
                  [
                    60453.8,
                    30759.5
                  ],
                  [
                    60333.2,
                    30734.4
                  ],
                  [
                    60099.5,
                    30677.9
                  ],
                  [
                    60012.7,
                    30620.1
                  ],
                  [
                    59921.3,
                    30628.9
                  ],
                  [
                    59841.7,
                    30691.9
                  ],
                  [
                    59686.2,
                    30861.1
                  ],
                  [
                    59672.6,
                    30983.1
                  ],
                  [
                    59900.2,
                    30926.3
                  ],
                  [
                    59897.9,
                    31205.3
                  ],
                  [
                    60065.1,
                    31517.9
                  ],
                  [
                    60162.1,
                    31435.7
                  ]
                ],
                "id": 280,
                "chat_link": "[&BBgBAAA=]"
              },
              "281": {
                "name": "Windrock Maze",
                "level": 12,
                "coord": [
                  60391.9,
                  31581.3
                ],
                "bounds": [
                  [
                    60180.3,
                    31642.1
                  ],
                  [
                    60161.7,
                    31435.4
                  ],
                  [
                    60315.7,
                    31322
                  ],
                  [
                    60466.2,
                    31377.5
                  ],
                  [
                    60666.9,
                    31649.1
                  ],
                  [
                    60541.7,
                    31790.9
                  ],
                  [
                    60411.3,
                    31851.8
                  ],
                  [
                    60180.3,
                    31642.1
                  ]
                ],
                "id": 281,
                "chat_link": "[&BBkBAAA=]"
              },
              "282": {
                "name": "Ascalon Basin",
                "level": 12,
                "coord": [
                  61215.8,
                  31531.5
                ],
                "bounds": [
                  [
                    60666,
                    31652.3
                  ],
                  [
                    60982.6,
                    31591.5
                  ],
                  [
                    61296.3,
                    31773.7
                  ],
                  [
                    61458.5,
                    31781.3
                  ],
                  [
                    61619.4,
                    31898.9
                  ],
                  [
                    61603.1,
                    32053.5
                  ],
                  [
                    61680.8,
                    32143
                  ],
                  [
                    61800.4,
                    32266.6
                  ],
                  [
                    62020.7,
                    31978.7
                  ],
                  [
                    62040.4,
                    31882.4
                  ],
                  [
                    61961.6,
                    31505.5
                  ],
                  [
                    61442.9,
                    31466.1
                  ],
                  [
                    61175.9,
                    31065.4
                  ],
                  [
                    61051.7,
                    31086
                  ],
                  [
                    60870.2,
                    30981.4
                  ],
                  [
                    60845.5,
                    30844.8
                  ],
                  [
                    60643.1,
                    30846.8
                  ],
                  [
                    60386,
                    31101.2
                  ],
                  [
                    60307.5,
                    31326.2
                  ],
                  [
                    60462.6,
                    31384.5
                  ],
                  [
                    60666,
                    31652.3
                  ]
                ],
                "id": 282,
                "chat_link": "[&BBoBAAA=]"
              },
              "283": {
                "name": "Phasmatis Corridor",
                "level": 13,
                "coord": [
                  60438.8,
                  30569.8
                ],
                "bounds": [
                  [
                    60640.3,
                    30858.9
                  ],
                  [
                    60582.4,
                    30915.2
                  ],
                  [
                    60450.9,
                    30771.6
                  ],
                  [
                    60096.5,
                    30681
                  ],
                  [
                    60122.2,
                    30628.4
                  ],
                  [
                    60142.1,
                    30578.6
                  ],
                  [
                    60145.5,
                    30519.8
                  ],
                  [
                    60090.6,
                    30365.1
                  ],
                  [
                    60196,
                    30311.9
                  ],
                  [
                    60368.2,
                    30355.2
                  ],
                  [
                    60478.5,
                    30343.4
                  ],
                  [
                    60716.8,
                    30224.2
                  ],
                  [
                    60700.7,
                    30400.6
                  ],
                  [
                    61009.4,
                    30738.8
                  ],
                  [
                    60842.4,
                    30854.7
                  ],
                  [
                    60640.3,
                    30858.9
                  ]
                ],
                "id": 283,
                "chat_link": "[&BBsBAAA=]"
              },
              "284": {
                "name": "The Toppled Wall",
                "level": 15,
                "coord": [
                  60142.8,
                  30218.1
                ],
                "bounds": [
                  [
                    60354.2,
                    30371.4
                  ],
                  [
                    60193.5,
                    30317.5
                  ],
                  [
                    60097.7,
                    30365.9
                  ],
                  [
                    60026.4,
                    30339.2
                  ],
                  [
                    59975.4,
                    30373.9
                  ],
                  [
                    59901.2,
                    30285.7
                  ],
                  [
                    59716.3,
                    30311.3
                  ],
                  [
                    59514.5,
                    30264.8
                  ],
                  [
                    59300.1,
                    29999.9
                  ],
                  [
                    60307.3,
                    29873.5
                  ],
                  [
                    60734.6,
                    29939
                  ],
                  [
                    60712.1,
                    30002.8
                  ],
                  [
                    60702.9,
                    30248.4
                  ],
                  [
                    60463.8,
                    30359.8
                  ],
                  [
                    60354.2,
                    30371.4
                  ]
                ],
                "id": 284,
                "chat_link": "[&BBwBAAA=]"
              },
              "285": {
                "name": "Lamia Mire",
                "level": 11,
                "coord": [
                  61089.9,
                  30885.5
                ],
                "bounds": [
                  [
                    61009.7,
                    30727.9
                  ],
                  [
                    61300.9,
                    30664.1
                  ],
                  [
                    61380.3,
                    30824.2
                  ],
                  [
                    61174.3,
                    31068.5
                  ],
                  [
                    61050.9,
                    31087.3
                  ],
                  [
                    60868.5,
                    30981.8
                  ],
                  [
                    60844.7,
                    30845
                  ],
                  [
                    61009.7,
                    30727.9
                  ]
                ],
                "id": 285,
                "chat_link": "[&BB0BAAA=]"
              },
              "286": {
                "name": "Loreclaw Expanse",
                "level": 11,
                "coord": [
                  61133.9,
                  31833.1
                ],
                "bounds": [
                  [
                    60541.3,
                    31790.3
                  ],
                  [
                    60666.8,
                    31648.9
                  ],
                  [
                    60981,
                    31590.2
                  ],
                  [
                    61303.5,
                    31774.6
                  ],
                  [
                    61462.3,
                    31777.7
                  ],
                  [
                    61624.9,
                    31894.9
                  ],
                  [
                    61608.9,
                    32048.5
                  ],
                  [
                    61163.5,
                    32020.7
                  ],
                  [
                    60853,
                    31952
                  ],
                  [
                    60541.3,
                    31790.3
                  ]
                ],
                "id": 286,
                "chat_link": "[&BB4BAAA=]"
              },
              "287": {
                "name": "Cadem Forest",
                "level": 13,
                "coord": [
                  61649.7,
                  30878.2
                ],
                "bounds": [
                  [
                    61175.7,
                    31066.7
                  ],
                  [
                    61382.4,
                    30824.6
                  ],
                  [
                    61302.4,
                    30665.2
                  ],
                  [
                    61292.9,
                    30588.2
                  ],
                  [
                    61470,
                    30418.9
                  ],
                  [
                    61659,
                    30457.1
                  ],
                  [
                    61934.2,
                    30370.9
                  ],
                  [
                    61939.4,
                    30675.2
                  ],
                  [
                    62008.4,
                    30866.8
                  ],
                  [
                    61943.6,
                    31211.3
                  ],
                  [
                    61956.3,
                    31299.2
                  ],
                  [
                    61939.3,
                    31504.9
                  ],
                  [
                    61442.5,
                    31467.4
                  ],
                  [
                    61175.7,
                    31066.7
                  ]
                ],
                "id": 287,
                "chat_link": "[&BB8BAAA=]"
              },
              "288": {
                "name": "Gunbreach Hills",
                "level": 3,
                "coord": [
                  58277,
                  30394.2
                ],
                "bounds": [
                  [
                    57811.7,
                    30326.9
                  ],
                  [
                    57985.1,
                    30336.6
                  ],
                  [
                    58139.5,
                    30216.8
                  ],
                  [
                    58197.3,
                    30260
                  ],
                  [
                    58466.1,
                    30120
                  ],
                  [
                    58627.1,
                    30196.5
                  ],
                  [
                    58748.3,
                    30586.6
                  ],
                  [
                    58543.3,
                    30743.6
                  ],
                  [
                    58379.7,
                    30589.3
                  ],
                  [
                    57871.7,
                    30565.2
                  ],
                  [
                    57811.7,
                    30326.9
                  ]
                ],
                "id": 288,
                "chat_link": "[&BCABAAA=]"
              },
              "289": {
                "name": "Ascalon City Ruins",
                "level": 14,
                "coord": [
                  61034.8,
                  30253.6
                ],
                "bounds": [
                  [
                    61011.7,
                    30731.4
                  ],
                  [
                    60697,
                    30393
                  ],
                  [
                    60723.5,
                    30048.4
                  ],
                  [
                    60727.4,
                    29978.6
                  ],
                  [
                    60743.3,
                    29921.7
                  ],
                  [
                    60963.8,
                    29895.4
                  ],
                  [
                    61426,
                    29892.3
                  ],
                  [
                    61466,
                    30421.3
                  ],
                  [
                    61289.4,
                    30588.3
                  ],
                  [
                    61300,
                    30665.6
                  ],
                  [
                    61011.7,
                    30731.4
                  ]
                ],
                "id": 289,
                "chat_link": "[&BCEBAAA=]"
              },
              "290": {
                "name": "Devourer's Mouth",
                "level": 3,
                "coord": [
                  58268,
                  30086
                ],
                "bounds": [
                  [
                    58467.2,
                    30120.9
                  ],
                  [
                    58200.9,
                    30259.5
                  ],
                  [
                    58140.9,
                    30220.5
                  ],
                  [
                    58229.3,
                    30157
                  ],
                  [
                    58229.8,
                    30114.4
                  ],
                  [
                    58152.3,
                    30016.7
                  ],
                  [
                    58208.3,
                    29891.4
                  ],
                  [
                    58368.6,
                    29949.9
                  ],
                  [
                    58414.6,
                    30043.9
                  ],
                  [
                    58467.2,
                    30120.9
                  ]
                ],
                "id": 290,
                "chat_link": "[&BCIBAAA=]"
              },
              "291": {
                "name": "Abbey Ruins",
                "level": 10,
                "coord": [
                  59808.3,
                  31063.9
                ],
                "bounds": [
                  [
                    59905.1,
                    30919.6
                  ],
                  [
                    59679.5,
                    30979.2
                  ],
                  [
                    59748.7,
                    31146.6
                  ],
                  [
                    59900.1,
                    31210.1
                  ],
                  [
                    59905.1,
                    30919.6
                  ]
                ],
                "id": 291,
                "chat_link": "[&BCMBAAA=]"
              },
              "292": {
                "name": "Agnos Gorge",
                "level": 15,
                "coord": [
                  60059.9,
                  30492.4
                ],
                "bounds": [
                  [
                    60015.7,
                    30543.8
                  ],
                  [
                    60000.2,
                    30494
                  ],
                  [
                    59953.9,
                    30423.6
                  ],
                  [
                    59971,
                    30374
                  ],
                  [
                    60017.9,
                    30334.5
                  ],
                  [
                    60099.9,
                    30364.6
                  ],
                  [
                    60111.6,
                    30418.3
                  ],
                  [
                    60148.1,
                    30515.3
                  ],
                  [
                    60147.1,
                    30549.7
                  ],
                  [
                    60145.2,
                    30581.8
                  ],
                  [
                    60102.4,
                    30680.4
                  ],
                  [
                    60005.7,
                    30628.6
                  ],
                  [
                    60015.7,
                    30543.8
                  ]
                ],
                "id": 292,
                "chat_link": "[&BCQBAAA=]"
              },
              "293": {
                "name": "Human's Lament",
                "level": 14,
                "coord": [
                  61730.5,
                  30125.3
                ],
                "bounds": [
                  [
                    61438.6,
                    30135.4
                  ],
                  [
                    61423.9,
                    29896.1
                  ],
                  [
                    61598.6,
                    29922.2
                  ],
                  [
                    61700.4,
                    29837.9
                  ],
                  [
                    61921.9,
                    29893.1
                  ],
                  [
                    62009.2,
                    29994.1
                  ],
                  [
                    61936.7,
                    30165.6
                  ],
                  [
                    61949.6,
                    30275
                  ],
                  [
                    61935.4,
                    30378.1
                  ],
                  [
                    61656,
                    30460.7
                  ],
                  [
                    61465.6,
                    30420.5
                  ],
                  [
                    61438.6,
                    30135.4
                  ]
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              },
              "567": {
                "name": "Facula Castrum",
                "level": 5,
                "coord": [
                  59121.5,
                  30024
                ],
                "bounds": [
                  [
                    59147.3,
                    30224.4
                  ],
                  [
                    59228.4,
                    30179.7
                  ],
                  [
                    59307.6,
                    30007.8
                  ],
                  [
                    59351.6,
                    29908.2
                  ],
                  [
                    59078.3,
                    29853.8
                  ],
                  [
                    58817.2,
                    29908.1
                  ],
                  [
                    58920.3,
                    30085.8
                  ],
                  [
                    59147.3,
                    30224.4
                  ]
                ],
                "id": 567,
                "chat_link": "[&BDcCAAA=]"
              },
              "1104": {
                "name": "Langmar Estate",
                "level": 15,
                "coord": [
                  58219.9,
                  31645.5
                ],
                "bounds": [
                  [
                    58484.8,
                    31778.8
                  ],
                  [
                    58575,
                    31811.5
                  ],
                  [
                    58489.1,
                    32027.1
                  ],
                  [
                    57798.1,
                    31991.6
                  ],
                  [
                    57779,
                    31145.6
                  ],
                  [
                    58072,
                    31078.3
                  ],
                  [
                    58112.6,
                    31438.4
                  ],
                  [
                    58110.3,
                    31754.6
                  ],
                  [
                    58287.9,
                    31762.2
                  ],
                  [
                    58490.1,
                    31666.8
                  ],
                  [
                    58484.8,
                    31778.8
                  ]
                ],
                "id": 1104,
                "chat_link": "[&BFAEAAA=]"
              }
            },
            "id": 1082,
            "mastery_points": [],
            "adventures": []
          },
          "1086": {
            "name": "Save Our Supplies",
            "min_level": 50,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              60928,
              27904
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                59904,
                25856
              ],
              [
                61952,
                29952
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "433": {
                "name": "Champion's Shield",
                "level": 54,
                "coord": [
                  60464.9,
                  29077.8
                ],
                "bounds": [
                  [
                    59906.5,
                    29535.9
                  ],
                  [
                    60142.4,
                    29465.2
                  ],
                  [
                    60332.5,
                    29597.5
                  ],
                  [
                    60589.6,
                    29543.2
                  ],
                  [
                    60718.4,
                    29291.3
                  ],
                  [
                    60835.9,
                    29115.6
                  ],
                  [
                    61091.2,
                    29074.5
                  ],
                  [
                    60957.3,
                    29006.4
                  ],
                  [
                    60913.8,
                    28942.5
                  ],
                  [
                    61002.8,
                    28761.8
                  ],
                  [
                    60951.1,
                    28708.4
                  ],
                  [
                    60683.9,
                    28904.1
                  ],
                  [
                    60427.7,
                    28910
                  ],
                  [
                    60185.8,
                    28739.6
                  ],
                  [
                    60010,
                    28837
                  ],
                  [
                    59916.2,
                    28765.3
                  ],
                  [
                    59857.7,
                    28954.8
                  ],
                  [
                    59845.2,
                    29247.4
                  ],
                  [
                    59906.5,
                    29535.9
                  ]
                ],
                "id": 433,
                "chat_link": "[&BLEBAAA=]"
              },
              "434": {
                "name": "Stonesheath Overlook",
                "level": 52,
                "coord": [
                  60716.9,
                  29831.6
                ],
                "bounds": [
                  [
                    60590,
                    29542.5
                  ],
                  [
                    60789.9,
                    29653.4
                  ],
                  [
                    60847,
                    29766
                  ],
                  [
                    61007.3,
                    29781.6
                  ],
                  [
                    61022.8,
                    29864.7
                  ],
                  [
                    61004.8,
                    30017.5
                  ],
                  [
                    60894.1,
                    30007.1
                  ],
                  [
                    60882.6,
                    29951
                  ],
                  [
                    60546.7,
                    29973.3
                  ],
                  [
                    60340.5,
                    29968.3
                  ],
                  [
                    60344.7,
                    29856.1
                  ],
                  [
                    60332.8,
                    29597.5
                  ],
                  [
                    60590,
                    29542.5
                  ]
                ],
                "id": 434,
                "chat_link": "[&BLIBAAA=]"
              },
              "435": {
                "name": "Ironhead Lake",
                "level": 53,
                "coord": [
                  60996,
                  29461.3
                ],
                "bounds": [
                  [
                    60590.1,
                    29543.3
                  ],
                  [
                    60717.6,
                    29291.3
                  ],
                  [
                    60841.1,
                    29124.2
                  ],
                  [
                    61093.5,
                    29078
                  ],
                  [
                    61068.2,
                    29273.4
                  ],
                  [
                    61217.3,
                    29440.5
                  ],
                  [
                    61345.6,
                    29440.3
                  ],
                  [
                    61300.9,
                    29540.5
                  ],
                  [
                    61133.8,
                    29602.9
                  ],
                  [
                    61006.7,
                    29782.2
                  ],
                  [
                    60847.3,
                    29765.4
                  ],
                  [
                    60789.4,
                    29654
                  ],
                  [
                    60590.1,
                    29543.3
                  ]
                ],
                "id": 435,
                "chat_link": "[&BLMBAAA=]"
              },
              "436": {
                "name": "Bloodfin Lake",
                "level": 51,
                "coord": [
                  61404.3,
                  29650.5
                ],
                "bounds": [
                  [
                    61022.8,
                    29864.5
                  ],
                  [
                    61004.7,
                    29985.7
                  ],
                  [
                    61350.3,
                    29943.7
                  ],
                  [
                    61760.3,
                    29939.8
                  ],
                  [
                    61940.2,
                    29782.8
                  ],
                  [
                    61910.7,
                    29321.9
                  ],
                  [
                    61623.8,
                    29354.3
                  ],
                  [
                    61450.5,
                    29244
                  ],
                  [
                    61345,
                    29444.2
                  ],
                  [
                    61301.4,
                    29542.6
                  ],
                  [
                    61134,
                    29601.3
                  ],
                  [
                    61007.8,
                    29781.6
                  ],
                  [
                    61022.8,
                    29864.5
                  ]
                ],
                "id": 436,
                "chat_link": "[&BLQBAAA=]"
              },
              "437": {
                "name": "Hellion Forest",
                "level": 50,
                "coord": [
                  61648.8,
                  28968.5
                ],
                "bounds": [
                  [
                    61910.6,
                    29321.8
                  ],
                  [
                    61931.3,
                    29157
                  ],
                  [
                    61883.4,
                    28921.1
                  ],
                  [
                    61948.3,
                    28935.3
                  ],
                  [
                    61942.7,
                    28820.8
                  ],
                  [
                    61845.8,
                    28768.9
                  ],
                  [
                    61552.7,
                    28703.4
                  ],
                  [
                    61535.9,
                    28658.7
                  ],
                  [
                    61334.8,
                    28784.4
                  ],
                  [
                    61369.3,
                    28879.6
                  ],
                  [
                    61280.9,
                    28993.9
                  ],
                  [
                    61472.2,
                    29014.5
                  ],
                  [
                    61450.3,
                    29243.6
                  ],
                  [
                    61624.8,
                    29356.3
                  ],
                  [
                    61910.6,
                    29321.8
                  ]
                ],
                "id": 437,
                "chat_link": "[&BLUBAAA=]"
              },
              "438": {
                "name": "Sunken Halls of Clarent",
                "level": 52,
                "coord": [
                  61277.8,
                  29213.2
                ],
                "bounds": [
                  [
                    61347.8,
                    29439.2
                  ],
                  [
                    61448.9,
                    29243.7
                  ],
                  [
                    61473,
                    29014
                  ],
                  [
                    61281.3,
                    28993.9
                  ],
                  [
                    61099.6,
                    29081
                  ],
                  [
                    61072.4,
                    29280.6
                  ],
                  [
                    61221.9,
                    29440.1
                  ],
                  [
                    61347.8,
                    29439.2
                  ]
                ],
                "id": 438,
                "chat_link": "[&BLYBAAA=]"
              },
              "439": {
                "name": "Monger's Sink",
                "level": 55,
                "coord": [
                  60560.7,
                  28563.1
                ],
                "bounds": [
                  [
                    60189.3,
                    28428.1
                  ],
                  [
                    60011.7,
                    28232.8
                  ],
                  [
                    60764,
                    28201
                  ],
                  [
                    60892.6,
                    28405.2
                  ],
                  [
                    60939.4,
                    28542
                  ],
                  [
                    60951.9,
                    28705.5
                  ],
                  [
                    60684.6,
                    28903.9
                  ],
                  [
                    60427.8,
                    28910.6
                  ],
                  [
                    60184.9,
                    28738.9
                  ],
                  [
                    60189.3,
                    28428.1
                  ]
                ],
                "id": 439,
                "chat_link": "[&BLcBAAA=]"
              },
              "440": {
                "name": "Scourgejaw's Vault",
                "level": 55,
                "coord": [
                  60036.3,
                  28558.1
                ],
                "bounds": [
                  [
                    60011.6,
                    28232.4
                  ],
                  [
                    60189.3,
                    28428.5
                  ],
                  [
                    60184.8,
                    28740.4
                  ],
                  [
                    60010,
                    28836.8
                  ],
                  [
                    59913,
                    28767.2
                  ],
                  [
                    59909,
                    28343.1
                  ],
                  [
                    60011.6,
                    28232.4
                  ]
                ],
                "id": 440,
                "chat_link": "[&BLgBAAA=]"
              },
              "441": {
                "name": "Soldier Mesa",
                "level": 56,
                "coord": [
                  60336.1,
                  27971.7
                ],
                "bounds": [
                  [
                    60342.5,
                    27696.9
                  ],
                  [
                    60462,
                    27843.7
                  ],
                  [
                    60730.2,
                    27835.2
                  ],
                  [
                    60827.7,
                    28010.1
                  ],
                  [
                    60762.2,
                    28202
                  ],
                  [
                    60009.8,
                    28235.3
                  ],
                  [
                    59853.3,
                    28177.5
                  ],
                  [
                    59917,
                    27885.5
                  ],
                  [
                    60120,
                    27858.8
                  ],
                  [
                    60342.5,
                    27696.9
                  ]
                ],
                "id": 441,
                "chat_link": "[&BLkBAAA=]"
              },
              "442": {
                "name": "Viper's Run",
                "level": 56,
                "coord": [
                  61057.5,
                  27950.7
                ],
                "bounds": [
                  [
                    60828.5,
                    28010
                  ],
                  [
                    60763.3,
                    28203.4
                  ],
                  [
                    60892.7,
                    28404.1
                  ],
                  [
                    60990,
                    28252
                  ],
                  [
                    61402.5,
                    28275.4
                  ],
                  [
                    61394.3,
                    28145.3
                  ],
                  [
                    61386.3,
                    27995.3
                  ],
                  [
                    61254.2,
                    27819.5
                  ],
                  [
                    61295,
                    27411.4
                  ],
                  [
                    60876.2,
                    27384.1
                  ],
                  [
                    60877.3,
                    27671.1
                  ],
                  [
                    60730.3,
                    27836.5
                  ],
                  [
                    60828.5,
                    28010
                  ]
                ],
                "id": 442,
                "chat_link": "[&BLoBAAA=]"
              },
              "443": {
                "name": "Lamprey Grottoes",
                "level": 56,
                "coord": [
                  61114.6,
                  28502.6
                ],
                "bounds": [
                  [
                    60990.4,
                    28252.6
                  ],
                  [
                    61401.3,
                    28274.3
                  ],
                  [
                    61445.5,
                    28409.8
                  ],
                  [
                    61254.6,
                    28584.5
                  ],
                  [
                    61146.7,
                    28580.1
                  ],
                  [
                    61006.6,
                    28765.4
                  ],
                  [
                    60955.8,
                    28710.1
                  ],
                  [
                    60939,
                    28542.5
                  ],
                  [
                    60891.7,
                    28403.9
                  ],
                  [
                    60990.4,
                    28252.6
                  ]
                ],
                "id": 443,
                "chat_link": "[&BLsBAAA=]"
              },
              "444": {
                "name": "Southshore Wastes",
                "level": 56,
                "coord": [
                  61648,
                  28463.3
                ],
                "bounds": [
                  [
                    61401.6,
                    28274
                  ],
                  [
                    61394.3,
                    28143.1
                  ],
                  [
                    61636.2,
                    28231.1
                  ],
                  [
                    61896.8,
                    28115.8
                  ],
                  [
                    62035.8,
                    28179.6
                  ],
                  [
                    62144.2,
                    28346.9
                  ],
                  [
                    61940.4,
                    28819.5
                  ],
                  [
                    61846.6,
                    28769.4
                  ],
                  [
                    61552.8,
                    28704.4
                  ],
                  [
                    61537.9,
                    28654.9
                  ],
                  [
                    61334.2,
                    28778.5
                  ],
                  [
                    61258.9,
                    28597.7
                  ],
                  [
                    61444,
                    28408
                  ],
                  [
                    61401.6,
                    28274
                  ]
                ],
                "id": 444,
                "chat_link": "[&BLwBAAA=]"
              },
              "445": {
                "name": "Lake Desolann",
                "level": 57,
                "coord": [
                  61677.4,
                  27859.6
                ],
                "bounds": [
                  [
                    61253.5,
                    27818.9
                  ],
                  [
                    61294.7,
                    27411
                  ],
                  [
                    61940.3,
                    27258.2
                  ],
                  [
                    61902.2,
                    27625.6
                  ],
                  [
                    62035.8,
                    27815.3
                  ],
                  [
                    62034.7,
                    28180
                  ],
                  [
                    61896.5,
                    28116.2
                  ],
                  [
                    61636.1,
                    28231.5
                  ],
                  [
                    61394.5,
                    28143.2
                  ],
                  [
                    61386,
                    27995.9
                  ],
                  [
                    61253.5,
                    27818.9
                  ]
                ],
                "id": 445,
                "chat_link": "[&BL0BAAA=]"
              },
              "446": {
                "name": "Crystalwept Groves",
                "level": 58,
                "coord": [
                  61545.3,
                  26843.5
                ],
                "bounds": [
                  [
                    61294.3,
                    27411.6
                  ],
                  [
                    61851.2,
                    27282.6
                  ],
                  [
                    61872.8,
                    26710.5
                  ],
                  [
                    61802,
                    26532
                  ],
                  [
                    61546.5,
                    26534.2
                  ],
                  [
                    61273.5,
                    26651.4
                  ],
                  [
                    61177.1,
                    26782
                  ],
                  [
                    61294.3,
                    27411.6
                  ]
                ],
                "id": 446,
                "chat_link": "[&BL4BAAA=]"
              },
              "447": {
                "name": "The Granite Front",
                "level": 58,
                "coord": [
                  61004.1,
                  27049.1
                ],
                "bounds": [
                  [
                    60876.1,
                    27385
                  ],
                  [
                    61295.3,
                    27411.9
                  ],
                  [
                    61177.9,
                    26781.8
                  ],
                  [
                    60932.1,
                    26584.9
                  ],
                  [
                    60739.2,
                    27082.1
                  ],
                  [
                    60876.1,
                    27385
                  ]
                ],
                "id": 447,
                "chat_link": "[&BL8BAAA=]"
              },
              "448": {
                "name": "Glory's Steps",
                "level": 57,
                "coord": [
                  60620.1,
                  27536.7
                ],
                "bounds": [
                  [
                    60308.2,
                    27433.8
                  ],
                  [
                    60624.5,
                    27348.8
                  ],
                  [
                    60739.3,
                    27080.1
                  ],
                  [
                    60876.6,
                    27384.6
                  ],
                  [
                    60877.8,
                    27671.5
                  ],
                  [
                    60730.3,
                    27835.7
                  ],
                  [
                    60462,
                    27843.3
                  ],
                  [
                    60342,
                    27696.3
                  ],
                  [
                    60308.2,
                    27433.8
                  ]
                ],
                "id": 448,
                "chat_link": "[&BMABAAA=]"
              },
              "449": {
                "name": "Western Bulwark",
                "level": 57,
                "coord": [
                  60014.2,
                  27381.5
                ],
                "bounds": [
                  [
                    60119.7,
                    27863.4
                  ],
                  [
                    60342.2,
                    27698
                  ],
                  [
                    60309.1,
                    27433.6
                  ],
                  [
                    59985.5,
                    27005.6
                  ],
                  [
                    59864.3,
                    26989.7
                  ],
                  [
                    59852.4,
                    27087
                  ],
                  [
                    59896,
                    27099.2
                  ],
                  [
                    59838.8,
                    27364.9
                  ],
                  [
                    59919.9,
                    27892.1
                  ],
                  [
                    60119.7,
                    27863.4
                  ]
                ],
                "id": 449,
                "chat_link": "[&BMEBAAA=]"
              },
              "450": {
                "name": "Lake Carnifex",
                "level": 58,
                "coord": [
                  60375.3,
                  27120.4
                ],
                "bounds": [
                  [
                    60624.4,
                    27348.9
                  ],
                  [
                    60308,
                    27433.5
                  ],
                  [
                    59985.2,
                    27004.8
                  ],
                  [
                    60065.8,
                    26901.1
                  ],
                  [
                    60260.5,
                    27113.3
                  ],
                  [
                    60474.8,
                    27109
                  ],
                  [
                    60543.6,
                    26971.8
                  ],
                  [
                    60740.1,
                    27080.7
                  ],
                  [
                    60624.4,
                    27348.9
                  ]
                ],
                "id": 450,
                "chat_link": "[&BMIBAAA=]"
              },
              "451": {
                "name": "Victium Moors",
                "level": 60,
                "coord": [
                  60173.8,
                  26726.5
                ],
                "bounds": [
                  [
                    59983.5,
                    27010.9
                  ],
                  [
                    59899.5,
                    26999.2
                  ],
                  [
                    59875,
                    26921
                  ],
                  [
                    59887.9,
                    26595
                  ],
                  [
                    59966.7,
                    26345.3
                  ],
                  [
                    60158.3,
                    26318.5
                  ],
                  [
                    60273.6,
                    26231.3
                  ],
                  [
                    60328.2,
                    26359.8
                  ],
                  [
                    60541.5,
                    26560.8
                  ],
                  [
                    60544,
                    26971.9
                  ],
                  [
                    60474.8,
                    27110
                  ],
                  [
                    60259.9,
                    27113.2
                  ],
                  [
                    60065.9,
                    26907.8
                  ],
                  [
                    59983.5,
                    27010.9
                  ]
                ],
                "id": 451,
                "chat_link": "[&BMMBAAA=]"
              },
              "452": {
                "name": "Scorchlands",
                "level": 60,
                "coord": [
                  60042.4,
                  25977.2
                ],
                "bounds": [
                  [
                    60171.5,
                    25625.1
                  ],
                  [
                    60283.7,
                    25687.9
                  ],
                  [
                    60333.1,
                    25796.2
                  ],
                  [
                    60273.9,
                    26235
                  ],
                  [
                    60158.3,
                    26319.1
                  ],
                  [
                    59966.3,
                    26344.6
                  ],
                  [
                    59897.8,
                    26229
                  ],
                  [
                    59797.4,
                    26127.7
                  ],
                  [
                    59775,
                    25897.4
                  ],
                  [
                    59876.6,
                    25791.2
                  ],
                  [
                    59932.9,
                    25696.3
                  ],
                  [
                    60171.5,
                    25625.1
                  ]
                ],
                "id": 452,
                "chat_link": "[&BMQBAAA=]"
              },
              "453": {
                "name": "Obsidian Run",
                "level": 59,
                "coord": [
                  61230.1,
                  26473.2
                ],
                "bounds": [
                  [
                    61176.9,
                    26781.6
                  ],
                  [
                    61273.7,
                    26651.1
                  ],
                  [
                    61546,
                    26535
                  ],
                  [
                    61526.2,
                    26278.5
                  ],
                  [
                    61290.3,
                    26324.3
                  ],
                  [
                    60865.4,
                    26157.2
                  ],
                  [
                    60932.6,
                    26584.8
                  ],
                  [
                    61176.9,
                    26781.6
                  ]
                ],
                "id": 453,
                "chat_link": "[&BMUBAAA=]"
              },
              "454": {
                "name": "The Infestation",
                "level": 59,
                "coord": [
                  61307.4,
                  26061.9
                ],
                "bounds": [
                  [
                    61726.4,
                    25954.6
                  ],
                  [
                    61663.6,
                    26216.9
                  ],
                  [
                    61525.3,
                    26279
                  ],
                  [
                    61289,
                    26324.7
                  ],
                  [
                    60863.7,
                    26156.3
                  ],
                  [
                    60851.5,
                    25979.2
                  ],
                  [
                    61007.2,
                    25889.4
                  ],
                  [
                    61267.5,
                    25860.3
                  ],
                  [
                    61572.7,
                    25896.6
                  ],
                  [
                    61726.4,
                    25954.6
                  ]
                ],
                "id": 454,
                "chat_link": "[&BMYBAAA=]"
              },
              "455": {
                "name": "Harvester's Glade",
                "level": 51,
                "coord": [
                  61129.8,
                  28853.7
                ],
                "bounds": [
                  [
                    61148.9,
                    28583.6
                  ],
                  [
                    61253.1,
                    28590.6
                  ],
                  [
                    61366.7,
                    28876.3
                  ],
                  [
                    61281.8,
                    28992.6
                  ],
                  [
                    61099.7,
                    29075.5
                  ],
                  [
                    60962.6,
                    29005.3
                  ],
                  [
                    60915.4,
                    28939.3
                  ],
                  [
                    61010.3,
                    28766.8
                  ],
                  [
                    61148.9,
                    28583.6
                  ]
                ],
                "id": 455,
                "chat_link": "[&BMcBAAA=]"
              },
              "456": {
                "name": "Echoslab Arches",
                "level": 53,
                "coord": [
                  60135,
                  29755.7
                ],
                "bounds": [
                  [
                    60345,
                    29856.3
                  ],
                  [
                    60332.8,
                    29597.4
                  ],
                  [
                    60142.5,
                    29464.5
                  ],
                  [
                    59952.3,
                    29518
                  ],
                  [
                    59868.9,
                    29711.8
                  ],
                  [
                    59919.6,
                    29932.4
                  ],
                  [
                    60173.9,
                    29989.8
                  ],
                  [
                    60345.5,
                    29975.1
                  ],
                  [
                    60345,
                    29856.3
                  ]
                ],
                "id": 456,
                "chat_link": "[&BMgBAAA=]"
              },
              "457": {
                "name": "Ebbing Heart Run",
                "level": 59,
                "coord": [
                  61761.6,
                  26193.5
                ],
                "bounds": [
                  [
                    61546.5,
                    26534.7
                  ],
                  [
                    61802.1,
                    26532.2
                  ],
                  [
                    61883,
                    26305.9
                  ],
                  [
                    61936.2,
                    26173.6
                  ],
                  [
                    61928.4,
                    25975
                  ],
                  [
                    61832,
                    25844.7
                  ],
                  [
                    61737.3,
                    25877.4
                  ],
                  [
                    61664.5,
                    26218.3
                  ],
                  [
                    61524.7,
                    26279.5
                  ],
                  [
                    61546.5,
                    26534.7
                  ]
                ],
                "id": 457,
                "chat_link": "[&BMkBAAA=]"
              },
              "458": {
                "name": "Gladefall Run",
                "level": 60,
                "coord": [
                  60602,
                  26324.4
                ],
                "bounds": [
                  [
                    60273.1,
                    26233.3
                  ],
                  [
                    60327.8,
                    26363.8
                  ],
                  [
                    60541.3,
                    26560.7
                  ],
                  [
                    60542.8,
                    26972
                  ],
                  [
                    60739.8,
                    27082.3
                  ],
                  [
                    60933.3,
                    26585.3
                  ],
                  [
                    60865,
                    26157.5
                  ],
                  [
                    60851.2,
                    25958.5
                  ],
                  [
                    60721.5,
                    25905.5
                  ],
                  [
                    60492.7,
                    25896.5
                  ],
                  [
                    60333.3,
                    25852.8
                  ],
                  [
                    60273.1,
                    26233.3
                  ]
                ],
                "id": 458,
                "chat_link": "[&BMoBAAA=]"
              }
            },
            "adventures": [],
            "id": 1086,
            "mastery_points": []
          },
          "1090": {
            "name": "Langmar Estate",
            "min_level": 1,
            "max_level": 15,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "270": {
                "name": "Village of Smokestead",
                "level": 3,
                "coord": [
                  58156.3,
                  30833.9
                ],
                "bounds": [
                  [
                    57856,
                    30550.5
                  ],
                  [
                    57996.7,
                    30571
                  ],
                  [
                    58378.9,
                    30592.8
                  ],
                  [
                    58545.1,
                    30743.8
                  ],
                  [
                    58526.7,
                    30851.5
                  ],
                  [
                    58424.6,
                    31121.2
                  ],
                  [
                    58158.3,
                    31028.9
                  ],
                  [
                    58070.5,
                    31085.8
                  ],
                  [
                    57749.8,
                    31164.6
                  ],
                  [
                    57856,
                    30629.3
                  ],
                  [
                    57856,
                    30550.5
                  ]
                ],
                "id": 270,
                "chat_link": "[&BA4BAAA=]"
              },
              "271": {
                "name": "Tela Range",
                "level": 4,
                "coord": [
                  57985.5,
                  30119.3
                ],
                "bounds": [
                  [
                    57802.3,
                    30344.5
                  ],
                  [
                    57985.1,
                    30336.5
                  ],
                  [
                    58225.7,
                    30165
                  ],
                  [
                    58232.5,
                    30110.6
                  ],
                  [
                    58153.4,
                    30012.7
                  ],
                  [
                    58021.3,
                    29815.9
                  ],
                  [
                    57795.6,
                    29955.1
                  ],
                  [
                    57668.2,
                    30213.8
                  ],
                  [
                    57802.3,
                    30344.5
                  ]
                ],
                "id": 271,
                "chat_link": "[&BA8BAAA=]"
              },
              "272": {
                "name": "Victor's Presidium",
                "level": 6,
                "coord": [
                  58619.5,
                  31354.6
                ],
                "bounds": [
                  [
                    58377.7,
                    31462.3
                  ],
                  [
                    58107,
                    31444.8
                  ],
                  [
                    58067.5,
                    31084.7
                  ],
                  [
                    58154.6,
                    31026.6
                  ],
                  [
                    58424.9,
                    31119
                  ],
                  [
                    58528.8,
                    30853.1
                  ],
                  [
                    58778.9,
                    31012.2
                  ],
                  [
                    58956.4,
                    30865.6
                  ],
                  [
                    58960.7,
                    31165.8
                  ],
                  [
                    59145.5,
                    31508.3
                  ],
                  [
                    59152.1,
                    31641.5
                  ],
                  [
                    59030.3,
                    31713.5
                  ],
                  [
                    58675.4,
                    31650.2
                  ],
                  [
                    58573.1,
                    31815.7
                  ],
                  [
                    58477,
                    31779.6
                  ],
                  [
                    58501.8,
                    31530
                  ],
                  [
                    58377.7,
                    31462.3
                  ]
                ],
                "id": 272,
                "chat_link": "[&BBABAAA=]"
              },
              "273": {
                "name": "Lake Feritas",
                "level": 5,
                "coord": [
                  58714.1,
                  30124.2
                ],
                "bounds": [
                  [
                    58961.2,
                    30433.2
                  ],
                  [
                    59149.5,
                    30224.9
                  ],
                  [
                    58926.3,
                    30089.1
                  ],
                  [
                    58821.3,
                    29908.7
                  ],
                  [
                    58622.6,
                    29930.8
                  ],
                  [
                    58466.7,
                    29814.3
                  ],
                  [
                    58351.4,
                    29933.1
                  ],
                  [
                    58466.9,
                    30121.5
                  ],
                  [
                    58626.4,
                    30199
                  ],
                  [
                    58748.8,
                    30587.3
                  ],
                  [
                    58961.2,
                    30433.2
                  ]
                ],
                "id": 273,
                "chat_link": "[&BBEBAAA=]"
              },
              "274": {
                "name": "Old Duke's Estate",
                "level": 6,
                "coord": [
                  58786.2,
                  30721.7
                ],
                "bounds": [
                  [
                    58780.2,
                    31015.2
                  ],
                  [
                    58526.3,
                    30852.5
                  ],
                  [
                    58543.1,
                    30742.7
                  ],
                  [
                    58748,
                    30587
                  ],
                  [
                    58960.9,
                    30433.3
                  ],
                  [
                    59158.8,
                    30699.4
                  ],
                  [
                    58780.2,
                    31015.2
                  ]
                ],
                "id": 274,
                "chat_link": "[&BBIBAAA=]"
              },
              "275": {
                "name": "Decimus Stones",
                "level": 7,
                "coord": [
                  58311.8,
                  31605.8
                ],
                "bounds": [
                  [
                    58105.3,
                    31758
                  ],
                  [
                    58287.2,
                    31766.5
                  ],
                  [
                    58491.2,
                    31678.8
                  ],
                  [
                    58499,
                    31527.7
                  ],
                  [
                    58381,
                    31461.2
                  ],
                  [
                    58107.3,
                    31442.4
                  ],
                  [
                    58105.3,
                    31758
                  ]
                ],
                "id": 275,
                "chat_link": "[&BBMBAAA=]"
              },
              "276": {
                "name": "Charr's Triumph",
                "level": 8,
                "coord": [
                  59352.1,
                  31140.9
                ],
                "bounds": [
                  [
                    59776,
                    31147.4
                  ],
                  [
                    59708.5,
                    30981.9
                  ],
                  [
                    59186.8,
                    30702.1
                  ],
                  [
                    58984.7,
                    30868.8
                  ],
                  [
                    58987.7,
                    31167.6
                  ],
                  [
                    59173.9,
                    31511.9
                  ],
                  [
                    59488.5,
                    31461.5
                  ],
                  [
                    59510.7,
                    31286.2
                  ],
                  [
                    59776,
                    31147.4
                  ]
                ],
                "id": 276,
                "chat_link": "[&BBQBAAA=]"
              },
              "277": {
                "name": "Martyr's Woods",
                "level": 7,
                "coord": [
                  59590,
                  30474.5
                ],
                "bounds": [
                  [
                    59560.1,
                    30894.6
                  ],
                  [
                    59675.6,
                    30968.6
                  ],
                  [
                    59690.2,
                    30862
                  ],
                  [
                    59791.4,
                    30755.1
                  ],
                  [
                    59841.6,
                    30697.2
                  ],
                  [
                    59923.6,
                    30631.9
                  ],
                  [
                    60012.8,
                    30625.2
                  ],
                  [
                    60015.7,
                    30511
                  ],
                  [
                    59960.6,
                    30423.9
                  ],
                  [
                    59972.9,
                    30374.3
                  ],
                  [
                    59902.5,
                    30279.9
                  ],
                  [
                    59716.5,
                    30309.4
                  ],
                  [
                    59512,
                    30254.2
                  ],
                  [
                    59422,
                    30134.8
                  ],
                  [
                    59317.8,
                    30001
                  ],
                  [
                    59074.2,
                    30119.8
                  ],
                  [
                    59157.5,
                    30232.6
                  ],
                  [
                    59078,
                    30274.2
                  ],
                  [
                    59005.9,
                    30466.7
                  ],
                  [
                    59169.3,
                    30673.2
                  ],
                  [
                    59560.1,
                    30894.6
                  ]
                ],
                "id": 277,
                "chat_link": "[&BBUBAAA=]"
              },
              "278": {
                "name": "Ashford Forum",
                "level": 9,
                "coord": [
                  59745.5,
                  31407.1
                ],
                "bounds": [
                  [
                    59649.1,
                    31596.6
                  ],
                  [
                    59917.3,
                    31638.5
                  ],
                  [
                    60067.2,
                    31518.5
                  ],
                  [
                    59901,
                    31208.4
                  ],
                  [
                    59747.3,
                    31144.2
                  ],
                  [
                    59478.6,
                    31284.4
                  ],
                  [
                    59458,
                    31459.4
                  ],
                  [
                    59649.1,
                    31596.6
                  ]
                ],
                "id": 278,
                "chat_link": "[&BBYBAAA=]"
              },
              "279": {
                "name": "Lake Adorea",
                "level": 11,
                "coord": [
                  59592.8,
                  31705.8
                ],
                "bounds": [
                  [
                    59313.5,
                    31972.8
                  ],
                  [
                    59547.6,
                    31870.2
                  ],
                  [
                    59677,
                    31959.9
                  ],
                  [
                    59922.2,
                    31764.2
                  ],
                  [
                    60097.2,
                    31751.6
                  ],
                  [
                    60179.8,
                    31641.9
                  ],
                  [
                    60163.1,
                    31435
                  ],
                  [
                    59917.8,
                    31635.1
                  ],
                  [
                    59648.8,
                    31597.8
                  ],
                  [
                    59457.8,
                    31458.4
                  ],
                  [
                    59144.4,
                    31509
                  ],
                  [
                    59151.8,
                    31641.1
                  ],
                  [
                    59031.2,
                    31712.8
                  ],
                  [
                    59046.9,
                    31931.7
                  ],
                  [
                    59313.5,
                    31972.8
                  ]
                ],
                "id": 279,
                "chat_link": "[&BBcBAAA=]"
              },
              "280": {
                "name": "Devast District",
                "level": 10,
                "coord": [
                  60088.4,
                  30958.3
                ],
                "bounds": [
                  [
                    60162.1,
                    31435.7
                  ],
                  [
                    60312.4,
                    31323.5
                  ],
                  [
                    60386,
                    31100.6
                  ],
                  [
                    60581.8,
                    30907.5
                  ],
                  [
                    60453.8,
                    30759.5
                  ],
                  [
                    60333.2,
                    30734.4
                  ],
                  [
                    60099.5,
                    30677.9
                  ],
                  [
                    60012.7,
                    30620.1
                  ],
                  [
                    59921.3,
                    30628.9
                  ],
                  [
                    59841.7,
                    30691.9
                  ],
                  [
                    59686.2,
                    30861.1
                  ],
                  [
                    59672.6,
                    30983.1
                  ],
                  [
                    59900.2,
                    30926.3
                  ],
                  [
                    59897.9,
                    31205.3
                  ],
                  [
                    60065.1,
                    31517.9
                  ],
                  [
                    60162.1,
                    31435.7
                  ]
                ],
                "id": 280,
                "chat_link": "[&BBgBAAA=]"
              },
              "281": {
                "name": "Windrock Maze",
                "level": 12,
                "coord": [
                  60391.9,
                  31581.3
                ],
                "bounds": [
                  [
                    60180.3,
                    31642.1
                  ],
                  [
                    60161.7,
                    31435.4
                  ],
                  [
                    60315.7,
                    31322
                  ],
                  [
                    60466.2,
                    31377.5
                  ],
                  [
                    60666.9,
                    31649.1
                  ],
                  [
                    60541.7,
                    31790.9
                  ],
                  [
                    60411.3,
                    31851.8
                  ],
                  [
                    60180.3,
                    31642.1
                  ]
                ],
                "id": 281,
                "chat_link": "[&BBkBAAA=]"
              },
              "282": {
                "name": "Ascalon Basin",
                "level": 12,
                "coord": [
                  61215.8,
                  31531.5
                ],
                "bounds": [
                  [
                    60666,
                    31652.3
                  ],
                  [
                    60982.6,
                    31591.5
                  ],
                  [
                    61296.3,
                    31773.7
                  ],
                  [
                    61458.5,
                    31781.3
                  ],
                  [
                    61619.4,
                    31898.9
                  ],
                  [
                    61603.1,
                    32053.5
                  ],
                  [
                    61680.8,
                    32143
                  ],
                  [
                    61800.4,
                    32266.6
                  ],
                  [
                    62020.7,
                    31978.7
                  ],
                  [
                    62040.4,
                    31882.4
                  ],
                  [
                    61961.6,
                    31505.5
                  ],
                  [
                    61442.9,
                    31466.1
                  ],
                  [
                    61175.9,
                    31065.4
                  ],
                  [
                    61051.7,
                    31086
                  ],
                  [
                    60870.2,
                    30981.4
                  ],
                  [
                    60845.5,
                    30844.8
                  ],
                  [
                    60643.1,
                    30846.8
                  ],
                  [
                    60386,
                    31101.2
                  ],
                  [
                    60307.5,
                    31326.2
                  ],
                  [
                    60462.6,
                    31384.5
                  ],
                  [
                    60666,
                    31652.3
                  ]
                ],
                "id": 282,
                "chat_link": "[&BBoBAAA=]"
              },
              "283": {
                "name": "Phasmatis Corridor",
                "level": 13,
                "coord": [
                  60438.8,
                  30569.8
                ],
                "bounds": [
                  [
                    60640.3,
                    30858.9
                  ],
                  [
                    60582.4,
                    30915.2
                  ],
                  [
                    60450.9,
                    30771.6
                  ],
                  [
                    60096.5,
                    30681
                  ],
                  [
                    60122.2,
                    30628.4
                  ],
                  [
                    60142.1,
                    30578.6
                  ],
                  [
                    60145.5,
                    30519.8
                  ],
                  [
                    60090.6,
                    30365.1
                  ],
                  [
                    60196,
                    30311.9
                  ],
                  [
                    60368.2,
                    30355.2
                  ],
                  [
                    60478.5,
                    30343.4
                  ],
                  [
                    60716.8,
                    30224.2
                  ],
                  [
                    60700.7,
                    30400.6
                  ],
                  [
                    61009.4,
                    30738.8
                  ],
                  [
                    60842.4,
                    30854.7
                  ],
                  [
                    60640.3,
                    30858.9
                  ]
                ],
                "id": 283,
                "chat_link": "[&BBsBAAA=]"
              },
              "284": {
                "name": "The Toppled Wall",
                "level": 15,
                "coord": [
                  60142.8,
                  30218.1
                ],
                "bounds": [
                  [
                    60354.2,
                    30371.4
                  ],
                  [
                    60193.5,
                    30317.5
                  ],
                  [
                    60097.7,
                    30365.9
                  ],
                  [
                    60026.4,
                    30339.2
                  ],
                  [
                    59975.4,
                    30373.9
                  ],
                  [
                    59901.2,
                    30285.7
                  ],
                  [
                    59716.3,
                    30311.3
                  ],
                  [
                    59514.5,
                    30264.8
                  ],
                  [
                    59300.1,
                    29999.9
                  ],
                  [
                    60307.3,
                    29873.5
                  ],
                  [
                    60734.6,
                    29939
                  ],
                  [
                    60712.1,
                    30002.8
                  ],
                  [
                    60702.9,
                    30248.4
                  ],
                  [
                    60463.8,
                    30359.8
                  ],
                  [
                    60354.2,
                    30371.4
                  ]
                ],
                "id": 284,
                "chat_link": "[&BBwBAAA=]"
              },
              "285": {
                "name": "Lamia Mire",
                "level": 11,
                "coord": [
                  61089.9,
                  30885.5
                ],
                "bounds": [
                  [
                    61009.7,
                    30727.9
                  ],
                  [
                    61300.9,
                    30664.1
                  ],
                  [
                    61380.3,
                    30824.2
                  ],
                  [
                    61174.3,
                    31068.5
                  ],
                  [
                    61050.9,
                    31087.3
                  ],
                  [
                    60868.5,
                    30981.8
                  ],
                  [
                    60844.7,
                    30845
                  ],
                  [
                    61009.7,
                    30727.9
                  ]
                ],
                "id": 285,
                "chat_link": "[&BB0BAAA=]"
              },
              "286": {
                "name": "Loreclaw Expanse",
                "level": 11,
                "coord": [
                  61133.9,
                  31833.1
                ],
                "bounds": [
                  [
                    60541.3,
                    31790.3
                  ],
                  [
                    60666.8,
                    31648.9
                  ],
                  [
                    60981,
                    31590.2
                  ],
                  [
                    61303.5,
                    31774.6
                  ],
                  [
                    61462.3,
                    31777.7
                  ],
                  [
                    61624.9,
                    31894.9
                  ],
                  [
                    61608.9,
                    32048.5
                  ],
                  [
                    61163.5,
                    32020.7
                  ],
                  [
                    60853,
                    31952
                  ],
                  [
                    60541.3,
                    31790.3
                  ]
                ],
                "id": 286,
                "chat_link": "[&BB4BAAA=]"
              },
              "287": {
                "name": "Cadem Forest",
                "level": 13,
                "coord": [
                  61649.7,
                  30878.2
                ],
                "bounds": [
                  [
                    61175.7,
                    31066.7
                  ],
                  [
                    61382.4,
                    30824.6
                  ],
                  [
                    61302.4,
                    30665.2
                  ],
                  [
                    61292.9,
                    30588.2
                  ],
                  [
                    61470,
                    30418.9
                  ],
                  [
                    61659,
                    30457.1
                  ],
                  [
                    61934.2,
                    30370.9
                  ],
                  [
                    61939.4,
                    30675.2
                  ],
                  [
                    62008.4,
                    30866.8
                  ],
                  [
                    61943.6,
                    31211.3
                  ],
                  [
                    61956.3,
                    31299.2
                  ],
                  [
                    61939.3,
                    31504.9
                  ],
                  [
                    61442.5,
                    31467.4
                  ],
                  [
                    61175.7,
                    31066.7
                  ]
                ],
                "id": 287,
                "chat_link": "[&BB8BAAA=]"
              },
              "288": {
                "name": "Gunbreach Hills",
                "level": 3,
                "coord": [
                  58277,
                  30394.2
                ],
                "bounds": [
                  [
                    57811.7,
                    30326.9
                  ],
                  [
                    57985.1,
                    30336.6
                  ],
                  [
                    58139.5,
                    30216.8
                  ],
                  [
                    58197.3,
                    30260
                  ],
                  [
                    58466.1,
                    30120
                  ],
                  [
                    58627.1,
                    30196.5
                  ],
                  [
                    58748.3,
                    30586.6
                  ],
                  [
                    58543.3,
                    30743.6
                  ],
                  [
                    58379.7,
                    30589.3
                  ],
                  [
                    57871.7,
                    30565.2
                  ],
                  [
                    57811.7,
                    30326.9
                  ]
                ],
                "id": 288,
                "chat_link": "[&BCABAAA=]"
              },
              "289": {
                "name": "Ascalon City Ruins",
                "level": 14,
                "coord": [
                  61034.8,
                  30253.6
                ],
                "bounds": [
                  [
                    61011.7,
                    30731.4
                  ],
                  [
                    60697,
                    30393
                  ],
                  [
                    60723.5,
                    30048.4
                  ],
                  [
                    60727.4,
                    29978.6
                  ],
                  [
                    60743.3,
                    29921.7
                  ],
                  [
                    60963.8,
                    29895.4
                  ],
                  [
                    61426,
                    29892.3
                  ],
                  [
                    61466,
                    30421.3
                  ],
                  [
                    61289.4,
                    30588.3
                  ],
                  [
                    61300,
                    30665.6
                  ],
                  [
                    61011.7,
                    30731.4
                  ]
                ],
                "id": 289,
                "chat_link": "[&BCEBAAA=]"
              },
              "290": {
                "name": "Devourer's Mouth",
                "level": 3,
                "coord": [
                  58268,
                  30086
                ],
                "bounds": [
                  [
                    58467.2,
                    30120.9
                  ],
                  [
                    58200.9,
                    30259.5
                  ],
                  [
                    58140.9,
                    30220.5
                  ],
                  [
                    58229.3,
                    30157
                  ],
                  [
                    58229.8,
                    30114.4
                  ],
                  [
                    58152.3,
                    30016.7
                  ],
                  [
                    58208.3,
                    29891.4
                  ],
                  [
                    58368.6,
                    29949.9
                  ],
                  [
                    58414.6,
                    30043.9
                  ],
                  [
                    58467.2,
                    30120.9
                  ]
                ],
                "id": 290,
                "chat_link": "[&BCIBAAA=]"
              },
              "291": {
                "name": "Abbey Ruins",
                "level": 10,
                "coord": [
                  59808.3,
                  31063.9
                ],
                "bounds": [
                  [
                    59905.1,
                    30919.6
                  ],
                  [
                    59679.5,
                    30979.2
                  ],
                  [
                    59748.7,
                    31146.6
                  ],
                  [
                    59900.1,
                    31210.1
                  ],
                  [
                    59905.1,
                    30919.6
                  ]
                ],
                "id": 291,
                "chat_link": "[&BCMBAAA=]"
              },
              "292": {
                "name": "Agnos Gorge",
                "level": 15,
                "coord": [
                  60059.9,
                  30492.4
                ],
                "bounds": [
                  [
                    60015.7,
                    30543.8
                  ],
                  [
                    60000.2,
                    30494
                  ],
                  [
                    59953.9,
                    30423.6
                  ],
                  [
                    59971,
                    30374
                  ],
                  [
                    60017.9,
                    30334.5
                  ],
                  [
                    60099.9,
                    30364.6
                  ],
                  [
                    60111.6,
                    30418.3
                  ],
                  [
                    60148.1,
                    30515.3
                  ],
                  [
                    60147.1,
                    30549.7
                  ],
                  [
                    60145.2,
                    30581.8
                  ],
                  [
                    60102.4,
                    30680.4
                  ],
                  [
                    60005.7,
                    30628.6
                  ],
                  [
                    60015.7,
                    30543.8
                  ]
                ],
                "id": 292,
                "chat_link": "[&BCQBAAA=]"
              },
              "293": {
                "name": "Human's Lament",
                "level": 14,
                "coord": [
                  61730.5,
                  30125.3
                ],
                "bounds": [
                  [
                    61438.6,
                    30135.4
                  ],
                  [
                    61423.9,
                    29896.1
                  ],
                  [
                    61598.6,
                    29922.2
                  ],
                  [
                    61700.4,
                    29837.9
                  ],
                  [
                    61921.9,
                    29893.1
                  ],
                  [
                    62009.2,
                    29994.1
                  ],
                  [
                    61936.7,
                    30165.6
                  ],
                  [
                    61949.6,
                    30275
                  ],
                  [
                    61935.4,
                    30378.1
                  ],
                  [
                    61656,
                    30460.7
                  ],
                  [
                    61465.6,
                    30420.5
                  ],
                  [
                    61438.6,
                    30135.4
                  ]
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              },
              "567": {
                "name": "Facula Castrum",
                "level": 5,
                "coord": [
                  59121.5,
                  30024
                ],
                "bounds": [
                  [
                    59147.3,
                    30224.4
                  ],
                  [
                    59228.4,
                    30179.7
                  ],
                  [
                    59307.6,
                    30007.8
                  ],
                  [
                    59351.6,
                    29908.2
                  ],
                  [
                    59078.3,
                    29853.8
                  ],
                  [
                    58817.2,
                    29908.1
                  ],
                  [
                    58920.3,
                    30085.8
                  ],
                  [
                    59147.3,
                    30224.4
                  ]
                ],
                "id": 567,
                "chat_link": "[&BDcCAAA=]"
              },
              "1104": {
                "name": "Langmar Estate",
                "level": 15,
                "coord": [
                  58219.9,
                  31645.5
                ],
                "bounds": [
                  [
                    58484.8,
                    31778.8
                  ],
                  [
                    58575,
                    31811.5
                  ],
                  [
                    58489.1,
                    32027.1
                  ],
                  [
                    57798.1,
                    31991.6
                  ],
                  [
                    57779,
                    31145.6
                  ],
                  [
                    58072,
                    31078.3
                  ],
                  [
                    58112.6,
                    31438.4
                  ],
                  [
                    58110.3,
                    31754.6
                  ],
                  [
                    58287.9,
                    31762.2
                  ],
                  [
                    58490.1,
                    31666.8
                  ],
                  [
                    58484.8,
                    31778.8
                  ]
                ],
                "id": 1104,
                "chat_link": "[&BFAEAAA=]"
              }
            },
            "id": 1090,
            "mastery_points": [],
            "adventures": []
          },
          "1091": {
            "name": "Save Our Supplies",
            "min_level": 50,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              60928,
              27904
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                59904,
                25856
              ],
              [
                61952,
                29952
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "433": {
                "name": "Champion's Shield",
                "level": 54,
                "coord": [
                  60464.9,
                  29077.8
                ],
                "bounds": [
                  [
                    59906.5,
                    29535.9
                  ],
                  [
                    60142.4,
                    29465.2
                  ],
                  [
                    60332.5,
                    29597.5
                  ],
                  [
                    60589.6,
                    29543.2
                  ],
                  [
                    60718.4,
                    29291.3
                  ],
                  [
                    60835.9,
                    29115.6
                  ],
                  [
                    61091.2,
                    29074.5
                  ],
                  [
                    60957.3,
                    29006.4
                  ],
                  [
                    60913.8,
                    28942.5
                  ],
                  [
                    61002.8,
                    28761.8
                  ],
                  [
                    60951.1,
                    28708.4
                  ],
                  [
                    60683.9,
                    28904.1
                  ],
                  [
                    60427.7,
                    28910
                  ],
                  [
                    60185.8,
                    28739.6
                  ],
                  [
                    60010,
                    28837
                  ],
                  [
                    59916.2,
                    28765.3
                  ],
                  [
                    59857.7,
                    28954.8
                  ],
                  [
                    59845.2,
                    29247.4
                  ],
                  [
                    59906.5,
                    29535.9
                  ]
                ],
                "id": 433,
                "chat_link": "[&BLEBAAA=]"
              },
              "434": {
                "name": "Stonesheath Overlook",
                "level": 52,
                "coord": [
                  60716.9,
                  29831.6
                ],
                "bounds": [
                  [
                    60590,
                    29542.5
                  ],
                  [
                    60789.9,
                    29653.4
                  ],
                  [
                    60847,
                    29766
                  ],
                  [
                    61007.3,
                    29781.6
                  ],
                  [
                    61022.8,
                    29864.7
                  ],
                  [
                    61004.8,
                    30017.5
                  ],
                  [
                    60894.1,
                    30007.1
                  ],
                  [
                    60882.6,
                    29951
                  ],
                  [
                    60546.7,
                    29973.3
                  ],
                  [
                    60340.5,
                    29968.3
                  ],
                  [
                    60344.7,
                    29856.1
                  ],
                  [
                    60332.8,
                    29597.5
                  ],
                  [
                    60590,
                    29542.5
                  ]
                ],
                "id": 434,
                "chat_link": "[&BLIBAAA=]"
              },
              "435": {
                "name": "Ironhead Lake",
                "level": 53,
                "coord": [
                  60996,
                  29461.3
                ],
                "bounds": [
                  [
                    60590.1,
                    29543.3
                  ],
                  [
                    60717.6,
                    29291.3
                  ],
                  [
                    60841.1,
                    29124.2
                  ],
                  [
                    61093.5,
                    29078
                  ],
                  [
                    61068.2,
                    29273.4
                  ],
                  [
                    61217.3,
                    29440.5
                  ],
                  [
                    61345.6,
                    29440.3
                  ],
                  [
                    61300.9,
                    29540.5
                  ],
                  [
                    61133.8,
                    29602.9
                  ],
                  [
                    61006.7,
                    29782.2
                  ],
                  [
                    60847.3,
                    29765.4
                  ],
                  [
                    60789.4,
                    29654
                  ],
                  [
                    60590.1,
                    29543.3
                  ]
                ],
                "id": 435,
                "chat_link": "[&BLMBAAA=]"
              },
              "436": {
                "name": "Bloodfin Lake",
                "level": 51,
                "coord": [
                  61404.3,
                  29650.5
                ],
                "bounds": [
                  [
                    61022.8,
                    29864.5
                  ],
                  [
                    61004.7,
                    29985.7
                  ],
                  [
                    61350.3,
                    29943.7
                  ],
                  [
                    61760.3,
                    29939.8
                  ],
                  [
                    61940.2,
                    29782.8
                  ],
                  [
                    61910.7,
                    29321.9
                  ],
                  [
                    61623.8,
                    29354.3
                  ],
                  [
                    61450.5,
                    29244
                  ],
                  [
                    61345,
                    29444.2
                  ],
                  [
                    61301.4,
                    29542.6
                  ],
                  [
                    61134,
                    29601.3
                  ],
                  [
                    61007.8,
                    29781.6
                  ],
                  [
                    61022.8,
                    29864.5
                  ]
                ],
                "id": 436,
                "chat_link": "[&BLQBAAA=]"
              },
              "437": {
                "name": "Hellion Forest",
                "level": 50,
                "coord": [
                  61648.8,
                  28968.5
                ],
                "bounds": [
                  [
                    61910.6,
                    29321.8
                  ],
                  [
                    61931.3,
                    29157
                  ],
                  [
                    61883.4,
                    28921.1
                  ],
                  [
                    61948.3,
                    28935.3
                  ],
                  [
                    61942.7,
                    28820.8
                  ],
                  [
                    61845.8,
                    28768.9
                  ],
                  [
                    61552.7,
                    28703.4
                  ],
                  [
                    61535.9,
                    28658.7
                  ],
                  [
                    61334.8,
                    28784.4
                  ],
                  [
                    61369.3,
                    28879.6
                  ],
                  [
                    61280.9,
                    28993.9
                  ],
                  [
                    61472.2,
                    29014.5
                  ],
                  [
                    61450.3,
                    29243.6
                  ],
                  [
                    61624.8,
                    29356.3
                  ],
                  [
                    61910.6,
                    29321.8
                  ]
                ],
                "id": 437,
                "chat_link": "[&BLUBAAA=]"
              },
              "438": {
                "name": "Sunken Halls of Clarent",
                "level": 52,
                "coord": [
                  61277.8,
                  29213.2
                ],
                "bounds": [
                  [
                    61347.8,
                    29439.2
                  ],
                  [
                    61448.9,
                    29243.7
                  ],
                  [
                    61473,
                    29014
                  ],
                  [
                    61281.3,
                    28993.9
                  ],
                  [
                    61099.6,
                    29081
                  ],
                  [
                    61072.4,
                    29280.6
                  ],
                  [
                    61221.9,
                    29440.1
                  ],
                  [
                    61347.8,
                    29439.2
                  ]
                ],
                "id": 438,
                "chat_link": "[&BLYBAAA=]"
              },
              "439": {
                "name": "Monger's Sink",
                "level": 55,
                "coord": [
                  60560.7,
                  28563.1
                ],
                "bounds": [
                  [
                    60189.3,
                    28428.1
                  ],
                  [
                    60011.7,
                    28232.8
                  ],
                  [
                    60764,
                    28201
                  ],
                  [
                    60892.6,
                    28405.2
                  ],
                  [
                    60939.4,
                    28542
                  ],
                  [
                    60951.9,
                    28705.5
                  ],
                  [
                    60684.6,
                    28903.9
                  ],
                  [
                    60427.8,
                    28910.6
                  ],
                  [
                    60184.9,
                    28738.9
                  ],
                  [
                    60189.3,
                    28428.1
                  ]
                ],
                "id": 439,
                "chat_link": "[&BLcBAAA=]"
              },
              "440": {
                "name": "Scourgejaw's Vault",
                "level": 55,
                "coord": [
                  60036.3,
                  28558.1
                ],
                "bounds": [
                  [
                    60011.6,
                    28232.4
                  ],
                  [
                    60189.3,
                    28428.5
                  ],
                  [
                    60184.8,
                    28740.4
                  ],
                  [
                    60010,
                    28836.8
                  ],
                  [
                    59913,
                    28767.2
                  ],
                  [
                    59909,
                    28343.1
                  ],
                  [
                    60011.6,
                    28232.4
                  ]
                ],
                "id": 440,
                "chat_link": "[&BLgBAAA=]"
              },
              "441": {
                "name": "Soldier Mesa",
                "level": 56,
                "coord": [
                  60336.1,
                  27971.7
                ],
                "bounds": [
                  [
                    60342.5,
                    27696.9
                  ],
                  [
                    60462,
                    27843.7
                  ],
                  [
                    60730.2,
                    27835.2
                  ],
                  [
                    60827.7,
                    28010.1
                  ],
                  [
                    60762.2,
                    28202
                  ],
                  [
                    60009.8,
                    28235.3
                  ],
                  [
                    59853.3,
                    28177.5
                  ],
                  [
                    59917,
                    27885.5
                  ],
                  [
                    60120,
                    27858.8
                  ],
                  [
                    60342.5,
                    27696.9
                  ]
                ],
                "id": 441,
                "chat_link": "[&BLkBAAA=]"
              },
              "442": {
                "name": "Viper's Run",
                "level": 56,
                "coord": [
                  61057.5,
                  27950.7
                ],
                "bounds": [
                  [
                    60828.5,
                    28010
                  ],
                  [
                    60763.3,
                    28203.4
                  ],
                  [
                    60892.7,
                    28404.1
                  ],
                  [
                    60990,
                    28252
                  ],
                  [
                    61402.5,
                    28275.4
                  ],
                  [
                    61394.3,
                    28145.3
                  ],
                  [
                    61386.3,
                    27995.3
                  ],
                  [
                    61254.2,
                    27819.5
                  ],
                  [
                    61295,
                    27411.4
                  ],
                  [
                    60876.2,
                    27384.1
                  ],
                  [
                    60877.3,
                    27671.1
                  ],
                  [
                    60730.3,
                    27836.5
                  ],
                  [
                    60828.5,
                    28010
                  ]
                ],
                "id": 442,
                "chat_link": "[&BLoBAAA=]"
              },
              "443": {
                "name": "Lamprey Grottoes",
                "level": 56,
                "coord": [
                  61114.6,
                  28502.6
                ],
                "bounds": [
                  [
                    60990.4,
                    28252.6
                  ],
                  [
                    61401.3,
                    28274.3
                  ],
                  [
                    61445.5,
                    28409.8
                  ],
                  [
                    61254.6,
                    28584.5
                  ],
                  [
                    61146.7,
                    28580.1
                  ],
                  [
                    61006.6,
                    28765.4
                  ],
                  [
                    60955.8,
                    28710.1
                  ],
                  [
                    60939,
                    28542.5
                  ],
                  [
                    60891.7,
                    28403.9
                  ],
                  [
                    60990.4,
                    28252.6
                  ]
                ],
                "id": 443,
                "chat_link": "[&BLsBAAA=]"
              },
              "444": {
                "name": "Southshore Wastes",
                "level": 56,
                "coord": [
                  61648,
                  28463.3
                ],
                "bounds": [
                  [
                    61401.6,
                    28274
                  ],
                  [
                    61394.3,
                    28143.1
                  ],
                  [
                    61636.2,
                    28231.1
                  ],
                  [
                    61896.8,
                    28115.8
                  ],
                  [
                    62035.8,
                    28179.6
                  ],
                  [
                    62144.2,
                    28346.9
                  ],
                  [
                    61940.4,
                    28819.5
                  ],
                  [
                    61846.6,
                    28769.4
                  ],
                  [
                    61552.8,
                    28704.4
                  ],
                  [
                    61537.9,
                    28654.9
                  ],
                  [
                    61334.2,
                    28778.5
                  ],
                  [
                    61258.9,
                    28597.7
                  ],
                  [
                    61444,
                    28408
                  ],
                  [
                    61401.6,
                    28274
                  ]
                ],
                "id": 444,
                "chat_link": "[&BLwBAAA=]"
              },
              "445": {
                "name": "Lake Desolann",
                "level": 57,
                "coord": [
                  61677.4,
                  27859.6
                ],
                "bounds": [
                  [
                    61253.5,
                    27818.9
                  ],
                  [
                    61294.7,
                    27411
                  ],
                  [
                    61940.3,
                    27258.2
                  ],
                  [
                    61902.2,
                    27625.6
                  ],
                  [
                    62035.8,
                    27815.3
                  ],
                  [
                    62034.7,
                    28180
                  ],
                  [
                    61896.5,
                    28116.2
                  ],
                  [
                    61636.1,
                    28231.5
                  ],
                  [
                    61394.5,
                    28143.2
                  ],
                  [
                    61386,
                    27995.9
                  ],
                  [
                    61253.5,
                    27818.9
                  ]
                ],
                "id": 445,
                "chat_link": "[&BL0BAAA=]"
              },
              "446": {
                "name": "Crystalwept Groves",
                "level": 58,
                "coord": [
                  61545.3,
                  26843.5
                ],
                "bounds": [
                  [
                    61294.3,
                    27411.6
                  ],
                  [
                    61851.2,
                    27282.6
                  ],
                  [
                    61872.8,
                    26710.5
                  ],
                  [
                    61802,
                    26532
                  ],
                  [
                    61546.5,
                    26534.2
                  ],
                  [
                    61273.5,
                    26651.4
                  ],
                  [
                    61177.1,
                    26782
                  ],
                  [
                    61294.3,
                    27411.6
                  ]
                ],
                "id": 446,
                "chat_link": "[&BL4BAAA=]"
              },
              "447": {
                "name": "The Granite Front",
                "level": 58,
                "coord": [
                  61004.1,
                  27049.1
                ],
                "bounds": [
                  [
                    60876.1,
                    27385
                  ],
                  [
                    61295.3,
                    27411.9
                  ],
                  [
                    61177.9,
                    26781.8
                  ],
                  [
                    60932.1,
                    26584.9
                  ],
                  [
                    60739.2,
                    27082.1
                  ],
                  [
                    60876.1,
                    27385
                  ]
                ],
                "id": 447,
                "chat_link": "[&BL8BAAA=]"
              },
              "448": {
                "name": "Glory's Steps",
                "level": 57,
                "coord": [
                  60620.1,
                  27536.7
                ],
                "bounds": [
                  [
                    60308.2,
                    27433.8
                  ],
                  [
                    60624.5,
                    27348.8
                  ],
                  [
                    60739.3,
                    27080.1
                  ],
                  [
                    60876.6,
                    27384.6
                  ],
                  [
                    60877.8,
                    27671.5
                  ],
                  [
                    60730.3,
                    27835.7
                  ],
                  [
                    60462,
                    27843.3
                  ],
                  [
                    60342,
                    27696.3
                  ],
                  [
                    60308.2,
                    27433.8
                  ]
                ],
                "id": 448,
                "chat_link": "[&BMABAAA=]"
              },
              "449": {
                "name": "Western Bulwark",
                "level": 57,
                "coord": [
                  60014.2,
                  27381.5
                ],
                "bounds": [
                  [
                    60119.7,
                    27863.4
                  ],
                  [
                    60342.2,
                    27698
                  ],
                  [
                    60309.1,
                    27433.6
                  ],
                  [
                    59985.5,
                    27005.6
                  ],
                  [
                    59864.3,
                    26989.7
                  ],
                  [
                    59852.4,
                    27087
                  ],
                  [
                    59896,
                    27099.2
                  ],
                  [
                    59838.8,
                    27364.9
                  ],
                  [
                    59919.9,
                    27892.1
                  ],
                  [
                    60119.7,
                    27863.4
                  ]
                ],
                "id": 449,
                "chat_link": "[&BMEBAAA=]"
              },
              "450": {
                "name": "Lake Carnifex",
                "level": 58,
                "coord": [
                  60375.3,
                  27120.4
                ],
                "bounds": [
                  [
                    60624.4,
                    27348.9
                  ],
                  [
                    60308,
                    27433.5
                  ],
                  [
                    59985.2,
                    27004.8
                  ],
                  [
                    60065.8,
                    26901.1
                  ],
                  [
                    60260.5,
                    27113.3
                  ],
                  [
                    60474.8,
                    27109
                  ],
                  [
                    60543.6,
                    26971.8
                  ],
                  [
                    60740.1,
                    27080.7
                  ],
                  [
                    60624.4,
                    27348.9
                  ]
                ],
                "id": 450,
                "chat_link": "[&BMIBAAA=]"
              },
              "451": {
                "name": "Victium Moors",
                "level": 60,
                "coord": [
                  60173.8,
                  26726.5
                ],
                "bounds": [
                  [
                    59983.5,
                    27010.9
                  ],
                  [
                    59899.5,
                    26999.2
                  ],
                  [
                    59875,
                    26921
                  ],
                  [
                    59887.9,
                    26595
                  ],
                  [
                    59966.7,
                    26345.3
                  ],
                  [
                    60158.3,
                    26318.5
                  ],
                  [
                    60273.6,
                    26231.3
                  ],
                  [
                    60328.2,
                    26359.8
                  ],
                  [
                    60541.5,
                    26560.8
                  ],
                  [
                    60544,
                    26971.9
                  ],
                  [
                    60474.8,
                    27110
                  ],
                  [
                    60259.9,
                    27113.2
                  ],
                  [
                    60065.9,
                    26907.8
                  ],
                  [
                    59983.5,
                    27010.9
                  ]
                ],
                "id": 451,
                "chat_link": "[&BMMBAAA=]"
              },
              "452": {
                "name": "Scorchlands",
                "level": 60,
                "coord": [
                  60042.4,
                  25977.2
                ],
                "bounds": [
                  [
                    60171.5,
                    25625.1
                  ],
                  [
                    60283.7,
                    25687.9
                  ],
                  [
                    60333.1,
                    25796.2
                  ],
                  [
                    60273.9,
                    26235
                  ],
                  [
                    60158.3,
                    26319.1
                  ],
                  [
                    59966.3,
                    26344.6
                  ],
                  [
                    59897.8,
                    26229
                  ],
                  [
                    59797.4,
                    26127.7
                  ],
                  [
                    59775,
                    25897.4
                  ],
                  [
                    59876.6,
                    25791.2
                  ],
                  [
                    59932.9,
                    25696.3
                  ],
                  [
                    60171.5,
                    25625.1
                  ]
                ],
                "id": 452,
                "chat_link": "[&BMQBAAA=]"
              },
              "453": {
                "name": "Obsidian Run",
                "level": 59,
                "coord": [
                  61230.1,
                  26473.2
                ],
                "bounds": [
                  [
                    61176.9,
                    26781.6
                  ],
                  [
                    61273.7,
                    26651.1
                  ],
                  [
                    61546,
                    26535
                  ],
                  [
                    61526.2,
                    26278.5
                  ],
                  [
                    61290.3,
                    26324.3
                  ],
                  [
                    60865.4,
                    26157.2
                  ],
                  [
                    60932.6,
                    26584.8
                  ],
                  [
                    61176.9,
                    26781.6
                  ]
                ],
                "id": 453,
                "chat_link": "[&BMUBAAA=]"
              },
              "454": {
                "name": "The Infestation",
                "level": 59,
                "coord": [
                  61307.4,
                  26061.9
                ],
                "bounds": [
                  [
                    61726.4,
                    25954.6
                  ],
                  [
                    61663.6,
                    26216.9
                  ],
                  [
                    61525.3,
                    26279
                  ],
                  [
                    61289,
                    26324.7
                  ],
                  [
                    60863.7,
                    26156.3
                  ],
                  [
                    60851.5,
                    25979.2
                  ],
                  [
                    61007.2,
                    25889.4
                  ],
                  [
                    61267.5,
                    25860.3
                  ],
                  [
                    61572.7,
                    25896.6
                  ],
                  [
                    61726.4,
                    25954.6
                  ]
                ],
                "id": 454,
                "chat_link": "[&BMYBAAA=]"
              },
              "455": {
                "name": "Harvester's Glade",
                "level": 51,
                "coord": [
                  61129.8,
                  28853.7
                ],
                "bounds": [
                  [
                    61148.9,
                    28583.6
                  ],
                  [
                    61253.1,
                    28590.6
                  ],
                  [
                    61366.7,
                    28876.3
                  ],
                  [
                    61281.8,
                    28992.6
                  ],
                  [
                    61099.7,
                    29075.5
                  ],
                  [
                    60962.6,
                    29005.3
                  ],
                  [
                    60915.4,
                    28939.3
                  ],
                  [
                    61010.3,
                    28766.8
                  ],
                  [
                    61148.9,
                    28583.6
                  ]
                ],
                "id": 455,
                "chat_link": "[&BMcBAAA=]"
              },
              "456": {
                "name": "Echoslab Arches",
                "level": 53,
                "coord": [
                  60135,
                  29755.7
                ],
                "bounds": [
                  [
                    60345,
                    29856.3
                  ],
                  [
                    60332.8,
                    29597.4
                  ],
                  [
                    60142.5,
                    29464.5
                  ],
                  [
                    59952.3,
                    29518
                  ],
                  [
                    59868.9,
                    29711.8
                  ],
                  [
                    59919.6,
                    29932.4
                  ],
                  [
                    60173.9,
                    29989.8
                  ],
                  [
                    60345.5,
                    29975.1
                  ],
                  [
                    60345,
                    29856.3
                  ]
                ],
                "id": 456,
                "chat_link": "[&BMgBAAA=]"
              },
              "457": {
                "name": "Ebbing Heart Run",
                "level": 59,
                "coord": [
                  61761.6,
                  26193.5
                ],
                "bounds": [
                  [
                    61546.5,
                    26534.7
                  ],
                  [
                    61802.1,
                    26532.2
                  ],
                  [
                    61883,
                    26305.9
                  ],
                  [
                    61936.2,
                    26173.6
                  ],
                  [
                    61928.4,
                    25975
                  ],
                  [
                    61832,
                    25844.7
                  ],
                  [
                    61737.3,
                    25877.4
                  ],
                  [
                    61664.5,
                    26218.3
                  ],
                  [
                    61524.7,
                    26279.5
                  ],
                  [
                    61546.5,
                    26534.7
                  ]
                ],
                "id": 457,
                "chat_link": "[&BMkBAAA=]"
              },
              "458": {
                "name": "Gladefall Run",
                "level": 60,
                "coord": [
                  60602,
                  26324.4
                ],
                "bounds": [
                  [
                    60273.1,
                    26233.3
                  ],
                  [
                    60327.8,
                    26363.8
                  ],
                  [
                    60541.3,
                    26560.7
                  ],
                  [
                    60542.8,
                    26972
                  ],
                  [
                    60739.8,
                    27082.3
                  ],
                  [
                    60933.3,
                    26585.3
                  ],
                  [
                    60865,
                    26157.5
                  ],
                  [
                    60851.2,
                    25958.5
                  ],
                  [
                    60721.5,
                    25905.5
                  ],
                  [
                    60492.7,
                    25896.5
                  ],
                  [
                    60333.3,
                    25852.8
                  ],
                  [
                    60273.1,
                    26233.3
                  ]
                ],
                "id": 458,
                "chat_link": "[&BMoBAAA=]"
              }
            },
            "id": 1091,
            "mastery_points": [],
            "adventures": []
          },
          "1094": {
            "name": "Save Our Supplies",
            "min_level": 50,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              60928,
              27904
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                59904,
                25856
              ],
              [
                61952,
                29952
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "433": {
                "name": "Champion's Shield",
                "level": 54,
                "coord": [
                  60464.9,
                  29077.8
                ],
                "bounds": [
                  [
                    59906.5,
                    29535.9
                  ],
                  [
                    60142.4,
                    29465.2
                  ],
                  [
                    60332.5,
                    29597.5
                  ],
                  [
                    60589.6,
                    29543.2
                  ],
                  [
                    60718.4,
                    29291.3
                  ],
                  [
                    60835.9,
                    29115.6
                  ],
                  [
                    61091.2,
                    29074.5
                  ],
                  [
                    60957.3,
                    29006.4
                  ],
                  [
                    60913.8,
                    28942.5
                  ],
                  [
                    61002.8,
                    28761.8
                  ],
                  [
                    60951.1,
                    28708.4
                  ],
                  [
                    60683.9,
                    28904.1
                  ],
                  [
                    60427.7,
                    28910
                  ],
                  [
                    60185.8,
                    28739.6
                  ],
                  [
                    60010,
                    28837
                  ],
                  [
                    59916.2,
                    28765.3
                  ],
                  [
                    59857.7,
                    28954.8
                  ],
                  [
                    59845.2,
                    29247.4
                  ],
                  [
                    59906.5,
                    29535.9
                  ]
                ],
                "id": 433,
                "chat_link": "[&BLEBAAA=]"
              },
              "434": {
                "name": "Stonesheath Overlook",
                "level": 52,
                "coord": [
                  60716.9,
                  29831.6
                ],
                "bounds": [
                  [
                    60590,
                    29542.5
                  ],
                  [
                    60789.9,
                    29653.4
                  ],
                  [
                    60847,
                    29766
                  ],
                  [
                    61007.3,
                    29781.6
                  ],
                  [
                    61022.8,
                    29864.7
                  ],
                  [
                    61004.8,
                    30017.5
                  ],
                  [
                    60894.1,
                    30007.1
                  ],
                  [
                    60882.6,
                    29951
                  ],
                  [
                    60546.7,
                    29973.3
                  ],
                  [
                    60340.5,
                    29968.3
                  ],
                  [
                    60344.7,
                    29856.1
                  ],
                  [
                    60332.8,
                    29597.5
                  ],
                  [
                    60590,
                    29542.5
                  ]
                ],
                "id": 434,
                "chat_link": "[&BLIBAAA=]"
              },
              "435": {
                "name": "Ironhead Lake",
                "level": 53,
                "coord": [
                  60996,
                  29461.3
                ],
                "bounds": [
                  [
                    60590.1,
                    29543.3
                  ],
                  [
                    60717.6,
                    29291.3
                  ],
                  [
                    60841.1,
                    29124.2
                  ],
                  [
                    61093.5,
                    29078
                  ],
                  [
                    61068.2,
                    29273.4
                  ],
                  [
                    61217.3,
                    29440.5
                  ],
                  [
                    61345.6,
                    29440.3
                  ],
                  [
                    61300.9,
                    29540.5
                  ],
                  [
                    61133.8,
                    29602.9
                  ],
                  [
                    61006.7,
                    29782.2
                  ],
                  [
                    60847.3,
                    29765.4
                  ],
                  [
                    60789.4,
                    29654
                  ],
                  [
                    60590.1,
                    29543.3
                  ]
                ],
                "id": 435,
                "chat_link": "[&BLMBAAA=]"
              },
              "436": {
                "name": "Bloodfin Lake",
                "level": 51,
                "coord": [
                  61404.3,
                  29650.5
                ],
                "bounds": [
                  [
                    61022.8,
                    29864.5
                  ],
                  [
                    61004.7,
                    29985.7
                  ],
                  [
                    61350.3,
                    29943.7
                  ],
                  [
                    61760.3,
                    29939.8
                  ],
                  [
                    61940.2,
                    29782.8
                  ],
                  [
                    61910.7,
                    29321.9
                  ],
                  [
                    61623.8,
                    29354.3
                  ],
                  [
                    61450.5,
                    29244
                  ],
                  [
                    61345,
                    29444.2
                  ],
                  [
                    61301.4,
                    29542.6
                  ],
                  [
                    61134,
                    29601.3
                  ],
                  [
                    61007.8,
                    29781.6
                  ],
                  [
                    61022.8,
                    29864.5
                  ]
                ],
                "id": 436,
                "chat_link": "[&BLQBAAA=]"
              },
              "437": {
                "name": "Hellion Forest",
                "level": 50,
                "coord": [
                  61648.8,
                  28968.5
                ],
                "bounds": [
                  [
                    61910.6,
                    29321.8
                  ],
                  [
                    61931.3,
                    29157
                  ],
                  [
                    61883.4,
                    28921.1
                  ],
                  [
                    61948.3,
                    28935.3
                  ],
                  [
                    61942.7,
                    28820.8
                  ],
                  [
                    61845.8,
                    28768.9
                  ],
                  [
                    61552.7,
                    28703.4
                  ],
                  [
                    61535.9,
                    28658.7
                  ],
                  [
                    61334.8,
                    28784.4
                  ],
                  [
                    61369.3,
                    28879.6
                  ],
                  [
                    61280.9,
                    28993.9
                  ],
                  [
                    61472.2,
                    29014.5
                  ],
                  [
                    61450.3,
                    29243.6
                  ],
                  [
                    61624.8,
                    29356.3
                  ],
                  [
                    61910.6,
                    29321.8
                  ]
                ],
                "id": 437,
                "chat_link": "[&BLUBAAA=]"
              },
              "438": {
                "name": "Sunken Halls of Clarent",
                "level": 52,
                "coord": [
                  61277.8,
                  29213.2
                ],
                "bounds": [
                  [
                    61347.8,
                    29439.2
                  ],
                  [
                    61448.9,
                    29243.7
                  ],
                  [
                    61473,
                    29014
                  ],
                  [
                    61281.3,
                    28993.9
                  ],
                  [
                    61099.6,
                    29081
                  ],
                  [
                    61072.4,
                    29280.6
                  ],
                  [
                    61221.9,
                    29440.1
                  ],
                  [
                    61347.8,
                    29439.2
                  ]
                ],
                "id": 438,
                "chat_link": "[&BLYBAAA=]"
              },
              "439": {
                "name": "Monger's Sink",
                "level": 55,
                "coord": [
                  60560.7,
                  28563.1
                ],
                "bounds": [
                  [
                    60189.3,
                    28428.1
                  ],
                  [
                    60011.7,
                    28232.8
                  ],
                  [
                    60764,
                    28201
                  ],
                  [
                    60892.6,
                    28405.2
                  ],
                  [
                    60939.4,
                    28542
                  ],
                  [
                    60951.9,
                    28705.5
                  ],
                  [
                    60684.6,
                    28903.9
                  ],
                  [
                    60427.8,
                    28910.6
                  ],
                  [
                    60184.9,
                    28738.9
                  ],
                  [
                    60189.3,
                    28428.1
                  ]
                ],
                "id": 439,
                "chat_link": "[&BLcBAAA=]"
              },
              "440": {
                "name": "Scourgejaw's Vault",
                "level": 55,
                "coord": [
                  60036.3,
                  28558.1
                ],
                "bounds": [
                  [
                    60011.6,
                    28232.4
                  ],
                  [
                    60189.3,
                    28428.5
                  ],
                  [
                    60184.8,
                    28740.4
                  ],
                  [
                    60010,
                    28836.8
                  ],
                  [
                    59913,
                    28767.2
                  ],
                  [
                    59909,
                    28343.1
                  ],
                  [
                    60011.6,
                    28232.4
                  ]
                ],
                "id": 440,
                "chat_link": "[&BLgBAAA=]"
              },
              "441": {
                "name": "Soldier Mesa",
                "level": 56,
                "coord": [
                  60336.1,
                  27971.7
                ],
                "bounds": [
                  [
                    60342.5,
                    27696.9
                  ],
                  [
                    60462,
                    27843.7
                  ],
                  [
                    60730.2,
                    27835.2
                  ],
                  [
                    60827.7,
                    28010.1
                  ],
                  [
                    60762.2,
                    28202
                  ],
                  [
                    60009.8,
                    28235.3
                  ],
                  [
                    59853.3,
                    28177.5
                  ],
                  [
                    59917,
                    27885.5
                  ],
                  [
                    60120,
                    27858.8
                  ],
                  [
                    60342.5,
                    27696.9
                  ]
                ],
                "id": 441,
                "chat_link": "[&BLkBAAA=]"
              },
              "442": {
                "name": "Viper's Run",
                "level": 56,
                "coord": [
                  61057.5,
                  27950.7
                ],
                "bounds": [
                  [
                    60828.5,
                    28010
                  ],
                  [
                    60763.3,
                    28203.4
                  ],
                  [
                    60892.7,
                    28404.1
                  ],
                  [
                    60990,
                    28252
                  ],
                  [
                    61402.5,
                    28275.4
                  ],
                  [
                    61394.3,
                    28145.3
                  ],
                  [
                    61386.3,
                    27995.3
                  ],
                  [
                    61254.2,
                    27819.5
                  ],
                  [
                    61295,
                    27411.4
                  ],
                  [
                    60876.2,
                    27384.1
                  ],
                  [
                    60877.3,
                    27671.1
                  ],
                  [
                    60730.3,
                    27836.5
                  ],
                  [
                    60828.5,
                    28010
                  ]
                ],
                "id": 442,
                "chat_link": "[&BLoBAAA=]"
              },
              "443": {
                "name": "Lamprey Grottoes",
                "level": 56,
                "coord": [
                  61114.6,
                  28502.6
                ],
                "bounds": [
                  [
                    60990.4,
                    28252.6
                  ],
                  [
                    61401.3,
                    28274.3
                  ],
                  [
                    61445.5,
                    28409.8
                  ],
                  [
                    61254.6,
                    28584.5
                  ],
                  [
                    61146.7,
                    28580.1
                  ],
                  [
                    61006.6,
                    28765.4
                  ],
                  [
                    60955.8,
                    28710.1
                  ],
                  [
                    60939,
                    28542.5
                  ],
                  [
                    60891.7,
                    28403.9
                  ],
                  [
                    60990.4,
                    28252.6
                  ]
                ],
                "id": 443,
                "chat_link": "[&BLsBAAA=]"
              },
              "444": {
                "name": "Southshore Wastes",
                "level": 56,
                "coord": [
                  61648,
                  28463.3
                ],
                "bounds": [
                  [
                    61401.6,
                    28274
                  ],
                  [
                    61394.3,
                    28143.1
                  ],
                  [
                    61636.2,
                    28231.1
                  ],
                  [
                    61896.8,
                    28115.8
                  ],
                  [
                    62035.8,
                    28179.6
                  ],
                  [
                    62144.2,
                    28346.9
                  ],
                  [
                    61940.4,
                    28819.5
                  ],
                  [
                    61846.6,
                    28769.4
                  ],
                  [
                    61552.8,
                    28704.4
                  ],
                  [
                    61537.9,
                    28654.9
                  ],
                  [
                    61334.2,
                    28778.5
                  ],
                  [
                    61258.9,
                    28597.7
                  ],
                  [
                    61444,
                    28408
                  ],
                  [
                    61401.6,
                    28274
                  ]
                ],
                "id": 444,
                "chat_link": "[&BLwBAAA=]"
              },
              "445": {
                "name": "Lake Desolann",
                "level": 57,
                "coord": [
                  61677.4,
                  27859.6
                ],
                "bounds": [
                  [
                    61253.5,
                    27818.9
                  ],
                  [
                    61294.7,
                    27411
                  ],
                  [
                    61940.3,
                    27258.2
                  ],
                  [
                    61902.2,
                    27625.6
                  ],
                  [
                    62035.8,
                    27815.3
                  ],
                  [
                    62034.7,
                    28180
                  ],
                  [
                    61896.5,
                    28116.2
                  ],
                  [
                    61636.1,
                    28231.5
                  ],
                  [
                    61394.5,
                    28143.2
                  ],
                  [
                    61386,
                    27995.9
                  ],
                  [
                    61253.5,
                    27818.9
                  ]
                ],
                "id": 445,
                "chat_link": "[&BL0BAAA=]"
              },
              "446": {
                "name": "Crystalwept Groves",
                "level": 58,
                "coord": [
                  61545.3,
                  26843.5
                ],
                "bounds": [
                  [
                    61294.3,
                    27411.6
                  ],
                  [
                    61851.2,
                    27282.6
                  ],
                  [
                    61872.8,
                    26710.5
                  ],
                  [
                    61802,
                    26532
                  ],
                  [
                    61546.5,
                    26534.2
                  ],
                  [
                    61273.5,
                    26651.4
                  ],
                  [
                    61177.1,
                    26782
                  ],
                  [
                    61294.3,
                    27411.6
                  ]
                ],
                "id": 446,
                "chat_link": "[&BL4BAAA=]"
              },
              "447": {
                "name": "The Granite Front",
                "level": 58,
                "coord": [
                  61004.1,
                  27049.1
                ],
                "bounds": [
                  [
                    60876.1,
                    27385
                  ],
                  [
                    61295.3,
                    27411.9
                  ],
                  [
                    61177.9,
                    26781.8
                  ],
                  [
                    60932.1,
                    26584.9
                  ],
                  [
                    60739.2,
                    27082.1
                  ],
                  [
                    60876.1,
                    27385
                  ]
                ],
                "id": 447,
                "chat_link": "[&BL8BAAA=]"
              },
              "448": {
                "name": "Glory's Steps",
                "level": 57,
                "coord": [
                  60620.1,
                  27536.7
                ],
                "bounds": [
                  [
                    60308.2,
                    27433.8
                  ],
                  [
                    60624.5,
                    27348.8
                  ],
                  [
                    60739.3,
                    27080.1
                  ],
                  [
                    60876.6,
                    27384.6
                  ],
                  [
                    60877.8,
                    27671.5
                  ],
                  [
                    60730.3,
                    27835.7
                  ],
                  [
                    60462,
                    27843.3
                  ],
                  [
                    60342,
                    27696.3
                  ],
                  [
                    60308.2,
                    27433.8
                  ]
                ],
                "id": 448,
                "chat_link": "[&BMABAAA=]"
              },
              "449": {
                "name": "Western Bulwark",
                "level": 57,
                "coord": [
                  60014.2,
                  27381.5
                ],
                "bounds": [
                  [
                    60119.7,
                    27863.4
                  ],
                  [
                    60342.2,
                    27698
                  ],
                  [
                    60309.1,
                    27433.6
                  ],
                  [
                    59985.5,
                    27005.6
                  ],
                  [
                    59864.3,
                    26989.7
                  ],
                  [
                    59852.4,
                    27087
                  ],
                  [
                    59896,
                    27099.2
                  ],
                  [
                    59838.8,
                    27364.9
                  ],
                  [
                    59919.9,
                    27892.1
                  ],
                  [
                    60119.7,
                    27863.4
                  ]
                ],
                "id": 449,
                "chat_link": "[&BMEBAAA=]"
              },
              "450": {
                "name": "Lake Carnifex",
                "level": 58,
                "coord": [
                  60375.3,
                  27120.4
                ],
                "bounds": [
                  [
                    60624.4,
                    27348.9
                  ],
                  [
                    60308,
                    27433.5
                  ],
                  [
                    59985.2,
                    27004.8
                  ],
                  [
                    60065.8,
                    26901.1
                  ],
                  [
                    60260.5,
                    27113.3
                  ],
                  [
                    60474.8,
                    27109
                  ],
                  [
                    60543.6,
                    26971.8
                  ],
                  [
                    60740.1,
                    27080.7
                  ],
                  [
                    60624.4,
                    27348.9
                  ]
                ],
                "id": 450,
                "chat_link": "[&BMIBAAA=]"
              },
              "451": {
                "name": "Victium Moors",
                "level": 60,
                "coord": [
                  60173.8,
                  26726.5
                ],
                "bounds": [
                  [
                    59983.5,
                    27010.9
                  ],
                  [
                    59899.5,
                    26999.2
                  ],
                  [
                    59875,
                    26921
                  ],
                  [
                    59887.9,
                    26595
                  ],
                  [
                    59966.7,
                    26345.3
                  ],
                  [
                    60158.3,
                    26318.5
                  ],
                  [
                    60273.6,
                    26231.3
                  ],
                  [
                    60328.2,
                    26359.8
                  ],
                  [
                    60541.5,
                    26560.8
                  ],
                  [
                    60544,
                    26971.9
                  ],
                  [
                    60474.8,
                    27110
                  ],
                  [
                    60259.9,
                    27113.2
                  ],
                  [
                    60065.9,
                    26907.8
                  ],
                  [
                    59983.5,
                    27010.9
                  ]
                ],
                "id": 451,
                "chat_link": "[&BMMBAAA=]"
              },
              "452": {
                "name": "Scorchlands",
                "level": 60,
                "coord": [
                  60042.4,
                  25977.2
                ],
                "bounds": [
                  [
                    60171.5,
                    25625.1
                  ],
                  [
                    60283.7,
                    25687.9
                  ],
                  [
                    60333.1,
                    25796.2
                  ],
                  [
                    60273.9,
                    26235
                  ],
                  [
                    60158.3,
                    26319.1
                  ],
                  [
                    59966.3,
                    26344.6
                  ],
                  [
                    59897.8,
                    26229
                  ],
                  [
                    59797.4,
                    26127.7
                  ],
                  [
                    59775,
                    25897.4
                  ],
                  [
                    59876.6,
                    25791.2
                  ],
                  [
                    59932.9,
                    25696.3
                  ],
                  [
                    60171.5,
                    25625.1
                  ]
                ],
                "id": 452,
                "chat_link": "[&BMQBAAA=]"
              },
              "453": {
                "name": "Obsidian Run",
                "level": 59,
                "coord": [
                  61230.1,
                  26473.2
                ],
                "bounds": [
                  [
                    61176.9,
                    26781.6
                  ],
                  [
                    61273.7,
                    26651.1
                  ],
                  [
                    61546,
                    26535
                  ],
                  [
                    61526.2,
                    26278.5
                  ],
                  [
                    61290.3,
                    26324.3
                  ],
                  [
                    60865.4,
                    26157.2
                  ],
                  [
                    60932.6,
                    26584.8
                  ],
                  [
                    61176.9,
                    26781.6
                  ]
                ],
                "id": 453,
                "chat_link": "[&BMUBAAA=]"
              },
              "454": {
                "name": "The Infestation",
                "level": 59,
                "coord": [
                  61307.4,
                  26061.9
                ],
                "bounds": [
                  [
                    61726.4,
                    25954.6
                  ],
                  [
                    61663.6,
                    26216.9
                  ],
                  [
                    61525.3,
                    26279
                  ],
                  [
                    61289,
                    26324.7
                  ],
                  [
                    60863.7,
                    26156.3
                  ],
                  [
                    60851.5,
                    25979.2
                  ],
                  [
                    61007.2,
                    25889.4
                  ],
                  [
                    61267.5,
                    25860.3
                  ],
                  [
                    61572.7,
                    25896.6
                  ],
                  [
                    61726.4,
                    25954.6
                  ]
                ],
                "id": 454,
                "chat_link": "[&BMYBAAA=]"
              },
              "455": {
                "name": "Harvester's Glade",
                "level": 51,
                "coord": [
                  61129.8,
                  28853.7
                ],
                "bounds": [
                  [
                    61148.9,
                    28583.6
                  ],
                  [
                    61253.1,
                    28590.6
                  ],
                  [
                    61366.7,
                    28876.3
                  ],
                  [
                    61281.8,
                    28992.6
                  ],
                  [
                    61099.7,
                    29075.5
                  ],
                  [
                    60962.6,
                    29005.3
                  ],
                  [
                    60915.4,
                    28939.3
                  ],
                  [
                    61010.3,
                    28766.8
                  ],
                  [
                    61148.9,
                    28583.6
                  ]
                ],
                "id": 455,
                "chat_link": "[&BMcBAAA=]"
              },
              "456": {
                "name": "Echoslab Arches",
                "level": 53,
                "coord": [
                  60135,
                  29755.7
                ],
                "bounds": [
                  [
                    60345,
                    29856.3
                  ],
                  [
                    60332.8,
                    29597.4
                  ],
                  [
                    60142.5,
                    29464.5
                  ],
                  [
                    59952.3,
                    29518
                  ],
                  [
                    59868.9,
                    29711.8
                  ],
                  [
                    59919.6,
                    29932.4
                  ],
                  [
                    60173.9,
                    29989.8
                  ],
                  [
                    60345.5,
                    29975.1
                  ],
                  [
                    60345,
                    29856.3
                  ]
                ],
                "id": 456,
                "chat_link": "[&BMgBAAA=]"
              },
              "457": {
                "name": "Ebbing Heart Run",
                "level": 59,
                "coord": [
                  61761.6,
                  26193.5
                ],
                "bounds": [
                  [
                    61546.5,
                    26534.7
                  ],
                  [
                    61802.1,
                    26532.2
                  ],
                  [
                    61883,
                    26305.9
                  ],
                  [
                    61936.2,
                    26173.6
                  ],
                  [
                    61928.4,
                    25975
                  ],
                  [
                    61832,
                    25844.7
                  ],
                  [
                    61737.3,
                    25877.4
                  ],
                  [
                    61664.5,
                    26218.3
                  ],
                  [
                    61524.7,
                    26279.5
                  ],
                  [
                    61546.5,
                    26534.7
                  ]
                ],
                "id": 457,
                "chat_link": "[&BMkBAAA=]"
              },
              "458": {
                "name": "Gladefall Run",
                "level": 60,
                "coord": [
                  60602,
                  26324.4
                ],
                "bounds": [
                  [
                    60273.1,
                    26233.3
                  ],
                  [
                    60327.8,
                    26363.8
                  ],
                  [
                    60541.3,
                    26560.7
                  ],
                  [
                    60542.8,
                    26972
                  ],
                  [
                    60739.8,
                    27082.3
                  ],
                  [
                    60933.3,
                    26585.3
                  ],
                  [
                    60865,
                    26157.5
                  ],
                  [
                    60851.2,
                    25958.5
                  ],
                  [
                    60721.5,
                    25905.5
                  ],
                  [
                    60492.7,
                    25896.5
                  ],
                  [
                    60333.3,
                    25852.8
                  ],
                  [
                    60273.1,
                    26233.3
                  ]
                ],
                "id": 458,
                "chat_link": "[&BMoBAAA=]"
              }
            },
            "id": 1094,
            "mastery_points": [],
            "adventures": []
          },
          "1105": {
            "name": "Langmar Estate",
            "min_level": 1,
            "max_level": 15,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "270": {
                "name": "Village of Smokestead",
                "level": 3,
                "coord": [
                  58156.3,
                  30833.9
                ],
                "bounds": [
                  [
                    57856,
                    30550.5
                  ],
                  [
                    57996.7,
                    30571
                  ],
                  [
                    58378.9,
                    30592.8
                  ],
                  [
                    58545.1,
                    30743.8
                  ],
                  [
                    58526.7,
                    30851.5
                  ],
                  [
                    58424.6,
                    31121.2
                  ],
                  [
                    58158.3,
                    31028.9
                  ],
                  [
                    58070.5,
                    31085.8
                  ],
                  [
                    57749.8,
                    31164.6
                  ],
                  [
                    57856,
                    30629.3
                  ],
                  [
                    57856,
                    30550.5
                  ]
                ],
                "id": 270,
                "chat_link": "[&BA4BAAA=]"
              },
              "271": {
                "name": "Tela Range",
                "level": 4,
                "coord": [
                  57985.5,
                  30119.3
                ],
                "bounds": [
                  [
                    57802.3,
                    30344.5
                  ],
                  [
                    57985.1,
                    30336.5
                  ],
                  [
                    58225.7,
                    30165
                  ],
                  [
                    58232.5,
                    30110.6
                  ],
                  [
                    58153.4,
                    30012.7
                  ],
                  [
                    58021.3,
                    29815.9
                  ],
                  [
                    57795.6,
                    29955.1
                  ],
                  [
                    57668.2,
                    30213.8
                  ],
                  [
                    57802.3,
                    30344.5
                  ]
                ],
                "id": 271,
                "chat_link": "[&BA8BAAA=]"
              },
              "272": {
                "name": "Victor's Presidium",
                "level": 6,
                "coord": [
                  58619.5,
                  31354.6
                ],
                "bounds": [
                  [
                    58377.7,
                    31462.3
                  ],
                  [
                    58107,
                    31444.8
                  ],
                  [
                    58067.5,
                    31084.7
                  ],
                  [
                    58154.6,
                    31026.6
                  ],
                  [
                    58424.9,
                    31119
                  ],
                  [
                    58528.8,
                    30853.1
                  ],
                  [
                    58778.9,
                    31012.2
                  ],
                  [
                    58956.4,
                    30865.6
                  ],
                  [
                    58960.7,
                    31165.8
                  ],
                  [
                    59145.5,
                    31508.3
                  ],
                  [
                    59152.1,
                    31641.5
                  ],
                  [
                    59030.3,
                    31713.5
                  ],
                  [
                    58675.4,
                    31650.2
                  ],
                  [
                    58573.1,
                    31815.7
                  ],
                  [
                    58477,
                    31779.6
                  ],
                  [
                    58501.8,
                    31530
                  ],
                  [
                    58377.7,
                    31462.3
                  ]
                ],
                "id": 272,
                "chat_link": "[&BBABAAA=]"
              },
              "273": {
                "name": "Lake Feritas",
                "level": 5,
                "coord": [
                  58714.1,
                  30124.2
                ],
                "bounds": [
                  [
                    58961.2,
                    30433.2
                  ],
                  [
                    59149.5,
                    30224.9
                  ],
                  [
                    58926.3,
                    30089.1
                  ],
                  [
                    58821.3,
                    29908.7
                  ],
                  [
                    58622.6,
                    29930.8
                  ],
                  [
                    58466.7,
                    29814.3
                  ],
                  [
                    58351.4,
                    29933.1
                  ],
                  [
                    58466.9,
                    30121.5
                  ],
                  [
                    58626.4,
                    30199
                  ],
                  [
                    58748.8,
                    30587.3
                  ],
                  [
                    58961.2,
                    30433.2
                  ]
                ],
                "id": 273,
                "chat_link": "[&BBEBAAA=]"
              },
              "274": {
                "name": "Old Duke's Estate",
                "level": 6,
                "coord": [
                  58786.2,
                  30721.7
                ],
                "bounds": [
                  [
                    58780.2,
                    31015.2
                  ],
                  [
                    58526.3,
                    30852.5
                  ],
                  [
                    58543.1,
                    30742.7
                  ],
                  [
                    58748,
                    30587
                  ],
                  [
                    58960.9,
                    30433.3
                  ],
                  [
                    59158.8,
                    30699.4
                  ],
                  [
                    58780.2,
                    31015.2
                  ]
                ],
                "id": 274,
                "chat_link": "[&BBIBAAA=]"
              },
              "275": {
                "name": "Decimus Stones",
                "level": 7,
                "coord": [
                  58311.8,
                  31605.8
                ],
                "bounds": [
                  [
                    58105.3,
                    31758
                  ],
                  [
                    58287.2,
                    31766.5
                  ],
                  [
                    58491.2,
                    31678.8
                  ],
                  [
                    58499,
                    31527.7
                  ],
                  [
                    58381,
                    31461.2
                  ],
                  [
                    58107.3,
                    31442.4
                  ],
                  [
                    58105.3,
                    31758
                  ]
                ],
                "id": 275,
                "chat_link": "[&BBMBAAA=]"
              },
              "276": {
                "name": "Charr's Triumph",
                "level": 8,
                "coord": [
                  59352.1,
                  31140.9
                ],
                "bounds": [
                  [
                    59776,
                    31147.4
                  ],
                  [
                    59708.5,
                    30981.9
                  ],
                  [
                    59186.8,
                    30702.1
                  ],
                  [
                    58984.7,
                    30868.8
                  ],
                  [
                    58987.7,
                    31167.6
                  ],
                  [
                    59173.9,
                    31511.9
                  ],
                  [
                    59488.5,
                    31461.5
                  ],
                  [
                    59510.7,
                    31286.2
                  ],
                  [
                    59776,
                    31147.4
                  ]
                ],
                "id": 276,
                "chat_link": "[&BBQBAAA=]"
              },
              "277": {
                "name": "Martyr's Woods",
                "level": 7,
                "coord": [
                  59590,
                  30474.5
                ],
                "bounds": [
                  [
                    59560.1,
                    30894.6
                  ],
                  [
                    59675.6,
                    30968.6
                  ],
                  [
                    59690.2,
                    30862
                  ],
                  [
                    59791.4,
                    30755.1
                  ],
                  [
                    59841.6,
                    30697.2
                  ],
                  [
                    59923.6,
                    30631.9
                  ],
                  [
                    60012.8,
                    30625.2
                  ],
                  [
                    60015.7,
                    30511
                  ],
                  [
                    59960.6,
                    30423.9
                  ],
                  [
                    59972.9,
                    30374.3
                  ],
                  [
                    59902.5,
                    30279.9
                  ],
                  [
                    59716.5,
                    30309.4
                  ],
                  [
                    59512,
                    30254.2
                  ],
                  [
                    59422,
                    30134.8
                  ],
                  [
                    59317.8,
                    30001
                  ],
                  [
                    59074.2,
                    30119.8
                  ],
                  [
                    59157.5,
                    30232.6
                  ],
                  [
                    59078,
                    30274.2
                  ],
                  [
                    59005.9,
                    30466.7
                  ],
                  [
                    59169.3,
                    30673.2
                  ],
                  [
                    59560.1,
                    30894.6
                  ]
                ],
                "id": 277,
                "chat_link": "[&BBUBAAA=]"
              },
              "278": {
                "name": "Ashford Forum",
                "level": 9,
                "coord": [
                  59745.5,
                  31407.1
                ],
                "bounds": [
                  [
                    59649.1,
                    31596.6
                  ],
                  [
                    59917.3,
                    31638.5
                  ],
                  [
                    60067.2,
                    31518.5
                  ],
                  [
                    59901,
                    31208.4
                  ],
                  [
                    59747.3,
                    31144.2
                  ],
                  [
                    59478.6,
                    31284.4
                  ],
                  [
                    59458,
                    31459.4
                  ],
                  [
                    59649.1,
                    31596.6
                  ]
                ],
                "id": 278,
                "chat_link": "[&BBYBAAA=]"
              },
              "279": {
                "name": "Lake Adorea",
                "level": 11,
                "coord": [
                  59592.8,
                  31705.8
                ],
                "bounds": [
                  [
                    59313.5,
                    31972.8
                  ],
                  [
                    59547.6,
                    31870.2
                  ],
                  [
                    59677,
                    31959.9
                  ],
                  [
                    59922.2,
                    31764.2
                  ],
                  [
                    60097.2,
                    31751.6
                  ],
                  [
                    60179.8,
                    31641.9
                  ],
                  [
                    60163.1,
                    31435
                  ],
                  [
                    59917.8,
                    31635.1
                  ],
                  [
                    59648.8,
                    31597.8
                  ],
                  [
                    59457.8,
                    31458.4
                  ],
                  [
                    59144.4,
                    31509
                  ],
                  [
                    59151.8,
                    31641.1
                  ],
                  [
                    59031.2,
                    31712.8
                  ],
                  [
                    59046.9,
                    31931.7
                  ],
                  [
                    59313.5,
                    31972.8
                  ]
                ],
                "id": 279,
                "chat_link": "[&BBcBAAA=]"
              },
              "280": {
                "name": "Devast District",
                "level": 10,
                "coord": [
                  60088.4,
                  30958.3
                ],
                "bounds": [
                  [
                    60162.1,
                    31435.7
                  ],
                  [
                    60312.4,
                    31323.5
                  ],
                  [
                    60386,
                    31100.6
                  ],
                  [
                    60581.8,
                    30907.5
                  ],
                  [
                    60453.8,
                    30759.5
                  ],
                  [
                    60333.2,
                    30734.4
                  ],
                  [
                    60099.5,
                    30677.9
                  ],
                  [
                    60012.7,
                    30620.1
                  ],
                  [
                    59921.3,
                    30628.9
                  ],
                  [
                    59841.7,
                    30691.9
                  ],
                  [
                    59686.2,
                    30861.1
                  ],
                  [
                    59672.6,
                    30983.1
                  ],
                  [
                    59900.2,
                    30926.3
                  ],
                  [
                    59897.9,
                    31205.3
                  ],
                  [
                    60065.1,
                    31517.9
                  ],
                  [
                    60162.1,
                    31435.7
                  ]
                ],
                "id": 280,
                "chat_link": "[&BBgBAAA=]"
              },
              "281": {
                "name": "Windrock Maze",
                "level": 12,
                "coord": [
                  60391.9,
                  31581.3
                ],
                "bounds": [
                  [
                    60180.3,
                    31642.1
                  ],
                  [
                    60161.7,
                    31435.4
                  ],
                  [
                    60315.7,
                    31322
                  ],
                  [
                    60466.2,
                    31377.5
                  ],
                  [
                    60666.9,
                    31649.1
                  ],
                  [
                    60541.7,
                    31790.9
                  ],
                  [
                    60411.3,
                    31851.8
                  ],
                  [
                    60180.3,
                    31642.1
                  ]
                ],
                "id": 281,
                "chat_link": "[&BBkBAAA=]"
              },
              "282": {
                "name": "Ascalon Basin",
                "level": 12,
                "coord": [
                  61215.8,
                  31531.5
                ],
                "bounds": [
                  [
                    60666,
                    31652.3
                  ],
                  [
                    60982.6,
                    31591.5
                  ],
                  [
                    61296.3,
                    31773.7
                  ],
                  [
                    61458.5,
                    31781.3
                  ],
                  [
                    61619.4,
                    31898.9
                  ],
                  [
                    61603.1,
                    32053.5
                  ],
                  [
                    61680.8,
                    32143
                  ],
                  [
                    61800.4,
                    32266.6
                  ],
                  [
                    62020.7,
                    31978.7
                  ],
                  [
                    62040.4,
                    31882.4
                  ],
                  [
                    61961.6,
                    31505.5
                  ],
                  [
                    61442.9,
                    31466.1
                  ],
                  [
                    61175.9,
                    31065.4
                  ],
                  [
                    61051.7,
                    31086
                  ],
                  [
                    60870.2,
                    30981.4
                  ],
                  [
                    60845.5,
                    30844.8
                  ],
                  [
                    60643.1,
                    30846.8
                  ],
                  [
                    60386,
                    31101.2
                  ],
                  [
                    60307.5,
                    31326.2
                  ],
                  [
                    60462.6,
                    31384.5
                  ],
                  [
                    60666,
                    31652.3
                  ]
                ],
                "id": 282,
                "chat_link": "[&BBoBAAA=]"
              },
              "283": {
                "name": "Phasmatis Corridor",
                "level": 13,
                "coord": [
                  60438.8,
                  30569.8
                ],
                "bounds": [
                  [
                    60640.3,
                    30858.9
                  ],
                  [
                    60582.4,
                    30915.2
                  ],
                  [
                    60450.9,
                    30771.6
                  ],
                  [
                    60096.5,
                    30681
                  ],
                  [
                    60122.2,
                    30628.4
                  ],
                  [
                    60142.1,
                    30578.6
                  ],
                  [
                    60145.5,
                    30519.8
                  ],
                  [
                    60090.6,
                    30365.1
                  ],
                  [
                    60196,
                    30311.9
                  ],
                  [
                    60368.2,
                    30355.2
                  ],
                  [
                    60478.5,
                    30343.4
                  ],
                  [
                    60716.8,
                    30224.2
                  ],
                  [
                    60700.7,
                    30400.6
                  ],
                  [
                    61009.4,
                    30738.8
                  ],
                  [
                    60842.4,
                    30854.7
                  ],
                  [
                    60640.3,
                    30858.9
                  ]
                ],
                "id": 283,
                "chat_link": "[&BBsBAAA=]"
              },
              "284": {
                "name": "The Toppled Wall",
                "level": 15,
                "coord": [
                  60142.8,
                  30218.1
                ],
                "bounds": [
                  [
                    60354.2,
                    30371.4
                  ],
                  [
                    60193.5,
                    30317.5
                  ],
                  [
                    60097.7,
                    30365.9
                  ],
                  [
                    60026.4,
                    30339.2
                  ],
                  [
                    59975.4,
                    30373.9
                  ],
                  [
                    59901.2,
                    30285.7
                  ],
                  [
                    59716.3,
                    30311.3
                  ],
                  [
                    59514.5,
                    30264.8
                  ],
                  [
                    59300.1,
                    29999.9
                  ],
                  [
                    60307.3,
                    29873.5
                  ],
                  [
                    60734.6,
                    29939
                  ],
                  [
                    60712.1,
                    30002.8
                  ],
                  [
                    60702.9,
                    30248.4
                  ],
                  [
                    60463.8,
                    30359.8
                  ],
                  [
                    60354.2,
                    30371.4
                  ]
                ],
                "id": 284,
                "chat_link": "[&BBwBAAA=]"
              },
              "285": {
                "name": "Lamia Mire",
                "level": 11,
                "coord": [
                  61089.9,
                  30885.5
                ],
                "bounds": [
                  [
                    61009.7,
                    30727.9
                  ],
                  [
                    61300.9,
                    30664.1
                  ],
                  [
                    61380.3,
                    30824.2
                  ],
                  [
                    61174.3,
                    31068.5
                  ],
                  [
                    61050.9,
                    31087.3
                  ],
                  [
                    60868.5,
                    30981.8
                  ],
                  [
                    60844.7,
                    30845
                  ],
                  [
                    61009.7,
                    30727.9
                  ]
                ],
                "id": 285,
                "chat_link": "[&BB0BAAA=]"
              },
              "286": {
                "name": "Loreclaw Expanse",
                "level": 11,
                "coord": [
                  61133.9,
                  31833.1
                ],
                "bounds": [
                  [
                    60541.3,
                    31790.3
                  ],
                  [
                    60666.8,
                    31648.9
                  ],
                  [
                    60981,
                    31590.2
                  ],
                  [
                    61303.5,
                    31774.6
                  ],
                  [
                    61462.3,
                    31777.7
                  ],
                  [
                    61624.9,
                    31894.9
                  ],
                  [
                    61608.9,
                    32048.5
                  ],
                  [
                    61163.5,
                    32020.7
                  ],
                  [
                    60853,
                    31952
                  ],
                  [
                    60541.3,
                    31790.3
                  ]
                ],
                "id": 286,
                "chat_link": "[&BB4BAAA=]"
              },
              "287": {
                "name": "Cadem Forest",
                "level": 13,
                "coord": [
                  61649.7,
                  30878.2
                ],
                "bounds": [
                  [
                    61175.7,
                    31066.7
                  ],
                  [
                    61382.4,
                    30824.6
                  ],
                  [
                    61302.4,
                    30665.2
                  ],
                  [
                    61292.9,
                    30588.2
                  ],
                  [
                    61470,
                    30418.9
                  ],
                  [
                    61659,
                    30457.1
                  ],
                  [
                    61934.2,
                    30370.9
                  ],
                  [
                    61939.4,
                    30675.2
                  ],
                  [
                    62008.4,
                    30866.8
                  ],
                  [
                    61943.6,
                    31211.3
                  ],
                  [
                    61956.3,
                    31299.2
                  ],
                  [
                    61939.3,
                    31504.9
                  ],
                  [
                    61442.5,
                    31467.4
                  ],
                  [
                    61175.7,
                    31066.7
                  ]
                ],
                "id": 287,
                "chat_link": "[&BB8BAAA=]"
              },
              "288": {
                "name": "Gunbreach Hills",
                "level": 3,
                "coord": [
                  58277,
                  30394.2
                ],
                "bounds": [
                  [
                    57811.7,
                    30326.9
                  ],
                  [
                    57985.1,
                    30336.6
                  ],
                  [
                    58139.5,
                    30216.8
                  ],
                  [
                    58197.3,
                    30260
                  ],
                  [
                    58466.1,
                    30120
                  ],
                  [
                    58627.1,
                    30196.5
                  ],
                  [
                    58748.3,
                    30586.6
                  ],
                  [
                    58543.3,
                    30743.6
                  ],
                  [
                    58379.7,
                    30589.3
                  ],
                  [
                    57871.7,
                    30565.2
                  ],
                  [
                    57811.7,
                    30326.9
                  ]
                ],
                "id": 288,
                "chat_link": "[&BCABAAA=]"
              },
              "289": {
                "name": "Ascalon City Ruins",
                "level": 14,
                "coord": [
                  61034.8,
                  30253.6
                ],
                "bounds": [
                  [
                    61011.7,
                    30731.4
                  ],
                  [
                    60697,
                    30393
                  ],
                  [
                    60723.5,
                    30048.4
                  ],
                  [
                    60727.4,
                    29978.6
                  ],
                  [
                    60743.3,
                    29921.7
                  ],
                  [
                    60963.8,
                    29895.4
                  ],
                  [
                    61426,
                    29892.3
                  ],
                  [
                    61466,
                    30421.3
                  ],
                  [
                    61289.4,
                    30588.3
                  ],
                  [
                    61300,
                    30665.6
                  ],
                  [
                    61011.7,
                    30731.4
                  ]
                ],
                "id": 289,
                "chat_link": "[&BCEBAAA=]"
              },
              "290": {
                "name": "Devourer's Mouth",
                "level": 3,
                "coord": [
                  58268,
                  30086
                ],
                "bounds": [
                  [
                    58467.2,
                    30120.9
                  ],
                  [
                    58200.9,
                    30259.5
                  ],
                  [
                    58140.9,
                    30220.5
                  ],
                  [
                    58229.3,
                    30157
                  ],
                  [
                    58229.8,
                    30114.4
                  ],
                  [
                    58152.3,
                    30016.7
                  ],
                  [
                    58208.3,
                    29891.4
                  ],
                  [
                    58368.6,
                    29949.9
                  ],
                  [
                    58414.6,
                    30043.9
                  ],
                  [
                    58467.2,
                    30120.9
                  ]
                ],
                "id": 290,
                "chat_link": "[&BCIBAAA=]"
              },
              "291": {
                "name": "Abbey Ruins",
                "level": 10,
                "coord": [
                  59808.3,
                  31063.9
                ],
                "bounds": [
                  [
                    59905.1,
                    30919.6
                  ],
                  [
                    59679.5,
                    30979.2
                  ],
                  [
                    59748.7,
                    31146.6
                  ],
                  [
                    59900.1,
                    31210.1
                  ],
                  [
                    59905.1,
                    30919.6
                  ]
                ],
                "id": 291,
                "chat_link": "[&BCMBAAA=]"
              },
              "292": {
                "name": "Agnos Gorge",
                "level": 15,
                "coord": [
                  60059.9,
                  30492.4
                ],
                "bounds": [
                  [
                    60015.7,
                    30543.8
                  ],
                  [
                    60000.2,
                    30494
                  ],
                  [
                    59953.9,
                    30423.6
                  ],
                  [
                    59971,
                    30374
                  ],
                  [
                    60017.9,
                    30334.5
                  ],
                  [
                    60099.9,
                    30364.6
                  ],
                  [
                    60111.6,
                    30418.3
                  ],
                  [
                    60148.1,
                    30515.3
                  ],
                  [
                    60147.1,
                    30549.7
                  ],
                  [
                    60145.2,
                    30581.8
                  ],
                  [
                    60102.4,
                    30680.4
                  ],
                  [
                    60005.7,
                    30628.6
                  ],
                  [
                    60015.7,
                    30543.8
                  ]
                ],
                "id": 292,
                "chat_link": "[&BCQBAAA=]"
              },
              "293": {
                "name": "Human's Lament",
                "level": 14,
                "coord": [
                  61730.5,
                  30125.3
                ],
                "bounds": [
                  [
                    61438.6,
                    30135.4
                  ],
                  [
                    61423.9,
                    29896.1
                  ],
                  [
                    61598.6,
                    29922.2
                  ],
                  [
                    61700.4,
                    29837.9
                  ],
                  [
                    61921.9,
                    29893.1
                  ],
                  [
                    62009.2,
                    29994.1
                  ],
                  [
                    61936.7,
                    30165.6
                  ],
                  [
                    61949.6,
                    30275
                  ],
                  [
                    61935.4,
                    30378.1
                  ],
                  [
                    61656,
                    30460.7
                  ],
                  [
                    61465.6,
                    30420.5
                  ],
                  [
                    61438.6,
                    30135.4
                  ]
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              },
              "567": {
                "name": "Facula Castrum",
                "level": 5,
                "coord": [
                  59121.5,
                  30024
                ],
                "bounds": [
                  [
                    59147.3,
                    30224.4
                  ],
                  [
                    59228.4,
                    30179.7
                  ],
                  [
                    59307.6,
                    30007.8
                  ],
                  [
                    59351.6,
                    29908.2
                  ],
                  [
                    59078.3,
                    29853.8
                  ],
                  [
                    58817.2,
                    29908.1
                  ],
                  [
                    58920.3,
                    30085.8
                  ],
                  [
                    59147.3,
                    30224.4
                  ]
                ],
                "id": 567,
                "chat_link": "[&BDcCAAA=]"
              },
              "1104": {
                "name": "Langmar Estate",
                "level": 15,
                "coord": [
                  58219.9,
                  31645.5
                ],
                "bounds": [
                  [
                    58484.8,
                    31778.8
                  ],
                  [
                    58575,
                    31811.5
                  ],
                  [
                    58489.1,
                    32027.1
                  ],
                  [
                    57798.1,
                    31991.6
                  ],
                  [
                    57779,
                    31145.6
                  ],
                  [
                    58072,
                    31078.3
                  ],
                  [
                    58112.6,
                    31438.4
                  ],
                  [
                    58110.3,
                    31754.6
                  ],
                  [
                    58287.9,
                    31762.2
                  ],
                  [
                    58490.1,
                    31666.8
                  ],
                  [
                    58484.8,
                    31778.8
                  ]
                ],
                "id": 1104,
                "chat_link": "[&BFAEAAA=]"
              }
            },
            "id": 1105,
            "mastery_points": [],
            "adventures": []
          },
          "1112": {
            "name": "Branded for Termination",
            "min_level": 30,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              62976,
              34176
            ],
            "map_rect": [
              [
                -36864,
                -36864
              ],
              [
                36864,
                36864
              ]
            ],
            "continent_rect": [
              [
                61440,
                32640
              ],
              [
                64512,
                35712
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "365": {
                "name": "Last Stand Shelter",
                "level": 31,
                "coord": [
                  61657.9,
                  35015.4
                ],
                "bounds": [
                  [
                    61456.9,
                    34889.1
                  ],
                  [
                    61607.9,
                    34741.1
                  ],
                  [
                    61812.8,
                    34931.5
                  ],
                  [
                    61785.2,
                    35009.7
                  ],
                  [
                    61709.3,
                    35063.5
                  ],
                  [
                    61698.5,
                    35205.7
                  ],
                  [
                    61534.8,
                    35267.4
                  ],
                  [
                    61456.9,
                    34889.1
                  ]
                ],
                "id": 365,
                "chat_link": "[&BG0BAAA=]"
              },
              "366": {
                "name": "Blackwing Excavation",
                "level": 31,
                "coord": [
                  62641.1,
                  35403.7
                ],
                "bounds": [
                  [
                    62557.5,
                    35091.2
                  ],
                  [
                    62771.9,
                    35156.6
                  ],
                  [
                    62878.7,
                    35543.5
                  ],
                  [
                    62746.7,
                    35649.8
                  ],
                  [
                    62451.9,
                    35654.8
                  ],
                  [
                    62440,
                    35326.3
                  ],
                  [
                    62557.5,
                    35091.2
                  ]
                ],
                "id": 366,
                "chat_link": "[&BG4BAAA=]"
              },
              "367": {
                "name": "Stronghold of Ebonhawke",
                "level": 31,
                "coord": [
                  62008.8,
                  35138
                ],
                "bounds": [
                  [
                    61812.5,
                    34931.7
                  ],
                  [
                    61608.6,
                    34739.7
                  ],
                  [
                    61974.8,
                    34550.6
                  ],
                  [
                    62116.3,
                    34621.3
                  ],
                  [
                    62342,
                    34818.7
                  ],
                  [
                    62699,
                    34688.4
                  ],
                  [
                    62557.7,
                    35091.4
                  ],
                  [
                    62440.8,
                    35324.7
                  ],
                  [
                    62450.3,
                    35654.7
                  ],
                  [
                    62165.5,
                    35625.2
                  ],
                  [
                    61939.4,
                    35533.8
                  ],
                  [
                    61770.3,
                    35659.5
                  ],
                  [
                    61542.8,
                    35558.4
                  ],
                  [
                    61534.8,
                    35269.1
                  ],
                  [
                    61699,
                    35206.4
                  ],
                  [
                    61709.8,
                    35064.6
                  ],
                  [
                    61785.5,
                    35008.6
                  ],
                  [
                    61812.5,
                    34931.7
                  ]
                ],
                "id": 367,
                "chat_link": "[&BG8BAAA=]"
              },
              "368": {
                "name": "Grimm Hills",
                "level": 34,
                "coord": [
                  62913.6,
                  34678.1
                ],
                "bounds": [
                  [
                    62775,
                    35155.6
                  ],
                  [
                    63095.2,
                    34880.6
                  ],
                  [
                    63095,
                    34671.8
                  ],
                  [
                    63212.3,
                    34293.8
                  ],
                  [
                    63014.9,
                    34325.3
                  ],
                  [
                    62889.8,
                    34422.3
                  ],
                  [
                    62883.8,
                    34575
                  ],
                  [
                    62698.5,
                    34687.4
                  ],
                  [
                    62558.2,
                    35091.2
                  ],
                  [
                    62775,
                    35155.6
                  ]
                ],
                "id": 368,
                "chat_link": "[&BHABAAA=]"
              },
              "369": {
                "name": "The Ogre Road",
                "level": 33,
                "coord": [
                  63775.2,
                  34960.3
                ],
                "bounds": [
                  [
                    63818,
                    34775.5
                  ],
                  [
                    64049.9,
                    34874.6
                  ],
                  [
                    63983.2,
                    35117.8
                  ],
                  [
                    63650.4,
                    35343.8
                  ],
                  [
                    63469.1,
                    34973.7
                  ],
                  [
                    63680.8,
                    34676.6
                  ],
                  [
                    63818,
                    34775.5
                  ]
                ],
                "id": 369,
                "chat_link": "[&BHEBAAA=]"
              },
              "370": {
                "name": "Wildlin Narrows",
                "level": 34,
                "coord": [
                  64113.6,
                  35332.1
                ],
                "bounds": [
                  [
                    63981.4,
                    35119
                  ],
                  [
                    64047.3,
                    34879.9
                  ],
                  [
                    64446.4,
                    34880.2
                  ],
                  [
                    64454.7,
                    35016.9
                  ],
                  [
                    64482.5,
                    35162.6
                  ],
                  [
                    64437,
                    35419.7
                  ],
                  [
                    64379.4,
                    35572.2
                  ],
                  [
                    64266.7,
                    35658.7
                  ],
                  [
                    63887.2,
                    35684.1
                  ],
                  [
                    63726.7,
                    35630.3
                  ],
                  [
                    63602.3,
                    35623
                  ],
                  [
                    63651.7,
                    35338
                  ],
                  [
                    63981.4,
                    35119
                  ]
                ],
                "id": 370,
                "chat_link": "[&BHIBAAA=]"
              },
              "371": {
                "name": "Mithric Cliffs",
                "level": 35,
                "coord": [
                  64140.7,
                  34560.1
                ],
                "bounds": [
                  [
                    63873.1,
                    34199.8
                  ],
                  [
                    64439.5,
                    34200.8
                  ],
                  [
                    64522.9,
                    34271.7
                  ],
                  [
                    64421.7,
                    34550.9
                  ],
                  [
                    64486.2,
                    34796.1
                  ],
                  [
                    64446.4,
                    34880
                  ],
                  [
                    64049.8,
                    34881.8
                  ],
                  [
                    63817.7,
                    34776.3
                  ],
                  [
                    63679.6,
                    34676
                  ],
                  [
                    63670,
                    34367.5
                  ],
                  [
                    63873.1,
                    34199.8
                  ]
                ],
                "id": 371,
                "chat_link": "[&BHMBAAA=]"
              },
              "372": {
                "name": "Hunter's Gorge",
                "level": 35,
                "coord": [
                  63341.8,
                  34640.5
                ],
                "bounds": [
                  [
                    63669.7,
                    34367.2
                  ],
                  [
                    63679.1,
                    34676
                  ],
                  [
                    63470.3,
                    34973.3
                  ],
                  [
                    63163.9,
                    34985.8
                  ],
                  [
                    63094,
                    34882.4
                  ],
                  [
                    63095.7,
                    34672.5
                  ],
                  [
                    63212.8,
                    34294.4
                  ],
                  [
                    63348.8,
                    34272.4
                  ],
                  [
                    63669.7,
                    34367.2
                  ]
                ],
                "id": 372,
                "chat_link": "[&BHQBAAA=]"
              },
              "373": {
                "name": "The Siege Plains",
                "level": 33,
                "coord": [
                  62661.4,
                  34431.1
                ],
                "bounds": [
                  [
                    62342.5,
                    34820
                  ],
                  [
                    62698.4,
                    34688
                  ],
                  [
                    62884,
                    34573.7
                  ],
                  [
                    62895.1,
                    34415.3
                  ],
                  [
                    63015.8,
                    34325.2
                  ],
                  [
                    62807.6,
                    34052
                  ],
                  [
                    62532,
                    33954.3
                  ],
                  [
                    62115.9,
                    34620.7
                  ],
                  [
                    62342.5,
                    34820
                  ]
                ],
                "id": 373,
                "chat_link": "[&BHUBAAA=]"
              },
              "374": {
                "name": "Sniper's Woods",
                "level": 35,
                "coord": [
                  62135,
                  34190.4
                ],
                "bounds": [
                  [
                    61976.5,
                    34544.7
                  ],
                  [
                    62116.8,
                    34620
                  ],
                  [
                    62531.9,
                    33954
                  ],
                  [
                    62317,
                    33906.1
                  ],
                  [
                    62102.3,
                    34036.9
                  ],
                  [
                    61765.8,
                    34080.3
                  ],
                  [
                    61976.5,
                    34544.7
                  ]
                ],
                "id": 374,
                "chat_link": "[&BHYBAAA=]"
              },
              "375": {
                "name": "Bento Canyon",
                "level": 34,
                "coord": [
                  61654.1,
                  34397.7
                ],
                "bounds": [
                  [
                    61608.5,
                    34740
                  ],
                  [
                    61977.2,
                    34544.8
                  ],
                  [
                    61766,
                    34081.3
                  ],
                  [
                    61522.8,
                    34074.4
                  ],
                  [
                    61571.5,
                    34348
                  ],
                  [
                    61478.8,
                    34597.5
                  ],
                  [
                    61608.5,
                    34740
                  ]
                ],
                "id": 375,
                "chat_link": "[&BHcBAAA=]"
              },
              "376": {
                "name": "Dragonrot Domains",
                "level": 38,
                "coord": [
                  61711,
                  33852.5
                ],
                "bounds": [
                  [
                    61522.5,
                    34074.1
                  ],
                  [
                    61765.8,
                    34080.1
                  ],
                  [
                    62103,
                    34037.3
                  ],
                  [
                    61890.2,
                    33602.7
                  ],
                  [
                    61522.8,
                    33605.5
                  ],
                  [
                    61461.9,
                    33715.2
                  ],
                  [
                    61522.5,
                    34074.1
                  ]
                ],
                "id": 376,
                "chat_link": "[&BHgBAAA=]"
              },
              "377": {
                "name": "Varim's Run",
                "level": 40,
                "coord": [
                  61676.3,
                  33049.4
                ],
                "bounds": [
                  [
                    61684.6,
                    32846.2
                  ],
                  [
                    61627.8,
                    32689
                  ],
                  [
                    61783.8,
                    32640.9
                  ],
                  [
                    62037,
                    32658.6
                  ],
                  [
                    61927,
                    32793.8
                  ],
                  [
                    61888.9,
                    33603.3
                  ],
                  [
                    61521.8,
                    33606.4
                  ],
                  [
                    61568.4,
                    33387.3
                  ],
                  [
                    61411.7,
                    33325.3
                  ],
                  [
                    61408,
                    33080.2
                  ],
                  [
                    61580,
                    32912.1
                  ],
                  [
                    61684.6,
                    32846.2
                  ]
                ],
                "id": 377,
                "chat_link": "[&BHkBAAA=]"
              },
              "378": {
                "name": "Tenaebron Lake",
                "level": 39,
                "coord": [
                  62214.2,
                  33182.2
                ],
                "bounds": [
                  [
                    61884.8,
                    33603.9
                  ],
                  [
                    62102.9,
                    34046.4
                  ],
                  [
                    62317.7,
                    33899.6
                  ],
                  [
                    62262.7,
                    33569.9
                  ],
                  [
                    62495.3,
                    33233.3
                  ],
                  [
                    62442.7,
                    32764
                  ],
                  [
                    62420.4,
                    32651.8
                  ],
                  [
                    62238,
                    32617.8
                  ],
                  [
                    62046.1,
                    32647.3
                  ],
                  [
                    61931.3,
                    32787.9
                  ],
                  [
                    61884.8,
                    33603.9
                  ]
                ],
                "id": 378,
                "chat_link": "[&BHoBAAA=]"
              },
              "379": {
                "name": "Vulture's Sweep",
                "level": 37,
                "coord": [
                  62545.4,
                  33687.2
                ],
                "bounds": [
                  [
                    62315.8,
                    33906
                  ],
                  [
                    62530.4,
                    33952.9
                  ],
                  [
                    62805.8,
                    34052.8
                  ],
                  [
                    62867.3,
                    33390.9
                  ],
                  [
                    62492.3,
                    33242.2
                  ],
                  [
                    62260.7,
                    33578.4
                  ],
                  [
                    62315.8,
                    33906
                  ]
                ],
                "id": 379,
                "chat_link": "[&BHsBAAA=]"
              },
              "380": {
                "name": "Warrior's Crown",
                "level": 36,
                "coord": [
                  63286.9,
                  33885.3
                ],
                "bounds": [
                  [
                    62867.6,
                    33388
                  ],
                  [
                    63792.5,
                    33512.5
                  ],
                  [
                    63709.9,
                    33749.2
                  ],
                  [
                    63468.1,
                    33900.9
                  ],
                  [
                    63349.3,
                    34273.4
                  ],
                  [
                    63014.9,
                    34324.5
                  ],
                  [
                    62805.9,
                    34048.8
                  ],
                  [
                    62867.6,
                    33388
                  ]
                ],
                "id": 380,
                "chat_link": "[&BHwBAAA=]"
              },
              "381": {
                "name": "Belag Crossroads",
                "level": 35,
                "coord": [
                  63662.8,
                  34062.1
                ],
                "bounds": [
                  [
                    63348.9,
                    34273.4
                  ],
                  [
                    63669.7,
                    34368.1
                  ],
                  [
                    63873.3,
                    34199.3
                  ],
                  [
                    63905.5,
                    33881.5
                  ],
                  [
                    63711,
                    33749.6
                  ],
                  [
                    63468.4,
                    33900.9
                  ],
                  [
                    63348.9,
                    34273.4
                  ]
                ],
                "id": 381,
                "chat_link": "[&BH0BAAA=]"
              },
              "382": {
                "name": "Flameroot Caverns",
                "level": 36,
                "coord": [
                  64189.7,
                  33999.4
                ],
                "bounds": [
                  [
                    63872.4,
                    34199.8
                  ],
                  [
                    64439.4,
                    34201.8
                  ],
                  [
                    64395.5,
                    34050.3
                  ],
                  [
                    64466,
                    33931.9
                  ],
                  [
                    64059.3,
                    33731.8
                  ],
                  [
                    63905.5,
                    33880.9
                  ],
                  [
                    63872.4,
                    34199.8
                  ]
                ],
                "id": 382,
                "chat_link": "[&BH4BAAA=]"
              },
              "383": {
                "name": "Highden Caves",
                "level": 37,
                "coord": [
                  64321.2,
                  33581.6
                ],
                "bounds": [
                  [
                    64058.1,
                    33737.1
                  ],
                  [
                    64465.7,
                    33931.5
                  ],
                  [
                    64495.3,
                    33748.5
                  ],
                  [
                    64427.9,
                    33511.7
                  ],
                  [
                    64421.5,
                    33370.7
                  ],
                  [
                    64304.1,
                    33239.5
                  ],
                  [
                    64075.8,
                    33532.5
                  ],
                  [
                    64058.1,
                    33737.1
                  ]
                ],
                "id": 383,
                "chat_link": "[&BH8BAAA=]"
              },
              "384": {
                "name": "Axedrag Cut",
                "level": 37,
                "coord": [
                  63990.9,
                  33565.5
                ],
                "bounds": [
                  [
                    63881.1,
                    33256.4
                  ],
                  [
                    64304,
                    33239.1
                  ],
                  [
                    64083.4,
                    33532.1
                  ],
                  [
                    64061.1,
                    33735.1
                  ],
                  [
                    63905.5,
                    33881.2
                  ],
                  [
                    63710.1,
                    33748.8
                  ],
                  [
                    63881.1,
                    33256.4
                  ]
                ],
                "id": 384,
                "chat_link": "[&BIABAAA=]"
              },
              "385": {
                "name": "Tanglerot Hills",
                "level": 38,
                "coord": [
                  64171.4,
                  32762.6
                ],
                "bounds": [
                  [
                    63983.3,
                    32611.9
                  ],
                  [
                    63951.1,
                    32609.5
                  ],
                  [
                    64029.3,
                    32351.6
                  ],
                  [
                    64129.6,
                    32438.2
                  ],
                  [
                    64262.5,
                    32504.9
                  ],
                  [
                    64348,
                    32526.6
                  ],
                  [
                    64495,
                    32743.9
                  ],
                  [
                    64478.6,
                    33115.1
                  ],
                  [
                    64304,
                    33238.5
                  ],
                  [
                    63880,
                    33257.4
                  ],
                  [
                    64024.1,
                    32991.5
                  ],
                  [
                    63983.3,
                    32611.9
                  ]
                ],
                "id": 385,
                "chat_link": "[&BIEBAAA=]"
              },
              "386": {
                "name": "Halkor Meadows",
                "level": 38,
                "coord": [
                  63745.8,
                  32858
                ],
                "bounds": [
                  [
                    63566.3,
                    33004.5
                  ],
                  [
                    63855.8,
                    33329.6
                  ],
                  [
                    63879.9,
                    33259.8
                  ],
                  [
                    64024.2,
                    32991.6
                  ],
                  [
                    64008,
                    32735
                  ],
                  [
                    63986.5,
                    32610.7
                  ],
                  [
                    63759.8,
                    32579.6
                  ],
                  [
                    63522.4,
                    32646.3
                  ],
                  [
                    63394.6,
                    32629.6
                  ],
                  [
                    63460.5,
                    32793.5
                  ],
                  [
                    63566.3,
                    33004.5
                  ]
                ],
                "id": 386,
                "chat_link": "[&BIIBAAA=]"
              },
              "387": {
                "name": "Thunderbreak Hills",
                "level": 38,
                "coord": [
                  62924.8,
                  32849.6
                ],
                "bounds": [
                  [
                    63401.1,
                    32628
                  ],
                  [
                    63567,
                    33004.2
                  ],
                  [
                    63218.8,
                    33031.5
                  ],
                  [
                    62867.4,
                    33390
                  ],
                  [
                    62493,
                    33242.9
                  ],
                  [
                    62440,
                    32773.5
                  ],
                  [
                    62420.6,
                    32649
                  ],
                  [
                    62745,
                    32572
                  ],
                  [
                    62954.7,
                    32648.8
                  ],
                  [
                    63140.4,
                    32556.1
                  ],
                  [
                    63401.1,
                    32628
                  ]
                ],
                "id": 387,
                "chat_link": "[&BIMBAAA=]"
              },
              "388": {
                "name": "Hautclaire Vale",
                "level": 31,
                "coord": [
                  63239.6,
                  35319.1
                ],
                "bounds": [
                  [
                    63094.3,
                    34879.9
                  ],
                  [
                    63162.7,
                    34986.4
                  ],
                  [
                    63470.2,
                    34971.3
                  ],
                  [
                    63650.7,
                    35342.5
                  ],
                  [
                    63603.5,
                    35626.5
                  ],
                  [
                    63482.8,
                    35538.9
                  ],
                  [
                    63249.2,
                    35599.6
                  ],
                  [
                    63033.2,
                    35546.5
                  ],
                  [
                    62877.4,
                    35543.2
                  ],
                  [
                    62772.5,
                    35155.8
                  ],
                  [
                    63094.3,
                    34879.9
                  ]
                ],
                "id": 388,
                "chat_link": "[&BIQBAAA=]"
              },
              "389": {
                "name": "Gillfarn Plains",
                "level": 38,
                "coord": [
                  63459.3,
                  33253.3
                ],
                "bounds": [
                  [
                    62864.8,
                    33390.4
                  ],
                  [
                    63792.2,
                    33514.1
                  ],
                  [
                    63855.6,
                    33329
                  ],
                  [
                    63566.4,
                    33004.3
                  ],
                  [
                    63217.5,
                    33028.6
                  ],
                  [
                    62864.8,
                    33390.4
                  ]
                ],
                "id": 389,
                "chat_link": "[&BIUBAAA=]"
              },
              "877": {
                "name": "Secluded Glen",
                "level": 40,
                "coord": [
                  61571.1,
                  32795.5
                ],
                "bounds": [
                  [
                    61579.8,
                    32911.9
                  ],
                  [
                    61685,
                    32846.5
                  ],
                  [
                    61634.9,
                    32697
                  ],
                  [
                    61505.3,
                    32679.9
                  ],
                  [
                    61450.4,
                    32842.2
                  ],
                  [
                    61579.8,
                    32911.9
                  ]
                ],
                "id": 877,
                "chat_link": "[&BG0DAAA=]"
              }
            },
            "id": 1112,
            "mastery_points": [],
            "adventures": []
          },
          "1118": {
            "name": "Save Our Supplies",
            "min_level": 50,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              60928,
              27904
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                59904,
                25856
              ],
              [
                61952,
                29952
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "433": {
                "name": "Champion's Shield",
                "level": 54,
                "coord": [
                  60464.9,
                  29077.8
                ],
                "bounds": [
                  [
                    59906.5,
                    29535.9
                  ],
                  [
                    60142.4,
                    29465.2
                  ],
                  [
                    60332.5,
                    29597.5
                  ],
                  [
                    60589.6,
                    29543.2
                  ],
                  [
                    60718.4,
                    29291.3
                  ],
                  [
                    60835.9,
                    29115.6
                  ],
                  [
                    61091.2,
                    29074.5
                  ],
                  [
                    60957.3,
                    29006.4
                  ],
                  [
                    60913.8,
                    28942.5
                  ],
                  [
                    61002.8,
                    28761.8
                  ],
                  [
                    60951.1,
                    28708.4
                  ],
                  [
                    60683.9,
                    28904.1
                  ],
                  [
                    60427.7,
                    28910
                  ],
                  [
                    60185.8,
                    28739.6
                  ],
                  [
                    60010,
                    28837
                  ],
                  [
                    59916.2,
                    28765.3
                  ],
                  [
                    59857.7,
                    28954.8
                  ],
                  [
                    59845.2,
                    29247.4
                  ],
                  [
                    59906.5,
                    29535.9
                  ]
                ],
                "id": 433,
                "chat_link": "[&BLEBAAA=]"
              },
              "434": {
                "name": "Stonesheath Overlook",
                "level": 52,
                "coord": [
                  60716.9,
                  29831.6
                ],
                "bounds": [
                  [
                    60590,
                    29542.5
                  ],
                  [
                    60789.9,
                    29653.4
                  ],
                  [
                    60847,
                    29766
                  ],
                  [
                    61007.3,
                    29781.6
                  ],
                  [
                    61022.8,
                    29864.7
                  ],
                  [
                    61004.8,
                    30017.5
                  ],
                  [
                    60894.1,
                    30007.1
                  ],
                  [
                    60882.6,
                    29951
                  ],
                  [
                    60546.7,
                    29973.3
                  ],
                  [
                    60340.5,
                    29968.3
                  ],
                  [
                    60344.7,
                    29856.1
                  ],
                  [
                    60332.8,
                    29597.5
                  ],
                  [
                    60590,
                    29542.5
                  ]
                ],
                "id": 434,
                "chat_link": "[&BLIBAAA=]"
              },
              "435": {
                "name": "Ironhead Lake",
                "level": 53,
                "coord": [
                  60996,
                  29461.3
                ],
                "bounds": [
                  [
                    60590.1,
                    29543.3
                  ],
                  [
                    60717.6,
                    29291.3
                  ],
                  [
                    60841.1,
                    29124.2
                  ],
                  [
                    61093.5,
                    29078
                  ],
                  [
                    61068.2,
                    29273.4
                  ],
                  [
                    61217.3,
                    29440.5
                  ],
                  [
                    61345.6,
                    29440.3
                  ],
                  [
                    61300.9,
                    29540.5
                  ],
                  [
                    61133.8,
                    29602.9
                  ],
                  [
                    61006.7,
                    29782.2
                  ],
                  [
                    60847.3,
                    29765.4
                  ],
                  [
                    60789.4,
                    29654
                  ],
                  [
                    60590.1,
                    29543.3
                  ]
                ],
                "id": 435,
                "chat_link": "[&BLMBAAA=]"
              },
              "436": {
                "name": "Bloodfin Lake",
                "level": 51,
                "coord": [
                  61404.3,
                  29650.5
                ],
                "bounds": [
                  [
                    61022.8,
                    29864.5
                  ],
                  [
                    61004.7,
                    29985.7
                  ],
                  [
                    61350.3,
                    29943.7
                  ],
                  [
                    61760.3,
                    29939.8
                  ],
                  [
                    61940.2,
                    29782.8
                  ],
                  [
                    61910.7,
                    29321.9
                  ],
                  [
                    61623.8,
                    29354.3
                  ],
                  [
                    61450.5,
                    29244
                  ],
                  [
                    61345,
                    29444.2
                  ],
                  [
                    61301.4,
                    29542.6
                  ],
                  [
                    61134,
                    29601.3
                  ],
                  [
                    61007.8,
                    29781.6
                  ],
                  [
                    61022.8,
                    29864.5
                  ]
                ],
                "id": 436,
                "chat_link": "[&BLQBAAA=]"
              },
              "437": {
                "name": "Hellion Forest",
                "level": 50,
                "coord": [
                  61648.8,
                  28968.5
                ],
                "bounds": [
                  [
                    61910.6,
                    29321.8
                  ],
                  [
                    61931.3,
                    29157
                  ],
                  [
                    61883.4,
                    28921.1
                  ],
                  [
                    61948.3,
                    28935.3
                  ],
                  [
                    61942.7,
                    28820.8
                  ],
                  [
                    61845.8,
                    28768.9
                  ],
                  [
                    61552.7,
                    28703.4
                  ],
                  [
                    61535.9,
                    28658.7
                  ],
                  [
                    61334.8,
                    28784.4
                  ],
                  [
                    61369.3,
                    28879.6
                  ],
                  [
                    61280.9,
                    28993.9
                  ],
                  [
                    61472.2,
                    29014.5
                  ],
                  [
                    61450.3,
                    29243.6
                  ],
                  [
                    61624.8,
                    29356.3
                  ],
                  [
                    61910.6,
                    29321.8
                  ]
                ],
                "id": 437,
                "chat_link": "[&BLUBAAA=]"
              },
              "438": {
                "name": "Sunken Halls of Clarent",
                "level": 52,
                "coord": [
                  61277.8,
                  29213.2
                ],
                "bounds": [
                  [
                    61347.8,
                    29439.2
                  ],
                  [
                    61448.9,
                    29243.7
                  ],
                  [
                    61473,
                    29014
                  ],
                  [
                    61281.3,
                    28993.9
                  ],
                  [
                    61099.6,
                    29081
                  ],
                  [
                    61072.4,
                    29280.6
                  ],
                  [
                    61221.9,
                    29440.1
                  ],
                  [
                    61347.8,
                    29439.2
                  ]
                ],
                "id": 438,
                "chat_link": "[&BLYBAAA=]"
              },
              "439": {
                "name": "Monger's Sink",
                "level": 55,
                "coord": [
                  60560.7,
                  28563.1
                ],
                "bounds": [
                  [
                    60189.3,
                    28428.1
                  ],
                  [
                    60011.7,
                    28232.8
                  ],
                  [
                    60764,
                    28201
                  ],
                  [
                    60892.6,
                    28405.2
                  ],
                  [
                    60939.4,
                    28542
                  ],
                  [
                    60951.9,
                    28705.5
                  ],
                  [
                    60684.6,
                    28903.9
                  ],
                  [
                    60427.8,
                    28910.6
                  ],
                  [
                    60184.9,
                    28738.9
                  ],
                  [
                    60189.3,
                    28428.1
                  ]
                ],
                "id": 439,
                "chat_link": "[&BLcBAAA=]"
              },
              "440": {
                "name": "Scourgejaw's Vault",
                "level": 55,
                "coord": [
                  60036.3,
                  28558.1
                ],
                "bounds": [
                  [
                    60011.6,
                    28232.4
                  ],
                  [
                    60189.3,
                    28428.5
                  ],
                  [
                    60184.8,
                    28740.4
                  ],
                  [
                    60010,
                    28836.8
                  ],
                  [
                    59913,
                    28767.2
                  ],
                  [
                    59909,
                    28343.1
                  ],
                  [
                    60011.6,
                    28232.4
                  ]
                ],
                "id": 440,
                "chat_link": "[&BLgBAAA=]"
              },
              "441": {
                "name": "Soldier Mesa",
                "level": 56,
                "coord": [
                  60336.1,
                  27971.7
                ],
                "bounds": [
                  [
                    60342.5,
                    27696.9
                  ],
                  [
                    60462,
                    27843.7
                  ],
                  [
                    60730.2,
                    27835.2
                  ],
                  [
                    60827.7,
                    28010.1
                  ],
                  [
                    60762.2,
                    28202
                  ],
                  [
                    60009.8,
                    28235.3
                  ],
                  [
                    59853.3,
                    28177.5
                  ],
                  [
                    59917,
                    27885.5
                  ],
                  [
                    60120,
                    27858.8
                  ],
                  [
                    60342.5,
                    27696.9
                  ]
                ],
                "id": 441,
                "chat_link": "[&BLkBAAA=]"
              },
              "442": {
                "name": "Viper's Run",
                "level": 56,
                "coord": [
                  61057.5,
                  27950.7
                ],
                "bounds": [
                  [
                    60828.5,
                    28010
                  ],
                  [
                    60763.3,
                    28203.4
                  ],
                  [
                    60892.7,
                    28404.1
                  ],
                  [
                    60990,
                    28252
                  ],
                  [
                    61402.5,
                    28275.4
                  ],
                  [
                    61394.3,
                    28145.3
                  ],
                  [
                    61386.3,
                    27995.3
                  ],
                  [
                    61254.2,
                    27819.5
                  ],
                  [
                    61295,
                    27411.4
                  ],
                  [
                    60876.2,
                    27384.1
                  ],
                  [
                    60877.3,
                    27671.1
                  ],
                  [
                    60730.3,
                    27836.5
                  ],
                  [
                    60828.5,
                    28010
                  ]
                ],
                "id": 442,
                "chat_link": "[&BLoBAAA=]"
              },
              "443": {
                "name": "Lamprey Grottoes",
                "level": 56,
                "coord": [
                  61114.6,
                  28502.6
                ],
                "bounds": [
                  [
                    60990.4,
                    28252.6
                  ],
                  [
                    61401.3,
                    28274.3
                  ],
                  [
                    61445.5,
                    28409.8
                  ],
                  [
                    61254.6,
                    28584.5
                  ],
                  [
                    61146.7,
                    28580.1
                  ],
                  [
                    61006.6,
                    28765.4
                  ],
                  [
                    60955.8,
                    28710.1
                  ],
                  [
                    60939,
                    28542.5
                  ],
                  [
                    60891.7,
                    28403.9
                  ],
                  [
                    60990.4,
                    28252.6
                  ]
                ],
                "id": 443,
                "chat_link": "[&BLsBAAA=]"
              },
              "444": {
                "name": "Southshore Wastes",
                "level": 56,
                "coord": [
                  61648,
                  28463.3
                ],
                "bounds": [
                  [
                    61401.6,
                    28274
                  ],
                  [
                    61394.3,
                    28143.1
                  ],
                  [
                    61636.2,
                    28231.1
                  ],
                  [
                    61896.8,
                    28115.8
                  ],
                  [
                    62035.8,
                    28179.6
                  ],
                  [
                    62144.2,
                    28346.9
                  ],
                  [
                    61940.4,
                    28819.5
                  ],
                  [
                    61846.6,
                    28769.4
                  ],
                  [
                    61552.8,
                    28704.4
                  ],
                  [
                    61537.9,
                    28654.9
                  ],
                  [
                    61334.2,
                    28778.5
                  ],
                  [
                    61258.9,
                    28597.7
                  ],
                  [
                    61444,
                    28408
                  ],
                  [
                    61401.6,
                    28274
                  ]
                ],
                "id": 444,
                "chat_link": "[&BLwBAAA=]"
              },
              "445": {
                "name": "Lake Desolann",
                "level": 57,
                "coord": [
                  61677.4,
                  27859.6
                ],
                "bounds": [
                  [
                    61253.5,
                    27818.9
                  ],
                  [
                    61294.7,
                    27411
                  ],
                  [
                    61940.3,
                    27258.2
                  ],
                  [
                    61902.2,
                    27625.6
                  ],
                  [
                    62035.8,
                    27815.3
                  ],
                  [
                    62034.7,
                    28180
                  ],
                  [
                    61896.5,
                    28116.2
                  ],
                  [
                    61636.1,
                    28231.5
                  ],
                  [
                    61394.5,
                    28143.2
                  ],
                  [
                    61386,
                    27995.9
                  ],
                  [
                    61253.5,
                    27818.9
                  ]
                ],
                "id": 445,
                "chat_link": "[&BL0BAAA=]"
              },
              "446": {
                "name": "Crystalwept Groves",
                "level": 58,
                "coord": [
                  61545.3,
                  26843.5
                ],
                "bounds": [
                  [
                    61294.3,
                    27411.6
                  ],
                  [
                    61851.2,
                    27282.6
                  ],
                  [
                    61872.8,
                    26710.5
                  ],
                  [
                    61802,
                    26532
                  ],
                  [
                    61546.5,
                    26534.2
                  ],
                  [
                    61273.5,
                    26651.4
                  ],
                  [
                    61177.1,
                    26782
                  ],
                  [
                    61294.3,
                    27411.6
                  ]
                ],
                "id": 446,
                "chat_link": "[&BL4BAAA=]"
              },
              "447": {
                "name": "The Granite Front",
                "level": 58,
                "coord": [
                  61004.1,
                  27049.1
                ],
                "bounds": [
                  [
                    60876.1,
                    27385
                  ],
                  [
                    61295.3,
                    27411.9
                  ],
                  [
                    61177.9,
                    26781.8
                  ],
                  [
                    60932.1,
                    26584.9
                  ],
                  [
                    60739.2,
                    27082.1
                  ],
                  [
                    60876.1,
                    27385
                  ]
                ],
                "id": 447,
                "chat_link": "[&BL8BAAA=]"
              },
              "448": {
                "name": "Glory's Steps",
                "level": 57,
                "coord": [
                  60620.1,
                  27536.7
                ],
                "bounds": [
                  [
                    60308.2,
                    27433.8
                  ],
                  [
                    60624.5,
                    27348.8
                  ],
                  [
                    60739.3,
                    27080.1
                  ],
                  [
                    60876.6,
                    27384.6
                  ],
                  [
                    60877.8,
                    27671.5
                  ],
                  [
                    60730.3,
                    27835.7
                  ],
                  [
                    60462,
                    27843.3
                  ],
                  [
                    60342,
                    27696.3
                  ],
                  [
                    60308.2,
                    27433.8
                  ]
                ],
                "id": 448,
                "chat_link": "[&BMABAAA=]"
              },
              "449": {
                "name": "Western Bulwark",
                "level": 57,
                "coord": [
                  60014.2,
                  27381.5
                ],
                "bounds": [
                  [
                    60119.7,
                    27863.4
                  ],
                  [
                    60342.2,
                    27698
                  ],
                  [
                    60309.1,
                    27433.6
                  ],
                  [
                    59985.5,
                    27005.6
                  ],
                  [
                    59864.3,
                    26989.7
                  ],
                  [
                    59852.4,
                    27087
                  ],
                  [
                    59896,
                    27099.2
                  ],
                  [
                    59838.8,
                    27364.9
                  ],
                  [
                    59919.9,
                    27892.1
                  ],
                  [
                    60119.7,
                    27863.4
                  ]
                ],
                "id": 449,
                "chat_link": "[&BMEBAAA=]"
              },
              "450": {
                "name": "Lake Carnifex",
                "level": 58,
                "coord": [
                  60375.3,
                  27120.4
                ],
                "bounds": [
                  [
                    60624.4,
                    27348.9
                  ],
                  [
                    60308,
                    27433.5
                  ],
                  [
                    59985.2,
                    27004.8
                  ],
                  [
                    60065.8,
                    26901.1
                  ],
                  [
                    60260.5,
                    27113.3
                  ],
                  [
                    60474.8,
                    27109
                  ],
                  [
                    60543.6,
                    26971.8
                  ],
                  [
                    60740.1,
                    27080.7
                  ],
                  [
                    60624.4,
                    27348.9
                  ]
                ],
                "id": 450,
                "chat_link": "[&BMIBAAA=]"
              },
              "451": {
                "name": "Victium Moors",
                "level": 60,
                "coord": [
                  60173.8,
                  26726.5
                ],
                "bounds": [
                  [
                    59983.5,
                    27010.9
                  ],
                  [
                    59899.5,
                    26999.2
                  ],
                  [
                    59875,
                    26921
                  ],
                  [
                    59887.9,
                    26595
                  ],
                  [
                    59966.7,
                    26345.3
                  ],
                  [
                    60158.3,
                    26318.5
                  ],
                  [
                    60273.6,
                    26231.3
                  ],
                  [
                    60328.2,
                    26359.8
                  ],
                  [
                    60541.5,
                    26560.8
                  ],
                  [
                    60544,
                    26971.9
                  ],
                  [
                    60474.8,
                    27110
                  ],
                  [
                    60259.9,
                    27113.2
                  ],
                  [
                    60065.9,
                    26907.8
                  ],
                  [
                    59983.5,
                    27010.9
                  ]
                ],
                "id": 451,
                "chat_link": "[&BMMBAAA=]"
              },
              "452": {
                "name": "Scorchlands",
                "level": 60,
                "coord": [
                  60042.4,
                  25977.2
                ],
                "bounds": [
                  [
                    60171.5,
                    25625.1
                  ],
                  [
                    60283.7,
                    25687.9
                  ],
                  [
                    60333.1,
                    25796.2
                  ],
                  [
                    60273.9,
                    26235
                  ],
                  [
                    60158.3,
                    26319.1
                  ],
                  [
                    59966.3,
                    26344.6
                  ],
                  [
                    59897.8,
                    26229
                  ],
                  [
                    59797.4,
                    26127.7
                  ],
                  [
                    59775,
                    25897.4
                  ],
                  [
                    59876.6,
                    25791.2
                  ],
                  [
                    59932.9,
                    25696.3
                  ],
                  [
                    60171.5,
                    25625.1
                  ]
                ],
                "id": 452,
                "chat_link": "[&BMQBAAA=]"
              },
              "453": {
                "name": "Obsidian Run",
                "level": 59,
                "coord": [
                  61230.1,
                  26473.2
                ],
                "bounds": [
                  [
                    61176.9,
                    26781.6
                  ],
                  [
                    61273.7,
                    26651.1
                  ],
                  [
                    61546,
                    26535
                  ],
                  [
                    61526.2,
                    26278.5
                  ],
                  [
                    61290.3,
                    26324.3
                  ],
                  [
                    60865.4,
                    26157.2
                  ],
                  [
                    60932.6,
                    26584.8
                  ],
                  [
                    61176.9,
                    26781.6
                  ]
                ],
                "id": 453,
                "chat_link": "[&BMUBAAA=]"
              },
              "454": {
                "name": "The Infestation",
                "level": 59,
                "coord": [
                  61307.4,
                  26061.9
                ],
                "bounds": [
                  [
                    61726.4,
                    25954.6
                  ],
                  [
                    61663.6,
                    26216.9
                  ],
                  [
                    61525.3,
                    26279
                  ],
                  [
                    61289,
                    26324.7
                  ],
                  [
                    60863.7,
                    26156.3
                  ],
                  [
                    60851.5,
                    25979.2
                  ],
                  [
                    61007.2,
                    25889.4
                  ],
                  [
                    61267.5,
                    25860.3
                  ],
                  [
                    61572.7,
                    25896.6
                  ],
                  [
                    61726.4,
                    25954.6
                  ]
                ],
                "id": 454,
                "chat_link": "[&BMYBAAA=]"
              },
              "455": {
                "name": "Harvester's Glade",
                "level": 51,
                "coord": [
                  61129.8,
                  28853.7
                ],
                "bounds": [
                  [
                    61148.9,
                    28583.6
                  ],
                  [
                    61253.1,
                    28590.6
                  ],
                  [
                    61366.7,
                    28876.3
                  ],
                  [
                    61281.8,
                    28992.6
                  ],
                  [
                    61099.7,
                    29075.5
                  ],
                  [
                    60962.6,
                    29005.3
                  ],
                  [
                    60915.4,
                    28939.3
                  ],
                  [
                    61010.3,
                    28766.8
                  ],
                  [
                    61148.9,
                    28583.6
                  ]
                ],
                "id": 455,
                "chat_link": "[&BMcBAAA=]"
              },
              "456": {
                "name": "Echoslab Arches",
                "level": 53,
                "coord": [
                  60135,
                  29755.7
                ],
                "bounds": [
                  [
                    60345,
                    29856.3
                  ],
                  [
                    60332.8,
                    29597.4
                  ],
                  [
                    60142.5,
                    29464.5
                  ],
                  [
                    59952.3,
                    29518
                  ],
                  [
                    59868.9,
                    29711.8
                  ],
                  [
                    59919.6,
                    29932.4
                  ],
                  [
                    60173.9,
                    29989.8
                  ],
                  [
                    60345.5,
                    29975.1
                  ],
                  [
                    60345,
                    29856.3
                  ]
                ],
                "id": 456,
                "chat_link": "[&BMgBAAA=]"
              },
              "457": {
                "name": "Ebbing Heart Run",
                "level": 59,
                "coord": [
                  61761.6,
                  26193.5
                ],
                "bounds": [
                  [
                    61546.5,
                    26534.7
                  ],
                  [
                    61802.1,
                    26532.2
                  ],
                  [
                    61883,
                    26305.9
                  ],
                  [
                    61936.2,
                    26173.6
                  ],
                  [
                    61928.4,
                    25975
                  ],
                  [
                    61832,
                    25844.7
                  ],
                  [
                    61737.3,
                    25877.4
                  ],
                  [
                    61664.5,
                    26218.3
                  ],
                  [
                    61524.7,
                    26279.5
                  ],
                  [
                    61546.5,
                    26534.7
                  ]
                ],
                "id": 457,
                "chat_link": "[&BMkBAAA=]"
              },
              "458": {
                "name": "Gladefall Run",
                "level": 60,
                "coord": [
                  60602,
                  26324.4
                ],
                "bounds": [
                  [
                    60273.1,
                    26233.3
                  ],
                  [
                    60327.8,
                    26363.8
                  ],
                  [
                    60541.3,
                    26560.7
                  ],
                  [
                    60542.8,
                    26972
                  ],
                  [
                    60739.8,
                    27082.3
                  ],
                  [
                    60933.3,
                    26585.3
                  ],
                  [
                    60865,
                    26157.5
                  ],
                  [
                    60851.2,
                    25958.5
                  ],
                  [
                    60721.5,
                    25905.5
                  ],
                  [
                    60492.7,
                    25896.5
                  ],
                  [
                    60333.3,
                    25852.8
                  ],
                  [
                    60273.1,
                    26233.3
                  ]
                ],
                "id": 458,
                "chat_link": "[&BMoBAAA=]"
              }
            },
            "id": 1118,
            "mastery_points": [],
            "adventures": []
          },
          "1123": {
            "name": "Blightwater Shatterstrike",
            "min_level": 40,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              62998,
              30464
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                61952,
                28544
              ],
              [
                64000,
                32640
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "484": {
                "name": "Tawny Ridge",
                "level": 49,
                "coord": [
                  63787.3,
                  29317.5
                ],
                "bounds": [
                  [
                    63834.3,
                    29385.9
                  ],
                  [
                    63878.9,
                    29286.7
                  ],
                  [
                    63836.8,
                    29212
                  ],
                  [
                    63745.4,
                    29237.2
                  ],
                  [
                    63699,
                    29364
                  ],
                  [
                    63729.6,
                    29419
                  ],
                  [
                    63834.3,
                    29385.9
                  ]
                ],
                "id": 484,
                "chat_link": "[&BOQBAAA=]"
              },
              "485": {
                "name": "Steeleye Span",
                "level": 43,
                "coord": [
                  62529.3,
                  31630.3
                ],
                "bounds": [
                  [
                    62334,
                    31493.3
                  ],
                  [
                    62569.1,
                    31511.8
                  ],
                  [
                    62764.5,
                    31653.4
                  ],
                  [
                    62647.5,
                    31807
                  ],
                  [
                    62331.5,
                    31685.8
                  ],
                  [
                    62334,
                    31493.3
                  ]
                ],
                "id": 485,
                "chat_link": "[&BOUBAAA=]"
              },
              "486": {
                "name": "Deserter Flats",
                "level": 45,
                "coord": [
                  62613.5,
                  30722.1
                ],
                "bounds": [
                  [
                    62439.6,
                    30695.3
                  ],
                  [
                    62452.9,
                    30472.3
                  ],
                  [
                    62598.7,
                    30334.8
                  ],
                  [
                    62811.9,
                    30457.6
                  ],
                  [
                    62958.3,
                    30707.9
                  ],
                  [
                    62839.8,
                    30912.9
                  ],
                  [
                    62726.3,
                    30877.3
                  ],
                  [
                    62641.9,
                    30973.8
                  ],
                  [
                    62351.8,
                    31035.3
                  ],
                  [
                    62313.7,
                    30754.1
                  ],
                  [
                    62439.6,
                    30695.3
                  ]
                ],
                "id": 486,
                "chat_link": "[&BOYBAAA=]"
              },
              "487": {
                "name": "Hazmagic Aggregate",
                "level": 48,
                "coord": [
                  62738.3,
                  30060.6
                ],
                "bounds": [
                  [
                    62811.3,
                    30462.7
                  ],
                  [
                    62929.5,
                    30273.1
                  ],
                  [
                    62928.1,
                    30070
                  ],
                  [
                    62816,
                    29773.8
                  ],
                  [
                    62843.9,
                    29606.6
                  ],
                  [
                    62492,
                    29699.6
                  ],
                  [
                    62573.5,
                    30053.8
                  ],
                  [
                    62658.6,
                    30065.7
                  ],
                  [
                    62730.9,
                    30263
                  ],
                  [
                    62598.8,
                    30337.7
                  ],
                  [
                    62811.3,
                    30462.7
                  ]
                ],
                "id": 487,
                "chat_link": "[&BOcBAAA=]"
              },
              "488": {
                "name": "Foulblain Expanse",
                "level": 43,
                "coord": [
                  62557.5,
                  31301.7
                ],
                "bounds": [
                  [
                    62337.1,
                    31156.7
                  ],
                  [
                    62350.8,
                    31028.3
                  ],
                  [
                    62645.7,
                    30961.6
                  ],
                  [
                    62603.2,
                    31125.8
                  ],
                  [
                    62658.3,
                    31339.5
                  ],
                  [
                    62753.8,
                    31420.5
                  ],
                  [
                    62762.4,
                    31655.3
                  ],
                  [
                    62568.6,
                    31523.9
                  ],
                  [
                    62337.9,
                    31504.2
                  ],
                  [
                    62337.1,
                    31156.7
                  ]
                ],
                "id": 488,
                "chat_link": "[&BOgBAAA=]"
              },
              "489": {
                "name": "Lowland Burns",
                "level": 50,
                "coord": [
                  62333.4,
                  28730.6
                ],
                "bounds": [
                  [
                    62331.1,
                    28939.1
                  ],
                  [
                    62257.1,
                    28819.7
                  ],
                  [
                    62090.8,
                    28826.8
                  ],
                  [
                    61794.4,
                    28687.8
                  ],
                  [
                    61938.5,
                    28177.5
                  ],
                  [
                    62027.6,
                    28190.3
                  ],
                  [
                    62106.3,
                    28274.4
                  ],
                  [
                    62222.5,
                    28337.8
                  ],
                  [
                    62320,
                    28413.6
                  ],
                  [
                    62385.2,
                    28509.2
                  ],
                  [
                    62435.3,
                    28600.1
                  ],
                  [
                    62517.2,
                    28640.4
                  ],
                  [
                    62670,
                    29018.7
                  ],
                  [
                    62922.2,
                    29225.1
                  ],
                  [
                    62890,
                    29333.1
                  ],
                  [
                    62446,
                    29308.9
                  ],
                  [
                    62313.5,
                    29117.5
                  ],
                  [
                    62331.1,
                    28939.1
                  ]
                ],
                "id": 489,
                "chat_link": "[&BOkBAAA=]"
              },
              "490": {
                "name": "Blightwater Basin",
                "level": 42,
                "coord": [
                  62087.1,
                  32282.7
                ],
                "bounds": [
                  [
                    62475.8,
                    32616.7
                  ],
                  [
                    62449.6,
                    32150.3
                  ],
                  [
                    62646.2,
                    31808.5
                  ],
                  [
                    62331.8,
                    31685.8
                  ],
                  [
                    62326.8,
                    31780.5
                  ],
                  [
                    61973.7,
                    31941.7
                  ],
                  [
                    61509.8,
                    32070.4
                  ],
                  [
                    61678.1,
                    32224.7
                  ],
                  [
                    61761.7,
                    32366.7
                  ],
                  [
                    61787.2,
                    32521.6
                  ],
                  [
                    61870.1,
                    32635.4
                  ],
                  [
                    62002.2,
                    32677.4
                  ],
                  [
                    62097.8,
                    32730.4
                  ],
                  [
                    62308.7,
                    32747.6
                  ],
                  [
                    62475.8,
                    32616.7
                  ]
                ],
                "id": 490,
                "chat_link": "[&BOoBAAA=]"
              },
              "491": {
                "name": "Tumok's Last Stand",
                "level": 42,
                "coord": [
                  62708.1,
                  32441.5
                ],
                "bounds": [
                  [
                    62475.4,
                    32613.9
                  ],
                  [
                    62574.8,
                    32661.6
                  ],
                  [
                    62807.9,
                    32713.7
                  ],
                  [
                    62940,
                    32662.1
                  ],
                  [
                    62957.1,
                    32598.9
                  ],
                  [
                    63050.1,
                    32235.4
                  ],
                  [
                    62644.3,
                    31809.7
                  ],
                  [
                    62452.7,
                    32155.4
                  ],
                  [
                    62470.8,
                    32522.3
                  ],
                  [
                    62475.4,
                    32613.9
                  ]
                ],
                "id": 491,
                "chat_link": "[&BOsBAAA=]"
              },
              "492": {
                "name": "Pockmark Roughs",
                "level": 45,
                "coord": [
                  63227.9,
                  31010.7
                ],
                "bounds": [
                  [
                    62841,
                    30913.6
                  ],
                  [
                    62955.5,
                    30712.2
                  ],
                  [
                    63229.3,
                    30638.3
                  ],
                  [
                    63447.8,
                    30736.4
                  ],
                  [
                    63538.4,
                    30885.5
                  ],
                  [
                    63527.2,
                    31093
                  ],
                  [
                    63443.4,
                    31236.1
                  ],
                  [
                    63307.8,
                    31352.4
                  ],
                  [
                    63109.2,
                    31370.7
                  ],
                  [
                    62879.8,
                    31168.8
                  ],
                  [
                    62841,
                    30913.6
                  ]
                ],
                "id": 492,
                "chat_link": "[&BOwBAAA=]"
              },
              "493": {
                "name": "Crater Rim",
                "level": 42,
                "coord": [
                  62868.6,
                  31245.7
                ],
                "bounds": [
                  [
                    62751.9,
                    31427.3
                  ],
                  [
                    62658.5,
                    31342.8
                  ],
                  [
                    62601,
                    31130.2
                  ],
                  [
                    62636.8,
                    30977.7
                  ],
                  [
                    62730.2,
                    30877.8
                  ],
                  [
                    62840.6,
                    30911.7
                  ],
                  [
                    62877.2,
                    31164.1
                  ],
                  [
                    63108.9,
                    31367.5
                  ],
                  [
                    63307.8,
                    31349.7
                  ],
                  [
                    63280.4,
                    31498.4
                  ],
                  [
                    62760.8,
                    31655
                  ],
                  [
                    62751.9,
                    31427.3
                  ]
                ],
                "id": 493,
                "chat_link": "[&BO0BAAA=]"
              },
              "494": {
                "name": "Behem Gauntlet",
                "level": 42,
                "coord": [
                  63694.3,
                  31526.8
                ],
                "bounds": [
                  [
                    63271.2,
                    31726
                  ],
                  [
                    63385.2,
                    31922
                  ],
                  [
                    63651.7,
                    31679.6
                  ],
                  [
                    63924.3,
                    31814.5
                  ],
                  [
                    64038.7,
                    31803.6
                  ],
                  [
                    64094,
                    31571.6
                  ],
                  [
                    64085.1,
                    31319.6
                  ],
                  [
                    63942.8,
                    31304.5
                  ],
                  [
                    63873.8,
                    31387.6
                  ],
                  [
                    63782,
                    31414.4
                  ],
                  [
                    63740.9,
                    31473.9
                  ],
                  [
                    63595.5,
                    31417.7
                  ],
                  [
                    63441.6,
                    31227.4
                  ],
                  [
                    63311.4,
                    31343.3
                  ],
                  [
                    63276.7,
                    31496.2
                  ],
                  [
                    63271.2,
                    31726
                  ]
                ],
                "id": 494,
                "chat_link": "[&BO4BAAA=]"
              },
              "495": {
                "name": "Unbroken Expanse",
                "level": 45,
                "coord": [
                  63211.9,
                  30390.3
                ],
                "bounds": [
                  [
                    63228.8,
                    30645.9
                  ],
                  [
                    63447.9,
                    30738.9
                  ],
                  [
                    63594.9,
                    30605.9
                  ],
                  [
                    63546,
                    30298.3
                  ],
                  [
                    63595.9,
                    30138.5
                  ],
                  [
                    63083,
                    29956.2
                  ],
                  [
                    62925.8,
                    30070.6
                  ],
                  [
                    62926.9,
                    30273.4
                  ],
                  [
                    62810.4,
                    30458.3
                  ],
                  [
                    62959.4,
                    30717.1
                  ],
                  [
                    63228.8,
                    30645.9
                  ]
                ],
                "id": 495,
                "chat_link": "[&BO8BAAA=]"
              },
              "496": {
                "name": "Gastor Gullet",
                "level": 45,
                "coord": [
                  63716,
                  31092.8
                ],
                "bounds": [
                  [
                    63527.8,
                    31091.7
                  ],
                  [
                    63538.8,
                    30886.2
                  ],
                  [
                    63447.1,
                    30737.8
                  ],
                  [
                    63593.5,
                    30606.3
                  ],
                  [
                    63767.3,
                    30670.9
                  ],
                  [
                    63870.3,
                    30901.8
                  ],
                  [
                    63918.4,
                    31019.5
                  ],
                  [
                    63979.9,
                    31145
                  ],
                  [
                    63944.9,
                    31306.2
                  ],
                  [
                    63875,
                    31387.9
                  ],
                  [
                    63782.4,
                    31416.7
                  ],
                  [
                    63740.2,
                    31476.7
                  ],
                  [
                    63594,
                    31418.9
                  ],
                  [
                    63445,
                    31233.4
                  ],
                  [
                    63527.8,
                    31091.7
                  ]
                ],
                "id": 496,
                "chat_link": "[&BPABAAA=]"
              },
              "497": {
                "name": "Degun Shun",
                "level": 45,
                "coord": [
                  63692.8,
                  30247.4
                ],
                "bounds": [
                  [
                    63695,
                    30391.3
                  ],
                  [
                    63851.2,
                    30298.3
                  ],
                  [
                    63781.1,
                    30177
                  ],
                  [
                    63698.5,
                    30183.2
                  ],
                  [
                    63586.8,
                    30135.9
                  ],
                  [
                    63544.1,
                    30298.9
                  ],
                  [
                    63695,
                    30391.3
                  ]
                ],
                "id": 497,
                "chat_link": "[&BPEBAAA=]"
              },
              "498": {
                "name": "Agrak Kraal",
                "level": 45,
                "coord": [
                  63888,
                  30702.1
                ],
                "bounds": [
                  [
                    63855.5,
                    30566.8
                  ],
                  [
                    63937.4,
                    30576.7
                  ],
                  [
                    63946.3,
                    30708
                  ],
                  [
                    63970,
                    30827.9
                  ],
                  [
                    63847.8,
                    30864
                  ],
                  [
                    63771.2,
                    30669.4
                  ],
                  [
                    63855.5,
                    30566.8
                  ]
                ],
                "id": 498,
                "chat_link": "[&BPIBAAA=]"
              },
              "499": {
                "name": "Twin Sisters Crossing",
                "level": 42,
                "coord": [
                  63862.8,
                  32402.3
                ],
                "bounds": [
                  [
                    63927,
                    32682.5
                  ],
                  [
                    63797.7,
                    32729.8
                  ],
                  [
                    63678.9,
                    32732
                  ],
                  [
                    63567.1,
                    32672.7
                  ],
                  [
                    63547.2,
                    32581.1
                  ],
                  [
                    63612.6,
                    32474.9
                  ],
                  [
                    63559.8,
                    32276.8
                  ],
                  [
                    63645.6,
                    32136.1
                  ],
                  [
                    63901.9,
                    31992.3
                  ],
                  [
                    63945,
                    32022
                  ],
                  [
                    63957.7,
                    32129.7
                  ],
                  [
                    64026.3,
                    32249.1
                  ],
                  [
                    64121.1,
                    32326.2
                  ],
                  [
                    64202.4,
                    32366.9
                  ],
                  [
                    64241,
                    32436.5
                  ],
                  [
                    64074.1,
                    32628.4
                  ],
                  [
                    63927,
                    32682.5
                  ]
                ],
                "id": 499,
                "chat_link": "[&BPMBAAA=]"
              },
              "500": {
                "name": "Splinter Hills",
                "level": 42,
                "coord": [
                  63436.8,
                  32369.6
                ],
                "bounds": [
                  [
                    63036.6,
                    32228.9
                  ],
                  [
                    63648.4,
                    31681.5
                  ],
                  [
                    63923.3,
                    31813.4
                  ],
                  [
                    63906.8,
                    31993.9
                  ],
                  [
                    63645.5,
                    32137.2
                  ],
                  [
                    63559.9,
                    32277.8
                  ],
                  [
                    63612.5,
                    32475.6
                  ],
                  [
                    63548.9,
                    32581.5
                  ],
                  [
                    63569.1,
                    32673.9
                  ],
                  [
                    63427,
                    32726.4
                  ],
                  [
                    63250.9,
                    32645.8
                  ],
                  [
                    63095.1,
                    32692.7
                  ],
                  [
                    62937.4,
                    32653.1
                  ],
                  [
                    62953.7,
                    32592.1
                  ],
                  [
                    63036.6,
                    32228.9
                  ]
                ],
                "id": 500,
                "chat_link": "[&BPQBAAA=]"
              },
              "501": {
                "name": "Soot Road",
                "level": 42,
                "coord": [
                  63065.7,
                  31805.3
                ],
                "bounds": [
                  [
                    62763.1,
                    31650.1
                  ],
                  [
                    63278.9,
                    31499.1
                  ],
                  [
                    63273,
                    31723.4
                  ],
                  [
                    63386.3,
                    31922.3
                  ],
                  [
                    63044.8,
                    32226.1
                  ],
                  [
                    62647.9,
                    31810.5
                  ],
                  [
                    62763.1,
                    31650.1
                  ]
                ],
                "id": 501,
                "chat_link": "[&BPUBAAA=]"
              },
              "502": {
                "name": "Tongue Rock",
                "level": 45,
                "coord": [
                  62007.1,
                  30517.7
                ],
                "bounds": [
                  [
                    62232.6,
                    30493.1
                  ],
                  [
                    62156,
                    30619.2
                  ],
                  [
                    61988.4,
                    30604.4
                  ],
                  [
                    61818.8,
                    30755.6
                  ],
                  [
                    61834,
                    30623.4
                  ],
                  [
                    61898.2,
                    30479.3
                  ],
                  [
                    61876.1,
                    30403.2
                  ],
                  [
                    62014.4,
                    30456.3
                  ],
                  [
                    62099.9,
                    30361.9
                  ],
                  [
                    62152.6,
                    30381
                  ],
                  [
                    62232.6,
                    30493.1
                  ]
                ],
                "id": 502,
                "chat_link": "[&BPYBAAA=]"
              },
              "503": {
                "name": "Terra Combusta",
                "level": 49,
                "coord": [
                  62967.3,
                  28959.5
                ],
                "bounds": [
                  [
                    62914.2,
                    29238.7
                  ],
                  [
                    62669.5,
                    29019
                  ],
                  [
                    62515.1,
                    28641.8
                  ],
                  [
                    62776.6,
                    28568.7
                  ],
                  [
                    63054.8,
                    28653
                  ],
                  [
                    63103.2,
                    28738.1
                  ],
                  [
                    63387,
                    28803.3
                  ],
                  [
                    63161.3,
                    29217.8
                  ],
                  [
                    63199,
                    29380.4
                  ],
                  [
                    62891.9,
                    29334.6
                  ],
                  [
                    62914.2,
                    29238.7
                  ]
                ],
                "id": 503,
                "chat_link": "[&BPcBAAA=]"
              },
              "504": {
                "name": "Terra Carorunda",
                "level": 49,
                "coord": [
                  63646.7,
                  29033.7
                ],
                "bounds": [
                  [
                    63201.7,
                    29381.4
                  ],
                  [
                    63409.6,
                    29507.8
                  ],
                  [
                    63750.9,
                    29457.3
                  ],
                  [
                    63700,
                    29362.1
                  ],
                  [
                    63748.1,
                    29237
                  ],
                  [
                    63838.9,
                    29214.4
                  ],
                  [
                    63881,
                    29161.8
                  ],
                  [
                    63872.6,
                    28991.6
                  ],
                  [
                    63962.4,
                    28839.9
                  ],
                  [
                    63943.6,
                    28602.4
                  ],
                  [
                    63754.8,
                    28591
                  ],
                  [
                    63640.6,
                    28555.1
                  ],
                  [
                    63447.2,
                    28584
                  ],
                  [
                    63389.2,
                    28801
                  ],
                  [
                    63160.3,
                    29218.5
                  ],
                  [
                    63201.7,
                    29381.4
                  ]
                ],
                "id": 504,
                "chat_link": "[&BPgBAAA=]"
              },
              "505": {
                "name": "Shattered Palisades",
                "level": 49,
                "coord": [
                  63287.8,
                  29508.3
                ],
                "bounds": [
                  [
                    63449.3,
                    29664.6
                  ],
                  [
                    63735.3,
                    29560.1
                  ],
                  [
                    63750.7,
                    29455.5
                  ],
                  [
                    63408.7,
                    29506
                  ],
                  [
                    63200.8,
                    29377.6
                  ],
                  [
                    62817.8,
                    29319.5
                  ],
                  [
                    62844.4,
                    29604.2
                  ],
                  [
                    63095.2,
                    29579.1
                  ],
                  [
                    63449.3,
                    29664.6
                  ]
                ],
                "id": 505,
                "chat_link": "[&BPkBAAA=]"
              },
              "506": {
                "name": "Monument Grounds",
                "level": 50,
                "coord": [
                  62337.5,
                  29448.3
                ],
                "bounds": [
                  [
                    62494,
                    29697.9
                  ],
                  [
                    62842.3,
                    29604.2
                  ],
                  [
                    62815.3,
                    29323.4
                  ],
                  [
                    62445,
                    29310.7
                  ],
                  [
                    62394.7,
                    29405.1
                  ],
                  [
                    62030.1,
                    29409.7
                  ],
                  [
                    61826.2,
                    29318.8
                  ],
                  [
                    61852.4,
                    29516.2
                  ],
                  [
                    62494,
                    29697.9
                  ]
                ],
                "id": 506,
                "chat_link": "[&BPoBAAA=]"
              },
              "507": {
                "name": "Heretic Plain",
                "level": 47,
                "coord": [
                  63435.8,
                  29829
                ],
                "bounds": [
                  [
                    62818.3,
                    29770.1
                  ],
                  [
                    62841.7,
                    29605.5
                  ],
                  [
                    63095.3,
                    29579.2
                  ],
                  [
                    63445.5,
                    29663.5
                  ],
                  [
                    63733,
                    29560.5
                  ],
                  [
                    63873.3,
                    29555.4
                  ],
                  [
                    63930,
                    29805.3
                  ],
                  [
                    63930.2,
                    30021.5
                  ],
                  [
                    63856.9,
                    30170.4
                  ],
                  [
                    63696.5,
                    30184.3
                  ],
                  [
                    63082.1,
                    29961.7
                  ],
                  [
                    62926.8,
                    30071.2
                  ],
                  [
                    62818.3,
                    29770.1
                  ]
                ],
                "id": 507,
                "chat_link": "[&BPsBAAA=]"
              },
              "508": {
                "name": "Kindling Bridge",
                "level": 50,
                "coord": [
                  62106.6,
                  29094
                ],
                "bounds": [
                  [
                    61831.5,
                    29315.7
                  ],
                  [
                    61875,
                    29191.1
                  ],
                  [
                    61781.9,
                    29002.1
                  ],
                  [
                    61799.7,
                    28689.3
                  ],
                  [
                    62091.7,
                    28823.8
                  ],
                  [
                    62261.8,
                    28824.8
                  ],
                  [
                    62335.3,
                    28942.4
                  ],
                  [
                    62313.2,
                    29121.6
                  ],
                  [
                    62450.6,
                    29310
                  ],
                  [
                    62398.5,
                    29405.6
                  ],
                  [
                    62033.3,
                    29407.7
                  ],
                  [
                    61831.5,
                    29315.7
                  ]
                ],
                "id": 508,
                "chat_link": "[&BPwBAAA=]"
              },
              "509": {
                "name": "Dragonwatch",
                "level": 43,
                "coord": [
                  62071,
                  31427.8
                ],
                "bounds": [
                  [
                    62326.5,
                    31774.7
                  ],
                  [
                    62338.5,
                    31506.3
                  ],
                  [
                    62339,
                    31156.7
                  ],
                  [
                    62107.7,
                    31209.2
                  ],
                  [
                    61953.1,
                    31186
                  ],
                  [
                    61952,
                    31215.8
                  ],
                  [
                    61944.9,
                    31281.9
                  ],
                  [
                    61954.3,
                    31359.3
                  ],
                  [
                    61819.8,
                    31647.2
                  ],
                  [
                    61974.8,
                    31940.8
                  ],
                  [
                    62326.5,
                    31774.7
                  ]
                ],
                "id": 509,
                "chat_link": "[&BP0BAAA=]"
              },
              "510": {
                "name": "Ratcatcher Knoll",
                "level": 45,
                "coord": [
                  62202.2,
                  30748
                ],
                "bounds": [
                  [
                    62107.6,
                    31211
                  ],
                  [
                    61958.7,
                    31186.4
                  ],
                  [
                    61818.8,
                    30757.4
                  ],
                  [
                    61993.7,
                    30604.6
                  ],
                  [
                    62153.8,
                    30620.1
                  ],
                  [
                    62231.2,
                    30491.7
                  ],
                  [
                    62150.8,
                    30381.6
                  ],
                  [
                    62310.9,
                    30344.7
                  ],
                  [
                    62456.3,
                    30474.6
                  ],
                  [
                    62442.6,
                    30698.2
                  ],
                  [
                    62314.6,
                    30758.1
                  ],
                  [
                    62354.1,
                    31035.8
                  ],
                  [
                    62334.9,
                    31159.4
                  ],
                  [
                    62107.6,
                    31211
                  ]
                ],
                "id": 510,
                "chat_link": "[&BP4BAAA=]"
              },
              "511": {
                "name": "Relliatus Canyon",
                "level": 47,
                "coord": [
                  62217.2,
                  30139.4
                ],
                "bounds": [
                  [
                    62010,
                    30457.9
                  ],
                  [
                    62100.9,
                    30361.2
                  ],
                  [
                    62151.1,
                    30381
                  ],
                  [
                    62311,
                    30347.8
                  ],
                  [
                    62455,
                    30476.1
                  ],
                  [
                    62600.2,
                    30334.8
                  ],
                  [
                    62464.6,
                    30156.9
                  ],
                  [
                    62476.8,
                    30058.2
                  ],
                  [
                    62573.8,
                    30052.6
                  ],
                  [
                    62494.1,
                    29698.1
                  ],
                  [
                    61853.7,
                    29509.6
                  ],
                  [
                    61831.6,
                    29761.8
                  ],
                  [
                    61837.2,
                    29956.5
                  ],
                  [
                    61880.5,
                    30399.3
                  ],
                  [
                    62010,
                    30457.9
                  ]
                ],
                "id": 511,
                "chat_link": "[&BP8BAAA=]"
              },
              "758": {
                "name": "InGenium Research Facility",
                "level": 48,
                "coord": [
                  62584.6,
                  30155.2
                ],
                "bounds": [
                  [
                    62463.8,
                    30156.9
                  ],
                  [
                    62476.9,
                    30056.9
                  ],
                  [
                    62577.4,
                    30050.8
                  ],
                  [
                    62660.6,
                    30065.2
                  ],
                  [
                    62729.8,
                    30264
                  ],
                  [
                    62599.3,
                    30337.5
                  ],
                  [
                    62463.8,
                    30156.9
                  ]
                ],
                "id": 758,
                "chat_link": "[&BPYCAAA=]"
              }
            },
            "id": 1123,
            "mastery_points": [],
            "adventures": []
          },
          "1129": {
            "name": "Langmar Estate",
            "min_level": 1,
            "max_level": 15,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "270": {
                "name": "Village of Smokestead",
                "level": 3,
                "coord": [
                  58156.3,
                  30833.9
                ],
                "bounds": [
                  [
                    57856,
                    30550.5
                  ],
                  [
                    57996.7,
                    30571
                  ],
                  [
                    58378.9,
                    30592.8
                  ],
                  [
                    58545.1,
                    30743.8
                  ],
                  [
                    58526.7,
                    30851.5
                  ],
                  [
                    58424.6,
                    31121.2
                  ],
                  [
                    58158.3,
                    31028.9
                  ],
                  [
                    58070.5,
                    31085.8
                  ],
                  [
                    57749.8,
                    31164.6
                  ],
                  [
                    57856,
                    30629.3
                  ],
                  [
                    57856,
                    30550.5
                  ]
                ],
                "id": 270,
                "chat_link": "[&BA4BAAA=]"
              },
              "271": {
                "name": "Tela Range",
                "level": 4,
                "coord": [
                  57985.5,
                  30119.3
                ],
                "bounds": [
                  [
                    57802.3,
                    30344.5
                  ],
                  [
                    57985.1,
                    30336.5
                  ],
                  [
                    58225.7,
                    30165
                  ],
                  [
                    58232.5,
                    30110.6
                  ],
                  [
                    58153.4,
                    30012.7
                  ],
                  [
                    58021.3,
                    29815.9
                  ],
                  [
                    57795.6,
                    29955.1
                  ],
                  [
                    57668.2,
                    30213.8
                  ],
                  [
                    57802.3,
                    30344.5
                  ]
                ],
                "id": 271,
                "chat_link": "[&BA8BAAA=]"
              },
              "272": {
                "name": "Victor's Presidium",
                "level": 6,
                "coord": [
                  58619.5,
                  31354.6
                ],
                "bounds": [
                  [
                    58377.7,
                    31462.3
                  ],
                  [
                    58107,
                    31444.8
                  ],
                  [
                    58067.5,
                    31084.7
                  ],
                  [
                    58154.6,
                    31026.6
                  ],
                  [
                    58424.9,
                    31119
                  ],
                  [
                    58528.8,
                    30853.1
                  ],
                  [
                    58778.9,
                    31012.2
                  ],
                  [
                    58956.4,
                    30865.6
                  ],
                  [
                    58960.7,
                    31165.8
                  ],
                  [
                    59145.5,
                    31508.3
                  ],
                  [
                    59152.1,
                    31641.5
                  ],
                  [
                    59030.3,
                    31713.5
                  ],
                  [
                    58675.4,
                    31650.2
                  ],
                  [
                    58573.1,
                    31815.7
                  ],
                  [
                    58477,
                    31779.6
                  ],
                  [
                    58501.8,
                    31530
                  ],
                  [
                    58377.7,
                    31462.3
                  ]
                ],
                "id": 272,
                "chat_link": "[&BBABAAA=]"
              },
              "273": {
                "name": "Lake Feritas",
                "level": 5,
                "coord": [
                  58714.1,
                  30124.2
                ],
                "bounds": [
                  [
                    58961.2,
                    30433.2
                  ],
                  [
                    59149.5,
                    30224.9
                  ],
                  [
                    58926.3,
                    30089.1
                  ],
                  [
                    58821.3,
                    29908.7
                  ],
                  [
                    58622.6,
                    29930.8
                  ],
                  [
                    58466.7,
                    29814.3
                  ],
                  [
                    58351.4,
                    29933.1
                  ],
                  [
                    58466.9,
                    30121.5
                  ],
                  [
                    58626.4,
                    30199
                  ],
                  [
                    58748.8,
                    30587.3
                  ],
                  [
                    58961.2,
                    30433.2
                  ]
                ],
                "id": 273,
                "chat_link": "[&BBEBAAA=]"
              },
              "274": {
                "name": "Old Duke's Estate",
                "level": 6,
                "coord": [
                  58786.2,
                  30721.7
                ],
                "bounds": [
                  [
                    58780.2,
                    31015.2
                  ],
                  [
                    58526.3,
                    30852.5
                  ],
                  [
                    58543.1,
                    30742.7
                  ],
                  [
                    58748,
                    30587
                  ],
                  [
                    58960.9,
                    30433.3
                  ],
                  [
                    59158.8,
                    30699.4
                  ],
                  [
                    58780.2,
                    31015.2
                  ]
                ],
                "id": 274,
                "chat_link": "[&BBIBAAA=]"
              },
              "275": {
                "name": "Decimus Stones",
                "level": 7,
                "coord": [
                  58311.8,
                  31605.8
                ],
                "bounds": [
                  [
                    58105.3,
                    31758
                  ],
                  [
                    58287.2,
                    31766.5
                  ],
                  [
                    58491.2,
                    31678.8
                  ],
                  [
                    58499,
                    31527.7
                  ],
                  [
                    58381,
                    31461.2
                  ],
                  [
                    58107.3,
                    31442.4
                  ],
                  [
                    58105.3,
                    31758
                  ]
                ],
                "id": 275,
                "chat_link": "[&BBMBAAA=]"
              },
              "276": {
                "name": "Charr's Triumph",
                "level": 8,
                "coord": [
                  59352.1,
                  31140.9
                ],
                "bounds": [
                  [
                    59776,
                    31147.4
                  ],
                  [
                    59708.5,
                    30981.9
                  ],
                  [
                    59186.8,
                    30702.1
                  ],
                  [
                    58984.7,
                    30868.8
                  ],
                  [
                    58987.7,
                    31167.6
                  ],
                  [
                    59173.9,
                    31511.9
                  ],
                  [
                    59488.5,
                    31461.5
                  ],
                  [
                    59510.7,
                    31286.2
                  ],
                  [
                    59776,
                    31147.4
                  ]
                ],
                "id": 276,
                "chat_link": "[&BBQBAAA=]"
              },
              "277": {
                "name": "Martyr's Woods",
                "level": 7,
                "coord": [
                  59590,
                  30474.5
                ],
                "bounds": [
                  [
                    59560.1,
                    30894.6
                  ],
                  [
                    59675.6,
                    30968.6
                  ],
                  [
                    59690.2,
                    30862
                  ],
                  [
                    59791.4,
                    30755.1
                  ],
                  [
                    59841.6,
                    30697.2
                  ],
                  [
                    59923.6,
                    30631.9
                  ],
                  [
                    60012.8,
                    30625.2
                  ],
                  [
                    60015.7,
                    30511
                  ],
                  [
                    59960.6,
                    30423.9
                  ],
                  [
                    59972.9,
                    30374.3
                  ],
                  [
                    59902.5,
                    30279.9
                  ],
                  [
                    59716.5,
                    30309.4
                  ],
                  [
                    59512,
                    30254.2
                  ],
                  [
                    59422,
                    30134.8
                  ],
                  [
                    59317.8,
                    30001
                  ],
                  [
                    59074.2,
                    30119.8
                  ],
                  [
                    59157.5,
                    30232.6
                  ],
                  [
                    59078,
                    30274.2
                  ],
                  [
                    59005.9,
                    30466.7
                  ],
                  [
                    59169.3,
                    30673.2
                  ],
                  [
                    59560.1,
                    30894.6
                  ]
                ],
                "id": 277,
                "chat_link": "[&BBUBAAA=]"
              },
              "278": {
                "name": "Ashford Forum",
                "level": 9,
                "coord": [
                  59745.5,
                  31407.1
                ],
                "bounds": [
                  [
                    59649.1,
                    31596.6
                  ],
                  [
                    59917.3,
                    31638.5
                  ],
                  [
                    60067.2,
                    31518.5
                  ],
                  [
                    59901,
                    31208.4
                  ],
                  [
                    59747.3,
                    31144.2
                  ],
                  [
                    59478.6,
                    31284.4
                  ],
                  [
                    59458,
                    31459.4
                  ],
                  [
                    59649.1,
                    31596.6
                  ]
                ],
                "id": 278,
                "chat_link": "[&BBYBAAA=]"
              },
              "279": {
                "name": "Lake Adorea",
                "level": 11,
                "coord": [
                  59592.8,
                  31705.8
                ],
                "bounds": [
                  [
                    59313.5,
                    31972.8
                  ],
                  [
                    59547.6,
                    31870.2
                  ],
                  [
                    59677,
                    31959.9
                  ],
                  [
                    59922.2,
                    31764.2
                  ],
                  [
                    60097.2,
                    31751.6
                  ],
                  [
                    60179.8,
                    31641.9
                  ],
                  [
                    60163.1,
                    31435
                  ],
                  [
                    59917.8,
                    31635.1
                  ],
                  [
                    59648.8,
                    31597.8
                  ],
                  [
                    59457.8,
                    31458.4
                  ],
                  [
                    59144.4,
                    31509
                  ],
                  [
                    59151.8,
                    31641.1
                  ],
                  [
                    59031.2,
                    31712.8
                  ],
                  [
                    59046.9,
                    31931.7
                  ],
                  [
                    59313.5,
                    31972.8
                  ]
                ],
                "id": 279,
                "chat_link": "[&BBcBAAA=]"
              },
              "280": {
                "name": "Devast District",
                "level": 10,
                "coord": [
                  60088.4,
                  30958.3
                ],
                "bounds": [
                  [
                    60162.1,
                    31435.7
                  ],
                  [
                    60312.4,
                    31323.5
                  ],
                  [
                    60386,
                    31100.6
                  ],
                  [
                    60581.8,
                    30907.5
                  ],
                  [
                    60453.8,
                    30759.5
                  ],
                  [
                    60333.2,
                    30734.4
                  ],
                  [
                    60099.5,
                    30677.9
                  ],
                  [
                    60012.7,
                    30620.1
                  ],
                  [
                    59921.3,
                    30628.9
                  ],
                  [
                    59841.7,
                    30691.9
                  ],
                  [
                    59686.2,
                    30861.1
                  ],
                  [
                    59672.6,
                    30983.1
                  ],
                  [
                    59900.2,
                    30926.3
                  ],
                  [
                    59897.9,
                    31205.3
                  ],
                  [
                    60065.1,
                    31517.9
                  ],
                  [
                    60162.1,
                    31435.7
                  ]
                ],
                "id": 280,
                "chat_link": "[&BBgBAAA=]"
              },
              "281": {
                "name": "Windrock Maze",
                "level": 12,
                "coord": [
                  60391.9,
                  31581.3
                ],
                "bounds": [
                  [
                    60180.3,
                    31642.1
                  ],
                  [
                    60161.7,
                    31435.4
                  ],
                  [
                    60315.7,
                    31322
                  ],
                  [
                    60466.2,
                    31377.5
                  ],
                  [
                    60666.9,
                    31649.1
                  ],
                  [
                    60541.7,
                    31790.9
                  ],
                  [
                    60411.3,
                    31851.8
                  ],
                  [
                    60180.3,
                    31642.1
                  ]
                ],
                "id": 281,
                "chat_link": "[&BBkBAAA=]"
              },
              "282": {
                "name": "Ascalon Basin",
                "level": 12,
                "coord": [
                  61215.8,
                  31531.5
                ],
                "bounds": [
                  [
                    60666,
                    31652.3
                  ],
                  [
                    60982.6,
                    31591.5
                  ],
                  [
                    61296.3,
                    31773.7
                  ],
                  [
                    61458.5,
                    31781.3
                  ],
                  [
                    61619.4,
                    31898.9
                  ],
                  [
                    61603.1,
                    32053.5
                  ],
                  [
                    61680.8,
                    32143
                  ],
                  [
                    61800.4,
                    32266.6
                  ],
                  [
                    62020.7,
                    31978.7
                  ],
                  [
                    62040.4,
                    31882.4
                  ],
                  [
                    61961.6,
                    31505.5
                  ],
                  [
                    61442.9,
                    31466.1
                  ],
                  [
                    61175.9,
                    31065.4
                  ],
                  [
                    61051.7,
                    31086
                  ],
                  [
                    60870.2,
                    30981.4
                  ],
                  [
                    60845.5,
                    30844.8
                  ],
                  [
                    60643.1,
                    30846.8
                  ],
                  [
                    60386,
                    31101.2
                  ],
                  [
                    60307.5,
                    31326.2
                  ],
                  [
                    60462.6,
                    31384.5
                  ],
                  [
                    60666,
                    31652.3
                  ]
                ],
                "id": 282,
                "chat_link": "[&BBoBAAA=]"
              },
              "283": {
                "name": "Phasmatis Corridor",
                "level": 13,
                "coord": [
                  60438.8,
                  30569.8
                ],
                "bounds": [
                  [
                    60640.3,
                    30858.9
                  ],
                  [
                    60582.4,
                    30915.2
                  ],
                  [
                    60450.9,
                    30771.6
                  ],
                  [
                    60096.5,
                    30681
                  ],
                  [
                    60122.2,
                    30628.4
                  ],
                  [
                    60142.1,
                    30578.6
                  ],
                  [
                    60145.5,
                    30519.8
                  ],
                  [
                    60090.6,
                    30365.1
                  ],
                  [
                    60196,
                    30311.9
                  ],
                  [
                    60368.2,
                    30355.2
                  ],
                  [
                    60478.5,
                    30343.4
                  ],
                  [
                    60716.8,
                    30224.2
                  ],
                  [
                    60700.7,
                    30400.6
                  ],
                  [
                    61009.4,
                    30738.8
                  ],
                  [
                    60842.4,
                    30854.7
                  ],
                  [
                    60640.3,
                    30858.9
                  ]
                ],
                "id": 283,
                "chat_link": "[&BBsBAAA=]"
              },
              "284": {
                "name": "The Toppled Wall",
                "level": 15,
                "coord": [
                  60142.8,
                  30218.1
                ],
                "bounds": [
                  [
                    60354.2,
                    30371.4
                  ],
                  [
                    60193.5,
                    30317.5
                  ],
                  [
                    60097.7,
                    30365.9
                  ],
                  [
                    60026.4,
                    30339.2
                  ],
                  [
                    59975.4,
                    30373.9
                  ],
                  [
                    59901.2,
                    30285.7
                  ],
                  [
                    59716.3,
                    30311.3
                  ],
                  [
                    59514.5,
                    30264.8
                  ],
                  [
                    59300.1,
                    29999.9
                  ],
                  [
                    60307.3,
                    29873.5
                  ],
                  [
                    60734.6,
                    29939
                  ],
                  [
                    60712.1,
                    30002.8
                  ],
                  [
                    60702.9,
                    30248.4
                  ],
                  [
                    60463.8,
                    30359.8
                  ],
                  [
                    60354.2,
                    30371.4
                  ]
                ],
                "id": 284,
                "chat_link": "[&BBwBAAA=]"
              },
              "285": {
                "name": "Lamia Mire",
                "level": 11,
                "coord": [
                  61089.9,
                  30885.5
                ],
                "bounds": [
                  [
                    61009.7,
                    30727.9
                  ],
                  [
                    61300.9,
                    30664.1
                  ],
                  [
                    61380.3,
                    30824.2
                  ],
                  [
                    61174.3,
                    31068.5
                  ],
                  [
                    61050.9,
                    31087.3
                  ],
                  [
                    60868.5,
                    30981.8
                  ],
                  [
                    60844.7,
                    30845
                  ],
                  [
                    61009.7,
                    30727.9
                  ]
                ],
                "id": 285,
                "chat_link": "[&BB0BAAA=]"
              },
              "286": {
                "name": "Loreclaw Expanse",
                "level": 11,
                "coord": [
                  61133.9,
                  31833.1
                ],
                "bounds": [
                  [
                    60541.3,
                    31790.3
                  ],
                  [
                    60666.8,
                    31648.9
                  ],
                  [
                    60981,
                    31590.2
                  ],
                  [
                    61303.5,
                    31774.6
                  ],
                  [
                    61462.3,
                    31777.7
                  ],
                  [
                    61624.9,
                    31894.9
                  ],
                  [
                    61608.9,
                    32048.5
                  ],
                  [
                    61163.5,
                    32020.7
                  ],
                  [
                    60853,
                    31952
                  ],
                  [
                    60541.3,
                    31790.3
                  ]
                ],
                "id": 286,
                "chat_link": "[&BB4BAAA=]"
              },
              "287": {
                "name": "Cadem Forest",
                "level": 13,
                "coord": [
                  61649.7,
                  30878.2
                ],
                "bounds": [
                  [
                    61175.7,
                    31066.7
                  ],
                  [
                    61382.4,
                    30824.6
                  ],
                  [
                    61302.4,
                    30665.2
                  ],
                  [
                    61292.9,
                    30588.2
                  ],
                  [
                    61470,
                    30418.9
                  ],
                  [
                    61659,
                    30457.1
                  ],
                  [
                    61934.2,
                    30370.9
                  ],
                  [
                    61939.4,
                    30675.2
                  ],
                  [
                    62008.4,
                    30866.8
                  ],
                  [
                    61943.6,
                    31211.3
                  ],
                  [
                    61956.3,
                    31299.2
                  ],
                  [
                    61939.3,
                    31504.9
                  ],
                  [
                    61442.5,
                    31467.4
                  ],
                  [
                    61175.7,
                    31066.7
                  ]
                ],
                "id": 287,
                "chat_link": "[&BB8BAAA=]"
              },
              "288": {
                "name": "Gunbreach Hills",
                "level": 3,
                "coord": [
                  58277,
                  30394.2
                ],
                "bounds": [
                  [
                    57811.7,
                    30326.9
                  ],
                  [
                    57985.1,
                    30336.6
                  ],
                  [
                    58139.5,
                    30216.8
                  ],
                  [
                    58197.3,
                    30260
                  ],
                  [
                    58466.1,
                    30120
                  ],
                  [
                    58627.1,
                    30196.5
                  ],
                  [
                    58748.3,
                    30586.6
                  ],
                  [
                    58543.3,
                    30743.6
                  ],
                  [
                    58379.7,
                    30589.3
                  ],
                  [
                    57871.7,
                    30565.2
                  ],
                  [
                    57811.7,
                    30326.9
                  ]
                ],
                "id": 288,
                "chat_link": "[&BCABAAA=]"
              },
              "289": {
                "name": "Ascalon City Ruins",
                "level": 14,
                "coord": [
                  61034.8,
                  30253.6
                ],
                "bounds": [
                  [
                    61011.7,
                    30731.4
                  ],
                  [
                    60697,
                    30393
                  ],
                  [
                    60723.5,
                    30048.4
                  ],
                  [
                    60727.4,
                    29978.6
                  ],
                  [
                    60743.3,
                    29921.7
                  ],
                  [
                    60963.8,
                    29895.4
                  ],
                  [
                    61426,
                    29892.3
                  ],
                  [
                    61466,
                    30421.3
                  ],
                  [
                    61289.4,
                    30588.3
                  ],
                  [
                    61300,
                    30665.6
                  ],
                  [
                    61011.7,
                    30731.4
                  ]
                ],
                "id": 289,
                "chat_link": "[&BCEBAAA=]"
              },
              "290": {
                "name": "Devourer's Mouth",
                "level": 3,
                "coord": [
                  58268,
                  30086
                ],
                "bounds": [
                  [
                    58467.2,
                    30120.9
                  ],
                  [
                    58200.9,
                    30259.5
                  ],
                  [
                    58140.9,
                    30220.5
                  ],
                  [
                    58229.3,
                    30157
                  ],
                  [
                    58229.8,
                    30114.4
                  ],
                  [
                    58152.3,
                    30016.7
                  ],
                  [
                    58208.3,
                    29891.4
                  ],
                  [
                    58368.6,
                    29949.9
                  ],
                  [
                    58414.6,
                    30043.9
                  ],
                  [
                    58467.2,
                    30120.9
                  ]
                ],
                "id": 290,
                "chat_link": "[&BCIBAAA=]"
              },
              "291": {
                "name": "Abbey Ruins",
                "level": 10,
                "coord": [
                  59808.3,
                  31063.9
                ],
                "bounds": [
                  [
                    59905.1,
                    30919.6
                  ],
                  [
                    59679.5,
                    30979.2
                  ],
                  [
                    59748.7,
                    31146.6
                  ],
                  [
                    59900.1,
                    31210.1
                  ],
                  [
                    59905.1,
                    30919.6
                  ]
                ],
                "id": 291,
                "chat_link": "[&BCMBAAA=]"
              },
              "292": {
                "name": "Agnos Gorge",
                "level": 15,
                "coord": [
                  60059.9,
                  30492.4
                ],
                "bounds": [
                  [
                    60015.7,
                    30543.8
                  ],
                  [
                    60000.2,
                    30494
                  ],
                  [
                    59953.9,
                    30423.6
                  ],
                  [
                    59971,
                    30374
                  ],
                  [
                    60017.9,
                    30334.5
                  ],
                  [
                    60099.9,
                    30364.6
                  ],
                  [
                    60111.6,
                    30418.3
                  ],
                  [
                    60148.1,
                    30515.3
                  ],
                  [
                    60147.1,
                    30549.7
                  ],
                  [
                    60145.2,
                    30581.8
                  ],
                  [
                    60102.4,
                    30680.4
                  ],
                  [
                    60005.7,
                    30628.6
                  ],
                  [
                    60015.7,
                    30543.8
                  ]
                ],
                "id": 292,
                "chat_link": "[&BCQBAAA=]"
              },
              "293": {
                "name": "Human's Lament",
                "level": 14,
                "coord": [
                  61730.5,
                  30125.3
                ],
                "bounds": [
                  [
                    61438.6,
                    30135.4
                  ],
                  [
                    61423.9,
                    29896.1
                  ],
                  [
                    61598.6,
                    29922.2
                  ],
                  [
                    61700.4,
                    29837.9
                  ],
                  [
                    61921.9,
                    29893.1
                  ],
                  [
                    62009.2,
                    29994.1
                  ],
                  [
                    61936.7,
                    30165.6
                  ],
                  [
                    61949.6,
                    30275
                  ],
                  [
                    61935.4,
                    30378.1
                  ],
                  [
                    61656,
                    30460.7
                  ],
                  [
                    61465.6,
                    30420.5
                  ],
                  [
                    61438.6,
                    30135.4
                  ]
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              },
              "567": {
                "name": "Facula Castrum",
                "level": 5,
                "coord": [
                  59121.5,
                  30024
                ],
                "bounds": [
                  [
                    59147.3,
                    30224.4
                  ],
                  [
                    59228.4,
                    30179.7
                  ],
                  [
                    59307.6,
                    30007.8
                  ],
                  [
                    59351.6,
                    29908.2
                  ],
                  [
                    59078.3,
                    29853.8
                  ],
                  [
                    58817.2,
                    29908.1
                  ],
                  [
                    58920.3,
                    30085.8
                  ],
                  [
                    59147.3,
                    30224.4
                  ]
                ],
                "id": 567,
                "chat_link": "[&BDcCAAA=]"
              },
              "1104": {
                "name": "Langmar Estate",
                "level": 15,
                "coord": [
                  58219.9,
                  31645.5
                ],
                "bounds": [
                  [
                    58484.8,
                    31778.8
                  ],
                  [
                    58575,
                    31811.5
                  ],
                  [
                    58489.1,
                    32027.1
                  ],
                  [
                    57798.1,
                    31991.6
                  ],
                  [
                    57779,
                    31145.6
                  ],
                  [
                    58072,
                    31078.3
                  ],
                  [
                    58112.6,
                    31438.4
                  ],
                  [
                    58110.3,
                    31754.6
                  ],
                  [
                    58287.9,
                    31762.2
                  ],
                  [
                    58490.1,
                    31666.8
                  ],
                  [
                    58484.8,
                    31778.8
                  ]
                ],
                "id": 1104,
                "chat_link": "[&BFAEAAA=]"
              }
            },
            "id": 1129,
            "mastery_points": [],
            "adventures": []
          },
          "1131": {
            "name": "Blightwater Shatterstrike",
            "min_level": 40,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              62998,
              30464
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                61952,
                28544
              ],
              [
                64000,
                32640
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "484": {
                "name": "Tawny Ridge",
                "level": 49,
                "coord": [
                  63787.3,
                  29317.5
                ],
                "bounds": [
                  [
                    63834.3,
                    29385.9
                  ],
                  [
                    63878.9,
                    29286.7
                  ],
                  [
                    63836.8,
                    29212
                  ],
                  [
                    63745.4,
                    29237.2
                  ],
                  [
                    63699,
                    29364
                  ],
                  [
                    63729.6,
                    29419
                  ],
                  [
                    63834.3,
                    29385.9
                  ]
                ],
                "id": 484,
                "chat_link": "[&BOQBAAA=]"
              },
              "485": {
                "name": "Steeleye Span",
                "level": 43,
                "coord": [
                  62529.3,
                  31630.3
                ],
                "bounds": [
                  [
                    62334,
                    31493.3
                  ],
                  [
                    62569.1,
                    31511.8
                  ],
                  [
                    62764.5,
                    31653.4
                  ],
                  [
                    62647.5,
                    31807
                  ],
                  [
                    62331.5,
                    31685.8
                  ],
                  [
                    62334,
                    31493.3
                  ]
                ],
                "id": 485,
                "chat_link": "[&BOUBAAA=]"
              },
              "486": {
                "name": "Deserter Flats",
                "level": 45,
                "coord": [
                  62613.5,
                  30722.1
                ],
                "bounds": [
                  [
                    62439.6,
                    30695.3
                  ],
                  [
                    62452.9,
                    30472.3
                  ],
                  [
                    62598.7,
                    30334.8
                  ],
                  [
                    62811.9,
                    30457.6
                  ],
                  [
                    62958.3,
                    30707.9
                  ],
                  [
                    62839.8,
                    30912.9
                  ],
                  [
                    62726.3,
                    30877.3
                  ],
                  [
                    62641.9,
                    30973.8
                  ],
                  [
                    62351.8,
                    31035.3
                  ],
                  [
                    62313.7,
                    30754.1
                  ],
                  [
                    62439.6,
                    30695.3
                  ]
                ],
                "id": 486,
                "chat_link": "[&BOYBAAA=]"
              },
              "487": {
                "name": "Hazmagic Aggregate",
                "level": 48,
                "coord": [
                  62738.3,
                  30060.6
                ],
                "bounds": [
                  [
                    62811.3,
                    30462.7
                  ],
                  [
                    62929.5,
                    30273.1
                  ],
                  [
                    62928.1,
                    30070
                  ],
                  [
                    62816,
                    29773.8
                  ],
                  [
                    62843.9,
                    29606.6
                  ],
                  [
                    62492,
                    29699.6
                  ],
                  [
                    62573.5,
                    30053.8
                  ],
                  [
                    62658.6,
                    30065.7
                  ],
                  [
                    62730.9,
                    30263
                  ],
                  [
                    62598.8,
                    30337.7
                  ],
                  [
                    62811.3,
                    30462.7
                  ]
                ],
                "id": 487,
                "chat_link": "[&BOcBAAA=]"
              },
              "488": {
                "name": "Foulblain Expanse",
                "level": 43,
                "coord": [
                  62557.5,
                  31301.7
                ],
                "bounds": [
                  [
                    62337.1,
                    31156.7
                  ],
                  [
                    62350.8,
                    31028.3
                  ],
                  [
                    62645.7,
                    30961.6
                  ],
                  [
                    62603.2,
                    31125.8
                  ],
                  [
                    62658.3,
                    31339.5
                  ],
                  [
                    62753.8,
                    31420.5
                  ],
                  [
                    62762.4,
                    31655.3
                  ],
                  [
                    62568.6,
                    31523.9
                  ],
                  [
                    62337.9,
                    31504.2
                  ],
                  [
                    62337.1,
                    31156.7
                  ]
                ],
                "id": 488,
                "chat_link": "[&BOgBAAA=]"
              },
              "489": {
                "name": "Lowland Burns",
                "level": 50,
                "coord": [
                  62333.4,
                  28730.6
                ],
                "bounds": [
                  [
                    62331.1,
                    28939.1
                  ],
                  [
                    62257.1,
                    28819.7
                  ],
                  [
                    62090.8,
                    28826.8
                  ],
                  [
                    61794.4,
                    28687.8
                  ],
                  [
                    61938.5,
                    28177.5
                  ],
                  [
                    62027.6,
                    28190.3
                  ],
                  [
                    62106.3,
                    28274.4
                  ],
                  [
                    62222.5,
                    28337.8
                  ],
                  [
                    62320,
                    28413.6
                  ],
                  [
                    62385.2,
                    28509.2
                  ],
                  [
                    62435.3,
                    28600.1
                  ],
                  [
                    62517.2,
                    28640.4
                  ],
                  [
                    62670,
                    29018.7
                  ],
                  [
                    62922.2,
                    29225.1
                  ],
                  [
                    62890,
                    29333.1
                  ],
                  [
                    62446,
                    29308.9
                  ],
                  [
                    62313.5,
                    29117.5
                  ],
                  [
                    62331.1,
                    28939.1
                  ]
                ],
                "id": 489,
                "chat_link": "[&BOkBAAA=]"
              },
              "490": {
                "name": "Blightwater Basin",
                "level": 42,
                "coord": [
                  62087.1,
                  32282.7
                ],
                "bounds": [
                  [
                    62475.8,
                    32616.7
                  ],
                  [
                    62449.6,
                    32150.3
                  ],
                  [
                    62646.2,
                    31808.5
                  ],
                  [
                    62331.8,
                    31685.8
                  ],
                  [
                    62326.8,
                    31780.5
                  ],
                  [
                    61973.7,
                    31941.7
                  ],
                  [
                    61509.8,
                    32070.4
                  ],
                  [
                    61678.1,
                    32224.7
                  ],
                  [
                    61761.7,
                    32366.7
                  ],
                  [
                    61787.2,
                    32521.6
                  ],
                  [
                    61870.1,
                    32635.4
                  ],
                  [
                    62002.2,
                    32677.4
                  ],
                  [
                    62097.8,
                    32730.4
                  ],
                  [
                    62308.7,
                    32747.6
                  ],
                  [
                    62475.8,
                    32616.7
                  ]
                ],
                "id": 490,
                "chat_link": "[&BOoBAAA=]"
              },
              "491": {
                "name": "Tumok's Last Stand",
                "level": 42,
                "coord": [
                  62708.1,
                  32441.5
                ],
                "bounds": [
                  [
                    62475.4,
                    32613.9
                  ],
                  [
                    62574.8,
                    32661.6
                  ],
                  [
                    62807.9,
                    32713.7
                  ],
                  [
                    62940,
                    32662.1
                  ],
                  [
                    62957.1,
                    32598.9
                  ],
                  [
                    63050.1,
                    32235.4
                  ],
                  [
                    62644.3,
                    31809.7
                  ],
                  [
                    62452.7,
                    32155.4
                  ],
                  [
                    62470.8,
                    32522.3
                  ],
                  [
                    62475.4,
                    32613.9
                  ]
                ],
                "id": 491,
                "chat_link": "[&BOsBAAA=]"
              },
              "492": {
                "name": "Pockmark Roughs",
                "level": 45,
                "coord": [
                  63227.9,
                  31010.7
                ],
                "bounds": [
                  [
                    62841,
                    30913.6
                  ],
                  [
                    62955.5,
                    30712.2
                  ],
                  [
                    63229.3,
                    30638.3
                  ],
                  [
                    63447.8,
                    30736.4
                  ],
                  [
                    63538.4,
                    30885.5
                  ],
                  [
                    63527.2,
                    31093
                  ],
                  [
                    63443.4,
                    31236.1
                  ],
                  [
                    63307.8,
                    31352.4
                  ],
                  [
                    63109.2,
                    31370.7
                  ],
                  [
                    62879.8,
                    31168.8
                  ],
                  [
                    62841,
                    30913.6
                  ]
                ],
                "id": 492,
                "chat_link": "[&BOwBAAA=]"
              },
              "493": {
                "name": "Crater Rim",
                "level": 42,
                "coord": [
                  62868.6,
                  31245.7
                ],
                "bounds": [
                  [
                    62751.9,
                    31427.3
                  ],
                  [
                    62658.5,
                    31342.8
                  ],
                  [
                    62601,
                    31130.2
                  ],
                  [
                    62636.8,
                    30977.7
                  ],
                  [
                    62730.2,
                    30877.8
                  ],
                  [
                    62840.6,
                    30911.7
                  ],
                  [
                    62877.2,
                    31164.1
                  ],
                  [
                    63108.9,
                    31367.5
                  ],
                  [
                    63307.8,
                    31349.7
                  ],
                  [
                    63280.4,
                    31498.4
                  ],
                  [
                    62760.8,
                    31655
                  ],
                  [
                    62751.9,
                    31427.3
                  ]
                ],
                "id": 493,
                "chat_link": "[&BO0BAAA=]"
              },
              "494": {
                "name": "Behem Gauntlet",
                "level": 42,
                "coord": [
                  63694.3,
                  31526.8
                ],
                "bounds": [
                  [
                    63271.2,
                    31726
                  ],
                  [
                    63385.2,
                    31922
                  ],
                  [
                    63651.7,
                    31679.6
                  ],
                  [
                    63924.3,
                    31814.5
                  ],
                  [
                    64038.7,
                    31803.6
                  ],
                  [
                    64094,
                    31571.6
                  ],
                  [
                    64085.1,
                    31319.6
                  ],
                  [
                    63942.8,
                    31304.5
                  ],
                  [
                    63873.8,
                    31387.6
                  ],
                  [
                    63782,
                    31414.4
                  ],
                  [
                    63740.9,
                    31473.9
                  ],
                  [
                    63595.5,
                    31417.7
                  ],
                  [
                    63441.6,
                    31227.4
                  ],
                  [
                    63311.4,
                    31343.3
                  ],
                  [
                    63276.7,
                    31496.2
                  ],
                  [
                    63271.2,
                    31726
                  ]
                ],
                "id": 494,
                "chat_link": "[&BO4BAAA=]"
              },
              "495": {
                "name": "Unbroken Expanse",
                "level": 45,
                "coord": [
                  63211.9,
                  30390.3
                ],
                "bounds": [
                  [
                    63228.8,
                    30645.9
                  ],
                  [
                    63447.9,
                    30738.9
                  ],
                  [
                    63594.9,
                    30605.9
                  ],
                  [
                    63546,
                    30298.3
                  ],
                  [
                    63595.9,
                    30138.5
                  ],
                  [
                    63083,
                    29956.2
                  ],
                  [
                    62925.8,
                    30070.6
                  ],
                  [
                    62926.9,
                    30273.4
                  ],
                  [
                    62810.4,
                    30458.3
                  ],
                  [
                    62959.4,
                    30717.1
                  ],
                  [
                    63228.8,
                    30645.9
                  ]
                ],
                "id": 495,
                "chat_link": "[&BO8BAAA=]"
              },
              "496": {
                "name": "Gastor Gullet",
                "level": 45,
                "coord": [
                  63716,
                  31092.8
                ],
                "bounds": [
                  [
                    63527.8,
                    31091.7
                  ],
                  [
                    63538.8,
                    30886.2
                  ],
                  [
                    63447.1,
                    30737.8
                  ],
                  [
                    63593.5,
                    30606.3
                  ],
                  [
                    63767.3,
                    30670.9
                  ],
                  [
                    63870.3,
                    30901.8
                  ],
                  [
                    63918.4,
                    31019.5
                  ],
                  [
                    63979.9,
                    31145
                  ],
                  [
                    63944.9,
                    31306.2
                  ],
                  [
                    63875,
                    31387.9
                  ],
                  [
                    63782.4,
                    31416.7
                  ],
                  [
                    63740.2,
                    31476.7
                  ],
                  [
                    63594,
                    31418.9
                  ],
                  [
                    63445,
                    31233.4
                  ],
                  [
                    63527.8,
                    31091.7
                  ]
                ],
                "id": 496,
                "chat_link": "[&BPABAAA=]"
              },
              "497": {
                "name": "Degun Shun",
                "level": 45,
                "coord": [
                  63692.8,
                  30247.4
                ],
                "bounds": [
                  [
                    63695,
                    30391.3
                  ],
                  [
                    63851.2,
                    30298.3
                  ],
                  [
                    63781.1,
                    30177
                  ],
                  [
                    63698.5,
                    30183.2
                  ],
                  [
                    63586.8,
                    30135.9
                  ],
                  [
                    63544.1,
                    30298.9
                  ],
                  [
                    63695,
                    30391.3
                  ]
                ],
                "id": 497,
                "chat_link": "[&BPEBAAA=]"
              },
              "498": {
                "name": "Agrak Kraal",
                "level": 45,
                "coord": [
                  63888,
                  30702.1
                ],
                "bounds": [
                  [
                    63855.5,
                    30566.8
                  ],
                  [
                    63937.4,
                    30576.7
                  ],
                  [
                    63946.3,
                    30708
                  ],
                  [
                    63970,
                    30827.9
                  ],
                  [
                    63847.8,
                    30864
                  ],
                  [
                    63771.2,
                    30669.4
                  ],
                  [
                    63855.5,
                    30566.8
                  ]
                ],
                "id": 498,
                "chat_link": "[&BPIBAAA=]"
              },
              "499": {
                "name": "Twin Sisters Crossing",
                "level": 42,
                "coord": [
                  63862.8,
                  32402.3
                ],
                "bounds": [
                  [
                    63927,
                    32682.5
                  ],
                  [
                    63797.7,
                    32729.8
                  ],
                  [
                    63678.9,
                    32732
                  ],
                  [
                    63567.1,
                    32672.7
                  ],
                  [
                    63547.2,
                    32581.1
                  ],
                  [
                    63612.6,
                    32474.9
                  ],
                  [
                    63559.8,
                    32276.8
                  ],
                  [
                    63645.6,
                    32136.1
                  ],
                  [
                    63901.9,
                    31992.3
                  ],
                  [
                    63945,
                    32022
                  ],
                  [
                    63957.7,
                    32129.7
                  ],
                  [
                    64026.3,
                    32249.1
                  ],
                  [
                    64121.1,
                    32326.2
                  ],
                  [
                    64202.4,
                    32366.9
                  ],
                  [
                    64241,
                    32436.5
                  ],
                  [
                    64074.1,
                    32628.4
                  ],
                  [
                    63927,
                    32682.5
                  ]
                ],
                "id": 499,
                "chat_link": "[&BPMBAAA=]"
              },
              "500": {
                "name": "Splinter Hills",
                "level": 42,
                "coord": [
                  63436.8,
                  32369.6
                ],
                "bounds": [
                  [
                    63036.6,
                    32228.9
                  ],
                  [
                    63648.4,
                    31681.5
                  ],
                  [
                    63923.3,
                    31813.4
                  ],
                  [
                    63906.8,
                    31993.9
                  ],
                  [
                    63645.5,
                    32137.2
                  ],
                  [
                    63559.9,
                    32277.8
                  ],
                  [
                    63612.5,
                    32475.6
                  ],
                  [
                    63548.9,
                    32581.5
                  ],
                  [
                    63569.1,
                    32673.9
                  ],
                  [
                    63427,
                    32726.4
                  ],
                  [
                    63250.9,
                    32645.8
                  ],
                  [
                    63095.1,
                    32692.7
                  ],
                  [
                    62937.4,
                    32653.1
                  ],
                  [
                    62953.7,
                    32592.1
                  ],
                  [
                    63036.6,
                    32228.9
                  ]
                ],
                "id": 500,
                "chat_link": "[&BPQBAAA=]"
              },
              "501": {
                "name": "Soot Road",
                "level": 42,
                "coord": [
                  63065.7,
                  31805.3
                ],
                "bounds": [
                  [
                    62763.1,
                    31650.1
                  ],
                  [
                    63278.9,
                    31499.1
                  ],
                  [
                    63273,
                    31723.4
                  ],
                  [
                    63386.3,
                    31922.3
                  ],
                  [
                    63044.8,
                    32226.1
                  ],
                  [
                    62647.9,
                    31810.5
                  ],
                  [
                    62763.1,
                    31650.1
                  ]
                ],
                "id": 501,
                "chat_link": "[&BPUBAAA=]"
              },
              "502": {
                "name": "Tongue Rock",
                "level": 45,
                "coord": [
                  62007.1,
                  30517.7
                ],
                "bounds": [
                  [
                    62232.6,
                    30493.1
                  ],
                  [
                    62156,
                    30619.2
                  ],
                  [
                    61988.4,
                    30604.4
                  ],
                  [
                    61818.8,
                    30755.6
                  ],
                  [
                    61834,
                    30623.4
                  ],
                  [
                    61898.2,
                    30479.3
                  ],
                  [
                    61876.1,
                    30403.2
                  ],
                  [
                    62014.4,
                    30456.3
                  ],
                  [
                    62099.9,
                    30361.9
                  ],
                  [
                    62152.6,
                    30381
                  ],
                  [
                    62232.6,
                    30493.1
                  ]
                ],
                "id": 502,
                "chat_link": "[&BPYBAAA=]"
              },
              "503": {
                "name": "Terra Combusta",
                "level": 49,
                "coord": [
                  62967.3,
                  28959.5
                ],
                "bounds": [
                  [
                    62914.2,
                    29238.7
                  ],
                  [
                    62669.5,
                    29019
                  ],
                  [
                    62515.1,
                    28641.8
                  ],
                  [
                    62776.6,
                    28568.7
                  ],
                  [
                    63054.8,
                    28653
                  ],
                  [
                    63103.2,
                    28738.1
                  ],
                  [
                    63387,
                    28803.3
                  ],
                  [
                    63161.3,
                    29217.8
                  ],
                  [
                    63199,
                    29380.4
                  ],
                  [
                    62891.9,
                    29334.6
                  ],
                  [
                    62914.2,
                    29238.7
                  ]
                ],
                "id": 503,
                "chat_link": "[&BPcBAAA=]"
              },
              "504": {
                "name": "Terra Carorunda",
                "level": 49,
                "coord": [
                  63646.7,
                  29033.7
                ],
                "bounds": [
                  [
                    63201.7,
                    29381.4
                  ],
                  [
                    63409.6,
                    29507.8
                  ],
                  [
                    63750.9,
                    29457.3
                  ],
                  [
                    63700,
                    29362.1
                  ],
                  [
                    63748.1,
                    29237
                  ],
                  [
                    63838.9,
                    29214.4
                  ],
                  [
                    63881,
                    29161.8
                  ],
                  [
                    63872.6,
                    28991.6
                  ],
                  [
                    63962.4,
                    28839.9
                  ],
                  [
                    63943.6,
                    28602.4
                  ],
                  [
                    63754.8,
                    28591
                  ],
                  [
                    63640.6,
                    28555.1
                  ],
                  [
                    63447.2,
                    28584
                  ],
                  [
                    63389.2,
                    28801
                  ],
                  [
                    63160.3,
                    29218.5
                  ],
                  [
                    63201.7,
                    29381.4
                  ]
                ],
                "id": 504,
                "chat_link": "[&BPgBAAA=]"
              },
              "505": {
                "name": "Shattered Palisades",
                "level": 49,
                "coord": [
                  63287.8,
                  29508.3
                ],
                "bounds": [
                  [
                    63449.3,
                    29664.6
                  ],
                  [
                    63735.3,
                    29560.1
                  ],
                  [
                    63750.7,
                    29455.5
                  ],
                  [
                    63408.7,
                    29506
                  ],
                  [
                    63200.8,
                    29377.6
                  ],
                  [
                    62817.8,
                    29319.5
                  ],
                  [
                    62844.4,
                    29604.2
                  ],
                  [
                    63095.2,
                    29579.1
                  ],
                  [
                    63449.3,
                    29664.6
                  ]
                ],
                "id": 505,
                "chat_link": "[&BPkBAAA=]"
              },
              "506": {
                "name": "Monument Grounds",
                "level": 50,
                "coord": [
                  62337.5,
                  29448.3
                ],
                "bounds": [
                  [
                    62494,
                    29697.9
                  ],
                  [
                    62842.3,
                    29604.2
                  ],
                  [
                    62815.3,
                    29323.4
                  ],
                  [
                    62445,
                    29310.7
                  ],
                  [
                    62394.7,
                    29405.1
                  ],
                  [
                    62030.1,
                    29409.7
                  ],
                  [
                    61826.2,
                    29318.8
                  ],
                  [
                    61852.4,
                    29516.2
                  ],
                  [
                    62494,
                    29697.9
                  ]
                ],
                "id": 506,
                "chat_link": "[&BPoBAAA=]"
              },
              "507": {
                "name": "Heretic Plain",
                "level": 47,
                "coord": [
                  63435.8,
                  29829
                ],
                "bounds": [
                  [
                    62818.3,
                    29770.1
                  ],
                  [
                    62841.7,
                    29605.5
                  ],
                  [
                    63095.3,
                    29579.2
                  ],
                  [
                    63445.5,
                    29663.5
                  ],
                  [
                    63733,
                    29560.5
                  ],
                  [
                    63873.3,
                    29555.4
                  ],
                  [
                    63930,
                    29805.3
                  ],
                  [
                    63930.2,
                    30021.5
                  ],
                  [
                    63856.9,
                    30170.4
                  ],
                  [
                    63696.5,
                    30184.3
                  ],
                  [
                    63082.1,
                    29961.7
                  ],
                  [
                    62926.8,
                    30071.2
                  ],
                  [
                    62818.3,
                    29770.1
                  ]
                ],
                "id": 507,
                "chat_link": "[&BPsBAAA=]"
              },
              "508": {
                "name": "Kindling Bridge",
                "level": 50,
                "coord": [
                  62106.6,
                  29094
                ],
                "bounds": [
                  [
                    61831.5,
                    29315.7
                  ],
                  [
                    61875,
                    29191.1
                  ],
                  [
                    61781.9,
                    29002.1
                  ],
                  [
                    61799.7,
                    28689.3
                  ],
                  [
                    62091.7,
                    28823.8
                  ],
                  [
                    62261.8,
                    28824.8
                  ],
                  [
                    62335.3,
                    28942.4
                  ],
                  [
                    62313.2,
                    29121.6
                  ],
                  [
                    62450.6,
                    29310
                  ],
                  [
                    62398.5,
                    29405.6
                  ],
                  [
                    62033.3,
                    29407.7
                  ],
                  [
                    61831.5,
                    29315.7
                  ]
                ],
                "id": 508,
                "chat_link": "[&BPwBAAA=]"
              },
              "509": {
                "name": "Dragonwatch",
                "level": 43,
                "coord": [
                  62071,
                  31427.8
                ],
                "bounds": [
                  [
                    62326.5,
                    31774.7
                  ],
                  [
                    62338.5,
                    31506.3
                  ],
                  [
                    62339,
                    31156.7
                  ],
                  [
                    62107.7,
                    31209.2
                  ],
                  [
                    61953.1,
                    31186
                  ],
                  [
                    61952,
                    31215.8
                  ],
                  [
                    61944.9,
                    31281.9
                  ],
                  [
                    61954.3,
                    31359.3
                  ],
                  [
                    61819.8,
                    31647.2
                  ],
                  [
                    61974.8,
                    31940.8
                  ],
                  [
                    62326.5,
                    31774.7
                  ]
                ],
                "id": 509,
                "chat_link": "[&BP0BAAA=]"
              },
              "510": {
                "name": "Ratcatcher Knoll",
                "level": 45,
                "coord": [
                  62202.2,
                  30748
                ],
                "bounds": [
                  [
                    62107.6,
                    31211
                  ],
                  [
                    61958.7,
                    31186.4
                  ],
                  [
                    61818.8,
                    30757.4
                  ],
                  [
                    61993.7,
                    30604.6
                  ],
                  [
                    62153.8,
                    30620.1
                  ],
                  [
                    62231.2,
                    30491.7
                  ],
                  [
                    62150.8,
                    30381.6
                  ],
                  [
                    62310.9,
                    30344.7
                  ],
                  [
                    62456.3,
                    30474.6
                  ],
                  [
                    62442.6,
                    30698.2
                  ],
                  [
                    62314.6,
                    30758.1
                  ],
                  [
                    62354.1,
                    31035.8
                  ],
                  [
                    62334.9,
                    31159.4
                  ],
                  [
                    62107.6,
                    31211
                  ]
                ],
                "id": 510,
                "chat_link": "[&BP4BAAA=]"
              },
              "511": {
                "name": "Relliatus Canyon",
                "level": 47,
                "coord": [
                  62217.2,
                  30139.4
                ],
                "bounds": [
                  [
                    62010,
                    30457.9
                  ],
                  [
                    62100.9,
                    30361.2
                  ],
                  [
                    62151.1,
                    30381
                  ],
                  [
                    62311,
                    30347.8
                  ],
                  [
                    62455,
                    30476.1
                  ],
                  [
                    62600.2,
                    30334.8
                  ],
                  [
                    62464.6,
                    30156.9
                  ],
                  [
                    62476.8,
                    30058.2
                  ],
                  [
                    62573.8,
                    30052.6
                  ],
                  [
                    62494.1,
                    29698.1
                  ],
                  [
                    61853.7,
                    29509.6
                  ],
                  [
                    61831.6,
                    29761.8
                  ],
                  [
                    61837.2,
                    29956.5
                  ],
                  [
                    61880.5,
                    30399.3
                  ],
                  [
                    62010,
                    30457.9
                  ]
                ],
                "id": 511,
                "chat_link": "[&BP8BAAA=]"
              },
              "758": {
                "name": "InGenium Research Facility",
                "level": 48,
                "coord": [
                  62584.6,
                  30155.2
                ],
                "bounds": [
                  [
                    62463.8,
                    30156.9
                  ],
                  [
                    62476.9,
                    30056.9
                  ],
                  [
                    62577.4,
                    30050.8
                  ],
                  [
                    62660.6,
                    30065.2
                  ],
                  [
                    62729.8,
                    30264
                  ],
                  [
                    62599.3,
                    30337.5
                  ],
                  [
                    62463.8,
                    30156.9
                  ]
                ],
                "id": 758,
                "chat_link": "[&BPYCAAA=]"
              }
            },
            "id": 1131,
            "mastery_points": [],
            "adventures": []
          },
          "1133": {
            "name": "Branded for Termination",
            "min_level": 30,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              62976,
              34176
            ],
            "map_rect": [
              [
                -36864,
                -36864
              ],
              [
                36864,
                36864
              ]
            ],
            "continent_rect": [
              [
                61440,
                32640
              ],
              [
                64512,
                35712
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "365": {
                "name": "Last Stand Shelter",
                "level": 31,
                "coord": [
                  61657.9,
                  35015.4
                ],
                "bounds": [
                  [
                    61456.9,
                    34889.1
                  ],
                  [
                    61607.9,
                    34741.1
                  ],
                  [
                    61812.8,
                    34931.5
                  ],
                  [
                    61785.2,
                    35009.7
                  ],
                  [
                    61709.3,
                    35063.5
                  ],
                  [
                    61698.5,
                    35205.7
                  ],
                  [
                    61534.8,
                    35267.4
                  ],
                  [
                    61456.9,
                    34889.1
                  ]
                ],
                "id": 365,
                "chat_link": "[&BG0BAAA=]"
              },
              "366": {
                "name": "Blackwing Excavation",
                "level": 31,
                "coord": [
                  62641.1,
                  35403.7
                ],
                "bounds": [
                  [
                    62557.5,
                    35091.2
                  ],
                  [
                    62771.9,
                    35156.6
                  ],
                  [
                    62878.7,
                    35543.5
                  ],
                  [
                    62746.7,
                    35649.8
                  ],
                  [
                    62451.9,
                    35654.8
                  ],
                  [
                    62440,
                    35326.3
                  ],
                  [
                    62557.5,
                    35091.2
                  ]
                ],
                "id": 366,
                "chat_link": "[&BG4BAAA=]"
              },
              "367": {
                "name": "Stronghold of Ebonhawke",
                "level": 31,
                "coord": [
                  62008.8,
                  35138
                ],
                "bounds": [
                  [
                    61812.5,
                    34931.7
                  ],
                  [
                    61608.6,
                    34739.7
                  ],
                  [
                    61974.8,
                    34550.6
                  ],
                  [
                    62116.3,
                    34621.3
                  ],
                  [
                    62342,
                    34818.7
                  ],
                  [
                    62699,
                    34688.4
                  ],
                  [
                    62557.7,
                    35091.4
                  ],
                  [
                    62440.8,
                    35324.7
                  ],
                  [
                    62450.3,
                    35654.7
                  ],
                  [
                    62165.5,
                    35625.2
                  ],
                  [
                    61939.4,
                    35533.8
                  ],
                  [
                    61770.3,
                    35659.5
                  ],
                  [
                    61542.8,
                    35558.4
                  ],
                  [
                    61534.8,
                    35269.1
                  ],
                  [
                    61699,
                    35206.4
                  ],
                  [
                    61709.8,
                    35064.6
                  ],
                  [
                    61785.5,
                    35008.6
                  ],
                  [
                    61812.5,
                    34931.7
                  ]
                ],
                "id": 367,
                "chat_link": "[&BG8BAAA=]"
              },
              "368": {
                "name": "Grimm Hills",
                "level": 34,
                "coord": [
                  62913.6,
                  34678.1
                ],
                "bounds": [
                  [
                    62775,
                    35155.6
                  ],
                  [
                    63095.2,
                    34880.6
                  ],
                  [
                    63095,
                    34671.8
                  ],
                  [
                    63212.3,
                    34293.8
                  ],
                  [
                    63014.9,
                    34325.3
                  ],
                  [
                    62889.8,
                    34422.3
                  ],
                  [
                    62883.8,
                    34575
                  ],
                  [
                    62698.5,
                    34687.4
                  ],
                  [
                    62558.2,
                    35091.2
                  ],
                  [
                    62775,
                    35155.6
                  ]
                ],
                "id": 368,
                "chat_link": "[&BHABAAA=]"
              },
              "369": {
                "name": "The Ogre Road",
                "level": 33,
                "coord": [
                  63775.2,
                  34960.3
                ],
                "bounds": [
                  [
                    63818,
                    34775.5
                  ],
                  [
                    64049.9,
                    34874.6
                  ],
                  [
                    63983.2,
                    35117.8
                  ],
                  [
                    63650.4,
                    35343.8
                  ],
                  [
                    63469.1,
                    34973.7
                  ],
                  [
                    63680.8,
                    34676.6
                  ],
                  [
                    63818,
                    34775.5
                  ]
                ],
                "id": 369,
                "chat_link": "[&BHEBAAA=]"
              },
              "370": {
                "name": "Wildlin Narrows",
                "level": 34,
                "coord": [
                  64113.6,
                  35332.1
                ],
                "bounds": [
                  [
                    63981.4,
                    35119
                  ],
                  [
                    64047.3,
                    34879.9
                  ],
                  [
                    64446.4,
                    34880.2
                  ],
                  [
                    64454.7,
                    35016.9
                  ],
                  [
                    64482.5,
                    35162.6
                  ],
                  [
                    64437,
                    35419.7
                  ],
                  [
                    64379.4,
                    35572.2
                  ],
                  [
                    64266.7,
                    35658.7
                  ],
                  [
                    63887.2,
                    35684.1
                  ],
                  [
                    63726.7,
                    35630.3
                  ],
                  [
                    63602.3,
                    35623
                  ],
                  [
                    63651.7,
                    35338
                  ],
                  [
                    63981.4,
                    35119
                  ]
                ],
                "id": 370,
                "chat_link": "[&BHIBAAA=]"
              },
              "371": {
                "name": "Mithric Cliffs",
                "level": 35,
                "coord": [
                  64140.7,
                  34560.1
                ],
                "bounds": [
                  [
                    63873.1,
                    34199.8
                  ],
                  [
                    64439.5,
                    34200.8
                  ],
                  [
                    64522.9,
                    34271.7
                  ],
                  [
                    64421.7,
                    34550.9
                  ],
                  [
                    64486.2,
                    34796.1
                  ],
                  [
                    64446.4,
                    34880
                  ],
                  [
                    64049.8,
                    34881.8
                  ],
                  [
                    63817.7,
                    34776.3
                  ],
                  [
                    63679.6,
                    34676
                  ],
                  [
                    63670,
                    34367.5
                  ],
                  [
                    63873.1,
                    34199.8
                  ]
                ],
                "id": 371,
                "chat_link": "[&BHMBAAA=]"
              },
              "372": {
                "name": "Hunter's Gorge",
                "level": 35,
                "coord": [
                  63341.8,
                  34640.5
                ],
                "bounds": [
                  [
                    63669.7,
                    34367.2
                  ],
                  [
                    63679.1,
                    34676
                  ],
                  [
                    63470.3,
                    34973.3
                  ],
                  [
                    63163.9,
                    34985.8
                  ],
                  [
                    63094,
                    34882.4
                  ],
                  [
                    63095.7,
                    34672.5
                  ],
                  [
                    63212.8,
                    34294.4
                  ],
                  [
                    63348.8,
                    34272.4
                  ],
                  [
                    63669.7,
                    34367.2
                  ]
                ],
                "id": 372,
                "chat_link": "[&BHQBAAA=]"
              },
              "373": {
                "name": "The Siege Plains",
                "level": 33,
                "coord": [
                  62661.4,
                  34431.1
                ],
                "bounds": [
                  [
                    62342.5,
                    34820
                  ],
                  [
                    62698.4,
                    34688
                  ],
                  [
                    62884,
                    34573.7
                  ],
                  [
                    62895.1,
                    34415.3
                  ],
                  [
                    63015.8,
                    34325.2
                  ],
                  [
                    62807.6,
                    34052
                  ],
                  [
                    62532,
                    33954.3
                  ],
                  [
                    62115.9,
                    34620.7
                  ],
                  [
                    62342.5,
                    34820
                  ]
                ],
                "id": 373,
                "chat_link": "[&BHUBAAA=]"
              },
              "374": {
                "name": "Sniper's Woods",
                "level": 35,
                "coord": [
                  62135,
                  34190.4
                ],
                "bounds": [
                  [
                    61976.5,
                    34544.7
                  ],
                  [
                    62116.8,
                    34620
                  ],
                  [
                    62531.9,
                    33954
                  ],
                  [
                    62317,
                    33906.1
                  ],
                  [
                    62102.3,
                    34036.9
                  ],
                  [
                    61765.8,
                    34080.3
                  ],
                  [
                    61976.5,
                    34544.7
                  ]
                ],
                "id": 374,
                "chat_link": "[&BHYBAAA=]"
              },
              "375": {
                "name": "Bento Canyon",
                "level": 34,
                "coord": [
                  61654.1,
                  34397.7
                ],
                "bounds": [
                  [
                    61608.5,
                    34740
                  ],
                  [
                    61977.2,
                    34544.8
                  ],
                  [
                    61766,
                    34081.3
                  ],
                  [
                    61522.8,
                    34074.4
                  ],
                  [
                    61571.5,
                    34348
                  ],
                  [
                    61478.8,
                    34597.5
                  ],
                  [
                    61608.5,
                    34740
                  ]
                ],
                "id": 375,
                "chat_link": "[&BHcBAAA=]"
              },
              "376": {
                "name": "Dragonrot Domains",
                "level": 38,
                "coord": [
                  61711,
                  33852.5
                ],
                "bounds": [
                  [
                    61522.5,
                    34074.1
                  ],
                  [
                    61765.8,
                    34080.1
                  ],
                  [
                    62103,
                    34037.3
                  ],
                  [
                    61890.2,
                    33602.7
                  ],
                  [
                    61522.8,
                    33605.5
                  ],
                  [
                    61461.9,
                    33715.2
                  ],
                  [
                    61522.5,
                    34074.1
                  ]
                ],
                "id": 376,
                "chat_link": "[&BHgBAAA=]"
              },
              "377": {
                "name": "Varim's Run",
                "level": 40,
                "coord": [
                  61676.3,
                  33049.4
                ],
                "bounds": [
                  [
                    61684.6,
                    32846.2
                  ],
                  [
                    61627.8,
                    32689
                  ],
                  [
                    61783.8,
                    32640.9
                  ],
                  [
                    62037,
                    32658.6
                  ],
                  [
                    61927,
                    32793.8
                  ],
                  [
                    61888.9,
                    33603.3
                  ],
                  [
                    61521.8,
                    33606.4
                  ],
                  [
                    61568.4,
                    33387.3
                  ],
                  [
                    61411.7,
                    33325.3
                  ],
                  [
                    61408,
                    33080.2
                  ],
                  [
                    61580,
                    32912.1
                  ],
                  [
                    61684.6,
                    32846.2
                  ]
                ],
                "id": 377,
                "chat_link": "[&BHkBAAA=]"
              },
              "378": {
                "name": "Tenaebron Lake",
                "level": 39,
                "coord": [
                  62214.2,
                  33182.2
                ],
                "bounds": [
                  [
                    61884.8,
                    33603.9
                  ],
                  [
                    62102.9,
                    34046.4
                  ],
                  [
                    62317.7,
                    33899.6
                  ],
                  [
                    62262.7,
                    33569.9
                  ],
                  [
                    62495.3,
                    33233.3
                  ],
                  [
                    62442.7,
                    32764
                  ],
                  [
                    62420.4,
                    32651.8
                  ],
                  [
                    62238,
                    32617.8
                  ],
                  [
                    62046.1,
                    32647.3
                  ],
                  [
                    61931.3,
                    32787.9
                  ],
                  [
                    61884.8,
                    33603.9
                  ]
                ],
                "id": 378,
                "chat_link": "[&BHoBAAA=]"
              },
              "379": {
                "name": "Vulture's Sweep",
                "level": 37,
                "coord": [
                  62545.4,
                  33687.2
                ],
                "bounds": [
                  [
                    62315.8,
                    33906
                  ],
                  [
                    62530.4,
                    33952.9
                  ],
                  [
                    62805.8,
                    34052.8
                  ],
                  [
                    62867.3,
                    33390.9
                  ],
                  [
                    62492.3,
                    33242.2
                  ],
                  [
                    62260.7,
                    33578.4
                  ],
                  [
                    62315.8,
                    33906
                  ]
                ],
                "id": 379,
                "chat_link": "[&BHsBAAA=]"
              },
              "380": {
                "name": "Warrior's Crown",
                "level": 36,
                "coord": [
                  63286.9,
                  33885.3
                ],
                "bounds": [
                  [
                    62867.6,
                    33388
                  ],
                  [
                    63792.5,
                    33512.5
                  ],
                  [
                    63709.9,
                    33749.2
                  ],
                  [
                    63468.1,
                    33900.9
                  ],
                  [
                    63349.3,
                    34273.4
                  ],
                  [
                    63014.9,
                    34324.5
                  ],
                  [
                    62805.9,
                    34048.8
                  ],
                  [
                    62867.6,
                    33388
                  ]
                ],
                "id": 380,
                "chat_link": "[&BHwBAAA=]"
              },
              "381": {
                "name": "Belag Crossroads",
                "level": 35,
                "coord": [
                  63662.8,
                  34062.1
                ],
                "bounds": [
                  [
                    63348.9,
                    34273.4
                  ],
                  [
                    63669.7,
                    34368.1
                  ],
                  [
                    63873.3,
                    34199.3
                  ],
                  [
                    63905.5,
                    33881.5
                  ],
                  [
                    63711,
                    33749.6
                  ],
                  [
                    63468.4,
                    33900.9
                  ],
                  [
                    63348.9,
                    34273.4
                  ]
                ],
                "id": 381,
                "chat_link": "[&BH0BAAA=]"
              },
              "382": {
                "name": "Flameroot Caverns",
                "level": 36,
                "coord": [
                  64189.7,
                  33999.4
                ],
                "bounds": [
                  [
                    63872.4,
                    34199.8
                  ],
                  [
                    64439.4,
                    34201.8
                  ],
                  [
                    64395.5,
                    34050.3
                  ],
                  [
                    64466,
                    33931.9
                  ],
                  [
                    64059.3,
                    33731.8
                  ],
                  [
                    63905.5,
                    33880.9
                  ],
                  [
                    63872.4,
                    34199.8
                  ]
                ],
                "id": 382,
                "chat_link": "[&BH4BAAA=]"
              },
              "383": {
                "name": "Highden Caves",
                "level": 37,
                "coord": [
                  64321.2,
                  33581.6
                ],
                "bounds": [
                  [
                    64058.1,
                    33737.1
                  ],
                  [
                    64465.7,
                    33931.5
                  ],
                  [
                    64495.3,
                    33748.5
                  ],
                  [
                    64427.9,
                    33511.7
                  ],
                  [
                    64421.5,
                    33370.7
                  ],
                  [
                    64304.1,
                    33239.5
                  ],
                  [
                    64075.8,
                    33532.5
                  ],
                  [
                    64058.1,
                    33737.1
                  ]
                ],
                "id": 383,
                "chat_link": "[&BH8BAAA=]"
              },
              "384": {
                "name": "Axedrag Cut",
                "level": 37,
                "coord": [
                  63990.9,
                  33565.5
                ],
                "bounds": [
                  [
                    63881.1,
                    33256.4
                  ],
                  [
                    64304,
                    33239.1
                  ],
                  [
                    64083.4,
                    33532.1
                  ],
                  [
                    64061.1,
                    33735.1
                  ],
                  [
                    63905.5,
                    33881.2
                  ],
                  [
                    63710.1,
                    33748.8
                  ],
                  [
                    63881.1,
                    33256.4
                  ]
                ],
                "id": 384,
                "chat_link": "[&BIABAAA=]"
              },
              "385": {
                "name": "Tanglerot Hills",
                "level": 38,
                "coord": [
                  64171.4,
                  32762.6
                ],
                "bounds": [
                  [
                    63983.3,
                    32611.9
                  ],
                  [
                    63951.1,
                    32609.5
                  ],
                  [
                    64029.3,
                    32351.6
                  ],
                  [
                    64129.6,
                    32438.2
                  ],
                  [
                    64262.5,
                    32504.9
                  ],
                  [
                    64348,
                    32526.6
                  ],
                  [
                    64495,
                    32743.9
                  ],
                  [
                    64478.6,
                    33115.1
                  ],
                  [
                    64304,
                    33238.5
                  ],
                  [
                    63880,
                    33257.4
                  ],
                  [
                    64024.1,
                    32991.5
                  ],
                  [
                    63983.3,
                    32611.9
                  ]
                ],
                "id": 385,
                "chat_link": "[&BIEBAAA=]"
              },
              "386": {
                "name": "Halkor Meadows",
                "level": 38,
                "coord": [
                  63745.8,
                  32858
                ],
                "bounds": [
                  [
                    63566.3,
                    33004.5
                  ],
                  [
                    63855.8,
                    33329.6
                  ],
                  [
                    63879.9,
                    33259.8
                  ],
                  [
                    64024.2,
                    32991.6
                  ],
                  [
                    64008,
                    32735
                  ],
                  [
                    63986.5,
                    32610.7
                  ],
                  [
                    63759.8,
                    32579.6
                  ],
                  [
                    63522.4,
                    32646.3
                  ],
                  [
                    63394.6,
                    32629.6
                  ],
                  [
                    63460.5,
                    32793.5
                  ],
                  [
                    63566.3,
                    33004.5
                  ]
                ],
                "id": 386,
                "chat_link": "[&BIIBAAA=]"
              },
              "387": {
                "name": "Thunderbreak Hills",
                "level": 38,
                "coord": [
                  62924.8,
                  32849.6
                ],
                "bounds": [
                  [
                    63401.1,
                    32628
                  ],
                  [
                    63567,
                    33004.2
                  ],
                  [
                    63218.8,
                    33031.5
                  ],
                  [
                    62867.4,
                    33390
                  ],
                  [
                    62493,
                    33242.9
                  ],
                  [
                    62440,
                    32773.5
                  ],
                  [
                    62420.6,
                    32649
                  ],
                  [
                    62745,
                    32572
                  ],
                  [
                    62954.7,
                    32648.8
                  ],
                  [
                    63140.4,
                    32556.1
                  ],
                  [
                    63401.1,
                    32628
                  ]
                ],
                "id": 387,
                "chat_link": "[&BIMBAAA=]"
              },
              "388": {
                "name": "Hautclaire Vale",
                "level": 31,
                "coord": [
                  63239.6,
                  35319.1
                ],
                "bounds": [
                  [
                    63094.3,
                    34879.9
                  ],
                  [
                    63162.7,
                    34986.4
                  ],
                  [
                    63470.2,
                    34971.3
                  ],
                  [
                    63650.7,
                    35342.5
                  ],
                  [
                    63603.5,
                    35626.5
                  ],
                  [
                    63482.8,
                    35538.9
                  ],
                  [
                    63249.2,
                    35599.6
                  ],
                  [
                    63033.2,
                    35546.5
                  ],
                  [
                    62877.4,
                    35543.2
                  ],
                  [
                    62772.5,
                    35155.8
                  ],
                  [
                    63094.3,
                    34879.9
                  ]
                ],
                "id": 388,
                "chat_link": "[&BIQBAAA=]"
              },
              "389": {
                "name": "Gillfarn Plains",
                "level": 38,
                "coord": [
                  63459.3,
                  33253.3
                ],
                "bounds": [
                  [
                    62864.8,
                    33390.4
                  ],
                  [
                    63792.2,
                    33514.1
                  ],
                  [
                    63855.6,
                    33329
                  ],
                  [
                    63566.4,
                    33004.3
                  ],
                  [
                    63217.5,
                    33028.6
                  ],
                  [
                    62864.8,
                    33390.4
                  ]
                ],
                "id": 389,
                "chat_link": "[&BIUBAAA=]"
              },
              "877": {
                "name": "Secluded Glen",
                "level": 40,
                "coord": [
                  61571.1,
                  32795.5
                ],
                "bounds": [
                  [
                    61579.8,
                    32911.9
                  ],
                  [
                    61685,
                    32846.5
                  ],
                  [
                    61634.9,
                    32697
                  ],
                  [
                    61505.3,
                    32679.9
                  ],
                  [
                    61450.4,
                    32842.2
                  ],
                  [
                    61579.8,
                    32911.9
                  ]
                ],
                "id": 877,
                "chat_link": "[&BG0DAAA=]"
              }
            },
            "id": 1133,
            "mastery_points": [],
            "adventures": []
          },
          "1134": {
            "name": "Blightwater Shatterstrike",
            "min_level": 40,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              62998,
              30464
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                61952,
                28544
              ],
              [
                64000,
                32640
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "484": {
                "name": "Tawny Ridge",
                "level": 49,
                "coord": [
                  63787.3,
                  29317.5
                ],
                "bounds": [
                  [
                    63834.3,
                    29385.9
                  ],
                  [
                    63878.9,
                    29286.7
                  ],
                  [
                    63836.8,
                    29212
                  ],
                  [
                    63745.4,
                    29237.2
                  ],
                  [
                    63699,
                    29364
                  ],
                  [
                    63729.6,
                    29419
                  ],
                  [
                    63834.3,
                    29385.9
                  ]
                ],
                "id": 484,
                "chat_link": "[&BOQBAAA=]"
              },
              "485": {
                "name": "Steeleye Span",
                "level": 43,
                "coord": [
                  62529.3,
                  31630.3
                ],
                "bounds": [
                  [
                    62334,
                    31493.3
                  ],
                  [
                    62569.1,
                    31511.8
                  ],
                  [
                    62764.5,
                    31653.4
                  ],
                  [
                    62647.5,
                    31807
                  ],
                  [
                    62331.5,
                    31685.8
                  ],
                  [
                    62334,
                    31493.3
                  ]
                ],
                "id": 485,
                "chat_link": "[&BOUBAAA=]"
              },
              "486": {
                "name": "Deserter Flats",
                "level": 45,
                "coord": [
                  62613.5,
                  30722.1
                ],
                "bounds": [
                  [
                    62439.6,
                    30695.3
                  ],
                  [
                    62452.9,
                    30472.3
                  ],
                  [
                    62598.7,
                    30334.8
                  ],
                  [
                    62811.9,
                    30457.6
                  ],
                  [
                    62958.3,
                    30707.9
                  ],
                  [
                    62839.8,
                    30912.9
                  ],
                  [
                    62726.3,
                    30877.3
                  ],
                  [
                    62641.9,
                    30973.8
                  ],
                  [
                    62351.8,
                    31035.3
                  ],
                  [
                    62313.7,
                    30754.1
                  ],
                  [
                    62439.6,
                    30695.3
                  ]
                ],
                "id": 486,
                "chat_link": "[&BOYBAAA=]"
              },
              "487": {
                "name": "Hazmagic Aggregate",
                "level": 48,
                "coord": [
                  62738.3,
                  30060.6
                ],
                "bounds": [
                  [
                    62811.3,
                    30462.7
                  ],
                  [
                    62929.5,
                    30273.1
                  ],
                  [
                    62928.1,
                    30070
                  ],
                  [
                    62816,
                    29773.8
                  ],
                  [
                    62843.9,
                    29606.6
                  ],
                  [
                    62492,
                    29699.6
                  ],
                  [
                    62573.5,
                    30053.8
                  ],
                  [
                    62658.6,
                    30065.7
                  ],
                  [
                    62730.9,
                    30263
                  ],
                  [
                    62598.8,
                    30337.7
                  ],
                  [
                    62811.3,
                    30462.7
                  ]
                ],
                "id": 487,
                "chat_link": "[&BOcBAAA=]"
              },
              "488": {
                "name": "Foulblain Expanse",
                "level": 43,
                "coord": [
                  62557.5,
                  31301.7
                ],
                "bounds": [
                  [
                    62337.1,
                    31156.7
                  ],
                  [
                    62350.8,
                    31028.3
                  ],
                  [
                    62645.7,
                    30961.6
                  ],
                  [
                    62603.2,
                    31125.8
                  ],
                  [
                    62658.3,
                    31339.5
                  ],
                  [
                    62753.8,
                    31420.5
                  ],
                  [
                    62762.4,
                    31655.3
                  ],
                  [
                    62568.6,
                    31523.9
                  ],
                  [
                    62337.9,
                    31504.2
                  ],
                  [
                    62337.1,
                    31156.7
                  ]
                ],
                "id": 488,
                "chat_link": "[&BOgBAAA=]"
              },
              "489": {
                "name": "Lowland Burns",
                "level": 50,
                "coord": [
                  62333.4,
                  28730.6
                ],
                "bounds": [
                  [
                    62331.1,
                    28939.1
                  ],
                  [
                    62257.1,
                    28819.7
                  ],
                  [
                    62090.8,
                    28826.8
                  ],
                  [
                    61794.4,
                    28687.8
                  ],
                  [
                    61938.5,
                    28177.5
                  ],
                  [
                    62027.6,
                    28190.3
                  ],
                  [
                    62106.3,
                    28274.4
                  ],
                  [
                    62222.5,
                    28337.8
                  ],
                  [
                    62320,
                    28413.6
                  ],
                  [
                    62385.2,
                    28509.2
                  ],
                  [
                    62435.3,
                    28600.1
                  ],
                  [
                    62517.2,
                    28640.4
                  ],
                  [
                    62670,
                    29018.7
                  ],
                  [
                    62922.2,
                    29225.1
                  ],
                  [
                    62890,
                    29333.1
                  ],
                  [
                    62446,
                    29308.9
                  ],
                  [
                    62313.5,
                    29117.5
                  ],
                  [
                    62331.1,
                    28939.1
                  ]
                ],
                "id": 489,
                "chat_link": "[&BOkBAAA=]"
              },
              "490": {
                "name": "Blightwater Basin",
                "level": 42,
                "coord": [
                  62087.1,
                  32282.7
                ],
                "bounds": [
                  [
                    62475.8,
                    32616.7
                  ],
                  [
                    62449.6,
                    32150.3
                  ],
                  [
                    62646.2,
                    31808.5
                  ],
                  [
                    62331.8,
                    31685.8
                  ],
                  [
                    62326.8,
                    31780.5
                  ],
                  [
                    61973.7,
                    31941.7
                  ],
                  [
                    61509.8,
                    32070.4
                  ],
                  [
                    61678.1,
                    32224.7
                  ],
                  [
                    61761.7,
                    32366.7
                  ],
                  [
                    61787.2,
                    32521.6
                  ],
                  [
                    61870.1,
                    32635.4
                  ],
                  [
                    62002.2,
                    32677.4
                  ],
                  [
                    62097.8,
                    32730.4
                  ],
                  [
                    62308.7,
                    32747.6
                  ],
                  [
                    62475.8,
                    32616.7
                  ]
                ],
                "id": 490,
                "chat_link": "[&BOoBAAA=]"
              },
              "491": {
                "name": "Tumok's Last Stand",
                "level": 42,
                "coord": [
                  62708.1,
                  32441.5
                ],
                "bounds": [
                  [
                    62475.4,
                    32613.9
                  ],
                  [
                    62574.8,
                    32661.6
                  ],
                  [
                    62807.9,
                    32713.7
                  ],
                  [
                    62940,
                    32662.1
                  ],
                  [
                    62957.1,
                    32598.9
                  ],
                  [
                    63050.1,
                    32235.4
                  ],
                  [
                    62644.3,
                    31809.7
                  ],
                  [
                    62452.7,
                    32155.4
                  ],
                  [
                    62470.8,
                    32522.3
                  ],
                  [
                    62475.4,
                    32613.9
                  ]
                ],
                "id": 491,
                "chat_link": "[&BOsBAAA=]"
              },
              "492": {
                "name": "Pockmark Roughs",
                "level": 45,
                "coord": [
                  63227.9,
                  31010.7
                ],
                "bounds": [
                  [
                    62841,
                    30913.6
                  ],
                  [
                    62955.5,
                    30712.2
                  ],
                  [
                    63229.3,
                    30638.3
                  ],
                  [
                    63447.8,
                    30736.4
                  ],
                  [
                    63538.4,
                    30885.5
                  ],
                  [
                    63527.2,
                    31093
                  ],
                  [
                    63443.4,
                    31236.1
                  ],
                  [
                    63307.8,
                    31352.4
                  ],
                  [
                    63109.2,
                    31370.7
                  ],
                  [
                    62879.8,
                    31168.8
                  ],
                  [
                    62841,
                    30913.6
                  ]
                ],
                "id": 492,
                "chat_link": "[&BOwBAAA=]"
              },
              "493": {
                "name": "Crater Rim",
                "level": 42,
                "coord": [
                  62868.6,
                  31245.7
                ],
                "bounds": [
                  [
                    62751.9,
                    31427.3
                  ],
                  [
                    62658.5,
                    31342.8
                  ],
                  [
                    62601,
                    31130.2
                  ],
                  [
                    62636.8,
                    30977.7
                  ],
                  [
                    62730.2,
                    30877.8
                  ],
                  [
                    62840.6,
                    30911.7
                  ],
                  [
                    62877.2,
                    31164.1
                  ],
                  [
                    63108.9,
                    31367.5
                  ],
                  [
                    63307.8,
                    31349.7
                  ],
                  [
                    63280.4,
                    31498.4
                  ],
                  [
                    62760.8,
                    31655
                  ],
                  [
                    62751.9,
                    31427.3
                  ]
                ],
                "id": 493,
                "chat_link": "[&BO0BAAA=]"
              },
              "494": {
                "name": "Behem Gauntlet",
                "level": 42,
                "coord": [
                  63694.3,
                  31526.8
                ],
                "bounds": [
                  [
                    63271.2,
                    31726
                  ],
                  [
                    63385.2,
                    31922
                  ],
                  [
                    63651.7,
                    31679.6
                  ],
                  [
                    63924.3,
                    31814.5
                  ],
                  [
                    64038.7,
                    31803.6
                  ],
                  [
                    64094,
                    31571.6
                  ],
                  [
                    64085.1,
                    31319.6
                  ],
                  [
                    63942.8,
                    31304.5
                  ],
                  [
                    63873.8,
                    31387.6
                  ],
                  [
                    63782,
                    31414.4
                  ],
                  [
                    63740.9,
                    31473.9
                  ],
                  [
                    63595.5,
                    31417.7
                  ],
                  [
                    63441.6,
                    31227.4
                  ],
                  [
                    63311.4,
                    31343.3
                  ],
                  [
                    63276.7,
                    31496.2
                  ],
                  [
                    63271.2,
                    31726
                  ]
                ],
                "id": 494,
                "chat_link": "[&BO4BAAA=]"
              },
              "495": {
                "name": "Unbroken Expanse",
                "level": 45,
                "coord": [
                  63211.9,
                  30390.3
                ],
                "bounds": [
                  [
                    63228.8,
                    30645.9
                  ],
                  [
                    63447.9,
                    30738.9
                  ],
                  [
                    63594.9,
                    30605.9
                  ],
                  [
                    63546,
                    30298.3
                  ],
                  [
                    63595.9,
                    30138.5
                  ],
                  [
                    63083,
                    29956.2
                  ],
                  [
                    62925.8,
                    30070.6
                  ],
                  [
                    62926.9,
                    30273.4
                  ],
                  [
                    62810.4,
                    30458.3
                  ],
                  [
                    62959.4,
                    30717.1
                  ],
                  [
                    63228.8,
                    30645.9
                  ]
                ],
                "id": 495,
                "chat_link": "[&BO8BAAA=]"
              },
              "496": {
                "name": "Gastor Gullet",
                "level": 45,
                "coord": [
                  63716,
                  31092.8
                ],
                "bounds": [
                  [
                    63527.8,
                    31091.7
                  ],
                  [
                    63538.8,
                    30886.2
                  ],
                  [
                    63447.1,
                    30737.8
                  ],
                  [
                    63593.5,
                    30606.3
                  ],
                  [
                    63767.3,
                    30670.9
                  ],
                  [
                    63870.3,
                    30901.8
                  ],
                  [
                    63918.4,
                    31019.5
                  ],
                  [
                    63979.9,
                    31145
                  ],
                  [
                    63944.9,
                    31306.2
                  ],
                  [
                    63875,
                    31387.9
                  ],
                  [
                    63782.4,
                    31416.7
                  ],
                  [
                    63740.2,
                    31476.7
                  ],
                  [
                    63594,
                    31418.9
                  ],
                  [
                    63445,
                    31233.4
                  ],
                  [
                    63527.8,
                    31091.7
                  ]
                ],
                "id": 496,
                "chat_link": "[&BPABAAA=]"
              },
              "497": {
                "name": "Degun Shun",
                "level": 45,
                "coord": [
                  63692.8,
                  30247.4
                ],
                "bounds": [
                  [
                    63695,
                    30391.3
                  ],
                  [
                    63851.2,
                    30298.3
                  ],
                  [
                    63781.1,
                    30177
                  ],
                  [
                    63698.5,
                    30183.2
                  ],
                  [
                    63586.8,
                    30135.9
                  ],
                  [
                    63544.1,
                    30298.9
                  ],
                  [
                    63695,
                    30391.3
                  ]
                ],
                "id": 497,
                "chat_link": "[&BPEBAAA=]"
              },
              "498": {
                "name": "Agrak Kraal",
                "level": 45,
                "coord": [
                  63888,
                  30702.1
                ],
                "bounds": [
                  [
                    63855.5,
                    30566.8
                  ],
                  [
                    63937.4,
                    30576.7
                  ],
                  [
                    63946.3,
                    30708
                  ],
                  [
                    63970,
                    30827.9
                  ],
                  [
                    63847.8,
                    30864
                  ],
                  [
                    63771.2,
                    30669.4
                  ],
                  [
                    63855.5,
                    30566.8
                  ]
                ],
                "id": 498,
                "chat_link": "[&BPIBAAA=]"
              },
              "499": {
                "name": "Twin Sisters Crossing",
                "level": 42,
                "coord": [
                  63862.8,
                  32402.3
                ],
                "bounds": [
                  [
                    63927,
                    32682.5
                  ],
                  [
                    63797.7,
                    32729.8
                  ],
                  [
                    63678.9,
                    32732
                  ],
                  [
                    63567.1,
                    32672.7
                  ],
                  [
                    63547.2,
                    32581.1
                  ],
                  [
                    63612.6,
                    32474.9
                  ],
                  [
                    63559.8,
                    32276.8
                  ],
                  [
                    63645.6,
                    32136.1
                  ],
                  [
                    63901.9,
                    31992.3
                  ],
                  [
                    63945,
                    32022
                  ],
                  [
                    63957.7,
                    32129.7
                  ],
                  [
                    64026.3,
                    32249.1
                  ],
                  [
                    64121.1,
                    32326.2
                  ],
                  [
                    64202.4,
                    32366.9
                  ],
                  [
                    64241,
                    32436.5
                  ],
                  [
                    64074.1,
                    32628.4
                  ],
                  [
                    63927,
                    32682.5
                  ]
                ],
                "id": 499,
                "chat_link": "[&BPMBAAA=]"
              },
              "500": {
                "name": "Splinter Hills",
                "level": 42,
                "coord": [
                  63436.8,
                  32369.6
                ],
                "bounds": [
                  [
                    63036.6,
                    32228.9
                  ],
                  [
                    63648.4,
                    31681.5
                  ],
                  [
                    63923.3,
                    31813.4
                  ],
                  [
                    63906.8,
                    31993.9
                  ],
                  [
                    63645.5,
                    32137.2
                  ],
                  [
                    63559.9,
                    32277.8
                  ],
                  [
                    63612.5,
                    32475.6
                  ],
                  [
                    63548.9,
                    32581.5
                  ],
                  [
                    63569.1,
                    32673.9
                  ],
                  [
                    63427,
                    32726.4
                  ],
                  [
                    63250.9,
                    32645.8
                  ],
                  [
                    63095.1,
                    32692.7
                  ],
                  [
                    62937.4,
                    32653.1
                  ],
                  [
                    62953.7,
                    32592.1
                  ],
                  [
                    63036.6,
                    32228.9
                  ]
                ],
                "id": 500,
                "chat_link": "[&BPQBAAA=]"
              },
              "501": {
                "name": "Soot Road",
                "level": 42,
                "coord": [
                  63065.7,
                  31805.3
                ],
                "bounds": [
                  [
                    62763.1,
                    31650.1
                  ],
                  [
                    63278.9,
                    31499.1
                  ],
                  [
                    63273,
                    31723.4
                  ],
                  [
                    63386.3,
                    31922.3
                  ],
                  [
                    63044.8,
                    32226.1
                  ],
                  [
                    62647.9,
                    31810.5
                  ],
                  [
                    62763.1,
                    31650.1
                  ]
                ],
                "id": 501,
                "chat_link": "[&BPUBAAA=]"
              },
              "502": {
                "name": "Tongue Rock",
                "level": 45,
                "coord": [
                  62007.1,
                  30517.7
                ],
                "bounds": [
                  [
                    62232.6,
                    30493.1
                  ],
                  [
                    62156,
                    30619.2
                  ],
                  [
                    61988.4,
                    30604.4
                  ],
                  [
                    61818.8,
                    30755.6
                  ],
                  [
                    61834,
                    30623.4
                  ],
                  [
                    61898.2,
                    30479.3
                  ],
                  [
                    61876.1,
                    30403.2
                  ],
                  [
                    62014.4,
                    30456.3
                  ],
                  [
                    62099.9,
                    30361.9
                  ],
                  [
                    62152.6,
                    30381
                  ],
                  [
                    62232.6,
                    30493.1
                  ]
                ],
                "id": 502,
                "chat_link": "[&BPYBAAA=]"
              },
              "503": {
                "name": "Terra Combusta",
                "level": 49,
                "coord": [
                  62967.3,
                  28959.5
                ],
                "bounds": [
                  [
                    62914.2,
                    29238.7
                  ],
                  [
                    62669.5,
                    29019
                  ],
                  [
                    62515.1,
                    28641.8
                  ],
                  [
                    62776.6,
                    28568.7
                  ],
                  [
                    63054.8,
                    28653
                  ],
                  [
                    63103.2,
                    28738.1
                  ],
                  [
                    63387,
                    28803.3
                  ],
                  [
                    63161.3,
                    29217.8
                  ],
                  [
                    63199,
                    29380.4
                  ],
                  [
                    62891.9,
                    29334.6
                  ],
                  [
                    62914.2,
                    29238.7
                  ]
                ],
                "id": 503,
                "chat_link": "[&BPcBAAA=]"
              },
              "504": {
                "name": "Terra Carorunda",
                "level": 49,
                "coord": [
                  63646.7,
                  29033.7
                ],
                "bounds": [
                  [
                    63201.7,
                    29381.4
                  ],
                  [
                    63409.6,
                    29507.8
                  ],
                  [
                    63750.9,
                    29457.3
                  ],
                  [
                    63700,
                    29362.1
                  ],
                  [
                    63748.1,
                    29237
                  ],
                  [
                    63838.9,
                    29214.4
                  ],
                  [
                    63881,
                    29161.8
                  ],
                  [
                    63872.6,
                    28991.6
                  ],
                  [
                    63962.4,
                    28839.9
                  ],
                  [
                    63943.6,
                    28602.4
                  ],
                  [
                    63754.8,
                    28591
                  ],
                  [
                    63640.6,
                    28555.1
                  ],
                  [
                    63447.2,
                    28584
                  ],
                  [
                    63389.2,
                    28801
                  ],
                  [
                    63160.3,
                    29218.5
                  ],
                  [
                    63201.7,
                    29381.4
                  ]
                ],
                "id": 504,
                "chat_link": "[&BPgBAAA=]"
              },
              "505": {
                "name": "Shattered Palisades",
                "level": 49,
                "coord": [
                  63287.8,
                  29508.3
                ],
                "bounds": [
                  [
                    63449.3,
                    29664.6
                  ],
                  [
                    63735.3,
                    29560.1
                  ],
                  [
                    63750.7,
                    29455.5
                  ],
                  [
                    63408.7,
                    29506
                  ],
                  [
                    63200.8,
                    29377.6
                  ],
                  [
                    62817.8,
                    29319.5
                  ],
                  [
                    62844.4,
                    29604.2
                  ],
                  [
                    63095.2,
                    29579.1
                  ],
                  [
                    63449.3,
                    29664.6
                  ]
                ],
                "id": 505,
                "chat_link": "[&BPkBAAA=]"
              },
              "506": {
                "name": "Monument Grounds",
                "level": 50,
                "coord": [
                  62337.5,
                  29448.3
                ],
                "bounds": [
                  [
                    62494,
                    29697.9
                  ],
                  [
                    62842.3,
                    29604.2
                  ],
                  [
                    62815.3,
                    29323.4
                  ],
                  [
                    62445,
                    29310.7
                  ],
                  [
                    62394.7,
                    29405.1
                  ],
                  [
                    62030.1,
                    29409.7
                  ],
                  [
                    61826.2,
                    29318.8
                  ],
                  [
                    61852.4,
                    29516.2
                  ],
                  [
                    62494,
                    29697.9
                  ]
                ],
                "id": 506,
                "chat_link": "[&BPoBAAA=]"
              },
              "507": {
                "name": "Heretic Plain",
                "level": 47,
                "coord": [
                  63435.8,
                  29829
                ],
                "bounds": [
                  [
                    62818.3,
                    29770.1
                  ],
                  [
                    62841.7,
                    29605.5
                  ],
                  [
                    63095.3,
                    29579.2
                  ],
                  [
                    63445.5,
                    29663.5
                  ],
                  [
                    63733,
                    29560.5
                  ],
                  [
                    63873.3,
                    29555.4
                  ],
                  [
                    63930,
                    29805.3
                  ],
                  [
                    63930.2,
                    30021.5
                  ],
                  [
                    63856.9,
                    30170.4
                  ],
                  [
                    63696.5,
                    30184.3
                  ],
                  [
                    63082.1,
                    29961.7
                  ],
                  [
                    62926.8,
                    30071.2
                  ],
                  [
                    62818.3,
                    29770.1
                  ]
                ],
                "id": 507,
                "chat_link": "[&BPsBAAA=]"
              },
              "508": {
                "name": "Kindling Bridge",
                "level": 50,
                "coord": [
                  62106.6,
                  29094
                ],
                "bounds": [
                  [
                    61831.5,
                    29315.7
                  ],
                  [
                    61875,
                    29191.1
                  ],
                  [
                    61781.9,
                    29002.1
                  ],
                  [
                    61799.7,
                    28689.3
                  ],
                  [
                    62091.7,
                    28823.8
                  ],
                  [
                    62261.8,
                    28824.8
                  ],
                  [
                    62335.3,
                    28942.4
                  ],
                  [
                    62313.2,
                    29121.6
                  ],
                  [
                    62450.6,
                    29310
                  ],
                  [
                    62398.5,
                    29405.6
                  ],
                  [
                    62033.3,
                    29407.7
                  ],
                  [
                    61831.5,
                    29315.7
                  ]
                ],
                "id": 508,
                "chat_link": "[&BPwBAAA=]"
              },
              "509": {
                "name": "Dragonwatch",
                "level": 43,
                "coord": [
                  62071,
                  31427.8
                ],
                "bounds": [
                  [
                    62326.5,
                    31774.7
                  ],
                  [
                    62338.5,
                    31506.3
                  ],
                  [
                    62339,
                    31156.7
                  ],
                  [
                    62107.7,
                    31209.2
                  ],
                  [
                    61953.1,
                    31186
                  ],
                  [
                    61952,
                    31215.8
                  ],
                  [
                    61944.9,
                    31281.9
                  ],
                  [
                    61954.3,
                    31359.3
                  ],
                  [
                    61819.8,
                    31647.2
                  ],
                  [
                    61974.8,
                    31940.8
                  ],
                  [
                    62326.5,
                    31774.7
                  ]
                ],
                "id": 509,
                "chat_link": "[&BP0BAAA=]"
              },
              "510": {
                "name": "Ratcatcher Knoll",
                "level": 45,
                "coord": [
                  62202.2,
                  30748
                ],
                "bounds": [
                  [
                    62107.6,
                    31211
                  ],
                  [
                    61958.7,
                    31186.4
                  ],
                  [
                    61818.8,
                    30757.4
                  ],
                  [
                    61993.7,
                    30604.6
                  ],
                  [
                    62153.8,
                    30620.1
                  ],
                  [
                    62231.2,
                    30491.7
                  ],
                  [
                    62150.8,
                    30381.6
                  ],
                  [
                    62310.9,
                    30344.7
                  ],
                  [
                    62456.3,
                    30474.6
                  ],
                  [
                    62442.6,
                    30698.2
                  ],
                  [
                    62314.6,
                    30758.1
                  ],
                  [
                    62354.1,
                    31035.8
                  ],
                  [
                    62334.9,
                    31159.4
                  ],
                  [
                    62107.6,
                    31211
                  ]
                ],
                "id": 510,
                "chat_link": "[&BP4BAAA=]"
              },
              "511": {
                "name": "Relliatus Canyon",
                "level": 47,
                "coord": [
                  62217.2,
                  30139.4
                ],
                "bounds": [
                  [
                    62010,
                    30457.9
                  ],
                  [
                    62100.9,
                    30361.2
                  ],
                  [
                    62151.1,
                    30381
                  ],
                  [
                    62311,
                    30347.8
                  ],
                  [
                    62455,
                    30476.1
                  ],
                  [
                    62600.2,
                    30334.8
                  ],
                  [
                    62464.6,
                    30156.9
                  ],
                  [
                    62476.8,
                    30058.2
                  ],
                  [
                    62573.8,
                    30052.6
                  ],
                  [
                    62494.1,
                    29698.1
                  ],
                  [
                    61853.7,
                    29509.6
                  ],
                  [
                    61831.6,
                    29761.8
                  ],
                  [
                    61837.2,
                    29956.5
                  ],
                  [
                    61880.5,
                    30399.3
                  ],
                  [
                    62010,
                    30457.9
                  ]
                ],
                "id": 511,
                "chat_link": "[&BP8BAAA=]"
              },
              "758": {
                "name": "InGenium Research Facility",
                "level": 48,
                "coord": [
                  62584.6,
                  30155.2
                ],
                "bounds": [
                  [
                    62463.8,
                    30156.9
                  ],
                  [
                    62476.9,
                    30056.9
                  ],
                  [
                    62577.4,
                    30050.8
                  ],
                  [
                    62660.6,
                    30065.2
                  ],
                  [
                    62729.8,
                    30264
                  ],
                  [
                    62599.3,
                    30337.5
                  ],
                  [
                    62463.8,
                    30156.9
                  ]
                ],
                "id": 758,
                "chat_link": "[&BPYCAAA=]"
              }
            },
            "id": 1134,
            "mastery_points": [],
            "adventures": []
          },
          "1135": {
            "name": "Branded for Termination",
            "min_level": 30,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              62976,
              34176
            ],
            "map_rect": [
              [
                -36864,
                -36864
              ],
              [
                36864,
                36864
              ]
            ],
            "continent_rect": [
              [
                61440,
                32640
              ],
              [
                64512,
                35712
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "365": {
                "name": "Last Stand Shelter",
                "level": 31,
                "coord": [
                  61657.9,
                  35015.4
                ],
                "bounds": [
                  [
                    61456.9,
                    34889.1
                  ],
                  [
                    61607.9,
                    34741.1
                  ],
                  [
                    61812.8,
                    34931.5
                  ],
                  [
                    61785.2,
                    35009.7
                  ],
                  [
                    61709.3,
                    35063.5
                  ],
                  [
                    61698.5,
                    35205.7
                  ],
                  [
                    61534.8,
                    35267.4
                  ],
                  [
                    61456.9,
                    34889.1
                  ]
                ],
                "id": 365,
                "chat_link": "[&BG0BAAA=]"
              },
              "366": {
                "name": "Blackwing Excavation",
                "level": 31,
                "coord": [
                  62641.1,
                  35403.7
                ],
                "bounds": [
                  [
                    62557.5,
                    35091.2
                  ],
                  [
                    62771.9,
                    35156.6
                  ],
                  [
                    62878.7,
                    35543.5
                  ],
                  [
                    62746.7,
                    35649.8
                  ],
                  [
                    62451.9,
                    35654.8
                  ],
                  [
                    62440,
                    35326.3
                  ],
                  [
                    62557.5,
                    35091.2
                  ]
                ],
                "id": 366,
                "chat_link": "[&BG4BAAA=]"
              },
              "367": {
                "name": "Stronghold of Ebonhawke",
                "level": 31,
                "coord": [
                  62008.8,
                  35138
                ],
                "bounds": [
                  [
                    61812.5,
                    34931.7
                  ],
                  [
                    61608.6,
                    34739.7
                  ],
                  [
                    61974.8,
                    34550.6
                  ],
                  [
                    62116.3,
                    34621.3
                  ],
                  [
                    62342,
                    34818.7
                  ],
                  [
                    62699,
                    34688.4
                  ],
                  [
                    62557.7,
                    35091.4
                  ],
                  [
                    62440.8,
                    35324.7
                  ],
                  [
                    62450.3,
                    35654.7
                  ],
                  [
                    62165.5,
                    35625.2
                  ],
                  [
                    61939.4,
                    35533.8
                  ],
                  [
                    61770.3,
                    35659.5
                  ],
                  [
                    61542.8,
                    35558.4
                  ],
                  [
                    61534.8,
                    35269.1
                  ],
                  [
                    61699,
                    35206.4
                  ],
                  [
                    61709.8,
                    35064.6
                  ],
                  [
                    61785.5,
                    35008.6
                  ],
                  [
                    61812.5,
                    34931.7
                  ]
                ],
                "id": 367,
                "chat_link": "[&BG8BAAA=]"
              },
              "368": {
                "name": "Grimm Hills",
                "level": 34,
                "coord": [
                  62913.6,
                  34678.1
                ],
                "bounds": [
                  [
                    62775,
                    35155.6
                  ],
                  [
                    63095.2,
                    34880.6
                  ],
                  [
                    63095,
                    34671.8
                  ],
                  [
                    63212.3,
                    34293.8
                  ],
                  [
                    63014.9,
                    34325.3
                  ],
                  [
                    62889.8,
                    34422.3
                  ],
                  [
                    62883.8,
                    34575
                  ],
                  [
                    62698.5,
                    34687.4
                  ],
                  [
                    62558.2,
                    35091.2
                  ],
                  [
                    62775,
                    35155.6
                  ]
                ],
                "id": 368,
                "chat_link": "[&BHABAAA=]"
              },
              "369": {
                "name": "The Ogre Road",
                "level": 33,
                "coord": [
                  63775.2,
                  34960.3
                ],
                "bounds": [
                  [
                    63818,
                    34775.5
                  ],
                  [
                    64049.9,
                    34874.6
                  ],
                  [
                    63983.2,
                    35117.8
                  ],
                  [
                    63650.4,
                    35343.8
                  ],
                  [
                    63469.1,
                    34973.7
                  ],
                  [
                    63680.8,
                    34676.6
                  ],
                  [
                    63818,
                    34775.5
                  ]
                ],
                "id": 369,
                "chat_link": "[&BHEBAAA=]"
              },
              "370": {
                "name": "Wildlin Narrows",
                "level": 34,
                "coord": [
                  64113.6,
                  35332.1
                ],
                "bounds": [
                  [
                    63981.4,
                    35119
                  ],
                  [
                    64047.3,
                    34879.9
                  ],
                  [
                    64446.4,
                    34880.2
                  ],
                  [
                    64454.7,
                    35016.9
                  ],
                  [
                    64482.5,
                    35162.6
                  ],
                  [
                    64437,
                    35419.7
                  ],
                  [
                    64379.4,
                    35572.2
                  ],
                  [
                    64266.7,
                    35658.7
                  ],
                  [
                    63887.2,
                    35684.1
                  ],
                  [
                    63726.7,
                    35630.3
                  ],
                  [
                    63602.3,
                    35623
                  ],
                  [
                    63651.7,
                    35338
                  ],
                  [
                    63981.4,
                    35119
                  ]
                ],
                "id": 370,
                "chat_link": "[&BHIBAAA=]"
              },
              "371": {
                "name": "Mithric Cliffs",
                "level": 35,
                "coord": [
                  64140.7,
                  34560.1
                ],
                "bounds": [
                  [
                    63873.1,
                    34199.8
                  ],
                  [
                    64439.5,
                    34200.8
                  ],
                  [
                    64522.9,
                    34271.7
                  ],
                  [
                    64421.7,
                    34550.9
                  ],
                  [
                    64486.2,
                    34796.1
                  ],
                  [
                    64446.4,
                    34880
                  ],
                  [
                    64049.8,
                    34881.8
                  ],
                  [
                    63817.7,
                    34776.3
                  ],
                  [
                    63679.6,
                    34676
                  ],
                  [
                    63670,
                    34367.5
                  ],
                  [
                    63873.1,
                    34199.8
                  ]
                ],
                "id": 371,
                "chat_link": "[&BHMBAAA=]"
              },
              "372": {
                "name": "Hunter's Gorge",
                "level": 35,
                "coord": [
                  63341.8,
                  34640.5
                ],
                "bounds": [
                  [
                    63669.7,
                    34367.2
                  ],
                  [
                    63679.1,
                    34676
                  ],
                  [
                    63470.3,
                    34973.3
                  ],
                  [
                    63163.9,
                    34985.8
                  ],
                  [
                    63094,
                    34882.4
                  ],
                  [
                    63095.7,
                    34672.5
                  ],
                  [
                    63212.8,
                    34294.4
                  ],
                  [
                    63348.8,
                    34272.4
                  ],
                  [
                    63669.7,
                    34367.2
                  ]
                ],
                "id": 372,
                "chat_link": "[&BHQBAAA=]"
              },
              "373": {
                "name": "The Siege Plains",
                "level": 33,
                "coord": [
                  62661.4,
                  34431.1
                ],
                "bounds": [
                  [
                    62342.5,
                    34820
                  ],
                  [
                    62698.4,
                    34688
                  ],
                  [
                    62884,
                    34573.7
                  ],
                  [
                    62895.1,
                    34415.3
                  ],
                  [
                    63015.8,
                    34325.2
                  ],
                  [
                    62807.6,
                    34052
                  ],
                  [
                    62532,
                    33954.3
                  ],
                  [
                    62115.9,
                    34620.7
                  ],
                  [
                    62342.5,
                    34820
                  ]
                ],
                "id": 373,
                "chat_link": "[&BHUBAAA=]"
              },
              "374": {
                "name": "Sniper's Woods",
                "level": 35,
                "coord": [
                  62135,
                  34190.4
                ],
                "bounds": [
                  [
                    61976.5,
                    34544.7
                  ],
                  [
                    62116.8,
                    34620
                  ],
                  [
                    62531.9,
                    33954
                  ],
                  [
                    62317,
                    33906.1
                  ],
                  [
                    62102.3,
                    34036.9
                  ],
                  [
                    61765.8,
                    34080.3
                  ],
                  [
                    61976.5,
                    34544.7
                  ]
                ],
                "id": 374,
                "chat_link": "[&BHYBAAA=]"
              },
              "375": {
                "name": "Bento Canyon",
                "level": 34,
                "coord": [
                  61654.1,
                  34397.7
                ],
                "bounds": [
                  [
                    61608.5,
                    34740
                  ],
                  [
                    61977.2,
                    34544.8
                  ],
                  [
                    61766,
                    34081.3
                  ],
                  [
                    61522.8,
                    34074.4
                  ],
                  [
                    61571.5,
                    34348
                  ],
                  [
                    61478.8,
                    34597.5
                  ],
                  [
                    61608.5,
                    34740
                  ]
                ],
                "id": 375,
                "chat_link": "[&BHcBAAA=]"
              },
              "376": {
                "name": "Dragonrot Domains",
                "level": 38,
                "coord": [
                  61711,
                  33852.5
                ],
                "bounds": [
                  [
                    61522.5,
                    34074.1
                  ],
                  [
                    61765.8,
                    34080.1
                  ],
                  [
                    62103,
                    34037.3
                  ],
                  [
                    61890.2,
                    33602.7
                  ],
                  [
                    61522.8,
                    33605.5
                  ],
                  [
                    61461.9,
                    33715.2
                  ],
                  [
                    61522.5,
                    34074.1
                  ]
                ],
                "id": 376,
                "chat_link": "[&BHgBAAA=]"
              },
              "377": {
                "name": "Varim's Run",
                "level": 40,
                "coord": [
                  61676.3,
                  33049.4
                ],
                "bounds": [
                  [
                    61684.6,
                    32846.2
                  ],
                  [
                    61627.8,
                    32689
                  ],
                  [
                    61783.8,
                    32640.9
                  ],
                  [
                    62037,
                    32658.6
                  ],
                  [
                    61927,
                    32793.8
                  ],
                  [
                    61888.9,
                    33603.3
                  ],
                  [
                    61521.8,
                    33606.4
                  ],
                  [
                    61568.4,
                    33387.3
                  ],
                  [
                    61411.7,
                    33325.3
                  ],
                  [
                    61408,
                    33080.2
                  ],
                  [
                    61580,
                    32912.1
                  ],
                  [
                    61684.6,
                    32846.2
                  ]
                ],
                "id": 377,
                "chat_link": "[&BHkBAAA=]"
              },
              "378": {
                "name": "Tenaebron Lake",
                "level": 39,
                "coord": [
                  62214.2,
                  33182.2
                ],
                "bounds": [
                  [
                    61884.8,
                    33603.9
                  ],
                  [
                    62102.9,
                    34046.4
                  ],
                  [
                    62317.7,
                    33899.6
                  ],
                  [
                    62262.7,
                    33569.9
                  ],
                  [
                    62495.3,
                    33233.3
                  ],
                  [
                    62442.7,
                    32764
                  ],
                  [
                    62420.4,
                    32651.8
                  ],
                  [
                    62238,
                    32617.8
                  ],
                  [
                    62046.1,
                    32647.3
                  ],
                  [
                    61931.3,
                    32787.9
                  ],
                  [
                    61884.8,
                    33603.9
                  ]
                ],
                "id": 378,
                "chat_link": "[&BHoBAAA=]"
              },
              "379": {
                "name": "Vulture's Sweep",
                "level": 37,
                "coord": [
                  62545.4,
                  33687.2
                ],
                "bounds": [
                  [
                    62315.8,
                    33906
                  ],
                  [
                    62530.4,
                    33952.9
                  ],
                  [
                    62805.8,
                    34052.8
                  ],
                  [
                    62867.3,
                    33390.9
                  ],
                  [
                    62492.3,
                    33242.2
                  ],
                  [
                    62260.7,
                    33578.4
                  ],
                  [
                    62315.8,
                    33906
                  ]
                ],
                "id": 379,
                "chat_link": "[&BHsBAAA=]"
              },
              "380": {
                "name": "Warrior's Crown",
                "level": 36,
                "coord": [
                  63286.9,
                  33885.3
                ],
                "bounds": [
                  [
                    62867.6,
                    33388
                  ],
                  [
                    63792.5,
                    33512.5
                  ],
                  [
                    63709.9,
                    33749.2
                  ],
                  [
                    63468.1,
                    33900.9
                  ],
                  [
                    63349.3,
                    34273.4
                  ],
                  [
                    63014.9,
                    34324.5
                  ],
                  [
                    62805.9,
                    34048.8
                  ],
                  [
                    62867.6,
                    33388
                  ]
                ],
                "id": 380,
                "chat_link": "[&BHwBAAA=]"
              },
              "381": {
                "name": "Belag Crossroads",
                "level": 35,
                "coord": [
                  63662.8,
                  34062.1
                ],
                "bounds": [
                  [
                    63348.9,
                    34273.4
                  ],
                  [
                    63669.7,
                    34368.1
                  ],
                  [
                    63873.3,
                    34199.3
                  ],
                  [
                    63905.5,
                    33881.5
                  ],
                  [
                    63711,
                    33749.6
                  ],
                  [
                    63468.4,
                    33900.9
                  ],
                  [
                    63348.9,
                    34273.4
                  ]
                ],
                "id": 381,
                "chat_link": "[&BH0BAAA=]"
              },
              "382": {
                "name": "Flameroot Caverns",
                "level": 36,
                "coord": [
                  64189.7,
                  33999.4
                ],
                "bounds": [
                  [
                    63872.4,
                    34199.8
                  ],
                  [
                    64439.4,
                    34201.8
                  ],
                  [
                    64395.5,
                    34050.3
                  ],
                  [
                    64466,
                    33931.9
                  ],
                  [
                    64059.3,
                    33731.8
                  ],
                  [
                    63905.5,
                    33880.9
                  ],
                  [
                    63872.4,
                    34199.8
                  ]
                ],
                "id": 382,
                "chat_link": "[&BH4BAAA=]"
              },
              "383": {
                "name": "Highden Caves",
                "level": 37,
                "coord": [
                  64321.2,
                  33581.6
                ],
                "bounds": [
                  [
                    64058.1,
                    33737.1
                  ],
                  [
                    64465.7,
                    33931.5
                  ],
                  [
                    64495.3,
                    33748.5
                  ],
                  [
                    64427.9,
                    33511.7
                  ],
                  [
                    64421.5,
                    33370.7
                  ],
                  [
                    64304.1,
                    33239.5
                  ],
                  [
                    64075.8,
                    33532.5
                  ],
                  [
                    64058.1,
                    33737.1
                  ]
                ],
                "id": 383,
                "chat_link": "[&BH8BAAA=]"
              },
              "384": {
                "name": "Axedrag Cut",
                "level": 37,
                "coord": [
                  63990.9,
                  33565.5
                ],
                "bounds": [
                  [
                    63881.1,
                    33256.4
                  ],
                  [
                    64304,
                    33239.1
                  ],
                  [
                    64083.4,
                    33532.1
                  ],
                  [
                    64061.1,
                    33735.1
                  ],
                  [
                    63905.5,
                    33881.2
                  ],
                  [
                    63710.1,
                    33748.8
                  ],
                  [
                    63881.1,
                    33256.4
                  ]
                ],
                "id": 384,
                "chat_link": "[&BIABAAA=]"
              },
              "385": {
                "name": "Tanglerot Hills",
                "level": 38,
                "coord": [
                  64171.4,
                  32762.6
                ],
                "bounds": [
                  [
                    63983.3,
                    32611.9
                  ],
                  [
                    63951.1,
                    32609.5
                  ],
                  [
                    64029.3,
                    32351.6
                  ],
                  [
                    64129.6,
                    32438.2
                  ],
                  [
                    64262.5,
                    32504.9
                  ],
                  [
                    64348,
                    32526.6
                  ],
                  [
                    64495,
                    32743.9
                  ],
                  [
                    64478.6,
                    33115.1
                  ],
                  [
                    64304,
                    33238.5
                  ],
                  [
                    63880,
                    33257.4
                  ],
                  [
                    64024.1,
                    32991.5
                  ],
                  [
                    63983.3,
                    32611.9
                  ]
                ],
                "id": 385,
                "chat_link": "[&BIEBAAA=]"
              },
              "386": {
                "name": "Halkor Meadows",
                "level": 38,
                "coord": [
                  63745.8,
                  32858
                ],
                "bounds": [
                  [
                    63566.3,
                    33004.5
                  ],
                  [
                    63855.8,
                    33329.6
                  ],
                  [
                    63879.9,
                    33259.8
                  ],
                  [
                    64024.2,
                    32991.6
                  ],
                  [
                    64008,
                    32735
                  ],
                  [
                    63986.5,
                    32610.7
                  ],
                  [
                    63759.8,
                    32579.6
                  ],
                  [
                    63522.4,
                    32646.3
                  ],
                  [
                    63394.6,
                    32629.6
                  ],
                  [
                    63460.5,
                    32793.5
                  ],
                  [
                    63566.3,
                    33004.5
                  ]
                ],
                "id": 386,
                "chat_link": "[&BIIBAAA=]"
              },
              "387": {
                "name": "Thunderbreak Hills",
                "level": 38,
                "coord": [
                  62924.8,
                  32849.6
                ],
                "bounds": [
                  [
                    63401.1,
                    32628
                  ],
                  [
                    63567,
                    33004.2
                  ],
                  [
                    63218.8,
                    33031.5
                  ],
                  [
                    62867.4,
                    33390
                  ],
                  [
                    62493,
                    33242.9
                  ],
                  [
                    62440,
                    32773.5
                  ],
                  [
                    62420.6,
                    32649
                  ],
                  [
                    62745,
                    32572
                  ],
                  [
                    62954.7,
                    32648.8
                  ],
                  [
                    63140.4,
                    32556.1
                  ],
                  [
                    63401.1,
                    32628
                  ]
                ],
                "id": 387,
                "chat_link": "[&BIMBAAA=]"
              },
              "388": {
                "name": "Hautclaire Vale",
                "level": 31,
                "coord": [
                  63239.6,
                  35319.1
                ],
                "bounds": [
                  [
                    63094.3,
                    34879.9
                  ],
                  [
                    63162.7,
                    34986.4
                  ],
                  [
                    63470.2,
                    34971.3
                  ],
                  [
                    63650.7,
                    35342.5
                  ],
                  [
                    63603.5,
                    35626.5
                  ],
                  [
                    63482.8,
                    35538.9
                  ],
                  [
                    63249.2,
                    35599.6
                  ],
                  [
                    63033.2,
                    35546.5
                  ],
                  [
                    62877.4,
                    35543.2
                  ],
                  [
                    62772.5,
                    35155.8
                  ],
                  [
                    63094.3,
                    34879.9
                  ]
                ],
                "id": 388,
                "chat_link": "[&BIQBAAA=]"
              },
              "389": {
                "name": "Gillfarn Plains",
                "level": 38,
                "coord": [
                  63459.3,
                  33253.3
                ],
                "bounds": [
                  [
                    62864.8,
                    33390.4
                  ],
                  [
                    63792.2,
                    33514.1
                  ],
                  [
                    63855.6,
                    33329
                  ],
                  [
                    63566.4,
                    33004.3
                  ],
                  [
                    63217.5,
                    33028.6
                  ],
                  [
                    62864.8,
                    33390.4
                  ]
                ],
                "id": 389,
                "chat_link": "[&BIUBAAA=]"
              },
              "877": {
                "name": "Secluded Glen",
                "level": 40,
                "coord": [
                  61571.1,
                  32795.5
                ],
                "bounds": [
                  [
                    61579.8,
                    32911.9
                  ],
                  [
                    61685,
                    32846.5
                  ],
                  [
                    61634.9,
                    32697
                  ],
                  [
                    61505.3,
                    32679.9
                  ],
                  [
                    61450.4,
                    32842.2
                  ],
                  [
                    61579.8,
                    32911.9
                  ]
                ],
                "id": 877,
                "chat_link": "[&BG0DAAA=]"
              }
            },
            "id": 1135,
            "mastery_points": [],
            "adventures": []
          },
          "1138": {
            "name": "Save Our Supplies",
            "min_level": 50,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              60928,
              27904
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                59904,
                25856
              ],
              [
                61952,
                29952
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "433": {
                "name": "Champion's Shield",
                "level": 54,
                "coord": [
                  60464.9,
                  29077.8
                ],
                "bounds": [
                  [
                    59906.5,
                    29535.9
                  ],
                  [
                    60142.4,
                    29465.2
                  ],
                  [
                    60332.5,
                    29597.5
                  ],
                  [
                    60589.6,
                    29543.2
                  ],
                  [
                    60718.4,
                    29291.3
                  ],
                  [
                    60835.9,
                    29115.6
                  ],
                  [
                    61091.2,
                    29074.5
                  ],
                  [
                    60957.3,
                    29006.4
                  ],
                  [
                    60913.8,
                    28942.5
                  ],
                  [
                    61002.8,
                    28761.8
                  ],
                  [
                    60951.1,
                    28708.4
                  ],
                  [
                    60683.9,
                    28904.1
                  ],
                  [
                    60427.7,
                    28910
                  ],
                  [
                    60185.8,
                    28739.6
                  ],
                  [
                    60010,
                    28837
                  ],
                  [
                    59916.2,
                    28765.3
                  ],
                  [
                    59857.7,
                    28954.8
                  ],
                  [
                    59845.2,
                    29247.4
                  ],
                  [
                    59906.5,
                    29535.9
                  ]
                ],
                "id": 433,
                "chat_link": "[&BLEBAAA=]"
              },
              "434": {
                "name": "Stonesheath Overlook",
                "level": 52,
                "coord": [
                  60716.9,
                  29831.6
                ],
                "bounds": [
                  [
                    60590,
                    29542.5
                  ],
                  [
                    60789.9,
                    29653.4
                  ],
                  [
                    60847,
                    29766
                  ],
                  [
                    61007.3,
                    29781.6
                  ],
                  [
                    61022.8,
                    29864.7
                  ],
                  [
                    61004.8,
                    30017.5
                  ],
                  [
                    60894.1,
                    30007.1
                  ],
                  [
                    60882.6,
                    29951
                  ],
                  [
                    60546.7,
                    29973.3
                  ],
                  [
                    60340.5,
                    29968.3
                  ],
                  [
                    60344.7,
                    29856.1
                  ],
                  [
                    60332.8,
                    29597.5
                  ],
                  [
                    60590,
                    29542.5
                  ]
                ],
                "id": 434,
                "chat_link": "[&BLIBAAA=]"
              },
              "435": {
                "name": "Ironhead Lake",
                "level": 53,
                "coord": [
                  60996,
                  29461.3
                ],
                "bounds": [
                  [
                    60590.1,
                    29543.3
                  ],
                  [
                    60717.6,
                    29291.3
                  ],
                  [
                    60841.1,
                    29124.2
                  ],
                  [
                    61093.5,
                    29078
                  ],
                  [
                    61068.2,
                    29273.4
                  ],
                  [
                    61217.3,
                    29440.5
                  ],
                  [
                    61345.6,
                    29440.3
                  ],
                  [
                    61300.9,
                    29540.5
                  ],
                  [
                    61133.8,
                    29602.9
                  ],
                  [
                    61006.7,
                    29782.2
                  ],
                  [
                    60847.3,
                    29765.4
                  ],
                  [
                    60789.4,
                    29654
                  ],
                  [
                    60590.1,
                    29543.3
                  ]
                ],
                "id": 435,
                "chat_link": "[&BLMBAAA=]"
              },
              "436": {
                "name": "Bloodfin Lake",
                "level": 51,
                "coord": [
                  61404.3,
                  29650.5
                ],
                "bounds": [
                  [
                    61022.8,
                    29864.5
                  ],
                  [
                    61004.7,
                    29985.7
                  ],
                  [
                    61350.3,
                    29943.7
                  ],
                  [
                    61760.3,
                    29939.8
                  ],
                  [
                    61940.2,
                    29782.8
                  ],
                  [
                    61910.7,
                    29321.9
                  ],
                  [
                    61623.8,
                    29354.3
                  ],
                  [
                    61450.5,
                    29244
                  ],
                  [
                    61345,
                    29444.2
                  ],
                  [
                    61301.4,
                    29542.6
                  ],
                  [
                    61134,
                    29601.3
                  ],
                  [
                    61007.8,
                    29781.6
                  ],
                  [
                    61022.8,
                    29864.5
                  ]
                ],
                "id": 436,
                "chat_link": "[&BLQBAAA=]"
              },
              "437": {
                "name": "Hellion Forest",
                "level": 50,
                "coord": [
                  61648.8,
                  28968.5
                ],
                "bounds": [
                  [
                    61910.6,
                    29321.8
                  ],
                  [
                    61931.3,
                    29157
                  ],
                  [
                    61883.4,
                    28921.1
                  ],
                  [
                    61948.3,
                    28935.3
                  ],
                  [
                    61942.7,
                    28820.8
                  ],
                  [
                    61845.8,
                    28768.9
                  ],
                  [
                    61552.7,
                    28703.4
                  ],
                  [
                    61535.9,
                    28658.7
                  ],
                  [
                    61334.8,
                    28784.4
                  ],
                  [
                    61369.3,
                    28879.6
                  ],
                  [
                    61280.9,
                    28993.9
                  ],
                  [
                    61472.2,
                    29014.5
                  ],
                  [
                    61450.3,
                    29243.6
                  ],
                  [
                    61624.8,
                    29356.3
                  ],
                  [
                    61910.6,
                    29321.8
                  ]
                ],
                "id": 437,
                "chat_link": "[&BLUBAAA=]"
              },
              "438": {
                "name": "Sunken Halls of Clarent",
                "level": 52,
                "coord": [
                  61277.8,
                  29213.2
                ],
                "bounds": [
                  [
                    61347.8,
                    29439.2
                  ],
                  [
                    61448.9,
                    29243.7
                  ],
                  [
                    61473,
                    29014
                  ],
                  [
                    61281.3,
                    28993.9
                  ],
                  [
                    61099.6,
                    29081
                  ],
                  [
                    61072.4,
                    29280.6
                  ],
                  [
                    61221.9,
                    29440.1
                  ],
                  [
                    61347.8,
                    29439.2
                  ]
                ],
                "id": 438,
                "chat_link": "[&BLYBAAA=]"
              },
              "439": {
                "name": "Monger's Sink",
                "level": 55,
                "coord": [
                  60560.7,
                  28563.1
                ],
                "bounds": [
                  [
                    60189.3,
                    28428.1
                  ],
                  [
                    60011.7,
                    28232.8
                  ],
                  [
                    60764,
                    28201
                  ],
                  [
                    60892.6,
                    28405.2
                  ],
                  [
                    60939.4,
                    28542
                  ],
                  [
                    60951.9,
                    28705.5
                  ],
                  [
                    60684.6,
                    28903.9
                  ],
                  [
                    60427.8,
                    28910.6
                  ],
                  [
                    60184.9,
                    28738.9
                  ],
                  [
                    60189.3,
                    28428.1
                  ]
                ],
                "id": 439,
                "chat_link": "[&BLcBAAA=]"
              },
              "440": {
                "name": "Scourgejaw's Vault",
                "level": 55,
                "coord": [
                  60036.3,
                  28558.1
                ],
                "bounds": [
                  [
                    60011.6,
                    28232.4
                  ],
                  [
                    60189.3,
                    28428.5
                  ],
                  [
                    60184.8,
                    28740.4
                  ],
                  [
                    60010,
                    28836.8
                  ],
                  [
                    59913,
                    28767.2
                  ],
                  [
                    59909,
                    28343.1
                  ],
                  [
                    60011.6,
                    28232.4
                  ]
                ],
                "id": 440,
                "chat_link": "[&BLgBAAA=]"
              },
              "441": {
                "name": "Soldier Mesa",
                "level": 56,
                "coord": [
                  60336.1,
                  27971.7
                ],
                "bounds": [
                  [
                    60342.5,
                    27696.9
                  ],
                  [
                    60462,
                    27843.7
                  ],
                  [
                    60730.2,
                    27835.2
                  ],
                  [
                    60827.7,
                    28010.1
                  ],
                  [
                    60762.2,
                    28202
                  ],
                  [
                    60009.8,
                    28235.3
                  ],
                  [
                    59853.3,
                    28177.5
                  ],
                  [
                    59917,
                    27885.5
                  ],
                  [
                    60120,
                    27858.8
                  ],
                  [
                    60342.5,
                    27696.9
                  ]
                ],
                "id": 441,
                "chat_link": "[&BLkBAAA=]"
              },
              "442": {
                "name": "Viper's Run",
                "level": 56,
                "coord": [
                  61057.5,
                  27950.7
                ],
                "bounds": [
                  [
                    60828.5,
                    28010
                  ],
                  [
                    60763.3,
                    28203.4
                  ],
                  [
                    60892.7,
                    28404.1
                  ],
                  [
                    60990,
                    28252
                  ],
                  [
                    61402.5,
                    28275.4
                  ],
                  [
                    61394.3,
                    28145.3
                  ],
                  [
                    61386.3,
                    27995.3
                  ],
                  [
                    61254.2,
                    27819.5
                  ],
                  [
                    61295,
                    27411.4
                  ],
                  [
                    60876.2,
                    27384.1
                  ],
                  [
                    60877.3,
                    27671.1
                  ],
                  [
                    60730.3,
                    27836.5
                  ],
                  [
                    60828.5,
                    28010
                  ]
                ],
                "id": 442,
                "chat_link": "[&BLoBAAA=]"
              },
              "443": {
                "name": "Lamprey Grottoes",
                "level": 56,
                "coord": [
                  61114.6,
                  28502.6
                ],
                "bounds": [
                  [
                    60990.4,
                    28252.6
                  ],
                  [
                    61401.3,
                    28274.3
                  ],
                  [
                    61445.5,
                    28409.8
                  ],
                  [
                    61254.6,
                    28584.5
                  ],
                  [
                    61146.7,
                    28580.1
                  ],
                  [
                    61006.6,
                    28765.4
                  ],
                  [
                    60955.8,
                    28710.1
                  ],
                  [
                    60939,
                    28542.5
                  ],
                  [
                    60891.7,
                    28403.9
                  ],
                  [
                    60990.4,
                    28252.6
                  ]
                ],
                "id": 443,
                "chat_link": "[&BLsBAAA=]"
              },
              "444": {
                "name": "Southshore Wastes",
                "level": 56,
                "coord": [
                  61648,
                  28463.3
                ],
                "bounds": [
                  [
                    61401.6,
                    28274
                  ],
                  [
                    61394.3,
                    28143.1
                  ],
                  [
                    61636.2,
                    28231.1
                  ],
                  [
                    61896.8,
                    28115.8
                  ],
                  [
                    62035.8,
                    28179.6
                  ],
                  [
                    62144.2,
                    28346.9
                  ],
                  [
                    61940.4,
                    28819.5
                  ],
                  [
                    61846.6,
                    28769.4
                  ],
                  [
                    61552.8,
                    28704.4
                  ],
                  [
                    61537.9,
                    28654.9
                  ],
                  [
                    61334.2,
                    28778.5
                  ],
                  [
                    61258.9,
                    28597.7
                  ],
                  [
                    61444,
                    28408
                  ],
                  [
                    61401.6,
                    28274
                  ]
                ],
                "id": 444,
                "chat_link": "[&BLwBAAA=]"
              },
              "445": {
                "name": "Lake Desolann",
                "level": 57,
                "coord": [
                  61677.4,
                  27859.6
                ],
                "bounds": [
                  [
                    61253.5,
                    27818.9
                  ],
                  [
                    61294.7,
                    27411
                  ],
                  [
                    61940.3,
                    27258.2
                  ],
                  [
                    61902.2,
                    27625.6
                  ],
                  [
                    62035.8,
                    27815.3
                  ],
                  [
                    62034.7,
                    28180
                  ],
                  [
                    61896.5,
                    28116.2
                  ],
                  [
                    61636.1,
                    28231.5
                  ],
                  [
                    61394.5,
                    28143.2
                  ],
                  [
                    61386,
                    27995.9
                  ],
                  [
                    61253.5,
                    27818.9
                  ]
                ],
                "id": 445,
                "chat_link": "[&BL0BAAA=]"
              },
              "446": {
                "name": "Crystalwept Groves",
                "level": 58,
                "coord": [
                  61545.3,
                  26843.5
                ],
                "bounds": [
                  [
                    61294.3,
                    27411.6
                  ],
                  [
                    61851.2,
                    27282.6
                  ],
                  [
                    61872.8,
                    26710.5
                  ],
                  [
                    61802,
                    26532
                  ],
                  [
                    61546.5,
                    26534.2
                  ],
                  [
                    61273.5,
                    26651.4
                  ],
                  [
                    61177.1,
                    26782
                  ],
                  [
                    61294.3,
                    27411.6
                  ]
                ],
                "id": 446,
                "chat_link": "[&BL4BAAA=]"
              },
              "447": {
                "name": "The Granite Front",
                "level": 58,
                "coord": [
                  61004.1,
                  27049.1
                ],
                "bounds": [
                  [
                    60876.1,
                    27385
                  ],
                  [
                    61295.3,
                    27411.9
                  ],
                  [
                    61177.9,
                    26781.8
                  ],
                  [
                    60932.1,
                    26584.9
                  ],
                  [
                    60739.2,
                    27082.1
                  ],
                  [
                    60876.1,
                    27385
                  ]
                ],
                "id": 447,
                "chat_link": "[&BL8BAAA=]"
              },
              "448": {
                "name": "Glory's Steps",
                "level": 57,
                "coord": [
                  60620.1,
                  27536.7
                ],
                "bounds": [
                  [
                    60308.2,
                    27433.8
                  ],
                  [
                    60624.5,
                    27348.8
                  ],
                  [
                    60739.3,
                    27080.1
                  ],
                  [
                    60876.6,
                    27384.6
                  ],
                  [
                    60877.8,
                    27671.5
                  ],
                  [
                    60730.3,
                    27835.7
                  ],
                  [
                    60462,
                    27843.3
                  ],
                  [
                    60342,
                    27696.3
                  ],
                  [
                    60308.2,
                    27433.8
                  ]
                ],
                "id": 448,
                "chat_link": "[&BMABAAA=]"
              },
              "449": {
                "name": "Western Bulwark",
                "level": 57,
                "coord": [
                  60014.2,
                  27381.5
                ],
                "bounds": [
                  [
                    60119.7,
                    27863.4
                  ],
                  [
                    60342.2,
                    27698
                  ],
                  [
                    60309.1,
                    27433.6
                  ],
                  [
                    59985.5,
                    27005.6
                  ],
                  [
                    59864.3,
                    26989.7
                  ],
                  [
                    59852.4,
                    27087
                  ],
                  [
                    59896,
                    27099.2
                  ],
                  [
                    59838.8,
                    27364.9
                  ],
                  [
                    59919.9,
                    27892.1
                  ],
                  [
                    60119.7,
                    27863.4
                  ]
                ],
                "id": 449,
                "chat_link": "[&BMEBAAA=]"
              },
              "450": {
                "name": "Lake Carnifex",
                "level": 58,
                "coord": [
                  60375.3,
                  27120.4
                ],
                "bounds": [
                  [
                    60624.4,
                    27348.9
                  ],
                  [
                    60308,
                    27433.5
                  ],
                  [
                    59985.2,
                    27004.8
                  ],
                  [
                    60065.8,
                    26901.1
                  ],
                  [
                    60260.5,
                    27113.3
                  ],
                  [
                    60474.8,
                    27109
                  ],
                  [
                    60543.6,
                    26971.8
                  ],
                  [
                    60740.1,
                    27080.7
                  ],
                  [
                    60624.4,
                    27348.9
                  ]
                ],
                "id": 450,
                "chat_link": "[&BMIBAAA=]"
              },
              "451": {
                "name": "Victium Moors",
                "level": 60,
                "coord": [
                  60173.8,
                  26726.5
                ],
                "bounds": [
                  [
                    59983.5,
                    27010.9
                  ],
                  [
                    59899.5,
                    26999.2
                  ],
                  [
                    59875,
                    26921
                  ],
                  [
                    59887.9,
                    26595
                  ],
                  [
                    59966.7,
                    26345.3
                  ],
                  [
                    60158.3,
                    26318.5
                  ],
                  [
                    60273.6,
                    26231.3
                  ],
                  [
                    60328.2,
                    26359.8
                  ],
                  [
                    60541.5,
                    26560.8
                  ],
                  [
                    60544,
                    26971.9
                  ],
                  [
                    60474.8,
                    27110
                  ],
                  [
                    60259.9,
                    27113.2
                  ],
                  [
                    60065.9,
                    26907.8
                  ],
                  [
                    59983.5,
                    27010.9
                  ]
                ],
                "id": 451,
                "chat_link": "[&BMMBAAA=]"
              },
              "452": {
                "name": "Scorchlands",
                "level": 60,
                "coord": [
                  60042.4,
                  25977.2
                ],
                "bounds": [
                  [
                    60171.5,
                    25625.1
                  ],
                  [
                    60283.7,
                    25687.9
                  ],
                  [
                    60333.1,
                    25796.2
                  ],
                  [
                    60273.9,
                    26235
                  ],
                  [
                    60158.3,
                    26319.1
                  ],
                  [
                    59966.3,
                    26344.6
                  ],
                  [
                    59897.8,
                    26229
                  ],
                  [
                    59797.4,
                    26127.7
                  ],
                  [
                    59775,
                    25897.4
                  ],
                  [
                    59876.6,
                    25791.2
                  ],
                  [
                    59932.9,
                    25696.3
                  ],
                  [
                    60171.5,
                    25625.1
                  ]
                ],
                "id": 452,
                "chat_link": "[&BMQBAAA=]"
              },
              "453": {
                "name": "Obsidian Run",
                "level": 59,
                "coord": [
                  61230.1,
                  26473.2
                ],
                "bounds": [
                  [
                    61176.9,
                    26781.6
                  ],
                  [
                    61273.7,
                    26651.1
                  ],
                  [
                    61546,
                    26535
                  ],
                  [
                    61526.2,
                    26278.5
                  ],
                  [
                    61290.3,
                    26324.3
                  ],
                  [
                    60865.4,
                    26157.2
                  ],
                  [
                    60932.6,
                    26584.8
                  ],
                  [
                    61176.9,
                    26781.6
                  ]
                ],
                "id": 453,
                "chat_link": "[&BMUBAAA=]"
              },
              "454": {
                "name": "The Infestation",
                "level": 59,
                "coord": [
                  61307.4,
                  26061.9
                ],
                "bounds": [
                  [
                    61726.4,
                    25954.6
                  ],
                  [
                    61663.6,
                    26216.9
                  ],
                  [
                    61525.3,
                    26279
                  ],
                  [
                    61289,
                    26324.7
                  ],
                  [
                    60863.7,
                    26156.3
                  ],
                  [
                    60851.5,
                    25979.2
                  ],
                  [
                    61007.2,
                    25889.4
                  ],
                  [
                    61267.5,
                    25860.3
                  ],
                  [
                    61572.7,
                    25896.6
                  ],
                  [
                    61726.4,
                    25954.6
                  ]
                ],
                "id": 454,
                "chat_link": "[&BMYBAAA=]"
              },
              "455": {
                "name": "Harvester's Glade",
                "level": 51,
                "coord": [
                  61129.8,
                  28853.7
                ],
                "bounds": [
                  [
                    61148.9,
                    28583.6
                  ],
                  [
                    61253.1,
                    28590.6
                  ],
                  [
                    61366.7,
                    28876.3
                  ],
                  [
                    61281.8,
                    28992.6
                  ],
                  [
                    61099.7,
                    29075.5
                  ],
                  [
                    60962.6,
                    29005.3
                  ],
                  [
                    60915.4,
                    28939.3
                  ],
                  [
                    61010.3,
                    28766.8
                  ],
                  [
                    61148.9,
                    28583.6
                  ]
                ],
                "id": 455,
                "chat_link": "[&BMcBAAA=]"
              },
              "456": {
                "name": "Echoslab Arches",
                "level": 53,
                "coord": [
                  60135,
                  29755.7
                ],
                "bounds": [
                  [
                    60345,
                    29856.3
                  ],
                  [
                    60332.8,
                    29597.4
                  ],
                  [
                    60142.5,
                    29464.5
                  ],
                  [
                    59952.3,
                    29518
                  ],
                  [
                    59868.9,
                    29711.8
                  ],
                  [
                    59919.6,
                    29932.4
                  ],
                  [
                    60173.9,
                    29989.8
                  ],
                  [
                    60345.5,
                    29975.1
                  ],
                  [
                    60345,
                    29856.3
                  ]
                ],
                "id": 456,
                "chat_link": "[&BMgBAAA=]"
              },
              "457": {
                "name": "Ebbing Heart Run",
                "level": 59,
                "coord": [
                  61761.6,
                  26193.5
                ],
                "bounds": [
                  [
                    61546.5,
                    26534.7
                  ],
                  [
                    61802.1,
                    26532.2
                  ],
                  [
                    61883,
                    26305.9
                  ],
                  [
                    61936.2,
                    26173.6
                  ],
                  [
                    61928.4,
                    25975
                  ],
                  [
                    61832,
                    25844.7
                  ],
                  [
                    61737.3,
                    25877.4
                  ],
                  [
                    61664.5,
                    26218.3
                  ],
                  [
                    61524.7,
                    26279.5
                  ],
                  [
                    61546.5,
                    26534.7
                  ]
                ],
                "id": 457,
                "chat_link": "[&BMkBAAA=]"
              },
              "458": {
                "name": "Gladefall Run",
                "level": 60,
                "coord": [
                  60602,
                  26324.4
                ],
                "bounds": [
                  [
                    60273.1,
                    26233.3
                  ],
                  [
                    60327.8,
                    26363.8
                  ],
                  [
                    60541.3,
                    26560.7
                  ],
                  [
                    60542.8,
                    26972
                  ],
                  [
                    60739.8,
                    27082.3
                  ],
                  [
                    60933.3,
                    26585.3
                  ],
                  [
                    60865,
                    26157.5
                  ],
                  [
                    60851.2,
                    25958.5
                  ],
                  [
                    60721.5,
                    25905.5
                  ],
                  [
                    60492.7,
                    25896.5
                  ],
                  [
                    60333.3,
                    25852.8
                  ],
                  [
                    60273.1,
                    26233.3
                  ]
                ],
                "id": 458,
                "chat_link": "[&BMoBAAA=]"
              }
            },
            "id": 1138,
            "mastery_points": [],
            "adventures": []
          },
          "1142": {
            "name": "Blightwater Shatterstrike",
            "min_level": 40,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              62998,
              30464
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                61952,
                28544
              ],
              [
                64000,
                32640
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "484": {
                "name": "Tawny Ridge",
                "level": 49,
                "coord": [
                  63787.3,
                  29317.5
                ],
                "bounds": [
                  [
                    63834.3,
                    29385.9
                  ],
                  [
                    63878.9,
                    29286.7
                  ],
                  [
                    63836.8,
                    29212
                  ],
                  [
                    63745.4,
                    29237.2
                  ],
                  [
                    63699,
                    29364
                  ],
                  [
                    63729.6,
                    29419
                  ],
                  [
                    63834.3,
                    29385.9
                  ]
                ],
                "id": 484,
                "chat_link": "[&BOQBAAA=]"
              },
              "485": {
                "name": "Steeleye Span",
                "level": 43,
                "coord": [
                  62529.3,
                  31630.3
                ],
                "bounds": [
                  [
                    62334,
                    31493.3
                  ],
                  [
                    62569.1,
                    31511.8
                  ],
                  [
                    62764.5,
                    31653.4
                  ],
                  [
                    62647.5,
                    31807
                  ],
                  [
                    62331.5,
                    31685.8
                  ],
                  [
                    62334,
                    31493.3
                  ]
                ],
                "id": 485,
                "chat_link": "[&BOUBAAA=]"
              },
              "486": {
                "name": "Deserter Flats",
                "level": 45,
                "coord": [
                  62613.5,
                  30722.1
                ],
                "bounds": [
                  [
                    62439.6,
                    30695.3
                  ],
                  [
                    62452.9,
                    30472.3
                  ],
                  [
                    62598.7,
                    30334.8
                  ],
                  [
                    62811.9,
                    30457.6
                  ],
                  [
                    62958.3,
                    30707.9
                  ],
                  [
                    62839.8,
                    30912.9
                  ],
                  [
                    62726.3,
                    30877.3
                  ],
                  [
                    62641.9,
                    30973.8
                  ],
                  [
                    62351.8,
                    31035.3
                  ],
                  [
                    62313.7,
                    30754.1
                  ],
                  [
                    62439.6,
                    30695.3
                  ]
                ],
                "id": 486,
                "chat_link": "[&BOYBAAA=]"
              },
              "487": {
                "name": "Hazmagic Aggregate",
                "level": 48,
                "coord": [
                  62738.3,
                  30060.6
                ],
                "bounds": [
                  [
                    62811.3,
                    30462.7
                  ],
                  [
                    62929.5,
                    30273.1
                  ],
                  [
                    62928.1,
                    30070
                  ],
                  [
                    62816,
                    29773.8
                  ],
                  [
                    62843.9,
                    29606.6
                  ],
                  [
                    62492,
                    29699.6
                  ],
                  [
                    62573.5,
                    30053.8
                  ],
                  [
                    62658.6,
                    30065.7
                  ],
                  [
                    62730.9,
                    30263
                  ],
                  [
                    62598.8,
                    30337.7
                  ],
                  [
                    62811.3,
                    30462.7
                  ]
                ],
                "id": 487,
                "chat_link": "[&BOcBAAA=]"
              },
              "488": {
                "name": "Foulblain Expanse",
                "level": 43,
                "coord": [
                  62557.5,
                  31301.7
                ],
                "bounds": [
                  [
                    62337.1,
                    31156.7
                  ],
                  [
                    62350.8,
                    31028.3
                  ],
                  [
                    62645.7,
                    30961.6
                  ],
                  [
                    62603.2,
                    31125.8
                  ],
                  [
                    62658.3,
                    31339.5
                  ],
                  [
                    62753.8,
                    31420.5
                  ],
                  [
                    62762.4,
                    31655.3
                  ],
                  [
                    62568.6,
                    31523.9
                  ],
                  [
                    62337.9,
                    31504.2
                  ],
                  [
                    62337.1,
                    31156.7
                  ]
                ],
                "id": 488,
                "chat_link": "[&BOgBAAA=]"
              },
              "489": {
                "name": "Lowland Burns",
                "level": 50,
                "coord": [
                  62333.4,
                  28730.6
                ],
                "bounds": [
                  [
                    62331.1,
                    28939.1
                  ],
                  [
                    62257.1,
                    28819.7
                  ],
                  [
                    62090.8,
                    28826.8
                  ],
                  [
                    61794.4,
                    28687.8
                  ],
                  [
                    61938.5,
                    28177.5
                  ],
                  [
                    62027.6,
                    28190.3
                  ],
                  [
                    62106.3,
                    28274.4
                  ],
                  [
                    62222.5,
                    28337.8
                  ],
                  [
                    62320,
                    28413.6
                  ],
                  [
                    62385.2,
                    28509.2
                  ],
                  [
                    62435.3,
                    28600.1
                  ],
                  [
                    62517.2,
                    28640.4
                  ],
                  [
                    62670,
                    29018.7
                  ],
                  [
                    62922.2,
                    29225.1
                  ],
                  [
                    62890,
                    29333.1
                  ],
                  [
                    62446,
                    29308.9
                  ],
                  [
                    62313.5,
                    29117.5
                  ],
                  [
                    62331.1,
                    28939.1
                  ]
                ],
                "id": 489,
                "chat_link": "[&BOkBAAA=]"
              },
              "490": {
                "name": "Blightwater Basin",
                "level": 42,
                "coord": [
                  62087.1,
                  32282.7
                ],
                "bounds": [
                  [
                    62475.8,
                    32616.7
                  ],
                  [
                    62449.6,
                    32150.3
                  ],
                  [
                    62646.2,
                    31808.5
                  ],
                  [
                    62331.8,
                    31685.8
                  ],
                  [
                    62326.8,
                    31780.5
                  ],
                  [
                    61973.7,
                    31941.7
                  ],
                  [
                    61509.8,
                    32070.4
                  ],
                  [
                    61678.1,
                    32224.7
                  ],
                  [
                    61761.7,
                    32366.7
                  ],
                  [
                    61787.2,
                    32521.6
                  ],
                  [
                    61870.1,
                    32635.4
                  ],
                  [
                    62002.2,
                    32677.4
                  ],
                  [
                    62097.8,
                    32730.4
                  ],
                  [
                    62308.7,
                    32747.6
                  ],
                  [
                    62475.8,
                    32616.7
                  ]
                ],
                "id": 490,
                "chat_link": "[&BOoBAAA=]"
              },
              "491": {
                "name": "Tumok's Last Stand",
                "level": 42,
                "coord": [
                  62708.1,
                  32441.5
                ],
                "bounds": [
                  [
                    62475.4,
                    32613.9
                  ],
                  [
                    62574.8,
                    32661.6
                  ],
                  [
                    62807.9,
                    32713.7
                  ],
                  [
                    62940,
                    32662.1
                  ],
                  [
                    62957.1,
                    32598.9
                  ],
                  [
                    63050.1,
                    32235.4
                  ],
                  [
                    62644.3,
                    31809.7
                  ],
                  [
                    62452.7,
                    32155.4
                  ],
                  [
                    62470.8,
                    32522.3
                  ],
                  [
                    62475.4,
                    32613.9
                  ]
                ],
                "id": 491,
                "chat_link": "[&BOsBAAA=]"
              },
              "492": {
                "name": "Pockmark Roughs",
                "level": 45,
                "coord": [
                  63227.9,
                  31010.7
                ],
                "bounds": [
                  [
                    62841,
                    30913.6
                  ],
                  [
                    62955.5,
                    30712.2
                  ],
                  [
                    63229.3,
                    30638.3
                  ],
                  [
                    63447.8,
                    30736.4
                  ],
                  [
                    63538.4,
                    30885.5
                  ],
                  [
                    63527.2,
                    31093
                  ],
                  [
                    63443.4,
                    31236.1
                  ],
                  [
                    63307.8,
                    31352.4
                  ],
                  [
                    63109.2,
                    31370.7
                  ],
                  [
                    62879.8,
                    31168.8
                  ],
                  [
                    62841,
                    30913.6
                  ]
                ],
                "id": 492,
                "chat_link": "[&BOwBAAA=]"
              },
              "493": {
                "name": "Crater Rim",
                "level": 42,
                "coord": [
                  62868.6,
                  31245.7
                ],
                "bounds": [
                  [
                    62751.9,
                    31427.3
                  ],
                  [
                    62658.5,
                    31342.8
                  ],
                  [
                    62601,
                    31130.2
                  ],
                  [
                    62636.8,
                    30977.7
                  ],
                  [
                    62730.2,
                    30877.8
                  ],
                  [
                    62840.6,
                    30911.7
                  ],
                  [
                    62877.2,
                    31164.1
                  ],
                  [
                    63108.9,
                    31367.5
                  ],
                  [
                    63307.8,
                    31349.7
                  ],
                  [
                    63280.4,
                    31498.4
                  ],
                  [
                    62760.8,
                    31655
                  ],
                  [
                    62751.9,
                    31427.3
                  ]
                ],
                "id": 493,
                "chat_link": "[&BO0BAAA=]"
              },
              "494": {
                "name": "Behem Gauntlet",
                "level": 42,
                "coord": [
                  63694.3,
                  31526.8
                ],
                "bounds": [
                  [
                    63271.2,
                    31726
                  ],
                  [
                    63385.2,
                    31922
                  ],
                  [
                    63651.7,
                    31679.6
                  ],
                  [
                    63924.3,
                    31814.5
                  ],
                  [
                    64038.7,
                    31803.6
                  ],
                  [
                    64094,
                    31571.6
                  ],
                  [
                    64085.1,
                    31319.6
                  ],
                  [
                    63942.8,
                    31304.5
                  ],
                  [
                    63873.8,
                    31387.6
                  ],
                  [
                    63782,
                    31414.4
                  ],
                  [
                    63740.9,
                    31473.9
                  ],
                  [
                    63595.5,
                    31417.7
                  ],
                  [
                    63441.6,
                    31227.4
                  ],
                  [
                    63311.4,
                    31343.3
                  ],
                  [
                    63276.7,
                    31496.2
                  ],
                  [
                    63271.2,
                    31726
                  ]
                ],
                "id": 494,
                "chat_link": "[&BO4BAAA=]"
              },
              "495": {
                "name": "Unbroken Expanse",
                "level": 45,
                "coord": [
                  63211.9,
                  30390.3
                ],
                "bounds": [
                  [
                    63228.8,
                    30645.9
                  ],
                  [
                    63447.9,
                    30738.9
                  ],
                  [
                    63594.9,
                    30605.9
                  ],
                  [
                    63546,
                    30298.3
                  ],
                  [
                    63595.9,
                    30138.5
                  ],
                  [
                    63083,
                    29956.2
                  ],
                  [
                    62925.8,
                    30070.6
                  ],
                  [
                    62926.9,
                    30273.4
                  ],
                  [
                    62810.4,
                    30458.3
                  ],
                  [
                    62959.4,
                    30717.1
                  ],
                  [
                    63228.8,
                    30645.9
                  ]
                ],
                "id": 495,
                "chat_link": "[&BO8BAAA=]"
              },
              "496": {
                "name": "Gastor Gullet",
                "level": 45,
                "coord": [
                  63716,
                  31092.8
                ],
                "bounds": [
                  [
                    63527.8,
                    31091.7
                  ],
                  [
                    63538.8,
                    30886.2
                  ],
                  [
                    63447.1,
                    30737.8
                  ],
                  [
                    63593.5,
                    30606.3
                  ],
                  [
                    63767.3,
                    30670.9
                  ],
                  [
                    63870.3,
                    30901.8
                  ],
                  [
                    63918.4,
                    31019.5
                  ],
                  [
                    63979.9,
                    31145
                  ],
                  [
                    63944.9,
                    31306.2
                  ],
                  [
                    63875,
                    31387.9
                  ],
                  [
                    63782.4,
                    31416.7
                  ],
                  [
                    63740.2,
                    31476.7
                  ],
                  [
                    63594,
                    31418.9
                  ],
                  [
                    63445,
                    31233.4
                  ],
                  [
                    63527.8,
                    31091.7
                  ]
                ],
                "id": 496,
                "chat_link": "[&BPABAAA=]"
              },
              "497": {
                "name": "Degun Shun",
                "level": 45,
                "coord": [
                  63692.8,
                  30247.4
                ],
                "bounds": [
                  [
                    63695,
                    30391.3
                  ],
                  [
                    63851.2,
                    30298.3
                  ],
                  [
                    63781.1,
                    30177
                  ],
                  [
                    63698.5,
                    30183.2
                  ],
                  [
                    63586.8,
                    30135.9
                  ],
                  [
                    63544.1,
                    30298.9
                  ],
                  [
                    63695,
                    30391.3
                  ]
                ],
                "id": 497,
                "chat_link": "[&BPEBAAA=]"
              },
              "498": {
                "name": "Agrak Kraal",
                "level": 45,
                "coord": [
                  63888,
                  30702.1
                ],
                "bounds": [
                  [
                    63855.5,
                    30566.8
                  ],
                  [
                    63937.4,
                    30576.7
                  ],
                  [
                    63946.3,
                    30708
                  ],
                  [
                    63970,
                    30827.9
                  ],
                  [
                    63847.8,
                    30864
                  ],
                  [
                    63771.2,
                    30669.4
                  ],
                  [
                    63855.5,
                    30566.8
                  ]
                ],
                "id": 498,
                "chat_link": "[&BPIBAAA=]"
              },
              "499": {
                "name": "Twin Sisters Crossing",
                "level": 42,
                "coord": [
                  63862.8,
                  32402.3
                ],
                "bounds": [
                  [
                    63927,
                    32682.5
                  ],
                  [
                    63797.7,
                    32729.8
                  ],
                  [
                    63678.9,
                    32732
                  ],
                  [
                    63567.1,
                    32672.7
                  ],
                  [
                    63547.2,
                    32581.1
                  ],
                  [
                    63612.6,
                    32474.9
                  ],
                  [
                    63559.8,
                    32276.8
                  ],
                  [
                    63645.6,
                    32136.1
                  ],
                  [
                    63901.9,
                    31992.3
                  ],
                  [
                    63945,
                    32022
                  ],
                  [
                    63957.7,
                    32129.7
                  ],
                  [
                    64026.3,
                    32249.1
                  ],
                  [
                    64121.1,
                    32326.2
                  ],
                  [
                    64202.4,
                    32366.9
                  ],
                  [
                    64241,
                    32436.5
                  ],
                  [
                    64074.1,
                    32628.4
                  ],
                  [
                    63927,
                    32682.5
                  ]
                ],
                "id": 499,
                "chat_link": "[&BPMBAAA=]"
              },
              "500": {
                "name": "Splinter Hills",
                "level": 42,
                "coord": [
                  63436.8,
                  32369.6
                ],
                "bounds": [
                  [
                    63036.6,
                    32228.9
                  ],
                  [
                    63648.4,
                    31681.5
                  ],
                  [
                    63923.3,
                    31813.4
                  ],
                  [
                    63906.8,
                    31993.9
                  ],
                  [
                    63645.5,
                    32137.2
                  ],
                  [
                    63559.9,
                    32277.8
                  ],
                  [
                    63612.5,
                    32475.6
                  ],
                  [
                    63548.9,
                    32581.5
                  ],
                  [
                    63569.1,
                    32673.9
                  ],
                  [
                    63427,
                    32726.4
                  ],
                  [
                    63250.9,
                    32645.8
                  ],
                  [
                    63095.1,
                    32692.7
                  ],
                  [
                    62937.4,
                    32653.1
                  ],
                  [
                    62953.7,
                    32592.1
                  ],
                  [
                    63036.6,
                    32228.9
                  ]
                ],
                "id": 500,
                "chat_link": "[&BPQBAAA=]"
              },
              "501": {
                "name": "Soot Road",
                "level": 42,
                "coord": [
                  63065.7,
                  31805.3
                ],
                "bounds": [
                  [
                    62763.1,
                    31650.1
                  ],
                  [
                    63278.9,
                    31499.1
                  ],
                  [
                    63273,
                    31723.4
                  ],
                  [
                    63386.3,
                    31922.3
                  ],
                  [
                    63044.8,
                    32226.1
                  ],
                  [
                    62647.9,
                    31810.5
                  ],
                  [
                    62763.1,
                    31650.1
                  ]
                ],
                "id": 501,
                "chat_link": "[&BPUBAAA=]"
              },
              "502": {
                "name": "Tongue Rock",
                "level": 45,
                "coord": [
                  62007.1,
                  30517.7
                ],
                "bounds": [
                  [
                    62232.6,
                    30493.1
                  ],
                  [
                    62156,
                    30619.2
                  ],
                  [
                    61988.4,
                    30604.4
                  ],
                  [
                    61818.8,
                    30755.6
                  ],
                  [
                    61834,
                    30623.4
                  ],
                  [
                    61898.2,
                    30479.3
                  ],
                  [
                    61876.1,
                    30403.2
                  ],
                  [
                    62014.4,
                    30456.3
                  ],
                  [
                    62099.9,
                    30361.9
                  ],
                  [
                    62152.6,
                    30381
                  ],
                  [
                    62232.6,
                    30493.1
                  ]
                ],
                "id": 502,
                "chat_link": "[&BPYBAAA=]"
              },
              "503": {
                "name": "Terra Combusta",
                "level": 49,
                "coord": [
                  62967.3,
                  28959.5
                ],
                "bounds": [
                  [
                    62914.2,
                    29238.7
                  ],
                  [
                    62669.5,
                    29019
                  ],
                  [
                    62515.1,
                    28641.8
                  ],
                  [
                    62776.6,
                    28568.7
                  ],
                  [
                    63054.8,
                    28653
                  ],
                  [
                    63103.2,
                    28738.1
                  ],
                  [
                    63387,
                    28803.3
                  ],
                  [
                    63161.3,
                    29217.8
                  ],
                  [
                    63199,
                    29380.4
                  ],
                  [
                    62891.9,
                    29334.6
                  ],
                  [
                    62914.2,
                    29238.7
                  ]
                ],
                "id": 503,
                "chat_link": "[&BPcBAAA=]"
              },
              "504": {
                "name": "Terra Carorunda",
                "level": 49,
                "coord": [
                  63646.7,
                  29033.7
                ],
                "bounds": [
                  [
                    63201.7,
                    29381.4
                  ],
                  [
                    63409.6,
                    29507.8
                  ],
                  [
                    63750.9,
                    29457.3
                  ],
                  [
                    63700,
                    29362.1
                  ],
                  [
                    63748.1,
                    29237
                  ],
                  [
                    63838.9,
                    29214.4
                  ],
                  [
                    63881,
                    29161.8
                  ],
                  [
                    63872.6,
                    28991.6
                  ],
                  [
                    63962.4,
                    28839.9
                  ],
                  [
                    63943.6,
                    28602.4
                  ],
                  [
                    63754.8,
                    28591
                  ],
                  [
                    63640.6,
                    28555.1
                  ],
                  [
                    63447.2,
                    28584
                  ],
                  [
                    63389.2,
                    28801
                  ],
                  [
                    63160.3,
                    29218.5
                  ],
                  [
                    63201.7,
                    29381.4
                  ]
                ],
                "id": 504,
                "chat_link": "[&BPgBAAA=]"
              },
              "505": {
                "name": "Shattered Palisades",
                "level": 49,
                "coord": [
                  63287.8,
                  29508.3
                ],
                "bounds": [
                  [
                    63449.3,
                    29664.6
                  ],
                  [
                    63735.3,
                    29560.1
                  ],
                  [
                    63750.7,
                    29455.5
                  ],
                  [
                    63408.7,
                    29506
                  ],
                  [
                    63200.8,
                    29377.6
                  ],
                  [
                    62817.8,
                    29319.5
                  ],
                  [
                    62844.4,
                    29604.2
                  ],
                  [
                    63095.2,
                    29579.1
                  ],
                  [
                    63449.3,
                    29664.6
                  ]
                ],
                "id": 505,
                "chat_link": "[&BPkBAAA=]"
              },
              "506": {
                "name": "Monument Grounds",
                "level": 50,
                "coord": [
                  62337.5,
                  29448.3
                ],
                "bounds": [
                  [
                    62494,
                    29697.9
                  ],
                  [
                    62842.3,
                    29604.2
                  ],
                  [
                    62815.3,
                    29323.4
                  ],
                  [
                    62445,
                    29310.7
                  ],
                  [
                    62394.7,
                    29405.1
                  ],
                  [
                    62030.1,
                    29409.7
                  ],
                  [
                    61826.2,
                    29318.8
                  ],
                  [
                    61852.4,
                    29516.2
                  ],
                  [
                    62494,
                    29697.9
                  ]
                ],
                "id": 506,
                "chat_link": "[&BPoBAAA=]"
              },
              "507": {
                "name": "Heretic Plain",
                "level": 47,
                "coord": [
                  63435.8,
                  29829
                ],
                "bounds": [
                  [
                    62818.3,
                    29770.1
                  ],
                  [
                    62841.7,
                    29605.5
                  ],
                  [
                    63095.3,
                    29579.2
                  ],
                  [
                    63445.5,
                    29663.5
                  ],
                  [
                    63733,
                    29560.5
                  ],
                  [
                    63873.3,
                    29555.4
                  ],
                  [
                    63930,
                    29805.3
                  ],
                  [
                    63930.2,
                    30021.5
                  ],
                  [
                    63856.9,
                    30170.4
                  ],
                  [
                    63696.5,
                    30184.3
                  ],
                  [
                    63082.1,
                    29961.7
                  ],
                  [
                    62926.8,
                    30071.2
                  ],
                  [
                    62818.3,
                    29770.1
                  ]
                ],
                "id": 507,
                "chat_link": "[&BPsBAAA=]"
              },
              "508": {
                "name": "Kindling Bridge",
                "level": 50,
                "coord": [
                  62106.6,
                  29094
                ],
                "bounds": [
                  [
                    61831.5,
                    29315.7
                  ],
                  [
                    61875,
                    29191.1
                  ],
                  [
                    61781.9,
                    29002.1
                  ],
                  [
                    61799.7,
                    28689.3
                  ],
                  [
                    62091.7,
                    28823.8
                  ],
                  [
                    62261.8,
                    28824.8
                  ],
                  [
                    62335.3,
                    28942.4
                  ],
                  [
                    62313.2,
                    29121.6
                  ],
                  [
                    62450.6,
                    29310
                  ],
                  [
                    62398.5,
                    29405.6
                  ],
                  [
                    62033.3,
                    29407.7
                  ],
                  [
                    61831.5,
                    29315.7
                  ]
                ],
                "id": 508,
                "chat_link": "[&BPwBAAA=]"
              },
              "509": {
                "name": "Dragonwatch",
                "level": 43,
                "coord": [
                  62071,
                  31427.8
                ],
                "bounds": [
                  [
                    62326.5,
                    31774.7
                  ],
                  [
                    62338.5,
                    31506.3
                  ],
                  [
                    62339,
                    31156.7
                  ],
                  [
                    62107.7,
                    31209.2
                  ],
                  [
                    61953.1,
                    31186
                  ],
                  [
                    61952,
                    31215.8
                  ],
                  [
                    61944.9,
                    31281.9
                  ],
                  [
                    61954.3,
                    31359.3
                  ],
                  [
                    61819.8,
                    31647.2
                  ],
                  [
                    61974.8,
                    31940.8
                  ],
                  [
                    62326.5,
                    31774.7
                  ]
                ],
                "id": 509,
                "chat_link": "[&BP0BAAA=]"
              },
              "510": {
                "name": "Ratcatcher Knoll",
                "level": 45,
                "coord": [
                  62202.2,
                  30748
                ],
                "bounds": [
                  [
                    62107.6,
                    31211
                  ],
                  [
                    61958.7,
                    31186.4
                  ],
                  [
                    61818.8,
                    30757.4
                  ],
                  [
                    61993.7,
                    30604.6
                  ],
                  [
                    62153.8,
                    30620.1
                  ],
                  [
                    62231.2,
                    30491.7
                  ],
                  [
                    62150.8,
                    30381.6
                  ],
                  [
                    62310.9,
                    30344.7
                  ],
                  [
                    62456.3,
                    30474.6
                  ],
                  [
                    62442.6,
                    30698.2
                  ],
                  [
                    62314.6,
                    30758.1
                  ],
                  [
                    62354.1,
                    31035.8
                  ],
                  [
                    62334.9,
                    31159.4
                  ],
                  [
                    62107.6,
                    31211
                  ]
                ],
                "id": 510,
                "chat_link": "[&BP4BAAA=]"
              },
              "511": {
                "name": "Relliatus Canyon",
                "level": 47,
                "coord": [
                  62217.2,
                  30139.4
                ],
                "bounds": [
                  [
                    62010,
                    30457.9
                  ],
                  [
                    62100.9,
                    30361.2
                  ],
                  [
                    62151.1,
                    30381
                  ],
                  [
                    62311,
                    30347.8
                  ],
                  [
                    62455,
                    30476.1
                  ],
                  [
                    62600.2,
                    30334.8
                  ],
                  [
                    62464.6,
                    30156.9
                  ],
                  [
                    62476.8,
                    30058.2
                  ],
                  [
                    62573.8,
                    30052.6
                  ],
                  [
                    62494.1,
                    29698.1
                  ],
                  [
                    61853.7,
                    29509.6
                  ],
                  [
                    61831.6,
                    29761.8
                  ],
                  [
                    61837.2,
                    29956.5
                  ],
                  [
                    61880.5,
                    30399.3
                  ],
                  [
                    62010,
                    30457.9
                  ]
                ],
                "id": 511,
                "chat_link": "[&BP8BAAA=]"
              },
              "758": {
                "name": "InGenium Research Facility",
                "level": 48,
                "coord": [
                  62584.6,
                  30155.2
                ],
                "bounds": [
                  [
                    62463.8,
                    30156.9
                  ],
                  [
                    62476.9,
                    30056.9
                  ],
                  [
                    62577.4,
                    30050.8
                  ],
                  [
                    62660.6,
                    30065.2
                  ],
                  [
                    62729.8,
                    30264
                  ],
                  [
                    62599.3,
                    30337.5
                  ],
                  [
                    62463.8,
                    30156.9
                  ]
                ],
                "id": 758,
                "chat_link": "[&BPYCAAA=]"
              }
            },
            "id": 1142,
            "mastery_points": [],
            "adventures": []
          },
          "1146": {
            "name": "Branded for Termination",
            "min_level": 30,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              62976,
              34176
            ],
            "map_rect": [
              [
                -36864,
                -36864
              ],
              [
                36864,
                36864
              ]
            ],
            "continent_rect": [
              [
                61440,
                32640
              ],
              [
                64512,
                35712
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "365": {
                "name": "Last Stand Shelter",
                "level": 31,
                "coord": [
                  61657.9,
                  35015.4
                ],
                "bounds": [
                  [
                    61456.9,
                    34889.1
                  ],
                  [
                    61607.9,
                    34741.1
                  ],
                  [
                    61812.8,
                    34931.5
                  ],
                  [
                    61785.2,
                    35009.7
                  ],
                  [
                    61709.3,
                    35063.5
                  ],
                  [
                    61698.5,
                    35205.7
                  ],
                  [
                    61534.8,
                    35267.4
                  ],
                  [
                    61456.9,
                    34889.1
                  ]
                ],
                "id": 365,
                "chat_link": "[&BG0BAAA=]"
              },
              "366": {
                "name": "Blackwing Excavation",
                "level": 31,
                "coord": [
                  62641.1,
                  35403.7
                ],
                "bounds": [
                  [
                    62557.5,
                    35091.2
                  ],
                  [
                    62771.9,
                    35156.6
                  ],
                  [
                    62878.7,
                    35543.5
                  ],
                  [
                    62746.7,
                    35649.8
                  ],
                  [
                    62451.9,
                    35654.8
                  ],
                  [
                    62440,
                    35326.3
                  ],
                  [
                    62557.5,
                    35091.2
                  ]
                ],
                "id": 366,
                "chat_link": "[&BG4BAAA=]"
              },
              "367": {
                "name": "Stronghold of Ebonhawke",
                "level": 31,
                "coord": [
                  62008.8,
                  35138
                ],
                "bounds": [
                  [
                    61812.5,
                    34931.7
                  ],
                  [
                    61608.6,
                    34739.7
                  ],
                  [
                    61974.8,
                    34550.6
                  ],
                  [
                    62116.3,
                    34621.3
                  ],
                  [
                    62342,
                    34818.7
                  ],
                  [
                    62699,
                    34688.4
                  ],
                  [
                    62557.7,
                    35091.4
                  ],
                  [
                    62440.8,
                    35324.7
                  ],
                  [
                    62450.3,
                    35654.7
                  ],
                  [
                    62165.5,
                    35625.2
                  ],
                  [
                    61939.4,
                    35533.8
                  ],
                  [
                    61770.3,
                    35659.5
                  ],
                  [
                    61542.8,
                    35558.4
                  ],
                  [
                    61534.8,
                    35269.1
                  ],
                  [
                    61699,
                    35206.4
                  ],
                  [
                    61709.8,
                    35064.6
                  ],
                  [
                    61785.5,
                    35008.6
                  ],
                  [
                    61812.5,
                    34931.7
                  ]
                ],
                "id": 367,
                "chat_link": "[&BG8BAAA=]"
              },
              "368": {
                "name": "Grimm Hills",
                "level": 34,
                "coord": [
                  62913.6,
                  34678.1
                ],
                "bounds": [
                  [
                    62775,
                    35155.6
                  ],
                  [
                    63095.2,
                    34880.6
                  ],
                  [
                    63095,
                    34671.8
                  ],
                  [
                    63212.3,
                    34293.8
                  ],
                  [
                    63014.9,
                    34325.3
                  ],
                  [
                    62889.8,
                    34422.3
                  ],
                  [
                    62883.8,
                    34575
                  ],
                  [
                    62698.5,
                    34687.4
                  ],
                  [
                    62558.2,
                    35091.2
                  ],
                  [
                    62775,
                    35155.6
                  ]
                ],
                "id": 368,
                "chat_link": "[&BHABAAA=]"
              },
              "369": {
                "name": "The Ogre Road",
                "level": 33,
                "coord": [
                  63775.2,
                  34960.3
                ],
                "bounds": [
                  [
                    63818,
                    34775.5
                  ],
                  [
                    64049.9,
                    34874.6
                  ],
                  [
                    63983.2,
                    35117.8
                  ],
                  [
                    63650.4,
                    35343.8
                  ],
                  [
                    63469.1,
                    34973.7
                  ],
                  [
                    63680.8,
                    34676.6
                  ],
                  [
                    63818,
                    34775.5
                  ]
                ],
                "id": 369,
                "chat_link": "[&BHEBAAA=]"
              },
              "370": {
                "name": "Wildlin Narrows",
                "level": 34,
                "coord": [
                  64113.6,
                  35332.1
                ],
                "bounds": [
                  [
                    63981.4,
                    35119
                  ],
                  [
                    64047.3,
                    34879.9
                  ],
                  [
                    64446.4,
                    34880.2
                  ],
                  [
                    64454.7,
                    35016.9
                  ],
                  [
                    64482.5,
                    35162.6
                  ],
                  [
                    64437,
                    35419.7
                  ],
                  [
                    64379.4,
                    35572.2
                  ],
                  [
                    64266.7,
                    35658.7
                  ],
                  [
                    63887.2,
                    35684.1
                  ],
                  [
                    63726.7,
                    35630.3
                  ],
                  [
                    63602.3,
                    35623
                  ],
                  [
                    63651.7,
                    35338
                  ],
                  [
                    63981.4,
                    35119
                  ]
                ],
                "id": 370,
                "chat_link": "[&BHIBAAA=]"
              },
              "371": {
                "name": "Mithric Cliffs",
                "level": 35,
                "coord": [
                  64140.7,
                  34560.1
                ],
                "bounds": [
                  [
                    63873.1,
                    34199.8
                  ],
                  [
                    64439.5,
                    34200.8
                  ],
                  [
                    64522.9,
                    34271.7
                  ],
                  [
                    64421.7,
                    34550.9
                  ],
                  [
                    64486.2,
                    34796.1
                  ],
                  [
                    64446.4,
                    34880
                  ],
                  [
                    64049.8,
                    34881.8
                  ],
                  [
                    63817.7,
                    34776.3
                  ],
                  [
                    63679.6,
                    34676
                  ],
                  [
                    63670,
                    34367.5
                  ],
                  [
                    63873.1,
                    34199.8
                  ]
                ],
                "id": 371,
                "chat_link": "[&BHMBAAA=]"
              },
              "372": {
                "name": "Hunter's Gorge",
                "level": 35,
                "coord": [
                  63341.8,
                  34640.5
                ],
                "bounds": [
                  [
                    63669.7,
                    34367.2
                  ],
                  [
                    63679.1,
                    34676
                  ],
                  [
                    63470.3,
                    34973.3
                  ],
                  [
                    63163.9,
                    34985.8
                  ],
                  [
                    63094,
                    34882.4
                  ],
                  [
                    63095.7,
                    34672.5
                  ],
                  [
                    63212.8,
                    34294.4
                  ],
                  [
                    63348.8,
                    34272.4
                  ],
                  [
                    63669.7,
                    34367.2
                  ]
                ],
                "id": 372,
                "chat_link": "[&BHQBAAA=]"
              },
              "373": {
                "name": "The Siege Plains",
                "level": 33,
                "coord": [
                  62661.4,
                  34431.1
                ],
                "bounds": [
                  [
                    62342.5,
                    34820
                  ],
                  [
                    62698.4,
                    34688
                  ],
                  [
                    62884,
                    34573.7
                  ],
                  [
                    62895.1,
                    34415.3
                  ],
                  [
                    63015.8,
                    34325.2
                  ],
                  [
                    62807.6,
                    34052
                  ],
                  [
                    62532,
                    33954.3
                  ],
                  [
                    62115.9,
                    34620.7
                  ],
                  [
                    62342.5,
                    34820
                  ]
                ],
                "id": 373,
                "chat_link": "[&BHUBAAA=]"
              },
              "374": {
                "name": "Sniper's Woods",
                "level": 35,
                "coord": [
                  62135,
                  34190.4
                ],
                "bounds": [
                  [
                    61976.5,
                    34544.7
                  ],
                  [
                    62116.8,
                    34620
                  ],
                  [
                    62531.9,
                    33954
                  ],
                  [
                    62317,
                    33906.1
                  ],
                  [
                    62102.3,
                    34036.9
                  ],
                  [
                    61765.8,
                    34080.3
                  ],
                  [
                    61976.5,
                    34544.7
                  ]
                ],
                "id": 374,
                "chat_link": "[&BHYBAAA=]"
              },
              "375": {
                "name": "Bento Canyon",
                "level": 34,
                "coord": [
                  61654.1,
                  34397.7
                ],
                "bounds": [
                  [
                    61608.5,
                    34740
                  ],
                  [
                    61977.2,
                    34544.8
                  ],
                  [
                    61766,
                    34081.3
                  ],
                  [
                    61522.8,
                    34074.4
                  ],
                  [
                    61571.5,
                    34348
                  ],
                  [
                    61478.8,
                    34597.5
                  ],
                  [
                    61608.5,
                    34740
                  ]
                ],
                "id": 375,
                "chat_link": "[&BHcBAAA=]"
              },
              "376": {
                "name": "Dragonrot Domains",
                "level": 38,
                "coord": [
                  61711,
                  33852.5
                ],
                "bounds": [
                  [
                    61522.5,
                    34074.1
                  ],
                  [
                    61765.8,
                    34080.1
                  ],
                  [
                    62103,
                    34037.3
                  ],
                  [
                    61890.2,
                    33602.7
                  ],
                  [
                    61522.8,
                    33605.5
                  ],
                  [
                    61461.9,
                    33715.2
                  ],
                  [
                    61522.5,
                    34074.1
                  ]
                ],
                "id": 376,
                "chat_link": "[&BHgBAAA=]"
              },
              "377": {
                "name": "Varim's Run",
                "level": 40,
                "coord": [
                  61676.3,
                  33049.4
                ],
                "bounds": [
                  [
                    61684.6,
                    32846.2
                  ],
                  [
                    61627.8,
                    32689
                  ],
                  [
                    61783.8,
                    32640.9
                  ],
                  [
                    62037,
                    32658.6
                  ],
                  [
                    61927,
                    32793.8
                  ],
                  [
                    61888.9,
                    33603.3
                  ],
                  [
                    61521.8,
                    33606.4
                  ],
                  [
                    61568.4,
                    33387.3
                  ],
                  [
                    61411.7,
                    33325.3
                  ],
                  [
                    61408,
                    33080.2
                  ],
                  [
                    61580,
                    32912.1
                  ],
                  [
                    61684.6,
                    32846.2
                  ]
                ],
                "id": 377,
                "chat_link": "[&BHkBAAA=]"
              },
              "378": {
                "name": "Tenaebron Lake",
                "level": 39,
                "coord": [
                  62214.2,
                  33182.2
                ],
                "bounds": [
                  [
                    61884.8,
                    33603.9
                  ],
                  [
                    62102.9,
                    34046.4
                  ],
                  [
                    62317.7,
                    33899.6
                  ],
                  [
                    62262.7,
                    33569.9
                  ],
                  [
                    62495.3,
                    33233.3
                  ],
                  [
                    62442.7,
                    32764
                  ],
                  [
                    62420.4,
                    32651.8
                  ],
                  [
                    62238,
                    32617.8
                  ],
                  [
                    62046.1,
                    32647.3
                  ],
                  [
                    61931.3,
                    32787.9
                  ],
                  [
                    61884.8,
                    33603.9
                  ]
                ],
                "id": 378,
                "chat_link": "[&BHoBAAA=]"
              },
              "379": {
                "name": "Vulture's Sweep",
                "level": 37,
                "coord": [
                  62545.4,
                  33687.2
                ],
                "bounds": [
                  [
                    62315.8,
                    33906
                  ],
                  [
                    62530.4,
                    33952.9
                  ],
                  [
                    62805.8,
                    34052.8
                  ],
                  [
                    62867.3,
                    33390.9
                  ],
                  [
                    62492.3,
                    33242.2
                  ],
                  [
                    62260.7,
                    33578.4
                  ],
                  [
                    62315.8,
                    33906
                  ]
                ],
                "id": 379,
                "chat_link": "[&BHsBAAA=]"
              },
              "380": {
                "name": "Warrior's Crown",
                "level": 36,
                "coord": [
                  63286.9,
                  33885.3
                ],
                "bounds": [
                  [
                    62867.6,
                    33388
                  ],
                  [
                    63792.5,
                    33512.5
                  ],
                  [
                    63709.9,
                    33749.2
                  ],
                  [
                    63468.1,
                    33900.9
                  ],
                  [
                    63349.3,
                    34273.4
                  ],
                  [
                    63014.9,
                    34324.5
                  ],
                  [
                    62805.9,
                    34048.8
                  ],
                  [
                    62867.6,
                    33388
                  ]
                ],
                "id": 380,
                "chat_link": "[&BHwBAAA=]"
              },
              "381": {
                "name": "Belag Crossroads",
                "level": 35,
                "coord": [
                  63662.8,
                  34062.1
                ],
                "bounds": [
                  [
                    63348.9,
                    34273.4
                  ],
                  [
                    63669.7,
                    34368.1
                  ],
                  [
                    63873.3,
                    34199.3
                  ],
                  [
                    63905.5,
                    33881.5
                  ],
                  [
                    63711,
                    33749.6
                  ],
                  [
                    63468.4,
                    33900.9
                  ],
                  [
                    63348.9,
                    34273.4
                  ]
                ],
                "id": 381,
                "chat_link": "[&BH0BAAA=]"
              },
              "382": {
                "name": "Flameroot Caverns",
                "level": 36,
                "coord": [
                  64189.7,
                  33999.4
                ],
                "bounds": [
                  [
                    63872.4,
                    34199.8
                  ],
                  [
                    64439.4,
                    34201.8
                  ],
                  [
                    64395.5,
                    34050.3
                  ],
                  [
                    64466,
                    33931.9
                  ],
                  [
                    64059.3,
                    33731.8
                  ],
                  [
                    63905.5,
                    33880.9
                  ],
                  [
                    63872.4,
                    34199.8
                  ]
                ],
                "id": 382,
                "chat_link": "[&BH4BAAA=]"
              },
              "383": {
                "name": "Highden Caves",
                "level": 37,
                "coord": [
                  64321.2,
                  33581.6
                ],
                "bounds": [
                  [
                    64058.1,
                    33737.1
                  ],
                  [
                    64465.7,
                    33931.5
                  ],
                  [
                    64495.3,
                    33748.5
                  ],
                  [
                    64427.9,
                    33511.7
                  ],
                  [
                    64421.5,
                    33370.7
                  ],
                  [
                    64304.1,
                    33239.5
                  ],
                  [
                    64075.8,
                    33532.5
                  ],
                  [
                    64058.1,
                    33737.1
                  ]
                ],
                "id": 383,
                "chat_link": "[&BH8BAAA=]"
              },
              "384": {
                "name": "Axedrag Cut",
                "level": 37,
                "coord": [
                  63990.9,
                  33565.5
                ],
                "bounds": [
                  [
                    63881.1,
                    33256.4
                  ],
                  [
                    64304,
                    33239.1
                  ],
                  [
                    64083.4,
                    33532.1
                  ],
                  [
                    64061.1,
                    33735.1
                  ],
                  [
                    63905.5,
                    33881.2
                  ],
                  [
                    63710.1,
                    33748.8
                  ],
                  [
                    63881.1,
                    33256.4
                  ]
                ],
                "id": 384,
                "chat_link": "[&BIABAAA=]"
              },
              "385": {
                "name": "Tanglerot Hills",
                "level": 38,
                "coord": [
                  64171.4,
                  32762.6
                ],
                "bounds": [
                  [
                    63983.3,
                    32611.9
                  ],
                  [
                    63951.1,
                    32609.5
                  ],
                  [
                    64029.3,
                    32351.6
                  ],
                  [
                    64129.6,
                    32438.2
                  ],
                  [
                    64262.5,
                    32504.9
                  ],
                  [
                    64348,
                    32526.6
                  ],
                  [
                    64495,
                    32743.9
                  ],
                  [
                    64478.6,
                    33115.1
                  ],
                  [
                    64304,
                    33238.5
                  ],
                  [
                    63880,
                    33257.4
                  ],
                  [
                    64024.1,
                    32991.5
                  ],
                  [
                    63983.3,
                    32611.9
                  ]
                ],
                "id": 385,
                "chat_link": "[&BIEBAAA=]"
              },
              "386": {
                "name": "Halkor Meadows",
                "level": 38,
                "coord": [
                  63745.8,
                  32858
                ],
                "bounds": [
                  [
                    63566.3,
                    33004.5
                  ],
                  [
                    63855.8,
                    33329.6
                  ],
                  [
                    63879.9,
                    33259.8
                  ],
                  [
                    64024.2,
                    32991.6
                  ],
                  [
                    64008,
                    32735
                  ],
                  [
                    63986.5,
                    32610.7
                  ],
                  [
                    63759.8,
                    32579.6
                  ],
                  [
                    63522.4,
                    32646.3
                  ],
                  [
                    63394.6,
                    32629.6
                  ],
                  [
                    63460.5,
                    32793.5
                  ],
                  [
                    63566.3,
                    33004.5
                  ]
                ],
                "id": 386,
                "chat_link": "[&BIIBAAA=]"
              },
              "387": {
                "name": "Thunderbreak Hills",
                "level": 38,
                "coord": [
                  62924.8,
                  32849.6
                ],
                "bounds": [
                  [
                    63401.1,
                    32628
                  ],
                  [
                    63567,
                    33004.2
                  ],
                  [
                    63218.8,
                    33031.5
                  ],
                  [
                    62867.4,
                    33390
                  ],
                  [
                    62493,
                    33242.9
                  ],
                  [
                    62440,
                    32773.5
                  ],
                  [
                    62420.6,
                    32649
                  ],
                  [
                    62745,
                    32572
                  ],
                  [
                    62954.7,
                    32648.8
                  ],
                  [
                    63140.4,
                    32556.1
                  ],
                  [
                    63401.1,
                    32628
                  ]
                ],
                "id": 387,
                "chat_link": "[&BIMBAAA=]"
              },
              "388": {
                "name": "Hautclaire Vale",
                "level": 31,
                "coord": [
                  63239.6,
                  35319.1
                ],
                "bounds": [
                  [
                    63094.3,
                    34879.9
                  ],
                  [
                    63162.7,
                    34986.4
                  ],
                  [
                    63470.2,
                    34971.3
                  ],
                  [
                    63650.7,
                    35342.5
                  ],
                  [
                    63603.5,
                    35626.5
                  ],
                  [
                    63482.8,
                    35538.9
                  ],
                  [
                    63249.2,
                    35599.6
                  ],
                  [
                    63033.2,
                    35546.5
                  ],
                  [
                    62877.4,
                    35543.2
                  ],
                  [
                    62772.5,
                    35155.8
                  ],
                  [
                    63094.3,
                    34879.9
                  ]
                ],
                "id": 388,
                "chat_link": "[&BIQBAAA=]"
              },
              "389": {
                "name": "Gillfarn Plains",
                "level": 38,
                "coord": [
                  63459.3,
                  33253.3
                ],
                "bounds": [
                  [
                    62864.8,
                    33390.4
                  ],
                  [
                    63792.2,
                    33514.1
                  ],
                  [
                    63855.6,
                    33329
                  ],
                  [
                    63566.4,
                    33004.3
                  ],
                  [
                    63217.5,
                    33028.6
                  ],
                  [
                    62864.8,
                    33390.4
                  ]
                ],
                "id": 389,
                "chat_link": "[&BIUBAAA=]"
              },
              "877": {
                "name": "Secluded Glen",
                "level": 40,
                "coord": [
                  61571.1,
                  32795.5
                ],
                "bounds": [
                  [
                    61579.8,
                    32911.9
                  ],
                  [
                    61685,
                    32846.5
                  ],
                  [
                    61634.9,
                    32697
                  ],
                  [
                    61505.3,
                    32679.9
                  ],
                  [
                    61450.4,
                    32842.2
                  ],
                  [
                    61579.8,
                    32911.9
                  ]
                ],
                "id": 877,
                "chat_link": "[&BG0DAAA=]"
              }
            },
            "id": 1146,
            "mastery_points": [],
            "adventures": []
          },
          "1329": {
            "name": "Coming Home",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              60992,
              18784
            ],
            "map_rect": [
              [
                -36864,
                -30720
              ],
              [
                39936,
                30720
              ]
            ],
            "continent_rect": [
              [
                59392,
                17504
              ],
              [
                62592,
                20064
              ]
            ],
            "points_of_interest": {
              "3057": {
                "name": "Priory Research Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62327.2,
                  18975.3
                ],
                "id": 3057,
                "chat_link": "[&BPELAAA=]"
              },
              "3058": {
                "name": "Santia's Forge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60944.1,
                  18927.5
                ],
                "id": 3058,
                "chat_link": "[&BPILAAA=]"
              },
              "3059": {
                "name": "Blood Dam",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60087.9,
                  18368.5
                ],
                "id": 3059,
                "chat_link": "[&BPMLAAA=]"
              },
              "3060": {
                "name": "Auris's Workshop",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60456.4,
                  18907.9
                ],
                "id": 3060,
                "chat_link": "[&BPQLAAA=]"
              },
              "3061": {
                "name": "Ash Legion Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61314.2,
                  18781.2
                ],
                "id": 3061,
                "chat_link": "[&BPULAAA=]"
              },
              "3062": {
                "name": "Imperator Ruinbringer's Office",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60210.5,
                  19235.8
                ],
                "id": 3062,
                "chat_link": "[&BPYLAAA=]"
              },
              "3065": {
                "name": "Stockade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60370.2,
                  18582.3
                ],
                "id": 3065,
                "chat_link": "[&BPkLAAA=]"
              },
              "3067": {
                "name": "Keep Kitchen",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60264.6,
                  18820.8
                ],
                "id": 3067,
                "chat_link": "[&BPsLAAA=]"
              },
              "3068": {
                "name": "Cathedral of Flames Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62107.2,
                  17966.7
                ],
                "id": 3068,
                "chat_link": "[&BPwLAAA=]"
              },
              "3069": {
                "name": "Contender's Colosseum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61149.9,
                  19664.3
                ],
                "id": 3069,
                "chat_link": "[&BP0LAAA=]"
              },
              "3070": {
                "name": "Aurene's Grace",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62123.2,
                  19587.6
                ],
                "id": 3070,
                "chat_link": "[&BP4LAAA=]"
              },
              "3071": {
                "name": "Soul's Hearth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60120.6,
                  18142.3
                ],
                "id": 3071,
                "chat_link": "[&BP8LAAA=]"
              },
              "3073": {
                "name": "Doomlore Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62210,
                  18042.8
                ],
                "id": 3073,
                "chat_link": "[&BAEMAAA=]"
              },
              "3074": {
                "name": "Warden's Office",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60488.1,
                  18570.2
                ],
                "id": 3074,
                "chat_link": "[&BAIMAAA=]"
              },
              "3075": {
                "name": "Fangstorm's Farmhouse",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60624.5,
                  18053
                ],
                "id": 3075,
                "chat_link": "[&BAMMAAA=]"
              },
              "3076": {
                "name": "Rank 'n' File Pub",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60381.9,
                  19042.2
                ],
                "id": 3076,
                "chat_link": "[&BAQMAAA=]"
              },
              "3077": {
                "name": "Rally Pavilion",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61025.1,
                  18671
                ],
                "id": 3077,
                "chat_link": "[&BAUMAAA=]"
              },
              "3079": {
                "name": "Eternal Cauldron",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60843.7,
                  18407.9
                ],
                "id": 3079,
                "chat_link": "[&BAcMAAA=]"
              },
              "3082": {
                "name": "Blood Legion Fahrar",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60259.4,
                  19206.6
                ],
                "id": 3082,
                "chat_link": "[&BAoMAAA=]"
              },
              "3085": {
                "name": "Blood Lagoon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61585.4,
                  19707.4
                ],
                "id": 3085,
                "chat_link": "[&BA0MAAA=]"
              },
              "3087": {
                "name": "All-Legion Commons",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60776.5,
                  18617.4
                ],
                "id": 3087,
                "chat_link": "[&BA8MAAA=]"
              },
              "3089": {
                "name": "Recon Cove",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61892.7,
                  18977.2
                ],
                "id": 3089,
                "chat_link": "[&BBEMAAA=]"
              },
              "3090": {
                "name": "Vault of the Khan-Ur",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61680.3,
                  17876.1
                ],
                "id": 3090,
                "chat_link": "[&BBIMAAA=]"
              },
              "3093": {
                "name": "Sniper's Square",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60287.9,
                  19572.7
                ],
                "id": 3093,
                "chat_link": "[&BBUMAAA=]"
              },
              "3095": {
                "name": "Shiver Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60113.2,
                  19683.9
                ],
                "id": 3095,
                "chat_link": "[&BBcMAAA=]"
              },
              "3096": {
                "name": "Blood Keep Main Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60504.1,
                  19311.8
                ],
                "id": 3096,
                "chat_link": "[&BBgMAAA=]"
              },
              "3097": {
                "name": "Blood Stand Stage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61914.3,
                  19470.2
                ],
                "id": 3097,
                "chat_link": "[&BBkMAAA=]"
              },
              "3098": {
                "name": "Band's Bivouac",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61537.4,
                  19173.2
                ],
                "id": 3098,
                "chat_link": "[&BBoMAAA=]"
              },
              "3100": {
                "name": "Great Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60141.9,
                  18983.8
                ],
                "id": 3100,
                "chat_link": "[&BBwMAAA=]"
              },
              "3101": {
                "name": "Unity's Beacon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61195.5,
                  18132.8
                ],
                "id": 3101,
                "chat_link": "[&BB0MAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1748": {
                "name": "Kralkatorrik's Emergence Zone",
                "level": 80,
                "coord": [
                  62036.1,
                  19519.6
                ],
                "bounds": [
                  [
                    61509.7,
                    19991.4
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61677,
                    19861.8
                  ],
                  [
                    61731.3,
                    19802
                  ],
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61959.5,
                    19543
                  ],
                  [
                    61997.5,
                    19467
                  ],
                  [
                    61956.5,
                    19357.1
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61966.3,
                    19176.7
                  ],
                  [
                    62018.3,
                    19088.5
                  ],
                  [
                    62109.8,
                    19001.5
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62271.7,
                    19052.4
                  ],
                  [
                    62512.3,
                    19181.8
                  ],
                  [
                    62498.6,
                    19733
                  ],
                  [
                    62452.5,
                    19868.9
                  ],
                  [
                    62360.4,
                    19934.6
                  ],
                  [
                    62236.4,
                    19964.3
                  ],
                  [
                    61509.7,
                    19991.4
                  ]
                ],
                "id": 1748,
                "chat_link": "[&BNQGAAA=]"
              },
              "1749": {
                "name": "Dalada Forest",
                "level": 80,
                "coord": [
                  61871.9,
                  18350.6
                ],
                "bounds": [
                  [
                    62449.5,
                    18644.4
                  ],
                  [
                    62497.1,
                    18324.3
                  ],
                  [
                    62336.9,
                    18317.8
                  ],
                  [
                    62143.7,
                    18281.3
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    61932,
                    18184
                  ],
                  [
                    61867.3,
                    18219.2
                  ],
                  [
                    61752.2,
                    18252.6
                  ],
                  [
                    61694.3,
                    18209.6
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61484.5,
                    18298.5
                  ],
                  [
                    61581.4,
                    18421.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61929.2,
                    18680.9
                  ],
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    62449.5,
                    18644.4
                  ]
                ],
                "id": 1749,
                "chat_link": "[&BNUGAAA=]"
              },
              "1750": {
                "name": "Burning Effigy",
                "level": 80,
                "coord": [
                  61154.9,
                  18232
                ],
                "bounds": [
                  [
                    61049.4,
                    17948
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61287,
                    18312.5
                  ],
                  [
                    61157.9,
                    18391.8
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    61022.7,
                    18354
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    61049.4,
                    17948
                  ]
                ],
                "id": 1750,
                "chat_link": "[&BNYGAAA=]"
              },
              "1751": {
                "name": "The Ooze Pit",
                "level": 80,
                "coord": [
                  61133.5,
                  19807.8
                ],
                "bounds": [
                  [
                    60917.5,
                    20004.8
                  ],
                  [
                    60769,
                    19989
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60907.3,
                    19651.3
                  ],
                  [
                    61043,
                    19603
                  ],
                  [
                    61238,
                    19606.6
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61509.7,
                    19991.4
                  ],
                  [
                    61179,
                    20032.4
                  ],
                  [
                    60917.5,
                    20004.8
                  ]
                ],
                "id": 1751,
                "chat_link": "[&BNcGAAA=]"
              },
              "1752": {
                "name": "Flame Legion Camp",
                "level": 80,
                "coord": [
                  60855.8,
                  18398.5
                ],
                "bounds": [
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    60977.7,
                    18548.2
                  ],
                  [
                    60790.4,
                    18547.6
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60674.2,
                    18383.3
                  ],
                  [
                    60755.9,
                    18244.2
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    61022.7,
                    18354
                  ],
                  [
                    61042.5,
                    18468.2
                  ]
                ],
                "id": 1752,
                "chat_link": "[&BNgGAAA=]"
              },
              "1753": {
                "name": "Shiverpeaks Pass",
                "level": 80,
                "coord": [
                  59772.3,
                  19582.9
                ],
                "bounds": [
                  [
                    59476.5,
                    19222.8
                  ],
                  [
                    59510,
                    19899.3
                  ],
                  [
                    59599.8,
                    19971.5
                  ],
                  [
                    59778.1,
                    19980.2
                  ],
                  [
                    60007.6,
                    19908.3
                  ],
                  [
                    60011.2,
                    19720.1
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59790.4,
                    19254.6
                  ],
                  [
                    59629.3,
                    19273.3
                  ],
                  [
                    59476.5,
                    19222.8
                  ]
                ],
                "id": 1753,
                "chat_link": "[&BNkGAAA=]"
              },
              "1754": {
                "name": "Shattered Steppes",
                "level": 80,
                "coord": [
                  61979.3,
                  19016.7
                ],
                "bounds": [
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    61929.2,
                    18680.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61703.3,
                    18988.7
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61809,
                    19299.3
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61966.3,
                    19176.7
                  ],
                  [
                    62018.3,
                    19088.5
                  ],
                  [
                    62109.8,
                    19001.5
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62315.6,
                    18861.1
                  ],
                  [
                    62319.6,
                    18766.6
                  ]
                ],
                "id": 1754,
                "chat_link": "[&BNoGAAA=]"
              },
              "1755": {
                "name": "The Crag",
                "level": 80,
                "coord": [
                  61836.3,
                  19441.7
                ],
                "bounds": [
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61710,
                    19584.1
                  ],
                  [
                    61719.9,
                    19428.8
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61809,
                    19299.3
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61956.5,
                    19357.1
                  ],
                  [
                    61997.5,
                    19467
                  ],
                  [
                    61959.5,
                    19543
                  ],
                  [
                    61738.7,
                    19669.8
                  ]
                ],
                "id": 1755,
                "chat_link": "[&BNsGAAA=]"
              },
              "1756": {
                "name": "The Wardowns",
                "level": 80,
                "coord": [
                  61143.4,
                  19167.6
                ],
                "bounds": [
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61424.8,
                    19151.8
                  ],
                  [
                    61457.4,
                    19516.8
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61238,
                    19606.6
                  ],
                  [
                    61043,
                    19603
                  ],
                  [
                    60907.3,
                    19651.3
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60790.9,
                    19286.1
                  ],
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    61053.9,
                    19052
                  ],
                  [
                    61106.6,
                    19007.5
                  ],
                  [
                    61128.9,
                    18918.3
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61180.6,
                    18729.1
                  ],
                  [
                    61229.5,
                    18831.9
                  ],
                  [
                    61269,
                    18848.6
                  ],
                  [
                    61479.4,
                    18887.6
                  ]
                ],
                "id": 1756,
                "chat_link": "[&BNwGAAA=]"
              },
              "1757": {
                "name": "Cavern of the Khan-Ur",
                "level": 80,
                "coord": [
                  61803.9,
                  18001.4
                ],
                "bounds": [
                  [
                    61615.8,
                    17565.2
                  ],
                  [
                    61598.2,
                    17890.5
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61694.3,
                    18209.6
                  ],
                  [
                    61752.2,
                    18252.6
                  ],
                  [
                    61867.3,
                    18219.2
                  ],
                  [
                    61932,
                    18184
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    61949.7,
                    17888.5
                  ],
                  [
                    61991.5,
                    17641.1
                  ],
                  [
                    61615.8,
                    17565.2
                  ]
                ],
                "id": 1757,
                "chat_link": "[&BN0GAAA=]"
              },
              "1758": {
                "name": "Khan-Ur's Gauntlet",
                "level": 80,
                "coord": [
                  61184.5,
                  17740.4
                ],
                "bounds": [
                  [
                    60794.8,
                    17540.8
                  ],
                  [
                    60619,
                    17566
                  ],
                  [
                    60554.9,
                    17795.3
                  ],
                  [
                    60919.4,
                    17818.7
                  ],
                  [
                    61049.4,
                    17948
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61598.2,
                    17890.5
                  ],
                  [
                    61615.8,
                    17565.2
                  ],
                  [
                    61511.5,
                    17546.7
                  ],
                  [
                    61381.3,
                    17532.9
                  ],
                  [
                    60794.8,
                    17540.8
                  ]
                ],
                "id": 1758,
                "chat_link": "[&BN4GAAA=]"
              },
              "1759": {
                "name": "Training Grounds",
                "level": 80,
                "coord": [
                  60345.7,
                  19735.4
                ],
                "bounds": [
                  [
                    60605.1,
                    19638
                  ],
                  [
                    60598.4,
                    19733.2
                  ],
                  [
                    60531.7,
                    19808
                  ],
                  [
                    60509.8,
                    19885.3
                  ],
                  [
                    60524.6,
                    19946.1
                  ],
                  [
                    60456.2,
                    19955.2
                  ],
                  [
                    60159.5,
                    19992.2
                  ],
                  [
                    60007.6,
                    19908.3
                  ],
                  [
                    60011.2,
                    19720.1
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60605.1,
                    19638
                  ]
                ],
                "id": 1759,
                "chat_link": "[&BN8GAAA=]"
              },
              "1760": {
                "name": "Upper Blood Keep",
                "level": 80,
                "coord": [
                  60155.1,
                  19085.3
                ],
                "bounds": [
                  [
                    60091.5,
                    18871.4
                  ],
                  [
                    60227.8,
                    18872.8
                  ],
                  [
                    60230.6,
                    18943
                  ],
                  [
                    60334.3,
                    18943.7
                  ],
                  [
                    60333.1,
                    19254.5
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60091.5,
                    18871.4
                  ]
                ],
                "id": 1760,
                "chat_link": "[&BOAGAAA=]"
              },
              "1761": {
                "name": "The Overlook",
                "level": 80,
                "coord": [
                  62368.5,
                  18902.8
                ],
                "bounds": [
                  [
                    62506.5,
                    18819.5
                  ],
                  [
                    62449.5,
                    18644.4
                  ],
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    62315.6,
                    18861.1
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62271.7,
                    19052.4
                  ],
                  [
                    62512.3,
                    19181.8
                  ],
                  [
                    62506.5,
                    18819.5
                  ]
                ],
                "id": 1761,
                "chat_link": "[&BOEGAAA=]"
              },
              "1762": {
                "name": "The Brig",
                "level": 80,
                "coord": [
                  60432.6,
                  18634.6
                ],
                "bounds": [
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60519.2,
                    18511.8
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60259.2,
                    18709.5
                  ]
                ],
                "id": 1762,
                "chat_link": "[&BOIGAAA=]"
              },
              "1763": {
                "name": "Iron Legion Camp",
                "level": 80,
                "coord": [
                  60966.6,
                  18905
                ],
                "bounds": [
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    61053.9,
                    19052
                  ],
                  [
                    61106.6,
                    19007.5
                  ],
                  [
                    61128.9,
                    18918.3
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    60927.8,
                    18724.5
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60790.4,
                    18875.3
                  ],
                  [
                    60872.3,
                    19101.9
                  ]
                ],
                "id": 1763,
                "chat_link": "[&BOMGAAA=]"
              },
              "1764": {
                "name": "Lower Blood Keep",
                "level": 80,
                "coord": [
                  60343.8,
                  19021.2
                ],
                "bounds": [
                  [
                    60000,
                    18805.5
                  ],
                  [
                    60100,
                    18745.8
                  ],
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60593.3,
                    18915.3
                  ],
                  [
                    60585.9,
                    19048.5
                  ],
                  [
                    60592.4,
                    19159.5
                  ],
                  [
                    60628.5,
                    19233.2
                  ],
                  [
                    60613.4,
                    19292.4
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    60333.1,
                    19254.5
                  ],
                  [
                    60334.3,
                    18943.7
                  ],
                  [
                    60230.6,
                    18943
                  ],
                  [
                    60227.8,
                    18872.8
                  ],
                  [
                    60091.5,
                    18871.4
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60000,
                    18805.5
                  ]
                ],
                "id": 1764,
                "chat_link": "[&BOQGAAA=]"
              },
              "1765": {
                "name": "Rusty Meadows",
                "level": 80,
                "coord": [
                  60483.3,
                  18144.7
                ],
                "bounds": [
                  [
                    59747,
                    18085.2
                  ],
                  [
                    59909.8,
                    17877.5
                  ],
                  [
                    60197.3,
                    17663.5
                  ],
                  [
                    60619,
                    17566
                  ],
                  [
                    60554.9,
                    17795.3
                  ],
                  [
                    60919.4,
                    17818.7
                  ],
                  [
                    61049.4,
                    17948
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    60755.9,
                    18244.2
                  ],
                  [
                    60674.2,
                    18383.3
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60519.2,
                    18511.8
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60208,
                    18388.8
                  ],
                  [
                    60154.3,
                    18284.1
                  ],
                  [
                    59747,
                    18085.2
                  ]
                ],
                "id": 1765,
                "chat_link": "[&BOUGAAA=]"
              },
              "1766": {
                "name": "Festival Promenade",
                "level": 80,
                "coord": [
                  60851.2,
                  18645.6
                ],
                "bounds": [
                  [
                    60977.7,
                    18548.2
                  ],
                  [
                    60790.4,
                    18547.6
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60927.8,
                    18724.5
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    60977.7,
                    18548.2
                  ]
                ],
                "id": 1766,
                "chat_link": "[&BOYGAAA=]"
              },
              "1767": {
                "name": "Longeye's Landslide",
                "level": 80,
                "coord": [
                  59983.7,
                  18546.9
                ],
                "bounds": [
                  [
                    60000,
                    18805.5
                  ],
                  [
                    60100,
                    18745.8
                  ],
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60208,
                    18388.8
                  ],
                  [
                    60154.3,
                    18284.1
                  ],
                  [
                    59747,
                    18085.2
                  ],
                  [
                    59602.2,
                    18385
                  ],
                  [
                    59561.5,
                    18639.4
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60000,
                    18805.5
                  ]
                ],
                "id": 1767,
                "chat_link": "[&BOcGAAA=]"
              },
              "1768": {
                "name": "Doomlore Ruins",
                "level": 80,
                "coord": [
                  62211.3,
                  17975.1
                ],
                "bounds": [
                  [
                    61949.7,
                    17888.5
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    62143.7,
                    18281.3
                  ],
                  [
                    62336.9,
                    18317.8
                  ],
                  [
                    62497.1,
                    18324.3
                  ],
                  [
                    62486.3,
                    17799.2
                  ],
                  [
                    62343.5,
                    17692.6
                  ],
                  [
                    62129.8,
                    17681.4
                  ],
                  [
                    61991.5,
                    17641.1
                  ],
                  [
                    61949.7,
                    17888.5
                  ]
                ],
                "id": 1768,
                "chat_link": "[&BOgGAAA=]"
              },
              "1769": {
                "name": "Bitter Horn",
                "level": 80,
                "coord": [
                  59650.8,
                  19041.8
                ],
                "bounds": [
                  [
                    59561.5,
                    18639.4
                  ],
                  [
                    59433.2,
                    18865.3
                  ],
                  [
                    59428.2,
                    18997.3
                  ],
                  [
                    59476.5,
                    19222.8
                  ],
                  [
                    59629.3,
                    19273.3
                  ],
                  [
                    59790.4,
                    19254.6
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    59561.5,
                    18639.4
                  ]
                ],
                "id": 1769,
                "chat_link": "[&BOkGAAA=]"
              },
              "1770": {
                "name": "Sacnoth Stream",
                "level": 80,
                "coord": [
                  61613.2,
                  19314.9
                ],
                "bounds": [
                  [
                    61457.4,
                    19516.8
                  ],
                  [
                    61424.8,
                    19151.8
                  ],
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61542.1,
                    18693.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61703.3,
                    18988.7
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61719.9,
                    19428.8
                  ],
                  [
                    61710,
                    19584.1
                  ],
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61731.3,
                    19802
                  ],
                  [
                    61677,
                    19861.8
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61457.4,
                    19516.8
                  ]
                ],
                "id": 1770,
                "chat_link": "[&BOoGAAA=]"
              },
              "1771": {
                "name": "Devourer's Ridge",
                "level": 80,
                "coord": [
                  61333.6,
                  18577.6
                ],
                "bounds": [
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61484.5,
                    18298.5
                  ],
                  [
                    61581.4,
                    18421.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61542.1,
                    18693.8
                  ],
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61269,
                    18848.6
                  ],
                  [
                    61229.5,
                    18831.9
                  ],
                  [
                    61180.6,
                    18729.1
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    61157.9,
                    18391.8
                  ],
                  [
                    61287,
                    18312.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ]
                ],
                "id": 1771,
                "chat_link": "[&BOsGAAA=]"
              },
              "1772": {
                "name": "Tribunes' Trench",
                "level": 80,
                "coord": [
                  60642.6,
                  19403.5
                ],
                "bounds": [
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60593.3,
                    18915.3
                  ],
                  [
                    60585.9,
                    19048.5
                  ],
                  [
                    60592.4,
                    19159.5
                  ],
                  [
                    60628.5,
                    19233.2
                  ],
                  [
                    60613.4,
                    19292.4
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60605.1,
                    19638
                  ],
                  [
                    60598.4,
                    19733.2
                  ],
                  [
                    60531.7,
                    19808
                  ],
                  [
                    60509.8,
                    19885.3
                  ],
                  [
                    60524.6,
                    19946.1
                  ],
                  [
                    60646.9,
                    19977.6
                  ],
                  [
                    60769,
                    19989
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60790.9,
                    19286.1
                  ],
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    60790.4,
                    18875.3
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60543.9,
                    18845.7
                  ]
                ],
                "id": 1772,
                "chat_link": "[&BOwGAAA=]"
              }
            },
            "adventures": [],
            "id": 1329,
            "mastery_points": []
          },
          "1330": {
            "name": "Grothmar Valley",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              60992,
              18784
            ],
            "map_rect": [
              [
                -36864,
                -30720
              ],
              [
                39936,
                30720
              ]
            ],
            "continent_rect": [
              [
                59392,
                17504
              ],
              [
                62592,
                20064
              ]
            ],
            "points_of_interest": {
              "3057": {
                "name": "Priory Research Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62327.2,
                  18975.3
                ],
                "id": 3057,
                "chat_link": "[&BPELAAA=]"
              },
              "3058": {
                "name": "Santia's Forge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60944.1,
                  18927.5
                ],
                "id": 3058,
                "chat_link": "[&BPILAAA=]"
              },
              "3059": {
                "name": "Blood Dam",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60087.9,
                  18368.5
                ],
                "id": 3059,
                "chat_link": "[&BPMLAAA=]"
              },
              "3060": {
                "name": "Auris's Workshop",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60456.4,
                  18907.9
                ],
                "id": 3060,
                "chat_link": "[&BPQLAAA=]"
              },
              "3061": {
                "name": "Ash Legion Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61314.2,
                  18781.2
                ],
                "id": 3061,
                "chat_link": "[&BPULAAA=]"
              },
              "3062": {
                "name": "Imperator Ruinbringer's Office",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60210.5,
                  19235.8
                ],
                "id": 3062,
                "chat_link": "[&BPYLAAA=]"
              },
              "3063": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  61558,
                  19168.1
                ],
                "id": 3063,
                "chat_link": "[&BPcLAAA=]"
              },
              "3064": {
                "name": "Wardowns Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  61288.2,
                  19612.2
                ],
                "id": 3064,
                "chat_link": "[&BPgLAAA=]"
              },
              "3065": {
                "name": "Stockade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60370.2,
                  18582.3
                ],
                "id": 3065,
                "chat_link": "[&BPkLAAA=]"
              },
              "3066": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60983.4,
                  19677.6
                ],
                "id": 3066,
                "chat_link": "[&BPoLAAA=]"
              },
              "3067": {
                "name": "Keep Kitchen",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60264.6,
                  18820.8
                ],
                "id": 3067,
                "chat_link": "[&BPsLAAA=]"
              },
              "3068": {
                "name": "Cathedral of Flames Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62107.2,
                  17966.7
                ],
                "id": 3068,
                "chat_link": "[&BPwLAAA=]"
              },
              "3069": {
                "name": "Contender's Colosseum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61149.9,
                  19664.3
                ],
                "id": 3069,
                "chat_link": "[&BP0LAAA=]"
              },
              "3070": {
                "name": "Aurene's Grace",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62123.2,
                  19587.6
                ],
                "id": 3070,
                "chat_link": "[&BP4LAAA=]"
              },
              "3071": {
                "name": "Soul's Hearth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60120.6,
                  18142.3
                ],
                "id": 3071,
                "chat_link": "[&BP8LAAA=]"
              },
              "3072": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60898.6,
                  18994.8
                ],
                "id": 3072,
                "chat_link": "[&BAAMAAA=]"
              },
              "3073": {
                "name": "Doomlore Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62210,
                  18042.8
                ],
                "id": 3073,
                "chat_link": "[&BAEMAAA=]"
              },
              "3074": {
                "name": "Warden's Office",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60488.1,
                  18570.2
                ],
                "id": 3074,
                "chat_link": "[&BAIMAAA=]"
              },
              "3075": {
                "name": "Fangstorm's Farmhouse",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60624.5,
                  18053
                ],
                "id": 3075,
                "chat_link": "[&BAMMAAA=]"
              },
              "3076": {
                "name": "Rank 'n' File Pub",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60381.9,
                  19042.2
                ],
                "id": 3076,
                "chat_link": "[&BAQMAAA=]"
              },
              "3077": {
                "name": "Rally Pavilion",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61025.1,
                  18671
                ],
                "id": 3077,
                "chat_link": "[&BAUMAAA=]"
              },
              "3078": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60321.1,
                  18080
                ],
                "id": 3078,
                "chat_link": "[&BAYMAAA=]"
              },
              "3079": {
                "name": "Eternal Cauldron",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60843.7,
                  18407.9
                ],
                "id": 3079,
                "chat_link": "[&BAcMAAA=]"
              },
              "3080": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60905,
                  18397.9
                ],
                "id": 3080,
                "chat_link": "[&BAgMAAA=]"
              },
              "3082": {
                "name": "Blood Legion Fahrar",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60259.4,
                  19206.6
                ],
                "id": 3082,
                "chat_link": "[&BAoMAAA=]"
              },
              "3083": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  61135.1,
                  18093.3
                ],
                "id": 3083,
                "chat_link": "[&BAsMAAA=]"
              },
              "3084": {
                "name": "War Room",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60125.9,
                  19121.6
                ],
                "id": 3084,
                "chat_link": "[&BAwMAAA=]"
              },
              "3085": {
                "name": "Blood Lagoon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61585.4,
                  19707.4
                ],
                "id": 3085,
                "chat_link": "[&BA0MAAA=]"
              },
              "3086": {
                "name": "Dalada Forest Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  61726.3,
                  18513.4
                ],
                "id": 3086,
                "chat_link": "[&BA4MAAA=]"
              },
              "3087": {
                "name": "All-Legion Commons",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60776.5,
                  18617.4
                ],
                "id": 3087,
                "chat_link": "[&BA8MAAA=]"
              },
              "3088": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  62299.7,
                  19061.8
                ],
                "id": 3088,
                "chat_link": "[&BBAMAAA=]"
              },
              "3089": {
                "name": "Recon Cove",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61892.7,
                  18977.2
                ],
                "id": 3089,
                "chat_link": "[&BBEMAAA=]"
              },
              "3090": {
                "name": "Vault of the Khan-Ur",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61680.3,
                  17876.1
                ],
                "id": 3090,
                "chat_link": "[&BBIMAAA=]"
              },
              "3091": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  61011.2,
                  17587.9
                ],
                "id": 3091,
                "chat_link": "[&BBMMAAA=]"
              },
              "3092": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60537.8,
                  19052.9
                ],
                "id": 3092,
                "chat_link": "[&BBQMAAA=]"
              },
              "3093": {
                "name": "Sniper's Square",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60287.9,
                  19572.7
                ],
                "id": 3093,
                "chat_link": "[&BBUMAAA=]"
              },
              "3094": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  62220.4,
                  18221.7
                ],
                "id": 3094,
                "chat_link": "[&BBYMAAA=]"
              },
              "3095": {
                "name": "Shiver Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60113.2,
                  19683.9
                ],
                "id": 3095,
                "chat_link": "[&BBcMAAA=]"
              },
              "3096": {
                "name": "Blood Keep Main Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60504.1,
                  19311.8
                ],
                "id": 3096,
                "chat_link": "[&BBgMAAA=]"
              },
              "3097": {
                "name": "Blood Stand Stage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61914.3,
                  19470.2
                ],
                "id": 3097,
                "chat_link": "[&BBkMAAA=]"
              },
              "3098": {
                "name": "Band's Bivouac",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61537.4,
                  19173.2
                ],
                "id": 3098,
                "chat_link": "[&BBoMAAA=]"
              },
              "3099": {
                "name": "Blood Keep Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60426.8,
                  18848.4
                ],
                "id": 3099,
                "chat_link": "[&BBsMAAA=]"
              },
              "3100": {
                "name": "Great Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60141.9,
                  18983.8
                ],
                "id": 3100,
                "chat_link": "[&BBwMAAA=]"
              },
              "3101": {
                "name": "Unity's Beacon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61195.5,
                  18132.8
                ],
                "id": 3101,
                "chat_link": "[&BB0MAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1748": {
                "name": "Kralkatorrik's Emergence Zone",
                "level": 80,
                "coord": [
                  62036.1,
                  19519.6
                ],
                "bounds": [
                  [
                    61509.7,
                    19991.4
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61677,
                    19861.8
                  ],
                  [
                    61731.3,
                    19802
                  ],
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61959.5,
                    19543
                  ],
                  [
                    61997.5,
                    19467
                  ],
                  [
                    61956.5,
                    19357.1
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61966.3,
                    19176.7
                  ],
                  [
                    62018.3,
                    19088.5
                  ],
                  [
                    62109.8,
                    19001.5
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62271.7,
                    19052.4
                  ],
                  [
                    62512.3,
                    19181.8
                  ],
                  [
                    62498.6,
                    19733
                  ],
                  [
                    62452.5,
                    19868.9
                  ],
                  [
                    62360.4,
                    19934.6
                  ],
                  [
                    62236.4,
                    19964.3
                  ],
                  [
                    61509.7,
                    19991.4
                  ]
                ],
                "id": 1748,
                "chat_link": "[&BNQGAAA=]"
              },
              "1749": {
                "name": "Dalada Forest",
                "level": 80,
                "coord": [
                  61871.9,
                  18350.6
                ],
                "bounds": [
                  [
                    62449.5,
                    18644.4
                  ],
                  [
                    62497.1,
                    18324.3
                  ],
                  [
                    62336.9,
                    18317.8
                  ],
                  [
                    62143.7,
                    18281.3
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    61932,
                    18184
                  ],
                  [
                    61867.3,
                    18219.2
                  ],
                  [
                    61752.2,
                    18252.6
                  ],
                  [
                    61694.3,
                    18209.6
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61484.5,
                    18298.5
                  ],
                  [
                    61581.4,
                    18421.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61929.2,
                    18680.9
                  ],
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    62449.5,
                    18644.4
                  ]
                ],
                "id": 1749,
                "chat_link": "[&BNUGAAA=]"
              },
              "1750": {
                "name": "Burning Effigy",
                "level": 80,
                "coord": [
                  61154.9,
                  18232
                ],
                "bounds": [
                  [
                    61049.4,
                    17948
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61287,
                    18312.5
                  ],
                  [
                    61157.9,
                    18391.8
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    61022.7,
                    18354
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    61049.4,
                    17948
                  ]
                ],
                "id": 1750,
                "chat_link": "[&BNYGAAA=]"
              },
              "1751": {
                "name": "The Ooze Pit",
                "level": 80,
                "coord": [
                  61133.5,
                  19807.8
                ],
                "bounds": [
                  [
                    60917.5,
                    20004.8
                  ],
                  [
                    60769,
                    19989
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60907.3,
                    19651.3
                  ],
                  [
                    61043,
                    19603
                  ],
                  [
                    61238,
                    19606.6
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61509.7,
                    19991.4
                  ],
                  [
                    61179,
                    20032.4
                  ],
                  [
                    60917.5,
                    20004.8
                  ]
                ],
                "id": 1751,
                "chat_link": "[&BNcGAAA=]"
              },
              "1752": {
                "name": "Flame Legion Camp",
                "level": 80,
                "coord": [
                  60855.8,
                  18398.5
                ],
                "bounds": [
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    60977.7,
                    18548.2
                  ],
                  [
                    60790.4,
                    18547.6
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60674.2,
                    18383.3
                  ],
                  [
                    60755.9,
                    18244.2
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    61022.7,
                    18354
                  ],
                  [
                    61042.5,
                    18468.2
                  ]
                ],
                "id": 1752,
                "chat_link": "[&BNgGAAA=]"
              },
              "1753": {
                "name": "Shiverpeaks Pass",
                "level": 80,
                "coord": [
                  59772.3,
                  19582.9
                ],
                "bounds": [
                  [
                    59476.5,
                    19222.8
                  ],
                  [
                    59510,
                    19899.3
                  ],
                  [
                    59599.8,
                    19971.5
                  ],
                  [
                    59778.1,
                    19980.2
                  ],
                  [
                    60007.6,
                    19908.3
                  ],
                  [
                    60011.2,
                    19720.1
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59790.4,
                    19254.6
                  ],
                  [
                    59629.3,
                    19273.3
                  ],
                  [
                    59476.5,
                    19222.8
                  ]
                ],
                "id": 1753,
                "chat_link": "[&BNkGAAA=]"
              },
              "1754": {
                "name": "Shattered Steppes",
                "level": 80,
                "coord": [
                  61979.3,
                  19016.7
                ],
                "bounds": [
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    61929.2,
                    18680.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61703.3,
                    18988.7
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61809,
                    19299.3
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61966.3,
                    19176.7
                  ],
                  [
                    62018.3,
                    19088.5
                  ],
                  [
                    62109.8,
                    19001.5
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62315.6,
                    18861.1
                  ],
                  [
                    62319.6,
                    18766.6
                  ]
                ],
                "id": 1754,
                "chat_link": "[&BNoGAAA=]"
              },
              "1755": {
                "name": "The Crag",
                "level": 80,
                "coord": [
                  61836.3,
                  19441.7
                ],
                "bounds": [
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61710,
                    19584.1
                  ],
                  [
                    61719.9,
                    19428.8
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61809,
                    19299.3
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61956.5,
                    19357.1
                  ],
                  [
                    61997.5,
                    19467
                  ],
                  [
                    61959.5,
                    19543
                  ],
                  [
                    61738.7,
                    19669.8
                  ]
                ],
                "id": 1755,
                "chat_link": "[&BNsGAAA=]"
              },
              "1756": {
                "name": "The Wardowns",
                "level": 80,
                "coord": [
                  61143.4,
                  19167.6
                ],
                "bounds": [
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61424.8,
                    19151.8
                  ],
                  [
                    61457.4,
                    19516.8
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61238,
                    19606.6
                  ],
                  [
                    61043,
                    19603
                  ],
                  [
                    60907.3,
                    19651.3
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60790.9,
                    19286.1
                  ],
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    61053.9,
                    19052
                  ],
                  [
                    61106.6,
                    19007.5
                  ],
                  [
                    61128.9,
                    18918.3
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61180.6,
                    18729.1
                  ],
                  [
                    61229.5,
                    18831.9
                  ],
                  [
                    61269,
                    18848.6
                  ],
                  [
                    61479.4,
                    18887.6
                  ]
                ],
                "id": 1756,
                "chat_link": "[&BNwGAAA=]"
              },
              "1757": {
                "name": "Cavern of the Khan-Ur",
                "level": 80,
                "coord": [
                  61803.9,
                  18001.4
                ],
                "bounds": [
                  [
                    61615.8,
                    17565.2
                  ],
                  [
                    61598.2,
                    17890.5
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61694.3,
                    18209.6
                  ],
                  [
                    61752.2,
                    18252.6
                  ],
                  [
                    61867.3,
                    18219.2
                  ],
                  [
                    61932,
                    18184
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    61949.7,
                    17888.5
                  ],
                  [
                    61991.5,
                    17641.1
                  ],
                  [
                    61615.8,
                    17565.2
                  ]
                ],
                "id": 1757,
                "chat_link": "[&BN0GAAA=]"
              },
              "1758": {
                "name": "Khan-Ur's Gauntlet",
                "level": 80,
                "coord": [
                  61184.5,
                  17740.4
                ],
                "bounds": [
                  [
                    60794.8,
                    17540.8
                  ],
                  [
                    60619,
                    17566
                  ],
                  [
                    60554.9,
                    17795.3
                  ],
                  [
                    60919.4,
                    17818.7
                  ],
                  [
                    61049.4,
                    17948
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61598.2,
                    17890.5
                  ],
                  [
                    61615.8,
                    17565.2
                  ],
                  [
                    61511.5,
                    17546.7
                  ],
                  [
                    61381.3,
                    17532.9
                  ],
                  [
                    60794.8,
                    17540.8
                  ]
                ],
                "id": 1758,
                "chat_link": "[&BN4GAAA=]"
              },
              "1759": {
                "name": "Training Grounds",
                "level": 80,
                "coord": [
                  60345.7,
                  19735.4
                ],
                "bounds": [
                  [
                    60605.1,
                    19638
                  ],
                  [
                    60598.4,
                    19733.2
                  ],
                  [
                    60531.7,
                    19808
                  ],
                  [
                    60509.8,
                    19885.3
                  ],
                  [
                    60524.6,
                    19946.1
                  ],
                  [
                    60456.2,
                    19955.2
                  ],
                  [
                    60159.5,
                    19992.2
                  ],
                  [
                    60007.6,
                    19908.3
                  ],
                  [
                    60011.2,
                    19720.1
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60605.1,
                    19638
                  ]
                ],
                "id": 1759,
                "chat_link": "[&BN8GAAA=]"
              },
              "1760": {
                "name": "Upper Blood Keep",
                "level": 80,
                "coord": [
                  60155.1,
                  19085.3
                ],
                "bounds": [
                  [
                    60091.5,
                    18871.4
                  ],
                  [
                    60227.8,
                    18872.8
                  ],
                  [
                    60230.6,
                    18943
                  ],
                  [
                    60334.3,
                    18943.7
                  ],
                  [
                    60333.1,
                    19254.5
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60091.5,
                    18871.4
                  ]
                ],
                "id": 1760,
                "chat_link": "[&BOAGAAA=]"
              },
              "1761": {
                "name": "The Overlook",
                "level": 80,
                "coord": [
                  62368.5,
                  18902.8
                ],
                "bounds": [
                  [
                    62506.5,
                    18819.5
                  ],
                  [
                    62449.5,
                    18644.4
                  ],
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    62315.6,
                    18861.1
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62271.7,
                    19052.4
                  ],
                  [
                    62512.3,
                    19181.8
                  ],
                  [
                    62506.5,
                    18819.5
                  ]
                ],
                "id": 1761,
                "chat_link": "[&BOEGAAA=]"
              },
              "1762": {
                "name": "The Brig",
                "level": 80,
                "coord": [
                  60432.6,
                  18634.6
                ],
                "bounds": [
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60519.2,
                    18511.8
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60259.2,
                    18709.5
                  ]
                ],
                "id": 1762,
                "chat_link": "[&BOIGAAA=]"
              },
              "1763": {
                "name": "Iron Legion Camp",
                "level": 80,
                "coord": [
                  60966.6,
                  18905
                ],
                "bounds": [
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    61053.9,
                    19052
                  ],
                  [
                    61106.6,
                    19007.5
                  ],
                  [
                    61128.9,
                    18918.3
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    60927.8,
                    18724.5
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60790.4,
                    18875.3
                  ],
                  [
                    60872.3,
                    19101.9
                  ]
                ],
                "id": 1763,
                "chat_link": "[&BOMGAAA=]"
              },
              "1764": {
                "name": "Lower Blood Keep",
                "level": 80,
                "coord": [
                  60343.8,
                  19021.2
                ],
                "bounds": [
                  [
                    60000,
                    18805.5
                  ],
                  [
                    60100,
                    18745.8
                  ],
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60593.3,
                    18915.3
                  ],
                  [
                    60585.9,
                    19048.5
                  ],
                  [
                    60592.4,
                    19159.5
                  ],
                  [
                    60628.5,
                    19233.2
                  ],
                  [
                    60613.4,
                    19292.4
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    60333.1,
                    19254.5
                  ],
                  [
                    60334.3,
                    18943.7
                  ],
                  [
                    60230.6,
                    18943
                  ],
                  [
                    60227.8,
                    18872.8
                  ],
                  [
                    60091.5,
                    18871.4
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60000,
                    18805.5
                  ]
                ],
                "id": 1764,
                "chat_link": "[&BOQGAAA=]"
              },
              "1765": {
                "name": "Rusty Meadows",
                "level": 80,
                "coord": [
                  60483.3,
                  18144.7
                ],
                "bounds": [
                  [
                    59747,
                    18085.2
                  ],
                  [
                    59909.8,
                    17877.5
                  ],
                  [
                    60197.3,
                    17663.5
                  ],
                  [
                    60619,
                    17566
                  ],
                  [
                    60554.9,
                    17795.3
                  ],
                  [
                    60919.4,
                    17818.7
                  ],
                  [
                    61049.4,
                    17948
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    60755.9,
                    18244.2
                  ],
                  [
                    60674.2,
                    18383.3
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60519.2,
                    18511.8
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60208,
                    18388.8
                  ],
                  [
                    60154.3,
                    18284.1
                  ],
                  [
                    59747,
                    18085.2
                  ]
                ],
                "id": 1765,
                "chat_link": "[&BOUGAAA=]"
              },
              "1766": {
                "name": "Festival Promenade",
                "level": 80,
                "coord": [
                  60851.2,
                  18645.6
                ],
                "bounds": [
                  [
                    60977.7,
                    18548.2
                  ],
                  [
                    60790.4,
                    18547.6
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60927.8,
                    18724.5
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    60977.7,
                    18548.2
                  ]
                ],
                "id": 1766,
                "chat_link": "[&BOYGAAA=]"
              },
              "1767": {
                "name": "Longeye's Landslide",
                "level": 80,
                "coord": [
                  59983.7,
                  18546.9
                ],
                "bounds": [
                  [
                    60000,
                    18805.5
                  ],
                  [
                    60100,
                    18745.8
                  ],
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60208,
                    18388.8
                  ],
                  [
                    60154.3,
                    18284.1
                  ],
                  [
                    59747,
                    18085.2
                  ],
                  [
                    59602.2,
                    18385
                  ],
                  [
                    59561.5,
                    18639.4
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60000,
                    18805.5
                  ]
                ],
                "id": 1767,
                "chat_link": "[&BOcGAAA=]"
              },
              "1768": {
                "name": "Doomlore Ruins",
                "level": 80,
                "coord": [
                  62211.3,
                  17975.1
                ],
                "bounds": [
                  [
                    61949.7,
                    17888.5
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    62143.7,
                    18281.3
                  ],
                  [
                    62336.9,
                    18317.8
                  ],
                  [
                    62497.1,
                    18324.3
                  ],
                  [
                    62486.3,
                    17799.2
                  ],
                  [
                    62343.5,
                    17692.6
                  ],
                  [
                    62129.8,
                    17681.4
                  ],
                  [
                    61991.5,
                    17641.1
                  ],
                  [
                    61949.7,
                    17888.5
                  ]
                ],
                "id": 1768,
                "chat_link": "[&BOgGAAA=]"
              },
              "1769": {
                "name": "Bitter Horn",
                "level": 80,
                "coord": [
                  59650.8,
                  19041.8
                ],
                "bounds": [
                  [
                    59561.5,
                    18639.4
                  ],
                  [
                    59433.2,
                    18865.3
                  ],
                  [
                    59428.2,
                    18997.3
                  ],
                  [
                    59476.5,
                    19222.8
                  ],
                  [
                    59629.3,
                    19273.3
                  ],
                  [
                    59790.4,
                    19254.6
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    59561.5,
                    18639.4
                  ]
                ],
                "id": 1769,
                "chat_link": "[&BOkGAAA=]"
              },
              "1770": {
                "name": "Sacnoth Stream",
                "level": 80,
                "coord": [
                  61613.2,
                  19314.9
                ],
                "bounds": [
                  [
                    61457.4,
                    19516.8
                  ],
                  [
                    61424.8,
                    19151.8
                  ],
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61542.1,
                    18693.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61703.3,
                    18988.7
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61719.9,
                    19428.8
                  ],
                  [
                    61710,
                    19584.1
                  ],
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61731.3,
                    19802
                  ],
                  [
                    61677,
                    19861.8
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61457.4,
                    19516.8
                  ]
                ],
                "id": 1770,
                "chat_link": "[&BOoGAAA=]"
              },
              "1771": {
                "name": "Devourer's Ridge",
                "level": 80,
                "coord": [
                  61333.6,
                  18577.6
                ],
                "bounds": [
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61484.5,
                    18298.5
                  ],
                  [
                    61581.4,
                    18421.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61542.1,
                    18693.8
                  ],
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61269,
                    18848.6
                  ],
                  [
                    61229.5,
                    18831.9
                  ],
                  [
                    61180.6,
                    18729.1
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    61157.9,
                    18391.8
                  ],
                  [
                    61287,
                    18312.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ]
                ],
                "id": 1771,
                "chat_link": "[&BOsGAAA=]"
              },
              "1772": {
                "name": "Tribunes' Trench",
                "level": 80,
                "coord": [
                  60642.6,
                  19403.5
                ],
                "bounds": [
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60593.3,
                    18915.3
                  ],
                  [
                    60585.9,
                    19048.5
                  ],
                  [
                    60592.4,
                    19159.5
                  ],
                  [
                    60628.5,
                    19233.2
                  ],
                  [
                    60613.4,
                    19292.4
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60605.1,
                    19638
                  ],
                  [
                    60598.4,
                    19733.2
                  ],
                  [
                    60531.7,
                    19808
                  ],
                  [
                    60509.8,
                    19885.3
                  ],
                  [
                    60524.6,
                    19946.1
                  ],
                  [
                    60646.9,
                    19977.6
                  ],
                  [
                    60769,
                    19989
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60790.9,
                    19286.1
                  ],
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    60790.4,
                    18875.3
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60543.9,
                    18845.7
                  ]
                ],
                "id": 1772,
                "chat_link": "[&BOwGAAA=]"
              }
            },
            "adventures": [],
            "id": 1330,
            "mastery_points": [
              {
                "coord": [
                  62101.9,
                  19057.1
                ],
                "id": 484,
                "region": "Tundra"
              },
              {
                "coord": [
                  61386.5,
                  17776.9
                ],
                "id": 491,
                "region": "Tundra"
              }
            ]
          },
          "1331": {
            "name": "Strike Mission: Shiverpeaks Pass (Public)",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              60992,
              18784
            ],
            "map_rect": [
              [
                -36864,
                -30720
              ],
              [
                39936,
                30720
              ]
            ],
            "continent_rect": [
              [
                59392,
                17504
              ],
              [
                62592,
                20064
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1748": {
                "name": "Kralkatorrik's Emergence Zone",
                "level": 80,
                "coord": [
                  62036.1,
                  19519.6
                ],
                "bounds": [
                  [
                    61509.7,
                    19991.4
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61677,
                    19861.8
                  ],
                  [
                    61731.3,
                    19802
                  ],
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61959.5,
                    19543
                  ],
                  [
                    61997.5,
                    19467
                  ],
                  [
                    61956.5,
                    19357.1
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61966.3,
                    19176.7
                  ],
                  [
                    62018.3,
                    19088.5
                  ],
                  [
                    62109.8,
                    19001.5
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62271.7,
                    19052.4
                  ],
                  [
                    62512.3,
                    19181.8
                  ],
                  [
                    62498.6,
                    19733
                  ],
                  [
                    62452.5,
                    19868.9
                  ],
                  [
                    62360.4,
                    19934.6
                  ],
                  [
                    62236.4,
                    19964.3
                  ],
                  [
                    61509.7,
                    19991.4
                  ]
                ],
                "id": 1748,
                "chat_link": "[&BNQGAAA=]"
              },
              "1749": {
                "name": "Dalada Forest",
                "level": 80,
                "coord": [
                  61871.9,
                  18350.6
                ],
                "bounds": [
                  [
                    62449.5,
                    18644.4
                  ],
                  [
                    62497.1,
                    18324.3
                  ],
                  [
                    62336.9,
                    18317.8
                  ],
                  [
                    62143.7,
                    18281.3
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    61932,
                    18184
                  ],
                  [
                    61867.3,
                    18219.2
                  ],
                  [
                    61752.2,
                    18252.6
                  ],
                  [
                    61694.3,
                    18209.6
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61484.5,
                    18298.5
                  ],
                  [
                    61581.4,
                    18421.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61929.2,
                    18680.9
                  ],
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    62449.5,
                    18644.4
                  ]
                ],
                "id": 1749,
                "chat_link": "[&BNUGAAA=]"
              },
              "1750": {
                "name": "Burning Effigy",
                "level": 80,
                "coord": [
                  61154.9,
                  18232
                ],
                "bounds": [
                  [
                    61049.4,
                    17948
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61287,
                    18312.5
                  ],
                  [
                    61157.9,
                    18391.8
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    61022.7,
                    18354
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    61049.4,
                    17948
                  ]
                ],
                "id": 1750,
                "chat_link": "[&BNYGAAA=]"
              },
              "1751": {
                "name": "The Ooze Pit",
                "level": 80,
                "coord": [
                  61133.5,
                  19807.8
                ],
                "bounds": [
                  [
                    60917.5,
                    20004.8
                  ],
                  [
                    60769,
                    19989
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60907.3,
                    19651.3
                  ],
                  [
                    61043,
                    19603
                  ],
                  [
                    61238,
                    19606.6
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61509.7,
                    19991.4
                  ],
                  [
                    61179,
                    20032.4
                  ],
                  [
                    60917.5,
                    20004.8
                  ]
                ],
                "id": 1751,
                "chat_link": "[&BNcGAAA=]"
              },
              "1752": {
                "name": "Flame Legion Camp",
                "level": 80,
                "coord": [
                  60855.8,
                  18398.5
                ],
                "bounds": [
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    60977.7,
                    18548.2
                  ],
                  [
                    60790.4,
                    18547.6
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60674.2,
                    18383.3
                  ],
                  [
                    60755.9,
                    18244.2
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    61022.7,
                    18354
                  ],
                  [
                    61042.5,
                    18468.2
                  ]
                ],
                "id": 1752,
                "chat_link": "[&BNgGAAA=]"
              },
              "1753": {
                "name": "Shiverpeaks Pass",
                "level": 80,
                "coord": [
                  59772.3,
                  19582.9
                ],
                "bounds": [
                  [
                    59476.5,
                    19222.8
                  ],
                  [
                    59510,
                    19899.3
                  ],
                  [
                    59599.8,
                    19971.5
                  ],
                  [
                    59778.1,
                    19980.2
                  ],
                  [
                    60007.6,
                    19908.3
                  ],
                  [
                    60011.2,
                    19720.1
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59790.4,
                    19254.6
                  ],
                  [
                    59629.3,
                    19273.3
                  ],
                  [
                    59476.5,
                    19222.8
                  ]
                ],
                "id": 1753,
                "chat_link": "[&BNkGAAA=]"
              },
              "1754": {
                "name": "Shattered Steppes",
                "level": 80,
                "coord": [
                  61979.3,
                  19016.7
                ],
                "bounds": [
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    61929.2,
                    18680.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61703.3,
                    18988.7
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61809,
                    19299.3
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61966.3,
                    19176.7
                  ],
                  [
                    62018.3,
                    19088.5
                  ],
                  [
                    62109.8,
                    19001.5
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62315.6,
                    18861.1
                  ],
                  [
                    62319.6,
                    18766.6
                  ]
                ],
                "id": 1754,
                "chat_link": "[&BNoGAAA=]"
              },
              "1755": {
                "name": "The Crag",
                "level": 80,
                "coord": [
                  61836.3,
                  19441.7
                ],
                "bounds": [
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61710,
                    19584.1
                  ],
                  [
                    61719.9,
                    19428.8
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61809,
                    19299.3
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61956.5,
                    19357.1
                  ],
                  [
                    61997.5,
                    19467
                  ],
                  [
                    61959.5,
                    19543
                  ],
                  [
                    61738.7,
                    19669.8
                  ]
                ],
                "id": 1755,
                "chat_link": "[&BNsGAAA=]"
              },
              "1756": {
                "name": "The Wardowns",
                "level": 80,
                "coord": [
                  61143.4,
                  19167.6
                ],
                "bounds": [
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61424.8,
                    19151.8
                  ],
                  [
                    61457.4,
                    19516.8
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61238,
                    19606.6
                  ],
                  [
                    61043,
                    19603
                  ],
                  [
                    60907.3,
                    19651.3
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60790.9,
                    19286.1
                  ],
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    61053.9,
                    19052
                  ],
                  [
                    61106.6,
                    19007.5
                  ],
                  [
                    61128.9,
                    18918.3
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61180.6,
                    18729.1
                  ],
                  [
                    61229.5,
                    18831.9
                  ],
                  [
                    61269,
                    18848.6
                  ],
                  [
                    61479.4,
                    18887.6
                  ]
                ],
                "id": 1756,
                "chat_link": "[&BNwGAAA=]"
              },
              "1758": {
                "name": "Khan-Ur's Gauntlet",
                "level": 80,
                "coord": [
                  61184.5,
                  17740.4
                ],
                "bounds": [
                  [
                    60794.8,
                    17540.8
                  ],
                  [
                    60619,
                    17566
                  ],
                  [
                    60554.9,
                    17795.3
                  ],
                  [
                    60919.4,
                    17818.7
                  ],
                  [
                    61049.4,
                    17948
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61598.2,
                    17890.5
                  ],
                  [
                    61615.8,
                    17565.2
                  ],
                  [
                    61511.5,
                    17546.7
                  ],
                  [
                    61381.3,
                    17532.9
                  ],
                  [
                    60794.8,
                    17540.8
                  ]
                ],
                "id": 1758,
                "chat_link": "[&BN4GAAA=]"
              },
              "1759": {
                "name": "Training Grounds",
                "level": 80,
                "coord": [
                  60345.7,
                  19735.4
                ],
                "bounds": [
                  [
                    60605.1,
                    19638
                  ],
                  [
                    60598.4,
                    19733.2
                  ],
                  [
                    60531.7,
                    19808
                  ],
                  [
                    60509.8,
                    19885.3
                  ],
                  [
                    60524.6,
                    19946.1
                  ],
                  [
                    60456.2,
                    19955.2
                  ],
                  [
                    60159.5,
                    19992.2
                  ],
                  [
                    60007.6,
                    19908.3
                  ],
                  [
                    60011.2,
                    19720.1
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60605.1,
                    19638
                  ]
                ],
                "id": 1759,
                "chat_link": "[&BN8GAAA=]"
              },
              "1760": {
                "name": "Upper Blood Keep",
                "level": 80,
                "coord": [
                  60155.1,
                  19085.3
                ],
                "bounds": [
                  [
                    60091.5,
                    18871.4
                  ],
                  [
                    60227.8,
                    18872.8
                  ],
                  [
                    60230.6,
                    18943
                  ],
                  [
                    60334.3,
                    18943.7
                  ],
                  [
                    60333.1,
                    19254.5
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60091.5,
                    18871.4
                  ]
                ],
                "id": 1760,
                "chat_link": "[&BOAGAAA=]"
              },
              "1761": {
                "name": "The Overlook",
                "level": 80,
                "coord": [
                  62368.5,
                  18902.8
                ],
                "bounds": [
                  [
                    62506.5,
                    18819.5
                  ],
                  [
                    62449.5,
                    18644.4
                  ],
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    62315.6,
                    18861.1
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62271.7,
                    19052.4
                  ],
                  [
                    62512.3,
                    19181.8
                  ],
                  [
                    62506.5,
                    18819.5
                  ]
                ],
                "id": 1761,
                "chat_link": "[&BOEGAAA=]"
              },
              "1762": {
                "name": "The Brig",
                "level": 80,
                "coord": [
                  60432.6,
                  18634.6
                ],
                "bounds": [
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60519.2,
                    18511.8
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60259.2,
                    18709.5
                  ]
                ],
                "id": 1762,
                "chat_link": "[&BOIGAAA=]"
              },
              "1763": {
                "name": "Iron Legion Camp",
                "level": 80,
                "coord": [
                  60966.6,
                  18905
                ],
                "bounds": [
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    61053.9,
                    19052
                  ],
                  [
                    61106.6,
                    19007.5
                  ],
                  [
                    61128.9,
                    18918.3
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    60927.8,
                    18724.5
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60790.4,
                    18875.3
                  ],
                  [
                    60872.3,
                    19101.9
                  ]
                ],
                "id": 1763,
                "chat_link": "[&BOMGAAA=]"
              },
              "1764": {
                "name": "Lower Blood Keep",
                "level": 80,
                "coord": [
                  60343.8,
                  19021.2
                ],
                "bounds": [
                  [
                    60000,
                    18805.5
                  ],
                  [
                    60100,
                    18745.8
                  ],
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60593.3,
                    18915.3
                  ],
                  [
                    60585.9,
                    19048.5
                  ],
                  [
                    60592.4,
                    19159.5
                  ],
                  [
                    60628.5,
                    19233.2
                  ],
                  [
                    60613.4,
                    19292.4
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    60333.1,
                    19254.5
                  ],
                  [
                    60334.3,
                    18943.7
                  ],
                  [
                    60230.6,
                    18943
                  ],
                  [
                    60227.8,
                    18872.8
                  ],
                  [
                    60091.5,
                    18871.4
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60000,
                    18805.5
                  ]
                ],
                "id": 1764,
                "chat_link": "[&BOQGAAA=]"
              },
              "1765": {
                "name": "Rusty Meadows",
                "level": 80,
                "coord": [
                  60483.3,
                  18144.7
                ],
                "bounds": [
                  [
                    59747,
                    18085.2
                  ],
                  [
                    59909.8,
                    17877.5
                  ],
                  [
                    60197.3,
                    17663.5
                  ],
                  [
                    60619,
                    17566
                  ],
                  [
                    60554.9,
                    17795.3
                  ],
                  [
                    60919.4,
                    17818.7
                  ],
                  [
                    61049.4,
                    17948
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    60755.9,
                    18244.2
                  ],
                  [
                    60674.2,
                    18383.3
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60519.2,
                    18511.8
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60208,
                    18388.8
                  ],
                  [
                    60154.3,
                    18284.1
                  ],
                  [
                    59747,
                    18085.2
                  ]
                ],
                "id": 1765,
                "chat_link": "[&BOUGAAA=]"
              },
              "1766": {
                "name": "Festival Promenade",
                "level": 80,
                "coord": [
                  60851.2,
                  18645.6
                ],
                "bounds": [
                  [
                    60977.7,
                    18548.2
                  ],
                  [
                    60790.4,
                    18547.6
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60927.8,
                    18724.5
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    60977.7,
                    18548.2
                  ]
                ],
                "id": 1766,
                "chat_link": "[&BOYGAAA=]"
              },
              "1767": {
                "name": "Longeye's Landslide",
                "level": 80,
                "coord": [
                  59983.7,
                  18546.9
                ],
                "bounds": [
                  [
                    60000,
                    18805.5
                  ],
                  [
                    60100,
                    18745.8
                  ],
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60208,
                    18388.8
                  ],
                  [
                    60154.3,
                    18284.1
                  ],
                  [
                    59747,
                    18085.2
                  ],
                  [
                    59602.2,
                    18385
                  ],
                  [
                    59561.5,
                    18639.4
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60000,
                    18805.5
                  ]
                ],
                "id": 1767,
                "chat_link": "[&BOcGAAA=]"
              },
              "1768": {
                "name": "Doomlore Ruins",
                "level": 80,
                "coord": [
                  62211.3,
                  17975.1
                ],
                "bounds": [
                  [
                    61949.7,
                    17888.5
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    62143.7,
                    18281.3
                  ],
                  [
                    62336.9,
                    18317.8
                  ],
                  [
                    62497.1,
                    18324.3
                  ],
                  [
                    62486.3,
                    17799.2
                  ],
                  [
                    62343.5,
                    17692.6
                  ],
                  [
                    62129.8,
                    17681.4
                  ],
                  [
                    61991.5,
                    17641.1
                  ],
                  [
                    61949.7,
                    17888.5
                  ]
                ],
                "id": 1768,
                "chat_link": "[&BOgGAAA=]"
              },
              "1769": {
                "name": "Bitter Horn",
                "level": 80,
                "coord": [
                  59650.8,
                  19041.8
                ],
                "bounds": [
                  [
                    59561.5,
                    18639.4
                  ],
                  [
                    59433.2,
                    18865.3
                  ],
                  [
                    59428.2,
                    18997.3
                  ],
                  [
                    59476.5,
                    19222.8
                  ],
                  [
                    59629.3,
                    19273.3
                  ],
                  [
                    59790.4,
                    19254.6
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    59561.5,
                    18639.4
                  ]
                ],
                "id": 1769,
                "chat_link": "[&BOkGAAA=]"
              },
              "1770": {
                "name": "Sacnoth Stream",
                "level": 80,
                "coord": [
                  61613.2,
                  19314.9
                ],
                "bounds": [
                  [
                    61457.4,
                    19516.8
                  ],
                  [
                    61424.8,
                    19151.8
                  ],
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61542.1,
                    18693.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61703.3,
                    18988.7
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61719.9,
                    19428.8
                  ],
                  [
                    61710,
                    19584.1
                  ],
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61731.3,
                    19802
                  ],
                  [
                    61677,
                    19861.8
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61457.4,
                    19516.8
                  ]
                ],
                "id": 1770,
                "chat_link": "[&BOoGAAA=]"
              },
              "1771": {
                "name": "Devourer's Ridge",
                "level": 80,
                "coord": [
                  61333.6,
                  18577.6
                ],
                "bounds": [
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61484.5,
                    18298.5
                  ],
                  [
                    61581.4,
                    18421.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61542.1,
                    18693.8
                  ],
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61269,
                    18848.6
                  ],
                  [
                    61229.5,
                    18831.9
                  ],
                  [
                    61180.6,
                    18729.1
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    61157.9,
                    18391.8
                  ],
                  [
                    61287,
                    18312.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ]
                ],
                "id": 1771,
                "chat_link": "[&BOsGAAA=]"
              },
              "1772": {
                "name": "Tribunes' Trench",
                "level": 80,
                "coord": [
                  60642.6,
                  19403.5
                ],
                "bounds": [
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60593.3,
                    18915.3
                  ],
                  [
                    60585.9,
                    19048.5
                  ],
                  [
                    60592.4,
                    19159.5
                  ],
                  [
                    60628.5,
                    19233.2
                  ],
                  [
                    60613.4,
                    19292.4
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60605.1,
                    19638
                  ],
                  [
                    60598.4,
                    19733.2
                  ],
                  [
                    60531.7,
                    19808
                  ],
                  [
                    60509.8,
                    19885.3
                  ],
                  [
                    60524.6,
                    19946.1
                  ],
                  [
                    60646.9,
                    19977.6
                  ],
                  [
                    60769,
                    19989
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60790.9,
                    19286.1
                  ],
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    60790.4,
                    18875.3
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60543.9,
                    18845.7
                  ]
                ],
                "id": 1772,
                "chat_link": "[&BOwGAAA=]"
              }
            },
            "adventures": [],
            "id": 1331,
            "mastery_points": []
          },
          "1332": {
            "name": "Strike Mission: Shiverpeaks Pass (Squad)",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              60992,
              18784
            ],
            "map_rect": [
              [
                -36864,
                -30720
              ],
              [
                39936,
                30720
              ]
            ],
            "continent_rect": [
              [
                59392,
                17504
              ],
              [
                62592,
                20064
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1748": {
                "name": "Kralkatorrik's Emergence Zone",
                "level": 80,
                "coord": [
                  62036.1,
                  19519.6
                ],
                "bounds": [
                  [
                    61509.7,
                    19991.4
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61677,
                    19861.8
                  ],
                  [
                    61731.3,
                    19802
                  ],
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61959.5,
                    19543
                  ],
                  [
                    61997.5,
                    19467
                  ],
                  [
                    61956.5,
                    19357.1
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61966.3,
                    19176.7
                  ],
                  [
                    62018.3,
                    19088.5
                  ],
                  [
                    62109.8,
                    19001.5
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62271.7,
                    19052.4
                  ],
                  [
                    62512.3,
                    19181.8
                  ],
                  [
                    62498.6,
                    19733
                  ],
                  [
                    62452.5,
                    19868.9
                  ],
                  [
                    62360.4,
                    19934.6
                  ],
                  [
                    62236.4,
                    19964.3
                  ],
                  [
                    61509.7,
                    19991.4
                  ]
                ],
                "id": 1748,
                "chat_link": "[&BNQGAAA=]"
              },
              "1749": {
                "name": "Dalada Forest",
                "level": 80,
                "coord": [
                  61871.9,
                  18350.6
                ],
                "bounds": [
                  [
                    62449.5,
                    18644.4
                  ],
                  [
                    62497.1,
                    18324.3
                  ],
                  [
                    62336.9,
                    18317.8
                  ],
                  [
                    62143.7,
                    18281.3
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    61932,
                    18184
                  ],
                  [
                    61867.3,
                    18219.2
                  ],
                  [
                    61752.2,
                    18252.6
                  ],
                  [
                    61694.3,
                    18209.6
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61484.5,
                    18298.5
                  ],
                  [
                    61581.4,
                    18421.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61929.2,
                    18680.9
                  ],
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    62449.5,
                    18644.4
                  ]
                ],
                "id": 1749,
                "chat_link": "[&BNUGAAA=]"
              },
              "1750": {
                "name": "Burning Effigy",
                "level": 80,
                "coord": [
                  61154.9,
                  18232
                ],
                "bounds": [
                  [
                    61049.4,
                    17948
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61287,
                    18312.5
                  ],
                  [
                    61157.9,
                    18391.8
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    61022.7,
                    18354
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    61049.4,
                    17948
                  ]
                ],
                "id": 1750,
                "chat_link": "[&BNYGAAA=]"
              },
              "1751": {
                "name": "The Ooze Pit",
                "level": 80,
                "coord": [
                  61133.5,
                  19807.8
                ],
                "bounds": [
                  [
                    60917.5,
                    20004.8
                  ],
                  [
                    60769,
                    19989
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60907.3,
                    19651.3
                  ],
                  [
                    61043,
                    19603
                  ],
                  [
                    61238,
                    19606.6
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61509.7,
                    19991.4
                  ],
                  [
                    61179,
                    20032.4
                  ],
                  [
                    60917.5,
                    20004.8
                  ]
                ],
                "id": 1751,
                "chat_link": "[&BNcGAAA=]"
              },
              "1752": {
                "name": "Flame Legion Camp",
                "level": 80,
                "coord": [
                  60855.8,
                  18398.5
                ],
                "bounds": [
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    60977.7,
                    18548.2
                  ],
                  [
                    60790.4,
                    18547.6
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60674.2,
                    18383.3
                  ],
                  [
                    60755.9,
                    18244.2
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    61022.7,
                    18354
                  ],
                  [
                    61042.5,
                    18468.2
                  ]
                ],
                "id": 1752,
                "chat_link": "[&BNgGAAA=]"
              },
              "1753": {
                "name": "Shiverpeaks Pass",
                "level": 80,
                "coord": [
                  59772.3,
                  19582.9
                ],
                "bounds": [
                  [
                    59476.5,
                    19222.8
                  ],
                  [
                    59510,
                    19899.3
                  ],
                  [
                    59599.8,
                    19971.5
                  ],
                  [
                    59778.1,
                    19980.2
                  ],
                  [
                    60007.6,
                    19908.3
                  ],
                  [
                    60011.2,
                    19720.1
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59790.4,
                    19254.6
                  ],
                  [
                    59629.3,
                    19273.3
                  ],
                  [
                    59476.5,
                    19222.8
                  ]
                ],
                "id": 1753,
                "chat_link": "[&BNkGAAA=]"
              },
              "1754": {
                "name": "Shattered Steppes",
                "level": 80,
                "coord": [
                  61979.3,
                  19016.7
                ],
                "bounds": [
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    61929.2,
                    18680.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61703.3,
                    18988.7
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61809,
                    19299.3
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61966.3,
                    19176.7
                  ],
                  [
                    62018.3,
                    19088.5
                  ],
                  [
                    62109.8,
                    19001.5
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62315.6,
                    18861.1
                  ],
                  [
                    62319.6,
                    18766.6
                  ]
                ],
                "id": 1754,
                "chat_link": "[&BNoGAAA=]"
              },
              "1755": {
                "name": "The Crag",
                "level": 80,
                "coord": [
                  61836.3,
                  19441.7
                ],
                "bounds": [
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61710,
                    19584.1
                  ],
                  [
                    61719.9,
                    19428.8
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61809,
                    19299.3
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61956.5,
                    19357.1
                  ],
                  [
                    61997.5,
                    19467
                  ],
                  [
                    61959.5,
                    19543
                  ],
                  [
                    61738.7,
                    19669.8
                  ]
                ],
                "id": 1755,
                "chat_link": "[&BNsGAAA=]"
              },
              "1756": {
                "name": "The Wardowns",
                "level": 80,
                "coord": [
                  61143.4,
                  19167.6
                ],
                "bounds": [
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61424.8,
                    19151.8
                  ],
                  [
                    61457.4,
                    19516.8
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61238,
                    19606.6
                  ],
                  [
                    61043,
                    19603
                  ],
                  [
                    60907.3,
                    19651.3
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60790.9,
                    19286.1
                  ],
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    61053.9,
                    19052
                  ],
                  [
                    61106.6,
                    19007.5
                  ],
                  [
                    61128.9,
                    18918.3
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61180.6,
                    18729.1
                  ],
                  [
                    61229.5,
                    18831.9
                  ],
                  [
                    61269,
                    18848.6
                  ],
                  [
                    61479.4,
                    18887.6
                  ]
                ],
                "id": 1756,
                "chat_link": "[&BNwGAAA=]"
              },
              "1758": {
                "name": "Khan-Ur's Gauntlet",
                "level": 80,
                "coord": [
                  61184.5,
                  17740.4
                ],
                "bounds": [
                  [
                    60794.8,
                    17540.8
                  ],
                  [
                    60619,
                    17566
                  ],
                  [
                    60554.9,
                    17795.3
                  ],
                  [
                    60919.4,
                    17818.7
                  ],
                  [
                    61049.4,
                    17948
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61598.2,
                    17890.5
                  ],
                  [
                    61615.8,
                    17565.2
                  ],
                  [
                    61511.5,
                    17546.7
                  ],
                  [
                    61381.3,
                    17532.9
                  ],
                  [
                    60794.8,
                    17540.8
                  ]
                ],
                "id": 1758,
                "chat_link": "[&BN4GAAA=]"
              },
              "1759": {
                "name": "Training Grounds",
                "level": 80,
                "coord": [
                  60345.7,
                  19735.4
                ],
                "bounds": [
                  [
                    60605.1,
                    19638
                  ],
                  [
                    60598.4,
                    19733.2
                  ],
                  [
                    60531.7,
                    19808
                  ],
                  [
                    60509.8,
                    19885.3
                  ],
                  [
                    60524.6,
                    19946.1
                  ],
                  [
                    60456.2,
                    19955.2
                  ],
                  [
                    60159.5,
                    19992.2
                  ],
                  [
                    60007.6,
                    19908.3
                  ],
                  [
                    60011.2,
                    19720.1
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60605.1,
                    19638
                  ]
                ],
                "id": 1759,
                "chat_link": "[&BN8GAAA=]"
              },
              "1760": {
                "name": "Upper Blood Keep",
                "level": 80,
                "coord": [
                  60155.1,
                  19085.3
                ],
                "bounds": [
                  [
                    60091.5,
                    18871.4
                  ],
                  [
                    60227.8,
                    18872.8
                  ],
                  [
                    60230.6,
                    18943
                  ],
                  [
                    60334.3,
                    18943.7
                  ],
                  [
                    60333.1,
                    19254.5
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60091.5,
                    18871.4
                  ]
                ],
                "id": 1760,
                "chat_link": "[&BOAGAAA=]"
              },
              "1761": {
                "name": "The Overlook",
                "level": 80,
                "coord": [
                  62368.5,
                  18902.8
                ],
                "bounds": [
                  [
                    62506.5,
                    18819.5
                  ],
                  [
                    62449.5,
                    18644.4
                  ],
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    62315.6,
                    18861.1
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62271.7,
                    19052.4
                  ],
                  [
                    62512.3,
                    19181.8
                  ],
                  [
                    62506.5,
                    18819.5
                  ]
                ],
                "id": 1761,
                "chat_link": "[&BOEGAAA=]"
              },
              "1762": {
                "name": "The Brig",
                "level": 80,
                "coord": [
                  60432.6,
                  18634.6
                ],
                "bounds": [
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60519.2,
                    18511.8
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60259.2,
                    18709.5
                  ]
                ],
                "id": 1762,
                "chat_link": "[&BOIGAAA=]"
              },
              "1763": {
                "name": "Iron Legion Camp",
                "level": 80,
                "coord": [
                  60966.6,
                  18905
                ],
                "bounds": [
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    61053.9,
                    19052
                  ],
                  [
                    61106.6,
                    19007.5
                  ],
                  [
                    61128.9,
                    18918.3
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    60927.8,
                    18724.5
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60790.4,
                    18875.3
                  ],
                  [
                    60872.3,
                    19101.9
                  ]
                ],
                "id": 1763,
                "chat_link": "[&BOMGAAA=]"
              },
              "1764": {
                "name": "Lower Blood Keep",
                "level": 80,
                "coord": [
                  60343.8,
                  19021.2
                ],
                "bounds": [
                  [
                    60000,
                    18805.5
                  ],
                  [
                    60100,
                    18745.8
                  ],
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60593.3,
                    18915.3
                  ],
                  [
                    60585.9,
                    19048.5
                  ],
                  [
                    60592.4,
                    19159.5
                  ],
                  [
                    60628.5,
                    19233.2
                  ],
                  [
                    60613.4,
                    19292.4
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    60333.1,
                    19254.5
                  ],
                  [
                    60334.3,
                    18943.7
                  ],
                  [
                    60230.6,
                    18943
                  ],
                  [
                    60227.8,
                    18872.8
                  ],
                  [
                    60091.5,
                    18871.4
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60000,
                    18805.5
                  ]
                ],
                "id": 1764,
                "chat_link": "[&BOQGAAA=]"
              },
              "1765": {
                "name": "Rusty Meadows",
                "level": 80,
                "coord": [
                  60483.3,
                  18144.7
                ],
                "bounds": [
                  [
                    59747,
                    18085.2
                  ],
                  [
                    59909.8,
                    17877.5
                  ],
                  [
                    60197.3,
                    17663.5
                  ],
                  [
                    60619,
                    17566
                  ],
                  [
                    60554.9,
                    17795.3
                  ],
                  [
                    60919.4,
                    17818.7
                  ],
                  [
                    61049.4,
                    17948
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    60755.9,
                    18244.2
                  ],
                  [
                    60674.2,
                    18383.3
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60519.2,
                    18511.8
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60208,
                    18388.8
                  ],
                  [
                    60154.3,
                    18284.1
                  ],
                  [
                    59747,
                    18085.2
                  ]
                ],
                "id": 1765,
                "chat_link": "[&BOUGAAA=]"
              },
              "1766": {
                "name": "Festival Promenade",
                "level": 80,
                "coord": [
                  60851.2,
                  18645.6
                ],
                "bounds": [
                  [
                    60977.7,
                    18548.2
                  ],
                  [
                    60790.4,
                    18547.6
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60927.8,
                    18724.5
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    60977.7,
                    18548.2
                  ]
                ],
                "id": 1766,
                "chat_link": "[&BOYGAAA=]"
              },
              "1767": {
                "name": "Longeye's Landslide",
                "level": 80,
                "coord": [
                  59983.7,
                  18546.9
                ],
                "bounds": [
                  [
                    60000,
                    18805.5
                  ],
                  [
                    60100,
                    18745.8
                  ],
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60208,
                    18388.8
                  ],
                  [
                    60154.3,
                    18284.1
                  ],
                  [
                    59747,
                    18085.2
                  ],
                  [
                    59602.2,
                    18385
                  ],
                  [
                    59561.5,
                    18639.4
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60000,
                    18805.5
                  ]
                ],
                "id": 1767,
                "chat_link": "[&BOcGAAA=]"
              },
              "1768": {
                "name": "Doomlore Ruins",
                "level": 80,
                "coord": [
                  62211.3,
                  17975.1
                ],
                "bounds": [
                  [
                    61949.7,
                    17888.5
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    62143.7,
                    18281.3
                  ],
                  [
                    62336.9,
                    18317.8
                  ],
                  [
                    62497.1,
                    18324.3
                  ],
                  [
                    62486.3,
                    17799.2
                  ],
                  [
                    62343.5,
                    17692.6
                  ],
                  [
                    62129.8,
                    17681.4
                  ],
                  [
                    61991.5,
                    17641.1
                  ],
                  [
                    61949.7,
                    17888.5
                  ]
                ],
                "id": 1768,
                "chat_link": "[&BOgGAAA=]"
              },
              "1769": {
                "name": "Bitter Horn",
                "level": 80,
                "coord": [
                  59650.8,
                  19041.8
                ],
                "bounds": [
                  [
                    59561.5,
                    18639.4
                  ],
                  [
                    59433.2,
                    18865.3
                  ],
                  [
                    59428.2,
                    18997.3
                  ],
                  [
                    59476.5,
                    19222.8
                  ],
                  [
                    59629.3,
                    19273.3
                  ],
                  [
                    59790.4,
                    19254.6
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    59561.5,
                    18639.4
                  ]
                ],
                "id": 1769,
                "chat_link": "[&BOkGAAA=]"
              },
              "1770": {
                "name": "Sacnoth Stream",
                "level": 80,
                "coord": [
                  61613.2,
                  19314.9
                ],
                "bounds": [
                  [
                    61457.4,
                    19516.8
                  ],
                  [
                    61424.8,
                    19151.8
                  ],
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61542.1,
                    18693.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61703.3,
                    18988.7
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61719.9,
                    19428.8
                  ],
                  [
                    61710,
                    19584.1
                  ],
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61731.3,
                    19802
                  ],
                  [
                    61677,
                    19861.8
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61457.4,
                    19516.8
                  ]
                ],
                "id": 1770,
                "chat_link": "[&BOoGAAA=]"
              },
              "1771": {
                "name": "Devourer's Ridge",
                "level": 80,
                "coord": [
                  61333.6,
                  18577.6
                ],
                "bounds": [
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61484.5,
                    18298.5
                  ],
                  [
                    61581.4,
                    18421.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61542.1,
                    18693.8
                  ],
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61269,
                    18848.6
                  ],
                  [
                    61229.5,
                    18831.9
                  ],
                  [
                    61180.6,
                    18729.1
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    61157.9,
                    18391.8
                  ],
                  [
                    61287,
                    18312.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ]
                ],
                "id": 1771,
                "chat_link": "[&BOsGAAA=]"
              },
              "1772": {
                "name": "Tribunes' Trench",
                "level": 80,
                "coord": [
                  60642.6,
                  19403.5
                ],
                "bounds": [
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60593.3,
                    18915.3
                  ],
                  [
                    60585.9,
                    19048.5
                  ],
                  [
                    60592.4,
                    19159.5
                  ],
                  [
                    60628.5,
                    19233.2
                  ],
                  [
                    60613.4,
                    19292.4
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60605.1,
                    19638
                  ],
                  [
                    60598.4,
                    19733.2
                  ],
                  [
                    60531.7,
                    19808
                  ],
                  [
                    60509.8,
                    19885.3
                  ],
                  [
                    60524.6,
                    19946.1
                  ],
                  [
                    60646.9,
                    19977.6
                  ],
                  [
                    60769,
                    19989
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60790.9,
                    19286.1
                  ],
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    60790.4,
                    18875.3
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60543.9,
                    18845.7
                  ]
                ],
                "id": 1772,
                "chat_link": "[&BOwGAAA=]"
              }
            },
            "id": 1332,
            "mastery_points": [],
            "adventures": []
          },
          "1334": {
            "name": "Deeper and Deeper",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              60992,
              18784
            ],
            "map_rect": [
              [
                -36864,
                -30720
              ],
              [
                39936,
                30720
              ]
            ],
            "continent_rect": [
              [
                59392,
                17504
              ],
              [
                62592,
                20064
              ]
            ],
            "points_of_interest": {
              "3084": {
                "name": "War Room",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60125.9,
                  19121.6
                ],
                "id": 3084,
                "chat_link": "[&BAwMAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1748": {
                "name": "Kralkatorrik's Emergence Zone",
                "level": 80,
                "coord": [
                  62036.1,
                  19519.6
                ],
                "bounds": [
                  [
                    61509.7,
                    19991.4
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61677,
                    19861.8
                  ],
                  [
                    61731.3,
                    19802
                  ],
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61959.5,
                    19543
                  ],
                  [
                    61997.5,
                    19467
                  ],
                  [
                    61956.5,
                    19357.1
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61966.3,
                    19176.7
                  ],
                  [
                    62018.3,
                    19088.5
                  ],
                  [
                    62109.8,
                    19001.5
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62271.7,
                    19052.4
                  ],
                  [
                    62512.3,
                    19181.8
                  ],
                  [
                    62498.6,
                    19733
                  ],
                  [
                    62452.5,
                    19868.9
                  ],
                  [
                    62360.4,
                    19934.6
                  ],
                  [
                    62236.4,
                    19964.3
                  ],
                  [
                    61509.7,
                    19991.4
                  ]
                ],
                "id": 1748,
                "chat_link": "[&BNQGAAA=]"
              },
              "1749": {
                "name": "Dalada Forest",
                "level": 80,
                "coord": [
                  61871.9,
                  18350.6
                ],
                "bounds": [
                  [
                    62449.5,
                    18644.4
                  ],
                  [
                    62497.1,
                    18324.3
                  ],
                  [
                    62336.9,
                    18317.8
                  ],
                  [
                    62143.7,
                    18281.3
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    61932,
                    18184
                  ],
                  [
                    61867.3,
                    18219.2
                  ],
                  [
                    61752.2,
                    18252.6
                  ],
                  [
                    61694.3,
                    18209.6
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61484.5,
                    18298.5
                  ],
                  [
                    61581.4,
                    18421.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61929.2,
                    18680.9
                  ],
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    62449.5,
                    18644.4
                  ]
                ],
                "id": 1749,
                "chat_link": "[&BNUGAAA=]"
              },
              "1750": {
                "name": "Burning Effigy",
                "level": 80,
                "coord": [
                  61154.9,
                  18232
                ],
                "bounds": [
                  [
                    61049.4,
                    17948
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61287,
                    18312.5
                  ],
                  [
                    61157.9,
                    18391.8
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    61022.7,
                    18354
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    61049.4,
                    17948
                  ]
                ],
                "id": 1750,
                "chat_link": "[&BNYGAAA=]"
              },
              "1751": {
                "name": "The Ooze Pit",
                "level": 80,
                "coord": [
                  61133.5,
                  19807.8
                ],
                "bounds": [
                  [
                    60917.5,
                    20004.8
                  ],
                  [
                    60769,
                    19989
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60907.3,
                    19651.3
                  ],
                  [
                    61043,
                    19603
                  ],
                  [
                    61238,
                    19606.6
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61509.7,
                    19991.4
                  ],
                  [
                    61179,
                    20032.4
                  ],
                  [
                    60917.5,
                    20004.8
                  ]
                ],
                "id": 1751,
                "chat_link": "[&BNcGAAA=]"
              },
              "1752": {
                "name": "Flame Legion Camp",
                "level": 80,
                "coord": [
                  60855.8,
                  18398.5
                ],
                "bounds": [
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    60977.7,
                    18548.2
                  ],
                  [
                    60790.4,
                    18547.6
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60674.2,
                    18383.3
                  ],
                  [
                    60755.9,
                    18244.2
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    61022.7,
                    18354
                  ],
                  [
                    61042.5,
                    18468.2
                  ]
                ],
                "id": 1752,
                "chat_link": "[&BNgGAAA=]"
              },
              "1753": {
                "name": "Shiverpeaks Pass",
                "level": 80,
                "coord": [
                  59772.3,
                  19582.9
                ],
                "bounds": [
                  [
                    59476.5,
                    19222.8
                  ],
                  [
                    59510,
                    19899.3
                  ],
                  [
                    59599.8,
                    19971.5
                  ],
                  [
                    59778.1,
                    19980.2
                  ],
                  [
                    60007.6,
                    19908.3
                  ],
                  [
                    60011.2,
                    19720.1
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59790.4,
                    19254.6
                  ],
                  [
                    59629.3,
                    19273.3
                  ],
                  [
                    59476.5,
                    19222.8
                  ]
                ],
                "id": 1753,
                "chat_link": "[&BNkGAAA=]"
              },
              "1754": {
                "name": "Shattered Steppes",
                "level": 80,
                "coord": [
                  61979.3,
                  19016.7
                ],
                "bounds": [
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    61929.2,
                    18680.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61703.3,
                    18988.7
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61809,
                    19299.3
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61966.3,
                    19176.7
                  ],
                  [
                    62018.3,
                    19088.5
                  ],
                  [
                    62109.8,
                    19001.5
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62315.6,
                    18861.1
                  ],
                  [
                    62319.6,
                    18766.6
                  ]
                ],
                "id": 1754,
                "chat_link": "[&BNoGAAA=]"
              },
              "1755": {
                "name": "The Crag",
                "level": 80,
                "coord": [
                  61836.3,
                  19441.7
                ],
                "bounds": [
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61710,
                    19584.1
                  ],
                  [
                    61719.9,
                    19428.8
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61809,
                    19299.3
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61956.5,
                    19357.1
                  ],
                  [
                    61997.5,
                    19467
                  ],
                  [
                    61959.5,
                    19543
                  ],
                  [
                    61738.7,
                    19669.8
                  ]
                ],
                "id": 1755,
                "chat_link": "[&BNsGAAA=]"
              },
              "1756": {
                "name": "The Wardowns",
                "level": 80,
                "coord": [
                  61143.4,
                  19167.6
                ],
                "bounds": [
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61424.8,
                    19151.8
                  ],
                  [
                    61457.4,
                    19516.8
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61238,
                    19606.6
                  ],
                  [
                    61043,
                    19603
                  ],
                  [
                    60907.3,
                    19651.3
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60790.9,
                    19286.1
                  ],
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    61053.9,
                    19052
                  ],
                  [
                    61106.6,
                    19007.5
                  ],
                  [
                    61128.9,
                    18918.3
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61180.6,
                    18729.1
                  ],
                  [
                    61229.5,
                    18831.9
                  ],
                  [
                    61269,
                    18848.6
                  ],
                  [
                    61479.4,
                    18887.6
                  ]
                ],
                "id": 1756,
                "chat_link": "[&BNwGAAA=]"
              },
              "1757": {
                "name": "Cavern of the Khan-Ur",
                "level": 80,
                "coord": [
                  61803.9,
                  18001.4
                ],
                "bounds": [
                  [
                    61615.8,
                    17565.2
                  ],
                  [
                    61598.2,
                    17890.5
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61694.3,
                    18209.6
                  ],
                  [
                    61752.2,
                    18252.6
                  ],
                  [
                    61867.3,
                    18219.2
                  ],
                  [
                    61932,
                    18184
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    61949.7,
                    17888.5
                  ],
                  [
                    61991.5,
                    17641.1
                  ],
                  [
                    61615.8,
                    17565.2
                  ]
                ],
                "id": 1757,
                "chat_link": "[&BN0GAAA=]"
              },
              "1758": {
                "name": "Khan-Ur's Gauntlet",
                "level": 80,
                "coord": [
                  61184.5,
                  17740.4
                ],
                "bounds": [
                  [
                    60794.8,
                    17540.8
                  ],
                  [
                    60619,
                    17566
                  ],
                  [
                    60554.9,
                    17795.3
                  ],
                  [
                    60919.4,
                    17818.7
                  ],
                  [
                    61049.4,
                    17948
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61598.2,
                    17890.5
                  ],
                  [
                    61615.8,
                    17565.2
                  ],
                  [
                    61511.5,
                    17546.7
                  ],
                  [
                    61381.3,
                    17532.9
                  ],
                  [
                    60794.8,
                    17540.8
                  ]
                ],
                "id": 1758,
                "chat_link": "[&BN4GAAA=]"
              },
              "1759": {
                "name": "Training Grounds",
                "level": 80,
                "coord": [
                  60345.7,
                  19735.4
                ],
                "bounds": [
                  [
                    60605.1,
                    19638
                  ],
                  [
                    60598.4,
                    19733.2
                  ],
                  [
                    60531.7,
                    19808
                  ],
                  [
                    60509.8,
                    19885.3
                  ],
                  [
                    60524.6,
                    19946.1
                  ],
                  [
                    60456.2,
                    19955.2
                  ],
                  [
                    60159.5,
                    19992.2
                  ],
                  [
                    60007.6,
                    19908.3
                  ],
                  [
                    60011.2,
                    19720.1
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60605.1,
                    19638
                  ]
                ],
                "id": 1759,
                "chat_link": "[&BN8GAAA=]"
              },
              "1760": {
                "name": "Upper Blood Keep",
                "level": 80,
                "coord": [
                  60155.1,
                  19085.3
                ],
                "bounds": [
                  [
                    60091.5,
                    18871.4
                  ],
                  [
                    60227.8,
                    18872.8
                  ],
                  [
                    60230.6,
                    18943
                  ],
                  [
                    60334.3,
                    18943.7
                  ],
                  [
                    60333.1,
                    19254.5
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60091.5,
                    18871.4
                  ]
                ],
                "id": 1760,
                "chat_link": "[&BOAGAAA=]"
              },
              "1761": {
                "name": "The Overlook",
                "level": 80,
                "coord": [
                  62368.5,
                  18902.8
                ],
                "bounds": [
                  [
                    62506.5,
                    18819.5
                  ],
                  [
                    62449.5,
                    18644.4
                  ],
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    62315.6,
                    18861.1
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62271.7,
                    19052.4
                  ],
                  [
                    62512.3,
                    19181.8
                  ],
                  [
                    62506.5,
                    18819.5
                  ]
                ],
                "id": 1761,
                "chat_link": "[&BOEGAAA=]"
              },
              "1762": {
                "name": "The Brig",
                "level": 80,
                "coord": [
                  60432.6,
                  18634.6
                ],
                "bounds": [
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60519.2,
                    18511.8
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60259.2,
                    18709.5
                  ]
                ],
                "id": 1762,
                "chat_link": "[&BOIGAAA=]"
              },
              "1763": {
                "name": "Iron Legion Camp",
                "level": 80,
                "coord": [
                  60966.6,
                  18905
                ],
                "bounds": [
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    61053.9,
                    19052
                  ],
                  [
                    61106.6,
                    19007.5
                  ],
                  [
                    61128.9,
                    18918.3
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    60927.8,
                    18724.5
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60790.4,
                    18875.3
                  ],
                  [
                    60872.3,
                    19101.9
                  ]
                ],
                "id": 1763,
                "chat_link": "[&BOMGAAA=]"
              },
              "1764": {
                "name": "Lower Blood Keep",
                "level": 80,
                "coord": [
                  60343.8,
                  19021.2
                ],
                "bounds": [
                  [
                    60000,
                    18805.5
                  ],
                  [
                    60100,
                    18745.8
                  ],
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60593.3,
                    18915.3
                  ],
                  [
                    60585.9,
                    19048.5
                  ],
                  [
                    60592.4,
                    19159.5
                  ],
                  [
                    60628.5,
                    19233.2
                  ],
                  [
                    60613.4,
                    19292.4
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    60333.1,
                    19254.5
                  ],
                  [
                    60334.3,
                    18943.7
                  ],
                  [
                    60230.6,
                    18943
                  ],
                  [
                    60227.8,
                    18872.8
                  ],
                  [
                    60091.5,
                    18871.4
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60000,
                    18805.5
                  ]
                ],
                "id": 1764,
                "chat_link": "[&BOQGAAA=]"
              },
              "1765": {
                "name": "Rusty Meadows",
                "level": 80,
                "coord": [
                  60483.3,
                  18144.7
                ],
                "bounds": [
                  [
                    59747,
                    18085.2
                  ],
                  [
                    59909.8,
                    17877.5
                  ],
                  [
                    60197.3,
                    17663.5
                  ],
                  [
                    60619,
                    17566
                  ],
                  [
                    60554.9,
                    17795.3
                  ],
                  [
                    60919.4,
                    17818.7
                  ],
                  [
                    61049.4,
                    17948
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    60755.9,
                    18244.2
                  ],
                  [
                    60674.2,
                    18383.3
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60519.2,
                    18511.8
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60208,
                    18388.8
                  ],
                  [
                    60154.3,
                    18284.1
                  ],
                  [
                    59747,
                    18085.2
                  ]
                ],
                "id": 1765,
                "chat_link": "[&BOUGAAA=]"
              },
              "1766": {
                "name": "Festival Promenade",
                "level": 80,
                "coord": [
                  60851.2,
                  18645.6
                ],
                "bounds": [
                  [
                    60977.7,
                    18548.2
                  ],
                  [
                    60790.4,
                    18547.6
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60927.8,
                    18724.5
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    60977.7,
                    18548.2
                  ]
                ],
                "id": 1766,
                "chat_link": "[&BOYGAAA=]"
              },
              "1767": {
                "name": "Longeye's Landslide",
                "level": 80,
                "coord": [
                  59983.7,
                  18546.9
                ],
                "bounds": [
                  [
                    60000,
                    18805.5
                  ],
                  [
                    60100,
                    18745.8
                  ],
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60208,
                    18388.8
                  ],
                  [
                    60154.3,
                    18284.1
                  ],
                  [
                    59747,
                    18085.2
                  ],
                  [
                    59602.2,
                    18385
                  ],
                  [
                    59561.5,
                    18639.4
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60000,
                    18805.5
                  ]
                ],
                "id": 1767,
                "chat_link": "[&BOcGAAA=]"
              },
              "1768": {
                "name": "Doomlore Ruins",
                "level": 80,
                "coord": [
                  62211.3,
                  17975.1
                ],
                "bounds": [
                  [
                    61949.7,
                    17888.5
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    62143.7,
                    18281.3
                  ],
                  [
                    62336.9,
                    18317.8
                  ],
                  [
                    62497.1,
                    18324.3
                  ],
                  [
                    62486.3,
                    17799.2
                  ],
                  [
                    62343.5,
                    17692.6
                  ],
                  [
                    62129.8,
                    17681.4
                  ],
                  [
                    61991.5,
                    17641.1
                  ],
                  [
                    61949.7,
                    17888.5
                  ]
                ],
                "id": 1768,
                "chat_link": "[&BOgGAAA=]"
              },
              "1769": {
                "name": "Bitter Horn",
                "level": 80,
                "coord": [
                  59650.8,
                  19041.8
                ],
                "bounds": [
                  [
                    59561.5,
                    18639.4
                  ],
                  [
                    59433.2,
                    18865.3
                  ],
                  [
                    59428.2,
                    18997.3
                  ],
                  [
                    59476.5,
                    19222.8
                  ],
                  [
                    59629.3,
                    19273.3
                  ],
                  [
                    59790.4,
                    19254.6
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    59561.5,
                    18639.4
                  ]
                ],
                "id": 1769,
                "chat_link": "[&BOkGAAA=]"
              },
              "1770": {
                "name": "Sacnoth Stream",
                "level": 80,
                "coord": [
                  61613.2,
                  19314.9
                ],
                "bounds": [
                  [
                    61457.4,
                    19516.8
                  ],
                  [
                    61424.8,
                    19151.8
                  ],
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61542.1,
                    18693.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61703.3,
                    18988.7
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61719.9,
                    19428.8
                  ],
                  [
                    61710,
                    19584.1
                  ],
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61731.3,
                    19802
                  ],
                  [
                    61677,
                    19861.8
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61457.4,
                    19516.8
                  ]
                ],
                "id": 1770,
                "chat_link": "[&BOoGAAA=]"
              },
              "1771": {
                "name": "Devourer's Ridge",
                "level": 80,
                "coord": [
                  61333.6,
                  18577.6
                ],
                "bounds": [
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61484.5,
                    18298.5
                  ],
                  [
                    61581.4,
                    18421.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61542.1,
                    18693.8
                  ],
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61269,
                    18848.6
                  ],
                  [
                    61229.5,
                    18831.9
                  ],
                  [
                    61180.6,
                    18729.1
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    61157.9,
                    18391.8
                  ],
                  [
                    61287,
                    18312.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ]
                ],
                "id": 1771,
                "chat_link": "[&BOsGAAA=]"
              },
              "1772": {
                "name": "Tribunes' Trench",
                "level": 80,
                "coord": [
                  60642.6,
                  19403.5
                ],
                "bounds": [
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60593.3,
                    18915.3
                  ],
                  [
                    60585.9,
                    19048.5
                  ],
                  [
                    60592.4,
                    19159.5
                  ],
                  [
                    60628.5,
                    19233.2
                  ],
                  [
                    60613.4,
                    19292.4
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60605.1,
                    19638
                  ],
                  [
                    60598.4,
                    19733.2
                  ],
                  [
                    60531.7,
                    19808
                  ],
                  [
                    60509.8,
                    19885.3
                  ],
                  [
                    60524.6,
                    19946.1
                  ],
                  [
                    60646.9,
                    19977.6
                  ],
                  [
                    60769,
                    19989
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60790.9,
                    19286.1
                  ],
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    60790.4,
                    18875.3
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60543.9,
                    18845.7
                  ]
                ],
                "id": 1772,
                "chat_link": "[&BOwGAAA=]"
              }
            },
            "adventures": [],
            "id": 1334,
            "mastery_points": []
          },
          "1336": {
            "name": "A Race to Arms",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              60992,
              18784
            ],
            "map_rect": [
              [
                -36864,
                -30720
              ],
              [
                39936,
                30720
              ]
            ],
            "continent_rect": [
              [
                59392,
                17504
              ],
              [
                62592,
                20064
              ]
            ],
            "points_of_interest": {
              "3057": {
                "name": "Priory Research Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62327.2,
                  18975.3
                ],
                "id": 3057,
                "chat_link": "[&BPELAAA=]"
              },
              "3058": {
                "name": "Santia's Forge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60944.1,
                  18927.5
                ],
                "id": 3058,
                "chat_link": "[&BPILAAA=]"
              },
              "3059": {
                "name": "Blood Dam",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60087.9,
                  18368.5
                ],
                "id": 3059,
                "chat_link": "[&BPMLAAA=]"
              },
              "3060": {
                "name": "Auris's Workshop",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60456.4,
                  18907.9
                ],
                "id": 3060,
                "chat_link": "[&BPQLAAA=]"
              },
              "3061": {
                "name": "Ash Legion Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61314.2,
                  18781.2
                ],
                "id": 3061,
                "chat_link": "[&BPULAAA=]"
              },
              "3062": {
                "name": "Imperator Ruinbringer's Office",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60210.5,
                  19235.8
                ],
                "id": 3062,
                "chat_link": "[&BPYLAAA=]"
              },
              "3065": {
                "name": "Stockade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60370.2,
                  18582.3
                ],
                "id": 3065,
                "chat_link": "[&BPkLAAA=]"
              },
              "3067": {
                "name": "Keep Kitchen",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60264.6,
                  18820.8
                ],
                "id": 3067,
                "chat_link": "[&BPsLAAA=]"
              },
              "3068": {
                "name": "Cathedral of Flames Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62107.2,
                  17966.7
                ],
                "id": 3068,
                "chat_link": "[&BPwLAAA=]"
              },
              "3069": {
                "name": "Contender's Colosseum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61149.9,
                  19664.3
                ],
                "id": 3069,
                "chat_link": "[&BP0LAAA=]"
              },
              "3070": {
                "name": "Aurene's Grace",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62123.2,
                  19587.6
                ],
                "id": 3070,
                "chat_link": "[&BP4LAAA=]"
              },
              "3071": {
                "name": "Soul's Hearth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60120.6,
                  18142.3
                ],
                "id": 3071,
                "chat_link": "[&BP8LAAA=]"
              },
              "3073": {
                "name": "Doomlore Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62210,
                  18042.8
                ],
                "id": 3073,
                "chat_link": "[&BAEMAAA=]"
              },
              "3074": {
                "name": "Warden's Office",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60488.1,
                  18570.2
                ],
                "id": 3074,
                "chat_link": "[&BAIMAAA=]"
              },
              "3075": {
                "name": "Fangstorm's Farmhouse",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60624.5,
                  18053
                ],
                "id": 3075,
                "chat_link": "[&BAMMAAA=]"
              },
              "3076": {
                "name": "Rank 'n' File Pub",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60381.9,
                  19042.2
                ],
                "id": 3076,
                "chat_link": "[&BAQMAAA=]"
              },
              "3077": {
                "name": "Rally Pavilion",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61025.1,
                  18671
                ],
                "id": 3077,
                "chat_link": "[&BAUMAAA=]"
              },
              "3079": {
                "name": "Eternal Cauldron",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60843.7,
                  18407.9
                ],
                "id": 3079,
                "chat_link": "[&BAcMAAA=]"
              },
              "3082": {
                "name": "Blood Legion Fahrar",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60259.4,
                  19206.6
                ],
                "id": 3082,
                "chat_link": "[&BAoMAAA=]"
              },
              "3085": {
                "name": "Blood Lagoon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61585.4,
                  19707.4
                ],
                "id": 3085,
                "chat_link": "[&BA0MAAA=]"
              },
              "3087": {
                "name": "All-Legion Commons",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60776.5,
                  18617.4
                ],
                "id": 3087,
                "chat_link": "[&BA8MAAA=]"
              },
              "3089": {
                "name": "Recon Cove",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61892.7,
                  18977.2
                ],
                "id": 3089,
                "chat_link": "[&BBEMAAA=]"
              },
              "3090": {
                "name": "Vault of the Khan-Ur",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61680.3,
                  17876.1
                ],
                "id": 3090,
                "chat_link": "[&BBIMAAA=]"
              },
              "3093": {
                "name": "Sniper's Square",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60287.9,
                  19572.7
                ],
                "id": 3093,
                "chat_link": "[&BBUMAAA=]"
              },
              "3095": {
                "name": "Shiver Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60113.2,
                  19683.9
                ],
                "id": 3095,
                "chat_link": "[&BBcMAAA=]"
              },
              "3096": {
                "name": "Blood Keep Main Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60504.1,
                  19311.8
                ],
                "id": 3096,
                "chat_link": "[&BBgMAAA=]"
              },
              "3097": {
                "name": "Blood Stand Stage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61914.3,
                  19470.2
                ],
                "id": 3097,
                "chat_link": "[&BBkMAAA=]"
              },
              "3098": {
                "name": "Band's Bivouac",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61537.4,
                  19173.2
                ],
                "id": 3098,
                "chat_link": "[&BBoMAAA=]"
              },
              "3100": {
                "name": "Great Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60141.9,
                  18983.8
                ],
                "id": 3100,
                "chat_link": "[&BBwMAAA=]"
              },
              "3101": {
                "name": "Unity's Beacon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61195.5,
                  18132.8
                ],
                "id": 3101,
                "chat_link": "[&BB0MAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1748": {
                "name": "Kralkatorrik's Emergence Zone",
                "level": 80,
                "coord": [
                  62036.1,
                  19519.6
                ],
                "bounds": [
                  [
                    61509.7,
                    19991.4
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61677,
                    19861.8
                  ],
                  [
                    61731.3,
                    19802
                  ],
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61959.5,
                    19543
                  ],
                  [
                    61997.5,
                    19467
                  ],
                  [
                    61956.5,
                    19357.1
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61966.3,
                    19176.7
                  ],
                  [
                    62018.3,
                    19088.5
                  ],
                  [
                    62109.8,
                    19001.5
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62271.7,
                    19052.4
                  ],
                  [
                    62512.3,
                    19181.8
                  ],
                  [
                    62498.6,
                    19733
                  ],
                  [
                    62452.5,
                    19868.9
                  ],
                  [
                    62360.4,
                    19934.6
                  ],
                  [
                    62236.4,
                    19964.3
                  ],
                  [
                    61509.7,
                    19991.4
                  ]
                ],
                "id": 1748,
                "chat_link": "[&BNQGAAA=]"
              },
              "1749": {
                "name": "Dalada Forest",
                "level": 80,
                "coord": [
                  61871.9,
                  18350.6
                ],
                "bounds": [
                  [
                    62449.5,
                    18644.4
                  ],
                  [
                    62497.1,
                    18324.3
                  ],
                  [
                    62336.9,
                    18317.8
                  ],
                  [
                    62143.7,
                    18281.3
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    61932,
                    18184
                  ],
                  [
                    61867.3,
                    18219.2
                  ],
                  [
                    61752.2,
                    18252.6
                  ],
                  [
                    61694.3,
                    18209.6
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61484.5,
                    18298.5
                  ],
                  [
                    61581.4,
                    18421.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61929.2,
                    18680.9
                  ],
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    62449.5,
                    18644.4
                  ]
                ],
                "id": 1749,
                "chat_link": "[&BNUGAAA=]"
              },
              "1750": {
                "name": "Burning Effigy",
                "level": 80,
                "coord": [
                  61154.9,
                  18232
                ],
                "bounds": [
                  [
                    61049.4,
                    17948
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61287,
                    18312.5
                  ],
                  [
                    61157.9,
                    18391.8
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    61022.7,
                    18354
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    61049.4,
                    17948
                  ]
                ],
                "id": 1750,
                "chat_link": "[&BNYGAAA=]"
              },
              "1751": {
                "name": "The Ooze Pit",
                "level": 80,
                "coord": [
                  61133.5,
                  19807.8
                ],
                "bounds": [
                  [
                    60917.5,
                    20004.8
                  ],
                  [
                    60769,
                    19989
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60907.3,
                    19651.3
                  ],
                  [
                    61043,
                    19603
                  ],
                  [
                    61238,
                    19606.6
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61509.7,
                    19991.4
                  ],
                  [
                    61179,
                    20032.4
                  ],
                  [
                    60917.5,
                    20004.8
                  ]
                ],
                "id": 1751,
                "chat_link": "[&BNcGAAA=]"
              },
              "1752": {
                "name": "Flame Legion Camp",
                "level": 80,
                "coord": [
                  60855.8,
                  18398.5
                ],
                "bounds": [
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    60977.7,
                    18548.2
                  ],
                  [
                    60790.4,
                    18547.6
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60674.2,
                    18383.3
                  ],
                  [
                    60755.9,
                    18244.2
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    61022.7,
                    18354
                  ],
                  [
                    61042.5,
                    18468.2
                  ]
                ],
                "id": 1752,
                "chat_link": "[&BNgGAAA=]"
              },
              "1753": {
                "name": "Shiverpeaks Pass",
                "level": 80,
                "coord": [
                  59772.3,
                  19582.9
                ],
                "bounds": [
                  [
                    59476.5,
                    19222.8
                  ],
                  [
                    59510,
                    19899.3
                  ],
                  [
                    59599.8,
                    19971.5
                  ],
                  [
                    59778.1,
                    19980.2
                  ],
                  [
                    60007.6,
                    19908.3
                  ],
                  [
                    60011.2,
                    19720.1
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59790.4,
                    19254.6
                  ],
                  [
                    59629.3,
                    19273.3
                  ],
                  [
                    59476.5,
                    19222.8
                  ]
                ],
                "id": 1753,
                "chat_link": "[&BNkGAAA=]"
              },
              "1754": {
                "name": "Shattered Steppes",
                "level": 80,
                "coord": [
                  61979.3,
                  19016.7
                ],
                "bounds": [
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    61929.2,
                    18680.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61703.3,
                    18988.7
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61809,
                    19299.3
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61966.3,
                    19176.7
                  ],
                  [
                    62018.3,
                    19088.5
                  ],
                  [
                    62109.8,
                    19001.5
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62315.6,
                    18861.1
                  ],
                  [
                    62319.6,
                    18766.6
                  ]
                ],
                "id": 1754,
                "chat_link": "[&BNoGAAA=]"
              },
              "1755": {
                "name": "The Crag",
                "level": 80,
                "coord": [
                  61836.3,
                  19441.7
                ],
                "bounds": [
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61710,
                    19584.1
                  ],
                  [
                    61719.9,
                    19428.8
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61809,
                    19299.3
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61956.5,
                    19357.1
                  ],
                  [
                    61997.5,
                    19467
                  ],
                  [
                    61959.5,
                    19543
                  ],
                  [
                    61738.7,
                    19669.8
                  ]
                ],
                "id": 1755,
                "chat_link": "[&BNsGAAA=]"
              },
              "1756": {
                "name": "The Wardowns",
                "level": 80,
                "coord": [
                  61143.4,
                  19167.6
                ],
                "bounds": [
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61424.8,
                    19151.8
                  ],
                  [
                    61457.4,
                    19516.8
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61238,
                    19606.6
                  ],
                  [
                    61043,
                    19603
                  ],
                  [
                    60907.3,
                    19651.3
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60790.9,
                    19286.1
                  ],
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    61053.9,
                    19052
                  ],
                  [
                    61106.6,
                    19007.5
                  ],
                  [
                    61128.9,
                    18918.3
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61180.6,
                    18729.1
                  ],
                  [
                    61229.5,
                    18831.9
                  ],
                  [
                    61269,
                    18848.6
                  ],
                  [
                    61479.4,
                    18887.6
                  ]
                ],
                "id": 1756,
                "chat_link": "[&BNwGAAA=]"
              },
              "1757": {
                "name": "Cavern of the Khan-Ur",
                "level": 80,
                "coord": [
                  61803.9,
                  18001.4
                ],
                "bounds": [
                  [
                    61615.8,
                    17565.2
                  ],
                  [
                    61598.2,
                    17890.5
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61694.3,
                    18209.6
                  ],
                  [
                    61752.2,
                    18252.6
                  ],
                  [
                    61867.3,
                    18219.2
                  ],
                  [
                    61932,
                    18184
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    61949.7,
                    17888.5
                  ],
                  [
                    61991.5,
                    17641.1
                  ],
                  [
                    61615.8,
                    17565.2
                  ]
                ],
                "id": 1757,
                "chat_link": "[&BN0GAAA=]"
              },
              "1758": {
                "name": "Khan-Ur's Gauntlet",
                "level": 80,
                "coord": [
                  61184.5,
                  17740.4
                ],
                "bounds": [
                  [
                    60794.8,
                    17540.8
                  ],
                  [
                    60619,
                    17566
                  ],
                  [
                    60554.9,
                    17795.3
                  ],
                  [
                    60919.4,
                    17818.7
                  ],
                  [
                    61049.4,
                    17948
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61598.2,
                    17890.5
                  ],
                  [
                    61615.8,
                    17565.2
                  ],
                  [
                    61511.5,
                    17546.7
                  ],
                  [
                    61381.3,
                    17532.9
                  ],
                  [
                    60794.8,
                    17540.8
                  ]
                ],
                "id": 1758,
                "chat_link": "[&BN4GAAA=]"
              },
              "1759": {
                "name": "Training Grounds",
                "level": 80,
                "coord": [
                  60345.7,
                  19735.4
                ],
                "bounds": [
                  [
                    60605.1,
                    19638
                  ],
                  [
                    60598.4,
                    19733.2
                  ],
                  [
                    60531.7,
                    19808
                  ],
                  [
                    60509.8,
                    19885.3
                  ],
                  [
                    60524.6,
                    19946.1
                  ],
                  [
                    60456.2,
                    19955.2
                  ],
                  [
                    60159.5,
                    19992.2
                  ],
                  [
                    60007.6,
                    19908.3
                  ],
                  [
                    60011.2,
                    19720.1
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60605.1,
                    19638
                  ]
                ],
                "id": 1759,
                "chat_link": "[&BN8GAAA=]"
              },
              "1760": {
                "name": "Upper Blood Keep",
                "level": 80,
                "coord": [
                  60155.1,
                  19085.3
                ],
                "bounds": [
                  [
                    60091.5,
                    18871.4
                  ],
                  [
                    60227.8,
                    18872.8
                  ],
                  [
                    60230.6,
                    18943
                  ],
                  [
                    60334.3,
                    18943.7
                  ],
                  [
                    60333.1,
                    19254.5
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60091.5,
                    18871.4
                  ]
                ],
                "id": 1760,
                "chat_link": "[&BOAGAAA=]"
              },
              "1761": {
                "name": "The Overlook",
                "level": 80,
                "coord": [
                  62368.5,
                  18902.8
                ],
                "bounds": [
                  [
                    62506.5,
                    18819.5
                  ],
                  [
                    62449.5,
                    18644.4
                  ],
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    62315.6,
                    18861.1
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62271.7,
                    19052.4
                  ],
                  [
                    62512.3,
                    19181.8
                  ],
                  [
                    62506.5,
                    18819.5
                  ]
                ],
                "id": 1761,
                "chat_link": "[&BOEGAAA=]"
              },
              "1762": {
                "name": "The Brig",
                "level": 80,
                "coord": [
                  60432.6,
                  18634.6
                ],
                "bounds": [
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60519.2,
                    18511.8
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60259.2,
                    18709.5
                  ]
                ],
                "id": 1762,
                "chat_link": "[&BOIGAAA=]"
              },
              "1763": {
                "name": "Iron Legion Camp",
                "level": 80,
                "coord": [
                  60966.6,
                  18905
                ],
                "bounds": [
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    61053.9,
                    19052
                  ],
                  [
                    61106.6,
                    19007.5
                  ],
                  [
                    61128.9,
                    18918.3
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    60927.8,
                    18724.5
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60790.4,
                    18875.3
                  ],
                  [
                    60872.3,
                    19101.9
                  ]
                ],
                "id": 1763,
                "chat_link": "[&BOMGAAA=]"
              },
              "1764": {
                "name": "Lower Blood Keep",
                "level": 80,
                "coord": [
                  60343.8,
                  19021.2
                ],
                "bounds": [
                  [
                    60000,
                    18805.5
                  ],
                  [
                    60100,
                    18745.8
                  ],
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60593.3,
                    18915.3
                  ],
                  [
                    60585.9,
                    19048.5
                  ],
                  [
                    60592.4,
                    19159.5
                  ],
                  [
                    60628.5,
                    19233.2
                  ],
                  [
                    60613.4,
                    19292.4
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    60333.1,
                    19254.5
                  ],
                  [
                    60334.3,
                    18943.7
                  ],
                  [
                    60230.6,
                    18943
                  ],
                  [
                    60227.8,
                    18872.8
                  ],
                  [
                    60091.5,
                    18871.4
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60000,
                    18805.5
                  ]
                ],
                "id": 1764,
                "chat_link": "[&BOQGAAA=]"
              },
              "1765": {
                "name": "Rusty Meadows",
                "level": 80,
                "coord": [
                  60483.3,
                  18144.7
                ],
                "bounds": [
                  [
                    59747,
                    18085.2
                  ],
                  [
                    59909.8,
                    17877.5
                  ],
                  [
                    60197.3,
                    17663.5
                  ],
                  [
                    60619,
                    17566
                  ],
                  [
                    60554.9,
                    17795.3
                  ],
                  [
                    60919.4,
                    17818.7
                  ],
                  [
                    61049.4,
                    17948
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    60755.9,
                    18244.2
                  ],
                  [
                    60674.2,
                    18383.3
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60519.2,
                    18511.8
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60208,
                    18388.8
                  ],
                  [
                    60154.3,
                    18284.1
                  ],
                  [
                    59747,
                    18085.2
                  ]
                ],
                "id": 1765,
                "chat_link": "[&BOUGAAA=]"
              },
              "1766": {
                "name": "Festival Promenade",
                "level": 80,
                "coord": [
                  60851.2,
                  18645.6
                ],
                "bounds": [
                  [
                    60977.7,
                    18548.2
                  ],
                  [
                    60790.4,
                    18547.6
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60927.8,
                    18724.5
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    60977.7,
                    18548.2
                  ]
                ],
                "id": 1766,
                "chat_link": "[&BOYGAAA=]"
              },
              "1767": {
                "name": "Longeye's Landslide",
                "level": 80,
                "coord": [
                  59983.7,
                  18546.9
                ],
                "bounds": [
                  [
                    60000,
                    18805.5
                  ],
                  [
                    60100,
                    18745.8
                  ],
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60208,
                    18388.8
                  ],
                  [
                    60154.3,
                    18284.1
                  ],
                  [
                    59747,
                    18085.2
                  ],
                  [
                    59602.2,
                    18385
                  ],
                  [
                    59561.5,
                    18639.4
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60000,
                    18805.5
                  ]
                ],
                "id": 1767,
                "chat_link": "[&BOcGAAA=]"
              },
              "1768": {
                "name": "Doomlore Ruins",
                "level": 80,
                "coord": [
                  62211.3,
                  17975.1
                ],
                "bounds": [
                  [
                    61949.7,
                    17888.5
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    62143.7,
                    18281.3
                  ],
                  [
                    62336.9,
                    18317.8
                  ],
                  [
                    62497.1,
                    18324.3
                  ],
                  [
                    62486.3,
                    17799.2
                  ],
                  [
                    62343.5,
                    17692.6
                  ],
                  [
                    62129.8,
                    17681.4
                  ],
                  [
                    61991.5,
                    17641.1
                  ],
                  [
                    61949.7,
                    17888.5
                  ]
                ],
                "id": 1768,
                "chat_link": "[&BOgGAAA=]"
              },
              "1769": {
                "name": "Bitter Horn",
                "level": 80,
                "coord": [
                  59650.8,
                  19041.8
                ],
                "bounds": [
                  [
                    59561.5,
                    18639.4
                  ],
                  [
                    59433.2,
                    18865.3
                  ],
                  [
                    59428.2,
                    18997.3
                  ],
                  [
                    59476.5,
                    19222.8
                  ],
                  [
                    59629.3,
                    19273.3
                  ],
                  [
                    59790.4,
                    19254.6
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    59561.5,
                    18639.4
                  ]
                ],
                "id": 1769,
                "chat_link": "[&BOkGAAA=]"
              },
              "1770": {
                "name": "Sacnoth Stream",
                "level": 80,
                "coord": [
                  61613.2,
                  19314.9
                ],
                "bounds": [
                  [
                    61457.4,
                    19516.8
                  ],
                  [
                    61424.8,
                    19151.8
                  ],
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61542.1,
                    18693.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61703.3,
                    18988.7
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61719.9,
                    19428.8
                  ],
                  [
                    61710,
                    19584.1
                  ],
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61731.3,
                    19802
                  ],
                  [
                    61677,
                    19861.8
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61457.4,
                    19516.8
                  ]
                ],
                "id": 1770,
                "chat_link": "[&BOoGAAA=]"
              },
              "1771": {
                "name": "Devourer's Ridge",
                "level": 80,
                "coord": [
                  61333.6,
                  18577.6
                ],
                "bounds": [
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61484.5,
                    18298.5
                  ],
                  [
                    61581.4,
                    18421.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61542.1,
                    18693.8
                  ],
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61269,
                    18848.6
                  ],
                  [
                    61229.5,
                    18831.9
                  ],
                  [
                    61180.6,
                    18729.1
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    61157.9,
                    18391.8
                  ],
                  [
                    61287,
                    18312.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ]
                ],
                "id": 1771,
                "chat_link": "[&BOsGAAA=]"
              },
              "1772": {
                "name": "Tribunes' Trench",
                "level": 80,
                "coord": [
                  60642.6,
                  19403.5
                ],
                "bounds": [
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60593.3,
                    18915.3
                  ],
                  [
                    60585.9,
                    19048.5
                  ],
                  [
                    60592.4,
                    19159.5
                  ],
                  [
                    60628.5,
                    19233.2
                  ],
                  [
                    60613.4,
                    19292.4
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60605.1,
                    19638
                  ],
                  [
                    60598.4,
                    19733.2
                  ],
                  [
                    60531.7,
                    19808
                  ],
                  [
                    60509.8,
                    19885.3
                  ],
                  [
                    60524.6,
                    19946.1
                  ],
                  [
                    60646.9,
                    19977.6
                  ],
                  [
                    60769,
                    19989
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60790.9,
                    19286.1
                  ],
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    60790.4,
                    18875.3
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60543.9,
                    18845.7
                  ]
                ],
                "id": 1772,
                "chat_link": "[&BOwGAAA=]"
              }
            },
            "adventures": [],
            "id": 1336,
            "mastery_points": []
          },
          "1338": {
            "name": "Bad Blood",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              60992,
              18784
            ],
            "map_rect": [
              [
                -36864,
                -30720
              ],
              [
                39936,
                30720
              ]
            ],
            "continent_rect": [
              [
                59392,
                17504
              ],
              [
                62592,
                20064
              ]
            ],
            "points_of_interest": {
              "3057": {
                "name": "Priory Research Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62327.2,
                  18975.3
                ],
                "id": 3057,
                "chat_link": "[&BPELAAA=]"
              },
              "3058": {
                "name": "Santia's Forge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60944.1,
                  18927.5
                ],
                "id": 3058,
                "chat_link": "[&BPILAAA=]"
              },
              "3059": {
                "name": "Blood Dam",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60087.9,
                  18368.5
                ],
                "id": 3059,
                "chat_link": "[&BPMLAAA=]"
              },
              "3060": {
                "name": "Auris's Workshop",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60456.4,
                  18907.9
                ],
                "id": 3060,
                "chat_link": "[&BPQLAAA=]"
              },
              "3061": {
                "name": "Ash Legion Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61314.2,
                  18781.2
                ],
                "id": 3061,
                "chat_link": "[&BPULAAA=]"
              },
              "3062": {
                "name": "Imperator Ruinbringer's Office",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60210.5,
                  19235.8
                ],
                "id": 3062,
                "chat_link": "[&BPYLAAA=]"
              },
              "3065": {
                "name": "Stockade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60370.2,
                  18582.3
                ],
                "id": 3065,
                "chat_link": "[&BPkLAAA=]"
              },
              "3067": {
                "name": "Keep Kitchen",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60264.6,
                  18820.8
                ],
                "id": 3067,
                "chat_link": "[&BPsLAAA=]"
              },
              "3068": {
                "name": "Cathedral of Flames Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62107.2,
                  17966.7
                ],
                "id": 3068,
                "chat_link": "[&BPwLAAA=]"
              },
              "3069": {
                "name": "Contender's Colosseum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61149.9,
                  19664.3
                ],
                "id": 3069,
                "chat_link": "[&BP0LAAA=]"
              },
              "3070": {
                "name": "Aurene's Grace",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62123.2,
                  19587.6
                ],
                "id": 3070,
                "chat_link": "[&BP4LAAA=]"
              },
              "3071": {
                "name": "Soul's Hearth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60120.6,
                  18142.3
                ],
                "id": 3071,
                "chat_link": "[&BP8LAAA=]"
              },
              "3073": {
                "name": "Doomlore Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62210,
                  18042.8
                ],
                "id": 3073,
                "chat_link": "[&BAEMAAA=]"
              },
              "3074": {
                "name": "Warden's Office",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60488.1,
                  18570.2
                ],
                "id": 3074,
                "chat_link": "[&BAIMAAA=]"
              },
              "3075": {
                "name": "Fangstorm's Farmhouse",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60624.5,
                  18053
                ],
                "id": 3075,
                "chat_link": "[&BAMMAAA=]"
              },
              "3076": {
                "name": "Rank 'n' File Pub",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60381.9,
                  19042.2
                ],
                "id": 3076,
                "chat_link": "[&BAQMAAA=]"
              },
              "3077": {
                "name": "Rally Pavilion",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61025.1,
                  18671
                ],
                "id": 3077,
                "chat_link": "[&BAUMAAA=]"
              },
              "3079": {
                "name": "Eternal Cauldron",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60843.7,
                  18407.9
                ],
                "id": 3079,
                "chat_link": "[&BAcMAAA=]"
              },
              "3082": {
                "name": "Blood Legion Fahrar",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60259.4,
                  19206.6
                ],
                "id": 3082,
                "chat_link": "[&BAoMAAA=]"
              },
              "3084": {
                "name": "War Room",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60125.9,
                  19121.6
                ],
                "id": 3084,
                "chat_link": "[&BAwMAAA=]"
              },
              "3085": {
                "name": "Blood Lagoon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61585.4,
                  19707.4
                ],
                "id": 3085,
                "chat_link": "[&BA0MAAA=]"
              },
              "3087": {
                "name": "All-Legion Commons",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60776.5,
                  18617.4
                ],
                "id": 3087,
                "chat_link": "[&BA8MAAA=]"
              },
              "3089": {
                "name": "Recon Cove",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61892.7,
                  18977.2
                ],
                "id": 3089,
                "chat_link": "[&BBEMAAA=]"
              },
              "3090": {
                "name": "Vault of the Khan-Ur",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61680.3,
                  17876.1
                ],
                "id": 3090,
                "chat_link": "[&BBIMAAA=]"
              },
              "3093": {
                "name": "Sniper's Square",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60287.9,
                  19572.7
                ],
                "id": 3093,
                "chat_link": "[&BBUMAAA=]"
              },
              "3095": {
                "name": "Shiver Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60113.2,
                  19683.9
                ],
                "id": 3095,
                "chat_link": "[&BBcMAAA=]"
              },
              "3096": {
                "name": "Blood Keep Main Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60504.1,
                  19311.8
                ],
                "id": 3096,
                "chat_link": "[&BBgMAAA=]"
              },
              "3097": {
                "name": "Blood Stand Stage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61914.3,
                  19470.2
                ],
                "id": 3097,
                "chat_link": "[&BBkMAAA=]"
              },
              "3098": {
                "name": "Band's Bivouac",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61537.4,
                  19173.2
                ],
                "id": 3098,
                "chat_link": "[&BBoMAAA=]"
              },
              "3100": {
                "name": "Great Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60141.9,
                  18983.8
                ],
                "id": 3100,
                "chat_link": "[&BBwMAAA=]"
              },
              "3101": {
                "name": "Unity's Beacon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61195.5,
                  18132.8
                ],
                "id": 3101,
                "chat_link": "[&BB0MAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1748": {
                "name": "Kralkatorrik's Emergence Zone",
                "level": 80,
                "coord": [
                  62036.1,
                  19519.6
                ],
                "bounds": [
                  [
                    61509.7,
                    19991.4
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61677,
                    19861.8
                  ],
                  [
                    61731.3,
                    19802
                  ],
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61959.5,
                    19543
                  ],
                  [
                    61997.5,
                    19467
                  ],
                  [
                    61956.5,
                    19357.1
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61966.3,
                    19176.7
                  ],
                  [
                    62018.3,
                    19088.5
                  ],
                  [
                    62109.8,
                    19001.5
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62271.7,
                    19052.4
                  ],
                  [
                    62512.3,
                    19181.8
                  ],
                  [
                    62498.6,
                    19733
                  ],
                  [
                    62452.5,
                    19868.9
                  ],
                  [
                    62360.4,
                    19934.6
                  ],
                  [
                    62236.4,
                    19964.3
                  ],
                  [
                    61509.7,
                    19991.4
                  ]
                ],
                "id": 1748,
                "chat_link": "[&BNQGAAA=]"
              },
              "1749": {
                "name": "Dalada Forest",
                "level": 80,
                "coord": [
                  61871.9,
                  18350.6
                ],
                "bounds": [
                  [
                    62449.5,
                    18644.4
                  ],
                  [
                    62497.1,
                    18324.3
                  ],
                  [
                    62336.9,
                    18317.8
                  ],
                  [
                    62143.7,
                    18281.3
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    61932,
                    18184
                  ],
                  [
                    61867.3,
                    18219.2
                  ],
                  [
                    61752.2,
                    18252.6
                  ],
                  [
                    61694.3,
                    18209.6
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61484.5,
                    18298.5
                  ],
                  [
                    61581.4,
                    18421.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61929.2,
                    18680.9
                  ],
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    62449.5,
                    18644.4
                  ]
                ],
                "id": 1749,
                "chat_link": "[&BNUGAAA=]"
              },
              "1750": {
                "name": "Burning Effigy",
                "level": 80,
                "coord": [
                  61154.9,
                  18232
                ],
                "bounds": [
                  [
                    61049.4,
                    17948
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61287,
                    18312.5
                  ],
                  [
                    61157.9,
                    18391.8
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    61022.7,
                    18354
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    61049.4,
                    17948
                  ]
                ],
                "id": 1750,
                "chat_link": "[&BNYGAAA=]"
              },
              "1751": {
                "name": "The Ooze Pit",
                "level": 80,
                "coord": [
                  61133.5,
                  19807.8
                ],
                "bounds": [
                  [
                    60917.5,
                    20004.8
                  ],
                  [
                    60769,
                    19989
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60907.3,
                    19651.3
                  ],
                  [
                    61043,
                    19603
                  ],
                  [
                    61238,
                    19606.6
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61509.7,
                    19991.4
                  ],
                  [
                    61179,
                    20032.4
                  ],
                  [
                    60917.5,
                    20004.8
                  ]
                ],
                "id": 1751,
                "chat_link": "[&BNcGAAA=]"
              },
              "1752": {
                "name": "Flame Legion Camp",
                "level": 80,
                "coord": [
                  60855.8,
                  18398.5
                ],
                "bounds": [
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    60977.7,
                    18548.2
                  ],
                  [
                    60790.4,
                    18547.6
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60674.2,
                    18383.3
                  ],
                  [
                    60755.9,
                    18244.2
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    61022.7,
                    18354
                  ],
                  [
                    61042.5,
                    18468.2
                  ]
                ],
                "id": 1752,
                "chat_link": "[&BNgGAAA=]"
              },
              "1753": {
                "name": "Shiverpeaks Pass",
                "level": 80,
                "coord": [
                  59772.3,
                  19582.9
                ],
                "bounds": [
                  [
                    59476.5,
                    19222.8
                  ],
                  [
                    59510,
                    19899.3
                  ],
                  [
                    59599.8,
                    19971.5
                  ],
                  [
                    59778.1,
                    19980.2
                  ],
                  [
                    60007.6,
                    19908.3
                  ],
                  [
                    60011.2,
                    19720.1
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59790.4,
                    19254.6
                  ],
                  [
                    59629.3,
                    19273.3
                  ],
                  [
                    59476.5,
                    19222.8
                  ]
                ],
                "id": 1753,
                "chat_link": "[&BNkGAAA=]"
              },
              "1754": {
                "name": "Shattered Steppes",
                "level": 80,
                "coord": [
                  61979.3,
                  19016.7
                ],
                "bounds": [
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    61929.2,
                    18680.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61703.3,
                    18988.7
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61809,
                    19299.3
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61966.3,
                    19176.7
                  ],
                  [
                    62018.3,
                    19088.5
                  ],
                  [
                    62109.8,
                    19001.5
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62315.6,
                    18861.1
                  ],
                  [
                    62319.6,
                    18766.6
                  ]
                ],
                "id": 1754,
                "chat_link": "[&BNoGAAA=]"
              },
              "1755": {
                "name": "The Crag",
                "level": 80,
                "coord": [
                  61836.3,
                  19441.7
                ],
                "bounds": [
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61710,
                    19584.1
                  ],
                  [
                    61719.9,
                    19428.8
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61809,
                    19299.3
                  ],
                  [
                    61912.2,
                    19321.6
                  ],
                  [
                    61956.5,
                    19357.1
                  ],
                  [
                    61997.5,
                    19467
                  ],
                  [
                    61959.5,
                    19543
                  ],
                  [
                    61738.7,
                    19669.8
                  ]
                ],
                "id": 1755,
                "chat_link": "[&BNsGAAA=]"
              },
              "1756": {
                "name": "The Wardowns",
                "level": 80,
                "coord": [
                  61143.4,
                  19167.6
                ],
                "bounds": [
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61424.8,
                    19151.8
                  ],
                  [
                    61457.4,
                    19516.8
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61238,
                    19606.6
                  ],
                  [
                    61043,
                    19603
                  ],
                  [
                    60907.3,
                    19651.3
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60790.9,
                    19286.1
                  ],
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    61053.9,
                    19052
                  ],
                  [
                    61106.6,
                    19007.5
                  ],
                  [
                    61128.9,
                    18918.3
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61180.6,
                    18729.1
                  ],
                  [
                    61229.5,
                    18831.9
                  ],
                  [
                    61269,
                    18848.6
                  ],
                  [
                    61479.4,
                    18887.6
                  ]
                ],
                "id": 1756,
                "chat_link": "[&BNwGAAA=]"
              },
              "1757": {
                "name": "Cavern of the Khan-Ur",
                "level": 80,
                "coord": [
                  61803.9,
                  18001.4
                ],
                "bounds": [
                  [
                    61615.8,
                    17565.2
                  ],
                  [
                    61598.2,
                    17890.5
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61694.3,
                    18209.6
                  ],
                  [
                    61752.2,
                    18252.6
                  ],
                  [
                    61867.3,
                    18219.2
                  ],
                  [
                    61932,
                    18184
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    61949.7,
                    17888.5
                  ],
                  [
                    61991.5,
                    17641.1
                  ],
                  [
                    61615.8,
                    17565.2
                  ]
                ],
                "id": 1757,
                "chat_link": "[&BN0GAAA=]"
              },
              "1758": {
                "name": "Khan-Ur's Gauntlet",
                "level": 80,
                "coord": [
                  61184.5,
                  17740.4
                ],
                "bounds": [
                  [
                    60794.8,
                    17540.8
                  ],
                  [
                    60619,
                    17566
                  ],
                  [
                    60554.9,
                    17795.3
                  ],
                  [
                    60919.4,
                    17818.7
                  ],
                  [
                    61049.4,
                    17948
                  ],
                  [
                    61370.5,
                    17926.5
                  ],
                  [
                    61614.3,
                    18013.5
                  ],
                  [
                    61598.2,
                    17890.5
                  ],
                  [
                    61615.8,
                    17565.2
                  ],
                  [
                    61511.5,
                    17546.7
                  ],
                  [
                    61381.3,
                    17532.9
                  ],
                  [
                    60794.8,
                    17540.8
                  ]
                ],
                "id": 1758,
                "chat_link": "[&BN4GAAA=]"
              },
              "1759": {
                "name": "Training Grounds",
                "level": 80,
                "coord": [
                  60345.7,
                  19735.4
                ],
                "bounds": [
                  [
                    60605.1,
                    19638
                  ],
                  [
                    60598.4,
                    19733.2
                  ],
                  [
                    60531.7,
                    19808
                  ],
                  [
                    60509.8,
                    19885.3
                  ],
                  [
                    60524.6,
                    19946.1
                  ],
                  [
                    60456.2,
                    19955.2
                  ],
                  [
                    60159.5,
                    19992.2
                  ],
                  [
                    60007.6,
                    19908.3
                  ],
                  [
                    60011.2,
                    19720.1
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60605.1,
                    19638
                  ]
                ],
                "id": 1759,
                "chat_link": "[&BN8GAAA=]"
              },
              "1760": {
                "name": "Upper Blood Keep",
                "level": 80,
                "coord": [
                  60155.1,
                  19085.3
                ],
                "bounds": [
                  [
                    60091.5,
                    18871.4
                  ],
                  [
                    60227.8,
                    18872.8
                  ],
                  [
                    60230.6,
                    18943
                  ],
                  [
                    60334.3,
                    18943.7
                  ],
                  [
                    60333.1,
                    19254.5
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    59980.3,
                    19406.3
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60091.5,
                    18871.4
                  ]
                ],
                "id": 1760,
                "chat_link": "[&BOAGAAA=]"
              },
              "1761": {
                "name": "The Overlook",
                "level": 80,
                "coord": [
                  62368.5,
                  18902.8
                ],
                "bounds": [
                  [
                    62506.5,
                    18819.5
                  ],
                  [
                    62449.5,
                    18644.4
                  ],
                  [
                    62319.6,
                    18766.6
                  ],
                  [
                    62315.6,
                    18861.1
                  ],
                  [
                    62204.2,
                    18994
                  ],
                  [
                    62271.7,
                    19052.4
                  ],
                  [
                    62512.3,
                    19181.8
                  ],
                  [
                    62506.5,
                    18819.5
                  ]
                ],
                "id": 1761,
                "chat_link": "[&BOEGAAA=]"
              },
              "1762": {
                "name": "The Brig",
                "level": 80,
                "coord": [
                  60432.6,
                  18634.6
                ],
                "bounds": [
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60519.2,
                    18511.8
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60259.2,
                    18709.5
                  ]
                ],
                "id": 1762,
                "chat_link": "[&BOIGAAA=]"
              },
              "1763": {
                "name": "Iron Legion Camp",
                "level": 80,
                "coord": [
                  60966.6,
                  18905
                ],
                "bounds": [
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    61053.9,
                    19052
                  ],
                  [
                    61106.6,
                    19007.5
                  ],
                  [
                    61128.9,
                    18918.3
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    60927.8,
                    18724.5
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60790.4,
                    18875.3
                  ],
                  [
                    60872.3,
                    19101.9
                  ]
                ],
                "id": 1763,
                "chat_link": "[&BOMGAAA=]"
              },
              "1764": {
                "name": "Lower Blood Keep",
                "level": 80,
                "coord": [
                  60343.8,
                  19021.2
                ],
                "bounds": [
                  [
                    60000,
                    18805.5
                  ],
                  [
                    60100,
                    18745.8
                  ],
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60593.3,
                    18915.3
                  ],
                  [
                    60585.9,
                    19048.5
                  ],
                  [
                    60592.4,
                    19159.5
                  ],
                  [
                    60628.5,
                    19233.2
                  ],
                  [
                    60613.4,
                    19292.4
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60311,
                    19394.2
                  ],
                  [
                    60333.1,
                    19254.5
                  ],
                  [
                    60334.3,
                    18943.7
                  ],
                  [
                    60230.6,
                    18943
                  ],
                  [
                    60227.8,
                    18872.8
                  ],
                  [
                    60091.5,
                    18871.4
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60000,
                    18805.5
                  ]
                ],
                "id": 1764,
                "chat_link": "[&BOQGAAA=]"
              },
              "1765": {
                "name": "Rusty Meadows",
                "level": 80,
                "coord": [
                  60483.3,
                  18144.7
                ],
                "bounds": [
                  [
                    59747,
                    18085.2
                  ],
                  [
                    59909.8,
                    17877.5
                  ],
                  [
                    60197.3,
                    17663.5
                  ],
                  [
                    60619,
                    17566
                  ],
                  [
                    60554.9,
                    17795.3
                  ],
                  [
                    60919.4,
                    17818.7
                  ],
                  [
                    61049.4,
                    17948
                  ],
                  [
                    60914.8,
                    18171.6
                  ],
                  [
                    60755.9,
                    18244.2
                  ],
                  [
                    60674.2,
                    18383.3
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60519.2,
                    18511.8
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60208,
                    18388.8
                  ],
                  [
                    60154.3,
                    18284.1
                  ],
                  [
                    59747,
                    18085.2
                  ]
                ],
                "id": 1765,
                "chat_link": "[&BOUGAAA=]"
              },
              "1766": {
                "name": "Festival Promenade",
                "level": 80,
                "coord": [
                  60851.2,
                  18645.6
                ],
                "bounds": [
                  [
                    60977.7,
                    18548.2
                  ],
                  [
                    60790.4,
                    18547.6
                  ],
                  [
                    60668.5,
                    18471.2
                  ],
                  [
                    60583,
                    18568.8
                  ],
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60927.8,
                    18724.5
                  ],
                  [
                    61075.5,
                    18767.8
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    60977.7,
                    18548.2
                  ]
                ],
                "id": 1766,
                "chat_link": "[&BOYGAAA=]"
              },
              "1767": {
                "name": "Longeye's Landslide",
                "level": 80,
                "coord": [
                  59983.7,
                  18546.9
                ],
                "bounds": [
                  [
                    60000,
                    18805.5
                  ],
                  [
                    60100,
                    18745.8
                  ],
                  [
                    60259.2,
                    18709.5
                  ],
                  [
                    60257.6,
                    18537.4
                  ],
                  [
                    60208,
                    18388.8
                  ],
                  [
                    60154.3,
                    18284.1
                  ],
                  [
                    59747,
                    18085.2
                  ],
                  [
                    59602.2,
                    18385
                  ],
                  [
                    59561.5,
                    18639.4
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    60000,
                    18805.5
                  ]
                ],
                "id": 1767,
                "chat_link": "[&BOcGAAA=]"
              },
              "1768": {
                "name": "Doomlore Ruins",
                "level": 80,
                "coord": [
                  62211.3,
                  17975.1
                ],
                "bounds": [
                  [
                    61949.7,
                    17888.5
                  ],
                  [
                    62023.6,
                    18149.7
                  ],
                  [
                    62143.7,
                    18281.3
                  ],
                  [
                    62336.9,
                    18317.8
                  ],
                  [
                    62497.1,
                    18324.3
                  ],
                  [
                    62486.3,
                    17799.2
                  ],
                  [
                    62343.5,
                    17692.6
                  ],
                  [
                    62129.8,
                    17681.4
                  ],
                  [
                    61991.5,
                    17641.1
                  ],
                  [
                    61949.7,
                    17888.5
                  ]
                ],
                "id": 1768,
                "chat_link": "[&BOgGAAA=]"
              },
              "1769": {
                "name": "Bitter Horn",
                "level": 80,
                "coord": [
                  59650.8,
                  19041.8
                ],
                "bounds": [
                  [
                    59561.5,
                    18639.4
                  ],
                  [
                    59433.2,
                    18865.3
                  ],
                  [
                    59428.2,
                    18997.3
                  ],
                  [
                    59476.5,
                    19222.8
                  ],
                  [
                    59629.3,
                    19273.3
                  ],
                  [
                    59790.4,
                    19254.6
                  ],
                  [
                    59939.9,
                    19193.2
                  ],
                  [
                    59947.2,
                    18888.3
                  ],
                  [
                    59561.5,
                    18639.4
                  ]
                ],
                "id": 1769,
                "chat_link": "[&BOkGAAA=]"
              },
              "1770": {
                "name": "Sacnoth Stream",
                "level": 80,
                "coord": [
                  61613.2,
                  19314.9
                ],
                "bounds": [
                  [
                    61457.4,
                    19516.8
                  ],
                  [
                    61424.8,
                    19151.8
                  ],
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61542.1,
                    18693.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61740.7,
                    18717.5
                  ],
                  [
                    61703.3,
                    18988.7
                  ],
                  [
                    61723.3,
                    19304.2
                  ],
                  [
                    61719.9,
                    19428.8
                  ],
                  [
                    61710,
                    19584.1
                  ],
                  [
                    61738.7,
                    19669.8
                  ],
                  [
                    61731.3,
                    19802
                  ],
                  [
                    61677,
                    19861.8
                  ],
                  [
                    61572.8,
                    19863.5
                  ],
                  [
                    61415.7,
                    19634
                  ],
                  [
                    61457.4,
                    19516.8
                  ]
                ],
                "id": 1770,
                "chat_link": "[&BOoGAAA=]"
              },
              "1771": {
                "name": "Devourer's Ridge",
                "level": 80,
                "coord": [
                  61333.6,
                  18577.6
                ],
                "bounds": [
                  [
                    61394.8,
                    18283.5
                  ],
                  [
                    61484.5,
                    18298.5
                  ],
                  [
                    61581.4,
                    18421.8
                  ],
                  [
                    61561.9,
                    18619.9
                  ],
                  [
                    61542.1,
                    18693.8
                  ],
                  [
                    61479.4,
                    18887.6
                  ],
                  [
                    61269,
                    18848.6
                  ],
                  [
                    61229.5,
                    18831.9
                  ],
                  [
                    61180.6,
                    18729.1
                  ],
                  [
                    61125.6,
                    18721.3
                  ],
                  [
                    61042.5,
                    18468.2
                  ],
                  [
                    61157.9,
                    18391.8
                  ],
                  [
                    61287,
                    18312.5
                  ],
                  [
                    61394.8,
                    18283.5
                  ]
                ],
                "id": 1771,
                "chat_link": "[&BOsGAAA=]"
              },
              "1772": {
                "name": "Tribunes' Trench",
                "level": 80,
                "coord": [
                  60642.6,
                  19403.5
                ],
                "bounds": [
                  [
                    60543.9,
                    18845.7
                  ],
                  [
                    60593.3,
                    18915.3
                  ],
                  [
                    60585.9,
                    19048.5
                  ],
                  [
                    60592.4,
                    19159.5
                  ],
                  [
                    60628.5,
                    19233.2
                  ],
                  [
                    60613.4,
                    19292.4
                  ],
                  [
                    60452.8,
                    19437.5
                  ],
                  [
                    60605.1,
                    19638
                  ],
                  [
                    60598.4,
                    19733.2
                  ],
                  [
                    60531.7,
                    19808
                  ],
                  [
                    60509.8,
                    19885.3
                  ],
                  [
                    60524.6,
                    19946.1
                  ],
                  [
                    60646.9,
                    19977.6
                  ],
                  [
                    60769,
                    19989
                  ],
                  [
                    60782.8,
                    19701.6
                  ],
                  [
                    60790.9,
                    19286.1
                  ],
                  [
                    60872.3,
                    19101.9
                  ],
                  [
                    60790.4,
                    18875.3
                  ],
                  [
                    60777.5,
                    18793.1
                  ],
                  [
                    60543.9,
                    18845.7
                  ]
                ],
                "id": 1772,
                "chat_link": "[&BOwGAAA=]"
              }
            },
            "adventures": [],
            "id": 1338,
            "mastery_points": []
          },
          "1467": {
            "name": "New Friends, New Enemies—The Command Core",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              24320,
              14076
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "831": {
                "name": "Iron Tribune Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57090.7,
                  30675.6
                ],
                "id": 831,
                "chat_link": "[&BD8DAAA=]"
              },
              "931": {
                "name": "The War Council",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57093.3,
                  30609.7
                ],
                "id": 931,
                "chat_link": "[&BKMDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "adventures": [],
            "id": 1467,
            "mastery_points": []
          },
          "1469": {
            "name": "New Friends, New Enemies—Blood Tribune Quarters",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              56320,
              29952
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "828": {
                "name": "Blood Tribune Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57061.9,
                  30687.5
                ],
                "id": 828,
                "chat_link": "[&BDwDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "adventures": [],
            "id": 1469,
            "mastery_points": []
          },
          "1470": {
            "name": "A Quiet Celebration—Citadel Stockade",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              56320,
              29952
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "929": {
                "name": "Citadel Stockade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57151.1,
                  30615.6
                ],
                "id": 929,
                "chat_link": "[&BKEDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "adventures": [],
            "id": 1470,
            "mastery_points": []
          }
        },
        "id": 2
      },
      "3": {
        "name": "Ruins of Orr",
        "label_coord": [
          46368,
          42112
        ],
        "continent_rect": [
          [
            42880,
            38784
          ],
          [
            50560,
            45696
          ]
        ],
        "maps": {
          "51": {
            "name": "Straits of Devastation",
            "min_level": 70,
            "max_level": 75,
            "default_floor": 1,
            "label_coord": [
              48688,
              40192
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                47232,
                38784
              ],
              [
                50560,
                41600
              ]
            ],
            "points_of_interest": {
              "727": {
                "name": "Oceanside Ordnance",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49419.1,
                  38971.2
                ],
                "id": 727,
                "chat_link": "[&BNcCAAA=]"
              },
              "728": {
                "name": "Razorslide Bivouac",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50224.1,
                  39472.8
                ],
                "id": 728,
                "chat_link": "[&BNgCAAA=]"
              },
              "729": {
                "name": "Stentor Cannonade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49000.4,
                  39163.1
                ],
                "id": 729,
                "chat_link": "[&BNkCAAA=]"
              },
              "730": {
                "name": "Thunderhead Battery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49956.7,
                  40496.6
                ],
                "id": 730,
                "chat_link": "[&BNoCAAA=]"
              },
              "731": {
                "name": "Cadrigan's Jetty",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50296.7,
                  40730
                ],
                "id": 731,
                "chat_link": "[&BNsCAAA=]"
              },
              "732": {
                "name": "Izz-al-Din Sarayi",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49594.8,
                  40784
                ],
                "id": 732,
                "chat_link": "[&BNwCAAA=]"
              },
              "733": {
                "name": "Broken Spit",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49329.8,
                  41019.9
                ],
                "id": 733,
                "chat_link": "[&BN0CAAA=]"
              },
              "734": {
                "name": "The Vizier's Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49203.8,
                  40708
                ],
                "id": 734,
                "chat_link": "[&BN4CAAA=]"
              },
              "735": {
                "name": "Stygian Deeps",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49178.4,
                  39894.8
                ],
                "id": 735,
                "chat_link": "[&BN8CAAA=]"
              },
              "736": {
                "name": "Plaza of Lost Wisdom",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48297.3,
                  39104.4
                ],
                "id": 736,
                "chat_link": "[&BOACAAA=]"
              },
              "737": {
                "name": "Lone Post",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48992.3,
                  40784.6
                ],
                "id": 737,
                "chat_link": "[&BOECAAA=]"
              },
              "738": {
                "name": "Conquest Marina",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48452,
                  40271.7
                ],
                "id": 738,
                "chat_link": "[&BOICAAA=]"
              },
              "739": {
                "name": "Brassclaw Landing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48180.8,
                  39877.3
                ],
                "id": 739,
                "chat_link": "[&BOMCAAA=]"
              },
              "740": {
                "name": "Snipe Hill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48160.1,
                  40184.6
                ],
                "id": 740,
                "chat_link": "[&BOQCAAA=]"
              },
              "741": {
                "name": "Altar of Betrayal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47877.7,
                  41084.9
                ],
                "id": 741,
                "chat_link": "[&BOUCAAA=]"
              },
              "742": {
                "name": "Compass Bridge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49897.4,
                  40631.8
                ],
                "id": 742,
                "chat_link": "[&BOYCAAA=]"
              },
              "743": {
                "name": "Din al-Jindi",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47367.6,
                  40898
                ],
                "id": 743,
                "chat_link": "[&BOcCAAA=]"
              },
              "744": {
                "name": "Chapel of Lady Glaive",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47400.9,
                  40610
                ],
                "id": 744,
                "chat_link": "[&BOgCAAA=]"
              },
              "745": {
                "name": "The Royal Forum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48578.1,
                  39617.2
                ],
                "id": 745,
                "chat_link": "[&BOkCAAA=]"
              },
              "746": {
                "name": "The Vesper Bell",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48917.1,
                  40069.3
                ],
                "id": 746,
                "chat_link": "[&BOoCAAA=]"
              },
              "747": {
                "name": "Monastery of Tughra",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47352.6,
                  39983.4
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              },
              "748": {
                "name": "Bramble Pass Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49731,
                  38998.8
                ],
                "id": 748,
                "chat_link": "[&BOwCAAA=]"
              },
              "749": {
                "name": "Signal Peak Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49122,
                  39051.6
                ],
                "id": 749,
                "chat_link": "[&BO0CAAA=]"
              },
              "750": {
                "name": "Fort Trinity Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50061.3,
                  40004.1
                ],
                "id": 750,
                "chat_link": "[&BO4CAAA=]"
              },
              "751": {
                "name": "Thorn Pass Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50385.3,
                  39950.2
                ],
                "id": 751,
                "chat_link": "[&BO8CAAA=]"
              },
              "752": {
                "name": "Thunderhead Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49929,
                  40404.1
                ],
                "id": 752,
                "chat_link": "[&BPACAAA=]"
              },
              "753": {
                "name": "Broken Spit Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49380.2,
                  40962.5
                ],
                "id": 753,
                "chat_link": "[&BPECAAA=]"
              },
              "754": {
                "name": "Vesper Bell Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49072.5,
                  40068.6
                ],
                "id": 754,
                "chat_link": "[&BPICAAA=]"
              },
              "755": {
                "name": "Royal Forum Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48538,
                  39525.4
                ],
                "id": 755,
                "chat_link": "[&BPMCAAA=]"
              },
              "756": {
                "name": "Brassclaw Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48348.7,
                  39852.1
                ],
                "id": 756,
                "chat_link": "[&BPQCAAA=]"
              },
              "757": {
                "name": "Antheneum Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  47602.2,
                  40251.9
                ],
                "id": 757,
                "chat_link": "[&BPUCAAA=]"
              },
              "758": {
                "name": "Conquest Marina Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48531.7,
                  40341.5
                ],
                "id": 758,
                "chat_link": "[&BPYCAAA=]"
              },
              "759": {
                "name": "Lone Post Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48935.9,
                  40697.2
                ],
                "id": 759,
                "chat_link": "[&BPcCAAA=]"
              },
              "760": {
                "name": "Waywarde Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48532.5,
                  41315.8
                ],
                "id": 760,
                "chat_link": "[&BPgCAAA=]"
              },
              "761": {
                "name": "Xenarius Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48249.8,
                  40845.8
                ],
                "id": 761,
                "chat_link": "[&BPkCAAA=]"
              },
              "762": {
                "name": "Glorious Victory Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  47819.1,
                  40959.7
                ],
                "id": 762,
                "chat_link": "[&BPoCAAA=]"
              },
              "763": {
                "name": "Sentry Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  47420.5,
                  40811.6
                ],
                "id": 763,
                "chat_link": "[&BPsCAAA=]"
              },
              "816": {
                "name": "Zaishen Antheneum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47644,
                  40286.8
                ],
                "id": 816,
                "chat_link": "[&BDADAAA=]"
              },
              "1021": {
                "name": "Armada Harbor",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49843.7,
                  39841
                ],
                "id": 1021,
                "chat_link": "[&BP0DAAA=]"
              },
              "1022": {
                "name": "Alseta Generator",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50143,
                  39986.2
                ],
                "id": 1022,
                "chat_link": "[&BP4DAAA=]"
              },
              "1023": {
                "name": "Caer Aval",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49933.9,
                  40162.5
                ],
                "id": 1023,
                "chat_link": "[&BP8DAAA=]"
              },
              "1230": {
                "name": "Lasciate Gateway",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48718.1,
                  40886
                ],
                "id": 1230,
                "chat_link": "[&BM4EAAA=]"
              },
              "1231": {
                "name": "Brassburn Torch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48290.8,
                  39625.1
                ],
                "id": 1231,
                "chat_link": "[&BM8EAAA=]"
              },
              "1232": {
                "name": "Pact Rally Point",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48051.7,
                  40415.4
                ],
                "id": 1232,
                "chat_link": "[&BNAEAAA=]"
              },
              "1233": {
                "name": "Conservatory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48667.1,
                  41105.2
                ],
                "id": 1233,
                "chat_link": "[&BNEEAAA=]"
              },
              "1234": {
                "name": "Rally Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48072.4,
                  40387.3
                ],
                "id": 1234,
                "chat_link": "[&BNIEAAA=]"
              },
              "1624": {
                "name": "Plinth Timberland Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50065.2,
                  39284.9
                ],
                "id": 1624,
                "chat_link": "[&BFgGAAA=]"
              },
              "1625": {
                "name": "Underbelly Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49736.8,
                  39268.3
                ],
                "id": 1625,
                "chat_link": "[&BFkGAAA=]"
              },
              "1626": {
                "name": "The Underbelly",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49702.6,
                  39078.4
                ],
                "id": 1626,
                "chat_link": "[&BFoGAAA=]"
              },
              "1723": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  49702.3,
                  39994.7
                ],
                "id": 1723,
                "chat_link": "[&BLsGAAA=]"
              },
              "1724": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  49206.6,
                  39884.4
                ],
                "id": 1724,
                "chat_link": "[&BLwGAAA=]"
              },
              "1725": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  47955.9,
                  40541.8
                ],
                "id": 1725,
                "chat_link": "[&BL0GAAA=]"
              },
              "1726": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  50377.5,
                  40548.8
                ],
                "id": 1726,
                "chat_link": "[&BL4GAAA=]"
              },
              "1727": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  49175.5,
                  40670.3
                ],
                "id": 1727,
                "chat_link": "[&BL8GAAA=]"
              },
              "1728": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  49630.2,
                  40893.1
                ],
                "id": 1728,
                "chat_link": "[&BMAGAAA=]"
              },
              "1765": {
                "name": "Dire Shoal Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  47706.6,
                  39501.8
                ],
                "id": 1765,
                "chat_link": "[&BOUGAAA=]"
              }
            },
            "god_shrines": [
              {
                "id": 3,
                "name": "Temple of Balthazar <c=#a9a9a9>[Uncontested]</c><br>• All Balthazar statues in Orr are disabled.</c>",
                "name_contested": "Temple of Balthazar <c=#ff8c00>[Contested]</c><br>• All Balthazar statues in Orr are active.",
                "coord": [
                  47839.1,
                  41007.8
                ],
                "poi_id": 762,
                "icon": "https://render.guildwars2.com/file/61EB4505770BBC22013E4EBD60D2B878456C9712/347219.png",
                "icon_contested": "https://render.guildwars2.com/file/4B937E3ECA980ACD29655EA1D767DD5E0E23462F/347220.png"
              }
            ],
            "tasks": {},
            "skill_challenges": [
              {
                "coord": [
                  47752.3,
                  40642.4
                ],
                "id": "0-50"
              },
              {
                "coord": [
                  47379.4,
                  39712.9
                ],
                "id": "0-157"
              },
              {
                "coord": [
                  47872.8,
                  41090.8
                ],
                "id": "0-158"
              },
              {
                "coord": [
                  47551.6,
                  40292.2
                ],
                "id": "0-159"
              },
              {
                "coord": [
                  50070.7,
                  40060.3
                ],
                "id": "0-160"
              },
              {
                "coord": [
                  47563.3,
                  41241.2
                ],
                "id": "0-161"
              },
              {
                "coord": [
                  49203.8,
                  40678.5
                ],
                "id": "0-162"
              },
              {
                "coord": [
                  48028.9,
                  40335.7
                ],
                "id": "0-163"
              },
              {
                "coord": [
                  48789.4,
                  39472.5
                ],
                "id": "0-164"
              },
              {
                "coord": [
                  49377.8,
                  40315
                ],
                "id": "0-165"
              },
              {
                "coord": [
                  48640.8,
                  39592.3
                ],
                "id": "0-239"
              },
              {
                "coord": [
                  48267.3,
                  40610.5
                ],
                "id": "0-240"
              }
            ],
            "sectors": {
              "677": {
                "name": "Zho'qafa Catacombs",
                "level": 75,
                "coord": [
                  47891.1,
                  41342.3
                ],
                "bounds": [
                  [
                    47487.9,
                    41532.4
                  ],
                  [
                    47580.7,
                    41285.2
                  ],
                  [
                    47683.9,
                    41207.8
                  ],
                  [
                    47986.7,
                    41220.3
                  ],
                  [
                    48063.1,
                    41125.5
                  ],
                  [
                    48169.8,
                    41296.6
                  ],
                  [
                    48298.1,
                    41529
                  ],
                  [
                    47858.5,
                    41541.3
                  ],
                  [
                    47487.9,
                    41532.4
                  ]
                ],
                "id": 677,
                "chat_link": "[&BKUCAAA=]"
              },
              "678": {
                "name": "Blighted Battleground",
                "level": 74,
                "coord": [
                  48924.2,
                  41168.6
                ],
                "bounds": [
                  [
                    48933.6,
                    40687.6
                  ],
                  [
                    49097.6,
                    40854.3
                  ],
                  [
                    49062,
                    40969.4
                  ],
                  [
                    49107.9,
                    41275.7
                  ],
                  [
                    49246.2,
                    41325.4
                  ],
                  [
                    49195.4,
                    41494.7
                  ],
                  [
                    48976.5,
                    41548.6
                  ],
                  [
                    48742,
                    41542.1
                  ],
                  [
                    48678.1,
                    41452
                  ],
                  [
                    48703,
                    41241.4
                  ],
                  [
                    48804.6,
                    41037.9
                  ],
                  [
                    48684.3,
                    40979.7
                  ],
                  [
                    48783.3,
                    40783
                  ],
                  [
                    48933.6,
                    40687.6
                  ]
                ],
                "id": 678,
                "chat_link": "[&BKYCAAA=]"
              },
              "679": {
                "name": "Bramble Pass",
                "level": 71,
                "coord": [
                  50032.6,
                  38927.7
                ],
                "bounds": [
                  [
                    49897.9,
                    38692.4
                  ],
                  [
                    50052,
                    38695.7
                  ],
                  [
                    50223.2,
                    38766.2
                  ],
                  [
                    50403.4,
                    38649.9
                  ],
                  [
                    50561.5,
                    38782.9
                  ],
                  [
                    50620.4,
                    38978.3
                  ],
                  [
                    50368.6,
                    39027.9
                  ],
                  [
                    50095.2,
                    39208
                  ],
                  [
                    49803.1,
                    39239.4
                  ],
                  [
                    49618.6,
                    39179.2
                  ],
                  [
                    49567.1,
                    39090.5
                  ],
                  [
                    49547.1,
                    38964.4
                  ],
                  [
                    49665.5,
                    38785.4
                  ],
                  [
                    49897.9,
                    38692.4
                  ]
                ],
                "id": 679,
                "chat_link": "[&BKcCAAA=]"
              },
              "681": {
                "name": "Cathedral of Glorious Victory",
                "level": 75,
                "coord": [
                  47772.1,
                  41047.8
                ],
                "bounds": [
                  [
                    48060.8,
                    40947.4
                  ],
                  [
                    48063.2,
                    41125.7
                  ],
                  [
                    47986.9,
                    41220.6
                  ],
                  [
                    47681.5,
                    41210.3
                  ],
                  [
                    47580.9,
                    41284.1
                  ],
                  [
                    47509.6,
                    41157.4
                  ],
                  [
                    47581,
                    41000
                  ],
                  [
                    47653.6,
                    40840.6
                  ],
                  [
                    47738.9,
                    40857.1
                  ],
                  [
                    47864.7,
                    40834.2
                  ],
                  [
                    48060.8,
                    40947.4
                  ]
                ],
                "id": 681,
                "chat_link": "[&BKkCAAA=]"
              },
              "682": {
                "name": "Crippled Bridges",
                "level": 74,
                "coord": [
                  48061.1,
                  39900.9
                ],
                "bounds": [
                  [
                    48088.5,
                    40124.6
                  ],
                  [
                    48036.3,
                    40245.6
                  ],
                  [
                    47780.4,
                    40260.2
                  ],
                  [
                    47749,
                    40116
                  ],
                  [
                    47831.9,
                    39922.6
                  ],
                  [
                    47951.5,
                    39642
                  ],
                  [
                    48179.8,
                    39716.7
                  ],
                  [
                    48269.3,
                    39581.2
                  ],
                  [
                    48319.8,
                    39572.6
                  ],
                  [
                    48404,
                    39827.2
                  ],
                  [
                    48088.5,
                    40124.6
                  ]
                ],
                "id": 682,
                "chat_link": "[&BKoCAAA=]"
              },
              "683": {
                "name": "Elysium Beach",
                "level": 74,
                "coord": [
                  47519.8,
                  39805.5
                ],
                "bounds": [
                  [
                    47695.4,
                    39581.6
                  ],
                  [
                    47951.3,
                    39637.7
                  ],
                  [
                    47831.9,
                    39922.9
                  ],
                  [
                    47750.9,
                    40114.5
                  ],
                  [
                    47587.4,
                    40086.5
                  ],
                  [
                    47132,
                    40071.6
                  ],
                  [
                    47029.6,
                    39813.9
                  ],
                  [
                    47243.5,
                    39544.8
                  ],
                  [
                    47436.3,
                    39677.5
                  ],
                  [
                    47539.3,
                    39603.8
                  ],
                  [
                    47695.4,
                    39581.6
                  ]
                ],
                "id": 683,
                "chat_link": "[&BKsCAAA=]"
              },
              "684": {
                "name": "Fort Trinity",
                "level": 71,
                "coord": [
                  50040.2,
                  39934
                ],
                "bounds": [
                  [
                    49835.6,
                    39572.2
                  ],
                  [
                    49992,
                    39616.4
                  ],
                  [
                    50251.7,
                    39775.9
                  ],
                  [
                    50244.2,
                    39912.7
                  ],
                  [
                    50296.7,
                    39959.1
                  ],
                  [
                    50291.5,
                    40014.9
                  ],
                  [
                    50254.4,
                    40055.6
                  ],
                  [
                    50205.3,
                    40064.9
                  ],
                  [
                    50007.9,
                    40260.7
                  ],
                  [
                    49911.3,
                    40265.5
                  ],
                  [
                    49799.9,
                    40158.6
                  ],
                  [
                    49695.4,
                    39860.6
                  ],
                  [
                    49736.9,
                    39624.7
                  ],
                  [
                    49835.6,
                    39572.2
                  ]
                ],
                "id": 684,
                "chat_link": "[&BKwCAAA=]"
              },
              "685": {
                "name": "Half Circle Cove",
                "level": 71,
                "coord": [
                  49613.2,
                  39265
                ],
                "bounds": [
                  [
                    49619,
                    39180.9
                  ],
                  [
                    49802.6,
                    39241
                  ],
                  [
                    49767.1,
                    39480
                  ],
                  [
                    49555.1,
                    39411.2
                  ],
                  [
                    49367.4,
                    39183.4
                  ],
                  [
                    49568.2,
                    39093.6
                  ],
                  [
                    49619,
                    39180.9
                  ]
                ],
                "id": 685,
                "chat_link": "[&BK0CAAA=]"
              },
              "686": {
                "name": "Hunter's Table",
                "level": 74,
                "coord": [
                  48422.2,
                  40299.5
                ],
                "bounds": [
                  [
                    48581.6,
                    40457.8
                  ],
                  [
                    48676.4,
                    40723.8
                  ],
                  [
                    48369.7,
                    40736.5
                  ],
                  [
                    48349.8,
                    40567.3
                  ],
                  [
                    48031.8,
                    40244
                  ],
                  [
                    48085.6,
                    40124.2
                  ],
                  [
                    48405.3,
                    39825.2
                  ],
                  [
                    48546.8,
                    39968.6
                  ],
                  [
                    48604.8,
                    40075.8
                  ],
                  [
                    48570.1,
                    40272.3
                  ],
                  [
                    48581.6,
                    40457.8
                  ]
                ],
                "id": 686,
                "chat_link": "[&BK4CAAA=]"
              },
              "687": {
                "name": "Lightfoot Passage",
                "level": 71,
                "coord": [
                  50326,
                  40540
                ],
                "bounds": [
                  [
                    50459.6,
                    40770
                  ],
                  [
                    50158.8,
                    40778.6
                  ],
                  [
                    50095.9,
                    40473.2
                  ],
                  [
                    50191.3,
                    40414
                  ],
                  [
                    50348.9,
                    40268
                  ],
                  [
                    50514.7,
                    40427.1
                  ],
                  [
                    50512.9,
                    40649.4
                  ],
                  [
                    50459.6,
                    40770
                  ]
                ],
                "id": 687,
                "chat_link": "[&BK8CAAA=]"
              },
              "688": {
                "name": "Triumph Plaza",
                "level": 75,
                "coord": [
                  47818.9,
                  40630.6
                ],
                "bounds": [
                  [
                    48350.6,
                    40567.2
                  ],
                  [
                    48373.8,
                    40736.3
                  ],
                  [
                    48060.6,
                    40947.2
                  ],
                  [
                    47864.6,
                    40833.4
                  ],
                  [
                    47739.1,
                    40857
                  ],
                  [
                    47654.2,
                    40840.8
                  ],
                  [
                    47227.6,
                    40639.9
                  ],
                  [
                    47212,
                    40541.4
                  ],
                  [
                    47706.7,
                    40468.8
                  ],
                  [
                    47783.5,
                    40260
                  ],
                  [
                    48035,
                    40244.4
                  ],
                  [
                    48350.6,
                    40567.2
                  ]
                ],
                "id": 688,
                "chat_link": "[&BLACAAA=]"
              },
              "689": {
                "name": "Plinth Timberland",
                "level": 71,
                "coord": [
                  50144.7,
                  39410.1
                ],
                "bounds": [
                  [
                    50095.5,
                    39208
                  ],
                  [
                    50369.5,
                    39026.5
                  ],
                  [
                    50620.5,
                    38979
                  ],
                  [
                    50594.9,
                    39484.4
                  ],
                  [
                    50211.8,
                    39598.1
                  ],
                  [
                    50184.8,
                    39739.2
                  ],
                  [
                    49992.5,
                    39617.7
                  ],
                  [
                    49833.3,
                    39580.2
                  ],
                  [
                    49742.7,
                    39629.1
                  ],
                  [
                    49801.4,
                    39238.6
                  ],
                  [
                    50095.5,
                    39208
                  ]
                ],
                "id": 689,
                "chat_link": "[&BLECAAA=]"
              },
              "690": {
                "name": "Sea of Elon",
                "level": 73,
                "coord": [
                  49859.8,
                  41152.7
                ],
                "bounds": [
                  [
                    50158.7,
                    40778.6
                  ],
                  [
                    50460.6,
                    40766.2
                  ],
                  [
                    50384.3,
                    41130.4
                  ],
                  [
                    50249.3,
                    41353.5
                  ],
                  [
                    50023.8,
                    41499.2
                  ],
                  [
                    49601.9,
                    41539.7
                  ],
                  [
                    49195.2,
                    41494.2
                  ],
                  [
                    49244.4,
                    41325.1
                  ],
                  [
                    49452.2,
                    41162.5
                  ],
                  [
                    49698.4,
                    40884
                  ],
                  [
                    49989.1,
                    40745.9
                  ],
                  [
                    50158.7,
                    40778.6
                  ]
                ],
                "id": 690,
                "chat_link": "[&BLICAAA=]"
              },
              "691": {
                "name": "Sentry Steppes",
                "level": 75,
                "coord": [
                  47368.1,
                  41059.3
                ],
                "bounds": [
                  [
                    47226.4,
                    40636
                  ],
                  [
                    47654,
                    40841.6
                  ],
                  [
                    47581.2,
                    40999.2
                  ],
                  [
                    47515.7,
                    41154.3
                  ],
                  [
                    47579.4,
                    41284.5
                  ],
                  [
                    47491.6,
                    41540.6
                  ],
                  [
                    47185.7,
                    41416.1
                  ],
                  [
                    47125.9,
                    41029.9
                  ],
                  [
                    47127.3,
                    40908.5
                  ],
                  [
                    47193.7,
                    40781.9
                  ],
                  [
                    47226.4,
                    40636
                  ]
                ],
                "id": 691,
                "chat_link": "[&BLMCAAA=]"
              },
              "692": {
                "name": "Shark's Teeth Archipelago",
                "level": 73,
                "coord": [
                  49388.6,
                  40870.7
                ],
                "bounds": [
                  [
                    49697.7,
                    40883.7
                  ],
                  [
                    49452.7,
                    41162.7
                  ],
                  [
                    49244.7,
                    41325.7
                  ],
                  [
                    49106.4,
                    41276.1
                  ],
                  [
                    49062.6,
                    40970.3
                  ],
                  [
                    49097.3,
                    40854.4
                  ],
                  [
                    48934,
                    40689.3
                  ],
                  [
                    49432.4,
                    40320.9
                  ],
                  [
                    49868.9,
                    40478.1
                  ],
                  [
                    49989.3,
                    40746.1
                  ],
                  [
                    49697.7,
                    40883.7
                  ]
                ],
                "id": 692,
                "chat_link": "[&BLQCAAA=]"
              },
              "693": {
                "name": "Signal Peak",
                "level": 71,
                "coord": [
                  49218.2,
                  39025.5
                ],
                "bounds": [
                  [
                    49569.3,
                    39093.7
                  ],
                  [
                    49367.5,
                    39183.6
                  ],
                  [
                    49218.5,
                    39123.9
                  ],
                  [
                    49144.3,
                    39127.4
                  ],
                  [
                    49110.9,
                    39203.2
                  ],
                  [
                    49032.5,
                    39273.5
                  ],
                  [
                    48969.7,
                    39276.7
                  ],
                  [
                    48842,
                    39061.3
                  ],
                  [
                    48951.9,
                    38971.3
                  ],
                  [
                    48946.6,
                    38826.7
                  ],
                  [
                    49119.9,
                    38690.4
                  ],
                  [
                    49567.2,
                    38780
                  ],
                  [
                    49666,
                    38780.7
                  ],
                  [
                    49548.3,
                    38965.1
                  ],
                  [
                    49569.3,
                    39093.7
                  ]
                ],
                "id": 693,
                "chat_link": "[&BLUCAAA=]"
              },
              "694": {
                "name": "Squall Cusps",
                "level": 71,
                "coord": [
                  50083.2,
                  40420.1
                ],
                "bounds": [
                  [
                    50177.9,
                    40097
                  ],
                  [
                    50348.3,
                    40267.7
                  ],
                  [
                    50191.4,
                    40413.9
                  ],
                  [
                    50095.7,
                    40473
                  ],
                  [
                    50158.9,
                    40778.8
                  ],
                  [
                    49989.2,
                    40745.8
                  ],
                  [
                    49868.8,
                    40478.3
                  ],
                  [
                    49911.7,
                    40266.4
                  ],
                  [
                    50006.7,
                    40260.5
                  ],
                  [
                    50177.9,
                    40097
                  ]
                ],
                "id": 694,
                "chat_link": "[&BLYCAAA=]"
              },
              "695": {
                "name": "Strait of Malediction",
                "level": 73,
                "coord": [
                  48130.9,
                  39270.4
                ],
                "bounds": [
                  [
                    48946.1,
                    38826.9
                  ],
                  [
                    48951.2,
                    38971.5
                  ],
                  [
                    48841.6,
                    39061.4
                  ],
                  [
                    48894.9,
                    39150.7
                  ],
                  [
                    48670.3,
                    39524.2
                  ],
                  [
                    48269.9,
                    39582.4
                  ],
                  [
                    48178.1,
                    39715.9
                  ],
                  [
                    47949.5,
                    39636.4
                  ],
                  [
                    47694.9,
                    39581.3
                  ],
                  [
                    47538.4,
                    39603.3
                  ],
                  [
                    47436.5,
                    39677.3
                  ],
                  [
                    47240.7,
                    39546.9
                  ],
                  [
                    47373.8,
                    39334.6
                  ],
                  [
                    47528.4,
                    39063.8
                  ],
                  [
                    47821.7,
                    39084.7
                  ],
                  [
                    48095.5,
                    38968.2
                  ],
                  [
                    48272,
                    38831.7
                  ],
                  [
                    48653.1,
                    38705.4
                  ],
                  [
                    48946.1,
                    38826.9
                  ]
                ],
                "id": 695,
                "chat_link": "[&BLcCAAA=]"
              },
              "696": {
                "name": "Strait of Sacrilege",
                "level": 73,
                "coord": [
                  48746.7,
                  40042
                ],
                "bounds": [
                  [
                    48895.7,
                    39149.8
                  ],
                  [
                    48969.7,
                    39276.7
                  ],
                  [
                    49082.6,
                    39961.7
                  ],
                  [
                    49431.6,
                    40321.2
                  ],
                  [
                    48934.1,
                    40688.2
                  ],
                  [
                    48783.9,
                    40782.9
                  ],
                  [
                    48674.3,
                    40724.4
                  ],
                  [
                    48582.3,
                    40451.8
                  ],
                  [
                    48567.6,
                    40273.6
                  ],
                  [
                    48601,
                    40074.1
                  ],
                  [
                    48545,
                    39970.6
                  ],
                  [
                    48407.4,
                    39828.4
                  ],
                  [
                    48311.4,
                    39564.6
                  ],
                  [
                    48666.5,
                    39519.7
                  ],
                  [
                    48895.7,
                    39149.8
                  ]
                ],
                "id": 696,
                "chat_link": "[&BLgCAAA=]"
              },
              "697": {
                "name": "Terzetto Bay",
                "level": 72,
                "coord": [
                  49446.3,
                  39650.2
                ],
                "bounds": [
                  [
                    49801.1,
                    40156.9
                  ],
                  [
                    49907.6,
                    40267.9
                  ],
                  [
                    49869.1,
                    40478.5
                  ],
                  [
                    49431.7,
                    40320.8
                  ],
                  [
                    49082.8,
                    39962
                  ],
                  [
                    48969.6,
                    39276.6
                  ],
                  [
                    49033,
                    39273.5
                  ],
                  [
                    49111.3,
                    39202.9
                  ],
                  [
                    49144,
                    39127.4
                  ],
                  [
                    49218.4,
                    39124.2
                  ],
                  [
                    49367.5,
                    39183
                  ],
                  [
                    49554,
                    39411.3
                  ],
                  [
                    49765.7,
                    39477.4
                  ],
                  [
                    49743.7,
                    39630.5
                  ],
                  [
                    49694.8,
                    39860.4
                  ],
                  [
                    49801.1,
                    40156.9
                  ]
                ],
                "id": 697,
                "chat_link": "[&BLkCAAA=]"
              },
              "698": {
                "name": "The Bloodtrough",
                "level": 75,
                "coord": [
                  47529.4,
                  40260
                ],
                "bounds": [
                  [
                    47588.7,
                    40086
                  ],
                  [
                    47750.5,
                    40115.2
                  ],
                  [
                    47782.3,
                    40257.9
                  ],
                  [
                    47707.2,
                    40469.1
                  ],
                  [
                    47213.4,
                    40559.3
                  ],
                  [
                    47134.5,
                    40072.6
                  ],
                  [
                    47588.7,
                    40086
                  ]
                ],
                "id": 698,
                "chat_link": "[&BLoCAAA=]"
              },
              "700": {
                "name": "Thorn Pass",
                "level": 71,
                "coord": [
                  50336.3,
                  39930
                ],
                "bounds": [
                  [
                    50521.6,
                    40019.4
                  ],
                  [
                    50522.8,
                    40433.9
                  ],
                  [
                    50174.7,
                    40097
                  ],
                  [
                    50206.4,
                    40064.8
                  ],
                  [
                    50254.2,
                    40055.9
                  ],
                  [
                    50290.9,
                    40016.4
                  ],
                  [
                    50297,
                    39958.8
                  ],
                  [
                    50244.1,
                    39912.3
                  ],
                  [
                    50251.1,
                    39775
                  ],
                  [
                    50183.8,
                    39736
                  ],
                  [
                    50212.2,
                    39598.1
                  ],
                  [
                    50594.1,
                    39482.9
                  ],
                  [
                    50619.3,
                    39938.8
                  ],
                  [
                    50521.6,
                    40019.4
                  ]
                ],
                "id": 700,
                "chat_link": "[&BLwCAAA=]"
              },
              "701": {
                "name": "Waywarde Way",
                "level": 74,
                "coord": [
                  48571.3,
                  41288.4
                ],
                "bounds": [
                  [
                    48698.5,
                    41244
                  ],
                  [
                    48678.4,
                    41450.6
                  ],
                  [
                    48742.5,
                    41542.4
                  ],
                  [
                    48488.3,
                    41524.4
                  ],
                  [
                    48294,
                    41529.2
                  ],
                  [
                    48170,
                    41296.6
                  ],
                  [
                    48577.5,
                    40998.7
                  ],
                  [
                    48686.7,
                    40972
                  ],
                  [
                    48806,
                    41038
                  ],
                  [
                    48698.5,
                    41244
                  ]
                ],
                "id": 701,
                "chat_link": "[&BL0CAAA=]"
              },
              "702": {
                "name": "Xenarius Bayt",
                "level": 74,
                "coord": [
                  48423.4,
                  40949.1
                ],
                "bounds": [
                  [
                    48578.9,
                    40998.2
                  ],
                  [
                    48169.7,
                    41296.8
                  ],
                  [
                    48063.2,
                    41125.5
                  ],
                  [
                    48060.5,
                    40947.3
                  ],
                  [
                    48368.8,
                    40731.8
                  ],
                  [
                    48674.8,
                    40724.9
                  ],
                  [
                    48783.3,
                    40782.8
                  ],
                  [
                    48687.6,
                    40985.5
                  ],
                  [
                    48578.9,
                    40998.2
                  ]
                ],
                "id": 702,
                "chat_link": "[&BL4CAAA=]"
              }
            },
            "adventures": [],
            "id": 51,
            "mastery_points": []
          },
          "62": {
            "name": "Cursed Shore",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              43904,
              43648
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42880,
                41600
              ],
              [
                44928,
                45696
              ]
            ],
            "points_of_interest": {
              "764": {
                "name": "Bitter Mountain",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44098.5,
                  41827.2
                ],
                "id": 764,
                "chat_link": "[&BPwCAAA=]"
              },
              "765": {
                "name": "Caer Shadowfain",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44064.5,
                  42175.3
                ],
                "id": 765,
                "chat_link": "[&BP0CAAA=]"
              },
              "766": {
                "name": "Village Sayix",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44127,
                  42578.3
                ],
                "id": 766,
                "chat_link": "[&BP4CAAA=]"
              },
              "767": {
                "name": "Seachange Tidepools",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43345.9,
                  42147.4
                ],
                "id": 767,
                "chat_link": "[&BP8CAAA=]"
              },
              "768": {
                "name": "Cachistic R&D",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43612.3,
                  42366.9
                ],
                "id": 768,
                "chat_link": "[&BAADAAA=]"
              },
              "769": {
                "name": "Gavbeorn's Landing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43289.5,
                  42903.7
                ],
                "id": 769,
                "chat_link": "[&BAEDAAA=]"
              },
              "770": {
                "name": "Bakkir Sarayi",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43568.5,
                  42859.6
                ],
                "id": 770,
                "chat_link": "[&BAIDAAA=]"
              },
              "771": {
                "name": "Winterknell Labyrinth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43897.2,
                  42783.5
                ],
                "id": 771,
                "chat_link": "[&BAMDAAA=]"
              },
              "772": {
                "name": "Shelter's Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44493.3,
                  42992.8
                ],
                "id": 772,
                "chat_link": "[&BAQDAAA=]"
              },
              "773": {
                "name": "Gallow's Hang",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44672.4,
                  43265.7
                ],
                "id": 773,
                "chat_link": "[&BAUDAAA=]"
              },
              "774": {
                "name": "Village of Ewan",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43809.9,
                  43500.2
                ],
                "id": 774,
                "chat_link": "[&BAYDAAA=]"
              },
              "775": {
                "name": "Thorn Dock",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43601.5,
                  43583.3
                ],
                "id": 775,
                "chat_link": "[&BAcDAAA=]"
              },
              "776": {
                "name": "The Wreck of the Golden Vanity",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43108.7,
                  43577.4
                ],
                "id": 776,
                "chat_link": "[&BAgDAAA=]"
              },
              "777": {
                "name": "Harbinger Torch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43195.8,
                  44094.9
                ],
                "id": 777,
                "chat_link": "[&BAkDAAA=]"
              },
              "778": {
                "name": "Death's Gaze Torch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43156.2,
                  44541.9
                ],
                "id": 778,
                "chat_link": "[&BAoDAAA=]"
              },
              "779": {
                "name": "Buried Archives",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43630.9,
                  45044.5
                ],
                "id": 779,
                "chat_link": "[&BAsDAAA=]"
              },
              "780": {
                "name": "Altar of Murdered Dreams",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43244.2,
                  45035.3
                ],
                "id": 780,
                "chat_link": "[&BAwDAAA=]"
              },
              "781": {
                "name": "Death's Anthem",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44349.1,
                  45215.8
                ],
                "id": 781,
                "chat_link": "[&BA0DAAA=]"
              },
              "782": {
                "name": "The Wreck of the Saehrimnir",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44680.7,
                  45286
                ],
                "id": 782,
                "chat_link": "[&BA4DAAA=]"
              },
              "783": {
                "name": "Meddler's Summit",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43844,
                  43780.8
                ],
                "id": 783,
                "chat_link": "[&BA8DAAA=]"
              },
              "784": {
                "name": "Telmat Knoll",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43970.5,
                  44022.1
                ],
                "id": 784,
                "chat_link": "[&BBADAAA=]"
              },
              "785": {
                "name": "Augur's Torch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43818.7,
                  44420.7
                ],
                "id": 785,
                "chat_link": "[&BBEDAAA=]"
              },
              "786": {
                "name": "Shank Anchorage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43788.6,
                  44254.2
                ],
                "id": 786,
                "chat_link": "[&BBIDAAA=]"
              },
              "787": {
                "name": "Sharn's Free Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44164.1,
                  44775.7
                ],
                "id": 787,
                "chat_link": "[&BBMDAAA=]"
              },
              "788": {
                "name": "Reliquary Vault",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44343,
                  43752.6
                ],
                "id": 788,
                "chat_link": "[&BBQDAAA=]"
              },
              "789": {
                "name": "Gates of Arah",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44693.3,
                  44111.8
                ],
                "id": 789,
                "chat_link": "[&BBUDAAA=]"
              },
              "790": {
                "name": "Altar of the Withered Heart",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44058.2,
                  43081.5
                ],
                "id": 790,
                "chat_link": "[&BBYDAAA=]"
              },
              "791": {
                "name": "Pursuit Pass Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44523.8,
                  41785.7
                ],
                "id": 791,
                "chat_link": "[&BBcDAAA=]"
              },
              "792": {
                "name": "R&D Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43631.7,
                  42391.8
                ],
                "id": 792,
                "chat_link": "[&BBgDAAA=]"
              },
              "793": {
                "name": "Penitent Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44208.5,
                  42598.4
                ],
                "id": 793,
                "chat_link": "[&BBkDAAA=]"
              },
              "794": {
                "name": "Gavbeorn's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43265.7,
                  42875.5
                ],
                "id": 794,
                "chat_link": "[&BBoDAAA=]"
              },
              "795": {
                "name": "Verdance Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43953.6,
                  43173.1
                ],
                "id": 795,
                "chat_link": "[&BBsDAAA=]"
              },
              "796": {
                "name": "Shelter's Gate Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44476.2,
                  42973.6
                ],
                "id": 796,
                "chat_link": "[&BBwDAAA=]"
              },
              "797": {
                "name": "Jofast's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44339.4,
                  43403.7
                ],
                "id": 797,
                "chat_link": "[&BB0DAAA=]"
              },
              "798": {
                "name": "Meddler's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43853.8,
                  43751.8
                ],
                "id": 798,
                "chat_link": "[&BB4DAAA=]"
              },
              "799": {
                "name": "Anchorage Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43741.1,
                  44276.6
                ],
                "id": 799,
                "chat_link": "[&BB8DAAA=]"
              },
              "800": {
                "name": "Arah Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44754.9,
                  44115.3
                ],
                "id": 800,
                "chat_link": "[&BCADAAA=]"
              },
              "801": {
                "name": "Caer Shadowfain Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44087.2,
                  42138.6
                ],
                "id": 801,
                "chat_link": "[&BCEDAAA=]"
              },
              "802": {
                "name": "Murdered Dreams Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43289.7,
                  45056.9
                ],
                "id": 802,
                "chat_link": "[&BCIDAAA=]"
              },
              "1718": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43927.5,
                  45206
                ],
                "id": 1718,
                "chat_link": "[&BLYGAAA=]"
              },
              "1719": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43789.3,
                  44259.5
                ],
                "id": 1719,
                "chat_link": "[&BLcGAAA=]"
              },
              "1720": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43283,
                  42840.8
                ],
                "id": 1720,
                "chat_link": "[&BLgGAAA=]"
              },
              "1721": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  44088.6,
                  43799.6
                ],
                "id": 1721,
                "chat_link": "[&BLkGAAA=]"
              },
              "1722": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  44030.2,
                  42181.9
                ],
                "id": 1722,
                "chat_link": "[&BLoGAAA=]"
              },
              "1735": {
                "name": "The Ruined City of Arah",
                "type": "unlock",
                "floor": 1,
                "coord": [
                  44802.4,
                  44060.5
                ],
                "id": 1735,
                "chat_link": "[&BMcGAAA=]",
                "icon": "https://render.guildwars2.com/file/943538394A94A491C8632FBEF6203C2013443555/102478.png"
              },
              "1764": {
                "name": "Shipwreck Rock Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44616.1,
                  45441.1
                ],
                "id": 1764,
                "chat_link": "[&BOQGAAA=]"
              }
            },
            "god_shrines": [
              {
                "id": 5,
                "name": "Temple of Grenth <c=#a9a9a9>[Uncontested]</c><br>• All Grenth statues in Orr are disabled.</c>",
                "name_contested": "Temple of Grenth <c=#ff8c00>[Contested]</c><br>• All Grenth statues in Orr are active.",
                "coord": [
                  43203.4,
                  45053.6
                ],
                "poi_id": 802,
                "icon": "https://render.guildwars2.com/file/61EB4505770BBC22013E4EBD60D2B878456C9712/347219.png",
                "icon_contested": "https://render.guildwars2.com/file/4B937E3ECA980ACD29655EA1D767DD5E0E23462F/347220.png"
              },
              {
                "id": 2,
                "name": "Temple of Melandru <c=#a9a9a9>[Uncontested]</c><br>• All Melandru statues in Orr are disabled.</c>",
                "name_contested": "Temple of Melandru <c=#ff8c00>[Contested]</c><br>• All Melandru statues in Orr are active.",
                "coord": [
                  44056.1,
                  43112.1
                ],
                "poi_id": 795,
                "icon": "https://render.guildwars2.com/file/61EB4505770BBC22013E4EBD60D2B878456C9712/347219.png",
                "icon_contested": "https://render.guildwars2.com/file/4B937E3ECA980ACD29655EA1D767DD5E0E23462F/347220.png"
              }
            ],
            "tasks": {},
            "skill_challenges": [
              {
                "coord": [
                  43139.6,
                  45060.1
                ],
                "id": "0-176"
              },
              {
                "coord": [
                  44082,
                  43094.4
                ],
                "id": "0-177"
              },
              {
                "coord": [
                  44686.4,
                  43266.9
                ],
                "id": "0-178"
              },
              {
                "coord": [
                  44467.3,
                  45300
                ],
                "id": "0-179"
              },
              {
                "coord": [
                  43777.5,
                  43525.9
                ],
                "id": "0-180"
              },
              {
                "coord": [
                  44028.3,
                  42216
                ],
                "id": "0-181"
              },
              {
                "coord": [
                  43210.6,
                  44114.3
                ],
                "id": "0-182"
              },
              {
                "coord": [
                  43710.2,
                  44444.3
                ],
                "id": "0-183"
              },
              {
                "coord": [
                  43126.3,
                  43568.3
                ],
                "id": "0-184"
              },
              {
                "coord": [
                  44389.9,
                  43758.4
                ],
                "id": "0-185"
              },
              {
                "coord": [
                  43140.8,
                  42076.4
                ],
                "id": "0-186"
              },
              {
                "coord": [
                  44023.2,
                  45444.6
                ],
                "id": "0-187"
              },
              {
                "coord": [
                  44151.8,
                  44777
                ],
                "id": "0-188"
              },
              {
                "coord": [
                  43877.8,
                  43778.8
                ],
                "id": "0-189"
              },
              {
                "coord": [
                  43868.2,
                  42679.3
                ],
                "id": "0-190"
              },
              {
                "coord": [
                  43584.1,
                  41952.8
                ],
                "id": "0-241"
              },
              {
                "coord": [
                  43300.7,
                  44320.8
                ],
                "id": "0-242"
              }
            ],
            "sectors": {
              "703": {
                "name": "Pursuit Pass",
                "level": 80,
                "coord": [
                  44478.3,
                  41846.8
                ],
                "bounds": [
                  [
                    44537.5,
                    41605
                  ],
                  [
                    44686.1,
                    41517.6
                  ],
                  [
                    44873.2,
                    41527.4
                  ],
                  [
                    44999.7,
                    41752.5
                  ],
                  [
                    44967.8,
                    42010.5
                  ],
                  [
                    44865.6,
                    42192.7
                  ],
                  [
                    44717.7,
                    42500.6
                  ],
                  [
                    44567.7,
                    42397.4
                  ],
                  [
                    43935.7,
                    42122.8
                  ],
                  [
                    43873,
                    41844.7
                  ],
                  [
                    43974.1,
                    41742.3
                  ],
                  [
                    44055.9,
                    41604
                  ],
                  [
                    44229.9,
                    41515.6
                  ],
                  [
                    44412.8,
                    41521.8
                  ],
                  [
                    44537.5,
                    41605
                  ]
                ],
                "id": 703,
                "chat_link": "[&BL8CAAA=]"
              },
              "704": {
                "name": "Fields of Gold",
                "level": 80,
                "coord": [
                  43910.4,
                  42076.2
                ],
                "bounds": [
                  [
                    43935.4,
                    42121.6
                  ],
                  [
                    44568.1,
                    42396.7
                  ],
                  [
                    44522.7,
                    42542.9
                  ],
                  [
                    44166.2,
                    42648.7
                  ],
                  [
                    44072.9,
                    42631.7
                  ],
                  [
                    43988.1,
                    42527.3
                  ],
                  [
                    43745,
                    42372.6
                  ],
                  [
                    43509,
                    42068.4
                  ],
                  [
                    43435.7,
                    41834.7
                  ],
                  [
                    43441.1,
                    41711.9
                  ],
                  [
                    43569,
                    41556.1
                  ],
                  [
                    43803.3,
                    41532.1
                  ],
                  [
                    44054,
                    41612.9
                  ],
                  [
                    43973.2,
                    41742.1
                  ],
                  [
                    43872.4,
                    41843.5
                  ],
                  [
                    43935.4,
                    42121.6
                  ]
                ],
                "id": 704,
                "chat_link": "[&BMACAAA=]"
              },
              "705": {
                "name": "Winterknell Shore",
                "level": 80,
                "coord": [
                  43316.7,
                  42420.2
                ],
                "bounds": [
                  [
                    43436,
                    41835.2
                  ],
                  [
                    43508.9,
                    42068.7
                  ],
                  [
                    43744.8,
                    42372.7
                  ],
                  [
                    43693.9,
                    42631.2
                  ],
                  [
                    43472.1,
                    42728.1
                  ],
                  [
                    43328.3,
                    43062.3
                  ],
                  [
                    43132.2,
                    43137.5
                  ],
                  [
                    42965.4,
                    42704.8
                  ],
                  [
                    43085.9,
                    42308.7
                  ],
                  [
                    42897.7,
                    42011.9
                  ],
                  [
                    43218,
                    41760.9
                  ],
                  [
                    43436,
                    41835.2
                  ]
                ],
                "id": 705,
                "chat_link": "[&BMECAAA=]"
              },
              "706": {
                "name": "Winterknell Isle",
                "level": 80,
                "coord": [
                  43808.8,
                  42790.9
                ],
                "bounds": [
                  [
                    43988.1,
                    42528.3
                  ],
                  [
                    44073.3,
                    42631.7
                  ],
                  [
                    44165,
                    42648.7
                  ],
                  [
                    44181.5,
                    42823.1
                  ],
                  [
                    44092.9,
                    42846.1
                  ],
                  [
                    43680.4,
                    43264.4
                  ],
                  [
                    43481.3,
                    43165.7
                  ],
                  [
                    43324.4,
                    43061.9
                  ],
                  [
                    43471.1,
                    42726.7
                  ],
                  [
                    43693.2,
                    42630.6
                  ],
                  [
                    43745.4,
                    42372.4
                  ],
                  [
                    43988.1,
                    42528.3
                  ]
                ],
                "id": 706,
                "chat_link": "[&BMICAAA=]"
              },
              "707": {
                "name": "Penitent Path",
                "level": 80,
                "coord": [
                  44288.7,
                  42852.1
                ],
                "bounds": [
                  [
                    44286.8,
                    42613.5
                  ],
                  [
                    44500.6,
                    42921.6
                  ],
                  [
                    44301.1,
                    43170
                  ],
                  [
                    44189.8,
                    42907.8
                  ],
                  [
                    44165.1,
                    42647.8
                  ],
                  [
                    44286.8,
                    42613.5
                  ]
                ],
                "id": 707,
                "chat_link": "[&BMMCAAA=]"
              },
              "708": {
                "name": "The Artesian Waters",
                "level": 80,
                "coord": [
                  44630.4,
                  42659.6
                ],
                "bounds": [
                  [
                    44518.4,
                    42539.9
                  ],
                  [
                    44562.9,
                    42386.7
                  ],
                  [
                    44890.9,
                    42593.2
                  ],
                  [
                    44886.7,
                    42720.2
                  ],
                  [
                    44764.7,
                    42858.1
                  ],
                  [
                    44502.1,
                    42922
                  ],
                  [
                    44286.9,
                    42597.4
                  ],
                  [
                    44518.4,
                    42539.9
                  ]
                ],
                "id": 708,
                "chat_link": "[&BMQCAAA=]"
              },
              "709": {
                "name": "Noose Road",
                "level": 80,
                "coord": [
                  44560.2,
                  43118.1
                ],
                "bounds": [
                  [
                    44460,
                    42970.4
                  ],
                  [
                    44497.3,
                    42926.2
                  ],
                  [
                    44643.3,
                    42887
                  ],
                  [
                    44791.1,
                    43088.9
                  ],
                  [
                    44782.1,
                    43404.7
                  ],
                  [
                    44445.3,
                    43380.2
                  ],
                  [
                    44302.3,
                    43169.2
                  ],
                  [
                    44460,
                    42970.4
                  ]
                ],
                "id": 709,
                "chat_link": "[&BMUCAAA=]"
              },
              "710": {
                "name": "Craven Blight",
                "level": 80,
                "coord": [
                  43892.2,
                  43433.8
                ],
                "bounds": [
                  [
                    44302.6,
                    43169.2
                  ],
                  [
                    44445.5,
                    43380.2
                  ],
                  [
                    44200.3,
                    43548.1
                  ],
                  [
                    44048.2,
                    43689.7
                  ],
                  [
                    43819.8,
                    43685.5
                  ],
                  [
                    43599.5,
                    43612.5
                  ],
                  [
                    43507.3,
                    43465.1
                  ],
                  [
                    43515.1,
                    43308.5
                  ],
                  [
                    43559.2,
                    43206.3
                  ],
                  [
                    43836.3,
                    43332.9
                  ],
                  [
                    43980.3,
                    43373.9
                  ],
                  [
                    44302.6,
                    43169.2
                  ]
                ],
                "id": 710,
                "chat_link": "[&BMYCAAA=]"
              },
              "711": {
                "name": "Cathedral of Verdance",
                "level": 80,
                "coord": [
                  44061,
                  43084.8
                ],
                "bounds": [
                  [
                    44183.8,
                    42822.9
                  ],
                  [
                    44190,
                    42908.3
                  ],
                  [
                    44227.2,
                    42963.7
                  ],
                  [
                    44302.1,
                    43169.3
                  ],
                  [
                    43979.9,
                    43373
                  ],
                  [
                    43836,
                    43333.7
                  ],
                  [
                    43676,
                    43261.1
                  ],
                  [
                    44093.5,
                    42846.5
                  ],
                  [
                    44183.8,
                    42822.9
                  ]
                ],
                "id": 711,
                "chat_link": "[&BMcCAAA=]"
              },
              "712": {
                "name": "Harrowed Sea",
                "level": 80,
                "coord": [
                  43317.1,
                  43485
                ],
                "bounds": [
                  [
                    43508.1,
                    43464.8
                  ],
                  [
                    43600,
                    43612.9
                  ],
                  [
                    43355.5,
                    43944.7
                  ],
                  [
                    43159.6,
                    43951.1
                  ],
                  [
                    42968,
                    43796.8
                  ],
                  [
                    43045.7,
                    43367.2
                  ],
                  [
                    43132.9,
                    43138
                  ],
                  [
                    43325.1,
                    43057.7
                  ],
                  [
                    43560.1,
                    43208.3
                  ],
                  [
                    43515.8,
                    43308.3
                  ],
                  [
                    43508.1,
                    43464.8
                  ]
                ],
                "id": 712,
                "chat_link": "[&BMgCAAA=]"
              },
              "713": {
                "name": "Graven Cay",
                "level": 80,
                "coord": [
                  43240.1,
                  44405.5
                ],
                "bounds": [
                  [
                    43355.3,
                    43945
                  ],
                  [
                    43449.9,
                    44017.6
                  ],
                  [
                    43417.8,
                    44233.1
                  ],
                  [
                    43669.5,
                    44680.8
                  ],
                  [
                    43466.1,
                    44843.4
                  ],
                  [
                    43311.4,
                    44897.3
                  ],
                  [
                    42964.4,
                    45104.8
                  ],
                  [
                    42979.5,
                    44725.9
                  ],
                  [
                    42899.5,
                    44264.3
                  ],
                  [
                    42968.6,
                    43796.9
                  ],
                  [
                    43159.2,
                    43951.5
                  ],
                  [
                    43355.3,
                    43945
                  ]
                ],
                "id": 713,
                "chat_link": "[&BMkCAAA=]"
              },
              "714": {
                "name": "Cathedral of Silence",
                "level": 80,
                "coord": [
                  43517.4,
                  45141.8
                ],
                "bounds": [
                  [
                    43465,
                    44844
                  ],
                  [
                    43669.9,
                    44680.8
                  ],
                  [
                    43801.8,
                    45005.5
                  ],
                  [
                    43860.3,
                    45245.4
                  ],
                  [
                    43847.6,
                    45570.5
                  ],
                  [
                    43537.3,
                    45551.4
                  ],
                  [
                    43200.9,
                    45376.9
                  ],
                  [
                    42963.8,
                    45105
                  ],
                  [
                    43310.6,
                    44897.1
                  ],
                  [
                    43465,
                    44844
                  ]
                ],
                "id": 714,
                "chat_link": "[&BMoCAAA=]"
              },
              "715": {
                "name": "The Shipyard",
                "level": 80,
                "coord": [
                  43714.4,
                  44405.2
                ],
                "bounds": [
                  [
                    43599.7,
                    43613.2
                  ],
                  [
                    43611.7,
                    43858
                  ],
                  [
                    43673.5,
                    44084
                  ],
                  [
                    43689.9,
                    44368.5
                  ],
                  [
                    43899.7,
                    44514.8
                  ],
                  [
                    44071.4,
                    44725.9
                  ],
                  [
                    44188.1,
                    44975.2
                  ],
                  [
                    43860,
                    45245.5
                  ],
                  [
                    43801,
                    45005.5
                  ],
                  [
                    43669.8,
                    44681
                  ],
                  [
                    43417.3,
                    44233.5
                  ],
                  [
                    43449.5,
                    44017.8
                  ],
                  [
                    43355.6,
                    43944.9
                  ],
                  [
                    43599.7,
                    43613.2
                  ]
                ],
                "id": 715,
                "chat_link": "[&BMsCAAA=]"
              },
              "716": {
                "name": "Mausollus Sea",
                "level": 80,
                "coord": [
                  44352.4,
                  45348.5
                ],
                "bounds": [
                  [
                    44188.5,
                    44974.8
                  ],
                  [
                    44176.8,
                    45147.1
                  ],
                  [
                    44255.3,
                    45277.9
                  ],
                  [
                    44402.5,
                    45343.7
                  ],
                  [
                    44625.4,
                    45292
                  ],
                  [
                    44693.5,
                    45344.9
                  ],
                  [
                    44865.1,
                    45371
                  ],
                  [
                    44738.5,
                    45627
                  ],
                  [
                    44223.8,
                    45639
                  ],
                  [
                    43847.5,
                    45570.4
                  ],
                  [
                    43859.9,
                    45245.5
                  ],
                  [
                    44188.5,
                    44974.8
                  ]
                ],
                "id": 716,
                "chat_link": "[&BMwCAAA=]"
              },
              "717": {
                "name": "Desmina's Hallows",
                "level": 80,
                "coord": [
                  44453.4,
                  44936.2
                ],
                "bounds": [
                  [
                    44254.7,
                    45277.6
                  ],
                  [
                    44177.2,
                    45147.4
                  ],
                  [
                    44188.3,
                    44974.2
                  ],
                  [
                    44071,
                    44726.4
                  ],
                  [
                    43967.5,
                    44599.1
                  ],
                  [
                    44153.5,
                    44457.8
                  ],
                  [
                    44238.6,
                    44517.1
                  ],
                  [
                    44364.7,
                    44579.3
                  ],
                  [
                    44587.8,
                    44579.2
                  ],
                  [
                    44896.2,
                    44639.5
                  ],
                  [
                    44856.9,
                    44941.7
                  ],
                  [
                    44911.2,
                    45187.3
                  ],
                  [
                    44864.8,
                    45371.2
                  ],
                  [
                    44693.7,
                    45345.1
                  ],
                  [
                    44624.7,
                    45291.8
                  ],
                  [
                    44403.8,
                    45344.1
                  ],
                  [
                    44254.7,
                    45277.6
                  ]
                ],
                "id": 717,
                "chat_link": "[&BM0CAAA=]"
              },
              "718": {
                "name": "Compass Plaza",
                "level": 80,
                "coord": [
                  43925.6,
                  44122
                ],
                "bounds": [
                  [
                    43901.4,
                    44515.3
                  ],
                  [
                    43690.3,
                    44370
                  ],
                  [
                    43673.5,
                    44086.8
                  ],
                  [
                    43611.8,
                    43858.5
                  ],
                  [
                    43600,
                    43613.6
                  ],
                  [
                    43820.4,
                    43686.5
                  ],
                  [
                    44048,
                    43690.1
                  ],
                  [
                    44084.9,
                    43882.3
                  ],
                  [
                    44239.1,
                    43980.5
                  ],
                  [
                    44100.4,
                    44160.5
                  ],
                  [
                    44005.4,
                    44206.1
                  ],
                  [
                    43972,
                    44313.1
                  ],
                  [
                    44016.3,
                    44407.6
                  ],
                  [
                    44153.5,
                    44456.7
                  ],
                  [
                    43967.3,
                    44602.3
                  ],
                  [
                    43901.4,
                    44515.3
                  ]
                ],
                "id": 718,
                "chat_link": "[&BM4CAAA=]"
              },
              "719": {
                "name": "Azabe Qabar, the Royal Tombs",
                "level": 80,
                "coord": [
                  44449.6,
                  43664
                ],
                "bounds": [
                  [
                    44200.4,
                    43548.4
                  ],
                  [
                    44445.3,
                    43380
                  ],
                  [
                    44782.4,
                    43404.4
                  ],
                  [
                    44920,
                    43576.3
                  ],
                  [
                    44877.3,
                    43850.8
                  ],
                  [
                    44239.1,
                    43980.2
                  ],
                  [
                    44084.6,
                    43882.4
                  ],
                  [
                    44048,
                    43689.9
                  ],
                  [
                    44200.4,
                    43548.4
                  ]
                ],
                "id": 719,
                "chat_link": "[&BM8CAAA=]"
              },
              "720": {
                "name": "Promenade of the Gods",
                "level": 80,
                "coord": [
                  44272.6,
                  44293.7
                ],
                "bounds": [
                  [
                    44005.3,
                    44206.3
                  ],
                  [
                    44100.5,
                    44160.2
                  ],
                  [
                    44239.5,
                    43979.3
                  ],
                  [
                    44434.6,
                    43932.7
                  ],
                  [
                    44430.2,
                    44122.1
                  ],
                  [
                    44467.1,
                    44242.6
                  ],
                  [
                    44532.9,
                    44320.5
                  ],
                  [
                    44587.9,
                    44579.4
                  ],
                  [
                    44364.8,
                    44579.3
                  ],
                  [
                    44238.5,
                    44518
                  ],
                  [
                    44153.7,
                    44456.6
                  ],
                  [
                    44016.5,
                    44407.7
                  ],
                  [
                    43971.9,
                    44313.3
                  ],
                  [
                    44005.3,
                    44206.3
                  ]
                ],
                "id": 720,
                "chat_link": "[&BNACAAA=]"
              },
              "721": {
                "name": "The Narthex",
                "level": 80,
                "coord": [
                  44695.6,
                  44206.1
                ],
                "bounds": [
                  [
                    44532.9,
                    44320.2
                  ],
                  [
                    44466.6,
                    44242.8
                  ],
                  [
                    44430,
                    44122.3
                  ],
                  [
                    44426.3,
                    43933.1
                  ],
                  [
                    44642.5,
                    43897.2
                  ],
                  [
                    44704.4,
                    43988.6
                  ],
                  [
                    44880.5,
                    43941.2
                  ],
                  [
                    44928.5,
                    44097.8
                  ],
                  [
                    44788.8,
                    44203.9
                  ],
                  [
                    44843.5,
                    44279.3
                  ],
                  [
                    44913.9,
                    44434.2
                  ],
                  [
                    44896.4,
                    44639.5
                  ],
                  [
                    44587.9,
                    44579
                  ],
                  [
                    44532.9,
                    44320.2
                  ]
                ],
                "id": 721,
                "chat_link": "[&BNECAAA=]"
              }
            },
            "adventures": [],
            "id": 62,
            "mastery_points": []
          },
          "65": {
            "name": "Malchor's Leap",
            "min_level": 75,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45184,
              40576
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                43136,
                39552
              ],
              [
                47232,
                41600
              ]
            ],
            "points_of_interest": {
              "647": {
                "name": "Pagga's Post",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46867.8,
                  41221.5
                ],
                "id": 647,
                "chat_link": "[&BIcCAAA=]"
              },
              "648": {
                "name": "Shark's Tooth Isle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46313.3,
                  40375
                ],
                "id": 648,
                "chat_link": "[&BIgCAAA=]"
              },
              "649": {
                "name": "Eastern Colonnade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46429.8,
                  40798.5
                ],
                "id": 649,
                "chat_link": "[&BIkCAAA=]"
              },
              "650": {
                "name": "Beacon Torch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45356.5,
                  40139.2
                ],
                "id": 650,
                "chat_link": "[&BIoCAAA=]"
              },
              "651": {
                "name": "Plaza of Lights",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44453.2,
                  41111.6
                ],
                "id": 651,
                "chat_link": "[&BIsCAAA=]"
              },
              "652": {
                "name": "Altar of Tempests",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44788.3,
                  40628.9
                ],
                "id": 652,
                "chat_link": "[&BIwCAAA=]"
              },
              "653": {
                "name": "Alarjann Bayt",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47049.3,
                  40881.9
                ],
                "id": 653,
                "chat_link": "[&BI0CAAA=]"
              },
              "654": {
                "name": "The Wealdwood",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46686.1,
                  40202.1
                ],
                "id": 654,
                "chat_link": "[&BI4CAAA=]"
              },
              "655": {
                "name": "Kitah Manse",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47130.2,
                  40723
                ],
                "id": 655,
                "chat_link": "[&BI8CAAA=]"
              },
              "656": {
                "name": "Upsilon Test Facility",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46872.9,
                  39987.7
                ],
                "id": 656,
                "chat_link": "[&BJACAAA=]"
              },
              "657": {
                "name": "Sculptor's End",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44576.8,
                  40391.7
                ],
                "id": 657,
                "chat_link": "[&BJECAAA=]"
              },
              "658": {
                "name": "Omicron Test Facility",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44984.3,
                  39913.7
                ],
                "id": 658,
                "chat_link": "[&BJICAAA=]"
              },
              "659": {
                "name": "Arcadian Deeps",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44263.8,
                  40474.3
                ],
                "id": 659,
                "chat_link": "[&BJMCAAA=]"
              },
              "660": {
                "name": "Altar of Lies",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45903.2,
                  40336.9
                ],
                "id": 660,
                "chat_link": "[&BJQCAAA=]"
              },
              "661": {
                "name": "Spark of Ilya",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45566.1,
                  40094.6
                ],
                "id": 661,
                "chat_link": "[&BJUCAAA=]"
              },
              "662": {
                "name": "Song of Lyss",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46143.1,
                  40563.5
                ],
                "id": 662,
                "chat_link": "[&BJYCAAA=]"
              },
              "663": {
                "name": "Seal of Union",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46006.8,
                  39963.1
                ],
                "id": 663,
                "chat_link": "[&BJcCAAA=]"
              },
              "664": {
                "name": "Malchor's Anguish",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44112,
                  40944
                ],
                "id": 664,
                "chat_link": "[&BJgCAAA=]"
              },
              "665": {
                "name": "Mirror's Handle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46019,
                  39894.1
                ],
                "id": 665,
                "chat_link": "[&BJkCAAA=]"
              },
              "666": {
                "name": "Murmur Isle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44674.4,
                  40109.9
                ],
                "id": 666,
                "chat_link": "[&BJoCAAA=]"
              },
              "667": {
                "name": "Shelter Docks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46812.1,
                  40747.5
                ],
                "id": 667,
                "chat_link": "[&BJsCAAA=]"
              },
              "668": {
                "name": "Doric's Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44603.8,
                  41284.8
                ],
                "id": 668,
                "chat_link": "[&BJwCAAA=]"
              },
              "669": {
                "name": "Kahloipoi Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44553.7,
                  40198.5
                ],
                "id": 669,
                "chat_link": "[&BJ0CAAA=]"
              },
              "670": {
                "name": "Rayhan Bayt",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46633.6,
                  41218.3
                ],
                "id": 670,
                "chat_link": "[&BJ4CAAA=]"
              },
              "671": {
                "name": "Bayt Fallahin",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45633.2,
                  41277.5
                ],
                "id": 671,
                "chat_link": "[&BJ8CAAA=]"
              },
              "672": {
                "name": "Saliah Bayt",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45165.9,
                  41310.7
                ],
                "id": 672,
                "chat_link": "[&BKACAAA=]"
              },
              "673": {
                "name": "Wreck of the Qashvian",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46602.9,
                  41036.8
                ],
                "id": 673,
                "chat_link": "[&BKECAAA=]"
              },
              "674": {
                "name": "Follower's Bridge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44698.9,
                  41483.4
                ],
                "id": 674,
                "chat_link": "[&BKICAAA=]"
              },
              "675": {
                "name": "Dhuum's Last Stand",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45213.7,
                  40401.9
                ],
                "id": 675,
                "chat_link": "[&BKMCAAA=]"
              },
              "676": {
                "name": "Village of Wren",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45477.6,
                  40770.4
                ],
                "id": 676,
                "chat_link": "[&BKQCAAA=]"
              },
              "677": {
                "name": "Hope Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46327.7,
                  41430.3
                ],
                "id": 677,
                "chat_link": "[&BKUCAAA=]"
              },
              "678": {
                "name": "Pagga's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46866.4,
                  41177.4
                ],
                "id": 678,
                "chat_link": "[&BKYCAAA=]"
              },
              "679": {
                "name": "Doric's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44641.4,
                  41268.2
                ],
                "id": 679,
                "chat_link": "[&BKcCAAA=]"
              },
              "680": {
                "name": "Waste Hollows Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46874.7,
                  40461.2
                ],
                "id": 680,
                "chat_link": "[&BKgCAAA=]"
              },
              "681": {
                "name": "Colonnade Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46387.6,
                  40821.8
                ],
                "id": 681,
                "chat_link": "[&BKkCAAA=]"
              },
              "682": {
                "name": "Valley of Lyss Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46178.6,
                  41237.6
                ],
                "id": 682,
                "chat_link": "[&BKoCAAA=]"
              },
              "683": {
                "name": "Union Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46013.5,
                  39946.8
                ],
                "id": 683,
                "chat_link": "[&BKsCAAA=]"
              },
              "684": {
                "name": "Wren Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  45494.9,
                  40742.5
                ],
                "id": 684,
                "chat_link": "[&BKwCAAA=]"
              },
              "685": {
                "name": "Lyssa Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  45969.5,
                  40323.2
                ],
                "id": 685,
                "chat_link": "[&BK0CAAA=]"
              },
              "686": {
                "name": "Blighted Arch Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  45132.2,
                  40523.1
                ],
                "id": 686,
                "chat_link": "[&BK4CAAA=]"
              },
              "687": {
                "name": "Murmur Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44641.4,
                  40123.4
                ],
                "id": 687,
                "chat_link": "[&BK8CAAA=]"
              },
              "688": {
                "name": "Tempest Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44888.7,
                  40702.6
                ],
                "id": 688,
                "chat_link": "[&BLACAAA=]"
              },
              "689": {
                "name": "Versoconjouring Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43931.2,
                  39953.1
                ],
                "id": 689,
                "chat_link": "[&BLECAAA=]"
              },
              "690": {
                "name": "Lights Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44489.3,
                  40825.3
                ],
                "id": 690,
                "chat_link": "[&BLICAAA=]"
              },
              "1259": {
                "name": "Augur's Grotto",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45729.2,
                  40331.2
                ],
                "id": 1259,
                "chat_link": "[&BOsEAAA=]"
              },
              "1273": {
                "name": "Harbinger",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43474.9,
                  40606.3
                ],
                "id": 1273,
                "chat_link": "[&BPkEAAA=]"
              },
              "1277": {
                "name": "Versoconjouring Array",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43797.5,
                  40095.6
                ],
                "id": 1277,
                "chat_link": "[&BP0EAAA=]"
              },
              "1622": {
                "name": "Bauxite Alchemicals",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44114.4,
                  40095.6
                ],
                "id": 1622,
                "chat_link": "[&BFYGAAA=]"
              },
              "1623": {
                "name": "King's Passage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44516.9,
                  41307.1
                ],
                "id": 1623,
                "chat_link": "[&BFcGAAA=]"
              },
              "1690": {
                "name": "Reflection Cove",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45923.6,
                  40216.2
                ],
                "id": 1690,
                "chat_link": "[&BJoGAAA=]"
              },
              "1713": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  44528.2,
                  40371
                ],
                "id": 1713,
                "chat_link": "[&BLEGAAA=]"
              },
              "1714": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  46055.2,
                  39635.2
                ],
                "id": 1714,
                "chat_link": "[&BLIGAAA=]"
              },
              "1715": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  46749.3,
                  40881.8
                ],
                "id": 1715,
                "chat_link": "[&BLMGAAA=]"
              },
              "1716": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  45328.4,
                  40579.2
                ],
                "id": 1716,
                "chat_link": "[&BLQGAAA=]"
              },
              "1717": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43411.6,
                  41035.7
                ],
                "id": 1717,
                "chat_link": "[&BLUGAAA=]"
              }
            },
            "god_shrines": [
              {
                "id": 4,
                "name": "Temple of Lyssa <c=#a9a9a9>[Uncontested]</c><br>• All Lyssa statues in Orr are disabled.</c>",
                "name_contested": "Temple of Lyssa <c=#ff8c00>[Contested]</c><br>• All Lyssa statues in Orr are active.",
                "coord": [
                  45868.6,
                  40320.7
                ],
                "poi_id": 685,
                "icon": "https://render.guildwars2.com/file/61EB4505770BBC22013E4EBD60D2B878456C9712/347219.png",
                "icon_contested": "https://render.guildwars2.com/file/4B937E3ECA980ACD29655EA1D767DD5E0E23462F/347220.png"
              },
              {
                "id": 1,
                "name": "Temple of Dwayna <c=#a9a9a9>[Uncontested]</c><br>• All Dwayna statues in Orr are disabled.</c>",
                "name_contested": "Temple of Dwayna <c=#ff8c00>[Contested]</c><br>• All Dwayna statues in Orr are active.",
                "coord": [
                  44788.9,
                  40659.9
                ],
                "poi_id": 688,
                "icon": "https://render.guildwars2.com/file/61EB4505770BBC22013E4EBD60D2B878456C9712/347219.png",
                "icon_contested": "https://render.guildwars2.com/file/4B937E3ECA980ACD29655EA1D767DD5E0E23462F/347220.png"
              }
            ],
            "tasks": {},
            "skill_challenges": [
              {
                "coord": [
                  44585.1,
                  41117.3
                ],
                "id": "0-175"
              },
              {
                "coord": [
                  44788.4,
                  40582.2
                ],
                "id": "0-166"
              },
              {
                "coord": [
                  45595.1,
                  41238.4
                ],
                "id": "0-168"
              },
              {
                "coord": [
                  45909.9,
                  40312.1
                ],
                "id": "0-167"
              },
              {
                "coord": [
                  44620,
                  40509.7
                ],
                "id": "0-169"
              },
              {
                "coord": [
                  46732.7,
                  40180.1
                ],
                "id": "0-174"
              },
              {
                "coord": [
                  45746.6,
                  40276.1
                ],
                "id": "0-170"
              },
              {
                "coord": [
                  45229.8,
                  40419.3
                ],
                "id": "0-173"
              },
              {
                "coord": [
                  46299.9,
                  40343.3
                ],
                "id": "0-171"
              },
              {
                "coord": [
                  44155.7,
                  41241.4
                ],
                "id": "0-172"
              },
              {
                "coord": [
                  44997.5,
                  41263.2
                ],
                "id": "0-234"
              },
              {
                "coord": [
                  43715.2,
                  41311
                ],
                "id": "0-235"
              },
              {
                "coord": [
                  44472.2,
                  40376.1
                ],
                "id": "0-236"
              },
              {
                "coord": [
                  45428.7,
                  39946.5
                ],
                "id": "0-237"
              },
              {
                "coord": [
                  46064.8,
                  41219.2
                ],
                "id": "0-238"
              }
            ],
            "sectors": {
              "592": {
                "name": "Midwater Hollows",
                "level": 75,
                "coord": [
                  47016.8,
                  40095.2
                ],
                "bounds": [
                  [
                    46801.3,
                    39756.7
                  ],
                  [
                    47092.8,
                    39854.8
                  ],
                  [
                    47335.1,
                    40001.3
                  ],
                  [
                    47298.6,
                    40378.4
                  ],
                  [
                    47059.2,
                    40359.5
                  ],
                  [
                    46892.3,
                    40437.6
                  ],
                  [
                    46887,
                    40083.7
                  ],
                  [
                    46767.8,
                    39889.9
                  ],
                  [
                    46801.3,
                    39756.7
                  ]
                ],
                "id": 592,
                "chat_link": "[&BFACAAA=]"
              },
              "593": {
                "name": "Crusted Sholes",
                "level": 76,
                "coord": [
                  46426.2,
                  40525.6
                ],
                "bounds": [
                  [
                    46170.4,
                    40292.6
                  ],
                  [
                    46366.4,
                    40177.1
                  ],
                  [
                    46506.5,
                    40289.4
                  ],
                  [
                    46650.5,
                    40325.7
                  ],
                  [
                    46648,
                    40462.8
                  ],
                  [
                    46720.4,
                    40575.3
                  ],
                  [
                    46706.5,
                    40700.3
                  ],
                  [
                    46630.3,
                    40751
                  ],
                  [
                    46459.7,
                    40654.5
                  ],
                  [
                    46314.6,
                    40756.3
                  ],
                  [
                    46217.2,
                    40786.8
                  ],
                  [
                    46017.9,
                    40589.3
                  ],
                  [
                    46132,
                    40471.8
                  ],
                  [
                    46170.4,
                    40292.6
                  ]
                ],
                "id": 593,
                "chat_link": "[&BFECAAA=]"
              },
              "594": {
                "name": "Whisper Bay",
                "level": 78,
                "coord": [
                  44853.1,
                  40042.4
                ],
                "bounds": [
                  [
                    44332.4,
                    40319.1
                  ],
                  [
                    44435.2,
                    40165.3
                  ],
                  [
                    44422.4,
                    39782.1
                  ],
                  [
                    44849.3,
                    39671.1
                  ],
                  [
                    45135.8,
                    39685.1
                  ],
                  [
                    45347.8,
                    39730.8
                  ],
                  [
                    45229.8,
                    39894.6
                  ],
                  [
                    45282.9,
                    40003.3
                  ],
                  [
                    45163.3,
                    40194.6
                  ],
                  [
                    44838.1,
                    40220.9
                  ],
                  [
                    44729.6,
                    40366.5
                  ],
                  [
                    44470.5,
                    40475.9
                  ],
                  [
                    44332.4,
                    40319.1
                  ]
                ],
                "id": 594,
                "chat_link": "[&BFICAAA=]"
              },
              "595": {
                "name": "Mirror Bay",
                "level": 76,
                "coord": [
                  46287.6,
                  40001.9
                ],
                "bounds": [
                  [
                    46169.7,
                    40295.6
                  ],
                  [
                    46113.8,
                    40139.2
                  ],
                  [
                    45964.6,
                    40000.9
                  ],
                  [
                    45788.9,
                    39964.5
                  ],
                  [
                    45803.4,
                    39684.7
                  ],
                  [
                    46800.9,
                    39757
                  ],
                  [
                    46777.4,
                    39886.2
                  ],
                  [
                    46656.6,
                    40055.6
                  ],
                  [
                    46430.1,
                    40053.2
                  ],
                  [
                    46370.8,
                    40181.8
                  ],
                  [
                    46169.7,
                    40295.6
                  ]
                ],
                "id": 595,
                "chat_link": "[&BFMCAAA=]"
              },
              "596": {
                "name": "Drowned Brine",
                "level": 79,
                "coord": [
                  43958.1,
                  40965.4
                ],
                "bounds": [
                  [
                    44009.1,
                    41231.4
                  ],
                  [
                    43918.7,
                    41346.4
                  ],
                  [
                    43971.1,
                    41647.3
                  ],
                  [
                    43435.1,
                    41597.7
                  ],
                  [
                    43272.3,
                    41239.3
                  ],
                  [
                    43425,
                    40899.5
                  ],
                  [
                    43503.5,
                    40346
                  ],
                  [
                    44045.4,
                    40445.5
                  ],
                  [
                    44318.4,
                    40318.7
                  ],
                  [
                    44473.7,
                    40477.9
                  ],
                  [
                    44449.1,
                    40919
                  ],
                  [
                    44329.8,
                    40986.8
                  ],
                  [
                    44304.2,
                    41094.9
                  ],
                  [
                    44009.1,
                    41231.4
                  ]
                ],
                "id": 596,
                "chat_link": "[&BFQCAAA=]"
              },
              "597": {
                "name": "Theater of Delight",
                "level": 76,
                "coord": [
                  46683.7,
                  41062.2
                ],
                "bounds": [
                  [
                    46405.1,
                    41407.5
                  ],
                  [
                    46376,
                    41124.6
                  ],
                  [
                    46423.7,
                    40992.4
                  ],
                  [
                    46316.5,
                    40757.1
                  ],
                  [
                    46461.2,
                    40655.3
                  ],
                  [
                    46630.8,
                    40749.4
                  ],
                  [
                    46704.8,
                    40702.3
                  ],
                  [
                    46995.7,
                    41133.2
                  ],
                  [
                    47234.6,
                    41091.7
                  ],
                  [
                    47351.5,
                    41534.3
                  ],
                  [
                    46621.1,
                    41536.7
                  ],
                  [
                    46405.1,
                    41407.5
                  ]
                ],
                "id": 597,
                "chat_link": "[&BFUCAAA=]"
              },
              "598": {
                "name": "Blighted Arch",
                "level": 78,
                "coord": [
                  45287.5,
                  40131.6
                ],
                "bounds": [
                  [
                    45788.2,
                    39961.2
                  ],
                  [
                    45622.4,
                    40035.3
                  ],
                  [
                    45514.4,
                    40199.6
                  ],
                  [
                    45521,
                    40379.3
                  ],
                  [
                    44999.1,
                    40615.7
                  ],
                  [
                    44932,
                    40457.5
                  ],
                  [
                    44726.7,
                    40357
                  ],
                  [
                    44833.2,
                    40209.2
                  ],
                  [
                    45154.9,
                    40186.9
                  ],
                  [
                    45275.1,
                    40006.7
                  ],
                  [
                    45221.7,
                    39894.2
                  ],
                  [
                    45346.4,
                    39724.8
                  ],
                  [
                    45801.9,
                    39683.2
                  ],
                  [
                    45788.2,
                    39961.2
                  ]
                ],
                "id": 598,
                "chat_link": "[&BFYCAAA=]"
              },
              "599": {
                "name": "Cathedral of Zephyrs",
                "level": 79,
                "coord": [
                  44763.9,
                  40664.9
                ],
                "bounds": [
                  [
                    44457,
                    40706.3
                  ],
                  [
                    44469.4,
                    40479.9
                  ],
                  [
                    44726,
                    40358.5
                  ],
                  [
                    44929,
                    40462.6
                  ],
                  [
                    44997.7,
                    40616.3
                  ],
                  [
                    44994.8,
                    40742.3
                  ],
                  [
                    44913.6,
                    40870.8
                  ],
                  [
                    44762.1,
                    40900.1
                  ],
                  [
                    44625.7,
                    40847.4
                  ],
                  [
                    44457,
                    40706.3
                  ]
                ],
                "id": 599,
                "chat_link": "[&BFcCAAA=]"
              },
              "600": {
                "name": "Waste Hollows",
                "level": 75,
                "coord": [
                  47079.6,
                  40709.6
                ],
                "bounds": [
                  [
                    46986.4,
                    41133
                  ],
                  [
                    46705.6,
                    40697.8
                  ],
                  [
                    46714.7,
                    40577.5
                  ],
                  [
                    46901.2,
                    40419.4
                  ],
                  [
                    47048,
                    40355.1
                  ],
                  [
                    47194.5,
                    40368.8
                  ],
                  [
                    47367.3,
                    40581.9
                  ],
                  [
                    47314.8,
                    40861.2
                  ],
                  [
                    47332.4,
                    41021.3
                  ],
                  [
                    47231.4,
                    41080.2
                  ],
                  [
                    46986.4,
                    41133
                  ]
                ],
                "id": 600,
                "chat_link": "[&BFgCAAA=]"
              },
              "601": {
                "name": "Pyrite Peninsula",
                "level": 75,
                "coord": [
                  46654.2,
                  40233.1
                ],
                "bounds": [
                  [
                    46433.5,
                    40048.1
                  ],
                  [
                    46655,
                    40056.4
                  ],
                  [
                    46768.5,
                    39885.7
                  ],
                  [
                    46889.8,
                    40083.3
                  ],
                  [
                    46901.6,
                    40421.9
                  ],
                  [
                    46719,
                    40573.4
                  ],
                  [
                    46649.7,
                    40462.3
                  ],
                  [
                    46650,
                    40328.4
                  ],
                  [
                    46507,
                    40291.8
                  ],
                  [
                    46368.4,
                    40179.5
                  ],
                  [
                    46433.5,
                    40048.1
                  ]
                ],
                "id": 601,
                "chat_link": "[&BFkCAAA=]"
              },
              "602": {
                "name": "Jinx Isle",
                "level": 79,
                "coord": [
                  44071.5,
                  40065
                ],
                "bounds": [
                  [
                    43504.5,
                    40353.9
                  ],
                  [
                    43625.9,
                    40043
                  ],
                  [
                    43929.5,
                    39745.1
                  ],
                  [
                    44288.6,
                    39661
                  ],
                  [
                    44429.1,
                    39786.5
                  ],
                  [
                    44426.2,
                    40167.8
                  ],
                  [
                    44323,
                    40318.8
                  ],
                  [
                    44045.6,
                    40444
                  ],
                  [
                    43504.5,
                    40353.9
                  ]
                ],
                "id": 602,
                "chat_link": "[&BFoCAAA=]"
              },
              "603": {
                "name": "Karst Plains",
                "level": 79,
                "coord": [
                  44756.3,
                  41196.1
                ],
                "bounds": [
                  [
                    44658.1,
                    41785.7
                  ],
                  [
                    44655.4,
                    41428.4
                  ],
                  [
                    44299.5,
                    41094.7
                  ],
                  [
                    44330.4,
                    40985.9
                  ],
                  [
                    44448.3,
                    40918.5
                  ],
                  [
                    44455.8,
                    40711.2
                  ],
                  [
                    44632.4,
                    40846.7
                  ],
                  [
                    44762.3,
                    40898.3
                  ],
                  [
                    44912.5,
                    40871
                  ],
                  [
                    44994.4,
                    40739
                  ],
                  [
                    45327.7,
                    41262.2
                  ],
                  [
                    45307.6,
                    41659.9
                  ],
                  [
                    45018.3,
                    41760
                  ],
                  [
                    44786.2,
                    41784.2
                  ],
                  [
                    44658.1,
                    41785.7
                  ]
                ],
                "id": 603,
                "chat_link": "[&BFsCAAA=]"
              },
              "605": {
                "name": "Snaketail Inlet",
                "level": 79,
                "coord": [
                  44253.2,
                  41465.2
                ],
                "bounds": [
                  [
                    43907.7,
                    41349
                  ],
                  [
                    43992.7,
                    41229.8
                  ],
                  [
                    44303,
                    41088.3
                  ],
                  [
                    44652.5,
                    41430.8
                  ],
                  [
                    44658.4,
                    41790.3
                  ],
                  [
                    44288.7,
                    41713.1
                  ],
                  [
                    43969.7,
                    41655.1
                  ],
                  [
                    43907.7,
                    41349
                  ]
                ],
                "id": 605,
                "chat_link": "[&BF0CAAA=]"
              },
              "606": {
                "name": "Cathedral of Eternal Radiance",
                "level": 78,
                "coord": [
                  45842.7,
                  40326.8
                ],
                "bounds": [
                  [
                    45515.9,
                    40380.6
                  ],
                  [
                    45516,
                    40199.5
                  ],
                  [
                    45623.1,
                    40036.3
                  ],
                  [
                    45792.8,
                    39962.8
                  ],
                  [
                    45964.6,
                    40001.3
                  ],
                  [
                    46108.2,
                    40140.3
                  ],
                  [
                    46172.1,
                    40294.7
                  ],
                  [
                    46134.3,
                    40473.1
                  ],
                  [
                    46018.4,
                    40590.1
                  ],
                  [
                    45880.4,
                    40640.5
                  ],
                  [
                    45754.5,
                    40630.9
                  ],
                  [
                    45631.8,
                    40572
                  ],
                  [
                    45515.9,
                    40380.6
                  ]
                ],
                "id": 606,
                "chat_link": "[&BF4CAAA=]"
              },
              "607": {
                "name": "Valley of Lyss",
                "level": 77,
                "coord": [
                  46050.7,
                  41021.1
                ],
                "bounds": [
                  [
                    45662.6,
                    41343
                  ],
                  [
                    45604,
                    41123.6
                  ],
                  [
                    45753.7,
                    40628.5
                  ],
                  [
                    45880.8,
                    40639.3
                  ],
                  [
                    46016.7,
                    40589.6
                  ],
                  [
                    46218.2,
                    40787.3
                  ],
                  [
                    46314.4,
                    40756.6
                  ],
                  [
                    46424.3,
                    40992.9
                  ],
                  [
                    46375.4,
                    41125
                  ],
                  [
                    46410.9,
                    41488.5
                  ],
                  [
                    46079,
                    41469
                  ],
                  [
                    45868.8,
                    41309.6
                  ],
                  [
                    45662.6,
                    41343
                  ]
                ],
                "id": 607,
                "chat_link": "[&BF8CAAA=]"
              },
              "608": {
                "name": "Garden of Ilya",
                "level": 78,
                "coord": [
                  45441.3,
                  40838.2
                ],
                "bounds": [
                  [
                    44993.5,
                    40743.5
                  ],
                  [
                    44998.2,
                    40613.9
                  ],
                  [
                    45520.1,
                    40378.2
                  ],
                  [
                    45633.6,
                    40568.9
                  ],
                  [
                    45752.7,
                    40635.1
                  ],
                  [
                    45604,
                    41124.8
                  ],
                  [
                    45646.1,
                    41280.1
                  ],
                  [
                    45382.3,
                    41360.9
                  ],
                  [
                    44993.5,
                    40743.5
                  ]
                ],
                "id": 608,
                "chat_link": "[&BGACAAA=]"
              },
              "1014": {
                "name": "Malchor's Fingers",
                "level": 78,
                "coord": [
                  45223.6,
                  39643.6
                ],
                "bounds": [
                  [
                    44291.1,
                    39657.9
                  ],
                  [
                    44469.7,
                    39483.1
                  ],
                  [
                    45293.4,
                    39384.2
                  ],
                  [
                    46230.7,
                    39587.2
                  ],
                  [
                    46392.9,
                    39741.5
                  ],
                  [
                    45796.1,
                    39677.3
                  ],
                  [
                    45347.7,
                    39746
                  ],
                  [
                    45135.8,
                    39690.3
                  ],
                  [
                    44851,
                    39677.2
                  ],
                  [
                    44427.7,
                    39791
                  ],
                  [
                    44291.1,
                    39657.9
                  ]
                ],
                "id": 1014,
                "chat_link": "[&BPYDAAA=]"
              }
            },
            "adventures": [],
            "id": 65,
            "mastery_points": [
              {
                "coord": [
                  46828.1,
                  41354.2
                ],
                "id": 325,
                "region": "Tyria"
              }
            ]
          },
          "827": {
            "name": "Caer Aval",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              48688,
              40192
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                47232,
                38784
              ],
              [
                50560,
                41600
              ]
            ],
            "points_of_interest": {
              "1023": {
                "name": "Caer Aval",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49933.9,
                  40162.5
                ],
                "id": 1023,
                "chat_link": "[&BP8DAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "684": {
                "name": "Fort Trinity",
                "level": 71,
                "coord": [
                  50040.2,
                  39934
                ],
                "bounds": [
                  [
                    49835.6,
                    39572.2
                  ],
                  [
                    49992,
                    39616.4
                  ],
                  [
                    50251.7,
                    39775.9
                  ],
                  [
                    50244.2,
                    39912.7
                  ],
                  [
                    50296.7,
                    39959.1
                  ],
                  [
                    50291.5,
                    40014.9
                  ],
                  [
                    50254.4,
                    40055.6
                  ],
                  [
                    50205.3,
                    40064.9
                  ],
                  [
                    50007.9,
                    40260.7
                  ],
                  [
                    49911.3,
                    40265.5
                  ],
                  [
                    49799.9,
                    40158.6
                  ],
                  [
                    49695.4,
                    39860.6
                  ],
                  [
                    49736.9,
                    39624.7
                  ],
                  [
                    49835.6,
                    39572.2
                  ]
                ],
                "id": 684,
                "chat_link": "[&BKwCAAA=]"
              }
            },
            "adventures": [],
            "id": 827,
            "mastery_points": []
          },
          "1194": {
            "name": "The Sword Regrown",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              43904,
              43648
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42880,
                41600
              ],
              [
                44928,
                45696
              ]
            ],
            "points_of_interest": {
              "764": {
                "name": "Bitter Mountain",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44098.5,
                  41827.2
                ],
                "id": 764,
                "chat_link": "[&BPwCAAA=]"
              },
              "765": {
                "name": "Caer Shadowfain",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44064.5,
                  42175.3
                ],
                "id": 765,
                "chat_link": "[&BP0CAAA=]"
              },
              "766": {
                "name": "Village Sayix",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44127,
                  42578.3
                ],
                "id": 766,
                "chat_link": "[&BP4CAAA=]"
              },
              "767": {
                "name": "Seachange Tidepools",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43345.9,
                  42147.4
                ],
                "id": 767,
                "chat_link": "[&BP8CAAA=]"
              },
              "768": {
                "name": "Cachistic R&D",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43612.3,
                  42366.9
                ],
                "id": 768,
                "chat_link": "[&BAADAAA=]"
              },
              "769": {
                "name": "Gavbeorn's Landing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43289.5,
                  42903.7
                ],
                "id": 769,
                "chat_link": "[&BAEDAAA=]"
              },
              "770": {
                "name": "Bakkir Sarayi",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43568.5,
                  42859.6
                ],
                "id": 770,
                "chat_link": "[&BAIDAAA=]"
              },
              "771": {
                "name": "Winterknell Labyrinth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43897.2,
                  42783.5
                ],
                "id": 771,
                "chat_link": "[&BAMDAAA=]"
              },
              "772": {
                "name": "Shelter's Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44493.3,
                  42992.8
                ],
                "id": 772,
                "chat_link": "[&BAQDAAA=]"
              },
              "773": {
                "name": "Gallow's Hang",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44672.4,
                  43265.7
                ],
                "id": 773,
                "chat_link": "[&BAUDAAA=]"
              },
              "774": {
                "name": "Village of Ewan",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43809.9,
                  43500.2
                ],
                "id": 774,
                "chat_link": "[&BAYDAAA=]"
              },
              "775": {
                "name": "Thorn Dock",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43601.5,
                  43583.3
                ],
                "id": 775,
                "chat_link": "[&BAcDAAA=]"
              },
              "776": {
                "name": "The Wreck of the Golden Vanity",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43108.7,
                  43577.4
                ],
                "id": 776,
                "chat_link": "[&BAgDAAA=]"
              },
              "777": {
                "name": "Harbinger Torch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43195.8,
                  44094.9
                ],
                "id": 777,
                "chat_link": "[&BAkDAAA=]"
              },
              "778": {
                "name": "Death's Gaze Torch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43156.2,
                  44541.9
                ],
                "id": 778,
                "chat_link": "[&BAoDAAA=]"
              },
              "779": {
                "name": "Buried Archives",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43630.9,
                  45044.5
                ],
                "id": 779,
                "chat_link": "[&BAsDAAA=]"
              },
              "780": {
                "name": "Altar of Murdered Dreams",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43244.2,
                  45035.3
                ],
                "id": 780,
                "chat_link": "[&BAwDAAA=]"
              },
              "781": {
                "name": "Death's Anthem",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44349.1,
                  45215.8
                ],
                "id": 781,
                "chat_link": "[&BA0DAAA=]"
              },
              "782": {
                "name": "The Wreck of the Saehrimnir",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44680.7,
                  45286
                ],
                "id": 782,
                "chat_link": "[&BA4DAAA=]"
              },
              "783": {
                "name": "Meddler's Summit",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43844,
                  43780.8
                ],
                "id": 783,
                "chat_link": "[&BA8DAAA=]"
              },
              "784": {
                "name": "Telmat Knoll",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43970.5,
                  44022.1
                ],
                "id": 784,
                "chat_link": "[&BBADAAA=]"
              },
              "785": {
                "name": "Augur's Torch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43818.7,
                  44420.7
                ],
                "id": 785,
                "chat_link": "[&BBEDAAA=]"
              },
              "786": {
                "name": "Shank Anchorage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43788.6,
                  44254.2
                ],
                "id": 786,
                "chat_link": "[&BBIDAAA=]"
              },
              "787": {
                "name": "Sharn's Free Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44164.1,
                  44775.7
                ],
                "id": 787,
                "chat_link": "[&BBMDAAA=]"
              },
              "788": {
                "name": "Reliquary Vault",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44343,
                  43752.6
                ],
                "id": 788,
                "chat_link": "[&BBQDAAA=]"
              },
              "789": {
                "name": "Gates of Arah",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44693.3,
                  44111.8
                ],
                "id": 789,
                "chat_link": "[&BBUDAAA=]"
              },
              "790": {
                "name": "Altar of the Withered Heart",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44058.2,
                  43081.5
                ],
                "id": 790,
                "chat_link": "[&BBYDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "703": {
                "name": "Pursuit Pass",
                "level": 80,
                "coord": [
                  44478.3,
                  41846.8
                ],
                "bounds": [
                  [
                    44537.5,
                    41605
                  ],
                  [
                    44686.1,
                    41517.6
                  ],
                  [
                    44873.2,
                    41527.4
                  ],
                  [
                    44999.7,
                    41752.5
                  ],
                  [
                    44967.8,
                    42010.5
                  ],
                  [
                    44865.6,
                    42192.7
                  ],
                  [
                    44717.7,
                    42500.6
                  ],
                  [
                    44567.7,
                    42397.4
                  ],
                  [
                    43935.7,
                    42122.8
                  ],
                  [
                    43873,
                    41844.7
                  ],
                  [
                    43974.1,
                    41742.3
                  ],
                  [
                    44055.9,
                    41604
                  ],
                  [
                    44229.9,
                    41515.6
                  ],
                  [
                    44412.8,
                    41521.8
                  ],
                  [
                    44537.5,
                    41605
                  ]
                ],
                "id": 703,
                "chat_link": "[&BL8CAAA=]"
              },
              "704": {
                "name": "Fields of Gold",
                "level": 80,
                "coord": [
                  43910.4,
                  42076.2
                ],
                "bounds": [
                  [
                    43935.4,
                    42121.6
                  ],
                  [
                    44568.1,
                    42396.7
                  ],
                  [
                    44522.7,
                    42542.9
                  ],
                  [
                    44166.2,
                    42648.7
                  ],
                  [
                    44072.9,
                    42631.7
                  ],
                  [
                    43988.1,
                    42527.3
                  ],
                  [
                    43745,
                    42372.6
                  ],
                  [
                    43509,
                    42068.4
                  ],
                  [
                    43435.7,
                    41834.7
                  ],
                  [
                    43441.1,
                    41711.9
                  ],
                  [
                    43569,
                    41556.1
                  ],
                  [
                    43803.3,
                    41532.1
                  ],
                  [
                    44054,
                    41612.9
                  ],
                  [
                    43973.2,
                    41742.1
                  ],
                  [
                    43872.4,
                    41843.5
                  ],
                  [
                    43935.4,
                    42121.6
                  ]
                ],
                "id": 704,
                "chat_link": "[&BMACAAA=]"
              },
              "705": {
                "name": "Winterknell Shore",
                "level": 80,
                "coord": [
                  43316.7,
                  42420.2
                ],
                "bounds": [
                  [
                    43436,
                    41835.2
                  ],
                  [
                    43508.9,
                    42068.7
                  ],
                  [
                    43744.8,
                    42372.7
                  ],
                  [
                    43693.9,
                    42631.2
                  ],
                  [
                    43472.1,
                    42728.1
                  ],
                  [
                    43328.3,
                    43062.3
                  ],
                  [
                    43132.2,
                    43137.5
                  ],
                  [
                    42965.4,
                    42704.8
                  ],
                  [
                    43085.9,
                    42308.7
                  ],
                  [
                    42897.7,
                    42011.9
                  ],
                  [
                    43218,
                    41760.9
                  ],
                  [
                    43436,
                    41835.2
                  ]
                ],
                "id": 705,
                "chat_link": "[&BMECAAA=]"
              },
              "706": {
                "name": "Winterknell Isle",
                "level": 80,
                "coord": [
                  43808.8,
                  42790.9
                ],
                "bounds": [
                  [
                    43988.1,
                    42528.3
                  ],
                  [
                    44073.3,
                    42631.7
                  ],
                  [
                    44165,
                    42648.7
                  ],
                  [
                    44181.5,
                    42823.1
                  ],
                  [
                    44092.9,
                    42846.1
                  ],
                  [
                    43680.4,
                    43264.4
                  ],
                  [
                    43481.3,
                    43165.7
                  ],
                  [
                    43324.4,
                    43061.9
                  ],
                  [
                    43471.1,
                    42726.7
                  ],
                  [
                    43693.2,
                    42630.6
                  ],
                  [
                    43745.4,
                    42372.4
                  ],
                  [
                    43988.1,
                    42528.3
                  ]
                ],
                "id": 706,
                "chat_link": "[&BMICAAA=]"
              },
              "707": {
                "name": "Penitent Path",
                "level": 80,
                "coord": [
                  44288.7,
                  42852.1
                ],
                "bounds": [
                  [
                    44286.8,
                    42613.5
                  ],
                  [
                    44500.6,
                    42921.6
                  ],
                  [
                    44301.1,
                    43170
                  ],
                  [
                    44189.8,
                    42907.8
                  ],
                  [
                    44165.1,
                    42647.8
                  ],
                  [
                    44286.8,
                    42613.5
                  ]
                ],
                "id": 707,
                "chat_link": "[&BMMCAAA=]"
              },
              "708": {
                "name": "The Artesian Waters",
                "level": 80,
                "coord": [
                  44630.4,
                  42659.6
                ],
                "bounds": [
                  [
                    44518.4,
                    42539.9
                  ],
                  [
                    44562.9,
                    42386.7
                  ],
                  [
                    44890.9,
                    42593.2
                  ],
                  [
                    44886.7,
                    42720.2
                  ],
                  [
                    44764.7,
                    42858.1
                  ],
                  [
                    44502.1,
                    42922
                  ],
                  [
                    44286.9,
                    42597.4
                  ],
                  [
                    44518.4,
                    42539.9
                  ]
                ],
                "id": 708,
                "chat_link": "[&BMQCAAA=]"
              },
              "709": {
                "name": "Noose Road",
                "level": 80,
                "coord": [
                  44560.2,
                  43118.1
                ],
                "bounds": [
                  [
                    44460,
                    42970.4
                  ],
                  [
                    44497.3,
                    42926.2
                  ],
                  [
                    44643.3,
                    42887
                  ],
                  [
                    44791.1,
                    43088.9
                  ],
                  [
                    44782.1,
                    43404.7
                  ],
                  [
                    44445.3,
                    43380.2
                  ],
                  [
                    44302.3,
                    43169.2
                  ],
                  [
                    44460,
                    42970.4
                  ]
                ],
                "id": 709,
                "chat_link": "[&BMUCAAA=]"
              },
              "710": {
                "name": "Craven Blight",
                "level": 80,
                "coord": [
                  43892.2,
                  43433.8
                ],
                "bounds": [
                  [
                    44302.6,
                    43169.2
                  ],
                  [
                    44445.5,
                    43380.2
                  ],
                  [
                    44200.3,
                    43548.1
                  ],
                  [
                    44048.2,
                    43689.7
                  ],
                  [
                    43819.8,
                    43685.5
                  ],
                  [
                    43599.5,
                    43612.5
                  ],
                  [
                    43507.3,
                    43465.1
                  ],
                  [
                    43515.1,
                    43308.5
                  ],
                  [
                    43559.2,
                    43206.3
                  ],
                  [
                    43836.3,
                    43332.9
                  ],
                  [
                    43980.3,
                    43373.9
                  ],
                  [
                    44302.6,
                    43169.2
                  ]
                ],
                "id": 710,
                "chat_link": "[&BMYCAAA=]"
              },
              "711": {
                "name": "Cathedral of Verdance",
                "level": 80,
                "coord": [
                  44061,
                  43084.8
                ],
                "bounds": [
                  [
                    44183.8,
                    42822.9
                  ],
                  [
                    44190,
                    42908.3
                  ],
                  [
                    44227.2,
                    42963.7
                  ],
                  [
                    44302.1,
                    43169.3
                  ],
                  [
                    43979.9,
                    43373
                  ],
                  [
                    43836,
                    43333.7
                  ],
                  [
                    43676,
                    43261.1
                  ],
                  [
                    44093.5,
                    42846.5
                  ],
                  [
                    44183.8,
                    42822.9
                  ]
                ],
                "id": 711,
                "chat_link": "[&BMcCAAA=]"
              },
              "712": {
                "name": "Harrowed Sea",
                "level": 80,
                "coord": [
                  43317.1,
                  43485
                ],
                "bounds": [
                  [
                    43508.1,
                    43464.8
                  ],
                  [
                    43600,
                    43612.9
                  ],
                  [
                    43355.5,
                    43944.7
                  ],
                  [
                    43159.6,
                    43951.1
                  ],
                  [
                    42968,
                    43796.8
                  ],
                  [
                    43045.7,
                    43367.2
                  ],
                  [
                    43132.9,
                    43138
                  ],
                  [
                    43325.1,
                    43057.7
                  ],
                  [
                    43560.1,
                    43208.3
                  ],
                  [
                    43515.8,
                    43308.3
                  ],
                  [
                    43508.1,
                    43464.8
                  ]
                ],
                "id": 712,
                "chat_link": "[&BMgCAAA=]"
              },
              "713": {
                "name": "Graven Cay",
                "level": 80,
                "coord": [
                  43240.1,
                  44405.5
                ],
                "bounds": [
                  [
                    43355.3,
                    43945
                  ],
                  [
                    43449.9,
                    44017.6
                  ],
                  [
                    43417.8,
                    44233.1
                  ],
                  [
                    43669.5,
                    44680.8
                  ],
                  [
                    43466.1,
                    44843.4
                  ],
                  [
                    43311.4,
                    44897.3
                  ],
                  [
                    42964.4,
                    45104.8
                  ],
                  [
                    42979.5,
                    44725.9
                  ],
                  [
                    42899.5,
                    44264.3
                  ],
                  [
                    42968.6,
                    43796.9
                  ],
                  [
                    43159.2,
                    43951.5
                  ],
                  [
                    43355.3,
                    43945
                  ]
                ],
                "id": 713,
                "chat_link": "[&BMkCAAA=]"
              },
              "714": {
                "name": "Cathedral of Silence",
                "level": 80,
                "coord": [
                  43517.4,
                  45141.8
                ],
                "bounds": [
                  [
                    43465,
                    44844
                  ],
                  [
                    43669.9,
                    44680.8
                  ],
                  [
                    43801.8,
                    45005.5
                  ],
                  [
                    43860.3,
                    45245.4
                  ],
                  [
                    43847.6,
                    45570.5
                  ],
                  [
                    43537.3,
                    45551.4
                  ],
                  [
                    43200.9,
                    45376.9
                  ],
                  [
                    42963.8,
                    45105
                  ],
                  [
                    43310.6,
                    44897.1
                  ],
                  [
                    43465,
                    44844
                  ]
                ],
                "id": 714,
                "chat_link": "[&BMoCAAA=]"
              },
              "715": {
                "name": "The Shipyard",
                "level": 80,
                "coord": [
                  43714.4,
                  44405.2
                ],
                "bounds": [
                  [
                    43599.7,
                    43613.2
                  ],
                  [
                    43611.7,
                    43858
                  ],
                  [
                    43673.5,
                    44084
                  ],
                  [
                    43689.9,
                    44368.5
                  ],
                  [
                    43899.7,
                    44514.8
                  ],
                  [
                    44071.4,
                    44725.9
                  ],
                  [
                    44188.1,
                    44975.2
                  ],
                  [
                    43860,
                    45245.5
                  ],
                  [
                    43801,
                    45005.5
                  ],
                  [
                    43669.8,
                    44681
                  ],
                  [
                    43417.3,
                    44233.5
                  ],
                  [
                    43449.5,
                    44017.8
                  ],
                  [
                    43355.6,
                    43944.9
                  ],
                  [
                    43599.7,
                    43613.2
                  ]
                ],
                "id": 715,
                "chat_link": "[&BMsCAAA=]"
              },
              "716": {
                "name": "Mausollus Sea",
                "level": 80,
                "coord": [
                  44352.4,
                  45348.5
                ],
                "bounds": [
                  [
                    44188.5,
                    44974.8
                  ],
                  [
                    44176.8,
                    45147.1
                  ],
                  [
                    44255.3,
                    45277.9
                  ],
                  [
                    44402.5,
                    45343.7
                  ],
                  [
                    44625.4,
                    45292
                  ],
                  [
                    44693.5,
                    45344.9
                  ],
                  [
                    44865.1,
                    45371
                  ],
                  [
                    44738.5,
                    45627
                  ],
                  [
                    44223.8,
                    45639
                  ],
                  [
                    43847.5,
                    45570.4
                  ],
                  [
                    43859.9,
                    45245.5
                  ],
                  [
                    44188.5,
                    44974.8
                  ]
                ],
                "id": 716,
                "chat_link": "[&BMwCAAA=]"
              },
              "717": {
                "name": "Desmina's Hallows",
                "level": 80,
                "coord": [
                  44453.4,
                  44936.2
                ],
                "bounds": [
                  [
                    44254.7,
                    45277.6
                  ],
                  [
                    44177.2,
                    45147.4
                  ],
                  [
                    44188.3,
                    44974.2
                  ],
                  [
                    44071,
                    44726.4
                  ],
                  [
                    43967.5,
                    44599.1
                  ],
                  [
                    44153.5,
                    44457.8
                  ],
                  [
                    44238.6,
                    44517.1
                  ],
                  [
                    44364.7,
                    44579.3
                  ],
                  [
                    44587.8,
                    44579.2
                  ],
                  [
                    44896.2,
                    44639.5
                  ],
                  [
                    44856.9,
                    44941.7
                  ],
                  [
                    44911.2,
                    45187.3
                  ],
                  [
                    44864.8,
                    45371.2
                  ],
                  [
                    44693.7,
                    45345.1
                  ],
                  [
                    44624.7,
                    45291.8
                  ],
                  [
                    44403.8,
                    45344.1
                  ],
                  [
                    44254.7,
                    45277.6
                  ]
                ],
                "id": 717,
                "chat_link": "[&BM0CAAA=]"
              },
              "718": {
                "name": "Compass Plaza",
                "level": 80,
                "coord": [
                  43925.6,
                  44122
                ],
                "bounds": [
                  [
                    43901.4,
                    44515.3
                  ],
                  [
                    43690.3,
                    44370
                  ],
                  [
                    43673.5,
                    44086.8
                  ],
                  [
                    43611.8,
                    43858.5
                  ],
                  [
                    43600,
                    43613.6
                  ],
                  [
                    43820.4,
                    43686.5
                  ],
                  [
                    44048,
                    43690.1
                  ],
                  [
                    44084.9,
                    43882.3
                  ],
                  [
                    44239.1,
                    43980.5
                  ],
                  [
                    44100.4,
                    44160.5
                  ],
                  [
                    44005.4,
                    44206.1
                  ],
                  [
                    43972,
                    44313.1
                  ],
                  [
                    44016.3,
                    44407.6
                  ],
                  [
                    44153.5,
                    44456.7
                  ],
                  [
                    43967.3,
                    44602.3
                  ],
                  [
                    43901.4,
                    44515.3
                  ]
                ],
                "id": 718,
                "chat_link": "[&BM4CAAA=]"
              },
              "719": {
                "name": "Azabe Qabar, the Royal Tombs",
                "level": 80,
                "coord": [
                  44449.6,
                  43664
                ],
                "bounds": [
                  [
                    44200.4,
                    43548.4
                  ],
                  [
                    44445.3,
                    43380
                  ],
                  [
                    44782.4,
                    43404.4
                  ],
                  [
                    44920,
                    43576.3
                  ],
                  [
                    44877.3,
                    43850.8
                  ],
                  [
                    44239.1,
                    43980.2
                  ],
                  [
                    44084.6,
                    43882.4
                  ],
                  [
                    44048,
                    43689.9
                  ],
                  [
                    44200.4,
                    43548.4
                  ]
                ],
                "id": 719,
                "chat_link": "[&BM8CAAA=]"
              },
              "720": {
                "name": "Promenade of the Gods",
                "level": 80,
                "coord": [
                  44272.6,
                  44293.7
                ],
                "bounds": [
                  [
                    44005.3,
                    44206.3
                  ],
                  [
                    44100.5,
                    44160.2
                  ],
                  [
                    44239.5,
                    43979.3
                  ],
                  [
                    44434.6,
                    43932.7
                  ],
                  [
                    44430.2,
                    44122.1
                  ],
                  [
                    44467.1,
                    44242.6
                  ],
                  [
                    44532.9,
                    44320.5
                  ],
                  [
                    44587.9,
                    44579.4
                  ],
                  [
                    44364.8,
                    44579.3
                  ],
                  [
                    44238.5,
                    44518
                  ],
                  [
                    44153.7,
                    44456.6
                  ],
                  [
                    44016.5,
                    44407.7
                  ],
                  [
                    43971.9,
                    44313.3
                  ],
                  [
                    44005.3,
                    44206.3
                  ]
                ],
                "id": 720,
                "chat_link": "[&BNACAAA=]"
              },
              "721": {
                "name": "The Narthex",
                "level": 80,
                "coord": [
                  44695.6,
                  44206.1
                ],
                "bounds": [
                  [
                    44532.9,
                    44320.2
                  ],
                  [
                    44466.6,
                    44242.8
                  ],
                  [
                    44430,
                    44122.3
                  ],
                  [
                    44426.3,
                    43933.1
                  ],
                  [
                    44642.5,
                    43897.2
                  ],
                  [
                    44704.4,
                    43988.6
                  ],
                  [
                    44880.5,
                    43941.2
                  ],
                  [
                    44928.5,
                    44097.8
                  ],
                  [
                    44788.8,
                    44203.9
                  ],
                  [
                    44843.5,
                    44279.3
                  ],
                  [
                    44913.9,
                    44434.2
                  ],
                  [
                    44896.4,
                    44639.5
                  ],
                  [
                    44587.9,
                    44579
                  ],
                  [
                    44532.9,
                    44320.2
                  ]
                ],
                "id": 721,
                "chat_link": "[&BNECAAA=]"
              }
            },
            "adventures": [],
            "id": 1194,
            "mastery_points": []
          },
          "1203": {
            "name": "Siren's Landing",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              48688,
              42184
            ],
            "map_rect": [
              [
                -39936,
                -15360
              ],
              [
                39936,
                15360
              ]
            ],
            "continent_rect": [
              [
                47002,
                41600
              ],
              [
                50330,
                42880
              ]
            ],
            "points_of_interest": {
              "2524": {
                "name": "Mosaic Bower",
                "type": "vista",
                "floor": 1,
                "coord": [
                  48238.5,
                  42587.7
                ],
                "id": 2524,
                "chat_link": "[&BNwJAAA=]"
              },
              "2525": {
                "name": "Wreck of the Yesteryear",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49902.9,
                  42613.8
                ],
                "id": 2525,
                "chat_link": "[&BN0JAAA=]"
              },
              "2526": {
                "name": "The Arm of Abaddon",
                "type": "vista",
                "floor": 1,
                "coord": [
                  48982.7,
                  41843.3
                ],
                "id": 2526,
                "chat_link": "[&BN4JAAA=]"
              },
              "2527": {
                "name": "Updraft Alley",
                "type": "vista",
                "floor": 1,
                "coord": [
                  47484.3,
                  42304.8
                ],
                "id": 2527,
                "chat_link": "[&BN8JAAA=]"
              },
              "2528": {
                "name": "Tears of Orr",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47883.4,
                  42565
                ],
                "id": 2528,
                "chat_link": "[&BOAJAAA=]"
              },
              "2529": {
                "name": "Secret Garden",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48828.8,
                  41688
                ],
                "id": 2529,
                "chat_link": "[&BOEJAAA=]"
              },
              "2530": {
                "name": "The Arm of Abaddon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49641.6,
                  41978.4
                ],
                "id": 2530,
                "chat_link": "[&BOIJAAA=]"
              },
              "2531": {
                "name": "Hidden Reliquary",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47996.2,
                  42093.9
                ],
                "id": 2531,
                "chat_link": "[&BOMJAAA=]"
              },
              "2532": {
                "name": "Balthazar's Vein",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47876.5,
                  41736.5
                ],
                "id": 2532,
                "chat_link": "[&BOQJAAA=]"
              },
              "2533": {
                "name": "Camp Reclamation",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49257.8,
                  42710.2
                ],
                "id": 2533,
                "chat_link": "[&BOUJAAA=]"
              },
              "2534": {
                "name": "Camp Winfred",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49223.2,
                  42414.2
                ],
                "id": 2534,
                "chat_link": "[&BOYJAAA=]"
              },
              "2535": {
                "name": "Overgrown Gazebo",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47613.6,
                  42083.4
                ],
                "id": 2535,
                "chat_link": "[&BOcJAAA=]"
              },
              "2536": {
                "name": "Wyvern's Den",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47196.5,
                  42358.8
                ],
                "id": 2536,
                "chat_link": "[&BOgJAAA=]"
              },
              "2537": {
                "name": "Hiffa's Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47829.2,
                  42356.8
                ],
                "id": 2537,
                "chat_link": "[&BOkJAAA=]"
              },
              "2539": {
                "name": "Forgotten Plaza",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48263.9,
                  42073.6
                ],
                "id": 2539,
                "chat_link": "[&BOsJAAA=]"
              },
              "2540": {
                "name": "Watchman's Roost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48467.4,
                  42432.6
                ],
                "id": 2540,
                "chat_link": "[&BOwJAAA=]"
              },
              "2541": {
                "name": "Ancient Greenhouse",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48579,
                  42660.8
                ],
                "id": 2541,
                "chat_link": "[&BO0JAAA=]"
              },
              "2542": {
                "name": "Balthazar's Heart",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47341.6,
                  41823.1
                ],
                "id": 2542,
                "chat_link": "[&BO4JAAA=]"
              },
              "2543": {
                "name": "Camp Reclamation Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49392.5,
                  42605
                ],
                "id": 2543,
                "chat_link": "[&BO8JAAA=]"
              },
              "2544": {
                "name": "The Buoyant Bough",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49965.4,
                  42355.2
                ],
                "id": 2544,
                "chat_link": "[&BPAJAAA=]"
              },
              "2545": {
                "name": "Thoroughfare Ruins",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48308.8,
                  42772.5
                ],
                "id": 2545,
                "chat_link": "[&BPEJAAA=]"
              },
              "2548": {
                "name": "Ruined Panorama",
                "type": "vista",
                "floor": 1,
                "coord": [
                  49389.8,
                  42721.4
                ],
                "id": 2548,
                "chat_link": "[&BPQJAAA=]"
              }
            },
            "tasks": {
              "382": {
                "objective": "Reclaim Grenth's reliquary.",
                "level": 80,
                "coord": [
                  47771.9,
                  42678.6
                ],
                "bounds": [
                  [
                    47863.1,
                    42463.8
                  ],
                  [
                    47798.7,
                    42443.2
                  ],
                  [
                    47762.1,
                    42455.1
                  ],
                  [
                    47540.6,
                    42351.6
                  ],
                  [
                    47368.6,
                    42764.6
                  ],
                  [
                    47679,
                    42925.1
                  ],
                  [
                    47849.7,
                    42820.3
                  ],
                  [
                    47914.6,
                    42844.1
                  ],
                  [
                    48067.8,
                    42793.5
                  ],
                  [
                    47863.1,
                    42463.8
                  ]
                ],
                "id": 382,
                "chat_link": "[&BH4BAAA=]"
              },
              "383": {
                "objective": "Reclaim Dwayna's reliquary.",
                "level": 80,
                "coord": [
                  47359.1,
                  42320.2
                ],
                "bounds": [
                  [
                    47492.7,
                    42470.8
                  ],
                  [
                    47532.8,
                    42345.1
                  ],
                  [
                    47504.9,
                    42192.3
                  ],
                  [
                    47411.6,
                    42027
                  ],
                  [
                    47346.5,
                    42072.4
                  ],
                  [
                    47254.6,
                    42079.9
                  ],
                  [
                    47121,
                    42027.1
                  ],
                  [
                    47036.6,
                    42143.7
                  ],
                  [
                    47027,
                    42463.6
                  ],
                  [
                    47002.7,
                    42913.1
                  ],
                  [
                    47248,
                    42918.6
                  ],
                  [
                    47318.7,
                    42864.2
                  ],
                  [
                    47492.7,
                    42470.8
                  ]
                ],
                "id": 383,
                "chat_link": "[&BH8BAAA=]"
              },
              "384": {
                "objective": "Reclaim Melandru's reliquary.",
                "level": 80,
                "coord": [
                  48655.5,
                  42554.1
                ],
                "bounds": [
                  [
                    49002.1,
                    42554.1
                  ],
                  [
                    48678.1,
                    42482.3
                  ],
                  [
                    48515.6,
                    42461.4
                  ],
                  [
                    48412,
                    42478.1
                  ],
                  [
                    47839.4,
                    42503.5
                  ],
                  [
                    48026.9,
                    42741.7
                  ],
                  [
                    48274.2,
                    42855
                  ],
                  [
                    48496.1,
                    42876.3
                  ],
                  [
                    48607.9,
                    42847.4
                  ],
                  [
                    48699.1,
                    42792.9
                  ],
                  [
                    48802.3,
                    42837.8
                  ],
                  [
                    48959.2,
                    42732.9
                  ],
                  [
                    49002.1,
                    42554.1
                  ]
                ],
                "id": 384,
                "chat_link": "[&BIABAAA=]"
              },
              "385": {
                "objective": "Reclaim Balthazar's reliquary.",
                "level": 80,
                "coord": [
                  47546.6,
                  41688.9
                ],
                "bounds": [
                  [
                    47539,
                    41892.1
                  ],
                  [
                    47666.9,
                    41855.5
                  ],
                  [
                    47844.5,
                    41821.9
                  ],
                  [
                    47991.9,
                    41810.8
                  ],
                  [
                    48189.6,
                    41855.5
                  ],
                  [
                    48290.2,
                    41802.1
                  ],
                  [
                    48274.3,
                    41720.5
                  ],
                  [
                    48114.4,
                    41644.2
                  ],
                  [
                    47944.7,
                    41623.9
                  ],
                  [
                    47773.3,
                    41638.4
                  ],
                  [
                    47693.4,
                    41625.9
                  ],
                  [
                    47534.2,
                    41628
                  ],
                  [
                    47386.3,
                    41624.2
                  ],
                  [
                    47262.1,
                    41624.1
                  ],
                  [
                    47124.2,
                    41651
                  ],
                  [
                    46961.8,
                    41734.1
                  ],
                  [
                    46936.5,
                    41854.4
                  ],
                  [
                    47060.3,
                    41946.1
                  ],
                  [
                    47100.3,
                    42028.1
                  ],
                  [
                    47272.7,
                    42058.5
                  ],
                  [
                    47353.6,
                    42058.6
                  ],
                  [
                    47463.7,
                    41978.3
                  ],
                  [
                    47539,
                    41892.1
                  ]
                ],
                "id": 385,
                "chat_link": "[&BIEBAAA=]"
              },
              "386": {
                "objective": "Reclaim Lyssa's reliquary.",
                "level": 80,
                "coord": [
                  48593.9,
                  41853.9
                ],
                "bounds": [
                  [
                    48672.8,
                    42072
                  ],
                  [
                    48898.3,
                    41972.2
                  ],
                  [
                    48927.5,
                    41665.1
                  ],
                  [
                    48885.4,
                    41632.5
                  ],
                  [
                    48795.5,
                    41622.1
                  ],
                  [
                    48671.2,
                    41639.2
                  ],
                  [
                    48506.6,
                    41599.9
                  ],
                  [
                    48244.3,
                    41677.7
                  ],
                  [
                    48267.6,
                    41792.8
                  ],
                  [
                    48169.5,
                    41852.6
                  ],
                  [
                    48172.3,
                    42136.2
                  ],
                  [
                    48301.8,
                    42173
                  ],
                  [
                    48513.8,
                    42158.8
                  ],
                  [
                    48672.8,
                    42072
                  ]
                ],
                "id": 386,
                "chat_link": "[&BIIBAAA=]"
              }
            },
            "skill_challenges": [],
            "sectors": {
              "1469": {
                "name": "Risen Lowlands",
                "level": 80,
                "coord": [
                  49210.5,
                  42622.5
                ],
                "bounds": [
                  [
                    49665.4,
                    42841.9
                  ],
                  [
                    49645.8,
                    42646.2
                  ],
                  [
                    49549,
                    42569.8
                  ],
                  [
                    49431.6,
                    42489.5
                  ],
                  [
                    49225,
                    42378.3
                  ],
                  [
                    49133.7,
                    42325.7
                  ],
                  [
                    48791.5,
                    42530.7
                  ],
                  [
                    48855,
                    42760.1
                  ],
                  [
                    48913.9,
                    42713
                  ],
                  [
                    48958.6,
                    42748.3
                  ],
                  [
                    49145.7,
                    42844.1
                  ],
                  [
                    49665.4,
                    42841.9
                  ]
                ],
                "id": 1469,
                "chat_link": "[&BL0FAAA=]"
              },
              "1470": {
                "name": "Bloated Beach",
                "level": 80,
                "coord": [
                  49528.1,
                  42380
                ],
                "bounds": [
                  [
                    50032.3,
                    42803.8
                  ],
                  [
                    50030.8,
                    42173.6
                  ],
                  [
                    49785.5,
                    42112.5
                  ],
                  [
                    49639.3,
                    42200.1
                  ],
                  [
                    49575,
                    42179.8
                  ],
                  [
                    49464.1,
                    42039.1
                  ],
                  [
                    49204.7,
                    42117.2
                  ],
                  [
                    49032.2,
                    42122.2
                  ],
                  [
                    49046.3,
                    42246
                  ],
                  [
                    49133.7,
                    42325.7
                  ],
                  [
                    49225,
                    42378.3
                  ],
                  [
                    49431.6,
                    42489.5
                  ],
                  [
                    49549,
                    42569.8
                  ],
                  [
                    49645.8,
                    42646.2
                  ],
                  [
                    49665.4,
                    42841.9
                  ],
                  [
                    49989.1,
                    42834.2
                  ],
                  [
                    50032.3,
                    42803.8
                  ]
                ],
                "id": 1470,
                "chat_link": "[&BL4FAAA=]"
              },
              "1471": {
                "name": "Abaddon's Reliquary",
                "level": 80,
                "coord": [
                  47784.7,
                  42069.8
                ],
                "bounds": [
                  [
                    48185.6,
                    41854.6
                  ],
                  [
                    48003.6,
                    41804
                  ],
                  [
                    47857.3,
                    41818.1
                  ],
                  [
                    47676.9,
                    41850.6
                  ],
                  [
                    47534.8,
                    41879.9
                  ],
                  [
                    47396.9,
                    42017.8
                  ],
                  [
                    47504.4,
                    42189.4
                  ],
                  [
                    47652.2,
                    42346.9
                  ],
                  [
                    47773,
                    42410.3
                  ],
                  [
                    47864.5,
                    42467.2
                  ],
                  [
                    48182.5,
                    42129.4
                  ],
                  [
                    48185.6,
                    41854.6
                  ]
                ],
                "id": 1471,
                "chat_link": "[&BL8FAAA=]"
              },
              "1472": {
                "name": "Melandru's Reliquary",
                "level": 80,
                "coord": [
                  48442.6,
                  42732.1
                ],
                "bounds": [
                  [
                    48791.5,
                    42530.7
                  ],
                  [
                    48660.4,
                    42509
                  ],
                  [
                    48500,
                    42509
                  ],
                  [
                    47834.5,
                    42510.6
                  ],
                  [
                    48026.9,
                    42741.7
                  ],
                  [
                    48132.6,
                    42794.2
                  ],
                  [
                    48205.2,
                    42820.5
                  ],
                  [
                    48275.4,
                    42827.8
                  ],
                  [
                    48329,
                    42833.3
                  ],
                  [
                    48432.9,
                    42840.9
                  ],
                  [
                    48481,
                    42841.4
                  ],
                  [
                    48607.9,
                    42847.4
                  ],
                  [
                    48699,
                    42792.8
                  ],
                  [
                    48807.6,
                    42822.2
                  ],
                  [
                    48855,
                    42760.1
                  ],
                  [
                    48791.5,
                    42530.7
                  ]
                ],
                "id": 1472,
                "chat_link": "[&BMAFAAA=]"
              },
              "1473": {
                "name": "Merciless Shore",
                "level": 80,
                "coord": [
                  48559.7,
                  42304.8
                ],
                "bounds": [
                  [
                    49133.7,
                    42325.7
                  ],
                  [
                    49046.3,
                    42246
                  ],
                  [
                    49032.2,
                    42122.2
                  ],
                  [
                    48885.5,
                    41968.9
                  ],
                  [
                    48513.5,
                    42161.6
                  ],
                  [
                    48292.3,
                    42173.7
                  ],
                  [
                    48182.5,
                    42129.4
                  ],
                  [
                    47843.8,
                    42470.9
                  ],
                  [
                    47834.5,
                    42510.6
                  ],
                  [
                    48500,
                    42509
                  ],
                  [
                    48660.4,
                    42509
                  ],
                  [
                    48791.5,
                    42530.7
                  ],
                  [
                    49133.7,
                    42325.7
                  ]
                ],
                "id": 1473,
                "chat_link": "[&BMEFAAA=]"
              },
              "1475": {
                "name": "Grenth's Reliquary",
                "level": 80,
                "coord": [
                  47705.2,
                  42669
                ],
                "bounds": [
                  [
                    47864.5,
                    42467.2
                  ],
                  [
                    47773,
                    42410.3
                  ],
                  [
                    47652.2,
                    42346.9
                  ],
                  [
                    47483,
                    42407.4
                  ],
                  [
                    47405.3,
                    42725.4
                  ],
                  [
                    47498.3,
                    42846.5
                  ],
                  [
                    47559.3,
                    42854.5
                  ],
                  [
                    47678.5,
                    42850
                  ],
                  [
                    47849.8,
                    42820.3
                  ],
                  [
                    47914.6,
                    42844.1
                  ],
                  [
                    48078.9,
                    42786
                  ],
                  [
                    47864.5,
                    42467.2
                  ]
                ],
                "id": 1475,
                "chat_link": "[&BMMFAAA=]"
              },
              "1476": {
                "name": "Pilaster Rock",
                "level": 80,
                "coord": [
                  49662.9,
                  41967.2
                ],
                "bounds": [
                  [
                    49836.5,
                    41997
                  ],
                  [
                    49800.5,
                    41913.1
                  ],
                  [
                    49728.5,
                    41802
                  ],
                  [
                    49677.2,
                    41783
                  ],
                  [
                    49593.5,
                    41801.6
                  ],
                  [
                    49528.7,
                    41843.6
                  ],
                  [
                    49464.1,
                    42039.1
                  ],
                  [
                    49575,
                    42179.8
                  ],
                  [
                    49639.3,
                    42200.1
                  ],
                  [
                    49785.5,
                    42112.5
                  ],
                  [
                    49836.5,
                    41997
                  ]
                ],
                "id": 1476,
                "chat_link": "[&BMQFAAA=]"
              },
              "1477": {
                "name": "Dwayna's Reliquary",
                "level": 80,
                "coord": [
                  47242.9,
                  42446
                ],
                "bounds": [
                  [
                    47483,
                    42407.4
                  ],
                  [
                    47652.2,
                    42346.9
                  ],
                  [
                    47504.4,
                    42189.4
                  ],
                  [
                    47405.4,
                    42028.5
                  ],
                  [
                    47354.3,
                    42075.1
                  ],
                  [
                    47244.8,
                    42087.8
                  ],
                  [
                    47103.7,
                    42024.4
                  ],
                  [
                    47041.8,
                    42096.7
                  ],
                  [
                    47030.2,
                    42146.7
                  ],
                  [
                    47069.3,
                    42518.8
                  ],
                  [
                    47115.8,
                    42552.9
                  ],
                  [
                    47156.8,
                    42620.2
                  ],
                  [
                    47106,
                    42659.3
                  ],
                  [
                    47063.5,
                    42686.3
                  ],
                  [
                    47062.2,
                    42791.3
                  ],
                  [
                    47108.8,
                    42824.7
                  ],
                  [
                    47331.7,
                    42834.2
                  ],
                  [
                    47380.3,
                    42811.5
                  ],
                  [
                    47401.8,
                    42771.8
                  ],
                  [
                    47483,
                    42407.4
                  ]
                ],
                "id": 1477,
                "chat_link": "[&BMUFAAA=]"
              },
              "1481": {
                "name": "Choking Depths",
                "level": 80,
                "coord": [
                  49538.7,
                  41885.3
                ],
                "bounds": [
                  [
                    50030.8,
                    42173.6
                  ],
                  [
                    50021.5,
                    41301.9
                  ],
                  [
                    49101.8,
                    41348.5
                  ],
                  [
                    49066.2,
                    41678.2
                  ],
                  [
                    48885.5,
                    41968.9
                  ],
                  [
                    49032.2,
                    42122.2
                  ],
                  [
                    49204.7,
                    42117.2
                  ],
                  [
                    49464.1,
                    42039.1
                  ],
                  [
                    49528.7,
                    41843.6
                  ],
                  [
                    49593.5,
                    41801.6
                  ],
                  [
                    49677.2,
                    41783
                  ],
                  [
                    49728.5,
                    41802
                  ],
                  [
                    49800.5,
                    41913.1
                  ],
                  [
                    49836.5,
                    41997
                  ],
                  [
                    49785.5,
                    42112.5
                  ],
                  [
                    49862.6,
                    42162.1
                  ],
                  [
                    50030.8,
                    42173.6
                  ]
                ],
                "id": 1481,
                "chat_link": "[&BMkFAAA=]"
              },
              "1482": {
                "name": "Balthazar's Reliquary",
                "level": 80,
                "coord": [
                  47589,
                  41793.3
                ],
                "bounds": [
                  [
                    47535.1,
                    41888
                  ],
                  [
                    47676.9,
                    41850.6
                  ],
                  [
                    47857.3,
                    41818.1
                  ],
                  [
                    48003.6,
                    41804
                  ],
                  [
                    48185.6,
                    41854.6
                  ],
                  [
                    48279,
                    41797.5
                  ],
                  [
                    48245.5,
                    41668.9
                  ],
                  [
                    48120,
                    41278.9
                  ],
                  [
                    47096.1,
                    41222.9
                  ],
                  [
                    47026.5,
                    41746.1
                  ],
                  [
                    47046.5,
                    41836
                  ],
                  [
                    47060.3,
                    41946.1
                  ],
                  [
                    47103.7,
                    42024.4
                  ],
                  [
                    47244.8,
                    42087.8
                  ],
                  [
                    47354.3,
                    42075.1
                  ],
                  [
                    47535.1,
                    41888
                  ]
                ],
                "id": 1482,
                "chat_link": "[&BMoFAAA=]"
              },
              "1483": {
                "name": "Lyssa's Reliquary",
                "level": 80,
                "coord": [
                  48504.5,
                  41831.7
                ],
                "bounds": [
                  [
                    48672.8,
                    42072.1
                  ],
                  [
                    48885.5,
                    41968.9
                  ],
                  [
                    49066.2,
                    41678.2
                  ],
                  [
                    49108.1,
                    41363.5
                  ],
                  [
                    48118.7,
                    41280.1
                  ],
                  [
                    48245.5,
                    41668.9
                  ],
                  [
                    48279,
                    41797.5
                  ],
                  [
                    48185.6,
                    41854.6
                  ],
                  [
                    48182.5,
                    42129.4
                  ],
                  [
                    48292.3,
                    42173.7
                  ],
                  [
                    48513.5,
                    42161.6
                  ],
                  [
                    48672.8,
                    42072.1
                  ]
                ],
                "id": 1483,
                "chat_link": "[&BMsFAAA=]"
              }
            },
            "adventures": [],
            "id": 1203,
            "mastery_points": [
              {
                "coord": [
                  47239.6,
                  42460
                ],
                "id": 312,
                "region": "Maguuma"
              },
              {
                "coord": [
                  47532.2,
                  42658.3
                ],
                "id": 316,
                "region": "Maguuma"
              },
              {
                "coord": [
                  47172.8,
                  41776.4
                ],
                "id": 308,
                "region": "Maguuma"
              },
              {
                "coord": [
                  49894.2,
                  42382.4
                ],
                "id": 327,
                "region": "Maguuma"
              },
              {
                "coord": [
                  48260.5,
                  42615.9
                ],
                "id": 310,
                "region": "Maguuma"
              }
            ]
          },
          "1207": {
            "name": "The Last Chance",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              48688,
              41384
            ],
            "map_rect": [
              [
                -39936,
                -15360
              ],
              [
                39936,
                15360
              ]
            ],
            "continent_rect": [
              [
                47002,
                41600
              ],
              [
                50330,
                42880
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1207,
            "mastery_points": []
          }
        },
        "id": 3
      },
      "4": {
        "name": "Kryta",
        "label_coord": [
          46208,
          30080
        ],
        "continent_rect": [
          [
            42112,
            25856
          ],
          [
            50432,
            36864
          ]
        ],
        "maps": {
          "15": {
            "name": "Queensdale",
            "min_level": 1,
            "max_level": 15,
            "default_floor": 1,
            "label_coord": [
              44416,
              29248
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                30720
              ]
            ],
            "continent_rect": [
              [
                42624,
                28032
              ],
              [
                46208,
                30464
              ]
            ],
            "points_of_interest": {
              "127": {
                "name": "Eda's Orchard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42830.7,
                  28406.7
                ],
                "id": 127,
                "chat_link": "[&BH8AAAA=]"
              },
              "128": {
                "name": "Mepi's Moa Ranch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42845.6,
                  28728.5
                ],
                "id": 128,
                "chat_link": "[&BIAAAAA=]"
              },
              "129": {
                "name": "Jeb's Wheatfield",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43185.6,
                  28652.4
                ],
                "id": 129,
                "chat_link": "[&BIEAAAA=]"
              },
              "130": {
                "name": "Dalin's Pumping Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43400.7,
                  29097.3
                ],
                "id": 130,
                "chat_link": "[&BIIAAAA=]"
              },
              "131": {
                "name": "Altar Brook Trading Post",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44065.5,
                  29380.8
                ],
                "id": 131,
                "chat_link": "[&BIMAAAA=]"
              },
              "132": {
                "name": "Altar Brook Crossing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43709.1,
                  29563.7
                ],
                "id": 132,
                "chat_link": "[&BIQAAAA=]"
              },
              "133": {
                "name": "Hunting Lodge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45312,
                  28554.8
                ],
                "id": 133,
                "chat_link": "[&BIUAAAA=]"
              },
              "134": {
                "name": "Eldvin Monastery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45185.3,
                  29265.2
                ],
                "id": 134,
                "chat_link": "[&BIYAAAA=]"
              },
              "135": {
                "name": "Holdland Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45517.1,
                  29263.3
                ],
                "id": 135,
                "chat_link": "[&BIcAAAA=]"
              },
              "136": {
                "name": "Hidden Cliff Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46077.5,
                  29534.1
                ],
                "id": 136,
                "chat_link": "[&BIgAAAA=]"
              },
              "137": {
                "name": "Cliffwatch Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45658.4,
                  29619.7
                ],
                "id": 137,
                "chat_link": "[&BIkAAAA=]"
              },
              "138": {
                "name": "Deathroot Shack",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44911.2,
                  29856.2
                ],
                "id": 138,
                "chat_link": "[&BIoAAAA=]"
              },
              "139": {
                "name": "Temple of the Ages",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45150.8,
                  29776.4
                ],
                "id": 139,
                "chat_link": "[&BIsAAAA=]"
              },
              "140": {
                "name": "Righteous Hoofmoot",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45880.1,
                  30171.8
                ],
                "id": 140,
                "chat_link": "[&BIwAAAA=]"
              },
              "239": {
                "name": "Shaemoor Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43728.4,
                  28589.9
                ],
                "id": 239,
                "chat_link": "[&BO8AAAA=]"
              },
              "240": {
                "name": "Fields Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43356.9,
                  28720.8
                ],
                "id": 240,
                "chat_link": "[&BPAAAAA=]"
              },
              "241": {
                "name": "Garrison Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44094.9,
                  28803.7
                ],
                "id": 241,
                "chat_link": "[&BPEAAAA=]"
              },
              "242": {
                "name": "Crossing Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43584.3,
                  29518.7
                ],
                "id": 242,
                "chat_link": "[&BPIAAAA=]"
              },
              "243": {
                "name": "Phinney Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44548.8,
                  29806.5
                ],
                "id": 243,
                "chat_link": "[&BPMAAAA=]"
              },
              "244": {
                "name": "Vale Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  42996.3,
                  29695.9
                ],
                "id": 244,
                "chat_link": "[&BPQAAAA=]"
              },
              "245": {
                "name": "Heartwood Pass Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44239.4,
                  30073.3
                ],
                "id": 245,
                "chat_link": "[&BPUAAAA=]"
              },
              "246": {
                "name": "Claypool Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43482,
                  29972.5
                ],
                "id": 246,
                "chat_link": "[&BPYAAAA=]"
              },
              "247": {
                "name": "Swamplost Haven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44959.4,
                  30336.3
                ],
                "id": 247,
                "chat_link": "[&BPcAAAA=]"
              },
              "248": {
                "name": "Krytan Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  45150.5,
                  29080.3
                ],
                "id": 248,
                "chat_link": "[&BPgAAAA=]"
              },
              "249": {
                "name": "Ojon's Lumbermill Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44714.8,
                  28616.8
                ],
                "id": 249,
                "chat_link": "[&BPkAAAA=]"
              },
              "250": {
                "name": "Beetletun Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  45967.6,
                  28419.5
                ],
                "id": 250,
                "chat_link": "[&BPoAAAA=]"
              },
              "251": {
                "name": "Tunwatch Redoubt Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  45690.6,
                  29146.2
                ],
                "id": 251,
                "chat_link": "[&BPsAAAA=]"
              },
              "252": {
                "name": "Godslost Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  45274.7,
                  29755
                ],
                "id": 252,
                "chat_link": "[&BPwAAAA=]"
              },
              "835": {
                "name": "Bonegrinder's Gully",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45565.6,
                  30320.7
                ],
                "id": 835,
                "chat_link": "[&BEMDAAA=]"
              },
              "836": {
                "name": "Orchard Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  42863.9,
                  28509.6
                ],
                "id": 836,
                "chat_link": "[&BEQDAAA=]"
              },
              "837": {
                "name": "Scaver Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44145.3,
                  29193.7
                ],
                "id": 837,
                "chat_link": "[&BEUDAAA=]"
              },
              "851": {
                "name": "Trainer's Terrace",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43626.4,
                  28710.2
                ],
                "id": 851,
                "chat_link": "[&BFMDAAA=]"
              },
              "1361": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43090,
                  28127.8
                ],
                "id": 1361,
                "chat_link": "[&BFEFAAA=]"
              },
              "1382": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43093.7,
                  30157.3
                ],
                "id": 1382,
                "chat_link": "[&BGYFAAA=]"
              },
              "1383": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  45043,
                  29064.9
                ],
                "id": 1383,
                "chat_link": "[&BGcFAAA=]"
              },
              "1384": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43559.9,
                  28989.5
                ],
                "id": 1384,
                "chat_link": "[&BGgFAAA=]"
              },
              "1385": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  45993.8,
                  28528.9
                ],
                "id": 1385,
                "chat_link": "[&BGkFAAA=]"
              },
              "1386": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  42882.6,
                  29808.8
                ],
                "id": 1386,
                "chat_link": "[&BGoFAAA=]"
              },
              "1387": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43184.7,
                  29210
                ],
                "id": 1387,
                "chat_link": "[&BGsFAAA=]"
              },
              "1388": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  44895.7,
                  29797
                ],
                "id": 1388,
                "chat_link": "[&BGwFAAA=]"
              },
              "1389": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  44143.4,
                  28849.3
                ],
                "id": 1389,
                "chat_link": "[&BG0FAAA=]"
              },
              "1672": {
                "name": "Kappa's Corral",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45041.2,
                  28957
                ],
                "id": 1672,
                "chat_link": "[&BIgGAAA=]"
              },
              "1673": {
                "name": "Beetletun Waterworks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45607.8,
                  28867.8
                ],
                "id": 1673,
                "chat_link": "[&BIkGAAA=]"
              },
              "1674": {
                "name": "Greatheart Weald",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44258,
                  29700.6
                ],
                "id": 1674,
                "chat_link": "[&BIoGAAA=]"
              },
              "1675": {
                "name": "Bar Curtis Ranch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43215.5,
                  29722.4
                ],
                "id": 1675,
                "chat_link": "[&BIsGAAA=]"
              },
              "1676": {
                "name": "Duran Brothers' Docks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43110.4,
                  30146.3
                ],
                "id": 1676,
                "chat_link": "[&BIwGAAA=]"
              },
              "1737": {
                "name": "Caudecus's Manor",
                "type": "unlock",
                "floor": 1,
                "coord": [
                  46046,
                  28325
                ],
                "id": 1737,
                "chat_link": "[&BMkGAAA=]",
                "icon": "https://render.guildwars2.com/file/943538394A94A491C8632FBEF6203C2013443555/102478.png"
              }
            },
            "tasks": {
              "211": {
                "objective": "Help the Seraph protect Claypool from centaurs.",
                "level": 9,
                "coord": [
                  44063.9,
                  29886.6
                ],
                "bounds": [
                  [
                    43757.6,
                    29866.2
                  ],
                  [
                    43743.7,
                    30189.7
                  ],
                  [
                    44251.2,
                    30269.5
                  ],
                  [
                    44443.1,
                    30102.9
                  ],
                  [
                    44366.6,
                    29859.8
                  ],
                  [
                    44152,
                    29749.1
                  ],
                  [
                    43757.6,
                    29866.2
                  ]
                ],
                "id": 211,
                "chat_link": "[&BNMAAAA=]"
              },
              "212": {
                "objective": "Train with the militia.",
                "level": 8,
                "coord": [
                  43550.7,
                  30028
                ],
                "bounds": [
                  [
                    43479.8,
                    29915.3
                  ],
                  [
                    43603.3,
                    29933.2
                  ],
                  [
                    43640.2,
                    30014.6
                  ],
                  [
                    43746,
                    30128.8
                  ],
                  [
                    43499.8,
                    30162.8
                  ],
                  [
                    43387.4,
                    30128.8
                  ],
                  [
                    43360.4,
                    30042
                  ],
                  [
                    43419.2,
                    29945.7
                  ],
                  [
                    43479.8,
                    29915.3
                  ]
                ],
                "id": 212,
                "chat_link": "[&BNQAAAA=]"
              },
              "213": {
                "objective": "Assist the Seraph at Shaemoor Garrison.",
                "level": 6,
                "coord": [
                  44142.2,
                  28815.7
                ],
                "bounds": [
                  [
                    44062.1,
                    29146.3
                  ],
                  [
                    44020.4,
                    29043.2
                  ],
                  [
                    43963.5,
                    28712.4
                  ],
                  [
                    44019,
                    28662
                  ],
                  [
                    44127.3,
                    28619.6
                  ],
                  [
                    44168.4,
                    28641.2
                  ],
                  [
                    44386,
                    28974.2
                  ],
                  [
                    44398.4,
                    29048.7
                  ],
                  [
                    44426.8,
                    29109.2
                  ],
                  [
                    44511,
                    29105.2
                  ],
                  [
                    44492,
                    29241.1
                  ],
                  [
                    44349.4,
                    29246.3
                  ],
                  [
                    44222.7,
                    29278
                  ],
                  [
                    44189.4,
                    29169.6
                  ],
                  [
                    44062.1,
                    29146.3
                  ]
                ],
                "id": 213,
                "chat_link": "[&BNUAAAA=]"
              },
              "214": {
                "objective": "Help Lexi Price protect the trade route.",
                "level": 7,
                "coord": [
                  44087.8,
                  29386.4
                ],
                "bounds": [
                  [
                    43934.4,
                    29470.4
                  ],
                  [
                    43778.6,
                    29478.4
                  ],
                  [
                    43691.1,
                    29542.8
                  ],
                  [
                    43608.9,
                    29589.7
                  ],
                  [
                    43553.2,
                    29554.9
                  ],
                  [
                    43566.4,
                    29465.6
                  ],
                  [
                    43631.8,
                    29367.8
                  ],
                  [
                    43785,
                    29331.2
                  ],
                  [
                    43937.6,
                    29316.4
                  ],
                  [
                    44123.4,
                    29165.5
                  ],
                  [
                    44172.8,
                    29197.5
                  ],
                  [
                    44174.8,
                    29367
                  ],
                  [
                    44119.3,
                    29491.1
                  ],
                  [
                    43934.4,
                    29470.4
                  ]
                ],
                "id": 214,
                "chat_link": "[&BNYAAAA=]"
              },
              "215": {
                "objective": "Help Diah tend her farm.",
                "level": 2,
                "coord": [
                  43244.7,
                  28723.5
                ],
                "bounds": [
                  [
                    43145,
                    28878.6
                  ],
                  [
                    42959.4,
                    28672.9
                  ],
                  [
                    43009.9,
                    28526.1
                  ],
                  [
                    43170.3,
                    28466.8
                  ],
                  [
                    43311,
                    28608.7
                  ],
                  [
                    43327.8,
                    28869.7
                  ],
                  [
                    43145,
                    28878.6
                  ]
                ],
                "id": 215,
                "chat_link": "[&BNcAAAA=]"
              },
              "216": {
                "objective": "Help Fisher Travis maintain the river.",
                "level": 2,
                "coord": [
                  43236.7,
                  28382.2
                ],
                "bounds": [
                  [
                    43385.4,
                    28421.9
                  ],
                  [
                    43506.5,
                    28654
                  ],
                  [
                    43409.4,
                    28693.2
                  ],
                  [
                    43090.5,
                    28344.2
                  ],
                  [
                    43152,
                    28277.5
                  ],
                  [
                    43385.4,
                    28421.9
                  ]
                ],
                "id": 216,
                "chat_link": "[&BNgAAAA=]"
              },
              "218": {
                "objective": "Help Foreman Flannum improve dam safety.",
                "level": 3,
                "coord": [
                  43330.3,
                  28324.2
                ],
                "bounds": [
                  [
                    43380,
                    27908.9
                  ],
                  [
                    43371.9,
                    28406
                  ],
                  [
                    42974,
                    28169.5
                  ],
                  [
                    42982.7,
                    28093.4
                  ],
                  [
                    43380,
                    27908.9
                  ]
                ],
                "id": 218,
                "chat_link": "[&BNoAAAA=]"
              },
              "219": {
                "objective": "Assist Farmer Eda with her orchard.",
                "level": 4,
                "coord": [
                  42834.8,
                  28302.3
                ],
                "bounds": [
                  [
                    42782.8,
                    28386.9
                  ],
                  [
                    44585.1,
                    29312
                  ],
                  [
                    42782.8,
                    28386.9
                  ]
                ],
                "id": 219,
                "chat_link": "[&BNsAAAA=]"
              },
              "220": {
                "objective": "Help Cassie around the moa ranch.",
                "level": 5,
                "coord": [
                  42822.6,
                  28780
                ],
                "bounds": [
                  [
                    42731.9,
                    28993.1
                  ],
                  [
                    42731,
                    28796.3
                  ],
                  [
                    42811.4,
                    28619.5
                  ],
                  [
                    43257.6,
                    29051.6
                  ],
                  [
                    43308.2,
                    29306
                  ],
                  [
                    42812.5,
                    29298.4
                  ],
                  [
                    42731.9,
                    28993.1
                  ]
                ],
                "id": 220,
                "chat_link": "[&BNwAAAA=]"
              },
              "221": {
                "objective": "Protect Beetletun farmers from Tamini centaurs.",
                "level": 12,
                "coord": [
                  45750.9,
                  28964.1
                ],
                "bounds": [
                  [
                    45660,
                    28805.8
                  ],
                  [
                    46043.9,
                    28882.1
                  ],
                  [
                    46183.2,
                    29740.6
                  ],
                  [
                    45699.7,
                    29791
                  ],
                  [
                    45529.1,
                    29618.4
                  ],
                  [
                    45308.5,
                    29148.9
                  ],
                  [
                    45333.2,
                    29017.1
                  ],
                  [
                    45660,
                    28805.8
                  ]
                ],
                "id": 221,
                "chat_link": "[&BN0AAAA=]"
              },
              "222": {
                "objective": "Help the citizens of Beetletun maintain their town.",
                "level": 13,
                "coord": [
                  45852.1,
                  28430
                ],
                "bounds": [
                  [
                    46114.5,
                    28311.2
                  ],
                  [
                    46149.7,
                    28375.1
                  ],
                  [
                    46062.8,
                    28571.4
                  ],
                  [
                    45997.9,
                    28581.8
                  ],
                  [
                    45976,
                    28534.2
                  ],
                  [
                    45940.7,
                    28497.1
                  ],
                  [
                    45897.6,
                    28491.4
                  ],
                  [
                    45820.4,
                    28510.3
                  ],
                  [
                    45763.5,
                    28509.3
                  ],
                  [
                    45731.8,
                    28469
                  ],
                  [
                    45704.1,
                    28374.1
                  ],
                  [
                    45706,
                    28224.8
                  ],
                  [
                    46114.5,
                    28311.2
                  ]
                ],
                "id": 222,
                "chat_link": "[&BN4AAAA=]"
              },
              "223": {
                "objective": "Unite the ettins.",
                "level": 14,
                "coord": [
                  45662.7,
                  30062.8
                ],
                "bounds": [
                  [
                    45808,
                    29957.3
                  ],
                  [
                    45900.4,
                    29947.6
                  ],
                  [
                    46054.5,
                    30055.8
                  ],
                  [
                    46134.5,
                    30381.6
                  ],
                  [
                    45728.9,
                    30443.4
                  ],
                  [
                    45507.8,
                    30400.8
                  ],
                  [
                    45469.5,
                    30271.3
                  ],
                  [
                    45532.4,
                    30131.6
                  ],
                  [
                    45667.4,
                    29979
                  ],
                  [
                    45808,
                    29957.3
                  ]
                ],
                "id": 223,
                "chat_link": "[&BN8AAAA=]"
              },
              "224": {
                "objective": "Help Historian Garrod investigate Godslost Swamp.",
                "level": 15,
                "coord": [
                  44988.9,
                  29668.7
                ],
                "bounds": [
                  [
                    45020.6,
                    29538.9
                  ],
                  [
                    44920.4,
                    29539.1
                  ],
                  [
                    44850.9,
                    29547.9
                  ],
                  [
                    44789,
                    29565.7
                  ],
                  [
                    44769.3,
                    29620.7
                  ],
                  [
                    44744.5,
                    29660.6
                  ],
                  [
                    44688.9,
                    29682
                  ],
                  [
                    44631.9,
                    29701.9
                  ],
                  [
                    44622.1,
                    29766.2
                  ],
                  [
                    44635.8,
                    29801.7
                  ],
                  [
                    44659.4,
                    29844.5
                  ],
                  [
                    44635,
                    29883.3
                  ],
                  [
                    44612.5,
                    29927.1
                  ],
                  [
                    44610.6,
                    29958.8
                  ],
                  [
                    44602.6,
                    30005.4
                  ],
                  [
                    44617.9,
                    30044.5
                  ],
                  [
                    44638,
                    30058.6
                  ],
                  [
                    44671.7,
                    30079.3
                  ],
                  [
                    44686.1,
                    30129.6
                  ],
                  [
                    44724.9,
                    30162.5
                  ],
                  [
                    44772.7,
                    30226.7
                  ],
                  [
                    44817.6,
                    30272
                  ],
                  [
                    44850.3,
                    30277.9
                  ],
                  [
                    44926.2,
                    30282.2
                  ],
                  [
                    45006.2,
                    30272.2
                  ],
                  [
                    45070.3,
                    30278.5
                  ],
                  [
                    45104.1,
                    30301.4
                  ],
                  [
                    45147.1,
                    30308.4
                  ],
                  [
                    45185.2,
                    30320.6
                  ],
                  [
                    45224,
                    30324.8
                  ],
                  [
                    45289.8,
                    30319.1
                  ],
                  [
                    45338.8,
                    30291.8
                  ],
                  [
                    45351.4,
                    30197.7
                  ],
                  [
                    45343.7,
                    30133
                  ],
                  [
                    45383.4,
                    30088
                  ],
                  [
                    45413.9,
                    30060.6
                  ],
                  [
                    45439.4,
                    30000.4
                  ],
                  [
                    45447.6,
                    29938.1
                  ],
                  [
                    45446.6,
                    29901.5
                  ],
                  [
                    45415.1,
                    29888.6
                  ],
                  [
                    45383.4,
                    29889.4
                  ],
                  [
                    45358.2,
                    29859.2
                  ],
                  [
                    45357,
                    29835.5
                  ],
                  [
                    45355.9,
                    29794
                  ],
                  [
                    45338.5,
                    29759
                  ],
                  [
                    45320.6,
                    29725.1
                  ],
                  [
                    45282.5,
                    29707.7
                  ],
                  [
                    45219.9,
                    29669.5
                  ],
                  [
                    45167.6,
                    29639.6
                  ],
                  [
                    45128.5,
                    29608.6
                  ],
                  [
                    45066.2,
                    29567.7
                  ],
                  [
                    45020.6,
                    29538.9
                  ]
                ],
                "id": 224,
                "chat_link": "[&BOAAAAA=]"
              },
              "225": {
                "objective": "Keep the monastery operational.",
                "level": 11,
                "coord": [
                  45225.9,
                  29229.5
                ],
                "bounds": [
                  [
                    44978.1,
                    29148.7
                  ],
                  [
                    45112.8,
                    29076.8
                  ],
                  [
                    45219.6,
                    29082.3
                  ],
                  [
                    45323.5,
                    29178.4
                  ],
                  [
                    45387.7,
                    29250.2
                  ],
                  [
                    45422.8,
                    29357.7
                  ],
                  [
                    45411.5,
                    29507.4
                  ],
                  [
                    45242,
                    29508.7
                  ],
                  [
                    45023.6,
                    29486.6
                  ],
                  [
                    45006.3,
                    29303.2
                  ],
                  [
                    44958.8,
                    29244
                  ],
                  [
                    44978.1,
                    29148.7
                  ]
                ],
                "id": 225,
                "chat_link": "[&BOEAAAA=]"
              },
              "226": {
                "objective": "Assist Laborer Cardy and Ojon's lumbermill.",
                "level": 8,
                "coord": [
                  44598.1,
                  28755.7
                ],
                "bounds": [
                  [
                    44693.8,
                    28536
                  ],
                  [
                    44409.3,
                    28677.6
                  ],
                  [
                    44384.8,
                    28883.2
                  ],
                  [
                    44392.2,
                    28973.3
                  ],
                  [
                    44408.4,
                    29050.9
                  ],
                  [
                    44436.3,
                    29103.7
                  ],
                  [
                    44719.3,
                    29092.7
                  ],
                  [
                    44756.2,
                    28970.8
                  ],
                  [
                    44949.2,
                    28852.3
                  ],
                  [
                    44982.8,
                    28754.9
                  ],
                  [
                    44968,
                    28533.9
                  ],
                  [
                    44922.8,
                    28427.6
                  ],
                  [
                    44790.6,
                    28443.9
                  ],
                  [
                    44693.8,
                    28536
                  ]
                ],
                "id": 226,
                "chat_link": "[&BOIAAAA=]"
              },
              "227": {
                "objective": "Assist Hunter Block and the hunting lodge.",
                "level": 9,
                "coord": [
                  45266.7,
                  28533.4
                ],
                "bounds": [
                  [
                    45356.6,
                    28840.7
                  ],
                  [
                    45253.8,
                    28910.4
                  ],
                  [
                    45155.4,
                    28940
                  ],
                  [
                    45099.8,
                    28889.2
                  ],
                  [
                    45088,
                    28801.7
                  ],
                  [
                    45014.8,
                    28535.6
                  ],
                  [
                    45097.4,
                    28424.1
                  ],
                  [
                    45229.3,
                    28385.9
                  ],
                  [
                    45399.8,
                    28389.7
                  ],
                  [
                    45411.4,
                    28492.4
                  ],
                  [
                    45397.2,
                    28604.1
                  ],
                  [
                    45421.1,
                    28646.9
                  ],
                  [
                    45553.2,
                    28723.2
                  ],
                  [
                    45547.6,
                    28750.9
                  ],
                  [
                    45527.3,
                    28759.3
                  ],
                  [
                    45502.3,
                    28766.4
                  ],
                  [
                    45356.6,
                    28840.7
                  ]
                ],
                "id": 227,
                "chat_link": "[&BOMAAAA=]"
              },
              "228": {
                "objective": "Assist Fisherman Will and the fishermen of Beetletun.",
                "level": 10,
                "coord": [
                  45600.2,
                  28218.9
                ],
                "bounds": [
                  [
                    45654.6,
                    28166.4
                  ],
                  [
                    45666.6,
                    28219.3
                  ],
                  [
                    45709,
                    28407.8
                  ],
                  [
                    45735.4,
                    28591.1
                  ],
                  [
                    45659.2,
                    28617.6
                  ],
                  [
                    45608.2,
                    28590.2
                  ],
                  [
                    45551.4,
                    28562.1
                  ],
                  [
                    45511.3,
                    28511.5
                  ],
                  [
                    45579.2,
                    28442.4
                  ],
                  [
                    45594.9,
                    28367.7
                  ],
                  [
                    45545.2,
                    28325.9
                  ],
                  [
                    45436.2,
                    28331.5
                  ],
                  [
                    45410,
                    28220
                  ],
                  [
                    45654.6,
                    28166.4
                  ]
                ],
                "id": 228,
                "chat_link": "[&BOQAAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  45135.5,
                  29863.7
                ],
                "id": "0-7"
              },
              {
                "coord": [
                  42717.7,
                  29510.3
                ],
                "id": "0-8"
              },
              {
                "coord": [
                  45877.8,
                  30152.6
                ],
                "id": "0-9"
              },
              {
                "coord": [
                  43193.8,
                  29475
                ],
                "id": "0-65"
              },
              {
                "coord": [
                  44471.7,
                  29021.8
                ],
                "id": "0-6"
              },
              {
                "coord": [
                  44180.7,
                  29045.5
                ],
                "id": "0-42"
              },
              {
                "coord": [
                  46085.9,
                  28351.8
                ],
                "id": "0-140"
              }
            ],
            "sectors": {
              "47": {
                "name": "Bandithaunt Caverns",
                "level": 5,
                "coord": [
                  43020.2,
                  29173.9
                ],
                "bounds": [
                  [
                    42957.1,
                    29443.5
                  ],
                  [
                    43079.7,
                    29427
                  ],
                  [
                    43377.9,
                    29320.1
                  ],
                  [
                    43278.3,
                    29053.8
                  ],
                  [
                    43200.8,
                    29008.8
                  ],
                  [
                    42865.5,
                    28902.1
                  ],
                  [
                    42761.5,
                    28899.7
                  ],
                  [
                    42776.3,
                    29175
                  ],
                  [
                    42884.8,
                    29334.9
                  ],
                  [
                    42957.1,
                    29443.5
                  ]
                ],
                "id": 47,
                "chat_link": "[&BC8AAAA=]"
              },
              "48": {
                "name": "Shire of Beetletun",
                "level": 13,
                "coord": [
                  45900.9,
                  28224.5
                ],
                "bounds": [
                  [
                    45593.8,
                    28056.8
                  ],
                  [
                    45436.4,
                    28345.2
                  ],
                  [
                    45539.2,
                    28458.9
                  ],
                  [
                    45621.4,
                    28644.8
                  ],
                  [
                    46007.9,
                    28578.7
                  ],
                  [
                    46239.8,
                    28459.7
                  ],
                  [
                    46308.9,
                    28317.9
                  ],
                  [
                    46318,
                    28150.4
                  ],
                  [
                    46232.1,
                    27968.2
                  ],
                  [
                    46029.3,
                    27859.8
                  ],
                  [
                    45836.6,
                    27886.4
                  ],
                  [
                    45647.6,
                    27967.6
                  ],
                  [
                    45593.8,
                    28056.8
                  ]
                ],
                "id": 48,
                "chat_link": "[&BDAAAAA=]"
              },
              "49": {
                "name": "Beetletun Farms",
                "level": 11,
                "coord": [
                  45975.8,
                  28844.7
                ],
                "bounds": [
                  [
                    45615.8,
                    28647
                  ],
                  [
                    45558.9,
                    28795.6
                  ],
                  [
                    45583.8,
                    28936.3
                  ],
                  [
                    45764.1,
                    29074.9
                  ],
                  [
                    46011.5,
                    29059.5
                  ],
                  [
                    46229.9,
                    29158.8
                  ],
                  [
                    46241.7,
                    29050.6
                  ],
                  [
                    46265.6,
                    28862.7
                  ],
                  [
                    46222.2,
                    28665.1
                  ],
                  [
                    46233.4,
                    28463.4
                  ],
                  [
                    46006.6,
                    28577.7
                  ],
                  [
                    45615.8,
                    28647
                  ]
                ],
                "id": 49,
                "chat_link": "[&BDEAAAA=]"
              },
              "50": {
                "name": "Altar's Windings",
                "level": 10,
                "coord": [
                  42843.1,
                  29734.9
                ],
                "bounds": [
                  [
                    42686.4,
                    29603.8
                  ],
                  [
                    42694.8,
                    29909.2
                  ],
                  [
                    42735.1,
                    30041.3
                  ],
                  [
                    42842.6,
                    30017.8
                  ],
                  [
                    42932,
                    29853.3
                  ],
                  [
                    42944.6,
                    29583.7
                  ],
                  [
                    43019.6,
                    29542.1
                  ],
                  [
                    42889.3,
                    29327.8
                  ],
                  [
                    42686.4,
                    29603.8
                  ]
                ],
                "id": 50,
                "chat_link": "[&BDIAAAA=]"
              },
              "51": {
                "name": "Altar Brook Vale",
                "level": 8,
                "coord": [
                  43343,
                  29575.8
                ],
                "bounds": [
                  [
                    43511.5,
                    29282.8
                  ],
                  [
                    43378.5,
                    29321.7
                  ],
                  [
                    43083.8,
                    29422.7
                  ],
                  [
                    42952.3,
                    29440.6
                  ],
                  [
                    43011,
                    29539.3
                  ],
                  [
                    42938.6,
                    29581.7
                  ],
                  [
                    42924.8,
                    29855.1
                  ],
                  [
                    43183.9,
                    29947.5
                  ],
                  [
                    43287.5,
                    30031.7
                  ],
                  [
                    43459.5,
                    29914.6
                  ],
                  [
                    43540.1,
                    29908
                  ],
                  [
                    43978.3,
                    29505.5
                  ],
                  [
                    43881,
                    29177.7
                  ],
                  [
                    43671.5,
                    29131.8
                  ],
                  [
                    43511.5,
                    29282.8
                  ]
                ],
                "id": 51,
                "chat_link": "[&BDMAAAA=]"
              },
              "52": {
                "name": "Township of Claypool",
                "level": 8,
                "coord": [
                  43436,
                  30257.7
                ],
                "bounds": [
                  [
                    43120.9,
                    30351.6
                  ],
                  [
                    43203.5,
                    30484.5
                  ],
                  [
                    43292.5,
                    30497.2
                  ],
                  [
                    43342.4,
                    30451.8
                  ],
                  [
                    43563.6,
                    30478.5
                  ],
                  [
                    43741.8,
                    30433.4
                  ],
                  [
                    43654.3,
                    30259.8
                  ],
                  [
                    43747.4,
                    30116.7
                  ],
                  [
                    43540,
                    29909
                  ],
                  [
                    43468.2,
                    29911.2
                  ],
                  [
                    43287.5,
                    30031.1
                  ],
                  [
                    43270.4,
                    30167.8
                  ],
                  [
                    43120.9,
                    30351.6
                  ]
                ],
                "id": 52,
                "chat_link": "[&BDQAAAA=]"
              },
              "53": {
                "name": "Clayent Falls",
                "level": 10,
                "coord": [
                  43012.6,
                  30212.4
                ],
                "bounds": [
                  [
                    43128.4,
                    30351
                  ],
                  [
                    43170,
                    30424.5
                  ],
                  [
                    43204,
                    30480.5
                  ],
                  [
                    43044.4,
                    30479.8
                  ],
                  [
                    42936.8,
                    30446.1
                  ],
                  [
                    42776.6,
                    30356.4
                  ],
                  [
                    42675.4,
                    30194.8
                  ],
                  [
                    42731.3,
                    30033.4
                  ],
                  [
                    42837.7,
                    30009.1
                  ],
                  [
                    42919,
                    29842.5
                  ],
                  [
                    43183.3,
                    29946.1
                  ],
                  [
                    43286.5,
                    30030.3
                  ],
                  [
                    43270.7,
                    30167.2
                  ],
                  [
                    43128.4,
                    30351
                  ]
                ],
                "id": 53,
                "chat_link": "[&BDUAAAA=]"
              },
              "54": {
                "name": "Salma's Heath",
                "level": 13,
                "coord": [
                  45911.6,
                  29417.3
                ],
                "bounds": [
                  [
                    46231.8,
                    29629.2
                  ],
                  [
                    46193.6,
                    29489.5
                  ],
                  [
                    46235.6,
                    29314.5
                  ],
                  [
                    46227.1,
                    29158.6
                  ],
                  [
                    46010.2,
                    29061.8
                  ],
                  [
                    45763.2,
                    29070.5
                  ],
                  [
                    45719.7,
                    29033.6
                  ],
                  [
                    45657.4,
                    29098
                  ],
                  [
                    45618.4,
                    29186.8
                  ],
                  [
                    45649.5,
                    29311.3
                  ],
                  [
                    45632.1,
                    29471.2
                  ],
                  [
                    45797.7,
                    29496.3
                  ],
                  [
                    45875.5,
                    29562.5
                  ],
                  [
                    45878.1,
                    29699.7
                  ],
                  [
                    45812.5,
                    29752.9
                  ],
                  [
                    46042.1,
                    29868.9
                  ],
                  [
                    46153.5,
                    29888.2
                  ],
                  [
                    46231.8,
                    29629.2
                  ]
                ],
                "id": 54,
                "chat_link": "[&BDYAAAA=]"
              },
              "55": {
                "name": "Eastern Divinity Dam",
                "level": 10,
                "coord": [
                  45067.9,
                  28157.7
                ],
                "bounds": [
                  [
                    44727.3,
                    28084.5
                  ],
                  [
                    44705.2,
                    28181.3
                  ],
                  [
                    44786.6,
                    28269
                  ],
                  [
                    44924.8,
                    28250.6
                  ],
                  [
                    45435.5,
                    28345.3
                  ],
                  [
                    45586.4,
                    28061.7
                  ],
                  [
                    45354.6,
                    28144.3
                  ],
                  [
                    45222.5,
                    28089.6
                  ],
                  [
                    44868,
                    27992.7
                  ],
                  [
                    44727.3,
                    28084.5
                  ]
                ],
                "id": 55,
                "chat_link": "[&BDcAAAA=]"
              },
              "56": {
                "name": "Western Divinity Dam",
                "level": 3,
                "coord": [
                  43054.6,
                  28209.7
                ],
                "bounds": [
                  [
                    42656,
                    28235.7
                  ],
                  [
                    42754.6,
                    28065.4
                  ],
                  [
                    43022.6,
                    28044.8
                  ],
                  [
                    43302,
                    28141.4
                  ],
                  [
                    43366.7,
                    28329.8
                  ],
                  [
                    43215.1,
                    28379.9
                  ],
                  [
                    43065.6,
                    28271.3
                  ],
                  [
                    42656,
                    28235.7
                  ]
                ],
                "id": 56,
                "chat_link": "[&BDgAAAA=]"
              },
              "57": {
                "name": "Taminn Foothills",
                "level": 14,
                "coord": [
                  45776.7,
                  30154.3
                ],
                "bounds": [
                  [
                    45898.1,
                    29962.8
                  ],
                  [
                    46044,
                    29866.1
                  ],
                  [
                    45812.8,
                    29753.9
                  ],
                  [
                    45709.1,
                    29848.2
                  ],
                  [
                    45572.9,
                    30057.8
                  ],
                  [
                    45496,
                    30401.4
                  ],
                  [
                    45518.3,
                    30448.3
                  ],
                  [
                    45727.3,
                    30465.3
                  ],
                  [
                    45885,
                    30503.1
                  ],
                  [
                    45934.8,
                    30315
                  ],
                  [
                    45945.6,
                    30075.8
                  ],
                  [
                    45898.1,
                    29962.8
                  ]
                ],
                "id": 57,
                "chat_link": "[&BDkAAAA=]"
              },
              "58": {
                "name": "Queen's Forest",
                "level": 9,
                "coord": [
                  44888.3,
                  28803.8
                ],
                "bounds": [
                  [
                    45537.2,
                    28456.8
                  ],
                  [
                    45616.3,
                    28646.4
                  ],
                  [
                    45558.8,
                    28795.3
                  ],
                  [
                    45377.4,
                    28740.7
                  ],
                  [
                    45156,
                    28886
                  ],
                  [
                    45089.4,
                    29015.5
                  ],
                  [
                    44913.7,
                    29094.3
                  ],
                  [
                    44942.6,
                    29363.6
                  ],
                  [
                    44595.2,
                    29328.7
                  ],
                  [
                    44618.8,
                    29076.1
                  ],
                  [
                    44613.7,
                    29041.4
                  ],
                  [
                    44617.6,
                    28985.1
                  ],
                  [
                    44556.6,
                    28882.7
                  ],
                  [
                    44522.9,
                    28854.1
                  ],
                  [
                    44481.3,
                    28874
                  ],
                  [
                    44468.2,
                    28856.8
                  ],
                  [
                    44415.2,
                    28682.8
                  ],
                  [
                    44603.4,
                    28684.4
                  ],
                  [
                    44711,
                    28553.7
                  ],
                  [
                    44787,
                    28268.3
                  ],
                  [
                    44925.1,
                    28250.5
                  ],
                  [
                    45435.8,
                    28346.3
                  ],
                  [
                    45537.2,
                    28456.8
                  ]
                ],
                "id": 58,
                "chat_link": "[&BDoAAAA=]"
              },
              "59": {
                "name": "The Heartwoods",
                "level": 9,
                "coord": [
                  44089.1,
                  29946.2
                ],
                "bounds": [
                  [
                    43970,
                    29505.1
                  ],
                  [
                    44209.7,
                    29468.9
                  ],
                  [
                    44252.4,
                    29502.5
                  ],
                  [
                    44312.8,
                    29522
                  ],
                  [
                    44356.2,
                    29488.7
                  ],
                  [
                    44462.2,
                    29551.9
                  ],
                  [
                    44418.8,
                    29742.9
                  ],
                  [
                    44313.5,
                    29825
                  ],
                  [
                    44318.8,
                    30420.4
                  ],
                  [
                    44245.5,
                    30461.1
                  ],
                  [
                    44054.7,
                    30473.2
                  ],
                  [
                    43828.4,
                    30458.5
                  ],
                  [
                    43737.5,
                    30431.6
                  ],
                  [
                    43656.9,
                    30262.8
                  ],
                  [
                    43747.1,
                    30116.4
                  ],
                  [
                    43541.4,
                    29908
                  ],
                  [
                    43970,
                    29505.1
                  ]
                ],
                "id": 59,
                "chat_link": "[&BDsAAAA=]"
              },
              "60": {
                "name": "Krytan Freeholds",
                "level": 12,
                "coord": [
                  45393.6,
                  29167.1
                ],
                "bounds": [
                  [
                    45720.3,
                    29039.2
                  ],
                  [
                    45659.8,
                    29099.9
                  ],
                  [
                    45623.7,
                    29184.4
                  ],
                  [
                    45652.1,
                    29312.3
                  ],
                  [
                    45631.5,
                    29470.6
                  ],
                  [
                    45493.1,
                    29559.8
                  ],
                  [
                    45312.5,
                    29569.5
                  ],
                  [
                    45191.1,
                    29436.7
                  ],
                  [
                    44940.7,
                    29362.8
                  ],
                  [
                    44914.9,
                    29094.9
                  ],
                  [
                    45089.7,
                    29015.4
                  ],
                  [
                    45156.2,
                    28886.6
                  ],
                  [
                    45377.3,
                    28741
                  ],
                  [
                    45558.2,
                    28796
                  ],
                  [
                    45583.1,
                    28936.8
                  ],
                  [
                    45720.3,
                    29039.2
                  ]
                ],
                "id": 60,
                "chat_link": "[&BDwAAAA=]"
              },
              "61": {
                "name": "Lake Delavan",
                "level": 7,
                "coord": [
                  44465.6,
                  28523.5
                ],
                "bounds": [
                  [
                    44336.5,
                    28406.6
                  ],
                  [
                    44664.4,
                    28127.7
                  ],
                  [
                    44787.3,
                    28268.9
                  ],
                  [
                    44710.4,
                    28553
                  ],
                  [
                    44602.5,
                    28682.2
                  ],
                  [
                    44415,
                    28683.2
                  ],
                  [
                    44246.4,
                    28827
                  ],
                  [
                    44151.8,
                    28596.6
                  ],
                  [
                    44276.8,
                    28566.4
                  ],
                  [
                    44336.5,
                    28406.6
                  ]
                ],
                "id": 61,
                "chat_link": "[&BD0AAAA=]"
              },
              "62": {
                "name": "Orlaf Escarpments",
                "level": 14,
                "coord": [
                  45608.4,
                  29670.9
                ],
                "bounds": [
                  [
                    45493.3,
                    29559.8
                  ],
                  [
                    45312.4,
                    29569.8
                  ],
                  [
                    45335.5,
                    29671.3
                  ],
                  [
                    45480.1,
                    29774.5
                  ],
                  [
                    45572.8,
                    30057.8
                  ],
                  [
                    45708.9,
                    29847.9
                  ],
                  [
                    45877.2,
                    29698.8
                  ],
                  [
                    45875.4,
                    29562.5
                  ],
                  [
                    45797.6,
                    29496.4
                  ],
                  [
                    45631.3,
                    29470.5
                  ],
                  [
                    45493.3,
                    29559.8
                  ]
                ],
                "id": 62,
                "chat_link": "[&BD4AAAA=]"
              },
              "63": {
                "name": "Scaver Plateau",
                "level": 7,
                "coord": [
                  44326.8,
                  29115.1
                ],
                "bounds": [
                  [
                    44061.6,
                    28921.1
                  ],
                  [
                    44191.6,
                    28886.1
                  ],
                  [
                    44247.9,
                    28825.7
                  ],
                  [
                    44416.5,
                    28681.5
                  ],
                  [
                    44470,
                    28855.8
                  ],
                  [
                    44482.7,
                    28875.5
                  ],
                  [
                    44472.4,
                    28881.2
                  ],
                  [
                    44464,
                    28935
                  ],
                  [
                    44552,
                    29051.3
                  ],
                  [
                    44615.2,
                    29040.7
                  ],
                  [
                    44619.8,
                    29074.8
                  ],
                  [
                    44597.5,
                    29327.5
                  ],
                  [
                    44391.9,
                    29420.9
                  ],
                  [
                    44357.2,
                    29492
                  ],
                  [
                    44314,
                    29522.9
                  ],
                  [
                    44251.6,
                    29503.6
                  ],
                  [
                    44209,
                    29471.9
                  ],
                  [
                    43966.6,
                    29503.7
                  ],
                  [
                    43873.1,
                    29178.4
                  ],
                  [
                    43980.8,
                    28853.1
                  ],
                  [
                    44061.6,
                    28921.1
                  ]
                ],
                "id": 63,
                "chat_link": "[&BD8AAAA=]"
              },
              "64": {
                "name": "Phinney Ridge",
                "level": 11,
                "coord": [
                  44533.3,
                  29783.8
                ],
                "bounds": [
                  [
                    44417.5,
                    29741.3
                  ],
                  [
                    44312.9,
                    29824.4
                  ],
                  [
                    44316.1,
                    30425.6
                  ],
                  [
                    44420.4,
                    30422.9
                  ],
                  [
                    44527.3,
                    30352.8
                  ],
                  [
                    44522.6,
                    29964.1
                  ],
                  [
                    44621.5,
                    29877.1
                  ],
                  [
                    44618.1,
                    29692.3
                  ],
                  [
                    44967.1,
                    29518.8
                  ],
                  [
                    44941.5,
                    29362.1
                  ],
                  [
                    44594.8,
                    29327.7
                  ],
                  [
                    44390.3,
                    29419.3
                  ],
                  [
                    44354,
                    29492.9
                  ],
                  [
                    44462.7,
                    29551.5
                  ],
                  [
                    44417.5,
                    29741.3
                  ]
                ],
                "id": 64,
                "chat_link": "[&BEAAAAA=]"
              },
              "65": {
                "name": "Village of Shaemoor",
                "level": 4,
                "coord": [
                  43851.1,
                  28584.1
                ],
                "bounds": [
                  [
                    43670.1,
                    29135.4
                  ],
                  [
                    43655.4,
                    28861
                  ],
                  [
                    43582.2,
                    28798.4
                  ],
                  [
                    43572.7,
                    28690.6
                  ],
                  [
                    43344.9,
                    28504.9
                  ],
                  [
                    43349.9,
                    28334.1
                  ],
                  [
                    43544.3,
                    27970.2
                  ],
                  [
                    44210,
                    27964.2
                  ],
                  [
                    44215.7,
                    28204.6
                  ],
                  [
                    44337.6,
                    28406.8
                  ],
                  [
                    44276.1,
                    28565
                  ],
                  [
                    44149.8,
                    28593.5
                  ],
                  [
                    43992.9,
                    28684.6
                  ],
                  [
                    43984,
                    28862
                  ],
                  [
                    43880.9,
                    29185.6
                  ],
                  [
                    43670.1,
                    29135.4
                  ]
                ],
                "id": 65,
                "chat_link": "[&BEEAAAA=]"
              },
              "66": {
                "name": "Shaemoor Fields",
                "level": 5,
                "coord": [
                  43196.4,
                  28761.2
                ],
                "bounds": [
                  [
                    42763.3,
                    28245.6
                  ],
                  [
                    42746,
                    28543.8
                  ],
                  [
                    42565.5,
                    28700.1
                  ],
                  [
                    42572.8,
                    28911.4
                  ],
                  [
                    42871.2,
                    28900.9
                  ],
                  [
                    43196.8,
                    29010.1
                  ],
                  [
                    43279.6,
                    29054.3
                  ],
                  [
                    43378.1,
                    29320.1
                  ],
                  [
                    43510.4,
                    29281.5
                  ],
                  [
                    43669.2,
                    29132.7
                  ],
                  [
                    43654.7,
                    28861.3
                  ],
                  [
                    43583.1,
                    28798.6
                  ],
                  [
                    43572.2,
                    28690.8
                  ],
                  [
                    43345,
                    28505.2
                  ],
                  [
                    43348.7,
                    28335
                  ],
                  [
                    43216.2,
                    28378.5
                  ],
                  [
                    43067,
                    28270.2
                  ],
                  [
                    42763.3,
                    28245.6
                  ]
                ],
                "id": 66,
                "chat_link": "[&BEIAAAA=]"
              },
              "67": {
                "name": "Shaemoor Garrison",
                "level": 6,
                "coord": [
                  44103.8,
                  28796.6
                ],
                "bounds": [
                  [
                    43984.7,
                    28862.6
                  ],
                  [
                    43993,
                    28685.3
                  ],
                  [
                    44150.1,
                    28594.6
                  ],
                  [
                    44245.8,
                    28826.7
                  ],
                  [
                    44189.6,
                    28887.2
                  ],
                  [
                    44059.6,
                    28923
                  ],
                  [
                    43984.7,
                    28862.6
                  ]
                ],
                "id": 67,
                "chat_link": "[&BEMAAAA=]"
              },
              "68": {
                "name": "Godslost Swamp",
                "level": 15,
                "coord": [
                  45060.6,
                  30002.2
                ],
                "bounds": [
                  [
                    45484.9,
                    29765.9
                  ],
                  [
                    45578.3,
                    30060.3
                  ],
                  [
                    45500.1,
                    30398.2
                  ],
                  [
                    45522.8,
                    30453
                  ],
                  [
                    45372.4,
                    30491.9
                  ],
                  [
                    45051.5,
                    30496.8
                  ],
                  [
                    44922.8,
                    30487.9
                  ],
                  [
                    44569.7,
                    30431.8
                  ],
                  [
                    44523.6,
                    30358.3
                  ],
                  [
                    44518.8,
                    29970
                  ],
                  [
                    44617.9,
                    29883.3
                  ],
                  [
                    44614.2,
                    29698.4
                  ],
                  [
                    44963.1,
                    29524.8
                  ],
                  [
                    44935.8,
                    29353.4
                  ],
                  [
                    45195.6,
                    29430.9
                  ],
                  [
                    45317,
                    29566.5
                  ],
                  [
                    45341.7,
                    29666.6
                  ],
                  [
                    45484.9,
                    29765.9
                  ]
                ],
                "id": 68,
                "chat_link": "[&BEQAAAA=]"
              },
              "566": {
                "name": "Pinion Trail",
                "level": 10,
                "coord": [
                  42710.4,
                  29223.4
                ],
                "bounds": [
                  [
                    42776.6,
                    29180.7
                  ],
                  [
                    42765.3,
                    28899.2
                  ],
                  [
                    42576.7,
                    28904
                  ],
                  [
                    42555.8,
                    29437.6
                  ],
                  [
                    42700.8,
                    29588.8
                  ],
                  [
                    42887.4,
                    29330
                  ],
                  [
                    42776.6,
                    29180.7
                  ]
                ],
                "id": 566,
                "chat_link": "[&BDYCAAA=]"
              },
              "729": {
                "name": "Windloss Delves",
                "level": 7,
                "coord": [
                  44543,
                  28946.8
                ],
                "bounds": [
                  [
                    44614,
                    29043.3
                  ],
                  [
                    44551.8,
                    29052.7
                  ],
                  [
                    44462.8,
                    28935.3
                  ],
                  [
                    44471.3,
                    28880
                  ],
                  [
                    44523.7,
                    28850.2
                  ],
                  [
                    44558.6,
                    28881.5
                  ],
                  [
                    44618.6,
                    28984.6
                  ],
                  [
                    44614,
                    29043.3
                  ]
                ],
                "id": 729,
                "chat_link": "[&BNkCAAA=]"
              },
              "757": {
                "name": "Beggar's Burrow",
                "level": 10,
                "coord": [
                  44425.6,
                  28205.8
                ],
                "bounds": [
                  [
                    44339.3,
                    28416.3
                  ],
                  [
                    44279.9,
                    28316.8
                  ],
                  [
                    44333.6,
                    28101.4
                  ],
                  [
                    44468.4,
                    28042.6
                  ],
                  [
                    44574.3,
                    28133.2
                  ],
                  [
                    44558.2,
                    28224.6
                  ],
                  [
                    44339.3,
                    28416.3
                  ]
                ],
                "id": 757,
                "chat_link": "[&BPUCAAA=]"
              },
              "1018": {
                "name": "Demongrub Pits",
                "level": 17,
                "coord": [
                  46072,
                  30173.6
                ],
                "bounds": [
                  [
                    46153.9,
                    29884.6
                  ],
                  [
                    46044,
                    29866.1
                  ],
                  [
                    45896.2,
                    29962.7
                  ],
                  [
                    45942.8,
                    30076.3
                  ],
                  [
                    45930.8,
                    30317.9
                  ],
                  [
                    45885,
                    30503.1
                  ],
                  [
                    46060.8,
                    30505.3
                  ],
                  [
                    46195.8,
                    30435.6
                  ],
                  [
                    46235.7,
                    30306.8
                  ],
                  [
                    46244.6,
                    30121.7
                  ],
                  [
                    46202,
                    29930
                  ],
                  [
                    46153.9,
                    29884.6
                  ]
                ],
                "id": 1018,
                "chat_link": "[&BPoDAAA=]"
              }
            },
            "adventures": [],
            "id": 15,
            "mastery_points": []
          },
          "17": {
            "name": "Harathi Hinterlands",
            "min_level": 35,
            "max_level": 45,
            "default_floor": 1,
            "label_coord": [
              47808,
              27264
            ],
            "map_rect": [
              [
                -36864,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                46208,
                25856
              ],
              [
                49408,
                28672
              ]
            ],
            "points_of_interest": {
              "148": {
                "name": "Restricted Zone XRB",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47567.2,
                  27348.8
                ],
                "id": 148,
                "chat_link": "[&BJQAAAA=]"
              },
              "149": {
                "name": "Forward Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46913.7,
                  27000.2
                ],
                "id": 149,
                "chat_link": "[&BJUAAAA=]"
              },
              "150": {
                "name": "Northpasture Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48211.3,
                  26155.5
                ],
                "id": 150,
                "chat_link": "[&BJYAAAA=]"
              },
              "151": {
                "name": "Southforge Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48325.7,
                  26607
                ],
                "id": 151,
                "chat_link": "[&BJcAAAA=]"
              },
              "152": {
                "name": "War King's Greatcamp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49246.8,
                  26333
                ],
                "id": 152,
                "chat_link": "[&BJgAAAA=]"
              },
              "153": {
                "name": "Kingsgate Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48693.8,
                  26346.5
                ],
                "id": 153,
                "chat_link": "[&BJkAAAA=]"
              },
              "154": {
                "name": "Watchlin Armory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48255.4,
                  27722.4
                ],
                "id": 154,
                "chat_link": "[&BJoAAAA=]"
              },
              "155": {
                "name": "Shorebluff Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48259.9,
                  28195.9
                ],
                "id": 155,
                "chat_link": "[&BJsAAAA=]"
              },
              "156": {
                "name": "Overwatch Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48023.2,
                  27855.3
                ],
                "id": 156,
                "chat_link": "[&BJwAAAA=]"
              },
              "157": {
                "name": "Confinement Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47579.6,
                  27804.3
                ],
                "id": 157,
                "chat_link": "[&BJ0AAAA=]"
              },
              "158": {
                "name": "Blackhold Mine Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48529.6,
                  26844.3
                ],
                "id": 158,
                "chat_link": "[&BJ4AAAA=]"
              },
              "159": {
                "name": "Drakken's Den",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47270.5,
                  26966.1
                ],
                "id": 159,
                "chat_link": "[&BJ8AAAA=]"
              },
              "160": {
                "name": "Mountainroot Lair",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46355.6,
                  28393.9
                ],
                "id": 160,
                "chat_link": "[&BKAAAAA=]"
              },
              "161": {
                "name": "Koofooloo",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48914.8,
                  28446.5
                ],
                "id": 161,
                "chat_link": "[&BKEAAAA=]"
              },
              "162": {
                "name": "Martyr's Tomb",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46299.6,
                  27516
                ],
                "id": 162,
                "chat_link": "[&BKIAAAA=]"
              },
              "165": {
                "name": "Faun's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  47173.8,
                  28233.9
                ],
                "id": 165,
                "chat_link": "[&BKUAAAA=]"
              },
              "166": {
                "name": "Shieldbluff Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48489.3,
                  28515.4
                ],
                "id": 166,
                "chat_link": "[&BKYAAAA=]"
              },
              "167": {
                "name": "Seraph's Landing Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46569.9,
                  26596.1
                ],
                "id": 167,
                "chat_link": "[&BKcAAAA=]"
              },
              "168": {
                "name": "Wynchona Rally Point Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46897.9,
                  27366.9
                ],
                "id": 168,
                "chat_link": "[&BKgAAAA=]"
              },
              "169": {
                "name": "Grey Gritta's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49048.1,
                  27956.6
                ],
                "id": 169,
                "chat_link": "[&BKkAAAA=]"
              },
              "170": {
                "name": "Nightguard Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  47627.1,
                  28497
                ],
                "id": 170,
                "chat_link": "[&BKoAAAA=]"
              },
              "171": {
                "name": "Demetra Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46506.2,
                  27638.7
                ],
                "id": 171,
                "chat_link": "[&BKsAAAA=]"
              },
              "172": {
                "name": "Recovery Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  47862.6,
                  27455.2
                ],
                "id": 172,
                "chat_link": "[&BKwAAAA=]"
              },
              "173": {
                "name": "Barricade Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48543.8,
                  27299.1
                ],
                "id": 173,
                "chat_link": "[&BK0AAAA=]"
              },
              "174": {
                "name": "Trebusha's Overlook Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  47779.3,
                  26802.1
                ],
                "id": 174,
                "chat_link": "[&BK4AAAA=]"
              },
              "175": {
                "name": "Bridgewatch Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  47384.1,
                  26626.6
                ],
                "id": 175,
                "chat_link": "[&BK8AAAA=]"
              },
              "176": {
                "name": "Junction Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48031.8,
                  26413.9
                ],
                "id": 176,
                "chat_link": "[&BLAAAAA=]"
              },
              "177": {
                "name": "Cloven Hoof Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48809.3,
                  26174.8
                ],
                "id": 177,
                "chat_link": "[&BLEAAAA=]"
              },
              "178": {
                "name": "Arca Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46498.7,
                  26140.6
                ],
                "id": 178,
                "chat_link": "[&BLIAAAA=]"
              },
              "195": {
                "name": "Arcallion Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  47559.2,
                  26139.4
                ],
                "id": 195,
                "chat_link": "[&BMMAAAA=]"
              },
              "1542": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  46952.3,
                  28497.9
                ],
                "id": 1542,
                "chat_link": "[&BAYGAAA=]"
              },
              "1543": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48181.2,
                  27601.3
                ],
                "id": 1543,
                "chat_link": "[&BAcGAAA=]"
              },
              "1544": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48917.4,
                  27823.4
                ],
                "id": 1544,
                "chat_link": "[&BAgGAAA=]"
              },
              "1545": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  46872.3,
                  27382.1
                ],
                "id": 1545,
                "chat_link": "[&BAkGAAA=]"
              },
              "1546": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  46641.5,
                  26677.2
                ],
                "id": 1546,
                "chat_link": "[&BAoGAAA=]"
              },
              "1547": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  47922.5,
                  26690.5
                ],
                "id": 1547,
                "chat_link": "[&BAsGAAA=]"
              },
              "1548": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48187.4,
                  26515.9
                ],
                "id": 1548,
                "chat_link": "[&BAwGAAA=]"
              },
              "1549": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48839.1,
                  27309.4
                ],
                "id": 1549,
                "chat_link": "[&BA0GAAA=]"
              }
            },
            "tasks": {
              "200": {
                "objective": "Protect Seraph's Landing.",
                "level": 39,
                "coord": [
                  46524.6,
                  26614.6
                ],
                "bounds": [
                  [
                    46378.2,
                    26806.5
                  ],
                  [
                    46367.8,
                    26362.7
                  ],
                  [
                    46548,
                    26366.3
                  ],
                  [
                    46590.7,
                    26444.1
                  ],
                  [
                    46615.9,
                    26442.1
                  ],
                  [
                    46642.1,
                    26531.7
                  ],
                  [
                    46706.6,
                    26549.5
                  ],
                  [
                    46768.9,
                    26608.3
                  ],
                  [
                    46789,
                    26701.5
                  ],
                  [
                    46625.3,
                    26830.4
                  ],
                  [
                    46378.2,
                    26806.5
                  ]
                ],
                "id": 200,
                "chat_link": "[&BMgAAAA=]"
              },
              "201": {
                "objective": "Help the Seraph disrupt bandit activity.",
                "level": 37,
                "coord": [
                  46944,
                  27377.7
                ],
                "bounds": [
                  [
                    46600.6,
                    27400.2
                  ],
                  [
                    46652.2,
                    27235.5
                  ],
                  [
                    47023.5,
                    27287.5
                  ],
                  [
                    47279.5,
                    27448.9
                  ],
                  [
                    47393,
                    27720.4
                  ],
                  [
                    47361.8,
                    27943.3
                  ],
                  [
                    47196.5,
                    28137.1
                  ],
                  [
                    47086.9,
                    28199
                  ],
                  [
                    46989.7,
                    28153.3
                  ],
                  [
                    46765.8,
                    27987.2
                  ],
                  [
                    46648.8,
                    27659.5
                  ],
                  [
                    46600.6,
                    27400.2
                  ]
                ],
                "id": 201,
                "chat_link": "[&BMkAAAA=]"
              },
              "202": {
                "objective": "Help the Seraph at Nightguard Beach.",
                "level": 33,
                "coord": [
                  47633.2,
                  28431.2
                ],
                "bounds": [
                  [
                    47871.9,
                    28457.8
                  ],
                  [
                    48005.3,
                    28430.7
                  ],
                  [
                    48027.5,
                    28287.7
                  ],
                  [
                    48001.3,
                    28046.6
                  ],
                  [
                    47517.9,
                    28064.5
                  ],
                  [
                    47295.1,
                    28372.1
                  ],
                  [
                    47300.8,
                    28646.9
                  ],
                  [
                    47825.2,
                    28623.3
                  ],
                  [
                    47871.9,
                    28457.8
                  ]
                ],
                "id": 202,
                "chat_link": "[&BMoAAAA=]"
              },
              "203": {
                "objective": "Cause chaos among the centaurs.",
                "level": 36,
                "coord": [
                  48195.6,
                  27360.1
                ],
                "bounds": [
                  [
                    48439.8,
                    27783.2
                  ],
                  [
                    48244.8,
                    27312.4
                  ],
                  [
                    48112.8,
                    27186.2
                  ],
                  [
                    47878.4,
                    27264.3
                  ],
                  [
                    47436.9,
                    27637.8
                  ],
                  [
                    47391,
                    27862.7
                  ],
                  [
                    47469.9,
                    27974.2
                  ],
                  [
                    48022.5,
                    28009
                  ],
                  [
                    48358.5,
                    27896.6
                  ],
                  [
                    48439.8,
                    27783.2
                  ]
                ],
                "id": 203,
                "chat_link": "[&BMsAAAA=]"
              },
              "204": {
                "objective": "Help Ket investigate the Ruins of Demetra.",
                "level": 38,
                "coord": [
                  46550.3,
                  27787.7
                ],
                "bounds": [
                  [
                    46481.2,
                    27960.6
                  ],
                  [
                    46225.9,
                    27882.9
                  ],
                  [
                    46233.5,
                    27397
                  ],
                  [
                    46409.5,
                    27419.7
                  ],
                  [
                    46519.5,
                    27494.4
                  ],
                  [
                    46628.1,
                    27630.1
                  ],
                  [
                    46647,
                    27727.2
                  ],
                  [
                    46637.8,
                    27866.3
                  ],
                  [
                    46481.2,
                    27960.6
                  ]
                ],
                "id": 204,
                "chat_link": "[&BMwAAAA=]"
              },
              "205": {
                "objective": "Help Broil Cane disrupt centaurs.",
                "level": 34,
                "coord": [
                  48816.6,
                  28501.8
                ],
                "bounds": [
                  [
                    48871.5,
                    28577.7
                  ],
                  [
                    48675.7,
                    28585.4
                  ],
                  [
                    48517.3,
                    28528.1
                  ],
                  [
                    48453.1,
                    28490
                  ],
                  [
                    48118.8,
                    28614.4
                  ],
                  [
                    47855.8,
                    28582
                  ],
                  [
                    47881.9,
                    28472.5
                  ],
                  [
                    48027.3,
                    28446
                  ],
                  [
                    48115,
                    28419.7
                  ],
                  [
                    48157,
                    28336
                  ],
                  [
                    48136.3,
                    28188.5
                  ],
                  [
                    48257.2,
                    28039.9
                  ],
                  [
                    48555.1,
                    28199.9
                  ],
                  [
                    48648.5,
                    28371.4
                  ],
                  [
                    48745.5,
                    28426.5
                  ],
                  [
                    48851.2,
                    28460.3
                  ],
                  [
                    48871.5,
                    28577.7
                  ]
                ],
                "id": 205,
                "chat_link": "[&BM0AAAA=]"
              },
              "206": {
                "objective": "Train with the Company.",
                "level": 35,
                "coord": [
                  49078.6,
                  28027.5
                ],
                "bounds": [
                  [
                    48926.7,
                    28216
                  ],
                  [
                    49073.6,
                    28232.7
                  ],
                  [
                    49235,
                    28185.2
                  ],
                  [
                    49232.2,
                    27987.4
                  ],
                  [
                    49056.3,
                    27752.9
                  ],
                  [
                    48836.8,
                    27863.2
                  ],
                  [
                    48926.7,
                    28216
                  ]
                ],
                "id": 206,
                "chat_link": "[&BM4AAAA=]"
              },
              "207": {
                "objective": "Assist the skritt in Arcallion Digs.",
                "level": 40,
                "coord": [
                  47470.4,
                  25963.3
                ],
                "bounds": [
                  [
                    47235.2,
                    26275
                  ],
                  [
                    46988.7,
                    26333.6
                  ],
                  [
                    46825.5,
                    26221.6
                  ],
                  [
                    46686,
                    26094.8
                  ],
                  [
                    46726.4,
                    25972.1
                  ],
                  [
                    47099.1,
                    25955.1
                  ],
                  [
                    47520.2,
                    25893.1
                  ],
                  [
                    47735.3,
                    25876.6
                  ],
                  [
                    47783.5,
                    25996.3
                  ],
                  [
                    47668,
                    26108
                  ],
                  [
                    47592.6,
                    26165.9
                  ],
                  [
                    47235.2,
                    26275
                  ]
                ],
                "id": 207,
                "chat_link": "[&BM8AAAA=]"
              },
              "208": {
                "objective": "Attack the centaurs.",
                "level": 41,
                "coord": [
                  47722.7,
                  26260.8
                ],
                "bounds": [
                  [
                    48350.2,
                    26734.3
                  ],
                  [
                    48422.6,
                    26643
                  ],
                  [
                    48377.8,
                    26519
                  ],
                  [
                    48237,
                    26476.2
                  ],
                  [
                    48197.4,
                    26310.3
                  ],
                  [
                    48336.9,
                    26223.8
                  ],
                  [
                    48412.3,
                    26121.3
                  ],
                  [
                    48354.2,
                    26017.9
                  ],
                  [
                    48187,
                    25947
                  ],
                  [
                    47649.2,
                    26222.8
                  ],
                  [
                    47674,
                    26588.8
                  ],
                  [
                    48350.2,
                    26734.3
                  ]
                ],
                "id": 208,
                "chat_link": "[&BNAAAAA=]"
              },
              "209": {
                "objective": "Help Forward Scout Luke disrupt centaur logistics.",
                "level": 42,
                "coord": [
                  48602,
                  26658.4
                ],
                "bounds": [
                  [
                    48698.8,
                    26958.9
                  ],
                  [
                    48548.3,
                    26984.8
                  ],
                  [
                    48449,
                    26942.9
                  ],
                  [
                    48360.5,
                    26826.9
                  ],
                  [
                    48395.9,
                    26749.5
                  ],
                  [
                    48450.5,
                    26703.9
                  ],
                  [
                    48483,
                    26595.6
                  ],
                  [
                    48330.8,
                    26462
                  ],
                  [
                    48332.9,
                    26360
                  ],
                  [
                    48373,
                    26308.8
                  ],
                  [
                    48481.7,
                    26321.9
                  ],
                  [
                    48628,
                    26453.1
                  ],
                  [
                    48722.1,
                    26461.7
                  ],
                  [
                    48794.6,
                    26488.2
                  ],
                  [
                    48822.4,
                    26609.9
                  ],
                  [
                    48711.6,
                    26729.7
                  ],
                  [
                    48698.8,
                    26958.9
                  ]
                ],
                "id": 209,
                "chat_link": "[&BNEAAAA=]"
              },
              "210": {
                "objective": "Help Forward Scout Greta cause chaos in the Modniir homeland.",
                "level": 43,
                "coord": [
                  48575.4,
                  26289.4
                ],
                "bounds": [
                  [
                    48855.6,
                    26468.5
                  ],
                  [
                    48865.6,
                    26516.6
                  ],
                  [
                    49068.6,
                    26605.5
                  ],
                  [
                    49274.8,
                    26591.9
                  ],
                  [
                    49335.7,
                    26407.2
                  ],
                  [
                    49254.6,
                    26027.4
                  ],
                  [
                    48930.9,
                    25938.6
                  ],
                  [
                    48707.5,
                    25963.4
                  ],
                  [
                    48518.5,
                    26218.1
                  ],
                  [
                    48540.3,
                    26349.5
                  ],
                  [
                    48633.5,
                    26433.9
                  ],
                  [
                    48855.6,
                    26468.5
                  ]
                ],
                "id": 210,
                "chat_link": "[&BNIAAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  46963.2,
                  28526.9
                ],
                "id": "0-151"
              },
              {
                "coord": [
                  49181.1,
                  28221.8
                ],
                "id": "0-152"
              },
              {
                "coord": [
                  48869.5,
                  28029.7
                ],
                "id": "0-149"
              },
              {
                "coord": [
                  49296.3,
                  26324.2
                ],
                "id": "0-150"
              },
              {
                "coord": [
                  46404.4,
                  26447.3
                ],
                "id": "0-57"
              },
              {
                "coord": [
                  47296.6,
                  26354.9
                ],
                "id": "0-230"
              }
            ],
            "sectors": {
              "341": {
                "name": "Nightguard Beach",
                "level": 34,
                "coord": [
                  47440.7,
                  28438.6
                ],
                "bounds": [
                  [
                    47410.4,
                    28224.7
                  ],
                  [
                    47275,
                    28376.6
                  ],
                  [
                    47082.8,
                    28342.4
                  ],
                  [
                    47027.6,
                    28702.3
                  ],
                  [
                    47849.9,
                    28650.8
                  ],
                  [
                    47786.8,
                    28456.5
                  ],
                  [
                    47652.6,
                    28317
                  ],
                  [
                    47410.4,
                    28224.7
                  ]
                ],
                "id": 341,
                "chat_link": "[&BFUBAAA=]"
              },
              "342": {
                "name": "Bonerattler Caverns",
                "level": 39,
                "coord": [
                  46535.1,
                  28464.9
                ],
                "bounds": [
                  [
                    46254.7,
                    28146.4
                  ],
                  [
                    46433.8,
                    27978.2
                  ],
                  [
                    46928.9,
                    28216.3
                  ],
                  [
                    47093,
                    28340.5
                  ],
                  [
                    47023.2,
                    28695.4
                  ],
                  [
                    46851.5,
                    28670.6
                  ],
                  [
                    46669.5,
                    28662.5
                  ],
                  [
                    46525.3,
                    28729.1
                  ],
                  [
                    46393.8,
                    28721.7
                  ],
                  [
                    46247.1,
                    28693.7
                  ],
                  [
                    46164.5,
                    28557.8
                  ],
                  [
                    46179.4,
                    28400.4
                  ],
                  [
                    46191.8,
                    28231.1
                  ],
                  [
                    46254.7,
                    28146.4
                  ]
                ],
                "id": 342,
                "chat_link": "[&BFYBAAA=]"
              },
              "343": {
                "name": "Cloven Hoof Pass",
                "level": 42,
                "coord": [
                  48128.8,
                  26487.3
                ],
                "bounds": [
                  [
                    47778.1,
                    26619.7
                  ],
                  [
                    48072.8,
                    26789.3
                  ],
                  [
                    48187.3,
                    26793.9
                  ],
                  [
                    48397.4,
                    26782.4
                  ],
                  [
                    48404.1,
                    26547.9
                  ],
                  [
                    48283,
                    26486.5
                  ],
                  [
                    48217.8,
                    26316.3
                  ],
                  [
                    48389.5,
                    26167.8
                  ],
                  [
                    48213.3,
                    26018.3
                  ],
                  [
                    47764.1,
                    26329.2
                  ],
                  [
                    47708.8,
                    26509
                  ],
                  [
                    47778.1,
                    26619.7
                  ]
                ],
                "id": 343,
                "chat_link": "[&BFcBAAA=]"
              },
              "344": {
                "name": "Diremane Woods",
                "level": 42,
                "coord": [
                  48907.3,
                  27048.9
                ],
                "bounds": [
                  [
                    48582.2,
                    27154.4
                  ],
                  [
                    48582.2,
                    26967.2
                  ],
                  [
                    49033,
                    26711.7
                  ],
                  [
                    49073.9,
                    26867
                  ],
                  [
                    49030.6,
                    27041
                  ],
                  [
                    49132.8,
                    27283.5
                  ],
                  [
                    48916.5,
                    27317.4
                  ],
                  [
                    48582.2,
                    27154.4
                  ]
                ],
                "id": 344,
                "chat_link": "[&BFgBAAA=]"
              },
              "345": {
                "name": "Modniir Gorge",
                "level": 43,
                "coord": [
                  48965.8,
                  26312.9
                ],
                "bounds": [
                  [
                    49117.7,
                    26484.9
                  ],
                  [
                    49025.9,
                    26499.9
                  ],
                  [
                    48817.8,
                    26430.8
                  ],
                  [
                    48708.7,
                    26438.9
                  ],
                  [
                    48598.5,
                    26309.8
                  ],
                  [
                    48701.3,
                    26013.3
                  ],
                  [
                    48764.3,
                    25981.2
                  ],
                  [
                    48853.2,
                    26073.4
                  ],
                  [
                    49148.5,
                    25985.5
                  ],
                  [
                    49315,
                    26260.3
                  ],
                  [
                    49345.4,
                    26650.3
                  ],
                  [
                    49193.4,
                    26626.8
                  ],
                  [
                    49117.7,
                    26484.9
                  ]
                ],
                "id": 345,
                "chat_link": "[&BFkBAAA=]"
              },
              "346": {
                "name": "High Timber Claim",
                "level": 42,
                "coord": [
                  48582.3,
                  26507.5
                ],
                "bounds": [
                  [
                    48387.5,
                    26163.2
                  ],
                  [
                    48544.9,
                    26242.7
                  ],
                  [
                    48709.5,
                    26435.8
                  ],
                  [
                    48817.8,
                    26430.7
                  ],
                  [
                    49025.7,
                    26490.9
                  ],
                  [
                    49033.5,
                    26706.4
                  ],
                  [
                    48586.5,
                    26966.8
                  ],
                  [
                    48393.7,
                    26782.8
                  ],
                  [
                    48405.3,
                    26555.1
                  ],
                  [
                    48281.8,
                    26486.8
                  ],
                  [
                    48219.1,
                    26321
                  ],
                  [
                    48387.5,
                    26163.2
                  ]
                ],
                "id": 346,
                "chat_link": "[&BFoBAAA=]"
              },
              "347": {
                "name": "Thunder Rock",
                "level": 37,
                "coord": [
                  48131.2,
                  27638.5
                ],
                "bounds": [
                  [
                    47845,
                    27994.5
                  ],
                  [
                    47913.1,
                    27662.8
                  ],
                  [
                    47841.5,
                    27482
                  ],
                  [
                    48052.4,
                    27454.2
                  ],
                  [
                    48198.7,
                    27310.9
                  ],
                  [
                    48257.3,
                    27522.7
                  ],
                  [
                    48394.4,
                    27501.1
                  ],
                  [
                    48551.4,
                    27557.3
                  ],
                  [
                    48302.4,
                    27903.1
                  ],
                  [
                    47955.5,
                    27996
                  ],
                  [
                    47845,
                    27994.5
                  ]
                ],
                "id": 347,
                "chat_link": "[&BFsBAAA=]"
              },
              "348": {
                "name": "Stoneman's Notch",
                "level": 40,
                "coord": [
                  48169.3,
                  27109.7
                ],
                "bounds": [
                  [
                    47818.8,
                    27345.8
                  ],
                  [
                    47854.3,
                    27028.2
                  ],
                  [
                    48098.5,
                    26938.3
                  ],
                  [
                    48074.7,
                    26790
                  ],
                  [
                    48396.2,
                    26781.7
                  ],
                  [
                    48589.5,
                    26963.9
                  ],
                  [
                    48583,
                    27163.6
                  ],
                  [
                    48370.1,
                    27142.5
                  ],
                  [
                    48061.5,
                    27454.4
                  ],
                  [
                    47846.5,
                    27488.3
                  ],
                  [
                    47818.8,
                    27345.8
                  ]
                ],
                "id": 348,
                "chat_link": "[&BFwBAAA=]"
              },
              "349": {
                "name": "Greenflin Plateau",
                "level": 40,
                "coord": [
                  47448.6,
                  26388.6
                ],
                "bounds": [
                  [
                    47095.9,
                    26692.6
                  ],
                  [
                    46958.8,
                    26494.3
                  ],
                  [
                    46963.5,
                    26323
                  ],
                  [
                    47427.3,
                    26073.7
                  ],
                  [
                    47552.2,
                    26211.7
                  ],
                  [
                    47670.5,
                    26077.9
                  ],
                  [
                    47755.9,
                    26152.9
                  ],
                  [
                    47765.4,
                    26328
                  ],
                  [
                    47710.3,
                    26505.5
                  ],
                  [
                    47770.3,
                    26614.5
                  ],
                  [
                    47264.5,
                    26800.6
                  ],
                  [
                    47095.9,
                    26692.6
                  ]
                ],
                "id": 349,
                "chat_link": "[&BF0BAAA=]"
              },
              "350": {
                "name": "Guardian Lake",
                "level": 33,
                "coord": [
                  48249.9,
                  28295.7
                ],
                "bounds": [
                  [
                    48112.7,
                    28291.6
                  ],
                  [
                    48136.8,
                    28664.9
                  ],
                  [
                    47846.1,
                    28668.6
                  ],
                  [
                    47781.6,
                    28456.4
                  ],
                  [
                    47652.6,
                    28319.1
                  ],
                  [
                    47622.8,
                    27985.7
                  ],
                  [
                    47986.1,
                    27977.2
                  ],
                  [
                    48308.8,
                    27896.5
                  ],
                  [
                    48817.2,
                    28073.6
                  ],
                  [
                    49144.4,
                    28605.4
                  ],
                  [
                    49003.1,
                    28640.7
                  ],
                  [
                    48566.4,
                    28204.4
                  ],
                  [
                    48269.8,
                    28060.8
                  ],
                  [
                    48112.7,
                    28291.6
                  ]
                ],
                "id": 350,
                "chat_link": "[&BF4BAAA=]"
              },
              "351": {
                "name": "Greystone Rise",
                "level": 39,
                "coord": [
                  46767.7,
                  26979.2
                ],
                "bounds": [
                  [
                    46340.2,
                    27274.8
                  ],
                  [
                    46402.8,
                    26959.7
                  ],
                  [
                    46298.2,
                    26711.5
                  ],
                  [
                    46412.4,
                    26558.7
                  ],
                  [
                    46587.3,
                    26521.1
                  ],
                  [
                    46748.7,
                    26794
                  ],
                  [
                    47098,
                    26692.6
                  ],
                  [
                    47265,
                    26797.6
                  ],
                  [
                    47188.4,
                    26869
                  ],
                  [
                    47207.4,
                    27137.6
                  ],
                  [
                    47217,
                    27297.4
                  ],
                  [
                    46975,
                    27163.1
                  ],
                  [
                    46693.4,
                    27216.1
                  ],
                  [
                    46609.9,
                    27389.7
                  ],
                  [
                    46472.5,
                    27304.8
                  ],
                  [
                    46340.2,
                    27274.8
                  ]
                ],
                "id": 351,
                "chat_link": "[&BF8BAAA=]"
              },
              "352": {
                "name": "Wildspine Hills",
                "level": 36,
                "coord": [
                  49133.3,
                  28134.1
                ],
                "bounds": [
                  [
                    49209.5,
                    28638.9
                  ],
                  [
                    49376.9,
                    28608.2
                  ],
                  [
                    49453.4,
                    28562.9
                  ],
                  [
                    49536.5,
                    28466.8
                  ],
                  [
                    49559.7,
                    28355.8
                  ],
                  [
                    49529.4,
                    28170.5
                  ],
                  [
                    49438.8,
                    28072.4
                  ],
                  [
                    49253.1,
                    27695.8
                  ],
                  [
                    48913.8,
                    27527.7
                  ],
                  [
                    48800.9,
                    27652.7
                  ],
                  [
                    48547.5,
                    27543.9
                  ],
                  [
                    48294,
                    27900.6
                  ],
                  [
                    48811.2,
                    28077.8
                  ],
                  [
                    49142.2,
                    28602.6
                  ],
                  [
                    49209.5,
                    28638.9
                  ]
                ],
                "id": 352,
                "chat_link": "[&BGABAAA=]"
              },
              "353": {
                "name": "Hangman's Saddle",
                "level": 36,
                "coord": [
                  48554.8,
                  27391.4
                ],
                "bounds": [
                  [
                    48396.1,
                    27500.9
                  ],
                  [
                    48803.1,
                    27655.6
                  ],
                  [
                    48917,
                    27527.5
                  ],
                  [
                    48915.6,
                    27317.5
                  ],
                  [
                    48582.4,
                    27154.6
                  ],
                  [
                    48370,
                    27146.7
                  ],
                  [
                    48198.5,
                    27309.4
                  ],
                  [
                    48255.7,
                    27519
                  ],
                  [
                    48396.1,
                    27500.9
                  ]
                ],
                "id": 353,
                "chat_link": "[&BGEBAAA=]"
              },
              "354": {
                "name": "Shieldbluff Point",
                "level": 33,
                "coord": [
                  48465.1,
                  28479.3
                ],
                "bounds": [
                  [
                    48103,
                    28290.9
                  ],
                  [
                    48100.5,
                    28612.6
                  ],
                  [
                    48365.6,
                    28624.2
                  ],
                  [
                    48468.2,
                    28672
                  ],
                  [
                    48608.9,
                    28662.9
                  ],
                  [
                    48744.7,
                    28600.3
                  ],
                  [
                    49005.2,
                    28644.5
                  ],
                  [
                    48521.5,
                    28154.9
                  ],
                  [
                    48268.1,
                    28051
                  ],
                  [
                    48103,
                    28290.9
                  ]
                ],
                "id": 354,
                "chat_link": "[&BGIBAAA=]"
              },
              "355": {
                "name": "Arca Lake",
                "level": 39,
                "coord": [
                  46635.3,
                  26361.7
                ],
                "bounds": [
                  [
                    46412.8,
                    26561.1
                  ],
                  [
                    46303.9,
                    26711.2
                  ],
                  [
                    46263.6,
                    26678.6
                  ],
                  [
                    46233.6,
                    26522.5
                  ],
                  [
                    46273.9,
                    26426.5
                  ],
                  [
                    46360.6,
                    26345.5
                  ],
                  [
                    46326.6,
                    26221
                  ],
                  [
                    46469.3,
                    26240.7
                  ],
                  [
                    46564.9,
                    26136.6
                  ],
                  [
                    46516.5,
                    26043.5
                  ],
                  [
                    46688.1,
                    25876.1
                  ],
                  [
                    47232.9,
                    25828.3
                  ],
                  [
                    47428.3,
                    26074.7
                  ],
                  [
                    46964.3,
                    26325.8
                  ],
                  [
                    46961.5,
                    26497.8
                  ],
                  [
                    47099.3,
                    26694.7
                  ],
                  [
                    46749.9,
                    26802.2
                  ],
                  [
                    46585.4,
                    26524.1
                  ],
                  [
                    46412.8,
                    26561.1
                  ]
                ],
                "id": 355,
                "chat_link": "[&BGMBAAA=]"
              },
              "356": {
                "name": "Ruins of Holy Demetra",
                "level": 39,
                "coord": [
                  46363.5,
                  27785.8
                ],
                "bounds": [
                  [
                    46655.3,
                    27705.4
                  ],
                  [
                    46748.8,
                    27847.9
                  ],
                  [
                    46649.2,
                    28089.9
                  ],
                  [
                    46431.3,
                    27984
                  ],
                  [
                    46261.6,
                    28147
                  ],
                  [
                    46217.7,
                    28138.7
                  ],
                  [
                    46130.2,
                    28075.2
                  ],
                  [
                    46102.2,
                    27936.2
                  ],
                  [
                    46154.6,
                    27855.7
                  ],
                  [
                    46210,
                    27825.3
                  ],
                  [
                    46239.4,
                    27747.8
                  ],
                  [
                    46230.4,
                    27470.1
                  ],
                  [
                    46336.9,
                    27268.6
                  ],
                  [
                    46484.6,
                    27309.2
                  ],
                  [
                    46601.1,
                    27385.6
                  ],
                  [
                    46655.3,
                    27705.4
                  ]
                ],
                "id": 356,
                "chat_link": "[&BGQBAAA=]"
              },
              "357": {
                "name": "Wynchona Woods",
                "level": 37,
                "coord": [
                  46982.5,
                  27674.1
                ],
                "bounds": [
                  [
                    46653.6,
                    27708.7
                  ],
                  [
                    46597.4,
                    27389.4
                  ],
                  [
                    46692.2,
                    27211.6
                  ],
                  [
                    46966.2,
                    27159.3
                  ],
                  [
                    47329.4,
                    27354.6
                  ],
                  [
                    47345,
                    27597.2
                  ],
                  [
                    47395.3,
                    27692.2
                  ],
                  [
                    47371,
                    27809.5
                  ],
                  [
                    47119.6,
                    28016.2
                  ],
                  [
                    46928.2,
                    28220.3
                  ],
                  [
                    46645.9,
                    28080.6
                  ],
                  [
                    46746.8,
                    27849.9
                  ],
                  [
                    46653.6,
                    27708.7
                  ]
                ],
                "id": 357,
                "chat_link": "[&BGUBAAA=]"
              },
              "358": {
                "name": "Hidden Ourobon",
                "level": 43,
                "coord": [
                  49157.3,
                  26804.8
                ],
                "bounds": [
                  [
                    49022,
                    27042.6
                  ],
                  [
                    49074.8,
                    26868.9
                  ],
                  [
                    49029,
                    26709.9
                  ],
                  [
                    49022.9,
                    26496.7
                  ],
                  [
                    49117.1,
                    26484.8
                  ],
                  [
                    49193.6,
                    26627.1
                  ],
                  [
                    49345.9,
                    26649.9
                  ],
                  [
                    49421,
                    26716.8
                  ],
                  [
                    49241.7,
                    27212
                  ],
                  [
                    49104.8,
                    27239
                  ],
                  [
                    49022,
                    27042.6
                  ]
                ],
                "id": 358,
                "chat_link": "[&BGYBAAA=]"
              },
              "359": {
                "name": "Trebuchet Bend",
                "level": 39,
                "coord": [
                  47632.6,
                  27054.4
                ],
                "bounds": [
                  [
                    47769.1,
                    26612
                  ],
                  [
                    48078.1,
                    26789.3
                  ],
                  [
                    48101.9,
                    26935.7
                  ],
                  [
                    47853.3,
                    27030.7
                  ],
                  [
                    47823.7,
                    27354.4
                  ],
                  [
                    47717.3,
                    27294.3
                  ],
                  [
                    47617.3,
                    27246.8
                  ],
                  [
                    47328.7,
                    27352.8
                  ],
                  [
                    47215.8,
                    27312.8
                  ],
                  [
                    47188.5,
                    26870.2
                  ],
                  [
                    47265.4,
                    26799
                  ],
                  [
                    47769.1,
                    26612
                  ]
                ],
                "id": 359,
                "chat_link": "[&BGcBAAA=]"
              },
              "360": {
                "name": "Splintered Teeth",
                "level": 36,
                "coord": [
                  47587.6,
                  27628.9
                ],
                "bounds": [
                  [
                    47624.4,
                    27976.4
                  ],
                  [
                    47852.9,
                    27988.6
                  ],
                  [
                    47927,
                    27665.2
                  ],
                  [
                    47827.2,
                    27339
                  ],
                  [
                    47620,
                    27244.6
                  ],
                  [
                    47331.4,
                    27353
                  ],
                  [
                    47345.7,
                    27597.4
                  ],
                  [
                    47391,
                    27688.6
                  ],
                  [
                    47368.7,
                    27807.1
                  ],
                  [
                    47624.4,
                    27976.4
                  ]
                ],
                "id": 360,
                "chat_link": "[&BGgBAAA=]"
              },
              "361": {
                "name": "Faun's Gap",
                "level": 35,
                "coord": [
                  47302.6,
                  28131.8
                ],
                "bounds": [
                  [
                    47119.7,
                    28015.8
                  ],
                  [
                    47255.3,
                    27912.7
                  ],
                  [
                    47365.8,
                    27804.7
                  ],
                  [
                    47628.2,
                    27977.2
                  ],
                  [
                    47657,
                    28321
                  ],
                  [
                    47410.9,
                    28225.6
                  ],
                  [
                    47275,
                    28376.1
                  ],
                  [
                    47083.6,
                    28339.6
                  ],
                  [
                    46927.8,
                    28213.5
                  ],
                  [
                    47119.7,
                    28015.8
                  ]
                ],
                "id": 361,
                "chat_link": "[&BGkBAAA=]"
              },
              "362": {
                "name": "Arcallion Digs",
                "level": 41,
                "coord": [
                  47696.5,
                  26077.2
                ],
                "bounds": [
                  [
                    47835.6,
                    25913.4
                  ],
                  [
                    47671.5,
                    25937.8
                  ],
                  [
                    47437.8,
                    25902.4
                  ],
                  [
                    47378,
                    26025.7
                  ],
                  [
                    47552.3,
                    26213.1
                  ],
                  [
                    47669.5,
                    26080.2
                  ],
                  [
                    47756.8,
                    26153.4
                  ],
                  [
                    47756.3,
                    26342
                  ],
                  [
                    48017.5,
                    26167.3
                  ],
                  [
                    47889.4,
                    26036.1
                  ],
                  [
                    47835.6,
                    25913.4
                  ]
                ],
                "id": 362,
                "chat_link": "[&BGoBAAA=]"
              },
              "363": {
                "name": "The Feral Dens",
                "level": 39,
                "coord": [
                  46413.5,
                  26043.7
                ],
                "bounds": [
                  [
                    46561.8,
                    26000.8
                  ],
                  [
                    46519.9,
                    25970.9
                  ],
                  [
                    46486.2,
                    25931.9
                  ],
                  [
                    46458.3,
                    25873.1
                  ],
                  [
                    46310.4,
                    25864.9
                  ],
                  [
                    46225.2,
                    25951.8
                  ],
                  [
                    46240,
                    26098.3
                  ],
                  [
                    46269.4,
                    26178.2
                  ],
                  [
                    46326.3,
                    26225
                  ],
                  [
                    46471.4,
                    26245.1
                  ],
                  [
                    46569.4,
                    26138.5
                  ],
                  [
                    46523.8,
                    26046.2
                  ],
                  [
                    46561.8,
                    26000.8
                  ]
                ],
                "id": 363,
                "chat_link": "[&BGsBAAA=]"
              },
              "364": {
                "name": "Ourobore Caves",
                "level": 36,
                "coord": [
                  49156.5,
                  27460.4
                ],
                "bounds": [
                  [
                    49131.1,
                    27274.8
                  ],
                  [
                    48914.9,
                    27316.1
                  ],
                  [
                    48915.6,
                    27530
                  ],
                  [
                    49274.3,
                    27711.9
                  ],
                  [
                    49381,
                    27597.5
                  ],
                  [
                    49322.4,
                    27332.3
                  ],
                  [
                    49131.1,
                    27274.8
                  ]
                ],
                "id": 364,
                "chat_link": "[&BGwBAAA=]"
              }
            },
            "adventures": [],
            "id": 17,
            "mastery_points": [
              {
                "coord": [
                  49365.3,
                  26707.4
                ],
                "id": 313,
                "region": "Tyria"
              }
            ]
          },
          "18": {
            "name": "Divinity's Reach",
            "min_level": 0,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {
              "256": {
                "name": "Mina's Target Shooting",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43893.7,
                  27623.3
                ],
                "id": 256,
                "chat_link": "[&BAABAAA=]"
              },
              "257": {
                "name": "Durmand Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44285,
                  27390.2
                ],
                "id": 257,
                "chat_link": "[&BAEBAAA=]"
              },
              "258": {
                "name": "Maiden's Whisper",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44627.3,
                  27195.1
                ],
                "id": 258,
                "chat_link": "[&BAIBAAA=]"
              },
              "259": {
                "name": "Uzolan's Mechanical Orchestra",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44463.5,
                  27635.8
                ],
                "id": 259,
                "chat_link": "[&BAMBAAA=]"
              },
              "260": {
                "name": "Vigil Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43751.2,
                  27381.4
                ],
                "id": 260,
                "chat_link": "[&BAQBAAA=]"
              },
              "261": {
                "name": "Vanguard Hospital",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44353.8,
                  26577.9
                ],
                "id": 261,
                "chat_link": "[&BAUBAAA=]"
              },
              "262": {
                "name": "Queen's Heart Orphanage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44280.3,
                  26860.6
                ],
                "id": 262,
                "chat_link": "[&BAYBAAA=]"
              },
              "263": {
                "name": "Minister Zamon's Mansion",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43923.7,
                  26765.3
                ],
                "id": 263,
                "chat_link": "[&BAcBAAA=]"
              },
              "264": {
                "name": "Minister Wi's Mansion",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44525.9,
                  27336.4
                ],
                "id": 264,
                "chat_link": "[&BAgBAAA=]"
              },
              "266": {
                "name": "Manor Hill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44154,
                  26741.5
                ],
                "id": 266,
                "chat_link": "[&BAoBAAA=]"
              },
              "267": {
                "name": "Cottage Bend",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44355.6,
                  26907.3
                ],
                "id": 267,
                "chat_link": "[&BAsBAAA=]"
              },
              "268": {
                "name": "Rook's Row",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44383.1,
                  26758.6
                ],
                "id": 268,
                "chat_link": "[&BAwBAAA=]"
              },
              "269": {
                "name": "Haidryn's Menagerie",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43474.3,
                  27674.7
                ],
                "id": 269,
                "chat_link": "[&BA0BAAA=]"
              },
              "803": {
                "name": "Dwayna Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43995.6,
                  27954
                ],
                "id": 803,
                "chat_link": "[&BCMDAAA=]"
              },
              "804": {
                "name": "Grenth Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44043.5,
                  26498.9
                ],
                "id": 804,
                "chat_link": "[&BCQDAAA=]"
              },
              "805": {
                "name": "Kormir Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44637.7,
                  27624.8
                ],
                "id": 805,
                "chat_link": "[&BCUDAAA=]"
              },
              "806": {
                "name": "Lyssa Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44660.4,
                  26885
                ],
                "id": 806,
                "chat_link": "[&BCYDAAA=]"
              },
              "807": {
                "name": "Melandru Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43376.3,
                  27570.9
                ],
                "id": 807,
                "chat_link": "[&BCcDAAA=]"
              },
              "808": {
                "name": "Balthazar Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43389.5,
                  26850.3
                ],
                "id": 808,
                "chat_link": "[&BCgDAAA=]"
              },
              "809": {
                "name": "Palace Waypoint",
                "type": "waypoint",
                "floor": 2,
                "coord": [
                  44036,
                  27193.3
                ],
                "id": 809,
                "chat_link": "[&BCkDAAA=]"
              },
              "810": {
                "name": "Commons Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43917.3,
                  27584.1
                ],
                "id": 810,
                "chat_link": "[&BCoDAAA=]"
              },
              "811": {
                "name": "Rurikton Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44410.5,
                  27239.1
                ],
                "id": 811,
                "chat_link": "[&BCsDAAA=]"
              },
              "812": {
                "name": "Crown Pavilion Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43628.3,
                  27229.6
                ],
                "id": 812,
                "chat_link": "[&BCwDAAA=]"
              },
              "813": {
                "name": "Ossan Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43818.9,
                  26866.1
                ],
                "id": 813,
                "chat_link": "[&BC0DAAA=]"
              },
              "814": {
                "name": "Salma Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44266.4,
                  26928.4
                ],
                "id": 814,
                "chat_link": "[&BC4DAAA=]"
              },
              "817": {
                "name": "Skull Plaza",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44015.1,
                  26879.2
                ],
                "id": 817,
                "chat_link": "[&BDEDAAA=]"
              },
              "843": {
                "name": "The Busted Flagon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43856.5,
                  27780
                ],
                "id": 843,
                "chat_link": "[&BEsDAAA=]"
              },
              "1278": {
                "name": "Ministers Waypoint",
                "type": "waypoint",
                "floor": 2,
                "coord": [
                  44048,
                  27570.5
                ],
                "id": 1278,
                "chat_link": "[&BP4EAAA=]"
              },
              "1399": {
                "type": "vista",
                "floor": 2,
                "coord": [
                  44139.5,
                  27319.8
                ],
                "id": 1399,
                "chat_link": "[&BHcFAAA=]"
              },
              "1400": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43799.5,
                  26893.3
                ],
                "id": 1400,
                "chat_link": "[&BHgFAAA=]"
              },
              "1401": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43437.7,
                  27407
                ],
                "id": 1401,
                "chat_link": "[&BHkFAAA=]"
              },
              "1402": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  44139.8,
                  26527
                ],
                "id": 1402,
                "chat_link": "[&BHoFAAA=]"
              },
              "1403": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43549.8,
                  27610.7
                ],
                "id": 1403,
                "chat_link": "[&BHsFAAA=]"
              },
              "1404": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  44482,
                  26832.2
                ],
                "id": 1404,
                "chat_link": "[&BHwFAAA=]"
              },
              "1805": {
                "name": "The Dead End",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44361.8,
                  27847.8
                ],
                "id": 1805,
                "chat_link": "[&BA0HAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "183": {
                "name": "Rurikton",
                "level": 0,
                "coord": [
                  44587.4,
                  27247.4
                ],
                "bounds": [
                  [
                    44442.7,
                    27221.2
                  ],
                  [
                    44428.7,
                    27131.2
                  ],
                  [
                    44401.3,
                    27054.2
                  ],
                  [
                    44473.9,
                    27008.8
                  ],
                  [
                    44565.6,
                    27068
                  ],
                  [
                    44844.3,
                    27038
                  ],
                  [
                    44877,
                    27178.6
                  ],
                  [
                    44876.6,
                    27338.7
                  ],
                  [
                    44852.9,
                    27466.9
                  ],
                  [
                    44639,
                    27372.7
                  ],
                  [
                    44533.8,
                    27406.1
                  ],
                  [
                    44470.3,
                    27457.3
                  ],
                  [
                    44389,
                    27407.7
                  ],
                  [
                    44428.8,
                    27314.8
                  ],
                  [
                    44442.7,
                    27221.2
                  ]
                ],
                "id": 183,
                "chat_link": "[&BLcAAAA=]"
              },
              "184": {
                "name": "The Crown Pavilion",
                "level": 0,
                "coord": [
                  43450.8,
                  27235.3
                ],
                "bounds": [
                  [
                    43646.2,
                    27062.6
                  ],
                  [
                    43623.8,
                    27143.8
                  ],
                  [
                    43607.5,
                    27224.1
                  ],
                  [
                    43628.6,
                    27305.3
                  ],
                  [
                    43652.2,
                    27387.6
                  ],
                  [
                    43559.7,
                    27438.7
                  ],
                  [
                    43493.8,
                    27363
                  ],
                  [
                    43170,
                    27454.9
                  ],
                  [
                    43141,
                    27333.3
                  ],
                  [
                    43129.6,
                    27196
                  ],
                  [
                    43156.5,
                    27047.1
                  ],
                  [
                    43497.2,
                    27089
                  ],
                  [
                    43554.6,
                    27014
                  ],
                  [
                    43646.2,
                    27062.6
                  ]
                ],
                "id": 184,
                "chat_link": "[&BLgAAAA=]"
              },
              "186": {
                "name": "Ossan Quarter",
                "level": 0,
                "coord": [
                  43739.1,
                  26730.8
                ],
                "bounds": [
                  [
                    43784.6,
                    26385.8
                  ],
                  [
                    43646.1,
                    26459.3
                  ],
                  [
                    43520.2,
                    26536.4
                  ],
                  [
                    43408,
                    26622.5
                  ],
                  [
                    43611.8,
                    26836.6
                  ],
                  [
                    43597,
                    26948.8
                  ],
                  [
                    43676.1,
                    26994.7
                  ],
                  [
                    43722.2,
                    26924.5
                  ],
                  [
                    43788,
                    26862.8
                  ],
                  [
                    43869.5,
                    26835.8
                  ],
                  [
                    43976.2,
                    26813.3
                  ],
                  [
                    43976.2,
                    26725
                  ],
                  [
                    43923.8,
                    26703.4
                  ],
                  [
                    43847.4,
                    26583.1
                  ],
                  [
                    43784.6,
                    26385.8
                  ]
                ],
                "id": 186,
                "chat_link": "[&BLoAAAA=]"
              },
              "187": {
                "name": "Salma District (Home)",
                "level": 0,
                "coord": [
                  44309.2,
                  26738.4
                ],
                "bounds": [
                  [
                    44409.9,
                    26426.2
                  ],
                  [
                    44262.5,
                    26365.6
                  ],
                  [
                    44194.7,
                    26638
                  ],
                  [
                    44128.4,
                    26704.4
                  ],
                  [
                    44054.6,
                    26742.7
                  ],
                  [
                    44054.2,
                    26822.1
                  ],
                  [
                    44129.5,
                    26847.2
                  ],
                  [
                    44224.3,
                    26883.8
                  ],
                  [
                    44296.2,
                    26924.9
                  ],
                  [
                    44344.8,
                    26997.1
                  ],
                  [
                    44427,
                    26942.6
                  ],
                  [
                    44427.7,
                    26872.1
                  ],
                  [
                    44478.9,
                    26761.8
                  ],
                  [
                    44663.5,
                    26630.9
                  ],
                  [
                    44542.4,
                    26517.4
                  ],
                  [
                    44409.9,
                    26426.2
                  ]
                ],
                "id": 187,
                "chat_link": "[&BLsAAAA=]"
              },
              "722": {
                "name": "District Promenade",
                "level": 0,
                "coord": [
                  44015.6,
                  27258.7
                ],
                "bounds": [
                  [
                    43813,
                    27578
                  ],
                  [
                    43750,
                    27535.9
                  ],
                  [
                    43689,
                    27469
                  ],
                  [
                    43771.3,
                    27419.9
                  ],
                  [
                    43729,
                    27345
                  ],
                  [
                    43651.3,
                    27404.3
                  ],
                  [
                    43627,
                    27304.8
                  ],
                  [
                    43605.6,
                    27225.2
                  ],
                  [
                    43621.7,
                    27144.8
                  ],
                  [
                    43646.8,
                    27061.5
                  ],
                  [
                    43719,
                    27108
                  ],
                  [
                    43753.8,
                    27049.7
                  ],
                  [
                    43677.1,
                    26996.8
                  ],
                  [
                    43720.2,
                    26923.1
                  ],
                  [
                    43783.7,
                    26861.6
                  ],
                  [
                    43869.2,
                    26835.4
                  ],
                  [
                    43974.5,
                    26810.6
                  ],
                  [
                    43979.3,
                    26916.6
                  ],
                  [
                    44050.7,
                    26915.2
                  ],
                  [
                    44050.7,
                    26822.7
                  ],
                  [
                    44136.4,
                    26844.7
                  ],
                  [
                    44226.3,
                    26879.5
                  ],
                  [
                    44301.2,
                    26922
                  ],
                  [
                    44351.5,
                    26999.4
                  ],
                  [
                    44267.9,
                    27046.8
                  ],
                  [
                    44302.3,
                    27110.1
                  ],
                  [
                    44392.3,
                    27058.7
                  ],
                  [
                    44433.8,
                    27134.5
                  ],
                  [
                    44446.4,
                    27219
                  ],
                  [
                    44437.6,
                    27316.9
                  ],
                  [
                    44390,
                    27406.8
                  ],
                  [
                    44291.6,
                    27353.2
                  ],
                  [
                    44254,
                    27415.6
                  ],
                  [
                    44343,
                    27470.3
                  ],
                  [
                    44288.6,
                    27526.1
                  ],
                  [
                    44225,
                    27575.5
                  ],
                  [
                    44133.6,
                    27609
                  ],
                  [
                    44051.6,
                    27622.2
                  ],
                  [
                    44096.7,
                    27600.3
                  ],
                  [
                    44097.4,
                    27569.2
                  ],
                  [
                    44056.2,
                    27551.5
                  ],
                  [
                    43982,
                    27549
                  ],
                  [
                    43927.2,
                    27568.3
                  ],
                  [
                    43924.3,
                    27599.4
                  ],
                  [
                    43976.3,
                    27623.2
                  ],
                  [
                    43900.5,
                    27602.5
                  ],
                  [
                    43813,
                    27578
                  ]
                ],
                "id": 722,
                "chat_link": "[&BNICAAA=]"
              },
              "723": {
                "name": "Plaza of Balthazar",
                "level": 0,
                "coord": [
                  43429.8,
                  26898.5
                ],
                "bounds": [
                  [
                    43483.2,
                    26887.3
                  ],
                  [
                    43449.3,
                    26954.8
                  ],
                  [
                    43555.4,
                    27013.1
                  ],
                  [
                    43499.2,
                    27087.3
                  ],
                  [
                    43160,
                    27048.3
                  ],
                  [
                    43217.5,
                    26862.9
                  ],
                  [
                    43315.6,
                    26719.6
                  ],
                  [
                    43406.4,
                    26623.3
                  ],
                  [
                    43612.6,
                    26837.8
                  ],
                  [
                    43598.9,
                    26950.7
                  ],
                  [
                    43483.2,
                    26887.3
                  ]
                ],
                "id": 723,
                "chat_link": "[&BNMCAAA=]"
              },
              "724": {
                "name": "Plaza of Dwayna",
                "level": 0,
                "coord": [
                  43946,
                  27867.4
                ],
                "bounds": [
                  [
                    43844.8,
                    27943.4
                  ],
                  [
                    43852.7,
                    27819.3
                  ],
                  [
                    43922,
                    27736.3
                  ],
                  [
                    43976.6,
                    27733.1
                  ],
                  [
                    43977,
                    27851
                  ],
                  [
                    44052.1,
                    27853.8
                  ],
                  [
                    44049.7,
                    27735.9
                  ],
                  [
                    44116,
                    27738.9
                  ],
                  [
                    44181.4,
                    27836.7
                  ],
                  [
                    44181.7,
                    27952.6
                  ],
                  [
                    44182.5,
                    28030.8
                  ],
                  [
                    43618.9,
                    28040.4
                  ],
                  [
                    43538.4,
                    27945.3
                  ],
                  [
                    43750.8,
                    27925.4
                  ],
                  [
                    43844.8,
                    27943.4
                  ]
                ],
                "id": 724,
                "chat_link": "[&BNQCAAA=]"
              },
              "725": {
                "name": "Plaza of Grenth",
                "level": 0,
                "coord": [
                  44018.8,
                  26558.5
                ],
                "bounds": [
                  [
                    44054.4,
                    26577
                  ],
                  [
                    43974.1,
                    26573.2
                  ],
                  [
                    43977,
                    26726.6
                  ],
                  [
                    43925.1,
                    26705.8
                  ],
                  [
                    43849,
                    26586
                  ],
                  [
                    43787.8,
                    26390.8
                  ],
                  [
                    43925.1,
                    26350.7
                  ],
                  [
                    44091,
                    26342
                  ],
                  [
                    44265.3,
                    26364.1
                  ],
                  [
                    44194.7,
                    26637.9
                  ],
                  [
                    44128.6,
                    26704.3
                  ],
                  [
                    44053.6,
                    26743.6
                  ],
                  [
                    44054.4,
                    26577
                  ]
                ],
                "id": 725,
                "chat_link": "[&BNUCAAA=]"
              },
              "726": {
                "name": "Plaza of Kormir",
                "level": 0,
                "coord": [
                  44601.6,
                  27569
                ],
                "bounds": [
                  [
                    44708.6,
                    27760.6
                  ],
                  [
                    44594.8,
                    27864.9
                  ],
                  [
                    44435,
                    27651.8
                  ],
                  [
                    44447.8,
                    27528
                  ],
                  [
                    44556.6,
                    27586.4
                  ],
                  [
                    44591.5,
                    27530.1
                  ],
                  [
                    44474.4,
                    27453.8
                  ],
                  [
                    44533.3,
                    27407
                  ],
                  [
                    44639.7,
                    27376.3
                  ],
                  [
                    44851.8,
                    27470.6
                  ],
                  [
                    44784,
                    27629.7
                  ],
                  [
                    44708.6,
                    27760.6
                  ]
                ],
                "id": 726,
                "chat_link": "[&BNYCAAA=]"
              },
              "727": {
                "name": "Plaza of Lyssa",
                "level": 0,
                "coord": [
                  44597.1,
                  26890
                ],
                "bounds": [
                  [
                    44842.1,
                    27040.1
                  ],
                  [
                    44565,
                    27069.5
                  ],
                  [
                    44472.7,
                    27009.2
                  ],
                  [
                    44584,
                    26941.5
                  ],
                  [
                    44544.7,
                    26876.4
                  ],
                  [
                    44426.5,
                    26945.6
                  ],
                  [
                    44426.4,
                    26872.7
                  ],
                  [
                    44474.7,
                    26762.7
                  ],
                  [
                    44664.9,
                    26629.5
                  ],
                  [
                    44753,
                    26758.3
                  ],
                  [
                    44814,
                    26884.8
                  ],
                  [
                    44842.1,
                    27040.1
                  ]
                ],
                "id": 727,
                "chat_link": "[&BNcCAAA=]"
              },
              "728": {
                "name": "Plaza of Melandru",
                "level": 0,
                "coord": [
                  43435.9,
                  27565.5
                ],
                "bounds": [
                  [
                    43493.8,
                    27362.4
                  ],
                  [
                    43565.1,
                    27441.2
                  ],
                  [
                    43451.9,
                    27517
                  ],
                  [
                    43489,
                    27584.3
                  ],
                  [
                    43601.9,
                    27519.8
                  ],
                  [
                    43633.1,
                    27621.1
                  ],
                  [
                    43422.2,
                    27841.2
                  ],
                  [
                    43299.6,
                    27703
                  ],
                  [
                    43232.1,
                    27612.2
                  ],
                  [
                    43170,
                    27453
                  ],
                  [
                    43493.8,
                    27362.4
                  ]
                ],
                "id": 728,
                "chat_link": "[&BNgCAAA=]"
              },
              "730": {
                "name": "Balthazar Low Road",
                "level": 0,
                "coord": [
                  43598.7,
                  26995.9
                ],
                "bounds": [
                  [
                    43477.8,
                    26883.4
                  ],
                  [
                    43442.1,
                    26953.5
                  ],
                  [
                    43717.6,
                    27104.3
                  ],
                  [
                    43757.2,
                    27042.4
                  ],
                  [
                    43477.8,
                    26883.4
                  ]
                ],
                "id": 730,
                "chat_link": "[&BNoCAAA=]"
              },
              "731": {
                "name": "Dwayna Low Road",
                "level": 0,
                "coord": [
                  44013.1,
                  27639.8
                ],
                "bounds": [
                  [
                    44056.7,
                    27551
                  ],
                  [
                    43976.7,
                    27550
                  ],
                  [
                    43926.4,
                    27568.3
                  ],
                  [
                    43924,
                    27599.8
                  ],
                  [
                    43974.7,
                    27621.9
                  ],
                  [
                    43975.1,
                    27857.9
                  ],
                  [
                    44048.6,
                    27859.6
                  ],
                  [
                    44052,
                    27621.4
                  ],
                  [
                    44098.5,
                    27599.6
                  ],
                  [
                    44098.8,
                    27568.6
                  ],
                  [
                    44056.7,
                    27551
                  ]
                ],
                "id": 731,
                "chat_link": "[&BNsCAAA=]"
              },
              "732": {
                "name": "Grenth Low Road",
                "level": 0,
                "coord": [
                  44013.7,
                  26742.4
                ],
                "bounds": [
                  [
                    43973,
                    26566.8
                  ],
                  [
                    43976.1,
                    26918.4
                  ],
                  [
                    44051.1,
                    26916.1
                  ],
                  [
                    44054.5,
                    26568.1
                  ],
                  [
                    43973,
                    26566.8
                  ]
                ],
                "id": 732,
                "chat_link": "[&BNwCAAA=]"
              },
              "733": {
                "name": "Kormir Low Road",
                "level": 0,
                "coord": [
                  44423.9,
                  27472.6
                ],
                "bounds": [
                  [
                    44595.6,
                    27531.4
                  ],
                  [
                    44287.7,
                    27355.6
                  ],
                  [
                    44253,
                    27413.3
                  ],
                  [
                    44559.3,
                    27590.3
                  ],
                  [
                    44595.6,
                    27531.4
                  ]
                ],
                "id": 733,
                "chat_link": "[&BN0CAAA=]"
              },
              "734": {
                "name": "Lyssa Low Road",
                "level": 0,
                "coord": [
                  44427.3,
                  26988.9
                ],
                "bounds": [
                  [
                    44303.4,
                    27106.9
                  ],
                  [
                    44266.3,
                    27042.7
                  ],
                  [
                    44548.1,
                    26869.7
                  ],
                  [
                    44591.3,
                    26936.2
                  ],
                  [
                    44303.4,
                    27106.9
                  ]
                ],
                "id": 734,
                "chat_link": "[&BN4CAAA=]"
              },
              "735": {
                "name": "Melandru Low Road",
                "level": 0,
                "coord": [
                  43606.1,
                  27466.5
                ],
                "bounds": [
                  [
                    43725.3,
                    27341.3
                  ],
                  [
                    43768.8,
                    27419.4
                  ],
                  [
                    43484.7,
                    27587.4
                  ],
                  [
                    43445.5,
                    27517.8
                  ],
                  [
                    43725.3,
                    27341.3
                  ]
                ],
                "id": 735,
                "chat_link": "[&BN8CAAA=]"
              },
              "736": {
                "name": "Eastern Commons",
                "level": 0,
                "coord": [
                  44277.2,
                  27723
                ],
                "bounds": [
                  [
                    44344,
                    27466.1
                  ],
                  [
                    44447.2,
                    27528.3
                  ],
                  [
                    44435.8,
                    27653.3
                  ],
                  [
                    44594.2,
                    27862.4
                  ],
                  [
                    44489,
                    27944.1
                  ],
                  [
                    44347.1,
                    28008.4
                  ],
                  [
                    44180.8,
                    28027.1
                  ],
                  [
                    44179,
                    27829.3
                  ],
                  [
                    44116.2,
                    27740.5
                  ],
                  [
                    44054.3,
                    27737.5
                  ],
                  [
                    44052.9,
                    27623.9
                  ],
                  [
                    44130.3,
                    27606.8
                  ],
                  [
                    44222.9,
                    27572.6
                  ],
                  [
                    44287.2,
                    27522.2
                  ],
                  [
                    44344,
                    27466.1
                  ]
                ],
                "id": 736,
                "chat_link": "[&BOACAAA=]"
              },
              "737": {
                "name": "Western Commons",
                "level": 0,
                "coord": [
                  43761.3,
                  27705.5
                ],
                "bounds": [
                  [
                    43972.7,
                    27731.6
                  ],
                  [
                    43920.6,
                    27733.7
                  ],
                  [
                    43850.2,
                    27819.8
                  ],
                  [
                    43837.8,
                    27940
                  ],
                  [
                    43753.5,
                    27917
                  ],
                  [
                    43544.5,
                    27947.4
                  ],
                  [
                    43422.4,
                    27840.7
                  ],
                  [
                    43631,
                    27628
                  ],
                  [
                    43599.8,
                    27525.5
                  ],
                  [
                    43688.1,
                    27466.1
                  ],
                  [
                    43748.8,
                    27531
                  ],
                  [
                    43813.5,
                    27573.6
                  ],
                  [
                    43902.3,
                    27600.3
                  ],
                  [
                    43973.3,
                    27622.1
                  ],
                  [
                    43972.7,
                    27731.6
                  ]
                ],
                "id": 737,
                "chat_link": "[&BOECAAA=]"
              }
            },
            "adventures": [],
            "id": 18,
            "mastery_points": []
          },
          "23": {
            "name": "Kessex Hills",
            "min_level": 15,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {
              "3": {
                "name": "Fort Salma Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  42695.1,
                  30680.5
                ],
                "id": 3,
                "chat_link": "[&BAMAAAA=]"
              },
              "4": {
                "name": "Overlord's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  42759.5,
                  31679.2
                ],
                "id": 4,
                "chat_link": "[&BAQAAAA=]"
              },
              "6": {
                "name": "Halacon Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  42299.7,
                  31027.5
                ],
                "id": 6,
                "chat_link": "[&BAYAAAA=]"
              },
              "7": {
                "name": "Sojourner's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  45163.2,
                  30664
                ],
                "id": 7,
                "chat_link": "[&BAcAAAA=]"
              },
              "8": {
                "name": "Delanian Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  45766.9,
                  30799.6
                ],
                "id": 8,
                "chat_link": "[&BAgAAAA=]"
              },
              "10": {
                "name": "Ireko Tradecamp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43537.7,
                  32163.9
                ],
                "id": 10,
                "chat_link": "[&BAoAAAA=]"
              },
              "12": {
                "name": "Shadowheart Site Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  42841,
                  32330.2
                ],
                "id": 12,
                "chat_link": "[&BAwAAAA=]"
              },
              "16": {
                "name": "Viathan Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43833.9,
                  31419.4
                ],
                "id": 16,
                "chat_link": "[&BBAAAAA=]"
              },
              "17": {
                "name": "Darkwound Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  45999,
                  31579.6
                ],
                "id": 17,
                "chat_link": "[&BBEAAAA=]"
              },
              "18": {
                "name": "Cereboth Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  45528.3,
                  31950.6
                ],
                "id": 18,
                "chat_link": "[&BBIAAAA=]"
              },
              "19": {
                "name": "Overlake Haven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44742.9,
                  32051.8
                ],
                "id": 19,
                "chat_link": "[&BBMAAAA=]"
              },
              "20": {
                "name": "Kessex Haven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44843,
                  31380.9
                ],
                "id": 20,
                "chat_link": "[&BBQAAAA=]"
              },
              "21": {
                "name": "Cavernhold Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44559.4,
                  30633.6
                ],
                "id": 21,
                "chat_link": "[&BBUAAAA=]"
              },
              "22": {
                "name": "Greyhoof Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43589.1,
                  30655.8
                ],
                "id": 22,
                "chat_link": "[&BBYAAAA=]"
              },
              "23": {
                "name": "Black Haven",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45707.1,
                  30934.8
                ],
                "id": 23,
                "chat_link": "[&BBcAAAA=]"
              },
              "24": {
                "name": "Gort's Pit",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45741.9,
                  31380.8
                ],
                "id": 24,
                "chat_link": "[&BBgAAAA=]"
              },
              "25": {
                "name": "Garenhoff",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46100.6,
                  32018.3
                ],
                "id": 25,
                "chat_link": "[&BBkAAAA=]"
              },
              "26": {
                "name": "Jannaj's Bandits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45361.2,
                  30551.3
                ],
                "id": 26,
                "chat_link": "[&BBoAAAA=]"
              },
              "27": {
                "name": "Quarryside",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44344.4,
                  31240.6
                ],
                "id": 27,
                "chat_link": "[&BBsAAAA=]"
              },
              "28": {
                "name": "Triskell Quay",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44378.5,
                  31716.4
                ],
                "id": 28,
                "chat_link": "[&BBwAAAA=]"
              },
              "29": {
                "name": "Goff's Bandits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44149.6,
                  30620.3
                ],
                "id": 29,
                "chat_link": "[&BB0AAAA=]"
              },
              "30": {
                "name": "Kenna's Bandits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43862.6,
                  31000.4
                ],
                "id": 30,
                "chat_link": "[&BB4AAAA=]"
              },
              "31": {
                "name": "Auld Red Wharf",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43612.4,
                  31314.2
                ],
                "id": 31,
                "chat_link": "[&BB8AAAA=]"
              },
              "32": {
                "name": "Wallwatcher Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42521.1,
                  31030.5
                ],
                "id": 32,
                "chat_link": "[&BCAAAAA=]"
              },
              "33": {
                "name": "Mudbay Digs",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43161.6,
                  31946.5
                ],
                "id": 33,
                "chat_link": "[&BCEAAAA=]"
              },
              "34": {
                "name": "Togatl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43952.9,
                  31587.5
                ],
                "id": 34,
                "chat_link": "[&BCIAAAA=]"
              },
              "35": {
                "name": "Krait's Larder",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44382.8,
                  32025.9
                ],
                "id": 35,
                "chat_link": "[&BCMAAAA=]"
              },
              "822": {
                "name": "Uzolan's Hideout",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45527.1,
                  30686.9
                ],
                "id": 822,
                "chat_link": "[&BDYDAAA=]"
              },
              "953": {
                "name": "Earthworks Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  45432.8,
                  31161
                ],
                "id": 953,
                "chat_link": "[&BLkDAAA=]"
              },
              "954": {
                "name": "Gap Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44257.8,
                  30860.3
                ],
                "id": 954,
                "chat_link": "[&BLoDAAA=]"
              },
              "1270": {
                "name": "Barnaby's Watch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44714.8,
                  30886.7
                ],
                "id": 1270,
                "chat_link": "[&BPYEAAA=]"
              },
              "1283": {
                "name": "Isgarren's View",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45867.1,
                  32291
                ],
                "id": 1283,
                "chat_link": "[&BAMFAAA=]"
              },
              "1502": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43022.3,
                  32384.6
                ],
                "id": 1502,
                "chat_link": "[&BN4FAAA=]"
              },
              "1503": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  45500.5,
                  31819.3
                ],
                "id": 1503,
                "chat_link": "[&BN8FAAA=]"
              },
              "1504": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  44987.2,
                  31568.3
                ],
                "id": 1504,
                "chat_link": "[&BOAFAAA=]"
              },
              "1505": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  44240.3,
                  31312.8
                ],
                "id": 1505,
                "chat_link": "[&BOEFAAA=]"
              },
              "1506": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  45696.1,
                  31016.1
                ],
                "id": 1506,
                "chat_link": "[&BOIFAAA=]"
              },
              "1507": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  44955.7,
                  31080
                ],
                "id": 1507,
                "chat_link": "[&BOMFAAA=]"
              },
              "1508": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  42612.4,
                  30613.8
                ],
                "id": 1508,
                "chat_link": "[&BOQFAAA=]"
              },
              "1509": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  45989.3,
                  32223.9
                ],
                "id": 1509,
                "chat_link": "[&BOUFAAA=]"
              },
              "1510": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43406.9,
                  31586.1
                ],
                "id": 1510,
                "chat_link": "[&BOYFAAA=]"
              },
              "1526": {
                "name": "Lair of the Seawitch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43459.9,
                  31784.9
                ],
                "id": 1526,
                "chat_link": "[&BPYFAAA=]"
              },
              "1527": {
                "name": "Mafic Core",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45454.2,
                  32288.6
                ],
                "id": 1527,
                "chat_link": "[&BPcFAAA=]"
              },
              "1837": {
                "name": "Thunder Ridge Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42944,
                  31222.8
                ],
                "id": 1837,
                "chat_link": "[&BC0HAAA=]"
              },
              "1838": {
                "name": "Tower of Nightmares",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43395.7,
                  31595.5
                ],
                "id": 1838,
                "chat_link": "[&BC4HAAA=]"
              }
            },
            "tasks": {
              "246": {
                "objective": "Help Waldo Flood take revenge on local bandits.",
                "level": 15,
                "coord": [
                  45251.6,
                  30520.4
                ],
                "bounds": [
                  [
                    45149.5,
                    30468.6
                  ],
                  [
                    45465.9,
                    30482.3
                  ],
                  [
                    45584.3,
                    30565.8
                  ],
                  [
                    45574.3,
                    30760.5
                  ],
                  [
                    45426.2,
                    30855.1
                  ],
                  [
                    45140.5,
                    30674.2
                  ],
                  [
                    45149.5,
                    30468.6
                  ]
                ],
                "id": 246,
                "chat_link": "[&BPYAAAA=]"
              },
              "247": {
                "objective": "Help Lionguard Micah keep the Black Haven area safe for travelers.",
                "level": 16,
                "coord": [
                  45699.3,
                  30872.1
                ],
                "bounds": [
                  [
                    45317.1,
                    31243.9
                  ],
                  [
                    45421.2,
                    31178.8
                  ],
                  [
                    45435,
                    30857.2
                  ],
                  [
                    45535.8,
                    30792.5
                  ],
                  [
                    45649,
                    30813.9
                  ],
                  [
                    45817.4,
                    30751.5
                  ],
                  [
                    45886.3,
                    30679.8
                  ],
                  [
                    45976.5,
                    30667.2
                  ],
                  [
                    46052.5,
                    30729.3
                  ],
                  [
                    46170.5,
                    30934
                  ],
                  [
                    46155.9,
                    31133.8
                  ],
                  [
                    45894.5,
                    31272.5
                  ],
                  [
                    45514.5,
                    31358.9
                  ],
                  [
                    45337,
                    31337.7
                  ],
                  [
                    45317.1,
                    31243.9
                  ]
                ],
                "id": 247,
                "chat_link": "[&BPcAAAA=]"
              },
              "248": {
                "objective": "Help Engineer Gilli.",
                "level": 18,
                "coord": [
                  44530.9,
                  31238.8
                ],
                "bounds": [
                  [
                    44443.3,
                    31252.9
                  ],
                  [
                    44413.8,
                    31488
                  ],
                  [
                    44443.3,
                    31252.9
                  ]
                ],
                "id": 248,
                "chat_link": "[&BPgAAAA=]"
              },
              "249": {
                "objective": "Help Guard Barnaby.",
                "level": 17,
                "coord": [
                  44718,
                  30866.7
                ],
                "bounds": [
                  [
                    44770.9,
                    30506.3
                  ],
                  [
                    45131.1,
                    30688.1
                  ],
                  [
                    45426.5,
                    30885.2
                  ],
                  [
                    45418.9,
                    31176.3
                  ],
                  [
                    45310.5,
                    31247.5
                  ],
                  [
                    45323.5,
                    31313.7
                  ],
                  [
                    45205,
                    31332.2
                  ],
                  [
                    45017.7,
                    31355.6
                  ],
                  [
                    44962.7,
                    31218.3
                  ],
                  [
                    44455,
                    30900
                  ],
                  [
                    44351.1,
                    30780.6
                  ],
                  [
                    44349.3,
                    30682.9
                  ],
                  [
                    44406.2,
                    30508.6
                  ],
                  [
                    44770.9,
                    30506.3
                  ]
                ],
                "id": 249,
                "chat_link": "[&BPkAAAA=]"
              },
              "250": {
                "objective": "Aid the wardens of Shadowheart.",
                "level": 22,
                "coord": [
                  42830.3,
                  32417.1
                ],
                "bounds": [
                  [
                    42136.7,
                    32090.6
                  ],
                  [
                    42964.2,
                    32134.2
                  ],
                  [
                    43065.3,
                    32229.8
                  ],
                  [
                    43022.2,
                    32461
                  ],
                  [
                    42137.7,
                    32444.1
                  ],
                  [
                    42136.7,
                    32090.6
                  ]
                ],
                "id": 250,
                "chat_link": "[&BPoAAAA=]"
              },
              "251": {
                "objective": "Help the fishers of Triskell Quay.",
                "level": 19,
                "coord": [
                  44435.3,
                  31656.9
                ],
                "bounds": [
                  [
                    44507,
                    32145.3
                  ],
                  [
                    44606.7,
                    31949.2
                  ],
                  [
                    44514.6,
                    31556.1
                  ],
                  [
                    44166.9,
                    31611.6
                  ],
                  [
                    44137.3,
                    32199.9
                  ],
                  [
                    44507,
                    32145.3
                  ]
                ],
                "id": 251,
                "chat_link": "[&BPsAAAA=]"
              },
              "252": {
                "objective": "Help Matlal collect truffles for her starving tribe.",
                "level": 22,
                "coord": [
                  43762,
                  31851.5
                ],
                "bounds": [
                  [
                    43780.4,
                    32243.4
                  ],
                  [
                    44013.7,
                    32246
                  ],
                  [
                    44128.3,
                    32199.8
                  ],
                  [
                    44139,
                    31963.7
                  ],
                  [
                    43935.6,
                    31774.1
                  ],
                  [
                    43941.8,
                    31756
                  ],
                  [
                    44111.1,
                    31724.1
                  ],
                  [
                    44148.7,
                    31643.5
                  ],
                  [
                    44021.3,
                    31485.5
                  ],
                  [
                    43881.8,
                    31454.4
                  ],
                  [
                    43789.3,
                    31572.6
                  ],
                  [
                    43772.9,
                    31620.9
                  ],
                  [
                    43716,
                    31629.3
                  ],
                  [
                    43645.1,
                    31664
                  ],
                  [
                    43644.6,
                    31868
                  ],
                  [
                    43735.6,
                    32095.1
                  ],
                  [
                    43780.4,
                    32243.4
                  ]
                ],
                "id": 252,
                "chat_link": "[&BPwAAAA=]"
              },
              "253": {
                "objective": "Help Doolsileep protect Moogooloo Village.",
                "level": 23,
                "coord": [
                  43261.9,
                  31270.3
                ],
                "bounds": [
                  [
                    43702.6,
                    32071.9
                  ],
                  [
                    43739.4,
                    32205.5
                  ],
                  [
                    43666.3,
                    32223
                  ],
                  [
                    43541.7,
                    32095.3
                  ],
                  [
                    43414.9,
                    32114.8
                  ],
                  [
                    43336.2,
                    32051.8
                  ],
                  [
                    43308.2,
                    31917.9
                  ],
                  [
                    43291.8,
                    31852.5
                  ],
                  [
                    43169.6,
                    31727.8
                  ],
                  [
                    43036.7,
                    31705.4
                  ],
                  [
                    43013.9,
                    31636.1
                  ],
                  [
                    43202.5,
                    31415.3
                  ],
                  [
                    43126.8,
                    31171
                  ],
                  [
                    43214.3,
                    31116.3
                  ],
                  [
                    43476.6,
                    31312.7
                  ],
                  [
                    43744.1,
                    31367.7
                  ],
                  [
                    43739.3,
                    31514.1
                  ],
                  [
                    43634,
                    31645
                  ],
                  [
                    43636.9,
                    31857.4
                  ],
                  [
                    43702.6,
                    32071.9
                  ]
                ],
                "id": 253,
                "chat_link": "[&BP0AAAA=]"
              },
              "254": {
                "objective": "Assist Overlake Haven with their ettin nuisance.",
                "level": 20,
                "coord": [
                  44881.2,
                  31979.2
                ],
                "bounds": [
                  [
                    44932.3,
                    31610.5
                  ],
                  [
                    45023.8,
                    31606.3
                  ],
                  [
                    45228,
                    31586.1
                  ],
                  [
                    45141.9,
                    31983.7
                  ],
                  [
                    45047,
                    32074.4
                  ],
                  [
                    45001.8,
                    32051.1
                  ],
                  [
                    44915.8,
                    32061.1
                  ],
                  [
                    44836.2,
                    32012.1
                  ],
                  [
                    44682.6,
                    31976.1
                  ],
                  [
                    44636.9,
                    31806.4
                  ],
                  [
                    44932.3,
                    31610.5
                  ]
                ],
                "id": 254,
                "chat_link": "[&BP4AAAA=]"
              },
              "255": {
                "objective": "Help Seraph Soldier Tripp.",
                "level": 25,
                "coord": [
                  42674.2,
                  31653.5
                ],
                "bounds": [
                  [
                    42354.7,
                    31762.8
                  ],
                  [
                    42413.1,
                    31786.2
                  ],
                  [
                    42619.4,
                    31790.3
                  ],
                  [
                    42690,
                    31737.5
                  ],
                  [
                    42721.9,
                    31685.6
                  ],
                  [
                    42751.5,
                    31491.5
                  ],
                  [
                    42732.3,
                    31394.5
                  ],
                  [
                    42656.5,
                    31335.3
                  ],
                  [
                    42508.6,
                    31295.5
                  ],
                  [
                    42272.6,
                    31289.3
                  ],
                  [
                    42228.2,
                    31508.2
                  ],
                  [
                    42354.7,
                    31762.8
                  ]
                ],
                "id": 255,
                "chat_link": "[&BP8AAAA=]"
              },
              "256": {
                "objective": "Help Sergeant Rane.",
                "level": 22,
                "coord": [
                  43255.4,
                  30775.1
                ],
                "bounds": [
                  [
                    42936.5,
                    31107.9
                  ],
                  [
                    42976.6,
                    30858.5
                  ],
                  [
                    43126.2,
                    30736.9
                  ],
                  [
                    43330.8,
                    30698.2
                  ],
                  [
                    43538.2,
                    30799.5
                  ],
                  [
                    43690.8,
                    30983.7
                  ],
                  [
                    43744.3,
                    31440.7
                  ],
                  [
                    43610.8,
                    31473.5
                  ],
                  [
                    43426.1,
                    31354.9
                  ],
                  [
                    43211.9,
                    31129.3
                  ],
                  [
                    42936.5,
                    31107.9
                  ]
                ],
                "id": 256,
                "chat_link": "[&BAABAAA=]"
              },
              "257": {
                "objective": "Aid Fort Salma.",
                "level": 23,
                "coord": [
                  42616.5,
                  30737.9
                ],
                "bounds": [
                  [
                    42713.1,
                    31213.2
                  ],
                  [
                    42938.7,
                    30644
                  ],
                  [
                    42778.1,
                    30530.2
                  ],
                  [
                    42169.5,
                    30565
                  ],
                  [
                    42277.2,
                    31018
                  ],
                  [
                    42387.3,
                    31188
                  ],
                  [
                    42713.1,
                    31213.2
                  ]
                ],
                "id": 257,
                "chat_link": "[&BAEBAAA=]"
              },
              "258": {
                "objective": "Assist Dianna by undermining bandit salvage operations.",
                "level": 24,
                "coord": [
                  43019.6,
                  31943.5
                ],
                "bounds": [
                  [
                    43201.9,
                    32124.5
                  ],
                  [
                    43306.2,
                    32115.4
                  ],
                  [
                    43312.6,
                    31959
                  ],
                  [
                    43286.3,
                    31857
                  ],
                  [
                    43164.6,
                    31731
                  ],
                  [
                    43073.4,
                    31716.8
                  ],
                  [
                    43015.5,
                    31777.3
                  ],
                  [
                    43000.9,
                    31878
                  ],
                  [
                    43014.4,
                    31990.1
                  ],
                  [
                    43102.7,
                    32083
                  ],
                  [
                    43201.9,
                    32124.5
                  ]
                ],
                "id": 258,
                "chat_link": "[&BAIBAAA=]"
              },
              "259": {
                "objective": "Assist Sangdo Swiftwing.",
                "level": 21,
                "coord": [
                  45259.7,
                  32172.8
                ],
                "bounds": [
                  [
                    45280.5,
                    32392.7
                  ],
                  [
                    45178.1,
                    32384.8
                  ],
                  [
                    45095.8,
                    32386.3
                  ],
                  [
                    45010.4,
                    32381.7
                  ],
                  [
                    44982.9,
                    32373
                  ],
                  [
                    44982.8,
                    32307.1
                  ],
                  [
                    44985.1,
                    32241.9
                  ],
                  [
                    44991.6,
                    32204.8
                  ],
                  [
                    44997.4,
                    32176
                  ],
                  [
                    45023.1,
                    32136.4
                  ],
                  [
                    45055.4,
                    32108.2
                  ],
                  [
                    45110.8,
                    32087.6
                  ],
                  [
                    45169.4,
                    32071.2
                  ],
                  [
                    45218.7,
                    32051.5
                  ],
                  [
                    45323.3,
                    32008.6
                  ],
                  [
                    45419.2,
                    31993.5
                  ],
                  [
                    45565.5,
                    31951.2
                  ],
                  [
                    45628,
                    31976.6
                  ],
                  [
                    45637.6,
                    32048.4
                  ],
                  [
                    45628.5,
                    32079.5
                  ],
                  [
                    45586.9,
                    32092.1
                  ],
                  [
                    45529.4,
                    32121
                  ],
                  [
                    45493,
                    32176.6
                  ],
                  [
                    45515.9,
                    32225.1
                  ],
                  [
                    45517.2,
                    32304.1
                  ],
                  [
                    45452.6,
                    32373.2
                  ],
                  [
                    45404.3,
                    32391.2
                  ],
                  [
                    45280.5,
                    32392.7
                  ]
                ],
                "id": 259,
                "chat_link": "[&BAMBAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  42521.8,
                  32041.2
                ],
                "id": "0-148"
              },
              {
                "coord": [
                  43900,
                  31900.9
                ],
                "id": "0-147"
              },
              {
                "coord": [
                  46129.6,
                  32149.2
                ],
                "id": "0-145"
              },
              {
                "coord": [
                  46121,
                  30971.8
                ],
                "id": "0-146"
              },
              {
                "coord": [
                  46052.3,
                  30563.4
                ],
                "id": "0-47"
              }
            ],
            "sectors": {
              "69": {
                "name": "Eukaryan Caves",
                "level": 22,
                "coord": [
                  43842.3,
                  31995
                ],
                "bounds": [
                  [
                    43683.8,
                    31768.7
                  ],
                  [
                    43805.6,
                    32261.3
                  ],
                  [
                    44128.7,
                    32263.1
                  ],
                  [
                    43751.4,
                    31687.1
                  ],
                  [
                    43683.8,
                    31768.7
                  ]
                ],
                "id": 69,
                "chat_link": "[&BEUAAAA=]"
              },
              "70": {
                "name": "Earthworks Bluff",
                "level": 16,
                "coord": [
                  45152.2,
                  31153
                ],
                "bounds": [
                  [
                    44973,
                    31236
                  ],
                  [
                    44713.8,
                    31012.2
                  ],
                  [
                    44955.8,
                    30761.8
                  ],
                  [
                    45195.3,
                    30763.2
                  ],
                  [
                    45477.7,
                    30931.3
                  ],
                  [
                    45522.8,
                    31198.2
                  ],
                  [
                    45329.6,
                    31507.9
                  ],
                  [
                    45232.3,
                    31574.8
                  ],
                  [
                    44969.4,
                    31391.7
                  ],
                  [
                    44973,
                    31236
                  ]
                ],
                "id": 70,
                "chat_link": "[&BEYAAAA=]"
              },
              "71": {
                "name": "Overlord's Greatcamp",
                "level": 25,
                "coord": [
                  42469.5,
                  31560.4
                ],
                "bounds": [
                  [
                    42889.7,
                    31400.3
                  ],
                  [
                    42081.4,
                    31276.8
                  ],
                  [
                    42053.2,
                    31538.6
                  ],
                  [
                    42115.2,
                    31724.4
                  ],
                  [
                    42860,
                    31788.9
                  ],
                  [
                    42817.4,
                    31633.6
                  ],
                  [
                    42889.7,
                    31400.3
                  ]
                ],
                "id": 71,
                "chat_link": "[&BEcAAAA=]"
              },
              "72": {
                "name": "Manefire Hills",
                "level": 20,
                "coord": [
                  44040.3,
                  31133.2
                ],
                "bounds": [
                  [
                    44136.4,
                    31554.8
                  ],
                  [
                    43863.4,
                    31338.3
                  ],
                  [
                    43708.5,
                    30942.2
                  ],
                  [
                    43850.6,
                    30856.3
                  ],
                  [
                    44008.3,
                    30793.1
                  ],
                  [
                    44177.3,
                    31001.5
                  ],
                  [
                    44269,
                    31097.9
                  ],
                  [
                    44173.3,
                    31234.6
                  ],
                  [
                    44175.9,
                    31380.1
                  ],
                  [
                    44136.4,
                    31554.8
                  ]
                ],
                "id": 72,
                "chat_link": "[&BEgAAAA=]"
              },
              "73": {
                "name": "Meremoot Hill",
                "level": 24,
                "coord": [
                  42526.7,
                  31960
                ],
                "bounds": [
                  [
                    42914.8,
                    32084
                  ],
                  [
                    42860.5,
                    31787.8
                  ],
                  [
                    42112.1,
                    31727.2
                  ],
                  [
                    42047.7,
                    31873.9
                  ],
                  [
                    42470.6,
                    32112.1
                  ],
                  [
                    42754.4,
                    32174.8
                  ],
                  [
                    42914.8,
                    32084
                  ]
                ],
                "id": 73,
                "chat_link": "[&BEkAAAA=]"
              },
              "74": {
                "name": "Thunder Ridge",
                "level": 24,
                "coord": [
                  42571.2,
                  31159.3
                ],
                "bounds": [
                  [
                    43018.8,
                    31316
                  ],
                  [
                    42890.9,
                    31400.6
                  ],
                  [
                    42090.9,
                    31276.3
                  ],
                  [
                    42158.8,
                    31008.7
                  ],
                  [
                    42304.9,
                    31124.8
                  ],
                  [
                    42461.7,
                    30974.2
                  ],
                  [
                    42595.8,
                    30968
                  ],
                  [
                    43047.8,
                    31205.5
                  ],
                  [
                    43018.8,
                    31316
                  ]
                ],
                "id": 74,
                "chat_link": "[&BEoAAAA=]"
              },
              "75": {
                "name": "Greyhoof Meadows",
                "level": 22,
                "coord": [
                  43498,
                  30725.9
                ],
                "bounds": [
                  [
                    43750.3,
                    31041.3
                  ],
                  [
                    43392,
                    31213.3
                  ],
                  [
                    43191.3,
                    31095.2
                  ],
                  [
                    43064.7,
                    30752.8
                  ],
                  [
                    43136.5,
                    30461.3
                  ],
                  [
                    43225.2,
                    30392.9
                  ],
                  [
                    43533.4,
                    30368.5
                  ],
                  [
                    43776.5,
                    30402.3
                  ],
                  [
                    43844,
                    30453.2
                  ],
                  [
                    43850.1,
                    30858.3
                  ],
                  [
                    43713.3,
                    30945.8
                  ],
                  [
                    43750.3,
                    31041.3
                  ]
                ],
                "id": 75,
                "chat_link": "[&BEsAAAA=]"
              },
              "76": {
                "name": "Earthlord's Gap",
                "level": 19,
                "coord": [
                  44253,
                  30734.8
                ],
                "bounds": [
                  [
                    44396.5,
                    31013.5
                  ],
                  [
                    44268.6,
                    31098.3
                  ],
                  [
                    44172.7,
                    30999.5
                  ],
                  [
                    44008.6,
                    30792.3
                  ],
                  [
                    43850.3,
                    30856.2
                  ],
                  [
                    43843.6,
                    30452
                  ],
                  [
                    44131.2,
                    30428
                  ],
                  [
                    44485.6,
                    30340.5
                  ],
                  [
                    44732.1,
                    30456.3
                  ],
                  [
                    44640.5,
                    30911.8
                  ],
                  [
                    44396.5,
                    31013.5
                  ]
                ],
                "id": 76,
                "chat_link": "[&BEwAAAA=]"
              },
              "77": {
                "name": "Fort Salma",
                "level": 23,
                "coord": [
                  42863.9,
                  30543.3
                ],
                "bounds": [
                  [
                    43137.2,
                    30458.5
                  ],
                  [
                    43057.7,
                    30376.9
                  ],
                  [
                    42661.4,
                    30396
                  ],
                  [
                    42527.5,
                    30509.5
                  ],
                  [
                    42732.1,
                    30763.9
                  ],
                  [
                    43067.6,
                    30755.1
                  ],
                  [
                    43137.2,
                    30458.5
                  ]
                ],
                "id": 77,
                "chat_link": "[&BE0AAAA=]"
              },
              "78": {
                "name": "Triskellion Vale",
                "level": 19,
                "coord": [
                  44555.1,
                  31356
                ],
                "bounds": [
                  [
                    44973.2,
                    31390.2
                  ],
                  [
                    44881.7,
                    31494.6
                  ],
                  [
                    44753.8,
                    31476.2
                  ],
                  [
                    44626.9,
                    31584.4
                  ],
                  [
                    44599.2,
                    31793.3
                  ],
                  [
                    44456.9,
                    31806
                  ],
                  [
                    44136.3,
                    31553.6
                  ],
                  [
                    44176,
                    31380.3
                  ],
                  [
                    44173.6,
                    31236.8
                  ],
                  [
                    44269.4,
                    31098.3
                  ],
                  [
                    44395,
                    31011
                  ],
                  [
                    44641.8,
                    30910.8
                  ],
                  [
                    44713.5,
                    31013
                  ],
                  [
                    44973.9,
                    31235
                  ],
                  [
                    44973.2,
                    31390.2
                  ]
                ],
                "id": 78,
                "chat_link": "[&BE4AAAA=]"
              },
              "79": {
                "name": "Viathan's Arm",
                "level": 21,
                "coord": [
                  44322.4,
                  31900.8
                ],
                "bounds": [
                  [
                    44126.2,
                    32261.4
                  ],
                  [
                    44455.7,
                    32261.9
                  ],
                  [
                    44618.3,
                    32126.5
                  ],
                  [
                    44704.7,
                    31928.8
                  ],
                  [
                    44600.7,
                    31794
                  ],
                  [
                    44458.1,
                    31804.7
                  ],
                  [
                    43865.8,
                    31337.1
                  ],
                  [
                    43749.4,
                    31692.2
                  ],
                  [
                    44126.2,
                    32261.4
                  ]
                ],
                "id": 79,
                "chat_link": "[&BE8AAAA=]"
              },
              "80": {
                "name": "Viathan Lake",
                "level": 23,
                "coord": [
                  43466.6,
                  31793.7
                ],
                "bounds": [
                  [
                    43680.4,
                    31766.7
                  ],
                  [
                    43752.3,
                    31696.2
                  ],
                  [
                    43864.3,
                    31340.9
                  ],
                  [
                    43745.7,
                    31042
                  ],
                  [
                    43392,
                    31210.7
                  ],
                  [
                    43194.4,
                    31094.9
                  ],
                  [
                    43113.8,
                    31160
                  ],
                  [
                    43220.1,
                    31383.2
                  ],
                  [
                    43060.4,
                    31648.7
                  ],
                  [
                    43297.7,
                    31933.2
                  ],
                  [
                    43253.6,
                    32145.5
                  ],
                  [
                    43418.8,
                    32383.8
                  ],
                  [
                    43381.1,
                    32520.6
                  ],
                  [
                    43589.1,
                    32582.2
                  ],
                  [
                    43692.8,
                    32523.1
                  ],
                  [
                    43808.5,
                    32266.7
                  ],
                  [
                    43680.4,
                    31766.7
                  ]
                ],
                "id": 80,
                "chat_link": "[&BFAAAAA=]"
              },
              "81": {
                "name": "Delanian Foothills",
                "level": 16,
                "coord": [
                  45799.8,
                  31003.8
                ],
                "bounds": [
                  [
                    45892.9,
                    30937.8
                  ],
                  [
                    45831.5,
                    30946.6
                  ],
                  [
                    45853.1,
                    30775.9
                  ],
                  [
                    45765.9,
                    30763.2
                  ],
                  [
                    45611.4,
                    30819.8
                  ],
                  [
                    45476.6,
                    30930.8
                  ],
                  [
                    45520.6,
                    31194.7
                  ],
                  [
                    45848.7,
                    31293.6
                  ],
                  [
                    46142.6,
                    31241.7
                  ],
                  [
                    46054.7,
                    31134.1
                  ],
                  [
                    45892.9,
                    30937.8
                  ]
                ],
                "id": 81,
                "chat_link": "[&BFEAAAA=]"
              },
              "82": {
                "name": "Blackroot Cut",
                "level": 16,
                "coord": [
                  45894.2,
                  30717.2
                ],
                "bounds": [
                  [
                    45577.1,
                    30669
                  ],
                  [
                    45610.7,
                    30830.5
                  ],
                  [
                    45765.4,
                    30764.3
                  ],
                  [
                    45854.1,
                    30775.7
                  ],
                  [
                    45827.5,
                    30946.8
                  ],
                  [
                    45890,
                    30939.4
                  ],
                  [
                    45934.6,
                    30894.3
                  ],
                  [
                    45996.5,
                    30889.7
                  ],
                  [
                    46139.5,
                    30778.3
                  ],
                  [
                    46243.3,
                    30532.6
                  ],
                  [
                    46199.3,
                    30446
                  ],
                  [
                    45947,
                    30405.5
                  ],
                  [
                    45639.2,
                    30451.9
                  ],
                  [
                    45577.1,
                    30669
                  ]
                ],
                "id": 82,
                "chat_link": "[&BFIAAAA=]"
              },
              "83": {
                "name": "Cereboth Canyon",
                "level": 20,
                "coord": [
                  45557,
                  31978.7
                ],
                "bounds": [
                  [
                    45520.8,
                    31196.5
                  ],
                  [
                    45329.1,
                    31507.1
                  ],
                  [
                    45232.3,
                    31573.4
                  ],
                  [
                    45219,
                    31738.3
                  ],
                  [
                    45368.3,
                    31829
                  ],
                  [
                    45226.5,
                    32145.9
                  ],
                  [
                    45379.5,
                    32388.4
                  ],
                  [
                    45428.7,
                    32480.5
                  ],
                  [
                    45525.2,
                    32578
                  ],
                  [
                    45719.3,
                    32550.4
                  ],
                  [
                    45909.5,
                    32500.8
                  ],
                  [
                    45748.7,
                    32325.8
                  ],
                  [
                    45683.8,
                    32254.5
                  ],
                  [
                    45873.6,
                    31829.2
                  ],
                  [
                    45898.9,
                    31470.5
                  ],
                  [
                    45849.4,
                    31290.9
                  ],
                  [
                    45520.8,
                    31196.5
                  ]
                ],
                "id": 83,
                "chat_link": "[&BFMAAAA=]"
              },
              "84": {
                "name": "Halacon Cataracts",
                "level": 23,
                "coord": [
                  42556.9,
                  30865.5
                ],
                "bounds": [
                  [
                    43047.6,
                    31207.3
                  ],
                  [
                    42597.9,
                    30969.5
                  ],
                  [
                    42462.8,
                    30974.9
                  ],
                  [
                    42305,
                    31126.9
                  ],
                  [
                    42153.9,
                    31014.6
                  ],
                  [
                    42164,
                    30827
                  ],
                  [
                    42166.5,
                    30627
                  ],
                  [
                    42263.3,
                    30521.3
                  ],
                  [
                    42528.2,
                    30509.2
                  ],
                  [
                    42733,
                    30761.6
                  ],
                  [
                    43068.2,
                    30753.9
                  ],
                  [
                    43192.8,
                    31093
                  ],
                  [
                    43047.6,
                    31207.3
                  ]
                ],
                "id": 84,
                "chat_link": "[&BFQAAAA=]"
              },
              "85": {
                "name": "Viath Shore",
                "level": 24,
                "coord": [
                  43041.7,
                  31641.6
                ],
                "bounds": [
                  [
                    43254.6,
                    32142.1
                  ],
                  [
                    43299.8,
                    31929.6
                  ],
                  [
                    43062.5,
                    31645.7
                  ],
                  [
                    43220.2,
                    31379.5
                  ],
                  [
                    43112.2,
                    31154.3
                  ],
                  [
                    43046.8,
                    31201.8
                  ],
                  [
                    43016,
                    31312.1
                  ],
                  [
                    42890.4,
                    31400.4
                  ],
                  [
                    42816.7,
                    31634.6
                  ],
                  [
                    42861,
                    31787.9
                  ],
                  [
                    42914.8,
                    32082.8
                  ],
                  [
                    43005.8,
                    32028
                  ],
                  [
                    43254.6,
                    32142.1
                  ]
                ],
                "id": 85,
                "chat_link": "[&BFUAAAA=]"
              },
              "86": {
                "name": "Sojourner's Way",
                "level": 15,
                "coord": [
                  45174.4,
                  30638.1
                ],
                "bounds": [
                  [
                    45621.2,
                    30832.1
                  ],
                  [
                    45577.9,
                    30670
                  ],
                  [
                    45641,
                    30452.5
                  ],
                  [
                    45560.2,
                    30414.4
                  ],
                  [
                    45356.7,
                    30456.5
                  ],
                  [
                    45073.4,
                    30450.4
                  ],
                  [
                    45001.6,
                    30402.2
                  ],
                  [
                    44903,
                    30440.5
                  ],
                  [
                    44729.4,
                    30443.9
                  ],
                  [
                    44638,
                    30900.2
                  ],
                  [
                    44714.8,
                    31011.5
                  ],
                  [
                    44954.3,
                    30763.5
                  ],
                  [
                    45192.5,
                    30762.8
                  ],
                  [
                    45477.2,
                    30932.9
                  ],
                  [
                    45621.2,
                    30832.1
                  ]
                ],
                "id": 86,
                "chat_link": "[&BFYAAAA=]"
              },
              "87": {
                "name": "Alakess Ledge",
                "level": 22,
                "coord": [
                  44238.9,
                  32351
                ],
                "bounds": [
                  [
                    44072,
                    32411.1
                  ],
                  [
                    43900.6,
                    32563.4
                  ],
                  [
                    43691,
                    32518.7
                  ],
                  [
                    43806.4,
                    32260.6
                  ],
                  [
                    44454.4,
                    32261.2
                  ],
                  [
                    44615,
                    32125.8
                  ],
                  [
                    44716.5,
                    32296
                  ],
                  [
                    44655.6,
                    32371.1
                  ],
                  [
                    44072,
                    32411.1
                  ]
                ],
                "id": 87,
                "chat_link": "[&BFcAAAA=]"
              },
              "88": {
                "name": "Darkwound Defile",
                "level": 18,
                "coord": [
                  46049.7,
                  31542.2
                ],
                "bounds": [
                  [
                    46124.1,
                    31851
                  ],
                  [
                    46199.7,
                    31666.2
                  ],
                  [
                    46198.3,
                    31577
                  ],
                  [
                    46111.1,
                    31409.2
                  ],
                  [
                    46142.8,
                    31245
                  ],
                  [
                    45848.9,
                    31288.5
                  ],
                  [
                    45898.2,
                    31472.4
                  ],
                  [
                    45874.4,
                    31828.5
                  ],
                  [
                    46124.1,
                    31851
                  ]
                ],
                "id": 88,
                "chat_link": "[&BFgAAAA=]"
              },
              "89": {
                "name": "Giant's Passage",
                "level": 20,
                "coord": [
                  44831.6,
                  31740.4
                ],
                "bounds": [
                  [
                    44714.3,
                    32296.6
                  ],
                  [
                    44616.2,
                    32125.7
                  ],
                  [
                    44702,
                    31929.7
                  ],
                  [
                    44599.1,
                    31793.8
                  ],
                  [
                    44628.5,
                    31586.7
                  ],
                  [
                    44753.7,
                    31476.6
                  ],
                  [
                    44881.5,
                    31493.4
                  ],
                  [
                    44969.9,
                    31389.8
                  ],
                  [
                    45232.5,
                    31574.2
                  ],
                  [
                    45218.6,
                    31737.5
                  ],
                  [
                    44714.3,
                    32296.6
                  ]
                ],
                "id": 89,
                "chat_link": "[&BFkAAAA=]"
              },
              "90": {
                "name": "Lychcroft Mere",
                "level": 22,
                "coord": [
                  42655.4,
                  32220.9
                ],
                "bounds": [
                  [
                    43382.8,
                    32519.4
                  ],
                  [
                    42159.2,
                    32552.1
                  ],
                  [
                    42055.5,
                    32447.9
                  ],
                  [
                    42000.3,
                    31986.5
                  ],
                  [
                    42048.6,
                    31873.9
                  ],
                  [
                    42471,
                    32113
                  ],
                  [
                    42754.3,
                    32173.8
                  ],
                  [
                    43006.3,
                    32028.3
                  ],
                  [
                    43258.1,
                    32135.6
                  ],
                  [
                    43418.3,
                    32378.6
                  ],
                  [
                    43382.8,
                    32519.4
                  ]
                ],
                "id": 90,
                "chat_link": "[&BFoAAAA=]"
              },
              "91": {
                "name": "Dominion Killing Zone",
                "level": 21,
                "coord": [
                  45098.7,
                  32221.2
                ],
                "bounds": [
                  [
                    45370,
                    31826.5
                  ],
                  [
                    45212.9,
                    31734.5
                  ],
                  [
                    44644.6,
                    32351.7
                  ],
                  [
                    44725.4,
                    32472
                  ],
                  [
                    44877.5,
                    32402.3
                  ],
                  [
                    45350.7,
                    32449.7
                  ],
                  [
                    45381.3,
                    32388
                  ],
                  [
                    45227.2,
                    32145
                  ],
                  [
                    45370,
                    31826.5
                  ]
                ],
                "id": 91,
                "chat_link": "[&BFsAAAA=]"
              },
              "92": {
                "name": "Wizard's Fief",
                "level": 19,
                "coord": [
                  46057.5,
                  32277.4
                ],
                "bounds": [
                  [
                    46130.3,
                    31848.2
                  ],
                  [
                    45873.9,
                    31829.2
                  ],
                  [
                    45681.7,
                    32253.6
                  ],
                  [
                    46163.9,
                    32808.2
                  ],
                  [
                    46437.7,
                    32647.9
                  ],
                  [
                    46130.3,
                    31848.2
                  ]
                ],
                "id": 92,
                "chat_link": "[&BFwAAAA=]"
              },
              "739": {
                "name": "Draithor's Demesnes",
                "level": 16,
                "coord": [
                  46063.3,
                  30982.4
                ],
                "bounds": [
                  [
                    46139.7,
                    30777.7
                  ],
                  [
                    46164.7,
                    30908
                  ],
                  [
                    46185.6,
                    31077.3
                  ],
                  [
                    46140.9,
                    31239.8
                  ],
                  [
                    46053.5,
                    31133
                  ],
                  [
                    45890,
                    30938.3
                  ],
                  [
                    45935.3,
                    30894.6
                  ],
                  [
                    45996.7,
                    30890.2
                  ],
                  [
                    46139.7,
                    30777.7
                  ]
                ],
                "id": 739,
                "chat_link": "[&BOMCAAA=]"
              }
            },
            "adventures": [],
            "id": 23,
            "mastery_points": []
          },
          "24": {
            "name": "Gendarran Fields",
            "min_level": 25,
            "max_level": 35,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {
              "119": {
                "name": "Melandru's Cenote",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46297.8,
                  30379.3
                ],
                "id": 119,
                "chat_link": "[&BHcAAAA=]"
              },
              "120": {
                "name": "Amaranth Grotto",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47403.4,
                  28893.4
                ],
                "id": 120,
                "chat_link": "[&BHgAAAA=]"
              },
              "121": {
                "name": "The Beastpool",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48009.4,
                  29066.3
                ],
                "id": 121,
                "chat_link": "[&BHkAAAA=]"
              },
              "122": {
                "name": "Stonefish Beach",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49391.1,
                  30213.7
                ],
                "id": 122,
                "chat_link": "[&BHoAAAA=]"
              },
              "123": {
                "name": "Wiley's Cove",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48989.3,
                  29170.5
                ],
                "id": 123,
                "chat_link": "[&BHsAAAA=]"
              },
              "124": {
                "name": "Vigil HQ",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49417.3,
                  28868.2
                ],
                "id": 124,
                "chat_link": "[&BHwAAAA=]"
              },
              "125": {
                "name": "Molenheide",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50000.5,
                  29598.7
                ],
                "id": 125,
                "chat_link": "[&BH0AAAA=]"
              },
              "126": {
                "name": "Almuten Mansion",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49381.4,
                  29894.5
                ],
                "id": 126,
                "chat_link": "[&BH4AAAA=]"
              },
              "223": {
                "name": "Traveler's Dale Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46449.5,
                  30416.7
                ],
                "id": 223,
                "chat_link": "[&BN8AAAA=]"
              },
              "224": {
                "name": "Stoneguard Gate Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46363.7,
                  29131.4
                ],
                "id": 224,
                "chat_link": "[&BOAAAAA=]"
              },
              "225": {
                "name": "Broadhollow Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48027,
                  30390
                ],
                "id": 225,
                "chat_link": "[&BOEAAAA=]"
              },
              "226": {
                "name": "Oogooth Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48089,
                  29884.4
                ],
                "id": 226,
                "chat_link": "[&BOIAAAA=]"
              },
              "227": {
                "name": "Cornucopian Fields Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48668.1,
                  30456
                ],
                "id": 227,
                "chat_link": "[&BOMAAAA=]"
              },
              "228": {
                "name": "Provern Shore Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48551.5,
                  28867.2
                ],
                "id": 228,
                "chat_link": "[&BOQAAAA=]"
              },
              "237": {
                "name": "Junction Haven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50046.1,
                  29938
                ],
                "id": 237,
                "chat_link": "[&BO0AAAA=]"
              },
              "238": {
                "name": "Winter Haven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50142.9,
                  29190.2
                ],
                "id": 238,
                "chat_link": "[&BO4AAAA=]"
              },
              "395": {
                "name": "First Haven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46693.6,
                  30206
                ],
                "id": 395,
                "chat_link": "[&BIsBAAA=]"
              },
              "396": {
                "name": "Talajian Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46734.4,
                  29727.6
                ],
                "id": 396,
                "chat_link": "[&BIwBAAA=]"
              },
              "397": {
                "name": "Blood Hill Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  47155.5,
                  28761.6
                ],
                "id": 397,
                "chat_link": "[&BI0BAAA=]"
              },
              "398": {
                "name": "Nebo Terrace Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  47004.9,
                  29558.9
                ],
                "id": 398,
                "chat_link": "[&BI4BAAA=]"
              },
              "399": {
                "name": "Ascalon Settlement Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  47695.4,
                  29692.5
                ],
                "id": 399,
                "chat_link": "[&BI8BAAA=]"
              },
              "400": {
                "name": "Northfields Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48224.9,
                  29350.5
                ],
                "id": 400,
                "chat_link": "[&BJABAAA=]"
              },
              "401": {
                "name": "Applenook Hamlet Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48875.6,
                  29957.1
                ],
                "id": 401,
                "chat_link": "[&BJEBAAA=]"
              },
              "402": {
                "name": "Vigil Keep Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49506.9,
                  28945.7
                ],
                "id": 402,
                "chat_link": "[&BJIBAAA=]"
              },
              "403": {
                "name": "Icegate Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49981.6,
                  30510.4
                ],
                "id": 403,
                "chat_link": "[&BJMBAAA=]"
              },
              "404": {
                "name": "Almuten Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49351.5,
                  29825.7
                ],
                "id": 404,
                "chat_link": "[&BJQBAAA=]"
              },
              "923": {
                "name": "Lionbridge Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  47324.9,
                  30117.2
                ],
                "id": 923,
                "chat_link": "[&BJsDAAA=]"
              },
              "946": {
                "name": "Bad Omen Beach",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47545.3,
                  30266.1
                ],
                "id": 946,
                "chat_link": "[&BLIDAAA=]"
              },
              "955": {
                "name": "Ambush Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46353.6,
                  29528.8
                ],
                "id": 955,
                "chat_link": "[&BLsDAAA=]"
              },
              "956": {
                "name": "Vollym's Battle Pit",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49834.2,
                  29062.4
                ],
                "id": 956,
                "chat_link": "[&BLwDAAA=]"
              },
              "957": {
                "name": "Jackdaw's Reef",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48726.5,
                  29400.5
                ],
                "id": 957,
                "chat_link": "[&BL0DAAA=]"
              },
              "958": {
                "name": "Slade's Bay",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48562.2,
                  29521.7
                ],
                "id": 958,
                "chat_link": "[&BL4DAAA=]"
              },
              "972": {
                "name": "Snowblind Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49697.7,
                  29287.1
                ],
                "id": 972,
                "chat_link": "[&BMwDAAA=]"
              },
              "973": {
                "name": "Brigantine Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48632.1,
                  29278
                ],
                "id": 973,
                "chat_link": "[&BM0DAAA=]"
              },
              "1024": {
                "name": "Mellaggan Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48263.3,
                  29625.5
                ],
                "id": 1024,
                "chat_link": "[&BAAEAAA=]"
              },
              "1026": {
                "name": "Bloodfields Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  47358.7,
                  29501
                ],
                "id": 1026,
                "chat_link": "[&BAIEAAA=]"
              },
              "1045": {
                "name": "Janusian Caves",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50283.9,
                  30224.1
                ],
                "id": 1045,
                "chat_link": "[&BBUEAAA=]"
              },
              "1512": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  47655.9,
                  29577.5
                ],
                "id": 1512,
                "chat_link": "[&BOgFAAA=]"
              },
              "1513": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  47912.6,
                  28792.4
                ],
                "id": 1513,
                "chat_link": "[&BOkFAAA=]"
              },
              "1514": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48634.2,
                  29977.3
                ],
                "id": 1514,
                "chat_link": "[&BOoFAAA=]"
              },
              "1515": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  49343.7,
                  29918.6
                ],
                "id": 1515,
                "chat_link": "[&BOsFAAA=]"
              },
              "1516": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  49694.5,
                  30300.5
                ],
                "id": 1516,
                "chat_link": "[&BOwFAAA=]"
              },
              "1517": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48447.3,
                  29559.9
                ],
                "id": 1517,
                "chat_link": "[&BO0FAAA=]"
              },
              "1518": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  49050,
                  29060.3
                ],
                "id": 1518,
                "chat_link": "[&BO4FAAA=]"
              },
              "1519": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  47028.5,
                  29713.4
                ],
                "id": 1519,
                "chat_link": "[&BO8FAAA=]"
              },
              "1528": {
                "name": "Quaggankeep Channel",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47874.7,
                  30106.1
                ],
                "id": 1528,
                "chat_link": "[&BPgFAAA=]"
              },
              "1809": {
                "name": "Second Aetherblade Site",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48071.4,
                  30685.8
                ],
                "id": 1809,
                "chat_link": "[&BBEHAAA=]"
              }
            },
            "tasks": {
              "229": {
                "objective": "Help First Haven's residents deal with the undead.",
                "level": 26,
                "coord": [
                  46680.5,
                  30234.5
                ],
                "bounds": [
                  [
                    46495,
                    30688.3
                  ],
                  [
                    46460.7,
                    30383.5
                  ],
                  [
                    46481.3,
                    30234.5
                  ],
                  [
                    46666.8,
                    30074.8
                  ],
                  [
                    47087.1,
                    30060.3
                  ],
                  [
                    47344.6,
                    30166.1
                  ],
                  [
                    47444.6,
                    30420.6
                  ],
                  [
                    47402.8,
                    30660.6
                  ],
                  [
                    46495,
                    30688.3
                  ]
                ],
                "id": 229,
                "chat_link": "[&BOUAAAA=]"
              },
              "231": {
                "objective": "Rescue fallen Seraph in the Bloodfields.",
                "level": 27,
                "coord": [
                  46778.1,
                  29544.2
                ],
                "bounds": [
                  [
                    46858.3,
                    29731
                  ],
                  [
                    46740.3,
                    29585.1
                  ],
                  [
                    46666.8,
                    29437.5
                  ],
                  [
                    46716,
                    29307.7
                  ],
                  [
                    46850.8,
                    29225.1
                  ],
                  [
                    46907.6,
                    29253.9
                  ],
                  [
                    47026.1,
                    29239.6
                  ],
                  [
                    47093.9,
                    29185.3
                  ],
                  [
                    47162,
                    29185.5
                  ],
                  [
                    47172.7,
                    29269.1
                  ],
                  [
                    47199.8,
                    29298.5
                  ],
                  [
                    47327.7,
                    29341.3
                  ],
                  [
                    47373.7,
                    29388.9
                  ],
                  [
                    47340.2,
                    29490.2
                  ],
                  [
                    47227.4,
                    29574.7
                  ],
                  [
                    47144.8,
                    29724.6
                  ],
                  [
                    47037.2,
                    29779.2
                  ],
                  [
                    46958,
                    29784
                  ],
                  [
                    46858.3,
                    29731
                  ]
                ],
                "id": 231,
                "chat_link": "[&BOcAAAA=]"
              },
              "232": {
                "objective": "Help Bronson disrupt centaur troops.",
                "level": 28,
                "coord": [
                  46909.7,
                  29178.5
                ],
                "bounds": [
                  [
                    46850.8,
                    29215.9
                  ],
                  [
                    46721.5,
                    29065.2
                  ],
                  [
                    46774.4,
                    28884.9
                  ],
                  [
                    46811.2,
                    28727.3
                  ],
                  [
                    47716.8,
                    28705.7
                  ],
                  [
                    47722.5,
                    28829.6
                  ],
                  [
                    47792.4,
                    28954.2
                  ],
                  [
                    47831.6,
                    28933.5
                  ],
                  [
                    47898.1,
                    28955.2
                  ],
                  [
                    47967.8,
                    28939.8
                  ],
                  [
                    48067.4,
                    29028.5
                  ],
                  [
                    48107,
                    29098.2
                  ],
                  [
                    48106.7,
                    29200.6
                  ],
                  [
                    48011.8,
                    29262.3
                  ],
                  [
                    47908.7,
                    29314.4
                  ],
                  [
                    47807.1,
                    29285.6
                  ],
                  [
                    47792.6,
                    29232.9
                  ],
                  [
                    47759,
                    29156.1
                  ],
                  [
                    47664.6,
                    29145.9
                  ],
                  [
                    47665.6,
                    29167.4
                  ],
                  [
                    47610.4,
                    29206.2
                  ],
                  [
                    47522.8,
                    29220.4
                  ],
                  [
                    47491.3,
                    29202.1
                  ],
                  [
                    47450.5,
                    29222.8
                  ],
                  [
                    47435,
                    29275.9
                  ],
                  [
                    47385.4,
                    29292.4
                  ],
                  [
                    47338.5,
                    29319.5
                  ],
                  [
                    47263.9,
                    29294
                  ],
                  [
                    47215.1,
                    29298
                  ],
                  [
                    47177.2,
                    29284.8
                  ],
                  [
                    47171.8,
                    29260.3
                  ],
                  [
                    47203.2,
                    29212.2
                  ],
                  [
                    47185.2,
                    29152
                  ],
                  [
                    47151.2,
                    29124.6
                  ],
                  [
                    47116.1,
                    29136.2
                  ],
                  [
                    47074.1,
                    29171.9
                  ],
                  [
                    47052.8,
                    29185.4
                  ],
                  [
                    47044.4,
                    29225.3
                  ],
                  [
                    47022.3,
                    29231.9
                  ],
                  [
                    46967.3,
                    29245.1
                  ],
                  [
                    46897.2,
                    29251.4
                  ],
                  [
                    46870.2,
                    29237
                  ],
                  [
                    46850.8,
                    29215.9
                  ]
                ],
                "id": 232,
                "chat_link": "[&BOgAAAA=]"
              },
              "234": {
                "objective": "Get back at the pirates for Joukje.",
                "level": 31,
                "coord": [
                  48503.7,
                  29572.4
                ],
                "bounds": [
                  [
                    48405.5,
                    29575.5
                  ],
                  [
                    48700.4,
                    29644
                  ],
                  [
                    48811.3,
                    29645.4
                  ],
                  [
                    48924.8,
                    29498.6
                  ],
                  [
                    48848.5,
                    29383.9
                  ],
                  [
                    48629.6,
                    29179.7
                  ],
                  [
                    48537.2,
                    29176.9
                  ],
                  [
                    48466.4,
                    29297.5
                  ],
                  [
                    48405.5,
                    29575.5
                  ]
                ],
                "id": 234,
                "chat_link": "[&BOoAAAA=]"
              },
              "236": {
                "objective": "Help Milton Book and local farmers with their pirate and pest problems.",
                "level": 30,
                "coord": [
                  48549.1,
                  30135.3
                ],
                "bounds": [
                  [
                    48364.8,
                    30010.1
                  ],
                  [
                    48601.3,
                    29863.1
                  ],
                  [
                    48897.6,
                    29828.7
                  ],
                  [
                    49031.2,
                    29928
                  ],
                  [
                    48999.8,
                    30153.9
                  ],
                  [
                    49010.6,
                    30301.9
                  ],
                  [
                    48947,
                    30411.5
                  ],
                  [
                    48850.3,
                    30452.4
                  ],
                  [
                    48285.6,
                    30306.6
                  ],
                  [
                    48253.3,
                    30182.4
                  ],
                  [
                    48364.8,
                    30010.1
                  ]
                ],
                "id": 236,
                "chat_link": "[&BOwAAAA=]"
              },
              "239": {
                "objective": "Support the troops stationed at Ascalon Settlement.",
                "level": 29,
                "coord": [
                  47643.8,
                  29732.2
                ],
                "bounds": [
                  [
                    47616.3,
                    29448.6
                  ],
                  [
                    47830.3,
                    29438.2
                  ],
                  [
                    47899.1,
                    29500.5
                  ],
                  [
                    48027.5,
                    29673.1
                  ],
                  [
                    48009.6,
                    29885
                  ],
                  [
                    47874.3,
                    30127
                  ],
                  [
                    47592.4,
                    30129.8
                  ],
                  [
                    47476.4,
                    29971.1
                  ],
                  [
                    47447.4,
                    29890
                  ],
                  [
                    47484.8,
                    29631.8
                  ],
                  [
                    47393.4,
                    29617.8
                  ],
                  [
                    47398.7,
                    29570.4
                  ],
                  [
                    47498.4,
                    29565.3
                  ],
                  [
                    47616.3,
                    29448.6
                  ]
                ],
                "id": 239,
                "chat_link": "[&BO8AAAA=]"
              },
              "241": {
                "objective": "Help Lionguard Rhyn drive the dredge away from Junction Haven.",
                "level": 27,
                "coord": [
                  50096.1,
                  29642.9
                ],
                "bounds": [
                  [
                    49820.6,
                    29434.9
                  ],
                  [
                    50177,
                    29403
                  ],
                  [
                    50154.8,
                    29603.3
                  ],
                  [
                    50123.1,
                    29720.6
                  ],
                  [
                    50075.9,
                    29803.6
                  ],
                  [
                    50063.6,
                    29957.4
                  ],
                  [
                    49887.4,
                    30011.4
                  ],
                  [
                    49783.5,
                    29878.1
                  ],
                  [
                    49730.3,
                    29673.7
                  ],
                  [
                    49820.6,
                    29434.9
                  ]
                ],
                "id": 241,
                "chat_link": "[&BPEAAAA=]"
              },
              "242": {
                "objective": "Assist the Lionguard and protect Junction Haven.",
                "level": 28,
                "coord": [
                  50041.1,
                  30031
                ],
                "bounds": [
                  [
                    50006.4,
                    30267.4
                  ],
                  [
                    49891.1,
                    30235.2
                  ],
                  [
                    49914.7,
                    30070.1
                  ],
                  [
                    49945.2,
                    29983.9
                  ],
                  [
                    50075.3,
                    29959.3
                  ],
                  [
                    50125,
                    30048.1
                  ],
                  [
                    50186.3,
                    30146.9
                  ],
                  [
                    50319.9,
                    30111.8
                  ],
                  [
                    50390.4,
                    30284.3
                  ],
                  [
                    50172.7,
                    30337.9
                  ],
                  [
                    50074.6,
                    30313.4
                  ],
                  [
                    50006.4,
                    30267.4
                  ]
                ],
                "id": 242,
                "chat_link": "[&BPIAAAA=]"
              },
              "243": {
                "objective": "Help Johan with his training duties at Vollym's battle pit.",
                "level": 26,
                "coord": [
                  49858.3,
                  29188.5
                ],
                "bounds": [
                  [
                    49969.1,
                    28932.1
                  ],
                  [
                    49930.8,
                    28903.2
                  ],
                  [
                    49850,
                    28905.9
                  ],
                  [
                    49793.1,
                    28895.2
                  ],
                  [
                    49734.1,
                    28908.2
                  ],
                  [
                    49691.4,
                    29093.3
                  ],
                  [
                    49649.6,
                    29202.2
                  ],
                  [
                    49749.4,
                    29300.8
                  ],
                  [
                    49835.1,
                    29320.3
                  ],
                  [
                    49870.1,
                    29314.8
                  ],
                  [
                    49912.7,
                    29285.2
                  ],
                  [
                    49967.5,
                    29220.4
                  ],
                  [
                    50039.9,
                    29153.1
                  ],
                  [
                    49969.1,
                    28932.1
                  ]
                ],
                "id": 243,
                "chat_link": "[&BPMAAAA=]"
              },
              "244": {
                "objective": "Help Mei Shadowwalker reclaim the Wiley pirates' stolen treasure.",
                "level": 32,
                "coord": [
                  48799.5,
                  29079.3
                ],
                "bounds": [
                  [
                    48584,
                    28952.8
                  ],
                  [
                    48624.4,
                    29081.7
                  ],
                  [
                    49036.7,
                    29612.6
                  ],
                  [
                    49174.8,
                    29639.6
                  ],
                  [
                    49263.6,
                    29562.2
                  ],
                  [
                    49218.1,
                    29410.7
                  ],
                  [
                    48989.4,
                    29054.1
                  ],
                  [
                    48883.9,
                    28909.5
                  ],
                  [
                    48709.8,
                    28902
                  ],
                  [
                    48647.7,
                    28909.5
                  ],
                  [
                    48584,
                    28952.8
                  ]
                ],
                "id": 244,
                "chat_link": "[&BPQAAAA=]"
              },
              "245": {
                "objective": "Maintain security around Almuten Mansion.",
                "level": 29,
                "coord": [
                  49388.3,
                  29919.6
                ],
                "bounds": [
                  [
                    49502.2,
                    29758.1
                  ],
                  [
                    49528.9,
                    29803
                  ],
                  [
                    49552.8,
                    29857.9
                  ],
                  [
                    49509.9,
                    29923.1
                  ],
                  [
                    49446.9,
                    29964.1
                  ],
                  [
                    49372.3,
                    30026.1
                  ],
                  [
                    49297.5,
                    30013.4
                  ],
                  [
                    49246.1,
                    29987.7
                  ],
                  [
                    49210,
                    29925.7
                  ],
                  [
                    49274,
                    29835.3
                  ],
                  [
                    49318.3,
                    29768.2
                  ],
                  [
                    49332.6,
                    29752.1
                  ],
                  [
                    49395.2,
                    29719
                  ],
                  [
                    49447.4,
                    29706.3
                  ],
                  [
                    49481.5,
                    29727
                  ],
                  [
                    49502.2,
                    29758.1
                  ]
                ],
                "id": 245,
                "chat_link": "[&BPUAAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  50307.1,
                  30255.4
                ],
                "id": "0-60"
              },
              {
                "coord": [
                  48683.2,
                  29643.3
                ],
                "id": "0-156"
              },
              {
                "coord": [
                  46435.4,
                  28737
                ],
                "id": "0-154"
              },
              {
                "coord": [
                  48169.5,
                  29750.3
                ],
                "id": "0-155"
              },
              {
                "coord": [
                  49305.2,
                  28956.8
                ],
                "id": "0-153"
              },
              {
                "coord": [
                  46333.7,
                  30370.7
                ],
                "id": "0-206"
              },
              {
                "coord": [
                  47136.6,
                  29954.1
                ],
                "id": "0-55"
              }
            ],
            "sectors": {
              "244": {
                "name": "Traveler's Dale",
                "level": 26,
                "coord": [
                  46453.8,
                  30349.3
                ],
                "bounds": [
                  [
                    46264.8,
                    30594.1
                  ],
                  [
                    46442,
                    30536.7
                  ],
                  [
                    46708.3,
                    30381.3
                  ],
                  [
                    46785,
                    30297
                  ],
                  [
                    46743.3,
                    30163.7
                  ],
                  [
                    46630.5,
                    30092.2
                  ],
                  [
                    46426.6,
                    30048.8
                  ],
                  [
                    46387.5,
                    30318.8
                  ],
                  [
                    46373.8,
                    30434.5
                  ],
                  [
                    46143.6,
                    30447.3
                  ],
                  [
                    46086.6,
                    30527.7
                  ],
                  [
                    46264.8,
                    30594.1
                  ]
                ],
                "id": 244,
                "chat_link": "[&BPQAAAA=]"
              },
              "245": {
                "name": "Stonebore Vaults",
                "level": 27,
                "coord": [
                  46305.9,
                  29856.4
                ],
                "bounds": [
                  [
                    46103.2,
                    29473.2
                  ],
                  [
                    46173.2,
                    29227
                  ],
                  [
                    46280.8,
                    29223.3
                  ],
                  [
                    46349.3,
                    29276.9
                  ],
                  [
                    46673,
                    29610.9
                  ],
                  [
                    46668.8,
                    29738.8
                  ],
                  [
                    46424.3,
                    29981
                  ],
                  [
                    46429.6,
                    30051
                  ],
                  [
                    46387.7,
                    30319.5
                  ],
                  [
                    46375.5,
                    30433.1
                  ],
                  [
                    46143.3,
                    30451.3
                  ],
                  [
                    46177.9,
                    30309.4
                  ],
                  [
                    46130.4,
                    30116.8
                  ],
                  [
                    46168.1,
                    29929.1
                  ],
                  [
                    46104.3,
                    29704.5
                  ],
                  [
                    46103.2,
                    29473.2
                  ]
                ],
                "id": 245,
                "chat_link": "[&BPUAAAA=]"
              },
              "246": {
                "name": "Guardian's Pass",
                "level": 27,
                "coord": [
                  46453.5,
                  29264.3
                ],
                "bounds": [
                  [
                    46675.1,
                    29614.1
                  ],
                  [
                    46774.2,
                    29596.3
                  ],
                  [
                    46795.7,
                    29506.6
                  ],
                  [
                    46783.9,
                    29191.9
                  ],
                  [
                    46384.9,
                    29005.9
                  ],
                  [
                    46193,
                    28872.1
                  ],
                  [
                    46124.4,
                    29127.8
                  ],
                  [
                    46171.8,
                    29228.7
                  ],
                  [
                    46281.5,
                    29222.9
                  ],
                  [
                    46350.5,
                    29277
                  ],
                  [
                    46675.1,
                    29614.1
                  ]
                ],
                "id": 246,
                "chat_link": "[&BPYAAAA=]"
              },
              "247": {
                "name": "Hezran Outcrops",
                "level": 28,
                "coord": [
                  46506.3,
                  28824.9
                ],
                "bounds": [
                  [
                    46193.7,
                    28871.5
                  ],
                  [
                    46159.2,
                    28727.9
                  ],
                  [
                    46237.5,
                    28633.4
                  ],
                  [
                    46518.6,
                    28603.7
                  ],
                  [
                    46826.6,
                    28664.2
                  ],
                  [
                    46947.2,
                    28900.2
                  ],
                  [
                    46782.9,
                    29192.2
                  ],
                  [
                    46385,
                    29006.3
                  ],
                  [
                    46193.7,
                    28871.5
                  ]
                ],
                "id": 247,
                "chat_link": "[&BPcAAAA=]"
              },
              "248": {
                "name": "Blood Hill Camps",
                "level": 28,
                "coord": [
                  47381.1,
                  28949.8
                ],
                "bounds": [
                  [
                    47249.8,
                    29258
                  ],
                  [
                    47365.3,
                    29396.9
                  ],
                  [
                    47524.1,
                    29349.6
                  ],
                  [
                    47556.3,
                    29234.5
                  ],
                  [
                    47628.6,
                    29209
                  ],
                  [
                    47649.2,
                    29045.5
                  ],
                  [
                    47746.4,
                    28891.6
                  ],
                  [
                    47739.4,
                    28829.7
                  ],
                  [
                    47843.6,
                    28807.7
                  ],
                  [
                    47787.7,
                    28600.3
                  ],
                  [
                    47280.4,
                    28627.4
                  ],
                  [
                    47119.5,
                    28592.9
                  ],
                  [
                    47045,
                    28591.8
                  ],
                  [
                    46831.9,
                    28669.3
                  ],
                  [
                    46946.2,
                    28899.8
                  ],
                  [
                    46783.8,
                    29193.2
                  ],
                  [
                    47249.8,
                    29258
                  ]
                ],
                "id": 248,
                "chat_link": "[&BPgAAAA=]"
              },
              "249": {
                "name": "The Bloodfields",
                "level": 29,
                "coord": [
                  47167.5,
                  29467.6
                ],
                "bounds": [
                  [
                    47251.3,
                    29258.3
                  ],
                  [
                    47366.3,
                    29396.8
                  ],
                  [
                    47432.6,
                    29560.1
                  ],
                  [
                    47421,
                    29650.3
                  ],
                  [
                    47218.8,
                    29705.5
                  ],
                  [
                    47072.1,
                    29467.1
                  ],
                  [
                    46795.2,
                    29509.3
                  ],
                  [
                    46782.6,
                    29193.1
                  ],
                  [
                    47251.3,
                    29258.3
                  ]
                ],
                "id": 249,
                "chat_link": "[&BPkAAAA=]"
              },
              "250": {
                "name": "Nebo Terrace",
                "level": 28,
                "coord": [
                  46956.7,
                  29676
                ],
                "bounds": [
                  [
                    46803.5,
                    29720.6
                  ],
                  [
                    46938.3,
                    29865.8
                  ],
                  [
                    47097.3,
                    29868.8
                  ],
                  [
                    47217.8,
                    29704.8
                  ],
                  [
                    47073.3,
                    29466.9
                  ],
                  [
                    46792.7,
                    29508
                  ],
                  [
                    46774,
                    29597.4
                  ],
                  [
                    46803.5,
                    29720.6
                  ]
                ],
                "id": 250,
                "chat_link": "[&BPoAAAA=]"
              },
              "251": {
                "name": "Talajian Piedmont",
                "level": 26,
                "coord": [
                  46802.4,
                  29948.3
                ],
                "bounds": [
                  [
                    46424.6,
                    29980.5
                  ],
                  [
                    46668.7,
                    29738.1
                  ],
                  [
                    46674.8,
                    29614.7
                  ],
                  [
                    46773.9,
                    29595.7
                  ],
                  [
                    46805.1,
                    29719.5
                  ],
                  [
                    46938.8,
                    29864.9
                  ],
                  [
                    47100.7,
                    29869.4
                  ],
                  [
                    47162.3,
                    29976.3
                  ],
                  [
                    47166.3,
                    30157.5
                  ],
                  [
                    46951.2,
                    30158.1
                  ],
                  [
                    46779.4,
                    30293.5
                  ],
                  [
                    46737.5,
                    30168.9
                  ],
                  [
                    46625.6,
                    30092.3
                  ],
                  [
                    46424.3,
                    30046.5
                  ],
                  [
                    46424.6,
                    29980.5
                  ]
                ],
                "id": 251,
                "chat_link": "[&BPsAAAA=]"
              },
              "252": {
                "name": "The Lawen Ponds",
                "level": 26,
                "coord": [
                  46865.1,
                  30474.5
                ],
                "bounds": [
                  [
                    46401.4,
                    30686.6
                  ],
                  [
                    46605.5,
                    30634.3
                  ],
                  [
                    47184.1,
                    30609.5
                  ],
                  [
                    47374.1,
                    30646.1
                  ],
                  [
                    47571.1,
                    30559.5
                  ],
                  [
                    47440.2,
                    30249.1
                  ],
                  [
                    47210.5,
                    30156.4
                  ],
                  [
                    46950.8,
                    30157.9
                  ],
                  [
                    46780.5,
                    30295.8
                  ],
                  [
                    46708.1,
                    30378.5
                  ],
                  [
                    46443.3,
                    30534.2
                  ],
                  [
                    46263.7,
                    30592.3
                  ],
                  [
                    46313.5,
                    30668.1
                  ],
                  [
                    46401.4,
                    30686.6
                  ]
                ],
                "id": 252,
                "chat_link": "[&BPwAAAA=]"
              },
              "253": {
                "name": "Lionbridge Expanse",
                "level": 28,
                "coord": [
                  47455,
                  30117.2
                ],
                "bounds": [
                  [
                    47210.2,
                    30156
                  ],
                  [
                    47439.8,
                    30250.6
                  ],
                  [
                    47568.1,
                    30567.4
                  ],
                  [
                    47622.7,
                    30622.7
                  ],
                  [
                    47657.1,
                    30619.4
                  ],
                  [
                    47688.2,
                    30427.9
                  ],
                  [
                    47648.5,
                    30314.4
                  ],
                  [
                    47610.8,
                    30268.5
                  ],
                  [
                    47749.3,
                    30107.3
                  ],
                  [
                    47484.5,
                    30002.3
                  ],
                  [
                    47437.9,
                    29901.9
                  ],
                  [
                    47498.1,
                    29865.6
                  ],
                  [
                    47507.2,
                    29648.5
                  ],
                  [
                    47421,
                    29651.6
                  ],
                  [
                    47218.8,
                    29705.2
                  ],
                  [
                    47097.1,
                    29869.5
                  ],
                  [
                    47162.2,
                    29974.8
                  ],
                  [
                    47167.9,
                    30155.4
                  ],
                  [
                    47210.2,
                    30156
                  ]
                ],
                "id": 253,
                "chat_link": "[&BP0AAAA=]"
              },
              "254": {
                "name": "Ascalon Settlement",
                "level": 29,
                "coord": [
                  47646.4,
                  29767.7
                ],
                "bounds": [
                  [
                    47433,
                    29560.1
                  ],
                  [
                    47511.6,
                    29555.3
                  ],
                  [
                    47734.5,
                    29389.3
                  ],
                  [
                    48037.4,
                    29607.7
                  ],
                  [
                    48012.3,
                    29900
                  ],
                  [
                    47926.5,
                    30024
                  ],
                  [
                    47748.2,
                    30108.4
                  ],
                  [
                    47485.3,
                    30001
                  ],
                  [
                    47439,
                    29900.8
                  ],
                  [
                    47499,
                    29865.5
                  ],
                  [
                    47508.5,
                    29648.5
                  ],
                  [
                    47421.4,
                    29651.3
                  ],
                  [
                    47433,
                    29560.1
                  ]
                ],
                "id": 254,
                "chat_link": "[&BP4AAAA=]"
              },
              "255": {
                "name": "Northfields",
                "level": 29,
                "coord": [
                  47965.4,
                  29170.1
                ],
                "bounds": [
                  [
                    48036.6,
                    29607.5
                  ],
                  [
                    48291.5,
                    29408.4
                  ],
                  [
                    48228.8,
                    29268.7
                  ],
                  [
                    48275.8,
                    29091.4
                  ],
                  [
                    48002.1,
                    28775.3
                  ],
                  [
                    47886.3,
                    28923.8
                  ],
                  [
                    47779.8,
                    28936.6
                  ],
                  [
                    47814.7,
                    29057.6
                  ],
                  [
                    47756.8,
                    29173.8
                  ],
                  [
                    47812.2,
                    29238
                  ],
                  [
                    47735.3,
                    29390.2
                  ],
                  [
                    48036.6,
                    29607.5
                  ]
                ],
                "id": 255,
                "chat_link": "[&BP8AAAA=]"
              },
              "256": {
                "name": "Provern Shore",
                "level": 32,
                "coord": [
                  48556,
                  28887.1
                ],
                "bounds": [
                  [
                    48078.6,
                    28867.3
                  ],
                  [
                    48275.3,
                    29091.4
                  ],
                  [
                    48397,
                    28943.1
                  ],
                  [
                    48590.5,
                    28957.3
                  ],
                  [
                    48636.1,
                    29122.1
                  ],
                  [
                    48793.1,
                    29207.7
                  ],
                  [
                    48926.3,
                    29053.1
                  ],
                  [
                    48860.2,
                    28766
                  ],
                  [
                    48876.2,
                    28634.8
                  ],
                  [
                    48535.9,
                    28630.1
                  ],
                  [
                    48463.8,
                    28660.6
                  ],
                  [
                    48454.1,
                    28739.2
                  ],
                  [
                    48341.2,
                    28859.4
                  ],
                  [
                    48078.6,
                    28867.3
                  ]
                ],
                "id": 256,
                "chat_link": "[&BAABAAA=]"
              },
              "257": {
                "name": "Lake Gendarr",
                "level": 32,
                "coord": [
                  48617.2,
                  29472
                ],
                "bounds": [
                  [
                    48291.8,
                    29409.3
                  ],
                  [
                    48228.5,
                    29268.8
                  ],
                  [
                    48277.1,
                    29092.8
                  ],
                  [
                    48397,
                    28943.5
                  ],
                  [
                    48591.1,
                    28956.6
                  ],
                  [
                    48644,
                    29118.1
                  ],
                  [
                    48794,
                    29200.4
                  ],
                  [
                    48687.9,
                    29211.6
                  ],
                  [
                    48541.4,
                    29176.6
                  ],
                  [
                    48419.9,
                    29471.2
                  ],
                  [
                    48441,
                    29565.3
                  ],
                  [
                    48770.7,
                    29660.2
                  ],
                  [
                    48868.6,
                    29581.3
                  ],
                  [
                    48687.5,
                    29211.5
                  ],
                  [
                    48792.3,
                    29200
                  ],
                  [
                    48849.3,
                    29134.9
                  ],
                  [
                    48925.7,
                    29332.6
                  ],
                  [
                    49030.2,
                    29425.4
                  ],
                  [
                    49174.9,
                    29648.6
                  ],
                  [
                    49148.8,
                    29769.1
                  ],
                  [
                    49072,
                    29814
                  ],
                  [
                    48940.3,
                    29688.5
                  ],
                  [
                    48846.8,
                    29701.7
                  ],
                  [
                    48691.8,
                    29840
                  ],
                  [
                    48380.1,
                    29857.5
                  ],
                  [
                    48269,
                    29955.4
                  ],
                  [
                    48086.2,
                    29945.4
                  ],
                  [
                    48013.3,
                    29900.8
                  ],
                  [
                    48036.8,
                    29608
                  ],
                  [
                    48291.8,
                    29409.3
                  ]
                ],
                "id": 257,
                "chat_link": "[&BAEBAAA=]"
              },
              "258": {
                "name": "Broadhollow Bluffs",
                "level": 29,
                "coord": [
                  47923.4,
                  30319.7
                ],
                "bounds": [
                  [
                    47656,
                    30620.2
                  ],
                  [
                    47702.6,
                    30738
                  ],
                  [
                    47835.6,
                    30777.2
                  ],
                  [
                    48210,
                    30760.6
                  ],
                  [
                    48309.1,
                    30364.7
                  ],
                  [
                    48222.5,
                    30266.3
                  ],
                  [
                    48269.3,
                    29955.6
                  ],
                  [
                    48089.6,
                    29947.6
                  ],
                  [
                    48009.8,
                    29902
                  ],
                  [
                    47926,
                    30024.7
                  ],
                  [
                    47749.1,
                    30107.7
                  ],
                  [
                    47611.7,
                    30267.3
                  ],
                  [
                    47649.5,
                    30316.5
                  ],
                  [
                    47687.3,
                    30428
                  ],
                  [
                    47656,
                    30620.2
                  ]
                ],
                "id": 258,
                "chat_link": "[&BAIBAAA=]"
              },
              "259": {
                "name": "Cornucopian Fields",
                "level": 30,
                "coord": [
                  48795.6,
                  30295.1
                ],
                "bounds": [
                  [
                    48209,
                    30758.8
                  ],
                  [
                    48562,
                    30773.8
                  ],
                  [
                    48775.2,
                    30765
                  ],
                  [
                    48811.6,
                    30734.8
                  ],
                  [
                    49331.8,
                    30790.3
                  ],
                  [
                    49414.7,
                    30633.4
                  ],
                  [
                    49352.5,
                    30429.6
                  ],
                  [
                    49259.9,
                    30452.6
                  ],
                  [
                    49081.5,
                    30191.9
                  ],
                  [
                    49069.8,
                    29808.5
                  ],
                  [
                    48940.2,
                    29689
                  ],
                  [
                    48847,
                    29703.6
                  ],
                  [
                    48690.3,
                    29841
                  ],
                  [
                    48380.1,
                    29858.7
                  ],
                  [
                    48270.2,
                    29956.3
                  ],
                  [
                    48222,
                    30265.8
                  ],
                  [
                    48307.9,
                    30363.8
                  ],
                  [
                    48209,
                    30758.8
                  ]
                ],
                "id": 259,
                "chat_link": "[&BAMBAAA=]"
              },
              "260": {
                "name": "Vigilant Hills",
                "level": 29,
                "coord": [
                  49239.9,
                  29137.1
                ],
                "bounds": [
                  [
                    48891.3,
                    28906.3
                  ],
                  [
                    49581.1,
                    28946.2
                  ],
                  [
                    49524.2,
                    29217.3
                  ],
                  [
                    49553.5,
                    29367.6
                  ],
                  [
                    49180.3,
                    29417.3
                  ],
                  [
                    49021.3,
                    29052.4
                  ],
                  [
                    48927.5,
                    29052.3
                  ],
                  [
                    48891.3,
                    28906.3
                  ]
                ],
                "id": 260,
                "chat_link": "[&BAQBAAA=]"
              },
              "261": {
                "name": "Newbeach Bluffs",
                "level": 32,
                "coord": [
                  49212.3,
                  29471.9
                ],
                "bounds": [
                  [
                    48927.3,
                    29051.9
                  ],
                  [
                    49022,
                    29050.5
                  ],
                  [
                    49182.2,
                    29416
                  ],
                  [
                    49552.9,
                    29368.2
                  ],
                  [
                    49703.9,
                    29568
                  ],
                  [
                    49723.1,
                    29689.8
                  ],
                  [
                    49357.1,
                    29663
                  ],
                  [
                    49202.3,
                    29836.5
                  ],
                  [
                    49143.5,
                    29770.2
                  ],
                  [
                    49174.1,
                    29650.3
                  ],
                  [
                    49175.7,
                    29649.7
                  ],
                  [
                    49032.1,
                    29424.9
                  ],
                  [
                    48925.8,
                    29333.5
                  ],
                  [
                    48850.1,
                    29133.6
                  ],
                  [
                    48927.3,
                    29051.9
                  ]
                ],
                "id": 261,
                "chat_link": "[&BAUBAAA=]"
              },
              "262": {
                "name": "Lake Bounty",
                "level": 29,
                "coord": [
                  49343.6,
                  30352.6
                ],
                "bounds": [
                  [
                    49352.4,
                    30428.8
                  ],
                  [
                    49415,
                    30634.1
                  ],
                  [
                    49330.9,
                    30792.3
                  ],
                  [
                    49802.7,
                    30799.2
                  ],
                  [
                    49633.5,
                    30299.7
                  ],
                  [
                    49147.5,
                    29765.4
                  ],
                  [
                    49069.8,
                    29807.9
                  ],
                  [
                    49081.8,
                    30193.3
                  ],
                  [
                    49259,
                    30452.5
                  ],
                  [
                    49352.4,
                    30428.8
                  ]
                ],
                "id": 262,
                "chat_link": "[&BAYBAAA=]"
              },
              "263": {
                "name": "Overlook Caverns",
                "level": 28,
                "coord": [
                  49866.8,
                  30273.5
                ],
                "bounds": [
                  [
                    49704,
                    30515.9
                  ],
                  [
                    49880.2,
                    30382.3
                  ],
                  [
                    50081.3,
                    30318.7
                  ],
                  [
                    50044.2,
                    30157.5
                  ],
                  [
                    49873.7,
                    30037.7
                  ],
                  [
                    49849.4,
                    30201.9
                  ],
                  [
                    49634.5,
                    30300.5
                  ],
                  [
                    49704,
                    30515.9
                  ]
                ],
                "id": 263,
                "chat_link": "[&BAcBAAA=]"
              },
              "264": {
                "name": "Almuten Estates",
                "level": 29,
                "coord": [
                  49606,
                  29954.8
                ],
                "bounds": [
                  [
                    49635,
                    30302
                  ],
                  [
                    49849,
                    30203.7
                  ],
                  [
                    49874.2,
                    30037.3
                  ],
                  [
                    49721.6,
                    29692.1
                  ],
                  [
                    49357.1,
                    29665.1
                  ],
                  [
                    49199.2,
                    29828.6
                  ],
                  [
                    49635,
                    30302
                  ]
                ],
                "id": 264,
                "chat_link": "[&BAgBAAA=]"
              },
              "265": {
                "name": "Shiverspur Front",
                "level": 27,
                "coord": [
                  50150.7,
                  29804.4
                ],
                "bounds": [
                  [
                    50043.8,
                    30156.7
                  ],
                  [
                    50208.1,
                    30137.2
                  ],
                  [
                    50441.3,
                    30091.2
                  ],
                  [
                    50518.5,
                    30000.5
                  ],
                  [
                    50464.7,
                    29904.1
                  ],
                  [
                    50507.2,
                    29756
                  ],
                  [
                    50470.9,
                    29456.9
                  ],
                  [
                    49976.7,
                    29475.9
                  ],
                  [
                    49875.2,
                    29381.1
                  ],
                  [
                    49703.6,
                    29568.2
                  ],
                  [
                    49723.8,
                    29688.3
                  ],
                  [
                    49874.3,
                    30037.3
                  ],
                  [
                    50043.8,
                    30156.7
                  ]
                ],
                "id": 265,
                "chat_link": "[&BAkBAAA=]"
              },
              "266": {
                "name": "Snowblind Peaks",
                "level": 27,
                "coord": [
                  49741.2,
                  29105.2
                ],
                "bounds": [
                  [
                    49703.3,
                    29567.2
                  ],
                  [
                    49872.5,
                    29379.1
                  ],
                  [
                    49819.6,
                    29225.9
                  ],
                  [
                    49922.3,
                    29082.2
                  ],
                  [
                    49893.1,
                    28504
                  ],
                  [
                    49641.5,
                    28497.9
                  ],
                  [
                    49524.3,
                    29217.1
                  ],
                  [
                    49552.7,
                    29368.1
                  ],
                  [
                    49703.3,
                    29567.2
                  ]
                ],
                "id": 266,
                "chat_link": "[&BAoBAAA=]"
              },
              "267": {
                "name": "Bitterfrost Peaks",
                "level": 26,
                "coord": [
                  50168.3,
                  29000.5
                ],
                "bounds": [
                  [
                    49979.2,
                    29472.1
                  ],
                  [
                    50474.1,
                    29458.4
                  ],
                  [
                    50428,
                    29215.2
                  ],
                  [
                    50473,
                    29078.8
                  ],
                  [
                    50545,
                    28626.9
                  ],
                  [
                    50324,
                    28424.5
                  ],
                  [
                    50126.5,
                    28509.5
                  ],
                  [
                    49884.4,
                    28527.8
                  ],
                  [
                    49921.7,
                    29083
                  ],
                  [
                    49817.5,
                    29226.8
                  ],
                  [
                    49877.8,
                    29382.6
                  ],
                  [
                    49979.2,
                    29472.1
                  ]
                ],
                "id": 267,
                "chat_link": "[&BAsBAAA=]"
              },
              "268": {
                "name": "Icegate Gorge",
                "level": 28,
                "coord": [
                  50148.1,
                  30458.7
                ],
                "bounds": [
                  [
                    49705.6,
                    30518.5
                  ],
                  [
                    49880.1,
                    30382.5
                  ],
                  [
                    50080,
                    30317.5
                  ],
                  [
                    50044.1,
                    30155.4
                  ],
                  [
                    50208,
                    30137.5
                  ],
                  [
                    50442.4,
                    30096.9
                  ],
                  [
                    50539.5,
                    30567.6
                  ],
                  [
                    50466.1,
                    30756.4
                  ],
                  [
                    50312.7,
                    30850.2
                  ],
                  [
                    49802.5,
                    30804.2
                  ],
                  [
                    49705.6,
                    30518.5
                  ]
                ],
                "id": 268,
                "chat_link": "[&BAwBAAA=]"
              },
              "826": {
                "name": "Brigantine Isles",
                "level": 32,
                "coord": [
                  48621.3,
                  29444.6
                ],
                "bounds": [
                  [
                    48419.8,
                    29471.5
                  ],
                  [
                    48541.3,
                    29177.2
                  ],
                  [
                    48687.5,
                    29212.1
                  ],
                  [
                    48869,
                    29581.3
                  ],
                  [
                    48769.3,
                    29660.2
                  ],
                  [
                    48440.8,
                    29565.2
                  ],
                  [
                    48419.8,
                    29471.5
                  ]
                ],
                "id": 826,
                "chat_link": "[&BDoDAAA=]"
              },
              "827": {
                "name": "Witherflank River",
                "level": 29,
                "coord": [
                  47719.9,
                  29086.5
                ],
                "bounds": [
                  [
                    47555.9,
                    29234.9
                  ],
                  [
                    47628.4,
                    29209.3
                  ],
                  [
                    47649.2,
                    29046.2
                  ],
                  [
                    47745.9,
                    28891.1
                  ],
                  [
                    47742,
                    28832.7
                  ],
                  [
                    47842.7,
                    28813.1
                  ],
                  [
                    47787.6,
                    28604.8
                  ],
                  [
                    48106,
                    28649.9
                  ],
                  [
                    48001.8,
                    28776.5
                  ],
                  [
                    47886,
                    28923.4
                  ],
                  [
                    47780,
                    28937.3
                  ],
                  [
                    47813.7,
                    29057.8
                  ],
                  [
                    47756.5,
                    29173.6
                  ],
                  [
                    47811,
                    29238.5
                  ],
                  [
                    47735.5,
                    29390.5
                  ],
                  [
                    47512,
                    29554.8
                  ],
                  [
                    47432.4,
                    29561.8
                  ],
                  [
                    47366.5,
                    29397.3
                  ],
                  [
                    47525.7,
                    29350.6
                  ],
                  [
                    47555.9,
                    29234.9
                  ]
                ],
                "id": 827,
                "chat_link": "[&BDsDAAA=]"
              },
              "881": {
                "name": "Provernic Crypt",
                "level": 32,
                "coord": [
                  48252.4,
                  28735.9
                ],
                "bounds": [
                  [
                    48079.2,
                    28865.4
                  ],
                  [
                    48001.6,
                    28776.3
                  ],
                  [
                    48104.2,
                    28652.8
                  ],
                  [
                    48322.2,
                    28596.7
                  ],
                  [
                    48464.5,
                    28660.6
                  ],
                  [
                    48454.2,
                    28739.1
                  ],
                  [
                    48341.1,
                    28860.3
                  ],
                  [
                    48079.2,
                    28865.4
                  ]
                ],
                "id": 881,
                "chat_link": "[&BHEDAAA=]"
              },
              "948": {
                "name": "Vigil Keep",
                "level": 29,
                "coord": [
                  49263.7,
                  28645.4
                ],
                "bounds": [
                  [
                    48876.7,
                    28634.6
                  ],
                  [
                    49446.1,
                    28355.1
                  ],
                  [
                    49542.8,
                    28427.9
                  ],
                  [
                    49647.6,
                    28482.1
                  ],
                  [
                    49582,
                    28945.2
                  ],
                  [
                    48891,
                    28906.3
                  ],
                  [
                    48860,
                    28766.6
                  ],
                  [
                    48876.7,
                    28634.6
                  ]
                ],
                "id": 948,
                "chat_link": "[&BLQDAAA=]"
              }
            },
            "adventures": [],
            "id": 24,
            "mastery_points": []
          },
          "50": {
            "name": "Lion's Arch",
            "min_level": 0,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              49216,
              31488
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                30720,
                18432
              ]
            ],
            "continent_rect": [
              [
                48000,
                30720
              ],
              [
                50432,
                32256
              ]
            ],
            "points_of_interest": {
              "1036": {
                "name": "Commodore's Quarter Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48571,
                  30868.4
                ],
                "id": 1036,
                "chat_link": "[&BAwEAAA=]"
              },
              "1037": {
                "name": "Guild Bluff Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49927.1,
                  31138.4
                ],
                "id": 1037,
                "chat_link": "[&BA0EAAA=]"
              },
              "1038": {
                "name": "Bloodcoast Ward Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49619.8,
                  32044.1
                ],
                "id": 1038,
                "chat_link": "[&BA4EAAA=]"
              },
              "1039": {
                "name": "Claw Island Portage Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48996.8,
                  31853.2
                ],
                "id": 1039,
                "chat_link": "[&BA8EAAA=]"
              },
              "1040": {
                "name": "Trader's Forum Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49063.6,
                  30911
                ],
                "id": 1040,
                "chat_link": "[&BBAEAAA=]"
              },
              "1041": {
                "name": "Gate Hub Plaza Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49309.1,
                  31222.8
                ],
                "id": 1041,
                "chat_link": "[&BBEEAAA=]"
              },
              "1052": {
                "name": "Old Lion's Arch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48456.1,
                  31637.7
                ],
                "id": 1052,
                "chat_link": "[&BBwEAAA=]"
              },
              "1053": {
                "name": "Mist Portals",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49399.2,
                  31822.6
                ],
                "id": 1053,
                "chat_link": "[&BB0EAAA=]"
              },
              "1054": {
                "name": "Moran Memorial",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48637.4,
                  31491.4
                ],
                "id": 1054,
                "chat_link": "[&BB4EAAA=]"
              },
              "1055": {
                "name": "Crow's Nest Tavern (Captain's Council)",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48677.4,
                  31164.9
                ],
                "id": 1055,
                "chat_link": "[&BB8EAAA=]"
              },
              "1056": {
                "name": "Coriolis Plaza",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49399.7,
                  31138
                ],
                "id": 1056,
                "chat_link": "[&BCAEAAA=]"
              },
              "1057": {
                "name": "Mystic Plaza",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48987,
                  30985.1
                ],
                "id": 1057,
                "chat_link": "[&BCEEAAA=]"
              },
              "1058": {
                "name": "Deverol Gardens",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49842.1,
                  31495.3
                ],
                "id": 1058,
                "chat_link": "[&BCIEAAA=]"
              },
              "1059": {
                "name": "Phoenix Roost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48714.5,
                  32075.5
                ],
                "id": 1059,
                "chat_link": "[&BCMEAAA=]"
              },
              "1060": {
                "name": "Tokk's Mill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49973.7,
                  31841.8
                ],
                "id": 1060,
                "chat_link": "[&BCQEAAA=]"
              },
              "1061": {
                "name": "Captain Theo Ashford Memorial Bridge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49376.1,
                  31547.6
                ],
                "id": 1061,
                "chat_link": "[&BCUEAAA=]"
              },
              "1062": {
                "name": "The Vaults",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49300.4,
                  30959.5
                ],
                "id": 1062,
                "chat_link": "[&BCYEAAA=]"
              },
              "1063": {
                "name": "Durmand Priory Research Site",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48287.8,
                  31546.1
                ],
                "id": 1063,
                "chat_link": "[&BCcEAAA=]"
              },
              "1064": {
                "name": "The Undermarket",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48150.5,
                  30809.5
                ],
                "id": 1064,
                "chat_link": "[&BCgEAAA=]"
              },
              "1065": {
                "name": "Lion's Court",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49099.3,
                  31206.1
                ],
                "id": 1065,
                "chat_link": "[&BCkEAAA=]"
              },
              "1066": {
                "name": "Shuttered Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48198.2,
                  31681.1
                ],
                "id": 1066,
                "chat_link": "[&BCoEAAA=]"
              },
              "1067": {
                "name": "Vigil Centerhouse",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49514,
                  31961
                ],
                "id": 1067,
                "chat_link": "[&BCsEAAA=]"
              },
              "1068": {
                "name": "Frog Pond",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48881.4,
                  31042.6
                ],
                "id": 1068,
                "chat_link": "[&BCwEAAA=]"
              },
              "1069": {
                "name": "Diverse Ledges Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48229.9,
                  31688.5
                ],
                "id": 1069,
                "chat_link": "[&BC0EAAA=]"
              },
              "1070": {
                "name": "Western Ward Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48402.5,
                  31156.5
                ],
                "id": 1070,
                "chat_link": "[&BC4EAAA=]"
              },
              "1071": {
                "name": "Sanctum Harbor Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48663.5,
                  31395.1
                ],
                "id": 1071,
                "chat_link": "[&BC8EAAA=]"
              },
              "1072": {
                "name": "Fort Marriner Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49457.3,
                  31700
                ],
                "id": 1072,
                "chat_link": "[&BDAEAAA=]"
              },
              "1073": {
                "name": "Eastern Ward Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49749.7,
                  30961.2
                ],
                "id": 1073,
                "chat_link": "[&BDEEAAA=]"
              },
              "1074": {
                "name": "Cavern Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50162.3,
                  31436.3
                ],
                "id": 1074,
                "chat_link": "[&BDIEAAA=]"
              },
              "1075": {
                "name": "Farshore Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49957.1,
                  31690.5
                ],
                "id": 1075,
                "chat_link": "[&BDMEAAA=]"
              },
              "1189": {
                "name": "Field of the Fallen",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48220.7,
                  31266.3
                ],
                "id": 1189,
                "chat_link": "[&BKUEAAA=]"
              },
              "1190": {
                "name": "Moorookoo Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49156.2,
                  31654.4
                ],
                "id": 1190,
                "chat_link": "[&BKYEAAA=]"
              },
              "1284": {
                "name": "The Free Market",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48534.6,
                  31120.3
                ],
                "id": 1284,
                "chat_link": "[&BAQFAAA=]"
              },
              "1390": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  49864.3,
                  31173.9
                ],
                "id": 1390,
                "chat_link": "[&BG4FAAA=]"
              },
              "1391": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48640.1,
                  31134.1
                ],
                "id": 1391,
                "chat_link": "[&BG8FAAA=]"
              },
              "1392": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  49430.6,
                  31388.8
                ],
                "id": 1392,
                "chat_link": "[&BHAFAAA=]"
              },
              "1393": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  49599.9,
                  31317
                ],
                "id": 1393,
                "chat_link": "[&BHEFAAA=]"
              },
              "1394": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48486.6,
                  31168.2
                ],
                "id": 1394,
                "chat_link": "[&BHIFAAA=]"
              },
              "1395": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48634.5,
                  32094.5
                ],
                "id": 1395,
                "chat_link": "[&BHMFAAA=]"
              },
              "1396": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48194,
                  30972.4
                ],
                "id": 1396,
                "chat_link": "[&BHQFAAA=]"
              },
              "1397": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48941.6,
                  31674.8
                ],
                "id": 1397,
                "chat_link": "[&BHUFAAA=]"
              },
              "1398": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48992,
                  31210.8
                ],
                "id": 1398,
                "chat_link": "[&BHYFAAA=]"
              },
              "1459": {
                "name": "Black Lion Trading Company HQ",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48872.8,
                  31176.6
                ],
                "id": 1459,
                "chat_link": "[&BLMFAAA=]"
              },
              "1568": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  50086.2,
                  31987.9
                ],
                "id": 1568,
                "chat_link": "[&BCAGAAA=]"
              },
              "1729": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  49705.5,
                  31935.7
                ],
                "id": 1729,
                "chat_link": "[&BMEGAAA=]"
              },
              "1757": {
                "name": "Fractals of the Mists",
                "type": "unlock",
                "floor": 1,
                "coord": [
                  49392.2,
                  31889.7
                ],
                "id": 1757,
                "chat_link": "[&BN0GAAA=]",
                "icon": "https://render.guildwars2.com/file/80F608A1E8112313595813033BDEAD3C05A43D01/514379.png"
              },
              "1758": {
                "name": "Macha's Landing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48768.9,
                  31514.6
                ],
                "id": 1758,
                "chat_link": "[&BN4GAAA=]"
              },
              "1759": {
                "name": "Order of Whispers Headquarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48601.6,
                  31012.6
                ],
                "id": 1759,
                "chat_link": "[&BN8GAAA=]"
              },
              "1874": {
                "name": "Wreckage of the Breachmaker",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48715.1,
                  31753
                ],
                "id": 1874,
                "chat_link": "[&BFIHAAA=]"
              },
              "1884": {
                "name": "Guild Initiative Headquarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49986.4,
                  31211.8
                ],
                "id": 1884,
                "chat_link": "[&BFwHAAA=]"
              },
              "2344": {
                "type": "unlock",
                "floor": 1,
                "coord": [
                  49358.5,
                  32032.7
                ],
                "id": 2344,
                "chat_link": "[&BCgJAAA=]",
                "icon": "https://render.guildwars2.com/file/5866630DA52DCB5C423FB81ECF69FD071611E36B/1128644.png"
              },
              "2737": {
                "name": "Captain Kiel's Office",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48659.6,
                  31035.5
                ],
                "id": 2737,
                "chat_link": "[&BLEKAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "854": {
                "name": "Commodore's Quarter",
                "level": 0,
                "coord": [
                  48567.8,
                  30932
                ],
                "bounds": [
                  [
                    48413.1,
                    30875.7
                  ],
                  [
                    48406,
                    30777.8
                  ],
                  [
                    48802,
                    30757.5
                  ],
                  [
                    48740.4,
                    31025.5
                  ],
                  [
                    48745,
                    31108.7
                  ],
                  [
                    48499.5,
                    31042
                  ],
                  [
                    48369,
                    30936.6
                  ],
                  [
                    48413.1,
                    30875.7
                  ]
                ],
                "id": 854,
                "chat_link": "[&BFYDAAA=]"
              },
              "859": {
                "name": "Hooligan's Route",
                "level": 0,
                "coord": [
                  48196,
                  30937.7
                ],
                "bounds": [
                  [
                    48063,
                    31133.5
                  ],
                  [
                    48030.1,
                    30930.2
                  ],
                  [
                    48038,
                    30773.3
                  ],
                  [
                    48406,
                    30777.8
                  ],
                  [
                    48413.1,
                    30875.7
                  ],
                  [
                    48225.9,
                    31135.8
                  ],
                  [
                    48063,
                    31133.5
                  ]
                ],
                "id": 859,
                "chat_link": "[&BFsDAAA=]"
              },
              "860": {
                "name": "Inner Harbor",
                "level": 0,
                "coord": [
                  49711.8,
                  31318.1
                ],
                "bounds": [
                  [
                    49361.8,
                    31625.4
                  ],
                  [
                    49314.8,
                    31517.3
                  ],
                  [
                    49368.8,
                    31359.2
                  ],
                  [
                    49545.3,
                    31251.1
                  ],
                  [
                    49590.2,
                    31289.6
                  ],
                  [
                    49719.3,
                    31205.8
                  ],
                  [
                    49659.8,
                    31135.9
                  ],
                  [
                    49665.3,
                    31041.3
                  ],
                  [
                    49714.3,
                    31016.3
                  ],
                  [
                    49831.4,
                    31047.4
                  ],
                  [
                    49880.2,
                    31099.1
                  ],
                  [
                    49843.1,
                    31163.8
                  ],
                  [
                    49856.6,
                    31242.5
                  ],
                  [
                    49928.2,
                    31332
                  ],
                  [
                    49978.7,
                    31346.7
                  ],
                  [
                    50018.7,
                    31508.4
                  ],
                  [
                    49812.1,
                    31754.6
                  ],
                  [
                    49723.9,
                    31788.4
                  ],
                  [
                    49361.8,
                    31625.4
                  ]
                ],
                "id": 860,
                "chat_link": "[&BFwDAAA=]"
              },
              "861": {
                "name": "Postern Ward",
                "level": 0,
                "coord": [
                  49964.8,
                  31155.7
                ],
                "bounds": [
                  [
                    50018.7,
                    31508.4
                  ],
                  [
                    49978.7,
                    31346.7
                  ],
                  [
                    49928.2,
                    31332
                  ],
                  [
                    49856.6,
                    31242.5
                  ],
                  [
                    49843.1,
                    31163.8
                  ],
                  [
                    49880.2,
                    31099.1
                  ],
                  [
                    49831.4,
                    31047.4
                  ],
                  [
                    49714.3,
                    31016.3
                  ],
                  [
                    49664,
                    30935.1
                  ],
                  [
                    49634.5,
                    30752.6
                  ],
                  [
                    50286.6,
                    30802.7
                  ],
                  [
                    50356.3,
                    31146.6
                  ],
                  [
                    50341,
                    31395.1
                  ],
                  [
                    50174.2,
                    31391.4
                  ],
                  [
                    50018.7,
                    31508.4
                  ]
                ],
                "id": 861,
                "chat_link": "[&BF0DAAA=]"
              },
              "862": {
                "name": "Bloodcoast Ward",
                "level": 0,
                "coord": [
                  49625.1,
                  31934.1
                ],
                "bounds": [
                  [
                    49469.2,
                    31854.2
                  ],
                  [
                    49469.4,
                    31791.7
                  ],
                  [
                    49499.2,
                    31685.5
                  ],
                  [
                    49723.9,
                    31788.4
                  ],
                  [
                    49812.1,
                    31754.6
                  ],
                  [
                    50002.2,
                    31997.3
                  ],
                  [
                    49940.8,
                    32233.4
                  ],
                  [
                    49441.2,
                    32208.7
                  ],
                  [
                    49454.6,
                    32083.8
                  ],
                  [
                    49538,
                    31996.1
                  ],
                  [
                    49525.7,
                    31881.9
                  ],
                  [
                    49469.2,
                    31854.2
                  ]
                ],
                "id": 862,
                "chat_link": "[&BF4DAAA=]"
              },
              "863": {
                "name": "Fort Marriner",
                "level": 0,
                "coord": [
                  49321.8,
                  31883.6
                ],
                "bounds": [
                  [
                    48953.2,
                    31918.9
                  ],
                  [
                    48995.1,
                    31834.6
                  ],
                  [
                    49233.5,
                    31756.6
                  ],
                  [
                    49293.8,
                    31654.4
                  ],
                  [
                    49361.8,
                    31625.4
                  ],
                  [
                    49499.2,
                    31685.5
                  ],
                  [
                    49469.4,
                    31791.7
                  ],
                  [
                    49469.2,
                    31854.2
                  ],
                  [
                    49525.7,
                    31881.9
                  ],
                  [
                    49538,
                    31996.1
                  ],
                  [
                    49454.6,
                    32083.8
                  ],
                  [
                    49441.2,
                    32208.7
                  ],
                  [
                    48948.3,
                    32195.4
                  ],
                  [
                    48953.2,
                    31918.9
                  ]
                ],
                "id": 863,
                "chat_link": "[&BF8DAAA=]"
              },
              "864": {
                "name": "Trader's Forum",
                "level": 0,
                "coord": [
                  49005.2,
                  31022.4
                ],
                "bounds": [
                  [
                    49031.1,
                    30706.3
                  ],
                  [
                    49237,
                    30752.8
                  ],
                  [
                    49190,
                    30819.6
                  ],
                  [
                    49192,
                    30897.6
                  ],
                  [
                    49225.2,
                    30977.2
                  ],
                  [
                    49200.9,
                    31101.4
                  ],
                  [
                    49125.7,
                    31056.5
                  ],
                  [
                    49046.3,
                    31071.1
                  ],
                  [
                    48958.5,
                    31109.8
                  ],
                  [
                    48944.7,
                    31177.6
                  ],
                  [
                    48931.2,
                    31239
                  ],
                  [
                    48879.9,
                    31313
                  ],
                  [
                    48835.4,
                    31255.4
                  ],
                  [
                    48742.5,
                    31097.5
                  ],
                  [
                    48740.4,
                    31025.5
                  ],
                  [
                    48802,
                    30757.5
                  ],
                  [
                    49031.1,
                    30706.3
                  ]
                ],
                "id": 864,
                "chat_link": "[&BGADAAA=]"
              },
              "865": {
                "name": "Eastern Ward",
                "level": 0,
                "coord": [
                  49460.1,
                  31050.2
                ],
                "bounds": [
                  [
                    49295.4,
                    31217.7
                  ],
                  [
                    49368.8,
                    31359.2
                  ],
                  [
                    49545.3,
                    31251.1
                  ],
                  [
                    49590.2,
                    31289.6
                  ],
                  [
                    49719.3,
                    31205.8
                  ],
                  [
                    49659.8,
                    31135.9
                  ],
                  [
                    49665.3,
                    31041.3
                  ],
                  [
                    49714.3,
                    31016.3
                  ],
                  [
                    49664,
                    30935.1
                  ],
                  [
                    49634.5,
                    30752.6
                  ],
                  [
                    49237,
                    30752.8
                  ],
                  [
                    49190,
                    30819.6
                  ],
                  [
                    49192,
                    30897.6
                  ],
                  [
                    49225.2,
                    30977.2
                  ],
                  [
                    49200.9,
                    31101.4
                  ],
                  [
                    49295.4,
                    31217.7
                  ]
                ],
                "id": 865,
                "chat_link": "[&BGEDAAA=]"
              },
              "866": {
                "name": "Western Ward",
                "level": 0,
                "coord": [
                  48576,
                  31217
                ],
                "bounds": [
                  [
                    48415.4,
                    31365.9
                  ],
                  [
                    48446.3,
                    31240.2
                  ],
                  [
                    48368.9,
                    31131.6
                  ],
                  [
                    48278.1,
                    31065
                  ],
                  [
                    48369,
                    30936.6
                  ],
                  [
                    48502.4,
                    31033.9
                  ],
                  [
                    48742.5,
                    31097.5
                  ],
                  [
                    48835.4,
                    31255.4
                  ],
                  [
                    48879.9,
                    31313
                  ],
                  [
                    48904.8,
                    31486.8
                  ],
                  [
                    48593.5,
                    31461
                  ],
                  [
                    48415.4,
                    31365.9
                  ]
                ],
                "id": 866,
                "chat_link": "[&BGIDAAA=]"
              },
              "867": {
                "name": "White Crane Terrace",
                "level": 0,
                "coord": [
                  48199.1,
                  31441.7
                ],
                "bounds": [
                  [
                    48084.9,
                    32047.5
                  ],
                  [
                    48023.3,
                    31737
                  ],
                  [
                    48115.2,
                    31632.2
                  ],
                  [
                    48040.6,
                    31452.7
                  ],
                  [
                    48041.8,
                    31275.8
                  ],
                  [
                    48063,
                    31133.5
                  ],
                  [
                    48225.9,
                    31135.8
                  ],
                  [
                    48278.1,
                    31065
                  ],
                  [
                    48368.9,
                    31131.6
                  ],
                  [
                    48446.3,
                    31240.2
                  ],
                  [
                    48415.4,
                    31365.9
                  ],
                  [
                    48236.6,
                    31495.2
                  ],
                  [
                    48248.5,
                    32029.5
                  ],
                  [
                    48084.9,
                    32047.5
                  ]
                ],
                "id": 867,
                "chat_link": "[&BGMDAAA=]"
              },
              "868": {
                "name": "Grand Piazza",
                "level": 0,
                "coord": [
                  49083.8,
                  31267.8
                ],
                "bounds": [
                  [
                    49200.9,
                    31101.4
                  ],
                  [
                    49125.7,
                    31056.5
                  ],
                  [
                    49046.3,
                    31071.1
                  ],
                  [
                    48958.5,
                    31109.8
                  ],
                  [
                    48944.7,
                    31177.6
                  ],
                  [
                    48931.2,
                    31239
                  ],
                  [
                    48879.9,
                    31313
                  ],
                  [
                    48904.8,
                    31486.8
                  ],
                  [
                    49034.8,
                    31564.8
                  ],
                  [
                    49314.8,
                    31517.3
                  ],
                  [
                    49368.8,
                    31359.2
                  ],
                  [
                    49295.4,
                    31217.7
                  ],
                  [
                    49200.9,
                    31101.4
                  ]
                ],
                "id": 868,
                "chat_link": "[&BGQDAAA=]"
              },
              "869": {
                "name": "Sanctum Harbor",
                "level": 0,
                "coord": [
                  48786.3,
                  31773.8
                ],
                "bounds": [
                  [
                    48236.6,
                    31495.2
                  ],
                  [
                    48415.4,
                    31365.9
                  ],
                  [
                    48593.5,
                    31461
                  ],
                  [
                    48904.8,
                    31486.8
                  ],
                  [
                    49034.8,
                    31564.8
                  ],
                  [
                    49314.8,
                    31517.3
                  ],
                  [
                    49361.8,
                    31625.4
                  ],
                  [
                    49293.8,
                    31654.4
                  ],
                  [
                    49233.5,
                    31756.6
                  ],
                  [
                    48995.1,
                    31834.6
                  ],
                  [
                    48953.2,
                    31918.9
                  ],
                  [
                    48948.3,
                    32195.4
                  ],
                  [
                    48621.3,
                    32228.9
                  ],
                  [
                    48340.5,
                    32198.6
                  ],
                  [
                    48084.9,
                    32047.5
                  ],
                  [
                    48248.5,
                    32029.5
                  ],
                  [
                    48236.6,
                    31495.2
                  ]
                ],
                "id": 869,
                "chat_link": "[&BGUDAAA=]"
              },
              "870": {
                "name": "Farshore Ward",
                "level": 0,
                "coord": [
                  50166.4,
                  31735.5
                ],
                "bounds": [
                  [
                    50002.2,
                    31997.3
                  ],
                  [
                    49812.1,
                    31754.6
                  ],
                  [
                    50018.7,
                    31508.4
                  ],
                  [
                    50174.2,
                    31391.4
                  ],
                  [
                    50341,
                    31395.1
                  ],
                  [
                    50404,
                    31780.8
                  ],
                  [
                    50402.7,
                    31844.5
                  ],
                  [
                    50238.1,
                    31951.6
                  ],
                  [
                    50104.7,
                    31996
                  ],
                  [
                    50002.2,
                    31997.3
                  ]
                ],
                "id": 870,
                "chat_link": "[&BGYDAAA=]"
              },
              "1029": {
                "name": "Sharkmaw Caverns",
                "level": 0,
                "coord": [
                  50216,
                  32045.6
                ],
                "bounds": [
                  [
                    50104.7,
                    31996
                  ],
                  [
                    50238.1,
                    31951.6
                  ],
                  [
                    50402.7,
                    31844.5
                  ],
                  [
                    50409.5,
                    32063.1
                  ],
                  [
                    50414,
                    32233.6
                  ],
                  [
                    49940.8,
                    32233.4
                  ],
                  [
                    50002.2,
                    31997.3
                  ],
                  [
                    50104.7,
                    31996
                  ]
                ],
                "id": 1029,
                "chat_link": "[&BAUEAAA=]"
              }
            },
            "adventures": [],
            "id": 50,
            "mastery_points": []
          },
          "73": {
            "name": "Bloodtide Coast",
            "min_level": 45,
            "max_level": 55,
            "default_floor": 1,
            "label_coord": [
              49212,
              33792
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                30720,
                39936
              ]
            ],
            "continent_rect": [
              [
                48000,
                32256
              ],
              [
                50432,
                35456
              ]
            ],
            "points_of_interest": {
              "36": {
                "name": "Glorious Drill Collective #4",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49201.7,
                  34450.5
                ],
                "id": 36,
                "chat_link": "[&BCQAAAA=]"
              },
              "37": {
                "name": "Gleaner's Archway",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50051.3,
                  34681.4
                ],
                "id": 37,
                "chat_link": "[&BCUAAAA=]"
              },
              "38": {
                "name": "Lapatl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48254.5,
                  34762.2
                ],
                "id": 38,
                "chat_link": "[&BCYAAAA=]"
              },
              "39": {
                "name": "Aquanarium Hydropost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48691.5,
                  32921.3
                ],
                "id": 39,
                "chat_link": "[&BCcAAAA=]"
              },
              "40": {
                "name": "Stormbluff Beacon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49036.7,
                  32935.8
                ],
                "id": 40,
                "chat_link": "[&BCgAAAA=]"
              },
              "41": {
                "name": "Deadend Cave",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49464.4,
                  33014.3
                ],
                "id": 41,
                "chat_link": "[&BCkAAAA=]"
              },
              "42": {
                "name": "Covington Keep",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48872.8,
                  33549.7
                ],
                "id": 42,
                "chat_link": "[&BCoAAAA=]"
              },
              "43": {
                "name": "Bloody Bill's Base",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49905.8,
                  33090.3
                ],
                "id": 43,
                "chat_link": "[&BCsAAAA=]"
              },
              "44": {
                "name": "Sullivan's Wake",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49389.6,
                  33580.8
                ],
                "id": 44,
                "chat_link": "[&BCwAAAA=]"
              },
              "45": {
                "name": "Mudflat Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49935.7,
                  33727.2
                ],
                "id": 45,
                "chat_link": "[&BC0AAAA=]"
              },
              "46": {
                "name": "Vonooroovah",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48575.4,
                  32637.8
                ],
                "id": 46,
                "chat_link": "[&BC4AAAA=]"
              },
              "47": {
                "name": "Morgooroo",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48742.4,
                  34181.6
                ],
                "id": 47,
                "chat_link": "[&BC8AAAA=]"
              },
              "48": {
                "name": "Broken Beacon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48815.7,
                  32388
                ],
                "id": 48,
                "chat_link": "[&BDAAAAA=]"
              },
              "49": {
                "name": "Challdar's Nest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49881.8,
                  34327.3
                ],
                "id": 49,
                "chat_link": "[&BDEAAAA=]"
              },
              "50": {
                "name": "Rhiann's Respite",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50209.6,
                  35247.8
                ],
                "id": 50,
                "chat_link": "[&BDIAAAA=]"
              },
              "419": {
                "name": "Archen Foreland Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49515.9,
                  32337.6
                ],
                "id": 419,
                "chat_link": "[&BKMBAAA=]"
              },
              "420": {
                "name": "Sorrowful Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48753.2,
                  32780
                ],
                "id": 420,
                "chat_link": "[&BKQBAAA=]"
              },
              "421": {
                "name": "Stormbluff Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49245,
                  33072.2
                ],
                "id": 421,
                "chat_link": "[&BKUBAAA=]"
              },
              "422": {
                "name": "Marshwatch Haven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50112.6,
                  32532.3
                ],
                "id": 422,
                "chat_link": "[&BKYBAAA=]"
              },
              "423": {
                "name": "Remanda Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49985.5,
                  33404.8
                ],
                "id": 423,
                "chat_link": "[&BKcBAAA=]"
              },
              "424": {
                "name": "Laughing Gull Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48915.9,
                  33772.2
                ],
                "id": 424,
                "chat_link": "[&BKgBAAA=]"
              },
              "425": {
                "name": "Barrier Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48357.9,
                  34155
                ],
                "id": 425,
                "chat_link": "[&BKkBAAA=]"
              },
              "426": {
                "name": "Firthside Vigil Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49401.4,
                  34071.5
                ],
                "id": 426,
                "chat_link": "[&BKoBAAA=]"
              },
              "427": {
                "name": "Lostwreck Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50197.2,
                  34085.1
                ],
                "id": 427,
                "chat_link": "[&BKsBAAA=]"
              },
              "428": {
                "name": "Bogside Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50184.3,
                  34696.1
                ],
                "id": 428,
                "chat_link": "[&BKwBAAA=]"
              },
              "429": {
                "name": "Mournful Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48993.3,
                  34736.1
                ],
                "id": 429,
                "chat_link": "[&BK0BAAA=]"
              },
              "430": {
                "name": "Castavall Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48999.2,
                  34955
                ],
                "id": 430,
                "chat_link": "[&BK4BAAA=]"
              },
              "431": {
                "name": "Jelako Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48315,
                  35172.4
                ],
                "id": 431,
                "chat_link": "[&BK8BAAA=]"
              },
              "432": {
                "name": "Whisperwill Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50033.1,
                  35244.4
                ],
                "id": 432,
                "chat_link": "[&BLABAAA=]"
              },
              "1035": {
                "name": "Deadend Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49550.2,
                  32792.4
                ],
                "id": 1035,
                "chat_link": "[&BAsEAAA=]"
              },
              "1196": {
                "name": "Breekeelee",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48393.7,
                  33648.5
                ],
                "id": 1196,
                "chat_link": "[&BKwEAAA=]"
              },
              "1197": {
                "name": "Lorantl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49666.8,
                  33738.7
                ],
                "id": 1197,
                "chat_link": "[&BK0EAAA=]"
              },
              "1581": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  49919.9,
                  32377.9
                ],
                "id": 1581,
                "chat_link": "[&BC0GAAA=]"
              },
              "1582": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  50271.3,
                  35016.6
                ],
                "id": 1582,
                "chat_link": "[&BC4GAAA=]"
              },
              "1583": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48650.8,
                  35403.5
                ],
                "id": 1583,
                "chat_link": "[&BC8GAAA=]"
              },
              "1584": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  49312.1,
                  34320.7
                ],
                "id": 1584,
                "chat_link": "[&BDAGAAA=]"
              },
              "1585": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  49284,
                  32935.3
                ],
                "id": 1585,
                "chat_link": "[&BDEGAAA=]"
              },
              "1586": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  49980,
                  32921.8
                ],
                "id": 1586,
                "chat_link": "[&BDIGAAA=]"
              },
              "1587": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48777.9,
                  33523.3
                ],
                "id": 1587,
                "chat_link": "[&BDMGAAA=]"
              },
              "1621": {
                "name": "Lostwreck Passage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50305.5,
                  34236
                ],
                "id": 1621,
                "chat_link": "[&BFUGAAA=]"
              }
            },
            "tasks": {
              "187": {
                "objective": "Help the Priory put ghost pirates to rest.",
                "level": 45,
                "coord": [
                  48804.7,
                  32335.9
                ],
                "bounds": [
                  [
                    48663.2,
                    32314.3
                  ],
                  [
                    48730.4,
                    32512.1
                  ],
                  [
                    48840.9,
                    32520.8
                  ],
                  [
                    48972.3,
                    32472.1
                  ],
                  [
                    49090,
                    32305
                  ],
                  [
                    48663.2,
                    32314.3
                  ]
                ],
                "id": 187,
                "chat_link": "[&BLsAAAA=]"
              },
              "188": {
                "objective": "Help the Lionguard keep drakes at bay.",
                "level": 45,
                "coord": [
                  49403.2,
                  32413.3
                ],
                "bounds": [
                  [
                    49245.6,
                    32354.1
                  ],
                  [
                    49353.6,
                    32317.4
                  ],
                  [
                    49479.2,
                    32339.1
                  ],
                  [
                    49592.1,
                    32357.1
                  ],
                  [
                    49664.6,
                    32413.8
                  ],
                  [
                    49730,
                    32468
                  ],
                  [
                    49763.7,
                    32521
                  ],
                  [
                    49792,
                    32599.9
                  ],
                  [
                    49702.8,
                    32629.1
                  ],
                  [
                    49184,
                    32617.7
                  ],
                  [
                    49182.5,
                    32464.4
                  ],
                  [
                    49245.6,
                    32354.1
                  ]
                ],
                "id": 188,
                "chat_link": "[&BLwAAAA=]"
              },
              "189": {
                "objective": "Help spy on the Crafty Corsairs.",
                "level": 49,
                "coord": [
                  49302.2,
                  33460.5
                ],
                "bounds": [
                  [
                    49535.9,
                    33648
                  ],
                  [
                    49548.5,
                    33499.1
                  ],
                  [
                    49520.5,
                    33392.1
                  ],
                  [
                    49454,
                    33372.5
                  ],
                  [
                    49305.5,
                    33404.3
                  ],
                  [
                    49206.8,
                    33537.5
                  ],
                  [
                    49192.7,
                    33662.1
                  ],
                  [
                    49259.7,
                    33853.2
                  ],
                  [
                    49422.2,
                    33824
                  ],
                  [
                    49535.9,
                    33648
                  ]
                ],
                "id": 189,
                "chat_link": "[&BL0AAAA=]"
              },
              "190": {
                "objective": "Help subvert the Bloody Buccaneers.",
                "level": 47,
                "coord": [
                  49938.5,
                  32927
                ],
                "bounds": [
                  [
                    49827.6,
                    33319.1
                  ],
                  [
                    49719.6,
                    33130.4
                  ],
                  [
                    49726.5,
                    33022.2
                  ],
                  [
                    49759.4,
                    32956.1
                  ],
                  [
                    49977.5,
                    32782.7
                  ],
                  [
                    50113.9,
                    32811
                  ],
                  [
                    50124.1,
                    33009.4
                  ],
                  [
                    50129.5,
                    33155
                  ],
                  [
                    49978.5,
                    33259.1
                  ],
                  [
                    49827.6,
                    33319.1
                  ]
                ],
                "id": 190,
                "chat_link": "[&BL4AAAA=]"
              },
              "191": {
                "objective": "Help maintain order in Moriarity's Hold.",
                "level": 48,
                "coord": [
                  50315.3,
                  33027.7
                ],
                "bounds": [
                  [
                    50381.2,
                    33088.8
                  ],
                  [
                    50373.8,
                    33216.4
                  ],
                  [
                    50335.9,
                    33184
                  ],
                  [
                    50261.5,
                    33066.4
                  ],
                  [
                    50321.9,
                    32971.9
                  ],
                  [
                    50372.1,
                    32980
                  ],
                  [
                    50381.2,
                    33088.8
                  ]
                ],
                "id": 191,
                "chat_link": "[&BL8AAAA=]"
              },
              "192": {
                "objective": "Help Arm the Quaggans",
                "level": 52,
                "coord": [
                  48892.8,
                  34072.1
                ],
                "bounds": [
                  [
                    48569,
                    34199.6
                  ],
                  [
                    48662.7,
                    33926.8
                  ],
                  [
                    48869.4,
                    33888.7
                  ],
                  [
                    49013.4,
                    33909.3
                  ],
                  [
                    48950.5,
                    34169.4
                  ],
                  [
                    48839.3,
                    34330.6
                  ],
                  [
                    48667.5,
                    34364.9
                  ],
                  [
                    48569,
                    34199.6
                  ]
                ],
                "id": 192,
                "chat_link": "[&BMAAAAA=]"
              },
              "193": {
                "objective": "Help Shore up Hylek Defenses",
                "level": 54,
                "coord": [
                  48312.9,
                  34864.8
                ],
                "bounds": [
                  [
                    48141.3,
                    35155.7
                  ],
                  [
                    48283.8,
                    35070.6
                  ],
                  [
                    48353.1,
                    34948.5
                  ],
                  [
                    48398.8,
                    34905.1
                  ],
                  [
                    48390.8,
                    34751.6
                  ],
                  [
                    48339.6,
                    34676.5
                  ],
                  [
                    48208.6,
                    34732.7
                  ],
                  [
                    48141.3,
                    35155.7
                  ]
                ],
                "id": 193,
                "chat_link": "[&BMEAAAA=]"
              },
              "194": {
                "objective": "Fight the Mysterious Quaggan Affliction",
                "level": 53,
                "coord": [
                  48305.2,
                  34098.4
                ],
                "bounds": [
                  [
                    48462,
                    34033.5
                  ],
                  [
                    48452.9,
                    33981.2
                  ],
                  [
                    48487.8,
                    33927.7
                  ],
                  [
                    48421.8,
                    33899.9
                  ],
                  [
                    48341.5,
                    33903.1
                  ],
                  [
                    48295.9,
                    33923.2
                  ],
                  [
                    48283.5,
                    33985.3
                  ],
                  [
                    48251.1,
                    34024.3
                  ],
                  [
                    48247.7,
                    34127.4
                  ],
                  [
                    48242.4,
                    34391.6
                  ],
                  [
                    48355.8,
                    34319.3
                  ],
                  [
                    48412.8,
                    34245.4
                  ],
                  [
                    48412.9,
                    34167.9
                  ],
                  [
                    48462.8,
                    34108.3
                  ],
                  [
                    48462,
                    34033.5
                  ]
                ],
                "id": 194,
                "chat_link": "[&BMIAAAA=]"
              },
              "195": {
                "objective": "Disrupt experiments at Aquanarium Hydropost.",
                "level": 47,
                "coord": [
                  48882.1,
                  32956
                ],
                "bounds": [
                  [
                    48642.1,
                    32714.7
                  ],
                  [
                    48545.7,
                    32811.3
                  ],
                  [
                    48585.2,
                    32973.1
                  ],
                  [
                    48626.5,
                    33079.7
                  ],
                  [
                    48806.1,
                    33030.2
                  ],
                  [
                    48909.7,
                    32941.7
                  ],
                  [
                    48642.1,
                    32714.7
                  ]
                ],
                "id": 195,
                "chat_link": "[&BMMAAAA=]"
              },
              "196": {
                "objective": "Teach quaggans how to raise crabs.",
                "level": 46,
                "coord": [
                  48824.5,
                  32639.7
                ],
                "bounds": [
                  [
                    48745.5,
                    32700.7
                  ],
                  [
                    48778.6,
                    32582.2
                  ],
                  [
                    49118,
                    32530.8
                  ],
                  [
                    49164.3,
                    32659.9
                  ],
                  [
                    48838.1,
                    32819.7
                  ],
                  [
                    48745.5,
                    32700.7
                  ]
                ],
                "id": 196,
                "chat_link": "[&BMQAAAA=]"
              },
              "197": {
                "objective": "Help the Vigil clear out the abandoned caves of Mole's Head",
                "level": 51,
                "coord": [
                  49450.6,
                  34265
                ],
                "bounds": [
                  [
                    49245.1,
                    33944.2
                  ],
                  [
                    49473.4,
                    34210.8
                  ],
                  [
                    49488.8,
                    34316
                  ],
                  [
                    49483.3,
                    34359.1
                  ],
                  [
                    49453.2,
                    34530.9
                  ],
                  [
                    49161.1,
                    34696.2
                  ],
                  [
                    48987.3,
                    34705.3
                  ],
                  [
                    48894.5,
                    34647.5
                  ],
                  [
                    48882.1,
                    34418.4
                  ],
                  [
                    49042.3,
                    34093.9
                  ],
                  [
                    49245.1,
                    33944.2
                  ]
                ],
                "id": 197,
                "chat_link": "[&BMUAAAA=]"
              },
              "198": {
                "objective": "Assist Crusader Aisling of the Vigil recover lost skritt territory",
                "level": 50,
                "coord": [
                  49623.1,
                  34176.5
                ],
                "bounds": [
                  [
                    49485.6,
                    34131.8
                  ],
                  [
                    49505.2,
                    34313.5
                  ],
                  [
                    49549.4,
                    34360.3
                  ],
                  [
                    49478.9,
                    34523.7
                  ],
                  [
                    49531.2,
                    34544.9
                  ],
                  [
                    49603.3,
                    34501.6
                  ],
                  [
                    49655.7,
                    34535.1
                  ],
                  [
                    49743.8,
                    34568.2
                  ],
                  [
                    49794.9,
                    34520.2
                  ],
                  [
                    49944.9,
                    34324.7
                  ],
                  [
                    50045.4,
                    34139.4
                  ],
                  [
                    49970.5,
                    34095.3
                  ],
                  [
                    49871.1,
                    34039.6
                  ],
                  [
                    49756.2,
                    34037.9
                  ],
                  [
                    49714.9,
                    34073.1
                  ],
                  [
                    49688.7,
                    34132.8
                  ],
                  [
                    49612.9,
                    34129.9
                  ],
                  [
                    49485.6,
                    34131.8
                  ]
                ],
                "id": 198,
                "chat_link": "[&BMYAAAA=]"
              },
              "199": {
                "objective": "Help Cesseilia defend and research the oasis.",
                "level": 55,
                "coord": [
                  50172,
                  35218.9
                ],
                "bounds": [
                  [
                    50265.2,
                    35034.4
                  ],
                  [
                    50192.3,
                    35015.7
                  ],
                  [
                    50155.2,
                    35067.2
                  ],
                  [
                    50137.9,
                    35169.9
                  ],
                  [
                    50097.2,
                    35357.2
                  ],
                  [
                    50281.8,
                    35382.6
                  ],
                  [
                    50325,
                    35295.8
                  ],
                  [
                    50282.6,
                    35096.3
                  ],
                  [
                    50265.2,
                    35034.4
                  ]
                ],
                "id": 199,
                "chat_link": "[&BMcAAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  50261.5,
                  34193.5
                ],
                "id": "0-52"
              },
              {
                "coord": [
                  49084.6,
                  32912.3
                ],
                "id": "0-53"
              },
              {
                "coord": [
                  48881,
                  33504.3
                ],
                "id": "0-51"
              },
              {
                "coord": [
                  49517.4,
                  32845.7
                ],
                "id": "0-142"
              },
              {
                "coord": [
                  49044.7,
                  34981.7
                ],
                "id": "0-144"
              },
              {
                "coord": [
                  48508.9,
                  35012.6
                ],
                "id": "0-143"
              }
            ],
            "sectors": {
              "295": {
                "name": "Merchantman's Strait",
                "level": 49,
                "coord": [
                  49416.2,
                  33497.8
                ],
                "bounds": [
                  [
                    49553,
                    33834.7
                  ],
                  [
                    49119.4,
                    34060
                  ],
                  [
                    48915.3,
                    33811.3
                  ],
                  [
                    49126.8,
                    33504.4
                  ],
                  [
                    49206.8,
                    33292
                  ],
                  [
                    49606.3,
                    33064.3
                  ],
                  [
                    49774.8,
                    33067.6
                  ],
                  [
                    49816.7,
                    33250
                  ],
                  [
                    49626.8,
                    33596.3
                  ],
                  [
                    49553,
                    33834.7
                  ]
                ],
                "id": 295,
                "chat_link": "[&BCcBAAA=]"
              },
              "296": {
                "name": "Mournful Depths",
                "level": 54,
                "coord": [
                  48936.3,
                  34978.4
                ],
                "bounds": [
                  [
                    48776.3,
                    34484.8
                  ],
                  [
                    48879.5,
                    34519.8
                  ],
                  [
                    48918.7,
                    34648.4
                  ],
                  [
                    49085.9,
                    34678
                  ],
                  [
                    49221.9,
                    34793.7
                  ],
                  [
                    49460.5,
                    34733.7
                  ],
                  [
                    49784.3,
                    35330
                  ],
                  [
                    49595.6,
                    35518.6
                  ],
                  [
                    49105.4,
                    35535.8
                  ],
                  [
                    48685.1,
                    35457.3
                  ],
                  [
                    48483.5,
                    35159.4
                  ],
                  [
                    48636.8,
                    35113.4
                  ],
                  [
                    49165.1,
                    35062.5
                  ],
                  [
                    49098.3,
                    34847.6
                  ],
                  [
                    48728.9,
                    34722.6
                  ],
                  [
                    48574.5,
                    34877
                  ],
                  [
                    48637.7,
                    35113.6
                  ],
                  [
                    48482.5,
                    35161.9
                  ],
                  [
                    48468.1,
                    34831.8
                  ],
                  [
                    48776.3,
                    34484.8
                  ]
                ],
                "id": 296,
                "chat_link": "[&BCgBAAA=]"
              },
              "297": {
                "name": "Mistarion Beach",
                "level": 54,
                "coord": [
                  49766.4,
                  34914.8
                ],
                "bounds": [
                  [
                    49812,
                    35108.3
                  ],
                  [
                    49962.4,
                    35068.8
                  ],
                  [
                    50048.3,
                    34847.7
                  ],
                  [
                    49768.2,
                    34789
                  ],
                  [
                    49731,
                    34700.2
                  ],
                  [
                    49595.3,
                    34788.4
                  ],
                  [
                    49485.9,
                    34787.3
                  ],
                  [
                    49727.7,
                    35228.5
                  ],
                  [
                    49812,
                    35108.3
                  ]
                ],
                "id": 297,
                "chat_link": "[&BCkBAAA=]"
              },
              "298": {
                "name": "Challdar Gorges",
                "level": 52,
                "coord": [
                  49631.3,
                  34456.8
                ],
                "bounds": [
                  [
                    49490.5,
                    34527.8
                  ],
                  [
                    49126.4,
                    34705.1
                  ],
                  [
                    49221.5,
                    34794.3
                  ],
                  [
                    49460.4,
                    34735.7
                  ],
                  [
                    49485.9,
                    34790.6
                  ],
                  [
                    49597.5,
                    34792.2
                  ],
                  [
                    49732.1,
                    34702.8
                  ],
                  [
                    49692.6,
                    34619.1
                  ],
                  [
                    49739.4,
                    34458.6
                  ],
                  [
                    49882.3,
                    34430.8
                  ],
                  [
                    49990.3,
                    34299.6
                  ],
                  [
                    50060.8,
                    34142.2
                  ],
                  [
                    49873,
                    34034.8
                  ],
                  [
                    49757.3,
                    34017.7
                  ],
                  [
                    49664.5,
                    34128.7
                  ],
                  [
                    49325.9,
                    34129.6
                  ],
                  [
                    49490.5,
                    34527.8
                  ]
                ],
                "id": 298,
                "chat_link": "[&BCoBAAA=]"
              },
              "299": {
                "name": "Mole's Head",
                "level": 52,
                "coord": [
                  49152.7,
                  34369.3
                ],
                "bounds": [
                  [
                    48918.5,
                    34647.9
                  ],
                  [
                    48878.1,
                    34520.4
                  ],
                  [
                    49118.6,
                    34049.5
                  ],
                  [
                    49212.5,
                    34004.5
                  ],
                  [
                    49326.5,
                    34130.6
                  ],
                  [
                    49490,
                    34526.8
                  ],
                  [
                    49124.5,
                    34705.4
                  ],
                  [
                    48918.5,
                    34647.9
                  ]
                ],
                "id": 299,
                "chat_link": "[&BCsBAAA=]"
              },
              "300": {
                "name": "Wraithwalker Woods",
                "level": 54,
                "coord": [
                  49955.5,
                  34585.8
                ],
                "bounds": [
                  [
                    49740,
                    34458.9
                  ],
                  [
                    49878.2,
                    34431.8
                  ],
                  [
                    49927.6,
                    34377.3
                  ],
                  [
                    50201.8,
                    34490
                  ],
                  [
                    50223.5,
                    34596.5
                  ],
                  [
                    50121.7,
                    34660.9
                  ],
                  [
                    50048,
                    34848.9
                  ],
                  [
                    49767.8,
                    34790.4
                  ],
                  [
                    49690.8,
                    34617.3
                  ],
                  [
                    49740,
                    34458.9
                  ]
                ],
                "id": 300,
                "chat_link": "[&BCwBAAA=]"
              },
              "301": {
                "name": "Portage Hills",
                "level": 46,
                "coord": [
                  50154.9,
                  32428.2
                ],
                "bounds": [
                  [
                    49918.9,
                    32510
                  ],
                  [
                    49828.8,
                    32518.8
                  ],
                  [
                    49792.3,
                    32229.3
                  ],
                  [
                    49884.7,
                    32195
                  ],
                  [
                    50170.8,
                    32152.9
                  ],
                  [
                    50494.6,
                    32313.8
                  ],
                  [
                    50529.5,
                    32468.1
                  ],
                  [
                    50380.2,
                    32530.9
                  ],
                  [
                    50359.7,
                    32633.4
                  ],
                  [
                    50188.9,
                    32730.3
                  ],
                  [
                    49918.9,
                    32510
                  ]
                ],
                "id": 301,
                "chat_link": "[&BC0BAAA=]"
              },
              "302": {
                "name": "Jelako Cliffrise",
                "level": 54,
                "coord": [
                  48365.4,
                  35130.8
                ],
                "bounds": [
                  [
                    48128.2,
                    35265.2
                  ],
                  [
                    48233.8,
                    35454
                  ],
                  [
                    48340.8,
                    35454
                  ],
                  [
                    48584.3,
                    35470.7
                  ],
                  [
                    48668.9,
                    35430.8
                  ],
                  [
                    48484.7,
                    35162.6
                  ],
                  [
                    48469.7,
                    34829.8
                  ],
                  [
                    48348.9,
                    34712.8
                  ],
                  [
                    48240.6,
                    34672.5
                  ],
                  [
                    48153.8,
                    34855.6
                  ],
                  [
                    48128.2,
                    35265.2
                  ]
                ],
                "id": 302,
                "chat_link": "[&BC4BAAA=]"
              },
              "303": {
                "name": "Captain's Cut",
                "level": 48,
                "coord": [
                  48992.7,
                  33194.7
                ],
                "bounds": [
                  [
                    48881.1,
                    32921.5
                  ],
                  [
                    48683.8,
                    33081.6
                  ],
                  [
                    49126.9,
                    33504.5
                  ],
                  [
                    49210.8,
                    33294.8
                  ],
                  [
                    49061,
                    33171
                  ],
                  [
                    48881.1,
                    32921.5
                  ]
                ],
                "id": 303,
                "chat_link": "[&BC8BAAA=]"
              },
              "304": {
                "name": "Vindar's Lagoon",
                "level": 47,
                "coord": [
                  49916.6,
                  32836.9
                ],
                "bounds": [
                  [
                    49585.1,
                    32787.3
                  ],
                  [
                    49829.8,
                    32517.8
                  ],
                  [
                    49918.1,
                    32506.6
                  ],
                  [
                    50188.7,
                    32727.7
                  ],
                  [
                    50241.1,
                    32849.1
                  ],
                  [
                    50201,
                    33017.8
                  ],
                  [
                    49909.1,
                    32991.5
                  ],
                  [
                    49773.5,
                    33068.8
                  ],
                  [
                    49603.5,
                    33065.9
                  ],
                  [
                    49585.1,
                    32787.3
                  ]
                ],
                "id": 304,
                "chat_link": "[&BDABAAA=]"
              },
              "305": {
                "name": "Stormbluff Isle",
                "level": 47,
                "coord": [
                  49212.5,
                  32967.3
                ],
                "bounds": [
                  [
                    49057.7,
                    33171.9
                  ],
                  [
                    49207.4,
                    33295
                  ],
                  [
                    49604,
                    33068.6
                  ],
                  [
                    49587.3,
                    32785.5
                  ],
                  [
                    49246.8,
                    32673.5
                  ],
                  [
                    48904.9,
                    32853.6
                  ],
                  [
                    48879.1,
                    32922.9
                  ],
                  [
                    49057.7,
                    33171.9
                  ]
                ],
                "id": 305,
                "chat_link": "[&BDEBAAA=]"
              },
              "306": {
                "name": "Dredgehat Isle",
                "level": 53,
                "coord": [
                  48367.9,
                  34563.8
                ],
                "bounds": [
                  [
                    48145.4,
                    34585.6
                  ],
                  [
                    48200,
                    34407.5
                  ],
                  [
                    48399.9,
                    34246.6
                  ],
                  [
                    48771.5,
                    34489.4
                  ],
                  [
                    48468.7,
                    34831.4
                  ],
                  [
                    48349.1,
                    34713.9
                  ],
                  [
                    48240.7,
                    34672.1
                  ],
                  [
                    48145.4,
                    34585.6
                  ]
                ],
                "id": 306,
                "chat_link": "[&BDIBAAA=]"
              },
              "307": {
                "name": "Mentecki Pass",
                "level": 52,
                "coord": [
                  50241.6,
                  34151.8
                ],
                "bounds": [
                  [
                    50188.8,
                    34502.2
                  ],
                  [
                    50351.6,
                    34371.2
                  ],
                  [
                    50472.4,
                    34124
                  ],
                  [
                    50457.6,
                    33865.6
                  ],
                  [
                    50393,
                    33763.5
                  ],
                  [
                    50149.6,
                    33911.7
                  ],
                  [
                    49990.6,
                    34299.5
                  ],
                  [
                    49928.9,
                    34377
                  ],
                  [
                    50188.8,
                    34502.2
                  ]
                ],
                "id": 307,
                "chat_link": "[&BDMBAAA=]"
              },
              "308": {
                "name": "Moriarity's Hold",
                "level": 47,
                "coord": [
                  50322.5,
                  33003.7
                ],
                "bounds": [
                  [
                    50321.3,
                    33409.2
                  ],
                  [
                    50430.6,
                    33334
                  ],
                  [
                    50483.5,
                    33036.7
                  ],
                  [
                    50437.7,
                    32743.1
                  ],
                  [
                    50359.2,
                    32631
                  ],
                  [
                    50187.4,
                    32727
                  ],
                  [
                    50240.9,
                    32849.3
                  ],
                  [
                    50200,
                    33015.6
                  ],
                  [
                    50242,
                    33287.5
                  ],
                  [
                    50321.3,
                    33409.2
                  ]
                ],
                "id": 308,
                "chat_link": "[&BDQBAAA=]"
              },
              "310": {
                "name": "Laughing Gull Island",
                "level": 50,
                "coord": [
                  48706.8,
                  33524.1
                ],
                "bounds": [
                  [
                    49126.9,
                    33503.7
                  ],
                  [
                    48932.5,
                    33819.2
                  ],
                  [
                    48562.1,
                    33767.2
                  ],
                  [
                    48229,
                    33449.6
                  ],
                  [
                    48683.3,
                    33080.6
                  ],
                  [
                    49126.9,
                    33503.7
                  ]
                ],
                "id": 310,
                "chat_link": "[&BDYBAAA=]"
              },
              "311": {
                "name": "Grand Barrier Isle",
                "level": 52,
                "coord": [
                  48266.5,
                  34092.7
                ],
                "bounds": [
                  [
                    48402,
                    33928.5
                  ],
                  [
                    48404.9,
                    34263.7
                  ],
                  [
                    48199.9,
                    34408.6
                  ],
                  [
                    48144,
                    34083
                  ],
                  [
                    48181.8,
                    33779.7
                  ],
                  [
                    48402,
                    33928.5
                  ]
                ],
                "id": 311,
                "chat_link": "[&BDcBAAA=]"
              },
              "312": {
                "name": "Archen Foreland",
                "level": 46,
                "coord": [
                  49335.2,
                  32456.4
                ],
                "bounds": [
                  [
                    49792.2,
                    32230
                  ],
                  [
                    49830.4,
                    32518.5
                  ],
                  [
                    49585.7,
                    32785.6
                  ],
                  [
                    49246.4,
                    32673.7
                  ],
                  [
                    48905.2,
                    32854.1
                  ],
                  [
                    48746,
                    32449.7
                  ],
                  [
                    48731.1,
                    32206.3
                  ],
                  [
                    49531.7,
                    32194.2
                  ],
                  [
                    49648,
                    32195.5
                  ],
                  [
                    49792.2,
                    32230
                  ]
                ],
                "id": 312,
                "chat_link": "[&BDgBAAA=]"
              },
              "313": {
                "name": "Sanguine Bay",
                "level": 52,
                "coord": [
                  48559.8,
                  33949.2
                ],
                "bounds": [
                  [
                    48230.3,
                    33448.5
                  ],
                  [
                    48562.4,
                    33765.3
                  ],
                  [
                    48929,
                    33796.4
                  ],
                  [
                    49119.1,
                    34049.7
                  ],
                  [
                    48879.4,
                    34521.4
                  ],
                  [
                    48768.7,
                    34490.3
                  ],
                  [
                    48393.2,
                    34263.6
                  ],
                  [
                    48400,
                    33930.3
                  ],
                  [
                    48180.9,
                    33779.8
                  ],
                  [
                    48135.1,
                    33446.9
                  ],
                  [
                    48230.3,
                    33448.5
                  ]
                ],
                "id": 313,
                "chat_link": "[&BDkBAAA=]"
              },
              "314": {
                "name": "Firth of Revanion",
                "level": 50,
                "coord": [
                  49740.7,
                  33997.7
                ],
                "bounds": [
                  [
                    49551.7,
                    33829.4
                  ],
                  [
                    49763,
                    33910.9
                  ],
                  [
                    50044.8,
                    33863.6
                  ],
                  [
                    50150.8,
                    33913.9
                  ],
                  [
                    50060,
                    34142.1
                  ],
                  [
                    49872.8,
                    34035.7
                  ],
                  [
                    49758,
                    34018
                  ],
                  [
                    49664.9,
                    34128.9
                  ],
                  [
                    49326.2,
                    34129.1
                  ],
                  [
                    49214.4,
                    34005.3
                  ],
                  [
                    49551.7,
                    33829.4
                  ]
                ],
                "id": 314,
                "chat_link": "[&BDoBAAA=]"
              },
              "315": {
                "name": "Sorrowful Sound",
                "level": 47,
                "coord": [
                  48458.6,
                  32840
                ],
                "bounds": [
                  [
                    48121.7,
                    33109.8
                  ],
                  [
                    48116.3,
                    32644.8
                  ],
                  [
                    48397.3,
                    32203.5
                  ],
                  [
                    48592,
                    32480.2
                  ],
                  [
                    48747.1,
                    32451.7
                  ],
                  [
                    48908.7,
                    32851.3
                  ],
                  [
                    48882.5,
                    32922.4
                  ],
                  [
                    48228.8,
                    33450.4
                  ],
                  [
                    48133.2,
                    33446
                  ],
                  [
                    48121.7,
                    33109.8
                  ]
                ],
                "id": 315,
                "chat_link": "[&BDsBAAA=]"
              },
              "316": {
                "name": "Whisperwill Bogs",
                "level": 55,
                "coord": [
                  50077,
                  35098.9
                ],
                "bounds": [
                  [
                    50235.7,
                    34579.5
                  ],
                  [
                    50443.5,
                    34606.4
                  ],
                  [
                    50453,
                    35012.2
                  ],
                  [
                    50378.8,
                    35335.6
                  ],
                  [
                    50160.5,
                    35470.2
                  ],
                  [
                    50016.1,
                    35466.8
                  ],
                  [
                    49780.9,
                    35389.8
                  ],
                  [
                    49793,
                    35316.4
                  ],
                  [
                    49737.8,
                    35213.2
                  ],
                  [
                    49821.5,
                    35092.1
                  ],
                  [
                    49972.3,
                    35056
                  ],
                  [
                    50131.1,
                    34648.4
                  ],
                  [
                    50235.7,
                    34579.5
                  ]
                ],
                "id": 316,
                "chat_link": "[&BDwBAAA=]"
              },
              "317": {
                "name": "Remanda Saltmarsh",
                "level": 48,
                "coord": [
                  50008.5,
                  33358.8
                ],
                "bounds": [
                  [
                    49813.2,
                    33253.5
                  ],
                  [
                    49773.6,
                    33068
                  ],
                  [
                    49908.7,
                    32990.3
                  ],
                  [
                    50201.1,
                    33014.8
                  ],
                  [
                    50243.2,
                    33287.8
                  ],
                  [
                    50367,
                    33469
                  ],
                  [
                    50396.8,
                    33526.2
                  ],
                  [
                    50036.4,
                    33680.5
                  ],
                  [
                    49718.5,
                    33697.5
                  ],
                  [
                    49626,
                    33600.2
                  ],
                  [
                    49813.2,
                    33253.5
                  ]
                ],
                "id": 317,
                "chat_link": "[&BD0BAAA=]"
              },
              "318": {
                "name": "Risewild Hills",
                "level": 50,
                "coord": [
                  50085.8,
                  33731.7
                ],
                "bounds": [
                  [
                    49718.2,
                    33695.3
                  ],
                  [
                    50036.5,
                    33679.4
                  ],
                  [
                    50395.6,
                    33525.2
                  ],
                  [
                    50426.9,
                    33569.1
                  ],
                  [
                    50488.6,
                    33668.3
                  ],
                  [
                    50442.4,
                    33760
                  ],
                  [
                    50389.8,
                    33763.5
                  ],
                  [
                    50146.9,
                    33915.5
                  ],
                  [
                    50045.5,
                    33862.7
                  ],
                  [
                    49762.5,
                    33913.2
                  ],
                  [
                    49550.3,
                    33831.4
                  ],
                  [
                    49626,
                    33596.8
                  ],
                  [
                    49718.2,
                    33695.3
                  ]
                ],
                "id": 318,
                "chat_link": "[&BD4BAAA=]"
              },
              "319": {
                "name": "Flooded Castavall",
                "level": 55,
                "coord": [
                  48841.3,
                  34924.7
                ],
                "bounds": [
                  [
                    49098,
                    34848.7
                  ],
                  [
                    49165,
                    35062.3
                  ],
                  [
                    48638.3,
                    35112.9
                  ],
                  [
                    48576,
                    34877.3
                  ],
                  [
                    48729.4,
                    34722.4
                  ],
                  [
                    49098,
                    34848.7
                  ]
                ],
                "id": 319,
                "chat_link": "[&BD8BAAA=]"
              },
              "946": {
                "name": "Momoztli Grounds",
                "level": 47,
                "coord": [
                  48616.3,
                  32335.8
                ],
                "bounds": [
                  [
                    48396.9,
                    32203.8
                  ],
                  [
                    48591.1,
                    32479.9
                  ],
                  [
                    48747,
                    32452
                  ],
                  [
                    48730.4,
                    32207.4
                  ],
                  [
                    48396.9,
                    32203.8
                  ]
                ],
                "id": 946,
                "chat_link": "[&BLIDAAA=]"
              }
            },
            "adventures": [],
            "id": 73,
            "mastery_points": [
              {
                "coord": [
                  49879.3,
                  33067.6
                ],
                "id": 324,
                "region": "Tyria"
              }
            ]
          },
          "248": {
            "name": "Salma District (Home)",
            "min_level": 0,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {
              "261": {
                "name": "Vanguard Hospital",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44353.8,
                  26577.9
                ],
                "id": 261,
                "chat_link": "[&BAUBAAA=]"
              },
              "262": {
                "name": "Queen's Heart Orphanage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44280.3,
                  26860.6
                ],
                "id": 262,
                "chat_link": "[&BAYBAAA=]"
              },
              "266": {
                "name": "Manor Hill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44154,
                  26741.5
                ],
                "id": 266,
                "chat_link": "[&BAoBAAA=]"
              },
              "267": {
                "name": "Cottage Bend",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44355.6,
                  26907.3
                ],
                "id": 267,
                "chat_link": "[&BAsBAAA=]"
              },
              "268": {
                "name": "Rook's Row",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44383.1,
                  26758.6
                ],
                "id": 268,
                "chat_link": "[&BAwBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "187": {
                "name": "Salma District (Home)",
                "level": 0,
                "coord": [
                  44309.2,
                  26738.4
                ],
                "bounds": [
                  [
                    44409.9,
                    26426.2
                  ],
                  [
                    44262.5,
                    26365.6
                  ],
                  [
                    44194.7,
                    26638
                  ],
                  [
                    44128.4,
                    26704.4
                  ],
                  [
                    44054.6,
                    26742.7
                  ],
                  [
                    44054.2,
                    26822.1
                  ],
                  [
                    44129.5,
                    26847.2
                  ],
                  [
                    44224.3,
                    26883.8
                  ],
                  [
                    44296.2,
                    26924.9
                  ],
                  [
                    44344.8,
                    26997.1
                  ],
                  [
                    44427,
                    26942.6
                  ],
                  [
                    44427.7,
                    26872.1
                  ],
                  [
                    44478.9,
                    26761.8
                  ],
                  [
                    44663.5,
                    26630.9
                  ],
                  [
                    44542.4,
                    26517.4
                  ],
                  [
                    44409.9,
                    26426.2
                  ]
                ],
                "id": 187,
                "chat_link": "[&BLsAAAA=]"
              }
            },
            "id": 248,
            "mastery_points": [],
            "adventures": []
          },
          "330": {
            "name": "Seraph Headquarters",
            "min_level": 0,
            "max_level": 15,
            "default_floor": 2,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "id": 330,
            "mastery_points": [],
            "adventures": []
          },
          "335": {
            "name": "Claw Island",
            "min_level": 60,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              47488,
              32896
            ],
            "map_rect": [
              [
                -18432,
                -18432
              ],
              [
                18432,
                18432
              ]
            ],
            "continent_rect": [
              [
                46720,
                32256
              ],
              [
                48256,
                33792
              ]
            ],
            "points_of_interest": {
              "1229": {
                "name": "Lion's Torch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47430.9,
                  32667.7
                ],
                "id": 1229,
                "chat_link": "[&BM0EAAA=]"
              },
              "1274": {
                "name": "Eastern Pyramid",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48180.8,
                  32760
                ],
                "id": 1274,
                "chat_link": "[&BPoEAAA=]"
              },
              "1275": {
                "name": "Maw and Pride",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47961,
                  33040.1
                ],
                "id": 1275,
                "chat_link": "[&BPsEAAA=]"
              },
              "1276": {
                "name": "Western Pyramid",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47086.8,
                  32609
                ],
                "id": 1276,
                "chat_link": "[&BPwEAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "857": {
                "name": "Sorrow's Bay",
                "level": 60,
                "coord": [
                  47789.3,
                  32606.8
                ],
                "bounds": [
                  [
                    47595.8,
                    32598.2
                  ],
                  [
                    47402.3,
                    32643.4
                  ],
                  [
                    47171.4,
                    32374.5
                  ],
                  [
                    48284.6,
                    32300.7
                  ],
                  [
                    48352.1,
                    32428.1
                  ],
                  [
                    48196.3,
                    32909.4
                  ],
                  [
                    47714.1,
                    32819.7
                  ],
                  [
                    47597.9,
                    32780
                  ],
                  [
                    47595.8,
                    32598.2
                  ]
                ],
                "id": 857,
                "chat_link": "[&BFkDAAA=]"
              },
              "968": {
                "name": "Lion's Mane",
                "level": 60,
                "coord": [
                  47657.7,
                  33174.6
                ],
                "bounds": [
                  [
                    47398,
                    33020.8
                  ],
                  [
                    47423.2,
                    33008.6
                  ],
                  [
                    47530,
                    32918.7
                  ],
                  [
                    47621.7,
                    32956.9
                  ],
                  [
                    47715.2,
                    32817.6
                  ],
                  [
                    48195.5,
                    32908.2
                  ],
                  [
                    48246.1,
                    33815
                  ],
                  [
                    47425.2,
                    33873.4
                  ],
                  [
                    47364.5,
                    33252.6
                  ],
                  [
                    47398,
                    33020.8
                  ]
                ],
                "id": 968,
                "chat_link": "[&BMgDAAA=]"
              },
              "969": {
                "name": "Western Strait",
                "level": 60,
                "coord": [
                  47220.9,
                  33043.9
                ],
                "bounds": [
                  [
                    46607.6,
                    33572.5
                  ],
                  [
                    46894,
                    32684.2
                  ],
                  [
                    47171.4,
                    32374.5
                  ],
                  [
                    47401.4,
                    32639.7
                  ],
                  [
                    47352.8,
                    32775.4
                  ],
                  [
                    47306.2,
                    32813.1
                  ],
                  [
                    47278.7,
                    32869.9
                  ],
                  [
                    47274.2,
                    32911.2
                  ],
                  [
                    47279.3,
                    32946.9
                  ],
                  [
                    47309.4,
                    32984
                  ],
                  [
                    47344.7,
                    33007.6
                  ],
                  [
                    47397.3,
                    33020.2
                  ],
                  [
                    47364.9,
                    33252.8
                  ],
                  [
                    47424.7,
                    33875.3
                  ],
                  [
                    46906.8,
                    33930.7
                  ],
                  [
                    46607.6,
                    33572.5
                  ]
                ],
                "id": 969,
                "chat_link": "[&BMkDAAA=]"
              },
              "970": {
                "name": "Fort Stalwart",
                "level": 60,
                "coord": [
                  47427.1,
                  32869.3
                ],
                "bounds": [
                  [
                    47274.7,
                    32950.8
                  ],
                  [
                    47268.5,
                    32911.4
                  ],
                  [
                    47272.3,
                    32867.6
                  ],
                  [
                    47303.1,
                    32806.2
                  ],
                  [
                    47348.6,
                    32770.2
                  ],
                  [
                    47400.8,
                    32639.6
                  ],
                  [
                    47599.5,
                    32593.8
                  ],
                  [
                    47600.5,
                    32777.3
                  ],
                  [
                    47715.7,
                    32818
                  ],
                  [
                    47622,
                    32957.2
                  ],
                  [
                    47530,
                    32919.2
                  ],
                  [
                    47423.5,
                    33008.8
                  ],
                  [
                    47398.3,
                    33020.6
                  ],
                  [
                    47342.7,
                    33011.5
                  ],
                  [
                    47306.5,
                    32987.9
                  ],
                  [
                    47274.7,
                    32950.8
                  ]
                ],
                "id": 970,
                "chat_link": "[&BMoDAAA=]"
              }
            },
            "adventures": [],
            "id": 335,
            "mastery_points": []
          },
          "336": {
            "name": "Chantry of Secrets",
            "min_level": 45,
            "max_level": 55,
            "default_floor": -3,
            "label_coord": [
              49212,
              33792
            ],
            "map_rect": [
              [
                -12288,
                -12288
              ],
              [
                12288,
                12288
              ]
            ],
            "continent_rect": [
              [
                48768,
                32384
              ],
              [
                49792,
                33408
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 336,
            "mastery_points": []
          },
          "378": {
            "name": "Queen's Throne Room",
            "min_level": 0,
            "max_level": 15,
            "default_floor": 2,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "id": 378,
            "mastery_points": [],
            "adventures": []
          },
          "830": {
            "name": "Vigil Headquarters",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {
              "124": {
                "name": "Vigil HQ",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49417.3,
                  28868.2
                ],
                "id": 124,
                "chat_link": "[&BHwAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "948": {
                "name": "Vigil Keep",
                "level": 29,
                "coord": [
                  49263.7,
                  28645.4
                ],
                "bounds": [
                  [
                    48876.7,
                    28634.6
                  ],
                  [
                    49446.1,
                    28355.1
                  ],
                  [
                    49542.8,
                    28427.9
                  ],
                  [
                    49647.6,
                    28482.1
                  ],
                  [
                    49582,
                    28945.2
                  ],
                  [
                    48891,
                    28906.3
                  ],
                  [
                    48860,
                    28766.6
                  ],
                  [
                    48876.7,
                    28634.6
                  ]
                ],
                "id": 948,
                "chat_link": "[&BLQDAAA=]"
              }
            },
            "adventures": [],
            "id": 830,
            "mastery_points": []
          },
          "873": {
            "name": "Southsun Cove",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45668,
              36216
            ],
            "map_rect": [
              [
                -30720,
                -21504
              ],
              [
                33792,
                21504
              ]
            ],
            "continent_rect": [
              [
                44288,
                35328
              ],
              [
                46976,
                37120
              ]
            ],
            "points_of_interest": {
              "1744": {
                "name": "Lion Point Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  45546,
                  35647.4
                ],
                "id": 1744,
                "chat_link": "[&BNAGAAA=]"
              },
              "1746": {
                "name": "Pride Point Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46637.7,
                  35611.8
                ],
                "id": 1746,
                "chat_link": "[&BNIGAAA=]"
              },
              "1748": {
                "name": "Onyx Field",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46286.7,
                  36236.7
                ],
                "id": 1748,
                "chat_link": "[&BNQGAAA=]"
              },
              "1749": {
                "name": "Pearl Islet Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46589.2,
                  36791.8
                ],
                "id": 1749,
                "chat_link": "[&BNUGAAA=]"
              },
              "1750": {
                "name": "Privateer's Moorage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46066.4,
                  36859.4
                ],
                "id": 1750,
                "chat_link": "[&BNYGAAA=]"
              },
              "1751": {
                "name": "Camp Karka Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  45605.9,
                  36766.5
                ],
                "id": 1751,
                "chat_link": "[&BNcGAAA=]"
              },
              "1752": {
                "name": "Owain's Refuge Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44683.5,
                  36898.4
                ],
                "id": 1752,
                "chat_link": "[&BNgGAAA=]"
              },
              "1753": {
                "name": "Ember Passage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45378,
                  36002.4
                ],
                "id": 1753,
                "chat_link": "[&BNkGAAA=]"
              },
              "1754": {
                "name": "Canach's Folly",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44971.7,
                  36698.8
                ],
                "id": 1754,
                "chat_link": "[&BNoGAAA=]"
              },
              "1755": {
                "name": "Karka Hive",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45164.9,
                  35922
                ],
                "id": 1755,
                "chat_link": "[&BNsGAAA=]"
              },
              "1756": {
                "name": "Kiel's Outpost Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46363.5,
                  36069.5
                ],
                "id": 1756,
                "chat_link": "[&BNwGAAA=]"
              },
              "1802": {
                "name": "Steampipe Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45877.5,
                  36201.7
                ],
                "id": 1802,
                "chat_link": "[&BAoHAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1088": {
                "name": "Southsun Shoals",
                "level": 80,
                "coord": [
                  45924.9,
                  35840.5
                ],
                "bounds": [
                  [
                    45123,
                    35691
                  ],
                  [
                    45407.2,
                    35782.7
                  ],
                  [
                    45538.4,
                    35995.2
                  ],
                  [
                    45488.6,
                    36129.1
                  ],
                  [
                    45756.5,
                    36003.5
                  ],
                  [
                    45858.2,
                    36070.3
                  ],
                  [
                    46087.4,
                    36098.3
                  ],
                  [
                    46221.9,
                    36029.5
                  ],
                  [
                    46480.9,
                    36212.2
                  ],
                  [
                    46889.5,
                    36204.4
                  ],
                  [
                    46931.3,
                    35742.3
                  ],
                  [
                    46624.5,
                    35488.7
                  ],
                  [
                    45859.4,
                    35321.2
                  ],
                  [
                    45422.5,
                    35495.9
                  ],
                  [
                    45184.7,
                    35343.4
                  ],
                  [
                    45123,
                    35691
                  ]
                ],
                "id": 1088,
                "chat_link": "[&BEAEAAA=]"
              },
              "1089": {
                "name": "Dappled Shores",
                "level": 80,
                "coord": [
                  46399.9,
                  36456
                ],
                "bounds": [
                  [
                    46326,
                    36874.7
                  ],
                  [
                    46270.4,
                    36597.2
                  ],
                  [
                    45987.8,
                    36489.3
                  ],
                  [
                    46015.3,
                    36332.3
                  ],
                  [
                    46142.5,
                    36312.4
                  ],
                  [
                    46080.5,
                    36100
                  ],
                  [
                    46219.7,
                    36021.8
                  ],
                  [
                    46482.2,
                    36202.6
                  ],
                  [
                    46887,
                    36203.4
                  ],
                  [
                    46946.4,
                    36541.7
                  ],
                  [
                    46664.6,
                    36543.3
                  ],
                  [
                    46571.3,
                    36581
                  ],
                  [
                    46583.9,
                    36683
                  ],
                  [
                    46421.1,
                    36901.3
                  ],
                  [
                    46326,
                    36874.7
                  ]
                ],
                "id": 1089,
                "chat_link": "[&BEEEAAA=]"
              },
              "1090": {
                "name": "Pearl Islet",
                "level": 80,
                "coord": [
                  46666.4,
                  36796.3
                ],
                "bounds": [
                  [
                    46417.8,
                    36895.9
                  ],
                  [
                    46582.1,
                    36678.5
                  ],
                  [
                    46567.4,
                    36580.1
                  ],
                  [
                    46666.1,
                    36538.1
                  ],
                  [
                    46946.5,
                    36535.6
                  ],
                  [
                    46915.3,
                    36956.8
                  ],
                  [
                    46820,
                    37068.3
                  ],
                  [
                    46415.7,
                    37117.2
                  ],
                  [
                    46417.8,
                    36895.9
                  ]
                ],
                "id": 1090,
                "chat_link": "[&BEIEAAA=]"
              },
              "1091": {
                "name": "Sawtooth Bay",
                "level": 80,
                "coord": [
                  46102.6,
                  36813.9
                ],
                "bounds": [
                  [
                    45981.4,
                    36483.8
                  ],
                  [
                    45732.1,
                    36531.4
                  ],
                  [
                    45845,
                    36723.8
                  ],
                  [
                    45805.9,
                    37086.8
                  ],
                  [
                    46112.1,
                    37028.3
                  ],
                  [
                    46422,
                    37116
                  ],
                  [
                    46424.9,
                    36890.7
                  ],
                  [
                    46326,
                    36867
                  ],
                  [
                    46274.3,
                    36597.6
                  ],
                  [
                    45981.4,
                    36483.8
                  ]
                ],
                "id": 1091,
                "chat_link": "[&BEMEAAA=]"
              },
              "1092": {
                "name": "Captain's Retreat",
                "level": 80,
                "coord": [
                  45556.9,
                  36786.2
                ],
                "bounds": [
                  [
                    45437.9,
                    36807.5
                  ],
                  [
                    45619.9,
                    36552.6
                  ],
                  [
                    45735.1,
                    36532
                  ],
                  [
                    45845.6,
                    36722.8
                  ],
                  [
                    45806.1,
                    37086.7
                  ],
                  [
                    45224.7,
                    36965.6
                  ],
                  [
                    45229.3,
                    36836.4
                  ],
                  [
                    45437.9,
                    36807.5
                  ]
                ],
                "id": 1092,
                "chat_link": "[&BEQEAAA=]"
              },
              "1093": {
                "name": "Owain's Refuge",
                "level": 80,
                "coord": [
                  44639.7,
                  36766.9
                ],
                "bounds": [
                  [
                    44384.6,
                    36497.7
                  ],
                  [
                    44650.3,
                    36359.6
                  ],
                  [
                    44771.1,
                    36764.5
                  ],
                  [
                    44983.2,
                    36993.1
                  ],
                  [
                    44800,
                    37032.5
                  ],
                  [
                    44504,
                    36983.5
                  ],
                  [
                    44385,
                    36737.7
                  ],
                  [
                    44384.6,
                    36497.7
                  ]
                ],
                "id": 1093,
                "chat_link": "[&BEUEAAA=]"
              },
              "1094": {
                "name": "Driftglass Springs",
                "level": 80,
                "coord": [
                  45653.2,
                  36393.2
                ],
                "bounds": [
                  [
                    45238.4,
                    36717.9
                  ],
                  [
                    45221.9,
                    36861.9
                  ],
                  [
                    45426.1,
                    36822.9
                  ],
                  [
                    45618,
                    36552.9
                  ],
                  [
                    45998.2,
                    36485.1
                  ],
                  [
                    46020.3,
                    36339.5
                  ],
                  [
                    46145.4,
                    36324.8
                  ],
                  [
                    46083.1,
                    36103.2
                  ],
                  [
                    45858,
                    36072.9
                  ],
                  [
                    45755.1,
                    36001.7
                  ],
                  [
                    45486.9,
                    36130
                  ],
                  [
                    45447.7,
                    36271.4
                  ],
                  [
                    45192.3,
                    36427.5
                  ],
                  [
                    45238.4,
                    36717.9
                  ]
                ],
                "id": 1094,
                "chat_link": "[&BEYEAAA=]"
              },
              "1095": {
                "name": "Scoured Plains",
                "level": 80,
                "coord": [
                  45028.2,
                  36677.9
                ],
                "bounds": [
                  [
                    44983.9,
                    36993.9
                  ],
                  [
                    44766.4,
                    36764.7
                  ],
                  [
                    44697.7,
                    36525
                  ],
                  [
                    45095.1,
                    36348.6
                  ],
                  [
                    45193.2,
                    36428.1
                  ],
                  [
                    45239,
                    36718.5
                  ],
                  [
                    45221.9,
                    36966.7
                  ],
                  [
                    44983.9,
                    36993.9
                  ]
                ],
                "id": 1095,
                "chat_link": "[&BEcEAAA=]"
              },
              "1096": {
                "name": "Seashell Hills",
                "level": 80,
                "coord": [
                  44833.6,
                  36143.4
                ],
                "bounds": [
                  [
                    44699.9,
                    36526
                  ],
                  [
                    44603,
                    36156.1
                  ],
                  [
                    44621.5,
                    35918.8
                  ],
                  [
                    44877.7,
                    35799.3
                  ],
                  [
                    45102.9,
                    36110.2
                  ],
                  [
                    45096.5,
                    36350.1
                  ],
                  [
                    44699.9,
                    36526
                  ]
                ],
                "id": 1096,
                "chat_link": "[&BEgEAAA=]"
              },
              "1097": {
                "name": "Bakestone Cavern",
                "level": 80,
                "coord": [
                  45222.5,
                  36055.3
                ],
                "bounds": [
                  [
                    45192.1,
                    36445
                  ],
                  [
                    45092.4,
                    36353.3
                  ],
                  [
                    45099.8,
                    36111.1
                  ],
                  [
                    44874.8,
                    35799.4
                  ],
                  [
                    45122.8,
                    35690.5
                  ],
                  [
                    45408.4,
                    35781.6
                  ],
                  [
                    45545.2,
                    35993.6
                  ],
                  [
                    45444.7,
                    36268
                  ],
                  [
                    45192.1,
                    36445
                  ]
                ],
                "id": 1097,
                "chat_link": "[&BEkEAAA=]"
              },
              "1098": {
                "name": "Southsun Strait",
                "level": 80,
                "coord": [
                  44619.1,
                  35822.3
                ],
                "bounds": [
                  [
                    44084.1,
                    36115.1
                  ],
                  [
                    44386.9,
                    36501.8
                  ],
                  [
                    44649.7,
                    36359.9
                  ],
                  [
                    44602.9,
                    36155.7
                  ],
                  [
                    44622.3,
                    35919
                  ],
                  [
                    44877.4,
                    35798
                  ],
                  [
                    45123,
                    35691.8
                  ],
                  [
                    45185.8,
                    35340.8
                  ],
                  [
                    44771.3,
                    35448.4
                  ],
                  [
                    44380.6,
                    35361
                  ],
                  [
                    44126.1,
                    35354.1
                  ],
                  [
                    44084.1,
                    36115.1
                  ]
                ],
                "id": 1098,
                "chat_link": "[&BEoEAAA=]"
              }
            },
            "adventures": [],
            "id": 873,
            "mastery_points": []
          },
          "905": {
            "name": "Crab Toss",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              45668,
              36216
            ],
            "map_rect": [
              [
                -30720,
                -21504
              ],
              [
                33792,
                21504
              ]
            ],
            "continent_rect": [
              [
                44288,
                35328
              ],
              [
                46976,
                37120
              ]
            ],
            "points_of_interest": {
              "1748": {
                "name": "Onyx Field",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46286.7,
                  36236.7
                ],
                "id": 1748,
                "chat_link": "[&BNQGAAA=]"
              },
              "1750": {
                "name": "Privateer's Moorage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46066.4,
                  36859.4
                ],
                "id": 1750,
                "chat_link": "[&BNYGAAA=]"
              },
              "1753": {
                "name": "Ember Passage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45378,
                  36002.4
                ],
                "id": 1753,
                "chat_link": "[&BNkGAAA=]"
              },
              "1754": {
                "name": "Canach's Folly",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44971.7,
                  36698.8
                ],
                "id": 1754,
                "chat_link": "[&BNoGAAA=]"
              },
              "1755": {
                "name": "Karka Hive",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45164.9,
                  35922
                ],
                "id": 1755,
                "chat_link": "[&BNsGAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1091": {
                "name": "Sawtooth Bay",
                "level": 80,
                "coord": [
                  46102.6,
                  36813.9
                ],
                "bounds": [
                  [
                    45981.4,
                    36483.8
                  ],
                  [
                    45732.1,
                    36531.4
                  ],
                  [
                    45845,
                    36723.8
                  ],
                  [
                    45805.9,
                    37086.8
                  ],
                  [
                    46112.1,
                    37028.3
                  ],
                  [
                    46422,
                    37116
                  ],
                  [
                    46424.9,
                    36890.7
                  ],
                  [
                    46326,
                    36867
                  ],
                  [
                    46274.3,
                    36597.6
                  ],
                  [
                    45981.4,
                    36483.8
                  ]
                ],
                "id": 1091,
                "chat_link": "[&BEMEAAA=]"
              }
            },
            "adventures": [],
            "id": 905,
            "mastery_points": []
          },
          "914": {
            "name": "The Dead End",
            "min_level": 1,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {
              "1805": {
                "name": "The Dead End",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44361.8,
                  27847.8
                ],
                "id": 1805,
                "chat_link": "[&BA0HAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "736": {
                "name": "Eastern Commons",
                "level": 0,
                "coord": [
                  44277.2,
                  27723
                ],
                "bounds": [
                  [
                    44344,
                    27466.1
                  ],
                  [
                    44447.2,
                    27528.3
                  ],
                  [
                    44435.8,
                    27653.3
                  ],
                  [
                    44594.2,
                    27862.4
                  ],
                  [
                    44489,
                    27944.1
                  ],
                  [
                    44347.1,
                    28008.4
                  ],
                  [
                    44180.8,
                    28027.1
                  ],
                  [
                    44179,
                    27829.3
                  ],
                  [
                    44116.2,
                    27740.5
                  ],
                  [
                    44054.3,
                    27737.5
                  ],
                  [
                    44052.9,
                    27623.9
                  ],
                  [
                    44130.3,
                    27606.8
                  ],
                  [
                    44222.9,
                    27572.6
                  ],
                  [
                    44287.2,
                    27522.2
                  ],
                  [
                    44344,
                    27466.1
                  ]
                ],
                "id": 736,
                "chat_link": "[&BOACAAA=]"
              }
            },
            "adventures": [],
            "id": 914,
            "mastery_points": []
          },
          "924": {
            "name": "Grandmaster of Om",
            "min_level": 1,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "id": 924,
            "mastery_points": [],
            "adventures": []
          },
          "932": {
            "name": "Closing Ceremony",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {
              "812": {
                "name": "Crown Pavilion Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43628.3,
                  27229.6
                ],
                "id": 812,
                "chat_link": "[&BCwDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 932,
            "mastery_points": []
          },
          "999": {
            "name": "Trouble at Fort Salma",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "77": {
                "name": "Fort Salma",
                "level": 23,
                "coord": [
                  42863.9,
                  30543.3
                ],
                "bounds": [
                  [
                    43137.2,
                    30458.5
                  ],
                  [
                    43057.7,
                    30376.9
                  ],
                  [
                    42661.4,
                    30396
                  ],
                  [
                    42527.5,
                    30509.5
                  ],
                  [
                    42732.1,
                    30763.9
                  ],
                  [
                    43067.6,
                    30755.1
                  ],
                  [
                    43137.2,
                    30458.5
                  ]
                ],
                "id": 77,
                "chat_link": "[&BE0AAAA=]"
              }
            },
            "adventures": [],
            "id": 999,
            "mastery_points": []
          },
          "1008": {
            "name": "The Ghosts of Fort Salma",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1008,
            "mastery_points": []
          },
          "1063": {
            "name": "Southsun Crab Toss",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45668,
              36216
            ],
            "map_rect": [
              [
                -30720,
                -21504
              ],
              [
                33792,
                21504
              ]
            ],
            "continent_rect": [
              [
                44288,
                35328
              ],
              [
                46976,
                37120
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1088": {
                "name": "Southsun Shoals",
                "level": 80,
                "coord": [
                  45924.9,
                  35840.5
                ],
                "bounds": [
                  [
                    45123,
                    35691
                  ],
                  [
                    45407.2,
                    35782.7
                  ],
                  [
                    45538.4,
                    35995.2
                  ],
                  [
                    45488.6,
                    36129.1
                  ],
                  [
                    45756.5,
                    36003.5
                  ],
                  [
                    45858.2,
                    36070.3
                  ],
                  [
                    46087.4,
                    36098.3
                  ],
                  [
                    46221.9,
                    36029.5
                  ],
                  [
                    46480.9,
                    36212.2
                  ],
                  [
                    46889.5,
                    36204.4
                  ],
                  [
                    46931.3,
                    35742.3
                  ],
                  [
                    46624.5,
                    35488.7
                  ],
                  [
                    45859.4,
                    35321.2
                  ],
                  [
                    45422.5,
                    35495.9
                  ],
                  [
                    45184.7,
                    35343.4
                  ],
                  [
                    45123,
                    35691
                  ]
                ],
                "id": 1088,
                "chat_link": "[&BEAEAAA=]"
              },
              "1089": {
                "name": "Dappled Shores",
                "level": 80,
                "coord": [
                  46399.9,
                  36456
                ],
                "bounds": [
                  [
                    46326,
                    36874.7
                  ],
                  [
                    46270.4,
                    36597.2
                  ],
                  [
                    45987.8,
                    36489.3
                  ],
                  [
                    46015.3,
                    36332.3
                  ],
                  [
                    46142.5,
                    36312.4
                  ],
                  [
                    46080.5,
                    36100
                  ],
                  [
                    46219.7,
                    36021.8
                  ],
                  [
                    46482.2,
                    36202.6
                  ],
                  [
                    46887,
                    36203.4
                  ],
                  [
                    46946.4,
                    36541.7
                  ],
                  [
                    46664.6,
                    36543.3
                  ],
                  [
                    46571.3,
                    36581
                  ],
                  [
                    46583.9,
                    36683
                  ],
                  [
                    46421.1,
                    36901.3
                  ],
                  [
                    46326,
                    36874.7
                  ]
                ],
                "id": 1089,
                "chat_link": "[&BEEEAAA=]"
              },
              "1090": {
                "name": "Pearl Islet",
                "level": 80,
                "coord": [
                  46666.4,
                  36796.3
                ],
                "bounds": [
                  [
                    46417.8,
                    36895.9
                  ],
                  [
                    46582.1,
                    36678.5
                  ],
                  [
                    46567.4,
                    36580.1
                  ],
                  [
                    46666.1,
                    36538.1
                  ],
                  [
                    46946.5,
                    36535.6
                  ],
                  [
                    46915.3,
                    36956.8
                  ],
                  [
                    46820,
                    37068.3
                  ],
                  [
                    46415.7,
                    37117.2
                  ],
                  [
                    46417.8,
                    36895.9
                  ]
                ],
                "id": 1090,
                "chat_link": "[&BEIEAAA=]"
              },
              "1091": {
                "name": "Sawtooth Bay",
                "level": 80,
                "coord": [
                  46102.6,
                  36813.9
                ],
                "bounds": [
                  [
                    45981.4,
                    36483.8
                  ],
                  [
                    45732.1,
                    36531.4
                  ],
                  [
                    45845,
                    36723.8
                  ],
                  [
                    45805.9,
                    37086.8
                  ],
                  [
                    46112.1,
                    37028.3
                  ],
                  [
                    46422,
                    37116
                  ],
                  [
                    46424.9,
                    36890.7
                  ],
                  [
                    46326,
                    36867
                  ],
                  [
                    46274.3,
                    36597.6
                  ],
                  [
                    45981.4,
                    36483.8
                  ]
                ],
                "id": 1091,
                "chat_link": "[&BEMEAAA=]"
              },
              "1092": {
                "name": "Captain's Retreat",
                "level": 80,
                "coord": [
                  45556.9,
                  36786.2
                ],
                "bounds": [
                  [
                    45437.9,
                    36807.5
                  ],
                  [
                    45619.9,
                    36552.6
                  ],
                  [
                    45735.1,
                    36532
                  ],
                  [
                    45845.6,
                    36722.8
                  ],
                  [
                    45806.1,
                    37086.7
                  ],
                  [
                    45224.7,
                    36965.6
                  ],
                  [
                    45229.3,
                    36836.4
                  ],
                  [
                    45437.9,
                    36807.5
                  ]
                ],
                "id": 1092,
                "chat_link": "[&BEQEAAA=]"
              },
              "1093": {
                "name": "Owain's Refuge",
                "level": 80,
                "coord": [
                  44639.7,
                  36766.9
                ],
                "bounds": [
                  [
                    44384.6,
                    36497.7
                  ],
                  [
                    44650.3,
                    36359.6
                  ],
                  [
                    44771.1,
                    36764.5
                  ],
                  [
                    44983.2,
                    36993.1
                  ],
                  [
                    44800,
                    37032.5
                  ],
                  [
                    44504,
                    36983.5
                  ],
                  [
                    44385,
                    36737.7
                  ],
                  [
                    44384.6,
                    36497.7
                  ]
                ],
                "id": 1093,
                "chat_link": "[&BEUEAAA=]"
              },
              "1094": {
                "name": "Driftglass Springs",
                "level": 80,
                "coord": [
                  45653.2,
                  36393.2
                ],
                "bounds": [
                  [
                    45238.4,
                    36717.9
                  ],
                  [
                    45221.9,
                    36861.9
                  ],
                  [
                    45426.1,
                    36822.9
                  ],
                  [
                    45618,
                    36552.9
                  ],
                  [
                    45998.2,
                    36485.1
                  ],
                  [
                    46020.3,
                    36339.5
                  ],
                  [
                    46145.4,
                    36324.8
                  ],
                  [
                    46083.1,
                    36103.2
                  ],
                  [
                    45858,
                    36072.9
                  ],
                  [
                    45755.1,
                    36001.7
                  ],
                  [
                    45486.9,
                    36130
                  ],
                  [
                    45447.7,
                    36271.4
                  ],
                  [
                    45192.3,
                    36427.5
                  ],
                  [
                    45238.4,
                    36717.9
                  ]
                ],
                "id": 1094,
                "chat_link": "[&BEYEAAA=]"
              },
              "1095": {
                "name": "Scoured Plains",
                "level": 80,
                "coord": [
                  45028.2,
                  36677.9
                ],
                "bounds": [
                  [
                    44983.9,
                    36993.9
                  ],
                  [
                    44766.4,
                    36764.7
                  ],
                  [
                    44697.7,
                    36525
                  ],
                  [
                    45095.1,
                    36348.6
                  ],
                  [
                    45193.2,
                    36428.1
                  ],
                  [
                    45239,
                    36718.5
                  ],
                  [
                    45221.9,
                    36966.7
                  ],
                  [
                    44983.9,
                    36993.9
                  ]
                ],
                "id": 1095,
                "chat_link": "[&BEcEAAA=]"
              },
              "1096": {
                "name": "Seashell Hills",
                "level": 80,
                "coord": [
                  44833.6,
                  36143.4
                ],
                "bounds": [
                  [
                    44699.9,
                    36526
                  ],
                  [
                    44603,
                    36156.1
                  ],
                  [
                    44621.5,
                    35918.8
                  ],
                  [
                    44877.7,
                    35799.3
                  ],
                  [
                    45102.9,
                    36110.2
                  ],
                  [
                    45096.5,
                    36350.1
                  ],
                  [
                    44699.9,
                    36526
                  ]
                ],
                "id": 1096,
                "chat_link": "[&BEgEAAA=]"
              },
              "1097": {
                "name": "Bakestone Cavern",
                "level": 80,
                "coord": [
                  45222.5,
                  36055.3
                ],
                "bounds": [
                  [
                    45192.1,
                    36445
                  ],
                  [
                    45092.4,
                    36353.3
                  ],
                  [
                    45099.8,
                    36111.1
                  ],
                  [
                    44874.8,
                    35799.4
                  ],
                  [
                    45122.8,
                    35690.5
                  ],
                  [
                    45408.4,
                    35781.6
                  ],
                  [
                    45545.2,
                    35993.6
                  ],
                  [
                    45444.7,
                    36268
                  ],
                  [
                    45192.1,
                    36445
                  ]
                ],
                "id": 1097,
                "chat_link": "[&BEkEAAA=]"
              },
              "1098": {
                "name": "Southsun Strait",
                "level": 80,
                "coord": [
                  44619.1,
                  35822.3
                ],
                "bounds": [
                  [
                    44084.1,
                    36115.1
                  ],
                  [
                    44386.9,
                    36501.8
                  ],
                  [
                    44649.7,
                    36359.9
                  ],
                  [
                    44602.9,
                    36155.7
                  ],
                  [
                    44622.3,
                    35919
                  ],
                  [
                    44877.4,
                    35798
                  ],
                  [
                    45123,
                    35691.8
                  ],
                  [
                    45185.8,
                    35340.8
                  ],
                  [
                    44771.3,
                    35448.4
                  ],
                  [
                    44380.6,
                    35361
                  ],
                  [
                    44126.1,
                    35354.1
                  ],
                  [
                    44084.1,
                    36115.1
                  ]
                ],
                "id": 1098,
                "chat_link": "[&BEoEAAA=]"
              }
            },
            "adventures": [],
            "id": 1063,
            "mastery_points": []
          },
          "1072": {
            "name": "Southsun Crab Toss",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45668,
              36216
            ],
            "map_rect": [
              [
                -30720,
                -21504
              ],
              [
                33792,
                21504
              ]
            ],
            "continent_rect": [
              [
                44288,
                35328
              ],
              [
                46976,
                37120
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1088": {
                "name": "Southsun Shoals",
                "level": 80,
                "coord": [
                  45924.9,
                  35840.5
                ],
                "bounds": [
                  [
                    45123,
                    35691
                  ],
                  [
                    45407.2,
                    35782.7
                  ],
                  [
                    45538.4,
                    35995.2
                  ],
                  [
                    45488.6,
                    36129.1
                  ],
                  [
                    45756.5,
                    36003.5
                  ],
                  [
                    45858.2,
                    36070.3
                  ],
                  [
                    46087.4,
                    36098.3
                  ],
                  [
                    46221.9,
                    36029.5
                  ],
                  [
                    46480.9,
                    36212.2
                  ],
                  [
                    46889.5,
                    36204.4
                  ],
                  [
                    46931.3,
                    35742.3
                  ],
                  [
                    46624.5,
                    35488.7
                  ],
                  [
                    45859.4,
                    35321.2
                  ],
                  [
                    45422.5,
                    35495.9
                  ],
                  [
                    45184.7,
                    35343.4
                  ],
                  [
                    45123,
                    35691
                  ]
                ],
                "id": 1088,
                "chat_link": "[&BEAEAAA=]"
              },
              "1089": {
                "name": "Dappled Shores",
                "level": 80,
                "coord": [
                  46399.9,
                  36456
                ],
                "bounds": [
                  [
                    46326,
                    36874.7
                  ],
                  [
                    46270.4,
                    36597.2
                  ],
                  [
                    45987.8,
                    36489.3
                  ],
                  [
                    46015.3,
                    36332.3
                  ],
                  [
                    46142.5,
                    36312.4
                  ],
                  [
                    46080.5,
                    36100
                  ],
                  [
                    46219.7,
                    36021.8
                  ],
                  [
                    46482.2,
                    36202.6
                  ],
                  [
                    46887,
                    36203.4
                  ],
                  [
                    46946.4,
                    36541.7
                  ],
                  [
                    46664.6,
                    36543.3
                  ],
                  [
                    46571.3,
                    36581
                  ],
                  [
                    46583.9,
                    36683
                  ],
                  [
                    46421.1,
                    36901.3
                  ],
                  [
                    46326,
                    36874.7
                  ]
                ],
                "id": 1089,
                "chat_link": "[&BEEEAAA=]"
              },
              "1090": {
                "name": "Pearl Islet",
                "level": 80,
                "coord": [
                  46666.4,
                  36796.3
                ],
                "bounds": [
                  [
                    46417.8,
                    36895.9
                  ],
                  [
                    46582.1,
                    36678.5
                  ],
                  [
                    46567.4,
                    36580.1
                  ],
                  [
                    46666.1,
                    36538.1
                  ],
                  [
                    46946.5,
                    36535.6
                  ],
                  [
                    46915.3,
                    36956.8
                  ],
                  [
                    46820,
                    37068.3
                  ],
                  [
                    46415.7,
                    37117.2
                  ],
                  [
                    46417.8,
                    36895.9
                  ]
                ],
                "id": 1090,
                "chat_link": "[&BEIEAAA=]"
              },
              "1091": {
                "name": "Sawtooth Bay",
                "level": 80,
                "coord": [
                  46102.6,
                  36813.9
                ],
                "bounds": [
                  [
                    45981.4,
                    36483.8
                  ],
                  [
                    45732.1,
                    36531.4
                  ],
                  [
                    45845,
                    36723.8
                  ],
                  [
                    45805.9,
                    37086.8
                  ],
                  [
                    46112.1,
                    37028.3
                  ],
                  [
                    46422,
                    37116
                  ],
                  [
                    46424.9,
                    36890.7
                  ],
                  [
                    46326,
                    36867
                  ],
                  [
                    46274.3,
                    36597.6
                  ],
                  [
                    45981.4,
                    36483.8
                  ]
                ],
                "id": 1091,
                "chat_link": "[&BEMEAAA=]"
              },
              "1092": {
                "name": "Captain's Retreat",
                "level": 80,
                "coord": [
                  45556.9,
                  36786.2
                ],
                "bounds": [
                  [
                    45437.9,
                    36807.5
                  ],
                  [
                    45619.9,
                    36552.6
                  ],
                  [
                    45735.1,
                    36532
                  ],
                  [
                    45845.6,
                    36722.8
                  ],
                  [
                    45806.1,
                    37086.7
                  ],
                  [
                    45224.7,
                    36965.6
                  ],
                  [
                    45229.3,
                    36836.4
                  ],
                  [
                    45437.9,
                    36807.5
                  ]
                ],
                "id": 1092,
                "chat_link": "[&BEQEAAA=]"
              },
              "1093": {
                "name": "Owain's Refuge",
                "level": 80,
                "coord": [
                  44639.7,
                  36766.9
                ],
                "bounds": [
                  [
                    44384.6,
                    36497.7
                  ],
                  [
                    44650.3,
                    36359.6
                  ],
                  [
                    44771.1,
                    36764.5
                  ],
                  [
                    44983.2,
                    36993.1
                  ],
                  [
                    44800,
                    37032.5
                  ],
                  [
                    44504,
                    36983.5
                  ],
                  [
                    44385,
                    36737.7
                  ],
                  [
                    44384.6,
                    36497.7
                  ]
                ],
                "id": 1093,
                "chat_link": "[&BEUEAAA=]"
              },
              "1094": {
                "name": "Driftglass Springs",
                "level": 80,
                "coord": [
                  45653.2,
                  36393.2
                ],
                "bounds": [
                  [
                    45238.4,
                    36717.9
                  ],
                  [
                    45221.9,
                    36861.9
                  ],
                  [
                    45426.1,
                    36822.9
                  ],
                  [
                    45618,
                    36552.9
                  ],
                  [
                    45998.2,
                    36485.1
                  ],
                  [
                    46020.3,
                    36339.5
                  ],
                  [
                    46145.4,
                    36324.8
                  ],
                  [
                    46083.1,
                    36103.2
                  ],
                  [
                    45858,
                    36072.9
                  ],
                  [
                    45755.1,
                    36001.7
                  ],
                  [
                    45486.9,
                    36130
                  ],
                  [
                    45447.7,
                    36271.4
                  ],
                  [
                    45192.3,
                    36427.5
                  ],
                  [
                    45238.4,
                    36717.9
                  ]
                ],
                "id": 1094,
                "chat_link": "[&BEYEAAA=]"
              },
              "1095": {
                "name": "Scoured Plains",
                "level": 80,
                "coord": [
                  45028.2,
                  36677.9
                ],
                "bounds": [
                  [
                    44983.9,
                    36993.9
                  ],
                  [
                    44766.4,
                    36764.7
                  ],
                  [
                    44697.7,
                    36525
                  ],
                  [
                    45095.1,
                    36348.6
                  ],
                  [
                    45193.2,
                    36428.1
                  ],
                  [
                    45239,
                    36718.5
                  ],
                  [
                    45221.9,
                    36966.7
                  ],
                  [
                    44983.9,
                    36993.9
                  ]
                ],
                "id": 1095,
                "chat_link": "[&BEcEAAA=]"
              },
              "1096": {
                "name": "Seashell Hills",
                "level": 80,
                "coord": [
                  44833.6,
                  36143.4
                ],
                "bounds": [
                  [
                    44699.9,
                    36526
                  ],
                  [
                    44603,
                    36156.1
                  ],
                  [
                    44621.5,
                    35918.8
                  ],
                  [
                    44877.7,
                    35799.3
                  ],
                  [
                    45102.9,
                    36110.2
                  ],
                  [
                    45096.5,
                    36350.1
                  ],
                  [
                    44699.9,
                    36526
                  ]
                ],
                "id": 1096,
                "chat_link": "[&BEgEAAA=]"
              },
              "1097": {
                "name": "Bakestone Cavern",
                "level": 80,
                "coord": [
                  45222.5,
                  36055.3
                ],
                "bounds": [
                  [
                    45192.1,
                    36445
                  ],
                  [
                    45092.4,
                    36353.3
                  ],
                  [
                    45099.8,
                    36111.1
                  ],
                  [
                    44874.8,
                    35799.4
                  ],
                  [
                    45122.8,
                    35690.5
                  ],
                  [
                    45408.4,
                    35781.6
                  ],
                  [
                    45545.2,
                    35993.6
                  ],
                  [
                    45444.7,
                    36268
                  ],
                  [
                    45192.1,
                    36445
                  ]
                ],
                "id": 1097,
                "chat_link": "[&BEkEAAA=]"
              },
              "1098": {
                "name": "Southsun Strait",
                "level": 80,
                "coord": [
                  44619.1,
                  35822.3
                ],
                "bounds": [
                  [
                    44084.1,
                    36115.1
                  ],
                  [
                    44386.9,
                    36501.8
                  ],
                  [
                    44649.7,
                    36359.9
                  ],
                  [
                    44602.9,
                    36155.7
                  ],
                  [
                    44622.3,
                    35919
                  ],
                  [
                    44877.4,
                    35798
                  ],
                  [
                    45123,
                    35691.8
                  ],
                  [
                    45185.8,
                    35340.8
                  ],
                  [
                    44771.3,
                    35448.4
                  ],
                  [
                    44380.6,
                    35361
                  ],
                  [
                    44126.1,
                    35354.1
                  ],
                  [
                    44084.1,
                    36115.1
                  ]
                ],
                "id": 1098,
                "chat_link": "[&BEoEAAA=]"
              }
            },
            "id": 1072,
            "mastery_points": [],
            "adventures": []
          },
          "1073": {
            "name": "Guild Initiative Office",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              49216,
              31488
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                30720,
                18432
              ]
            ],
            "continent_rect": [
              [
                48000,
                30720
              ],
              [
                50432,
                32256
              ]
            ],
            "points_of_interest": {
              "1884": {
                "name": "Guild Initiative Headquarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49986.4,
                  31211.8
                ],
                "id": 1884,
                "chat_link": "[&BFwHAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "861": {
                "name": "Postern Ward",
                "level": 0,
                "coord": [
                  49964.8,
                  31155.7
                ],
                "bounds": [
                  [
                    50018.7,
                    31508.4
                  ],
                  [
                    49978.7,
                    31346.7
                  ],
                  [
                    49928.2,
                    31332
                  ],
                  [
                    49856.6,
                    31242.5
                  ],
                  [
                    49843.1,
                    31163.8
                  ],
                  [
                    49880.2,
                    31099.1
                  ],
                  [
                    49831.4,
                    31047.4
                  ],
                  [
                    49714.3,
                    31016.3
                  ],
                  [
                    49664,
                    30935.1
                  ],
                  [
                    49634.5,
                    30752.6
                  ],
                  [
                    50286.6,
                    30802.7
                  ],
                  [
                    50356.3,
                    31146.6
                  ],
                  [
                    50341,
                    31395.1
                  ],
                  [
                    50174.2,
                    31391.4
                  ],
                  [
                    50018.7,
                    31508.4
                  ]
                ],
                "id": 861,
                "chat_link": "[&BF0DAAA=]"
              }
            },
            "adventures": [],
            "id": 1073,
            "mastery_points": []
          },
          "1084": {
            "name": "Southsun Crab Toss",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45668,
              36216
            ],
            "map_rect": [
              [
                -30720,
                -21504
              ],
              [
                33792,
                21504
              ]
            ],
            "continent_rect": [
              [
                44288,
                35328
              ],
              [
                46976,
                37120
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1088": {
                "name": "Southsun Shoals",
                "level": 80,
                "coord": [
                  45924.9,
                  35840.5
                ],
                "bounds": [
                  [
                    45123,
                    35691
                  ],
                  [
                    45407.2,
                    35782.7
                  ],
                  [
                    45538.4,
                    35995.2
                  ],
                  [
                    45488.6,
                    36129.1
                  ],
                  [
                    45756.5,
                    36003.5
                  ],
                  [
                    45858.2,
                    36070.3
                  ],
                  [
                    46087.4,
                    36098.3
                  ],
                  [
                    46221.9,
                    36029.5
                  ],
                  [
                    46480.9,
                    36212.2
                  ],
                  [
                    46889.5,
                    36204.4
                  ],
                  [
                    46931.3,
                    35742.3
                  ],
                  [
                    46624.5,
                    35488.7
                  ],
                  [
                    45859.4,
                    35321.2
                  ],
                  [
                    45422.5,
                    35495.9
                  ],
                  [
                    45184.7,
                    35343.4
                  ],
                  [
                    45123,
                    35691
                  ]
                ],
                "id": 1088,
                "chat_link": "[&BEAEAAA=]"
              },
              "1089": {
                "name": "Dappled Shores",
                "level": 80,
                "coord": [
                  46399.9,
                  36456
                ],
                "bounds": [
                  [
                    46326,
                    36874.7
                  ],
                  [
                    46270.4,
                    36597.2
                  ],
                  [
                    45987.8,
                    36489.3
                  ],
                  [
                    46015.3,
                    36332.3
                  ],
                  [
                    46142.5,
                    36312.4
                  ],
                  [
                    46080.5,
                    36100
                  ],
                  [
                    46219.7,
                    36021.8
                  ],
                  [
                    46482.2,
                    36202.6
                  ],
                  [
                    46887,
                    36203.4
                  ],
                  [
                    46946.4,
                    36541.7
                  ],
                  [
                    46664.6,
                    36543.3
                  ],
                  [
                    46571.3,
                    36581
                  ],
                  [
                    46583.9,
                    36683
                  ],
                  [
                    46421.1,
                    36901.3
                  ],
                  [
                    46326,
                    36874.7
                  ]
                ],
                "id": 1089,
                "chat_link": "[&BEEEAAA=]"
              },
              "1090": {
                "name": "Pearl Islet",
                "level": 80,
                "coord": [
                  46666.4,
                  36796.3
                ],
                "bounds": [
                  [
                    46417.8,
                    36895.9
                  ],
                  [
                    46582.1,
                    36678.5
                  ],
                  [
                    46567.4,
                    36580.1
                  ],
                  [
                    46666.1,
                    36538.1
                  ],
                  [
                    46946.5,
                    36535.6
                  ],
                  [
                    46915.3,
                    36956.8
                  ],
                  [
                    46820,
                    37068.3
                  ],
                  [
                    46415.7,
                    37117.2
                  ],
                  [
                    46417.8,
                    36895.9
                  ]
                ],
                "id": 1090,
                "chat_link": "[&BEIEAAA=]"
              },
              "1091": {
                "name": "Sawtooth Bay",
                "level": 80,
                "coord": [
                  46102.6,
                  36813.9
                ],
                "bounds": [
                  [
                    45981.4,
                    36483.8
                  ],
                  [
                    45732.1,
                    36531.4
                  ],
                  [
                    45845,
                    36723.8
                  ],
                  [
                    45805.9,
                    37086.8
                  ],
                  [
                    46112.1,
                    37028.3
                  ],
                  [
                    46422,
                    37116
                  ],
                  [
                    46424.9,
                    36890.7
                  ],
                  [
                    46326,
                    36867
                  ],
                  [
                    46274.3,
                    36597.6
                  ],
                  [
                    45981.4,
                    36483.8
                  ]
                ],
                "id": 1091,
                "chat_link": "[&BEMEAAA=]"
              },
              "1092": {
                "name": "Captain's Retreat",
                "level": 80,
                "coord": [
                  45556.9,
                  36786.2
                ],
                "bounds": [
                  [
                    45437.9,
                    36807.5
                  ],
                  [
                    45619.9,
                    36552.6
                  ],
                  [
                    45735.1,
                    36532
                  ],
                  [
                    45845.6,
                    36722.8
                  ],
                  [
                    45806.1,
                    37086.7
                  ],
                  [
                    45224.7,
                    36965.6
                  ],
                  [
                    45229.3,
                    36836.4
                  ],
                  [
                    45437.9,
                    36807.5
                  ]
                ],
                "id": 1092,
                "chat_link": "[&BEQEAAA=]"
              },
              "1093": {
                "name": "Owain's Refuge",
                "level": 80,
                "coord": [
                  44639.7,
                  36766.9
                ],
                "bounds": [
                  [
                    44384.6,
                    36497.7
                  ],
                  [
                    44650.3,
                    36359.6
                  ],
                  [
                    44771.1,
                    36764.5
                  ],
                  [
                    44983.2,
                    36993.1
                  ],
                  [
                    44800,
                    37032.5
                  ],
                  [
                    44504,
                    36983.5
                  ],
                  [
                    44385,
                    36737.7
                  ],
                  [
                    44384.6,
                    36497.7
                  ]
                ],
                "id": 1093,
                "chat_link": "[&BEUEAAA=]"
              },
              "1094": {
                "name": "Driftglass Springs",
                "level": 80,
                "coord": [
                  45653.2,
                  36393.2
                ],
                "bounds": [
                  [
                    45238.4,
                    36717.9
                  ],
                  [
                    45221.9,
                    36861.9
                  ],
                  [
                    45426.1,
                    36822.9
                  ],
                  [
                    45618,
                    36552.9
                  ],
                  [
                    45998.2,
                    36485.1
                  ],
                  [
                    46020.3,
                    36339.5
                  ],
                  [
                    46145.4,
                    36324.8
                  ],
                  [
                    46083.1,
                    36103.2
                  ],
                  [
                    45858,
                    36072.9
                  ],
                  [
                    45755.1,
                    36001.7
                  ],
                  [
                    45486.9,
                    36130
                  ],
                  [
                    45447.7,
                    36271.4
                  ],
                  [
                    45192.3,
                    36427.5
                  ],
                  [
                    45238.4,
                    36717.9
                  ]
                ],
                "id": 1094,
                "chat_link": "[&BEYEAAA=]"
              },
              "1095": {
                "name": "Scoured Plains",
                "level": 80,
                "coord": [
                  45028.2,
                  36677.9
                ],
                "bounds": [
                  [
                    44983.9,
                    36993.9
                  ],
                  [
                    44766.4,
                    36764.7
                  ],
                  [
                    44697.7,
                    36525
                  ],
                  [
                    45095.1,
                    36348.6
                  ],
                  [
                    45193.2,
                    36428.1
                  ],
                  [
                    45239,
                    36718.5
                  ],
                  [
                    45221.9,
                    36966.7
                  ],
                  [
                    44983.9,
                    36993.9
                  ]
                ],
                "id": 1095,
                "chat_link": "[&BEcEAAA=]"
              },
              "1096": {
                "name": "Seashell Hills",
                "level": 80,
                "coord": [
                  44833.6,
                  36143.4
                ],
                "bounds": [
                  [
                    44699.9,
                    36526
                  ],
                  [
                    44603,
                    36156.1
                  ],
                  [
                    44621.5,
                    35918.8
                  ],
                  [
                    44877.7,
                    35799.3
                  ],
                  [
                    45102.9,
                    36110.2
                  ],
                  [
                    45096.5,
                    36350.1
                  ],
                  [
                    44699.9,
                    36526
                  ]
                ],
                "id": 1096,
                "chat_link": "[&BEgEAAA=]"
              },
              "1097": {
                "name": "Bakestone Cavern",
                "level": 80,
                "coord": [
                  45222.5,
                  36055.3
                ],
                "bounds": [
                  [
                    45192.1,
                    36445
                  ],
                  [
                    45092.4,
                    36353.3
                  ],
                  [
                    45099.8,
                    36111.1
                  ],
                  [
                    44874.8,
                    35799.4
                  ],
                  [
                    45122.8,
                    35690.5
                  ],
                  [
                    45408.4,
                    35781.6
                  ],
                  [
                    45545.2,
                    35993.6
                  ],
                  [
                    45444.7,
                    36268
                  ],
                  [
                    45192.1,
                    36445
                  ]
                ],
                "id": 1097,
                "chat_link": "[&BEkEAAA=]"
              },
              "1098": {
                "name": "Southsun Strait",
                "level": 80,
                "coord": [
                  44619.1,
                  35822.3
                ],
                "bounds": [
                  [
                    44084.1,
                    36115.1
                  ],
                  [
                    44386.9,
                    36501.8
                  ],
                  [
                    44649.7,
                    36359.9
                  ],
                  [
                    44602.9,
                    36155.7
                  ],
                  [
                    44622.3,
                    35919
                  ],
                  [
                    44877.4,
                    35798
                  ],
                  [
                    45123,
                    35691.8
                  ],
                  [
                    45185.8,
                    35340.8
                  ],
                  [
                    44771.3,
                    35448.4
                  ],
                  [
                    44380.6,
                    35361
                  ],
                  [
                    44126.1,
                    35354.1
                  ],
                  [
                    44084.1,
                    36115.1
                  ]
                ],
                "id": 1098,
                "chat_link": "[&BEoEAAA=]"
              }
            },
            "id": 1084,
            "mastery_points": [],
            "adventures": []
          },
          "1126": {
            "name": "Southsun Crab Toss",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45668,
              36216
            ],
            "map_rect": [
              [
                -30720,
                -21504
              ],
              [
                33792,
                21504
              ]
            ],
            "continent_rect": [
              [
                44288,
                35328
              ],
              [
                46976,
                37120
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1088": {
                "name": "Southsun Shoals",
                "level": 80,
                "coord": [
                  45924.9,
                  35840.5
                ],
                "bounds": [
                  [
                    45123,
                    35691
                  ],
                  [
                    45407.2,
                    35782.7
                  ],
                  [
                    45538.4,
                    35995.2
                  ],
                  [
                    45488.6,
                    36129.1
                  ],
                  [
                    45756.5,
                    36003.5
                  ],
                  [
                    45858.2,
                    36070.3
                  ],
                  [
                    46087.4,
                    36098.3
                  ],
                  [
                    46221.9,
                    36029.5
                  ],
                  [
                    46480.9,
                    36212.2
                  ],
                  [
                    46889.5,
                    36204.4
                  ],
                  [
                    46931.3,
                    35742.3
                  ],
                  [
                    46624.5,
                    35488.7
                  ],
                  [
                    45859.4,
                    35321.2
                  ],
                  [
                    45422.5,
                    35495.9
                  ],
                  [
                    45184.7,
                    35343.4
                  ],
                  [
                    45123,
                    35691
                  ]
                ],
                "id": 1088,
                "chat_link": "[&BEAEAAA=]"
              },
              "1089": {
                "name": "Dappled Shores",
                "level": 80,
                "coord": [
                  46399.9,
                  36456
                ],
                "bounds": [
                  [
                    46326,
                    36874.7
                  ],
                  [
                    46270.4,
                    36597.2
                  ],
                  [
                    45987.8,
                    36489.3
                  ],
                  [
                    46015.3,
                    36332.3
                  ],
                  [
                    46142.5,
                    36312.4
                  ],
                  [
                    46080.5,
                    36100
                  ],
                  [
                    46219.7,
                    36021.8
                  ],
                  [
                    46482.2,
                    36202.6
                  ],
                  [
                    46887,
                    36203.4
                  ],
                  [
                    46946.4,
                    36541.7
                  ],
                  [
                    46664.6,
                    36543.3
                  ],
                  [
                    46571.3,
                    36581
                  ],
                  [
                    46583.9,
                    36683
                  ],
                  [
                    46421.1,
                    36901.3
                  ],
                  [
                    46326,
                    36874.7
                  ]
                ],
                "id": 1089,
                "chat_link": "[&BEEEAAA=]"
              },
              "1090": {
                "name": "Pearl Islet",
                "level": 80,
                "coord": [
                  46666.4,
                  36796.3
                ],
                "bounds": [
                  [
                    46417.8,
                    36895.9
                  ],
                  [
                    46582.1,
                    36678.5
                  ],
                  [
                    46567.4,
                    36580.1
                  ],
                  [
                    46666.1,
                    36538.1
                  ],
                  [
                    46946.5,
                    36535.6
                  ],
                  [
                    46915.3,
                    36956.8
                  ],
                  [
                    46820,
                    37068.3
                  ],
                  [
                    46415.7,
                    37117.2
                  ],
                  [
                    46417.8,
                    36895.9
                  ]
                ],
                "id": 1090,
                "chat_link": "[&BEIEAAA=]"
              },
              "1091": {
                "name": "Sawtooth Bay",
                "level": 80,
                "coord": [
                  46102.6,
                  36813.9
                ],
                "bounds": [
                  [
                    45981.4,
                    36483.8
                  ],
                  [
                    45732.1,
                    36531.4
                  ],
                  [
                    45845,
                    36723.8
                  ],
                  [
                    45805.9,
                    37086.8
                  ],
                  [
                    46112.1,
                    37028.3
                  ],
                  [
                    46422,
                    37116
                  ],
                  [
                    46424.9,
                    36890.7
                  ],
                  [
                    46326,
                    36867
                  ],
                  [
                    46274.3,
                    36597.6
                  ],
                  [
                    45981.4,
                    36483.8
                  ]
                ],
                "id": 1091,
                "chat_link": "[&BEMEAAA=]"
              },
              "1092": {
                "name": "Captain's Retreat",
                "level": 80,
                "coord": [
                  45556.9,
                  36786.2
                ],
                "bounds": [
                  [
                    45437.9,
                    36807.5
                  ],
                  [
                    45619.9,
                    36552.6
                  ],
                  [
                    45735.1,
                    36532
                  ],
                  [
                    45845.6,
                    36722.8
                  ],
                  [
                    45806.1,
                    37086.7
                  ],
                  [
                    45224.7,
                    36965.6
                  ],
                  [
                    45229.3,
                    36836.4
                  ],
                  [
                    45437.9,
                    36807.5
                  ]
                ],
                "id": 1092,
                "chat_link": "[&BEQEAAA=]"
              },
              "1093": {
                "name": "Owain's Refuge",
                "level": 80,
                "coord": [
                  44639.7,
                  36766.9
                ],
                "bounds": [
                  [
                    44384.6,
                    36497.7
                  ],
                  [
                    44650.3,
                    36359.6
                  ],
                  [
                    44771.1,
                    36764.5
                  ],
                  [
                    44983.2,
                    36993.1
                  ],
                  [
                    44800,
                    37032.5
                  ],
                  [
                    44504,
                    36983.5
                  ],
                  [
                    44385,
                    36737.7
                  ],
                  [
                    44384.6,
                    36497.7
                  ]
                ],
                "id": 1093,
                "chat_link": "[&BEUEAAA=]"
              },
              "1094": {
                "name": "Driftglass Springs",
                "level": 80,
                "coord": [
                  45653.2,
                  36393.2
                ],
                "bounds": [
                  [
                    45238.4,
                    36717.9
                  ],
                  [
                    45221.9,
                    36861.9
                  ],
                  [
                    45426.1,
                    36822.9
                  ],
                  [
                    45618,
                    36552.9
                  ],
                  [
                    45998.2,
                    36485.1
                  ],
                  [
                    46020.3,
                    36339.5
                  ],
                  [
                    46145.4,
                    36324.8
                  ],
                  [
                    46083.1,
                    36103.2
                  ],
                  [
                    45858,
                    36072.9
                  ],
                  [
                    45755.1,
                    36001.7
                  ],
                  [
                    45486.9,
                    36130
                  ],
                  [
                    45447.7,
                    36271.4
                  ],
                  [
                    45192.3,
                    36427.5
                  ],
                  [
                    45238.4,
                    36717.9
                  ]
                ],
                "id": 1094,
                "chat_link": "[&BEYEAAA=]"
              },
              "1095": {
                "name": "Scoured Plains",
                "level": 80,
                "coord": [
                  45028.2,
                  36677.9
                ],
                "bounds": [
                  [
                    44983.9,
                    36993.9
                  ],
                  [
                    44766.4,
                    36764.7
                  ],
                  [
                    44697.7,
                    36525
                  ],
                  [
                    45095.1,
                    36348.6
                  ],
                  [
                    45193.2,
                    36428.1
                  ],
                  [
                    45239,
                    36718.5
                  ],
                  [
                    45221.9,
                    36966.7
                  ],
                  [
                    44983.9,
                    36993.9
                  ]
                ],
                "id": 1095,
                "chat_link": "[&BEcEAAA=]"
              },
              "1096": {
                "name": "Seashell Hills",
                "level": 80,
                "coord": [
                  44833.6,
                  36143.4
                ],
                "bounds": [
                  [
                    44699.9,
                    36526
                  ],
                  [
                    44603,
                    36156.1
                  ],
                  [
                    44621.5,
                    35918.8
                  ],
                  [
                    44877.7,
                    35799.3
                  ],
                  [
                    45102.9,
                    36110.2
                  ],
                  [
                    45096.5,
                    36350.1
                  ],
                  [
                    44699.9,
                    36526
                  ]
                ],
                "id": 1096,
                "chat_link": "[&BEgEAAA=]"
              },
              "1097": {
                "name": "Bakestone Cavern",
                "level": 80,
                "coord": [
                  45222.5,
                  36055.3
                ],
                "bounds": [
                  [
                    45192.1,
                    36445
                  ],
                  [
                    45092.4,
                    36353.3
                  ],
                  [
                    45099.8,
                    36111.1
                  ],
                  [
                    44874.8,
                    35799.4
                  ],
                  [
                    45122.8,
                    35690.5
                  ],
                  [
                    45408.4,
                    35781.6
                  ],
                  [
                    45545.2,
                    35993.6
                  ],
                  [
                    45444.7,
                    36268
                  ],
                  [
                    45192.1,
                    36445
                  ]
                ],
                "id": 1097,
                "chat_link": "[&BEkEAAA=]"
              },
              "1098": {
                "name": "Southsun Strait",
                "level": 80,
                "coord": [
                  44619.1,
                  35822.3
                ],
                "bounds": [
                  [
                    44084.1,
                    36115.1
                  ],
                  [
                    44386.9,
                    36501.8
                  ],
                  [
                    44649.7,
                    36359.9
                  ],
                  [
                    44602.9,
                    36155.7
                  ],
                  [
                    44622.3,
                    35919
                  ],
                  [
                    44877.4,
                    35798
                  ],
                  [
                    45123,
                    35691.8
                  ],
                  [
                    45185.8,
                    35340.8
                  ],
                  [
                    44771.3,
                    35448.4
                  ],
                  [
                    44380.6,
                    35361
                  ],
                  [
                    44126.1,
                    35354.1
                  ],
                  [
                    44084.1,
                    36115.1
                  ]
                ],
                "id": 1098,
                "chat_link": "[&BEoEAAA=]"
              }
            },
            "id": 1126,
            "mastery_points": [],
            "adventures": []
          },
          "1139": {
            "name": "Southsun Crab Toss",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45668,
              36216
            ],
            "map_rect": [
              [
                -30720,
                -21504
              ],
              [
                33792,
                21504
              ]
            ],
            "continent_rect": [
              [
                44288,
                35328
              ],
              [
                46976,
                37120
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1088": {
                "name": "Southsun Shoals",
                "level": 80,
                "coord": [
                  45924.9,
                  35840.5
                ],
                "bounds": [
                  [
                    45123,
                    35691
                  ],
                  [
                    45407.2,
                    35782.7
                  ],
                  [
                    45538.4,
                    35995.2
                  ],
                  [
                    45488.6,
                    36129.1
                  ],
                  [
                    45756.5,
                    36003.5
                  ],
                  [
                    45858.2,
                    36070.3
                  ],
                  [
                    46087.4,
                    36098.3
                  ],
                  [
                    46221.9,
                    36029.5
                  ],
                  [
                    46480.9,
                    36212.2
                  ],
                  [
                    46889.5,
                    36204.4
                  ],
                  [
                    46931.3,
                    35742.3
                  ],
                  [
                    46624.5,
                    35488.7
                  ],
                  [
                    45859.4,
                    35321.2
                  ],
                  [
                    45422.5,
                    35495.9
                  ],
                  [
                    45184.7,
                    35343.4
                  ],
                  [
                    45123,
                    35691
                  ]
                ],
                "id": 1088,
                "chat_link": "[&BEAEAAA=]"
              },
              "1089": {
                "name": "Dappled Shores",
                "level": 80,
                "coord": [
                  46399.9,
                  36456
                ],
                "bounds": [
                  [
                    46326,
                    36874.7
                  ],
                  [
                    46270.4,
                    36597.2
                  ],
                  [
                    45987.8,
                    36489.3
                  ],
                  [
                    46015.3,
                    36332.3
                  ],
                  [
                    46142.5,
                    36312.4
                  ],
                  [
                    46080.5,
                    36100
                  ],
                  [
                    46219.7,
                    36021.8
                  ],
                  [
                    46482.2,
                    36202.6
                  ],
                  [
                    46887,
                    36203.4
                  ],
                  [
                    46946.4,
                    36541.7
                  ],
                  [
                    46664.6,
                    36543.3
                  ],
                  [
                    46571.3,
                    36581
                  ],
                  [
                    46583.9,
                    36683
                  ],
                  [
                    46421.1,
                    36901.3
                  ],
                  [
                    46326,
                    36874.7
                  ]
                ],
                "id": 1089,
                "chat_link": "[&BEEEAAA=]"
              },
              "1090": {
                "name": "Pearl Islet",
                "level": 80,
                "coord": [
                  46666.4,
                  36796.3
                ],
                "bounds": [
                  [
                    46417.8,
                    36895.9
                  ],
                  [
                    46582.1,
                    36678.5
                  ],
                  [
                    46567.4,
                    36580.1
                  ],
                  [
                    46666.1,
                    36538.1
                  ],
                  [
                    46946.5,
                    36535.6
                  ],
                  [
                    46915.3,
                    36956.8
                  ],
                  [
                    46820,
                    37068.3
                  ],
                  [
                    46415.7,
                    37117.2
                  ],
                  [
                    46417.8,
                    36895.9
                  ]
                ],
                "id": 1090,
                "chat_link": "[&BEIEAAA=]"
              },
              "1091": {
                "name": "Sawtooth Bay",
                "level": 80,
                "coord": [
                  46102.6,
                  36813.9
                ],
                "bounds": [
                  [
                    45981.4,
                    36483.8
                  ],
                  [
                    45732.1,
                    36531.4
                  ],
                  [
                    45845,
                    36723.8
                  ],
                  [
                    45805.9,
                    37086.8
                  ],
                  [
                    46112.1,
                    37028.3
                  ],
                  [
                    46422,
                    37116
                  ],
                  [
                    46424.9,
                    36890.7
                  ],
                  [
                    46326,
                    36867
                  ],
                  [
                    46274.3,
                    36597.6
                  ],
                  [
                    45981.4,
                    36483.8
                  ]
                ],
                "id": 1091,
                "chat_link": "[&BEMEAAA=]"
              },
              "1092": {
                "name": "Captain's Retreat",
                "level": 80,
                "coord": [
                  45556.9,
                  36786.2
                ],
                "bounds": [
                  [
                    45437.9,
                    36807.5
                  ],
                  [
                    45619.9,
                    36552.6
                  ],
                  [
                    45735.1,
                    36532
                  ],
                  [
                    45845.6,
                    36722.8
                  ],
                  [
                    45806.1,
                    37086.7
                  ],
                  [
                    45224.7,
                    36965.6
                  ],
                  [
                    45229.3,
                    36836.4
                  ],
                  [
                    45437.9,
                    36807.5
                  ]
                ],
                "id": 1092,
                "chat_link": "[&BEQEAAA=]"
              },
              "1093": {
                "name": "Owain's Refuge",
                "level": 80,
                "coord": [
                  44639.7,
                  36766.9
                ],
                "bounds": [
                  [
                    44384.6,
                    36497.7
                  ],
                  [
                    44650.3,
                    36359.6
                  ],
                  [
                    44771.1,
                    36764.5
                  ],
                  [
                    44983.2,
                    36993.1
                  ],
                  [
                    44800,
                    37032.5
                  ],
                  [
                    44504,
                    36983.5
                  ],
                  [
                    44385,
                    36737.7
                  ],
                  [
                    44384.6,
                    36497.7
                  ]
                ],
                "id": 1093,
                "chat_link": "[&BEUEAAA=]"
              },
              "1094": {
                "name": "Driftglass Springs",
                "level": 80,
                "coord": [
                  45653.2,
                  36393.2
                ],
                "bounds": [
                  [
                    45238.4,
                    36717.9
                  ],
                  [
                    45221.9,
                    36861.9
                  ],
                  [
                    45426.1,
                    36822.9
                  ],
                  [
                    45618,
                    36552.9
                  ],
                  [
                    45998.2,
                    36485.1
                  ],
                  [
                    46020.3,
                    36339.5
                  ],
                  [
                    46145.4,
                    36324.8
                  ],
                  [
                    46083.1,
                    36103.2
                  ],
                  [
                    45858,
                    36072.9
                  ],
                  [
                    45755.1,
                    36001.7
                  ],
                  [
                    45486.9,
                    36130
                  ],
                  [
                    45447.7,
                    36271.4
                  ],
                  [
                    45192.3,
                    36427.5
                  ],
                  [
                    45238.4,
                    36717.9
                  ]
                ],
                "id": 1094,
                "chat_link": "[&BEYEAAA=]"
              },
              "1095": {
                "name": "Scoured Plains",
                "level": 80,
                "coord": [
                  45028.2,
                  36677.9
                ],
                "bounds": [
                  [
                    44983.9,
                    36993.9
                  ],
                  [
                    44766.4,
                    36764.7
                  ],
                  [
                    44697.7,
                    36525
                  ],
                  [
                    45095.1,
                    36348.6
                  ],
                  [
                    45193.2,
                    36428.1
                  ],
                  [
                    45239,
                    36718.5
                  ],
                  [
                    45221.9,
                    36966.7
                  ],
                  [
                    44983.9,
                    36993.9
                  ]
                ],
                "id": 1095,
                "chat_link": "[&BEcEAAA=]"
              },
              "1096": {
                "name": "Seashell Hills",
                "level": 80,
                "coord": [
                  44833.6,
                  36143.4
                ],
                "bounds": [
                  [
                    44699.9,
                    36526
                  ],
                  [
                    44603,
                    36156.1
                  ],
                  [
                    44621.5,
                    35918.8
                  ],
                  [
                    44877.7,
                    35799.3
                  ],
                  [
                    45102.9,
                    36110.2
                  ],
                  [
                    45096.5,
                    36350.1
                  ],
                  [
                    44699.9,
                    36526
                  ]
                ],
                "id": 1096,
                "chat_link": "[&BEgEAAA=]"
              },
              "1097": {
                "name": "Bakestone Cavern",
                "level": 80,
                "coord": [
                  45222.5,
                  36055.3
                ],
                "bounds": [
                  [
                    45192.1,
                    36445
                  ],
                  [
                    45092.4,
                    36353.3
                  ],
                  [
                    45099.8,
                    36111.1
                  ],
                  [
                    44874.8,
                    35799.4
                  ],
                  [
                    45122.8,
                    35690.5
                  ],
                  [
                    45408.4,
                    35781.6
                  ],
                  [
                    45545.2,
                    35993.6
                  ],
                  [
                    45444.7,
                    36268
                  ],
                  [
                    45192.1,
                    36445
                  ]
                ],
                "id": 1097,
                "chat_link": "[&BEkEAAA=]"
              },
              "1098": {
                "name": "Southsun Strait",
                "level": 80,
                "coord": [
                  44619.1,
                  35822.3
                ],
                "bounds": [
                  [
                    44084.1,
                    36115.1
                  ],
                  [
                    44386.9,
                    36501.8
                  ],
                  [
                    44649.7,
                    36359.9
                  ],
                  [
                    44602.9,
                    36155.7
                  ],
                  [
                    44622.3,
                    35919
                  ],
                  [
                    44877.4,
                    35798
                  ],
                  [
                    45123,
                    35691.8
                  ],
                  [
                    45185.8,
                    35340.8
                  ],
                  [
                    44771.3,
                    35448.4
                  ],
                  [
                    44380.6,
                    35361
                  ],
                  [
                    44126.1,
                    35354.1
                  ],
                  [
                    44084.1,
                    36115.1
                  ]
                ],
                "id": 1098,
                "chat_link": "[&BEoEAAA=]"
              }
            },
            "id": 1139,
            "mastery_points": [],
            "adventures": []
          },
          "1155": {
            "name": "Lion's Arch Aerodrome",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              49216,
              31488
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                30720,
                18432
              ]
            ],
            "continent_rect": [
              [
                47964,
                30806
              ],
              [
                50396,
                32342
              ]
            ],
            "points_of_interest": {
              "2336": {
                "name": "Aerodrome Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49331.4,
                  32136.9
                ],
                "id": 2336,
                "chat_link": "[&BCAJAAA=]"
              },
              "2970": {
                "type": "unlock",
                "floor": 1,
                "coord": [
                  49386.9,
                  32213.7
                ],
                "id": 2970,
                "chat_link": "[&BJoLAAA=]",
                "icon": "https://render.guildwars2.com/file/5866630DA52DCB5C423FB81ECF69FD071611E36B/1128644.png"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1361": {
                "level": 0,
                "coord": [
                  49339.2,
                  32140.1
                ],
                "bounds": [
                  [
                    49080.6,
                    31996.7
                  ],
                  [
                    49363.4,
                    31895.6
                  ],
                  [
                    49617.4,
                    32060.6
                  ],
                  [
                    49581.5,
                    32298.6
                  ],
                  [
                    49312.9,
                    32330.7
                  ],
                  [
                    49079.4,
                    32258.2
                  ],
                  [
                    49080.6,
                    31996.7
                  ]
                ],
                "id": 1361,
                "chat_link": "[&BFEFAAA=]"
              }
            },
            "adventures": [],
            "id": 1155,
            "mastery_points": []
          },
          "1185": {
            "name": "Lake Doric",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45568,
              26884
            ],
            "map_rect": [
              [
                -15360,
                -30720
              ],
              [
                15360,
                30720
              ]
            ],
            "continent_rect": [
              [
                44928,
                25472
              ],
              [
                46208,
                28032
              ]
            ],
            "points_of_interest": {
              "2448": {
                "name": "Land Bridge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45261.8,
                  26944.7
                ],
                "id": 2448,
                "chat_link": "[&BJAJAAA=]"
              },
              "2449": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  46108.2,
                  27516.3
                ],
                "id": 2449,
                "chat_link": "[&BJEJAAA=]"
              },
              "2450": {
                "name": "Chieftain's Hollow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45933.4,
                  25875.3
                ],
                "id": 2450,
                "chat_link": "[&BJIJAAA=]"
              },
              "2451": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  45652,
                  25620.9
                ],
                "id": 2451,
                "chat_link": "[&BJMJAAA=]"
              },
              "2453": {
                "name": "Defense Headquarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45082.5,
                  27354.3
                ],
                "id": 2453,
                "chat_link": "[&BJUJAAA=]"
              },
              "2455": {
                "name": "Divinity's Waterworks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45030.1,
                  27762.2
                ],
                "id": 2455,
                "chat_link": "[&BJcJAAA=]"
              },
              "2456": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  45043.9,
                  26027.7
                ],
                "id": 2456,
                "chat_link": "[&BJgJAAA=]"
              },
              "2458": {
                "name": "Soren's Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45128,
                  25581
                ],
                "id": 2458,
                "chat_link": "[&BJoJAAA=]"
              },
              "2460": {
                "name": "Temple of the Six",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45913.4,
                  27517.2
                ],
                "id": 2460,
                "chat_link": "[&BJwJAAA=]"
              },
              "2461": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  45108.8,
                  26826.5
                ],
                "id": 2461,
                "chat_link": "[&BJ0JAAA=]"
              },
              "2462": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  45302.8,
                  27713.6
                ],
                "id": 2462,
                "chat_link": "[&BJ4JAAA=]"
              },
              "2465": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  45891.3,
                  27066.8
                ],
                "id": 2465,
                "chat_link": "[&BKEJAAA=]"
              },
              "2468": {
                "name": "Fort Evennia",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46068.4,
                  26583.2
                ],
                "id": 2468,
                "chat_link": "[&BKQJAAA=]"
              },
              "2470": {
                "name": "Bluster Watershed",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45621.3,
                  26247.2
                ],
                "id": 2470,
                "chat_link": "[&BKYJAAA=]"
              },
              "2471": {
                "name": "Peach Tree",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45709.2,
                  25621.6
                ],
                "id": 2471,
                "chat_link": "[&BKcJAAA=]"
              },
              "2472": {
                "name": "SS Pinkeens",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45537.4,
                  26558.4
                ],
                "id": 2472,
                "chat_link": "[&BKgJAAA=]"
              },
              "2473": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  45677.5,
                  26058.4
                ],
                "id": 2473,
                "chat_link": "[&BKkJAAA=]"
              },
              "2474": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  45688.5,
                  25784.6
                ],
                "id": 2474,
                "chat_link": "[&BKoJAAA=]"
              },
              "2475": {
                "name": "Noran's Homestead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45302.5,
                  25710.7
                ],
                "id": 2475,
                "chat_link": "[&BKsJAAA=]"
              },
              "2477": {
                "name": "Doric's Landing Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  45004.7,
                  27001.9
                ],
                "id": 2477,
                "chat_link": "[&BK0JAAA=]"
              },
              "2478": {
                "name": "Loamhurst Clubhouse",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45591.7,
                  27699.7
                ],
                "id": 2478,
                "chat_link": "[&BK4JAAA=]"
              },
              "2479": {
                "name": "Red Leaf Retreat Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  45006,
                  25823.3
                ],
                "id": 2479,
                "chat_link": "[&BK8JAAA=]"
              },
              "2480": {
                "name": "Red Leaf Retreat",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44988.3,
                  25778.3
                ],
                "id": 2480,
                "chat_link": "[&BLAJAAA=]"
              },
              "2482": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  45869,
                  26107.6
                ],
                "id": 2482,
                "chat_link": "[&BLIJAAA=]"
              },
              "2483": {
                "name": "Fallen Watchtower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46035.1,
                  25636.2
                ],
                "id": 2483,
                "chat_link": "[&BLMJAAA=]"
              },
              "2484": {
                "name": "Lakeside Bazaar Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46062.5,
                  27237.5
                ],
                "id": 2484,
                "chat_link": "[&BLQJAAA=]"
              },
              "2485": {
                "name": "Lakeview Villa",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46141.4,
                  27277.9
                ],
                "id": 2485,
                "chat_link": "[&BLUJAAA=]"
              },
              "2486": {
                "name": "Fisherman's Ship",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45314.3,
                  27674.9
                ],
                "id": 2486,
                "chat_link": "[&BLYJAAA=]"
              }
            },
            "tasks": {
              "372": {
                "objective": "Help Cin Fursarai around the Lakeside Bazaar.",
                "level": 80,
                "coord": [
                  45987,
                  27216.1
                ],
                "bounds": [
                  [
                    46108.6,
                    27026.8
                  ],
                  [
                    46069.9,
                    26889.8
                  ],
                  [
                    45981.4,
                    26854.7
                  ],
                  [
                    45878.5,
                    26895.3
                  ],
                  [
                    45823.8,
                    26981.9
                  ],
                  [
                    45719.2,
                    27014.9
                  ],
                  [
                    45706.1,
                    27101.6
                  ],
                  [
                    45680.8,
                    27176.6
                  ],
                  [
                    45757,
                    27384.5
                  ],
                  [
                    45821.3,
                    27576.9
                  ],
                  [
                    45841.5,
                    27628.7
                  ],
                  [
                    45913.4,
                    27642
                  ],
                  [
                    45948.3,
                    27597.1
                  ],
                  [
                    46155.2,
                    27269.7
                  ],
                  [
                    46107.8,
                    27231.9
                  ],
                  [
                    46067.6,
                    27122.8
                  ],
                  [
                    46108.6,
                    27026.8
                  ]
                ],
                "id": 372,
                "chat_link": "[&BHQBAAA=]"
              },
              "373": {
                "objective": "Aid the front-line defense of Doric's Landing",
                "level": 80,
                "coord": [
                  45046.3,
                  27359.9
                ],
                "bounds": [
                  [
                    44917.2,
                    26759.7
                  ],
                  [
                    45119,
                    26769
                  ],
                  [
                    45287.7,
                    26847.6
                  ],
                  [
                    45390.8,
                    26988.4
                  ],
                  [
                    45274.7,
                    27704.7
                  ],
                  [
                    44928,
                    27852.2
                  ],
                  [
                    44917.2,
                    26759.7
                  ]
                ],
                "id": 373,
                "chat_link": "[&BHUBAAA=]"
              },
              "374": {
                "objective": "Help Noran around the Harvest Cascades.",
                "level": 80,
                "coord": [
                  45295.1,
                  25681.9
                ],
                "bounds": [
                  [
                    46225,
                    25876.2
                  ],
                  [
                    46154.4,
                    26155.1
                  ],
                  [
                    45994.3,
                    26167.2
                  ],
                  [
                    45648.4,
                    26138
                  ],
                  [
                    45383.5,
                    26248.3
                  ],
                  [
                    45266.6,
                    26341.8
                  ],
                  [
                    45143.6,
                    26328.2
                  ],
                  [
                    45074.7,
                    26259.2
                  ],
                  [
                    44965.7,
                    26037.4
                  ],
                  [
                    44936,
                    25799.9
                  ],
                  [
                    44955.6,
                    25510.8
                  ],
                  [
                    45425.7,
                    25504.9
                  ],
                  [
                    45514.3,
                    25569
                  ],
                  [
                    45576.9,
                    25692.6
                  ],
                  [
                    45833.8,
                    25728.9
                  ],
                  [
                    45919.1,
                    25479.9
                  ],
                  [
                    46180.9,
                    25493.6
                  ],
                  [
                    46225,
                    25876.2
                  ]
                ],
                "id": 374,
                "chat_link": "[&BHYBAAA=]"
              },
              "375": {
                "objective": "Restore normalcy in New Loamhurst.",
                "level": 80,
                "coord": [
                  45565.3,
                  27601.2
                ],
                "bounds": [
                  [
                    46134.9,
                    27528.3
                  ],
                  [
                    46094.4,
                    27433.5
                  ],
                  [
                    45917.9,
                    27358.2
                  ],
                  [
                    45814.1,
                    27332.3
                  ],
                  [
                    45598.6,
                    27353.5
                  ],
                  [
                    45289.1,
                    27386.4
                  ],
                  [
                    45272.4,
                    27681.6
                  ],
                  [
                    45386.7,
                    28031
                  ],
                  [
                    45559.9,
                    28029.9
                  ],
                  [
                    45723.3,
                    27875.2
                  ],
                  [
                    45938,
                    27690.4
                  ],
                  [
                    46188.5,
                    27818.6
                  ],
                  [
                    46134.9,
                    27528.3
                  ]
                ],
                "id": 375,
                "chat_link": "[&BHcBAAA=]"
              },
              "376": {
                "objective": "Help restore life to Saidra's Haven.",
                "level": 80,
                "coord": [
                  45505.1,
                  26809.6
                ],
                "bounds": [
                  [
                    45670.7,
                    26468.9
                  ],
                  [
                    45725.8,
                    26582.1
                  ],
                  [
                    45784.2,
                    26781.6
                  ],
                  [
                    45805.8,
                    26985.2
                  ],
                  [
                    45700,
                    26968.8
                  ],
                  [
                    45693.3,
                    27107.9
                  ],
                  [
                    45603.3,
                    27297.8
                  ],
                  [
                    45463.7,
                    27246.6
                  ],
                  [
                    45360.2,
                    26939.9
                  ],
                  [
                    45124.2,
                    26604.7
                  ],
                  [
                    45183.5,
                    26532.7
                  ],
                  [
                    45340.5,
                    26428.1
                  ],
                  [
                    45504.8,
                    26362.2
                  ],
                  [
                    45670.7,
                    26468.9
                  ]
                ],
                "id": 376,
                "chat_link": "[&BHgBAAA=]"
              },
              "377": {
                "objective": "Disrupt White Mantle forces occupying Fort Evennia.",
                "level": 80,
                "coord": [
                  45918.2,
                  26705.4
                ],
                "bounds": [
                  [
                    46206.2,
                    26687.7
                  ],
                  [
                    45928.3,
                    26769.4
                  ],
                  [
                    45862,
                    26695.3
                  ],
                  [
                    45951.7,
                    26141.5
                  ],
                  [
                    46247.7,
                    26120.6
                  ],
                  [
                    46206.2,
                    26687.7
                  ]
                ],
                "id": 377,
                "chat_link": "[&BHkBAAA=]"
              }
            },
            "skill_challenges": [],
            "sectors": {
              "1424": {
                "name": "Mantle's Breach",
                "level": 80,
                "coord": [
                  44923.1,
                  26465.2
                ],
                "bounds": [
                  [
                    45143.9,
                    26025.7
                  ],
                  [
                    44948.6,
                    26027.1
                  ],
                  [
                    44952.9,
                    26330.7
                  ],
                  [
                    44812.5,
                    26416.9
                  ],
                  [
                    44568,
                    26559
                  ],
                  [
                    44683.8,
                    26770.9
                  ],
                  [
                    44916.8,
                    26762.5
                  ],
                  [
                    45117.9,
                    26773.1
                  ],
                  [
                    45163.6,
                    26521.3
                  ],
                  [
                    45143.9,
                    26025.7
                  ]
                ],
                "id": 1424,
                "chat_link": "[&BJAFAAA=]"
              },
              "1425": {
                "name": "Saidra's Haven",
                "level": 80,
                "coord": [
                  45512.1,
                  26813
                ],
                "bounds": [
                  [
                    45286.7,
                    27385.1
                  ],
                  [
                    45275.3,
                    26863.7
                  ],
                  [
                    45115.6,
                    26770.7
                  ],
                  [
                    45159.4,
                    26522.6
                  ],
                  [
                    45419,
                    26344.9
                  ],
                  [
                    45533.7,
                    26395.9
                  ],
                  [
                    45777,
                    26583.4
                  ],
                  [
                    45836.4,
                    26784.9
                  ],
                  [
                    45810.7,
                    26992.6
                  ],
                  [
                    45696.8,
                    26979.8
                  ],
                  [
                    45722,
                    27318.9
                  ],
                  [
                    45286.7,
                    27385.1
                  ]
                ],
                "id": 1425,
                "chat_link": "[&BJEFAAA=]"
              },
              "1426": {
                "name": "Watchtower Cliffs",
                "level": 80,
                "coord": [
                  45999.5,
                  25849
                ],
                "bounds": [
                  [
                    45683.2,
                    26153.3
                  ],
                  [
                    45574.2,
                    26005.8
                  ],
                  [
                    45633.5,
                    25875.5
                  ],
                  [
                    45596.6,
                    25762.4
                  ],
                  [
                    45715.1,
                    25728.4
                  ],
                  [
                    45785.9,
                    25702.5
                  ],
                  [
                    45906.4,
                    25545.9
                  ],
                  [
                    46058.2,
                    25502.1
                  ],
                  [
                    46118.9,
                    25510.6
                  ],
                  [
                    46171,
                    25550.5
                  ],
                  [
                    46188.7,
                    25660.7
                  ],
                  [
                    46188.2,
                    25746
                  ],
                  [
                    46183.1,
                    25808.1
                  ],
                  [
                    46197.1,
                    25969.8
                  ],
                  [
                    46262.4,
                    25965.7
                  ],
                  [
                    46241.8,
                    26121.3
                  ],
                  [
                    46384.6,
                    26284.5
                  ],
                  [
                    46176,
                    26145.1
                  ],
                  [
                    45926.3,
                    26093
                  ],
                  [
                    45683.2,
                    26153.3
                  ]
                ],
                "id": 1426,
                "chat_link": "[&BJIFAAA=]"
              },
              "1428": {
                "name": "Lakeside Bazaar",
                "level": 80,
                "coord": [
                  46072.1,
                  27352
                ],
                "bounds": [
                  [
                    45696.5,
                    26981.6
                  ],
                  [
                    45985.1,
                    27009.7
                  ],
                  [
                    46366,
                    27202.6
                  ],
                  [
                    46377.3,
                    27396.9
                  ],
                  [
                    46318.2,
                    27508.4
                  ],
                  [
                    46279.2,
                    27722.6
                  ],
                  [
                    45832.2,
                    27679.8
                  ],
                  [
                    45722.6,
                    27314.4
                  ],
                  [
                    45696.5,
                    26981.6
                  ]
                ],
                "id": 1428,
                "chat_link": "[&BJQFAAA=]"
              },
              "1429": {
                "name": "Doric's Landing",
                "level": 80,
                "coord": [
                  45049.6,
                  27172.4
                ],
                "bounds": [
                  [
                    44661.9,
                    26747.2
                  ],
                  [
                    45119,
                    26769
                  ],
                  [
                    45276.5,
                    26861.2
                  ],
                  [
                    45282.9,
                    27020.1
                  ],
                  [
                    45296.1,
                    27425.5
                  ],
                  [
                    45274.7,
                    27683.3
                  ],
                  [
                    44689.9,
                    27742.5
                  ],
                  [
                    44795.6,
                    27130.5
                  ],
                  [
                    44661.9,
                    26747.2
                  ]
                ],
                "id": 1429,
                "chat_link": "[&BJUFAAA=]"
              },
              "1431": {
                "name": "Harvest Cascades",
                "level": 80,
                "coord": [
                  45313.8,
                  25772
                ],
                "bounds": [
                  [
                    45583.2,
                    26010.7
                  ],
                  [
                    45345.3,
                    26036.9
                  ],
                  [
                    45138.3,
                    26034
                  ],
                  [
                    44950,
                    26034.3
                  ],
                  [
                    44950.1,
                    25620.3
                  ],
                  [
                    44982,
                    25561.9
                  ],
                  [
                    45046.1,
                    25529.1
                  ],
                  [
                    45517.6,
                    25523.7
                  ],
                  [
                    45483.9,
                    25590.6
                  ],
                  [
                    45515.9,
                    25680.3
                  ],
                  [
                    45607,
                    25763.4
                  ],
                  [
                    45646,
                    25878.6
                  ],
                  [
                    45583.2,
                    26010.7
                  ]
                ],
                "id": 1431,
                "chat_link": "[&BJcFAAA=]"
              },
              "1432": {
                "name": "Eastern Divinity Reservoir",
                "level": 80,
                "coord": [
                  44839.2,
                  28048.2
                ],
                "bounds": [
                  [
                    44194.8,
                    27977.4
                  ],
                  [
                    44684.2,
                    27746.1
                  ],
                  [
                    45272,
                    27679.9
                  ],
                  [
                    45386.8,
                    28192.4
                  ],
                  [
                    45209.1,
                    28207.1
                  ],
                  [
                    44871.2,
                    28184.6
                  ],
                  [
                    44256.2,
                    28349.5
                  ],
                  [
                    44194.8,
                    27977.4
                  ]
                ],
                "id": 1432,
                "chat_link": "[&BJgFAAA=]"
              },
              "1434": {
                "name": "Melandru's Refuge",
                "level": 80,
                "coord": [
                  45991.7,
                  27828.7
                ],
                "bounds": [
                  [
                    46243,
                    27825.4
                  ],
                  [
                    46173.5,
                    28018
                  ],
                  [
                    45572.2,
                    28183.5
                  ],
                  [
                    45655.1,
                    27737.4
                  ],
                  [
                    45833.5,
                    27685.2
                  ],
                  [
                    45938.2,
                    27687.1
                  ],
                  [
                    46279.6,
                    27719.8
                  ],
                  [
                    46238.3,
                    27773.4
                  ],
                  [
                    46243,
                    27825.4
                  ]
                ],
                "id": 1434,
                "chat_link": "[&BJoFAAA=]"
              },
              "1435": {
                "name": "Doric Lumberyard",
                "level": 80,
                "coord": [
                  45433.1,
                  26208
                ],
                "bounds": [
                  [
                    45685.6,
                    26150.6
                  ],
                  [
                    45594.9,
                    26170.3
                  ],
                  [
                    45535.1,
                    26402.1
                  ],
                  [
                    45419.4,
                    26349
                  ],
                  [
                    45162.8,
                    26525.5
                  ],
                  [
                    45140,
                    26032.3
                  ],
                  [
                    45347.2,
                    26030.3
                  ],
                  [
                    45579.4,
                    26003.9
                  ],
                  [
                    45685.6,
                    26150.6
                  ]
                ],
                "id": 1435,
                "chat_link": "[&BJsFAAA=]"
              },
              "1437": {
                "name": "Eastern Hunting Grounds",
                "level": 80,
                "coord": [
                  46069.4,
                  26875.9
                ],
                "bounds": [
                  [
                    45813.9,
                    26997.7
                  ],
                  [
                    45833.7,
                    26786.9
                  ],
                  [
                    45807.9,
                    26702.7
                  ],
                  [
                    46033.4,
                    26714
                  ],
                  [
                    46314.5,
                    26709.3
                  ],
                  [
                    46402.6,
                    26875.7
                  ],
                  [
                    46366.8,
                    27205.2
                  ],
                  [
                    45982,
                    27015.4
                  ],
                  [
                    45813.9,
                    26997.7
                  ]
                ],
                "id": 1437,
                "chat_link": "[&BJ0FAAA=]"
              },
              "1440": {
                "name": "Watcher's Hollow",
                "level": 80,
                "coord": [
                  45647.6,
                  25649.9
                ],
                "bounds": [
                  [
                    45909.1,
                    25542.3
                  ],
                  [
                    45512.9,
                    25519.3
                  ],
                  [
                    45479.4,
                    25590.6
                  ],
                  [
                    45515.8,
                    25683.3
                  ],
                  [
                    45604.3,
                    25770.9
                  ],
                  [
                    45719.4,
                    25733.8
                  ],
                  [
                    45792.6,
                    25709.1
                  ],
                  [
                    45909.1,
                    25542.3
                  ]
                ],
                "id": 1440,
                "chat_link": "[&BKAFAAA=]"
              },
              "1446": {
                "name": "New Loamhurst",
                "level": 80,
                "coord": [
                  45590,
                  27698.9
                ],
                "bounds": [
                  [
                    45810.3,
                    27625.8
                  ],
                  [
                    45765.2,
                    27480.7
                  ],
                  [
                    45727,
                    27318.2
                  ],
                  [
                    45289.1,
                    27386.4
                  ],
                  [
                    45272.4,
                    27681.6
                  ],
                  [
                    45384.3,
                    28193.5
                  ],
                  [
                    45575.9,
                    28181.8
                  ],
                  [
                    45657.6,
                    27739.7
                  ],
                  [
                    45828,
                    27682.8
                  ],
                  [
                    45810.3,
                    27625.8
                  ]
                ],
                "id": 1446,
                "chat_link": "[&BKYFAAA=]"
              },
              "1448": {
                "name": "Fort Evennia",
                "level": 80,
                "coord": [
                  45946.8,
                  26422.7
                ],
                "bounds": [
                  [
                    45808.7,
                    26706.7
                  ],
                  [
                    45772.3,
                    26585.1
                  ],
                  [
                    45529.9,
                    26398.9
                  ],
                  [
                    45592.1,
                    26167.7
                  ],
                  [
                    45928.6,
                    26090.4
                  ],
                  [
                    46158.6,
                    26142.6
                  ],
                  [
                    46384.4,
                    26280.8
                  ],
                  [
                    46313.2,
                    26712.4
                  ],
                  [
                    46032.9,
                    26720
                  ],
                  [
                    45808.7,
                    26706.7
                  ]
                ],
                "id": 1448,
                "chat_link": "[&BKgFAAA=]"
              }
            },
            "adventures": [],
            "id": 1185,
            "mastery_points": [
              {
                "coord": [
                  46198.1,
                  27528.9
                ],
                "id": 184,
                "region": "Maguuma"
              },
              {
                "coord": [
                  45413.7,
                  25598.4
                ],
                "id": 156,
                "region": "Maguuma"
              },
              {
                "coord": [
                  45791.1,
                  27307.5
                ],
                "id": 173,
                "region": "Maguuma"
              },
              {
                "coord": [
                  46037.1,
                  27931.1
                ],
                "id": 187,
                "region": "Maguuma"
              }
            ]
          },
          "1193": {
            "name": "The First Vision",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {
              "23": {
                "name": "Black Haven",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45707.1,
                  30934.8
                ],
                "id": 23,
                "chat_link": "[&BBcAAAA=]"
              },
              "24": {
                "name": "Gort's Pit",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45741.9,
                  31380.8
                ],
                "id": 24,
                "chat_link": "[&BBgAAAA=]"
              },
              "25": {
                "name": "Garenhoff",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46100.6,
                  32018.3
                ],
                "id": 25,
                "chat_link": "[&BBkAAAA=]"
              },
              "26": {
                "name": "Jannaj's Bandits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45361.2,
                  30551.3
                ],
                "id": 26,
                "chat_link": "[&BBoAAAA=]"
              },
              "27": {
                "name": "Quarryside",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44344.4,
                  31240.6
                ],
                "id": 27,
                "chat_link": "[&BBsAAAA=]"
              },
              "28": {
                "name": "Triskell Quay",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44378.5,
                  31716.4
                ],
                "id": 28,
                "chat_link": "[&BBwAAAA=]"
              },
              "29": {
                "name": "Goff's Bandits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44149.6,
                  30620.3
                ],
                "id": 29,
                "chat_link": "[&BB0AAAA=]"
              },
              "30": {
                "name": "Kenna's Bandits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43862.6,
                  31000.4
                ],
                "id": 30,
                "chat_link": "[&BB4AAAA=]"
              },
              "31": {
                "name": "Auld Red Wharf",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43612.4,
                  31314.2
                ],
                "id": 31,
                "chat_link": "[&BB8AAAA=]"
              },
              "32": {
                "name": "Wallwatcher Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42521.1,
                  31030.5
                ],
                "id": 32,
                "chat_link": "[&BCAAAAA=]"
              },
              "33": {
                "name": "Mudbay Digs",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43161.6,
                  31946.5
                ],
                "id": 33,
                "chat_link": "[&BCEAAAA=]"
              },
              "34": {
                "name": "Togatl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43952.9,
                  31587.5
                ],
                "id": 34,
                "chat_link": "[&BCIAAAA=]"
              },
              "35": {
                "name": "Krait's Larder",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44382.8,
                  32025.9
                ],
                "id": 35,
                "chat_link": "[&BCMAAAA=]"
              },
              "822": {
                "name": "Uzolan's Hideout",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45527.1,
                  30686.9
                ],
                "id": 822,
                "chat_link": "[&BDYDAAA=]"
              },
              "1270": {
                "name": "Barnaby's Watch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44714.8,
                  30886.7
                ],
                "id": 1270,
                "chat_link": "[&BPYEAAA=]"
              },
              "1283": {
                "name": "Isgarren's View",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45867.1,
                  32291
                ],
                "id": 1283,
                "chat_link": "[&BAMFAAA=]"
              },
              "1526": {
                "name": "Lair of the Seawitch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43459.9,
                  31784.9
                ],
                "id": 1526,
                "chat_link": "[&BPYFAAA=]"
              },
              "1527": {
                "name": "Mafic Core",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45454.2,
                  32288.6
                ],
                "id": 1527,
                "chat_link": "[&BPcFAAA=]"
              },
              "1837": {
                "name": "Thunder Ridge Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42944,
                  31222.8
                ],
                "id": 1837,
                "chat_link": "[&BC0HAAA=]"
              },
              "1838": {
                "name": "Tower of Nightmares",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43395.7,
                  31595.5
                ],
                "id": 1838,
                "chat_link": "[&BC4HAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "69": {
                "name": "Eukaryan Caves",
                "level": 22,
                "coord": [
                  43842.3,
                  31995
                ],
                "bounds": [
                  [
                    43683.8,
                    31768.7
                  ],
                  [
                    43805.6,
                    32261.3
                  ],
                  [
                    44128.7,
                    32263.1
                  ],
                  [
                    43751.4,
                    31687.1
                  ],
                  [
                    43683.8,
                    31768.7
                  ]
                ],
                "id": 69,
                "chat_link": "[&BEUAAAA=]"
              },
              "70": {
                "name": "Earthworks Bluff",
                "level": 16,
                "coord": [
                  45152.2,
                  31153
                ],
                "bounds": [
                  [
                    44973,
                    31236
                  ],
                  [
                    44713.8,
                    31012.2
                  ],
                  [
                    44955.8,
                    30761.8
                  ],
                  [
                    45195.3,
                    30763.2
                  ],
                  [
                    45477.7,
                    30931.3
                  ],
                  [
                    45522.8,
                    31198.2
                  ],
                  [
                    45329.6,
                    31507.9
                  ],
                  [
                    45232.3,
                    31574.8
                  ],
                  [
                    44969.4,
                    31391.7
                  ],
                  [
                    44973,
                    31236
                  ]
                ],
                "id": 70,
                "chat_link": "[&BEYAAAA=]"
              },
              "71": {
                "name": "Overlord's Greatcamp",
                "level": 25,
                "coord": [
                  42469.5,
                  31560.4
                ],
                "bounds": [
                  [
                    42889.7,
                    31400.3
                  ],
                  [
                    42081.4,
                    31276.8
                  ],
                  [
                    42053.2,
                    31538.6
                  ],
                  [
                    42115.2,
                    31724.4
                  ],
                  [
                    42860,
                    31788.9
                  ],
                  [
                    42817.4,
                    31633.6
                  ],
                  [
                    42889.7,
                    31400.3
                  ]
                ],
                "id": 71,
                "chat_link": "[&BEcAAAA=]"
              },
              "72": {
                "name": "Manefire Hills",
                "level": 20,
                "coord": [
                  44040.3,
                  31133.2
                ],
                "bounds": [
                  [
                    44136.4,
                    31554.8
                  ],
                  [
                    43863.4,
                    31338.3
                  ],
                  [
                    43708.5,
                    30942.2
                  ],
                  [
                    43850.6,
                    30856.3
                  ],
                  [
                    44008.3,
                    30793.1
                  ],
                  [
                    44177.3,
                    31001.5
                  ],
                  [
                    44269,
                    31097.9
                  ],
                  [
                    44173.3,
                    31234.6
                  ],
                  [
                    44175.9,
                    31380.1
                  ],
                  [
                    44136.4,
                    31554.8
                  ]
                ],
                "id": 72,
                "chat_link": "[&BEgAAAA=]"
              },
              "73": {
                "name": "Meremoot Hill",
                "level": 24,
                "coord": [
                  42526.7,
                  31960
                ],
                "bounds": [
                  [
                    42914.8,
                    32084
                  ],
                  [
                    42860.5,
                    31787.8
                  ],
                  [
                    42112.1,
                    31727.2
                  ],
                  [
                    42047.7,
                    31873.9
                  ],
                  [
                    42470.6,
                    32112.1
                  ],
                  [
                    42754.4,
                    32174.8
                  ],
                  [
                    42914.8,
                    32084
                  ]
                ],
                "id": 73,
                "chat_link": "[&BEkAAAA=]"
              },
              "74": {
                "name": "Thunder Ridge",
                "level": 24,
                "coord": [
                  42571.2,
                  31159.3
                ],
                "bounds": [
                  [
                    43018.8,
                    31316
                  ],
                  [
                    42890.9,
                    31400.6
                  ],
                  [
                    42090.9,
                    31276.3
                  ],
                  [
                    42158.8,
                    31008.7
                  ],
                  [
                    42304.9,
                    31124.8
                  ],
                  [
                    42461.7,
                    30974.2
                  ],
                  [
                    42595.8,
                    30968
                  ],
                  [
                    43047.8,
                    31205.5
                  ],
                  [
                    43018.8,
                    31316
                  ]
                ],
                "id": 74,
                "chat_link": "[&BEoAAAA=]"
              },
              "75": {
                "name": "Greyhoof Meadows",
                "level": 22,
                "coord": [
                  43498,
                  30725.9
                ],
                "bounds": [
                  [
                    43750.3,
                    31041.3
                  ],
                  [
                    43392,
                    31213.3
                  ],
                  [
                    43191.3,
                    31095.2
                  ],
                  [
                    43064.7,
                    30752.8
                  ],
                  [
                    43136.5,
                    30461.3
                  ],
                  [
                    43225.2,
                    30392.9
                  ],
                  [
                    43533.4,
                    30368.5
                  ],
                  [
                    43776.5,
                    30402.3
                  ],
                  [
                    43844,
                    30453.2
                  ],
                  [
                    43850.1,
                    30858.3
                  ],
                  [
                    43713.3,
                    30945.8
                  ],
                  [
                    43750.3,
                    31041.3
                  ]
                ],
                "id": 75,
                "chat_link": "[&BEsAAAA=]"
              },
              "76": {
                "name": "Earthlord's Gap",
                "level": 19,
                "coord": [
                  44253,
                  30734.8
                ],
                "bounds": [
                  [
                    44396.5,
                    31013.5
                  ],
                  [
                    44268.6,
                    31098.3
                  ],
                  [
                    44172.7,
                    30999.5
                  ],
                  [
                    44008.6,
                    30792.3
                  ],
                  [
                    43850.3,
                    30856.2
                  ],
                  [
                    43843.6,
                    30452
                  ],
                  [
                    44131.2,
                    30428
                  ],
                  [
                    44485.6,
                    30340.5
                  ],
                  [
                    44732.1,
                    30456.3
                  ],
                  [
                    44640.5,
                    30911.8
                  ],
                  [
                    44396.5,
                    31013.5
                  ]
                ],
                "id": 76,
                "chat_link": "[&BEwAAAA=]"
              },
              "77": {
                "name": "Fort Salma",
                "level": 23,
                "coord": [
                  42863.9,
                  30543.3
                ],
                "bounds": [
                  [
                    43137.2,
                    30458.5
                  ],
                  [
                    43057.7,
                    30376.9
                  ],
                  [
                    42661.4,
                    30396
                  ],
                  [
                    42527.5,
                    30509.5
                  ],
                  [
                    42732.1,
                    30763.9
                  ],
                  [
                    43067.6,
                    30755.1
                  ],
                  [
                    43137.2,
                    30458.5
                  ]
                ],
                "id": 77,
                "chat_link": "[&BE0AAAA=]"
              },
              "78": {
                "name": "Triskellion Vale",
                "level": 19,
                "coord": [
                  44555.1,
                  31356
                ],
                "bounds": [
                  [
                    44973.2,
                    31390.2
                  ],
                  [
                    44881.7,
                    31494.6
                  ],
                  [
                    44753.8,
                    31476.2
                  ],
                  [
                    44626.9,
                    31584.4
                  ],
                  [
                    44599.2,
                    31793.3
                  ],
                  [
                    44456.9,
                    31806
                  ],
                  [
                    44136.3,
                    31553.6
                  ],
                  [
                    44176,
                    31380.3
                  ],
                  [
                    44173.6,
                    31236.8
                  ],
                  [
                    44269.4,
                    31098.3
                  ],
                  [
                    44395,
                    31011
                  ],
                  [
                    44641.8,
                    30910.8
                  ],
                  [
                    44713.5,
                    31013
                  ],
                  [
                    44973.9,
                    31235
                  ],
                  [
                    44973.2,
                    31390.2
                  ]
                ],
                "id": 78,
                "chat_link": "[&BE4AAAA=]"
              },
              "79": {
                "name": "Viathan's Arm",
                "level": 21,
                "coord": [
                  44322.4,
                  31900.8
                ],
                "bounds": [
                  [
                    44126.2,
                    32261.4
                  ],
                  [
                    44455.7,
                    32261.9
                  ],
                  [
                    44618.3,
                    32126.5
                  ],
                  [
                    44704.7,
                    31928.8
                  ],
                  [
                    44600.7,
                    31794
                  ],
                  [
                    44458.1,
                    31804.7
                  ],
                  [
                    43865.8,
                    31337.1
                  ],
                  [
                    43749.4,
                    31692.2
                  ],
                  [
                    44126.2,
                    32261.4
                  ]
                ],
                "id": 79,
                "chat_link": "[&BE8AAAA=]"
              },
              "80": {
                "name": "Viathan Lake",
                "level": 23,
                "coord": [
                  43466.6,
                  31793.7
                ],
                "bounds": [
                  [
                    43680.4,
                    31766.7
                  ],
                  [
                    43752.3,
                    31696.2
                  ],
                  [
                    43864.3,
                    31340.9
                  ],
                  [
                    43745.7,
                    31042
                  ],
                  [
                    43392,
                    31210.7
                  ],
                  [
                    43194.4,
                    31094.9
                  ],
                  [
                    43113.8,
                    31160
                  ],
                  [
                    43220.1,
                    31383.2
                  ],
                  [
                    43060.4,
                    31648.7
                  ],
                  [
                    43297.7,
                    31933.2
                  ],
                  [
                    43253.6,
                    32145.5
                  ],
                  [
                    43418.8,
                    32383.8
                  ],
                  [
                    43381.1,
                    32520.6
                  ],
                  [
                    43589.1,
                    32582.2
                  ],
                  [
                    43692.8,
                    32523.1
                  ],
                  [
                    43808.5,
                    32266.7
                  ],
                  [
                    43680.4,
                    31766.7
                  ]
                ],
                "id": 80,
                "chat_link": "[&BFAAAAA=]"
              },
              "81": {
                "name": "Delanian Foothills",
                "level": 16,
                "coord": [
                  45799.8,
                  31003.8
                ],
                "bounds": [
                  [
                    45892.9,
                    30937.8
                  ],
                  [
                    45831.5,
                    30946.6
                  ],
                  [
                    45853.1,
                    30775.9
                  ],
                  [
                    45765.9,
                    30763.2
                  ],
                  [
                    45611.4,
                    30819.8
                  ],
                  [
                    45476.6,
                    30930.8
                  ],
                  [
                    45520.6,
                    31194.7
                  ],
                  [
                    45848.7,
                    31293.6
                  ],
                  [
                    46142.6,
                    31241.7
                  ],
                  [
                    46054.7,
                    31134.1
                  ],
                  [
                    45892.9,
                    30937.8
                  ]
                ],
                "id": 81,
                "chat_link": "[&BFEAAAA=]"
              },
              "82": {
                "name": "Blackroot Cut",
                "level": 16,
                "coord": [
                  45894.2,
                  30717.2
                ],
                "bounds": [
                  [
                    45577.1,
                    30669
                  ],
                  [
                    45610.7,
                    30830.5
                  ],
                  [
                    45765.4,
                    30764.3
                  ],
                  [
                    45854.1,
                    30775.7
                  ],
                  [
                    45827.5,
                    30946.8
                  ],
                  [
                    45890,
                    30939.4
                  ],
                  [
                    45934.6,
                    30894.3
                  ],
                  [
                    45996.5,
                    30889.7
                  ],
                  [
                    46139.5,
                    30778.3
                  ],
                  [
                    46243.3,
                    30532.6
                  ],
                  [
                    46199.3,
                    30446
                  ],
                  [
                    45947,
                    30405.5
                  ],
                  [
                    45639.2,
                    30451.9
                  ],
                  [
                    45577.1,
                    30669
                  ]
                ],
                "id": 82,
                "chat_link": "[&BFIAAAA=]"
              },
              "83": {
                "name": "Cereboth Canyon",
                "level": 20,
                "coord": [
                  45557,
                  31978.7
                ],
                "bounds": [
                  [
                    45520.8,
                    31196.5
                  ],
                  [
                    45329.1,
                    31507.1
                  ],
                  [
                    45232.3,
                    31573.4
                  ],
                  [
                    45219,
                    31738.3
                  ],
                  [
                    45368.3,
                    31829
                  ],
                  [
                    45226.5,
                    32145.9
                  ],
                  [
                    45379.5,
                    32388.4
                  ],
                  [
                    45428.7,
                    32480.5
                  ],
                  [
                    45525.2,
                    32578
                  ],
                  [
                    45719.3,
                    32550.4
                  ],
                  [
                    45909.5,
                    32500.8
                  ],
                  [
                    45748.7,
                    32325.8
                  ],
                  [
                    45683.8,
                    32254.5
                  ],
                  [
                    45873.6,
                    31829.2
                  ],
                  [
                    45898.9,
                    31470.5
                  ],
                  [
                    45849.4,
                    31290.9
                  ],
                  [
                    45520.8,
                    31196.5
                  ]
                ],
                "id": 83,
                "chat_link": "[&BFMAAAA=]"
              },
              "84": {
                "name": "Halacon Cataracts",
                "level": 23,
                "coord": [
                  42556.9,
                  30865.5
                ],
                "bounds": [
                  [
                    43047.6,
                    31207.3
                  ],
                  [
                    42597.9,
                    30969.5
                  ],
                  [
                    42462.8,
                    30974.9
                  ],
                  [
                    42305,
                    31126.9
                  ],
                  [
                    42153.9,
                    31014.6
                  ],
                  [
                    42164,
                    30827
                  ],
                  [
                    42166.5,
                    30627
                  ],
                  [
                    42263.3,
                    30521.3
                  ],
                  [
                    42528.2,
                    30509.2
                  ],
                  [
                    42733,
                    30761.6
                  ],
                  [
                    43068.2,
                    30753.9
                  ],
                  [
                    43192.8,
                    31093
                  ],
                  [
                    43047.6,
                    31207.3
                  ]
                ],
                "id": 84,
                "chat_link": "[&BFQAAAA=]"
              },
              "85": {
                "name": "Viath Shore",
                "level": 24,
                "coord": [
                  43041.7,
                  31641.6
                ],
                "bounds": [
                  [
                    43254.6,
                    32142.1
                  ],
                  [
                    43299.8,
                    31929.6
                  ],
                  [
                    43062.5,
                    31645.7
                  ],
                  [
                    43220.2,
                    31379.5
                  ],
                  [
                    43112.2,
                    31154.3
                  ],
                  [
                    43046.8,
                    31201.8
                  ],
                  [
                    43016,
                    31312.1
                  ],
                  [
                    42890.4,
                    31400.4
                  ],
                  [
                    42816.7,
                    31634.6
                  ],
                  [
                    42861,
                    31787.9
                  ],
                  [
                    42914.8,
                    32082.8
                  ],
                  [
                    43005.8,
                    32028
                  ],
                  [
                    43254.6,
                    32142.1
                  ]
                ],
                "id": 85,
                "chat_link": "[&BFUAAAA=]"
              },
              "86": {
                "name": "Sojourner's Way",
                "level": 15,
                "coord": [
                  45174.4,
                  30638.1
                ],
                "bounds": [
                  [
                    45621.2,
                    30832.1
                  ],
                  [
                    45577.9,
                    30670
                  ],
                  [
                    45641,
                    30452.5
                  ],
                  [
                    45560.2,
                    30414.4
                  ],
                  [
                    45356.7,
                    30456.5
                  ],
                  [
                    45073.4,
                    30450.4
                  ],
                  [
                    45001.6,
                    30402.2
                  ],
                  [
                    44903,
                    30440.5
                  ],
                  [
                    44729.4,
                    30443.9
                  ],
                  [
                    44638,
                    30900.2
                  ],
                  [
                    44714.8,
                    31011.5
                  ],
                  [
                    44954.3,
                    30763.5
                  ],
                  [
                    45192.5,
                    30762.8
                  ],
                  [
                    45477.2,
                    30932.9
                  ],
                  [
                    45621.2,
                    30832.1
                  ]
                ],
                "id": 86,
                "chat_link": "[&BFYAAAA=]"
              },
              "87": {
                "name": "Alakess Ledge",
                "level": 22,
                "coord": [
                  44238.9,
                  32351
                ],
                "bounds": [
                  [
                    44072,
                    32411.1
                  ],
                  [
                    43900.6,
                    32563.4
                  ],
                  [
                    43691,
                    32518.7
                  ],
                  [
                    43806.4,
                    32260.6
                  ],
                  [
                    44454.4,
                    32261.2
                  ],
                  [
                    44615,
                    32125.8
                  ],
                  [
                    44716.5,
                    32296
                  ],
                  [
                    44655.6,
                    32371.1
                  ],
                  [
                    44072,
                    32411.1
                  ]
                ],
                "id": 87,
                "chat_link": "[&BFcAAAA=]"
              },
              "88": {
                "name": "Darkwound Defile",
                "level": 18,
                "coord": [
                  46049.7,
                  31542.2
                ],
                "bounds": [
                  [
                    46124.1,
                    31851
                  ],
                  [
                    46199.7,
                    31666.2
                  ],
                  [
                    46198.3,
                    31577
                  ],
                  [
                    46111.1,
                    31409.2
                  ],
                  [
                    46142.8,
                    31245
                  ],
                  [
                    45848.9,
                    31288.5
                  ],
                  [
                    45898.2,
                    31472.4
                  ],
                  [
                    45874.4,
                    31828.5
                  ],
                  [
                    46124.1,
                    31851
                  ]
                ],
                "id": 88,
                "chat_link": "[&BFgAAAA=]"
              },
              "89": {
                "name": "Giant's Passage",
                "level": 20,
                "coord": [
                  44831.6,
                  31740.4
                ],
                "bounds": [
                  [
                    44714.3,
                    32296.6
                  ],
                  [
                    44616.2,
                    32125.7
                  ],
                  [
                    44702,
                    31929.7
                  ],
                  [
                    44599.1,
                    31793.8
                  ],
                  [
                    44628.5,
                    31586.7
                  ],
                  [
                    44753.7,
                    31476.6
                  ],
                  [
                    44881.5,
                    31493.4
                  ],
                  [
                    44969.9,
                    31389.8
                  ],
                  [
                    45232.5,
                    31574.2
                  ],
                  [
                    45218.6,
                    31737.5
                  ],
                  [
                    44714.3,
                    32296.6
                  ]
                ],
                "id": 89,
                "chat_link": "[&BFkAAAA=]"
              },
              "90": {
                "name": "Lychcroft Mere",
                "level": 22,
                "coord": [
                  42655.4,
                  32220.9
                ],
                "bounds": [
                  [
                    43382.8,
                    32519.4
                  ],
                  [
                    42159.2,
                    32552.1
                  ],
                  [
                    42055.5,
                    32447.9
                  ],
                  [
                    42000.3,
                    31986.5
                  ],
                  [
                    42048.6,
                    31873.9
                  ],
                  [
                    42471,
                    32113
                  ],
                  [
                    42754.3,
                    32173.8
                  ],
                  [
                    43006.3,
                    32028.3
                  ],
                  [
                    43258.1,
                    32135.6
                  ],
                  [
                    43418.3,
                    32378.6
                  ],
                  [
                    43382.8,
                    32519.4
                  ]
                ],
                "id": 90,
                "chat_link": "[&BFoAAAA=]"
              },
              "91": {
                "name": "Dominion Killing Zone",
                "level": 21,
                "coord": [
                  45098.7,
                  32221.2
                ],
                "bounds": [
                  [
                    45370,
                    31826.5
                  ],
                  [
                    45212.9,
                    31734.5
                  ],
                  [
                    44644.6,
                    32351.7
                  ],
                  [
                    44725.4,
                    32472
                  ],
                  [
                    44877.5,
                    32402.3
                  ],
                  [
                    45350.7,
                    32449.7
                  ],
                  [
                    45381.3,
                    32388
                  ],
                  [
                    45227.2,
                    32145
                  ],
                  [
                    45370,
                    31826.5
                  ]
                ],
                "id": 91,
                "chat_link": "[&BFsAAAA=]"
              },
              "92": {
                "name": "Wizard's Fief",
                "level": 19,
                "coord": [
                  46057.5,
                  32277.4
                ],
                "bounds": [
                  [
                    46130.3,
                    31848.2
                  ],
                  [
                    45873.9,
                    31829.2
                  ],
                  [
                    45681.7,
                    32253.6
                  ],
                  [
                    46163.9,
                    32808.2
                  ],
                  [
                    46437.7,
                    32647.9
                  ],
                  [
                    46130.3,
                    31848.2
                  ]
                ],
                "id": 92,
                "chat_link": "[&BFwAAAA=]"
              },
              "739": {
                "name": "Draithor's Demesnes",
                "level": 16,
                "coord": [
                  46063.3,
                  30982.4
                ],
                "bounds": [
                  [
                    46139.7,
                    30777.7
                  ],
                  [
                    46164.7,
                    30908
                  ],
                  [
                    46185.6,
                    31077.3
                  ],
                  [
                    46140.9,
                    31239.8
                  ],
                  [
                    46053.5,
                    31133
                  ],
                  [
                    45890,
                    30938.3
                  ],
                  [
                    45935.3,
                    30894.6
                  ],
                  [
                    45996.7,
                    30890.2
                  ],
                  [
                    46139.7,
                    30777.7
                  ]
                ],
                "id": 739,
                "chat_link": "[&BOMCAAA=]"
              }
            },
            "adventures": [],
            "id": 1193,
            "mastery_points": []
          },
          "1220": {
            "name": "Sparking the Flame (Prologue)",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              49216,
              31488
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                30720,
                18432
              ]
            ],
            "continent_rect": [
              [
                48000,
                30720
              ],
              [
                50432,
                32256
              ]
            ],
            "points_of_interest": {
              "1759": {
                "name": "Order of Whispers Headquarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48601.6,
                  31012.6
                ],
                "id": 1759,
                "chat_link": "[&BN8GAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "854": {
                "name": "Commodore's Quarter",
                "level": 0,
                "coord": [
                  48567.8,
                  30932
                ],
                "bounds": [
                  [
                    48413.1,
                    30875.7
                  ],
                  [
                    48406,
                    30777.8
                  ],
                  [
                    48802,
                    30757.5
                  ],
                  [
                    48740.4,
                    31025.5
                  ],
                  [
                    48745,
                    31108.7
                  ],
                  [
                    48499.5,
                    31042
                  ],
                  [
                    48369,
                    30936.6
                  ],
                  [
                    48413.1,
                    30875.7
                  ]
                ],
                "id": 854,
                "chat_link": "[&BFYDAAA=]"
              },
              "866": {
                "name": "Western Ward",
                "level": 0,
                "coord": [
                  48576,
                  31217
                ],
                "bounds": [
                  [
                    48415.4,
                    31365.9
                  ],
                  [
                    48446.3,
                    31240.2
                  ],
                  [
                    48368.9,
                    31131.6
                  ],
                  [
                    48278.1,
                    31065
                  ],
                  [
                    48369,
                    30936.6
                  ],
                  [
                    48502.4,
                    31033.9
                  ],
                  [
                    48742.5,
                    31097.5
                  ],
                  [
                    48835.4,
                    31255.4
                  ],
                  [
                    48879.9,
                    31313
                  ],
                  [
                    48904.8,
                    31486.8
                  ],
                  [
                    48593.5,
                    31461
                  ],
                  [
                    48415.4,
                    31365.9
                  ]
                ],
                "id": 866,
                "chat_link": "[&BGIDAAA=]"
              }
            },
            "adventures": [],
            "id": 1220,
            "mastery_points": []
          },
          "1246": {
            "name": "Captain Kiel's Office",
            "min_level": 0,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              49216,
              31488
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                30720,
                18432
              ]
            ],
            "continent_rect": [
              [
                48000,
                30720
              ],
              [
                50432,
                32256
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1246,
            "mastery_points": []
          },
          "1285": {
            "name": "???",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              54068,
              57384
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1285,
            "mastery_points": []
          },
          "1369": {
            "name": "Canach's Lair",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45668,
              36216
            ],
            "map_rect": [
              [
                -30720,
                -21504
              ],
              [
                33792,
                21504
              ]
            ],
            "continent_rect": [
              [
                44288,
                35328
              ],
              [
                46976,
                37120
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1369,
            "mastery_points": []
          },
          "1471": {
            "name": "Case Closed—The Dead End",
            "min_level": 1,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              43008,
              26240
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {
              "1805": {
                "name": "The Dead End",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44361.8,
                  27847.8
                ],
                "id": 1805,
                "chat_link": "[&BA0HAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "736": {
                "name": "Eastern Commons",
                "level": 0,
                "coord": [
                  44277.2,
                  27723
                ],
                "bounds": [
                  [
                    44344,
                    27466.1
                  ],
                  [
                    44447.2,
                    27528.3
                  ],
                  [
                    44435.8,
                    27653.3
                  ],
                  [
                    44594.2,
                    27862.4
                  ],
                  [
                    44489,
                    27944.1
                  ],
                  [
                    44347.1,
                    28008.4
                  ],
                  [
                    44180.8,
                    28027.1
                  ],
                  [
                    44179,
                    27829.3
                  ],
                  [
                    44116.2,
                    27740.5
                  ],
                  [
                    44054.3,
                    27737.5
                  ],
                  [
                    44052.9,
                    27623.9
                  ],
                  [
                    44130.3,
                    27606.8
                  ],
                  [
                    44222.9,
                    27572.6
                  ],
                  [
                    44287.2,
                    27522.2
                  ],
                  [
                    44344,
                    27466.1
                  ]
                ],
                "id": 736,
                "chat_link": "[&BOACAAA=]"
              }
            },
            "adventures": [],
            "id": 1471,
            "mastery_points": []
          },
          "1472": {
            "name": "Hard Boiled—The Dead End",
            "min_level": 1,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              43008,
              26240
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {
              "1805": {
                "name": "The Dead End",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44361.8,
                  27847.8
                ],
                "id": 1805,
                "chat_link": "[&BA0HAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "736": {
                "name": "Eastern Commons",
                "level": 0,
                "coord": [
                  44277.2,
                  27723
                ],
                "bounds": [
                  [
                    44344,
                    27466.1
                  ],
                  [
                    44447.2,
                    27528.3
                  ],
                  [
                    44435.8,
                    27653.3
                  ],
                  [
                    44594.2,
                    27862.4
                  ],
                  [
                    44489,
                    27944.1
                  ],
                  [
                    44347.1,
                    28008.4
                  ],
                  [
                    44180.8,
                    28027.1
                  ],
                  [
                    44179,
                    27829.3
                  ],
                  [
                    44116.2,
                    27740.5
                  ],
                  [
                    44054.3,
                    27737.5
                  ],
                  [
                    44052.9,
                    27623.9
                  ],
                  [
                    44130.3,
                    27606.8
                  ],
                  [
                    44222.9,
                    27572.6
                  ],
                  [
                    44287.2,
                    27522.2
                  ],
                  [
                    44344,
                    27466.1
                  ]
                ],
                "id": 736,
                "chat_link": "[&BOACAAA=]"
              }
            },
            "adventures": [],
            "id": 1472,
            "mastery_points": []
          },
          "1474": {
            "name": "Picking Up the Pieces",
            "min_level": 0,
            "max_level": 80,
            "default_floor": 2,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1474,
            "mastery_points": []
          }
        },
        "id": 4
      },
      "5": {
        "name": "Maguuma Jungle",
        "label_coord": [
          41216,
          37344
        ],
        "continent_rect": [
          [
            37376,
            30848
          ],
          [
            44032,
            38592
          ]
        ],
        "maps": {
          "34": {
            "name": "Caledon Forest",
            "min_level": 1,
            "max_level": 15,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {
              "103": {
                "name": "Solitaire Island",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42899,
                  36265.2
                ],
                "id": 103,
                "chat_link": "[&BGcAAAA=]"
              },
              "104": {
                "name": "Caer Verdant",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43468.7,
                  36063.8
                ],
                "id": 104,
                "chat_link": "[&BGgAAAA=]"
              },
              "105": {
                "name": "Golotl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42957.3,
                  35412.8
                ],
                "id": 105,
                "chat_link": "[&BGkAAAA=]"
              },
              "106": {
                "name": "Bay Haven",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42602.6,
                  35097.1
                ],
                "id": 106,
                "chat_link": "[&BGoAAAA=]"
              },
              "107": {
                "name": "Morgatl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43708.6,
                  33164.1
                ],
                "id": 107,
                "chat_link": "[&BGsAAAA=]"
              },
              "108": {
                "name": "Naulshead Refuge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42357.7,
                  34599.7
                ],
                "id": 108,
                "chat_link": "[&BGwAAAA=]"
              },
              "109": {
                "name": "Stormwreck Deeps",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43632.3,
                  34558
                ],
                "id": 109,
                "chat_link": "[&BG0AAAA=]"
              },
              "110": {
                "name": "Hemlock Coil",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42367.8,
                  34346
                ],
                "id": 110,
                "chat_link": "[&BG4AAAA=]"
              },
              "111": {
                "name": "Hanto Trading Post",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43131.8,
                  33728.3
                ],
                "id": 111,
                "chat_link": "[&BG8AAAA=]"
              },
              "112": {
                "name": "Hazupl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43374.8,
                  33724.7
                ],
                "id": 112,
                "chat_link": "[&BHAAAAA=]"
              },
              "113": {
                "name": "Soggorsort",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43735.8,
                  33569.1
                ],
                "id": 113,
                "chat_link": "[&BHEAAAA=]"
              },
              "114": {
                "name": "Slaver's Deeps",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43826.8,
                  32933.3
                ],
                "id": 114,
                "chat_link": "[&BHIAAAA=]"
              },
              "115": {
                "name": "Banshee's Keen",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42487.9,
                  32975.4
                ],
                "id": 115,
                "chat_link": "[&BHMAAAA=]"
              },
              "116": {
                "name": "Dengatl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42316.5,
                  33711.8
                ],
                "id": 116,
                "chat_link": "[&BHQAAAA=]"
              },
              "308": {
                "name": "Astorea Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  42723.9,
                  36217.2
                ],
                "id": 308,
                "chat_link": "[&BDQBAAA=]"
              },
              "309": {
                "name": "Spiral Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43729.7,
                  35620.3
                ],
                "id": 309,
                "chat_link": "[&BDUBAAA=]"
              },
              "310": {
                "name": "Caer Astorea Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  42620.1,
                  35734.6
                ],
                "id": 310,
                "chat_link": "[&BDYBAAA=]"
              },
              "311": {
                "name": "Gleaner's Cove Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  42534.7,
                  35459.8
                ],
                "id": 311,
                "chat_link": "[&BDcBAAA=]"
              },
              "312": {
                "name": "Brigid's Overlook Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43061.3,
                  35067.5
                ],
                "id": 312,
                "chat_link": "[&BDgBAAA=]"
              },
              "313": {
                "name": "Sperrins Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43759.5,
                  34975.3
                ],
                "id": 313,
                "chat_link": "[&BDkBAAA=]"
              },
              "314": {
                "name": "Mabon Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  42869.2,
                  34533
                ],
                "id": 314,
                "chat_link": "[&BDoBAAA=]"
              },
              "315": {
                "name": "Town of Cathal Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  42302.5,
                  33993.5
                ],
                "id": 315,
                "chat_link": "[&BDsBAAA=]"
              },
              "316": {
                "name": "Caledon Haven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  42659.5,
                  33826.3
                ],
                "id": 316,
                "chat_link": "[&BDwBAAA=]"
              },
              "317": {
                "name": "Titan's Staircase Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43593.9,
                  34162.9
                ],
                "id": 317,
                "chat_link": "[&BD0BAAA=]"
              },
              "318": {
                "name": "Falias Thorp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  42446.1,
                  33409
                ],
                "id": 318,
                "chat_link": "[&BD4BAAA=]"
              },
              "319": {
                "name": "Hamlet of Annwen Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43345.5,
                  33197.9
                ],
                "id": 319,
                "chat_link": "[&BD8BAAA=]"
              },
              "320": {
                "name": "Kraitbane Haven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43487.8,
                  32858.3
                ],
                "id": 320,
                "chat_link": "[&BEABAAA=]"
              },
              "321": {
                "name": "Wychmire Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  42252.6,
                  32679.8
                ],
                "id": 321,
                "chat_link": "[&BEEBAAA=]"
              },
              "322": {
                "name": "Wardenhurst Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43019,
                  35643
                ],
                "id": 322,
                "chat_link": "[&BEIBAAA=]"
              },
              "844": {
                "name": "Lionguard Waystation Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  42884.3,
                  33154.5
                ],
                "id": 844,
                "chat_link": "[&BEwDAAA=]"
              },
              "1087": {
                "name": "Briarthorn Den",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43922.7,
                  35208.6
                ],
                "id": 1087,
                "chat_link": "[&BD8EAAA=]"
              },
              "1088": {
                "name": "The Weeping Isle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42682.6,
                  34800.5
                ],
                "id": 1088,
                "chat_link": "[&BEAEAAA=]"
              },
              "1089": {
                "name": "Dolorous Vale",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42203.3,
                  35414.8
                ],
                "id": 1089,
                "chat_link": "[&BEEEAAA=]"
              },
              "1093": {
                "name": "Rime's Garden",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42611.3,
                  36132.9
                ],
                "id": 1093,
                "chat_link": "[&BEUEAAA=]"
              },
              "1280": {
                "name": "Danador's Kennel",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43271.1,
                  36029
                ],
                "id": 1280,
                "chat_link": "[&BAAFAAA=]"
              },
              "1281": {
                "name": "Zopatl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43775.1,
                  34802.3
                ],
                "id": 1281,
                "chat_link": "[&BAEFAAA=]"
              },
              "1345": {
                "name": "Twilight Arbor Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  42351.3,
                  32964.6
                ],
                "id": 1345,
                "chat_link": "[&BEEFAAA=]"
              },
              "1460": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  42723.4,
                  34183.7
                ],
                "id": 1460,
                "chat_link": "[&BLQFAAA=]"
              },
              "1461": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43549.6,
                  32974.5
                ],
                "id": 1461,
                "chat_link": "[&BLUFAAA=]"
              },
              "1462": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43413.9,
                  34648.9
                ],
                "id": 1462,
                "chat_link": "[&BLYFAAA=]"
              },
              "1463": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  42313,
                  35695.3
                ],
                "id": 1463,
                "chat_link": "[&BLcFAAA=]"
              },
              "1464": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43439.9,
                  36204.1
                ],
                "id": 1464,
                "chat_link": "[&BLgFAAA=]"
              },
              "1465": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43286.2,
                  33831
                ],
                "id": 1465,
                "chat_link": "[&BLkFAAA=]"
              },
              "1466": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  42726.5,
                  33821.9
                ],
                "id": 1466,
                "chat_link": "[&BLoFAAA=]"
              },
              "1467": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  42572.5,
                  35045.7
                ],
                "id": 1467,
                "chat_link": "[&BLsFAAA=]"
              },
              "1534": {
                "name": "Sleive's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43515.9,
                  35981.1
                ],
                "id": 1534,
                "chat_link": "[&BP4FAAA=]"
              },
              "1736": {
                "name": "Twilight Arbor",
                "type": "unlock",
                "floor": 1,
                "coord": [
                  42331.4,
                  32939.1
                ],
                "id": 1736,
                "chat_link": "[&BMgGAAA=]",
                "icon": "https://render.guildwars2.com/file/943538394A94A491C8632FBEF6203C2013443555/102478.png"
              }
            },
            "tasks": {
              "260": {
                "objective": "Help Warden Brulians clear undead creatures from the area.",
                "level": 5,
                "coord": [
                  43631.5,
                  35765.1
                ],
                "bounds": [
                  [
                    43653.5,
                    35594
                  ],
                  [
                    43757.5,
                    35564.5
                  ],
                  [
                    43931,
                    35546.4
                  ],
                  [
                    44026.1,
                    35574.1
                  ],
                  [
                    44011.4,
                    35807.1
                  ],
                  [
                    43976.6,
                    35940
                  ],
                  [
                    43862.6,
                    35958.1
                  ],
                  [
                    43682.4,
                    35920.7
                  ],
                  [
                    43574.3,
                    35777.5
                  ],
                  [
                    43653.5,
                    35594
                  ]
                ],
                "id": 260,
                "chat_link": "[&BAQBAAA=]"
              },
              "261": {
                "objective": "Assist Valiant Caillech with the Risen.",
                "level": 4,
                "coord": [
                  43488.8,
                  36061.6
                ],
                "bounds": [
                  [
                    43922.8,
                    36173
                  ],
                  [
                    43621.2,
                    36007.7
                  ],
                  [
                    43526.3,
                    35967.4
                  ],
                  [
                    43431.6,
                    36031.3
                  ],
                  [
                    43436.2,
                    36179.3
                  ],
                  [
                    43523.6,
                    36430.4
                  ],
                  [
                    43930.1,
                    36483.5
                  ],
                  [
                    43922.8,
                    36173
                  ]
                ],
                "id": 261,
                "chat_link": "[&BAUBAAA=]"
              },
              "262": {
                "objective": "Help Elain clear the spider cave.",
                "level": 3,
                "coord": [
                  43346.3,
                  35629.9
                ],
                "bounds": [
                  [
                    43251.5,
                    35420.9
                  ],
                  [
                    43264.7,
                    35615.5
                  ],
                  [
                    43283.9,
                    35737.8
                  ],
                  [
                    43396.9,
                    35818.1
                  ],
                  [
                    43488.3,
                    35781.5
                  ],
                  [
                    43432.5,
                    35630
                  ],
                  [
                    43551.2,
                    35588.4
                  ],
                  [
                    43391.4,
                    35424.7
                  ],
                  [
                    43251.5,
                    35420.9
                  ]
                ],
                "id": 262,
                "chat_link": "[&BAYBAAA=]"
              },
              "263": {
                "objective": "Help Danador manage his kennel.",
                "level": 3,
                "coord": [
                  43213.2,
                  36021.3
                ],
                "bounds": [
                  [
                    43099.4,
                    36025.3
                  ],
                  [
                    43110.2,
                    35945.8
                  ],
                  [
                    43165.3,
                    35822.1
                  ],
                  [
                    43308.8,
                    35830.9
                  ],
                  [
                    43408.5,
                    35924.4
                  ],
                  [
                    43423.1,
                    36000.2
                  ],
                  [
                    43401.6,
                    36090.9
                  ],
                  [
                    43347.7,
                    36183.3
                  ],
                  [
                    43211.8,
                    36259.3
                  ],
                  [
                    43098.8,
                    36142.3
                  ],
                  [
                    43099.4,
                    36025.3
                  ]
                ],
                "id": 263,
                "chat_link": "[&BAcBAAA=]"
              },
              "264": {
                "objective": "Help Yoal weaken the krait and recover kidnapped hylek.",
                "level": 11,
                "coord": [
                  43687.8,
                  34009.2
                ],
                "bounds": [
                  [
                    43936.7,
                    33728.4
                  ],
                  [
                    43679.1,
                    33710.3
                  ],
                  [
                    43549.9,
                    33710.5
                  ],
                  [
                    43486.1,
                    33813.7
                  ],
                  [
                    43464.3,
                    33939.6
                  ],
                  [
                    43528.4,
                    34029.9
                  ],
                  [
                    43640.9,
                    34162
                  ],
                  [
                    43929.6,
                    34166.8
                  ],
                  [
                    43936.7,
                    33728.4
                  ]
                ],
                "id": 264,
                "chat_link": "[&BAgBAAA=]"
              },
              "265": {
                "objective": "Help Fisher Leudap support the fishers of Soggorsort.",
                "level": 12,
                "coord": [
                  43861.1,
                  33619.5
                ],
                "bounds": [
                  [
                    43575.9,
                    33693.4
                  ],
                  [
                    43493.5,
                    33589.9
                  ],
                  [
                    43496,
                    33477
                  ],
                  [
                    43556,
                    33371.5
                  ],
                  [
                    43983.3,
                    33393.3
                  ],
                  [
                    43962.1,
                    33723
                  ],
                  [
                    43575.9,
                    33693.4
                  ]
                ],
                "id": 265,
                "chat_link": "[&BAkBAAA=]"
              },
              "266": {
                "objective": "Help the Atzintli and Zopatl tribes battle the krait.",
                "level": 10,
                "coord": [
                  43669.5,
                  34707.3
                ],
                "bounds": [
                  [
                    43838,
                    34733.7
                  ],
                  [
                    43823.6,
                    34787.6
                  ],
                  [
                    43736.5,
                    34882.1
                  ],
                  [
                    43647.1,
                    34872.9
                  ],
                  [
                    43551.4,
                    34800.3
                  ],
                  [
                    43469.6,
                    34601.5
                  ],
                  [
                    43490,
                    34501.9
                  ],
                  [
                    43607.9,
                    34407.7
                  ],
                  [
                    43723.8,
                    34434.4
                  ],
                  [
                    43813.3,
                    34563.5
                  ],
                  [
                    43838,
                    34733.7
                  ]
                ],
                "id": 266,
                "chat_link": "[&BAoBAAA=]"
              },
              "267": {
                "objective": "Assist Lionguard Hester in recovering slaves from Slaver's Deeps.",
                "level": 13,
                "coord": [
                  43680.6,
                  32939.9
                ],
                "bounds": [
                  [
                    43705.3,
                    33129.9
                  ],
                  [
                    43762.2,
                    33159.8
                  ],
                  [
                    43757.6,
                    33231.7
                  ],
                  [
                    43632.8,
                    33287.8
                  ],
                  [
                    43562.2,
                    33361.9
                  ],
                  [
                    43872.9,
                    33383.3
                  ],
                  [
                    43967.6,
                    33346.6
                  ],
                  [
                    43995.9,
                    32907.7
                  ],
                  [
                    43923.5,
                    32696.4
                  ],
                  [
                    43806.6,
                    32688.2
                  ],
                  [
                    43783.6,
                    32695.5
                  ],
                  [
                    43764.4,
                    32756.1
                  ],
                  [
                    43713.2,
                    32781.8
                  ],
                  [
                    43641.4,
                    32826.6
                  ],
                  [
                    43654.4,
                    32864.6
                  ],
                  [
                    43634.4,
                    32941.9
                  ],
                  [
                    43647.6,
                    33070.5
                  ],
                  [
                    43705.3,
                    33129.9
                  ]
                ],
                "id": 267,
                "chat_link": "[&BAsBAAA=]"
              },
              "268": {
                "objective": "Help Harvester Mavad manage the kelp harvest.",
                "level": 7,
                "coord": [
                  42607.4,
                  35408.3
                ],
                "bounds": [
                  [
                    42508.1,
                    35388
                  ],
                  [
                    42519.5,
                    35448.8
                  ],
                  [
                    42574.5,
                    35473.1
                  ],
                  [
                    42632.5,
                    35460.7
                  ],
                  [
                    42690.8,
                    35390.8
                  ],
                  [
                    42812.1,
                    35355
                  ],
                  [
                    43005.6,
                    35274.9
                  ],
                  [
                    43009.4,
                    35160.2
                  ],
                  [
                    42940.8,
                    35041.1
                  ],
                  [
                    42762.4,
                    35056.7
                  ],
                  [
                    42573.9,
                    35244.9
                  ],
                  [
                    42531.3,
                    35295.4
                  ],
                  [
                    42508.1,
                    35388
                  ]
                ],
                "id": 268,
                "chat_link": "[&BAwBAAA=]"
              },
              "269": {
                "objective": "Help the Soundless deal with the Nightmare Court.",
                "level": 8,
                "coord": [
                  42699.2,
                  34815
                ],
                "bounds": [
                  [
                    42466,
                    34884.9
                  ],
                  [
                    42543.1,
                    34986.3
                  ],
                  [
                    42712.2,
                    34998.5
                  ],
                  [
                    43005.5,
                    34813.8
                  ],
                  [
                    42999.5,
                    34710.4
                  ],
                  [
                    42697,
                    34599.5
                  ],
                  [
                    42534.2,
                    34635.6
                  ],
                  [
                    42446.3,
                    34693.1
                  ],
                  [
                    42466,
                    34884.9
                  ]
                ],
                "id": 269,
                "chat_link": "[&BA0BAAA=]"
              },
              "270": {
                "objective": "Help Tovar harass the Nightmare Court.",
                "level": 9,
                "coord": [
                  42579.4,
                  34370.8
                ],
                "bounds": [
                  [
                    42174.5,
                    34518.2
                  ],
                  [
                    42379.1,
                    34516.5
                  ],
                  [
                    42574.9,
                    34476.7
                  ],
                  [
                    42649.2,
                    34375.1
                  ],
                  [
                    42438.7,
                    34061
                  ],
                  [
                    42356.6,
                    33992.5
                  ],
                  [
                    42174.3,
                    34030.1
                  ],
                  [
                    42174.5,
                    34518.2
                  ]
                ],
                "id": 270,
                "chat_link": "[&BA4BAAA=]"
              },
              "271": {
                "objective": "Help Zippti study the hyper-aggressive skritt.",
                "level": 10,
                "coord": [
                  42814.8,
                  34220.1
                ],
                "bounds": [
                  [
                    42654.1,
                    34077.3
                  ],
                  [
                    42760,
                    33974.8
                  ],
                  [
                    42924.8,
                    33884.2
                  ],
                  [
                    43019.8,
                    33872.6
                  ],
                  [
                    43218.4,
                    34085.7
                  ],
                  [
                    43213.7,
                    34314
                  ],
                  [
                    42752.4,
                    34333.6
                  ],
                  [
                    42679.6,
                    34271
                  ],
                  [
                    42654.1,
                    34077.3
                  ]
                ],
                "id": 271,
                "chat_link": "[&BA8BAAA=]"
              },
              "272": {
                "objective": "Help the wardens in Wychmire Swamp.",
                "level": 14,
                "coord": [
                  42508.4,
                  33255.6
                ],
                "bounds": [
                  [
                    42186.3,
                    33138.8
                  ],
                  [
                    42252.1,
                    32891.1
                  ],
                  [
                    42334.4,
                    32805.2
                  ],
                  [
                    42638.9,
                    32927.5
                  ],
                  [
                    42690.2,
                    33158.6
                  ],
                  [
                    42660.8,
                    33318.4
                  ],
                  [
                    42559.5,
                    33432.4
                  ],
                  [
                    42435.4,
                    33526.9
                  ],
                  [
                    42299.9,
                    33467.8
                  ],
                  [
                    42186.3,
                    33138.8
                  ]
                ],
                "id": 272,
                "chat_link": "[&BBABAAA=]"
              },
              "273": {
                "objective": "Help Lionguard Cern safeguard the road.",
                "level": 15,
                "coord": [
                  42733.3,
                  32826.9
                ],
                "bounds": [
                  [
                    42354,
                    32546.8
                  ],
                  [
                    42354.8,
                    32778.2
                  ],
                  [
                    42709.3,
                    32929.7
                  ],
                  [
                    42803,
                    32819.3
                  ],
                  [
                    42658.4,
                    32543.9
                  ],
                  [
                    42354,
                    32546.8
                  ]
                ],
                "id": 273,
                "chat_link": "[&BBEBAAA=]"
              },
              "274": {
                "objective": "Help Gemai support the wardens of Wardenhurst.",
                "level": 2,
                "coord": [
                  42998.5,
                  35631.6
                ],
                "bounds": [
                  [
                    42956.3,
                    35615.4
                  ],
                  [
                    42923.7,
                    35646.6
                  ],
                  [
                    42899.3,
                    35688.4
                  ],
                  [
                    42924.2,
                    35726.7
                  ],
                  [
                    42924.9,
                    35802.3
                  ],
                  [
                    42985.9,
                    35891.1
                  ],
                  [
                    43079.1,
                    35894.4
                  ],
                  [
                    43157.6,
                    35821.3
                  ],
                  [
                    43184.8,
                    35701.4
                  ],
                  [
                    43138.3,
                    35578.7
                  ],
                  [
                    42956.3,
                    35615.4
                  ]
                ],
                "id": 274,
                "chat_link": "[&BBIBAAA=]"
              },
              "275": {
                "objective": "Help defend Caer Astorea from the Nightmare Court.",
                "level": 6,
                "coord": [
                  42631.7,
                  35888
                ],
                "bounds": [
                  [
                    42652.1,
                    35581.4
                  ],
                  [
                    42786.6,
                    35728
                  ],
                  [
                    42747.3,
                    35834.4
                  ],
                  [
                    42723.4,
                    35943
                  ],
                  [
                    42615.8,
                    35964.9
                  ],
                  [
                    42580.2,
                    35906
                  ],
                  [
                    42491.7,
                    35698.7
                  ],
                  [
                    42556.8,
                    35623.5
                  ],
                  [
                    42652.1,
                    35581.4
                  ]
                ],
                "id": 275,
                "chat_link": "[&BBMBAAA=]"
              },
              "276": {
                "objective": "Disrupt the Nightmare Court at Briarthorn Den.",
                "level": 6,
                "coord": [
                  43797.6,
                  35332
                ],
                "bounds": [
                  [
                    43807.4,
                    35227.2
                  ],
                  [
                    43735.9,
                    35394.4
                  ],
                  [
                    43819.6,
                    35430.4
                  ],
                  [
                    43927.5,
                    35427.1
                  ],
                  [
                    44014.4,
                    35418.8
                  ],
                  [
                    44035.3,
                    35307.8
                  ],
                  [
                    44014.5,
                    35011.1
                  ],
                  [
                    43876.1,
                    35047.3
                  ],
                  [
                    43807.4,
                    35227.2
                  ]
                ],
                "id": 276,
                "chat_link": "[&BBQBAAA=]"
              },
              "277": {
                "objective": "Assist Arias in maintaining his garden.",
                "level": 7,
                "coord": [
                  42261,
                  36020.7
                ],
                "bounds": [
                  [
                    42198.6,
                    35967.2
                  ],
                  [
                    42137,
                    36089.5
                  ],
                  [
                    42156.7,
                    36212.7
                  ],
                  [
                    42191.8,
                    36277.4
                  ],
                  [
                    42381.5,
                    36331.7
                  ],
                  [
                    42460.9,
                    36279.8
                  ],
                  [
                    42490.5,
                    36076
                  ],
                  [
                    42198.6,
                    35967.2
                  ]
                ],
                "id": 277,
                "chat_link": "[&BBUBAAA=]"
              },
              "355": {
                "objective": "Help Delilah keep the farmer's fields safe.",
                "level": 2,
                "coord": [
                  42682.1,
                  36129.9
                ],
                "bounds": [
                  [
                    42584.2,
                    36333.9
                  ],
                  [
                    42490.2,
                    36295.7
                  ],
                  [
                    42494.1,
                    36180.4
                  ],
                  [
                    42504.8,
                    36023.5
                  ],
                  [
                    42614.5,
                    35959.1
                  ],
                  [
                    42731.9,
                    36044.3
                  ],
                  [
                    42743,
                    36116.4
                  ],
                  [
                    42734.2,
                    36178.5
                  ],
                  [
                    42709.5,
                    36229.4
                  ],
                  [
                    42700.3,
                    36328.3
                  ],
                  [
                    42584.2,
                    36333.9
                  ]
                ],
                "id": 355,
                "chat_link": "[&BGMBAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  42207.5,
                  35722.1
                ],
                "id": "0-21"
              },
              {
                "coord": [
                  43798.2,
                  32934.1
                ],
                "id": "0-22"
              },
              {
                "coord": [
                  43786.6,
                  35732.3
                ],
                "id": "0-20"
              },
              {
                "coord": [
                  43915.5,
                  34182.6
                ],
                "id": "0-23"
              },
              {
                "coord": [
                  43234.8,
                  34980.9
                ],
                "id": "0-56"
              },
              {
                "coord": [
                  42400.2,
                  32859.7
                ],
                "id": "0-31"
              },
              {
                "coord": [
                  43983.7,
                  35119.5
                ],
                "id": "0-49"
              }
            ],
            "sectors": {
              "93": {
                "name": "Mabon Market",
                "level": 10,
                "coord": [
                  42978.6,
                  34533.9
                ],
                "bounds": [
                  [
                    42787.2,
                    34539.3
                  ],
                  [
                    42886.7,
                    34450.3
                  ],
                  [
                    43073.8,
                    34414.6
                  ],
                  [
                    43178.9,
                    34479.2
                  ],
                  [
                    43076.8,
                    34656
                  ],
                  [
                    42868.2,
                    34664.2
                  ],
                  [
                    42787.2,
                    34539.3
                  ]
                ],
                "id": 93,
                "chat_link": "[&BF0AAAA=]"
              },
              "94": {
                "name": "Quetzal Bay",
                "level": 13,
                "coord": [
                  43648.8,
                  33347.9
                ],
                "bounds": [
                  [
                    43631.4,
                    34077
                  ],
                  [
                    43631.1,
                    34148.5
                  ],
                  [
                    43895.6,
                    34149.3
                  ],
                  [
                    43887.2,
                    33956.6
                  ],
                  [
                    43918.3,
                    33368.2
                  ],
                  [
                    44031.8,
                    32807.3
                  ],
                  [
                    43937.4,
                    32480
                  ],
                  [
                    43811.2,
                    32453.6
                  ],
                  [
                    43611.9,
                    32892.8
                  ],
                  [
                    43518.2,
                    33008.5
                  ],
                  [
                    43444.8,
                    33018.5
                  ],
                  [
                    43398.2,
                    33119.8
                  ],
                  [
                    43497.4,
                    33147.9
                  ],
                  [
                    43536.5,
                    33295.9
                  ],
                  [
                    43234.3,
                    33682.6
                  ],
                  [
                    43395,
                    33959.3
                  ],
                  [
                    43631.4,
                    34077
                  ]
                ],
                "id": 94,
                "chat_link": "[&BF4AAAA=]"
              },
              "95": {
                "name": "Ventry Bay",
                "level": 10,
                "coord": [
                  42938.5,
                  34616.1
                ],
                "bounds": [
                  [
                    42104.4,
                    35018.8
                  ],
                  [
                    42480.4,
                    34896
                  ],
                  [
                    42552.5,
                    34994.3
                  ],
                  [
                    42967.8,
                    35033.9
                  ],
                  [
                    42924.9,
                    34896.8
                  ],
                  [
                    43147.8,
                    34812
                  ],
                  [
                    43460.3,
                    34971
                  ],
                  [
                    43919.5,
                    34726.9
                  ],
                  [
                    43910.2,
                    34235.8
                  ],
                  [
                    43635.6,
                    34211.3
                  ],
                  [
                    43615.6,
                    34226.3
                  ],
                  [
                    43436.5,
                    34221.2
                  ],
                  [
                    43264.7,
                    34312.9
                  ],
                  [
                    43074.8,
                    34649.6
                  ],
                  [
                    42867.4,
                    34664.8
                  ],
                  [
                    42788.3,
                    34541.6
                  ],
                  [
                    42689.8,
                    34547.8
                  ],
                  [
                    42404.3,
                    34374.9
                  ],
                  [
                    42288.6,
                    34440.2
                  ],
                  [
                    42112.6,
                    34425.6
                  ],
                  [
                    42061.9,
                    34736
                  ],
                  [
                    42104.4,
                    35018.8
                  ]
                ],
                "id": 95,
                "chat_link": "[&BF8AAAA=]"
              },
              "96": {
                "name": "Sandycove Beach",
                "level": 8,
                "coord": [
                  42648,
                  35243.4
                ],
                "bounds": [
                  [
                    42775.5,
                    35574.7
                  ],
                  [
                    43078.1,
                    35418.4
                  ],
                  [
                    43103.1,
                    35301.9
                  ],
                  [
                    43090.7,
                    35157.7
                  ],
                  [
                    42994.6,
                    35128.3
                  ],
                  [
                    42967.8,
                    35035.4
                  ],
                  [
                    42552,
                    34991.8
                  ],
                  [
                    42480.3,
                    34895.9
                  ],
                  [
                    42075.2,
                    35025
                  ],
                  [
                    42074.8,
                    35373.5
                  ],
                  [
                    42074.9,
                    35617.2
                  ],
                  [
                    42509,
                    35400.9
                  ],
                  [
                    42775.5,
                    35574.7
                  ]
                ],
                "id": 96,
                "chat_link": "[&BGAAAAA=]"
              },
              "97": {
                "name": "Treemarch Estuary",
                "level": 15,
                "coord": [
                  43290.3,
                  32843.3
                ],
                "bounds": [
                  [
                    43444.1,
                    33017.2
                  ],
                  [
                    43516.3,
                    33011.4
                  ],
                  [
                    43612.4,
                    32893.1
                  ],
                  [
                    43790.9,
                    32498.7
                  ],
                  [
                    43540.6,
                    32492.7
                  ],
                  [
                    43401.6,
                    32805.5
                  ],
                  [
                    43298.4,
                    32901.8
                  ],
                  [
                    43286.5,
                    32985.4
                  ],
                  [
                    43144.4,
                    32967.9
                  ],
                  [
                    43162.8,
                    32796.3
                  ],
                  [
                    43019.4,
                    32488.4
                  ],
                  [
                    42836.5,
                    32485.4
                  ],
                  [
                    42946,
                    32884.8
                  ],
                  [
                    42990.6,
                    33076.4
                  ],
                  [
                    43255.9,
                    33071.1
                  ],
                  [
                    43398.3,
                    33117.3
                  ],
                  [
                    43444.1,
                    33017.2
                  ]
                ],
                "id": 97,
                "chat_link": "[&BGEAAAA=]"
              },
              "98": {
                "name": "Titan's Staircase",
                "level": 11,
                "coord": [
                  43419.6,
                  34074.1
                ],
                "bounds": [
                  [
                    43145.7,
                    33902.3
                  ],
                  [
                    43233.6,
                    33682.1
                  ],
                  [
                    43395.3,
                    33959.1
                  ],
                  [
                    43631.5,
                    34077.1
                  ],
                  [
                    43635.3,
                    34211.4
                  ],
                  [
                    43615.5,
                    34226.1
                  ],
                  [
                    43435.9,
                    34221.7
                  ],
                  [
                    43264,
                    34312.7
                  ],
                  [
                    43145.7,
                    33902.3
                  ]
                ],
                "id": 98,
                "chat_link": "[&BGIAAAA=]"
              },
              "99": {
                "name": "Glencarn Sperrins",
                "level": 10,
                "coord": [
                  43412.7,
                  35130
                ],
                "bounds": [
                  [
                    43088.9,
                    35160.6
                  ],
                  [
                    42994.1,
                    35128.4
                  ],
                  [
                    42925,
                    34896.4
                  ],
                  [
                    43146.7,
                    34812.3
                  ],
                  [
                    43459.7,
                    34971.4
                  ],
                  [
                    43918.7,
                    34714.2
                  ],
                  [
                    43916,
                    35006.2
                  ],
                  [
                    43742.7,
                    35344.4
                  ],
                  [
                    43719,
                    35460.8
                  ],
                  [
                    43549.3,
                    35377.7
                  ],
                  [
                    43386.5,
                    35399.8
                  ],
                  [
                    43105.6,
                    35288.4
                  ],
                  [
                    43088.9,
                    35160.6
                  ]
                ],
                "id": 99,
                "chat_link": "[&BGMAAAA=]"
              },
              "100": {
                "name": "Sleive's Inlet",
                "level": 4,
                "coord": [
                  43707.4,
                  36267.8
                ],
                "bounds": [
                  [
                    43400.7,
                    36499.6
                  ],
                  [
                    43603.5,
                    36545.5
                  ],
                  [
                    43848.7,
                    36536.7
                  ],
                  [
                    43947,
                    36438.7
                  ],
                  [
                    43998.6,
                    36311
                  ],
                  [
                    43960.6,
                    36134.5
                  ],
                  [
                    43614.5,
                    35983.8
                  ],
                  [
                    43546.6,
                    35926.5
                  ],
                  [
                    43446.7,
                    36034
                  ],
                  [
                    43400.7,
                    36499.6
                  ]
                ],
                "id": 100,
                "chat_link": "[&BGQAAAA=]"
              },
              "101": {
                "name": "The Verdence",
                "level": 3,
                "coord": [
                  43034,
                  35956.7
                ],
                "bounds": [
                  [
                    42952.9,
                    36100.3
                  ],
                  [
                    43046.8,
                    36263.8
                  ],
                  [
                    43020.4,
                    36502.3
                  ],
                  [
                    43401.1,
                    36503.7
                  ],
                  [
                    43447.4,
                    36036.6
                  ],
                  [
                    43333.4,
                    36026.9
                  ],
                  [
                    43147.9,
                    35884.5
                  ],
                  [
                    43080.9,
                    35419.8
                  ],
                  [
                    42926.6,
                    35501.3
                  ],
                  [
                    42879,
                    35649.7
                  ],
                  [
                    42814.3,
                    35685.7
                  ],
                  [
                    42724.2,
                    35838.6
                  ],
                  [
                    42733.8,
                    35967.2
                  ],
                  [
                    42967.7,
                    36014
                  ],
                  [
                    42952.9,
                    36100.3
                  ]
                ],
                "id": 101,
                "chat_link": "[&BGUAAAA=]"
              },
              "102": {
                "name": "Village of Astorea",
                "level": 2,
                "coord": [
                  42726.4,
                  36165.8
                ],
                "bounds": [
                  [
                    42733.3,
                    35970.5
                  ],
                  [
                    42729.5,
                    36009.1
                  ],
                  [
                    42777.3,
                    36039.4
                  ],
                  [
                    42766.9,
                    36058.8
                  ],
                  [
                    42613.8,
                    35967.6
                  ],
                  [
                    42537.2,
                    36016.6
                  ],
                  [
                    42514.4,
                    36065.1
                  ],
                  [
                    42503.5,
                    36174.5
                  ],
                  [
                    42531.3,
                    36245.4
                  ],
                  [
                    42499.9,
                    36517.1
                  ],
                  [
                    42705,
                    36551.3
                  ],
                  [
                    43019.2,
                    36497.1
                  ],
                  [
                    43045.4,
                    36261.7
                  ],
                  [
                    42952.3,
                    36098.4
                  ],
                  [
                    42967,
                    36014.4
                  ],
                  [
                    42733.3,
                    35970.5
                  ]
                ],
                "id": 102,
                "chat_link": "[&BGYAAAA=]"
              },
              "103": {
                "name": "Willowalk Groves",
                "level": 14,
                "coord": [
                  43125.2,
                  33323.4
                ],
                "bounds": [
                  [
                    42728.4,
                    33266.2
                  ],
                  [
                    42991.1,
                    33076.1
                  ],
                  [
                    43256.6,
                    33070.7
                  ],
                  [
                    43497,
                    33147.6
                  ],
                  [
                    43536.6,
                    33296
                  ],
                  [
                    43233.9,
                    33682.2
                  ],
                  [
                    43018.5,
                    33537.5
                  ],
                  [
                    42739.3,
                    33511.3
                  ],
                  [
                    42728.4,
                    33266.2
                  ]
                ],
                "id": 103,
                "chat_link": "[&BGcAAAA=]"
              },
              "104": {
                "name": "Grenbrack Delves",
                "level": 4,
                "coord": [
                  43354.3,
                  35650.6
                ],
                "bounds": [
                  [
                    43333.8,
                    36026.2
                  ],
                  [
                    43447.4,
                    36034.3
                  ],
                  [
                    43545.9,
                    35927
                  ],
                  [
                    43522.9,
                    35772.8
                  ],
                  [
                    43498.4,
                    35589.1
                  ],
                  [
                    43421.5,
                    35585.6
                  ],
                  [
                    43384.1,
                    35453.6
                  ],
                  [
                    43390,
                    35403.3
                  ],
                  [
                    43374.7,
                    35404.7
                  ],
                  [
                    43106,
                    35302.1
                  ],
                  [
                    43080.9,
                    35423
                  ],
                  [
                    43145.9,
                    35885.3
                  ],
                  [
                    43333.8,
                    36026.2
                  ]
                ],
                "id": 104,
                "chat_link": "[&BGgAAAA=]"
              },
              "105": {
                "name": "Trader's Green",
                "level": 12,
                "coord": [
                  42589.1,
                  33922.8
                ],
                "bounds": [
                  [
                    42281.7,
                    34451.8
                  ],
                  [
                    42074.4,
                    34419.6
                  ],
                  [
                    42079.1,
                    33979.1
                  ],
                  [
                    42306.2,
                    33851.2
                  ],
                  [
                    42449.8,
                    33720.2
                  ],
                  [
                    42550.4,
                    33535.3
                  ],
                  [
                    42739.2,
                    33513.4
                  ],
                  [
                    43019.6,
                    33537.1
                  ],
                  [
                    43234.5,
                    33681.5
                  ],
                  [
                    43147.7,
                    33905.3
                  ],
                  [
                    42762,
                    33949.4
                  ],
                  [
                    42609.1,
                    34079.5
                  ],
                  [
                    42404.7,
                    34373.1
                  ],
                  [
                    42281.7,
                    34451.8
                  ]
                ],
                "id": 105,
                "chat_link": "[&BGkAAAA=]"
              },
              "106": {
                "name": "The Rootangles",
                "level": 11,
                "coord": [
                  42898.1,
                  34310.3
                ],
                "bounds": [
                  [
                    42788.3,
                    34539.6
                  ],
                  [
                    42885.8,
                    34450.5
                  ],
                  [
                    43073,
                    34414.1
                  ],
                  [
                    43174.2,
                    34482.5
                  ],
                  [
                    43264.9,
                    34312.7
                  ],
                  [
                    43145.7,
                    33902.8
                  ],
                  [
                    43017.3,
                    33916.6
                  ],
                  [
                    43012.8,
                    34232.2
                  ],
                  [
                    42820.7,
                    34330.3
                  ],
                  [
                    42508.8,
                    34220.7
                  ],
                  [
                    42399.2,
                    34374
                  ],
                  [
                    42687.2,
                    34548.3
                  ],
                  [
                    42788.3,
                    34539.6
                  ]
                ],
                "id": 106,
                "chat_link": "[&BGoAAAA=]"
              },
              "107": {
                "name": "Morgan's Spiral",
                "level": 6,
                "coord": [
                  43843.3,
                  35603.7
                ],
                "bounds": [
                  [
                    43522.3,
                    35772.5
                  ],
                  [
                    43499.2,
                    35583.8
                  ],
                  [
                    43657.1,
                    35592.8
                  ],
                  [
                    43695.8,
                    35578
                  ],
                  [
                    43744.9,
                    35347.5
                  ],
                  [
                    43915.9,
                    34997.7
                  ],
                  [
                    44008.3,
                    35077.1
                  ],
                  [
                    44024,
                    35220.7
                  ],
                  [
                    44207.6,
                    35407
                  ],
                  [
                    44245.3,
                    35733.8
                  ],
                  [
                    44165.7,
                    36094
                  ],
                  [
                    43958.6,
                    36135.6
                  ],
                  [
                    43614.5,
                    35984.3
                  ],
                  [
                    43546.8,
                    35926.7
                  ],
                  [
                    43522.3,
                    35772.5
                  ]
                ],
                "id": 107,
                "chat_link": "[&BGsAAAA=]"
              },
              "108": {
                "name": "Wychmire Swamp",
                "level": 15,
                "coord": [
                  42487.1,
                  33167.9
                ],
                "bounds": [
                  [
                    42450.9,
                    33720.9
                  ],
                  [
                    42550.5,
                    33536.5
                  ],
                  [
                    42738.8,
                    33514.5
                  ],
                  [
                    42729.4,
                    33268.3
                  ],
                  [
                    42992.3,
                    33078
                  ],
                  [
                    42946.5,
                    32884.5
                  ],
                  [
                    42840.3,
                    32467.1
                  ],
                  [
                    42450.9,
                    32505.2
                  ],
                  [
                    42137.2,
                    32466.3
                  ],
                  [
                    42070.4,
                    32543.1
                  ],
                  [
                    42041.9,
                    33363.7
                  ],
                  [
                    42076.1,
                    33983.6
                  ],
                  [
                    42307.4,
                    33851.4
                  ],
                  [
                    42450.9,
                    33720.9
                  ]
                ],
                "id": 108,
                "chat_link": "[&BGwAAAA=]"
              },
              "109": {
                "name": "Ruins of the Unseen",
                "level": 11,
                "coord": [
                  42787.5,
                  34121
                ],
                "bounds": [
                  [
                    42820.5,
                    34331.3
                  ],
                  [
                    42508.3,
                    34220.4
                  ],
                  [
                    42609.4,
                    34077.5
                  ],
                  [
                    42759.1,
                    33948.5
                  ],
                  [
                    43014.8,
                    33915.7
                  ],
                  [
                    43013,
                    34232.7
                  ],
                  [
                    42820.5,
                    34331.3
                  ]
                ],
                "id": 109,
                "chat_link": "[&BG0AAAA=]"
              },
              "110": {
                "name": "Dominion of Winds",
                "level": 11,
                "coord": [
                  43897.7,
                  33935
                ],
                "bounds": [
                  [
                    43910.4,
                    34235.2
                  ],
                  [
                    43914.8,
                    34922.7
                  ],
                  [
                    43953.1,
                    34879.5
                  ],
                  [
                    43956.1,
                    34078
                  ],
                  [
                    43956.2,
                    33854.2
                  ],
                  [
                    43960.2,
                    33688.7
                  ],
                  [
                    43992.3,
                    33302.3
                  ],
                  [
                    43990.5,
                    33175.4
                  ],
                  [
                    43967.7,
                    33119.6
                  ],
                  [
                    43918.3,
                    33368.4
                  ],
                  [
                    43886.8,
                    33956.8
                  ],
                  [
                    43895.2,
                    34149
                  ],
                  [
                    43631.9,
                    34148.6
                  ],
                  [
                    43635,
                    34211.2
                  ],
                  [
                    43910.4,
                    34235.2
                  ]
                ],
                "id": 110,
                "chat_link": "[&BG4AAAA=]"
              },
              "111": {
                "name": "Ogham Wilds",
                "level": 7,
                "coord": [
                  42559.4,
                  36066.3
                ],
                "bounds": [
                  [
                    42507.5,
                    35402.7
                  ],
                  [
                    42772.1,
                    35575.4
                  ],
                  [
                    42772.2,
                    35576.1
                  ],
                  [
                    42925,
                    35499.9
                  ],
                  [
                    42876.5,
                    35647.1
                  ],
                  [
                    42811.6,
                    35685.8
                  ],
                  [
                    42719.4,
                    35840.1
                  ],
                  [
                    42732.1,
                    35969.4
                  ],
                  [
                    42727.8,
                    36011.7
                  ],
                  [
                    42774.2,
                    36040.1
                  ],
                  [
                    42761.9,
                    36057.3
                  ],
                  [
                    42609.8,
                    35979
                  ],
                  [
                    42540.8,
                    36024.6
                  ],
                  [
                    42518,
                    36073.1
                  ],
                  [
                    42506.5,
                    36178.1
                  ],
                  [
                    42534.6,
                    36251.2
                  ],
                  [
                    42477.3,
                    36740.6
                  ],
                  [
                    42451.9,
                    36782.7
                  ],
                  [
                    42381.7,
                    36793
                  ],
                  [
                    42150.4,
                    36742.1
                  ],
                  [
                    42146,
                    36573.3
                  ],
                  [
                    42094,
                    36464.9
                  ],
                  [
                    42074.1,
                    35617.5
                  ],
                  [
                    42507.5,
                    35402.7
                  ]
                ],
                "id": 111,
                "chat_link": "[&BG8AAAA=]"
              },
              "112": {
                "name": "The Rowanwoods",
                "level": 15,
                "coord": [
                  43278.8,
                  32703.7
                ],
                "bounds": [
                  [
                    43287.3,
                    32984.9
                  ],
                  [
                    43298.6,
                    32902.3
                  ],
                  [
                    43401.5,
                    32805.5
                  ],
                  [
                    43537,
                    32491.9
                  ],
                  [
                    43486.6,
                    32460.3
                  ],
                  [
                    43174.8,
                    32438.1
                  ],
                  [
                    43016.3,
                    32486.2
                  ],
                  [
                    43162.5,
                    32796.5
                  ],
                  [
                    43144.3,
                    32967.8
                  ],
                  [
                    43287.3,
                    32984.9
                  ]
                ],
                "id": 112,
                "chat_link": "[&BHAAAAA=]"
              },
              "1024": {
                "name": "Dreamdark Enclave",
                "level": 7,
                "coord": [
                  43546.5,
                  35493.8
                ],
                "bounds": [
                  [
                    43423.2,
                    35584.6
                  ],
                  [
                    43389,
                    35454
                  ],
                  [
                    43393.1,
                    35403.7
                  ],
                  [
                    43547.9,
                    35378.8
                  ],
                  [
                    43718,
                    35468.2
                  ],
                  [
                    43697.4,
                    35575.3
                  ],
                  [
                    43656.8,
                    35592
                  ],
                  [
                    43423.2,
                    35584.6
                  ]
                ],
                "id": 1024,
                "chat_link": "[&BAAEAAA=]"
              }
            },
            "adventures": [],
            "id": 34,
            "mastery_points": []
          },
          "35": {
            "name": "Metrica Province",
            "min_level": 1,
            "max_level": 15,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {
              "51": {
                "name": "Incinergen Labs",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40659.6,
                  36593.6
                ],
                "id": 51,
                "chat_link": "[&BDMAAAA=]"
              },
              "52": {
                "name": "Battleground Plaza",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40583.5,
                  36342.7
                ],
                "id": 52,
                "chat_link": "[&BDQAAAA=]"
              },
              "53": {
                "name": "The Opticalium",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41068.5,
                  36685.1
                ],
                "id": 53,
                "chat_link": "[&BDUAAAA=]"
              },
              "54": {
                "name": "Durotl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41131.2,
                  36208.9
                ],
                "id": 54,
                "chat_link": "[&BDYAAAA=]"
              },
              "55": {
                "name": "Aquannian Research Group",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41356.3,
                  36474.3
                ],
                "id": 55,
                "chat_link": "[&BDcAAAA=]"
              },
              "56": {
                "name": "Dr. Bleent's Encampment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41438.7,
                  35612.2
                ],
                "id": 56,
                "chat_link": "[&BDgAAAA=]"
              },
              "57": {
                "name": "Old Oola Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42045.6,
                  35525.3
                ],
                "id": 57,
                "chat_link": "[&BDkAAAA=]"
              },
              "58": {
                "name": "Parnna's Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41974,
                  36140.2
                ],
                "id": 58,
                "chat_link": "[&BDoAAAA=]"
              },
              "59": {
                "name": "Conduit Tower Blig",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41373.6,
                  34433.3
                ],
                "id": 59,
                "chat_link": "[&BDsAAAA=]"
              },
              "60": {
                "name": "Conduit Tower Nopp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41101.2,
                  34155.8
                ],
                "id": 60,
                "chat_link": "[&BDwAAAA=]"
              },
              "61": {
                "name": "Inner Inquest Complex",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41888.4,
                  33654.6
                ],
                "id": 61,
                "chat_link": "[&BD0AAAA=]"
              },
              "62": {
                "name": "Transfer Gate (Private)",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40134.4,
                  34309.9
                ],
                "id": 62,
                "chat_link": "[&BD4AAAA=]"
              },
              "63": {
                "name": "Conduit Tower Scoln",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40836.1,
                  33969.7
                ],
                "id": 63,
                "chat_link": "[&BD8AAAA=]"
              },
              "64": {
                "name": "Soren Draa Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  40171.7,
                  36402.5
                ],
                "id": 64,
                "chat_link": "[&BEAAAAA=]"
              },
              "65": {
                "name": "Jeztar Falls Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  41201.9,
                  36636.2
                ],
                "id": 65,
                "chat_link": "[&BEEAAAA=]"
              },
              "66": {
                "name": "Akk Wilds Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  41739.1,
                  36013.3
                ],
                "id": 66,
                "chat_link": "[&BEIAAAA=]"
              },
              "67": {
                "name": "Rana Landing Complex Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  40758.4,
                  35412.8
                ],
                "id": 67,
                "chat_link": "[&BEMAAAA=]"
              },
              "68": {
                "name": "Arterium Haven Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  41281.5,
                  34770.2
                ],
                "id": 68,
                "chat_link": "[&BEQAAAA=]"
              },
              "69": {
                "name": "Hexane Regrade Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  41822.1,
                  34087.5
                ],
                "id": 69,
                "chat_link": "[&BEUAAAA=]"
              },
              "70": {
                "name": "Survivor's Encampment Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  40577.9,
                  34465.8
                ],
                "id": 70,
                "chat_link": "[&BEYAAAA=]"
              },
              "71": {
                "name": "Muridian Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  40840.7,
                  33722.1
                ],
                "id": 71,
                "chat_link": "[&BEcAAAA=]"
              },
              "72": {
                "name": "Desider Atum Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  41307.6,
                  35437.2
                ],
                "id": 72,
                "chat_link": "[&BEgAAAA=]"
              },
              "141": {
                "name": "C.L.E.A.N. Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40740.8,
                  34066.9
                ],
                "id": 141,
                "chat_link": "[&BI0AAAA=]"
              },
              "551": {
                "name": "PR&T Esoterics",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41645.1,
                  36378.2
                ],
                "id": 551,
                "chat_link": "[&BCcCAAA=]"
              },
              "552": {
                "name": "Incomp Optics",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41358.3,
                  36694.4
                ],
                "id": 552,
                "chat_link": "[&BCgCAAA=]"
              },
              "553": {
                "name": "Brill Alliance Labs",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40869.1,
                  35412.8
                ],
                "id": 553,
                "chat_link": "[&BCkCAAA=]"
              },
              "1076": {
                "name": "Splorg Metamystics Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40856.9,
                  36440.9
                ],
                "id": 1076,
                "chat_link": "[&BDQEAAA=]"
              },
              "1134": {
                "name": "Transformer Hub Kachong",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41318.7,
                  34228.5
                ],
                "id": 1134,
                "chat_link": "[&BG4EAAA=]"
              },
              "1191": {
                "name": "Biocauldron Alchemics",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40965.4,
                  35220.5
                ],
                "id": 1191,
                "chat_link": "[&BKcEAAA=]"
              },
              "1198": {
                "name": "Old Golem Factory Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  40388.2,
                  35749.2
                ],
                "id": 1198,
                "chat_link": "[&BK4EAAA=]"
              },
              "1199": {
                "name": "Loch Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  41036.1,
                  36064.3
                ],
                "id": 1199,
                "chat_link": "[&BK8EAAA=]"
              },
              "1200": {
                "name": "Anthill Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  40094.7,
                  34617.4
                ],
                "id": 1200,
                "chat_link": "[&BLAEAAA=]"
              },
              "1201": {
                "name": "Michotl Grounds Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  40694.4,
                  35000.4
                ],
                "id": 1201,
                "chat_link": "[&BLEEAAA=]"
              },
              "1202": {
                "name": "Cuatl Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  41907.1,
                  35125.7
                ],
                "id": 1202,
                "chat_link": "[&BLIEAAA=]"
              },
              "1203": {
                "name": "Artergon Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  41015.8,
                  34337.7
                ],
                "id": 1203,
                "chat_link": "[&BLMEAAA=]"
              },
              "1271": {
                "name": "Hydrone Unit Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  40631.8,
                  36216.7
                ],
                "id": 1271,
                "chat_link": "[&BPcEAAA=]"
              },
              "1289": {
                "name": "Terranexic Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40217.8,
                  36288.7
                ],
                "id": 1289,
                "chat_link": "[&BAkFAAA=]"
              },
              "1290": {
                "name": "Aeronotics Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40911.4,
                  36728.2
                ],
                "id": 1290,
                "chat_link": "[&BAoFAAA=]"
              },
              "1405": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  41453.4,
                  35248.2
                ],
                "id": 1405,
                "chat_link": "[&BH0FAAA=]"
              },
              "1406": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  40282.6,
                  36642.7
                ],
                "id": 1406,
                "chat_link": "[&BH4FAAA=]"
              },
              "1407": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  41124.2,
                  34781.7
                ],
                "id": 1407,
                "chat_link": "[&BH8FAAA=]"
              },
              "1408": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  40810.2,
                  36484.6
                ],
                "id": 1408,
                "chat_link": "[&BIAFAAA=]"
              },
              "1409": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  40624.9,
                  36550.1
                ],
                "id": 1409,
                "chat_link": "[&BIEFAAA=]"
              },
              "1410": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  40802,
                  35459.7
                ],
                "id": 1410,
                "chat_link": "[&BIIFAAA=]"
              },
              "1411": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  40744.3,
                  34113
                ],
                "id": 1411,
                "chat_link": "[&BIMFAAA=]"
              },
              "1412": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  41531.1,
                  33791
                ],
                "id": 1412,
                "chat_link": "[&BIQFAAA=]"
              },
              "1413": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  41739,
                  36111.8
                ],
                "id": 1413,
                "chat_link": "[&BIUFAAA=]"
              },
              "1535": {
                "name": "Old Flamen Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41147.5,
                  34999.1
                ],
                "id": 1535,
                "chat_link": "[&BP8FAAA=]"
              }
            },
            "tasks": {
              "319": {
                "objective": "Support Doola's golemancing research.",
                "level": 2,
                "coord": [
                  40428.5,
                  36473.3
                ],
                "bounds": [
                  [
                    40763.9,
                    36236.1
                  ],
                  [
                    40708.1,
                    36148.7
                  ],
                  [
                    40668.9,
                    36100.5
                  ],
                  [
                    40532.8,
                    36090.9
                  ],
                  [
                    40498.6,
                    36236.4
                  ],
                  [
                    40422.9,
                    36267.7
                  ],
                  [
                    40351.4,
                    36270.1
                  ],
                  [
                    40353,
                    36370.6
                  ],
                  [
                    40331.1,
                    36367.7
                  ],
                  [
                    40330.4,
                    36411.2
                  ],
                  [
                    40351,
                    36410.5
                  ],
                  [
                    40339.5,
                    36546.2
                  ],
                  [
                    40437.4,
                    36537.5
                  ],
                  [
                    40499,
                    36669.6
                  ],
                  [
                    40616.8,
                    36739.4
                  ],
                  [
                    40743.5,
                    36654.2
                  ],
                  [
                    40746.7,
                    36544.1
                  ],
                  [
                    40724,
                    36496.4
                  ],
                  [
                    40724.9,
                    36461.1
                  ],
                  [
                    40716.5,
                    36420
                  ],
                  [
                    40728.2,
                    36391.3
                  ],
                  [
                    40777.5,
                    36312.6
                  ],
                  [
                    40763.9,
                    36236.1
                  ]
                ],
                "id": 319,
                "chat_link": "[&BD8BAAA=]"
              },
              "320": {
                "objective": "Assist the Opticalium with lightning research.",
                "level": 3,
                "coord": [
                  40969,
                  36620.6
                ],
                "bounds": [
                  [
                    41184.5,
                    36820.3
                  ],
                  [
                    41196.5,
                    36669.5
                  ],
                  [
                    41180.2,
                    36600.3
                  ],
                  [
                    41166.3,
                    36542.2
                  ],
                  [
                    41050.5,
                    36536.7
                  ],
                  [
                    40974.6,
                    36557.6
                  ],
                  [
                    40963.4,
                    36582.1
                  ],
                  [
                    40939.8,
                    36593.9
                  ],
                  [
                    40938.9,
                    36616.1
                  ],
                  [
                    40956.2,
                    36625.3
                  ],
                  [
                    40958.6,
                    36637.8
                  ],
                  [
                    40944.8,
                    36812.8
                  ],
                  [
                    41184.5,
                    36820.3
                  ]
                ],
                "id": 320,
                "chat_link": "[&BEABAAA=]"
              },
              "321": {
                "objective": "Help Blopp stop the Inquest from using hylek poison to drive lake creatures crazy.",
                "level": 5,
                "coord": [
                  41225.1,
                  36275.2
                ],
                "bounds": [
                  [
                    41176.3,
                    36129.9
                  ],
                  [
                    41259.5,
                    36153.2
                  ],
                  [
                    41305.6,
                    36209
                  ],
                  [
                    41323.7,
                    36301
                  ],
                  [
                    41276.6,
                    36384.1
                  ],
                  [
                    41208,
                    36413.7
                  ],
                  [
                    41127,
                    36397.8
                  ],
                  [
                    41045,
                    36358.9
                  ],
                  [
                    40994.5,
                    36243.8
                  ],
                  [
                    40984,
                    36177.8
                  ],
                  [
                    40996.1,
                    36123
                  ],
                  [
                    41040.3,
                    36105.3
                  ],
                  [
                    41176.3,
                    36129.9
                  ]
                ],
                "id": 321,
                "chat_link": "[&BEEBAAA=]"
              },
              "322": {
                "objective": "Assist PR&T Esoterics with ooze research.",
                "level": 4,
                "coord": [
                  41638.1,
                  36406.5
                ],
                "bounds": [
                  [
                    41320.1,
                    36196.9
                  ],
                  [
                    41330.5,
                    36247.3
                  ],
                  [
                    41342.6,
                    36306.7
                  ],
                  [
                    41398.6,
                    36344.5
                  ],
                  [
                    41441.4,
                    36386.6
                  ],
                  [
                    41572.4,
                    36533.1
                  ],
                  [
                    41700.3,
                    36525.3
                  ],
                  [
                    41740.5,
                    36371.8
                  ],
                  [
                    41545.1,
                    36242.5
                  ],
                  [
                    41466.9,
                    36185.3
                  ],
                  [
                    41409.5,
                    36166.5
                  ],
                  [
                    41320.1,
                    36196.9
                  ]
                ],
                "id": 322,
                "chat_link": "[&BEIBAAA=]"
              },
              "323": {
                "objective": "Help Shoon's salvage krewe deal with Inquest interference.",
                "level": 6,
                "coord": [
                  40313.5,
                  36000.6
                ],
                "bounds": [
                  [
                    40286,
                    36112.3
                  ],
                  [
                    39957.3,
                    36084.8
                  ],
                  [
                    39954.7,
                    35626.4
                  ],
                  [
                    40267.5,
                    35612
                  ],
                  [
                    40296,
                    35632.1
                  ],
                  [
                    40389.8,
                    35640.5
                  ],
                  [
                    40454.1,
                    35687.2
                  ],
                  [
                    40473.8,
                    35724.1
                  ],
                  [
                    40494.3,
                    35824.9
                  ],
                  [
                    40457,
                    36002.7
                  ],
                  [
                    40425.6,
                    36065.3
                  ],
                  [
                    40286,
                    36112.3
                  ]
                ],
                "id": 323,
                "chat_link": "[&BEMBAAA=]"
              },
              "324": {
                "objective": "Help Brill Alliance study the skritt.",
                "level": 7,
                "coord": [
                  40787.3,
                  35552.4
                ],
                "bounds": [
                  [
                    40768,
                    35337
                  ],
                  [
                    40985.7,
                    35324.8
                  ],
                  [
                    41119.2,
                    35308
                  ],
                  [
                    41188.9,
                    35381.3
                  ],
                  [
                    41196.9,
                    35547.1
                  ],
                  [
                    41350,
                    35681.2
                  ],
                  [
                    41448.9,
                    35911.3
                  ],
                  [
                    41402.9,
                    36072.2
                  ],
                  [
                    41206.4,
                    36027.1
                  ],
                  [
                    41130.6,
                    35892.2
                  ],
                  [
                    41066.5,
                    35754.7
                  ],
                  [
                    40930.3,
                    35718.8
                  ],
                  [
                    40827.7,
                    35740.1
                  ],
                  [
                    40756.3,
                    35765.8
                  ],
                  [
                    40677.7,
                    35579.6
                  ],
                  [
                    40705.4,
                    35422.1
                  ],
                  [
                    40768,
                    35337
                  ]
                ],
                "id": 324,
                "chat_link": "[&BEQBAAA=]"
              },
              "325": {
                "objective": "Help Hrouda maintain the ecosystem in spite of Dr. Bleent's research.",
                "level": 8,
                "coord": [
                  41469.4,
                  35671
                ],
                "bounds": [
                  [
                    41470.4,
                    35452.9
                  ],
                  [
                    41528,
                    35483.8
                  ],
                  [
                    41590.1,
                    35536.5
                  ],
                  [
                    41640.5,
                    35584.8
                  ],
                  [
                    41683.2,
                    35700.7
                  ],
                  [
                    41707.3,
                    35814.6
                  ],
                  [
                    41566.5,
                    35924.3
                  ],
                  [
                    41456,
                    35797.5
                  ],
                  [
                    41385.7,
                    35705.1
                  ],
                  [
                    41342.4,
                    35661.1
                  ],
                  [
                    41316.5,
                    35633
                  ],
                  [
                    41277.5,
                    35580.5
                  ],
                  [
                    41216.2,
                    35547.4
                  ],
                  [
                    41232.8,
                    35493.3
                  ],
                  [
                    41381.6,
                    35463.5
                  ],
                  [
                    41470.4,
                    35452.9
                  ]
                ],
                "id": 325,
                "chat_link": "[&BEUBAAA=]"
              },
              "326": {
                "objective": "Assist Parnna's research into the ancient transfer chamber.",
                "level": 9,
                "coord": [
                  41794.5,
                  36108.1
                ],
                "bounds": [
                  [
                    42047,
                    36145.2
                  ],
                  [
                    42030.7,
                    36303
                  ],
                  [
                    41997,
                    36406.5
                  ],
                  [
                    42023.6,
                    36667.2
                  ],
                  [
                    41800.2,
                    36656.8
                  ],
                  [
                    41805.7,
                    36348.8
                  ],
                  [
                    41666.7,
                    36278.1
                  ],
                  [
                    41614.5,
                    36121.7
                  ],
                  [
                    41615.5,
                    36050
                  ],
                  [
                    41659,
                    35968
                  ],
                  [
                    41732.6,
                    35866.9
                  ],
                  [
                    41883.8,
                    35847.4
                  ],
                  [
                    42031.3,
                    35959.9
                  ],
                  [
                    42053.4,
                    36091.3
                  ],
                  [
                    42047,
                    36145.2
                  ]
                ],
                "id": 326,
                "chat_link": "[&BEYBAAA=]"
              },
              "327": {
                "objective": "Help the Lionguard keep the Cuatl hylek in check.",
                "level": 10,
                "coord": [
                  41830.1,
                  35099.8
                ],
                "bounds": [
                  [
                    41739.1,
                    35200.2
                  ],
                  [
                    41880.2,
                    35104.8
                  ],
                  [
                    41829.1,
                    34946
                  ],
                  [
                    41755.8,
                    34831.8
                  ],
                  [
                    41604,
                    34751.7
                  ],
                  [
                    41499.6,
                    34741.6
                  ],
                  [
                    41447.9,
                    34781.3
                  ],
                  [
                    41373.9,
                    34790.3
                  ],
                  [
                    41340.4,
                    34852
                  ],
                  [
                    41346.6,
                    35036.6
                  ],
                  [
                    41400.1,
                    35191.8
                  ],
                  [
                    41671.5,
                    35224
                  ],
                  [
                    41739.1,
                    35200.2
                  ]
                ],
                "id": 327,
                "chat_link": "[&BEcBAAA=]"
              },
              "328": {
                "objective": "Help the Michotl tribe.",
                "level": 11,
                "coord": [
                  41063.7,
                  35136.4
                ],
                "bounds": [
                  [
                    41234.4,
                    35081.5
                  ],
                  [
                    41238.7,
                    35184
                  ],
                  [
                    41033.5,
                    35238.4
                  ],
                  [
                    40858.9,
                    35288
                  ],
                  [
                    40631.5,
                    35254.1
                  ],
                  [
                    40412.8,
                    35179.5
                  ],
                  [
                    40377.2,
                    34835.3
                  ],
                  [
                    40535.4,
                    34780.8
                  ],
                  [
                    40822.5,
                    34804.4
                  ],
                  [
                    40994.6,
                    34833.7
                  ],
                  [
                    41266.1,
                    35076.2
                  ],
                  [
                    41234.4,
                    35081.5
                  ]
                ],
                "id": 328,
                "chat_link": "[&BEgBAAA=]"
              },
              "329": {
                "objective": "Help the Luminates plant krewe maintain the power grid.",
                "level": 13,
                "coord": [
                  41056.8,
                  34336.8
                ],
                "bounds": [
                  [
                    41430.2,
                    34529.7
                  ],
                  [
                    41341.1,
                    34528.9
                  ],
                  [
                    41120.2,
                    34545.9
                  ],
                  [
                    40954.3,
                    34366
                  ],
                  [
                    40862.5,
                    34177.3
                  ],
                  [
                    40726.8,
                    34031.4
                  ],
                  [
                    40723.8,
                    33970.6
                  ],
                  [
                    40763.6,
                    33885.4
                  ],
                  [
                    40836.8,
                    33851.9
                  ],
                  [
                    40951.9,
                    33888.2
                  ],
                  [
                    41142.9,
                    34086.1
                  ],
                  [
                    41223.1,
                    34096.7
                  ],
                  [
                    41361.9,
                    34274.4
                  ],
                  [
                    41472.8,
                    34373.6
                  ],
                  [
                    41485.8,
                    34433.5
                  ],
                  [
                    41430.2,
                    34529.7
                  ]
                ],
                "id": 329,
                "chat_link": "[&BEkBAAA=]"
              },
              "330": {
                "objective": "Help Peacemaker Owta disrupt the Inquest complex.",
                "level": 14,
                "coord": [
                  41645.1,
                  34131.6
                ],
                "bounds": [
                  [
                    41753.7,
                    33944.4
                  ],
                  [
                    41680.2,
                    34055.4
                  ],
                  [
                    41713,
                    34129.3
                  ],
                  [
                    41642.1,
                    34168
                  ],
                  [
                    41592.7,
                    34142
                  ],
                  [
                    41522.3,
                    34004.9
                  ],
                  [
                    41506,
                    33973.2
                  ],
                  [
                    41523,
                    33845.8
                  ],
                  [
                    41576.8,
                    33777.5
                  ],
                  [
                    41560,
                    33499.3
                  ],
                  [
                    42054,
                    33513.7
                  ],
                  [
                    42085.2,
                    33726.8
                  ],
                  [
                    41998.1,
                    33818.2
                  ],
                  [
                    41753.7,
                    33944.4
                  ]
                ],
                "id": 330,
                "chat_link": "[&BEoBAAA=]"
              },
              "331": {
                "objective": "Assist the Chaos krewe.",
                "level": 12,
                "coord": [
                  40496.8,
                  34562.7
                ],
                "bounds": [
                  [
                    40611.3,
                    34710.2
                  ],
                  [
                    40434.4,
                    34789.4
                  ],
                  [
                    40290.2,
                    34797.4
                  ],
                  [
                    40126.1,
                    34837.8
                  ],
                  [
                    40036.3,
                    34836.1
                  ],
                  [
                    39984.6,
                    34719.7
                  ],
                  [
                    39942,
                    34647.8
                  ],
                  [
                    39929.4,
                    34527.9
                  ],
                  [
                    40192.2,
                    34453.8
                  ],
                  [
                    40327.4,
                    34396.3
                  ],
                  [
                    40446.3,
                    34430.9
                  ],
                  [
                    40629.9,
                    34469.8
                  ],
                  [
                    40661.7,
                    34600.1
                  ],
                  [
                    40611.3,
                    34710.2
                  ]
                ],
                "id": 331,
                "chat_link": "[&BEsBAAA=]"
              },
              "332": {
                "objective": "Help the C.L.E.A.N. krewe.",
                "level": 15,
                "coord": [
                  40478.5,
                  34055.6
                ],
                "bounds": [
                  [
                    40649.3,
                    33979.5
                  ],
                  [
                    40597,
                    33872.4
                  ],
                  [
                    40482.1,
                    33765
                  ],
                  [
                    40375.9,
                    33679.9
                  ],
                  [
                    40235.8,
                    33680.5
                  ],
                  [
                    40152.1,
                    33882.5
                  ],
                  [
                    40150.9,
                    34034.8
                  ],
                  [
                    40176.4,
                    34176
                  ],
                  [
                    40348.2,
                    34245.7
                  ],
                  [
                    40583.2,
                    34193.6
                  ],
                  [
                    40626.6,
                    34040.9
                  ],
                  [
                    40649.3,
                    33979.5
                  ]
                ],
                "id": 332,
                "chat_link": "[&BEwBAAA=]"
              },
              "333": {
                "objective": "Assist Professor Gahf in teaching his young progeny.",
                "level": 2,
                "coord": [
                  40809.4,
                  36503.9
                ],
                "bounds": [
                  [
                    40882.8,
                    36342.8
                  ],
                  [
                    40952.1,
                    36411.6
                  ],
                  [
                    40999,
                    36442.4
                  ],
                  [
                    40928.5,
                    36534.6
                  ],
                  [
                    40887.1,
                    36576.4
                  ],
                  [
                    40820.8,
                    36591.3
                  ],
                  [
                    40775.9,
                    36551.4
                  ],
                  [
                    40737.9,
                    36485
                  ],
                  [
                    40751.8,
                    36471.5
                  ],
                  [
                    40746.1,
                    36438.4
                  ],
                  [
                    40749.8,
                    36412.8
                  ],
                  [
                    40770.2,
                    36383.3
                  ],
                  [
                    40797.8,
                    36351.6
                  ],
                  [
                    40812.1,
                    36340.5
                  ],
                  [
                    40875,
                    36350.6
                  ],
                  [
                    40882.8,
                    36342.8
                  ]
                ],
                "id": 333,
                "chat_link": "[&BE0BAAA=]"
              },
              "334": {
                "objective": "Assist Researcher Kaii with Incomp's scrap heap.",
                "level": 4,
                "coord": [
                  41466.4,
                  36744.5
                ],
                "bounds": [
                  [
                    41373.2,
                    36742.2
                  ],
                  [
                    41407.5,
                    36704.6
                  ],
                  [
                    41435.1,
                    36699
                  ],
                  [
                    41472.8,
                    36690.6
                  ],
                  [
                    41539.9,
                    36634.7
                  ],
                  [
                    41572.4,
                    36651
                  ],
                  [
                    41625.7,
                    36774.3
                  ],
                  [
                    41589.1,
                    36905.1
                  ],
                  [
                    41412.4,
                    36892.2
                  ],
                  [
                    41373.2,
                    36742.2
                  ]
                ],
                "id": 334,
                "chat_link": "[&BE4BAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  41714.5,
                  33789.5
                ],
                "id": "0-26"
              },
              {
                "coord": [
                  41951.6,
                  35461.7
                ],
                "id": "0-27"
              },
              {
                "coord": [
                  41507.5,
                  34980.2
                ],
                "id": "0-24"
              },
              {
                "coord": [
                  41006,
                  35158.3
                ],
                "id": "0-67"
              },
              {
                "coord": [
                  40465.6,
                  33759
                ],
                "id": "0-66"
              },
              {
                "coord": [
                  40031.8,
                  35761.7
                ],
                "id": "0-69"
              },
              {
                "coord": [
                  41792.2,
                  34532.1
                ],
                "id": "0-207"
              },
              {
                "coord": [
                  41226.9,
                  36240.4
                ],
                "id": "0-25"
              }
            ],
            "sectors": {
              "144": {
                "name": "Luminates Plant",
                "level": 12,
                "coord": [
                  41917.4,
                  34582.1
                ],
                "bounds": [
                  [
                    41447.1,
                    34482.7
                  ],
                  [
                    41920.9,
                    34260.2
                  ],
                  [
                    42131.9,
                    34313.2
                  ],
                  [
                    42198.6,
                    34583.2
                  ],
                  [
                    42109.1,
                    34865.1
                  ],
                  [
                    41960.3,
                    34866.6
                  ],
                  [
                    41654.3,
                    34703.5
                  ],
                  [
                    41447.1,
                    34482.7
                  ]
                ],
                "id": 144,
                "chat_link": "[&BJAAAAA=]"
              },
              "145": {
                "name": "Cuatl Morass",
                "level": 10,
                "coord": [
                  41772.7,
                  35054.5
                ],
                "bounds": [
                  [
                    41528.7,
                    35221
                  ],
                  [
                    41386.5,
                    35092.3
                  ],
                  [
                    41458.1,
                    34839.3
                  ],
                  [
                    41656.7,
                    34699.8
                  ],
                  [
                    41960.1,
                    34867.1
                  ],
                  [
                    42109.3,
                    34867.1
                  ],
                  [
                    42171.6,
                    35063
                  ],
                  [
                    42122,
                    35441.6
                  ],
                  [
                    41561.6,
                    35399.1
                  ],
                  [
                    41528.7,
                    35221
                  ]
                ],
                "id": 145,
                "chat_link": "[&BJEAAAA=]"
              },
              "146": {
                "name": "Michoan Marsh",
                "level": 11,
                "coord": [
                  40909.5,
                  35145.1
                ],
                "bounds": [
                  [
                    41244.3,
                    35251.8
                  ],
                  [
                    41268.7,
                    35104.3
                  ],
                  [
                    40833.7,
                    34670.6
                  ],
                  [
                    40364.6,
                    34769.4
                  ],
                  [
                    40437,
                    35378.3
                  ],
                  [
                    40911.4,
                    35271.3
                  ],
                  [
                    40927.8,
                    35305.2
                  ],
                  [
                    41072.1,
                    35319
                  ],
                  [
                    41126,
                    35236.4
                  ],
                  [
                    41244.3,
                    35251.8
                  ]
                ],
                "id": 146,
                "chat_link": "[&BJIAAAA=]"
              },
              "147": {
                "name": "Voloxian Passage",
                "level": 8,
                "coord": [
                  40926.2,
                  35549
                ],
                "bounds": [
                  [
                    41339.4,
                    35712.3
                  ],
                  [
                    41247.1,
                    35253.3
                  ],
                  [
                    41127.1,
                    35237.3
                  ],
                  [
                    41070.9,
                    35319.4
                  ],
                  [
                    40928.6,
                    35304.9
                  ],
                  [
                    40914.4,
                    35270.5
                  ],
                  [
                    40416.6,
                    35388
                  ],
                  [
                    40510.3,
                    35715.9
                  ],
                  [
                    40714.1,
                    35796.2
                  ],
                  [
                    40760.5,
                    35918
                  ],
                  [
                    41110.1,
                    35905
                  ],
                  [
                    40974.8,
                    35767.2
                  ],
                  [
                    41339.4,
                    35712.3
                  ]
                ],
                "id": 147,
                "chat_link": "[&BJMAAAA=]"
              },
              "148": {
                "name": "Artergon Woods",
                "level": 13,
                "coord": [
                  41198.6,
                  34665
                ],
                "bounds": [
                  [
                    41000.5,
                    34578.6
                  ],
                  [
                    40878.9,
                    34251.4
                  ],
                  [
                    41089.6,
                    34074.9
                  ],
                  [
                    41666.7,
                    34703.5
                  ],
                  [
                    41458,
                    34839.2
                  ],
                  [
                    41387.2,
                    35093.8
                  ],
                  [
                    41269,
                    35100.5
                  ],
                  [
                    40838.6,
                    34678.3
                  ],
                  [
                    41000.5,
                    34578.6
                  ]
                ],
                "id": 148,
                "chat_link": "[&BJQAAAA=]"
              },
              "149": {
                "name": "Desider Atum",
                "level": 9,
                "coord": [
                  41380.1,
                  35255.8
                ],
                "bounds": [
                  [
                    41243.8,
                    35252.9
                  ],
                  [
                    41293.9,
                    35469.4
                  ],
                  [
                    41556.8,
                    35393.3
                  ],
                  [
                    41530.9,
                    35224.5
                  ],
                  [
                    41388,
                    35093.1
                  ],
                  [
                    41267.3,
                    35101.5
                  ],
                  [
                    41243.8,
                    35252.9
                  ]
                ],
                "id": 149,
                "chat_link": "[&BJUAAAA=]"
              },
              "150": {
                "name": "Akk Wilds",
                "level": 9,
                "coord": [
                  41778.7,
                  35730.9
                ],
                "bounds": [
                  [
                    41346.7,
                    35702.3
                  ],
                  [
                    41507.3,
                    36012.7
                  ],
                  [
                    42133,
                    36221.9
                  ],
                  [
                    42115.9,
                    35837.6
                  ],
                  [
                    42148.8,
                    35769.4
                  ],
                  [
                    42127.3,
                    35441.7
                  ],
                  [
                    41557.4,
                    35393.4
                  ],
                  [
                    41293.3,
                    35468.1
                  ],
                  [
                    41346.7,
                    35702.3
                  ]
                ],
                "id": 150,
                "chat_link": "[&BJYAAAA=]"
              },
              "151": {
                "name": "Wildflame Caverns",
                "level": 3,
                "coord": [
                  40276.3,
                  36696
                ],
                "bounds": [
                  [
                    40309.2,
                    36840.4
                  ],
                  [
                    40079.7,
                    36840.9
                  ],
                  [
                    40024,
                    36672.9
                  ],
                  [
                    40226.5,
                    36524.1
                  ],
                  [
                    40451.6,
                    36554.5
                  ],
                  [
                    40456.5,
                    36661
                  ],
                  [
                    40386.4,
                    36778.2
                  ],
                  [
                    40309.2,
                    36840.4
                  ]
                ],
                "id": 151,
                "chat_link": "[&BJcAAAA=]"
              },
              "152": {
                "name": "Obscura Incline",
                "level": 6,
                "coord": [
                  40364.7,
                  35966.4
                ],
                "bounds": [
                  [
                    40245.2,
                    36304.3
                  ],
                  [
                    40448.6,
                    36312.6
                  ],
                  [
                    40535.2,
                    36050
                  ],
                  [
                    40766.3,
                    35895.1
                  ],
                  [
                    40725.3,
                    35789.5
                  ],
                  [
                    40522.3,
                    35703.8
                  ],
                  [
                    40511.7,
                    35671.7
                  ],
                  [
                    40337.5,
                    35666.9
                  ],
                  [
                    40225.8,
                    35785.9
                  ],
                  [
                    40280.7,
                    36004.3
                  ],
                  [
                    40274.5,
                    36057
                  ],
                  [
                    40189.1,
                    36071.3
                  ],
                  [
                    40035.7,
                    36053.4
                  ],
                  [
                    40008.1,
                    36163.5
                  ],
                  [
                    40245.2,
                    36304.3
                  ]
                ],
                "id": 152,
                "chat_link": "[&BJgAAAA=]"
              },
              "153": {
                "name": "Calx's Hideout",
                "level": 10,
                "coord": [
                  42020,
                  36621.2
                ],
                "bounds": [
                  [
                    41791.3,
                    36435.5
                  ],
                  [
                    41802.3,
                    36795.5
                  ],
                  [
                    42087.2,
                    36825.3
                  ],
                  [
                    42164.8,
                    36744.6
                  ],
                  [
                    42146.9,
                    36487.8
                  ],
                  [
                    42127.8,
                    36438.3
                  ],
                  [
                    41791.3,
                    36435.5
                  ]
                ],
                "id": 153,
                "chat_link": "[&BJkAAAA=]"
              },
              "154": {
                "name": "Thaumanova Reactor",
                "level": 15,
                "coord": [
                  40206.4,
                  33801.8
                ],
                "bounds": [
                  [
                    40090.4,
                    33486.9
                  ],
                  [
                    40357.5,
                    33473.2
                  ],
                  [
                    40522.2,
                    33524.7
                  ],
                  [
                    40643.1,
                    33770.2
                  ],
                  [
                    40578.1,
                    34227.2
                  ],
                  [
                    39984,
                    34202
                  ],
                  [
                    40034.3,
                    34007.4
                  ],
                  [
                    40090.9,
                    33945.5
                  ],
                  [
                    40091.3,
                    33886.4
                  ],
                  [
                    40064.3,
                    33850.5
                  ],
                  [
                    40062.2,
                    33765.6
                  ],
                  [
                    40105.3,
                    33712.9
                  ],
                  [
                    40060.2,
                    33571
                  ],
                  [
                    40090.4,
                    33486.9
                  ]
                ],
                "id": 154,
                "chat_link": "[&BJoAAAA=]"
              },
              "155": {
                "name": "Soren Draa",
                "level": 3,
                "coord": [
                  40147.6,
                  36424
                ],
                "bounds": [
                  [
                    40447.9,
                    36315.7
                  ],
                  [
                    40450.2,
                    36551.2
                  ],
                  [
                    40225.8,
                    36523.4
                  ],
                  [
                    40023.2,
                    36670.9
                  ],
                  [
                    39889.8,
                    36632
                  ],
                  [
                    39890.9,
                    36234.1
                  ],
                  [
                    40006.7,
                    36162.8
                  ],
                  [
                    40246.2,
                    36301.5
                  ],
                  [
                    40447.9,
                    36315.7
                  ]
                ],
                "id": 155,
                "chat_link": "[&BJsAAAA=]"
              },
              "156": {
                "name": "Hexane Regrade",
                "level": 14,
                "coord": [
                  41672.9,
                  33970.5
                ],
                "bounds": [
                  [
                    41456,
                    34486.8
                  ],
                  [
                    41922,
                    34261.2
                  ],
                  [
                    42133.7,
                    34314.6
                  ],
                  [
                    42182.7,
                    34046.6
                  ],
                  [
                    42132.4,
                    33846.8
                  ],
                  [
                    41861.1,
                    33948.3
                  ],
                  [
                    41525,
                    33947.2
                  ],
                  [
                    41527.8,
                    33778.6
                  ],
                  [
                    41468.1,
                    33506.1
                  ],
                  [
                    41102.8,
                    33459.8
                  ],
                  [
                    41090.8,
                    34079.2
                  ],
                  [
                    41456,
                    34486.8
                  ]
                ],
                "id": 156,
                "chat_link": "[&BJwAAAA=]"
              },
              "157": {
                "name": "Greyfern Expanses",
                "level": 12,
                "coord": [
                  40519.2,
                  34509.3
                ],
                "bounds": [
                  [
                    40622.4,
                    34721.6
                  ],
                  [
                    40651.2,
                    34585
                  ],
                  [
                    40141.9,
                    34540.8
                  ],
                  [
                    40032.4,
                    34516.6
                  ],
                  [
                    39981.7,
                    34201
                  ],
                  [
                    40881.8,
                    34250.5
                  ],
                  [
                    41002.1,
                    34579.1
                  ],
                  [
                    40839.6,
                    34679.5
                  ],
                  [
                    40622.4,
                    34721.6
                  ]
                ],
                "id": 157,
                "chat_link": "[&BJ0AAAA=]"
              },
              "158": {
                "name": "Muridian Uplands",
                "level": 13,
                "coord": [
                  40827.8,
                  33794.7
                ],
                "bounds": [
                  [
                    40880.8,
                    34250.7
                  ],
                  [
                    40585.1,
                    34230.2
                  ],
                  [
                    40643.9,
                    33769.8
                  ],
                  [
                    40522.1,
                    33531.8
                  ],
                  [
                    40722.9,
                    33518.9
                  ],
                  [
                    40820.5,
                    33460.2
                  ],
                  [
                    41100,
                    33454.1
                  ],
                  [
                    41089.1,
                    33835.5
                  ],
                  [
                    41085.7,
                    34101.2
                  ],
                  [
                    40880.8,
                    34250.7
                  ]
                ],
                "id": 158,
                "chat_link": "[&BJ4AAAA=]"
              },
              "159": {
                "name": "Inquest Outer Complex",
                "level": 14,
                "coord": [
                  41860.7,
                  33722.4
                ],
                "bounds": [
                  [
                    41525.7,
                    33948.1
                  ],
                  [
                    41861.5,
                    33948.1
                  ],
                  [
                    42133.8,
                    33851.7
                  ],
                  [
                    42129.6,
                    33676.7
                  ],
                  [
                    42164.4,
                    33571.1
                  ],
                  [
                    42075.6,
                    33498.8
                  ],
                  [
                    41467.4,
                    33506.6
                  ],
                  [
                    41527.5,
                    33778
                  ],
                  [
                    41525.7,
                    33948.1
                  ]
                ],
                "id": 159,
                "chat_link": "[&BJ8AAAA=]"
              },
              "160": {
                "name": "The Anthill",
                "level": 12,
                "coord": [
                  40244.8,
                  34687.4
                ],
                "bounds": [
                  [
                    40257.4,
                    34797.2
                  ],
                  [
                    40622.7,
                    34720.6
                  ],
                  [
                    40655.5,
                    34581.7
                  ],
                  [
                    40142.8,
                    34540.8
                  ],
                  [
                    40003.8,
                    34509
                  ],
                  [
                    39952.6,
                    34730.6
                  ],
                  [
                    40078.7,
                    34931.8
                  ],
                  [
                    40257.4,
                    34797.2
                  ]
                ],
                "id": 160,
                "chat_link": "[&BKAAAAA=]"
              },
              "161": {
                "name": "The Serpentwind",
                "level": 7,
                "coord": [
                  41323.5,
                  35943.4
                ],
                "bounds": [
                  [
                    41349.6,
                    35700.4
                  ],
                  [
                    40985.1,
                    35752.2
                  ],
                  [
                    41330.5,
                    36132.7
                  ],
                  [
                    41444.1,
                    36117.9
                  ],
                  [
                    41508,
                    36014.1
                  ],
                  [
                    41349.6,
                    35700.4
                  ]
                ],
                "id": 161,
                "chat_link": "[&BKEAAAA=]"
              },
              "162": {
                "name": "Jeztar Falls",
                "level": 4,
                "coord": [
                  41453.6,
                  36517.7
                ],
                "bounds": [
                  [
                    41142.7,
                    36382.2
                  ],
                  [
                    41315.4,
                    36218.9
                  ],
                  [
                    41325.5,
                    36121.3
                  ],
                  [
                    41441.4,
                    36103.5
                  ],
                  [
                    41786.9,
                    36416.3
                  ],
                  [
                    41801,
                    36816.2
                  ],
                  [
                    41648,
                    36839.1
                  ],
                  [
                    41468.2,
                    36956.3
                  ],
                  [
                    41153.4,
                    36805.4
                  ],
                  [
                    41142.7,
                    36382.2
                  ]
                ],
                "id": 162,
                "chat_link": "[&BKIAAAA=]"
              },
              "163": {
                "name": "Loch Jezt",
                "level": 5,
                "coord": [
                  41036.9,
                  36099.8
                ],
                "bounds": [
                  [
                    41153.6,
                    36394
                  ],
                  [
                    40532.2,
                    36049.5
                  ],
                  [
                    40766.5,
                    35898
                  ],
                  [
                    41118.8,
                    35895.3
                  ],
                  [
                    41329.7,
                    36130.8
                  ],
                  [
                    41320.6,
                    36230.8
                  ],
                  [
                    41153.6,
                    36394
                  ]
                ],
                "id": 163,
                "chat_link": "[&BKMAAAA=]"
              },
              "164": {
                "name": "The Hinterlabs",
                "level": 3,
                "coord": [
                  40678.6,
                  36522.9
                ],
                "bounds": [
                  [
                    40449.1,
                    36313.1
                  ],
                  [
                    40471.8,
                    36252.9
                  ],
                  [
                    40534.3,
                    36063.8
                  ],
                  [
                    41149.2,
                    36393
                  ],
                  [
                    41160,
                    36824.4
                  ],
                  [
                    40733.5,
                    36842.8
                  ],
                  [
                    40624.6,
                    36797.9
                  ],
                  [
                    40531.4,
                    36609.9
                  ],
                  [
                    40453.2,
                    36608.7
                  ],
                  [
                    40449.1,
                    36313.1
                  ]
                ],
                "id": 164,
                "chat_link": "[&BKQAAAA=]"
              },
              "165": {
                "name": "The Funhouse",
                "level": 6,
                "coord": [
                  40155.8,
                  35871.3
                ],
                "bounds": [
                  [
                    40035.7,
                    36052.6
                  ],
                  [
                    40024.6,
                    35951.2
                  ],
                  [
                    39971.3,
                    35890.3
                  ],
                  [
                    39974.1,
                    35616.5
                  ],
                  [
                    40245.7,
                    35617.5
                  ],
                  [
                    40337.4,
                    35669.5
                  ],
                  [
                    40225.4,
                    35782.4
                  ],
                  [
                    40278.8,
                    36007.2
                  ],
                  [
                    40272.8,
                    36052.6
                  ],
                  [
                    40191.9,
                    36073.8
                  ],
                  [
                    40035.7,
                    36052.6
                  ]
                ],
                "id": 165,
                "chat_link": "[&BKUAAAA=]"
              },
              "166": {
                "name": "Fisher's Beach Bend",
                "level": 9,
                "coord": [
                  40187.2,
                  35259.6
                ],
                "bounds": [
                  [
                    40337.1,
                    35664.9
                  ],
                  [
                    40246,
                    35616.8
                  ],
                  [
                    39974.1,
                    35614.5
                  ],
                  [
                    39942.1,
                    35355.8
                  ],
                  [
                    39940.3,
                    35092.3
                  ],
                  [
                    39968,
                    34969.2
                  ],
                  [
                    40077.5,
                    34932.4
                  ],
                  [
                    40257.4,
                    34785.1
                  ],
                  [
                    40372,
                    34770.9
                  ],
                  [
                    40433.1,
                    35382
                  ],
                  [
                    40511.5,
                    35671.2
                  ],
                  [
                    40337.1,
                    35664.9
                  ]
                ],
                "id": 166,
                "chat_link": "[&BKYAAAA=]"
              },
              "167": {
                "name": "Sunshade Caves",
                "level": 9,
                "coord": [
                  41801.5,
                  36244.1
                ],
                "bounds": [
                  [
                    42126.8,
                    36436.7
                  ],
                  [
                    41793,
                    36431.5
                  ],
                  [
                    41446.4,
                    36117.4
                  ],
                  [
                    41509.3,
                    36013.4
                  ],
                  [
                    42132.1,
                    36221.3
                  ],
                  [
                    42126.8,
                    36436.7
                  ]
                ],
                "id": 167,
                "chat_link": "[&BKcAAAA=]"
              },
              "940": {
                "name": "Golemagical Institute",
                "level": 3,
                "coord": [
                  40488,
                  36782
                ],
                "bounds": [
                  [
                    40457.3,
                    36662.3
                  ],
                  [
                    40454,
                    36612.7
                  ],
                  [
                    40531.6,
                    36612
                  ],
                  [
                    40624.3,
                    36798.8
                  ],
                  [
                    40604.8,
                    36869.4
                  ],
                  [
                    40541.9,
                    36900.2
                  ],
                  [
                    40479.8,
                    36901.4
                  ],
                  [
                    40417.5,
                    36866
                  ],
                  [
                    40382.4,
                    36818.9
                  ],
                  [
                    40386.5,
                    36778.8
                  ],
                  [
                    40457.3,
                    36662.3
                  ]
                ],
                "id": 940,
                "chat_link": "[&BKwDAAA=]"
              }
            },
            "adventures": [],
            "id": 35,
            "mastery_points": []
          },
          "54": {
            "name": "Brisban Wildlands",
            "min_level": 15,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {
              "75": {
                "name": "Ogotl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40536,
                  32195
                ],
                "id": 75,
                "chat_link": "[&BEsAAAA=]"
              },
              "76": {
                "name": "Invariant Base",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40513,
                  32844.1
                ],
                "id": 76,
                "chat_link": "[&BEwAAAA=]"
              },
              "77": {
                "name": "Joy's End",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41938,
                  32967.1
                ],
                "id": 77,
                "chat_link": "[&BE0AAAA=]"
              },
              "78": {
                "name": "Beldame's Rise",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41531.1,
                  32044
                ],
                "id": 78,
                "chat_link": "[&BE4AAAA=]"
              },
              "79": {
                "name": "Seraph Protectors",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41904.7,
                  31324.3
                ],
                "id": 79,
                "chat_link": "[&BE8AAAA=]"
              },
              "80": {
                "name": "Willem's Bandits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41501.5,
                  31041.7
                ],
                "id": 80,
                "chat_link": "[&BFAAAAA=]"
              },
              "81": {
                "name": "Scotta's Bandits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40776,
                  31143.6
                ],
                "id": 81,
                "chat_link": "[&BFEAAAA=]"
              },
              "82": {
                "name": "Angelan's Bandits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40661.5,
                  31762.1
                ],
                "id": 82,
                "chat_link": "[&BFIAAAA=]"
              },
              "83": {
                "name": "Skrittsatawney",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40302.2,
                  31867.5
                ],
                "id": 83,
                "chat_link": "[&BFMAAAA=]"
              },
              "84": {
                "name": "Enrav Exploration Post",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40078.4,
                  32152.8
                ],
                "id": 84,
                "chat_link": "[&BFQAAAA=]"
              },
              "85": {
                "name": "Breean's Bandits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  39934,
                  31646.3
                ],
                "id": 85,
                "chat_link": "[&BFUAAAA=]"
              },
              "86": {
                "name": "Plunder Hold",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  39062.8,
                  31197
                ],
                "id": 86,
                "chat_link": "[&BFYAAAA=]"
              },
              "87": {
                "name": "Seanan's Bandits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  39368.6,
                  31365.6
                ],
                "id": 87,
                "chat_link": "[&BFcAAAA=]"
              },
              "88": {
                "name": "Robbari's Bandits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  39260.5,
                  31843.3
                ],
                "id": 88,
                "chat_link": "[&BFgAAAA=]"
              },
              "89": {
                "name": "Fort Vandal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38856.7,
                  32120.9
                ],
                "id": 89,
                "chat_link": "[&BFkAAAA=]"
              },
              "90": {
                "name": "Thaumacore Inquiry Center",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  39262.8,
                  32722.5
                ],
                "id": 90,
                "chat_link": "[&BFoAAAA=]"
              },
              "91": {
                "name": "Revered Terebinth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41792.3,
                  32175.7
                ],
                "id": 91,
                "chat_link": "[&BFsAAAA=]"
              },
              "92": {
                "name": "Watchful Source Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  41833.6,
                  32676.5
                ],
                "id": 92,
                "chat_link": "[&BFwAAAA=]"
              },
              "93": {
                "name": "Wendon Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  41907.4,
                  31191.8
                ],
                "id": 93,
                "chat_link": "[&BF0AAAA=]"
              },
              "94": {
                "name": "Tunnels Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  40859.9,
                  32459.5
                ],
                "id": 94,
                "chat_link": "[&BF4AAAA=]"
              },
              "95": {
                "name": "Hillstead Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  41311,
                  32306.9
                ],
                "id": 95,
                "chat_link": "[&BF8AAAA=]"
              },
              "96": {
                "name": "East End Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  41275.2,
                  31983.9
                ],
                "id": 96,
                "chat_link": "[&BGAAAAA=]"
              },
              "97": {
                "name": "Brilitine Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  40165.6,
                  31856.7
                ],
                "id": 97,
                "chat_link": "[&BGEAAAA=]"
              },
              "98": {
                "name": "Seraph Observers Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  40190.6,
                  31059.9
                ],
                "id": 98,
                "chat_link": "[&BGIAAAA=]"
              },
              "99": {
                "name": "Gallowfields Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  39175.1,
                  31346.1
                ],
                "id": 99,
                "chat_link": "[&BGMAAAA=]"
              },
              "100": {
                "name": "Triforge Point Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  38992.5,
                  32509
                ],
                "id": 100,
                "chat_link": "[&BGQAAAA=]"
              },
              "101": {
                "name": "Ulta Metamagicals Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  40015.9,
                  32542.8
                ],
                "id": 101,
                "chat_link": "[&BGUAAAA=]"
              },
              "102": {
                "name": "Aethervolt Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41102.5,
                  33325.6
                ],
                "id": 102,
                "chat_link": "[&BGYAAAA=]"
              },
              "117": {
                "name": "Mrot Boru Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  40733.6,
                  33298.8
                ],
                "id": 117,
                "chat_link": "[&BHUAAAA=]"
              },
              "118": {
                "name": "Mirkrise Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  39870.1,
                  33051.4
                ],
                "id": 118,
                "chat_link": "[&BHYAAAA=]"
              },
              "823": {
                "name": "Cutpurse Circle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  39657.4,
                  31933.5
                ],
                "id": 823,
                "chat_link": "[&BDcDAAA=]"
              },
              "1474": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  39981.5,
                  31002
                ],
                "id": 1474,
                "chat_link": "[&BMIFAAA=]"
              },
              "1475": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  41883.8,
                  32368.9
                ],
                "id": 1475,
                "chat_link": "[&BMMFAAA=]"
              },
              "1476": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  40367.2,
                  32961.6
                ],
                "id": 1476,
                "chat_link": "[&BMQFAAA=]"
              },
              "1477": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  39617.8,
                  33443.2
                ],
                "id": 1477,
                "chat_link": "[&BMUFAAA=]"
              },
              "1478": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  40573.1,
                  32144.1
                ],
                "id": 1478,
                "chat_link": "[&BMYFAAA=]"
              },
              "1479": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  41080.6,
                  33229.9
                ],
                "id": 1479,
                "chat_link": "[&BMcFAAA=]"
              },
              "1480": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  41139.2,
                  32709.3
                ],
                "id": 1480,
                "chat_link": "[&BMgFAAA=]"
              },
              "1785": {
                "name": "Proxemics Lab Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  38936.7,
                  31509.4
                ],
                "id": 1785,
                "chat_link": "[&BPkGAAA=]"
              },
              "1904": {
                "name": "Tangle Root Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38744.1,
                  33385.4
                ],
                "id": 1904,
                "chat_link": "[&BHAHAAA=]"
              }
            },
            "tasks": {
              "302": {
                "objective": "Help the grub farmers in Skrittsburgh Hillstead.",
                "level": 18,
                "coord": [
                  41467.7,
                  32511.8
                ],
                "bounds": [
                  [
                    41464.8,
                    32148.9
                  ],
                  [
                    41216.8,
                    32132.9
                  ],
                  [
                    41060.8,
                    32304.5
                  ],
                  [
                    41290.1,
                    32570.5
                  ],
                  [
                    41355.1,
                    32837
                  ],
                  [
                    41506.9,
                    32739.7
                  ],
                  [
                    41586.5,
                    32570.8
                  ],
                  [
                    41518.4,
                    32229.6
                  ],
                  [
                    41464.8,
                    32148.9
                  ]
                ],
                "id": 302,
                "chat_link": "[&BC4BAAA=]"
              },
              "303": {
                "objective": "Help the skritt defend Skrittsburgh East End.",
                "level": 19,
                "coord": [
                  41381.2,
                  31738.8
                ],
                "bounds": [
                  [
                    41094.8,
                    32009.1
                  ],
                  [
                    41086.4,
                    31936.3
                  ],
                  [
                    41047.4,
                    31811.4
                  ],
                  [
                    40957,
                    31697
                  ],
                  [
                    41079.8,
                    31557.9
                  ],
                  [
                    41482,
                    31555.6
                  ],
                  [
                    41627.6,
                    31880
                  ],
                  [
                    41485.8,
                    31975.9
                  ],
                  [
                    41412.8,
                    32099.4
                  ],
                  [
                    41266.9,
                    32135.3
                  ],
                  [
                    41094.8,
                    32009.1
                  ]
                ],
                "id": 303,
                "chat_link": "[&BC8BAAA=]"
              },
              "304": {
                "objective": "Help the skritt experimenting in Skrittsburgh Tunnels.",
                "level": 17,
                "coord": [
                  41018,
                  32695.3
                ],
                "bounds": [
                  [
                    40931.1,
                    32712.5
                  ],
                  [
                    40796.9,
                    32570.8
                  ],
                  [
                    40745.6,
                    32417.3
                  ],
                  [
                    40825.5,
                    32307
                  ],
                  [
                    40882.1,
                    32275.3
                  ],
                  [
                    41073.4,
                    32363.5
                  ],
                  [
                    41263.3,
                    32543.7
                  ],
                  [
                    41255.2,
                    32763.4
                  ],
                  [
                    41143.8,
                    32772.5
                  ],
                  [
                    40931.1,
                    32712.5
                  ]
                ],
                "id": 304,
                "chat_link": "[&BDABAAA=]"
              },
              "305": {
                "objective": "Help Leigheara protect the Revered Terebinth.",
                "level": 17,
                "coord": [
                  41768.3,
                  32260.9
                ],
                "bounds": [
                  [
                    41611.8,
                    32454.3
                  ],
                  [
                    41917.8,
                    32302.2
                  ],
                  [
                    41914.7,
                    32073.4
                  ],
                  [
                    41605.4,
                    31926.5
                  ],
                  [
                    41494.2,
                    31976.1
                  ],
                  [
                    41417.9,
                    32102.6
                  ],
                  [
                    41611.8,
                    32454.3
                  ]
                ],
                "id": 305,
                "chat_link": "[&BDEBAAA=]"
              },
              "306": {
                "objective": "Thwart the Nightmare Court at Joy's End.",
                "level": 16,
                "coord": [
                  41927.1,
                  32766
                ],
                "bounds": [
                  [
                    42017.9,
                    32783.8
                  ],
                  [
                    41881.5,
                    32737.8
                  ],
                  [
                    41766.4,
                    32750.1
                  ],
                  [
                    41703.6,
                    32838
                  ],
                  [
                    41830.1,
                    33188.3
                  ],
                  [
                    42060.8,
                    33171.5
                  ],
                  [
                    42095.8,
                    32964
                  ],
                  [
                    42017.9,
                    32783.8
                  ]
                ],
                "id": 306,
                "chat_link": "[&BDIBAAA=]"
              },
              "307": {
                "objective": "Remove threats to Durmand Priory researchers in Toxal Bog.",
                "level": 25,
                "coord": [
                  39720.1,
                  32950.5
                ],
                "bounds": [
                  [
                    39018.9,
                    32846.5
                  ],
                  [
                    39504.6,
                    32849.7
                  ],
                  [
                    39773.8,
                    32930.5
                  ],
                  [
                    39931.9,
                    33300.6
                  ],
                  [
                    39846.4,
                    33530.9
                  ],
                  [
                    39158.4,
                    33535
                  ],
                  [
                    39003.3,
                    32981.7
                  ],
                  [
                    39018.9,
                    32846.5
                  ]
                ],
                "id": 307,
                "chat_link": "[&BDMBAAA=]"
              },
              "308": {
                "objective": "Assist Ulta Metamagicals with their asura gate research.",
                "level": 24,
                "coord": [
                  40129.7,
                  32571.1
                ],
                "bounds": [
                  [
                    39811.4,
                    32628.7
                  ],
                  [
                    39754.5,
                    32456.6
                  ],
                  [
                    39812.1,
                    32358.7
                  ],
                  [
                    40053.6,
                    32342.6
                  ],
                  [
                    40211.2,
                    32511.2
                  ],
                  [
                    40163.5,
                    32624.4
                  ],
                  [
                    39962.1,
                    32705.3
                  ],
                  [
                    39811.4,
                    32628.7
                  ]
                ],
                "id": 308,
                "chat_link": "[&BDQBAAA=]"
              },
              "309": {
                "objective": "Aethervolt researchers require temporary assistants.",
                "level": 16,
                "coord": [
                  41049.5,
                  33151
                ],
                "bounds": [
                  [
                    41018.4,
                    33147.8
                  ],
                  [
                    41042.2,
                    32988.6
                  ],
                  [
                    41036.7,
                    32853.6
                  ],
                  [
                    41177.9,
                    32881.8
                  ],
                  [
                    41218.5,
                    33073
                  ],
                  [
                    41185.3,
                    33212.6
                  ],
                  [
                    41071,
                    33188.7
                  ],
                  [
                    41018.4,
                    33147.8
                  ]
                ],
                "id": 309,
                "chat_link": "[&BDUBAAA=]"
              },
              "310": {
                "objective": "Keep the Inquest from endangering Mrot Boru.",
                "level": 17,
                "coord": [
                  40801.8,
                  32906
                ],
                "bounds": [
                  [
                    40395.8,
                    32912
                  ],
                  [
                    40355,
                    32740.5
                  ],
                  [
                    40459.3,
                    32648.3
                  ],
                  [
                    40687.6,
                    32691.6
                  ],
                  [
                    40847.9,
                    32944.5
                  ],
                  [
                    40791.3,
                    33013
                  ],
                  [
                    40395.8,
                    32912
                  ]
                ],
                "id": 310,
                "chat_link": "[&BDYBAAA=]"
              },
              "311": {
                "objective": "Help the Seraph fight Willem's bandits.",
                "level": 19,
                "coord": [
                  41904.6,
                  31350.2
                ],
                "bounds": [
                  [
                    41403.6,
                    30957.9
                  ],
                  [
                    41770.2,
                    30930.7
                  ],
                  [
                    41845.3,
                    31053.2
                  ],
                  [
                    41975.6,
                    31372.4
                  ],
                  [
                    41903.9,
                    31528.9
                  ],
                  [
                    41854.6,
                    31678.3
                  ],
                  [
                    41674,
                    31665.2
                  ],
                  [
                    41537,
                    31569.8
                  ],
                  [
                    41463.5,
                    31463.1
                  ],
                  [
                    41403.6,
                    30957.9
                  ]
                ],
                "id": 311,
                "chat_link": "[&BDcBAAA=]"
              },
              "312": {
                "objective": "Hinder Scotta's bandits.",
                "level": 20,
                "coord": [
                  41006.6,
                  31228.7
                ],
                "bounds": [
                  [
                    41118.6,
                    31487.8
                  ],
                  [
                    41195.1,
                    31385.5
                  ],
                  [
                    41208.4,
                    31309.8
                  ],
                  [
                    41148.5,
                    31091.3
                  ],
                  [
                    40695.4,
                    30976.3
                  ],
                  [
                    40565.8,
                    31061.6
                  ],
                  [
                    40563.6,
                    31386.9
                  ],
                  [
                    41118.6,
                    31487.8
                  ]
                ],
                "id": 312,
                "chat_link": "[&BDgBAAA=]"
              },
              "313": {
                "objective": "Help the cornered spies at Seraph Observers.",
                "level": 21,
                "coord": [
                  40409.8,
                  31235.7
                ],
                "bounds": [
                  [
                    40154.9,
                    31555.8
                  ],
                  [
                    40223.2,
                    31631.8
                  ],
                  [
                    40408.3,
                    31547.7
                  ],
                  [
                    40499.2,
                    31367.6
                  ],
                  [
                    40476.1,
                    31132.1
                  ],
                  [
                    40597.6,
                    31084.8
                  ],
                  [
                    40601,
                    30989.5
                  ],
                  [
                    40265.4,
                    30977.7
                  ],
                  [
                    40093.3,
                    30971.9
                  ],
                  [
                    40044.2,
                    31034.1
                  ],
                  [
                    40039.9,
                    31190.6
                  ],
                  [
                    40091.9,
                    31359.8
                  ],
                  [
                    40154.9,
                    31555.8
                  ]
                ],
                "id": 313,
                "chat_link": "[&BDkBAAA=]"
              },
              "314": {
                "objective": "Help the skritt challenge the bandits.",
                "level": 23,
                "coord": [
                  39141.1,
                  31401.7
                ],
                "bounds": [
                  [
                    39015,
                    31143.3
                  ],
                  [
                    39126.8,
                    31142.8
                  ],
                  [
                    39174.2,
                    31284.2
                  ],
                  [
                    39222.7,
                    31361.4
                  ],
                  [
                    39280.5,
                    31480.1
                  ],
                  [
                    39342.7,
                    31649.4
                  ],
                  [
                    39357.6,
                    31773.3
                  ],
                  [
                    39331.7,
                    31894
                  ],
                  [
                    39139.4,
                    31869.7
                  ],
                  [
                    38888.9,
                    31693.2
                  ],
                  [
                    38900.4,
                    31488.1
                  ],
                  [
                    38986.4,
                    31359
                  ],
                  [
                    39015,
                    31143.3
                  ]
                ],
                "id": 314,
                "chat_link": "[&BDoBAAA=]"
              },
              "315": {
                "objective": "Help Valiant Mathair secure Vandal's Claim.",
                "level": 23,
                "coord": [
                  39012.1,
                  32470.6
                ],
                "bounds": [
                  [
                    38952.5,
                    32024.2
                  ],
                  [
                    39029.8,
                    31896.9
                  ],
                  [
                    39076.2,
                    31856.5
                  ],
                  [
                    39142.7,
                    31913.1
                  ],
                  [
                    39221.1,
                    32052.8
                  ],
                  [
                    39326.5,
                    32174.5
                  ],
                  [
                    39338.1,
                    32423.9
                  ],
                  [
                    39144.8,
                    32559.3
                  ],
                  [
                    38944.3,
                    32532.9
                  ],
                  [
                    38832.7,
                    32388.4
                  ],
                  [
                    38799.9,
                    32149
                  ],
                  [
                    38952.5,
                    32024.2
                  ]
                ],
                "id": 315,
                "chat_link": "[&BDsBAAA=]"
              },
              "316": {
                "objective": "Help Peacemaker Klodi disperse the alliance of criminals.",
                "level": 23,
                "coord": [
                  39872.5,
                  31921.9
                ],
                "bounds": [
                  [
                    39400.4,
                    32009.3
                  ],
                  [
                    39486.8,
                    31843.4
                  ],
                  [
                    39872.3,
                    31758.2
                  ],
                  [
                    39944.8,
                    31783.4
                  ],
                  [
                    40191.9,
                    32067.3
                  ],
                  [
                    40305.2,
                    32262.4
                  ],
                  [
                    40150.8,
                    32420.5
                  ],
                  [
                    39941.5,
                    32324.8
                  ],
                  [
                    39797.2,
                    32446.5
                  ],
                  [
                    39541.6,
                    32347.4
                  ],
                  [
                    39400.4,
                    32009.3
                  ]
                ],
                "id": 316,
                "chat_link": "[&BDwBAAA=]"
              },
              "318": {
                "objective": "Infiltrate and disrupt Seanan's bandits.",
                "level": 22,
                "coord": [
                  39430.4,
                  31414.7
                ],
                "bounds": [
                  [
                    39375.8,
                    31352.9
                  ],
                  [
                    40474.8,
                    32256
                  ],
                  [
                    39375.8,
                    31352.9
                  ]
                ],
                "id": 318,
                "chat_link": "[&BD4BAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  39021.2,
                  32871.7
                ],
                "id": "0-104"
              },
              {
                "coord": [
                  39588.4,
                  33438.1
                ],
                "id": "0-105"
              },
              {
                "coord": [
                  40237.8,
                  32958.4
                ],
                "id": "0-106"
              },
              {
                "coord": [
                  40258.1,
                  31194.2
                ],
                "id": "0-107"
              },
              {
                "coord": [
                  39217.8,
                  32768.7
                ],
                "id": "0-204"
              },
              {
                "coord": [
                  41303.6,
                  31940.4
                ],
                "id": "0-71"
              },
              {
                "coord": [
                  40758.4,
                  32016.4
                ],
                "id": "0-232"
              },
              {
                "coord": [
                  40959.9,
                  32270.6
                ],
                "id": "0-231"
              }
            ],
            "sectors": {
              "122": {
                "name": "Koga Ruins",
                "level": 24,
                "coord": [
                  40224.2,
                  33097.3
                ],
                "bounds": [
                  [
                    40403.2,
                    32719.6
                  ],
                  [
                    40167,
                    32604.7
                  ],
                  [
                    39673,
                    32918.7
                  ],
                  [
                    39958.2,
                    33293.9
                  ],
                  [
                    39995.1,
                    33536.5
                  ],
                  [
                    40388.4,
                    33538.9
                  ],
                  [
                    40387.2,
                    33346.2
                  ],
                  [
                    40555.1,
                    32977.6
                  ],
                  [
                    40490.7,
                    32939.9
                  ],
                  [
                    40403.2,
                    32719.6
                  ]
                ],
                "id": 122,
                "chat_link": "[&BHoAAAA=]"
              },
              "123": {
                "name": "The Wendon Steps",
                "level": 19,
                "coord": [
                  41781.1,
                  31268.7
                ],
                "bounds": [
                  [
                    41628.3,
                    31879.3
                  ],
                  [
                    41436.3,
                    31544.2
                  ],
                  [
                    41294.5,
                    31539.8
                  ],
                  [
                    41412.9,
                    30921.2
                  ],
                  [
                    41568.6,
                    30902.5
                  ],
                  [
                    41759.5,
                    30910.8
                  ],
                  [
                    42112.9,
                    30816.2
                  ],
                  [
                    42161.1,
                    30946.1
                  ],
                  [
                    42128.5,
                    31211.5
                  ],
                  [
                    42195.1,
                    31619.6
                  ],
                  [
                    41894,
                    31664.9
                  ],
                  [
                    41628.3,
                    31879.3
                  ]
                ],
                "id": 123,
                "chat_link": "[&BHsAAAA=]"
              },
              "124": {
                "name": "Highwayman's Vale",
                "level": 23,
                "coord": [
                  39560.4,
                  32117.4
                ],
                "bounds": [
                  [
                    39656.3,
                    32494.1
                  ],
                  [
                    39928.8,
                    32273.8
                  ],
                  [
                    39760,
                    32046
                  ],
                  [
                    39787.9,
                    31767.4
                  ],
                  [
                    39584.3,
                    31679.8
                  ],
                  [
                    39301,
                    31904.6
                  ],
                  [
                    39413.4,
                    32081.3
                  ],
                  [
                    39386.1,
                    32281.3
                  ],
                  [
                    39226.2,
                    32528.5
                  ],
                  [
                    39656.3,
                    32494.1
                  ]
                ],
                "id": 124,
                "chat_link": "[&BHwAAAA=]"
              },
              "125": {
                "name": "Gnashar's Hills",
                "level": 21,
                "coord": [
                  40936.9,
                  31376.5
                ],
                "bounds": [
                  [
                    40456.7,
                    31917.9
                  ],
                  [
                    40539.8,
                    31982.4
                  ],
                  [
                    40843.9,
                    31600.1
                  ],
                  [
                    40868.1,
                    31542.4
                  ],
                  [
                    41061.8,
                    31427.6
                  ],
                  [
                    41116.5,
                    31466.9
                  ],
                  [
                    41164,
                    31527.1
                  ],
                  [
                    41296.9,
                    31540.7
                  ],
                  [
                    41418.2,
                    30890.4
                  ],
                  [
                    41269.1,
                    30994.8
                  ],
                  [
                    41054,
                    30989.7
                  ],
                  [
                    40928.6,
                    31059
                  ],
                  [
                    40678.4,
                    30971.6
                  ],
                  [
                    40420.1,
                    31360.7
                  ],
                  [
                    40456.7,
                    31917.9
                  ]
                ],
                "id": 125,
                "chat_link": "[&BH0AAAA=]"
              },
              "126": {
                "name": "The Gallowfields",
                "level": 23,
                "coord": [
                  39135.6,
                  31439.6
                ],
                "bounds": [
                  [
                    38922.3,
                    31851.6
                  ],
                  [
                    38850.2,
                    31737.3
                  ],
                  [
                    38897.9,
                    31525.8
                  ],
                  [
                    39002.7,
                    31332.3
                  ],
                  [
                    38991,
                    31071.2
                  ],
                  [
                    39102.5,
                    31037.3
                  ],
                  [
                    39208.5,
                    31118.6
                  ],
                  [
                    39196.3,
                    31236.6
                  ],
                  [
                    39432.6,
                    31339.8
                  ],
                  [
                    39586,
                    31678.6
                  ],
                  [
                    39302.1,
                    31906.3
                  ],
                  [
                    38922.3,
                    31851.6
                  ]
                ],
                "id": 126,
                "chat_link": "[&BH4AAAA=]"
              },
              "127": {
                "name": "Lionshead Outcrops",
                "level": 22,
                "coord": [
                  39678.9,
                  31258
                ],
                "bounds": [
                  [
                    40073.4,
                    31546
                  ],
                  [
                    39962,
                    31252.3
                  ],
                  [
                    39765.9,
                    31190.6
                  ],
                  [
                    39836.1,
                    30918.3
                  ],
                  [
                    39788.8,
                    30851.3
                  ],
                  [
                    39666.7,
                    30854
                  ],
                  [
                    39526.4,
                    30935
                  ],
                  [
                    39209.9,
                    31119
                  ],
                  [
                    39196.3,
                    31236.5
                  ],
                  [
                    39427.9,
                    31339.8
                  ],
                  [
                    39582.8,
                    31679.3
                  ],
                  [
                    39786.2,
                    31769.9
                  ],
                  [
                    40003,
                    31662.5
                  ],
                  [
                    40073.4,
                    31546
                  ]
                ],
                "id": 127,
                "chat_link": "[&BH8AAAA=]"
              },
              "128": {
                "name": "Vandal's Claim",
                "level": 23,
                "coord": [
                  38957.5,
                  32142
                ],
                "bounds": [
                  [
                    38995.7,
                    32630.3
                  ],
                  [
                    38606.3,
                    32525
                  ],
                  [
                    38591,
                    32231.4
                  ],
                  [
                    38589,
                    32100.9
                  ],
                  [
                    38643.6,
                    31690.7
                  ],
                  [
                    38850,
                    31731.8
                  ],
                  [
                    38925.4,
                    31851.3
                  ],
                  [
                    39299.2,
                    31905.1
                  ],
                  [
                    39414.4,
                    32083.3
                  ],
                  [
                    39388.7,
                    32280.5
                  ],
                  [
                    39228.8,
                    32531.8
                  ],
                  [
                    38995.7,
                    32630.3
                  ]
                ],
                "id": 128,
                "chat_link": "[&BIAAAAA=]"
              },
              "129": {
                "name": "Karston Chambers",
                "level": 17,
                "coord": [
                  41884,
                  33223.8
                ],
                "bounds": [
                  [
                    42178.2,
                    33347.1
                  ],
                  [
                    42114.5,
                    33092.8
                  ],
                  [
                    42135.2,
                    32770.7
                  ],
                  [
                    41828,
                    32836.9
                  ],
                  [
                    41481.6,
                    33207.6
                  ],
                  [
                    41644.1,
                    33442.8
                  ],
                  [
                    41606.3,
                    33550.6
                  ],
                  [
                    42084,
                    33541.7
                  ],
                  [
                    42178.2,
                    33347.1
                  ]
                ],
                "id": 129,
                "chat_link": "[&BIEAAAA=]"
              },
              "130": {
                "name": "Brilitine Swath",
                "level": 22,
                "coord": [
                  40173.1,
                  31913.1
                ],
                "bounds": [
                  [
                    40004.9,
                    31661.6
                  ],
                  [
                    40069.4,
                    31549.3
                  ],
                  [
                    40440.4,
                    31500.5
                  ],
                  [
                    40459.1,
                    31916.1
                  ],
                  [
                    40536.6,
                    31984.7
                  ],
                  [
                    40339.3,
                    32191.8
                  ],
                  [
                    40167.8,
                    32600.9
                  ],
                  [
                    39760,
                    32047.8
                  ],
                  [
                    39780.5,
                    31765.3
                  ],
                  [
                    40004.9,
                    31661.6
                  ]
                ],
                "id": 130,
                "chat_link": "[&BIIAAAA=]"
              },
              "131": {
                "name": "Gotala Cascade",
                "level": 23,
                "coord": [
                  40476,
                  32400.7
                ],
                "bounds": [
                  [
                    40541.2,
                    31974.3
                  ],
                  [
                    40338.3,
                    32191.9
                  ],
                  [
                    40162.7,
                    32607.3
                  ],
                  [
                    40400.4,
                    32723.7
                  ],
                  [
                    40781.8,
                    32622.1
                  ],
                  [
                    40631.9,
                    32284.9
                  ],
                  [
                    40541.2,
                    31974.3
                  ]
                ],
                "id": 131,
                "chat_link": "[&BIMAAAA=]"
              },
              "132": {
                "name": "Hidden Lake",
                "level": 21,
                "coord": [
                  40165.7,
                  31206.9
                ],
                "bounds": [
                  [
                    40440.4,
                    31500.2
                  ],
                  [
                    40075,
                    31547
                  ],
                  [
                    39962.4,
                    31252.2
                  ],
                  [
                    39766.4,
                    31191
                  ],
                  [
                    39836.1,
                    30918.5
                  ],
                  [
                    40130.9,
                    30900.1
                  ],
                  [
                    40686.7,
                    30984
                  ],
                  [
                    40428,
                    31361.8
                  ],
                  [
                    40440.4,
                    31500.2
                  ]
                ],
                "id": 132,
                "chat_link": "[&BIQAAAA=]"
              },
              "133": {
                "name": "Venlin Vale",
                "level": 16,
                "coord": [
                  40883.2,
                  33161.9
                ],
                "bounds": [
                  [
                    40781.7,
                    32620.8
                  ],
                  [
                    40926.1,
                    32757.6
                  ],
                  [
                    41194.4,
                    32858.9
                  ],
                  [
                    41273.5,
                    32847.7
                  ],
                  [
                    41642.7,
                    33432.2
                  ],
                  [
                    41606.8,
                    33552.3
                  ],
                  [
                    41152.7,
                    33576.8
                  ],
                  [
                    40807.1,
                    33535.1
                  ],
                  [
                    40766.1,
                    33570.1
                  ],
                  [
                    40390.1,
                    33538
                  ],
                  [
                    40387.6,
                    33339
                  ],
                  [
                    40550.8,
                    32978.2
                  ],
                  [
                    40485.6,
                    32940.4
                  ],
                  [
                    40399.6,
                    32719.8
                  ],
                  [
                    40781.7,
                    32620.8
                  ]
                ],
                "id": 133,
                "chat_link": "[&BIUAAAA=]"
              },
              "134": {
                "name": "Zinder Slope",
                "level": 16,
                "coord": [
                  41789.3,
                  32735.5
                ],
                "bounds": [
                  [
                    41832.8,
                    32837
                  ],
                  [
                    42135.3,
                    32772.7
                  ],
                  [
                    42165.5,
                    32560
                  ],
                  [
                    42113.4,
                    32491.5
                  ],
                  [
                    41964.7,
                    32560.6
                  ],
                  [
                    41619.9,
                    32557.8
                  ],
                  [
                    41512.3,
                    32782.1
                  ],
                  [
                    41268.9,
                    32845.5
                  ],
                  [
                    41490.9,
                    33212.4
                  ],
                  [
                    41832.8,
                    32837
                  ]
                ],
                "id": 134,
                "chat_link": "[&BIYAAAA=]"
              },
              "135": {
                "name": "Skrittsburgh Center",
                "level": 20,
                "coord": [
                  40859.4,
                  32017.5
                ],
                "bounds": [
                  [
                    41088.7,
                    31937.1
                  ],
                  [
                    41047.5,
                    31809.1
                  ],
                  [
                    40841.3,
                    31597.9
                  ],
                  [
                    40721.1,
                    31767
                  ],
                  [
                    40651.8,
                    31837.1
                  ],
                  [
                    40532.7,
                    31984.1
                  ],
                  [
                    40628.7,
                    32298
                  ],
                  [
                    40764.3,
                    32222.4
                  ],
                  [
                    40890.8,
                    32299.6
                  ],
                  [
                    41067,
                    32306.6
                  ],
                  [
                    41219.4,
                    32134
                  ],
                  [
                    41088.7,
                    31937.1
                  ]
                ],
                "id": 135,
                "chat_link": "[&BIcAAAA=]"
              },
              "136": {
                "name": "Skrittsburgh East End",
                "level": 19,
                "coord": [
                  41199.2,
                  31748.9
                ],
                "bounds": [
                  [
                    41218.4,
                    32134.6
                  ],
                  [
                    41086.4,
                    31936.3
                  ],
                  [
                    41047.4,
                    31811.4
                  ],
                  [
                    40839.7,
                    31598.3
                  ],
                  [
                    40863.9,
                    31541
                  ],
                  [
                    41061.7,
                    31423.2
                  ],
                  [
                    41120.2,
                    31465.8
                  ],
                  [
                    41164.8,
                    31524.9
                  ],
                  [
                    41437.2,
                    31543.6
                  ],
                  [
                    41627.6,
                    31880
                  ],
                  [
                    41477.8,
                    31968.2
                  ],
                  [
                    41445.5,
                    32159.4
                  ],
                  [
                    41218.4,
                    32134.6
                  ]
                ],
                "id": 136,
                "chat_link": "[&BIgAAAA=]"
              },
              "137": {
                "name": "Skrittsburgh Tunnels",
                "level": 17,
                "coord": [
                  40989.5,
                  32529.9
                ],
                "bounds": [
                  [
                    40922.5,
                    32759.1
                  ],
                  [
                    40781.4,
                    32631.3
                  ],
                  [
                    40634.8,
                    32290.7
                  ],
                  [
                    40763,
                    32217.5
                  ],
                  [
                    40890.4,
                    32298
                  ],
                  [
                    41062.5,
                    32304.1
                  ],
                  [
                    41291.1,
                    32570.1
                  ],
                  [
                    41354.2,
                    32836.3
                  ],
                  [
                    41205.3,
                    32861.9
                  ],
                  [
                    40922.5,
                    32759.1
                  ]
                ],
                "id": 137,
                "chat_link": "[&BIkAAAA=]"
              },
              "138": {
                "name": "Skrittsburgh Hillstead",
                "level": 18,
                "coord": [
                  41378.6,
                  32443.8
                ],
                "bounds": [
                  [
                    41444,
                    32159.3
                  ],
                  [
                    41216.8,
                    32132.9
                  ],
                  [
                    41060.8,
                    32304.5
                  ],
                  [
                    41290.1,
                    32570.5
                  ],
                  [
                    41355.1,
                    32837
                  ],
                  [
                    41514.4,
                    32782.2
                  ],
                  [
                    41623.8,
                    32559.6
                  ],
                  [
                    41523.7,
                    32204.6
                  ],
                  [
                    41444,
                    32159.3
                  ]
                ],
                "id": 138,
                "chat_link": "[&BIoAAAA=]"
              },
              "140": {
                "name": "The Shattered Henge",
                "level": 25,
                "coord": [
                  39603.7,
                  33211.1
                ],
                "bounds": [
                  [
                    39522.9,
                    32845.1
                  ],
                  [
                    39372.3,
                    32835.7
                  ],
                  [
                    39342,
                    33090.2
                  ],
                  [
                    39423.2,
                    33239.2
                  ],
                  [
                    39374.2,
                    33463.8
                  ],
                  [
                    39521,
                    33500.3
                  ],
                  [
                    39865.8,
                    33488
                  ],
                  [
                    39983.9,
                    33438.9
                  ],
                  [
                    39956.8,
                    33292.1
                  ],
                  [
                    39674.7,
                    32918
                  ],
                  [
                    39522.9,
                    32845.1
                  ]
                ],
                "id": 140,
                "chat_link": "[&BIwAAAA=]"
              },
              "141": {
                "name": "Duskstruck Moors",
                "level": 24,
                "coord": [
                  39544.2,
                  32639.6
                ],
                "bounds": [
                  [
                    39521.7,
                    32847
                  ],
                  [
                    39671.3,
                    32919.2
                  ],
                  [
                    40171,
                    32603.6
                  ],
                  [
                    39935,
                    32268.7
                  ],
                  [
                    39654.9,
                    32495.1
                  ],
                  [
                    39219.9,
                    32525.5
                  ],
                  [
                    38994.4,
                    32627.4
                  ],
                  [
                    39185.7,
                    32830.7
                  ],
                  [
                    39521.7,
                    32847
                  ]
                ],
                "id": 141,
                "chat_link": "[&BI0AAAA=]"
              },
              "142": {
                "name": "Toxal Bog",
                "level": 25,
                "coord": [
                  39135.4,
                  33101.3
                ],
                "bounds": [
                  [
                    39187.9,
                    32826.3
                  ],
                  [
                    39100.5,
                    32736.8
                  ],
                  [
                    38990,
                    32764.1
                  ],
                  [
                    38902,
                    32823.1
                  ],
                  [
                    38872.4,
                    32993.2
                  ],
                  [
                    39059.6,
                    33124.5
                  ],
                  [
                    39019.4,
                    33257.9
                  ],
                  [
                    39007.3,
                    33339.8
                  ],
                  [
                    39041.4,
                    33439.2
                  ],
                  [
                    39194.5,
                    33492.8
                  ],
                  [
                    39380.5,
                    33449.6
                  ],
                  [
                    39423.4,
                    33237.8
                  ],
                  [
                    39342.2,
                    33094.4
                  ],
                  [
                    39374.6,
                    32839
                  ],
                  [
                    39187.9,
                    32826.3
                  ]
                ],
                "id": 142,
                "chat_link": "[&BI4AAAA=]"
              },
              "143": {
                "name": "Nemeton Grove",
                "level": 17,
                "coord": [
                  41798,
                  32117.7
                ],
                "bounds": [
                  [
                    42113.4,
                    32492.5
                  ],
                  [
                    41965.3,
                    32569.8
                  ],
                  [
                    41621.3,
                    32560.5
                  ],
                  [
                    41525.8,
                    32203.1
                  ],
                  [
                    41443,
                    32158.7
                  ],
                  [
                    41478.2,
                    31968.9
                  ],
                  [
                    41625.6,
                    31880.9
                  ],
                  [
                    41891,
                    31666.3
                  ],
                  [
                    42193.6,
                    31618.9
                  ],
                  [
                    42123.1,
                    32057.6
                  ],
                  [
                    42113.4,
                    32492.5
                  ]
                ],
                "id": 143,
                "chat_link": "[&BI8AAAA=]"
              },
              "1030": {
                "name": "Aurora's Remains",
                "level": 26,
                "coord": [
                  38882.2,
                  32864.9
                ],
                "bounds": [
                  [
                    38873,
                    32992.9
                  ],
                  [
                    39058.6,
                    33124.6
                  ],
                  [
                    39019.2,
                    33259.2
                  ],
                  [
                    38663.1,
                    33072.5
                  ],
                  [
                    38610.7,
                    32723.8
                  ],
                  [
                    38607.3,
                    32526.2
                  ],
                  [
                    38996.2,
                    32625.7
                  ],
                  [
                    39100,
                    32736.1
                  ],
                  [
                    38991.5,
                    32765.1
                  ],
                  [
                    38902,
                    32823.2
                  ],
                  [
                    38873,
                    32992.9
                  ]
                ],
                "id": 1030,
                "chat_link": "[&BAYEAAA=]"
              },
              "1103": {
                "name": "Proxemics Lab",
                "level": 23,
                "coord": [
                  38832.7,
                  31231.7
                ],
                "bounds": [
                  [
                    38991.6,
                    30957.7
                  ],
                  [
                    39004.8,
                    31333.4
                  ],
                  [
                    38897.9,
                    31529.6
                  ],
                  [
                    38851.4,
                    31731
                  ],
                  [
                    38641.2,
                    31697
                  ],
                  [
                    38648.6,
                    30835.6
                  ],
                  [
                    38779.8,
                    30840.3
                  ],
                  [
                    38846,
                    30928.9
                  ],
                  [
                    38991.6,
                    30957.7
                  ]
                ],
                "id": 1103,
                "chat_link": "[&BE8EAAA=]"
              },
              "1185": {
                "name": "Tangle Root",
                "level": 26,
                "coord": [
                  38862.9,
                  33354.3
                ],
                "bounds": [
                  [
                    38660.3,
                    33478.7
                  ],
                  [
                    38664.6,
                    33073.2
                  ],
                  [
                    39018.8,
                    33259.8
                  ],
                  [
                    39007.2,
                    33340.2
                  ],
                  [
                    39041.8,
                    33439.8
                  ],
                  [
                    38784.8,
                    33534.3
                  ],
                  [
                    38660.3,
                    33478.7
                  ]
                ],
                "id": 1185,
                "chat_link": "[&BKEEAAA=]"
              }
            },
            "adventures": [],
            "id": 54,
            "mastery_points": []
          },
          "91": {
            "name": "The Grove",
            "min_level": 0,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {
              "1042": {
                "name": "Caledon Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43050.6,
                  37063.8
                ],
                "id": 1042,
                "chat_link": "[&BBIEAAA=]"
              },
              "1152": {
                "name": "Gardenroot Tunnel",
                "type": "landmark",
                "floor": 3,
                "coord": [
                  42946.3,
                  37231.5
                ],
                "id": 1152,
                "chat_link": "[&BIAEAAA=]"
              },
              "1155": {
                "name": "Pale Tree's Circle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43194.5,
                  37452.6
                ],
                "id": 1155,
                "chat_link": "[&BIMEAAA=]"
              },
              "1156": {
                "name": "Warden's Watchgate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43076.6,
                  37253.1
                ],
                "id": 1156,
                "chat_link": "[&BIQEAAA=]"
              },
              "1157": {
                "name": "The Envoy's Shelter",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43329,
                  37472.5
                ],
                "id": 1157,
                "chat_link": "[&BIUEAAA=]"
              },
              "1158": {
                "name": "The Maker's Path",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43311.1,
                  37407.4
                ],
                "id": 1158,
                "chat_link": "[&BIYEAAA=]"
              },
              "1210": {
                "name": "Upper Commons Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  43161.8,
                  37494.4
                ],
                "id": 1210,
                "chat_link": "[&BLoEAAA=]"
              },
              "1211": {
                "name": "Reckoner's Waypoint",
                "type": "waypoint",
                "floor": 0,
                "coord": [
                  43171.8,
                  37445.5
                ],
                "id": 1211,
                "chat_link": "[&BLsEAAA=]"
              },
              "1212": {
                "name": "Ronan's Waypoint",
                "type": "waypoint",
                "floor": 3,
                "coord": [
                  43213.5,
                  37448.8
                ],
                "id": 1212,
                "chat_link": "[&BLwEAAA=]"
              },
              "1468": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43289.1,
                  37469.3
                ],
                "id": 1468,
                "chat_link": "[&BLwFAAA=]"
              },
              "1469": {
                "type": "vista",
                "floor": 3,
                "coord": [
                  43267.3,
                  37539.8
                ],
                "id": 1469,
                "chat_link": "[&BL0FAAA=]"
              },
              "1470": {
                "type": "vista",
                "floor": 3,
                "coord": [
                  43050.4,
                  37263.1
                ],
                "id": 1470,
                "chat_link": "[&BL4FAAA=]"
              },
              "1471": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43135.8,
                  37070.4
                ],
                "id": 1471,
                "chat_link": "[&BL8FAAA=]"
              },
              "1472": {
                "type": "vista",
                "floor": 3,
                "coord": [
                  43154.5,
                  37498.4
                ],
                "id": 1472,
                "chat_link": "[&BMAFAAA=]"
              },
              "1473": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  43373.4,
                  37343.8
                ],
                "id": 1473,
                "chat_link": "[&BMEFAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "855": {
                "name": "Caledon Path",
                "level": 0,
                "coord": [
                  42921.2,
                  36915
                ],
                "bounds": [
                  [
                    42489.3,
                    36436.8
                  ],
                  [
                    43075.1,
                    36430.2
                  ],
                  [
                    42950.2,
                    36837.1
                  ],
                  [
                    43054.6,
                    36998.3
                  ],
                  [
                    43139.6,
                    37052
                  ],
                  [
                    43134.4,
                    37103.6
                  ],
                  [
                    43076.1,
                    37182.4
                  ],
                  [
                    43013.1,
                    37187.5
                  ],
                  [
                    42968.3,
                    37073.9
                  ],
                  [
                    42855.1,
                    36934.1
                  ],
                  [
                    42377,
                    36829
                  ],
                  [
                    42489.3,
                    36436.8
                  ]
                ],
                "id": 855,
                "chat_link": "[&BFcDAAA=]"
              },
              "894": {
                "name": "Constellation Shelter",
                "level": 0,
                "coord": [
                  43220.3,
                  37648.1
                ],
                "bounds": [
                  [
                    43220.7,
                    37597.4
                  ],
                  [
                    43252.8,
                    37613.7
                  ],
                  [
                    43273.3,
                    37667.7
                  ],
                  [
                    43226.4,
                    37701.5
                  ],
                  [
                    43167.7,
                    37693.8
                  ],
                  [
                    43180.8,
                    37614.3
                  ],
                  [
                    43220.7,
                    37597.4
                  ]
                ],
                "id": 894,
                "chat_link": "[&BH4DAAA=]"
              },
              "902": {
                "name": "Necrolith Bay",
                "level": 0,
                "coord": [
                  43312.1,
                  36942.4
                ],
                "bounds": [
                  [
                    43052.3,
                    36998.3
                  ],
                  [
                    42946.9,
                    36836.1
                  ],
                  [
                    43073.4,
                    36427.1
                  ],
                  [
                    43860.7,
                    36450.5
                  ],
                  [
                    43680.8,
                    36768.3
                  ],
                  [
                    43817.8,
                    37012.2
                  ],
                  [
                    43456.7,
                    37148.5
                  ],
                  [
                    43224.5,
                    37198.8
                  ],
                  [
                    43178.6,
                    37181.4
                  ],
                  [
                    43181.8,
                    37131.8
                  ],
                  [
                    43134.3,
                    37104.2
                  ],
                  [
                    43136.9,
                    37051.7
                  ],
                  [
                    43052.3,
                    36998.3
                  ]
                ],
                "id": 902,
                "chat_link": "[&BIYDAAA=]"
              },
              "903": {
                "name": "Seawatcher's Ledge",
                "level": 0,
                "coord": [
                  43306.4,
                  37732.3
                ],
                "bounds": [
                  [
                    43227.9,
                    37701
                  ],
                  [
                    43275.7,
                    37669
                  ],
                  [
                    43292.6,
                    37729.2
                  ],
                  [
                    43358.2,
                    37791.2
                  ],
                  [
                    43437.3,
                    37821.2
                  ],
                  [
                    43488.1,
                    37784.3
                  ],
                  [
                    43486.9,
                    37715.9
                  ],
                  [
                    43396.2,
                    37666.5
                  ],
                  [
                    43461.2,
                    37625.8
                  ],
                  [
                    43429.2,
                    37560.4
                  ],
                  [
                    43410.9,
                    37552.4
                  ],
                  [
                    43417.1,
                    37514.9
                  ],
                  [
                    43825.4,
                    37686.2
                  ],
                  [
                    43717.3,
                    38195.5
                  ],
                  [
                    42976.2,
                    38344
                  ],
                  [
                    42585.3,
                    37709
                  ],
                  [
                    42941,
                    37532.1
                  ],
                  [
                    42984,
                    37623.2
                  ],
                  [
                    43110.9,
                    37692.5
                  ],
                  [
                    43227.9,
                    37701
                  ]
                ],
                "id": 903,
                "chat_link": "[&BIcDAAA=]"
              },
              "904": {
                "name": "Privet Gardens",
                "level": 0,
                "coord": [
                  42733.9,
                  37142.8
                ],
                "bounds": [
                  [
                    42840.7,
                    37315.1
                  ],
                  [
                    42925,
                    37196.5
                  ],
                  [
                    43013,
                    37191.7
                  ],
                  [
                    42967.6,
                    37074
                  ],
                  [
                    42856.3,
                    36935.2
                  ],
                  [
                    42713.1,
                    36899.7
                  ],
                  [
                    42459.4,
                    36841.4
                  ],
                  [
                    42443.2,
                    36931.1
                  ],
                  [
                    42513.4,
                    37008.7
                  ],
                  [
                    42540.8,
                    37075.2
                  ],
                  [
                    42592.4,
                    37711.2
                  ],
                  [
                    42942,
                    37533.2
                  ],
                  [
                    42840.7,
                    37315.1
                  ]
                ],
                "id": 904,
                "chat_link": "[&BIgDAAA=]"
              },
              "911": {
                "name": "Great Helix",
                "level": 0,
                "coord": [
                  43080.5,
                  37411.1
                ],
                "bounds": [
                  [
                    43078.6,
                    37470.6
                  ],
                  [
                    43129.9,
                    37445.6
                  ],
                  [
                    43134.3,
                    37409.9
                  ],
                  [
                    43120,
                    37371.6
                  ],
                  [
                    43097.5,
                    37363.5
                  ],
                  [
                    43022.8,
                    37353.3
                  ],
                  [
                    43014.1,
                    37424.3
                  ],
                  [
                    43046.8,
                    37450.2
                  ],
                  [
                    43078.6,
                    37470.6
                  ]
                ],
                "id": 911,
                "chat_link": "[&BI8DAAA=]"
              },
              "912": {
                "name": "The Sea Rider's Gate",
                "level": 0,
                "coord": [
                  43563,
                  37312.7
                ],
                "bounds": [
                  [
                    43819.2,
                    37005.1
                  ],
                  [
                    43457.9,
                    37148.5
                  ],
                  [
                    43286.4,
                    37182.9
                  ],
                  [
                    43358.1,
                    37247.4
                  ],
                  [
                    43395.1,
                    37313.8
                  ],
                  [
                    43427.8,
                    37461.9
                  ],
                  [
                    43418.8,
                    37510.8
                  ],
                  [
                    43774.1,
                    37670.4
                  ],
                  [
                    43841.3,
                    37554.8
                  ],
                  [
                    43851.7,
                    37031.3
                  ],
                  [
                    43819.2,
                    37005.1
                  ]
                ],
                "id": 912,
                "chat_link": "[&BJADAAA=]"
              },
              "913": {
                "name": "Upper Commons",
                "level": 0,
                "coord": [
                  43165.2,
                  37441.5
                ],
                "bounds": [
                  [
                    43132.1,
                    37516.9
                  ],
                  [
                    43078.5,
                    37470.4
                  ],
                  [
                    43130.1,
                    37446
                  ],
                  [
                    43134.4,
                    37410
                  ],
                  [
                    43125.5,
                    37388.9
                  ],
                  [
                    43161,
                    37369.3
                  ],
                  [
                    43210.1,
                    37372.2
                  ],
                  [
                    43266,
                    37423.9
                  ],
                  [
                    43244.3,
                    37500.7
                  ],
                  [
                    43170.4,
                    37517
                  ],
                  [
                    43132.1,
                    37516.9
                  ]
                ],
                "id": 913,
                "chat_link": "[&BJEDAAA=]"
              },
              "914": {
                "name": "The Quester's Terrace",
                "level": 0,
                "coord": [
                  43375,
                  37621.7
                ],
                "bounds": [
                  [
                    43244.4,
                    37501.4
                  ],
                  [
                    43264.9,
                    37422.1
                  ],
                  [
                    43415.2,
                    37397.2
                  ],
                  [
                    43428,
                    37461.8
                  ],
                  [
                    43413.2,
                    37547.4
                  ],
                  [
                    43427.7,
                    37560.3
                  ],
                  [
                    43459.5,
                    37625.8
                  ],
                  [
                    43397.9,
                    37666.2
                  ],
                  [
                    43484.9,
                    37713.8
                  ],
                  [
                    43488.3,
                    37784.2
                  ],
                  [
                    43437.2,
                    37821.1
                  ],
                  [
                    43356.9,
                    37788.9
                  ],
                  [
                    43291,
                    37727.3
                  ],
                  [
                    43274,
                    37665.9
                  ],
                  [
                    43313.1,
                    37668.2
                  ],
                  [
                    43303.8,
                    37595.6
                  ],
                  [
                    43244.4,
                    37501.4
                  ]
                ],
                "id": 914,
                "chat_link": "[&BJIDAAA=]"
              },
              "915": {
                "name": "Marshaling Field",
                "level": 0,
                "coord": [
                  43144.3,
                  37294.5
                ],
                "bounds": [
                  [
                    42841.8,
                    37316.8
                  ],
                  [
                    42875.6,
                    37389
                  ],
                  [
                    43017.3,
                    37389.9
                  ],
                  [
                    43022.8,
                    37352.8
                  ],
                  [
                    43098.5,
                    37364.8
                  ],
                  [
                    43121,
                    37373.3
                  ],
                  [
                    43127.1,
                    37390.8
                  ],
                  [
                    43161.3,
                    37371.8
                  ],
                  [
                    43209.5,
                    37372.5
                  ],
                  [
                    43264.8,
                    37424.5
                  ],
                  [
                    43405,
                    37396
                  ],
                  [
                    43388.5,
                    37314.7
                  ],
                  [
                    43352.5,
                    37249.7
                  ],
                  [
                    43282.4,
                    37185.4
                  ],
                  [
                    43220.4,
                    37199.3
                  ],
                  [
                    43178,
                    37183
                  ],
                  [
                    43181.2,
                    37133.8
                  ],
                  [
                    43135.9,
                    37104.9
                  ],
                  [
                    43076.2,
                    37180.6
                  ],
                  [
                    42927.2,
                    37196.4
                  ],
                  [
                    42841.8,
                    37316.8
                  ]
                ],
                "id": 915,
                "chat_link": "[&BJMDAAA=]"
              },
              "916": {
                "name": "The Song Bower",
                "level": 0,
                "coord": [
                  43201.7,
                  37611.6
                ],
                "bounds": [
                  [
                    43050.7,
                    37656.9
                  ],
                  [
                    43132.2,
                    37517.3
                  ],
                  [
                    43170.1,
                    37516.8
                  ],
                  [
                    43246.6,
                    37498.3
                  ],
                  [
                    43303.3,
                    37595.7
                  ],
                  [
                    43311.4,
                    37671.5
                  ],
                  [
                    43273.2,
                    37669.5
                  ],
                  [
                    43252.9,
                    37614
                  ],
                  [
                    43220.8,
                    37597.3
                  ],
                  [
                    43180.9,
                    37614
                  ],
                  [
                    43169,
                    37694.4
                  ],
                  [
                    43109.8,
                    37693.2
                  ],
                  [
                    43050.7,
                    37656.9
                  ]
                ],
                "id": 916,
                "chat_link": "[&BJQDAAA=]"
              },
              "917": {
                "name": "Envoy's Terrace",
                "level": 0,
                "coord": [
                  43025.3,
                  37490.4
                ],
                "bounds": [
                  [
                    43014,
                    37424.1
                  ],
                  [
                    43046.5,
                    37450.3
                  ],
                  [
                    43079.1,
                    37470
                  ],
                  [
                    43131.4,
                    37517.1
                  ],
                  [
                    43056.7,
                    37658.9
                  ],
                  [
                    42983,
                    37623.6
                  ],
                  [
                    42874.8,
                    37389.1
                  ],
                  [
                    43017.1,
                    37390.4
                  ],
                  [
                    43014,
                    37424.1
                  ]
                ],
                "id": 917,
                "chat_link": "[&BJUDAAA=]"
              }
            },
            "adventures": [],
            "id": 91,
            "mastery_points": []
          },
          "139": {
            "name": "Rata Sum",
            "min_level": 0,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {
              "1043": {
                "name": "Metrical Court Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  38851.9,
                  37177.6
                ],
                "id": 1043,
                "chat_link": "[&BBMEAAA=]"
              },
              "1044": {
                "name": "Magustan Court Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  38775.1,
                  36969.6
                ],
                "id": 1044,
                "chat_link": "[&BBQEAAA=]"
              },
              "1171": {
                "name": "PR-1000 Prototype Golem",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38596.4,
                  37000.4
                ],
                "id": 1171,
                "chat_link": "[&BJMEAAA=]"
              },
              "1175": {
                "name": "The Magihedron",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38880.3,
                  37049.4
                ],
                "id": 1175,
                "chat_link": "[&BJcEAAA=]"
              },
              "1177": {
                "name": "Thamaturgic Calculus",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38695,
                  37271.1
                ],
                "id": 1177,
                "chat_link": "[&BJkEAAA=]"
              },
              "1181": {
                "name": "Engaged Demo Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37644,
                  36366.1
                ],
                "id": 1181,
                "chat_link": "[&BJ0EAAA=]"
              },
              "1182": {
                "name": "Zojja's Workstation (Don't Touch!)",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38182.9,
                  37334
                ],
                "id": 1182,
                "chat_link": "[&BJ4EAAA=]"
              },
              "1183": {
                "name": "Usability Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38623.7,
                  38124.4
                ],
                "id": 1183,
                "chat_link": "[&BJ8EAAA=]"
              },
              "1204": {
                "name": "Magicat Court Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  38581.5,
                  37130
                ],
                "id": 1204,
                "chat_link": "[&BLQEAAA=]"
              },
              "1205": {
                "name": "Incubation Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  38702.5,
                  37961.4
                ],
                "id": 1205,
                "chat_link": "[&BLUEAAA=]"
              },
              "1206": {
                "name": "Accountancy Waypoint",
                "type": "waypoint",
                "floor": 0,
                "coord": [
                  38742.8,
                  37098.1
                ],
                "id": 1206,
                "chat_link": "[&BLYEAAA=]"
              },
              "1207": {
                "name": "Apprentice Waypoint",
                "type": "waypoint",
                "floor": 3,
                "coord": [
                  38854.5,
                  37110.4
                ],
                "id": 1207,
                "chat_link": "[&BLcEAAA=]"
              },
              "1208": {
                "name": "Research Waypoint",
                "type": "waypoint",
                "floor": 3,
                "coord": [
                  38598.7,
                  37064.6
                ],
                "id": 1208,
                "chat_link": "[&BLgEAAA=]"
              },
              "1209": {
                "name": "Auxiliary Waypoint",
                "type": "waypoint",
                "floor": 3,
                "coord": [
                  38745.7,
                  37235.7
                ],
                "id": 1209,
                "chat_link": "[&BLkEAAA=]"
              },
              "1285": {
                "name": "Antidawn Anchorage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38071.3,
                  38313.2
                ],
                "id": 1285,
                "chat_link": "[&BAUFAAA=]"
              },
              "1286": {
                "name": "Dawnside Quay",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38322.1,
                  38195.4
                ],
                "id": 1286,
                "chat_link": "[&BAYFAAA=]"
              },
              "1287": {
                "name": "Port Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  38102.1,
                  38251
                ],
                "id": 1287,
                "chat_link": "[&BAcFAAA=]"
              },
              "1481": {
                "type": "vista",
                "floor": 3,
                "coord": [
                  38728.7,
                  37124
                ],
                "id": 1481,
                "chat_link": "[&BMkFAAA=]"
              },
              "1482": {
                "type": "vista",
                "floor": 3,
                "coord": [
                  38892.9,
                  37044.9
                ],
                "id": 1482,
                "chat_link": "[&BMoFAAA=]"
              },
              "1483": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  38177,
                  38461.8
                ],
                "id": 1483,
                "chat_link": "[&BMsFAAA=]"
              },
              "1484": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  38838.9,
                  37075.4
                ],
                "id": 1484,
                "chat_link": "[&BMwFAAA=]"
              },
              "1485": {
                "type": "vista",
                "floor": 0,
                "coord": [
                  38721,
                  37261.7
                ],
                "id": 1485,
                "chat_link": "[&BM0FAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "856": {
                "name": "Riven Valley",
                "level": 0,
                "coord": [
                  39282.7,
                  37462.8
                ],
                "bounds": [
                  [
                    38626.7,
                    37783.5
                  ],
                  [
                    38658.9,
                    37474.1
                  ],
                  [
                    39076.8,
                    36977.1
                  ],
                  [
                    39457.9,
                    36851.3
                  ],
                  [
                    39938.6,
                    37073.7
                  ],
                  [
                    39742.9,
                    37905.7
                  ],
                  [
                    39477.1,
                    38174.1
                  ],
                  [
                    38626.7,
                    37783.5
                  ]
                ],
                "id": 856,
                "chat_link": "[&BFgDAAA=]"
              },
              "919": {
                "name": "Applied Development Lab (Home)",
                "level": 0,
                "coord": [
                  37819.7,
                  36301.5
                ],
                "bounds": [
                  [
                    38180.8,
                    36251.8
                  ],
                  [
                    38021.9,
                    36118.1
                  ],
                  [
                    37841.3,
                    36116.1
                  ],
                  [
                    37671.3,
                    36147.8
                  ],
                  [
                    37401.1,
                    36368.3
                  ],
                  [
                    37621.3,
                    36619.1
                  ],
                  [
                    38000,
                    36489
                  ],
                  [
                    38180.8,
                    36251.8
                  ]
                ],
                "id": 919,
                "chat_link": "[&BJcDAAA=]"
              },
              "920": {
                "name": "Snaff Memorial Lab",
                "level": 0,
                "coord": [
                  38014.6,
                  37408.8
                ],
                "bounds": [
                  [
                    37572.9,
                    37270.8
                  ],
                  [
                    38154.6,
                    37083.7
                  ],
                  [
                    38299.6,
                    37250.7
                  ],
                  [
                    38309.6,
                    37463.1
                  ],
                  [
                    38020.6,
                    37738.9
                  ],
                  [
                    37730.4,
                    37645.5
                  ],
                  [
                    37572.9,
                    37270.8
                  ]
                ],
                "id": 920,
                "chat_link": "[&BJgDAAA=]"
              },
              "921": {
                "name": "Advanced Metamystics Lab",
                "level": 0,
                "coord": [
                  38698.8,
                  36297
                ],
                "bounds": [
                  [
                    38340.1,
                    36315.2
                  ],
                  [
                    38624.3,
                    36140.8
                  ],
                  [
                    38973.6,
                    36234.3
                  ],
                  [
                    38857.2,
                    36497.8
                  ],
                  [
                    38340.1,
                    36315.2
                  ]
                ],
                "id": 921,
                "chat_link": "[&BJkDAAA=]"
              },
              "922": {
                "name": "Idea Incubation lab",
                "level": 0,
                "coord": [
                  38796.7,
                  38172.9
                ],
                "bounds": [
                  [
                    38628,
                    37783
                  ],
                  [
                    39482.6,
                    38171.2
                  ],
                  [
                    38913.7,
                    38626.3
                  ],
                  [
                    38405.5,
                    38514.4
                  ],
                  [
                    38553.4,
                    37769.6
                  ],
                  [
                    38628,
                    37783
                  ]
                ],
                "id": 922,
                "chat_link": "[&BJoDAAA=]"
              },
              "934": {
                "name": "College of Dynamics",
                "level": 0,
                "coord": [
                  38569.9,
                  36977.6
                ],
                "bounds": [
                  [
                    38438.8,
                    36868.2
                  ],
                  [
                    38733.3,
                    36918
                  ],
                  [
                    38537.7,
                    37146.5
                  ],
                  [
                    38438.8,
                    36868.2
                  ]
                ],
                "id": 934,
                "chat_link": "[&BKYDAAA=]"
              },
              "935": {
                "name": "Creator's Commons",
                "level": 0,
                "coord": [
                  38725.7,
                  37105.6
                ],
                "bounds": [
                  [
                    38890.6,
                    37199.7
                  ],
                  [
                    38851.6,
                    37246.3
                  ],
                  [
                    38556.2,
                    37195.3
                  ],
                  [
                    38538.5,
                    37147.2
                  ],
                  [
                    38732.7,
                    36917.9
                  ],
                  [
                    38784.3,
                    36927
                  ],
                  [
                    38890.6,
                    37199.7
                  ]
                ],
                "id": 935,
                "chat_link": "[&BKcDAAA=]"
              },
              "936": {
                "name": "College of Statics",
                "level": 0,
                "coord": [
                  38916.9,
                  37034.7
                ],
                "bounds": [
                  [
                    38890.6,
                    37200.1
                  ],
                  [
                    39076,
                    36977.6
                  ],
                  [
                    38784.2,
                    36926.3
                  ],
                  [
                    38890.6,
                    37200.1
                  ]
                ],
                "id": 936,
                "chat_link": "[&BKgDAAA=]"
              },
              "937": {
                "name": "College of Synergetics",
                "level": 0,
                "coord": [
                  38689.1,
                  37305.5
                ],
                "bounds": [
                  [
                    38556.4,
                    37194.6
                  ],
                  [
                    38658.8,
                    37475.8
                  ],
                  [
                    38852,
                    37246.1
                  ],
                  [
                    38556.4,
                    37194.6
                  ]
                ],
                "id": 937,
                "chat_link": "[&BKkDAAA=]"
              },
              "938": {
                "name": "Arkentia Valley",
                "level": 0,
                "coord": [
                  38793.4,
                  36540.4
                ],
                "bounds": [
                  [
                    39458.8,
                    36855.5
                  ],
                  [
                    39366.4,
                    36142.8
                  ],
                  [
                    38975.9,
                    36234.4
                  ],
                  [
                    38855.8,
                    36498.3
                  ],
                  [
                    38180.7,
                    36252.8
                  ],
                  [
                    38000.2,
                    36494.6
                  ],
                  [
                    38433,
                    36867.3
                  ],
                  [
                    39076.2,
                    36977.5
                  ],
                  [
                    39458.8,
                    36855.5
                  ]
                ],
                "id": 938,
                "chat_link": "[&BKoDAAA=]"
              },
              "939": {
                "name": "Magus Valley",
                "level": 0,
                "coord": [
                  38175.8,
                  37202.9
                ],
                "bounds": [
                  [
                    37623,
                    36621.1
                  ],
                  [
                    37624.5,
                    37260.1
                  ],
                  [
                    38152.6,
                    37089.3
                  ],
                  [
                    38299.1,
                    37252.5
                  ],
                  [
                    38310.9,
                    37464.6
                  ],
                  [
                    38023.1,
                    37736.6
                  ],
                  [
                    38627.4,
                    37783
                  ],
                  [
                    38661,
                    37474
                  ],
                  [
                    38437.5,
                    36864.6
                  ],
                  [
                    37998.4,
                    36483.2
                  ],
                  [
                    37623,
                    36621.1
                  ]
                ],
                "id": 939,
                "chat_link": "[&BKsDAAA=]"
              },
              "1016": {
                "name": "Polymock Arenas",
                "level": 0,
                "coord": [
                  39777.3,
                  36659.2
                ],
                "bounds": [
                  [
                    39941.6,
                    37070.8
                  ],
                  [
                    39461.6,
                    36865.5
                  ],
                  [
                    39366.8,
                    36142.2
                  ],
                  [
                    40039.1,
                    36310
                  ],
                  [
                    40077.2,
                    36907.6
                  ],
                  [
                    39941.6,
                    37070.8
                  ]
                ],
                "id": 1016,
                "chat_link": "[&BPgDAAA=]"
              },
              "1022": {
                "name": "Rata Sum Port Authority",
                "level": 0,
                "coord": [
                  38059.1,
                  38100.3
                ],
                "bounds": [
                  [
                    38554.5,
                    37769.2
                  ],
                  [
                    38405.5,
                    38514.4
                  ],
                  [
                    37999.3,
                    38623.5
                  ],
                  [
                    37641.6,
                    38312
                  ],
                  [
                    37729.7,
                    37646.3
                  ],
                  [
                    38023.9,
                    37736.3
                  ],
                  [
                    38554.5,
                    37769.2
                  ]
                ],
                "id": 1022,
                "chat_link": "[&BP4DAAA=]"
              }
            },
            "adventures": [],
            "id": 139,
            "mastery_points": []
          },
          "646": {
            "name": "The House of Caithe",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 3,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 646,
            "mastery_points": []
          },
          "647": {
            "name": "Dreamer's Terrace (Home)",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 3,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 647,
            "mastery_points": []
          },
          "648": {
            "name": "The Omphalos Chamber",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 2,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 648,
            "mastery_points": []
          },
          "649": {
            "name": "Snaff Memorial Lab",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {
              "1182": {
                "name": "Zojja's Workstation (Don't Touch!)",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38182.9,
                  37334
                ],
                "id": 1182,
                "chat_link": "[&BJ4EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "920": {
                "name": "Snaff Memorial Lab",
                "level": 0,
                "coord": [
                  38014.6,
                  37408.8
                ],
                "bounds": [
                  [
                    37572.9,
                    37270.8
                  ],
                  [
                    38154.6,
                    37083.7
                  ],
                  [
                    38299.6,
                    37250.7
                  ],
                  [
                    38309.6,
                    37463.1
                  ],
                  [
                    38020.6,
                    37738.9
                  ],
                  [
                    37730.4,
                    37645.5
                  ],
                  [
                    37572.9,
                    37270.8
                  ]
                ],
                "id": 920,
                "chat_link": "[&BJgDAAA=]"
              }
            },
            "id": 649,
            "mastery_points": [],
            "adventures": []
          },
          "650": {
            "name": "Applied Development Lab (Home)",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {
              "1181": {
                "name": "Engaged Demo Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37644,
                  36366.1
                ],
                "id": 1181,
                "chat_link": "[&BJ0EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "919": {
                "name": "Applied Development Lab (Home)",
                "level": 0,
                "coord": [
                  37819.7,
                  36301.5
                ],
                "bounds": [
                  [
                    38180.8,
                    36251.8
                  ],
                  [
                    38021.9,
                    36118.1
                  ],
                  [
                    37841.3,
                    36116.1
                  ],
                  [
                    37671.3,
                    36147.8
                  ],
                  [
                    37401.1,
                    36368.3
                  ],
                  [
                    37621.3,
                    36619.1
                  ],
                  [
                    38000,
                    36489
                  ],
                  [
                    38180.8,
                    36251.8
                  ]
                ],
                "id": 919,
                "chat_link": "[&BJcDAAA=]"
              }
            },
            "id": 650,
            "mastery_points": [],
            "adventures": []
          },
          "651": {
            "name": "Council Level",
            "min_level": 0,
            "max_level": 0,
            "default_floor": 2,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "id": 651,
            "mastery_points": [],
            "adventures": []
          },
          "1075": {
            "name": "Proxemics Lab",
            "min_level": 15,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "122": {
                "name": "Koga Ruins",
                "level": 24,
                "coord": [
                  40224.2,
                  33097.3
                ],
                "bounds": [
                  [
                    40403.2,
                    32719.6
                  ],
                  [
                    40167,
                    32604.7
                  ],
                  [
                    39673,
                    32918.7
                  ],
                  [
                    39958.2,
                    33293.9
                  ],
                  [
                    39995.1,
                    33536.5
                  ],
                  [
                    40388.4,
                    33538.9
                  ],
                  [
                    40387.2,
                    33346.2
                  ],
                  [
                    40555.1,
                    32977.6
                  ],
                  [
                    40490.7,
                    32939.9
                  ],
                  [
                    40403.2,
                    32719.6
                  ]
                ],
                "id": 122,
                "chat_link": "[&BHoAAAA=]"
              },
              "123": {
                "name": "The Wendon Steps",
                "level": 19,
                "coord": [
                  41781.1,
                  31268.7
                ],
                "bounds": [
                  [
                    41628.3,
                    31879.3
                  ],
                  [
                    41436.3,
                    31544.2
                  ],
                  [
                    41294.5,
                    31539.8
                  ],
                  [
                    41412.9,
                    30921.2
                  ],
                  [
                    41568.6,
                    30902.5
                  ],
                  [
                    41759.5,
                    30910.8
                  ],
                  [
                    42112.9,
                    30816.2
                  ],
                  [
                    42161.1,
                    30946.1
                  ],
                  [
                    42128.5,
                    31211.5
                  ],
                  [
                    42195.1,
                    31619.6
                  ],
                  [
                    41894,
                    31664.9
                  ],
                  [
                    41628.3,
                    31879.3
                  ]
                ],
                "id": 123,
                "chat_link": "[&BHsAAAA=]"
              },
              "124": {
                "name": "Highwayman's Vale",
                "level": 23,
                "coord": [
                  39560.4,
                  32117.4
                ],
                "bounds": [
                  [
                    39656.3,
                    32494.1
                  ],
                  [
                    39928.8,
                    32273.8
                  ],
                  [
                    39760,
                    32046
                  ],
                  [
                    39787.9,
                    31767.4
                  ],
                  [
                    39584.3,
                    31679.8
                  ],
                  [
                    39301,
                    31904.6
                  ],
                  [
                    39413.4,
                    32081.3
                  ],
                  [
                    39386.1,
                    32281.3
                  ],
                  [
                    39226.2,
                    32528.5
                  ],
                  [
                    39656.3,
                    32494.1
                  ]
                ],
                "id": 124,
                "chat_link": "[&BHwAAAA=]"
              },
              "125": {
                "name": "Gnashar's Hills",
                "level": 21,
                "coord": [
                  40936.9,
                  31376.5
                ],
                "bounds": [
                  [
                    40456.7,
                    31917.9
                  ],
                  [
                    40539.8,
                    31982.4
                  ],
                  [
                    40843.9,
                    31600.1
                  ],
                  [
                    40868.1,
                    31542.4
                  ],
                  [
                    41061.8,
                    31427.6
                  ],
                  [
                    41116.5,
                    31466.9
                  ],
                  [
                    41164,
                    31527.1
                  ],
                  [
                    41296.9,
                    31540.7
                  ],
                  [
                    41418.2,
                    30890.4
                  ],
                  [
                    41269.1,
                    30994.8
                  ],
                  [
                    41054,
                    30989.7
                  ],
                  [
                    40928.6,
                    31059
                  ],
                  [
                    40678.4,
                    30971.6
                  ],
                  [
                    40420.1,
                    31360.7
                  ],
                  [
                    40456.7,
                    31917.9
                  ]
                ],
                "id": 125,
                "chat_link": "[&BH0AAAA=]"
              },
              "126": {
                "name": "The Gallowfields",
                "level": 23,
                "coord": [
                  39135.6,
                  31439.6
                ],
                "bounds": [
                  [
                    38922.3,
                    31851.6
                  ],
                  [
                    38850.2,
                    31737.3
                  ],
                  [
                    38897.9,
                    31525.8
                  ],
                  [
                    39002.7,
                    31332.3
                  ],
                  [
                    38991,
                    31071.2
                  ],
                  [
                    39102.5,
                    31037.3
                  ],
                  [
                    39208.5,
                    31118.6
                  ],
                  [
                    39196.3,
                    31236.6
                  ],
                  [
                    39432.6,
                    31339.8
                  ],
                  [
                    39586,
                    31678.6
                  ],
                  [
                    39302.1,
                    31906.3
                  ],
                  [
                    38922.3,
                    31851.6
                  ]
                ],
                "id": 126,
                "chat_link": "[&BH4AAAA=]"
              },
              "127": {
                "name": "Lionshead Outcrops",
                "level": 22,
                "coord": [
                  39678.9,
                  31258
                ],
                "bounds": [
                  [
                    40073.4,
                    31546
                  ],
                  [
                    39962,
                    31252.3
                  ],
                  [
                    39765.9,
                    31190.6
                  ],
                  [
                    39836.1,
                    30918.3
                  ],
                  [
                    39788.8,
                    30851.3
                  ],
                  [
                    39666.7,
                    30854
                  ],
                  [
                    39526.4,
                    30935
                  ],
                  [
                    39209.9,
                    31119
                  ],
                  [
                    39196.3,
                    31236.5
                  ],
                  [
                    39427.9,
                    31339.8
                  ],
                  [
                    39582.8,
                    31679.3
                  ],
                  [
                    39786.2,
                    31769.9
                  ],
                  [
                    40003,
                    31662.5
                  ],
                  [
                    40073.4,
                    31546
                  ]
                ],
                "id": 127,
                "chat_link": "[&BH8AAAA=]"
              },
              "128": {
                "name": "Vandal's Claim",
                "level": 23,
                "coord": [
                  38957.5,
                  32142
                ],
                "bounds": [
                  [
                    38995.7,
                    32630.3
                  ],
                  [
                    38606.3,
                    32525
                  ],
                  [
                    38591,
                    32231.4
                  ],
                  [
                    38589,
                    32100.9
                  ],
                  [
                    38643.6,
                    31690.7
                  ],
                  [
                    38850,
                    31731.8
                  ],
                  [
                    38925.4,
                    31851.3
                  ],
                  [
                    39299.2,
                    31905.1
                  ],
                  [
                    39414.4,
                    32083.3
                  ],
                  [
                    39388.7,
                    32280.5
                  ],
                  [
                    39228.8,
                    32531.8
                  ],
                  [
                    38995.7,
                    32630.3
                  ]
                ],
                "id": 128,
                "chat_link": "[&BIAAAAA=]"
              },
              "129": {
                "name": "Karston Chambers",
                "level": 17,
                "coord": [
                  41884,
                  33223.8
                ],
                "bounds": [
                  [
                    42178.2,
                    33347.1
                  ],
                  [
                    42114.5,
                    33092.8
                  ],
                  [
                    42135.2,
                    32770.7
                  ],
                  [
                    41828,
                    32836.9
                  ],
                  [
                    41481.6,
                    33207.6
                  ],
                  [
                    41644.1,
                    33442.8
                  ],
                  [
                    41606.3,
                    33550.6
                  ],
                  [
                    42084,
                    33541.7
                  ],
                  [
                    42178.2,
                    33347.1
                  ]
                ],
                "id": 129,
                "chat_link": "[&BIEAAAA=]"
              },
              "130": {
                "name": "Brilitine Swath",
                "level": 22,
                "coord": [
                  40173.1,
                  31913.1
                ],
                "bounds": [
                  [
                    40004.9,
                    31661.6
                  ],
                  [
                    40069.4,
                    31549.3
                  ],
                  [
                    40440.4,
                    31500.5
                  ],
                  [
                    40459.1,
                    31916.1
                  ],
                  [
                    40536.6,
                    31984.7
                  ],
                  [
                    40339.3,
                    32191.8
                  ],
                  [
                    40167.8,
                    32600.9
                  ],
                  [
                    39760,
                    32047.8
                  ],
                  [
                    39780.5,
                    31765.3
                  ],
                  [
                    40004.9,
                    31661.6
                  ]
                ],
                "id": 130,
                "chat_link": "[&BIIAAAA=]"
              },
              "131": {
                "name": "Gotala Cascade",
                "level": 23,
                "coord": [
                  40476,
                  32400.7
                ],
                "bounds": [
                  [
                    40541.2,
                    31974.3
                  ],
                  [
                    40338.3,
                    32191.9
                  ],
                  [
                    40162.7,
                    32607.3
                  ],
                  [
                    40400.4,
                    32723.7
                  ],
                  [
                    40781.8,
                    32622.1
                  ],
                  [
                    40631.9,
                    32284.9
                  ],
                  [
                    40541.2,
                    31974.3
                  ]
                ],
                "id": 131,
                "chat_link": "[&BIMAAAA=]"
              },
              "132": {
                "name": "Hidden Lake",
                "level": 21,
                "coord": [
                  40165.7,
                  31206.9
                ],
                "bounds": [
                  [
                    40440.4,
                    31500.2
                  ],
                  [
                    40075,
                    31547
                  ],
                  [
                    39962.4,
                    31252.2
                  ],
                  [
                    39766.4,
                    31191
                  ],
                  [
                    39836.1,
                    30918.5
                  ],
                  [
                    40130.9,
                    30900.1
                  ],
                  [
                    40686.7,
                    30984
                  ],
                  [
                    40428,
                    31361.8
                  ],
                  [
                    40440.4,
                    31500.2
                  ]
                ],
                "id": 132,
                "chat_link": "[&BIQAAAA=]"
              },
              "133": {
                "name": "Venlin Vale",
                "level": 16,
                "coord": [
                  40883.2,
                  33161.9
                ],
                "bounds": [
                  [
                    40781.7,
                    32620.8
                  ],
                  [
                    40926.1,
                    32757.6
                  ],
                  [
                    41194.4,
                    32858.9
                  ],
                  [
                    41273.5,
                    32847.7
                  ],
                  [
                    41642.7,
                    33432.2
                  ],
                  [
                    41606.8,
                    33552.3
                  ],
                  [
                    41152.7,
                    33576.8
                  ],
                  [
                    40807.1,
                    33535.1
                  ],
                  [
                    40766.1,
                    33570.1
                  ],
                  [
                    40390.1,
                    33538
                  ],
                  [
                    40387.6,
                    33339
                  ],
                  [
                    40550.8,
                    32978.2
                  ],
                  [
                    40485.6,
                    32940.4
                  ],
                  [
                    40399.6,
                    32719.8
                  ],
                  [
                    40781.7,
                    32620.8
                  ]
                ],
                "id": 133,
                "chat_link": "[&BIUAAAA=]"
              },
              "134": {
                "name": "Zinder Slope",
                "level": 16,
                "coord": [
                  41789.3,
                  32735.5
                ],
                "bounds": [
                  [
                    41832.8,
                    32837
                  ],
                  [
                    42135.3,
                    32772.7
                  ],
                  [
                    42165.5,
                    32560
                  ],
                  [
                    42113.4,
                    32491.5
                  ],
                  [
                    41964.7,
                    32560.6
                  ],
                  [
                    41619.9,
                    32557.8
                  ],
                  [
                    41512.3,
                    32782.1
                  ],
                  [
                    41268.9,
                    32845.5
                  ],
                  [
                    41490.9,
                    33212.4
                  ],
                  [
                    41832.8,
                    32837
                  ]
                ],
                "id": 134,
                "chat_link": "[&BIYAAAA=]"
              },
              "135": {
                "name": "Skrittsburgh Center",
                "level": 20,
                "coord": [
                  40859.4,
                  32017.5
                ],
                "bounds": [
                  [
                    41088.7,
                    31937.1
                  ],
                  [
                    41047.5,
                    31809.1
                  ],
                  [
                    40841.3,
                    31597.9
                  ],
                  [
                    40721.1,
                    31767
                  ],
                  [
                    40651.8,
                    31837.1
                  ],
                  [
                    40532.7,
                    31984.1
                  ],
                  [
                    40628.7,
                    32298
                  ],
                  [
                    40764.3,
                    32222.4
                  ],
                  [
                    40890.8,
                    32299.6
                  ],
                  [
                    41067,
                    32306.6
                  ],
                  [
                    41219.4,
                    32134
                  ],
                  [
                    41088.7,
                    31937.1
                  ]
                ],
                "id": 135,
                "chat_link": "[&BIcAAAA=]"
              },
              "136": {
                "name": "Skrittsburgh East End",
                "level": 19,
                "coord": [
                  41199.2,
                  31748.9
                ],
                "bounds": [
                  [
                    41218.4,
                    32134.6
                  ],
                  [
                    41086.4,
                    31936.3
                  ],
                  [
                    41047.4,
                    31811.4
                  ],
                  [
                    40839.7,
                    31598.3
                  ],
                  [
                    40863.9,
                    31541
                  ],
                  [
                    41061.7,
                    31423.2
                  ],
                  [
                    41120.2,
                    31465.8
                  ],
                  [
                    41164.8,
                    31524.9
                  ],
                  [
                    41437.2,
                    31543.6
                  ],
                  [
                    41627.6,
                    31880
                  ],
                  [
                    41477.8,
                    31968.2
                  ],
                  [
                    41445.5,
                    32159.4
                  ],
                  [
                    41218.4,
                    32134.6
                  ]
                ],
                "id": 136,
                "chat_link": "[&BIgAAAA=]"
              },
              "137": {
                "name": "Skrittsburgh Tunnels",
                "level": 17,
                "coord": [
                  40989.5,
                  32529.9
                ],
                "bounds": [
                  [
                    40922.5,
                    32759.1
                  ],
                  [
                    40781.4,
                    32631.3
                  ],
                  [
                    40634.8,
                    32290.7
                  ],
                  [
                    40763,
                    32217.5
                  ],
                  [
                    40890.4,
                    32298
                  ],
                  [
                    41062.5,
                    32304.1
                  ],
                  [
                    41291.1,
                    32570.1
                  ],
                  [
                    41354.2,
                    32836.3
                  ],
                  [
                    41205.3,
                    32861.9
                  ],
                  [
                    40922.5,
                    32759.1
                  ]
                ],
                "id": 137,
                "chat_link": "[&BIkAAAA=]"
              },
              "138": {
                "name": "Skrittsburgh Hillstead",
                "level": 18,
                "coord": [
                  41378.6,
                  32443.8
                ],
                "bounds": [
                  [
                    41444,
                    32159.3
                  ],
                  [
                    41216.8,
                    32132.9
                  ],
                  [
                    41060.8,
                    32304.5
                  ],
                  [
                    41290.1,
                    32570.5
                  ],
                  [
                    41355.1,
                    32837
                  ],
                  [
                    41514.4,
                    32782.2
                  ],
                  [
                    41623.8,
                    32559.6
                  ],
                  [
                    41523.7,
                    32204.6
                  ],
                  [
                    41444,
                    32159.3
                  ]
                ],
                "id": 138,
                "chat_link": "[&BIoAAAA=]"
              },
              "140": {
                "name": "The Shattered Henge",
                "level": 25,
                "coord": [
                  39603.7,
                  33211.1
                ],
                "bounds": [
                  [
                    39522.9,
                    32845.1
                  ],
                  [
                    39372.3,
                    32835.7
                  ],
                  [
                    39342,
                    33090.2
                  ],
                  [
                    39423.2,
                    33239.2
                  ],
                  [
                    39374.2,
                    33463.8
                  ],
                  [
                    39521,
                    33500.3
                  ],
                  [
                    39865.8,
                    33488
                  ],
                  [
                    39983.9,
                    33438.9
                  ],
                  [
                    39956.8,
                    33292.1
                  ],
                  [
                    39674.7,
                    32918
                  ],
                  [
                    39522.9,
                    32845.1
                  ]
                ],
                "id": 140,
                "chat_link": "[&BIwAAAA=]"
              },
              "141": {
                "name": "Duskstruck Moors",
                "level": 24,
                "coord": [
                  39544.2,
                  32639.6
                ],
                "bounds": [
                  [
                    39521.7,
                    32847
                  ],
                  [
                    39671.3,
                    32919.2
                  ],
                  [
                    40171,
                    32603.6
                  ],
                  [
                    39935,
                    32268.7
                  ],
                  [
                    39654.9,
                    32495.1
                  ],
                  [
                    39219.9,
                    32525.5
                  ],
                  [
                    38994.4,
                    32627.4
                  ],
                  [
                    39185.7,
                    32830.7
                  ],
                  [
                    39521.7,
                    32847
                  ]
                ],
                "id": 141,
                "chat_link": "[&BI0AAAA=]"
              },
              "142": {
                "name": "Toxal Bog",
                "level": 25,
                "coord": [
                  39135.4,
                  33101.3
                ],
                "bounds": [
                  [
                    39187.9,
                    32826.3
                  ],
                  [
                    39100.5,
                    32736.8
                  ],
                  [
                    38990,
                    32764.1
                  ],
                  [
                    38902,
                    32823.1
                  ],
                  [
                    38872.4,
                    32993.2
                  ],
                  [
                    39059.6,
                    33124.5
                  ],
                  [
                    39019.4,
                    33257.9
                  ],
                  [
                    39007.3,
                    33339.8
                  ],
                  [
                    39041.4,
                    33439.2
                  ],
                  [
                    39194.5,
                    33492.8
                  ],
                  [
                    39380.5,
                    33449.6
                  ],
                  [
                    39423.4,
                    33237.8
                  ],
                  [
                    39342.2,
                    33094.4
                  ],
                  [
                    39374.6,
                    32839
                  ],
                  [
                    39187.9,
                    32826.3
                  ]
                ],
                "id": 142,
                "chat_link": "[&BI4AAAA=]"
              },
              "143": {
                "name": "Nemeton Grove",
                "level": 17,
                "coord": [
                  41798,
                  32117.7
                ],
                "bounds": [
                  [
                    42113.4,
                    32492.5
                  ],
                  [
                    41965.3,
                    32569.8
                  ],
                  [
                    41621.3,
                    32560.5
                  ],
                  [
                    41525.8,
                    32203.1
                  ],
                  [
                    41443,
                    32158.7
                  ],
                  [
                    41478.2,
                    31968.9
                  ],
                  [
                    41625.6,
                    31880.9
                  ],
                  [
                    41891,
                    31666.3
                  ],
                  [
                    42193.6,
                    31618.9
                  ],
                  [
                    42123.1,
                    32057.6
                  ],
                  [
                    42113.4,
                    32492.5
                  ]
                ],
                "id": 143,
                "chat_link": "[&BI8AAAA=]"
              },
              "1030": {
                "name": "Aurora's Remains",
                "level": 26,
                "coord": [
                  38882.2,
                  32864.9
                ],
                "bounds": [
                  [
                    38873,
                    32992.9
                  ],
                  [
                    39058.6,
                    33124.6
                  ],
                  [
                    39019.2,
                    33259.2
                  ],
                  [
                    38663.1,
                    33072.5
                  ],
                  [
                    38610.7,
                    32723.8
                  ],
                  [
                    38607.3,
                    32526.2
                  ],
                  [
                    38996.2,
                    32625.7
                  ],
                  [
                    39100,
                    32736.1
                  ],
                  [
                    38991.5,
                    32765.1
                  ],
                  [
                    38902,
                    32823.2
                  ],
                  [
                    38873,
                    32992.9
                  ]
                ],
                "id": 1030,
                "chat_link": "[&BAYEAAA=]"
              },
              "1103": {
                "name": "Proxemics Lab",
                "level": 23,
                "coord": [
                  38832.7,
                  31231.7
                ],
                "bounds": [
                  [
                    38991.6,
                    30957.7
                  ],
                  [
                    39004.8,
                    31333.4
                  ],
                  [
                    38897.9,
                    31529.6
                  ],
                  [
                    38851.4,
                    31731
                  ],
                  [
                    38641.2,
                    31697
                  ],
                  [
                    38648.6,
                    30835.6
                  ],
                  [
                    38779.8,
                    30840.3
                  ],
                  [
                    38846,
                    30928.9
                  ],
                  [
                    38991.6,
                    30957.7
                  ]
                ],
                "id": 1103,
                "chat_link": "[&BE8EAAA=]"
              },
              "1185": {
                "name": "Tangle Root",
                "level": 26,
                "coord": [
                  38862.9,
                  33354.3
                ],
                "bounds": [
                  [
                    38660.3,
                    33478.7
                  ],
                  [
                    38664.6,
                    33073.2
                  ],
                  [
                    39018.8,
                    33259.8
                  ],
                  [
                    39007.2,
                    33340.2
                  ],
                  [
                    39041.8,
                    33439.8
                  ],
                  [
                    38784.8,
                    33534.3
                  ],
                  [
                    38660.3,
                    33478.7
                  ]
                ],
                "id": 1185,
                "chat_link": "[&BKEEAAA=]"
              }
            },
            "id": 1075,
            "mastery_points": [],
            "adventures": []
          },
          "1087": {
            "name": "Proxemics Lab",
            "min_level": 15,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "122": {
                "name": "Koga Ruins",
                "level": 24,
                "coord": [
                  40224.2,
                  33097.3
                ],
                "bounds": [
                  [
                    40403.2,
                    32719.6
                  ],
                  [
                    40167,
                    32604.7
                  ],
                  [
                    39673,
                    32918.7
                  ],
                  [
                    39958.2,
                    33293.9
                  ],
                  [
                    39995.1,
                    33536.5
                  ],
                  [
                    40388.4,
                    33538.9
                  ],
                  [
                    40387.2,
                    33346.2
                  ],
                  [
                    40555.1,
                    32977.6
                  ],
                  [
                    40490.7,
                    32939.9
                  ],
                  [
                    40403.2,
                    32719.6
                  ]
                ],
                "id": 122,
                "chat_link": "[&BHoAAAA=]"
              },
              "123": {
                "name": "The Wendon Steps",
                "level": 19,
                "coord": [
                  41781.1,
                  31268.7
                ],
                "bounds": [
                  [
                    41628.3,
                    31879.3
                  ],
                  [
                    41436.3,
                    31544.2
                  ],
                  [
                    41294.5,
                    31539.8
                  ],
                  [
                    41412.9,
                    30921.2
                  ],
                  [
                    41568.6,
                    30902.5
                  ],
                  [
                    41759.5,
                    30910.8
                  ],
                  [
                    42112.9,
                    30816.2
                  ],
                  [
                    42161.1,
                    30946.1
                  ],
                  [
                    42128.5,
                    31211.5
                  ],
                  [
                    42195.1,
                    31619.6
                  ],
                  [
                    41894,
                    31664.9
                  ],
                  [
                    41628.3,
                    31879.3
                  ]
                ],
                "id": 123,
                "chat_link": "[&BHsAAAA=]"
              },
              "124": {
                "name": "Highwayman's Vale",
                "level": 23,
                "coord": [
                  39560.4,
                  32117.4
                ],
                "bounds": [
                  [
                    39656.3,
                    32494.1
                  ],
                  [
                    39928.8,
                    32273.8
                  ],
                  [
                    39760,
                    32046
                  ],
                  [
                    39787.9,
                    31767.4
                  ],
                  [
                    39584.3,
                    31679.8
                  ],
                  [
                    39301,
                    31904.6
                  ],
                  [
                    39413.4,
                    32081.3
                  ],
                  [
                    39386.1,
                    32281.3
                  ],
                  [
                    39226.2,
                    32528.5
                  ],
                  [
                    39656.3,
                    32494.1
                  ]
                ],
                "id": 124,
                "chat_link": "[&BHwAAAA=]"
              },
              "125": {
                "name": "Gnashar's Hills",
                "level": 21,
                "coord": [
                  40936.9,
                  31376.5
                ],
                "bounds": [
                  [
                    40456.7,
                    31917.9
                  ],
                  [
                    40539.8,
                    31982.4
                  ],
                  [
                    40843.9,
                    31600.1
                  ],
                  [
                    40868.1,
                    31542.4
                  ],
                  [
                    41061.8,
                    31427.6
                  ],
                  [
                    41116.5,
                    31466.9
                  ],
                  [
                    41164,
                    31527.1
                  ],
                  [
                    41296.9,
                    31540.7
                  ],
                  [
                    41418.2,
                    30890.4
                  ],
                  [
                    41269.1,
                    30994.8
                  ],
                  [
                    41054,
                    30989.7
                  ],
                  [
                    40928.6,
                    31059
                  ],
                  [
                    40678.4,
                    30971.6
                  ],
                  [
                    40420.1,
                    31360.7
                  ],
                  [
                    40456.7,
                    31917.9
                  ]
                ],
                "id": 125,
                "chat_link": "[&BH0AAAA=]"
              },
              "126": {
                "name": "The Gallowfields",
                "level": 23,
                "coord": [
                  39135.6,
                  31439.6
                ],
                "bounds": [
                  [
                    38922.3,
                    31851.6
                  ],
                  [
                    38850.2,
                    31737.3
                  ],
                  [
                    38897.9,
                    31525.8
                  ],
                  [
                    39002.7,
                    31332.3
                  ],
                  [
                    38991,
                    31071.2
                  ],
                  [
                    39102.5,
                    31037.3
                  ],
                  [
                    39208.5,
                    31118.6
                  ],
                  [
                    39196.3,
                    31236.6
                  ],
                  [
                    39432.6,
                    31339.8
                  ],
                  [
                    39586,
                    31678.6
                  ],
                  [
                    39302.1,
                    31906.3
                  ],
                  [
                    38922.3,
                    31851.6
                  ]
                ],
                "id": 126,
                "chat_link": "[&BH4AAAA=]"
              },
              "127": {
                "name": "Lionshead Outcrops",
                "level": 22,
                "coord": [
                  39678.9,
                  31258
                ],
                "bounds": [
                  [
                    40073.4,
                    31546
                  ],
                  [
                    39962,
                    31252.3
                  ],
                  [
                    39765.9,
                    31190.6
                  ],
                  [
                    39836.1,
                    30918.3
                  ],
                  [
                    39788.8,
                    30851.3
                  ],
                  [
                    39666.7,
                    30854
                  ],
                  [
                    39526.4,
                    30935
                  ],
                  [
                    39209.9,
                    31119
                  ],
                  [
                    39196.3,
                    31236.5
                  ],
                  [
                    39427.9,
                    31339.8
                  ],
                  [
                    39582.8,
                    31679.3
                  ],
                  [
                    39786.2,
                    31769.9
                  ],
                  [
                    40003,
                    31662.5
                  ],
                  [
                    40073.4,
                    31546
                  ]
                ],
                "id": 127,
                "chat_link": "[&BH8AAAA=]"
              },
              "128": {
                "name": "Vandal's Claim",
                "level": 23,
                "coord": [
                  38957.5,
                  32142
                ],
                "bounds": [
                  [
                    38995.7,
                    32630.3
                  ],
                  [
                    38606.3,
                    32525
                  ],
                  [
                    38591,
                    32231.4
                  ],
                  [
                    38589,
                    32100.9
                  ],
                  [
                    38643.6,
                    31690.7
                  ],
                  [
                    38850,
                    31731.8
                  ],
                  [
                    38925.4,
                    31851.3
                  ],
                  [
                    39299.2,
                    31905.1
                  ],
                  [
                    39414.4,
                    32083.3
                  ],
                  [
                    39388.7,
                    32280.5
                  ],
                  [
                    39228.8,
                    32531.8
                  ],
                  [
                    38995.7,
                    32630.3
                  ]
                ],
                "id": 128,
                "chat_link": "[&BIAAAAA=]"
              },
              "129": {
                "name": "Karston Chambers",
                "level": 17,
                "coord": [
                  41884,
                  33223.8
                ],
                "bounds": [
                  [
                    42178.2,
                    33347.1
                  ],
                  [
                    42114.5,
                    33092.8
                  ],
                  [
                    42135.2,
                    32770.7
                  ],
                  [
                    41828,
                    32836.9
                  ],
                  [
                    41481.6,
                    33207.6
                  ],
                  [
                    41644.1,
                    33442.8
                  ],
                  [
                    41606.3,
                    33550.6
                  ],
                  [
                    42084,
                    33541.7
                  ],
                  [
                    42178.2,
                    33347.1
                  ]
                ],
                "id": 129,
                "chat_link": "[&BIEAAAA=]"
              },
              "130": {
                "name": "Brilitine Swath",
                "level": 22,
                "coord": [
                  40173.1,
                  31913.1
                ],
                "bounds": [
                  [
                    40004.9,
                    31661.6
                  ],
                  [
                    40069.4,
                    31549.3
                  ],
                  [
                    40440.4,
                    31500.5
                  ],
                  [
                    40459.1,
                    31916.1
                  ],
                  [
                    40536.6,
                    31984.7
                  ],
                  [
                    40339.3,
                    32191.8
                  ],
                  [
                    40167.8,
                    32600.9
                  ],
                  [
                    39760,
                    32047.8
                  ],
                  [
                    39780.5,
                    31765.3
                  ],
                  [
                    40004.9,
                    31661.6
                  ]
                ],
                "id": 130,
                "chat_link": "[&BIIAAAA=]"
              },
              "131": {
                "name": "Gotala Cascade",
                "level": 23,
                "coord": [
                  40476,
                  32400.7
                ],
                "bounds": [
                  [
                    40541.2,
                    31974.3
                  ],
                  [
                    40338.3,
                    32191.9
                  ],
                  [
                    40162.7,
                    32607.3
                  ],
                  [
                    40400.4,
                    32723.7
                  ],
                  [
                    40781.8,
                    32622.1
                  ],
                  [
                    40631.9,
                    32284.9
                  ],
                  [
                    40541.2,
                    31974.3
                  ]
                ],
                "id": 131,
                "chat_link": "[&BIMAAAA=]"
              },
              "132": {
                "name": "Hidden Lake",
                "level": 21,
                "coord": [
                  40165.7,
                  31206.9
                ],
                "bounds": [
                  [
                    40440.4,
                    31500.2
                  ],
                  [
                    40075,
                    31547
                  ],
                  [
                    39962.4,
                    31252.2
                  ],
                  [
                    39766.4,
                    31191
                  ],
                  [
                    39836.1,
                    30918.5
                  ],
                  [
                    40130.9,
                    30900.1
                  ],
                  [
                    40686.7,
                    30984
                  ],
                  [
                    40428,
                    31361.8
                  ],
                  [
                    40440.4,
                    31500.2
                  ]
                ],
                "id": 132,
                "chat_link": "[&BIQAAAA=]"
              },
              "133": {
                "name": "Venlin Vale",
                "level": 16,
                "coord": [
                  40883.2,
                  33161.9
                ],
                "bounds": [
                  [
                    40781.7,
                    32620.8
                  ],
                  [
                    40926.1,
                    32757.6
                  ],
                  [
                    41194.4,
                    32858.9
                  ],
                  [
                    41273.5,
                    32847.7
                  ],
                  [
                    41642.7,
                    33432.2
                  ],
                  [
                    41606.8,
                    33552.3
                  ],
                  [
                    41152.7,
                    33576.8
                  ],
                  [
                    40807.1,
                    33535.1
                  ],
                  [
                    40766.1,
                    33570.1
                  ],
                  [
                    40390.1,
                    33538
                  ],
                  [
                    40387.6,
                    33339
                  ],
                  [
                    40550.8,
                    32978.2
                  ],
                  [
                    40485.6,
                    32940.4
                  ],
                  [
                    40399.6,
                    32719.8
                  ],
                  [
                    40781.7,
                    32620.8
                  ]
                ],
                "id": 133,
                "chat_link": "[&BIUAAAA=]"
              },
              "134": {
                "name": "Zinder Slope",
                "level": 16,
                "coord": [
                  41789.3,
                  32735.5
                ],
                "bounds": [
                  [
                    41832.8,
                    32837
                  ],
                  [
                    42135.3,
                    32772.7
                  ],
                  [
                    42165.5,
                    32560
                  ],
                  [
                    42113.4,
                    32491.5
                  ],
                  [
                    41964.7,
                    32560.6
                  ],
                  [
                    41619.9,
                    32557.8
                  ],
                  [
                    41512.3,
                    32782.1
                  ],
                  [
                    41268.9,
                    32845.5
                  ],
                  [
                    41490.9,
                    33212.4
                  ],
                  [
                    41832.8,
                    32837
                  ]
                ],
                "id": 134,
                "chat_link": "[&BIYAAAA=]"
              },
              "135": {
                "name": "Skrittsburgh Center",
                "level": 20,
                "coord": [
                  40859.4,
                  32017.5
                ],
                "bounds": [
                  [
                    41088.7,
                    31937.1
                  ],
                  [
                    41047.5,
                    31809.1
                  ],
                  [
                    40841.3,
                    31597.9
                  ],
                  [
                    40721.1,
                    31767
                  ],
                  [
                    40651.8,
                    31837.1
                  ],
                  [
                    40532.7,
                    31984.1
                  ],
                  [
                    40628.7,
                    32298
                  ],
                  [
                    40764.3,
                    32222.4
                  ],
                  [
                    40890.8,
                    32299.6
                  ],
                  [
                    41067,
                    32306.6
                  ],
                  [
                    41219.4,
                    32134
                  ],
                  [
                    41088.7,
                    31937.1
                  ]
                ],
                "id": 135,
                "chat_link": "[&BIcAAAA=]"
              },
              "136": {
                "name": "Skrittsburgh East End",
                "level": 19,
                "coord": [
                  41199.2,
                  31748.9
                ],
                "bounds": [
                  [
                    41218.4,
                    32134.6
                  ],
                  [
                    41086.4,
                    31936.3
                  ],
                  [
                    41047.4,
                    31811.4
                  ],
                  [
                    40839.7,
                    31598.3
                  ],
                  [
                    40863.9,
                    31541
                  ],
                  [
                    41061.7,
                    31423.2
                  ],
                  [
                    41120.2,
                    31465.8
                  ],
                  [
                    41164.8,
                    31524.9
                  ],
                  [
                    41437.2,
                    31543.6
                  ],
                  [
                    41627.6,
                    31880
                  ],
                  [
                    41477.8,
                    31968.2
                  ],
                  [
                    41445.5,
                    32159.4
                  ],
                  [
                    41218.4,
                    32134.6
                  ]
                ],
                "id": 136,
                "chat_link": "[&BIgAAAA=]"
              },
              "137": {
                "name": "Skrittsburgh Tunnels",
                "level": 17,
                "coord": [
                  40989.5,
                  32529.9
                ],
                "bounds": [
                  [
                    40922.5,
                    32759.1
                  ],
                  [
                    40781.4,
                    32631.3
                  ],
                  [
                    40634.8,
                    32290.7
                  ],
                  [
                    40763,
                    32217.5
                  ],
                  [
                    40890.4,
                    32298
                  ],
                  [
                    41062.5,
                    32304.1
                  ],
                  [
                    41291.1,
                    32570.1
                  ],
                  [
                    41354.2,
                    32836.3
                  ],
                  [
                    41205.3,
                    32861.9
                  ],
                  [
                    40922.5,
                    32759.1
                  ]
                ],
                "id": 137,
                "chat_link": "[&BIkAAAA=]"
              },
              "138": {
                "name": "Skrittsburgh Hillstead",
                "level": 18,
                "coord": [
                  41378.6,
                  32443.8
                ],
                "bounds": [
                  [
                    41444,
                    32159.3
                  ],
                  [
                    41216.8,
                    32132.9
                  ],
                  [
                    41060.8,
                    32304.5
                  ],
                  [
                    41290.1,
                    32570.5
                  ],
                  [
                    41355.1,
                    32837
                  ],
                  [
                    41514.4,
                    32782.2
                  ],
                  [
                    41623.8,
                    32559.6
                  ],
                  [
                    41523.7,
                    32204.6
                  ],
                  [
                    41444,
                    32159.3
                  ]
                ],
                "id": 138,
                "chat_link": "[&BIoAAAA=]"
              },
              "140": {
                "name": "The Shattered Henge",
                "level": 25,
                "coord": [
                  39603.7,
                  33211.1
                ],
                "bounds": [
                  [
                    39522.9,
                    32845.1
                  ],
                  [
                    39372.3,
                    32835.7
                  ],
                  [
                    39342,
                    33090.2
                  ],
                  [
                    39423.2,
                    33239.2
                  ],
                  [
                    39374.2,
                    33463.8
                  ],
                  [
                    39521,
                    33500.3
                  ],
                  [
                    39865.8,
                    33488
                  ],
                  [
                    39983.9,
                    33438.9
                  ],
                  [
                    39956.8,
                    33292.1
                  ],
                  [
                    39674.7,
                    32918
                  ],
                  [
                    39522.9,
                    32845.1
                  ]
                ],
                "id": 140,
                "chat_link": "[&BIwAAAA=]"
              },
              "141": {
                "name": "Duskstruck Moors",
                "level": 24,
                "coord": [
                  39544.2,
                  32639.6
                ],
                "bounds": [
                  [
                    39521.7,
                    32847
                  ],
                  [
                    39671.3,
                    32919.2
                  ],
                  [
                    40171,
                    32603.6
                  ],
                  [
                    39935,
                    32268.7
                  ],
                  [
                    39654.9,
                    32495.1
                  ],
                  [
                    39219.9,
                    32525.5
                  ],
                  [
                    38994.4,
                    32627.4
                  ],
                  [
                    39185.7,
                    32830.7
                  ],
                  [
                    39521.7,
                    32847
                  ]
                ],
                "id": 141,
                "chat_link": "[&BI0AAAA=]"
              },
              "142": {
                "name": "Toxal Bog",
                "level": 25,
                "coord": [
                  39135.4,
                  33101.3
                ],
                "bounds": [
                  [
                    39187.9,
                    32826.3
                  ],
                  [
                    39100.5,
                    32736.8
                  ],
                  [
                    38990,
                    32764.1
                  ],
                  [
                    38902,
                    32823.1
                  ],
                  [
                    38872.4,
                    32993.2
                  ],
                  [
                    39059.6,
                    33124.5
                  ],
                  [
                    39019.4,
                    33257.9
                  ],
                  [
                    39007.3,
                    33339.8
                  ],
                  [
                    39041.4,
                    33439.2
                  ],
                  [
                    39194.5,
                    33492.8
                  ],
                  [
                    39380.5,
                    33449.6
                  ],
                  [
                    39423.4,
                    33237.8
                  ],
                  [
                    39342.2,
                    33094.4
                  ],
                  [
                    39374.6,
                    32839
                  ],
                  [
                    39187.9,
                    32826.3
                  ]
                ],
                "id": 142,
                "chat_link": "[&BI4AAAA=]"
              },
              "143": {
                "name": "Nemeton Grove",
                "level": 17,
                "coord": [
                  41798,
                  32117.7
                ],
                "bounds": [
                  [
                    42113.4,
                    32492.5
                  ],
                  [
                    41965.3,
                    32569.8
                  ],
                  [
                    41621.3,
                    32560.5
                  ],
                  [
                    41525.8,
                    32203.1
                  ],
                  [
                    41443,
                    32158.7
                  ],
                  [
                    41478.2,
                    31968.9
                  ],
                  [
                    41625.6,
                    31880.9
                  ],
                  [
                    41891,
                    31666.3
                  ],
                  [
                    42193.6,
                    31618.9
                  ],
                  [
                    42123.1,
                    32057.6
                  ],
                  [
                    42113.4,
                    32492.5
                  ]
                ],
                "id": 143,
                "chat_link": "[&BI8AAAA=]"
              },
              "1030": {
                "name": "Aurora's Remains",
                "level": 26,
                "coord": [
                  38882.2,
                  32864.9
                ],
                "bounds": [
                  [
                    38873,
                    32992.9
                  ],
                  [
                    39058.6,
                    33124.6
                  ],
                  [
                    39019.2,
                    33259.2
                  ],
                  [
                    38663.1,
                    33072.5
                  ],
                  [
                    38610.7,
                    32723.8
                  ],
                  [
                    38607.3,
                    32526.2
                  ],
                  [
                    38996.2,
                    32625.7
                  ],
                  [
                    39100,
                    32736.1
                  ],
                  [
                    38991.5,
                    32765.1
                  ],
                  [
                    38902,
                    32823.2
                  ],
                  [
                    38873,
                    32992.9
                  ]
                ],
                "id": 1030,
                "chat_link": "[&BAYEAAA=]"
              },
              "1103": {
                "name": "Proxemics Lab",
                "level": 23,
                "coord": [
                  38832.7,
                  31231.7
                ],
                "bounds": [
                  [
                    38991.6,
                    30957.7
                  ],
                  [
                    39004.8,
                    31333.4
                  ],
                  [
                    38897.9,
                    31529.6
                  ],
                  [
                    38851.4,
                    31731
                  ],
                  [
                    38641.2,
                    31697
                  ],
                  [
                    38648.6,
                    30835.6
                  ],
                  [
                    38779.8,
                    30840.3
                  ],
                  [
                    38846,
                    30928.9
                  ],
                  [
                    38991.6,
                    30957.7
                  ]
                ],
                "id": 1103,
                "chat_link": "[&BE8EAAA=]"
              },
              "1185": {
                "name": "Tangle Root",
                "level": 26,
                "coord": [
                  38862.9,
                  33354.3
                ],
                "bounds": [
                  [
                    38660.3,
                    33478.7
                  ],
                  [
                    38664.6,
                    33073.2
                  ],
                  [
                    39018.8,
                    33259.8
                  ],
                  [
                    39007.2,
                    33340.2
                  ],
                  [
                    39041.8,
                    33439.8
                  ],
                  [
                    38784.8,
                    33534.3
                  ],
                  [
                    38660.3,
                    33478.7
                  ]
                ],
                "id": 1185,
                "chat_link": "[&BKEEAAA=]"
              }
            },
            "id": 1087,
            "mastery_points": [],
            "adventures": []
          },
          "1097": {
            "name": "Proxemics Lab",
            "min_level": 15,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "122": {
                "name": "Koga Ruins",
                "level": 24,
                "coord": [
                  40224.2,
                  33097.3
                ],
                "bounds": [
                  [
                    40403.2,
                    32719.6
                  ],
                  [
                    40167,
                    32604.7
                  ],
                  [
                    39673,
                    32918.7
                  ],
                  [
                    39958.2,
                    33293.9
                  ],
                  [
                    39995.1,
                    33536.5
                  ],
                  [
                    40388.4,
                    33538.9
                  ],
                  [
                    40387.2,
                    33346.2
                  ],
                  [
                    40555.1,
                    32977.6
                  ],
                  [
                    40490.7,
                    32939.9
                  ],
                  [
                    40403.2,
                    32719.6
                  ]
                ],
                "id": 122,
                "chat_link": "[&BHoAAAA=]"
              },
              "123": {
                "name": "The Wendon Steps",
                "level": 19,
                "coord": [
                  41781.1,
                  31268.7
                ],
                "bounds": [
                  [
                    41628.3,
                    31879.3
                  ],
                  [
                    41436.3,
                    31544.2
                  ],
                  [
                    41294.5,
                    31539.8
                  ],
                  [
                    41412.9,
                    30921.2
                  ],
                  [
                    41568.6,
                    30902.5
                  ],
                  [
                    41759.5,
                    30910.8
                  ],
                  [
                    42112.9,
                    30816.2
                  ],
                  [
                    42161.1,
                    30946.1
                  ],
                  [
                    42128.5,
                    31211.5
                  ],
                  [
                    42195.1,
                    31619.6
                  ],
                  [
                    41894,
                    31664.9
                  ],
                  [
                    41628.3,
                    31879.3
                  ]
                ],
                "id": 123,
                "chat_link": "[&BHsAAAA=]"
              },
              "124": {
                "name": "Highwayman's Vale",
                "level": 23,
                "coord": [
                  39560.4,
                  32117.4
                ],
                "bounds": [
                  [
                    39656.3,
                    32494.1
                  ],
                  [
                    39928.8,
                    32273.8
                  ],
                  [
                    39760,
                    32046
                  ],
                  [
                    39787.9,
                    31767.4
                  ],
                  [
                    39584.3,
                    31679.8
                  ],
                  [
                    39301,
                    31904.6
                  ],
                  [
                    39413.4,
                    32081.3
                  ],
                  [
                    39386.1,
                    32281.3
                  ],
                  [
                    39226.2,
                    32528.5
                  ],
                  [
                    39656.3,
                    32494.1
                  ]
                ],
                "id": 124,
                "chat_link": "[&BHwAAAA=]"
              },
              "125": {
                "name": "Gnashar's Hills",
                "level": 21,
                "coord": [
                  40936.9,
                  31376.5
                ],
                "bounds": [
                  [
                    40456.7,
                    31917.9
                  ],
                  [
                    40539.8,
                    31982.4
                  ],
                  [
                    40843.9,
                    31600.1
                  ],
                  [
                    40868.1,
                    31542.4
                  ],
                  [
                    41061.8,
                    31427.6
                  ],
                  [
                    41116.5,
                    31466.9
                  ],
                  [
                    41164,
                    31527.1
                  ],
                  [
                    41296.9,
                    31540.7
                  ],
                  [
                    41418.2,
                    30890.4
                  ],
                  [
                    41269.1,
                    30994.8
                  ],
                  [
                    41054,
                    30989.7
                  ],
                  [
                    40928.6,
                    31059
                  ],
                  [
                    40678.4,
                    30971.6
                  ],
                  [
                    40420.1,
                    31360.7
                  ],
                  [
                    40456.7,
                    31917.9
                  ]
                ],
                "id": 125,
                "chat_link": "[&BH0AAAA=]"
              },
              "126": {
                "name": "The Gallowfields",
                "level": 23,
                "coord": [
                  39135.6,
                  31439.6
                ],
                "bounds": [
                  [
                    38922.3,
                    31851.6
                  ],
                  [
                    38850.2,
                    31737.3
                  ],
                  [
                    38897.9,
                    31525.8
                  ],
                  [
                    39002.7,
                    31332.3
                  ],
                  [
                    38991,
                    31071.2
                  ],
                  [
                    39102.5,
                    31037.3
                  ],
                  [
                    39208.5,
                    31118.6
                  ],
                  [
                    39196.3,
                    31236.6
                  ],
                  [
                    39432.6,
                    31339.8
                  ],
                  [
                    39586,
                    31678.6
                  ],
                  [
                    39302.1,
                    31906.3
                  ],
                  [
                    38922.3,
                    31851.6
                  ]
                ],
                "id": 126,
                "chat_link": "[&BH4AAAA=]"
              },
              "127": {
                "name": "Lionshead Outcrops",
                "level": 22,
                "coord": [
                  39678.9,
                  31258
                ],
                "bounds": [
                  [
                    40073.4,
                    31546
                  ],
                  [
                    39962,
                    31252.3
                  ],
                  [
                    39765.9,
                    31190.6
                  ],
                  [
                    39836.1,
                    30918.3
                  ],
                  [
                    39788.8,
                    30851.3
                  ],
                  [
                    39666.7,
                    30854
                  ],
                  [
                    39526.4,
                    30935
                  ],
                  [
                    39209.9,
                    31119
                  ],
                  [
                    39196.3,
                    31236.5
                  ],
                  [
                    39427.9,
                    31339.8
                  ],
                  [
                    39582.8,
                    31679.3
                  ],
                  [
                    39786.2,
                    31769.9
                  ],
                  [
                    40003,
                    31662.5
                  ],
                  [
                    40073.4,
                    31546
                  ]
                ],
                "id": 127,
                "chat_link": "[&BH8AAAA=]"
              },
              "128": {
                "name": "Vandal's Claim",
                "level": 23,
                "coord": [
                  38957.5,
                  32142
                ],
                "bounds": [
                  [
                    38995.7,
                    32630.3
                  ],
                  [
                    38606.3,
                    32525
                  ],
                  [
                    38591,
                    32231.4
                  ],
                  [
                    38589,
                    32100.9
                  ],
                  [
                    38643.6,
                    31690.7
                  ],
                  [
                    38850,
                    31731.8
                  ],
                  [
                    38925.4,
                    31851.3
                  ],
                  [
                    39299.2,
                    31905.1
                  ],
                  [
                    39414.4,
                    32083.3
                  ],
                  [
                    39388.7,
                    32280.5
                  ],
                  [
                    39228.8,
                    32531.8
                  ],
                  [
                    38995.7,
                    32630.3
                  ]
                ],
                "id": 128,
                "chat_link": "[&BIAAAAA=]"
              },
              "129": {
                "name": "Karston Chambers",
                "level": 17,
                "coord": [
                  41884,
                  33223.8
                ],
                "bounds": [
                  [
                    42178.2,
                    33347.1
                  ],
                  [
                    42114.5,
                    33092.8
                  ],
                  [
                    42135.2,
                    32770.7
                  ],
                  [
                    41828,
                    32836.9
                  ],
                  [
                    41481.6,
                    33207.6
                  ],
                  [
                    41644.1,
                    33442.8
                  ],
                  [
                    41606.3,
                    33550.6
                  ],
                  [
                    42084,
                    33541.7
                  ],
                  [
                    42178.2,
                    33347.1
                  ]
                ],
                "id": 129,
                "chat_link": "[&BIEAAAA=]"
              },
              "130": {
                "name": "Brilitine Swath",
                "level": 22,
                "coord": [
                  40173.1,
                  31913.1
                ],
                "bounds": [
                  [
                    40004.9,
                    31661.6
                  ],
                  [
                    40069.4,
                    31549.3
                  ],
                  [
                    40440.4,
                    31500.5
                  ],
                  [
                    40459.1,
                    31916.1
                  ],
                  [
                    40536.6,
                    31984.7
                  ],
                  [
                    40339.3,
                    32191.8
                  ],
                  [
                    40167.8,
                    32600.9
                  ],
                  [
                    39760,
                    32047.8
                  ],
                  [
                    39780.5,
                    31765.3
                  ],
                  [
                    40004.9,
                    31661.6
                  ]
                ],
                "id": 130,
                "chat_link": "[&BIIAAAA=]"
              },
              "131": {
                "name": "Gotala Cascade",
                "level": 23,
                "coord": [
                  40476,
                  32400.7
                ],
                "bounds": [
                  [
                    40541.2,
                    31974.3
                  ],
                  [
                    40338.3,
                    32191.9
                  ],
                  [
                    40162.7,
                    32607.3
                  ],
                  [
                    40400.4,
                    32723.7
                  ],
                  [
                    40781.8,
                    32622.1
                  ],
                  [
                    40631.9,
                    32284.9
                  ],
                  [
                    40541.2,
                    31974.3
                  ]
                ],
                "id": 131,
                "chat_link": "[&BIMAAAA=]"
              },
              "132": {
                "name": "Hidden Lake",
                "level": 21,
                "coord": [
                  40165.7,
                  31206.9
                ],
                "bounds": [
                  [
                    40440.4,
                    31500.2
                  ],
                  [
                    40075,
                    31547
                  ],
                  [
                    39962.4,
                    31252.2
                  ],
                  [
                    39766.4,
                    31191
                  ],
                  [
                    39836.1,
                    30918.5
                  ],
                  [
                    40130.9,
                    30900.1
                  ],
                  [
                    40686.7,
                    30984
                  ],
                  [
                    40428,
                    31361.8
                  ],
                  [
                    40440.4,
                    31500.2
                  ]
                ],
                "id": 132,
                "chat_link": "[&BIQAAAA=]"
              },
              "133": {
                "name": "Venlin Vale",
                "level": 16,
                "coord": [
                  40883.2,
                  33161.9
                ],
                "bounds": [
                  [
                    40781.7,
                    32620.8
                  ],
                  [
                    40926.1,
                    32757.6
                  ],
                  [
                    41194.4,
                    32858.9
                  ],
                  [
                    41273.5,
                    32847.7
                  ],
                  [
                    41642.7,
                    33432.2
                  ],
                  [
                    41606.8,
                    33552.3
                  ],
                  [
                    41152.7,
                    33576.8
                  ],
                  [
                    40807.1,
                    33535.1
                  ],
                  [
                    40766.1,
                    33570.1
                  ],
                  [
                    40390.1,
                    33538
                  ],
                  [
                    40387.6,
                    33339
                  ],
                  [
                    40550.8,
                    32978.2
                  ],
                  [
                    40485.6,
                    32940.4
                  ],
                  [
                    40399.6,
                    32719.8
                  ],
                  [
                    40781.7,
                    32620.8
                  ]
                ],
                "id": 133,
                "chat_link": "[&BIUAAAA=]"
              },
              "134": {
                "name": "Zinder Slope",
                "level": 16,
                "coord": [
                  41789.3,
                  32735.5
                ],
                "bounds": [
                  [
                    41832.8,
                    32837
                  ],
                  [
                    42135.3,
                    32772.7
                  ],
                  [
                    42165.5,
                    32560
                  ],
                  [
                    42113.4,
                    32491.5
                  ],
                  [
                    41964.7,
                    32560.6
                  ],
                  [
                    41619.9,
                    32557.8
                  ],
                  [
                    41512.3,
                    32782.1
                  ],
                  [
                    41268.9,
                    32845.5
                  ],
                  [
                    41490.9,
                    33212.4
                  ],
                  [
                    41832.8,
                    32837
                  ]
                ],
                "id": 134,
                "chat_link": "[&BIYAAAA=]"
              },
              "135": {
                "name": "Skrittsburgh Center",
                "level": 20,
                "coord": [
                  40859.4,
                  32017.5
                ],
                "bounds": [
                  [
                    41088.7,
                    31937.1
                  ],
                  [
                    41047.5,
                    31809.1
                  ],
                  [
                    40841.3,
                    31597.9
                  ],
                  [
                    40721.1,
                    31767
                  ],
                  [
                    40651.8,
                    31837.1
                  ],
                  [
                    40532.7,
                    31984.1
                  ],
                  [
                    40628.7,
                    32298
                  ],
                  [
                    40764.3,
                    32222.4
                  ],
                  [
                    40890.8,
                    32299.6
                  ],
                  [
                    41067,
                    32306.6
                  ],
                  [
                    41219.4,
                    32134
                  ],
                  [
                    41088.7,
                    31937.1
                  ]
                ],
                "id": 135,
                "chat_link": "[&BIcAAAA=]"
              },
              "136": {
                "name": "Skrittsburgh East End",
                "level": 19,
                "coord": [
                  41199.2,
                  31748.9
                ],
                "bounds": [
                  [
                    41218.4,
                    32134.6
                  ],
                  [
                    41086.4,
                    31936.3
                  ],
                  [
                    41047.4,
                    31811.4
                  ],
                  [
                    40839.7,
                    31598.3
                  ],
                  [
                    40863.9,
                    31541
                  ],
                  [
                    41061.7,
                    31423.2
                  ],
                  [
                    41120.2,
                    31465.8
                  ],
                  [
                    41164.8,
                    31524.9
                  ],
                  [
                    41437.2,
                    31543.6
                  ],
                  [
                    41627.6,
                    31880
                  ],
                  [
                    41477.8,
                    31968.2
                  ],
                  [
                    41445.5,
                    32159.4
                  ],
                  [
                    41218.4,
                    32134.6
                  ]
                ],
                "id": 136,
                "chat_link": "[&BIgAAAA=]"
              },
              "137": {
                "name": "Skrittsburgh Tunnels",
                "level": 17,
                "coord": [
                  40989.5,
                  32529.9
                ],
                "bounds": [
                  [
                    40922.5,
                    32759.1
                  ],
                  [
                    40781.4,
                    32631.3
                  ],
                  [
                    40634.8,
                    32290.7
                  ],
                  [
                    40763,
                    32217.5
                  ],
                  [
                    40890.4,
                    32298
                  ],
                  [
                    41062.5,
                    32304.1
                  ],
                  [
                    41291.1,
                    32570.1
                  ],
                  [
                    41354.2,
                    32836.3
                  ],
                  [
                    41205.3,
                    32861.9
                  ],
                  [
                    40922.5,
                    32759.1
                  ]
                ],
                "id": 137,
                "chat_link": "[&BIkAAAA=]"
              },
              "138": {
                "name": "Skrittsburgh Hillstead",
                "level": 18,
                "coord": [
                  41378.6,
                  32443.8
                ],
                "bounds": [
                  [
                    41444,
                    32159.3
                  ],
                  [
                    41216.8,
                    32132.9
                  ],
                  [
                    41060.8,
                    32304.5
                  ],
                  [
                    41290.1,
                    32570.5
                  ],
                  [
                    41355.1,
                    32837
                  ],
                  [
                    41514.4,
                    32782.2
                  ],
                  [
                    41623.8,
                    32559.6
                  ],
                  [
                    41523.7,
                    32204.6
                  ],
                  [
                    41444,
                    32159.3
                  ]
                ],
                "id": 138,
                "chat_link": "[&BIoAAAA=]"
              },
              "140": {
                "name": "The Shattered Henge",
                "level": 25,
                "coord": [
                  39603.7,
                  33211.1
                ],
                "bounds": [
                  [
                    39522.9,
                    32845.1
                  ],
                  [
                    39372.3,
                    32835.7
                  ],
                  [
                    39342,
                    33090.2
                  ],
                  [
                    39423.2,
                    33239.2
                  ],
                  [
                    39374.2,
                    33463.8
                  ],
                  [
                    39521,
                    33500.3
                  ],
                  [
                    39865.8,
                    33488
                  ],
                  [
                    39983.9,
                    33438.9
                  ],
                  [
                    39956.8,
                    33292.1
                  ],
                  [
                    39674.7,
                    32918
                  ],
                  [
                    39522.9,
                    32845.1
                  ]
                ],
                "id": 140,
                "chat_link": "[&BIwAAAA=]"
              },
              "141": {
                "name": "Duskstruck Moors",
                "level": 24,
                "coord": [
                  39544.2,
                  32639.6
                ],
                "bounds": [
                  [
                    39521.7,
                    32847
                  ],
                  [
                    39671.3,
                    32919.2
                  ],
                  [
                    40171,
                    32603.6
                  ],
                  [
                    39935,
                    32268.7
                  ],
                  [
                    39654.9,
                    32495.1
                  ],
                  [
                    39219.9,
                    32525.5
                  ],
                  [
                    38994.4,
                    32627.4
                  ],
                  [
                    39185.7,
                    32830.7
                  ],
                  [
                    39521.7,
                    32847
                  ]
                ],
                "id": 141,
                "chat_link": "[&BI0AAAA=]"
              },
              "142": {
                "name": "Toxal Bog",
                "level": 25,
                "coord": [
                  39135.4,
                  33101.3
                ],
                "bounds": [
                  [
                    39187.9,
                    32826.3
                  ],
                  [
                    39100.5,
                    32736.8
                  ],
                  [
                    38990,
                    32764.1
                  ],
                  [
                    38902,
                    32823.1
                  ],
                  [
                    38872.4,
                    32993.2
                  ],
                  [
                    39059.6,
                    33124.5
                  ],
                  [
                    39019.4,
                    33257.9
                  ],
                  [
                    39007.3,
                    33339.8
                  ],
                  [
                    39041.4,
                    33439.2
                  ],
                  [
                    39194.5,
                    33492.8
                  ],
                  [
                    39380.5,
                    33449.6
                  ],
                  [
                    39423.4,
                    33237.8
                  ],
                  [
                    39342.2,
                    33094.4
                  ],
                  [
                    39374.6,
                    32839
                  ],
                  [
                    39187.9,
                    32826.3
                  ]
                ],
                "id": 142,
                "chat_link": "[&BI4AAAA=]"
              },
              "143": {
                "name": "Nemeton Grove",
                "level": 17,
                "coord": [
                  41798,
                  32117.7
                ],
                "bounds": [
                  [
                    42113.4,
                    32492.5
                  ],
                  [
                    41965.3,
                    32569.8
                  ],
                  [
                    41621.3,
                    32560.5
                  ],
                  [
                    41525.8,
                    32203.1
                  ],
                  [
                    41443,
                    32158.7
                  ],
                  [
                    41478.2,
                    31968.9
                  ],
                  [
                    41625.6,
                    31880.9
                  ],
                  [
                    41891,
                    31666.3
                  ],
                  [
                    42193.6,
                    31618.9
                  ],
                  [
                    42123.1,
                    32057.6
                  ],
                  [
                    42113.4,
                    32492.5
                  ]
                ],
                "id": 143,
                "chat_link": "[&BI8AAAA=]"
              },
              "1030": {
                "name": "Aurora's Remains",
                "level": 26,
                "coord": [
                  38882.2,
                  32864.9
                ],
                "bounds": [
                  [
                    38873,
                    32992.9
                  ],
                  [
                    39058.6,
                    33124.6
                  ],
                  [
                    39019.2,
                    33259.2
                  ],
                  [
                    38663.1,
                    33072.5
                  ],
                  [
                    38610.7,
                    32723.8
                  ],
                  [
                    38607.3,
                    32526.2
                  ],
                  [
                    38996.2,
                    32625.7
                  ],
                  [
                    39100,
                    32736.1
                  ],
                  [
                    38991.5,
                    32765.1
                  ],
                  [
                    38902,
                    32823.2
                  ],
                  [
                    38873,
                    32992.9
                  ]
                ],
                "id": 1030,
                "chat_link": "[&BAYEAAA=]"
              },
              "1103": {
                "name": "Proxemics Lab",
                "level": 23,
                "coord": [
                  38832.7,
                  31231.7
                ],
                "bounds": [
                  [
                    38991.6,
                    30957.7
                  ],
                  [
                    39004.8,
                    31333.4
                  ],
                  [
                    38897.9,
                    31529.6
                  ],
                  [
                    38851.4,
                    31731
                  ],
                  [
                    38641.2,
                    31697
                  ],
                  [
                    38648.6,
                    30835.6
                  ],
                  [
                    38779.8,
                    30840.3
                  ],
                  [
                    38846,
                    30928.9
                  ],
                  [
                    38991.6,
                    30957.7
                  ]
                ],
                "id": 1103,
                "chat_link": "[&BE8EAAA=]"
              },
              "1185": {
                "name": "Tangle Root",
                "level": 26,
                "coord": [
                  38862.9,
                  33354.3
                ],
                "bounds": [
                  [
                    38660.3,
                    33478.7
                  ],
                  [
                    38664.6,
                    33073.2
                  ],
                  [
                    39018.8,
                    33259.8
                  ],
                  [
                    39007.2,
                    33340.2
                  ],
                  [
                    39041.8,
                    33439.8
                  ],
                  [
                    38784.8,
                    33534.3
                  ],
                  [
                    38660.3,
                    33478.7
                  ]
                ],
                "id": 1185,
                "chat_link": "[&BKEEAAA=]"
              }
            },
            "id": 1097,
            "mastery_points": [],
            "adventures": []
          },
          "1136": {
            "name": "Proxemics Lab",
            "min_level": 15,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "122": {
                "name": "Koga Ruins",
                "level": 24,
                "coord": [
                  40224.2,
                  33097.3
                ],
                "bounds": [
                  [
                    40403.2,
                    32719.6
                  ],
                  [
                    40167,
                    32604.7
                  ],
                  [
                    39673,
                    32918.7
                  ],
                  [
                    39958.2,
                    33293.9
                  ],
                  [
                    39995.1,
                    33536.5
                  ],
                  [
                    40388.4,
                    33538.9
                  ],
                  [
                    40387.2,
                    33346.2
                  ],
                  [
                    40555.1,
                    32977.6
                  ],
                  [
                    40490.7,
                    32939.9
                  ],
                  [
                    40403.2,
                    32719.6
                  ]
                ],
                "id": 122,
                "chat_link": "[&BHoAAAA=]"
              },
              "123": {
                "name": "The Wendon Steps",
                "level": 19,
                "coord": [
                  41781.1,
                  31268.7
                ],
                "bounds": [
                  [
                    41628.3,
                    31879.3
                  ],
                  [
                    41436.3,
                    31544.2
                  ],
                  [
                    41294.5,
                    31539.8
                  ],
                  [
                    41412.9,
                    30921.2
                  ],
                  [
                    41568.6,
                    30902.5
                  ],
                  [
                    41759.5,
                    30910.8
                  ],
                  [
                    42112.9,
                    30816.2
                  ],
                  [
                    42161.1,
                    30946.1
                  ],
                  [
                    42128.5,
                    31211.5
                  ],
                  [
                    42195.1,
                    31619.6
                  ],
                  [
                    41894,
                    31664.9
                  ],
                  [
                    41628.3,
                    31879.3
                  ]
                ],
                "id": 123,
                "chat_link": "[&BHsAAAA=]"
              },
              "124": {
                "name": "Highwayman's Vale",
                "level": 23,
                "coord": [
                  39560.4,
                  32117.4
                ],
                "bounds": [
                  [
                    39656.3,
                    32494.1
                  ],
                  [
                    39928.8,
                    32273.8
                  ],
                  [
                    39760,
                    32046
                  ],
                  [
                    39787.9,
                    31767.4
                  ],
                  [
                    39584.3,
                    31679.8
                  ],
                  [
                    39301,
                    31904.6
                  ],
                  [
                    39413.4,
                    32081.3
                  ],
                  [
                    39386.1,
                    32281.3
                  ],
                  [
                    39226.2,
                    32528.5
                  ],
                  [
                    39656.3,
                    32494.1
                  ]
                ],
                "id": 124,
                "chat_link": "[&BHwAAAA=]"
              },
              "125": {
                "name": "Gnashar's Hills",
                "level": 21,
                "coord": [
                  40936.9,
                  31376.5
                ],
                "bounds": [
                  [
                    40456.7,
                    31917.9
                  ],
                  [
                    40539.8,
                    31982.4
                  ],
                  [
                    40843.9,
                    31600.1
                  ],
                  [
                    40868.1,
                    31542.4
                  ],
                  [
                    41061.8,
                    31427.6
                  ],
                  [
                    41116.5,
                    31466.9
                  ],
                  [
                    41164,
                    31527.1
                  ],
                  [
                    41296.9,
                    31540.7
                  ],
                  [
                    41418.2,
                    30890.4
                  ],
                  [
                    41269.1,
                    30994.8
                  ],
                  [
                    41054,
                    30989.7
                  ],
                  [
                    40928.6,
                    31059
                  ],
                  [
                    40678.4,
                    30971.6
                  ],
                  [
                    40420.1,
                    31360.7
                  ],
                  [
                    40456.7,
                    31917.9
                  ]
                ],
                "id": 125,
                "chat_link": "[&BH0AAAA=]"
              },
              "126": {
                "name": "The Gallowfields",
                "level": 23,
                "coord": [
                  39135.6,
                  31439.6
                ],
                "bounds": [
                  [
                    38922.3,
                    31851.6
                  ],
                  [
                    38850.2,
                    31737.3
                  ],
                  [
                    38897.9,
                    31525.8
                  ],
                  [
                    39002.7,
                    31332.3
                  ],
                  [
                    38991,
                    31071.2
                  ],
                  [
                    39102.5,
                    31037.3
                  ],
                  [
                    39208.5,
                    31118.6
                  ],
                  [
                    39196.3,
                    31236.6
                  ],
                  [
                    39432.6,
                    31339.8
                  ],
                  [
                    39586,
                    31678.6
                  ],
                  [
                    39302.1,
                    31906.3
                  ],
                  [
                    38922.3,
                    31851.6
                  ]
                ],
                "id": 126,
                "chat_link": "[&BH4AAAA=]"
              },
              "127": {
                "name": "Lionshead Outcrops",
                "level": 22,
                "coord": [
                  39678.9,
                  31258
                ],
                "bounds": [
                  [
                    40073.4,
                    31546
                  ],
                  [
                    39962,
                    31252.3
                  ],
                  [
                    39765.9,
                    31190.6
                  ],
                  [
                    39836.1,
                    30918.3
                  ],
                  [
                    39788.8,
                    30851.3
                  ],
                  [
                    39666.7,
                    30854
                  ],
                  [
                    39526.4,
                    30935
                  ],
                  [
                    39209.9,
                    31119
                  ],
                  [
                    39196.3,
                    31236.5
                  ],
                  [
                    39427.9,
                    31339.8
                  ],
                  [
                    39582.8,
                    31679.3
                  ],
                  [
                    39786.2,
                    31769.9
                  ],
                  [
                    40003,
                    31662.5
                  ],
                  [
                    40073.4,
                    31546
                  ]
                ],
                "id": 127,
                "chat_link": "[&BH8AAAA=]"
              },
              "128": {
                "name": "Vandal's Claim",
                "level": 23,
                "coord": [
                  38957.5,
                  32142
                ],
                "bounds": [
                  [
                    38995.7,
                    32630.3
                  ],
                  [
                    38606.3,
                    32525
                  ],
                  [
                    38591,
                    32231.4
                  ],
                  [
                    38589,
                    32100.9
                  ],
                  [
                    38643.6,
                    31690.7
                  ],
                  [
                    38850,
                    31731.8
                  ],
                  [
                    38925.4,
                    31851.3
                  ],
                  [
                    39299.2,
                    31905.1
                  ],
                  [
                    39414.4,
                    32083.3
                  ],
                  [
                    39388.7,
                    32280.5
                  ],
                  [
                    39228.8,
                    32531.8
                  ],
                  [
                    38995.7,
                    32630.3
                  ]
                ],
                "id": 128,
                "chat_link": "[&BIAAAAA=]"
              },
              "129": {
                "name": "Karston Chambers",
                "level": 17,
                "coord": [
                  41884,
                  33223.8
                ],
                "bounds": [
                  [
                    42178.2,
                    33347.1
                  ],
                  [
                    42114.5,
                    33092.8
                  ],
                  [
                    42135.2,
                    32770.7
                  ],
                  [
                    41828,
                    32836.9
                  ],
                  [
                    41481.6,
                    33207.6
                  ],
                  [
                    41644.1,
                    33442.8
                  ],
                  [
                    41606.3,
                    33550.6
                  ],
                  [
                    42084,
                    33541.7
                  ],
                  [
                    42178.2,
                    33347.1
                  ]
                ],
                "id": 129,
                "chat_link": "[&BIEAAAA=]"
              },
              "130": {
                "name": "Brilitine Swath",
                "level": 22,
                "coord": [
                  40173.1,
                  31913.1
                ],
                "bounds": [
                  [
                    40004.9,
                    31661.6
                  ],
                  [
                    40069.4,
                    31549.3
                  ],
                  [
                    40440.4,
                    31500.5
                  ],
                  [
                    40459.1,
                    31916.1
                  ],
                  [
                    40536.6,
                    31984.7
                  ],
                  [
                    40339.3,
                    32191.8
                  ],
                  [
                    40167.8,
                    32600.9
                  ],
                  [
                    39760,
                    32047.8
                  ],
                  [
                    39780.5,
                    31765.3
                  ],
                  [
                    40004.9,
                    31661.6
                  ]
                ],
                "id": 130,
                "chat_link": "[&BIIAAAA=]"
              },
              "131": {
                "name": "Gotala Cascade",
                "level": 23,
                "coord": [
                  40476,
                  32400.7
                ],
                "bounds": [
                  [
                    40541.2,
                    31974.3
                  ],
                  [
                    40338.3,
                    32191.9
                  ],
                  [
                    40162.7,
                    32607.3
                  ],
                  [
                    40400.4,
                    32723.7
                  ],
                  [
                    40781.8,
                    32622.1
                  ],
                  [
                    40631.9,
                    32284.9
                  ],
                  [
                    40541.2,
                    31974.3
                  ]
                ],
                "id": 131,
                "chat_link": "[&BIMAAAA=]"
              },
              "132": {
                "name": "Hidden Lake",
                "level": 21,
                "coord": [
                  40165.7,
                  31206.9
                ],
                "bounds": [
                  [
                    40440.4,
                    31500.2
                  ],
                  [
                    40075,
                    31547
                  ],
                  [
                    39962.4,
                    31252.2
                  ],
                  [
                    39766.4,
                    31191
                  ],
                  [
                    39836.1,
                    30918.5
                  ],
                  [
                    40130.9,
                    30900.1
                  ],
                  [
                    40686.7,
                    30984
                  ],
                  [
                    40428,
                    31361.8
                  ],
                  [
                    40440.4,
                    31500.2
                  ]
                ],
                "id": 132,
                "chat_link": "[&BIQAAAA=]"
              },
              "133": {
                "name": "Venlin Vale",
                "level": 16,
                "coord": [
                  40883.2,
                  33161.9
                ],
                "bounds": [
                  [
                    40781.7,
                    32620.8
                  ],
                  [
                    40926.1,
                    32757.6
                  ],
                  [
                    41194.4,
                    32858.9
                  ],
                  [
                    41273.5,
                    32847.7
                  ],
                  [
                    41642.7,
                    33432.2
                  ],
                  [
                    41606.8,
                    33552.3
                  ],
                  [
                    41152.7,
                    33576.8
                  ],
                  [
                    40807.1,
                    33535.1
                  ],
                  [
                    40766.1,
                    33570.1
                  ],
                  [
                    40390.1,
                    33538
                  ],
                  [
                    40387.6,
                    33339
                  ],
                  [
                    40550.8,
                    32978.2
                  ],
                  [
                    40485.6,
                    32940.4
                  ],
                  [
                    40399.6,
                    32719.8
                  ],
                  [
                    40781.7,
                    32620.8
                  ]
                ],
                "id": 133,
                "chat_link": "[&BIUAAAA=]"
              },
              "134": {
                "name": "Zinder Slope",
                "level": 16,
                "coord": [
                  41789.3,
                  32735.5
                ],
                "bounds": [
                  [
                    41832.8,
                    32837
                  ],
                  [
                    42135.3,
                    32772.7
                  ],
                  [
                    42165.5,
                    32560
                  ],
                  [
                    42113.4,
                    32491.5
                  ],
                  [
                    41964.7,
                    32560.6
                  ],
                  [
                    41619.9,
                    32557.8
                  ],
                  [
                    41512.3,
                    32782.1
                  ],
                  [
                    41268.9,
                    32845.5
                  ],
                  [
                    41490.9,
                    33212.4
                  ],
                  [
                    41832.8,
                    32837
                  ]
                ],
                "id": 134,
                "chat_link": "[&BIYAAAA=]"
              },
              "135": {
                "name": "Skrittsburgh Center",
                "level": 20,
                "coord": [
                  40859.4,
                  32017.5
                ],
                "bounds": [
                  [
                    41088.7,
                    31937.1
                  ],
                  [
                    41047.5,
                    31809.1
                  ],
                  [
                    40841.3,
                    31597.9
                  ],
                  [
                    40721.1,
                    31767
                  ],
                  [
                    40651.8,
                    31837.1
                  ],
                  [
                    40532.7,
                    31984.1
                  ],
                  [
                    40628.7,
                    32298
                  ],
                  [
                    40764.3,
                    32222.4
                  ],
                  [
                    40890.8,
                    32299.6
                  ],
                  [
                    41067,
                    32306.6
                  ],
                  [
                    41219.4,
                    32134
                  ],
                  [
                    41088.7,
                    31937.1
                  ]
                ],
                "id": 135,
                "chat_link": "[&BIcAAAA=]"
              },
              "136": {
                "name": "Skrittsburgh East End",
                "level": 19,
                "coord": [
                  41199.2,
                  31748.9
                ],
                "bounds": [
                  [
                    41218.4,
                    32134.6
                  ],
                  [
                    41086.4,
                    31936.3
                  ],
                  [
                    41047.4,
                    31811.4
                  ],
                  [
                    40839.7,
                    31598.3
                  ],
                  [
                    40863.9,
                    31541
                  ],
                  [
                    41061.7,
                    31423.2
                  ],
                  [
                    41120.2,
                    31465.8
                  ],
                  [
                    41164.8,
                    31524.9
                  ],
                  [
                    41437.2,
                    31543.6
                  ],
                  [
                    41627.6,
                    31880
                  ],
                  [
                    41477.8,
                    31968.2
                  ],
                  [
                    41445.5,
                    32159.4
                  ],
                  [
                    41218.4,
                    32134.6
                  ]
                ],
                "id": 136,
                "chat_link": "[&BIgAAAA=]"
              },
              "137": {
                "name": "Skrittsburgh Tunnels",
                "level": 17,
                "coord": [
                  40989.5,
                  32529.9
                ],
                "bounds": [
                  [
                    40922.5,
                    32759.1
                  ],
                  [
                    40781.4,
                    32631.3
                  ],
                  [
                    40634.8,
                    32290.7
                  ],
                  [
                    40763,
                    32217.5
                  ],
                  [
                    40890.4,
                    32298
                  ],
                  [
                    41062.5,
                    32304.1
                  ],
                  [
                    41291.1,
                    32570.1
                  ],
                  [
                    41354.2,
                    32836.3
                  ],
                  [
                    41205.3,
                    32861.9
                  ],
                  [
                    40922.5,
                    32759.1
                  ]
                ],
                "id": 137,
                "chat_link": "[&BIkAAAA=]"
              },
              "138": {
                "name": "Skrittsburgh Hillstead",
                "level": 18,
                "coord": [
                  41378.6,
                  32443.8
                ],
                "bounds": [
                  [
                    41444,
                    32159.3
                  ],
                  [
                    41216.8,
                    32132.9
                  ],
                  [
                    41060.8,
                    32304.5
                  ],
                  [
                    41290.1,
                    32570.5
                  ],
                  [
                    41355.1,
                    32837
                  ],
                  [
                    41514.4,
                    32782.2
                  ],
                  [
                    41623.8,
                    32559.6
                  ],
                  [
                    41523.7,
                    32204.6
                  ],
                  [
                    41444,
                    32159.3
                  ]
                ],
                "id": 138,
                "chat_link": "[&BIoAAAA=]"
              },
              "140": {
                "name": "The Shattered Henge",
                "level": 25,
                "coord": [
                  39603.7,
                  33211.1
                ],
                "bounds": [
                  [
                    39522.9,
                    32845.1
                  ],
                  [
                    39372.3,
                    32835.7
                  ],
                  [
                    39342,
                    33090.2
                  ],
                  [
                    39423.2,
                    33239.2
                  ],
                  [
                    39374.2,
                    33463.8
                  ],
                  [
                    39521,
                    33500.3
                  ],
                  [
                    39865.8,
                    33488
                  ],
                  [
                    39983.9,
                    33438.9
                  ],
                  [
                    39956.8,
                    33292.1
                  ],
                  [
                    39674.7,
                    32918
                  ],
                  [
                    39522.9,
                    32845.1
                  ]
                ],
                "id": 140,
                "chat_link": "[&BIwAAAA=]"
              },
              "141": {
                "name": "Duskstruck Moors",
                "level": 24,
                "coord": [
                  39544.2,
                  32639.6
                ],
                "bounds": [
                  [
                    39521.7,
                    32847
                  ],
                  [
                    39671.3,
                    32919.2
                  ],
                  [
                    40171,
                    32603.6
                  ],
                  [
                    39935,
                    32268.7
                  ],
                  [
                    39654.9,
                    32495.1
                  ],
                  [
                    39219.9,
                    32525.5
                  ],
                  [
                    38994.4,
                    32627.4
                  ],
                  [
                    39185.7,
                    32830.7
                  ],
                  [
                    39521.7,
                    32847
                  ]
                ],
                "id": 141,
                "chat_link": "[&BI0AAAA=]"
              },
              "142": {
                "name": "Toxal Bog",
                "level": 25,
                "coord": [
                  39135.4,
                  33101.3
                ],
                "bounds": [
                  [
                    39187.9,
                    32826.3
                  ],
                  [
                    39100.5,
                    32736.8
                  ],
                  [
                    38990,
                    32764.1
                  ],
                  [
                    38902,
                    32823.1
                  ],
                  [
                    38872.4,
                    32993.2
                  ],
                  [
                    39059.6,
                    33124.5
                  ],
                  [
                    39019.4,
                    33257.9
                  ],
                  [
                    39007.3,
                    33339.8
                  ],
                  [
                    39041.4,
                    33439.2
                  ],
                  [
                    39194.5,
                    33492.8
                  ],
                  [
                    39380.5,
                    33449.6
                  ],
                  [
                    39423.4,
                    33237.8
                  ],
                  [
                    39342.2,
                    33094.4
                  ],
                  [
                    39374.6,
                    32839
                  ],
                  [
                    39187.9,
                    32826.3
                  ]
                ],
                "id": 142,
                "chat_link": "[&BI4AAAA=]"
              },
              "143": {
                "name": "Nemeton Grove",
                "level": 17,
                "coord": [
                  41798,
                  32117.7
                ],
                "bounds": [
                  [
                    42113.4,
                    32492.5
                  ],
                  [
                    41965.3,
                    32569.8
                  ],
                  [
                    41621.3,
                    32560.5
                  ],
                  [
                    41525.8,
                    32203.1
                  ],
                  [
                    41443,
                    32158.7
                  ],
                  [
                    41478.2,
                    31968.9
                  ],
                  [
                    41625.6,
                    31880.9
                  ],
                  [
                    41891,
                    31666.3
                  ],
                  [
                    42193.6,
                    31618.9
                  ],
                  [
                    42123.1,
                    32057.6
                  ],
                  [
                    42113.4,
                    32492.5
                  ]
                ],
                "id": 143,
                "chat_link": "[&BI8AAAA=]"
              },
              "1030": {
                "name": "Aurora's Remains",
                "level": 26,
                "coord": [
                  38882.2,
                  32864.9
                ],
                "bounds": [
                  [
                    38873,
                    32992.9
                  ],
                  [
                    39058.6,
                    33124.6
                  ],
                  [
                    39019.2,
                    33259.2
                  ],
                  [
                    38663.1,
                    33072.5
                  ],
                  [
                    38610.7,
                    32723.8
                  ],
                  [
                    38607.3,
                    32526.2
                  ],
                  [
                    38996.2,
                    32625.7
                  ],
                  [
                    39100,
                    32736.1
                  ],
                  [
                    38991.5,
                    32765.1
                  ],
                  [
                    38902,
                    32823.2
                  ],
                  [
                    38873,
                    32992.9
                  ]
                ],
                "id": 1030,
                "chat_link": "[&BAYEAAA=]"
              },
              "1103": {
                "name": "Proxemics Lab",
                "level": 23,
                "coord": [
                  38832.7,
                  31231.7
                ],
                "bounds": [
                  [
                    38991.6,
                    30957.7
                  ],
                  [
                    39004.8,
                    31333.4
                  ],
                  [
                    38897.9,
                    31529.6
                  ],
                  [
                    38851.4,
                    31731
                  ],
                  [
                    38641.2,
                    31697
                  ],
                  [
                    38648.6,
                    30835.6
                  ],
                  [
                    38779.8,
                    30840.3
                  ],
                  [
                    38846,
                    30928.9
                  ],
                  [
                    38991.6,
                    30957.7
                  ]
                ],
                "id": 1103,
                "chat_link": "[&BE8EAAA=]"
              },
              "1185": {
                "name": "Tangle Root",
                "level": 26,
                "coord": [
                  38862.9,
                  33354.3
                ],
                "bounds": [
                  [
                    38660.3,
                    33478.7
                  ],
                  [
                    38664.6,
                    33073.2
                  ],
                  [
                    39018.8,
                    33259.8
                  ],
                  [
                    39007.2,
                    33340.2
                  ],
                  [
                    39041.8,
                    33439.8
                  ],
                  [
                    38784.8,
                    33534.3
                  ],
                  [
                    38660.3,
                    33478.7
                  ]
                ],
                "id": 1185,
                "chat_link": "[&BKEEAAA=]"
              }
            },
            "id": 1136,
            "mastery_points": [],
            "adventures": []
          },
          "1137": {
            "name": "Proxemics Lab",
            "min_level": 15,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "122": {
                "name": "Koga Ruins",
                "level": 24,
                "coord": [
                  40224.2,
                  33097.3
                ],
                "bounds": [
                  [
                    40403.2,
                    32719.6
                  ],
                  [
                    40167,
                    32604.7
                  ],
                  [
                    39673,
                    32918.7
                  ],
                  [
                    39958.2,
                    33293.9
                  ],
                  [
                    39995.1,
                    33536.5
                  ],
                  [
                    40388.4,
                    33538.9
                  ],
                  [
                    40387.2,
                    33346.2
                  ],
                  [
                    40555.1,
                    32977.6
                  ],
                  [
                    40490.7,
                    32939.9
                  ],
                  [
                    40403.2,
                    32719.6
                  ]
                ],
                "id": 122,
                "chat_link": "[&BHoAAAA=]"
              },
              "123": {
                "name": "The Wendon Steps",
                "level": 19,
                "coord": [
                  41781.1,
                  31268.7
                ],
                "bounds": [
                  [
                    41628.3,
                    31879.3
                  ],
                  [
                    41436.3,
                    31544.2
                  ],
                  [
                    41294.5,
                    31539.8
                  ],
                  [
                    41412.9,
                    30921.2
                  ],
                  [
                    41568.6,
                    30902.5
                  ],
                  [
                    41759.5,
                    30910.8
                  ],
                  [
                    42112.9,
                    30816.2
                  ],
                  [
                    42161.1,
                    30946.1
                  ],
                  [
                    42128.5,
                    31211.5
                  ],
                  [
                    42195.1,
                    31619.6
                  ],
                  [
                    41894,
                    31664.9
                  ],
                  [
                    41628.3,
                    31879.3
                  ]
                ],
                "id": 123,
                "chat_link": "[&BHsAAAA=]"
              },
              "124": {
                "name": "Highwayman's Vale",
                "level": 23,
                "coord": [
                  39560.4,
                  32117.4
                ],
                "bounds": [
                  [
                    39656.3,
                    32494.1
                  ],
                  [
                    39928.8,
                    32273.8
                  ],
                  [
                    39760,
                    32046
                  ],
                  [
                    39787.9,
                    31767.4
                  ],
                  [
                    39584.3,
                    31679.8
                  ],
                  [
                    39301,
                    31904.6
                  ],
                  [
                    39413.4,
                    32081.3
                  ],
                  [
                    39386.1,
                    32281.3
                  ],
                  [
                    39226.2,
                    32528.5
                  ],
                  [
                    39656.3,
                    32494.1
                  ]
                ],
                "id": 124,
                "chat_link": "[&BHwAAAA=]"
              },
              "125": {
                "name": "Gnashar's Hills",
                "level": 21,
                "coord": [
                  40936.9,
                  31376.5
                ],
                "bounds": [
                  [
                    40456.7,
                    31917.9
                  ],
                  [
                    40539.8,
                    31982.4
                  ],
                  [
                    40843.9,
                    31600.1
                  ],
                  [
                    40868.1,
                    31542.4
                  ],
                  [
                    41061.8,
                    31427.6
                  ],
                  [
                    41116.5,
                    31466.9
                  ],
                  [
                    41164,
                    31527.1
                  ],
                  [
                    41296.9,
                    31540.7
                  ],
                  [
                    41418.2,
                    30890.4
                  ],
                  [
                    41269.1,
                    30994.8
                  ],
                  [
                    41054,
                    30989.7
                  ],
                  [
                    40928.6,
                    31059
                  ],
                  [
                    40678.4,
                    30971.6
                  ],
                  [
                    40420.1,
                    31360.7
                  ],
                  [
                    40456.7,
                    31917.9
                  ]
                ],
                "id": 125,
                "chat_link": "[&BH0AAAA=]"
              },
              "126": {
                "name": "The Gallowfields",
                "level": 23,
                "coord": [
                  39135.6,
                  31439.6
                ],
                "bounds": [
                  [
                    38922.3,
                    31851.6
                  ],
                  [
                    38850.2,
                    31737.3
                  ],
                  [
                    38897.9,
                    31525.8
                  ],
                  [
                    39002.7,
                    31332.3
                  ],
                  [
                    38991,
                    31071.2
                  ],
                  [
                    39102.5,
                    31037.3
                  ],
                  [
                    39208.5,
                    31118.6
                  ],
                  [
                    39196.3,
                    31236.6
                  ],
                  [
                    39432.6,
                    31339.8
                  ],
                  [
                    39586,
                    31678.6
                  ],
                  [
                    39302.1,
                    31906.3
                  ],
                  [
                    38922.3,
                    31851.6
                  ]
                ],
                "id": 126,
                "chat_link": "[&BH4AAAA=]"
              },
              "127": {
                "name": "Lionshead Outcrops",
                "level": 22,
                "coord": [
                  39678.9,
                  31258
                ],
                "bounds": [
                  [
                    40073.4,
                    31546
                  ],
                  [
                    39962,
                    31252.3
                  ],
                  [
                    39765.9,
                    31190.6
                  ],
                  [
                    39836.1,
                    30918.3
                  ],
                  [
                    39788.8,
                    30851.3
                  ],
                  [
                    39666.7,
                    30854
                  ],
                  [
                    39526.4,
                    30935
                  ],
                  [
                    39209.9,
                    31119
                  ],
                  [
                    39196.3,
                    31236.5
                  ],
                  [
                    39427.9,
                    31339.8
                  ],
                  [
                    39582.8,
                    31679.3
                  ],
                  [
                    39786.2,
                    31769.9
                  ],
                  [
                    40003,
                    31662.5
                  ],
                  [
                    40073.4,
                    31546
                  ]
                ],
                "id": 127,
                "chat_link": "[&BH8AAAA=]"
              },
              "128": {
                "name": "Vandal's Claim",
                "level": 23,
                "coord": [
                  38957.5,
                  32142
                ],
                "bounds": [
                  [
                    38995.7,
                    32630.3
                  ],
                  [
                    38606.3,
                    32525
                  ],
                  [
                    38591,
                    32231.4
                  ],
                  [
                    38589,
                    32100.9
                  ],
                  [
                    38643.6,
                    31690.7
                  ],
                  [
                    38850,
                    31731.8
                  ],
                  [
                    38925.4,
                    31851.3
                  ],
                  [
                    39299.2,
                    31905.1
                  ],
                  [
                    39414.4,
                    32083.3
                  ],
                  [
                    39388.7,
                    32280.5
                  ],
                  [
                    39228.8,
                    32531.8
                  ],
                  [
                    38995.7,
                    32630.3
                  ]
                ],
                "id": 128,
                "chat_link": "[&BIAAAAA=]"
              },
              "129": {
                "name": "Karston Chambers",
                "level": 17,
                "coord": [
                  41884,
                  33223.8
                ],
                "bounds": [
                  [
                    42178.2,
                    33347.1
                  ],
                  [
                    42114.5,
                    33092.8
                  ],
                  [
                    42135.2,
                    32770.7
                  ],
                  [
                    41828,
                    32836.9
                  ],
                  [
                    41481.6,
                    33207.6
                  ],
                  [
                    41644.1,
                    33442.8
                  ],
                  [
                    41606.3,
                    33550.6
                  ],
                  [
                    42084,
                    33541.7
                  ],
                  [
                    42178.2,
                    33347.1
                  ]
                ],
                "id": 129,
                "chat_link": "[&BIEAAAA=]"
              },
              "130": {
                "name": "Brilitine Swath",
                "level": 22,
                "coord": [
                  40173.1,
                  31913.1
                ],
                "bounds": [
                  [
                    40004.9,
                    31661.6
                  ],
                  [
                    40069.4,
                    31549.3
                  ],
                  [
                    40440.4,
                    31500.5
                  ],
                  [
                    40459.1,
                    31916.1
                  ],
                  [
                    40536.6,
                    31984.7
                  ],
                  [
                    40339.3,
                    32191.8
                  ],
                  [
                    40167.8,
                    32600.9
                  ],
                  [
                    39760,
                    32047.8
                  ],
                  [
                    39780.5,
                    31765.3
                  ],
                  [
                    40004.9,
                    31661.6
                  ]
                ],
                "id": 130,
                "chat_link": "[&BIIAAAA=]"
              },
              "131": {
                "name": "Gotala Cascade",
                "level": 23,
                "coord": [
                  40476,
                  32400.7
                ],
                "bounds": [
                  [
                    40541.2,
                    31974.3
                  ],
                  [
                    40338.3,
                    32191.9
                  ],
                  [
                    40162.7,
                    32607.3
                  ],
                  [
                    40400.4,
                    32723.7
                  ],
                  [
                    40781.8,
                    32622.1
                  ],
                  [
                    40631.9,
                    32284.9
                  ],
                  [
                    40541.2,
                    31974.3
                  ]
                ],
                "id": 131,
                "chat_link": "[&BIMAAAA=]"
              },
              "132": {
                "name": "Hidden Lake",
                "level": 21,
                "coord": [
                  40165.7,
                  31206.9
                ],
                "bounds": [
                  [
                    40440.4,
                    31500.2
                  ],
                  [
                    40075,
                    31547
                  ],
                  [
                    39962.4,
                    31252.2
                  ],
                  [
                    39766.4,
                    31191
                  ],
                  [
                    39836.1,
                    30918.5
                  ],
                  [
                    40130.9,
                    30900.1
                  ],
                  [
                    40686.7,
                    30984
                  ],
                  [
                    40428,
                    31361.8
                  ],
                  [
                    40440.4,
                    31500.2
                  ]
                ],
                "id": 132,
                "chat_link": "[&BIQAAAA=]"
              },
              "133": {
                "name": "Venlin Vale",
                "level": 16,
                "coord": [
                  40883.2,
                  33161.9
                ],
                "bounds": [
                  [
                    40781.7,
                    32620.8
                  ],
                  [
                    40926.1,
                    32757.6
                  ],
                  [
                    41194.4,
                    32858.9
                  ],
                  [
                    41273.5,
                    32847.7
                  ],
                  [
                    41642.7,
                    33432.2
                  ],
                  [
                    41606.8,
                    33552.3
                  ],
                  [
                    41152.7,
                    33576.8
                  ],
                  [
                    40807.1,
                    33535.1
                  ],
                  [
                    40766.1,
                    33570.1
                  ],
                  [
                    40390.1,
                    33538
                  ],
                  [
                    40387.6,
                    33339
                  ],
                  [
                    40550.8,
                    32978.2
                  ],
                  [
                    40485.6,
                    32940.4
                  ],
                  [
                    40399.6,
                    32719.8
                  ],
                  [
                    40781.7,
                    32620.8
                  ]
                ],
                "id": 133,
                "chat_link": "[&BIUAAAA=]"
              },
              "134": {
                "name": "Zinder Slope",
                "level": 16,
                "coord": [
                  41789.3,
                  32735.5
                ],
                "bounds": [
                  [
                    41832.8,
                    32837
                  ],
                  [
                    42135.3,
                    32772.7
                  ],
                  [
                    42165.5,
                    32560
                  ],
                  [
                    42113.4,
                    32491.5
                  ],
                  [
                    41964.7,
                    32560.6
                  ],
                  [
                    41619.9,
                    32557.8
                  ],
                  [
                    41512.3,
                    32782.1
                  ],
                  [
                    41268.9,
                    32845.5
                  ],
                  [
                    41490.9,
                    33212.4
                  ],
                  [
                    41832.8,
                    32837
                  ]
                ],
                "id": 134,
                "chat_link": "[&BIYAAAA=]"
              },
              "135": {
                "name": "Skrittsburgh Center",
                "level": 20,
                "coord": [
                  40859.4,
                  32017.5
                ],
                "bounds": [
                  [
                    41088.7,
                    31937.1
                  ],
                  [
                    41047.5,
                    31809.1
                  ],
                  [
                    40841.3,
                    31597.9
                  ],
                  [
                    40721.1,
                    31767
                  ],
                  [
                    40651.8,
                    31837.1
                  ],
                  [
                    40532.7,
                    31984.1
                  ],
                  [
                    40628.7,
                    32298
                  ],
                  [
                    40764.3,
                    32222.4
                  ],
                  [
                    40890.8,
                    32299.6
                  ],
                  [
                    41067,
                    32306.6
                  ],
                  [
                    41219.4,
                    32134
                  ],
                  [
                    41088.7,
                    31937.1
                  ]
                ],
                "id": 135,
                "chat_link": "[&BIcAAAA=]"
              },
              "136": {
                "name": "Skrittsburgh East End",
                "level": 19,
                "coord": [
                  41199.2,
                  31748.9
                ],
                "bounds": [
                  [
                    41218.4,
                    32134.6
                  ],
                  [
                    41086.4,
                    31936.3
                  ],
                  [
                    41047.4,
                    31811.4
                  ],
                  [
                    40839.7,
                    31598.3
                  ],
                  [
                    40863.9,
                    31541
                  ],
                  [
                    41061.7,
                    31423.2
                  ],
                  [
                    41120.2,
                    31465.8
                  ],
                  [
                    41164.8,
                    31524.9
                  ],
                  [
                    41437.2,
                    31543.6
                  ],
                  [
                    41627.6,
                    31880
                  ],
                  [
                    41477.8,
                    31968.2
                  ],
                  [
                    41445.5,
                    32159.4
                  ],
                  [
                    41218.4,
                    32134.6
                  ]
                ],
                "id": 136,
                "chat_link": "[&BIgAAAA=]"
              },
              "137": {
                "name": "Skrittsburgh Tunnels",
                "level": 17,
                "coord": [
                  40989.5,
                  32529.9
                ],
                "bounds": [
                  [
                    40922.5,
                    32759.1
                  ],
                  [
                    40781.4,
                    32631.3
                  ],
                  [
                    40634.8,
                    32290.7
                  ],
                  [
                    40763,
                    32217.5
                  ],
                  [
                    40890.4,
                    32298
                  ],
                  [
                    41062.5,
                    32304.1
                  ],
                  [
                    41291.1,
                    32570.1
                  ],
                  [
                    41354.2,
                    32836.3
                  ],
                  [
                    41205.3,
                    32861.9
                  ],
                  [
                    40922.5,
                    32759.1
                  ]
                ],
                "id": 137,
                "chat_link": "[&BIkAAAA=]"
              },
              "138": {
                "name": "Skrittsburgh Hillstead",
                "level": 18,
                "coord": [
                  41378.6,
                  32443.8
                ],
                "bounds": [
                  [
                    41444,
                    32159.3
                  ],
                  [
                    41216.8,
                    32132.9
                  ],
                  [
                    41060.8,
                    32304.5
                  ],
                  [
                    41290.1,
                    32570.5
                  ],
                  [
                    41355.1,
                    32837
                  ],
                  [
                    41514.4,
                    32782.2
                  ],
                  [
                    41623.8,
                    32559.6
                  ],
                  [
                    41523.7,
                    32204.6
                  ],
                  [
                    41444,
                    32159.3
                  ]
                ],
                "id": 138,
                "chat_link": "[&BIoAAAA=]"
              },
              "140": {
                "name": "The Shattered Henge",
                "level": 25,
                "coord": [
                  39603.7,
                  33211.1
                ],
                "bounds": [
                  [
                    39522.9,
                    32845.1
                  ],
                  [
                    39372.3,
                    32835.7
                  ],
                  [
                    39342,
                    33090.2
                  ],
                  [
                    39423.2,
                    33239.2
                  ],
                  [
                    39374.2,
                    33463.8
                  ],
                  [
                    39521,
                    33500.3
                  ],
                  [
                    39865.8,
                    33488
                  ],
                  [
                    39983.9,
                    33438.9
                  ],
                  [
                    39956.8,
                    33292.1
                  ],
                  [
                    39674.7,
                    32918
                  ],
                  [
                    39522.9,
                    32845.1
                  ]
                ],
                "id": 140,
                "chat_link": "[&BIwAAAA=]"
              },
              "141": {
                "name": "Duskstruck Moors",
                "level": 24,
                "coord": [
                  39544.2,
                  32639.6
                ],
                "bounds": [
                  [
                    39521.7,
                    32847
                  ],
                  [
                    39671.3,
                    32919.2
                  ],
                  [
                    40171,
                    32603.6
                  ],
                  [
                    39935,
                    32268.7
                  ],
                  [
                    39654.9,
                    32495.1
                  ],
                  [
                    39219.9,
                    32525.5
                  ],
                  [
                    38994.4,
                    32627.4
                  ],
                  [
                    39185.7,
                    32830.7
                  ],
                  [
                    39521.7,
                    32847
                  ]
                ],
                "id": 141,
                "chat_link": "[&BI0AAAA=]"
              },
              "142": {
                "name": "Toxal Bog",
                "level": 25,
                "coord": [
                  39135.4,
                  33101.3
                ],
                "bounds": [
                  [
                    39187.9,
                    32826.3
                  ],
                  [
                    39100.5,
                    32736.8
                  ],
                  [
                    38990,
                    32764.1
                  ],
                  [
                    38902,
                    32823.1
                  ],
                  [
                    38872.4,
                    32993.2
                  ],
                  [
                    39059.6,
                    33124.5
                  ],
                  [
                    39019.4,
                    33257.9
                  ],
                  [
                    39007.3,
                    33339.8
                  ],
                  [
                    39041.4,
                    33439.2
                  ],
                  [
                    39194.5,
                    33492.8
                  ],
                  [
                    39380.5,
                    33449.6
                  ],
                  [
                    39423.4,
                    33237.8
                  ],
                  [
                    39342.2,
                    33094.4
                  ],
                  [
                    39374.6,
                    32839
                  ],
                  [
                    39187.9,
                    32826.3
                  ]
                ],
                "id": 142,
                "chat_link": "[&BI4AAAA=]"
              },
              "143": {
                "name": "Nemeton Grove",
                "level": 17,
                "coord": [
                  41798,
                  32117.7
                ],
                "bounds": [
                  [
                    42113.4,
                    32492.5
                  ],
                  [
                    41965.3,
                    32569.8
                  ],
                  [
                    41621.3,
                    32560.5
                  ],
                  [
                    41525.8,
                    32203.1
                  ],
                  [
                    41443,
                    32158.7
                  ],
                  [
                    41478.2,
                    31968.9
                  ],
                  [
                    41625.6,
                    31880.9
                  ],
                  [
                    41891,
                    31666.3
                  ],
                  [
                    42193.6,
                    31618.9
                  ],
                  [
                    42123.1,
                    32057.6
                  ],
                  [
                    42113.4,
                    32492.5
                  ]
                ],
                "id": 143,
                "chat_link": "[&BI8AAAA=]"
              },
              "1030": {
                "name": "Aurora's Remains",
                "level": 26,
                "coord": [
                  38882.2,
                  32864.9
                ],
                "bounds": [
                  [
                    38873,
                    32992.9
                  ],
                  [
                    39058.6,
                    33124.6
                  ],
                  [
                    39019.2,
                    33259.2
                  ],
                  [
                    38663.1,
                    33072.5
                  ],
                  [
                    38610.7,
                    32723.8
                  ],
                  [
                    38607.3,
                    32526.2
                  ],
                  [
                    38996.2,
                    32625.7
                  ],
                  [
                    39100,
                    32736.1
                  ],
                  [
                    38991.5,
                    32765.1
                  ],
                  [
                    38902,
                    32823.2
                  ],
                  [
                    38873,
                    32992.9
                  ]
                ],
                "id": 1030,
                "chat_link": "[&BAYEAAA=]"
              },
              "1103": {
                "name": "Proxemics Lab",
                "level": 23,
                "coord": [
                  38832.7,
                  31231.7
                ],
                "bounds": [
                  [
                    38991.6,
                    30957.7
                  ],
                  [
                    39004.8,
                    31333.4
                  ],
                  [
                    38897.9,
                    31529.6
                  ],
                  [
                    38851.4,
                    31731
                  ],
                  [
                    38641.2,
                    31697
                  ],
                  [
                    38648.6,
                    30835.6
                  ],
                  [
                    38779.8,
                    30840.3
                  ],
                  [
                    38846,
                    30928.9
                  ],
                  [
                    38991.6,
                    30957.7
                  ]
                ],
                "id": 1103,
                "chat_link": "[&BE8EAAA=]"
              },
              "1185": {
                "name": "Tangle Root",
                "level": 26,
                "coord": [
                  38862.9,
                  33354.3
                ],
                "bounds": [
                  [
                    38660.3,
                    33478.7
                  ],
                  [
                    38664.6,
                    33073.2
                  ],
                  [
                    39018.8,
                    33259.8
                  ],
                  [
                    39007.2,
                    33340.2
                  ],
                  [
                    39041.8,
                    33439.8
                  ],
                  [
                    38784.8,
                    33534.3
                  ],
                  [
                    38660.3,
                    33478.7
                  ]
                ],
                "id": 1185,
                "chat_link": "[&BKEEAAA=]"
              }
            },
            "id": 1137,
            "mastery_points": [],
            "adventures": []
          },
          "1283": {
            "name": "???",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              54068,
              57384
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1283,
            "mastery_points": []
          },
          "1392": {
            "name": "Primordus Rising",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {
              "1168": {
                "name": "Dept. Of Arcane Eye",
                "type": "landmark",
                "floor": 0,
                "coord": [
                  38626.6,
                  37293
                ],
                "id": 1168,
                "chat_link": "[&BJAEAAA=]"
              },
              "1169": {
                "name": "Polymock Atrium",
                "type": "landmark",
                "floor": 0,
                "coord": [
                  38937.3,
                  37098.9
                ],
                "id": 1169,
                "chat_link": "[&BJEEAAA=]"
              },
              "1174": {
                "name": "Priory Recruiting Station",
                "type": "landmark",
                "floor": 0,
                "coord": [
                  38750.4,
                  37321.7
                ],
                "id": 1174,
                "chat_link": "[&BJYEAAA=]"
              },
              "1176": {
                "name": "Forge Hall",
                "type": "landmark",
                "floor": 0,
                "coord": [
                  38878.9,
                  37049.6
                ],
                "id": 1176,
                "chat_link": "[&BJgEAAA=]"
              },
              "1178": {
                "name": "Skinner Hall",
                "type": "landmark",
                "floor": 0,
                "coord": [
                  38694.5,
                  37270.5
                ],
                "id": 1178,
                "chat_link": "[&BJoEAAA=]"
              },
              "1179": {
                "name": "Vigil Recruiting Station",
                "type": "landmark",
                "floor": 0,
                "coord": [
                  38891.5,
                  36975.1
                ],
                "id": 1179,
                "chat_link": "[&BJsEAAA=]"
              },
              "1181": {
                "name": "Engaged Demo Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37644,
                  36366.1
                ],
                "id": 1181,
                "chat_link": "[&BJ0EAAA=]"
              },
              "1182": {
                "name": "Zojja's Workstation (Don't Touch!)",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38182.9,
                  37334
                ],
                "id": 1182,
                "chat_link": "[&BJ4EAAA=]"
              },
              "1183": {
                "name": "Usability Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38623.7,
                  38124.4
                ],
                "id": 1183,
                "chat_link": "[&BJ8EAAA=]"
              },
              "1184": {
                "name": "Artisan Hall",
                "type": "landmark",
                "floor": 0,
                "coord": [
                  38597.8,
                  36999
                ],
                "id": 1184,
                "chat_link": "[&BKAEAAA=]"
              },
              "1285": {
                "name": "Antidawn Anchorage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38071.3,
                  38313.2
                ],
                "id": 1285,
                "chat_link": "[&BAUFAAA=]"
              },
              "1286": {
                "name": "Dawnside Quay",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38322.1,
                  38195.4
                ],
                "id": 1286,
                "chat_link": "[&BAYFAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "856": {
                "name": "Riven Valley",
                "level": 0,
                "coord": [
                  39282.7,
                  37462.8
                ],
                "bounds": [
                  [
                    38626.7,
                    37783.5
                  ],
                  [
                    38658.9,
                    37474.1
                  ],
                  [
                    39076.8,
                    36977.1
                  ],
                  [
                    39457.9,
                    36851.3
                  ],
                  [
                    39938.6,
                    37073.7
                  ],
                  [
                    39742.9,
                    37905.7
                  ],
                  [
                    39477.1,
                    38174.1
                  ],
                  [
                    38626.7,
                    37783.5
                  ]
                ],
                "id": 856,
                "chat_link": "[&BFgDAAA=]"
              },
              "919": {
                "name": "Applied Development Lab (Home)",
                "level": 0,
                "coord": [
                  37819.7,
                  36301.5
                ],
                "bounds": [
                  [
                    38180.8,
                    36251.8
                  ],
                  [
                    38021.9,
                    36118.1
                  ],
                  [
                    37841.3,
                    36116.1
                  ],
                  [
                    37671.3,
                    36147.8
                  ],
                  [
                    37401.1,
                    36368.3
                  ],
                  [
                    37621.3,
                    36619.1
                  ],
                  [
                    38000,
                    36489
                  ],
                  [
                    38180.8,
                    36251.8
                  ]
                ],
                "id": 919,
                "chat_link": "[&BJcDAAA=]"
              },
              "920": {
                "name": "Snaff Memorial Lab",
                "level": 0,
                "coord": [
                  38014.6,
                  37408.8
                ],
                "bounds": [
                  [
                    37572.9,
                    37270.8
                  ],
                  [
                    38154.6,
                    37083.7
                  ],
                  [
                    38299.6,
                    37250.7
                  ],
                  [
                    38309.6,
                    37463.1
                  ],
                  [
                    38020.6,
                    37738.9
                  ],
                  [
                    37730.4,
                    37645.5
                  ],
                  [
                    37572.9,
                    37270.8
                  ]
                ],
                "id": 920,
                "chat_link": "[&BJgDAAA=]"
              },
              "921": {
                "name": "Advanced Metamystics Lab",
                "level": 0,
                "coord": [
                  38698.8,
                  36297
                ],
                "bounds": [
                  [
                    38340.1,
                    36315.2
                  ],
                  [
                    38624.3,
                    36140.8
                  ],
                  [
                    38973.6,
                    36234.3
                  ],
                  [
                    38857.2,
                    36497.8
                  ],
                  [
                    38340.1,
                    36315.2
                  ]
                ],
                "id": 921,
                "chat_link": "[&BJkDAAA=]"
              },
              "922": {
                "name": "Idea Incubation lab",
                "level": 0,
                "coord": [
                  38796.7,
                  38172.9
                ],
                "bounds": [
                  [
                    38628,
                    37783
                  ],
                  [
                    39482.6,
                    38171.2
                  ],
                  [
                    38913.7,
                    38626.3
                  ],
                  [
                    38405.5,
                    38514.4
                  ],
                  [
                    38553.4,
                    37769.6
                  ],
                  [
                    38628,
                    37783
                  ]
                ],
                "id": 922,
                "chat_link": "[&BJoDAAA=]"
              },
              "929": {
                "name": "Interdisciplinary Accessium",
                "level": 0,
                "coord": [
                  38723.4,
                  37107
                ],
                "bounds": [
                  [
                    38769.3,
                    37026.7
                  ],
                  [
                    38811.9,
                    37139.7
                  ],
                  [
                    38886,
                    37203.6
                  ],
                  [
                    38847.8,
                    37250.8
                  ],
                  [
                    38770.6,
                    37187
                  ],
                  [
                    38652.4,
                    37166.3
                  ],
                  [
                    38556.3,
                    37199.8
                  ],
                  [
                    38535.3,
                    37143.4
                  ],
                  [
                    38631.9,
                    37107.8
                  ],
                  [
                    38706.9,
                    37018.4
                  ],
                  [
                    38722.7,
                    36913.7
                  ],
                  [
                    38789.2,
                    36926.3
                  ],
                  [
                    38769.3,
                    37026.7
                  ]
                ],
                "id": 929,
                "chat_link": "[&BKEDAAA=]"
              },
              "930": {
                "name": "Dynamics Union",
                "level": 0,
                "coord": [
                  38606.2,
                  37009.6
                ],
                "bounds": [
                  [
                    38721.4,
                    36913.6
                  ],
                  [
                    38706.7,
                    37018.6
                  ],
                  [
                    38632.6,
                    37107
                  ],
                  [
                    38536.2,
                    37143.1
                  ],
                  [
                    38434,
                    36865.9
                  ],
                  [
                    38721.4,
                    36913.6
                  ]
                ],
                "id": 930,
                "chat_link": "[&BKIDAAA=]"
              },
              "931": {
                "name": "Statics Union",
                "level": 0,
                "coord": [
                  38866.5,
                  37054.7
                ],
                "bounds": [
                  [
                    38811.7,
                    37139.1
                  ],
                  [
                    38885.1,
                    37202.4
                  ],
                  [
                    39076,
                    36977.8
                  ],
                  [
                    38790.3,
                    36927.4
                  ],
                  [
                    38769.5,
                    37026.9
                  ],
                  [
                    38811.7,
                    37139.1
                  ]
                ],
                "id": 931,
                "chat_link": "[&BKMDAAA=]"
              },
              "932": {
                "name": "Synergetics Union",
                "level": 0,
                "coord": [
                  38697.3,
                  37256.3
                ],
                "bounds": [
                  [
                    38557.2,
                    37201.2
                  ],
                  [
                    38660.1,
                    37475
                  ],
                  [
                    38846.4,
                    37252.3
                  ],
                  [
                    38770.7,
                    37187
                  ],
                  [
                    38652.1,
                    37166.1
                  ],
                  [
                    38557.2,
                    37201.2
                  ]
                ],
                "id": 932,
                "chat_link": "[&BKQDAAA=]"
              },
              "938": {
                "name": "Arkentia Valley",
                "level": 0,
                "coord": [
                  38793.4,
                  36540.4
                ],
                "bounds": [
                  [
                    39458.8,
                    36855.5
                  ],
                  [
                    39366.4,
                    36142.8
                  ],
                  [
                    38975.9,
                    36234.4
                  ],
                  [
                    38855.8,
                    36498.3
                  ],
                  [
                    38180.7,
                    36252.8
                  ],
                  [
                    38000.2,
                    36494.6
                  ],
                  [
                    38433,
                    36867.3
                  ],
                  [
                    39076.2,
                    36977.5
                  ],
                  [
                    39458.8,
                    36855.5
                  ]
                ],
                "id": 938,
                "chat_link": "[&BKoDAAA=]"
              },
              "939": {
                "name": "Magus Valley",
                "level": 0,
                "coord": [
                  38175.8,
                  37202.9
                ],
                "bounds": [
                  [
                    37623,
                    36621.1
                  ],
                  [
                    37624.5,
                    37260.1
                  ],
                  [
                    38152.6,
                    37089.3
                  ],
                  [
                    38299.1,
                    37252.5
                  ],
                  [
                    38310.9,
                    37464.6
                  ],
                  [
                    38023.1,
                    37736.6
                  ],
                  [
                    38627.4,
                    37783
                  ],
                  [
                    38661,
                    37474
                  ],
                  [
                    38437.5,
                    36864.6
                  ],
                  [
                    37998.4,
                    36483.2
                  ],
                  [
                    37623,
                    36621.1
                  ]
                ],
                "id": 939,
                "chat_link": "[&BKsDAAA=]"
              },
              "1016": {
                "name": "Polymock Arenas",
                "level": 0,
                "coord": [
                  39777.3,
                  36659.2
                ],
                "bounds": [
                  [
                    39941.6,
                    37070.8
                  ],
                  [
                    39461.6,
                    36865.5
                  ],
                  [
                    39366.8,
                    36142.2
                  ],
                  [
                    40039.1,
                    36310
                  ],
                  [
                    40077.2,
                    36907.6
                  ],
                  [
                    39941.6,
                    37070.8
                  ]
                ],
                "id": 1016,
                "chat_link": "[&BPgDAAA=]"
              },
              "1022": {
                "name": "Rata Sum Port Authority",
                "level": 0,
                "coord": [
                  38059.1,
                  38100.3
                ],
                "bounds": [
                  [
                    38554.5,
                    37769.2
                  ],
                  [
                    38405.5,
                    38514.4
                  ],
                  [
                    37999.3,
                    38623.5
                  ],
                  [
                    37641.6,
                    38312
                  ],
                  [
                    37729.7,
                    37646.3
                  ],
                  [
                    38023.9,
                    37736.3
                  ],
                  [
                    38554.5,
                    37769.2
                  ]
                ],
                "id": 1022,
                "chat_link": "[&BP4DAAA=]"
              }
            },
            "adventures": [],
            "id": 1392,
            "mastery_points": []
          },
          "1407": {
            "name": "Council Level",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 2,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1407,
            "mastery_points": []
          }
        },
        "id": 5
      },
      "8": {
        "name": "Steamspur Mountains",
        "label_coord": [
          51072,
          37624
        ],
        "continent_rect": [
          [
            48000,
            35392
          ],
          [
            54400,
            40192
          ]
        ],
        "maps": {
          "37": {
            "name": "Arson at the Orphanage",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {
              "261": {
                "name": "Vanguard Hospital",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44353.8,
                  26577.9
                ],
                "id": 261,
                "chat_link": "[&BAUBAAA=]"
              },
              "262": {
                "name": "Queen's Heart Orphanage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44280.3,
                  26860.6
                ],
                "id": 262,
                "chat_link": "[&BAYBAAA=]"
              },
              "266": {
                "name": "Manor Hill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44154,
                  26741.5
                ],
                "id": 266,
                "chat_link": "[&BAoBAAA=]"
              },
              "267": {
                "name": "Cottage Bend",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44355.6,
                  26907.3
                ],
                "id": 267,
                "chat_link": "[&BAsBAAA=]"
              },
              "268": {
                "name": "Rook's Row",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44383.1,
                  26758.6
                ],
                "id": 268,
                "chat_link": "[&BAwBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "187": {
                "name": "Salma District (Home)",
                "level": 0,
                "coord": [
                  44309.2,
                  26738.4
                ],
                "bounds": [
                  [
                    44409.9,
                    26426.2
                  ],
                  [
                    44262.5,
                    26365.6
                  ],
                  [
                    44194.7,
                    26638
                  ],
                  [
                    44128.4,
                    26704.4
                  ],
                  [
                    44054.6,
                    26742.7
                  ],
                  [
                    44054.2,
                    26822.1
                  ],
                  [
                    44129.5,
                    26847.2
                  ],
                  [
                    44224.3,
                    26883.8
                  ],
                  [
                    44296.2,
                    26924.9
                  ],
                  [
                    44344.8,
                    26997.1
                  ],
                  [
                    44427,
                    26942.6
                  ],
                  [
                    44427.7,
                    26872.1
                  ],
                  [
                    44478.9,
                    26761.8
                  ],
                  [
                    44663.5,
                    26630.9
                  ],
                  [
                    44542.4,
                    26517.4
                  ],
                  [
                    44409.9,
                    26426.2
                  ]
                ],
                "id": 187,
                "chat_link": "[&BLsAAAA=]"
              }
            },
            "adventures": [],
            "id": 37,
            "mastery_points": []
          },
          "39": {
            "name": "Mount Maelstrom",
            "min_level": 60,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              52480,
              38912
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {
              "692": {
                "name": "Valley of Gwaun",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52043.2,
                  38152.1
                ],
                "id": 692,
                "chat_link": "[&BLQCAAA=]"
              },
              "693": {
                "name": "Tzanopl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53602.1,
                  40043.4
                ],
                "id": 693,
                "chat_link": "[&BLUCAAA=]"
              },
              "694": {
                "name": "Restless Deeps",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53219.8,
                  39211.5
                ],
                "id": 694,
                "chat_link": "[&BLYCAAA=]"
              },
              "695": {
                "name": "Gorlois Spine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52290.5,
                  38823.6
                ],
                "id": 695,
                "chat_link": "[&BLcCAAA=]"
              },
              "696": {
                "name": "Venomblight",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51840.4,
                  38706.6
                ],
                "id": 696,
                "chat_link": "[&BLgCAAA=]"
              },
              "697": {
                "name": "Gallant's Folly",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52990.7,
                  37978
                ],
                "id": 697,
                "chat_link": "[&BLkCAAA=]"
              },
              "698": {
                "name": "Evisomancer's Resort",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51145.3,
                  38075.8
                ],
                "id": 698,
                "chat_link": "[&BLoCAAA=]"
              },
              "699": {
                "name": "Malxa Pyronetics",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53294.7,
                  39952.2
                ],
                "id": 699,
                "chat_link": "[&BLsCAAA=]"
              },
              "700": {
                "name": "Moonlight Rill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52210.1,
                  37875.9
                ],
                "id": 700,
                "chat_link": "[&BLwCAAA=]"
              },
              "701": {
                "name": "Zone Violet",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54001.7,
                  38431.9
                ],
                "id": 701,
                "chat_link": "[&BL0CAAA=]"
              },
              "702": {
                "name": "Zone White",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53998.8,
                  38066.1
                ],
                "id": 702,
                "chat_link": "[&BL4CAAA=]"
              },
              "703": {
                "name": "Zone Green",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53728.1,
                  37898.9
                ],
                "id": 703,
                "chat_link": "[&BL8CAAA=]"
              },
              "704": {
                "name": "Zone Black",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53421.8,
                  38463.2
                ],
                "id": 704,
                "chat_link": "[&BMACAAA=]"
              },
              "705": {
                "name": "Zone Red",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53383.4,
                  38081
                ],
                "id": 705,
                "chat_link": "[&BMECAAA=]"
              },
              "706": {
                "name": "Zone Blue (Under Construction)",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53740.7,
                  38635.6
                ],
                "id": 706,
                "chat_link": "[&BMICAAA=]"
              },
              "707": {
                "name": "Breth Ayahusasca",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51816.3,
                  38264.9
                ],
                "id": 707,
                "chat_link": "[&BMMCAAA=]"
              },
              "708": {
                "name": "Rata Pten",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50760.5,
                  38673.7
                ],
                "id": 708,
                "chat_link": "[&BMQCAAA=]"
              },
              "709": {
                "name": "Herot's Ascent",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52349.3,
                  39436.7
                ],
                "id": 709,
                "chat_link": "[&BMUCAAA=]"
              },
              "710": {
                "name": "Theurgic Volute",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52187.7,
                  40002.3
                ],
                "id": 710,
                "chat_link": "[&BMYCAAA=]"
              },
              "711": {
                "name": "Murkvale Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50740.4,
                  39671.9
                ],
                "id": 711,
                "chat_link": "[&BMcCAAA=]"
              },
              "712": {
                "name": "Govoran Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50706.2,
                  38116.2
                ],
                "id": 712,
                "chat_link": "[&BMgCAAA=]"
              },
              "713": {
                "name": "Criterion Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51007.6,
                  38441.5
                ],
                "id": 713,
                "chat_link": "[&BMkCAAA=]"
              },
              "714": {
                "name": "Firebreak Fort Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51326.6,
                  38959.6
                ],
                "id": 714,
                "chat_link": "[&BMoCAAA=]"
              },
              "715": {
                "name": "Spaecia Illogica Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51296,
                  39360.4
                ],
                "id": 715,
                "chat_link": "[&BMsCAAA=]"
              },
              "716": {
                "name": "Bard's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51797.3,
                  38107.5
                ],
                "id": 716,
                "chat_link": "[&BMwCAAA=]"
              },
              "717": {
                "name": "Maelstrom's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51987.3,
                  39515.1
                ],
                "id": 717,
                "chat_link": "[&BM0CAAA=]"
              },
              "718": {
                "name": "Ashen Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52162.5,
                  38540
                ],
                "id": 718,
                "chat_link": "[&BM4CAAA=]"
              },
              "719": {
                "name": "Avernan Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52453.3,
                  39564.9
                ],
                "id": 719,
                "chat_link": "[&BM8CAAA=]"
              },
              "720": {
                "name": "Broken Arrow Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52372.1,
                  37859.2
                ],
                "id": 720,
                "chat_link": "[&BNACAAA=]"
              },
              "721": {
                "name": "Oxbow Isle Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52794.1,
                  38992.3
                ],
                "id": 721,
                "chat_link": "[&BNECAAA=]"
              },
              "722": {
                "name": "Irwin Isle Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53195,
                  39622.9
                ],
                "id": 722,
                "chat_link": "[&BNICAAA=]"
              },
              "723": {
                "name": "Gauntlet Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  52967.7,
                  37946.5
                ],
                "id": 723,
                "chat_link": "[&BNMCAAA=]"
              },
              "724": {
                "name": "Old Sledge Site Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53917.5,
                  39300.4
                ],
                "id": 724,
                "chat_link": "[&BNQCAAA=]"
              },
              "725": {
                "name": "Judgment Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54220.8,
                  40050.6
                ],
                "id": 725,
                "chat_link": "[&BNUCAAA=]"
              },
              "726": {
                "name": "Magmatic Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  51773.1,
                  39890.5
                ],
                "id": 726,
                "chat_link": "[&BNYCAAA=]"
              },
              "1346": {
                "name": "Crucible of Eternity Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53743.2,
                  38322.7
                ],
                "id": 1346,
                "chat_link": "[&BEIFAAA=]"
              },
              "1677": {
                "name": "Aquabase Terror Seven",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54053.6,
                  39612.8
                ],
                "id": 1677,
                "chat_link": "[&BI0GAAA=]"
              },
              "1678": {
                "name": "New Skrittstead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51506,
                  38141.2
                ],
                "id": 1678,
                "chat_link": "[&BI4GAAA=]"
              },
              "1679": {
                "name": "Forge Foundations",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53293.4,
                  38852.2
                ],
                "id": 1679,
                "chat_link": "[&BI8GAAA=]"
              },
              "1680": {
                "name": "Gloomirk Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50688.5,
                  39818.5
                ],
                "id": 1680,
                "chat_link": "[&BJAGAAA=]"
              },
              "1681": {
                "name": "Mosstide Walfts",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52994.8,
                  38559.1
                ],
                "id": 1681,
                "chat_link": "[&BJEGAAA=]"
              },
              "1682": {
                "name": "Aliyana's Haunt",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50883.6,
                  39702.1
                ],
                "id": 1682,
                "chat_link": "[&BJIGAAA=]"
              },
              "1683": {
                "name": "Treacherous Vents",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52823.4,
                  39608.1
                ],
                "id": 1683,
                "chat_link": "[&BJMGAAA=]"
              },
              "1684": {
                "name": "Maelstrom's Core",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51938.9,
                  39396.3
                ],
                "id": 1684,
                "chat_link": "[&BJQGAAA=]"
              },
              "1685": {
                "name": "Hellmouth Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52068.3,
                  39789.6
                ],
                "id": 1685,
                "chat_link": "[&BJUGAAA=]"
              },
              "1686": {
                "name": "Felsic Plains",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52368.4,
                  39893
                ],
                "id": 1686,
                "chat_link": "[&BJYGAAA=]"
              },
              "1687": {
                "name": "Clandest Basecamp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53114.1,
                  39545.9
                ],
                "id": 1687,
                "chat_link": "[&BJcGAAA=]"
              },
              "1688": {
                "name": "Lonatl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54268.6,
                  38888.3
                ],
                "id": 1688,
                "chat_link": "[&BJgGAAA=]"
              },
              "1689": {
                "name": "Observation Platform XKV",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53953.4,
                  38916.1
                ],
                "id": 1689,
                "chat_link": "[&BJkGAAA=]"
              },
              "1702": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  53329.5,
                  39368.2
                ],
                "id": 1702,
                "chat_link": "[&BKYGAAA=]"
              },
              "1703": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  50964.3,
                  38685.6
                ],
                "id": 1703,
                "chat_link": "[&BKcGAAA=]"
              },
              "1704": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51906.9,
                  39240
                ],
                "id": 1704,
                "chat_link": "[&BKgGAAA=]"
              },
              "1705": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  53159.3,
                  38254.1
                ],
                "id": 1705,
                "chat_link": "[&BKkGAAA=]"
              },
              "1706": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  53406.8,
                  40025
                ],
                "id": 1706,
                "chat_link": "[&BKoGAAA=]"
              },
              "1707": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  53822.3,
                  39416.6
                ],
                "id": 1707,
                "chat_link": "[&BKsGAAA=]"
              },
              "1708": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  51273.6,
                  38957.2
                ],
                "id": 1708,
                "chat_link": "[&BKwGAAA=]"
              },
              "1738": {
                "name": "Crucible of Eternity",
                "type": "unlock",
                "floor": 1,
                "coord": [
                  53747.7,
                  38279.5
                ],
                "id": 1738,
                "chat_link": "[&BMoGAAA=]",
                "icon": "https://render.guildwars2.com/file/943538394A94A491C8632FBEF6203C2013443555/102478.png"
              }
            },
            "tasks": {
              "278": {
                "objective": "Help the Order of Whispers sabotage Inquest weapon tests on the hylek village of Tzanopl Grounds.",
                "level": 67,
                "coord": [
                  53415.6,
                  39775.8
                ],
                "bounds": [
                  [
                    53359.7,
                    40217.2
                  ],
                  [
                    53128.6,
                    40124.1
                  ],
                  [
                    53055.4,
                    40001
                  ],
                  [
                    53269.4,
                    39743.3
                  ],
                  [
                    53440.3,
                    39689.4
                  ],
                  [
                    53564,
                    39822.1
                  ],
                  [
                    53359.7,
                    40217.2
                  ]
                ],
                "id": 278,
                "chat_link": "[&BBYBAAA=]"
              },
              "279": {
                "objective": "Aid Tactician Blazefur in preparing Firebreak Fort for the Risen offensive.",
                "level": 64,
                "coord": [
                  51265.1,
                  38975.8
                ],
                "bounds": [
                  [
                    51081.2,
                    39264.7
                  ],
                  [
                    51248.3,
                    39287.3
                  ],
                  [
                    51363.4,
                    39151.1
                  ],
                  [
                    51517.3,
                    38954.2
                  ],
                  [
                    51556.2,
                    38841.1
                  ],
                  [
                    51509.5,
                    38745.4
                  ],
                  [
                    51295,
                    38728
                  ],
                  [
                    51160.2,
                    38939.6
                  ],
                  [
                    51033.7,
                    39062.3
                  ],
                  [
                    51049.2,
                    39177.7
                  ],
                  [
                    51081.2,
                    39264.7
                  ]
                ],
                "id": 279,
                "chat_link": "[&BBcBAAA=]"
              },
              "280": {
                "objective": "Help Carmel cleanse the Inquest pollution.",
                "level": 68,
                "coord": [
                  53963.6,
                  39212.1
                ],
                "bounds": [
                  [
                    53826.9,
                    38685.8
                  ],
                  [
                    54172.1,
                    38641.3
                  ],
                  [
                    54349.3,
                    38815.3
                  ],
                  [
                    54247.2,
                    39171
                  ],
                  [
                    54119.4,
                    39387
                  ],
                  [
                    53975.4,
                    39375.5
                  ],
                  [
                    53859.5,
                    39317.2
                  ],
                  [
                    53782.2,
                    39260.8
                  ],
                  [
                    53622.1,
                    39035.8
                  ],
                  [
                    53688.8,
                    38719.7
                  ],
                  [
                    53826.9,
                    38685.8
                  ]
                ],
                "id": 280,
                "chat_link": "[&BBgBAAA=]"
              },
              "281": {
                "objective": "Help Ambr's krewe defend the lab.",
                "level": 65,
                "coord": [
                  51773.2,
                  39934.2
                ],
                "bounds": [
                  [
                    51573.8,
                    39872.3
                  ],
                  [
                    51734.9,
                    39663.6
                  ],
                  [
                    51860.1,
                    39760.4
                  ],
                  [
                    51963.7,
                    39876.7
                  ],
                  [
                    52024.3,
                    40103.4
                  ],
                  [
                    51850,
                    40138
                  ],
                  [
                    51738.6,
                    40071.5
                  ],
                  [
                    51529.8,
                    40020.2
                  ],
                  [
                    51573.8,
                    39872.3
                  ]
                ],
                "id": 281,
                "chat_link": "[&BBkBAAA=]"
              },
              "282": {
                "objective": "Help Pixtor test his weapons on the Risen in Murkvale.",
                "level": 65,
                "coord": [
                  51156.9,
                  39652.3
                ],
                "bounds": [
                  [
                    50739,
                    39309.1
                  ],
                  [
                    50776.4,
                    39139.7
                  ],
                  [
                    50921.8,
                    39110.2
                  ],
                  [
                    51043.9,
                    39208.5
                  ],
                  [
                    51144.5,
                    39401.8
                  ],
                  [
                    51203.6,
                    39569.1
                  ],
                  [
                    51232.5,
                    39789.9
                  ],
                  [
                    51111.7,
                    39920.2
                  ],
                  [
                    50958,
                    40026.9
                  ],
                  [
                    50883.6,
                    39939.3
                  ],
                  [
                    50789.1,
                    39757.7
                  ],
                  [
                    50784.5,
                    39512.1
                  ],
                  [
                    50739,
                    39309.1
                  ]
                ],
                "id": 282,
                "chat_link": "[&BBoBAAA=]"
              },
              "283": {
                "objective": "Help Zara secure and supply Gallant's Folly.",
                "level": 68,
                "coord": [
                  52952.3,
                  38001.5
                ],
                "bounds": [
                  [
                    53273.6,
                    38137.7
                  ],
                  [
                    53287.8,
                    38554.3
                  ],
                  [
                    53157.1,
                    38728
                  ],
                  [
                    53080.1,
                    38840.3
                  ],
                  [
                    52915.5,
                    38885.5
                  ],
                  [
                    52872.9,
                    38887.1
                  ],
                  [
                    52689.7,
                    38692
                  ],
                  [
                    52687.4,
                    38606.7
                  ],
                  [
                    52684.3,
                    38487.9
                  ],
                  [
                    52687.3,
                    38381.6
                  ],
                  [
                    52685.6,
                    38280.1
                  ],
                  [
                    52712.8,
                    38181.2
                  ],
                  [
                    52800,
                    38011.5
                  ],
                  [
                    52926.6,
                    37937.8
                  ],
                  [
                    53059,
                    37944.7
                  ],
                  [
                    53273.6,
                    38137.7
                  ]
                ],
                "id": 283,
                "chat_link": "[&BBsBAAA=]"
              },
              "284": {
                "objective": "Help Pact soldiers secure a path to Orr.",
                "level": 61,
                "coord": [
                  52216,
                  37914.8
                ],
                "bounds": [
                  [
                    51754.1,
                    38243.4
                  ],
                  [
                    51788.4,
                    38164.1
                  ],
                  [
                    51796.8,
                    38068.9
                  ],
                  [
                    51798.1,
                    37994
                  ],
                  [
                    51862.1,
                    37968.7
                  ],
                  [
                    51919.9,
                    37933.5
                  ],
                  [
                    51959.1,
                    37918
                  ],
                  [
                    51985.3,
                    37890.4
                  ],
                  [
                    52003.5,
                    37867.3
                  ],
                  [
                    52020.5,
                    37830
                  ],
                  [
                    52067.5,
                    37805.6
                  ],
                  [
                    52107.8,
                    37797.2
                  ],
                  [
                    52150.9,
                    37771.5
                  ],
                  [
                    52212.6,
                    37773.1
                  ],
                  [
                    52253.2,
                    37769.8
                  ],
                  [
                    52289.7,
                    37788.4
                  ],
                  [
                    52321,
                    37812.6
                  ],
                  [
                    52350.4,
                    37849.2
                  ],
                  [
                    52368.3,
                    37893.9
                  ],
                  [
                    52384.2,
                    37933.1
                  ],
                  [
                    52395.6,
                    37975.4
                  ],
                  [
                    52407,
                    38027
                  ],
                  [
                    52413.1,
                    38071.9
                  ],
                  [
                    52432.9,
                    38153
                  ],
                  [
                    52399.6,
                    38256.2
                  ],
                  [
                    52289.2,
                    38404.8
                  ],
                  [
                    52180.1,
                    38441.9
                  ],
                  [
                    52122.6,
                    38477.7
                  ],
                  [
                    52046.3,
                    38503.4
                  ],
                  [
                    51933.3,
                    38511.2
                  ],
                  [
                    51783.5,
                    38431.6
                  ],
                  [
                    51709.3,
                    38329.1
                  ],
                  [
                    51754.1,
                    38243.4
                  ]
                ],
                "id": 284,
                "chat_link": "[&BBwBAAA=]"
              },
              "285": {
                "objective": "Assist the skritt with their fortifications.",
                "level": 62,
                "coord": [
                  51558.7,
                  38065.4
                ],
                "bounds": [
                  [
                    51017.9,
                    37971.6
                  ],
                  [
                    51055.5,
                    37977.4
                  ],
                  [
                    51087,
                    37959.6
                  ],
                  [
                    51135.4,
                    37948.7
                  ],
                  [
                    51161.4,
                    37929.3
                  ],
                  [
                    51200.6,
                    37906
                  ],
                  [
                    51252.4,
                    37890
                  ],
                  [
                    51281.4,
                    37861.2
                  ],
                  [
                    51317.3,
                    37813.1
                  ],
                  [
                    51361.7,
                    37805.6
                  ],
                  [
                    51493.8,
                    37810.6
                  ],
                  [
                    51559.7,
                    37825.7
                  ],
                  [
                    51624,
                    37860
                  ],
                  [
                    51683,
                    37863.4
                  ],
                  [
                    51796.5,
                    37899.5
                  ],
                  [
                    51793,
                    37945.7
                  ],
                  [
                    51759.5,
                    37966.2
                  ],
                  [
                    51757.1,
                    37982.1
                  ],
                  [
                    51751.6,
                    38050.6
                  ],
                  [
                    51757.6,
                    38130.8
                  ],
                  [
                    51778.8,
                    38170.7
                  ],
                  [
                    51729.1,
                    38232.8
                  ],
                  [
                    51704.6,
                    38330.9
                  ],
                  [
                    51646.9,
                    38441.2
                  ],
                  [
                    51593.4,
                    38547.2
                  ],
                  [
                    51550.4,
                    38625.4
                  ],
                  [
                    51528.3,
                    38695.1
                  ],
                  [
                    51533.6,
                    38706.8
                  ],
                  [
                    51488.6,
                    38751.6
                  ],
                  [
                    51463,
                    38754.3
                  ],
                  [
                    51403,
                    38707.3
                  ],
                  [
                    51393.4,
                    38673.8
                  ],
                  [
                    51353.5,
                    38604.2
                  ],
                  [
                    51371.5,
                    38544.4
                  ],
                  [
                    51336.9,
                    38480.3
                  ],
                  [
                    51307.2,
                    38463.2
                  ],
                  [
                    51270.4,
                    38440.1
                  ],
                  [
                    51235,
                    38435
                  ],
                  [
                    51193.3,
                    38447.4
                  ],
                  [
                    51165.8,
                    38427.7
                  ],
                  [
                    51138.8,
                    38391.9
                  ],
                  [
                    51105.9,
                    38348.6
                  ],
                  [
                    51044.1,
                    38310.6
                  ],
                  [
                    51006.3,
                    38254.9
                  ],
                  [
                    50972.3,
                    38198.8
                  ],
                  [
                    50955.3,
                    38136
                  ],
                  [
                    50940.4,
                    38067.3
                  ],
                  [
                    50965.9,
                    38013.9
                  ],
                  [
                    50986.9,
                    37970.2
                  ],
                  [
                    51017.9,
                    37971.6
                  ]
                ],
                "id": 285,
                "chat_link": "[&BB0BAAA=]"
              },
              "286": {
                "objective": "Help Jenrys protect nature from the Inquest.",
                "level": 69,
                "coord": [
                  54208.9,
                  39832.8
                ],
                "bounds": [
                  [
                    54247.1,
                    39692.1
                  ],
                  [
                    54207.6,
                    39488.5
                  ],
                  [
                    54073.5,
                    39408.4
                  ],
                  [
                    53948.6,
                    39427.8
                  ],
                  [
                    53825.3,
                    39454
                  ],
                  [
                    53714.6,
                    39545.2
                  ],
                  [
                    53690.3,
                    39645.7
                  ],
                  [
                    53728.7,
                    39761.9
                  ],
                  [
                    53798.6,
                    39857.4
                  ],
                  [
                    53925.1,
                    39915.1
                  ],
                  [
                    54214.5,
                    39844.2
                  ],
                  [
                    54247.1,
                    39692.1
                  ]
                ],
                "id": 286,
                "chat_link": "[&BB4BAAA=]"
              },
              "287": {
                "objective": "Help the Priory members excavate Rata Pten.",
                "level": 63,
                "coord": [
                  50829.6,
                  38541.1
                ],
                "bounds": [
                  [
                    50849.9,
                    38537.2
                  ],
                  [
                    50865.2,
                    38547.1
                  ],
                  [
                    50875.4,
                    38561.2
                  ],
                  [
                    50889.1,
                    38576.3
                  ],
                  [
                    50898.5,
                    38596.1
                  ],
                  [
                    50914.9,
                    38621.8
                  ],
                  [
                    50927.7,
                    38639.6
                  ],
                  [
                    50938.6,
                    38648.2
                  ],
                  [
                    50972.3,
                    38655.6
                  ],
                  [
                    50951.9,
                    38719.8
                  ],
                  [
                    50929.8,
                    38741.8
                  ],
                  [
                    50912.6,
                    38757.7
                  ],
                  [
                    50906.6,
                    38772.8
                  ],
                  [
                    50902.7,
                    38785.6
                  ],
                  [
                    50899.4,
                    38798.7
                  ],
                  [
                    50896.9,
                    38809.3
                  ],
                  [
                    50890.6,
                    38827.1
                  ],
                  [
                    50872.4,
                    38819.4
                  ],
                  [
                    50851.2,
                    38821.3
                  ],
                  [
                    50811.8,
                    38824.3
                  ],
                  [
                    50797.8,
                    38820.6
                  ],
                  [
                    50784.7,
                    38821.7
                  ],
                  [
                    50769.9,
                    38818.9
                  ],
                  [
                    50761.5,
                    38815.4
                  ],
                  [
                    50766.5,
                    38796.3
                  ],
                  [
                    50749.7,
                    38774.1
                  ],
                  [
                    50729,
                    38747.9
                  ],
                  [
                    50690.2,
                    38730.6
                  ],
                  [
                    50683.3,
                    38696.6
                  ],
                  [
                    50689.5,
                    38646.6
                  ],
                  [
                    50681.3,
                    38591.3
                  ],
                  [
                    50703.4,
                    38572.4
                  ],
                  [
                    50713.8,
                    38552.5
                  ],
                  [
                    50728,
                    38539.8
                  ],
                  [
                    50749.8,
                    38530.5
                  ],
                  [
                    50777.1,
                    38523.1
                  ],
                  [
                    50805.6,
                    38524.2
                  ],
                  [
                    50829.4,
                    38527.7
                  ],
                  [
                    50849.9,
                    38537.2
                  ]
                ],
                "id": 287,
                "chat_link": "[&BB8BAAA=]"
              },
              "288": {
                "objective": "Help the Order of Whispers instigate a fight between krait and Risen.",
                "level": 66,
                "coord": [
                  52745.9,
                  39012.5
                ],
                "bounds": [
                  [
                    53340.5,
                    39502.3
                  ],
                  [
                    53405.9,
                    39528.7
                  ],
                  [
                    53452.1,
                    39533.6
                  ],
                  [
                    53513.5,
                    39515.9
                  ],
                  [
                    53555.3,
                    39404.3
                  ],
                  [
                    53559.7,
                    39269.2
                  ],
                  [
                    53507.6,
                    39143.9
                  ],
                  [
                    53455,
                    39107.6
                  ],
                  [
                    53390.8,
                    39078
                  ],
                  [
                    53353.8,
                    38993.8
                  ],
                  [
                    53323.2,
                    38967.7
                  ],
                  [
                    53282.8,
                    38953.6
                  ],
                  [
                    53248.1,
                    38952.3
                  ],
                  [
                    53214.7,
                    38952.1
                  ],
                  [
                    53188,
                    38948
                  ],
                  [
                    53143.3,
                    38945.8
                  ],
                  [
                    53100.7,
                    38946.5
                  ],
                  [
                    53056.8,
                    38955.5
                  ],
                  [
                    53009.1,
                    38960.3
                  ],
                  [
                    52961.9,
                    38954.8
                  ],
                  [
                    52897.6,
                    38944.1
                  ],
                  [
                    52845.1,
                    38954.4
                  ],
                  [
                    52798.8,
                    38957.6
                  ],
                  [
                    52767.5,
                    38970.9
                  ],
                  [
                    52740.4,
                    38982.7
                  ],
                  [
                    52730.5,
                    39008.6
                  ],
                  [
                    52724.9,
                    39036.3
                  ],
                  [
                    52730,
                    39069.3
                  ],
                  [
                    52748.5,
                    39132.4
                  ],
                  [
                    52785.1,
                    39165.9
                  ],
                  [
                    52832.5,
                    39178.6
                  ],
                  [
                    52870.3,
                    39200.6
                  ],
                  [
                    52907.3,
                    39232.2
                  ],
                  [
                    52945.1,
                    39262.1
                  ],
                  [
                    52982.7,
                    39289.9
                  ],
                  [
                    53031.7,
                    39322.7
                  ],
                  [
                    53068.4,
                    39333.7
                  ],
                  [
                    53139.8,
                    39377.8
                  ],
                  [
                    53255.3,
                    39462.6
                  ],
                  [
                    53306.2,
                    39488.9
                  ],
                  [
                    53340.5,
                    39502.3
                  ]
                ],
                "id": 288,
                "chat_link": "[&BCABAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  53729.5,
                  37888.8
                ],
                "id": "0-109"
              },
              {
                "coord": [
                  53635.1,
                  40048.7
                ],
                "id": "0-114"
              },
              {
                "coord": [
                  52919.7,
                  39694.9
                ],
                "id": "0-110"
              },
              {
                "coord": [
                  53643.6,
                  39219.6
                ],
                "id": "0-113"
              },
              {
                "coord": [
                  51766.5,
                  39307.3
                ],
                "id": "0-108"
              },
              {
                "coord": [
                  53353.1,
                  38851.7
                ],
                "id": "0-199"
              },
              {
                "coord": [
                  50842.6,
                  39866.2
                ],
                "id": "0-111"
              }
            ],
            "sectors": {
              "628": {
                "name": "The Mire Sea",
                "level": 67,
                "coord": [
                  53266.4,
                  39193.6
                ],
                "bounds": [
                  [
                    53159.7,
                    39398
                  ],
                  [
                    52697.9,
                    39135.6
                  ],
                  [
                    52680.7,
                    38944
                  ],
                  [
                    52757.6,
                    38730.2
                  ],
                  [
                    52993.3,
                    38773.5
                  ],
                  [
                    53056.9,
                    38915.5
                  ],
                  [
                    53230.1,
                    38890.3
                  ],
                  [
                    53368.6,
                    39021
                  ],
                  [
                    53650.1,
                    39074.5
                  ],
                  [
                    53898,
                    39345.2
                  ],
                  [
                    53817.2,
                    39399.3
                  ],
                  [
                    53676.3,
                    39702.6
                  ],
                  [
                    53425,
                    39666.5
                  ],
                  [
                    53318.8,
                    39713.9
                  ],
                  [
                    53159.7,
                    39398
                  ]
                ],
                "id": 628,
                "chat_link": "[&BHQCAAA=]"
              },
              "629": {
                "name": "Benthic Kelp Beds",
                "level": 68,
                "coord": [
                  54019.2,
                  39685.7
                ],
                "bounds": [
                  [
                    53743.2,
                    39840.5
                  ],
                  [
                    53749.3,
                    39781.8
                  ],
                  [
                    53676.3,
                    39699.6
                  ],
                  [
                    53816.3,
                    39395.5
                  ],
                  [
                    53895.6,
                    39343.7
                  ],
                  [
                    54118.2,
                    39358.2
                  ],
                  [
                    54245.3,
                    39162
                  ],
                  [
                    54309.1,
                    39267.7
                  ],
                  [
                    54299.6,
                    39771.7
                  ],
                  [
                    54215.3,
                    39832.8
                  ],
                  [
                    54154.5,
                    40119.1
                  ],
                  [
                    54079.6,
                    40175.3
                  ],
                  [
                    53947.3,
                    40166.8
                  ],
                  [
                    53743.2,
                    39840.5
                  ]
                ],
                "id": 629,
                "chat_link": "[&BHUCAAA=]"
              },
              "630": {
                "name": "Sunken Droknah",
                "level": 67,
                "coord": [
                  53578.4,
                  38885.4
                ],
                "bounds": [
                  [
                    53231.1,
                    38892
                  ],
                  [
                    53281.7,
                    38731.1
                  ],
                  [
                    53548.2,
                    38573.8
                  ],
                  [
                    53853.7,
                    38777.3
                  ],
                  [
                    53856.5,
                    38910.2
                  ],
                  [
                    53753.8,
                    38990.9
                  ],
                  [
                    53664.3,
                    38989
                  ],
                  [
                    53648.8,
                    39079.7
                  ],
                  [
                    53367.1,
                    39024.3
                  ],
                  [
                    53231.1,
                    38892
                  ]
                ],
                "id": 630,
                "chat_link": "[&BHYCAAA=]"
              },
              "631": {
                "name": "Irwin Isle",
                "level": 67,
                "coord": [
                  52783.6,
                  39451.8
                ],
                "bounds": [
                  [
                    52787,
                    39896.7
                  ],
                  [
                    52683.9,
                    39684.1
                  ],
                  [
                    52666,
                    39501.3
                  ],
                  [
                    52508.6,
                    39404.4
                  ],
                  [
                    52435.5,
                    39293.3
                  ],
                  [
                    52429.4,
                    39100.1
                  ],
                  [
                    52489.2,
                    38946.1
                  ],
                  [
                    52685.5,
                    38940.8
                  ],
                  [
                    52699.4,
                    39129.2
                  ],
                  [
                    53162.5,
                    39399.5
                  ],
                  [
                    53317.8,
                    39712.4
                  ],
                  [
                    53260.9,
                    39893.2
                  ],
                  [
                    53061.3,
                    39972.3
                  ],
                  [
                    52787,
                    39896.7
                  ]
                ],
                "id": 631,
                "chat_link": "[&BHcCAAA=]"
              },
              "632": {
                "name": "The Stychs",
                "level": 67,
                "coord": [
                  53332.4,
                  39924.5
                ],
                "bounds": [
                  [
                    53261.1,
                    39892.5
                  ],
                  [
                    53319.5,
                    39712.5
                  ],
                  [
                    53424.8,
                    39666.6
                  ],
                  [
                    53676.9,
                    39701.1
                  ],
                  [
                    53749.1,
                    39781
                  ],
                  [
                    53743.2,
                    39839.3
                  ],
                  [
                    53942.1,
                    40160.2
                  ],
                  [
                    53377.2,
                    40137
                  ],
                  [
                    53242.8,
                    40096.5
                  ],
                  [
                    53011.7,
                    40143.6
                  ],
                  [
                    52725.9,
                    40024
                  ],
                  [
                    52785.9,
                    39890.9
                  ],
                  [
                    53060.5,
                    39973.4
                  ],
                  [
                    53261.1,
                    39892.5
                  ]
                ],
                "id": 632,
                "chat_link": "[&BHgCAAA=]"
              },
              "633": {
                "name": "Dysphoric Rim",
                "level": 65,
                "coord": [
                  51324,
                  39659.2
                ],
                "bounds": [
                  [
                    51092.6,
                    39913.1
                  ],
                  [
                    50929.2,
                    39460.8
                  ],
                  [
                    51129.6,
                    39205.5
                  ],
                  [
                    51450.7,
                    39294.2
                  ],
                  [
                    51479.2,
                    39562.4
                  ],
                  [
                    51511,
                    39734.5
                  ],
                  [
                    51582,
                    39791.9
                  ],
                  [
                    51472.5,
                    39971
                  ],
                  [
                    51269.6,
                    39999.1
                  ],
                  [
                    51092.6,
                    39913.1
                  ]
                ],
                "id": 633,
                "chat_link": "[&BHkCAAA=]"
              },
              "634": {
                "name": "Murkvale",
                "level": 65,
                "coord": [
                  50745.4,
                  39658.6
                ],
                "bounds": [
                  [
                    50974.3,
                    40160.4
                  ],
                  [
                    50836.6,
                    40095.1
                  ],
                  [
                    50688.7,
                    40120
                  ],
                  [
                    50544.1,
                    40088.8
                  ],
                  [
                    50518.2,
                    39975.4
                  ],
                  [
                    50520.8,
                    39804.2
                  ],
                  [
                    50557.1,
                    39734.8
                  ],
                  [
                    50555.3,
                    39558.1
                  ],
                  [
                    50535.4,
                    39463.1
                  ],
                  [
                    50497.6,
                    39258.6
                  ],
                  [
                    50544.3,
                    39117
                  ],
                  [
                    50631.2,
                    39101.8
                  ],
                  [
                    51027.7,
                    39071.5
                  ],
                  [
                    51125.7,
                    39205.6
                  ],
                  [
                    50932.3,
                    39463.3
                  ],
                  [
                    51090.4,
                    39908.7
                  ],
                  [
                    51091.7,
                    40070
                  ],
                  [
                    50974.3,
                    40160.4
                  ]
                ],
                "id": 634,
                "chat_link": "[&BHoCAAA=]"
              },
              "635": {
                "name": "Judgment Rock",
                "level": 69,
                "coord": [
                  54312.3,
                  40017.9
                ],
                "bounds": [
                  [
                    54156.4,
                    40116.7
                  ],
                  [
                    54214.5,
                    39831.3
                  ],
                  [
                    54299.1,
                    39770.5
                  ],
                  [
                    54352.6,
                    39943.3
                  ],
                  [
                    54360.5,
                    40079
                  ],
                  [
                    54399.9,
                    40065.3
                  ],
                  [
                    54399,
                    40135
                  ],
                  [
                    54347,
                    40142.3
                  ],
                  [
                    54281.5,
                    40077.8
                  ],
                  [
                    54156.4,
                    40116.7
                  ]
                ],
                "id": 635,
                "chat_link": "[&BHsCAAA=]"
              },
              "636": {
                "name": "Gauntlet Gulch",
                "level": 67,
                "coord": [
                  53045.6,
                  38288.9
                ],
                "bounds": [
                  [
                    52756.9,
                    38736.3
                  ],
                  [
                    52604.1,
                    38531.3
                  ],
                  [
                    52689.6,
                    38354.4
                  ],
                  [
                    52703.1,
                    38126.3
                  ],
                  [
                    52813.3,
                    38053.6
                  ],
                  [
                    52860.5,
                    37969.4
                  ],
                  [
                    52816.7,
                    37762.1
                  ],
                  [
                    52952.9,
                    37731.9
                  ],
                  [
                    53117.2,
                    37741.5
                  ],
                  [
                    53385.1,
                    37839.3
                  ],
                  [
                    53322.2,
                    37927.1
                  ],
                  [
                    53327.6,
                    38054.4
                  ],
                  [
                    53358.3,
                    38463.2
                  ],
                  [
                    53547.9,
                    38579
                  ],
                  [
                    53285,
                    38733.5
                  ],
                  [
                    53229.6,
                    38895.4
                  ],
                  [
                    53057.5,
                    38920.5
                  ],
                  [
                    52993.1,
                    38780.4
                  ],
                  [
                    52756.9,
                    38736.3
                  ]
                ],
                "id": 636,
                "chat_link": "[&BHwCAAA=]"
              },
              "637": {
                "name": "Govoran Terraces",
                "level": 63,
                "coord": [
                  50860.2,
                  38065.1
                ],
                "bounds": [
                  [
                    50489.6,
                    38081.8
                  ],
                  [
                    50523.3,
                    37970
                  ],
                  [
                    50668.6,
                    38089.1
                  ],
                  [
                    50766.7,
                    38006.8
                  ],
                  [
                    50931.6,
                    37816.3
                  ],
                  [
                    51013.7,
                    37804.3
                  ],
                  [
                    51225.5,
                    37821.3
                  ],
                  [
                    51265,
                    37941
                  ],
                  [
                    51290,
                    38014.9
                  ],
                  [
                    51273.8,
                    38309.4
                  ],
                  [
                    50608.3,
                    38449.9
                  ],
                  [
                    50558.1,
                    38362.1
                  ],
                  [
                    50568.9,
                    38179.8
                  ],
                  [
                    50489.6,
                    38081.8
                  ]
                ],
                "id": 637,
                "chat_link": "[&BH0CAAA=]"
              },
              "638": {
                "name": "Broken Arrow River",
                "level": 61,
                "coord": [
                  52475.9,
                  38261.5
                ],
                "bounds": [
                  [
                    52251.8,
                    38508
                  ],
                  [
                    52066.3,
                    37885.1
                  ],
                  [
                    52103.4,
                    37745
                  ],
                  [
                    52267.9,
                    37695.8
                  ],
                  [
                    52519.5,
                    37758.1
                  ],
                  [
                    52571.8,
                    37916.7
                  ],
                  [
                    52702.4,
                    38126.7
                  ],
                  [
                    52688.8,
                    38354.3
                  ],
                  [
                    52604.6,
                    38531.3
                  ],
                  [
                    52763.3,
                    38725
                  ],
                  [
                    52682.1,
                    38946
                  ],
                  [
                    52489.3,
                    38946.5
                  ],
                  [
                    52251.8,
                    38508
                  ]
                ],
                "id": 638,
                "chat_link": "[&BH4CAAA=]"
              },
              "639": {
                "name": "Quandry Scratch",
                "level": 62,
                "coord": [
                  51391.4,
                  38064.7
                ],
                "bounds": [
                  [
                    51339.3,
                    38479.8
                  ],
                  [
                    51269.8,
                    38311.5
                  ],
                  [
                    51289.8,
                    38015.7
                  ],
                  [
                    51261.3,
                    37940.4
                  ],
                  [
                    51223,
                    37825.6
                  ],
                  [
                    51371.3,
                    37770.5
                  ],
                  [
                    51585.5,
                    37779.7
                  ],
                  [
                    51687.1,
                    37920.1
                  ],
                  [
                    51496.1,
                    38538.7
                  ],
                  [
                    51339.3,
                    38479.8
                  ]
                ],
                "id": 639,
                "chat_link": "[&BH8CAAA=]"
              },
              "640": {
                "name": "Bard's Valley",
                "level": 61,
                "coord": [
                  51861.6,
                  38159.3
                ],
                "bounds": [
                  [
                    51494.8,
                    38532.7
                  ],
                  [
                    51686.7,
                    37917.9
                  ],
                  [
                    51661.9,
                    37800.5
                  ],
                  [
                    51848.2,
                    37754.1
                  ],
                  [
                    52018.3,
                    37775.4
                  ],
                  [
                    52068.3,
                    37884
                  ],
                  [
                    52255.5,
                    38510.9
                  ],
                  [
                    51947.8,
                    38554.3
                  ],
                  [
                    51773.3,
                    38704.2
                  ],
                  [
                    51494.8,
                    38532.7
                  ]
                ],
                "id": 640,
                "chat_link": "[&BIACAAA=]"
              },
              "641": {
                "name": "Criterion Canyon",
                "level": 63,
                "coord": [
                  50955.3,
                  38714.6
                ],
                "bounds": [
                  [
                    50630.6,
                    39103.2
                  ],
                  [
                    50566,
                    39071.7
                  ],
                  [
                    50532.7,
                    38844.7
                  ],
                  [
                    50537.2,
                    38621.4
                  ],
                  [
                    50590.9,
                    38512.8
                  ],
                  [
                    50609.6,
                    38453.3
                  ],
                  [
                    51273.7,
                    38310
                  ],
                  [
                    51342.1,
                    38472.2
                  ],
                  [
                    51495.4,
                    38533.5
                  ],
                  [
                    51426.9,
                    38677.8
                  ],
                  [
                    51242.3,
                    38785
                  ],
                  [
                    51143.2,
                    38834
                  ],
                  [
                    51027.8,
                    39070.2
                  ],
                  [
                    50630.6,
                    39103.2
                  ]
                ],
                "id": 641,
                "chat_link": "[&BIECAAA=]"
              },
              "642": {
                "name": "Whitland Flats",
                "level": 68,
                "coord": [
                  53950.1,
                  38930.3
                ],
                "bounds": [
                  [
                    53894.8,
                    39345.8
                  ],
                  [
                    53651.5,
                    39080.2
                  ],
                  [
                    53660.9,
                    38988.3
                  ],
                  [
                    53752.8,
                    38984.3
                  ],
                  [
                    53852.6,
                    38911.5
                  ],
                  [
                    53853.5,
                    38778.1
                  ],
                  [
                    53736.9,
                    38701.6
                  ],
                  [
                    54033.1,
                    38560.7
                  ],
                  [
                    54151.3,
                    38574
                  ],
                  [
                    54339.3,
                    38863.8
                  ],
                  [
                    54357.5,
                    39012.8
                  ],
                  [
                    54116.9,
                    39362.1
                  ],
                  [
                    53894.8,
                    39345.8
                  ]
                ],
                "id": 642,
                "chat_link": "[&BIICAAA=]"
              },
              "643": {
                "name": "Unguent Den",
                "level": 68,
                "coord": [
                  52701.2,
                  37882.1
                ],
                "bounds": [
                  [
                    52701.4,
                    38127.8
                  ],
                  [
                    52572.9,
                    37917.9
                  ],
                  [
                    52519.3,
                    37756.1
                  ],
                  [
                    52592.4,
                    37735.9
                  ],
                  [
                    52731.4,
                    37736.3
                  ],
                  [
                    52816.7,
                    37761.9
                  ],
                  [
                    52860.6,
                    37968.6
                  ],
                  [
                    52814.8,
                    38052.5
                  ],
                  [
                    52701.4,
                    38127.8
                  ]
                ],
                "id": 643,
                "chat_link": "[&BIMCAAA=]"
              },
              "644": {
                "name": "Magmatic Conjury",
                "level": 65,
                "coord": [
                  51653.8,
                  39744.7
                ],
                "bounds": [
                  [
                    51800.1,
                    39887.6
                  ],
                  [
                    51658.3,
                    39850.4
                  ],
                  [
                    51582.2,
                    39790.5
                  ],
                  [
                    51513,
                    39733.1
                  ],
                  [
                    51479.1,
                    39563.8
                  ],
                  [
                    51700,
                    39681.4
                  ],
                  [
                    51843.8,
                    39706
                  ],
                  [
                    51800.1,
                    39887.6
                  ]
                ],
                "id": 644,
                "chat_link": "[&BIQCAAA=]"
              },
              "645": {
                "name": "Maelstrom's Bile",
                "level": 66,
                "coord": [
                  51805.5,
                  39351.4
                ],
                "bounds": [
                  [
                    51699.1,
                    39683.2
                  ],
                  [
                    51480.4,
                    39560.8
                  ],
                  [
                    51451.9,
                    39298.6
                  ],
                  [
                    51513.4,
                    39136.7
                  ],
                  [
                    51626.5,
                    38966.4
                  ],
                  [
                    51798.4,
                    38900.2
                  ],
                  [
                    51996.1,
                    39056.3
                  ],
                  [
                    52180.9,
                    39197.3
                  ],
                  [
                    52235.5,
                    39416.3
                  ],
                  [
                    51999.2,
                    39638.3
                  ],
                  [
                    51842.7,
                    39655.2
                  ],
                  [
                    51841.6,
                    39707.5
                  ],
                  [
                    51699.1,
                    39683.2
                  ]
                ],
                "id": 645,
                "chat_link": "[&BIUCAAA=]"
              },
              "646": {
                "name": "Sootberme",
                "level": 64,
                "coord": [
                  51446.6,
                  38907.6
                ],
                "bounds": [
                  [
                    51027,
                    39079.3
                  ],
                  [
                    51135.2,
                    38832
                  ],
                  [
                    51241.4,
                    38786.5
                  ],
                  [
                    51427.3,
                    38671.9
                  ],
                  [
                    51497.2,
                    38531.4
                  ],
                  [
                    51773.6,
                    38703.1
                  ],
                  [
                    51738.9,
                    38779.7
                  ],
                  [
                    51799.9,
                    38898.5
                  ],
                  [
                    51628.2,
                    38965.6
                  ],
                  [
                    51512.7,
                    39136.6
                  ],
                  [
                    51451.9,
                    39295.1
                  ],
                  [
                    51126.1,
                    39212.1
                  ],
                  [
                    51027,
                    39079.3
                  ]
                ],
                "id": 646,
                "chat_link": "[&BIYCAAA=]"
              },
              "647": {
                "name": "Ashen Waste",
                "level": 65,
                "coord": [
                  52169.8,
                  39023.4
                ],
                "bounds": [
                  [
                    51737.4,
                    38779.8
                  ],
                  [
                    51771.6,
                    38702.9
                  ],
                  [
                    51947.1,
                    38554.7
                  ],
                  [
                    52255.3,
                    38509.3
                  ],
                  [
                    52489.8,
                    38950.5
                  ],
                  [
                    52431.9,
                    39105.5
                  ],
                  [
                    52437.9,
                    39290.7
                  ],
                  [
                    52507.8,
                    39396.6
                  ],
                  [
                    52424.2,
                    39432
                  ],
                  [
                    52236,
                    39421
                  ],
                  [
                    52177,
                    39199.3
                  ],
                  [
                    51993.5,
                    39057
                  ],
                  [
                    51797.5,
                    38904.3
                  ],
                  [
                    51737.4,
                    38779.8
                  ]
                ],
                "id": 647,
                "chat_link": "[&BIcCAAA=]"
              },
              "648": {
                "name": "Avernan Volatile",
                "level": 65,
                "coord": [
                  52483.6,
                  39673.6
                ],
                "bounds": [
                  [
                    52059,
                    39590.5
                  ],
                  [
                    52233.1,
                    39420.1
                  ],
                  [
                    52424.7,
                    39434.2
                  ],
                  [
                    52508.6,
                    39392
                  ],
                  [
                    52672.1,
                    39500.4
                  ],
                  [
                    52686.5,
                    39689.1
                  ],
                  [
                    52785.4,
                    39894.4
                  ],
                  [
                    52726.7,
                    40025.6
                  ],
                  [
                    52255.8,
                    40115.8
                  ],
                  [
                    52059,
                    39590.5
                  ]
                ],
                "id": 648,
                "chat_link": "[&BIgCAAA=]"
              },
              "649": {
                "name": "Mon Maelstrom",
                "level": 65,
                "coord": [
                  51785.3,
                  39881.4
                ],
                "bounds": [
                  [
                    51876.6,
                    40154.4
                  ],
                  [
                    51554.4,
                    40142.3
                  ],
                  [
                    51483.7,
                    40073.1
                  ],
                  [
                    51472.6,
                    39969.7
                  ],
                  [
                    51583.5,
                    39790.1
                  ],
                  [
                    51657.6,
                    39850.4
                  ],
                  [
                    51800,
                    39887.6
                  ],
                  [
                    51841.2,
                    39708.1
                  ],
                  [
                    51840.2,
                    39655.3
                  ],
                  [
                    51997.9,
                    39641
                  ],
                  [
                    52057.7,
                    39591.7
                  ],
                  [
                    52257.9,
                    40113
                  ],
                  [
                    51876.6,
                    40154.4
                  ]
                ],
                "id": 649,
                "chat_link": "[&BIkCAAA=]"
              },
              "651": {
                "name": "Infinity Coil",
                "level": 69,
                "coord": [
                  53696.3,
                  38071.6
                ],
                "bounds": [
                  [
                    53355.6,
                    38466.7
                  ],
                  [
                    53325.4,
                    38063.5
                  ],
                  [
                    53323.4,
                    37926.8
                  ],
                  [
                    53409.8,
                    37802.4
                  ],
                  [
                    53670.2,
                    37693.6
                  ],
                  [
                    53964,
                    37706.2
                  ],
                  [
                    54089.4,
                    37796.4
                  ],
                  [
                    54053.9,
                    37995.7
                  ],
                  [
                    54034.7,
                    38561.9
                  ],
                  [
                    53736.9,
                    38702.5
                  ],
                  [
                    53355.6,
                    38466.7
                  ]
                ],
                "id": 651,
                "chat_link": "[&BIsCAAA=]"
              },
              "1059": {
                "name": "Cubular Fells",
                "level": 62,
                "coord": [
                  50714.5,
                  37913.5
                ],
                "bounds": [
                  [
                    50526.4,
                    37969.6
                  ],
                  [
                    50668.6,
                    38089.9
                  ],
                  [
                    50767.4,
                    38007.1
                  ],
                  [
                    50894,
                    37861
                  ],
                  [
                    50809.1,
                    37774.6
                  ],
                  [
                    50621.7,
                    37778.6
                  ],
                  [
                    50526.4,
                    37969.6
                  ]
                ],
                "id": 1059,
                "chat_link": "[&BCMEAAA=]"
              },
              "1076": {
                "name": "Dierdre's Steps",
                "level": 69,
                "coord": [
                  54218.1,
                  38231.4
                ],
                "bounds": [
                  [
                    54052.1,
                    37996.6
                  ],
                  [
                    54089.3,
                    37794.8
                  ],
                  [
                    54429.8,
                    37922.4
                  ],
                  [
                    54412.6,
                    38523.6
                  ],
                  [
                    54289.6,
                    38591.3
                  ],
                  [
                    54035.4,
                    38559.9
                  ],
                  [
                    54052.1,
                    37996.6
                  ]
                ],
                "id": 1076,
                "chat_link": "[&BDQEAAA=]"
              }
            },
            "adventures": [],
            "id": 39,
            "mastery_points": [
              {
                "coord": [
                  52075.4,
                  39509.6
                ],
                "id": 314,
                "region": "Tyria"
              }
            ]
          },
          "53": {
            "name": "Sparkfly Fen",
            "min_level": 55,
            "max_level": 65,
            "default_floor": 1,
            "label_coord": [
              49280,
              37120
            ],
            "map_rect": [
              [
                -30720,
                -39936
              ],
              [
                30720,
                39936
              ]
            ],
            "continent_rect": [
              [
                48000,
                35456
              ],
              [
                50560,
                38784
              ]
            ],
            "points_of_interest": {
              "433": {
                "name": "Deadman's Reach",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48691.6,
                  35667.5
                ],
                "id": 433,
                "chat_link": "[&BLEBAAA=]"
              },
              "434": {
                "name": "Porgotl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49891.1,
                  36129.1
                ],
                "id": 434,
                "chat_link": "[&BLIBAAA=]"
              },
              "435": {
                "name": "Occuintl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50167.8,
                  36444.5
                ],
                "id": 435,
                "chat_link": "[&BLMBAAA=]"
              },
              "436": {
                "name": "Nicantl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48410.6,
                  36078.1
                ],
                "id": 436,
                "chat_link": "[&BLQBAAA=]"
              },
              "437": {
                "name": "The Tower of Modius",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48455.9,
                  36444
                ],
                "id": 437,
                "chat_link": "[&BLUBAAA=]"
              },
              "438": {
                "name": "Quinatl Deadgrounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48688.7,
                  36627.3
                ],
                "id": 438,
                "chat_link": "[&BLYBAAA=]"
              },
              "439": {
                "name": "Sunken Chaladeen",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48940.7,
                  36983.3
                ],
                "id": 439,
                "chat_link": "[&BLcBAAA=]"
              },
              "440": {
                "name": "Jinotl Deadgrounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49554.8,
                  37613
                ],
                "id": 440,
                "chat_link": "[&BLgBAAA=]"
              },
              "441": {
                "name": "Brokenhope Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50356.1,
                  37633.5
                ],
                "id": 441,
                "chat_link": "[&BLkBAAA=]"
              },
              "442": {
                "name": "Shrine of Usharr",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49303.3,
                  37287.2
                ],
                "id": 442,
                "chat_link": "[&BLoBAAA=]"
              },
              "443": {
                "name": "Inquest Hexfoundry G-14",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50327.8,
                  38308.3
                ],
                "id": 443,
                "chat_link": "[&BLsBAAA=]"
              },
              "444": {
                "name": "Ruined Vallah",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48888.5,
                  37830.5
                ],
                "id": 444,
                "chat_link": "[&BLwBAAA=]"
              },
              "445": {
                "name": "United Arcanist Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48632,
                  38125.8
                ],
                "id": 445,
                "chat_link": "[&BL0BAAA=]"
              },
              "446": {
                "name": "Fabled Djannor",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48523.3,
                  38353.9
                ],
                "id": 446,
                "chat_link": "[&BL4BAAA=]"
              },
              "447": {
                "name": "Wrathwave Deeps",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48160.8,
                  38009
                ],
                "id": 447,
                "chat_link": "[&BL8BAAA=]"
              },
              "448": {
                "name": "Wreck of the Argent Warrior",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48514.2,
                  37314.9
                ],
                "id": 448,
                "chat_link": "[&BMABAAA=]"
              },
              "449": {
                "name": "Shorewatch Post",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48991.6,
                  36436.7
                ],
                "id": 449,
                "chat_link": "[&BMEBAAA=]"
              },
              "450": {
                "name": "Swampwatch Post",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49559,
                  36192.7
                ],
                "id": 450,
                "chat_link": "[&BMIBAAA=]"
              },
              "451": {
                "name": "Southwatch Post",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49209.2,
                  36770.1
                ],
                "id": 451,
                "chat_link": "[&BMMBAAA=]"
              },
              "452": {
                "name": "Orvar's Glen Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48420,
                  35663.5
                ],
                "id": 452,
                "chat_link": "[&BMQBAAA=]"
              },
              "453": {
                "name": "Fort Cadence Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49607.4,
                  35721.8
                ],
                "id": 453,
                "chat_link": "[&BMUBAAA=]"
              },
              "454": {
                "name": "Braggi's Stead Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50128.7,
                  35786.4
                ],
                "id": 454,
                "chat_link": "[&BMYBAAA=]"
              },
              "455": {
                "name": "Saltflood Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50075.9,
                  36234.5
                ],
                "id": 455,
                "chat_link": "[&BMcBAAA=]"
              },
              "456": {
                "name": "Zintl Holy Grounds Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49239.5,
                  36452.3
                ],
                "id": 456,
                "chat_link": "[&BMgBAAA=]"
              },
              "457": {
                "name": "Ocean's Gullet Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48721.9,
                  36264.1
                ],
                "id": 457,
                "chat_link": "[&BMkBAAA=]"
              },
              "458": {
                "name": "Forvar's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48297.4,
                  37012.5
                ],
                "id": 458,
                "chat_link": "[&BMoBAAA=]"
              },
              "459": {
                "name": "Toade's Head Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49398.3,
                  37058.2
                ],
                "id": 459,
                "chat_link": "[&BMsBAAA=]"
              },
              "460": {
                "name": "Flamefrog Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50234.1,
                  37084
                ],
                "id": 460,
                "chat_link": "[&BMwBAAA=]"
              },
              "461": {
                "name": "Darkweather Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  50229.3,
                  38119.2
                ],
                "id": 461,
                "chat_link": "[&BM0BAAA=]"
              },
              "462": {
                "name": "Brackwater Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49789.8,
                  38320.4
                ],
                "id": 462,
                "chat_link": "[&BM4BAAA=]"
              },
              "463": {
                "name": "Aleem's Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49164.7,
                  37688.1
                ],
                "id": 463,
                "chat_link": "[&BM8BAAA=]"
              },
              "464": {
                "name": "Splintered Coast Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48647.6,
                  38360.6
                ],
                "id": 464,
                "chat_link": "[&BNABAAA=]"
              },
              "465": {
                "name": "Brooloonu Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  48380.7,
                  37754
                ],
                "id": 465,
                "chat_link": "[&BNEBAAA=]"
              },
              "845": {
                "name": "Dryground Village Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49822.3,
                  37647.4
                ],
                "id": 845,
                "chat_link": "[&BE0DAAA=]"
              },
              "945": {
                "name": "Battlement Shore",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49448,
                  35850.8
                ],
                "id": 945,
                "chat_link": "[&BLEDAAA=]"
              },
              "947": {
                "name": "Caer Brier Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49260.1,
                  38212.3
                ],
                "id": 947,
                "chat_link": "[&BLMDAAA=]"
              },
              "948": {
                "name": "Mire Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  49626.8,
                  35965.8
                ],
                "id": 948,
                "chat_link": "[&BLQDAAA=]"
              },
              "1655": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  50163.9,
                  36021.8
                ],
                "id": 1655,
                "chat_link": "[&BHcGAAA=]"
              },
              "1656": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48440.4,
                  36547.2
                ],
                "id": 1656,
                "chat_link": "[&BHgGAAA=]"
              },
              "1657": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48881,
                  36632.4
                ],
                "id": 1657,
                "chat_link": "[&BHkGAAA=]"
              },
              "1658": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48173,
                  38019.7
                ],
                "id": 1658,
                "chat_link": "[&BHoGAAA=]"
              },
              "1659": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  48525.6,
                  38002.8
                ],
                "id": 1659,
                "chat_link": "[&BHsGAAA=]"
              }
            },
            "tasks": {
              "289": {
                "objective": "Help Admiral Clarinda Demard.",
                "level": 59,
                "coord": [
                  48284.7,
                  37055.1
                ],
                "bounds": [
                  [
                    48052.3,
                    37126.3
                  ],
                  [
                    48083.4,
                    37338.4
                  ],
                  [
                    48199.4,
                    37400.7
                  ],
                  [
                    48262.9,
                    37426.7
                  ],
                  [
                    48389.7,
                    37478
                  ],
                  [
                    48499,
                    37480.5
                  ],
                  [
                    48588.2,
                    37334.3
                  ],
                  [
                    48682.7,
                    37147.2
                  ],
                  [
                    48690.5,
                    36902.3
                  ],
                  [
                    48428.5,
                    36805.1
                  ],
                  [
                    48033.1,
                    36868.4
                  ],
                  [
                    48052.3,
                    37126.3
                  ]
                ],
                "id": 289,
                "chat_link": "[&BCEBAAA=]"
              },
              "290": {
                "objective": "Help Potatlan at the Western Shore.",
                "level": 57,
                "coord": [
                  48995.4,
                  36482.2
                ],
                "bounds": [
                  [
                    48866.8,
                    36400.3
                  ],
                  [
                    48874.2,
                    36268.8
                  ],
                  [
                    48915.3,
                    36167.7
                  ],
                  [
                    48962.2,
                    36074.6
                  ],
                  [
                    49159.2,
                    36025.8
                  ],
                  [
                    49209.1,
                    36174.7
                  ],
                  [
                    49263,
                    36334.8
                  ],
                  [
                    49201.1,
                    36466
                  ],
                  [
                    49128.9,
                    36543.6
                  ],
                  [
                    49014.9,
                    36590.1
                  ],
                  [
                    48931.1,
                    36556.3
                  ],
                  [
                    48866.8,
                    36400.3
                  ]
                ],
                "id": 290,
                "chat_link": "[&BCIBAAA=]"
              },
              "291": {
                "objective": "Help Cuadinti Prepare Southwatch Post.",
                "level": 58,
                "coord": [
                  49223.2,
                  36780.2
                ],
                "bounds": [
                  [
                    49001.6,
                    36781.1
                  ],
                  [
                    49030.9,
                    36703.5
                  ],
                  [
                    49099.8,
                    36641.8
                  ],
                  [
                    49164.8,
                    36592.8
                  ],
                  [
                    49251.5,
                    36551.2
                  ],
                  [
                    49359.8,
                    36555.5
                  ],
                  [
                    49347.9,
                    36729.2
                  ],
                  [
                    49326.1,
                    36791.7
                  ],
                  [
                    49310.8,
                    36846
                  ],
                  [
                    49259.6,
                    36890.2
                  ],
                  [
                    49149.5,
                    36923.2
                  ],
                  [
                    49074.9,
                    36921.5
                  ],
                  [
                    48953.2,
                    36867.1
                  ],
                  [
                    49001.6,
                    36781.1
                  ]
                ],
                "id": 291,
                "chat_link": "[&BCMBAAA=]"
              },
              "292": {
                "objective": "Assist Qoetl and the Ni-tlacua at Swampwatch Post.",
                "level": 57,
                "coord": [
                  49555.6,
                  36223.7
                ],
                "bounds": [
                  [
                    49726.6,
                    36606.2
                  ],
                  [
                    49510.9,
                    36605.8
                  ],
                  [
                    49484.7,
                    36469.9
                  ],
                  [
                    49434.6,
                    36439.9
                  ],
                  [
                    49418.3,
                    36415
                  ],
                  [
                    49409.9,
                    36345.6
                  ],
                  [
                    49387.5,
                    36324.8
                  ],
                  [
                    49350.4,
                    36313.9
                  ],
                  [
                    49383.3,
                    36229.3
                  ],
                  [
                    49400.6,
                    36106.7
                  ],
                  [
                    49532.1,
                    36072.3
                  ],
                  [
                    49633.3,
                    36122.7
                  ],
                  [
                    49699.8,
                    36227.6
                  ],
                  [
                    49712,
                    36341.5
                  ],
                  [
                    49726.6,
                    36606.2
                  ]
                ],
                "id": 292,
                "chat_link": "[&BCQBAAA=]"
              },
              "293": {
                "objective": "Assist Jezza and the Vigil in clearing Risen from Fort Cadence.",
                "level": 55,
                "coord": [
                  49420.9,
                  35765
                ],
                "bounds": [
                  [
                    49251.4,
                    35512.7
                  ],
                  [
                    49572.9,
                    35455.8
                  ],
                  [
                    49827.3,
                    35449.6
                  ],
                  [
                    49827.7,
                    35770.2
                  ],
                  [
                    49643.2,
                    36008.2
                  ],
                  [
                    49486.1,
                    35996.1
                  ],
                  [
                    49299,
                    35901.6
                  ],
                  [
                    49175.9,
                    35642.2
                  ],
                  [
                    49251.4,
                    35512.7
                  ]
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              },
              "294": {
                "objective": "Protect the quaggans from the krait.",
                "level": 60,
                "coord": [
                  48189.2,
                  37539.1
                ],
                "bounds": [
                  [
                    48468.2,
                    37664.7
                  ],
                  [
                    48404.3,
                    37505.7
                  ],
                  [
                    48356,
                    37430.4
                  ],
                  [
                    48247.7,
                    37426.4
                  ],
                  [
                    48008.7,
                    37431.9
                  ],
                  [
                    47987.6,
                    37489
                  ],
                  [
                    47976.9,
                    37537.9
                  ],
                  [
                    47968.2,
                    37635.8
                  ],
                  [
                    47991.7,
                    37699.5
                  ],
                  [
                    48191.2,
                    37788.4
                  ],
                  [
                    48455.8,
                    37767.8
                  ],
                  [
                    48468.2,
                    37664.7
                  ]
                ],
                "id": 294,
                "chat_link": "[&BCYBAAA=]"
              },
              "295": {
                "objective": "Help Kamma test her experimental weapon.",
                "level": 65,
                "coord": [
                  48608.1,
                  38148.3
                ],
                "bounds": [
                  [
                    48466.3,
                    37986.9
                  ],
                  [
                    48337.7,
                    38027.6
                  ],
                  [
                    48252.6,
                    38134.9
                  ],
                  [
                    48256.8,
                    38275.4
                  ],
                  [
                    48297.3,
                    38360.5
                  ],
                  [
                    48376.8,
                    38398.8
                  ],
                  [
                    48784.1,
                    38452.4
                  ],
                  [
                    48865.1,
                    38317.1
                  ],
                  [
                    48814.3,
                    38141
                  ],
                  [
                    48742.6,
                    38048
                  ],
                  [
                    48637,
                    38017.2
                  ],
                  [
                    48466.3,
                    37986.9
                  ]
                ],
                "id": 295,
                "chat_link": "[&BCcBAAA=]"
              },
              "296": {
                "objective": "Help Costi Atl and his tribe hunt for termite larvae.",
                "level": 55,
                "coord": [
                  48763.9,
                  35870
                ],
                "bounds": [
                  [
                    48807,
                    35639.3
                  ],
                  [
                    48810.4,
                    35938
                  ],
                  [
                    48736.8,
                    36015.5
                  ],
                  [
                    48655.3,
                    36013.2
                  ],
                  [
                    48559.6,
                    35975
                  ],
                  [
                    48521.8,
                    35872.8
                  ],
                  [
                    48526.4,
                    35798.4
                  ],
                  [
                    48559.1,
                    35743.7
                  ],
                  [
                    48634.5,
                    35608.5
                  ],
                  [
                    48807,
                    35639.3
                  ]
                ],
                "id": 296,
                "chat_link": "[&BCgBAAA=]"
              },
              "297": {
                "objective": "Help Ayomichi slow the spread of Risen corruption",
                "level": 56,
                "coord": [
                  48738.6,
                  36465.9
                ],
                "bounds": [
                  [
                    48756.8,
                    36310.3
                  ],
                  [
                    48840.9,
                    36265.2
                  ],
                  [
                    48922,
                    36588.3
                  ],
                  [
                    48966.9,
                    36641.2
                  ],
                  [
                    48983.6,
                    36675.6
                  ],
                  [
                    48997,
                    36716.2
                  ],
                  [
                    48981.6,
                    36810.6
                  ],
                  [
                    48912.9,
                    36825.4
                  ],
                  [
                    48775.7,
                    36709.2
                  ],
                  [
                    48556,
                    36708.1
                  ],
                  [
                    47977.7,
                    36414.1
                  ],
                  [
                    48469.4,
                    36231.1
                  ],
                  [
                    48587.6,
                    36201.2
                  ],
                  [
                    48713.8,
                    36289.6
                  ],
                  [
                    48756.8,
                    36310.3
                  ]
                ],
                "id": 297,
                "chat_link": "[&BCkBAAA=]"
              },
              "298": {
                "objective": "Secure the area around Dryground Village.",
                "level": 62,
                "coord": [
                  49770.4,
                  37672.6
                ],
                "bounds": [
                  [
                    49457.8,
                    37872.3
                  ],
                  [
                    49644.1,
                    37843.4
                  ],
                  [
                    49839.4,
                    37913.1
                  ],
                  [
                    50057.3,
                    37991.3
                  ],
                  [
                    50097,
                    37887.1
                  ],
                  [
                    50093.9,
                    37658.8
                  ],
                  [
                    50147.4,
                    37446.1
                  ],
                  [
                    49949.2,
                    37362.8
                  ],
                  [
                    49683.7,
                    37304.6
                  ],
                  [
                    49511.8,
                    37322.7
                  ],
                  [
                    49415.3,
                    37424
                  ],
                  [
                    49293.8,
                    37582.7
                  ],
                  [
                    49266,
                    37814.6
                  ],
                  [
                    49457.8,
                    37872.3
                  ]
                ],
                "id": 298,
                "chat_link": "[&BCoBAAA=]"
              },
              "299": {
                "objective": "Help the Wyld Hunt valiants to explore the shipwrecks.",
                "level": 61,
                "coord": [
                  48890.5,
                  37582.4
                ],
                "bounds": [
                  [
                    48549.5,
                    37690.4
                  ],
                  [
                    48739.1,
                    37793.2
                  ],
                  [
                    48799.8,
                    37792.6
                  ],
                  [
                    48887.9,
                    37785.8
                  ],
                  [
                    48956.3,
                    37652.9
                  ],
                  [
                    48991.8,
                    37516.2
                  ],
                  [
                    48976.5,
                    37368.7
                  ],
                  [
                    48887.4,
                    37269.2
                  ],
                  [
                    48594,
                    37337.3
                  ],
                  [
                    48504.4,
                    37484
                  ],
                  [
                    48503.3,
                    37621.5
                  ],
                  [
                    48549.5,
                    37690.4
                  ]
                ],
                "id": 299,
                "chat_link": "[&BCsBAAA=]"
              },
              "300": {
                "objective": "Secure Brackwater Village",
                "level": 63,
                "coord": [
                  49756.3,
                  38236
                ],
                "bounds": [
                  [
                    49434.9,
                    38079.8
                  ],
                  [
                    49410.3,
                    37939.2
                  ],
                  [
                    49612.9,
                    37878.6
                  ],
                  [
                    49684.4,
                    37866.4
                  ],
                  [
                    49852.7,
                    37935
                  ],
                  [
                    50060.3,
                    38003.8
                  ],
                  [
                    50092.9,
                    38069.5
                  ],
                  [
                    50205.3,
                    38178.8
                  ],
                  [
                    50155.1,
                    38355.9
                  ],
                  [
                    50057.7,
                    38544.8
                  ],
                  [
                    49808.6,
                    38570.4
                  ],
                  [
                    49680.5,
                    38528.5
                  ],
                  [
                    49464.9,
                    38356.4
                  ],
                  [
                    49434.9,
                    38079.8
                  ]
                ],
                "id": 300,
                "chat_link": "[&BCwBAAA=]"
              },
              "301": {
                "objective": "Help Brannen maintain Caer Brier.",
                "level": 64,
                "coord": [
                  49178.4,
                  38175.3
                ],
                "bounds": [
                  [
                    48833.2,
                    38138.1
                  ],
                  [
                    48757.6,
                    38247.4
                  ],
                  [
                    48795.9,
                    38330.8
                  ],
                  [
                    48855.5,
                    38351.5
                  ],
                  [
                    48935,
                    38412
                  ],
                  [
                    49081,
                    38426.5
                  ],
                  [
                    49234.3,
                    38392.3
                  ],
                  [
                    49349.1,
                    38376.4
                  ],
                  [
                    49473.6,
                    38188.4
                  ],
                  [
                    49390.3,
                    38058
                  ],
                  [
                    49300.5,
                    38020.7
                  ],
                  [
                    48961.3,
                    38029
                  ],
                  [
                    48888.8,
                    38047.2
                  ],
                  [
                    48833.2,
                    38138.1
                  ]
                ],
                "id": 301,
                "chat_link": "[&BC0BAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  48205.6,
                  35994.9
                ],
                "id": "0-63"
              },
              {
                "coord": [
                  49937.2,
                  36287.9
                ],
                "id": "0-70"
              },
              {
                "coord": [
                  49055.4,
                  37981.3
                ],
                "id": "0-75"
              },
              {
                "coord": [
                  48938,
                  36957.2
                ],
                "id": "0-102"
              },
              {
                "coord": [
                  49645.9,
                  35505.1
                ],
                "id": "0-101"
              },
              {
                "coord": [
                  49140.5,
                  37188.2
                ],
                "id": "0-103"
              }
            ],
            "sectors": {
              "411": {
                "name": "Orvar's Glen",
                "level": 56,
                "coord": [
                  48464.5,
                  35598.5
                ],
                "bounds": [
                  [
                    48092.6,
                    35609.9
                  ],
                  [
                    48095.3,
                    35699.5
                  ],
                  [
                    48409,
                    35862.3
                  ],
                  [
                    48788.3,
                    35946.4
                  ],
                  [
                    48753.2,
                    35759.2
                  ],
                  [
                    48849,
                    35590.2
                  ],
                  [
                    48838.4,
                    35472.2
                  ],
                  [
                    48569.1,
                    35443.1
                  ],
                  [
                    48470.9,
                    35376.7
                  ],
                  [
                    48311.8,
                    35406.8
                  ],
                  [
                    48214.9,
                    35432.1
                  ],
                  [
                    48181.2,
                    35583.3
                  ],
                  [
                    48092.6,
                    35609.9
                  ]
                ],
                "id": 411,
                "chat_link": "[&BJsBAAA=]"
              },
              "412": {
                "name": "Ocean's Gullet",
                "level": 57,
                "coord": [
                  49096.4,
                  35763.9
                ],
                "bounds": [
                  [
                    48754,
                    35759.2
                  ],
                  [
                    48789.6,
                    35945.9
                  ],
                  [
                    48969,
                    36122.4
                  ],
                  [
                    49118.9,
                    36049.6
                  ],
                  [
                    49271.2,
                    36032.5
                  ],
                  [
                    49390.6,
                    36118.2
                  ],
                  [
                    49454.1,
                    35862.9
                  ],
                  [
                    49297.8,
                    35699.5
                  ],
                  [
                    49252.6,
                    35586.6
                  ],
                  [
                    49235.7,
                    35520.2
                  ],
                  [
                    49166.2,
                    35479
                  ],
                  [
                    48960.7,
                    35455.3
                  ],
                  [
                    48839.8,
                    35472.6
                  ],
                  [
                    48849.1,
                    35590.1
                  ],
                  [
                    48754,
                    35759.2
                  ]
                ],
                "id": 412,
                "chat_link": "[&BJwBAAA=]"
              },
              "413": {
                "name": "Fort Cadence",
                "level": 56,
                "coord": [
                  49617.3,
                  35598.6
                ],
                "bounds": [
                  [
                    49297.5,
                    35701.1
                  ],
                  [
                    49454.1,
                    35863.1
                  ],
                  [
                    49855.2,
                    35971.3
                  ],
                  [
                    50013.3,
                    35713.2
                  ],
                  [
                    50012.7,
                    35467.9
                  ],
                  [
                    49906.9,
                    35428.9
                  ],
                  [
                    49790.4,
                    35466.2
                  ],
                  [
                    49793.6,
                    35633.3
                  ],
                  [
                    49575.9,
                    35635.1
                  ],
                  [
                    49580.1,
                    35469.1
                  ],
                  [
                    49490.7,
                    35437.7
                  ],
                  [
                    49381,
                    35473.4
                  ],
                  [
                    49238.3,
                    35533.2
                  ],
                  [
                    49252.3,
                    35586.3
                  ],
                  [
                    49297.5,
                    35701.1
                  ]
                ],
                "id": 413,
                "chat_link": "[&BJ0BAAA=]"
              },
              "414": {
                "name": "The Shattered Keep",
                "level": 57,
                "coord": [
                  49684.9,
                  35551.1
                ],
                "bounds": [
                  [
                    49575.9,
                    35636.1
                  ],
                  [
                    49793.4,
                    35633.6
                  ],
                  [
                    49790,
                    35466.1
                  ],
                  [
                    49580.2,
                    35468.8
                  ],
                  [
                    49575.9,
                    35636.1
                  ]
                ],
                "id": 414,
                "chat_link": "[&BJ4BAAA=]"
              },
              "415": {
                "name": "Floodwater Causeway",
                "level": 56,
                "coord": [
                  50090,
                  35764
                ],
                "bounds": [
                  [
                    50183.9,
                    35468.2
                  ],
                  [
                    50173.8,
                    35788.5
                  ],
                  [
                    50287.3,
                    35960.6
                  ],
                  [
                    50106.7,
                    35985
                  ],
                  [
                    49855.4,
                    35971.2
                  ],
                  [
                    50013,
                    35712.3
                  ],
                  [
                    50009.9,
                    35462.5
                  ],
                  [
                    50183.9,
                    35468.2
                  ]
                ],
                "id": 415,
                "chat_link": "[&BJ8BAAA=]"
              },
              "416": {
                "name": "Saltflood Mire",
                "level": 56,
                "coord": [
                  49948.2,
                  36160.2
                ],
                "bounds": [
                  [
                    49855.5,
                    35971.5
                  ],
                  [
                    49453.7,
                    35862.5
                  ],
                  [
                    49391.3,
                    36117.9
                  ],
                  [
                    49597,
                    36161.7
                  ],
                  [
                    49709.2,
                    36384
                  ],
                  [
                    49855.8,
                    36488.6
                  ],
                  [
                    50017.1,
                    36452.4
                  ],
                  [
                    50324.4,
                    36337.9
                  ],
                  [
                    50403.6,
                    36178.2
                  ],
                  [
                    50376.6,
                    36020
                  ],
                  [
                    50287,
                    35963.7
                  ],
                  [
                    50106.6,
                    35984.1
                  ],
                  [
                    49855.5,
                    35971.5
                  ]
                ],
                "id": 416,
                "chat_link": "[&BKABAAA=]"
              },
              "417": {
                "name": "Flamefrog Vale",
                "level": 59,
                "coord": [
                  50249.6,
                  36926.9
                ],
                "bounds": [
                  [
                    50324.3,
                    36338.3
                  ],
                  [
                    50505.2,
                    36572.5
                  ],
                  [
                    50530.6,
                    36930.8
                  ],
                  [
                    50505.3,
                    37157.4
                  ],
                  [
                    50352.5,
                    37152.4
                  ],
                  [
                    50205,
                    37378.7
                  ],
                  [
                    49926.1,
                    37280.3
                  ],
                  [
                    50040.5,
                    36998.9
                  ],
                  [
                    50120.1,
                    37083.5
                  ],
                  [
                    50212.7,
                    36988.1
                  ],
                  [
                    50255,
                    36791.6
                  ],
                  [
                    50018.1,
                    36451
                  ],
                  [
                    50324.3,
                    36338.3
                  ]
                ],
                "id": 417,
                "chat_link": "[&BKEBAAA=]"
              },
              "418": {
                "name": "Shimmerstone Cave",
                "level": 60,
                "coord": [
                  50084.4,
                  36802
                ],
                "bounds": [
                  [
                    50044,
                    37006.7
                  ],
                  [
                    50120.3,
                    37083.7
                  ],
                  [
                    50212.4,
                    36988.9
                  ],
                  [
                    50255.2,
                    36790.7
                  ],
                  [
                    50017.6,
                    36451.8
                  ],
                  [
                    49856.8,
                    36490.3
                  ],
                  [
                    50044,
                    37006.7
                  ]
                ],
                "id": 418,
                "chat_link": "[&BKIBAAA=]"
              },
              "419": {
                "name": "Astrozintli Forelands",
                "level": 58,
                "coord": [
                  49307.9,
                  36452.8
                ],
                "bounds": [
                  [
                    49120.3,
                    36048.3
                  ],
                  [
                    49272.3,
                    36031.5
                  ],
                  [
                    49392.3,
                    36116.5
                  ],
                  [
                    49597,
                    36161.1
                  ],
                  [
                    49708.5,
                    36384
                  ],
                  [
                    49855.4,
                    36489.1
                  ],
                  [
                    49589,
                    36684.9
                  ],
                  [
                    49348.4,
                    36862.8
                  ],
                  [
                    49304.5,
                    36844.6
                  ],
                  [
                    49170.9,
                    36876.1
                  ],
                  [
                    49062.5,
                    36851
                  ],
                  [
                    49008.7,
                    36539.9
                  ],
                  [
                    48910.1,
                    36324.6
                  ],
                  [
                    48970,
                    36124.8
                  ],
                  [
                    49120.3,
                    36048.3
                  ]
                ],
                "id": 419,
                "chat_link": "[&BKMBAAA=]"
              },
              "420": {
                "name": "Orvanic Shore",
                "level": 56,
                "coord": [
                  48577.4,
                  36317.1
                ],
                "bounds": [
                  [
                    48415.6,
                    35993.6
                  ],
                  [
                    48343.5,
                    36202.7
                  ],
                  [
                    48070.8,
                    36281.5
                  ],
                  [
                    48098.2,
                    36415.3
                  ],
                  [
                    48342.4,
                    36355.6
                  ],
                  [
                    48345.5,
                    36538.9
                  ],
                  [
                    48751.6,
                    36811.8
                  ],
                  [
                    49044.5,
                    36730.1
                  ],
                  [
                    49010.4,
                    36539.3
                  ],
                  [
                    48910.5,
                    36323
                  ],
                  [
                    48974.4,
                    36122.2
                  ],
                  [
                    48789.6,
                    35946.3
                  ],
                  [
                    48408.9,
                    35861.4
                  ],
                  [
                    48415.6,
                    35993.6
                  ]
                ],
                "id": 420,
                "chat_link": "[&BKQBAAA=]"
              },
              "421": {
                "name": "Uzanarin Depths",
                "level": 56,
                "coord": [
                  48226.2,
                  36009.5
                ],
                "bounds": [
                  [
                    48021.8,
                    36019.5
                  ],
                  [
                    48070.7,
                    36281.6
                  ],
                  [
                    48344.6,
                    36204.1
                  ],
                  [
                    48416.6,
                    35991.3
                  ],
                  [
                    48408.5,
                    35861.6
                  ],
                  [
                    48094.8,
                    35698.9
                  ],
                  [
                    48021.8,
                    36019.5
                  ]
                ],
                "id": 421,
                "chat_link": "[&BKUBAAA=]"
              },
              "422": {
                "name": "Verarium Delves",
                "level": 57,
                "coord": [
                  48213.9,
                  36493.3
                ],
                "bounds": [
                  [
                    48067.3,
                    36553.6
                  ],
                  [
                    48217.3,
                    36601.7
                  ],
                  [
                    48345,
                    36539.3
                  ],
                  [
                    48341.5,
                    36356.2
                  ],
                  [
                    48098.5,
                    36415.8
                  ],
                  [
                    48067.3,
                    36553.6
                  ]
                ],
                "id": 422,
                "chat_link": "[&BKYBAAA=]"
              },
              "423": {
                "name": "Karinn's Passage",
                "level": 59,
                "coord": [
                  48281.4,
                  36821.1
                ],
                "bounds": [
                  [
                    48048.9,
                    36699.9
                  ],
                  [
                    48217.5,
                    36601.9
                  ],
                  [
                    48345.4,
                    36539.3
                  ],
                  [
                    48752,
                    36811.5
                  ],
                  [
                    48521.2,
                    37094.7
                  ],
                  [
                    48163.6,
                    37135.8
                  ],
                  [
                    48111.5,
                    36977.6
                  ],
                  [
                    48328.6,
                    36818.7
                  ],
                  [
                    48279.2,
                    36747.5
                  ],
                  [
                    48046.4,
                    36784
                  ],
                  [
                    48048.9,
                    36699.9
                  ]
                ],
                "id": 423,
                "chat_link": "[&BKcBAAA=]"
              },
              "424": {
                "name": "Leeshore Gauntlet",
                "level": 61,
                "coord": [
                  48752.9,
                  37248
                ],
                "bounds": [
                  [
                    49304.6,
                    36840.4
                  ],
                  [
                    49347.2,
                    36863.5
                  ],
                  [
                    49358,
                    37006
                  ],
                  [
                    49393.2,
                    37109
                  ],
                  [
                    49248.4,
                    37166.2
                  ],
                  [
                    49055.6,
                    37263
                  ],
                  [
                    48996.3,
                    37363
                  ],
                  [
                    48834.7,
                    37372
                  ],
                  [
                    48791.4,
                    37423.9
                  ],
                  [
                    48825,
                    37534.6
                  ],
                  [
                    48772,
                    37605.4
                  ],
                  [
                    48568.3,
                    37675.9
                  ],
                  [
                    48521.1,
                    37748.3
                  ],
                  [
                    48068.3,
                    37699.8
                  ],
                  [
                    48015.4,
                    37639.1
                  ],
                  [
                    48111.5,
                    37482.8
                  ],
                  [
                    48042.8,
                    37402.8
                  ],
                  [
                    48102.7,
                    37278.6
                  ],
                  [
                    48163,
                    37135.3
                  ],
                  [
                    48521.8,
                    37090.1
                  ],
                  [
                    48750.4,
                    36806.7
                  ],
                  [
                    49044.5,
                    36728.7
                  ],
                  [
                    49062.6,
                    36845.9
                  ],
                  [
                    49171.2,
                    36871.3
                  ],
                  [
                    49304.6,
                    36840.4
                  ]
                ],
                "id": 424,
                "chat_link": "[&BKgBAAA=]"
              },
              "425": {
                "name": "Toade's Head",
                "level": 59,
                "coord": [
                  49640.7,
                  36986.8
                ],
                "bounds": [
                  [
                    49393.5,
                    37108.4
                  ],
                  [
                    49592.7,
                    37177.2
                  ],
                  [
                    49673.3,
                    37285
                  ],
                  [
                    49927,
                    37280.8
                  ],
                  [
                    50041,
                    37000.3
                  ],
                  [
                    49857.8,
                    36483.1
                  ],
                  [
                    49581.2,
                    36681.4
                  ],
                  [
                    49341.7,
                    36861.1
                  ],
                  [
                    49358.1,
                    37004.5
                  ],
                  [
                    49393.5,
                    37108.4
                  ]
                ],
                "id": 425,
                "chat_link": "[&BKkBAAA=]"
              },
              "426": {
                "name": "Stone of Hazaan",
                "level": 61,
                "coord": [
                  49333.7,
                  37310.8
                ],
                "bounds": [
                  [
                    48995.1,
                    37363.6
                  ],
                  [
                    49195.5,
                    37600.1
                  ],
                  [
                    49514.2,
                    37522.3
                  ],
                  [
                    49673.2,
                    37285.8
                  ],
                  [
                    49592.8,
                    37178
                  ],
                  [
                    49394,
                    37108.6
                  ],
                  [
                    49248.7,
                    37165
                  ],
                  [
                    49056,
                    37262.7
                  ],
                  [
                    48995.1,
                    37363.6
                  ]
                ],
                "id": 426,
                "chat_link": "[&BKoBAAA=]"
              },
              "427": {
                "name": "Thundertroll Swamp",
                "level": 63,
                "coord": [
                  49773.4,
                  37792.5
                ],
                "bounds": [
                  [
                    49195.4,
                    37599.8
                  ],
                  [
                    49271,
                    37800.9
                  ],
                  [
                    49281.3,
                    38054.6
                  ],
                  [
                    49396.6,
                    38346.7
                  ],
                  [
                    49845.3,
                    38409
                  ],
                  [
                    50045.1,
                    38059.6
                  ],
                  [
                    50282.1,
                    38055.8
                  ],
                  [
                    50337.5,
                    37893.3
                  ],
                  [
                    50082,
                    37616.2
                  ],
                  [
                    50205.1,
                    37378.3
                  ],
                  [
                    49926.8,
                    37280.1
                  ],
                  [
                    49673.5,
                    37287.2
                  ],
                  [
                    49513.1,
                    37521.2
                  ],
                  [
                    49195.4,
                    37599.8
                  ]
                ],
                "id": 427,
                "chat_link": "[&BKsBAAA=]"
              },
              "428": {
                "name": "Diresight Caverns",
                "level": 62,
                "coord": [
                  50441.6,
                  37594.3
                ],
                "bounds": [
                  [
                    50337.3,
                    37893.7
                  ],
                  [
                    50289.6,
                    38064.4
                  ],
                  [
                    50545.6,
                    38061.2
                  ],
                  [
                    50545.3,
                    38052.7
                  ],
                  [
                    50510.6,
                    37959.7
                  ],
                  [
                    50520.1,
                    37828.8
                  ],
                  [
                    50541.8,
                    37721.2
                  ],
                  [
                    50533.5,
                    37612.9
                  ],
                  [
                    50491.5,
                    37543
                  ],
                  [
                    50474.7,
                    37483
                  ],
                  [
                    50533.6,
                    37416.3
                  ],
                  [
                    50534.5,
                    37303.1
                  ],
                  [
                    50457.6,
                    37256.9
                  ],
                  [
                    50488.1,
                    37198.4
                  ],
                  [
                    50505.3,
                    37157.1
                  ],
                  [
                    50352.7,
                    37151.7
                  ],
                  [
                    50204.5,
                    37378
                  ],
                  [
                    50082.3,
                    37615.3
                  ],
                  [
                    50337.3,
                    37893.7
                  ]
                ],
                "id": 428,
                "chat_link": "[&BKwBAAA=]"
              },
              "429": {
                "name": "Darkweather Rise",
                "level": 63,
                "coord": [
                  50221.9,
                  38497.3
                ],
                "bounds": [
                  [
                    50575,
                    38233.4
                  ],
                  [
                    50613.2,
                    38190.5
                  ],
                  [
                    50591,
                    38045.9
                  ],
                  [
                    50552.4,
                    38054
                  ],
                  [
                    50281.8,
                    38054.5
                  ],
                  [
                    50045.1,
                    38058.8
                  ],
                  [
                    49843.3,
                    38401.3
                  ],
                  [
                    49659.7,
                    38364.4
                  ],
                  [
                    49691.5,
                    38593.6
                  ],
                  [
                    49649.4,
                    38770.5
                  ],
                  [
                    49770.4,
                    38793.9
                  ],
                  [
                    49866.3,
                    38745.7
                  ],
                  [
                    49955.9,
                    38776.8
                  ],
                  [
                    50102.3,
                    38808.6
                  ],
                  [
                    50236.1,
                    38805.6
                  ],
                  [
                    50376.7,
                    38781.7
                  ],
                  [
                    50496.6,
                    38792.4
                  ],
                  [
                    50563.4,
                    38729.4
                  ],
                  [
                    50601.8,
                    38636
                  ],
                  [
                    50605.3,
                    38478.6
                  ],
                  [
                    50582.2,
                    38326.5
                  ],
                  [
                    50575,
                    38233.4
                  ]
                ],
                "id": 429,
                "chat_link": "[&BK0BAAA=]"
              },
              "430": {
                "name": "Shattercleft Hills",
                "level": 64,
                "coord": [
                  49223.5,
                  38642.7
                ],
                "bounds": [
                  [
                    49208.5,
                    38749.4
                  ],
                  [
                    49337.6,
                    38779
                  ],
                  [
                    49499.5,
                    38797.4
                  ],
                  [
                    49659,
                    38760.3
                  ],
                  [
                    49688.2,
                    38597.9
                  ],
                  [
                    49669.3,
                    38353.3
                  ],
                  [
                    49018.9,
                    38295.5
                  ],
                  [
                    48762,
                    38433
                  ],
                  [
                    48671.1,
                    38738
                  ],
                  [
                    48864.8,
                    38818.7
                  ],
                  [
                    49079.8,
                    38747.1
                  ],
                  [
                    49208.5,
                    38749.4
                  ]
                ],
                "id": 430,
                "chat_link": "[&BK4BAAA=]"
              },
              "431": {
                "name": "Aleem's Penance",
                "level": 63,
                "coord": [
                  48840.3,
                  37702.5
                ],
                "bounds": [
                  [
                    48404,
                    37912
                  ],
                  [
                    48565.2,
                    37674.7
                  ],
                  [
                    48771.6,
                    37605.3
                  ],
                  [
                    48818.3,
                    37539.6
                  ],
                  [
                    48792.2,
                    37422.8
                  ],
                  [
                    48834.3,
                    37369.9
                  ],
                  [
                    48995.3,
                    37362.8
                  ],
                  [
                    49195.4,
                    37600.3
                  ],
                  [
                    49270.4,
                    37800.4
                  ],
                  [
                    49279.4,
                    38050.7
                  ],
                  [
                    48653.9,
                    38021.7
                  ],
                  [
                    48504.1,
                    38070.3
                  ],
                  [
                    48404,
                    37912
                  ]
                ],
                "id": 431,
                "chat_link": "[&BK8BAAA=]"
              },
              "432": {
                "name": "Splintered Coast",
                "level": 65,
                "coord": [
                  48402.7,
                  38289.4
                ],
                "bounds": [
                  [
                    48040.4,
                    38649.1
                  ],
                  [
                    48344.2,
                    38847.4
                  ],
                  [
                    48683.1,
                    38737.6
                  ],
                  [
                    48763.2,
                    38433.5
                  ],
                  [
                    48404.2,
                    37911.6
                  ],
                  [
                    48520.8,
                    37747.6
                  ],
                  [
                    48063.3,
                    37698.7
                  ],
                  [
                    48040.4,
                    38649.1
                  ]
                ],
                "id": 432,
                "chat_link": "[&BLABAAA=]"
              },
              "825": {
                "name": "Chokevine Gorge",
                "level": 64,
                "coord": [
                  48937.8,
                  38203.1
                ],
                "bounds": [
                  [
                    49279.4,
                    38048.8
                  ],
                  [
                    49409.5,
                    38347
                  ],
                  [
                    49018.8,
                    38296.1
                  ],
                  [
                    48761.8,
                    38433.4
                  ],
                  [
                    48503.3,
                    38071.3
                  ],
                  [
                    48654,
                    38022.1
                  ],
                  [
                    49279.4,
                    38048.8
                  ]
                ],
                "id": 825,
                "chat_link": "[&BDkDAAA=]"
              }
            },
            "adventures": [],
            "id": 53,
            "mastery_points": [
              {
                "coord": [
                  49032.3,
                  38340.2
                ],
                "id": 309,
                "region": "Tyria"
              }
            ]
          },
          "55": {
            "name": "The Hospital in Jeopardy",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {
              "261": {
                "name": "Vanguard Hospital",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44353.8,
                  26577.9
                ],
                "id": 261,
                "chat_link": "[&BAUBAAA=]"
              },
              "262": {
                "name": "Queen's Heart Orphanage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44280.3,
                  26860.6
                ],
                "id": 262,
                "chat_link": "[&BAYBAAA=]"
              },
              "266": {
                "name": "Manor Hill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44154,
                  26741.5
                ],
                "id": 266,
                "chat_link": "[&BAoBAAA=]"
              },
              "267": {
                "name": "Cottage Bend",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44355.6,
                  26907.3
                ],
                "id": 267,
                "chat_link": "[&BAsBAAA=]"
              },
              "268": {
                "name": "Rook's Row",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44383.1,
                  26758.6
                ],
                "id": 268,
                "chat_link": "[&BAwBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "187": {
                "name": "Salma District (Home)",
                "level": 0,
                "coord": [
                  44309.2,
                  26738.4
                ],
                "bounds": [
                  [
                    44409.9,
                    26426.2
                  ],
                  [
                    44262.5,
                    26365.6
                  ],
                  [
                    44194.7,
                    26638
                  ],
                  [
                    44128.4,
                    26704.4
                  ],
                  [
                    44054.6,
                    26742.7
                  ],
                  [
                    44054.2,
                    26822.1
                  ],
                  [
                    44129.5,
                    26847.2
                  ],
                  [
                    44224.3,
                    26883.8
                  ],
                  [
                    44296.2,
                    26924.9
                  ],
                  [
                    44344.8,
                    26997.1
                  ],
                  [
                    44427,
                    26942.6
                  ],
                  [
                    44427.7,
                    26872.1
                  ],
                  [
                    44478.9,
                    26761.8
                  ],
                  [
                    44663.5,
                    26630.9
                  ],
                  [
                    44542.4,
                    26517.4
                  ],
                  [
                    44409.9,
                    26426.2
                  ]
                ],
                "id": 187,
                "chat_link": "[&BLsAAAA=]"
              }
            },
            "adventures": [],
            "id": 55,
            "mastery_points": []
          },
          "61": {
            "name": "Infiltration",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              44416,
              29248
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                30720
              ]
            ],
            "continent_rect": [
              [
                42624,
                28032
              ],
              [
                46208,
                30464
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "61": {
                "name": "Lake Delavan",
                "level": 7,
                "coord": [
                  44465.6,
                  28523.5
                ],
                "bounds": [
                  [
                    44336.5,
                    28406.6
                  ],
                  [
                    44664.4,
                    28127.7
                  ],
                  [
                    44787.3,
                    28268.9
                  ],
                  [
                    44710.4,
                    28553
                  ],
                  [
                    44602.5,
                    28682.2
                  ],
                  [
                    44415,
                    28683.2
                  ],
                  [
                    44246.4,
                    28827
                  ],
                  [
                    44151.8,
                    28596.6
                  ],
                  [
                    44276.8,
                    28566.4
                  ],
                  [
                    44336.5,
                    28406.6
                  ]
                ],
                "id": 61,
                "chat_link": "[&BD0AAAA=]"
              },
              "757": {
                "name": "Beggar's Burrow",
                "level": 10,
                "coord": [
                  44425.6,
                  28205.8
                ],
                "bounds": [
                  [
                    44339.3,
                    28416.3
                  ],
                  [
                    44279.9,
                    28316.8
                  ],
                  [
                    44333.6,
                    28101.4
                  ],
                  [
                    44468.4,
                    28042.6
                  ],
                  [
                    44574.3,
                    28133.2
                  ],
                  [
                    44558.2,
                    28224.6
                  ],
                  [
                    44339.3,
                    28416.3
                  ]
                ],
                "id": 757,
                "chat_link": "[&BPUCAAA=]"
              }
            },
            "adventures": [],
            "id": 61,
            "mastery_points": []
          },
          "77": {
            "name": "Search the Premises",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {
              "263": {
                "name": "Minister Zamon's Mansion",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43923.7,
                  26765.3
                ],
                "id": 263,
                "chat_link": "[&BAcBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "186": {
                "name": "Ossan Quarter",
                "level": 0,
                "coord": [
                  43739.1,
                  26730.8
                ],
                "bounds": [
                  [
                    43784.6,
                    26385.8
                  ],
                  [
                    43646.1,
                    26459.3
                  ],
                  [
                    43520.2,
                    26536.4
                  ],
                  [
                    43408,
                    26622.5
                  ],
                  [
                    43611.8,
                    26836.6
                  ],
                  [
                    43597,
                    26948.8
                  ],
                  [
                    43676.1,
                    26994.7
                  ],
                  [
                    43722.2,
                    26924.5
                  ],
                  [
                    43788,
                    26862.8
                  ],
                  [
                    43869.5,
                    26835.8
                  ],
                  [
                    43976.2,
                    26813.3
                  ],
                  [
                    43976.2,
                    26725
                  ],
                  [
                    43923.8,
                    26703.4
                  ],
                  [
                    43847.4,
                    26583.1
                  ],
                  [
                    43784.6,
                    26385.8
                  ]
                ],
                "id": 186,
                "chat_link": "[&BLoAAAA=]"
              }
            },
            "adventures": [],
            "id": 77,
            "mastery_points": []
          },
          "79": {
            "name": "The Informant",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 79,
            "mastery_points": []
          },
          "80": {
            "name": "A Society Function",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {
              "264": {
                "name": "Minister Wi's Mansion",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44525.9,
                  27336.4
                ],
                "id": 264,
                "chat_link": "[&BAgBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "183": {
                "name": "Rurikton",
                "level": 0,
                "coord": [
                  44587.4,
                  27247.4
                ],
                "bounds": [
                  [
                    44442.7,
                    27221.2
                  ],
                  [
                    44428.7,
                    27131.2
                  ],
                  [
                    44401.3,
                    27054.2
                  ],
                  [
                    44473.9,
                    27008.8
                  ],
                  [
                    44565.6,
                    27068
                  ],
                  [
                    44844.3,
                    27038
                  ],
                  [
                    44877,
                    27178.6
                  ],
                  [
                    44876.6,
                    27338.7
                  ],
                  [
                    44852.9,
                    27466.9
                  ],
                  [
                    44639,
                    27372.7
                  ],
                  [
                    44533.8,
                    27406.1
                  ],
                  [
                    44470.3,
                    27457.3
                  ],
                  [
                    44389,
                    27407.7
                  ],
                  [
                    44428.8,
                    27314.8
                  ],
                  [
                    44442.7,
                    27221.2
                  ]
                ],
                "id": 183,
                "chat_link": "[&BLcAAAA=]"
              }
            },
            "adventures": [],
            "id": 80,
            "mastery_points": []
          },
          "89": {
            "name": "Chasing the Culprits",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              44416,
              29248
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                30720
              ]
            ],
            "continent_rect": [
              [
                42624,
                28032
              ],
              [
                46208,
                30464
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "47": {
                "name": "Bandithaunt Caverns",
                "level": 5,
                "coord": [
                  43020.2,
                  29173.9
                ],
                "bounds": [
                  [
                    42957.1,
                    29443.5
                  ],
                  [
                    43079.7,
                    29427
                  ],
                  [
                    43377.9,
                    29320.1
                  ],
                  [
                    43278.3,
                    29053.8
                  ],
                  [
                    43200.8,
                    29008.8
                  ],
                  [
                    42865.5,
                    28902.1
                  ],
                  [
                    42761.5,
                    28899.7
                  ],
                  [
                    42776.3,
                    29175
                  ],
                  [
                    42884.8,
                    29334.9
                  ],
                  [
                    42957.1,
                    29443.5
                  ]
                ],
                "id": 47,
                "chat_link": "[&BC8AAAA=]"
              },
              "66": {
                "name": "Shaemoor Fields",
                "level": 5,
                "coord": [
                  43196.4,
                  28761.2
                ],
                "bounds": [
                  [
                    42763.3,
                    28245.6
                  ],
                  [
                    42746,
                    28543.8
                  ],
                  [
                    42565.5,
                    28700.1
                  ],
                  [
                    42572.8,
                    28911.4
                  ],
                  [
                    42871.2,
                    28900.9
                  ],
                  [
                    43196.8,
                    29010.1
                  ],
                  [
                    43279.6,
                    29054.3
                  ],
                  [
                    43378.1,
                    29320.1
                  ],
                  [
                    43510.4,
                    29281.5
                  ],
                  [
                    43669.2,
                    29132.7
                  ],
                  [
                    43654.7,
                    28861.3
                  ],
                  [
                    43583.1,
                    28798.6
                  ],
                  [
                    43572.2,
                    28690.8
                  ],
                  [
                    43345,
                    28505.2
                  ],
                  [
                    43348.7,
                    28335
                  ],
                  [
                    43216.2,
                    28378.5
                  ],
                  [
                    43067,
                    28270.2
                  ],
                  [
                    42763.3,
                    28245.6
                  ]
                ],
                "id": 66,
                "chat_link": "[&BEIAAAA=]"
              }
            },
            "adventures": [],
            "id": 89,
            "mastery_points": []
          },
          "92": {
            "name": "The Trial of Julius Zamon",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 92,
            "mastery_points": []
          },
          "97": {
            "name": "Infiltration",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 97,
            "mastery_points": []
          },
          "110": {
            "name": "The Perils of Friendship",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {
              "261": {
                "name": "Vanguard Hospital",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44353.8,
                  26577.9
                ],
                "id": 261,
                "chat_link": "[&BAUBAAA=]"
              },
              "262": {
                "name": "Queen's Heart Orphanage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44280.3,
                  26860.6
                ],
                "id": 262,
                "chat_link": "[&BAYBAAA=]"
              },
              "266": {
                "name": "Manor Hill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44154,
                  26741.5
                ],
                "id": 266,
                "chat_link": "[&BAoBAAA=]"
              },
              "267": {
                "name": "Cottage Bend",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44355.6,
                  26907.3
                ],
                "id": 267,
                "chat_link": "[&BAsBAAA=]"
              },
              "268": {
                "name": "Rook's Row",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44383.1,
                  26758.6
                ],
                "id": 268,
                "chat_link": "[&BAwBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "187": {
                "name": "Salma District (Home)",
                "level": 0,
                "coord": [
                  44309.2,
                  26738.4
                ],
                "bounds": [
                  [
                    44409.9,
                    26426.2
                  ],
                  [
                    44262.5,
                    26365.6
                  ],
                  [
                    44194.7,
                    26638
                  ],
                  [
                    44128.4,
                    26704.4
                  ],
                  [
                    44054.6,
                    26742.7
                  ],
                  [
                    44054.2,
                    26822.1
                  ],
                  [
                    44129.5,
                    26847.2
                  ],
                  [
                    44224.3,
                    26883.8
                  ],
                  [
                    44296.2,
                    26924.9
                  ],
                  [
                    44344.8,
                    26997.1
                  ],
                  [
                    44427,
                    26942.6
                  ],
                  [
                    44427.7,
                    26872.1
                  ],
                  [
                    44478.9,
                    26761.8
                  ],
                  [
                    44663.5,
                    26630.9
                  ],
                  [
                    44542.4,
                    26517.4
                  ],
                  [
                    44409.9,
                    26426.2
                  ]
                ],
                "id": 187,
                "chat_link": "[&BLsAAAA=]"
              }
            },
            "adventures": [],
            "id": 110,
            "mastery_points": []
          },
          "113": {
            "name": "Desperate Medicine",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              44416,
              29248
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                30720
              ]
            ],
            "continent_rect": [
              [
                42624,
                28032
              ],
              [
                46208,
                30464
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "47": {
                "name": "Bandithaunt Caverns",
                "level": 5,
                "coord": [
                  43020.2,
                  29173.9
                ],
                "bounds": [
                  [
                    42957.1,
                    29443.5
                  ],
                  [
                    43079.7,
                    29427
                  ],
                  [
                    43377.9,
                    29320.1
                  ],
                  [
                    43278.3,
                    29053.8
                  ],
                  [
                    43200.8,
                    29008.8
                  ],
                  [
                    42865.5,
                    28902.1
                  ],
                  [
                    42761.5,
                    28899.7
                  ],
                  [
                    42776.3,
                    29175
                  ],
                  [
                    42884.8,
                    29334.9
                  ],
                  [
                    42957.1,
                    29443.5
                  ]
                ],
                "id": 47,
                "chat_link": "[&BC8AAAA=]"
              }
            },
            "adventures": [],
            "id": 113,
            "mastery_points": []
          },
          "120": {
            "name": "The Commander",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 120,
            "mastery_points": []
          },
          "138": {
            "name": "Defense of Shaemoor",
            "min_level": 1,
            "max_level": 1,
            "default_floor": 1,
            "label_coord": [
              44416,
              29248
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                30720
              ]
            ],
            "continent_rect": [
              [
                42624,
                28032
              ],
              [
                46208,
                30464
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "63": {
                "name": "Scaver Plateau",
                "level": 7,
                "coord": [
                  44326.8,
                  29115.1
                ],
                "bounds": [
                  [
                    44061.6,
                    28921.1
                  ],
                  [
                    44191.6,
                    28886.1
                  ],
                  [
                    44247.9,
                    28825.7
                  ],
                  [
                    44416.5,
                    28681.5
                  ],
                  [
                    44470,
                    28855.8
                  ],
                  [
                    44482.7,
                    28875.5
                  ],
                  [
                    44472.4,
                    28881.2
                  ],
                  [
                    44464,
                    28935
                  ],
                  [
                    44552,
                    29051.3
                  ],
                  [
                    44615.2,
                    29040.7
                  ],
                  [
                    44619.8,
                    29074.8
                  ],
                  [
                    44597.5,
                    29327.5
                  ],
                  [
                    44391.9,
                    29420.9
                  ],
                  [
                    44357.2,
                    29492
                  ],
                  [
                    44314,
                    29522.9
                  ],
                  [
                    44251.6,
                    29503.6
                  ],
                  [
                    44209,
                    29471.9
                  ],
                  [
                    43966.6,
                    29503.7
                  ],
                  [
                    43873.1,
                    29178.4
                  ],
                  [
                    43980.8,
                    28853.1
                  ],
                  [
                    44061.6,
                    28921.1
                  ]
                ],
                "id": 63,
                "chat_link": "[&BD8AAAA=]"
              },
              "65": {
                "name": "Village of Shaemoor",
                "level": 4,
                "coord": [
                  43851.1,
                  28584.1
                ],
                "bounds": [
                  [
                    43670.1,
                    29135.4
                  ],
                  [
                    43655.4,
                    28861
                  ],
                  [
                    43582.2,
                    28798.4
                  ],
                  [
                    43572.7,
                    28690.6
                  ],
                  [
                    43344.9,
                    28504.9
                  ],
                  [
                    43349.9,
                    28334.1
                  ],
                  [
                    43544.3,
                    27970.2
                  ],
                  [
                    44210,
                    27964.2
                  ],
                  [
                    44215.7,
                    28204.6
                  ],
                  [
                    44337.6,
                    28406.8
                  ],
                  [
                    44276.1,
                    28565
                  ],
                  [
                    44149.8,
                    28593.5
                  ],
                  [
                    43992.9,
                    28684.6
                  ],
                  [
                    43984,
                    28862
                  ],
                  [
                    43880.9,
                    29185.6
                  ],
                  [
                    43670.1,
                    29135.4
                  ]
                ],
                "id": 65,
                "chat_link": "[&BEEAAAA=]"
              },
              "67": {
                "name": "Shaemoor Garrison",
                "level": 6,
                "coord": [
                  44103.8,
                  28796.6
                ],
                "bounds": [
                  [
                    43984.7,
                    28862.6
                  ],
                  [
                    43993,
                    28685.3
                  ],
                  [
                    44150.1,
                    28594.6
                  ],
                  [
                    44245.8,
                    28826.7
                  ],
                  [
                    44189.6,
                    28887.2
                  ],
                  [
                    44059.6,
                    28923
                  ],
                  [
                    43984.7,
                    28862.6
                  ]
                ],
                "id": 67,
                "chat_link": "[&BEMAAAA=]"
              }
            },
            "adventures": [],
            "id": 138,
            "mastery_points": []
          },
          "140": {
            "name": "The Apothecary",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              44416,
              29248
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                30720
              ]
            ],
            "continent_rect": [
              [
                42624,
                28032
              ],
              [
                46208,
                30464
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "65": {
                "name": "Village of Shaemoor",
                "level": 4,
                "coord": [
                  43851.1,
                  28584.1
                ],
                "bounds": [
                  [
                    43670.1,
                    29135.4
                  ],
                  [
                    43655.4,
                    28861
                  ],
                  [
                    43582.2,
                    28798.4
                  ],
                  [
                    43572.7,
                    28690.6
                  ],
                  [
                    43344.9,
                    28504.9
                  ],
                  [
                    43349.9,
                    28334.1
                  ],
                  [
                    43544.3,
                    27970.2
                  ],
                  [
                    44210,
                    27964.2
                  ],
                  [
                    44215.7,
                    28204.6
                  ],
                  [
                    44337.6,
                    28406.8
                  ],
                  [
                    44276.1,
                    28565
                  ],
                  [
                    44149.8,
                    28593.5
                  ],
                  [
                    43992.9,
                    28684.6
                  ],
                  [
                    43984,
                    28862
                  ],
                  [
                    43880.9,
                    29185.6
                  ],
                  [
                    43670.1,
                    29135.4
                  ]
                ],
                "id": 65,
                "chat_link": "[&BEEAAAA=]"
              }
            },
            "adventures": [],
            "id": 140,
            "mastery_points": []
          },
          "142": {
            "name": "Going Undercover",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              44416,
              29248
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                30720
              ]
            ],
            "continent_rect": [
              [
                42624,
                28032
              ],
              [
                46208,
                30464
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "61": {
                "name": "Lake Delavan",
                "level": 7,
                "coord": [
                  44465.6,
                  28523.5
                ],
                "bounds": [
                  [
                    44336.5,
                    28406.6
                  ],
                  [
                    44664.4,
                    28127.7
                  ],
                  [
                    44787.3,
                    28268.9
                  ],
                  [
                    44710.4,
                    28553
                  ],
                  [
                    44602.5,
                    28682.2
                  ],
                  [
                    44415,
                    28683.2
                  ],
                  [
                    44246.4,
                    28827
                  ],
                  [
                    44151.8,
                    28596.6
                  ],
                  [
                    44276.8,
                    28566.4
                  ],
                  [
                    44336.5,
                    28406.6
                  ]
                ],
                "id": 61,
                "chat_link": "[&BD0AAAA=]"
              },
              "757": {
                "name": "Beggar's Burrow",
                "level": 10,
                "coord": [
                  44425.6,
                  28205.8
                ],
                "bounds": [
                  [
                    44339.3,
                    28416.3
                  ],
                  [
                    44279.9,
                    28316.8
                  ],
                  [
                    44333.6,
                    28101.4
                  ],
                  [
                    44468.4,
                    28042.6
                  ],
                  [
                    44574.3,
                    28133.2
                  ],
                  [
                    44558.2,
                    28224.6
                  ],
                  [
                    44339.3,
                    28416.3
                  ]
                ],
                "id": 757,
                "chat_link": "[&BPUCAAA=]"
              }
            },
            "adventures": [],
            "id": 142,
            "mastery_points": []
          },
          "143": {
            "name": "Going Undercover",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 143,
            "mastery_points": []
          },
          "144": {
            "name": "The Greater Good",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "725": {
                "name": "Plaza of Grenth",
                "level": 0,
                "coord": [
                  44018.8,
                  26558.5
                ],
                "bounds": [
                  [
                    44054.4,
                    26577
                  ],
                  [
                    43974.1,
                    26573.2
                  ],
                  [
                    43977,
                    26726.6
                  ],
                  [
                    43925.1,
                    26705.8
                  ],
                  [
                    43849,
                    26586
                  ],
                  [
                    43787.8,
                    26390.8
                  ],
                  [
                    43925.1,
                    26350.7
                  ],
                  [
                    44091,
                    26342
                  ],
                  [
                    44265.3,
                    26364.1
                  ],
                  [
                    44194.7,
                    26637.9
                  ],
                  [
                    44128.6,
                    26704.3
                  ],
                  [
                    44053.6,
                    26743.6
                  ],
                  [
                    44054.4,
                    26577
                  ]
                ],
                "id": 725,
                "chat_link": "[&BNUCAAA=]"
              },
              "732": {
                "name": "Grenth Low Road",
                "level": 0,
                "coord": [
                  44013.7,
                  26742.4
                ],
                "bounds": [
                  [
                    43973,
                    26566.8
                  ],
                  [
                    43976.1,
                    26918.4
                  ],
                  [
                    44051.1,
                    26916.1
                  ],
                  [
                    44054.5,
                    26568.1
                  ],
                  [
                    43973,
                    26566.8
                  ]
                ],
                "id": 732,
                "chat_link": "[&BNwCAAA=]"
              }
            },
            "adventures": [],
            "id": 144,
            "mastery_points": []
          },
          "145": {
            "name": "The Rescue",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              44416,
              29248
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                30720
              ]
            ],
            "continent_rect": [
              [
                42624,
                28032
              ],
              [
                46208,
                30464
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "52": {
                "name": "Township of Claypool",
                "level": 8,
                "coord": [
                  43436,
                  30257.7
                ],
                "bounds": [
                  [
                    43120.9,
                    30351.6
                  ],
                  [
                    43203.5,
                    30484.5
                  ],
                  [
                    43292.5,
                    30497.2
                  ],
                  [
                    43342.4,
                    30451.8
                  ],
                  [
                    43563.6,
                    30478.5
                  ],
                  [
                    43741.8,
                    30433.4
                  ],
                  [
                    43654.3,
                    30259.8
                  ],
                  [
                    43747.4,
                    30116.7
                  ],
                  [
                    43540,
                    29909
                  ],
                  [
                    43468.2,
                    29911.2
                  ],
                  [
                    43287.5,
                    30031.1
                  ],
                  [
                    43270.4,
                    30167.8
                  ],
                  [
                    43120.9,
                    30351.6
                  ]
                ],
                "id": 52,
                "chat_link": "[&BDQAAAA=]"
              }
            },
            "adventures": [],
            "id": 145,
            "mastery_points": []
          },
          "147": {
            "name": "Breaking the Blade",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {
              "261": {
                "name": "Vanguard Hospital",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44353.8,
                  26577.9
                ],
                "id": 261,
                "chat_link": "[&BAUBAAA=]"
              },
              "262": {
                "name": "Queen's Heart Orphanage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44280.3,
                  26860.6
                ],
                "id": 262,
                "chat_link": "[&BAYBAAA=]"
              },
              "266": {
                "name": "Manor Hill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44154,
                  26741.5
                ],
                "id": 266,
                "chat_link": "[&BAoBAAA=]"
              },
              "267": {
                "name": "Cottage Bend",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44355.6,
                  26907.3
                ],
                "id": 267,
                "chat_link": "[&BAsBAAA=]"
              },
              "268": {
                "name": "Rook's Row",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44383.1,
                  26758.6
                ],
                "id": 268,
                "chat_link": "[&BAwBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "187": {
                "name": "Salma District (Home)",
                "level": 0,
                "coord": [
                  44309.2,
                  26738.4
                ],
                "bounds": [
                  [
                    44409.9,
                    26426.2
                  ],
                  [
                    44262.5,
                    26365.6
                  ],
                  [
                    44194.7,
                    26638
                  ],
                  [
                    44128.4,
                    26704.4
                  ],
                  [
                    44054.6,
                    26742.7
                  ],
                  [
                    44054.2,
                    26822.1
                  ],
                  [
                    44129.5,
                    26847.2
                  ],
                  [
                    44224.3,
                    26883.8
                  ],
                  [
                    44296.2,
                    26924.9
                  ],
                  [
                    44344.8,
                    26997.1
                  ],
                  [
                    44427,
                    26942.6
                  ],
                  [
                    44427.7,
                    26872.1
                  ],
                  [
                    44478.9,
                    26761.8
                  ],
                  [
                    44663.5,
                    26630.9
                  ],
                  [
                    44542.4,
                    26517.4
                  ],
                  [
                    44409.9,
                    26426.2
                  ]
                ],
                "id": 187,
                "chat_link": "[&BLsAAAA=]"
              }
            },
            "adventures": [],
            "id": 147,
            "mastery_points": []
          },
          "148": {
            "name": "The Fall of Falcon Company",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 148,
            "mastery_points": []
          },
          "149": {
            "name": "The Fall of Falcon Company",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              44416,
              29248
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                30720
              ]
            ],
            "continent_rect": [
              [
                42624,
                28032
              ],
              [
                46208,
                30464
              ]
            ],
            "points_of_interest": {
              "134": {
                "name": "Eldvin Monastery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45185.3,
                  29265.2
                ],
                "id": 134,
                "chat_link": "[&BIYAAAA=]"
              },
              "135": {
                "name": "Holdland Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45517.1,
                  29263.3
                ],
                "id": 135,
                "chat_link": "[&BIcAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "60": {
                "name": "Krytan Freeholds",
                "level": 12,
                "coord": [
                  45393.6,
                  29167.1
                ],
                "bounds": [
                  [
                    45720.3,
                    29039.2
                  ],
                  [
                    45659.8,
                    29099.9
                  ],
                  [
                    45623.7,
                    29184.4
                  ],
                  [
                    45652.1,
                    29312.3
                  ],
                  [
                    45631.5,
                    29470.6
                  ],
                  [
                    45493.1,
                    29559.8
                  ],
                  [
                    45312.5,
                    29569.5
                  ],
                  [
                    45191.1,
                    29436.7
                  ],
                  [
                    44940.7,
                    29362.8
                  ],
                  [
                    44914.9,
                    29094.9
                  ],
                  [
                    45089.7,
                    29015.4
                  ],
                  [
                    45156.2,
                    28886.6
                  ],
                  [
                    45377.3,
                    28741
                  ],
                  [
                    45558.2,
                    28796
                  ],
                  [
                    45583.1,
                    28936.8
                  ],
                  [
                    45720.3,
                    29039.2
                  ]
                ],
                "id": 60,
                "chat_link": "[&BDwAAAA=]"
              }
            },
            "adventures": [],
            "id": 149,
            "mastery_points": []
          },
          "152": {
            "name": "Confronting Captain Tervelan",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              44416,
              29248
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                30720
              ]
            ],
            "continent_rect": [
              [
                42624,
                28032
              ],
              [
                46208,
                30464
              ]
            ],
            "points_of_interest": {
              "835": {
                "name": "Bonegrinder's Gully",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45565.6,
                  30320.7
                ],
                "id": 835,
                "chat_link": "[&BEMDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "57": {
                "name": "Taminn Foothills",
                "level": 14,
                "coord": [
                  45776.7,
                  30154.3
                ],
                "bounds": [
                  [
                    45898.1,
                    29962.8
                  ],
                  [
                    46044,
                    29866.1
                  ],
                  [
                    45812.8,
                    29753.9
                  ],
                  [
                    45709.1,
                    29848.2
                  ],
                  [
                    45572.9,
                    30057.8
                  ],
                  [
                    45496,
                    30401.4
                  ],
                  [
                    45518.3,
                    30448.3
                  ],
                  [
                    45727.3,
                    30465.3
                  ],
                  [
                    45885,
                    30503.1
                  ],
                  [
                    45934.8,
                    30315
                  ],
                  [
                    45945.6,
                    30075.8
                  ],
                  [
                    45898.1,
                    29962.8
                  ]
                ],
                "id": 57,
                "chat_link": "[&BDkAAAA=]"
              },
              "68": {
                "name": "Godslost Swamp",
                "level": 15,
                "coord": [
                  45060.6,
                  30002.2
                ],
                "bounds": [
                  [
                    45484.9,
                    29765.9
                  ],
                  [
                    45578.3,
                    30060.3
                  ],
                  [
                    45500.1,
                    30398.2
                  ],
                  [
                    45522.8,
                    30453
                  ],
                  [
                    45372.4,
                    30491.9
                  ],
                  [
                    45051.5,
                    30496.8
                  ],
                  [
                    44922.8,
                    30487.9
                  ],
                  [
                    44569.7,
                    30431.8
                  ],
                  [
                    44523.6,
                    30358.3
                  ],
                  [
                    44518.8,
                    29970
                  ],
                  [
                    44617.9,
                    29883.3
                  ],
                  [
                    44614.2,
                    29698.4
                  ],
                  [
                    44963.1,
                    29524.8
                  ],
                  [
                    44935.8,
                    29353.4
                  ],
                  [
                    45195.6,
                    29430.9
                  ],
                  [
                    45317,
                    29566.5
                  ],
                  [
                    45341.7,
                    29666.6
                  ],
                  [
                    45484.9,
                    29765.9
                  ]
                ],
                "id": 68,
                "chat_link": "[&BEQAAAA=]"
              }
            },
            "adventures": [],
            "id": 152,
            "mastery_points": []
          },
          "153": {
            "name": "Seek Logan's Aid",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 153,
            "mastery_points": []
          },
          "154": {
            "name": "Seek Logan's Aid",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              44416,
              29248
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                30720
              ]
            ],
            "continent_rect": [
              [
                42624,
                28032
              ],
              [
                46208,
                30464
              ]
            ],
            "points_of_interest": {
              "134": {
                "name": "Eldvin Monastery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45185.3,
                  29265.2
                ],
                "id": 134,
                "chat_link": "[&BIYAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "60": {
                "name": "Krytan Freeholds",
                "level": 12,
                "coord": [
                  45393.6,
                  29167.1
                ],
                "bounds": [
                  [
                    45720.3,
                    29039.2
                  ],
                  [
                    45659.8,
                    29099.9
                  ],
                  [
                    45623.7,
                    29184.4
                  ],
                  [
                    45652.1,
                    29312.3
                  ],
                  [
                    45631.5,
                    29470.6
                  ],
                  [
                    45493.1,
                    29559.8
                  ],
                  [
                    45312.5,
                    29569.5
                  ],
                  [
                    45191.1,
                    29436.7
                  ],
                  [
                    44940.7,
                    29362.8
                  ],
                  [
                    44914.9,
                    29094.9
                  ],
                  [
                    45089.7,
                    29015.4
                  ],
                  [
                    45156.2,
                    28886.6
                  ],
                  [
                    45377.3,
                    28741
                  ],
                  [
                    45558.2,
                    28796
                  ],
                  [
                    45583.1,
                    28936.8
                  ],
                  [
                    45720.3,
                    29039.2
                  ]
                ],
                "id": 60,
                "chat_link": "[&BDwAAAA=]"
              }
            },
            "adventures": [],
            "id": 154,
            "mastery_points": []
          },
          "157": {
            "name": "Accusation",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 157,
            "mastery_points": []
          },
          "159": {
            "name": "Accusation",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {
              "23": {
                "name": "Black Haven",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45707.1,
                  30934.8
                ],
                "id": 23,
                "chat_link": "[&BBcAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "81": {
                "name": "Delanian Foothills",
                "level": 16,
                "coord": [
                  45799.8,
                  31003.8
                ],
                "bounds": [
                  [
                    45892.9,
                    30937.8
                  ],
                  [
                    45831.5,
                    30946.6
                  ],
                  [
                    45853.1,
                    30775.9
                  ],
                  [
                    45765.9,
                    30763.2
                  ],
                  [
                    45611.4,
                    30819.8
                  ],
                  [
                    45476.6,
                    30930.8
                  ],
                  [
                    45520.6,
                    31194.7
                  ],
                  [
                    45848.7,
                    31293.6
                  ],
                  [
                    46142.6,
                    31241.7
                  ],
                  [
                    46054.7,
                    31134.1
                  ],
                  [
                    45892.9,
                    30937.8
                  ]
                ],
                "id": 81,
                "chat_link": "[&BFEAAAA=]"
              }
            },
            "adventures": [],
            "id": 159,
            "mastery_points": []
          },
          "161": {
            "name": "Liberation",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {
              "29": {
                "name": "Goff's Bandits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44149.6,
                  30620.3
                ],
                "id": 29,
                "chat_link": "[&BB0AAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "76": {
                "name": "Earthlord's Gap",
                "level": 19,
                "coord": [
                  44253,
                  30734.8
                ],
                "bounds": [
                  [
                    44396.5,
                    31013.5
                  ],
                  [
                    44268.6,
                    31098.3
                  ],
                  [
                    44172.7,
                    30999.5
                  ],
                  [
                    44008.6,
                    30792.3
                  ],
                  [
                    43850.3,
                    30856.2
                  ],
                  [
                    43843.6,
                    30452
                  ],
                  [
                    44131.2,
                    30428
                  ],
                  [
                    44485.6,
                    30340.5
                  ],
                  [
                    44732.1,
                    30456.3
                  ],
                  [
                    44640.5,
                    30911.8
                  ],
                  [
                    44396.5,
                    31013.5
                  ]
                ],
                "id": 76,
                "chat_link": "[&BEwAAAA=]"
              }
            },
            "adventures": [],
            "id": 161,
            "mastery_points": []
          },
          "162": {
            "name": "Voices From the Past",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {
              "261": {
                "name": "Vanguard Hospital",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44353.8,
                  26577.9
                ],
                "id": 261,
                "chat_link": "[&BAUBAAA=]"
              },
              "262": {
                "name": "Queen's Heart Orphanage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44280.3,
                  26860.6
                ],
                "id": 262,
                "chat_link": "[&BAYBAAA=]"
              },
              "266": {
                "name": "Manor Hill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44154,
                  26741.5
                ],
                "id": 266,
                "chat_link": "[&BAoBAAA=]"
              },
              "267": {
                "name": "Cottage Bend",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44355.6,
                  26907.3
                ],
                "id": 267,
                "chat_link": "[&BAsBAAA=]"
              },
              "268": {
                "name": "Rook's Row",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44383.1,
                  26758.6
                ],
                "id": 268,
                "chat_link": "[&BAwBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "187": {
                "name": "Salma District (Home)",
                "level": 0,
                "coord": [
                  44309.2,
                  26738.4
                ],
                "bounds": [
                  [
                    44409.9,
                    26426.2
                  ],
                  [
                    44262.5,
                    26365.6
                  ],
                  [
                    44194.7,
                    26638
                  ],
                  [
                    44128.4,
                    26704.4
                  ],
                  [
                    44054.6,
                    26742.7
                  ],
                  [
                    44054.2,
                    26822.1
                  ],
                  [
                    44129.5,
                    26847.2
                  ],
                  [
                    44224.3,
                    26883.8
                  ],
                  [
                    44296.2,
                    26924.9
                  ],
                  [
                    44344.8,
                    26997.1
                  ],
                  [
                    44427,
                    26942.6
                  ],
                  [
                    44427.7,
                    26872.1
                  ],
                  [
                    44478.9,
                    26761.8
                  ],
                  [
                    44663.5,
                    26630.9
                  ],
                  [
                    44542.4,
                    26517.4
                  ],
                  [
                    44409.9,
                    26426.2
                  ]
                ],
                "id": 187,
                "chat_link": "[&BLsAAAA=]"
              }
            },
            "adventures": [],
            "id": 162,
            "mastery_points": []
          },
          "163": {
            "name": "Voices From the Past",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 163,
            "mastery_points": []
          },
          "171": {
            "name": "Rending the Mantle",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              44416,
              29248
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                30720
              ]
            ],
            "continent_rect": [
              [
                42624,
                28032
              ],
              [
                46208,
                30464
              ]
            ],
            "points_of_interest": {
              "133": {
                "name": "Hunting Lodge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45312,
                  28554.8
                ],
                "id": 133,
                "chat_link": "[&BIUAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "58": {
                "name": "Queen's Forest",
                "level": 9,
                "coord": [
                  44888.3,
                  28803.8
                ],
                "bounds": [
                  [
                    45537.2,
                    28456.8
                  ],
                  [
                    45616.3,
                    28646.4
                  ],
                  [
                    45558.8,
                    28795.3
                  ],
                  [
                    45377.4,
                    28740.7
                  ],
                  [
                    45156,
                    28886
                  ],
                  [
                    45089.4,
                    29015.5
                  ],
                  [
                    44913.7,
                    29094.3
                  ],
                  [
                    44942.6,
                    29363.6
                  ],
                  [
                    44595.2,
                    29328.7
                  ],
                  [
                    44618.8,
                    29076.1
                  ],
                  [
                    44613.7,
                    29041.4
                  ],
                  [
                    44617.6,
                    28985.1
                  ],
                  [
                    44556.6,
                    28882.7
                  ],
                  [
                    44522.9,
                    28854.1
                  ],
                  [
                    44481.3,
                    28874
                  ],
                  [
                    44468.2,
                    28856.8
                  ],
                  [
                    44415.2,
                    28682.8
                  ],
                  [
                    44603.4,
                    28684.4
                  ],
                  [
                    44711,
                    28553.7
                  ],
                  [
                    44787,
                    28268.3
                  ],
                  [
                    44925.1,
                    28250.5
                  ],
                  [
                    45435.8,
                    28346.3
                  ],
                  [
                    45537.2,
                    28456.8
                  ]
                ],
                "id": 58,
                "chat_link": "[&BDoAAAA=]"
              }
            },
            "adventures": [],
            "id": 171,
            "mastery_points": []
          },
          "172": {
            "name": "Rending the Mantle",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 172,
            "mastery_points": []
          },
          "178": {
            "name": "The Floating Grizwhirl",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 178,
            "mastery_points": []
          },
          "179": {
            "name": "The Floating Grizwhirl",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "724": {
                "name": "Plaza of Dwayna",
                "level": 0,
                "coord": [
                  43946,
                  27867.4
                ],
                "bounds": [
                  [
                    43844.8,
                    27943.4
                  ],
                  [
                    43852.7,
                    27819.3
                  ],
                  [
                    43922,
                    27736.3
                  ],
                  [
                    43976.6,
                    27733.1
                  ],
                  [
                    43977,
                    27851
                  ],
                  [
                    44052.1,
                    27853.8
                  ],
                  [
                    44049.7,
                    27735.9
                  ],
                  [
                    44116,
                    27738.9
                  ],
                  [
                    44181.4,
                    27836.7
                  ],
                  [
                    44181.7,
                    27952.6
                  ],
                  [
                    44182.5,
                    28030.8
                  ],
                  [
                    43618.9,
                    28040.4
                  ],
                  [
                    43538.4,
                    27945.3
                  ],
                  [
                    43750.8,
                    27925.4
                  ],
                  [
                    43844.8,
                    27943.4
                  ]
                ],
                "id": 724,
                "chat_link": "[&BNQCAAA=]"
              },
              "736": {
                "name": "Eastern Commons",
                "level": 0,
                "coord": [
                  44277.2,
                  27723
                ],
                "bounds": [
                  [
                    44344,
                    27466.1
                  ],
                  [
                    44447.2,
                    27528.3
                  ],
                  [
                    44435.8,
                    27653.3
                  ],
                  [
                    44594.2,
                    27862.4
                  ],
                  [
                    44489,
                    27944.1
                  ],
                  [
                    44347.1,
                    28008.4
                  ],
                  [
                    44180.8,
                    28027.1
                  ],
                  [
                    44179,
                    27829.3
                  ],
                  [
                    44116.2,
                    27740.5
                  ],
                  [
                    44054.3,
                    27737.5
                  ],
                  [
                    44052.9,
                    27623.9
                  ],
                  [
                    44130.3,
                    27606.8
                  ],
                  [
                    44222.9,
                    27572.6
                  ],
                  [
                    44287.2,
                    27522.2
                  ],
                  [
                    44344,
                    27466.1
                  ]
                ],
                "id": 736,
                "chat_link": "[&BOACAAA=]"
              }
            },
            "adventures": [],
            "id": 179,
            "mastery_points": []
          },
          "180": {
            "name": "The Floating Grizwhirl",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 180,
            "mastery_points": []
          },
          "182": {
            "name": "Clown College",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              44416,
              29248
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                30720
              ]
            ],
            "continent_rect": [
              [
                42624,
                28032
              ],
              [
                46208,
                30464
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "48": {
                "name": "Shire of Beetletun",
                "level": 13,
                "coord": [
                  45900.9,
                  28224.5
                ],
                "bounds": [
                  [
                    45593.8,
                    28056.8
                  ],
                  [
                    45436.4,
                    28345.2
                  ],
                  [
                    45539.2,
                    28458.9
                  ],
                  [
                    45621.4,
                    28644.8
                  ],
                  [
                    46007.9,
                    28578.7
                  ],
                  [
                    46239.8,
                    28459.7
                  ],
                  [
                    46308.9,
                    28317.9
                  ],
                  [
                    46318,
                    28150.4
                  ],
                  [
                    46232.1,
                    27968.2
                  ],
                  [
                    46029.3,
                    27859.8
                  ],
                  [
                    45836.6,
                    27886.4
                  ],
                  [
                    45647.6,
                    27967.6
                  ],
                  [
                    45593.8,
                    28056.8
                  ]
                ],
                "id": 48,
                "chat_link": "[&BDAAAAA=]"
              }
            },
            "adventures": [],
            "id": 182,
            "mastery_points": []
          },
          "184": {
            "name": "The Artist's Workshop",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {
              "26": {
                "name": "Jannaj's Bandits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45361.2,
                  30551.3
                ],
                "id": 26,
                "chat_link": "[&BBoAAAA=]"
              },
              "822": {
                "name": "Uzolan's Hideout",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45527.1,
                  30686.9
                ],
                "id": 822,
                "chat_link": "[&BDYDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "86": {
                "name": "Sojourner's Way",
                "level": 15,
                "coord": [
                  45174.4,
                  30638.1
                ],
                "bounds": [
                  [
                    45621.2,
                    30832.1
                  ],
                  [
                    45577.9,
                    30670
                  ],
                  [
                    45641,
                    30452.5
                  ],
                  [
                    45560.2,
                    30414.4
                  ],
                  [
                    45356.7,
                    30456.5
                  ],
                  [
                    45073.4,
                    30450.4
                  ],
                  [
                    45001.6,
                    30402.2
                  ],
                  [
                    44903,
                    30440.5
                  ],
                  [
                    44729.4,
                    30443.9
                  ],
                  [
                    44638,
                    30900.2
                  ],
                  [
                    44714.8,
                    31011.5
                  ],
                  [
                    44954.3,
                    30763.5
                  ],
                  [
                    45192.5,
                    30762.8
                  ],
                  [
                    45477.2,
                    30932.9
                  ],
                  [
                    45621.2,
                    30832.1
                  ]
                ],
                "id": 86,
                "chat_link": "[&BFYAAAA=]"
              }
            },
            "adventures": [],
            "id": 184,
            "mastery_points": []
          },
          "185": {
            "name": "Into the Woods",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "82": {
                "name": "Blackroot Cut",
                "level": 16,
                "coord": [
                  45894.2,
                  30717.2
                ],
                "bounds": [
                  [
                    45577.1,
                    30669
                  ],
                  [
                    45610.7,
                    30830.5
                  ],
                  [
                    45765.4,
                    30764.3
                  ],
                  [
                    45854.1,
                    30775.7
                  ],
                  [
                    45827.5,
                    30946.8
                  ],
                  [
                    45890,
                    30939.4
                  ],
                  [
                    45934.6,
                    30894.3
                  ],
                  [
                    45996.5,
                    30889.7
                  ],
                  [
                    46139.5,
                    30778.3
                  ],
                  [
                    46243.3,
                    30532.6
                  ],
                  [
                    46199.3,
                    30446
                  ],
                  [
                    45947,
                    30405.5
                  ],
                  [
                    45639.2,
                    30451.9
                  ],
                  [
                    45577.1,
                    30669
                  ]
                ],
                "id": 82,
                "chat_link": "[&BFIAAAA=]"
              }
            },
            "adventures": [],
            "id": 185,
            "mastery_points": []
          },
          "186": {
            "name": "The Ringmaster",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {
              "259": {
                "name": "Uzolan's Mechanical Orchestra",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44463.5,
                  27635.8
                ],
                "id": 259,
                "chat_link": "[&BAMBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "726": {
                "name": "Plaza of Kormir",
                "level": 0,
                "coord": [
                  44601.6,
                  27569
                ],
                "bounds": [
                  [
                    44708.6,
                    27760.6
                  ],
                  [
                    44594.8,
                    27864.9
                  ],
                  [
                    44435,
                    27651.8
                  ],
                  [
                    44447.8,
                    27528
                  ],
                  [
                    44556.6,
                    27586.4
                  ],
                  [
                    44591.5,
                    27530.1
                  ],
                  [
                    44474.4,
                    27453.8
                  ],
                  [
                    44533.3,
                    27407
                  ],
                  [
                    44639.7,
                    27376.3
                  ],
                  [
                    44851.8,
                    27470.6
                  ],
                  [
                    44784,
                    27629.7
                  ],
                  [
                    44708.6,
                    27760.6
                  ]
                ],
                "id": 726,
                "chat_link": "[&BNYCAAA=]"
              },
              "736": {
                "name": "Eastern Commons",
                "level": 0,
                "coord": [
                  44277.2,
                  27723
                ],
                "bounds": [
                  [
                    44344,
                    27466.1
                  ],
                  [
                    44447.2,
                    27528.3
                  ],
                  [
                    44435.8,
                    27653.3
                  ],
                  [
                    44594.2,
                    27862.4
                  ],
                  [
                    44489,
                    27944.1
                  ],
                  [
                    44347.1,
                    28008.4
                  ],
                  [
                    44180.8,
                    28027.1
                  ],
                  [
                    44179,
                    27829.3
                  ],
                  [
                    44116.2,
                    27740.5
                  ],
                  [
                    44054.3,
                    27737.5
                  ],
                  [
                    44052.9,
                    27623.9
                  ],
                  [
                    44130.3,
                    27606.8
                  ],
                  [
                    44222.9,
                    27572.6
                  ],
                  [
                    44287.2,
                    27522.2
                  ],
                  [
                    44344,
                    27466.1
                  ]
                ],
                "id": 736,
                "chat_link": "[&BOACAAA=]"
              }
            },
            "adventures": [],
            "id": 186,
            "mastery_points": []
          },
          "190": {
            "name": "The Orders of Tyria",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 190,
            "mastery_points": []
          },
          "191": {
            "name": "The Orders of Tyria",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "80": {
                "name": "Viathan Lake",
                "level": 23,
                "coord": [
                  43466.6,
                  31793.7
                ],
                "bounds": [
                  [
                    43680.4,
                    31766.7
                  ],
                  [
                    43752.3,
                    31696.2
                  ],
                  [
                    43864.3,
                    31340.9
                  ],
                  [
                    43745.7,
                    31042
                  ],
                  [
                    43392,
                    31210.7
                  ],
                  [
                    43194.4,
                    31094.9
                  ],
                  [
                    43113.8,
                    31160
                  ],
                  [
                    43220.1,
                    31383.2
                  ],
                  [
                    43060.4,
                    31648.7
                  ],
                  [
                    43297.7,
                    31933.2
                  ],
                  [
                    43253.6,
                    32145.5
                  ],
                  [
                    43418.8,
                    32383.8
                  ],
                  [
                    43381.1,
                    32520.6
                  ],
                  [
                    43589.1,
                    32582.2
                  ],
                  [
                    43692.8,
                    32523.1
                  ],
                  [
                    43808.5,
                    32266.7
                  ],
                  [
                    43680.4,
                    31766.7
                  ]
                ],
                "id": 80,
                "chat_link": "[&BFAAAAA=]"
              }
            },
            "adventures": [],
            "id": 191,
            "mastery_points": []
          },
          "192": {
            "name": "Brute Force",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "90": {
                "name": "Lychcroft Mere",
                "level": 22,
                "coord": [
                  42655.4,
                  32220.9
                ],
                "bounds": [
                  [
                    43382.8,
                    32519.4
                  ],
                  [
                    42159.2,
                    32552.1
                  ],
                  [
                    42055.5,
                    32447.9
                  ],
                  [
                    42000.3,
                    31986.5
                  ],
                  [
                    42048.6,
                    31873.9
                  ],
                  [
                    42471,
                    32113
                  ],
                  [
                    42754.3,
                    32173.8
                  ],
                  [
                    43006.3,
                    32028.3
                  ],
                  [
                    43258.1,
                    32135.6
                  ],
                  [
                    43418.3,
                    32378.6
                  ],
                  [
                    43382.8,
                    32519.4
                  ]
                ],
                "id": 90,
                "chat_link": "[&BFoAAAA=]"
              }
            },
            "adventures": [],
            "id": 192,
            "mastery_points": []
          },
          "193": {
            "name": "Mortus Virge",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "90": {
                "name": "Lychcroft Mere",
                "level": 22,
                "coord": [
                  42655.4,
                  32220.9
                ],
                "bounds": [
                  [
                    43382.8,
                    32519.4
                  ],
                  [
                    42159.2,
                    32552.1
                  ],
                  [
                    42055.5,
                    32447.9
                  ],
                  [
                    42000.3,
                    31986.5
                  ],
                  [
                    42048.6,
                    31873.9
                  ],
                  [
                    42471,
                    32113
                  ],
                  [
                    42754.3,
                    32173.8
                  ],
                  [
                    43006.3,
                    32028.3
                  ],
                  [
                    43258.1,
                    32135.6
                  ],
                  [
                    43418.3,
                    32378.6
                  ],
                  [
                    43382.8,
                    32519.4
                  ]
                ],
                "id": 90,
                "chat_link": "[&BFoAAAA=]"
              }
            },
            "adventures": [],
            "id": 193,
            "mastery_points": []
          },
          "195": {
            "name": "Triskell Quay",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {
              "28": {
                "name": "Triskell Quay",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44378.5,
                  31716.4
                ],
                "id": 28,
                "chat_link": "[&BBwAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "78": {
                "name": "Triskellion Vale",
                "level": 19,
                "coord": [
                  44555.1,
                  31356
                ],
                "bounds": [
                  [
                    44973.2,
                    31390.2
                  ],
                  [
                    44881.7,
                    31494.6
                  ],
                  [
                    44753.8,
                    31476.2
                  ],
                  [
                    44626.9,
                    31584.4
                  ],
                  [
                    44599.2,
                    31793.3
                  ],
                  [
                    44456.9,
                    31806
                  ],
                  [
                    44136.3,
                    31553.6
                  ],
                  [
                    44176,
                    31380.3
                  ],
                  [
                    44173.6,
                    31236.8
                  ],
                  [
                    44269.4,
                    31098.3
                  ],
                  [
                    44395,
                    31011
                  ],
                  [
                    44641.8,
                    30910.8
                  ],
                  [
                    44713.5,
                    31013
                  ],
                  [
                    44973.9,
                    31235
                  ],
                  [
                    44973.2,
                    31390.2
                  ]
                ],
                "id": 78,
                "chat_link": "[&BE4AAAA=]"
              }
            },
            "adventures": [],
            "id": 195,
            "mastery_points": []
          },
          "196": {
            "name": "Track the Seraph",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {
              "23": {
                "name": "Black Haven",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45707.1,
                  30934.8
                ],
                "id": 23,
                "chat_link": "[&BBcAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "81": {
                "name": "Delanian Foothills",
                "level": 16,
                "coord": [
                  45799.8,
                  31003.8
                ],
                "bounds": [
                  [
                    45892.9,
                    30937.8
                  ],
                  [
                    45831.5,
                    30946.6
                  ],
                  [
                    45853.1,
                    30775.9
                  ],
                  [
                    45765.9,
                    30763.2
                  ],
                  [
                    45611.4,
                    30819.8
                  ],
                  [
                    45476.6,
                    30930.8
                  ],
                  [
                    45520.6,
                    31194.7
                  ],
                  [
                    45848.7,
                    31293.6
                  ],
                  [
                    46142.6,
                    31241.7
                  ],
                  [
                    46054.7,
                    31134.1
                  ],
                  [
                    45892.9,
                    30937.8
                  ]
                ],
                "id": 81,
                "chat_link": "[&BFEAAAA=]"
              }
            },
            "adventures": [],
            "id": 196,
            "mastery_points": []
          },
          "198": {
            "name": "Speaker of the Dead",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "247": {
                "name": "Hezran Outcrops",
                "level": 28,
                "coord": [
                  46506.3,
                  28824.9
                ],
                "bounds": [
                  [
                    46193.7,
                    28871.5
                  ],
                  [
                    46159.2,
                    28727.9
                  ],
                  [
                    46237.5,
                    28633.4
                  ],
                  [
                    46518.6,
                    28603.7
                  ],
                  [
                    46826.6,
                    28664.2
                  ],
                  [
                    46947.2,
                    28900.2
                  ],
                  [
                    46782.9,
                    29192.2
                  ],
                  [
                    46385,
                    29006.3
                  ],
                  [
                    46193.7,
                    28871.5
                  ]
                ],
                "id": 247,
                "chat_link": "[&BPcAAAA=]"
              }
            },
            "adventures": [],
            "id": 198,
            "mastery_points": []
          },
          "199": {
            "name": "The Sad Tale of the \"Ravenous\"",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {
              "946": {
                "name": "Bad Omen Beach",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47545.3,
                  30266.1
                ],
                "id": 946,
                "chat_link": "[&BLIDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "253": {
                "name": "Lionbridge Expanse",
                "level": 28,
                "coord": [
                  47455,
                  30117.2
                ],
                "bounds": [
                  [
                    47210.2,
                    30156
                  ],
                  [
                    47439.8,
                    30250.6
                  ],
                  [
                    47568.1,
                    30567.4
                  ],
                  [
                    47622.7,
                    30622.7
                  ],
                  [
                    47657.1,
                    30619.4
                  ],
                  [
                    47688.2,
                    30427.9
                  ],
                  [
                    47648.5,
                    30314.4
                  ],
                  [
                    47610.8,
                    30268.5
                  ],
                  [
                    47749.3,
                    30107.3
                  ],
                  [
                    47484.5,
                    30002.3
                  ],
                  [
                    47437.9,
                    29901.9
                  ],
                  [
                    47498.1,
                    29865.6
                  ],
                  [
                    47507.2,
                    29648.5
                  ],
                  [
                    47421,
                    29651.6
                  ],
                  [
                    47218.8,
                    29705.2
                  ],
                  [
                    47097.1,
                    29869.5
                  ],
                  [
                    47162.2,
                    29974.8
                  ],
                  [
                    47167.9,
                    30155.4
                  ],
                  [
                    47210.2,
                    30156
                  ]
                ],
                "id": 253,
                "chat_link": "[&BP0AAAA=]"
              }
            },
            "adventures": [],
            "id": 199,
            "mastery_points": []
          },
          "201": {
            "name": "Kellach's Attack",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 201,
            "mastery_points": []
          },
          "202": {
            "name": "The Queen's Justice",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 202,
            "mastery_points": []
          },
          "203": {
            "name": "The Trap",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 203,
            "mastery_points": []
          },
          "211": {
            "name": "Best Laid Plans",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "829": {
                "name": "Fahrar of Young Heroes",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57785.7,
                  30416.9
                ],
                "id": 829,
                "chat_link": "[&BD0DAAA=]"
              },
              "924": {
                "name": "Ash Checkpoint 13",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57685.8,
                  30451
                ],
                "id": 924,
                "chat_link": "[&BJwDAAA=]"
              },
              "925": {
                "name": "Hero's Forum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57404.5,
                  30448.7
                ],
                "id": 925,
                "chat_link": "[&BJ0DAAA=]"
              },
              "926": {
                "name": "20th Blood Cohort",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57567.1,
                  30223.9
                ],
                "id": 926,
                "chat_link": "[&BJ4DAAA=]"
              },
              "928": {
                "name": "12th Iron Maniple",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57754.3,
                  30227
                ],
                "id": 928,
                "chat_link": "[&BKADAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "815": {
                "name": "Hero's Canton (Home)",
                "level": 0,
                "coord": [
                  57570.9,
                  30334.7
                ],
                "bounds": [
                  [
                    57299,
                    30404.2
                  ],
                  [
                    57460.8,
                    30205.5
                  ],
                  [
                    57724.4,
                    29900.3
                  ],
                  [
                    57905.2,
                    30080
                  ],
                  [
                    57862.9,
                    30402.6
                  ],
                  [
                    57861,
                    30539.9
                  ],
                  [
                    57372.5,
                    30556.6
                  ],
                  [
                    57324,
                    30487.1
                  ],
                  [
                    57328.4,
                    30436.3
                  ],
                  [
                    57299,
                    30404.2
                  ]
                ],
                "id": 815,
                "chat_link": "[&BC8DAAA=]"
              }
            },
            "adventures": [],
            "id": 211,
            "mastery_points": []
          },
          "212": {
            "name": "Welcome Home",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {
              "261": {
                "name": "Vanguard Hospital",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44353.8,
                  26577.9
                ],
                "id": 261,
                "chat_link": "[&BAUBAAA=]"
              },
              "262": {
                "name": "Queen's Heart Orphanage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44280.3,
                  26860.6
                ],
                "id": 262,
                "chat_link": "[&BAYBAAA=]"
              },
              "266": {
                "name": "Manor Hill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44154,
                  26741.5
                ],
                "id": 266,
                "chat_link": "[&BAoBAAA=]"
              },
              "267": {
                "name": "Cottage Bend",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44355.6,
                  26907.3
                ],
                "id": 267,
                "chat_link": "[&BAsBAAA=]"
              },
              "268": {
                "name": "Rook's Row",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44383.1,
                  26758.6
                ],
                "id": 268,
                "chat_link": "[&BAwBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "187": {
                "name": "Salma District (Home)",
                "level": 0,
                "coord": [
                  44309.2,
                  26738.4
                ],
                "bounds": [
                  [
                    44409.9,
                    26426.2
                  ],
                  [
                    44262.5,
                    26365.6
                  ],
                  [
                    44194.7,
                    26638
                  ],
                  [
                    44128.4,
                    26704.4
                  ],
                  [
                    44054.6,
                    26742.7
                  ],
                  [
                    44054.2,
                    26822.1
                  ],
                  [
                    44129.5,
                    26847.2
                  ],
                  [
                    44224.3,
                    26883.8
                  ],
                  [
                    44296.2,
                    26924.9
                  ],
                  [
                    44344.8,
                    26997.1
                  ],
                  [
                    44427,
                    26942.6
                  ],
                  [
                    44427.7,
                    26872.1
                  ],
                  [
                    44478.9,
                    26761.8
                  ],
                  [
                    44663.5,
                    26630.9
                  ],
                  [
                    44542.4,
                    26517.4
                  ],
                  [
                    44409.9,
                    26426.2
                  ]
                ],
                "id": 187,
                "chat_link": "[&BLsAAAA=]"
              }
            },
            "adventures": [],
            "id": 212,
            "mastery_points": []
          },
          "215": {
            "name": "The Tribune's Call",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "829": {
                "name": "Fahrar of Young Heroes",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57785.7,
                  30416.9
                ],
                "id": 829,
                "chat_link": "[&BD0DAAA=]"
              },
              "924": {
                "name": "Ash Checkpoint 13",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57685.8,
                  30451
                ],
                "id": 924,
                "chat_link": "[&BJwDAAA=]"
              },
              "925": {
                "name": "Hero's Forum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57404.5,
                  30448.7
                ],
                "id": 925,
                "chat_link": "[&BJ0DAAA=]"
              },
              "926": {
                "name": "20th Blood Cohort",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57567.1,
                  30223.9
                ],
                "id": 926,
                "chat_link": "[&BJ4DAAA=]"
              },
              "928": {
                "name": "12th Iron Maniple",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57754.3,
                  30227
                ],
                "id": 928,
                "chat_link": "[&BKADAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "815": {
                "name": "Hero's Canton (Home)",
                "level": 0,
                "coord": [
                  57570.9,
                  30334.7
                ],
                "bounds": [
                  [
                    57299,
                    30404.2
                  ],
                  [
                    57460.8,
                    30205.5
                  ],
                  [
                    57724.4,
                    29900.3
                  ],
                  [
                    57905.2,
                    30080
                  ],
                  [
                    57862.9,
                    30402.6
                  ],
                  [
                    57861,
                    30539.9
                  ],
                  [
                    57372.5,
                    30556.6
                  ],
                  [
                    57324,
                    30487.1
                  ],
                  [
                    57328.4,
                    30436.3
                  ],
                  [
                    57299,
                    30404.2
                  ]
                ],
                "id": 815,
                "chat_link": "[&BC8DAAA=]"
              }
            },
            "adventures": [],
            "id": 215,
            "mastery_points": []
          },
          "216": {
            "name": "The Tribune's Call",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "834": {
                "name": "Serrated Blade Tavern",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57268,
                  30262
                ],
                "id": 834,
                "chat_link": "[&BEIDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "813": {
                "name": "Canton Factorium",
                "level": 0,
                "coord": [
                  57322.6,
                  30121
                ],
                "bounds": [
                  [
                    57154.9,
                    30356.3
                  ],
                  [
                    57126,
                    30087.8
                  ],
                  [
                    57107.3,
                    29895.6
                  ],
                  [
                    57313.2,
                    29870.1
                  ],
                  [
                    57531.9,
                    29917.1
                  ],
                  [
                    57667.1,
                    29971.6
                  ],
                  [
                    57468.5,
                    30209.8
                  ],
                  [
                    57305.1,
                    30407.1
                  ],
                  [
                    57229.5,
                    30373.6
                  ],
                  [
                    57154.9,
                    30356.3
                  ]
                ],
                "id": 813,
                "chat_link": "[&BC0DAAA=]"
              }
            },
            "adventures": [],
            "id": 216,
            "mastery_points": []
          },
          "217": {
            "name": "The Tribune's Call",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "adventures": [],
            "id": 217,
            "mastery_points": []
          },
          "222": {
            "name": "A Spy for a Spy",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "831": {
                "name": "Junker's Scrapyard",
                "level": 0,
                "coord": [
                  57339.5,
                  30907.4
                ],
                "bounds": [
                  [
                    57187.7,
                    30922.4
                  ],
                  [
                    57261.6,
                    30886.7
                  ],
                  [
                    57342.3,
                    30814.3
                  ],
                  [
                    57387.2,
                    30854.4
                  ],
                  [
                    57407.9,
                    30812.3
                  ],
                  [
                    57544.4,
                    30919.5
                  ],
                  [
                    57245.3,
                    31142.6
                  ],
                  [
                    57187.7,
                    30922.4
                  ]
                ],
                "id": 831,
                "chat_link": "[&BD8DAAA=]"
              },
              "832": {
                "name": "Great Imperial Smelter",
                "level": 0,
                "coord": [
                  57582.8,
                  31251.1
                ],
                "bounds": [
                  [
                    57239,
                    31148
                  ],
                  [
                    57378.9,
                    31432.9
                  ],
                  [
                    57805.6,
                    31533.4
                  ],
                  [
                    57946.8,
                    31220.7
                  ],
                  [
                    57543.4,
                    30920.6
                  ],
                  [
                    57239,
                    31148
                  ]
                ],
                "id": 832,
                "chat_link": "[&BEADAAA=]"
              }
            },
            "adventures": [],
            "id": 222,
            "mastery_points": []
          },
          "224": {
            "name": "Scrapyard Dogs",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {
              "343": {
                "name": "The Wrecking Yard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58534,
                  30530
                ],
                "id": 343,
                "chat_link": "[&BFcBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "288": {
                "name": "Gunbreach Hills",
                "level": 3,
                "coord": [
                  58277,
                  30394.2
                ],
                "bounds": [
                  [
                    57811.7,
                    30326.9
                  ],
                  [
                    57985.1,
                    30336.6
                  ],
                  [
                    58139.5,
                    30216.8
                  ],
                  [
                    58197.3,
                    30260
                  ],
                  [
                    58466.1,
                    30120
                  ],
                  [
                    58627.1,
                    30196.5
                  ],
                  [
                    58748.3,
                    30586.6
                  ],
                  [
                    58543.3,
                    30743.6
                  ],
                  [
                    58379.7,
                    30589.3
                  ],
                  [
                    57871.7,
                    30565.2
                  ],
                  [
                    57811.7,
                    30326.9
                  ]
                ],
                "id": 288,
                "chat_link": "[&BCABAAA=]"
              }
            },
            "adventures": [],
            "id": 224,
            "mastery_points": []
          },
          "225": {
            "name": "A Spy for a Spy",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "273": {
                "name": "Lake Feritas",
                "level": 5,
                "coord": [
                  58714.1,
                  30124.2
                ],
                "bounds": [
                  [
                    58961.2,
                    30433.2
                  ],
                  [
                    59149.5,
                    30224.9
                  ],
                  [
                    58926.3,
                    30089.1
                  ],
                  [
                    58821.3,
                    29908.7
                  ],
                  [
                    58622.6,
                    29930.8
                  ],
                  [
                    58466.7,
                    29814.3
                  ],
                  [
                    58351.4,
                    29933.1
                  ],
                  [
                    58466.9,
                    30121.5
                  ],
                  [
                    58626.4,
                    30199
                  ],
                  [
                    58748.8,
                    30587.3
                  ],
                  [
                    58961.2,
                    30433.2
                  ]
                ],
                "id": 273,
                "chat_link": "[&BBEBAAA=]"
              },
              "567": {
                "name": "Facula Castrum",
                "level": 5,
                "coord": [
                  59121.5,
                  30024
                ],
                "bounds": [
                  [
                    59147.3,
                    30224.4
                  ],
                  [
                    59228.4,
                    30179.7
                  ],
                  [
                    59307.6,
                    30007.8
                  ],
                  [
                    59351.6,
                    29908.2
                  ],
                  [
                    59078.3,
                    29853.8
                  ],
                  [
                    58817.2,
                    29908.1
                  ],
                  [
                    58920.3,
                    30085.8
                  ],
                  [
                    59147.3,
                    30224.4
                  ]
                ],
                "id": 567,
                "chat_link": "[&BDcCAAA=]"
              }
            },
            "adventures": [],
            "id": 225,
            "mastery_points": []
          },
          "226": {
            "name": "On the Mend",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {
              "261": {
                "name": "Vanguard Hospital",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44353.8,
                  26577.9
                ],
                "id": 261,
                "chat_link": "[&BAUBAAA=]"
              },
              "262": {
                "name": "Queen's Heart Orphanage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44280.3,
                  26860.6
                ],
                "id": 262,
                "chat_link": "[&BAYBAAA=]"
              },
              "266": {
                "name": "Manor Hill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44154,
                  26741.5
                ],
                "id": 266,
                "chat_link": "[&BAoBAAA=]"
              },
              "267": {
                "name": "Cottage Bend",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44355.6,
                  26907.3
                ],
                "id": 267,
                "chat_link": "[&BAsBAAA=]"
              },
              "268": {
                "name": "Rook's Row",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44383.1,
                  26758.6
                ],
                "id": 268,
                "chat_link": "[&BAwBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "187": {
                "name": "Salma District (Home)",
                "level": 0,
                "coord": [
                  44309.2,
                  26738.4
                ],
                "bounds": [
                  [
                    44409.9,
                    26426.2
                  ],
                  [
                    44262.5,
                    26365.6
                  ],
                  [
                    44194.7,
                    26638
                  ],
                  [
                    44128.4,
                    26704.4
                  ],
                  [
                    44054.6,
                    26742.7
                  ],
                  [
                    44054.2,
                    26822.1
                  ],
                  [
                    44129.5,
                    26847.2
                  ],
                  [
                    44224.3,
                    26883.8
                  ],
                  [
                    44296.2,
                    26924.9
                  ],
                  [
                    44344.8,
                    26997.1
                  ],
                  [
                    44427,
                    26942.6
                  ],
                  [
                    44427.7,
                    26872.1
                  ],
                  [
                    44478.9,
                    26761.8
                  ],
                  [
                    44663.5,
                    26630.9
                  ],
                  [
                    44542.4,
                    26517.4
                  ],
                  [
                    44409.9,
                    26426.2
                  ]
                ],
                "id": 187,
                "chat_link": "[&BLsAAAA=]"
              }
            },
            "adventures": [],
            "id": 226,
            "mastery_points": []
          },
          "232": {
            "name": "Spilled Blood",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "276": {
                "name": "Charr's Triumph",
                "level": 8,
                "coord": [
                  59352.1,
                  31140.9
                ],
                "bounds": [
                  [
                    59776,
                    31147.4
                  ],
                  [
                    59708.5,
                    30981.9
                  ],
                  [
                    59186.8,
                    30702.1
                  ],
                  [
                    58984.7,
                    30868.8
                  ],
                  [
                    58987.7,
                    31167.6
                  ],
                  [
                    59173.9,
                    31511.9
                  ],
                  [
                    59488.5,
                    31461.5
                  ],
                  [
                    59510.7,
                    31286.2
                  ],
                  [
                    59776,
                    31147.4
                  ]
                ],
                "id": 276,
                "chat_link": "[&BBQBAAA=]"
              }
            },
            "adventures": [],
            "id": 232,
            "mastery_points": []
          },
          "234": {
            "name": "Ghostbore Musket",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "274": {
                "name": "Old Duke's Estate",
                "level": 6,
                "coord": [
                  58786.2,
                  30721.7
                ],
                "bounds": [
                  [
                    58780.2,
                    31015.2
                  ],
                  [
                    58526.3,
                    30852.5
                  ],
                  [
                    58543.1,
                    30742.7
                  ],
                  [
                    58748,
                    30587
                  ],
                  [
                    58960.9,
                    30433.3
                  ],
                  [
                    59158.8,
                    30699.4
                  ],
                  [
                    58780.2,
                    31015.2
                  ]
                ],
                "id": 274,
                "chat_link": "[&BBIBAAA=]"
              },
              "276": {
                "name": "Charr's Triumph",
                "level": 8,
                "coord": [
                  59352.1,
                  31140.9
                ],
                "bounds": [
                  [
                    59776,
                    31147.4
                  ],
                  [
                    59708.5,
                    30981.9
                  ],
                  [
                    59186.8,
                    30702.1
                  ],
                  [
                    58984.7,
                    30868.8
                  ],
                  [
                    58987.7,
                    31167.6
                  ],
                  [
                    59173.9,
                    31511.9
                  ],
                  [
                    59488.5,
                    31461.5
                  ],
                  [
                    59510.7,
                    31286.2
                  ],
                  [
                    59776,
                    31147.4
                  ]
                ],
                "id": 276,
                "chat_link": "[&BBQBAAA=]"
              }
            },
            "adventures": [],
            "id": 234,
            "mastery_points": []
          },
          "237": {
            "name": "Iron Grip of the Legion",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {
              "347": {
                "name": "Exterminatus HQ",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59005,
                  31180.9
                ],
                "id": 347,
                "chat_link": "[&BFsBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "272": {
                "name": "Victor's Presidium",
                "level": 6,
                "coord": [
                  58619.5,
                  31354.6
                ],
                "bounds": [
                  [
                    58377.7,
                    31462.3
                  ],
                  [
                    58107,
                    31444.8
                  ],
                  [
                    58067.5,
                    31084.7
                  ],
                  [
                    58154.6,
                    31026.6
                  ],
                  [
                    58424.9,
                    31119
                  ],
                  [
                    58528.8,
                    30853.1
                  ],
                  [
                    58778.9,
                    31012.2
                  ],
                  [
                    58956.4,
                    30865.6
                  ],
                  [
                    58960.7,
                    31165.8
                  ],
                  [
                    59145.5,
                    31508.3
                  ],
                  [
                    59152.1,
                    31641.5
                  ],
                  [
                    59030.3,
                    31713.5
                  ],
                  [
                    58675.4,
                    31650.2
                  ],
                  [
                    58573.1,
                    31815.7
                  ],
                  [
                    58477,
                    31779.6
                  ],
                  [
                    58501.8,
                    31530
                  ],
                  [
                    58377.7,
                    31462.3
                  ]
                ],
                "id": 272,
                "chat_link": "[&BBABAAA=]"
              },
              "276": {
                "name": "Charr's Triumph",
                "level": 8,
                "coord": [
                  59352.1,
                  31140.9
                ],
                "bounds": [
                  [
                    59776,
                    31147.4
                  ],
                  [
                    59708.5,
                    30981.9
                  ],
                  [
                    59186.8,
                    30702.1
                  ],
                  [
                    58984.7,
                    30868.8
                  ],
                  [
                    58987.7,
                    31167.6
                  ],
                  [
                    59173.9,
                    31511.9
                  ],
                  [
                    59488.5,
                    31461.5
                  ],
                  [
                    59510.7,
                    31286.2
                  ],
                  [
                    59776,
                    31147.4
                  ]
                ],
                "id": 276,
                "chat_link": "[&BBQBAAA=]"
              }
            },
            "adventures": [],
            "id": 237,
            "mastery_points": []
          },
          "238": {
            "name": "The Flame Advances",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "831": {
                "name": "Junker's Scrapyard",
                "level": 0,
                "coord": [
                  57339.5,
                  30907.4
                ],
                "bounds": [
                  [
                    57187.7,
                    30922.4
                  ],
                  [
                    57261.6,
                    30886.7
                  ],
                  [
                    57342.3,
                    30814.3
                  ],
                  [
                    57387.2,
                    30854.4
                  ],
                  [
                    57407.9,
                    30812.3
                  ],
                  [
                    57544.4,
                    30919.5
                  ],
                  [
                    57245.3,
                    31142.6
                  ],
                  [
                    57187.7,
                    30922.4
                  ]
                ],
                "id": 831,
                "chat_link": "[&BD8DAAA=]"
              },
              "832": {
                "name": "Great Imperial Smelter",
                "level": 0,
                "coord": [
                  57582.8,
                  31251.1
                ],
                "bounds": [
                  [
                    57239,
                    31148
                  ],
                  [
                    57378.9,
                    31432.9
                  ],
                  [
                    57805.6,
                    31533.4
                  ],
                  [
                    57946.8,
                    31220.7
                  ],
                  [
                    57543.4,
                    30920.6
                  ],
                  [
                    57239,
                    31148
                  ]
                ],
                "id": 832,
                "chat_link": "[&BEADAAA=]"
              }
            },
            "adventures": [],
            "id": 238,
            "mastery_points": []
          },
          "239": {
            "name": "The Flame Advances",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "830": {
                "name": "Abandoned Caverns (Access Prohibited)",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56545.4,
                  31364.3
                ],
                "id": 830,
                "chat_link": "[&BD4DAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "816": {
                "name": "Ligacus Notos",
                "level": 0,
                "coord": [
                  56676.8,
                  30846
                ],
                "bounds": [
                  [
                    56229.3,
                    31072.3
                  ],
                  [
                    56315.4,
                    30846.2
                  ],
                  [
                    56253.4,
                    30543.8
                  ],
                  [
                    56807.8,
                    30591.3
                  ],
                  [
                    56808.9,
                    30654.7
                  ],
                  [
                    56829.5,
                    30706.1
                  ],
                  [
                    56876.3,
                    30763.9
                  ],
                  [
                    56955.5,
                    30792.3
                  ],
                  [
                    57002.5,
                    30790.1
                  ],
                  [
                    56968.5,
                    30911.4
                  ],
                  [
                    56852.3,
                    31104.7
                  ],
                  [
                    56222.4,
                    31375.8
                  ],
                  [
                    56229.3,
                    31072.3
                  ]
                ],
                "id": 816,
                "chat_link": "[&BDADAAA=]"
              },
              "822": {
                "name": "Ruins of Rin",
                "level": 0,
                "coord": [
                  56655.8,
                  31441.9
                ],
                "bounds": [
                  [
                    56848.4,
                    31097.3
                  ],
                  [
                    57080.1,
                    31165.5
                  ],
                  [
                    56870.1,
                    31539.3
                  ],
                  [
                    56662.8,
                    31705.2
                  ],
                  [
                    56282.3,
                    31765.1
                  ],
                  [
                    56190.7,
                    31378.8
                  ],
                  [
                    56848.4,
                    31097.3
                  ]
                ],
                "id": 822,
                "chat_link": "[&BDYDAAA=]"
              }
            },
            "adventures": [],
            "id": 239,
            "mastery_points": []
          },
          "242": {
            "name": "Test Your Metal",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {
              "342": {
                "name": "Victory Cenotaph",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59350.1,
                  31090
                ],
                "id": 342,
                "chat_link": "[&BFYBAAA=]"
              },
              "347": {
                "name": "Exterminatus HQ",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59005,
                  31180.9
                ],
                "id": 347,
                "chat_link": "[&BFsBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "272": {
                "name": "Victor's Presidium",
                "level": 6,
                "coord": [
                  58619.5,
                  31354.6
                ],
                "bounds": [
                  [
                    58377.7,
                    31462.3
                  ],
                  [
                    58107,
                    31444.8
                  ],
                  [
                    58067.5,
                    31084.7
                  ],
                  [
                    58154.6,
                    31026.6
                  ],
                  [
                    58424.9,
                    31119
                  ],
                  [
                    58528.8,
                    30853.1
                  ],
                  [
                    58778.9,
                    31012.2
                  ],
                  [
                    58956.4,
                    30865.6
                  ],
                  [
                    58960.7,
                    31165.8
                  ],
                  [
                    59145.5,
                    31508.3
                  ],
                  [
                    59152.1,
                    31641.5
                  ],
                  [
                    59030.3,
                    31713.5
                  ],
                  [
                    58675.4,
                    31650.2
                  ],
                  [
                    58573.1,
                    31815.7
                  ],
                  [
                    58477,
                    31779.6
                  ],
                  [
                    58501.8,
                    31530
                  ],
                  [
                    58377.7,
                    31462.3
                  ]
                ],
                "id": 272,
                "chat_link": "[&BBABAAA=]"
              },
              "276": {
                "name": "Charr's Triumph",
                "level": 8,
                "coord": [
                  59352.1,
                  31140.9
                ],
                "bounds": [
                  [
                    59776,
                    31147.4
                  ],
                  [
                    59708.5,
                    30981.9
                  ],
                  [
                    59186.8,
                    30702.1
                  ],
                  [
                    58984.7,
                    30868.8
                  ],
                  [
                    58987.7,
                    31167.6
                  ],
                  [
                    59173.9,
                    31511.9
                  ],
                  [
                    59488.5,
                    31461.5
                  ],
                  [
                    59510.7,
                    31286.2
                  ],
                  [
                    59776,
                    31147.4
                  ]
                ],
                "id": 276,
                "chat_link": "[&BBQBAAA=]"
              },
              "277": {
                "name": "Martyr's Woods",
                "level": 7,
                "coord": [
                  59590,
                  30474.5
                ],
                "bounds": [
                  [
                    59560.1,
                    30894.6
                  ],
                  [
                    59675.6,
                    30968.6
                  ],
                  [
                    59690.2,
                    30862
                  ],
                  [
                    59791.4,
                    30755.1
                  ],
                  [
                    59841.6,
                    30697.2
                  ],
                  [
                    59923.6,
                    30631.9
                  ],
                  [
                    60012.8,
                    30625.2
                  ],
                  [
                    60015.7,
                    30511
                  ],
                  [
                    59960.6,
                    30423.9
                  ],
                  [
                    59972.9,
                    30374.3
                  ],
                  [
                    59902.5,
                    30279.9
                  ],
                  [
                    59716.5,
                    30309.4
                  ],
                  [
                    59512,
                    30254.2
                  ],
                  [
                    59422,
                    30134.8
                  ],
                  [
                    59317.8,
                    30001
                  ],
                  [
                    59074.2,
                    30119.8
                  ],
                  [
                    59157.5,
                    30232.6
                  ],
                  [
                    59078,
                    30274.2
                  ],
                  [
                    59005.9,
                    30466.7
                  ],
                  [
                    59169.3,
                    30673.2
                  ],
                  [
                    59560.1,
                    30894.6
                  ]
                ],
                "id": 277,
                "chat_link": "[&BBUBAAA=]"
              }
            },
            "adventures": [],
            "id": 242,
            "mastery_points": []
          },
          "244": {
            "name": "Quick and Quiet",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {
              "346": {
                "name": "Igni Castrum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59090.5,
                  31638.2
                ],
                "id": 346,
                "chat_link": "[&BFoBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "272": {
                "name": "Victor's Presidium",
                "level": 6,
                "coord": [
                  58619.5,
                  31354.6
                ],
                "bounds": [
                  [
                    58377.7,
                    31462.3
                  ],
                  [
                    58107,
                    31444.8
                  ],
                  [
                    58067.5,
                    31084.7
                  ],
                  [
                    58154.6,
                    31026.6
                  ],
                  [
                    58424.9,
                    31119
                  ],
                  [
                    58528.8,
                    30853.1
                  ],
                  [
                    58778.9,
                    31012.2
                  ],
                  [
                    58956.4,
                    30865.6
                  ],
                  [
                    58960.7,
                    31165.8
                  ],
                  [
                    59145.5,
                    31508.3
                  ],
                  [
                    59152.1,
                    31641.5
                  ],
                  [
                    59030.3,
                    31713.5
                  ],
                  [
                    58675.4,
                    31650.2
                  ],
                  [
                    58573.1,
                    31815.7
                  ],
                  [
                    58477,
                    31779.6
                  ],
                  [
                    58501.8,
                    31530
                  ],
                  [
                    58377.7,
                    31462.3
                  ]
                ],
                "id": 272,
                "chat_link": "[&BBABAAA=]"
              },
              "279": {
                "name": "Lake Adorea",
                "level": 11,
                "coord": [
                  59592.8,
                  31705.8
                ],
                "bounds": [
                  [
                    59313.5,
                    31972.8
                  ],
                  [
                    59547.6,
                    31870.2
                  ],
                  [
                    59677,
                    31959.9
                  ],
                  [
                    59922.2,
                    31764.2
                  ],
                  [
                    60097.2,
                    31751.6
                  ],
                  [
                    60179.8,
                    31641.9
                  ],
                  [
                    60163.1,
                    31435
                  ],
                  [
                    59917.8,
                    31635.1
                  ],
                  [
                    59648.8,
                    31597.8
                  ],
                  [
                    59457.8,
                    31458.4
                  ],
                  [
                    59144.4,
                    31509
                  ],
                  [
                    59151.8,
                    31641.1
                  ],
                  [
                    59031.2,
                    31712.8
                  ],
                  [
                    59046.9,
                    31931.7
                  ],
                  [
                    59313.5,
                    31972.8
                  ]
                ],
                "id": 279,
                "chat_link": "[&BBcBAAA=]"
              }
            },
            "adventures": [],
            "id": 244,
            "mastery_points": []
          },
          "249": {
            "name": "An Unusual Inheritance",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "adventures": [],
            "id": 249,
            "mastery_points": []
          },
          "250": {
            "name": "Windrock Maze",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "281": {
                "name": "Windrock Maze",
                "level": 12,
                "coord": [
                  60391.9,
                  31581.3
                ],
                "bounds": [
                  [
                    60180.3,
                    31642.1
                  ],
                  [
                    60161.7,
                    31435.4
                  ],
                  [
                    60315.7,
                    31322
                  ],
                  [
                    60466.2,
                    31377.5
                  ],
                  [
                    60666.9,
                    31649.1
                  ],
                  [
                    60541.7,
                    31790.9
                  ],
                  [
                    60411.3,
                    31851.8
                  ],
                  [
                    60180.3,
                    31642.1
                  ]
                ],
                "id": 281,
                "chat_link": "[&BBkBAAA=]"
              },
              "282": {
                "name": "Ascalon Basin",
                "level": 12,
                "coord": [
                  61215.8,
                  31531.5
                ],
                "bounds": [
                  [
                    60666,
                    31652.3
                  ],
                  [
                    60982.6,
                    31591.5
                  ],
                  [
                    61296.3,
                    31773.7
                  ],
                  [
                    61458.5,
                    31781.3
                  ],
                  [
                    61619.4,
                    31898.9
                  ],
                  [
                    61603.1,
                    32053.5
                  ],
                  [
                    61680.8,
                    32143
                  ],
                  [
                    61800.4,
                    32266.6
                  ],
                  [
                    62020.7,
                    31978.7
                  ],
                  [
                    62040.4,
                    31882.4
                  ],
                  [
                    61961.6,
                    31505.5
                  ],
                  [
                    61442.9,
                    31466.1
                  ],
                  [
                    61175.9,
                    31065.4
                  ],
                  [
                    61051.7,
                    31086
                  ],
                  [
                    60870.2,
                    30981.4
                  ],
                  [
                    60845.5,
                    30844.8
                  ],
                  [
                    60643.1,
                    30846.8
                  ],
                  [
                    60386,
                    31101.2
                  ],
                  [
                    60307.5,
                    31326.2
                  ],
                  [
                    60462.6,
                    31384.5
                  ],
                  [
                    60666,
                    31652.3
                  ]
                ],
                "id": 282,
                "chat_link": "[&BBoBAAA=]"
              }
            },
            "adventures": [],
            "id": 250,
            "mastery_points": []
          },
          "251": {
            "name": "Mired Deep",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "adventures": [],
            "id": 251,
            "mastery_points": []
          },
          "252": {
            "name": "Mired Deep",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "283": {
                "name": "Phasmatis Corridor",
                "level": 13,
                "coord": [
                  60438.8,
                  30569.8
                ],
                "bounds": [
                  [
                    60640.3,
                    30858.9
                  ],
                  [
                    60582.4,
                    30915.2
                  ],
                  [
                    60450.9,
                    30771.6
                  ],
                  [
                    60096.5,
                    30681
                  ],
                  [
                    60122.2,
                    30628.4
                  ],
                  [
                    60142.1,
                    30578.6
                  ],
                  [
                    60145.5,
                    30519.8
                  ],
                  [
                    60090.6,
                    30365.1
                  ],
                  [
                    60196,
                    30311.9
                  ],
                  [
                    60368.2,
                    30355.2
                  ],
                  [
                    60478.5,
                    30343.4
                  ],
                  [
                    60716.8,
                    30224.2
                  ],
                  [
                    60700.7,
                    30400.6
                  ],
                  [
                    61009.4,
                    30738.8
                  ],
                  [
                    60842.4,
                    30854.7
                  ],
                  [
                    60640.3,
                    30858.9
                  ]
                ],
                "id": 283,
                "chat_link": "[&BBsBAAA=]"
              },
              "285": {
                "name": "Lamia Mire",
                "level": 11,
                "coord": [
                  61089.9,
                  30885.5
                ],
                "bounds": [
                  [
                    61009.7,
                    30727.9
                  ],
                  [
                    61300.9,
                    30664.1
                  ],
                  [
                    61380.3,
                    30824.2
                  ],
                  [
                    61174.3,
                    31068.5
                  ],
                  [
                    61050.9,
                    31087.3
                  ],
                  [
                    60868.5,
                    30981.8
                  ],
                  [
                    60844.7,
                    30845
                  ],
                  [
                    61009.7,
                    30727.9
                  ]
                ],
                "id": 285,
                "chat_link": "[&BB0BAAA=]"
              },
              "289": {
                "name": "Ascalon City Ruins",
                "level": 14,
                "coord": [
                  61034.8,
                  30253.6
                ],
                "bounds": [
                  [
                    61011.7,
                    30731.4
                  ],
                  [
                    60697,
                    30393
                  ],
                  [
                    60723.5,
                    30048.4
                  ],
                  [
                    60727.4,
                    29978.6
                  ],
                  [
                    60743.3,
                    29921.7
                  ],
                  [
                    60963.8,
                    29895.4
                  ],
                  [
                    61426,
                    29892.3
                  ],
                  [
                    61466,
                    30421.3
                  ],
                  [
                    61289.4,
                    30588.3
                  ],
                  [
                    61300,
                    30665.6
                  ],
                  [
                    61011.7,
                    30731.4
                  ]
                ],
                "id": 289,
                "chat_link": "[&BCEBAAA=]"
              }
            },
            "adventures": [],
            "id": 252,
            "mastery_points": []
          },
          "254": {
            "name": "Deadly Force",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "278": {
                "name": "Ashford Forum",
                "level": 9,
                "coord": [
                  59745.5,
                  31407.1
                ],
                "bounds": [
                  [
                    59649.1,
                    31596.6
                  ],
                  [
                    59917.3,
                    31638.5
                  ],
                  [
                    60067.2,
                    31518.5
                  ],
                  [
                    59901,
                    31208.4
                  ],
                  [
                    59747.3,
                    31144.2
                  ],
                  [
                    59478.6,
                    31284.4
                  ],
                  [
                    59458,
                    31459.4
                  ],
                  [
                    59649.1,
                    31596.6
                  ]
                ],
                "id": 278,
                "chat_link": "[&BBYBAAA=]"
              },
              "280": {
                "name": "Devast District",
                "level": 10,
                "coord": [
                  60088.4,
                  30958.3
                ],
                "bounds": [
                  [
                    60162.1,
                    31435.7
                  ],
                  [
                    60312.4,
                    31323.5
                  ],
                  [
                    60386,
                    31100.6
                  ],
                  [
                    60581.8,
                    30907.5
                  ],
                  [
                    60453.8,
                    30759.5
                  ],
                  [
                    60333.2,
                    30734.4
                  ],
                  [
                    60099.5,
                    30677.9
                  ],
                  [
                    60012.7,
                    30620.1
                  ],
                  [
                    59921.3,
                    30628.9
                  ],
                  [
                    59841.7,
                    30691.9
                  ],
                  [
                    59686.2,
                    30861.1
                  ],
                  [
                    59672.6,
                    30983.1
                  ],
                  [
                    59900.2,
                    30926.3
                  ],
                  [
                    59897.9,
                    31205.3
                  ],
                  [
                    60065.1,
                    31517.9
                  ],
                  [
                    60162.1,
                    31435.7
                  ]
                ],
                "id": 280,
                "chat_link": "[&BBgBAAA=]"
              },
              "291": {
                "name": "Abbey Ruins",
                "level": 10,
                "coord": [
                  59808.3,
                  31063.9
                ],
                "bounds": [
                  [
                    59905.1,
                    30919.6
                  ],
                  [
                    59679.5,
                    30979.2
                  ],
                  [
                    59748.7,
                    31146.6
                  ],
                  [
                    59900.1,
                    31210.1
                  ],
                  [
                    59905.1,
                    30919.6
                  ]
                ],
                "id": 291,
                "chat_link": "[&BCMBAAA=]"
              }
            },
            "adventures": [],
            "id": 254,
            "mastery_points": []
          },
          "255": {
            "name": "Ghostbore Artillery",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "278": {
                "name": "Ashford Forum",
                "level": 9,
                "coord": [
                  59745.5,
                  31407.1
                ],
                "bounds": [
                  [
                    59649.1,
                    31596.6
                  ],
                  [
                    59917.3,
                    31638.5
                  ],
                  [
                    60067.2,
                    31518.5
                  ],
                  [
                    59901,
                    31208.4
                  ],
                  [
                    59747.3,
                    31144.2
                  ],
                  [
                    59478.6,
                    31284.4
                  ],
                  [
                    59458,
                    31459.4
                  ],
                  [
                    59649.1,
                    31596.6
                  ]
                ],
                "id": 278,
                "chat_link": "[&BBYBAAA=]"
              },
              "280": {
                "name": "Devast District",
                "level": 10,
                "coord": [
                  60088.4,
                  30958.3
                ],
                "bounds": [
                  [
                    60162.1,
                    31435.7
                  ],
                  [
                    60312.4,
                    31323.5
                  ],
                  [
                    60386,
                    31100.6
                  ],
                  [
                    60581.8,
                    30907.5
                  ],
                  [
                    60453.8,
                    30759.5
                  ],
                  [
                    60333.2,
                    30734.4
                  ],
                  [
                    60099.5,
                    30677.9
                  ],
                  [
                    60012.7,
                    30620.1
                  ],
                  [
                    59921.3,
                    30628.9
                  ],
                  [
                    59841.7,
                    30691.9
                  ],
                  [
                    59686.2,
                    30861.1
                  ],
                  [
                    59672.6,
                    30983.1
                  ],
                  [
                    59900.2,
                    30926.3
                  ],
                  [
                    59897.9,
                    31205.3
                  ],
                  [
                    60065.1,
                    31517.9
                  ],
                  [
                    60162.1,
                    31435.7
                  ]
                ],
                "id": 280,
                "chat_link": "[&BBgBAAA=]"
              },
              "291": {
                "name": "Abbey Ruins",
                "level": 10,
                "coord": [
                  59808.3,
                  31063.9
                ],
                "bounds": [
                  [
                    59905.1,
                    30919.6
                  ],
                  [
                    59679.5,
                    30979.2
                  ],
                  [
                    59748.7,
                    31146.6
                  ],
                  [
                    59900.1,
                    31210.1
                  ],
                  [
                    59905.1,
                    30919.6
                  ]
                ],
                "id": 291,
                "chat_link": "[&BCMBAAA=]"
              }
            },
            "adventures": [],
            "id": 255,
            "mastery_points": []
          },
          "256": {
            "name": "No Negotiations",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              58048,
              28760
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                27648
              ]
            ],
            "continent_rect": [
              [
                56320,
                27648
              ],
              [
                59904,
                29952
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "41": {
                "name": "Halrunting Plains",
                "level": 16,
                "coord": [
                  56651.4,
                  28511.7
                ],
                "bounds": [
                  [
                    56304.4,
                    28620.7
                  ],
                  [
                    56655.9,
                    28569.2
                  ],
                  [
                    56745,
                    28658.5
                  ],
                  [
                    56666,
                    28866.4
                  ],
                  [
                    56759.4,
                    29036.2
                  ],
                  [
                    56987,
                    28759.3
                  ],
                  [
                    56852,
                    28566.3
                  ],
                  [
                    56844.5,
                    28486.7
                  ],
                  [
                    56909.3,
                    28320.4
                  ],
                  [
                    56811.6,
                    28167.8
                  ],
                  [
                    56579,
                    28210
                  ],
                  [
                    56462.5,
                    28227.3
                  ],
                  [
                    56304.9,
                    28265.9
                  ],
                  [
                    56238.8,
                    28408.6
                  ],
                  [
                    56304.4,
                    28620.7
                  ]
                ],
                "id": 41,
                "chat_link": "[&BCkAAAA=]"
              }
            },
            "adventures": [],
            "id": 256,
            "mastery_points": []
          },
          "257": {
            "name": "Salvaging Scrap",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              58048,
              28760
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                27648
              ]
            ],
            "continent_rect": [
              [
                56320,
                27648
              ],
              [
                59904,
                29952
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "41": {
                "name": "Halrunting Plains",
                "level": 16,
                "coord": [
                  56651.4,
                  28511.7
                ],
                "bounds": [
                  [
                    56304.4,
                    28620.7
                  ],
                  [
                    56655.9,
                    28569.2
                  ],
                  [
                    56745,
                    28658.5
                  ],
                  [
                    56666,
                    28866.4
                  ],
                  [
                    56759.4,
                    29036.2
                  ],
                  [
                    56987,
                    28759.3
                  ],
                  [
                    56852,
                    28566.3
                  ],
                  [
                    56844.5,
                    28486.7
                  ],
                  [
                    56909.3,
                    28320.4
                  ],
                  [
                    56811.6,
                    28167.8
                  ],
                  [
                    56579,
                    28210
                  ],
                  [
                    56462.5,
                    28227.3
                  ],
                  [
                    56304.9,
                    28265.9
                  ],
                  [
                    56238.8,
                    28408.6
                  ],
                  [
                    56304.4,
                    28620.7
                  ]
                ],
                "id": 41,
                "chat_link": "[&BCkAAAA=]"
              }
            },
            "adventures": [],
            "id": 257,
            "mastery_points": []
          },
          "258": {
            "name": "Salvaging Scrap",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              58048,
              28760
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                27648
              ]
            ],
            "continent_rect": [
              [
                56320,
                27648
              ],
              [
                59904,
                29952
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "37": {
                "name": "Wodron Glens",
                "level": 18,
                "coord": [
                  57179.3,
                  29141.1
                ],
                "bounds": [
                  [
                    56988.1,
                    28756.9
                  ],
                  [
                    57279.2,
                    28959.5
                  ],
                  [
                    57532.9,
                    28941.6
                  ],
                  [
                    57563.9,
                    29252.8
                  ],
                  [
                    57445.6,
                    29414.6
                  ],
                  [
                    57160.8,
                    29304.4
                  ],
                  [
                    56948,
                    29447.8
                  ],
                  [
                    56936.5,
                    29156.8
                  ],
                  [
                    56758.9,
                    29035.3
                  ],
                  [
                    56988.1,
                    28756.9
                  ]
                ],
                "id": 37,
                "chat_link": "[&BCUAAAA=]"
              }
            },
            "adventures": [],
            "id": 258,
            "mastery_points": []
          },
          "259": {
            "name": "In the Ruins",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "adventures": [],
            "id": 259,
            "mastery_points": []
          },
          "260": {
            "name": "In the Ruins",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              58048,
              28760
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                27648
              ]
            ],
            "continent_rect": [
              [
                56320,
                27648
              ],
              [
                59904,
                29952
              ]
            ],
            "points_of_interest": {
              "273": {
                "name": "Grendich Ruins",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57689,
                  28424.4
                ],
                "id": 273,
                "chat_link": "[&BBEBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "17": {
                "name": "The Blasted Moors",
                "level": 19,
                "coord": [
                  57863.6,
                  28720.1
                ],
                "bounds": [
                  [
                    57775.8,
                    28987.3
                  ],
                  [
                    57999.8,
                    29050.8
                  ],
                  [
                    58121.8,
                    28970.7
                  ],
                  [
                    58031.1,
                    28532.5
                  ],
                  [
                    57688.9,
                    28333.8
                  ],
                  [
                    57564.5,
                    28445.6
                  ],
                  [
                    57775.8,
                    28987.3
                  ]
                ],
                "id": 17,
                "chat_link": "[&BBEAAAA=]"
              }
            },
            "adventures": [],
            "id": 260,
            "mastery_points": []
          },
          "262": {
            "name": "Chain of Command",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "829": {
                "name": "Fahrar of Young Heroes",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57785.7,
                  30416.9
                ],
                "id": 829,
                "chat_link": "[&BD0DAAA=]"
              },
              "924": {
                "name": "Ash Checkpoint 13",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57685.8,
                  30451
                ],
                "id": 924,
                "chat_link": "[&BJwDAAA=]"
              },
              "925": {
                "name": "Hero's Forum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57404.5,
                  30448.7
                ],
                "id": 925,
                "chat_link": "[&BJ0DAAA=]"
              },
              "926": {
                "name": "20th Blood Cohort",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57567.1,
                  30223.9
                ],
                "id": 926,
                "chat_link": "[&BJ4DAAA=]"
              },
              "928": {
                "name": "12th Iron Maniple",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57754.3,
                  30227
                ],
                "id": 928,
                "chat_link": "[&BKADAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "815": {
                "name": "Hero's Canton (Home)",
                "level": 0,
                "coord": [
                  57570.9,
                  30334.7
                ],
                "bounds": [
                  [
                    57299,
                    30404.2
                  ],
                  [
                    57460.8,
                    30205.5
                  ],
                  [
                    57724.4,
                    29900.3
                  ],
                  [
                    57905.2,
                    30080
                  ],
                  [
                    57862.9,
                    30402.6
                  ],
                  [
                    57861,
                    30539.9
                  ],
                  [
                    57372.5,
                    30556.6
                  ],
                  [
                    57324,
                    30487.1
                  ],
                  [
                    57328.4,
                    30436.3
                  ],
                  [
                    57299,
                    30404.2
                  ]
                ],
                "id": 815,
                "chat_link": "[&BC8DAAA=]"
              }
            },
            "adventures": [],
            "id": 262,
            "mastery_points": []
          },
          "263": {
            "name": "Chain of Command",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {
              "916": {
                "name": "Mock's Niche",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57973,
                  30047.8
                ],
                "id": 916,
                "chat_link": "[&BJQDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "271": {
                "name": "Tela Range",
                "level": 4,
                "coord": [
                  57985.5,
                  30119.3
                ],
                "bounds": [
                  [
                    57802.3,
                    30344.5
                  ],
                  [
                    57985.1,
                    30336.5
                  ],
                  [
                    58225.7,
                    30165
                  ],
                  [
                    58232.5,
                    30110.6
                  ],
                  [
                    58153.4,
                    30012.7
                  ],
                  [
                    58021.3,
                    29815.9
                  ],
                  [
                    57795.6,
                    29955.1
                  ],
                  [
                    57668.2,
                    30213.8
                  ],
                  [
                    57802.3,
                    30344.5
                  ]
                ],
                "id": 271,
                "chat_link": "[&BA8BAAA=]"
              }
            },
            "adventures": [],
            "id": 263,
            "mastery_points": []
          },
          "264": {
            "name": "Time for a Promotion",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "740": {
                "name": "The Bane",
                "level": 0,
                "coord": [
                  56926.4,
                  30597.2
                ],
                "bounds": [
                  [
                    56807.9,
                    30588.7
                  ],
                  [
                    56842.9,
                    30517.5
                  ],
                  [
                    56895.7,
                    30469.8
                  ],
                  [
                    56971.6,
                    30450.5
                  ],
                  [
                    57020.1,
                    30460.7
                  ],
                  [
                    57066.5,
                    30475.4
                  ],
                  [
                    57007.7,
                    30495.6
                  ],
                  [
                    57041.2,
                    30788.5
                  ],
                  [
                    56952.9,
                    30795.1
                  ],
                  [
                    56875,
                    30763.3
                  ],
                  [
                    56825.9,
                    30707.5
                  ],
                  [
                    56808.6,
                    30654.1
                  ],
                  [
                    56807.9,
                    30588.7
                  ]
                ],
                "id": 740,
                "chat_link": "[&BOQCAAA=]"
              }
            },
            "adventures": [],
            "id": 264,
            "mastery_points": []
          },
          "267": {
            "name": "The End of the Line",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "272": {
                "name": "Victor's Presidium",
                "level": 6,
                "coord": [
                  58619.5,
                  31354.6
                ],
                "bounds": [
                  [
                    58377.7,
                    31462.3
                  ],
                  [
                    58107,
                    31444.8
                  ],
                  [
                    58067.5,
                    31084.7
                  ],
                  [
                    58154.6,
                    31026.6
                  ],
                  [
                    58424.9,
                    31119
                  ],
                  [
                    58528.8,
                    30853.1
                  ],
                  [
                    58778.9,
                    31012.2
                  ],
                  [
                    58956.4,
                    30865.6
                  ],
                  [
                    58960.7,
                    31165.8
                  ],
                  [
                    59145.5,
                    31508.3
                  ],
                  [
                    59152.1,
                    31641.5
                  ],
                  [
                    59030.3,
                    31713.5
                  ],
                  [
                    58675.4,
                    31650.2
                  ],
                  [
                    58573.1,
                    31815.7
                  ],
                  [
                    58477,
                    31779.6
                  ],
                  [
                    58501.8,
                    31530
                  ],
                  [
                    58377.7,
                    31462.3
                  ]
                ],
                "id": 272,
                "chat_link": "[&BBABAAA=]"
              },
              "275": {
                "name": "Decimus Stones",
                "level": 7,
                "coord": [
                  58311.8,
                  31605.8
                ],
                "bounds": [
                  [
                    58105.3,
                    31758
                  ],
                  [
                    58287.2,
                    31766.5
                  ],
                  [
                    58491.2,
                    31678.8
                  ],
                  [
                    58499,
                    31527.7
                  ],
                  [
                    58381,
                    31461.2
                  ],
                  [
                    58107.3,
                    31442.4
                  ],
                  [
                    58105.3,
                    31758
                  ]
                ],
                "id": 275,
                "chat_link": "[&BBMBAAA=]"
              }
            },
            "adventures": [],
            "id": 267,
            "mastery_points": []
          },
          "269": {
            "name": "Magic Users",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "272": {
                "name": "Victor's Presidium",
                "level": 6,
                "coord": [
                  58619.5,
                  31354.6
                ],
                "bounds": [
                  [
                    58377.7,
                    31462.3
                  ],
                  [
                    58107,
                    31444.8
                  ],
                  [
                    58067.5,
                    31084.7
                  ],
                  [
                    58154.6,
                    31026.6
                  ],
                  [
                    58424.9,
                    31119
                  ],
                  [
                    58528.8,
                    30853.1
                  ],
                  [
                    58778.9,
                    31012.2
                  ],
                  [
                    58956.4,
                    30865.6
                  ],
                  [
                    58960.7,
                    31165.8
                  ],
                  [
                    59145.5,
                    31508.3
                  ],
                  [
                    59152.1,
                    31641.5
                  ],
                  [
                    59030.3,
                    31713.5
                  ],
                  [
                    58675.4,
                    31650.2
                  ],
                  [
                    58573.1,
                    31815.7
                  ],
                  [
                    58477,
                    31779.6
                  ],
                  [
                    58501.8,
                    31530
                  ],
                  [
                    58377.7,
                    31462.3
                  ]
                ],
                "id": 272,
                "chat_link": "[&BBABAAA=]"
              }
            },
            "adventures": [],
            "id": 269,
            "mastery_points": []
          },
          "271": {
            "name": "Rage Suppression",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "adventures": [],
            "id": 271,
            "mastery_points": []
          },
          "272": {
            "name": "Rage Suppression",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {
              "343": {
                "name": "The Wrecking Yard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58534,
                  30530
                ],
                "id": 343,
                "chat_link": "[&BFcBAAA=]"
              },
              "917": {
                "name": "Three Legions Court",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58199.7,
                  30965.9
                ],
                "id": 917,
                "chat_link": "[&BJUDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "270": {
                "name": "Village of Smokestead",
                "level": 3,
                "coord": [
                  58156.3,
                  30833.9
                ],
                "bounds": [
                  [
                    57856,
                    30550.5
                  ],
                  [
                    57996.7,
                    30571
                  ],
                  [
                    58378.9,
                    30592.8
                  ],
                  [
                    58545.1,
                    30743.8
                  ],
                  [
                    58526.7,
                    30851.5
                  ],
                  [
                    58424.6,
                    31121.2
                  ],
                  [
                    58158.3,
                    31028.9
                  ],
                  [
                    58070.5,
                    31085.8
                  ],
                  [
                    57749.8,
                    31164.6
                  ],
                  [
                    57856,
                    30629.3
                  ],
                  [
                    57856,
                    30550.5
                  ]
                ],
                "id": 270,
                "chat_link": "[&BA4BAAA=]"
              },
              "273": {
                "name": "Lake Feritas",
                "level": 5,
                "coord": [
                  58714.1,
                  30124.2
                ],
                "bounds": [
                  [
                    58961.2,
                    30433.2
                  ],
                  [
                    59149.5,
                    30224.9
                  ],
                  [
                    58926.3,
                    30089.1
                  ],
                  [
                    58821.3,
                    29908.7
                  ],
                  [
                    58622.6,
                    29930.8
                  ],
                  [
                    58466.7,
                    29814.3
                  ],
                  [
                    58351.4,
                    29933.1
                  ],
                  [
                    58466.9,
                    30121.5
                  ],
                  [
                    58626.4,
                    30199
                  ],
                  [
                    58748.8,
                    30587.3
                  ],
                  [
                    58961.2,
                    30433.2
                  ]
                ],
                "id": 273,
                "chat_link": "[&BBEBAAA=]"
              }
            },
            "adventures": [],
            "id": 272,
            "mastery_points": []
          },
          "274": {
            "name": "Operation: Bulwark",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "277": {
                "name": "Martyr's Woods",
                "level": 7,
                "coord": [
                  59590,
                  30474.5
                ],
                "bounds": [
                  [
                    59560.1,
                    30894.6
                  ],
                  [
                    59675.6,
                    30968.6
                  ],
                  [
                    59690.2,
                    30862
                  ],
                  [
                    59791.4,
                    30755.1
                  ],
                  [
                    59841.6,
                    30697.2
                  ],
                  [
                    59923.6,
                    30631.9
                  ],
                  [
                    60012.8,
                    30625.2
                  ],
                  [
                    60015.7,
                    30511
                  ],
                  [
                    59960.6,
                    30423.9
                  ],
                  [
                    59972.9,
                    30374.3
                  ],
                  [
                    59902.5,
                    30279.9
                  ],
                  [
                    59716.5,
                    30309.4
                  ],
                  [
                    59512,
                    30254.2
                  ],
                  [
                    59422,
                    30134.8
                  ],
                  [
                    59317.8,
                    30001
                  ],
                  [
                    59074.2,
                    30119.8
                  ],
                  [
                    59157.5,
                    30232.6
                  ],
                  [
                    59078,
                    30274.2
                  ],
                  [
                    59005.9,
                    30466.7
                  ],
                  [
                    59169.3,
                    30673.2
                  ],
                  [
                    59560.1,
                    30894.6
                  ]
                ],
                "id": 277,
                "chat_link": "[&BBUBAAA=]"
              }
            },
            "adventures": [],
            "id": 274,
            "mastery_points": []
          },
          "275": {
            "name": "AWOL",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "adventures": [],
            "id": 275,
            "mastery_points": []
          },
          "276": {
            "name": "Human's Lament",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "287": {
                "name": "Cadem Forest",
                "level": 13,
                "coord": [
                  61649.7,
                  30878.2
                ],
                "bounds": [
                  [
                    61175.7,
                    31066.7
                  ],
                  [
                    61382.4,
                    30824.6
                  ],
                  [
                    61302.4,
                    30665.2
                  ],
                  [
                    61292.9,
                    30588.2
                  ],
                  [
                    61470,
                    30418.9
                  ],
                  [
                    61659,
                    30457.1
                  ],
                  [
                    61934.2,
                    30370.9
                  ],
                  [
                    61939.4,
                    30675.2
                  ],
                  [
                    62008.4,
                    30866.8
                  ],
                  [
                    61943.6,
                    31211.3
                  ],
                  [
                    61956.3,
                    31299.2
                  ],
                  [
                    61939.3,
                    31504.9
                  ],
                  [
                    61442.5,
                    31467.4
                  ],
                  [
                    61175.7,
                    31066.7
                  ]
                ],
                "id": 287,
                "chat_link": "[&BB8BAAA=]"
              },
              "289": {
                "name": "Ascalon City Ruins",
                "level": 14,
                "coord": [
                  61034.8,
                  30253.6
                ],
                "bounds": [
                  [
                    61011.7,
                    30731.4
                  ],
                  [
                    60697,
                    30393
                  ],
                  [
                    60723.5,
                    30048.4
                  ],
                  [
                    60727.4,
                    29978.6
                  ],
                  [
                    60743.3,
                    29921.7
                  ],
                  [
                    60963.8,
                    29895.4
                  ],
                  [
                    61426,
                    29892.3
                  ],
                  [
                    61466,
                    30421.3
                  ],
                  [
                    61289.4,
                    30588.3
                  ],
                  [
                    61300,
                    30665.6
                  ],
                  [
                    61011.7,
                    30731.4
                  ]
                ],
                "id": 289,
                "chat_link": "[&BCEBAAA=]"
              },
              "293": {
                "name": "Human's Lament",
                "level": 14,
                "coord": [
                  61730.5,
                  30125.3
                ],
                "bounds": [
                  [
                    61438.6,
                    30135.4
                  ],
                  [
                    61423.9,
                    29896.1
                  ],
                  [
                    61598.6,
                    29922.2
                  ],
                  [
                    61700.4,
                    29837.9
                  ],
                  [
                    61921.9,
                    29893.1
                  ],
                  [
                    62009.2,
                    29994.1
                  ],
                  [
                    61936.7,
                    30165.6
                  ],
                  [
                    61949.6,
                    30275
                  ],
                  [
                    61935.4,
                    30378.1
                  ],
                  [
                    61656,
                    30460.7
                  ],
                  [
                    61465.6,
                    30420.5
                  ],
                  [
                    61438.6,
                    30135.4
                  ]
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              }
            },
            "adventures": [],
            "id": 276,
            "mastery_points": []
          },
          "282": {
            "name": "Misplaced Faith",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              58048,
              28760
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                27648
              ]
            ],
            "continent_rect": [
              [
                56320,
                27648
              ],
              [
                59904,
                29952
              ]
            ],
            "points_of_interest": {
              "274": {
                "name": "Dunrock Gulch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57482.8,
                  29775.1
                ],
                "id": 274,
                "chat_link": "[&BBIBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "22": {
                "name": "Oldgate Clearing",
                "level": 16,
                "coord": [
                  57173.7,
                  29674.2
                ],
                "bounds": [
                  [
                    56774.2,
                    29496.8
                  ],
                  [
                    56962.9,
                    29671.9
                  ],
                  [
                    56955.8,
                    29905.5
                  ],
                  [
                    57052.6,
                    29936.1
                  ],
                  [
                    57309.6,
                    30059.9
                  ],
                  [
                    57593.1,
                    29939.2
                  ],
                  [
                    57541,
                    29562.9
                  ],
                  [
                    57442.6,
                    29416.1
                  ],
                  [
                    57156.4,
                    29305.3
                  ],
                  [
                    56949,
                    29448.9
                  ],
                  [
                    56774.2,
                    29496.8
                  ]
                ],
                "id": 22,
                "chat_link": "[&BBYAAAA=]"
              }
            },
            "adventures": [],
            "id": 282,
            "mastery_points": []
          },
          "283": {
            "name": "Thicker Than Water",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "929": {
                "name": "Citadel Stockade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57151.1,
                  30615.6
                ],
                "id": 929,
                "chat_link": "[&BKEDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "744": {
                "name": "Mustering Ground",
                "level": 0,
                "coord": [
                  57622,
                  30648.7
                ],
                "bounds": [
                  [
                    57372.6,
                    30664.2
                  ],
                  [
                    57372.6,
                    30556.7
                  ],
                  [
                    57866.6,
                    30544.8
                  ],
                  [
                    57868.2,
                    30671.5
                  ],
                  [
                    57706.2,
                    30687.7
                  ],
                  [
                    57701.3,
                    30724.8
                  ],
                  [
                    57466.5,
                    30691.3
                  ],
                  [
                    57372.6,
                    30664.2
                  ]
                ],
                "id": 744,
                "chat_link": "[&BOgCAAA=]"
              },
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              },
              "812": {
                "name": "Iron Legion Arsenal",
                "level": 0,
                "coord": [
                  57390.4,
                  30760
                ],
                "bounds": [
                  [
                    57308.4,
                    30786.6
                  ],
                  [
                    57368.6,
                    30668.2
                  ],
                  [
                    57466.3,
                    30691.7
                  ],
                  [
                    57423.2,
                    30795.8
                  ],
                  [
                    57385.3,
                    30857.5
                  ],
                  [
                    57308.4,
                    30786.6
                  ]
                ],
                "id": 812,
                "chat_link": "[&BCwDAAA=]"
              },
              "817": {
                "name": "Perimeter Loop",
                "level": 0,
                "coord": [
                  57187.5,
                  30628.6
                ],
                "bounds": [
                  [
                    56978.8,
                    30386.7
                  ],
                  [
                    57066.5,
                    30349.7
                  ],
                  [
                    57155.7,
                    30353.3
                  ],
                  [
                    57231.9,
                    30375.6
                  ],
                  [
                    57305.8,
                    30411.1
                  ],
                  [
                    57332.3,
                    30443.3
                  ],
                  [
                    57326.2,
                    30493.3
                  ],
                  [
                    57375.2,
                    30560
                  ],
                  [
                    57371.1,
                    30659.8
                  ],
                  [
                    57306.9,
                    30790.5
                  ],
                  [
                    57342.6,
                    30817
                  ],
                  [
                    57260.8,
                    30890.8
                  ],
                  [
                    57189.3,
                    30919.9
                  ],
                  [
                    57067.2,
                    30935.5
                  ],
                  [
                    56967.5,
                    30914.8
                  ],
                  [
                    56996.8,
                    30795.9
                  ],
                  [
                    57050.3,
                    30735.5
                  ],
                  [
                    57092,
                    30748.3
                  ],
                  [
                    57162.6,
                    30750.6
                  ],
                  [
                    57230.4,
                    30707.1
                  ],
                  [
                    57261.5,
                    30656.8
                  ],
                  [
                    57250.8,
                    30571.5
                  ],
                  [
                    57195.1,
                    30495.8
                  ],
                  [
                    57127,
                    30466.6
                  ],
                  [
                    57042.4,
                    30485.1
                  ],
                  [
                    56978.8,
                    30386.7
                  ]
                ],
                "id": 817,
                "chat_link": "[&BDEDAAA=]"
              },
              "823": {
                "name": "Ligacus Aquilo",
                "level": 0,
                "coord": [
                  56786.7,
                  30428.3
                ],
                "bounds": [
                  [
                    56251.5,
                    30544.9
                  ],
                  [
                    56328,
                    30244.3
                  ],
                  [
                    56788,
                    30310.5
                  ],
                  [
                    56957.3,
                    30301.6
                  ],
                  [
                    56983,
                    30393.2
                  ],
                  [
                    57031.7,
                    30469.6
                  ],
                  [
                    56973,
                    30450.5
                  ],
                  [
                    56897.5,
                    30470.5
                  ],
                  [
                    56846.1,
                    30509.1
                  ],
                  [
                    56810.5,
                    30589.3
                  ],
                  [
                    56251.5,
                    30544.9
                  ]
                ],
                "id": 823,
                "chat_link": "[&BDcDAAA=]"
              }
            },
            "adventures": [],
            "id": 283,
            "mastery_points": []
          },
          "284": {
            "name": "Dishonorable Discharge",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "740": {
                "name": "The Bane",
                "level": 0,
                "coord": [
                  56926.4,
                  30597.2
                ],
                "bounds": [
                  [
                    56807.9,
                    30588.7
                  ],
                  [
                    56842.9,
                    30517.5
                  ],
                  [
                    56895.7,
                    30469.8
                  ],
                  [
                    56971.6,
                    30450.5
                  ],
                  [
                    57020.1,
                    30460.7
                  ],
                  [
                    57066.5,
                    30475.4
                  ],
                  [
                    57007.7,
                    30495.6
                  ],
                  [
                    57041.2,
                    30788.5
                  ],
                  [
                    56952.9,
                    30795.1
                  ],
                  [
                    56875,
                    30763.3
                  ],
                  [
                    56825.9,
                    30707.5
                  ],
                  [
                    56808.6,
                    30654.1
                  ],
                  [
                    56807.9,
                    30588.7
                  ]
                ],
                "id": 740,
                "chat_link": "[&BOQCAAA=]"
              }
            },
            "adventures": [],
            "id": 284,
            "mastery_points": []
          },
          "287": {
            "name": "Searching for the Truth",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "828": {
                "name": "Blood Tribune Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57061.9,
                  30687.5
                ],
                "id": 828,
                "chat_link": "[&BDwDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "adventures": [],
            "id": 287,
            "mastery_points": []
          },
          "288": {
            "name": "Lighting the Beacons",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "929": {
                "name": "Citadel Stockade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57151.1,
                  30615.6
                ],
                "id": 929,
                "chat_link": "[&BKEDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "adventures": [],
            "id": 288,
            "mastery_points": []
          },
          "290": {
            "name": "Stoking the Flame",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "282": {
                "name": "Ascalon Basin",
                "level": 12,
                "coord": [
                  61215.8,
                  31531.5
                ],
                "bounds": [
                  [
                    60666,
                    31652.3
                  ],
                  [
                    60982.6,
                    31591.5
                  ],
                  [
                    61296.3,
                    31773.7
                  ],
                  [
                    61458.5,
                    31781.3
                  ],
                  [
                    61619.4,
                    31898.9
                  ],
                  [
                    61603.1,
                    32053.5
                  ],
                  [
                    61680.8,
                    32143
                  ],
                  [
                    61800.4,
                    32266.6
                  ],
                  [
                    62020.7,
                    31978.7
                  ],
                  [
                    62040.4,
                    31882.4
                  ],
                  [
                    61961.6,
                    31505.5
                  ],
                  [
                    61442.9,
                    31466.1
                  ],
                  [
                    61175.9,
                    31065.4
                  ],
                  [
                    61051.7,
                    31086
                  ],
                  [
                    60870.2,
                    30981.4
                  ],
                  [
                    60845.5,
                    30844.8
                  ],
                  [
                    60643.1,
                    30846.8
                  ],
                  [
                    60386,
                    31101.2
                  ],
                  [
                    60307.5,
                    31326.2
                  ],
                  [
                    60462.6,
                    31384.5
                  ],
                  [
                    60666,
                    31652.3
                  ]
                ],
                "id": 282,
                "chat_link": "[&BBoBAAA=]"
              },
              "285": {
                "name": "Lamia Mire",
                "level": 11,
                "coord": [
                  61089.9,
                  30885.5
                ],
                "bounds": [
                  [
                    61009.7,
                    30727.9
                  ],
                  [
                    61300.9,
                    30664.1
                  ],
                  [
                    61380.3,
                    30824.2
                  ],
                  [
                    61174.3,
                    31068.5
                  ],
                  [
                    61050.9,
                    31087.3
                  ],
                  [
                    60868.5,
                    30981.8
                  ],
                  [
                    60844.7,
                    30845
                  ],
                  [
                    61009.7,
                    30727.9
                  ]
                ],
                "id": 285,
                "chat_link": "[&BB0BAAA=]"
              }
            },
            "adventures": [],
            "id": 290,
            "mastery_points": []
          },
          "294": {
            "name": "A Fork in the Road",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              58048,
              28760
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                27648
              ]
            ],
            "continent_rect": [
              [
                56320,
                27648
              ],
              [
                59904,
                29952
              ]
            ],
            "points_of_interest": {
              "417": {
                "name": "Silex Castrum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56492.8,
                  29097.2
                ],
                "id": 417,
                "chat_link": "[&BKEBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "40": {
                "name": "Arcovian Foothills",
                "level": 17,
                "coord": [
                  56514.8,
                  29273
                ],
                "bounds": [
                  [
                    56345.7,
                    29718.1
                  ],
                  [
                    56775,
                    29495.9
                  ],
                  [
                    56629.5,
                    29371.7
                  ],
                  [
                    56632.1,
                    29179.1
                  ],
                  [
                    56758.9,
                    29036.8
                  ],
                  [
                    56665.3,
                    28867.1
                  ],
                  [
                    56344.9,
                    29015.9
                  ],
                  [
                    56247.1,
                    29213.1
                  ],
                  [
                    56235,
                    29559.6
                  ],
                  [
                    56345.7,
                    29718.1
                  ]
                ],
                "id": 40,
                "chat_link": "[&BCgAAAA=]"
              }
            },
            "adventures": [],
            "id": 294,
            "mastery_points": []
          },
          "295": {
            "name": "Sins of the Father",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 295,
            "mastery_points": []
          },
          "297": {
            "name": "Graveyard Ornaments",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 297,
            "mastery_points": []
          },
          "327": {
            "name": "Desperate Medicine",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {
              "261": {
                "name": "Vanguard Hospital",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44353.8,
                  26577.9
                ],
                "id": 261,
                "chat_link": "[&BAUBAAA=]"
              },
              "262": {
                "name": "Queen's Heart Orphanage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44280.3,
                  26860.6
                ],
                "id": 262,
                "chat_link": "[&BAYBAAA=]"
              },
              "266": {
                "name": "Manor Hill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44154,
                  26741.5
                ],
                "id": 266,
                "chat_link": "[&BAoBAAA=]"
              },
              "267": {
                "name": "Cottage Bend",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44355.6,
                  26907.3
                ],
                "id": 267,
                "chat_link": "[&BAsBAAA=]"
              },
              "268": {
                "name": "Rook's Row",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44383.1,
                  26758.6
                ],
                "id": 268,
                "chat_link": "[&BAwBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "187": {
                "name": "Salma District (Home)",
                "level": 0,
                "coord": [
                  44309.2,
                  26738.4
                ],
                "bounds": [
                  [
                    44409.9,
                    26426.2
                  ],
                  [
                    44262.5,
                    26365.6
                  ],
                  [
                    44194.7,
                    26638
                  ],
                  [
                    44128.4,
                    26704.4
                  ],
                  [
                    44054.6,
                    26742.7
                  ],
                  [
                    44054.2,
                    26822.1
                  ],
                  [
                    44129.5,
                    26847.2
                  ],
                  [
                    44224.3,
                    26883.8
                  ],
                  [
                    44296.2,
                    26924.9
                  ],
                  [
                    44344.8,
                    26997.1
                  ],
                  [
                    44427,
                    26942.6
                  ],
                  [
                    44427.7,
                    26872.1
                  ],
                  [
                    44478.9,
                    26761.8
                  ],
                  [
                    44663.5,
                    26630.9
                  ],
                  [
                    44542.4,
                    26517.4
                  ],
                  [
                    44409.9,
                    26426.2
                  ]
                ],
                "id": 187,
                "chat_link": "[&BLsAAAA=]"
              }
            },
            "id": 327,
            "mastery_points": [],
            "adventures": []
          },
          "363": {
            "name": "The Sting",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "82": {
                "name": "Blackroot Cut",
                "level": 16,
                "coord": [
                  45894.2,
                  30717.2
                ],
                "bounds": [
                  [
                    45577.1,
                    30669
                  ],
                  [
                    45610.7,
                    30830.5
                  ],
                  [
                    45765.4,
                    30764.3
                  ],
                  [
                    45854.1,
                    30775.7
                  ],
                  [
                    45827.5,
                    30946.8
                  ],
                  [
                    45890,
                    30939.4
                  ],
                  [
                    45934.6,
                    30894.3
                  ],
                  [
                    45996.5,
                    30889.7
                  ],
                  [
                    46139.5,
                    30778.3
                  ],
                  [
                    46243.3,
                    30532.6
                  ],
                  [
                    46199.3,
                    30446
                  ],
                  [
                    45947,
                    30405.5
                  ],
                  [
                    45639.2,
                    30451.9
                  ],
                  [
                    45577.1,
                    30669
                  ]
                ],
                "id": 82,
                "chat_link": "[&BFIAAAA=]"
              }
            },
            "adventures": [],
            "id": 363,
            "mastery_points": []
          },
          "364": {
            "name": "Drawing Out the Cult",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {
              "26": {
                "name": "Jannaj's Bandits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45361.2,
                  30551.3
                ],
                "id": 26,
                "chat_link": "[&BBoAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "86": {
                "name": "Sojourner's Way",
                "level": 15,
                "coord": [
                  45174.4,
                  30638.1
                ],
                "bounds": [
                  [
                    45621.2,
                    30832.1
                  ],
                  [
                    45577.9,
                    30670
                  ],
                  [
                    45641,
                    30452.5
                  ],
                  [
                    45560.2,
                    30414.4
                  ],
                  [
                    45356.7,
                    30456.5
                  ],
                  [
                    45073.4,
                    30450.4
                  ],
                  [
                    45001.6,
                    30402.2
                  ],
                  [
                    44903,
                    30440.5
                  ],
                  [
                    44729.4,
                    30443.9
                  ],
                  [
                    44638,
                    30900.2
                  ],
                  [
                    44714.8,
                    31011.5
                  ],
                  [
                    44954.3,
                    30763.5
                  ],
                  [
                    45192.5,
                    30762.8
                  ],
                  [
                    45477.2,
                    30932.9
                  ],
                  [
                    45621.2,
                    30832.1
                  ]
                ],
                "id": 86,
                "chat_link": "[&BFYAAAA=]"
              }
            },
            "adventures": [],
            "id": 364,
            "mastery_points": []
          },
          "365": {
            "name": "Ashes of the Past",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "88": {
                "name": "Darkwound Defile",
                "level": 18,
                "coord": [
                  46049.7,
                  31542.2
                ],
                "bounds": [
                  [
                    46124.1,
                    31851
                  ],
                  [
                    46199.7,
                    31666.2
                  ],
                  [
                    46198.3,
                    31577
                  ],
                  [
                    46111.1,
                    31409.2
                  ],
                  [
                    46142.8,
                    31245
                  ],
                  [
                    45848.9,
                    31288.5
                  ],
                  [
                    45898.2,
                    31472.4
                  ],
                  [
                    45874.4,
                    31828.5
                  ],
                  [
                    46124.1,
                    31851
                  ]
                ],
                "id": 88,
                "chat_link": "[&BFgAAAA=]"
              }
            },
            "adventures": [],
            "id": 365,
            "mastery_points": []
          },
          "379": {
            "name": "The Great Hunt",
            "min_level": 1,
            "max_level": 1,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "200": {
                "name": "Borealis Forest",
                "level": 5,
                "coord": [
                  55458.4,
                  31311.6
                ],
                "bounds": [
                  [
                    54941.6,
                    31566.1
                  ],
                  [
                    54965.4,
                    31394.7
                  ],
                  [
                    55114.1,
                    31398.1
                  ],
                  [
                    55542.2,
                    31028.7
                  ],
                  [
                    55709.4,
                    30997.8
                  ],
                  [
                    55776.4,
                    30997.2
                  ],
                  [
                    55817.2,
                    31036.9
                  ],
                  [
                    55778.4,
                    31118.2
                  ],
                  [
                    55713.8,
                    31630.9
                  ],
                  [
                    55477.1,
                    31642.2
                  ],
                  [
                    55206.8,
                    31616.5
                  ],
                  [
                    54941.6,
                    31566.1
                  ]
                ],
                "id": 200,
                "chat_link": "[&BMgAAAA=]"
              },
              "201": {
                "name": "Snowlord's Gate",
                "level": 2,
                "coord": [
                  55057.6,
                  31036
                ],
                "bounds": [
                  [
                    55114.5,
                    31399.2
                  ],
                  [
                    55538.9,
                    31028.7
                  ],
                  [
                    55445,
                    30973.2
                  ],
                  [
                    55364.5,
                    30906.9
                  ],
                  [
                    55271.6,
                    30878.4
                  ],
                  [
                    55052.7,
                    30720.3
                  ],
                  [
                    54961.1,
                    30720.2
                  ],
                  [
                    54533,
                    30817.9
                  ],
                  [
                    54501.8,
                    31276.3
                  ],
                  [
                    54883.3,
                    31277.5
                  ],
                  [
                    54966.6,
                    31397.1
                  ],
                  [
                    55114.5,
                    31399.2
                  ]
                ],
                "id": 201,
                "chat_link": "[&BMkAAAA=]"
              },
              "512": {
                "name": "Hangrammr Climb",
                "level": 7,
                "coord": [
                  55420.7,
                  30764.1
                ],
                "bounds": [
                  [
                    55542.3,
                    31033.3
                  ],
                  [
                    55441.4,
                    30971.9
                  ],
                  [
                    55364.3,
                    30909.9
                  ],
                  [
                    55270.8,
                    30882.8
                  ],
                  [
                    55052.9,
                    30720.8
                  ],
                  [
                    55058,
                    30601.9
                  ],
                  [
                    55124.3,
                    30544.6
                  ],
                  [
                    55410.5,
                    30525.2
                  ],
                  [
                    55558.1,
                    30482.5
                  ],
                  [
                    55742.3,
                    30642.4
                  ],
                  [
                    55505.8,
                    30651
                  ],
                  [
                    55461.3,
                    30788.4
                  ],
                  [
                    55648.9,
                    30936.3
                  ],
                  [
                    55708.7,
                    31006.5
                  ],
                  [
                    55542.3,
                    31033.3
                  ]
                ],
                "id": 512,
                "chat_link": "[&BAACAAA=]"
              }
            },
            "adventures": [],
            "id": 379,
            "mastery_points": []
          },
          "380": {
            "name": "A Weapon of Legend",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "198": {
                "name": "Grawlenfjord",
                "level": 3,
                "coord": [
                  55900.5,
                  31298.1
                ],
                "bounds": [
                  [
                    55773.9,
                    31117.4
                  ],
                  [
                    55817,
                    31037.1
                  ],
                  [
                    55865.1,
                    31047.1
                  ],
                  [
                    55893.6,
                    30997.3
                  ],
                  [
                    56081,
                    30999.2
                  ],
                  [
                    56068.5,
                    31380.1
                  ],
                  [
                    56051.4,
                    31713
                  ],
                  [
                    55840.6,
                    31765.8
                  ],
                  [
                    55713.6,
                    31626.1
                  ],
                  [
                    55773.9,
                    31117.4
                  ]
                ],
                "id": 198,
                "chat_link": "[&BMYAAAA=]"
              },
              "199": {
                "name": "Kresdor Kenning",
                "level": 4,
                "coord": [
                  56190.7,
                  31094
                ],
                "bounds": [
                  [
                    56041.5,
                    30806.2
                  ],
                  [
                    56303.2,
                    30827
                  ],
                  [
                    56360.8,
                    31142.7
                  ],
                  [
                    56296.1,
                    31417.1
                  ],
                  [
                    56066.1,
                    31360.4
                  ],
                  [
                    56076.6,
                    31010.9
                  ],
                  [
                    56041.5,
                    30806.2
                  ]
                ],
                "id": 199,
                "chat_link": "[&BMcAAAA=]"
              }
            },
            "adventures": [],
            "id": 380,
            "mastery_points": []
          },
          "381": {
            "name": "The Last of the Giant-Kings",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {
              "974": {
                "name": "Haivoissen Kenning",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54705.9,
                  30255.7
                ],
                "id": 974,
                "chat_link": "[&BM4DAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "202": {
                "name": "The Osenfold Shear",
                "level": 7,
                "coord": [
                  54845,
                  30296.8
                ],
                "bounds": [
                  [
                    54850.6,
                    30020.3
                  ],
                  [
                    54913.7,
                    29963.9
                  ],
                  [
                    55056.6,
                    30174.2
                  ],
                  [
                    55176.7,
                    30189.9
                  ],
                  [
                    55239.6,
                    30317.4
                  ],
                  [
                    54963.7,
                    30397.6
                  ],
                  [
                    54941.2,
                    30473
                  ],
                  [
                    54985,
                    30528
                  ],
                  [
                    54961.6,
                    30720.9
                  ],
                  [
                    54528.6,
                    30814.3
                  ],
                  [
                    54435.7,
                    30440.9
                  ],
                  [
                    54503.1,
                    30062.8
                  ],
                  [
                    54564.7,
                    30133.4
                  ],
                  [
                    54697.3,
                    30168
                  ],
                  [
                    54856.4,
                    30048.2
                  ],
                  [
                    54850.6,
                    30020.3
                  ]
                ],
                "id": 202,
                "chat_link": "[&BMoAAAA=]"
              }
            },
            "adventures": [],
            "id": 381,
            "mastery_points": []
          },
          "382": {
            "name": "Disciples of the Dragon",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {
              "364": {
                "name": "Alpenzure Cave",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55303.1,
                  32129.6
                ],
                "id": 364,
                "chat_link": "[&BGwBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "196": {
                "name": "Outcast's Cleft",
                "level": 4,
                "coord": [
                  55456.1,
                  31954.3
                ],
                "bounds": [
                  [
                    56176.1,
                    32113.4
                  ],
                  [
                    55713.9,
                    31630.6
                  ],
                  [
                    55476.3,
                    31640
                  ],
                  [
                    55207.1,
                    31617.5
                  ],
                  [
                    55224.6,
                    31919.5
                  ],
                  [
                    54994.2,
                    32073.5
                  ],
                  [
                    55001.5,
                    32168.5
                  ],
                  [
                    55489.6,
                    32215.6
                  ],
                  [
                    55821.8,
                    32210.1
                  ],
                  [
                    56176.1,
                    32113.4
                  ]
                ],
                "id": 196,
                "chat_link": "[&BMQAAAA=]"
              }
            },
            "adventures": [],
            "id": 382,
            "mastery_points": []
          },
          "385": {
            "name": "A Weapon of Legend",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "886": {
                "name": "Stonewright's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54015.6,
                  31159.6
                ],
                "id": 886,
                "chat_link": "[&BHYDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "805": {
                "name": "Frost Basin",
                "level": 0,
                "coord": [
                  54220.9,
                  31207.1
                ],
                "bounds": [
                  [
                    53878,
                    31116.3
                  ],
                  [
                    54211.6,
                    30928.4
                  ],
                  [
                    54549.9,
                    30961
                  ],
                  [
                    54551.5,
                    31357.6
                  ],
                  [
                    54329.2,
                    31369.1
                  ],
                  [
                    54144.6,
                    31355.4
                  ],
                  [
                    53881.3,
                    31362.3
                  ],
                  [
                    53878,
                    31116.3
                  ]
                ],
                "id": 805,
                "chat_link": "[&BCUDAAA=]"
              }
            },
            "adventures": [],
            "id": 385,
            "mastery_points": []
          },
          "386": {
            "name": "Echoes of Ages Past",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {
              "974": {
                "name": "Haivoissen Kenning",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54705.9,
                  30255.7
                ],
                "id": 974,
                "chat_link": "[&BM4DAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "202": {
                "name": "The Osenfold Shear",
                "level": 7,
                "coord": [
                  54845,
                  30296.8
                ],
                "bounds": [
                  [
                    54850.6,
                    30020.3
                  ],
                  [
                    54913.7,
                    29963.9
                  ],
                  [
                    55056.6,
                    30174.2
                  ],
                  [
                    55176.7,
                    30189.9
                  ],
                  [
                    55239.6,
                    30317.4
                  ],
                  [
                    54963.7,
                    30397.6
                  ],
                  [
                    54941.2,
                    30473
                  ],
                  [
                    54985,
                    30528
                  ],
                  [
                    54961.6,
                    30720.9
                  ],
                  [
                    54528.6,
                    30814.3
                  ],
                  [
                    54435.7,
                    30440.9
                  ],
                  [
                    54503.1,
                    30062.8
                  ],
                  [
                    54564.7,
                    30133.4
                  ],
                  [
                    54697.3,
                    30168
                  ],
                  [
                    54856.4,
                    30048.2
                  ],
                  [
                    54850.6,
                    30020.3
                  ]
                ],
                "id": 202,
                "chat_link": "[&BMoAAAA=]"
              }
            },
            "adventures": [],
            "id": 386,
            "mastery_points": []
          },
          "387": {
            "name": "Wild Spirits",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {
              "357": {
                "name": "Heart of the Wolf",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55478.8,
                  31773.4
                ],
                "id": 357,
                "chat_link": "[&BGUBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "196": {
                "name": "Outcast's Cleft",
                "level": 4,
                "coord": [
                  55456.1,
                  31954.3
                ],
                "bounds": [
                  [
                    56176.1,
                    32113.4
                  ],
                  [
                    55713.9,
                    31630.6
                  ],
                  [
                    55476.3,
                    31640
                  ],
                  [
                    55207.1,
                    31617.5
                  ],
                  [
                    55224.6,
                    31919.5
                  ],
                  [
                    54994.2,
                    32073.5
                  ],
                  [
                    55001.5,
                    32168.5
                  ],
                  [
                    55489.6,
                    32215.6
                  ],
                  [
                    55821.8,
                    32210.1
                  ],
                  [
                    56176.1,
                    32113.4
                  ]
                ],
                "id": 196,
                "chat_link": "[&BMQAAAA=]"
              },
              "200": {
                "name": "Borealis Forest",
                "level": 5,
                "coord": [
                  55458.4,
                  31311.6
                ],
                "bounds": [
                  [
                    54941.6,
                    31566.1
                  ],
                  [
                    54965.4,
                    31394.7
                  ],
                  [
                    55114.1,
                    31398.1
                  ],
                  [
                    55542.2,
                    31028.7
                  ],
                  [
                    55709.4,
                    30997.8
                  ],
                  [
                    55776.4,
                    30997.2
                  ],
                  [
                    55817.2,
                    31036.9
                  ],
                  [
                    55778.4,
                    31118.2
                  ],
                  [
                    55713.8,
                    31630.9
                  ],
                  [
                    55477.1,
                    31642.2
                  ],
                  [
                    55206.8,
                    31616.5
                  ],
                  [
                    54941.6,
                    31566.1
                  ]
                ],
                "id": 200,
                "chat_link": "[&BMgAAAA=]"
              }
            },
            "adventures": [],
            "id": 387,
            "mastery_points": []
          },
          "388": {
            "name": "Out of the Skies",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {
              "365": {
                "name": "Gaerta's Summit",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55146.1,
                  30687.5
                ],
                "id": 365,
                "chat_link": "[&BG0BAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "202": {
                "name": "The Osenfold Shear",
                "level": 7,
                "coord": [
                  54845,
                  30296.8
                ],
                "bounds": [
                  [
                    54850.6,
                    30020.3
                  ],
                  [
                    54913.7,
                    29963.9
                  ],
                  [
                    55056.6,
                    30174.2
                  ],
                  [
                    55176.7,
                    30189.9
                  ],
                  [
                    55239.6,
                    30317.4
                  ],
                  [
                    54963.7,
                    30397.6
                  ],
                  [
                    54941.2,
                    30473
                  ],
                  [
                    54985,
                    30528
                  ],
                  [
                    54961.6,
                    30720.9
                  ],
                  [
                    54528.6,
                    30814.3
                  ],
                  [
                    54435.7,
                    30440.9
                  ],
                  [
                    54503.1,
                    30062.8
                  ],
                  [
                    54564.7,
                    30133.4
                  ],
                  [
                    54697.3,
                    30168
                  ],
                  [
                    54856.4,
                    30048.2
                  ],
                  [
                    54850.6,
                    30020.3
                  ]
                ],
                "id": 202,
                "chat_link": "[&BMoAAAA=]"
              },
              "512": {
                "name": "Hangrammr Climb",
                "level": 7,
                "coord": [
                  55420.7,
                  30764.1
                ],
                "bounds": [
                  [
                    55542.3,
                    31033.3
                  ],
                  [
                    55441.4,
                    30971.9
                  ],
                  [
                    55364.3,
                    30909.9
                  ],
                  [
                    55270.8,
                    30882.8
                  ],
                  [
                    55052.9,
                    30720.8
                  ],
                  [
                    55058,
                    30601.9
                  ],
                  [
                    55124.3,
                    30544.6
                  ],
                  [
                    55410.5,
                    30525.2
                  ],
                  [
                    55558.1,
                    30482.5
                  ],
                  [
                    55742.3,
                    30642.4
                  ],
                  [
                    55505.8,
                    30651
                  ],
                  [
                    55461.3,
                    30788.4
                  ],
                  [
                    55648.9,
                    30936.3
                  ],
                  [
                    55708.7,
                    31006.5
                  ],
                  [
                    55542.3,
                    31033.3
                  ]
                ],
                "id": 512,
                "chat_link": "[&BAACAAA=]"
              },
              "829": {
                "name": "Breakneck Pass",
                "level": 6,
                "coord": [
                  55081.7,
                  30536.1
                ],
                "bounds": [
                  [
                    54986.1,
                    30527.5
                  ],
                  [
                    54941.3,
                    30472.7
                  ],
                  [
                    54963.7,
                    30397.4
                  ],
                  [
                    55239.9,
                    30316.5
                  ],
                  [
                    55408.2,
                    30524.3
                  ],
                  [
                    55123.8,
                    30544.2
                  ],
                  [
                    55058,
                    30601.3
                  ],
                  [
                    55053.3,
                    30721
                  ],
                  [
                    54961.5,
                    30720.2
                  ],
                  [
                    54986.1,
                    30527.5
                  ]
                ],
                "id": 829,
                "chat_link": "[&BD0DAAA=]"
              }
            },
            "adventures": [],
            "id": 388,
            "mastery_points": []
          },
          "389": {
            "name": "Echoes of Ages Past",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "886": {
                "name": "Stonewright's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54015.6,
                  31159.6
                ],
                "id": 886,
                "chat_link": "[&BHYDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "805": {
                "name": "Frost Basin",
                "level": 0,
                "coord": [
                  54220.9,
                  31207.1
                ],
                "bounds": [
                  [
                    53878,
                    31116.3
                  ],
                  [
                    54211.6,
                    30928.4
                  ],
                  [
                    54549.9,
                    30961
                  ],
                  [
                    54551.5,
                    31357.6
                  ],
                  [
                    54329.2,
                    31369.1
                  ],
                  [
                    54144.6,
                    31355.4
                  ],
                  [
                    53881.3,
                    31362.3
                  ],
                  [
                    53878,
                    31116.3
                  ]
                ],
                "id": 805,
                "chat_link": "[&BCUDAAA=]"
              }
            },
            "adventures": [],
            "id": 389,
            "mastery_points": []
          },
          "390": {
            "name": "Twilight of the Wolf",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "894": {
                "name": "Dragon Hallow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53310.8,
                  29861.1
                ],
                "id": 894,
                "chat_link": "[&BH4DAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "797": {
                "name": "Might and Main",
                "level": 0,
                "coord": [
                  53821.1,
                  30398.4
                ],
                "bounds": [
                  [
                    54184.5,
                    30431.1
                  ],
                  [
                    54144.6,
                    30443.3
                  ],
                  [
                    54087.9,
                    30559.6
                  ],
                  [
                    54131.3,
                    30597.5
                  ],
                  [
                    54118.8,
                    30657.7
                  ],
                  [
                    54062.4,
                    30699.1
                  ],
                  [
                    54048.6,
                    30691.1
                  ],
                  [
                    54011.9,
                    30722.8
                  ],
                  [
                    54019.3,
                    30734.2
                  ],
                  [
                    53976,
                    30783.2
                  ],
                  [
                    53964.2,
                    30822.1
                  ],
                  [
                    53866.7,
                    30845.7
                  ],
                  [
                    53780.8,
                    30722
                  ],
                  [
                    53675.4,
                    30645.9
                  ],
                  [
                    53542.9,
                    30597.3
                  ],
                  [
                    53466,
                    30601.3
                  ],
                  [
                    53491.2,
                    30526.9
                  ],
                  [
                    53389,
                    30508.3
                  ],
                  [
                    53410.7,
                    30402.4
                  ],
                  [
                    53442.6,
                    30404.5
                  ],
                  [
                    53455.2,
                    30336.2
                  ],
                  [
                    53419.3,
                    30328.2
                  ],
                  [
                    53440.7,
                    30219.1
                  ],
                  [
                    53456.4,
                    30174.3
                  ],
                  [
                    53598.6,
                    30065.5
                  ],
                  [
                    53610.4,
                    30111.6
                  ],
                  [
                    53629.4,
                    30140.5
                  ],
                  [
                    53738.1,
                    30136
                  ],
                  [
                    53741.5,
                    30163.8
                  ],
                  [
                    53806.2,
                    30155.6
                  ],
                  [
                    53802.3,
                    30121.3
                  ],
                  [
                    53921.6,
                    30116.4
                  ],
                  [
                    53938,
                    30081.4
                  ],
                  [
                    53940.4,
                    30044.5
                  ],
                  [
                    53999.2,
                    30027.4
                  ],
                  [
                    54058.5,
                    30125.7
                  ],
                  [
                    54116.7,
                    30258.5
                  ],
                  [
                    54088.1,
                    30273.8
                  ],
                  [
                    54120.6,
                    30336
                  ],
                  [
                    54145.9,
                    30326.2
                  ],
                  [
                    54184.5,
                    30431.1
                  ]
                ],
                "id": 797,
                "chat_link": "[&BB0DAAA=]"
              },
              "801": {
                "name": "Veins of the Dragon",
                "level": 0,
                "coord": [
                  53332.3,
                  30070.5
                ],
                "bounds": [
                  [
                    52958.9,
                    29726.7
                  ],
                  [
                    53438.5,
                    29695.9
                  ],
                  [
                    53592.5,
                    30001.4
                  ],
                  [
                    53599.1,
                    30066
                  ],
                  [
                    53456.5,
                    30173.8
                  ],
                  [
                    53439.1,
                    30218.4
                  ],
                  [
                    53364.8,
                    30184.7
                  ],
                  [
                    53292.7,
                    30195.4
                  ],
                  [
                    53233.2,
                    30236.7
                  ],
                  [
                    53179.4,
                    30129.1
                  ],
                  [
                    53100.6,
                    30147.1
                  ],
                  [
                    52958.9,
                    29726.7
                  ]
                ],
                "id": 801,
                "chat_link": "[&BCEDAAA=]"
              }
            },
            "adventures": [],
            "id": 390,
            "mastery_points": []
          },
          "391": {
            "name": "Rage of the Minotaurs",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "512": {
                "name": "Hangrammr Climb",
                "level": 7,
                "coord": [
                  55420.7,
                  30764.1
                ],
                "bounds": [
                  [
                    55542.3,
                    31033.3
                  ],
                  [
                    55441.4,
                    30971.9
                  ],
                  [
                    55364.3,
                    30909.9
                  ],
                  [
                    55270.8,
                    30882.8
                  ],
                  [
                    55052.9,
                    30720.8
                  ],
                  [
                    55058,
                    30601.9
                  ],
                  [
                    55124.3,
                    30544.6
                  ],
                  [
                    55410.5,
                    30525.2
                  ],
                  [
                    55558.1,
                    30482.5
                  ],
                  [
                    55742.3,
                    30642.4
                  ],
                  [
                    55505.8,
                    30651
                  ],
                  [
                    55461.3,
                    30788.4
                  ],
                  [
                    55648.9,
                    30936.3
                  ],
                  [
                    55708.7,
                    31006.5
                  ],
                  [
                    55542.3,
                    31033.3
                  ]
                ],
                "id": 512,
                "chat_link": "[&BAACAAA=]"
              }
            },
            "adventures": [],
            "id": 391,
            "mastery_points": []
          },
          "392": {
            "name": "A Pup's Illness",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "1135": {
                "name": "Traveler's Loft",
                "type": "landmark",
                "floor": 2,
                "coord": [
                  53492.6,
                  31150.2
                ],
                "id": 1135,
                "chat_link": "[&BG8EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "853": {
                "name": "Hunter's Hearth (Home)",
                "level": 0,
                "coord": [
                  53446.5,
                  31107.3
                ],
                "bounds": [
                  [
                    53747.5,
                    31112.5
                  ],
                  [
                    53697.1,
                    31246
                  ],
                  [
                    53704.7,
                    31372.6
                  ],
                  [
                    53430.8,
                    31414.6
                  ],
                  [
                    53129.1,
                    31372.2
                  ],
                  [
                    53085.1,
                    31181.8
                  ],
                  [
                    53179.3,
                    30930.9
                  ],
                  [
                    53316.9,
                    30873.7
                  ],
                  [
                    53460.4,
                    30944
                  ],
                  [
                    53482.9,
                    30898.5
                  ],
                  [
                    53575.8,
                    30945.6
                  ],
                  [
                    53548.9,
                    30995.7
                  ],
                  [
                    53747.5,
                    31112.5
                  ]
                ],
                "id": 853,
                "chat_link": "[&BFUDAAA=]"
              }
            },
            "adventures": [],
            "id": 392,
            "mastery_points": []
          },
          "393": {
            "name": "Through the Veil",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {
              "363": {
                "name": "Heart of the Snow Leopard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55077.5,
                  31518.7
                ],
                "id": 363,
                "chat_link": "[&BGsBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "200": {
                "name": "Borealis Forest",
                "level": 5,
                "coord": [
                  55458.4,
                  31311.6
                ],
                "bounds": [
                  [
                    54941.6,
                    31566.1
                  ],
                  [
                    54965.4,
                    31394.7
                  ],
                  [
                    55114.1,
                    31398.1
                  ],
                  [
                    55542.2,
                    31028.7
                  ],
                  [
                    55709.4,
                    30997.8
                  ],
                  [
                    55776.4,
                    30997.2
                  ],
                  [
                    55817.2,
                    31036.9
                  ],
                  [
                    55778.4,
                    31118.2
                  ],
                  [
                    55713.8,
                    31630.9
                  ],
                  [
                    55477.1,
                    31642.2
                  ],
                  [
                    55206.8,
                    31616.5
                  ],
                  [
                    54941.6,
                    31566.1
                  ]
                ],
                "id": 200,
                "chat_link": "[&BMgAAAA=]"
              },
              "201": {
                "name": "Snowlord's Gate",
                "level": 2,
                "coord": [
                  55057.6,
                  31036
                ],
                "bounds": [
                  [
                    55114.5,
                    31399.2
                  ],
                  [
                    55538.9,
                    31028.7
                  ],
                  [
                    55445,
                    30973.2
                  ],
                  [
                    55364.5,
                    30906.9
                  ],
                  [
                    55271.6,
                    30878.4
                  ],
                  [
                    55052.7,
                    30720.3
                  ],
                  [
                    54961.1,
                    30720.2
                  ],
                  [
                    54533,
                    30817.9
                  ],
                  [
                    54501.8,
                    31276.3
                  ],
                  [
                    54883.3,
                    31277.5
                  ],
                  [
                    54966.6,
                    31397.1
                  ],
                  [
                    55114.5,
                    31399.2
                  ]
                ],
                "id": 201,
                "chat_link": "[&BMkAAAA=]"
              }
            },
            "adventures": [],
            "id": 393,
            "mastery_points": []
          },
          "394": {
            "name": "A Trap Foiled",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {
              "365": {
                "name": "Gaerta's Summit",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55146.1,
                  30687.5
                ],
                "id": 365,
                "chat_link": "[&BG0BAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "202": {
                "name": "The Osenfold Shear",
                "level": 7,
                "coord": [
                  54845,
                  30296.8
                ],
                "bounds": [
                  [
                    54850.6,
                    30020.3
                  ],
                  [
                    54913.7,
                    29963.9
                  ],
                  [
                    55056.6,
                    30174.2
                  ],
                  [
                    55176.7,
                    30189.9
                  ],
                  [
                    55239.6,
                    30317.4
                  ],
                  [
                    54963.7,
                    30397.6
                  ],
                  [
                    54941.2,
                    30473
                  ],
                  [
                    54985,
                    30528
                  ],
                  [
                    54961.6,
                    30720.9
                  ],
                  [
                    54528.6,
                    30814.3
                  ],
                  [
                    54435.7,
                    30440.9
                  ],
                  [
                    54503.1,
                    30062.8
                  ],
                  [
                    54564.7,
                    30133.4
                  ],
                  [
                    54697.3,
                    30168
                  ],
                  [
                    54856.4,
                    30048.2
                  ],
                  [
                    54850.6,
                    30020.3
                  ]
                ],
                "id": 202,
                "chat_link": "[&BMoAAAA=]"
              },
              "512": {
                "name": "Hangrammr Climb",
                "level": 7,
                "coord": [
                  55420.7,
                  30764.1
                ],
                "bounds": [
                  [
                    55542.3,
                    31033.3
                  ],
                  [
                    55441.4,
                    30971.9
                  ],
                  [
                    55364.3,
                    30909.9
                  ],
                  [
                    55270.8,
                    30882.8
                  ],
                  [
                    55052.9,
                    30720.8
                  ],
                  [
                    55058,
                    30601.9
                  ],
                  [
                    55124.3,
                    30544.6
                  ],
                  [
                    55410.5,
                    30525.2
                  ],
                  [
                    55558.1,
                    30482.5
                  ],
                  [
                    55742.3,
                    30642.4
                  ],
                  [
                    55505.8,
                    30651
                  ],
                  [
                    55461.3,
                    30788.4
                  ],
                  [
                    55648.9,
                    30936.3
                  ],
                  [
                    55708.7,
                    31006.5
                  ],
                  [
                    55542.3,
                    31033.3
                  ]
                ],
                "id": 512,
                "chat_link": "[&BAACAAA=]"
              },
              "829": {
                "name": "Breakneck Pass",
                "level": 6,
                "coord": [
                  55081.7,
                  30536.1
                ],
                "bounds": [
                  [
                    54986.1,
                    30527.5
                  ],
                  [
                    54941.3,
                    30472.7
                  ],
                  [
                    54963.7,
                    30397.4
                  ],
                  [
                    55239.9,
                    30316.5
                  ],
                  [
                    55408.2,
                    30524.3
                  ],
                  [
                    55123.8,
                    30544.2
                  ],
                  [
                    55058,
                    30601.3
                  ],
                  [
                    55053.3,
                    30721
                  ],
                  [
                    54961.5,
                    30720.2
                  ],
                  [
                    54986.1,
                    30527.5
                  ]
                ],
                "id": 829,
                "chat_link": "[&BD0DAAA=]"
              }
            },
            "adventures": [],
            "id": 394,
            "mastery_points": []
          },
          "396": {
            "name": "Raven's Revered",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "203": {
                "name": "Doldenvan Passage",
                "level": 7,
                "coord": [
                  55792.9,
                  30825.7
                ],
                "bounds": [
                  [
                    55505.1,
                    30650.4
                  ],
                  [
                    55742.8,
                    30645.7
                  ],
                  [
                    55769.2,
                    30514.4
                  ],
                  [
                    55862.4,
                    30551.7
                  ],
                  [
                    55933.1,
                    30656.1
                  ],
                  [
                    56033,
                    30717.9
                  ],
                  [
                    56086.8,
                    31001.3
                  ],
                  [
                    55895.6,
                    31000.9
                  ],
                  [
                    55866.6,
                    31052.2
                  ],
                  [
                    55817.9,
                    31039.4
                  ],
                  [
                    55775.3,
                    30999
                  ],
                  [
                    55699.3,
                    31004.5
                  ],
                  [
                    55652.1,
                    30938.4
                  ],
                  [
                    55461.7,
                    30787.3
                  ],
                  [
                    55505.1,
                    30650.4
                  ]
                ],
                "id": 203,
                "chat_link": "[&BMsAAAA=]"
              },
              "204": {
                "name": "Darkriven Bluffs",
                "level": 7,
                "coord": [
                  55955.6,
                  30351.6
                ],
                "bounds": [
                  [
                    55880.8,
                    30268
                  ],
                  [
                    55860.3,
                    30127.2
                  ],
                  [
                    55742.2,
                    30062.1
                  ],
                  [
                    55656.6,
                    30067.7
                  ],
                  [
                    55613.4,
                    29949.7
                  ],
                  [
                    56125.5,
                    29962.5
                  ],
                  [
                    56333.6,
                    29933.5
                  ],
                  [
                    56391,
                    30454.1
                  ],
                  [
                    56306.6,
                    30827.8
                  ],
                  [
                    56056.2,
                    30817.2
                  ],
                  [
                    56025.5,
                    30713.1
                  ],
                  [
                    55930.1,
                    30656.3
                  ],
                  [
                    55859.5,
                    30552
                  ],
                  [
                    55767.9,
                    30517.6
                  ],
                  [
                    55785,
                    30365.6
                  ],
                  [
                    55880.8,
                    30268
                  ]
                ],
                "id": 204,
                "chat_link": "[&BMwAAAA=]"
              }
            },
            "adventures": [],
            "id": 396,
            "mastery_points": []
          },
          "397": {
            "name": "One Good Drink Deserves Another",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {
              "366": {
                "name": "Hermit's Watch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56134.4,
                  30135.7
                ],
                "id": 366,
                "chat_link": "[&BG4BAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "204": {
                "name": "Darkriven Bluffs",
                "level": 7,
                "coord": [
                  55955.6,
                  30351.6
                ],
                "bounds": [
                  [
                    55880.8,
                    30268
                  ],
                  [
                    55860.3,
                    30127.2
                  ],
                  [
                    55742.2,
                    30062.1
                  ],
                  [
                    55656.6,
                    30067.7
                  ],
                  [
                    55613.4,
                    29949.7
                  ],
                  [
                    56125.5,
                    29962.5
                  ],
                  [
                    56333.6,
                    29933.5
                  ],
                  [
                    56391,
                    30454.1
                  ],
                  [
                    56306.6,
                    30827.8
                  ],
                  [
                    56056.2,
                    30817.2
                  ],
                  [
                    56025.5,
                    30713.1
                  ],
                  [
                    55930.1,
                    30656.3
                  ],
                  [
                    55859.5,
                    30552
                  ],
                  [
                    55767.9,
                    30517.6
                  ],
                  [
                    55785,
                    30365.6
                  ],
                  [
                    55880.8,
                    30268
                  ]
                ],
                "id": 204,
                "chat_link": "[&BMwAAAA=]"
              }
            },
            "adventures": [],
            "id": 397,
            "mastery_points": []
          },
          "399": {
            "name": "Shape of the Spirit",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {
              "366": {
                "name": "Hermit's Watch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56134.4,
                  30135.7
                ],
                "id": 366,
                "chat_link": "[&BG4BAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "204": {
                "name": "Darkriven Bluffs",
                "level": 7,
                "coord": [
                  55955.6,
                  30351.6
                ],
                "bounds": [
                  [
                    55880.8,
                    30268
                  ],
                  [
                    55860.3,
                    30127.2
                  ],
                  [
                    55742.2,
                    30062.1
                  ],
                  [
                    55656.6,
                    30067.7
                  ],
                  [
                    55613.4,
                    29949.7
                  ],
                  [
                    56125.5,
                    29962.5
                  ],
                  [
                    56333.6,
                    29933.5
                  ],
                  [
                    56391,
                    30454.1
                  ],
                  [
                    56306.6,
                    30827.8
                  ],
                  [
                    56056.2,
                    30817.2
                  ],
                  [
                    56025.5,
                    30713.1
                  ],
                  [
                    55930.1,
                    30656.3
                  ],
                  [
                    55859.5,
                    30552
                  ],
                  [
                    55767.9,
                    30517.6
                  ],
                  [
                    55785,
                    30365.6
                  ],
                  [
                    55880.8,
                    30268
                  ]
                ],
                "id": 204,
                "chat_link": "[&BMwAAAA=]"
              }
            },
            "adventures": [],
            "id": 399,
            "mastery_points": []
          },
          "400": {
            "name": "Into the Mists",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "882": {
                "name": "Fang of the Serpent",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53427.9,
                  31108.1
                ],
                "id": 882,
                "chat_link": "[&BHIDAAA=]"
              },
              "952": {
                "name": "Knut Whitebear's Loft",
                "type": "landmark",
                "floor": 2,
                "coord": [
                  53416.1,
                  31136.5
                ],
                "id": 952,
                "chat_link": "[&BLgDAAA=]"
              },
              "1135": {
                "name": "Traveler's Loft",
                "type": "landmark",
                "floor": 2,
                "coord": [
                  53492.6,
                  31150.2
                ],
                "id": 1135,
                "chat_link": "[&BG8EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "798": {
                "name": "The Great Lodge",
                "level": 0,
                "coord": [
                  53465.6,
                  31103.7
                ],
                "bounds": [
                  [
                    53691,
                    31069.9
                  ],
                  [
                    53750.3,
                    31112.7
                  ],
                  [
                    53698.6,
                    31247.4
                  ],
                  [
                    53703.5,
                    31364.2
                  ],
                  [
                    53437.6,
                    31414.9
                  ],
                  [
                    53121.8,
                    31375.4
                  ],
                  [
                    53084.2,
                    31183.7
                  ],
                  [
                    53179,
                    30929.1
                  ],
                  [
                    53317.2,
                    30872.5
                  ],
                  [
                    53460.8,
                    30942.7
                  ],
                  [
                    53483.3,
                    30897.3
                  ],
                  [
                    53576.1,
                    30944.3
                  ],
                  [
                    53549.3,
                    30994.4
                  ],
                  [
                    53691,
                    31069.9
                  ]
                ],
                "id": 798,
                "chat_link": "[&BB4DAAA=]"
              }
            },
            "adventures": [],
            "id": 400,
            "mastery_points": []
          },
          "401": {
            "name": "Through the Veil",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "1135": {
                "name": "Traveler's Loft",
                "type": "landmark",
                "floor": 2,
                "coord": [
                  53492.6,
                  31150.2
                ],
                "id": 1135,
                "chat_link": "[&BG8EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "853": {
                "name": "Hunter's Hearth (Home)",
                "level": 0,
                "coord": [
                  53446.5,
                  31107.3
                ],
                "bounds": [
                  [
                    53747.5,
                    31112.5
                  ],
                  [
                    53697.1,
                    31246
                  ],
                  [
                    53704.7,
                    31372.6
                  ],
                  [
                    53430.8,
                    31414.6
                  ],
                  [
                    53129.1,
                    31372.2
                  ],
                  [
                    53085.1,
                    31181.8
                  ],
                  [
                    53179.3,
                    30930.9
                  ],
                  [
                    53316.9,
                    30873.7
                  ],
                  [
                    53460.4,
                    30944
                  ],
                  [
                    53482.9,
                    30898.5
                  ],
                  [
                    53575.8,
                    30945.6
                  ],
                  [
                    53548.9,
                    30995.7
                  ],
                  [
                    53747.5,
                    31112.5
                  ]
                ],
                "id": 853,
                "chat_link": "[&BFUDAAA=]"
              }
            },
            "id": 401,
            "mastery_points": [],
            "adventures": []
          },
          "405": {
            "name": "Blessed of Bear",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "201": {
                "name": "Snowlord's Gate",
                "level": 2,
                "coord": [
                  55057.6,
                  31036
                ],
                "bounds": [
                  [
                    55114.5,
                    31399.2
                  ],
                  [
                    55538.9,
                    31028.7
                  ],
                  [
                    55445,
                    30973.2
                  ],
                  [
                    55364.5,
                    30906.9
                  ],
                  [
                    55271.6,
                    30878.4
                  ],
                  [
                    55052.7,
                    30720.3
                  ],
                  [
                    54961.1,
                    30720.2
                  ],
                  [
                    54533,
                    30817.9
                  ],
                  [
                    54501.8,
                    31276.3
                  ],
                  [
                    54883.3,
                    31277.5
                  ],
                  [
                    54966.6,
                    31397.1
                  ],
                  [
                    55114.5,
                    31399.2
                  ]
                ],
                "id": 201,
                "chat_link": "[&BMkAAAA=]"
              },
              "829": {
                "name": "Breakneck Pass",
                "level": 6,
                "coord": [
                  55081.7,
                  30536.1
                ],
                "bounds": [
                  [
                    54986.1,
                    30527.5
                  ],
                  [
                    54941.3,
                    30472.7
                  ],
                  [
                    54963.7,
                    30397.4
                  ],
                  [
                    55239.9,
                    30316.5
                  ],
                  [
                    55408.2,
                    30524.3
                  ],
                  [
                    55123.8,
                    30544.2
                  ],
                  [
                    55058,
                    30601.3
                  ],
                  [
                    55053.3,
                    30721
                  ],
                  [
                    54961.5,
                    30720.2
                  ],
                  [
                    54986.1,
                    30527.5
                  ]
                ],
                "id": 829,
                "chat_link": "[&BD0DAAA=]"
              }
            },
            "adventures": [],
            "id": 405,
            "mastery_points": []
          },
          "407": {
            "name": "The Wolf Havroun",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "210": {
                "name": "Frusenfell Creek",
                "level": 10,
                "coord": [
                  56072.3,
                  29581.1
                ],
                "bounds": [
                  [
                    56166.5,
                    29192.1
                  ],
                  [
                    56308.2,
                    29206.8
                  ],
                  [
                    56405.2,
                    29353.3
                  ],
                  [
                    56272.8,
                    29953
                  ],
                  [
                    56131.8,
                    29967.6
                  ],
                  [
                    55885.4,
                    29952.3
                  ],
                  [
                    55869.5,
                    29734.2
                  ],
                  [
                    55760.4,
                    29562.8
                  ],
                  [
                    55851.2,
                    29307.7
                  ],
                  [
                    56166.5,
                    29192.1
                  ]
                ],
                "id": 210,
                "chat_link": "[&BNIAAAA=]"
              }
            },
            "adventures": [],
            "id": 407,
            "mastery_points": []
          },
          "410": {
            "name": "Minotaur Rampant",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "886": {
                "name": "Stonewright's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54015.6,
                  31159.6
                ],
                "id": 886,
                "chat_link": "[&BHYDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "805": {
                "name": "Frost Basin",
                "level": 0,
                "coord": [
                  54220.9,
                  31207.1
                ],
                "bounds": [
                  [
                    53878,
                    31116.3
                  ],
                  [
                    54211.6,
                    30928.4
                  ],
                  [
                    54549.9,
                    30961
                  ],
                  [
                    54551.5,
                    31357.6
                  ],
                  [
                    54329.2,
                    31369.1
                  ],
                  [
                    54144.6,
                    31355.4
                  ],
                  [
                    53881.3,
                    31362.3
                  ],
                  [
                    53878,
                    31116.3
                  ]
                ],
                "id": 805,
                "chat_link": "[&BCUDAAA=]"
              }
            },
            "adventures": [],
            "id": 410,
            "mastery_points": []
          },
          "411": {
            "name": "Minotaur Rampant",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {
              "984": {
                "name": "The Frozen Maw",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56131.1,
                  29001.7
                ],
                "id": 984,
                "chat_link": "[&BNgDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "211": {
                "name": "Hunter's Lake",
                "level": 11,
                "coord": [
                  56027.3,
                  28968
                ],
                "bounds": [
                  [
                    55530.8,
                    28840.6
                  ],
                  [
                    55739.3,
                    28708.9
                  ],
                  [
                    56015.5,
                    28728.1
                  ],
                  [
                    56303.8,
                    28676.6
                  ],
                  [
                    56368.2,
                    28741.2
                  ],
                  [
                    56462.3,
                    29073.9
                  ],
                  [
                    56309,
                    29209.9
                  ],
                  [
                    56166.6,
                    29196.4
                  ],
                  [
                    55850.5,
                    29308.4
                  ],
                  [
                    55526.7,
                    29196.2
                  ],
                  [
                    55530.8,
                    28840.6
                  ]
                ],
                "id": 211,
                "chat_link": "[&BNMAAAA=]"
              }
            },
            "adventures": [],
            "id": 411,
            "mastery_points": []
          },
          "412": {
            "name": "Unexpected Visitors",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "886": {
                "name": "Stonewright's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54015.6,
                  31159.6
                ],
                "id": 886,
                "chat_link": "[&BHYDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "805": {
                "name": "Frost Basin",
                "level": 0,
                "coord": [
                  54220.9,
                  31207.1
                ],
                "bounds": [
                  [
                    53878,
                    31116.3
                  ],
                  [
                    54211.6,
                    30928.4
                  ],
                  [
                    54549.9,
                    30961
                  ],
                  [
                    54551.5,
                    31357.6
                  ],
                  [
                    54329.2,
                    31369.1
                  ],
                  [
                    54144.6,
                    31355.4
                  ],
                  [
                    53881.3,
                    31362.3
                  ],
                  [
                    53878,
                    31116.3
                  ]
                ],
                "id": 805,
                "chat_link": "[&BCUDAAA=]"
              }
            },
            "adventures": [],
            "id": 412,
            "mastery_points": []
          },
          "413": {
            "name": "Rumors of Trouble",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "886": {
                "name": "Stonewright's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54015.6,
                  31159.6
                ],
                "id": 886,
                "chat_link": "[&BHYDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "805": {
                "name": "Frost Basin",
                "level": 0,
                "coord": [
                  54220.9,
                  31207.1
                ],
                "bounds": [
                  [
                    53878,
                    31116.3
                  ],
                  [
                    54211.6,
                    30928.4
                  ],
                  [
                    54549.9,
                    30961
                  ],
                  [
                    54551.5,
                    31357.6
                  ],
                  [
                    54329.2,
                    31369.1
                  ],
                  [
                    54144.6,
                    31355.4
                  ],
                  [
                    53881.3,
                    31362.3
                  ],
                  [
                    53878,
                    31116.3
                  ]
                ],
                "id": 805,
                "chat_link": "[&BCUDAAA=]"
              }
            },
            "adventures": [],
            "id": 413,
            "mastery_points": []
          },
          "414": {
            "name": "A New Challenger",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "886": {
                "name": "Stonewright's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54015.6,
                  31159.6
                ],
                "id": 886,
                "chat_link": "[&BHYDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "805": {
                "name": "Frost Basin",
                "level": 0,
                "coord": [
                  54220.9,
                  31207.1
                ],
                "bounds": [
                  [
                    53878,
                    31116.3
                  ],
                  [
                    54211.6,
                    30928.4
                  ],
                  [
                    54549.9,
                    30961
                  ],
                  [
                    54551.5,
                    31357.6
                  ],
                  [
                    54329.2,
                    31369.1
                  ],
                  [
                    54144.6,
                    31355.4
                  ],
                  [
                    53881.3,
                    31362.3
                  ],
                  [
                    53878,
                    31116.3
                  ]
                ],
                "id": 805,
                "chat_link": "[&BCUDAAA=]"
              }
            },
            "adventures": [],
            "id": 414,
            "mastery_points": []
          },
          "415": {
            "name": "Unexpected Visitors",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "205": {
                "name": "Taigan Groves",
                "level": 7,
                "coord": [
                  55579,
                  30296.2
                ],
                "bounds": [
                  [
                    55239.7,
                    30317.3
                  ],
                  [
                    55174.7,
                    30189.8
                  ],
                  [
                    55307,
                    30205.3
                  ],
                  [
                    55656.8,
                    30068.6
                  ],
                  [
                    55744.6,
                    30060.7
                  ],
                  [
                    55864.3,
                    30127.9
                  ],
                  [
                    55880.8,
                    30268
                  ],
                  [
                    55787.7,
                    30365
                  ],
                  [
                    55742.3,
                    30647
                  ],
                  [
                    55562.3,
                    30484.1
                  ],
                  [
                    55408.7,
                    30524.3
                  ],
                  [
                    55239.7,
                    30317.3
                  ]
                ],
                "id": 205,
                "chat_link": "[&BM0AAAA=]"
              },
              "206": {
                "name": "Icevine Dale",
                "level": 7,
                "coord": [
                  55247.7,
                  29919.5
                ],
                "bounds": [
                  [
                    55309.7,
                    30208.8
                  ],
                  [
                    55658.8,
                    30070.7
                  ],
                  [
                    55598.8,
                    29852
                  ],
                  [
                    55412.4,
                    29841.5
                  ],
                  [
                    55308.6,
                    29697.2
                  ],
                  [
                    54989,
                    29681.1
                  ],
                  [
                    54985.2,
                    29781.4
                  ],
                  [
                    54914.2,
                    29967.1
                  ],
                  [
                    55052.2,
                    30175.8
                  ],
                  [
                    55309.7,
                    30208.8
                  ]
                ],
                "id": 206,
                "chat_link": "[&BM4AAAA=]"
              }
            },
            "adventures": [],
            "id": 415,
            "mastery_points": []
          },
          "416": {
            "name": "Roadblock",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              58048,
              28760
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                27648
              ]
            ],
            "continent_rect": [
              [
                56320,
                27648
              ],
              [
                59904,
                29952
              ]
            ],
            "points_of_interest": {
              "1033": {
                "name": "Butcher's Yard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56720.2,
                  28358.5
                ],
                "id": 1033,
                "chat_link": "[&BAkEAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "30": {
                "name": "Gram Hills",
                "level": 18,
                "coord": [
                  57195.9,
                  28073.9
                ],
                "bounds": [
                  [
                    57090.8,
                    28330.7
                  ],
                  [
                    57192.7,
                    28434.8
                  ],
                  [
                    57587.9,
                    28121.2
                  ],
                  [
                    57478.8,
                    27938.3
                  ],
                  [
                    57333.4,
                    27687.1
                  ],
                  [
                    57219.4,
                    27649.5
                  ],
                  [
                    57139.8,
                    28012.8
                  ],
                  [
                    56810.9,
                    28168.5
                  ],
                  [
                    56909.3,
                    28322.2
                  ],
                  [
                    57090.8,
                    28330.7
                  ]
                ],
                "id": 30,
                "chat_link": "[&BB4AAAA=]"
              },
              "41": {
                "name": "Halrunting Plains",
                "level": 16,
                "coord": [
                  56651.4,
                  28511.7
                ],
                "bounds": [
                  [
                    56304.4,
                    28620.7
                  ],
                  [
                    56655.9,
                    28569.2
                  ],
                  [
                    56745,
                    28658.5
                  ],
                  [
                    56666,
                    28866.4
                  ],
                  [
                    56759.4,
                    29036.2
                  ],
                  [
                    56987,
                    28759.3
                  ],
                  [
                    56852,
                    28566.3
                  ],
                  [
                    56844.5,
                    28486.7
                  ],
                  [
                    56909.3,
                    28320.4
                  ],
                  [
                    56811.6,
                    28167.8
                  ],
                  [
                    56579,
                    28210
                  ],
                  [
                    56462.5,
                    28227.3
                  ],
                  [
                    56304.9,
                    28265.9
                  ],
                  [
                    56238.8,
                    28408.6
                  ],
                  [
                    56304.4,
                    28620.7
                  ]
                ],
                "id": 41,
                "chat_link": "[&BCkAAAA=]"
              }
            },
            "adventures": [],
            "id": 416,
            "mastery_points": []
          },
          "417": {
            "name": "Assault on Moledavia",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              58048,
              28760
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                27648
              ]
            ],
            "continent_rect": [
              [
                56320,
                27648
              ],
              [
                59904,
                29952
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "23": {
                "name": "Burrows of Moledavia",
                "level": 17,
                "coord": [
                  56617.2,
                  27877
                ],
                "bounds": [
                  [
                    56462,
                    28229.1
                  ],
                  [
                    56811.3,
                    28168.3
                  ],
                  [
                    57140.4,
                    28013.6
                  ],
                  [
                    57219.2,
                    27648.9
                  ],
                  [
                    57082.5,
                    27638.7
                  ],
                  [
                    56823.9,
                    27526
                  ],
                  [
                    56564.9,
                    27537.5
                  ],
                  [
                    56300.6,
                    27643.9
                  ],
                  [
                    56226.7,
                    27789.4
                  ],
                  [
                    56201.5,
                    27950.5
                  ],
                  [
                    56239.4,
                    28114.3
                  ],
                  [
                    56334.3,
                    28263.3
                  ],
                  [
                    56462,
                    28229.1
                  ]
                ],
                "id": 23,
                "chat_link": "[&BBcAAAA=]"
              },
              "30": {
                "name": "Gram Hills",
                "level": 18,
                "coord": [
                  57195.9,
                  28073.9
                ],
                "bounds": [
                  [
                    57090.8,
                    28330.7
                  ],
                  [
                    57192.7,
                    28434.8
                  ],
                  [
                    57587.9,
                    28121.2
                  ],
                  [
                    57478.8,
                    27938.3
                  ],
                  [
                    57333.4,
                    27687.1
                  ],
                  [
                    57219.4,
                    27649.5
                  ],
                  [
                    57139.8,
                    28012.8
                  ],
                  [
                    56810.9,
                    28168.5
                  ],
                  [
                    56909.3,
                    28322.2
                  ],
                  [
                    57090.8,
                    28330.7
                  ]
                ],
                "id": 30,
                "chat_link": "[&BB4AAAA=]"
              },
              "41": {
                "name": "Halrunting Plains",
                "level": 16,
                "coord": [
                  56651.4,
                  28511.7
                ],
                "bounds": [
                  [
                    56304.4,
                    28620.7
                  ],
                  [
                    56655.9,
                    28569.2
                  ],
                  [
                    56745,
                    28658.5
                  ],
                  [
                    56666,
                    28866.4
                  ],
                  [
                    56759.4,
                    29036.2
                  ],
                  [
                    56987,
                    28759.3
                  ],
                  [
                    56852,
                    28566.3
                  ],
                  [
                    56844.5,
                    28486.7
                  ],
                  [
                    56909.3,
                    28320.4
                  ],
                  [
                    56811.6,
                    28167.8
                  ],
                  [
                    56579,
                    28210
                  ],
                  [
                    56462.5,
                    28227.3
                  ],
                  [
                    56304.9,
                    28265.9
                  ],
                  [
                    56238.8,
                    28408.6
                  ],
                  [
                    56304.4,
                    28620.7
                  ]
                ],
                "id": 41,
                "chat_link": "[&BCkAAAA=]"
              }
            },
            "adventures": [],
            "id": 417,
            "mastery_points": []
          },
          "418": {
            "name": "Don't Leave Your Toys Out",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "213": {
                "name": "Halvaunt Snowfield",
                "level": 13,
                "coord": [
                  55021.5,
                  28813.7
                ],
                "bounds": [
                  [
                    54818.6,
                    28978.2
                  ],
                  [
                    54596.2,
                    29018.3
                  ],
                  [
                    54512.3,
                    28621.4
                  ],
                  [
                    54595.9,
                    28486
                  ],
                  [
                    54970,
                    28441.6
                  ],
                  [
                    55114.2,
                    28368.8
                  ],
                  [
                    55465.7,
                    28412.2
                  ],
                  [
                    55411.3,
                    28768.4
                  ],
                  [
                    55231.8,
                    28790.3
                  ],
                  [
                    55255.6,
                    28924.1
                  ],
                  [
                    55446.7,
                    29219.4
                  ],
                  [
                    54943.3,
                    29366.4
                  ],
                  [
                    54918.3,
                    29182.6
                  ],
                  [
                    54818.6,
                    28978.2
                  ]
                ],
                "id": 213,
                "chat_link": "[&BNUAAAA=]"
              }
            },
            "adventures": [],
            "id": 418,
            "mastery_points": []
          },
          "419": {
            "name": "A New Challenger",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {
              "368": {
                "name": "Edenvar's Homestead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55177.4,
                  29147.3
                ],
                "id": 368,
                "chat_link": "[&BHABAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "213": {
                "name": "Halvaunt Snowfield",
                "level": 13,
                "coord": [
                  55021.5,
                  28813.7
                ],
                "bounds": [
                  [
                    54818.6,
                    28978.2
                  ],
                  [
                    54596.2,
                    29018.3
                  ],
                  [
                    54512.3,
                    28621.4
                  ],
                  [
                    54595.9,
                    28486
                  ],
                  [
                    54970,
                    28441.6
                  ],
                  [
                    55114.2,
                    28368.8
                  ],
                  [
                    55465.7,
                    28412.2
                  ],
                  [
                    55411.3,
                    28768.4
                  ],
                  [
                    55231.8,
                    28790.3
                  ],
                  [
                    55255.6,
                    28924.1
                  ],
                  [
                    55446.7,
                    29219.4
                  ],
                  [
                    54943.3,
                    29366.4
                  ],
                  [
                    54918.3,
                    29182.6
                  ],
                  [
                    54818.6,
                    28978.2
                  ]
                ],
                "id": 213,
                "chat_link": "[&BNUAAAA=]"
              }
            },
            "adventures": [],
            "id": 419,
            "mastery_points": []
          },
          "420": {
            "name": "First Attack",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {
              "975": {
                "name": "Dragonblest Hold",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55459.8,
                  27996.1
                ],
                "id": 975,
                "chat_link": "[&BM8DAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "215": {
                "name": "Svanir's Dome",
                "level": 15,
                "coord": [
                  55287.5,
                  27907.9
                ],
                "bounds": [
                  [
                    55054.4,
                    27665.6
                  ],
                  [
                    55148.2,
                    27597.2
                  ],
                  [
                    55370,
                    27614
                  ],
                  [
                    55433.3,
                    27684.6
                  ],
                  [
                    55539.1,
                    27920.6
                  ],
                  [
                    55626.8,
                    28441.6
                  ],
                  [
                    55108.3,
                    28372.1
                  ],
                  [
                    55019.9,
                    27967.8
                  ],
                  [
                    55054.4,
                    27665.6
                  ]
                ],
                "id": 215,
                "chat_link": "[&BNcAAAA=]"
              },
              "217": {
                "name": "Solitude Vale",
                "level": 15,
                "coord": [
                  55772.3,
                  27876.7
                ],
                "bounds": [
                  [
                    55536.3,
                    27920.9
                  ],
                  [
                    55623.6,
                    28455.1
                  ],
                  [
                    55827.4,
                    28260.3
                  ],
                  [
                    55977.8,
                    28244
                  ],
                  [
                    55995.9,
                    28009.5
                  ],
                  [
                    55920,
                    27655.8
                  ],
                  [
                    55920.4,
                    27654.9
                  ],
                  [
                    55863.2,
                    27557.7
                  ],
                  [
                    55753.7,
                    27546.4
                  ],
                  [
                    55648,
                    27649.9
                  ],
                  [
                    55429.2,
                    27688.8
                  ],
                  [
                    55536.3,
                    27920.9
                  ]
                ],
                "id": 217,
                "chat_link": "[&BNkAAAA=]"
              }
            },
            "adventures": [],
            "id": 420,
            "mastery_points": []
          },
          "421": {
            "name": "The Finishing Blow",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {
              "1032": {
                "name": "Warmspring Grotto",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56115.3,
                  27939.2
                ],
                "id": 1032,
                "chat_link": "[&BAgEAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "217": {
                "name": "Solitude Vale",
                "level": 15,
                "coord": [
                  55772.3,
                  27876.7
                ],
                "bounds": [
                  [
                    55536.3,
                    27920.9
                  ],
                  [
                    55623.6,
                    28455.1
                  ],
                  [
                    55827.4,
                    28260.3
                  ],
                  [
                    55977.8,
                    28244
                  ],
                  [
                    55995.9,
                    28009.5
                  ],
                  [
                    55920,
                    27655.8
                  ],
                  [
                    55920.4,
                    27654.9
                  ],
                  [
                    55863.2,
                    27557.7
                  ],
                  [
                    55753.7,
                    27546.4
                  ],
                  [
                    55648,
                    27649.9
                  ],
                  [
                    55429.2,
                    27688.8
                  ],
                  [
                    55536.3,
                    27920.9
                  ]
                ],
                "id": 217,
                "chat_link": "[&BNkAAAA=]"
              }
            },
            "adventures": [],
            "id": 421,
            "mastery_points": []
          },
          "422": {
            "name": "The Semifinals",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              58048,
              28760
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                27648
              ]
            ],
            "continent_rect": [
              [
                56320,
                27648
              ],
              [
                59904,
                29952
              ]
            ],
            "points_of_interest": {
              "1033": {
                "name": "Butcher's Yard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56720.2,
                  28358.5
                ],
                "id": 1033,
                "chat_link": "[&BAkEAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "41": {
                "name": "Halrunting Plains",
                "level": 16,
                "coord": [
                  56651.4,
                  28511.7
                ],
                "bounds": [
                  [
                    56304.4,
                    28620.7
                  ],
                  [
                    56655.9,
                    28569.2
                  ],
                  [
                    56745,
                    28658.5
                  ],
                  [
                    56666,
                    28866.4
                  ],
                  [
                    56759.4,
                    29036.2
                  ],
                  [
                    56987,
                    28759.3
                  ],
                  [
                    56852,
                    28566.3
                  ],
                  [
                    56844.5,
                    28486.7
                  ],
                  [
                    56909.3,
                    28320.4
                  ],
                  [
                    56811.6,
                    28167.8
                  ],
                  [
                    56579,
                    28210
                  ],
                  [
                    56462.5,
                    28227.3
                  ],
                  [
                    56304.9,
                    28265.9
                  ],
                  [
                    56238.8,
                    28408.6
                  ],
                  [
                    56304.4,
                    28620.7
                  ]
                ],
                "id": 41,
                "chat_link": "[&BCkAAAA=]"
              }
            },
            "adventures": [],
            "id": 422,
            "mastery_points": []
          },
          "423": {
            "name": "The Championship Fight",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "886": {
                "name": "Stonewright's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54015.6,
                  31159.6
                ],
                "id": 886,
                "chat_link": "[&BHYDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "805": {
                "name": "Frost Basin",
                "level": 0,
                "coord": [
                  54220.9,
                  31207.1
                ],
                "bounds": [
                  [
                    53878,
                    31116.3
                  ],
                  [
                    54211.6,
                    30928.4
                  ],
                  [
                    54549.9,
                    30961
                  ],
                  [
                    54551.5,
                    31357.6
                  ],
                  [
                    54329.2,
                    31369.1
                  ],
                  [
                    54144.6,
                    31355.4
                  ],
                  [
                    53881.3,
                    31362.3
                  ],
                  [
                    53878,
                    31116.3
                  ]
                ],
                "id": 805,
                "chat_link": "[&BCUDAAA=]"
              }
            },
            "adventures": [],
            "id": 423,
            "mastery_points": []
          },
          "424": {
            "name": "The Championship Fight",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "881": {
                "name": "Courage Brewery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53009.3,
                  30196.3
                ],
                "id": 881,
                "chat_link": "[&BHEDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "794": {
                "name": "Biergarten",
                "level": 0,
                "coord": [
                  52885.1,
                  29973.1
                ],
                "bounds": [
                  [
                    52954.8,
                    30266.8
                  ],
                  [
                    52823.2,
                    30029.2
                  ],
                  [
                    52550.5,
                    29746.8
                  ],
                  [
                    52749.6,
                    29664.4
                  ],
                  [
                    52965,
                    29722.3
                  ],
                  [
                    53101.3,
                    30146.4
                  ],
                  [
                    53051.2,
                    30235.8
                  ],
                  [
                    52954.8,
                    30266.8
                  ]
                ],
                "id": 794,
                "chat_link": "[&BBoDAAA=]"
              },
              "799": {
                "name": "Lake Mourn",
                "level": 0,
                "coord": [
                  52746.6,
                  30556.8
                ],
                "bounds": [
                  [
                    52825.3,
                    30025
                  ],
                  [
                    52957,
                    30262.5
                  ],
                  [
                    52986.9,
                    30257.1
                  ],
                  [
                    53026.8,
                    30324.9
                  ],
                  [
                    53003.8,
                    30353.8
                  ],
                  [
                    52951.8,
                    30526.7
                  ],
                  [
                    53134,
                    30558.6
                  ],
                  [
                    53168.1,
                    30540.1
                  ],
                  [
                    53180.2,
                    30817.5
                  ],
                  [
                    53183.7,
                    30931
                  ],
                  [
                    53088.9,
                    31179.1
                  ],
                  [
                    53122.6,
                    31361.8
                  ],
                  [
                    52895.6,
                    31373.6
                  ],
                  [
                    52599.8,
                    31381.4
                  ],
                  [
                    52370.6,
                    31304.6
                  ],
                  [
                    52205.1,
                    31122.9
                  ],
                  [
                    52143.3,
                    30810.2
                  ],
                  [
                    52149.5,
                    30123.1
                  ],
                  [
                    52199,
                    29885.4
                  ],
                  [
                    52262.2,
                    29700.7
                  ],
                  [
                    52417.5,
                    29665.4
                  ],
                  [
                    52552.8,
                    29745
                  ],
                  [
                    52825.3,
                    30025
                  ]
                ],
                "id": 799,
                "chat_link": "[&BB8DAAA=]"
              }
            },
            "adventures": [],
            "id": 424,
            "mastery_points": []
          },
          "425": {
            "name": "The Machine in Action",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              58048,
              28760
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                27648
              ]
            ],
            "continent_rect": [
              [
                56320,
                27648
              ],
              [
                59904,
                29952
              ]
            ],
            "points_of_interest": {
              "273": {
                "name": "Grendich Ruins",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57689,
                  28424.4
                ],
                "id": 273,
                "chat_link": "[&BBEBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "17": {
                "name": "The Blasted Moors",
                "level": 19,
                "coord": [
                  57863.6,
                  28720.1
                ],
                "bounds": [
                  [
                    57775.8,
                    28987.3
                  ],
                  [
                    57999.8,
                    29050.8
                  ],
                  [
                    58121.8,
                    28970.7
                  ],
                  [
                    58031.1,
                    28532.5
                  ],
                  [
                    57688.9,
                    28333.8
                  ],
                  [
                    57564.5,
                    28445.6
                  ],
                  [
                    57775.8,
                    28987.3
                  ]
                ],
                "id": 17,
                "chat_link": "[&BBEAAAA=]"
              },
              "627": {
                "name": "Manbane's Outcrop",
                "level": 20,
                "coord": [
                  58011.7,
                  28279.6
                ],
                "bounds": [
                  [
                    57690.8,
                    28335
                  ],
                  [
                    58031.3,
                    28531.9
                  ],
                  [
                    58062,
                    28412.1
                  ],
                  [
                    58358.6,
                    28229.5
                  ],
                  [
                    58476,
                    28234.3
                  ],
                  [
                    58445.5,
                    28049.1
                  ],
                  [
                    57897.1,
                    28161.2
                  ],
                  [
                    57583.6,
                    28118.1
                  ],
                  [
                    57560.7,
                    28445.4
                  ],
                  [
                    57690.8,
                    28335
                  ]
                ],
                "id": 627,
                "chat_link": "[&BHMCAAA=]"
              }
            },
            "adventures": [],
            "id": 425,
            "mastery_points": []
          },
          "427": {
            "name": "Among the Kodan",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              52480,
              28672
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                50432,
                27648
              ],
              [
                54528,
                29696
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "235": {
                "name": "Tromigar Valley",
                "level": 16,
                "coord": [
                  53857.4,
                  28354.8
                ],
                "bounds": [
                  [
                    53223.5,
                    28540.5
                  ],
                  [
                    53502.7,
                    28777.5
                  ],
                  [
                    53731.9,
                    28686.5
                  ],
                  [
                    54221.6,
                    28613.8
                  ],
                  [
                    54347.1,
                    28374
                  ],
                  [
                    54174.5,
                    28332.3
                  ],
                  [
                    54192.2,
                    28198.6
                  ],
                  [
                    54103.2,
                    28008.7
                  ],
                  [
                    53942.8,
                    27993.1
                  ],
                  [
                    53755.8,
                    28101
                  ],
                  [
                    53235.7,
                    28277
                  ],
                  [
                    53223.5,
                    28540.5
                  ]
                ],
                "id": 235,
                "chat_link": "[&BOsAAAA=]"
              },
              "241": {
                "name": "Hunter's Pitfalls",
                "level": 15,
                "coord": [
                  54406.9,
                  28026.6
                ],
                "bounds": [
                  [
                    54102.5,
                    28007.9
                  ],
                  [
                    54189.7,
                    28199.2
                  ],
                  [
                    54169.1,
                    28336.2
                  ],
                  [
                    54348.5,
                    28378.4
                  ],
                  [
                    54426.1,
                    28230.8
                  ],
                  [
                    54516.1,
                    28249.2
                  ],
                  [
                    54562.2,
                    28063.3
                  ],
                  [
                    54647.6,
                    27983.4
                  ],
                  [
                    54650,
                    27857.8
                  ],
                  [
                    54567.7,
                    27772.9
                  ],
                  [
                    54543.9,
                    27589.7
                  ],
                  [
                    54159.4,
                    27650.3
                  ],
                  [
                    54102.5,
                    28007.9
                  ]
                ],
                "id": 241,
                "chat_link": "[&BPEAAAA=]"
              },
              "242": {
                "name": "Trapper's Labyrinth",
                "level": 16,
                "coord": [
                  53848.1,
                  27821.1
                ],
                "bounds": [
                  [
                    53760.4,
                    28107.7
                  ],
                  [
                    53608.6,
                    27881.3
                  ],
                  [
                    53620.9,
                    27630.3
                  ],
                  [
                    53721.9,
                    27648
                  ],
                  [
                    53869.9,
                    27648
                  ],
                  [
                    54158.6,
                    27648.9
                  ],
                  [
                    54103.4,
                    28008.4
                  ],
                  [
                    53941,
                    27996.1
                  ],
                  [
                    53760.4,
                    28107.7
                  ]
                ],
                "id": 242,
                "chat_link": "[&BPIAAAA=]"
              }
            },
            "adventures": [],
            "id": 427,
            "mastery_points": []
          },
          "428": {
            "name": "Rumors of Trouble",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "211": {
                "name": "Hunter's Lake",
                "level": 11,
                "coord": [
                  56027.3,
                  28968
                ],
                "bounds": [
                  [
                    55530.8,
                    28840.6
                  ],
                  [
                    55739.3,
                    28708.9
                  ],
                  [
                    56015.5,
                    28728.1
                  ],
                  [
                    56303.8,
                    28676.6
                  ],
                  [
                    56368.2,
                    28741.2
                  ],
                  [
                    56462.3,
                    29073.9
                  ],
                  [
                    56309,
                    29209.9
                  ],
                  [
                    56166.6,
                    29196.4
                  ],
                  [
                    55850.5,
                    29308.4
                  ],
                  [
                    55526.7,
                    29196.2
                  ],
                  [
                    55530.8,
                    28840.6
                  ]
                ],
                "id": 211,
                "chat_link": "[&BNMAAAA=]"
              }
            },
            "adventures": [],
            "id": 428,
            "mastery_points": []
          },
          "429": {
            "name": "Rage of the Minotaurs",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "886": {
                "name": "Stonewright's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54015.6,
                  31159.6
                ],
                "id": 886,
                "chat_link": "[&BHYDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "805": {
                "name": "Frost Basin",
                "level": 0,
                "coord": [
                  54220.9,
                  31207.1
                ],
                "bounds": [
                  [
                    53878,
                    31116.3
                  ],
                  [
                    54211.6,
                    30928.4
                  ],
                  [
                    54549.9,
                    30961
                  ],
                  [
                    54551.5,
                    31357.6
                  ],
                  [
                    54329.2,
                    31369.1
                  ],
                  [
                    54144.6,
                    31355.4
                  ],
                  [
                    53881.3,
                    31362.3
                  ],
                  [
                    53878,
                    31116.3
                  ]
                ],
                "id": 805,
                "chat_link": "[&BCUDAAA=]"
              }
            },
            "adventures": [],
            "id": 429,
            "mastery_points": []
          },
          "430": {
            "name": "Darkness at Drakentelt",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              52480,
              28672
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                50432,
                27648
              ],
              [
                54528,
                29696
              ]
            ],
            "points_of_interest": {
              "142": {
                "name": "Drakentelt",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54281.9,
                  28735.8
                ],
                "id": 142,
                "chat_link": "[&BI4AAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "240": {
                "name": "Villmark Foothills",
                "level": 17,
                "coord": [
                  54043,
                  28764.2
                ],
                "bounds": [
                  [
                    54216.1,
                    28608.4
                  ],
                  [
                    54322.1,
                    28765.2
                  ],
                  [
                    54158.2,
                    28947.5
                  ],
                  [
                    53798.2,
                    28815.9
                  ],
                  [
                    53720.7,
                    28684.2
                  ],
                  [
                    54216.1,
                    28608.4
                  ]
                ],
                "id": 240,
                "chat_link": "[&BPAAAAA=]"
              }
            },
            "adventures": [],
            "id": 430,
            "mastery_points": []
          },
          "434": {
            "name": "Preserving the Balance",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              52480,
              28672
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                50432,
                27648
              ],
              [
                54528,
                29696
              ]
            ],
            "points_of_interest": {
              "145": {
                "name": "Tala Point",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52946.8,
                  29327.9
                ],
                "id": 145,
                "chat_link": "[&BJEAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "236": {
                "name": "Song of Final Exile",
                "level": 20,
                "coord": [
                  53053.8,
                  29466.9
                ],
                "bounds": [
                  [
                    53166.5,
                    29202.5
                  ],
                  [
                    53343.4,
                    29256
                  ],
                  [
                    53188.9,
                    29562.9
                  ],
                  [
                    53242.6,
                    29819.5
                  ],
                  [
                    52759.6,
                    29689.7
                  ],
                  [
                    52756.3,
                    29447.7
                  ],
                  [
                    52919.3,
                    29289.7
                  ],
                  [
                    53166.5,
                    29202.5
                  ]
                ],
                "id": 236,
                "chat_link": "[&BOwAAAA=]"
              }
            },
            "adventures": [],
            "id": 434,
            "mastery_points": []
          },
          "435": {
            "name": "Means to an End",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 435,
            "mastery_points": []
          },
          "436": {
            "name": "Dredge Technology",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "886": {
                "name": "Stonewright's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54015.6,
                  31159.6
                ],
                "id": 886,
                "chat_link": "[&BHYDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "805": {
                "name": "Frost Basin",
                "level": 0,
                "coord": [
                  54220.9,
                  31207.1
                ],
                "bounds": [
                  [
                    53878,
                    31116.3
                  ],
                  [
                    54211.6,
                    30928.4
                  ],
                  [
                    54549.9,
                    30961
                  ],
                  [
                    54551.5,
                    31357.6
                  ],
                  [
                    54329.2,
                    31369.1
                  ],
                  [
                    54144.6,
                    31355.4
                  ],
                  [
                    53881.3,
                    31362.3
                  ],
                  [
                    53878,
                    31116.3
                  ]
                ],
                "id": 805,
                "chat_link": "[&BCUDAAA=]"
              }
            },
            "adventures": [],
            "id": 436,
            "mastery_points": []
          },
          "439": {
            "name": "Underground Scholar",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              52480,
              28672
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                50432,
                27648
              ],
              [
                54528,
                29696
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "340": {
                "name": "Ossencrest Climb",
                "level": 24,
                "coord": [
                  50616.3,
                  28310.2
                ],
                "bounds": [
                  [
                    50831.9,
                    28081.4
                  ],
                  [
                    50863.9,
                    28360.4
                  ],
                  [
                    50975.1,
                    28448.4
                  ],
                  [
                    50815,
                    28662.7
                  ],
                  [
                    50437.8,
                    28689.8
                  ],
                  [
                    50391,
                    28581.7
                  ],
                  [
                    50345,
                    28432.8
                  ],
                  [
                    50563.5,
                    28307.7
                  ],
                  [
                    50592,
                    28226.8
                  ],
                  [
                    50502.6,
                    28169
                  ],
                  [
                    50437.7,
                    28069.6
                  ],
                  [
                    50536.8,
                    27993.4
                  ],
                  [
                    50719.1,
                    28009.4
                  ],
                  [
                    50831.9,
                    28081.4
                  ]
                ],
                "id": 340,
                "chat_link": "[&BFQBAAA=]"
              }
            },
            "adventures": [],
            "id": 439,
            "mastery_points": []
          },
          "440": {
            "name": "Dredge Assault",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              52480,
              28672
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                50432,
                27648
              ],
              [
                54528,
                29696
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "221": {
                "name": "Molengrad",
                "level": 24,
                "coord": [
                  51212.2,
                  29527.5
                ],
                "bounds": [
                  [
                    51017.4,
                    29696
                  ],
                  [
                    50957.3,
                    29414.6
                  ],
                  [
                    51149.3,
                    29300.3
                  ],
                  [
                    51315.9,
                    29302
                  ],
                  [
                    51533.1,
                    29679.1
                  ],
                  [
                    51300.2,
                    29772.9
                  ],
                  [
                    51017.4,
                    29696
                  ]
                ],
                "id": 221,
                "chat_link": "[&BN0AAAA=]"
              }
            },
            "adventures": [],
            "id": 440,
            "mastery_points": []
          },
          "441": {
            "name": "The Dredge Hideout",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              52480,
              28672
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                50432,
                27648
              ],
              [
                54528,
                29696
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "221": {
                "name": "Molengrad",
                "level": 24,
                "coord": [
                  51212.2,
                  29527.5
                ],
                "bounds": [
                  [
                    51017.4,
                    29696
                  ],
                  [
                    50957.3,
                    29414.6
                  ],
                  [
                    51149.3,
                    29300.3
                  ],
                  [
                    51315.9,
                    29302
                  ],
                  [
                    51533.1,
                    29679.1
                  ],
                  [
                    51300.2,
                    29772.9
                  ],
                  [
                    51017.4,
                    29696
                  ]
                ],
                "id": 221,
                "chat_link": "[&BN0AAAA=]"
              }
            },
            "adventures": [],
            "id": 441,
            "mastery_points": []
          },
          "444": {
            "name": "Sabotage",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "335": {
                "name": "The Thunderhorns",
                "level": 27,
                "coord": [
                  51640.2,
                  30024.5
                ],
                "bounds": [
                  [
                    51745.2,
                    30521
                  ],
                  [
                    51311.8,
                    30622.5
                  ],
                  [
                    51261.8,
                    30389.6
                  ],
                  [
                    51396.2,
                    30081.8
                  ],
                  [
                    51337.3,
                    29604.3
                  ],
                  [
                    51728,
                    29689.3
                  ],
                  [
                    51851.9,
                    29646.5
                  ],
                  [
                    51967.2,
                    29663.4
                  ],
                  [
                    51840.4,
                    29860.8
                  ],
                  [
                    51962,
                    30166
                  ],
                  [
                    51745.2,
                    30521
                  ]
                ],
                "id": 335,
                "chat_link": "[&BE8BAAA=]"
              },
              "336": {
                "name": "Underburg",
                "level": 26,
                "coord": [
                  52104.1,
                  29908.4
                ],
                "bounds": [
                  [
                    51962.2,
                    30164.8
                  ],
                  [
                    52074.8,
                    30155.4
                  ],
                  [
                    52222.1,
                    30151.7
                  ],
                  [
                    52286.6,
                    30048.9
                  ],
                  [
                    52301.7,
                    29891.9
                  ],
                  [
                    52253.6,
                    29762.5
                  ],
                  [
                    52129.5,
                    29677
                  ],
                  [
                    52025.8,
                    29676.8
                  ],
                  [
                    51945.2,
                    29694.3
                  ],
                  [
                    51839.7,
                    29860.3
                  ],
                  [
                    51962.2,
                    30164.8
                  ]
                ],
                "id": 336,
                "chat_link": "[&BFABAAA=]"
              }
            },
            "adventures": [],
            "id": 444,
            "mastery_points": []
          },
          "447": {
            "name": "Codebreaker",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "335": {
                "name": "The Thunderhorns",
                "level": 27,
                "coord": [
                  51640.2,
                  30024.5
                ],
                "bounds": [
                  [
                    51745.2,
                    30521
                  ],
                  [
                    51311.8,
                    30622.5
                  ],
                  [
                    51261.8,
                    30389.6
                  ],
                  [
                    51396.2,
                    30081.8
                  ],
                  [
                    51337.3,
                    29604.3
                  ],
                  [
                    51728,
                    29689.3
                  ],
                  [
                    51851.9,
                    29646.5
                  ],
                  [
                    51967.2,
                    29663.4
                  ],
                  [
                    51840.4,
                    29860.8
                  ],
                  [
                    51962,
                    30166
                  ],
                  [
                    51745.2,
                    30521
                  ]
                ],
                "id": 335,
                "chat_link": "[&BE8BAAA=]"
              },
              "336": {
                "name": "Underburg",
                "level": 26,
                "coord": [
                  52104.1,
                  29908.4
                ],
                "bounds": [
                  [
                    51962.2,
                    30164.8
                  ],
                  [
                    52074.8,
                    30155.4
                  ],
                  [
                    52222.1,
                    30151.7
                  ],
                  [
                    52286.6,
                    30048.9
                  ],
                  [
                    52301.7,
                    29891.9
                  ],
                  [
                    52253.6,
                    29762.5
                  ],
                  [
                    52129.5,
                    29677
                  ],
                  [
                    52025.8,
                    29676.8
                  ],
                  [
                    51945.2,
                    29694.3
                  ],
                  [
                    51839.7,
                    29860.3
                  ],
                  [
                    51962.2,
                    30164.8
                  ]
                ],
                "id": 336,
                "chat_link": "[&BFABAAA=]"
              }
            },
            "adventures": [],
            "id": 447,
            "mastery_points": []
          },
          "449": {
            "name": "Armaments",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              52480,
              28672
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                50432,
                27648
              ],
              [
                54528,
                29696
              ]
            ],
            "points_of_interest": {
              "1034": {
                "name": "Moldary Point",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52367.5,
                  29135.8
                ],
                "id": 1034,
                "chat_link": "[&BAoEAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "229": {
                "name": "Valslake",
                "level": 20,
                "coord": [
                  52628.5,
                  29295.9
                ],
                "bounds": [
                  [
                    52046,
                    29069
                  ],
                  [
                    52290.9,
                    28967.9
                  ],
                  [
                    52461.5,
                    29021.2
                  ],
                  [
                    52943.5,
                    28775.7
                  ],
                  [
                    53379.5,
                    29026.6
                  ],
                  [
                    53339,
                    29259.4
                  ],
                  [
                    53165.7,
                    29204.3
                  ],
                  [
                    52922.2,
                    29290
                  ],
                  [
                    52753.9,
                    29461.2
                  ],
                  [
                    52761.7,
                    29690.8
                  ],
                  [
                    52597,
                    29800.6
                  ],
                  [
                    52065.5,
                    29795
                  ],
                  [
                    52090.4,
                    29508.8
                  ],
                  [
                    51982,
                    29272.4
                  ],
                  [
                    52046,
                    29069
                  ]
                ],
                "id": 229,
                "chat_link": "[&BOUAAAA=]"
              }
            },
            "adventures": [],
            "id": 449,
            "mastery_points": []
          },
          "453": {
            "name": "Assault the Hill",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {
              "293": {
                "name": "Priory Archives",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50509.3,
                  31048.7
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "331": {
                "name": "Refuge Peak",
                "level": 31,
                "coord": [
                  51067.6,
                  31532.6
                ],
                "bounds": [
                  [
                    50876.4,
                    30985.8
                  ],
                  [
                    51178.5,
                    31208.3
                  ],
                  [
                    51249.4,
                    31223.8
                  ],
                  [
                    51189.8,
                    31521.4
                  ],
                  [
                    51434.6,
                    31680.3
                  ],
                  [
                    51381,
                    32042.4
                  ],
                  [
                    50924.5,
                    31909.1
                  ],
                  [
                    50933.5,
                    31712.4
                  ],
                  [
                    50726.8,
                    31654.3
                  ],
                  [
                    50781.2,
                    31388
                  ],
                  [
                    50876.4,
                    30985.8
                  ]
                ],
                "id": 331,
                "chat_link": "[&BEsBAAA=]"
              }
            },
            "adventures": [],
            "id": 453,
            "mastery_points": []
          },
          "454": {
            "name": "Silent Warfare",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {
              "293": {
                "name": "Priory Archives",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50509.3,
                  31048.7
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "331": {
                "name": "Refuge Peak",
                "level": 31,
                "coord": [
                  51067.6,
                  31532.6
                ],
                "bounds": [
                  [
                    50876.4,
                    30985.8
                  ],
                  [
                    51178.5,
                    31208.3
                  ],
                  [
                    51249.4,
                    31223.8
                  ],
                  [
                    51189.8,
                    31521.4
                  ],
                  [
                    51434.6,
                    31680.3
                  ],
                  [
                    51381,
                    32042.4
                  ],
                  [
                    50924.5,
                    31909.1
                  ],
                  [
                    50933.5,
                    31712.4
                  ],
                  [
                    50726.8,
                    31654.3
                  ],
                  [
                    50781.2,
                    31388
                  ],
                  [
                    50876.4,
                    30985.8
                  ]
                ],
                "id": 331,
                "chat_link": "[&BEsBAAA=]"
              }
            },
            "adventures": [],
            "id": 454,
            "mastery_points": []
          },
          "455": {
            "name": "Sever the Head",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "331": {
                "name": "Refuge Peak",
                "level": 31,
                "coord": [
                  51067.6,
                  31532.6
                ],
                "bounds": [
                  [
                    50876.4,
                    30985.8
                  ],
                  [
                    51178.5,
                    31208.3
                  ],
                  [
                    51249.4,
                    31223.8
                  ],
                  [
                    51189.8,
                    31521.4
                  ],
                  [
                    51434.6,
                    31680.3
                  ],
                  [
                    51381,
                    32042.4
                  ],
                  [
                    50924.5,
                    31909.1
                  ],
                  [
                    50933.5,
                    31712.4
                  ],
                  [
                    50726.8,
                    31654.3
                  ],
                  [
                    50781.2,
                    31388
                  ],
                  [
                    50876.4,
                    30985.8
                  ]
                ],
                "id": 331,
                "chat_link": "[&BEsBAAA=]"
              }
            },
            "adventures": [],
            "id": 455,
            "mastery_points": []
          },
          "458": {
            "name": "Fury of the Dead",
            "min_level": 1,
            "max_level": 1,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {
              "1458": {
                "name": "Barradin's Vaults",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58973.9,
                  30876.6
                ],
                "id": 1458,
                "chat_link": "[&BLIFAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "270": {
                "name": "Village of Smokestead",
                "level": 3,
                "coord": [
                  58156.3,
                  30833.9
                ],
                "bounds": [
                  [
                    57856,
                    30550.5
                  ],
                  [
                    57996.7,
                    30571
                  ],
                  [
                    58378.9,
                    30592.8
                  ],
                  [
                    58545.1,
                    30743.8
                  ],
                  [
                    58526.7,
                    30851.5
                  ],
                  [
                    58424.6,
                    31121.2
                  ],
                  [
                    58158.3,
                    31028.9
                  ],
                  [
                    58070.5,
                    31085.8
                  ],
                  [
                    57749.8,
                    31164.6
                  ],
                  [
                    57856,
                    30629.3
                  ],
                  [
                    57856,
                    30550.5
                  ]
                ],
                "id": 270,
                "chat_link": "[&BA4BAAA=]"
              },
              "272": {
                "name": "Victor's Presidium",
                "level": 6,
                "coord": [
                  58619.5,
                  31354.6
                ],
                "bounds": [
                  [
                    58377.7,
                    31462.3
                  ],
                  [
                    58107,
                    31444.8
                  ],
                  [
                    58067.5,
                    31084.7
                  ],
                  [
                    58154.6,
                    31026.6
                  ],
                  [
                    58424.9,
                    31119
                  ],
                  [
                    58528.8,
                    30853.1
                  ],
                  [
                    58778.9,
                    31012.2
                  ],
                  [
                    58956.4,
                    30865.6
                  ],
                  [
                    58960.7,
                    31165.8
                  ],
                  [
                    59145.5,
                    31508.3
                  ],
                  [
                    59152.1,
                    31641.5
                  ],
                  [
                    59030.3,
                    31713.5
                  ],
                  [
                    58675.4,
                    31650.2
                  ],
                  [
                    58573.1,
                    31815.7
                  ],
                  [
                    58477,
                    31779.6
                  ],
                  [
                    58501.8,
                    31530
                  ],
                  [
                    58377.7,
                    31462.3
                  ]
                ],
                "id": 272,
                "chat_link": "[&BBABAAA=]"
              },
              "274": {
                "name": "Old Duke's Estate",
                "level": 6,
                "coord": [
                  58786.2,
                  30721.7
                ],
                "bounds": [
                  [
                    58780.2,
                    31015.2
                  ],
                  [
                    58526.3,
                    30852.5
                  ],
                  [
                    58543.1,
                    30742.7
                  ],
                  [
                    58748,
                    30587
                  ],
                  [
                    58960.9,
                    30433.3
                  ],
                  [
                    59158.8,
                    30699.4
                  ],
                  [
                    58780.2,
                    31015.2
                  ]
                ],
                "id": 274,
                "chat_link": "[&BBIBAAA=]"
              },
              "276": {
                "name": "Charr's Triumph",
                "level": 8,
                "coord": [
                  59352.1,
                  31140.9
                ],
                "bounds": [
                  [
                    59776,
                    31147.4
                  ],
                  [
                    59708.5,
                    30981.9
                  ],
                  [
                    59186.8,
                    30702.1
                  ],
                  [
                    58984.7,
                    30868.8
                  ],
                  [
                    58987.7,
                    31167.6
                  ],
                  [
                    59173.9,
                    31511.9
                  ],
                  [
                    59488.5,
                    31461.5
                  ],
                  [
                    59510.7,
                    31286.2
                  ],
                  [
                    59776,
                    31147.4
                  ]
                ],
                "id": 276,
                "chat_link": "[&BBQBAAA=]"
              }
            },
            "adventures": [],
            "id": 458,
            "mastery_points": []
          },
          "459": {
            "name": "A Fork in the Road",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "929": {
                "name": "Citadel Stockade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57151.1,
                  30615.6
                ],
                "id": 929,
                "chat_link": "[&BKEDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "adventures": [],
            "id": 459,
            "mastery_points": []
          },
          "464": {
            "name": "Tribunes in Effigy",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "929": {
                "name": "Citadel Stockade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57151.1,
                  30615.6
                ],
                "id": 929,
                "chat_link": "[&BKEDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              },
              "817": {
                "name": "Perimeter Loop",
                "level": 0,
                "coord": [
                  57187.5,
                  30628.6
                ],
                "bounds": [
                  [
                    56978.8,
                    30386.7
                  ],
                  [
                    57066.5,
                    30349.7
                  ],
                  [
                    57155.7,
                    30353.3
                  ],
                  [
                    57231.9,
                    30375.6
                  ],
                  [
                    57305.8,
                    30411.1
                  ],
                  [
                    57332.3,
                    30443.3
                  ],
                  [
                    57326.2,
                    30493.3
                  ],
                  [
                    57375.2,
                    30560
                  ],
                  [
                    57371.1,
                    30659.8
                  ],
                  [
                    57306.9,
                    30790.5
                  ],
                  [
                    57342.6,
                    30817
                  ],
                  [
                    57260.8,
                    30890.8
                  ],
                  [
                    57189.3,
                    30919.9
                  ],
                  [
                    57067.2,
                    30935.5
                  ],
                  [
                    56967.5,
                    30914.8
                  ],
                  [
                    56996.8,
                    30795.9
                  ],
                  [
                    57050.3,
                    30735.5
                  ],
                  [
                    57092,
                    30748.3
                  ],
                  [
                    57162.6,
                    30750.6
                  ],
                  [
                    57230.4,
                    30707.1
                  ],
                  [
                    57261.5,
                    30656.8
                  ],
                  [
                    57250.8,
                    30571.5
                  ],
                  [
                    57195.1,
                    30495.8
                  ],
                  [
                    57127,
                    30466.6
                  ],
                  [
                    57042.4,
                    30485.1
                  ],
                  [
                    56978.8,
                    30386.7
                  ]
                ],
                "id": 817,
                "chat_link": "[&BDEDAAA=]"
              }
            },
            "adventures": [],
            "id": 464,
            "mastery_points": []
          },
          "465": {
            "name": "Sins of the Father",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "adventures": [],
            "id": 465,
            "mastery_points": []
          },
          "466": {
            "name": "Misplaced Faith",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {
              "929": {
                "name": "Citadel Stockade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57151.1,
                  30615.6
                ],
                "id": 929,
                "chat_link": "[&BKEDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "adventures": [],
            "id": 466,
            "mastery_points": []
          },
          "470": {
            "name": "Graveyard Ornaments",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "272": {
                "name": "Victor's Presidium",
                "level": 6,
                "coord": [
                  58619.5,
                  31354.6
                ],
                "bounds": [
                  [
                    58377.7,
                    31462.3
                  ],
                  [
                    58107,
                    31444.8
                  ],
                  [
                    58067.5,
                    31084.7
                  ],
                  [
                    58154.6,
                    31026.6
                  ],
                  [
                    58424.9,
                    31119
                  ],
                  [
                    58528.8,
                    30853.1
                  ],
                  [
                    58778.9,
                    31012.2
                  ],
                  [
                    58956.4,
                    30865.6
                  ],
                  [
                    58960.7,
                    31165.8
                  ],
                  [
                    59145.5,
                    31508.3
                  ],
                  [
                    59152.1,
                    31641.5
                  ],
                  [
                    59030.3,
                    31713.5
                  ],
                  [
                    58675.4,
                    31650.2
                  ],
                  [
                    58573.1,
                    31815.7
                  ],
                  [
                    58477,
                    31779.6
                  ],
                  [
                    58501.8,
                    31530
                  ],
                  [
                    58377.7,
                    31462.3
                  ]
                ],
                "id": 272,
                "chat_link": "[&BBABAAA=]"
              }
            },
            "adventures": [],
            "id": 470,
            "mastery_points": []
          },
          "471": {
            "name": "Undead Infestation",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              52480,
              28672
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                50432,
                27648
              ],
              [
                54528,
                29696
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "228": {
                "name": "Hrothgar's Pass",
                "level": 22,
                "coord": [
                  52276,
                  28793.6
                ],
                "bounds": [
                  [
                    52461.1,
                    29023.5
                  ],
                  [
                    52291.1,
                    28967.1
                  ],
                  [
                    52049.6,
                    29069.2
                  ],
                  [
                    51785.3,
                    29008.9
                  ],
                  [
                    51787.1,
                    28915.1
                  ],
                  [
                    51884.2,
                    28755.3
                  ],
                  [
                    52087.1,
                    28629.8
                  ],
                  [
                    52040,
                    28528.3
                  ],
                  [
                    52476.2,
                    28451.5
                  ],
                  [
                    52646.5,
                    28737.1
                  ],
                  [
                    52852.2,
                    28651
                  ],
                  [
                    52950.9,
                    28786
                  ],
                  [
                    52461.1,
                    29023.5
                  ]
                ],
                "id": 228,
                "chat_link": "[&BOQAAAA=]"
              }
            },
            "adventures": [],
            "id": 471,
            "mastery_points": []
          },
          "474": {
            "name": "Whispers in the Dark",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              52480,
              28672
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                50432,
                27648
              ],
              [
                54528,
                29696
              ]
            ],
            "points_of_interest": {
              "147": {
                "name": "Durgar's Homestead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51707,
                  27785.4
                ],
                "id": 147,
                "chat_link": "[&BJMAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "227": {
                "name": "Isenfall Lake",
                "level": 22,
                "coord": [
                  51866,
                  28185.4
                ],
                "bounds": [
                  [
                    52056.7,
                    28112.5
                  ],
                  [
                    52192.4,
                    27939.1
                  ],
                  [
                    52158.1,
                    27682.1
                  ],
                  [
                    52018.5,
                    27680.2
                  ],
                  [
                    52007,
                    27762.9
                  ],
                  [
                    51882.5,
                    27826.6
                  ],
                  [
                    51759.7,
                    27663.5
                  ],
                  [
                    51534.6,
                    27724.9
                  ],
                  [
                    51468,
                    28023.3
                  ],
                  [
                    51728.3,
                    28372.5
                  ],
                  [
                    51657.1,
                    28598
                  ],
                  [
                    51642.4,
                    28867.6
                  ],
                  [
                    51791.8,
                    28918.1
                  ],
                  [
                    51884,
                    28754.8
                  ],
                  [
                    52087.8,
                    28630.3
                  ],
                  [
                    51987.1,
                    28409.6
                  ],
                  [
                    52056.7,
                    28112.5
                  ]
                ],
                "id": 227,
                "chat_link": "[&BOMAAAA=]"
              }
            },
            "adventures": [],
            "id": 474,
            "mastery_points": []
          },
          "476": {
            "name": "Dangerous Research",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              52480,
              28672
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                50432,
                27648
              ],
              [
                54528,
                29696
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "340": {
                "name": "Ossencrest Climb",
                "level": 24,
                "coord": [
                  50616.3,
                  28310.2
                ],
                "bounds": [
                  [
                    50831.9,
                    28081.4
                  ],
                  [
                    50863.9,
                    28360.4
                  ],
                  [
                    50975.1,
                    28448.4
                  ],
                  [
                    50815,
                    28662.7
                  ],
                  [
                    50437.8,
                    28689.8
                  ],
                  [
                    50391,
                    28581.7
                  ],
                  [
                    50345,
                    28432.8
                  ],
                  [
                    50563.5,
                    28307.7
                  ],
                  [
                    50592,
                    28226.8
                  ],
                  [
                    50502.6,
                    28169
                  ],
                  [
                    50437.7,
                    28069.6
                  ],
                  [
                    50536.8,
                    27993.4
                  ],
                  [
                    50719.1,
                    28009.4
                  ],
                  [
                    50831.9,
                    28081.4
                  ]
                ],
                "id": 340,
                "chat_link": "[&BFQBAAA=]"
              }
            },
            "adventures": [],
            "id": 476,
            "mastery_points": []
          },
          "477": {
            "name": "Digging Up Answers",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              52480,
              28672
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                50432,
                27648
              ],
              [
                54528,
                29696
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "220": {
                "name": "The Frozen Sweeps",
                "level": 24,
                "coord": [
                  51359.9,
                  28989
                ],
                "bounds": [
                  [
                    51100.5,
                    29342.2
                  ],
                  [
                    51149.7,
                    29298.5
                  ],
                  [
                    51588.9,
                    29311.2
                  ],
                  [
                    51770.3,
                    29223.4
                  ],
                  [
                    51789.8,
                    28917.2
                  ],
                  [
                    51643.6,
                    28869.2
                  ],
                  [
                    51655.7,
                    28601.7
                  ],
                  [
                    51490.9,
                    28602
                  ],
                  [
                    51400.9,
                    28712.5
                  ],
                  [
                    51096,
                    28728.2
                  ],
                  [
                    50966.9,
                    28954.1
                  ],
                  [
                    51021.4,
                    29080.2
                  ],
                  [
                    51004,
                    29216.2
                  ],
                  [
                    51100.5,
                    29342.2
                  ]
                ],
                "id": 220,
                "chat_link": "[&BNwAAAA=]"
              },
              "221": {
                "name": "Molengrad",
                "level": 24,
                "coord": [
                  51212.2,
                  29527.5
                ],
                "bounds": [
                  [
                    51017.4,
                    29696
                  ],
                  [
                    50957.3,
                    29414.6
                  ],
                  [
                    51149.3,
                    29300.3
                  ],
                  [
                    51315.9,
                    29302
                  ],
                  [
                    51533.1,
                    29679.1
                  ],
                  [
                    51300.2,
                    29772.9
                  ],
                  [
                    51017.4,
                    29696
                  ]
                ],
                "id": 221,
                "chat_link": "[&BN0AAAA=]"
              },
              "226": {
                "name": "Lornar's Gate",
                "level": 22,
                "coord": [
                  51796,
                  29351
                ],
                "bounds": [
                  [
                    51309.3,
                    29301.4
                  ],
                  [
                    51590.7,
                    29307.5
                  ],
                  [
                    51768.4,
                    29222
                  ],
                  [
                    51786.2,
                    29007.7
                  ],
                  [
                    52044.5,
                    29069.3
                  ],
                  [
                    51982.1,
                    29272.8
                  ],
                  [
                    52091.8,
                    29506.2
                  ],
                  [
                    52066.2,
                    29798.1
                  ],
                  [
                    51524.6,
                    29673.9
                  ],
                  [
                    51309.3,
                    29301.4
                  ]
                ],
                "id": 226,
                "chat_link": "[&BOIAAAA=]"
              }
            },
            "adventures": [],
            "id": 477,
            "mastery_points": []
          },
          "480": {
            "name": "Defending the Keep",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {
              "124": {
                "name": "Vigil HQ",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49417.3,
                  28868.2
                ],
                "id": 124,
                "chat_link": "[&BHwAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "260": {
                "name": "Vigilant Hills",
                "level": 29,
                "coord": [
                  49239.9,
                  29137.1
                ],
                "bounds": [
                  [
                    48891.3,
                    28906.3
                  ],
                  [
                    49581.1,
                    28946.2
                  ],
                  [
                    49524.2,
                    29217.3
                  ],
                  [
                    49553.5,
                    29367.6
                  ],
                  [
                    49180.3,
                    29417.3
                  ],
                  [
                    49021.3,
                    29052.4
                  ],
                  [
                    48927.5,
                    29052.3
                  ],
                  [
                    48891.3,
                    28906.3
                  ]
                ],
                "id": 260,
                "chat_link": "[&BAQBAAA=]"
              },
              "948": {
                "name": "Vigil Keep",
                "level": 29,
                "coord": [
                  49263.7,
                  28645.4
                ],
                "bounds": [
                  [
                    48876.7,
                    28634.6
                  ],
                  [
                    49446.1,
                    28355.1
                  ],
                  [
                    49542.8,
                    28427.9
                  ],
                  [
                    49647.6,
                    28482.1
                  ],
                  [
                    49582,
                    28945.2
                  ],
                  [
                    48891,
                    28906.3
                  ],
                  [
                    48860,
                    28766.6
                  ],
                  [
                    48876.7,
                    28634.6
                  ]
                ],
                "id": 948,
                "chat_link": "[&BLQDAAA=]"
              }
            },
            "adventures": [],
            "id": 480,
            "mastery_points": []
          },
          "481": {
            "name": "Undead Detection",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "263": {
                "name": "Overlook Caverns",
                "level": 28,
                "coord": [
                  49866.8,
                  30273.5
                ],
                "bounds": [
                  [
                    49704,
                    30515.9
                  ],
                  [
                    49880.2,
                    30382.3
                  ],
                  [
                    50081.3,
                    30318.7
                  ],
                  [
                    50044.2,
                    30157.5
                  ],
                  [
                    49873.7,
                    30037.7
                  ],
                  [
                    49849.4,
                    30201.9
                  ],
                  [
                    49634.5,
                    30300.5
                  ],
                  [
                    49704,
                    30515.9
                  ]
                ],
                "id": 263,
                "chat_link": "[&BAcBAAA=]"
              },
              "265": {
                "name": "Shiverspur Front",
                "level": 27,
                "coord": [
                  50150.7,
                  29804.4
                ],
                "bounds": [
                  [
                    50043.8,
                    30156.7
                  ],
                  [
                    50208.1,
                    30137.2
                  ],
                  [
                    50441.3,
                    30091.2
                  ],
                  [
                    50518.5,
                    30000.5
                  ],
                  [
                    50464.7,
                    29904.1
                  ],
                  [
                    50507.2,
                    29756
                  ],
                  [
                    50470.9,
                    29456.9
                  ],
                  [
                    49976.7,
                    29475.9
                  ],
                  [
                    49875.2,
                    29381.1
                  ],
                  [
                    49703.6,
                    29568.2
                  ],
                  [
                    49723.8,
                    29688.3
                  ],
                  [
                    49874.3,
                    30037.3
                  ],
                  [
                    50043.8,
                    30156.7
                  ]
                ],
                "id": 265,
                "chat_link": "[&BAkBAAA=]"
              }
            },
            "adventures": [],
            "id": 481,
            "mastery_points": []
          },
          "483": {
            "name": "Ever Vigilant",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "252": {
                "name": "The Lawen Ponds",
                "level": 26,
                "coord": [
                  46865.1,
                  30474.5
                ],
                "bounds": [
                  [
                    46401.4,
                    30686.6
                  ],
                  [
                    46605.5,
                    30634.3
                  ],
                  [
                    47184.1,
                    30609.5
                  ],
                  [
                    47374.1,
                    30646.1
                  ],
                  [
                    47571.1,
                    30559.5
                  ],
                  [
                    47440.2,
                    30249.1
                  ],
                  [
                    47210.5,
                    30156.4
                  ],
                  [
                    46950.8,
                    30157.9
                  ],
                  [
                    46780.5,
                    30295.8
                  ],
                  [
                    46708.1,
                    30378.5
                  ],
                  [
                    46443.3,
                    30534.2
                  ],
                  [
                    46263.7,
                    30592.3
                  ],
                  [
                    46313.5,
                    30668.1
                  ],
                  [
                    46401.4,
                    30686.6
                  ]
                ],
                "id": 252,
                "chat_link": "[&BPwAAAA=]"
              },
              "253": {
                "name": "Lionbridge Expanse",
                "level": 28,
                "coord": [
                  47455,
                  30117.2
                ],
                "bounds": [
                  [
                    47210.2,
                    30156
                  ],
                  [
                    47439.8,
                    30250.6
                  ],
                  [
                    47568.1,
                    30567.4
                  ],
                  [
                    47622.7,
                    30622.7
                  ],
                  [
                    47657.1,
                    30619.4
                  ],
                  [
                    47688.2,
                    30427.9
                  ],
                  [
                    47648.5,
                    30314.4
                  ],
                  [
                    47610.8,
                    30268.5
                  ],
                  [
                    47749.3,
                    30107.3
                  ],
                  [
                    47484.5,
                    30002.3
                  ],
                  [
                    47437.9,
                    29901.9
                  ],
                  [
                    47498.1,
                    29865.6
                  ],
                  [
                    47507.2,
                    29648.5
                  ],
                  [
                    47421,
                    29651.6
                  ],
                  [
                    47218.8,
                    29705.2
                  ],
                  [
                    47097.1,
                    29869.5
                  ],
                  [
                    47162.2,
                    29974.8
                  ],
                  [
                    47167.9,
                    30155.4
                  ],
                  [
                    47210.2,
                    30156
                  ]
                ],
                "id": 253,
                "chat_link": "[&BP0AAAA=]"
              }
            },
            "adventures": [],
            "id": 483,
            "mastery_points": []
          },
          "485": {
            "name": "Research and Destroy",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "252": {
                "name": "The Lawen Ponds",
                "level": 26,
                "coord": [
                  46865.1,
                  30474.5
                ],
                "bounds": [
                  [
                    46401.4,
                    30686.6
                  ],
                  [
                    46605.5,
                    30634.3
                  ],
                  [
                    47184.1,
                    30609.5
                  ],
                  [
                    47374.1,
                    30646.1
                  ],
                  [
                    47571.1,
                    30559.5
                  ],
                  [
                    47440.2,
                    30249.1
                  ],
                  [
                    47210.5,
                    30156.4
                  ],
                  [
                    46950.8,
                    30157.9
                  ],
                  [
                    46780.5,
                    30295.8
                  ],
                  [
                    46708.1,
                    30378.5
                  ],
                  [
                    46443.3,
                    30534.2
                  ],
                  [
                    46263.7,
                    30592.3
                  ],
                  [
                    46313.5,
                    30668.1
                  ],
                  [
                    46401.4,
                    30686.6
                  ]
                ],
                "id": 252,
                "chat_link": "[&BPwAAAA=]"
              },
              "253": {
                "name": "Lionbridge Expanse",
                "level": 28,
                "coord": [
                  47455,
                  30117.2
                ],
                "bounds": [
                  [
                    47210.2,
                    30156
                  ],
                  [
                    47439.8,
                    30250.6
                  ],
                  [
                    47568.1,
                    30567.4
                  ],
                  [
                    47622.7,
                    30622.7
                  ],
                  [
                    47657.1,
                    30619.4
                  ],
                  [
                    47688.2,
                    30427.9
                  ],
                  [
                    47648.5,
                    30314.4
                  ],
                  [
                    47610.8,
                    30268.5
                  ],
                  [
                    47749.3,
                    30107.3
                  ],
                  [
                    47484.5,
                    30002.3
                  ],
                  [
                    47437.9,
                    29901.9
                  ],
                  [
                    47498.1,
                    29865.6
                  ],
                  [
                    47507.2,
                    29648.5
                  ],
                  [
                    47421,
                    29651.6
                  ],
                  [
                    47218.8,
                    29705.2
                  ],
                  [
                    47097.1,
                    29869.5
                  ],
                  [
                    47162.2,
                    29974.8
                  ],
                  [
                    47167.9,
                    30155.4
                  ],
                  [
                    47210.2,
                    30156
                  ]
                ],
                "id": 253,
                "chat_link": "[&BP0AAAA=]"
              }
            },
            "adventures": [],
            "id": 485,
            "mastery_points": []
          },
          "487": {
            "name": "Whispers of Vengeance",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "252": {
                "name": "The Lawen Ponds",
                "level": 26,
                "coord": [
                  46865.1,
                  30474.5
                ],
                "bounds": [
                  [
                    46401.4,
                    30686.6
                  ],
                  [
                    46605.5,
                    30634.3
                  ],
                  [
                    47184.1,
                    30609.5
                  ],
                  [
                    47374.1,
                    30646.1
                  ],
                  [
                    47571.1,
                    30559.5
                  ],
                  [
                    47440.2,
                    30249.1
                  ],
                  [
                    47210.5,
                    30156.4
                  ],
                  [
                    46950.8,
                    30157.9
                  ],
                  [
                    46780.5,
                    30295.8
                  ],
                  [
                    46708.1,
                    30378.5
                  ],
                  [
                    46443.3,
                    30534.2
                  ],
                  [
                    46263.7,
                    30592.3
                  ],
                  [
                    46313.5,
                    30668.1
                  ],
                  [
                    46401.4,
                    30686.6
                  ]
                ],
                "id": 252,
                "chat_link": "[&BPwAAAA=]"
              },
              "253": {
                "name": "Lionbridge Expanse",
                "level": 28,
                "coord": [
                  47455,
                  30117.2
                ],
                "bounds": [
                  [
                    47210.2,
                    30156
                  ],
                  [
                    47439.8,
                    30250.6
                  ],
                  [
                    47568.1,
                    30567.4
                  ],
                  [
                    47622.7,
                    30622.7
                  ],
                  [
                    47657.1,
                    30619.4
                  ],
                  [
                    47688.2,
                    30427.9
                  ],
                  [
                    47648.5,
                    30314.4
                  ],
                  [
                    47610.8,
                    30268.5
                  ],
                  [
                    47749.3,
                    30107.3
                  ],
                  [
                    47484.5,
                    30002.3
                  ],
                  [
                    47437.9,
                    29901.9
                  ],
                  [
                    47498.1,
                    29865.6
                  ],
                  [
                    47507.2,
                    29648.5
                  ],
                  [
                    47421,
                    29651.6
                  ],
                  [
                    47218.8,
                    29705.2
                  ],
                  [
                    47097.1,
                    29869.5
                  ],
                  [
                    47162.2,
                    29974.8
                  ],
                  [
                    47167.9,
                    30155.4
                  ],
                  [
                    47210.2,
                    30156
                  ]
                ],
                "id": 253,
                "chat_link": "[&BP0AAAA=]"
              }
            },
            "adventures": [],
            "id": 487,
            "mastery_points": []
          },
          "488": {
            "name": "Killer Instinct",
            "min_level": 40,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              62976,
              34176
            ],
            "map_rect": [
              [
                -36864,
                -36864
              ],
              [
                36864,
                36864
              ]
            ],
            "continent_rect": [
              [
                61440,
                32640
              ],
              [
                64512,
                35712
              ]
            ],
            "points_of_interest": {
              "199": {
                "name": "Spotter's Base",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62811,
                  34857.5
                ],
                "id": 199,
                "chat_link": "[&BMcAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "368": {
                "name": "Grimm Hills",
                "level": 34,
                "coord": [
                  62913.6,
                  34678.1
                ],
                "bounds": [
                  [
                    62775,
                    35155.6
                  ],
                  [
                    63095.2,
                    34880.6
                  ],
                  [
                    63095,
                    34671.8
                  ],
                  [
                    63212.3,
                    34293.8
                  ],
                  [
                    63014.9,
                    34325.3
                  ],
                  [
                    62889.8,
                    34422.3
                  ],
                  [
                    62883.8,
                    34575
                  ],
                  [
                    62698.5,
                    34687.4
                  ],
                  [
                    62558.2,
                    35091.2
                  ],
                  [
                    62775,
                    35155.6
                  ]
                ],
                "id": 368,
                "chat_link": "[&BHABAAA=]"
              },
              "373": {
                "name": "The Siege Plains",
                "level": 33,
                "coord": [
                  62661.4,
                  34431.1
                ],
                "bounds": [
                  [
                    62342.5,
                    34820
                  ],
                  [
                    62698.4,
                    34688
                  ],
                  [
                    62884,
                    34573.7
                  ],
                  [
                    62895.1,
                    34415.3
                  ],
                  [
                    63015.8,
                    34325.2
                  ],
                  [
                    62807.6,
                    34052
                  ],
                  [
                    62532,
                    33954.3
                  ],
                  [
                    62115.9,
                    34620.7
                  ],
                  [
                    62342.5,
                    34820
                  ]
                ],
                "id": 373,
                "chat_link": "[&BHUBAAA=]"
              }
            },
            "adventures": [],
            "id": 488,
            "mastery_points": []
          },
          "490": {
            "name": "A Fragile Peace",
            "min_level": 40,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              62976,
              34176
            ],
            "map_rect": [
              [
                -36864,
                -36864
              ],
              [
                36864,
                36864
              ]
            ],
            "continent_rect": [
              [
                61440,
                32640
              ],
              [
                64512,
                35712
              ]
            ],
            "points_of_interest": {
              "1051": {
                "name": "The Hawke Heart",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62003,
                  35192.7
                ],
                "id": 1051,
                "chat_link": "[&BBsEAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "367": {
                "name": "Stronghold of Ebonhawke",
                "level": 31,
                "coord": [
                  62008.8,
                  35138
                ],
                "bounds": [
                  [
                    61812.5,
                    34931.7
                  ],
                  [
                    61608.6,
                    34739.7
                  ],
                  [
                    61974.8,
                    34550.6
                  ],
                  [
                    62116.3,
                    34621.3
                  ],
                  [
                    62342,
                    34818.7
                  ],
                  [
                    62699,
                    34688.4
                  ],
                  [
                    62557.7,
                    35091.4
                  ],
                  [
                    62440.8,
                    35324.7
                  ],
                  [
                    62450.3,
                    35654.7
                  ],
                  [
                    62165.5,
                    35625.2
                  ],
                  [
                    61939.4,
                    35533.8
                  ],
                  [
                    61770.3,
                    35659.5
                  ],
                  [
                    61542.8,
                    35558.4
                  ],
                  [
                    61534.8,
                    35269.1
                  ],
                  [
                    61699,
                    35206.4
                  ],
                  [
                    61709.8,
                    35064.6
                  ],
                  [
                    61785.5,
                    35008.6
                  ],
                  [
                    61812.5,
                    34931.7
                  ]
                ],
                "id": 367,
                "chat_link": "[&BG8BAAA=]"
              }
            },
            "adventures": [],
            "id": 490,
            "mastery_points": []
          },
          "492": {
            "name": "Don't Shoot the Messenger",
            "min_level": 40,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              62976,
              34176
            ],
            "map_rect": [
              [
                -36864,
                -36864
              ],
              [
                36864,
                36864
              ]
            ],
            "continent_rect": [
              [
                61440,
                32640
              ],
              [
                64512,
                35712
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "373": {
                "name": "The Siege Plains",
                "level": 33,
                "coord": [
                  62661.4,
                  34431.1
                ],
                "bounds": [
                  [
                    62342.5,
                    34820
                  ],
                  [
                    62698.4,
                    34688
                  ],
                  [
                    62884,
                    34573.7
                  ],
                  [
                    62895.1,
                    34415.3
                  ],
                  [
                    63015.8,
                    34325.2
                  ],
                  [
                    62807.6,
                    34052
                  ],
                  [
                    62532,
                    33954.3
                  ],
                  [
                    62115.9,
                    34620.7
                  ],
                  [
                    62342.5,
                    34820
                  ]
                ],
                "id": 373,
                "chat_link": "[&BHUBAAA=]"
              },
              "374": {
                "name": "Sniper's Woods",
                "level": 35,
                "coord": [
                  62135,
                  34190.4
                ],
                "bounds": [
                  [
                    61976.5,
                    34544.7
                  ],
                  [
                    62116.8,
                    34620
                  ],
                  [
                    62531.9,
                    33954
                  ],
                  [
                    62317,
                    33906.1
                  ],
                  [
                    62102.3,
                    34036.9
                  ],
                  [
                    61765.8,
                    34080.3
                  ],
                  [
                    61976.5,
                    34544.7
                  ]
                ],
                "id": 374,
                "chat_link": "[&BHYBAAA=]"
              },
              "379": {
                "name": "Vulture's Sweep",
                "level": 37,
                "coord": [
                  62545.4,
                  33687.2
                ],
                "bounds": [
                  [
                    62315.8,
                    33906
                  ],
                  [
                    62530.4,
                    33952.9
                  ],
                  [
                    62805.8,
                    34052.8
                  ],
                  [
                    62867.3,
                    33390.9
                  ],
                  [
                    62492.3,
                    33242.2
                  ],
                  [
                    62260.7,
                    33578.4
                  ],
                  [
                    62315.8,
                    33906
                  ]
                ],
                "id": 379,
                "chat_link": "[&BHsBAAA=]"
              }
            },
            "adventures": [],
            "id": 492,
            "mastery_points": []
          },
          "497": {
            "name": "Dredging Up the Past",
            "min_level": 40,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "330": {
                "name": "Molent Summit",
                "level": 31,
                "coord": [
                  52160.1,
                  31385
                ],
                "bounds": [
                  [
                    51967.5,
                    31229
                  ],
                  [
                    52271.2,
                    31141.2
                  ],
                  [
                    52226.7,
                    31232.7
                  ],
                  [
                    52270.1,
                    31395.5
                  ],
                  [
                    52259.4,
                    31517.2
                  ],
                  [
                    52268.6,
                    31587.7
                  ],
                  [
                    52137.1,
                    31565.8
                  ],
                  [
                    51880.3,
                    31410.8
                  ],
                  [
                    51967.5,
                    31229
                  ]
                ],
                "id": 330,
                "chat_link": "[&BEoBAAA=]"
              },
              "339": {
                "name": "Lake of Lamentation",
                "level": 32,
                "coord": [
                  51824.8,
                  31661.3
                ],
                "bounds": [
                  [
                    52100,
                    31910.1
                  ],
                  [
                    51700.7,
                    32046.6
                  ],
                  [
                    51615.8,
                    32029
                  ],
                  [
                    51360.2,
                    32224.5
                  ],
                  [
                    51434.5,
                    31680.1
                  ],
                  [
                    51189,
                    31519.8
                  ],
                  [
                    51248.9,
                    31223.6
                  ],
                  [
                    51755.3,
                    31012.2
                  ],
                  [
                    51967.2,
                    31228.5
                  ],
                  [
                    51881.1,
                    31410.6
                  ],
                  [
                    52137.9,
                    31566.1
                  ],
                  [
                    52255.5,
                    31584.7
                  ],
                  [
                    52290.6,
                    31717.6
                  ],
                  [
                    52249.2,
                    31838.7
                  ],
                  [
                    52186.2,
                    31926.9
                  ],
                  [
                    52100,
                    31910.1
                  ]
                ],
                "id": 339,
                "chat_link": "[&BFMBAAA=]"
              }
            },
            "adventures": [],
            "id": 497,
            "mastery_points": []
          },
          "498": {
            "name": "Dredging Up the Past",
            "min_level": 40,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {
              "293": {
                "name": "Priory Archives",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50509.3,
                  31048.7
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "947": {
                "name": "Durmand Priory",
                "level": 31,
                "coord": [
                  50600.6,
                  31003.3
                ],
                "bounds": [
                  [
                    50368,
                    31537.9
                  ],
                  [
                    50781.9,
                    31388
                  ],
                  [
                    50876.9,
                    30987
                  ],
                  [
                    50824.2,
                    30793.6
                  ],
                  [
                    50731,
                    30797.9
                  ],
                  [
                    50659.6,
                    30721.1
                  ],
                  [
                    50338.2,
                    30741.7
                  ],
                  [
                    50224.6,
                    31059.4
                  ],
                  [
                    50368,
                    31537.9
                  ]
                ],
                "id": 947,
                "chat_link": "[&BLMDAAA=]"
              }
            },
            "id": 498,
            "mastery_points": [],
            "adventures": []
          },
          "499": {
            "name": "Scrapyard Dogs",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              57088,
              30460
            ],
            "map_rect": [
              [
                -18432,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                56320,
                29952
              ],
              [
                57856,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "747": {
                "name": "Imperator's Core",
                "level": 0,
                "coord": [
                  57150.5,
                  30626.8
                ],
                "bounds": [
                  [
                    57034.1,
                    30739.8
                  ],
                  [
                    57006.4,
                    30499.3
                  ],
                  [
                    57120.6,
                    30464.5
                  ],
                  [
                    57198.8,
                    30495.4
                  ],
                  [
                    57255.5,
                    30574.2
                  ],
                  [
                    57263.4,
                    30629.9
                  ],
                  [
                    57229,
                    30715.7
                  ],
                  [
                    57159,
                    30757.9
                  ],
                  [
                    57088.1,
                    30764.5
                  ],
                  [
                    57034.1,
                    30739.8
                  ]
                ],
                "id": 747,
                "chat_link": "[&BOsCAAA=]"
              }
            },
            "adventures": [],
            "id": 499,
            "mastery_points": []
          },
          "502": {
            "name": "Quaestor's Siege",
            "min_level": 40,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              62976,
              34176
            ],
            "map_rect": [
              [
                -36864,
                -36864
              ],
              [
                36864,
                36864
              ]
            ],
            "continent_rect": [
              [
                61440,
                32640
              ],
              [
                64512,
                35712
              ]
            ],
            "points_of_interest": {
              "209": {
                "name": "The Thunder Den",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63283.3,
                  32814.3
                ],
                "id": 209,
                "chat_link": "[&BNEAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "387": {
                "name": "Thunderbreak Hills",
                "level": 38,
                "coord": [
                  62924.8,
                  32849.6
                ],
                "bounds": [
                  [
                    63401.1,
                    32628
                  ],
                  [
                    63567,
                    33004.2
                  ],
                  [
                    63218.8,
                    33031.5
                  ],
                  [
                    62867.4,
                    33390
                  ],
                  [
                    62493,
                    33242.9
                  ],
                  [
                    62440,
                    32773.5
                  ],
                  [
                    62420.6,
                    32649
                  ],
                  [
                    62745,
                    32572
                  ],
                  [
                    62954.7,
                    32648.8
                  ],
                  [
                    63140.4,
                    32556.1
                  ],
                  [
                    63401.1,
                    32628
                  ]
                ],
                "id": 387,
                "chat_link": "[&BIMBAAA=]"
              }
            },
            "adventures": [],
            "id": 502,
            "mastery_points": []
          },
          "503": {
            "name": "Minister's Defense",
            "min_level": 40,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              62976,
              34176
            ],
            "map_rect": [
              [
                -36864,
                -36864
              ],
              [
                36864,
                36864
              ]
            ],
            "continent_rect": [
              [
                61440,
                32640
              ],
              [
                64512,
                35712
              ]
            ],
            "points_of_interest": {
              "205": {
                "name": "Ebonhawke Delegation",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63123.1,
                  33937.4
                ],
                "id": 205,
                "chat_link": "[&BM0AAAA=]"
              },
              "206": {
                "name": "Summit Peak",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63070.5,
                  33619.2
                ],
                "id": 206,
                "chat_link": "[&BM4AAAA=]"
              },
              "208": {
                "name": "Delegation of the Legions",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63429.5,
                  33644.1
                ],
                "id": 208,
                "chat_link": "[&BNAAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "373": {
                "name": "The Siege Plains",
                "level": 33,
                "coord": [
                  62661.4,
                  34431.1
                ],
                "bounds": [
                  [
                    62342.5,
                    34820
                  ],
                  [
                    62698.4,
                    34688
                  ],
                  [
                    62884,
                    34573.7
                  ],
                  [
                    62895.1,
                    34415.3
                  ],
                  [
                    63015.8,
                    34325.2
                  ],
                  [
                    62807.6,
                    34052
                  ],
                  [
                    62532,
                    33954.3
                  ],
                  [
                    62115.9,
                    34620.7
                  ],
                  [
                    62342.5,
                    34820
                  ]
                ],
                "id": 373,
                "chat_link": "[&BHUBAAA=]"
              },
              "374": {
                "name": "Sniper's Woods",
                "level": 35,
                "coord": [
                  62135,
                  34190.4
                ],
                "bounds": [
                  [
                    61976.5,
                    34544.7
                  ],
                  [
                    62116.8,
                    34620
                  ],
                  [
                    62531.9,
                    33954
                  ],
                  [
                    62317,
                    33906.1
                  ],
                  [
                    62102.3,
                    34036.9
                  ],
                  [
                    61765.8,
                    34080.3
                  ],
                  [
                    61976.5,
                    34544.7
                  ]
                ],
                "id": 374,
                "chat_link": "[&BHYBAAA=]"
              },
              "379": {
                "name": "Vulture's Sweep",
                "level": 37,
                "coord": [
                  62545.4,
                  33687.2
                ],
                "bounds": [
                  [
                    62315.8,
                    33906
                  ],
                  [
                    62530.4,
                    33952.9
                  ],
                  [
                    62805.8,
                    34052.8
                  ],
                  [
                    62867.3,
                    33390.9
                  ],
                  [
                    62492.3,
                    33242.2
                  ],
                  [
                    62260.7,
                    33578.4
                  ],
                  [
                    62315.8,
                    33906
                  ]
                ],
                "id": 379,
                "chat_link": "[&BHsBAAA=]"
              },
              "380": {
                "name": "Warrior's Crown",
                "level": 36,
                "coord": [
                  63286.9,
                  33885.3
                ],
                "bounds": [
                  [
                    62867.6,
                    33388
                  ],
                  [
                    63792.5,
                    33512.5
                  ],
                  [
                    63709.9,
                    33749.2
                  ],
                  [
                    63468.1,
                    33900.9
                  ],
                  [
                    63349.3,
                    34273.4
                  ],
                  [
                    63014.9,
                    34324.5
                  ],
                  [
                    62805.9,
                    34048.8
                  ],
                  [
                    62867.6,
                    33388
                  ]
                ],
                "id": 380,
                "chat_link": "[&BHwBAAA=]"
              },
              "387": {
                "name": "Thunderbreak Hills",
                "level": 38,
                "coord": [
                  62924.8,
                  32849.6
                ],
                "bounds": [
                  [
                    63401.1,
                    32628
                  ],
                  [
                    63567,
                    33004.2
                  ],
                  [
                    63218.8,
                    33031.5
                  ],
                  [
                    62867.4,
                    33390
                  ],
                  [
                    62493,
                    33242.9
                  ],
                  [
                    62440,
                    32773.5
                  ],
                  [
                    62420.6,
                    32649
                  ],
                  [
                    62745,
                    32572
                  ],
                  [
                    62954.7,
                    32648.8
                  ],
                  [
                    63140.4,
                    32556.1
                  ],
                  [
                    63401.1,
                    32628
                  ]
                ],
                "id": 387,
                "chat_link": "[&BIMBAAA=]"
              }
            },
            "adventures": [],
            "id": 503,
            "mastery_points": []
          },
          "504": {
            "name": "Called to Service",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 504,
            "mastery_points": []
          },
          "505": {
            "name": "Called to Service",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "99": {
                "name": "Glencarn Sperrins",
                "level": 10,
                "coord": [
                  43412.7,
                  35130
                ],
                "bounds": [
                  [
                    43088.9,
                    35160.6
                  ],
                  [
                    42994.1,
                    35128.4
                  ],
                  [
                    42925,
                    34896.4
                  ],
                  [
                    43146.7,
                    34812.3
                  ],
                  [
                    43459.7,
                    34971.4
                  ],
                  [
                    43918.7,
                    34714.2
                  ],
                  [
                    43916,
                    35006.2
                  ],
                  [
                    43742.7,
                    35344.4
                  ],
                  [
                    43719,
                    35460.8
                  ],
                  [
                    43549.3,
                    35377.7
                  ],
                  [
                    43386.5,
                    35399.8
                  ],
                  [
                    43105.6,
                    35288.4
                  ],
                  [
                    43088.9,
                    35160.6
                  ]
                ],
                "id": 99,
                "chat_link": "[&BGMAAAA=]"
              },
              "104": {
                "name": "Grenbrack Delves",
                "level": 4,
                "coord": [
                  43354.3,
                  35650.6
                ],
                "bounds": [
                  [
                    43333.8,
                    36026.2
                  ],
                  [
                    43447.4,
                    36034.3
                  ],
                  [
                    43545.9,
                    35927
                  ],
                  [
                    43522.9,
                    35772.8
                  ],
                  [
                    43498.4,
                    35589.1
                  ],
                  [
                    43421.5,
                    35585.6
                  ],
                  [
                    43384.1,
                    35453.6
                  ],
                  [
                    43390,
                    35403.3
                  ],
                  [
                    43374.7,
                    35404.7
                  ],
                  [
                    43106,
                    35302.1
                  ],
                  [
                    43080.9,
                    35423
                  ],
                  [
                    43145.9,
                    35885.3
                  ],
                  [
                    43333.8,
                    36026.2
                  ]
                ],
                "id": 104,
                "chat_link": "[&BGgAAAA=]"
              }
            },
            "adventures": [],
            "id": 505,
            "mastery_points": []
          },
          "507": {
            "name": "Mockery of Death",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 507,
            "mastery_points": []
          },
          "509": {
            "name": "Discovering Darkness",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "96": {
                "name": "Sandycove Beach",
                "level": 8,
                "coord": [
                  42648,
                  35243.4
                ],
                "bounds": [
                  [
                    42775.5,
                    35574.7
                  ],
                  [
                    43078.1,
                    35418.4
                  ],
                  [
                    43103.1,
                    35301.9
                  ],
                  [
                    43090.7,
                    35157.7
                  ],
                  [
                    42994.6,
                    35128.3
                  ],
                  [
                    42967.8,
                    35035.4
                  ],
                  [
                    42552,
                    34991.8
                  ],
                  [
                    42480.3,
                    34895.9
                  ],
                  [
                    42075.2,
                    35025
                  ],
                  [
                    42074.8,
                    35373.5
                  ],
                  [
                    42074.9,
                    35617.2
                  ],
                  [
                    42509,
                    35400.9
                  ],
                  [
                    42775.5,
                    35574.7
                  ]
                ],
                "id": 96,
                "chat_link": "[&BGAAAAA=]"
              },
              "111": {
                "name": "Ogham Wilds",
                "level": 7,
                "coord": [
                  42559.4,
                  36066.3
                ],
                "bounds": [
                  [
                    42507.5,
                    35402.7
                  ],
                  [
                    42772.1,
                    35575.4
                  ],
                  [
                    42772.2,
                    35576.1
                  ],
                  [
                    42925,
                    35499.9
                  ],
                  [
                    42876.5,
                    35647.1
                  ],
                  [
                    42811.6,
                    35685.8
                  ],
                  [
                    42719.4,
                    35840.1
                  ],
                  [
                    42732.1,
                    35969.4
                  ],
                  [
                    42727.8,
                    36011.7
                  ],
                  [
                    42774.2,
                    36040.1
                  ],
                  [
                    42761.9,
                    36057.3
                  ],
                  [
                    42609.8,
                    35979
                  ],
                  [
                    42540.8,
                    36024.6
                  ],
                  [
                    42518,
                    36073.1
                  ],
                  [
                    42506.5,
                    36178.1
                  ],
                  [
                    42534.6,
                    36251.2
                  ],
                  [
                    42477.3,
                    36740.6
                  ],
                  [
                    42451.9,
                    36782.7
                  ],
                  [
                    42381.7,
                    36793
                  ],
                  [
                    42150.4,
                    36742.1
                  ],
                  [
                    42146,
                    36573.3
                  ],
                  [
                    42094,
                    36464.9
                  ],
                  [
                    42074.1,
                    35617.5
                  ],
                  [
                    42507.5,
                    35402.7
                  ]
                ],
                "id": 111,
                "chat_link": "[&BG8AAAA=]"
              }
            },
            "adventures": [],
            "id": 509,
            "mastery_points": []
          },
          "511": {
            "name": "Hounds and the Hunted",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {
              "104": {
                "name": "Caer Verdant",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43468.7,
                  36063.8
                ],
                "id": 104,
                "chat_link": "[&BGgAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "100": {
                "name": "Sleive's Inlet",
                "level": 4,
                "coord": [
                  43707.4,
                  36267.8
                ],
                "bounds": [
                  [
                    43400.7,
                    36499.6
                  ],
                  [
                    43603.5,
                    36545.5
                  ],
                  [
                    43848.7,
                    36536.7
                  ],
                  [
                    43947,
                    36438.7
                  ],
                  [
                    43998.6,
                    36311
                  ],
                  [
                    43960.6,
                    36134.5
                  ],
                  [
                    43614.5,
                    35983.8
                  ],
                  [
                    43546.6,
                    35926.5
                  ],
                  [
                    43446.7,
                    36034
                  ],
                  [
                    43400.7,
                    36499.6
                  ]
                ],
                "id": 100,
                "chat_link": "[&BGQAAAA=]"
              }
            },
            "adventures": [],
            "id": 511,
            "mastery_points": []
          },
          "512": {
            "name": "Hounds and the Hunted",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 512,
            "mastery_points": []
          },
          "513": {
            "name": "Loved and Lost",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "100": {
                "name": "Sleive's Inlet",
                "level": 4,
                "coord": [
                  43707.4,
                  36267.8
                ],
                "bounds": [
                  [
                    43400.7,
                    36499.6
                  ],
                  [
                    43603.5,
                    36545.5
                  ],
                  [
                    43848.7,
                    36536.7
                  ],
                  [
                    43947,
                    36438.7
                  ],
                  [
                    43998.6,
                    36311
                  ],
                  [
                    43960.6,
                    36134.5
                  ],
                  [
                    43614.5,
                    35983.8
                  ],
                  [
                    43546.6,
                    35926.5
                  ],
                  [
                    43446.7,
                    36034
                  ],
                  [
                    43400.7,
                    36499.6
                  ]
                ],
                "id": 100,
                "chat_link": "[&BGQAAAA=]"
              },
              "104": {
                "name": "Grenbrack Delves",
                "level": 4,
                "coord": [
                  43354.3,
                  35650.6
                ],
                "bounds": [
                  [
                    43333.8,
                    36026.2
                  ],
                  [
                    43447.4,
                    36034.3
                  ],
                  [
                    43545.9,
                    35927
                  ],
                  [
                    43522.9,
                    35772.8
                  ],
                  [
                    43498.4,
                    35589.1
                  ],
                  [
                    43421.5,
                    35585.6
                  ],
                  [
                    43384.1,
                    35453.6
                  ],
                  [
                    43390,
                    35403.3
                  ],
                  [
                    43374.7,
                    35404.7
                  ],
                  [
                    43106,
                    35302.1
                  ],
                  [
                    43080.9,
                    35423
                  ],
                  [
                    43145.9,
                    35885.3
                  ],
                  [
                    43333.8,
                    36026.2
                  ]
                ],
                "id": 104,
                "chat_link": "[&BGgAAAA=]"
              },
              "107": {
                "name": "Morgan's Spiral",
                "level": 6,
                "coord": [
                  43843.3,
                  35603.7
                ],
                "bounds": [
                  [
                    43522.3,
                    35772.5
                  ],
                  [
                    43499.2,
                    35583.8
                  ],
                  [
                    43657.1,
                    35592.8
                  ],
                  [
                    43695.8,
                    35578
                  ],
                  [
                    43744.9,
                    35347.5
                  ],
                  [
                    43915.9,
                    34997.7
                  ],
                  [
                    44008.3,
                    35077.1
                  ],
                  [
                    44024,
                    35220.7
                  ],
                  [
                    44207.6,
                    35407
                  ],
                  [
                    44245.3,
                    35733.8
                  ],
                  [
                    44165.7,
                    36094
                  ],
                  [
                    43958.6,
                    36135.6
                  ],
                  [
                    43614.5,
                    35984.3
                  ],
                  [
                    43546.8,
                    35926.7
                  ],
                  [
                    43522.3,
                    35772.5
                  ]
                ],
                "id": 107,
                "chat_link": "[&BGsAAAA=]"
              }
            },
            "adventures": [],
            "id": 513,
            "mastery_points": []
          },
          "514": {
            "name": "Saving the Stag",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {
              "110": {
                "name": "Hemlock Coil",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42367.8,
                  34346
                ],
                "id": 110,
                "chat_link": "[&BG4AAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "93": {
                "name": "Mabon Market",
                "level": 10,
                "coord": [
                  42978.6,
                  34533.9
                ],
                "bounds": [
                  [
                    42787.2,
                    34539.3
                  ],
                  [
                    42886.7,
                    34450.3
                  ],
                  [
                    43073.8,
                    34414.6
                  ],
                  [
                    43178.9,
                    34479.2
                  ],
                  [
                    43076.8,
                    34656
                  ],
                  [
                    42868.2,
                    34664.2
                  ],
                  [
                    42787.2,
                    34539.3
                  ]
                ],
                "id": 93,
                "chat_link": "[&BF0AAAA=]"
              },
              "95": {
                "name": "Ventry Bay",
                "level": 10,
                "coord": [
                  42938.5,
                  34616.1
                ],
                "bounds": [
                  [
                    42104.4,
                    35018.8
                  ],
                  [
                    42480.4,
                    34896
                  ],
                  [
                    42552.5,
                    34994.3
                  ],
                  [
                    42967.8,
                    35033.9
                  ],
                  [
                    42924.9,
                    34896.8
                  ],
                  [
                    43147.8,
                    34812
                  ],
                  [
                    43460.3,
                    34971
                  ],
                  [
                    43919.5,
                    34726.9
                  ],
                  [
                    43910.2,
                    34235.8
                  ],
                  [
                    43635.6,
                    34211.3
                  ],
                  [
                    43615.6,
                    34226.3
                  ],
                  [
                    43436.5,
                    34221.2
                  ],
                  [
                    43264.7,
                    34312.9
                  ],
                  [
                    43074.8,
                    34649.6
                  ],
                  [
                    42867.4,
                    34664.8
                  ],
                  [
                    42788.3,
                    34541.6
                  ],
                  [
                    42689.8,
                    34547.8
                  ],
                  [
                    42404.3,
                    34374.9
                  ],
                  [
                    42288.6,
                    34440.2
                  ],
                  [
                    42112.6,
                    34425.6
                  ],
                  [
                    42061.9,
                    34736
                  ],
                  [
                    42104.4,
                    35018.8
                  ]
                ],
                "id": 95,
                "chat_link": "[&BF8AAAA=]"
              },
              "105": {
                "name": "Trader's Green",
                "level": 12,
                "coord": [
                  42589.1,
                  33922.8
                ],
                "bounds": [
                  [
                    42281.7,
                    34451.8
                  ],
                  [
                    42074.4,
                    34419.6
                  ],
                  [
                    42079.1,
                    33979.1
                  ],
                  [
                    42306.2,
                    33851.2
                  ],
                  [
                    42449.8,
                    33720.2
                  ],
                  [
                    42550.4,
                    33535.3
                  ],
                  [
                    42739.2,
                    33513.4
                  ],
                  [
                    43019.6,
                    33537.1
                  ],
                  [
                    43234.5,
                    33681.5
                  ],
                  [
                    43147.7,
                    33905.3
                  ],
                  [
                    42762,
                    33949.4
                  ],
                  [
                    42609.1,
                    34079.5
                  ],
                  [
                    42404.7,
                    34373.1
                  ],
                  [
                    42281.7,
                    34451.8
                  ]
                ],
                "id": 105,
                "chat_link": "[&BGkAAAA=]"
              },
              "106": {
                "name": "The Rootangles",
                "level": 11,
                "coord": [
                  42898.1,
                  34310.3
                ],
                "bounds": [
                  [
                    42788.3,
                    34539.6
                  ],
                  [
                    42885.8,
                    34450.5
                  ],
                  [
                    43073,
                    34414.1
                  ],
                  [
                    43174.2,
                    34482.5
                  ],
                  [
                    43264.9,
                    34312.7
                  ],
                  [
                    43145.7,
                    33902.8
                  ],
                  [
                    43017.3,
                    33916.6
                  ],
                  [
                    43012.8,
                    34232.2
                  ],
                  [
                    42820.7,
                    34330.3
                  ],
                  [
                    42508.8,
                    34220.7
                  ],
                  [
                    42399.2,
                    34374
                  ],
                  [
                    42687.2,
                    34548.3
                  ],
                  [
                    42788.3,
                    34539.6
                  ]
                ],
                "id": 106,
                "chat_link": "[&BGoAAAA=]"
              }
            },
            "adventures": [],
            "id": 514,
            "mastery_points": []
          },
          "515": {
            "name": "Hidden in Darkness",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {
              "110": {
                "name": "Hemlock Coil",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42367.8,
                  34346
                ],
                "id": 110,
                "chat_link": "[&BG4AAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "95": {
                "name": "Ventry Bay",
                "level": 10,
                "coord": [
                  42938.5,
                  34616.1
                ],
                "bounds": [
                  [
                    42104.4,
                    35018.8
                  ],
                  [
                    42480.4,
                    34896
                  ],
                  [
                    42552.5,
                    34994.3
                  ],
                  [
                    42967.8,
                    35033.9
                  ],
                  [
                    42924.9,
                    34896.8
                  ],
                  [
                    43147.8,
                    34812
                  ],
                  [
                    43460.3,
                    34971
                  ],
                  [
                    43919.5,
                    34726.9
                  ],
                  [
                    43910.2,
                    34235.8
                  ],
                  [
                    43635.6,
                    34211.3
                  ],
                  [
                    43615.6,
                    34226.3
                  ],
                  [
                    43436.5,
                    34221.2
                  ],
                  [
                    43264.7,
                    34312.9
                  ],
                  [
                    43074.8,
                    34649.6
                  ],
                  [
                    42867.4,
                    34664.8
                  ],
                  [
                    42788.3,
                    34541.6
                  ],
                  [
                    42689.8,
                    34547.8
                  ],
                  [
                    42404.3,
                    34374.9
                  ],
                  [
                    42288.6,
                    34440.2
                  ],
                  [
                    42112.6,
                    34425.6
                  ],
                  [
                    42061.9,
                    34736
                  ],
                  [
                    42104.4,
                    35018.8
                  ]
                ],
                "id": 95,
                "chat_link": "[&BF8AAAA=]"
              },
              "105": {
                "name": "Trader's Green",
                "level": 12,
                "coord": [
                  42589.1,
                  33922.8
                ],
                "bounds": [
                  [
                    42281.7,
                    34451.8
                  ],
                  [
                    42074.4,
                    34419.6
                  ],
                  [
                    42079.1,
                    33979.1
                  ],
                  [
                    42306.2,
                    33851.2
                  ],
                  [
                    42449.8,
                    33720.2
                  ],
                  [
                    42550.4,
                    33535.3
                  ],
                  [
                    42739.2,
                    33513.4
                  ],
                  [
                    43019.6,
                    33537.1
                  ],
                  [
                    43234.5,
                    33681.5
                  ],
                  [
                    43147.7,
                    33905.3
                  ],
                  [
                    42762,
                    33949.4
                  ],
                  [
                    42609.1,
                    34079.5
                  ],
                  [
                    42404.7,
                    34373.1
                  ],
                  [
                    42281.7,
                    34451.8
                  ]
                ],
                "id": 105,
                "chat_link": "[&BGkAAAA=]"
              },
              "106": {
                "name": "The Rootangles",
                "level": 11,
                "coord": [
                  42898.1,
                  34310.3
                ],
                "bounds": [
                  [
                    42788.3,
                    34539.6
                  ],
                  [
                    42885.8,
                    34450.5
                  ],
                  [
                    43073,
                    34414.1
                  ],
                  [
                    43174.2,
                    34482.5
                  ],
                  [
                    43264.9,
                    34312.7
                  ],
                  [
                    43145.7,
                    33902.8
                  ],
                  [
                    43017.3,
                    33916.6
                  ],
                  [
                    43012.8,
                    34232.2
                  ],
                  [
                    42820.7,
                    34330.3
                  ],
                  [
                    42508.8,
                    34220.7
                  ],
                  [
                    42399.2,
                    34374
                  ],
                  [
                    42687.2,
                    34548.3
                  ],
                  [
                    42788.3,
                    34539.6
                  ]
                ],
                "id": 106,
                "chat_link": "[&BGoAAAA=]"
              }
            },
            "adventures": [],
            "id": 515,
            "mastery_points": []
          },
          "516": {
            "name": "Good Work Spoiled",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "96": {
                "name": "Sandycove Beach",
                "level": 8,
                "coord": [
                  42648,
                  35243.4
                ],
                "bounds": [
                  [
                    42775.5,
                    35574.7
                  ],
                  [
                    43078.1,
                    35418.4
                  ],
                  [
                    43103.1,
                    35301.9
                  ],
                  [
                    43090.7,
                    35157.7
                  ],
                  [
                    42994.6,
                    35128.3
                  ],
                  [
                    42967.8,
                    35035.4
                  ],
                  [
                    42552,
                    34991.8
                  ],
                  [
                    42480.3,
                    34895.9
                  ],
                  [
                    42075.2,
                    35025
                  ],
                  [
                    42074.8,
                    35373.5
                  ],
                  [
                    42074.9,
                    35617.2
                  ],
                  [
                    42509,
                    35400.9
                  ],
                  [
                    42775.5,
                    35574.7
                  ]
                ],
                "id": 96,
                "chat_link": "[&BGAAAAA=]"
              }
            },
            "adventures": [],
            "id": 516,
            "mastery_points": []
          },
          "517": {
            "name": "Black Night, White Stag",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 517,
            "mastery_points": []
          },
          "518": {
            "name": "The Omphalos Chamber",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 518,
            "mastery_points": []
          },
          "519": {
            "name": "Weakness of the Heart",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "100": {
                "name": "Sleive's Inlet",
                "level": 4,
                "coord": [
                  43707.4,
                  36267.8
                ],
                "bounds": [
                  [
                    43400.7,
                    36499.6
                  ],
                  [
                    43603.5,
                    36545.5
                  ],
                  [
                    43848.7,
                    36536.7
                  ],
                  [
                    43947,
                    36438.7
                  ],
                  [
                    43998.6,
                    36311
                  ],
                  [
                    43960.6,
                    36134.5
                  ],
                  [
                    43614.5,
                    35983.8
                  ],
                  [
                    43546.6,
                    35926.5
                  ],
                  [
                    43446.7,
                    36034
                  ],
                  [
                    43400.7,
                    36499.6
                  ]
                ],
                "id": 100,
                "chat_link": "[&BGQAAAA=]"
              },
              "107": {
                "name": "Morgan's Spiral",
                "level": 6,
                "coord": [
                  43843.3,
                  35603.7
                ],
                "bounds": [
                  [
                    43522.3,
                    35772.5
                  ],
                  [
                    43499.2,
                    35583.8
                  ],
                  [
                    43657.1,
                    35592.8
                  ],
                  [
                    43695.8,
                    35578
                  ],
                  [
                    43744.9,
                    35347.5
                  ],
                  [
                    43915.9,
                    34997.7
                  ],
                  [
                    44008.3,
                    35077.1
                  ],
                  [
                    44024,
                    35220.7
                  ],
                  [
                    44207.6,
                    35407
                  ],
                  [
                    44245.3,
                    35733.8
                  ],
                  [
                    44165.7,
                    36094
                  ],
                  [
                    43958.6,
                    36135.6
                  ],
                  [
                    43614.5,
                    35984.3
                  ],
                  [
                    43546.8,
                    35926.7
                  ],
                  [
                    43522.3,
                    35772.5
                  ]
                ],
                "id": 107,
                "chat_link": "[&BGsAAAA=]"
              }
            },
            "adventures": [],
            "id": 519,
            "mastery_points": []
          },
          "520": {
            "name": "Awakening",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 520,
            "mastery_points": []
          },
          "521": {
            "name": "Holding Back the Darkness",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {
              "104": {
                "name": "Caer Verdant",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43468.7,
                  36063.8
                ],
                "id": 104,
                "chat_link": "[&BGgAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "100": {
                "name": "Sleive's Inlet",
                "level": 4,
                "coord": [
                  43707.4,
                  36267.8
                ],
                "bounds": [
                  [
                    43400.7,
                    36499.6
                  ],
                  [
                    43603.5,
                    36545.5
                  ],
                  [
                    43848.7,
                    36536.7
                  ],
                  [
                    43947,
                    36438.7
                  ],
                  [
                    43998.6,
                    36311
                  ],
                  [
                    43960.6,
                    36134.5
                  ],
                  [
                    43614.5,
                    35983.8
                  ],
                  [
                    43546.6,
                    35926.5
                  ],
                  [
                    43446.7,
                    36034
                  ],
                  [
                    43400.7,
                    36499.6
                  ]
                ],
                "id": 100,
                "chat_link": "[&BGQAAAA=]"
              },
              "101": {
                "name": "The Verdence",
                "level": 3,
                "coord": [
                  43034,
                  35956.7
                ],
                "bounds": [
                  [
                    42952.9,
                    36100.3
                  ],
                  [
                    43046.8,
                    36263.8
                  ],
                  [
                    43020.4,
                    36502.3
                  ],
                  [
                    43401.1,
                    36503.7
                  ],
                  [
                    43447.4,
                    36036.6
                  ],
                  [
                    43333.4,
                    36026.9
                  ],
                  [
                    43147.9,
                    35884.5
                  ],
                  [
                    43080.9,
                    35419.8
                  ],
                  [
                    42926.6,
                    35501.3
                  ],
                  [
                    42879,
                    35649.7
                  ],
                  [
                    42814.3,
                    35685.7
                  ],
                  [
                    42724.2,
                    35838.6
                  ],
                  [
                    42733.8,
                    35967.2
                  ],
                  [
                    42967.7,
                    36014
                  ],
                  [
                    42952.9,
                    36100.3
                  ]
                ],
                "id": 101,
                "chat_link": "[&BGUAAAA=]"
              },
              "104": {
                "name": "Grenbrack Delves",
                "level": 4,
                "coord": [
                  43354.3,
                  35650.6
                ],
                "bounds": [
                  [
                    43333.8,
                    36026.2
                  ],
                  [
                    43447.4,
                    36034.3
                  ],
                  [
                    43545.9,
                    35927
                  ],
                  [
                    43522.9,
                    35772.8
                  ],
                  [
                    43498.4,
                    35589.1
                  ],
                  [
                    43421.5,
                    35585.6
                  ],
                  [
                    43384.1,
                    35453.6
                  ],
                  [
                    43390,
                    35403.3
                  ],
                  [
                    43374.7,
                    35404.7
                  ],
                  [
                    43106,
                    35302.1
                  ],
                  [
                    43080.9,
                    35423
                  ],
                  [
                    43145.9,
                    35885.3
                  ],
                  [
                    43333.8,
                    36026.2
                  ]
                ],
                "id": 104,
                "chat_link": "[&BGgAAAA=]"
              },
              "107": {
                "name": "Morgan's Spiral",
                "level": 6,
                "coord": [
                  43843.3,
                  35603.7
                ],
                "bounds": [
                  [
                    43522.3,
                    35772.5
                  ],
                  [
                    43499.2,
                    35583.8
                  ],
                  [
                    43657.1,
                    35592.8
                  ],
                  [
                    43695.8,
                    35578
                  ],
                  [
                    43744.9,
                    35347.5
                  ],
                  [
                    43915.9,
                    34997.7
                  ],
                  [
                    44008.3,
                    35077.1
                  ],
                  [
                    44024,
                    35220.7
                  ],
                  [
                    44207.6,
                    35407
                  ],
                  [
                    44245.3,
                    35733.8
                  ],
                  [
                    44165.7,
                    36094
                  ],
                  [
                    43958.6,
                    36135.6
                  ],
                  [
                    43614.5,
                    35984.3
                  ],
                  [
                    43546.8,
                    35926.7
                  ],
                  [
                    43522.3,
                    35772.5
                  ]
                ],
                "id": 107,
                "chat_link": "[&BGsAAAA=]"
              }
            },
            "adventures": [],
            "id": 521,
            "mastery_points": []
          },
          "522": {
            "name": "A Sly Trick",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 522,
            "mastery_points": []
          },
          "523": {
            "name": "Deep Tangled Roots",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {
              "1089": {
                "name": "Dolorous Vale",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42203.3,
                  35414.8
                ],
                "id": 1089,
                "chat_link": "[&BEEEAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "96": {
                "name": "Sandycove Beach",
                "level": 8,
                "coord": [
                  42648,
                  35243.4
                ],
                "bounds": [
                  [
                    42775.5,
                    35574.7
                  ],
                  [
                    43078.1,
                    35418.4
                  ],
                  [
                    43103.1,
                    35301.9
                  ],
                  [
                    43090.7,
                    35157.7
                  ],
                  [
                    42994.6,
                    35128.3
                  ],
                  [
                    42967.8,
                    35035.4
                  ],
                  [
                    42552,
                    34991.8
                  ],
                  [
                    42480.3,
                    34895.9
                  ],
                  [
                    42075.2,
                    35025
                  ],
                  [
                    42074.8,
                    35373.5
                  ],
                  [
                    42074.9,
                    35617.2
                  ],
                  [
                    42509,
                    35400.9
                  ],
                  [
                    42775.5,
                    35574.7
                  ]
                ],
                "id": 96,
                "chat_link": "[&BGAAAAA=]"
              },
              "111": {
                "name": "Ogham Wilds",
                "level": 7,
                "coord": [
                  42559.4,
                  36066.3
                ],
                "bounds": [
                  [
                    42507.5,
                    35402.7
                  ],
                  [
                    42772.1,
                    35575.4
                  ],
                  [
                    42772.2,
                    35576.1
                  ],
                  [
                    42925,
                    35499.9
                  ],
                  [
                    42876.5,
                    35647.1
                  ],
                  [
                    42811.6,
                    35685.8
                  ],
                  [
                    42719.4,
                    35840.1
                  ],
                  [
                    42732.1,
                    35969.4
                  ],
                  [
                    42727.8,
                    36011.7
                  ],
                  [
                    42774.2,
                    36040.1
                  ],
                  [
                    42761.9,
                    36057.3
                  ],
                  [
                    42609.8,
                    35979
                  ],
                  [
                    42540.8,
                    36024.6
                  ],
                  [
                    42518,
                    36073.1
                  ],
                  [
                    42506.5,
                    36178.1
                  ],
                  [
                    42534.6,
                    36251.2
                  ],
                  [
                    42477.3,
                    36740.6
                  ],
                  [
                    42451.9,
                    36782.7
                  ],
                  [
                    42381.7,
                    36793
                  ],
                  [
                    42150.4,
                    36742.1
                  ],
                  [
                    42146,
                    36573.3
                  ],
                  [
                    42094,
                    36464.9
                  ],
                  [
                    42074.1,
                    35617.5
                  ],
                  [
                    42507.5,
                    35402.7
                  ]
                ],
                "id": 111,
                "chat_link": "[&BG8AAAA=]"
              }
            },
            "adventures": [],
            "id": 523,
            "mastery_points": []
          },
          "524": {
            "name": "The Heart of Nightmare",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "111": {
                "name": "Ogham Wilds",
                "level": 7,
                "coord": [
                  42559.4,
                  36066.3
                ],
                "bounds": [
                  [
                    42507.5,
                    35402.7
                  ],
                  [
                    42772.1,
                    35575.4
                  ],
                  [
                    42772.2,
                    35576.1
                  ],
                  [
                    42925,
                    35499.9
                  ],
                  [
                    42876.5,
                    35647.1
                  ],
                  [
                    42811.6,
                    35685.8
                  ],
                  [
                    42719.4,
                    35840.1
                  ],
                  [
                    42732.1,
                    35969.4
                  ],
                  [
                    42727.8,
                    36011.7
                  ],
                  [
                    42774.2,
                    36040.1
                  ],
                  [
                    42761.9,
                    36057.3
                  ],
                  [
                    42609.8,
                    35979
                  ],
                  [
                    42540.8,
                    36024.6
                  ],
                  [
                    42518,
                    36073.1
                  ],
                  [
                    42506.5,
                    36178.1
                  ],
                  [
                    42534.6,
                    36251.2
                  ],
                  [
                    42477.3,
                    36740.6
                  ],
                  [
                    42451.9,
                    36782.7
                  ],
                  [
                    42381.7,
                    36793
                  ],
                  [
                    42150.4,
                    36742.1
                  ],
                  [
                    42146,
                    36573.3
                  ],
                  [
                    42094,
                    36464.9
                  ],
                  [
                    42074.1,
                    35617.5
                  ],
                  [
                    42507.5,
                    35402.7
                  ]
                ],
                "id": 111,
                "chat_link": "[&BG8AAAA=]"
              }
            },
            "adventures": [],
            "id": 524,
            "mastery_points": []
          },
          "525": {
            "name": "Beneath a Cold Moon",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "101": {
                "name": "The Verdence",
                "level": 3,
                "coord": [
                  43034,
                  35956.7
                ],
                "bounds": [
                  [
                    42952.9,
                    36100.3
                  ],
                  [
                    43046.8,
                    36263.8
                  ],
                  [
                    43020.4,
                    36502.3
                  ],
                  [
                    43401.1,
                    36503.7
                  ],
                  [
                    43447.4,
                    36036.6
                  ],
                  [
                    43333.4,
                    36026.9
                  ],
                  [
                    43147.9,
                    35884.5
                  ],
                  [
                    43080.9,
                    35419.8
                  ],
                  [
                    42926.6,
                    35501.3
                  ],
                  [
                    42879,
                    35649.7
                  ],
                  [
                    42814.3,
                    35685.7
                  ],
                  [
                    42724.2,
                    35838.6
                  ],
                  [
                    42733.8,
                    35967.2
                  ],
                  [
                    42967.7,
                    36014
                  ],
                  [
                    42952.9,
                    36100.3
                  ]
                ],
                "id": 101,
                "chat_link": "[&BGUAAAA=]"
              },
              "102": {
                "name": "Village of Astorea",
                "level": 2,
                "coord": [
                  42726.4,
                  36165.8
                ],
                "bounds": [
                  [
                    42733.3,
                    35970.5
                  ],
                  [
                    42729.5,
                    36009.1
                  ],
                  [
                    42777.3,
                    36039.4
                  ],
                  [
                    42766.9,
                    36058.8
                  ],
                  [
                    42613.8,
                    35967.6
                  ],
                  [
                    42537.2,
                    36016.6
                  ],
                  [
                    42514.4,
                    36065.1
                  ],
                  [
                    42503.5,
                    36174.5
                  ],
                  [
                    42531.3,
                    36245.4
                  ],
                  [
                    42499.9,
                    36517.1
                  ],
                  [
                    42705,
                    36551.3
                  ],
                  [
                    43019.2,
                    36497.1
                  ],
                  [
                    43045.4,
                    36261.7
                  ],
                  [
                    42952.3,
                    36098.4
                  ],
                  [
                    42967,
                    36014.4
                  ],
                  [
                    42733.3,
                    35970.5
                  ]
                ],
                "id": 102,
                "chat_link": "[&BGYAAAA=]"
              },
              "111": {
                "name": "Ogham Wilds",
                "level": 7,
                "coord": [
                  42559.4,
                  36066.3
                ],
                "bounds": [
                  [
                    42507.5,
                    35402.7
                  ],
                  [
                    42772.1,
                    35575.4
                  ],
                  [
                    42772.2,
                    35576.1
                  ],
                  [
                    42925,
                    35499.9
                  ],
                  [
                    42876.5,
                    35647.1
                  ],
                  [
                    42811.6,
                    35685.8
                  ],
                  [
                    42719.4,
                    35840.1
                  ],
                  [
                    42732.1,
                    35969.4
                  ],
                  [
                    42727.8,
                    36011.7
                  ],
                  [
                    42774.2,
                    36040.1
                  ],
                  [
                    42761.9,
                    36057.3
                  ],
                  [
                    42609.8,
                    35979
                  ],
                  [
                    42540.8,
                    36024.6
                  ],
                  [
                    42518,
                    36073.1
                  ],
                  [
                    42506.5,
                    36178.1
                  ],
                  [
                    42534.6,
                    36251.2
                  ],
                  [
                    42477.3,
                    36740.6
                  ],
                  [
                    42451.9,
                    36782.7
                  ],
                  [
                    42381.7,
                    36793
                  ],
                  [
                    42150.4,
                    36742.1
                  ],
                  [
                    42146,
                    36573.3
                  ],
                  [
                    42094,
                    36464.9
                  ],
                  [
                    42074.1,
                    35617.5
                  ],
                  [
                    42507.5,
                    35402.7
                  ]
                ],
                "id": 111,
                "chat_link": "[&BG8AAAA=]"
              }
            },
            "adventures": [],
            "id": 525,
            "mastery_points": []
          },
          "527": {
            "name": "The Knight's Duel",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "95": {
                "name": "Ventry Bay",
                "level": 10,
                "coord": [
                  42938.5,
                  34616.1
                ],
                "bounds": [
                  [
                    42104.4,
                    35018.8
                  ],
                  [
                    42480.4,
                    34896
                  ],
                  [
                    42552.5,
                    34994.3
                  ],
                  [
                    42967.8,
                    35033.9
                  ],
                  [
                    42924.9,
                    34896.8
                  ],
                  [
                    43147.8,
                    34812
                  ],
                  [
                    43460.3,
                    34971
                  ],
                  [
                    43919.5,
                    34726.9
                  ],
                  [
                    43910.2,
                    34235.8
                  ],
                  [
                    43635.6,
                    34211.3
                  ],
                  [
                    43615.6,
                    34226.3
                  ],
                  [
                    43436.5,
                    34221.2
                  ],
                  [
                    43264.7,
                    34312.9
                  ],
                  [
                    43074.8,
                    34649.6
                  ],
                  [
                    42867.4,
                    34664.8
                  ],
                  [
                    42788.3,
                    34541.6
                  ],
                  [
                    42689.8,
                    34547.8
                  ],
                  [
                    42404.3,
                    34374.9
                  ],
                  [
                    42288.6,
                    34440.2
                  ],
                  [
                    42112.6,
                    34425.6
                  ],
                  [
                    42061.9,
                    34736
                  ],
                  [
                    42104.4,
                    35018.8
                  ]
                ],
                "id": 95,
                "chat_link": "[&BF8AAAA=]"
              }
            },
            "adventures": [],
            "id": 527,
            "mastery_points": []
          },
          "528": {
            "name": "Hammer and Steel",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {
              "1089": {
                "name": "Dolorous Vale",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42203.3,
                  35414.8
                ],
                "id": 1089,
                "chat_link": "[&BEEEAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "96": {
                "name": "Sandycove Beach",
                "level": 8,
                "coord": [
                  42648,
                  35243.4
                ],
                "bounds": [
                  [
                    42775.5,
                    35574.7
                  ],
                  [
                    43078.1,
                    35418.4
                  ],
                  [
                    43103.1,
                    35301.9
                  ],
                  [
                    43090.7,
                    35157.7
                  ],
                  [
                    42994.6,
                    35128.3
                  ],
                  [
                    42967.8,
                    35035.4
                  ],
                  [
                    42552,
                    34991.8
                  ],
                  [
                    42480.3,
                    34895.9
                  ],
                  [
                    42075.2,
                    35025
                  ],
                  [
                    42074.8,
                    35373.5
                  ],
                  [
                    42074.9,
                    35617.2
                  ],
                  [
                    42509,
                    35400.9
                  ],
                  [
                    42775.5,
                    35574.7
                  ]
                ],
                "id": 96,
                "chat_link": "[&BGAAAAA=]"
              },
              "111": {
                "name": "Ogham Wilds",
                "level": 7,
                "coord": [
                  42559.4,
                  36066.3
                ],
                "bounds": [
                  [
                    42507.5,
                    35402.7
                  ],
                  [
                    42772.1,
                    35575.4
                  ],
                  [
                    42772.2,
                    35576.1
                  ],
                  [
                    42925,
                    35499.9
                  ],
                  [
                    42876.5,
                    35647.1
                  ],
                  [
                    42811.6,
                    35685.8
                  ],
                  [
                    42719.4,
                    35840.1
                  ],
                  [
                    42732.1,
                    35969.4
                  ],
                  [
                    42727.8,
                    36011.7
                  ],
                  [
                    42774.2,
                    36040.1
                  ],
                  [
                    42761.9,
                    36057.3
                  ],
                  [
                    42609.8,
                    35979
                  ],
                  [
                    42540.8,
                    36024.6
                  ],
                  [
                    42518,
                    36073.1
                  ],
                  [
                    42506.5,
                    36178.1
                  ],
                  [
                    42534.6,
                    36251.2
                  ],
                  [
                    42477.3,
                    36740.6
                  ],
                  [
                    42451.9,
                    36782.7
                  ],
                  [
                    42381.7,
                    36793
                  ],
                  [
                    42150.4,
                    36742.1
                  ],
                  [
                    42146,
                    36573.3
                  ],
                  [
                    42094,
                    36464.9
                  ],
                  [
                    42074.1,
                    35617.5
                  ],
                  [
                    42507.5,
                    35402.7
                  ]
                ],
                "id": 111,
                "chat_link": "[&BG8AAAA=]"
              }
            },
            "adventures": [],
            "id": 528,
            "mastery_points": []
          },
          "529": {
            "name": "Where Life Goes",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "108": {
                "name": "Wychmire Swamp",
                "level": 15,
                "coord": [
                  42487.1,
                  33167.9
                ],
                "bounds": [
                  [
                    42450.9,
                    33720.9
                  ],
                  [
                    42550.5,
                    33536.5
                  ],
                  [
                    42738.8,
                    33514.5
                  ],
                  [
                    42729.4,
                    33268.3
                  ],
                  [
                    42992.3,
                    33078
                  ],
                  [
                    42946.5,
                    32884.5
                  ],
                  [
                    42840.3,
                    32467.1
                  ],
                  [
                    42450.9,
                    32505.2
                  ],
                  [
                    42137.2,
                    32466.3
                  ],
                  [
                    42070.4,
                    32543.1
                  ],
                  [
                    42041.9,
                    33363.7
                  ],
                  [
                    42076.1,
                    33983.6
                  ],
                  [
                    42307.4,
                    33851.4
                  ],
                  [
                    42450.9,
                    33720.9
                  ]
                ],
                "id": 108,
                "chat_link": "[&BGwAAAA=]"
              }
            },
            "adventures": [],
            "id": 529,
            "mastery_points": []
          },
          "532": {
            "name": "After the Storm",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 532,
            "mastery_points": []
          },
          "533": {
            "name": "After the Storm",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "94": {
                "name": "Quetzal Bay",
                "level": 13,
                "coord": [
                  43648.8,
                  33347.9
                ],
                "bounds": [
                  [
                    43631.4,
                    34077
                  ],
                  [
                    43631.1,
                    34148.5
                  ],
                  [
                    43895.6,
                    34149.3
                  ],
                  [
                    43887.2,
                    33956.6
                  ],
                  [
                    43918.3,
                    33368.2
                  ],
                  [
                    44031.8,
                    32807.3
                  ],
                  [
                    43937.4,
                    32480
                  ],
                  [
                    43811.2,
                    32453.6
                  ],
                  [
                    43611.9,
                    32892.8
                  ],
                  [
                    43518.2,
                    33008.5
                  ],
                  [
                    43444.8,
                    33018.5
                  ],
                  [
                    43398.2,
                    33119.8
                  ],
                  [
                    43497.4,
                    33147.9
                  ],
                  [
                    43536.5,
                    33295.9
                  ],
                  [
                    43234.3,
                    33682.6
                  ],
                  [
                    43395,
                    33959.3
                  ],
                  [
                    43631.4,
                    34077
                  ]
                ],
                "id": 94,
                "chat_link": "[&BF4AAAA=]"
              },
              "97": {
                "name": "Treemarch Estuary",
                "level": 15,
                "coord": [
                  43290.3,
                  32843.3
                ],
                "bounds": [
                  [
                    43444.1,
                    33017.2
                  ],
                  [
                    43516.3,
                    33011.4
                  ],
                  [
                    43612.4,
                    32893.1
                  ],
                  [
                    43790.9,
                    32498.7
                  ],
                  [
                    43540.6,
                    32492.7
                  ],
                  [
                    43401.6,
                    32805.5
                  ],
                  [
                    43298.4,
                    32901.8
                  ],
                  [
                    43286.5,
                    32985.4
                  ],
                  [
                    43144.4,
                    32967.9
                  ],
                  [
                    43162.8,
                    32796.3
                  ],
                  [
                    43019.4,
                    32488.4
                  ],
                  [
                    42836.5,
                    32485.4
                  ],
                  [
                    42946,
                    32884.8
                  ],
                  [
                    42990.6,
                    33076.4
                  ],
                  [
                    43255.9,
                    33071.1
                  ],
                  [
                    43398.3,
                    33117.3
                  ],
                  [
                    43444.1,
                    33017.2
                  ]
                ],
                "id": 97,
                "chat_link": "[&BGEAAAA=]"
              },
              "103": {
                "name": "Willowalk Groves",
                "level": 14,
                "coord": [
                  43125.2,
                  33323.4
                ],
                "bounds": [
                  [
                    42728.4,
                    33266.2
                  ],
                  [
                    42991.1,
                    33076.1
                  ],
                  [
                    43256.6,
                    33070.7
                  ],
                  [
                    43497,
                    33147.6
                  ],
                  [
                    43536.6,
                    33296
                  ],
                  [
                    43233.9,
                    33682.2
                  ],
                  [
                    43018.5,
                    33537.5
                  ],
                  [
                    42739.3,
                    33511.3
                  ],
                  [
                    42728.4,
                    33266.2
                  ]
                ],
                "id": 103,
                "chat_link": "[&BGcAAAA=]"
              }
            },
            "adventures": [],
            "id": 533,
            "mastery_points": []
          },
          "534": {
            "name": "Beneath the Waves",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {
              "114": {
                "name": "Slaver's Deeps",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43826.8,
                  32933.3
                ],
                "id": 114,
                "chat_link": "[&BHIAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "94": {
                "name": "Quetzal Bay",
                "level": 13,
                "coord": [
                  43648.8,
                  33347.9
                ],
                "bounds": [
                  [
                    43631.4,
                    34077
                  ],
                  [
                    43631.1,
                    34148.5
                  ],
                  [
                    43895.6,
                    34149.3
                  ],
                  [
                    43887.2,
                    33956.6
                  ],
                  [
                    43918.3,
                    33368.2
                  ],
                  [
                    44031.8,
                    32807.3
                  ],
                  [
                    43937.4,
                    32480
                  ],
                  [
                    43811.2,
                    32453.6
                  ],
                  [
                    43611.9,
                    32892.8
                  ],
                  [
                    43518.2,
                    33008.5
                  ],
                  [
                    43444.8,
                    33018.5
                  ],
                  [
                    43398.2,
                    33119.8
                  ],
                  [
                    43497.4,
                    33147.9
                  ],
                  [
                    43536.5,
                    33295.9
                  ],
                  [
                    43234.3,
                    33682.6
                  ],
                  [
                    43395,
                    33959.3
                  ],
                  [
                    43631.4,
                    34077
                  ]
                ],
                "id": 94,
                "chat_link": "[&BF4AAAA=]"
              },
              "97": {
                "name": "Treemarch Estuary",
                "level": 15,
                "coord": [
                  43290.3,
                  32843.3
                ],
                "bounds": [
                  [
                    43444.1,
                    33017.2
                  ],
                  [
                    43516.3,
                    33011.4
                  ],
                  [
                    43612.4,
                    32893.1
                  ],
                  [
                    43790.9,
                    32498.7
                  ],
                  [
                    43540.6,
                    32492.7
                  ],
                  [
                    43401.6,
                    32805.5
                  ],
                  [
                    43298.4,
                    32901.8
                  ],
                  [
                    43286.5,
                    32985.4
                  ],
                  [
                    43144.4,
                    32967.9
                  ],
                  [
                    43162.8,
                    32796.3
                  ],
                  [
                    43019.4,
                    32488.4
                  ],
                  [
                    42836.5,
                    32485.4
                  ],
                  [
                    42946,
                    32884.8
                  ],
                  [
                    42990.6,
                    33076.4
                  ],
                  [
                    43255.9,
                    33071.1
                  ],
                  [
                    43398.3,
                    33117.3
                  ],
                  [
                    43444.1,
                    33017.2
                  ]
                ],
                "id": 97,
                "chat_link": "[&BGEAAAA=]"
              }
            },
            "adventures": [],
            "id": 534,
            "mastery_points": []
          },
          "535": {
            "name": "Mirror, Mirror",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "134": {
                "name": "Zinder Slope",
                "level": 16,
                "coord": [
                  41789.3,
                  32735.5
                ],
                "bounds": [
                  [
                    41832.8,
                    32837
                  ],
                  [
                    42135.3,
                    32772.7
                  ],
                  [
                    42165.5,
                    32560
                  ],
                  [
                    42113.4,
                    32491.5
                  ],
                  [
                    41964.7,
                    32560.6
                  ],
                  [
                    41619.9,
                    32557.8
                  ],
                  [
                    41512.3,
                    32782.1
                  ],
                  [
                    41268.9,
                    32845.5
                  ],
                  [
                    41490.9,
                    33212.4
                  ],
                  [
                    41832.8,
                    32837
                  ]
                ],
                "id": 134,
                "chat_link": "[&BIYAAAA=]"
              },
              "138": {
                "name": "Skrittsburgh Hillstead",
                "level": 18,
                "coord": [
                  41378.6,
                  32443.8
                ],
                "bounds": [
                  [
                    41444,
                    32159.3
                  ],
                  [
                    41216.8,
                    32132.9
                  ],
                  [
                    41060.8,
                    32304.5
                  ],
                  [
                    41290.1,
                    32570.5
                  ],
                  [
                    41355.1,
                    32837
                  ],
                  [
                    41514.4,
                    32782.2
                  ],
                  [
                    41623.8,
                    32559.6
                  ],
                  [
                    41523.7,
                    32204.6
                  ],
                  [
                    41444,
                    32159.3
                  ]
                ],
                "id": 138,
                "chat_link": "[&BIoAAAA=]"
              }
            },
            "adventures": [],
            "id": 535,
            "mastery_points": []
          },
          "536": {
            "name": "A Vision of Darkness",
            "min_level": 20,
            "max_level": 20,
            "default_floor": -16,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -33792,
                -24576
              ],
              [
                33792,
                24576
              ]
            ],
            "continent_rect": [
              [
                41088,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 536,
            "mastery_points": []
          },
          "537": {
            "name": "Shattered Light",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {
              "102": {
                "name": "Aethervolt Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41102.5,
                  33325.6
                ],
                "id": 102,
                "chat_link": "[&BGYAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "133": {
                "name": "Venlin Vale",
                "level": 16,
                "coord": [
                  40883.2,
                  33161.9
                ],
                "bounds": [
                  [
                    40781.7,
                    32620.8
                  ],
                  [
                    40926.1,
                    32757.6
                  ],
                  [
                    41194.4,
                    32858.9
                  ],
                  [
                    41273.5,
                    32847.7
                  ],
                  [
                    41642.7,
                    33432.2
                  ],
                  [
                    41606.8,
                    33552.3
                  ],
                  [
                    41152.7,
                    33576.8
                  ],
                  [
                    40807.1,
                    33535.1
                  ],
                  [
                    40766.1,
                    33570.1
                  ],
                  [
                    40390.1,
                    33538
                  ],
                  [
                    40387.6,
                    33339
                  ],
                  [
                    40550.8,
                    32978.2
                  ],
                  [
                    40485.6,
                    32940.4
                  ],
                  [
                    40399.6,
                    32719.8
                  ],
                  [
                    40781.7,
                    32620.8
                  ]
                ],
                "id": 133,
                "chat_link": "[&BIUAAAA=]"
              }
            },
            "adventures": [],
            "id": 537,
            "mastery_points": []
          },
          "538": {
            "name": "An Unknown Soul",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {
              "77": {
                "name": "Joy's End",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41938,
                  32967.1
                ],
                "id": 77,
                "chat_link": "[&BE0AAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "129": {
                "name": "Karston Chambers",
                "level": 17,
                "coord": [
                  41884,
                  33223.8
                ],
                "bounds": [
                  [
                    42178.2,
                    33347.1
                  ],
                  [
                    42114.5,
                    33092.8
                  ],
                  [
                    42135.2,
                    32770.7
                  ],
                  [
                    41828,
                    32836.9
                  ],
                  [
                    41481.6,
                    33207.6
                  ],
                  [
                    41644.1,
                    33442.8
                  ],
                  [
                    41606.3,
                    33550.6
                  ],
                  [
                    42084,
                    33541.7
                  ],
                  [
                    42178.2,
                    33347.1
                  ]
                ],
                "id": 129,
                "chat_link": "[&BIEAAAA=]"
              }
            },
            "adventures": [],
            "id": 538,
            "mastery_points": []
          },
          "539": {
            "name": "An Unknown Soul",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 539,
            "mastery_points": []
          },
          "540": {
            "name": "Where Life Goes",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 540,
            "mastery_points": []
          },
          "542": {
            "name": "Source of the Issue",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "131": {
                "name": "Gotala Cascade",
                "level": 23,
                "coord": [
                  40476,
                  32400.7
                ],
                "bounds": [
                  [
                    40541.2,
                    31974.3
                  ],
                  [
                    40338.3,
                    32191.9
                  ],
                  [
                    40162.7,
                    32607.3
                  ],
                  [
                    40400.4,
                    32723.7
                  ],
                  [
                    40781.8,
                    32622.1
                  ],
                  [
                    40631.9,
                    32284.9
                  ],
                  [
                    40541.2,
                    31974.3
                  ]
                ],
                "id": 131,
                "chat_link": "[&BIMAAAA=]"
              },
              "133": {
                "name": "Venlin Vale",
                "level": 16,
                "coord": [
                  40883.2,
                  33161.9
                ],
                "bounds": [
                  [
                    40781.7,
                    32620.8
                  ],
                  [
                    40926.1,
                    32757.6
                  ],
                  [
                    41194.4,
                    32858.9
                  ],
                  [
                    41273.5,
                    32847.7
                  ],
                  [
                    41642.7,
                    33432.2
                  ],
                  [
                    41606.8,
                    33552.3
                  ],
                  [
                    41152.7,
                    33576.8
                  ],
                  [
                    40807.1,
                    33535.1
                  ],
                  [
                    40766.1,
                    33570.1
                  ],
                  [
                    40390.1,
                    33538
                  ],
                  [
                    40387.6,
                    33339
                  ],
                  [
                    40550.8,
                    32978.2
                  ],
                  [
                    40485.6,
                    32940.4
                  ],
                  [
                    40399.6,
                    32719.8
                  ],
                  [
                    40781.7,
                    32620.8
                  ]
                ],
                "id": 133,
                "chat_link": "[&BIUAAAA=]"
              }
            },
            "adventures": [],
            "id": 542,
            "mastery_points": []
          },
          "543": {
            "name": "Wild Growth",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 543,
            "mastery_points": []
          },
          "544": {
            "name": "Wild Growth",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "106": {
                "name": "The Rootangles",
                "level": 11,
                "coord": [
                  42898.1,
                  34310.3
                ],
                "bounds": [
                  [
                    42788.3,
                    34539.6
                  ],
                  [
                    42885.8,
                    34450.5
                  ],
                  [
                    43073,
                    34414.1
                  ],
                  [
                    43174.2,
                    34482.5
                  ],
                  [
                    43264.9,
                    34312.7
                  ],
                  [
                    43145.7,
                    33902.8
                  ],
                  [
                    43017.3,
                    33916.6
                  ],
                  [
                    43012.8,
                    34232.2
                  ],
                  [
                    42820.7,
                    34330.3
                  ],
                  [
                    42508.8,
                    34220.7
                  ],
                  [
                    42399.2,
                    34374
                  ],
                  [
                    42687.2,
                    34548.3
                  ],
                  [
                    42788.3,
                    34539.6
                  ]
                ],
                "id": 106,
                "chat_link": "[&BGoAAAA=]"
              },
              "109": {
                "name": "Ruins of the Unseen",
                "level": 11,
                "coord": [
                  42787.5,
                  34121
                ],
                "bounds": [
                  [
                    42820.5,
                    34331.3
                  ],
                  [
                    42508.3,
                    34220.4
                  ],
                  [
                    42609.4,
                    34077.5
                  ],
                  [
                    42759.1,
                    33948.5
                  ],
                  [
                    43014.8,
                    33915.7
                  ],
                  [
                    43013,
                    34232.7
                  ],
                  [
                    42820.5,
                    34331.3
                  ]
                ],
                "id": 109,
                "chat_link": "[&BG0AAAA=]"
              }
            },
            "adventures": [],
            "id": 544,
            "mastery_points": []
          },
          "545": {
            "name": "Seeking the Zalisco",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {
              "111": {
                "name": "Hanto Trading Post",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43131.8,
                  33728.3
                ],
                "id": 111,
                "chat_link": "[&BG8AAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "105": {
                "name": "Trader's Green",
                "level": 12,
                "coord": [
                  42589.1,
                  33922.8
                ],
                "bounds": [
                  [
                    42281.7,
                    34451.8
                  ],
                  [
                    42074.4,
                    34419.6
                  ],
                  [
                    42079.1,
                    33979.1
                  ],
                  [
                    42306.2,
                    33851.2
                  ],
                  [
                    42449.8,
                    33720.2
                  ],
                  [
                    42550.4,
                    33535.3
                  ],
                  [
                    42739.2,
                    33513.4
                  ],
                  [
                    43019.6,
                    33537.1
                  ],
                  [
                    43234.5,
                    33681.5
                  ],
                  [
                    43147.7,
                    33905.3
                  ],
                  [
                    42762,
                    33949.4
                  ],
                  [
                    42609.1,
                    34079.5
                  ],
                  [
                    42404.7,
                    34373.1
                  ],
                  [
                    42281.7,
                    34451.8
                  ]
                ],
                "id": 105,
                "chat_link": "[&BGkAAAA=]"
              }
            },
            "adventures": [],
            "id": 545,
            "mastery_points": []
          },
          "546": {
            "name": "The Direct Approach",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {
              "116": {
                "name": "Dengatl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  42316.5,
                  33711.8
                ],
                "id": 116,
                "chat_link": "[&BHQAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "108": {
                "name": "Wychmire Swamp",
                "level": 15,
                "coord": [
                  42487.1,
                  33167.9
                ],
                "bounds": [
                  [
                    42450.9,
                    33720.9
                  ],
                  [
                    42550.5,
                    33536.5
                  ],
                  [
                    42738.8,
                    33514.5
                  ],
                  [
                    42729.4,
                    33268.3
                  ],
                  [
                    42992.3,
                    33078
                  ],
                  [
                    42946.5,
                    32884.5
                  ],
                  [
                    42840.3,
                    32467.1
                  ],
                  [
                    42450.9,
                    32505.2
                  ],
                  [
                    42137.2,
                    32466.3
                  ],
                  [
                    42070.4,
                    32543.1
                  ],
                  [
                    42041.9,
                    33363.7
                  ],
                  [
                    42076.1,
                    33983.6
                  ],
                  [
                    42307.4,
                    33851.4
                  ],
                  [
                    42450.9,
                    33720.9
                  ]
                ],
                "id": 108,
                "chat_link": "[&BGwAAAA=]"
              }
            },
            "adventures": [],
            "id": 546,
            "mastery_points": []
          },
          "547": {
            "name": "Trading Trickery",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "108": {
                "name": "Wychmire Swamp",
                "level": 15,
                "coord": [
                  42487.1,
                  33167.9
                ],
                "bounds": [
                  [
                    42450.9,
                    33720.9
                  ],
                  [
                    42550.5,
                    33536.5
                  ],
                  [
                    42738.8,
                    33514.5
                  ],
                  [
                    42729.4,
                    33268.3
                  ],
                  [
                    42992.3,
                    33078
                  ],
                  [
                    42946.5,
                    32884.5
                  ],
                  [
                    42840.3,
                    32467.1
                  ],
                  [
                    42450.9,
                    32505.2
                  ],
                  [
                    42137.2,
                    32466.3
                  ],
                  [
                    42070.4,
                    32543.1
                  ],
                  [
                    42041.9,
                    33363.7
                  ],
                  [
                    42076.1,
                    33983.6
                  ],
                  [
                    42307.4,
                    33851.4
                  ],
                  [
                    42450.9,
                    33720.9
                  ]
                ],
                "id": 108,
                "chat_link": "[&BGwAAAA=]"
              }
            },
            "adventures": [],
            "id": 547,
            "mastery_points": []
          },
          "548": {
            "name": "Eye of the Sun",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 548,
            "mastery_points": []
          },
          "552": {
            "name": "Seeking the Zalisco",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 552,
            "mastery_points": []
          },
          "556": {
            "name": "A Different Dream",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "133": {
                "name": "Venlin Vale",
                "level": 16,
                "coord": [
                  40883.2,
                  33161.9
                ],
                "bounds": [
                  [
                    40781.7,
                    32620.8
                  ],
                  [
                    40926.1,
                    32757.6
                  ],
                  [
                    41194.4,
                    32858.9
                  ],
                  [
                    41273.5,
                    32847.7
                  ],
                  [
                    41642.7,
                    33432.2
                  ],
                  [
                    41606.8,
                    33552.3
                  ],
                  [
                    41152.7,
                    33576.8
                  ],
                  [
                    40807.1,
                    33535.1
                  ],
                  [
                    40766.1,
                    33570.1
                  ],
                  [
                    40390.1,
                    33538
                  ],
                  [
                    40387.6,
                    33339
                  ],
                  [
                    40550.8,
                    32978.2
                  ],
                  [
                    40485.6,
                    32940.4
                  ],
                  [
                    40399.6,
                    32719.8
                  ],
                  [
                    40781.7,
                    32620.8
                  ]
                ],
                "id": 133,
                "chat_link": "[&BIUAAAA=]"
              },
              "134": {
                "name": "Zinder Slope",
                "level": 16,
                "coord": [
                  41789.3,
                  32735.5
                ],
                "bounds": [
                  [
                    41832.8,
                    32837
                  ],
                  [
                    42135.3,
                    32772.7
                  ],
                  [
                    42165.5,
                    32560
                  ],
                  [
                    42113.4,
                    32491.5
                  ],
                  [
                    41964.7,
                    32560.6
                  ],
                  [
                    41619.9,
                    32557.8
                  ],
                  [
                    41512.3,
                    32782.1
                  ],
                  [
                    41268.9,
                    32845.5
                  ],
                  [
                    41490.9,
                    33212.4
                  ],
                  [
                    41832.8,
                    32837
                  ]
                ],
                "id": 134,
                "chat_link": "[&BIYAAAA=]"
              },
              "138": {
                "name": "Skrittsburgh Hillstead",
                "level": 18,
                "coord": [
                  41378.6,
                  32443.8
                ],
                "bounds": [
                  [
                    41444,
                    32159.3
                  ],
                  [
                    41216.8,
                    32132.9
                  ],
                  [
                    41060.8,
                    32304.5
                  ],
                  [
                    41290.1,
                    32570.5
                  ],
                  [
                    41355.1,
                    32837
                  ],
                  [
                    41514.4,
                    32782.2
                  ],
                  [
                    41623.8,
                    32559.6
                  ],
                  [
                    41523.7,
                    32204.6
                  ],
                  [
                    41444,
                    32159.3
                  ]
                ],
                "id": 138,
                "chat_link": "[&BIoAAAA=]"
              },
              "143": {
                "name": "Nemeton Grove",
                "level": 17,
                "coord": [
                  41798,
                  32117.7
                ],
                "bounds": [
                  [
                    42113.4,
                    32492.5
                  ],
                  [
                    41965.3,
                    32569.8
                  ],
                  [
                    41621.3,
                    32560.5
                  ],
                  [
                    41525.8,
                    32203.1
                  ],
                  [
                    41443,
                    32158.7
                  ],
                  [
                    41478.2,
                    31968.9
                  ],
                  [
                    41625.6,
                    31880.9
                  ],
                  [
                    41891,
                    31666.3
                  ],
                  [
                    42193.6,
                    31618.9
                  ],
                  [
                    42123.1,
                    32057.6
                  ],
                  [
                    42113.4,
                    32492.5
                  ]
                ],
                "id": 143,
                "chat_link": "[&BI8AAAA=]"
              }
            },
            "adventures": [],
            "id": 556,
            "mastery_points": []
          },
          "557": {
            "name": "A Splinter in the Flesh",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 557,
            "mastery_points": []
          },
          "558": {
            "name": "Shadow of the Tree",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "134": {
                "name": "Zinder Slope",
                "level": 16,
                "coord": [
                  41789.3,
                  32735.5
                ],
                "bounds": [
                  [
                    41832.8,
                    32837
                  ],
                  [
                    42135.3,
                    32772.7
                  ],
                  [
                    42165.5,
                    32560
                  ],
                  [
                    42113.4,
                    32491.5
                  ],
                  [
                    41964.7,
                    32560.6
                  ],
                  [
                    41619.9,
                    32557.8
                  ],
                  [
                    41512.3,
                    32782.1
                  ],
                  [
                    41268.9,
                    32845.5
                  ],
                  [
                    41490.9,
                    33212.4
                  ],
                  [
                    41832.8,
                    32837
                  ]
                ],
                "id": 134,
                "chat_link": "[&BIYAAAA=]"
              },
              "143": {
                "name": "Nemeton Grove",
                "level": 17,
                "coord": [
                  41798,
                  32117.7
                ],
                "bounds": [
                  [
                    42113.4,
                    32492.5
                  ],
                  [
                    41965.3,
                    32569.8
                  ],
                  [
                    41621.3,
                    32560.5
                  ],
                  [
                    41525.8,
                    32203.1
                  ],
                  [
                    41443,
                    32158.7
                  ],
                  [
                    41478.2,
                    31968.9
                  ],
                  [
                    41625.6,
                    31880.9
                  ],
                  [
                    41891,
                    31666.3
                  ],
                  [
                    42193.6,
                    31618.9
                  ],
                  [
                    42123.1,
                    32057.6
                  ],
                  [
                    42113.4,
                    32492.5
                  ]
                ],
                "id": 143,
                "chat_link": "[&BI8AAAA=]"
              }
            },
            "adventures": [],
            "id": 558,
            "mastery_points": []
          },
          "559": {
            "name": "Eye of the Sun",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "131": {
                "name": "Gotala Cascade",
                "level": 23,
                "coord": [
                  40476,
                  32400.7
                ],
                "bounds": [
                  [
                    40541.2,
                    31974.3
                  ],
                  [
                    40338.3,
                    32191.9
                  ],
                  [
                    40162.7,
                    32607.3
                  ],
                  [
                    40400.4,
                    32723.7
                  ],
                  [
                    40781.8,
                    32622.1
                  ],
                  [
                    40631.9,
                    32284.9
                  ],
                  [
                    40541.2,
                    31974.3
                  ]
                ],
                "id": 131,
                "chat_link": "[&BIMAAAA=]"
              },
              "133": {
                "name": "Venlin Vale",
                "level": 16,
                "coord": [
                  40883.2,
                  33161.9
                ],
                "bounds": [
                  [
                    40781.7,
                    32620.8
                  ],
                  [
                    40926.1,
                    32757.6
                  ],
                  [
                    41194.4,
                    32858.9
                  ],
                  [
                    41273.5,
                    32847.7
                  ],
                  [
                    41642.7,
                    33432.2
                  ],
                  [
                    41606.8,
                    33552.3
                  ],
                  [
                    41152.7,
                    33576.8
                  ],
                  [
                    40807.1,
                    33535.1
                  ],
                  [
                    40766.1,
                    33570.1
                  ],
                  [
                    40390.1,
                    33538
                  ],
                  [
                    40387.6,
                    33339
                  ],
                  [
                    40550.8,
                    32978.2
                  ],
                  [
                    40485.6,
                    32940.4
                  ],
                  [
                    40399.6,
                    32719.8
                  ],
                  [
                    40781.7,
                    32620.8
                  ]
                ],
                "id": 133,
                "chat_link": "[&BIUAAAA=]"
              }
            },
            "adventures": [],
            "id": 559,
            "mastery_points": []
          },
          "560": {
            "name": "Sharpened Thorns",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "87": {
                "name": "Alakess Ledge",
                "level": 22,
                "coord": [
                  44238.9,
                  32351
                ],
                "bounds": [
                  [
                    44072,
                    32411.1
                  ],
                  [
                    43900.6,
                    32563.4
                  ],
                  [
                    43691,
                    32518.7
                  ],
                  [
                    43806.4,
                    32260.6
                  ],
                  [
                    44454.4,
                    32261.2
                  ],
                  [
                    44615,
                    32125.8
                  ],
                  [
                    44716.5,
                    32296
                  ],
                  [
                    44655.6,
                    32371.1
                  ],
                  [
                    44072,
                    32411.1
                  ]
                ],
                "id": 87,
                "chat_link": "[&BFcAAAA=]"
              },
              "89": {
                "name": "Giant's Passage",
                "level": 20,
                "coord": [
                  44831.6,
                  31740.4
                ],
                "bounds": [
                  [
                    44714.3,
                    32296.6
                  ],
                  [
                    44616.2,
                    32125.7
                  ],
                  [
                    44702,
                    31929.7
                  ],
                  [
                    44599.1,
                    31793.8
                  ],
                  [
                    44628.5,
                    31586.7
                  ],
                  [
                    44753.7,
                    31476.6
                  ],
                  [
                    44881.5,
                    31493.4
                  ],
                  [
                    44969.9,
                    31389.8
                  ],
                  [
                    45232.5,
                    31574.2
                  ],
                  [
                    45218.6,
                    31737.5
                  ],
                  [
                    44714.3,
                    32296.6
                  ]
                ],
                "id": 89,
                "chat_link": "[&BFkAAAA=]"
              },
              "91": {
                "name": "Dominion Killing Zone",
                "level": 21,
                "coord": [
                  45098.7,
                  32221.2
                ],
                "bounds": [
                  [
                    45370,
                    31826.5
                  ],
                  [
                    45212.9,
                    31734.5
                  ],
                  [
                    44644.6,
                    32351.7
                  ],
                  [
                    44725.4,
                    32472
                  ],
                  [
                    44877.5,
                    32402.3
                  ],
                  [
                    45350.7,
                    32449.7
                  ],
                  [
                    45381.3,
                    32388
                  ],
                  [
                    45227.2,
                    32145
                  ],
                  [
                    45370,
                    31826.5
                  ]
                ],
                "id": 91,
                "chat_link": "[&BFsAAAA=]"
              }
            },
            "adventures": [],
            "id": 560,
            "mastery_points": []
          },
          "561": {
            "name": "Bramble Walls",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "89": {
                "name": "Giant's Passage",
                "level": 20,
                "coord": [
                  44831.6,
                  31740.4
                ],
                "bounds": [
                  [
                    44714.3,
                    32296.6
                  ],
                  [
                    44616.2,
                    32125.7
                  ],
                  [
                    44702,
                    31929.7
                  ],
                  [
                    44599.1,
                    31793.8
                  ],
                  [
                    44628.5,
                    31586.7
                  ],
                  [
                    44753.7,
                    31476.6
                  ],
                  [
                    44881.5,
                    31493.4
                  ],
                  [
                    44969.9,
                    31389.8
                  ],
                  [
                    45232.5,
                    31574.2
                  ],
                  [
                    45218.6,
                    31737.5
                  ],
                  [
                    44714.3,
                    32296.6
                  ]
                ],
                "id": 89,
                "chat_link": "[&BFkAAAA=]"
              },
              "91": {
                "name": "Dominion Killing Zone",
                "level": 21,
                "coord": [
                  45098.7,
                  32221.2
                ],
                "bounds": [
                  [
                    45370,
                    31826.5
                  ],
                  [
                    45212.9,
                    31734.5
                  ],
                  [
                    44644.6,
                    32351.7
                  ],
                  [
                    44725.4,
                    32472
                  ],
                  [
                    44877.5,
                    32402.3
                  ],
                  [
                    45350.7,
                    32449.7
                  ],
                  [
                    45381.3,
                    32388
                  ],
                  [
                    45227.2,
                    32145
                  ],
                  [
                    45370,
                    31826.5
                  ]
                ],
                "id": 91,
                "chat_link": "[&BFsAAAA=]"
              }
            },
            "adventures": [],
            "id": 561,
            "mastery_points": []
          },
          "563": {
            "name": "Secrets in the Earth",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "90": {
                "name": "Lychcroft Mere",
                "level": 22,
                "coord": [
                  42655.4,
                  32220.9
                ],
                "bounds": [
                  [
                    43382.8,
                    32519.4
                  ],
                  [
                    42159.2,
                    32552.1
                  ],
                  [
                    42055.5,
                    32447.9
                  ],
                  [
                    42000.3,
                    31986.5
                  ],
                  [
                    42048.6,
                    31873.9
                  ],
                  [
                    42471,
                    32113
                  ],
                  [
                    42754.3,
                    32173.8
                  ],
                  [
                    43006.3,
                    32028.3
                  ],
                  [
                    43258.1,
                    32135.6
                  ],
                  [
                    43418.3,
                    32378.6
                  ],
                  [
                    43382.8,
                    32519.4
                  ]
                ],
                "id": 90,
                "chat_link": "[&BFoAAAA=]"
              }
            },
            "adventures": [],
            "id": 563,
            "mastery_points": []
          },
          "564": {
            "name": "The Blossom of Youth",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {
              "88": {
                "name": "Robbari's Bandits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  39260.5,
                  31843.3
                ],
                "id": 88,
                "chat_link": "[&BFgAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "124": {
                "name": "Highwayman's Vale",
                "level": 23,
                "coord": [
                  39560.4,
                  32117.4
                ],
                "bounds": [
                  [
                    39656.3,
                    32494.1
                  ],
                  [
                    39928.8,
                    32273.8
                  ],
                  [
                    39760,
                    32046
                  ],
                  [
                    39787.9,
                    31767.4
                  ],
                  [
                    39584.3,
                    31679.8
                  ],
                  [
                    39301,
                    31904.6
                  ],
                  [
                    39413.4,
                    32081.3
                  ],
                  [
                    39386.1,
                    32281.3
                  ],
                  [
                    39226.2,
                    32528.5
                  ],
                  [
                    39656.3,
                    32494.1
                  ]
                ],
                "id": 124,
                "chat_link": "[&BHwAAAA=]"
              },
              "126": {
                "name": "The Gallowfields",
                "level": 23,
                "coord": [
                  39135.6,
                  31439.6
                ],
                "bounds": [
                  [
                    38922.3,
                    31851.6
                  ],
                  [
                    38850.2,
                    31737.3
                  ],
                  [
                    38897.9,
                    31525.8
                  ],
                  [
                    39002.7,
                    31332.3
                  ],
                  [
                    38991,
                    31071.2
                  ],
                  [
                    39102.5,
                    31037.3
                  ],
                  [
                    39208.5,
                    31118.6
                  ],
                  [
                    39196.3,
                    31236.6
                  ],
                  [
                    39432.6,
                    31339.8
                  ],
                  [
                    39586,
                    31678.6
                  ],
                  [
                    39302.1,
                    31906.3
                  ],
                  [
                    38922.3,
                    31851.6
                  ]
                ],
                "id": 126,
                "chat_link": "[&BH4AAAA=]"
              }
            },
            "adventures": [],
            "id": 564,
            "mastery_points": []
          },
          "566": {
            "name": "The Bad Apple",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 566,
            "mastery_points": []
          },
          "567": {
            "name": "Trouble at the Roots",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "246": {
                "name": "Guardian's Pass",
                "level": 27,
                "coord": [
                  46453.5,
                  29264.3
                ],
                "bounds": [
                  [
                    46675.1,
                    29614.1
                  ],
                  [
                    46774.2,
                    29596.3
                  ],
                  [
                    46795.7,
                    29506.6
                  ],
                  [
                    46783.9,
                    29191.9
                  ],
                  [
                    46384.9,
                    29005.9
                  ],
                  [
                    46193,
                    28872.1
                  ],
                  [
                    46124.4,
                    29127.8
                  ],
                  [
                    46171.8,
                    29228.7
                  ],
                  [
                    46281.5,
                    29222.9
                  ],
                  [
                    46350.5,
                    29277
                  ],
                  [
                    46675.1,
                    29614.1
                  ]
                ],
                "id": 246,
                "chat_link": "[&BPYAAAA=]"
              },
              "247": {
                "name": "Hezran Outcrops",
                "level": 28,
                "coord": [
                  46506.3,
                  28824.9
                ],
                "bounds": [
                  [
                    46193.7,
                    28871.5
                  ],
                  [
                    46159.2,
                    28727.9
                  ],
                  [
                    46237.5,
                    28633.4
                  ],
                  [
                    46518.6,
                    28603.7
                  ],
                  [
                    46826.6,
                    28664.2
                  ],
                  [
                    46947.2,
                    28900.2
                  ],
                  [
                    46782.9,
                    29192.2
                  ],
                  [
                    46385,
                    29006.3
                  ],
                  [
                    46193.7,
                    28871.5
                  ]
                ],
                "id": 247,
                "chat_link": "[&BPcAAAA=]"
              }
            },
            "adventures": [],
            "id": 567,
            "mastery_points": []
          },
          "569": {
            "name": "Flower of Death",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "253": {
                "name": "Lionbridge Expanse",
                "level": 28,
                "coord": [
                  47455,
                  30117.2
                ],
                "bounds": [
                  [
                    47210.2,
                    30156
                  ],
                  [
                    47439.8,
                    30250.6
                  ],
                  [
                    47568.1,
                    30567.4
                  ],
                  [
                    47622.7,
                    30622.7
                  ],
                  [
                    47657.1,
                    30619.4
                  ],
                  [
                    47688.2,
                    30427.9
                  ],
                  [
                    47648.5,
                    30314.4
                  ],
                  [
                    47610.8,
                    30268.5
                  ],
                  [
                    47749.3,
                    30107.3
                  ],
                  [
                    47484.5,
                    30002.3
                  ],
                  [
                    47437.9,
                    29901.9
                  ],
                  [
                    47498.1,
                    29865.6
                  ],
                  [
                    47507.2,
                    29648.5
                  ],
                  [
                    47421,
                    29651.6
                  ],
                  [
                    47218.8,
                    29705.2
                  ],
                  [
                    47097.1,
                    29869.5
                  ],
                  [
                    47162.2,
                    29974.8
                  ],
                  [
                    47167.9,
                    30155.4
                  ],
                  [
                    47210.2,
                    30156
                  ]
                ],
                "id": 253,
                "chat_link": "[&BP0AAAA=]"
              },
              "254": {
                "name": "Ascalon Settlement",
                "level": 29,
                "coord": [
                  47646.4,
                  29767.7
                ],
                "bounds": [
                  [
                    47433,
                    29560.1
                  ],
                  [
                    47511.6,
                    29555.3
                  ],
                  [
                    47734.5,
                    29389.3
                  ],
                  [
                    48037.4,
                    29607.7
                  ],
                  [
                    48012.3,
                    29900
                  ],
                  [
                    47926.5,
                    30024
                  ],
                  [
                    47748.2,
                    30108.4
                  ],
                  [
                    47485.3,
                    30001
                  ],
                  [
                    47439,
                    29900.8
                  ],
                  [
                    47499,
                    29865.5
                  ],
                  [
                    47508.5,
                    29648.5
                  ],
                  [
                    47421.4,
                    29651.3
                  ],
                  [
                    47433,
                    29560.1
                  ]
                ],
                "id": 254,
                "chat_link": "[&BP4AAAA=]"
              },
              "255": {
                "name": "Northfields",
                "level": 29,
                "coord": [
                  47965.4,
                  29170.1
                ],
                "bounds": [
                  [
                    48036.6,
                    29607.5
                  ],
                  [
                    48291.5,
                    29408.4
                  ],
                  [
                    48228.8,
                    29268.7
                  ],
                  [
                    48275.8,
                    29091.4
                  ],
                  [
                    48002.1,
                    28775.3
                  ],
                  [
                    47886.3,
                    28923.8
                  ],
                  [
                    47779.8,
                    28936.6
                  ],
                  [
                    47814.7,
                    29057.6
                  ],
                  [
                    47756.8,
                    29173.8
                  ],
                  [
                    47812.2,
                    29238
                  ],
                  [
                    47735.3,
                    29390.2
                  ],
                  [
                    48036.6,
                    29607.5
                  ]
                ],
                "id": 255,
                "chat_link": "[&BP8AAAA=]"
              },
              "258": {
                "name": "Broadhollow Bluffs",
                "level": 29,
                "coord": [
                  47923.4,
                  30319.7
                ],
                "bounds": [
                  [
                    47656,
                    30620.2
                  ],
                  [
                    47702.6,
                    30738
                  ],
                  [
                    47835.6,
                    30777.2
                  ],
                  [
                    48210,
                    30760.6
                  ],
                  [
                    48309.1,
                    30364.7
                  ],
                  [
                    48222.5,
                    30266.3
                  ],
                  [
                    48269.3,
                    29955.6
                  ],
                  [
                    48089.6,
                    29947.6
                  ],
                  [
                    48009.8,
                    29902
                  ],
                  [
                    47926,
                    30024.7
                  ],
                  [
                    47749.1,
                    30107.7
                  ],
                  [
                    47611.7,
                    30267.3
                  ],
                  [
                    47649.5,
                    30316.5
                  ],
                  [
                    47687.3,
                    30428
                  ],
                  [
                    47656,
                    30620.2
                  ]
                ],
                "id": 258,
                "chat_link": "[&BAIBAAA=]"
              },
              "827": {
                "name": "Witherflank River",
                "level": 29,
                "coord": [
                  47719.9,
                  29086.5
                ],
                "bounds": [
                  [
                    47555.9,
                    29234.9
                  ],
                  [
                    47628.4,
                    29209.3
                  ],
                  [
                    47649.2,
                    29046.2
                  ],
                  [
                    47745.9,
                    28891.1
                  ],
                  [
                    47742,
                    28832.7
                  ],
                  [
                    47842.7,
                    28813.1
                  ],
                  [
                    47787.6,
                    28604.8
                  ],
                  [
                    48106,
                    28649.9
                  ],
                  [
                    48001.8,
                    28776.5
                  ],
                  [
                    47886,
                    28923.4
                  ],
                  [
                    47780,
                    28937.3
                  ],
                  [
                    47813.7,
                    29057.8
                  ],
                  [
                    47756.5,
                    29173.6
                  ],
                  [
                    47811,
                    29238.5
                  ],
                  [
                    47735.5,
                    29390.5
                  ],
                  [
                    47512,
                    29554.8
                  ],
                  [
                    47432.4,
                    29561.8
                  ],
                  [
                    47366.5,
                    29397.3
                  ],
                  [
                    47525.7,
                    29350.6
                  ],
                  [
                    47555.9,
                    29234.9
                  ]
                ],
                "id": 827,
                "chat_link": "[&BDsDAAA=]"
              }
            },
            "adventures": [],
            "id": 569,
            "mastery_points": []
          },
          "570": {
            "name": "Dead of Winter",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "256": {
                "name": "Provern Shore",
                "level": 32,
                "coord": [
                  48556,
                  28887.1
                ],
                "bounds": [
                  [
                    48078.6,
                    28867.3
                  ],
                  [
                    48275.3,
                    29091.4
                  ],
                  [
                    48397,
                    28943.1
                  ],
                  [
                    48590.5,
                    28957.3
                  ],
                  [
                    48636.1,
                    29122.1
                  ],
                  [
                    48793.1,
                    29207.7
                  ],
                  [
                    48926.3,
                    29053.1
                  ],
                  [
                    48860.2,
                    28766
                  ],
                  [
                    48876.2,
                    28634.8
                  ],
                  [
                    48535.9,
                    28630.1
                  ],
                  [
                    48463.8,
                    28660.6
                  ],
                  [
                    48454.1,
                    28739.2
                  ],
                  [
                    48341.2,
                    28859.4
                  ],
                  [
                    48078.6,
                    28867.3
                  ]
                ],
                "id": 256,
                "chat_link": "[&BAABAAA=]"
              },
              "881": {
                "name": "Provernic Crypt",
                "level": 32,
                "coord": [
                  48252.4,
                  28735.9
                ],
                "bounds": [
                  [
                    48079.2,
                    28865.4
                  ],
                  [
                    48001.6,
                    28776.3
                  ],
                  [
                    48104.2,
                    28652.8
                  ],
                  [
                    48322.2,
                    28596.7
                  ],
                  [
                    48464.5,
                    28660.6
                  ],
                  [
                    48454.2,
                    28739.1
                  ],
                  [
                    48341.1,
                    28860.3
                  ],
                  [
                    48079.2,
                    28865.4
                  ]
                ],
                "id": 881,
                "chat_link": "[&BHEDAAA=]"
              }
            },
            "adventures": [],
            "id": 570,
            "mastery_points": []
          },
          "571": {
            "name": "A Tangle of Weeds",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "249": {
                "name": "The Bloodfields",
                "level": 29,
                "coord": [
                  47167.5,
                  29467.6
                ],
                "bounds": [
                  [
                    47251.3,
                    29258.3
                  ],
                  [
                    47366.3,
                    29396.8
                  ],
                  [
                    47432.6,
                    29560.1
                  ],
                  [
                    47421,
                    29650.3
                  ],
                  [
                    47218.8,
                    29705.5
                  ],
                  [
                    47072.1,
                    29467.1
                  ],
                  [
                    46795.2,
                    29509.3
                  ],
                  [
                    46782.6,
                    29193.1
                  ],
                  [
                    47251.3,
                    29258.3
                  ]
                ],
                "id": 249,
                "chat_link": "[&BPkAAAA=]"
              },
              "253": {
                "name": "Lionbridge Expanse",
                "level": 28,
                "coord": [
                  47455,
                  30117.2
                ],
                "bounds": [
                  [
                    47210.2,
                    30156
                  ],
                  [
                    47439.8,
                    30250.6
                  ],
                  [
                    47568.1,
                    30567.4
                  ],
                  [
                    47622.7,
                    30622.7
                  ],
                  [
                    47657.1,
                    30619.4
                  ],
                  [
                    47688.2,
                    30427.9
                  ],
                  [
                    47648.5,
                    30314.4
                  ],
                  [
                    47610.8,
                    30268.5
                  ],
                  [
                    47749.3,
                    30107.3
                  ],
                  [
                    47484.5,
                    30002.3
                  ],
                  [
                    47437.9,
                    29901.9
                  ],
                  [
                    47498.1,
                    29865.6
                  ],
                  [
                    47507.2,
                    29648.5
                  ],
                  [
                    47421,
                    29651.6
                  ],
                  [
                    47218.8,
                    29705.2
                  ],
                  [
                    47097.1,
                    29869.5
                  ],
                  [
                    47162.2,
                    29974.8
                  ],
                  [
                    47167.9,
                    30155.4
                  ],
                  [
                    47210.2,
                    30156
                  ]
                ],
                "id": 253,
                "chat_link": "[&BP0AAAA=]"
              },
              "254": {
                "name": "Ascalon Settlement",
                "level": 29,
                "coord": [
                  47646.4,
                  29767.7
                ],
                "bounds": [
                  [
                    47433,
                    29560.1
                  ],
                  [
                    47511.6,
                    29555.3
                  ],
                  [
                    47734.5,
                    29389.3
                  ],
                  [
                    48037.4,
                    29607.7
                  ],
                  [
                    48012.3,
                    29900
                  ],
                  [
                    47926.5,
                    30024
                  ],
                  [
                    47748.2,
                    30108.4
                  ],
                  [
                    47485.3,
                    30001
                  ],
                  [
                    47439,
                    29900.8
                  ],
                  [
                    47499,
                    29865.5
                  ],
                  [
                    47508.5,
                    29648.5
                  ],
                  [
                    47421.4,
                    29651.3
                  ],
                  [
                    47433,
                    29560.1
                  ]
                ],
                "id": 254,
                "chat_link": "[&BP4AAAA=]"
              },
              "255": {
                "name": "Northfields",
                "level": 29,
                "coord": [
                  47965.4,
                  29170.1
                ],
                "bounds": [
                  [
                    48036.6,
                    29607.5
                  ],
                  [
                    48291.5,
                    29408.4
                  ],
                  [
                    48228.8,
                    29268.7
                  ],
                  [
                    48275.8,
                    29091.4
                  ],
                  [
                    48002.1,
                    28775.3
                  ],
                  [
                    47886.3,
                    28923.8
                  ],
                  [
                    47779.8,
                    28936.6
                  ],
                  [
                    47814.7,
                    29057.6
                  ],
                  [
                    47756.8,
                    29173.8
                  ],
                  [
                    47812.2,
                    29238
                  ],
                  [
                    47735.3,
                    29390.2
                  ],
                  [
                    48036.6,
                    29607.5
                  ]
                ],
                "id": 255,
                "chat_link": "[&BP8AAAA=]"
              },
              "827": {
                "name": "Witherflank River",
                "level": 29,
                "coord": [
                  47719.9,
                  29086.5
                ],
                "bounds": [
                  [
                    47555.9,
                    29234.9
                  ],
                  [
                    47628.4,
                    29209.3
                  ],
                  [
                    47649.2,
                    29046.2
                  ],
                  [
                    47745.9,
                    28891.1
                  ],
                  [
                    47742,
                    28832.7
                  ],
                  [
                    47842.7,
                    28813.1
                  ],
                  [
                    47787.6,
                    28604.8
                  ],
                  [
                    48106,
                    28649.9
                  ],
                  [
                    48001.8,
                    28776.5
                  ],
                  [
                    47886,
                    28923.4
                  ],
                  [
                    47780,
                    28937.3
                  ],
                  [
                    47813.7,
                    29057.8
                  ],
                  [
                    47756.5,
                    29173.6
                  ],
                  [
                    47811,
                    29238.5
                  ],
                  [
                    47735.5,
                    29390.5
                  ],
                  [
                    47512,
                    29554.8
                  ],
                  [
                    47432.4,
                    29561.8
                  ],
                  [
                    47366.5,
                    29397.3
                  ],
                  [
                    47525.7,
                    29350.6
                  ],
                  [
                    47555.9,
                    29234.9
                  ]
                ],
                "id": 827,
                "chat_link": "[&BDsDAAA=]"
              }
            },
            "adventures": [],
            "id": 571,
            "mastery_points": []
          },
          "573": {
            "name": "Explosive Intellect",
            "min_level": 1,
            "max_level": 1,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "151": {
                "name": "Wildflame Caverns",
                "level": 3,
                "coord": [
                  40276.3,
                  36696
                ],
                "bounds": [
                  [
                    40309.2,
                    36840.4
                  ],
                  [
                    40079.7,
                    36840.9
                  ],
                  [
                    40024,
                    36672.9
                  ],
                  [
                    40226.5,
                    36524.1
                  ],
                  [
                    40451.6,
                    36554.5
                  ],
                  [
                    40456.5,
                    36661
                  ],
                  [
                    40386.4,
                    36778.2
                  ],
                  [
                    40309.2,
                    36840.4
                  ]
                ],
                "id": 151,
                "chat_link": "[&BJcAAAA=]"
              },
              "155": {
                "name": "Soren Draa",
                "level": 3,
                "coord": [
                  40147.6,
                  36424
                ],
                "bounds": [
                  [
                    40447.9,
                    36315.7
                  ],
                  [
                    40450.2,
                    36551.2
                  ],
                  [
                    40225.8,
                    36523.4
                  ],
                  [
                    40023.2,
                    36670.9
                  ],
                  [
                    39889.8,
                    36632
                  ],
                  [
                    39890.9,
                    36234.1
                  ],
                  [
                    40006.7,
                    36162.8
                  ],
                  [
                    40246.2,
                    36301.5
                  ],
                  [
                    40447.9,
                    36315.7
                  ]
                ],
                "id": 155,
                "chat_link": "[&BJsAAAA=]"
              },
              "164": {
                "name": "The Hinterlabs",
                "level": 3,
                "coord": [
                  40678.6,
                  36522.9
                ],
                "bounds": [
                  [
                    40449.1,
                    36313.1
                  ],
                  [
                    40471.8,
                    36252.9
                  ],
                  [
                    40534.3,
                    36063.8
                  ],
                  [
                    41149.2,
                    36393
                  ],
                  [
                    41160,
                    36824.4
                  ],
                  [
                    40733.5,
                    36842.8
                  ],
                  [
                    40624.6,
                    36797.9
                  ],
                  [
                    40531.4,
                    36609.9
                  ],
                  [
                    40453.2,
                    36608.7
                  ],
                  [
                    40449.1,
                    36313.1
                  ]
                ],
                "id": 164,
                "chat_link": "[&BKQAAAA=]"
              },
              "940": {
                "name": "Golemagical Institute",
                "level": 3,
                "coord": [
                  40488,
                  36782
                ],
                "bounds": [
                  [
                    40457.3,
                    36662.3
                  ],
                  [
                    40454,
                    36612.7
                  ],
                  [
                    40531.6,
                    36612
                  ],
                  [
                    40624.3,
                    36798.8
                  ],
                  [
                    40604.8,
                    36869.4
                  ],
                  [
                    40541.9,
                    36900.2
                  ],
                  [
                    40479.8,
                    36901.4
                  ],
                  [
                    40417.5,
                    36866
                  ],
                  [
                    40382.4,
                    36818.9
                  ],
                  [
                    40386.5,
                    36778.8
                  ],
                  [
                    40457.3,
                    36662.3
                  ]
                ],
                "id": 940,
                "chat_link": "[&BKwDAAA=]"
              }
            },
            "adventures": [],
            "id": 573,
            "mastery_points": []
          },
          "574": {
            "name": "In Snaff's Footsteps",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {
              "52": {
                "name": "Battleground Plaza",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40583.5,
                  36342.7
                ],
                "id": 52,
                "chat_link": "[&BDQAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "164": {
                "name": "The Hinterlabs",
                "level": 3,
                "coord": [
                  40678.6,
                  36522.9
                ],
                "bounds": [
                  [
                    40449.1,
                    36313.1
                  ],
                  [
                    40471.8,
                    36252.9
                  ],
                  [
                    40534.3,
                    36063.8
                  ],
                  [
                    41149.2,
                    36393
                  ],
                  [
                    41160,
                    36824.4
                  ],
                  [
                    40733.5,
                    36842.8
                  ],
                  [
                    40624.6,
                    36797.9
                  ],
                  [
                    40531.4,
                    36609.9
                  ],
                  [
                    40453.2,
                    36608.7
                  ],
                  [
                    40449.1,
                    36313.1
                  ]
                ],
                "id": 164,
                "chat_link": "[&BKQAAAA=]"
              }
            },
            "adventures": [],
            "id": 574,
            "mastery_points": []
          },
          "575": {
            "name": "Golem Positioning System",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {
              "1181": {
                "name": "Engaged Demo Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37644,
                  36366.1
                ],
                "id": 1181,
                "chat_link": "[&BJ0EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "919": {
                "name": "Applied Development Lab (Home)",
                "level": 0,
                "coord": [
                  37819.7,
                  36301.5
                ],
                "bounds": [
                  [
                    38180.8,
                    36251.8
                  ],
                  [
                    38021.9,
                    36118.1
                  ],
                  [
                    37841.3,
                    36116.1
                  ],
                  [
                    37671.3,
                    36147.8
                  ],
                  [
                    37401.1,
                    36368.3
                  ],
                  [
                    37621.3,
                    36619.1
                  ],
                  [
                    38000,
                    36489
                  ],
                  [
                    38180.8,
                    36251.8
                  ]
                ],
                "id": 919,
                "chat_link": "[&BJcDAAA=]"
              }
            },
            "adventures": [],
            "id": 575,
            "mastery_points": []
          },
          "576": {
            "name": "Monkey Wrench",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "152": {
                "name": "Obscura Incline",
                "level": 6,
                "coord": [
                  40364.7,
                  35966.4
                ],
                "bounds": [
                  [
                    40245.2,
                    36304.3
                  ],
                  [
                    40448.6,
                    36312.6
                  ],
                  [
                    40535.2,
                    36050
                  ],
                  [
                    40766.3,
                    35895.1
                  ],
                  [
                    40725.3,
                    35789.5
                  ],
                  [
                    40522.3,
                    35703.8
                  ],
                  [
                    40511.7,
                    35671.7
                  ],
                  [
                    40337.5,
                    35666.9
                  ],
                  [
                    40225.8,
                    35785.9
                  ],
                  [
                    40280.7,
                    36004.3
                  ],
                  [
                    40274.5,
                    36057
                  ],
                  [
                    40189.1,
                    36071.3
                  ],
                  [
                    40035.7,
                    36053.4
                  ],
                  [
                    40008.1,
                    36163.5
                  ],
                  [
                    40245.2,
                    36304.3
                  ]
                ],
                "id": 152,
                "chat_link": "[&BJgAAAA=]"
              },
              "165": {
                "name": "The Funhouse",
                "level": 6,
                "coord": [
                  40155.8,
                  35871.3
                ],
                "bounds": [
                  [
                    40035.7,
                    36052.6
                  ],
                  [
                    40024.6,
                    35951.2
                  ],
                  [
                    39971.3,
                    35890.3
                  ],
                  [
                    39974.1,
                    35616.5
                  ],
                  [
                    40245.7,
                    35617.5
                  ],
                  [
                    40337.4,
                    35669.5
                  ],
                  [
                    40225.4,
                    35782.4
                  ],
                  [
                    40278.8,
                    36007.2
                  ],
                  [
                    40272.8,
                    36052.6
                  ],
                  [
                    40191.9,
                    36073.8
                  ],
                  [
                    40035.7,
                    36052.6
                  ]
                ],
                "id": 165,
                "chat_link": "[&BKUAAAA=]"
              }
            },
            "adventures": [],
            "id": 576,
            "mastery_points": []
          },
          "577": {
            "name": "Defusing the Problem",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {
              "1181": {
                "name": "Engaged Demo Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37644,
                  36366.1
                ],
                "id": 1181,
                "chat_link": "[&BJ0EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "919": {
                "name": "Applied Development Lab (Home)",
                "level": 0,
                "coord": [
                  37819.7,
                  36301.5
                ],
                "bounds": [
                  [
                    38180.8,
                    36251.8
                  ],
                  [
                    38021.9,
                    36118.1
                  ],
                  [
                    37841.3,
                    36116.1
                  ],
                  [
                    37671.3,
                    36147.8
                  ],
                  [
                    37401.1,
                    36368.3
                  ],
                  [
                    37621.3,
                    36619.1
                  ],
                  [
                    38000,
                    36489
                  ],
                  [
                    38180.8,
                    36251.8
                  ]
                ],
                "id": 919,
                "chat_link": "[&BJcDAAA=]"
              }
            },
            "adventures": [],
            "id": 577,
            "mastery_points": []
          },
          "578": {
            "name": "The Things We Do For Love",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "149": {
                "name": "Desider Atum",
                "level": 9,
                "coord": [
                  41380.1,
                  35255.8
                ],
                "bounds": [
                  [
                    41243.8,
                    35252.9
                  ],
                  [
                    41293.9,
                    35469.4
                  ],
                  [
                    41556.8,
                    35393.3
                  ],
                  [
                    41530.9,
                    35224.5
                  ],
                  [
                    41388,
                    35093.1
                  ],
                  [
                    41267.3,
                    35101.5
                  ],
                  [
                    41243.8,
                    35252.9
                  ]
                ],
                "id": 149,
                "chat_link": "[&BJUAAAA=]"
              }
            },
            "adventures": [],
            "id": 578,
            "mastery_points": []
          },
          "579": {
            "name": "The Snaff Prize",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {
              "52": {
                "name": "Battleground Plaza",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40583.5,
                  36342.7
                ],
                "id": 52,
                "chat_link": "[&BDQAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "164": {
                "name": "The Hinterlabs",
                "level": 3,
                "coord": [
                  40678.6,
                  36522.9
                ],
                "bounds": [
                  [
                    40449.1,
                    36313.1
                  ],
                  [
                    40471.8,
                    36252.9
                  ],
                  [
                    40534.3,
                    36063.8
                  ],
                  [
                    41149.2,
                    36393
                  ],
                  [
                    41160,
                    36824.4
                  ],
                  [
                    40733.5,
                    36842.8
                  ],
                  [
                    40624.6,
                    36797.9
                  ],
                  [
                    40531.4,
                    36609.9
                  ],
                  [
                    40453.2,
                    36608.7
                  ],
                  [
                    40449.1,
                    36313.1
                  ]
                ],
                "id": 164,
                "chat_link": "[&BKQAAAA=]"
              }
            },
            "adventures": [],
            "id": 579,
            "mastery_points": []
          },
          "581": {
            "name": "A Sparkling Rescue",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "152": {
                "name": "Obscura Incline",
                "level": 6,
                "coord": [
                  40364.7,
                  35966.4
                ],
                "bounds": [
                  [
                    40245.2,
                    36304.3
                  ],
                  [
                    40448.6,
                    36312.6
                  ],
                  [
                    40535.2,
                    36050
                  ],
                  [
                    40766.3,
                    35895.1
                  ],
                  [
                    40725.3,
                    35789.5
                  ],
                  [
                    40522.3,
                    35703.8
                  ],
                  [
                    40511.7,
                    35671.7
                  ],
                  [
                    40337.5,
                    35666.9
                  ],
                  [
                    40225.8,
                    35785.9
                  ],
                  [
                    40280.7,
                    36004.3
                  ],
                  [
                    40274.5,
                    36057
                  ],
                  [
                    40189.1,
                    36071.3
                  ],
                  [
                    40035.7,
                    36053.4
                  ],
                  [
                    40008.1,
                    36163.5
                  ],
                  [
                    40245.2,
                    36304.3
                  ]
                ],
                "id": 152,
                "chat_link": "[&BJgAAAA=]"
              },
              "165": {
                "name": "The Funhouse",
                "level": 6,
                "coord": [
                  40155.8,
                  35871.3
                ],
                "bounds": [
                  [
                    40035.7,
                    36052.6
                  ],
                  [
                    40024.6,
                    35951.2
                  ],
                  [
                    39971.3,
                    35890.3
                  ],
                  [
                    39974.1,
                    35616.5
                  ],
                  [
                    40245.7,
                    35617.5
                  ],
                  [
                    40337.4,
                    35669.5
                  ],
                  [
                    40225.4,
                    35782.4
                  ],
                  [
                    40278.8,
                    36007.2
                  ],
                  [
                    40272.8,
                    36052.6
                  ],
                  [
                    40191.9,
                    36073.8
                  ],
                  [
                    40035.7,
                    36052.6
                  ]
                ],
                "id": 165,
                "chat_link": "[&BKUAAAA=]"
              }
            },
            "adventures": [],
            "id": 581,
            "mastery_points": []
          },
          "582": {
            "name": "High Maintenance",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {
              "552": {
                "name": "Incomp Optics",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41358.3,
                  36694.4
                ],
                "id": 552,
                "chat_link": "[&BCgCAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "162": {
                "name": "Jeztar Falls",
                "level": 4,
                "coord": [
                  41453.6,
                  36517.7
                ],
                "bounds": [
                  [
                    41142.7,
                    36382.2
                  ],
                  [
                    41315.4,
                    36218.9
                  ],
                  [
                    41325.5,
                    36121.3
                  ],
                  [
                    41441.4,
                    36103.5
                  ],
                  [
                    41786.9,
                    36416.3
                  ],
                  [
                    41801,
                    36816.2
                  ],
                  [
                    41648,
                    36839.1
                  ],
                  [
                    41468.2,
                    36956.3
                  ],
                  [
                    41153.4,
                    36805.4
                  ],
                  [
                    41142.7,
                    36382.2
                  ]
                ],
                "id": 162,
                "chat_link": "[&BKIAAAA=]"
              }
            },
            "adventures": [],
            "id": 582,
            "mastery_points": []
          },
          "583": {
            "name": "Snaff Would Be Proud",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {
              "52": {
                "name": "Battleground Plaza",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40583.5,
                  36342.7
                ],
                "id": 52,
                "chat_link": "[&BDQAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "164": {
                "name": "The Hinterlabs",
                "level": 3,
                "coord": [
                  40678.6,
                  36522.9
                ],
                "bounds": [
                  [
                    40449.1,
                    36313.1
                  ],
                  [
                    40471.8,
                    36252.9
                  ],
                  [
                    40534.3,
                    36063.8
                  ],
                  [
                    41149.2,
                    36393
                  ],
                  [
                    41160,
                    36824.4
                  ],
                  [
                    40733.5,
                    36842.8
                  ],
                  [
                    40624.6,
                    36797.9
                  ],
                  [
                    40531.4,
                    36609.9
                  ],
                  [
                    40453.2,
                    36608.7
                  ],
                  [
                    40449.1,
                    36313.1
                  ]
                ],
                "id": 164,
                "chat_link": "[&BKQAAAA=]"
              }
            },
            "adventures": [],
            "id": 583,
            "mastery_points": []
          },
          "584": {
            "name": "Taking Credit Back",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {
              "54": {
                "name": "Durotl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41131.2,
                  36208.9
                ],
                "id": 54,
                "chat_link": "[&BDYAAAA=]"
              },
              "55": {
                "name": "Aquannian Research Group",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41356.3,
                  36474.3
                ],
                "id": 55,
                "chat_link": "[&BDcAAAA=]"
              },
              "551": {
                "name": "PR&T Esoterics",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41645.1,
                  36378.2
                ],
                "id": 551,
                "chat_link": "[&BCcCAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "162": {
                "name": "Jeztar Falls",
                "level": 4,
                "coord": [
                  41453.6,
                  36517.7
                ],
                "bounds": [
                  [
                    41142.7,
                    36382.2
                  ],
                  [
                    41315.4,
                    36218.9
                  ],
                  [
                    41325.5,
                    36121.3
                  ],
                  [
                    41441.4,
                    36103.5
                  ],
                  [
                    41786.9,
                    36416.3
                  ],
                  [
                    41801,
                    36816.2
                  ],
                  [
                    41648,
                    36839.1
                  ],
                  [
                    41468.2,
                    36956.3
                  ],
                  [
                    41153.4,
                    36805.4
                  ],
                  [
                    41142.7,
                    36382.2
                  ]
                ],
                "id": 162,
                "chat_link": "[&BKIAAAA=]"
              },
              "163": {
                "name": "Loch Jezt",
                "level": 5,
                "coord": [
                  41036.9,
                  36099.8
                ],
                "bounds": [
                  [
                    41153.6,
                    36394
                  ],
                  [
                    40532.2,
                    36049.5
                  ],
                  [
                    40766.5,
                    35898
                  ],
                  [
                    41118.8,
                    35895.3
                  ],
                  [
                    41329.7,
                    36130.8
                  ],
                  [
                    41320.6,
                    36230.8
                  ],
                  [
                    41153.6,
                    36394
                  ]
                ],
                "id": 163,
                "chat_link": "[&BKMAAAA=]"
              },
              "164": {
                "name": "The Hinterlabs",
                "level": 3,
                "coord": [
                  40678.6,
                  36522.9
                ],
                "bounds": [
                  [
                    40449.1,
                    36313.1
                  ],
                  [
                    40471.8,
                    36252.9
                  ],
                  [
                    40534.3,
                    36063.8
                  ],
                  [
                    41149.2,
                    36393
                  ],
                  [
                    41160,
                    36824.4
                  ],
                  [
                    40733.5,
                    36842.8
                  ],
                  [
                    40624.6,
                    36797.9
                  ],
                  [
                    40531.4,
                    36609.9
                  ],
                  [
                    40453.2,
                    36608.7
                  ],
                  [
                    40449.1,
                    36313.1
                  ]
                ],
                "id": 164,
                "chat_link": "[&BKQAAAA=]"
              },
              "167": {
                "name": "Sunshade Caves",
                "level": 9,
                "coord": [
                  41801.5,
                  36244.1
                ],
                "bounds": [
                  [
                    42126.8,
                    36436.7
                  ],
                  [
                    41793,
                    36431.5
                  ],
                  [
                    41446.4,
                    36117.4
                  ],
                  [
                    41509.3,
                    36013.4
                  ],
                  [
                    42132.1,
                    36221.3
                  ],
                  [
                    42126.8,
                    36436.7
                  ]
                ],
                "id": 167,
                "chat_link": "[&BKcAAAA=]"
              }
            },
            "adventures": [],
            "id": 584,
            "mastery_points": []
          },
          "586": {
            "name": "Political Homicide",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 586,
            "mastery_points": []
          },
          "587": {
            "name": "Here, There, Everywhere",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "147": {
                "name": "Voloxian Passage",
                "level": 8,
                "coord": [
                  40926.2,
                  35549
                ],
                "bounds": [
                  [
                    41339.4,
                    35712.3
                  ],
                  [
                    41247.1,
                    35253.3
                  ],
                  [
                    41127.1,
                    35237.3
                  ],
                  [
                    41070.9,
                    35319.4
                  ],
                  [
                    40928.6,
                    35304.9
                  ],
                  [
                    40914.4,
                    35270.5
                  ],
                  [
                    40416.6,
                    35388
                  ],
                  [
                    40510.3,
                    35715.9
                  ],
                  [
                    40714.1,
                    35796.2
                  ],
                  [
                    40760.5,
                    35918
                  ],
                  [
                    41110.1,
                    35905
                  ],
                  [
                    40974.8,
                    35767.2
                  ],
                  [
                    41339.4,
                    35712.3
                  ]
                ],
                "id": 147,
                "chat_link": "[&BJMAAAA=]"
              }
            },
            "adventures": [],
            "id": 587,
            "mastery_points": []
          },
          "588": {
            "name": "Piece Negotiations",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {
              "1181": {
                "name": "Engaged Demo Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37644,
                  36366.1
                ],
                "id": 1181,
                "chat_link": "[&BJ0EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "919": {
                "name": "Applied Development Lab (Home)",
                "level": 0,
                "coord": [
                  37819.7,
                  36301.5
                ],
                "bounds": [
                  [
                    38180.8,
                    36251.8
                  ],
                  [
                    38021.9,
                    36118.1
                  ],
                  [
                    37841.3,
                    36116.1
                  ],
                  [
                    37671.3,
                    36147.8
                  ],
                  [
                    37401.1,
                    36368.3
                  ],
                  [
                    37621.3,
                    36619.1
                  ],
                  [
                    38000,
                    36489
                  ],
                  [
                    38180.8,
                    36251.8
                  ]
                ],
                "id": 919,
                "chat_link": "[&BJcDAAA=]"
              }
            },
            "adventures": [],
            "id": 588,
            "mastery_points": []
          },
          "589": {
            "name": "Readings On the Rise",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 589,
            "mastery_points": []
          },
          "590": {
            "name": "Snaff Would Be Proud",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "162": {
                "name": "Jeztar Falls",
                "level": 4,
                "coord": [
                  41453.6,
                  36517.7
                ],
                "bounds": [
                  [
                    41142.7,
                    36382.2
                  ],
                  [
                    41315.4,
                    36218.9
                  ],
                  [
                    41325.5,
                    36121.3
                  ],
                  [
                    41441.4,
                    36103.5
                  ],
                  [
                    41786.9,
                    36416.3
                  ],
                  [
                    41801,
                    36816.2
                  ],
                  [
                    41648,
                    36839.1
                  ],
                  [
                    41468.2,
                    36956.3
                  ],
                  [
                    41153.4,
                    36805.4
                  ],
                  [
                    41142.7,
                    36382.2
                  ]
                ],
                "id": 162,
                "chat_link": "[&BKIAAAA=]"
              }
            },
            "adventures": [],
            "id": 590,
            "mastery_points": []
          },
          "591": {
            "name": "Readings On the Rise",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "152": {
                "name": "Obscura Incline",
                "level": 6,
                "coord": [
                  40364.7,
                  35966.4
                ],
                "bounds": [
                  [
                    40245.2,
                    36304.3
                  ],
                  [
                    40448.6,
                    36312.6
                  ],
                  [
                    40535.2,
                    36050
                  ],
                  [
                    40766.3,
                    35895.1
                  ],
                  [
                    40725.3,
                    35789.5
                  ],
                  [
                    40522.3,
                    35703.8
                  ],
                  [
                    40511.7,
                    35671.7
                  ],
                  [
                    40337.5,
                    35666.9
                  ],
                  [
                    40225.8,
                    35785.9
                  ],
                  [
                    40280.7,
                    36004.3
                  ],
                  [
                    40274.5,
                    36057
                  ],
                  [
                    40189.1,
                    36071.3
                  ],
                  [
                    40035.7,
                    36053.4
                  ],
                  [
                    40008.1,
                    36163.5
                  ],
                  [
                    40245.2,
                    36304.3
                  ]
                ],
                "id": 152,
                "chat_link": "[&BJgAAAA=]"
              },
              "166": {
                "name": "Fisher's Beach Bend",
                "level": 9,
                "coord": [
                  40187.2,
                  35259.6
                ],
                "bounds": [
                  [
                    40337.1,
                    35664.9
                  ],
                  [
                    40246,
                    35616.8
                  ],
                  [
                    39974.1,
                    35614.5
                  ],
                  [
                    39942.1,
                    35355.8
                  ],
                  [
                    39940.3,
                    35092.3
                  ],
                  [
                    39968,
                    34969.2
                  ],
                  [
                    40077.5,
                    34932.4
                  ],
                  [
                    40257.4,
                    34785.1
                  ],
                  [
                    40372,
                    34770.9
                  ],
                  [
                    40433.1,
                    35382
                  ],
                  [
                    40511.5,
                    35671.2
                  ],
                  [
                    40337.1,
                    35664.9
                  ]
                ],
                "id": 166,
                "chat_link": "[&BKYAAAA=]"
              }
            },
            "adventures": [],
            "id": 591,
            "mastery_points": []
          },
          "592": {
            "name": "Unscheduled Delay",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {
              "553": {
                "name": "Brill Alliance Labs",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40869.1,
                  35412.8
                ],
                "id": 553,
                "chat_link": "[&BCkCAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "147": {
                "name": "Voloxian Passage",
                "level": 8,
                "coord": [
                  40926.2,
                  35549
                ],
                "bounds": [
                  [
                    41339.4,
                    35712.3
                  ],
                  [
                    41247.1,
                    35253.3
                  ],
                  [
                    41127.1,
                    35237.3
                  ],
                  [
                    41070.9,
                    35319.4
                  ],
                  [
                    40928.6,
                    35304.9
                  ],
                  [
                    40914.4,
                    35270.5
                  ],
                  [
                    40416.6,
                    35388
                  ],
                  [
                    40510.3,
                    35715.9
                  ],
                  [
                    40714.1,
                    35796.2
                  ],
                  [
                    40760.5,
                    35918
                  ],
                  [
                    41110.1,
                    35905
                  ],
                  [
                    40974.8,
                    35767.2
                  ],
                  [
                    41339.4,
                    35712.3
                  ]
                ],
                "id": 147,
                "chat_link": "[&BJMAAAA=]"
              },
              "149": {
                "name": "Desider Atum",
                "level": 9,
                "coord": [
                  41380.1,
                  35255.8
                ],
                "bounds": [
                  [
                    41243.8,
                    35252.9
                  ],
                  [
                    41293.9,
                    35469.4
                  ],
                  [
                    41556.8,
                    35393.3
                  ],
                  [
                    41530.9,
                    35224.5
                  ],
                  [
                    41388,
                    35093.1
                  ],
                  [
                    41267.3,
                    35101.5
                  ],
                  [
                    41243.8,
                    35252.9
                  ]
                ],
                "id": 149,
                "chat_link": "[&BJUAAAA=]"
              }
            },
            "adventures": [],
            "id": 592,
            "mastery_points": []
          },
          "594": {
            "name": "Stand By Your Krewe",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {
              "1191": {
                "name": "Biocauldron Alchemics",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40965.4,
                  35220.5
                ],
                "id": 1191,
                "chat_link": "[&BKcEAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "146": {
                "name": "Michoan Marsh",
                "level": 11,
                "coord": [
                  40909.5,
                  35145.1
                ],
                "bounds": [
                  [
                    41244.3,
                    35251.8
                  ],
                  [
                    41268.7,
                    35104.3
                  ],
                  [
                    40833.7,
                    34670.6
                  ],
                  [
                    40364.6,
                    34769.4
                  ],
                  [
                    40437,
                    35378.3
                  ],
                  [
                    40911.4,
                    35271.3
                  ],
                  [
                    40927.8,
                    35305.2
                  ],
                  [
                    41072.1,
                    35319
                  ],
                  [
                    41126,
                    35236.4
                  ],
                  [
                    41244.3,
                    35251.8
                  ]
                ],
                "id": 146,
                "chat_link": "[&BJIAAAA=]"
              },
              "147": {
                "name": "Voloxian Passage",
                "level": 8,
                "coord": [
                  40926.2,
                  35549
                ],
                "bounds": [
                  [
                    41339.4,
                    35712.3
                  ],
                  [
                    41247.1,
                    35253.3
                  ],
                  [
                    41127.1,
                    35237.3
                  ],
                  [
                    41070.9,
                    35319.4
                  ],
                  [
                    40928.6,
                    35304.9
                  ],
                  [
                    40914.4,
                    35270.5
                  ],
                  [
                    40416.6,
                    35388
                  ],
                  [
                    40510.3,
                    35715.9
                  ],
                  [
                    40714.1,
                    35796.2
                  ],
                  [
                    40760.5,
                    35918
                  ],
                  [
                    41110.1,
                    35905
                  ],
                  [
                    40974.8,
                    35767.2
                  ],
                  [
                    41339.4,
                    35712.3
                  ]
                ],
                "id": 147,
                "chat_link": "[&BJMAAAA=]"
              }
            },
            "adventures": [],
            "id": 594,
            "mastery_points": []
          },
          "595": {
            "name": "Unwelcome Visitors",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {
              "1191": {
                "name": "Biocauldron Alchemics",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40965.4,
                  35220.5
                ],
                "id": 1191,
                "chat_link": "[&BKcEAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "146": {
                "name": "Michoan Marsh",
                "level": 11,
                "coord": [
                  40909.5,
                  35145.1
                ],
                "bounds": [
                  [
                    41244.3,
                    35251.8
                  ],
                  [
                    41268.7,
                    35104.3
                  ],
                  [
                    40833.7,
                    34670.6
                  ],
                  [
                    40364.6,
                    34769.4
                  ],
                  [
                    40437,
                    35378.3
                  ],
                  [
                    40911.4,
                    35271.3
                  ],
                  [
                    40927.8,
                    35305.2
                  ],
                  [
                    41072.1,
                    35319
                  ],
                  [
                    41126,
                    35236.4
                  ],
                  [
                    41244.3,
                    35251.8
                  ]
                ],
                "id": 146,
                "chat_link": "[&BJIAAAA=]"
              },
              "147": {
                "name": "Voloxian Passage",
                "level": 8,
                "coord": [
                  40926.2,
                  35549
                ],
                "bounds": [
                  [
                    41339.4,
                    35712.3
                  ],
                  [
                    41247.1,
                    35253.3
                  ],
                  [
                    41127.1,
                    35237.3
                  ],
                  [
                    41070.9,
                    35319.4
                  ],
                  [
                    40928.6,
                    35304.9
                  ],
                  [
                    40914.4,
                    35270.5
                  ],
                  [
                    40416.6,
                    35388
                  ],
                  [
                    40510.3,
                    35715.9
                  ],
                  [
                    40714.1,
                    35796.2
                  ],
                  [
                    40760.5,
                    35918
                  ],
                  [
                    41110.1,
                    35905
                  ],
                  [
                    40974.8,
                    35767.2
                  ],
                  [
                    41339.4,
                    35712.3
                  ]
                ],
                "id": 147,
                "chat_link": "[&BJMAAAA=]"
              }
            },
            "adventures": [],
            "id": 595,
            "mastery_points": []
          },
          "596": {
            "name": "Where Credit Is Due",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {
              "1182": {
                "name": "Zojja's Workstation (Don't Touch!)",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38182.9,
                  37334
                ],
                "id": 1182,
                "chat_link": "[&BJ4EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "920": {
                "name": "Snaff Memorial Lab",
                "level": 0,
                "coord": [
                  38014.6,
                  37408.8
                ],
                "bounds": [
                  [
                    37572.9,
                    37270.8
                  ],
                  [
                    38154.6,
                    37083.7
                  ],
                  [
                    38299.6,
                    37250.7
                  ],
                  [
                    38309.6,
                    37463.1
                  ],
                  [
                    38020.6,
                    37738.9
                  ],
                  [
                    37730.4,
                    37645.5
                  ],
                  [
                    37572.9,
                    37270.8
                  ]
                ],
                "id": 920,
                "chat_link": "[&BJgDAAA=]"
              }
            },
            "adventures": [],
            "id": 596,
            "mastery_points": []
          },
          "597": {
            "name": "Where Credit Is Due",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "149": {
                "name": "Desider Atum",
                "level": 9,
                "coord": [
                  41380.1,
                  35255.8
                ],
                "bounds": [
                  [
                    41243.8,
                    35252.9
                  ],
                  [
                    41293.9,
                    35469.4
                  ],
                  [
                    41556.8,
                    35393.3
                  ],
                  [
                    41530.9,
                    35224.5
                  ],
                  [
                    41388,
                    35093.1
                  ],
                  [
                    41267.3,
                    35101.5
                  ],
                  [
                    41243.8,
                    35252.9
                  ]
                ],
                "id": 149,
                "chat_link": "[&BJUAAAA=]"
              }
            },
            "adventures": [],
            "id": 597,
            "mastery_points": []
          },
          "598": {
            "name": "Short Fuse",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {
              "1134": {
                "name": "Transformer Hub Kachong",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41318.7,
                  34228.5
                ],
                "id": 1134,
                "chat_link": "[&BG4EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "148": {
                "name": "Artergon Woods",
                "level": 13,
                "coord": [
                  41198.6,
                  34665
                ],
                "bounds": [
                  [
                    41000.5,
                    34578.6
                  ],
                  [
                    40878.9,
                    34251.4
                  ],
                  [
                    41089.6,
                    34074.9
                  ],
                  [
                    41666.7,
                    34703.5
                  ],
                  [
                    41458,
                    34839.2
                  ],
                  [
                    41387.2,
                    35093.8
                  ],
                  [
                    41269,
                    35100.5
                  ],
                  [
                    40838.6,
                    34678.3
                  ],
                  [
                    41000.5,
                    34578.6
                  ]
                ],
                "id": 148,
                "chat_link": "[&BJQAAAA=]"
              },
              "156": {
                "name": "Hexane Regrade",
                "level": 14,
                "coord": [
                  41672.9,
                  33970.5
                ],
                "bounds": [
                  [
                    41456,
                    34486.8
                  ],
                  [
                    41922,
                    34261.2
                  ],
                  [
                    42133.7,
                    34314.6
                  ],
                  [
                    42182.7,
                    34046.6
                  ],
                  [
                    42132.4,
                    33846.8
                  ],
                  [
                    41861.1,
                    33948.3
                  ],
                  [
                    41525,
                    33947.2
                  ],
                  [
                    41527.8,
                    33778.6
                  ],
                  [
                    41468.1,
                    33506.1
                  ],
                  [
                    41102.8,
                    33459.8
                  ],
                  [
                    41090.8,
                    34079.2
                  ],
                  [
                    41456,
                    34486.8
                  ]
                ],
                "id": 156,
                "chat_link": "[&BJwAAAA=]"
              }
            },
            "adventures": [],
            "id": 598,
            "mastery_points": []
          },
          "599": {
            "name": "Short Fuse",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {
              "1181": {
                "name": "Engaged Demo Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37644,
                  36366.1
                ],
                "id": 1181,
                "chat_link": "[&BJ0EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "919": {
                "name": "Applied Development Lab (Home)",
                "level": 0,
                "coord": [
                  37819.7,
                  36301.5
                ],
                "bounds": [
                  [
                    38180.8,
                    36251.8
                  ],
                  [
                    38021.9,
                    36118.1
                  ],
                  [
                    37841.3,
                    36116.1
                  ],
                  [
                    37671.3,
                    36147.8
                  ],
                  [
                    37401.1,
                    36368.3
                  ],
                  [
                    37621.3,
                    36619.1
                  ],
                  [
                    38000,
                    36489
                  ],
                  [
                    38180.8,
                    36251.8
                  ]
                ],
                "id": 919,
                "chat_link": "[&BJcDAAA=]"
              }
            },
            "adventures": [],
            "id": 599,
            "mastery_points": []
          },
          "606": {
            "name": "Salt in the Wound",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {
              "61": {
                "name": "Inner Inquest Complex",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41888.4,
                  33654.6
                ],
                "id": 61,
                "chat_link": "[&BD0AAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "159": {
                "name": "Inquest Outer Complex",
                "level": 14,
                "coord": [
                  41860.7,
                  33722.4
                ],
                "bounds": [
                  [
                    41525.7,
                    33948.1
                  ],
                  [
                    41861.5,
                    33948.1
                  ],
                  [
                    42133.8,
                    33851.7
                  ],
                  [
                    42129.6,
                    33676.7
                  ],
                  [
                    42164.4,
                    33571.1
                  ],
                  [
                    42075.6,
                    33498.8
                  ],
                  [
                    41467.4,
                    33506.6
                  ],
                  [
                    41527.5,
                    33778
                  ],
                  [
                    41525.7,
                    33948.1
                  ]
                ],
                "id": 159,
                "chat_link": "[&BJ8AAAA=]"
              }
            },
            "adventures": [],
            "id": 606,
            "mastery_points": []
          },
          "607": {
            "name": "Free Rein",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "129": {
                "name": "Karston Chambers",
                "level": 17,
                "coord": [
                  41884,
                  33223.8
                ],
                "bounds": [
                  [
                    42178.2,
                    33347.1
                  ],
                  [
                    42114.5,
                    33092.8
                  ],
                  [
                    42135.2,
                    32770.7
                  ],
                  [
                    41828,
                    32836.9
                  ],
                  [
                    41481.6,
                    33207.6
                  ],
                  [
                    41644.1,
                    33442.8
                  ],
                  [
                    41606.3,
                    33550.6
                  ],
                  [
                    42084,
                    33541.7
                  ],
                  [
                    42178.2,
                    33347.1
                  ]
                ],
                "id": 129,
                "chat_link": "[&BIEAAAA=]"
              }
            },
            "adventures": [],
            "id": 607,
            "mastery_points": []
          },
          "608": {
            "name": "Serving Up Trouble",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {
              "1182": {
                "name": "Zojja's Workstation (Don't Touch!)",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38182.9,
                  37334
                ],
                "id": 1182,
                "chat_link": "[&BJ4EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "920": {
                "name": "Snaff Memorial Lab",
                "level": 0,
                "coord": [
                  38014.6,
                  37408.8
                ],
                "bounds": [
                  [
                    37572.9,
                    37270.8
                  ],
                  [
                    38154.6,
                    37083.7
                  ],
                  [
                    38299.6,
                    37250.7
                  ],
                  [
                    38309.6,
                    37463.1
                  ],
                  [
                    38020.6,
                    37738.9
                  ],
                  [
                    37730.4,
                    37645.5
                  ],
                  [
                    37572.9,
                    37270.8
                  ]
                ],
                "id": 920,
                "chat_link": "[&BJgDAAA=]"
              }
            },
            "adventures": [],
            "id": 608,
            "mastery_points": []
          },
          "609": {
            "name": "Serving Up Trouble",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "149": {
                "name": "Desider Atum",
                "level": 9,
                "coord": [
                  41380.1,
                  35255.8
                ],
                "bounds": [
                  [
                    41243.8,
                    35252.9
                  ],
                  [
                    41293.9,
                    35469.4
                  ],
                  [
                    41556.8,
                    35393.3
                  ],
                  [
                    41530.9,
                    35224.5
                  ],
                  [
                    41388,
                    35093.1
                  ],
                  [
                    41267.3,
                    35101.5
                  ],
                  [
                    41243.8,
                    35252.9
                  ]
                ],
                "id": 149,
                "chat_link": "[&BJUAAAA=]"
              }
            },
            "adventures": [],
            "id": 609,
            "mastery_points": []
          },
          "610": {
            "name": "Flash Flood",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 610,
            "mastery_points": []
          },
          "611": {
            "name": "I Smell a Rat",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "133": {
                "name": "Venlin Vale",
                "level": 16,
                "coord": [
                  40883.2,
                  33161.9
                ],
                "bounds": [
                  [
                    40781.7,
                    32620.8
                  ],
                  [
                    40926.1,
                    32757.6
                  ],
                  [
                    41194.4,
                    32858.9
                  ],
                  [
                    41273.5,
                    32847.7
                  ],
                  [
                    41642.7,
                    33432.2
                  ],
                  [
                    41606.8,
                    33552.3
                  ],
                  [
                    41152.7,
                    33576.8
                  ],
                  [
                    40807.1,
                    33535.1
                  ],
                  [
                    40766.1,
                    33570.1
                  ],
                  [
                    40390.1,
                    33538
                  ],
                  [
                    40387.6,
                    33339
                  ],
                  [
                    40550.8,
                    32978.2
                  ],
                  [
                    40485.6,
                    32940.4
                  ],
                  [
                    40399.6,
                    32719.8
                  ],
                  [
                    40781.7,
                    32620.8
                  ]
                ],
                "id": 133,
                "chat_link": "[&BIUAAAA=]"
              },
              "137": {
                "name": "Skrittsburgh Tunnels",
                "level": 17,
                "coord": [
                  40989.5,
                  32529.9
                ],
                "bounds": [
                  [
                    40922.5,
                    32759.1
                  ],
                  [
                    40781.4,
                    32631.3
                  ],
                  [
                    40634.8,
                    32290.7
                  ],
                  [
                    40763,
                    32217.5
                  ],
                  [
                    40890.4,
                    32298
                  ],
                  [
                    41062.5,
                    32304.1
                  ],
                  [
                    41291.1,
                    32570.1
                  ],
                  [
                    41354.2,
                    32836.3
                  ],
                  [
                    41205.3,
                    32861.9
                  ],
                  [
                    40922.5,
                    32759.1
                  ]
                ],
                "id": 137,
                "chat_link": "[&BIkAAAA=]"
              }
            },
            "adventures": [],
            "id": 611,
            "mastery_points": []
          },
          "613": {
            "name": "Magnum Opus",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {
              "1182": {
                "name": "Zojja's Workstation (Don't Touch!)",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38182.9,
                  37334
                ],
                "id": 1182,
                "chat_link": "[&BJ4EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "920": {
                "name": "Snaff Memorial Lab",
                "level": 0,
                "coord": [
                  38014.6,
                  37408.8
                ],
                "bounds": [
                  [
                    37572.9,
                    37270.8
                  ],
                  [
                    38154.6,
                    37083.7
                  ],
                  [
                    38299.6,
                    37250.7
                  ],
                  [
                    38309.6,
                    37463.1
                  ],
                  [
                    38020.6,
                    37738.9
                  ],
                  [
                    37730.4,
                    37645.5
                  ],
                  [
                    37572.9,
                    37270.8
                  ]
                ],
                "id": 920,
                "chat_link": "[&BJgDAAA=]"
              }
            },
            "adventures": [],
            "id": 613,
            "mastery_points": []
          },
          "614": {
            "name": "Magnum Opus",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {
              "1171": {
                "name": "PR-1000 Prototype Golem",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38596.4,
                  37000.4
                ],
                "id": 1171,
                "chat_link": "[&BJMEAAA=]"
              },
              "1175": {
                "name": "The Magihedron",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38880.3,
                  37049.4
                ],
                "id": 1175,
                "chat_link": "[&BJcEAAA=]"
              },
              "1177": {
                "name": "Thamaturgic Calculus",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38695,
                  37271.1
                ],
                "id": 1177,
                "chat_link": "[&BJkEAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "934": {
                "name": "College of Dynamics",
                "level": 0,
                "coord": [
                  38569.9,
                  36977.6
                ],
                "bounds": [
                  [
                    38438.8,
                    36868.2
                  ],
                  [
                    38733.3,
                    36918
                  ],
                  [
                    38537.7,
                    37146.5
                  ],
                  [
                    38438.8,
                    36868.2
                  ]
                ],
                "id": 934,
                "chat_link": "[&BKYDAAA=]"
              },
              "935": {
                "name": "Creator's Commons",
                "level": 0,
                "coord": [
                  38725.7,
                  37105.6
                ],
                "bounds": [
                  [
                    38890.6,
                    37199.7
                  ],
                  [
                    38851.6,
                    37246.3
                  ],
                  [
                    38556.2,
                    37195.3
                  ],
                  [
                    38538.5,
                    37147.2
                  ],
                  [
                    38732.7,
                    36917.9
                  ],
                  [
                    38784.3,
                    36927
                  ],
                  [
                    38890.6,
                    37199.7
                  ]
                ],
                "id": 935,
                "chat_link": "[&BKcDAAA=]"
              },
              "936": {
                "name": "College of Statics",
                "level": 0,
                "coord": [
                  38916.9,
                  37034.7
                ],
                "bounds": [
                  [
                    38890.6,
                    37200.1
                  ],
                  [
                    39076,
                    36977.6
                  ],
                  [
                    38784.2,
                    36926.3
                  ],
                  [
                    38890.6,
                    37200.1
                  ]
                ],
                "id": 936,
                "chat_link": "[&BKgDAAA=]"
              },
              "937": {
                "name": "College of Synergetics",
                "level": 0,
                "coord": [
                  38689.1,
                  37305.5
                ],
                "bounds": [
                  [
                    38556.4,
                    37194.6
                  ],
                  [
                    38658.8,
                    37475.8
                  ],
                  [
                    38852,
                    37246.1
                  ],
                  [
                    38556.4,
                    37194.6
                  ]
                ],
                "id": 937,
                "chat_link": "[&BKkDAAA=]"
              }
            },
            "adventures": [],
            "id": 614,
            "mastery_points": []
          },
          "617": {
            "name": "Bad Business",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "134": {
                "name": "Zinder Slope",
                "level": 16,
                "coord": [
                  41789.3,
                  32735.5
                ],
                "bounds": [
                  [
                    41832.8,
                    32837
                  ],
                  [
                    42135.3,
                    32772.7
                  ],
                  [
                    42165.5,
                    32560
                  ],
                  [
                    42113.4,
                    32491.5
                  ],
                  [
                    41964.7,
                    32560.6
                  ],
                  [
                    41619.9,
                    32557.8
                  ],
                  [
                    41512.3,
                    32782.1
                  ],
                  [
                    41268.9,
                    32845.5
                  ],
                  [
                    41490.9,
                    33212.4
                  ],
                  [
                    41832.8,
                    32837
                  ]
                ],
                "id": 134,
                "chat_link": "[&BIYAAAA=]"
              }
            },
            "adventures": [],
            "id": 617,
            "mastery_points": []
          },
          "618": {
            "name": "Beta Test",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {
              "102": {
                "name": "Aethervolt Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41102.5,
                  33325.6
                ],
                "id": 102,
                "chat_link": "[&BGYAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "133": {
                "name": "Venlin Vale",
                "level": 16,
                "coord": [
                  40883.2,
                  33161.9
                ],
                "bounds": [
                  [
                    40781.7,
                    32620.8
                  ],
                  [
                    40926.1,
                    32757.6
                  ],
                  [
                    41194.4,
                    32858.9
                  ],
                  [
                    41273.5,
                    32847.7
                  ],
                  [
                    41642.7,
                    33432.2
                  ],
                  [
                    41606.8,
                    33552.3
                  ],
                  [
                    41152.7,
                    33576.8
                  ],
                  [
                    40807.1,
                    33535.1
                  ],
                  [
                    40766.1,
                    33570.1
                  ],
                  [
                    40390.1,
                    33538
                  ],
                  [
                    40387.6,
                    33339
                  ],
                  [
                    40550.8,
                    32978.2
                  ],
                  [
                    40485.6,
                    32940.4
                  ],
                  [
                    40399.6,
                    32719.8
                  ],
                  [
                    40781.7,
                    32620.8
                  ]
                ],
                "id": 133,
                "chat_link": "[&BIUAAAA=]"
              }
            },
            "adventures": [],
            "id": 618,
            "mastery_points": []
          },
          "619": {
            "name": "Beta Test",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 619,
            "mastery_points": []
          },
          "620": {
            "name": "Any Sufficiently Advanced Science",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {
              "1182": {
                "name": "Zojja's Workstation (Don't Touch!)",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38182.9,
                  37334
                ],
                "id": 1182,
                "chat_link": "[&BJ4EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "920": {
                "name": "Snaff Memorial Lab",
                "level": 0,
                "coord": [
                  38014.6,
                  37408.8
                ],
                "bounds": [
                  [
                    37572.9,
                    37270.8
                  ],
                  [
                    38154.6,
                    37083.7
                  ],
                  [
                    38299.6,
                    37250.7
                  ],
                  [
                    38309.6,
                    37463.1
                  ],
                  [
                    38020.6,
                    37738.9
                  ],
                  [
                    37730.4,
                    37645.5
                  ],
                  [
                    37572.9,
                    37270.8
                  ]
                ],
                "id": 920,
                "chat_link": "[&BJgDAAA=]"
              }
            },
            "adventures": [],
            "id": 620,
            "mastery_points": []
          },
          "621": {
            "name": "Any Sufficiently Advanced Science",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {
              "59": {
                "name": "Conduit Tower Blig",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41373.6,
                  34433.3
                ],
                "id": 59,
                "chat_link": "[&BDsAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "144": {
                "name": "Luminates Plant",
                "level": 12,
                "coord": [
                  41917.4,
                  34582.1
                ],
                "bounds": [
                  [
                    41447.1,
                    34482.7
                  ],
                  [
                    41920.9,
                    34260.2
                  ],
                  [
                    42131.9,
                    34313.2
                  ],
                  [
                    42198.6,
                    34583.2
                  ],
                  [
                    42109.1,
                    34865.1
                  ],
                  [
                    41960.3,
                    34866.6
                  ],
                  [
                    41654.3,
                    34703.5
                  ],
                  [
                    41447.1,
                    34482.7
                  ]
                ],
                "id": 144,
                "chat_link": "[&BJAAAAA=]"
              },
              "156": {
                "name": "Hexane Regrade",
                "level": 14,
                "coord": [
                  41672.9,
                  33970.5
                ],
                "bounds": [
                  [
                    41456,
                    34486.8
                  ],
                  [
                    41922,
                    34261.2
                  ],
                  [
                    42133.7,
                    34314.6
                  ],
                  [
                    42182.7,
                    34046.6
                  ],
                  [
                    42132.4,
                    33846.8
                  ],
                  [
                    41861.1,
                    33948.3
                  ],
                  [
                    41525,
                    33947.2
                  ],
                  [
                    41527.8,
                    33778.6
                  ],
                  [
                    41468.1,
                    33506.1
                  ],
                  [
                    41102.8,
                    33459.8
                  ],
                  [
                    41090.8,
                    34079.2
                  ],
                  [
                    41456,
                    34486.8
                  ]
                ],
                "id": 156,
                "chat_link": "[&BJwAAAA=]"
              }
            },
            "adventures": [],
            "id": 621,
            "mastery_points": []
          },
          "622": {
            "name": "Bad Forecast",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {
              "76": {
                "name": "Invariant Base",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40513,
                  32844.1
                ],
                "id": 76,
                "chat_link": "[&BEwAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "131": {
                "name": "Gotala Cascade",
                "level": 23,
                "coord": [
                  40476,
                  32400.7
                ],
                "bounds": [
                  [
                    40541.2,
                    31974.3
                  ],
                  [
                    40338.3,
                    32191.9
                  ],
                  [
                    40162.7,
                    32607.3
                  ],
                  [
                    40400.4,
                    32723.7
                  ],
                  [
                    40781.8,
                    32622.1
                  ],
                  [
                    40631.9,
                    32284.9
                  ],
                  [
                    40541.2,
                    31974.3
                  ]
                ],
                "id": 131,
                "chat_link": "[&BIMAAAA=]"
              }
            },
            "adventures": [],
            "id": 622,
            "mastery_points": []
          },
          "623": {
            "name": "Industrial Espionage",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {
              "76": {
                "name": "Invariant Base",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40513,
                  32844.1
                ],
                "id": 76,
                "chat_link": "[&BEwAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "131": {
                "name": "Gotala Cascade",
                "level": 23,
                "coord": [
                  40476,
                  32400.7
                ],
                "bounds": [
                  [
                    40541.2,
                    31974.3
                  ],
                  [
                    40338.3,
                    32191.9
                  ],
                  [
                    40162.7,
                    32607.3
                  ],
                  [
                    40400.4,
                    32723.7
                  ],
                  [
                    40781.8,
                    32622.1
                  ],
                  [
                    40631.9,
                    32284.9
                  ],
                  [
                    40541.2,
                    31974.3
                  ]
                ],
                "id": 131,
                "chat_link": "[&BIMAAAA=]"
              },
              "133": {
                "name": "Venlin Vale",
                "level": 16,
                "coord": [
                  40883.2,
                  33161.9
                ],
                "bounds": [
                  [
                    40781.7,
                    32620.8
                  ],
                  [
                    40926.1,
                    32757.6
                  ],
                  [
                    41194.4,
                    32858.9
                  ],
                  [
                    41273.5,
                    32847.7
                  ],
                  [
                    41642.7,
                    33432.2
                  ],
                  [
                    41606.8,
                    33552.3
                  ],
                  [
                    41152.7,
                    33576.8
                  ],
                  [
                    40807.1,
                    33535.1
                  ],
                  [
                    40766.1,
                    33570.1
                  ],
                  [
                    40390.1,
                    33538
                  ],
                  [
                    40387.6,
                    33339
                  ],
                  [
                    40550.8,
                    32978.2
                  ],
                  [
                    40485.6,
                    32940.4
                  ],
                  [
                    40399.6,
                    32719.8
                  ],
                  [
                    40781.7,
                    32620.8
                  ]
                ],
                "id": 133,
                "chat_link": "[&BIUAAAA=]"
              }
            },
            "adventures": [],
            "id": 623,
            "mastery_points": []
          },
          "624": {
            "name": "Split Second",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "123": {
                "name": "The Wendon Steps",
                "level": 19,
                "coord": [
                  41781.1,
                  31268.7
                ],
                "bounds": [
                  [
                    41628.3,
                    31879.3
                  ],
                  [
                    41436.3,
                    31544.2
                  ],
                  [
                    41294.5,
                    31539.8
                  ],
                  [
                    41412.9,
                    30921.2
                  ],
                  [
                    41568.6,
                    30902.5
                  ],
                  [
                    41759.5,
                    30910.8
                  ],
                  [
                    42112.9,
                    30816.2
                  ],
                  [
                    42161.1,
                    30946.1
                  ],
                  [
                    42128.5,
                    31211.5
                  ],
                  [
                    42195.1,
                    31619.6
                  ],
                  [
                    41894,
                    31664.9
                  ],
                  [
                    41628.3,
                    31879.3
                  ]
                ],
                "id": 123,
                "chat_link": "[&BHsAAAA=]"
              }
            },
            "adventures": [],
            "id": 624,
            "mastery_points": []
          },
          "625": {
            "name": "Carry a Big Stick",
            "min_level": 20,
            "max_level": 25,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {
              "1183": {
                "name": "Usability Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38623.7,
                  38124.4
                ],
                "id": 1183,
                "chat_link": "[&BJ8EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "922": {
                "name": "Idea Incubation lab",
                "level": 0,
                "coord": [
                  38796.7,
                  38172.9
                ],
                "bounds": [
                  [
                    38628,
                    37783
                  ],
                  [
                    39482.6,
                    38171.2
                  ],
                  [
                    38913.7,
                    38626.3
                  ],
                  [
                    38405.5,
                    38514.4
                  ],
                  [
                    38553.4,
                    37769.6
                  ],
                  [
                    38628,
                    37783
                  ]
                ],
                "id": 922,
                "chat_link": "[&BJoDAAA=]"
              }
            },
            "adventures": [],
            "id": 625,
            "mastery_points": []
          },
          "628": {
            "name": "Stealing Secrets",
            "min_level": 40,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "259": {
                "name": "Cornucopian Fields",
                "level": 30,
                "coord": [
                  48795.6,
                  30295.1
                ],
                "bounds": [
                  [
                    48209,
                    30758.8
                  ],
                  [
                    48562,
                    30773.8
                  ],
                  [
                    48775.2,
                    30765
                  ],
                  [
                    48811.6,
                    30734.8
                  ],
                  [
                    49331.8,
                    30790.3
                  ],
                  [
                    49414.7,
                    30633.4
                  ],
                  [
                    49352.5,
                    30429.6
                  ],
                  [
                    49259.9,
                    30452.6
                  ],
                  [
                    49081.5,
                    30191.9
                  ],
                  [
                    49069.8,
                    29808.5
                  ],
                  [
                    48940.2,
                    29689
                  ],
                  [
                    48847,
                    29703.6
                  ],
                  [
                    48690.3,
                    29841
                  ],
                  [
                    48380.1,
                    29858.7
                  ],
                  [
                    48270.2,
                    29956.3
                  ],
                  [
                    48222,
                    30265.8
                  ],
                  [
                    48307.9,
                    30363.8
                  ],
                  [
                    48209,
                    30758.8
                  ]
                ],
                "id": 259,
                "chat_link": "[&BAMBAAA=]"
              }
            },
            "adventures": [],
            "id": 628,
            "mastery_points": []
          },
          "629": {
            "name": "A Bold New Theory",
            "min_level": 30,
            "max_level": 35,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 629,
            "mastery_points": []
          },
          "630": {
            "name": "Forging Permission",
            "min_level": 30,
            "max_level": 35,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {
              "1183": {
                "name": "Usability Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38623.7,
                  38124.4
                ],
                "id": 1183,
                "chat_link": "[&BJ8EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "922": {
                "name": "Idea Incubation lab",
                "level": 0,
                "coord": [
                  38796.7,
                  38172.9
                ],
                "bounds": [
                  [
                    38628,
                    37783
                  ],
                  [
                    39482.6,
                    38171.2
                  ],
                  [
                    38913.7,
                    38626.3
                  ],
                  [
                    38405.5,
                    38514.4
                  ],
                  [
                    38553.4,
                    37769.6
                  ],
                  [
                    38628,
                    37783
                  ]
                ],
                "id": 922,
                "chat_link": "[&BJoDAAA=]"
              }
            },
            "adventures": [],
            "id": 630,
            "mastery_points": []
          },
          "631": {
            "name": "Forging Permission",
            "min_level": 30,
            "max_level": 35,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "921": {
                "name": "Advanced Metamystics Lab",
                "level": 0,
                "coord": [
                  38698.8,
                  36297
                ],
                "bounds": [
                  [
                    38340.1,
                    36315.2
                  ],
                  [
                    38624.3,
                    36140.8
                  ],
                  [
                    38973.6,
                    36234.3
                  ],
                  [
                    38857.2,
                    36497.8
                  ],
                  [
                    38340.1,
                    36315.2
                  ]
                ],
                "id": 921,
                "chat_link": "[&BJkDAAA=]"
              }
            },
            "adventures": [],
            "id": 631,
            "mastery_points": []
          },
          "634": {
            "name": "Containment",
            "min_level": 40,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {
              "293": {
                "name": "Priory Archives",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50509.3,
                  31048.7
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              },
              "294": {
                "name": "Ogden's Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50800.9,
                  31369.9
                ],
                "id": 294,
                "chat_link": "[&BCYBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "947": {
                "name": "Durmand Priory",
                "level": 31,
                "coord": [
                  50600.6,
                  31003.3
                ],
                "bounds": [
                  [
                    50368,
                    31537.9
                  ],
                  [
                    50781.9,
                    31388
                  ],
                  [
                    50876.9,
                    30987
                  ],
                  [
                    50824.2,
                    30793.6
                  ],
                  [
                    50731,
                    30797.9
                  ],
                  [
                    50659.6,
                    30721.1
                  ],
                  [
                    50338.2,
                    30741.7
                  ],
                  [
                    50224.6,
                    31059.4
                  ],
                  [
                    50368,
                    31537.9
                  ]
                ],
                "id": 947,
                "chat_link": "[&BLMDAAA=]"
              }
            },
            "adventures": [],
            "id": 634,
            "mastery_points": []
          },
          "635": {
            "name": "Containment",
            "min_level": 40,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "329": {
                "name": "Reaper's Gate",
                "level": 34,
                "coord": [
                  52112,
                  32128.4
                ],
                "bounds": [
                  [
                    52094.3,
                    32396.4
                  ],
                  [
                    52224.8,
                    32397.6
                  ],
                  [
                    52246.8,
                    32193.3
                  ],
                  [
                    52230.7,
                    32027.7
                  ],
                  [
                    52186,
                    31926.6
                  ],
                  [
                    52100,
                    31910.2
                  ],
                  [
                    51701.4,
                    32047.3
                  ],
                  [
                    52094.3,
                    32396.4
                  ]
                ],
                "id": 329,
                "chat_link": "[&BEkBAAA=]"
              },
              "339": {
                "name": "Lake of Lamentation",
                "level": 32,
                "coord": [
                  51824.8,
                  31661.3
                ],
                "bounds": [
                  [
                    52100,
                    31910.1
                  ],
                  [
                    51700.7,
                    32046.6
                  ],
                  [
                    51615.8,
                    32029
                  ],
                  [
                    51360.2,
                    32224.5
                  ],
                  [
                    51434.5,
                    31680.1
                  ],
                  [
                    51189,
                    31519.8
                  ],
                  [
                    51248.9,
                    31223.6
                  ],
                  [
                    51755.3,
                    31012.2
                  ],
                  [
                    51967.2,
                    31228.5
                  ],
                  [
                    51881.1,
                    31410.6
                  ],
                  [
                    52137.9,
                    31566.1
                  ],
                  [
                    52255.5,
                    31584.7
                  ],
                  [
                    52290.6,
                    31717.6
                  ],
                  [
                    52249.2,
                    31838.7
                  ],
                  [
                    52186.2,
                    31926.9
                  ],
                  [
                    52100,
                    31910.1
                  ]
                ],
                "id": 339,
                "chat_link": "[&BFMBAAA=]"
              }
            },
            "adventures": [],
            "id": 635,
            "mastery_points": []
          },
          "636": {
            "name": "Hazardous Environment",
            "min_level": 30,
            "max_level": 35,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "921": {
                "name": "Advanced Metamystics Lab",
                "level": 0,
                "coord": [
                  38698.8,
                  36297
                ],
                "bounds": [
                  [
                    38340.1,
                    36315.2
                  ],
                  [
                    38624.3,
                    36140.8
                  ],
                  [
                    38973.6,
                    36234.3
                  ],
                  [
                    38857.2,
                    36497.8
                  ],
                  [
                    38340.1,
                    36315.2
                  ]
                ],
                "id": 921,
                "chat_link": "[&BJkDAAA=]"
              }
            },
            "adventures": [],
            "id": 636,
            "mastery_points": []
          },
          "638": {
            "name": "Down the Hatch",
            "min_level": 40,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {
              "957": {
                "name": "Jackdaw's Reef",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48726.5,
                  29400.5
                ],
                "id": 957,
                "chat_link": "[&BL0DAAA=]"
              },
              "958": {
                "name": "Slade's Bay",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48562.2,
                  29521.7
                ],
                "id": 958,
                "chat_link": "[&BL4DAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "256": {
                "name": "Provern Shore",
                "level": 32,
                "coord": [
                  48556,
                  28887.1
                ],
                "bounds": [
                  [
                    48078.6,
                    28867.3
                  ],
                  [
                    48275.3,
                    29091.4
                  ],
                  [
                    48397,
                    28943.1
                  ],
                  [
                    48590.5,
                    28957.3
                  ],
                  [
                    48636.1,
                    29122.1
                  ],
                  [
                    48793.1,
                    29207.7
                  ],
                  [
                    48926.3,
                    29053.1
                  ],
                  [
                    48860.2,
                    28766
                  ],
                  [
                    48876.2,
                    28634.8
                  ],
                  [
                    48535.9,
                    28630.1
                  ],
                  [
                    48463.8,
                    28660.6
                  ],
                  [
                    48454.1,
                    28739.2
                  ],
                  [
                    48341.2,
                    28859.4
                  ],
                  [
                    48078.6,
                    28867.3
                  ]
                ],
                "id": 256,
                "chat_link": "[&BAABAAA=]"
              },
              "257": {
                "name": "Lake Gendarr",
                "level": 32,
                "coord": [
                  48617.2,
                  29472
                ],
                "bounds": [
                  [
                    48291.8,
                    29409.3
                  ],
                  [
                    48228.5,
                    29268.8
                  ],
                  [
                    48277.1,
                    29092.8
                  ],
                  [
                    48397,
                    28943.5
                  ],
                  [
                    48591.1,
                    28956.6
                  ],
                  [
                    48644,
                    29118.1
                  ],
                  [
                    48794,
                    29200.4
                  ],
                  [
                    48687.9,
                    29211.6
                  ],
                  [
                    48541.4,
                    29176.6
                  ],
                  [
                    48419.9,
                    29471.2
                  ],
                  [
                    48441,
                    29565.3
                  ],
                  [
                    48770.7,
                    29660.2
                  ],
                  [
                    48868.6,
                    29581.3
                  ],
                  [
                    48687.5,
                    29211.5
                  ],
                  [
                    48792.3,
                    29200
                  ],
                  [
                    48849.3,
                    29134.9
                  ],
                  [
                    48925.7,
                    29332.6
                  ],
                  [
                    49030.2,
                    29425.4
                  ],
                  [
                    49174.9,
                    29648.6
                  ],
                  [
                    49148.8,
                    29769.1
                  ],
                  [
                    49072,
                    29814
                  ],
                  [
                    48940.3,
                    29688.5
                  ],
                  [
                    48846.8,
                    29701.7
                  ],
                  [
                    48691.8,
                    29840
                  ],
                  [
                    48380.1,
                    29857.5
                  ],
                  [
                    48269,
                    29955.4
                  ],
                  [
                    48086.2,
                    29945.4
                  ],
                  [
                    48013.3,
                    29900.8
                  ],
                  [
                    48036.8,
                    29608
                  ],
                  [
                    48291.8,
                    29409.3
                  ]
                ],
                "id": 257,
                "chat_link": "[&BAEBAAA=]"
              },
              "826": {
                "name": "Brigantine Isles",
                "level": 32,
                "coord": [
                  48621.3,
                  29444.6
                ],
                "bounds": [
                  [
                    48419.8,
                    29471.5
                  ],
                  [
                    48541.3,
                    29177.2
                  ],
                  [
                    48687.5,
                    29212.1
                  ],
                  [
                    48869,
                    29581.3
                  ],
                  [
                    48769.3,
                    29660.2
                  ],
                  [
                    48440.8,
                    29565.2
                  ],
                  [
                    48419.8,
                    29471.5
                  ]
                ],
                "id": 826,
                "chat_link": "[&BDoDAAA=]"
              }
            },
            "adventures": [],
            "id": 638,
            "mastery_points": []
          },
          "642": {
            "name": "The Stone Sheath",
            "min_level": 40,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {
              "285": {
                "name": "Greybeard's Landing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50659.3,
                  33739
                ],
                "id": 285,
                "chat_link": "[&BB0BAAA=]"
              },
              "286": {
                "name": "Jetsam Isle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50980.5,
                  33245.2
                ],
                "id": 286,
                "chat_link": "[&BB4BAAA=]"
              },
              "287": {
                "name": "Koolookuu",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51122.5,
                  33211.1
                ],
                "id": 287,
                "chat_link": "[&BB8BAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "320": {
                "name": "Demon's Maw",
                "level": 39,
                "coord": [
                  50789.2,
                  34283.6
                ],
                "bounds": [
                  [
                    50346,
                    34168.2
                  ],
                  [
                    50439,
                    34246.6
                  ],
                  [
                    50467,
                    34355.7
                  ],
                  [
                    50573.2,
                    34473.8
                  ],
                  [
                    50722,
                    34503.7
                  ],
                  [
                    50910.7,
                    34465.6
                  ],
                  [
                    51043.3,
                    34502.3
                  ],
                  [
                    51108.9,
                    34496.7
                  ],
                  [
                    51270.3,
                    34453.7
                  ],
                  [
                    51395,
                    34482.1
                  ],
                  [
                    51415.6,
                    34124.1
                  ],
                  [
                    50886.5,
                    33913.9
                  ],
                  [
                    50439.4,
                    33952.7
                  ],
                  [
                    50451.5,
                    34068.3
                  ],
                  [
                    50369.4,
                    34046.4
                  ],
                  [
                    50346,
                    34168.2
                  ]
                ],
                "id": 320,
                "chat_link": "[&BEABAAA=]"
              },
              "322": {
                "name": "Winterthaw Snowfield",
                "level": 36,
                "coord": [
                  51784.6,
                  32925.1
                ],
                "bounds": [
                  [
                    51623.1,
                    33220.3
                  ],
                  [
                    51222.5,
                    33073.8
                  ],
                  [
                    50977.3,
                    32853.2
                  ],
                  [
                    51388.2,
                    32609.3
                  ],
                  [
                    51390,
                    32633.5
                  ],
                  [
                    51639.6,
                    32805.4
                  ],
                  [
                    51705.4,
                    32818.6
                  ],
                  [
                    51782.5,
                    32940.7
                  ],
                  [
                    51862.9,
                    32974.6
                  ],
                  [
                    51893.1,
                    32960.5
                  ],
                  [
                    52010.2,
                    32969.1
                  ],
                  [
                    52043.4,
                    32942.1
                  ],
                  [
                    52259.1,
                    32838.1
                  ],
                  [
                    52266,
                    32936.2
                  ],
                  [
                    52211.6,
                    32980.2
                  ],
                  [
                    52279.1,
                    33245.6
                  ],
                  [
                    51623.1,
                    33220.3
                  ]
                ],
                "id": 322,
                "chat_link": "[&BEIBAAA=]"
              },
              "323": {
                "name": "Lost Delver's Ridge",
                "level": 37,
                "coord": [
                  51441.3,
                  33662.5
                ],
                "bounds": [
                  [
                    50878.3,
                    33920.2
                  ],
                  [
                    51155.9,
                    33686.5
                  ],
                  [
                    51221.3,
                    33071
                  ],
                  [
                    51622.9,
                    33220.6
                  ],
                  [
                    51648.5,
                    33469.8
                  ],
                  [
                    51952.9,
                    33858
                  ],
                  [
                    51643.7,
                    33943.9
                  ],
                  [
                    51407.3,
                    34129.7
                  ],
                  [
                    50878.3,
                    33920.2
                  ]
                ],
                "id": 323,
                "chat_link": "[&BEMBAAA=]"
              },
              "324": {
                "name": "False Lake",
                "level": 37,
                "coord": [
                  50766.3,
                  33442.3
                ],
                "bounds": [
                  [
                    50582,
                    33943.7
                  ],
                  [
                    50878.7,
                    33920
                  ],
                  [
                    51156.8,
                    33686.8
                  ],
                  [
                    51221.6,
                    33071
                  ],
                  [
                    50977.3,
                    32853.6
                  ],
                  [
                    50684.4,
                    32962.5
                  ],
                  [
                    50695.9,
                    33279
                  ],
                  [
                    50734.1,
                    33322.4
                  ],
                  [
                    50726.8,
                    33375.1
                  ],
                  [
                    50690.9,
                    33400.7
                  ],
                  [
                    50417.6,
                    33529.6
                  ],
                  [
                    50430,
                    33963.8
                  ],
                  [
                    50582,
                    33943.7
                  ]
                ],
                "id": 324,
                "chat_link": "[&BEQBAAA=]"
              }
            },
            "adventures": [],
            "id": 642,
            "mastery_points": []
          },
          "643": {
            "name": "Bad Blood",
            "min_level": 40,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {
              "1221": {
                "name": "Windy Cave",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  51050.3,
                  30561.5
                ],
                "id": 1221,
                "chat_link": "[&BMUEAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "332": {
                "name": "Mistriven Gorge",
                "level": 28,
                "coord": [
                  51098.2,
                  30808.6
                ],
                "bounds": [
                  [
                    51312,
                    30618.8
                  ],
                  [
                    51262.3,
                    30390.1
                  ],
                  [
                    50982,
                    30444
                  ],
                  [
                    50824.3,
                    30793.6
                  ],
                  [
                    50876.4,
                    30985.9
                  ],
                  [
                    51178.8,
                    31207.9
                  ],
                  [
                    51251.9,
                    31219.4
                  ],
                  [
                    51312,
                    30618.8
                  ]
                ],
                "id": 332,
                "chat_link": "[&BEwBAAA=]"
              }
            },
            "adventures": [],
            "id": 643,
            "mastery_points": []
          },
          "644": {
            "name": "Test Subject",
            "min_level": 30,
            "max_level": 35,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "141": {
                "name": "Duskstruck Moors",
                "level": 24,
                "coord": [
                  39544.2,
                  32639.6
                ],
                "bounds": [
                  [
                    39521.7,
                    32847
                  ],
                  [
                    39671.3,
                    32919.2
                  ],
                  [
                    40171,
                    32603.6
                  ],
                  [
                    39935,
                    32268.7
                  ],
                  [
                    39654.9,
                    32495.1
                  ],
                  [
                    39219.9,
                    32525.5
                  ],
                  [
                    38994.4,
                    32627.4
                  ],
                  [
                    39185.7,
                    32830.7
                  ],
                  [
                    39521.7,
                    32847
                  ]
                ],
                "id": 141,
                "chat_link": "[&BI0AAAA=]"
              }
            },
            "adventures": [],
            "id": 644,
            "mastery_points": []
          },
          "645": {
            "name": "Field Test",
            "min_level": 30,
            "max_level": 35,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "244": {
                "name": "Traveler's Dale",
                "level": 26,
                "coord": [
                  46453.8,
                  30349.3
                ],
                "bounds": [
                  [
                    46264.8,
                    30594.1
                  ],
                  [
                    46442,
                    30536.7
                  ],
                  [
                    46708.3,
                    30381.3
                  ],
                  [
                    46785,
                    30297
                  ],
                  [
                    46743.3,
                    30163.7
                  ],
                  [
                    46630.5,
                    30092.2
                  ],
                  [
                    46426.6,
                    30048.8
                  ],
                  [
                    46387.5,
                    30318.8
                  ],
                  [
                    46373.8,
                    30434.5
                  ],
                  [
                    46143.6,
                    30447.3
                  ],
                  [
                    46086.6,
                    30527.7
                  ],
                  [
                    46264.8,
                    30594.1
                  ]
                ],
                "id": 244,
                "chat_link": "[&BPQAAAA=]"
              },
              "251": {
                "name": "Talajian Piedmont",
                "level": 26,
                "coord": [
                  46802.4,
                  29948.3
                ],
                "bounds": [
                  [
                    46424.6,
                    29980.5
                  ],
                  [
                    46668.7,
                    29738.1
                  ],
                  [
                    46674.8,
                    29614.7
                  ],
                  [
                    46773.9,
                    29595.7
                  ],
                  [
                    46805.1,
                    29719.5
                  ],
                  [
                    46938.8,
                    29864.9
                  ],
                  [
                    47100.7,
                    29869.4
                  ],
                  [
                    47162.3,
                    29976.3
                  ],
                  [
                    47166.3,
                    30157.5
                  ],
                  [
                    46951.2,
                    30158.1
                  ],
                  [
                    46779.4,
                    30293.5
                  ],
                  [
                    46737.5,
                    30168.9
                  ],
                  [
                    46625.6,
                    30092.3
                  ],
                  [
                    46424.3,
                    30046.5
                  ],
                  [
                    46424.6,
                    29980.5
                  ]
                ],
                "id": 251,
                "chat_link": "[&BPsAAAA=]"
              },
              "252": {
                "name": "The Lawen Ponds",
                "level": 26,
                "coord": [
                  46865.1,
                  30474.5
                ],
                "bounds": [
                  [
                    46401.4,
                    30686.6
                  ],
                  [
                    46605.5,
                    30634.3
                  ],
                  [
                    47184.1,
                    30609.5
                  ],
                  [
                    47374.1,
                    30646.1
                  ],
                  [
                    47571.1,
                    30559.5
                  ],
                  [
                    47440.2,
                    30249.1
                  ],
                  [
                    47210.5,
                    30156.4
                  ],
                  [
                    46950.8,
                    30157.9
                  ],
                  [
                    46780.5,
                    30295.8
                  ],
                  [
                    46708.1,
                    30378.5
                  ],
                  [
                    46443.3,
                    30534.2
                  ],
                  [
                    46263.7,
                    30592.3
                  ],
                  [
                    46313.5,
                    30668.1
                  ],
                  [
                    46401.4,
                    30686.6
                  ]
                ],
                "id": 252,
                "chat_link": "[&BPwAAAA=]"
              }
            },
            "adventures": [],
            "id": 645,
            "mastery_points": []
          },
          "652": {
            "name": "A Meeting of the Minds",
            "min_level": 30,
            "max_level": 35,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {
              "1177": {
                "name": "Thamaturgic Calculus",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38695,
                  37271.1
                ],
                "id": 1177,
                "chat_link": "[&BJkEAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "935": {
                "name": "Creator's Commons",
                "level": 0,
                "coord": [
                  38725.7,
                  37105.6
                ],
                "bounds": [
                  [
                    38890.6,
                    37199.7
                  ],
                  [
                    38851.6,
                    37246.3
                  ],
                  [
                    38556.2,
                    37195.3
                  ],
                  [
                    38538.5,
                    37147.2
                  ],
                  [
                    38732.7,
                    36917.9
                  ],
                  [
                    38784.3,
                    36927
                  ],
                  [
                    38890.6,
                    37199.7
                  ]
                ],
                "id": 935,
                "chat_link": "[&BKcDAAA=]"
              },
              "937": {
                "name": "College of Synergetics",
                "level": 0,
                "coord": [
                  38689.1,
                  37305.5
                ],
                "bounds": [
                  [
                    38556.4,
                    37194.6
                  ],
                  [
                    38658.8,
                    37475.8
                  ],
                  [
                    38852,
                    37246.1
                  ],
                  [
                    38556.4,
                    37194.6
                  ]
                ],
                "id": 937,
                "chat_link": "[&BKkDAAA=]"
              }
            },
            "adventures": [],
            "id": 652,
            "mastery_points": []
          },
          "653": {
            "name": "Mightier than the Sword",
            "min_level": 40,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {
              "281": {
                "name": "Black Barl's Mill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50968.1,
                  34092.9
                ],
                "id": 281,
                "chat_link": "[&BBkBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "320": {
                "name": "Demon's Maw",
                "level": 39,
                "coord": [
                  50789.2,
                  34283.6
                ],
                "bounds": [
                  [
                    50346,
                    34168.2
                  ],
                  [
                    50439,
                    34246.6
                  ],
                  [
                    50467,
                    34355.7
                  ],
                  [
                    50573.2,
                    34473.8
                  ],
                  [
                    50722,
                    34503.7
                  ],
                  [
                    50910.7,
                    34465.6
                  ],
                  [
                    51043.3,
                    34502.3
                  ],
                  [
                    51108.9,
                    34496.7
                  ],
                  [
                    51270.3,
                    34453.7
                  ],
                  [
                    51395,
                    34482.1
                  ],
                  [
                    51415.6,
                    34124.1
                  ],
                  [
                    50886.5,
                    33913.9
                  ],
                  [
                    50439.4,
                    33952.7
                  ],
                  [
                    50451.5,
                    34068.3
                  ],
                  [
                    50369.4,
                    34046.4
                  ],
                  [
                    50346,
                    34168.2
                  ]
                ],
                "id": 320,
                "chat_link": "[&BEABAAA=]"
              },
              "323": {
                "name": "Lost Delver's Ridge",
                "level": 37,
                "coord": [
                  51441.3,
                  33662.5
                ],
                "bounds": [
                  [
                    50878.3,
                    33920.2
                  ],
                  [
                    51155.9,
                    33686.5
                  ],
                  [
                    51221.3,
                    33071
                  ],
                  [
                    51622.9,
                    33220.6
                  ],
                  [
                    51648.5,
                    33469.8
                  ],
                  [
                    51952.9,
                    33858
                  ],
                  [
                    51643.7,
                    33943.9
                  ],
                  [
                    51407.3,
                    34129.7
                  ],
                  [
                    50878.3,
                    33920.2
                  ]
                ],
                "id": 323,
                "chat_link": "[&BEMBAAA=]"
              }
            },
            "adventures": [],
            "id": 653,
            "mastery_points": []
          },
          "655": {
            "name": "Lines of Communication",
            "min_level": 30,
            "max_level": 35,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 655,
            "mastery_points": []
          },
          "656": {
            "name": "Untamed Wilds",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              62998,
              30464
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                61952,
                28544
              ],
              [
                64000,
                32640
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "498": {
                "name": "Agrak Kraal",
                "level": 45,
                "coord": [
                  63888,
                  30702.1
                ],
                "bounds": [
                  [
                    63855.5,
                    30566.8
                  ],
                  [
                    63937.4,
                    30576.7
                  ],
                  [
                    63946.3,
                    30708
                  ],
                  [
                    63970,
                    30827.9
                  ],
                  [
                    63847.8,
                    30864
                  ],
                  [
                    63771.2,
                    30669.4
                  ],
                  [
                    63855.5,
                    30566.8
                  ]
                ],
                "id": 498,
                "chat_link": "[&BPIBAAA=]"
              }
            },
            "adventures": [],
            "id": 656,
            "mastery_points": []
          },
          "657": {
            "name": "An Apple a Day",
            "min_level": 40,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              49212,
              33792
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                30720,
                39936
              ]
            ],
            "continent_rect": [
              [
                48000,
                32256
              ],
              [
                50432,
                35456
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "305": {
                "name": "Stormbluff Isle",
                "level": 47,
                "coord": [
                  49212.5,
                  32967.3
                ],
                "bounds": [
                  [
                    49057.7,
                    33171.9
                  ],
                  [
                    49207.4,
                    33295
                  ],
                  [
                    49604,
                    33068.6
                  ],
                  [
                    49587.3,
                    32785.5
                  ],
                  [
                    49246.8,
                    32673.5
                  ],
                  [
                    48904.9,
                    32853.6
                  ],
                  [
                    48879.1,
                    32922.9
                  ],
                  [
                    49057.7,
                    33171.9
                  ]
                ],
                "id": 305,
                "chat_link": "[&BDEBAAA=]"
              },
              "312": {
                "name": "Archen Foreland",
                "level": 46,
                "coord": [
                  49335.2,
                  32456.4
                ],
                "bounds": [
                  [
                    49792.2,
                    32230
                  ],
                  [
                    49830.4,
                    32518.5
                  ],
                  [
                    49585.7,
                    32785.6
                  ],
                  [
                    49246.4,
                    32673.7
                  ],
                  [
                    48905.2,
                    32854.1
                  ],
                  [
                    48746,
                    32449.7
                  ],
                  [
                    48731.1,
                    32206.3
                  ],
                  [
                    49531.7,
                    32194.2
                  ],
                  [
                    49648,
                    32195.5
                  ],
                  [
                    49792.2,
                    32230
                  ]
                ],
                "id": 312,
                "chat_link": "[&BDgBAAA=]"
              }
            },
            "adventures": [],
            "id": 657,
            "mastery_points": []
          },
          "658": {
            "name": "Base of Operations",
            "min_level": 40,
            "max_level": 40,
            "default_floor": -3,
            "label_coord": [
              49212,
              33792
            ],
            "map_rect": [
              [
                -12288,
                -12288
              ],
              [
                12288,
                12288
              ]
            ],
            "continent_rect": [
              [
                48768,
                32384
              ],
              [
                49792,
                33408
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 658,
            "mastery_points": []
          },
          "659": {
            "name": "The Lost Chieftain's Return",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              62998,
              30464
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                61952,
                28544
              ],
              [
                64000,
                32640
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "492": {
                "name": "Pockmark Roughs",
                "level": 45,
                "coord": [
                  63227.9,
                  31010.7
                ],
                "bounds": [
                  [
                    62841,
                    30913.6
                  ],
                  [
                    62955.5,
                    30712.2
                  ],
                  [
                    63229.3,
                    30638.3
                  ],
                  [
                    63447.8,
                    30736.4
                  ],
                  [
                    63538.4,
                    30885.5
                  ],
                  [
                    63527.2,
                    31093
                  ],
                  [
                    63443.4,
                    31236.1
                  ],
                  [
                    63307.8,
                    31352.4
                  ],
                  [
                    63109.2,
                    31370.7
                  ],
                  [
                    62879.8,
                    31168.8
                  ],
                  [
                    62841,
                    30913.6
                  ]
                ],
                "id": 492,
                "chat_link": "[&BOwBAAA=]"
              },
              "495": {
                "name": "Unbroken Expanse",
                "level": 45,
                "coord": [
                  63211.9,
                  30390.3
                ],
                "bounds": [
                  [
                    63228.8,
                    30645.9
                  ],
                  [
                    63447.9,
                    30738.9
                  ],
                  [
                    63594.9,
                    30605.9
                  ],
                  [
                    63546,
                    30298.3
                  ],
                  [
                    63595.9,
                    30138.5
                  ],
                  [
                    63083,
                    29956.2
                  ],
                  [
                    62925.8,
                    30070.6
                  ],
                  [
                    62926.9,
                    30273.4
                  ],
                  [
                    62810.4,
                    30458.3
                  ],
                  [
                    62959.4,
                    30717.1
                  ],
                  [
                    63228.8,
                    30645.9
                  ]
                ],
                "id": 495,
                "chat_link": "[&BO8BAAA=]"
              },
              "496": {
                "name": "Gastor Gullet",
                "level": 45,
                "coord": [
                  63716,
                  31092.8
                ],
                "bounds": [
                  [
                    63527.8,
                    31091.7
                  ],
                  [
                    63538.8,
                    30886.2
                  ],
                  [
                    63447.1,
                    30737.8
                  ],
                  [
                    63593.5,
                    30606.3
                  ],
                  [
                    63767.3,
                    30670.9
                  ],
                  [
                    63870.3,
                    30901.8
                  ],
                  [
                    63918.4,
                    31019.5
                  ],
                  [
                    63979.9,
                    31145
                  ],
                  [
                    63944.9,
                    31306.2
                  ],
                  [
                    63875,
                    31387.9
                  ],
                  [
                    63782.4,
                    31416.7
                  ],
                  [
                    63740.2,
                    31476.7
                  ],
                  [
                    63594,
                    31418.9
                  ],
                  [
                    63445,
                    31233.4
                  ],
                  [
                    63527.8,
                    31091.7
                  ]
                ],
                "id": 496,
                "chat_link": "[&BPABAAA=]"
              },
              "498": {
                "name": "Agrak Kraal",
                "level": 45,
                "coord": [
                  63888,
                  30702.1
                ],
                "bounds": [
                  [
                    63855.5,
                    30566.8
                  ],
                  [
                    63937.4,
                    30576.7
                  ],
                  [
                    63946.3,
                    30708
                  ],
                  [
                    63970,
                    30827.9
                  ],
                  [
                    63847.8,
                    30864
                  ],
                  [
                    63771.2,
                    30669.4
                  ],
                  [
                    63855.5,
                    30566.8
                  ]
                ],
                "id": 498,
                "chat_link": "[&BPIBAAA=]"
              }
            },
            "adventures": [],
            "id": 659,
            "mastery_points": []
          },
          "662": {
            "name": "Pets and Walls Make Stronger Kraals",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              62998,
              30464
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                61952,
                28544
              ],
              [
                64000,
                32640
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "495": {
                "name": "Unbroken Expanse",
                "level": 45,
                "coord": [
                  63211.9,
                  30390.3
                ],
                "bounds": [
                  [
                    63228.8,
                    30645.9
                  ],
                  [
                    63447.9,
                    30738.9
                  ],
                  [
                    63594.9,
                    30605.9
                  ],
                  [
                    63546,
                    30298.3
                  ],
                  [
                    63595.9,
                    30138.5
                  ],
                  [
                    63083,
                    29956.2
                  ],
                  [
                    62925.8,
                    30070.6
                  ],
                  [
                    62926.9,
                    30273.4
                  ],
                  [
                    62810.4,
                    30458.3
                  ],
                  [
                    62959.4,
                    30717.1
                  ],
                  [
                    63228.8,
                    30645.9
                  ]
                ],
                "id": 495,
                "chat_link": "[&BO8BAAA=]"
              }
            },
            "adventures": [],
            "id": 662,
            "mastery_points": []
          },
          "663": {
            "name": "Doubt",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              53376,
              32960
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                52224,
                31360
              ],
              [
                54528,
                34560
              ]
            ],
            "points_of_interest": {
              "563": {
                "name": "Bergtrolde",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53226.5,
                  32130
                ],
                "id": 563,
                "chat_link": "[&BDMCAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "535": {
                "name": "Graupel Kohn",
                "level": 44,
                "coord": [
                  53519.9,
                  31683.6
                ],
                "bounds": [
                  [
                    53381.6,
                    32253.9
                  ],
                  [
                    53463.6,
                    32107.5
                  ],
                  [
                    53642.7,
                    32096.5
                  ],
                  [
                    53735.5,
                    31756.3
                  ],
                  [
                    53994,
                    31644
                  ],
                  [
                    53957.4,
                    31366.6
                  ],
                  [
                    53756.3,
                    31368
                  ],
                  [
                    53733.9,
                    31238.8
                  ],
                  [
                    53602.2,
                    31248.8
                  ],
                  [
                    53555,
                    31306.4
                  ],
                  [
                    53333.2,
                    31318.6
                  ],
                  [
                    53243.3,
                    31658.9
                  ],
                  [
                    53222.1,
                    31799.3
                  ],
                  [
                    53049,
                    31942.9
                  ],
                  [
                    53128.9,
                    32147.3
                  ],
                  [
                    53381.6,
                    32253.9
                  ]
                ],
                "id": 535,
                "chat_link": "[&BBcCAAA=]"
              }
            },
            "adventures": [],
            "id": 663,
            "mastery_points": []
          },
          "664": {
            "name": "The False God's Lair",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              53376,
              32960
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                52224,
                31360
              ],
              [
                54528,
                34560
              ]
            ],
            "points_of_interest": {
              "557": {
                "name": "Esjudare Scratch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52424.2,
                  33655.3
                ],
                "id": 557,
                "chat_link": "[&BC0CAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "525": {
                "name": "Steelbrachen",
                "level": 40,
                "coord": [
                  52584.8,
                  33227.1
                ],
                "bounds": [
                  [
                    52454.4,
                    33402.8
                  ],
                  [
                    52354,
                    33316.3
                  ],
                  [
                    52305.7,
                    33350
                  ],
                  [
                    52228.9,
                    33357
                  ],
                  [
                    52227,
                    32954.9
                  ],
                  [
                    52562.4,
                    32803.2
                  ],
                  [
                    52948.6,
                    32877.9
                  ],
                  [
                    52908.2,
                    32971.9
                  ],
                  [
                    52930.3,
                    33227.7
                  ],
                  [
                    52824.1,
                    33427.4
                  ],
                  [
                    52734.2,
                    33521.5
                  ],
                  [
                    52540.3,
                    33515.1
                  ],
                  [
                    52454.4,
                    33402.8
                  ]
                ],
                "id": 525,
                "chat_link": "[&BA0CAAA=]"
              },
              "530": {
                "name": "Troll's Teeth",
                "level": 42,
                "coord": [
                  52926.2,
                  32485
                ],
                "bounds": [
                  [
                    52562.3,
                    32803.9
                  ],
                  [
                    52949,
                    32878.3
                  ],
                  [
                    53209.5,
                    32647.3
                  ],
                  [
                    53377.6,
                    32371.2
                  ],
                  [
                    53381.7,
                    32253.2
                  ],
                  [
                    53129.3,
                    32147.4
                  ],
                  [
                    53061.8,
                    32296.7
                  ],
                  [
                    52726.3,
                    32445.3
                  ],
                  [
                    52568.1,
                    32432.5
                  ],
                  [
                    52558.7,
                    32475.5
                  ],
                  [
                    52663.8,
                    32584
                  ],
                  [
                    52562.3,
                    32803.9
                  ]
                ],
                "id": 530,
                "chat_link": "[&BBICAAA=]"
              },
              "531": {
                "name": "Toran Hollow",
                "level": 40,
                "coord": [
                  52395.2,
                  32614.9
                ],
                "bounds": [
                  [
                    52233.9,
                    32427.9
                  ],
                  [
                    52547.4,
                    32338.1
                  ],
                  [
                    52568,
                    32431.3
                  ],
                  [
                    52559.7,
                    32475.8
                  ],
                  [
                    52664.4,
                    32584.5
                  ],
                  [
                    52562.6,
                    32803.3
                  ],
                  [
                    52229.3,
                    32951.5
                  ],
                  [
                    52095.1,
                    32930.2
                  ],
                  [
                    52096.5,
                    32591.7
                  ],
                  [
                    52233.9,
                    32427.9
                  ]
                ],
                "id": 531,
                "chat_link": "[&BBMCAAA=]"
              }
            },
            "adventures": [],
            "id": 664,
            "mastery_points": []
          },
          "666": {
            "name": "Bad Ice",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              53376,
              32960
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                52224,
                31360
              ],
              [
                54528,
                34560
              ]
            ],
            "points_of_interest": {
              "1486": {
                "name": "Falooaloo",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52528.9,
                  31763.5
                ],
                "id": 1486,
                "chat_link": "[&BM4FAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "532": {
                "name": "Wyrmblood Lake",
                "level": 42,
                "coord": [
                  52428.9,
                  31717.9
                ],
                "bounds": [
                  [
                    52706.7,
                    31305.5
                  ],
                  [
                    52695.8,
                    31728.3
                  ],
                  [
                    52706.9,
                    32138.8
                  ],
                  [
                    52547.2,
                    32339.9
                  ],
                  [
                    52233.8,
                    32431.1
                  ],
                  [
                    52205.6,
                    32022.7
                  ],
                  [
                    52180.1,
                    31739.4
                  ],
                  [
                    52143.2,
                    31517.7
                  ],
                  [
                    52235.1,
                    31243.7
                  ],
                  [
                    52450.9,
                    31193.8
                  ],
                  [
                    52612.5,
                    31235.7
                  ],
                  [
                    52706.7,
                    31305.5
                  ]
                ],
                "id": 532,
                "chat_link": "[&BBQCAAA=]"
              }
            },
            "adventures": [],
            "id": 666,
            "mastery_points": []
          },
          "667": {
            "name": "Bad Ice",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              53376,
              32960
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                52224,
                31360
              ],
              [
                54528,
                34560
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "532": {
                "name": "Wyrmblood Lake",
                "level": 42,
                "coord": [
                  52428.9,
                  31717.9
                ],
                "bounds": [
                  [
                    52706.7,
                    31305.5
                  ],
                  [
                    52695.8,
                    31728.3
                  ],
                  [
                    52706.9,
                    32138.8
                  ],
                  [
                    52547.2,
                    32339.9
                  ],
                  [
                    52233.8,
                    32431.1
                  ],
                  [
                    52205.6,
                    32022.7
                  ],
                  [
                    52180.1,
                    31739.4
                  ],
                  [
                    52143.2,
                    31517.7
                  ],
                  [
                    52235.1,
                    31243.7
                  ],
                  [
                    52450.9,
                    31193.8
                  ],
                  [
                    52612.5,
                    31235.7
                  ],
                  [
                    52706.7,
                    31305.5
                  ]
                ],
                "id": 532,
                "chat_link": "[&BBQCAAA=]"
              },
              "533": {
                "name": "Kolkorensburg",
                "level": 42,
                "coord": [
                  52811.1,
                  32209.9
                ],
                "bounds": [
                  [
                    52565.5,
                    32434
                  ],
                  [
                    52726.3,
                    32445.9
                  ],
                  [
                    53062.2,
                    32296.9
                  ],
                  [
                    53128.2,
                    32146.9
                  ],
                  [
                    53049.9,
                    31943.1
                  ],
                  [
                    52700.4,
                    31937.7
                  ],
                  [
                    52707.4,
                    32138.1
                  ],
                  [
                    52548.9,
                    32336.7
                  ],
                  [
                    52565.5,
                    32434
                  ]
                ],
                "id": 533,
                "chat_link": "[&BBUCAAA=]"
              },
              "534": {
                "name": "Snowslide Ravine",
                "level": 43,
                "coord": [
                  53000.8,
                  31575.4
                ],
                "bounds": [
                  [
                    53332.4,
                    31318.5
                  ],
                  [
                    53243.2,
                    31659.1
                  ],
                  [
                    53222.5,
                    31800.2
                  ],
                  [
                    53050.3,
                    31943
                  ],
                  [
                    52699.2,
                    31938.8
                  ],
                  [
                    52694.9,
                    31728
                  ],
                  [
                    52709.3,
                    31311.1
                  ],
                  [
                    52861.6,
                    31376.3
                  ],
                  [
                    53012.8,
                    31310.4
                  ],
                  [
                    53181.6,
                    31368.2
                  ],
                  [
                    53332.4,
                    31318.5
                  ]
                ],
                "id": 534,
                "chat_link": "[&BBYCAAA=]"
              }
            },
            "adventures": [],
            "id": 667,
            "mastery_points": []
          },
          "668": {
            "name": "Pets and Walls Make Stronger Kraals",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              62998,
              30464
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                61952,
                28544
              ],
              [
                64000,
                32640
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "495": {
                "name": "Unbroken Expanse",
                "level": 45,
                "coord": [
                  63211.9,
                  30390.3
                ],
                "bounds": [
                  [
                    63228.8,
                    30645.9
                  ],
                  [
                    63447.9,
                    30738.9
                  ],
                  [
                    63594.9,
                    30605.9
                  ],
                  [
                    63546,
                    30298.3
                  ],
                  [
                    63595.9,
                    30138.5
                  ],
                  [
                    63083,
                    29956.2
                  ],
                  [
                    62925.8,
                    30070.6
                  ],
                  [
                    62926.9,
                    30273.4
                  ],
                  [
                    62810.4,
                    30458.3
                  ],
                  [
                    62959.4,
                    30717.1
                  ],
                  [
                    63228.8,
                    30645.9
                  ]
                ],
                "id": 495,
                "chat_link": "[&BO8BAAA=]"
              }
            },
            "adventures": [],
            "id": 668,
            "mastery_points": []
          },
          "669": {
            "name": "Attempted Deicide",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              53376,
              32960
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                52224,
                31360
              ],
              [
                54528,
                34560
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "536": {
                "name": "Mountain's Tail",
                "level": 45,
                "coord": [
                  54013.6,
                  31978.6
                ],
                "bounds": [
                  [
                    53768.5,
                    32285.4
                  ],
                  [
                    53642.8,
                    32096
                  ],
                  [
                    53734.8,
                    31755.8
                  ],
                  [
                    53989.9,
                    31644.7
                  ],
                  [
                    54176.5,
                    31620
                  ],
                  [
                    54195.1,
                    31747.3
                  ],
                  [
                    54187.5,
                    31814.8
                  ],
                  [
                    54215.3,
                    31838.1
                  ],
                  [
                    54247.7,
                    31833.6
                  ],
                  [
                    54235.5,
                    31956.5
                  ],
                  [
                    54061.4,
                    32055.9
                  ],
                  [
                    53983.8,
                    32506.3
                  ],
                  [
                    53737.7,
                    32567.5
                  ],
                  [
                    53768.5,
                    32285.4
                  ]
                ],
                "id": 536,
                "chat_link": "[&BBgCAAA=]"
              },
              "537": {
                "name": "Ulukk's Hunger",
                "level": 45,
                "coord": [
                  54346,
                  31725.7
                ],
                "bounds": [
                  [
                    54402.4,
                    31803
                  ],
                  [
                    54536.1,
                    31716.6
                  ],
                  [
                    54557.6,
                    31668.8
                  ],
                  [
                    54526.3,
                    31578.1
                  ],
                  [
                    54173.7,
                    31619.7
                  ],
                  [
                    54190.5,
                    31748
                  ],
                  [
                    54176.2,
                    31823.1
                  ],
                  [
                    54205.2,
                    31847.9
                  ],
                  [
                    54402.4,
                    31803
                  ]
                ],
                "id": 537,
                "chat_link": "[&BBkCAAA=]"
              }
            },
            "adventures": [],
            "id": 669,
            "mastery_points": []
          },
          "670": {
            "name": "Doubt",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              53376,
              32960
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                52224,
                31360
              ],
              [
                54528,
                34560
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "536": {
                "name": "Mountain's Tail",
                "level": 45,
                "coord": [
                  54013.6,
                  31978.6
                ],
                "bounds": [
                  [
                    53768.5,
                    32285.4
                  ],
                  [
                    53642.8,
                    32096
                  ],
                  [
                    53734.8,
                    31755.8
                  ],
                  [
                    53989.9,
                    31644.7
                  ],
                  [
                    54176.5,
                    31620
                  ],
                  [
                    54195.1,
                    31747.3
                  ],
                  [
                    54187.5,
                    31814.8
                  ],
                  [
                    54215.3,
                    31838.1
                  ],
                  [
                    54247.7,
                    31833.6
                  ],
                  [
                    54235.5,
                    31956.5
                  ],
                  [
                    54061.4,
                    32055.9
                  ],
                  [
                    53983.8,
                    32506.3
                  ],
                  [
                    53737.7,
                    32567.5
                  ],
                  [
                    53768.5,
                    32285.4
                  ]
                ],
                "id": 536,
                "chat_link": "[&BBgCAAA=]"
              },
              "537": {
                "name": "Ulukk's Hunger",
                "level": 45,
                "coord": [
                  54346,
                  31725.7
                ],
                "bounds": [
                  [
                    54402.4,
                    31803
                  ],
                  [
                    54536.1,
                    31716.6
                  ],
                  [
                    54557.6,
                    31668.8
                  ],
                  [
                    54526.3,
                    31578.1
                  ],
                  [
                    54173.7,
                    31619.7
                  ],
                  [
                    54190.5,
                    31748
                  ],
                  [
                    54176.2,
                    31823.1
                  ],
                  [
                    54205.2,
                    31847.9
                  ],
                  [
                    54402.4,
                    31803
                  ]
                ],
                "id": 537,
                "chat_link": "[&BBkCAAA=]"
              }
            },
            "adventures": [],
            "id": 670,
            "mastery_points": []
          },
          "672": {
            "name": "Rat-Tastrophe",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              47808,
              27264
            ],
            "map_rect": [
              [
                -36864,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                46208,
                25856
              ],
              [
                49408,
                28672
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "355": {
                "name": "Arca Lake",
                "level": 39,
                "coord": [
                  46635.3,
                  26361.7
                ],
                "bounds": [
                  [
                    46412.8,
                    26561.1
                  ],
                  [
                    46303.9,
                    26711.2
                  ],
                  [
                    46263.6,
                    26678.6
                  ],
                  [
                    46233.6,
                    26522.5
                  ],
                  [
                    46273.9,
                    26426.5
                  ],
                  [
                    46360.6,
                    26345.5
                  ],
                  [
                    46326.6,
                    26221
                  ],
                  [
                    46469.3,
                    26240.7
                  ],
                  [
                    46564.9,
                    26136.6
                  ],
                  [
                    46516.5,
                    26043.5
                  ],
                  [
                    46688.1,
                    25876.1
                  ],
                  [
                    47232.9,
                    25828.3
                  ],
                  [
                    47428.3,
                    26074.7
                  ],
                  [
                    46964.3,
                    26325.8
                  ],
                  [
                    46961.5,
                    26497.8
                  ],
                  [
                    47099.3,
                    26694.7
                  ],
                  [
                    46749.9,
                    26802.2
                  ],
                  [
                    46585.4,
                    26524.1
                  ],
                  [
                    46412.8,
                    26561.1
                  ]
                ],
                "id": 355,
                "chat_link": "[&BGMBAAA=]"
              },
              "363": {
                "name": "The Feral Dens",
                "level": 39,
                "coord": [
                  46413.5,
                  26043.7
                ],
                "bounds": [
                  [
                    46561.8,
                    26000.8
                  ],
                  [
                    46519.9,
                    25970.9
                  ],
                  [
                    46486.2,
                    25931.9
                  ],
                  [
                    46458.3,
                    25873.1
                  ],
                  [
                    46310.4,
                    25864.9
                  ],
                  [
                    46225.2,
                    25951.8
                  ],
                  [
                    46240,
                    26098.3
                  ],
                  [
                    46269.4,
                    26178.2
                  ],
                  [
                    46326.3,
                    26225
                  ],
                  [
                    46471.4,
                    26245.1
                  ],
                  [
                    46569.4,
                    26138.5
                  ],
                  [
                    46523.8,
                    26046.2
                  ],
                  [
                    46561.8,
                    26000.8
                  ]
                ],
                "id": 363,
                "chat_link": "[&BGsBAAA=]"
              }
            },
            "adventures": [],
            "id": 672,
            "mastery_points": []
          },
          "673": {
            "name": "Salvation Through Heresy",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              53376,
              32960
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                52224,
                31360
              ],
              [
                54528,
                34560
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "528": {
                "name": "The Wide Expanse",
                "level": 46,
                "coord": [
                  54143.2,
                  32786.8
                ],
                "bounds": [
                  [
                    53725.5,
                    33024.6
                  ],
                  [
                    54049.2,
                    33094.9
                  ],
                  [
                    54464.5,
                    32949.2
                  ],
                  [
                    54561.2,
                    32807.2
                  ],
                  [
                    54617.4,
                    32644.2
                  ],
                  [
                    54686.5,
                    32572.4
                  ],
                  [
                    53986.1,
                    32504.5
                  ],
                  [
                    53737.8,
                    32566.4
                  ],
                  [
                    53460.9,
                    32917.5
                  ],
                  [
                    53725.5,
                    33024.6
                  ]
                ],
                "id": 528,
                "chat_link": "[&BBACAAA=]"
              }
            },
            "adventures": [],
            "id": 673,
            "mastery_points": []
          },
          "674": {
            "name": "Enraged and Unashamed",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              53376,
              32960
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                52224,
                31360
              ],
              [
                54528,
                34560
              ]
            ],
            "points_of_interest": {
              "557": {
                "name": "Esjudare Scratch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52424.2,
                  33655.3
                ],
                "id": 557,
                "chat_link": "[&BC0CAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "525": {
                "name": "Steelbrachen",
                "level": 40,
                "coord": [
                  52584.8,
                  33227.1
                ],
                "bounds": [
                  [
                    52454.4,
                    33402.8
                  ],
                  [
                    52354,
                    33316.3
                  ],
                  [
                    52305.7,
                    33350
                  ],
                  [
                    52228.9,
                    33357
                  ],
                  [
                    52227,
                    32954.9
                  ],
                  [
                    52562.4,
                    32803.2
                  ],
                  [
                    52948.6,
                    32877.9
                  ],
                  [
                    52908.2,
                    32971.9
                  ],
                  [
                    52930.3,
                    33227.7
                  ],
                  [
                    52824.1,
                    33427.4
                  ],
                  [
                    52734.2,
                    33521.5
                  ],
                  [
                    52540.3,
                    33515.1
                  ],
                  [
                    52454.4,
                    33402.8
                  ]
                ],
                "id": 525,
                "chat_link": "[&BA0CAAA=]"
              },
              "530": {
                "name": "Troll's Teeth",
                "level": 42,
                "coord": [
                  52926.2,
                  32485
                ],
                "bounds": [
                  [
                    52562.3,
                    32803.9
                  ],
                  [
                    52949,
                    32878.3
                  ],
                  [
                    53209.5,
                    32647.3
                  ],
                  [
                    53377.6,
                    32371.2
                  ],
                  [
                    53381.7,
                    32253.2
                  ],
                  [
                    53129.3,
                    32147.4
                  ],
                  [
                    53061.8,
                    32296.7
                  ],
                  [
                    52726.3,
                    32445.3
                  ],
                  [
                    52568.1,
                    32432.5
                  ],
                  [
                    52558.7,
                    32475.5
                  ],
                  [
                    52663.8,
                    32584
                  ],
                  [
                    52562.3,
                    32803.9
                  ]
                ],
                "id": 530,
                "chat_link": "[&BBICAAA=]"
              },
              "531": {
                "name": "Toran Hollow",
                "level": 40,
                "coord": [
                  52395.2,
                  32614.9
                ],
                "bounds": [
                  [
                    52233.9,
                    32427.9
                  ],
                  [
                    52547.4,
                    32338.1
                  ],
                  [
                    52568,
                    32431.3
                  ],
                  [
                    52559.7,
                    32475.8
                  ],
                  [
                    52664.4,
                    32584.5
                  ],
                  [
                    52562.6,
                    32803.3
                  ],
                  [
                    52229.3,
                    32951.5
                  ],
                  [
                    52095.1,
                    32930.2
                  ],
                  [
                    52096.5,
                    32591.7
                  ],
                  [
                    52233.9,
                    32427.9
                  ]
                ],
                "id": 531,
                "chat_link": "[&BBMCAAA=]"
              }
            },
            "adventures": [],
            "id": 674,
            "mastery_points": []
          },
          "675": {
            "name": "Pastkeeper",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              53376,
              32960
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                52224,
                31360
              ],
              [
                54528,
                34560
              ]
            ],
            "points_of_interest": {
              "560": {
                "name": "Theign Kenning",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53505.7,
                  32286.6
                ],
                "id": 560,
                "chat_link": "[&BDACAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "529": {
                "name": "Theign Spiritwalk",
                "level": 44,
                "coord": [
                  53483.1,
                  32435.1
                ],
                "bounds": [
                  [
                    53209.9,
                    32645.9
                  ],
                  [
                    53376.5,
                    32370.6
                  ],
                  [
                    53381.7,
                    32253.4
                  ],
                  [
                    53463.7,
                    32107.2
                  ],
                  [
                    53643.2,
                    32096
                  ],
                  [
                    53769.1,
                    32285.8
                  ],
                  [
                    53738.1,
                    32567
                  ],
                  [
                    53460.6,
                    32917.7
                  ],
                  [
                    53305.1,
                    32672.7
                  ],
                  [
                    53209.9,
                    32645.9
                  ]
                ],
                "id": 529,
                "chat_link": "[&BBECAAA=]"
              }
            },
            "adventures": [],
            "id": 675,
            "mastery_points": []
          },
          "676": {
            "name": "Protest Too Much",
            "min_level": 30,
            "max_level": 35,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {
              "25": {
                "name": "Garenhoff",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46100.6,
                  32018.3
                ],
                "id": 25,
                "chat_link": "[&BBkAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "92": {
                "name": "Wizard's Fief",
                "level": 19,
                "coord": [
                  46057.5,
                  32277.4
                ],
                "bounds": [
                  [
                    46130.3,
                    31848.2
                  ],
                  [
                    45873.9,
                    31829.2
                  ],
                  [
                    45681.7,
                    32253.6
                  ],
                  [
                    46163.9,
                    32808.2
                  ],
                  [
                    46437.7,
                    32647.9
                  ],
                  [
                    46130.3,
                    31848.2
                  ]
                ],
                "id": 92,
                "chat_link": "[&BFwAAAA=]"
              }
            },
            "adventures": [],
            "id": 676,
            "mastery_points": []
          },
          "677": {
            "name": "Prying the Eye Open",
            "min_level": 30,
            "max_level": 35,
            "default_floor": 1,
            "label_coord": [
              44224,
              31509
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                42112,
                30464
              ],
              [
                46208,
                32512
              ]
            ],
            "points_of_interest": {
              "25": {
                "name": "Garenhoff",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46100.6,
                  32018.3
                ],
                "id": 25,
                "chat_link": "[&BBkAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "92": {
                "name": "Wizard's Fief",
                "level": 19,
                "coord": [
                  46057.5,
                  32277.4
                ],
                "bounds": [
                  [
                    46130.3,
                    31848.2
                  ],
                  [
                    45873.9,
                    31829.2
                  ],
                  [
                    45681.7,
                    32253.6
                  ],
                  [
                    46163.9,
                    32808.2
                  ],
                  [
                    46437.7,
                    32647.9
                  ],
                  [
                    46130.3,
                    31848.2
                  ]
                ],
                "id": 92,
                "chat_link": "[&BFwAAAA=]"
              }
            },
            "adventures": [],
            "id": 677,
            "mastery_points": []
          },
          "678": {
            "name": "The Hatchery",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              47808,
              27264
            ],
            "map_rect": [
              [
                -36864,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                46208,
                25856
              ],
              [
                49408,
                28672
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "344": {
                "name": "Diremane Woods",
                "level": 42,
                "coord": [
                  48907.3,
                  27048.9
                ],
                "bounds": [
                  [
                    48582.2,
                    27154.4
                  ],
                  [
                    48582.2,
                    26967.2
                  ],
                  [
                    49033,
                    26711.7
                  ],
                  [
                    49073.9,
                    26867
                  ],
                  [
                    49030.6,
                    27041
                  ],
                  [
                    49132.8,
                    27283.5
                  ],
                  [
                    48916.5,
                    27317.4
                  ],
                  [
                    48582.2,
                    27154.4
                  ]
                ],
                "id": 344,
                "chat_link": "[&BFgBAAA=]"
              },
              "358": {
                "name": "Hidden Ourobon",
                "level": 43,
                "coord": [
                  49157.3,
                  26804.8
                ],
                "bounds": [
                  [
                    49022,
                    27042.6
                  ],
                  [
                    49074.8,
                    26868.9
                  ],
                  [
                    49029,
                    26709.9
                  ],
                  [
                    49022.9,
                    26496.7
                  ],
                  [
                    49117.1,
                    26484.8
                  ],
                  [
                    49193.6,
                    26627.1
                  ],
                  [
                    49345.9,
                    26649.9
                  ],
                  [
                    49421,
                    26716.8
                  ],
                  [
                    49241.7,
                    27212
                  ],
                  [
                    49104.8,
                    27239
                  ],
                  [
                    49022,
                    27042.6
                  ]
                ],
                "id": 358,
                "chat_link": "[&BGYBAAA=]"
              }
            },
            "adventures": [],
            "id": 678,
            "mastery_points": []
          },
          "680": {
            "name": "Convincing the Faithful",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              49212,
              33792
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                30720,
                39936
              ]
            ],
            "continent_rect": [
              [
                48000,
                32256
              ],
              [
                50432,
                35456
              ]
            ],
            "points_of_interest": {
              "44": {
                "name": "Sullivan's Wake",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49389.6,
                  33580.8
                ],
                "id": 44,
                "chat_link": "[&BCwAAAA=]"
              },
              "1197": {
                "name": "Lorantl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49666.8,
                  33738.7
                ],
                "id": 1197,
                "chat_link": "[&BK0EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "295": {
                "name": "Merchantman's Strait",
                "level": 49,
                "coord": [
                  49416.2,
                  33497.8
                ],
                "bounds": [
                  [
                    49553,
                    33834.7
                  ],
                  [
                    49119.4,
                    34060
                  ],
                  [
                    48915.3,
                    33811.3
                  ],
                  [
                    49126.8,
                    33504.4
                  ],
                  [
                    49206.8,
                    33292
                  ],
                  [
                    49606.3,
                    33064.3
                  ],
                  [
                    49774.8,
                    33067.6
                  ],
                  [
                    49816.7,
                    33250
                  ],
                  [
                    49626.8,
                    33596.3
                  ],
                  [
                    49553,
                    33834.7
                  ]
                ],
                "id": 295,
                "chat_link": "[&BCcBAAA=]"
              },
              "303": {
                "name": "Captain's Cut",
                "level": 48,
                "coord": [
                  48992.7,
                  33194.7
                ],
                "bounds": [
                  [
                    48881.1,
                    32921.5
                  ],
                  [
                    48683.8,
                    33081.6
                  ],
                  [
                    49126.9,
                    33504.5
                  ],
                  [
                    49210.8,
                    33294.8
                  ],
                  [
                    49061,
                    33171
                  ],
                  [
                    48881.1,
                    32921.5
                  ]
                ],
                "id": 303,
                "chat_link": "[&BC8BAAA=]"
              },
              "305": {
                "name": "Stormbluff Isle",
                "level": 47,
                "coord": [
                  49212.5,
                  32967.3
                ],
                "bounds": [
                  [
                    49057.7,
                    33171.9
                  ],
                  [
                    49207.4,
                    33295
                  ],
                  [
                    49604,
                    33068.6
                  ],
                  [
                    49587.3,
                    32785.5
                  ],
                  [
                    49246.8,
                    32673.5
                  ],
                  [
                    48904.9,
                    32853.6
                  ],
                  [
                    48879.1,
                    32922.9
                  ],
                  [
                    49057.7,
                    33171.9
                  ]
                ],
                "id": 305,
                "chat_link": "[&BDEBAAA=]"
              },
              "310": {
                "name": "Laughing Gull Island",
                "level": 50,
                "coord": [
                  48706.8,
                  33524.1
                ],
                "bounds": [
                  [
                    49126.9,
                    33503.7
                  ],
                  [
                    48932.5,
                    33819.2
                  ],
                  [
                    48562.1,
                    33767.2
                  ],
                  [
                    48229,
                    33449.6
                  ],
                  [
                    48683.3,
                    33080.6
                  ],
                  [
                    49126.9,
                    33503.7
                  ]
                ],
                "id": 310,
                "chat_link": "[&BDYBAAA=]"
              },
              "318": {
                "name": "Risewild Hills",
                "level": 50,
                "coord": [
                  50085.8,
                  33731.7
                ],
                "bounds": [
                  [
                    49718.2,
                    33695.3
                  ],
                  [
                    50036.5,
                    33679.4
                  ],
                  [
                    50395.6,
                    33525.2
                  ],
                  [
                    50426.9,
                    33569.1
                  ],
                  [
                    50488.6,
                    33668.3
                  ],
                  [
                    50442.4,
                    33760
                  ],
                  [
                    50389.8,
                    33763.5
                  ],
                  [
                    50146.9,
                    33915.5
                  ],
                  [
                    50045.5,
                    33862.7
                  ],
                  [
                    49762.5,
                    33913.2
                  ],
                  [
                    49550.3,
                    33831.4
                  ],
                  [
                    49626,
                    33596.8
                  ],
                  [
                    49718.2,
                    33695.3
                  ]
                ],
                "id": 318,
                "chat_link": "[&BD4BAAA=]"
              }
            },
            "adventures": [],
            "id": 680,
            "mastery_points": []
          },
          "681": {
            "name": "Evacuation",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              53376,
              32960
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                52224,
                31360
              ],
              [
                54528,
                34560
              ]
            ],
            "points_of_interest": {
              "1486": {
                "name": "Falooaloo",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52528.9,
                  31763.5
                ],
                "id": 1486,
                "chat_link": "[&BM4FAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "532": {
                "name": "Wyrmblood Lake",
                "level": 42,
                "coord": [
                  52428.9,
                  31717.9
                ],
                "bounds": [
                  [
                    52706.7,
                    31305.5
                  ],
                  [
                    52695.8,
                    31728.3
                  ],
                  [
                    52706.9,
                    32138.8
                  ],
                  [
                    52547.2,
                    32339.9
                  ],
                  [
                    52233.8,
                    32431.1
                  ],
                  [
                    52205.6,
                    32022.7
                  ],
                  [
                    52180.1,
                    31739.4
                  ],
                  [
                    52143.2,
                    31517.7
                  ],
                  [
                    52235.1,
                    31243.7
                  ],
                  [
                    52450.9,
                    31193.8
                  ],
                  [
                    52612.5,
                    31235.7
                  ],
                  [
                    52706.7,
                    31305.5
                  ]
                ],
                "id": 532,
                "chat_link": "[&BBQCAAA=]"
              }
            },
            "adventures": [],
            "id": 681,
            "mastery_points": []
          },
          "682": {
            "name": "Untamed Wilds",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              62998,
              30464
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                61952,
                28544
              ],
              [
                64000,
                32640
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "486": {
                "name": "Deserter Flats",
                "level": 45,
                "coord": [
                  62613.5,
                  30722.1
                ],
                "bounds": [
                  [
                    62439.6,
                    30695.3
                  ],
                  [
                    62452.9,
                    30472.3
                  ],
                  [
                    62598.7,
                    30334.8
                  ],
                  [
                    62811.9,
                    30457.6
                  ],
                  [
                    62958.3,
                    30707.9
                  ],
                  [
                    62839.8,
                    30912.9
                  ],
                  [
                    62726.3,
                    30877.3
                  ],
                  [
                    62641.9,
                    30973.8
                  ],
                  [
                    62351.8,
                    31035.3
                  ],
                  [
                    62313.7,
                    30754.1
                  ],
                  [
                    62439.6,
                    30695.3
                  ]
                ],
                "id": 486,
                "chat_link": "[&BOYBAAA=]"
              },
              "488": {
                "name": "Foulblain Expanse",
                "level": 43,
                "coord": [
                  62557.5,
                  31301.7
                ],
                "bounds": [
                  [
                    62337.1,
                    31156.7
                  ],
                  [
                    62350.8,
                    31028.3
                  ],
                  [
                    62645.7,
                    30961.6
                  ],
                  [
                    62603.2,
                    31125.8
                  ],
                  [
                    62658.3,
                    31339.5
                  ],
                  [
                    62753.8,
                    31420.5
                  ],
                  [
                    62762.4,
                    31655.3
                  ],
                  [
                    62568.6,
                    31523.9
                  ],
                  [
                    62337.9,
                    31504.2
                  ],
                  [
                    62337.1,
                    31156.7
                  ]
                ],
                "id": 488,
                "chat_link": "[&BOgBAAA=]"
              }
            },
            "adventures": [],
            "id": 682,
            "mastery_points": []
          },
          "683": {
            "name": "Champion's Sacrifice",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              49212,
              33792
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                30720,
                39936
              ]
            ],
            "continent_rect": [
              [
                48000,
                32256
              ],
              [
                50432,
                35456
              ]
            ],
            "points_of_interest": {
              "48": {
                "name": "Broken Beacon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48815.7,
                  32388
                ],
                "id": 48,
                "chat_link": "[&BDAAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "305": {
                "name": "Stormbluff Isle",
                "level": 47,
                "coord": [
                  49212.5,
                  32967.3
                ],
                "bounds": [
                  [
                    49057.7,
                    33171.9
                  ],
                  [
                    49207.4,
                    33295
                  ],
                  [
                    49604,
                    33068.6
                  ],
                  [
                    49587.3,
                    32785.5
                  ],
                  [
                    49246.8,
                    32673.5
                  ],
                  [
                    48904.9,
                    32853.6
                  ],
                  [
                    48879.1,
                    32922.9
                  ],
                  [
                    49057.7,
                    33171.9
                  ]
                ],
                "id": 305,
                "chat_link": "[&BDEBAAA=]"
              },
              "312": {
                "name": "Archen Foreland",
                "level": 46,
                "coord": [
                  49335.2,
                  32456.4
                ],
                "bounds": [
                  [
                    49792.2,
                    32230
                  ],
                  [
                    49830.4,
                    32518.5
                  ],
                  [
                    49585.7,
                    32785.6
                  ],
                  [
                    49246.4,
                    32673.7
                  ],
                  [
                    48905.2,
                    32854.1
                  ],
                  [
                    48746,
                    32449.7
                  ],
                  [
                    48731.1,
                    32206.3
                  ],
                  [
                    49531.7,
                    32194.2
                  ],
                  [
                    49648,
                    32195.5
                  ],
                  [
                    49792.2,
                    32230
                  ]
                ],
                "id": 312,
                "chat_link": "[&BDgBAAA=]"
              },
              "315": {
                "name": "Sorrowful Sound",
                "level": 47,
                "coord": [
                  48458.6,
                  32840
                ],
                "bounds": [
                  [
                    48121.7,
                    33109.8
                  ],
                  [
                    48116.3,
                    32644.8
                  ],
                  [
                    48397.3,
                    32203.5
                  ],
                  [
                    48592,
                    32480.2
                  ],
                  [
                    48747.1,
                    32451.7
                  ],
                  [
                    48908.7,
                    32851.3
                  ],
                  [
                    48882.5,
                    32922.4
                  ],
                  [
                    48228.8,
                    33450.4
                  ],
                  [
                    48133.2,
                    33446
                  ],
                  [
                    48121.7,
                    33109.8
                  ]
                ],
                "id": 315,
                "chat_link": "[&BDsBAAA=]"
              }
            },
            "adventures": [],
            "id": 683,
            "mastery_points": []
          },
          "684": {
            "name": "Thieving from Thieves",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              47808,
              27264
            ],
            "map_rect": [
              [
                -36864,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                46208,
                25856
              ],
              [
                49408,
                28672
              ]
            ],
            "points_of_interest": {
              "153": {
                "name": "Kingsgate Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48693.8,
                  26346.5
                ],
                "id": 153,
                "chat_link": "[&BJkAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "345": {
                "name": "Modniir Gorge",
                "level": 43,
                "coord": [
                  48965.8,
                  26312.9
                ],
                "bounds": [
                  [
                    49117.7,
                    26484.9
                  ],
                  [
                    49025.9,
                    26499.9
                  ],
                  [
                    48817.8,
                    26430.8
                  ],
                  [
                    48708.7,
                    26438.9
                  ],
                  [
                    48598.5,
                    26309.8
                  ],
                  [
                    48701.3,
                    26013.3
                  ],
                  [
                    48764.3,
                    25981.2
                  ],
                  [
                    48853.2,
                    26073.4
                  ],
                  [
                    49148.5,
                    25985.5
                  ],
                  [
                    49315,
                    26260.3
                  ],
                  [
                    49345.4,
                    26650.3
                  ],
                  [
                    49193.4,
                    26626.8
                  ],
                  [
                    49117.7,
                    26484.9
                  ]
                ],
                "id": 345,
                "chat_link": "[&BFkBAAA=]"
              },
              "346": {
                "name": "High Timber Claim",
                "level": 42,
                "coord": [
                  48582.3,
                  26507.5
                ],
                "bounds": [
                  [
                    48387.5,
                    26163.2
                  ],
                  [
                    48544.9,
                    26242.7
                  ],
                  [
                    48709.5,
                    26435.8
                  ],
                  [
                    48817.8,
                    26430.7
                  ],
                  [
                    49025.7,
                    26490.9
                  ],
                  [
                    49033.5,
                    26706.4
                  ],
                  [
                    48586.5,
                    26966.8
                  ],
                  [
                    48393.7,
                    26782.8
                  ],
                  [
                    48405.3,
                    26555.1
                  ],
                  [
                    48281.8,
                    26486.8
                  ],
                  [
                    48219.1,
                    26321
                  ],
                  [
                    48387.5,
                    26163.2
                  ]
                ],
                "id": 346,
                "chat_link": "[&BFoBAAA=]"
              }
            },
            "adventures": [],
            "id": 684,
            "mastery_points": []
          },
          "685": {
            "name": "Crusader's Return",
            "min_level": 40,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {
              "124": {
                "name": "Vigil HQ",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49417.3,
                  28868.2
                ],
                "id": 124,
                "chat_link": "[&BHwAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "260": {
                "name": "Vigilant Hills",
                "level": 29,
                "coord": [
                  49239.9,
                  29137.1
                ],
                "bounds": [
                  [
                    48891.3,
                    28906.3
                  ],
                  [
                    49581.1,
                    28946.2
                  ],
                  [
                    49524.2,
                    29217.3
                  ],
                  [
                    49553.5,
                    29367.6
                  ],
                  [
                    49180.3,
                    29417.3
                  ],
                  [
                    49021.3,
                    29052.4
                  ],
                  [
                    48927.5,
                    29052.3
                  ],
                  [
                    48891.3,
                    28906.3
                  ]
                ],
                "id": 260,
                "chat_link": "[&BAQBAAA=]"
              },
              "948": {
                "name": "Vigil Keep",
                "level": 29,
                "coord": [
                  49263.7,
                  28645.4
                ],
                "bounds": [
                  [
                    48876.7,
                    28634.6
                  ],
                  [
                    49446.1,
                    28355.1
                  ],
                  [
                    49542.8,
                    28427.9
                  ],
                  [
                    49647.6,
                    28482.1
                  ],
                  [
                    49582,
                    28945.2
                  ],
                  [
                    48891,
                    28906.3
                  ],
                  [
                    48860,
                    28766.6
                  ],
                  [
                    48876.7,
                    28634.6
                  ]
                ],
                "id": 948,
                "chat_link": "[&BLQDAAA=]"
              }
            },
            "adventures": [],
            "id": 685,
            "mastery_points": []
          },
          "686": {
            "name": "Unholy Grounds",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              49212,
              33792
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                30720,
                39936
              ]
            ],
            "continent_rect": [
              [
                48000,
                32256
              ],
              [
                50432,
                35456
              ]
            ],
            "points_of_interest": {
              "48": {
                "name": "Broken Beacon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48815.7,
                  32388
                ],
                "id": 48,
                "chat_link": "[&BDAAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "312": {
                "name": "Archen Foreland",
                "level": 46,
                "coord": [
                  49335.2,
                  32456.4
                ],
                "bounds": [
                  [
                    49792.2,
                    32230
                  ],
                  [
                    49830.4,
                    32518.5
                  ],
                  [
                    49585.7,
                    32785.6
                  ],
                  [
                    49246.4,
                    32673.7
                  ],
                  [
                    48905.2,
                    32854.1
                  ],
                  [
                    48746,
                    32449.7
                  ],
                  [
                    48731.1,
                    32206.3
                  ],
                  [
                    49531.7,
                    32194.2
                  ],
                  [
                    49648,
                    32195.5
                  ],
                  [
                    49792.2,
                    32230
                  ]
                ],
                "id": 312,
                "chat_link": "[&BDgBAAA=]"
              },
              "315": {
                "name": "Sorrowful Sound",
                "level": 47,
                "coord": [
                  48458.6,
                  32840
                ],
                "bounds": [
                  [
                    48121.7,
                    33109.8
                  ],
                  [
                    48116.3,
                    32644.8
                  ],
                  [
                    48397.3,
                    32203.5
                  ],
                  [
                    48592,
                    32480.2
                  ],
                  [
                    48747.1,
                    32451.7
                  ],
                  [
                    48908.7,
                    32851.3
                  ],
                  [
                    48882.5,
                    32922.4
                  ],
                  [
                    48228.8,
                    33450.4
                  ],
                  [
                    48133.2,
                    33446
                  ],
                  [
                    48121.7,
                    33109.8
                  ]
                ],
                "id": 315,
                "chat_link": "[&BDsBAAA=]"
              }
            },
            "adventures": [],
            "id": 686,
            "mastery_points": []
          },
          "687": {
            "name": "Chosen of the Sun",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              49212,
              33792
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                30720,
                39936
              ]
            ],
            "continent_rect": [
              [
                48000,
                32256
              ],
              [
                50432,
                35456
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "301": {
                "name": "Portage Hills",
                "level": 46,
                "coord": [
                  50154.9,
                  32428.2
                ],
                "bounds": [
                  [
                    49918.9,
                    32510
                  ],
                  [
                    49828.8,
                    32518.8
                  ],
                  [
                    49792.3,
                    32229.3
                  ],
                  [
                    49884.7,
                    32195
                  ],
                  [
                    50170.8,
                    32152.9
                  ],
                  [
                    50494.6,
                    32313.8
                  ],
                  [
                    50529.5,
                    32468.1
                  ],
                  [
                    50380.2,
                    32530.9
                  ],
                  [
                    50359.7,
                    32633.4
                  ],
                  [
                    50188.9,
                    32730.3
                  ],
                  [
                    49918.9,
                    32510
                  ]
                ],
                "id": 301,
                "chat_link": "[&BC0BAAA=]"
              },
              "304": {
                "name": "Vindar's Lagoon",
                "level": 47,
                "coord": [
                  49916.6,
                  32836.9
                ],
                "bounds": [
                  [
                    49585.1,
                    32787.3
                  ],
                  [
                    49829.8,
                    32517.8
                  ],
                  [
                    49918.1,
                    32506.6
                  ],
                  [
                    50188.7,
                    32727.7
                  ],
                  [
                    50241.1,
                    32849.1
                  ],
                  [
                    50201,
                    33017.8
                  ],
                  [
                    49909.1,
                    32991.5
                  ],
                  [
                    49773.5,
                    33068.8
                  ],
                  [
                    49603.5,
                    33065.9
                  ],
                  [
                    49585.1,
                    32787.3
                  ]
                ],
                "id": 304,
                "chat_link": "[&BDABAAA=]"
              }
            },
            "adventures": [],
            "id": 687,
            "mastery_points": []
          },
          "691": {
            "name": "Set to Blow",
            "min_level": 50,
            "max_level": 50,
            "default_floor": 1,
            "label_coord": [
              47808,
              27264
            ],
            "map_rect": [
              [
                -36864,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                46208,
                25856
              ],
              [
                49408,
                28672
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "355": {
                "name": "Arca Lake",
                "level": 39,
                "coord": [
                  46635.3,
                  26361.7
                ],
                "bounds": [
                  [
                    46412.8,
                    26561.1
                  ],
                  [
                    46303.9,
                    26711.2
                  ],
                  [
                    46263.6,
                    26678.6
                  ],
                  [
                    46233.6,
                    26522.5
                  ],
                  [
                    46273.9,
                    26426.5
                  ],
                  [
                    46360.6,
                    26345.5
                  ],
                  [
                    46326.6,
                    26221
                  ],
                  [
                    46469.3,
                    26240.7
                  ],
                  [
                    46564.9,
                    26136.6
                  ],
                  [
                    46516.5,
                    26043.5
                  ],
                  [
                    46688.1,
                    25876.1
                  ],
                  [
                    47232.9,
                    25828.3
                  ],
                  [
                    47428.3,
                    26074.7
                  ],
                  [
                    46964.3,
                    26325.8
                  ],
                  [
                    46961.5,
                    26497.8
                  ],
                  [
                    47099.3,
                    26694.7
                  ],
                  [
                    46749.9,
                    26802.2
                  ],
                  [
                    46585.4,
                    26524.1
                  ],
                  [
                    46412.8,
                    26561.1
                  ]
                ],
                "id": 355,
                "chat_link": "[&BGMBAAA=]"
              },
              "363": {
                "name": "The Feral Dens",
                "level": 39,
                "coord": [
                  46413.5,
                  26043.7
                ],
                "bounds": [
                  [
                    46561.8,
                    26000.8
                  ],
                  [
                    46519.9,
                    25970.9
                  ],
                  [
                    46486.2,
                    25931.9
                  ],
                  [
                    46458.3,
                    25873.1
                  ],
                  [
                    46310.4,
                    25864.9
                  ],
                  [
                    46225.2,
                    25951.8
                  ],
                  [
                    46240,
                    26098.3
                  ],
                  [
                    46269.4,
                    26178.2
                  ],
                  [
                    46326.3,
                    26225
                  ],
                  [
                    46471.4,
                    26245.1
                  ],
                  [
                    46569.4,
                    26138.5
                  ],
                  [
                    46523.8,
                    26046.2
                  ],
                  [
                    46561.8,
                    26000.8
                  ]
                ],
                "id": 363,
                "chat_link": "[&BGsBAAA=]"
              }
            },
            "adventures": [],
            "id": 691,
            "mastery_points": []
          },
          "692": {
            "name": "Gadd's Last Gizmo",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "146": {
                "name": "Michoan Marsh",
                "level": 11,
                "coord": [
                  40909.5,
                  35145.1
                ],
                "bounds": [
                  [
                    41244.3,
                    35251.8
                  ],
                  [
                    41268.7,
                    35104.3
                  ],
                  [
                    40833.7,
                    34670.6
                  ],
                  [
                    40364.6,
                    34769.4
                  ],
                  [
                    40437,
                    35378.3
                  ],
                  [
                    40911.4,
                    35271.3
                  ],
                  [
                    40927.8,
                    35305.2
                  ],
                  [
                    41072.1,
                    35319
                  ],
                  [
                    41126,
                    35236.4
                  ],
                  [
                    41244.3,
                    35251.8
                  ]
                ],
                "id": 146,
                "chat_link": "[&BJIAAAA=]"
              },
              "148": {
                "name": "Artergon Woods",
                "level": 13,
                "coord": [
                  41198.6,
                  34665
                ],
                "bounds": [
                  [
                    41000.5,
                    34578.6
                  ],
                  [
                    40878.9,
                    34251.4
                  ],
                  [
                    41089.6,
                    34074.9
                  ],
                  [
                    41666.7,
                    34703.5
                  ],
                  [
                    41458,
                    34839.2
                  ],
                  [
                    41387.2,
                    35093.8
                  ],
                  [
                    41269,
                    35100.5
                  ],
                  [
                    40838.6,
                    34678.3
                  ],
                  [
                    41000.5,
                    34578.6
                  ]
                ],
                "id": 148,
                "chat_link": "[&BJQAAAA=]"
              }
            },
            "adventures": [],
            "id": 692,
            "mastery_points": []
          },
          "693": {
            "name": "Library Science",
            "min_level": 40,
            "max_level": 40,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {
              "293": {
                "name": "Priory Archives",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50509.3,
                  31048.7
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              },
              "294": {
                "name": "Ogden's Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50800.9,
                  31369.9
                ],
                "id": 294,
                "chat_link": "[&BCYBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "947": {
                "name": "Durmand Priory",
                "level": 31,
                "coord": [
                  50600.6,
                  31003.3
                ],
                "bounds": [
                  [
                    50368,
                    31537.9
                  ],
                  [
                    50781.9,
                    31388
                  ],
                  [
                    50876.9,
                    30987
                  ],
                  [
                    50824.2,
                    30793.6
                  ],
                  [
                    50731,
                    30797.9
                  ],
                  [
                    50659.6,
                    30721.1
                  ],
                  [
                    50338.2,
                    30741.7
                  ],
                  [
                    50224.6,
                    31059.4
                  ],
                  [
                    50368,
                    31537.9
                  ]
                ],
                "id": 947,
                "chat_link": "[&BLMDAAA=]"
              }
            },
            "adventures": [],
            "id": 693,
            "mastery_points": []
          },
          "694": {
            "name": "Rakt and Ruin",
            "min_level": 30,
            "max_level": 35,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "259": {
                "name": "Cornucopian Fields",
                "level": 30,
                "coord": [
                  48795.6,
                  30295.1
                ],
                "bounds": [
                  [
                    48209,
                    30758.8
                  ],
                  [
                    48562,
                    30773.8
                  ],
                  [
                    48775.2,
                    30765
                  ],
                  [
                    48811.6,
                    30734.8
                  ],
                  [
                    49331.8,
                    30790.3
                  ],
                  [
                    49414.7,
                    30633.4
                  ],
                  [
                    49352.5,
                    30429.6
                  ],
                  [
                    49259.9,
                    30452.6
                  ],
                  [
                    49081.5,
                    30191.9
                  ],
                  [
                    49069.8,
                    29808.5
                  ],
                  [
                    48940.2,
                    29689
                  ],
                  [
                    48847,
                    29703.6
                  ],
                  [
                    48690.3,
                    29841
                  ],
                  [
                    48380.1,
                    29858.7
                  ],
                  [
                    48270.2,
                    29956.3
                  ],
                  [
                    48222,
                    30265.8
                  ],
                  [
                    48307.9,
                    30363.8
                  ],
                  [
                    48209,
                    30758.8
                  ]
                ],
                "id": 259,
                "chat_link": "[&BAMBAAA=]"
              }
            },
            "adventures": [],
            "id": 694,
            "mastery_points": []
          },
          "697": {
            "name": "Critical Blowback",
            "min_level": 60,
            "max_level": 60,
            "default_floor": -3,
            "label_coord": [
              49212,
              33792
            ],
            "map_rect": [
              [
                -12288,
                -12288
              ],
              [
                12288,
                12288
              ]
            ],
            "continent_rect": [
              [
                48000,
                32256
              ],
              [
                50432,
                35456
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 697,
            "mastery_points": []
          },
          "698": {
            "name": "The Battle of Claw Island",
            "min_level": 60,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              47488,
              32896
            ],
            "map_rect": [
              [
                -18432,
                -18432
              ],
              [
                18432,
                18432
              ]
            ],
            "continent_rect": [
              [
                46720,
                32256
              ],
              [
                48256,
                33792
              ]
            ],
            "points_of_interest": {
              "1229": {
                "name": "Lion's Torch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47430.9,
                  32667.7
                ],
                "id": 1229,
                "chat_link": "[&BM0EAAA=]"
              },
              "1274": {
                "name": "Eastern Pyramid",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48180.8,
                  32760
                ],
                "id": 1274,
                "chat_link": "[&BPoEAAA=]"
              },
              "1275": {
                "name": "Maw and Pride",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47961,
                  33040.1
                ],
                "id": 1275,
                "chat_link": "[&BPsEAAA=]"
              },
              "1276": {
                "name": "Western Pyramid",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47086.8,
                  32609
                ],
                "id": 1276,
                "chat_link": "[&BPwEAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "857": {
                "name": "Sorrow's Bay",
                "level": 60,
                "coord": [
                  47789.3,
                  32606.8
                ],
                "bounds": [
                  [
                    47595.8,
                    32598.2
                  ],
                  [
                    47402.3,
                    32643.4
                  ],
                  [
                    47171.4,
                    32374.5
                  ],
                  [
                    48284.6,
                    32300.7
                  ],
                  [
                    48352.1,
                    32428.1
                  ],
                  [
                    48196.3,
                    32909.4
                  ],
                  [
                    47714.1,
                    32819.7
                  ],
                  [
                    47597.9,
                    32780
                  ],
                  [
                    47595.8,
                    32598.2
                  ]
                ],
                "id": 857,
                "chat_link": "[&BFkDAAA=]"
              },
              "968": {
                "name": "Lion's Mane",
                "level": 60,
                "coord": [
                  47657.7,
                  33174.6
                ],
                "bounds": [
                  [
                    47398,
                    33020.8
                  ],
                  [
                    47423.2,
                    33008.6
                  ],
                  [
                    47530,
                    32918.7
                  ],
                  [
                    47621.7,
                    32956.9
                  ],
                  [
                    47715.2,
                    32817.6
                  ],
                  [
                    48195.5,
                    32908.2
                  ],
                  [
                    48246.1,
                    33815
                  ],
                  [
                    47425.2,
                    33873.4
                  ],
                  [
                    47364.5,
                    33252.6
                  ],
                  [
                    47398,
                    33020.8
                  ]
                ],
                "id": 968,
                "chat_link": "[&BMgDAAA=]"
              },
              "969": {
                "name": "Western Strait",
                "level": 60,
                "coord": [
                  47220.9,
                  33043.9
                ],
                "bounds": [
                  [
                    46607.6,
                    33572.5
                  ],
                  [
                    46894,
                    32684.2
                  ],
                  [
                    47171.4,
                    32374.5
                  ],
                  [
                    47401.4,
                    32639.7
                  ],
                  [
                    47352.8,
                    32775.4
                  ],
                  [
                    47306.2,
                    32813.1
                  ],
                  [
                    47278.7,
                    32869.9
                  ],
                  [
                    47274.2,
                    32911.2
                  ],
                  [
                    47279.3,
                    32946.9
                  ],
                  [
                    47309.4,
                    32984
                  ],
                  [
                    47344.7,
                    33007.6
                  ],
                  [
                    47397.3,
                    33020.2
                  ],
                  [
                    47364.9,
                    33252.8
                  ],
                  [
                    47424.7,
                    33875.3
                  ],
                  [
                    46906.8,
                    33930.7
                  ],
                  [
                    46607.6,
                    33572.5
                  ]
                ],
                "id": 969,
                "chat_link": "[&BMkDAAA=]"
              },
              "970": {
                "name": "Fort Stalwart",
                "level": 60,
                "coord": [
                  47427.1,
                  32869.3
                ],
                "bounds": [
                  [
                    47274.7,
                    32950.8
                  ],
                  [
                    47268.5,
                    32911.4
                  ],
                  [
                    47272.3,
                    32867.6
                  ],
                  [
                    47303.1,
                    32806.2
                  ],
                  [
                    47348.6,
                    32770.2
                  ],
                  [
                    47400.8,
                    32639.6
                  ],
                  [
                    47599.5,
                    32593.8
                  ],
                  [
                    47600.5,
                    32777.3
                  ],
                  [
                    47715.7,
                    32818
                  ],
                  [
                    47622,
                    32957.2
                  ],
                  [
                    47530,
                    32919.2
                  ],
                  [
                    47423.5,
                    33008.8
                  ],
                  [
                    47398.3,
                    33020.6
                  ],
                  [
                    47342.7,
                    33011.5
                  ],
                  [
                    47306.5,
                    32987.9
                  ],
                  [
                    47274.7,
                    32950.8
                  ]
                ],
                "id": 970,
                "chat_link": "[&BMoDAAA=]"
              }
            },
            "adventures": [],
            "id": 698,
            "mastery_points": []
          },
          "700": {
            "name": "Priory Library",
            "min_level": 60,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {
              "293": {
                "name": "Priory Archives",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50509.3,
                  31048.7
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              },
              "294": {
                "name": "Ogden's Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50800.9,
                  31369.9
                ],
                "id": 294,
                "chat_link": "[&BCYBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "331": {
                "name": "Refuge Peak",
                "level": 31,
                "coord": [
                  51067.6,
                  31532.6
                ],
                "bounds": [
                  [
                    50876.4,
                    30985.8
                  ],
                  [
                    51178.5,
                    31208.3
                  ],
                  [
                    51249.4,
                    31223.8
                  ],
                  [
                    51189.8,
                    31521.4
                  ],
                  [
                    51434.6,
                    31680.3
                  ],
                  [
                    51381,
                    32042.4
                  ],
                  [
                    50924.5,
                    31909.1
                  ],
                  [
                    50933.5,
                    31712.4
                  ],
                  [
                    50726.8,
                    31654.3
                  ],
                  [
                    50781.2,
                    31388
                  ],
                  [
                    50876.4,
                    30985.8
                  ]
                ],
                "id": 331,
                "chat_link": "[&BEsBAAA=]"
              },
              "947": {
                "name": "Durmand Priory",
                "level": 31,
                "coord": [
                  50600.6,
                  31003.3
                ],
                "bounds": [
                  [
                    50368,
                    31537.9
                  ],
                  [
                    50781.9,
                    31388
                  ],
                  [
                    50876.9,
                    30987
                  ],
                  [
                    50824.2,
                    30793.6
                  ],
                  [
                    50731,
                    30797.9
                  ],
                  [
                    50659.6,
                    30721.1
                  ],
                  [
                    50338.2,
                    30741.7
                  ],
                  [
                    50224.6,
                    31059.4
                  ],
                  [
                    50368,
                    31537.9
                  ]
                ],
                "id": 947,
                "chat_link": "[&BLMDAAA=]"
              }
            },
            "adventures": [],
            "id": 700,
            "mastery_points": []
          },
          "703": {
            "name": "The Oratory",
            "min_level": 60,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {
              "124": {
                "name": "Vigil HQ",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49417.3,
                  28868.2
                ],
                "id": 124,
                "chat_link": "[&BHwAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "948": {
                "name": "Vigil Keep",
                "level": 29,
                "coord": [
                  49263.7,
                  28645.4
                ],
                "bounds": [
                  [
                    48876.7,
                    28634.6
                  ],
                  [
                    49446.1,
                    28355.1
                  ],
                  [
                    49542.8,
                    28427.9
                  ],
                  [
                    49647.6,
                    28482.1
                  ],
                  [
                    49582,
                    28945.2
                  ],
                  [
                    48891,
                    28906.3
                  ],
                  [
                    48860,
                    28766.6
                  ],
                  [
                    48876.7,
                    28634.6
                  ]
                ],
                "id": 948,
                "chat_link": "[&BLQDAAA=]"
              }
            },
            "adventures": [],
            "id": 703,
            "mastery_points": []
          },
          "706": {
            "name": "The Good Fight",
            "min_level": 60,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              52864,
              36160
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                51712,
                34560
              ],
              [
                54016,
                37760
              ]
            ],
            "points_of_interest": {
              "577": {
                "name": "Kyesjard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52127.9,
                  35027.5
                ],
                "id": 577,
                "chat_link": "[&BEECAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "560": {
                "name": "Krongar Pass",
                "level": 53,
                "coord": [
                  51981.8,
                  34882.7
                ],
                "bounds": [
                  [
                    51730.4,
                    34910.8
                  ],
                  [
                    51745.9,
                    34639.2
                  ],
                  [
                    51836.8,
                    34504.2
                  ],
                  [
                    52112.8,
                    34499.3
                  ],
                  [
                    52395.1,
                    34567.7
                  ],
                  [
                    52333,
                    35085.4
                  ],
                  [
                    52095.2,
                    35281.8
                  ],
                  [
                    51824.7,
                    35283.8
                  ],
                  [
                    51762.3,
                    35172.6
                  ],
                  [
                    51730.4,
                    34910.8
                  ]
                ],
                "id": 560,
                "chat_link": "[&BDACAAA=]"
              }
            },
            "adventures": [],
            "id": 706,
            "mastery_points": []
          },
          "707": {
            "name": "Defense Contract",
            "min_level": 60,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              60928,
              27904
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                59904,
                25856
              ],
              [
                61952,
                29952
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "433": {
                "name": "Champion's Shield",
                "level": 54,
                "coord": [
                  60464.9,
                  29077.8
                ],
                "bounds": [
                  [
                    59906.5,
                    29535.9
                  ],
                  [
                    60142.4,
                    29465.2
                  ],
                  [
                    60332.5,
                    29597.5
                  ],
                  [
                    60589.6,
                    29543.2
                  ],
                  [
                    60718.4,
                    29291.3
                  ],
                  [
                    60835.9,
                    29115.6
                  ],
                  [
                    61091.2,
                    29074.5
                  ],
                  [
                    60957.3,
                    29006.4
                  ],
                  [
                    60913.8,
                    28942.5
                  ],
                  [
                    61002.8,
                    28761.8
                  ],
                  [
                    60951.1,
                    28708.4
                  ],
                  [
                    60683.9,
                    28904.1
                  ],
                  [
                    60427.7,
                    28910
                  ],
                  [
                    60185.8,
                    28739.6
                  ],
                  [
                    60010,
                    28837
                  ],
                  [
                    59916.2,
                    28765.3
                  ],
                  [
                    59857.7,
                    28954.8
                  ],
                  [
                    59845.2,
                    29247.4
                  ],
                  [
                    59906.5,
                    29535.9
                  ]
                ],
                "id": 433,
                "chat_link": "[&BLEBAAA=]"
              },
              "434": {
                "name": "Stonesheath Overlook",
                "level": 52,
                "coord": [
                  60716.9,
                  29831.6
                ],
                "bounds": [
                  [
                    60590,
                    29542.5
                  ],
                  [
                    60789.9,
                    29653.4
                  ],
                  [
                    60847,
                    29766
                  ],
                  [
                    61007.3,
                    29781.6
                  ],
                  [
                    61022.8,
                    29864.7
                  ],
                  [
                    61004.8,
                    30017.5
                  ],
                  [
                    60894.1,
                    30007.1
                  ],
                  [
                    60882.6,
                    29951
                  ],
                  [
                    60546.7,
                    29973.3
                  ],
                  [
                    60340.5,
                    29968.3
                  ],
                  [
                    60344.7,
                    29856.1
                  ],
                  [
                    60332.8,
                    29597.5
                  ],
                  [
                    60590,
                    29542.5
                  ]
                ],
                "id": 434,
                "chat_link": "[&BLIBAAA=]"
              },
              "435": {
                "name": "Ironhead Lake",
                "level": 53,
                "coord": [
                  60996,
                  29461.3
                ],
                "bounds": [
                  [
                    60590.1,
                    29543.3
                  ],
                  [
                    60717.6,
                    29291.3
                  ],
                  [
                    60841.1,
                    29124.2
                  ],
                  [
                    61093.5,
                    29078
                  ],
                  [
                    61068.2,
                    29273.4
                  ],
                  [
                    61217.3,
                    29440.5
                  ],
                  [
                    61345.6,
                    29440.3
                  ],
                  [
                    61300.9,
                    29540.5
                  ],
                  [
                    61133.8,
                    29602.9
                  ],
                  [
                    61006.7,
                    29782.2
                  ],
                  [
                    60847.3,
                    29765.4
                  ],
                  [
                    60789.4,
                    29654
                  ],
                  [
                    60590.1,
                    29543.3
                  ]
                ],
                "id": 435,
                "chat_link": "[&BLMBAAA=]"
              },
              "436": {
                "name": "Bloodfin Lake",
                "level": 51,
                "coord": [
                  61404.3,
                  29650.5
                ],
                "bounds": [
                  [
                    61022.8,
                    29864.5
                  ],
                  [
                    61004.7,
                    29985.7
                  ],
                  [
                    61350.3,
                    29943.7
                  ],
                  [
                    61760.3,
                    29939.8
                  ],
                  [
                    61940.2,
                    29782.8
                  ],
                  [
                    61910.7,
                    29321.9
                  ],
                  [
                    61623.8,
                    29354.3
                  ],
                  [
                    61450.5,
                    29244
                  ],
                  [
                    61345,
                    29444.2
                  ],
                  [
                    61301.4,
                    29542.6
                  ],
                  [
                    61134,
                    29601.3
                  ],
                  [
                    61007.8,
                    29781.6
                  ],
                  [
                    61022.8,
                    29864.5
                  ]
                ],
                "id": 436,
                "chat_link": "[&BLQBAAA=]"
              },
              "438": {
                "name": "Sunken Halls of Clarent",
                "level": 52,
                "coord": [
                  61277.8,
                  29213.2
                ],
                "bounds": [
                  [
                    61347.8,
                    29439.2
                  ],
                  [
                    61448.9,
                    29243.7
                  ],
                  [
                    61473,
                    29014
                  ],
                  [
                    61281.3,
                    28993.9
                  ],
                  [
                    61099.6,
                    29081
                  ],
                  [
                    61072.4,
                    29280.6
                  ],
                  [
                    61221.9,
                    29440.1
                  ],
                  [
                    61347.8,
                    29439.2
                  ]
                ],
                "id": 438,
                "chat_link": "[&BLYBAAA=]"
              },
              "456": {
                "name": "Echoslab Arches",
                "level": 53,
                "coord": [
                  60135,
                  29755.7
                ],
                "bounds": [
                  [
                    60345,
                    29856.3
                  ],
                  [
                    60332.8,
                    29597.4
                  ],
                  [
                    60142.5,
                    29464.5
                  ],
                  [
                    59952.3,
                    29518
                  ],
                  [
                    59868.9,
                    29711.8
                  ],
                  [
                    59919.6,
                    29932.4
                  ],
                  [
                    60173.9,
                    29989.8
                  ],
                  [
                    60345.5,
                    29975.1
                  ],
                  [
                    60345,
                    29856.3
                  ]
                ],
                "id": 456,
                "chat_link": "[&BMgBAAA=]"
              }
            },
            "adventures": [],
            "id": 707,
            "mastery_points": []
          },
          "708": {
            "name": "Shards of Orr",
            "min_level": 60,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              49212,
              33792
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                30720,
                39936
              ]
            ],
            "continent_rect": [
              [
                48000,
                32256
              ],
              [
                50432,
                35456
              ]
            ],
            "points_of_interest": {
              "37": {
                "name": "Gleaner's Archway",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50051.3,
                  34681.4
                ],
                "id": 37,
                "chat_link": "[&BCUAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "297": {
                "name": "Mistarion Beach",
                "level": 54,
                "coord": [
                  49766.4,
                  34914.8
                ],
                "bounds": [
                  [
                    49812,
                    35108.3
                  ],
                  [
                    49962.4,
                    35068.8
                  ],
                  [
                    50048.3,
                    34847.7
                  ],
                  [
                    49768.2,
                    34789
                  ],
                  [
                    49731,
                    34700.2
                  ],
                  [
                    49595.3,
                    34788.4
                  ],
                  [
                    49485.9,
                    34787.3
                  ],
                  [
                    49727.7,
                    35228.5
                  ],
                  [
                    49812,
                    35108.3
                  ]
                ],
                "id": 297,
                "chat_link": "[&BCkBAAA=]"
              },
              "300": {
                "name": "Wraithwalker Woods",
                "level": 54,
                "coord": [
                  49955.5,
                  34585.8
                ],
                "bounds": [
                  [
                    49740,
                    34458.9
                  ],
                  [
                    49878.2,
                    34431.8
                  ],
                  [
                    49927.6,
                    34377.3
                  ],
                  [
                    50201.8,
                    34490
                  ],
                  [
                    50223.5,
                    34596.5
                  ],
                  [
                    50121.7,
                    34660.9
                  ],
                  [
                    50048,
                    34848.9
                  ],
                  [
                    49767.8,
                    34790.4
                  ],
                  [
                    49690.8,
                    34617.3
                  ],
                  [
                    49740,
                    34458.9
                  ]
                ],
                "id": 300,
                "chat_link": "[&BCwBAAA=]"
              },
              "316": {
                "name": "Whisperwill Bogs",
                "level": 55,
                "coord": [
                  50077,
                  35098.9
                ],
                "bounds": [
                  [
                    50235.7,
                    34579.5
                  ],
                  [
                    50443.5,
                    34606.4
                  ],
                  [
                    50453,
                    35012.2
                  ],
                  [
                    50378.8,
                    35335.6
                  ],
                  [
                    50160.5,
                    35470.2
                  ],
                  [
                    50016.1,
                    35466.8
                  ],
                  [
                    49780.9,
                    35389.8
                  ],
                  [
                    49793,
                    35316.4
                  ],
                  [
                    49737.8,
                    35213.2
                  ],
                  [
                    49821.5,
                    35092.1
                  ],
                  [
                    49972.3,
                    35056
                  ],
                  [
                    50131.1,
                    34648.4
                  ],
                  [
                    50235.7,
                    34579.5
                  ]
                ],
                "id": 316,
                "chat_link": "[&BDwBAAA=]"
              }
            },
            "adventures": [],
            "id": 708,
            "mastery_points": []
          },
          "709": {
            "name": "The Sound of Psi-Lance",
            "min_level": 60,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              52864,
              36160
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                51712,
                34560
              ],
              [
                54016,
                37760
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "562": {
                "name": "The Iron Veil",
                "level": 52,
                "coord": [
                  53237,
                  34875.6
                ],
                "bounds": [
                  [
                    52902.6,
                    34515.3
                  ],
                  [
                    53198.2,
                    34602.6
                  ],
                  [
                    53298.9,
                    34479.7
                  ],
                  [
                    53445.5,
                    34462.8
                  ],
                  [
                    53539.9,
                    34761.4
                  ],
                  [
                    53277.7,
                    34876.7
                  ],
                  [
                    53283.8,
                    35132
                  ],
                  [
                    53512.3,
                    35282.5
                  ],
                  [
                    53497.9,
                    35362.3
                  ],
                  [
                    53030,
                    35257.6
                  ],
                  [
                    52963.6,
                    34890
                  ],
                  [
                    52893.5,
                    34883.8
                  ],
                  [
                    52902.6,
                    34515.3
                  ]
                ],
                "id": 562,
                "chat_link": "[&BDICAAA=]"
              }
            },
            "adventures": [],
            "id": 709,
            "mastery_points": []
          },
          "710": {
            "name": "Early Parole",
            "min_level": 60,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              44416,
              29248
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                30720
              ]
            ],
            "continent_rect": [
              [
                42624,
                28032
              ],
              [
                46208,
                30464
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "48": {
                "name": "Shire of Beetletun",
                "level": 13,
                "coord": [
                  45900.9,
                  28224.5
                ],
                "bounds": [
                  [
                    45593.8,
                    28056.8
                  ],
                  [
                    45436.4,
                    28345.2
                  ],
                  [
                    45539.2,
                    28458.9
                  ],
                  [
                    45621.4,
                    28644.8
                  ],
                  [
                    46007.9,
                    28578.7
                  ],
                  [
                    46239.8,
                    28459.7
                  ],
                  [
                    46308.9,
                    28317.9
                  ],
                  [
                    46318,
                    28150.4
                  ],
                  [
                    46232.1,
                    27968.2
                  ],
                  [
                    46029.3,
                    27859.8
                  ],
                  [
                    45836.6,
                    27886.4
                  ],
                  [
                    45647.6,
                    27967.6
                  ],
                  [
                    45593.8,
                    28056.8
                  ]
                ],
                "id": 48,
                "chat_link": "[&BDAAAAA=]"
              }
            },
            "adventures": [],
            "id": 710,
            "mastery_points": []
          },
          "711": {
            "name": "Magic Sucks",
            "min_level": 60,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              38848,
              36928
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                37376,
                36094
              ],
              [
                39936,
                38654
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "921": {
                "name": "Advanced Metamystics Lab",
                "level": 0,
                "coord": [
                  38698.8,
                  36297
                ],
                "bounds": [
                  [
                    38340.1,
                    36315.2
                  ],
                  [
                    38624.3,
                    36140.8
                  ],
                  [
                    38973.6,
                    36234.3
                  ],
                  [
                    38857.2,
                    36497.8
                  ],
                  [
                    38340.1,
                    36315.2
                  ]
                ],
                "id": 921,
                "chat_link": "[&BJkDAAA=]"
              }
            },
            "adventures": [],
            "id": 711,
            "mastery_points": []
          },
          "712": {
            "name": "A Light in the Darkness",
            "min_level": 60,
            "max_level": 60,
            "default_floor": -16,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -33792,
                -24576
              ],
              [
                33792,
                24576
              ]
            ],
            "continent_rect": [
              [
                41088,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 712,
            "mastery_points": []
          },
          "713": {
            "name": "The Priory Assailed",
            "min_level": 60,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -21504,
                -58368
              ],
              [
                21504,
                58368
              ]
            ],
            "continent_rect": [
              [
                50432,
                29696
              ],
              [
                52224,
                34560
              ]
            ],
            "points_of_interest": {
              "293": {
                "name": "Priory Archives",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50509.3,
                  31048.7
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              },
              "294": {
                "name": "Ogden's Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50800.9,
                  31369.9
                ],
                "id": 294,
                "chat_link": "[&BCYBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "331": {
                "name": "Refuge Peak",
                "level": 31,
                "coord": [
                  51067.6,
                  31532.6
                ],
                "bounds": [
                  [
                    50876.4,
                    30985.8
                  ],
                  [
                    51178.5,
                    31208.3
                  ],
                  [
                    51249.4,
                    31223.8
                  ],
                  [
                    51189.8,
                    31521.4
                  ],
                  [
                    51434.6,
                    31680.3
                  ],
                  [
                    51381,
                    32042.4
                  ],
                  [
                    50924.5,
                    31909.1
                  ],
                  [
                    50933.5,
                    31712.4
                  ],
                  [
                    50726.8,
                    31654.3
                  ],
                  [
                    50781.2,
                    31388
                  ],
                  [
                    50876.4,
                    30985.8
                  ]
                ],
                "id": 331,
                "chat_link": "[&BEsBAAA=]"
              },
              "947": {
                "name": "Durmand Priory",
                "level": 31,
                "coord": [
                  50600.6,
                  31003.3
                ],
                "bounds": [
                  [
                    50368,
                    31537.9
                  ],
                  [
                    50781.9,
                    31388
                  ],
                  [
                    50876.9,
                    30987
                  ],
                  [
                    50824.2,
                    30793.6
                  ],
                  [
                    50731,
                    30797.9
                  ],
                  [
                    50659.6,
                    30721.1
                  ],
                  [
                    50338.2,
                    30741.7
                  ],
                  [
                    50224.6,
                    31059.4
                  ],
                  [
                    50368,
                    31537.9
                  ]
                ],
                "id": 947,
                "chat_link": "[&BLMDAAA=]"
              }
            },
            "adventures": [],
            "id": 713,
            "mastery_points": []
          },
          "714": {
            "name": "Under Siege",
            "min_level": 60,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {
              "123": {
                "name": "Wiley's Cove",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48989.3,
                  29170.5
                ],
                "id": 123,
                "chat_link": "[&BHsAAAA=]"
              },
              "124": {
                "name": "Vigil HQ",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49417.3,
                  28868.2
                ],
                "id": 124,
                "chat_link": "[&BHwAAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "256": {
                "name": "Provern Shore",
                "level": 32,
                "coord": [
                  48556,
                  28887.1
                ],
                "bounds": [
                  [
                    48078.6,
                    28867.3
                  ],
                  [
                    48275.3,
                    29091.4
                  ],
                  [
                    48397,
                    28943.1
                  ],
                  [
                    48590.5,
                    28957.3
                  ],
                  [
                    48636.1,
                    29122.1
                  ],
                  [
                    48793.1,
                    29207.7
                  ],
                  [
                    48926.3,
                    29053.1
                  ],
                  [
                    48860.2,
                    28766
                  ],
                  [
                    48876.2,
                    28634.8
                  ],
                  [
                    48535.9,
                    28630.1
                  ],
                  [
                    48463.8,
                    28660.6
                  ],
                  [
                    48454.1,
                    28739.2
                  ],
                  [
                    48341.2,
                    28859.4
                  ],
                  [
                    48078.6,
                    28867.3
                  ]
                ],
                "id": 256,
                "chat_link": "[&BAABAAA=]"
              },
              "260": {
                "name": "Vigilant Hills",
                "level": 29,
                "coord": [
                  49239.9,
                  29137.1
                ],
                "bounds": [
                  [
                    48891.3,
                    28906.3
                  ],
                  [
                    49581.1,
                    28946.2
                  ],
                  [
                    49524.2,
                    29217.3
                  ],
                  [
                    49553.5,
                    29367.6
                  ],
                  [
                    49180.3,
                    29417.3
                  ],
                  [
                    49021.3,
                    29052.4
                  ],
                  [
                    48927.5,
                    29052.3
                  ],
                  [
                    48891.3,
                    28906.3
                  ]
                ],
                "id": 260,
                "chat_link": "[&BAQBAAA=]"
              },
              "261": {
                "name": "Newbeach Bluffs",
                "level": 32,
                "coord": [
                  49212.3,
                  29471.9
                ],
                "bounds": [
                  [
                    48927.3,
                    29051.9
                  ],
                  [
                    49022,
                    29050.5
                  ],
                  [
                    49182.2,
                    29416
                  ],
                  [
                    49552.9,
                    29368.2
                  ],
                  [
                    49703.9,
                    29568
                  ],
                  [
                    49723.1,
                    29689.8
                  ],
                  [
                    49357.1,
                    29663
                  ],
                  [
                    49202.3,
                    29836.5
                  ],
                  [
                    49143.5,
                    29770.2
                  ],
                  [
                    49174.1,
                    29650.3
                  ],
                  [
                    49175.7,
                    29649.7
                  ],
                  [
                    49032.1,
                    29424.9
                  ],
                  [
                    48925.8,
                    29333.5
                  ],
                  [
                    48850.1,
                    29133.6
                  ],
                  [
                    48927.3,
                    29051.9
                  ]
                ],
                "id": 261,
                "chat_link": "[&BAUBAAA=]"
              },
              "948": {
                "name": "Vigil Keep",
                "level": 29,
                "coord": [
                  49263.7,
                  28645.4
                ],
                "bounds": [
                  [
                    48876.7,
                    28634.6
                  ],
                  [
                    49446.1,
                    28355.1
                  ],
                  [
                    49542.8,
                    28427.9
                  ],
                  [
                    49647.6,
                    28482.1
                  ],
                  [
                    49582,
                    28945.2
                  ],
                  [
                    48891,
                    28906.3
                  ],
                  [
                    48860,
                    28766.6
                  ],
                  [
                    48876.7,
                    28634.6
                  ]
                ],
                "id": 948,
                "chat_link": "[&BLQDAAA=]"
              }
            },
            "adventures": [],
            "id": 714,
            "mastery_points": []
          },
          "715": {
            "name": "Retribution",
            "min_level": 60,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              47488,
              32896
            ],
            "map_rect": [
              [
                -18432,
                -18432
              ],
              [
                18432,
                18432
              ]
            ],
            "continent_rect": [
              [
                46720,
                32256
              ],
              [
                48256,
                33792
              ]
            ],
            "points_of_interest": {
              "1229": {
                "name": "Lion's Torch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47430.9,
                  32667.7
                ],
                "id": 1229,
                "chat_link": "[&BM0EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "857": {
                "name": "Sorrow's Bay",
                "level": 60,
                "coord": [
                  47789.3,
                  32606.8
                ],
                "bounds": [
                  [
                    47595.8,
                    32598.2
                  ],
                  [
                    47402.3,
                    32643.4
                  ],
                  [
                    47171.4,
                    32374.5
                  ],
                  [
                    48284.6,
                    32300.7
                  ],
                  [
                    48352.1,
                    32428.1
                  ],
                  [
                    48196.3,
                    32909.4
                  ],
                  [
                    47714.1,
                    32819.7
                  ],
                  [
                    47597.9,
                    32780
                  ],
                  [
                    47595.8,
                    32598.2
                  ]
                ],
                "id": 857,
                "chat_link": "[&BFkDAAA=]"
              },
              "968": {
                "name": "Lion's Mane",
                "level": 60,
                "coord": [
                  47657.7,
                  33174.6
                ],
                "bounds": [
                  [
                    47398,
                    33020.8
                  ],
                  [
                    47423.2,
                    33008.6
                  ],
                  [
                    47530,
                    32918.7
                  ],
                  [
                    47621.7,
                    32956.9
                  ],
                  [
                    47715.2,
                    32817.6
                  ],
                  [
                    48195.5,
                    32908.2
                  ],
                  [
                    48246.1,
                    33815
                  ],
                  [
                    47425.2,
                    33873.4
                  ],
                  [
                    47364.5,
                    33252.6
                  ],
                  [
                    47398,
                    33020.8
                  ]
                ],
                "id": 968,
                "chat_link": "[&BMgDAAA=]"
              },
              "969": {
                "name": "Western Strait",
                "level": 60,
                "coord": [
                  47220.9,
                  33043.9
                ],
                "bounds": [
                  [
                    46607.6,
                    33572.5
                  ],
                  [
                    46894,
                    32684.2
                  ],
                  [
                    47171.4,
                    32374.5
                  ],
                  [
                    47401.4,
                    32639.7
                  ],
                  [
                    47352.8,
                    32775.4
                  ],
                  [
                    47306.2,
                    32813.1
                  ],
                  [
                    47278.7,
                    32869.9
                  ],
                  [
                    47274.2,
                    32911.2
                  ],
                  [
                    47279.3,
                    32946.9
                  ],
                  [
                    47309.4,
                    32984
                  ],
                  [
                    47344.7,
                    33007.6
                  ],
                  [
                    47397.3,
                    33020.2
                  ],
                  [
                    47364.9,
                    33252.8
                  ],
                  [
                    47424.7,
                    33875.3
                  ],
                  [
                    46906.8,
                    33930.7
                  ],
                  [
                    46607.6,
                    33572.5
                  ]
                ],
                "id": 969,
                "chat_link": "[&BMkDAAA=]"
              },
              "970": {
                "name": "Fort Stalwart",
                "level": 60,
                "coord": [
                  47427.1,
                  32869.3
                ],
                "bounds": [
                  [
                    47274.7,
                    32950.8
                  ],
                  [
                    47268.5,
                    32911.4
                  ],
                  [
                    47272.3,
                    32867.6
                  ],
                  [
                    47303.1,
                    32806.2
                  ],
                  [
                    47348.6,
                    32770.2
                  ],
                  [
                    47400.8,
                    32639.6
                  ],
                  [
                    47599.5,
                    32593.8
                  ],
                  [
                    47600.5,
                    32777.3
                  ],
                  [
                    47715.7,
                    32818
                  ],
                  [
                    47622,
                    32957.2
                  ],
                  [
                    47530,
                    32919.2
                  ],
                  [
                    47423.5,
                    33008.8
                  ],
                  [
                    47398.3,
                    33020.6
                  ],
                  [
                    47342.7,
                    33011.5
                  ],
                  [
                    47306.5,
                    32987.9
                  ],
                  [
                    47274.7,
                    32950.8
                  ]
                ],
                "id": 970,
                "chat_link": "[&BMoDAAA=]"
              }
            },
            "adventures": [],
            "id": 715,
            "mastery_points": []
          },
          "719": {
            "name": "The Sound of Psi-Lance",
            "min_level": 60,
            "max_level": 60,
            "default_floor": 1,
            "label_coord": [
              52864,
              36160
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                51712,
                34560
              ],
              [
                54016,
                37760
              ]
            ],
            "points_of_interest": {
              "578": {
                "name": "Balddistead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52934,
                  35056.4
                ],
                "id": 578,
                "chat_link": "[&BEICAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "562": {
                "name": "The Iron Veil",
                "level": 52,
                "coord": [
                  53237,
                  34875.6
                ],
                "bounds": [
                  [
                    52902.6,
                    34515.3
                  ],
                  [
                    53198.2,
                    34602.6
                  ],
                  [
                    53298.9,
                    34479.7
                  ],
                  [
                    53445.5,
                    34462.8
                  ],
                  [
                    53539.9,
                    34761.4
                  ],
                  [
                    53277.7,
                    34876.7
                  ],
                  [
                    53283.8,
                    35132
                  ],
                  [
                    53512.3,
                    35282.5
                  ],
                  [
                    53497.9,
                    35362.3
                  ],
                  [
                    53030,
                    35257.6
                  ],
                  [
                    52963.6,
                    34890
                  ],
                  [
                    52893.5,
                    34883.8
                  ],
                  [
                    52902.6,
                    34515.3
                  ]
                ],
                "id": 562,
                "chat_link": "[&BDICAAA=]"
              }
            },
            "adventures": [],
            "id": 719,
            "mastery_points": []
          },
          "726": {
            "name": "Wet Work",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              52480,
              38912
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "631": {
                "name": "Irwin Isle",
                "level": 67,
                "coord": [
                  52783.6,
                  39451.8
                ],
                "bounds": [
                  [
                    52787,
                    39896.7
                  ],
                  [
                    52683.9,
                    39684.1
                  ],
                  [
                    52666,
                    39501.3
                  ],
                  [
                    52508.6,
                    39404.4
                  ],
                  [
                    52435.5,
                    39293.3
                  ],
                  [
                    52429.4,
                    39100.1
                  ],
                  [
                    52489.2,
                    38946.1
                  ],
                  [
                    52685.5,
                    38940.8
                  ],
                  [
                    52699.4,
                    39129.2
                  ],
                  [
                    53162.5,
                    39399.5
                  ],
                  [
                    53317.8,
                    39712.4
                  ],
                  [
                    53260.9,
                    39893.2
                  ],
                  [
                    53061.3,
                    39972.3
                  ],
                  [
                    52787,
                    39896.7
                  ]
                ],
                "id": 631,
                "chat_link": "[&BHcCAAA=]"
              }
            },
            "adventures": [],
            "id": 726,
            "mastery_points": []
          },
          "727": {
            "name": "Shell Shock",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              52480,
              38912
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "633": {
                "name": "Dysphoric Rim",
                "level": 65,
                "coord": [
                  51324,
                  39659.2
                ],
                "bounds": [
                  [
                    51092.6,
                    39913.1
                  ],
                  [
                    50929.2,
                    39460.8
                  ],
                  [
                    51129.6,
                    39205.5
                  ],
                  [
                    51450.7,
                    39294.2
                  ],
                  [
                    51479.2,
                    39562.4
                  ],
                  [
                    51511,
                    39734.5
                  ],
                  [
                    51582,
                    39791.9
                  ],
                  [
                    51472.5,
                    39971
                  ],
                  [
                    51269.6,
                    39999.1
                  ],
                  [
                    51092.6,
                    39913.1
                  ]
                ],
                "id": 633,
                "chat_link": "[&BHkCAAA=]"
              },
              "634": {
                "name": "Murkvale",
                "level": 65,
                "coord": [
                  50745.4,
                  39658.6
                ],
                "bounds": [
                  [
                    50974.3,
                    40160.4
                  ],
                  [
                    50836.6,
                    40095.1
                  ],
                  [
                    50688.7,
                    40120
                  ],
                  [
                    50544.1,
                    40088.8
                  ],
                  [
                    50518.2,
                    39975.4
                  ],
                  [
                    50520.8,
                    39804.2
                  ],
                  [
                    50557.1,
                    39734.8
                  ],
                  [
                    50555.3,
                    39558.1
                  ],
                  [
                    50535.4,
                    39463.1
                  ],
                  [
                    50497.6,
                    39258.6
                  ],
                  [
                    50544.3,
                    39117
                  ],
                  [
                    50631.2,
                    39101.8
                  ],
                  [
                    51027.7,
                    39071.5
                  ],
                  [
                    51125.7,
                    39205.6
                  ],
                  [
                    50932.3,
                    39463.3
                  ],
                  [
                    51090.4,
                    39908.7
                  ],
                  [
                    51091.7,
                    40070
                  ],
                  [
                    50974.3,
                    40160.4
                  ]
                ],
                "id": 634,
                "chat_link": "[&BHoCAAA=]"
              },
              "641": {
                "name": "Criterion Canyon",
                "level": 63,
                "coord": [
                  50955.3,
                  38714.6
                ],
                "bounds": [
                  [
                    50630.6,
                    39103.2
                  ],
                  [
                    50566,
                    39071.7
                  ],
                  [
                    50532.7,
                    38844.7
                  ],
                  [
                    50537.2,
                    38621.4
                  ],
                  [
                    50590.9,
                    38512.8
                  ],
                  [
                    50609.6,
                    38453.3
                  ],
                  [
                    51273.7,
                    38310
                  ],
                  [
                    51342.1,
                    38472.2
                  ],
                  [
                    51495.4,
                    38533.5
                  ],
                  [
                    51426.9,
                    38677.8
                  ],
                  [
                    51242.3,
                    38785
                  ],
                  [
                    51143.2,
                    38834
                  ],
                  [
                    51027.8,
                    39070.2
                  ],
                  [
                    50630.6,
                    39103.2
                  ]
                ],
                "id": 641,
                "chat_link": "[&BIECAAA=]"
              },
              "646": {
                "name": "Sootberme",
                "level": 64,
                "coord": [
                  51446.6,
                  38907.6
                ],
                "bounds": [
                  [
                    51027,
                    39079.3
                  ],
                  [
                    51135.2,
                    38832
                  ],
                  [
                    51241.4,
                    38786.5
                  ],
                  [
                    51427.3,
                    38671.9
                  ],
                  [
                    51497.2,
                    38531.4
                  ],
                  [
                    51773.6,
                    38703.1
                  ],
                  [
                    51738.9,
                    38779.7
                  ],
                  [
                    51799.9,
                    38898.5
                  ],
                  [
                    51628.2,
                    38965.6
                  ],
                  [
                    51512.7,
                    39136.6
                  ],
                  [
                    51451.9,
                    39295.1
                  ],
                  [
                    51126.1,
                    39212.1
                  ],
                  [
                    51027,
                    39079.3
                  ]
                ],
                "id": 646,
                "chat_link": "[&BIYCAAA=]"
              }
            },
            "adventures": [],
            "id": 727,
            "mastery_points": []
          },
          "728": {
            "name": "Volcanic Extraction",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "633": {
                "name": "Dysphoric Rim",
                "level": 65,
                "coord": [
                  51324,
                  39659.2
                ],
                "bounds": [
                  [
                    51092.6,
                    39913.1
                  ],
                  [
                    50929.2,
                    39460.8
                  ],
                  [
                    51129.6,
                    39205.5
                  ],
                  [
                    51450.7,
                    39294.2
                  ],
                  [
                    51479.2,
                    39562.4
                  ],
                  [
                    51511,
                    39734.5
                  ],
                  [
                    51582,
                    39791.9
                  ],
                  [
                    51472.5,
                    39971
                  ],
                  [
                    51269.6,
                    39999.1
                  ],
                  [
                    51092.6,
                    39913.1
                  ]
                ],
                "id": 633,
                "chat_link": "[&BHkCAAA=]"
              },
              "644": {
                "name": "Magmatic Conjury",
                "level": 65,
                "coord": [
                  51653.8,
                  39744.7
                ],
                "bounds": [
                  [
                    51800.1,
                    39887.6
                  ],
                  [
                    51658.3,
                    39850.4
                  ],
                  [
                    51582.2,
                    39790.5
                  ],
                  [
                    51513,
                    39733.1
                  ],
                  [
                    51479.1,
                    39563.8
                  ],
                  [
                    51700,
                    39681.4
                  ],
                  [
                    51843.8,
                    39706
                  ],
                  [
                    51800.1,
                    39887.6
                  ]
                ],
                "id": 644,
                "chat_link": "[&BIQCAAA=]"
              },
              "645": {
                "name": "Maelstrom's Bile",
                "level": 66,
                "coord": [
                  51805.5,
                  39351.4
                ],
                "bounds": [
                  [
                    51699.1,
                    39683.2
                  ],
                  [
                    51480.4,
                    39560.8
                  ],
                  [
                    51451.9,
                    39298.6
                  ],
                  [
                    51513.4,
                    39136.7
                  ],
                  [
                    51626.5,
                    38966.4
                  ],
                  [
                    51798.4,
                    38900.2
                  ],
                  [
                    51996.1,
                    39056.3
                  ],
                  [
                    52180.9,
                    39197.3
                  ],
                  [
                    52235.5,
                    39416.3
                  ],
                  [
                    51999.2,
                    39638.3
                  ],
                  [
                    51842.7,
                    39655.2
                  ],
                  [
                    51841.6,
                    39707.5
                  ],
                  [
                    51699.1,
                    39683.2
                  ]
                ],
                "id": 645,
                "chat_link": "[&BIUCAAA=]"
              },
              "646": {
                "name": "Sootberme",
                "level": 64,
                "coord": [
                  51446.6,
                  38907.6
                ],
                "bounds": [
                  [
                    51027,
                    39079.3
                  ],
                  [
                    51135.2,
                    38832
                  ],
                  [
                    51241.4,
                    38786.5
                  ],
                  [
                    51427.3,
                    38671.9
                  ],
                  [
                    51497.2,
                    38531.4
                  ],
                  [
                    51773.6,
                    38703.1
                  ],
                  [
                    51738.9,
                    38779.7
                  ],
                  [
                    51799.9,
                    38898.5
                  ],
                  [
                    51628.2,
                    38965.6
                  ],
                  [
                    51512.7,
                    39136.6
                  ],
                  [
                    51451.9,
                    39295.1
                  ],
                  [
                    51126.1,
                    39212.1
                  ],
                  [
                    51027,
                    39079.3
                  ]
                ],
                "id": 646,
                "chat_link": "[&BIYCAAA=]"
              },
              "647": {
                "name": "Ashen Waste",
                "level": 65,
                "coord": [
                  52169.8,
                  39023.4
                ],
                "bounds": [
                  [
                    51737.4,
                    38779.8
                  ],
                  [
                    51771.6,
                    38702.9
                  ],
                  [
                    51947.1,
                    38554.7
                  ],
                  [
                    52255.3,
                    38509.3
                  ],
                  [
                    52489.8,
                    38950.5
                  ],
                  [
                    52431.9,
                    39105.5
                  ],
                  [
                    52437.9,
                    39290.7
                  ],
                  [
                    52507.8,
                    39396.6
                  ],
                  [
                    52424.2,
                    39432
                  ],
                  [
                    52236,
                    39421
                  ],
                  [
                    52177,
                    39199.3
                  ],
                  [
                    51993.5,
                    39057
                  ],
                  [
                    51797.5,
                    38904.3
                  ],
                  [
                    51737.4,
                    38779.8
                  ]
                ],
                "id": 647,
                "chat_link": "[&BIcCAAA=]"
              }
            },
            "adventures": [],
            "id": 728,
            "mastery_points": []
          },
          "729": {
            "name": "Munition Acquisition",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {
              "709": {
                "name": "Herot's Ascent",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52349.3,
                  39436.7
                ],
                "id": 709,
                "chat_link": "[&BMUCAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "647": {
                "name": "Ashen Waste",
                "level": 65,
                "coord": [
                  52169.8,
                  39023.4
                ],
                "bounds": [
                  [
                    51737.4,
                    38779.8
                  ],
                  [
                    51771.6,
                    38702.9
                  ],
                  [
                    51947.1,
                    38554.7
                  ],
                  [
                    52255.3,
                    38509.3
                  ],
                  [
                    52489.8,
                    38950.5
                  ],
                  [
                    52431.9,
                    39105.5
                  ],
                  [
                    52437.9,
                    39290.7
                  ],
                  [
                    52507.8,
                    39396.6
                  ],
                  [
                    52424.2,
                    39432
                  ],
                  [
                    52236,
                    39421
                  ],
                  [
                    52177,
                    39199.3
                  ],
                  [
                    51993.5,
                    39057
                  ],
                  [
                    51797.5,
                    38904.3
                  ],
                  [
                    51737.4,
                    38779.8
                  ]
                ],
                "id": 647,
                "chat_link": "[&BIcCAAA=]"
              }
            },
            "adventures": [],
            "id": 729,
            "mastery_points": []
          },
          "730": {
            "name": "To the Core",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "645": {
                "name": "Maelstrom's Bile",
                "level": 66,
                "coord": [
                  51805.5,
                  39351.4
                ],
                "bounds": [
                  [
                    51699.1,
                    39683.2
                  ],
                  [
                    51480.4,
                    39560.8
                  ],
                  [
                    51451.9,
                    39298.6
                  ],
                  [
                    51513.4,
                    39136.7
                  ],
                  [
                    51626.5,
                    38966.4
                  ],
                  [
                    51798.4,
                    38900.2
                  ],
                  [
                    51996.1,
                    39056.3
                  ],
                  [
                    52180.9,
                    39197.3
                  ],
                  [
                    52235.5,
                    39416.3
                  ],
                  [
                    51999.2,
                    39638.3
                  ],
                  [
                    51842.7,
                    39655.2
                  ],
                  [
                    51841.6,
                    39707.5
                  ],
                  [
                    51699.1,
                    39683.2
                  ]
                ],
                "id": 645,
                "chat_link": "[&BIUCAAA=]"
              },
              "647": {
                "name": "Ashen Waste",
                "level": 65,
                "coord": [
                  52169.8,
                  39023.4
                ],
                "bounds": [
                  [
                    51737.4,
                    38779.8
                  ],
                  [
                    51771.6,
                    38702.9
                  ],
                  [
                    51947.1,
                    38554.7
                  ],
                  [
                    52255.3,
                    38509.3
                  ],
                  [
                    52489.8,
                    38950.5
                  ],
                  [
                    52431.9,
                    39105.5
                  ],
                  [
                    52437.9,
                    39290.7
                  ],
                  [
                    52507.8,
                    39396.6
                  ],
                  [
                    52424.2,
                    39432
                  ],
                  [
                    52236,
                    39421
                  ],
                  [
                    52177,
                    39199.3
                  ],
                  [
                    51993.5,
                    39057
                  ],
                  [
                    51797.5,
                    38904.3
                  ],
                  [
                    51737.4,
                    38779.8
                  ]
                ],
                "id": 647,
                "chat_link": "[&BIcCAAA=]"
              }
            },
            "adventures": [],
            "id": 730,
            "mastery_points": []
          },
          "731": {
            "name": "The Battle of Fort Trinity",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              48688,
              40192
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                47232,
                38784
              ],
              [
                50560,
                41600
              ]
            ],
            "points_of_interest": {
              "728": {
                "name": "Razorslide Bivouac",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50224.1,
                  39472.8
                ],
                "id": 728,
                "chat_link": "[&BNgCAAA=]"
              },
              "730": {
                "name": "Thunderhead Battery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49956.7,
                  40496.6
                ],
                "id": 730,
                "chat_link": "[&BNoCAAA=]"
              },
              "1021": {
                "name": "Armada Harbor",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49843.7,
                  39841
                ],
                "id": 1021,
                "chat_link": "[&BP0DAAA=]"
              },
              "1022": {
                "name": "Alseta Generator",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50143,
                  39986.2
                ],
                "id": 1022,
                "chat_link": "[&BP4DAAA=]"
              },
              "1023": {
                "name": "Caer Aval",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49933.9,
                  40162.5
                ],
                "id": 1023,
                "chat_link": "[&BP8DAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "684": {
                "name": "Fort Trinity",
                "level": 71,
                "coord": [
                  50040.2,
                  39934
                ],
                "bounds": [
                  [
                    49835.6,
                    39572.2
                  ],
                  [
                    49992,
                    39616.4
                  ],
                  [
                    50251.7,
                    39775.9
                  ],
                  [
                    50244.2,
                    39912.7
                  ],
                  [
                    50296.7,
                    39959.1
                  ],
                  [
                    50291.5,
                    40014.9
                  ],
                  [
                    50254.4,
                    40055.6
                  ],
                  [
                    50205.3,
                    40064.9
                  ],
                  [
                    50007.9,
                    40260.7
                  ],
                  [
                    49911.3,
                    40265.5
                  ],
                  [
                    49799.9,
                    40158.6
                  ],
                  [
                    49695.4,
                    39860.6
                  ],
                  [
                    49736.9,
                    39624.7
                  ],
                  [
                    49835.6,
                    39572.2
                  ]
                ],
                "id": 684,
                "chat_link": "[&BKwCAAA=]"
              },
              "689": {
                "name": "Plinth Timberland",
                "level": 71,
                "coord": [
                  50144.7,
                  39410.1
                ],
                "bounds": [
                  [
                    50095.5,
                    39208
                  ],
                  [
                    50369.5,
                    39026.5
                  ],
                  [
                    50620.5,
                    38979
                  ],
                  [
                    50594.9,
                    39484.4
                  ],
                  [
                    50211.8,
                    39598.1
                  ],
                  [
                    50184.8,
                    39739.2
                  ],
                  [
                    49992.5,
                    39617.7
                  ],
                  [
                    49833.3,
                    39580.2
                  ],
                  [
                    49742.7,
                    39629.1
                  ],
                  [
                    49801.4,
                    39238.6
                  ],
                  [
                    50095.5,
                    39208
                  ]
                ],
                "id": 689,
                "chat_link": "[&BLECAAA=]"
              },
              "694": {
                "name": "Squall Cusps",
                "level": 71,
                "coord": [
                  50083.2,
                  40420.1
                ],
                "bounds": [
                  [
                    50177.9,
                    40097
                  ],
                  [
                    50348.3,
                    40267.7
                  ],
                  [
                    50191.4,
                    40413.9
                  ],
                  [
                    50095.7,
                    40473
                  ],
                  [
                    50158.9,
                    40778.8
                  ],
                  [
                    49989.2,
                    40745.8
                  ],
                  [
                    49868.8,
                    40478.3
                  ],
                  [
                    49911.7,
                    40266.4
                  ],
                  [
                    50006.7,
                    40260.5
                  ],
                  [
                    50177.9,
                    40097
                  ]
                ],
                "id": 694,
                "chat_link": "[&BLYCAAA=]"
              },
              "697": {
                "name": "Terzetto Bay",
                "level": 72,
                "coord": [
                  49446.3,
                  39650.2
                ],
                "bounds": [
                  [
                    49801.1,
                    40156.9
                  ],
                  [
                    49907.6,
                    40267.9
                  ],
                  [
                    49869.1,
                    40478.5
                  ],
                  [
                    49431.7,
                    40320.8
                  ],
                  [
                    49082.8,
                    39962
                  ],
                  [
                    48969.6,
                    39276.6
                  ],
                  [
                    49033,
                    39273.5
                  ],
                  [
                    49111.3,
                    39202.9
                  ],
                  [
                    49144,
                    39127.4
                  ],
                  [
                    49218.4,
                    39124.2
                  ],
                  [
                    49367.5,
                    39183
                  ],
                  [
                    49554,
                    39411.3
                  ],
                  [
                    49765.7,
                    39477.4
                  ],
                  [
                    49743.7,
                    39630.5
                  ],
                  [
                    49694.8,
                    39860.4
                  ],
                  [
                    49801.1,
                    40156.9
                  ]
                ],
                "id": 697,
                "chat_link": "[&BLkCAAA=]"
              },
              "700": {
                "name": "Thorn Pass",
                "level": 71,
                "coord": [
                  50336.3,
                  39930
                ],
                "bounds": [
                  [
                    50521.6,
                    40019.4
                  ],
                  [
                    50522.8,
                    40433.9
                  ],
                  [
                    50174.7,
                    40097
                  ],
                  [
                    50206.4,
                    40064.8
                  ],
                  [
                    50254.2,
                    40055.9
                  ],
                  [
                    50290.9,
                    40016.4
                  ],
                  [
                    50297,
                    39958.8
                  ],
                  [
                    50244.1,
                    39912.3
                  ],
                  [
                    50251.1,
                    39775
                  ],
                  [
                    50183.8,
                    39736
                  ],
                  [
                    50212.2,
                    39598.1
                  ],
                  [
                    50594.1,
                    39482.9
                  ],
                  [
                    50619.3,
                    39938.8
                  ],
                  [
                    50521.6,
                    40019.4
                  ]
                ],
                "id": 700,
                "chat_link": "[&BLwCAAA=]"
              }
            },
            "adventures": [],
            "id": 731,
            "mastery_points": []
          },
          "732": {
            "name": "Tower Down",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              49280,
              37120
            ],
            "map_rect": [
              [
                -30720,
                -39936
              ],
              [
                30720,
                39936
              ]
            ],
            "continent_rect": [
              [
                48000,
                35456
              ],
              [
                50560,
                38784
              ]
            ],
            "points_of_interest": {
              "444": {
                "name": "Ruined Vallah",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48888.5,
                  37830.5
                ],
                "id": 444,
                "chat_link": "[&BLwBAAA=]"
              },
              "445": {
                "name": "United Arcanist Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48632,
                  38125.8
                ],
                "id": 445,
                "chat_link": "[&BL0BAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "424": {
                "name": "Leeshore Gauntlet",
                "level": 61,
                "coord": [
                  48752.9,
                  37248
                ],
                "bounds": [
                  [
                    49304.6,
                    36840.4
                  ],
                  [
                    49347.2,
                    36863.5
                  ],
                  [
                    49358,
                    37006
                  ],
                  [
                    49393.2,
                    37109
                  ],
                  [
                    49248.4,
                    37166.2
                  ],
                  [
                    49055.6,
                    37263
                  ],
                  [
                    48996.3,
                    37363
                  ],
                  [
                    48834.7,
                    37372
                  ],
                  [
                    48791.4,
                    37423.9
                  ],
                  [
                    48825,
                    37534.6
                  ],
                  [
                    48772,
                    37605.4
                  ],
                  [
                    48568.3,
                    37675.9
                  ],
                  [
                    48521.1,
                    37748.3
                  ],
                  [
                    48068.3,
                    37699.8
                  ],
                  [
                    48015.4,
                    37639.1
                  ],
                  [
                    48111.5,
                    37482.8
                  ],
                  [
                    48042.8,
                    37402.8
                  ],
                  [
                    48102.7,
                    37278.6
                  ],
                  [
                    48163,
                    37135.3
                  ],
                  [
                    48521.8,
                    37090.1
                  ],
                  [
                    48750.4,
                    36806.7
                  ],
                  [
                    49044.5,
                    36728.7
                  ],
                  [
                    49062.6,
                    36845.9
                  ],
                  [
                    49171.2,
                    36871.3
                  ],
                  [
                    49304.6,
                    36840.4
                  ]
                ],
                "id": 424,
                "chat_link": "[&BKgBAAA=]"
              },
              "431": {
                "name": "Aleem's Penance",
                "level": 63,
                "coord": [
                  48840.3,
                  37702.5
                ],
                "bounds": [
                  [
                    48404,
                    37912
                  ],
                  [
                    48565.2,
                    37674.7
                  ],
                  [
                    48771.6,
                    37605.3
                  ],
                  [
                    48818.3,
                    37539.6
                  ],
                  [
                    48792.2,
                    37422.8
                  ],
                  [
                    48834.3,
                    37369.9
                  ],
                  [
                    48995.3,
                    37362.8
                  ],
                  [
                    49195.4,
                    37600.3
                  ],
                  [
                    49270.4,
                    37800.4
                  ],
                  [
                    49279.4,
                    38050.7
                  ],
                  [
                    48653.9,
                    38021.7
                  ],
                  [
                    48504.1,
                    38070.3
                  ],
                  [
                    48404,
                    37912
                  ]
                ],
                "id": 431,
                "chat_link": "[&BK8BAAA=]"
              }
            },
            "adventures": [],
            "id": 732,
            "mastery_points": []
          },
          "733": {
            "name": "Forging the Pact",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              52864,
              36160
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                51712,
                34560
              ],
              [
                54016,
                37760
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "547": {
                "name": "Pythian Point",
                "level": 57,
                "coord": [
                  52544.2,
                  37099.9
                ],
                "bounds": [
                  [
                    52290.7,
                    36817.2
                  ],
                  [
                    52535.1,
                    36752.6
                  ],
                  [
                    52589.7,
                    36852.6
                  ],
                  [
                    52804.2,
                    36888
                  ],
                  [
                    52882.1,
                    37186.3
                  ],
                  [
                    52739.5,
                    37205
                  ],
                  [
                    52642.5,
                    37155.6
                  ],
                  [
                    52491.5,
                    37267.5
                  ],
                  [
                    52440.1,
                    37404.9
                  ],
                  [
                    52310.8,
                    37444
                  ],
                  [
                    52260.1,
                    37125.6
                  ],
                  [
                    52290.7,
                    36817.2
                  ]
                ],
                "id": 547,
                "chat_link": "[&BCMCAAA=]"
              },
              "548": {
                "name": "Tyrant's Mount",
                "level": 57,
                "coord": [
                  52082.8,
                  37109.1
                ],
                "bounds": [
                  [
                    52043.6,
                    37185
                  ],
                  [
                    52133.4,
                    37063.8
                  ],
                  [
                    52043.5,
                    36933.6
                  ],
                  [
                    52016.7,
                    36837.4
                  ],
                  [
                    52135,
                    36769.8
                  ],
                  [
                    52291.1,
                    36817.7
                  ],
                  [
                    52259.8,
                    37126.8
                  ],
                  [
                    52311,
                    37444.4
                  ],
                  [
                    52046.4,
                    37436.6
                  ],
                  [
                    51823.2,
                    37347
                  ],
                  [
                    51807.4,
                    37238
                  ],
                  [
                    52043.6,
                    37185
                  ]
                ],
                "id": 548,
                "chat_link": "[&BCQCAAA=]"
              },
              "549": {
                "name": "Ural's Delve",
                "level": 57,
                "coord": [
                  51917,
                  36994.8
                ],
                "bounds": [
                  [
                    51724.6,
                    36979.4
                  ],
                  [
                    51733,
                    36924.1
                  ],
                  [
                    51816.6,
                    36787.7
                  ],
                  [
                    52022.1,
                    36832.1
                  ],
                  [
                    52047.3,
                    36929.9
                  ],
                  [
                    52139.8,
                    37069.1
                  ],
                  [
                    52041.3,
                    37191.5
                  ],
                  [
                    51811.4,
                    37245
                  ],
                  [
                    51724.6,
                    36979.4
                  ]
                ],
                "id": 549,
                "chat_link": "[&BCUCAAA=]"
              },
              "550": {
                "name": "Candle Chimney",
                "level": 57,
                "coord": [
                  51917.2,
                  36552.6
                ],
                "bounds": [
                  [
                    51817.1,
                    36790.4
                  ],
                  [
                    51789,
                    36708.1
                  ],
                  [
                    51725.9,
                    36457.8
                  ],
                  [
                    51758,
                    36197.3
                  ],
                  [
                    51897.1,
                    36209.8
                  ],
                  [
                    51927.8,
                    36376
                  ],
                  [
                    52187,
                    36625.7
                  ],
                  [
                    52136,
                    36770.3
                  ],
                  [
                    52016.8,
                    36837.9
                  ],
                  [
                    51817.1,
                    36790.4
                  ]
                ],
                "id": 550,
                "chat_link": "[&BCYCAAA=]"
              },
              "551": {
                "name": "Gyre Rapids",
                "level": 56,
                "coord": [
                  52298.8,
                  36493.3
                ],
                "bounds": [
                  [
                    52135.5,
                    36770.5
                  ],
                  [
                    52290.4,
                    36817.6
                  ],
                  [
                    52534.5,
                    36752.8
                  ],
                  [
                    52645.5,
                    36622.8
                  ],
                  [
                    52643.6,
                    36453.4
                  ],
                  [
                    52529.8,
                    36347.9
                  ],
                  [
                    52485.8,
                    36229
                  ],
                  [
                    52013.4,
                    36223.1
                  ],
                  [
                    51894.3,
                    36205.5
                  ],
                  [
                    51927.4,
                    36377.4
                  ],
                  [
                    52186.5,
                    36625.9
                  ],
                  [
                    52135.5,
                    36770.5
                  ]
                ],
                "id": 551,
                "chat_link": "[&BCcCAAA=]"
              }
            },
            "adventures": [],
            "id": 733,
            "mastery_points": []
          },
          "735": {
            "name": "Willing Captives",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {
              "694": {
                "name": "Restless Deeps",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53219.8,
                  39211.5
                ],
                "id": 694,
                "chat_link": "[&BLYCAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "628": {
                "name": "The Mire Sea",
                "level": 67,
                "coord": [
                  53266.4,
                  39193.6
                ],
                "bounds": [
                  [
                    53159.7,
                    39398
                  ],
                  [
                    52697.9,
                    39135.6
                  ],
                  [
                    52680.7,
                    38944
                  ],
                  [
                    52757.6,
                    38730.2
                  ],
                  [
                    52993.3,
                    38773.5
                  ],
                  [
                    53056.9,
                    38915.5
                  ],
                  [
                    53230.1,
                    38890.3
                  ],
                  [
                    53368.6,
                    39021
                  ],
                  [
                    53650.1,
                    39074.5
                  ],
                  [
                    53898,
                    39345.2
                  ],
                  [
                    53817.2,
                    39399.3
                  ],
                  [
                    53676.3,
                    39702.6
                  ],
                  [
                    53425,
                    39666.5
                  ],
                  [
                    53318.8,
                    39713.9
                  ],
                  [
                    53159.7,
                    39398
                  ]
                ],
                "id": 628,
                "chat_link": "[&BHQCAAA=]"
              },
              "630": {
                "name": "Sunken Droknah",
                "level": 67,
                "coord": [
                  53578.4,
                  38885.4
                ],
                "bounds": [
                  [
                    53231.1,
                    38892
                  ],
                  [
                    53281.7,
                    38731.1
                  ],
                  [
                    53548.2,
                    38573.8
                  ],
                  [
                    53853.7,
                    38777.3
                  ],
                  [
                    53856.5,
                    38910.2
                  ],
                  [
                    53753.8,
                    38990.9
                  ],
                  [
                    53664.3,
                    38989
                  ],
                  [
                    53648.8,
                    39079.7
                  ],
                  [
                    53367.1,
                    39024.3
                  ],
                  [
                    53231.1,
                    38892
                  ]
                ],
                "id": 630,
                "chat_link": "[&BHYCAAA=]"
              },
              "636": {
                "name": "Gauntlet Gulch",
                "level": 67,
                "coord": [
                  53045.6,
                  38288.9
                ],
                "bounds": [
                  [
                    52756.9,
                    38736.3
                  ],
                  [
                    52604.1,
                    38531.3
                  ],
                  [
                    52689.6,
                    38354.4
                  ],
                  [
                    52703.1,
                    38126.3
                  ],
                  [
                    52813.3,
                    38053.6
                  ],
                  [
                    52860.5,
                    37969.4
                  ],
                  [
                    52816.7,
                    37762.1
                  ],
                  [
                    52952.9,
                    37731.9
                  ],
                  [
                    53117.2,
                    37741.5
                  ],
                  [
                    53385.1,
                    37839.3
                  ],
                  [
                    53322.2,
                    37927.1
                  ],
                  [
                    53327.6,
                    38054.4
                  ],
                  [
                    53358.3,
                    38463.2
                  ],
                  [
                    53547.9,
                    38579
                  ],
                  [
                    53285,
                    38733.5
                  ],
                  [
                    53229.6,
                    38895.4
                  ],
                  [
                    53057.5,
                    38920.5
                  ],
                  [
                    52993.1,
                    38780.4
                  ],
                  [
                    52756.9,
                    38736.3
                  ]
                ],
                "id": 636,
                "chat_link": "[&BHwCAAA=]"
              }
            },
            "adventures": [],
            "id": 735,
            "mastery_points": []
          },
          "736": {
            "name": "Marshaling the Truth",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "628": {
                "name": "The Mire Sea",
                "level": 67,
                "coord": [
                  53266.4,
                  39193.6
                ],
                "bounds": [
                  [
                    53159.7,
                    39398
                  ],
                  [
                    52697.9,
                    39135.6
                  ],
                  [
                    52680.7,
                    38944
                  ],
                  [
                    52757.6,
                    38730.2
                  ],
                  [
                    52993.3,
                    38773.5
                  ],
                  [
                    53056.9,
                    38915.5
                  ],
                  [
                    53230.1,
                    38890.3
                  ],
                  [
                    53368.6,
                    39021
                  ],
                  [
                    53650.1,
                    39074.5
                  ],
                  [
                    53898,
                    39345.2
                  ],
                  [
                    53817.2,
                    39399.3
                  ],
                  [
                    53676.3,
                    39702.6
                  ],
                  [
                    53425,
                    39666.5
                  ],
                  [
                    53318.8,
                    39713.9
                  ],
                  [
                    53159.7,
                    39398
                  ]
                ],
                "id": 628,
                "chat_link": "[&BHQCAAA=]"
              }
            },
            "adventures": [],
            "id": 736,
            "mastery_points": []
          },
          "737": {
            "name": "Breaking the Bone Ship",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "628": {
                "name": "The Mire Sea",
                "level": 67,
                "coord": [
                  53266.4,
                  39193.6
                ],
                "bounds": [
                  [
                    53159.7,
                    39398
                  ],
                  [
                    52697.9,
                    39135.6
                  ],
                  [
                    52680.7,
                    38944
                  ],
                  [
                    52757.6,
                    38730.2
                  ],
                  [
                    52993.3,
                    38773.5
                  ],
                  [
                    53056.9,
                    38915.5
                  ],
                  [
                    53230.1,
                    38890.3
                  ],
                  [
                    53368.6,
                    39021
                  ],
                  [
                    53650.1,
                    39074.5
                  ],
                  [
                    53898,
                    39345.2
                  ],
                  [
                    53817.2,
                    39399.3
                  ],
                  [
                    53676.3,
                    39702.6
                  ],
                  [
                    53425,
                    39666.5
                  ],
                  [
                    53318.8,
                    39713.9
                  ],
                  [
                    53159.7,
                    39398
                  ]
                ],
                "id": 628,
                "chat_link": "[&BHQCAAA=]"
              },
              "629": {
                "name": "Benthic Kelp Beds",
                "level": 68,
                "coord": [
                  54019.2,
                  39685.7
                ],
                "bounds": [
                  [
                    53743.2,
                    39840.5
                  ],
                  [
                    53749.3,
                    39781.8
                  ],
                  [
                    53676.3,
                    39699.6
                  ],
                  [
                    53816.3,
                    39395.5
                  ],
                  [
                    53895.6,
                    39343.7
                  ],
                  [
                    54118.2,
                    39358.2
                  ],
                  [
                    54245.3,
                    39162
                  ],
                  [
                    54309.1,
                    39267.7
                  ],
                  [
                    54299.6,
                    39771.7
                  ],
                  [
                    54215.3,
                    39832.8
                  ],
                  [
                    54154.5,
                    40119.1
                  ],
                  [
                    54079.6,
                    40175.3
                  ],
                  [
                    53947.3,
                    40166.8
                  ],
                  [
                    53743.2,
                    39840.5
                  ]
                ],
                "id": 629,
                "chat_link": "[&BHUCAAA=]"
              }
            },
            "adventures": [],
            "id": 737,
            "mastery_points": []
          },
          "738": {
            "name": "Liberating Apatia",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {
              "694": {
                "name": "Restless Deeps",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53219.8,
                  39211.5
                ],
                "id": 694,
                "chat_link": "[&BLYCAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "628": {
                "name": "The Mire Sea",
                "level": 67,
                "coord": [
                  53266.4,
                  39193.6
                ],
                "bounds": [
                  [
                    53159.7,
                    39398
                  ],
                  [
                    52697.9,
                    39135.6
                  ],
                  [
                    52680.7,
                    38944
                  ],
                  [
                    52757.6,
                    38730.2
                  ],
                  [
                    52993.3,
                    38773.5
                  ],
                  [
                    53056.9,
                    38915.5
                  ],
                  [
                    53230.1,
                    38890.3
                  ],
                  [
                    53368.6,
                    39021
                  ],
                  [
                    53650.1,
                    39074.5
                  ],
                  [
                    53898,
                    39345.2
                  ],
                  [
                    53817.2,
                    39399.3
                  ],
                  [
                    53676.3,
                    39702.6
                  ],
                  [
                    53425,
                    39666.5
                  ],
                  [
                    53318.8,
                    39713.9
                  ],
                  [
                    53159.7,
                    39398
                  ]
                ],
                "id": 628,
                "chat_link": "[&BHQCAAA=]"
              },
              "630": {
                "name": "Sunken Droknah",
                "level": 67,
                "coord": [
                  53578.4,
                  38885.4
                ],
                "bounds": [
                  [
                    53231.1,
                    38892
                  ],
                  [
                    53281.7,
                    38731.1
                  ],
                  [
                    53548.2,
                    38573.8
                  ],
                  [
                    53853.7,
                    38777.3
                  ],
                  [
                    53856.5,
                    38910.2
                  ],
                  [
                    53753.8,
                    38990.9
                  ],
                  [
                    53664.3,
                    38989
                  ],
                  [
                    53648.8,
                    39079.7
                  ],
                  [
                    53367.1,
                    39024.3
                  ],
                  [
                    53231.1,
                    38892
                  ]
                ],
                "id": 630,
                "chat_link": "[&BHYCAAA=]"
              },
              "636": {
                "name": "Gauntlet Gulch",
                "level": 67,
                "coord": [
                  53045.6,
                  38288.9
                ],
                "bounds": [
                  [
                    52756.9,
                    38736.3
                  ],
                  [
                    52604.1,
                    38531.3
                  ],
                  [
                    52689.6,
                    38354.4
                  ],
                  [
                    52703.1,
                    38126.3
                  ],
                  [
                    52813.3,
                    38053.6
                  ],
                  [
                    52860.5,
                    37969.4
                  ],
                  [
                    52816.7,
                    37762.1
                  ],
                  [
                    52952.9,
                    37731.9
                  ],
                  [
                    53117.2,
                    37741.5
                  ],
                  [
                    53385.1,
                    37839.3
                  ],
                  [
                    53322.2,
                    37927.1
                  ],
                  [
                    53327.6,
                    38054.4
                  ],
                  [
                    53358.3,
                    38463.2
                  ],
                  [
                    53547.9,
                    38579
                  ],
                  [
                    53285,
                    38733.5
                  ],
                  [
                    53229.6,
                    38895.4
                  ],
                  [
                    53057.5,
                    38920.5
                  ],
                  [
                    52993.1,
                    38780.4
                  ],
                  [
                    52756.9,
                    38736.3
                  ]
                ],
                "id": 636,
                "chat_link": "[&BHwCAAA=]"
              }
            },
            "adventures": [],
            "id": 738,
            "mastery_points": []
          },
          "739": {
            "name": "Liberating Apatia",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "882": {
                "name": "Fang of the Serpent",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53427.9,
                  31108.1
                ],
                "id": 882,
                "chat_link": "[&BHIDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "798": {
                "name": "The Great Lodge",
                "level": 0,
                "coord": [
                  53465.6,
                  31103.7
                ],
                "bounds": [
                  [
                    53691,
                    31069.9
                  ],
                  [
                    53750.3,
                    31112.7
                  ],
                  [
                    53698.6,
                    31247.4
                  ],
                  [
                    53703.5,
                    31364.2
                  ],
                  [
                    53437.6,
                    31414.9
                  ],
                  [
                    53121.8,
                    31375.4
                  ],
                  [
                    53084.2,
                    31183.7
                  ],
                  [
                    53179,
                    30929.1
                  ],
                  [
                    53317.2,
                    30872.5
                  ],
                  [
                    53460.8,
                    30942.7
                  ],
                  [
                    53483.3,
                    30897.3
                  ],
                  [
                    53576.1,
                    30944.3
                  ],
                  [
                    53549.3,
                    30994.4
                  ],
                  [
                    53691,
                    31069.9
                  ]
                ],
                "id": 798,
                "chat_link": "[&BB4DAAA=]"
              }
            },
            "adventures": [],
            "id": 739,
            "mastery_points": []
          },
          "743": {
            "name": "Fixing the Blame",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              58240,
              26240
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                56576,
                24832
              ],
              [
                59904,
                27648
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "472": {
                "name": "Onager Bivouac",
                "level": 67,
                "coord": [
                  57427.7,
                  25853.8
                ],
                "bounds": [
                  [
                    57465.8,
                    26114.9
                  ],
                  [
                    57592.3,
                    25932
                  ],
                  [
                    57489.9,
                    25531.3
                  ],
                  [
                    57423.9,
                    25589.4
                  ],
                  [
                    57301.2,
                    25902.3
                  ],
                  [
                    57293.1,
                    26052.6
                  ],
                  [
                    57465.8,
                    26114.9
                  ]
                ],
                "id": 472,
                "chat_link": "[&BNgBAAA=]"
              },
              "480": {
                "name": "Highland Thaw",
                "level": 67,
                "coord": [
                  56990.2,
                  25685.3
                ],
                "bounds": [
                  [
                    57303.7,
                    25901.6
                  ],
                  [
                    57423.1,
                    25590.8
                  ],
                  [
                    57281.8,
                    25405
                  ],
                  [
                    57046.7,
                    25124.7
                  ],
                  [
                    56891.3,
                    25300.2
                  ],
                  [
                    56550.9,
                    25442.4
                  ],
                  [
                    56472.5,
                    25960.9
                  ],
                  [
                    56529.2,
                    26086.2
                  ],
                  [
                    57109.5,
                    25989.5
                  ],
                  [
                    57293.1,
                    26051.9
                  ],
                  [
                    57303.7,
                    25901.6
                  ]
                ],
                "id": 480,
                "chat_link": "[&BOABAAA=]"
              },
              "483": {
                "name": "Rustbowl",
                "level": 65,
                "coord": [
                  56884.1,
                  26322.8
                ],
                "bounds": [
                  [
                    56436.9,
                    26502.1
                  ],
                  [
                    56526.7,
                    26270
                  ],
                  [
                    56530.3,
                    26086.4
                  ],
                  [
                    57113.5,
                    25993
                  ],
                  [
                    57319,
                    26063.2
                  ],
                  [
                    57307.1,
                    26236.4
                  ],
                  [
                    57284.1,
                    26374
                  ],
                  [
                    56969.3,
                    26764.8
                  ],
                  [
                    56469.8,
                    26615.1
                  ],
                  [
                    56436.9,
                    26502.1
                  ]
                ],
                "id": 483,
                "chat_link": "[&BOMBAAA=]"
              }
            },
            "adventures": [],
            "id": 743,
            "mastery_points": []
          },
          "744": {
            "name": "A Sad Duty",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              48688,
              40192
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                47232,
                38784
              ],
              [
                50560,
                41600
              ]
            ],
            "points_of_interest": {
              "730": {
                "name": "Thunderhead Battery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49956.7,
                  40496.6
                ],
                "id": 730,
                "chat_link": "[&BNoCAAA=]"
              },
              "731": {
                "name": "Cadrigan's Jetty",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50296.7,
                  40730
                ],
                "id": 731,
                "chat_link": "[&BNsCAAA=]"
              },
              "742": {
                "name": "Compass Bridge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49897.4,
                  40631.8
                ],
                "id": 742,
                "chat_link": "[&BOYCAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "687": {
                "name": "Lightfoot Passage",
                "level": 71,
                "coord": [
                  50326,
                  40540
                ],
                "bounds": [
                  [
                    50459.6,
                    40770
                  ],
                  [
                    50158.8,
                    40778.6
                  ],
                  [
                    50095.9,
                    40473.2
                  ],
                  [
                    50191.3,
                    40414
                  ],
                  [
                    50348.9,
                    40268
                  ],
                  [
                    50514.7,
                    40427.1
                  ],
                  [
                    50512.9,
                    40649.4
                  ],
                  [
                    50459.6,
                    40770
                  ]
                ],
                "id": 687,
                "chat_link": "[&BK8CAAA=]"
              },
              "694": {
                "name": "Squall Cusps",
                "level": 71,
                "coord": [
                  50083.2,
                  40420.1
                ],
                "bounds": [
                  [
                    50177.9,
                    40097
                  ],
                  [
                    50348.3,
                    40267.7
                  ],
                  [
                    50191.4,
                    40413.9
                  ],
                  [
                    50095.7,
                    40473
                  ],
                  [
                    50158.9,
                    40778.8
                  ],
                  [
                    49989.2,
                    40745.8
                  ],
                  [
                    49868.8,
                    40478.3
                  ],
                  [
                    49911.7,
                    40266.4
                  ],
                  [
                    50006.7,
                    40260.5
                  ],
                  [
                    50177.9,
                    40097
                  ]
                ],
                "id": 694,
                "chat_link": "[&BLYCAAA=]"
              }
            },
            "adventures": [],
            "id": 744,
            "mastery_points": []
          },
          "745": {
            "name": "Striking off the Chains",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              52864,
              36160
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                51712,
                34560
              ],
              [
                54016,
                37760
              ]
            ],
            "points_of_interest": {
              "570": {
                "name": "Sipedon Deeps",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53330.9,
                  37056.6
                ],
                "id": 570,
                "chat_link": "[&BDoCAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "541": {
                "name": "Serpent Stones",
                "level": 59,
                "coord": [
                  52758.9,
                  37436.8
                ],
                "bounds": [
                  [
                    52439.5,
                    37404.7
                  ],
                  [
                    52492.9,
                    37266.3
                  ],
                  [
                    52642.5,
                    37155.6
                  ],
                  [
                    52740,
                    37205
                  ],
                  [
                    52883.5,
                    37185.4
                  ],
                  [
                    53087.8,
                    37333.9
                  ],
                  [
                    53042.3,
                    37441.5
                  ],
                  [
                    52953.5,
                    37527
                  ],
                  [
                    52881.4,
                    37755.9
                  ],
                  [
                    52645.3,
                    37828.9
                  ],
                  [
                    52671.3,
                    37656.4
                  ],
                  [
                    52626.5,
                    37480.6
                  ],
                  [
                    52439.5,
                    37404.7
                  ]
                ],
                "id": 541,
                "chat_link": "[&BB0CAAA=]"
              },
              "546": {
                "name": "Nonmoa Lake",
                "level": 60,
                "coord": [
                  53362.7,
                  36957.2
                ],
                "bounds": [
                  [
                    53087.1,
                    37333.3
                  ],
                  [
                    53593.5,
                    37309.4
                  ],
                  [
                    53749.4,
                    37136.3
                  ],
                  [
                    53758.2,
                    36931.3
                  ],
                  [
                    53667.2,
                    36835.3
                  ],
                  [
                    53636.7,
                    36584.5
                  ],
                  [
                    53342,
                    36667.8
                  ],
                  [
                    53106.1,
                    36700
                  ],
                  [
                    52804,
                    36888.5
                  ],
                  [
                    52882.6,
                    37185.5
                  ],
                  [
                    53087.1,
                    37333.3
                  ]
                ],
                "id": 546,
                "chat_link": "[&BCICAAA=]"
              }
            },
            "adventures": [],
            "id": 745,
            "mastery_points": []
          },
          "746": {
            "name": "Delivering Justice",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              48688,
              40192
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                47232,
                38784
              ],
              [
                50560,
                41600
              ]
            ],
            "points_of_interest": {
              "727": {
                "name": "Oceanside Ordnance",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49419.1,
                  38971.2
                ],
                "id": 727,
                "chat_link": "[&BNcCAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "693": {
                "name": "Signal Peak",
                "level": 71,
                "coord": [
                  49218.2,
                  39025.5
                ],
                "bounds": [
                  [
                    49569.3,
                    39093.7
                  ],
                  [
                    49367.5,
                    39183.6
                  ],
                  [
                    49218.5,
                    39123.9
                  ],
                  [
                    49144.3,
                    39127.4
                  ],
                  [
                    49110.9,
                    39203.2
                  ],
                  [
                    49032.5,
                    39273.5
                  ],
                  [
                    48969.7,
                    39276.7
                  ],
                  [
                    48842,
                    39061.3
                  ],
                  [
                    48951.9,
                    38971.3
                  ],
                  [
                    48946.6,
                    38826.7
                  ],
                  [
                    49119.9,
                    38690.4
                  ],
                  [
                    49567.2,
                    38780
                  ],
                  [
                    49666,
                    38780.7
                  ],
                  [
                    49548.3,
                    38965.1
                  ],
                  [
                    49569.3,
                    39093.7
                  ]
                ],
                "id": 693,
                "chat_link": "[&BLUCAAA=]"
              }
            },
            "adventures": [],
            "id": 746,
            "mastery_points": []
          },
          "747": {
            "name": "Intercepting the Orb",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "636": {
                "name": "Gauntlet Gulch",
                "level": 67,
                "coord": [
                  53045.6,
                  38288.9
                ],
                "bounds": [
                  [
                    52756.9,
                    38736.3
                  ],
                  [
                    52604.1,
                    38531.3
                  ],
                  [
                    52689.6,
                    38354.4
                  ],
                  [
                    52703.1,
                    38126.3
                  ],
                  [
                    52813.3,
                    38053.6
                  ],
                  [
                    52860.5,
                    37969.4
                  ],
                  [
                    52816.7,
                    37762.1
                  ],
                  [
                    52952.9,
                    37731.9
                  ],
                  [
                    53117.2,
                    37741.5
                  ],
                  [
                    53385.1,
                    37839.3
                  ],
                  [
                    53322.2,
                    37927.1
                  ],
                  [
                    53327.6,
                    38054.4
                  ],
                  [
                    53358.3,
                    38463.2
                  ],
                  [
                    53547.9,
                    38579
                  ],
                  [
                    53285,
                    38733.5
                  ],
                  [
                    53229.6,
                    38895.4
                  ],
                  [
                    53057.5,
                    38920.5
                  ],
                  [
                    52993.1,
                    38780.4
                  ],
                  [
                    52756.9,
                    38736.3
                  ]
                ],
                "id": 636,
                "chat_link": "[&BHwCAAA=]"
              },
              "638": {
                "name": "Broken Arrow River",
                "level": 61,
                "coord": [
                  52475.9,
                  38261.5
                ],
                "bounds": [
                  [
                    52251.8,
                    38508
                  ],
                  [
                    52066.3,
                    37885.1
                  ],
                  [
                    52103.4,
                    37745
                  ],
                  [
                    52267.9,
                    37695.8
                  ],
                  [
                    52519.5,
                    37758.1
                  ],
                  [
                    52571.8,
                    37916.7
                  ],
                  [
                    52702.4,
                    38126.7
                  ],
                  [
                    52688.8,
                    38354.3
                  ],
                  [
                    52604.6,
                    38531.3
                  ],
                  [
                    52763.3,
                    38725
                  ],
                  [
                    52682.1,
                    38946
                  ],
                  [
                    52489.3,
                    38946.5
                  ],
                  [
                    52251.8,
                    38508
                  ]
                ],
                "id": 638,
                "chat_link": "[&BH4CAAA=]"
              }
            },
            "adventures": [],
            "id": 747,
            "mastery_points": []
          },
          "750": {
            "name": "Close the Eye",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              48688,
              40192
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                47232,
                38784
              ],
              [
                50560,
                41600
              ]
            ],
            "points_of_interest": {
              "737": {
                "name": "Lone Post",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48992.3,
                  40784.6
                ],
                "id": 737,
                "chat_link": "[&BOECAAA=]"
              },
              "1230": {
                "name": "Lasciate Gateway",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48718.1,
                  40886
                ],
                "id": 1230,
                "chat_link": "[&BM4EAAA=]"
              },
              "1233": {
                "name": "Conservatory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48667.1,
                  41105.2
                ],
                "id": 1233,
                "chat_link": "[&BNEEAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "678": {
                "name": "Blighted Battleground",
                "level": 74,
                "coord": [
                  48924.2,
                  41168.6
                ],
                "bounds": [
                  [
                    48933.6,
                    40687.6
                  ],
                  [
                    49097.6,
                    40854.3
                  ],
                  [
                    49062,
                    40969.4
                  ],
                  [
                    49107.9,
                    41275.7
                  ],
                  [
                    49246.2,
                    41325.4
                  ],
                  [
                    49195.4,
                    41494.7
                  ],
                  [
                    48976.5,
                    41548.6
                  ],
                  [
                    48742,
                    41542.1
                  ],
                  [
                    48678.1,
                    41452
                  ],
                  [
                    48703,
                    41241.4
                  ],
                  [
                    48804.6,
                    41037.9
                  ],
                  [
                    48684.3,
                    40979.7
                  ],
                  [
                    48783.3,
                    40783
                  ],
                  [
                    48933.6,
                    40687.6
                  ]
                ],
                "id": 678,
                "chat_link": "[&BKYCAAA=]"
              },
              "692": {
                "name": "Shark's Teeth Archipelago",
                "level": 73,
                "coord": [
                  49388.6,
                  40870.7
                ],
                "bounds": [
                  [
                    49697.7,
                    40883.7
                  ],
                  [
                    49452.7,
                    41162.7
                  ],
                  [
                    49244.7,
                    41325.7
                  ],
                  [
                    49106.4,
                    41276.1
                  ],
                  [
                    49062.6,
                    40970.3
                  ],
                  [
                    49097.3,
                    40854.4
                  ],
                  [
                    48934,
                    40689.3
                  ],
                  [
                    49432.4,
                    40320.9
                  ],
                  [
                    49868.9,
                    40478.1
                  ],
                  [
                    49989.3,
                    40746.1
                  ],
                  [
                    49697.7,
                    40883.7
                  ]
                ],
                "id": 692,
                "chat_link": "[&BLQCAAA=]"
              },
              "701": {
                "name": "Waywarde Way",
                "level": 74,
                "coord": [
                  48571.3,
                  41288.4
                ],
                "bounds": [
                  [
                    48698.5,
                    41244
                  ],
                  [
                    48678.4,
                    41450.6
                  ],
                  [
                    48742.5,
                    41542.4
                  ],
                  [
                    48488.3,
                    41524.4
                  ],
                  [
                    48294,
                    41529.2
                  ],
                  [
                    48170,
                    41296.6
                  ],
                  [
                    48577.5,
                    40998.7
                  ],
                  [
                    48686.7,
                    40972
                  ],
                  [
                    48806,
                    41038
                  ],
                  [
                    48698.5,
                    41244
                  ]
                ],
                "id": 701,
                "chat_link": "[&BL0CAAA=]"
              },
              "702": {
                "name": "Xenarius Bayt",
                "level": 74,
                "coord": [
                  48423.4,
                  40949.1
                ],
                "bounds": [
                  [
                    48578.9,
                    40998.2
                  ],
                  [
                    48169.7,
                    41296.8
                  ],
                  [
                    48063.2,
                    41125.5
                  ],
                  [
                    48060.5,
                    40947.3
                  ],
                  [
                    48368.8,
                    40731.8
                  ],
                  [
                    48674.8,
                    40724.9
                  ],
                  [
                    48783.3,
                    40782.8
                  ],
                  [
                    48687.6,
                    40985.5
                  ],
                  [
                    48578.9,
                    40998.2
                  ]
                ],
                "id": 702,
                "chat_link": "[&BL4CAAA=]"
              }
            },
            "adventures": [],
            "id": 750,
            "mastery_points": []
          },
          "751": {
            "name": "Through the Looking Glass",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              48688,
              40192
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                47232,
                38784
              ],
              [
                50560,
                41600
              ]
            ],
            "points_of_interest": {
              "1230": {
                "name": "Lasciate Gateway",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  48718.1,
                  40886
                ],
                "id": 1230,
                "chat_link": "[&BM4EAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "678": {
                "name": "Blighted Battleground",
                "level": 74,
                "coord": [
                  48924.2,
                  41168.6
                ],
                "bounds": [
                  [
                    48933.6,
                    40687.6
                  ],
                  [
                    49097.6,
                    40854.3
                  ],
                  [
                    49062,
                    40969.4
                  ],
                  [
                    49107.9,
                    41275.7
                  ],
                  [
                    49246.2,
                    41325.4
                  ],
                  [
                    49195.4,
                    41494.7
                  ],
                  [
                    48976.5,
                    41548.6
                  ],
                  [
                    48742,
                    41542.1
                  ],
                  [
                    48678.1,
                    41452
                  ],
                  [
                    48703,
                    41241.4
                  ],
                  [
                    48804.6,
                    41037.9
                  ],
                  [
                    48684.3,
                    40979.7
                  ],
                  [
                    48783.3,
                    40783
                  ],
                  [
                    48933.6,
                    40687.6
                  ]
                ],
                "id": 678,
                "chat_link": "[&BKYCAAA=]"
              }
            },
            "adventures": [],
            "id": 751,
            "mastery_points": []
          },
          "758": {
            "name": "The Cathedral of Silence",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              43904,
              43648
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42880,
                41600
              ],
              [
                44928,
                45696
              ]
            ],
            "points_of_interest": {
              "779": {
                "name": "Buried Archives",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43630.9,
                  45044.5
                ],
                "id": 779,
                "chat_link": "[&BAsDAAA=]"
              },
              "780": {
                "name": "Altar of Murdered Dreams",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43244.2,
                  45035.3
                ],
                "id": 780,
                "chat_link": "[&BAwDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "713": {
                "name": "Graven Cay",
                "level": 80,
                "coord": [
                  43240.1,
                  44405.5
                ],
                "bounds": [
                  [
                    43355.3,
                    43945
                  ],
                  [
                    43449.9,
                    44017.6
                  ],
                  [
                    43417.8,
                    44233.1
                  ],
                  [
                    43669.5,
                    44680.8
                  ],
                  [
                    43466.1,
                    44843.4
                  ],
                  [
                    43311.4,
                    44897.3
                  ],
                  [
                    42964.4,
                    45104.8
                  ],
                  [
                    42979.5,
                    44725.9
                  ],
                  [
                    42899.5,
                    44264.3
                  ],
                  [
                    42968.6,
                    43796.9
                  ],
                  [
                    43159.2,
                    43951.5
                  ],
                  [
                    43355.3,
                    43945
                  ]
                ],
                "id": 713,
                "chat_link": "[&BMkCAAA=]"
              },
              "714": {
                "name": "Cathedral of Silence",
                "level": 80,
                "coord": [
                  43517.4,
                  45141.8
                ],
                "bounds": [
                  [
                    43465,
                    44844
                  ],
                  [
                    43669.9,
                    44680.8
                  ],
                  [
                    43801.8,
                    45005.5
                  ],
                  [
                    43860.3,
                    45245.4
                  ],
                  [
                    43847.6,
                    45570.5
                  ],
                  [
                    43537.3,
                    45551.4
                  ],
                  [
                    43200.9,
                    45376.9
                  ],
                  [
                    42963.8,
                    45105
                  ],
                  [
                    43310.6,
                    44897.1
                  ],
                  [
                    43465,
                    44844
                  ]
                ],
                "id": 714,
                "chat_link": "[&BMoCAAA=]"
              }
            },
            "adventures": [],
            "id": 758,
            "mastery_points": []
          },
          "760": {
            "name": "Starving the Beast",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45184,
              40576
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                43136,
                39552
              ],
              [
                47232,
                41600
              ]
            ],
            "points_of_interest": {
              "654": {
                "name": "The Wealdwood",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46686.1,
                  40202.1
                ],
                "id": 654,
                "chat_link": "[&BI4CAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "593": {
                "name": "Crusted Sholes",
                "level": 76,
                "coord": [
                  46426.2,
                  40525.6
                ],
                "bounds": [
                  [
                    46170.4,
                    40292.6
                  ],
                  [
                    46366.4,
                    40177.1
                  ],
                  [
                    46506.5,
                    40289.4
                  ],
                  [
                    46650.5,
                    40325.7
                  ],
                  [
                    46648,
                    40462.8
                  ],
                  [
                    46720.4,
                    40575.3
                  ],
                  [
                    46706.5,
                    40700.3
                  ],
                  [
                    46630.3,
                    40751
                  ],
                  [
                    46459.7,
                    40654.5
                  ],
                  [
                    46314.6,
                    40756.3
                  ],
                  [
                    46217.2,
                    40786.8
                  ],
                  [
                    46017.9,
                    40589.3
                  ],
                  [
                    46132,
                    40471.8
                  ],
                  [
                    46170.4,
                    40292.6
                  ]
                ],
                "id": 593,
                "chat_link": "[&BFECAAA=]"
              },
              "595": {
                "name": "Mirror Bay",
                "level": 76,
                "coord": [
                  46287.6,
                  40001.9
                ],
                "bounds": [
                  [
                    46169.7,
                    40295.6
                  ],
                  [
                    46113.8,
                    40139.2
                  ],
                  [
                    45964.6,
                    40000.9
                  ],
                  [
                    45788.9,
                    39964.5
                  ],
                  [
                    45803.4,
                    39684.7
                  ],
                  [
                    46800.9,
                    39757
                  ],
                  [
                    46777.4,
                    39886.2
                  ],
                  [
                    46656.6,
                    40055.6
                  ],
                  [
                    46430.1,
                    40053.2
                  ],
                  [
                    46370.8,
                    40181.8
                  ],
                  [
                    46169.7,
                    40295.6
                  ]
                ],
                "id": 595,
                "chat_link": "[&BFMCAAA=]"
              },
              "600": {
                "name": "Waste Hollows",
                "level": 75,
                "coord": [
                  47079.6,
                  40709.6
                ],
                "bounds": [
                  [
                    46986.4,
                    41133
                  ],
                  [
                    46705.6,
                    40697.8
                  ],
                  [
                    46714.7,
                    40577.5
                  ],
                  [
                    46901.2,
                    40419.4
                  ],
                  [
                    47048,
                    40355.1
                  ],
                  [
                    47194.5,
                    40368.8
                  ],
                  [
                    47367.3,
                    40581.9
                  ],
                  [
                    47314.8,
                    40861.2
                  ],
                  [
                    47332.4,
                    41021.3
                  ],
                  [
                    47231.4,
                    41080.2
                  ],
                  [
                    46986.4,
                    41133
                  ]
                ],
                "id": 600,
                "chat_link": "[&BFgCAAA=]"
              },
              "601": {
                "name": "Pyrite Peninsula",
                "level": 75,
                "coord": [
                  46654.2,
                  40233.1
                ],
                "bounds": [
                  [
                    46433.5,
                    40048.1
                  ],
                  [
                    46655,
                    40056.4
                  ],
                  [
                    46768.5,
                    39885.7
                  ],
                  [
                    46889.8,
                    40083.3
                  ],
                  [
                    46901.6,
                    40421.9
                  ],
                  [
                    46719,
                    40573.4
                  ],
                  [
                    46649.7,
                    40462.3
                  ],
                  [
                    46650,
                    40328.4
                  ],
                  [
                    46507,
                    40291.8
                  ],
                  [
                    46368.4,
                    40179.5
                  ],
                  [
                    46433.5,
                    40048.1
                  ]
                ],
                "id": 601,
                "chat_link": "[&BFkCAAA=]"
              }
            },
            "adventures": [],
            "id": 760,
            "mastery_points": []
          },
          "761": {
            "name": "Stealing Light",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45184,
              40576
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                43136,
                39552
              ],
              [
                47232,
                41600
              ]
            ],
            "points_of_interest": {
              "650": {
                "name": "Beacon Torch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45356.5,
                  40139.2
                ],
                "id": 650,
                "chat_link": "[&BIoCAAA=]"
              },
              "661": {
                "name": "Spark of Ilya",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45566.1,
                  40094.6
                ],
                "id": 661,
                "chat_link": "[&BJUCAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "594": {
                "name": "Whisper Bay",
                "level": 78,
                "coord": [
                  44853.1,
                  40042.4
                ],
                "bounds": [
                  [
                    44332.4,
                    40319.1
                  ],
                  [
                    44435.2,
                    40165.3
                  ],
                  [
                    44422.4,
                    39782.1
                  ],
                  [
                    44849.3,
                    39671.1
                  ],
                  [
                    45135.8,
                    39685.1
                  ],
                  [
                    45347.8,
                    39730.8
                  ],
                  [
                    45229.8,
                    39894.6
                  ],
                  [
                    45282.9,
                    40003.3
                  ],
                  [
                    45163.3,
                    40194.6
                  ],
                  [
                    44838.1,
                    40220.9
                  ],
                  [
                    44729.6,
                    40366.5
                  ],
                  [
                    44470.5,
                    40475.9
                  ],
                  [
                    44332.4,
                    40319.1
                  ]
                ],
                "id": 594,
                "chat_link": "[&BFICAAA=]"
              },
              "598": {
                "name": "Blighted Arch",
                "level": 78,
                "coord": [
                  45287.5,
                  40131.6
                ],
                "bounds": [
                  [
                    45788.2,
                    39961.2
                  ],
                  [
                    45622.4,
                    40035.3
                  ],
                  [
                    45514.4,
                    40199.6
                  ],
                  [
                    45521,
                    40379.3
                  ],
                  [
                    44999.1,
                    40615.7
                  ],
                  [
                    44932,
                    40457.5
                  ],
                  [
                    44726.7,
                    40357
                  ],
                  [
                    44833.2,
                    40209.2
                  ],
                  [
                    45154.9,
                    40186.9
                  ],
                  [
                    45275.1,
                    40006.7
                  ],
                  [
                    45221.7,
                    39894.2
                  ],
                  [
                    45346.4,
                    39724.8
                  ],
                  [
                    45801.9,
                    39683.2
                  ],
                  [
                    45788.2,
                    39961.2
                  ]
                ],
                "id": 598,
                "chat_link": "[&BFYCAAA=]"
              }
            },
            "adventures": [],
            "id": 761,
            "mastery_points": []
          },
          "762": {
            "name": "Hunters and Prey",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45184,
              40576
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                43136,
                39552
              ],
              [
                47232,
                41600
              ]
            ],
            "points_of_interest": {
              "675": {
                "name": "Dhuum's Last Stand",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45213.7,
                  40401.9
                ],
                "id": 675,
                "chat_link": "[&BKMCAAA=]"
              },
              "676": {
                "name": "Village of Wren",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45477.6,
                  40770.4
                ],
                "id": 676,
                "chat_link": "[&BKQCAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "598": {
                "name": "Blighted Arch",
                "level": 78,
                "coord": [
                  45287.5,
                  40131.6
                ],
                "bounds": [
                  [
                    45788.2,
                    39961.2
                  ],
                  [
                    45622.4,
                    40035.3
                  ],
                  [
                    45514.4,
                    40199.6
                  ],
                  [
                    45521,
                    40379.3
                  ],
                  [
                    44999.1,
                    40615.7
                  ],
                  [
                    44932,
                    40457.5
                  ],
                  [
                    44726.7,
                    40357
                  ],
                  [
                    44833.2,
                    40209.2
                  ],
                  [
                    45154.9,
                    40186.9
                  ],
                  [
                    45275.1,
                    40006.7
                  ],
                  [
                    45221.7,
                    39894.2
                  ],
                  [
                    45346.4,
                    39724.8
                  ],
                  [
                    45801.9,
                    39683.2
                  ],
                  [
                    45788.2,
                    39961.2
                  ]
                ],
                "id": 598,
                "chat_link": "[&BFYCAAA=]"
              },
              "608": {
                "name": "Garden of Ilya",
                "level": 78,
                "coord": [
                  45441.3,
                  40838.2
                ],
                "bounds": [
                  [
                    44993.5,
                    40743.5
                  ],
                  [
                    44998.2,
                    40613.9
                  ],
                  [
                    45520.1,
                    40378.2
                  ],
                  [
                    45633.6,
                    40568.9
                  ],
                  [
                    45752.7,
                    40635.1
                  ],
                  [
                    45604,
                    41124.8
                  ],
                  [
                    45646.1,
                    41280.1
                  ],
                  [
                    45382.3,
                    41360.9
                  ],
                  [
                    44993.5,
                    40743.5
                  ]
                ],
                "id": 608,
                "chat_link": "[&BGACAAA=]"
              }
            },
            "adventures": [],
            "id": 762,
            "mastery_points": []
          },
          "763": {
            "name": "Romke's Final Voyage",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              43904,
              43648
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42880,
                41600
              ],
              [
                44928,
                45696
              ]
            ],
            "points_of_interest": {
              "785": {
                "name": "Augur's Torch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43818.7,
                  44420.7
                ],
                "id": 785,
                "chat_link": "[&BBEDAAA=]"
              },
              "787": {
                "name": "Sharn's Free Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44164.1,
                  44775.7
                ],
                "id": 787,
                "chat_link": "[&BBMDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "715": {
                "name": "The Shipyard",
                "level": 80,
                "coord": [
                  43714.4,
                  44405.2
                ],
                "bounds": [
                  [
                    43599.7,
                    43613.2
                  ],
                  [
                    43611.7,
                    43858
                  ],
                  [
                    43673.5,
                    44084
                  ],
                  [
                    43689.9,
                    44368.5
                  ],
                  [
                    43899.7,
                    44514.8
                  ],
                  [
                    44071.4,
                    44725.9
                  ],
                  [
                    44188.1,
                    44975.2
                  ],
                  [
                    43860,
                    45245.5
                  ],
                  [
                    43801,
                    45005.5
                  ],
                  [
                    43669.8,
                    44681
                  ],
                  [
                    43417.3,
                    44233.5
                  ],
                  [
                    43449.5,
                    44017.8
                  ],
                  [
                    43355.6,
                    43944.9
                  ],
                  [
                    43599.7,
                    43613.2
                  ]
                ],
                "id": 715,
                "chat_link": "[&BMsCAAA=]"
              },
              "717": {
                "name": "Desmina's Hallows",
                "level": 80,
                "coord": [
                  44453.4,
                  44936.2
                ],
                "bounds": [
                  [
                    44254.7,
                    45277.6
                  ],
                  [
                    44177.2,
                    45147.4
                  ],
                  [
                    44188.3,
                    44974.2
                  ],
                  [
                    44071,
                    44726.4
                  ],
                  [
                    43967.5,
                    44599.1
                  ],
                  [
                    44153.5,
                    44457.8
                  ],
                  [
                    44238.6,
                    44517.1
                  ],
                  [
                    44364.7,
                    44579.3
                  ],
                  [
                    44587.8,
                    44579.2
                  ],
                  [
                    44896.2,
                    44639.5
                  ],
                  [
                    44856.9,
                    44941.7
                  ],
                  [
                    44911.2,
                    45187.3
                  ],
                  [
                    44864.8,
                    45371.2
                  ],
                  [
                    44693.7,
                    45345.1
                  ],
                  [
                    44624.7,
                    45291.8
                  ],
                  [
                    44403.8,
                    45344.1
                  ],
                  [
                    44254.7,
                    45277.6
                  ]
                ],
                "id": 717,
                "chat_link": "[&BM0CAAA=]"
              },
              "718": {
                "name": "Compass Plaza",
                "level": 80,
                "coord": [
                  43925.6,
                  44122
                ],
                "bounds": [
                  [
                    43901.4,
                    44515.3
                  ],
                  [
                    43690.3,
                    44370
                  ],
                  [
                    43673.5,
                    44086.8
                  ],
                  [
                    43611.8,
                    43858.5
                  ],
                  [
                    43600,
                    43613.6
                  ],
                  [
                    43820.4,
                    43686.5
                  ],
                  [
                    44048,
                    43690.1
                  ],
                  [
                    44084.9,
                    43882.3
                  ],
                  [
                    44239.1,
                    43980.5
                  ],
                  [
                    44100.4,
                    44160.5
                  ],
                  [
                    44005.4,
                    44206.1
                  ],
                  [
                    43972,
                    44313.1
                  ],
                  [
                    44016.3,
                    44407.6
                  ],
                  [
                    44153.5,
                    44456.7
                  ],
                  [
                    43967.3,
                    44602.3
                  ],
                  [
                    43901.4,
                    44515.3
                  ]
                ],
                "id": 718,
                "chat_link": "[&BM4CAAA=]"
              }
            },
            "adventures": [],
            "id": 763,
            "mastery_points": []
          },
          "764": {
            "name": "Marching Orders",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45184,
              40576
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                43136,
                39552
              ],
              [
                47232,
                41600
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 764,
            "mastery_points": []
          },
          "766": {
            "name": "Air Drop",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45184,
              40576
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                43136,
                39552
              ],
              [
                47232,
                41600
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 766,
            "mastery_points": []
          },
          "767": {
            "name": "Estate of Decay",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45184,
              40576
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                43136,
                39552
              ],
              [
                47232,
                41600
              ]
            ],
            "points_of_interest": {
              "655": {
                "name": "Kitah Manse",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47130.2,
                  40723
                ],
                "id": 655,
                "chat_link": "[&BI8CAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "600": {
                "name": "Waste Hollows",
                "level": 75,
                "coord": [
                  47079.6,
                  40709.6
                ],
                "bounds": [
                  [
                    46986.4,
                    41133
                  ],
                  [
                    46705.6,
                    40697.8
                  ],
                  [
                    46714.7,
                    40577.5
                  ],
                  [
                    46901.2,
                    40419.4
                  ],
                  [
                    47048,
                    40355.1
                  ],
                  [
                    47194.5,
                    40368.8
                  ],
                  [
                    47367.3,
                    40581.9
                  ],
                  [
                    47314.8,
                    40861.2
                  ],
                  [
                    47332.4,
                    41021.3
                  ],
                  [
                    47231.4,
                    41080.2
                  ],
                  [
                    46986.4,
                    41133
                  ]
                ],
                "id": 600,
                "chat_link": "[&BFgCAAA=]"
              }
            },
            "adventures": [],
            "id": 767,
            "mastery_points": []
          },
          "768": {
            "name": "What the Eye Beholds",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              48688,
              40192
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                47232,
                38784
              ],
              [
                50560,
                41600
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "696": {
                "name": "Strait of Sacrilege",
                "level": 73,
                "coord": [
                  48746.7,
                  40042
                ],
                "bounds": [
                  [
                    48895.7,
                    39149.8
                  ],
                  [
                    48969.7,
                    39276.7
                  ],
                  [
                    49082.6,
                    39961.7
                  ],
                  [
                    49431.6,
                    40321.2
                  ],
                  [
                    48934.1,
                    40688.2
                  ],
                  [
                    48783.9,
                    40782.9
                  ],
                  [
                    48674.3,
                    40724.4
                  ],
                  [
                    48582.3,
                    40451.8
                  ],
                  [
                    48567.6,
                    40273.6
                  ],
                  [
                    48601,
                    40074.1
                  ],
                  [
                    48545,
                    39970.6
                  ],
                  [
                    48407.4,
                    39828.4
                  ],
                  [
                    48311.4,
                    39564.6
                  ],
                  [
                    48666.5,
                    39519.7
                  ],
                  [
                    48895.7,
                    39149.8
                  ]
                ],
                "id": 696,
                "chat_link": "[&BLgCAAA=]"
              },
              "697": {
                "name": "Terzetto Bay",
                "level": 72,
                "coord": [
                  49446.3,
                  39650.2
                ],
                "bounds": [
                  [
                    49801.1,
                    40156.9
                  ],
                  [
                    49907.6,
                    40267.9
                  ],
                  [
                    49869.1,
                    40478.5
                  ],
                  [
                    49431.7,
                    40320.8
                  ],
                  [
                    49082.8,
                    39962
                  ],
                  [
                    48969.6,
                    39276.6
                  ],
                  [
                    49033,
                    39273.5
                  ],
                  [
                    49111.3,
                    39202.9
                  ],
                  [
                    49144,
                    39127.4
                  ],
                  [
                    49218.4,
                    39124.2
                  ],
                  [
                    49367.5,
                    39183
                  ],
                  [
                    49554,
                    39411.3
                  ],
                  [
                    49765.7,
                    39477.4
                  ],
                  [
                    49743.7,
                    39630.5
                  ],
                  [
                    49694.8,
                    39860.4
                  ],
                  [
                    49801.1,
                    40156.9
                  ]
                ],
                "id": 697,
                "chat_link": "[&BLkCAAA=]"
              }
            },
            "adventures": [],
            "id": 768,
            "mastery_points": []
          },
          "769": {
            "name": "Conscript the Dead Ships",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45184,
              40576
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                43136,
                39552
              ],
              [
                47232,
                41600
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "594": {
                "name": "Whisper Bay",
                "level": 78,
                "coord": [
                  44853.1,
                  40042.4
                ],
                "bounds": [
                  [
                    44332.4,
                    40319.1
                  ],
                  [
                    44435.2,
                    40165.3
                  ],
                  [
                    44422.4,
                    39782.1
                  ],
                  [
                    44849.3,
                    39671.1
                  ],
                  [
                    45135.8,
                    39685.1
                  ],
                  [
                    45347.8,
                    39730.8
                  ],
                  [
                    45229.8,
                    39894.6
                  ],
                  [
                    45282.9,
                    40003.3
                  ],
                  [
                    45163.3,
                    40194.6
                  ],
                  [
                    44838.1,
                    40220.9
                  ],
                  [
                    44729.6,
                    40366.5
                  ],
                  [
                    44470.5,
                    40475.9
                  ],
                  [
                    44332.4,
                    40319.1
                  ]
                ],
                "id": 594,
                "chat_link": "[&BFICAAA=]"
              }
            },
            "adventures": [],
            "id": 769,
            "mastery_points": []
          },
          "772": {
            "name": "Ossuary of Unquiet Dead",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45184,
              40576
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                43136,
                39552
              ],
              [
                47232,
                41600
              ]
            ],
            "points_of_interest": {
              "650": {
                "name": "Beacon Torch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45356.5,
                  40139.2
                ],
                "id": 650,
                "chat_link": "[&BIoCAAA=]"
              },
              "660": {
                "name": "Altar of Lies",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45903.2,
                  40336.9
                ],
                "id": 660,
                "chat_link": "[&BJQCAAA=]"
              },
              "662": {
                "name": "Song of Lyss",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46143.1,
                  40563.5
                ],
                "id": 662,
                "chat_link": "[&BJYCAAA=]"
              },
              "663": {
                "name": "Seal of Union",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46006.8,
                  39963.1
                ],
                "id": 663,
                "chat_link": "[&BJcCAAA=]"
              },
              "675": {
                "name": "Dhuum's Last Stand",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45213.7,
                  40401.9
                ],
                "id": 675,
                "chat_link": "[&BKMCAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "593": {
                "name": "Crusted Sholes",
                "level": 76,
                "coord": [
                  46426.2,
                  40525.6
                ],
                "bounds": [
                  [
                    46170.4,
                    40292.6
                  ],
                  [
                    46366.4,
                    40177.1
                  ],
                  [
                    46506.5,
                    40289.4
                  ],
                  [
                    46650.5,
                    40325.7
                  ],
                  [
                    46648,
                    40462.8
                  ],
                  [
                    46720.4,
                    40575.3
                  ],
                  [
                    46706.5,
                    40700.3
                  ],
                  [
                    46630.3,
                    40751
                  ],
                  [
                    46459.7,
                    40654.5
                  ],
                  [
                    46314.6,
                    40756.3
                  ],
                  [
                    46217.2,
                    40786.8
                  ],
                  [
                    46017.9,
                    40589.3
                  ],
                  [
                    46132,
                    40471.8
                  ],
                  [
                    46170.4,
                    40292.6
                  ]
                ],
                "id": 593,
                "chat_link": "[&BFECAAA=]"
              },
              "595": {
                "name": "Mirror Bay",
                "level": 76,
                "coord": [
                  46287.6,
                  40001.9
                ],
                "bounds": [
                  [
                    46169.7,
                    40295.6
                  ],
                  [
                    46113.8,
                    40139.2
                  ],
                  [
                    45964.6,
                    40000.9
                  ],
                  [
                    45788.9,
                    39964.5
                  ],
                  [
                    45803.4,
                    39684.7
                  ],
                  [
                    46800.9,
                    39757
                  ],
                  [
                    46777.4,
                    39886.2
                  ],
                  [
                    46656.6,
                    40055.6
                  ],
                  [
                    46430.1,
                    40053.2
                  ],
                  [
                    46370.8,
                    40181.8
                  ],
                  [
                    46169.7,
                    40295.6
                  ]
                ],
                "id": 595,
                "chat_link": "[&BFMCAAA=]"
              },
              "598": {
                "name": "Blighted Arch",
                "level": 78,
                "coord": [
                  45287.5,
                  40131.6
                ],
                "bounds": [
                  [
                    45788.2,
                    39961.2
                  ],
                  [
                    45622.4,
                    40035.3
                  ],
                  [
                    45514.4,
                    40199.6
                  ],
                  [
                    45521,
                    40379.3
                  ],
                  [
                    44999.1,
                    40615.7
                  ],
                  [
                    44932,
                    40457.5
                  ],
                  [
                    44726.7,
                    40357
                  ],
                  [
                    44833.2,
                    40209.2
                  ],
                  [
                    45154.9,
                    40186.9
                  ],
                  [
                    45275.1,
                    40006.7
                  ],
                  [
                    45221.7,
                    39894.2
                  ],
                  [
                    45346.4,
                    39724.8
                  ],
                  [
                    45801.9,
                    39683.2
                  ],
                  [
                    45788.2,
                    39961.2
                  ]
                ],
                "id": 598,
                "chat_link": "[&BFYCAAA=]"
              },
              "606": {
                "name": "Cathedral of Eternal Radiance",
                "level": 78,
                "coord": [
                  45842.7,
                  40326.8
                ],
                "bounds": [
                  [
                    45515.9,
                    40380.6
                  ],
                  [
                    45516,
                    40199.5
                  ],
                  [
                    45623.1,
                    40036.3
                  ],
                  [
                    45792.8,
                    39962.8
                  ],
                  [
                    45964.6,
                    40001.3
                  ],
                  [
                    46108.2,
                    40140.3
                  ],
                  [
                    46172.1,
                    40294.7
                  ],
                  [
                    46134.3,
                    40473.1
                  ],
                  [
                    46018.4,
                    40590.1
                  ],
                  [
                    45880.4,
                    40640.5
                  ],
                  [
                    45754.5,
                    40630.9
                  ],
                  [
                    45631.8,
                    40572
                  ],
                  [
                    45515.9,
                    40380.6
                  ]
                ],
                "id": 606,
                "chat_link": "[&BF4CAAA=]"
              },
              "608": {
                "name": "Garden of Ilya",
                "level": 78,
                "coord": [
                  45441.3,
                  40838.2
                ],
                "bounds": [
                  [
                    44993.5,
                    40743.5
                  ],
                  [
                    44998.2,
                    40613.9
                  ],
                  [
                    45520.1,
                    40378.2
                  ],
                  [
                    45633.6,
                    40568.9
                  ],
                  [
                    45752.7,
                    40635.1
                  ],
                  [
                    45604,
                    41124.8
                  ],
                  [
                    45646.1,
                    41280.1
                  ],
                  [
                    45382.3,
                    41360.9
                  ],
                  [
                    44993.5,
                    40743.5
                  ]
                ],
                "id": 608,
                "chat_link": "[&BGACAAA=]"
              }
            },
            "adventures": [],
            "id": 772,
            "mastery_points": []
          },
          "775": {
            "name": "Temple of the Forgotten God",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              48688,
              40192
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                47232,
                38784
              ],
              [
                50560,
                41600
              ]
            ],
            "points_of_interest": {
              "1023": {
                "name": "Caer Aval",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49933.9,
                  40162.5
                ],
                "id": 1023,
                "chat_link": "[&BP8DAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "684": {
                "name": "Fort Trinity",
                "level": 71,
                "coord": [
                  50040.2,
                  39934
                ],
                "bounds": [
                  [
                    49835.6,
                    39572.2
                  ],
                  [
                    49992,
                    39616.4
                  ],
                  [
                    50251.7,
                    39775.9
                  ],
                  [
                    50244.2,
                    39912.7
                  ],
                  [
                    50296.7,
                    39959.1
                  ],
                  [
                    50291.5,
                    40014.9
                  ],
                  [
                    50254.4,
                    40055.6
                  ],
                  [
                    50205.3,
                    40064.9
                  ],
                  [
                    50007.9,
                    40260.7
                  ],
                  [
                    49911.3,
                    40265.5
                  ],
                  [
                    49799.9,
                    40158.6
                  ],
                  [
                    49695.4,
                    39860.6
                  ],
                  [
                    49736.9,
                    39624.7
                  ],
                  [
                    49835.6,
                    39572.2
                  ]
                ],
                "id": 684,
                "chat_link": "[&BKwCAAA=]"
              }
            },
            "adventures": [],
            "id": 775,
            "mastery_points": []
          },
          "776": {
            "name": "Temple of the Forgotten God",
            "min_level": 80,
            "max_level": 80,
            "default_floor": -8,
            "label_coord": [
              48262,
              39250
            ],
            "map_rect": [
              [
                -6144,
                -6144
              ],
              [
                9216,
                9216
              ]
            ],
            "continent_rect": [
              [
                48000,
                38912
              ],
              [
                48640,
                39552
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 776,
            "mastery_points": []
          },
          "777": {
            "name": "Temple of the Forgotten God",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              48688,
              40192
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                47232,
                38784
              ],
              [
                50560,
                41600
              ]
            ],
            "points_of_interest": {
              "1023": {
                "name": "Caer Aval",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49933.9,
                  40162.5
                ],
                "id": 1023,
                "chat_link": "[&BP8DAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "684": {
                "name": "Fort Trinity",
                "level": 71,
                "coord": [
                  50040.2,
                  39934
                ],
                "bounds": [
                  [
                    49835.6,
                    39572.2
                  ],
                  [
                    49992,
                    39616.4
                  ],
                  [
                    50251.7,
                    39775.9
                  ],
                  [
                    50244.2,
                    39912.7
                  ],
                  [
                    50296.7,
                    39959.1
                  ],
                  [
                    50291.5,
                    40014.9
                  ],
                  [
                    50254.4,
                    40055.6
                  ],
                  [
                    50205.3,
                    40064.9
                  ],
                  [
                    50007.9,
                    40260.7
                  ],
                  [
                    49911.3,
                    40265.5
                  ],
                  [
                    49799.9,
                    40158.6
                  ],
                  [
                    49695.4,
                    39860.6
                  ],
                  [
                    49736.9,
                    39624.7
                  ],
                  [
                    49835.6,
                    39572.2
                  ]
                ],
                "id": 684,
                "chat_link": "[&BKwCAAA=]"
              }
            },
            "adventures": [],
            "id": 777,
            "mastery_points": []
          },
          "778": {
            "name": "Through the Looking Glass",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              48688,
              40192
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                47232,
                38784
              ],
              [
                50560,
                41600
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "684": {
                "name": "Fort Trinity",
                "level": 71,
                "coord": [
                  50040.2,
                  39934
                ],
                "bounds": [
                  [
                    49835.6,
                    39572.2
                  ],
                  [
                    49992,
                    39616.4
                  ],
                  [
                    50251.7,
                    39775.9
                  ],
                  [
                    50244.2,
                    39912.7
                  ],
                  [
                    50296.7,
                    39959.1
                  ],
                  [
                    50291.5,
                    40014.9
                  ],
                  [
                    50254.4,
                    40055.6
                  ],
                  [
                    50205.3,
                    40064.9
                  ],
                  [
                    50007.9,
                    40260.7
                  ],
                  [
                    49911.3,
                    40265.5
                  ],
                  [
                    49799.9,
                    40158.6
                  ],
                  [
                    49695.4,
                    39860.6
                  ],
                  [
                    49736.9,
                    39624.7
                  ],
                  [
                    49835.6,
                    39572.2
                  ]
                ],
                "id": 684,
                "chat_link": "[&BKwCAAA=]"
              }
            },
            "adventures": [],
            "id": 778,
            "mastery_points": []
          },
          "779": {
            "name": "Starving the Beast",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              48688,
              40192
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                47232,
                38784
              ],
              [
                50560,
                41600
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "684": {
                "name": "Fort Trinity",
                "level": 71,
                "coord": [
                  50040.2,
                  39934
                ],
                "bounds": [
                  [
                    49835.6,
                    39572.2
                  ],
                  [
                    49992,
                    39616.4
                  ],
                  [
                    50251.7,
                    39775.9
                  ],
                  [
                    50244.2,
                    39912.7
                  ],
                  [
                    50296.7,
                    39959.1
                  ],
                  [
                    50291.5,
                    40014.9
                  ],
                  [
                    50254.4,
                    40055.6
                  ],
                  [
                    50205.3,
                    40064.9
                  ],
                  [
                    50007.9,
                    40260.7
                  ],
                  [
                    49911.3,
                    40265.5
                  ],
                  [
                    49799.9,
                    40158.6
                  ],
                  [
                    49695.4,
                    39860.6
                  ],
                  [
                    49736.9,
                    39624.7
                  ],
                  [
                    49835.6,
                    39572.2
                  ]
                ],
                "id": 684,
                "chat_link": "[&BKwCAAA=]"
              }
            },
            "adventures": [],
            "id": 779,
            "mastery_points": []
          },
          "780": {
            "name": "Against the Corruption",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              43904,
              43648
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42880,
                41600
              ],
              [
                44928,
                45696
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 780,
            "mastery_points": []
          },
          "781": {
            "name": "The Source of Orr",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              43904,
              43648
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42880,
                41600
              ],
              [
                44928,
                45696
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "707": {
                "name": "Penitent Path",
                "level": 80,
                "coord": [
                  44288.7,
                  42852.1
                ],
                "bounds": [
                  [
                    44286.8,
                    42613.5
                  ],
                  [
                    44500.6,
                    42921.6
                  ],
                  [
                    44301.1,
                    43170
                  ],
                  [
                    44189.8,
                    42907.8
                  ],
                  [
                    44165.1,
                    42647.8
                  ],
                  [
                    44286.8,
                    42613.5
                  ]
                ],
                "id": 707,
                "chat_link": "[&BMMCAAA=]"
              },
              "708": {
                "name": "The Artesian Waters",
                "level": 80,
                "coord": [
                  44630.4,
                  42659.6
                ],
                "bounds": [
                  [
                    44518.4,
                    42539.9
                  ],
                  [
                    44562.9,
                    42386.7
                  ],
                  [
                    44890.9,
                    42593.2
                  ],
                  [
                    44886.7,
                    42720.2
                  ],
                  [
                    44764.7,
                    42858.1
                  ],
                  [
                    44502.1,
                    42922
                  ],
                  [
                    44286.9,
                    42597.4
                  ],
                  [
                    44518.4,
                    42539.9
                  ]
                ],
                "id": 708,
                "chat_link": "[&BMQCAAA=]"
              },
              "711": {
                "name": "Cathedral of Verdance",
                "level": 80,
                "coord": [
                  44061,
                  43084.8
                ],
                "bounds": [
                  [
                    44183.8,
                    42822.9
                  ],
                  [
                    44190,
                    42908.3
                  ],
                  [
                    44227.2,
                    42963.7
                  ],
                  [
                    44302.1,
                    43169.3
                  ],
                  [
                    43979.9,
                    43373
                  ],
                  [
                    43836,
                    43333.7
                  ],
                  [
                    43676,
                    43261.1
                  ],
                  [
                    44093.5,
                    42846.5
                  ],
                  [
                    44183.8,
                    42822.9
                  ]
                ],
                "id": 711,
                "chat_link": "[&BMcCAAA=]"
              }
            },
            "adventures": [],
            "id": 781,
            "mastery_points": []
          },
          "782": {
            "name": "Armor Guard",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45184,
              40576
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                43136,
                39552
              ],
              [
                47232,
                41600
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 782,
            "mastery_points": []
          },
          "783": {
            "name": "Blast from the Past",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              43904,
              43648
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42880,
                41600
              ],
              [
                44928,
                45696
              ]
            ],
            "points_of_interest": {
              "790": {
                "name": "Altar of the Withered Heart",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44058.2,
                  43081.5
                ],
                "id": 790,
                "chat_link": "[&BBYDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "705": {
                "name": "Winterknell Shore",
                "level": 80,
                "coord": [
                  43316.7,
                  42420.2
                ],
                "bounds": [
                  [
                    43436,
                    41835.2
                  ],
                  [
                    43508.9,
                    42068.7
                  ],
                  [
                    43744.8,
                    42372.7
                  ],
                  [
                    43693.9,
                    42631.2
                  ],
                  [
                    43472.1,
                    42728.1
                  ],
                  [
                    43328.3,
                    43062.3
                  ],
                  [
                    43132.2,
                    43137.5
                  ],
                  [
                    42965.4,
                    42704.8
                  ],
                  [
                    43085.9,
                    42308.7
                  ],
                  [
                    42897.7,
                    42011.9
                  ],
                  [
                    43218,
                    41760.9
                  ],
                  [
                    43436,
                    41835.2
                  ]
                ],
                "id": 705,
                "chat_link": "[&BMECAAA=]"
              },
              "706": {
                "name": "Winterknell Isle",
                "level": 80,
                "coord": [
                  43808.8,
                  42790.9
                ],
                "bounds": [
                  [
                    43988.1,
                    42528.3
                  ],
                  [
                    44073.3,
                    42631.7
                  ],
                  [
                    44165,
                    42648.7
                  ],
                  [
                    44181.5,
                    42823.1
                  ],
                  [
                    44092.9,
                    42846.1
                  ],
                  [
                    43680.4,
                    43264.4
                  ],
                  [
                    43481.3,
                    43165.7
                  ],
                  [
                    43324.4,
                    43061.9
                  ],
                  [
                    43471.1,
                    42726.7
                  ],
                  [
                    43693.2,
                    42630.6
                  ],
                  [
                    43745.4,
                    42372.4
                  ],
                  [
                    43988.1,
                    42528.3
                  ]
                ],
                "id": 706,
                "chat_link": "[&BMICAAA=]"
              },
              "710": {
                "name": "Craven Blight",
                "level": 80,
                "coord": [
                  43892.2,
                  43433.8
                ],
                "bounds": [
                  [
                    44302.6,
                    43169.2
                  ],
                  [
                    44445.5,
                    43380.2
                  ],
                  [
                    44200.3,
                    43548.1
                  ],
                  [
                    44048.2,
                    43689.7
                  ],
                  [
                    43819.8,
                    43685.5
                  ],
                  [
                    43599.5,
                    43612.5
                  ],
                  [
                    43507.3,
                    43465.1
                  ],
                  [
                    43515.1,
                    43308.5
                  ],
                  [
                    43559.2,
                    43206.3
                  ],
                  [
                    43836.3,
                    43332.9
                  ],
                  [
                    43980.3,
                    43373.9
                  ],
                  [
                    44302.6,
                    43169.2
                  ]
                ],
                "id": 710,
                "chat_link": "[&BMYCAAA=]"
              },
              "711": {
                "name": "Cathedral of Verdance",
                "level": 80,
                "coord": [
                  44061,
                  43084.8
                ],
                "bounds": [
                  [
                    44183.8,
                    42822.9
                  ],
                  [
                    44190,
                    42908.3
                  ],
                  [
                    44227.2,
                    42963.7
                  ],
                  [
                    44302.1,
                    43169.3
                  ],
                  [
                    43979.9,
                    43373
                  ],
                  [
                    43836,
                    43333.7
                  ],
                  [
                    43676,
                    43261.1
                  ],
                  [
                    44093.5,
                    42846.5
                  ],
                  [
                    44183.8,
                    42822.9
                  ]
                ],
                "id": 711,
                "chat_link": "[&BMcCAAA=]"
              },
              "712": {
                "name": "Harrowed Sea",
                "level": 80,
                "coord": [
                  43317.1,
                  43485
                ],
                "bounds": [
                  [
                    43508.1,
                    43464.8
                  ],
                  [
                    43600,
                    43612.9
                  ],
                  [
                    43355.5,
                    43944.7
                  ],
                  [
                    43159.6,
                    43951.1
                  ],
                  [
                    42968,
                    43796.8
                  ],
                  [
                    43045.7,
                    43367.2
                  ],
                  [
                    43132.9,
                    43138
                  ],
                  [
                    43325.1,
                    43057.7
                  ],
                  [
                    43560.1,
                    43208.3
                  ],
                  [
                    43515.8,
                    43308.3
                  ],
                  [
                    43508.1,
                    43464.8
                  ]
                ],
                "id": 712,
                "chat_link": "[&BMgCAAA=]"
              }
            },
            "adventures": [],
            "id": 783,
            "mastery_points": []
          },
          "784": {
            "name": "The Steel Tide",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              43904,
              43648
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42880,
                41600
              ],
              [
                44928,
                45696
              ]
            ],
            "points_of_interest": {
              "765": {
                "name": "Caer Shadowfain",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44064.5,
                  42175.3
                ],
                "id": 765,
                "chat_link": "[&BP0CAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "703": {
                "name": "Pursuit Pass",
                "level": 80,
                "coord": [
                  44478.3,
                  41846.8
                ],
                "bounds": [
                  [
                    44537.5,
                    41605
                  ],
                  [
                    44686.1,
                    41517.6
                  ],
                  [
                    44873.2,
                    41527.4
                  ],
                  [
                    44999.7,
                    41752.5
                  ],
                  [
                    44967.8,
                    42010.5
                  ],
                  [
                    44865.6,
                    42192.7
                  ],
                  [
                    44717.7,
                    42500.6
                  ],
                  [
                    44567.7,
                    42397.4
                  ],
                  [
                    43935.7,
                    42122.8
                  ],
                  [
                    43873,
                    41844.7
                  ],
                  [
                    43974.1,
                    41742.3
                  ],
                  [
                    44055.9,
                    41604
                  ],
                  [
                    44229.9,
                    41515.6
                  ],
                  [
                    44412.8,
                    41521.8
                  ],
                  [
                    44537.5,
                    41605
                  ]
                ],
                "id": 703,
                "chat_link": "[&BL8CAAA=]"
              },
              "704": {
                "name": "Fields of Gold",
                "level": 80,
                "coord": [
                  43910.4,
                  42076.2
                ],
                "bounds": [
                  [
                    43935.4,
                    42121.6
                  ],
                  [
                    44568.1,
                    42396.7
                  ],
                  [
                    44522.7,
                    42542.9
                  ],
                  [
                    44166.2,
                    42648.7
                  ],
                  [
                    44072.9,
                    42631.7
                  ],
                  [
                    43988.1,
                    42527.3
                  ],
                  [
                    43745,
                    42372.6
                  ],
                  [
                    43509,
                    42068.4
                  ],
                  [
                    43435.7,
                    41834.7
                  ],
                  [
                    43441.1,
                    41711.9
                  ],
                  [
                    43569,
                    41556.1
                  ],
                  [
                    43803.3,
                    41532.1
                  ],
                  [
                    44054,
                    41612.9
                  ],
                  [
                    43973.2,
                    41742.1
                  ],
                  [
                    43872.4,
                    41843.5
                  ],
                  [
                    43935.4,
                    42121.6
                  ]
                ],
                "id": 704,
                "chat_link": "[&BMACAAA=]"
              }
            },
            "adventures": [],
            "id": 784,
            "mastery_points": []
          },
          "785": {
            "name": "Further Into Orr",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45184,
              40576
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                43136,
                39552
              ],
              [
                47232,
                41600
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "606": {
                "name": "Cathedral of Eternal Radiance",
                "level": 78,
                "coord": [
                  45842.7,
                  40326.8
                ],
                "bounds": [
                  [
                    45515.9,
                    40380.6
                  ],
                  [
                    45516,
                    40199.5
                  ],
                  [
                    45623.1,
                    40036.3
                  ],
                  [
                    45792.8,
                    39962.8
                  ],
                  [
                    45964.6,
                    40001.3
                  ],
                  [
                    46108.2,
                    40140.3
                  ],
                  [
                    46172.1,
                    40294.7
                  ],
                  [
                    46134.3,
                    40473.1
                  ],
                  [
                    46018.4,
                    40590.1
                  ],
                  [
                    45880.4,
                    40640.5
                  ],
                  [
                    45754.5,
                    40630.9
                  ],
                  [
                    45631.8,
                    40572
                  ],
                  [
                    45515.9,
                    40380.6
                  ]
                ],
                "id": 606,
                "chat_link": "[&BF4CAAA=]"
              },
              "608": {
                "name": "Garden of Ilya",
                "level": 78,
                "coord": [
                  45441.3,
                  40838.2
                ],
                "bounds": [
                  [
                    44993.5,
                    40743.5
                  ],
                  [
                    44998.2,
                    40613.9
                  ],
                  [
                    45520.1,
                    40378.2
                  ],
                  [
                    45633.6,
                    40568.9
                  ],
                  [
                    45752.7,
                    40635.1
                  ],
                  [
                    45604,
                    41124.8
                  ],
                  [
                    45646.1,
                    41280.1
                  ],
                  [
                    45382.3,
                    41360.9
                  ],
                  [
                    44993.5,
                    40743.5
                  ]
                ],
                "id": 608,
                "chat_link": "[&BGACAAA=]"
              }
            },
            "adventures": [],
            "id": 785,
            "mastery_points": []
          },
          "786": {
            "name": "Ships of the Line",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              43904,
              43648
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42880,
                41600
              ],
              [
                44928,
                45696
              ]
            ],
            "points_of_interest": {
              "769": {
                "name": "Gavbeorn's Landing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43289.5,
                  42903.7
                ],
                "id": 769,
                "chat_link": "[&BAEDAAA=]"
              },
              "775": {
                "name": "Thorn Dock",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43601.5,
                  43583.3
                ],
                "id": 775,
                "chat_link": "[&BAcDAAA=]"
              },
              "776": {
                "name": "The Wreck of the Golden Vanity",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43108.7,
                  43577.4
                ],
                "id": 776,
                "chat_link": "[&BAgDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "705": {
                "name": "Winterknell Shore",
                "level": 80,
                "coord": [
                  43316.7,
                  42420.2
                ],
                "bounds": [
                  [
                    43436,
                    41835.2
                  ],
                  [
                    43508.9,
                    42068.7
                  ],
                  [
                    43744.8,
                    42372.7
                  ],
                  [
                    43693.9,
                    42631.2
                  ],
                  [
                    43472.1,
                    42728.1
                  ],
                  [
                    43328.3,
                    43062.3
                  ],
                  [
                    43132.2,
                    43137.5
                  ],
                  [
                    42965.4,
                    42704.8
                  ],
                  [
                    43085.9,
                    42308.7
                  ],
                  [
                    42897.7,
                    42011.9
                  ],
                  [
                    43218,
                    41760.9
                  ],
                  [
                    43436,
                    41835.2
                  ]
                ],
                "id": 705,
                "chat_link": "[&BMECAAA=]"
              },
              "706": {
                "name": "Winterknell Isle",
                "level": 80,
                "coord": [
                  43808.8,
                  42790.9
                ],
                "bounds": [
                  [
                    43988.1,
                    42528.3
                  ],
                  [
                    44073.3,
                    42631.7
                  ],
                  [
                    44165,
                    42648.7
                  ],
                  [
                    44181.5,
                    42823.1
                  ],
                  [
                    44092.9,
                    42846.1
                  ],
                  [
                    43680.4,
                    43264.4
                  ],
                  [
                    43481.3,
                    43165.7
                  ],
                  [
                    43324.4,
                    43061.9
                  ],
                  [
                    43471.1,
                    42726.7
                  ],
                  [
                    43693.2,
                    42630.6
                  ],
                  [
                    43745.4,
                    42372.4
                  ],
                  [
                    43988.1,
                    42528.3
                  ]
                ],
                "id": 706,
                "chat_link": "[&BMICAAA=]"
              },
              "710": {
                "name": "Craven Blight",
                "level": 80,
                "coord": [
                  43892.2,
                  43433.8
                ],
                "bounds": [
                  [
                    44302.6,
                    43169.2
                  ],
                  [
                    44445.5,
                    43380.2
                  ],
                  [
                    44200.3,
                    43548.1
                  ],
                  [
                    44048.2,
                    43689.7
                  ],
                  [
                    43819.8,
                    43685.5
                  ],
                  [
                    43599.5,
                    43612.5
                  ],
                  [
                    43507.3,
                    43465.1
                  ],
                  [
                    43515.1,
                    43308.5
                  ],
                  [
                    43559.2,
                    43206.3
                  ],
                  [
                    43836.3,
                    43332.9
                  ],
                  [
                    43980.3,
                    43373.9
                  ],
                  [
                    44302.6,
                    43169.2
                  ]
                ],
                "id": 710,
                "chat_link": "[&BMYCAAA=]"
              },
              "712": {
                "name": "Harrowed Sea",
                "level": 80,
                "coord": [
                  43317.1,
                  43485
                ],
                "bounds": [
                  [
                    43508.1,
                    43464.8
                  ],
                  [
                    43600,
                    43612.9
                  ],
                  [
                    43355.5,
                    43944.7
                  ],
                  [
                    43159.6,
                    43951.1
                  ],
                  [
                    42968,
                    43796.8
                  ],
                  [
                    43045.7,
                    43367.2
                  ],
                  [
                    43132.9,
                    43138
                  ],
                  [
                    43325.1,
                    43057.7
                  ],
                  [
                    43560.1,
                    43208.3
                  ],
                  [
                    43515.8,
                    43308.3
                  ],
                  [
                    43508.1,
                    43464.8
                  ]
                ],
                "id": 712,
                "chat_link": "[&BMgCAAA=]"
              },
              "715": {
                "name": "The Shipyard",
                "level": 80,
                "coord": [
                  43714.4,
                  44405.2
                ],
                "bounds": [
                  [
                    43599.7,
                    43613.2
                  ],
                  [
                    43611.7,
                    43858
                  ],
                  [
                    43673.5,
                    44084
                  ],
                  [
                    43689.9,
                    44368.5
                  ],
                  [
                    43899.7,
                    44514.8
                  ],
                  [
                    44071.4,
                    44725.9
                  ],
                  [
                    44188.1,
                    44975.2
                  ],
                  [
                    43860,
                    45245.5
                  ],
                  [
                    43801,
                    45005.5
                  ],
                  [
                    43669.8,
                    44681
                  ],
                  [
                    43417.3,
                    44233.5
                  ],
                  [
                    43449.5,
                    44017.8
                  ],
                  [
                    43355.6,
                    43944.9
                  ],
                  [
                    43599.7,
                    43613.2
                  ]
                ],
                "id": 715,
                "chat_link": "[&BMsCAAA=]"
              },
              "718": {
                "name": "Compass Plaza",
                "level": 80,
                "coord": [
                  43925.6,
                  44122
                ],
                "bounds": [
                  [
                    43901.4,
                    44515.3
                  ],
                  [
                    43690.3,
                    44370
                  ],
                  [
                    43673.5,
                    44086.8
                  ],
                  [
                    43611.8,
                    43858.5
                  ],
                  [
                    43600,
                    43613.6
                  ],
                  [
                    43820.4,
                    43686.5
                  ],
                  [
                    44048,
                    43690.1
                  ],
                  [
                    44084.9,
                    43882.3
                  ],
                  [
                    44239.1,
                    43980.5
                  ],
                  [
                    44100.4,
                    44160.5
                  ],
                  [
                    44005.4,
                    44206.1
                  ],
                  [
                    43972,
                    44313.1
                  ],
                  [
                    44016.3,
                    44407.6
                  ],
                  [
                    44153.5,
                    44456.7
                  ],
                  [
                    43967.3,
                    44602.3
                  ],
                  [
                    43901.4,
                    44515.3
                  ]
                ],
                "id": 718,
                "chat_link": "[&BM4CAAA=]"
              }
            },
            "adventures": [],
            "id": 786,
            "mastery_points": []
          },
          "787": {
            "name": "Source of Orr",
            "min_level": 70,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              48688,
              40192
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                47232,
                38784
              ],
              [
                50560,
                41600
              ]
            ],
            "points_of_interest": {
              "1023": {
                "name": "Caer Aval",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49933.9,
                  40162.5
                ],
                "id": 1023,
                "chat_link": "[&BP8DAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "684": {
                "name": "Fort Trinity",
                "level": 71,
                "coord": [
                  50040.2,
                  39934
                ],
                "bounds": [
                  [
                    49835.6,
                    39572.2
                  ],
                  [
                    49992,
                    39616.4
                  ],
                  [
                    50251.7,
                    39775.9
                  ],
                  [
                    50244.2,
                    39912.7
                  ],
                  [
                    50296.7,
                    39959.1
                  ],
                  [
                    50291.5,
                    40014.9
                  ],
                  [
                    50254.4,
                    40055.6
                  ],
                  [
                    50205.3,
                    40064.9
                  ],
                  [
                    50007.9,
                    40260.7
                  ],
                  [
                    49911.3,
                    40265.5
                  ],
                  [
                    49799.9,
                    40158.6
                  ],
                  [
                    49695.4,
                    39860.6
                  ],
                  [
                    49736.9,
                    39624.7
                  ],
                  [
                    49835.6,
                    39572.2
                  ]
                ],
                "id": 684,
                "chat_link": "[&BKwCAAA=]"
              },
              "697": {
                "name": "Terzetto Bay",
                "level": 72,
                "coord": [
                  49446.3,
                  39650.2
                ],
                "bounds": [
                  [
                    49801.1,
                    40156.9
                  ],
                  [
                    49907.6,
                    40267.9
                  ],
                  [
                    49869.1,
                    40478.5
                  ],
                  [
                    49431.7,
                    40320.8
                  ],
                  [
                    49082.8,
                    39962
                  ],
                  [
                    48969.6,
                    39276.6
                  ],
                  [
                    49033,
                    39273.5
                  ],
                  [
                    49111.3,
                    39202.9
                  ],
                  [
                    49144,
                    39127.4
                  ],
                  [
                    49218.4,
                    39124.2
                  ],
                  [
                    49367.5,
                    39183
                  ],
                  [
                    49554,
                    39411.3
                  ],
                  [
                    49765.7,
                    39477.4
                  ],
                  [
                    49743.7,
                    39630.5
                  ],
                  [
                    49694.8,
                    39860.4
                  ],
                  [
                    49801.1,
                    40156.9
                  ]
                ],
                "id": 697,
                "chat_link": "[&BLkCAAA=]"
              }
            },
            "adventures": [],
            "id": 787,
            "mastery_points": []
          },
          "788": {
            "name": "Victory or Death",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              48688,
              40192
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                47232,
                38784
              ],
              [
                50560,
                41600
              ]
            ],
            "points_of_interest": {
              "1021": {
                "name": "Armada Harbor",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49843.7,
                  39841
                ],
                "id": 1021,
                "chat_link": "[&BP0DAAA=]"
              },
              "1022": {
                "name": "Alseta Generator",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50143,
                  39986.2
                ],
                "id": 1022,
                "chat_link": "[&BP4DAAA=]"
              },
              "1023": {
                "name": "Caer Aval",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49933.9,
                  40162.5
                ],
                "id": 1023,
                "chat_link": "[&BP8DAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "684": {
                "name": "Fort Trinity",
                "level": 71,
                "coord": [
                  50040.2,
                  39934
                ],
                "bounds": [
                  [
                    49835.6,
                    39572.2
                  ],
                  [
                    49992,
                    39616.4
                  ],
                  [
                    50251.7,
                    39775.9
                  ],
                  [
                    50244.2,
                    39912.7
                  ],
                  [
                    50296.7,
                    39959.1
                  ],
                  [
                    50291.5,
                    40014.9
                  ],
                  [
                    50254.4,
                    40055.6
                  ],
                  [
                    50205.3,
                    40064.9
                  ],
                  [
                    50007.9,
                    40260.7
                  ],
                  [
                    49911.3,
                    40265.5
                  ],
                  [
                    49799.9,
                    40158.6
                  ],
                  [
                    49695.4,
                    39860.6
                  ],
                  [
                    49736.9,
                    39624.7
                  ],
                  [
                    49835.6,
                    39572.2
                  ]
                ],
                "id": 684,
                "chat_link": "[&BKwCAAA=]"
              },
              "697": {
                "name": "Terzetto Bay",
                "level": 72,
                "coord": [
                  49446.3,
                  39650.2
                ],
                "bounds": [
                  [
                    49801.1,
                    40156.9
                  ],
                  [
                    49907.6,
                    40267.9
                  ],
                  [
                    49869.1,
                    40478.5
                  ],
                  [
                    49431.7,
                    40320.8
                  ],
                  [
                    49082.8,
                    39962
                  ],
                  [
                    48969.6,
                    39276.6
                  ],
                  [
                    49033,
                    39273.5
                  ],
                  [
                    49111.3,
                    39202.9
                  ],
                  [
                    49144,
                    39127.4
                  ],
                  [
                    49218.4,
                    39124.2
                  ],
                  [
                    49367.5,
                    39183
                  ],
                  [
                    49554,
                    39411.3
                  ],
                  [
                    49765.7,
                    39477.4
                  ],
                  [
                    49743.7,
                    39630.5
                  ],
                  [
                    49694.8,
                    39860.4
                  ],
                  [
                    49801.1,
                    40156.9
                  ]
                ],
                "id": 697,
                "chat_link": "[&BLkCAAA=]"
              }
            },
            "adventures": [],
            "id": 788,
            "mastery_points": []
          },
          "789": {
            "name": "A Grisly Shipment",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45184,
              40576
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                43136,
                39552
              ],
              [
                47232,
                41600
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 789,
            "mastery_points": []
          },
          "790": {
            "name": "Blast from the Past",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              43904,
              43648
            ],
            "map_rect": [
              [
                -24576,
                -49152
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42880,
                41600
              ],
              [
                44928,
                45696
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "705": {
                "name": "Winterknell Shore",
                "level": 80,
                "coord": [
                  43316.7,
                  42420.2
                ],
                "bounds": [
                  [
                    43436,
                    41835.2
                  ],
                  [
                    43508.9,
                    42068.7
                  ],
                  [
                    43744.8,
                    42372.7
                  ],
                  [
                    43693.9,
                    42631.2
                  ],
                  [
                    43472.1,
                    42728.1
                  ],
                  [
                    43328.3,
                    43062.3
                  ],
                  [
                    43132.2,
                    43137.5
                  ],
                  [
                    42965.4,
                    42704.8
                  ],
                  [
                    43085.9,
                    42308.7
                  ],
                  [
                    42897.7,
                    42011.9
                  ],
                  [
                    43218,
                    41760.9
                  ],
                  [
                    43436,
                    41835.2
                  ]
                ],
                "id": 705,
                "chat_link": "[&BMECAAA=]"
              },
              "706": {
                "name": "Winterknell Isle",
                "level": 80,
                "coord": [
                  43808.8,
                  42790.9
                ],
                "bounds": [
                  [
                    43988.1,
                    42528.3
                  ],
                  [
                    44073.3,
                    42631.7
                  ],
                  [
                    44165,
                    42648.7
                  ],
                  [
                    44181.5,
                    42823.1
                  ],
                  [
                    44092.9,
                    42846.1
                  ],
                  [
                    43680.4,
                    43264.4
                  ],
                  [
                    43481.3,
                    43165.7
                  ],
                  [
                    43324.4,
                    43061.9
                  ],
                  [
                    43471.1,
                    42726.7
                  ],
                  [
                    43693.2,
                    42630.6
                  ],
                  [
                    43745.4,
                    42372.4
                  ],
                  [
                    43988.1,
                    42528.3
                  ]
                ],
                "id": 706,
                "chat_link": "[&BMICAAA=]"
              }
            },
            "adventures": [],
            "id": 790,
            "mastery_points": []
          },
          "792": {
            "name": "A Pup's Illness",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -21504,
                -55296
              ],
              [
                21504,
                55296
              ]
            ],
            "continent_rect": [
              [
                54528,
                27648
              ],
              [
                56320,
                32256
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "197": {
                "name": "The Grekvelnn Burrows",
                "level": 4,
                "coord": [
                  56120.4,
                  31710
                ],
                "bounds": [
                  [
                    56050.5,
                    31711.5
                  ],
                  [
                    56067.3,
                    31361.3
                  ],
                  [
                    56294.3,
                    31416.3
                  ],
                  [
                    56303.8,
                    31894.3
                  ],
                  [
                    56170.4,
                    32113.7
                  ],
                  [
                    55836.3,
                    31762.9
                  ],
                  [
                    56050.5,
                    31711.5
                  ]
                ],
                "id": 197,
                "chat_link": "[&BMUAAAA=]"
              },
              "198": {
                "name": "Grawlenfjord",
                "level": 3,
                "coord": [
                  55900.5,
                  31298.1
                ],
                "bounds": [
                  [
                    55773.9,
                    31117.4
                  ],
                  [
                    55817,
                    31037.1
                  ],
                  [
                    55865.1,
                    31047.1
                  ],
                  [
                    55893.6,
                    30997.3
                  ],
                  [
                    56081,
                    30999.2
                  ],
                  [
                    56068.5,
                    31380.1
                  ],
                  [
                    56051.4,
                    31713
                  ],
                  [
                    55840.6,
                    31765.8
                  ],
                  [
                    55713.6,
                    31626.1
                  ],
                  [
                    55773.9,
                    31117.4
                  ]
                ],
                "id": 198,
                "chat_link": "[&BMYAAAA=]"
              },
              "199": {
                "name": "Kresdor Kenning",
                "level": 4,
                "coord": [
                  56190.7,
                  31094
                ],
                "bounds": [
                  [
                    56041.5,
                    30806.2
                  ],
                  [
                    56303.2,
                    30827
                  ],
                  [
                    56360.8,
                    31142.7
                  ],
                  [
                    56296.1,
                    31417.1
                  ],
                  [
                    56066.1,
                    31360.4
                  ],
                  [
                    56076.6,
                    31010.9
                  ],
                  [
                    56041.5,
                    30806.2
                  ]
                ],
                "id": 199,
                "chat_link": "[&BMcAAAA=]"
              }
            },
            "adventures": [],
            "id": 792,
            "mastery_points": []
          },
          "793": {
            "name": "Hunters and Prey",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              48688,
              40192
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                47232,
                38784
              ],
              [
                50560,
                41600
              ]
            ],
            "points_of_interest": {
              "1021": {
                "name": "Armada Harbor",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49843.7,
                  39841
                ],
                "id": 1021,
                "chat_link": "[&BP0DAAA=]"
              },
              "1022": {
                "name": "Alseta Generator",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50143,
                  39986.2
                ],
                "id": 1022,
                "chat_link": "[&BP4DAAA=]"
              },
              "1023": {
                "name": "Caer Aval",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49933.9,
                  40162.5
                ],
                "id": 1023,
                "chat_link": "[&BP8DAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "684": {
                "name": "Fort Trinity",
                "level": 71,
                "coord": [
                  50040.2,
                  39934
                ],
                "bounds": [
                  [
                    49835.6,
                    39572.2
                  ],
                  [
                    49992,
                    39616.4
                  ],
                  [
                    50251.7,
                    39775.9
                  ],
                  [
                    50244.2,
                    39912.7
                  ],
                  [
                    50296.7,
                    39959.1
                  ],
                  [
                    50291.5,
                    40014.9
                  ],
                  [
                    50254.4,
                    40055.6
                  ],
                  [
                    50205.3,
                    40064.9
                  ],
                  [
                    50007.9,
                    40260.7
                  ],
                  [
                    49911.3,
                    40265.5
                  ],
                  [
                    49799.9,
                    40158.6
                  ],
                  [
                    49695.4,
                    39860.6
                  ],
                  [
                    49736.9,
                    39624.7
                  ],
                  [
                    49835.6,
                    39572.2
                  ]
                ],
                "id": 684,
                "chat_link": "[&BKwCAAA=]"
              }
            },
            "adventures": [],
            "id": 793,
            "mastery_points": []
          },
          "796": {
            "name": "The Informant",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              44416,
              29248
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                30720
              ]
            ],
            "continent_rect": [
              [
                42624,
                28032
              ],
              [
                46208,
                30464
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "id": 796,
            "mastery_points": [],
            "adventures": []
          },
          "797": {
            "name": "A Traitor's Testimony",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "284": {
                "name": "The Toppled Wall",
                "level": 15,
                "coord": [
                  60142.8,
                  30218.1
                ],
                "bounds": [
                  [
                    60354.2,
                    30371.4
                  ],
                  [
                    60193.5,
                    30317.5
                  ],
                  [
                    60097.7,
                    30365.9
                  ],
                  [
                    60026.4,
                    30339.2
                  ],
                  [
                    59975.4,
                    30373.9
                  ],
                  [
                    59901.2,
                    30285.7
                  ],
                  [
                    59716.3,
                    30311.3
                  ],
                  [
                    59514.5,
                    30264.8
                  ],
                  [
                    59300.1,
                    29999.9
                  ],
                  [
                    60307.3,
                    29873.5
                  ],
                  [
                    60734.6,
                    29939
                  ],
                  [
                    60712.1,
                    30002.8
                  ],
                  [
                    60702.9,
                    30248.4
                  ],
                  [
                    60463.8,
                    30359.8
                  ],
                  [
                    60354.2,
                    30371.4
                  ]
                ],
                "id": 284,
                "chat_link": "[&BBwBAAA=]"
              },
              "289": {
                "name": "Ascalon City Ruins",
                "level": 14,
                "coord": [
                  61034.8,
                  30253.6
                ],
                "bounds": [
                  [
                    61011.7,
                    30731.4
                  ],
                  [
                    60697,
                    30393
                  ],
                  [
                    60723.5,
                    30048.4
                  ],
                  [
                    60727.4,
                    29978.6
                  ],
                  [
                    60743.3,
                    29921.7
                  ],
                  [
                    60963.8,
                    29895.4
                  ],
                  [
                    61426,
                    29892.3
                  ],
                  [
                    61466,
                    30421.3
                  ],
                  [
                    61289.4,
                    30588.3
                  ],
                  [
                    61300,
                    30665.6
                  ],
                  [
                    61011.7,
                    30731.4
                  ]
                ],
                "id": 289,
                "chat_link": "[&BCEBAAA=]"
              }
            },
            "adventures": [],
            "id": 797,
            "mastery_points": []
          },
          "799": {
            "name": "Follow the Trail",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {
              "344": {
                "name": "Stonecrag Kraal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61731,
                  30546.2
                ],
                "id": 344,
                "chat_link": "[&BFgBAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "287": {
                "name": "Cadem Forest",
                "level": 13,
                "coord": [
                  61649.7,
                  30878.2
                ],
                "bounds": [
                  [
                    61175.7,
                    31066.7
                  ],
                  [
                    61382.4,
                    30824.6
                  ],
                  [
                    61302.4,
                    30665.2
                  ],
                  [
                    61292.9,
                    30588.2
                  ],
                  [
                    61470,
                    30418.9
                  ],
                  [
                    61659,
                    30457.1
                  ],
                  [
                    61934.2,
                    30370.9
                  ],
                  [
                    61939.4,
                    30675.2
                  ],
                  [
                    62008.4,
                    30866.8
                  ],
                  [
                    61943.6,
                    31211.3
                  ],
                  [
                    61956.3,
                    31299.2
                  ],
                  [
                    61939.3,
                    31504.9
                  ],
                  [
                    61442.5,
                    31467.4
                  ],
                  [
                    61175.7,
                    31066.7
                  ]
                ],
                "id": 287,
                "chat_link": "[&BB8BAAA=]"
              },
              "293": {
                "name": "Human's Lament",
                "level": 14,
                "coord": [
                  61730.5,
                  30125.3
                ],
                "bounds": [
                  [
                    61438.6,
                    30135.4
                  ],
                  [
                    61423.9,
                    29896.1
                  ],
                  [
                    61598.6,
                    29922.2
                  ],
                  [
                    61700.4,
                    29837.9
                  ],
                  [
                    61921.9,
                    29893.1
                  ],
                  [
                    62009.2,
                    29994.1
                  ],
                  [
                    61936.7,
                    30165.6
                  ],
                  [
                    61949.6,
                    30275
                  ],
                  [
                    61935.4,
                    30378.1
                  ],
                  [
                    61656,
                    30460.7
                  ],
                  [
                    61465.6,
                    30420.5
                  ],
                  [
                    61438.6,
                    30135.4
                  ]
                ],
                "id": 293,
                "chat_link": "[&BCUBAAA=]"
              }
            },
            "adventures": [],
            "id": 799,
            "mastery_points": []
          },
          "806": {
            "name": "Awakening",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43072,
              34432
            ],
            "map_rect": [
              [
                -21504,
                -46080
              ],
              [
                24576,
                49152
              ]
            ],
            "continent_rect": [
              [
                42112,
                32512
              ],
              [
                44032,
                36480
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "101": {
                "name": "The Verdence",
                "level": 3,
                "coord": [
                  43034,
                  35956.7
                ],
                "bounds": [
                  [
                    42952.9,
                    36100.3
                  ],
                  [
                    43046.8,
                    36263.8
                  ],
                  [
                    43020.4,
                    36502.3
                  ],
                  [
                    43401.1,
                    36503.7
                  ],
                  [
                    43447.4,
                    36036.6
                  ],
                  [
                    43333.4,
                    36026.9
                  ],
                  [
                    43147.9,
                    35884.5
                  ],
                  [
                    43080.9,
                    35419.8
                  ],
                  [
                    42926.6,
                    35501.3
                  ],
                  [
                    42879,
                    35649.7
                  ],
                  [
                    42814.3,
                    35685.7
                  ],
                  [
                    42724.2,
                    35838.6
                  ],
                  [
                    42733.8,
                    35967.2
                  ],
                  [
                    42967.7,
                    36014
                  ],
                  [
                    42952.9,
                    36100.3
                  ]
                ],
                "id": 101,
                "chat_link": "[&BGUAAAA=]"
              }
            },
            "adventures": [],
            "id": 806,
            "mastery_points": []
          },
          "820": {
            "name": "The Omphalos Chamber",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 820,
            "mastery_points": []
          },
          "821": {
            "name": "The Omphalos Chamber",
            "min_level": 10,
            "max_level": 10,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 821,
            "mastery_points": []
          },
          "825": {
            "name": "Codebreaker",
            "min_level": 30,
            "max_level": 30,
            "default_floor": 1,
            "label_coord": [
              48320,
              29568
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                52224,
                24576
              ]
            ],
            "continent_rect": [
              [
                46208,
                28672
              ],
              [
                50432,
                30720
              ]
            ],
            "points_of_interest": {
              "125": {
                "name": "Molenheide",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50000.5,
                  29598.7
                ],
                "id": 125,
                "chat_link": "[&BH0AAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "265": {
                "name": "Shiverspur Front",
                "level": 27,
                "coord": [
                  50150.7,
                  29804.4
                ],
                "bounds": [
                  [
                    50043.8,
                    30156.7
                  ],
                  [
                    50208.1,
                    30137.2
                  ],
                  [
                    50441.3,
                    30091.2
                  ],
                  [
                    50518.5,
                    30000.5
                  ],
                  [
                    50464.7,
                    29904.1
                  ],
                  [
                    50507.2,
                    29756
                  ],
                  [
                    50470.9,
                    29456.9
                  ],
                  [
                    49976.7,
                    29475.9
                  ],
                  [
                    49875.2,
                    29381.1
                  ],
                  [
                    49703.6,
                    29568.2
                  ],
                  [
                    49723.8,
                    29688.3
                  ],
                  [
                    49874.3,
                    30037.3
                  ],
                  [
                    50043.8,
                    30156.7
                  ]
                ],
                "id": 265,
                "chat_link": "[&BAkBAAA=]"
              },
              "267": {
                "name": "Bitterfrost Peaks",
                "level": 26,
                "coord": [
                  50168.3,
                  29000.5
                ],
                "bounds": [
                  [
                    49979.2,
                    29472.1
                  ],
                  [
                    50474.1,
                    29458.4
                  ],
                  [
                    50428,
                    29215.2
                  ],
                  [
                    50473,
                    29078.8
                  ],
                  [
                    50545,
                    28626.9
                  ],
                  [
                    50324,
                    28424.5
                  ],
                  [
                    50126.5,
                    28509.5
                  ],
                  [
                    49884.4,
                    28527.8
                  ],
                  [
                    49921.7,
                    29083
                  ],
                  [
                    49817.5,
                    29226.8
                  ],
                  [
                    49877.8,
                    29382.6
                  ],
                  [
                    49979.2,
                    29472.1
                  ]
                ],
                "id": 267,
                "chat_link": "[&BAsBAAA=]"
              }
            },
            "adventures": [],
            "id": 825,
            "mastery_points": []
          },
          "845": {
            "name": "Shattered Light",
            "min_level": 20,
            "max_level": 20,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 845,
            "mastery_points": []
          },
          "896": {
            "name": "North Nolan Hatchery",
            "min_level": 0,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              58048,
              28760
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                27648
              ]
            ],
            "continent_rect": [
              [
                56320,
                27648
              ],
              [
                59904,
                29952
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 896,
            "mastery_points": []
          },
          "897": {
            "name": "Cragstead",
            "min_level": 0,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                55296,
                26368
              ],
              [
                57856,
                28928
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 897,
            "mastery_points": []
          },
          "922": {
            "name": "Labyrinthine Cliffs",
            "min_level": 1,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -18432,
                -18432
              ],
              [
                18432,
                18432
              ]
            ],
            "continent_rect": [
              [
                54958,
                38648
              ],
              [
                56494,
                40184
              ]
            ],
            "points_of_interest": {
              "1820": {
                "name": "Bazaar Docks Waypoint",
                "type": "waypoint",
                "floor": 900,
                "coord": [
                  55717.5,
                  39109.2
                ],
                "id": 1820,
                "chat_link": "[&BBwHAAA=]"
              },
              "1821": {
                "name": "Sky Docks Waypoint",
                "type": "waypoint",
                "floor": 900,
                "coord": [
                  55717.5,
                  39277.5
                ],
                "id": 1821,
                "chat_link": "[&BB0HAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1119": {
                "name": "Bazaar Docks",
                "level": 0,
                "coord": [
                  55726,
                  39416
                ],
                "bounds": [
                  [
                    56440.6,
                    40088.9
                  ],
                  [
                    56398.9,
                    40130.6
                  ],
                  [
                    55053.1,
                    40130.6
                  ],
                  [
                    55011.4,
                    40088.9
                  ],
                  [
                    55011.4,
                    38743.1
                  ],
                  [
                    55053.1,
                    38701.4
                  ],
                  [
                    56398.9,
                    38701.4
                  ],
                  [
                    56440.6,
                    38743.1
                  ],
                  [
                    56440.6,
                    40088.9
                  ]
                ],
                "id": 1119,
                "chat_link": "[&BF8EAAA=]"
              }
            },
            "adventures": [],
            "id": 922,
            "mastery_points": []
          },
          "989": {
            "name": "Prosperity's Mystery",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37840,
              32926
            ],
            "map_rect": [
              [
                -24576,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                36608,
                30976
              ],
              [
                38656,
                33536
              ]
            ],
            "points_of_interest": {
              "1918": {
                "name": "Town of Prosperity",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38123,
                  32609.8
                ],
                "id": 1918,
                "chat_link": "[&BH4HAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1186": {
                "name": "Prospect Valley",
                "level": 80,
                "coord": [
                  37927.6,
                  32843.3
                ],
                "bounds": [
                  [
                    38660.1,
                    32111.4
                  ],
                  [
                    37993.9,
                    32103.3
                  ],
                  [
                    37921.7,
                    32651.2
                  ],
                  [
                    37860.2,
                    32702.8
                  ],
                  [
                    37791.4,
                    32718.5
                  ],
                  [
                    37739.5,
                    32738.1
                  ],
                  [
                    37691.3,
                    32748.3
                  ],
                  [
                    37652.9,
                    32747.2
                  ],
                  [
                    37615.5,
                    32746.1
                  ],
                  [
                    37581.6,
                    32742.4
                  ],
                  [
                    37550.1,
                    32739.5
                  ],
                  [
                    37467.3,
                    32737.9
                  ],
                  [
                    37456.6,
                    32967.2
                  ],
                  [
                    37370.6,
                    33206.7
                  ],
                  [
                    38097,
                    33330.5
                  ],
                  [
                    38196.1,
                    33325.4
                  ],
                  [
                    38483.1,
                    33589.2
                  ],
                  [
                    38727,
                    33584.5
                  ],
                  [
                    38768.4,
                    32532.5
                  ],
                  [
                    38660.1,
                    32111.4
                  ]
                ],
                "id": 1186,
                "chat_link": "[&BKIEAAA=]"
              }
            },
            "id": 989,
            "mastery_points": [],
            "adventures": []
          },
          "990": {
            "name": "Cornered",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37840,
              32926
            ],
            "map_rect": [
              [
                -24576,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                36608,
                30976
              ],
              [
                38656,
                33536
              ]
            ],
            "points_of_interest": {
              "1905": {
                "name": "Spurbend Canyon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37692.6,
                  32864.1
                ],
                "id": 1905,
                "chat_link": "[&BHEHAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1186": {
                "name": "Prospect Valley",
                "level": 80,
                "coord": [
                  37927.6,
                  32843.3
                ],
                "bounds": [
                  [
                    38660.1,
                    32111.4
                  ],
                  [
                    37993.9,
                    32103.3
                  ],
                  [
                    37921.7,
                    32651.2
                  ],
                  [
                    37860.2,
                    32702.8
                  ],
                  [
                    37791.4,
                    32718.5
                  ],
                  [
                    37739.5,
                    32738.1
                  ],
                  [
                    37691.3,
                    32748.3
                  ],
                  [
                    37652.9,
                    32747.2
                  ],
                  [
                    37615.5,
                    32746.1
                  ],
                  [
                    37581.6,
                    32742.4
                  ],
                  [
                    37550.1,
                    32739.5
                  ],
                  [
                    37467.3,
                    32737.9
                  ],
                  [
                    37456.6,
                    32967.2
                  ],
                  [
                    37370.6,
                    33206.7
                  ],
                  [
                    38097,
                    33330.5
                  ],
                  [
                    38196.1,
                    33325.4
                  ],
                  [
                    38483.1,
                    33589.2
                  ],
                  [
                    38727,
                    33584.5
                  ],
                  [
                    38768.4,
                    32532.5
                  ],
                  [
                    38660.1,
                    32111.4
                  ]
                ],
                "id": 1186,
                "chat_link": "[&BKIEAAA=]"
              }
            },
            "adventures": [],
            "id": 990,
            "mastery_points": []
          },
          "991": {
            "name": "Disturbance in Brisban Wildlands",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              40384,
              32192
            ],
            "map_rect": [
              [
                -39936,
                -30720
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                38656,
                30848
              ],
              [
                42112,
                33536
              ]
            ],
            "points_of_interest": {
              "1904": {
                "name": "Tangle Root Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38744.1,
                  33385.4
                ],
                "id": 1904,
                "chat_link": "[&BHAHAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1185": {
                "name": "Tangle Root",
                "level": 26,
                "coord": [
                  38862.9,
                  33354.3
                ],
                "bounds": [
                  [
                    38660.3,
                    33478.7
                  ],
                  [
                    38664.6,
                    33073.2
                  ],
                  [
                    39018.8,
                    33259.8
                  ],
                  [
                    39007.2,
                    33340.2
                  ],
                  [
                    39041.8,
                    33439.8
                  ],
                  [
                    38784.8,
                    33534.3
                  ],
                  [
                    38660.3,
                    33478.7
                  ]
                ],
                "id": 1185,
                "chat_link": "[&BKEEAAA=]"
              }
            },
            "adventures": [],
            "id": 991,
            "mastery_points": []
          },
          "993": {
            "name": "Scarlet's Secret Room",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37840,
              32926
            ],
            "map_rect": [
              [
                -24576,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                36608,
                30976
              ],
              [
                38656,
                33536
              ]
            ],
            "points_of_interest": {
              "1918": {
                "name": "Town of Prosperity",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38123,
                  32609.8
                ],
                "id": 1918,
                "chat_link": "[&BH4HAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1186": {
                "name": "Prospect Valley",
                "level": 80,
                "coord": [
                  37927.6,
                  32843.3
                ],
                "bounds": [
                  [
                    38660.1,
                    32111.4
                  ],
                  [
                    37993.9,
                    32103.3
                  ],
                  [
                    37921.7,
                    32651.2
                  ],
                  [
                    37860.2,
                    32702.8
                  ],
                  [
                    37791.4,
                    32718.5
                  ],
                  [
                    37739.5,
                    32738.1
                  ],
                  [
                    37691.3,
                    32748.3
                  ],
                  [
                    37652.9,
                    32747.2
                  ],
                  [
                    37615.5,
                    32746.1
                  ],
                  [
                    37581.6,
                    32742.4
                  ],
                  [
                    37550.1,
                    32739.5
                  ],
                  [
                    37467.3,
                    32737.9
                  ],
                  [
                    37456.6,
                    32967.2
                  ],
                  [
                    37370.6,
                    33206.7
                  ],
                  [
                    38097,
                    33330.5
                  ],
                  [
                    38196.1,
                    33325.4
                  ],
                  [
                    38483.1,
                    33589.2
                  ],
                  [
                    38727,
                    33584.5
                  ],
                  [
                    38768.4,
                    32532.5
                  ],
                  [
                    38660.1,
                    32111.4
                  ]
                ],
                "id": 1186,
                "chat_link": "[&BKIEAAA=]"
              }
            },
            "id": 993,
            "mastery_points": [],
            "adventures": []
          },
          "994": {
            "name": "The Concordia Incident",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              52864,
              36160
            ],
            "map_rect": [
              [
                -27648,
                -36864
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                51712,
                34560
              ],
              [
                54016,
                37760
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "550": {
                "name": "Candle Chimney",
                "level": 57,
                "coord": [
                  51917.2,
                  36552.6
                ],
                "bounds": [
                  [
                    51817.1,
                    36790.4
                  ],
                  [
                    51789,
                    36708.1
                  ],
                  [
                    51725.9,
                    36457.8
                  ],
                  [
                    51758,
                    36197.3
                  ],
                  [
                    51897.1,
                    36209.8
                  ],
                  [
                    51927.8,
                    36376
                  ],
                  [
                    52187,
                    36625.7
                  ],
                  [
                    52136,
                    36770.3
                  ],
                  [
                    52016.8,
                    36837.9
                  ],
                  [
                    51817.1,
                    36790.4
                  ]
                ],
                "id": 550,
                "chat_link": "[&BCYCAAA=]"
              },
              "551": {
                "name": "Gyre Rapids",
                "level": 56,
                "coord": [
                  52298.8,
                  36493.3
                ],
                "bounds": [
                  [
                    52135.5,
                    36770.5
                  ],
                  [
                    52290.4,
                    36817.6
                  ],
                  [
                    52534.5,
                    36752.8
                  ],
                  [
                    52645.5,
                    36622.8
                  ],
                  [
                    52643.6,
                    36453.4
                  ],
                  [
                    52529.8,
                    36347.9
                  ],
                  [
                    52485.8,
                    36229
                  ],
                  [
                    52013.4,
                    36223.1
                  ],
                  [
                    51894.3,
                    36205.5
                  ],
                  [
                    51927.4,
                    36377.4
                  ],
                  [
                    52186.5,
                    36625.9
                  ],
                  [
                    52135.5,
                    36770.5
                  ]
                ],
                "id": 551,
                "chat_link": "[&BCcCAAA=]"
              },
              "558": {
                "name": "Fisher's Eye Bridges",
                "level": 55,
                "coord": [
                  52128.5,
                  35958.3
                ],
                "bounds": [
                  [
                    51759,
                    36201.6
                  ],
                  [
                    52013.3,
                    36223
                  ],
                  [
                    52485.8,
                    36228.8
                  ],
                  [
                    52544.9,
                    36081.1
                  ],
                  [
                    52556.9,
                    35845.5
                  ],
                  [
                    52428.2,
                    35639.3
                  ],
                  [
                    51887.8,
                    35707.4
                  ],
                  [
                    51730,
                    35712.8
                  ],
                  [
                    51750.5,
                    35984.7
                  ],
                  [
                    51759,
                    36201.6
                  ]
                ],
                "id": 558,
                "chat_link": "[&BC4CAAA=]"
              }
            },
            "adventures": [],
            "id": 994,
            "mastery_points": []
          },
          "1000": {
            "name": "The Waypoint Conundrum",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37840,
              32926
            ],
            "map_rect": [
              [
                -24576,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                36608,
                30976
              ],
              [
                38656,
                33536
              ]
            ],
            "points_of_interest": {
              "1922": {
                "name": "Omadd's Machine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36797.6,
                  33348.4
                ],
                "id": 1922,
                "chat_link": "[&BIIHAAA=]"
              },
              "1923": {
                "name": "Ley Line Hub",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37153.4,
                  33325.6
                ],
                "id": 1923,
                "chat_link": "[&BIMHAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1189": {
                "name": "Cavern of the Shining Lights",
                "level": 80,
                "coord": [
                  37218.3,
                  33352.8
                ],
                "bounds": [
                  [
                    36783.6,
                    33462.1
                  ],
                  [
                    36700.1,
                    33400.4
                  ],
                  [
                    36702.7,
                    33323.9
                  ],
                  [
                    36753.6,
                    33270.8
                  ],
                  [
                    36792.5,
                    33261.4
                  ],
                  [
                    36873.9,
                    33263.8
                  ],
                  [
                    37237.5,
                    33197.4
                  ],
                  [
                    37274.4,
                    33196.9
                  ],
                  [
                    37329.2,
                    33231.4
                  ],
                  [
                    37451.4,
                    33262.8
                  ],
                  [
                    37676.2,
                    33276.1
                  ],
                  [
                    37734.9,
                    33376.7
                  ],
                  [
                    37716.3,
                    33498.6
                  ],
                  [
                    37669.6,
                    33542.5
                  ],
                  [
                    37542.6,
                    33546.6
                  ],
                  [
                    37254.1,
                    33533.2
                  ],
                  [
                    36783.6,
                    33462.1
                  ]
                ],
                "id": 1189,
                "chat_link": "[&BKUEAAA=]"
              }
            },
            "adventures": [],
            "id": 1000,
            "mastery_points": []
          },
          "1001": {
            "name": "Summit Invitations",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              53664,
              30432
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                27648,
                21504
              ]
            ],
            "continent_rect": [
              [
                52224,
                29696
              ],
              [
                54528,
                31360
              ]
            ],
            "points_of_interest": {
              "886": {
                "name": "Stonewright's Steading",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54015.6,
                  31159.6
                ],
                "id": 886,
                "chat_link": "[&BHYDAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "805": {
                "name": "Frost Basin",
                "level": 0,
                "coord": [
                  54220.9,
                  31207.1
                ],
                "bounds": [
                  [
                    53878,
                    31116.3
                  ],
                  [
                    54211.6,
                    30928.4
                  ],
                  [
                    54549.9,
                    30961
                  ],
                  [
                    54551.5,
                    31357.6
                  ],
                  [
                    54329.2,
                    31369.1
                  ],
                  [
                    54144.6,
                    31355.4
                  ],
                  [
                    53881.3,
                    31362.3
                  ],
                  [
                    53878,
                    31116.3
                  ]
                ],
                "id": 805,
                "chat_link": "[&BCUDAAA=]"
              }
            },
            "adventures": [],
            "id": 1001,
            "mastery_points": []
          },
          "1002": {
            "name": "Mission Accomplished",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              55040,
              25984
            ],
            "map_rect": [
              [
                -36864,
                -36864
              ],
              [
                36864,
                36864
              ]
            ],
            "continent_rect": [
              [
                53504,
                24576
              ],
              [
                56576,
                27648
              ]
            ],
            "points_of_interest": {
              "629": {
                "name": "The Barrowstead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55104.5,
                  27407.7
                ],
                "id": 629,
                "chat_link": "[&BHUCAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "575": {
                "name": "Highpeaks",
                "level": 73,
                "coord": [
                  55238.8,
                  27250.6
                ],
                "bounds": [
                  [
                    54851.3,
                    27518.4
                  ],
                  [
                    54868.9,
                    27150.8
                  ],
                  [
                    54974.3,
                    27013.3
                  ],
                  [
                    55072.5,
                    26936.4
                  ],
                  [
                    55162.7,
                    27020.4
                  ],
                  [
                    55332.2,
                    27010.7
                  ],
                  [
                    55489,
                    26983.3
                  ],
                  [
                    55678.1,
                    27010.6
                  ],
                  [
                    55698.2,
                    27372.3
                  ],
                  [
                    55802.4,
                    27631
                  ],
                  [
                    55106.5,
                    27713.5
                  ],
                  [
                    54829.4,
                    27646.2
                  ],
                  [
                    54851.3,
                    27518.4
                  ]
                ],
                "id": 575,
                "chat_link": "[&BD8CAAA=]"
              }
            },
            "adventures": [],
            "id": 1002,
            "mastery_points": []
          },
          "1004": {
            "name": "Plan of Attack",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {
              "1458": {
                "name": "Barradin's Vaults",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58973.9,
                  30876.6
                ],
                "id": 1458,
                "chat_link": "[&BLIFAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "270": {
                "name": "Village of Smokestead",
                "level": 3,
                "coord": [
                  58156.3,
                  30833.9
                ],
                "bounds": [
                  [
                    57856,
                    30550.5
                  ],
                  [
                    57996.7,
                    30571
                  ],
                  [
                    58378.9,
                    30592.8
                  ],
                  [
                    58545.1,
                    30743.8
                  ],
                  [
                    58526.7,
                    30851.5
                  ],
                  [
                    58424.6,
                    31121.2
                  ],
                  [
                    58158.3,
                    31028.9
                  ],
                  [
                    58070.5,
                    31085.8
                  ],
                  [
                    57749.8,
                    31164.6
                  ],
                  [
                    57856,
                    30629.3
                  ],
                  [
                    57856,
                    30550.5
                  ]
                ],
                "id": 270,
                "chat_link": "[&BA4BAAA=]"
              },
              "272": {
                "name": "Victor's Presidium",
                "level": 6,
                "coord": [
                  58619.5,
                  31354.6
                ],
                "bounds": [
                  [
                    58377.7,
                    31462.3
                  ],
                  [
                    58107,
                    31444.8
                  ],
                  [
                    58067.5,
                    31084.7
                  ],
                  [
                    58154.6,
                    31026.6
                  ],
                  [
                    58424.9,
                    31119
                  ],
                  [
                    58528.8,
                    30853.1
                  ],
                  [
                    58778.9,
                    31012.2
                  ],
                  [
                    58956.4,
                    30865.6
                  ],
                  [
                    58960.7,
                    31165.8
                  ],
                  [
                    59145.5,
                    31508.3
                  ],
                  [
                    59152.1,
                    31641.5
                  ],
                  [
                    59030.3,
                    31713.5
                  ],
                  [
                    58675.4,
                    31650.2
                  ],
                  [
                    58573.1,
                    31815.7
                  ],
                  [
                    58477,
                    31779.6
                  ],
                  [
                    58501.8,
                    31530
                  ],
                  [
                    58377.7,
                    31462.3
                  ]
                ],
                "id": 272,
                "chat_link": "[&BBABAAA=]"
              },
              "274": {
                "name": "Old Duke's Estate",
                "level": 6,
                "coord": [
                  58786.2,
                  30721.7
                ],
                "bounds": [
                  [
                    58780.2,
                    31015.2
                  ],
                  [
                    58526.3,
                    30852.5
                  ],
                  [
                    58543.1,
                    30742.7
                  ],
                  [
                    58748,
                    30587
                  ],
                  [
                    58960.9,
                    30433.3
                  ],
                  [
                    59158.8,
                    30699.4
                  ],
                  [
                    58780.2,
                    31015.2
                  ]
                ],
                "id": 274,
                "chat_link": "[&BBIBAAA=]"
              },
              "276": {
                "name": "Charr's Triumph",
                "level": 8,
                "coord": [
                  59352.1,
                  31140.9
                ],
                "bounds": [
                  [
                    59776,
                    31147.4
                  ],
                  [
                    59708.5,
                    30981.9
                  ],
                  [
                    59186.8,
                    30702.1
                  ],
                  [
                    58984.7,
                    30868.8
                  ],
                  [
                    58987.7,
                    31167.6
                  ],
                  [
                    59173.9,
                    31511.9
                  ],
                  [
                    59488.5,
                    31461.5
                  ],
                  [
                    59510.7,
                    31286.2
                  ],
                  [
                    59776,
                    31147.4
                  ]
                ],
                "id": 276,
                "chat_link": "[&BBQBAAA=]"
              }
            },
            "adventures": [],
            "id": 1004,
            "mastery_points": []
          },
          "1005": {
            "name": "Party Politics",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "184": {
                "name": "The Crown Pavilion",
                "level": 0,
                "coord": [
                  43450.8,
                  27235.3
                ],
                "bounds": [
                  [
                    43646.2,
                    27062.6
                  ],
                  [
                    43623.8,
                    27143.8
                  ],
                  [
                    43607.5,
                    27224.1
                  ],
                  [
                    43628.6,
                    27305.3
                  ],
                  [
                    43652.2,
                    27387.6
                  ],
                  [
                    43559.7,
                    27438.7
                  ],
                  [
                    43493.8,
                    27363
                  ],
                  [
                    43170,
                    27454.9
                  ],
                  [
                    43141,
                    27333.3
                  ],
                  [
                    43129.6,
                    27196
                  ],
                  [
                    43156.5,
                    27047.1
                  ],
                  [
                    43497.2,
                    27089
                  ],
                  [
                    43554.6,
                    27014
                  ],
                  [
                    43646.2,
                    27062.6
                  ]
                ],
                "id": 184,
                "chat_link": "[&BLgAAAA=]"
              },
              "723": {
                "name": "Plaza of Balthazar",
                "level": 0,
                "coord": [
                  43429.8,
                  26898.5
                ],
                "bounds": [
                  [
                    43483.2,
                    26887.3
                  ],
                  [
                    43449.3,
                    26954.8
                  ],
                  [
                    43555.4,
                    27013.1
                  ],
                  [
                    43499.2,
                    27087.3
                  ],
                  [
                    43160,
                    27048.3
                  ],
                  [
                    43217.5,
                    26862.9
                  ],
                  [
                    43315.6,
                    26719.6
                  ],
                  [
                    43406.4,
                    26623.3
                  ],
                  [
                    43612.6,
                    26837.8
                  ],
                  [
                    43598.9,
                    26950.7
                  ],
                  [
                    43483.2,
                    26887.3
                  ]
                ],
                "id": 723,
                "chat_link": "[&BNMCAAA=]"
              },
              "730": {
                "name": "Balthazar Low Road",
                "level": 0,
                "coord": [
                  43598.7,
                  26995.9
                ],
                "bounds": [
                  [
                    43477.8,
                    26883.4
                  ],
                  [
                    43442.1,
                    26953.5
                  ],
                  [
                    43717.6,
                    27104.3
                  ],
                  [
                    43757.2,
                    27042.4
                  ],
                  [
                    43477.8,
                    26883.4
                  ]
                ],
                "id": 730,
                "chat_link": "[&BNoCAAA=]"
              }
            },
            "adventures": [],
            "id": 1005,
            "mastery_points": []
          },
          "1006": {
            "name": "Foefire Cleansing",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              59904,
              30976
            ],
            "map_rect": [
              [
                -49152,
                -24576
              ],
              [
                49152,
                24576
              ]
            ],
            "continent_rect": [
              [
                57856,
                29952
              ],
              [
                61952,
                32000
              ]
            ],
            "points_of_interest": {
              "1458": {
                "name": "Barradin's Vaults",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58973.9,
                  30876.6
                ],
                "id": 1458,
                "chat_link": "[&BLIFAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "270": {
                "name": "Village of Smokestead",
                "level": 3,
                "coord": [
                  58156.3,
                  30833.9
                ],
                "bounds": [
                  [
                    57856,
                    30550.5
                  ],
                  [
                    57996.7,
                    30571
                  ],
                  [
                    58378.9,
                    30592.8
                  ],
                  [
                    58545.1,
                    30743.8
                  ],
                  [
                    58526.7,
                    30851.5
                  ],
                  [
                    58424.6,
                    31121.2
                  ],
                  [
                    58158.3,
                    31028.9
                  ],
                  [
                    58070.5,
                    31085.8
                  ],
                  [
                    57749.8,
                    31164.6
                  ],
                  [
                    57856,
                    30629.3
                  ],
                  [
                    57856,
                    30550.5
                  ]
                ],
                "id": 270,
                "chat_link": "[&BA4BAAA=]"
              },
              "272": {
                "name": "Victor's Presidium",
                "level": 6,
                "coord": [
                  58619.5,
                  31354.6
                ],
                "bounds": [
                  [
                    58377.7,
                    31462.3
                  ],
                  [
                    58107,
                    31444.8
                  ],
                  [
                    58067.5,
                    31084.7
                  ],
                  [
                    58154.6,
                    31026.6
                  ],
                  [
                    58424.9,
                    31119
                  ],
                  [
                    58528.8,
                    30853.1
                  ],
                  [
                    58778.9,
                    31012.2
                  ],
                  [
                    58956.4,
                    30865.6
                  ],
                  [
                    58960.7,
                    31165.8
                  ],
                  [
                    59145.5,
                    31508.3
                  ],
                  [
                    59152.1,
                    31641.5
                  ],
                  [
                    59030.3,
                    31713.5
                  ],
                  [
                    58675.4,
                    31650.2
                  ],
                  [
                    58573.1,
                    31815.7
                  ],
                  [
                    58477,
                    31779.6
                  ],
                  [
                    58501.8,
                    31530
                  ],
                  [
                    58377.7,
                    31462.3
                  ]
                ],
                "id": 272,
                "chat_link": "[&BBABAAA=]"
              },
              "274": {
                "name": "Old Duke's Estate",
                "level": 6,
                "coord": [
                  58786.2,
                  30721.7
                ],
                "bounds": [
                  [
                    58780.2,
                    31015.2
                  ],
                  [
                    58526.3,
                    30852.5
                  ],
                  [
                    58543.1,
                    30742.7
                  ],
                  [
                    58748,
                    30587
                  ],
                  [
                    58960.9,
                    30433.3
                  ],
                  [
                    59158.8,
                    30699.4
                  ],
                  [
                    58780.2,
                    31015.2
                  ]
                ],
                "id": 274,
                "chat_link": "[&BBIBAAA=]"
              },
              "276": {
                "name": "Charr's Triumph",
                "level": 8,
                "coord": [
                  59352.1,
                  31140.9
                ],
                "bounds": [
                  [
                    59776,
                    31147.4
                  ],
                  [
                    59708.5,
                    30981.9
                  ],
                  [
                    59186.8,
                    30702.1
                  ],
                  [
                    58984.7,
                    30868.8
                  ],
                  [
                    58987.7,
                    31167.6
                  ],
                  [
                    59173.9,
                    31511.9
                  ],
                  [
                    59488.5,
                    31461.5
                  ],
                  [
                    59510.7,
                    31286.2
                  ],
                  [
                    59776,
                    31147.4
                  ]
                ],
                "id": 276,
                "chat_link": "[&BBQBAAA=]"
              }
            },
            "adventures": [],
            "id": 1006,
            "mastery_points": []
          },
          "1007": {
            "name": "Recalibrating the Waypoints",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37840,
              32926
            ],
            "map_rect": [
              [
                -24576,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                36608,
                30976
              ],
              [
                38656,
                33536
              ]
            ],
            "points_of_interest": {
              "1922": {
                "name": "Omadd's Machine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36797.6,
                  33348.4
                ],
                "id": 1922,
                "chat_link": "[&BIIHAAA=]"
              },
              "1923": {
                "name": "Ley Line Hub",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37153.4,
                  33325.6
                ],
                "id": 1923,
                "chat_link": "[&BIMHAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1189": {
                "name": "Cavern of the Shining Lights",
                "level": 80,
                "coord": [
                  37218.3,
                  33352.8
                ],
                "bounds": [
                  [
                    36783.6,
                    33462.1
                  ],
                  [
                    36700.1,
                    33400.4
                  ],
                  [
                    36702.7,
                    33323.9
                  ],
                  [
                    36753.6,
                    33270.8
                  ],
                  [
                    36792.5,
                    33261.4
                  ],
                  [
                    36873.9,
                    33263.8
                  ],
                  [
                    37237.5,
                    33197.4
                  ],
                  [
                    37274.4,
                    33196.9
                  ],
                  [
                    37329.2,
                    33231.4
                  ],
                  [
                    37451.4,
                    33262.8
                  ],
                  [
                    37676.2,
                    33276.1
                  ],
                  [
                    37734.9,
                    33376.7
                  ],
                  [
                    37716.3,
                    33498.6
                  ],
                  [
                    37669.6,
                    33542.5
                  ],
                  [
                    37542.6,
                    33546.6
                  ],
                  [
                    37254.1,
                    33533.2
                  ],
                  [
                    36783.6,
                    33462.1
                  ]
                ],
                "id": 1189,
                "chat_link": "[&BKUEAAA=]"
              }
            },
            "adventures": [],
            "id": 1007,
            "mastery_points": []
          },
          "1009": {
            "name": "Taimi's Device",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37840,
              32926
            ],
            "map_rect": [
              [
                -24576,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                36608,
                30976
              ],
              [
                38656,
                33536
              ]
            ],
            "points_of_interest": {
              "1942": {
                "name": "Crash Site 3",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37085.4,
                  32988.2
                ],
                "id": 1942,
                "chat_link": "[&BJYHAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1188": {
                "name": "Challenger Cliffs",
                "level": 80,
                "coord": [
                  36919.8,
                  33047.8
                ],
                "bounds": [
                  [
                    36504,
                    32671.2
                  ],
                  [
                    36598.3,
                    33183.1
                  ],
                  [
                    36631.1,
                    33294.2
                  ],
                  [
                    36671.3,
                    33302.5
                  ],
                  [
                    36749.1,
                    33269.5
                  ],
                  [
                    36792.2,
                    33259.3
                  ],
                  [
                    36875.6,
                    33263
                  ],
                  [
                    37156.4,
                    33212.3
                  ],
                  [
                    37225.2,
                    33196.3
                  ],
                  [
                    37201.9,
                    33157.2
                  ],
                  [
                    37203.9,
                    33108.7
                  ],
                  [
                    37132.5,
                    33075.9
                  ],
                  [
                    37136.4,
                    32988.4
                  ],
                  [
                    37136.7,
                    32918.4
                  ],
                  [
                    37081.7,
                    32826.4
                  ],
                  [
                    37018.2,
                    32748.8
                  ],
                  [
                    36768.7,
                    32731.2
                  ],
                  [
                    36674.2,
                    32654.7
                  ],
                  [
                    36504,
                    32671.2
                  ]
                ],
                "id": 1188,
                "chat_link": "[&BKQEAAA=]"
              }
            },
            "adventures": [],
            "id": 1009,
            "mastery_points": []
          },
          "1010": {
            "name": "The World Summit",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {
              "1155": {
                "name": "Pale Tree's Circle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43194.5,
                  37452.6
                ],
                "id": 1155,
                "chat_link": "[&BIMEAAA=]"
              },
              "1156": {
                "name": "Warden's Watchgate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43076.6,
                  37253.1
                ],
                "id": 1156,
                "chat_link": "[&BIQEAAA=]"
              },
              "1157": {
                "name": "The Envoy's Shelter",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43329,
                  37472.5
                ],
                "id": 1157,
                "chat_link": "[&BIUEAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "913": {
                "name": "Upper Commons",
                "level": 0,
                "coord": [
                  43165.2,
                  37441.5
                ],
                "bounds": [
                  [
                    43132.1,
                    37516.9
                  ],
                  [
                    43078.5,
                    37470.4
                  ],
                  [
                    43130.1,
                    37446
                  ],
                  [
                    43134.4,
                    37410
                  ],
                  [
                    43125.5,
                    37388.9
                  ],
                  [
                    43161,
                    37369.3
                  ],
                  [
                    43210.1,
                    37372.2
                  ],
                  [
                    43266,
                    37423.9
                  ],
                  [
                    43244.3,
                    37500.7
                  ],
                  [
                    43170.4,
                    37517
                  ],
                  [
                    43132.1,
                    37516.9
                  ]
                ],
                "id": 913,
                "chat_link": "[&BJEDAAA=]"
              },
              "914": {
                "name": "The Quester's Terrace",
                "level": 0,
                "coord": [
                  43375,
                  37621.7
                ],
                "bounds": [
                  [
                    43244.4,
                    37501.4
                  ],
                  [
                    43264.9,
                    37422.1
                  ],
                  [
                    43415.2,
                    37397.2
                  ],
                  [
                    43428,
                    37461.8
                  ],
                  [
                    43413.2,
                    37547.4
                  ],
                  [
                    43427.7,
                    37560.3
                  ],
                  [
                    43459.5,
                    37625.8
                  ],
                  [
                    43397.9,
                    37666.2
                  ],
                  [
                    43484.9,
                    37713.8
                  ],
                  [
                    43488.3,
                    37784.2
                  ],
                  [
                    43437.2,
                    37821.1
                  ],
                  [
                    43356.9,
                    37788.9
                  ],
                  [
                    43291,
                    37727.3
                  ],
                  [
                    43274,
                    37665.9
                  ],
                  [
                    43313.1,
                    37668.2
                  ],
                  [
                    43303.8,
                    37595.6
                  ],
                  [
                    43244.4,
                    37501.4
                  ]
                ],
                "id": 914,
                "chat_link": "[&BJIDAAA=]"
              },
              "915": {
                "name": "Marshaling Field",
                "level": 0,
                "coord": [
                  43144.3,
                  37294.5
                ],
                "bounds": [
                  [
                    42841.8,
                    37316.8
                  ],
                  [
                    42875.6,
                    37389
                  ],
                  [
                    43017.3,
                    37389.9
                  ],
                  [
                    43022.8,
                    37352.8
                  ],
                  [
                    43098.5,
                    37364.8
                  ],
                  [
                    43121,
                    37373.3
                  ],
                  [
                    43127.1,
                    37390.8
                  ],
                  [
                    43161.3,
                    37371.8
                  ],
                  [
                    43209.5,
                    37372.5
                  ],
                  [
                    43264.8,
                    37424.5
                  ],
                  [
                    43405,
                    37396
                  ],
                  [
                    43388.5,
                    37314.7
                  ],
                  [
                    43352.5,
                    37249.7
                  ],
                  [
                    43282.4,
                    37185.4
                  ],
                  [
                    43220.4,
                    37199.3
                  ],
                  [
                    43178,
                    37183
                  ],
                  [
                    43181.2,
                    37133.8
                  ],
                  [
                    43135.9,
                    37104.9
                  ],
                  [
                    43076.2,
                    37180.6
                  ],
                  [
                    42927.2,
                    37196.4
                  ],
                  [
                    42841.8,
                    37316.8
                  ]
                ],
                "id": 915,
                "chat_link": "[&BJMDAAA=]"
              },
              "916": {
                "name": "The Song Bower",
                "level": 0,
                "coord": [
                  43201.7,
                  37611.6
                ],
                "bounds": [
                  [
                    43050.7,
                    37656.9
                  ],
                  [
                    43132.2,
                    37517.3
                  ],
                  [
                    43170.1,
                    37516.8
                  ],
                  [
                    43246.6,
                    37498.3
                  ],
                  [
                    43303.3,
                    37595.7
                  ],
                  [
                    43311.4,
                    37671.5
                  ],
                  [
                    43273.2,
                    37669.5
                  ],
                  [
                    43252.9,
                    37614
                  ],
                  [
                    43220.8,
                    37597.3
                  ],
                  [
                    43180.9,
                    37614
                  ],
                  [
                    43169,
                    37694.4
                  ],
                  [
                    43109.8,
                    37693.2
                  ],
                  [
                    43050.7,
                    37656.9
                  ]
                ],
                "id": 916,
                "chat_link": "[&BJQDAAA=]"
              },
              "917": {
                "name": "Envoy's Terrace",
                "level": 0,
                "coord": [
                  43025.3,
                  37490.4
                ],
                "bounds": [
                  [
                    43014,
                    37424.1
                  ],
                  [
                    43046.5,
                    37450.3
                  ],
                  [
                    43079.1,
                    37470
                  ],
                  [
                    43131.4,
                    37517.1
                  ],
                  [
                    43056.7,
                    37658.9
                  ],
                  [
                    42983,
                    37623.6
                  ],
                  [
                    42874.8,
                    37389.1
                  ],
                  [
                    43017.1,
                    37390.4
                  ],
                  [
                    43014,
                    37424.1
                  ]
                ],
                "id": 917,
                "chat_link": "[&BJUDAAA=]"
              }
            },
            "adventures": [],
            "id": 1010,
            "mastery_points": []
          },
          "1016": {
            "name": "Hidden Arcana",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                30720,
                18432
              ]
            ],
            "continent_rect": [
              [
                49666,
                30720
              ],
              [
                52098,
                32256
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "947": {
                "name": "Durmand Priory",
                "level": 31,
                "coord": [
                  50090.6,
                  30363.3
                ],
                "bounds": [
                  [
                    49858,
                    30897.9
                  ],
                  [
                    50271.9,
                    30748
                  ],
                  [
                    50366.9,
                    30347
                  ],
                  [
                    50314.2,
                    30153.6
                  ],
                  [
                    50221,
                    30157.9
                  ],
                  [
                    50149.6,
                    30081.1
                  ],
                  [
                    49828.2,
                    30101.7
                  ],
                  [
                    49714.6,
                    30419.4
                  ],
                  [
                    49858,
                    30897.9
                  ]
                ],
                "id": 947,
                "chat_link": "[&BLMDAAA=]"
              }
            },
            "adventures": [],
            "id": 1016,
            "mastery_points": []
          },
          "1017": {
            "name": "Reunion with the Pact",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37840,
              31926
            ],
            "map_rect": [
              [
                -24576,
                -18432
              ],
              [
                24576,
                18432
              ]
            ],
            "continent_rect": [
              [
                36608,
                30592
              ],
              [
                38656,
                32128
              ]
            ],
            "points_of_interest": {
              "1959": {
                "name": "Camp Resolve",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38487.8,
                  31706.5
                ],
                "id": 1959,
                "chat_link": "[&BKcHAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1201": {
                "name": "Camp Resolve",
                "level": 80,
                "coord": [
                  38397.8,
                  31772.9
                ],
                "bounds": [
                  [
                    38264.8,
                    31545.7
                  ],
                  [
                    38336.5,
                    31481.1
                  ],
                  [
                    38683.6,
                    31527.5
                  ],
                  [
                    38678.2,
                    31573.9
                  ],
                  [
                    38666.7,
                    31706.6
                  ],
                  [
                    38627.3,
                    32139.2
                  ],
                  [
                    38237.7,
                    32113.6
                  ],
                  [
                    38269.8,
                    32003.9
                  ],
                  [
                    38245.9,
                    31951.8
                  ],
                  [
                    38214.1,
                    31899.1
                  ],
                  [
                    38296.2,
                    31742.9
                  ],
                  [
                    38253.3,
                    31589.1
                  ],
                  [
                    38264.8,
                    31545.7
                  ]
                ],
                "id": 1201,
                "chat_link": "[&BLEEAAA=]"
              }
            },
            "adventures": [],
            "id": 1017,
            "mastery_points": []
          },
          "1018": {
            "name": "Caithe's Reconnaissance Squad",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37840,
              31926
            ],
            "map_rect": [
              [
                -24576,
                -18432
              ],
              [
                24576,
                18432
              ]
            ],
            "continent_rect": [
              [
                36608,
                30592
              ],
              [
                38656,
                32128
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1197": {
                "name": "Northwestern Silverwastes",
                "level": 80,
                "coord": [
                  37266.7,
                  31197.3
                ],
                "bounds": [
                  [
                    37223.1,
                    31021.3
                  ],
                  [
                    37557.8,
                    31044.4
                  ],
                  [
                    37593.8,
                    31200.7
                  ],
                  [
                    37595.9,
                    31320.5
                  ],
                  [
                    37346.6,
                    31504.3
                  ],
                  [
                    36997.3,
                    31320
                  ],
                  [
                    36985.1,
                    31228.3
                  ],
                  [
                    37127.5,
                    31199.7
                  ],
                  [
                    37106.6,
                    31138.7
                  ],
                  [
                    37201.5,
                    31123.8
                  ],
                  [
                    37198.9,
                    31068.3
                  ],
                  [
                    37223.1,
                    31021.3
                  ]
                ],
                "id": 1197,
                "chat_link": "[&BK0EAAA=]"
              },
              "1199": {
                "name": "Northern Silverwastes",
                "level": 80,
                "coord": [
                  37776.7,
                  31156
                ],
                "bounds": [
                  [
                    37851.9,
                    31401.4
                  ],
                  [
                    37650.2,
                    31319.8
                  ],
                  [
                    37596.3,
                    31320.8
                  ],
                  [
                    37594,
                    31200.7
                  ],
                  [
                    37557.5,
                    31044.5
                  ],
                  [
                    37565.3,
                    30935
                  ],
                  [
                    37698.7,
                    30976.2
                  ],
                  [
                    37713.6,
                    31056.2
                  ],
                  [
                    37799,
                    31080.5
                  ],
                  [
                    37920.2,
                    31078.4
                  ],
                  [
                    37983,
                    31020.9
                  ],
                  [
                    38037,
                    31153.9
                  ],
                  [
                    37991.6,
                    31278.3
                  ],
                  [
                    37916.1,
                    31317
                  ],
                  [
                    37851.9,
                    31401.4
                  ]
                ],
                "id": 1199,
                "chat_link": "[&BK8EAAA=]"
              },
              "1202": {
                "name": "Desperate Passage",
                "level": 80,
                "coord": [
                  37181.4,
                  31003.9
                ],
                "bounds": [
                  [
                    37557.1,
                    31044.4
                  ],
                  [
                    37565.7,
                    30934
                  ],
                  [
                    37484,
                    30902
                  ],
                  [
                    37424.9,
                    30909
                  ],
                  [
                    37361.6,
                    30868.2
                  ],
                  [
                    37289.5,
                    30877
                  ],
                  [
                    37205.5,
                    30825.7
                  ],
                  [
                    37113.5,
                    30844.4
                  ],
                  [
                    37152.2,
                    30902.1
                  ],
                  [
                    37059.7,
                    30955.6
                  ],
                  [
                    36965,
                    30950.3
                  ],
                  [
                    36876.5,
                    30972
                  ],
                  [
                    36870,
                    31085.7
                  ],
                  [
                    36862.6,
                    31228.2
                  ],
                  [
                    36984.7,
                    31229.6
                  ],
                  [
                    37127.4,
                    31200
                  ],
                  [
                    37107.1,
                    31139
                  ],
                  [
                    37202.1,
                    31124.2
                  ],
                  [
                    37200.5,
                    31068.9
                  ],
                  [
                    37217.6,
                    31018.4
                  ],
                  [
                    37557.1,
                    31044.4
                  ]
                ],
                "id": 1202,
                "chat_link": "[&BLIEAAA=]"
              }
            },
            "adventures": [],
            "id": 1018,
            "mastery_points": []
          },
          "1019": {
            "name": "Fort Trinity",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              48688,
              40192
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                39936,
                33792
              ]
            ],
            "continent_rect": [
              [
                47232,
                38784
              ],
              [
                50560,
                41600
              ]
            ],
            "points_of_interest": {
              "1022": {
                "name": "Alseta Generator",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  50143,
                  39986.2
                ],
                "id": 1022,
                "chat_link": "[&BP4DAAA=]"
              },
              "1023": {
                "name": "Caer Aval",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  49933.9,
                  40162.5
                ],
                "id": 1023,
                "chat_link": "[&BP8DAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "684": {
                "name": "Fort Trinity",
                "level": 71,
                "coord": [
                  50040.2,
                  39934
                ],
                "bounds": [
                  [
                    49835.6,
                    39572.2
                  ],
                  [
                    49992,
                    39616.4
                  ],
                  [
                    50251.7,
                    39775.9
                  ],
                  [
                    50244.2,
                    39912.7
                  ],
                  [
                    50296.7,
                    39959.1
                  ],
                  [
                    50291.5,
                    40014.9
                  ],
                  [
                    50254.4,
                    40055.6
                  ],
                  [
                    50205.3,
                    40064.9
                  ],
                  [
                    50007.9,
                    40260.7
                  ],
                  [
                    49911.3,
                    40265.5
                  ],
                  [
                    49799.9,
                    40158.6
                  ],
                  [
                    49695.4,
                    39860.6
                  ],
                  [
                    49736.9,
                    39624.7
                  ],
                  [
                    49835.6,
                    39572.2
                  ]
                ],
                "id": 684,
                "chat_link": "[&BKwCAAA=]"
              },
              "694": {
                "name": "Squall Cusps",
                "level": 71,
                "coord": [
                  50083.2,
                  40420.1
                ],
                "bounds": [
                  [
                    50177.9,
                    40097
                  ],
                  [
                    50348.3,
                    40267.7
                  ],
                  [
                    50191.4,
                    40413.9
                  ],
                  [
                    50095.7,
                    40473
                  ],
                  [
                    50158.9,
                    40778.8
                  ],
                  [
                    49989.2,
                    40745.8
                  ],
                  [
                    49868.8,
                    40478.3
                  ],
                  [
                    49911.7,
                    40266.4
                  ],
                  [
                    50006.7,
                    40260.5
                  ],
                  [
                    50177.9,
                    40097
                  ]
                ],
                "id": 694,
                "chat_link": "[&BLYCAAA=]"
              },
              "700": {
                "name": "Thorn Pass",
                "level": 71,
                "coord": [
                  50336.3,
                  39930
                ],
                "bounds": [
                  [
                    50521.6,
                    40019.4
                  ],
                  [
                    50522.8,
                    40433.9
                  ],
                  [
                    50174.7,
                    40097
                  ],
                  [
                    50206.4,
                    40064.8
                  ],
                  [
                    50254.2,
                    40055.9
                  ],
                  [
                    50290.9,
                    40016.4
                  ],
                  [
                    50297,
                    39958.8
                  ],
                  [
                    50244.1,
                    39912.3
                  ],
                  [
                    50251.1,
                    39775
                  ],
                  [
                    50183.8,
                    39736
                  ],
                  [
                    50212.2,
                    39598.1
                  ],
                  [
                    50594.1,
                    39482.9
                  ],
                  [
                    50619.3,
                    39938.8
                  ],
                  [
                    50521.6,
                    40019.4
                  ]
                ],
                "id": 700,
                "chat_link": "[&BLwCAAA=]"
              }
            },
            "adventures": [],
            "id": 1019,
            "mastery_points": []
          },
          "1022": {
            "name": "Return to Camp Resolve",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37840,
              31926
            ],
            "map_rect": [
              [
                -24576,
                -18432
              ],
              [
                24576,
                18432
              ]
            ],
            "continent_rect": [
              [
                36608,
                30592
              ],
              [
                38656,
                32128
              ]
            ],
            "points_of_interest": {
              "1959": {
                "name": "Camp Resolve",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38487.8,
                  31706.5
                ],
                "id": 1959,
                "chat_link": "[&BKcHAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1201": {
                "name": "Camp Resolve",
                "level": 80,
                "coord": [
                  38397.8,
                  31772.9
                ],
                "bounds": [
                  [
                    38264.8,
                    31545.7
                  ],
                  [
                    38336.5,
                    31481.1
                  ],
                  [
                    38683.6,
                    31527.5
                  ],
                  [
                    38678.2,
                    31573.9
                  ],
                  [
                    38666.7,
                    31706.6
                  ],
                  [
                    38627.3,
                    32139.2
                  ],
                  [
                    38237.7,
                    32113.6
                  ],
                  [
                    38269.8,
                    32003.9
                  ],
                  [
                    38245.9,
                    31951.8
                  ],
                  [
                    38214.1,
                    31899.1
                  ],
                  [
                    38296.2,
                    31742.9
                  ],
                  [
                    38253.3,
                    31589.1
                  ],
                  [
                    38264.8,
                    31545.7
                  ]
                ],
                "id": 1201,
                "chat_link": "[&BLEEAAA=]"
              }
            },
            "adventures": [],
            "id": 1022,
            "mastery_points": []
          },
          "1024": {
            "name": "No Refuge",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37840,
              31926
            ],
            "map_rect": [
              [
                -24576,
                -18432
              ],
              [
                24576,
                18432
              ]
            ],
            "continent_rect": [
              [
                36608,
                30592
              ],
              [
                38656,
                32128
              ]
            ],
            "points_of_interest": {
              "1971": {
                "name": "Charnel Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38088.7,
                  30910.3
                ],
                "id": 1971,
                "chat_link": "[&BLMHAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1214": {
                "name": "Far Silverwastes",
                "level": 80,
                "coord": [
                  37860.7,
                  30864
                ],
                "bounds": [
                  [
                    38142.9,
                    30952.4
                  ],
                  [
                    38195,
                    30969.3
                  ],
                  [
                    38211.6,
                    30927
                  ],
                  [
                    38153.2,
                    30873.1
                  ],
                  [
                    38126.8,
                    30777.3
                  ],
                  [
                    38134.9,
                    30737.4
                  ],
                  [
                    38045.5,
                    30656.7
                  ],
                  [
                    37988.6,
                    30608.8
                  ],
                  [
                    37561.3,
                    30621.4
                  ],
                  [
                    37534.1,
                    30647.3
                  ],
                  [
                    37545.9,
                    30735.6
                  ],
                  [
                    37520.4,
                    30853.1
                  ],
                  [
                    37510.9,
                    30912.3
                  ],
                  [
                    37566.1,
                    30934.4
                  ],
                  [
                    37698.6,
                    30975.1
                  ],
                  [
                    37713.6,
                    31056
                  ],
                  [
                    37799.2,
                    31080.8
                  ],
                  [
                    37920.4,
                    31078.5
                  ],
                  [
                    37983.4,
                    31019.7
                  ],
                  [
                    38142.9,
                    30952.4
                  ]
                ],
                "id": 1214,
                "chat_link": "[&BL4EAAA=]"
              }
            },
            "adventures": [],
            "id": 1024,
            "mastery_points": []
          },
          "1025": {
            "name": "The Newly Awakened",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              43200,
              37384
            ],
            "map_rect": [
              [
                -15360,
                -24576
              ],
              [
                18432,
                24576
              ]
            ],
            "continent_rect": [
              [
                42496,
                36480
              ],
              [
                43904,
                38528
              ]
            ],
            "points_of_interest": {
              "1155": {
                "name": "Pale Tree's Circle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43194.5,
                  37452.6
                ],
                "id": 1155,
                "chat_link": "[&BIMEAAA=]"
              },
              "1156": {
                "name": "Warden's Watchgate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43076.6,
                  37253.1
                ],
                "id": 1156,
                "chat_link": "[&BIQEAAA=]"
              },
              "1157": {
                "name": "The Envoy's Shelter",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  43329,
                  37472.5
                ],
                "id": 1157,
                "chat_link": "[&BIUEAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "913": {
                "name": "Upper Commons",
                "level": 0,
                "coord": [
                  43165.2,
                  37441.5
                ],
                "bounds": [
                  [
                    43132.1,
                    37516.9
                  ],
                  [
                    43078.5,
                    37470.4
                  ],
                  [
                    43130.1,
                    37446
                  ],
                  [
                    43134.4,
                    37410
                  ],
                  [
                    43125.5,
                    37388.9
                  ],
                  [
                    43161,
                    37369.3
                  ],
                  [
                    43210.1,
                    37372.2
                  ],
                  [
                    43266,
                    37423.9
                  ],
                  [
                    43244.3,
                    37500.7
                  ],
                  [
                    43170.4,
                    37517
                  ],
                  [
                    43132.1,
                    37516.9
                  ]
                ],
                "id": 913,
                "chat_link": "[&BJEDAAA=]"
              },
              "914": {
                "name": "The Quester's Terrace",
                "level": 0,
                "coord": [
                  43375,
                  37621.7
                ],
                "bounds": [
                  [
                    43244.4,
                    37501.4
                  ],
                  [
                    43264.9,
                    37422.1
                  ],
                  [
                    43415.2,
                    37397.2
                  ],
                  [
                    43428,
                    37461.8
                  ],
                  [
                    43413.2,
                    37547.4
                  ],
                  [
                    43427.7,
                    37560.3
                  ],
                  [
                    43459.5,
                    37625.8
                  ],
                  [
                    43397.9,
                    37666.2
                  ],
                  [
                    43484.9,
                    37713.8
                  ],
                  [
                    43488.3,
                    37784.2
                  ],
                  [
                    43437.2,
                    37821.1
                  ],
                  [
                    43356.9,
                    37788.9
                  ],
                  [
                    43291,
                    37727.3
                  ],
                  [
                    43274,
                    37665.9
                  ],
                  [
                    43313.1,
                    37668.2
                  ],
                  [
                    43303.8,
                    37595.6
                  ],
                  [
                    43244.4,
                    37501.4
                  ]
                ],
                "id": 914,
                "chat_link": "[&BJIDAAA=]"
              },
              "915": {
                "name": "Marshaling Field",
                "level": 0,
                "coord": [
                  43144.3,
                  37294.5
                ],
                "bounds": [
                  [
                    42841.8,
                    37316.8
                  ],
                  [
                    42875.6,
                    37389
                  ],
                  [
                    43017.3,
                    37389.9
                  ],
                  [
                    43022.8,
                    37352.8
                  ],
                  [
                    43098.5,
                    37364.8
                  ],
                  [
                    43121,
                    37373.3
                  ],
                  [
                    43127.1,
                    37390.8
                  ],
                  [
                    43161.3,
                    37371.8
                  ],
                  [
                    43209.5,
                    37372.5
                  ],
                  [
                    43264.8,
                    37424.5
                  ],
                  [
                    43405,
                    37396
                  ],
                  [
                    43388.5,
                    37314.7
                  ],
                  [
                    43352.5,
                    37249.7
                  ],
                  [
                    43282.4,
                    37185.4
                  ],
                  [
                    43220.4,
                    37199.3
                  ],
                  [
                    43178,
                    37183
                  ],
                  [
                    43181.2,
                    37133.8
                  ],
                  [
                    43135.9,
                    37104.9
                  ],
                  [
                    43076.2,
                    37180.6
                  ],
                  [
                    42927.2,
                    37196.4
                  ],
                  [
                    42841.8,
                    37316.8
                  ]
                ],
                "id": 915,
                "chat_link": "[&BJMDAAA=]"
              },
              "916": {
                "name": "The Song Bower",
                "level": 0,
                "coord": [
                  43201.7,
                  37611.6
                ],
                "bounds": [
                  [
                    43050.7,
                    37656.9
                  ],
                  [
                    43132.2,
                    37517.3
                  ],
                  [
                    43170.1,
                    37516.8
                  ],
                  [
                    43246.6,
                    37498.3
                  ],
                  [
                    43303.3,
                    37595.7
                  ],
                  [
                    43311.4,
                    37671.5
                  ],
                  [
                    43273.2,
                    37669.5
                  ],
                  [
                    43252.9,
                    37614
                  ],
                  [
                    43220.8,
                    37597.3
                  ],
                  [
                    43180.9,
                    37614
                  ],
                  [
                    43169,
                    37694.4
                  ],
                  [
                    43109.8,
                    37693.2
                  ],
                  [
                    43050.7,
                    37656.9
                  ]
                ],
                "id": 916,
                "chat_link": "[&BJQDAAA=]"
              },
              "917": {
                "name": "Envoy's Terrace",
                "level": 0,
                "coord": [
                  43025.3,
                  37490.4
                ],
                "bounds": [
                  [
                    43014,
                    37424.1
                  ],
                  [
                    43046.5,
                    37450.3
                  ],
                  [
                    43079.1,
                    37470
                  ],
                  [
                    43131.4,
                    37517.1
                  ],
                  [
                    43056.7,
                    37658.9
                  ],
                  [
                    42983,
                    37623.6
                  ],
                  [
                    42874.8,
                    37389.1
                  ],
                  [
                    43017.1,
                    37390.4
                  ],
                  [
                    43014,
                    37424.1
                  ]
                ],
                "id": 917,
                "chat_link": "[&BJUDAAA=]"
              }
            },
            "adventures": [],
            "id": 1025,
            "mastery_points": []
          },
          "1026": {
            "name": "Meeting the Asura",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              41024,
              35200
            ],
            "map_rect": [
              [
                -24576,
                -39936
              ],
              [
                27648,
                39936
              ]
            ],
            "continent_rect": [
              [
                39936,
                33536
              ],
              [
                42112,
                36864
              ]
            ],
            "points_of_interest": {
              "61": {
                "name": "Inner Inquest Complex",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  41888.4,
                  33654.6
                ],
                "id": 61,
                "chat_link": "[&BD0AAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "156": {
                "name": "Hexane Regrade",
                "level": 14,
                "coord": [
                  41672.9,
                  33970.5
                ],
                "bounds": [
                  [
                    41456,
                    34486.8
                  ],
                  [
                    41922,
                    34261.2
                  ],
                  [
                    42133.7,
                    34314.6
                  ],
                  [
                    42182.7,
                    34046.6
                  ],
                  [
                    42132.4,
                    33846.8
                  ],
                  [
                    41861.1,
                    33948.3
                  ],
                  [
                    41525,
                    33947.2
                  ],
                  [
                    41527.8,
                    33778.6
                  ],
                  [
                    41468.1,
                    33506.1
                  ],
                  [
                    41102.8,
                    33459.8
                  ],
                  [
                    41090.8,
                    34079.2
                  ],
                  [
                    41456,
                    34486.8
                  ]
                ],
                "id": 156,
                "chat_link": "[&BJwAAAA=]"
              },
              "159": {
                "name": "Inquest Outer Complex",
                "level": 14,
                "coord": [
                  41860.7,
                  33722.4
                ],
                "bounds": [
                  [
                    41525.7,
                    33948.1
                  ],
                  [
                    41861.5,
                    33948.1
                  ],
                  [
                    42133.8,
                    33851.7
                  ],
                  [
                    42129.6,
                    33676.7
                  ],
                  [
                    42164.4,
                    33571.1
                  ],
                  [
                    42075.6,
                    33498.8
                  ],
                  [
                    41467.4,
                    33506.6
                  ],
                  [
                    41527.5,
                    33778
                  ],
                  [
                    41525.7,
                    33948.1
                  ]
                ],
                "id": 159,
                "chat_link": "[&BJ8AAAA=]"
              }
            },
            "adventures": [],
            "id": 1026,
            "mastery_points": []
          },
          "1027": {
            "name": "Pact Assaulted",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37618,
              31484
            ],
            "map_rect": [
              [
                -24576,
                -18432
              ],
              [
                24576,
                18432
              ]
            ],
            "continent_rect": [
              [
                36608,
                30592
              ],
              [
                38656,
                32128
              ]
            ],
            "points_of_interest": {
              "1959": {
                "name": "Camp Resolve",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38487.8,
                  31706.5
                ],
                "id": 1959,
                "chat_link": "[&BKcHAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1201": {
                "name": "Camp Resolve",
                "level": 80,
                "coord": [
                  38397.8,
                  31772.9
                ],
                "bounds": [
                  [
                    38264.8,
                    31545.7
                  ],
                  [
                    38336.5,
                    31481.1
                  ],
                  [
                    38683.6,
                    31527.5
                  ],
                  [
                    38678.2,
                    31573.9
                  ],
                  [
                    38666.7,
                    31706.6
                  ],
                  [
                    38627.3,
                    32139.2
                  ],
                  [
                    38237.7,
                    32113.6
                  ],
                  [
                    38269.8,
                    32003.9
                  ],
                  [
                    38245.9,
                    31951.8
                  ],
                  [
                    38214.1,
                    31899.1
                  ],
                  [
                    38296.2,
                    31742.9
                  ],
                  [
                    38253.3,
                    31589.1
                  ],
                  [
                    38264.8,
                    31545.7
                  ]
                ],
                "id": 1201,
                "chat_link": "[&BLEEAAA=]"
              }
            },
            "adventures": [],
            "id": 1027,
            "mastery_points": []
          },
          "1028": {
            "name": "The Mystery Cave",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37618,
              31484
            ],
            "map_rect": [
              [
                -24576,
                -18432
              ],
              [
                24576,
                18432
              ]
            ],
            "continent_rect": [
              [
                36608,
                30592
              ],
              [
                38656,
                32128
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1213": {
                "name": "The Sealed Cavern",
                "level": 80,
                "coord": [
                  37170.4,
                  30898
                ],
                "bounds": [
                  [
                    37561.5,
                    30621.6
                  ],
                  [
                    36729.8,
                    30666.8
                  ],
                  [
                    36635.3,
                    30953.8
                  ],
                  [
                    36714.6,
                    31228.3
                  ],
                  [
                    36862.8,
                    31228
                  ],
                  [
                    36869.2,
                    31086.1
                  ],
                  [
                    36876.5,
                    30970.8
                  ],
                  [
                    36961.5,
                    30954.6
                  ],
                  [
                    37059.9,
                    30955.6
                  ],
                  [
                    37149.6,
                    30902.4
                  ],
                  [
                    37115.3,
                    30847.4
                  ],
                  [
                    37205.9,
                    30827
                  ],
                  [
                    37289.9,
                    30876.5
                  ],
                  [
                    37360.7,
                    30871.4
                  ],
                  [
                    37425.8,
                    30908.4
                  ],
                  [
                    37483.6,
                    30903.4
                  ],
                  [
                    37510.1,
                    30913.1
                  ],
                  [
                    37519.8,
                    30854.3
                  ],
                  [
                    37542.3,
                    30741.6
                  ],
                  [
                    37534.6,
                    30648.7
                  ],
                  [
                    37561.5,
                    30621.6
                  ]
                ],
                "id": 1213,
                "chat_link": "[&BL0EAAA=]"
              },
              "1214": {
                "name": "Far Silverwastes",
                "level": 80,
                "coord": [
                  37860.7,
                  30864
                ],
                "bounds": [
                  [
                    38142.9,
                    30952.4
                  ],
                  [
                    38195,
                    30969.3
                  ],
                  [
                    38211.6,
                    30927
                  ],
                  [
                    38153.2,
                    30873.1
                  ],
                  [
                    38126.8,
                    30777.3
                  ],
                  [
                    38134.9,
                    30737.4
                  ],
                  [
                    38045.5,
                    30656.7
                  ],
                  [
                    37988.6,
                    30608.8
                  ],
                  [
                    37561.3,
                    30621.4
                  ],
                  [
                    37534.1,
                    30647.3
                  ],
                  [
                    37545.9,
                    30735.6
                  ],
                  [
                    37520.4,
                    30853.1
                  ],
                  [
                    37510.9,
                    30912.3
                  ],
                  [
                    37566.1,
                    30934.4
                  ],
                  [
                    37698.6,
                    30975.1
                  ],
                  [
                    37713.6,
                    31056
                  ],
                  [
                    37799.2,
                    31080.8
                  ],
                  [
                    37920.4,
                    31078.5
                  ],
                  [
                    37983.4,
                    31019.7
                  ],
                  [
                    38142.9,
                    30952.4
                  ]
                ],
                "id": 1214,
                "chat_link": "[&BL4EAAA=]"
              }
            },
            "adventures": [],
            "id": 1028,
            "mastery_points": []
          },
          "1029": {
            "name": "Arcana Obscura",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              51328,
              32128
            ],
            "map_rect": [
              [
                -27648,
                -18432
              ],
              [
                30720,
                18432
              ]
            ],
            "continent_rect": [
              [
                49666,
                30720
              ],
              [
                52098,
                32256
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "947": {
                "name": "Durmand Priory",
                "level": 31,
                "coord": [
                  50090.6,
                  30363.3
                ],
                "bounds": [
                  [
                    49858,
                    30897.9
                  ],
                  [
                    50271.9,
                    30748
                  ],
                  [
                    50366.9,
                    30347
                  ],
                  [
                    50314.2,
                    30153.6
                  ],
                  [
                    50221,
                    30157.9
                  ],
                  [
                    50149.6,
                    30081.1
                  ],
                  [
                    49828.2,
                    30101.7
                  ],
                  [
                    49714.6,
                    30419.4
                  ],
                  [
                    49858,
                    30897.9
                  ]
                ],
                "id": 947,
                "chat_link": "[&BLMDAAA=]"
              }
            },
            "adventures": [],
            "id": 1029,
            "mastery_points": []
          },
          "1079": {
            "name": "Deep Trouble",
            "min_level": 60,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              52480,
              38912
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "628": {
                "name": "The Mire Sea",
                "level": 67,
                "coord": [
                  53266.4,
                  39193.6
                ],
                "bounds": [
                  [
                    53159.7,
                    39398
                  ],
                  [
                    52697.9,
                    39135.6
                  ],
                  [
                    52680.7,
                    38944
                  ],
                  [
                    52757.6,
                    38730.2
                  ],
                  [
                    52993.3,
                    38773.5
                  ],
                  [
                    53056.9,
                    38915.5
                  ],
                  [
                    53230.1,
                    38890.3
                  ],
                  [
                    53368.6,
                    39021
                  ],
                  [
                    53650.1,
                    39074.5
                  ],
                  [
                    53898,
                    39345.2
                  ],
                  [
                    53817.2,
                    39399.3
                  ],
                  [
                    53676.3,
                    39702.6
                  ],
                  [
                    53425,
                    39666.5
                  ],
                  [
                    53318.8,
                    39713.9
                  ],
                  [
                    53159.7,
                    39398
                  ]
                ],
                "id": 628,
                "chat_link": "[&BHQCAAA=]"
              },
              "629": {
                "name": "Benthic Kelp Beds",
                "level": 68,
                "coord": [
                  54019.2,
                  39685.7
                ],
                "bounds": [
                  [
                    53743.2,
                    39840.5
                  ],
                  [
                    53749.3,
                    39781.8
                  ],
                  [
                    53676.3,
                    39699.6
                  ],
                  [
                    53816.3,
                    39395.5
                  ],
                  [
                    53895.6,
                    39343.7
                  ],
                  [
                    54118.2,
                    39358.2
                  ],
                  [
                    54245.3,
                    39162
                  ],
                  [
                    54309.1,
                    39267.7
                  ],
                  [
                    54299.6,
                    39771.7
                  ],
                  [
                    54215.3,
                    39832.8
                  ],
                  [
                    54154.5,
                    40119.1
                  ],
                  [
                    54079.6,
                    40175.3
                  ],
                  [
                    53947.3,
                    40166.8
                  ],
                  [
                    53743.2,
                    39840.5
                  ]
                ],
                "id": 629,
                "chat_link": "[&BHUCAAA=]"
              },
              "630": {
                "name": "Sunken Droknah",
                "level": 67,
                "coord": [
                  53578.4,
                  38885.4
                ],
                "bounds": [
                  [
                    53231.1,
                    38892
                  ],
                  [
                    53281.7,
                    38731.1
                  ],
                  [
                    53548.2,
                    38573.8
                  ],
                  [
                    53853.7,
                    38777.3
                  ],
                  [
                    53856.5,
                    38910.2
                  ],
                  [
                    53753.8,
                    38990.9
                  ],
                  [
                    53664.3,
                    38989
                  ],
                  [
                    53648.8,
                    39079.7
                  ],
                  [
                    53367.1,
                    39024.3
                  ],
                  [
                    53231.1,
                    38892
                  ]
                ],
                "id": 630,
                "chat_link": "[&BHYCAAA=]"
              },
              "631": {
                "name": "Irwin Isle",
                "level": 67,
                "coord": [
                  52783.6,
                  39451.8
                ],
                "bounds": [
                  [
                    52787,
                    39896.7
                  ],
                  [
                    52683.9,
                    39684.1
                  ],
                  [
                    52666,
                    39501.3
                  ],
                  [
                    52508.6,
                    39404.4
                  ],
                  [
                    52435.5,
                    39293.3
                  ],
                  [
                    52429.4,
                    39100.1
                  ],
                  [
                    52489.2,
                    38946.1
                  ],
                  [
                    52685.5,
                    38940.8
                  ],
                  [
                    52699.4,
                    39129.2
                  ],
                  [
                    53162.5,
                    39399.5
                  ],
                  [
                    53317.8,
                    39712.4
                  ],
                  [
                    53260.9,
                    39893.2
                  ],
                  [
                    53061.3,
                    39972.3
                  ],
                  [
                    52787,
                    39896.7
                  ]
                ],
                "id": 631,
                "chat_link": "[&BHcCAAA=]"
              },
              "632": {
                "name": "The Stychs",
                "level": 67,
                "coord": [
                  53332.4,
                  39924.5
                ],
                "bounds": [
                  [
                    53261.1,
                    39892.5
                  ],
                  [
                    53319.5,
                    39712.5
                  ],
                  [
                    53424.8,
                    39666.6
                  ],
                  [
                    53676.9,
                    39701.1
                  ],
                  [
                    53749.1,
                    39781
                  ],
                  [
                    53743.2,
                    39839.3
                  ],
                  [
                    53942.1,
                    40160.2
                  ],
                  [
                    53377.2,
                    40137
                  ],
                  [
                    53242.8,
                    40096.5
                  ],
                  [
                    53011.7,
                    40143.6
                  ],
                  [
                    52725.9,
                    40024
                  ],
                  [
                    52785.9,
                    39890.9
                  ],
                  [
                    53060.5,
                    39973.4
                  ],
                  [
                    53261.1,
                    39892.5
                  ]
                ],
                "id": 632,
                "chat_link": "[&BHgCAAA=]"
              },
              "633": {
                "name": "Dysphoric Rim",
                "level": 65,
                "coord": [
                  51324,
                  39659.2
                ],
                "bounds": [
                  [
                    51092.6,
                    39913.1
                  ],
                  [
                    50929.2,
                    39460.8
                  ],
                  [
                    51129.6,
                    39205.5
                  ],
                  [
                    51450.7,
                    39294.2
                  ],
                  [
                    51479.2,
                    39562.4
                  ],
                  [
                    51511,
                    39734.5
                  ],
                  [
                    51582,
                    39791.9
                  ],
                  [
                    51472.5,
                    39971
                  ],
                  [
                    51269.6,
                    39999.1
                  ],
                  [
                    51092.6,
                    39913.1
                  ]
                ],
                "id": 633,
                "chat_link": "[&BHkCAAA=]"
              },
              "634": {
                "name": "Murkvale",
                "level": 65,
                "coord": [
                  50745.4,
                  39658.6
                ],
                "bounds": [
                  [
                    50974.3,
                    40160.4
                  ],
                  [
                    50836.6,
                    40095.1
                  ],
                  [
                    50688.7,
                    40120
                  ],
                  [
                    50544.1,
                    40088.8
                  ],
                  [
                    50518.2,
                    39975.4
                  ],
                  [
                    50520.8,
                    39804.2
                  ],
                  [
                    50557.1,
                    39734.8
                  ],
                  [
                    50555.3,
                    39558.1
                  ],
                  [
                    50535.4,
                    39463.1
                  ],
                  [
                    50497.6,
                    39258.6
                  ],
                  [
                    50544.3,
                    39117
                  ],
                  [
                    50631.2,
                    39101.8
                  ],
                  [
                    51027.7,
                    39071.5
                  ],
                  [
                    51125.7,
                    39205.6
                  ],
                  [
                    50932.3,
                    39463.3
                  ],
                  [
                    51090.4,
                    39908.7
                  ],
                  [
                    51091.7,
                    40070
                  ],
                  [
                    50974.3,
                    40160.4
                  ]
                ],
                "id": 634,
                "chat_link": "[&BHoCAAA=]"
              },
              "635": {
                "name": "Judgment Rock",
                "level": 69,
                "coord": [
                  54312.3,
                  40017.9
                ],
                "bounds": [
                  [
                    54156.4,
                    40116.7
                  ],
                  [
                    54214.5,
                    39831.3
                  ],
                  [
                    54299.1,
                    39770.5
                  ],
                  [
                    54352.6,
                    39943.3
                  ],
                  [
                    54360.5,
                    40079
                  ],
                  [
                    54399.9,
                    40065.3
                  ],
                  [
                    54399,
                    40135
                  ],
                  [
                    54347,
                    40142.3
                  ],
                  [
                    54281.5,
                    40077.8
                  ],
                  [
                    54156.4,
                    40116.7
                  ]
                ],
                "id": 635,
                "chat_link": "[&BHsCAAA=]"
              },
              "636": {
                "name": "Gauntlet Gulch",
                "level": 67,
                "coord": [
                  53045.6,
                  38288.9
                ],
                "bounds": [
                  [
                    52756.9,
                    38736.3
                  ],
                  [
                    52604.1,
                    38531.3
                  ],
                  [
                    52689.6,
                    38354.4
                  ],
                  [
                    52703.1,
                    38126.3
                  ],
                  [
                    52813.3,
                    38053.6
                  ],
                  [
                    52860.5,
                    37969.4
                  ],
                  [
                    52816.7,
                    37762.1
                  ],
                  [
                    52952.9,
                    37731.9
                  ],
                  [
                    53117.2,
                    37741.5
                  ],
                  [
                    53385.1,
                    37839.3
                  ],
                  [
                    53322.2,
                    37927.1
                  ],
                  [
                    53327.6,
                    38054.4
                  ],
                  [
                    53358.3,
                    38463.2
                  ],
                  [
                    53547.9,
                    38579
                  ],
                  [
                    53285,
                    38733.5
                  ],
                  [
                    53229.6,
                    38895.4
                  ],
                  [
                    53057.5,
                    38920.5
                  ],
                  [
                    52993.1,
                    38780.4
                  ],
                  [
                    52756.9,
                    38736.3
                  ]
                ],
                "id": 636,
                "chat_link": "[&BHwCAAA=]"
              },
              "637": {
                "name": "Govoran Terraces",
                "level": 63,
                "coord": [
                  50860.2,
                  38065.1
                ],
                "bounds": [
                  [
                    50489.6,
                    38081.8
                  ],
                  [
                    50523.3,
                    37970
                  ],
                  [
                    50668.6,
                    38089.1
                  ],
                  [
                    50766.7,
                    38006.8
                  ],
                  [
                    50931.6,
                    37816.3
                  ],
                  [
                    51013.7,
                    37804.3
                  ],
                  [
                    51225.5,
                    37821.3
                  ],
                  [
                    51265,
                    37941
                  ],
                  [
                    51290,
                    38014.9
                  ],
                  [
                    51273.8,
                    38309.4
                  ],
                  [
                    50608.3,
                    38449.9
                  ],
                  [
                    50558.1,
                    38362.1
                  ],
                  [
                    50568.9,
                    38179.8
                  ],
                  [
                    50489.6,
                    38081.8
                  ]
                ],
                "id": 637,
                "chat_link": "[&BH0CAAA=]"
              },
              "638": {
                "name": "Broken Arrow River",
                "level": 61,
                "coord": [
                  52475.9,
                  38261.5
                ],
                "bounds": [
                  [
                    52251.8,
                    38508
                  ],
                  [
                    52066.3,
                    37885.1
                  ],
                  [
                    52103.4,
                    37745
                  ],
                  [
                    52267.9,
                    37695.8
                  ],
                  [
                    52519.5,
                    37758.1
                  ],
                  [
                    52571.8,
                    37916.7
                  ],
                  [
                    52702.4,
                    38126.7
                  ],
                  [
                    52688.8,
                    38354.3
                  ],
                  [
                    52604.6,
                    38531.3
                  ],
                  [
                    52763.3,
                    38725
                  ],
                  [
                    52682.1,
                    38946
                  ],
                  [
                    52489.3,
                    38946.5
                  ],
                  [
                    52251.8,
                    38508
                  ]
                ],
                "id": 638,
                "chat_link": "[&BH4CAAA=]"
              },
              "639": {
                "name": "Quandry Scratch",
                "level": 62,
                "coord": [
                  51391.4,
                  38064.7
                ],
                "bounds": [
                  [
                    51339.3,
                    38479.8
                  ],
                  [
                    51269.8,
                    38311.5
                  ],
                  [
                    51289.8,
                    38015.7
                  ],
                  [
                    51261.3,
                    37940.4
                  ],
                  [
                    51223,
                    37825.6
                  ],
                  [
                    51371.3,
                    37770.5
                  ],
                  [
                    51585.5,
                    37779.7
                  ],
                  [
                    51687.1,
                    37920.1
                  ],
                  [
                    51496.1,
                    38538.7
                  ],
                  [
                    51339.3,
                    38479.8
                  ]
                ],
                "id": 639,
                "chat_link": "[&BH8CAAA=]"
              },
              "640": {
                "name": "Bard's Valley",
                "level": 61,
                "coord": [
                  51861.6,
                  38159.3
                ],
                "bounds": [
                  [
                    51494.8,
                    38532.7
                  ],
                  [
                    51686.7,
                    37917.9
                  ],
                  [
                    51661.9,
                    37800.5
                  ],
                  [
                    51848.2,
                    37754.1
                  ],
                  [
                    52018.3,
                    37775.4
                  ],
                  [
                    52068.3,
                    37884
                  ],
                  [
                    52255.5,
                    38510.9
                  ],
                  [
                    51947.8,
                    38554.3
                  ],
                  [
                    51773.3,
                    38704.2
                  ],
                  [
                    51494.8,
                    38532.7
                  ]
                ],
                "id": 640,
                "chat_link": "[&BIACAAA=]"
              },
              "641": {
                "name": "Criterion Canyon",
                "level": 63,
                "coord": [
                  50955.3,
                  38714.6
                ],
                "bounds": [
                  [
                    50630.6,
                    39103.2
                  ],
                  [
                    50566,
                    39071.7
                  ],
                  [
                    50532.7,
                    38844.7
                  ],
                  [
                    50537.2,
                    38621.4
                  ],
                  [
                    50590.9,
                    38512.8
                  ],
                  [
                    50609.6,
                    38453.3
                  ],
                  [
                    51273.7,
                    38310
                  ],
                  [
                    51342.1,
                    38472.2
                  ],
                  [
                    51495.4,
                    38533.5
                  ],
                  [
                    51426.9,
                    38677.8
                  ],
                  [
                    51242.3,
                    38785
                  ],
                  [
                    51143.2,
                    38834
                  ],
                  [
                    51027.8,
                    39070.2
                  ],
                  [
                    50630.6,
                    39103.2
                  ]
                ],
                "id": 641,
                "chat_link": "[&BIECAAA=]"
              },
              "642": {
                "name": "Whitland Flats",
                "level": 68,
                "coord": [
                  53950.1,
                  38930.3
                ],
                "bounds": [
                  [
                    53894.8,
                    39345.8
                  ],
                  [
                    53651.5,
                    39080.2
                  ],
                  [
                    53660.9,
                    38988.3
                  ],
                  [
                    53752.8,
                    38984.3
                  ],
                  [
                    53852.6,
                    38911.5
                  ],
                  [
                    53853.5,
                    38778.1
                  ],
                  [
                    53736.9,
                    38701.6
                  ],
                  [
                    54033.1,
                    38560.7
                  ],
                  [
                    54151.3,
                    38574
                  ],
                  [
                    54339.3,
                    38863.8
                  ],
                  [
                    54357.5,
                    39012.8
                  ],
                  [
                    54116.9,
                    39362.1
                  ],
                  [
                    53894.8,
                    39345.8
                  ]
                ],
                "id": 642,
                "chat_link": "[&BIICAAA=]"
              },
              "643": {
                "name": "Unguent Den",
                "level": 68,
                "coord": [
                  52701.2,
                  37882.1
                ],
                "bounds": [
                  [
                    52701.4,
                    38127.8
                  ],
                  [
                    52572.9,
                    37917.9
                  ],
                  [
                    52519.3,
                    37756.1
                  ],
                  [
                    52592.4,
                    37735.9
                  ],
                  [
                    52731.4,
                    37736.3
                  ],
                  [
                    52816.7,
                    37761.9
                  ],
                  [
                    52860.6,
                    37968.6
                  ],
                  [
                    52814.8,
                    38052.5
                  ],
                  [
                    52701.4,
                    38127.8
                  ]
                ],
                "id": 643,
                "chat_link": "[&BIMCAAA=]"
              },
              "644": {
                "name": "Magmatic Conjury",
                "level": 65,
                "coord": [
                  51653.8,
                  39744.7
                ],
                "bounds": [
                  [
                    51800.1,
                    39887.6
                  ],
                  [
                    51658.3,
                    39850.4
                  ],
                  [
                    51582.2,
                    39790.5
                  ],
                  [
                    51513,
                    39733.1
                  ],
                  [
                    51479.1,
                    39563.8
                  ],
                  [
                    51700,
                    39681.4
                  ],
                  [
                    51843.8,
                    39706
                  ],
                  [
                    51800.1,
                    39887.6
                  ]
                ],
                "id": 644,
                "chat_link": "[&BIQCAAA=]"
              },
              "645": {
                "name": "Maelstrom's Bile",
                "level": 66,
                "coord": [
                  51805.5,
                  39351.4
                ],
                "bounds": [
                  [
                    51699.1,
                    39683.2
                  ],
                  [
                    51480.4,
                    39560.8
                  ],
                  [
                    51451.9,
                    39298.6
                  ],
                  [
                    51513.4,
                    39136.7
                  ],
                  [
                    51626.5,
                    38966.4
                  ],
                  [
                    51798.4,
                    38900.2
                  ],
                  [
                    51996.1,
                    39056.3
                  ],
                  [
                    52180.9,
                    39197.3
                  ],
                  [
                    52235.5,
                    39416.3
                  ],
                  [
                    51999.2,
                    39638.3
                  ],
                  [
                    51842.7,
                    39655.2
                  ],
                  [
                    51841.6,
                    39707.5
                  ],
                  [
                    51699.1,
                    39683.2
                  ]
                ],
                "id": 645,
                "chat_link": "[&BIUCAAA=]"
              },
              "646": {
                "name": "Sootberme",
                "level": 64,
                "coord": [
                  51446.6,
                  38907.6
                ],
                "bounds": [
                  [
                    51027,
                    39079.3
                  ],
                  [
                    51135.2,
                    38832
                  ],
                  [
                    51241.4,
                    38786.5
                  ],
                  [
                    51427.3,
                    38671.9
                  ],
                  [
                    51497.2,
                    38531.4
                  ],
                  [
                    51773.6,
                    38703.1
                  ],
                  [
                    51738.9,
                    38779.7
                  ],
                  [
                    51799.9,
                    38898.5
                  ],
                  [
                    51628.2,
                    38965.6
                  ],
                  [
                    51512.7,
                    39136.6
                  ],
                  [
                    51451.9,
                    39295.1
                  ],
                  [
                    51126.1,
                    39212.1
                  ],
                  [
                    51027,
                    39079.3
                  ]
                ],
                "id": 646,
                "chat_link": "[&BIYCAAA=]"
              },
              "647": {
                "name": "Ashen Waste",
                "level": 65,
                "coord": [
                  52169.8,
                  39023.4
                ],
                "bounds": [
                  [
                    51737.4,
                    38779.8
                  ],
                  [
                    51771.6,
                    38702.9
                  ],
                  [
                    51947.1,
                    38554.7
                  ],
                  [
                    52255.3,
                    38509.3
                  ],
                  [
                    52489.8,
                    38950.5
                  ],
                  [
                    52431.9,
                    39105.5
                  ],
                  [
                    52437.9,
                    39290.7
                  ],
                  [
                    52507.8,
                    39396.6
                  ],
                  [
                    52424.2,
                    39432
                  ],
                  [
                    52236,
                    39421
                  ],
                  [
                    52177,
                    39199.3
                  ],
                  [
                    51993.5,
                    39057
                  ],
                  [
                    51797.5,
                    38904.3
                  ],
                  [
                    51737.4,
                    38779.8
                  ]
                ],
                "id": 647,
                "chat_link": "[&BIcCAAA=]"
              },
              "648": {
                "name": "Avernan Volatile",
                "level": 65,
                "coord": [
                  52483.6,
                  39673.6
                ],
                "bounds": [
                  [
                    52059,
                    39590.5
                  ],
                  [
                    52233.1,
                    39420.1
                  ],
                  [
                    52424.7,
                    39434.2
                  ],
                  [
                    52508.6,
                    39392
                  ],
                  [
                    52672.1,
                    39500.4
                  ],
                  [
                    52686.5,
                    39689.1
                  ],
                  [
                    52785.4,
                    39894.4
                  ],
                  [
                    52726.7,
                    40025.6
                  ],
                  [
                    52255.8,
                    40115.8
                  ],
                  [
                    52059,
                    39590.5
                  ]
                ],
                "id": 648,
                "chat_link": "[&BIgCAAA=]"
              },
              "649": {
                "name": "Mon Maelstrom",
                "level": 65,
                "coord": [
                  51785.3,
                  39881.4
                ],
                "bounds": [
                  [
                    51876.6,
                    40154.4
                  ],
                  [
                    51554.4,
                    40142.3
                  ],
                  [
                    51483.7,
                    40073.1
                  ],
                  [
                    51472.6,
                    39969.7
                  ],
                  [
                    51583.5,
                    39790.1
                  ],
                  [
                    51657.6,
                    39850.4
                  ],
                  [
                    51800,
                    39887.6
                  ],
                  [
                    51841.2,
                    39708.1
                  ],
                  [
                    51840.2,
                    39655.3
                  ],
                  [
                    51997.9,
                    39641
                  ],
                  [
                    52057.7,
                    39591.7
                  ],
                  [
                    52257.9,
                    40113
                  ],
                  [
                    51876.6,
                    40154.4
                  ]
                ],
                "id": 649,
                "chat_link": "[&BIkCAAA=]"
              },
              "651": {
                "name": "Infinity Coil",
                "level": 69,
                "coord": [
                  53696.3,
                  38071.6
                ],
                "bounds": [
                  [
                    53355.6,
                    38466.7
                  ],
                  [
                    53325.4,
                    38063.5
                  ],
                  [
                    53323.4,
                    37926.8
                  ],
                  [
                    53409.8,
                    37802.4
                  ],
                  [
                    53670.2,
                    37693.6
                  ],
                  [
                    53964,
                    37706.2
                  ],
                  [
                    54089.4,
                    37796.4
                  ],
                  [
                    54053.9,
                    37995.7
                  ],
                  [
                    54034.7,
                    38561.9
                  ],
                  [
                    53736.9,
                    38702.5
                  ],
                  [
                    53355.6,
                    38466.7
                  ]
                ],
                "id": 651,
                "chat_link": "[&BIsCAAA=]"
              },
              "1059": {
                "name": "Cubular Fells",
                "level": 62,
                "coord": [
                  50714.5,
                  37913.5
                ],
                "bounds": [
                  [
                    50526.4,
                    37969.6
                  ],
                  [
                    50668.6,
                    38089.9
                  ],
                  [
                    50767.4,
                    38007.1
                  ],
                  [
                    50894,
                    37861
                  ],
                  [
                    50809.1,
                    37774.6
                  ],
                  [
                    50621.7,
                    37778.6
                  ],
                  [
                    50526.4,
                    37969.6
                  ]
                ],
                "id": 1059,
                "chat_link": "[&BCMEAAA=]"
              },
              "1076": {
                "name": "Dierdre's Steps",
                "level": 69,
                "coord": [
                  54218.1,
                  38231.4
                ],
                "bounds": [
                  [
                    54052.1,
                    37996.6
                  ],
                  [
                    54089.3,
                    37794.8
                  ],
                  [
                    54429.8,
                    37922.4
                  ],
                  [
                    54412.6,
                    38523.6
                  ],
                  [
                    54289.6,
                    38591.3
                  ],
                  [
                    54035.4,
                    38559.9
                  ],
                  [
                    54052.1,
                    37996.6
                  ]
                ],
                "id": 1076,
                "chat_link": "[&BDQEAAA=]"
              }
            },
            "adventures": [],
            "id": 1079,
            "mastery_points": []
          },
          "1083": {
            "name": "Deep Trouble",
            "min_level": 60,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              52480,
              38912
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "628": {
                "name": "The Mire Sea",
                "level": 67,
                "coord": [
                  53266.4,
                  39193.6
                ],
                "bounds": [
                  [
                    53159.7,
                    39398
                  ],
                  [
                    52697.9,
                    39135.6
                  ],
                  [
                    52680.7,
                    38944
                  ],
                  [
                    52757.6,
                    38730.2
                  ],
                  [
                    52993.3,
                    38773.5
                  ],
                  [
                    53056.9,
                    38915.5
                  ],
                  [
                    53230.1,
                    38890.3
                  ],
                  [
                    53368.6,
                    39021
                  ],
                  [
                    53650.1,
                    39074.5
                  ],
                  [
                    53898,
                    39345.2
                  ],
                  [
                    53817.2,
                    39399.3
                  ],
                  [
                    53676.3,
                    39702.6
                  ],
                  [
                    53425,
                    39666.5
                  ],
                  [
                    53318.8,
                    39713.9
                  ],
                  [
                    53159.7,
                    39398
                  ]
                ],
                "id": 628,
                "chat_link": "[&BHQCAAA=]"
              },
              "629": {
                "name": "Benthic Kelp Beds",
                "level": 68,
                "coord": [
                  54019.2,
                  39685.7
                ],
                "bounds": [
                  [
                    53743.2,
                    39840.5
                  ],
                  [
                    53749.3,
                    39781.8
                  ],
                  [
                    53676.3,
                    39699.6
                  ],
                  [
                    53816.3,
                    39395.5
                  ],
                  [
                    53895.6,
                    39343.7
                  ],
                  [
                    54118.2,
                    39358.2
                  ],
                  [
                    54245.3,
                    39162
                  ],
                  [
                    54309.1,
                    39267.7
                  ],
                  [
                    54299.6,
                    39771.7
                  ],
                  [
                    54215.3,
                    39832.8
                  ],
                  [
                    54154.5,
                    40119.1
                  ],
                  [
                    54079.6,
                    40175.3
                  ],
                  [
                    53947.3,
                    40166.8
                  ],
                  [
                    53743.2,
                    39840.5
                  ]
                ],
                "id": 629,
                "chat_link": "[&BHUCAAA=]"
              },
              "630": {
                "name": "Sunken Droknah",
                "level": 67,
                "coord": [
                  53578.4,
                  38885.4
                ],
                "bounds": [
                  [
                    53231.1,
                    38892
                  ],
                  [
                    53281.7,
                    38731.1
                  ],
                  [
                    53548.2,
                    38573.8
                  ],
                  [
                    53853.7,
                    38777.3
                  ],
                  [
                    53856.5,
                    38910.2
                  ],
                  [
                    53753.8,
                    38990.9
                  ],
                  [
                    53664.3,
                    38989
                  ],
                  [
                    53648.8,
                    39079.7
                  ],
                  [
                    53367.1,
                    39024.3
                  ],
                  [
                    53231.1,
                    38892
                  ]
                ],
                "id": 630,
                "chat_link": "[&BHYCAAA=]"
              },
              "631": {
                "name": "Irwin Isle",
                "level": 67,
                "coord": [
                  52783.6,
                  39451.8
                ],
                "bounds": [
                  [
                    52787,
                    39896.7
                  ],
                  [
                    52683.9,
                    39684.1
                  ],
                  [
                    52666,
                    39501.3
                  ],
                  [
                    52508.6,
                    39404.4
                  ],
                  [
                    52435.5,
                    39293.3
                  ],
                  [
                    52429.4,
                    39100.1
                  ],
                  [
                    52489.2,
                    38946.1
                  ],
                  [
                    52685.5,
                    38940.8
                  ],
                  [
                    52699.4,
                    39129.2
                  ],
                  [
                    53162.5,
                    39399.5
                  ],
                  [
                    53317.8,
                    39712.4
                  ],
                  [
                    53260.9,
                    39893.2
                  ],
                  [
                    53061.3,
                    39972.3
                  ],
                  [
                    52787,
                    39896.7
                  ]
                ],
                "id": 631,
                "chat_link": "[&BHcCAAA=]"
              },
              "632": {
                "name": "The Stychs",
                "level": 67,
                "coord": [
                  53332.4,
                  39924.5
                ],
                "bounds": [
                  [
                    53261.1,
                    39892.5
                  ],
                  [
                    53319.5,
                    39712.5
                  ],
                  [
                    53424.8,
                    39666.6
                  ],
                  [
                    53676.9,
                    39701.1
                  ],
                  [
                    53749.1,
                    39781
                  ],
                  [
                    53743.2,
                    39839.3
                  ],
                  [
                    53942.1,
                    40160.2
                  ],
                  [
                    53377.2,
                    40137
                  ],
                  [
                    53242.8,
                    40096.5
                  ],
                  [
                    53011.7,
                    40143.6
                  ],
                  [
                    52725.9,
                    40024
                  ],
                  [
                    52785.9,
                    39890.9
                  ],
                  [
                    53060.5,
                    39973.4
                  ],
                  [
                    53261.1,
                    39892.5
                  ]
                ],
                "id": 632,
                "chat_link": "[&BHgCAAA=]"
              },
              "633": {
                "name": "Dysphoric Rim",
                "level": 65,
                "coord": [
                  51324,
                  39659.2
                ],
                "bounds": [
                  [
                    51092.6,
                    39913.1
                  ],
                  [
                    50929.2,
                    39460.8
                  ],
                  [
                    51129.6,
                    39205.5
                  ],
                  [
                    51450.7,
                    39294.2
                  ],
                  [
                    51479.2,
                    39562.4
                  ],
                  [
                    51511,
                    39734.5
                  ],
                  [
                    51582,
                    39791.9
                  ],
                  [
                    51472.5,
                    39971
                  ],
                  [
                    51269.6,
                    39999.1
                  ],
                  [
                    51092.6,
                    39913.1
                  ]
                ],
                "id": 633,
                "chat_link": "[&BHkCAAA=]"
              },
              "634": {
                "name": "Murkvale",
                "level": 65,
                "coord": [
                  50745.4,
                  39658.6
                ],
                "bounds": [
                  [
                    50974.3,
                    40160.4
                  ],
                  [
                    50836.6,
                    40095.1
                  ],
                  [
                    50688.7,
                    40120
                  ],
                  [
                    50544.1,
                    40088.8
                  ],
                  [
                    50518.2,
                    39975.4
                  ],
                  [
                    50520.8,
                    39804.2
                  ],
                  [
                    50557.1,
                    39734.8
                  ],
                  [
                    50555.3,
                    39558.1
                  ],
                  [
                    50535.4,
                    39463.1
                  ],
                  [
                    50497.6,
                    39258.6
                  ],
                  [
                    50544.3,
                    39117
                  ],
                  [
                    50631.2,
                    39101.8
                  ],
                  [
                    51027.7,
                    39071.5
                  ],
                  [
                    51125.7,
                    39205.6
                  ],
                  [
                    50932.3,
                    39463.3
                  ],
                  [
                    51090.4,
                    39908.7
                  ],
                  [
                    51091.7,
                    40070
                  ],
                  [
                    50974.3,
                    40160.4
                  ]
                ],
                "id": 634,
                "chat_link": "[&BHoCAAA=]"
              },
              "635": {
                "name": "Judgment Rock",
                "level": 69,
                "coord": [
                  54312.3,
                  40017.9
                ],
                "bounds": [
                  [
                    54156.4,
                    40116.7
                  ],
                  [
                    54214.5,
                    39831.3
                  ],
                  [
                    54299.1,
                    39770.5
                  ],
                  [
                    54352.6,
                    39943.3
                  ],
                  [
                    54360.5,
                    40079
                  ],
                  [
                    54399.9,
                    40065.3
                  ],
                  [
                    54399,
                    40135
                  ],
                  [
                    54347,
                    40142.3
                  ],
                  [
                    54281.5,
                    40077.8
                  ],
                  [
                    54156.4,
                    40116.7
                  ]
                ],
                "id": 635,
                "chat_link": "[&BHsCAAA=]"
              },
              "636": {
                "name": "Gauntlet Gulch",
                "level": 67,
                "coord": [
                  53045.6,
                  38288.9
                ],
                "bounds": [
                  [
                    52756.9,
                    38736.3
                  ],
                  [
                    52604.1,
                    38531.3
                  ],
                  [
                    52689.6,
                    38354.4
                  ],
                  [
                    52703.1,
                    38126.3
                  ],
                  [
                    52813.3,
                    38053.6
                  ],
                  [
                    52860.5,
                    37969.4
                  ],
                  [
                    52816.7,
                    37762.1
                  ],
                  [
                    52952.9,
                    37731.9
                  ],
                  [
                    53117.2,
                    37741.5
                  ],
                  [
                    53385.1,
                    37839.3
                  ],
                  [
                    53322.2,
                    37927.1
                  ],
                  [
                    53327.6,
                    38054.4
                  ],
                  [
                    53358.3,
                    38463.2
                  ],
                  [
                    53547.9,
                    38579
                  ],
                  [
                    53285,
                    38733.5
                  ],
                  [
                    53229.6,
                    38895.4
                  ],
                  [
                    53057.5,
                    38920.5
                  ],
                  [
                    52993.1,
                    38780.4
                  ],
                  [
                    52756.9,
                    38736.3
                  ]
                ],
                "id": 636,
                "chat_link": "[&BHwCAAA=]"
              },
              "637": {
                "name": "Govoran Terraces",
                "level": 63,
                "coord": [
                  50860.2,
                  38065.1
                ],
                "bounds": [
                  [
                    50489.6,
                    38081.8
                  ],
                  [
                    50523.3,
                    37970
                  ],
                  [
                    50668.6,
                    38089.1
                  ],
                  [
                    50766.7,
                    38006.8
                  ],
                  [
                    50931.6,
                    37816.3
                  ],
                  [
                    51013.7,
                    37804.3
                  ],
                  [
                    51225.5,
                    37821.3
                  ],
                  [
                    51265,
                    37941
                  ],
                  [
                    51290,
                    38014.9
                  ],
                  [
                    51273.8,
                    38309.4
                  ],
                  [
                    50608.3,
                    38449.9
                  ],
                  [
                    50558.1,
                    38362.1
                  ],
                  [
                    50568.9,
                    38179.8
                  ],
                  [
                    50489.6,
                    38081.8
                  ]
                ],
                "id": 637,
                "chat_link": "[&BH0CAAA=]"
              },
              "638": {
                "name": "Broken Arrow River",
                "level": 61,
                "coord": [
                  52475.9,
                  38261.5
                ],
                "bounds": [
                  [
                    52251.8,
                    38508
                  ],
                  [
                    52066.3,
                    37885.1
                  ],
                  [
                    52103.4,
                    37745
                  ],
                  [
                    52267.9,
                    37695.8
                  ],
                  [
                    52519.5,
                    37758.1
                  ],
                  [
                    52571.8,
                    37916.7
                  ],
                  [
                    52702.4,
                    38126.7
                  ],
                  [
                    52688.8,
                    38354.3
                  ],
                  [
                    52604.6,
                    38531.3
                  ],
                  [
                    52763.3,
                    38725
                  ],
                  [
                    52682.1,
                    38946
                  ],
                  [
                    52489.3,
                    38946.5
                  ],
                  [
                    52251.8,
                    38508
                  ]
                ],
                "id": 638,
                "chat_link": "[&BH4CAAA=]"
              },
              "639": {
                "name": "Quandry Scratch",
                "level": 62,
                "coord": [
                  51391.4,
                  38064.7
                ],
                "bounds": [
                  [
                    51339.3,
                    38479.8
                  ],
                  [
                    51269.8,
                    38311.5
                  ],
                  [
                    51289.8,
                    38015.7
                  ],
                  [
                    51261.3,
                    37940.4
                  ],
                  [
                    51223,
                    37825.6
                  ],
                  [
                    51371.3,
                    37770.5
                  ],
                  [
                    51585.5,
                    37779.7
                  ],
                  [
                    51687.1,
                    37920.1
                  ],
                  [
                    51496.1,
                    38538.7
                  ],
                  [
                    51339.3,
                    38479.8
                  ]
                ],
                "id": 639,
                "chat_link": "[&BH8CAAA=]"
              },
              "640": {
                "name": "Bard's Valley",
                "level": 61,
                "coord": [
                  51861.6,
                  38159.3
                ],
                "bounds": [
                  [
                    51494.8,
                    38532.7
                  ],
                  [
                    51686.7,
                    37917.9
                  ],
                  [
                    51661.9,
                    37800.5
                  ],
                  [
                    51848.2,
                    37754.1
                  ],
                  [
                    52018.3,
                    37775.4
                  ],
                  [
                    52068.3,
                    37884
                  ],
                  [
                    52255.5,
                    38510.9
                  ],
                  [
                    51947.8,
                    38554.3
                  ],
                  [
                    51773.3,
                    38704.2
                  ],
                  [
                    51494.8,
                    38532.7
                  ]
                ],
                "id": 640,
                "chat_link": "[&BIACAAA=]"
              },
              "641": {
                "name": "Criterion Canyon",
                "level": 63,
                "coord": [
                  50955.3,
                  38714.6
                ],
                "bounds": [
                  [
                    50630.6,
                    39103.2
                  ],
                  [
                    50566,
                    39071.7
                  ],
                  [
                    50532.7,
                    38844.7
                  ],
                  [
                    50537.2,
                    38621.4
                  ],
                  [
                    50590.9,
                    38512.8
                  ],
                  [
                    50609.6,
                    38453.3
                  ],
                  [
                    51273.7,
                    38310
                  ],
                  [
                    51342.1,
                    38472.2
                  ],
                  [
                    51495.4,
                    38533.5
                  ],
                  [
                    51426.9,
                    38677.8
                  ],
                  [
                    51242.3,
                    38785
                  ],
                  [
                    51143.2,
                    38834
                  ],
                  [
                    51027.8,
                    39070.2
                  ],
                  [
                    50630.6,
                    39103.2
                  ]
                ],
                "id": 641,
                "chat_link": "[&BIECAAA=]"
              },
              "642": {
                "name": "Whitland Flats",
                "level": 68,
                "coord": [
                  53950.1,
                  38930.3
                ],
                "bounds": [
                  [
                    53894.8,
                    39345.8
                  ],
                  [
                    53651.5,
                    39080.2
                  ],
                  [
                    53660.9,
                    38988.3
                  ],
                  [
                    53752.8,
                    38984.3
                  ],
                  [
                    53852.6,
                    38911.5
                  ],
                  [
                    53853.5,
                    38778.1
                  ],
                  [
                    53736.9,
                    38701.6
                  ],
                  [
                    54033.1,
                    38560.7
                  ],
                  [
                    54151.3,
                    38574
                  ],
                  [
                    54339.3,
                    38863.8
                  ],
                  [
                    54357.5,
                    39012.8
                  ],
                  [
                    54116.9,
                    39362.1
                  ],
                  [
                    53894.8,
                    39345.8
                  ]
                ],
                "id": 642,
                "chat_link": "[&BIICAAA=]"
              },
              "643": {
                "name": "Unguent Den",
                "level": 68,
                "coord": [
                  52701.2,
                  37882.1
                ],
                "bounds": [
                  [
                    52701.4,
                    38127.8
                  ],
                  [
                    52572.9,
                    37917.9
                  ],
                  [
                    52519.3,
                    37756.1
                  ],
                  [
                    52592.4,
                    37735.9
                  ],
                  [
                    52731.4,
                    37736.3
                  ],
                  [
                    52816.7,
                    37761.9
                  ],
                  [
                    52860.6,
                    37968.6
                  ],
                  [
                    52814.8,
                    38052.5
                  ],
                  [
                    52701.4,
                    38127.8
                  ]
                ],
                "id": 643,
                "chat_link": "[&BIMCAAA=]"
              },
              "644": {
                "name": "Magmatic Conjury",
                "level": 65,
                "coord": [
                  51653.8,
                  39744.7
                ],
                "bounds": [
                  [
                    51800.1,
                    39887.6
                  ],
                  [
                    51658.3,
                    39850.4
                  ],
                  [
                    51582.2,
                    39790.5
                  ],
                  [
                    51513,
                    39733.1
                  ],
                  [
                    51479.1,
                    39563.8
                  ],
                  [
                    51700,
                    39681.4
                  ],
                  [
                    51843.8,
                    39706
                  ],
                  [
                    51800.1,
                    39887.6
                  ]
                ],
                "id": 644,
                "chat_link": "[&BIQCAAA=]"
              },
              "645": {
                "name": "Maelstrom's Bile",
                "level": 66,
                "coord": [
                  51805.5,
                  39351.4
                ],
                "bounds": [
                  [
                    51699.1,
                    39683.2
                  ],
                  [
                    51480.4,
                    39560.8
                  ],
                  [
                    51451.9,
                    39298.6
                  ],
                  [
                    51513.4,
                    39136.7
                  ],
                  [
                    51626.5,
                    38966.4
                  ],
                  [
                    51798.4,
                    38900.2
                  ],
                  [
                    51996.1,
                    39056.3
                  ],
                  [
                    52180.9,
                    39197.3
                  ],
                  [
                    52235.5,
                    39416.3
                  ],
                  [
                    51999.2,
                    39638.3
                  ],
                  [
                    51842.7,
                    39655.2
                  ],
                  [
                    51841.6,
                    39707.5
                  ],
                  [
                    51699.1,
                    39683.2
                  ]
                ],
                "id": 645,
                "chat_link": "[&BIUCAAA=]"
              },
              "646": {
                "name": "Sootberme",
                "level": 64,
                "coord": [
                  51446.6,
                  38907.6
                ],
                "bounds": [
                  [
                    51027,
                    39079.3
                  ],
                  [
                    51135.2,
                    38832
                  ],
                  [
                    51241.4,
                    38786.5
                  ],
                  [
                    51427.3,
                    38671.9
                  ],
                  [
                    51497.2,
                    38531.4
                  ],
                  [
                    51773.6,
                    38703.1
                  ],
                  [
                    51738.9,
                    38779.7
                  ],
                  [
                    51799.9,
                    38898.5
                  ],
                  [
                    51628.2,
                    38965.6
                  ],
                  [
                    51512.7,
                    39136.6
                  ],
                  [
                    51451.9,
                    39295.1
                  ],
                  [
                    51126.1,
                    39212.1
                  ],
                  [
                    51027,
                    39079.3
                  ]
                ],
                "id": 646,
                "chat_link": "[&BIYCAAA=]"
              },
              "647": {
                "name": "Ashen Waste",
                "level": 65,
                "coord": [
                  52169.8,
                  39023.4
                ],
                "bounds": [
                  [
                    51737.4,
                    38779.8
                  ],
                  [
                    51771.6,
                    38702.9
                  ],
                  [
                    51947.1,
                    38554.7
                  ],
                  [
                    52255.3,
                    38509.3
                  ],
                  [
                    52489.8,
                    38950.5
                  ],
                  [
                    52431.9,
                    39105.5
                  ],
                  [
                    52437.9,
                    39290.7
                  ],
                  [
                    52507.8,
                    39396.6
                  ],
                  [
                    52424.2,
                    39432
                  ],
                  [
                    52236,
                    39421
                  ],
                  [
                    52177,
                    39199.3
                  ],
                  [
                    51993.5,
                    39057
                  ],
                  [
                    51797.5,
                    38904.3
                  ],
                  [
                    51737.4,
                    38779.8
                  ]
                ],
                "id": 647,
                "chat_link": "[&BIcCAAA=]"
              },
              "648": {
                "name": "Avernan Volatile",
                "level": 65,
                "coord": [
                  52483.6,
                  39673.6
                ],
                "bounds": [
                  [
                    52059,
                    39590.5
                  ],
                  [
                    52233.1,
                    39420.1
                  ],
                  [
                    52424.7,
                    39434.2
                  ],
                  [
                    52508.6,
                    39392
                  ],
                  [
                    52672.1,
                    39500.4
                  ],
                  [
                    52686.5,
                    39689.1
                  ],
                  [
                    52785.4,
                    39894.4
                  ],
                  [
                    52726.7,
                    40025.6
                  ],
                  [
                    52255.8,
                    40115.8
                  ],
                  [
                    52059,
                    39590.5
                  ]
                ],
                "id": 648,
                "chat_link": "[&BIgCAAA=]"
              },
              "649": {
                "name": "Mon Maelstrom",
                "level": 65,
                "coord": [
                  51785.3,
                  39881.4
                ],
                "bounds": [
                  [
                    51876.6,
                    40154.4
                  ],
                  [
                    51554.4,
                    40142.3
                  ],
                  [
                    51483.7,
                    40073.1
                  ],
                  [
                    51472.6,
                    39969.7
                  ],
                  [
                    51583.5,
                    39790.1
                  ],
                  [
                    51657.6,
                    39850.4
                  ],
                  [
                    51800,
                    39887.6
                  ],
                  [
                    51841.2,
                    39708.1
                  ],
                  [
                    51840.2,
                    39655.3
                  ],
                  [
                    51997.9,
                    39641
                  ],
                  [
                    52057.7,
                    39591.7
                  ],
                  [
                    52257.9,
                    40113
                  ],
                  [
                    51876.6,
                    40154.4
                  ]
                ],
                "id": 649,
                "chat_link": "[&BIkCAAA=]"
              },
              "651": {
                "name": "Infinity Coil",
                "level": 69,
                "coord": [
                  53696.3,
                  38071.6
                ],
                "bounds": [
                  [
                    53355.6,
                    38466.7
                  ],
                  [
                    53325.4,
                    38063.5
                  ],
                  [
                    53323.4,
                    37926.8
                  ],
                  [
                    53409.8,
                    37802.4
                  ],
                  [
                    53670.2,
                    37693.6
                  ],
                  [
                    53964,
                    37706.2
                  ],
                  [
                    54089.4,
                    37796.4
                  ],
                  [
                    54053.9,
                    37995.7
                  ],
                  [
                    54034.7,
                    38561.9
                  ],
                  [
                    53736.9,
                    38702.5
                  ],
                  [
                    53355.6,
                    38466.7
                  ]
                ],
                "id": 651,
                "chat_link": "[&BIsCAAA=]"
              },
              "1059": {
                "name": "Cubular Fells",
                "level": 62,
                "coord": [
                  50714.5,
                  37913.5
                ],
                "bounds": [
                  [
                    50526.4,
                    37969.6
                  ],
                  [
                    50668.6,
                    38089.9
                  ],
                  [
                    50767.4,
                    38007.1
                  ],
                  [
                    50894,
                    37861
                  ],
                  [
                    50809.1,
                    37774.6
                  ],
                  [
                    50621.7,
                    37778.6
                  ],
                  [
                    50526.4,
                    37969.6
                  ]
                ],
                "id": 1059,
                "chat_link": "[&BCMEAAA=]"
              },
              "1076": {
                "name": "Dierdre's Steps",
                "level": 69,
                "coord": [
                  54218.1,
                  38231.4
                ],
                "bounds": [
                  [
                    54052.1,
                    37996.6
                  ],
                  [
                    54089.3,
                    37794.8
                  ],
                  [
                    54429.8,
                    37922.4
                  ],
                  [
                    54412.6,
                    38523.6
                  ],
                  [
                    54289.6,
                    38591.3
                  ],
                  [
                    54035.4,
                    38559.9
                  ],
                  [
                    54052.1,
                    37996.6
                  ]
                ],
                "id": 1076,
                "chat_link": "[&BDQEAAA=]"
              }
            },
            "id": 1083,
            "mastery_points": [],
            "adventures": []
          },
          "1106": {
            "name": "Deep Trouble",
            "min_level": 60,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              52480,
              38912
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "628": {
                "name": "The Mire Sea",
                "level": 67,
                "coord": [
                  53266.4,
                  39193.6
                ],
                "bounds": [
                  [
                    53159.7,
                    39398
                  ],
                  [
                    52697.9,
                    39135.6
                  ],
                  [
                    52680.7,
                    38944
                  ],
                  [
                    52757.6,
                    38730.2
                  ],
                  [
                    52993.3,
                    38773.5
                  ],
                  [
                    53056.9,
                    38915.5
                  ],
                  [
                    53230.1,
                    38890.3
                  ],
                  [
                    53368.6,
                    39021
                  ],
                  [
                    53650.1,
                    39074.5
                  ],
                  [
                    53898,
                    39345.2
                  ],
                  [
                    53817.2,
                    39399.3
                  ],
                  [
                    53676.3,
                    39702.6
                  ],
                  [
                    53425,
                    39666.5
                  ],
                  [
                    53318.8,
                    39713.9
                  ],
                  [
                    53159.7,
                    39398
                  ]
                ],
                "id": 628,
                "chat_link": "[&BHQCAAA=]"
              },
              "629": {
                "name": "Benthic Kelp Beds",
                "level": 68,
                "coord": [
                  54019.2,
                  39685.7
                ],
                "bounds": [
                  [
                    53743.2,
                    39840.5
                  ],
                  [
                    53749.3,
                    39781.8
                  ],
                  [
                    53676.3,
                    39699.6
                  ],
                  [
                    53816.3,
                    39395.5
                  ],
                  [
                    53895.6,
                    39343.7
                  ],
                  [
                    54118.2,
                    39358.2
                  ],
                  [
                    54245.3,
                    39162
                  ],
                  [
                    54309.1,
                    39267.7
                  ],
                  [
                    54299.6,
                    39771.7
                  ],
                  [
                    54215.3,
                    39832.8
                  ],
                  [
                    54154.5,
                    40119.1
                  ],
                  [
                    54079.6,
                    40175.3
                  ],
                  [
                    53947.3,
                    40166.8
                  ],
                  [
                    53743.2,
                    39840.5
                  ]
                ],
                "id": 629,
                "chat_link": "[&BHUCAAA=]"
              },
              "630": {
                "name": "Sunken Droknah",
                "level": 67,
                "coord": [
                  53578.4,
                  38885.4
                ],
                "bounds": [
                  [
                    53231.1,
                    38892
                  ],
                  [
                    53281.7,
                    38731.1
                  ],
                  [
                    53548.2,
                    38573.8
                  ],
                  [
                    53853.7,
                    38777.3
                  ],
                  [
                    53856.5,
                    38910.2
                  ],
                  [
                    53753.8,
                    38990.9
                  ],
                  [
                    53664.3,
                    38989
                  ],
                  [
                    53648.8,
                    39079.7
                  ],
                  [
                    53367.1,
                    39024.3
                  ],
                  [
                    53231.1,
                    38892
                  ]
                ],
                "id": 630,
                "chat_link": "[&BHYCAAA=]"
              },
              "631": {
                "name": "Irwin Isle",
                "level": 67,
                "coord": [
                  52783.6,
                  39451.8
                ],
                "bounds": [
                  [
                    52787,
                    39896.7
                  ],
                  [
                    52683.9,
                    39684.1
                  ],
                  [
                    52666,
                    39501.3
                  ],
                  [
                    52508.6,
                    39404.4
                  ],
                  [
                    52435.5,
                    39293.3
                  ],
                  [
                    52429.4,
                    39100.1
                  ],
                  [
                    52489.2,
                    38946.1
                  ],
                  [
                    52685.5,
                    38940.8
                  ],
                  [
                    52699.4,
                    39129.2
                  ],
                  [
                    53162.5,
                    39399.5
                  ],
                  [
                    53317.8,
                    39712.4
                  ],
                  [
                    53260.9,
                    39893.2
                  ],
                  [
                    53061.3,
                    39972.3
                  ],
                  [
                    52787,
                    39896.7
                  ]
                ],
                "id": 631,
                "chat_link": "[&BHcCAAA=]"
              },
              "632": {
                "name": "The Stychs",
                "level": 67,
                "coord": [
                  53332.4,
                  39924.5
                ],
                "bounds": [
                  [
                    53261.1,
                    39892.5
                  ],
                  [
                    53319.5,
                    39712.5
                  ],
                  [
                    53424.8,
                    39666.6
                  ],
                  [
                    53676.9,
                    39701.1
                  ],
                  [
                    53749.1,
                    39781
                  ],
                  [
                    53743.2,
                    39839.3
                  ],
                  [
                    53942.1,
                    40160.2
                  ],
                  [
                    53377.2,
                    40137
                  ],
                  [
                    53242.8,
                    40096.5
                  ],
                  [
                    53011.7,
                    40143.6
                  ],
                  [
                    52725.9,
                    40024
                  ],
                  [
                    52785.9,
                    39890.9
                  ],
                  [
                    53060.5,
                    39973.4
                  ],
                  [
                    53261.1,
                    39892.5
                  ]
                ],
                "id": 632,
                "chat_link": "[&BHgCAAA=]"
              },
              "633": {
                "name": "Dysphoric Rim",
                "level": 65,
                "coord": [
                  51324,
                  39659.2
                ],
                "bounds": [
                  [
                    51092.6,
                    39913.1
                  ],
                  [
                    50929.2,
                    39460.8
                  ],
                  [
                    51129.6,
                    39205.5
                  ],
                  [
                    51450.7,
                    39294.2
                  ],
                  [
                    51479.2,
                    39562.4
                  ],
                  [
                    51511,
                    39734.5
                  ],
                  [
                    51582,
                    39791.9
                  ],
                  [
                    51472.5,
                    39971
                  ],
                  [
                    51269.6,
                    39999.1
                  ],
                  [
                    51092.6,
                    39913.1
                  ]
                ],
                "id": 633,
                "chat_link": "[&BHkCAAA=]"
              },
              "634": {
                "name": "Murkvale",
                "level": 65,
                "coord": [
                  50745.4,
                  39658.6
                ],
                "bounds": [
                  [
                    50974.3,
                    40160.4
                  ],
                  [
                    50836.6,
                    40095.1
                  ],
                  [
                    50688.7,
                    40120
                  ],
                  [
                    50544.1,
                    40088.8
                  ],
                  [
                    50518.2,
                    39975.4
                  ],
                  [
                    50520.8,
                    39804.2
                  ],
                  [
                    50557.1,
                    39734.8
                  ],
                  [
                    50555.3,
                    39558.1
                  ],
                  [
                    50535.4,
                    39463.1
                  ],
                  [
                    50497.6,
                    39258.6
                  ],
                  [
                    50544.3,
                    39117
                  ],
                  [
                    50631.2,
                    39101.8
                  ],
                  [
                    51027.7,
                    39071.5
                  ],
                  [
                    51125.7,
                    39205.6
                  ],
                  [
                    50932.3,
                    39463.3
                  ],
                  [
                    51090.4,
                    39908.7
                  ],
                  [
                    51091.7,
                    40070
                  ],
                  [
                    50974.3,
                    40160.4
                  ]
                ],
                "id": 634,
                "chat_link": "[&BHoCAAA=]"
              },
              "635": {
                "name": "Judgment Rock",
                "level": 69,
                "coord": [
                  54312.3,
                  40017.9
                ],
                "bounds": [
                  [
                    54156.4,
                    40116.7
                  ],
                  [
                    54214.5,
                    39831.3
                  ],
                  [
                    54299.1,
                    39770.5
                  ],
                  [
                    54352.6,
                    39943.3
                  ],
                  [
                    54360.5,
                    40079
                  ],
                  [
                    54399.9,
                    40065.3
                  ],
                  [
                    54399,
                    40135
                  ],
                  [
                    54347,
                    40142.3
                  ],
                  [
                    54281.5,
                    40077.8
                  ],
                  [
                    54156.4,
                    40116.7
                  ]
                ],
                "id": 635,
                "chat_link": "[&BHsCAAA=]"
              },
              "636": {
                "name": "Gauntlet Gulch",
                "level": 67,
                "coord": [
                  53045.6,
                  38288.9
                ],
                "bounds": [
                  [
                    52756.9,
                    38736.3
                  ],
                  [
                    52604.1,
                    38531.3
                  ],
                  [
                    52689.6,
                    38354.4
                  ],
                  [
                    52703.1,
                    38126.3
                  ],
                  [
                    52813.3,
                    38053.6
                  ],
                  [
                    52860.5,
                    37969.4
                  ],
                  [
                    52816.7,
                    37762.1
                  ],
                  [
                    52952.9,
                    37731.9
                  ],
                  [
                    53117.2,
                    37741.5
                  ],
                  [
                    53385.1,
                    37839.3
                  ],
                  [
                    53322.2,
                    37927.1
                  ],
                  [
                    53327.6,
                    38054.4
                  ],
                  [
                    53358.3,
                    38463.2
                  ],
                  [
                    53547.9,
                    38579
                  ],
                  [
                    53285,
                    38733.5
                  ],
                  [
                    53229.6,
                    38895.4
                  ],
                  [
                    53057.5,
                    38920.5
                  ],
                  [
                    52993.1,
                    38780.4
                  ],
                  [
                    52756.9,
                    38736.3
                  ]
                ],
                "id": 636,
                "chat_link": "[&BHwCAAA=]"
              },
              "637": {
                "name": "Govoran Terraces",
                "level": 63,
                "coord": [
                  50860.2,
                  38065.1
                ],
                "bounds": [
                  [
                    50489.6,
                    38081.8
                  ],
                  [
                    50523.3,
                    37970
                  ],
                  [
                    50668.6,
                    38089.1
                  ],
                  [
                    50766.7,
                    38006.8
                  ],
                  [
                    50931.6,
                    37816.3
                  ],
                  [
                    51013.7,
                    37804.3
                  ],
                  [
                    51225.5,
                    37821.3
                  ],
                  [
                    51265,
                    37941
                  ],
                  [
                    51290,
                    38014.9
                  ],
                  [
                    51273.8,
                    38309.4
                  ],
                  [
                    50608.3,
                    38449.9
                  ],
                  [
                    50558.1,
                    38362.1
                  ],
                  [
                    50568.9,
                    38179.8
                  ],
                  [
                    50489.6,
                    38081.8
                  ]
                ],
                "id": 637,
                "chat_link": "[&BH0CAAA=]"
              },
              "638": {
                "name": "Broken Arrow River",
                "level": 61,
                "coord": [
                  52475.9,
                  38261.5
                ],
                "bounds": [
                  [
                    52251.8,
                    38508
                  ],
                  [
                    52066.3,
                    37885.1
                  ],
                  [
                    52103.4,
                    37745
                  ],
                  [
                    52267.9,
                    37695.8
                  ],
                  [
                    52519.5,
                    37758.1
                  ],
                  [
                    52571.8,
                    37916.7
                  ],
                  [
                    52702.4,
                    38126.7
                  ],
                  [
                    52688.8,
                    38354.3
                  ],
                  [
                    52604.6,
                    38531.3
                  ],
                  [
                    52763.3,
                    38725
                  ],
                  [
                    52682.1,
                    38946
                  ],
                  [
                    52489.3,
                    38946.5
                  ],
                  [
                    52251.8,
                    38508
                  ]
                ],
                "id": 638,
                "chat_link": "[&BH4CAAA=]"
              },
              "639": {
                "name": "Quandry Scratch",
                "level": 62,
                "coord": [
                  51391.4,
                  38064.7
                ],
                "bounds": [
                  [
                    51339.3,
                    38479.8
                  ],
                  [
                    51269.8,
                    38311.5
                  ],
                  [
                    51289.8,
                    38015.7
                  ],
                  [
                    51261.3,
                    37940.4
                  ],
                  [
                    51223,
                    37825.6
                  ],
                  [
                    51371.3,
                    37770.5
                  ],
                  [
                    51585.5,
                    37779.7
                  ],
                  [
                    51687.1,
                    37920.1
                  ],
                  [
                    51496.1,
                    38538.7
                  ],
                  [
                    51339.3,
                    38479.8
                  ]
                ],
                "id": 639,
                "chat_link": "[&BH8CAAA=]"
              },
              "640": {
                "name": "Bard's Valley",
                "level": 61,
                "coord": [
                  51861.6,
                  38159.3
                ],
                "bounds": [
                  [
                    51494.8,
                    38532.7
                  ],
                  [
                    51686.7,
                    37917.9
                  ],
                  [
                    51661.9,
                    37800.5
                  ],
                  [
                    51848.2,
                    37754.1
                  ],
                  [
                    52018.3,
                    37775.4
                  ],
                  [
                    52068.3,
                    37884
                  ],
                  [
                    52255.5,
                    38510.9
                  ],
                  [
                    51947.8,
                    38554.3
                  ],
                  [
                    51773.3,
                    38704.2
                  ],
                  [
                    51494.8,
                    38532.7
                  ]
                ],
                "id": 640,
                "chat_link": "[&BIACAAA=]"
              },
              "641": {
                "name": "Criterion Canyon",
                "level": 63,
                "coord": [
                  50955.3,
                  38714.6
                ],
                "bounds": [
                  [
                    50630.6,
                    39103.2
                  ],
                  [
                    50566,
                    39071.7
                  ],
                  [
                    50532.7,
                    38844.7
                  ],
                  [
                    50537.2,
                    38621.4
                  ],
                  [
                    50590.9,
                    38512.8
                  ],
                  [
                    50609.6,
                    38453.3
                  ],
                  [
                    51273.7,
                    38310
                  ],
                  [
                    51342.1,
                    38472.2
                  ],
                  [
                    51495.4,
                    38533.5
                  ],
                  [
                    51426.9,
                    38677.8
                  ],
                  [
                    51242.3,
                    38785
                  ],
                  [
                    51143.2,
                    38834
                  ],
                  [
                    51027.8,
                    39070.2
                  ],
                  [
                    50630.6,
                    39103.2
                  ]
                ],
                "id": 641,
                "chat_link": "[&BIECAAA=]"
              },
              "642": {
                "name": "Whitland Flats",
                "level": 68,
                "coord": [
                  53950.1,
                  38930.3
                ],
                "bounds": [
                  [
                    53894.8,
                    39345.8
                  ],
                  [
                    53651.5,
                    39080.2
                  ],
                  [
                    53660.9,
                    38988.3
                  ],
                  [
                    53752.8,
                    38984.3
                  ],
                  [
                    53852.6,
                    38911.5
                  ],
                  [
                    53853.5,
                    38778.1
                  ],
                  [
                    53736.9,
                    38701.6
                  ],
                  [
                    54033.1,
                    38560.7
                  ],
                  [
                    54151.3,
                    38574
                  ],
                  [
                    54339.3,
                    38863.8
                  ],
                  [
                    54357.5,
                    39012.8
                  ],
                  [
                    54116.9,
                    39362.1
                  ],
                  [
                    53894.8,
                    39345.8
                  ]
                ],
                "id": 642,
                "chat_link": "[&BIICAAA=]"
              },
              "643": {
                "name": "Unguent Den",
                "level": 68,
                "coord": [
                  52701.2,
                  37882.1
                ],
                "bounds": [
                  [
                    52701.4,
                    38127.8
                  ],
                  [
                    52572.9,
                    37917.9
                  ],
                  [
                    52519.3,
                    37756.1
                  ],
                  [
                    52592.4,
                    37735.9
                  ],
                  [
                    52731.4,
                    37736.3
                  ],
                  [
                    52816.7,
                    37761.9
                  ],
                  [
                    52860.6,
                    37968.6
                  ],
                  [
                    52814.8,
                    38052.5
                  ],
                  [
                    52701.4,
                    38127.8
                  ]
                ],
                "id": 643,
                "chat_link": "[&BIMCAAA=]"
              },
              "644": {
                "name": "Magmatic Conjury",
                "level": 65,
                "coord": [
                  51653.8,
                  39744.7
                ],
                "bounds": [
                  [
                    51800.1,
                    39887.6
                  ],
                  [
                    51658.3,
                    39850.4
                  ],
                  [
                    51582.2,
                    39790.5
                  ],
                  [
                    51513,
                    39733.1
                  ],
                  [
                    51479.1,
                    39563.8
                  ],
                  [
                    51700,
                    39681.4
                  ],
                  [
                    51843.8,
                    39706
                  ],
                  [
                    51800.1,
                    39887.6
                  ]
                ],
                "id": 644,
                "chat_link": "[&BIQCAAA=]"
              },
              "645": {
                "name": "Maelstrom's Bile",
                "level": 66,
                "coord": [
                  51805.5,
                  39351.4
                ],
                "bounds": [
                  [
                    51699.1,
                    39683.2
                  ],
                  [
                    51480.4,
                    39560.8
                  ],
                  [
                    51451.9,
                    39298.6
                  ],
                  [
                    51513.4,
                    39136.7
                  ],
                  [
                    51626.5,
                    38966.4
                  ],
                  [
                    51798.4,
                    38900.2
                  ],
                  [
                    51996.1,
                    39056.3
                  ],
                  [
                    52180.9,
                    39197.3
                  ],
                  [
                    52235.5,
                    39416.3
                  ],
                  [
                    51999.2,
                    39638.3
                  ],
                  [
                    51842.7,
                    39655.2
                  ],
                  [
                    51841.6,
                    39707.5
                  ],
                  [
                    51699.1,
                    39683.2
                  ]
                ],
                "id": 645,
                "chat_link": "[&BIUCAAA=]"
              },
              "646": {
                "name": "Sootberme",
                "level": 64,
                "coord": [
                  51446.6,
                  38907.6
                ],
                "bounds": [
                  [
                    51027,
                    39079.3
                  ],
                  [
                    51135.2,
                    38832
                  ],
                  [
                    51241.4,
                    38786.5
                  ],
                  [
                    51427.3,
                    38671.9
                  ],
                  [
                    51497.2,
                    38531.4
                  ],
                  [
                    51773.6,
                    38703.1
                  ],
                  [
                    51738.9,
                    38779.7
                  ],
                  [
                    51799.9,
                    38898.5
                  ],
                  [
                    51628.2,
                    38965.6
                  ],
                  [
                    51512.7,
                    39136.6
                  ],
                  [
                    51451.9,
                    39295.1
                  ],
                  [
                    51126.1,
                    39212.1
                  ],
                  [
                    51027,
                    39079.3
                  ]
                ],
                "id": 646,
                "chat_link": "[&BIYCAAA=]"
              },
              "647": {
                "name": "Ashen Waste",
                "level": 65,
                "coord": [
                  52169.8,
                  39023.4
                ],
                "bounds": [
                  [
                    51737.4,
                    38779.8
                  ],
                  [
                    51771.6,
                    38702.9
                  ],
                  [
                    51947.1,
                    38554.7
                  ],
                  [
                    52255.3,
                    38509.3
                  ],
                  [
                    52489.8,
                    38950.5
                  ],
                  [
                    52431.9,
                    39105.5
                  ],
                  [
                    52437.9,
                    39290.7
                  ],
                  [
                    52507.8,
                    39396.6
                  ],
                  [
                    52424.2,
                    39432
                  ],
                  [
                    52236,
                    39421
                  ],
                  [
                    52177,
                    39199.3
                  ],
                  [
                    51993.5,
                    39057
                  ],
                  [
                    51797.5,
                    38904.3
                  ],
                  [
                    51737.4,
                    38779.8
                  ]
                ],
                "id": 647,
                "chat_link": "[&BIcCAAA=]"
              },
              "648": {
                "name": "Avernan Volatile",
                "level": 65,
                "coord": [
                  52483.6,
                  39673.6
                ],
                "bounds": [
                  [
                    52059,
                    39590.5
                  ],
                  [
                    52233.1,
                    39420.1
                  ],
                  [
                    52424.7,
                    39434.2
                  ],
                  [
                    52508.6,
                    39392
                  ],
                  [
                    52672.1,
                    39500.4
                  ],
                  [
                    52686.5,
                    39689.1
                  ],
                  [
                    52785.4,
                    39894.4
                  ],
                  [
                    52726.7,
                    40025.6
                  ],
                  [
                    52255.8,
                    40115.8
                  ],
                  [
                    52059,
                    39590.5
                  ]
                ],
                "id": 648,
                "chat_link": "[&BIgCAAA=]"
              },
              "649": {
                "name": "Mon Maelstrom",
                "level": 65,
                "coord": [
                  51785.3,
                  39881.4
                ],
                "bounds": [
                  [
                    51876.6,
                    40154.4
                  ],
                  [
                    51554.4,
                    40142.3
                  ],
                  [
                    51483.7,
                    40073.1
                  ],
                  [
                    51472.6,
                    39969.7
                  ],
                  [
                    51583.5,
                    39790.1
                  ],
                  [
                    51657.6,
                    39850.4
                  ],
                  [
                    51800,
                    39887.6
                  ],
                  [
                    51841.2,
                    39708.1
                  ],
                  [
                    51840.2,
                    39655.3
                  ],
                  [
                    51997.9,
                    39641
                  ],
                  [
                    52057.7,
                    39591.7
                  ],
                  [
                    52257.9,
                    40113
                  ],
                  [
                    51876.6,
                    40154.4
                  ]
                ],
                "id": 649,
                "chat_link": "[&BIkCAAA=]"
              },
              "651": {
                "name": "Infinity Coil",
                "level": 69,
                "coord": [
                  53696.3,
                  38071.6
                ],
                "bounds": [
                  [
                    53355.6,
                    38466.7
                  ],
                  [
                    53325.4,
                    38063.5
                  ],
                  [
                    53323.4,
                    37926.8
                  ],
                  [
                    53409.8,
                    37802.4
                  ],
                  [
                    53670.2,
                    37693.6
                  ],
                  [
                    53964,
                    37706.2
                  ],
                  [
                    54089.4,
                    37796.4
                  ],
                  [
                    54053.9,
                    37995.7
                  ],
                  [
                    54034.7,
                    38561.9
                  ],
                  [
                    53736.9,
                    38702.5
                  ],
                  [
                    53355.6,
                    38466.7
                  ]
                ],
                "id": 651,
                "chat_link": "[&BIsCAAA=]"
              },
              "1059": {
                "name": "Cubular Fells",
                "level": 62,
                "coord": [
                  50714.5,
                  37913.5
                ],
                "bounds": [
                  [
                    50526.4,
                    37969.6
                  ],
                  [
                    50668.6,
                    38089.9
                  ],
                  [
                    50767.4,
                    38007.1
                  ],
                  [
                    50894,
                    37861
                  ],
                  [
                    50809.1,
                    37774.6
                  ],
                  [
                    50621.7,
                    37778.6
                  ],
                  [
                    50526.4,
                    37969.6
                  ]
                ],
                "id": 1059,
                "chat_link": "[&BCMEAAA=]"
              },
              "1076": {
                "name": "Dierdre's Steps",
                "level": 69,
                "coord": [
                  54218.1,
                  38231.4
                ],
                "bounds": [
                  [
                    54052.1,
                    37996.6
                  ],
                  [
                    54089.3,
                    37794.8
                  ],
                  [
                    54429.8,
                    37922.4
                  ],
                  [
                    54412.6,
                    38523.6
                  ],
                  [
                    54289.6,
                    38591.3
                  ],
                  [
                    54035.4,
                    38559.9
                  ],
                  [
                    54052.1,
                    37996.6
                  ]
                ],
                "id": 1076,
                "chat_link": "[&BDQEAAA=]"
              }
            },
            "id": 1106,
            "mastery_points": [],
            "adventures": []
          },
          "1116": {
            "name": "Deep Trouble",
            "min_level": 60,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              52480,
              38912
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "628": {
                "name": "The Mire Sea",
                "level": 67,
                "coord": [
                  53266.4,
                  39193.6
                ],
                "bounds": [
                  [
                    53159.7,
                    39398
                  ],
                  [
                    52697.9,
                    39135.6
                  ],
                  [
                    52680.7,
                    38944
                  ],
                  [
                    52757.6,
                    38730.2
                  ],
                  [
                    52993.3,
                    38773.5
                  ],
                  [
                    53056.9,
                    38915.5
                  ],
                  [
                    53230.1,
                    38890.3
                  ],
                  [
                    53368.6,
                    39021
                  ],
                  [
                    53650.1,
                    39074.5
                  ],
                  [
                    53898,
                    39345.2
                  ],
                  [
                    53817.2,
                    39399.3
                  ],
                  [
                    53676.3,
                    39702.6
                  ],
                  [
                    53425,
                    39666.5
                  ],
                  [
                    53318.8,
                    39713.9
                  ],
                  [
                    53159.7,
                    39398
                  ]
                ],
                "id": 628,
                "chat_link": "[&BHQCAAA=]"
              },
              "629": {
                "name": "Benthic Kelp Beds",
                "level": 68,
                "coord": [
                  54019.2,
                  39685.7
                ],
                "bounds": [
                  [
                    53743.2,
                    39840.5
                  ],
                  [
                    53749.3,
                    39781.8
                  ],
                  [
                    53676.3,
                    39699.6
                  ],
                  [
                    53816.3,
                    39395.5
                  ],
                  [
                    53895.6,
                    39343.7
                  ],
                  [
                    54118.2,
                    39358.2
                  ],
                  [
                    54245.3,
                    39162
                  ],
                  [
                    54309.1,
                    39267.7
                  ],
                  [
                    54299.6,
                    39771.7
                  ],
                  [
                    54215.3,
                    39832.8
                  ],
                  [
                    54154.5,
                    40119.1
                  ],
                  [
                    54079.6,
                    40175.3
                  ],
                  [
                    53947.3,
                    40166.8
                  ],
                  [
                    53743.2,
                    39840.5
                  ]
                ],
                "id": 629,
                "chat_link": "[&BHUCAAA=]"
              },
              "630": {
                "name": "Sunken Droknah",
                "level": 67,
                "coord": [
                  53578.4,
                  38885.4
                ],
                "bounds": [
                  [
                    53231.1,
                    38892
                  ],
                  [
                    53281.7,
                    38731.1
                  ],
                  [
                    53548.2,
                    38573.8
                  ],
                  [
                    53853.7,
                    38777.3
                  ],
                  [
                    53856.5,
                    38910.2
                  ],
                  [
                    53753.8,
                    38990.9
                  ],
                  [
                    53664.3,
                    38989
                  ],
                  [
                    53648.8,
                    39079.7
                  ],
                  [
                    53367.1,
                    39024.3
                  ],
                  [
                    53231.1,
                    38892
                  ]
                ],
                "id": 630,
                "chat_link": "[&BHYCAAA=]"
              },
              "631": {
                "name": "Irwin Isle",
                "level": 67,
                "coord": [
                  52783.6,
                  39451.8
                ],
                "bounds": [
                  [
                    52787,
                    39896.7
                  ],
                  [
                    52683.9,
                    39684.1
                  ],
                  [
                    52666,
                    39501.3
                  ],
                  [
                    52508.6,
                    39404.4
                  ],
                  [
                    52435.5,
                    39293.3
                  ],
                  [
                    52429.4,
                    39100.1
                  ],
                  [
                    52489.2,
                    38946.1
                  ],
                  [
                    52685.5,
                    38940.8
                  ],
                  [
                    52699.4,
                    39129.2
                  ],
                  [
                    53162.5,
                    39399.5
                  ],
                  [
                    53317.8,
                    39712.4
                  ],
                  [
                    53260.9,
                    39893.2
                  ],
                  [
                    53061.3,
                    39972.3
                  ],
                  [
                    52787,
                    39896.7
                  ]
                ],
                "id": 631,
                "chat_link": "[&BHcCAAA=]"
              },
              "632": {
                "name": "The Stychs",
                "level": 67,
                "coord": [
                  53332.4,
                  39924.5
                ],
                "bounds": [
                  [
                    53261.1,
                    39892.5
                  ],
                  [
                    53319.5,
                    39712.5
                  ],
                  [
                    53424.8,
                    39666.6
                  ],
                  [
                    53676.9,
                    39701.1
                  ],
                  [
                    53749.1,
                    39781
                  ],
                  [
                    53743.2,
                    39839.3
                  ],
                  [
                    53942.1,
                    40160.2
                  ],
                  [
                    53377.2,
                    40137
                  ],
                  [
                    53242.8,
                    40096.5
                  ],
                  [
                    53011.7,
                    40143.6
                  ],
                  [
                    52725.9,
                    40024
                  ],
                  [
                    52785.9,
                    39890.9
                  ],
                  [
                    53060.5,
                    39973.4
                  ],
                  [
                    53261.1,
                    39892.5
                  ]
                ],
                "id": 632,
                "chat_link": "[&BHgCAAA=]"
              },
              "633": {
                "name": "Dysphoric Rim",
                "level": 65,
                "coord": [
                  51324,
                  39659.2
                ],
                "bounds": [
                  [
                    51092.6,
                    39913.1
                  ],
                  [
                    50929.2,
                    39460.8
                  ],
                  [
                    51129.6,
                    39205.5
                  ],
                  [
                    51450.7,
                    39294.2
                  ],
                  [
                    51479.2,
                    39562.4
                  ],
                  [
                    51511,
                    39734.5
                  ],
                  [
                    51582,
                    39791.9
                  ],
                  [
                    51472.5,
                    39971
                  ],
                  [
                    51269.6,
                    39999.1
                  ],
                  [
                    51092.6,
                    39913.1
                  ]
                ],
                "id": 633,
                "chat_link": "[&BHkCAAA=]"
              },
              "634": {
                "name": "Murkvale",
                "level": 65,
                "coord": [
                  50745.4,
                  39658.6
                ],
                "bounds": [
                  [
                    50974.3,
                    40160.4
                  ],
                  [
                    50836.6,
                    40095.1
                  ],
                  [
                    50688.7,
                    40120
                  ],
                  [
                    50544.1,
                    40088.8
                  ],
                  [
                    50518.2,
                    39975.4
                  ],
                  [
                    50520.8,
                    39804.2
                  ],
                  [
                    50557.1,
                    39734.8
                  ],
                  [
                    50555.3,
                    39558.1
                  ],
                  [
                    50535.4,
                    39463.1
                  ],
                  [
                    50497.6,
                    39258.6
                  ],
                  [
                    50544.3,
                    39117
                  ],
                  [
                    50631.2,
                    39101.8
                  ],
                  [
                    51027.7,
                    39071.5
                  ],
                  [
                    51125.7,
                    39205.6
                  ],
                  [
                    50932.3,
                    39463.3
                  ],
                  [
                    51090.4,
                    39908.7
                  ],
                  [
                    51091.7,
                    40070
                  ],
                  [
                    50974.3,
                    40160.4
                  ]
                ],
                "id": 634,
                "chat_link": "[&BHoCAAA=]"
              },
              "635": {
                "name": "Judgment Rock",
                "level": 69,
                "coord": [
                  54312.3,
                  40017.9
                ],
                "bounds": [
                  [
                    54156.4,
                    40116.7
                  ],
                  [
                    54214.5,
                    39831.3
                  ],
                  [
                    54299.1,
                    39770.5
                  ],
                  [
                    54352.6,
                    39943.3
                  ],
                  [
                    54360.5,
                    40079
                  ],
                  [
                    54399.9,
                    40065.3
                  ],
                  [
                    54399,
                    40135
                  ],
                  [
                    54347,
                    40142.3
                  ],
                  [
                    54281.5,
                    40077.8
                  ],
                  [
                    54156.4,
                    40116.7
                  ]
                ],
                "id": 635,
                "chat_link": "[&BHsCAAA=]"
              },
              "636": {
                "name": "Gauntlet Gulch",
                "level": 67,
                "coord": [
                  53045.6,
                  38288.9
                ],
                "bounds": [
                  [
                    52756.9,
                    38736.3
                  ],
                  [
                    52604.1,
                    38531.3
                  ],
                  [
                    52689.6,
                    38354.4
                  ],
                  [
                    52703.1,
                    38126.3
                  ],
                  [
                    52813.3,
                    38053.6
                  ],
                  [
                    52860.5,
                    37969.4
                  ],
                  [
                    52816.7,
                    37762.1
                  ],
                  [
                    52952.9,
                    37731.9
                  ],
                  [
                    53117.2,
                    37741.5
                  ],
                  [
                    53385.1,
                    37839.3
                  ],
                  [
                    53322.2,
                    37927.1
                  ],
                  [
                    53327.6,
                    38054.4
                  ],
                  [
                    53358.3,
                    38463.2
                  ],
                  [
                    53547.9,
                    38579
                  ],
                  [
                    53285,
                    38733.5
                  ],
                  [
                    53229.6,
                    38895.4
                  ],
                  [
                    53057.5,
                    38920.5
                  ],
                  [
                    52993.1,
                    38780.4
                  ],
                  [
                    52756.9,
                    38736.3
                  ]
                ],
                "id": 636,
                "chat_link": "[&BHwCAAA=]"
              },
              "637": {
                "name": "Govoran Terraces",
                "level": 63,
                "coord": [
                  50860.2,
                  38065.1
                ],
                "bounds": [
                  [
                    50489.6,
                    38081.8
                  ],
                  [
                    50523.3,
                    37970
                  ],
                  [
                    50668.6,
                    38089.1
                  ],
                  [
                    50766.7,
                    38006.8
                  ],
                  [
                    50931.6,
                    37816.3
                  ],
                  [
                    51013.7,
                    37804.3
                  ],
                  [
                    51225.5,
                    37821.3
                  ],
                  [
                    51265,
                    37941
                  ],
                  [
                    51290,
                    38014.9
                  ],
                  [
                    51273.8,
                    38309.4
                  ],
                  [
                    50608.3,
                    38449.9
                  ],
                  [
                    50558.1,
                    38362.1
                  ],
                  [
                    50568.9,
                    38179.8
                  ],
                  [
                    50489.6,
                    38081.8
                  ]
                ],
                "id": 637,
                "chat_link": "[&BH0CAAA=]"
              },
              "638": {
                "name": "Broken Arrow River",
                "level": 61,
                "coord": [
                  52475.9,
                  38261.5
                ],
                "bounds": [
                  [
                    52251.8,
                    38508
                  ],
                  [
                    52066.3,
                    37885.1
                  ],
                  [
                    52103.4,
                    37745
                  ],
                  [
                    52267.9,
                    37695.8
                  ],
                  [
                    52519.5,
                    37758.1
                  ],
                  [
                    52571.8,
                    37916.7
                  ],
                  [
                    52702.4,
                    38126.7
                  ],
                  [
                    52688.8,
                    38354.3
                  ],
                  [
                    52604.6,
                    38531.3
                  ],
                  [
                    52763.3,
                    38725
                  ],
                  [
                    52682.1,
                    38946
                  ],
                  [
                    52489.3,
                    38946.5
                  ],
                  [
                    52251.8,
                    38508
                  ]
                ],
                "id": 638,
                "chat_link": "[&BH4CAAA=]"
              },
              "639": {
                "name": "Quandry Scratch",
                "level": 62,
                "coord": [
                  51391.4,
                  38064.7
                ],
                "bounds": [
                  [
                    51339.3,
                    38479.8
                  ],
                  [
                    51269.8,
                    38311.5
                  ],
                  [
                    51289.8,
                    38015.7
                  ],
                  [
                    51261.3,
                    37940.4
                  ],
                  [
                    51223,
                    37825.6
                  ],
                  [
                    51371.3,
                    37770.5
                  ],
                  [
                    51585.5,
                    37779.7
                  ],
                  [
                    51687.1,
                    37920.1
                  ],
                  [
                    51496.1,
                    38538.7
                  ],
                  [
                    51339.3,
                    38479.8
                  ]
                ],
                "id": 639,
                "chat_link": "[&BH8CAAA=]"
              },
              "640": {
                "name": "Bard's Valley",
                "level": 61,
                "coord": [
                  51861.6,
                  38159.3
                ],
                "bounds": [
                  [
                    51494.8,
                    38532.7
                  ],
                  [
                    51686.7,
                    37917.9
                  ],
                  [
                    51661.9,
                    37800.5
                  ],
                  [
                    51848.2,
                    37754.1
                  ],
                  [
                    52018.3,
                    37775.4
                  ],
                  [
                    52068.3,
                    37884
                  ],
                  [
                    52255.5,
                    38510.9
                  ],
                  [
                    51947.8,
                    38554.3
                  ],
                  [
                    51773.3,
                    38704.2
                  ],
                  [
                    51494.8,
                    38532.7
                  ]
                ],
                "id": 640,
                "chat_link": "[&BIACAAA=]"
              },
              "641": {
                "name": "Criterion Canyon",
                "level": 63,
                "coord": [
                  50955.3,
                  38714.6
                ],
                "bounds": [
                  [
                    50630.6,
                    39103.2
                  ],
                  [
                    50566,
                    39071.7
                  ],
                  [
                    50532.7,
                    38844.7
                  ],
                  [
                    50537.2,
                    38621.4
                  ],
                  [
                    50590.9,
                    38512.8
                  ],
                  [
                    50609.6,
                    38453.3
                  ],
                  [
                    51273.7,
                    38310
                  ],
                  [
                    51342.1,
                    38472.2
                  ],
                  [
                    51495.4,
                    38533.5
                  ],
                  [
                    51426.9,
                    38677.8
                  ],
                  [
                    51242.3,
                    38785
                  ],
                  [
                    51143.2,
                    38834
                  ],
                  [
                    51027.8,
                    39070.2
                  ],
                  [
                    50630.6,
                    39103.2
                  ]
                ],
                "id": 641,
                "chat_link": "[&BIECAAA=]"
              },
              "642": {
                "name": "Whitland Flats",
                "level": 68,
                "coord": [
                  53950.1,
                  38930.3
                ],
                "bounds": [
                  [
                    53894.8,
                    39345.8
                  ],
                  [
                    53651.5,
                    39080.2
                  ],
                  [
                    53660.9,
                    38988.3
                  ],
                  [
                    53752.8,
                    38984.3
                  ],
                  [
                    53852.6,
                    38911.5
                  ],
                  [
                    53853.5,
                    38778.1
                  ],
                  [
                    53736.9,
                    38701.6
                  ],
                  [
                    54033.1,
                    38560.7
                  ],
                  [
                    54151.3,
                    38574
                  ],
                  [
                    54339.3,
                    38863.8
                  ],
                  [
                    54357.5,
                    39012.8
                  ],
                  [
                    54116.9,
                    39362.1
                  ],
                  [
                    53894.8,
                    39345.8
                  ]
                ],
                "id": 642,
                "chat_link": "[&BIICAAA=]"
              },
              "643": {
                "name": "Unguent Den",
                "level": 68,
                "coord": [
                  52701.2,
                  37882.1
                ],
                "bounds": [
                  [
                    52701.4,
                    38127.8
                  ],
                  [
                    52572.9,
                    37917.9
                  ],
                  [
                    52519.3,
                    37756.1
                  ],
                  [
                    52592.4,
                    37735.9
                  ],
                  [
                    52731.4,
                    37736.3
                  ],
                  [
                    52816.7,
                    37761.9
                  ],
                  [
                    52860.6,
                    37968.6
                  ],
                  [
                    52814.8,
                    38052.5
                  ],
                  [
                    52701.4,
                    38127.8
                  ]
                ],
                "id": 643,
                "chat_link": "[&BIMCAAA=]"
              },
              "644": {
                "name": "Magmatic Conjury",
                "level": 65,
                "coord": [
                  51653.8,
                  39744.7
                ],
                "bounds": [
                  [
                    51800.1,
                    39887.6
                  ],
                  [
                    51658.3,
                    39850.4
                  ],
                  [
                    51582.2,
                    39790.5
                  ],
                  [
                    51513,
                    39733.1
                  ],
                  [
                    51479.1,
                    39563.8
                  ],
                  [
                    51700,
                    39681.4
                  ],
                  [
                    51843.8,
                    39706
                  ],
                  [
                    51800.1,
                    39887.6
                  ]
                ],
                "id": 644,
                "chat_link": "[&BIQCAAA=]"
              },
              "645": {
                "name": "Maelstrom's Bile",
                "level": 66,
                "coord": [
                  51805.5,
                  39351.4
                ],
                "bounds": [
                  [
                    51699.1,
                    39683.2
                  ],
                  [
                    51480.4,
                    39560.8
                  ],
                  [
                    51451.9,
                    39298.6
                  ],
                  [
                    51513.4,
                    39136.7
                  ],
                  [
                    51626.5,
                    38966.4
                  ],
                  [
                    51798.4,
                    38900.2
                  ],
                  [
                    51996.1,
                    39056.3
                  ],
                  [
                    52180.9,
                    39197.3
                  ],
                  [
                    52235.5,
                    39416.3
                  ],
                  [
                    51999.2,
                    39638.3
                  ],
                  [
                    51842.7,
                    39655.2
                  ],
                  [
                    51841.6,
                    39707.5
                  ],
                  [
                    51699.1,
                    39683.2
                  ]
                ],
                "id": 645,
                "chat_link": "[&BIUCAAA=]"
              },
              "646": {
                "name": "Sootberme",
                "level": 64,
                "coord": [
                  51446.6,
                  38907.6
                ],
                "bounds": [
                  [
                    51027,
                    39079.3
                  ],
                  [
                    51135.2,
                    38832
                  ],
                  [
                    51241.4,
                    38786.5
                  ],
                  [
                    51427.3,
                    38671.9
                  ],
                  [
                    51497.2,
                    38531.4
                  ],
                  [
                    51773.6,
                    38703.1
                  ],
                  [
                    51738.9,
                    38779.7
                  ],
                  [
                    51799.9,
                    38898.5
                  ],
                  [
                    51628.2,
                    38965.6
                  ],
                  [
                    51512.7,
                    39136.6
                  ],
                  [
                    51451.9,
                    39295.1
                  ],
                  [
                    51126.1,
                    39212.1
                  ],
                  [
                    51027,
                    39079.3
                  ]
                ],
                "id": 646,
                "chat_link": "[&BIYCAAA=]"
              },
              "647": {
                "name": "Ashen Waste",
                "level": 65,
                "coord": [
                  52169.8,
                  39023.4
                ],
                "bounds": [
                  [
                    51737.4,
                    38779.8
                  ],
                  [
                    51771.6,
                    38702.9
                  ],
                  [
                    51947.1,
                    38554.7
                  ],
                  [
                    52255.3,
                    38509.3
                  ],
                  [
                    52489.8,
                    38950.5
                  ],
                  [
                    52431.9,
                    39105.5
                  ],
                  [
                    52437.9,
                    39290.7
                  ],
                  [
                    52507.8,
                    39396.6
                  ],
                  [
                    52424.2,
                    39432
                  ],
                  [
                    52236,
                    39421
                  ],
                  [
                    52177,
                    39199.3
                  ],
                  [
                    51993.5,
                    39057
                  ],
                  [
                    51797.5,
                    38904.3
                  ],
                  [
                    51737.4,
                    38779.8
                  ]
                ],
                "id": 647,
                "chat_link": "[&BIcCAAA=]"
              },
              "648": {
                "name": "Avernan Volatile",
                "level": 65,
                "coord": [
                  52483.6,
                  39673.6
                ],
                "bounds": [
                  [
                    52059,
                    39590.5
                  ],
                  [
                    52233.1,
                    39420.1
                  ],
                  [
                    52424.7,
                    39434.2
                  ],
                  [
                    52508.6,
                    39392
                  ],
                  [
                    52672.1,
                    39500.4
                  ],
                  [
                    52686.5,
                    39689.1
                  ],
                  [
                    52785.4,
                    39894.4
                  ],
                  [
                    52726.7,
                    40025.6
                  ],
                  [
                    52255.8,
                    40115.8
                  ],
                  [
                    52059,
                    39590.5
                  ]
                ],
                "id": 648,
                "chat_link": "[&BIgCAAA=]"
              },
              "649": {
                "name": "Mon Maelstrom",
                "level": 65,
                "coord": [
                  51785.3,
                  39881.4
                ],
                "bounds": [
                  [
                    51876.6,
                    40154.4
                  ],
                  [
                    51554.4,
                    40142.3
                  ],
                  [
                    51483.7,
                    40073.1
                  ],
                  [
                    51472.6,
                    39969.7
                  ],
                  [
                    51583.5,
                    39790.1
                  ],
                  [
                    51657.6,
                    39850.4
                  ],
                  [
                    51800,
                    39887.6
                  ],
                  [
                    51841.2,
                    39708.1
                  ],
                  [
                    51840.2,
                    39655.3
                  ],
                  [
                    51997.9,
                    39641
                  ],
                  [
                    52057.7,
                    39591.7
                  ],
                  [
                    52257.9,
                    40113
                  ],
                  [
                    51876.6,
                    40154.4
                  ]
                ],
                "id": 649,
                "chat_link": "[&BIkCAAA=]"
              },
              "651": {
                "name": "Infinity Coil",
                "level": 69,
                "coord": [
                  53696.3,
                  38071.6
                ],
                "bounds": [
                  [
                    53355.6,
                    38466.7
                  ],
                  [
                    53325.4,
                    38063.5
                  ],
                  [
                    53323.4,
                    37926.8
                  ],
                  [
                    53409.8,
                    37802.4
                  ],
                  [
                    53670.2,
                    37693.6
                  ],
                  [
                    53964,
                    37706.2
                  ],
                  [
                    54089.4,
                    37796.4
                  ],
                  [
                    54053.9,
                    37995.7
                  ],
                  [
                    54034.7,
                    38561.9
                  ],
                  [
                    53736.9,
                    38702.5
                  ],
                  [
                    53355.6,
                    38466.7
                  ]
                ],
                "id": 651,
                "chat_link": "[&BIsCAAA=]"
              },
              "1059": {
                "name": "Cubular Fells",
                "level": 62,
                "coord": [
                  50714.5,
                  37913.5
                ],
                "bounds": [
                  [
                    50526.4,
                    37969.6
                  ],
                  [
                    50668.6,
                    38089.9
                  ],
                  [
                    50767.4,
                    38007.1
                  ],
                  [
                    50894,
                    37861
                  ],
                  [
                    50809.1,
                    37774.6
                  ],
                  [
                    50621.7,
                    37778.6
                  ],
                  [
                    50526.4,
                    37969.6
                  ]
                ],
                "id": 1059,
                "chat_link": "[&BCMEAAA=]"
              },
              "1076": {
                "name": "Dierdre's Steps",
                "level": 69,
                "coord": [
                  54218.1,
                  38231.4
                ],
                "bounds": [
                  [
                    54052.1,
                    37996.6
                  ],
                  [
                    54089.3,
                    37794.8
                  ],
                  [
                    54429.8,
                    37922.4
                  ],
                  [
                    54412.6,
                    38523.6
                  ],
                  [
                    54289.6,
                    38591.3
                  ],
                  [
                    54035.4,
                    38559.9
                  ],
                  [
                    54052.1,
                    37996.6
                  ]
                ],
                "id": 1076,
                "chat_link": "[&BDQEAAA=]"
              }
            },
            "id": 1116,
            "mastery_points": [],
            "adventures": []
          },
          "1130": {
            "name": "Deep Trouble",
            "min_level": 60,
            "max_level": 70,
            "default_floor": 1,
            "label_coord": [
              52480,
              38912
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "628": {
                "name": "The Mire Sea",
                "level": 67,
                "coord": [
                  53266.4,
                  39193.6
                ],
                "bounds": [
                  [
                    53159.7,
                    39398
                  ],
                  [
                    52697.9,
                    39135.6
                  ],
                  [
                    52680.7,
                    38944
                  ],
                  [
                    52757.6,
                    38730.2
                  ],
                  [
                    52993.3,
                    38773.5
                  ],
                  [
                    53056.9,
                    38915.5
                  ],
                  [
                    53230.1,
                    38890.3
                  ],
                  [
                    53368.6,
                    39021
                  ],
                  [
                    53650.1,
                    39074.5
                  ],
                  [
                    53898,
                    39345.2
                  ],
                  [
                    53817.2,
                    39399.3
                  ],
                  [
                    53676.3,
                    39702.6
                  ],
                  [
                    53425,
                    39666.5
                  ],
                  [
                    53318.8,
                    39713.9
                  ],
                  [
                    53159.7,
                    39398
                  ]
                ],
                "id": 628,
                "chat_link": "[&BHQCAAA=]"
              },
              "629": {
                "name": "Benthic Kelp Beds",
                "level": 68,
                "coord": [
                  54019.2,
                  39685.7
                ],
                "bounds": [
                  [
                    53743.2,
                    39840.5
                  ],
                  [
                    53749.3,
                    39781.8
                  ],
                  [
                    53676.3,
                    39699.6
                  ],
                  [
                    53816.3,
                    39395.5
                  ],
                  [
                    53895.6,
                    39343.7
                  ],
                  [
                    54118.2,
                    39358.2
                  ],
                  [
                    54245.3,
                    39162
                  ],
                  [
                    54309.1,
                    39267.7
                  ],
                  [
                    54299.6,
                    39771.7
                  ],
                  [
                    54215.3,
                    39832.8
                  ],
                  [
                    54154.5,
                    40119.1
                  ],
                  [
                    54079.6,
                    40175.3
                  ],
                  [
                    53947.3,
                    40166.8
                  ],
                  [
                    53743.2,
                    39840.5
                  ]
                ],
                "id": 629,
                "chat_link": "[&BHUCAAA=]"
              },
              "630": {
                "name": "Sunken Droknah",
                "level": 67,
                "coord": [
                  53578.4,
                  38885.4
                ],
                "bounds": [
                  [
                    53231.1,
                    38892
                  ],
                  [
                    53281.7,
                    38731.1
                  ],
                  [
                    53548.2,
                    38573.8
                  ],
                  [
                    53853.7,
                    38777.3
                  ],
                  [
                    53856.5,
                    38910.2
                  ],
                  [
                    53753.8,
                    38990.9
                  ],
                  [
                    53664.3,
                    38989
                  ],
                  [
                    53648.8,
                    39079.7
                  ],
                  [
                    53367.1,
                    39024.3
                  ],
                  [
                    53231.1,
                    38892
                  ]
                ],
                "id": 630,
                "chat_link": "[&BHYCAAA=]"
              },
              "631": {
                "name": "Irwin Isle",
                "level": 67,
                "coord": [
                  52783.6,
                  39451.8
                ],
                "bounds": [
                  [
                    52787,
                    39896.7
                  ],
                  [
                    52683.9,
                    39684.1
                  ],
                  [
                    52666,
                    39501.3
                  ],
                  [
                    52508.6,
                    39404.4
                  ],
                  [
                    52435.5,
                    39293.3
                  ],
                  [
                    52429.4,
                    39100.1
                  ],
                  [
                    52489.2,
                    38946.1
                  ],
                  [
                    52685.5,
                    38940.8
                  ],
                  [
                    52699.4,
                    39129.2
                  ],
                  [
                    53162.5,
                    39399.5
                  ],
                  [
                    53317.8,
                    39712.4
                  ],
                  [
                    53260.9,
                    39893.2
                  ],
                  [
                    53061.3,
                    39972.3
                  ],
                  [
                    52787,
                    39896.7
                  ]
                ],
                "id": 631,
                "chat_link": "[&BHcCAAA=]"
              },
              "632": {
                "name": "The Stychs",
                "level": 67,
                "coord": [
                  53332.4,
                  39924.5
                ],
                "bounds": [
                  [
                    53261.1,
                    39892.5
                  ],
                  [
                    53319.5,
                    39712.5
                  ],
                  [
                    53424.8,
                    39666.6
                  ],
                  [
                    53676.9,
                    39701.1
                  ],
                  [
                    53749.1,
                    39781
                  ],
                  [
                    53743.2,
                    39839.3
                  ],
                  [
                    53942.1,
                    40160.2
                  ],
                  [
                    53377.2,
                    40137
                  ],
                  [
                    53242.8,
                    40096.5
                  ],
                  [
                    53011.7,
                    40143.6
                  ],
                  [
                    52725.9,
                    40024
                  ],
                  [
                    52785.9,
                    39890.9
                  ],
                  [
                    53060.5,
                    39973.4
                  ],
                  [
                    53261.1,
                    39892.5
                  ]
                ],
                "id": 632,
                "chat_link": "[&BHgCAAA=]"
              },
              "633": {
                "name": "Dysphoric Rim",
                "level": 65,
                "coord": [
                  51324,
                  39659.2
                ],
                "bounds": [
                  [
                    51092.6,
                    39913.1
                  ],
                  [
                    50929.2,
                    39460.8
                  ],
                  [
                    51129.6,
                    39205.5
                  ],
                  [
                    51450.7,
                    39294.2
                  ],
                  [
                    51479.2,
                    39562.4
                  ],
                  [
                    51511,
                    39734.5
                  ],
                  [
                    51582,
                    39791.9
                  ],
                  [
                    51472.5,
                    39971
                  ],
                  [
                    51269.6,
                    39999.1
                  ],
                  [
                    51092.6,
                    39913.1
                  ]
                ],
                "id": 633,
                "chat_link": "[&BHkCAAA=]"
              },
              "634": {
                "name": "Murkvale",
                "level": 65,
                "coord": [
                  50745.4,
                  39658.6
                ],
                "bounds": [
                  [
                    50974.3,
                    40160.4
                  ],
                  [
                    50836.6,
                    40095.1
                  ],
                  [
                    50688.7,
                    40120
                  ],
                  [
                    50544.1,
                    40088.8
                  ],
                  [
                    50518.2,
                    39975.4
                  ],
                  [
                    50520.8,
                    39804.2
                  ],
                  [
                    50557.1,
                    39734.8
                  ],
                  [
                    50555.3,
                    39558.1
                  ],
                  [
                    50535.4,
                    39463.1
                  ],
                  [
                    50497.6,
                    39258.6
                  ],
                  [
                    50544.3,
                    39117
                  ],
                  [
                    50631.2,
                    39101.8
                  ],
                  [
                    51027.7,
                    39071.5
                  ],
                  [
                    51125.7,
                    39205.6
                  ],
                  [
                    50932.3,
                    39463.3
                  ],
                  [
                    51090.4,
                    39908.7
                  ],
                  [
                    51091.7,
                    40070
                  ],
                  [
                    50974.3,
                    40160.4
                  ]
                ],
                "id": 634,
                "chat_link": "[&BHoCAAA=]"
              },
              "635": {
                "name": "Judgment Rock",
                "level": 69,
                "coord": [
                  54312.3,
                  40017.9
                ],
                "bounds": [
                  [
                    54156.4,
                    40116.7
                  ],
                  [
                    54214.5,
                    39831.3
                  ],
                  [
                    54299.1,
                    39770.5
                  ],
                  [
                    54352.6,
                    39943.3
                  ],
                  [
                    54360.5,
                    40079
                  ],
                  [
                    54399.9,
                    40065.3
                  ],
                  [
                    54399,
                    40135
                  ],
                  [
                    54347,
                    40142.3
                  ],
                  [
                    54281.5,
                    40077.8
                  ],
                  [
                    54156.4,
                    40116.7
                  ]
                ],
                "id": 635,
                "chat_link": "[&BHsCAAA=]"
              },
              "636": {
                "name": "Gauntlet Gulch",
                "level": 67,
                "coord": [
                  53045.6,
                  38288.9
                ],
                "bounds": [
                  [
                    52756.9,
                    38736.3
                  ],
                  [
                    52604.1,
                    38531.3
                  ],
                  [
                    52689.6,
                    38354.4
                  ],
                  [
                    52703.1,
                    38126.3
                  ],
                  [
                    52813.3,
                    38053.6
                  ],
                  [
                    52860.5,
                    37969.4
                  ],
                  [
                    52816.7,
                    37762.1
                  ],
                  [
                    52952.9,
                    37731.9
                  ],
                  [
                    53117.2,
                    37741.5
                  ],
                  [
                    53385.1,
                    37839.3
                  ],
                  [
                    53322.2,
                    37927.1
                  ],
                  [
                    53327.6,
                    38054.4
                  ],
                  [
                    53358.3,
                    38463.2
                  ],
                  [
                    53547.9,
                    38579
                  ],
                  [
                    53285,
                    38733.5
                  ],
                  [
                    53229.6,
                    38895.4
                  ],
                  [
                    53057.5,
                    38920.5
                  ],
                  [
                    52993.1,
                    38780.4
                  ],
                  [
                    52756.9,
                    38736.3
                  ]
                ],
                "id": 636,
                "chat_link": "[&BHwCAAA=]"
              },
              "637": {
                "name": "Govoran Terraces",
                "level": 63,
                "coord": [
                  50860.2,
                  38065.1
                ],
                "bounds": [
                  [
                    50489.6,
                    38081.8
                  ],
                  [
                    50523.3,
                    37970
                  ],
                  [
                    50668.6,
                    38089.1
                  ],
                  [
                    50766.7,
                    38006.8
                  ],
                  [
                    50931.6,
                    37816.3
                  ],
                  [
                    51013.7,
                    37804.3
                  ],
                  [
                    51225.5,
                    37821.3
                  ],
                  [
                    51265,
                    37941
                  ],
                  [
                    51290,
                    38014.9
                  ],
                  [
                    51273.8,
                    38309.4
                  ],
                  [
                    50608.3,
                    38449.9
                  ],
                  [
                    50558.1,
                    38362.1
                  ],
                  [
                    50568.9,
                    38179.8
                  ],
                  [
                    50489.6,
                    38081.8
                  ]
                ],
                "id": 637,
                "chat_link": "[&BH0CAAA=]"
              },
              "638": {
                "name": "Broken Arrow River",
                "level": 61,
                "coord": [
                  52475.9,
                  38261.5
                ],
                "bounds": [
                  [
                    52251.8,
                    38508
                  ],
                  [
                    52066.3,
                    37885.1
                  ],
                  [
                    52103.4,
                    37745
                  ],
                  [
                    52267.9,
                    37695.8
                  ],
                  [
                    52519.5,
                    37758.1
                  ],
                  [
                    52571.8,
                    37916.7
                  ],
                  [
                    52702.4,
                    38126.7
                  ],
                  [
                    52688.8,
                    38354.3
                  ],
                  [
                    52604.6,
                    38531.3
                  ],
                  [
                    52763.3,
                    38725
                  ],
                  [
                    52682.1,
                    38946
                  ],
                  [
                    52489.3,
                    38946.5
                  ],
                  [
                    52251.8,
                    38508
                  ]
                ],
                "id": 638,
                "chat_link": "[&BH4CAAA=]"
              },
              "639": {
                "name": "Quandry Scratch",
                "level": 62,
                "coord": [
                  51391.4,
                  38064.7
                ],
                "bounds": [
                  [
                    51339.3,
                    38479.8
                  ],
                  [
                    51269.8,
                    38311.5
                  ],
                  [
                    51289.8,
                    38015.7
                  ],
                  [
                    51261.3,
                    37940.4
                  ],
                  [
                    51223,
                    37825.6
                  ],
                  [
                    51371.3,
                    37770.5
                  ],
                  [
                    51585.5,
                    37779.7
                  ],
                  [
                    51687.1,
                    37920.1
                  ],
                  [
                    51496.1,
                    38538.7
                  ],
                  [
                    51339.3,
                    38479.8
                  ]
                ],
                "id": 639,
                "chat_link": "[&BH8CAAA=]"
              },
              "640": {
                "name": "Bard's Valley",
                "level": 61,
                "coord": [
                  51861.6,
                  38159.3
                ],
                "bounds": [
                  [
                    51494.8,
                    38532.7
                  ],
                  [
                    51686.7,
                    37917.9
                  ],
                  [
                    51661.9,
                    37800.5
                  ],
                  [
                    51848.2,
                    37754.1
                  ],
                  [
                    52018.3,
                    37775.4
                  ],
                  [
                    52068.3,
                    37884
                  ],
                  [
                    52255.5,
                    38510.9
                  ],
                  [
                    51947.8,
                    38554.3
                  ],
                  [
                    51773.3,
                    38704.2
                  ],
                  [
                    51494.8,
                    38532.7
                  ]
                ],
                "id": 640,
                "chat_link": "[&BIACAAA=]"
              },
              "641": {
                "name": "Criterion Canyon",
                "level": 63,
                "coord": [
                  50955.3,
                  38714.6
                ],
                "bounds": [
                  [
                    50630.6,
                    39103.2
                  ],
                  [
                    50566,
                    39071.7
                  ],
                  [
                    50532.7,
                    38844.7
                  ],
                  [
                    50537.2,
                    38621.4
                  ],
                  [
                    50590.9,
                    38512.8
                  ],
                  [
                    50609.6,
                    38453.3
                  ],
                  [
                    51273.7,
                    38310
                  ],
                  [
                    51342.1,
                    38472.2
                  ],
                  [
                    51495.4,
                    38533.5
                  ],
                  [
                    51426.9,
                    38677.8
                  ],
                  [
                    51242.3,
                    38785
                  ],
                  [
                    51143.2,
                    38834
                  ],
                  [
                    51027.8,
                    39070.2
                  ],
                  [
                    50630.6,
                    39103.2
                  ]
                ],
                "id": 641,
                "chat_link": "[&BIECAAA=]"
              },
              "642": {
                "name": "Whitland Flats",
                "level": 68,
                "coord": [
                  53950.1,
                  38930.3
                ],
                "bounds": [
                  [
                    53894.8,
                    39345.8
                  ],
                  [
                    53651.5,
                    39080.2
                  ],
                  [
                    53660.9,
                    38988.3
                  ],
                  [
                    53752.8,
                    38984.3
                  ],
                  [
                    53852.6,
                    38911.5
                  ],
                  [
                    53853.5,
                    38778.1
                  ],
                  [
                    53736.9,
                    38701.6
                  ],
                  [
                    54033.1,
                    38560.7
                  ],
                  [
                    54151.3,
                    38574
                  ],
                  [
                    54339.3,
                    38863.8
                  ],
                  [
                    54357.5,
                    39012.8
                  ],
                  [
                    54116.9,
                    39362.1
                  ],
                  [
                    53894.8,
                    39345.8
                  ]
                ],
                "id": 642,
                "chat_link": "[&BIICAAA=]"
              },
              "643": {
                "name": "Unguent Den",
                "level": 68,
                "coord": [
                  52701.2,
                  37882.1
                ],
                "bounds": [
                  [
                    52701.4,
                    38127.8
                  ],
                  [
                    52572.9,
                    37917.9
                  ],
                  [
                    52519.3,
                    37756.1
                  ],
                  [
                    52592.4,
                    37735.9
                  ],
                  [
                    52731.4,
                    37736.3
                  ],
                  [
                    52816.7,
                    37761.9
                  ],
                  [
                    52860.6,
                    37968.6
                  ],
                  [
                    52814.8,
                    38052.5
                  ],
                  [
                    52701.4,
                    38127.8
                  ]
                ],
                "id": 643,
                "chat_link": "[&BIMCAAA=]"
              },
              "644": {
                "name": "Magmatic Conjury",
                "level": 65,
                "coord": [
                  51653.8,
                  39744.7
                ],
                "bounds": [
                  [
                    51800.1,
                    39887.6
                  ],
                  [
                    51658.3,
                    39850.4
                  ],
                  [
                    51582.2,
                    39790.5
                  ],
                  [
                    51513,
                    39733.1
                  ],
                  [
                    51479.1,
                    39563.8
                  ],
                  [
                    51700,
                    39681.4
                  ],
                  [
                    51843.8,
                    39706
                  ],
                  [
                    51800.1,
                    39887.6
                  ]
                ],
                "id": 644,
                "chat_link": "[&BIQCAAA=]"
              },
              "645": {
                "name": "Maelstrom's Bile",
                "level": 66,
                "coord": [
                  51805.5,
                  39351.4
                ],
                "bounds": [
                  [
                    51699.1,
                    39683.2
                  ],
                  [
                    51480.4,
                    39560.8
                  ],
                  [
                    51451.9,
                    39298.6
                  ],
                  [
                    51513.4,
                    39136.7
                  ],
                  [
                    51626.5,
                    38966.4
                  ],
                  [
                    51798.4,
                    38900.2
                  ],
                  [
                    51996.1,
                    39056.3
                  ],
                  [
                    52180.9,
                    39197.3
                  ],
                  [
                    52235.5,
                    39416.3
                  ],
                  [
                    51999.2,
                    39638.3
                  ],
                  [
                    51842.7,
                    39655.2
                  ],
                  [
                    51841.6,
                    39707.5
                  ],
                  [
                    51699.1,
                    39683.2
                  ]
                ],
                "id": 645,
                "chat_link": "[&BIUCAAA=]"
              },
              "646": {
                "name": "Sootberme",
                "level": 64,
                "coord": [
                  51446.6,
                  38907.6
                ],
                "bounds": [
                  [
                    51027,
                    39079.3
                  ],
                  [
                    51135.2,
                    38832
                  ],
                  [
                    51241.4,
                    38786.5
                  ],
                  [
                    51427.3,
                    38671.9
                  ],
                  [
                    51497.2,
                    38531.4
                  ],
                  [
                    51773.6,
                    38703.1
                  ],
                  [
                    51738.9,
                    38779.7
                  ],
                  [
                    51799.9,
                    38898.5
                  ],
                  [
                    51628.2,
                    38965.6
                  ],
                  [
                    51512.7,
                    39136.6
                  ],
                  [
                    51451.9,
                    39295.1
                  ],
                  [
                    51126.1,
                    39212.1
                  ],
                  [
                    51027,
                    39079.3
                  ]
                ],
                "id": 646,
                "chat_link": "[&BIYCAAA=]"
              },
              "647": {
                "name": "Ashen Waste",
                "level": 65,
                "coord": [
                  52169.8,
                  39023.4
                ],
                "bounds": [
                  [
                    51737.4,
                    38779.8
                  ],
                  [
                    51771.6,
                    38702.9
                  ],
                  [
                    51947.1,
                    38554.7
                  ],
                  [
                    52255.3,
                    38509.3
                  ],
                  [
                    52489.8,
                    38950.5
                  ],
                  [
                    52431.9,
                    39105.5
                  ],
                  [
                    52437.9,
                    39290.7
                  ],
                  [
                    52507.8,
                    39396.6
                  ],
                  [
                    52424.2,
                    39432
                  ],
                  [
                    52236,
                    39421
                  ],
                  [
                    52177,
                    39199.3
                  ],
                  [
                    51993.5,
                    39057
                  ],
                  [
                    51797.5,
                    38904.3
                  ],
                  [
                    51737.4,
                    38779.8
                  ]
                ],
                "id": 647,
                "chat_link": "[&BIcCAAA=]"
              },
              "648": {
                "name": "Avernan Volatile",
                "level": 65,
                "coord": [
                  52483.6,
                  39673.6
                ],
                "bounds": [
                  [
                    52059,
                    39590.5
                  ],
                  [
                    52233.1,
                    39420.1
                  ],
                  [
                    52424.7,
                    39434.2
                  ],
                  [
                    52508.6,
                    39392
                  ],
                  [
                    52672.1,
                    39500.4
                  ],
                  [
                    52686.5,
                    39689.1
                  ],
                  [
                    52785.4,
                    39894.4
                  ],
                  [
                    52726.7,
                    40025.6
                  ],
                  [
                    52255.8,
                    40115.8
                  ],
                  [
                    52059,
                    39590.5
                  ]
                ],
                "id": 648,
                "chat_link": "[&BIgCAAA=]"
              },
              "649": {
                "name": "Mon Maelstrom",
                "level": 65,
                "coord": [
                  51785.3,
                  39881.4
                ],
                "bounds": [
                  [
                    51876.6,
                    40154.4
                  ],
                  [
                    51554.4,
                    40142.3
                  ],
                  [
                    51483.7,
                    40073.1
                  ],
                  [
                    51472.6,
                    39969.7
                  ],
                  [
                    51583.5,
                    39790.1
                  ],
                  [
                    51657.6,
                    39850.4
                  ],
                  [
                    51800,
                    39887.6
                  ],
                  [
                    51841.2,
                    39708.1
                  ],
                  [
                    51840.2,
                    39655.3
                  ],
                  [
                    51997.9,
                    39641
                  ],
                  [
                    52057.7,
                    39591.7
                  ],
                  [
                    52257.9,
                    40113
                  ],
                  [
                    51876.6,
                    40154.4
                  ]
                ],
                "id": 649,
                "chat_link": "[&BIkCAAA=]"
              },
              "651": {
                "name": "Infinity Coil",
                "level": 69,
                "coord": [
                  53696.3,
                  38071.6
                ],
                "bounds": [
                  [
                    53355.6,
                    38466.7
                  ],
                  [
                    53325.4,
                    38063.5
                  ],
                  [
                    53323.4,
                    37926.8
                  ],
                  [
                    53409.8,
                    37802.4
                  ],
                  [
                    53670.2,
                    37693.6
                  ],
                  [
                    53964,
                    37706.2
                  ],
                  [
                    54089.4,
                    37796.4
                  ],
                  [
                    54053.9,
                    37995.7
                  ],
                  [
                    54034.7,
                    38561.9
                  ],
                  [
                    53736.9,
                    38702.5
                  ],
                  [
                    53355.6,
                    38466.7
                  ]
                ],
                "id": 651,
                "chat_link": "[&BIsCAAA=]"
              },
              "1059": {
                "name": "Cubular Fells",
                "level": 62,
                "coord": [
                  50714.5,
                  37913.5
                ],
                "bounds": [
                  [
                    50526.4,
                    37969.6
                  ],
                  [
                    50668.6,
                    38089.9
                  ],
                  [
                    50767.4,
                    38007.1
                  ],
                  [
                    50894,
                    37861
                  ],
                  [
                    50809.1,
                    37774.6
                  ],
                  [
                    50621.7,
                    37778.6
                  ],
                  [
                    50526.4,
                    37969.6
                  ]
                ],
                "id": 1059,
                "chat_link": "[&BCMEAAA=]"
              },
              "1076": {
                "name": "Dierdre's Steps",
                "level": 69,
                "coord": [
                  54218.1,
                  38231.4
                ],
                "bounds": [
                  [
                    54052.1,
                    37996.6
                  ],
                  [
                    54089.3,
                    37794.8
                  ],
                  [
                    54429.8,
                    37922.4
                  ],
                  [
                    54412.6,
                    38523.6
                  ],
                  [
                    54289.6,
                    38591.3
                  ],
                  [
                    54035.4,
                    38559.9
                  ],
                  [
                    54052.1,
                    37996.6
                  ]
                ],
                "id": 1076,
                "chat_link": "[&BDQEAAA=]"
              }
            },
            "id": 1130,
            "mastery_points": [],
            "adventures": []
          },
          "1153": {
            "name": "Tiger Den",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              52480,
              38912
            ],
            "map_rect": [
              [
                -46080,
                -27648
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                50560,
                37760
              ],
              [
                54400,
                40192
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1153,
            "mastery_points": []
          },
          "1363": {
            "name": "New Friends, New Enemies—North Nolan Hatchery",
            "min_level": 0,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              58048,
              28760
            ],
            "map_rect": [
              [
                -43008,
                -27648
              ],
              [
                43008,
                27648
              ]
            ],
            "continent_rect": [
              [
                56320,
                27648
              ],
              [
                59904,
                29952
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1363,
            "mastery_points": []
          },
          "1364": {
            "name": "The Battle for Cragstead",
            "min_level": 0,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              55424,
              29952
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                55296,
                26368
              ],
              [
                57856,
                28928
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1364,
            "mastery_points": []
          }
        },
        "id": 8
      },
      "10": {
        "name": "Heart of Maguuma",
        "label_coord": [
          35868,
          34484
        ],
        "continent_rect": [
          [
            50432,
            24448
          ],
          [
            56576,
            37760
          ]
        ],
        "maps": {
          "1068": {
            "name": "Gilded Hollow",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 0,
            "label_coord": [
              35976,
              33072
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                35328,
                32512
              ],
              [
                36608,
                33792
              ]
            ],
            "points_of_interest": {
              "2162": {
                "name": "Cavern Mine Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  36292.8,
                  33454.9
                ],
                "id": 2162,
                "chat_link": "[&BHIIAAA=]"
              },
              "2260": {
                "name": "Arena Tower Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  35726.9,
                  33285.9
                ],
                "id": 2260,
                "chat_link": "[&BNQIAAA=]"
              },
              "2273": {
                "name": "Waterfall Plaza Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  35910.5,
                  32705.9
                ],
                "id": 2273,
                "chat_link": "[&BOEIAAA=]"
              },
              "2303": {
                "name": "Central Hollow Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  35973.2,
                  33210.5
                ],
                "id": 2303,
                "chat_link": "[&BP8IAAA=]"
              },
              "2305": {
                "name": "Surface Tunnel Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  35392.8,
                  33662
                ],
                "id": 2305,
                "chat_link": "[&BAEJAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1299": {
                "level": 0,
                "coord": [
                  35937,
                  33340.6
                ],
                "bounds": [
                  [
                    35395.8,
                    33800.1
                  ],
                  [
                    35707.9,
                    33889.2
                  ],
                  [
                    36487,
                    33779
                  ],
                  [
                    36597.3,
                    33249.6
                  ],
                  [
                    36696.1,
                    32453.7
                  ],
                  [
                    35332.5,
                    32520.8
                  ],
                  [
                    35342.5,
                    33691.8
                  ],
                  [
                    35395.8,
                    33800.1
                  ]
                ],
                "id": 1299,
                "chat_link": "[&BBMFAAA=]"
              }
            },
            "adventures": [],
            "id": 1068,
            "mastery_points": []
          },
          "1032": {
            "name": "Prized Possessions",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              34304,
              33792
            ],
            "map_rect": [
              [
                -24576,
                -33792
              ],
              [
                24576,
                33792
              ]
            ],
            "continent_rect": [
              [
                33280,
                32512
              ],
              [
                35328,
                35328
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1218": {
                "name": "Southwatch Creep",
                "level": 80,
                "coord": [
                  34351.9,
                  34715.8
                ],
                "bounds": [
                  [
                    34281.2,
                    34367
                  ],
                  [
                    34370,
                    34364
                  ],
                  [
                    34615.6,
                    34504.5
                  ],
                  [
                    34654.6,
                    34667.6
                  ],
                  [
                    34628.6,
                    34832.7
                  ],
                  [
                    34577.9,
                    34854.3
                  ],
                  [
                    34546.1,
                    34933.2
                  ],
                  [
                    34467.2,
                    34919.9
                  ],
                  [
                    34184.3,
                    34913.5
                  ],
                  [
                    34114.3,
                    34987.2
                  ],
                  [
                    34011.5,
                    34862.3
                  ],
                  [
                    34015.5,
                    34540
                  ],
                  [
                    34108.3,
                    34559.8
                  ],
                  [
                    34281.2,
                    34367
                  ]
                ],
                "id": 1218,
                "chat_link": "[&BMIEAAA=]"
              },
              "1219": {
                "name": "Balthazar's Rest",
                "level": 80,
                "coord": [
                  33879.3,
                  35100.1
                ],
                "bounds": [
                  [
                    33602.1,
                    35301.6
                  ],
                  [
                    33615.6,
                    35070
                  ],
                  [
                    33878.2,
                    34954.7
                  ],
                  [
                    33912.4,
                    34847.9
                  ],
                  [
                    34013.9,
                    34853.4
                  ],
                  [
                    34142.4,
                    35034.8
                  ],
                  [
                    34000.1,
                    35110
                  ],
                  [
                    33975.3,
                    35310.6
                  ],
                  [
                    33773.7,
                    35418.3
                  ],
                  [
                    33602.1,
                    35301.6
                  ]
                ],
                "id": 1219,
                "chat_link": "[&BMMEAAA=]"
              },
              "1220": {
                "name": "Burnisher Quarry",
                "level": 80,
                "coord": [
                  34947.3,
                  32796.9
                ],
                "bounds": [
                  [
                    34605.5,
                    32481.5
                  ],
                  [
                    34907.7,
                    32483.3
                  ],
                  [
                    35099.7,
                    32380.2
                  ],
                  [
                    35376.2,
                    32609
                  ],
                  [
                    35353.4,
                    33003.4
                  ],
                  [
                    35244.1,
                    33238.8
                  ],
                  [
                    35050.3,
                    33365.3
                  ],
                  [
                    34944.1,
                    33013.2
                  ],
                  [
                    34889.1,
                    32932.7
                  ],
                  [
                    34741,
                    32816.5
                  ],
                  [
                    34620.7,
                    32688.6
                  ],
                  [
                    34535.7,
                    32550
                  ],
                  [
                    34605.5,
                    32481.5
                  ]
                ],
                "id": 1220,
                "chat_link": "[&BMQEAAA=]"
              },
              "1222": {
                "name": "Westwatch Patch",
                "level": 80,
                "coord": [
                  33654.8,
                  33521.4
                ],
                "bounds": [
                  [
                    33289,
                    33929.2
                  ],
                  [
                    33353.3,
                    33938.3
                  ],
                  [
                    33430.2,
                    33798.7
                  ],
                  [
                    33657.4,
                    33953.5
                  ],
                  [
                    33871.4,
                    33796.2
                  ],
                  [
                    33944.8,
                    33664.5
                  ],
                  [
                    33869.2,
                    33574.4
                  ],
                  [
                    33839.5,
                    33366.3
                  ],
                  [
                    33876.5,
                    33333.6
                  ],
                  [
                    33948.4,
                    33324
                  ],
                  [
                    33795,
                    33139.7
                  ],
                  [
                    33741.6,
                    33212.9
                  ],
                  [
                    33517.4,
                    33111.5
                  ],
                  [
                    33397,
                    33197.4
                  ],
                  [
                    33290.8,
                    33480.8
                  ],
                  [
                    33289,
                    33929.2
                  ]
                ],
                "id": 1222,
                "chat_link": "[&BMYEAAA=]"
              },
              "1224": {
                "name": "Tarnished Treetop",
                "level": 80,
                "coord": [
                  33694.9,
                  32853
                ],
                "bounds": [
                  [
                    33439.6,
                    32543.3
                  ],
                  [
                    33582.2,
                    32425.4
                  ],
                  [
                    33750,
                    32552.6
                  ],
                  [
                    34079.8,
                    32448.6
                  ],
                  [
                    34227.7,
                    32591.1
                  ],
                  [
                    34108.1,
                    32981.7
                  ],
                  [
                    34050.2,
                    32965.3
                  ],
                  [
                    33843,
                    33073.6
                  ],
                  [
                    33742.3,
                    33213
                  ],
                  [
                    33516.7,
                    33109.2
                  ],
                  [
                    33397.5,
                    33197.8
                  ],
                  [
                    33300.4,
                    33116.5
                  ],
                  [
                    33295.2,
                    32895.2
                  ],
                  [
                    33396.2,
                    32828.5
                  ],
                  [
                    33439.6,
                    32543.3
                  ]
                ],
                "id": 1224,
                "chat_link": "[&BMgEAAA=]"
              },
              "1225": {
                "name": "Mossheart Walk",
                "level": 80,
                "coord": [
                  34880.8,
                  34672
                ],
                "bounds": [
                  [
                    34613.3,
                    34499.6
                  ],
                  [
                    35084,
                    34396.6
                  ],
                  [
                    35193.6,
                    34752.2
                  ],
                  [
                    35110.7,
                    34883.6
                  ],
                  [
                    34629,
                    34832.1
                  ],
                  [
                    34654.3,
                    34667.9
                  ],
                  [
                    34613.3,
                    34499.6
                  ]
                ],
                "id": 1225,
                "chat_link": "[&BMkEAAA=]"
              },
              "1226": {
                "name": "Arrowhead Vale",
                "level": 80,
                "coord": [
                  34197,
                  33265.2
                ],
                "bounds": [
                  [
                    34130.2,
                    33460.5
                  ],
                  [
                    34050.1,
                    33346.4
                  ],
                  [
                    33946.5,
                    33323.6
                  ],
                  [
                    33794,
                    33137.6
                  ],
                  [
                    33842.2,
                    33070
                  ],
                  [
                    34049.3,
                    32966.6
                  ],
                  [
                    34259.3,
                    33020.9
                  ],
                  [
                    34270.4,
                    33168.7
                  ],
                  [
                    34533.1,
                    33187.9
                  ],
                  [
                    34592.5,
                    33280.3
                  ],
                  [
                    34481.4,
                    33502.1
                  ],
                  [
                    34403.6,
                    33488.7
                  ],
                  [
                    34208.8,
                    33494.1
                  ],
                  [
                    34130.2,
                    33460.5
                  ]
                ],
                "id": 1226,
                "chat_link": "[&BMoEAAA=]"
              },
              "1230": {
                "name": "Maguuma Shallows",
                "level": 80,
                "coord": [
                  34744.4,
                  33233.8
                ],
                "bounds": [
                  [
                    34530.6,
                    33189.2
                  ],
                  [
                    34743,
                    32958.8
                  ],
                  [
                    34696.1,
                    32905.2
                  ],
                  [
                    34739.4,
                    32812.5
                  ],
                  [
                    34890.2,
                    32929.9
                  ],
                  [
                    34947.4,
                    33008.1
                  ],
                  [
                    35050.6,
                    33366.6
                  ],
                  [
                    34917.3,
                    33593.1
                  ],
                  [
                    34748.2,
                    33703.3
                  ],
                  [
                    34592.4,
                    33556.5
                  ],
                  [
                    34482.7,
                    33502.2
                  ],
                  [
                    34595.2,
                    33280.8
                  ],
                  [
                    34530.6,
                    33189.2
                  ]
                ],
                "id": 1230,
                "chat_link": "[&BM4EAAA=]"
              },
              "1236": {
                "name": "Northwatch Descent",
                "level": 80,
                "coord": [
                  34474.7,
                  32887
                ],
                "bounds": [
                  [
                    34227.1,
                    32589.4
                  ],
                  [
                    34538,
                    32550.3
                  ],
                  [
                    34622.3,
                    32686.8
                  ],
                  [
                    34739.9,
                    32816.6
                  ],
                  [
                    34700,
                    32905.9
                  ],
                  [
                    34747.1,
                    32958.7
                  ],
                  [
                    34535.6,
                    33194.3
                  ],
                  [
                    34270.7,
                    33168.8
                  ],
                  [
                    34259.2,
                    33018.5
                  ],
                  [
                    34106.7,
                    32980.6
                  ],
                  [
                    34227.1,
                    32589.4
                  ]
                ],
                "id": 1236,
                "chat_link": "[&BNQEAAA=]"
              },
              "1240": {
                "name": "Chak Hollow",
                "level": 80,
                "coord": [
                  34912.7,
                  35054.1
                ],
                "bounds": [
                  [
                    35432.5,
                    35009.2
                  ],
                  [
                    35369.1,
                    35375.1
                  ],
                  [
                    35165.6,
                    35298.1
                  ],
                  [
                    34912.6,
                    35367.7
                  ],
                  [
                    34777.9,
                    35289.3
                  ],
                  [
                    34639,
                    35294.8
                  ],
                  [
                    34535.5,
                    35128.4
                  ],
                  [
                    34558.6,
                    34989.9
                  ],
                  [
                    34545.6,
                    34933.7
                  ],
                  [
                    34577.7,
                    34852.7
                  ],
                  [
                    34628.6,
                    34830.4
                  ],
                  [
                    35112.6,
                    34882.3
                  ],
                  [
                    35195.1,
                    34752.2
                  ],
                  [
                    35327.5,
                    34753.9
                  ],
                  [
                    35432.5,
                    35009.2
                  ]
                ],
                "id": 1240,
                "chat_link": "[&BNgEAAA=]"
              },
              "1241": {
                "name": "Bristleback Chasm",
                "level": 80,
                "coord": [
                  35030.9,
                  33824.5
                ],
                "bounds": [
                  [
                    34896.2,
                    33822
                  ],
                  [
                    34743.5,
                    33702.7
                  ],
                  [
                    34914.7,
                    33594.1
                  ],
                  [
                    35051.1,
                    33368.1
                  ],
                  [
                    35244.9,
                    33239.5
                  ],
                  [
                    35354.7,
                    33343.4
                  ],
                  [
                    35344.1,
                    33465.7
                  ],
                  [
                    35155.4,
                    33488.8
                  ],
                  [
                    35039.9,
                    33655.3
                  ],
                  [
                    35038.7,
                    33822.1
                  ],
                  [
                    35109.9,
                    33899.8
                  ],
                  [
                    35084.5,
                    34113.6
                  ],
                  [
                    35126.7,
                    34245.1
                  ],
                  [
                    35083.2,
                    34398.4
                  ],
                  [
                    34718.5,
                    34480.4
                  ],
                  [
                    34722,
                    34381.5
                  ],
                  [
                    34897.6,
                    33996.8
                  ],
                  [
                    34896.2,
                    33822
                  ]
                ],
                "id": 1241,
                "chat_link": "[&BNkEAAA=]"
              },
              "1244": {
                "name": "Tarir, the Forgotten City",
                "level": 80,
                "coord": [
                  34256.9,
                  33880.9
                ],
                "bounds": [
                  [
                    34130.7,
                    33460.9
                  ],
                  [
                    34213.3,
                    33495
                  ],
                  [
                    34411.2,
                    33485.1
                  ],
                  [
                    34479,
                    33502.6
                  ],
                  [
                    34594.1,
                    33554.8
                  ],
                  [
                    34743.5,
                    33700.4
                  ],
                  [
                    34901.2,
                    33832.4
                  ],
                  [
                    34898.1,
                    33996.9
                  ],
                  [
                    34722,
                    34382.7
                  ],
                  [
                    34717.9,
                    34480.3
                  ],
                  [
                    34615,
                    34505
                  ],
                  [
                    34378.2,
                    34364.8
                  ],
                  [
                    34281.7,
                    34367.8
                  ],
                  [
                    34110.1,
                    34559.7
                  ],
                  [
                    34018,
                    34540
                  ],
                  [
                    33972,
                    34279.2
                  ],
                  [
                    33998.4,
                    34148.9
                  ],
                  [
                    33839.6,
                    33959.6
                  ],
                  [
                    33872,
                    33797.5
                  ],
                  [
                    33945.8,
                    33664.7
                  ],
                  [
                    33869.3,
                    33574.5
                  ],
                  [
                    33839.8,
                    33366.6
                  ],
                  [
                    33876.5,
                    33333.6
                  ],
                  [
                    33945.2,
                    33324.4
                  ],
                  [
                    34049.4,
                    33344.2
                  ],
                  [
                    34130.7,
                    33460.9
                  ]
                ],
                "id": 1244,
                "chat_link": "[&BNwEAAA=]"
              },
              "1245": {
                "name": "Eastwatch Bluff",
                "level": 80,
                "coord": [
                  35192.6,
                  34030.3
                ],
                "bounds": [
                  [
                    35111.6,
                    33900.3
                  ],
                  [
                    35040.6,
                    33817
                  ],
                  [
                    35042.6,
                    33656.7
                  ],
                  [
                    35157.4,
                    33486.7
                  ],
                  [
                    35344.4,
                    33464.2
                  ],
                  [
                    35380.7,
                    33921.3
                  ],
                  [
                    35464,
                    34095.5
                  ],
                  [
                    35308.9,
                    34603.2
                  ],
                  [
                    35167.1,
                    34666.1
                  ],
                  [
                    35082.1,
                    34395.1
                  ],
                  [
                    35127.6,
                    34247
                  ],
                  [
                    35084.1,
                    34111.1
                  ],
                  [
                    35111.6,
                    33900.3
                  ]
                ],
                "id": 1245,
                "chat_link": "[&BN0EAAA=]"
              },
              "1248": {
                "name": "Griffonfall",
                "level": 80,
                "coord": [
                  33744.4,
                  34794.9
                ],
                "bounds": [
                  [
                    34026.8,
                    34592
                  ],
                  [
                    34013.4,
                    34855.7
                  ],
                  [
                    33913.7,
                    34846.9
                  ],
                  [
                    33870.8,
                    34950.5
                  ],
                  [
                    33615.8,
                    35074.9
                  ],
                  [
                    33469.2,
                    34983.9
                  ],
                  [
                    33360.8,
                    34701.6
                  ],
                  [
                    33574.1,
                    34530.1
                  ],
                  [
                    33855.2,
                    34618.7
                  ],
                  [
                    34026.8,
                    34592
                  ]
                ],
                "id": 1248,
                "chat_link": "[&BOAEAAA=]"
              },
              "1258": {
                "name": "The Falls",
                "level": 80,
                "coord": [
                  33850.5,
                  34371.3
                ],
                "bounds": [
                  [
                    33555.7,
                    34301
                  ],
                  [
                    33568.8,
                    34529.4
                  ],
                  [
                    33860.1,
                    34620.1
                  ],
                  [
                    34026.3,
                    34592.7
                  ],
                  [
                    33972.8,
                    34291.5
                  ],
                  [
                    33997.6,
                    34148.4
                  ],
                  [
                    33972.2,
                    34115.9
                  ],
                  [
                    33555.7,
                    34301
                  ]
                ],
                "id": 1258,
                "chat_link": "[&BOoEAAA=]"
              },
              "1260": {
                "name": "Lastgear Standing",
                "level": 80,
                "coord": [
                  33548.4,
                  34170.6
                ],
                "bounds": [
                  [
                    33556.1,
                    34304
                  ],
                  [
                    33971.2,
                    34117
                  ],
                  [
                    33839.8,
                    33959.7
                  ],
                  [
                    33872.2,
                    33797.8
                  ],
                  [
                    33656.5,
                    33957.7
                  ],
                  [
                    33430.5,
                    33798.9
                  ],
                  [
                    33316.8,
                    33985.4
                  ],
                  [
                    33363.5,
                    34143.2
                  ],
                  [
                    33301.4,
                    34229.2
                  ],
                  [
                    33300.9,
                    34561.3
                  ],
                  [
                    33402.1,
                    34663.3
                  ],
                  [
                    33569.4,
                    34529.8
                  ],
                  [
                    33556.1,
                    34304
                  ]
                ],
                "id": 1260,
                "chat_link": "[&BOwEAAA=]"
              },
              "1262": {
                "name": "Morwood Wilds",
                "level": 80,
                "coord": [
                  34324.3,
                  35092.1
                ],
                "bounds": [
                  [
                    34422.2,
                    35408.7
                  ],
                  [
                    33971.6,
                    35312.5
                  ],
                  [
                    33999.9,
                    35108
                  ],
                  [
                    34141.1,
                    35035.4
                  ],
                  [
                    34099.4,
                    34975.9
                  ],
                  [
                    34184.2,
                    34914.3
                  ],
                  [
                    34466.6,
                    34918.1
                  ],
                  [
                    34545.1,
                    34933.9
                  ],
                  [
                    34559.1,
                    34989.4
                  ],
                  [
                    34537.9,
                    35124.4
                  ],
                  [
                    34640.8,
                    35292.8
                  ],
                  [
                    34422.2,
                    35408.7
                  ]
                ],
                "id": 1262,
                "chat_link": "[&BO4EAAA=]"
              }
            },
            "adventures": [],
            "id": 1032,
            "mastery_points": []
          },
          "1037": {
            "name": "The Jungle Provides",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              35072,
              31744
            ],
            "map_rect": [
              [
                -36864,
                -18432
              ],
              [
                39936,
                18432
              ]
            ],
            "continent_rect": [
              [
                33408,
                30976
              ],
              [
                36608,
                32512
              ]
            ],
            "points_of_interest": {
              "1985": {
                "name": "Golden Boughs",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33695.3,
                  32148.6
                ],
                "id": 1985,
                "chat_link": "[&BMEHAAA=]"
              },
              "1986": {
                "name": "Matriarch's Perch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35229.7,
                  31801.6
                ],
                "id": 1986,
                "chat_link": "[&BMIHAAA=]"
              },
              "1991": {
                "name": "Wreck of the Thunderbreaker",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34154,
                  32246.9
                ],
                "id": 1991,
                "chat_link": "[&BMcHAAA=]"
              },
              "1994": {
                "name": "Dwelling of the Kaanas",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35980,
                  31149
                ],
                "id": 1994,
                "chat_link": "[&BMoHAAA=]"
              },
              "1995": {
                "name": "Wreck of the Mellaggan's Valor",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34466.1,
                  31517.4
                ],
                "id": 1995,
                "chat_link": "[&BMsHAAA=]"
              },
              "1999": {
                "name": "Wreck of the Lethal Vantage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36407.8,
                  32171.6
                ],
                "id": 1999,
                "chat_link": "[&BM8HAAA=]"
              },
              "2017": {
                "name": "Temple of Ameyalli",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36096.4,
                  31379
                ],
                "id": 2017,
                "chat_link": "[&BOEHAAA=]"
              },
              "2021": {
                "name": "Precarious Ruin",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33750.1,
                  31169.7
                ],
                "id": 2021,
                "chat_link": "[&BOUHAAA=]"
              },
              "2025": {
                "name": "Last Leap",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35581.7,
                  31392.3
                ],
                "id": 2025,
                "chat_link": "[&BOkHAAA=]"
              },
              "2030": {
                "name": "Fumerol Caves",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35714,
                  31043.1
                ],
                "id": 2030,
                "chat_link": "[&BO4HAAA=]"
              },
              "2032": {
                "name": "The Corpse Grove",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34605.9,
                  31227.2
                ],
                "id": 2032,
                "chat_link": "[&BPAHAAA=]"
              },
              "2036": {
                "name": "Coztic Itzel",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34456.1,
                  32046.8
                ],
                "id": 2036,
                "chat_link": "[&BPQHAAA=]"
              },
              "2042": {
                "name": "Batrach Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36458.3,
                  31267.6
                ],
                "id": 2042,
                "chat_link": "[&BPoHAAA=]"
              },
              "2043": {
                "name": "Brooding Gulch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35686.6,
                  31339.7
                ],
                "id": 2043,
                "chat_link": "[&BPsHAAA=]"
              },
              "2045": {
                "name": "Shaded Spring",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35115.6,
                  31751.3
                ],
                "id": 2045,
                "chat_link": "[&BP0HAAA=]"
              },
              "2046": {
                "name": "Ascendant's Ring",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34152.4,
                  32000.6
                ],
                "id": 2046,
                "chat_link": "[&BP4HAAA=]"
              },
              "2061": {
                "name": "Holdfast Hollow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33822.7,
                  31741.8
                ],
                "id": 2061,
                "chat_link": "[&BA0IAAA=]"
              },
              "2065": {
                "name": "The Waking Tomb",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35963.7,
                  32398.3
                ],
                "id": 2065,
                "chat_link": "[&BBEIAAA=]"
              },
              "2066": {
                "name": "Glory's Fall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35235.3,
                  31271.1
                ],
                "id": 2066,
                "chat_link": "[&BBIIAAA=]"
              },
              "2067": {
                "name": "Dust Dancer Plateau",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35265.6,
                  32306.8
                ],
                "id": 2067,
                "chat_link": "[&BBMIAAA=]"
              },
              "2071": {
                "name": "Uprooted Paradise",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34142.6,
                  31253.1
                ],
                "id": 2071,
                "chat_link": "[&BBcIAAA=]"
              },
              "2072": {
                "name": "Precarious Perch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35631.5,
                  31951.1
                ],
                "id": 2072,
                "chat_link": "[&BBgIAAA=]"
              },
              "2073": {
                "name": "Silent Woods",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34768.8,
                  31691.5
                ],
                "id": 2073,
                "chat_link": "[&BBkIAAA=]"
              },
              "2074": {
                "name": "Creaking Caverns",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35083.9,
                  32165.2
                ],
                "id": 2074,
                "chat_link": "[&BBoIAAA=]"
              },
              "2075": {
                "name": "The Tangle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36095.3,
                  31721.4
                ],
                "id": 2075,
                "chat_link": "[&BBsIAAA=]"
              },
              "2077": {
                "name": "Bongo's Bungalow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34829.3,
                  32391.4
                ],
                "id": 2077,
                "chat_link": "[&BB0IAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1228": {
                "name": "Stonetwist Paths",
                "level": 80,
                "coord": [
                  35244.4,
                  31688.2
                ],
                "bounds": [
                  [
                    35626.6,
                    31696.8
                  ],
                  [
                    35587.3,
                    31743.3
                  ],
                  [
                    35423,
                    31815.3
                  ],
                  [
                    35369.4,
                    31856.2
                  ],
                  [
                    35314.7,
                    31918.9
                  ],
                  [
                    35250.3,
                    31945.9
                  ],
                  [
                    35120.8,
                    31925.4
                  ],
                  [
                    35057.7,
                    31914
                  ],
                  [
                    34875,
                    31809
                  ],
                  [
                    34797.6,
                    31758.9
                  ],
                  [
                    34673.4,
                    31714.2
                  ],
                  [
                    34630.4,
                    31648
                  ],
                  [
                    34691.5,
                    31589.2
                  ],
                  [
                    34948,
                    31539.4
                  ],
                  [
                    35046.6,
                    31487.3
                  ],
                  [
                    35192,
                    31413.1
                  ],
                  [
                    35357.7,
                    31412.6
                  ],
                  [
                    35563.2,
                    31528
                  ],
                  [
                    35634.3,
                    31557.7
                  ],
                  [
                    35752.2,
                    31538.8
                  ],
                  [
                    35771.7,
                    31661.9
                  ],
                  [
                    35693.5,
                    31667.2
                  ],
                  [
                    35626.6,
                    31696.8
                  ]
                ],
                "id": 1228,
                "chat_link": "[&BMwEAAA=]"
              },
              "1229": {
                "name": "Noble Ledges",
                "level": 80,
                "coord": [
                  34221.3,
                  32284.5
                ],
                "bounds": [
                  [
                    33696.1,
                    32530.8
                  ],
                  [
                    34005,
                    32527.3
                  ],
                  [
                    34222.1,
                    32590.6
                  ],
                  [
                    34491.5,
                    32561
                  ],
                  [
                    34561.7,
                    32483.4
                  ],
                  [
                    34616.3,
                    32413.1
                  ],
                  [
                    34625.3,
                    32269.8
                  ],
                  [
                    34684.5,
                    32140.4
                  ],
                  [
                    34528.4,
                    32174.7
                  ],
                  [
                    34403.9,
                    32176.1
                  ],
                  [
                    34375.2,
                    32079.7
                  ],
                  [
                    34302.4,
                    31985
                  ],
                  [
                    34149.6,
                    32020
                  ],
                  [
                    34037.9,
                    32066.3
                  ],
                  [
                    33909.1,
                    32176.1
                  ],
                  [
                    33580.2,
                    32168.8
                  ],
                  [
                    33572.2,
                    32473.1
                  ],
                  [
                    33696.1,
                    32530.8
                  ]
                ],
                "id": 1229,
                "chat_link": "[&BM0EAAA=]"
              },
              "1232": {
                "name": "The Doomteeth",
                "level": 80,
                "coord": [
                  33829.6,
                  31295.8
                ],
                "bounds": [
                  [
                    33577.1,
                    31688.9
                  ],
                  [
                    33649.1,
                    31022.1
                  ],
                  [
                    34141.4,
                    31084.3
                  ],
                  [
                    34016.2,
                    31173.5
                  ],
                  [
                    33892.5,
                    31352.7
                  ],
                  [
                    33701,
                    31453.6
                  ],
                  [
                    33577.1,
                    31688.9
                  ]
                ],
                "id": 1232,
                "chat_link": "[&BNAEAAA=]"
              },
              "1243": {
                "name": "Jaka Itzel",
                "level": 80,
                "coord": [
                  36250.8,
                  31282.1
                ],
                "bounds": [
                  [
                    35973.9,
                    30996.2
                  ],
                  [
                    36629.6,
                    30961.6
                  ],
                  [
                    36712.2,
                    31249
                  ],
                  [
                    36677.6,
                    31392.9
                  ],
                  [
                    36416.4,
                    31363.7
                  ],
                  [
                    36439,
                    31302.1
                  ],
                  [
                    36218.4,
                    31371.6
                  ],
                  [
                    36159.9,
                    31463.5
                  ],
                  [
                    36043.6,
                    31514.9
                  ],
                  [
                    35885.6,
                    31502.2
                  ],
                  [
                    35949.1,
                    31266.2
                  ],
                  [
                    35904.2,
                    31001.1
                  ],
                  [
                    35973.9,
                    30996.2
                  ]
                ],
                "id": 1243,
                "chat_link": "[&BNsEAAA=]"
              },
              "1249": {
                "name": "Blighted Depths",
                "level": 80,
                "coord": [
                  34441.8,
                  31257
                ],
                "bounds": [
                  [
                    33892.1,
                    31351.5
                  ],
                  [
                    34020.5,
                    31168.2
                  ],
                  [
                    34145.8,
                    31083
                  ],
                  [
                    34368,
                    31034.7
                  ],
                  [
                    34634.9,
                    30997.8
                  ],
                  [
                    34991.7,
                    31029.6
                  ],
                  [
                    34842.9,
                    31291.2
                  ],
                  [
                    34769.6,
                    31466
                  ],
                  [
                    34675,
                    31377.7
                  ],
                  [
                    34567.3,
                    31347.7
                  ],
                  [
                    34381.9,
                    31327.3
                  ],
                  [
                    34261.9,
                    31379.8
                  ],
                  [
                    34191.7,
                    31485.9
                  ],
                  [
                    33892.1,
                    31351.5
                  ]
                ],
                "id": 1249,
                "chat_link": "[&BOEEAAA=]"
              },
              "1250": {
                "name": "Shrouded Ruins",
                "level": 80,
                "coord": [
                  35778.2,
                  32227.7
                ],
                "bounds": [
                  [
                    35359.7,
                    32628.8
                  ],
                  [
                    35346.2,
                    32173.3
                  ],
                  [
                    35527.8,
                    32175.6
                  ],
                  [
                    35596.2,
                    32159.1
                  ],
                  [
                    35742.9,
                    31967.5
                  ],
                  [
                    35777.1,
                    32024.3
                  ],
                  [
                    35913,
                    32015.4
                  ],
                  [
                    36078.5,
                    32030.8
                  ],
                  [
                    36191.6,
                    32141.3
                  ],
                  [
                    36267.4,
                    32483.8
                  ],
                  [
                    35919.9,
                    32487
                  ],
                  [
                    35618.5,
                    32445.7
                  ],
                  [
                    35359.7,
                    32628.8
                  ]
                ],
                "id": 1250,
                "chat_link": "[&BOIEAAA=]"
              },
              "1254": {
                "name": "Wyvern Cliffs",
                "level": 80,
                "coord": [
                  35654.4,
                  31333.3
                ],
                "bounds": [
                  [
                    35904.2,
                    31001.1
                  ],
                  [
                    35949,
                    31266.2
                  ],
                  [
                    35884.9,
                    31502.6
                  ],
                  [
                    35751.3,
                    31538.8
                  ],
                  [
                    35633.8,
                    31557.7
                  ],
                  [
                    35563.1,
                    31527.7
                  ],
                  [
                    35547,
                    31436.2
                  ],
                  [
                    35568.3,
                    31382.1
                  ],
                  [
                    35499.5,
                    31337.3
                  ],
                  [
                    35489.1,
                    31301.2
                  ],
                  [
                    35508.5,
                    31143.6
                  ],
                  [
                    35554.8,
                    31005.6
                  ],
                  [
                    35904.2,
                    31001.1
                  ]
                ],
                "id": 1254,
                "chat_link": "[&BOYEAAA=]"
              },
              "1256": {
                "name": "Creeping Crevasse",
                "level": 80,
                "coord": [
                  35941.9,
                  31804.3
                ],
                "bounds": [
                  [
                    36185,
                    31852.6
                  ],
                  [
                    36125.8,
                    31883.3
                  ],
                  [
                    36072.3,
                    31968.6
                  ],
                  [
                    36078.5,
                    32030.8
                  ],
                  [
                    35912.6,
                    32013.9
                  ],
                  [
                    35777.1,
                    32024.3
                  ],
                  [
                    35742.9,
                    31967.2
                  ],
                  [
                    35712.6,
                    31887.6
                  ],
                  [
                    35638.7,
                    31769.6
                  ],
                  [
                    35587.1,
                    31744.7
                  ],
                  [
                    35626.6,
                    31696.8
                  ],
                  [
                    35692.8,
                    31667.1
                  ],
                  [
                    35772.4,
                    31662.9
                  ],
                  [
                    35977.3,
                    31632.6
                  ],
                  [
                    36111.5,
                    31608.8
                  ],
                  [
                    36180.7,
                    31617.1
                  ],
                  [
                    36238.4,
                    31685.7
                  ],
                  [
                    36239.8,
                    31760.7
                  ],
                  [
                    36223.2,
                    31808.3
                  ],
                  [
                    36185,
                    31852.6
                  ]
                ],
                "id": 1256,
                "chat_link": "[&BOgEAAA=]"
              },
              "1259": {
                "name": "Dry Step Mesas",
                "level": 80,
                "coord": [
                  36289.2,
                  31844.6
                ],
                "bounds": [
                  [
                    36125.8,
                    31883.3
                  ],
                  [
                    36185,
                    31852.6
                  ],
                  [
                    36223.2,
                    31808.3
                  ],
                  [
                    36239.8,
                    31760.7
                  ],
                  [
                    36238.6,
                    31685.3
                  ],
                  [
                    36278.2,
                    31677.5
                  ],
                  [
                    36450.1,
                    31707.4
                  ],
                  [
                    36624.1,
                    31777.5
                  ],
                  [
                    36620.2,
                    31830.2
                  ],
                  [
                    36433.1,
                    31857.3
                  ],
                  [
                    36190.7,
                    32140.8
                  ],
                  [
                    36078.5,
                    32030.8
                  ],
                  [
                    36072.3,
                    31968.6
                  ],
                  [
                    36125.8,
                    31883.3
                  ]
                ],
                "id": 1259,
                "chat_link": "[&BOsEAAA=]"
              },
              "1263": {
                "name": "Heartless Pass",
                "level": 80,
                "coord": [
                  36206.2,
                  31528.7
                ],
                "bounds": [
                  [
                    36238.9,
                    31685.8
                  ],
                  [
                    36181.2,
                    31616.9
                  ],
                  [
                    36112.1,
                    31609
                  ],
                  [
                    35977.1,
                    31632.1
                  ],
                  [
                    35772.3,
                    31663
                  ],
                  [
                    35753,
                    31539
                  ],
                  [
                    35885.6,
                    31502.2
                  ],
                  [
                    36043.2,
                    31514
                  ],
                  [
                    36158.8,
                    31463.2
                  ],
                  [
                    36217.9,
                    31371.9
                  ],
                  [
                    36438.7,
                    31302.1
                  ],
                  [
                    36416,
                    31363.1
                  ],
                  [
                    36677.5,
                    31392.8
                  ],
                  [
                    36657.9,
                    31571
                  ],
                  [
                    36431.6,
                    31587.4
                  ],
                  [
                    36337.4,
                    31644.9
                  ],
                  [
                    36238.9,
                    31685.8
                  ]
                ],
                "id": 1263,
                "chat_link": "[&BO8EAAA=]"
              },
              "1264": {
                "name": "Broken Bluffs",
                "level": 80,
                "coord": [
                  34204.8,
                  31606.7
                ],
                "bounds": [
                  [
                    33578.6,
                    31687.4
                  ],
                  [
                    33701.6,
                    31454.3
                  ],
                  [
                    33890.7,
                    31350.4
                  ],
                  [
                    34189.3,
                    31485.9
                  ],
                  [
                    34262.9,
                    31380.3
                  ],
                  [
                    34381.7,
                    31328.2
                  ],
                  [
                    34570.6,
                    31345.3
                  ],
                  [
                    34669,
                    31371.2
                  ],
                  [
                    34770.6,
                    31465.5
                  ],
                  [
                    34691.3,
                    31588.2
                  ],
                  [
                    34629.8,
                    31648.3
                  ],
                  [
                    34376.9,
                    31715.6
                  ],
                  [
                    34315.7,
                    31741.4
                  ],
                  [
                    34282.6,
                    31827.2
                  ],
                  [
                    34080.7,
                    31850.5
                  ],
                  [
                    33926.2,
                    31905.4
                  ],
                  [
                    33758.4,
                    31894.6
                  ],
                  [
                    33609.5,
                    31881.5
                  ],
                  [
                    33578.6,
                    31687.4
                  ]
                ],
                "id": 1264,
                "chat_link": "[&BPAEAAA=]"
              },
              "1265": {
                "name": "Hidden Copse",
                "level": 80,
                "coord": [
                  34923.6,
                  32288.4
                ],
                "bounds": [
                  [
                    35197.9,
                    32183.6
                  ],
                  [
                    35116.3,
                    32304.3
                  ],
                  [
                    35135.5,
                    32380.5
                  ],
                  [
                    35159.3,
                    32561.3
                  ],
                  [
                    34561.8,
                    32483.2
                  ],
                  [
                    34615.4,
                    32413.9
                  ],
                  [
                    34625.7,
                    32270
                  ],
                  [
                    34684.5,
                    32139.9
                  ],
                  [
                    35013.2,
                    32066.1
                  ],
                  [
                    35126.4,
                    32081.4
                  ],
                  [
                    35197.9,
                    32183.6
                  ]
                ],
                "id": 1265,
                "chat_link": "[&BPEEAAA=]"
              },
              "1271": {
                "name": "Maguuma's Breach",
                "level": 80,
                "coord": [
                  36431.1,
                  31664.5
                ],
                "bounds": [
                  [
                    36657.9,
                    31571
                  ],
                  [
                    36431.9,
                    31587.9
                  ],
                  [
                    36337.2,
                    31645.1
                  ],
                  [
                    36238.9,
                    31685.6
                  ],
                  [
                    36277.4,
                    31677.3
                  ],
                  [
                    36450.1,
                    31707.3
                  ],
                  [
                    36624.2,
                    31777.6
                  ],
                  [
                    36657.9,
                    31571
                  ]
                ],
                "id": 1271,
                "chat_link": "[&BPcEAAA=]"
              }
            },
            "adventures": [],
            "id": 1037,
            "mastery_points": []
          },
          "1041": {
            "name": "Dragon's Stand",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              35712,
              37120
            ],
            "map_rect": [
              [
                -36864,
                -30720
              ],
              [
                36864,
                33792
              ]
            ],
            "continent_rect": [
              [
                34048,
                36096
              ],
              [
                37120,
                38784
              ]
            ],
            "points_of_interest": {
              "2064": {
                "name": "Pact Base Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  36648.9,
                  36231.5
                ],
                "id": 2064,
                "chat_link": "[&BBAIAAA=]"
              },
              "2092": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  36789.7,
                  37351.4
                ],
                "id": 2092,
                "chat_link": "[&BCwIAAA=]"
              },
              "2094": {
                "name": "Central Forward Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  36204.7,
                  36974.5
                ],
                "id": 2094,
                "chat_link": "[&BC4IAAA=]"
              },
              "2097": {
                "name": "Pact Base Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36645.4,
                  36289.6
                ],
                "id": 2097,
                "chat_link": "[&BDEIAAA=]"
              },
              "2104": {
                "name": "Ruined Glory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36706.8,
                  36828.8
                ],
                "id": 2104,
                "chat_link": "[&BDgIAAA=]"
              },
              "2110": {
                "name": "First Northern Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36388.4,
                  36271.6
                ],
                "id": 2110,
                "chat_link": "[&BD4IAAA=]"
              },
              "2119": {
                "name": "Ley Line Boneyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36563.3,
                  37621.4
                ],
                "id": 2119,
                "chat_link": "[&BEcIAAA=]"
              },
              "2124": {
                "name": "Wyvern Nest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36092.8,
                  37160.4
                ],
                "id": 2124,
                "chat_link": "[&BEwIAAA=]"
              },
              "2125": {
                "name": "Ley Line Overlook",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36478.5,
                  37720.9
                ],
                "id": 2125,
                "chat_link": "[&BE0IAAA=]"
              },
              "2127": {
                "name": "Southern Forward Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  36986.7,
                  37143
                ],
                "id": 2127,
                "chat_link": "[&BE8IAAA=]"
              },
              "2130": {
                "name": "Northern Forward Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  35730.2,
                  36555.7
                ],
                "id": 2130,
                "chat_link": "[&BFIIAAA=]"
              },
              "2131": {
                "name": "Central Advance Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  36118.5,
                  37357.4
                ],
                "id": 2131,
                "chat_link": "[&BFMIAAA=]"
              },
              "2135": {
                "name": "Dragon's Domain Southern Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  35648.7,
                  38076.6
                ],
                "id": 2135,
                "chat_link": "[&BFcIAAA=]"
              },
              "2142": {
                "name": "Mordremoth's Vantage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34376.1,
                  38198.5
                ],
                "id": 2142,
                "chat_link": "[&BF4IAAA=]"
              },
              "2143": {
                "name": "Third Central Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36069.9,
                  37336.1
                ],
                "id": 2143,
                "chat_link": "[&BF8IAAA=]"
              },
              "2147": {
                "name": "First Central Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36563.3,
                  36431
                ],
                "id": 2147,
                "chat_link": "[&BGMIAAA=]"
              },
              "2149": {
                "name": "Southern Advance Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  36654.2,
                  37490.9
                ],
                "id": 2149,
                "chat_link": "[&BGUIAAA=]"
              },
              "2161": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  35364.6,
                  37135.3
                ],
                "id": 2161,
                "chat_link": "[&BHEIAAA=]"
              },
              "2165": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  36062.6,
                  36929.3
                ],
                "id": 2165,
                "chat_link": "[&BHUIAAA=]"
              },
              "2169": {
                "name": "Rata Novan Remnants",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37059,
                  37013.5
                ],
                "id": 2169,
                "chat_link": "[&BHkIAAA=]"
              },
              "2170": {
                "name": "Pact Base Camp Southern Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  36810.7,
                  36524.6
                ],
                "id": 2170,
                "chat_link": "[&BHoIAAA=]"
              },
              "2172": {
                "name": "Mordrem Vineyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36072.9,
                  37427.3
                ],
                "id": 2172,
                "chat_link": "[&BHwIAAA=]"
              },
              "2175": {
                "name": "Serenity's Cove",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34184.7,
                  37841.8
                ],
                "id": 2175,
                "chat_link": "[&BH8IAAA=]"
              },
              "2176": {
                "name": "Northern Blighting Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35008.9,
                  37225.3
                ],
                "id": 2176,
                "chat_link": "[&BIAIAAA=]"
              },
              "2177": {
                "name": "Second Southern Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36945.6,
                  37199.6
                ],
                "id": 2177,
                "chat_link": "[&BIEIAAA=]"
              },
              "2179": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  35863.2,
                  37440.5
                ],
                "id": 2179,
                "chat_link": "[&BIMIAAA=]"
              },
              "2181": {
                "name": "Central Blighting Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35735.7,
                  37802.6
                ],
                "id": 2181,
                "chat_link": "[&BIUIAAA=]"
              },
              "2188": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  34244.1,
                  38137.2
                ],
                "id": 2188,
                "chat_link": "[&BIwIAAA=]"
              },
              "2193": {
                "name": "First Southern Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36918.9,
                  36658.4
                ],
                "id": 2193,
                "chat_link": "[&BJEIAAA=]"
              },
              "2199": {
                "name": "Dragon's Domain Central Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  35435.9,
                  37715
                ],
                "id": 2199,
                "chat_link": "[&BJcIAAA=]"
              },
              "2200": {
                "name": "Southern Blighting Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36071.1,
                  38096.4
                ],
                "id": 2200,
                "chat_link": "[&BJgIAAA=]"
              },
              "2206": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  36402.1,
                  37841.9
                ],
                "id": 2206,
                "chat_link": "[&BJ4IAAA=]"
              },
              "2210": {
                "name": "Second Northern Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35799.1,
                  36515.9
                ],
                "id": 2210,
                "chat_link": "[&BKIIAAA=]"
              },
              "2222": {
                "name": "Dragon's Domain Northern Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34756.5,
                  37366.8
                ],
                "id": 2222,
                "chat_link": "[&BK4IAAA=]"
              },
              "2224": {
                "name": "Chak Den",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36839.6,
                  37760.6
                ],
                "id": 2224,
                "chat_link": "[&BLAIAAA=]"
              },
              "2233": {
                "name": "Third Northern Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35506.1,
                  36862.5
                ],
                "id": 2233,
                "chat_link": "[&BLkIAAA=]"
              },
              "2241": {
                "name": "The Inverse Pit",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35033.1,
                  36819.8
                ],
                "id": 2241,
                "chat_link": "[&BMEIAAA=]"
              },
              "2251": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  35229.9,
                  36727.1
                ],
                "id": 2251,
                "chat_link": "[&BMsIAAA=]"
              },
              "2274": {
                "name": "Second Central Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36283.2,
                  36962.5
                ],
                "id": 2274,
                "chat_link": "[&BOIIAAA=]"
              },
              "2289": {
                "name": "Third Southern Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36693.4,
                  37538.3
                ],
                "id": 2289,
                "chat_link": "[&BPEIAAA=]"
              },
              "2290": {
                "name": "Blighted Bog",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36384.1,
                  36805.1
                ],
                "id": 2290,
                "chat_link": "[&BPIIAAA=]"
              },
              "2304": {
                "name": "Northern Advance Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  35531.9,
                  36790.1
                ],
                "id": 2304,
                "chat_link": "[&BAAJAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [
              {
                "coord": [
                  35986.5,
                  37399.2
                ],
                "id": "1-33"
              },
              {
                "coord": [
                  36539.2,
                  37126.2
                ],
                "id": "1-34"
              },
              {
                "coord": [
                  35297,
                  36722.4
                ],
                "id": "1-35"
              },
              {
                "coord": [
                  35003.4,
                  37222.1
                ],
                "id": "1-36"
              },
              {
                "coord": [
                  35734.7,
                  37811.9
                ],
                "id": "1-37"
              },
              {
                "coord": [
                  36077.2,
                  38100
                ],
                "id": "1-38"
              },
              {
                "coord": [
                  34154.2,
                  37852.2
                ],
                "id": "1-39"
              }
            ],
            "sectors": {
              "1257": {
                "name": "Pact Base Camp",
                "level": 80,
                "coord": [
                  36840.4,
                  36287.7
                ],
                "bounds": [
                  [
                    36656.8,
                    36104.1
                  ],
                  [
                    36683,
                    36216.1
                  ],
                  [
                    36701.8,
                    36324.3
                  ],
                  [
                    36719.1,
                    36410.6
                  ],
                  [
                    36742.1,
                    36597.6
                  ],
                  [
                    36823.4,
                    36553.8
                  ],
                  [
                    36885,
                    36511.2
                  ],
                  [
                    37038.9,
                    36481.6
                  ],
                  [
                    37176.4,
                    36209.8
                  ],
                  [
                    37077.1,
                    35863.6
                  ],
                  [
                    36740.7,
                    35892.2
                  ],
                  [
                    36656.8,
                    36104.1
                  ]
                ],
                "id": 1257,
                "chat_link": "[&BOkEAAA=]"
              },
              "1297": {
                "name": "Bitter Harvest",
                "level": 80,
                "coord": [
                  36251.2,
                  38282.8
                ],
                "bounds": [
                  [
                    36502.2,
                    37852.1
                  ],
                  [
                    36668.4,
                    37956.1
                  ],
                  [
                    36851.8,
                    38014.1
                  ],
                  [
                    36831.6,
                    38418.9
                  ],
                  [
                    36756.9,
                    38530.5
                  ],
                  [
                    36451.3,
                    38766.4
                  ],
                  [
                    35396.1,
                    38753.5
                  ],
                  [
                    35502.7,
                    38466.1
                  ],
                  [
                    35514.6,
                    38198.4
                  ],
                  [
                    35903,
                    38276.8
                  ],
                  [
                    36095,
                    38383.8
                  ],
                  [
                    36225.9,
                    38346.7
                  ],
                  [
                    36283.7,
                    38274.2
                  ],
                  [
                    36349.4,
                    38102.9
                  ],
                  [
                    36435.9,
                    37901.4
                  ],
                  [
                    36502.2,
                    37852.1
                  ]
                ],
                "id": 1297,
                "chat_link": "[&BBEFAAA=]"
              },
              "1305": {
                "name": "Central Blighting Tower",
                "level": 80,
                "coord": [
                  35659.6,
                  37870.7
                ],
                "bounds": [
                  [
                    35500.9,
                    37638.1
                  ],
                  [
                    35579.6,
                    37627.9
                  ],
                  [
                    35757.4,
                    37590.8
                  ],
                  [
                    35933.3,
                    37696.2
                  ],
                  [
                    35922.8,
                    37900.5
                  ],
                  [
                    35837.2,
                    38052.2
                  ],
                  [
                    35736.8,
                    38091.7
                  ],
                  [
                    35626.4,
                    38051.6
                  ],
                  [
                    35536.9,
                    38033.4
                  ],
                  [
                    35449.4,
                    38031.6
                  ],
                  [
                    35375.2,
                    37863.5
                  ],
                  [
                    35500.9,
                    37638.1
                  ]
                ],
                "id": 1305,
                "chat_link": "[&BBkFAAA=]"
              },
              "1307": {
                "name": "Southern Barbed Gate",
                "level": 80,
                "coord": [
                  36383.8,
                  37899.5
                ],
                "bounds": [
                  [
                    36575,
                    37747.8
                  ],
                  [
                    36533,
                    37818.2
                  ],
                  [
                    36485.7,
                    37887.4
                  ],
                  [
                    36437.1,
                    37902.8
                  ],
                  [
                    36419.1,
                    37933.4
                  ],
                  [
                    36347.4,
                    38107.5
                  ],
                  [
                    36315,
                    38167.9
                  ],
                  [
                    36294.8,
                    38242
                  ],
                  [
                    36281.7,
                    38273.9
                  ],
                  [
                    36213.5,
                    38286.9
                  ],
                  [
                    36219.4,
                    38250.5
                  ],
                  [
                    36238,
                    38158.2
                  ],
                  [
                    36248.9,
                    38059
                  ],
                  [
                    36228,
                    37981
                  ],
                  [
                    36115.2,
                    37884.5
                  ],
                  [
                    36260,
                    37714.7
                  ],
                  [
                    36452.8,
                    37321.7
                  ],
                  [
                    36588.3,
                    37362.4
                  ],
                  [
                    36548.5,
                    37484.5
                  ],
                  [
                    36640.5,
                    37630.9
                  ],
                  [
                    36617.4,
                    37673.4
                  ],
                  [
                    36575,
                    37747.8
                  ]
                ],
                "id": 1307,
                "chat_link": "[&BBsFAAA=]"
              },
              "1309": {
                "name": "Chak Nest",
                "level": 80,
                "coord": [
                  36865.7,
                  37749.6
                ],
                "bounds": [
                  [
                    37092.8,
                    37809.3
                  ],
                  [
                    37033,
                    37888.6
                  ],
                  [
                    36929.7,
                    37953.8
                  ],
                  [
                    36851.6,
                    38013.3
                  ],
                  [
                    36756.9,
                    37996.5
                  ],
                  [
                    36668.6,
                    37955.6
                  ],
                  [
                    36556.2,
                    37889
                  ],
                  [
                    36501.6,
                    37850.4
                  ],
                  [
                    36627.9,
                    37639.5
                  ],
                  [
                    36732.5,
                    37582.7
                  ],
                  [
                    36899.3,
                    37488.3
                  ],
                  [
                    37005.2,
                    37418.7
                  ],
                  [
                    37117.2,
                    37409.2
                  ],
                  [
                    37117.4,
                    37625.6
                  ],
                  [
                    37095.3,
                    37724.1
                  ],
                  [
                    37092.8,
                    37809.3
                  ]
                ],
                "id": 1309,
                "chat_link": "[&BB0FAAA=]"
              },
              "1319": {
                "name": "Exhumed Delve",
                "level": 80,
                "coord": [
                  36796.3,
                  37229.9
                ],
                "bounds": [
                  [
                    37101.8,
                    36941.6
                  ],
                  [
                    37096.7,
                    37225
                  ],
                  [
                    37096.7,
                    37403.6
                  ],
                  [
                    37095.8,
                    37418
                  ],
                  [
                    37003.7,
                    37429.3
                  ],
                  [
                    36902.4,
                    37493.5
                  ],
                  [
                    36816.6,
                    37541.7
                  ],
                  [
                    36735.8,
                    37588.4
                  ],
                  [
                    36632.9,
                    37640.7
                  ],
                  [
                    36541.5,
                    37487.5
                  ],
                  [
                    36579.5,
                    37364.9
                  ],
                  [
                    36623.8,
                    37182.7
                  ],
                  [
                    36573.8,
                    37040.5
                  ],
                  [
                    36557.1,
                    36879.6
                  ],
                  [
                    36594.8,
                    36896.6
                  ],
                  [
                    36636.5,
                    36906.3
                  ],
                  [
                    36756.8,
                    36935.7
                  ],
                  [
                    36861.8,
                    36980.7
                  ],
                  [
                    36921.4,
                    37012.6
                  ],
                  [
                    37101.8,
                    36941.6
                  ]
                ],
                "id": 1319,
                "chat_link": "[&BCcFAAA=]"
              },
              "1320": {
                "name": "Central Barbed Gate",
                "level": 80,
                "coord": [
                  35926.4,
                  37460.8
                ],
                "bounds": [
                  [
                    35885.3,
                    36951.5
                  ],
                  [
                    35985.7,
                    37190.6
                  ],
                  [
                    36130.5,
                    37234.8
                  ],
                  [
                    36262.8,
                    37307
                  ],
                  [
                    36324,
                    37292.1
                  ],
                  [
                    36456,
                    37328
                  ],
                  [
                    36265.5,
                    37715.9
                  ],
                  [
                    36116.3,
                    37889.7
                  ],
                  [
                    35916.9,
                    37902
                  ],
                  [
                    35927.4,
                    37701.1
                  ],
                  [
                    35759.3,
                    37600.6
                  ],
                  [
                    35584.8,
                    37635.8
                  ],
                  [
                    35485.6,
                    37638.1
                  ],
                  [
                    35392.1,
                    37539.9
                  ],
                  [
                    35615.2,
                    37264.4
                  ],
                  [
                    35715.8,
                    37180.9
                  ],
                  [
                    35885.3,
                    36951.5
                  ]
                ],
                "id": 1320,
                "chat_link": "[&BCgFAAA=]"
              },
              "1327": {
                "name": "Southern Blighting Tower",
                "level": 80,
                "coord": [
                  36019.5,
                  38120.7
                ],
                "bounds": [
                  [
                    35921.5,
                    37896.1
                  ],
                  [
                    36122.4,
                    37874.9
                  ],
                  [
                    36234.3,
                    37975.3
                  ],
                  [
                    36254.4,
                    38057.9
                  ],
                  [
                    36243.5,
                    38156
                  ],
                  [
                    36204.5,
                    38341.6
                  ],
                  [
                    36065.7,
                    38378.7
                  ],
                  [
                    35904.6,
                    38269.1
                  ],
                  [
                    35700.8,
                    38237
                  ],
                  [
                    35729.5,
                    38089
                  ],
                  [
                    35833.1,
                    38052.2
                  ],
                  [
                    35921.5,
                    37896.1
                  ]
                ],
                "id": 1327,
                "chat_link": "[&BC8FAAA=]"
              },
              "1329": {
                "name": "Northern Barbed Gate",
                "level": 80,
                "coord": [
                  35271,
                  37166.5
                ],
                "bounds": [
                  [
                    35893.4,
                    36945.4
                  ],
                  [
                    35698.3,
                    36815.7
                  ],
                  [
                    35436,
                    36738
                  ],
                  [
                    35183.9,
                    36904.5
                  ],
                  [
                    34939.3,
                    36988.2
                  ],
                  [
                    34820.4,
                    37021.7
                  ],
                  [
                    34840.6,
                    37067.2
                  ],
                  [
                    35046.3,
                    37041.1
                  ],
                  [
                    35198.4,
                    37170.6
                  ],
                  [
                    35167.1,
                    37270.8
                  ],
                  [
                    35153.5,
                    37322
                  ],
                  [
                    35056.9,
                    37650.4
                  ],
                  [
                    35166.3,
                    37729.1
                  ],
                  [
                    35395.9,
                    37541.1
                  ],
                  [
                    35617.4,
                    37271.4
                  ],
                  [
                    35721.7,
                    37186.6
                  ],
                  [
                    35893.4,
                    36945.4
                  ]
                ],
                "id": 1329,
                "chat_link": "[&BDEFAAA=]"
              },
              "1333": {
                "name": "Prismatic Postpile",
                "level": 80,
                "coord": [
                  36809.1,
                  36788
                ],
                "bounds": [
                  [
                    37039.8,
                    36479.6
                  ],
                  [
                    37074.3,
                    36815.7
                  ],
                  [
                    37100.4,
                    36944.2
                  ],
                  [
                    36919.1,
                    37020.7
                  ],
                  [
                    36854.1,
                    36983.7
                  ],
                  [
                    36756.1,
                    36941.5
                  ],
                  [
                    36634.3,
                    36912.3
                  ],
                  [
                    36592.4,
                    36901.1
                  ],
                  [
                    36547.6,
                    36885.1
                  ],
                  [
                    36549.9,
                    36712
                  ],
                  [
                    36744.4,
                    36593.9
                  ],
                  [
                    36820.8,
                    36548.6
                  ],
                  [
                    36885.1,
                    36505.3
                  ],
                  [
                    37039.8,
                    36479.6
                  ]
                ],
                "id": 1333,
                "chat_link": "[&BDUFAAA=]"
              },
              "1334": {
                "name": "Wyvern Scar",
                "level": 80,
                "coord": [
                  36311.1,
                  37087.7
                ],
                "bounds": [
                  [
                    35934.3,
                    36820.3
                  ],
                  [
                    35877.2,
                    36942.5
                  ],
                  [
                    35981.1,
                    37194.5
                  ],
                  [
                    36126.8,
                    37240.7
                  ],
                  [
                    36262.3,
                    37315.3
                  ],
                  [
                    36323.9,
                    37297.1
                  ],
                  [
                    36585.7,
                    37368
                  ],
                  [
                    36629.7,
                    37183.7
                  ],
                  [
                    36579.5,
                    37039.3
                  ],
                  [
                    36567.2,
                    36873.7
                  ],
                  [
                    36491.2,
                    36972.3
                  ],
                  [
                    36406.5,
                    36988.7
                  ],
                  [
                    36279,
                    36903.7
                  ],
                  [
                    35934.3,
                    36820.3
                  ]
                ],
                "id": 1334,
                "chat_link": "[&BDYFAAA=]"
              },
              "1335": {
                "name": "Northern Blighting Tower",
                "level": 80,
                "coord": [
                  34966.3,
                  37303.3
                ],
                "bounds": [
                  [
                    34838.7,
                    37060.6
                  ],
                  [
                    34912.6,
                    37048.7
                  ],
                  [
                    35051.8,
                    37035.5
                  ],
                  [
                    35202.1,
                    37171.1
                  ],
                  [
                    35172.5,
                    37277.3
                  ],
                  [
                    35158.8,
                    37324.1
                  ],
                  [
                    35138.1,
                    37391.6
                  ],
                  [
                    35091.8,
                    37543.7
                  ],
                  [
                    35061.3,
                    37653.4
                  ],
                  [
                    34872.2,
                    37545.2
                  ],
                  [
                    34813.5,
                    37447.4
                  ],
                  [
                    34798.8,
                    37353.5
                  ],
                  [
                    34685.4,
                    37281.4
                  ],
                  [
                    34731,
                    37113.2
                  ],
                  [
                    34838.7,
                    37060.6
                  ]
                ],
                "id": 1335,
                "chat_link": "[&BDcFAAA=]"
              },
              "1339": {
                "name": "Toadstool Mire",
                "level": 80,
                "coord": [
                  36421.6,
                  36609.6
                ],
                "bounds": [
                  [
                    36748,
                    36596
                  ],
                  [
                    36554.5,
                    36713.3
                  ],
                  [
                    36561.3,
                    36884.9
                  ],
                  [
                    36494.8,
                    36977.4
                  ],
                  [
                    36407.7,
                    36998.6
                  ],
                  [
                    36271.1,
                    36909.5
                  ],
                  [
                    35932,
                    36825.4
                  ],
                  [
                    36033.5,
                    36598.9
                  ],
                  [
                    36234.7,
                    36600.7
                  ],
                  [
                    36291.3,
                    36533.8
                  ],
                  [
                    36312.7,
                    36422.7
                  ],
                  [
                    36395.5,
                    36311.6
                  ],
                  [
                    36486.2,
                    36349.9
                  ],
                  [
                    36582.2,
                    36292.6
                  ],
                  [
                    36710,
                    36327.4
                  ],
                  [
                    36729.6,
                    36410.8
                  ],
                  [
                    36748,
                    36596
                  ]
                ],
                "id": 1339,
                "chat_link": "[&BDsFAAA=]"
              },
              "1341": {
                "name": "Rooted Copse",
                "level": 80,
                "coord": [
                  35049.9,
                  36734.9
                ],
                "bounds": [
                  [
                    34823.6,
                    37030.6
                  ],
                  [
                    34853.6,
                    36871
                  ],
                  [
                    34861.9,
                    36812.3
                  ],
                  [
                    34882.2,
                    36714
                  ],
                  [
                    35024.3,
                    36625.8
                  ],
                  [
                    35085.3,
                    36519.3
                  ],
                  [
                    35226.9,
                    36358.6
                  ],
                  [
                    35218.6,
                    36501.3
                  ],
                  [
                    35437.6,
                    36740.4
                  ],
                  [
                    35189.7,
                    36912.4
                  ],
                  [
                    34945.2,
                    36998.5
                  ],
                  [
                    34823.6,
                    37030.6
                  ]
                ],
                "id": 1341,
                "chat_link": "[&BD0FAAA=]"
              },
              "1346": {
                "name": "Vigilant Precipice",
                "level": 80,
                "coord": [
                  36370.5,
                  36279.1
                ],
                "bounds": [
                  [
                    36745.4,
                    35902.9
                  ],
                  [
                    36657.9,
                    36105.8
                  ],
                  [
                    36708.7,
                    36333.3
                  ],
                  [
                    36582.4,
                    36301.5
                  ],
                  [
                    36487.2,
                    36355.1
                  ],
                  [
                    36397.5,
                    36318.1
                  ],
                  [
                    36319.6,
                    36423.4
                  ],
                  [
                    36297.7,
                    36536.6
                  ],
                  [
                    36239.4,
                    36607
                  ],
                  [
                    36033.4,
                    36608.7
                  ],
                  [
                    35871.7,
                    35959.4
                  ],
                  [
                    36105.3,
                    35897.3
                  ],
                  [
                    36745.4,
                    35902.9
                  ]
                ],
                "id": 1346,
                "chat_link": "[&BEIFAAA=]"
              },
              "1347": {
                "name": "Dragon's Domain",
                "level": 80,
                "coord": [
                  35009.7,
                  37986.5
                ],
                "bounds": [
                  [
                    34200.1,
                    37722.9
                  ],
                  [
                    34152.7,
                    37852.6
                  ],
                  [
                    34185.2,
                    38029.5
                  ],
                  [
                    34309.9,
                    38335.7
                  ],
                  [
                    34357.8,
                    38473.8
                  ],
                  [
                    34573.9,
                    38579.3
                  ],
                  [
                    34815.4,
                    38710.2
                  ],
                  [
                    35119.7,
                    38759.8
                  ],
                  [
                    35438.7,
                    38631.2
                  ],
                  [
                    35504.5,
                    38465.8
                  ],
                  [
                    35525.5,
                    38238.9
                  ],
                  [
                    35519.5,
                    38209.6
                  ],
                  [
                    35705.1,
                    38238.9
                  ],
                  [
                    35734.2,
                    38088.2
                  ],
                  [
                    35627.7,
                    38050.7
                  ],
                  [
                    35537.9,
                    38030.4
                  ],
                  [
                    35448.2,
                    38027.8
                  ],
                  [
                    35379.2,
                    37864
                  ],
                  [
                    35504.6,
                    37641.8
                  ],
                  [
                    35392.9,
                    37535.9
                  ],
                  [
                    35157.1,
                    37723.2
                  ],
                  [
                    35000.9,
                    37606.1
                  ],
                  [
                    34873.9,
                    37543
                  ],
                  [
                    34818.3,
                    37445
                  ],
                  [
                    34802.7,
                    37350.3
                  ],
                  [
                    34686.1,
                    37278.2
                  ],
                  [
                    34575.4,
                    37532.3
                  ],
                  [
                    34323.2,
                    37658
                  ],
                  [
                    34200.1,
                    37722.9
                  ]
                ],
                "id": 1347,
                "chat_link": "[&BEMFAAA=]"
              },
              "1353": {
                "name": "Broken Altar",
                "level": 80,
                "coord": [
                  35596.3,
                  36432.4
                ],
                "bounds": [
                  [
                    35936.7,
                    36211.1
                  ],
                  [
                    35871.2,
                    35954.3
                  ],
                  [
                    35574.1,
                    36015.7
                  ],
                  [
                    35260.4,
                    36037.1
                  ],
                  [
                    35089.8,
                    36182.8
                  ],
                  [
                    35223.1,
                    36359.4
                  ],
                  [
                    35212,
                    36504.6
                  ],
                  [
                    35428.8,
                    36742.3
                  ],
                  [
                    35696.7,
                    36819.9
                  ],
                  [
                    35885.6,
                    36944.4
                  ],
                  [
                    35942.2,
                    36818.6
                  ],
                  [
                    36035.4,
                    36597.9
                  ],
                  [
                    35936.7,
                    36211.1
                  ]
                ],
                "id": 1353,
                "chat_link": "[&BEkFAAA=]"
              }
            },
            "adventures": [],
            "id": 1041,
            "mastery_points": []
          },
          "1043": {
            "name": "Auric Basin",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              34304,
              33792
            ],
            "map_rect": [
              [
                -24576,
                -33792
              ],
              [
                24576,
                33792
              ]
            ],
            "continent_rect": [
              [
                33280,
                32512
              ],
              [
                35328,
                35328
              ]
            ],
            "points_of_interest": {
              "1987": {
                "name": "Luminate's Throne",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34045.9,
                  33929.3
                ],
                "id": 1987,
                "chat_link": "[&BMMHAAA=]"
              },
              "1990": {
                "name": "Forgotten City Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34318.4,
                  33966.2
                ],
                "id": 1990,
                "chat_link": "[&BMYHAAA=]"
              },
              "1992": {
                "name": "Thornwatch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34410.4,
                  35156.5
                ],
                "id": 1992,
                "chat_link": "[&BMgHAAA=]"
              },
              "1993": {
                "name": "Northgate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34306.1,
                  33544.2
                ],
                "id": 1993,
                "chat_link": "[&BMkHAAA=]"
              },
              "1997": {
                "name": "Overseer's Cave",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34065.3,
                  34864.9
                ],
                "id": 1997,
                "chat_link": "[&BM0HAAA=]"
              },
              "2000": {
                "name": "Bramble Plateau",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34388.1,
                  32787.5
                ],
                "id": 2000,
                "chat_link": "[&BNAHAAA=]"
              },
              "2002": {
                "name": "Capitzel Grounds",
                "type": "landmark",
                "floor": 2,
                "coord": [
                  33493.8,
                  32980.1
                ],
                "id": 2002,
                "chat_link": "[&BNIHAAA=]"
              },
              "2003": {
                "name": "Quazupl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35025.3,
                  32786.2
                ],
                "id": 2003,
                "chat_link": "[&BNMHAAA=]"
              },
              "2004": {
                "name": "Weeping Glade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34997.6,
                  34256.8
                ],
                "id": 2004,
                "chat_link": "[&BNQHAAA=]"
              },
              "2006": {
                "name": "Wanderer's Waypoint",
                "type": "waypoint",
                "floor": 2,
                "coord": [
                  33672.4,
                  32820.5
                ],
                "id": 2006,
                "chat_link": "[&BNYHAAA=]"
              },
              "2007": {
                "name": "Inner Chamber",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34661,
                  34276
                ],
                "id": 2007,
                "chat_link": "[&BNcHAAA=]"
              },
              "2009": {
                "name": "Jawatl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34626.2,
                  34941.8
                ],
                "id": 2009,
                "chat_link": "[&BNkHAAA=]"
              },
              "2013": {
                "name": "Northwatch Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34402.5,
                  33143.6
                ],
                "id": 2013,
                "chat_link": "[&BN0HAAA=]"
              },
              "2018": {
                "name": "Masks of the Fallen",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33979.1,
                  33535.8
                ],
                "id": 2018,
                "chat_link": "[&BOIHAAA=]"
              },
              "2019": {
                "name": "Eastgate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34889.7,
                  33919.7
                ],
                "id": 2019,
                "chat_link": "[&BOMHAAA=]"
              },
              "2024": {
                "name": "Legacy Pillars",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34305.9,
                  33917.5
                ],
                "id": 2024,
                "chat_link": "[&BOgHAAA=]"
              },
              "2026": {
                "name": "New Skrittington",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33787,
                  33293.2
                ],
                "id": 2026,
                "chat_link": "[&BOoHAAA=]"
              },
              "2028": {
                "name": "Endurance Crash Site",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34819.4,
                  34618.2
                ],
                "id": 2028,
                "chat_link": "[&BOwHAAA=]"
              },
              "2029": {
                "name": "Westgate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33923,
                  33773.5
                ],
                "id": 2029,
                "chat_link": "[&BO0HAAA=]"
              },
              "2033": {
                "name": "Vinetooth Den",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35212.4,
                  33365.4
                ],
                "id": 2033,
                "chat_link": "[&BPEHAAA=]"
              },
              "2038": {
                "name": "Southgate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34304.6,
                  34365.6
                ],
                "id": 2038,
                "chat_link": "[&BPYHAAA=]"
              },
              "2040": {
                "name": "Eastwatch Ruins",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35228.9,
                  33828.5
                ],
                "id": 2040,
                "chat_link": "[&BPgHAAA=]"
              },
              "2041": {
                "name": "Northwatch Priory Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34514.8,
                  33089
                ],
                "id": 2041,
                "chat_link": "[&BPkHAAA=]"
              },
              "2044": {
                "name": "Fahautl Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33759.6,
                  34308.3
                ],
                "id": 2044,
                "chat_link": "[&BPwHAAA=]"
              },
              "2050": {
                "name": "Southwatch Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34227.8,
                  34590.9
                ],
                "id": 2050,
                "chat_link": "[&BAIIAAA=]"
              },
              "2054": {
                "name": "Westwatch Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  33703.9,
                  33522.1
                ],
                "id": 2054,
                "chat_link": "[&BAYIAAA=]"
              },
              "2057": {
                "name": "Sealed Passageway",
                "type": "landmark",
                "floor": 0,
                "coord": [
                  34666.7,
                  33685.1
                ],
                "id": 2057,
                "chat_link": "[&BAkIAAA=]"
              },
              "2121": {
                "name": "Chak Hollow Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34864.1,
                  35025
                ],
                "id": 2121,
                "chat_link": "[&BEkIAAA=]"
              },
              "2128": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  34969.1,
                  34389.4
                ],
                "id": 2128,
                "chat_link": "[&BFAIAAA=]"
              },
              "2156": {
                "name": "Eastwatch Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  35047.7,
                  33802.8
                ],
                "id": 2156,
                "chat_link": "[&BGwIAAA=]"
              },
              "2157": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  33677,
                  34331.1
                ],
                "id": 2157,
                "chat_link": "[&BG0IAAA=]"
              },
              "2220": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  33818.8,
                  33210.8
                ],
                "id": 2220,
                "chat_link": "[&BKwIAAA=]"
              },
              "2232": {
                "type": "vista",
                "floor": 0,
                "coord": [
                  34515.8,
                  34224.5
                ],
                "id": 2232,
                "chat_link": "[&BLgIAAA=]"
              },
              "2249": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  34856.7,
                  33891.8
                ],
                "id": 2249,
                "chat_link": "[&BMkIAAA=]"
              },
              "2284": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  34785.8,
                  32725
                ],
                "id": 2284,
                "chat_link": "[&BOwIAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [
              {
                "coord": [
                  33779.3,
                  35184.8
                ],
                "id": "1-11"
              },
              {
                "coord": [
                  35203.8,
                  33511
                ],
                "id": "1-12"
              },
              {
                "coord": [
                  34861.8,
                  32648.1
                ],
                "id": "1-13"
              },
              {
                "coord": [
                  34537.1,
                  33280.6
                ],
                "id": "1-14"
              },
              {
                "coord": [
                  34502.6,
                  33717.9
                ],
                "id": "1-15"
              },
              {
                "coord": [
                  34279.1,
                  33722.5
                ],
                "id": "1-16"
              },
              {
                "coord": [
                  33642.2,
                  32992.4
                ],
                "id": "1-17"
              },
              {
                "coord": [
                  35249,
                  34548.9
                ],
                "id": "1-18"
              },
              {
                "coord": [
                  34750.8,
                  35273.2
                ],
                "id": "1-19"
              },
              {
                "coord": [
                  33608,
                  33213.6
                ],
                "id": "1-20"
              },
              {
                "coord": [
                  33372.7,
                  34432.5
                ],
                "id": "1-21"
              }
            ],
            "sectors": {
              "1218": {
                "name": "Southwatch Creep",
                "level": 80,
                "coord": [
                  34351.9,
                  34715.8
                ],
                "bounds": [
                  [
                    34281.2,
                    34367
                  ],
                  [
                    34370,
                    34364
                  ],
                  [
                    34615.6,
                    34504.5
                  ],
                  [
                    34654.6,
                    34667.6
                  ],
                  [
                    34628.6,
                    34832.7
                  ],
                  [
                    34577.9,
                    34854.3
                  ],
                  [
                    34546.1,
                    34933.2
                  ],
                  [
                    34467.2,
                    34919.9
                  ],
                  [
                    34184.3,
                    34913.5
                  ],
                  [
                    34114.3,
                    34987.2
                  ],
                  [
                    34011.5,
                    34862.3
                  ],
                  [
                    34015.5,
                    34540
                  ],
                  [
                    34108.3,
                    34559.8
                  ],
                  [
                    34281.2,
                    34367
                  ]
                ],
                "id": 1218,
                "chat_link": "[&BMIEAAA=]"
              },
              "1219": {
                "name": "Balthazar's Rest",
                "level": 80,
                "coord": [
                  33879.3,
                  35100.1
                ],
                "bounds": [
                  [
                    33602.1,
                    35301.6
                  ],
                  [
                    33615.6,
                    35070
                  ],
                  [
                    33878.2,
                    34954.7
                  ],
                  [
                    33912.4,
                    34847.9
                  ],
                  [
                    34013.9,
                    34853.4
                  ],
                  [
                    34142.4,
                    35034.8
                  ],
                  [
                    34000.1,
                    35110
                  ],
                  [
                    33975.3,
                    35310.6
                  ],
                  [
                    33773.7,
                    35418.3
                  ],
                  [
                    33602.1,
                    35301.6
                  ]
                ],
                "id": 1219,
                "chat_link": "[&BMMEAAA=]"
              },
              "1220": {
                "name": "Burnisher Quarry",
                "level": 80,
                "coord": [
                  34947.3,
                  32796.9
                ],
                "bounds": [
                  [
                    34605.5,
                    32481.5
                  ],
                  [
                    34907.7,
                    32483.3
                  ],
                  [
                    35099.7,
                    32380.2
                  ],
                  [
                    35376.2,
                    32609
                  ],
                  [
                    35353.4,
                    33003.4
                  ],
                  [
                    35244.1,
                    33238.8
                  ],
                  [
                    35050.3,
                    33365.3
                  ],
                  [
                    34944.1,
                    33013.2
                  ],
                  [
                    34889.1,
                    32932.7
                  ],
                  [
                    34741,
                    32816.5
                  ],
                  [
                    34620.7,
                    32688.6
                  ],
                  [
                    34535.7,
                    32550
                  ],
                  [
                    34605.5,
                    32481.5
                  ]
                ],
                "id": 1220,
                "chat_link": "[&BMQEAAA=]"
              },
              "1222": {
                "name": "Westwatch Patch",
                "level": 80,
                "coord": [
                  33654.8,
                  33521.4
                ],
                "bounds": [
                  [
                    33289,
                    33929.2
                  ],
                  [
                    33353.3,
                    33938.3
                  ],
                  [
                    33430.2,
                    33798.7
                  ],
                  [
                    33657.4,
                    33953.5
                  ],
                  [
                    33871.4,
                    33796.2
                  ],
                  [
                    33944.8,
                    33664.5
                  ],
                  [
                    33869.2,
                    33574.4
                  ],
                  [
                    33839.5,
                    33366.3
                  ],
                  [
                    33876.5,
                    33333.6
                  ],
                  [
                    33948.4,
                    33324
                  ],
                  [
                    33795,
                    33139.7
                  ],
                  [
                    33741.6,
                    33212.9
                  ],
                  [
                    33517.4,
                    33111.5
                  ],
                  [
                    33397,
                    33197.4
                  ],
                  [
                    33290.8,
                    33480.8
                  ],
                  [
                    33289,
                    33929.2
                  ]
                ],
                "id": 1222,
                "chat_link": "[&BMYEAAA=]"
              },
              "1224": {
                "name": "Tarnished Treetop",
                "level": 80,
                "coord": [
                  33694.9,
                  32853
                ],
                "bounds": [
                  [
                    33439.6,
                    32543.3
                  ],
                  [
                    33582.2,
                    32425.4
                  ],
                  [
                    33750,
                    32552.6
                  ],
                  [
                    34079.8,
                    32448.6
                  ],
                  [
                    34227.7,
                    32591.1
                  ],
                  [
                    34108.1,
                    32981.7
                  ],
                  [
                    34050.2,
                    32965.3
                  ],
                  [
                    33843,
                    33073.6
                  ],
                  [
                    33742.3,
                    33213
                  ],
                  [
                    33516.7,
                    33109.2
                  ],
                  [
                    33397.5,
                    33197.8
                  ],
                  [
                    33300.4,
                    33116.5
                  ],
                  [
                    33295.2,
                    32895.2
                  ],
                  [
                    33396.2,
                    32828.5
                  ],
                  [
                    33439.6,
                    32543.3
                  ]
                ],
                "id": 1224,
                "chat_link": "[&BMgEAAA=]"
              },
              "1225": {
                "name": "Mossheart Walk",
                "level": 80,
                "coord": [
                  34880.8,
                  34672
                ],
                "bounds": [
                  [
                    34613.3,
                    34499.6
                  ],
                  [
                    35084,
                    34396.6
                  ],
                  [
                    35193.6,
                    34752.2
                  ],
                  [
                    35110.7,
                    34883.6
                  ],
                  [
                    34629,
                    34832.1
                  ],
                  [
                    34654.3,
                    34667.9
                  ],
                  [
                    34613.3,
                    34499.6
                  ]
                ],
                "id": 1225,
                "chat_link": "[&BMkEAAA=]"
              },
              "1226": {
                "name": "Arrowhead Vale",
                "level": 80,
                "coord": [
                  34197,
                  33265.2
                ],
                "bounds": [
                  [
                    34130.2,
                    33460.5
                  ],
                  [
                    34050.1,
                    33346.4
                  ],
                  [
                    33946.5,
                    33323.6
                  ],
                  [
                    33794,
                    33137.6
                  ],
                  [
                    33842.2,
                    33070
                  ],
                  [
                    34049.3,
                    32966.6
                  ],
                  [
                    34259.3,
                    33020.9
                  ],
                  [
                    34270.4,
                    33168.7
                  ],
                  [
                    34533.1,
                    33187.9
                  ],
                  [
                    34592.5,
                    33280.3
                  ],
                  [
                    34481.4,
                    33502.1
                  ],
                  [
                    34403.6,
                    33488.7
                  ],
                  [
                    34208.8,
                    33494.1
                  ],
                  [
                    34130.2,
                    33460.5
                  ]
                ],
                "id": 1226,
                "chat_link": "[&BMoEAAA=]"
              },
              "1230": {
                "name": "Maguuma Shallows",
                "level": 80,
                "coord": [
                  34744.4,
                  33233.8
                ],
                "bounds": [
                  [
                    34530.6,
                    33189.2
                  ],
                  [
                    34743,
                    32958.8
                  ],
                  [
                    34696.1,
                    32905.2
                  ],
                  [
                    34739.4,
                    32812.5
                  ],
                  [
                    34890.2,
                    32929.9
                  ],
                  [
                    34947.4,
                    33008.1
                  ],
                  [
                    35050.6,
                    33366.6
                  ],
                  [
                    34917.3,
                    33593.1
                  ],
                  [
                    34748.2,
                    33703.3
                  ],
                  [
                    34592.4,
                    33556.5
                  ],
                  [
                    34482.7,
                    33502.2
                  ],
                  [
                    34595.2,
                    33280.8
                  ],
                  [
                    34530.6,
                    33189.2
                  ]
                ],
                "id": 1230,
                "chat_link": "[&BM4EAAA=]"
              },
              "1236": {
                "name": "Northwatch Descent",
                "level": 80,
                "coord": [
                  34474.7,
                  32887
                ],
                "bounds": [
                  [
                    34227.1,
                    32589.4
                  ],
                  [
                    34538,
                    32550.3
                  ],
                  [
                    34622.3,
                    32686.8
                  ],
                  [
                    34739.9,
                    32816.6
                  ],
                  [
                    34700,
                    32905.9
                  ],
                  [
                    34747.1,
                    32958.7
                  ],
                  [
                    34535.6,
                    33194.3
                  ],
                  [
                    34270.7,
                    33168.8
                  ],
                  [
                    34259.2,
                    33018.5
                  ],
                  [
                    34106.7,
                    32980.6
                  ],
                  [
                    34227.1,
                    32589.4
                  ]
                ],
                "id": 1236,
                "chat_link": "[&BNQEAAA=]"
              },
              "1240": {
                "name": "Chak Hollow",
                "level": 80,
                "coord": [
                  34912.7,
                  35054.1
                ],
                "bounds": [
                  [
                    35432.5,
                    35009.2
                  ],
                  [
                    35369.1,
                    35375.1
                  ],
                  [
                    35165.6,
                    35298.1
                  ],
                  [
                    34912.6,
                    35367.7
                  ],
                  [
                    34777.9,
                    35289.3
                  ],
                  [
                    34639,
                    35294.8
                  ],
                  [
                    34535.5,
                    35128.4
                  ],
                  [
                    34558.6,
                    34989.9
                  ],
                  [
                    34545.6,
                    34933.7
                  ],
                  [
                    34577.7,
                    34852.7
                  ],
                  [
                    34628.6,
                    34830.4
                  ],
                  [
                    35112.6,
                    34882.3
                  ],
                  [
                    35195.1,
                    34752.2
                  ],
                  [
                    35327.5,
                    34753.9
                  ],
                  [
                    35432.5,
                    35009.2
                  ]
                ],
                "id": 1240,
                "chat_link": "[&BNgEAAA=]"
              },
              "1241": {
                "name": "Bristleback Chasm",
                "level": 80,
                "coord": [
                  35030.9,
                  33824.5
                ],
                "bounds": [
                  [
                    34896.2,
                    33822
                  ],
                  [
                    34743.5,
                    33702.7
                  ],
                  [
                    34914.7,
                    33594.1
                  ],
                  [
                    35051.1,
                    33368.1
                  ],
                  [
                    35244.9,
                    33239.5
                  ],
                  [
                    35354.7,
                    33343.4
                  ],
                  [
                    35344.1,
                    33465.7
                  ],
                  [
                    35155.4,
                    33488.8
                  ],
                  [
                    35039.9,
                    33655.3
                  ],
                  [
                    35038.7,
                    33822.1
                  ],
                  [
                    35109.9,
                    33899.8
                  ],
                  [
                    35084.5,
                    34113.6
                  ],
                  [
                    35126.7,
                    34245.1
                  ],
                  [
                    35083.2,
                    34398.4
                  ],
                  [
                    34718.5,
                    34480.4
                  ],
                  [
                    34722,
                    34381.5
                  ],
                  [
                    34897.6,
                    33996.8
                  ],
                  [
                    34896.2,
                    33822
                  ]
                ],
                "id": 1241,
                "chat_link": "[&BNkEAAA=]"
              },
              "1244": {
                "name": "Tarir, the Forgotten City",
                "level": 80,
                "coord": [
                  34256.9,
                  33880.9
                ],
                "bounds": [
                  [
                    34130.7,
                    33460.9
                  ],
                  [
                    34213.3,
                    33495
                  ],
                  [
                    34411.2,
                    33485.1
                  ],
                  [
                    34479,
                    33502.6
                  ],
                  [
                    34594.1,
                    33554.8
                  ],
                  [
                    34743.5,
                    33700.4
                  ],
                  [
                    34901.2,
                    33832.4
                  ],
                  [
                    34898.1,
                    33996.9
                  ],
                  [
                    34722,
                    34382.7
                  ],
                  [
                    34717.9,
                    34480.3
                  ],
                  [
                    34615,
                    34505
                  ],
                  [
                    34378.2,
                    34364.8
                  ],
                  [
                    34281.7,
                    34367.8
                  ],
                  [
                    34110.1,
                    34559.7
                  ],
                  [
                    34018,
                    34540
                  ],
                  [
                    33972,
                    34279.2
                  ],
                  [
                    33998.4,
                    34148.9
                  ],
                  [
                    33839.6,
                    33959.6
                  ],
                  [
                    33872,
                    33797.5
                  ],
                  [
                    33945.8,
                    33664.7
                  ],
                  [
                    33869.3,
                    33574.5
                  ],
                  [
                    33839.8,
                    33366.6
                  ],
                  [
                    33876.5,
                    33333.6
                  ],
                  [
                    33945.2,
                    33324.4
                  ],
                  [
                    34049.4,
                    33344.2
                  ],
                  [
                    34130.7,
                    33460.9
                  ]
                ],
                "id": 1244,
                "chat_link": "[&BNwEAAA=]"
              },
              "1245": {
                "name": "Eastwatch Bluff",
                "level": 80,
                "coord": [
                  35192.6,
                  34030.3
                ],
                "bounds": [
                  [
                    35111.6,
                    33900.3
                  ],
                  [
                    35040.6,
                    33817
                  ],
                  [
                    35042.6,
                    33656.7
                  ],
                  [
                    35157.4,
                    33486.7
                  ],
                  [
                    35344.4,
                    33464.2
                  ],
                  [
                    35380.7,
                    33921.3
                  ],
                  [
                    35464,
                    34095.5
                  ],
                  [
                    35308.9,
                    34603.2
                  ],
                  [
                    35167.1,
                    34666.1
                  ],
                  [
                    35082.1,
                    34395.1
                  ],
                  [
                    35127.6,
                    34247
                  ],
                  [
                    35084.1,
                    34111.1
                  ],
                  [
                    35111.6,
                    33900.3
                  ]
                ],
                "id": 1245,
                "chat_link": "[&BN0EAAA=]"
              },
              "1248": {
                "name": "Griffonfall",
                "level": 80,
                "coord": [
                  33744.4,
                  34794.9
                ],
                "bounds": [
                  [
                    34026.8,
                    34592
                  ],
                  [
                    34013.4,
                    34855.7
                  ],
                  [
                    33913.7,
                    34846.9
                  ],
                  [
                    33870.8,
                    34950.5
                  ],
                  [
                    33615.8,
                    35074.9
                  ],
                  [
                    33469.2,
                    34983.9
                  ],
                  [
                    33360.8,
                    34701.6
                  ],
                  [
                    33574.1,
                    34530.1
                  ],
                  [
                    33855.2,
                    34618.7
                  ],
                  [
                    34026.8,
                    34592
                  ]
                ],
                "id": 1248,
                "chat_link": "[&BOAEAAA=]"
              },
              "1258": {
                "name": "The Falls",
                "level": 80,
                "coord": [
                  33850.5,
                  34371.3
                ],
                "bounds": [
                  [
                    33555.7,
                    34301
                  ],
                  [
                    33568.8,
                    34529.4
                  ],
                  [
                    33860.1,
                    34620.1
                  ],
                  [
                    34026.3,
                    34592.7
                  ],
                  [
                    33972.8,
                    34291.5
                  ],
                  [
                    33997.6,
                    34148.4
                  ],
                  [
                    33972.2,
                    34115.9
                  ],
                  [
                    33555.7,
                    34301
                  ]
                ],
                "id": 1258,
                "chat_link": "[&BOoEAAA=]"
              },
              "1260": {
                "name": "Lastgear Standing",
                "level": 80,
                "coord": [
                  33548.4,
                  34170.6
                ],
                "bounds": [
                  [
                    33556.1,
                    34304
                  ],
                  [
                    33971.2,
                    34117
                  ],
                  [
                    33839.8,
                    33959.7
                  ],
                  [
                    33872.2,
                    33797.8
                  ],
                  [
                    33656.5,
                    33957.7
                  ],
                  [
                    33430.5,
                    33798.9
                  ],
                  [
                    33316.8,
                    33985.4
                  ],
                  [
                    33363.5,
                    34143.2
                  ],
                  [
                    33301.4,
                    34229.2
                  ],
                  [
                    33300.9,
                    34561.3
                  ],
                  [
                    33402.1,
                    34663.3
                  ],
                  [
                    33569.4,
                    34529.8
                  ],
                  [
                    33556.1,
                    34304
                  ]
                ],
                "id": 1260,
                "chat_link": "[&BOwEAAA=]"
              },
              "1262": {
                "name": "Morwood Wilds",
                "level": 80,
                "coord": [
                  34324.3,
                  35092.1
                ],
                "bounds": [
                  [
                    34422.2,
                    35408.7
                  ],
                  [
                    33971.6,
                    35312.5
                  ],
                  [
                    33999.9,
                    35108
                  ],
                  [
                    34141.1,
                    35035.4
                  ],
                  [
                    34099.4,
                    34975.9
                  ],
                  [
                    34184.2,
                    34914.3
                  ],
                  [
                    34466.6,
                    34918.1
                  ],
                  [
                    34545.1,
                    34933.9
                  ],
                  [
                    34559.1,
                    34989.4
                  ],
                  [
                    34537.9,
                    35124.4
                  ],
                  [
                    34640.8,
                    35292.8
                  ],
                  [
                    34422.2,
                    35408.7
                  ]
                ],
                "id": 1262,
                "chat_link": "[&BO4EAAA=]"
              }
            },
            "adventures": [],
            "id": 1043,
            "mastery_points": [
              {
                "coord": [
                  34175,
                  34761.6
                ],
                "id": 114,
                "region": "Maguuma"
              },
              {
                "coord": [
                  35138.6,
                  33196.1
                ],
                "id": 144,
                "region": "Maguuma"
              },
              {
                "coord": [
                  35274.3,
                  34231.8
                ],
                "id": 120,
                "region": "Maguuma"
              },
              {
                "coord": [
                  33620.2,
                  34167.2
                ],
                "id": 119,
                "region": "Maguuma"
              },
              {
                "coord": [
                  34578.1,
                  34900.3
                ],
                "id": 116,
                "region": "Maguuma"
              },
              {
                "coord": [
                  34056.4,
                  33483.3
                ],
                "id": 137,
                "region": "Maguuma"
              },
              {
                "coord": [
                  34120.5,
                  33928.1
                ],
                "id": 40,
                "region": "Maguuma"
              },
              {
                "coord": [
                  33608.5,
                  34402.3
                ],
                "id": 59,
                "region": "Maguuma"
              }
            ]
          },
          "1045": {
            "name": "Tangled Depths",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37004,
              34748
            ],
            "map_rect": [
              [
                -39936,
                -27648
              ],
              [
                39936,
                27648
              ]
            ],
            "continent_rect": [
              [
                35328,
                33792
              ],
              [
                38656,
                36096
              ]
            ],
            "points_of_interest": {
              "1988": {
                "name": "Arboreal Overlook",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36180,
                  35041.2
                ],
                "id": 1988,
                "chat_link": "[&BMQHAAA=]"
              },
              "1996": {
                "name": "Ogre Camp Waypoint",
                "type": "waypoint",
                "floor": 2,
                "coord": [
                  36673.7,
                  35237.7
                ],
                "id": 1996,
                "chat_link": "[&BMwHAAA=]"
              },
              "1998": {
                "name": "Ley Line Node",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36301.9,
                  35710.9
                ],
                "id": 1998,
                "chat_link": "[&BM4HAAA=]"
              },
              "2001": {
                "name": "Vine Wall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38336.2,
                  35850.7
                ],
                "id": 2001,
                "chat_link": "[&BNEHAAA=]"
              },
              "2008": {
                "name": "Ley Flow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36939.8,
                  35092.1
                ],
                "id": 2008,
                "chat_link": "[&BNgHAAA=]"
              },
              "2010": {
                "name": "Rata Novus Command Center",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37649.3,
                  35111
                ],
                "id": 2010,
                "chat_link": "[&BNoHAAA=]"
              },
              "2011": {
                "name": "Tranquil Refuge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36193.7,
                  35449.1
                ],
                "id": 2011,
                "chat_link": "[&BNsHAAA=]"
              },
              "2012": {
                "name": "Chak Staging Area",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36315.1,
                  34551.4
                ],
                "id": 2012,
                "chat_link": "[&BNwHAAA=]"
              },
              "2015": {
                "name": "Decrepit Chak Nest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37701.9,
                  34278.1
                ],
                "id": 2015,
                "chat_link": "[&BN8HAAA=]"
              },
              "2020": {
                "name": "Ogre Crash Site",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36865.2,
                  35495.4
                ],
                "id": 2020,
                "chat_link": "[&BOQHAAA=]"
              },
              "2022": {
                "name": "Kaana's Terrace",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36950.2,
                  34289.4
                ],
                "id": 2022,
                "chat_link": "[&BOYHAAA=]"
              },
              "2023": {
                "name": "Gnarled Roots",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35925.6,
                  35043.8
                ],
                "id": 2023,
                "chat_link": "[&BOcHAAA=]"
              },
              "2035": {
                "name": "Cascade Descent",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38212.7,
                  35245.3
                ],
                "id": 2035,
                "chat_link": "[&BPMHAAA=]"
              },
              "2037": {
                "name": "Ley-Line Confluence Waypoint",
                "type": "waypoint",
                "floor": 0,
                "coord": [
                  37246.5,
                  35515.6
                ],
                "id": 2037,
                "chat_link": "[&BPUHAAA=]"
              },
              "2039": {
                "name": "Rata Novus Perimeter",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37666.1,
                  34729.9
                ],
                "id": 2039,
                "chat_link": "[&BPcHAAA=]"
              },
              "2048": {
                "name": "SCAR Camp Waypoint",
                "type": "waypoint",
                "floor": 2,
                "coord": [
                  37974.7,
                  35495.3
                ],
                "id": 2048,
                "chat_link": "[&BAAIAAA=]"
              },
              "2051": {
                "name": "Rata Novus Waypoint",
                "type": "waypoint",
                "floor": 0,
                "coord": [
                  37716.8,
                  34709.8
                ],
                "id": 2051,
                "chat_link": "[&BAMIAAA=]"
              },
              "2052": {
                "name": "Subterranean Lake",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36945.5,
                  34209.5
                ],
                "id": 2052,
                "chat_link": "[&BAQIAAA=]"
              },
              "2053": {
                "name": "Order of Whispers Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35830.3,
                  34635.4
                ],
                "id": 2053,
                "chat_link": "[&BAUIAAA=]"
              },
              "2055": {
                "name": "Rata Novus Orchards",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37536,
                  35006.1
                ],
                "id": 2055,
                "chat_link": "[&BAcIAAA=]"
              },
              "2058": {
                "name": "Sheltered Clearing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37937.3,
                  35482.3
                ],
                "id": 2058,
                "chat_link": "[&BAoIAAA=]"
              },
              "2060": {
                "name": "Teku Nuhoch Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  37039.4,
                  34324.5
                ],
                "id": 2060,
                "chat_link": "[&BAwIAAA=]"
              },
              "2062": {
                "name": "Order of Whispers Camp Waypoint",
                "type": "waypoint",
                "floor": 2,
                "coord": [
                  35826,
                  34605.7
                ],
                "id": 2062,
                "chat_link": "[&BA4IAAA=]"
              },
              "2063": {
                "name": "Twisting Viaduct",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35817.8,
                  35798.3
                ],
                "id": 2063,
                "chat_link": "[&BA8IAAA=]"
              },
              "2068": {
                "name": "Terraced Hive",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38267.7,
                  35136
                ],
                "id": 2068,
                "chat_link": "[&BBQIAAA=]"
              },
              "2069": {
                "name": "Order of Whispers Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36185.4,
                  34744.2
                ],
                "id": 2069,
                "chat_link": "[&BBUIAAA=]"
              },
              "2070": {
                "type": "vista",
                "floor": 2,
                "coord": [
                  38267.4,
                  35244.8
                ],
                "id": 2070,
                "chat_link": "[&BBYIAAA=]"
              },
              "2133": {
                "type": "vista",
                "floor": 2,
                "coord": [
                  36144.7,
                  34816.3
                ],
                "id": 2133,
                "chat_link": "[&BFUIAAA=]"
              },
              "2184": {
                "name": "Dragon's Passage Waypoint",
                "type": "waypoint",
                "floor": 0,
                "coord": [
                  35651.7,
                  35858.9
                ],
                "id": 2184,
                "chat_link": "[&BIgIAAA=]"
              },
              "2213": {
                "type": "vista",
                "floor": 2,
                "coord": [
                  38140.5,
                  35752.2
                ],
                "id": 2213,
                "chat_link": "[&BKUIAAA=]"
              },
              "2214": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  36215.1,
                  35323.7
                ],
                "id": 2214,
                "chat_link": "[&BKYIAAA=]"
              },
              "2236": {
                "type": "vista",
                "floor": 2,
                "coord": [
                  36867.2,
                  34756.1
                ],
                "id": 2236,
                "chat_link": "[&BLwIAAA=]"
              },
              "2300": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  37705.1,
                  34689.3
                ],
                "id": 2300,
                "chat_link": "[&BPwIAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [
              {
                "coord": [
                  35635.2,
                  35669.7
                ],
                "id": "1-22"
              },
              {
                "coord": [
                  37294,
                  34723.6
                ],
                "id": "1-23"
              },
              {
                "coord": [
                  36047.9,
                  34304.2
                ],
                "id": "1-24"
              },
              {
                "coord": [
                  36204.6,
                  35778.8
                ],
                "id": "1-25"
              },
              {
                "coord": [
                  37670.4,
                  34205.6
                ],
                "id": "1-26"
              },
              {
                "coord": [
                  36053.1,
                  35454.3
                ],
                "id": "1-27"
              },
              {
                "coord": [
                  35825.9,
                  35022.5
                ],
                "id": "1-28"
              },
              {
                "coord": [
                  36629.6,
                  34364.8
                ],
                "id": "1-29"
              },
              {
                "coord": [
                  37492.9,
                  35081.5
                ],
                "id": "1-30"
              },
              {
                "coord": [
                  35976.9,
                  35372
                ],
                "id": "1-31"
              },
              {
                "coord": [
                  36119.6,
                  35181.3
                ],
                "id": "1-32"
              }
            ],
            "sectors": {
              "1221": {
                "name": "Undergrowth Connector",
                "level": 80,
                "coord": [
                  36603.1,
                  34355.3
                ],
                "bounds": [
                  [
                    36372.9,
                    34397.9
                  ],
                  [
                    36551.2,
                    34579.6
                  ],
                  [
                    36811.1,
                    34806
                  ],
                  [
                    36846.6,
                    34686.3
                  ],
                  [
                    36697.5,
                    34530.8
                  ],
                  [
                    36670.8,
                    33960.8
                  ],
                  [
                    36564,
                    33932.9
                  ],
                  [
                    36311.1,
                    33948
                  ],
                  [
                    36372.9,
                    34397.9
                  ]
                ],
                "id": 1221,
                "chat_link": "[&BMUEAAA=]"
              },
              "1223": {
                "name": "Deeproot Sink",
                "level": 80,
                "coord": [
                  36020.8,
                  35459
                ],
                "bounds": [
                  [
                    35726,
                    35303
                  ],
                  [
                    35859.4,
                    35256.4
                  ],
                  [
                    36125.3,
                    35229.8
                  ],
                  [
                    36292.8,
                    35245.8
                  ],
                  [
                    36234.4,
                    35395.6
                  ],
                  [
                    36358,
                    35593.5
                  ],
                  [
                    36113.2,
                    35653.6
                  ],
                  [
                    35936.5,
                    35731.5
                  ],
                  [
                    35847.7,
                    35666.2
                  ],
                  [
                    35714.3,
                    35514.7
                  ],
                  [
                    35726,
                    35303
                  ]
                ],
                "id": 1223,
                "chat_link": "[&BMcEAAA=]"
              },
              "1227": {
                "name": "Eastern Confluence Tunnel",
                "level": 80,
                "coord": [
                  37699.5,
                  35649.9
                ],
                "bounds": [
                  [
                    37838.7,
                    35537.3
                  ],
                  [
                    37940.9,
                    35567.7
                  ],
                  [
                    37930.8,
                    35715
                  ],
                  [
                    37654.4,
                    35936.5
                  ],
                  [
                    37471.8,
                    35864.2
                  ],
                  [
                    37447.8,
                    35688.4
                  ],
                  [
                    37525.5,
                    35597.8
                  ],
                  [
                    37669.7,
                    35488.5
                  ],
                  [
                    37816,
                    35453.6
                  ],
                  [
                    37838.7,
                    35537.3
                  ]
                ],
                "id": 1227,
                "chat_link": "[&BMsEAAA=]"
              },
              "1231": {
                "name": "Chak Stronghold",
                "level": 80,
                "coord": [
                  36169.8,
                  34353.2
                ],
                "bounds": [
                  [
                    35760.2,
                    34176
                  ],
                  [
                    35823.3,
                    33948.9
                  ],
                  [
                    36302.9,
                    33942
                  ],
                  [
                    36369.2,
                    34397.7
                  ],
                  [
                    36552,
                    34588.2
                  ],
                  [
                    36334.2,
                    34645.1
                  ],
                  [
                    36220.4,
                    34536.2
                  ],
                  [
                    35996.1,
                    34591.4
                  ],
                  [
                    35760.2,
                    34176
                  ]
                ],
                "id": 1231,
                "chat_link": "[&BM8EAAA=]"
              },
              "1233": {
                "name": "Dragon's Passage",
                "level": 80,
                "coord": [
                  35621.2,
                  35807
                ],
                "bounds": [
                  [
                    35847.6,
                    35657.9
                  ],
                  [
                    35939.5,
                    35731.6
                  ],
                  [
                    35959.6,
                    35899.7
                  ],
                  [
                    36032.1,
                    36048.5
                  ],
                  [
                    35726.5,
                    36173.4
                  ],
                  [
                    35197.5,
                    36289
                  ],
                  [
                    35161.3,
                    36189.2
                  ],
                  [
                    35418.6,
                    35939.1
                  ],
                  [
                    35444.4,
                    35577.1
                  ],
                  [
                    35276,
                    35361.2
                  ],
                  [
                    35731.1,
                    35303.6
                  ],
                  [
                    35719.8,
                    35513.7
                  ],
                  [
                    35847.6,
                    35657.9
                  ]
                ],
                "id": 1233,
                "chat_link": "[&BNEEAAA=]"
              },
              "1234": {
                "name": "Decayed Hive",
                "level": 80,
                "coord": [
                  37609.1,
                  34204.7
                ],
                "bounds": [
                  [
                    37359.2,
                    34148.7
                  ],
                  [
                    37290.1,
                    33959.1
                  ],
                  [
                    37453.4,
                    33957.8
                  ],
                  [
                    37551,
                    34033.4
                  ],
                  [
                    37634.9,
                    33918.6
                  ],
                  [
                    37768.9,
                    33924.2
                  ],
                  [
                    37997.8,
                    34127.1
                  ],
                  [
                    38152,
                    34570.8
                  ],
                  [
                    37671,
                    34613.7
                  ],
                  [
                    37478.5,
                    34492.5
                  ],
                  [
                    37342.9,
                    34505.9
                  ],
                  [
                    37359.2,
                    34148.7
                  ]
                ],
                "id": 1234,
                "chat_link": "[&BNIEAAA=]"
              },
              "1235": {
                "name": "Teku Nuhoch",
                "level": 80,
                "coord": [
                  37059.9,
                  34392.7
                ],
                "bounds": [
                  [
                    36668,
                    33947.4
                  ],
                  [
                    36875,
                    33899.4
                  ],
                  [
                    37287.6,
                    33959.7
                  ],
                  [
                    37359.5,
                    34148.3
                  ],
                  [
                    37349.7,
                    34512.1
                  ],
                  [
                    37287.6,
                    34651.1
                  ],
                  [
                    37204.1,
                    34781.7
                  ],
                  [
                    37039.7,
                    34803.9
                  ],
                  [
                    36839.8,
                    34691.3
                  ],
                  [
                    36688.5,
                    34532.6
                  ],
                  [
                    36668,
                    33947.4
                  ]
                ],
                "id": 1235,
                "chat_link": "[&BNMEAAA=]"
              },
              "1237": {
                "name": "SCAR Lane",
                "level": 80,
                "coord": [
                  37904,
                  35271.2
                ],
                "bounds": [
                  [
                    37605.3,
                    35315.5
                  ],
                  [
                    37635.6,
                    35207.6
                  ],
                  [
                    37768.3,
                    35216.5
                  ],
                  [
                    38227.8,
                    34984.9
                  ],
                  [
                    38402.8,
                    35095
                  ],
                  [
                    38381.5,
                    35262.4
                  ],
                  [
                    38263.6,
                    35348.3
                  ],
                  [
                    37668.6,
                    35491.3
                  ],
                  [
                    37550.4,
                    35428.9
                  ],
                  [
                    37535.7,
                    35362.2
                  ],
                  [
                    37605.3,
                    35315.5
                  ]
                ],
                "id": 1237,
                "chat_link": "[&BNUEAAA=]"
              },
              "1238": {
                "name": "Rata Novus Lane",
                "level": 80,
                "coord": [
                  37385.8,
                  34882.9
                ],
                "bounds": [
                  [
                    37203.5,
                    34768.4
                  ],
                  [
                    37294.2,
                    34626.9
                  ],
                  [
                    37349.8,
                    34490
                  ],
                  [
                    37491,
                    34474.5
                  ],
                  [
                    37583.3,
                    34530.5
                  ],
                  [
                    37540.2,
                    34768
                  ],
                  [
                    37537.1,
                    34982.9
                  ],
                  [
                    37491.2,
                    35179.8
                  ],
                  [
                    37359.3,
                    35295.3
                  ],
                  [
                    37300.8,
                    35286.6
                  ],
                  [
                    37251.8,
                    35156.4
                  ],
                  [
                    37227.9,
                    35035.7
                  ],
                  [
                    37203.5,
                    34768.4
                  ]
                ],
                "id": 1238,
                "chat_link": "[&BNYEAAA=]"
              },
              "1239": {
                "name": "Tangled Descent",
                "level": 80,
                "coord": [
                  35790,
                  34922.9
                ],
                "bounds": [
                  [
                    35658.9,
                    34578.6
                  ],
                  [
                    35890.5,
                    34397.7
                  ],
                  [
                    35993,
                    34587.4
                  ],
                  [
                    36155.5,
                    34951.8
                  ],
                  [
                    36162.4,
                    35128.2
                  ],
                  [
                    36133.4,
                    35244.5
                  ],
                  [
                    35860,
                    35266
                  ],
                  [
                    35732.1,
                    35309.7
                  ],
                  [
                    35288.6,
                    35372.5
                  ],
                  [
                    35287.3,
                    34755.5
                  ],
                  [
                    35527.7,
                    34559.9
                  ],
                  [
                    35658.9,
                    34578.6
                  ]
                ],
                "id": 1239,
                "chat_link": "[&BNcEAAA=]"
              },
              "1242": {
                "name": "Ogre Lane",
                "level": 80,
                "coord": [
                  36550.9,
                  35736.5
                ],
                "bounds": [
                  [
                    36083.9,
                    35657.9
                  ],
                  [
                    36351.1,
                    35590.9
                  ],
                  [
                    36786.1,
                    35527.8
                  ],
                  [
                    36972.9,
                    35512.3
                  ],
                  [
                    37069.5,
                    35543.6
                  ],
                  [
                    37085.7,
                    35642.5
                  ],
                  [
                    37015.9,
                    35724.2
                  ],
                  [
                    37020.9,
                    35924.3
                  ],
                  [
                    36306.3,
                    36056.1
                  ],
                  [
                    36032.5,
                    36049
                  ],
                  [
                    35947.9,
                    35882.2
                  ],
                  [
                    35937.6,
                    35727.4
                  ],
                  [
                    36083.9,
                    35657.9
                  ]
                ],
                "id": 1242,
                "chat_link": "[&BNoEAAA=]"
              },
              "1246": {
                "name": "Nuhoch Lane",
                "level": 80,
                "coord": [
                  36656.1,
                  34959.7
                ],
                "bounds": [
                  [
                    36764,
                    35116.7
                  ],
                  [
                    37041.6,
                    35322.5
                  ],
                  [
                    37108.8,
                    35334.4
                  ],
                  [
                    37147.7,
                    35300.9
                  ],
                  [
                    37145.2,
                    35240
                  ],
                  [
                    37048.6,
                    35049.9
                  ],
                  [
                    36809.9,
                    34797.7
                  ],
                  [
                    36551.3,
                    34581.4
                  ],
                  [
                    36335.2,
                    34643.1
                  ],
                  [
                    36219.7,
                    34529.8
                  ],
                  [
                    35993.7,
                    34590.4
                  ],
                  [
                    36145.6,
                    34962.2
                  ],
                  [
                    36342,
                    34950.3
                  ],
                  [
                    36532.5,
                    35015.8
                  ],
                  [
                    36764,
                    35116.7
                  ]
                ],
                "id": 1246,
                "chat_link": "[&BN4EAAA=]"
              },
              "1247": {
                "name": "Ley-Line Confluence",
                "level": 80,
                "coord": [
                  37291.8,
                  35485.7
                ],
                "bounds": [
                  [
                    37038.2,
                    35315
                  ],
                  [
                    37109.8,
                    35335
                  ],
                  [
                    37149.5,
                    35297.7
                  ],
                  [
                    37145.3,
                    35203.1
                  ],
                  [
                    37225.3,
                    35139.3
                  ],
                  [
                    37300.6,
                    35287
                  ],
                  [
                    37361.5,
                    35295.7
                  ],
                  [
                    37492.9,
                    35180
                  ],
                  [
                    37570.1,
                    35314.4
                  ],
                  [
                    37533,
                    35360.5
                  ],
                  [
                    37549,
                    35431.6
                  ],
                  [
                    37675.9,
                    35491.3
                  ],
                  [
                    37529.4,
                    35600.1
                  ],
                  [
                    37451.2,
                    35689.3
                  ],
                  [
                    37476.3,
                    35864
                  ],
                  [
                    37244.2,
                    35979.7
                  ],
                  [
                    37129.2,
                    36004.5
                  ],
                  [
                    37007.3,
                    35722.3
                  ],
                  [
                    37087.3,
                    35642.5
                  ],
                  [
                    37070.1,
                    35536
                  ],
                  [
                    36981.1,
                    35510.4
                  ],
                  [
                    37038.2,
                    35315
                  ]
                ],
                "id": 1247,
                "chat_link": "[&BN8EAAA=]"
              },
              "1251": {
                "name": "Northern Confluence Tunnel",
                "level": 80,
                "coord": [
                  37074.3,
                  34948
                ],
                "bounds": [
                  [
                    36843.3,
                    34684.7
                  ],
                  [
                    37040,
                    34803.3
                  ],
                  [
                    37211.8,
                    34776.2
                  ],
                  [
                    37236.3,
                    35043.8
                  ],
                  [
                    37262.2,
                    35178.7
                  ],
                  [
                    37147.8,
                    35238
                  ],
                  [
                    37045,
                    35057
                  ],
                  [
                    36807.7,
                    34802.2
                  ],
                  [
                    36843.3,
                    34684.7
                  ]
                ],
                "id": 1251,
                "chat_link": "[&BOMEAAA=]"
              },
              "1252": {
                "name": "Rata Novus",
                "level": 80,
                "coord": [
                  37779.7,
                  34917.8
                ],
                "bounds": [
                  [
                    37671.8,
                    34608.9
                  ],
                  [
                    38148.1,
                    34565.8
                  ],
                  [
                    38344.8,
                    34727.8
                  ],
                  [
                    38235.1,
                    34989.5
                  ],
                  [
                    37790.7,
                    35195.5
                  ],
                  [
                    37643.7,
                    35209.9
                  ],
                  [
                    37615,
                    35316.7
                  ],
                  [
                    37488.1,
                    35181.1
                  ],
                  [
                    37533.4,
                    34990.7
                  ],
                  [
                    37535.3,
                    34774.3
                  ],
                  [
                    37571,
                    34535.2
                  ],
                  [
                    37671.8,
                    34608.9
                  ]
                ],
                "id": 1252,
                "chat_link": "[&BOQEAAA=]"
              },
              "1253": {
                "name": "The Great Tree",
                "level": 80,
                "coord": [
                  36373.5,
                  35093.2
                ],
                "bounds": [
                  [
                    36187.5,
                    34916.5
                  ],
                  [
                    36392.5,
                    34903.5
                  ],
                  [
                    36531.2,
                    34950.8
                  ],
                  [
                    36629.9,
                    35091.5
                  ],
                  [
                    36537.9,
                    35189.5
                  ],
                  [
                    36350.2,
                    35240
                  ],
                  [
                    36220.1,
                    35241.6
                  ],
                  [
                    36138.9,
                    35211.9
                  ],
                  [
                    36187.5,
                    34916.5
                  ]
                ],
                "id": 1253,
                "chat_link": "[&BOUEAAA=]"
              },
              "1255": {
                "name": "Ogre Camp",
                "level": 80,
                "coord": [
                  36571.6,
                  35288
                ],
                "bounds": [
                  [
                    36290.2,
                    35271.5
                  ],
                  [
                    36348.9,
                    35202.9
                  ],
                  [
                    36533.1,
                    35180
                  ],
                  [
                    36622.2,
                    35079.1
                  ],
                  [
                    36787.1,
                    35085.1
                  ],
                  [
                    37021.2,
                    35300.4
                  ],
                  [
                    36959.6,
                    35477.3
                  ],
                  [
                    36352.9,
                    35595.4
                  ],
                  [
                    36229.5,
                    35400.5
                  ],
                  [
                    36290.2,
                    35271.5
                  ]
                ],
                "id": 1255,
                "chat_link": "[&BOcEAAA=]"
              },
              "1261": {
                "name": "SCAR Bivouac",
                "level": 80,
                "coord": [
                  38188.1,
                  35571.6
                ],
                "bounds": [
                  [
                    37813.3,
                    35452.9
                  ],
                  [
                    38260.6,
                    35343.8
                  ],
                  [
                    38386.4,
                    35258.1
                  ],
                  [
                    38391.8,
                    35181.2
                  ],
                  [
                    38506.5,
                    35205.2
                  ],
                  [
                    38557.7,
                    35543.2
                  ],
                  [
                    38598.5,
                    35824
                  ],
                  [
                    38403.7,
                    36023.5
                  ],
                  [
                    38018.7,
                    35955.7
                  ],
                  [
                    37815,
                    35814.9
                  ],
                  [
                    37922,
                    35714.9
                  ],
                  [
                    37935.8,
                    35570.5
                  ],
                  [
                    37834.9,
                    35543.1
                  ],
                  [
                    37813.3,
                    35452.9
                  ]
                ],
                "id": 1261,
                "chat_link": "[&BO0EAAA=]"
              }
            },
            "adventures": [
              {
                "coord": [
                  37316.5,
                  34114.2
                ],
                "id": "8D00FA87-28CD-4402-AAEF-501A610E0447",
                "name": "Beetle Feast",
                "description": "Eat yellow mushrooms to score points and blue mushrooms to gain abilities that help you in your hunt. Beware of the poisonous mushrooms with green spores, and use your burrow ability to bypass closed gates!"
              },
              {
                "coord": [
                  38159.8,
                  35845.1
                ],
                "id": "55D1CF24-ADE2-4946-B725-0AAB363641FB",
                "name": "Drone Race",
                "description": "Boost and blast your way through the checkpoints and across the finish line!"
              }
            ],
            "id": 1045,
            "mastery_points": [
              {
                "coord": [
                  36469.8,
                  34683.5
                ],
                "id": 112,
                "region": "Maguuma"
              },
              {
                "coord": [
                  38125.5,
                  35166.2
                ],
                "id": 20,
                "region": "Maguuma"
              },
              {
                "coord": [
                  37124.9,
                  34800.6
                ],
                "id": 8,
                "region": "Maguuma"
              },
              {
                "coord": [
                  36147.7,
                  34760.9
                ],
                "id": 61,
                "region": "Maguuma"
              },
              {
                "coord": [
                  35743.4,
                  35721.9
                ],
                "id": 46,
                "region": "Maguuma"
              }
            ]
          },
          "1046": {
            "name": "Roots of Terror",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              35736,
              35072
            ],
            "map_rect": [
              [
                -39936,
                -27648
              ],
              [
                39936,
                27648
              ]
            ],
            "continent_rect": [
              [
                35328,
                33792
              ],
              [
                38656,
                36096
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1046,
            "mastery_points": []
          },
          "1048": {
            "name": "City of Hope",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              34304,
              33792
            ],
            "map_rect": [
              [
                -24576,
                -33792
              ],
              [
                24576,
                33792
              ]
            ],
            "continent_rect": [
              [
                33280,
                32512
              ],
              [
                35328,
                35328
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1218": {
                "name": "Southwatch Creep",
                "level": 80,
                "coord": [
                  34351.9,
                  34715.8
                ],
                "bounds": [
                  [
                    34281.2,
                    34367
                  ],
                  [
                    34370,
                    34364
                  ],
                  [
                    34615.6,
                    34504.5
                  ],
                  [
                    34654.6,
                    34667.6
                  ],
                  [
                    34628.6,
                    34832.7
                  ],
                  [
                    34577.9,
                    34854.3
                  ],
                  [
                    34546.1,
                    34933.2
                  ],
                  [
                    34467.2,
                    34919.9
                  ],
                  [
                    34184.3,
                    34913.5
                  ],
                  [
                    34114.3,
                    34987.2
                  ],
                  [
                    34011.5,
                    34862.3
                  ],
                  [
                    34015.5,
                    34540
                  ],
                  [
                    34108.3,
                    34559.8
                  ],
                  [
                    34281.2,
                    34367
                  ]
                ],
                "id": 1218,
                "chat_link": "[&BMIEAAA=]"
              },
              "1219": {
                "name": "Balthazar's Rest",
                "level": 80,
                "coord": [
                  33879.3,
                  35100.1
                ],
                "bounds": [
                  [
                    33602.1,
                    35301.6
                  ],
                  [
                    33615.6,
                    35070
                  ],
                  [
                    33878.2,
                    34954.7
                  ],
                  [
                    33912.4,
                    34847.9
                  ],
                  [
                    34013.9,
                    34853.4
                  ],
                  [
                    34142.4,
                    35034.8
                  ],
                  [
                    34000.1,
                    35110
                  ],
                  [
                    33975.3,
                    35310.6
                  ],
                  [
                    33773.7,
                    35418.3
                  ],
                  [
                    33602.1,
                    35301.6
                  ]
                ],
                "id": 1219,
                "chat_link": "[&BMMEAAA=]"
              },
              "1220": {
                "name": "Burnisher Quarry",
                "level": 80,
                "coord": [
                  34947.3,
                  32796.9
                ],
                "bounds": [
                  [
                    34605.5,
                    32481.5
                  ],
                  [
                    34907.7,
                    32483.3
                  ],
                  [
                    35099.7,
                    32380.2
                  ],
                  [
                    35376.2,
                    32609
                  ],
                  [
                    35353.4,
                    33003.4
                  ],
                  [
                    35244.1,
                    33238.8
                  ],
                  [
                    35050.3,
                    33365.3
                  ],
                  [
                    34944.1,
                    33013.2
                  ],
                  [
                    34889.1,
                    32932.7
                  ],
                  [
                    34741,
                    32816.5
                  ],
                  [
                    34620.7,
                    32688.6
                  ],
                  [
                    34535.7,
                    32550
                  ],
                  [
                    34605.5,
                    32481.5
                  ]
                ],
                "id": 1220,
                "chat_link": "[&BMQEAAA=]"
              },
              "1222": {
                "name": "Westwatch Patch",
                "level": 80,
                "coord": [
                  33654.8,
                  33521.4
                ],
                "bounds": [
                  [
                    33289,
                    33929.2
                  ],
                  [
                    33353.3,
                    33938.3
                  ],
                  [
                    33430.2,
                    33798.7
                  ],
                  [
                    33657.4,
                    33953.5
                  ],
                  [
                    33871.4,
                    33796.2
                  ],
                  [
                    33944.8,
                    33664.5
                  ],
                  [
                    33869.2,
                    33574.4
                  ],
                  [
                    33839.5,
                    33366.3
                  ],
                  [
                    33876.5,
                    33333.6
                  ],
                  [
                    33948.4,
                    33324
                  ],
                  [
                    33795,
                    33139.7
                  ],
                  [
                    33741.6,
                    33212.9
                  ],
                  [
                    33517.4,
                    33111.5
                  ],
                  [
                    33397,
                    33197.4
                  ],
                  [
                    33290.8,
                    33480.8
                  ],
                  [
                    33289,
                    33929.2
                  ]
                ],
                "id": 1222,
                "chat_link": "[&BMYEAAA=]"
              },
              "1224": {
                "name": "Tarnished Treetop",
                "level": 80,
                "coord": [
                  33694.9,
                  32853
                ],
                "bounds": [
                  [
                    33439.6,
                    32543.3
                  ],
                  [
                    33582.2,
                    32425.4
                  ],
                  [
                    33750,
                    32552.6
                  ],
                  [
                    34079.8,
                    32448.6
                  ],
                  [
                    34227.7,
                    32591.1
                  ],
                  [
                    34108.1,
                    32981.7
                  ],
                  [
                    34050.2,
                    32965.3
                  ],
                  [
                    33843,
                    33073.6
                  ],
                  [
                    33742.3,
                    33213
                  ],
                  [
                    33516.7,
                    33109.2
                  ],
                  [
                    33397.5,
                    33197.8
                  ],
                  [
                    33300.4,
                    33116.5
                  ],
                  [
                    33295.2,
                    32895.2
                  ],
                  [
                    33396.2,
                    32828.5
                  ],
                  [
                    33439.6,
                    32543.3
                  ]
                ],
                "id": 1224,
                "chat_link": "[&BMgEAAA=]"
              },
              "1225": {
                "name": "Mossheart Walk",
                "level": 80,
                "coord": [
                  34880.8,
                  34672
                ],
                "bounds": [
                  [
                    34613.3,
                    34499.6
                  ],
                  [
                    35084,
                    34396.6
                  ],
                  [
                    35193.6,
                    34752.2
                  ],
                  [
                    35110.7,
                    34883.6
                  ],
                  [
                    34629,
                    34832.1
                  ],
                  [
                    34654.3,
                    34667.9
                  ],
                  [
                    34613.3,
                    34499.6
                  ]
                ],
                "id": 1225,
                "chat_link": "[&BMkEAAA=]"
              },
              "1226": {
                "name": "Arrowhead Vale",
                "level": 80,
                "coord": [
                  34197,
                  33265.2
                ],
                "bounds": [
                  [
                    34130.2,
                    33460.5
                  ],
                  [
                    34050.1,
                    33346.4
                  ],
                  [
                    33946.5,
                    33323.6
                  ],
                  [
                    33794,
                    33137.6
                  ],
                  [
                    33842.2,
                    33070
                  ],
                  [
                    34049.3,
                    32966.6
                  ],
                  [
                    34259.3,
                    33020.9
                  ],
                  [
                    34270.4,
                    33168.7
                  ],
                  [
                    34533.1,
                    33187.9
                  ],
                  [
                    34592.5,
                    33280.3
                  ],
                  [
                    34481.4,
                    33502.1
                  ],
                  [
                    34403.6,
                    33488.7
                  ],
                  [
                    34208.8,
                    33494.1
                  ],
                  [
                    34130.2,
                    33460.5
                  ]
                ],
                "id": 1226,
                "chat_link": "[&BMoEAAA=]"
              },
              "1230": {
                "name": "Maguuma Shallows",
                "level": 80,
                "coord": [
                  34744.4,
                  33233.8
                ],
                "bounds": [
                  [
                    34530.6,
                    33189.2
                  ],
                  [
                    34743,
                    32958.8
                  ],
                  [
                    34696.1,
                    32905.2
                  ],
                  [
                    34739.4,
                    32812.5
                  ],
                  [
                    34890.2,
                    32929.9
                  ],
                  [
                    34947.4,
                    33008.1
                  ],
                  [
                    35050.6,
                    33366.6
                  ],
                  [
                    34917.3,
                    33593.1
                  ],
                  [
                    34748.2,
                    33703.3
                  ],
                  [
                    34592.4,
                    33556.5
                  ],
                  [
                    34482.7,
                    33502.2
                  ],
                  [
                    34595.2,
                    33280.8
                  ],
                  [
                    34530.6,
                    33189.2
                  ]
                ],
                "id": 1230,
                "chat_link": "[&BM4EAAA=]"
              },
              "1236": {
                "name": "Northwatch Descent",
                "level": 80,
                "coord": [
                  34474.7,
                  32887
                ],
                "bounds": [
                  [
                    34227.1,
                    32589.4
                  ],
                  [
                    34538,
                    32550.3
                  ],
                  [
                    34622.3,
                    32686.8
                  ],
                  [
                    34739.9,
                    32816.6
                  ],
                  [
                    34700,
                    32905.9
                  ],
                  [
                    34747.1,
                    32958.7
                  ],
                  [
                    34535.6,
                    33194.3
                  ],
                  [
                    34270.7,
                    33168.8
                  ],
                  [
                    34259.2,
                    33018.5
                  ],
                  [
                    34106.7,
                    32980.6
                  ],
                  [
                    34227.1,
                    32589.4
                  ]
                ],
                "id": 1236,
                "chat_link": "[&BNQEAAA=]"
              },
              "1240": {
                "name": "Chak Hollow",
                "level": 80,
                "coord": [
                  34912.7,
                  35054.1
                ],
                "bounds": [
                  [
                    35432.5,
                    35009.2
                  ],
                  [
                    35369.1,
                    35375.1
                  ],
                  [
                    35165.6,
                    35298.1
                  ],
                  [
                    34912.6,
                    35367.7
                  ],
                  [
                    34777.9,
                    35289.3
                  ],
                  [
                    34639,
                    35294.8
                  ],
                  [
                    34535.5,
                    35128.4
                  ],
                  [
                    34558.6,
                    34989.9
                  ],
                  [
                    34545.6,
                    34933.7
                  ],
                  [
                    34577.7,
                    34852.7
                  ],
                  [
                    34628.6,
                    34830.4
                  ],
                  [
                    35112.6,
                    34882.3
                  ],
                  [
                    35195.1,
                    34752.2
                  ],
                  [
                    35327.5,
                    34753.9
                  ],
                  [
                    35432.5,
                    35009.2
                  ]
                ],
                "id": 1240,
                "chat_link": "[&BNgEAAA=]"
              },
              "1241": {
                "name": "Bristleback Chasm",
                "level": 80,
                "coord": [
                  35030.9,
                  33824.5
                ],
                "bounds": [
                  [
                    34896.2,
                    33822
                  ],
                  [
                    34743.5,
                    33702.7
                  ],
                  [
                    34914.7,
                    33594.1
                  ],
                  [
                    35051.1,
                    33368.1
                  ],
                  [
                    35244.9,
                    33239.5
                  ],
                  [
                    35354.7,
                    33343.4
                  ],
                  [
                    35344.1,
                    33465.7
                  ],
                  [
                    35155.4,
                    33488.8
                  ],
                  [
                    35039.9,
                    33655.3
                  ],
                  [
                    35038.7,
                    33822.1
                  ],
                  [
                    35109.9,
                    33899.8
                  ],
                  [
                    35084.5,
                    34113.6
                  ],
                  [
                    35126.7,
                    34245.1
                  ],
                  [
                    35083.2,
                    34398.4
                  ],
                  [
                    34718.5,
                    34480.4
                  ],
                  [
                    34722,
                    34381.5
                  ],
                  [
                    34897.6,
                    33996.8
                  ],
                  [
                    34896.2,
                    33822
                  ]
                ],
                "id": 1241,
                "chat_link": "[&BNkEAAA=]"
              },
              "1244": {
                "name": "Tarir, the Forgotten City",
                "level": 80,
                "coord": [
                  34256.9,
                  33880.9
                ],
                "bounds": [
                  [
                    34130.7,
                    33460.9
                  ],
                  [
                    34213.3,
                    33495
                  ],
                  [
                    34411.2,
                    33485.1
                  ],
                  [
                    34479,
                    33502.6
                  ],
                  [
                    34594.1,
                    33554.8
                  ],
                  [
                    34743.5,
                    33700.4
                  ],
                  [
                    34901.2,
                    33832.4
                  ],
                  [
                    34898.1,
                    33996.9
                  ],
                  [
                    34722,
                    34382.7
                  ],
                  [
                    34717.9,
                    34480.3
                  ],
                  [
                    34615,
                    34505
                  ],
                  [
                    34378.2,
                    34364.8
                  ],
                  [
                    34281.7,
                    34367.8
                  ],
                  [
                    34110.1,
                    34559.7
                  ],
                  [
                    34018,
                    34540
                  ],
                  [
                    33972,
                    34279.2
                  ],
                  [
                    33998.4,
                    34148.9
                  ],
                  [
                    33839.6,
                    33959.6
                  ],
                  [
                    33872,
                    33797.5
                  ],
                  [
                    33945.8,
                    33664.7
                  ],
                  [
                    33869.3,
                    33574.5
                  ],
                  [
                    33839.8,
                    33366.6
                  ],
                  [
                    33876.5,
                    33333.6
                  ],
                  [
                    33945.2,
                    33324.4
                  ],
                  [
                    34049.4,
                    33344.2
                  ],
                  [
                    34130.7,
                    33460.9
                  ]
                ],
                "id": 1244,
                "chat_link": "[&BNwEAAA=]"
              },
              "1245": {
                "name": "Eastwatch Bluff",
                "level": 80,
                "coord": [
                  35192.6,
                  34030.3
                ],
                "bounds": [
                  [
                    35111.6,
                    33900.3
                  ],
                  [
                    35040.6,
                    33817
                  ],
                  [
                    35042.6,
                    33656.7
                  ],
                  [
                    35157.4,
                    33486.7
                  ],
                  [
                    35344.4,
                    33464.2
                  ],
                  [
                    35380.7,
                    33921.3
                  ],
                  [
                    35464,
                    34095.5
                  ],
                  [
                    35308.9,
                    34603.2
                  ],
                  [
                    35167.1,
                    34666.1
                  ],
                  [
                    35082.1,
                    34395.1
                  ],
                  [
                    35127.6,
                    34247
                  ],
                  [
                    35084.1,
                    34111.1
                  ],
                  [
                    35111.6,
                    33900.3
                  ]
                ],
                "id": 1245,
                "chat_link": "[&BN0EAAA=]"
              },
              "1248": {
                "name": "Griffonfall",
                "level": 80,
                "coord": [
                  33744.4,
                  34794.9
                ],
                "bounds": [
                  [
                    34026.8,
                    34592
                  ],
                  [
                    34013.4,
                    34855.7
                  ],
                  [
                    33913.7,
                    34846.9
                  ],
                  [
                    33870.8,
                    34950.5
                  ],
                  [
                    33615.8,
                    35074.9
                  ],
                  [
                    33469.2,
                    34983.9
                  ],
                  [
                    33360.8,
                    34701.6
                  ],
                  [
                    33574.1,
                    34530.1
                  ],
                  [
                    33855.2,
                    34618.7
                  ],
                  [
                    34026.8,
                    34592
                  ]
                ],
                "id": 1248,
                "chat_link": "[&BOAEAAA=]"
              },
              "1258": {
                "name": "The Falls",
                "level": 80,
                "coord": [
                  33850.5,
                  34371.3
                ],
                "bounds": [
                  [
                    33555.7,
                    34301
                  ],
                  [
                    33568.8,
                    34529.4
                  ],
                  [
                    33860.1,
                    34620.1
                  ],
                  [
                    34026.3,
                    34592.7
                  ],
                  [
                    33972.8,
                    34291.5
                  ],
                  [
                    33997.6,
                    34148.4
                  ],
                  [
                    33972.2,
                    34115.9
                  ],
                  [
                    33555.7,
                    34301
                  ]
                ],
                "id": 1258,
                "chat_link": "[&BOoEAAA=]"
              },
              "1260": {
                "name": "Lastgear Standing",
                "level": 80,
                "coord": [
                  33548.4,
                  34170.6
                ],
                "bounds": [
                  [
                    33556.1,
                    34304
                  ],
                  [
                    33971.2,
                    34117
                  ],
                  [
                    33839.8,
                    33959.7
                  ],
                  [
                    33872.2,
                    33797.8
                  ],
                  [
                    33656.5,
                    33957.7
                  ],
                  [
                    33430.5,
                    33798.9
                  ],
                  [
                    33316.8,
                    33985.4
                  ],
                  [
                    33363.5,
                    34143.2
                  ],
                  [
                    33301.4,
                    34229.2
                  ],
                  [
                    33300.9,
                    34561.3
                  ],
                  [
                    33402.1,
                    34663.3
                  ],
                  [
                    33569.4,
                    34529.8
                  ],
                  [
                    33556.1,
                    34304
                  ]
                ],
                "id": 1260,
                "chat_link": "[&BOwEAAA=]"
              },
              "1262": {
                "name": "Morwood Wilds",
                "level": 80,
                "coord": [
                  34324.3,
                  35092.1
                ],
                "bounds": [
                  [
                    34422.2,
                    35408.7
                  ],
                  [
                    33971.6,
                    35312.5
                  ],
                  [
                    33999.9,
                    35108
                  ],
                  [
                    34141.1,
                    35035.4
                  ],
                  [
                    34099.4,
                    34975.9
                  ],
                  [
                    34184.2,
                    34914.3
                  ],
                  [
                    34466.6,
                    34918.1
                  ],
                  [
                    34545.1,
                    34933.9
                  ],
                  [
                    34559.1,
                    34989.4
                  ],
                  [
                    34537.9,
                    35124.4
                  ],
                  [
                    34640.8,
                    35292.8
                  ],
                  [
                    34422.2,
                    35408.7
                  ]
                ],
                "id": 1262,
                "chat_link": "[&BO4EAAA=]"
              }
            },
            "adventures": [],
            "id": 1048,
            "mastery_points": []
          },
          "1050": {
            "name": "Torn from the Sky",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              35072,
              31744
            ],
            "map_rect": [
              [
                -36864,
                -18432
              ],
              [
                39936,
                18432
              ]
            ],
            "continent_rect": [
              [
                33408,
                30976
              ],
              [
                36608,
                32512
              ]
            ],
            "points_of_interest": {
              "1985": {
                "name": "Golden Boughs",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33695.3,
                  32148.6
                ],
                "id": 1985,
                "chat_link": "[&BMEHAAA=]"
              },
              "1986": {
                "name": "Matriarch's Perch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35229.7,
                  31801.6
                ],
                "id": 1986,
                "chat_link": "[&BMIHAAA=]"
              },
              "1991": {
                "name": "Wreck of the Thunderbreaker",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34154,
                  32246.9
                ],
                "id": 1991,
                "chat_link": "[&BMcHAAA=]"
              },
              "1994": {
                "name": "Dwelling of the Kaanas",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35980,
                  31149
                ],
                "id": 1994,
                "chat_link": "[&BMoHAAA=]"
              },
              "1995": {
                "name": "Wreck of the Mellaggan's Valor",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34466.1,
                  31517.4
                ],
                "id": 1995,
                "chat_link": "[&BMsHAAA=]"
              },
              "1999": {
                "name": "Wreck of the Lethal Vantage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36407.8,
                  32171.6
                ],
                "id": 1999,
                "chat_link": "[&BM8HAAA=]"
              },
              "2017": {
                "name": "Temple of Ameyalli",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36096.4,
                  31379
                ],
                "id": 2017,
                "chat_link": "[&BOEHAAA=]"
              },
              "2021": {
                "name": "Precarious Ruin",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33750.1,
                  31169.7
                ],
                "id": 2021,
                "chat_link": "[&BOUHAAA=]"
              },
              "2025": {
                "name": "Last Leap",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35581.7,
                  31392.3
                ],
                "id": 2025,
                "chat_link": "[&BOkHAAA=]"
              },
              "2030": {
                "name": "Fumerol Caves",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35714,
                  31043.1
                ],
                "id": 2030,
                "chat_link": "[&BO4HAAA=]"
              },
              "2032": {
                "name": "The Corpse Grove",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34605.9,
                  31227.2
                ],
                "id": 2032,
                "chat_link": "[&BPAHAAA=]"
              },
              "2036": {
                "name": "Coztic Itzel",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34456.1,
                  32046.8
                ],
                "id": 2036,
                "chat_link": "[&BPQHAAA=]"
              },
              "2042": {
                "name": "Batrach Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36458.3,
                  31267.6
                ],
                "id": 2042,
                "chat_link": "[&BPoHAAA=]"
              },
              "2043": {
                "name": "Brooding Gulch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35686.6,
                  31339.7
                ],
                "id": 2043,
                "chat_link": "[&BPsHAAA=]"
              },
              "2045": {
                "name": "Shaded Spring",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35115.6,
                  31751.3
                ],
                "id": 2045,
                "chat_link": "[&BP0HAAA=]"
              },
              "2046": {
                "name": "Ascendant's Ring",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34152.4,
                  32000.6
                ],
                "id": 2046,
                "chat_link": "[&BP4HAAA=]"
              },
              "2061": {
                "name": "Holdfast Hollow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33822.7,
                  31741.8
                ],
                "id": 2061,
                "chat_link": "[&BA0IAAA=]"
              },
              "2065": {
                "name": "The Waking Tomb",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35963.7,
                  32398.3
                ],
                "id": 2065,
                "chat_link": "[&BBEIAAA=]"
              },
              "2066": {
                "name": "Glory's Fall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35235.3,
                  31271.1
                ],
                "id": 2066,
                "chat_link": "[&BBIIAAA=]"
              },
              "2067": {
                "name": "Dust Dancer Plateau",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35265.6,
                  32306.8
                ],
                "id": 2067,
                "chat_link": "[&BBMIAAA=]"
              },
              "2071": {
                "name": "Uprooted Paradise",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34142.6,
                  31253.1
                ],
                "id": 2071,
                "chat_link": "[&BBcIAAA=]"
              },
              "2072": {
                "name": "Precarious Perch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35631.5,
                  31951.1
                ],
                "id": 2072,
                "chat_link": "[&BBgIAAA=]"
              },
              "2073": {
                "name": "Silent Woods",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34768.8,
                  31691.5
                ],
                "id": 2073,
                "chat_link": "[&BBkIAAA=]"
              },
              "2074": {
                "name": "Creaking Caverns",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35083.9,
                  32165.2
                ],
                "id": 2074,
                "chat_link": "[&BBoIAAA=]"
              },
              "2075": {
                "name": "The Tangle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36095.3,
                  31721.4
                ],
                "id": 2075,
                "chat_link": "[&BBsIAAA=]"
              },
              "2077": {
                "name": "Bongo's Bungalow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34829.3,
                  32391.4
                ],
                "id": 2077,
                "chat_link": "[&BB0IAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1228": {
                "name": "Stonetwist Paths",
                "level": 80,
                "coord": [
                  35244.4,
                  31688.2
                ],
                "bounds": [
                  [
                    35626.6,
                    31696.8
                  ],
                  [
                    35587.3,
                    31743.3
                  ],
                  [
                    35423,
                    31815.3
                  ],
                  [
                    35369.4,
                    31856.2
                  ],
                  [
                    35314.7,
                    31918.9
                  ],
                  [
                    35250.3,
                    31945.9
                  ],
                  [
                    35120.8,
                    31925.4
                  ],
                  [
                    35057.7,
                    31914
                  ],
                  [
                    34875,
                    31809
                  ],
                  [
                    34797.6,
                    31758.9
                  ],
                  [
                    34673.4,
                    31714.2
                  ],
                  [
                    34630.4,
                    31648
                  ],
                  [
                    34691.5,
                    31589.2
                  ],
                  [
                    34948,
                    31539.4
                  ],
                  [
                    35046.6,
                    31487.3
                  ],
                  [
                    35192,
                    31413.1
                  ],
                  [
                    35357.7,
                    31412.6
                  ],
                  [
                    35563.2,
                    31528
                  ],
                  [
                    35634.3,
                    31557.7
                  ],
                  [
                    35752.2,
                    31538.8
                  ],
                  [
                    35771.7,
                    31661.9
                  ],
                  [
                    35693.5,
                    31667.2
                  ],
                  [
                    35626.6,
                    31696.8
                  ]
                ],
                "id": 1228,
                "chat_link": "[&BMwEAAA=]"
              },
              "1229": {
                "name": "Noble Ledges",
                "level": 80,
                "coord": [
                  34221.3,
                  32284.5
                ],
                "bounds": [
                  [
                    33696.1,
                    32530.8
                  ],
                  [
                    34005,
                    32527.3
                  ],
                  [
                    34222.1,
                    32590.6
                  ],
                  [
                    34491.5,
                    32561
                  ],
                  [
                    34561.7,
                    32483.4
                  ],
                  [
                    34616.3,
                    32413.1
                  ],
                  [
                    34625.3,
                    32269.8
                  ],
                  [
                    34684.5,
                    32140.4
                  ],
                  [
                    34528.4,
                    32174.7
                  ],
                  [
                    34403.9,
                    32176.1
                  ],
                  [
                    34375.2,
                    32079.7
                  ],
                  [
                    34302.4,
                    31985
                  ],
                  [
                    34149.6,
                    32020
                  ],
                  [
                    34037.9,
                    32066.3
                  ],
                  [
                    33909.1,
                    32176.1
                  ],
                  [
                    33580.2,
                    32168.8
                  ],
                  [
                    33572.2,
                    32473.1
                  ],
                  [
                    33696.1,
                    32530.8
                  ]
                ],
                "id": 1229,
                "chat_link": "[&BM0EAAA=]"
              },
              "1232": {
                "name": "The Doomteeth",
                "level": 80,
                "coord": [
                  33829.6,
                  31295.8
                ],
                "bounds": [
                  [
                    33577.1,
                    31688.9
                  ],
                  [
                    33649.1,
                    31022.1
                  ],
                  [
                    34141.4,
                    31084.3
                  ],
                  [
                    34016.2,
                    31173.5
                  ],
                  [
                    33892.5,
                    31352.7
                  ],
                  [
                    33701,
                    31453.6
                  ],
                  [
                    33577.1,
                    31688.9
                  ]
                ],
                "id": 1232,
                "chat_link": "[&BNAEAAA=]"
              },
              "1243": {
                "name": "Jaka Itzel",
                "level": 80,
                "coord": [
                  36250.8,
                  31282.1
                ],
                "bounds": [
                  [
                    35973.9,
                    30996.2
                  ],
                  [
                    36629.6,
                    30961.6
                  ],
                  [
                    36712.2,
                    31249
                  ],
                  [
                    36677.6,
                    31392.9
                  ],
                  [
                    36416.4,
                    31363.7
                  ],
                  [
                    36439,
                    31302.1
                  ],
                  [
                    36218.4,
                    31371.6
                  ],
                  [
                    36159.9,
                    31463.5
                  ],
                  [
                    36043.6,
                    31514.9
                  ],
                  [
                    35885.6,
                    31502.2
                  ],
                  [
                    35949.1,
                    31266.2
                  ],
                  [
                    35904.2,
                    31001.1
                  ],
                  [
                    35973.9,
                    30996.2
                  ]
                ],
                "id": 1243,
                "chat_link": "[&BNsEAAA=]"
              },
              "1249": {
                "name": "Blighted Depths",
                "level": 80,
                "coord": [
                  34441.8,
                  31257
                ],
                "bounds": [
                  [
                    33892.1,
                    31351.5
                  ],
                  [
                    34020.5,
                    31168.2
                  ],
                  [
                    34145.8,
                    31083
                  ],
                  [
                    34368,
                    31034.7
                  ],
                  [
                    34634.9,
                    30997.8
                  ],
                  [
                    34991.7,
                    31029.6
                  ],
                  [
                    34842.9,
                    31291.2
                  ],
                  [
                    34769.6,
                    31466
                  ],
                  [
                    34675,
                    31377.7
                  ],
                  [
                    34567.3,
                    31347.7
                  ],
                  [
                    34381.9,
                    31327.3
                  ],
                  [
                    34261.9,
                    31379.8
                  ],
                  [
                    34191.7,
                    31485.9
                  ],
                  [
                    33892.1,
                    31351.5
                  ]
                ],
                "id": 1249,
                "chat_link": "[&BOEEAAA=]"
              },
              "1250": {
                "name": "Shrouded Ruins",
                "level": 80,
                "coord": [
                  35778.2,
                  32227.7
                ],
                "bounds": [
                  [
                    35359.7,
                    32628.8
                  ],
                  [
                    35346.2,
                    32173.3
                  ],
                  [
                    35527.8,
                    32175.6
                  ],
                  [
                    35596.2,
                    32159.1
                  ],
                  [
                    35742.9,
                    31967.5
                  ],
                  [
                    35777.1,
                    32024.3
                  ],
                  [
                    35913,
                    32015.4
                  ],
                  [
                    36078.5,
                    32030.8
                  ],
                  [
                    36191.6,
                    32141.3
                  ],
                  [
                    36267.4,
                    32483.8
                  ],
                  [
                    35919.9,
                    32487
                  ],
                  [
                    35618.5,
                    32445.7
                  ],
                  [
                    35359.7,
                    32628.8
                  ]
                ],
                "id": 1250,
                "chat_link": "[&BOIEAAA=]"
              },
              "1254": {
                "name": "Wyvern Cliffs",
                "level": 80,
                "coord": [
                  35654.4,
                  31333.3
                ],
                "bounds": [
                  [
                    35904.2,
                    31001.1
                  ],
                  [
                    35949,
                    31266.2
                  ],
                  [
                    35884.9,
                    31502.6
                  ],
                  [
                    35751.3,
                    31538.8
                  ],
                  [
                    35633.8,
                    31557.7
                  ],
                  [
                    35563.1,
                    31527.7
                  ],
                  [
                    35547,
                    31436.2
                  ],
                  [
                    35568.3,
                    31382.1
                  ],
                  [
                    35499.5,
                    31337.3
                  ],
                  [
                    35489.1,
                    31301.2
                  ],
                  [
                    35508.5,
                    31143.6
                  ],
                  [
                    35554.8,
                    31005.6
                  ],
                  [
                    35904.2,
                    31001.1
                  ]
                ],
                "id": 1254,
                "chat_link": "[&BOYEAAA=]"
              },
              "1259": {
                "name": "Dry Step Mesas",
                "level": 80,
                "coord": [
                  36289.2,
                  31844.6
                ],
                "bounds": [
                  [
                    36125.8,
                    31883.3
                  ],
                  [
                    36185,
                    31852.6
                  ],
                  [
                    36223.2,
                    31808.3
                  ],
                  [
                    36239.8,
                    31760.7
                  ],
                  [
                    36238.6,
                    31685.3
                  ],
                  [
                    36278.2,
                    31677.5
                  ],
                  [
                    36450.1,
                    31707.4
                  ],
                  [
                    36624.1,
                    31777.5
                  ],
                  [
                    36620.2,
                    31830.2
                  ],
                  [
                    36433.1,
                    31857.3
                  ],
                  [
                    36190.7,
                    32140.8
                  ],
                  [
                    36078.5,
                    32030.8
                  ],
                  [
                    36072.3,
                    31968.6
                  ],
                  [
                    36125.8,
                    31883.3
                  ]
                ],
                "id": 1259,
                "chat_link": "[&BOsEAAA=]"
              },
              "1263": {
                "name": "Heartless Pass",
                "level": 80,
                "coord": [
                  36206.2,
                  31528.7
                ],
                "bounds": [
                  [
                    36238.9,
                    31685.8
                  ],
                  [
                    36181.2,
                    31616.9
                  ],
                  [
                    36112.1,
                    31609
                  ],
                  [
                    35977.1,
                    31632.1
                  ],
                  [
                    35772.3,
                    31663
                  ],
                  [
                    35753,
                    31539
                  ],
                  [
                    35885.6,
                    31502.2
                  ],
                  [
                    36043.2,
                    31514
                  ],
                  [
                    36158.8,
                    31463.2
                  ],
                  [
                    36217.9,
                    31371.9
                  ],
                  [
                    36438.7,
                    31302.1
                  ],
                  [
                    36416,
                    31363.1
                  ],
                  [
                    36677.5,
                    31392.8
                  ],
                  [
                    36657.9,
                    31571
                  ],
                  [
                    36431.6,
                    31587.4
                  ],
                  [
                    36337.4,
                    31644.9
                  ],
                  [
                    36238.9,
                    31685.8
                  ]
                ],
                "id": 1263,
                "chat_link": "[&BO8EAAA=]"
              },
              "1264": {
                "name": "Broken Bluffs",
                "level": 80,
                "coord": [
                  34204.8,
                  31606.7
                ],
                "bounds": [
                  [
                    33578.6,
                    31687.4
                  ],
                  [
                    33701.6,
                    31454.3
                  ],
                  [
                    33890.7,
                    31350.4
                  ],
                  [
                    34189.3,
                    31485.9
                  ],
                  [
                    34262.9,
                    31380.3
                  ],
                  [
                    34381.7,
                    31328.2
                  ],
                  [
                    34570.6,
                    31345.3
                  ],
                  [
                    34669,
                    31371.2
                  ],
                  [
                    34770.6,
                    31465.5
                  ],
                  [
                    34691.3,
                    31588.2
                  ],
                  [
                    34629.8,
                    31648.3
                  ],
                  [
                    34376.9,
                    31715.6
                  ],
                  [
                    34315.7,
                    31741.4
                  ],
                  [
                    34282.6,
                    31827.2
                  ],
                  [
                    34080.7,
                    31850.5
                  ],
                  [
                    33926.2,
                    31905.4
                  ],
                  [
                    33758.4,
                    31894.6
                  ],
                  [
                    33609.5,
                    31881.5
                  ],
                  [
                    33578.6,
                    31687.4
                  ]
                ],
                "id": 1264,
                "chat_link": "[&BPAEAAA=]"
              },
              "1265": {
                "name": "Hidden Copse",
                "level": 80,
                "coord": [
                  34923.6,
                  32288.4
                ],
                "bounds": [
                  [
                    35197.9,
                    32183.6
                  ],
                  [
                    35116.3,
                    32304.3
                  ],
                  [
                    35135.5,
                    32380.5
                  ],
                  [
                    35159.3,
                    32561.3
                  ],
                  [
                    34561.8,
                    32483.2
                  ],
                  [
                    34615.4,
                    32413.9
                  ],
                  [
                    34625.7,
                    32270
                  ],
                  [
                    34684.5,
                    32139.9
                  ],
                  [
                    35013.2,
                    32066.1
                  ],
                  [
                    35126.4,
                    32081.4
                  ],
                  [
                    35197.9,
                    32183.6
                  ]
                ],
                "id": 1265,
                "chat_link": "[&BPEEAAA=]"
              },
              "1269": {
                "name": "Treacherous Paths",
                "level": 80,
                "coord": [
                  33963.8,
                  31977.6
                ],
                "bounds": [
                  [
                    33580.4,
                    32169.1
                  ],
                  [
                    33608.9,
                    31882.8
                  ],
                  [
                    33759.3,
                    31895.7
                  ],
                  [
                    33924.1,
                    31902.4
                  ],
                  [
                    34078.9,
                    31850.4
                  ],
                  [
                    34284.2,
                    31825.3
                  ],
                  [
                    34303.2,
                    31986.3
                  ],
                  [
                    34149.5,
                    32020.5
                  ],
                  [
                    34039.4,
                    32066.2
                  ],
                  [
                    33909.9,
                    32177.2
                  ],
                  [
                    33580.4,
                    32169.1
                  ]
                ],
                "id": 1269,
                "chat_link": "[&BPUEAAA=]"
              },
              "1271": {
                "name": "Maguuma's Breach",
                "level": 80,
                "coord": [
                  36431.1,
                  31664.5
                ],
                "bounds": [
                  [
                    36657.9,
                    31571
                  ],
                  [
                    36431.9,
                    31587.9
                  ],
                  [
                    36337.2,
                    31645.1
                  ],
                  [
                    36238.9,
                    31685.6
                  ],
                  [
                    36277.4,
                    31677.3
                  ],
                  [
                    36450.1,
                    31707.3
                  ],
                  [
                    36624.2,
                    31777.6
                  ],
                  [
                    36657.9,
                    31571
                  ]
                ],
                "id": 1271,
                "chat_link": "[&BPcEAAA=]"
              }
            },
            "adventures": [],
            "id": 1050,
            "mastery_points": []
          },
          "1051": {
            "name": "Prisoners of the Dragon",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              35072,
              31744
            ],
            "map_rect": [
              [
                -36864,
                -18432
              ],
              [
                39936,
                18432
              ]
            ],
            "continent_rect": [
              [
                33408,
                30976
              ],
              [
                36608,
                32512
              ]
            ],
            "points_of_interest": {
              "1985": {
                "name": "Golden Boughs",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33695.3,
                  32148.6
                ],
                "id": 1985,
                "chat_link": "[&BMEHAAA=]"
              },
              "1986": {
                "name": "Matriarch's Perch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35229.7,
                  31801.6
                ],
                "id": 1986,
                "chat_link": "[&BMIHAAA=]"
              },
              "1991": {
                "name": "Wreck of the Thunderbreaker",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34154,
                  32246.9
                ],
                "id": 1991,
                "chat_link": "[&BMcHAAA=]"
              },
              "1994": {
                "name": "Dwelling of the Kaanas",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35980,
                  31149
                ],
                "id": 1994,
                "chat_link": "[&BMoHAAA=]"
              },
              "1995": {
                "name": "Wreck of the Mellaggan's Valor",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34466.1,
                  31517.4
                ],
                "id": 1995,
                "chat_link": "[&BMsHAAA=]"
              },
              "1999": {
                "name": "Wreck of the Lethal Vantage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36407.8,
                  32171.6
                ],
                "id": 1999,
                "chat_link": "[&BM8HAAA=]"
              },
              "2017": {
                "name": "Temple of Ameyalli",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36096.4,
                  31379
                ],
                "id": 2017,
                "chat_link": "[&BOEHAAA=]"
              },
              "2021": {
                "name": "Precarious Ruin",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33750.1,
                  31169.7
                ],
                "id": 2021,
                "chat_link": "[&BOUHAAA=]"
              },
              "2025": {
                "name": "Last Leap",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35581.7,
                  31392.3
                ],
                "id": 2025,
                "chat_link": "[&BOkHAAA=]"
              },
              "2030": {
                "name": "Fumerol Caves",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35714,
                  31043.1
                ],
                "id": 2030,
                "chat_link": "[&BO4HAAA=]"
              },
              "2032": {
                "name": "The Corpse Grove",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34605.9,
                  31227.2
                ],
                "id": 2032,
                "chat_link": "[&BPAHAAA=]"
              },
              "2036": {
                "name": "Coztic Itzel",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34456.1,
                  32046.8
                ],
                "id": 2036,
                "chat_link": "[&BPQHAAA=]"
              },
              "2042": {
                "name": "Batrach Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36458.3,
                  31267.6
                ],
                "id": 2042,
                "chat_link": "[&BPoHAAA=]"
              },
              "2043": {
                "name": "Brooding Gulch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35686.6,
                  31339.7
                ],
                "id": 2043,
                "chat_link": "[&BPsHAAA=]"
              },
              "2045": {
                "name": "Shaded Spring",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35115.6,
                  31751.3
                ],
                "id": 2045,
                "chat_link": "[&BP0HAAA=]"
              },
              "2046": {
                "name": "Ascendant's Ring",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34152.4,
                  32000.6
                ],
                "id": 2046,
                "chat_link": "[&BP4HAAA=]"
              },
              "2061": {
                "name": "Holdfast Hollow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33822.7,
                  31741.8
                ],
                "id": 2061,
                "chat_link": "[&BA0IAAA=]"
              },
              "2065": {
                "name": "The Waking Tomb",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35963.7,
                  32398.3
                ],
                "id": 2065,
                "chat_link": "[&BBEIAAA=]"
              },
              "2066": {
                "name": "Glory's Fall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35235.3,
                  31271.1
                ],
                "id": 2066,
                "chat_link": "[&BBIIAAA=]"
              },
              "2067": {
                "name": "Dust Dancer Plateau",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35265.6,
                  32306.8
                ],
                "id": 2067,
                "chat_link": "[&BBMIAAA=]"
              },
              "2071": {
                "name": "Uprooted Paradise",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34142.6,
                  31253.1
                ],
                "id": 2071,
                "chat_link": "[&BBcIAAA=]"
              },
              "2072": {
                "name": "Precarious Perch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35631.5,
                  31951.1
                ],
                "id": 2072,
                "chat_link": "[&BBgIAAA=]"
              },
              "2073": {
                "name": "Silent Woods",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34768.8,
                  31691.5
                ],
                "id": 2073,
                "chat_link": "[&BBkIAAA=]"
              },
              "2074": {
                "name": "Creaking Caverns",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35083.9,
                  32165.2
                ],
                "id": 2074,
                "chat_link": "[&BBoIAAA=]"
              },
              "2075": {
                "name": "The Tangle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36095.3,
                  31721.4
                ],
                "id": 2075,
                "chat_link": "[&BBsIAAA=]"
              },
              "2077": {
                "name": "Bongo's Bungalow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34829.3,
                  32391.4
                ],
                "id": 2077,
                "chat_link": "[&BB0IAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1228": {
                "name": "Stonetwist Paths",
                "level": 80,
                "coord": [
                  35244.4,
                  31688.2
                ],
                "bounds": [
                  [
                    35626.6,
                    31696.8
                  ],
                  [
                    35587.3,
                    31743.3
                  ],
                  [
                    35423,
                    31815.3
                  ],
                  [
                    35369.4,
                    31856.2
                  ],
                  [
                    35314.7,
                    31918.9
                  ],
                  [
                    35250.3,
                    31945.9
                  ],
                  [
                    35120.8,
                    31925.4
                  ],
                  [
                    35057.7,
                    31914
                  ],
                  [
                    34875,
                    31809
                  ],
                  [
                    34797.6,
                    31758.9
                  ],
                  [
                    34673.4,
                    31714.2
                  ],
                  [
                    34630.4,
                    31648
                  ],
                  [
                    34691.5,
                    31589.2
                  ],
                  [
                    34948,
                    31539.4
                  ],
                  [
                    35046.6,
                    31487.3
                  ],
                  [
                    35192,
                    31413.1
                  ],
                  [
                    35357.7,
                    31412.6
                  ],
                  [
                    35563.2,
                    31528
                  ],
                  [
                    35634.3,
                    31557.7
                  ],
                  [
                    35752.2,
                    31538.8
                  ],
                  [
                    35771.7,
                    31661.9
                  ],
                  [
                    35693.5,
                    31667.2
                  ],
                  [
                    35626.6,
                    31696.8
                  ]
                ],
                "id": 1228,
                "chat_link": "[&BMwEAAA=]"
              },
              "1229": {
                "name": "Noble Ledges",
                "level": 80,
                "coord": [
                  34221.3,
                  32284.5
                ],
                "bounds": [
                  [
                    33696.1,
                    32530.8
                  ],
                  [
                    34005,
                    32527.3
                  ],
                  [
                    34222.1,
                    32590.6
                  ],
                  [
                    34491.5,
                    32561
                  ],
                  [
                    34561.7,
                    32483.4
                  ],
                  [
                    34616.3,
                    32413.1
                  ],
                  [
                    34625.3,
                    32269.8
                  ],
                  [
                    34684.5,
                    32140.4
                  ],
                  [
                    34528.4,
                    32174.7
                  ],
                  [
                    34403.9,
                    32176.1
                  ],
                  [
                    34375.2,
                    32079.7
                  ],
                  [
                    34302.4,
                    31985
                  ],
                  [
                    34149.6,
                    32020
                  ],
                  [
                    34037.9,
                    32066.3
                  ],
                  [
                    33909.1,
                    32176.1
                  ],
                  [
                    33580.2,
                    32168.8
                  ],
                  [
                    33572.2,
                    32473.1
                  ],
                  [
                    33696.1,
                    32530.8
                  ]
                ],
                "id": 1229,
                "chat_link": "[&BM0EAAA=]"
              },
              "1232": {
                "name": "The Doomteeth",
                "level": 80,
                "coord": [
                  33829.6,
                  31295.8
                ],
                "bounds": [
                  [
                    33577.1,
                    31688.9
                  ],
                  [
                    33649.1,
                    31022.1
                  ],
                  [
                    34141.4,
                    31084.3
                  ],
                  [
                    34016.2,
                    31173.5
                  ],
                  [
                    33892.5,
                    31352.7
                  ],
                  [
                    33701,
                    31453.6
                  ],
                  [
                    33577.1,
                    31688.9
                  ]
                ],
                "id": 1232,
                "chat_link": "[&BNAEAAA=]"
              },
              "1243": {
                "name": "Jaka Itzel",
                "level": 80,
                "coord": [
                  36250.8,
                  31282.1
                ],
                "bounds": [
                  [
                    35973.9,
                    30996.2
                  ],
                  [
                    36629.6,
                    30961.6
                  ],
                  [
                    36712.2,
                    31249
                  ],
                  [
                    36677.6,
                    31392.9
                  ],
                  [
                    36416.4,
                    31363.7
                  ],
                  [
                    36439,
                    31302.1
                  ],
                  [
                    36218.4,
                    31371.6
                  ],
                  [
                    36159.9,
                    31463.5
                  ],
                  [
                    36043.6,
                    31514.9
                  ],
                  [
                    35885.6,
                    31502.2
                  ],
                  [
                    35949.1,
                    31266.2
                  ],
                  [
                    35904.2,
                    31001.1
                  ],
                  [
                    35973.9,
                    30996.2
                  ]
                ],
                "id": 1243,
                "chat_link": "[&BNsEAAA=]"
              },
              "1249": {
                "name": "Blighted Depths",
                "level": 80,
                "coord": [
                  34441.8,
                  31257
                ],
                "bounds": [
                  [
                    33892.1,
                    31351.5
                  ],
                  [
                    34020.5,
                    31168.2
                  ],
                  [
                    34145.8,
                    31083
                  ],
                  [
                    34368,
                    31034.7
                  ],
                  [
                    34634.9,
                    30997.8
                  ],
                  [
                    34991.7,
                    31029.6
                  ],
                  [
                    34842.9,
                    31291.2
                  ],
                  [
                    34769.6,
                    31466
                  ],
                  [
                    34675,
                    31377.7
                  ],
                  [
                    34567.3,
                    31347.7
                  ],
                  [
                    34381.9,
                    31327.3
                  ],
                  [
                    34261.9,
                    31379.8
                  ],
                  [
                    34191.7,
                    31485.9
                  ],
                  [
                    33892.1,
                    31351.5
                  ]
                ],
                "id": 1249,
                "chat_link": "[&BOEEAAA=]"
              },
              "1250": {
                "name": "Shrouded Ruins",
                "level": 80,
                "coord": [
                  35778.2,
                  32227.7
                ],
                "bounds": [
                  [
                    35359.7,
                    32628.8
                  ],
                  [
                    35346.2,
                    32173.3
                  ],
                  [
                    35527.8,
                    32175.6
                  ],
                  [
                    35596.2,
                    32159.1
                  ],
                  [
                    35742.9,
                    31967.5
                  ],
                  [
                    35777.1,
                    32024.3
                  ],
                  [
                    35913,
                    32015.4
                  ],
                  [
                    36078.5,
                    32030.8
                  ],
                  [
                    36191.6,
                    32141.3
                  ],
                  [
                    36267.4,
                    32483.8
                  ],
                  [
                    35919.9,
                    32487
                  ],
                  [
                    35618.5,
                    32445.7
                  ],
                  [
                    35359.7,
                    32628.8
                  ]
                ],
                "id": 1250,
                "chat_link": "[&BOIEAAA=]"
              },
              "1254": {
                "name": "Wyvern Cliffs",
                "level": 80,
                "coord": [
                  35654.4,
                  31333.3
                ],
                "bounds": [
                  [
                    35904.2,
                    31001.1
                  ],
                  [
                    35949,
                    31266.2
                  ],
                  [
                    35884.9,
                    31502.6
                  ],
                  [
                    35751.3,
                    31538.8
                  ],
                  [
                    35633.8,
                    31557.7
                  ],
                  [
                    35563.1,
                    31527.7
                  ],
                  [
                    35547,
                    31436.2
                  ],
                  [
                    35568.3,
                    31382.1
                  ],
                  [
                    35499.5,
                    31337.3
                  ],
                  [
                    35489.1,
                    31301.2
                  ],
                  [
                    35508.5,
                    31143.6
                  ],
                  [
                    35554.8,
                    31005.6
                  ],
                  [
                    35904.2,
                    31001.1
                  ]
                ],
                "id": 1254,
                "chat_link": "[&BOYEAAA=]"
              },
              "1256": {
                "name": "Creeping Crevasse",
                "level": 80,
                "coord": [
                  35941.9,
                  31804.3
                ],
                "bounds": [
                  [
                    36185,
                    31852.6
                  ],
                  [
                    36125.8,
                    31883.3
                  ],
                  [
                    36072.3,
                    31968.6
                  ],
                  [
                    36078.5,
                    32030.8
                  ],
                  [
                    35912.6,
                    32013.9
                  ],
                  [
                    35777.1,
                    32024.3
                  ],
                  [
                    35742.9,
                    31967.2
                  ],
                  [
                    35712.6,
                    31887.6
                  ],
                  [
                    35638.7,
                    31769.6
                  ],
                  [
                    35587.1,
                    31744.7
                  ],
                  [
                    35626.6,
                    31696.8
                  ],
                  [
                    35692.8,
                    31667.1
                  ],
                  [
                    35772.4,
                    31662.9
                  ],
                  [
                    35977.3,
                    31632.6
                  ],
                  [
                    36111.5,
                    31608.8
                  ],
                  [
                    36180.7,
                    31617.1
                  ],
                  [
                    36238.4,
                    31685.7
                  ],
                  [
                    36239.8,
                    31760.7
                  ],
                  [
                    36223.2,
                    31808.3
                  ],
                  [
                    36185,
                    31852.6
                  ]
                ],
                "id": 1256,
                "chat_link": "[&BOgEAAA=]"
              },
              "1259": {
                "name": "Dry Step Mesas",
                "level": 80,
                "coord": [
                  36289.2,
                  31844.6
                ],
                "bounds": [
                  [
                    36125.8,
                    31883.3
                  ],
                  [
                    36185,
                    31852.6
                  ],
                  [
                    36223.2,
                    31808.3
                  ],
                  [
                    36239.8,
                    31760.7
                  ],
                  [
                    36238.6,
                    31685.3
                  ],
                  [
                    36278.2,
                    31677.5
                  ],
                  [
                    36450.1,
                    31707.4
                  ],
                  [
                    36624.1,
                    31777.5
                  ],
                  [
                    36620.2,
                    31830.2
                  ],
                  [
                    36433.1,
                    31857.3
                  ],
                  [
                    36190.7,
                    32140.8
                  ],
                  [
                    36078.5,
                    32030.8
                  ],
                  [
                    36072.3,
                    31968.6
                  ],
                  [
                    36125.8,
                    31883.3
                  ]
                ],
                "id": 1259,
                "chat_link": "[&BOsEAAA=]"
              },
              "1263": {
                "name": "Heartless Pass",
                "level": 80,
                "coord": [
                  36206.2,
                  31528.7
                ],
                "bounds": [
                  [
                    36238.9,
                    31685.8
                  ],
                  [
                    36181.2,
                    31616.9
                  ],
                  [
                    36112.1,
                    31609
                  ],
                  [
                    35977.1,
                    31632.1
                  ],
                  [
                    35772.3,
                    31663
                  ],
                  [
                    35753,
                    31539
                  ],
                  [
                    35885.6,
                    31502.2
                  ],
                  [
                    36043.2,
                    31514
                  ],
                  [
                    36158.8,
                    31463.2
                  ],
                  [
                    36217.9,
                    31371.9
                  ],
                  [
                    36438.7,
                    31302.1
                  ],
                  [
                    36416,
                    31363.1
                  ],
                  [
                    36677.5,
                    31392.8
                  ],
                  [
                    36657.9,
                    31571
                  ],
                  [
                    36431.6,
                    31587.4
                  ],
                  [
                    36337.4,
                    31644.9
                  ],
                  [
                    36238.9,
                    31685.8
                  ]
                ],
                "id": 1263,
                "chat_link": "[&BO8EAAA=]"
              },
              "1264": {
                "name": "Broken Bluffs",
                "level": 80,
                "coord": [
                  34204.8,
                  31606.7
                ],
                "bounds": [
                  [
                    33578.6,
                    31687.4
                  ],
                  [
                    33701.6,
                    31454.3
                  ],
                  [
                    33890.7,
                    31350.4
                  ],
                  [
                    34189.3,
                    31485.9
                  ],
                  [
                    34262.9,
                    31380.3
                  ],
                  [
                    34381.7,
                    31328.2
                  ],
                  [
                    34570.6,
                    31345.3
                  ],
                  [
                    34669,
                    31371.2
                  ],
                  [
                    34770.6,
                    31465.5
                  ],
                  [
                    34691.3,
                    31588.2
                  ],
                  [
                    34629.8,
                    31648.3
                  ],
                  [
                    34376.9,
                    31715.6
                  ],
                  [
                    34315.7,
                    31741.4
                  ],
                  [
                    34282.6,
                    31827.2
                  ],
                  [
                    34080.7,
                    31850.5
                  ],
                  [
                    33926.2,
                    31905.4
                  ],
                  [
                    33758.4,
                    31894.6
                  ],
                  [
                    33609.5,
                    31881.5
                  ],
                  [
                    33578.6,
                    31687.4
                  ]
                ],
                "id": 1264,
                "chat_link": "[&BPAEAAA=]"
              },
              "1265": {
                "name": "Hidden Copse",
                "level": 80,
                "coord": [
                  34923.6,
                  32288.4
                ],
                "bounds": [
                  [
                    35197.9,
                    32183.6
                  ],
                  [
                    35116.3,
                    32304.3
                  ],
                  [
                    35135.5,
                    32380.5
                  ],
                  [
                    35159.3,
                    32561.3
                  ],
                  [
                    34561.8,
                    32483.2
                  ],
                  [
                    34615.4,
                    32413.9
                  ],
                  [
                    34625.7,
                    32270
                  ],
                  [
                    34684.5,
                    32139.9
                  ],
                  [
                    35013.2,
                    32066.1
                  ],
                  [
                    35126.4,
                    32081.4
                  ],
                  [
                    35197.9,
                    32183.6
                  ]
                ],
                "id": 1265,
                "chat_link": "[&BPEEAAA=]"
              },
              "1271": {
                "name": "Maguuma's Breach",
                "level": 80,
                "coord": [
                  36431.1,
                  31664.5
                ],
                "bounds": [
                  [
                    36657.9,
                    31571
                  ],
                  [
                    36431.9,
                    31587.9
                  ],
                  [
                    36337.2,
                    31645.1
                  ],
                  [
                    36238.9,
                    31685.6
                  ],
                  [
                    36277.4,
                    31677.3
                  ],
                  [
                    36450.1,
                    31707.3
                  ],
                  [
                    36624.2,
                    31777.6
                  ],
                  [
                    36657.9,
                    31571
                  ]
                ],
                "id": 1271,
                "chat_link": "[&BPcEAAA=]"
              }
            },
            "adventures": [],
            "id": 1051,
            "mastery_points": []
          },
          "1052": {
            "name": "Verdant Brink",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              35072,
              31744
            ],
            "map_rect": [
              [
                -36864,
                -18432
              ],
              [
                39936,
                18432
              ]
            ],
            "continent_rect": [
              [
                33408,
                30976
              ],
              [
                36608,
                32512
              ]
            ],
            "points_of_interest": {
              "1985": {
                "name": "Golden Boughs",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33695.3,
                  32148.6
                ],
                "id": 1985,
                "chat_link": "[&BMEHAAA=]"
              },
              "1991": {
                "name": "Wreck of the Thunderbreaker",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34154,
                  32246.9
                ],
                "id": 1991,
                "chat_link": "[&BMcHAAA=]"
              },
              "1994": {
                "name": "Dwelling of the Kaanas",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35980,
                  31149
                ],
                "id": 1994,
                "chat_link": "[&BMoHAAA=]"
              },
              "1995": {
                "name": "Wreck of the Mellaggan's Valor",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34466.1,
                  31517.4
                ],
                "id": 1995,
                "chat_link": "[&BMsHAAA=]"
              },
              "1999": {
                "name": "Wreck of the Lethal Vantage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36407.8,
                  32171.6
                ],
                "id": 1999,
                "chat_link": "[&BM8HAAA=]"
              },
              "2005": {
                "name": "Mellaggan's Valor Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34501.6,
                  31503.7
                ],
                "id": 2005,
                "chat_link": "[&BNUHAAA=]"
              },
              "2014": {
                "name": "Shipwreck Peak Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  36479.7,
                  31660.6
                ],
                "id": 2014,
                "chat_link": "[&BN4HAAA=]"
              },
              "2016": {
                "name": "Jaka Itzel Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  36032.8,
                  31135.7
                ],
                "id": 2016,
                "chat_link": "[&BOAHAAA=]"
              },
              "2017": {
                "name": "Temple of Ameyalli",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36096.4,
                  31379
                ],
                "id": 2017,
                "chat_link": "[&BOEHAAA=]"
              },
              "2021": {
                "name": "Precarious Ruin",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33750.1,
                  31169.7
                ],
                "id": 2021,
                "chat_link": "[&BOUHAAA=]"
              },
              "2030": {
                "name": "Fumerol Caves",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35714,
                  31043.1
                ],
                "id": 2030,
                "chat_link": "[&BO4HAAA=]"
              },
              "2031": {
                "name": "Faren's Flyer Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34083.3,
                  32201.2
                ],
                "id": 2031,
                "chat_link": "[&BO8HAAA=]"
              },
              "2032": {
                "name": "The Corpse Grove",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34605.9,
                  31227.2
                ],
                "id": 2032,
                "chat_link": "[&BPAHAAA=]"
              },
              "2036": {
                "name": "Coztic Itzel",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34456.1,
                  32046.8
                ],
                "id": 2036,
                "chat_link": "[&BPQHAAA=]"
              },
              "2042": {
                "name": "Batrach Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36458.3,
                  31267.6
                ],
                "id": 2042,
                "chat_link": "[&BPoHAAA=]"
              },
              "2043": {
                "name": "Brooding Gulch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35686.6,
                  31339.7
                ],
                "id": 2043,
                "chat_link": "[&BPsHAAA=]"
              },
              "2045": {
                "name": "Shaded Spring",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35115.6,
                  31751.3
                ],
                "id": 2045,
                "chat_link": "[&BP0HAAA=]"
              },
              "2049": {
                "name": "Shrouded Ruins Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  35554.9,
                  32384.1
                ],
                "id": 2049,
                "chat_link": "[&BAEIAAA=]"
              },
              "2056": {
                "name": "Pact Encampment Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  35165.7,
                  31785.4
                ],
                "id": 2056,
                "chat_link": "[&BAgIAAA=]"
              },
              "2061": {
                "name": "Holdfast Hollow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33822.7,
                  31741.8
                ],
                "id": 2061,
                "chat_link": "[&BA0IAAA=]"
              },
              "2065": {
                "name": "The Waking Tomb",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35963.7,
                  32398.3
                ],
                "id": 2065,
                "chat_link": "[&BBEIAAA=]"
              },
              "2066": {
                "name": "Glory's Fall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35235.3,
                  31271.1
                ],
                "id": 2066,
                "chat_link": "[&BBIIAAA=]"
              },
              "2067": {
                "name": "Dust Dancer Plateau",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35265.6,
                  32306.8
                ],
                "id": 2067,
                "chat_link": "[&BBMIAAA=]"
              },
              "2071": {
                "name": "Uprooted Paradise",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34142.6,
                  31253.1
                ],
                "id": 2071,
                "chat_link": "[&BBcIAAA=]"
              },
              "2074": {
                "name": "Creaking Caverns",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35083.9,
                  32165.2
                ],
                "id": 2074,
                "chat_link": "[&BBoIAAA=]"
              },
              "2075": {
                "name": "The Tangle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36095.3,
                  31721.4
                ],
                "id": 2075,
                "chat_link": "[&BBsIAAA=]"
              },
              "2076": {
                "name": "Treacherous Path Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  33681.2,
                  32396.7
                ],
                "id": 2076,
                "chat_link": "[&BBwIAAA=]"
              },
              "2077": {
                "name": "Bongo's Bungalow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34829.3,
                  32391.4
                ],
                "id": 2077,
                "chat_link": "[&BB0IAAA=]"
              },
              "2080": {
                "name": "Raid—Forsaken Thicket",
                "type": "unlock",
                "floor": 1,
                "coord": [
                  36533.9,
                  31050.6
                ],
                "id": 2080,
                "chat_link": "[&BCAIAAA=]",
                "icon": "https://render.guildwars2.com/file/5866630DA52DCB5C423FB81ECF69FD071611E36B/1128644.png"
              },
              "2204": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  35803.3,
                  32350.2
                ],
                "id": 2204,
                "chat_link": "[&BJwIAAA=]"
              },
              "2226": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  34804,
                  31697.3
                ],
                "id": 2226,
                "chat_link": "[&BLIIAAA=]"
              },
              "2231": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  36010.8,
                  31163
                ],
                "id": 2231,
                "chat_link": "[&BLcIAAA=]"
              },
              "2235": {
                "type": "vista",
                "floor": 2,
                "coord": [
                  34118.9,
                  31549.1
                ],
                "id": 2235,
                "chat_link": "[&BLsIAAA=]"
              },
              "2265": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  36361.8,
                  32065.1
                ],
                "id": 2265,
                "chat_link": "[&BNkIAAA=]"
              },
              "2277": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  33981.3,
                  31377.8
                ],
                "id": 2277,
                "chat_link": "[&BOUIAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [
              {
                "coord": [
                  34289.9,
                  31934.9
                ],
                "id": "1-0"
              },
              {
                "coord": [
                  35956.2,
                  32442.9
                ],
                "id": "1-1"
              },
              {
                "coord": [
                  35920,
                  31805.3
                ],
                "id": "1-2"
              },
              {
                "coord": [
                  35803,
                  31241.3
                ],
                "id": "1-3"
              },
              {
                "coord": [
                  33959.4,
                  31433.9
                ],
                "id": "1-4"
              },
              {
                "coord": [
                  34818.6,
                  31959.5
                ],
                "id": "1-5"
              },
              {
                "coord": [
                  35532.5,
                  31513.8
                ],
                "id": "1-6"
              },
              {
                "coord": [
                  34410,
                  32122
                ],
                "id": "1-7"
              },
              {
                "coord": [
                  33844.1,
                  31965.9
                ],
                "id": "1-8"
              },
              {
                "coord": [
                  35277.7,
                  31386.3
                ],
                "id": "1-9"
              },
              {
                "coord": [
                  33794.1,
                  32319.1
                ],
                "id": "1-10"
              }
            ],
            "sectors": {
              "1216": {
                "name": "Coztic Grounds",
                "level": 80,
                "coord": [
                  34519.7,
                  31911.2
                ],
                "bounds": [
                  [
                    34378.7,
                    32081.7
                  ],
                  [
                    34302.9,
                    31985.2
                  ],
                  [
                    34284,
                    31825.1
                  ],
                  [
                    34315.7,
                    31741.6
                  ],
                  [
                    34377,
                    31715.6
                  ],
                  [
                    34629.8,
                    31647.6
                  ],
                  [
                    34673.2,
                    31714.2
                  ],
                  [
                    34797.6,
                    31759.1
                  ],
                  [
                    34723.6,
                    31880.4
                  ],
                  [
                    34657.2,
                    32004.3
                  ],
                  [
                    34684.3,
                    32140.3
                  ],
                  [
                    34528.2,
                    32175
                  ],
                  [
                    34403.6,
                    32176
                  ],
                  [
                    34378.7,
                    32081.7
                  ]
                ],
                "id": 1216,
                "chat_link": "[&BMAEAAA=]"
              },
              "1228": {
                "name": "Stonetwist Paths",
                "level": 80,
                "coord": [
                  35244.4,
                  31688.2
                ],
                "bounds": [
                  [
                    35626.6,
                    31696.8
                  ],
                  [
                    35587.3,
                    31743.3
                  ],
                  [
                    35423,
                    31815.3
                  ],
                  [
                    35369.4,
                    31856.2
                  ],
                  [
                    35314.7,
                    31918.9
                  ],
                  [
                    35250.3,
                    31945.9
                  ],
                  [
                    35120.8,
                    31925.4
                  ],
                  [
                    35057.7,
                    31914
                  ],
                  [
                    34875,
                    31809
                  ],
                  [
                    34797.6,
                    31758.9
                  ],
                  [
                    34673.4,
                    31714.2
                  ],
                  [
                    34630.4,
                    31648
                  ],
                  [
                    34691.5,
                    31589.2
                  ],
                  [
                    34948,
                    31539.4
                  ],
                  [
                    35046.6,
                    31487.3
                  ],
                  [
                    35192,
                    31413.1
                  ],
                  [
                    35357.7,
                    31412.6
                  ],
                  [
                    35563.2,
                    31528
                  ],
                  [
                    35634.3,
                    31557.7
                  ],
                  [
                    35752.2,
                    31538.8
                  ],
                  [
                    35771.7,
                    31661.9
                  ],
                  [
                    35693.5,
                    31667.2
                  ],
                  [
                    35626.6,
                    31696.8
                  ]
                ],
                "id": 1228,
                "chat_link": "[&BMwEAAA=]"
              },
              "1229": {
                "name": "Noble Ledges",
                "level": 80,
                "coord": [
                  34221.3,
                  32284.5
                ],
                "bounds": [
                  [
                    33696.1,
                    32530.8
                  ],
                  [
                    34005,
                    32527.3
                  ],
                  [
                    34222.1,
                    32590.6
                  ],
                  [
                    34491.5,
                    32561
                  ],
                  [
                    34561.7,
                    32483.4
                  ],
                  [
                    34616.3,
                    32413.1
                  ],
                  [
                    34625.3,
                    32269.8
                  ],
                  [
                    34684.5,
                    32140.4
                  ],
                  [
                    34528.4,
                    32174.7
                  ],
                  [
                    34403.9,
                    32176.1
                  ],
                  [
                    34375.2,
                    32079.7
                  ],
                  [
                    34302.4,
                    31985
                  ],
                  [
                    34149.6,
                    32020
                  ],
                  [
                    34037.9,
                    32066.3
                  ],
                  [
                    33909.1,
                    32176.1
                  ],
                  [
                    33580.2,
                    32168.8
                  ],
                  [
                    33572.2,
                    32473.1
                  ],
                  [
                    33696.1,
                    32530.8
                  ]
                ],
                "id": 1229,
                "chat_link": "[&BM0EAAA=]"
              },
              "1232": {
                "name": "The Doomteeth",
                "level": 80,
                "coord": [
                  33829.6,
                  31295.8
                ],
                "bounds": [
                  [
                    33577.1,
                    31688.9
                  ],
                  [
                    33649.1,
                    31022.1
                  ],
                  [
                    34141.4,
                    31084.3
                  ],
                  [
                    34016.2,
                    31173.5
                  ],
                  [
                    33892.5,
                    31352.7
                  ],
                  [
                    33701,
                    31453.6
                  ],
                  [
                    33577.1,
                    31688.9
                  ]
                ],
                "id": 1232,
                "chat_link": "[&BNAEAAA=]"
              },
              "1243": {
                "name": "Jaka Itzel",
                "level": 80,
                "coord": [
                  36250.8,
                  31282.1
                ],
                "bounds": [
                  [
                    35973.9,
                    30996.2
                  ],
                  [
                    36629.6,
                    30961.6
                  ],
                  [
                    36712.2,
                    31249
                  ],
                  [
                    36677.6,
                    31392.9
                  ],
                  [
                    36416.4,
                    31363.7
                  ],
                  [
                    36439,
                    31302.1
                  ],
                  [
                    36218.4,
                    31371.6
                  ],
                  [
                    36159.9,
                    31463.5
                  ],
                  [
                    36043.6,
                    31514.9
                  ],
                  [
                    35885.6,
                    31502.2
                  ],
                  [
                    35949.1,
                    31266.2
                  ],
                  [
                    35904.2,
                    31001.1
                  ],
                  [
                    35973.9,
                    30996.2
                  ]
                ],
                "id": 1243,
                "chat_link": "[&BNsEAAA=]"
              },
              "1249": {
                "name": "Blighted Depths",
                "level": 80,
                "coord": [
                  34441.8,
                  31257
                ],
                "bounds": [
                  [
                    33892.1,
                    31351.5
                  ],
                  [
                    34020.5,
                    31168.2
                  ],
                  [
                    34145.8,
                    31083
                  ],
                  [
                    34368,
                    31034.7
                  ],
                  [
                    34634.9,
                    30997.8
                  ],
                  [
                    34991.7,
                    31029.6
                  ],
                  [
                    34842.9,
                    31291.2
                  ],
                  [
                    34769.6,
                    31466
                  ],
                  [
                    34675,
                    31377.7
                  ],
                  [
                    34567.3,
                    31347.7
                  ],
                  [
                    34381.9,
                    31327.3
                  ],
                  [
                    34261.9,
                    31379.8
                  ],
                  [
                    34191.7,
                    31485.9
                  ],
                  [
                    33892.1,
                    31351.5
                  ]
                ],
                "id": 1249,
                "chat_link": "[&BOEEAAA=]"
              },
              "1250": {
                "name": "Shrouded Ruins",
                "level": 80,
                "coord": [
                  35778.2,
                  32227.7
                ],
                "bounds": [
                  [
                    35359.7,
                    32628.8
                  ],
                  [
                    35346.2,
                    32173.3
                  ],
                  [
                    35527.8,
                    32175.6
                  ],
                  [
                    35596.2,
                    32159.1
                  ],
                  [
                    35742.9,
                    31967.5
                  ],
                  [
                    35777.1,
                    32024.3
                  ],
                  [
                    35913,
                    32015.4
                  ],
                  [
                    36078.5,
                    32030.8
                  ],
                  [
                    36191.6,
                    32141.3
                  ],
                  [
                    36267.4,
                    32483.8
                  ],
                  [
                    35919.9,
                    32487
                  ],
                  [
                    35618.5,
                    32445.7
                  ],
                  [
                    35359.7,
                    32628.8
                  ]
                ],
                "id": 1250,
                "chat_link": "[&BOIEAAA=]"
              },
              "1254": {
                "name": "Wyvern Cliffs",
                "level": 80,
                "coord": [
                  35654.4,
                  31333.3
                ],
                "bounds": [
                  [
                    35904.2,
                    31001.1
                  ],
                  [
                    35949,
                    31266.2
                  ],
                  [
                    35884.9,
                    31502.6
                  ],
                  [
                    35751.3,
                    31538.8
                  ],
                  [
                    35633.8,
                    31557.7
                  ],
                  [
                    35563.1,
                    31527.7
                  ],
                  [
                    35547,
                    31436.2
                  ],
                  [
                    35568.3,
                    31382.1
                  ],
                  [
                    35499.5,
                    31337.3
                  ],
                  [
                    35489.1,
                    31301.2
                  ],
                  [
                    35508.5,
                    31143.6
                  ],
                  [
                    35554.8,
                    31005.6
                  ],
                  [
                    35904.2,
                    31001.1
                  ]
                ],
                "id": 1254,
                "chat_link": "[&BOYEAAA=]"
              },
              "1256": {
                "name": "Creeping Crevasse",
                "level": 80,
                "coord": [
                  35941.9,
                  31804.3
                ],
                "bounds": [
                  [
                    36185,
                    31852.6
                  ],
                  [
                    36125.8,
                    31883.3
                  ],
                  [
                    36072.3,
                    31968.6
                  ],
                  [
                    36078.5,
                    32030.8
                  ],
                  [
                    35912.6,
                    32013.9
                  ],
                  [
                    35777.1,
                    32024.3
                  ],
                  [
                    35742.9,
                    31967.2
                  ],
                  [
                    35712.6,
                    31887.6
                  ],
                  [
                    35638.7,
                    31769.6
                  ],
                  [
                    35587.1,
                    31744.7
                  ],
                  [
                    35626.6,
                    31696.8
                  ],
                  [
                    35692.8,
                    31667.1
                  ],
                  [
                    35772.4,
                    31662.9
                  ],
                  [
                    35977.3,
                    31632.6
                  ],
                  [
                    36111.5,
                    31608.8
                  ],
                  [
                    36180.7,
                    31617.1
                  ],
                  [
                    36238.4,
                    31685.7
                  ],
                  [
                    36239.8,
                    31760.7
                  ],
                  [
                    36223.2,
                    31808.3
                  ],
                  [
                    36185,
                    31852.6
                  ]
                ],
                "id": 1256,
                "chat_link": "[&BOgEAAA=]"
              },
              "1259": {
                "name": "Dry Step Mesas",
                "level": 80,
                "coord": [
                  36289.2,
                  31844.6
                ],
                "bounds": [
                  [
                    36125.8,
                    31883.3
                  ],
                  [
                    36185,
                    31852.6
                  ],
                  [
                    36223.2,
                    31808.3
                  ],
                  [
                    36239.8,
                    31760.7
                  ],
                  [
                    36238.6,
                    31685.3
                  ],
                  [
                    36278.2,
                    31677.5
                  ],
                  [
                    36450.1,
                    31707.4
                  ],
                  [
                    36624.1,
                    31777.5
                  ],
                  [
                    36620.2,
                    31830.2
                  ],
                  [
                    36433.1,
                    31857.3
                  ],
                  [
                    36190.7,
                    32140.8
                  ],
                  [
                    36078.5,
                    32030.8
                  ],
                  [
                    36072.3,
                    31968.6
                  ],
                  [
                    36125.8,
                    31883.3
                  ]
                ],
                "id": 1259,
                "chat_link": "[&BOsEAAA=]"
              },
              "1263": {
                "name": "Heartless Pass",
                "level": 80,
                "coord": [
                  36206.2,
                  31528.7
                ],
                "bounds": [
                  [
                    36238.9,
                    31685.8
                  ],
                  [
                    36181.2,
                    31616.9
                  ],
                  [
                    36112.1,
                    31609
                  ],
                  [
                    35977.1,
                    31632.1
                  ],
                  [
                    35772.3,
                    31663
                  ],
                  [
                    35753,
                    31539
                  ],
                  [
                    35885.6,
                    31502.2
                  ],
                  [
                    36043.2,
                    31514
                  ],
                  [
                    36158.8,
                    31463.2
                  ],
                  [
                    36217.9,
                    31371.9
                  ],
                  [
                    36438.7,
                    31302.1
                  ],
                  [
                    36416,
                    31363.1
                  ],
                  [
                    36677.5,
                    31392.8
                  ],
                  [
                    36657.9,
                    31571
                  ],
                  [
                    36431.6,
                    31587.4
                  ],
                  [
                    36337.4,
                    31644.9
                  ],
                  [
                    36238.9,
                    31685.8
                  ]
                ],
                "id": 1263,
                "chat_link": "[&BO8EAAA=]"
              },
              "1264": {
                "name": "Broken Bluffs",
                "level": 80,
                "coord": [
                  34204.8,
                  31606.7
                ],
                "bounds": [
                  [
                    33578.6,
                    31687.4
                  ],
                  [
                    33701.6,
                    31454.3
                  ],
                  [
                    33890.7,
                    31350.4
                  ],
                  [
                    34189.3,
                    31485.9
                  ],
                  [
                    34262.9,
                    31380.3
                  ],
                  [
                    34381.7,
                    31328.2
                  ],
                  [
                    34570.6,
                    31345.3
                  ],
                  [
                    34669,
                    31371.2
                  ],
                  [
                    34770.6,
                    31465.5
                  ],
                  [
                    34691.3,
                    31588.2
                  ],
                  [
                    34629.8,
                    31648.3
                  ],
                  [
                    34376.9,
                    31715.6
                  ],
                  [
                    34315.7,
                    31741.4
                  ],
                  [
                    34282.6,
                    31827.2
                  ],
                  [
                    34080.7,
                    31850.5
                  ],
                  [
                    33926.2,
                    31905.4
                  ],
                  [
                    33758.4,
                    31894.6
                  ],
                  [
                    33609.5,
                    31881.5
                  ],
                  [
                    33578.6,
                    31687.4
                  ]
                ],
                "id": 1264,
                "chat_link": "[&BPAEAAA=]"
              },
              "1265": {
                "name": "Hidden Copse",
                "level": 80,
                "coord": [
                  34923.6,
                  32288.4
                ],
                "bounds": [
                  [
                    35197.9,
                    32183.6
                  ],
                  [
                    35116.3,
                    32304.3
                  ],
                  [
                    35135.5,
                    32380.5
                  ],
                  [
                    35159.3,
                    32561.3
                  ],
                  [
                    34561.8,
                    32483.2
                  ],
                  [
                    34615.4,
                    32413.9
                  ],
                  [
                    34625.7,
                    32270
                  ],
                  [
                    34684.5,
                    32139.9
                  ],
                  [
                    35013.2,
                    32066.1
                  ],
                  [
                    35126.4,
                    32081.4
                  ],
                  [
                    35197.9,
                    32183.6
                  ]
                ],
                "id": 1265,
                "chat_link": "[&BPEEAAA=]"
              },
              "1266": {
                "name": "Thistlevine Ravine",
                "level": 80,
                "coord": [
                  35221.2,
                  32041.9
                ],
                "bounds": [
                  [
                    35637.3,
                    31770.2
                  ],
                  [
                    35712.6,
                    31887.2
                  ],
                  [
                    35742.9,
                    31966.7
                  ],
                  [
                    35595.8,
                    32158.7
                  ],
                  [
                    35527.4,
                    32175.1
                  ],
                  [
                    35346.1,
                    32173
                  ],
                  [
                    35359.8,
                    32628.8
                  ],
                  [
                    35157.8,
                    32562.9
                  ],
                  [
                    35135.5,
                    32380
                  ],
                  [
                    35115.6,
                    32304.5
                  ],
                  [
                    35197.3,
                    32183.4
                  ],
                  [
                    35126.6,
                    32081.4
                  ],
                  [
                    35012.9,
                    32065.8
                  ],
                  [
                    34684.6,
                    32140.1
                  ],
                  [
                    34658.1,
                    32002.9
                  ],
                  [
                    34723.9,
                    31880.5
                  ],
                  [
                    34797.5,
                    31759
                  ],
                  [
                    34874.7,
                    31809.1
                  ],
                  [
                    35058,
                    31913.8
                  ],
                  [
                    35120.8,
                    31925.6
                  ],
                  [
                    35249.9,
                    31945.5
                  ],
                  [
                    35314.9,
                    31918.9
                  ],
                  [
                    35369.5,
                    31856.1
                  ],
                  [
                    35423.6,
                    31815.5
                  ],
                  [
                    35586.6,
                    31743.4
                  ],
                  [
                    35637.3,
                    31770.2
                  ]
                ],
                "id": 1266,
                "chat_link": "[&BPIEAAA=]"
              },
              "1267": {
                "name": "Snarled Frontier",
                "level": 80,
                "coord": [
                  36464.5,
                  32148.2
                ],
                "bounds": [
                  [
                    36613.4,
                    32432.7
                  ],
                  [
                    36267.1,
                    32484.6
                  ],
                  [
                    36191.4,
                    32141.4
                  ],
                  [
                    36434.2,
                    31857.6
                  ],
                  [
                    36620.2,
                    31830.3
                  ],
                  [
                    36660.6,
                    32142.6
                  ],
                  [
                    36613.4,
                    32432.7
                  ]
                ],
                "id": 1267,
                "chat_link": "[&BPMEAAA=]"
              },
              "1268": {
                "name": "Skyclaw Peaks",
                "level": 80,
                "coord": [
                  35238.1,
                  31357.3
                ],
                "bounds": [
                  [
                    35489.3,
                    31301.1
                  ],
                  [
                    35508.6,
                    31145.7
                  ],
                  [
                    35555.2,
                    31002.3
                  ],
                  [
                    34992.8,
                    31029.7
                  ],
                  [
                    34843.1,
                    31292
                  ],
                  [
                    34768.7,
                    31465.6
                  ],
                  [
                    34691.4,
                    31588.6
                  ],
                  [
                    34947.8,
                    31539.3
                  ],
                  [
                    35047.5,
                    31486.6
                  ],
                  [
                    35192.4,
                    31413.1
                  ],
                  [
                    35357.7,
                    31412.4
                  ],
                  [
                    35562.4,
                    31527.9
                  ],
                  [
                    35546.7,
                    31436.3
                  ],
                  [
                    35568.1,
                    31382.2
                  ],
                  [
                    35499.4,
                    31337.3
                  ],
                  [
                    35489.3,
                    31301.1
                  ]
                ],
                "id": 1268,
                "chat_link": "[&BPQEAAA=]"
              },
              "1269": {
                "name": "Treacherous Paths",
                "level": 80,
                "coord": [
                  33963.8,
                  31977.6
                ],
                "bounds": [
                  [
                    33580.4,
                    32169.1
                  ],
                  [
                    33608.9,
                    31882.8
                  ],
                  [
                    33759.3,
                    31895.7
                  ],
                  [
                    33924.1,
                    31902.4
                  ],
                  [
                    34078.9,
                    31850.4
                  ],
                  [
                    34284.2,
                    31825.3
                  ],
                  [
                    34303.2,
                    31986.3
                  ],
                  [
                    34149.5,
                    32020.5
                  ],
                  [
                    34039.4,
                    32066.2
                  ],
                  [
                    33909.9,
                    32177.2
                  ],
                  [
                    33580.4,
                    32169.1
                  ]
                ],
                "id": 1269,
                "chat_link": "[&BPUEAAA=]"
              },
              "1271": {
                "name": "Maguuma's Breach",
                "level": 80,
                "coord": [
                  36431.1,
                  31664.5
                ],
                "bounds": [
                  [
                    36657.9,
                    31571
                  ],
                  [
                    36431.9,
                    31587.9
                  ],
                  [
                    36337.2,
                    31645.1
                  ],
                  [
                    36238.9,
                    31685.6
                  ],
                  [
                    36277.4,
                    31677.3
                  ],
                  [
                    36450.1,
                    31707.3
                  ],
                  [
                    36624.2,
                    31777.6
                  ],
                  [
                    36657.9,
                    31571
                  ]
                ],
                "id": 1271,
                "chat_link": "[&BPcEAAA=]"
              }
            },
            "adventures": [
              {
                "coord": [
                  36433.6,
                  32107.2
                ],
                "id": "1E9B3362-99C4-4B82-A550-67B364C60054",
                "name": "Tendril Torchers",
                "description": "Burn tendrils and avoid unexploded shot before time runs out!"
              },
              {
                "coord": [
                  35906.9,
                  32351.9
                ],
                "id": "2C5812B6-650A-4A0B-8F01-A0B74DED529C",
                "name": "Salvage Pit",
                "description": "Gather supplies and avoid tendrils before time runs out!"
              },
              {
                "coord": [
                  36450,
                  31308.6
                ],
                "id": "8152C474-665F-487E-9270-C4B99D237D7D",
                "name": "Bugs in the Branches",
                "description": "Jump and glide to collect bugs before time runs out!"
              },
              {
                "coord": [
                  34807.9,
                  32357.8
                ],
                "id": "74ECC73B-3F4A-41BE-80A0-F12E5B8F4D95",
                "name": "Shooting Gallery",
                "description": "Shoot as many target dummies as you can before time runs out!"
              },
              {
                "coord": [
                  34297.2,
                  31212.1
                ],
                "id": "16A8A4CB-93CC-4E99-AE50-AD946030920C",
                "name": "Flying Circus",
                "description": "Glide through the glowing rings and reach the finish line as fast as possible!"
              }
            ],
            "id": 1052,
            "mastery_points": [
              {
                "coord": [
                  35206.7,
                  31628.7
                ],
                "id": 75,
                "region": "Maguuma"
              },
              {
                "coord": [
                  36063,
                  31596.1
                ],
                "id": 42,
                "region": "Maguuma"
              },
              {
                "coord": [
                  34428.7,
                  32203.4
                ],
                "id": 9,
                "region": "Maguuma"
              },
              {
                "coord": [
                  35154.4,
                  31955.3
                ],
                "id": 4,
                "region": "Maguuma"
              },
              {
                "coord": [
                  35903,
                  31823.7
                ],
                "id": 43,
                "region": "Maguuma"
              },
              {
                "coord": [
                  34572.6,
                  31170.7
                ],
                "id": 3,
                "region": "Maguuma"
              },
              {
                "coord": [
                  34977.8,
                  32251.7
                ],
                "id": 143,
                "region": "Maguuma"
              },
              {
                "coord": [
                  35105.5,
                  31892.8
                ],
                "id": 86,
                "region": "Maguuma"
              },
              {
                "coord": [
                  35592.9,
                  31016.7
                ],
                "id": 95,
                "region": "Maguuma"
              }
            ]
          },
          "1054": {
            "name": "Bitter Harvest",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              35712,
              37120
            ],
            "map_rect": [
              [
                -36864,
                -30720
              ],
              [
                36864,
                33792
              ]
            ],
            "continent_rect": [
              [
                34048,
                36096
              ],
              [
                37120,
                38784
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1257": {
                "name": "Pact Base Camp",
                "level": 80,
                "coord": [
                  36840.4,
                  36287.7
                ],
                "bounds": [
                  [
                    36656.8,
                    36104.1
                  ],
                  [
                    36683,
                    36216.1
                  ],
                  [
                    36701.8,
                    36324.3
                  ],
                  [
                    36719.1,
                    36410.6
                  ],
                  [
                    36742.1,
                    36597.6
                  ],
                  [
                    36823.4,
                    36553.8
                  ],
                  [
                    36885,
                    36511.2
                  ],
                  [
                    37038.9,
                    36481.6
                  ],
                  [
                    37176.4,
                    36209.8
                  ],
                  [
                    37077.1,
                    35863.6
                  ],
                  [
                    36740.7,
                    35892.2
                  ],
                  [
                    36656.8,
                    36104.1
                  ]
                ],
                "id": 1257,
                "chat_link": "[&BOkEAAA=]"
              },
              "1297": {
                "name": "Bitter Harvest",
                "level": 80,
                "coord": [
                  36251.2,
                  38282.8
                ],
                "bounds": [
                  [
                    36502.2,
                    37852.1
                  ],
                  [
                    36668.4,
                    37956.1
                  ],
                  [
                    36851.8,
                    38014.1
                  ],
                  [
                    36831.6,
                    38418.9
                  ],
                  [
                    36756.9,
                    38530.5
                  ],
                  [
                    36451.3,
                    38766.4
                  ],
                  [
                    35396.1,
                    38753.5
                  ],
                  [
                    35502.7,
                    38466.1
                  ],
                  [
                    35514.6,
                    38198.4
                  ],
                  [
                    35903,
                    38276.8
                  ],
                  [
                    36095,
                    38383.8
                  ],
                  [
                    36225.9,
                    38346.7
                  ],
                  [
                    36283.7,
                    38274.2
                  ],
                  [
                    36349.4,
                    38102.9
                  ],
                  [
                    36435.9,
                    37901.4
                  ],
                  [
                    36502.2,
                    37852.1
                  ]
                ],
                "id": 1297,
                "chat_link": "[&BBEFAAA=]"
              },
              "1305": {
                "name": "Central Blighting Tower",
                "level": 80,
                "coord": [
                  35659.6,
                  37870.7
                ],
                "bounds": [
                  [
                    35500.9,
                    37638.1
                  ],
                  [
                    35579.6,
                    37627.9
                  ],
                  [
                    35757.4,
                    37590.8
                  ],
                  [
                    35933.3,
                    37696.2
                  ],
                  [
                    35922.8,
                    37900.5
                  ],
                  [
                    35837.2,
                    38052.2
                  ],
                  [
                    35736.8,
                    38091.7
                  ],
                  [
                    35626.4,
                    38051.6
                  ],
                  [
                    35536.9,
                    38033.4
                  ],
                  [
                    35449.4,
                    38031.6
                  ],
                  [
                    35375.2,
                    37863.5
                  ],
                  [
                    35500.9,
                    37638.1
                  ]
                ],
                "id": 1305,
                "chat_link": "[&BBkFAAA=]"
              },
              "1307": {
                "name": "Southern Barbed Gate",
                "level": 80,
                "coord": [
                  36383.8,
                  37899.5
                ],
                "bounds": [
                  [
                    36575,
                    37747.8
                  ],
                  [
                    36533,
                    37818.2
                  ],
                  [
                    36485.7,
                    37887.4
                  ],
                  [
                    36437.1,
                    37902.8
                  ],
                  [
                    36419.1,
                    37933.4
                  ],
                  [
                    36347.4,
                    38107.5
                  ],
                  [
                    36315,
                    38167.9
                  ],
                  [
                    36294.8,
                    38242
                  ],
                  [
                    36281.7,
                    38273.9
                  ],
                  [
                    36213.5,
                    38286.9
                  ],
                  [
                    36219.4,
                    38250.5
                  ],
                  [
                    36238,
                    38158.2
                  ],
                  [
                    36248.9,
                    38059
                  ],
                  [
                    36228,
                    37981
                  ],
                  [
                    36115.2,
                    37884.5
                  ],
                  [
                    36260,
                    37714.7
                  ],
                  [
                    36452.8,
                    37321.7
                  ],
                  [
                    36588.3,
                    37362.4
                  ],
                  [
                    36548.5,
                    37484.5
                  ],
                  [
                    36640.5,
                    37630.9
                  ],
                  [
                    36617.4,
                    37673.4
                  ],
                  [
                    36575,
                    37747.8
                  ]
                ],
                "id": 1307,
                "chat_link": "[&BBsFAAA=]"
              },
              "1309": {
                "name": "Chak Nest",
                "level": 80,
                "coord": [
                  36865.7,
                  37749.6
                ],
                "bounds": [
                  [
                    37092.8,
                    37809.3
                  ],
                  [
                    37033,
                    37888.6
                  ],
                  [
                    36929.7,
                    37953.8
                  ],
                  [
                    36851.6,
                    38013.3
                  ],
                  [
                    36756.9,
                    37996.5
                  ],
                  [
                    36668.6,
                    37955.6
                  ],
                  [
                    36556.2,
                    37889
                  ],
                  [
                    36501.6,
                    37850.4
                  ],
                  [
                    36627.9,
                    37639.5
                  ],
                  [
                    36732.5,
                    37582.7
                  ],
                  [
                    36899.3,
                    37488.3
                  ],
                  [
                    37005.2,
                    37418.7
                  ],
                  [
                    37117.2,
                    37409.2
                  ],
                  [
                    37117.4,
                    37625.6
                  ],
                  [
                    37095.3,
                    37724.1
                  ],
                  [
                    37092.8,
                    37809.3
                  ]
                ],
                "id": 1309,
                "chat_link": "[&BB0FAAA=]"
              },
              "1319": {
                "name": "Exhumed Delve",
                "level": 80,
                "coord": [
                  36796.3,
                  37229.9
                ],
                "bounds": [
                  [
                    37101.8,
                    36941.6
                  ],
                  [
                    37096.7,
                    37225
                  ],
                  [
                    37096.7,
                    37403.6
                  ],
                  [
                    37095.8,
                    37418
                  ],
                  [
                    37003.7,
                    37429.3
                  ],
                  [
                    36902.4,
                    37493.5
                  ],
                  [
                    36816.6,
                    37541.7
                  ],
                  [
                    36735.8,
                    37588.4
                  ],
                  [
                    36632.9,
                    37640.7
                  ],
                  [
                    36541.5,
                    37487.5
                  ],
                  [
                    36579.5,
                    37364.9
                  ],
                  [
                    36623.8,
                    37182.7
                  ],
                  [
                    36573.8,
                    37040.5
                  ],
                  [
                    36557.1,
                    36879.6
                  ],
                  [
                    36594.8,
                    36896.6
                  ],
                  [
                    36636.5,
                    36906.3
                  ],
                  [
                    36756.8,
                    36935.7
                  ],
                  [
                    36861.8,
                    36980.7
                  ],
                  [
                    36921.4,
                    37012.6
                  ],
                  [
                    37101.8,
                    36941.6
                  ]
                ],
                "id": 1319,
                "chat_link": "[&BCcFAAA=]"
              },
              "1320": {
                "name": "Central Barbed Gate",
                "level": 80,
                "coord": [
                  35926.4,
                  37460.8
                ],
                "bounds": [
                  [
                    35885.3,
                    36951.5
                  ],
                  [
                    35985.7,
                    37190.6
                  ],
                  [
                    36130.5,
                    37234.8
                  ],
                  [
                    36262.8,
                    37307
                  ],
                  [
                    36324,
                    37292.1
                  ],
                  [
                    36456,
                    37328
                  ],
                  [
                    36265.5,
                    37715.9
                  ],
                  [
                    36116.3,
                    37889.7
                  ],
                  [
                    35916.9,
                    37902
                  ],
                  [
                    35927.4,
                    37701.1
                  ],
                  [
                    35759.3,
                    37600.6
                  ],
                  [
                    35584.8,
                    37635.8
                  ],
                  [
                    35485.6,
                    37638.1
                  ],
                  [
                    35392.1,
                    37539.9
                  ],
                  [
                    35615.2,
                    37264.4
                  ],
                  [
                    35715.8,
                    37180.9
                  ],
                  [
                    35885.3,
                    36951.5
                  ]
                ],
                "id": 1320,
                "chat_link": "[&BCgFAAA=]"
              },
              "1327": {
                "name": "Southern Blighting Tower",
                "level": 80,
                "coord": [
                  36019.5,
                  38120.7
                ],
                "bounds": [
                  [
                    35921.5,
                    37896.1
                  ],
                  [
                    36122.4,
                    37874.9
                  ],
                  [
                    36234.3,
                    37975.3
                  ],
                  [
                    36254.4,
                    38057.9
                  ],
                  [
                    36243.5,
                    38156
                  ],
                  [
                    36204.5,
                    38341.6
                  ],
                  [
                    36065.7,
                    38378.7
                  ],
                  [
                    35904.6,
                    38269.1
                  ],
                  [
                    35700.8,
                    38237
                  ],
                  [
                    35729.5,
                    38089
                  ],
                  [
                    35833.1,
                    38052.2
                  ],
                  [
                    35921.5,
                    37896.1
                  ]
                ],
                "id": 1327,
                "chat_link": "[&BC8FAAA=]"
              },
              "1329": {
                "name": "Northern Barbed Gate",
                "level": 80,
                "coord": [
                  35271,
                  37166.5
                ],
                "bounds": [
                  [
                    35893.4,
                    36945.4
                  ],
                  [
                    35698.3,
                    36815.7
                  ],
                  [
                    35436,
                    36738
                  ],
                  [
                    35183.9,
                    36904.5
                  ],
                  [
                    34939.3,
                    36988.2
                  ],
                  [
                    34820.4,
                    37021.7
                  ],
                  [
                    34840.6,
                    37067.2
                  ],
                  [
                    35046.3,
                    37041.1
                  ],
                  [
                    35198.4,
                    37170.6
                  ],
                  [
                    35167.1,
                    37270.8
                  ],
                  [
                    35153.5,
                    37322
                  ],
                  [
                    35056.9,
                    37650.4
                  ],
                  [
                    35166.3,
                    37729.1
                  ],
                  [
                    35395.9,
                    37541.1
                  ],
                  [
                    35617.4,
                    37271.4
                  ],
                  [
                    35721.7,
                    37186.6
                  ],
                  [
                    35893.4,
                    36945.4
                  ]
                ],
                "id": 1329,
                "chat_link": "[&BDEFAAA=]"
              },
              "1333": {
                "name": "Prismatic Postpile",
                "level": 80,
                "coord": [
                  36809.1,
                  36788
                ],
                "bounds": [
                  [
                    37039.8,
                    36479.6
                  ],
                  [
                    37074.3,
                    36815.7
                  ],
                  [
                    37100.4,
                    36944.2
                  ],
                  [
                    36919.1,
                    37020.7
                  ],
                  [
                    36854.1,
                    36983.7
                  ],
                  [
                    36756.1,
                    36941.5
                  ],
                  [
                    36634.3,
                    36912.3
                  ],
                  [
                    36592.4,
                    36901.1
                  ],
                  [
                    36547.6,
                    36885.1
                  ],
                  [
                    36549.9,
                    36712
                  ],
                  [
                    36744.4,
                    36593.9
                  ],
                  [
                    36820.8,
                    36548.6
                  ],
                  [
                    36885.1,
                    36505.3
                  ],
                  [
                    37039.8,
                    36479.6
                  ]
                ],
                "id": 1333,
                "chat_link": "[&BDUFAAA=]"
              },
              "1334": {
                "name": "Wyvern Scar",
                "level": 80,
                "coord": [
                  36311.1,
                  37087.7
                ],
                "bounds": [
                  [
                    35934.3,
                    36820.3
                  ],
                  [
                    35877.2,
                    36942.5
                  ],
                  [
                    35981.1,
                    37194.5
                  ],
                  [
                    36126.8,
                    37240.7
                  ],
                  [
                    36262.3,
                    37315.3
                  ],
                  [
                    36323.9,
                    37297.1
                  ],
                  [
                    36585.7,
                    37368
                  ],
                  [
                    36629.7,
                    37183.7
                  ],
                  [
                    36579.5,
                    37039.3
                  ],
                  [
                    36567.2,
                    36873.7
                  ],
                  [
                    36491.2,
                    36972.3
                  ],
                  [
                    36406.5,
                    36988.7
                  ],
                  [
                    36279,
                    36903.7
                  ],
                  [
                    35934.3,
                    36820.3
                  ]
                ],
                "id": 1334,
                "chat_link": "[&BDYFAAA=]"
              },
              "1335": {
                "name": "Northern Blighting Tower",
                "level": 80,
                "coord": [
                  34966.3,
                  37303.3
                ],
                "bounds": [
                  [
                    34838.7,
                    37060.6
                  ],
                  [
                    34912.6,
                    37048.7
                  ],
                  [
                    35051.8,
                    37035.5
                  ],
                  [
                    35202.1,
                    37171.1
                  ],
                  [
                    35172.5,
                    37277.3
                  ],
                  [
                    35158.8,
                    37324.1
                  ],
                  [
                    35138.1,
                    37391.6
                  ],
                  [
                    35091.8,
                    37543.7
                  ],
                  [
                    35061.3,
                    37653.4
                  ],
                  [
                    34872.2,
                    37545.2
                  ],
                  [
                    34813.5,
                    37447.4
                  ],
                  [
                    34798.8,
                    37353.5
                  ],
                  [
                    34685.4,
                    37281.4
                  ],
                  [
                    34731,
                    37113.2
                  ],
                  [
                    34838.7,
                    37060.6
                  ]
                ],
                "id": 1335,
                "chat_link": "[&BDcFAAA=]"
              },
              "1339": {
                "name": "Toadstool Mire",
                "level": 80,
                "coord": [
                  36421.6,
                  36609.6
                ],
                "bounds": [
                  [
                    36748,
                    36596
                  ],
                  [
                    36554.5,
                    36713.3
                  ],
                  [
                    36561.3,
                    36884.9
                  ],
                  [
                    36494.8,
                    36977.4
                  ],
                  [
                    36407.7,
                    36998.6
                  ],
                  [
                    36271.1,
                    36909.5
                  ],
                  [
                    35932,
                    36825.4
                  ],
                  [
                    36033.5,
                    36598.9
                  ],
                  [
                    36234.7,
                    36600.7
                  ],
                  [
                    36291.3,
                    36533.8
                  ],
                  [
                    36312.7,
                    36422.7
                  ],
                  [
                    36395.5,
                    36311.6
                  ],
                  [
                    36486.2,
                    36349.9
                  ],
                  [
                    36582.2,
                    36292.6
                  ],
                  [
                    36710,
                    36327.4
                  ],
                  [
                    36729.6,
                    36410.8
                  ],
                  [
                    36748,
                    36596
                  ]
                ],
                "id": 1339,
                "chat_link": "[&BDsFAAA=]"
              },
              "1341": {
                "name": "Rooted Copse",
                "level": 80,
                "coord": [
                  35049.9,
                  36734.9
                ],
                "bounds": [
                  [
                    34823.6,
                    37030.6
                  ],
                  [
                    34853.6,
                    36871
                  ],
                  [
                    34861.9,
                    36812.3
                  ],
                  [
                    34882.2,
                    36714
                  ],
                  [
                    35024.3,
                    36625.8
                  ],
                  [
                    35085.3,
                    36519.3
                  ],
                  [
                    35226.9,
                    36358.6
                  ],
                  [
                    35218.6,
                    36501.3
                  ],
                  [
                    35437.6,
                    36740.4
                  ],
                  [
                    35189.7,
                    36912.4
                  ],
                  [
                    34945.2,
                    36998.5
                  ],
                  [
                    34823.6,
                    37030.6
                  ]
                ],
                "id": 1341,
                "chat_link": "[&BD0FAAA=]"
              },
              "1346": {
                "name": "Vigilant Precipice",
                "level": 80,
                "coord": [
                  36370.5,
                  36279.1
                ],
                "bounds": [
                  [
                    36745.4,
                    35902.9
                  ],
                  [
                    36657.9,
                    36105.8
                  ],
                  [
                    36708.7,
                    36333.3
                  ],
                  [
                    36582.4,
                    36301.5
                  ],
                  [
                    36487.2,
                    36355.1
                  ],
                  [
                    36397.5,
                    36318.1
                  ],
                  [
                    36319.6,
                    36423.4
                  ],
                  [
                    36297.7,
                    36536.6
                  ],
                  [
                    36239.4,
                    36607
                  ],
                  [
                    36033.4,
                    36608.7
                  ],
                  [
                    35871.7,
                    35959.4
                  ],
                  [
                    36105.3,
                    35897.3
                  ],
                  [
                    36745.4,
                    35902.9
                  ]
                ],
                "id": 1346,
                "chat_link": "[&BEIFAAA=]"
              },
              "1347": {
                "name": "Dragon's Domain",
                "level": 80,
                "coord": [
                  35009.7,
                  37986.5
                ],
                "bounds": [
                  [
                    34200.1,
                    37722.9
                  ],
                  [
                    34152.7,
                    37852.6
                  ],
                  [
                    34185.2,
                    38029.5
                  ],
                  [
                    34309.9,
                    38335.7
                  ],
                  [
                    34357.8,
                    38473.8
                  ],
                  [
                    34573.9,
                    38579.3
                  ],
                  [
                    34815.4,
                    38710.2
                  ],
                  [
                    35119.7,
                    38759.8
                  ],
                  [
                    35438.7,
                    38631.2
                  ],
                  [
                    35504.5,
                    38465.8
                  ],
                  [
                    35525.5,
                    38238.9
                  ],
                  [
                    35519.5,
                    38209.6
                  ],
                  [
                    35705.1,
                    38238.9
                  ],
                  [
                    35734.2,
                    38088.2
                  ],
                  [
                    35627.7,
                    38050.7
                  ],
                  [
                    35537.9,
                    38030.4
                  ],
                  [
                    35448.2,
                    38027.8
                  ],
                  [
                    35379.2,
                    37864
                  ],
                  [
                    35504.6,
                    37641.8
                  ],
                  [
                    35392.9,
                    37535.9
                  ],
                  [
                    35157.1,
                    37723.2
                  ],
                  [
                    35000.9,
                    37606.1
                  ],
                  [
                    34873.9,
                    37543
                  ],
                  [
                    34818.3,
                    37445
                  ],
                  [
                    34802.7,
                    37350.3
                  ],
                  [
                    34686.1,
                    37278.2
                  ],
                  [
                    34575.4,
                    37532.3
                  ],
                  [
                    34323.2,
                    37658
                  ],
                  [
                    34200.1,
                    37722.9
                  ]
                ],
                "id": 1347,
                "chat_link": "[&BEMFAAA=]"
              },
              "1353": {
                "name": "Broken Altar",
                "level": 80,
                "coord": [
                  35596.3,
                  36432.4
                ],
                "bounds": [
                  [
                    35936.7,
                    36211.1
                  ],
                  [
                    35871.2,
                    35954.3
                  ],
                  [
                    35574.1,
                    36015.7
                  ],
                  [
                    35260.4,
                    36037.1
                  ],
                  [
                    35089.8,
                    36182.8
                  ],
                  [
                    35223.1,
                    36359.4
                  ],
                  [
                    35212,
                    36504.6
                  ],
                  [
                    35428.8,
                    36742.3
                  ],
                  [
                    35696.7,
                    36819.9
                  ],
                  [
                    35885.6,
                    36944.4
                  ],
                  [
                    35942.2,
                    36818.6
                  ],
                  [
                    36035.4,
                    36597.9
                  ],
                  [
                    35936.7,
                    36211.1
                  ]
                ],
                "id": 1353,
                "chat_link": "[&BEkFAAA=]"
              }
            },
            "adventures": [],
            "id": 1054,
            "mastery_points": []
          },
          "1057": {
            "name": "Strange Observations",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              34304,
              33792
            ],
            "map_rect": [
              [
                -24576,
                -33792
              ],
              [
                24576,
                33792
              ]
            ],
            "continent_rect": [
              [
                33280,
                32512
              ],
              [
                35328,
                35328
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1057,
            "mastery_points": []
          },
          "1062": {
            "name": "Spirit Vale",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              35968,
              29440
            ],
            "map_rect": [
              [
                -15360,
                -36864
              ],
              [
                15360,
                39936
              ]
            ],
            "continent_rect": [
              [
                36224,
                27396
              ],
              [
                37504,
                30596
              ]
            ],
            "points_of_interest": {
              "2309": {
                "name": "River of Spirits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36895.9,
                  29586.9
                ],
                "id": 2309,
                "chat_link": "[&BAUJAAA=]"
              },
              "2310": {
                "name": "Abandoned Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36742.1,
                  29422.4
                ],
                "id": 2310,
                "chat_link": "[&BAYJAAA=]"
              },
              "2311": {
                "name": "The Skillet",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36651.1,
                  28924.5
                ],
                "id": 2311,
                "chat_link": "[&BAcJAAA=]"
              },
              "2312": {
                "name": "Mysterious Pylons",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36664.2,
                  29917.7
                ],
                "id": 2312,
                "chat_link": "[&BAgJAAA=]"
              },
              "2313": {
                "name": "Bandit's Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36637.9,
                  29242.4
                ],
                "id": 2313,
                "chat_link": "[&BAkJAAA=]"
              },
              "2314": {
                "name": "Gorseval's Perch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36932.4,
                  29245.2
                ],
                "id": 2314,
                "chat_link": "[&BAoJAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1275": {
                "name": "Spirit Vale",
                "level": 80,
                "coord": [
                  36746.5,
                  29511.9
                ],
                "bounds": [
                  [
                    36304.6,
                    28969.5
                  ],
                  [
                    36334.4,
                    28882.3
                  ],
                  [
                    36501.5,
                    28784.9
                  ],
                  [
                    36646.8,
                    28676.1
                  ],
                  [
                    36797.3,
                    28661.7
                  ],
                  [
                    36983.7,
                    28660.9
                  ],
                  [
                    37101.3,
                    28887.2
                  ],
                  [
                    37100,
                    29320.6
                  ],
                  [
                    37054.3,
                    29818.9
                  ],
                  [
                    37079.9,
                    30246.8
                  ],
                  [
                    37071.2,
                    31209.5
                  ],
                  [
                    36352.1,
                    31204.1
                  ],
                  [
                    36378,
                    30332.6
                  ],
                  [
                    36304.6,
                    28969.5
                  ]
                ],
                "id": 1275,
                "chat_link": "[&BPsEAAA=]"
              }
            },
            "adventures": [],
            "id": 1062,
            "mastery_points": []
          },
          "1064": {
            "name": "Claiming the Lost Precipice",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 48,
            "label_coord": [
              34192,
              30270
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                33536,
                29696
              ],
              [
                34816,
                30976
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1289": {
                "level": 0,
                "coord": [
                  34265.1,
                  30458
                ],
                "bounds": [
                  [
                    34935.2,
                    29795.8
                  ],
                  [
                    34969.6,
                    31126.6
                  ],
                  [
                    33575.5,
                    31195
                  ],
                  [
                    33580.2,
                    29714.8
                  ],
                  [
                    34935.2,
                    29795.8
                  ]
                ],
                "id": 1289,
                "chat_link": "[&BAkFAAA=]"
              }
            },
            "adventures": [],
            "id": 1064,
            "mastery_points": []
          },
          "1069": {
            "name": "Lost Precipice",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              34192,
              30270
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                33536,
                29696
              ],
              [
                34816,
                30976
              ]
            ],
            "points_of_interest": {
              "2107": {
                "name": "Canyon Dig Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  33684.6,
                  29911.2
                ],
                "id": 2107,
                "chat_link": "[&BDsIAAA=]"
              },
              "2129": {
                "name": "Riverside Overlook Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  33951.8,
                  30648.6
                ],
                "id": 2129,
                "chat_link": "[&BFEIAAA=]"
              },
              "2167": {
                "name": "Upper Plaza Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34211.1,
                  29897.3
                ],
                "id": 2167,
                "chat_link": "[&BHcIAAA=]"
              },
              "2238": {
                "name": "Shrine Tunnel Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34612.9,
                  30938.2
                ],
                "id": 2238,
                "chat_link": "[&BL4IAAA=]"
              },
              "2242": {
                "name": "Central Precipice Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34234.5,
                  30347.5
                ],
                "id": 2242,
                "chat_link": "[&BMIIAAA=]"
              },
              "2292": {
                "name": "Sandstone Coliseum Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34786.5,
                  30849.3
                ],
                "id": 2292,
                "chat_link": "[&BPQIAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1289": {
                "level": 0,
                "coord": [
                  34265.1,
                  30458
                ],
                "bounds": [
                  [
                    34935.2,
                    29795.8
                  ],
                  [
                    34969.6,
                    31126.6
                  ],
                  [
                    33575.5,
                    31195
                  ],
                  [
                    33580.2,
                    29714.8
                  ],
                  [
                    34935.2,
                    29795.8
                  ]
                ],
                "id": 1289,
                "chat_link": "[&BAkFAAA=]"
              }
            },
            "adventures": [],
            "id": 1069,
            "mastery_points": []
          },
          "1070": {
            "name": "Claiming the Lost Precipice",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 48,
            "label_coord": [
              34192,
              30270
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                33536,
                29696
              ],
              [
                34816,
                30976
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1289": {
                "level": 0,
                "coord": [
                  34265.1,
                  30458
                ],
                "bounds": [
                  [
                    34935.2,
                    29795.8
                  ],
                  [
                    34969.6,
                    31126.6
                  ],
                  [
                    33575.5,
                    31195
                  ],
                  [
                    33580.2,
                    29714.8
                  ],
                  [
                    34935.2,
                    29795.8
                  ]
                ],
                "id": 1289,
                "chat_link": "[&BAkFAAA=]"
              }
            },
            "id": 1070,
            "mastery_points": [],
            "adventures": []
          },
          "1071": {
            "name": "Lost Precipice",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              34192,
              30270
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                33536,
                29696
              ],
              [
                34816,
                30976
              ]
            ],
            "points_of_interest": {
              "2107": {
                "name": "Canyon Dig Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  33684.6,
                  29911.2
                ],
                "id": 2107,
                "chat_link": "[&BDsIAAA=]"
              },
              "2129": {
                "name": "Riverside Overlook Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  33951.8,
                  30648.6
                ],
                "id": 2129,
                "chat_link": "[&BFEIAAA=]"
              },
              "2167": {
                "name": "Upper Plaza Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34211.1,
                  29897.3
                ],
                "id": 2167,
                "chat_link": "[&BHcIAAA=]"
              },
              "2238": {
                "name": "Shrine Tunnel Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34612.9,
                  30938.2
                ],
                "id": 2238,
                "chat_link": "[&BL4IAAA=]"
              },
              "2242": {
                "name": "Central Precipice Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34234.5,
                  30347.5
                ],
                "id": 2242,
                "chat_link": "[&BMIIAAA=]"
              },
              "2292": {
                "name": "Sandstone Coliseum Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34786.5,
                  30849.3
                ],
                "id": 2292,
                "chat_link": "[&BPQIAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1289": {
                "level": 0,
                "coord": [
                  34265.1,
                  30458
                ],
                "bounds": [
                  [
                    34935.2,
                    29795.8
                  ],
                  [
                    34969.6,
                    31126.6
                  ],
                  [
                    33575.5,
                    31195
                  ],
                  [
                    33580.2,
                    29714.8
                  ],
                  [
                    34935.2,
                    29795.8
                  ]
                ],
                "id": 1289,
                "chat_link": "[&BAkFAAA=]"
              }
            },
            "id": 1071,
            "mastery_points": [],
            "adventures": []
          },
          "1076": {
            "name": "Lost Precipice",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              34192,
              30270
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                33536,
                29696
              ],
              [
                34816,
                30976
              ]
            ],
            "points_of_interest": {
              "2107": {
                "name": "Canyon Dig Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  33684.6,
                  29911.2
                ],
                "id": 2107,
                "chat_link": "[&BDsIAAA=]"
              },
              "2129": {
                "name": "Riverside Overlook Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  33951.8,
                  30648.6
                ],
                "id": 2129,
                "chat_link": "[&BFEIAAA=]"
              },
              "2167": {
                "name": "Upper Plaza Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34211.1,
                  29897.3
                ],
                "id": 2167,
                "chat_link": "[&BHcIAAA=]"
              },
              "2238": {
                "name": "Shrine Tunnel Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34612.9,
                  30938.2
                ],
                "id": 2238,
                "chat_link": "[&BL4IAAA=]"
              },
              "2242": {
                "name": "Central Precipice Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34234.5,
                  30347.5
                ],
                "id": 2242,
                "chat_link": "[&BMIIAAA=]"
              },
              "2292": {
                "name": "Sandstone Coliseum Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34786.5,
                  30849.3
                ],
                "id": 2292,
                "chat_link": "[&BPQIAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1289": {
                "level": 0,
                "coord": [
                  34265.1,
                  30458
                ],
                "bounds": [
                  [
                    34935.2,
                    29795.8
                  ],
                  [
                    34969.6,
                    31126.6
                  ],
                  [
                    33575.5,
                    31195
                  ],
                  [
                    33580.2,
                    29714.8
                  ],
                  [
                    34935.2,
                    29795.8
                  ]
                ],
                "id": 1289,
                "chat_link": "[&BAkFAAA=]"
              }
            },
            "id": 1076,
            "mastery_points": [],
            "adventures": []
          },
          "1095": {
            "name": "Dragon's Stand (Heart of Thorns)",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "map_rect": [
              [
                -36864,
                -30720
              ],
              [
                36864,
                33792
              ]
            ],
            "continent_rect": [
              [
                34048,
                36096
              ],
              [
                37120,
                38784
              ]
            ],
            "points_of_interest": {
              "2097": {
                "name": "Pact Base Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36645.4,
                  36289.6
                ],
                "id": 2097,
                "chat_link": "[&BDEIAAA=]"
              },
              "2104": {
                "name": "Ruined Glory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36706.8,
                  36828.8
                ],
                "id": 2104,
                "chat_link": "[&BDgIAAA=]"
              },
              "2110": {
                "name": "First Northern Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36388.4,
                  36271.6
                ],
                "id": 2110,
                "chat_link": "[&BD4IAAA=]"
              },
              "2119": {
                "name": "Ley Line Boneyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36563.3,
                  37621.4
                ],
                "id": 2119,
                "chat_link": "[&BEcIAAA=]"
              },
              "2124": {
                "name": "Wyvern Nest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36092.8,
                  37160.4
                ],
                "id": 2124,
                "chat_link": "[&BEwIAAA=]"
              },
              "2125": {
                "name": "Ley Line Overlook",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36478.5,
                  37720.9
                ],
                "id": 2125,
                "chat_link": "[&BE0IAAA=]"
              },
              "2142": {
                "name": "Mordremoth's Vantage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34376.1,
                  38198.5
                ],
                "id": 2142,
                "chat_link": "[&BF4IAAA=]"
              },
              "2143": {
                "name": "Third Central Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36069.9,
                  37336.1
                ],
                "id": 2143,
                "chat_link": "[&BF8IAAA=]"
              },
              "2147": {
                "name": "First Central Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36563.3,
                  36431
                ],
                "id": 2147,
                "chat_link": "[&BGMIAAA=]"
              },
              "2169": {
                "name": "Rata Novan Remnants",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37059,
                  37013.5
                ],
                "id": 2169,
                "chat_link": "[&BHkIAAA=]"
              },
              "2172": {
                "name": "Mordrem Vineyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36072.9,
                  37427.3
                ],
                "id": 2172,
                "chat_link": "[&BHwIAAA=]"
              },
              "2175": {
                "name": "Serenity's Cove",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34184.7,
                  37841.8
                ],
                "id": 2175,
                "chat_link": "[&BH8IAAA=]"
              },
              "2176": {
                "name": "Northern Blighting Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35008.9,
                  37225.3
                ],
                "id": 2176,
                "chat_link": "[&BIAIAAA=]"
              },
              "2177": {
                "name": "Second Southern Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36945.6,
                  37199.6
                ],
                "id": 2177,
                "chat_link": "[&BIEIAAA=]"
              },
              "2181": {
                "name": "Central Blighting Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35735.7,
                  37802.6
                ],
                "id": 2181,
                "chat_link": "[&BIUIAAA=]"
              },
              "2193": {
                "name": "First Southern Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36918.9,
                  36658.4
                ],
                "id": 2193,
                "chat_link": "[&BJEIAAA=]"
              },
              "2200": {
                "name": "Southern Blighting Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36071.1,
                  38096.4
                ],
                "id": 2200,
                "chat_link": "[&BJgIAAA=]"
              },
              "2210": {
                "name": "Second Northern Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35799.1,
                  36515.9
                ],
                "id": 2210,
                "chat_link": "[&BKIIAAA=]"
              },
              "2224": {
                "name": "Chak Den",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36839.6,
                  37760.6
                ],
                "id": 2224,
                "chat_link": "[&BLAIAAA=]"
              },
              "2233": {
                "name": "Third Northern Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35506.1,
                  36862.5
                ],
                "id": 2233,
                "chat_link": "[&BLkIAAA=]"
              },
              "2241": {
                "name": "The Inverse Pit",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35033.1,
                  36819.8
                ],
                "id": 2241,
                "chat_link": "[&BMEIAAA=]"
              },
              "2274": {
                "name": "Second Central Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36283.2,
                  36962.5
                ],
                "id": 2274,
                "chat_link": "[&BOIIAAA=]"
              },
              "2289": {
                "name": "Third Southern Checkpoint",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36693.4,
                  37538.3
                ],
                "id": 2289,
                "chat_link": "[&BPEIAAA=]"
              },
              "2290": {
                "name": "Blighted Bog",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36384.1,
                  36805.1
                ],
                "id": 2290,
                "chat_link": "[&BPIIAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1257": {
                "name": "Pact Base Camp",
                "level": 80,
                "coord": [
                  36840.4,
                  36287.7
                ],
                "bounds": [
                  [
                    36656.8,
                    36104.1
                  ],
                  [
                    36683,
                    36216.1
                  ],
                  [
                    36701.8,
                    36324.3
                  ],
                  [
                    36719.1,
                    36410.6
                  ],
                  [
                    36742.1,
                    36597.6
                  ],
                  [
                    36823.4,
                    36553.8
                  ],
                  [
                    36885,
                    36511.2
                  ],
                  [
                    37038.9,
                    36481.6
                  ],
                  [
                    37176.4,
                    36209.8
                  ],
                  [
                    37077.1,
                    35863.6
                  ],
                  [
                    36740.7,
                    35892.2
                  ],
                  [
                    36656.8,
                    36104.1
                  ]
                ],
                "id": 1257,
                "chat_link": "[&BOkEAAA=]"
              },
              "1305": {
                "name": "Central Blighting Tower",
                "level": 80,
                "coord": [
                  35659.6,
                  37870.7
                ],
                "bounds": [
                  [
                    35500.9,
                    37638.1
                  ],
                  [
                    35579.6,
                    37627.9
                  ],
                  [
                    35757.4,
                    37590.8
                  ],
                  [
                    35933.3,
                    37696.2
                  ],
                  [
                    35922.8,
                    37900.5
                  ],
                  [
                    35837.2,
                    38052.2
                  ],
                  [
                    35736.8,
                    38091.7
                  ],
                  [
                    35626.4,
                    38051.6
                  ],
                  [
                    35536.9,
                    38033.4
                  ],
                  [
                    35449.4,
                    38031.6
                  ],
                  [
                    35375.2,
                    37863.5
                  ],
                  [
                    35500.9,
                    37638.1
                  ]
                ],
                "id": 1305,
                "chat_link": "[&BBkFAAA=]"
              },
              "1307": {
                "name": "Southern Barbed Gate",
                "level": 80,
                "coord": [
                  36383.8,
                  37899.5
                ],
                "bounds": [
                  [
                    36575,
                    37747.8
                  ],
                  [
                    36533,
                    37818.2
                  ],
                  [
                    36485.7,
                    37887.4
                  ],
                  [
                    36437.1,
                    37902.8
                  ],
                  [
                    36419.1,
                    37933.4
                  ],
                  [
                    36347.4,
                    38107.5
                  ],
                  [
                    36315,
                    38167.9
                  ],
                  [
                    36294.8,
                    38242
                  ],
                  [
                    36281.7,
                    38273.9
                  ],
                  [
                    36213.5,
                    38286.9
                  ],
                  [
                    36219.4,
                    38250.5
                  ],
                  [
                    36238,
                    38158.2
                  ],
                  [
                    36248.9,
                    38059
                  ],
                  [
                    36228,
                    37981
                  ],
                  [
                    36115.2,
                    37884.5
                  ],
                  [
                    36260,
                    37714.7
                  ],
                  [
                    36452.8,
                    37321.7
                  ],
                  [
                    36588.3,
                    37362.4
                  ],
                  [
                    36548.5,
                    37484.5
                  ],
                  [
                    36640.5,
                    37630.9
                  ],
                  [
                    36617.4,
                    37673.4
                  ],
                  [
                    36575,
                    37747.8
                  ]
                ],
                "id": 1307,
                "chat_link": "[&BBsFAAA=]"
              },
              "1309": {
                "name": "Chak Nest",
                "level": 80,
                "coord": [
                  36865.7,
                  37749.6
                ],
                "bounds": [
                  [
                    37092.8,
                    37809.3
                  ],
                  [
                    37033,
                    37888.6
                  ],
                  [
                    36929.7,
                    37953.8
                  ],
                  [
                    36851.6,
                    38013.3
                  ],
                  [
                    36756.9,
                    37996.5
                  ],
                  [
                    36668.6,
                    37955.6
                  ],
                  [
                    36556.2,
                    37889
                  ],
                  [
                    36501.6,
                    37850.4
                  ],
                  [
                    36627.9,
                    37639.5
                  ],
                  [
                    36732.5,
                    37582.7
                  ],
                  [
                    36899.3,
                    37488.3
                  ],
                  [
                    37005.2,
                    37418.7
                  ],
                  [
                    37117.2,
                    37409.2
                  ],
                  [
                    37117.4,
                    37625.6
                  ],
                  [
                    37095.3,
                    37724.1
                  ],
                  [
                    37092.8,
                    37809.3
                  ]
                ],
                "id": 1309,
                "chat_link": "[&BB0FAAA=]"
              },
              "1319": {
                "name": "Exhumed Delve",
                "level": 80,
                "coord": [
                  36796.3,
                  37229.9
                ],
                "bounds": [
                  [
                    37101.8,
                    36941.6
                  ],
                  [
                    37096.7,
                    37225
                  ],
                  [
                    37096.7,
                    37403.6
                  ],
                  [
                    37095.8,
                    37418
                  ],
                  [
                    37003.7,
                    37429.3
                  ],
                  [
                    36902.4,
                    37493.5
                  ],
                  [
                    36816.6,
                    37541.7
                  ],
                  [
                    36735.8,
                    37588.4
                  ],
                  [
                    36632.9,
                    37640.7
                  ],
                  [
                    36541.5,
                    37487.5
                  ],
                  [
                    36579.5,
                    37364.9
                  ],
                  [
                    36623.8,
                    37182.7
                  ],
                  [
                    36573.8,
                    37040.5
                  ],
                  [
                    36557.1,
                    36879.6
                  ],
                  [
                    36594.8,
                    36896.6
                  ],
                  [
                    36636.5,
                    36906.3
                  ],
                  [
                    36756.8,
                    36935.7
                  ],
                  [
                    36861.8,
                    36980.7
                  ],
                  [
                    36921.4,
                    37012.6
                  ],
                  [
                    37101.8,
                    36941.6
                  ]
                ],
                "id": 1319,
                "chat_link": "[&BCcFAAA=]"
              },
              "1320": {
                "name": "Central Barbed Gate",
                "level": 80,
                "coord": [
                  35926.4,
                  37460.8
                ],
                "bounds": [
                  [
                    35885.3,
                    36951.5
                  ],
                  [
                    35985.7,
                    37190.6
                  ],
                  [
                    36130.5,
                    37234.8
                  ],
                  [
                    36262.8,
                    37307
                  ],
                  [
                    36324,
                    37292.1
                  ],
                  [
                    36456,
                    37328
                  ],
                  [
                    36265.5,
                    37715.9
                  ],
                  [
                    36116.3,
                    37889.7
                  ],
                  [
                    35916.9,
                    37902
                  ],
                  [
                    35927.4,
                    37701.1
                  ],
                  [
                    35759.3,
                    37600.6
                  ],
                  [
                    35584.8,
                    37635.8
                  ],
                  [
                    35485.6,
                    37638.1
                  ],
                  [
                    35392.1,
                    37539.9
                  ],
                  [
                    35615.2,
                    37264.4
                  ],
                  [
                    35715.8,
                    37180.9
                  ],
                  [
                    35885.3,
                    36951.5
                  ]
                ],
                "id": 1320,
                "chat_link": "[&BCgFAAA=]"
              },
              "1327": {
                "name": "Southern Blighting Tower",
                "level": 80,
                "coord": [
                  36019.5,
                  38120.7
                ],
                "bounds": [
                  [
                    35921.5,
                    37896.1
                  ],
                  [
                    36122.4,
                    37874.9
                  ],
                  [
                    36234.3,
                    37975.3
                  ],
                  [
                    36254.4,
                    38057.9
                  ],
                  [
                    36243.5,
                    38156
                  ],
                  [
                    36204.5,
                    38341.6
                  ],
                  [
                    36065.7,
                    38378.7
                  ],
                  [
                    35904.6,
                    38269.1
                  ],
                  [
                    35700.8,
                    38237
                  ],
                  [
                    35729.5,
                    38089
                  ],
                  [
                    35833.1,
                    38052.2
                  ],
                  [
                    35921.5,
                    37896.1
                  ]
                ],
                "id": 1327,
                "chat_link": "[&BC8FAAA=]"
              },
              "1329": {
                "name": "Northern Barbed Gate",
                "level": 80,
                "coord": [
                  35271,
                  37166.5
                ],
                "bounds": [
                  [
                    35893.4,
                    36945.4
                  ],
                  [
                    35698.3,
                    36815.7
                  ],
                  [
                    35436,
                    36738
                  ],
                  [
                    35183.9,
                    36904.5
                  ],
                  [
                    34939.3,
                    36988.2
                  ],
                  [
                    34820.4,
                    37021.7
                  ],
                  [
                    34840.6,
                    37067.2
                  ],
                  [
                    35046.3,
                    37041.1
                  ],
                  [
                    35198.4,
                    37170.6
                  ],
                  [
                    35167.1,
                    37270.8
                  ],
                  [
                    35153.5,
                    37322
                  ],
                  [
                    35056.9,
                    37650.4
                  ],
                  [
                    35166.3,
                    37729.1
                  ],
                  [
                    35395.9,
                    37541.1
                  ],
                  [
                    35617.4,
                    37271.4
                  ],
                  [
                    35721.7,
                    37186.6
                  ],
                  [
                    35893.4,
                    36945.4
                  ]
                ],
                "id": 1329,
                "chat_link": "[&BDEFAAA=]"
              },
              "1333": {
                "name": "Prismatic Postpile",
                "level": 80,
                "coord": [
                  36809.1,
                  36788
                ],
                "bounds": [
                  [
                    37039.8,
                    36479.6
                  ],
                  [
                    37074.3,
                    36815.7
                  ],
                  [
                    37100.4,
                    36944.2
                  ],
                  [
                    36919.1,
                    37020.7
                  ],
                  [
                    36854.1,
                    36983.7
                  ],
                  [
                    36756.1,
                    36941.5
                  ],
                  [
                    36634.3,
                    36912.3
                  ],
                  [
                    36592.4,
                    36901.1
                  ],
                  [
                    36547.6,
                    36885.1
                  ],
                  [
                    36549.9,
                    36712
                  ],
                  [
                    36744.4,
                    36593.9
                  ],
                  [
                    36820.8,
                    36548.6
                  ],
                  [
                    36885.1,
                    36505.3
                  ],
                  [
                    37039.8,
                    36479.6
                  ]
                ],
                "id": 1333,
                "chat_link": "[&BDUFAAA=]"
              },
              "1334": {
                "name": "Wyvern Scar",
                "level": 80,
                "coord": [
                  36311.1,
                  37087.7
                ],
                "bounds": [
                  [
                    35934.3,
                    36820.3
                  ],
                  [
                    35877.2,
                    36942.5
                  ],
                  [
                    35981.1,
                    37194.5
                  ],
                  [
                    36126.8,
                    37240.7
                  ],
                  [
                    36262.3,
                    37315.3
                  ],
                  [
                    36323.9,
                    37297.1
                  ],
                  [
                    36585.7,
                    37368
                  ],
                  [
                    36629.7,
                    37183.7
                  ],
                  [
                    36579.5,
                    37039.3
                  ],
                  [
                    36567.2,
                    36873.7
                  ],
                  [
                    36491.2,
                    36972.3
                  ],
                  [
                    36406.5,
                    36988.7
                  ],
                  [
                    36279,
                    36903.7
                  ],
                  [
                    35934.3,
                    36820.3
                  ]
                ],
                "id": 1334,
                "chat_link": "[&BDYFAAA=]"
              },
              "1335": {
                "name": "Northern Blighting Tower",
                "level": 80,
                "coord": [
                  34966.3,
                  37303.3
                ],
                "bounds": [
                  [
                    34838.7,
                    37060.6
                  ],
                  [
                    34912.6,
                    37048.7
                  ],
                  [
                    35051.8,
                    37035.5
                  ],
                  [
                    35202.1,
                    37171.1
                  ],
                  [
                    35172.5,
                    37277.3
                  ],
                  [
                    35158.8,
                    37324.1
                  ],
                  [
                    35138.1,
                    37391.6
                  ],
                  [
                    35091.8,
                    37543.7
                  ],
                  [
                    35061.3,
                    37653.4
                  ],
                  [
                    34872.2,
                    37545.2
                  ],
                  [
                    34813.5,
                    37447.4
                  ],
                  [
                    34798.8,
                    37353.5
                  ],
                  [
                    34685.4,
                    37281.4
                  ],
                  [
                    34731,
                    37113.2
                  ],
                  [
                    34838.7,
                    37060.6
                  ]
                ],
                "id": 1335,
                "chat_link": "[&BDcFAAA=]"
              },
              "1339": {
                "name": "Toadstool Mire",
                "level": 80,
                "coord": [
                  36421.6,
                  36609.6
                ],
                "bounds": [
                  [
                    36748,
                    36596
                  ],
                  [
                    36554.5,
                    36713.3
                  ],
                  [
                    36561.3,
                    36884.9
                  ],
                  [
                    36494.8,
                    36977.4
                  ],
                  [
                    36407.7,
                    36998.6
                  ],
                  [
                    36271.1,
                    36909.5
                  ],
                  [
                    35932,
                    36825.4
                  ],
                  [
                    36033.5,
                    36598.9
                  ],
                  [
                    36234.7,
                    36600.7
                  ],
                  [
                    36291.3,
                    36533.8
                  ],
                  [
                    36312.7,
                    36422.7
                  ],
                  [
                    36395.5,
                    36311.6
                  ],
                  [
                    36486.2,
                    36349.9
                  ],
                  [
                    36582.2,
                    36292.6
                  ],
                  [
                    36710,
                    36327.4
                  ],
                  [
                    36729.6,
                    36410.8
                  ],
                  [
                    36748,
                    36596
                  ]
                ],
                "id": 1339,
                "chat_link": "[&BDsFAAA=]"
              },
              "1341": {
                "name": "Rooted Copse",
                "level": 80,
                "coord": [
                  35049.9,
                  36734.9
                ],
                "bounds": [
                  [
                    34823.6,
                    37030.6
                  ],
                  [
                    34853.6,
                    36871
                  ],
                  [
                    34861.9,
                    36812.3
                  ],
                  [
                    34882.2,
                    36714
                  ],
                  [
                    35024.3,
                    36625.8
                  ],
                  [
                    35085.3,
                    36519.3
                  ],
                  [
                    35226.9,
                    36358.6
                  ],
                  [
                    35218.6,
                    36501.3
                  ],
                  [
                    35437.6,
                    36740.4
                  ],
                  [
                    35189.7,
                    36912.4
                  ],
                  [
                    34945.2,
                    36998.5
                  ],
                  [
                    34823.6,
                    37030.6
                  ]
                ],
                "id": 1341,
                "chat_link": "[&BD0FAAA=]"
              },
              "1346": {
                "name": "Vigilant Precipice",
                "level": 80,
                "coord": [
                  36370.5,
                  36279.1
                ],
                "bounds": [
                  [
                    36745.4,
                    35902.9
                  ],
                  [
                    36657.9,
                    36105.8
                  ],
                  [
                    36708.7,
                    36333.3
                  ],
                  [
                    36582.4,
                    36301.5
                  ],
                  [
                    36487.2,
                    36355.1
                  ],
                  [
                    36397.5,
                    36318.1
                  ],
                  [
                    36319.6,
                    36423.4
                  ],
                  [
                    36297.7,
                    36536.6
                  ],
                  [
                    36239.4,
                    36607
                  ],
                  [
                    36033.4,
                    36608.7
                  ],
                  [
                    35871.7,
                    35959.4
                  ],
                  [
                    36105.3,
                    35897.3
                  ],
                  [
                    36745.4,
                    35902.9
                  ]
                ],
                "id": 1346,
                "chat_link": "[&BEIFAAA=]"
              },
              "1347": {
                "name": "Dragon's Domain",
                "level": 80,
                "coord": [
                  35009.7,
                  37986.5
                ],
                "bounds": [
                  [
                    34200.1,
                    37722.9
                  ],
                  [
                    34152.7,
                    37852.6
                  ],
                  [
                    34185.2,
                    38029.5
                  ],
                  [
                    34309.9,
                    38335.7
                  ],
                  [
                    34357.8,
                    38473.8
                  ],
                  [
                    34573.9,
                    38579.3
                  ],
                  [
                    34815.4,
                    38710.2
                  ],
                  [
                    35119.7,
                    38759.8
                  ],
                  [
                    35438.7,
                    38631.2
                  ],
                  [
                    35504.5,
                    38465.8
                  ],
                  [
                    35525.5,
                    38238.9
                  ],
                  [
                    35519.5,
                    38209.6
                  ],
                  [
                    35705.1,
                    38238.9
                  ],
                  [
                    35734.2,
                    38088.2
                  ],
                  [
                    35627.7,
                    38050.7
                  ],
                  [
                    35537.9,
                    38030.4
                  ],
                  [
                    35448.2,
                    38027.8
                  ],
                  [
                    35379.2,
                    37864
                  ],
                  [
                    35504.6,
                    37641.8
                  ],
                  [
                    35392.9,
                    37535.9
                  ],
                  [
                    35157.1,
                    37723.2
                  ],
                  [
                    35000.9,
                    37606.1
                  ],
                  [
                    34873.9,
                    37543
                  ],
                  [
                    34818.3,
                    37445
                  ],
                  [
                    34802.7,
                    37350.3
                  ],
                  [
                    34686.1,
                    37278.2
                  ],
                  [
                    34575.4,
                    37532.3
                  ],
                  [
                    34323.2,
                    37658
                  ],
                  [
                    34200.1,
                    37722.9
                  ]
                ],
                "id": 1347,
                "chat_link": "[&BEMFAAA=]"
              },
              "1353": {
                "name": "Broken Altar",
                "level": 80,
                "coord": [
                  35596.3,
                  36432.4
                ],
                "bounds": [
                  [
                    35936.7,
                    36211.1
                  ],
                  [
                    35871.2,
                    35954.3
                  ],
                  [
                    35574.1,
                    36015.7
                  ],
                  [
                    35260.4,
                    36037.1
                  ],
                  [
                    35089.8,
                    36182.8
                  ],
                  [
                    35223.1,
                    36359.4
                  ],
                  [
                    35212,
                    36504.6
                  ],
                  [
                    35428.8,
                    36742.3
                  ],
                  [
                    35696.7,
                    36819.9
                  ],
                  [
                    35885.6,
                    36944.4
                  ],
                  [
                    35942.2,
                    36818.6
                  ],
                  [
                    36035.4,
                    36597.9
                  ],
                  [
                    35936.7,
                    36211.1
                  ]
                ],
                "id": 1353,
                "chat_link": "[&BEkFAAA=]"
              }
            },
            "adventures": [],
            "id": 1095,
            "mastery_points": []
          },
          "1104": {
            "name": "Lost Precipice",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              34192,
              30270
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                33536,
                29696
              ],
              [
                34816,
                30976
              ]
            ],
            "points_of_interest": {
              "2107": {
                "name": "Canyon Dig Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  33684.6,
                  29911.2
                ],
                "id": 2107,
                "chat_link": "[&BDsIAAA=]"
              },
              "2129": {
                "name": "Riverside Overlook Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  33951.8,
                  30648.6
                ],
                "id": 2129,
                "chat_link": "[&BFEIAAA=]"
              },
              "2167": {
                "name": "Upper Plaza Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34211.1,
                  29897.3
                ],
                "id": 2167,
                "chat_link": "[&BHcIAAA=]"
              },
              "2238": {
                "name": "Shrine Tunnel Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34612.9,
                  30938.2
                ],
                "id": 2238,
                "chat_link": "[&BL4IAAA=]"
              },
              "2242": {
                "name": "Central Precipice Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34234.5,
                  30347.5
                ],
                "id": 2242,
                "chat_link": "[&BMIIAAA=]"
              },
              "2292": {
                "name": "Sandstone Coliseum Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34786.5,
                  30849.3
                ],
                "id": 2292,
                "chat_link": "[&BPQIAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1289": {
                "level": 0,
                "coord": [
                  34265.1,
                  30458
                ],
                "bounds": [
                  [
                    34935.2,
                    29795.8
                  ],
                  [
                    34969.6,
                    31126.6
                  ],
                  [
                    33575.5,
                    31195
                  ],
                  [
                    33580.2,
                    29714.8
                  ],
                  [
                    34935.2,
                    29795.8
                  ]
                ],
                "id": 1289,
                "chat_link": "[&BAkFAAA=]"
              }
            },
            "id": 1104,
            "mastery_points": [],
            "adventures": []
          },
          "1117": {
            "name": "Claiming the Lost Precipice",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 48,
            "label_coord": [
              34192,
              30270
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                33536,
                29696
              ],
              [
                34816,
                30976
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1289": {
                "level": 0,
                "coord": [
                  34265.1,
                  30458
                ],
                "bounds": [
                  [
                    34935.2,
                    29795.8
                  ],
                  [
                    34969.6,
                    31126.6
                  ],
                  [
                    33575.5,
                    31195
                  ],
                  [
                    33580.2,
                    29714.8
                  ],
                  [
                    34935.2,
                    29795.8
                  ]
                ],
                "id": 1289,
                "chat_link": "[&BAkFAAA=]"
              }
            },
            "id": 1117,
            "mastery_points": [],
            "adventures": []
          },
          "1124": {
            "name": "Lost Precipice",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              34192,
              30270
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                33536,
                29696
              ],
              [
                34816,
                30976
              ]
            ],
            "points_of_interest": {
              "2107": {
                "name": "Canyon Dig Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  33684.6,
                  29911.2
                ],
                "id": 2107,
                "chat_link": "[&BDsIAAA=]"
              },
              "2129": {
                "name": "Riverside Overlook Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  33951.8,
                  30648.6
                ],
                "id": 2129,
                "chat_link": "[&BFEIAAA=]"
              },
              "2167": {
                "name": "Upper Plaza Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34211.1,
                  29897.3
                ],
                "id": 2167,
                "chat_link": "[&BHcIAAA=]"
              },
              "2238": {
                "name": "Shrine Tunnel Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34612.9,
                  30938.2
                ],
                "id": 2238,
                "chat_link": "[&BL4IAAA=]"
              },
              "2242": {
                "name": "Central Precipice Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34234.5,
                  30347.5
                ],
                "id": 2242,
                "chat_link": "[&BMIIAAA=]"
              },
              "2292": {
                "name": "Sandstone Coliseum Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34786.5,
                  30849.3
                ],
                "id": 2292,
                "chat_link": "[&BPQIAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1289": {
                "level": 0,
                "coord": [
                  34265.1,
                  30458
                ],
                "bounds": [
                  [
                    34935.2,
                    29795.8
                  ],
                  [
                    34969.6,
                    31126.6
                  ],
                  [
                    33575.5,
                    31195
                  ],
                  [
                    33580.2,
                    29714.8
                  ],
                  [
                    34935.2,
                    29795.8
                  ]
                ],
                "id": 1289,
                "chat_link": "[&BAkFAAA=]"
              }
            },
            "id": 1124,
            "mastery_points": [],
            "adventures": []
          },
          "1132": {
            "name": "Claiming the Lost Precipice",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 48,
            "label_coord": [
              34192,
              30270
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                33536,
                29696
              ],
              [
                34816,
                30976
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1289": {
                "level": 0,
                "coord": [
                  34265.1,
                  30458
                ],
                "bounds": [
                  [
                    34935.2,
                    29795.8
                  ],
                  [
                    34969.6,
                    31126.6
                  ],
                  [
                    33575.5,
                    31195
                  ],
                  [
                    33580.2,
                    29714.8
                  ],
                  [
                    34935.2,
                    29795.8
                  ]
                ],
                "id": 1289,
                "chat_link": "[&BAkFAAA=]"
              }
            },
            "id": 1132,
            "mastery_points": [],
            "adventures": []
          },
          "1140": {
            "name": "Claiming the Lost Precipice",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 48,
            "label_coord": [
              34192,
              30270
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                33536,
                29696
              ],
              [
                34816,
                30976
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1289": {
                "level": 0,
                "coord": [
                  34265.1,
                  30458
                ],
                "bounds": [
                  [
                    34935.2,
                    29795.8
                  ],
                  [
                    34969.6,
                    31126.6
                  ],
                  [
                    33575.5,
                    31195
                  ],
                  [
                    33580.2,
                    29714.8
                  ],
                  [
                    34935.2,
                    29795.8
                  ]
                ],
                "id": 1289,
                "chat_link": "[&BAkFAAA=]"
              }
            },
            "id": 1140,
            "mastery_points": [],
            "adventures": []
          },
          "1147": {
            "name": "Spirit Vale",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              35968,
              29440
            ],
            "map_rect": [
              [
                -15360,
                -36864
              ],
              [
                15360,
                39936
              ]
            ],
            "continent_rect": [
              [
                36224,
                27396
              ],
              [
                37504,
                30596
              ]
            ],
            "points_of_interest": {
              "2309": {
                "name": "River of Spirits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36895.9,
                  29586.9
                ],
                "id": 2309,
                "chat_link": "[&BAUJAAA=]"
              },
              "2310": {
                "name": "Abandoned Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36742.1,
                  29422.4
                ],
                "id": 2310,
                "chat_link": "[&BAYJAAA=]"
              },
              "2311": {
                "name": "The Skillet",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36651.1,
                  28924.5
                ],
                "id": 2311,
                "chat_link": "[&BAcJAAA=]"
              },
              "2312": {
                "name": "Mysterious Pylons",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36664.2,
                  29917.7
                ],
                "id": 2312,
                "chat_link": "[&BAgJAAA=]"
              },
              "2313": {
                "name": "Bandit's Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36637.9,
                  29242.4
                ],
                "id": 2313,
                "chat_link": "[&BAkJAAA=]"
              },
              "2314": {
                "name": "Gorseval's Perch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36932.4,
                  29245.2
                ],
                "id": 2314,
                "chat_link": "[&BAoJAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1275": {
                "name": "Spirit Vale",
                "level": 80,
                "coord": [
                  36746.5,
                  29511.9
                ],
                "bounds": [
                  [
                    36304.6,
                    28969.5
                  ],
                  [
                    36334.4,
                    28882.3
                  ],
                  [
                    36501.5,
                    28784.9
                  ],
                  [
                    36646.8,
                    28676.1
                  ],
                  [
                    36797.3,
                    28661.7
                  ],
                  [
                    36983.7,
                    28660.9
                  ],
                  [
                    37101.3,
                    28887.2
                  ],
                  [
                    37100,
                    29320.6
                  ],
                  [
                    37054.3,
                    29818.9
                  ],
                  [
                    37079.9,
                    30246.8
                  ],
                  [
                    37071.2,
                    31209.5
                  ],
                  [
                    36352.1,
                    31204.1
                  ],
                  [
                    36378,
                    30332.6
                  ],
                  [
                    36304.6,
                    28969.5
                  ]
                ],
                "id": 1275,
                "chat_link": "[&BPsEAAA=]"
              }
            },
            "id": 1147,
            "mastery_points": [],
            "adventures": []
          },
          "1149": {
            "name": "Salvation Pass",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "map_rect": [
              [
                -12288,
                -27648
              ],
              [
                12288,
                27648
              ]
            ],
            "continent_rect": [
              [
                35456,
                28290
              ],
              [
                36480,
                30594
              ]
            ],
            "points_of_interest": {
              "2315": {
                "name": "Slothasor's Den",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36297.1,
                  29445.6
                ],
                "id": 2315,
                "chat_link": "[&BAsJAAA=]"
              },
              "2316": {
                "name": "Prison Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35893.1,
                  29866.6
                ],
                "id": 2316,
                "chat_link": "[&BAwJAAA=]"
              },
              "2317": {
                "name": "Temple of Salvation",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35720.6,
                  29196.4
                ],
                "id": 2317,
                "chat_link": "[&BA0JAAA=]"
              },
              "2318": {
                "name": "Burn Pit",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36180.6,
                  30212.1
                ],
                "id": 2318,
                "chat_link": "[&BA4JAAA=]"
              },
              "2319": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  36112.2,
                  29634.7
                ],
                "id": 2319,
                "chat_link": "[&BA8JAAA=]"
              },
              "2320": {
                "name": "Dead Man's Gorge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35794.8,
                  29490.1
                ],
                "id": 2320,
                "chat_link": "[&BBAJAAA=]"
              },
              "2321": {
                "name": "Labor Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35935.3,
                  29314.7
                ],
                "id": 2321,
                "chat_link": "[&BBEJAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1360": {
                "name": "Salvation Pass",
                "level": 0,
                "coord": [
                  36088.5,
                  29358.4
                ],
                "bounds": [
                  [
                    35535.5,
                    28800.9
                  ],
                  [
                    35649.9,
                    30298.5
                  ],
                  [
                    36259.7,
                    30393.1
                  ],
                  [
                    36449.6,
                    30255
                  ],
                  [
                    36474.3,
                    28963.7
                  ],
                  [
                    36268.7,
                    28918.5
                  ],
                  [
                    36140.3,
                    28669.1
                  ],
                  [
                    35929.9,
                    28568.5
                  ],
                  [
                    35535.5,
                    28800.9
                  ]
                ],
                "id": 1360,
                "chat_link": "[&BFAFAAA=]"
              }
            },
            "adventures": [],
            "id": 1149,
            "mastery_points": []
          },
          "1156": {
            "name": "Stronghold of the Faithful",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "map_rect": [
              [
                -12288,
                -27648
              ],
              [
                12288,
                27648
              ]
            ],
            "continent_rect": [
              [
                34688,
                28544
              ],
              [
                35712,
                30848
              ]
            ],
            "points_of_interest": {
              "2357": {
                "name": "Temple of Awakening",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35066.7,
                  29977.5
                ],
                "id": 2357,
                "chat_link": "[&BDUJAAA=]"
              },
              "2359": {
                "name": "Zealot's Bastion",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35040.9,
                  29305.2
                ],
                "id": 2359,
                "chat_link": "[&BDcJAAA=]"
              },
              "2364": {
                "name": "Tunnel of Respite",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35413.9,
                  29025.7
                ],
                "id": 2364,
                "chat_link": "[&BDwJAAA=]"
              },
              "2365": {
                "name": "Twisted Castle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35049.3,
                  29620.1
                ],
                "id": 2365,
                "chat_link": "[&BD0JAAA=]"
              },
              "2366": {
                "name": "Fountain of Cleansing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35040.8,
                  29164.1
                ],
                "id": 2366,
                "chat_link": "[&BD4JAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1363": {
                "name": "Stronghold of the Faithful",
                "level": 80,
                "coord": [
                  35087.6,
                  29434.7
                ],
                "bounds": [
                  [
                    35739.8,
                    30301.1
                  ],
                  [
                    35748.2,
                    28696.5
                  ],
                  [
                    35064.1,
                    28549.2
                  ],
                  [
                    34911.9,
                    28584.4
                  ],
                  [
                    34783.7,
                    28722.9
                  ],
                  [
                    34703.9,
                    29807.1
                  ],
                  [
                    34653.8,
                    30349.2
                  ],
                  [
                    35095.7,
                    30467
                  ],
                  [
                    35739.8,
                    30301.1
                  ]
                ],
                "id": 1363,
                "chat_link": "[&BFMFAAA=]"
              }
            },
            "adventures": [],
            "id": 1156,
            "mastery_points": []
          },
          "1158": {
            "name": "Noble's Folly",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              35072,
              31744
            ],
            "map_rect": [
              [
                -36864,
                -18432
              ],
              [
                39936,
                18432
              ]
            ],
            "continent_rect": [
              [
                33408,
                30976
              ],
              [
                36608,
                32512
              ]
            ],
            "points_of_interest": {
              "1985": {
                "name": "Golden Boughs",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33695.3,
                  32148.6
                ],
                "id": 1985,
                "chat_link": "[&BMEHAAA=]"
              },
              "1991": {
                "name": "Wreck of the Thunderbreaker",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34154,
                  32246.9
                ],
                "id": 1991,
                "chat_link": "[&BMcHAAA=]"
              },
              "1994": {
                "name": "Dwelling of the Kaanas",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35980,
                  31149
                ],
                "id": 1994,
                "chat_link": "[&BMoHAAA=]"
              },
              "1995": {
                "name": "Wreck of the Mellaggan's Valor",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34466.1,
                  31517.4
                ],
                "id": 1995,
                "chat_link": "[&BMsHAAA=]"
              },
              "1999": {
                "name": "Wreck of the Lethal Vantage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36407.8,
                  32171.6
                ],
                "id": 1999,
                "chat_link": "[&BM8HAAA=]"
              },
              "2017": {
                "name": "Temple of Ameyalli",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36096.4,
                  31379
                ],
                "id": 2017,
                "chat_link": "[&BOEHAAA=]"
              },
              "2021": {
                "name": "Precarious Ruin",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33750.1,
                  31169.7
                ],
                "id": 2021,
                "chat_link": "[&BOUHAAA=]"
              },
              "2030": {
                "name": "Fumerol Caves",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35714,
                  31043.1
                ],
                "id": 2030,
                "chat_link": "[&BO4HAAA=]"
              },
              "2032": {
                "name": "The Corpse Grove",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34605.9,
                  31227.2
                ],
                "id": 2032,
                "chat_link": "[&BPAHAAA=]"
              },
              "2036": {
                "name": "Coztic Itzel",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34456.1,
                  32046.8
                ],
                "id": 2036,
                "chat_link": "[&BPQHAAA=]"
              },
              "2042": {
                "name": "Batrach Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36458.3,
                  31267.6
                ],
                "id": 2042,
                "chat_link": "[&BPoHAAA=]"
              },
              "2043": {
                "name": "Brooding Gulch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35686.6,
                  31339.7
                ],
                "id": 2043,
                "chat_link": "[&BPsHAAA=]"
              },
              "2045": {
                "name": "Shaded Spring",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35115.6,
                  31751.3
                ],
                "id": 2045,
                "chat_link": "[&BP0HAAA=]"
              },
              "2061": {
                "name": "Holdfast Hollow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33822.7,
                  31741.8
                ],
                "id": 2061,
                "chat_link": "[&BA0IAAA=]"
              },
              "2065": {
                "name": "The Waking Tomb",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35963.7,
                  32398.3
                ],
                "id": 2065,
                "chat_link": "[&BBEIAAA=]"
              },
              "2066": {
                "name": "Glory's Fall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35235.3,
                  31271.1
                ],
                "id": 2066,
                "chat_link": "[&BBIIAAA=]"
              },
              "2067": {
                "name": "Dust Dancer Plateau",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35265.6,
                  32306.8
                ],
                "id": 2067,
                "chat_link": "[&BBMIAAA=]"
              },
              "2071": {
                "name": "Uprooted Paradise",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34142.6,
                  31253.1
                ],
                "id": 2071,
                "chat_link": "[&BBcIAAA=]"
              },
              "2074": {
                "name": "Creaking Caverns",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35083.9,
                  32165.2
                ],
                "id": 2074,
                "chat_link": "[&BBoIAAA=]"
              },
              "2075": {
                "name": "The Tangle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36095.3,
                  31721.4
                ],
                "id": 2075,
                "chat_link": "[&BBsIAAA=]"
              },
              "2077": {
                "name": "Bongo's Bungalow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34829.3,
                  32391.4
                ],
                "id": 2077,
                "chat_link": "[&BB0IAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1216": {
                "name": "Coztic Grounds",
                "level": 80,
                "coord": [
                  34519.7,
                  31911.2
                ],
                "bounds": [
                  [
                    34378.7,
                    32081.7
                  ],
                  [
                    34302.9,
                    31985.2
                  ],
                  [
                    34284,
                    31825.1
                  ],
                  [
                    34315.7,
                    31741.6
                  ],
                  [
                    34377,
                    31715.6
                  ],
                  [
                    34629.8,
                    31647.6
                  ],
                  [
                    34673.2,
                    31714.2
                  ],
                  [
                    34797.6,
                    31759.1
                  ],
                  [
                    34723.6,
                    31880.4
                  ],
                  [
                    34657.2,
                    32004.3
                  ],
                  [
                    34684.3,
                    32140.3
                  ],
                  [
                    34528.2,
                    32175
                  ],
                  [
                    34403.6,
                    32176
                  ],
                  [
                    34378.7,
                    32081.7
                  ]
                ],
                "id": 1216,
                "chat_link": "[&BMAEAAA=]"
              },
              "1228": {
                "name": "Stonetwist Paths",
                "level": 80,
                "coord": [
                  35244.4,
                  31688.2
                ],
                "bounds": [
                  [
                    35626.6,
                    31696.8
                  ],
                  [
                    35587.3,
                    31743.3
                  ],
                  [
                    35423,
                    31815.3
                  ],
                  [
                    35369.4,
                    31856.2
                  ],
                  [
                    35314.7,
                    31918.9
                  ],
                  [
                    35250.3,
                    31945.9
                  ],
                  [
                    35120.8,
                    31925.4
                  ],
                  [
                    35057.7,
                    31914
                  ],
                  [
                    34875,
                    31809
                  ],
                  [
                    34797.6,
                    31758.9
                  ],
                  [
                    34673.4,
                    31714.2
                  ],
                  [
                    34630.4,
                    31648
                  ],
                  [
                    34691.5,
                    31589.2
                  ],
                  [
                    34948,
                    31539.4
                  ],
                  [
                    35046.6,
                    31487.3
                  ],
                  [
                    35192,
                    31413.1
                  ],
                  [
                    35357.7,
                    31412.6
                  ],
                  [
                    35563.2,
                    31528
                  ],
                  [
                    35634.3,
                    31557.7
                  ],
                  [
                    35752.2,
                    31538.8
                  ],
                  [
                    35771.7,
                    31661.9
                  ],
                  [
                    35693.5,
                    31667.2
                  ],
                  [
                    35626.6,
                    31696.8
                  ]
                ],
                "id": 1228,
                "chat_link": "[&BMwEAAA=]"
              },
              "1229": {
                "name": "Noble Ledges",
                "level": 80,
                "coord": [
                  34221.3,
                  32284.5
                ],
                "bounds": [
                  [
                    33696.1,
                    32530.8
                  ],
                  [
                    34005,
                    32527.3
                  ],
                  [
                    34222.1,
                    32590.6
                  ],
                  [
                    34491.5,
                    32561
                  ],
                  [
                    34561.7,
                    32483.4
                  ],
                  [
                    34616.3,
                    32413.1
                  ],
                  [
                    34625.3,
                    32269.8
                  ],
                  [
                    34684.5,
                    32140.4
                  ],
                  [
                    34528.4,
                    32174.7
                  ],
                  [
                    34403.9,
                    32176.1
                  ],
                  [
                    34375.2,
                    32079.7
                  ],
                  [
                    34302.4,
                    31985
                  ],
                  [
                    34149.6,
                    32020
                  ],
                  [
                    34037.9,
                    32066.3
                  ],
                  [
                    33909.1,
                    32176.1
                  ],
                  [
                    33580.2,
                    32168.8
                  ],
                  [
                    33572.2,
                    32473.1
                  ],
                  [
                    33696.1,
                    32530.8
                  ]
                ],
                "id": 1229,
                "chat_link": "[&BM0EAAA=]"
              },
              "1232": {
                "name": "The Doomteeth",
                "level": 80,
                "coord": [
                  33829.6,
                  31295.8
                ],
                "bounds": [
                  [
                    33577.1,
                    31688.9
                  ],
                  [
                    33649.1,
                    31022.1
                  ],
                  [
                    34141.4,
                    31084.3
                  ],
                  [
                    34016.2,
                    31173.5
                  ],
                  [
                    33892.5,
                    31352.7
                  ],
                  [
                    33701,
                    31453.6
                  ],
                  [
                    33577.1,
                    31688.9
                  ]
                ],
                "id": 1232,
                "chat_link": "[&BNAEAAA=]"
              },
              "1243": {
                "name": "Jaka Itzel",
                "level": 80,
                "coord": [
                  36250.8,
                  31282.1
                ],
                "bounds": [
                  [
                    35973.9,
                    30996.2
                  ],
                  [
                    36629.6,
                    30961.6
                  ],
                  [
                    36712.2,
                    31249
                  ],
                  [
                    36677.6,
                    31392.9
                  ],
                  [
                    36416.4,
                    31363.7
                  ],
                  [
                    36439,
                    31302.1
                  ],
                  [
                    36218.4,
                    31371.6
                  ],
                  [
                    36159.9,
                    31463.5
                  ],
                  [
                    36043.6,
                    31514.9
                  ],
                  [
                    35885.6,
                    31502.2
                  ],
                  [
                    35949.1,
                    31266.2
                  ],
                  [
                    35904.2,
                    31001.1
                  ],
                  [
                    35973.9,
                    30996.2
                  ]
                ],
                "id": 1243,
                "chat_link": "[&BNsEAAA=]"
              },
              "1249": {
                "name": "Blighted Depths",
                "level": 80,
                "coord": [
                  34441.8,
                  31257
                ],
                "bounds": [
                  [
                    33892.1,
                    31351.5
                  ],
                  [
                    34020.5,
                    31168.2
                  ],
                  [
                    34145.8,
                    31083
                  ],
                  [
                    34368,
                    31034.7
                  ],
                  [
                    34634.9,
                    30997.8
                  ],
                  [
                    34991.7,
                    31029.6
                  ],
                  [
                    34842.9,
                    31291.2
                  ],
                  [
                    34769.6,
                    31466
                  ],
                  [
                    34675,
                    31377.7
                  ],
                  [
                    34567.3,
                    31347.7
                  ],
                  [
                    34381.9,
                    31327.3
                  ],
                  [
                    34261.9,
                    31379.8
                  ],
                  [
                    34191.7,
                    31485.9
                  ],
                  [
                    33892.1,
                    31351.5
                  ]
                ],
                "id": 1249,
                "chat_link": "[&BOEEAAA=]"
              },
              "1250": {
                "name": "Shrouded Ruins",
                "level": 80,
                "coord": [
                  35778.2,
                  32227.7
                ],
                "bounds": [
                  [
                    35359.7,
                    32628.8
                  ],
                  [
                    35346.2,
                    32173.3
                  ],
                  [
                    35527.8,
                    32175.6
                  ],
                  [
                    35596.2,
                    32159.1
                  ],
                  [
                    35742.9,
                    31967.5
                  ],
                  [
                    35777.1,
                    32024.3
                  ],
                  [
                    35913,
                    32015.4
                  ],
                  [
                    36078.5,
                    32030.8
                  ],
                  [
                    36191.6,
                    32141.3
                  ],
                  [
                    36267.4,
                    32483.8
                  ],
                  [
                    35919.9,
                    32487
                  ],
                  [
                    35618.5,
                    32445.7
                  ],
                  [
                    35359.7,
                    32628.8
                  ]
                ],
                "id": 1250,
                "chat_link": "[&BOIEAAA=]"
              },
              "1254": {
                "name": "Wyvern Cliffs",
                "level": 80,
                "coord": [
                  35654.4,
                  31333.3
                ],
                "bounds": [
                  [
                    35904.2,
                    31001.1
                  ],
                  [
                    35949,
                    31266.2
                  ],
                  [
                    35884.9,
                    31502.6
                  ],
                  [
                    35751.3,
                    31538.8
                  ],
                  [
                    35633.8,
                    31557.7
                  ],
                  [
                    35563.1,
                    31527.7
                  ],
                  [
                    35547,
                    31436.2
                  ],
                  [
                    35568.3,
                    31382.1
                  ],
                  [
                    35499.5,
                    31337.3
                  ],
                  [
                    35489.1,
                    31301.2
                  ],
                  [
                    35508.5,
                    31143.6
                  ],
                  [
                    35554.8,
                    31005.6
                  ],
                  [
                    35904.2,
                    31001.1
                  ]
                ],
                "id": 1254,
                "chat_link": "[&BOYEAAA=]"
              },
              "1256": {
                "name": "Creeping Crevasse",
                "level": 80,
                "coord": [
                  35941.9,
                  31804.3
                ],
                "bounds": [
                  [
                    36185,
                    31852.6
                  ],
                  [
                    36125.8,
                    31883.3
                  ],
                  [
                    36072.3,
                    31968.6
                  ],
                  [
                    36078.5,
                    32030.8
                  ],
                  [
                    35912.6,
                    32013.9
                  ],
                  [
                    35777.1,
                    32024.3
                  ],
                  [
                    35742.9,
                    31967.2
                  ],
                  [
                    35712.6,
                    31887.6
                  ],
                  [
                    35638.7,
                    31769.6
                  ],
                  [
                    35587.1,
                    31744.7
                  ],
                  [
                    35626.6,
                    31696.8
                  ],
                  [
                    35692.8,
                    31667.1
                  ],
                  [
                    35772.4,
                    31662.9
                  ],
                  [
                    35977.3,
                    31632.6
                  ],
                  [
                    36111.5,
                    31608.8
                  ],
                  [
                    36180.7,
                    31617.1
                  ],
                  [
                    36238.4,
                    31685.7
                  ],
                  [
                    36239.8,
                    31760.7
                  ],
                  [
                    36223.2,
                    31808.3
                  ],
                  [
                    36185,
                    31852.6
                  ]
                ],
                "id": 1256,
                "chat_link": "[&BOgEAAA=]"
              },
              "1259": {
                "name": "Dry Step Mesas",
                "level": 80,
                "coord": [
                  36289.2,
                  31844.6
                ],
                "bounds": [
                  [
                    36125.8,
                    31883.3
                  ],
                  [
                    36185,
                    31852.6
                  ],
                  [
                    36223.2,
                    31808.3
                  ],
                  [
                    36239.8,
                    31760.7
                  ],
                  [
                    36238.6,
                    31685.3
                  ],
                  [
                    36278.2,
                    31677.5
                  ],
                  [
                    36450.1,
                    31707.4
                  ],
                  [
                    36624.1,
                    31777.5
                  ],
                  [
                    36620.2,
                    31830.2
                  ],
                  [
                    36433.1,
                    31857.3
                  ],
                  [
                    36190.7,
                    32140.8
                  ],
                  [
                    36078.5,
                    32030.8
                  ],
                  [
                    36072.3,
                    31968.6
                  ],
                  [
                    36125.8,
                    31883.3
                  ]
                ],
                "id": 1259,
                "chat_link": "[&BOsEAAA=]"
              },
              "1263": {
                "name": "Heartless Pass",
                "level": 80,
                "coord": [
                  36206.2,
                  31528.7
                ],
                "bounds": [
                  [
                    36238.9,
                    31685.8
                  ],
                  [
                    36181.2,
                    31616.9
                  ],
                  [
                    36112.1,
                    31609
                  ],
                  [
                    35977.1,
                    31632.1
                  ],
                  [
                    35772.3,
                    31663
                  ],
                  [
                    35753,
                    31539
                  ],
                  [
                    35885.6,
                    31502.2
                  ],
                  [
                    36043.2,
                    31514
                  ],
                  [
                    36158.8,
                    31463.2
                  ],
                  [
                    36217.9,
                    31371.9
                  ],
                  [
                    36438.7,
                    31302.1
                  ],
                  [
                    36416,
                    31363.1
                  ],
                  [
                    36677.5,
                    31392.8
                  ],
                  [
                    36657.9,
                    31571
                  ],
                  [
                    36431.6,
                    31587.4
                  ],
                  [
                    36337.4,
                    31644.9
                  ],
                  [
                    36238.9,
                    31685.8
                  ]
                ],
                "id": 1263,
                "chat_link": "[&BO8EAAA=]"
              },
              "1264": {
                "name": "Broken Bluffs",
                "level": 80,
                "coord": [
                  34204.8,
                  31606.7
                ],
                "bounds": [
                  [
                    33578.6,
                    31687.4
                  ],
                  [
                    33701.6,
                    31454.3
                  ],
                  [
                    33890.7,
                    31350.4
                  ],
                  [
                    34189.3,
                    31485.9
                  ],
                  [
                    34262.9,
                    31380.3
                  ],
                  [
                    34381.7,
                    31328.2
                  ],
                  [
                    34570.6,
                    31345.3
                  ],
                  [
                    34669,
                    31371.2
                  ],
                  [
                    34770.6,
                    31465.5
                  ],
                  [
                    34691.3,
                    31588.2
                  ],
                  [
                    34629.8,
                    31648.3
                  ],
                  [
                    34376.9,
                    31715.6
                  ],
                  [
                    34315.7,
                    31741.4
                  ],
                  [
                    34282.6,
                    31827.2
                  ],
                  [
                    34080.7,
                    31850.5
                  ],
                  [
                    33926.2,
                    31905.4
                  ],
                  [
                    33758.4,
                    31894.6
                  ],
                  [
                    33609.5,
                    31881.5
                  ],
                  [
                    33578.6,
                    31687.4
                  ]
                ],
                "id": 1264,
                "chat_link": "[&BPAEAAA=]"
              },
              "1265": {
                "name": "Hidden Copse",
                "level": 80,
                "coord": [
                  34923.6,
                  32288.4
                ],
                "bounds": [
                  [
                    35197.9,
                    32183.6
                  ],
                  [
                    35116.3,
                    32304.3
                  ],
                  [
                    35135.5,
                    32380.5
                  ],
                  [
                    35159.3,
                    32561.3
                  ],
                  [
                    34561.8,
                    32483.2
                  ],
                  [
                    34615.4,
                    32413.9
                  ],
                  [
                    34625.7,
                    32270
                  ],
                  [
                    34684.5,
                    32139.9
                  ],
                  [
                    35013.2,
                    32066.1
                  ],
                  [
                    35126.4,
                    32081.4
                  ],
                  [
                    35197.9,
                    32183.6
                  ]
                ],
                "id": 1265,
                "chat_link": "[&BPEEAAA=]"
              },
              "1266": {
                "name": "Thistlevine Ravine",
                "level": 80,
                "coord": [
                  35221.2,
                  32041.9
                ],
                "bounds": [
                  [
                    35637.3,
                    31770.2
                  ],
                  [
                    35712.6,
                    31887.2
                  ],
                  [
                    35742.9,
                    31966.7
                  ],
                  [
                    35595.8,
                    32158.7
                  ],
                  [
                    35527.4,
                    32175.1
                  ],
                  [
                    35346.1,
                    32173
                  ],
                  [
                    35359.8,
                    32628.8
                  ],
                  [
                    35157.8,
                    32562.9
                  ],
                  [
                    35135.5,
                    32380
                  ],
                  [
                    35115.6,
                    32304.5
                  ],
                  [
                    35197.3,
                    32183.4
                  ],
                  [
                    35126.6,
                    32081.4
                  ],
                  [
                    35012.9,
                    32065.8
                  ],
                  [
                    34684.6,
                    32140.1
                  ],
                  [
                    34658.1,
                    32002.9
                  ],
                  [
                    34723.9,
                    31880.5
                  ],
                  [
                    34797.5,
                    31759
                  ],
                  [
                    34874.7,
                    31809.1
                  ],
                  [
                    35058,
                    31913.8
                  ],
                  [
                    35120.8,
                    31925.6
                  ],
                  [
                    35249.9,
                    31945.5
                  ],
                  [
                    35314.9,
                    31918.9
                  ],
                  [
                    35369.5,
                    31856.1
                  ],
                  [
                    35423.6,
                    31815.5
                  ],
                  [
                    35586.6,
                    31743.4
                  ],
                  [
                    35637.3,
                    31770.2
                  ]
                ],
                "id": 1266,
                "chat_link": "[&BPIEAAA=]"
              },
              "1267": {
                "name": "Snarled Frontier",
                "level": 80,
                "coord": [
                  36464.5,
                  32148.2
                ],
                "bounds": [
                  [
                    36613.4,
                    32432.7
                  ],
                  [
                    36267.1,
                    32484.6
                  ],
                  [
                    36191.4,
                    32141.4
                  ],
                  [
                    36434.2,
                    31857.6
                  ],
                  [
                    36620.2,
                    31830.3
                  ],
                  [
                    36660.6,
                    32142.6
                  ],
                  [
                    36613.4,
                    32432.7
                  ]
                ],
                "id": 1267,
                "chat_link": "[&BPMEAAA=]"
              },
              "1268": {
                "name": "Skyclaw Peaks",
                "level": 80,
                "coord": [
                  35238.1,
                  31357.3
                ],
                "bounds": [
                  [
                    35489.3,
                    31301.1
                  ],
                  [
                    35508.6,
                    31145.7
                  ],
                  [
                    35555.2,
                    31002.3
                  ],
                  [
                    34992.8,
                    31029.7
                  ],
                  [
                    34843.1,
                    31292
                  ],
                  [
                    34768.7,
                    31465.6
                  ],
                  [
                    34691.4,
                    31588.6
                  ],
                  [
                    34947.8,
                    31539.3
                  ],
                  [
                    35047.5,
                    31486.6
                  ],
                  [
                    35192.4,
                    31413.1
                  ],
                  [
                    35357.7,
                    31412.4
                  ],
                  [
                    35562.4,
                    31527.9
                  ],
                  [
                    35546.7,
                    31436.3
                  ],
                  [
                    35568.1,
                    31382.2
                  ],
                  [
                    35499.4,
                    31337.3
                  ],
                  [
                    35489.3,
                    31301.1
                  ]
                ],
                "id": 1268,
                "chat_link": "[&BPQEAAA=]"
              },
              "1269": {
                "name": "Treacherous Paths",
                "level": 80,
                "coord": [
                  33963.8,
                  31977.6
                ],
                "bounds": [
                  [
                    33580.4,
                    32169.1
                  ],
                  [
                    33608.9,
                    31882.8
                  ],
                  [
                    33759.3,
                    31895.7
                  ],
                  [
                    33924.1,
                    31902.4
                  ],
                  [
                    34078.9,
                    31850.4
                  ],
                  [
                    34284.2,
                    31825.3
                  ],
                  [
                    34303.2,
                    31986.3
                  ],
                  [
                    34149.5,
                    32020.5
                  ],
                  [
                    34039.4,
                    32066.2
                  ],
                  [
                    33909.9,
                    32177.2
                  ],
                  [
                    33580.4,
                    32169.1
                  ]
                ],
                "id": 1269,
                "chat_link": "[&BPUEAAA=]"
              },
              "1271": {
                "name": "Maguuma's Breach",
                "level": 80,
                "coord": [
                  36431.1,
                  31664.5
                ],
                "bounds": [
                  [
                    36657.9,
                    31571
                  ],
                  [
                    36431.9,
                    31587.9
                  ],
                  [
                    36337.2,
                    31645.1
                  ],
                  [
                    36238.9,
                    31685.6
                  ],
                  [
                    36277.4,
                    31677.3
                  ],
                  [
                    36450.1,
                    31707.3
                  ],
                  [
                    36624.2,
                    31777.6
                  ],
                  [
                    36657.9,
                    31571
                  ]
                ],
                "id": 1271,
                "chat_link": "[&BPcEAAA=]"
              }
            },
            "adventures": [],
            "id": 1158,
            "mastery_points": []
          },
          "1159": {
            "name": "Research in Rata Novus",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37004,
              34748
            ],
            "map_rect": [
              [
                -39936,
                -27648
              ],
              [
                39936,
                27648
              ]
            ],
            "continent_rect": [
              [
                35328,
                33792
              ],
              [
                38656,
                36096
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1234": {
                "name": "Decayed Hive",
                "level": 80,
                "coord": [
                  37609.1,
                  34204.7
                ],
                "bounds": [
                  [
                    37359.2,
                    34148.7
                  ],
                  [
                    37290.1,
                    33959.1
                  ],
                  [
                    37453.4,
                    33957.8
                  ],
                  [
                    37551,
                    34033.4
                  ],
                  [
                    37634.9,
                    33918.6
                  ],
                  [
                    37768.9,
                    33924.2
                  ],
                  [
                    37997.8,
                    34127.1
                  ],
                  [
                    38152,
                    34570.8
                  ],
                  [
                    37671,
                    34613.7
                  ],
                  [
                    37478.5,
                    34492.5
                  ],
                  [
                    37342.9,
                    34505.9
                  ],
                  [
                    37359.2,
                    34148.7
                  ]
                ],
                "id": 1234,
                "chat_link": "[&BNIEAAA=]"
              }
            },
            "adventures": [],
            "id": 1159,
            "mastery_points": []
          },
          "1165": {
            "name": "Bloodstone Fen",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 2,
            "label_coord": [
              35582,
              30688
            ],
            "map_rect": [
              [
                -18432,
                -6144
              ],
              [
                18432,
                9216
              ]
            ],
            "continent_rect": [
              [
                34816,
                30338
              ],
              [
                36352,
                30978
              ]
            ],
            "points_of_interest": {
              "2367": {
                "name": "Depths of the Maw Waypoint",
                "type": "waypoint",
                "floor": 0,
                "coord": [
                  35511.3,
                  30577.1
                ],
                "id": 2367,
                "chat_link": "[&BD8JAAA=]"
              },
              "2368": {
                "type": "vista",
                "floor": 2,
                "coord": [
                  35325.3,
                  30781.5
                ],
                "id": 2368,
                "chat_link": "[&BEAJAAA=]"
              },
              "2369": {
                "name": "Ground Zero Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  35827.6,
                  30738.4
                ],
                "id": 2369,
                "chat_link": "[&BEEJAAA=]"
              },
              "2374": {
                "name": "Colosseum of the Faithful",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35491.1,
                  30820.6
                ],
                "id": 2374,
                "chat_link": "[&BEYJAAA=]"
              },
              "2376": {
                "type": "vista",
                "floor": 2,
                "coord": [
                  36069.2,
                  30539.4
                ],
                "id": 2376,
                "chat_link": "[&BEgJAAA=]"
              },
              "2377": {
                "name": "Tomb of the Confessors",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35211.1,
                  30446.2
                ],
                "id": 2377,
                "chat_link": "[&BEkJAAA=]"
              },
              "2379": {
                "name": "Soulkeeper's Airship Waypoint",
                "type": "waypoint",
                "floor": 2,
                "coord": [
                  35212.1,
                  30583.8
                ],
                "id": 2379,
                "chat_link": "[&BEsJAAA=]"
              },
              "2380": {
                "name": "Salvation Springs",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34960.5,
                  30901
                ],
                "id": 2380,
                "chat_link": "[&BEwJAAA=]"
              },
              "2381": {
                "type": "vista",
                "floor": 0,
                "coord": [
                  35350,
                  30685.6
                ],
                "id": 2381,
                "chat_link": "[&BE0JAAA=]"
              },
              "2382": {
                "name": "Zealot's Overlook Waypoint",
                "type": "waypoint",
                "floor": 2,
                "coord": [
                  35482.2,
                  30692.4
                ],
                "id": 2382,
                "chat_link": "[&BE4JAAA=]"
              },
              "2385": {
                "name": "Bloodstone's Shell",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35709,
                  30645.9
                ],
                "id": 2385,
                "chat_link": "[&BFEJAAA=]"
              },
              "2452": {
                "name": "Raid—Bastion of the Penitent",
                "type": "unlock",
                "floor": 1,
                "coord": [
                  35494.9,
                  30669.7
                ],
                "id": 2452,
                "chat_link": "[&BJQJAAA=]",
                "icon": "https://render.guildwars2.com/file/5866630DA52DCB5C423FB81ECF69FD071611E36B/1128644.png"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1366": {
                "name": "Haunted Canyons",
                "level": 80,
                "coord": [
                  35290.1,
                  30612.6
                ],
                "bounds": [
                  [
                    34790,
                    31005.7
                  ],
                  [
                    34762.8,
                    30805.7
                  ],
                  [
                    34777.3,
                    30281.5
                  ],
                  [
                    35103.2,
                    30243.5
                  ],
                  [
                    35510.7,
                    30263
                  ],
                  [
                    35708.3,
                    30254.6
                  ],
                  [
                    35551,
                    30707.9
                  ],
                  [
                    35641.9,
                    30855.2
                  ],
                  [
                    35765.9,
                    31096.2
                  ],
                  [
                    34790,
                    31005.7
                  ]
                ],
                "id": 1366,
                "chat_link": "[&BFYFAAA=]"
              },
              "1368": {
                "name": "Bloodstone Maw",
                "level": 80,
                "coord": [
                  35961.3,
                  30674.1
                ],
                "bounds": [
                  [
                    35699.4,
                    30257.2
                  ],
                  [
                    35880.8,
                    30219.3
                  ],
                  [
                    36308.4,
                    30240.7
                  ],
                  [
                    36514.7,
                    30626.8
                  ],
                  [
                    36415.6,
                    30996.4
                  ],
                  [
                    35901.9,
                    31060
                  ],
                  [
                    35754.8,
                    31095.9
                  ],
                  [
                    35633.3,
                    30860.3
                  ],
                  [
                    35542.8,
                    30710.1
                  ],
                  [
                    35699.4,
                    30257.2
                  ]
                ],
                "id": 1368,
                "chat_link": "[&BFgFAAA=]"
              }
            },
            "adventures": [],
            "id": 1165,
            "mastery_points": [
              {
                "coord": [
                  35050,
                  30801
                ],
                "id": 140,
                "region": "Maguuma"
              },
              {
                "coord": [
                  36022.4,
                  30581
                ],
                "id": 139,
                "region": "Maguuma"
              }
            ]
          },
          "1169": {
            "name": "Rata Novus",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37004,
              34748
            ],
            "map_rect": [
              [
                -39936,
                -27648
              ],
              [
                39936,
                27648
              ]
            ],
            "continent_rect": [
              [
                35328,
                33792
              ],
              [
                38656,
                36096
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1252": {
                "name": "Rata Novus",
                "level": 80,
                "coord": [
                  37779.7,
                  34917.8
                ],
                "bounds": [
                  [
                    37671.8,
                    34608.9
                  ],
                  [
                    38148.1,
                    34565.8
                  ],
                  [
                    38344.8,
                    34727.8
                  ],
                  [
                    38235.1,
                    34989.5
                  ],
                  [
                    37790.7,
                    35195.5
                  ],
                  [
                    37643.7,
                    35209.9
                  ],
                  [
                    37615,
                    35316.7
                  ],
                  [
                    37488.1,
                    35181.1
                  ],
                  [
                    37533.4,
                    34990.7
                  ],
                  [
                    37535.3,
                    34774.3
                  ],
                  [
                    37571,
                    34535.2
                  ],
                  [
                    37671.8,
                    34608.9
                  ]
                ],
                "id": 1252,
                "chat_link": "[&BOQEAAA=]"
              }
            },
            "adventures": [],
            "id": 1169,
            "mastery_points": []
          },
          "1170": {
            "name": "Taimi's Game",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37004,
              34748
            ],
            "map_rect": [
              [
                -39936,
                -27648
              ],
              [
                39936,
                27648
              ]
            ],
            "continent_rect": [
              [
                35328,
                33792
              ],
              [
                38656,
                36096
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1252": {
                "name": "Rata Novus",
                "level": 80,
                "coord": [
                  37779.7,
                  34917.8
                ],
                "bounds": [
                  [
                    37671.8,
                    34608.9
                  ],
                  [
                    38148.1,
                    34565.8
                  ],
                  [
                    38344.8,
                    34727.8
                  ],
                  [
                    38235.1,
                    34989.5
                  ],
                  [
                    37790.7,
                    35195.5
                  ],
                  [
                    37643.7,
                    35209.9
                  ],
                  [
                    37615,
                    35316.7
                  ],
                  [
                    37488.1,
                    35181.1
                  ],
                  [
                    37533.4,
                    34990.7
                  ],
                  [
                    37535.3,
                    34774.3
                  ],
                  [
                    37571,
                    34535.2
                  ],
                  [
                    37671.8,
                    34608.9
                  ]
                ],
                "id": 1252,
                "chat_link": "[&BOQEAAA=]"
              }
            },
            "adventures": [],
            "id": 1170,
            "mastery_points": []
          },
          "1172": {
            "name": "Dragon Vigil",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              34304,
              33792
            ],
            "map_rect": [
              [
                -24576,
                -33792
              ],
              [
                24576,
                33792
              ]
            ],
            "continent_rect": [
              [
                33280,
                32512
              ],
              [
                35328,
                35328
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1172,
            "mastery_points": []
          },
          "1176": {
            "name": "Taimi's Game",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37004,
              34748
            ],
            "map_rect": [
              [
                -39936,
                -27648
              ],
              [
                39936,
                27648
              ]
            ],
            "continent_rect": [
              [
                35328,
                33792
              ],
              [
                38656,
                36096
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1252": {
                "name": "Rata Novus",
                "level": 80,
                "coord": [
                  37779.7,
                  34917.8
                ],
                "bounds": [
                  [
                    37671.8,
                    34608.9
                  ],
                  [
                    38148.1,
                    34565.8
                  ],
                  [
                    38344.8,
                    34727.8
                  ],
                  [
                    38235.1,
                    34989.5
                  ],
                  [
                    37790.7,
                    35195.5
                  ],
                  [
                    37643.7,
                    35209.9
                  ],
                  [
                    37615,
                    35316.7
                  ],
                  [
                    37488.1,
                    35181.1
                  ],
                  [
                    37533.4,
                    34990.7
                  ],
                  [
                    37535.3,
                    34774.3
                  ],
                  [
                    37571,
                    34535.2
                  ],
                  [
                    37671.8,
                    34608.9
                  ]
                ],
                "id": 1252,
                "chat_link": "[&BOQEAAA=]"
              }
            },
            "adventures": [],
            "id": 1176,
            "mastery_points": []
          },
          "1188": {
            "name": "Bastion of the Penitent",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "map_rect": [
              [
                -27648,
                -9216
              ],
              [
                27648,
                12288
              ]
            ],
            "continent_rect": [
              [
                44542,
                20864
              ],
              [
                46846,
                21760
              ]
            ],
            "points_of_interest": {
              "2454": {
                "name": "The Warden's Office",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45526.9,
                  21246
                ],
                "id": 2454,
                "chat_link": "[&BJYJAAA=]"
              },
              "2457": {
                "name": "Solitary Confinement",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45342.7,
                  21247.5
                ],
                "id": 2457,
                "chat_link": "[&BJkJAAA=]"
              },
              "2459": {
                "name": "Escape Tunnel",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45625.3,
                  21082.1
                ],
                "id": 2459,
                "chat_link": "[&BJsJAAA=]"
              },
              "2463": {
                "name": "Cairn's Perch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46292.2,
                  21291.9
                ],
                "id": 2463,
                "chat_link": "[&BJ8JAAA=]"
              },
              "2464": {
                "name": "Mystic Waters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46547,
                  21452
                ],
                "id": 2464,
                "chat_link": "[&BKAJAAA=]"
              },
              "2466": {
                "name": "Chamber of the Guilty",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45460.4,
                  21595.7
                ],
                "id": 2466,
                "chat_link": "[&BKIJAAA=]"
              },
              "2467": {
                "name": "Confessional",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45354.1,
                  21017.6
                ],
                "id": 2467,
                "chat_link": "[&BKMJAAA=]"
              },
              "2469": {
                "name": "Tree of Solitude",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45200.4,
                  21229.7
                ],
                "id": 2469,
                "chat_link": "[&BKUJAAA=]"
              },
              "2476": {
                "name": "Recreation Sector",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45803.1,
                  21210.4
                ],
                "id": 2476,
                "chat_link": "[&BKwJAAA=]"
              },
              "2481": {
                "name": "Death Row",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45804.8,
                  21095.1
                ],
                "id": 2481,
                "chat_link": "[&BLEJAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1422": {
                "name": "The Lockdown",
                "level": 80,
                "coord": [
                  45358.3,
                  21261.5
                ],
                "bounds": [
                  [
                    45656.1,
                    21518.1
                  ],
                  [
                    45625.3,
                    21729.7
                  ],
                  [
                    45305.8,
                    21720.4
                  ],
                  [
                    45303.9,
                    21477.4
                  ],
                  [
                    45128.3,
                    21409.7
                  ],
                  [
                    45058.2,
                    21286.2
                  ],
                  [
                    45101.1,
                    21149.2
                  ],
                  [
                    45211.7,
                    21021.1
                  ],
                  [
                    45270.8,
                    20906
                  ],
                  [
                    45427.9,
                    20912.7
                  ],
                  [
                    45443.6,
                    20955.9
                  ],
                  [
                    45463.7,
                    20978.2
                  ],
                  [
                    45435.4,
                    21208.4
                  ],
                  [
                    45416.4,
                    21251.2
                  ],
                  [
                    45431.1,
                    21299.7
                  ],
                  [
                    45453,
                    21360.1
                  ],
                  [
                    45656.1,
                    21518.1
                  ]
                ],
                "id": 1422,
                "chat_link": "[&BI4FAAA=]"
              },
              "1439": {
                "name": "The Holding",
                "level": 80,
                "coord": [
                  45673.7,
                  21290.7
                ],
                "bounds": [
                  [
                    45998.5,
                    21480.7
                  ],
                  [
                    45852,
                    21383.8
                  ],
                  [
                    45796.2,
                    21418.9
                  ],
                  [
                    45729.9,
                    21494.5
                  ],
                  [
                    45647.2,
                    21523.7
                  ],
                  [
                    45446.6,
                    21366.1
                  ],
                  [
                    45430.9,
                    21300.5
                  ],
                  [
                    45415.9,
                    21250.4
                  ],
                  [
                    45435.9,
                    21208.5
                  ],
                  [
                    45457.6,
                    20980.6
                  ],
                  [
                    45658.9,
                    21031.2
                  ],
                  [
                    45975.9,
                    21041.1
                  ],
                  [
                    45913.2,
                    21298.6
                  ],
                  [
                    45998.5,
                    21480.7
                  ]
                ],
                "id": 1439,
                "chat_link": "[&BJ8FAAA=]"
              },
              "1451": {
                "name": "The Yard",
                "level": 80,
                "coord": [
                  46320.6,
                  21340.5
                ],
                "bounds": [
                  [
                    46383.2,
                    21644.4
                  ],
                  [
                    46292,
                    21617
                  ],
                  [
                    46031.5,
                    21560.4
                  ],
                  [
                    45903.9,
                    21306.9
                  ],
                  [
                    45968.5,
                    21041.2
                  ],
                  [
                    46138.1,
                    20988.3
                  ],
                  [
                    46346.2,
                    21018.9
                  ],
                  [
                    46565.1,
                    21025.6
                  ],
                  [
                    46592.4,
                    21175.3
                  ],
                  [
                    46669.7,
                    21314.8
                  ],
                  [
                    46554.2,
                    21688.5
                  ],
                  [
                    46402.1,
                    21704.5
                  ],
                  [
                    46383.2,
                    21644.4
                  ]
                ],
                "id": 1451,
                "chat_link": "[&BKsFAAA=]"
              }
            },
            "adventures": [],
            "id": 1188,
            "mastery_points": []
          },
          "1198": {
            "name": "Taimi's Pet Project",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37004,
              34748
            ],
            "map_rect": [
              [
                -39936,
                -27648
              ],
              [
                39936,
                27648
              ]
            ],
            "continent_rect": [
              [
                35328,
                33792
              ],
              [
                38656,
                36096
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1252": {
                "name": "Rata Novus",
                "level": 80,
                "coord": [
                  37779.7,
                  34917.8
                ],
                "bounds": [
                  [
                    37671.8,
                    34608.9
                  ],
                  [
                    38148.1,
                    34565.8
                  ],
                  [
                    38344.8,
                    34727.8
                  ],
                  [
                    38235.1,
                    34989.5
                  ],
                  [
                    37790.7,
                    35195.5
                  ],
                  [
                    37643.7,
                    35209.9
                  ],
                  [
                    37615,
                    35316.7
                  ],
                  [
                    37488.1,
                    35181.1
                  ],
                  [
                    37533.4,
                    34990.7
                  ],
                  [
                    37535.3,
                    34774.3
                  ],
                  [
                    37571,
                    34535.2
                  ],
                  [
                    37671.8,
                    34608.9
                  ]
                ],
                "id": 1252,
                "chat_link": "[&BOQEAAA=]"
              }
            },
            "adventures": [],
            "id": 1198,
            "mastery_points": []
          },
          "1278": {
            "name": "???",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              54068,
              57384
            ],
            "map_rect": [
              [
                -36864,
                -36864
              ],
              [
                36864,
                36864
              ]
            ],
            "continent_rect": [
              [
                53504,
                24576
              ],
              [
                56576,
                27648
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1278,
            "mastery_points": []
          }
        },
        "id": 10
      },
      "11": {
        "name": "Maguuma Wastes",
        "label_coord": [
          36568,
          28384
        ],
        "continent_rect": [
          [
            50432,
            24448
          ],
          [
            56576,
            37760
          ]
        ],
        "maps": {
          "988": {
            "name": "Dry Top",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37840,
              32926
            ],
            "map_rect": [
              [
                -24576,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                36608,
                30976
              ],
              [
                38656,
                33536
              ]
            ],
            "points_of_interest": {
              "1905": {
                "name": "Spurbend Canyon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37692.6,
                  32864.1
                ],
                "id": 1905,
                "chat_link": "[&BHEHAAA=]"
              },
              "1906": {
                "name": "Flatland Wastes",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38140.2,
                  32749
                ],
                "id": 1906,
                "chat_link": "[&BHIHAAA=]"
              },
              "1907": {
                "name": "Choke Canyon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38141.3,
                  33169.7
                ],
                "id": 1907,
                "chat_link": "[&BHMHAAA=]"
              },
              "1908": {
                "name": "Ship's Fall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38283.9,
                  32955.9
                ],
                "id": 1908,
                "chat_link": "[&BHQHAAA=]"
              },
              "1909": {
                "name": "Crash Site 1",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38154.2,
                  32998.1
                ],
                "id": 1909,
                "chat_link": "[&BHUHAAA=]"
              },
              "1910": {
                "name": "Salamander's Rise",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37850.6,
                  32849.3
                ],
                "id": 1910,
                "chat_link": "[&BHYHAAA=]"
              },
              "1911": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  37648.9,
                  33015
                ],
                "id": 1911,
                "chat_link": "[&BHcHAAA=]"
              },
              "1912": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  38092.7,
                  33023
                ],
                "id": 1912,
                "chat_link": "[&BHgHAAA=]"
              },
              "1913": {
                "name": "Sparring Rock",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37777.4,
                  33026.9
                ],
                "id": 1913,
                "chat_link": "[&BHkHAAA=]"
              },
              "1914": {
                "name": "Prosperity Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  37988.4,
                  32717.8
                ],
                "id": 1914,
                "chat_link": "[&BHoHAAA=]"
              },
              "1915": {
                "name": "Abandoned Mine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38488.6,
                  32807.8
                ],
                "id": 1915,
                "chat_link": "[&BHsHAAA=]"
              },
              "1916": {
                "name": "Lair of the Beast",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37917.2,
                  33161.7
                ],
                "id": 1916,
                "chat_link": "[&BHwHAAA=]"
              },
              "1917": {
                "name": "Prosperity Mine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38255.3,
                  32416.3
                ],
                "id": 1917,
                "chat_link": "[&BH0HAAA=]"
              },
              "1918": {
                "name": "Town of Prosperity",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38123,
                  32609.8
                ],
                "id": 1918,
                "chat_link": "[&BH4HAAA=]"
              },
              "1920": {
                "name": "Dry Top Entry Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  38299.1,
                  33089
                ],
                "id": 1920,
                "chat_link": "[&BIAHAAA=]"
              },
              "1921": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  37275.3,
                  32571.4
                ],
                "id": 1921,
                "chat_link": "[&BIEHAAA=]"
              },
              "1922": {
                "name": "Omadd's Machine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36797.6,
                  33348.4
                ],
                "id": 1922,
                "chat_link": "[&BIIHAAA=]"
              },
              "1923": {
                "name": "Ley Line Hub",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37153.4,
                  33325.6
                ],
                "id": 1923,
                "chat_link": "[&BIMHAAA=]"
              },
              "1924": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  37374.5,
                  33348.2
                ],
                "id": 1924,
                "chat_link": "[&BIQHAAA=]"
              },
              "1925": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  37603.8,
                  32300.4
                ],
                "id": 1925,
                "chat_link": "[&BIUHAAA=]"
              },
              "1926": {
                "name": "Vine Bridge Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  36895,
                  32688.1
                ],
                "id": 1926,
                "chat_link": "[&BIYHAAA=]"
              },
              "1927": {
                "name": "Restoration Refuge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37800.1,
                  32619.8
                ],
                "id": 1927,
                "chat_link": "[&BIcHAAA=]"
              },
              "1928": {
                "name": "Restoration Refuge Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  37730.7,
                  32727.2
                ],
                "id": 1928,
                "chat_link": "[&BIgHAAA=]"
              },
              "1929": {
                "name": "Azarr's Arbor",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36828.4,
                  32583.1
                ],
                "id": 1929,
                "chat_link": "[&BIkHAAA=]"
              },
              "1930": {
                "name": "Cragrock Palace",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37302.4,
                  33142.8
                ],
                "id": 1930,
                "chat_link": "[&BIoHAAA=]"
              },
              "1931": {
                "name": "Oasis",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37076.8,
                  32404.6
                ],
                "id": 1931,
                "chat_link": "[&BIsHAAA=]"
              },
              "1932": {
                "name": "Crash Site 2",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37332.7,
                  32750.7
                ],
                "id": 1932,
                "chat_link": "[&BIwHAAA=]"
              },
              "1934": {
                "name": "Raptor Prowl",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37685.9,
                  32319.6
                ],
                "id": 1934,
                "chat_link": "[&BI4HAAA=]"
              },
              "1939": {
                "name": "Inquest Base",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36829.1,
                  32995.2
                ],
                "id": 1939,
                "chat_link": "[&BJMHAAA=]"
              },
              "1940": {
                "name": "Repair Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36696.3,
                  32813.5
                ],
                "id": 1940,
                "chat_link": "[&BJQHAAA=]"
              },
              "1941": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  36869.2,
                  33157.6
                ],
                "id": 1941,
                "chat_link": "[&BJUHAAA=]"
              },
              "1942": {
                "name": "Crash Site 3",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37085.4,
                  32988.2
                ],
                "id": 1942,
                "chat_link": "[&BJYHAAA=]"
              },
              "1943": {
                "name": "Repair Station Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  36713.1,
                  32755.1
                ],
                "id": 1943,
                "chat_link": "[&BJcHAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [
              {
                "coord": [
                  37625.6,
                  33421.1
                ],
                "id": "0-194"
              },
              {
                "coord": [
                  37153.8,
                  32157.7
                ],
                "id": "0-98"
              },
              {
                "coord": [
                  38150.9,
                  32820.6
                ],
                "id": "0-28"
              },
              {
                "coord": [
                  37532.1,
                  32794.8
                ],
                "id": "0-139"
              },
              {
                "coord": [
                  37112.8,
                  32819.9
                ],
                "id": "0-134"
              }
            ],
            "sectors": {
              "1186": {
                "name": "Prospect Valley",
                "level": 80,
                "coord": [
                  37927.6,
                  32843.3
                ],
                "bounds": [
                  [
                    38660.1,
                    32111.4
                  ],
                  [
                    37993.9,
                    32103.3
                  ],
                  [
                    37921.7,
                    32651.2
                  ],
                  [
                    37860.2,
                    32702.8
                  ],
                  [
                    37791.4,
                    32718.5
                  ],
                  [
                    37739.5,
                    32738.1
                  ],
                  [
                    37691.3,
                    32748.3
                  ],
                  [
                    37652.9,
                    32747.2
                  ],
                  [
                    37615.5,
                    32746.1
                  ],
                  [
                    37581.6,
                    32742.4
                  ],
                  [
                    37550.1,
                    32739.5
                  ],
                  [
                    37467.3,
                    32737.9
                  ],
                  [
                    37456.6,
                    32967.2
                  ],
                  [
                    37370.6,
                    33206.7
                  ],
                  [
                    38097,
                    33330.5
                  ],
                  [
                    38196.1,
                    33325.4
                  ],
                  [
                    38483.1,
                    33589.2
                  ],
                  [
                    38727,
                    33584.5
                  ],
                  [
                    38768.4,
                    32532.5
                  ],
                  [
                    38660.1,
                    32111.4
                  ]
                ],
                "id": 1186,
                "chat_link": "[&BKIEAAA=]"
              },
              "1187": {
                "name": "Treadrock Uplands",
                "level": 80,
                "coord": [
                  37591,
                  32581
                ],
                "bounds": [
                  [
                    37922.4,
                    32651.4
                  ],
                  [
                    37994,
                    32102.7
                  ],
                  [
                    37178.6,
                    32129.7
                  ],
                  [
                    37317.1,
                    32343.1
                  ],
                  [
                    37302.3,
                    32479.7
                  ],
                  [
                    37333.8,
                    32473.1
                  ],
                  [
                    37452.1,
                    32506.4
                  ],
                  [
                    37467.4,
                    32737.9
                  ],
                  [
                    37549.8,
                    32740.3
                  ],
                  [
                    37585.8,
                    32740.4
                  ],
                  [
                    37616.1,
                    32743.3
                  ],
                  [
                    37653.3,
                    32745.6
                  ],
                  [
                    37690.5,
                    32746.6
                  ],
                  [
                    37740.9,
                    32737.7
                  ],
                  [
                    37791.8,
                    32717.8
                  ],
                  [
                    37859.4,
                    32699.5
                  ],
                  [
                    37922.4,
                    32651.4
                  ]
                ],
                "id": 1187,
                "chat_link": "[&BKMEAAA=]"
              },
              "1188": {
                "name": "Challenger Cliffs",
                "level": 80,
                "coord": [
                  36919.8,
                  33047.8
                ],
                "bounds": [
                  [
                    36504,
                    32671.2
                  ],
                  [
                    36598.3,
                    33183.1
                  ],
                  [
                    36631.1,
                    33294.2
                  ],
                  [
                    36671.3,
                    33302.5
                  ],
                  [
                    36749.1,
                    33269.5
                  ],
                  [
                    36792.2,
                    33259.3
                  ],
                  [
                    36875.6,
                    33263
                  ],
                  [
                    37156.4,
                    33212.3
                  ],
                  [
                    37225.2,
                    33196.3
                  ],
                  [
                    37201.9,
                    33157.2
                  ],
                  [
                    37203.9,
                    33108.7
                  ],
                  [
                    37132.5,
                    33075.9
                  ],
                  [
                    37136.4,
                    32988.4
                  ],
                  [
                    37136.7,
                    32918.4
                  ],
                  [
                    37081.7,
                    32826.4
                  ],
                  [
                    37018.2,
                    32748.8
                  ],
                  [
                    36768.7,
                    32731.2
                  ],
                  [
                    36674.2,
                    32654.7
                  ],
                  [
                    36504,
                    32671.2
                  ]
                ],
                "id": 1188,
                "chat_link": "[&BKQEAAA=]"
              },
              "1189": {
                "name": "Cavern of the Shining Lights",
                "level": 80,
                "coord": [
                  37218.3,
                  33352.8
                ],
                "bounds": [
                  [
                    36783.6,
                    33462.1
                  ],
                  [
                    36700.1,
                    33400.4
                  ],
                  [
                    36702.7,
                    33323.9
                  ],
                  [
                    36753.6,
                    33270.8
                  ],
                  [
                    36792.5,
                    33261.4
                  ],
                  [
                    36873.9,
                    33263.8
                  ],
                  [
                    37237.5,
                    33197.4
                  ],
                  [
                    37274.4,
                    33196.9
                  ],
                  [
                    37329.2,
                    33231.4
                  ],
                  [
                    37451.4,
                    33262.8
                  ],
                  [
                    37676.2,
                    33276.1
                  ],
                  [
                    37734.9,
                    33376.7
                  ],
                  [
                    37716.3,
                    33498.6
                  ],
                  [
                    37669.6,
                    33542.5
                  ],
                  [
                    37542.6,
                    33546.6
                  ],
                  [
                    37254.1,
                    33533.2
                  ],
                  [
                    36783.6,
                    33462.1
                  ]
                ],
                "id": 1189,
                "chat_link": "[&BKUEAAA=]"
              },
              "1190": {
                "name": "Unswept Uplands",
                "level": 80,
                "coord": [
                  37222.2,
                  32915.7
                ],
                "bounds": [
                  [
                    37153.5,
                    32507.8
                  ],
                  [
                    37036.7,
                    32539.4
                  ],
                  [
                    37019.2,
                    32746.3
                  ],
                  [
                    37082.4,
                    32825.7
                  ],
                  [
                    37136.3,
                    32918.4
                  ],
                  [
                    37138.1,
                    32991
                  ],
                  [
                    37133.6,
                    33076.1
                  ],
                  [
                    37208.1,
                    33107.5
                  ],
                  [
                    37202.8,
                    33157.1
                  ],
                  [
                    37225.6,
                    33199.3
                  ],
                  [
                    37274.6,
                    33196.6
                  ],
                  [
                    37329.1,
                    33231.1
                  ],
                  [
                    37370.1,
                    33206.8
                  ],
                  [
                    37458.5,
                    32968
                  ],
                  [
                    37452.1,
                    32506.4
                  ],
                  [
                    37334.3,
                    32473.5
                  ],
                  [
                    37153.5,
                    32507.8
                  ]
                ],
                "id": 1190,
                "chat_link": "[&BKYEAAA=]"
              },
              "1191": {
                "name": "Uplands Oasis",
                "level": 80,
                "coord": [
                  36955.4,
                  32437.7
                ],
                "bounds": [
                  [
                    37317.4,
                    32342.6
                  ],
                  [
                    37178.2,
                    32130.3
                  ],
                  [
                    36728.5,
                    32134.2
                  ],
                  [
                    36616.7,
                    32176.3
                  ],
                  [
                    36631.1,
                    32659
                  ],
                  [
                    36769.7,
                    32731
                  ],
                  [
                    37018.7,
                    32747.3
                  ],
                  [
                    37035.9,
                    32538.8
                  ],
                  [
                    37302.5,
                    32479.8
                  ],
                  [
                    37317.4,
                    32342.6
                  ]
                ],
                "id": 1191,
                "chat_link": "[&BKcEAAA=]"
              }
            },
            "adventures": [],
            "id": 988,
            "mastery_points": []
          },
          "992": {
            "name": "Fallen Hopes",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37840,
              32926
            ],
            "map_rect": [
              [
                -24576,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                36608,
                30976
              ],
              [
                38656,
                33536
              ]
            ],
            "points_of_interest": {
              "1909": {
                "name": "Crash Site 1",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38154.2,
                  32998.1
                ],
                "id": 1909,
                "chat_link": "[&BHUHAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 992,
            "mastery_points": []
          },
          "997": {
            "name": "Discovering Scarlet's Breakthrough",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37840,
              32926
            ],
            "map_rect": [
              [
                -24576,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                36608,
                30976
              ],
              [
                38656,
                33536
              ]
            ],
            "points_of_interest": {
              "1923": {
                "name": "Ley Line Hub",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37153.4,
                  33325.6
                ],
                "id": 1923,
                "chat_link": "[&BIMHAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1189": {
                "name": "Cavern of the Shining Lights",
                "level": 80,
                "coord": [
                  37218.3,
                  33352.8
                ],
                "bounds": [
                  [
                    36783.6,
                    33462.1
                  ],
                  [
                    36700.1,
                    33400.4
                  ],
                  [
                    36702.7,
                    33323.9
                  ],
                  [
                    36753.6,
                    33270.8
                  ],
                  [
                    36792.5,
                    33261.4
                  ],
                  [
                    36873.9,
                    33263.8
                  ],
                  [
                    37237.5,
                    33197.4
                  ],
                  [
                    37274.4,
                    33196.9
                  ],
                  [
                    37329.2,
                    33231.4
                  ],
                  [
                    37451.4,
                    33262.8
                  ],
                  [
                    37676.2,
                    33276.1
                  ],
                  [
                    37734.9,
                    33376.7
                  ],
                  [
                    37716.3,
                    33498.6
                  ],
                  [
                    37669.6,
                    33542.5
                  ],
                  [
                    37542.6,
                    33546.6
                  ],
                  [
                    37254.1,
                    33533.2
                  ],
                  [
                    36783.6,
                    33462.1
                  ]
                ],
                "id": 1189,
                "chat_link": "[&BKUEAAA=]"
              }
            },
            "adventures": [],
            "id": 997,
            "mastery_points": []
          },
          "998": {
            "name": "The Machine",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37840,
              32926
            ],
            "map_rect": [
              [
                -24576,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                36608,
                30976
              ],
              [
                38656,
                33536
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 998,
            "mastery_points": []
          },
          "1015": {
            "name": "The Silverwastes",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37618,
              31484
            ],
            "map_rect": [
              [
                -24576,
                -18432
              ],
              [
                24576,
                18432
              ]
            ],
            "continent_rect": [
              [
                36608,
                30592
              ],
              [
                38656,
                32128
              ]
            ],
            "points_of_interest": {
              "1919": {
                "name": "Camp Resolve Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  38451.1,
                  31736.5
                ],
                "id": 1919,
                "chat_link": "[&BH8HAAA=]"
              },
              "1950": {
                "name": "The Labyrinth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37239.3,
                  31916.4
                ],
                "id": 1950,
                "chat_link": "[&BJ4HAAA=]"
              },
              "1951": {
                "name": "Wingspan Arch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37751.9,
                  31827.2
                ],
                "id": 1951,
                "chat_link": "[&BJ8HAAA=]"
              },
              "1953": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  37124.3,
                  30979.1
                ],
                "id": 1953,
                "chat_link": "[&BKEHAAA=]"
              },
              "1954": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  37667.4,
                  31456.2
                ],
                "id": 1954,
                "chat_link": "[&BKIHAAA=]"
              },
              "1955": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  38015.2,
                  31865.2
                ],
                "id": 1955,
                "chat_link": "[&BKMHAAA=]"
              },
              "1956": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  37873.3,
                  30839.1
                ],
                "id": 1956,
                "chat_link": "[&BKQHAAA=]"
              },
              "1957": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  38382.2,
                  31686.3
                ],
                "id": 1957,
                "chat_link": "[&BKUHAAA=]"
              },
              "1958": {
                "name": "Red Rock Bastion",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37947.2,
                  31913.7
                ],
                "id": 1958,
                "chat_link": "[&BKYHAAA=]"
              },
              "1959": {
                "name": "Camp Resolve",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38487.8,
                  31706.5
                ],
                "id": 1959,
                "chat_link": "[&BKcHAAA=]"
              },
              "1960": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  37893.8,
                  31402.2
                ],
                "id": 1960,
                "chat_link": "[&BKgHAAA=]"
              },
              "1961": {
                "name": "Indigo Cave",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37696.2,
                  31518.8
                ],
                "id": 1961,
                "chat_link": "[&BKkHAAA=]"
              },
              "1962": {
                "name": "Amber Sandfall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37187.6,
                  31808.6
                ],
                "id": 1962,
                "chat_link": "[&BKoHAAA=]"
              },
              "1963": {
                "name": "Blue Oasis",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37319,
                  31092.5
                ],
                "id": 1963,
                "chat_link": "[&BKsHAAA=]"
              },
              "1964": {
                "name": "Hidden Depths Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  37668.8,
                  32070.6
                ],
                "id": 1964,
                "chat_link": "[&BKwHAAA=]"
              },
              "1965": {
                "name": "SS Topsy-Turvy",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38075.9,
                  31104.9
                ],
                "id": 1965,
                "chat_link": "[&BK0HAAA=]"
              },
              "1966": {
                "name": "Fugitive's Claim",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38328.7,
                  32001
                ],
                "id": 1966,
                "chat_link": "[&BK4HAAA=]"
              },
              "1967": {
                "name": "Sand Dune Caverns",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37365,
                  31278.2
                ],
                "id": 1967,
                "chat_link": "[&BK8HAAA=]"
              },
              "1968": {
                "name": "Picaroon Scratch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38563.7,
                  31153.4
                ],
                "id": 1968,
                "chat_link": "[&BLAHAAA=]"
              },
              "1970": {
                "name": "Wailing Sands",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37683.2,
                  31241.1
                ],
                "id": 1970,
                "chat_link": "[&BLIHAAA=]"
              },
              "1971": {
                "name": "Charnel Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38088.7,
                  30910.3
                ],
                "id": 1971,
                "chat_link": "[&BLMHAAA=]"
              },
              "1972": {
                "name": "Dry Quarry",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37597.7,
                  31015.6
                ],
                "id": 1972,
                "chat_link": "[&BLQHAAA=]"
              },
              "1973": {
                "name": "Northern Shelf",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38105.7,
                  31280.4
                ],
                "id": 1973,
                "chat_link": "[&BLUHAAA=]"
              },
              "1974": {
                "name": "Remnant's Retreat",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37946.4,
                  31182.1
                ],
                "id": 1974,
                "chat_link": "[&BLYHAAA=]"
              },
              "1975": {
                "name": "Vinewrath Tangle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36879.8,
                  31407.2
                ],
                "id": 1975,
                "chat_link": "[&BLcHAAA=]"
              },
              "1976": {
                "name": "Outlier's Foundry",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37555.8,
                  32043.8
                ],
                "id": 1976,
                "chat_link": "[&BLgHAAA=]"
              },
              "1977": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  37133.7,
                  31780
                ],
                "id": 1977,
                "chat_link": "[&BLkHAAA=]"
              },
              "1978": {
                "name": "Drydock Grotto Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  38233.6,
                  31107.6
                ],
                "id": 1978,
                "chat_link": "[&BLoHAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [
              {
                "coord": [
                  37353.7,
                  31538
                ],
                "id": "0-243"
              },
              {
                "coord": [
                  36908.3,
                  30999.1
                ],
                "id": "0-245"
              },
              {
                "coord": [
                  38266.8,
                  31340.6
                ],
                "id": "0-244"
              },
              {
                "coord": [
                  37799.2,
                  30642.3
                ],
                "id": "0-246"
              },
              {
                "coord": [
                  38328.4,
                  31222.6
                ],
                "id": "0-247"
              },
              {
                "coord": [
                  36955.6,
                  31479.4
                ],
                "id": "0-248"
              }
            ],
            "sectors": {
              "1196": {
                "name": "Central Silverwastes",
                "level": 80,
                "coord": [
                  37617,
                  31656
                ],
                "bounds": [
                  [
                    37651.3,
                    31319.8
                  ],
                  [
                    37852.2,
                    31401.6
                  ],
                  [
                    37798.8,
                    31493.9
                  ],
                  [
                    37810.8,
                    31680.1
                  ],
                  [
                    37835.7,
                    31738.2
                  ],
                  [
                    37649,
                    31764.3
                  ],
                  [
                    37700.6,
                    31961.8
                  ],
                  [
                    37614,
                    31979.6
                  ],
                  [
                    37389,
                    31978.3
                  ],
                  [
                    37440.7,
                    31771.4
                  ],
                  [
                    37334.6,
                    31614.6
                  ],
                  [
                    37347.3,
                    31504.1
                  ],
                  [
                    37596.6,
                    31320.8
                  ],
                  [
                    37651.3,
                    31319.8
                  ]
                ],
                "id": 1196,
                "chat_link": "[&BKwEAAA=]"
              },
              "1197": {
                "name": "Northwestern Silverwastes",
                "level": 80,
                "coord": [
                  37266.7,
                  31197.3
                ],
                "bounds": [
                  [
                    37223.1,
                    31021.3
                  ],
                  [
                    37557.8,
                    31044.4
                  ],
                  [
                    37593.8,
                    31200.7
                  ],
                  [
                    37595.9,
                    31320.5
                  ],
                  [
                    37346.6,
                    31504.3
                  ],
                  [
                    36997.3,
                    31320
                  ],
                  [
                    36985.1,
                    31228.3
                  ],
                  [
                    37127.5,
                    31199.7
                  ],
                  [
                    37106.6,
                    31138.7
                  ],
                  [
                    37201.5,
                    31123.8
                  ],
                  [
                    37198.9,
                    31068.3
                  ],
                  [
                    37223.1,
                    31021.3
                  ]
                ],
                "id": 1197,
                "chat_link": "[&BK0EAAA=]"
              },
              "1198": {
                "name": "Southwestern Silverwastes",
                "level": 80,
                "coord": [
                  37125.8,
                  31701.3
                ],
                "bounds": [
                  [
                    37388.8,
                    31978.4
                  ],
                  [
                    37395.5,
                    32120
                  ],
                  [
                    37189.4,
                    32124.5
                  ],
                  [
                    37168.4,
                    31936.2
                  ],
                  [
                    37087,
                    31840
                  ],
                  [
                    37031.7,
                    31719.4
                  ],
                  [
                    36958,
                    31714.9
                  ],
                  [
                    36889.7,
                    31627.9
                  ],
                  [
                    36867,
                    31574.1
                  ],
                  [
                    36951.5,
                    31517.2
                  ],
                  [
                    36978.5,
                    31463.2
                  ],
                  [
                    36984.8,
                    31393.1
                  ],
                  [
                    36997.6,
                    31321.3
                  ],
                  [
                    37348.9,
                    31504.8
                  ],
                  [
                    37335.2,
                    31614.2
                  ],
                  [
                    37440.7,
                    31771.4
                  ],
                  [
                    37388.8,
                    31978.4
                  ]
                ],
                "id": 1198,
                "chat_link": "[&BK4EAAA=]"
              },
              "1199": {
                "name": "Northern Silverwastes",
                "level": 80,
                "coord": [
                  37776.7,
                  31156
                ],
                "bounds": [
                  [
                    37851.9,
                    31401.4
                  ],
                  [
                    37650.2,
                    31319.8
                  ],
                  [
                    37596.3,
                    31320.8
                  ],
                  [
                    37594,
                    31200.7
                  ],
                  [
                    37557.5,
                    31044.5
                  ],
                  [
                    37565.3,
                    30935
                  ],
                  [
                    37698.7,
                    30976.2
                  ],
                  [
                    37713.6,
                    31056.2
                  ],
                  [
                    37799,
                    31080.5
                  ],
                  [
                    37920.2,
                    31078.4
                  ],
                  [
                    37983,
                    31020.9
                  ],
                  [
                    38037,
                    31153.9
                  ],
                  [
                    37991.6,
                    31278.3
                  ],
                  [
                    37916.1,
                    31317
                  ],
                  [
                    37851.9,
                    31401.4
                  ]
                ],
                "id": 1199,
                "chat_link": "[&BK8EAAA=]"
              },
              "1200": {
                "name": "Sharp Valley",
                "level": 80,
                "coord": [
                  37569.3,
                  32030.9
                ],
                "bounds": [
                  [
                    37614.3,
                    31979.7
                  ],
                  [
                    37701.7,
                    31961
                  ],
                  [
                    37745.8,
                    32115.4
                  ],
                  [
                    37395.4,
                    32120.3
                  ],
                  [
                    37389.1,
                    31978.2
                  ],
                  [
                    37614.3,
                    31979.7
                  ]
                ],
                "id": 1200,
                "chat_link": "[&BLAEAAA=]"
              },
              "1201": {
                "name": "Camp Resolve",
                "level": 80,
                "coord": [
                  38397.8,
                  31772.9
                ],
                "bounds": [
                  [
                    38264.8,
                    31545.7
                  ],
                  [
                    38336.5,
                    31481.1
                  ],
                  [
                    38683.6,
                    31527.5
                  ],
                  [
                    38678.2,
                    31573.9
                  ],
                  [
                    38666.7,
                    31706.6
                  ],
                  [
                    38627.3,
                    32139.2
                  ],
                  [
                    38237.7,
                    32113.6
                  ],
                  [
                    38269.8,
                    32003.9
                  ],
                  [
                    38245.9,
                    31951.8
                  ],
                  [
                    38214.1,
                    31899.1
                  ],
                  [
                    38296.2,
                    31742.9
                  ],
                  [
                    38253.3,
                    31589.1
                  ],
                  [
                    38264.8,
                    31545.7
                  ]
                ],
                "id": 1201,
                "chat_link": "[&BLEEAAA=]"
              },
              "1202": {
                "name": "Desperate Passage",
                "level": 80,
                "coord": [
                  37181.4,
                  31003.9
                ],
                "bounds": [
                  [
                    37557.1,
                    31044.4
                  ],
                  [
                    37565.7,
                    30934
                  ],
                  [
                    37484,
                    30902
                  ],
                  [
                    37424.9,
                    30909
                  ],
                  [
                    37361.6,
                    30868.2
                  ],
                  [
                    37289.5,
                    30877
                  ],
                  [
                    37205.5,
                    30825.7
                  ],
                  [
                    37113.5,
                    30844.4
                  ],
                  [
                    37152.2,
                    30902.1
                  ],
                  [
                    37059.7,
                    30955.6
                  ],
                  [
                    36965,
                    30950.3
                  ],
                  [
                    36876.5,
                    30972
                  ],
                  [
                    36870,
                    31085.7
                  ],
                  [
                    36862.6,
                    31228.2
                  ],
                  [
                    36984.7,
                    31229.6
                  ],
                  [
                    37127.4,
                    31200
                  ],
                  [
                    37107.1,
                    31139
                  ],
                  [
                    37202.1,
                    31124.2
                  ],
                  [
                    37200.5,
                    31068.9
                  ],
                  [
                    37217.6,
                    31018.4
                  ],
                  [
                    37557.1,
                    31044.4
                  ]
                ],
                "id": 1202,
                "chat_link": "[&BLIEAAA=]"
              },
              "1203": {
                "name": "Southeastern Silverwastes",
                "level": 80,
                "coord": [
                  38021.5,
                  31747
                ],
                "bounds": [
                  [
                    37799.2,
                    31493.6
                  ],
                  [
                    37851.2,
                    31399.2
                  ],
                  [
                    37935.3,
                    31530.5
                  ],
                  [
                    38111.3,
                    31530.8
                  ],
                  [
                    38187.3,
                    31586.6
                  ],
                  [
                    38218.7,
                    31605.7
                  ],
                  [
                    38253.7,
                    31589.5
                  ],
                  [
                    38296.7,
                    31743.9
                  ],
                  [
                    38213.8,
                    31899.9
                  ],
                  [
                    38245.9,
                    31952.4
                  ],
                  [
                    38269.8,
                    32003.7
                  ],
                  [
                    38236.4,
                    32113.2
                  ],
                  [
                    37747.4,
                    32106.9
                  ],
                  [
                    37700.2,
                    31962.7
                  ],
                  [
                    37649.3,
                    31765.3
                  ],
                  [
                    37838.1,
                    31737.5
                  ],
                  [
                    37810.8,
                    31678.2
                  ],
                  [
                    37799.2,
                    31493.6
                  ]
                ],
                "id": 1203,
                "chat_link": "[&BLMEAAA=]"
              },
              "1204": {
                "name": "Northeastern Silverwastes",
                "level": 80,
                "coord": [
                  38194.7,
                  31330.5
                ],
                "bounds": [
                  [
                    37982.6,
                    31019.4
                  ],
                  [
                    38143,
                    30950.7
                  ],
                  [
                    38290.9,
                    31004.2
                  ],
                  [
                    38448.7,
                    31056.3
                  ],
                  [
                    38662.8,
                    31048
                  ],
                  [
                    38682.7,
                    31529.1
                  ],
                  [
                    38336.7,
                    31481.6
                  ],
                  [
                    38264.9,
                    31545.6
                  ],
                  [
                    38252.7,
                    31588.4
                  ],
                  [
                    38218.9,
                    31604.9
                  ],
                  [
                    38186.8,
                    31585.1
                  ],
                  [
                    38110.7,
                    31529.6
                  ],
                  [
                    37934.4,
                    31529.1
                  ],
                  [
                    37851.1,
                    31399.4
                  ],
                  [
                    37915.5,
                    31316
                  ],
                  [
                    37991.2,
                    31278.1
                  ],
                  [
                    38036.3,
                    31152.7
                  ],
                  [
                    37982.6,
                    31019.4
                  ]
                ],
                "id": 1204,
                "chat_link": "[&BLQEAAA=]"
              },
              "1211": {
                "name": "Tangled Labyrinth",
                "level": 80,
                "coord": [
                  37013.4,
                  31877.5
                ],
                "bounds": [
                  [
                    36883.8,
                    32115.2
                  ],
                  [
                    37185.7,
                    32111.3
                  ],
                  [
                    37167.7,
                    31937.1
                  ],
                  [
                    37088.5,
                    31841.3
                  ],
                  [
                    37032.2,
                    31721.5
                  ],
                  [
                    36958.4,
                    31715.3
                  ],
                  [
                    36923.4,
                    31674.3
                  ],
                  [
                    36867.9,
                    31903.8
                  ],
                  [
                    36883.8,
                    32115.2
                  ]
                ],
                "id": 1211,
                "chat_link": "[&BLsEAAA=]"
              },
              "1212": {
                "name": "Quarrel Gully",
                "level": 80,
                "coord": [
                  36794.2,
                  31791.9
                ],
                "bounds": [
                  [
                    36867.5,
                    31574.9
                  ],
                  [
                    36890.3,
                    31628
                  ],
                  [
                    36925.8,
                    31674.6
                  ],
                  [
                    36867.5,
                    31905.1
                  ],
                  [
                    36883,
                    32115.6
                  ],
                  [
                    36658.1,
                    32108.9
                  ],
                  [
                    36620.8,
                    31730.7
                  ],
                  [
                    36640.2,
                    31597.5
                  ],
                  [
                    36867.5,
                    31574.9
                  ]
                ],
                "id": 1212,
                "chat_link": "[&BLwEAAA=]"
              },
              "1213": {
                "name": "The Sealed Cavern",
                "level": 80,
                "coord": [
                  37170.4,
                  30898
                ],
                "bounds": [
                  [
                    37561.5,
                    30621.6
                  ],
                  [
                    36729.8,
                    30666.8
                  ],
                  [
                    36635.3,
                    30953.8
                  ],
                  [
                    36714.6,
                    31228.3
                  ],
                  [
                    36862.8,
                    31228
                  ],
                  [
                    36869.2,
                    31086.1
                  ],
                  [
                    36876.5,
                    30970.8
                  ],
                  [
                    36961.5,
                    30954.6
                  ],
                  [
                    37059.9,
                    30955.6
                  ],
                  [
                    37149.6,
                    30902.4
                  ],
                  [
                    37115.3,
                    30847.4
                  ],
                  [
                    37205.9,
                    30827
                  ],
                  [
                    37289.9,
                    30876.5
                  ],
                  [
                    37360.7,
                    30871.4
                  ],
                  [
                    37425.8,
                    30908.4
                  ],
                  [
                    37483.6,
                    30903.4
                  ],
                  [
                    37510.1,
                    30913.1
                  ],
                  [
                    37519.8,
                    30854.3
                  ],
                  [
                    37542.3,
                    30741.6
                  ],
                  [
                    37534.6,
                    30648.7
                  ],
                  [
                    37561.5,
                    30621.6
                  ]
                ],
                "id": 1213,
                "chat_link": "[&BL0EAAA=]"
              },
              "1214": {
                "name": "Far Silverwastes",
                "level": 80,
                "coord": [
                  37860.7,
                  30864
                ],
                "bounds": [
                  [
                    38142.9,
                    30952.4
                  ],
                  [
                    38195,
                    30969.3
                  ],
                  [
                    38211.6,
                    30927
                  ],
                  [
                    38153.2,
                    30873.1
                  ],
                  [
                    38126.8,
                    30777.3
                  ],
                  [
                    38134.9,
                    30737.4
                  ],
                  [
                    38045.5,
                    30656.7
                  ],
                  [
                    37988.6,
                    30608.8
                  ],
                  [
                    37561.3,
                    30621.4
                  ],
                  [
                    37534.1,
                    30647.3
                  ],
                  [
                    37545.9,
                    30735.6
                  ],
                  [
                    37520.4,
                    30853.1
                  ],
                  [
                    37510.9,
                    30912.3
                  ],
                  [
                    37566.1,
                    30934.4
                  ],
                  [
                    37698.6,
                    30975.1
                  ],
                  [
                    37713.6,
                    31056
                  ],
                  [
                    37799.2,
                    31080.8
                  ],
                  [
                    37920.4,
                    31078.5
                  ],
                  [
                    37983.4,
                    31019.7
                  ],
                  [
                    38142.9,
                    30952.4
                  ]
                ],
                "id": 1214,
                "chat_link": "[&BL4EAAA=]"
              },
              "1215": {
                "name": "Vinewrath Tangle",
                "level": 80,
                "coord": [
                  36890,
                  31415.5
                ],
                "bounds": [
                  [
                    36866.7,
                    31574.2
                  ],
                  [
                    36951.1,
                    31517.4
                  ],
                  [
                    36978.7,
                    31463.3
                  ],
                  [
                    36984.8,
                    31393.2
                  ],
                  [
                    36998,
                    31321.3
                  ],
                  [
                    36984.9,
                    31228.8
                  ],
                  [
                    36715.7,
                    31227.7
                  ],
                  [
                    36640.1,
                    31598.1
                  ],
                  [
                    36866.7,
                    31574.2
                  ]
                ],
                "id": 1215,
                "chat_link": "[&BL8EAAA=]"
              }
            },
            "adventures": [],
            "id": 1015,
            "mastery_points": []
          },
          "1021": {
            "name": "Into the Labyrinth",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37840,
              31926
            ],
            "map_rect": [
              [
                -24576,
                -18432
              ],
              [
                24576,
                18432
              ]
            ],
            "continent_rect": [
              [
                36608,
                30592
              ],
              [
                38656,
                32128
              ]
            ],
            "points_of_interest": {
              "1950": {
                "name": "The Labyrinth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37239.3,
                  31916.4
                ],
                "id": 1950,
                "chat_link": "[&BJ4HAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1198": {
                "name": "Southwestern Silverwastes",
                "level": 80,
                "coord": [
                  37125.8,
                  31701.3
                ],
                "bounds": [
                  [
                    37388.8,
                    31978.4
                  ],
                  [
                    37395.5,
                    32120
                  ],
                  [
                    37189.4,
                    32124.5
                  ],
                  [
                    37168.4,
                    31936.2
                  ],
                  [
                    37087,
                    31840
                  ],
                  [
                    37031.7,
                    31719.4
                  ],
                  [
                    36958,
                    31714.9
                  ],
                  [
                    36889.7,
                    31627.9
                  ],
                  [
                    36867,
                    31574.1
                  ],
                  [
                    36951.5,
                    31517.2
                  ],
                  [
                    36978.5,
                    31463.2
                  ],
                  [
                    36984.8,
                    31393.1
                  ],
                  [
                    36997.6,
                    31321.3
                  ],
                  [
                    37348.9,
                    31504.8
                  ],
                  [
                    37335.2,
                    31614.2
                  ],
                  [
                    37440.7,
                    31771.4
                  ],
                  [
                    37388.8,
                    31978.4
                  ]
                ],
                "id": 1198,
                "chat_link": "[&BK4EAAA=]"
              },
              "1200": {
                "name": "Sharp Valley",
                "level": 80,
                "coord": [
                  37569.3,
                  32030.9
                ],
                "bounds": [
                  [
                    37614.3,
                    31979.7
                  ],
                  [
                    37701.7,
                    31961
                  ],
                  [
                    37745.8,
                    32115.4
                  ],
                  [
                    37395.4,
                    32120.3
                  ],
                  [
                    37389.1,
                    31978.2
                  ],
                  [
                    37614.3,
                    31979.7
                  ]
                ],
                "id": 1200,
                "chat_link": "[&BLAEAAA=]"
              },
              "1204": {
                "name": "Northeastern Silverwastes",
                "level": 80,
                "coord": [
                  38194.7,
                  31330.5
                ],
                "bounds": [
                  [
                    37982.6,
                    31019.4
                  ],
                  [
                    38143,
                    30950.7
                  ],
                  [
                    38290.9,
                    31004.2
                  ],
                  [
                    38448.7,
                    31056.3
                  ],
                  [
                    38662.8,
                    31048
                  ],
                  [
                    38682.7,
                    31529.1
                  ],
                  [
                    38336.7,
                    31481.6
                  ],
                  [
                    38264.9,
                    31545.6
                  ],
                  [
                    38252.7,
                    31588.4
                  ],
                  [
                    38218.9,
                    31604.9
                  ],
                  [
                    38186.8,
                    31585.1
                  ],
                  [
                    38110.7,
                    31529.6
                  ],
                  [
                    37934.4,
                    31529.1
                  ],
                  [
                    37851.1,
                    31399.4
                  ],
                  [
                    37915.5,
                    31316
                  ],
                  [
                    37991.2,
                    31278.1
                  ],
                  [
                    38036.3,
                    31152.7
                  ],
                  [
                    37982.6,
                    31019.4
                  ]
                ],
                "id": 1204,
                "chat_link": "[&BLQEAAA=]"
              },
              "1211": {
                "name": "Tangled Labyrinth",
                "level": 80,
                "coord": [
                  37013.4,
                  31877.5
                ],
                "bounds": [
                  [
                    36883.8,
                    32115.2
                  ],
                  [
                    37185.7,
                    32111.3
                  ],
                  [
                    37167.7,
                    31937.1
                  ],
                  [
                    37088.5,
                    31841.3
                  ],
                  [
                    37032.2,
                    31721.5
                  ],
                  [
                    36958.4,
                    31715.3
                  ],
                  [
                    36923.4,
                    31674.3
                  ],
                  [
                    36867.9,
                    31903.8
                  ],
                  [
                    36883.8,
                    32115.2
                  ]
                ],
                "id": 1211,
                "chat_link": "[&BLsEAAA=]"
              }
            },
            "adventures": [],
            "id": 1021,
            "mastery_points": []
          },
          "1023": {
            "name": "Tracking the Aspect Masters",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37840,
              31926
            ],
            "map_rect": [
              [
                -24576,
                -18432
              ],
              [
                24576,
                18432
              ]
            ],
            "continent_rect": [
              [
                36608,
                30592
              ],
              [
                38656,
                32128
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1196": {
                "name": "Central Silverwastes",
                "level": 80,
                "coord": [
                  37617,
                  31656
                ],
                "bounds": [
                  [
                    37651.3,
                    31319.8
                  ],
                  [
                    37852.2,
                    31401.6
                  ],
                  [
                    37798.8,
                    31493.9
                  ],
                  [
                    37810.8,
                    31680.1
                  ],
                  [
                    37835.7,
                    31738.2
                  ],
                  [
                    37649,
                    31764.3
                  ],
                  [
                    37700.6,
                    31961.8
                  ],
                  [
                    37614,
                    31979.6
                  ],
                  [
                    37389,
                    31978.3
                  ],
                  [
                    37440.7,
                    31771.4
                  ],
                  [
                    37334.6,
                    31614.6
                  ],
                  [
                    37347.3,
                    31504.1
                  ],
                  [
                    37596.6,
                    31320.8
                  ],
                  [
                    37651.3,
                    31319.8
                  ]
                ],
                "id": 1196,
                "chat_link": "[&BKwEAAA=]"
              },
              "1197": {
                "name": "Northwestern Silverwastes",
                "level": 80,
                "coord": [
                  37266.7,
                  31197.3
                ],
                "bounds": [
                  [
                    37223.1,
                    31021.3
                  ],
                  [
                    37557.8,
                    31044.4
                  ],
                  [
                    37593.8,
                    31200.7
                  ],
                  [
                    37595.9,
                    31320.5
                  ],
                  [
                    37346.6,
                    31504.3
                  ],
                  [
                    36997.3,
                    31320
                  ],
                  [
                    36985.1,
                    31228.3
                  ],
                  [
                    37127.5,
                    31199.7
                  ],
                  [
                    37106.6,
                    31138.7
                  ],
                  [
                    37201.5,
                    31123.8
                  ],
                  [
                    37198.9,
                    31068.3
                  ],
                  [
                    37223.1,
                    31021.3
                  ]
                ],
                "id": 1197,
                "chat_link": "[&BK0EAAA=]"
              },
              "1198": {
                "name": "Southwestern Silverwastes",
                "level": 80,
                "coord": [
                  37125.8,
                  31701.3
                ],
                "bounds": [
                  [
                    37388.8,
                    31978.4
                  ],
                  [
                    37395.5,
                    32120
                  ],
                  [
                    37189.4,
                    32124.5
                  ],
                  [
                    37168.4,
                    31936.2
                  ],
                  [
                    37087,
                    31840
                  ],
                  [
                    37031.7,
                    31719.4
                  ],
                  [
                    36958,
                    31714.9
                  ],
                  [
                    36889.7,
                    31627.9
                  ],
                  [
                    36867,
                    31574.1
                  ],
                  [
                    36951.5,
                    31517.2
                  ],
                  [
                    36978.5,
                    31463.2
                  ],
                  [
                    36984.8,
                    31393.1
                  ],
                  [
                    36997.6,
                    31321.3
                  ],
                  [
                    37348.9,
                    31504.8
                  ],
                  [
                    37335.2,
                    31614.2
                  ],
                  [
                    37440.7,
                    31771.4
                  ],
                  [
                    37388.8,
                    31978.4
                  ]
                ],
                "id": 1198,
                "chat_link": "[&BK4EAAA=]"
              },
              "1199": {
                "name": "Northern Silverwastes",
                "level": 80,
                "coord": [
                  37776.7,
                  31156
                ],
                "bounds": [
                  [
                    37851.9,
                    31401.4
                  ],
                  [
                    37650.2,
                    31319.8
                  ],
                  [
                    37596.3,
                    31320.8
                  ],
                  [
                    37594,
                    31200.7
                  ],
                  [
                    37557.5,
                    31044.5
                  ],
                  [
                    37565.3,
                    30935
                  ],
                  [
                    37698.7,
                    30976.2
                  ],
                  [
                    37713.6,
                    31056.2
                  ],
                  [
                    37799,
                    31080.5
                  ],
                  [
                    37920.2,
                    31078.4
                  ],
                  [
                    37983,
                    31020.9
                  ],
                  [
                    38037,
                    31153.9
                  ],
                  [
                    37991.6,
                    31278.3
                  ],
                  [
                    37916.1,
                    31317
                  ],
                  [
                    37851.9,
                    31401.4
                  ]
                ],
                "id": 1199,
                "chat_link": "[&BK8EAAA=]"
              },
              "1200": {
                "name": "Sharp Valley",
                "level": 80,
                "coord": [
                  37569.3,
                  32030.9
                ],
                "bounds": [
                  [
                    37614.3,
                    31979.7
                  ],
                  [
                    37701.7,
                    31961
                  ],
                  [
                    37745.8,
                    32115.4
                  ],
                  [
                    37395.4,
                    32120.3
                  ],
                  [
                    37389.1,
                    31978.2
                  ],
                  [
                    37614.3,
                    31979.7
                  ]
                ],
                "id": 1200,
                "chat_link": "[&BLAEAAA=]"
              },
              "1201": {
                "name": "Camp Resolve",
                "level": 80,
                "coord": [
                  38397.8,
                  31772.9
                ],
                "bounds": [
                  [
                    38264.8,
                    31545.7
                  ],
                  [
                    38336.5,
                    31481.1
                  ],
                  [
                    38683.6,
                    31527.5
                  ],
                  [
                    38678.2,
                    31573.9
                  ],
                  [
                    38666.7,
                    31706.6
                  ],
                  [
                    38627.3,
                    32139.2
                  ],
                  [
                    38237.7,
                    32113.6
                  ],
                  [
                    38269.8,
                    32003.9
                  ],
                  [
                    38245.9,
                    31951.8
                  ],
                  [
                    38214.1,
                    31899.1
                  ],
                  [
                    38296.2,
                    31742.9
                  ],
                  [
                    38253.3,
                    31589.1
                  ],
                  [
                    38264.8,
                    31545.7
                  ]
                ],
                "id": 1201,
                "chat_link": "[&BLEEAAA=]"
              },
              "1202": {
                "name": "Desperate Passage",
                "level": 80,
                "coord": [
                  37181.4,
                  31003.9
                ],
                "bounds": [
                  [
                    37557.1,
                    31044.4
                  ],
                  [
                    37565.7,
                    30934
                  ],
                  [
                    37484,
                    30902
                  ],
                  [
                    37424.9,
                    30909
                  ],
                  [
                    37361.6,
                    30868.2
                  ],
                  [
                    37289.5,
                    30877
                  ],
                  [
                    37205.5,
                    30825.7
                  ],
                  [
                    37113.5,
                    30844.4
                  ],
                  [
                    37152.2,
                    30902.1
                  ],
                  [
                    37059.7,
                    30955.6
                  ],
                  [
                    36965,
                    30950.3
                  ],
                  [
                    36876.5,
                    30972
                  ],
                  [
                    36870,
                    31085.7
                  ],
                  [
                    36862.6,
                    31228.2
                  ],
                  [
                    36984.7,
                    31229.6
                  ],
                  [
                    37127.4,
                    31200
                  ],
                  [
                    37107.1,
                    31139
                  ],
                  [
                    37202.1,
                    31124.2
                  ],
                  [
                    37200.5,
                    31068.9
                  ],
                  [
                    37217.6,
                    31018.4
                  ],
                  [
                    37557.1,
                    31044.4
                  ]
                ],
                "id": 1202,
                "chat_link": "[&BLIEAAA=]"
              },
              "1203": {
                "name": "Southeastern Silverwastes",
                "level": 80,
                "coord": [
                  38021.5,
                  31747
                ],
                "bounds": [
                  [
                    37799.2,
                    31493.6
                  ],
                  [
                    37851.2,
                    31399.2
                  ],
                  [
                    37935.3,
                    31530.5
                  ],
                  [
                    38111.3,
                    31530.8
                  ],
                  [
                    38187.3,
                    31586.6
                  ],
                  [
                    38218.7,
                    31605.7
                  ],
                  [
                    38253.7,
                    31589.5
                  ],
                  [
                    38296.7,
                    31743.9
                  ],
                  [
                    38213.8,
                    31899.9
                  ],
                  [
                    38245.9,
                    31952.4
                  ],
                  [
                    38269.8,
                    32003.7
                  ],
                  [
                    38236.4,
                    32113.2
                  ],
                  [
                    37747.4,
                    32106.9
                  ],
                  [
                    37700.2,
                    31962.7
                  ],
                  [
                    37649.3,
                    31765.3
                  ],
                  [
                    37838.1,
                    31737.5
                  ],
                  [
                    37810.8,
                    31678.2
                  ],
                  [
                    37799.2,
                    31493.6
                  ]
                ],
                "id": 1203,
                "chat_link": "[&BLMEAAA=]"
              },
              "1204": {
                "name": "Northeastern Silverwastes",
                "level": 80,
                "coord": [
                  38194.7,
                  31330.5
                ],
                "bounds": [
                  [
                    37982.6,
                    31019.4
                  ],
                  [
                    38143,
                    30950.7
                  ],
                  [
                    38290.9,
                    31004.2
                  ],
                  [
                    38448.7,
                    31056.3
                  ],
                  [
                    38662.8,
                    31048
                  ],
                  [
                    38682.7,
                    31529.1
                  ],
                  [
                    38336.7,
                    31481.6
                  ],
                  [
                    38264.9,
                    31545.6
                  ],
                  [
                    38252.7,
                    31588.4
                  ],
                  [
                    38218.9,
                    31604.9
                  ],
                  [
                    38186.8,
                    31585.1
                  ],
                  [
                    38110.7,
                    31529.6
                  ],
                  [
                    37934.4,
                    31529.1
                  ],
                  [
                    37851.1,
                    31399.4
                  ],
                  [
                    37915.5,
                    31316
                  ],
                  [
                    37991.2,
                    31278.1
                  ],
                  [
                    38036.3,
                    31152.7
                  ],
                  [
                    37982.6,
                    31019.4
                  ]
                ],
                "id": 1204,
                "chat_link": "[&BLQEAAA=]"
              },
              "1211": {
                "name": "Tangled Labyrinth",
                "level": 80,
                "coord": [
                  37013.4,
                  31877.5
                ],
                "bounds": [
                  [
                    36883.8,
                    32115.2
                  ],
                  [
                    37185.7,
                    32111.3
                  ],
                  [
                    37167.7,
                    31937.1
                  ],
                  [
                    37088.5,
                    31841.3
                  ],
                  [
                    37032.2,
                    31721.5
                  ],
                  [
                    36958.4,
                    31715.3
                  ],
                  [
                    36923.4,
                    31674.3
                  ],
                  [
                    36867.9,
                    31903.8
                  ],
                  [
                    36883.8,
                    32115.2
                  ]
                ],
                "id": 1211,
                "chat_link": "[&BLsEAAA=]"
              }
            },
            "adventures": [],
            "id": 1023,
            "mastery_points": []
          },
          "1058": {
            "name": "Prologue: Rally to Maguuma",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              37618,
              31484
            ],
            "map_rect": [
              [
                -24576,
                -18432
              ],
              [
                24576,
                18432
              ]
            ],
            "continent_rect": [
              [
                36608,
                30592
              ],
              [
                38656,
                32128
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1196": {
                "name": "Central Silverwastes",
                "level": 80,
                "coord": [
                  37617,
                  31656
                ],
                "bounds": [
                  [
                    37651.3,
                    31319.8
                  ],
                  [
                    37852.2,
                    31401.6
                  ],
                  [
                    37798.8,
                    31493.9
                  ],
                  [
                    37810.8,
                    31680.1
                  ],
                  [
                    37835.7,
                    31738.2
                  ],
                  [
                    37649,
                    31764.3
                  ],
                  [
                    37700.6,
                    31961.8
                  ],
                  [
                    37614,
                    31979.6
                  ],
                  [
                    37389,
                    31978.3
                  ],
                  [
                    37440.7,
                    31771.4
                  ],
                  [
                    37334.6,
                    31614.6
                  ],
                  [
                    37347.3,
                    31504.1
                  ],
                  [
                    37596.6,
                    31320.8
                  ],
                  [
                    37651.3,
                    31319.8
                  ]
                ],
                "id": 1196,
                "chat_link": "[&BKwEAAA=]"
              },
              "1198": {
                "name": "Southwestern Silverwastes",
                "level": 80,
                "coord": [
                  37125.8,
                  31701.3
                ],
                "bounds": [
                  [
                    37388.8,
                    31978.4
                  ],
                  [
                    37395.5,
                    32120
                  ],
                  [
                    37189.4,
                    32124.5
                  ],
                  [
                    37168.4,
                    31936.2
                  ],
                  [
                    37087,
                    31840
                  ],
                  [
                    37031.7,
                    31719.4
                  ],
                  [
                    36958,
                    31714.9
                  ],
                  [
                    36889.7,
                    31627.9
                  ],
                  [
                    36867,
                    31574.1
                  ],
                  [
                    36951.5,
                    31517.2
                  ],
                  [
                    36978.5,
                    31463.2
                  ],
                  [
                    36984.8,
                    31393.1
                  ],
                  [
                    36997.6,
                    31321.3
                  ],
                  [
                    37348.9,
                    31504.8
                  ],
                  [
                    37335.2,
                    31614.2
                  ],
                  [
                    37440.7,
                    31771.4
                  ],
                  [
                    37388.8,
                    31978.4
                  ]
                ],
                "id": 1198,
                "chat_link": "[&BK4EAAA=]"
              },
              "1200": {
                "name": "Sharp Valley",
                "level": 80,
                "coord": [
                  37569.3,
                  32030.9
                ],
                "bounds": [
                  [
                    37614.3,
                    31979.7
                  ],
                  [
                    37701.7,
                    31961
                  ],
                  [
                    37745.8,
                    32115.4
                  ],
                  [
                    37395.4,
                    32120.3
                  ],
                  [
                    37389.1,
                    31978.2
                  ],
                  [
                    37614.3,
                    31979.7
                  ]
                ],
                "id": 1200,
                "chat_link": "[&BLAEAAA=]"
              },
              "1203": {
                "name": "Southeastern Silverwastes",
                "level": 80,
                "coord": [
                  38021.5,
                  31747
                ],
                "bounds": [
                  [
                    37799.2,
                    31493.6
                  ],
                  [
                    37851.2,
                    31399.2
                  ],
                  [
                    37935.3,
                    31530.5
                  ],
                  [
                    38111.3,
                    31530.8
                  ],
                  [
                    38187.3,
                    31586.6
                  ],
                  [
                    38218.7,
                    31605.7
                  ],
                  [
                    38253.7,
                    31589.5
                  ],
                  [
                    38296.7,
                    31743.9
                  ],
                  [
                    38213.8,
                    31899.9
                  ],
                  [
                    38245.9,
                    31952.4
                  ],
                  [
                    38269.8,
                    32003.7
                  ],
                  [
                    38236.4,
                    32113.2
                  ],
                  [
                    37747.4,
                    32106.9
                  ],
                  [
                    37700.2,
                    31962.7
                  ],
                  [
                    37649.3,
                    31765.3
                  ],
                  [
                    37838.1,
                    31737.5
                  ],
                  [
                    37810.8,
                    31678.2
                  ],
                  [
                    37799.2,
                    31493.6
                  ]
                ],
                "id": 1203,
                "chat_link": "[&BLMEAAA=]"
              },
              "1211": {
                "name": "Tangled Labyrinth",
                "level": 80,
                "coord": [
                  37013.4,
                  31877.5
                ],
                "bounds": [
                  [
                    36883.8,
                    32115.2
                  ],
                  [
                    37185.7,
                    32111.3
                  ],
                  [
                    37167.7,
                    31937.1
                  ],
                  [
                    37088.5,
                    31841.3
                  ],
                  [
                    37032.2,
                    31721.5
                  ],
                  [
                    36958.4,
                    31715.3
                  ],
                  [
                    36923.4,
                    31674.3
                  ],
                  [
                    36867.9,
                    31903.8
                  ],
                  [
                    36883.8,
                    32115.2
                  ]
                ],
                "id": 1211,
                "chat_link": "[&BLsEAAA=]"
              },
              "1212": {
                "name": "Quarrel Gully",
                "level": 80,
                "coord": [
                  36794.2,
                  31791.9
                ],
                "bounds": [
                  [
                    36867.5,
                    31574.9
                  ],
                  [
                    36890.3,
                    31628
                  ],
                  [
                    36925.8,
                    31674.6
                  ],
                  [
                    36867.5,
                    31905.1
                  ],
                  [
                    36883,
                    32115.6
                  ],
                  [
                    36658.1,
                    32108.9
                  ],
                  [
                    36620.8,
                    31730.7
                  ],
                  [
                    36640.2,
                    31597.5
                  ],
                  [
                    36867.5,
                    31574.9
                  ]
                ],
                "id": 1212,
                "chat_link": "[&BLwEAAA=]"
              }
            },
            "adventures": [],
            "id": 1058,
            "mastery_points": []
          }
        },
        "id": 11
      },
      "12": {
        "name": "Crystal Desert",
        "label_coord": [
          59968,
          42384
        ],
        "continent_rect": [
          [
            50432,
            24448
          ],
          [
            56576,
            37760
          ]
        ],
        "maps": {
          "1263": {
            "name": "Domain of Istan",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              57168,
              61884
            ],
            "map_rect": [
              [
                -46080,
                -46080
              ],
              [
                46080,
                46080
              ]
            ],
            "continent_rect": [
              [
                55318,
                59916
              ],
              [
                59158,
                63756
              ]
            ],
            "points_of_interest": {
              "2805": {
                "name": "Freetrader Haven",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56656.7,
                  60479.4
                ],
                "id": 2805,
                "chat_link": "[&BPUKAAA=]"
              },
              "2806": {
                "name": "The Dark Leviathan",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56815.3,
                  60377.6
                ],
                "id": 2806,
                "chat_link": "[&BPYKAAA=]"
              },
              "2807": {
                "name": "Temple of Joko",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57756.5,
                  61962.9
                ],
                "id": 2807,
                "chat_link": "[&BPcKAAA=]"
              },
              "2808": {
                "name": "Mirror of the Sun",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55773.8,
                  61325.7
                ],
                "id": 2808,
                "chat_link": "[&BPgKAAA=]"
              },
              "2809": {
                "name": "Ancient Royal Docks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57317.2,
                  62471.4
                ],
                "id": 2809,
                "chat_link": "[&BPkKAAA=]"
              },
              "2810": {
                "name": "Astralarium Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  55830.2,
                  60838.7
                ],
                "id": 2810,
                "chat_link": "[&BPoKAAA=]"
              },
              "2811": {
                "name": "Mirror of the Earth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55635.6,
                  61060.1
                ],
                "id": 2811,
                "chat_link": "[&BPsKAAA=]"
              },
              "2812": {
                "name": "The Sun Docks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58421.2,
                  61959.3
                ],
                "id": 2812,
                "chat_link": "[&BPwKAAA=]"
              },
              "2814": {
                "name": "Broken Observation Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55891.3,
                  60419
                ],
                "id": 2814,
                "chat_link": "[&BP4KAAA=]"
              },
              "2815": {
                "name": "Stage of Sacrifice",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57894.9,
                  62189.5
                ],
                "id": 2815,
                "chat_link": "[&BP8KAAA=]"
              },
              "2816": {
                "name": "Skylight Vault",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57427.3,
                  60931
                ],
                "id": 2816,
                "chat_link": "[&BAALAAA=]"
              },
              "2817": {
                "name": "Crucible of the Apostate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58268.6,
                  61451.1
                ],
                "id": 2817,
                "chat_link": "[&BAELAAA=]"
              },
              "2818": {
                "name": "Zehlon Waterworks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55911.9,
                  61913.9
                ],
                "id": 2818,
                "chat_link": "[&BAILAAA=]"
              },
              "2819": {
                "name": "Grotto of the Defeated",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56168.9,
                  62847.9
                ],
                "id": 2819,
                "chat_link": "[&BAMLAAA=]"
              },
              "2821": {
                "name": "Clanmarshal's Promenade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57905.7,
                  61774.3
                ],
                "id": 2821,
                "chat_link": "[&BAULAAA=]"
              },
              "2822": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  56184.3,
                  62099.6
                ],
                "id": 2822,
                "chat_link": "[&BAYLAAA=]"
              },
              "2823": {
                "name": "Plaza of Resurgence",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57026.3,
                  61453.7
                ],
                "id": 2823,
                "chat_link": "[&BAcLAAA=]"
              },
              "2824": {
                "name": "Jakumba's Legacy",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55948.2,
                  61578.3
                ],
                "id": 2824,
                "chat_link": "[&BAgLAAA=]"
              },
              "2825": {
                "name": "Chalon Docks Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57792.9,
                  61028.3
                ],
                "id": 2825,
                "chat_link": "[&BAkLAAA=]"
              },
              "2827": {
                "name": "The Wobbling Skies",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56589.3,
                  60713.3
                ],
                "id": 2827,
                "chat_link": "[&BAsLAAA=]"
              },
              "2828": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57794.2,
                  62714.1
                ],
                "id": 2828,
                "chat_link": "[&BAwLAAA=]"
              },
              "2830": {
                "name": "Palawadan Dormitories",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58093.4,
                  62187.9
                ],
                "id": 2830,
                "chat_link": "[&BA4LAAA=]"
              },
              "2831": {
                "name": "Mirror of the Moon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56293.6,
                  60725.3
                ],
                "id": 2831,
                "chat_link": "[&BA8LAAA=]"
              },
              "2832": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57783.1,
                  61963.8
                ],
                "id": 2832,
                "chat_link": "[&BBALAAA=]"
              },
              "2833": {
                "name": "The Skimming Stone",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56955.8,
                  60677.4
                ],
                "id": 2833,
                "chat_link": "[&BBELAAA=]"
              },
              "2835": {
                "name": "Mirror of the Stars",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55947.8,
                  61199.7
                ],
                "id": 2835,
                "chat_link": "[&BBMLAAA=]"
              },
              "2837": {
                "name": "Mehtani's Blade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56869.8,
                  62946.1
                ],
                "id": 2837,
                "chat_link": "[&BBULAAA=]"
              },
              "2838": {
                "name": "Chahbek Thrust",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57844.4,
                  62588.7
                ],
                "id": 2838,
                "chat_link": "[&BBYLAAA=]"
              },
              "2839": {
                "name": "Lahdok Craterlands",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56624.7,
                  61389.5
                ],
                "id": 2839,
                "chat_link": "[&BBcLAAA=]"
              },
              "2840": {
                "name": "Hall of Judgment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58097.2,
                  61964.4
                ],
                "id": 2840,
                "chat_link": "[&BBgLAAA=]"
              },
              "2841": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  56601.1,
                  60415.2
                ],
                "id": 2841,
                "chat_link": "[&BBkLAAA=]"
              },
              "2842": {
                "name": "Champion's Dawn Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  56265.3,
                  62042.9
                ],
                "id": 2842,
                "chat_link": "[&BBoLAAA=]"
              },
              "2843": {
                "name": "Field of the Hopeful",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56556.1,
                  62582.7
                ],
                "id": 2843,
                "chat_link": "[&BBsLAAA=]"
              },
              "2844": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  55893.6,
                  60795.1
                ],
                "id": 2844,
                "chat_link": "[&BBwLAAA=]"
              },
              "2845": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58079.4,
                  61597
                ],
                "id": 2845,
                "chat_link": "[&BB0LAAA=]"
              },
              "2846": {
                "name": "Warden's Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57025.9,
                  61285.5
                ],
                "id": 2846,
                "chat_link": "[&BB4LAAA=]"
              }
            },
            "tasks": {
              "420": {
                "objective": "Help the cause of dissenting Astralarium scholars.",
                "level": 80,
                "coord": [
                  55682,
                  60587.4
                ],
                "bounds": [
                  [
                    55889.5,
                    60798.8
                  ],
                  [
                    57547.7,
                    61836
                  ],
                  [
                    55889.5,
                    60798.8
                  ]
                ],
                "id": 420,
                "chat_link": "[&BKQBAAA=]"
              },
              "421": {
                "objective": "Aid the oppressed of Champion's Dawn on behalf of the Sunspears.",
                "level": 80,
                "coord": [
                  56240,
                  62583.3
                ],
                "bounds": [
                  [
                    55647,
                    62357.3
                  ],
                  [
                    56328.1,
                    61885.2
                  ],
                  [
                    56333.2,
                    61972.5
                  ],
                  [
                    56549.7,
                    62088.1
                  ],
                  [
                    56637.5,
                    62235.8
                  ],
                  [
                    56644.4,
                    62329
                  ],
                  [
                    56709,
                    62358.5
                  ],
                  [
                    56781.3,
                    62616.5
                  ],
                  [
                    56639.5,
                    62802.9
                  ],
                  [
                    56499.5,
                    62739.8
                  ],
                  [
                    56417.6,
                    62788.3
                  ],
                  [
                    56423.4,
                    62927.6
                  ],
                  [
                    56345.4,
                    63143.8
                  ],
                  [
                    56114.3,
                    62837.7
                  ],
                  [
                    55851.2,
                    62588.1
                  ],
                  [
                    55647,
                    62357.3
                  ]
                ],
                "id": 421,
                "chat_link": "[&BKUBAAA=]"
              },
              "422": {
                "objective": "Maintain peace and order in the corsair flotilla.",
                "level": 80,
                "coord": [
                  56649,
                  60509.7
                ],
                "bounds": [
                  [
                    56752.4,
                    60855.9
                  ],
                  [
                    56569.5,
                    60837.4
                  ],
                  [
                    56464.8,
                    60557
                  ],
                  [
                    56533.1,
                    60371.5
                  ],
                  [
                    56678.7,
                    60258.8
                  ],
                  [
                    56788.9,
                    60224.7
                  ],
                  [
                    56909.9,
                    60241.8
                  ],
                  [
                    57041.7,
                    60313.5
                  ],
                  [
                    57056.7,
                    60414.7
                  ],
                  [
                    57084.2,
                    60538.8
                  ],
                  [
                    57089.8,
                    60716
                  ],
                  [
                    57006.6,
                    60821.1
                  ],
                  [
                    56752.4,
                    60855.9
                  ]
                ],
                "id": 422,
                "chat_link": "[&BKYBAAA=]"
              }
            },
            "skill_challenges": [],
            "sectors": {
              "1598": {
                "name": "Churrhir Cliffs",
                "level": 80,
                "coord": [
                  57206.2,
                  62296.3
                ],
                "bounds": [
                  [
                    56449.5,
                    61979
                  ],
                  [
                    56605.9,
                    62015.8
                  ],
                  [
                    56740.8,
                    61959
                  ],
                  [
                    56815,
                    62081.9
                  ],
                  [
                    56788.2,
                    62143.1
                  ],
                  [
                    56807.5,
                    62282
                  ],
                  [
                    56897,
                    62374.4
                  ],
                  [
                    57239.4,
                    62437.5
                  ],
                  [
                    57191.7,
                    62837.5
                  ],
                  [
                    57293,
                    62921.8
                  ],
                  [
                    58048.3,
                    63240
                  ],
                  [
                    58304.3,
                    63191.9
                  ],
                  [
                    58296,
                    62383.3
                  ],
                  [
                    57633.5,
                    62339.1
                  ],
                  [
                    57434.5,
                    62213.9
                  ],
                  [
                    57331.8,
                    62067.6
                  ],
                  [
                    57343.5,
                    61710
                  ],
                  [
                    57157.5,
                    61707
                  ],
                  [
                    56540.2,
                    61745.5
                  ],
                  [
                    56449.5,
                    61979
                  ]
                ],
                "id": 1598,
                "chat_link": "[&BD4GAAA=]"
              },
              "1602": {
                "name": "Zehlon Breach",
                "level": 80,
                "coord": [
                  55987.2,
                  61792.9
                ],
                "bounds": [
                  [
                    55559.2,
                    61580.8
                  ],
                  [
                    56125,
                    61438.6
                  ],
                  [
                    56223.7,
                    61565.3
                  ],
                  [
                    56346.8,
                    61681.7
                  ],
                  [
                    56373.6,
                    61764.4
                  ],
                  [
                    56328.1,
                    61885.2
                  ],
                  [
                    55647,
                    62357.3
                  ],
                  [
                    55621.1,
                    62070.1
                  ],
                  [
                    55660.3,
                    61792.6
                  ],
                  [
                    55559.2,
                    61580.8
                  ]
                ],
                "id": 1602,
                "chat_link": "[&BEIGAAA=]"
              },
              "1604": {
                "name": "The Astralarium",
                "level": 80,
                "coord": [
                  56015.7,
                  60830.4
                ],
                "bounds": [
                  [
                    55644.3,
                    60333.6
                  ],
                  [
                    55851.9,
                    60247.9
                  ],
                  [
                    55988.3,
                    60355.5
                  ],
                  [
                    56093.6,
                    60390.9
                  ],
                  [
                    56199,
                    60478.3
                  ],
                  [
                    56136.3,
                    60522.5
                  ],
                  [
                    56335.5,
                    60611.8
                  ],
                  [
                    56462.1,
                    60590.6
                  ],
                  [
                    56441.4,
                    60770.5
                  ],
                  [
                    56261.3,
                    60833.7
                  ],
                  [
                    56257.2,
                    60932.5
                  ],
                  [
                    56368.9,
                    61005.3
                  ],
                  [
                    56147,
                    61082
                  ],
                  [
                    56098.8,
                    61318.8
                  ],
                  [
                    56125,
                    61438.6
                  ],
                  [
                    55559.2,
                    61580.8
                  ],
                  [
                    55478.5,
                    61384.1
                  ],
                  [
                    55398.8,
                    61104.6
                  ],
                  [
                    55450.7,
                    60794.8
                  ],
                  [
                    55644.3,
                    60333.6
                  ]
                ],
                "id": 1604,
                "chat_link": "[&BEQGAAA=]"
              },
              "1605": {
                "name": "Corsair Flotilla",
                "level": 80,
                "coord": [
                  56451.7,
                  60569.7
                ],
                "bounds": [
                  [
                    55761.3,
                    60152.1
                  ],
                  [
                    55742.6,
                    60295.2
                  ],
                  [
                    55851.9,
                    60247.9
                  ],
                  [
                    55988.3,
                    60355.5
                  ],
                  [
                    56093.6,
                    60390.9
                  ],
                  [
                    56199,
                    60478.3
                  ],
                  [
                    56136.3,
                    60522.5
                  ],
                  [
                    56335.5,
                    60611.8
                  ],
                  [
                    56462.1,
                    60590.6
                  ],
                  [
                    56441.4,
                    60770.5
                  ],
                  [
                    56261.3,
                    60833.7
                  ],
                  [
                    56257.2,
                    60932.5
                  ],
                  [
                    56368.9,
                    61005.3
                  ],
                  [
                    56660.1,
                    60943.5
                  ],
                  [
                    56874.6,
                    60875
                  ],
                  [
                    57026.2,
                    60852.4
                  ],
                  [
                    57128.8,
                    60773.4
                  ],
                  [
                    57354.3,
                    60596.3
                  ],
                  [
                    57355.8,
                    60112.5
                  ],
                  [
                    56734.4,
                    60054.7
                  ],
                  [
                    55761.3,
                    60152.1
                  ]
                ],
                "id": 1605,
                "chat_link": "[&BEUGAAA=]"
              },
              "1606": {
                "name": "Chalon Docks",
                "level": 80,
                "coord": [
                  57869.2,
                  61062.8
                ],
                "bounds": [
                  [
                    57685.2,
                    60686.3
                  ],
                  [
                    58056.3,
                    60837.8
                  ],
                  [
                    58182,
                    61124.2
                  ],
                  [
                    58027.8,
                    61343.6
                  ],
                  [
                    57821.5,
                    61382.6
                  ],
                  [
                    57695.1,
                    61231.3
                  ],
                  [
                    57719.5,
                    61051.9
                  ],
                  [
                    57766.2,
                    60844.4
                  ],
                  [
                    57685.2,
                    60686.3
                  ]
                ],
                "id": 1606,
                "chat_link": "[&BEYGAAA=]"
              },
              "1609": {
                "name": "Mordant Crescent<br>Great Hall",
                "level": 80,
                "coord": [
                  57041.2,
                  61332.1
                ],
                "bounds": [
                  [
                    56846.8,
                    61456.3
                  ],
                  [
                    56841.3,
                    61203.3
                  ],
                  [
                    56916.6,
                    61113.9
                  ],
                  [
                    57159.5,
                    61112.9
                  ],
                  [
                    57242.1,
                    61206.1
                  ],
                  [
                    57237.5,
                    61443.3
                  ],
                  [
                    57147.9,
                    61563
                  ],
                  [
                    56938.1,
                    61558
                  ],
                  [
                    56846.8,
                    61456.3
                  ]
                ],
                "id": 1609,
                "chat_link": "[&BEkGAAA=]"
              },
              "1610": {
                "name": "Heretic's Arena",
                "level": 80,
                "coord": [
                  58240.1,
                  61410.8
                ],
                "bounds": [
                  [
                    58463.4,
                    61209.9
                  ],
                  [
                    58579,
                    61394.8
                  ],
                  [
                    58561.2,
                    61657.4
                  ],
                  [
                    58265.9,
                    61626.8
                  ],
                  [
                    58020.1,
                    61547.3
                  ],
                  [
                    57821.5,
                    61382.6
                  ],
                  [
                    58027.8,
                    61343.6
                  ],
                  [
                    58182,
                    61124.2
                  ],
                  [
                    58463.4,
                    61209.9
                  ]
                ],
                "id": 1610,
                "chat_link": "[&BEoGAAA=]"
              },
              "1614": {
                "name": "Champion's Dawn",
                "level": 80,
                "coord": [
                  56394.7,
                  62511.4
                ],
                "bounds": [
                  [
                    55647,
                    62357.3
                  ],
                  [
                    56328.1,
                    61885.2
                  ],
                  [
                    56333.2,
                    61972.5
                  ],
                  [
                    56549.7,
                    62088.1
                  ],
                  [
                    56637.5,
                    62235.8
                  ],
                  [
                    56644.4,
                    62329
                  ],
                  [
                    56709,
                    62358.5
                  ],
                  [
                    56781.3,
                    62616.5
                  ],
                  [
                    56639.5,
                    62802.9
                  ],
                  [
                    56499.5,
                    62739.8
                  ],
                  [
                    56417.6,
                    62788.3
                  ],
                  [
                    56423.4,
                    62927.6
                  ],
                  [
                    56345.4,
                    63143.8
                  ],
                  [
                    56114.3,
                    62837.7
                  ],
                  [
                    55851.2,
                    62588.1
                  ],
                  [
                    55647,
                    62357.3
                  ]
                ],
                "id": 1614,
                "chat_link": "[&BE4GAAA=]"
              },
              "1615": {
                "name": "Modri Caverns",
                "level": 80,
                "coord": [
                  57462.9,
                  60832.7
                ],
                "bounds": [
                  [
                    57026.2,
                    60852.4
                  ],
                  [
                    57354.3,
                    60596.3
                  ],
                  [
                    57624.9,
                    60640.3
                  ],
                  [
                    57685.2,
                    60686.3
                  ],
                  [
                    57766.2,
                    60844.4
                  ],
                  [
                    57719.5,
                    61051.9
                  ],
                  [
                    57479,
                    61025.2
                  ],
                  [
                    57331,
                    60970.8
                  ],
                  [
                    57179.6,
                    60826.8
                  ],
                  [
                    57026.2,
                    60852.4
                  ]
                ],
                "id": 1615,
                "chat_link": "[&BE8GAAA=]"
              },
              "1616": {
                "name": "Palawadan, Jewel of Istan",
                "level": 80,
                "coord": [
                  57825.9,
                  61851.8
                ],
                "bounds": [
                  [
                    58561.2,
                    61657.4
                  ],
                  [
                    58618.7,
                    61971.4
                  ],
                  [
                    58533.6,
                    62288
                  ],
                  [
                    58296,
                    62383.3
                  ],
                  [
                    57633.5,
                    62339.1
                  ],
                  [
                    57434.5,
                    62213.9
                  ],
                  [
                    57331.8,
                    62067.6
                  ],
                  [
                    57343.5,
                    61710
                  ],
                  [
                    57157.5,
                    61707
                  ],
                  [
                    57153.7,
                    61639.2
                  ],
                  [
                    57457.2,
                    61389.4
                  ],
                  [
                    57639.5,
                    61623.9
                  ],
                  [
                    57942.3,
                    61613.5
                  ],
                  [
                    58020.1,
                    61547.3
                  ],
                  [
                    58265.9,
                    61626.8
                  ],
                  [
                    58561.2,
                    61657.4
                  ]
                ],
                "id": 1616,
                "chat_link": "[&BFAGAAA=]"
              },
              "1618": {
                "name": "Issnur Bay",
                "level": 80,
                "coord": [
                  56753.7,
                  62474.1
                ],
                "bounds": [
                  [
                    58048.3,
                    63240
                  ],
                  [
                    57293,
                    62921.8
                  ],
                  [
                    57191.7,
                    62837.5
                  ],
                  [
                    57239.4,
                    62437.5
                  ],
                  [
                    56897,
                    62374.4
                  ],
                  [
                    56807.5,
                    62282
                  ],
                  [
                    56788.2,
                    62143.1
                  ],
                  [
                    56815,
                    62081.9
                  ],
                  [
                    56740.8,
                    61959
                  ],
                  [
                    56605.9,
                    62015.8
                  ],
                  [
                    56449.5,
                    61979
                  ],
                  [
                    56328.1,
                    61885.2
                  ],
                  [
                    56333.2,
                    61972.5
                  ],
                  [
                    56549.7,
                    62088.1
                  ],
                  [
                    56637.5,
                    62235.8
                  ],
                  [
                    56644.4,
                    62329
                  ],
                  [
                    56709,
                    62358.5
                  ],
                  [
                    56781.3,
                    62616.5
                  ],
                  [
                    56639.5,
                    62802.9
                  ],
                  [
                    56499.5,
                    62739.8
                  ],
                  [
                    56417.6,
                    62788.3
                  ],
                  [
                    56423.4,
                    62927.6
                  ],
                  [
                    56345.4,
                    63143.8
                  ],
                  [
                    56902.8,
                    63218.3
                  ],
                  [
                    58048.3,
                    63240
                  ]
                ],
                "id": 1618,
                "chat_link": "[&BFIGAAA=]"
              },
              "1619": {
                "name": "Sea of Istan",
                "level": 80,
                "coord": [
                  58251.8,
                  61308.5
                ],
                "bounds": [
                  [
                    58267.3,
                    60733
                  ],
                  [
                    58367.4,
                    60825.2
                  ],
                  [
                    58648.8,
                    60995.5
                  ],
                  [
                    58810.9,
                    61253.4
                  ],
                  [
                    58790.1,
                    61983.8
                  ],
                  [
                    58604.6,
                    62642.5
                  ],
                  [
                    58304.3,
                    63191.9
                  ],
                  [
                    58296,
                    62383.3
                  ],
                  [
                    58533.6,
                    62288
                  ],
                  [
                    58618.7,
                    61971.4
                  ],
                  [
                    58561.2,
                    61657.4
                  ],
                  [
                    58579,
                    61394.8
                  ],
                  [
                    58463.4,
                    61209.9
                  ],
                  [
                    58182,
                    61124.2
                  ],
                  [
                    58056.3,
                    60837.8
                  ],
                  [
                    57685.2,
                    60686.3
                  ],
                  [
                    57624.9,
                    60640.3
                  ],
                  [
                    57354.3,
                    60596.3
                  ],
                  [
                    57355.8,
                    60112.5
                  ],
                  [
                    58026,
                    60410.8
                  ],
                  [
                    58157.4,
                    60541.1
                  ],
                  [
                    58267.3,
                    60733
                  ]
                ],
                "id": 1619,
                "chat_link": "[&BFMGAAA=]"
              },
              "1623": {
                "name": "Plains of Jarin",
                "level": 80,
                "coord": [
                  57005.3,
                  61354.4
                ],
                "bounds": [
                  [
                    56368.9,
                    61005.3
                  ],
                  [
                    56147,
                    61082
                  ],
                  [
                    56098.8,
                    61318.8
                  ],
                  [
                    56125,
                    61438.6
                  ],
                  [
                    56223.7,
                    61565.3
                  ],
                  [
                    56346.8,
                    61681.7
                  ],
                  [
                    56373.6,
                    61764.4
                  ],
                  [
                    56328.1,
                    61885.2
                  ],
                  [
                    56449.5,
                    61979
                  ],
                  [
                    56540.2,
                    61745.5
                  ],
                  [
                    57157.5,
                    61707
                  ],
                  [
                    57153.7,
                    61639.2
                  ],
                  [
                    57457.9,
                    61391.3
                  ],
                  [
                    57241.5,
                    61206.4
                  ],
                  [
                    57237.5,
                    61443.3
                  ],
                  [
                    57147.9,
                    61563
                  ],
                  [
                    56938.1,
                    61558
                  ],
                  [
                    56846.8,
                    61456.3
                  ],
                  [
                    56841.3,
                    61203.3
                  ],
                  [
                    56916.6,
                    61113.9
                  ],
                  [
                    57159.5,
                    61112.9
                  ],
                  [
                    57241.1,
                    61206.8
                  ],
                  [
                    57457,
                    61391.7
                  ],
                  [
                    57639.5,
                    61623.9
                  ],
                  [
                    57942.3,
                    61613.5
                  ],
                  [
                    58020.1,
                    61547.3
                  ],
                  [
                    57821.5,
                    61382.6
                  ],
                  [
                    57695.1,
                    61231.3
                  ],
                  [
                    57719.5,
                    61051.9
                  ],
                  [
                    57479,
                    61025.2
                  ],
                  [
                    57331,
                    60970.8
                  ],
                  [
                    57179.6,
                    60826.8
                  ],
                  [
                    57026.7,
                    60852.2
                  ],
                  [
                    56874.6,
                    60875
                  ],
                  [
                    56660.1,
                    60943.5
                  ],
                  [
                    56368.9,
                    61005.3
                  ]
                ],
                "id": 1623,
                "chat_link": "[&BFcGAAA=]"
              }
            },
            "adventures": [],
            "id": 1263,
            "mastery_points": [
              {
                "coord": [
                  56190.1,
                  62350.8
                ],
                "id": 421,
                "region": "Desert"
              },
              {
                "coord": [
                  57937.3,
                  62335.7
                ],
                "id": 419,
                "region": "Desert"
              },
              {
                "coord": [
                  56595,
                  60690
                ],
                "id": 425,
                "region": "Desert"
              }
            ]
          },
          "1268": {
            "name": "Fahranur, the First City",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              52968,
              62134
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                52304,
                61488
              ],
              [
                53584,
                62768
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1599": {
                "name": "Eternal Reservoir",
                "level": 80,
                "coord": [
                  53175.1,
                  62117.4
                ],
                "bounds": [
                  [
                    52969.4,
                    62052.5
                  ],
                  [
                    52964.3,
                    62152
                  ],
                  [
                    52995.6,
                    62260.2
                  ],
                  [
                    53051.9,
                    62310.3
                  ],
                  [
                    53195.7,
                    62289
                  ],
                  [
                    53224.1,
                    62213.6
                  ],
                  [
                    53225.5,
                    62173.9
                  ],
                  [
                    53234.9,
                    62159.4
                  ],
                  [
                    53257.8,
                    62141
                  ],
                  [
                    53274.7,
                    62091.9
                  ],
                  [
                    53269,
                    62066.3
                  ],
                  [
                    53271.3,
                    62044.9
                  ],
                  [
                    53292,
                    62016.5
                  ],
                  [
                    53270,
                    61975.6
                  ],
                  [
                    53230.8,
                    61960.4
                  ],
                  [
                    53074.3,
                    61971.1
                  ],
                  [
                    52969.4,
                    62052.5
                  ]
                ],
                "id": 1599,
                "chat_link": "[&BD8GAAA=]"
              },
              "1601": {
                "name": "Hall of Hadoon",
                "level": 80,
                "coord": [
                  52678.9,
                  62481.4
                ],
                "bounds": [
                  [
                    52727.9,
                    62655
                  ],
                  [
                    52684.7,
                    62662.9
                  ],
                  [
                    52684.2,
                    62741.5
                  ],
                  [
                    52564.4,
                    62744.3
                  ],
                  [
                    52563.2,
                    62611.3
                  ],
                  [
                    52469.1,
                    62604.3
                  ],
                  [
                    52469.9,
                    62493.2
                  ],
                  [
                    52356.9,
                    62484.9
                  ],
                  [
                    52357,
                    62364
                  ],
                  [
                    52622,
                    62352.3
                  ],
                  [
                    52729.4,
                    62359.5
                  ],
                  [
                    52756.5,
                    62310.5
                  ],
                  [
                    52901.8,
                    62170.4
                  ],
                  [
                    52995.8,
                    62260.1
                  ],
                  [
                    52900,
                    62370.8
                  ],
                  [
                    52839.4,
                    62378.8
                  ],
                  [
                    52732.9,
                    62454.6
                  ],
                  [
                    52713.8,
                    62474.1
                  ],
                  [
                    52665.4,
                    62474.6
                  ],
                  [
                    52664.9,
                    62517.4
                  ],
                  [
                    52768,
                    62526.9
                  ],
                  [
                    52768.2,
                    62579.3
                  ],
                  [
                    52727.9,
                    62655
                  ]
                ],
                "id": 1601,
                "chat_link": "[&BEEGAAA=]"
              },
              "1603": {
                "name": "Nadijeh's Assembly",
                "level": 80,
                "coord": [
                  52474.8,
                  61870.3
                ],
                "bounds": [
                  [
                    52442.5,
                    62029.1
                  ],
                  [
                    52369.4,
                    61985.5
                  ],
                  [
                    52356.2,
                    61892.2
                  ],
                  [
                    52371.5,
                    61786.6
                  ],
                  [
                    52517.9,
                    61745.2
                  ],
                  [
                    52588.2,
                    61745.7
                  ],
                  [
                    52584.4,
                    61876
                  ],
                  [
                    52568.2,
                    61902.3
                  ],
                  [
                    52442.5,
                    62029.1
                  ]
                ],
                "id": 1603,
                "chat_link": "[&BEMGAAA=]"
              },
              "1608": {
                "name": "Jokanur Passage",
                "level": 80,
                "coord": [
                  53289.8,
                  62005.6
                ],
                "bounds": [
                  [
                    53096.1,
                    61688.3
                  ],
                  [
                    53196.1,
                    61630.1
                  ],
                  [
                    53327.6,
                    61612.3
                  ],
                  [
                    53436.7,
                    61654.7
                  ],
                  [
                    53489,
                    61744.7
                  ],
                  [
                    53519.9,
                    61876.2
                  ],
                  [
                    53543.6,
                    62037.9
                  ],
                  [
                    53486.4,
                    62116
                  ],
                  [
                    53343.2,
                    62123.1
                  ],
                  [
                    53366.6,
                    62324.8
                  ],
                  [
                    53239.6,
                    62334.7
                  ],
                  [
                    53195.3,
                    62288.8
                  ],
                  [
                    53223.7,
                    62213.5
                  ],
                  [
                    53225,
                    62173.6
                  ],
                  [
                    53234.5,
                    62159.1
                  ],
                  [
                    53257.3,
                    62140.9
                  ],
                  [
                    53274.2,
                    62091.8
                  ],
                  [
                    53268.6,
                    62066.3
                  ],
                  [
                    53270.9,
                    62044.9
                  ],
                  [
                    53291.5,
                    62016.5
                  ],
                  [
                    53269.5,
                    61976.2
                  ],
                  [
                    53230.6,
                    61961.1
                  ],
                  [
                    53074.2,
                    61971.7
                  ],
                  [
                    53094.2,
                    61886.8
                  ],
                  [
                    53096.1,
                    61688.3
                  ]
                ],
                "id": 1608,
                "chat_link": "[&BEgGAAA=]"
              },
              "1611": {
                "name": "Secret Entrance",
                "level": 80,
                "coord": [
                  53396.2,
                  62410.6
                ],
                "bounds": [
                  [
                    53366.2,
                    62324.4
                  ],
                  [
                    53533.2,
                    62411.4
                  ],
                  [
                    53542.6,
                    62491.5
                  ],
                  [
                    53299.3,
                    62491.4
                  ],
                  [
                    53239.5,
                    62334.2
                  ],
                  [
                    53366.2,
                    62324.4
                  ]
                ],
                "id": 1611,
                "chat_link": "[&BEsGAAA=]"
              },
              "1612": {
                "name": "The Royal Chamber",
                "level": 80,
                "coord": [
                  52878.1,
                  62540.8
                ],
                "bounds": [
                  [
                    52815.4,
                    62741.8
                  ],
                  [
                    52727.4,
                    62655.1
                  ],
                  [
                    52767.9,
                    62579.4
                  ],
                  [
                    52767.8,
                    62526.9
                  ],
                  [
                    52732.6,
                    62454.4
                  ],
                  [
                    52838.8,
                    62378.6
                  ],
                  [
                    52900,
                    62370.4
                  ],
                  [
                    52969.4,
                    62380.5
                  ],
                  [
                    53082.6,
                    62503
                  ],
                  [
                    53084.9,
                    62625.2
                  ],
                  [
                    52973,
                    62734
                  ],
                  [
                    52815.4,
                    62741.8
                  ]
                ],
                "id": 1612,
                "chat_link": "[&BEwGAAA=]"
              },
              "1620": {
                "name": "Elswyth's Gallery",
                "level": 80,
                "coord": [
                  52707.5,
                  62119.4
                ],
                "bounds": [
                  [
                    52756.7,
                    62310.8
                  ],
                  [
                    52695.8,
                    62267.5
                  ],
                  [
                    52637.9,
                    62298.4
                  ],
                  [
                    52442,
                    62028.9
                  ],
                  [
                    52568.3,
                    61902.1
                  ],
                  [
                    52641.9,
                    61955.9
                  ],
                  [
                    52754.1,
                    62023.5
                  ],
                  [
                    52860.2,
                    62082.5
                  ],
                  [
                    52815.9,
                    62153.9
                  ],
                  [
                    52901.8,
                    62170.7
                  ],
                  [
                    52756.7,
                    62310.8
                  ]
                ],
                "id": 1620,
                "chat_link": "[&BFQGAAA=]"
              },
              "1621": {
                "name": "Vestibule of Faith",
                "level": 80,
                "coord": [
                  52743.4,
                  61787.1
                ],
                "bounds": [
                  [
                    52753.4,
                    61867.8
                  ],
                  [
                    52754.3,
                    62024.4
                  ],
                  [
                    52641.7,
                    61956.2
                  ],
                  [
                    52617.7,
                    61762.8
                  ],
                  [
                    52587.9,
                    61746.3
                  ],
                  [
                    52517.9,
                    61745.8
                  ],
                  [
                    52312.9,
                    61758.8
                  ],
                  [
                    52310.2,
                    61579.7
                  ],
                  [
                    52778.5,
                    61579.6
                  ],
                  [
                    52778.3,
                    61760.1
                  ],
                  [
                    53064.2,
                    61753.6
                  ],
                  [
                    53096.4,
                    61687.7
                  ],
                  [
                    53094.5,
                    61887.2
                  ],
                  [
                    53064.1,
                    61852.9
                  ],
                  [
                    52778.8,
                    61844.4
                  ],
                  [
                    52753.4,
                    61867.8
                  ]
                ],
                "id": 1621,
                "chat_link": "[&BFUGAAA=]"
              }
            },
            "adventures": [],
            "id": 1268,
            "mastery_points": []
          },
          "1209": {
            "name": "The Sacrifice",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              60176,
              41440
            ],
            "map_rect": [
              [
                -61440,
                -30720
              ],
              [
                61440,
                30720
              ]
            ],
            "continent_rect": [
              [
                57256,
                39744
              ],
              [
                62376,
                42304
              ]
            ],
            "points_of_interest": {
              "2594": {
                "name": "Awakened Garrison",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60268.4,
                  41275.8
                ],
                "id": 2594,
                "chat_link": "[&BCIKAAA=]"
              },
              "2647": {
                "name": "Makali Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60786.1,
                  42043.7
                ],
                "id": 2647,
                "chat_link": "[&BFcKAAA=]"
              },
              "2703": {
                "name": "Kanuz Cache",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59963.4,
                  41839.5
                ],
                "id": 2703,
                "chat_link": "[&BI8KAAA=]"
              },
              "2734": {
                "name": "Giant's Tea Table",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60539.8,
                  41575.1
                ],
                "id": 2734,
                "chat_link": "[&BK4KAAA=]"
              },
              "2800": {
                "name": "Godfall Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60098.2,
                  41628.8
                ],
                "id": 2800,
                "chat_link": "[&BPAKAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1527": {
                "name": "Diviner's Reach",
                "level": 80,
                "coord": [
                  60740.6,
                  42045.8
                ],
                "bounds": [
                  [
                    61100.9,
                    42308.1
                  ],
                  [
                    60713.2,
                    42392.1
                  ],
                  [
                    60121.8,
                    42211.6
                  ],
                  [
                    60486,
                    41901.8
                  ],
                  [
                    60760.7,
                    41778
                  ],
                  [
                    61007,
                    41801.7
                  ],
                  [
                    60994.8,
                    41927.3
                  ],
                  [
                    61100.9,
                    42308.1
                  ]
                ],
                "id": 1527,
                "chat_link": "[&BPcFAAA=]"
              },
              "1535": {
                "name": "Brightwater Inlet",
                "level": 80,
                "coord": [
                  59127,
                  41605.4
                ],
                "bounds": [
                  [
                    59879.9,
                    42280
                  ],
                  [
                    59866.4,
                    41983.4
                  ],
                  [
                    59790.1,
                    41750.9
                  ],
                  [
                    59655.7,
                    41630.5
                  ],
                  [
                    59592.7,
                    41476.5
                  ],
                  [
                    59493.8,
                    41182.9
                  ],
                  [
                    59156.2,
                    41116.4
                  ],
                  [
                    59037,
                    41175.4
                  ],
                  [
                    58961,
                    41164
                  ],
                  [
                    58864.1,
                    41367.1
                  ],
                  [
                    58574.1,
                    41445.8
                  ],
                  [
                    58398.7,
                    41576.4
                  ],
                  [
                    58232.2,
                    41911.9
                  ],
                  [
                    58275.6,
                    42413.8
                  ],
                  [
                    59879.9,
                    42280
                  ]
                ],
                "id": 1535,
                "chat_link": "[&BP8FAAA=]"
              },
              "1574": {
                "name": "Salt Flats",
                "level": 80,
                "coord": [
                  60221,
                  41450.8
                ],
                "bounds": [
                  [
                    61006.8,
                    41800.9
                  ],
                  [
                    60985.5,
                    41533.5
                  ],
                  [
                    60973.6,
                    41366.4
                  ],
                  [
                    60831.2,
                    41199.1
                  ],
                  [
                    60671.3,
                    41142.8
                  ],
                  [
                    60551.2,
                    41129.5
                  ],
                  [
                    60381.3,
                    41082.5
                  ],
                  [
                    60217.2,
                    40990.6
                  ],
                  [
                    60097.3,
                    41048.1
                  ],
                  [
                    59937.2,
                    41023.8
                  ],
                  [
                    59796.5,
                    40898.2
                  ],
                  [
                    59547.6,
                    41057.1
                  ],
                  [
                    59493.5,
                    41183.4
                  ],
                  [
                    59592.8,
                    41477.1
                  ],
                  [
                    59655.3,
                    41630.7
                  ],
                  [
                    59788.9,
                    41749
                  ],
                  [
                    59865.7,
                    41982.5
                  ],
                  [
                    59880.2,
                    42280.7
                  ],
                  [
                    60121.8,
                    42211.7
                  ],
                  [
                    60485.8,
                    41901.9
                  ],
                  [
                    60760.6,
                    41777.6
                  ],
                  [
                    61006.8,
                    41800.9
                  ]
                ],
                "id": 1574,
                "chat_link": "[&BCYGAAA=]"
              }
            },
            "adventures": [],
            "id": 1209,
            "mastery_points": []
          },
          "1210": {
            "name": "Crystal Oasis",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              59968,
              43534
            ],
            "map_rect": [
              [
                -61440,
                -30720
              ],
              [
                61440,
                30720
              ]
            ],
            "continent_rect": [
              [
                57256,
                42304
              ],
              [
                62376,
                44864
              ]
            ],
            "points_of_interest": {
              "2552": {
                "name": "Sanctum of Nabkha",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61011.6,
                  44491.6
                ],
                "id": 2552,
                "chat_link": "[&BPgJAAA=]"
              },
              "2564": {
                "name": "Marifa Refugee Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59234.2,
                  44140.4
                ],
                "id": 2564,
                "chat_link": "[&BAQKAAA=]"
              },
              "2566": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58346.9,
                  43131.7
                ],
                "id": 2566,
                "chat_link": "[&BAYKAAA=]"
              },
              "2568": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  59934.1,
                  43807.1
                ],
                "id": 2568,
                "chat_link": "[&BAgKAAA=]"
              },
              "2580": {
                "name": "Altar of the Six Gods",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58125.8,
                  44015.9
                ],
                "id": 2580,
                "chat_link": "[&BBQKAAA=]"
              },
              "2584": {
                "name": "Squaross Kraal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62187.8,
                  43689.3
                ],
                "id": 2584,
                "chat_link": "[&BBgKAAA=]"
              },
              "2591": {
                "name": "Amnoon Water Authority",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58716.4,
                  44460.4
                ],
                "id": 2591,
                "chat_link": "[&BB8KAAA=]"
              },
              "2592": {
                "name": "Old Amnoon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57534.8,
                  43748.4
                ],
                "id": 2592,
                "chat_link": "[&BCAKAAA=]"
              },
              "2593": {
                "name": "Tomb of the Abandoned",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58063.4,
                  42750
                ],
                "id": 2593,
                "chat_link": "[&BCEKAAA=]"
              },
              "2598": {
                "name": "The Teratohedron",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61858.9,
                  42851.2
                ],
                "id": 2598,
                "chat_link": "[&BCYKAAA=]"
              },
              "2599": {
                "name": "Tawla Rock",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57615.6,
                  43164.3
                ],
                "id": 2599,
                "chat_link": "[&BCcKAAA=]"
              },
              "2606": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  61707.8,
                  43900.4
                ],
                "id": 2606,
                "chat_link": "[&BC4KAAA=]"
              },
              "2610": {
                "name": "Kusini Water Hole",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60412.3,
                  44193.9
                ],
                "id": 2610,
                "chat_link": "[&BDIKAAA=]"
              },
              "2616": {
                "name": "Temple of Atar",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59864.6,
                  42526.5
                ],
                "id": 2616,
                "chat_link": "[&BDgKAAA=]"
              },
              "2624": {
                "name": "Temple of Kormir Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60972.9,
                  43251.6
                ],
                "id": 2624,
                "chat_link": "[&BEAKAAA=]"
              },
              "2629": {
                "name": "Fortunate Strike",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62089.9,
                  43952.2
                ],
                "id": 2629,
                "chat_link": "[&BEUKAAA=]"
              },
              "2630": {
                "name": "Seeker's Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58485.6,
                  42980.6
                ],
                "id": 2630,
                "chat_link": "[&BEYKAAA=]"
              },
              "2631": {
                "name": "Grand Sahil Casino",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58383.5,
                  44039.7
                ],
                "id": 2631,
                "chat_link": "[&BEcKAAA=]"
              },
              "2632": {
                "name": "Mount: Raptor",
                "type": "unlock",
                "floor": 1,
                "coord": [
                  58472.6,
                  43052.5
                ],
                "id": 2632,
                "chat_link": "[&BEgKAAA=]",
                "icon": "https://render.guildwars2.com/file/13A0A3055F9BD4AF7F2AC26F3907B0B35DA1DDE2/1770701.png"
              },
              "2636": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58973.9,
                  42872
                ],
                "id": 2636,
                "chat_link": "[&BEwKAAA=]"
              },
              "2641": {
                "name": "Zephyr's Trace",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61584.8,
                  44028.3
                ],
                "id": 2641,
                "chat_link": "[&BFEKAAA=]"
              },
              "2651": {
                "name": "Altar of Silence",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60234.1,
                  42665.2
                ],
                "id": 2651,
                "chat_link": "[&BFsKAAA=]"
              },
              "2652": {
                "name": "Shattered Templar",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59490.8,
                  43198.1
                ],
                "id": 2652,
                "chat_link": "[&BFwKAAA=]"
              },
              "2655": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  61475.1,
                  42898.1
                ],
                "id": 2655,
                "chat_link": "[&BF8KAAA=]"
              },
              "2656": {
                "name": "Crucible of Consecration",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61572.9,
                  43423.5
                ],
                "id": 2656,
                "chat_link": "[&BGAKAAA=]"
              },
              "2677": {
                "name": "Temple of Kormir",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60961.8,
                  43368.5
                ],
                "id": 2677,
                "chat_link": "[&BHUKAAA=]"
              },
              "2678": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60028.3,
                  43169
                ],
                "id": 2678,
                "chat_link": "[&BHYKAAA=]"
              },
              "2684": {
                "name": "Amnoon Cavalier Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58697.4,
                  43850.5
                ],
                "id": 2684,
                "chat_link": "[&BHwKAAA=]"
              },
              "2688": {
                "name": "Amnoon Civic Center",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58269,
                  43628.3
                ],
                "id": 2688,
                "chat_link": "[&BIAKAAA=]"
              },
              "2692": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57989.4,
                  43898.6
                ],
                "id": 2692,
                "chat_link": "[&BIQKAAA=]"
              },
              "2707": {
                "name": "Destiny's Gorge Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  61588.6,
                  44187.2
                ],
                "id": 2707,
                "chat_link": "[&BJMKAAA=]"
              },
              "2708": {
                "name": "Northern Way Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60118,
                  43221.6
                ],
                "id": 2708,
                "chat_link": "[&BJQKAAA=]"
              },
              "2711": {
                "name": "Amnoon Harbor",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58164.4,
                  43755.5
                ],
                "id": 2711,
                "chat_link": "[&BJcKAAA=]"
              },
              "2732": {
                "name": "Southern Way Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60415.1,
                  44009.7
                ],
                "id": 2732,
                "chat_link": "[&BKwKAAA=]"
              },
              "2742": {
                "name": "The Empty Quarter",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58218.6,
                  43294.3
                ],
                "id": 2742,
                "chat_link": "[&BLYKAAA=]"
              },
              "2746": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58596.8,
                  43937.3
                ],
                "id": 2746,
                "chat_link": "[&BLoKAAA=]"
              },
              "2747": {
                "name": "Amnoon Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  58615.4,
                  43742.9
                ],
                "id": 2747,
                "chat_link": "[&BLsKAAA=]"
              },
              "2751": {
                "name": "Amnoon Bazaar",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58989.6,
                  43751.8
                ],
                "id": 2751,
                "chat_link": "[&BL8KAAA=]"
              },
              "2757": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60698.1,
                  43156.2
                ],
                "id": 2757,
                "chat_link": "[&BMUKAAA=]"
              },
              "2784": {
                "name": "Amnoon Emporium",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58378.9,
                  43740.1
                ],
                "id": 2784,
                "chat_link": "[&BOAKAAA=]"
              },
              "2785": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60172.6,
                  42837.3
                ],
                "id": 2785,
                "chat_link": "[&BOEKAAA=]"
              },
              "2787": {
                "name": "Retreat of the Resolute",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60118.6,
                  43757
                ],
                "id": 2787,
                "chat_link": "[&BOMKAAA=]"
              },
              "2789": {
                "name": "Village of Kweli",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60948.4,
                  43005.6
                ],
                "id": 2789,
                "chat_link": "[&BOUKAAA=]"
              },
              "2793": {
                "name": "Talatat Quarry",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58904.3,
                  42605.9
                ],
                "id": 2793,
                "chat_link": "[&BOkKAAA=]"
              }
            },
            "tasks": {
              "387": {
                "objective": "Give aid to the refugees at Marifa Camp.",
                "level": 80,
                "coord": [
                  59259,
                  44140.3
                ],
                "bounds": [
                  [
                    59618.8,
                    43887
                  ],
                  [
                    59366.5,
                    43923.3
                  ],
                  [
                    59017.9,
                    44087
                  ],
                  [
                    58877,
                    44196.7
                  ],
                  [
                    58963,
                    44356
                  ],
                  [
                    59115.7,
                    44418.9
                  ],
                  [
                    59310.2,
                    44415.5
                  ],
                  [
                    59558.7,
                    44309.7
                  ],
                  [
                    59650.6,
                    44149.6
                  ],
                  [
                    59618.8,
                    43887
                  ]
                ],
                "id": 387,
                "chat_link": "[&BIMBAAA=]"
              },
              "406": {
                "objective": "Help Aksim care for and train raptors.",
                "level": 80,
                "coord": [
                  58473.4,
                  43025.1
                ],
                "bounds": [
                  [
                    58238.1,
                    43120.1
                  ],
                  [
                    58364.8,
                    42545.7
                  ],
                  [
                    58475.9,
                    42430
                  ],
                  [
                    58734.3,
                    42375.9
                  ],
                  [
                    58767.1,
                    42730.9
                  ],
                  [
                    58733.7,
                    43003.6
                  ],
                  [
                    58665.5,
                    43122.3
                  ],
                  [
                    58469.4,
                    43138.8
                  ],
                  [
                    58238.1,
                    43120.1
                  ]
                ],
                "id": 406,
                "chat_link": "[&BJYBAAA=]"
              },
              "411": {
                "objective": "Aid the villagers of Zephyr's Trace.",
                "level": 80,
                "coord": [
                  61548.1,
                  44114.9
                ],
                "bounds": [
                  [
                    61606.7,
                    44060.4
                  ],
                  [
                    60222.4,
                    43584
                  ],
                  [
                    61606.7,
                    44060.4
                  ]
                ],
                "id": 411,
                "chat_link": "[&BJsBAAA=]"
              },
              "413": {
                "objective": "Aid the Temple of Kormir.",
                "level": 80,
                "coord": [
                  60977.9,
                  43401.9
                ],
                "bounds": [
                  [
                    60754.3,
                    43571.3
                  ],
                  [
                    60840.2,
                    43120
                  ],
                  [
                    60754.3,
                    42919.7
                  ],
                  [
                    61177.1,
                    42902.8
                  ],
                  [
                    61172.7,
                    43081
                  ],
                  [
                    61177.1,
                    43571.3
                  ],
                  [
                    60754.3,
                    43571.3
                  ]
                ],
                "id": 413,
                "chat_link": "[&BJ0BAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  59411.2,
                  42953.6
                ],
                "id": "2-0"
              },
              {
                "coord": [
                  61880.5,
                  42829.3
                ],
                "id": "2-4"
              },
              {
                "coord": [
                  60262.4,
                  42652
                ],
                "id": "2-3"
              },
              {
                "coord": [
                  59015.7,
                  44685.5
                ],
                "id": "2-1"
              },
              {
                "coord": [
                  58349.9,
                  42464.6
                ],
                "id": "2-2"
              }
            ],
            "sectors": {
              "1487": {
                "name": "Elona Reach",
                "level": 80,
                "coord": [
                  61076.1,
                  43543.8
                ],
                "bounds": [
                  [
                    60787.1,
                    43983.5
                  ],
                  [
                    60903.9,
                    44046.1
                  ],
                  [
                    61022,
                    44124.6
                  ],
                  [
                    61172.3,
                    44085.7
                  ],
                  [
                    61334.5,
                    43978.1
                  ],
                  [
                    61282.2,
                    43809.8
                  ],
                  [
                    61396.7,
                    43734.9
                  ],
                  [
                    61328.8,
                    43567.8
                  ],
                  [
                    61346.4,
                    43306.4
                  ],
                  [
                    61446.9,
                    43219.1
                  ],
                  [
                    61434.5,
                    43011.4
                  ],
                  [
                    61162.3,
                    42972.7
                  ],
                  [
                    61009.9,
                    42954.2
                  ],
                  [
                    60667.1,
                    42901.9
                  ],
                  [
                    60638.2,
                    43156.9
                  ],
                  [
                    60638.9,
                    43572.9
                  ],
                  [
                    60721.7,
                    43819.2
                  ],
                  [
                    60787.1,
                    43983.5
                  ]
                ],
                "id": 1487,
                "chat_link": "[&BM8FAAA=]"
              },
              "1491": {
                "name": "Amnoon Southern Outskirts",
                "level": 80,
                "coord": [
                  59327.2,
                  44396.2
                ],
                "bounds": [
                  [
                    58096.1,
                    44749.6
                  ],
                  [
                    59971.4,
                    44841.5
                  ],
                  [
                    60127.4,
                    44692.7
                  ],
                  [
                    60148,
                    44396.4
                  ],
                  [
                    59974.2,
                    44205.6
                  ],
                  [
                    59905.2,
                    44301.1
                  ],
                  [
                    59708.3,
                    44384.8
                  ],
                  [
                    59312.2,
                    44375.1
                  ],
                  [
                    59185.6,
                    44286.7
                  ],
                  [
                    59001.6,
                    44289
                  ],
                  [
                    58874.9,
                    44256.1
                  ],
                  [
                    58726.8,
                    44196
                  ],
                  [
                    58221.3,
                    44176.4
                  ],
                  [
                    58096.1,
                    44749.6
                  ]
                ],
                "id": 1491,
                "chat_link": "[&BNMFAAA=]"
              },
              "1496": {
                "name": "The Sinking Ruins",
                "level": 80,
                "coord": [
                  58178.9,
                  42862
                ],
                "bounds": [
                  [
                    57581.1,
                    42885.2
                  ],
                  [
                    57839.5,
                    43065.6
                  ],
                  [
                    57885.6,
                    43274.3
                  ],
                  [
                    58043.1,
                    43244.8
                  ],
                  [
                    58093.1,
                    43115.8
                  ],
                  [
                    58283.4,
                    43126.4
                  ],
                  [
                    58379.4,
                    43159.1
                  ],
                  [
                    58431.6,
                    43204.6
                  ],
                  [
                    58540.1,
                    43207.6
                  ],
                  [
                    58748.2,
                    43251
                  ],
                  [
                    58726.1,
                    42946.7
                  ],
                  [
                    58641,
                    42796.1
                  ],
                  [
                    58560.2,
                    42673.2
                  ],
                  [
                    58472.2,
                    42687
                  ],
                  [
                    58463,
                    42508.6
                  ],
                  [
                    58339.3,
                    42458.8
                  ],
                  [
                    58345.8,
                    42326.3
                  ],
                  [
                    57410.1,
                    42210.4
                  ],
                  [
                    57314.6,
                    42504.7
                  ],
                  [
                    57480.7,
                    42594.3
                  ],
                  [
                    57581.1,
                    42885.2
                  ]
                ],
                "id": 1496,
                "chat_link": "[&BNgFAAA=]"
              },
              "1498": {
                "name": "Maculate Fringe",
                "level": 80,
                "coord": [
                  61833,
                  42890.1
                ],
                "bounds": [
                  [
                    61768.2,
                    43272
                  ],
                  [
                    61950.1,
                    43317.7
                  ],
                  [
                    62348.7,
                    43263.5
                  ],
                  [
                    62329.7,
                    42507.8
                  ],
                  [
                    62260.9,
                    42384.8
                  ],
                  [
                    62139,
                    42344.6
                  ],
                  [
                    61407.6,
                    42374.7
                  ],
                  [
                    61522.7,
                    42815.3
                  ],
                  [
                    61433.7,
                    43011.4
                  ],
                  [
                    61446,
                    43219.6
                  ],
                  [
                    61556.3,
                    43280.3
                  ],
                  [
                    61768.2,
                    43272
                  ]
                ],
                "id": 1498,
                "chat_link": "[&BNoFAAA=]"
              },
              "1499": {
                "name": "Destiny's Gorge",
                "level": 80,
                "coord": [
                  61680.6,
                  44110
                ],
                "bounds": [
                  [
                    61395.3,
                    44842
                  ],
                  [
                    61839.4,
                    44794.7
                  ],
                  [
                    61815.9,
                    44425.4
                  ],
                  [
                    61904.2,
                    44305.3
                  ],
                  [
                    61799.7,
                    44182.2
                  ],
                  [
                    61791.3,
                    44061.1
                  ],
                  [
                    61939.5,
                    43983.1
                  ],
                  [
                    61978.3,
                    43845.3
                  ],
                  [
                    62060.1,
                    43797.1
                  ],
                  [
                    61992.6,
                    43702.5
                  ],
                  [
                    61740.1,
                    43863.3
                  ],
                  [
                    61632.8,
                    43702.2
                  ],
                  [
                    61396.8,
                    43735.3
                  ],
                  [
                    61282.8,
                    43809.2
                  ],
                  [
                    61335.1,
                    43978.4
                  ],
                  [
                    61449.8,
                    44035.6
                  ],
                  [
                    61496.5,
                    44324.6
                  ],
                  [
                    61401.2,
                    44593.5
                  ],
                  [
                    61395.3,
                    44842
                  ]
                ],
                "id": 1499,
                "chat_link": "[&BNsFAAA=]"
              },
              "1506": {
                "name": "Destiny's Ascent",
                "level": 80,
                "coord": [
                  62124.7,
                  43613.6
                ],
                "bounds": [
                  [
                    61988.5,
                    43479.4
                  ],
                  [
                    62020.6,
                    43611.6
                  ],
                  [
                    61993.1,
                    43703.2
                  ],
                  [
                    62059.9,
                    43797.2
                  ],
                  [
                    62160.6,
                    43781.6
                  ],
                  [
                    62265.5,
                    43796.9
                  ],
                  [
                    62334,
                    43772.8
                  ],
                  [
                    62350.3,
                    43263.3
                  ],
                  [
                    61950.2,
                    43316
                  ],
                  [
                    61988.5,
                    43479.4
                  ]
                ],
                "id": 1506,
                "chat_link": "[&BOIFAAA=]"
              },
              "1513": {
                "name": "Amnoon Farms",
                "level": 80,
                "coord": [
                  59399.2,
                  43837.4
                ],
                "bounds": [
                  [
                    58847,
                    43967.8
                  ],
                  [
                    58962.8,
                    44046.4
                  ],
                  [
                    58981.7,
                    44123.4
                  ],
                  [
                    58942.7,
                    44174.3
                  ],
                  [
                    58874.5,
                    44256.1
                  ],
                  [
                    59001.8,
                    44288.8
                  ],
                  [
                    59185.7,
                    44286.3
                  ],
                  [
                    59312.2,
                    44375
                  ],
                  [
                    59707.4,
                    44388.4
                  ],
                  [
                    59905.5,
                    44301.3
                  ],
                  [
                    59974.5,
                    44205
                  ],
                  [
                    60062.7,
                    44104.1
                  ],
                  [
                    60000.9,
                    43888.5
                  ],
                  [
                    59929.6,
                    43838.9
                  ],
                  [
                    59902,
                    43733.6
                  ],
                  [
                    59792.9,
                    43698.2
                  ],
                  [
                    59636.8,
                    43647.5
                  ],
                  [
                    59544.6,
                    43595.5
                  ],
                  [
                    59485.5,
                    43477.5
                  ],
                  [
                    59384.8,
                    43408.6
                  ],
                  [
                    59314.6,
                    43334.6
                  ],
                  [
                    59299.4,
                    43221.4
                  ],
                  [
                    59086.8,
                    43104.8
                  ],
                  [
                    58982.4,
                    43173.8
                  ],
                  [
                    58860.4,
                    43296.4
                  ],
                  [
                    58847,
                    43967.8
                  ]
                ],
                "id": 1513,
                "chat_link": "[&BOkFAAA=]"
              },
              "1521": {
                "name": "Sifuri Sand Sea",
                "level": 80,
                "coord": [
                  59625.8,
                  42917.1
                ],
                "bounds": [
                  [
                    59087.1,
                    42812.1
                  ],
                  [
                    59105.6,
                    43013.3
                  ],
                  [
                    59085.1,
                    43104.3
                  ],
                  [
                    59300.3,
                    43221.3
                  ],
                  [
                    59315.8,
                    43333.9
                  ],
                  [
                    59385.3,
                    43408.7
                  ],
                  [
                    59486.9,
                    43479
                  ],
                  [
                    59632.9,
                    43440.4
                  ],
                  [
                    59678.5,
                    43342.5
                  ],
                  [
                    59744.2,
                    43250.8
                  ],
                  [
                    59884.4,
                    43207.5
                  ],
                  [
                    59884.3,
                    43064.7
                  ],
                  [
                    59937.2,
                    42939.1
                  ],
                  [
                    60019.2,
                    42919
                  ],
                  [
                    60043.3,
                    42863.6
                  ],
                  [
                    59937.6,
                    42840.9
                  ],
                  [
                    59907.1,
                    42762.9
                  ],
                  [
                    59845.8,
                    42758.9
                  ],
                  [
                    59810.3,
                    42654.6
                  ],
                  [
                    59821.8,
                    42623.6
                  ],
                  [
                    59797.2,
                    42588.3
                  ],
                  [
                    59776.9,
                    42526
                  ],
                  [
                    59812.1,
                    42476.6
                  ],
                  [
                    59737.2,
                    42326.1
                  ],
                  [
                    59058.2,
                    42321.6
                  ],
                  [
                    59177.6,
                    42564.6
                  ],
                  [
                    59087.1,
                    42812.1
                  ]
                ],
                "id": 1521,
                "chat_link": "[&BPEFAAA=]"
              },
              "1528": {
                "name": "Hatari Tablelands",
                "level": 80,
                "coord": [
                  60136.8,
                  42657.4
                ],
                "bounds": [
                  [
                    60270.7,
                    42857
                  ],
                  [
                    60373.8,
                    42829.8
                  ],
                  [
                    60509.8,
                    42894
                  ],
                  [
                    60669.2,
                    42902.6
                  ],
                  [
                    60636.3,
                    42665.9
                  ],
                  [
                    60517.9,
                    42570
                  ],
                  [
                    60469,
                    42508.2
                  ],
                  [
                    60463.5,
                    42245.2
                  ],
                  [
                    60127.4,
                    42205.2
                  ],
                  [
                    59736.6,
                    42326.1
                  ],
                  [
                    59811.9,
                    42476.6
                  ],
                  [
                    59776.9,
                    42526.1
                  ],
                  [
                    59797.4,
                    42588.5
                  ],
                  [
                    59821.8,
                    42623.5
                  ],
                  [
                    59805.4,
                    42658.6
                  ],
                  [
                    59846.5,
                    42759
                  ],
                  [
                    59907.1,
                    42762.9
                  ],
                  [
                    59937.9,
                    42840.6
                  ],
                  [
                    60042.7,
                    42862.3
                  ],
                  [
                    60141.9,
                    42834.9
                  ],
                  [
                    60209.8,
                    42868.1
                  ],
                  [
                    60270.7,
                    42857
                  ]
                ],
                "id": 1528,
                "chat_link": "[&BPgFAAA=]"
              },
              "1538": {
                "name": "Forged Foothold",
                "level": 80,
                "coord": [
                  61680.8,
                  43504.7
                ],
                "bounds": [
                  [
                    61632.8,
                    43703
                  ],
                  [
                    61740.5,
                    43862.7
                  ],
                  [
                    61993.4,
                    43702.7
                  ],
                  [
                    62022.1,
                    43612.6
                  ],
                  [
                    61987.6,
                    43478.7
                  ],
                  [
                    61950.4,
                    43317.1
                  ],
                  [
                    61768,
                    43271.8
                  ],
                  [
                    61557.7,
                    43279.2
                  ],
                  [
                    61447,
                    43219.8
                  ],
                  [
                    61345.5,
                    43306.9
                  ],
                  [
                    61328.8,
                    43567.8
                  ],
                  [
                    61396,
                    43734.3
                  ],
                  [
                    61632.8,
                    43703
                  ]
                ],
                "id": 1538,
                "chat_link": "[&BAIGAAA=]"
              },
              "1539": {
                "name": "Diviner's Passage",
                "level": 80,
                "coord": [
                  60929.4,
                  42701.4
                ],
                "bounds": [
                  [
                    61434.6,
                    43011.3
                  ],
                  [
                    61525.2,
                    42814
                  ],
                  [
                    61407.5,
                    42374.4
                  ],
                  [
                    60463.6,
                    42244.4
                  ],
                  [
                    60467.9,
                    42506.5
                  ],
                  [
                    60517.3,
                    42570.6
                  ],
                  [
                    60636.6,
                    42665.7
                  ],
                  [
                    60667.4,
                    42901.5
                  ],
                  [
                    61009.4,
                    42954.2
                  ],
                  [
                    61164.1,
                    42971.4
                  ],
                  [
                    61434.6,
                    43011.3
                  ]
                ],
                "id": 1539,
                "chat_link": "[&BAMGAAA=]"
              },
              "1542": {
                "name": "Mekele Bluffs",
                "level": 80,
                "coord": [
                  58777.2,
                  42794.7
                ],
                "bounds": [
                  [
                    58747.6,
                    43251.8
                  ],
                  [
                    58860.9,
                    43295.5
                  ],
                  [
                    58982.8,
                    43174.2
                  ],
                  [
                    59087.2,
                    43105.2
                  ],
                  [
                    59106.3,
                    43014
                  ],
                  [
                    59086.6,
                    42811.8
                  ],
                  [
                    59177.9,
                    42563.2
                  ],
                  [
                    59063.9,
                    42314.5
                  ],
                  [
                    58346.1,
                    42326.4
                  ],
                  [
                    58339.7,
                    42458.4
                  ],
                  [
                    58462.6,
                    42508.1
                  ],
                  [
                    58472,
                    42686.9
                  ],
                  [
                    58559.1,
                    42670.2
                  ],
                  [
                    58639.2,
                    42793.6
                  ],
                  [
                    58726.1,
                    42946.7
                  ],
                  [
                    58747.6,
                    43251.8
                  ]
                ],
                "id": 1542,
                "chat_link": "[&BAYGAAA=]"
              },
              "1550": {
                "name": "Kusini Crossing",
                "level": 80,
                "coord": [
                  60745,
                  44205.7
                ],
                "bounds": [
                  [
                    60290.4,
                    44698.1
                  ],
                  [
                    61394.2,
                    44841.6
                  ],
                  [
                    61401.9,
                    44591.9
                  ],
                  [
                    61496.7,
                    44326.7
                  ],
                  [
                    61450.5,
                    44035
                  ],
                  [
                    61334.9,
                    43977.8
                  ],
                  [
                    61172.7,
                    44085.1
                  ],
                  [
                    61021.7,
                    44124.6
                  ],
                  [
                    60904.2,
                    44045.5
                  ],
                  [
                    60785.9,
                    43982.5
                  ],
                  [
                    60721.5,
                    43819
                  ],
                  [
                    60519.9,
                    43926.3
                  ],
                  [
                    60342.7,
                    43860.5
                  ],
                  [
                    60262.5,
                    43991.5
                  ],
                  [
                    60061.3,
                    44101.6
                  ],
                  [
                    59974.4,
                    44205.5
                  ],
                  [
                    60147.7,
                    44396.5
                  ],
                  [
                    60127.4,
                    44692.8
                  ],
                  [
                    60290.4,
                    44698.1
                  ]
                ],
                "id": 1550,
                "chat_link": "[&BA4GAAA=]"
              },
              "1562": {
                "name": "Free City of Amnoon",
                "level": 80,
                "coord": [
                  58417.9,
                  43644.3
                ],
                "bounds": [
                  [
                    58220.8,
                    44176.2
                  ],
                  [
                    58727,
                    44196.1
                  ],
                  [
                    58874.5,
                    44256.1
                  ],
                  [
                    58942,
                    44173.4
                  ],
                  [
                    58980.9,
                    44123.6
                  ],
                  [
                    58962.3,
                    44046.2
                  ],
                  [
                    58847,
                    43967.2
                  ],
                  [
                    58860.9,
                    43295.6
                  ],
                  [
                    58747.8,
                    43250.8
                  ],
                  [
                    58539.8,
                    43207.2
                  ],
                  [
                    58430.7,
                    43204.8
                  ],
                  [
                    58379.3,
                    43159.2
                  ],
                  [
                    58284.1,
                    43126.7
                  ],
                  [
                    58093.3,
                    43115.7
                  ],
                  [
                    58043.3,
                    43245.2
                  ],
                  [
                    57885.9,
                    43274.9
                  ],
                  [
                    57887.5,
                    43407.1
                  ],
                  [
                    57828.3,
                    43644.2
                  ],
                  [
                    57823.3,
                    43846.7
                  ],
                  [
                    57999.4,
                    44168.3
                  ],
                  [
                    58220.8,
                    44176.2
                  ]
                ],
                "id": 1562,
                "chat_link": "[&BBoGAAA=]"
              },
              "1579": {
                "name": "Glint's Legacy",
                "level": 80,
                "coord": [
                  62032.5,
                  44204.7
                ],
                "bounds": [
                  [
                    61839.3,
                    44794.5
                  ],
                  [
                    62089.1,
                    44789
                  ],
                  [
                    62207.5,
                    44717.1
                  ],
                  [
                    62271.2,
                    44615.7
                  ],
                  [
                    62331.8,
                    43772.5
                  ],
                  [
                    62265.6,
                    43796.8
                  ],
                  [
                    62160.9,
                    43781.3
                  ],
                  [
                    62059.5,
                    43797.3
                  ],
                  [
                    61978,
                    43845.3
                  ],
                  [
                    61939.6,
                    43982.6
                  ],
                  [
                    61790.9,
                    44061.8
                  ],
                  [
                    61801.1,
                    44182
                  ],
                  [
                    61904.6,
                    44304.1
                  ],
                  [
                    61815.8,
                    44425.4
                  ],
                  [
                    61839.3,
                    44794.5
                  ]
                ],
                "id": 1579,
                "chat_link": "[&BCsGAAA=]"
              },
              "1581": {
                "name": "Omiramba Sand Sea",
                "level": 80,
                "coord": [
                  60088.7,
                  43376.1
                ],
                "bounds": [
                  [
                    60721.5,
                    43819.7
                  ],
                  [
                    60636.6,
                    43574.1
                  ],
                  [
                    60637.9,
                    43157.1
                  ],
                  [
                    60666.8,
                    42901.6
                  ],
                  [
                    60509.8,
                    42894.5
                  ],
                  [
                    60373.5,
                    42829.6
                  ],
                  [
                    60270.4,
                    42856.5
                  ],
                  [
                    60210.2,
                    42868.2
                  ],
                  [
                    60142.2,
                    42836
                  ],
                  [
                    60043.7,
                    42863.6
                  ],
                  [
                    60019.3,
                    42919.9
                  ],
                  [
                    59938,
                    42940.5
                  ],
                  [
                    59884.2,
                    43065.1
                  ],
                  [
                    59885.5,
                    43205.8
                  ],
                  [
                    59744.4,
                    43250.8
                  ],
                  [
                    59679.6,
                    43343.8
                  ],
                  [
                    59633.2,
                    43439.7
                  ],
                  [
                    59486.7,
                    43478.8
                  ],
                  [
                    59545,
                    43595.7
                  ],
                  [
                    59636.7,
                    43647.9
                  ],
                  [
                    59793.1,
                    43698.2
                  ],
                  [
                    59902.9,
                    43734
                  ],
                  [
                    59929.6,
                    43836.9
                  ],
                  [
                    60002,
                    43888.3
                  ],
                  [
                    60062.2,
                    44103.7
                  ],
                  [
                    60264.9,
                    43995
                  ],
                  [
                    60342.3,
                    43860.4
                  ],
                  [
                    60520.1,
                    43926
                  ],
                  [
                    60721.5,
                    43819.7
                  ]
                ],
                "id": 1581,
                "chat_link": "[&BC0GAAA=]"
              },
              "1590": {
                "name": "Bay of Elon",
                "level": 80,
                "coord": [
                  57754.6,
                  43661.3
                ],
                "bounds": [
                  [
                    58095.5,
                    44750.1
                  ],
                  [
                    58222.2,
                    44175.8
                  ],
                  [
                    57997.3,
                    44169.7
                  ],
                  [
                    57823.5,
                    43846.4
                  ],
                  [
                    57828.1,
                    43643.8
                  ],
                  [
                    57887.8,
                    43406.6
                  ],
                  [
                    57885.7,
                    43274.8
                  ],
                  [
                    57839.3,
                    43065.3
                  ],
                  [
                    57581.4,
                    42885.7
                  ],
                  [
                    57479.5,
                    42595.5
                  ],
                  [
                    57310.8,
                    42503.9
                  ],
                  [
                    57370.9,
                    44541.1
                  ],
                  [
                    57487.8,
                    44738.1
                  ],
                  [
                    58095.5,
                    44750.1
                  ]
                ],
                "id": 1590,
                "chat_link": "[&BDYGAAA=]"
              }
            },
            "adventures": [],
            "id": 1210,
            "mastery_points": [
              {
                "coord": [
                  59018.6,
                  43615.5
                ],
                "id": 391,
                "region": "Desert"
              },
              {
                "coord": [
                  59443.8,
                  42554.3
                ],
                "id": 380,
                "region": "Desert"
              },
              {
                "coord": [
                  57698.9,
                  43793.3
                ],
                "id": 361,
                "region": "Desert"
              },
              {
                "coord": [
                  62054.7,
                  44292.9
                ],
                "id": 349,
                "region": "Desert"
              },
              {
                "coord": [
                  61063.2,
                  44706
                ],
                "id": 386,
                "region": "Desert"
              },
              {
                "coord": [
                  58282.7,
                  43518.8
                ],
                "id": 333,
                "region": "Desert"
              },
              {
                "coord": [
                  57730,
                  44515.4
                ],
                "id": 355,
                "region": "Desert"
              },
              {
                "coord": [
                  60065.1,
                  42703.9
                ],
                "id": 409,
                "region": "Desert"
              }
            ]
          },
          "1211": {
            "name": "Desert Highlands",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              59968,
              41240
            ],
            "map_rect": [
              [
                -61440,
                -30720
              ],
              [
                61440,
                30720
              ]
            ],
            "continent_rect": [
              [
                57256,
                39744
              ],
              [
                62376,
                42304
              ]
            ],
            "points_of_interest": {
              "2556": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60162.6,
                  42042.2
                ],
                "id": 2556,
                "chat_link": "[&BPwJAAA=]"
              },
              "2557": {
                "name": "Sabkha Watchpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60360,
                  40972.9
                ],
                "id": 2557,
                "chat_link": "[&BP0JAAA=]"
              },
              "2565": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57734.3,
                  40796
                ],
                "id": 2565,
                "chat_link": "[&BAUKAAA=]"
              },
              "2569": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60153.5,
                  41583.6
                ],
                "id": 2569,
                "chat_link": "[&BAkKAAA=]"
              },
              "2573": {
                "name": "Standstill Lake",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58339.3,
                  39977.1
                ],
                "id": 2573,
                "chat_link": "[&BA0KAAA=]"
              },
              "2585": {
                "name": "Closed Passage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60797.2,
                  40008.5
                ],
                "id": 2585,
                "chat_link": "[&BBkKAAA=]"
              },
              "2594": {
                "name": "Awakened Garrison",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60268.4,
                  41275.8
                ],
                "id": 2594,
                "chat_link": "[&BCIKAAA=]"
              },
              "2595": {
                "name": "Highjump Ranch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59709.4,
                  40428
                ],
                "id": 2595,
                "chat_link": "[&BCMKAAA=]"
              },
              "2597": {
                "name": "Wayment Seep",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59486,
                  40091.5
                ],
                "id": 2597,
                "chat_link": "[&BCUKAAA=]"
              },
              "2601": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  59409,
                  40339.5
                ],
                "id": 2601,
                "chat_link": "[&BCkKAAA=]"
              },
              "2603": {
                "name": "Altar of Dakhma",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58262.4,
                  41034.8
                ],
                "id": 2603,
                "chat_link": "[&BCsKAAA=]"
              },
              "2613": {
                "name": "Windchill Pass",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58549.7,
                  40339.4
                ],
                "id": 2613,
                "chat_link": "[&BDUKAAA=]"
              },
              "2615": {
                "name": "Lifeblood Waterhole",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60622,
                  40845.6
                ],
                "id": 2615,
                "chat_link": "[&BDcKAAA=]"
              },
              "2622": {
                "name": "Giant's Steps",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58886.4,
                  40880.8
                ],
                "id": 2622,
                "chat_link": "[&BD4KAAA=]"
              },
              "2623": {
                "name": "Lommuld Kraal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60558.6,
                  40332.4
                ],
                "id": 2623,
                "chat_link": "[&BD8KAAA=]"
              },
              "2625": {
                "name": "Vantage Scree",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58624.1,
                  41459.1
                ],
                "id": 2625,
                "chat_link": "[&BEEKAAA=]"
              },
              "2627": {
                "name": "Pricklepatch Hollow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59072.2,
                  41471.4
                ],
                "id": 2627,
                "chat_link": "[&BEMKAAA=]"
              },
              "2645": {
                "name": "Mount: Springer",
                "type": "unlock",
                "floor": 1,
                "coord": [
                  59702.4,
                  40445.5
                ],
                "id": 2645,
                "chat_link": "[&BFUKAAA=]",
                "icon": "https://render.guildwars2.com/file/46BE19B7227A346805494155BEFB5B54C5179BED/1770699.png"
              },
              "2647": {
                "name": "Makali Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60786.1,
                  42043.7
                ],
                "id": 2647,
                "chat_link": "[&BFcKAAA=]"
              },
              "2650": {
                "name": "The Watchtower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61326.1,
                  40697.5
                ],
                "id": 2650,
                "chat_link": "[&BFoKAAA=]"
              },
              "2657": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58269.1,
                  41500.9
                ],
                "id": 2657,
                "chat_link": "[&BGEKAAA=]"
              },
              "2661": {
                "name": "Lifeblood Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60855.5,
                  39882.9
                ],
                "id": 2661,
                "chat_link": "[&BGUKAAA=]"
              },
              "2666": {
                "name": "Lommuld Kraal Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60598.2,
                  40452.9
                ],
                "id": 2666,
                "chat_link": "[&BGoKAAA=]"
              },
              "2667": {
                "name": "Makali Outpost Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60676.5,
                  42149.4
                ],
                "id": 2667,
                "chat_link": "[&BGsKAAA=]"
              },
              "2673": {
                "name": "Radiant Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59884.7,
                  40121.4
                ],
                "id": 2673,
                "chat_link": "[&BHEKAAA=]"
              },
              "2674": {
                "name": "Transcendent Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57807,
                  41601.3
                ],
                "id": 2674,
                "chat_link": "[&BHIKAAA=]"
              },
              "2680": {
                "name": "Glint's Lair",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61842.8,
                  41743
                ],
                "id": 2680,
                "chat_link": "[&BHgKAAA=]"
              },
              "2691": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  61709.9,
                  41484.7
                ],
                "id": 2691,
                "chat_link": "[&BIMKAAA=]"
              },
              "2693": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  61384.6,
                  40632.6
                ],
                "id": 2693,
                "chat_link": "[&BIUKAAA=]"
              },
              "2698": {
                "name": "The Portal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62178,
                  40091.3
                ],
                "id": 2698,
                "chat_link": "[&BIoKAAA=]"
              },
              "2699": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60806.2,
                  39999.2
                ],
                "id": 2699,
                "chat_link": "[&BIsKAAA=]"
              },
              "2703": {
                "name": "Kanuz Cache",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59963.4,
                  41839.5
                ],
                "id": 2703,
                "chat_link": "[&BI8KAAA=]"
              },
              "2705": {
                "name": "Brightwater Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59352.1,
                  41882.9
                ],
                "id": 2705,
                "chat_link": "[&BJEKAAA=]"
              },
              "2706": {
                "name": "Craggip Kraal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61592.4,
                  41122.9
                ],
                "id": 2706,
                "chat_link": "[&BJIKAAA=]"
              },
              "2717": {
                "name": "Highjump Ranch Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59604.9,
                  40332.9
                ],
                "id": 2717,
                "chat_link": "[&BJ0KAAA=]"
              },
              "2724": {
                "name": "Derelict Delve Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  57691.8,
                  40331.8
                ],
                "id": 2724,
                "chat_link": "[&BKQKAAA=]"
              },
              "2729": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58954.6,
                  41925
                ],
                "id": 2729,
                "chat_link": "[&BKkKAAA=]"
              },
              "2730": {
                "name": "Palace of Aban",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57826.3,
                  41327.1
                ],
                "id": 2730,
                "chat_link": "[&BKoKAAA=]"
              },
              "2734": {
                "name": "Giant's Tea Table",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60539.8,
                  41575.1
                ],
                "id": 2734,
                "chat_link": "[&BK4KAAA=]"
              },
              "2741": {
                "name": "Highjump Gap",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59929.5,
                  40441.6
                ],
                "id": 2741,
                "chat_link": "[&BLUKAAA=]"
              },
              "2762": {
                "name": "Jinx Hollow",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58149.8,
                  41397.4
                ],
                "id": 2762,
                "chat_link": "[&BMoKAAA=]"
              },
              "2765": {
                "name": "Nimbose Butte",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59517.8,
                  41456.8
                ],
                "id": 2765,
                "chat_link": "[&BM0KAAA=]"
              },
              "2771": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58797.7,
                  41766.2
                ],
                "id": 2771,
                "chat_link": "[&BNMKAAA=]"
              },
              "2773": {
                "name": "Discarded Vessels",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57753.4,
                  41881
                ],
                "id": 2773,
                "chat_link": "[&BNUKAAA=]"
              },
              "2777": {
                "name": "Derelict Delve",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57740.5,
                  40363.6
                ],
                "id": 2777,
                "chat_link": "[&BNkKAAA=]"
              },
              "2782": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  57951.8,
                  41570.9
                ],
                "id": 2782,
                "chat_link": "[&BN4KAAA=]"
              },
              "2799": {
                "name": "Overreach Chasm",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57804,
                  40767.9
                ],
                "id": 2799,
                "chat_link": "[&BO8KAAA=]"
              },
              "2800": {
                "name": "Godfall Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60098.2,
                  41628.8
                ],
                "id": 2800,
                "chat_link": "[&BPAKAAA=]"
              }
            },
            "tasks": {
              "390": {
                "objective": "Help out around Highjump Ranch.",
                "level": 80,
                "coord": [
                  59701.4,
                  40412.1
                ],
                "bounds": [
                  [
                    59287,
                    40643.6
                  ],
                  [
                    59259.2,
                    40346.4
                  ],
                  [
                    59258.7,
                    40225.5
                  ],
                  [
                    59365,
                    40114.1
                  ],
                  [
                    59473.6,
                    39984
                  ],
                  [
                    60025.5,
                    40003.3
                  ],
                  [
                    60015.1,
                    40149.9
                  ],
                  [
                    59845.7,
                    40762.1
                  ],
                  [
                    59477.4,
                    40775.3
                  ],
                  [
                    59287,
                    40643.6
                  ]
                ],
                "id": 390,
                "chat_link": "[&BIYBAAA=]"
              },
              "398": {
                "objective": "Help the Makali community.",
                "level": 80,
                "coord": [
                  60702.7,
                  42042.2
                ],
                "bounds": [
                  [
                    60169.5,
                    42223.3
                  ],
                  [
                    60302.2,
                    41763.3
                  ],
                  [
                    60410.9,
                    41365.2
                  ],
                  [
                    60779.1,
                    41275.3
                  ],
                  [
                    61127.6,
                    41288.9
                  ],
                  [
                    61143.4,
                    42274.5
                  ],
                  [
                    60169.5,
                    42223.3
                  ]
                ],
                "id": 398,
                "chat_link": "[&BI4BAAA=]"
              },
              "407": {
                "objective": "Help the Pricklepatch Hollow choya, or don't.",
                "level": 80,
                "coord": [
                  59067.1,
                  41441.5
                ],
                "bounds": [
                  [
                    58382.5,
                    41761.3
                  ],
                  [
                    58891.8,
                    41772
                  ],
                  [
                    59164.3,
                    41608.7
                  ],
                  [
                    59347.1,
                    41209.9
                  ],
                  [
                    59101.7,
                    41161.7
                  ],
                  [
                    58934.3,
                    41219.6
                  ],
                  [
                    58588.4,
                    41410.6
                  ],
                  [
                    58425.5,
                    41590.5
                  ],
                  [
                    58382.5,
                    41761.3
                  ]
                ],
                "id": 407,
                "chat_link": "[&BJcBAAA=]"
              },
              "416": {
                "objective": "Pitch in around Lommuld Kraal.",
                "level": 80,
                "coord": [
                  60634,
                  40643.1
                ],
                "bounds": [
                  [
                    60429.3,
                    41046.9
                  ],
                  [
                    60929.9,
                    40861.2
                  ],
                  [
                    61073.9,
                    40599.8
                  ],
                  [
                    61039.2,
                    40242.5
                  ],
                  [
                    60709.3,
                    40044.1
                  ],
                  [
                    60021.9,
                    40151.9
                  ],
                  [
                    59870.2,
                    40702.5
                  ],
                  [
                    60429.3,
                    41046.9
                  ]
                ],
                "id": 416,
                "chat_link": "[&BKABAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  61685.9,
                  40953.1
                ],
                "id": "2-5"
              },
              {
                "coord": [
                  57847.3,
                  40587.7
                ],
                "id": "2-6"
              },
              {
                "coord": [
                  59955.9,
                  41461.4
                ],
                "id": "2-7"
              },
              {
                "coord": [
                  61646.2,
                  41907.7
                ],
                "id": "2-8"
              },
              {
                "coord": [
                  60879.1,
                  39907.1
                ],
                "id": "2-9"
              },
              {
                "coord": [
                  62002.3,
                  40639.9
                ],
                "id": "2-10"
              },
              {
                "coord": [
                  60448.8,
                  40666.4
                ],
                "id": "2-11"
              }
            ],
            "sectors": {
              "1497": {
                "name": "Lifeblood Ravine",
                "level": 80,
                "coord": [
                  60764.9,
                  40565.9
                ],
                "bounds": [
                  [
                    61091.4,
                    40176
                  ],
                  [
                    61001.8,
                    39976.4
                  ],
                  [
                    60857.1,
                    39866.8
                  ],
                  [
                    60764.7,
                    39857
                  ],
                  [
                    60644.6,
                    40056.3
                  ],
                  [
                    60726.5,
                    40214.9
                  ],
                  [
                    60728.6,
                    40420.9
                  ],
                  [
                    60660.6,
                    40554
                  ],
                  [
                    60693.1,
                    40640
                  ],
                  [
                    60661.1,
                    40756.3
                  ],
                  [
                    60493.7,
                    40786.6
                  ],
                  [
                    60466.6,
                    40946.2
                  ],
                  [
                    60551.4,
                    41128.6
                  ],
                  [
                    60672.1,
                    41142.8
                  ],
                  [
                    60831.3,
                    41198.4
                  ],
                  [
                    60903.1,
                    40953.9
                  ],
                  [
                    60880.7,
                    40787.2
                  ],
                  [
                    60911.8,
                    40684.6
                  ],
                  [
                    60993.6,
                    40605.4
                  ],
                  [
                    61091.4,
                    40176
                  ]
                ],
                "id": 1497,
                "chat_link": "[&BNkFAAA=]"
              },
              "1501": {
                "name": "Fortune's Vale",
                "level": 80,
                "coord": [
                  57886.7,
                  40705.4
                ],
                "bounds": [
                  [
                    58071.8,
                    39810.6
                  ],
                  [
                    57537.2,
                    39814
                  ],
                  [
                    57332.4,
                    40079.1
                  ],
                  [
                    57434.2,
                    40945.5
                  ],
                  [
                    57469,
                    41161.6
                  ],
                  [
                    57667.3,
                    41118.2
                  ],
                  [
                    57801.8,
                    41146.1
                  ],
                  [
                    57983.7,
                    41215.1
                  ],
                  [
                    58105.5,
                    41343.5
                  ],
                  [
                    58124.6,
                    41209.5
                  ],
                  [
                    58005.2,
                    40861.3
                  ],
                  [
                    58140.6,
                    40805.7
                  ],
                  [
                    58286.8,
                    40657.2
                  ],
                  [
                    58128.5,
                    40333.2
                  ],
                  [
                    58212.4,
                    40080.1
                  ],
                  [
                    58071.8,
                    39810.6
                  ]
                ],
                "id": 1501,
                "chat_link": "[&BN0FAAA=]"
              },
              "1512": {
                "name": "Tomb of the Primeval Kings",
                "level": 80,
                "coord": [
                  61708.4,
                  40499.9
                ],
                "bounds": [
                  [
                    62206.2,
                    40978.5
                  ],
                  [
                    62292.2,
                    40707.3
                  ],
                  [
                    62213.9,
                    40538.8
                  ],
                  [
                    62313.1,
                    40216.2
                  ],
                  [
                    62106.4,
                    39985.8
                  ],
                  [
                    61771.2,
                    39969.2
                  ],
                  [
                    61616.8,
                    40167.2
                  ],
                  [
                    61360.9,
                    40218.3
                  ],
                  [
                    61090.9,
                    40175.6
                  ],
                  [
                    60993.8,
                    40604.9
                  ],
                  [
                    61141.6,
                    40635.1
                  ],
                  [
                    61390.3,
                    40669.9
                  ],
                  [
                    61467.1,
                    40769.2
                  ],
                  [
                    61679.4,
                    40901.6
                  ],
                  [
                    61982,
                    40960.8
                  ],
                  [
                    62206.2,
                    40978.5
                  ]
                ],
                "id": 1512,
                "chat_link": "[&BOgFAAA=]"
              },
              "1519": {
                "name": "Enchanted Bluffs",
                "level": 80,
                "coord": [
                  57794.2,
                  41322.5
                ],
                "bounds": [
                  [
                    58144.2,
                    41616.2
                  ],
                  [
                    58105.9,
                    41343
                  ],
                  [
                    57983.7,
                    41215
                  ],
                  [
                    57801.9,
                    41146.1
                  ],
                  [
                    57666.9,
                    41118.5
                  ],
                  [
                    57471.9,
                    41160.9
                  ],
                  [
                    57384.6,
                    41657.9
                  ],
                  [
                    58144.2,
                    41616.2
                  ]
                ],
                "id": 1519,
                "chat_link": "[&BO8FAAA=]"
              },
              "1527": {
                "name": "Diviner's Reach",
                "level": 80,
                "coord": [
                  60740.6,
                  42045.8
                ],
                "bounds": [
                  [
                    61100.9,
                    42308.1
                  ],
                  [
                    60713.2,
                    42392.1
                  ],
                  [
                    60121.8,
                    42211.6
                  ],
                  [
                    60486,
                    41901.8
                  ],
                  [
                    60760.7,
                    41778
                  ],
                  [
                    61007,
                    41801.7
                  ],
                  [
                    60994.8,
                    41927.3
                  ],
                  [
                    61100.9,
                    42308.1
                  ]
                ],
                "id": 1527,
                "chat_link": "[&BPcFAAA=]"
              },
              "1535": {
                "name": "Brightwater Inlet",
                "level": 80,
                "coord": [
                  59127,
                  41605.4
                ],
                "bounds": [
                  [
                    59879.9,
                    42280
                  ],
                  [
                    59866.4,
                    41983.4
                  ],
                  [
                    59790.1,
                    41750.9
                  ],
                  [
                    59655.7,
                    41630.5
                  ],
                  [
                    59592.7,
                    41476.5
                  ],
                  [
                    59493.8,
                    41182.9
                  ],
                  [
                    59156.2,
                    41116.4
                  ],
                  [
                    59037,
                    41175.4
                  ],
                  [
                    58961,
                    41164
                  ],
                  [
                    58864.1,
                    41367.1
                  ],
                  [
                    58574.1,
                    41445.8
                  ],
                  [
                    58398.7,
                    41576.4
                  ],
                  [
                    58232.2,
                    41911.9
                  ],
                  [
                    58275.6,
                    42413.8
                  ],
                  [
                    59879.9,
                    42280
                  ]
                ],
                "id": 1535,
                "chat_link": "[&BP8FAAA=]"
              },
              "1540": {
                "name": "Stampede Uplands",
                "level": 80,
                "coord": [
                  59371.8,
                  40509.4
                ],
                "bounds": [
                  [
                    59155.5,
                    41112.9
                  ],
                  [
                    59493.6,
                    41183
                  ],
                  [
                    59544.7,
                    41056.4
                  ],
                  [
                    59797.1,
                    40898
                  ],
                  [
                    59871.9,
                    40743.3
                  ],
                  [
                    59922.1,
                    40519.2
                  ],
                  [
                    59921.3,
                    40349.3
                  ],
                  [
                    59974.5,
                    40309.9
                  ],
                  [
                    60009.8,
                    40220.8
                  ],
                  [
                    60024.2,
                    40101.1
                  ],
                  [
                    60002.3,
                    39958
                  ],
                  [
                    59838.7,
                    40059.3
                  ],
                  [
                    59431.6,
                    39985.9
                  ],
                  [
                    59189.1,
                    39954.6
                  ],
                  [
                    59207.7,
                    40012.8
                  ],
                  [
                    59172.9,
                    40054.3
                  ],
                  [
                    59039.2,
                    40018
                  ],
                  [
                    58989.9,
                    40140.4
                  ],
                  [
                    59001,
                    40279.1
                  ],
                  [
                    59056.5,
                    40318.4
                  ],
                  [
                    59034.8,
                    40418.4
                  ],
                  [
                    58912.9,
                    40640.6
                  ],
                  [
                    58976.8,
                    40749
                  ],
                  [
                    58958,
                    40809.4
                  ],
                  [
                    58997.6,
                    40883.9
                  ],
                  [
                    59005.1,
                    40959.2
                  ],
                  [
                    59039.3,
                    41006.7
                  ],
                  [
                    59083.4,
                    41014.8
                  ],
                  [
                    59129.2,
                    41015.6
                  ],
                  [
                    59155.5,
                    41112.9
                  ]
                ],
                "id": 1540,
                "chat_link": "[&BAQGAAA=]"
              },
              "1554": {
                "name": "The Sunderlands",
                "level": 80,
                "coord": [
                  61434.5,
                  41067.6
                ],
                "bounds": [
                  [
                    61548.2,
                    41329.4
                  ],
                  [
                    61322.2,
                    41319.1
                  ],
                  [
                    61134.2,
                    41294.5
                  ],
                  [
                    60975.6,
                    41367.2
                  ],
                  [
                    60831.7,
                    41198.3
                  ],
                  [
                    60903,
                    40953.5
                  ],
                  [
                    60880.7,
                    40786.3
                  ],
                  [
                    60911.6,
                    40684
                  ],
                  [
                    60993.8,
                    40604.9
                  ],
                  [
                    61141.8,
                    40635.1
                  ],
                  [
                    61390.1,
                    40670
                  ],
                  [
                    61467,
                    40769
                  ],
                  [
                    61679.2,
                    40901.4
                  ],
                  [
                    61981.8,
                    40960.5
                  ],
                  [
                    62207.4,
                    40978.4
                  ],
                  [
                    62351.9,
                    41870.8
                  ],
                  [
                    62146.3,
                    41549
                  ],
                  [
                    61954.7,
                    41344.9
                  ],
                  [
                    61548.2,
                    41329.4
                  ]
                ],
                "id": 1554,
                "chat_link": "[&BBIGAAA=]"
              },
              "1574": {
                "name": "Salt Flats",
                "level": 80,
                "coord": [
                  60221,
                  41450.8
                ],
                "bounds": [
                  [
                    61006.8,
                    41800.9
                  ],
                  [
                    60985.5,
                    41533.5
                  ],
                  [
                    60973.6,
                    41366.4
                  ],
                  [
                    60831.2,
                    41199.1
                  ],
                  [
                    60671.3,
                    41142.8
                  ],
                  [
                    60551.2,
                    41129.5
                  ],
                  [
                    60381.3,
                    41082.5
                  ],
                  [
                    60217.2,
                    40990.6
                  ],
                  [
                    60097.3,
                    41048.1
                  ],
                  [
                    59937.2,
                    41023.8
                  ],
                  [
                    59796.5,
                    40898.2
                  ],
                  [
                    59547.6,
                    41057.1
                  ],
                  [
                    59493.5,
                    41183.4
                  ],
                  [
                    59592.8,
                    41477.1
                  ],
                  [
                    59655.3,
                    41630.7
                  ],
                  [
                    59788.9,
                    41749
                  ],
                  [
                    59865.7,
                    41982.5
                  ],
                  [
                    59880.2,
                    42280.7
                  ],
                  [
                    60121.8,
                    42211.7
                  ],
                  [
                    60485.8,
                    41901.9
                  ],
                  [
                    60760.6,
                    41777.6
                  ],
                  [
                    61006.8,
                    41800.9
                  ]
                ],
                "id": 1574,
                "chat_link": "[&BCYGAAA=]"
              },
              "1575": {
                "name": "Winter's Teeth",
                "level": 80,
                "coord": [
                  58415.6,
                  40668.3
                ],
                "bounds": [
                  [
                    58878.4,
                    39972
                  ],
                  [
                    58584.3,
                    39912
                  ],
                  [
                    58071.7,
                    39810.6
                  ],
                  [
                    58212.4,
                    40080.4
                  ],
                  [
                    58128.4,
                    40333.1
                  ],
                  [
                    58287.1,
                    40657.2
                  ],
                  [
                    58140.8,
                    40805.7
                  ],
                  [
                    58005.2,
                    40861.1
                  ],
                  [
                    58124.2,
                    41209.6
                  ],
                  [
                    58105.5,
                    41341.8
                  ],
                  [
                    58143.9,
                    41616.7
                  ],
                  [
                    58396.9,
                    41576.2
                  ],
                  [
                    58517.8,
                    41237
                  ],
                  [
                    58490.9,
                    41107.7
                  ],
                  [
                    58657.2,
                    40906.2
                  ],
                  [
                    58789.5,
                    40525.9
                  ],
                  [
                    58788.9,
                    40371.7
                  ],
                  [
                    58742.7,
                    40234.7
                  ],
                  [
                    58830.1,
                    40137.2
                  ],
                  [
                    58878.4,
                    39972
                  ]
                ],
                "id": 1575,
                "chat_link": "[&BCcGAAA=]"
              },
              "1578": {
                "name": "Windshear Scarps",
                "level": 80,
                "coord": [
                  58918.8,
                  40662.4
                ],
                "bounds": [
                  [
                    58864.1,
                    41365.7
                  ],
                  [
                    58960.1,
                    41162.3
                  ],
                  [
                    59036.8,
                    41177
                  ],
                  [
                    59156,
                    41116.3
                  ],
                  [
                    59129.2,
                    41015.6
                  ],
                  [
                    59083.2,
                    41014.9
                  ],
                  [
                    59039.3,
                    41006.8
                  ],
                  [
                    59004.7,
                    40959.2
                  ],
                  [
                    58997.4,
                    40884
                  ],
                  [
                    58958.1,
                    40809.6
                  ],
                  [
                    58976.9,
                    40749.1
                  ],
                  [
                    58912.8,
                    40640.6
                  ],
                  [
                    59034.4,
                    40418.2
                  ],
                  [
                    59056.1,
                    40318.3
                  ],
                  [
                    59001,
                    40279.2
                  ],
                  [
                    58989.9,
                    40140.8
                  ],
                  [
                    59039.1,
                    40018
                  ],
                  [
                    59172,
                    40054.2
                  ],
                  [
                    59209.5,
                    40016.3
                  ],
                  [
                    59189.1,
                    39954.6
                  ],
                  [
                    59005.6,
                    39921.6
                  ],
                  [
                    58878.2,
                    39972.2
                  ],
                  [
                    58830.1,
                    40137.4
                  ],
                  [
                    58743.1,
                    40234.9
                  ],
                  [
                    58788.8,
                    40371.8
                  ],
                  [
                    58789.7,
                    40525.8
                  ],
                  [
                    58656.8,
                    40905.8
                  ],
                  [
                    58490.7,
                    41107.8
                  ],
                  [
                    58518.7,
                    41236.6
                  ],
                  [
                    58398.2,
                    41575.8
                  ],
                  [
                    58574.5,
                    41444.9
                  ],
                  [
                    58864.1,
                    41365.7
                  ]
                ],
                "id": 1578,
                "chat_link": "[&BCoGAAA=]"
              },
              "1580": {
                "name": "Prophet's Fall",
                "level": 80,
                "coord": [
                  61489.8,
                  41729.3
                ],
                "bounds": [
                  [
                    61100.5,
                    42308
                  ],
                  [
                    61539.8,
                    42564.8
                  ],
                  [
                    62309.2,
                    42273.2
                  ],
                  [
                    62351.6,
                    41871.6
                  ],
                  [
                    62146.4,
                    41547
                  ],
                  [
                    61955.8,
                    41346.4
                  ],
                  [
                    61549.1,
                    41329.1
                  ],
                  [
                    61322.2,
                    41318.8
                  ],
                  [
                    61134.1,
                    41295
                  ],
                  [
                    60973.3,
                    41367
                  ],
                  [
                    60985.9,
                    41532.5
                  ],
                  [
                    61005.7,
                    41801.3
                  ],
                  [
                    60994.4,
                    41925.8
                  ],
                  [
                    61100.5,
                    42308
                  ]
                ],
                "id": 1580,
                "chat_link": "[&BCwGAAA=]"
              },
              "1587": {
                "name": "Auburn Hills",
                "level": 80,
                "coord": [
                  60296.8,
                  40494.9
                ],
                "bounds": [
                  [
                    60550.1,
                    41129
                  ],
                  [
                    60380.4,
                    41083.1
                  ],
                  [
                    60217.2,
                    40990.6
                  ],
                  [
                    60096.7,
                    41048.2
                  ],
                  [
                    59937,
                    41023.7
                  ],
                  [
                    59797.3,
                    40898.8
                  ],
                  [
                    59871.6,
                    40743.6
                  ],
                  [
                    59921.9,
                    40519.3
                  ],
                  [
                    59921.3,
                    40348.8
                  ],
                  [
                    59974.3,
                    40309.8
                  ],
                  [
                    60009.5,
                    40220.2
                  ],
                  [
                    60023.2,
                    40102.5
                  ],
                  [
                    60002,
                    39957.9
                  ],
                  [
                    60098.5,
                    39817.9
                  ],
                  [
                    60342.9,
                    39960.5
                  ],
                  [
                    60467,
                    39918.6
                  ],
                  [
                    60733.5,
                    39923.4
                  ],
                  [
                    60643.6,
                    40054.8
                  ],
                  [
                    60728.1,
                    40216.3
                  ],
                  [
                    60728.4,
                    40421
                  ],
                  [
                    60661.1,
                    40554
                  ],
                  [
                    60693.5,
                    40640
                  ],
                  [
                    60661,
                    40755.9
                  ],
                  [
                    60493.6,
                    40786.6
                  ],
                  [
                    60466.4,
                    40947.9
                  ],
                  [
                    60550.1,
                    41129
                  ]
                ],
                "id": 1587,
                "chat_link": "[&BDMGAAA=]"
              },
              "1597": {
                "name": "Transcendent Bay",
                "level": 80,
                "coord": [
                  57977.5,
                  41888.6
                ],
                "bounds": [
                  [
                    58286.1,
                    42415.8
                  ],
                  [
                    58244.2,
                    41907.7
                  ],
                  [
                    58397,
                    41575.4
                  ],
                  [
                    58144.5,
                    41617.1
                  ],
                  [
                    57384.4,
                    41657.1
                  ],
                  [
                    57408.9,
                    42158.2
                  ],
                  [
                    58286.1,
                    42415.8
                  ]
                ],
                "id": 1597,
                "chat_link": "[&BD0GAAA=]"
              }
            },
            "adventures": [],
            "id": 1211,
            "mastery_points": [
              {
                "coord": [
                  60728.5,
                  42115.5
                ],
                "id": 336,
                "region": "Desert"
              },
              {
                "coord": [
                  61296.8,
                  40765.1
                ],
                "id": 331,
                "region": "Desert"
              },
              {
                "coord": [
                  60704,
                  39992.5
                ],
                "id": 414,
                "region": "Desert"
              },
              {
                "coord": [
                  59549.3,
                  40287.1
                ],
                "id": 402,
                "region": "Desert"
              },
              {
                "coord": [
                  58792.4,
                  40904
                ],
                "id": 378,
                "region": "Desert"
              },
              {
                "coord": [
                  58309.9,
                  40223.4
                ],
                "id": 368,
                "region": "Desert"
              },
              {
                "coord": [
                  57688.8,
                  40277
                ],
                "id": 370,
                "region": "Desert"
              },
              {
                "coord": [
                  57839.1,
                  41291.6
                ],
                "id": 379,
                "region": "Desert"
              },
              {
                "coord": [
                  62102.4,
                  41107.1
                ],
                "id": 373,
                "region": "Desert"
              },
              {
                "coord": [
                  60071.1,
                  42019.8
                ],
                "id": 385,
                "region": "Desert"
              },
              {
                "coord": [
                  58971.9,
                  42227.9
                ],
                "id": 381,
                "region": "Desert"
              },
              {
                "coord": [
                  61963.3,
                  40338.6
                ],
                "id": 392,
                "region": "Desert"
              },
              {
                "coord": [
                  57714.1,
                  40877.9
                ],
                "id": 390,
                "region": "Desert"
              },
              {
                "coord": [
                  59760.9,
                  41380.6
                ],
                "id": 367,
                "region": "Desert"
              },
              {
                "coord": [
                  57589.8,
                  41805.7
                ],
                "id": 376,
                "region": "Desert"
              }
            ]
          },
          "1212": {
            "name": "Office of the Chief Councilor",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              60176,
              44240
            ],
            "map_rect": [
              [
                -61440,
                -30720
              ],
              [
                61440,
                30720
              ]
            ],
            "continent_rect": [
              [
                57256,
                42304
              ],
              [
                62376,
                44864
              ]
            ],
            "points_of_interest": {
              "2688": {
                "name": "Amnoon Civic Center",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58269,
                  43628.3
                ],
                "id": 2688,
                "chat_link": "[&BIAKAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1562": {
                "name": "Free City of Amnoon",
                "level": 80,
                "coord": [
                  58417.9,
                  43644.3
                ],
                "bounds": [
                  [
                    58220.8,
                    44176.2
                  ],
                  [
                    58727,
                    44196.1
                  ],
                  [
                    58874.5,
                    44256.1
                  ],
                  [
                    58942,
                    44173.4
                  ],
                  [
                    58980.9,
                    44123.6
                  ],
                  [
                    58962.3,
                    44046.2
                  ],
                  [
                    58847,
                    43967.2
                  ],
                  [
                    58860.9,
                    43295.6
                  ],
                  [
                    58747.8,
                    43250.8
                  ],
                  [
                    58539.8,
                    43207.2
                  ],
                  [
                    58430.7,
                    43204.8
                  ],
                  [
                    58379.3,
                    43159.2
                  ],
                  [
                    58284.1,
                    43126.7
                  ],
                  [
                    58093.3,
                    43115.7
                  ],
                  [
                    58043.3,
                    43245.2
                  ],
                  [
                    57885.9,
                    43274.9
                  ],
                  [
                    57887.5,
                    43407.1
                  ],
                  [
                    57828.3,
                    43644.2
                  ],
                  [
                    57823.3,
                    43846.7
                  ],
                  [
                    57999.4,
                    44168.3
                  ],
                  [
                    58220.8,
                    44176.2
                  ]
                ],
                "id": 1562,
                "chat_link": "[&BBoGAAA=]"
              }
            },
            "adventures": [],
            "id": 1212,
            "mastery_points": []
          },
          "1214": {
            "name": "Windswept Haven",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              64672,
              51646
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                64016,
                51072
              ],
              [
                65296,
                52352
              ]
            ],
            "points_of_interest": {
              "2690": {
                "name": "Windswept Arena Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64610.8,
                  51738.4
                ],
                "id": 2690,
                "chat_link": "[&BIIKAAA=]"
              },
              "2721": {
                "name": "Cavern Overlook Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64453.1,
                  52290.7
                ],
                "id": 2721,
                "chat_link": "[&BKEKAAA=]"
              },
              "2775": {
                "name": "Vantage Dome Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  65172.6,
                  51485.6
                ],
                "id": 2775,
                "chat_link": "[&BNcKAAA=]"
              },
              "2781": {
                "name": "Haven Terrace Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64843.8,
                  51650.5
                ],
                "id": 2781,
                "chat_link": "[&BN0KAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1518": {
                "level": 0,
                "coord": [
                  64748.2,
                  51688.9
                ],
                "bounds": [
                  [
                    65265.6,
                    51274
                  ],
                  [
                    65282.6,
                    51903.2
                  ],
                  [
                    65229.7,
                    52092.6
                  ],
                  [
                    65092.8,
                    52388.4
                  ],
                  [
                    64340.1,
                    52410.9
                  ],
                  [
                    64180.4,
                    51778.5
                  ],
                  [
                    64217.3,
                    51162.9
                  ],
                  [
                    64436.8,
                    51101.1
                  ],
                  [
                    64688.1,
                    51089
                  ],
                  [
                    65265.6,
                    51274
                  ]
                ],
                "id": 1518,
                "chat_link": "[&BO4FAAA=]"
              }
            },
            "adventures": [],
            "id": 1214,
            "mastery_points": []
          },
          "1215": {
            "name": "Windswept Haven",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              64672,
              51646
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                64016,
                51072
              ],
              [
                65296,
                52352
              ]
            ],
            "points_of_interest": {
              "2690": {
                "name": "Windswept Arena Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64610.8,
                  51738.4
                ],
                "id": 2690,
                "chat_link": "[&BIIKAAA=]"
              },
              "2721": {
                "name": "Cavern Overlook Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64453.1,
                  52290.7
                ],
                "id": 2721,
                "chat_link": "[&BKEKAAA=]"
              },
              "2775": {
                "name": "Vantage Dome Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  65172.6,
                  51485.6
                ],
                "id": 2775,
                "chat_link": "[&BNcKAAA=]"
              },
              "2781": {
                "name": "Haven Terrace Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64843.8,
                  51650.5
                ],
                "id": 2781,
                "chat_link": "[&BN0KAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1518": {
                "level": 0,
                "coord": [
                  64748.2,
                  51688.9
                ],
                "bounds": [
                  [
                    65265.6,
                    51274
                  ],
                  [
                    65282.6,
                    51903.2
                  ],
                  [
                    65229.7,
                    52092.6
                  ],
                  [
                    65092.8,
                    52388.4
                  ],
                  [
                    64340.1,
                    52410.9
                  ],
                  [
                    64180.4,
                    51778.5
                  ],
                  [
                    64217.3,
                    51162.9
                  ],
                  [
                    64436.8,
                    51101.1
                  ],
                  [
                    64688.1,
                    51089
                  ],
                  [
                    65265.6,
                    51274
                  ]
                ],
                "id": 1518,
                "chat_link": "[&BO4FAAA=]"
              }
            },
            "id": 1215,
            "mastery_points": [],
            "adventures": []
          },
          "1217": {
            "name": "Sparking the Flame",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              60176,
              44240
            ],
            "map_rect": [
              [
                -61440,
                -30720
              ],
              [
                61440,
                30720
              ]
            ],
            "continent_rect": [
              [
                57256,
                42304
              ],
              [
                62376,
                44864
              ]
            ],
            "points_of_interest": {
              "2593": {
                "name": "Tomb of the Abandoned",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58063.4,
                  42750
                ],
                "id": 2593,
                "chat_link": "[&BCEKAAA=]"
              },
              "2630": {
                "name": "Seeker's Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58485.6,
                  42980.6
                ],
                "id": 2630,
                "chat_link": "[&BEYKAAA=]"
              },
              "2742": {
                "name": "The Empty Quarter",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58218.6,
                  43294.3
                ],
                "id": 2742,
                "chat_link": "[&BLYKAAA=]"
              },
              "2793": {
                "name": "Talatat Quarry",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58904.3,
                  42605.9
                ],
                "id": 2793,
                "chat_link": "[&BOkKAAA=]"
              }
            },
            "tasks": {
              "414": {
                "objective": "Help Aksim care for and train raptors.",
                "level": 80,
                "coord": [
                  58343.1,
                  43050.8
                ],
                "bounds": [
                  [
                    58260.6,
                    43110.9
                  ],
                  [
                    58278.3,
                    42981.6
                  ],
                  [
                    58517.1,
                    42754.8
                  ],
                  [
                    58685.9,
                    42776.3
                  ],
                  [
                    58764.5,
                    42983.4
                  ],
                  [
                    58701.3,
                    43152.4
                  ],
                  [
                    58260.6,
                    43110.9
                  ]
                ],
                "id": 414,
                "chat_link": "[&BJ4BAAA=]"
              }
            },
            "skill_challenges": [],
            "sectors": {
              "1496": {
                "name": "The Sinking Ruins",
                "level": 80,
                "coord": [
                  58178.9,
                  42862
                ],
                "bounds": [
                  [
                    57581.1,
                    42885.2
                  ],
                  [
                    57839.5,
                    43065.6
                  ],
                  [
                    57885.6,
                    43274.3
                  ],
                  [
                    58043.1,
                    43244.8
                  ],
                  [
                    58093.1,
                    43115.8
                  ],
                  [
                    58283.4,
                    43126.4
                  ],
                  [
                    58379.4,
                    43159.1
                  ],
                  [
                    58431.6,
                    43204.6
                  ],
                  [
                    58540.1,
                    43207.6
                  ],
                  [
                    58748.2,
                    43251
                  ],
                  [
                    58726.1,
                    42946.7
                  ],
                  [
                    58641,
                    42796.1
                  ],
                  [
                    58560.2,
                    42673.2
                  ],
                  [
                    58472.2,
                    42687
                  ],
                  [
                    58463,
                    42508.6
                  ],
                  [
                    58339.3,
                    42458.8
                  ],
                  [
                    58345.8,
                    42326.3
                  ],
                  [
                    57410.1,
                    42210.4
                  ],
                  [
                    57314.6,
                    42504.7
                  ],
                  [
                    57480.7,
                    42594.3
                  ],
                  [
                    57581.1,
                    42885.2
                  ]
                ],
                "id": 1496,
                "chat_link": "[&BNgFAAA=]"
              },
              "1513": {
                "name": "Amnoon Farms",
                "level": 80,
                "coord": [
                  59399.2,
                  43837.4
                ],
                "bounds": [
                  [
                    58847,
                    43967.8
                  ],
                  [
                    58962.8,
                    44046.4
                  ],
                  [
                    58981.7,
                    44123.4
                  ],
                  [
                    58942.7,
                    44174.3
                  ],
                  [
                    58874.5,
                    44256.1
                  ],
                  [
                    59001.8,
                    44288.8
                  ],
                  [
                    59185.7,
                    44286.3
                  ],
                  [
                    59312.2,
                    44375
                  ],
                  [
                    59707.4,
                    44388.4
                  ],
                  [
                    59905.5,
                    44301.3
                  ],
                  [
                    59974.5,
                    44205
                  ],
                  [
                    60062.7,
                    44104.1
                  ],
                  [
                    60000.9,
                    43888.5
                  ],
                  [
                    59929.6,
                    43838.9
                  ],
                  [
                    59902,
                    43733.6
                  ],
                  [
                    59792.9,
                    43698.2
                  ],
                  [
                    59636.8,
                    43647.5
                  ],
                  [
                    59544.6,
                    43595.5
                  ],
                  [
                    59485.5,
                    43477.5
                  ],
                  [
                    59384.8,
                    43408.6
                  ],
                  [
                    59314.6,
                    43334.6
                  ],
                  [
                    59299.4,
                    43221.4
                  ],
                  [
                    59086.8,
                    43104.8
                  ],
                  [
                    58982.4,
                    43173.8
                  ],
                  [
                    58860.4,
                    43296.4
                  ],
                  [
                    58847,
                    43967.8
                  ]
                ],
                "id": 1513,
                "chat_link": "[&BOkFAAA=]"
              },
              "1542": {
                "name": "Mekele Bluffs",
                "level": 80,
                "coord": [
                  58777.2,
                  42794.7
                ],
                "bounds": [
                  [
                    58747.6,
                    43251.8
                  ],
                  [
                    58860.9,
                    43295.5
                  ],
                  [
                    58982.8,
                    43174.2
                  ],
                  [
                    59087.2,
                    43105.2
                  ],
                  [
                    59106.3,
                    43014
                  ],
                  [
                    59086.6,
                    42811.8
                  ],
                  [
                    59177.9,
                    42563.2
                  ],
                  [
                    59063.9,
                    42314.5
                  ],
                  [
                    58346.1,
                    42326.4
                  ],
                  [
                    58339.7,
                    42458.4
                  ],
                  [
                    58462.6,
                    42508.1
                  ],
                  [
                    58472,
                    42686.9
                  ],
                  [
                    58559.1,
                    42670.2
                  ],
                  [
                    58639.2,
                    42793.6
                  ],
                  [
                    58726.1,
                    42946.7
                  ],
                  [
                    58747.6,
                    43251.8
                  ]
                ],
                "id": 1542,
                "chat_link": "[&BAYGAAA=]"
              },
              "1562": {
                "name": "Free City of Amnoon",
                "level": 80,
                "coord": [
                  58417.9,
                  43644.3
                ],
                "bounds": [
                  [
                    58220.8,
                    44176.2
                  ],
                  [
                    58727,
                    44196.1
                  ],
                  [
                    58874.5,
                    44256.1
                  ],
                  [
                    58942,
                    44173.4
                  ],
                  [
                    58980.9,
                    44123.6
                  ],
                  [
                    58962.3,
                    44046.2
                  ],
                  [
                    58847,
                    43967.2
                  ],
                  [
                    58860.9,
                    43295.6
                  ],
                  [
                    58747.8,
                    43250.8
                  ],
                  [
                    58539.8,
                    43207.2
                  ],
                  [
                    58430.7,
                    43204.8
                  ],
                  [
                    58379.3,
                    43159.2
                  ],
                  [
                    58284.1,
                    43126.7
                  ],
                  [
                    58093.3,
                    43115.7
                  ],
                  [
                    58043.3,
                    43245.2
                  ],
                  [
                    57885.9,
                    43274.9
                  ],
                  [
                    57887.5,
                    43407.1
                  ],
                  [
                    57828.3,
                    43644.2
                  ],
                  [
                    57823.3,
                    43846.7
                  ],
                  [
                    57999.4,
                    44168.3
                  ],
                  [
                    58220.8,
                    44176.2
                  ]
                ],
                "id": 1562,
                "chat_link": "[&BBoGAAA=]"
              }
            },
            "adventures": [],
            "id": 1217,
            "mastery_points": []
          },
          "1219": {
            "name": "Enemy of My Enemy: The Beastmarshal",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              38768,
              45740
            ],
            "map_rect": [
              [
                -58368,
                -36864
              ],
              [
                58368,
                39936
              ]
            ],
            "continent_rect": [
              [
                63616,
                52352
              ],
              [
                68480,
                55552
              ]
            ],
            "points_of_interest": {
              "2550": {
                "name": "The Menagerie",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66235,
                  53193.4
                ],
                "id": 2550,
                "chat_link": "[&BPYJAAA=]"
              },
              "2555": {
                "name": "The Promenade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64999.5,
                  53201.3
                ],
                "id": 2555,
                "chat_link": "[&BPsJAAA=]"
              },
              "2559": {
                "name": "Ruins of Mihanu Township",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66737.1,
                  52538.7
                ],
                "id": 2559,
                "chat_link": "[&BP8JAAA=]"
              },
              "2561": {
                "name": "Spearmarshal's Lament",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  68076.9,
                  55017.1
                ],
                "id": 2561,
                "chat_link": "[&BAEKAAA=]"
              },
              "2563": {
                "name": "Spa",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65532.1,
                  52936
                ],
                "id": 2563,
                "chat_link": "[&BAMKAAA=]"
              },
              "2574": {
                "name": "Vehjin Royal Rotunda",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64000.1,
                  53492.3
                ],
                "id": 2574,
                "chat_link": "[&BA4KAAA=]"
              },
              "2581": {
                "name": "The Warehouse",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66628.9,
                  54894.7
                ],
                "id": 2581,
                "chat_link": "[&BBUKAAA=]"
              },
              "2602": {
                "name": "Junundu Nests",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65769.7,
                  55195.3
                ],
                "id": 2602,
                "chat_link": "[&BCoKAAA=]"
              },
              "2604": {
                "name": "Beastmarshal's Encampment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65211,
                  55293.7
                ],
                "id": 2604,
                "chat_link": "[&BCwKAAA=]"
              },
              "2612": {
                "name": "Troopmarshal's Encampment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64491.7,
                  54314.2
                ],
                "id": 2612,
                "chat_link": "[&BDQKAAA=]"
              },
              "2621": {
                "name": "Seborhin Circle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65287.1,
                  53198.5
                ],
                "id": 2621,
                "chat_link": "[&BD0KAAA=]"
              },
              "2658": {
                "name": "Tihark Orchard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65438.5,
                  54252.7
                ],
                "id": 2658,
                "chat_link": "[&BGIKAAA=]"
              },
              "2662": {
                "name": "Merchant's Row",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65645.1,
                  53191.6
                ],
                "id": 2662,
                "chat_link": "[&BGYKAAA=]"
              },
              "2669": {
                "name": "The Hearth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63952.7,
                  54416.8
                ],
                "id": 2669,
                "chat_link": "[&BG0KAAA=]"
              },
              "2696": {
                "name": "Market Ruins",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66162.1,
                  54005.2
                ],
                "id": 2696,
                "chat_link": "[&BIgKAAA=]"
              },
              "2710": {
                "name": "Hanging Gardens",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  68127.9,
                  54313.2
                ],
                "id": 2710,
                "chat_link": "[&BJYKAAA=]"
              },
              "2714": {
                "name": "House Ingene Dormitory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66715.5,
                  55167.1
                ],
                "id": 2714,
                "chat_link": "[&BJoKAAA=]"
              },
              "2715": {
                "name": "Great Palawa Joko Monument",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66153.5,
                  54897
                ],
                "id": 2715,
                "chat_link": "[&BJsKAAA=]"
              },
              "2720": {
                "name": "Tournament Battlegrounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66206.1,
                  54515.6
                ],
                "id": 2720,
                "chat_link": "[&BKAKAAA=]"
              },
              "2731": {
                "name": "House Ventura Dormitory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66638.6,
                  55250.9
                ],
                "id": 2731,
                "chat_link": "[&BKsKAAA=]"
              },
              "2748": {
                "name": "Excavation Site",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63864.4,
                  53729.2
                ],
                "id": 2748,
                "chat_link": "[&BLwKAAA=]"
              },
              "2752": {
                "name": "The Boneyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63898.4,
                  55287.7
                ],
                "id": 2752,
                "chat_link": "[&BMAKAAA=]"
              },
              "2755": {
                "name": "Vehtendi Vineyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67038.6,
                  55431.5
                ],
                "id": 2755,
                "chat_link": "[&BMMKAAA=]"
              },
              "2758": {
                "name": "Lyssan Fools Theater",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65281.3,
                  53503
                ],
                "id": 2758,
                "chat_link": "[&BMYKAAA=]"
              },
              "2763": {
                "name": "Court of the Dead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64650.3,
                  54973.4
                ],
                "id": 2763,
                "chat_link": "[&BMsKAAA=]"
              },
              "2776": {
                "name": "Headmaster's Office",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66508.9,
                  55072
                ],
                "id": 2776,
                "chat_link": "[&BNgKAAA=]"
              },
              "2779": {
                "name": "House Rolic Dormitory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66723.4,
                  55054.4
                ],
                "id": 2779,
                "chat_link": "[&BNsKAAA=]"
              },
              "2783": {
                "name": "Ruins of Jennur's Horde",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64796,
                  53554.4
                ],
                "id": 2783,
                "chat_link": "[&BN8KAAA=]"
              },
              "2794": {
                "name": "King Joko's Sky Garden",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66843.3,
                  54040.5
                ],
                "id": 2794,
                "chat_link": "[&BOoKAAA=]"
              },
              "2795": {
                "name": "The Crypts",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64512.4,
                  55189.4
                ],
                "id": 2795,
                "chat_link": "[&BOsKAAA=]"
              },
              "2796": {
                "name": "Lair of Zommoros",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64728.5,
                  52403.3
                ],
                "id": 2796,
                "chat_link": "[&BOwKAAA=]"
              },
              "2802": {
                "name": "Ruins of the Mirror of Lyss",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67587.2,
                  53006
                ],
                "id": 2802,
                "chat_link": "[&BPIKAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1484": {
                "name": "Western Mihan Hillsides",
                "level": 80,
                "coord": [
                  64950.8,
                  52651.6
                ],
                "bounds": [
                  [
                    64523.9,
                    52579.7
                  ],
                  [
                    64569.3,
                    52518.8
                  ],
                  [
                    64649.7,
                    52494.7
                  ],
                  [
                    64753.3,
                    52537.3
                  ],
                  [
                    64842.8,
                    52519.9
                  ],
                  [
                    64913.2,
                    52496.1
                  ],
                  [
                    64925.6,
                    52424.3
                  ],
                  [
                    65141.4,
                    52397.5
                  ],
                  [
                    65449.8,
                    52375.6
                  ],
                  [
                    65457.5,
                    52481.8
                  ],
                  [
                    65402,
                    52520.9
                  ],
                  [
                    65390.1,
                    52578.3
                  ],
                  [
                    65422.6,
                    52726
                  ],
                  [
                    65433,
                    52837.1
                  ],
                  [
                    65297.7,
                    52837.6
                  ],
                  [
                    65146.8,
                    52838.6
                  ],
                  [
                    64981.1,
                    52835.1
                  ],
                  [
                    64856.7,
                    52859.1
                  ],
                  [
                    64799.5,
                    52997.4
                  ],
                  [
                    64636,
                    52978.1
                  ],
                  [
                    64471,
                    52956.4
                  ],
                  [
                    64368.9,
                    52596.9
                  ],
                  [
                    64435.3,
                    52600.7
                  ],
                  [
                    64523.9,
                    52579.7
                  ]
                ],
                "id": 1484,
                "chat_link": "[&BMwFAAA=]"
              },
              "1485": {
                "name": "Vehjin Mines",
                "level": 80,
                "coord": [
                  64043.4,
                  53884.5
                ],
                "bounds": [
                  [
                    63666.7,
                    53964.1
                  ],
                  [
                    63697.3,
                    54237.3
                  ],
                  [
                    63879.6,
                    54185.9
                  ],
                  [
                    63906.4,
                    54191.9
                  ],
                  [
                    64037.4,
                    54157
                  ],
                  [
                    64167.3,
                    54049.4
                  ],
                  [
                    64413.4,
                    54034.9
                  ],
                  [
                    64412.8,
                    53875.5
                  ],
                  [
                    64395.5,
                    53814.7
                  ],
                  [
                    64354,
                    53835.3
                  ],
                  [
                    64292,
                    53837
                  ],
                  [
                    64113.8,
                    53772
                  ],
                  [
                    64069,
                    53690.5
                  ],
                  [
                    64007.8,
                    53632.2
                  ],
                  [
                    63888.1,
                    53592.8
                  ],
                  [
                    63777.8,
                    53573.9
                  ],
                  [
                    63659.1,
                    53591.4
                  ],
                  [
                    63666.7,
                    53964.1
                  ]
                ],
                "id": 1485,
                "chat_link": "[&BM0FAAA=]"
              },
              "1490": {
                "name": "The Foundry",
                "level": 80,
                "coord": [
                  64168,
                  54396.7
                ],
                "bounds": [
                  [
                    63698.7,
                    54238
                  ],
                  [
                    63676.6,
                    54423.3
                  ],
                  [
                    63734.9,
                    54603.1
                  ],
                  [
                    63838.6,
                    54625.6
                  ],
                  [
                    63927.1,
                    54631.5
                  ],
                  [
                    64127.1,
                    54628.2
                  ],
                  [
                    64309.5,
                    54609.4
                  ],
                  [
                    64345,
                    54762.5
                  ],
                  [
                    64582.9,
                    54634.8
                  ],
                  [
                    64557.7,
                    54503.3
                  ],
                  [
                    64648.1,
                    54344.7
                  ],
                  [
                    64624.5,
                    54282.6
                  ],
                  [
                    64548.7,
                    54233.3
                  ],
                  [
                    64411.6,
                    54035.6
                  ],
                  [
                    64167.6,
                    54048.9
                  ],
                  [
                    64036.4,
                    54157.6
                  ],
                  [
                    63908.7,
                    54193.1
                  ],
                  [
                    63880.5,
                    54186
                  ],
                  [
                    63698.7,
                    54238
                  ]
                ],
                "id": 1490,
                "chat_link": "[&BNIFAAA=]"
              },
              "1500": {
                "name": "Isha Corridor",
                "level": 80,
                "coord": [
                  65686.4,
                  53869.5
                ],
                "bounds": [
                  [
                    66149.2,
                    53850.9
                  ],
                  [
                    66297.7,
                    53807
                  ],
                  [
                    66396.9,
                    53767.1
                  ],
                  [
                    66394.9,
                    53742.7
                  ],
                  [
                    66330.5,
                    53698.1
                  ],
                  [
                    66305.2,
                    53638
                  ],
                  [
                    66324.2,
                    53555.9
                  ],
                  [
                    66300.2,
                    53564
                  ],
                  [
                    66011.2,
                    53558.8
                  ],
                  [
                    65941.9,
                    53557
                  ],
                  [
                    65907.9,
                    53540.2
                  ],
                  [
                    65755.5,
                    53552.4
                  ],
                  [
                    65176.9,
                    53561.7
                  ],
                  [
                    65062.2,
                    53565.1
                  ],
                  [
                    65115.4,
                    53625.4
                  ],
                  [
                    65079.2,
                    53818.7
                  ],
                  [
                    65006.3,
                    53894.9
                  ],
                  [
                    64975.3,
                    54014.6
                  ],
                  [
                    64980.3,
                    54068.7
                  ],
                  [
                    65011.8,
                    54158.9
                  ],
                  [
                    65095,
                    54267.5
                  ],
                  [
                    65263.6,
                    54267.3
                  ],
                  [
                    65315.6,
                    54202.4
                  ],
                  [
                    65368.9,
                    54154
                  ],
                  [
                    65512.2,
                    54125.6
                  ],
                  [
                    65609.5,
                    54167.7
                  ],
                  [
                    65715.5,
                    54249
                  ],
                  [
                    65813.2,
                    54261.4
                  ],
                  [
                    65832.4,
                    54114.8
                  ],
                  [
                    65825,
                    53871.5
                  ],
                  [
                    65993.7,
                    53779.5
                  ],
                  [
                    66098,
                    53824.8
                  ],
                  [
                    66149.2,
                    53850.9
                  ]
                ],
                "id": 1500,
                "chat_link": "[&BNwFAAA=]"
              },
              "1504": {
                "name": "Purling Deep",
                "level": 80,
                "coord": [
                  64560.7,
                  52454.8
                ],
                "bounds": [
                  [
                    64693.7,
                    52354.1
                  ],
                  [
                    64493.8,
                    52311.5
                  ],
                  [
                    64441.4,
                    52305.4
                  ],
                  [
                    64405.7,
                    52330.2
                  ],
                  [
                    64364.5,
                    52334.3
                  ],
                  [
                    64299,
                    52393.5
                  ],
                  [
                    64276.9,
                    52478.6
                  ],
                  [
                    64322,
                    52547.9
                  ],
                  [
                    64370.5,
                    52598.9
                  ],
                  [
                    64435.4,
                    52600.4
                  ],
                  [
                    64524.4,
                    52579.2
                  ],
                  [
                    64570.1,
                    52517.7
                  ],
                  [
                    64650.6,
                    52494.9
                  ],
                  [
                    64756.5,
                    52538
                  ],
                  [
                    64840.5,
                    52521.6
                  ],
                  [
                    64913.4,
                    52493.2
                  ],
                  [
                    64926.5,
                    52427.4
                  ],
                  [
                    64807,
                    52360.4
                  ],
                  [
                    64693.7,
                    52354.1
                  ]
                ],
                "id": 1504,
                "chat_link": "[&BOAFAAA=]"
              },
              "1515": {
                "name": "Resplendent Trace",
                "level": 80,
                "coord": [
                  67525.9,
                  54925.9
                ],
                "bounds": [
                  [
                    67163.7,
                    55390.8
                  ],
                  [
                    67131.6,
                    55517
                  ],
                  [
                    67351.3,
                    55523.2
                  ],
                  [
                    67550.4,
                    55519.3
                  ],
                  [
                    67783.8,
                    55510.4
                  ],
                  [
                    67888.1,
                    55487.2
                  ],
                  [
                    67875.5,
                    55304.9
                  ],
                  [
                    67996.2,
                    55213.8
                  ],
                  [
                    68046.7,
                    55112.1
                  ],
                  [
                    67988.2,
                    54904.7
                  ],
                  [
                    67987.3,
                    54823.1
                  ],
                  [
                    67990.4,
                    54778
                  ],
                  [
                    68124.6,
                    54610.3
                  ],
                  [
                    67942.1,
                    54564.5
                  ],
                  [
                    67912.4,
                    54361
                  ],
                  [
                    67695.2,
                    54298.4
                  ],
                  [
                    67283.1,
                    54306.1
                  ],
                  [
                    67249.5,
                    54363.7
                  ],
                  [
                    67225,
                    54627.5
                  ],
                  [
                    66978.9,
                    54690.1
                  ],
                  [
                    66784.1,
                    54693.8
                  ],
                  [
                    66803.6,
                    54775.3
                  ],
                  [
                    66887,
                    54880.2
                  ],
                  [
                    66982.5,
                    54966.7
                  ],
                  [
                    67163.7,
                    55390.8
                  ]
                ],
                "id": 1515,
                "chat_link": "[&BOsFAAA=]"
              },
              "1523": {
                "name": "Vehtendi Arena",
                "level": 80,
                "coord": [
                  66168.3,
                  54552.3
                ],
                "bounds": [
                  [
                    66052.6,
                    54275.6
                  ],
                  [
                    65969.1,
                    54278.4
                  ],
                  [
                    65986.7,
                    54439.2
                  ],
                  [
                    65920.9,
                    54519
                  ],
                  [
                    65936.5,
                    54656.7
                  ],
                  [
                    65945.4,
                    54724.5
                  ],
                  [
                    66081,
                    54826.4
                  ],
                  [
                    66322.3,
                    54787.7
                  ],
                  [
                    66459.7,
                    54721.1
                  ],
                  [
                    66493.8,
                    54628.5
                  ],
                  [
                    66497.1,
                    54504.4
                  ],
                  [
                    66354.4,
                    54266
                  ],
                  [
                    66052.6,
                    54275.6
                  ]
                ],
                "id": 1523,
                "chat_link": "[&BPMFAAA=]"
              },
              "1529": {
                "name": "Eastern Mihan Hillsides",
                "level": 80,
                "coord": [
                  65925.4,
                  52605.3
                ],
                "bounds": [
                  [
                    65389.9,
                    52578.2
                  ],
                  [
                    65400.8,
                    52520.3
                  ],
                  [
                    65456.9,
                    52482.8
                  ],
                  [
                    65453.4,
                    52375.7
                  ],
                  [
                    65574.3,
                    52351.2
                  ],
                  [
                    65871.9,
                    52373.7
                  ],
                  [
                    66124.1,
                    52376.3
                  ],
                  [
                    66398.5,
                    52394.1
                  ],
                  [
                    66399.1,
                    52540.4
                  ],
                  [
                    66427.9,
                    52657.1
                  ],
                  [
                    66496.1,
                    52769.9
                  ],
                  [
                    66493.2,
                    52797.9
                  ],
                  [
                    66353,
                    52833.1
                  ],
                  [
                    66209.3,
                    52833.2
                  ],
                  [
                    65827.3,
                    52842.8
                  ],
                  [
                    65432.8,
                    52836.5
                  ],
                  [
                    65422.8,
                    52726.3
                  ],
                  [
                    65389.9,
                    52578.2
                  ]
                ],
                "id": 1529,
                "chat_link": "[&BPkFAAA=]"
              },
              "1536": {
                "name": "Yahnur Plateau",
                "level": 80,
                "coord": [
                  68148.5,
                  55011.4
                ],
                "bounds": [
                  [
                    67888.6,
                    55487.2
                  ],
                  [
                    68419.6,
                    55508.2
                  ],
                  [
                    68448.9,
                    55393.5
                  ],
                  [
                    68432.7,
                    54861.7
                  ],
                  [
                    68409.9,
                    54597.2
                  ],
                  [
                    68319.9,
                    54555.9
                  ],
                  [
                    68124.4,
                    54610.1
                  ],
                  [
                    67989.7,
                    54777.4
                  ],
                  [
                    67987.2,
                    54821.8
                  ],
                  [
                    67988.6,
                    54904.9
                  ],
                  [
                    68048.3,
                    55111.9
                  ],
                  [
                    67995.9,
                    55213.5
                  ],
                  [
                    67876.6,
                    55305
                  ],
                  [
                    67888.6,
                    55487.2
                  ]
                ],
                "id": 1536,
                "chat_link": "[&BAAGAAA=]"
              },
              "1545": {
                "name": "Garden of Seborhin",
                "level": 80,
                "coord": [
                  65690.6,
                  53192.1
                ],
                "bounds": [
                  [
                    64799.9,
                    53005.3
                  ],
                  [
                    64856.8,
                    52859
                  ],
                  [
                    64981.1,
                    52834.3
                  ],
                  [
                    65146.8,
                    52836.6
                  ],
                  [
                    65298.9,
                    52836.4
                  ],
                  [
                    65432.3,
                    52836.8
                  ],
                  [
                    65827.6,
                    52841.4
                  ],
                  [
                    66209.3,
                    52832.5
                  ],
                  [
                    66352.5,
                    52833.8
                  ],
                  [
                    66494,
                    52798.5
                  ],
                  [
                    66562.7,
                    52918.8
                  ],
                  [
                    66506.3,
                    53036.9
                  ],
                  [
                    66452.3,
                    53064.9
                  ],
                  [
                    66434.1,
                    53147.2
                  ],
                  [
                    66434.4,
                    53221
                  ],
                  [
                    66443.9,
                    53281.1
                  ],
                  [
                    66518.9,
                    53389.5
                  ],
                  [
                    66511.9,
                    53507.1
                  ],
                  [
                    66475.1,
                    53563.7
                  ],
                  [
                    66314.4,
                    53572.8
                  ],
                  [
                    66069.8,
                    53570.4
                  ],
                  [
                    65767.5,
                    53571.3
                  ],
                  [
                    65278.5,
                    53564.4
                  ],
                  [
                    65179,
                    53564.2
                  ],
                  [
                    65062.3,
                    53564.6
                  ],
                  [
                    64948.8,
                    53460.2
                  ],
                  [
                    64918.8,
                    53418.2
                  ],
                  [
                    64835.4,
                    53387.2
                  ],
                  [
                    64757.2,
                    53283.2
                  ],
                  [
                    64764.8,
                    53205.8
                  ],
                  [
                    64773.7,
                    53148.9
                  ],
                  [
                    64799.9,
                    53005.3
                  ]
                ],
                "id": 1545,
                "chat_link": "[&BAkGAAA=]"
              },
              "1552": {
                "name": "Dzasha Uplands",
                "level": 80,
                "coord": [
                  67895.3,
                  52896
                ],
                "bounds": [
                  [
                    67233.4,
                    52481.6
                  ],
                  [
                    67288.3,
                    52455.9
                  ],
                  [
                    67398.8,
                    52391.2
                  ],
                  [
                    67620.9,
                    52405.8
                  ],
                  [
                    67938,
                    52443.6
                  ],
                  [
                    68225.5,
                    52587.9
                  ],
                  [
                    68268.1,
                    52854.3
                  ],
                  [
                    68342.5,
                    52982
                  ],
                  [
                    68404.4,
                    53028.7
                  ],
                  [
                    68422.8,
                    53156
                  ],
                  [
                    68428.4,
                    53333.1
                  ],
                  [
                    68385.1,
                    53458
                  ],
                  [
                    68384.3,
                    53459.3
                  ],
                  [
                    67842.5,
                    53383.8
                  ],
                  [
                    67896.8,
                    53185.3
                  ],
                  [
                    67878.4,
                    52952.6
                  ],
                  [
                    67761.5,
                    52882.7
                  ],
                  [
                    67585.4,
                    52849.9
                  ],
                  [
                    67352.7,
                    52859.5
                  ],
                  [
                    67247.9,
                    52769.2
                  ],
                  [
                    67233.4,
                    52481.6
                  ]
                ],
                "id": 1552,
                "chat_link": "[&BBAGAAA=]"
              },
              "1553": {
                "name": "Grand Court of Sebelkeh",
                "level": 80,
                "coord": [
                  67526.9,
                  53116.7
                ],
                "bounds": [
                  [
                    67250.7,
                    52771.1
                  ],
                  [
                    67359.5,
                    52840.4
                  ],
                  [
                    67590.6,
                    52810.7
                  ],
                  [
                    67755.9,
                    52839.1
                  ],
                  [
                    67877.5,
                    52949.8
                  ],
                  [
                    67894.5,
                    53180.8
                  ],
                  [
                    67847,
                    53381.7
                  ],
                  [
                    67566.8,
                    53551.1
                  ],
                  [
                    67373.8,
                    53447.5
                  ],
                  [
                    67209,
                    53490.3
                  ],
                  [
                    67071,
                    53021.1
                  ],
                  [
                    67250.7,
                    52771.1
                  ]
                ],
                "id": 1553,
                "chat_link": "[&BBEGAAA=]"
              },
              "1555": {
                "name": "Kaluun Ravine",
                "level": 80,
                "coord": [
                  65700.8,
                  55118.1
                ],
                "bounds": [
                  [
                    66086,
                    55505
                  ],
                  [
                    66083.5,
                    55410.1
                  ],
                  [
                    66128.4,
                    55283.7
                  ],
                  [
                    66111.2,
                    55052.2
                  ],
                  [
                    66082.8,
                    54826.2
                  ],
                  [
                    65946.5,
                    54727.4
                  ],
                  [
                    65501.9,
                    54888.9
                  ],
                  [
                    65365.4,
                    55017.7
                  ],
                  [
                    65237.4,
                    54949.3
                  ],
                  [
                    65072.9,
                    55125.1
                  ],
                  [
                    65093,
                    55513.4
                  ],
                  [
                    66086,
                    55505
                  ]
                ],
                "id": 1555,
                "chat_link": "[&BBMGAAA=]"
              },
              "1556": {
                "name": "Forum Highlands",
                "level": 80,
                "coord": [
                  65526,
                  54462.2
                ],
                "bounds": [
                  [
                    65843.6,
                    54285.6
                  ],
                  [
                    65971.1,
                    54277.7
                  ],
                  [
                    65985.7,
                    54440.2
                  ],
                  [
                    65921.4,
                    54519
                  ],
                  [
                    65945.4,
                    54725.9
                  ],
                  [
                    65501.8,
                    54889.7
                  ],
                  [
                    65365.2,
                    55016.6
                  ],
                  [
                    65238.4,
                    54950.6
                  ],
                  [
                    65224.1,
                    54815.4
                  ],
                  [
                    65221.1,
                    54633.2
                  ],
                  [
                    65084.1,
                    54535.8
                  ],
                  [
                    65097.2,
                    54270.2
                  ],
                  [
                    65264.4,
                    54266.8
                  ],
                  [
                    65314.5,
                    54201.3
                  ],
                  [
                    65369.8,
                    54154.5
                  ],
                  [
                    65512.2,
                    54124.2
                  ],
                  [
                    65607,
                    54167.5
                  ],
                  [
                    65712.6,
                    54248.8
                  ],
                  [
                    65814,
                    54259
                  ],
                  [
                    65843.6,
                    54285.6
                  ]
                ],
                "id": 1556,
                "chat_link": "[&BBQGAAA=]"
              },
              "1566": {
                "name": "Jennur's Run",
                "level": 80,
                "coord": [
                  64765,
                  53756.9
                ],
                "bounds": [
                  [
                    64635,
                    52976.9
                  ],
                  [
                    64470.4,
                    52956.5
                  ],
                  [
                    64420.4,
                    53172
                  ],
                  [
                    64463.5,
                    53389.9
                  ],
                  [
                    64507.9,
                    53493.8
                  ],
                  [
                    64603.1,
                    53667.3
                  ],
                  [
                    64395.6,
                    53815.8
                  ],
                  [
                    64413,
                    53874.1
                  ],
                  [
                    64411.6,
                    54035.6
                  ],
                  [
                    64549.4,
                    54233.9
                  ],
                  [
                    64625.6,
                    54283.4
                  ],
                  [
                    64651.7,
                    54347.2
                  ],
                  [
                    64836.2,
                    54450.4
                  ],
                  [
                    64975.4,
                    54426.9
                  ],
                  [
                    65090.6,
                    54419.8
                  ],
                  [
                    65096.4,
                    54270.8
                  ],
                  [
                    65011.5,
                    54159.9
                  ],
                  [
                    64975.1,
                    54014.7
                  ],
                  [
                    65006.6,
                    53894.8
                  ],
                  [
                    65080.3,
                    53818
                  ],
                  [
                    65115.6,
                    53625.7
                  ],
                  [
                    65061.4,
                    53564.8
                  ],
                  [
                    64948.6,
                    53461
                  ],
                  [
                    64918.3,
                    53420
                  ],
                  [
                    64834.8,
                    53383.3
                  ],
                  [
                    64756.4,
                    53284.1
                  ],
                  [
                    64799.5,
                    52994.9
                  ],
                  [
                    64635,
                    52976.9
                  ]
                ],
                "id": 1566,
                "chat_link": "[&BB4GAAA=]"
              },
              "1569": {
                "name": "Vehjin Palace",
                "level": 80,
                "coord": [
                  64164.8,
                  53448.2
                ],
                "bounds": [
                  [
                    63677.4,
                    53027
                  ],
                  [
                    63658.8,
                    53591.4
                  ],
                  [
                    63778,
                    53574.2
                  ],
                  [
                    63888.2,
                    53592.8
                  ],
                  [
                    64007.6,
                    53632.3
                  ],
                  [
                    64069.1,
                    53690.5
                  ],
                  [
                    64113.7,
                    53771.8
                  ],
                  [
                    64292.2,
                    53836.5
                  ],
                  [
                    64353.9,
                    53835.1
                  ],
                  [
                    64395.7,
                    53814.9
                  ],
                  [
                    64602.9,
                    53667.4
                  ],
                  [
                    64506.8,
                    53491
                  ],
                  [
                    64462.9,
                    53389
                  ],
                  [
                    64420.2,
                    53168.9
                  ],
                  [
                    64470.5,
                    52955.7
                  ],
                  [
                    64252.1,
                    52968.8
                  ],
                  [
                    64072.8,
                    53000.2
                  ],
                  [
                    63944.5,
                    53059.3
                  ],
                  [
                    63677.4,
                    53027
                  ]
                ],
                "id": 1569,
                "chat_link": "[&BCEGAAA=]"
              },
              "1571": {
                "name": "Kodash Bazaar",
                "level": 80,
                "coord": [
                  66635.8,
                  53948
                ],
                "bounds": [
                  [
                    65996.8,
                    53781.3
                  ],
                  [
                    65949.6,
                    53806.8
                  ],
                  [
                    65826.6,
                    53875.5
                  ],
                  [
                    65833.1,
                    54113.9
                  ],
                  [
                    65814.3,
                    54257
                  ],
                  [
                    65843.3,
                    54285.3
                  ],
                  [
                    66054.3,
                    54274.8
                  ],
                  [
                    66355.4,
                    54265.4
                  ],
                  [
                    66498.2,
                    54504.8
                  ],
                  [
                    66494,
                    54629.1
                  ],
                  [
                    66712.4,
                    54696.6
                  ],
                  [
                    66978.2,
                    54688.8
                  ],
                  [
                    67226.6,
                    54626
                  ],
                  [
                    67249.8,
                    54364
                  ],
                  [
                    67283.3,
                    54305.5
                  ],
                  [
                    67693.5,
                    54298.3
                  ],
                  [
                    67697.5,
                    54033.4
                  ],
                  [
                    67537.1,
                    54003.9
                  ],
                  [
                    67417.7,
                    53899
                  ],
                  [
                    67324.8,
                    53842.9
                  ],
                  [
                    67210.9,
                    53823.1
                  ],
                  [
                    67054,
                    53795
                  ],
                  [
                    67014.1,
                    53615.1
                  ],
                  [
                    66895.9,
                    53578.3
                  ],
                  [
                    66905.8,
                    53483
                  ],
                  [
                    66778,
                    53413.8
                  ],
                  [
                    66687.5,
                    53395.7
                  ],
                  [
                    66518.6,
                    53388
                  ],
                  [
                    66507.8,
                    53500.1
                  ],
                  [
                    66473.1,
                    53565.3
                  ],
                  [
                    66334.8,
                    53561.9
                  ],
                  [
                    66309.8,
                    53647.8
                  ],
                  [
                    66334.3,
                    53697.6
                  ],
                  [
                    66401.2,
                    53741.3
                  ],
                  [
                    66396.2,
                    53774
                  ],
                  [
                    66302,
                    53811
                  ],
                  [
                    66152.8,
                    53852.6
                  ],
                  [
                    66097,
                    53828.4
                  ],
                  [
                    65996.8,
                    53781.3
                  ]
                ],
                "id": 1571,
                "chat_link": "[&BCMGAAA=]"
              },
              "1572": {
                "name": "Dehwan Expanse",
                "level": 80,
                "coord": [
                  66752,
                  52998
                ],
                "bounds": [
                  [
                    66894.7,
                    53579.3
                  ],
                  [
                    66905.6,
                    53483.1
                  ],
                  [
                    66777.9,
                    53413.8
                  ],
                  [
                    66688.1,
                    53396.4
                  ],
                  [
                    66518.6,
                    53389.1
                  ],
                  [
                    66435.3,
                    53221.9
                  ],
                  [
                    66435.6,
                    53142
                  ],
                  [
                    66458,
                    53061.3
                  ],
                  [
                    66497.5,
                    53042.4
                  ],
                  [
                    66568.4,
                    52915.8
                  ],
                  [
                    66492.8,
                    52797.5
                  ],
                  [
                    66496,
                    52770.6
                  ],
                  [
                    66429.1,
                    52658.8
                  ],
                  [
                    66400.5,
                    52541.2
                  ],
                  [
                    66398,
                    52395.1
                  ],
                  [
                    66696.9,
                    52383.1
                  ],
                  [
                    66916.8,
                    52427.2
                  ],
                  [
                    67105.1,
                    52435.1
                  ],
                  [
                    67233.4,
                    52481.6
                  ],
                  [
                    67247.8,
                    52773
                  ],
                  [
                    67069.6,
                    53023.9
                  ],
                  [
                    67208.3,
                    53491.7
                  ],
                  [
                    67159.5,
                    53515.3
                  ],
                  [
                    67015,
                    53613
                  ],
                  [
                    66894.7,
                    53579.3
                  ]
                ],
                "id": 1572,
                "chat_link": "[&BCQGAAA=]"
              },
              "1576": {
                "name": "Cragged Vale",
                "level": 80,
                "coord": [
                  64024.7,
                  52819.3
                ],
                "bounds": [
                  [
                    63669.7,
                    52660.9
                  ],
                  [
                    63676.7,
                    53026.7
                  ],
                  [
                    63943.9,
                    53059.1
                  ],
                  [
                    64073.1,
                    53000.5
                  ],
                  [
                    64252.6,
                    52969.1
                  ],
                  [
                    64470.3,
                    52954.8
                  ],
                  [
                    64368.7,
                    52593.7
                  ],
                  [
                    63942.8,
                    52546.1
                  ],
                  [
                    63824.7,
                    52562.5
                  ],
                  [
                    63669.7,
                    52660.9
                  ]
                ],
                "id": 1576,
                "chat_link": "[&BCgGAAA=]"
              },
              "1583": {
                "name": "The Necropolis",
                "level": 80,
                "coord": [
                  64737.6,
                  54825.9
                ],
                "bounds": [
                  [
                    64307.7,
                    55138.9
                  ],
                  [
                    64234.5,
                    55270.3
                  ],
                  [
                    64219,
                    55518.8
                  ],
                  [
                    65091.9,
                    55514
                  ],
                  [
                    65072.9,
                    55125.3
                  ],
                  [
                    65238,
                    54948.9
                  ],
                  [
                    65223,
                    54814.1
                  ],
                  [
                    65221.1,
                    54631.2
                  ],
                  [
                    65084.6,
                    54535.8
                  ],
                  [
                    65091.2,
                    54418.9
                  ],
                  [
                    64973.5,
                    54425.4
                  ],
                  [
                    64836.2,
                    54450
                  ],
                  [
                    64650.2,
                    54345.5
                  ],
                  [
                    64557,
                    54503.2
                  ],
                  [
                    64582.2,
                    54634.7
                  ],
                  [
                    64344.8,
                    54762.4
                  ],
                  [
                    64306.2,
                    54838.7
                  ],
                  [
                    64241.8,
                    54990.4
                  ],
                  [
                    64307.7,
                    55138.9
                  ]
                ],
                "id": 1583,
                "chat_link": "[&BC8GAAA=]"
              },
              "1586": {
                "name": "Vehtendi Academy",
                "level": 80,
                "coord": [
                  66549,
                  55008.7
                ],
                "bounds": [
                  [
                    67130.6,
                    55516.6
                  ],
                  [
                    67163.3,
                    55389.7
                  ],
                  [
                    66982.9,
                    54967.6
                  ],
                  [
                    66886.5,
                    54879.7
                  ],
                  [
                    66804.3,
                    54771.6
                  ],
                  [
                    66783.7,
                    54695
                  ],
                  [
                    66712.8,
                    54696.7
                  ],
                  [
                    66494.9,
                    54630.7
                  ],
                  [
                    66457.5,
                    54721.6
                  ],
                  [
                    66322.1,
                    54787.4
                  ],
                  [
                    66081.4,
                    54826.7
                  ],
                  [
                    66114.1,
                    55052
                  ],
                  [
                    66131.9,
                    55281.8
                  ],
                  [
                    66083.3,
                    55408.6
                  ],
                  [
                    66086.3,
                    55505.1
                  ],
                  [
                    67130.6,
                    55516.6
                  ]
                ],
                "id": 1586,
                "chat_link": "[&BDIGAAA=]"
              },
              "1592": {
                "name": "Glowering Overlook",
                "level": 80,
                "coord": [
                  64011.4,
                  54986.9
                ],
                "bounds": [
                  [
                    64219.2,
                    55519.5
                  ],
                  [
                    63959,
                    55508.2
                  ],
                  [
                    63831.3,
                    55411.7
                  ],
                  [
                    63727,
                    55246
                  ],
                  [
                    63682,
                    55106.7
                  ],
                  [
                    63689.3,
                    54749.4
                  ],
                  [
                    63732,
                    54605
                  ],
                  [
                    63838.1,
                    54625.8
                  ],
                  [
                    63926.3,
                    54632.2
                  ],
                  [
                    64127.7,
                    54627.9
                  ],
                  [
                    64309.9,
                    54608.6
                  ],
                  [
                    64343.4,
                    54762.9
                  ],
                  [
                    64242.1,
                    54990.7
                  ],
                  [
                    64307.2,
                    55140.2
                  ],
                  [
                    64235.8,
                    55269
                  ],
                  [
                    64219.2,
                    55519.5
                  ]
                ],
                "id": 1592,
                "chat_link": "[&BDgGAAA=]"
              },
              "1595": {
                "name": "Zagonur Cliffs",
                "level": 80,
                "coord": [
                  67892.7,
                  53962.3
                ],
                "bounds": [
                  [
                    68450.2,
                    54220.1
                  ],
                  [
                    68451.7,
                    54368.8
                  ],
                  [
                    68443.8,
                    54505.4
                  ],
                  [
                    68412.2,
                    54602.9
                  ],
                  [
                    68319.2,
                    54555.4
                  ],
                  [
                    68125.5,
                    54610.6
                  ],
                  [
                    67944.8,
                    54560
                  ],
                  [
                    67912.6,
                    54360.6
                  ],
                  [
                    67695.4,
                    54297.8
                  ],
                  [
                    67696.7,
                    54035.4
                  ],
                  [
                    67536,
                    54002.8
                  ],
                  [
                    67418.2,
                    53899.7
                  ],
                  [
                    67324.9,
                    53842.8
                  ],
                  [
                    67210.5,
                    53823.4
                  ],
                  [
                    67055.5,
                    53796.1
                  ],
                  [
                    67013,
                    53612.8
                  ],
                  [
                    67159.5,
                    53515.6
                  ],
                  [
                    67209.9,
                    53492.3
                  ],
                  [
                    67374.1,
                    53448.4
                  ],
                  [
                    67566.9,
                    53552.6
                  ],
                  [
                    67845.2,
                    53384.8
                  ],
                  [
                    68385.1,
                    53458
                  ],
                  [
                    68400,
                    53537.4
                  ],
                  [
                    68400.8,
                    53671.4
                  ],
                  [
                    68391.9,
                    53809
                  ],
                  [
                    68384.5,
                    53920.2
                  ],
                  [
                    68424.6,
                    53968.4
                  ],
                  [
                    68442.3,
                    54092.7
                  ],
                  [
                    68450.2,
                    54220.1
                  ]
                ],
                "id": 1595,
                "chat_link": "[&BDsGAAA=]"
              }
            },
            "adventures": [],
            "id": 1219,
            "mastery_points": []
          },
          "1222": {
            "name": "Claiming Windswept Haven",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 49,
            "label_coord": [
              64672,
              51646
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                64016,
                51072
              ],
              [
                65296,
                52352
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1518": {
                "level": 0,
                "coord": [
                  64748.2,
                  51688.9
                ],
                "bounds": [
                  [
                    65265.6,
                    51274
                  ],
                  [
                    65282.6,
                    51903.2
                  ],
                  [
                    65229.7,
                    52092.6
                  ],
                  [
                    65092.8,
                    52388.4
                  ],
                  [
                    64340.1,
                    52410.9
                  ],
                  [
                    64180.4,
                    51778.5
                  ],
                  [
                    64217.3,
                    51162.9
                  ],
                  [
                    64436.8,
                    51101.1
                  ],
                  [
                    64688.1,
                    51089
                  ],
                  [
                    65265.6,
                    51274
                  ]
                ],
                "id": 1518,
                "chat_link": "[&BO4FAAA=]"
              }
            },
            "id": 1222,
            "mastery_points": [],
            "adventures": []
          },
          "1223": {
            "name": "Small Victory (Epilogue)",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              60176,
              44240
            ],
            "map_rect": [
              [
                -61440,
                -30720
              ],
              [
                61440,
                30720
              ]
            ],
            "continent_rect": [
              [
                57256,
                42304
              ],
              [
                62376,
                44864
              ]
            ],
            "points_of_interest": {
              "2684": {
                "name": "Amnoon Cavalier Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58697.4,
                  43850.5
                ],
                "id": 2684,
                "chat_link": "[&BHwKAAA=]"
              },
              "2751": {
                "name": "Amnoon Bazaar",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58989.6,
                  43751.8
                ],
                "id": 2751,
                "chat_link": "[&BL8KAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1513": {
                "name": "Amnoon Farms",
                "level": 80,
                "coord": [
                  59399.2,
                  43837.4
                ],
                "bounds": [
                  [
                    58847,
                    43967.8
                  ],
                  [
                    58962.8,
                    44046.4
                  ],
                  [
                    58981.7,
                    44123.4
                  ],
                  [
                    58942.7,
                    44174.3
                  ],
                  [
                    58874.5,
                    44256.1
                  ],
                  [
                    59001.8,
                    44288.8
                  ],
                  [
                    59185.7,
                    44286.3
                  ],
                  [
                    59312.2,
                    44375
                  ],
                  [
                    59707.4,
                    44388.4
                  ],
                  [
                    59905.5,
                    44301.3
                  ],
                  [
                    59974.5,
                    44205
                  ],
                  [
                    60062.7,
                    44104.1
                  ],
                  [
                    60000.9,
                    43888.5
                  ],
                  [
                    59929.6,
                    43838.9
                  ],
                  [
                    59902,
                    43733.6
                  ],
                  [
                    59792.9,
                    43698.2
                  ],
                  [
                    59636.8,
                    43647.5
                  ],
                  [
                    59544.6,
                    43595.5
                  ],
                  [
                    59485.5,
                    43477.5
                  ],
                  [
                    59384.8,
                    43408.6
                  ],
                  [
                    59314.6,
                    43334.6
                  ],
                  [
                    59299.4,
                    43221.4
                  ],
                  [
                    59086.8,
                    43104.8
                  ],
                  [
                    58982.4,
                    43173.8
                  ],
                  [
                    58860.4,
                    43296.4
                  ],
                  [
                    58847,
                    43967.8
                  ]
                ],
                "id": 1513,
                "chat_link": "[&BOkFAAA=]"
              },
              "1562": {
                "name": "Free City of Amnoon",
                "level": 80,
                "coord": [
                  58417.9,
                  43644.3
                ],
                "bounds": [
                  [
                    58220.8,
                    44176.2
                  ],
                  [
                    58727,
                    44196.1
                  ],
                  [
                    58874.5,
                    44256.1
                  ],
                  [
                    58942,
                    44173.4
                  ],
                  [
                    58980.9,
                    44123.6
                  ],
                  [
                    58962.3,
                    44046.2
                  ],
                  [
                    58847,
                    43967.2
                  ],
                  [
                    58860.9,
                    43295.6
                  ],
                  [
                    58747.8,
                    43250.8
                  ],
                  [
                    58539.8,
                    43207.2
                  ],
                  [
                    58430.7,
                    43204.8
                  ],
                  [
                    58379.3,
                    43159.2
                  ],
                  [
                    58284.1,
                    43126.7
                  ],
                  [
                    58093.3,
                    43115.7
                  ],
                  [
                    58043.3,
                    43245.2
                  ],
                  [
                    57885.9,
                    43274.9
                  ],
                  [
                    57887.5,
                    43407.1
                  ],
                  [
                    57828.3,
                    43644.2
                  ],
                  [
                    57823.3,
                    43846.7
                  ],
                  [
                    57999.4,
                    44168.3
                  ],
                  [
                    58220.8,
                    44176.2
                  ]
                ],
                "id": 1562,
                "chat_link": "[&BBoGAAA=]"
              }
            },
            "adventures": [],
            "id": 1223,
            "mastery_points": []
          },
          "1224": {
            "name": "Windswept Haven",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              64672,
              51646
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                64016,
                51072
              ],
              [
                65296,
                52352
              ]
            ],
            "points_of_interest": {
              "2690": {
                "name": "Windswept Arena Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64610.8,
                  51738.4
                ],
                "id": 2690,
                "chat_link": "[&BIIKAAA=]"
              },
              "2721": {
                "name": "Cavern Overlook Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64453.1,
                  52290.7
                ],
                "id": 2721,
                "chat_link": "[&BKEKAAA=]"
              },
              "2775": {
                "name": "Vantage Dome Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  65172.6,
                  51485.6
                ],
                "id": 2775,
                "chat_link": "[&BNcKAAA=]"
              },
              "2781": {
                "name": "Haven Terrace Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64843.8,
                  51650.5
                ],
                "id": 2781,
                "chat_link": "[&BN0KAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1518": {
                "level": 0,
                "coord": [
                  64748.2,
                  51688.9
                ],
                "bounds": [
                  [
                    65265.6,
                    51274
                  ],
                  [
                    65282.6,
                    51903.2
                  ],
                  [
                    65229.7,
                    52092.6
                  ],
                  [
                    65092.8,
                    52388.4
                  ],
                  [
                    64340.1,
                    52410.9
                  ],
                  [
                    64180.4,
                    51778.5
                  ],
                  [
                    64217.3,
                    51162.9
                  ],
                  [
                    64436.8,
                    51101.1
                  ],
                  [
                    64688.1,
                    51089
                  ],
                  [
                    65265.6,
                    51274
                  ]
                ],
                "id": 1518,
                "chat_link": "[&BO4FAAA=]"
              }
            },
            "id": 1224,
            "mastery_points": [],
            "adventures": []
          },
          "1226": {
            "name": "The Desolation",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              59868,
              50752
            ],
            "map_rect": [
              [
                -43008,
                -61440
              ],
              [
                43008,
                61440
              ]
            ],
            "continent_rect": [
              [
                58240,
                48192
              ],
              [
                61824,
                53312
              ]
            ],
            "points_of_interest": {
              "2554": {
                "name": "Northern Maw",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59050.9,
                  51347.5
                ],
                "id": 2554,
                "chat_link": "[&BPoJAAA=]"
              },
              "2562": {
                "name": "The Bone Palace",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60543.6,
                  52977.6
                ],
                "id": 2562,
                "chat_link": "[&BAIKAAA=]"
              },
              "2571": {
                "name": "Joko's Domain Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60886.5,
                  52307.6
                ],
                "id": 2571,
                "chat_link": "[&BAsKAAA=]"
              },
              "2577": {
                "name": "Acrid Sink",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58421.2,
                  50180.9
                ],
                "id": 2577,
                "chat_link": "[&BBEKAAA=]"
              },
              "2578": {
                "name": "Junundu Lookout",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60055.6,
                  52616.1
                ],
                "id": 2578,
                "chat_link": "[&BBIKAAA=]"
              },
              "2582": {
                "name": "Matriarch's View",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61171.9,
                  49061.1
                ],
                "id": 2582,
                "chat_link": "[&BBYKAAA=]"
              },
              "2583": {
                "name": "Imperial Sulfurworks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58934.9,
                  49611.9
                ],
                "id": 2583,
                "chat_link": "[&BBcKAAA=]"
              },
              "2586": {
                "name": "Forged Firebase",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60683.4,
                  51575.4
                ],
                "id": 2586,
                "chat_link": "[&BBoKAAA=]"
              },
              "2587": {
                "name": "Springer's Ladder",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61638.7,
                  49365.8
                ],
                "id": 2587,
                "chat_link": "[&BBsKAAA=]"
              },
              "2588": {
                "name": "Zayan Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60356.6,
                  51112.1
                ],
                "id": 2588,
                "chat_link": "[&BBwKAAA=]"
              },
              "2589": {
                "name": "Bleached Pillars",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58611.5,
                  52146.2
                ],
                "id": 2589,
                "chat_link": "[&BB0KAAA=]"
              },
              "2607": {
                "name": "Uhiwi's Bones",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61813.3,
                  51627.4
                ],
                "id": 2607,
                "chat_link": "[&BC8KAAA=]"
              },
              "2609": {
                "name": "Chukeht Overlook",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60213.6,
                  49913.8
                ],
                "id": 2609,
                "chat_link": "[&BDEKAAA=]"
              },
              "2611": {
                "name": "The Vermitheater",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58693.6,
                  52692.3
                ],
                "id": 2611,
                "chat_link": "[&BDMKAAA=]"
              },
              "2617": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  59430.7,
                  52396.5
                ],
                "id": 2617,
                "chat_link": "[&BDkKAAA=]"
              },
              "2619": {
                "name": "Conquest Overlook",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59725.8,
                  51307.9
                ],
                "id": 2619,
                "chat_link": "[&BDsKAAA=]"
              },
              "2626": {
                "name": "Towering Links",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60600.5,
                  50446.3
                ],
                "id": 2626,
                "chat_link": "[&BEIKAAA=]"
              },
              "2638": {
                "name": "Torment's Watch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59296.9,
                  50676.9
                ],
                "id": 2638,
                "chat_link": "[&BE4KAAA=]"
              },
              "2642": {
                "name": "Clanmarshal's Pergola",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60440,
                  49163.7
                ],
                "id": 2642,
                "chat_link": "[&BFIKAAA=]"
              },
              "2644": {
                "name": "Forbidden Vault",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61357.1,
                  51963.5
                ],
                "id": 2644,
                "chat_link": "[&BFQKAAA=]"
              },
              "2646": {
                "name": "Lone-Tree Hill",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60332.9,
                  52226.1
                ],
                "id": 2646,
                "chat_link": "[&BFYKAAA=]"
              },
              "2648": {
                "name": "Fort Huduh",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61028.2,
                  51792.6
                ],
                "id": 2648,
                "chat_link": "[&BFgKAAA=]"
              },
              "2649": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58521.1,
                  49167.4
                ],
                "id": 2649,
                "chat_link": "[&BFkKAAA=]"
              },
              "2653": {
                "name": "Vabbian Corridor",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61615.5,
                  51921.4
                ],
                "id": 2653,
                "chat_link": "[&BF0KAAA=]"
              },
              "2654": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  61396.3,
                  51036.1
                ],
                "id": 2654,
                "chat_link": "[&BF4KAAA=]"
              },
              "2660": {
                "name": "The Mouth of Torment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59058.3,
                  51518.8
                ],
                "id": 2660,
                "chat_link": "[&BGQKAAA=]"
              },
              "2664": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  59891.8,
                  48411.7
                ],
                "id": 2664,
                "chat_link": "[&BGgKAAA=]"
              },
              "2665": {
                "name": "Ember Heights",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60783.2,
                  49891.5
                ],
                "id": 2665,
                "chat_link": "[&BGkKAAA=]"
              },
              "2668": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  59165.2,
                  50680.8
                ],
                "id": 2668,
                "chat_link": "[&BGwKAAA=]"
              },
              "2672": {
                "name": "Wayward Watch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61155.8,
                  51353.3
                ],
                "id": 2672,
                "chat_link": "[&BHAKAAA=]"
              },
              "2675": {
                "name": "The Scourgeway Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60442.7,
                  50248.3
                ],
                "id": 2675,
                "chat_link": "[&BHMKAAA=]"
              },
              "2679": {
                "name": "Sand Jackal Run Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59123.2,
                  52734.9
                ],
                "id": 2679,
                "chat_link": "[&BHcKAAA=]"
              },
              "2682": {
                "name": "Scourge's Threshold",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59914.4,
                  49633.1
                ],
                "id": 2682,
                "chat_link": "[&BHoKAAA=]"
              },
              "2683": {
                "name": "Lupicus Boneyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61544.2,
                  52820
                ],
                "id": 2683,
                "chat_link": "[&BHsKAAA=]"
              },
              "2689": {
                "name": "Shadow Arcade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61312.3,
                  49804.6
                ],
                "id": 2689,
                "chat_link": "[&BIEKAAA=]"
              },
              "2700": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58976,
                  51531.1
                ],
                "id": 2700,
                "chat_link": "[&BIwKAAA=]"
              },
              "2701": {
                "name": "Eastern Maw",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59213.7,
                  51495.6
                ],
                "id": 2701,
                "chat_link": "[&BI0KAAA=]"
              },
              "2702": {
                "name": "Toxic Pools",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61518.7,
                  50447.2
                ],
                "id": 2702,
                "chat_link": "[&BI4KAAA=]"
              },
              "2709": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60354.9,
                  49066
                ],
                "id": 2709,
                "chat_link": "[&BJUKAAA=]"
              },
              "2718": {
                "name": "Sandfall Sanctum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60653.8,
                  49343.9
                ],
                "id": 2718,
                "chat_link": "[&BJ4KAAA=]"
              },
              "2719": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60443.5,
                  49770.1
                ],
                "id": 2719,
                "chat_link": "[&BJ8KAAA=]"
              },
              "2723": {
                "name": "The Darklands Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59187.1,
                  50521.2
                ],
                "id": 2723,
                "chat_link": "[&BKMKAAA=]"
              },
              "2727": {
                "name": "Bonestrand Garrison",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59634.7,
                  48879.9
                ],
                "id": 2727,
                "chat_link": "[&BKcKAAA=]"
              },
              "2728": {
                "name": "Chantry of Shadows",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59389.7,
                  50330.2
                ],
                "id": 2728,
                "chat_link": "[&BKgKAAA=]"
              },
              "2735": {
                "name": "Junundu Hatchery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61296.8,
                  53225.8
                ],
                "id": 2735,
                "chat_link": "[&BK8KAAA=]"
              },
              "2739": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60441.6,
                  52337.3
                ],
                "id": 2739,
                "chat_link": "[&BLMKAAA=]"
              },
              "2753": {
                "name": "Lair of the Forgotten Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  61423.3,
                  51140.4
                ],
                "id": 2753,
                "chat_link": "[&BMEKAAA=]"
              },
              "2754": {
                "name": "Western Maw",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58943.5,
                  51367.6
                ],
                "id": 2754,
                "chat_link": "[&BMIKAAA=]"
              },
              "2759": {
                "name": "Blind Faith",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61203.1,
                  48243.8
                ],
                "id": 2759,
                "chat_link": "[&BMcKAAA=]"
              },
              "2760": {
                "name": "Village of Purity",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60345.6,
                  48711.9
                ],
                "id": 2760,
                "chat_link": "[&BMgKAAA=]"
              },
              "2761": {
                "name": "Revealer Vantage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59725,
                  50917.8
                ],
                "id": 2761,
                "chat_link": "[&BMkKAAA=]"
              },
              "2764": {
                "name": "Bitumen Reserve",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60522.1,
                  53152.7
                ],
                "id": 2764,
                "chat_link": "[&BMwKAAA=]"
              },
              "2766": {
                "name": "Henge of Joko",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60049,
                  51819.9
                ],
                "id": 2766,
                "chat_link": "[&BM4KAAA=]"
              },
              "2770": {
                "name": "Bonecage Paddock",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59368.4,
                  49202.2
                ],
                "id": 2770,
                "chat_link": "[&BNIKAAA=]"
              },
              "2774": {
                "name": "Mount: Jackal",
                "type": "unlock",
                "floor": 1,
                "coord": [
                  59492.6,
                  52635.2
                ],
                "id": 2774,
                "chat_link": "[&BNYKAAA=]",
                "icon": "https://render.guildwars2.com/file/3C75C166F30EB69B45091832513A06C30E7664E8/1770698.png"
              },
              "2778": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  61203.6,
                  48770.4
                ],
                "id": 2778,
                "chat_link": "[&BNoKAAA=]"
              },
              "2780": {
                "name": "Bonestrand Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60080.7,
                  48404.7
                ],
                "id": 2780,
                "chat_link": "[&BNwKAAA=]"
              },
              "2786": {
                "name": "Tarstone Weeps",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61672.4,
                  52384.9
                ],
                "id": 2786,
                "chat_link": "[&BOIKAAA=]"
              },
              "2788": {
                "name": "Sandstrewn Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59019.7,
                  50155.1
                ],
                "id": 2788,
                "chat_link": "[&BOQKAAA=]"
              },
              "2790": {
                "name": "Djinn Enclave",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59469.8,
                  52616.2
                ],
                "id": 2790,
                "chat_link": "[&BOYKAAA=]"
              }
            },
            "tasks": {
              "391": {
                "objective": "Help Drojkor, Spirit Squall, control jackals.",
                "level": 80,
                "coord": [
                  59492.3,
                  52606.2
                ],
                "bounds": [
                  [
                    59838.6,
                    52961.3
                  ],
                  [
                    59995.4,
                    52640.9
                  ],
                  [
                    59731.8,
                    52275.9
                  ],
                  [
                    59376.6,
                    52172.1
                  ],
                  [
                    59025.8,
                    52299.7
                  ],
                  [
                    58881.4,
                    52594.6
                  ],
                  [
                    58874.4,
                    52744.4
                  ],
                  [
                    58994.9,
                    52879.3
                  ],
                  [
                    59170.7,
                    53034.1
                  ],
                  [
                    59489.1,
                    53205.8
                  ],
                  [
                    59838.6,
                    52961.3
                  ]
                ],
                "id": 391,
                "chat_link": "[&BIcBAAA=]"
              },
              "403": {
                "objective": "Help Dunkoro assist local ghosts.",
                "level": 80,
                "coord": [
                  61504.2,
                  51076.3
                ],
                "bounds": [
                  [
                    61560.9,
                    50635.5
                  ],
                  [
                    61350.4,
                    50812.7
                  ],
                  [
                    61109.5,
                    51030.2
                  ],
                  [
                    61183.7,
                    51327.1
                  ],
                  [
                    61374.4,
                    51541.1
                  ],
                  [
                    61806.5,
                    51304.2
                  ],
                  [
                    61829.4,
                    51127.9
                  ],
                  [
                    61903.1,
                    50740.8
                  ],
                  [
                    61560.9,
                    50635.5
                  ]
                ],
                "id": 403,
                "chat_link": "[&BJMBAAA=]"
              },
              "415": {
                "objective": "Help Tariq weaken the garrison.",
                "level": 80,
                "coord": [
                  59786.6,
                  48835
                ],
                "bounds": [
                  [
                    59964.9,
                    48953.8
                  ],
                  [
                    59897.2,
                    48847.3
                  ],
                  [
                    59888.9,
                    48681.4
                  ],
                  [
                    59808.8,
                    48592.3
                  ],
                  [
                    59509.1,
                    48617.7
                  ],
                  [
                    59336.1,
                    48776.2
                  ],
                  [
                    59346.9,
                    48968.6
                  ],
                  [
                    59399.4,
                    49043.5
                  ],
                  [
                    59557.3,
                    49159.9
                  ],
                  [
                    59913,
                    49088.9
                  ],
                  [
                    59964.9,
                    48953.8
                  ]
                ],
                "id": 415,
                "chat_link": "[&BJ8BAAA=]"
              },
              "418": {
                "objective": "Help the Order of Shadows defend against the Forged.",
                "level": 80,
                "coord": [
                  59325.1,
                  50678.4
                ],
                "bounds": [
                  [
                    59608.1,
                    50621.8
                  ],
                  [
                    59281.1,
                    50575.5
                  ],
                  [
                    59171.2,
                    50706.9
                  ],
                  [
                    59094.4,
                    50898
                  ],
                  [
                    59207.8,
                    51161.1
                  ],
                  [
                    59822.6,
                    51121
                  ],
                  [
                    60082.6,
                    50892.7
                  ],
                  [
                    59892.6,
                    50645.2
                  ],
                  [
                    59697.9,
                    50606.3
                  ],
                  [
                    59608.1,
                    50621.8
                  ]
                ],
                "id": 418,
                "chat_link": "[&BKIBAAA=]"
              },
              "419": {
                "objective": "Help Kisha Odili keep the village running.",
                "level": 80,
                "coord": [
                  60369.8,
                  48571.4
                ],
                "bounds": [
                  [
                    60218.9,
                    48171.1
                  ],
                  [
                    60823.7,
                    48202.3
                  ],
                  [
                    60963.8,
                    48615.8
                  ],
                  [
                    60764.4,
                    48908.5
                  ],
                  [
                    60315,
                    48976.9
                  ],
                  [
                    60114.5,
                    48724.3
                  ],
                  [
                    60218.9,
                    48171.1
                  ]
                ],
                "id": 419,
                "chat_link": "[&BKMBAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  58796.1,
                  52558.3
                ],
                "id": "2-20"
              },
              {
                "coord": [
                  61167.3,
                  51061.8
                ],
                "id": "2-21"
              },
              {
                "coord": [
                  58470.6,
                  49147.8
                ],
                "id": "2-22"
              },
              {
                "coord": [
                  60757,
                  50065.7
                ],
                "id": "2-23"
              },
              {
                "coord": [
                  59039.2,
                  51507.9
                ],
                "id": "2-24"
              },
              {
                "coord": [
                  60478.3,
                  52855.5
                ],
                "id": "2-25"
              }
            ],
            "sectors": {
              "1488": {
                "name": "Joko's Domain",
                "level": 80,
                "coord": [
                  60631.5,
                  52729.4
                ],
                "bounds": [
                  [
                    60245.6,
                    52665.1
                  ],
                  [
                    60106,
                    52470.6
                  ],
                  [
                    60416.3,
                    52358.2
                  ],
                  [
                    60482,
                    52129.7
                  ],
                  [
                    61038.5,
                    52043
                  ],
                  [
                    61139.9,
                    52203.8
                  ],
                  [
                    60973.8,
                    52614.6
                  ],
                  [
                    61002.4,
                    52892.6
                  ],
                  [
                    61044.1,
                    52973.9
                  ],
                  [
                    60968.4,
                    53248.7
                  ],
                  [
                    60898.2,
                    53266.9
                  ],
                  [
                    60407,
                    53272.6
                  ],
                  [
                    60070.8,
                    53152.1
                  ],
                  [
                    60047.9,
                    52919.7
                  ],
                  [
                    60245.6,
                    52665.1
                  ]
                ],
                "id": 1488,
                "chat_link": "[&BNAFAAA=]"
              },
              "1489": {
                "name": "The Spillway",
                "level": 80,
                "coord": [
                  59341.9,
                  48516.6
                ],
                "bounds": [
                  [
                    58910.9,
                    48844.1
                  ],
                  [
                    59118.6,
                    48932.7
                  ],
                  [
                    59514.3,
                    48620.6
                  ],
                  [
                    59855.5,
                    48585
                  ],
                  [
                    60033.3,
                    48191.7
                  ],
                  [
                    59193.7,
                    48189.6
                  ],
                  [
                    58767.3,
                    48252.8
                  ],
                  [
                    58910.9,
                    48844.1
                  ]
                ],
                "id": 1489,
                "chat_link": "[&BNEFAAA=]"
              },
              "1502": {
                "name": "The Shattered Ravines",
                "level": 80,
                "coord": [
                  60668.8,
                  51704.8
                ],
                "bounds": [
                  [
                    59968.4,
                    51263.5
                  ],
                  [
                    60555.9,
                    50948.6
                  ],
                  [
                    61225.6,
                    51478.7
                  ],
                  [
                    61595.7,
                    51549
                  ],
                  [
                    61296.9,
                    51989
                  ],
                  [
                    61036.8,
                    52053.2
                  ],
                  [
                    60485.1,
                    52141.1
                  ],
                  [
                    60270.1,
                    52065.1
                  ],
                  [
                    60240.7,
                    51845
                  ],
                  [
                    60012.5,
                    51714.4
                  ],
                  [
                    59968.4,
                    51263.5
                  ]
                ],
                "id": 1502,
                "chat_link": "[&BN4FAAA=]"
              },
              "1508": {
                "name": "Caustic Spur",
                "level": 80,
                "coord": [
                  58509.1,
                  50107
                ],
                "bounds": [
                  [
                    58826.5,
                    50465.4
                  ],
                  [
                    58576.3,
                    50103.2
                  ],
                  [
                    58603.4,
                    49909.4
                  ],
                  [
                    58543.7,
                    49855.1
                  ],
                  [
                    58348.7,
                    49757.1
                  ],
                  [
                    58285,
                    50008.4
                  ],
                  [
                    58380.4,
                    50650.5
                  ],
                  [
                    58826.5,
                    50465.4
                  ]
                ],
                "id": 1508,
                "chat_link": "[&BOQFAAA=]"
              },
              "1522": {
                "name": "Boundary Preserve",
                "level": 80,
                "coord": [
                  61221.5,
                  48971.2
                ],
                "bounds": [
                  [
                    61760.6,
                    48501.5
                  ],
                  [
                    61117.1,
                    48654.9
                  ],
                  [
                    60895.8,
                    48455.4
                  ],
                  [
                    60859.8,
                    48709.6
                  ],
                  [
                    60738.9,
                    48957
                  ],
                  [
                    60896.1,
                    49147.6
                  ],
                  [
                    60971.8,
                    49444.1
                  ],
                  [
                    61484.6,
                    49284.7
                  ],
                  [
                    61728.7,
                    49369.4
                  ],
                  [
                    61761.7,
                    49187.4
                  ],
                  [
                    61760.6,
                    48501.5
                  ]
                ],
                "id": 1522,
                "chat_link": "[&BPIFAAA=]"
              },
              "1526": {
                "name": "The Bonestrand",
                "level": 80,
                "coord": [
                  60287.5,
                  48628.3
                ],
                "bounds": [
                  [
                    60200.9,
                    49006.4
                  ],
                  [
                    60748.1,
                    48959.4
                  ],
                  [
                    60865.6,
                    48711.1
                  ],
                  [
                    60896.8,
                    48452.2
                  ],
                  [
                    60881.7,
                    48460.6
                  ],
                  [
                    60837.5,
                    48367.6
                  ],
                  [
                    60799.9,
                    48379.5
                  ],
                  [
                    60690.6,
                    48181.9
                  ],
                  [
                    60031,
                    48195.2
                  ],
                  [
                    59847.5,
                    48590.9
                  ],
                  [
                    59517.7,
                    48607.4
                  ],
                  [
                    59113.4,
                    48930.4
                  ],
                  [
                    59307.3,
                    49324.8
                  ],
                  [
                    60200.9,
                    49006.4
                  ]
                ],
                "id": 1526,
                "chat_link": "[&BPYFAAA=]"
              },
              "1530": {
                "name": "Acrid Springs",
                "level": 80,
                "coord": [
                  58632.7,
                  48912.7
                ],
                "bounds": [
                  [
                    58477.4,
                    49190
                  ],
                  [
                    58537.8,
                    49300.4
                  ],
                  [
                    58684.2,
                    49254.4
                  ],
                  [
                    58791.6,
                    49072.7
                  ],
                  [
                    59133.2,
                    48926.5
                  ],
                  [
                    58904.1,
                    48837.2
                  ],
                  [
                    58777.5,
                    48249.7
                  ],
                  [
                    58446.3,
                    48290.1
                  ],
                  [
                    58288.5,
                    48818
                  ],
                  [
                    58286.2,
                    49187.9
                  ],
                  [
                    58477.4,
                    49190
                  ]
                ],
                "id": 1530,
                "chat_link": "[&BPoFAAA=]"
              },
              "1533": {
                "name": "The Ruination",
                "level": 80,
                "coord": [
                  59469.5,
                  51065.2
                ],
                "bounds": [
                  [
                    59540.5,
                    51567.3
                  ],
                  [
                    59616.9,
                    51678.3
                  ],
                  [
                    59569.1,
                    51790.2
                  ],
                  [
                    59693.6,
                    51857.6
                  ],
                  [
                    59932.3,
                    51818
                  ],
                  [
                    60012.9,
                    51709.8
                  ],
                  [
                    59974.4,
                    51251.1
                  ],
                  [
                    60016.6,
                    50584.8
                  ],
                  [
                    59831.8,
                    50382.6
                  ],
                  [
                    59768.5,
                    50511.4
                  ],
                  [
                    59328.5,
                    50554
                  ],
                  [
                    59129.4,
                    50518.2
                  ],
                  [
                    59118,
                    50415.2
                  ],
                  [
                    58748.6,
                    50476.2
                  ],
                  [
                    58697.6,
                    50885.2
                  ],
                  [
                    58881.5,
                    50922.3
                  ],
                  [
                    59173.6,
                    50835.7
                  ],
                  [
                    59446.5,
                    51133.6
                  ],
                  [
                    59440.3,
                    51348.2
                  ],
                  [
                    59540.5,
                    51567.3
                  ]
                ],
                "id": 1533,
                "chat_link": "[&BP0FAAA=]"
              },
              "1547": {
                "name": "Broken Shelf",
                "level": 80,
                "coord": [
                  58797.3,
                  52282.8
                ],
                "bounds": [
                  [
                    58324.7,
                    52619.2
                  ],
                  [
                    58534.8,
                    52751.3
                  ],
                  [
                    58698.6,
                    52580.1
                  ],
                  [
                    58808,
                    52611.8
                  ],
                  [
                    58876.2,
                    52575.1
                  ],
                  [
                    59029.4,
                    52308.5
                  ],
                  [
                    59199.9,
                    52303
                  ],
                  [
                    59374.3,
                    52255.5
                  ],
                  [
                    59256.8,
                    51886.1
                  ],
                  [
                    58859.2,
                    51908.5
                  ],
                  [
                    58794.5,
                    51840.3
                  ],
                  [
                    58310.2,
                    51978.7
                  ],
                  [
                    58298,
                    52058.8
                  ],
                  [
                    58324.7,
                    52619.2
                  ]
                ],
                "id": 1547,
                "chat_link": "[&BAsGAAA=]"
              },
              "1548": {
                "name": "The Alkali Pan",
                "level": 80,
                "coord": [
                  59345,
                  52685
                ],
                "bounds": [
                  [
                    59949.3,
                    52251.9
                  ],
                  [
                    59331.4,
                    52153.5
                  ],
                  [
                    59411.3,
                    52392.3
                  ],
                  [
                    59548.6,
                    52416.8
                  ],
                  [
                    59784.3,
                    52644.3
                  ],
                  [
                    59776.9,
                    52724
                  ],
                  [
                    59588.8,
                    52855.5
                  ],
                  [
                    59580.3,
                    52949.6
                  ],
                  [
                    59418.3,
                    53007.1
                  ],
                  [
                    59149.9,
                    52844.8
                  ],
                  [
                    59014.3,
                    52843.6
                  ],
                  [
                    58969.1,
                    52757.6
                  ],
                  [
                    59168,
                    52483.2
                  ],
                  [
                    59418.2,
                    52389.8
                  ],
                  [
                    59372.9,
                    52252.8
                  ],
                  [
                    59201.5,
                    52297.1
                  ],
                  [
                    59026.9,
                    52302.6
                  ],
                  [
                    58870.2,
                    52571.6
                  ],
                  [
                    58795.2,
                    52611.7
                  ],
                  [
                    58693.2,
                    52576.2
                  ],
                  [
                    58535.9,
                    52746.8
                  ],
                  [
                    58626.3,
                    53162.3
                  ],
                  [
                    58703.9,
                    53270.1
                  ],
                  [
                    59995.7,
                    53267.8
                  ],
                  [
                    60079.1,
                    53145.8
                  ],
                  [
                    60052.1,
                    52915.5
                  ],
                  [
                    60253.7,
                    52660.8
                  ],
                  [
                    59949.3,
                    52251.9
                  ]
                ],
                "id": 1548,
                "chat_link": "[&BAwGAAA=]"
              },
              "1549": {
                "name": "Palawa Cut",
                "level": 80,
                "coord": [
                  60175.6,
                  49343.7
                ],
                "bounds": [
                  [
                    59303.7,
                    49316.6
                  ],
                  [
                    60196.1,
                    49001.5
                  ],
                  [
                    60738.9,
                    48948.2
                  ],
                  [
                    60896.6,
                    49146.3
                  ],
                  [
                    60979.6,
                    49444.4
                  ],
                  [
                    60142.4,
                    49605
                  ],
                  [
                    59758.8,
                    49776.4
                  ],
                  [
                    59388.8,
                    49511.2
                  ],
                  [
                    59303.7,
                    49316.6
                  ]
                ],
                "id": 1549,
                "chat_link": "[&BA0GAAA=]"
              },
              "1551": {
                "name": "Poisoned Outcrops",
                "level": 80,
                "coord": [
                  61201.3,
                  50199.7
                ],
                "bounds": [
                  [
                    61347.2,
                    50378
                  ],
                  [
                    61415.4,
                    50296.8
                  ],
                  [
                    61482.1,
                    50248.3
                  ],
                  [
                    61577.4,
                    50176.9
                  ],
                  [
                    61783.7,
                    50001.1
                  ],
                  [
                    61776.6,
                    49432.9
                  ],
                  [
                    61736,
                    49365.7
                  ],
                  [
                    61482.1,
                    49276.1
                  ],
                  [
                    60854.8,
                    49468.6
                  ],
                  [
                    60871.5,
                    49614.5
                  ],
                  [
                    60819.4,
                    49811.5
                  ],
                  [
                    60601,
                    50119.4
                  ],
                  [
                    60631.6,
                    50626.9
                  ],
                  [
                    60556.7,
                    50948
                  ],
                  [
                    60820.7,
                    51159.7
                  ],
                  [
                    61144.8,
                    50987
                  ],
                  [
                    61371.7,
                    50727.8
                  ],
                  [
                    61294.1,
                    50640.7
                  ],
                  [
                    61258.5,
                    50514.7
                  ],
                  [
                    61347.2,
                    50378
                  ]
                ],
                "id": 1551,
                "chat_link": "[&BA8GAAA=]"
              },
              "1557": {
                "name": "The Darklands",
                "level": 80,
                "coord": [
                  59240.5,
                  50159
                ],
                "bounds": [
                  [
                    58859.5,
                    49802.3
                  ],
                  [
                    59235,
                    49865.3
                  ],
                  [
                    59389.9,
                    49515.5
                  ],
                  [
                    59759.5,
                    49774
                  ],
                  [
                    59713.8,
                    50239.2
                  ],
                  [
                    59837.3,
                    50384.4
                  ],
                  [
                    59773.8,
                    50512.4
                  ],
                  [
                    59327.4,
                    50553.2
                  ],
                  [
                    59134.4,
                    50516.1
                  ],
                  [
                    59116.7,
                    50415.9
                  ],
                  [
                    58815.9,
                    50475.3
                  ],
                  [
                    58564.3,
                    50107.8
                  ],
                  [
                    58599.2,
                    49905.2
                  ],
                  [
                    58859.5,
                    49802.3
                  ]
                ],
                "id": 1557,
                "chat_link": "[&BBUGAAA=]"
              },
              "1558": {
                "name": "Scorched March",
                "level": 80,
                "coord": [
                  59895.7,
                  52007.3
                ],
                "bounds": [
                  [
                    60010.9,
                    51702.5
                  ],
                  [
                    59928.7,
                    51814.8
                  ],
                  [
                    59686.5,
                    51846.7
                  ],
                  [
                    59571.2,
                    51786.6
                  ],
                  [
                    59371.2,
                    51779.3
                  ],
                  [
                    59252.6,
                    51889.7
                  ],
                  [
                    59333.4,
                    52156.3
                  ],
                  [
                    59954.6,
                    52262.9
                  ],
                  [
                    60106,
                    52472.8
                  ],
                  [
                    60419,
                    52360.5
                  ],
                  [
                    60487.2,
                    52131.1
                  ],
                  [
                    60269.3,
                    52059.2
                  ],
                  [
                    60253.9,
                    51833
                  ],
                  [
                    60010.9,
                    51702.5
                  ]
                ],
                "id": 1558,
                "chat_link": "[&BBYGAAA=]"
              },
              "1565": {
                "name": "Vitriolic Rim",
                "level": 80,
                "coord": [
                  58528.1,
                  51284.4
                ],
                "bounds": [
                  [
                    58277.4,
                    51860.9
                  ],
                  [
                    58312.9,
                    51990.3
                  ],
                  [
                    58790.3,
                    51838.7
                  ],
                  [
                    58625,
                    51632.8
                  ],
                  [
                    58627.5,
                    51275.8
                  ],
                  [
                    58703.1,
                    50882.7
                  ],
                  [
                    58755.4,
                    50487.1
                  ],
                  [
                    58374.8,
                    50643.5
                  ],
                  [
                    58286.6,
                    50947.5
                  ],
                  [
                    58277.4,
                    51860.9
                  ]
                ],
                "id": 1565,
                "chat_link": "[&BB0GAAA=]"
              },
              "1567": {
                "name": "Silent Vale",
                "level": 80,
                "coord": [
                  61172.4,
                  48334.4
                ],
                "bounds": [
                  [
                    61116.4,
                    48660.8
                  ],
                  [
                    60882.6,
                    48457.5
                  ],
                  [
                    60837.6,
                    48369.1
                  ],
                  [
                    60793.6,
                    48383.6
                  ],
                  [
                    60669.9,
                    48183.9
                  ],
                  [
                    60969.1,
                    48198.4
                  ],
                  [
                    61743.7,
                    48058.4
                  ],
                  [
                    61775.3,
                    48192.2
                  ],
                  [
                    61763.7,
                    48505.9
                  ],
                  [
                    61116.4,
                    48660.8
                  ]
                ],
                "id": 1567,
                "chat_link": "[&BB8GAAA=]"
              },
              "1568": {
                "name": "Sulfur Quarry",
                "level": 80,
                "coord": [
                  58739.9,
                  49467.6
                ],
                "bounds": [
                  [
                    58541.1,
                    49861.2
                  ],
                  [
                    58600,
                    49916.2
                  ],
                  [
                    58862.6,
                    49803.7
                  ],
                  [
                    59238.9,
                    49862.3
                  ],
                  [
                    59391.9,
                    49494.3
                  ],
                  [
                    59122.4,
                    48927.9
                  ],
                  [
                    58782.3,
                    49067.9
                  ],
                  [
                    58675.8,
                    49251
                  ],
                  [
                    58539.1,
                    49293.3
                  ],
                  [
                    58489,
                    49186.5
                  ],
                  [
                    58287.4,
                    49182.3
                  ],
                  [
                    58348.6,
                    49764.7
                  ],
                  [
                    58541.1,
                    49861.2
                  ]
                ],
                "id": 1568,
                "chat_link": "[&BCAGAAA=]"
              },
              "1570": {
                "name": "Basaltic Fringe",
                "level": 80,
                "coord": [
                  61406.5,
                  52380
                ],
                "bounds": [
                  [
                    61133.2,
                    52202.8
                  ],
                  [
                    61031.3,
                    52042.3
                  ],
                  [
                    61287.8,
                    51978.9
                  ],
                  [
                    61594.8,
                    51544
                  ],
                  [
                    61776,
                    51483.1
                  ],
                  [
                    61779.9,
                    51664.6
                  ],
                  [
                    61764.2,
                    52013.2
                  ],
                  [
                    61767.5,
                    52274.2
                  ],
                  [
                    61772,
                    52543.3
                  ],
                  [
                    61773.3,
                    52965.4
                  ],
                  [
                    61452,
                    53264.4
                  ],
                  [
                    60966.8,
                    53248.1
                  ],
                  [
                    61037.4,
                    52974.3
                  ],
                  [
                    60995.8,
                    52892.8
                  ],
                  [
                    60966,
                    52607.9
                  ],
                  [
                    61133.2,
                    52202.8
                  ]
                ],
                "id": 1570,
                "chat_link": "[&BCIGAAA=]"
              },
              "1573": {
                "name": "The Scourgeway",
                "level": 80,
                "coord": [
                  60359.3,
                  50188.8
                ],
                "bounds": [
                  [
                    59966.1,
                    51263.6
                  ],
                  [
                    60563.6,
                    50949.3
                  ],
                  [
                    60634.3,
                    50626.9
                  ],
                  [
                    60601.8,
                    50119.1
                  ],
                  [
                    60821.3,
                    49816.7
                  ],
                  [
                    60883.4,
                    49611.1
                  ],
                  [
                    60866.5,
                    49465.1
                  ],
                  [
                    60144.5,
                    49602
                  ],
                  [
                    59749.6,
                    49772.1
                  ],
                  [
                    59711.9,
                    50260.2
                  ],
                  [
                    60009.7,
                    50590.5
                  ],
                  [
                    59966.1,
                    51263.6
                  ]
                ],
                "id": 1573,
                "chat_link": "[&BCUGAAA=]"
              },
              "1577": {
                "name": "The Ruptured Heart",
                "level": 80,
                "coord": [
                  59163,
                  51433.8
                ],
                "bounds": [
                  [
                    58852.6,
                    51910.4
                  ],
                  [
                    59262.5,
                    51890
                  ],
                  [
                    59383.4,
                    51775.9
                  ],
                  [
                    59572.8,
                    51790.9
                  ],
                  [
                    59622.9,
                    51678.6
                  ],
                  [
                    59540.6,
                    51567.3
                  ],
                  [
                    59440.3,
                    51346.6
                  ],
                  [
                    59446.3,
                    51134.2
                  ],
                  [
                    59172.7,
                    50833.5
                  ],
                  [
                    58880.3,
                    50917.1
                  ],
                  [
                    58700.6,
                    50883
                  ],
                  [
                    58623,
                    51280.2
                  ],
                  [
                    58620.6,
                    51631.2
                  ],
                  [
                    58852.6,
                    51910.4
                  ]
                ],
                "id": 1577,
                "chat_link": "[&BCkGAAA=]"
              },
              "1588": {
                "name": "Sand Jackal Run",
                "level": 80,
                "coord": [
                  59402,
                  52720.1
                ],
                "bounds": [
                  [
                    59014.7,
                    52847.9
                  ],
                  [
                    59147.9,
                    52849.3
                  ],
                  [
                    59416,
                    53012.4
                  ],
                  [
                    59584.4,
                    52951.8
                  ],
                  [
                    59591.8,
                    52858.6
                  ],
                  [
                    59781.5,
                    52721.8
                  ],
                  [
                    59790.7,
                    52642.5
                  ],
                  [
                    59550.5,
                    52413.2
                  ],
                  [
                    59414.9,
                    52385.5
                  ],
                  [
                    59165.2,
                    52479
                  ],
                  [
                    58963.9,
                    52759.2
                  ],
                  [
                    59014.7,
                    52847.9
                  ]
                ],
                "id": 1588,
                "chat_link": "[&BDQGAAA=]"
              },
              "1594": {
                "name": "Lair of the Forgotten",
                "level": 80,
                "coord": [
                  61479.4,
                  51032.4
                ],
                "bounds": [
                  [
                    60818.4,
                    51155.1
                  ],
                  [
                    61139.6,
                    50971.4
                  ],
                  [
                    61369.2,
                    50728
                  ],
                  [
                    61607.9,
                    50653.8
                  ],
                  [
                    61718.7,
                    50756.4
                  ],
                  [
                    61764.2,
                    50724.2
                  ],
                  [
                    61780,
                    50831.2
                  ],
                  [
                    61779.5,
                    51484.1
                  ],
                  [
                    61593.1,
                    51545.8
                  ],
                  [
                    61224.1,
                    51473.7
                  ],
                  [
                    60818.4,
                    51155.1
                  ]
                ],
                "id": 1594,
                "chat_link": "[&BDoGAAA=]"
              },
              "1596": {
                "name": "Helcoid Seeps",
                "level": 80,
                "coord": [
                  61543.7,
                  50409.6
                ],
                "bounds": [
                  [
                    61761.4,
                    50730
                  ],
                  [
                    61770.6,
                    50131.9
                  ],
                  [
                    61778.2,
                    49999
                  ],
                  [
                    61689.1,
                    50088.7
                  ],
                  [
                    61574,
                    50174.2
                  ],
                  [
                    61479,
                    50245.1
                  ],
                  [
                    61412.3,
                    50293.3
                  ],
                  [
                    61363.2,
                    50361.3
                  ],
                  [
                    61255.5,
                    50514.3
                  ],
                  [
                    61288,
                    50638.7
                  ],
                  [
                    61371.4,
                    50731.3
                  ],
                  [
                    61608.6,
                    50654.3
                  ],
                  [
                    61716.7,
                    50762.2
                  ],
                  [
                    61761.4,
                    50730
                  ]
                ],
                "id": 1596,
                "chat_link": "[&BDwGAAA=]"
              }
            },
            "adventures": [],
            "id": 1226,
            "mastery_points": [
              {
                "coord": [
                  60703.6,
                  50816.4
                ],
                "id": 405,
                "region": "Desert"
              },
              {
                "coord": [
                  61759.6,
                  51839.3
                ],
                "id": 360,
                "region": "Desert"
              },
              {
                "coord": [
                  60699.3,
                  49380.3
                ],
                "id": 403,
                "region": "Desert"
              },
              {
                "coord": [
                  61241.9,
                  48457.1
                ],
                "id": 350,
                "region": "Desert"
              },
              {
                "coord": [
                  61750.9,
                  52336.8
                ],
                "id": 375,
                "region": "Desert"
              },
              {
                "coord": [
                  59323,
                  52874
                ],
                "id": 335,
                "region": "Desert"
              },
              {
                "coord": [
                  60060.1,
                  51808.8
                ],
                "id": 401,
                "region": "Desert"
              },
              {
                "coord": [
                  59081.9,
                  51508.6
                ],
                "id": 371,
                "region": "Desert"
              },
              {
                "coord": [
                  59443.8,
                  50373.4
                ],
                "id": 339,
                "region": "Desert"
              },
              {
                "coord": [
                  58992,
                  50279.8
                ],
                "id": 359,
                "region": "Desert"
              }
            ]
          },
          "1227": {
            "name": "Hallowed Ground: Tomb of Primeval Kings",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              60176,
              41440
            ],
            "map_rect": [
              [
                -61440,
                -30720
              ],
              [
                61440,
                30720
              ]
            ],
            "continent_rect": [
              [
                57256,
                39744
              ],
              [
                62376,
                42304
              ]
            ],
            "points_of_interest": {
              "2698": {
                "name": "The Portal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  62178,
                  40091.3
                ],
                "id": 2698,
                "chat_link": "[&BIoKAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1512": {
                "name": "Tomb of the Primeval Kings",
                "level": 80,
                "coord": [
                  61708.4,
                  40499.9
                ],
                "bounds": [
                  [
                    62206.2,
                    40978.5
                  ],
                  [
                    62292.2,
                    40707.3
                  ],
                  [
                    62213.9,
                    40538.8
                  ],
                  [
                    62313.1,
                    40216.2
                  ],
                  [
                    62106.4,
                    39985.8
                  ],
                  [
                    61771.2,
                    39969.2
                  ],
                  [
                    61616.8,
                    40167.2
                  ],
                  [
                    61360.9,
                    40218.3
                  ],
                  [
                    61090.9,
                    40175.6
                  ],
                  [
                    60993.8,
                    40604.9
                  ],
                  [
                    61141.6,
                    40635.1
                  ],
                  [
                    61390.3,
                    40669.9
                  ],
                  [
                    61467.1,
                    40769.2
                  ],
                  [
                    61679.4,
                    40901.6
                  ],
                  [
                    61982,
                    40960.8
                  ],
                  [
                    62206.2,
                    40978.5
                  ]
                ],
                "id": 1512,
                "chat_link": "[&BOgFAAA=]"
              },
              "1554": {
                "name": "The Sunderlands",
                "level": 80,
                "coord": [
                  61434.5,
                  41067.6
                ],
                "bounds": [
                  [
                    61548.2,
                    41329.4
                  ],
                  [
                    61322.2,
                    41319.1
                  ],
                  [
                    61134.2,
                    41294.5
                  ],
                  [
                    60975.6,
                    41367.2
                  ],
                  [
                    60831.7,
                    41198.3
                  ],
                  [
                    60903,
                    40953.5
                  ],
                  [
                    60880.7,
                    40786.3
                  ],
                  [
                    60911.6,
                    40684
                  ],
                  [
                    60993.8,
                    40604.9
                  ],
                  [
                    61141.8,
                    40635.1
                  ],
                  [
                    61390.1,
                    40670
                  ],
                  [
                    61467,
                    40769
                  ],
                  [
                    61679.2,
                    40901.4
                  ],
                  [
                    61981.8,
                    40960.5
                  ],
                  [
                    62207.4,
                    40978.4
                  ],
                  [
                    62351.9,
                    41870.8
                  ],
                  [
                    62146.3,
                    41549
                  ],
                  [
                    61954.7,
                    41344.9
                  ],
                  [
                    61548.2,
                    41329.4
                  ]
                ],
                "id": 1554,
                "chat_link": "[&BBIGAAA=]"
              }
            },
            "adventures": [],
            "id": 1227,
            "mastery_points": []
          },
          "1228": {
            "name": "Elon Riverlands",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              59868,
              46284
            ],
            "map_rect": [
              [
                -43008,
                -39936
              ],
              [
                43008,
                43008
              ]
            ],
            "continent_rect": [
              [
                58240,
                44736
              ],
              [
                61824,
                48192
              ]
            ],
            "points_of_interest": {
              "2551": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  59215.1,
                  47358.7
                ],
                "id": 2551,
                "chat_link": "[&BPcJAAA=]"
              },
              "2553": {
                "name": "Fallback Fissure",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59458.8,
                  46261.5
                ],
                "id": 2553,
                "chat_link": "[&BPkJAAA=]"
              },
              "2558": {
                "name": "The Sepulcher",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60677.6,
                  47999.2
                ],
                "id": 2558,
                "chat_link": "[&BP4JAAA=]"
              },
              "2567": {
                "name": "Stoneyard Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61430.3,
                  47847.8
                ],
                "id": 2567,
                "chat_link": "[&BAcKAAA=]"
              },
              "2570": {
                "name": "Decimation Bend",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61579.7,
                  46154.1
                ],
                "id": 2570,
                "chat_link": "[&BAoKAAA=]"
              },
              "2576": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60100.5,
                  46100.5
                ],
                "id": 2576,
                "chat_link": "[&BBAKAAA=]"
              },
              "2579": {
                "name": "Syrtic Impasse",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58758.8,
                  44905.8
                ],
                "id": 2579,
                "chat_link": "[&BBMKAAA=]"
              },
              "2600": {
                "name": "Olishar's Oasis Camp Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  60363.6,
                  46367.2
                ],
                "id": 2600,
                "chat_link": "[&BCgKAAA=]"
              },
              "2605": {
                "name": "Elon Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61730,
                  47520.3
                ],
                "id": 2605,
                "chat_link": "[&BC0KAAA=]"
              },
              "2608": {
                "name": "Heroes' Overlook",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59778.8,
                  45332.6
                ],
                "id": 2608,
                "chat_link": "[&BDAKAAA=]"
              },
              "2614": {
                "name": "Giant's Rise",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59410.4,
                  44957.9
                ],
                "id": 2614,
                "chat_link": "[&BDYKAAA=]"
              },
              "2618": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60740,
                  45510.2
                ],
                "id": 2618,
                "chat_link": "[&BDoKAAA=]"
              },
              "2620": {
                "name": "First Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60659.6,
                  45719.7
                ],
                "id": 2620,
                "chat_link": "[&BDwKAAA=]"
              },
              "2628": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  59585.8,
                  45285.5
                ],
                "id": 2628,
                "chat_link": "[&BEQKAAA=]"
              },
              "2633": {
                "name": "Mount: Skimmer",
                "type": "unlock",
                "floor": 1,
                "coord": [
                  59170.1,
                  46599.4
                ],
                "id": 2633,
                "chat_link": "[&BEkKAAA=]",
                "icon": "https://render.guildwars2.com/file/0E2574EA021517B574C161CD090FCC07FA53C10D/1770700.png"
              },
              "2635": {
                "name": "Second Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60879,
                  45981.3
                ],
                "id": 2635,
                "chat_link": "[&BEsKAAA=]"
              },
              "2637": {
                "name": "Dragoon Hearth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61445,
                  46702.2
                ],
                "id": 2637,
                "chat_link": "[&BE0KAAA=]"
              },
              "2639": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60576.6,
                  46710.8
                ],
                "id": 2639,
                "chat_link": "[&BE8KAAA=]"
              },
              "2640": {
                "name": "Godslost Sandfalls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59773.9,
                  44968.9
                ],
                "id": 2640,
                "chat_link": "[&BFAKAAA=]"
              },
              "2643": {
                "name": "Augury's Shadow Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  61075,
                  45581
                ],
                "id": 2643,
                "chat_link": "[&BFMKAAA=]"
              },
              "2659": {
                "name": "Pillars of Supremacy",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58876.7,
                  46904.2
                ],
                "id": 2659,
                "chat_link": "[&BGMKAAA=]"
              },
              "2663": {
                "name": "Skimmer Ranch Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  59093.8,
                  46548.8
                ],
                "id": 2663,
                "chat_link": "[&BGcKAAA=]"
              },
              "2670": {
                "name": "Leviathan's Gullet",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59740,
                  45911.4
                ],
                "id": 2670,
                "chat_link": "[&BG4KAAA=]"
              },
              "2671": {
                "name": "Threefold Waylay",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61196.4,
                  45310.3
                ],
                "id": 2671,
                "chat_link": "[&BG8KAAA=]"
              },
              "2686": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58610.1,
                  45210.7
                ],
                "id": 2686,
                "chat_link": "[&BH4KAAA=]"
              },
              "2694": {
                "name": "Throne of Pellentia",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58540.1,
                  47863.5
                ],
                "id": 2694,
                "chat_link": "[&BIYKAAA=]"
              },
              "2695": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  60582.3,
                  47702.7
                ],
                "id": 2695,
                "chat_link": "[&BIcKAAA=]"
              },
              "2697": {
                "name": "Sandwallow Retreat",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58731.7,
                  46130.1
                ],
                "id": 2697,
                "chat_link": "[&BIkKAAA=]"
              },
              "2704": {
                "name": "Palawa's Grace",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60354,
                  46931.8
                ],
                "id": 2704,
                "chat_link": "[&BJAKAAA=]"
              },
              "2712": {
                "name": "Bahdaj Vigil",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58354.8,
                  47551
                ],
                "id": 2712,
                "chat_link": "[&BJgKAAA=]"
              },
              "2713": {
                "name": "The Triumph of Palawa Joko",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60630.6,
                  47687.5
                ],
                "id": 2713,
                "chat_link": "[&BJkKAAA=]"
              },
              "2722": {
                "name": "The Joko Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60099.1,
                  48149.2
                ],
                "id": 2722,
                "chat_link": "[&BKIKAAA=]"
              },
              "2726": {
                "name": "Pilgrims' Folly",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59282.8,
                  47397.8
                ],
                "id": 2726,
                "chat_link": "[&BKYKAAA=]"
              },
              "2733": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58688.8,
                  47789.2
                ],
                "id": 2733,
                "chat_link": "[&BK0KAAA=]"
              },
              "2736": {
                "name": "Exile's Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59830.2,
                  46533.1
                ],
                "id": 2736,
                "chat_link": "[&BLAKAAA=]"
              },
              "2738": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  58509.2,
                  45898.9
                ],
                "id": 2738,
                "chat_link": "[&BLIKAAA=]"
              },
              "2740": {
                "name": "Garden of the Chosen",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59664.3,
                  46972.4
                ],
                "id": 2740,
                "chat_link": "[&BLQKAAA=]"
              },
              "2743": {
                "name": "Scattered Remnants",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60996.8,
                  45092.1
                ],
                "id": 2743,
                "chat_link": "[&BLcKAAA=]"
              },
              "2744": {
                "name": "Hall of Ascension",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60641.9,
                  45313.3
                ],
                "id": 2744,
                "chat_link": "[&BLgKAAA=]"
              },
              "2756": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  61114.7,
                  47139.9
                ],
                "id": 2756,
                "chat_link": "[&BMQKAAA=]"
              },
              "2769": {
                "name": "Ossa's Defeat",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58441,
                  44895.1
                ],
                "id": 2769,
                "chat_link": "[&BNEKAAA=]"
              },
              "2772": {
                "name": "Sandbound Towers",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60182.4,
                  45956.5
                ],
                "id": 2772,
                "chat_link": "[&BNQKAAA=]"
              },
              "2791": {
                "name": "Skritt's Audience",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58450.5,
                  46143.6
                ],
                "id": 2791,
                "chat_link": "[&BOcKAAA=]"
              },
              "2792": {
                "name": "Lonely Vigil",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61200.6,
                  47269.9
                ],
                "id": 2792,
                "chat_link": "[&BOgKAAA=]"
              }
            },
            "tasks": {
              "393": {
                "objective": "Help Ebele prepare the way north for defectors.",
                "level": 80,
                "coord": [
                  60662.8,
                  46278.1
                ],
                "bounds": [
                  [
                    60208,
                    46120.1
                  ],
                  [
                    60091.7,
                    46294.7
                  ],
                  [
                    60180.4,
                    46475.3
                  ],
                  [
                    60568,
                    46456.6
                  ],
                  [
                    60909.4,
                    46459.4
                  ],
                  [
                    60987,
                    46139.8
                  ],
                  [
                    60802.3,
                    46038.8
                  ],
                  [
                    60703.7,
                    46004.3
                  ],
                  [
                    60596.2,
                    46000.1
                  ],
                  [
                    60208,
                    46120.1
                  ]
                ],
                "id": 393,
                "chat_link": "[&BIkBAAA=]"
              },
              "394": {
                "objective": "Help Adisa collect Slivers of Vlast from veteran Branded.",
                "level": 80,
                "coord": [
                  61375.3,
                  45643.8
                ],
                "bounds": [
                  [
                    61259.4,
                    46077.6
                  ],
                  [
                    61426.2,
                    46310.5
                  ],
                  [
                    61792.2,
                    46194.7
                  ],
                  [
                    61817.6,
                    44850.8
                  ],
                  [
                    61359.4,
                    44846.6
                  ],
                  [
                    61234.8,
                    44903.1
                  ],
                  [
                    61272.3,
                    45225.3
                  ],
                  [
                    61045.3,
                    45326.6
                  ],
                  [
                    61284.7,
                    45574.7
                  ],
                  [
                    61259.4,
                    46077.6
                  ]
                ],
                "id": 394,
                "chat_link": "[&BIoBAAA=]"
              },
              "400": {
                "objective": "Use a skimmer to help with training around the ranch.",
                "level": 80,
                "coord": [
                  59168,
                  46574.5
                ],
                "bounds": [
                  [
                    59475.3,
                    46285.1
                  ],
                  [
                    59284.3,
                    46346.5
                  ],
                  [
                    59040.9,
                    46332.5
                  ],
                  [
                    58919.7,
                    46420.5
                  ],
                  [
                    58874.3,
                    46535.9
                  ],
                  [
                    58865.4,
                    46695.1
                  ],
                  [
                    58928.6,
                    46752.8
                  ],
                  [
                    59045.3,
                    46817.3
                  ],
                  [
                    59131.5,
                    46856.9
                  ],
                  [
                    59225.9,
                    46888.3
                  ],
                  [
                    59292.5,
                    47012.4
                  ],
                  [
                    59458.1,
                    47081
                  ],
                  [
                    59573.9,
                    47056.1
                  ],
                  [
                    59714.8,
                    46803.2
                  ],
                  [
                    59716.1,
                    46682.4
                  ],
                  [
                    59622.4,
                    46667.8
                  ],
                  [
                    59549.4,
                    46353
                  ],
                  [
                    59475.3,
                    46285.1
                  ]
                ],
                "id": 400,
                "chat_link": "[&BJABAAA=]"
              },
              "404": {
                "objective": "Help Follower Dawnwynn defeat Branded Forgotten at Augury Rock.",
                "level": 80,
                "coord": [
                  60298.7,
                  45312.2
                ],
                "bounds": [
                  [
                    60314.7,
                    45565.8
                  ],
                  [
                    60781.4,
                    45510.1
                  ],
                  [
                    60905.8,
                    45303.5
                  ],
                  [
                    60831.4,
                    45154.9
                  ],
                  [
                    60306.3,
                    45107.2
                  ],
                  [
                    59872.1,
                    45217.6
                  ],
                  [
                    59872.1,
                    45389
                  ],
                  [
                    60314.7,
                    45565.8
                  ]
                ],
                "id": 404,
                "chat_link": "[&BJQBAAA=]"
              },
              "410": {
                "objective": "Help Assistant Foreman Kofi keep the people of the Gladefields safe.",
                "level": 80,
                "coord": [
                  60704.6,
                  46586.4
                ],
                "bounds": [
                  [
                    60568.1,
                    46458.9
                  ],
                  [
                    60551.3,
                    46616.7
                  ],
                  [
                    60598.3,
                    46756.7
                  ],
                  [
                    60758.6,
                    46867.9
                  ],
                  [
                    61180.7,
                    46835.6
                  ],
                  [
                    61174.8,
                    46656.8
                  ],
                  [
                    61077,
                    46464.6
                  ],
                  [
                    60568.1,
                    46458.9
                  ]
                ],
                "id": 410,
                "chat_link": "[&BJoBAAA=]"
              },
              "412": {
                "objective": "Help Follower Xunn collect Forgotten Glyphs for decoding.",
                "level": 80,
                "coord": [
                  60820.4,
                  45037
                ],
                "bounds": [
                  [
                    60836.1,
                    45149
                  ],
                  [
                    60931.3,
                    45330.6
                  ],
                  [
                    61038.1,
                    45324.9
                  ],
                  [
                    61269.6,
                    45222.2
                  ],
                  [
                    61232.2,
                    44874.3
                  ],
                  [
                    60249.2,
                    44885
                  ],
                  [
                    60269.9,
                    45104.1
                  ],
                  [
                    60836.1,
                    45149
                  ]
                ],
                "id": 412,
                "chat_link": "[&BJwBAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  61115.1,
                  47270.5
                ],
                "id": "2-12"
              },
              {
                "coord": [
                  58541.8,
                  47924.1
                ],
                "id": "2-13"
              },
              {
                "coord": [
                  61776.5,
                  45062.1
                ],
                "id": "2-14"
              },
              {
                "coord": [
                  59211.3,
                  45653.3
                ],
                "id": "2-15"
              },
              {
                "coord": [
                  59434.2,
                  47021
                ],
                "id": "2-16"
              },
              {
                "coord": [
                  61247.1,
                  45316.1
                ],
                "id": "2-17"
              },
              {
                "coord": [
                  59932.9,
                  46196.3
                ],
                "id": "2-18"
              },
              {
                "coord": [
                  58418.3,
                  45196.6
                ],
                "id": "2-19"
              }
            ],
            "sectors": {
              "1486": {
                "name": "Abandoned Barrows",
                "level": 80,
                "coord": [
                  58595.8,
                  46509.9
                ],
                "bounds": [
                  [
                    58715.7,
                    46693.1
                  ],
                  [
                    58851.6,
                    46617.2
                  ],
                  [
                    58912,
                    46525
                  ],
                  [
                    58915.3,
                    46397.7
                  ],
                  [
                    58488.4,
                    46252
                  ],
                  [
                    58294.8,
                    46280.9
                  ],
                  [
                    58294.6,
                    46625.6
                  ],
                  [
                    58294.1,
                    46688
                  ],
                  [
                    58715.7,
                    46693.1
                  ]
                ],
                "id": 1486,
                "chat_link": "[&BM4FAAA=]"
              },
              "1493": {
                "name": "The Deadhouse",
                "level": 80,
                "coord": [
                  60902.2,
                  48067.5
                ],
                "bounds": [
                  [
                    60742.9,
                    47822.2
                  ],
                  [
                    60480,
                    47945.6
                  ],
                  [
                    60474.3,
                    48031.1
                  ],
                  [
                    60718.4,
                    48261.9
                  ],
                  [
                    60820.6,
                    48400.3
                  ],
                  [
                    60871.2,
                    48378.1
                  ],
                  [
                    60958.8,
                    48250.7
                  ],
                  [
                    61265.2,
                    48211.3
                  ],
                  [
                    61128.7,
                    47906.3
                  ],
                  [
                    61256.5,
                    47833.4
                  ],
                  [
                    61207.3,
                    47701.9
                  ],
                  [
                    60742.9,
                    47822.2
                  ]
                ],
                "id": 1493,
                "chat_link": "[&BNUFAAA=]"
              },
              "1503": {
                "name": "Augury Rock",
                "level": 80,
                "coord": [
                  60525.7,
                  45333.5
                ],
                "bounds": [
                  [
                    60441.4,
                    45072.3
                  ],
                  [
                    59990.2,
                    45276.9
                  ],
                  [
                    59996.8,
                    45366.7
                  ],
                  [
                    60398.6,
                    45574.7
                  ],
                  [
                    60705,
                    45581.2
                  ],
                  [
                    60934,
                    45434.6
                  ],
                  [
                    60925.7,
                    45261
                  ],
                  [
                    60813.7,
                    45100.9
                  ],
                  [
                    60441.4,
                    45072.3
                  ]
                ],
                "id": 1503,
                "chat_link": "[&BN8FAAA=]"
              },
              "1509": {
                "name": "The Bone Wall",
                "level": 80,
                "coord": [
                  59960.6,
                  48128.4
                ],
                "bounds": [
                  [
                    59203.4,
                    48033
                  ],
                  [
                    59208,
                    48246.1
                  ],
                  [
                    60720.8,
                    48259.6
                  ],
                  [
                    60479.5,
                    48026.7
                  ],
                  [
                    60191.5,
                    48076.4
                  ],
                  [
                    59203.4,
                    48033
                  ]
                ],
                "id": 1509,
                "chat_link": "[&BOUFAAA=]"
              },
              "1510": {
                "name": "Ustulate Barrens",
                "level": 80,
                "coord": [
                  61504.6,
                  45733.1
                ],
                "bounds": [
                  [
                    61759.1,
                    46271.3
                  ],
                  [
                    61760.3,
                    46229.1
                  ],
                  [
                    61766.6,
                    46180.9
                  ],
                  [
                    61753.4,
                    45491.7
                  ],
                  [
                    61747.8,
                    44870.9
                  ],
                  [
                    61188.9,
                    44750.1
                  ],
                  [
                    61253.3,
                    45235.5
                  ],
                  [
                    61311.1,
                    45308.3
                  ],
                  [
                    61184.2,
                    45755.5
                  ],
                  [
                    61226.5,
                    46197.9
                  ],
                  [
                    61447.6,
                    46256.6
                  ],
                  [
                    61656.5,
                    46249.3
                  ],
                  [
                    61759.1,
                    46271.3
                  ]
                ],
                "id": 1510,
                "chat_link": "[&BOYFAAA=]"
              },
              "1514": {
                "name": "Skimmer Ranch",
                "level": 80,
                "coord": [
                  59115.4,
                  46598.4
                ],
                "bounds": [
                  [
                    59333.4,
                    47038.5
                  ],
                  [
                    59381.7,
                    46850.2
                  ],
                  [
                    59365.5,
                    46401.6
                  ],
                  [
                    59229,
                    46278.9
                  ],
                  [
                    59099,
                    46271.1
                  ],
                  [
                    58902.6,
                    46396.3
                  ],
                  [
                    58907.3,
                    46523.9
                  ],
                  [
                    58847.2,
                    46611.8
                  ],
                  [
                    58864.4,
                    46711.1
                  ],
                  [
                    59223.8,
                    46900.9
                  ],
                  [
                    59333.4,
                    47038.5
                  ]
                ],
                "id": 1514,
                "chat_link": "[&BOoFAAA=]"
              },
              "1516": {
                "name": "Arid Gladefields",
                "level": 80,
                "coord": [
                  60694.5,
                  46842.9
                ],
                "bounds": [
                  [
                    60942.6,
                    47292.1
                  ],
                  [
                    61029.9,
                    47410.4
                  ],
                  [
                    61189.1,
                    47221.1
                  ],
                  [
                    61047.3,
                    47145
                  ],
                  [
                    61033.6,
                    47042
                  ],
                  [
                    61158.9,
                    46843.5
                  ],
                  [
                    61238.4,
                    46306.4
                  ],
                  [
                    61231.3,
                    46095.7
                  ],
                  [
                    60937.9,
                    46141
                  ],
                  [
                    60685.8,
                    46009
                  ],
                  [
                    60324,
                    46096.1
                  ],
                  [
                    60172.2,
                    46255.6
                  ],
                  [
                    60307,
                    46653.4
                  ],
                  [
                    60008,
                    47020.6
                  ],
                  [
                    59955.2,
                    47392.9
                  ],
                  [
                    60130,
                    47453.2
                  ],
                  [
                    60431.1,
                    47456.2
                  ],
                  [
                    60677.8,
                    47338
                  ],
                  [
                    60942.6,
                    47292.1
                  ]
                ],
                "id": 1516,
                "chat_link": "[&BOwFAAA=]"
              },
              "1520": {
                "name": "Shallows of Despair",
                "level": 80,
                "coord": [
                  58738.2,
                  47705.3
                ],
                "bounds": [
                  [
                    58283,
                    48053.5
                  ],
                  [
                    58434.6,
                    48310.1
                  ],
                  [
                    59211.7,
                    48241
                  ],
                  [
                    59206.2,
                    47958.7
                  ],
                  [
                    59052.2,
                    47785.4
                  ],
                  [
                    59058.9,
                    47575.3
                  ],
                  [
                    58988.8,
                    47485.9
                  ],
                  [
                    58424.4,
                    47255.7
                  ],
                  [
                    58429.8,
                    47188.6
                  ],
                  [
                    58292.2,
                    47199
                  ],
                  [
                    58283,
                    48053.5
                  ]
                ],
                "id": 1520,
                "chat_link": "[&BPAFAAA=]"
              },
              "1524": {
                "name": "The Scavengelands",
                "level": 80,
                "coord": [
                  58442.9,
                  45891
                ],
                "bounds": [
                  [
                    58571.9,
                    45401.5
                  ],
                  [
                    58291.5,
                    45452.4
                  ],
                  [
                    58298.9,
                    46049.5
                  ],
                  [
                    58298.3,
                    46294.3
                  ],
                  [
                    58494,
                    46255.5
                  ],
                  [
                    58702.8,
                    45892.7
                  ],
                  [
                    58571.9,
                    45401.5
                  ]
                ],
                "id": 1524,
                "chat_link": "[&BPQFAAA=]"
              },
              "1531": {
                "name": "Vulture Drifts",
                "level": 80,
                "coord": [
                  59784.8,
                  46837.1
                ],
                "bounds": [
                  [
                    59305.3,
                    47157.8
                  ],
                  [
                    59658.2,
                    47527.8
                  ],
                  [
                    59955.2,
                    47399.5
                  ],
                  [
                    60014.3,
                    47019.3
                  ],
                  [
                    60312.7,
                    46653.3
                  ],
                  [
                    60180.2,
                    46255.9
                  ],
                  [
                    59905.5,
                    46266.3
                  ],
                  [
                    59352.9,
                    46404.1
                  ],
                  [
                    59378.5,
                    46850.1
                  ],
                  [
                    59305.3,
                    47157.8
                  ]
                ],
                "id": 1531,
                "chat_link": "[&BPsFAAA=]"
              },
              "1534": {
                "name": "Shoals of Sovereignty",
                "level": 80,
                "coord": [
                  60450.5,
                  47648.9
                ],
                "bounds": [
                  [
                    59957.1,
                    48072.9
                  ],
                  [
                    60191.1,
                    48079.2
                  ],
                  [
                    60475,
                    48031.4
                  ],
                  [
                    60481.2,
                    47945.4
                  ],
                  [
                    60741.5,
                    47817.9
                  ],
                  [
                    60946.9,
                    47766.1
                  ],
                  [
                    60938.9,
                    47595
                  ],
                  [
                    61035.7,
                    47404.6
                  ],
                  [
                    60941.1,
                    47262.4
                  ],
                  [
                    60677.8,
                    47331.7
                  ],
                  [
                    60433.9,
                    47449.5
                  ],
                  [
                    60129.9,
                    47452
                  ],
                  [
                    59952.2,
                    47397.3
                  ],
                  [
                    59845.7,
                    47441.5
                  ],
                  [
                    60010,
                    47686.2
                  ],
                  [
                    59957.1,
                    48072.9
                  ]
                ],
                "id": 1534,
                "chat_link": "[&BP4FAAA=]"
              },
              "1537": {
                "name": "Elon Flow",
                "level": 80,
                "coord": [
                  61348,
                  47659.2
                ],
                "bounds": [
                  [
                    60936.8,
                    47591.9
                  ],
                  [
                    60943.7,
                    47766.9
                  ],
                  [
                    61212.1,
                    47703.3
                  ],
                  [
                    61252.5,
                    47834.8
                  ],
                  [
                    61125.3,
                    47904.7
                  ],
                  [
                    61268.9,
                    48215.5
                  ],
                  [
                    61765,
                    48113
                  ],
                  [
                    61752.5,
                    47797.2
                  ],
                  [
                    61769.4,
                    47742.4
                  ],
                  [
                    61763.7,
                    47088.1
                  ],
                  [
                    61521.2,
                    47189.3
                  ],
                  [
                    61183.1,
                    47216.3
                  ],
                  [
                    61029.7,
                    47406.3
                  ],
                  [
                    60936.8,
                    47591.9
                  ]
                ],
                "id": 1537,
                "chat_link": "[&BAEGAAA=]"
              },
              "1543": {
                "name": "Whispering Grottos",
                "level": 80,
                "coord": [
                  61398.5,
                  46731.9
                ],
                "bounds": [
                  [
                    61764.3,
                    46923.1
                  ],
                  [
                    61769.7,
                    46294.6
                  ],
                  [
                    61661.3,
                    46238.7
                  ],
                  [
                    61441.8,
                    46247.4
                  ],
                  [
                    61229.4,
                    46193.7
                  ],
                  [
                    61235.9,
                    46305.1
                  ],
                  [
                    61153.6,
                    46841.9
                  ],
                  [
                    61023.6,
                    47048.7
                  ],
                  [
                    61039.6,
                    47157.4
                  ],
                  [
                    61181.8,
                    47228.1
                  ],
                  [
                    61521.3,
                    47202.7
                  ],
                  [
                    61759.6,
                    47101.7
                  ],
                  [
                    61764.3,
                    46923.1
                  ]
                ],
                "id": 1543,
                "chat_link": "[&BAcGAAA=]"
              },
              "1544": {
                "name": "Skyward Reach",
                "level": 80,
                "coord": [
                  60536.7,
                  45527.4
                ],
                "bounds": [
                  [
                    61190.1,
                    44719.9
                  ],
                  [
                    59755.7,
                    44696.4
                  ],
                  [
                    59659.2,
                    45366.9
                  ],
                  [
                    59707.6,
                    45500.1
                  ],
                  [
                    59848.1,
                    45456.2
                  ],
                  [
                    60113.1,
                    45818.3
                  ],
                  [
                    60259.6,
                    45815.1
                  ],
                  [
                    60345.9,
                    45895.5
                  ],
                  [
                    60321.1,
                    46101.1
                  ],
                  [
                    60692.2,
                    46009.7
                  ],
                  [
                    60705.7,
                    45579.6
                  ],
                  [
                    60397.6,
                    45572
                  ],
                  [
                    59999.6,
                    45367.6
                  ],
                  [
                    59988.6,
                    45276.3
                  ],
                  [
                    60441,
                    45074.6
                  ],
                  [
                    60812.6,
                    45100.7
                  ],
                  [
                    60925,
                    45262.7
                  ],
                  [
                    60932.6,
                    45431.9
                  ],
                  [
                    60703.3,
                    45579.2
                  ],
                  [
                    60683.2,
                    46010
                  ],
                  [
                    60936.1,
                    46144.7
                  ],
                  [
                    61229.9,
                    46107.5
                  ],
                  [
                    61195.7,
                    45757.3
                  ],
                  [
                    61315.7,
                    45308.1
                  ],
                  [
                    61259.4,
                    45233.9
                  ],
                  [
                    61190.1,
                    44719.9
                  ]
                ],
                "id": 1544,
                "chat_link": "[&BAgGAAA=]"
              },
              "1560": {
                "name": "Elon Riverbank",
                "level": 80,
                "coord": [
                  59428.6,
                  47672.3
                ],
                "bounds": [
                  [
                    59204.9,
                    48036.6
                  ],
                  [
                    59955.9,
                    48072.1
                  ],
                  [
                    60014,
                    47685.8
                  ],
                  [
                    59849.1,
                    47439
                  ],
                  [
                    59658.5,
                    47524.9
                  ],
                  [
                    59310.9,
                    47153.1
                  ],
                  [
                    58987.3,
                    47492.1
                  ],
                  [
                    59054.5,
                    47567.7
                  ],
                  [
                    59047.3,
                    47790.3
                  ],
                  [
                    59204.1,
                    47961.3
                  ],
                  [
                    59204.9,
                    48036.6
                  ]
                ],
                "id": 1560,
                "chat_link": "[&BBgGAAA=]"
              },
              "1561": {
                "name": "Deadlock Sweep",
                "level": 80,
                "coord": [
                  58483.7,
                  45061.8
                ],
                "bounds": [
                  [
                    58625.7,
                    44717.2
                  ],
                  [
                    58299.6,
                    44801.9
                  ],
                  [
                    58284.5,
                    44870.4
                  ],
                  [
                    58286.9,
                    45298.4
                  ],
                  [
                    58293.4,
                    45457.3
                  ],
                  [
                    58569.5,
                    45409.2
                  ],
                  [
                    59026.1,
                    44878.3
                  ],
                  [
                    58625.7,
                    44717.2
                  ]
                ],
                "id": 1561,
                "chat_link": "[&BBkGAAA=]"
              },
              "1582": {
                "name": "Prophet's Path",
                "level": 80,
                "coord": [
                  59252.4,
                  45441.4
                ],
                "bounds": [
                  [
                    59660.4,
                    45365.8
                  ],
                  [
                    59759.7,
                    44692.2
                  ],
                  [
                    59068.1,
                    44833.1
                  ],
                  [
                    58568.8,
                    45400.9
                  ],
                  [
                    58698.2,
                    45897.8
                  ],
                  [
                    59111.3,
                    45860.3
                  ],
                  [
                    59444.2,
                    45982.3
                  ],
                  [
                    59708.4,
                    45498.7
                  ],
                  [
                    59660.4,
                    45365.8
                  ]
                ],
                "id": 1582,
                "chat_link": "[&BC4GAAA=]"
              },
              "1584": {
                "name": "The Quickmire",
                "level": 80,
                "coord": [
                  59960.1,
                  45937.4
                ],
                "bounds": [
                  [
                    59904.1,
                    46274.3
                  ],
                  [
                    60180.7,
                    46255.8
                  ],
                  [
                    60325.4,
                    46100.1
                  ],
                  [
                    60349,
                    45894.5
                  ],
                  [
                    60261.5,
                    45809.4
                  ],
                  [
                    60114.1,
                    45813.9
                  ],
                  [
                    59848.6,
                    45447.4
                  ],
                  [
                    59705.3,
                    45492.7
                  ],
                  [
                    59438.6,
                    45980
                  ],
                  [
                    59620.2,
                    46122
                  ],
                  [
                    59814.1,
                    46121.5
                  ],
                  [
                    59904.1,
                    46274.3
                  ]
                ],
                "id": 1584,
                "chat_link": "[&BDAGAAA=]"
              },
              "1585": {
                "name": "Champion's Gap",
                "level": 80,
                "coord": [
                  59243.9,
                  46169
                ],
                "bounds": [
                  [
                    59817.7,
                    46120
                  ],
                  [
                    59623.5,
                    46118.7
                  ],
                  [
                    59444.5,
                    45978.4
                  ],
                  [
                    59111.4,
                    45855.9
                  ],
                  [
                    58697.6,
                    45894
                  ],
                  [
                    58490.7,
                    46251.7
                  ],
                  [
                    58907,
                    46403.3
                  ],
                  [
                    59100.4,
                    46278.2
                  ],
                  [
                    59229.9,
                    46283
                  ],
                  [
                    59352.4,
                    46405.3
                  ],
                  [
                    59908.3,
                    46270.1
                  ],
                  [
                    59817.7,
                    46120
                  ]
                ],
                "id": 1585,
                "chat_link": "[&BDEGAAA=]"
              },
              "1591": {
                "name": "Skimshallow Cove",
                "level": 80,
                "coord": [
                  60396.1,
                  45960.8
                ],
                "bounds": [
                  [
                    60970.1,
                    46137.1
                  ],
                  [
                    60997.7,
                    46018.5
                  ],
                  [
                    60889.5,
                    45872.2
                  ],
                  [
                    60532.2,
                    45687.5
                  ],
                  [
                    60514.7,
                    45589
                  ],
                  [
                    60379.3,
                    45664.9
                  ],
                  [
                    59984.1,
                    45659.7
                  ],
                  [
                    59982.8,
                    45938.4
                  ],
                  [
                    59986.6,
                    46031.1
                  ],
                  [
                    60086.1,
                    46066.7
                  ],
                  [
                    60099.2,
                    46127.1
                  ],
                  [
                    60073.4,
                    46227.9
                  ],
                  [
                    60653.3,
                    46469.8
                  ],
                  [
                    60970.1,
                    46137.1
                  ]
                ],
                "id": 1591,
                "chat_link": "[&BDcGAAA=]"
              }
            },
            "adventures": [],
            "id": 1228,
            "mastery_points": [
              {
                "coord": [
                  58411,
                  44886.1
                ],
                "id": 393,
                "region": "Desert"
              },
              {
                "coord": [
                  59745.5,
                  45890.2
                ],
                "id": 330,
                "region": "Desert"
              },
              {
                "coord": [
                  60928.2,
                  48123.6
                ],
                "id": 416,
                "region": "Desert"
              },
              {
                "coord": [
                  59603.9,
                  46498.2
                ],
                "id": 343,
                "region": "Desert"
              },
              {
                "coord": [
                  60720.4,
                  47320.5
                ],
                "id": 413,
                "region": "Desert"
              },
              {
                "coord": [
                  59013.5,
                  46844.2
                ],
                "id": 328,
                "region": "Desert"
              },
              {
                "coord": [
                  58979.6,
                  47980.7
                ],
                "id": 411,
                "region": "Desert"
              },
              {
                "coord": [
                  59870.9,
                  45370.3
                ],
                "id": 364,
                "region": "Desert"
              },
              {
                "coord": [
                  58663.6,
                  45066.8
                ],
                "id": 362,
                "region": "Desert"
              },
              {
                "coord": [
                  60175.3,
                  44936.9
                ],
                "id": 399,
                "region": "Desert"
              },
              {
                "coord": [
                  58319.4,
                  45956.8
                ],
                "id": 340,
                "region": "Desert"
              },
              {
                "coord": [
                  58824.3,
                  45981.1
                ],
                "id": 410,
                "region": "Desert"
              }
            ]
          },
          "1231": {
            "name": "Claiming Windswept Haven",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 49,
            "label_coord": [
              64672,
              51646
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                64016,
                51072
              ],
              [
                65296,
                52352
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1518": {
                "level": 0,
                "coord": [
                  64748.2,
                  51688.9
                ],
                "bounds": [
                  [
                    65265.6,
                    51274
                  ],
                  [
                    65282.6,
                    51903.2
                  ],
                  [
                    65229.7,
                    52092.6
                  ],
                  [
                    65092.8,
                    52388.4
                  ],
                  [
                    64340.1,
                    52410.9
                  ],
                  [
                    64180.4,
                    51778.5
                  ],
                  [
                    64217.3,
                    51162.9
                  ],
                  [
                    64436.8,
                    51101.1
                  ],
                  [
                    64688.1,
                    51089
                  ],
                  [
                    65265.6,
                    51274
                  ]
                ],
                "id": 1518,
                "chat_link": "[&BO4FAAA=]"
              }
            },
            "id": 1231,
            "mastery_points": [],
            "adventures": []
          },
          "1232": {
            "name": "Windswept Haven",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              64672,
              51646
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                64016,
                51072
              ],
              [
                65296,
                52352
              ]
            ],
            "points_of_interest": {
              "2690": {
                "name": "Windswept Arena Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64610.8,
                  51738.4
                ],
                "id": 2690,
                "chat_link": "[&BIIKAAA=]"
              },
              "2721": {
                "name": "Cavern Overlook Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64453.1,
                  52290.7
                ],
                "id": 2721,
                "chat_link": "[&BKEKAAA=]"
              },
              "2775": {
                "name": "Vantage Dome Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  65172.6,
                  51485.6
                ],
                "id": 2775,
                "chat_link": "[&BNcKAAA=]"
              },
              "2781": {
                "name": "Haven Terrace Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64843.8,
                  51650.5
                ],
                "id": 2781,
                "chat_link": "[&BN0KAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1518": {
                "level": 0,
                "coord": [
                  64748.2,
                  51688.9
                ],
                "bounds": [
                  [
                    65265.6,
                    51274
                  ],
                  [
                    65282.6,
                    51903.2
                  ],
                  [
                    65229.7,
                    52092.6
                  ],
                  [
                    65092.8,
                    52388.4
                  ],
                  [
                    64340.1,
                    52410.9
                  ],
                  [
                    64180.4,
                    51778.5
                  ],
                  [
                    64217.3,
                    51162.9
                  ],
                  [
                    64436.8,
                    51101.1
                  ],
                  [
                    64688.1,
                    51089
                  ],
                  [
                    65265.6,
                    51274
                  ]
                ],
                "id": 1518,
                "chat_link": "[&BO4FAAA=]"
              }
            },
            "id": 1232,
            "mastery_points": [],
            "adventures": []
          },
          "1234": {
            "name": "To Kill a God",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              38768,
              45740
            ],
            "map_rect": [
              [
                -58368,
                -36864
              ],
              [
                58368,
                39936
              ]
            ],
            "continent_rect": [
              [
                63616,
                52352
              ],
              [
                68480,
                55552
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1234,
            "mastery_points": []
          },
          "1236": {
            "name": "Claiming Windswept Haven",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 49,
            "label_coord": [
              64672,
              51646
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                64016,
                51072
              ],
              [
                65296,
                52352
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1518": {
                "level": 0,
                "coord": [
                  64748.2,
                  51688.9
                ],
                "bounds": [
                  [
                    65265.6,
                    51274
                  ],
                  [
                    65282.6,
                    51903.2
                  ],
                  [
                    65229.7,
                    52092.6
                  ],
                  [
                    65092.8,
                    52388.4
                  ],
                  [
                    64340.1,
                    52410.9
                  ],
                  [
                    64180.4,
                    51778.5
                  ],
                  [
                    64217.3,
                    51162.9
                  ],
                  [
                    64436.8,
                    51101.1
                  ],
                  [
                    64688.1,
                    51089
                  ],
                  [
                    65265.6,
                    51274
                  ]
                ],
                "id": 1518,
                "chat_link": "[&BO4FAAA=]"
              }
            },
            "id": 1236,
            "mastery_points": [],
            "adventures": []
          },
          "1240": {
            "name": "Blazing a Trail",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              60176,
              44240
            ],
            "map_rect": [
              [
                -61440,
                -30720
              ],
              [
                61440,
                30720
              ]
            ],
            "continent_rect": [
              [
                57256,
                42304
              ],
              [
                62376,
                44864
              ]
            ],
            "points_of_interest": {
              "2631": {
                "name": "Grand Sahil Casino",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58383.5,
                  44039.7
                ],
                "id": 2631,
                "chat_link": "[&BEcKAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1562": {
                "name": "Free City of Amnoon",
                "level": 80,
                "coord": [
                  58417.9,
                  43644.3
                ],
                "bounds": [
                  [
                    58220.8,
                    44176.2
                  ],
                  [
                    58727,
                    44196.1
                  ],
                  [
                    58874.5,
                    44256.1
                  ],
                  [
                    58942,
                    44173.4
                  ],
                  [
                    58980.9,
                    44123.6
                  ],
                  [
                    58962.3,
                    44046.2
                  ],
                  [
                    58847,
                    43967.2
                  ],
                  [
                    58860.9,
                    43295.6
                  ],
                  [
                    58747.8,
                    43250.8
                  ],
                  [
                    58539.8,
                    43207.2
                  ],
                  [
                    58430.7,
                    43204.8
                  ],
                  [
                    58379.3,
                    43159.2
                  ],
                  [
                    58284.1,
                    43126.7
                  ],
                  [
                    58093.3,
                    43115.7
                  ],
                  [
                    58043.3,
                    43245.2
                  ],
                  [
                    57885.9,
                    43274.9
                  ],
                  [
                    57887.5,
                    43407.1
                  ],
                  [
                    57828.3,
                    43644.2
                  ],
                  [
                    57823.3,
                    43846.7
                  ],
                  [
                    57999.4,
                    44168.3
                  ],
                  [
                    58220.8,
                    44176.2
                  ]
                ],
                "id": 1562,
                "chat_link": "[&BBoGAAA=]"
              }
            },
            "adventures": [],
            "id": 1240,
            "mastery_points": []
          },
          "1241": {
            "name": "Night of Fires",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              60176,
              44240
            ],
            "map_rect": [
              [
                -61440,
                -30720
              ],
              [
                61440,
                30720
              ]
            ],
            "continent_rect": [
              [
                57256,
                42304
              ],
              [
                62376,
                44864
              ]
            ],
            "points_of_interest": {
              "2641": {
                "name": "Zephyr's Trace",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61584.8,
                  44028.3
                ],
                "id": 2641,
                "chat_link": "[&BFEKAAA=]"
              },
              "2656": {
                "name": "Crucible of Consecration",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61572.9,
                  43423.5
                ],
                "id": 2656,
                "chat_link": "[&BGAKAAA=]"
              },
              "2677": {
                "name": "Temple of Kormir",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60961.8,
                  43368.5
                ],
                "id": 2677,
                "chat_link": "[&BHUKAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1487": {
                "name": "Elona Reach",
                "level": 80,
                "coord": [
                  61076.1,
                  43543.8
                ],
                "bounds": [
                  [
                    60787.1,
                    43983.5
                  ],
                  [
                    60903.9,
                    44046.1
                  ],
                  [
                    61022,
                    44124.6
                  ],
                  [
                    61172.3,
                    44085.7
                  ],
                  [
                    61334.5,
                    43978.1
                  ],
                  [
                    61282.2,
                    43809.8
                  ],
                  [
                    61396.7,
                    43734.9
                  ],
                  [
                    61328.8,
                    43567.8
                  ],
                  [
                    61346.4,
                    43306.4
                  ],
                  [
                    61446.9,
                    43219.1
                  ],
                  [
                    61434.5,
                    43011.4
                  ],
                  [
                    61162.3,
                    42972.7
                  ],
                  [
                    61009.9,
                    42954.2
                  ],
                  [
                    60667.1,
                    42901.9
                  ],
                  [
                    60638.2,
                    43156.9
                  ],
                  [
                    60638.9,
                    43572.9
                  ],
                  [
                    60721.7,
                    43819.2
                  ],
                  [
                    60787.1,
                    43983.5
                  ]
                ],
                "id": 1487,
                "chat_link": "[&BM8FAAA=]"
              },
              "1499": {
                "name": "Destiny's Gorge",
                "level": 80,
                "coord": [
                  61680.6,
                  44110
                ],
                "bounds": [
                  [
                    61395.3,
                    44842
                  ],
                  [
                    61839.4,
                    44794.7
                  ],
                  [
                    61815.9,
                    44425.4
                  ],
                  [
                    61904.2,
                    44305.3
                  ],
                  [
                    61799.7,
                    44182.2
                  ],
                  [
                    61791.3,
                    44061.1
                  ],
                  [
                    61939.5,
                    43983.1
                  ],
                  [
                    61978.3,
                    43845.3
                  ],
                  [
                    62060.1,
                    43797.1
                  ],
                  [
                    61992.6,
                    43702.5
                  ],
                  [
                    61740.1,
                    43863.3
                  ],
                  [
                    61632.8,
                    43702.2
                  ],
                  [
                    61396.8,
                    43735.3
                  ],
                  [
                    61282.8,
                    43809.2
                  ],
                  [
                    61335.1,
                    43978.4
                  ],
                  [
                    61449.8,
                    44035.6
                  ],
                  [
                    61496.5,
                    44324.6
                  ],
                  [
                    61401.2,
                    44593.5
                  ],
                  [
                    61395.3,
                    44842
                  ]
                ],
                "id": 1499,
                "chat_link": "[&BNsFAAA=]"
              },
              "1538": {
                "name": "Forged Foothold",
                "level": 80,
                "coord": [
                  61680.8,
                  43504.7
                ],
                "bounds": [
                  [
                    61632.8,
                    43703
                  ],
                  [
                    61740.5,
                    43862.7
                  ],
                  [
                    61993.4,
                    43702.7
                  ],
                  [
                    62022.1,
                    43612.6
                  ],
                  [
                    61987.6,
                    43478.7
                  ],
                  [
                    61950.4,
                    43317.1
                  ],
                  [
                    61768,
                    43271.8
                  ],
                  [
                    61557.7,
                    43279.2
                  ],
                  [
                    61447,
                    43219.8
                  ],
                  [
                    61345.5,
                    43306.9
                  ],
                  [
                    61328.8,
                    43567.8
                  ],
                  [
                    61396,
                    43734.3
                  ],
                  [
                    61632.8,
                    43703
                  ]
                ],
                "id": 1538,
                "chat_link": "[&BAIGAAA=]"
              },
              "1550": {
                "name": "Kusini Crossing",
                "level": 80,
                "coord": [
                  60745,
                  44205.7
                ],
                "bounds": [
                  [
                    60290.4,
                    44698.1
                  ],
                  [
                    61394.2,
                    44841.6
                  ],
                  [
                    61401.9,
                    44591.9
                  ],
                  [
                    61496.7,
                    44326.7
                  ],
                  [
                    61450.5,
                    44035
                  ],
                  [
                    61334.9,
                    43977.8
                  ],
                  [
                    61172.7,
                    44085.1
                  ],
                  [
                    61021.7,
                    44124.6
                  ],
                  [
                    60904.2,
                    44045.5
                  ],
                  [
                    60785.9,
                    43982.5
                  ],
                  [
                    60721.5,
                    43819
                  ],
                  [
                    60519.9,
                    43926.3
                  ],
                  [
                    60342.7,
                    43860.5
                  ],
                  [
                    60262.5,
                    43991.5
                  ],
                  [
                    60061.3,
                    44101.6
                  ],
                  [
                    59974.4,
                    44205.5
                  ],
                  [
                    60147.7,
                    44396.5
                  ],
                  [
                    60127.4,
                    44692.8
                  ],
                  [
                    60290.4,
                    44698.1
                  ]
                ],
                "id": 1550,
                "chat_link": "[&BA4GAAA=]"
              }
            },
            "adventures": [],
            "id": 1241,
            "mastery_points": []
          },
          "1242": {
            "name": "Zalambur's Office",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              60176,
              44240
            ],
            "map_rect": [
              [
                -61440,
                -30720
              ],
              [
                61440,
                30720
              ]
            ],
            "continent_rect": [
              [
                57256,
                42304
              ],
              [
                62376,
                44864
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1562": {
                "name": "Free City of Amnoon",
                "level": 80,
                "coord": [
                  58417.9,
                  43644.3
                ],
                "bounds": [
                  [
                    58220.8,
                    44176.2
                  ],
                  [
                    58727,
                    44196.1
                  ],
                  [
                    58874.5,
                    44256.1
                  ],
                  [
                    58942,
                    44173.4
                  ],
                  [
                    58980.9,
                    44123.6
                  ],
                  [
                    58962.3,
                    44046.2
                  ],
                  [
                    58847,
                    43967.2
                  ],
                  [
                    58860.9,
                    43295.6
                  ],
                  [
                    58747.8,
                    43250.8
                  ],
                  [
                    58539.8,
                    43207.2
                  ],
                  [
                    58430.7,
                    43204.8
                  ],
                  [
                    58379.3,
                    43159.2
                  ],
                  [
                    58284.1,
                    43126.7
                  ],
                  [
                    58093.3,
                    43115.7
                  ],
                  [
                    58043.3,
                    43245.2
                  ],
                  [
                    57885.9,
                    43274.9
                  ],
                  [
                    57887.5,
                    43407.1
                  ],
                  [
                    57828.3,
                    43644.2
                  ],
                  [
                    57823.3,
                    43846.7
                  ],
                  [
                    57999.4,
                    44168.3
                  ],
                  [
                    58220.8,
                    44176.2
                  ]
                ],
                "id": 1562,
                "chat_link": "[&BBoGAAA=]"
              }
            },
            "adventures": [],
            "id": 1242,
            "mastery_points": []
          },
          "1243": {
            "name": "Windswept Haven",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              64672,
              51646
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                64016,
                51072
              ],
              [
                65296,
                52352
              ]
            ],
            "points_of_interest": {
              "2690": {
                "name": "Windswept Arena Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64610.8,
                  51738.4
                ],
                "id": 2690,
                "chat_link": "[&BIIKAAA=]"
              },
              "2721": {
                "name": "Cavern Overlook Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64453.1,
                  52290.7
                ],
                "id": 2721,
                "chat_link": "[&BKEKAAA=]"
              },
              "2775": {
                "name": "Vantage Dome Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  65172.6,
                  51485.6
                ],
                "id": 2775,
                "chat_link": "[&BNcKAAA=]"
              },
              "2781": {
                "name": "Haven Terrace Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64843.8,
                  51650.5
                ],
                "id": 2781,
                "chat_link": "[&BN0KAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1518": {
                "level": 0,
                "coord": [
                  64748.2,
                  51688.9
                ],
                "bounds": [
                  [
                    65265.6,
                    51274
                  ],
                  [
                    65282.6,
                    51903.2
                  ],
                  [
                    65229.7,
                    52092.6
                  ],
                  [
                    65092.8,
                    52388.4
                  ],
                  [
                    64340.1,
                    52410.9
                  ],
                  [
                    64180.4,
                    51778.5
                  ],
                  [
                    64217.3,
                    51162.9
                  ],
                  [
                    64436.8,
                    51101.1
                  ],
                  [
                    64688.1,
                    51089
                  ],
                  [
                    65265.6,
                    51274
                  ]
                ],
                "id": 1518,
                "chat_link": "[&BO4FAAA=]"
              }
            },
            "id": 1243,
            "mastery_points": [],
            "adventures": []
          },
          "1244": {
            "name": "Claiming Windswept Haven",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 49,
            "label_coord": [
              64672,
              51646
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                64016,
                51072
              ],
              [
                65296,
                52352
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1518": {
                "level": 0,
                "coord": [
                  64748.2,
                  51688.9
                ],
                "bounds": [
                  [
                    65265.6,
                    51274
                  ],
                  [
                    65282.6,
                    51903.2
                  ],
                  [
                    65229.7,
                    52092.6
                  ],
                  [
                    65092.8,
                    52388.4
                  ],
                  [
                    64340.1,
                    52410.9
                  ],
                  [
                    64180.4,
                    51778.5
                  ],
                  [
                    64217.3,
                    51162.9
                  ],
                  [
                    64436.8,
                    51101.1
                  ],
                  [
                    64688.1,
                    51089
                  ],
                  [
                    65265.6,
                    51274
                  ]
                ],
                "id": 1518,
                "chat_link": "[&BO4FAAA=]"
              }
            },
            "id": 1244,
            "mastery_points": [],
            "adventures": []
          },
          "1245": {
            "name": "The Departing",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              59868,
              46284
            ],
            "map_rect": [
              [
                -33792,
                -27648
              ],
              [
                36864,
                30720
              ]
            ],
            "continent_rect": [
              [
                56963,
                46274
              ],
              [
                59907,
                48706
              ]
            ],
            "points_of_interest": {
              "2659": {
                "name": "Pillars of Supremacy",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57215.7,
                  47930.2
                ],
                "id": 2659,
                "chat_link": "[&BGMKAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1591": {
                "name": "Skimshallow Cove",
                "level": 80,
                "coord": [
                  58735.1,
                  46986.8
                ],
                "bounds": [
                  [
                    59309.1,
                    47163.1
                  ],
                  [
                    59336.7,
                    47044.5
                  ],
                  [
                    59228.5,
                    46898.2
                  ],
                  [
                    58871.2,
                    46713.5
                  ],
                  [
                    58853.7,
                    46615
                  ],
                  [
                    58718.3,
                    46690.9
                  ],
                  [
                    58323.1,
                    46685.7
                  ],
                  [
                    58321.8,
                    46964.4
                  ],
                  [
                    58325.6,
                    47057.1
                  ],
                  [
                    58425.1,
                    47092.7
                  ],
                  [
                    58438.2,
                    47153.1
                  ],
                  [
                    58412.4,
                    47253.9
                  ],
                  [
                    58992.3,
                    47495.8
                  ],
                  [
                    59309.1,
                    47163.1
                  ]
                ],
                "id": 1591,
                "chat_link": "[&BDcGAAA=]"
              }
            },
            "id": 1245,
            "mastery_points": [],
            "adventures": []
          },
          "1247": {
            "name": "Enemy of My Enemy",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              59868,
              48784
            ],
            "map_rect": [
              [
                -43008,
                -61440
              ],
              [
                43008,
                61440
              ]
            ],
            "continent_rect": [
              [
                58240,
                48192
              ],
              [
                61824,
                53312
              ]
            ],
            "points_of_interest": {
              "2554": {
                "name": "Northern Maw",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59050.9,
                  51347.5
                ],
                "id": 2554,
                "chat_link": "[&BPoJAAA=]"
              },
              "2562": {
                "name": "The Bone Palace",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60543.6,
                  52977.6
                ],
                "id": 2562,
                "chat_link": "[&BAIKAAA=]"
              },
              "2578": {
                "name": "Junundu Lookout",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60055.6,
                  52616.1
                ],
                "id": 2578,
                "chat_link": "[&BBIKAAA=]"
              },
              "2583": {
                "name": "Imperial Sulfurworks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58934.9,
                  49611.9
                ],
                "id": 2583,
                "chat_link": "[&BBcKAAA=]"
              },
              "2587": {
                "name": "Springer's Ladder",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61638.7,
                  49365.8
                ],
                "id": 2587,
                "chat_link": "[&BBsKAAA=]"
              },
              "2638": {
                "name": "Torment's Watch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59296.9,
                  50676.9
                ],
                "id": 2638,
                "chat_link": "[&BE4KAAA=]"
              },
              "2642": {
                "name": "Clanmarshal's Pergola",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60440,
                  49163.7
                ],
                "id": 2642,
                "chat_link": "[&BFIKAAA=]"
              },
              "2660": {
                "name": "The Mouth of Torment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59058.3,
                  51518.8
                ],
                "id": 2660,
                "chat_link": "[&BGQKAAA=]"
              },
              "2682": {
                "name": "Scourge's Threshold",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59914.4,
                  49633.1
                ],
                "id": 2682,
                "chat_link": "[&BHoKAAA=]"
              },
              "2701": {
                "name": "Eastern Maw",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59213.7,
                  51495.6
                ],
                "id": 2701,
                "chat_link": "[&BI0KAAA=]"
              },
              "2718": {
                "name": "Sandfall Sanctum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60653.8,
                  49343.9
                ],
                "id": 2718,
                "chat_link": "[&BJ4KAAA=]"
              },
              "2727": {
                "name": "Bonestrand Garrison",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59634.7,
                  48879.9
                ],
                "id": 2727,
                "chat_link": "[&BKcKAAA=]"
              },
              "2754": {
                "name": "Western Maw",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58943.5,
                  51367.6
                ],
                "id": 2754,
                "chat_link": "[&BMIKAAA=]"
              },
              "2760": {
                "name": "Village of Purity",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60345.6,
                  48711.9
                ],
                "id": 2760,
                "chat_link": "[&BMgKAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1488": {
                "name": "Joko's Domain",
                "level": 80,
                "coord": [
                  60631.5,
                  52729.4
                ],
                "bounds": [
                  [
                    60245.6,
                    52665.1
                  ],
                  [
                    60106,
                    52470.6
                  ],
                  [
                    60416.3,
                    52358.2
                  ],
                  [
                    60482,
                    52129.7
                  ],
                  [
                    61038.5,
                    52043
                  ],
                  [
                    61139.9,
                    52203.8
                  ],
                  [
                    60973.8,
                    52614.6
                  ],
                  [
                    61002.4,
                    52892.6
                  ],
                  [
                    61044.1,
                    52973.9
                  ],
                  [
                    60968.4,
                    53248.7
                  ],
                  [
                    60898.2,
                    53266.9
                  ],
                  [
                    60407,
                    53272.6
                  ],
                  [
                    60070.8,
                    53152.1
                  ],
                  [
                    60047.9,
                    52919.7
                  ],
                  [
                    60245.6,
                    52665.1
                  ]
                ],
                "id": 1488,
                "chat_link": "[&BNAFAAA=]"
              },
              "1489": {
                "name": "The Spillway",
                "level": 80,
                "coord": [
                  59341.9,
                  48516.6
                ],
                "bounds": [
                  [
                    58910.9,
                    48844.1
                  ],
                  [
                    59118.6,
                    48932.7
                  ],
                  [
                    59514.3,
                    48620.6
                  ],
                  [
                    59855.5,
                    48585
                  ],
                  [
                    60033.3,
                    48191.7
                  ],
                  [
                    59193.7,
                    48189.6
                  ],
                  [
                    58767.3,
                    48252.8
                  ],
                  [
                    58910.9,
                    48844.1
                  ]
                ],
                "id": 1489,
                "chat_link": "[&BNEFAAA=]"
              },
              "1502": {
                "name": "The Shattered Ravines",
                "level": 80,
                "coord": [
                  60668.8,
                  51704.8
                ],
                "bounds": [
                  [
                    59968.4,
                    51263.5
                  ],
                  [
                    60555.9,
                    50948.6
                  ],
                  [
                    61225.6,
                    51478.7
                  ],
                  [
                    61595.7,
                    51549
                  ],
                  [
                    61296.9,
                    51989
                  ],
                  [
                    61036.8,
                    52053.2
                  ],
                  [
                    60485.1,
                    52141.1
                  ],
                  [
                    60270.1,
                    52065.1
                  ],
                  [
                    60240.7,
                    51845
                  ],
                  [
                    60012.5,
                    51714.4
                  ],
                  [
                    59968.4,
                    51263.5
                  ]
                ],
                "id": 1502,
                "chat_link": "[&BN4FAAA=]"
              },
              "1508": {
                "name": "Caustic Spur",
                "level": 80,
                "coord": [
                  58509.1,
                  50107
                ],
                "bounds": [
                  [
                    58826.5,
                    50465.4
                  ],
                  [
                    58576.3,
                    50103.2
                  ],
                  [
                    58603.4,
                    49909.4
                  ],
                  [
                    58543.7,
                    49855.1
                  ],
                  [
                    58348.7,
                    49757.1
                  ],
                  [
                    58285,
                    50008.4
                  ],
                  [
                    58380.4,
                    50650.5
                  ],
                  [
                    58826.5,
                    50465.4
                  ]
                ],
                "id": 1508,
                "chat_link": "[&BOQFAAA=]"
              },
              "1522": {
                "name": "Boundary Preserve",
                "level": 80,
                "coord": [
                  61221.5,
                  48971.2
                ],
                "bounds": [
                  [
                    61760.6,
                    48501.5
                  ],
                  [
                    61117.1,
                    48654.9
                  ],
                  [
                    60895.8,
                    48455.4
                  ],
                  [
                    60859.8,
                    48709.6
                  ],
                  [
                    60738.9,
                    48957
                  ],
                  [
                    60896.1,
                    49147.6
                  ],
                  [
                    60971.8,
                    49444.1
                  ],
                  [
                    61484.6,
                    49284.7
                  ],
                  [
                    61728.7,
                    49369.4
                  ],
                  [
                    61761.7,
                    49187.4
                  ],
                  [
                    61760.6,
                    48501.5
                  ]
                ],
                "id": 1522,
                "chat_link": "[&BPIFAAA=]"
              },
              "1526": {
                "name": "The Bonestrand",
                "level": 80,
                "coord": [
                  60287.5,
                  48628.3
                ],
                "bounds": [
                  [
                    60200.9,
                    49006.4
                  ],
                  [
                    60748.1,
                    48959.4
                  ],
                  [
                    60865.6,
                    48711.1
                  ],
                  [
                    60896.8,
                    48452.2
                  ],
                  [
                    60881.7,
                    48460.6
                  ],
                  [
                    60837.5,
                    48367.6
                  ],
                  [
                    60799.9,
                    48379.5
                  ],
                  [
                    60690.6,
                    48181.9
                  ],
                  [
                    60031,
                    48195.2
                  ],
                  [
                    59847.5,
                    48590.9
                  ],
                  [
                    59517.7,
                    48607.4
                  ],
                  [
                    59113.4,
                    48930.4
                  ],
                  [
                    59307.3,
                    49324.8
                  ],
                  [
                    60200.9,
                    49006.4
                  ]
                ],
                "id": 1526,
                "chat_link": "[&BPYFAAA=]"
              },
              "1547": {
                "name": "Broken Shelf",
                "level": 80,
                "coord": [
                  58797.3,
                  52282.8
                ],
                "bounds": [
                  [
                    58324.7,
                    52619.2
                  ],
                  [
                    58534.8,
                    52751.3
                  ],
                  [
                    58698.6,
                    52580.1
                  ],
                  [
                    58808,
                    52611.8
                  ],
                  [
                    58876.2,
                    52575.1
                  ],
                  [
                    59029.4,
                    52308.5
                  ],
                  [
                    59199.9,
                    52303
                  ],
                  [
                    59374.3,
                    52255.5
                  ],
                  [
                    59256.8,
                    51886.1
                  ],
                  [
                    58859.2,
                    51908.5
                  ],
                  [
                    58794.5,
                    51840.3
                  ],
                  [
                    58310.2,
                    51978.7
                  ],
                  [
                    58298,
                    52058.8
                  ],
                  [
                    58324.7,
                    52619.2
                  ]
                ],
                "id": 1547,
                "chat_link": "[&BAsGAAA=]"
              },
              "1548": {
                "name": "The Alkali Pan",
                "level": 80,
                "coord": [
                  59345,
                  52685
                ],
                "bounds": [
                  [
                    59949.3,
                    52251.9
                  ],
                  [
                    59331.4,
                    52153.5
                  ],
                  [
                    59411.3,
                    52392.3
                  ],
                  [
                    59548.6,
                    52416.8
                  ],
                  [
                    59784.3,
                    52644.3
                  ],
                  [
                    59776.9,
                    52724
                  ],
                  [
                    59588.8,
                    52855.5
                  ],
                  [
                    59580.3,
                    52949.6
                  ],
                  [
                    59418.3,
                    53007.1
                  ],
                  [
                    59149.9,
                    52844.8
                  ],
                  [
                    59014.3,
                    52843.6
                  ],
                  [
                    58969.1,
                    52757.6
                  ],
                  [
                    59168,
                    52483.2
                  ],
                  [
                    59418.2,
                    52389.8
                  ],
                  [
                    59372.9,
                    52252.8
                  ],
                  [
                    59201.5,
                    52297.1
                  ],
                  [
                    59026.9,
                    52302.6
                  ],
                  [
                    58870.2,
                    52571.6
                  ],
                  [
                    58795.2,
                    52611.7
                  ],
                  [
                    58693.2,
                    52576.2
                  ],
                  [
                    58535.9,
                    52746.8
                  ],
                  [
                    58626.3,
                    53162.3
                  ],
                  [
                    58703.9,
                    53270.1
                  ],
                  [
                    59995.7,
                    53267.8
                  ],
                  [
                    60079.1,
                    53145.8
                  ],
                  [
                    60052.1,
                    52915.5
                  ],
                  [
                    60253.7,
                    52660.8
                  ],
                  [
                    59949.3,
                    52251.9
                  ]
                ],
                "id": 1548,
                "chat_link": "[&BAwGAAA=]"
              },
              "1549": {
                "name": "Palawa Cut",
                "level": 80,
                "coord": [
                  60175.6,
                  49343.7
                ],
                "bounds": [
                  [
                    59303.7,
                    49316.6
                  ],
                  [
                    60196.1,
                    49001.5
                  ],
                  [
                    60738.9,
                    48948.2
                  ],
                  [
                    60896.6,
                    49146.3
                  ],
                  [
                    60979.6,
                    49444.4
                  ],
                  [
                    60142.4,
                    49605
                  ],
                  [
                    59758.8,
                    49776.4
                  ],
                  [
                    59388.8,
                    49511.2
                  ],
                  [
                    59303.7,
                    49316.6
                  ]
                ],
                "id": 1549,
                "chat_link": "[&BA0GAAA=]"
              },
              "1551": {
                "name": "Poisoned Outcrops",
                "level": 80,
                "coord": [
                  61201.3,
                  50199.7
                ],
                "bounds": [
                  [
                    61347.2,
                    50378
                  ],
                  [
                    61415.4,
                    50296.8
                  ],
                  [
                    61482.1,
                    50248.3
                  ],
                  [
                    61577.4,
                    50176.9
                  ],
                  [
                    61783.7,
                    50001.1
                  ],
                  [
                    61776.6,
                    49432.9
                  ],
                  [
                    61736,
                    49365.7
                  ],
                  [
                    61482.1,
                    49276.1
                  ],
                  [
                    60854.8,
                    49468.6
                  ],
                  [
                    60871.5,
                    49614.5
                  ],
                  [
                    60819.4,
                    49811.5
                  ],
                  [
                    60601,
                    50119.4
                  ],
                  [
                    60631.6,
                    50626.9
                  ],
                  [
                    60556.7,
                    50948
                  ],
                  [
                    60820.7,
                    51159.7
                  ],
                  [
                    61144.8,
                    50987
                  ],
                  [
                    61371.7,
                    50727.8
                  ],
                  [
                    61294.1,
                    50640.7
                  ],
                  [
                    61258.5,
                    50514.7
                  ],
                  [
                    61347.2,
                    50378
                  ]
                ],
                "id": 1551,
                "chat_link": "[&BA8GAAA=]"
              },
              "1557": {
                "name": "The Darklands",
                "level": 80,
                "coord": [
                  59240.5,
                  50159
                ],
                "bounds": [
                  [
                    58859.5,
                    49802.3
                  ],
                  [
                    59235,
                    49865.3
                  ],
                  [
                    59389.9,
                    49515.5
                  ],
                  [
                    59759.5,
                    49774
                  ],
                  [
                    59713.8,
                    50239.2
                  ],
                  [
                    59837.3,
                    50384.4
                  ],
                  [
                    59773.8,
                    50512.4
                  ],
                  [
                    59327.4,
                    50553.2
                  ],
                  [
                    59134.4,
                    50516.1
                  ],
                  [
                    59116.7,
                    50415.9
                  ],
                  [
                    58815.9,
                    50475.3
                  ],
                  [
                    58564.3,
                    50107.8
                  ],
                  [
                    58599.2,
                    49905.2
                  ],
                  [
                    58859.5,
                    49802.3
                  ]
                ],
                "id": 1557,
                "chat_link": "[&BBUGAAA=]"
              },
              "1558": {
                "name": "Scorched March",
                "level": 80,
                "coord": [
                  59895.7,
                  52007.3
                ],
                "bounds": [
                  [
                    60010.9,
                    51702.5
                  ],
                  [
                    59928.7,
                    51814.8
                  ],
                  [
                    59686.5,
                    51846.7
                  ],
                  [
                    59571.2,
                    51786.6
                  ],
                  [
                    59371.2,
                    51779.3
                  ],
                  [
                    59252.6,
                    51889.7
                  ],
                  [
                    59333.4,
                    52156.3
                  ],
                  [
                    59954.6,
                    52262.9
                  ],
                  [
                    60106,
                    52472.8
                  ],
                  [
                    60419,
                    52360.5
                  ],
                  [
                    60487.2,
                    52131.1
                  ],
                  [
                    60269.3,
                    52059.2
                  ],
                  [
                    60253.9,
                    51833
                  ],
                  [
                    60010.9,
                    51702.5
                  ]
                ],
                "id": 1558,
                "chat_link": "[&BBYGAAA=]"
              },
              "1567": {
                "name": "Silent Vale",
                "level": 80,
                "coord": [
                  61172.4,
                  48334.4
                ],
                "bounds": [
                  [
                    61116.4,
                    48660.8
                  ],
                  [
                    60882.6,
                    48457.5
                  ],
                  [
                    60837.6,
                    48369.1
                  ],
                  [
                    60793.6,
                    48383.6
                  ],
                  [
                    60669.9,
                    48183.9
                  ],
                  [
                    60969.1,
                    48198.4
                  ],
                  [
                    61743.7,
                    48058.4
                  ],
                  [
                    61775.3,
                    48192.2
                  ],
                  [
                    61763.7,
                    48505.9
                  ],
                  [
                    61116.4,
                    48660.8
                  ]
                ],
                "id": 1567,
                "chat_link": "[&BB8GAAA=]"
              },
              "1568": {
                "name": "Sulfur Quarry",
                "level": 80,
                "coord": [
                  58739.9,
                  49467.6
                ],
                "bounds": [
                  [
                    58541.1,
                    49861.2
                  ],
                  [
                    58600,
                    49916.2
                  ],
                  [
                    58862.6,
                    49803.7
                  ],
                  [
                    59238.9,
                    49862.3
                  ],
                  [
                    59391.9,
                    49494.3
                  ],
                  [
                    59122.4,
                    48927.9
                  ],
                  [
                    58782.3,
                    49067.9
                  ],
                  [
                    58675.8,
                    49251
                  ],
                  [
                    58539.1,
                    49293.3
                  ],
                  [
                    58489,
                    49186.5
                  ],
                  [
                    58287.4,
                    49182.3
                  ],
                  [
                    58348.6,
                    49764.7
                  ],
                  [
                    58541.1,
                    49861.2
                  ]
                ],
                "id": 1568,
                "chat_link": "[&BCAGAAA=]"
              },
              "1573": {
                "name": "The Scourgeway",
                "level": 80,
                "coord": [
                  60359.3,
                  50188.8
                ],
                "bounds": [
                  [
                    59966.1,
                    51263.6
                  ],
                  [
                    60563.6,
                    50949.3
                  ],
                  [
                    60634.3,
                    50626.9
                  ],
                  [
                    60601.8,
                    50119.1
                  ],
                  [
                    60821.3,
                    49816.7
                  ],
                  [
                    60883.4,
                    49611.1
                  ],
                  [
                    60866.5,
                    49465.1
                  ],
                  [
                    60144.5,
                    49602
                  ],
                  [
                    59749.6,
                    49772.1
                  ],
                  [
                    59711.9,
                    50260.2
                  ],
                  [
                    60009.7,
                    50590.5
                  ],
                  [
                    59966.1,
                    51263.6
                  ]
                ],
                "id": 1573,
                "chat_link": "[&BCUGAAA=]"
              },
              "1577": {
                "name": "The Ruptured Heart",
                "level": 80,
                "coord": [
                  59163,
                  51433.8
                ],
                "bounds": [
                  [
                    58852.6,
                    51910.4
                  ],
                  [
                    59262.5,
                    51890
                  ],
                  [
                    59383.4,
                    51775.9
                  ],
                  [
                    59572.8,
                    51790.9
                  ],
                  [
                    59622.9,
                    51678.6
                  ],
                  [
                    59540.6,
                    51567.3
                  ],
                  [
                    59440.3,
                    51346.6
                  ],
                  [
                    59446.3,
                    51134.2
                  ],
                  [
                    59172.7,
                    50833.5
                  ],
                  [
                    58880.3,
                    50917.1
                  ],
                  [
                    58700.6,
                    50883
                  ],
                  [
                    58623,
                    51280.2
                  ],
                  [
                    58620.6,
                    51631.2
                  ],
                  [
                    58852.6,
                    51910.4
                  ]
                ],
                "id": 1577,
                "chat_link": "[&BCkGAAA=]"
              },
              "1588": {
                "name": "Sand Jackal Run",
                "level": 80,
                "coord": [
                  59402,
                  52720.1
                ],
                "bounds": [
                  [
                    59014.7,
                    52847.9
                  ],
                  [
                    59147.9,
                    52849.3
                  ],
                  [
                    59416,
                    53012.4
                  ],
                  [
                    59584.4,
                    52951.8
                  ],
                  [
                    59591.8,
                    52858.6
                  ],
                  [
                    59781.5,
                    52721.8
                  ],
                  [
                    59790.7,
                    52642.5
                  ],
                  [
                    59550.5,
                    52413.2
                  ],
                  [
                    59414.9,
                    52385.5
                  ],
                  [
                    59165.2,
                    52479
                  ],
                  [
                    58963.9,
                    52759.2
                  ],
                  [
                    59014.7,
                    52847.9
                  ]
                ],
                "id": 1588,
                "chat_link": "[&BDQGAAA=]"
              },
              "1594": {
                "name": "Lair of the Forgotten",
                "level": 80,
                "coord": [
                  61479.4,
                  51032.4
                ],
                "bounds": [
                  [
                    60818.4,
                    51155.1
                  ],
                  [
                    61139.6,
                    50971.4
                  ],
                  [
                    61369.2,
                    50728
                  ],
                  [
                    61607.9,
                    50653.8
                  ],
                  [
                    61718.7,
                    50756.4
                  ],
                  [
                    61764.2,
                    50724.2
                  ],
                  [
                    61780,
                    50831.2
                  ],
                  [
                    61779.5,
                    51484.1
                  ],
                  [
                    61593.1,
                    51545.8
                  ],
                  [
                    61224.1,
                    51473.7
                  ],
                  [
                    60818.4,
                    51155.1
                  ]
                ],
                "id": 1594,
                "chat_link": "[&BDoGAAA=]"
              }
            },
            "adventures": [],
            "id": 1247,
            "mastery_points": []
          },
          "1248": {
            "name": "Domain of Vabbi",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              66016,
              53702
            ],
            "map_rect": [
              [
                -58368,
                -36864
              ],
              [
                58368,
                39936
              ]
            ],
            "continent_rect": [
              [
                63616,
                52352
              ],
              [
                68480,
                55552
              ]
            ],
            "points_of_interest": {
              "2550": {
                "name": "The Menagerie",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66235,
                  53193.4
                ],
                "id": 2550,
                "chat_link": "[&BPYJAAA=]"
              },
              "2555": {
                "name": "The Promenade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64999.5,
                  53201.3
                ],
                "id": 2555,
                "chat_link": "[&BPsJAAA=]"
              },
              "2559": {
                "name": "Ruins of Mihanu Township",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66737.1,
                  52538.7
                ],
                "id": 2559,
                "chat_link": "[&BP8JAAA=]"
              },
              "2560": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  66512.5,
                  53707.9
                ],
                "id": 2560,
                "chat_link": "[&BAAKAAA=]"
              },
              "2561": {
                "name": "Spearmarshal's Lament",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  68076.9,
                  55017.1
                ],
                "id": 2561,
                "chat_link": "[&BAEKAAA=]"
              },
              "2563": {
                "name": "Spa",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65532.1,
                  52936
                ],
                "id": 2563,
                "chat_link": "[&BAMKAAA=]"
              },
              "2574": {
                "name": "Vehjin Royal Rotunda",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64000.1,
                  53492.3
                ],
                "id": 2574,
                "chat_link": "[&BA4KAAA=]"
              },
              "2575": {
                "name": "Vehtendi Academy Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  66421.2,
                  54770.7
                ],
                "id": 2575,
                "chat_link": "[&BA8KAAA=]"
              },
              "2581": {
                "name": "The Warehouse",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66628.9,
                  54894.7
                ],
                "id": 2581,
                "chat_link": "[&BBUKAAA=]"
              },
              "2590": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  67722.9,
                  52876
                ],
                "id": 2590,
                "chat_link": "[&BB4KAAA=]"
              },
              "2596": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  68258.1,
                  54227.3
                ],
                "id": 2596,
                "chat_link": "[&BCQKAAA=]"
              },
              "2602": {
                "name": "Junundu Nests",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65769.7,
                  55195.3
                ],
                "id": 2602,
                "chat_link": "[&BCoKAAA=]"
              },
              "2604": {
                "name": "Beastmarshal's Encampment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65211,
                  55293.7
                ],
                "id": 2604,
                "chat_link": "[&BCwKAAA=]"
              },
              "2612": {
                "name": "Troopmarshal's Encampment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64491.7,
                  54314.2
                ],
                "id": 2612,
                "chat_link": "[&BDQKAAA=]"
              },
              "2621": {
                "name": "Seborhin Circle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65287.1,
                  53198.5
                ],
                "id": 2621,
                "chat_link": "[&BD0KAAA=]"
              },
              "2634": {
                "name": "Necropolis Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  65111.6,
                  54720.3
                ],
                "id": 2634,
                "chat_link": "[&BEoKAAA=]"
              },
              "2658": {
                "name": "Tihark Orchard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65438.5,
                  54252.7
                ],
                "id": 2658,
                "chat_link": "[&BGIKAAA=]"
              },
              "2662": {
                "name": "Merchant's Row",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65645.1,
                  53191.6
                ],
                "id": 2662,
                "chat_link": "[&BGYKAAA=]"
              },
              "2669": {
                "name": "The Hearth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63952.7,
                  54416.8
                ],
                "id": 2669,
                "chat_link": "[&BG0KAAA=]"
              },
              "2676": {
                "name": "Market Ruins Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  67375.7,
                  53930.7
                ],
                "id": 2676,
                "chat_link": "[&BHQKAAA=]"
              },
              "2681": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  64672.9,
                  54917.6
                ],
                "id": 2681,
                "chat_link": "[&BHkKAAA=]"
              },
              "2685": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  68123.6,
                  54977.2
                ],
                "id": 2685,
                "chat_link": "[&BH0KAAA=]"
              },
              "2687": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  66143.6,
                  54897
                ],
                "id": 2687,
                "chat_link": "[&BH8KAAA=]"
              },
              "2696": {
                "name": "Market Ruins",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66162.1,
                  54005.2
                ],
                "id": 2696,
                "chat_link": "[&BIgKAAA=]"
              },
              "2710": {
                "name": "Hanging Gardens",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  68127.9,
                  54313.2
                ],
                "id": 2710,
                "chat_link": "[&BJYKAAA=]"
              },
              "2714": {
                "name": "House Ingene Dormitory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66715.5,
                  55167.1
                ],
                "id": 2714,
                "chat_link": "[&BJoKAAA=]"
              },
              "2715": {
                "name": "Great Palawa Joko Monument",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66153.5,
                  54897
                ],
                "id": 2715,
                "chat_link": "[&BJsKAAA=]"
              },
              "2720": {
                "name": "Tournament Battlegrounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66206.1,
                  54515.6
                ],
                "id": 2720,
                "chat_link": "[&BKAKAAA=]"
              },
              "2725": {
                "name": "Cragged Vale Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  63792.2,
                  52749.9
                ],
                "id": 2725,
                "chat_link": "[&BKUKAAA=]"
              },
              "2731": {
                "name": "House Ventura Dormitory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66638.6,
                  55250.9
                ],
                "id": 2731,
                "chat_link": "[&BKsKAAA=]"
              },
              "2748": {
                "name": "Excavation Site",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63864.4,
                  53729.2
                ],
                "id": 2748,
                "chat_link": "[&BLwKAAA=]"
              },
              "2749": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  64797.5,
                  53179.4
                ],
                "id": 2749,
                "chat_link": "[&BL0KAAA=]"
              },
              "2750": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  68225.6,
                  53728.9
                ],
                "id": 2750,
                "chat_link": "[&BL4KAAA=]"
              },
              "2752": {
                "name": "The Boneyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63898.4,
                  55287.7
                ],
                "id": 2752,
                "chat_link": "[&BMAKAAA=]"
              },
              "2755": {
                "name": "Vehtendi Vineyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67038.6,
                  55431.5
                ],
                "id": 2755,
                "chat_link": "[&BMMKAAA=]"
              },
              "2758": {
                "name": "Lyssan Fools Theater",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65281.3,
                  53503
                ],
                "id": 2758,
                "chat_link": "[&BMYKAAA=]"
              },
              "2763": {
                "name": "Court of the Dead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64650.3,
                  54973.4
                ],
                "id": 2763,
                "chat_link": "[&BMsKAAA=]"
              },
              "2768": {
                "name": "Seborhin Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  65531.2,
                  53474.3
                ],
                "id": 2768,
                "chat_link": "[&BNAKAAA=]"
              },
              "2776": {
                "name": "Headmaster's Office",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66508.9,
                  55072
                ],
                "id": 2776,
                "chat_link": "[&BNgKAAA=]"
              },
              "2779": {
                "name": "House Rolic Dormitory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66723.4,
                  55054.4
                ],
                "id": 2779,
                "chat_link": "[&BNsKAAA=]"
              },
              "2783": {
                "name": "Ruins of Jennur's Horde",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64796,
                  53554.4
                ],
                "id": 2783,
                "chat_link": "[&BN8KAAA=]"
              },
              "2794": {
                "name": "King Joko's Sky Garden",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66843.3,
                  54040.5
                ],
                "id": 2794,
                "chat_link": "[&BOoKAAA=]"
              },
              "2795": {
                "name": "The Crypts",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64512.4,
                  55189.4
                ],
                "id": 2795,
                "chat_link": "[&BOsKAAA=]"
              },
              "2796": {
                "name": "Lair of Zommoros",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64728.5,
                  52403.3
                ],
                "id": 2796,
                "chat_link": "[&BOwKAAA=]"
              },
              "2797": {
                "name": "Vehjin Palace Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64290.5,
                  53303.7
                ],
                "id": 2797,
                "chat_link": "[&BO0KAAA=]"
              },
              "2798": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  63951.6,
                  53533.7
                ],
                "id": 2798,
                "chat_link": "[&BO4KAAA=]"
              },
              "2802": {
                "name": "Ruins of the Mirror of Lyss",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67587.2,
                  53006
                ],
                "id": 2802,
                "chat_link": "[&BPIKAAA=]"
              },
              "2803": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  64377.6,
                  54497.3
                ],
                "id": 2803,
                "chat_link": "[&BPMKAAA=]"
              },
              "3053": {
                "type": "unlock",
                "floor": 1,
                "coord": [
                  67349.3,
                  52779.2
                ],
                "id": 3053,
                "chat_link": "[&BO0LAAA=]",
                "icon": "https://render.guildwars2.com/file/5866630DA52DCB5C423FB81ECF69FD071611E36B/1128644.png"
              }
            },
            "tasks": {
              "388": {
                "objective": "Aid the Awakened in the Vehjin Mines.",
                "level": 80,
                "coord": [
                  64053.2,
                  53863.3
                ],
                "bounds": [
                  [
                    64119.9,
                    53749.8
                  ],
                  [
                    64222.3,
                    53530.8
                  ],
                  [
                    63835.2,
                    53524.1
                  ],
                  [
                    63673.4,
                    53608
                  ],
                  [
                    63654.8,
                    53775.6
                  ],
                  [
                    63714.4,
                    53917
                  ],
                  [
                    63770.3,
                    54022.6
                  ],
                  [
                    63801,
                    54060.6
                  ],
                  [
                    63876.8,
                    54088.7
                  ],
                  [
                    64119.9,
                    53749.8
                  ]
                ],
                "id": 388,
                "chat_link": "[&BIQBAAA=]"
              },
              "389": {
                "objective": "Help the royals of Vehjin Palace.",
                "level": 80,
                "coord": [
                  63797.9,
                  53337.5
                ],
                "bounds": [
                  [
                    64043.6,
                    53095.3
                  ],
                  [
                    63953.3,
                    53132
                  ],
                  [
                    63767.7,
                    53550.9
                  ],
                  [
                    63783,
                    53574.5
                  ],
                  [
                    63991.2,
                    53628
                  ],
                  [
                    64043.6,
                    53095.3
                  ]
                ],
                "id": 389,
                "chat_link": "[&BIUBAAA=]"
              },
              "395": {
                "objective": "Be the life of the party.",
                "level": 80,
                "coord": [
                  65090.5,
                  53201.7
                ],
                "bounds": [
                  [
                    64970.1,
                    53200.4
                  ],
                  [
                    66267.1,
                    54016
                  ],
                  [
                    64970.1,
                    53200.4
                  ]
                ],
                "id": 395,
                "chat_link": "[&BIsBAAA=]"
              },
              "397": {
                "objective": "Help the living and the dead at the Necropolis.",
                "level": 80,
                "coord": [
                  64841.6,
                  54777.4
                ],
                "bounds": [
                  [
                    64618.2,
                    54693
                  ],
                  [
                    64875.3,
                    54596.3
                  ],
                  [
                    64948.7,
                    54599.7
                  ],
                  [
                    65074.4,
                    54701.1
                  ],
                  [
                    65084.3,
                    54756.5
                  ],
                  [
                    65067.8,
                    54880.8
                  ],
                  [
                    64969.1,
                    54917.4
                  ],
                  [
                    64692.7,
                    54976.8
                  ],
                  [
                    64683.7,
                    55098.4
                  ],
                  [
                    64612.6,
                    55117.8
                  ],
                  [
                    64578.8,
                    55104.3
                  ],
                  [
                    64561.9,
                    55047.9
                  ],
                  [
                    64564.1,
                    55000.4
                  ],
                  [
                    64591.5,
                    54970.2
                  ],
                  [
                    64620.1,
                    54976.7
                  ],
                  [
                    64617.4,
                    54943.8
                  ],
                  [
                    64542.6,
                    54830.5
                  ],
                  [
                    64569.3,
                    54747
                  ],
                  [
                    64618.2,
                    54693
                  ]
                ],
                "id": 397,
                "chat_link": "[&BI0BAAA=]"
              },
              "401": {
                "objective": "Assist the Lyssan Fools acting troupe.",
                "level": 80,
                "coord": [
                  65370.8,
                  53457.8
                ],
                "bounds": [
                  [
                    65472.9,
                    53580
                  ],
                  [
                    65474.3,
                    53388.1
                  ],
                  [
                    65413.2,
                    53395.3
                  ],
                  [
                    65396.4,
                    53396.8
                  ],
                  [
                    65379.7,
                    53411.3
                  ],
                  [
                    65322.5,
                    53398.1
                  ],
                  [
                    65219.4,
                    53399.8
                  ],
                  [
                    65150.5,
                    53422.9
                  ],
                  [
                    65152.9,
                    53561.4
                  ],
                  [
                    65294.5,
                    53615.7
                  ],
                  [
                    65472.9,
                    53580
                  ]
                ],
                "id": 401,
                "chat_link": "[&BJEBAAA=]"
              },
              "405": {
                "objective": "Disrupt the Forged occupying the Foundry.",
                "level": 80,
                "coord": [
                  64323.2,
                  54145.8
                ],
                "bounds": [
                  [
                    64392.6,
                    54262.5
                  ],
                  [
                    64394.8,
                    54172.8
                  ],
                  [
                    64296.6,
                    54080.6
                  ],
                  [
                    64190.3,
                    54101.3
                  ],
                  [
                    64135.2,
                    54179.5
                  ],
                  [
                    63997,
                    54225.8
                  ],
                  [
                    63871,
                    54204.1
                  ],
                  [
                    63710.1,
                    54214.6
                  ],
                  [
                    63658.3,
                    54311.1
                  ],
                  [
                    63664.4,
                    54541
                  ],
                  [
                    63931.7,
                    54798.1
                  ],
                  [
                    64290.3,
                    54503.4
                  ],
                  [
                    64368.1,
                    54370.2
                  ],
                  [
                    64385.6,
                    54324.4
                  ],
                  [
                    64392.6,
                    54262.5
                  ]
                ],
                "id": 405,
                "chat_link": "[&BJUBAAA=]"
              },
              "408": {
                "objective": "Help train the newly Awakened.",
                "level": 80,
                "coord": [
                  64450.4,
                  55266
                ],
                "bounds": [
                  [
                    64738.7,
                    55218.2
                  ],
                  [
                    64511.3,
                    55069.6
                  ],
                  [
                    64484.2,
                    55074.9
                  ],
                  [
                    64462.3,
                    54990.3
                  ],
                  [
                    64383.6,
                    54998.3
                  ],
                  [
                    64256.6,
                    55031.4
                  ],
                  [
                    64295.2,
                    55105.7
                  ],
                  [
                    64342.7,
                    55146.6
                  ],
                  [
                    64227,
                    55276
                  ],
                  [
                    64231.7,
                    55334
                  ],
                  [
                    64208.1,
                    55333
                  ],
                  [
                    64193.4,
                    55446.8
                  ],
                  [
                    64281.2,
                    55468.6
                  ],
                  [
                    64672.9,
                    55420
                  ],
                  [
                    64738.7,
                    55218.2
                  ]
                ],
                "id": 408,
                "chat_link": "[&BJgBAAA=]"
              },
              "409": {
                "objective": "Help the students of Vehtendi Academy.",
                "level": 80,
                "coord": [
                  66390.3,
                  55143.6
                ],
                "bounds": [
                  [
                    66515.4,
                    54779.4
                  ],
                  [
                    66209.1,
                    54775.2
                  ],
                  [
                    66095,
                    54885.7
                  ],
                  [
                    66077.6,
                    54997.3
                  ],
                  [
                    66109.7,
                    55158.7
                  ],
                  [
                    66314.3,
                    55322.4
                  ],
                  [
                    66500.5,
                    55441.8
                  ],
                  [
                    66698.4,
                    55421.2
                  ],
                  [
                    66887,
                    55227.8
                  ],
                  [
                    66822.7,
                    54981.6
                  ],
                  [
                    66515.4,
                    54779.4
                  ]
                ],
                "id": 409,
                "chat_link": "[&BJkBAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  66223.2,
                  54492.2
                ],
                "id": "2-26"
              },
              {
                "coord": [
                  67931,
                  53490
                ],
                "id": "2-27"
              },
              {
                "coord": [
                  64719.3,
                  55172.4
                ],
                "id": "2-28"
              }
            ],
            "sectors": {
              "1484": {
                "name": "Western Mihan Hillsides",
                "level": 80,
                "coord": [
                  64950.8,
                  52651.6
                ],
                "bounds": [
                  [
                    64523.9,
                    52579.7
                  ],
                  [
                    64569.3,
                    52518.8
                  ],
                  [
                    64649.7,
                    52494.7
                  ],
                  [
                    64753.3,
                    52537.3
                  ],
                  [
                    64842.8,
                    52519.9
                  ],
                  [
                    64913.2,
                    52496.1
                  ],
                  [
                    64925.6,
                    52424.3
                  ],
                  [
                    65141.4,
                    52397.5
                  ],
                  [
                    65449.8,
                    52375.6
                  ],
                  [
                    65457.5,
                    52481.8
                  ],
                  [
                    65402,
                    52520.9
                  ],
                  [
                    65390.1,
                    52578.3
                  ],
                  [
                    65422.6,
                    52726
                  ],
                  [
                    65433,
                    52837.1
                  ],
                  [
                    65297.7,
                    52837.6
                  ],
                  [
                    65146.8,
                    52838.6
                  ],
                  [
                    64981.1,
                    52835.1
                  ],
                  [
                    64856.7,
                    52859.1
                  ],
                  [
                    64799.5,
                    52997.4
                  ],
                  [
                    64636,
                    52978.1
                  ],
                  [
                    64471,
                    52956.4
                  ],
                  [
                    64368.9,
                    52596.9
                  ],
                  [
                    64435.3,
                    52600.7
                  ],
                  [
                    64523.9,
                    52579.7
                  ]
                ],
                "id": 1484,
                "chat_link": "[&BMwFAAA=]"
              },
              "1485": {
                "name": "Vehjin Mines",
                "level": 80,
                "coord": [
                  64043.4,
                  53884.5
                ],
                "bounds": [
                  [
                    63666.7,
                    53964.1
                  ],
                  [
                    63697.3,
                    54237.3
                  ],
                  [
                    63879.6,
                    54185.9
                  ],
                  [
                    63906.4,
                    54191.9
                  ],
                  [
                    64037.4,
                    54157
                  ],
                  [
                    64167.3,
                    54049.4
                  ],
                  [
                    64413.4,
                    54034.9
                  ],
                  [
                    64412.8,
                    53875.5
                  ],
                  [
                    64395.5,
                    53814.7
                  ],
                  [
                    64354,
                    53835.3
                  ],
                  [
                    64292,
                    53837
                  ],
                  [
                    64113.8,
                    53772
                  ],
                  [
                    64069,
                    53690.5
                  ],
                  [
                    64007.8,
                    53632.2
                  ],
                  [
                    63888.1,
                    53592.8
                  ],
                  [
                    63777.8,
                    53573.9
                  ],
                  [
                    63659.1,
                    53591.4
                  ],
                  [
                    63666.7,
                    53964.1
                  ]
                ],
                "id": 1485,
                "chat_link": "[&BM0FAAA=]"
              },
              "1490": {
                "name": "The Foundry",
                "level": 80,
                "coord": [
                  64168,
                  54396.7
                ],
                "bounds": [
                  [
                    63698.7,
                    54238
                  ],
                  [
                    63676.6,
                    54423.3
                  ],
                  [
                    63734.9,
                    54603.1
                  ],
                  [
                    63838.6,
                    54625.6
                  ],
                  [
                    63927.1,
                    54631.5
                  ],
                  [
                    64127.1,
                    54628.2
                  ],
                  [
                    64309.5,
                    54609.4
                  ],
                  [
                    64345,
                    54762.5
                  ],
                  [
                    64582.9,
                    54634.8
                  ],
                  [
                    64557.7,
                    54503.3
                  ],
                  [
                    64648.1,
                    54344.7
                  ],
                  [
                    64624.5,
                    54282.6
                  ],
                  [
                    64548.7,
                    54233.3
                  ],
                  [
                    64411.6,
                    54035.6
                  ],
                  [
                    64167.6,
                    54048.9
                  ],
                  [
                    64036.4,
                    54157.6
                  ],
                  [
                    63908.7,
                    54193.1
                  ],
                  [
                    63880.5,
                    54186
                  ],
                  [
                    63698.7,
                    54238
                  ]
                ],
                "id": 1490,
                "chat_link": "[&BNIFAAA=]"
              },
              "1500": {
                "name": "Isha Corridor",
                "level": 80,
                "coord": [
                  65686.4,
                  53869.5
                ],
                "bounds": [
                  [
                    66149.2,
                    53850.9
                  ],
                  [
                    66297.7,
                    53807
                  ],
                  [
                    66396.9,
                    53767.1
                  ],
                  [
                    66394.9,
                    53742.7
                  ],
                  [
                    66330.5,
                    53698.1
                  ],
                  [
                    66305.2,
                    53638
                  ],
                  [
                    66324.2,
                    53555.9
                  ],
                  [
                    66300.2,
                    53564
                  ],
                  [
                    66011.2,
                    53558.8
                  ],
                  [
                    65941.9,
                    53557
                  ],
                  [
                    65907.9,
                    53540.2
                  ],
                  [
                    65755.5,
                    53552.4
                  ],
                  [
                    65176.9,
                    53561.7
                  ],
                  [
                    65062.2,
                    53565.1
                  ],
                  [
                    65115.4,
                    53625.4
                  ],
                  [
                    65079.2,
                    53818.7
                  ],
                  [
                    65006.3,
                    53894.9
                  ],
                  [
                    64975.3,
                    54014.6
                  ],
                  [
                    64980.3,
                    54068.7
                  ],
                  [
                    65011.8,
                    54158.9
                  ],
                  [
                    65095,
                    54267.5
                  ],
                  [
                    65263.6,
                    54267.3
                  ],
                  [
                    65315.6,
                    54202.4
                  ],
                  [
                    65368.9,
                    54154
                  ],
                  [
                    65512.2,
                    54125.6
                  ],
                  [
                    65609.5,
                    54167.7
                  ],
                  [
                    65715.5,
                    54249
                  ],
                  [
                    65813.2,
                    54261.4
                  ],
                  [
                    65832.4,
                    54114.8
                  ],
                  [
                    65825,
                    53871.5
                  ],
                  [
                    65993.7,
                    53779.5
                  ],
                  [
                    66098,
                    53824.8
                  ],
                  [
                    66149.2,
                    53850.9
                  ]
                ],
                "id": 1500,
                "chat_link": "[&BNwFAAA=]"
              },
              "1504": {
                "name": "Purling Deep",
                "level": 80,
                "coord": [
                  64560.7,
                  52454.8
                ],
                "bounds": [
                  [
                    64693.7,
                    52354.1
                  ],
                  [
                    64493.8,
                    52311.5
                  ],
                  [
                    64441.4,
                    52305.4
                  ],
                  [
                    64405.7,
                    52330.2
                  ],
                  [
                    64364.5,
                    52334.3
                  ],
                  [
                    64299,
                    52393.5
                  ],
                  [
                    64276.9,
                    52478.6
                  ],
                  [
                    64322,
                    52547.9
                  ],
                  [
                    64370.5,
                    52598.9
                  ],
                  [
                    64435.4,
                    52600.4
                  ],
                  [
                    64524.4,
                    52579.2
                  ],
                  [
                    64570.1,
                    52517.7
                  ],
                  [
                    64650.6,
                    52494.9
                  ],
                  [
                    64756.5,
                    52538
                  ],
                  [
                    64840.5,
                    52521.6
                  ],
                  [
                    64913.4,
                    52493.2
                  ],
                  [
                    64926.5,
                    52427.4
                  ],
                  [
                    64807,
                    52360.4
                  ],
                  [
                    64693.7,
                    52354.1
                  ]
                ],
                "id": 1504,
                "chat_link": "[&BOAFAAA=]"
              },
              "1515": {
                "name": "Resplendent Trace",
                "level": 80,
                "coord": [
                  67525.9,
                  54925.9
                ],
                "bounds": [
                  [
                    67163.7,
                    55390.8
                  ],
                  [
                    67131.6,
                    55517
                  ],
                  [
                    67351.3,
                    55523.2
                  ],
                  [
                    67550.4,
                    55519.3
                  ],
                  [
                    67783.8,
                    55510.4
                  ],
                  [
                    67888.1,
                    55487.2
                  ],
                  [
                    67875.5,
                    55304.9
                  ],
                  [
                    67996.2,
                    55213.8
                  ],
                  [
                    68046.7,
                    55112.1
                  ],
                  [
                    67988.2,
                    54904.7
                  ],
                  [
                    67987.3,
                    54823.1
                  ],
                  [
                    67990.4,
                    54778
                  ],
                  [
                    68124.6,
                    54610.3
                  ],
                  [
                    67942.1,
                    54564.5
                  ],
                  [
                    67912.4,
                    54361
                  ],
                  [
                    67695.2,
                    54298.4
                  ],
                  [
                    67283.1,
                    54306.1
                  ],
                  [
                    67249.5,
                    54363.7
                  ],
                  [
                    67225,
                    54627.5
                  ],
                  [
                    66978.9,
                    54690.1
                  ],
                  [
                    66784.1,
                    54693.8
                  ],
                  [
                    66803.6,
                    54775.3
                  ],
                  [
                    66887,
                    54880.2
                  ],
                  [
                    66982.5,
                    54966.7
                  ],
                  [
                    67163.7,
                    55390.8
                  ]
                ],
                "id": 1515,
                "chat_link": "[&BOsFAAA=]"
              },
              "1523": {
                "name": "Vehtendi Arena",
                "level": 80,
                "coord": [
                  66168.3,
                  54552.3
                ],
                "bounds": [
                  [
                    66052.6,
                    54275.6
                  ],
                  [
                    65969.1,
                    54278.4
                  ],
                  [
                    65986.7,
                    54439.2
                  ],
                  [
                    65920.9,
                    54519
                  ],
                  [
                    65936.5,
                    54656.7
                  ],
                  [
                    65945.4,
                    54724.5
                  ],
                  [
                    66081,
                    54826.4
                  ],
                  [
                    66322.3,
                    54787.7
                  ],
                  [
                    66459.7,
                    54721.1
                  ],
                  [
                    66493.8,
                    54628.5
                  ],
                  [
                    66497.1,
                    54504.4
                  ],
                  [
                    66354.4,
                    54266
                  ],
                  [
                    66052.6,
                    54275.6
                  ]
                ],
                "id": 1523,
                "chat_link": "[&BPMFAAA=]"
              },
              "1529": {
                "name": "Eastern Mihan Hillsides",
                "level": 80,
                "coord": [
                  65925.4,
                  52605.3
                ],
                "bounds": [
                  [
                    65389.9,
                    52578.2
                  ],
                  [
                    65400.8,
                    52520.3
                  ],
                  [
                    65456.9,
                    52482.8
                  ],
                  [
                    65453.4,
                    52375.7
                  ],
                  [
                    65574.3,
                    52351.2
                  ],
                  [
                    65871.9,
                    52373.7
                  ],
                  [
                    66124.1,
                    52376.3
                  ],
                  [
                    66398.5,
                    52394.1
                  ],
                  [
                    66399.1,
                    52540.4
                  ],
                  [
                    66427.9,
                    52657.1
                  ],
                  [
                    66496.1,
                    52769.9
                  ],
                  [
                    66493.2,
                    52797.9
                  ],
                  [
                    66353,
                    52833.1
                  ],
                  [
                    66209.3,
                    52833.2
                  ],
                  [
                    65827.3,
                    52842.8
                  ],
                  [
                    65432.8,
                    52836.5
                  ],
                  [
                    65422.8,
                    52726.3
                  ],
                  [
                    65389.9,
                    52578.2
                  ]
                ],
                "id": 1529,
                "chat_link": "[&BPkFAAA=]"
              },
              "1536": {
                "name": "Yahnur Plateau",
                "level": 80,
                "coord": [
                  68148.5,
                  55011.4
                ],
                "bounds": [
                  [
                    67888.6,
                    55487.2
                  ],
                  [
                    68419.6,
                    55508.2
                  ],
                  [
                    68448.9,
                    55393.5
                  ],
                  [
                    68432.7,
                    54861.7
                  ],
                  [
                    68409.9,
                    54597.2
                  ],
                  [
                    68319.9,
                    54555.9
                  ],
                  [
                    68124.4,
                    54610.1
                  ],
                  [
                    67989.7,
                    54777.4
                  ],
                  [
                    67987.2,
                    54821.8
                  ],
                  [
                    67988.6,
                    54904.9
                  ],
                  [
                    68048.3,
                    55111.9
                  ],
                  [
                    67995.9,
                    55213.5
                  ],
                  [
                    67876.6,
                    55305
                  ],
                  [
                    67888.6,
                    55487.2
                  ]
                ],
                "id": 1536,
                "chat_link": "[&BAAGAAA=]"
              },
              "1545": {
                "name": "Garden of Seborhin",
                "level": 80,
                "coord": [
                  65690.6,
                  53192.1
                ],
                "bounds": [
                  [
                    64799.9,
                    53005.3
                  ],
                  [
                    64856.8,
                    52859
                  ],
                  [
                    64981.1,
                    52834.3
                  ],
                  [
                    65146.8,
                    52836.6
                  ],
                  [
                    65298.9,
                    52836.4
                  ],
                  [
                    65432.3,
                    52836.8
                  ],
                  [
                    65827.6,
                    52841.4
                  ],
                  [
                    66209.3,
                    52832.5
                  ],
                  [
                    66352.5,
                    52833.8
                  ],
                  [
                    66494,
                    52798.5
                  ],
                  [
                    66562.7,
                    52918.8
                  ],
                  [
                    66506.3,
                    53036.9
                  ],
                  [
                    66452.3,
                    53064.9
                  ],
                  [
                    66434.1,
                    53147.2
                  ],
                  [
                    66434.4,
                    53221
                  ],
                  [
                    66443.9,
                    53281.1
                  ],
                  [
                    66518.9,
                    53389.5
                  ],
                  [
                    66511.9,
                    53507.1
                  ],
                  [
                    66475.1,
                    53563.7
                  ],
                  [
                    66314.4,
                    53572.8
                  ],
                  [
                    66069.8,
                    53570.4
                  ],
                  [
                    65767.5,
                    53571.3
                  ],
                  [
                    65278.5,
                    53564.4
                  ],
                  [
                    65179,
                    53564.2
                  ],
                  [
                    65062.3,
                    53564.6
                  ],
                  [
                    64948.8,
                    53460.2
                  ],
                  [
                    64918.8,
                    53418.2
                  ],
                  [
                    64835.4,
                    53387.2
                  ],
                  [
                    64757.2,
                    53283.2
                  ],
                  [
                    64764.8,
                    53205.8
                  ],
                  [
                    64773.7,
                    53148.9
                  ],
                  [
                    64799.9,
                    53005.3
                  ]
                ],
                "id": 1545,
                "chat_link": "[&BAkGAAA=]"
              },
              "1552": {
                "name": "Dzasha Uplands",
                "level": 80,
                "coord": [
                  67895.3,
                  52896
                ],
                "bounds": [
                  [
                    67233.4,
                    52481.6
                  ],
                  [
                    67288.3,
                    52455.9
                  ],
                  [
                    67398.8,
                    52391.2
                  ],
                  [
                    67620.9,
                    52405.8
                  ],
                  [
                    67938,
                    52443.6
                  ],
                  [
                    68225.5,
                    52587.9
                  ],
                  [
                    68268.1,
                    52854.3
                  ],
                  [
                    68342.5,
                    52982
                  ],
                  [
                    68404.4,
                    53028.7
                  ],
                  [
                    68422.8,
                    53156
                  ],
                  [
                    68428.4,
                    53333.1
                  ],
                  [
                    68385.1,
                    53458
                  ],
                  [
                    68384.3,
                    53459.3
                  ],
                  [
                    67842.5,
                    53383.8
                  ],
                  [
                    67896.8,
                    53185.3
                  ],
                  [
                    67878.4,
                    52952.6
                  ],
                  [
                    67761.5,
                    52882.7
                  ],
                  [
                    67585.4,
                    52849.9
                  ],
                  [
                    67352.7,
                    52859.5
                  ],
                  [
                    67247.9,
                    52769.2
                  ],
                  [
                    67233.4,
                    52481.6
                  ]
                ],
                "id": 1552,
                "chat_link": "[&BBAGAAA=]"
              },
              "1553": {
                "name": "Grand Court of Sebelkeh",
                "level": 80,
                "coord": [
                  67526.9,
                  53116.7
                ],
                "bounds": [
                  [
                    67250.7,
                    52771.1
                  ],
                  [
                    67359.5,
                    52840.4
                  ],
                  [
                    67590.6,
                    52810.7
                  ],
                  [
                    67755.9,
                    52839.1
                  ],
                  [
                    67877.5,
                    52949.8
                  ],
                  [
                    67894.5,
                    53180.8
                  ],
                  [
                    67847,
                    53381.7
                  ],
                  [
                    67566.8,
                    53551.1
                  ],
                  [
                    67373.8,
                    53447.5
                  ],
                  [
                    67209,
                    53490.3
                  ],
                  [
                    67071,
                    53021.1
                  ],
                  [
                    67250.7,
                    52771.1
                  ]
                ],
                "id": 1553,
                "chat_link": "[&BBEGAAA=]"
              },
              "1555": {
                "name": "Kaluun Ravine",
                "level": 80,
                "coord": [
                  65700.8,
                  55118.1
                ],
                "bounds": [
                  [
                    66086,
                    55505
                  ],
                  [
                    66083.5,
                    55410.1
                  ],
                  [
                    66128.4,
                    55283.7
                  ],
                  [
                    66111.2,
                    55052.2
                  ],
                  [
                    66082.8,
                    54826.2
                  ],
                  [
                    65946.5,
                    54727.4
                  ],
                  [
                    65501.9,
                    54888.9
                  ],
                  [
                    65365.4,
                    55017.7
                  ],
                  [
                    65237.4,
                    54949.3
                  ],
                  [
                    65072.9,
                    55125.1
                  ],
                  [
                    65093,
                    55513.4
                  ],
                  [
                    66086,
                    55505
                  ]
                ],
                "id": 1555,
                "chat_link": "[&BBMGAAA=]"
              },
              "1556": {
                "name": "Forum Highlands",
                "level": 80,
                "coord": [
                  65526,
                  54462.2
                ],
                "bounds": [
                  [
                    65843.6,
                    54285.6
                  ],
                  [
                    65971.1,
                    54277.7
                  ],
                  [
                    65985.7,
                    54440.2
                  ],
                  [
                    65921.4,
                    54519
                  ],
                  [
                    65945.4,
                    54725.9
                  ],
                  [
                    65501.8,
                    54889.7
                  ],
                  [
                    65365.2,
                    55016.6
                  ],
                  [
                    65238.4,
                    54950.6
                  ],
                  [
                    65224.1,
                    54815.4
                  ],
                  [
                    65221.1,
                    54633.2
                  ],
                  [
                    65084.1,
                    54535.8
                  ],
                  [
                    65097.2,
                    54270.2
                  ],
                  [
                    65264.4,
                    54266.8
                  ],
                  [
                    65314.5,
                    54201.3
                  ],
                  [
                    65369.8,
                    54154.5
                  ],
                  [
                    65512.2,
                    54124.2
                  ],
                  [
                    65607,
                    54167.5
                  ],
                  [
                    65712.6,
                    54248.8
                  ],
                  [
                    65814,
                    54259
                  ],
                  [
                    65843.6,
                    54285.6
                  ]
                ],
                "id": 1556,
                "chat_link": "[&BBQGAAA=]"
              },
              "1566": {
                "name": "Jennur's Run",
                "level": 80,
                "coord": [
                  64765,
                  53756.9
                ],
                "bounds": [
                  [
                    64635,
                    52976.9
                  ],
                  [
                    64470.4,
                    52956.5
                  ],
                  [
                    64420.4,
                    53172
                  ],
                  [
                    64463.5,
                    53389.9
                  ],
                  [
                    64507.9,
                    53493.8
                  ],
                  [
                    64603.1,
                    53667.3
                  ],
                  [
                    64395.6,
                    53815.8
                  ],
                  [
                    64413,
                    53874.1
                  ],
                  [
                    64411.6,
                    54035.6
                  ],
                  [
                    64549.4,
                    54233.9
                  ],
                  [
                    64625.6,
                    54283.4
                  ],
                  [
                    64651.7,
                    54347.2
                  ],
                  [
                    64836.2,
                    54450.4
                  ],
                  [
                    64975.4,
                    54426.9
                  ],
                  [
                    65090.6,
                    54419.8
                  ],
                  [
                    65096.4,
                    54270.8
                  ],
                  [
                    65011.5,
                    54159.9
                  ],
                  [
                    64975.1,
                    54014.7
                  ],
                  [
                    65006.6,
                    53894.8
                  ],
                  [
                    65080.3,
                    53818
                  ],
                  [
                    65115.6,
                    53625.7
                  ],
                  [
                    65061.4,
                    53564.8
                  ],
                  [
                    64948.6,
                    53461
                  ],
                  [
                    64918.3,
                    53420
                  ],
                  [
                    64834.8,
                    53383.3
                  ],
                  [
                    64756.4,
                    53284.1
                  ],
                  [
                    64799.5,
                    52994.9
                  ],
                  [
                    64635,
                    52976.9
                  ]
                ],
                "id": 1566,
                "chat_link": "[&BB4GAAA=]"
              },
              "1569": {
                "name": "Vehjin Palace",
                "level": 80,
                "coord": [
                  64164.8,
                  53448.2
                ],
                "bounds": [
                  [
                    63677.4,
                    53027
                  ],
                  [
                    63658.8,
                    53591.4
                  ],
                  [
                    63778,
                    53574.2
                  ],
                  [
                    63888.2,
                    53592.8
                  ],
                  [
                    64007.6,
                    53632.3
                  ],
                  [
                    64069.1,
                    53690.5
                  ],
                  [
                    64113.7,
                    53771.8
                  ],
                  [
                    64292.2,
                    53836.5
                  ],
                  [
                    64353.9,
                    53835.1
                  ],
                  [
                    64395.7,
                    53814.9
                  ],
                  [
                    64602.9,
                    53667.4
                  ],
                  [
                    64506.8,
                    53491
                  ],
                  [
                    64462.9,
                    53389
                  ],
                  [
                    64420.2,
                    53168.9
                  ],
                  [
                    64470.5,
                    52955.7
                  ],
                  [
                    64252.1,
                    52968.8
                  ],
                  [
                    64072.8,
                    53000.2
                  ],
                  [
                    63944.5,
                    53059.3
                  ],
                  [
                    63677.4,
                    53027
                  ]
                ],
                "id": 1569,
                "chat_link": "[&BCEGAAA=]"
              },
              "1571": {
                "name": "Kodash Bazaar",
                "level": 80,
                "coord": [
                  66635.8,
                  53948
                ],
                "bounds": [
                  [
                    65996.8,
                    53781.3
                  ],
                  [
                    65949.6,
                    53806.8
                  ],
                  [
                    65826.6,
                    53875.5
                  ],
                  [
                    65833.1,
                    54113.9
                  ],
                  [
                    65814.3,
                    54257
                  ],
                  [
                    65843.3,
                    54285.3
                  ],
                  [
                    66054.3,
                    54274.8
                  ],
                  [
                    66355.4,
                    54265.4
                  ],
                  [
                    66498.2,
                    54504.8
                  ],
                  [
                    66494,
                    54629.1
                  ],
                  [
                    66712.4,
                    54696.6
                  ],
                  [
                    66978.2,
                    54688.8
                  ],
                  [
                    67226.6,
                    54626
                  ],
                  [
                    67249.8,
                    54364
                  ],
                  [
                    67283.3,
                    54305.5
                  ],
                  [
                    67693.5,
                    54298.3
                  ],
                  [
                    67697.5,
                    54033.4
                  ],
                  [
                    67537.1,
                    54003.9
                  ],
                  [
                    67417.7,
                    53899
                  ],
                  [
                    67324.8,
                    53842.9
                  ],
                  [
                    67210.9,
                    53823.1
                  ],
                  [
                    67054,
                    53795
                  ],
                  [
                    67014.1,
                    53615.1
                  ],
                  [
                    66895.9,
                    53578.3
                  ],
                  [
                    66905.8,
                    53483
                  ],
                  [
                    66778,
                    53413.8
                  ],
                  [
                    66687.5,
                    53395.7
                  ],
                  [
                    66518.6,
                    53388
                  ],
                  [
                    66507.8,
                    53500.1
                  ],
                  [
                    66473.1,
                    53565.3
                  ],
                  [
                    66334.8,
                    53561.9
                  ],
                  [
                    66309.8,
                    53647.8
                  ],
                  [
                    66334.3,
                    53697.6
                  ],
                  [
                    66401.2,
                    53741.3
                  ],
                  [
                    66396.2,
                    53774
                  ],
                  [
                    66302,
                    53811
                  ],
                  [
                    66152.8,
                    53852.6
                  ],
                  [
                    66097,
                    53828.4
                  ],
                  [
                    65996.8,
                    53781.3
                  ]
                ],
                "id": 1571,
                "chat_link": "[&BCMGAAA=]"
              },
              "1572": {
                "name": "Dehwan Expanse",
                "level": 80,
                "coord": [
                  66752,
                  52998
                ],
                "bounds": [
                  [
                    66894.7,
                    53579.3
                  ],
                  [
                    66905.6,
                    53483.1
                  ],
                  [
                    66777.9,
                    53413.8
                  ],
                  [
                    66688.1,
                    53396.4
                  ],
                  [
                    66518.6,
                    53389.1
                  ],
                  [
                    66435.3,
                    53221.9
                  ],
                  [
                    66435.6,
                    53142
                  ],
                  [
                    66458,
                    53061.3
                  ],
                  [
                    66497.5,
                    53042.4
                  ],
                  [
                    66568.4,
                    52915.8
                  ],
                  [
                    66492.8,
                    52797.5
                  ],
                  [
                    66496,
                    52770.6
                  ],
                  [
                    66429.1,
                    52658.8
                  ],
                  [
                    66400.5,
                    52541.2
                  ],
                  [
                    66398,
                    52395.1
                  ],
                  [
                    66696.9,
                    52383.1
                  ],
                  [
                    66916.8,
                    52427.2
                  ],
                  [
                    67105.1,
                    52435.1
                  ],
                  [
                    67233.4,
                    52481.6
                  ],
                  [
                    67247.8,
                    52773
                  ],
                  [
                    67069.6,
                    53023.9
                  ],
                  [
                    67208.3,
                    53491.7
                  ],
                  [
                    67159.5,
                    53515.3
                  ],
                  [
                    67015,
                    53613
                  ],
                  [
                    66894.7,
                    53579.3
                  ]
                ],
                "id": 1572,
                "chat_link": "[&BCQGAAA=]"
              },
              "1576": {
                "name": "Cragged Vale",
                "level": 80,
                "coord": [
                  64024.7,
                  52819.3
                ],
                "bounds": [
                  [
                    63669.7,
                    52660.9
                  ],
                  [
                    63676.7,
                    53026.7
                  ],
                  [
                    63943.9,
                    53059.1
                  ],
                  [
                    64073.1,
                    53000.5
                  ],
                  [
                    64252.6,
                    52969.1
                  ],
                  [
                    64470.3,
                    52954.8
                  ],
                  [
                    64368.7,
                    52593.7
                  ],
                  [
                    63942.8,
                    52546.1
                  ],
                  [
                    63824.7,
                    52562.5
                  ],
                  [
                    63669.7,
                    52660.9
                  ]
                ],
                "id": 1576,
                "chat_link": "[&BCgGAAA=]"
              },
              "1583": {
                "name": "The Necropolis",
                "level": 80,
                "coord": [
                  64737.6,
                  54825.9
                ],
                "bounds": [
                  [
                    64307.7,
                    55138.9
                  ],
                  [
                    64234.5,
                    55270.3
                  ],
                  [
                    64219,
                    55518.8
                  ],
                  [
                    65091.9,
                    55514
                  ],
                  [
                    65072.9,
                    55125.3
                  ],
                  [
                    65238,
                    54948.9
                  ],
                  [
                    65223,
                    54814.1
                  ],
                  [
                    65221.1,
                    54631.2
                  ],
                  [
                    65084.6,
                    54535.8
                  ],
                  [
                    65091.2,
                    54418.9
                  ],
                  [
                    64973.5,
                    54425.4
                  ],
                  [
                    64836.2,
                    54450
                  ],
                  [
                    64650.2,
                    54345.5
                  ],
                  [
                    64557,
                    54503.2
                  ],
                  [
                    64582.2,
                    54634.7
                  ],
                  [
                    64344.8,
                    54762.4
                  ],
                  [
                    64306.2,
                    54838.7
                  ],
                  [
                    64241.8,
                    54990.4
                  ],
                  [
                    64307.7,
                    55138.9
                  ]
                ],
                "id": 1583,
                "chat_link": "[&BC8GAAA=]"
              },
              "1586": {
                "name": "Vehtendi Academy",
                "level": 80,
                "coord": [
                  66549,
                  55008.7
                ],
                "bounds": [
                  [
                    67130.6,
                    55516.6
                  ],
                  [
                    67163.3,
                    55389.7
                  ],
                  [
                    66982.9,
                    54967.6
                  ],
                  [
                    66886.5,
                    54879.7
                  ],
                  [
                    66804.3,
                    54771.6
                  ],
                  [
                    66783.7,
                    54695
                  ],
                  [
                    66712.8,
                    54696.7
                  ],
                  [
                    66494.9,
                    54630.7
                  ],
                  [
                    66457.5,
                    54721.6
                  ],
                  [
                    66322.1,
                    54787.4
                  ],
                  [
                    66081.4,
                    54826.7
                  ],
                  [
                    66114.1,
                    55052
                  ],
                  [
                    66131.9,
                    55281.8
                  ],
                  [
                    66083.3,
                    55408.6
                  ],
                  [
                    66086.3,
                    55505.1
                  ],
                  [
                    67130.6,
                    55516.6
                  ]
                ],
                "id": 1586,
                "chat_link": "[&BDIGAAA=]"
              },
              "1592": {
                "name": "Glowering Overlook",
                "level": 80,
                "coord": [
                  64011.4,
                  54986.9
                ],
                "bounds": [
                  [
                    64219.2,
                    55519.5
                  ],
                  [
                    63959,
                    55508.2
                  ],
                  [
                    63831.3,
                    55411.7
                  ],
                  [
                    63727,
                    55246
                  ],
                  [
                    63682,
                    55106.7
                  ],
                  [
                    63689.3,
                    54749.4
                  ],
                  [
                    63732,
                    54605
                  ],
                  [
                    63838.1,
                    54625.8
                  ],
                  [
                    63926.3,
                    54632.2
                  ],
                  [
                    64127.7,
                    54627.9
                  ],
                  [
                    64309.9,
                    54608.6
                  ],
                  [
                    64343.4,
                    54762.9
                  ],
                  [
                    64242.1,
                    54990.7
                  ],
                  [
                    64307.2,
                    55140.2
                  ],
                  [
                    64235.8,
                    55269
                  ],
                  [
                    64219.2,
                    55519.5
                  ]
                ],
                "id": 1592,
                "chat_link": "[&BDgGAAA=]"
              },
              "1595": {
                "name": "Zagonur Cliffs",
                "level": 80,
                "coord": [
                  67892.7,
                  53962.3
                ],
                "bounds": [
                  [
                    68450.2,
                    54220.1
                  ],
                  [
                    68451.7,
                    54368.8
                  ],
                  [
                    68443.8,
                    54505.4
                  ],
                  [
                    68412.2,
                    54602.9
                  ],
                  [
                    68319.2,
                    54555.4
                  ],
                  [
                    68125.5,
                    54610.6
                  ],
                  [
                    67944.8,
                    54560
                  ],
                  [
                    67912.6,
                    54360.6
                  ],
                  [
                    67695.4,
                    54297.8
                  ],
                  [
                    67696.7,
                    54035.4
                  ],
                  [
                    67536,
                    54002.8
                  ],
                  [
                    67418.2,
                    53899.7
                  ],
                  [
                    67324.9,
                    53842.8
                  ],
                  [
                    67210.5,
                    53823.4
                  ],
                  [
                    67055.5,
                    53796.1
                  ],
                  [
                    67013,
                    53612.8
                  ],
                  [
                    67159.5,
                    53515.6
                  ],
                  [
                    67209.9,
                    53492.3
                  ],
                  [
                    67374.1,
                    53448.4
                  ],
                  [
                    67566.9,
                    53552.6
                  ],
                  [
                    67845.2,
                    53384.8
                  ],
                  [
                    68385.1,
                    53458
                  ],
                  [
                    68400,
                    53537.4
                  ],
                  [
                    68400.8,
                    53671.4
                  ],
                  [
                    68391.9,
                    53809
                  ],
                  [
                    68384.5,
                    53920.2
                  ],
                  [
                    68424.6,
                    53968.4
                  ],
                  [
                    68442.3,
                    54092.7
                  ],
                  [
                    68450.2,
                    54220.1
                  ]
                ],
                "id": 1595,
                "chat_link": "[&BDsGAAA=]"
              }
            },
            "adventures": [],
            "id": 1248,
            "mastery_points": [
              {
                "coord": [
                  66736,
                  52511.7
                ],
                "id": 396,
                "region": "Desert"
              },
              {
                "coord": [
                  67076.3,
                  55457.4
                ],
                "id": 400,
                "region": "Desert"
              },
              {
                "coord": [
                  63771.6,
                  54902.6
                ],
                "id": 415,
                "region": "Desert"
              },
              {
                "coord": [
                  66273.8,
                  52447.9
                ],
                "id": 354,
                "region": "Desert"
              },
              {
                "coord": [
                  65596.7,
                  55471.3
                ],
                "id": 372,
                "region": "Desert"
              },
              {
                "coord": [
                  67564,
                  52747.6
                ],
                "id": 408,
                "region": "Desert"
              },
              {
                "coord": [
                  67226.5,
                  53441.9
                ],
                "id": 357,
                "region": "Desert"
              },
              {
                "coord": [
                  65997.3,
                  54005.6
                ],
                "id": 397,
                "region": "Desert"
              },
              {
                "coord": [
                  67649.8,
                  53728.7
                ],
                "id": 395,
                "region": "Desert"
              },
              {
                "coord": [
                  68154.6,
                  53174.4
                ],
                "id": 383,
                "region": "Desert"
              },
              {
                "coord": [
                  68099.7,
                  55074.4
                ],
                "id": 337,
                "region": "Desert"
              }
            ]
          },
          "1250": {
            "name": "Windswept Haven",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              64672,
              51646
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                64016,
                51072
              ],
              [
                65296,
                52352
              ]
            ],
            "points_of_interest": {
              "2690": {
                "name": "Windswept Arena Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64610.8,
                  51738.4
                ],
                "id": 2690,
                "chat_link": "[&BIIKAAA=]"
              },
              "2721": {
                "name": "Cavern Overlook Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64453.1,
                  52290.7
                ],
                "id": 2721,
                "chat_link": "[&BKEKAAA=]"
              },
              "2775": {
                "name": "Vantage Dome Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  65172.6,
                  51485.6
                ],
                "id": 2775,
                "chat_link": "[&BNcKAAA=]"
              },
              "2781": {
                "name": "Haven Terrace Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64843.8,
                  51650.5
                ],
                "id": 2781,
                "chat_link": "[&BN0KAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1518": {
                "level": 0,
                "coord": [
                  64748.2,
                  51688.9
                ],
                "bounds": [
                  [
                    65265.6,
                    51274
                  ],
                  [
                    65282.6,
                    51903.2
                  ],
                  [
                    65229.7,
                    52092.6
                  ],
                  [
                    65092.8,
                    52388.4
                  ],
                  [
                    64340.1,
                    52410.9
                  ],
                  [
                    64180.4,
                    51778.5
                  ],
                  [
                    64217.3,
                    51162.9
                  ],
                  [
                    64436.8,
                    51101.1
                  ],
                  [
                    64688.1,
                    51089
                  ],
                  [
                    65265.6,
                    51274
                  ]
                ],
                "id": 1518,
                "chat_link": "[&BO4FAAA=]"
              }
            },
            "id": 1250,
            "mastery_points": [],
            "adventures": []
          },
          "1252": {
            "name": "Crystalline Memories",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              60176,
              41440
            ],
            "map_rect": [
              [
                -61440,
                -30720
              ],
              [
                61440,
                30720
              ]
            ],
            "continent_rect": [
              [
                57256,
                39744
              ],
              [
                62376,
                42304
              ]
            ],
            "points_of_interest": {
              "2680": {
                "name": "Glint's Lair",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61842.8,
                  41743
                ],
                "id": 2680,
                "chat_link": "[&BHgKAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1527": {
                "name": "Diviner's Reach",
                "level": 80,
                "coord": [
                  60740.6,
                  42045.8
                ],
                "bounds": [
                  [
                    61100.9,
                    42308.1
                  ],
                  [
                    60713.2,
                    42392.1
                  ],
                  [
                    60121.8,
                    42211.6
                  ],
                  [
                    60486,
                    41901.8
                  ],
                  [
                    60760.7,
                    41778
                  ],
                  [
                    61007,
                    41801.7
                  ],
                  [
                    60994.8,
                    41927.3
                  ],
                  [
                    61100.9,
                    42308.1
                  ]
                ],
                "id": 1527,
                "chat_link": "[&BPcFAAA=]"
              },
              "1554": {
                "name": "The Sunderlands",
                "level": 80,
                "coord": [
                  61434.5,
                  41067.6
                ],
                "bounds": [
                  [
                    61548.2,
                    41329.4
                  ],
                  [
                    61322.2,
                    41319.1
                  ],
                  [
                    61134.2,
                    41294.5
                  ],
                  [
                    60975.6,
                    41367.2
                  ],
                  [
                    60831.7,
                    41198.3
                  ],
                  [
                    60903,
                    40953.5
                  ],
                  [
                    60880.7,
                    40786.3
                  ],
                  [
                    60911.6,
                    40684
                  ],
                  [
                    60993.8,
                    40604.9
                  ],
                  [
                    61141.8,
                    40635.1
                  ],
                  [
                    61390.1,
                    40670
                  ],
                  [
                    61467,
                    40769
                  ],
                  [
                    61679.2,
                    40901.4
                  ],
                  [
                    61981.8,
                    40960.5
                  ],
                  [
                    62207.4,
                    40978.4
                  ],
                  [
                    62351.9,
                    41870.8
                  ],
                  [
                    62146.3,
                    41549
                  ],
                  [
                    61954.7,
                    41344.9
                  ],
                  [
                    61548.2,
                    41329.4
                  ]
                ],
                "id": 1554,
                "chat_link": "[&BBIGAAA=]"
              },
              "1580": {
                "name": "Prophet's Fall",
                "level": 80,
                "coord": [
                  61489.8,
                  41729.3
                ],
                "bounds": [
                  [
                    61100.5,
                    42308
                  ],
                  [
                    61539.8,
                    42564.8
                  ],
                  [
                    62309.2,
                    42273.2
                  ],
                  [
                    62351.6,
                    41871.6
                  ],
                  [
                    62146.4,
                    41547
                  ],
                  [
                    61955.8,
                    41346.4
                  ],
                  [
                    61549.1,
                    41329.1
                  ],
                  [
                    61322.2,
                    41318.8
                  ],
                  [
                    61134.1,
                    41295
                  ],
                  [
                    60973.3,
                    41367
                  ],
                  [
                    60985.9,
                    41532.5
                  ],
                  [
                    61005.7,
                    41801.3
                  ],
                  [
                    60994.4,
                    41925.8
                  ],
                  [
                    61100.5,
                    42308
                  ]
                ],
                "id": 1580,
                "chat_link": "[&BCwGAAA=]"
              }
            },
            "adventures": [],
            "id": 1252,
            "mastery_points": []
          },
          "1253": {
            "name": "Beast of War",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              38768,
              45740
            ],
            "map_rect": [
              [
                -58368,
                -36864
              ],
              [
                58368,
                39936
              ]
            ],
            "continent_rect": [
              [
                63616,
                52352
              ],
              [
                68480,
                55552
              ]
            ],
            "points_of_interest": {
              "2550": {
                "name": "The Menagerie",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66235,
                  53193.4
                ],
                "id": 2550,
                "chat_link": "[&BPYJAAA=]"
              },
              "2555": {
                "name": "The Promenade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64999.5,
                  53201.3
                ],
                "id": 2555,
                "chat_link": "[&BPsJAAA=]"
              },
              "2559": {
                "name": "Ruins of Mihanu Township",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66737.1,
                  52538.7
                ],
                "id": 2559,
                "chat_link": "[&BP8JAAA=]"
              },
              "2561": {
                "name": "Spearmarshal's Lament",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  68076.9,
                  55017.1
                ],
                "id": 2561,
                "chat_link": "[&BAEKAAA=]"
              },
              "2563": {
                "name": "Spa",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65532.1,
                  52936
                ],
                "id": 2563,
                "chat_link": "[&BAMKAAA=]"
              },
              "2574": {
                "name": "Vehjin Royal Rotunda",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64000.1,
                  53492.3
                ],
                "id": 2574,
                "chat_link": "[&BA4KAAA=]"
              },
              "2581": {
                "name": "The Warehouse",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66628.9,
                  54894.7
                ],
                "id": 2581,
                "chat_link": "[&BBUKAAA=]"
              },
              "2602": {
                "name": "Junundu Nests",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65769.7,
                  55195.3
                ],
                "id": 2602,
                "chat_link": "[&BCoKAAA=]"
              },
              "2604": {
                "name": "Beastmarshal's Encampment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65211,
                  55293.7
                ],
                "id": 2604,
                "chat_link": "[&BCwKAAA=]"
              },
              "2612": {
                "name": "Troopmarshal's Encampment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64491.7,
                  54314.2
                ],
                "id": 2612,
                "chat_link": "[&BDQKAAA=]"
              },
              "2621": {
                "name": "Seborhin Circle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65287.1,
                  53198.5
                ],
                "id": 2621,
                "chat_link": "[&BD0KAAA=]"
              },
              "2658": {
                "name": "Tihark Orchard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65438.5,
                  54252.7
                ],
                "id": 2658,
                "chat_link": "[&BGIKAAA=]"
              },
              "2662": {
                "name": "Merchant's Row",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65645.1,
                  53191.6
                ],
                "id": 2662,
                "chat_link": "[&BGYKAAA=]"
              },
              "2669": {
                "name": "The Hearth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63952.7,
                  54416.8
                ],
                "id": 2669,
                "chat_link": "[&BG0KAAA=]"
              },
              "2696": {
                "name": "Market Ruins",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66162.1,
                  54005.2
                ],
                "id": 2696,
                "chat_link": "[&BIgKAAA=]"
              },
              "2710": {
                "name": "Hanging Gardens",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  68127.9,
                  54313.2
                ],
                "id": 2710,
                "chat_link": "[&BJYKAAA=]"
              },
              "2714": {
                "name": "House Ingene Dormitory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66715.5,
                  55167.1
                ],
                "id": 2714,
                "chat_link": "[&BJoKAAA=]"
              },
              "2715": {
                "name": "Great Palawa Joko Monument",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66153.5,
                  54897
                ],
                "id": 2715,
                "chat_link": "[&BJsKAAA=]"
              },
              "2720": {
                "name": "Tournament Battlegrounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66206.1,
                  54515.6
                ],
                "id": 2720,
                "chat_link": "[&BKAKAAA=]"
              },
              "2731": {
                "name": "House Ventura Dormitory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66638.6,
                  55250.9
                ],
                "id": 2731,
                "chat_link": "[&BKsKAAA=]"
              },
              "2748": {
                "name": "Excavation Site",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63864.4,
                  53729.2
                ],
                "id": 2748,
                "chat_link": "[&BLwKAAA=]"
              },
              "2752": {
                "name": "The Boneyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63898.4,
                  55287.7
                ],
                "id": 2752,
                "chat_link": "[&BMAKAAA=]"
              },
              "2755": {
                "name": "Vehtendi Vineyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67038.6,
                  55431.5
                ],
                "id": 2755,
                "chat_link": "[&BMMKAAA=]"
              },
              "2758": {
                "name": "Lyssan Fools Theater",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65281.3,
                  53503
                ],
                "id": 2758,
                "chat_link": "[&BMYKAAA=]"
              },
              "2763": {
                "name": "Court of the Dead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64650.3,
                  54973.4
                ],
                "id": 2763,
                "chat_link": "[&BMsKAAA=]"
              },
              "2776": {
                "name": "Headmaster's Office",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66508.9,
                  55072
                ],
                "id": 2776,
                "chat_link": "[&BNgKAAA=]"
              },
              "2779": {
                "name": "House Rolic Dormitory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66723.4,
                  55054.4
                ],
                "id": 2779,
                "chat_link": "[&BNsKAAA=]"
              },
              "2783": {
                "name": "Ruins of Jennur's Horde",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64796,
                  53554.4
                ],
                "id": 2783,
                "chat_link": "[&BN8KAAA=]"
              },
              "2794": {
                "name": "King Joko's Sky Garden",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66843.3,
                  54040.5
                ],
                "id": 2794,
                "chat_link": "[&BOoKAAA=]"
              },
              "2795": {
                "name": "The Crypts",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64512.4,
                  55189.4
                ],
                "id": 2795,
                "chat_link": "[&BOsKAAA=]"
              },
              "2796": {
                "name": "Lair of Zommoros",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64728.5,
                  52403.3
                ],
                "id": 2796,
                "chat_link": "[&BOwKAAA=]"
              },
              "2802": {
                "name": "Ruins of the Mirror of Lyss",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67587.2,
                  53006
                ],
                "id": 2802,
                "chat_link": "[&BPIKAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1484": {
                "name": "Western Mihan Hillsides",
                "level": 80,
                "coord": [
                  64950.8,
                  52651.6
                ],
                "bounds": [
                  [
                    64523.9,
                    52579.7
                  ],
                  [
                    64569.3,
                    52518.8
                  ],
                  [
                    64649.7,
                    52494.7
                  ],
                  [
                    64753.3,
                    52537.3
                  ],
                  [
                    64842.8,
                    52519.9
                  ],
                  [
                    64913.2,
                    52496.1
                  ],
                  [
                    64925.6,
                    52424.3
                  ],
                  [
                    65141.4,
                    52397.5
                  ],
                  [
                    65449.8,
                    52375.6
                  ],
                  [
                    65457.5,
                    52481.8
                  ],
                  [
                    65402,
                    52520.9
                  ],
                  [
                    65390.1,
                    52578.3
                  ],
                  [
                    65422.6,
                    52726
                  ],
                  [
                    65433,
                    52837.1
                  ],
                  [
                    65297.7,
                    52837.6
                  ],
                  [
                    65146.8,
                    52838.6
                  ],
                  [
                    64981.1,
                    52835.1
                  ],
                  [
                    64856.7,
                    52859.1
                  ],
                  [
                    64799.5,
                    52997.4
                  ],
                  [
                    64636,
                    52978.1
                  ],
                  [
                    64471,
                    52956.4
                  ],
                  [
                    64368.9,
                    52596.9
                  ],
                  [
                    64435.3,
                    52600.7
                  ],
                  [
                    64523.9,
                    52579.7
                  ]
                ],
                "id": 1484,
                "chat_link": "[&BMwFAAA=]"
              },
              "1485": {
                "name": "Vehjin Mines",
                "level": 80,
                "coord": [
                  64043.4,
                  53884.5
                ],
                "bounds": [
                  [
                    63666.7,
                    53964.1
                  ],
                  [
                    63697.3,
                    54237.3
                  ],
                  [
                    63879.6,
                    54185.9
                  ],
                  [
                    63906.4,
                    54191.9
                  ],
                  [
                    64037.4,
                    54157
                  ],
                  [
                    64167.3,
                    54049.4
                  ],
                  [
                    64413.4,
                    54034.9
                  ],
                  [
                    64412.8,
                    53875.5
                  ],
                  [
                    64395.5,
                    53814.7
                  ],
                  [
                    64354,
                    53835.3
                  ],
                  [
                    64292,
                    53837
                  ],
                  [
                    64113.8,
                    53772
                  ],
                  [
                    64069,
                    53690.5
                  ],
                  [
                    64007.8,
                    53632.2
                  ],
                  [
                    63888.1,
                    53592.8
                  ],
                  [
                    63777.8,
                    53573.9
                  ],
                  [
                    63659.1,
                    53591.4
                  ],
                  [
                    63666.7,
                    53964.1
                  ]
                ],
                "id": 1485,
                "chat_link": "[&BM0FAAA=]"
              },
              "1490": {
                "name": "The Foundry",
                "level": 80,
                "coord": [
                  64168,
                  54396.7
                ],
                "bounds": [
                  [
                    63698.7,
                    54238
                  ],
                  [
                    63676.6,
                    54423.3
                  ],
                  [
                    63734.9,
                    54603.1
                  ],
                  [
                    63838.6,
                    54625.6
                  ],
                  [
                    63927.1,
                    54631.5
                  ],
                  [
                    64127.1,
                    54628.2
                  ],
                  [
                    64309.5,
                    54609.4
                  ],
                  [
                    64345,
                    54762.5
                  ],
                  [
                    64582.9,
                    54634.8
                  ],
                  [
                    64557.7,
                    54503.3
                  ],
                  [
                    64648.1,
                    54344.7
                  ],
                  [
                    64624.5,
                    54282.6
                  ],
                  [
                    64548.7,
                    54233.3
                  ],
                  [
                    64411.6,
                    54035.6
                  ],
                  [
                    64167.6,
                    54048.9
                  ],
                  [
                    64036.4,
                    54157.6
                  ],
                  [
                    63908.7,
                    54193.1
                  ],
                  [
                    63880.5,
                    54186
                  ],
                  [
                    63698.7,
                    54238
                  ]
                ],
                "id": 1490,
                "chat_link": "[&BNIFAAA=]"
              },
              "1500": {
                "name": "Isha Corridor",
                "level": 80,
                "coord": [
                  65686.4,
                  53869.5
                ],
                "bounds": [
                  [
                    66149.2,
                    53850.9
                  ],
                  [
                    66297.7,
                    53807
                  ],
                  [
                    66396.9,
                    53767.1
                  ],
                  [
                    66394.9,
                    53742.7
                  ],
                  [
                    66330.5,
                    53698.1
                  ],
                  [
                    66305.2,
                    53638
                  ],
                  [
                    66324.2,
                    53555.9
                  ],
                  [
                    66300.2,
                    53564
                  ],
                  [
                    66011.2,
                    53558.8
                  ],
                  [
                    65941.9,
                    53557
                  ],
                  [
                    65907.9,
                    53540.2
                  ],
                  [
                    65755.5,
                    53552.4
                  ],
                  [
                    65176.9,
                    53561.7
                  ],
                  [
                    65062.2,
                    53565.1
                  ],
                  [
                    65115.4,
                    53625.4
                  ],
                  [
                    65079.2,
                    53818.7
                  ],
                  [
                    65006.3,
                    53894.9
                  ],
                  [
                    64975.3,
                    54014.6
                  ],
                  [
                    64980.3,
                    54068.7
                  ],
                  [
                    65011.8,
                    54158.9
                  ],
                  [
                    65095,
                    54267.5
                  ],
                  [
                    65263.6,
                    54267.3
                  ],
                  [
                    65315.6,
                    54202.4
                  ],
                  [
                    65368.9,
                    54154
                  ],
                  [
                    65512.2,
                    54125.6
                  ],
                  [
                    65609.5,
                    54167.7
                  ],
                  [
                    65715.5,
                    54249
                  ],
                  [
                    65813.2,
                    54261.4
                  ],
                  [
                    65832.4,
                    54114.8
                  ],
                  [
                    65825,
                    53871.5
                  ],
                  [
                    65993.7,
                    53779.5
                  ],
                  [
                    66098,
                    53824.8
                  ],
                  [
                    66149.2,
                    53850.9
                  ]
                ],
                "id": 1500,
                "chat_link": "[&BNwFAAA=]"
              },
              "1504": {
                "name": "Purling Deep",
                "level": 80,
                "coord": [
                  64560.7,
                  52454.8
                ],
                "bounds": [
                  [
                    64693.7,
                    52354.1
                  ],
                  [
                    64493.8,
                    52311.5
                  ],
                  [
                    64441.4,
                    52305.4
                  ],
                  [
                    64405.7,
                    52330.2
                  ],
                  [
                    64364.5,
                    52334.3
                  ],
                  [
                    64299,
                    52393.5
                  ],
                  [
                    64276.9,
                    52478.6
                  ],
                  [
                    64322,
                    52547.9
                  ],
                  [
                    64370.5,
                    52598.9
                  ],
                  [
                    64435.4,
                    52600.4
                  ],
                  [
                    64524.4,
                    52579.2
                  ],
                  [
                    64570.1,
                    52517.7
                  ],
                  [
                    64650.6,
                    52494.9
                  ],
                  [
                    64756.5,
                    52538
                  ],
                  [
                    64840.5,
                    52521.6
                  ],
                  [
                    64913.4,
                    52493.2
                  ],
                  [
                    64926.5,
                    52427.4
                  ],
                  [
                    64807,
                    52360.4
                  ],
                  [
                    64693.7,
                    52354.1
                  ]
                ],
                "id": 1504,
                "chat_link": "[&BOAFAAA=]"
              },
              "1515": {
                "name": "Resplendent Trace",
                "level": 80,
                "coord": [
                  67525.9,
                  54925.9
                ],
                "bounds": [
                  [
                    67163.7,
                    55390.8
                  ],
                  [
                    67131.6,
                    55517
                  ],
                  [
                    67351.3,
                    55523.2
                  ],
                  [
                    67550.4,
                    55519.3
                  ],
                  [
                    67783.8,
                    55510.4
                  ],
                  [
                    67888.1,
                    55487.2
                  ],
                  [
                    67875.5,
                    55304.9
                  ],
                  [
                    67996.2,
                    55213.8
                  ],
                  [
                    68046.7,
                    55112.1
                  ],
                  [
                    67988.2,
                    54904.7
                  ],
                  [
                    67987.3,
                    54823.1
                  ],
                  [
                    67990.4,
                    54778
                  ],
                  [
                    68124.6,
                    54610.3
                  ],
                  [
                    67942.1,
                    54564.5
                  ],
                  [
                    67912.4,
                    54361
                  ],
                  [
                    67695.2,
                    54298.4
                  ],
                  [
                    67283.1,
                    54306.1
                  ],
                  [
                    67249.5,
                    54363.7
                  ],
                  [
                    67225,
                    54627.5
                  ],
                  [
                    66978.9,
                    54690.1
                  ],
                  [
                    66784.1,
                    54693.8
                  ],
                  [
                    66803.6,
                    54775.3
                  ],
                  [
                    66887,
                    54880.2
                  ],
                  [
                    66982.5,
                    54966.7
                  ],
                  [
                    67163.7,
                    55390.8
                  ]
                ],
                "id": 1515,
                "chat_link": "[&BOsFAAA=]"
              },
              "1523": {
                "name": "Vehtendi Arena",
                "level": 80,
                "coord": [
                  66168.3,
                  54552.3
                ],
                "bounds": [
                  [
                    66052.6,
                    54275.6
                  ],
                  [
                    65969.1,
                    54278.4
                  ],
                  [
                    65986.7,
                    54439.2
                  ],
                  [
                    65920.9,
                    54519
                  ],
                  [
                    65936.5,
                    54656.7
                  ],
                  [
                    65945.4,
                    54724.5
                  ],
                  [
                    66081,
                    54826.4
                  ],
                  [
                    66322.3,
                    54787.7
                  ],
                  [
                    66459.7,
                    54721.1
                  ],
                  [
                    66493.8,
                    54628.5
                  ],
                  [
                    66497.1,
                    54504.4
                  ],
                  [
                    66354.4,
                    54266
                  ],
                  [
                    66052.6,
                    54275.6
                  ]
                ],
                "id": 1523,
                "chat_link": "[&BPMFAAA=]"
              },
              "1529": {
                "name": "Eastern Mihan Hillsides",
                "level": 80,
                "coord": [
                  65925.4,
                  52605.3
                ],
                "bounds": [
                  [
                    65389.9,
                    52578.2
                  ],
                  [
                    65400.8,
                    52520.3
                  ],
                  [
                    65456.9,
                    52482.8
                  ],
                  [
                    65453.4,
                    52375.7
                  ],
                  [
                    65574.3,
                    52351.2
                  ],
                  [
                    65871.9,
                    52373.7
                  ],
                  [
                    66124.1,
                    52376.3
                  ],
                  [
                    66398.5,
                    52394.1
                  ],
                  [
                    66399.1,
                    52540.4
                  ],
                  [
                    66427.9,
                    52657.1
                  ],
                  [
                    66496.1,
                    52769.9
                  ],
                  [
                    66493.2,
                    52797.9
                  ],
                  [
                    66353,
                    52833.1
                  ],
                  [
                    66209.3,
                    52833.2
                  ],
                  [
                    65827.3,
                    52842.8
                  ],
                  [
                    65432.8,
                    52836.5
                  ],
                  [
                    65422.8,
                    52726.3
                  ],
                  [
                    65389.9,
                    52578.2
                  ]
                ],
                "id": 1529,
                "chat_link": "[&BPkFAAA=]"
              },
              "1536": {
                "name": "Yahnur Plateau",
                "level": 80,
                "coord": [
                  68148.5,
                  55011.4
                ],
                "bounds": [
                  [
                    67888.6,
                    55487.2
                  ],
                  [
                    68419.6,
                    55508.2
                  ],
                  [
                    68448.9,
                    55393.5
                  ],
                  [
                    68432.7,
                    54861.7
                  ],
                  [
                    68409.9,
                    54597.2
                  ],
                  [
                    68319.9,
                    54555.9
                  ],
                  [
                    68124.4,
                    54610.1
                  ],
                  [
                    67989.7,
                    54777.4
                  ],
                  [
                    67987.2,
                    54821.8
                  ],
                  [
                    67988.6,
                    54904.9
                  ],
                  [
                    68048.3,
                    55111.9
                  ],
                  [
                    67995.9,
                    55213.5
                  ],
                  [
                    67876.6,
                    55305
                  ],
                  [
                    67888.6,
                    55487.2
                  ]
                ],
                "id": 1536,
                "chat_link": "[&BAAGAAA=]"
              },
              "1545": {
                "name": "Garden of Seborhin",
                "level": 80,
                "coord": [
                  65690.6,
                  53192.1
                ],
                "bounds": [
                  [
                    64799.9,
                    53005.3
                  ],
                  [
                    64856.8,
                    52859
                  ],
                  [
                    64981.1,
                    52834.3
                  ],
                  [
                    65146.8,
                    52836.6
                  ],
                  [
                    65298.9,
                    52836.4
                  ],
                  [
                    65432.3,
                    52836.8
                  ],
                  [
                    65827.6,
                    52841.4
                  ],
                  [
                    66209.3,
                    52832.5
                  ],
                  [
                    66352.5,
                    52833.8
                  ],
                  [
                    66494,
                    52798.5
                  ],
                  [
                    66562.7,
                    52918.8
                  ],
                  [
                    66506.3,
                    53036.9
                  ],
                  [
                    66452.3,
                    53064.9
                  ],
                  [
                    66434.1,
                    53147.2
                  ],
                  [
                    66434.4,
                    53221
                  ],
                  [
                    66443.9,
                    53281.1
                  ],
                  [
                    66518.9,
                    53389.5
                  ],
                  [
                    66511.9,
                    53507.1
                  ],
                  [
                    66475.1,
                    53563.7
                  ],
                  [
                    66314.4,
                    53572.8
                  ],
                  [
                    66069.8,
                    53570.4
                  ],
                  [
                    65767.5,
                    53571.3
                  ],
                  [
                    65278.5,
                    53564.4
                  ],
                  [
                    65179,
                    53564.2
                  ],
                  [
                    65062.3,
                    53564.6
                  ],
                  [
                    64948.8,
                    53460.2
                  ],
                  [
                    64918.8,
                    53418.2
                  ],
                  [
                    64835.4,
                    53387.2
                  ],
                  [
                    64757.2,
                    53283.2
                  ],
                  [
                    64764.8,
                    53205.8
                  ],
                  [
                    64773.7,
                    53148.9
                  ],
                  [
                    64799.9,
                    53005.3
                  ]
                ],
                "id": 1545,
                "chat_link": "[&BAkGAAA=]"
              },
              "1552": {
                "name": "Dzasha Uplands",
                "level": 80,
                "coord": [
                  67895.3,
                  52896
                ],
                "bounds": [
                  [
                    67233.4,
                    52481.6
                  ],
                  [
                    67288.3,
                    52455.9
                  ],
                  [
                    67398.8,
                    52391.2
                  ],
                  [
                    67620.9,
                    52405.8
                  ],
                  [
                    67938,
                    52443.6
                  ],
                  [
                    68225.5,
                    52587.9
                  ],
                  [
                    68268.1,
                    52854.3
                  ],
                  [
                    68342.5,
                    52982
                  ],
                  [
                    68404.4,
                    53028.7
                  ],
                  [
                    68422.8,
                    53156
                  ],
                  [
                    68428.4,
                    53333.1
                  ],
                  [
                    68385.1,
                    53458
                  ],
                  [
                    68384.3,
                    53459.3
                  ],
                  [
                    67842.5,
                    53383.8
                  ],
                  [
                    67896.8,
                    53185.3
                  ],
                  [
                    67878.4,
                    52952.6
                  ],
                  [
                    67761.5,
                    52882.7
                  ],
                  [
                    67585.4,
                    52849.9
                  ],
                  [
                    67352.7,
                    52859.5
                  ],
                  [
                    67247.9,
                    52769.2
                  ],
                  [
                    67233.4,
                    52481.6
                  ]
                ],
                "id": 1552,
                "chat_link": "[&BBAGAAA=]"
              },
              "1553": {
                "name": "Grand Court of Sebelkeh",
                "level": 80,
                "coord": [
                  67526.9,
                  53116.7
                ],
                "bounds": [
                  [
                    67250.7,
                    52771.1
                  ],
                  [
                    67359.5,
                    52840.4
                  ],
                  [
                    67590.6,
                    52810.7
                  ],
                  [
                    67755.9,
                    52839.1
                  ],
                  [
                    67877.5,
                    52949.8
                  ],
                  [
                    67894.5,
                    53180.8
                  ],
                  [
                    67847,
                    53381.7
                  ],
                  [
                    67566.8,
                    53551.1
                  ],
                  [
                    67373.8,
                    53447.5
                  ],
                  [
                    67209,
                    53490.3
                  ],
                  [
                    67071,
                    53021.1
                  ],
                  [
                    67250.7,
                    52771.1
                  ]
                ],
                "id": 1553,
                "chat_link": "[&BBEGAAA=]"
              },
              "1555": {
                "name": "Kaluun Ravine",
                "level": 80,
                "coord": [
                  65700.8,
                  55118.1
                ],
                "bounds": [
                  [
                    66086,
                    55505
                  ],
                  [
                    66083.5,
                    55410.1
                  ],
                  [
                    66128.4,
                    55283.7
                  ],
                  [
                    66111.2,
                    55052.2
                  ],
                  [
                    66082.8,
                    54826.2
                  ],
                  [
                    65946.5,
                    54727.4
                  ],
                  [
                    65501.9,
                    54888.9
                  ],
                  [
                    65365.4,
                    55017.7
                  ],
                  [
                    65237.4,
                    54949.3
                  ],
                  [
                    65072.9,
                    55125.1
                  ],
                  [
                    65093,
                    55513.4
                  ],
                  [
                    66086,
                    55505
                  ]
                ],
                "id": 1555,
                "chat_link": "[&BBMGAAA=]"
              },
              "1556": {
                "name": "Forum Highlands",
                "level": 80,
                "coord": [
                  65526,
                  54462.2
                ],
                "bounds": [
                  [
                    65843.6,
                    54285.6
                  ],
                  [
                    65971.1,
                    54277.7
                  ],
                  [
                    65985.7,
                    54440.2
                  ],
                  [
                    65921.4,
                    54519
                  ],
                  [
                    65945.4,
                    54725.9
                  ],
                  [
                    65501.8,
                    54889.7
                  ],
                  [
                    65365.2,
                    55016.6
                  ],
                  [
                    65238.4,
                    54950.6
                  ],
                  [
                    65224.1,
                    54815.4
                  ],
                  [
                    65221.1,
                    54633.2
                  ],
                  [
                    65084.1,
                    54535.8
                  ],
                  [
                    65097.2,
                    54270.2
                  ],
                  [
                    65264.4,
                    54266.8
                  ],
                  [
                    65314.5,
                    54201.3
                  ],
                  [
                    65369.8,
                    54154.5
                  ],
                  [
                    65512.2,
                    54124.2
                  ],
                  [
                    65607,
                    54167.5
                  ],
                  [
                    65712.6,
                    54248.8
                  ],
                  [
                    65814,
                    54259
                  ],
                  [
                    65843.6,
                    54285.6
                  ]
                ],
                "id": 1556,
                "chat_link": "[&BBQGAAA=]"
              },
              "1566": {
                "name": "Jennur's Run",
                "level": 80,
                "coord": [
                  64765,
                  53756.9
                ],
                "bounds": [
                  [
                    64635,
                    52976.9
                  ],
                  [
                    64470.4,
                    52956.5
                  ],
                  [
                    64420.4,
                    53172
                  ],
                  [
                    64463.5,
                    53389.9
                  ],
                  [
                    64507.9,
                    53493.8
                  ],
                  [
                    64603.1,
                    53667.3
                  ],
                  [
                    64395.6,
                    53815.8
                  ],
                  [
                    64413,
                    53874.1
                  ],
                  [
                    64411.6,
                    54035.6
                  ],
                  [
                    64549.4,
                    54233.9
                  ],
                  [
                    64625.6,
                    54283.4
                  ],
                  [
                    64651.7,
                    54347.2
                  ],
                  [
                    64836.2,
                    54450.4
                  ],
                  [
                    64975.4,
                    54426.9
                  ],
                  [
                    65090.6,
                    54419.8
                  ],
                  [
                    65096.4,
                    54270.8
                  ],
                  [
                    65011.5,
                    54159.9
                  ],
                  [
                    64975.1,
                    54014.7
                  ],
                  [
                    65006.6,
                    53894.8
                  ],
                  [
                    65080.3,
                    53818
                  ],
                  [
                    65115.6,
                    53625.7
                  ],
                  [
                    65061.4,
                    53564.8
                  ],
                  [
                    64948.6,
                    53461
                  ],
                  [
                    64918.3,
                    53420
                  ],
                  [
                    64834.8,
                    53383.3
                  ],
                  [
                    64756.4,
                    53284.1
                  ],
                  [
                    64799.5,
                    52994.9
                  ],
                  [
                    64635,
                    52976.9
                  ]
                ],
                "id": 1566,
                "chat_link": "[&BB4GAAA=]"
              },
              "1569": {
                "name": "Vehjin Palace",
                "level": 80,
                "coord": [
                  64164.8,
                  53448.2
                ],
                "bounds": [
                  [
                    63677.4,
                    53027
                  ],
                  [
                    63658.8,
                    53591.4
                  ],
                  [
                    63778,
                    53574.2
                  ],
                  [
                    63888.2,
                    53592.8
                  ],
                  [
                    64007.6,
                    53632.3
                  ],
                  [
                    64069.1,
                    53690.5
                  ],
                  [
                    64113.7,
                    53771.8
                  ],
                  [
                    64292.2,
                    53836.5
                  ],
                  [
                    64353.9,
                    53835.1
                  ],
                  [
                    64395.7,
                    53814.9
                  ],
                  [
                    64602.9,
                    53667.4
                  ],
                  [
                    64506.8,
                    53491
                  ],
                  [
                    64462.9,
                    53389
                  ],
                  [
                    64420.2,
                    53168.9
                  ],
                  [
                    64470.5,
                    52955.7
                  ],
                  [
                    64252.1,
                    52968.8
                  ],
                  [
                    64072.8,
                    53000.2
                  ],
                  [
                    63944.5,
                    53059.3
                  ],
                  [
                    63677.4,
                    53027
                  ]
                ],
                "id": 1569,
                "chat_link": "[&BCEGAAA=]"
              },
              "1571": {
                "name": "Kodash Bazaar",
                "level": 80,
                "coord": [
                  66635.8,
                  53948
                ],
                "bounds": [
                  [
                    65996.8,
                    53781.3
                  ],
                  [
                    65949.6,
                    53806.8
                  ],
                  [
                    65826.6,
                    53875.5
                  ],
                  [
                    65833.1,
                    54113.9
                  ],
                  [
                    65814.3,
                    54257
                  ],
                  [
                    65843.3,
                    54285.3
                  ],
                  [
                    66054.3,
                    54274.8
                  ],
                  [
                    66355.4,
                    54265.4
                  ],
                  [
                    66498.2,
                    54504.8
                  ],
                  [
                    66494,
                    54629.1
                  ],
                  [
                    66712.4,
                    54696.6
                  ],
                  [
                    66978.2,
                    54688.8
                  ],
                  [
                    67226.6,
                    54626
                  ],
                  [
                    67249.8,
                    54364
                  ],
                  [
                    67283.3,
                    54305.5
                  ],
                  [
                    67693.5,
                    54298.3
                  ],
                  [
                    67697.5,
                    54033.4
                  ],
                  [
                    67537.1,
                    54003.9
                  ],
                  [
                    67417.7,
                    53899
                  ],
                  [
                    67324.8,
                    53842.9
                  ],
                  [
                    67210.9,
                    53823.1
                  ],
                  [
                    67054,
                    53795
                  ],
                  [
                    67014.1,
                    53615.1
                  ],
                  [
                    66895.9,
                    53578.3
                  ],
                  [
                    66905.8,
                    53483
                  ],
                  [
                    66778,
                    53413.8
                  ],
                  [
                    66687.5,
                    53395.7
                  ],
                  [
                    66518.6,
                    53388
                  ],
                  [
                    66507.8,
                    53500.1
                  ],
                  [
                    66473.1,
                    53565.3
                  ],
                  [
                    66334.8,
                    53561.9
                  ],
                  [
                    66309.8,
                    53647.8
                  ],
                  [
                    66334.3,
                    53697.6
                  ],
                  [
                    66401.2,
                    53741.3
                  ],
                  [
                    66396.2,
                    53774
                  ],
                  [
                    66302,
                    53811
                  ],
                  [
                    66152.8,
                    53852.6
                  ],
                  [
                    66097,
                    53828.4
                  ],
                  [
                    65996.8,
                    53781.3
                  ]
                ],
                "id": 1571,
                "chat_link": "[&BCMGAAA=]"
              },
              "1572": {
                "name": "Dehwan Expanse",
                "level": 80,
                "coord": [
                  66752,
                  52998
                ],
                "bounds": [
                  [
                    66894.7,
                    53579.3
                  ],
                  [
                    66905.6,
                    53483.1
                  ],
                  [
                    66777.9,
                    53413.8
                  ],
                  [
                    66688.1,
                    53396.4
                  ],
                  [
                    66518.6,
                    53389.1
                  ],
                  [
                    66435.3,
                    53221.9
                  ],
                  [
                    66435.6,
                    53142
                  ],
                  [
                    66458,
                    53061.3
                  ],
                  [
                    66497.5,
                    53042.4
                  ],
                  [
                    66568.4,
                    52915.8
                  ],
                  [
                    66492.8,
                    52797.5
                  ],
                  [
                    66496,
                    52770.6
                  ],
                  [
                    66429.1,
                    52658.8
                  ],
                  [
                    66400.5,
                    52541.2
                  ],
                  [
                    66398,
                    52395.1
                  ],
                  [
                    66696.9,
                    52383.1
                  ],
                  [
                    66916.8,
                    52427.2
                  ],
                  [
                    67105.1,
                    52435.1
                  ],
                  [
                    67233.4,
                    52481.6
                  ],
                  [
                    67247.8,
                    52773
                  ],
                  [
                    67069.6,
                    53023.9
                  ],
                  [
                    67208.3,
                    53491.7
                  ],
                  [
                    67159.5,
                    53515.3
                  ],
                  [
                    67015,
                    53613
                  ],
                  [
                    66894.7,
                    53579.3
                  ]
                ],
                "id": 1572,
                "chat_link": "[&BCQGAAA=]"
              },
              "1576": {
                "name": "Cragged Vale",
                "level": 80,
                "coord": [
                  64024.7,
                  52819.3
                ],
                "bounds": [
                  [
                    63669.7,
                    52660.9
                  ],
                  [
                    63676.7,
                    53026.7
                  ],
                  [
                    63943.9,
                    53059.1
                  ],
                  [
                    64073.1,
                    53000.5
                  ],
                  [
                    64252.6,
                    52969.1
                  ],
                  [
                    64470.3,
                    52954.8
                  ],
                  [
                    64368.7,
                    52593.7
                  ],
                  [
                    63942.8,
                    52546.1
                  ],
                  [
                    63824.7,
                    52562.5
                  ],
                  [
                    63669.7,
                    52660.9
                  ]
                ],
                "id": 1576,
                "chat_link": "[&BCgGAAA=]"
              },
              "1583": {
                "name": "The Necropolis",
                "level": 80,
                "coord": [
                  64737.6,
                  54825.9
                ],
                "bounds": [
                  [
                    64307.7,
                    55138.9
                  ],
                  [
                    64234.5,
                    55270.3
                  ],
                  [
                    64219,
                    55518.8
                  ],
                  [
                    65091.9,
                    55514
                  ],
                  [
                    65072.9,
                    55125.3
                  ],
                  [
                    65238,
                    54948.9
                  ],
                  [
                    65223,
                    54814.1
                  ],
                  [
                    65221.1,
                    54631.2
                  ],
                  [
                    65084.6,
                    54535.8
                  ],
                  [
                    65091.2,
                    54418.9
                  ],
                  [
                    64973.5,
                    54425.4
                  ],
                  [
                    64836.2,
                    54450
                  ],
                  [
                    64650.2,
                    54345.5
                  ],
                  [
                    64557,
                    54503.2
                  ],
                  [
                    64582.2,
                    54634.7
                  ],
                  [
                    64344.8,
                    54762.4
                  ],
                  [
                    64306.2,
                    54838.7
                  ],
                  [
                    64241.8,
                    54990.4
                  ],
                  [
                    64307.7,
                    55138.9
                  ]
                ],
                "id": 1583,
                "chat_link": "[&BC8GAAA=]"
              },
              "1592": {
                "name": "Glowering Overlook",
                "level": 80,
                "coord": [
                  64011.4,
                  54986.9
                ],
                "bounds": [
                  [
                    64219.2,
                    55519.5
                  ],
                  [
                    63959,
                    55508.2
                  ],
                  [
                    63831.3,
                    55411.7
                  ],
                  [
                    63727,
                    55246
                  ],
                  [
                    63682,
                    55106.7
                  ],
                  [
                    63689.3,
                    54749.4
                  ],
                  [
                    63732,
                    54605
                  ],
                  [
                    63838.1,
                    54625.8
                  ],
                  [
                    63926.3,
                    54632.2
                  ],
                  [
                    64127.7,
                    54627.9
                  ],
                  [
                    64309.9,
                    54608.6
                  ],
                  [
                    64343.4,
                    54762.9
                  ],
                  [
                    64242.1,
                    54990.7
                  ],
                  [
                    64307.2,
                    55140.2
                  ],
                  [
                    64235.8,
                    55269
                  ],
                  [
                    64219.2,
                    55519.5
                  ]
                ],
                "id": 1592,
                "chat_link": "[&BDgGAAA=]"
              },
              "1595": {
                "name": "Zagonur Cliffs",
                "level": 80,
                "coord": [
                  67892.7,
                  53962.3
                ],
                "bounds": [
                  [
                    68450.2,
                    54220.1
                  ],
                  [
                    68451.7,
                    54368.8
                  ],
                  [
                    68443.8,
                    54505.4
                  ],
                  [
                    68412.2,
                    54602.9
                  ],
                  [
                    68319.2,
                    54555.4
                  ],
                  [
                    68125.5,
                    54610.6
                  ],
                  [
                    67944.8,
                    54560
                  ],
                  [
                    67912.6,
                    54360.6
                  ],
                  [
                    67695.4,
                    54297.8
                  ],
                  [
                    67696.7,
                    54035.4
                  ],
                  [
                    67536,
                    54002.8
                  ],
                  [
                    67418.2,
                    53899.7
                  ],
                  [
                    67324.9,
                    53842.8
                  ],
                  [
                    67210.5,
                    53823.4
                  ],
                  [
                    67055.5,
                    53796.1
                  ],
                  [
                    67013,
                    53612.8
                  ],
                  [
                    67159.5,
                    53515.6
                  ],
                  [
                    67209.9,
                    53492.3
                  ],
                  [
                    67374.1,
                    53448.4
                  ],
                  [
                    67566.9,
                    53552.6
                  ],
                  [
                    67845.2,
                    53384.8
                  ],
                  [
                    68385.1,
                    53458
                  ],
                  [
                    68400,
                    53537.4
                  ],
                  [
                    68400.8,
                    53671.4
                  ],
                  [
                    68391.9,
                    53809
                  ],
                  [
                    68384.5,
                    53920.2
                  ],
                  [
                    68424.6,
                    53968.4
                  ],
                  [
                    68442.3,
                    54092.7
                  ],
                  [
                    68450.2,
                    54220.1
                  ]
                ],
                "id": 1595,
                "chat_link": "[&BDsGAAA=]"
              }
            },
            "adventures": [],
            "id": 1253,
            "mastery_points": []
          },
          "1255": {
            "name": "Enemy of My Enemy: The Troopmarshal",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              38768,
              45740
            ],
            "map_rect": [
              [
                -58368,
                -36864
              ],
              [
                58368,
                39936
              ]
            ],
            "continent_rect": [
              [
                63616,
                52352
              ],
              [
                68480,
                55552
              ]
            ],
            "points_of_interest": {
              "2550": {
                "name": "The Menagerie",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66235,
                  53193.4
                ],
                "id": 2550,
                "chat_link": "[&BPYJAAA=]"
              },
              "2555": {
                "name": "The Promenade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64999.5,
                  53201.3
                ],
                "id": 2555,
                "chat_link": "[&BPsJAAA=]"
              },
              "2559": {
                "name": "Ruins of Mihanu Township",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66737.1,
                  52538.7
                ],
                "id": 2559,
                "chat_link": "[&BP8JAAA=]"
              },
              "2561": {
                "name": "Spearmarshal's Lament",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  68076.9,
                  55017.1
                ],
                "id": 2561,
                "chat_link": "[&BAEKAAA=]"
              },
              "2563": {
                "name": "Spa",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65532.1,
                  52936
                ],
                "id": 2563,
                "chat_link": "[&BAMKAAA=]"
              },
              "2574": {
                "name": "Vehjin Royal Rotunda",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64000.1,
                  53492.3
                ],
                "id": 2574,
                "chat_link": "[&BA4KAAA=]"
              },
              "2581": {
                "name": "The Warehouse",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66628.9,
                  54894.7
                ],
                "id": 2581,
                "chat_link": "[&BBUKAAA=]"
              },
              "2602": {
                "name": "Junundu Nests",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65769.7,
                  55195.3
                ],
                "id": 2602,
                "chat_link": "[&BCoKAAA=]"
              },
              "2604": {
                "name": "Beastmarshal's Encampment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65211,
                  55293.7
                ],
                "id": 2604,
                "chat_link": "[&BCwKAAA=]"
              },
              "2612": {
                "name": "Troopmarshal's Encampment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64491.7,
                  54314.2
                ],
                "id": 2612,
                "chat_link": "[&BDQKAAA=]"
              },
              "2621": {
                "name": "Seborhin Circle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65287.1,
                  53198.5
                ],
                "id": 2621,
                "chat_link": "[&BD0KAAA=]"
              },
              "2658": {
                "name": "Tihark Orchard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65438.5,
                  54252.7
                ],
                "id": 2658,
                "chat_link": "[&BGIKAAA=]"
              },
              "2662": {
                "name": "Merchant's Row",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65645.1,
                  53191.6
                ],
                "id": 2662,
                "chat_link": "[&BGYKAAA=]"
              },
              "2669": {
                "name": "The Hearth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63952.7,
                  54416.8
                ],
                "id": 2669,
                "chat_link": "[&BG0KAAA=]"
              },
              "2696": {
                "name": "Market Ruins",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66162.1,
                  54005.2
                ],
                "id": 2696,
                "chat_link": "[&BIgKAAA=]"
              },
              "2710": {
                "name": "Hanging Gardens",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  68127.9,
                  54313.2
                ],
                "id": 2710,
                "chat_link": "[&BJYKAAA=]"
              },
              "2714": {
                "name": "House Ingene Dormitory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66715.5,
                  55167.1
                ],
                "id": 2714,
                "chat_link": "[&BJoKAAA=]"
              },
              "2715": {
                "name": "Great Palawa Joko Monument",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66153.5,
                  54897
                ],
                "id": 2715,
                "chat_link": "[&BJsKAAA=]"
              },
              "2720": {
                "name": "Tournament Battlegrounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66206.1,
                  54515.6
                ],
                "id": 2720,
                "chat_link": "[&BKAKAAA=]"
              },
              "2731": {
                "name": "House Ventura Dormitory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66638.6,
                  55250.9
                ],
                "id": 2731,
                "chat_link": "[&BKsKAAA=]"
              },
              "2748": {
                "name": "Excavation Site",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63864.4,
                  53729.2
                ],
                "id": 2748,
                "chat_link": "[&BLwKAAA=]"
              },
              "2752": {
                "name": "The Boneyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63898.4,
                  55287.7
                ],
                "id": 2752,
                "chat_link": "[&BMAKAAA=]"
              },
              "2755": {
                "name": "Vehtendi Vineyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67038.6,
                  55431.5
                ],
                "id": 2755,
                "chat_link": "[&BMMKAAA=]"
              },
              "2758": {
                "name": "Lyssan Fools Theater",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65281.3,
                  53503
                ],
                "id": 2758,
                "chat_link": "[&BMYKAAA=]"
              },
              "2763": {
                "name": "Court of the Dead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64650.3,
                  54973.4
                ],
                "id": 2763,
                "chat_link": "[&BMsKAAA=]"
              },
              "2776": {
                "name": "Headmaster's Office",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66508.9,
                  55072
                ],
                "id": 2776,
                "chat_link": "[&BNgKAAA=]"
              },
              "2779": {
                "name": "House Rolic Dormitory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66723.4,
                  55054.4
                ],
                "id": 2779,
                "chat_link": "[&BNsKAAA=]"
              },
              "2783": {
                "name": "Ruins of Jennur's Horde",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64796,
                  53554.4
                ],
                "id": 2783,
                "chat_link": "[&BN8KAAA=]"
              },
              "2794": {
                "name": "King Joko's Sky Garden",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66843.3,
                  54040.5
                ],
                "id": 2794,
                "chat_link": "[&BOoKAAA=]"
              },
              "2795": {
                "name": "The Crypts",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64512.4,
                  55189.4
                ],
                "id": 2795,
                "chat_link": "[&BOsKAAA=]"
              },
              "2796": {
                "name": "Lair of Zommoros",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64728.5,
                  52403.3
                ],
                "id": 2796,
                "chat_link": "[&BOwKAAA=]"
              },
              "2802": {
                "name": "Ruins of the Mirror of Lyss",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67587.2,
                  53006
                ],
                "id": 2802,
                "chat_link": "[&BPIKAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1484": {
                "name": "Western Mihan Hillsides",
                "level": 80,
                "coord": [
                  64950.8,
                  52651.6
                ],
                "bounds": [
                  [
                    64523.9,
                    52579.7
                  ],
                  [
                    64569.3,
                    52518.8
                  ],
                  [
                    64649.7,
                    52494.7
                  ],
                  [
                    64753.3,
                    52537.3
                  ],
                  [
                    64842.8,
                    52519.9
                  ],
                  [
                    64913.2,
                    52496.1
                  ],
                  [
                    64925.6,
                    52424.3
                  ],
                  [
                    65141.4,
                    52397.5
                  ],
                  [
                    65449.8,
                    52375.6
                  ],
                  [
                    65457.5,
                    52481.8
                  ],
                  [
                    65402,
                    52520.9
                  ],
                  [
                    65390.1,
                    52578.3
                  ],
                  [
                    65422.6,
                    52726
                  ],
                  [
                    65433,
                    52837.1
                  ],
                  [
                    65297.7,
                    52837.6
                  ],
                  [
                    65146.8,
                    52838.6
                  ],
                  [
                    64981.1,
                    52835.1
                  ],
                  [
                    64856.7,
                    52859.1
                  ],
                  [
                    64799.5,
                    52997.4
                  ],
                  [
                    64636,
                    52978.1
                  ],
                  [
                    64471,
                    52956.4
                  ],
                  [
                    64368.9,
                    52596.9
                  ],
                  [
                    64435.3,
                    52600.7
                  ],
                  [
                    64523.9,
                    52579.7
                  ]
                ],
                "id": 1484,
                "chat_link": "[&BMwFAAA=]"
              },
              "1485": {
                "name": "Vehjin Mines",
                "level": 80,
                "coord": [
                  64043.4,
                  53884.5
                ],
                "bounds": [
                  [
                    63666.7,
                    53964.1
                  ],
                  [
                    63697.3,
                    54237.3
                  ],
                  [
                    63879.6,
                    54185.9
                  ],
                  [
                    63906.4,
                    54191.9
                  ],
                  [
                    64037.4,
                    54157
                  ],
                  [
                    64167.3,
                    54049.4
                  ],
                  [
                    64413.4,
                    54034.9
                  ],
                  [
                    64412.8,
                    53875.5
                  ],
                  [
                    64395.5,
                    53814.7
                  ],
                  [
                    64354,
                    53835.3
                  ],
                  [
                    64292,
                    53837
                  ],
                  [
                    64113.8,
                    53772
                  ],
                  [
                    64069,
                    53690.5
                  ],
                  [
                    64007.8,
                    53632.2
                  ],
                  [
                    63888.1,
                    53592.8
                  ],
                  [
                    63777.8,
                    53573.9
                  ],
                  [
                    63659.1,
                    53591.4
                  ],
                  [
                    63666.7,
                    53964.1
                  ]
                ],
                "id": 1485,
                "chat_link": "[&BM0FAAA=]"
              },
              "1490": {
                "name": "The Foundry",
                "level": 80,
                "coord": [
                  64168,
                  54396.7
                ],
                "bounds": [
                  [
                    63698.7,
                    54238
                  ],
                  [
                    63676.6,
                    54423.3
                  ],
                  [
                    63734.9,
                    54603.1
                  ],
                  [
                    63838.6,
                    54625.6
                  ],
                  [
                    63927.1,
                    54631.5
                  ],
                  [
                    64127.1,
                    54628.2
                  ],
                  [
                    64309.5,
                    54609.4
                  ],
                  [
                    64345,
                    54762.5
                  ],
                  [
                    64582.9,
                    54634.8
                  ],
                  [
                    64557.7,
                    54503.3
                  ],
                  [
                    64648.1,
                    54344.7
                  ],
                  [
                    64624.5,
                    54282.6
                  ],
                  [
                    64548.7,
                    54233.3
                  ],
                  [
                    64411.6,
                    54035.6
                  ],
                  [
                    64167.6,
                    54048.9
                  ],
                  [
                    64036.4,
                    54157.6
                  ],
                  [
                    63908.7,
                    54193.1
                  ],
                  [
                    63880.5,
                    54186
                  ],
                  [
                    63698.7,
                    54238
                  ]
                ],
                "id": 1490,
                "chat_link": "[&BNIFAAA=]"
              },
              "1500": {
                "name": "Isha Corridor",
                "level": 80,
                "coord": [
                  65686.4,
                  53869.5
                ],
                "bounds": [
                  [
                    66149.2,
                    53850.9
                  ],
                  [
                    66297.7,
                    53807
                  ],
                  [
                    66396.9,
                    53767.1
                  ],
                  [
                    66394.9,
                    53742.7
                  ],
                  [
                    66330.5,
                    53698.1
                  ],
                  [
                    66305.2,
                    53638
                  ],
                  [
                    66324.2,
                    53555.9
                  ],
                  [
                    66300.2,
                    53564
                  ],
                  [
                    66011.2,
                    53558.8
                  ],
                  [
                    65941.9,
                    53557
                  ],
                  [
                    65907.9,
                    53540.2
                  ],
                  [
                    65755.5,
                    53552.4
                  ],
                  [
                    65176.9,
                    53561.7
                  ],
                  [
                    65062.2,
                    53565.1
                  ],
                  [
                    65115.4,
                    53625.4
                  ],
                  [
                    65079.2,
                    53818.7
                  ],
                  [
                    65006.3,
                    53894.9
                  ],
                  [
                    64975.3,
                    54014.6
                  ],
                  [
                    64980.3,
                    54068.7
                  ],
                  [
                    65011.8,
                    54158.9
                  ],
                  [
                    65095,
                    54267.5
                  ],
                  [
                    65263.6,
                    54267.3
                  ],
                  [
                    65315.6,
                    54202.4
                  ],
                  [
                    65368.9,
                    54154
                  ],
                  [
                    65512.2,
                    54125.6
                  ],
                  [
                    65609.5,
                    54167.7
                  ],
                  [
                    65715.5,
                    54249
                  ],
                  [
                    65813.2,
                    54261.4
                  ],
                  [
                    65832.4,
                    54114.8
                  ],
                  [
                    65825,
                    53871.5
                  ],
                  [
                    65993.7,
                    53779.5
                  ],
                  [
                    66098,
                    53824.8
                  ],
                  [
                    66149.2,
                    53850.9
                  ]
                ],
                "id": 1500,
                "chat_link": "[&BNwFAAA=]"
              },
              "1504": {
                "name": "Purling Deep",
                "level": 80,
                "coord": [
                  64560.7,
                  52454.8
                ],
                "bounds": [
                  [
                    64693.7,
                    52354.1
                  ],
                  [
                    64493.8,
                    52311.5
                  ],
                  [
                    64441.4,
                    52305.4
                  ],
                  [
                    64405.7,
                    52330.2
                  ],
                  [
                    64364.5,
                    52334.3
                  ],
                  [
                    64299,
                    52393.5
                  ],
                  [
                    64276.9,
                    52478.6
                  ],
                  [
                    64322,
                    52547.9
                  ],
                  [
                    64370.5,
                    52598.9
                  ],
                  [
                    64435.4,
                    52600.4
                  ],
                  [
                    64524.4,
                    52579.2
                  ],
                  [
                    64570.1,
                    52517.7
                  ],
                  [
                    64650.6,
                    52494.9
                  ],
                  [
                    64756.5,
                    52538
                  ],
                  [
                    64840.5,
                    52521.6
                  ],
                  [
                    64913.4,
                    52493.2
                  ],
                  [
                    64926.5,
                    52427.4
                  ],
                  [
                    64807,
                    52360.4
                  ],
                  [
                    64693.7,
                    52354.1
                  ]
                ],
                "id": 1504,
                "chat_link": "[&BOAFAAA=]"
              },
              "1515": {
                "name": "Resplendent Trace",
                "level": 80,
                "coord": [
                  67525.9,
                  54925.9
                ],
                "bounds": [
                  [
                    67163.7,
                    55390.8
                  ],
                  [
                    67131.6,
                    55517
                  ],
                  [
                    67351.3,
                    55523.2
                  ],
                  [
                    67550.4,
                    55519.3
                  ],
                  [
                    67783.8,
                    55510.4
                  ],
                  [
                    67888.1,
                    55487.2
                  ],
                  [
                    67875.5,
                    55304.9
                  ],
                  [
                    67996.2,
                    55213.8
                  ],
                  [
                    68046.7,
                    55112.1
                  ],
                  [
                    67988.2,
                    54904.7
                  ],
                  [
                    67987.3,
                    54823.1
                  ],
                  [
                    67990.4,
                    54778
                  ],
                  [
                    68124.6,
                    54610.3
                  ],
                  [
                    67942.1,
                    54564.5
                  ],
                  [
                    67912.4,
                    54361
                  ],
                  [
                    67695.2,
                    54298.4
                  ],
                  [
                    67283.1,
                    54306.1
                  ],
                  [
                    67249.5,
                    54363.7
                  ],
                  [
                    67225,
                    54627.5
                  ],
                  [
                    66978.9,
                    54690.1
                  ],
                  [
                    66784.1,
                    54693.8
                  ],
                  [
                    66803.6,
                    54775.3
                  ],
                  [
                    66887,
                    54880.2
                  ],
                  [
                    66982.5,
                    54966.7
                  ],
                  [
                    67163.7,
                    55390.8
                  ]
                ],
                "id": 1515,
                "chat_link": "[&BOsFAAA=]"
              },
              "1523": {
                "name": "Vehtendi Arena",
                "level": 80,
                "coord": [
                  66168.3,
                  54552.3
                ],
                "bounds": [
                  [
                    66052.6,
                    54275.6
                  ],
                  [
                    65969.1,
                    54278.4
                  ],
                  [
                    65986.7,
                    54439.2
                  ],
                  [
                    65920.9,
                    54519
                  ],
                  [
                    65936.5,
                    54656.7
                  ],
                  [
                    65945.4,
                    54724.5
                  ],
                  [
                    66081,
                    54826.4
                  ],
                  [
                    66322.3,
                    54787.7
                  ],
                  [
                    66459.7,
                    54721.1
                  ],
                  [
                    66493.8,
                    54628.5
                  ],
                  [
                    66497.1,
                    54504.4
                  ],
                  [
                    66354.4,
                    54266
                  ],
                  [
                    66052.6,
                    54275.6
                  ]
                ],
                "id": 1523,
                "chat_link": "[&BPMFAAA=]"
              },
              "1529": {
                "name": "Eastern Mihan Hillsides",
                "level": 80,
                "coord": [
                  65925.4,
                  52605.3
                ],
                "bounds": [
                  [
                    65389.9,
                    52578.2
                  ],
                  [
                    65400.8,
                    52520.3
                  ],
                  [
                    65456.9,
                    52482.8
                  ],
                  [
                    65453.4,
                    52375.7
                  ],
                  [
                    65574.3,
                    52351.2
                  ],
                  [
                    65871.9,
                    52373.7
                  ],
                  [
                    66124.1,
                    52376.3
                  ],
                  [
                    66398.5,
                    52394.1
                  ],
                  [
                    66399.1,
                    52540.4
                  ],
                  [
                    66427.9,
                    52657.1
                  ],
                  [
                    66496.1,
                    52769.9
                  ],
                  [
                    66493.2,
                    52797.9
                  ],
                  [
                    66353,
                    52833.1
                  ],
                  [
                    66209.3,
                    52833.2
                  ],
                  [
                    65827.3,
                    52842.8
                  ],
                  [
                    65432.8,
                    52836.5
                  ],
                  [
                    65422.8,
                    52726.3
                  ],
                  [
                    65389.9,
                    52578.2
                  ]
                ],
                "id": 1529,
                "chat_link": "[&BPkFAAA=]"
              },
              "1536": {
                "name": "Yahnur Plateau",
                "level": 80,
                "coord": [
                  68148.5,
                  55011.4
                ],
                "bounds": [
                  [
                    67888.6,
                    55487.2
                  ],
                  [
                    68419.6,
                    55508.2
                  ],
                  [
                    68448.9,
                    55393.5
                  ],
                  [
                    68432.7,
                    54861.7
                  ],
                  [
                    68409.9,
                    54597.2
                  ],
                  [
                    68319.9,
                    54555.9
                  ],
                  [
                    68124.4,
                    54610.1
                  ],
                  [
                    67989.7,
                    54777.4
                  ],
                  [
                    67987.2,
                    54821.8
                  ],
                  [
                    67988.6,
                    54904.9
                  ],
                  [
                    68048.3,
                    55111.9
                  ],
                  [
                    67995.9,
                    55213.5
                  ],
                  [
                    67876.6,
                    55305
                  ],
                  [
                    67888.6,
                    55487.2
                  ]
                ],
                "id": 1536,
                "chat_link": "[&BAAGAAA=]"
              },
              "1545": {
                "name": "Garden of Seborhin",
                "level": 80,
                "coord": [
                  65690.6,
                  53192.1
                ],
                "bounds": [
                  [
                    64799.9,
                    53005.3
                  ],
                  [
                    64856.8,
                    52859
                  ],
                  [
                    64981.1,
                    52834.3
                  ],
                  [
                    65146.8,
                    52836.6
                  ],
                  [
                    65298.9,
                    52836.4
                  ],
                  [
                    65432.3,
                    52836.8
                  ],
                  [
                    65827.6,
                    52841.4
                  ],
                  [
                    66209.3,
                    52832.5
                  ],
                  [
                    66352.5,
                    52833.8
                  ],
                  [
                    66494,
                    52798.5
                  ],
                  [
                    66562.7,
                    52918.8
                  ],
                  [
                    66506.3,
                    53036.9
                  ],
                  [
                    66452.3,
                    53064.9
                  ],
                  [
                    66434.1,
                    53147.2
                  ],
                  [
                    66434.4,
                    53221
                  ],
                  [
                    66443.9,
                    53281.1
                  ],
                  [
                    66518.9,
                    53389.5
                  ],
                  [
                    66511.9,
                    53507.1
                  ],
                  [
                    66475.1,
                    53563.7
                  ],
                  [
                    66314.4,
                    53572.8
                  ],
                  [
                    66069.8,
                    53570.4
                  ],
                  [
                    65767.5,
                    53571.3
                  ],
                  [
                    65278.5,
                    53564.4
                  ],
                  [
                    65179,
                    53564.2
                  ],
                  [
                    65062.3,
                    53564.6
                  ],
                  [
                    64948.8,
                    53460.2
                  ],
                  [
                    64918.8,
                    53418.2
                  ],
                  [
                    64835.4,
                    53387.2
                  ],
                  [
                    64757.2,
                    53283.2
                  ],
                  [
                    64764.8,
                    53205.8
                  ],
                  [
                    64773.7,
                    53148.9
                  ],
                  [
                    64799.9,
                    53005.3
                  ]
                ],
                "id": 1545,
                "chat_link": "[&BAkGAAA=]"
              },
              "1552": {
                "name": "Dzasha Uplands",
                "level": 80,
                "coord": [
                  67895.3,
                  52896
                ],
                "bounds": [
                  [
                    67233.4,
                    52481.6
                  ],
                  [
                    67288.3,
                    52455.9
                  ],
                  [
                    67398.8,
                    52391.2
                  ],
                  [
                    67620.9,
                    52405.8
                  ],
                  [
                    67938,
                    52443.6
                  ],
                  [
                    68225.5,
                    52587.9
                  ],
                  [
                    68268.1,
                    52854.3
                  ],
                  [
                    68342.5,
                    52982
                  ],
                  [
                    68404.4,
                    53028.7
                  ],
                  [
                    68422.8,
                    53156
                  ],
                  [
                    68428.4,
                    53333.1
                  ],
                  [
                    68385.1,
                    53458
                  ],
                  [
                    68384.3,
                    53459.3
                  ],
                  [
                    67842.5,
                    53383.8
                  ],
                  [
                    67896.8,
                    53185.3
                  ],
                  [
                    67878.4,
                    52952.6
                  ],
                  [
                    67761.5,
                    52882.7
                  ],
                  [
                    67585.4,
                    52849.9
                  ],
                  [
                    67352.7,
                    52859.5
                  ],
                  [
                    67247.9,
                    52769.2
                  ],
                  [
                    67233.4,
                    52481.6
                  ]
                ],
                "id": 1552,
                "chat_link": "[&BBAGAAA=]"
              },
              "1553": {
                "name": "Grand Court of Sebelkeh",
                "level": 80,
                "coord": [
                  67526.9,
                  53116.7
                ],
                "bounds": [
                  [
                    67250.7,
                    52771.1
                  ],
                  [
                    67359.5,
                    52840.4
                  ],
                  [
                    67590.6,
                    52810.7
                  ],
                  [
                    67755.9,
                    52839.1
                  ],
                  [
                    67877.5,
                    52949.8
                  ],
                  [
                    67894.5,
                    53180.8
                  ],
                  [
                    67847,
                    53381.7
                  ],
                  [
                    67566.8,
                    53551.1
                  ],
                  [
                    67373.8,
                    53447.5
                  ],
                  [
                    67209,
                    53490.3
                  ],
                  [
                    67071,
                    53021.1
                  ],
                  [
                    67250.7,
                    52771.1
                  ]
                ],
                "id": 1553,
                "chat_link": "[&BBEGAAA=]"
              },
              "1555": {
                "name": "Kaluun Ravine",
                "level": 80,
                "coord": [
                  65700.8,
                  55118.1
                ],
                "bounds": [
                  [
                    66086,
                    55505
                  ],
                  [
                    66083.5,
                    55410.1
                  ],
                  [
                    66128.4,
                    55283.7
                  ],
                  [
                    66111.2,
                    55052.2
                  ],
                  [
                    66082.8,
                    54826.2
                  ],
                  [
                    65946.5,
                    54727.4
                  ],
                  [
                    65501.9,
                    54888.9
                  ],
                  [
                    65365.4,
                    55017.7
                  ],
                  [
                    65237.4,
                    54949.3
                  ],
                  [
                    65072.9,
                    55125.1
                  ],
                  [
                    65093,
                    55513.4
                  ],
                  [
                    66086,
                    55505
                  ]
                ],
                "id": 1555,
                "chat_link": "[&BBMGAAA=]"
              },
              "1556": {
                "name": "Forum Highlands",
                "level": 80,
                "coord": [
                  65526,
                  54462.2
                ],
                "bounds": [
                  [
                    65843.6,
                    54285.6
                  ],
                  [
                    65971.1,
                    54277.7
                  ],
                  [
                    65985.7,
                    54440.2
                  ],
                  [
                    65921.4,
                    54519
                  ],
                  [
                    65945.4,
                    54725.9
                  ],
                  [
                    65501.8,
                    54889.7
                  ],
                  [
                    65365.2,
                    55016.6
                  ],
                  [
                    65238.4,
                    54950.6
                  ],
                  [
                    65224.1,
                    54815.4
                  ],
                  [
                    65221.1,
                    54633.2
                  ],
                  [
                    65084.1,
                    54535.8
                  ],
                  [
                    65097.2,
                    54270.2
                  ],
                  [
                    65264.4,
                    54266.8
                  ],
                  [
                    65314.5,
                    54201.3
                  ],
                  [
                    65369.8,
                    54154.5
                  ],
                  [
                    65512.2,
                    54124.2
                  ],
                  [
                    65607,
                    54167.5
                  ],
                  [
                    65712.6,
                    54248.8
                  ],
                  [
                    65814,
                    54259
                  ],
                  [
                    65843.6,
                    54285.6
                  ]
                ],
                "id": 1556,
                "chat_link": "[&BBQGAAA=]"
              },
              "1566": {
                "name": "Jennur's Run",
                "level": 80,
                "coord": [
                  64765,
                  53756.9
                ],
                "bounds": [
                  [
                    64635,
                    52976.9
                  ],
                  [
                    64470.4,
                    52956.5
                  ],
                  [
                    64420.4,
                    53172
                  ],
                  [
                    64463.5,
                    53389.9
                  ],
                  [
                    64507.9,
                    53493.8
                  ],
                  [
                    64603.1,
                    53667.3
                  ],
                  [
                    64395.6,
                    53815.8
                  ],
                  [
                    64413,
                    53874.1
                  ],
                  [
                    64411.6,
                    54035.6
                  ],
                  [
                    64549.4,
                    54233.9
                  ],
                  [
                    64625.6,
                    54283.4
                  ],
                  [
                    64651.7,
                    54347.2
                  ],
                  [
                    64836.2,
                    54450.4
                  ],
                  [
                    64975.4,
                    54426.9
                  ],
                  [
                    65090.6,
                    54419.8
                  ],
                  [
                    65096.4,
                    54270.8
                  ],
                  [
                    65011.5,
                    54159.9
                  ],
                  [
                    64975.1,
                    54014.7
                  ],
                  [
                    65006.6,
                    53894.8
                  ],
                  [
                    65080.3,
                    53818
                  ],
                  [
                    65115.6,
                    53625.7
                  ],
                  [
                    65061.4,
                    53564.8
                  ],
                  [
                    64948.6,
                    53461
                  ],
                  [
                    64918.3,
                    53420
                  ],
                  [
                    64834.8,
                    53383.3
                  ],
                  [
                    64756.4,
                    53284.1
                  ],
                  [
                    64799.5,
                    52994.9
                  ],
                  [
                    64635,
                    52976.9
                  ]
                ],
                "id": 1566,
                "chat_link": "[&BB4GAAA=]"
              },
              "1569": {
                "name": "Vehjin Palace",
                "level": 80,
                "coord": [
                  64164.8,
                  53448.2
                ],
                "bounds": [
                  [
                    63677.4,
                    53027
                  ],
                  [
                    63658.8,
                    53591.4
                  ],
                  [
                    63778,
                    53574.2
                  ],
                  [
                    63888.2,
                    53592.8
                  ],
                  [
                    64007.6,
                    53632.3
                  ],
                  [
                    64069.1,
                    53690.5
                  ],
                  [
                    64113.7,
                    53771.8
                  ],
                  [
                    64292.2,
                    53836.5
                  ],
                  [
                    64353.9,
                    53835.1
                  ],
                  [
                    64395.7,
                    53814.9
                  ],
                  [
                    64602.9,
                    53667.4
                  ],
                  [
                    64506.8,
                    53491
                  ],
                  [
                    64462.9,
                    53389
                  ],
                  [
                    64420.2,
                    53168.9
                  ],
                  [
                    64470.5,
                    52955.7
                  ],
                  [
                    64252.1,
                    52968.8
                  ],
                  [
                    64072.8,
                    53000.2
                  ],
                  [
                    63944.5,
                    53059.3
                  ],
                  [
                    63677.4,
                    53027
                  ]
                ],
                "id": 1569,
                "chat_link": "[&BCEGAAA=]"
              },
              "1571": {
                "name": "Kodash Bazaar",
                "level": 80,
                "coord": [
                  66635.8,
                  53948
                ],
                "bounds": [
                  [
                    65996.8,
                    53781.3
                  ],
                  [
                    65949.6,
                    53806.8
                  ],
                  [
                    65826.6,
                    53875.5
                  ],
                  [
                    65833.1,
                    54113.9
                  ],
                  [
                    65814.3,
                    54257
                  ],
                  [
                    65843.3,
                    54285.3
                  ],
                  [
                    66054.3,
                    54274.8
                  ],
                  [
                    66355.4,
                    54265.4
                  ],
                  [
                    66498.2,
                    54504.8
                  ],
                  [
                    66494,
                    54629.1
                  ],
                  [
                    66712.4,
                    54696.6
                  ],
                  [
                    66978.2,
                    54688.8
                  ],
                  [
                    67226.6,
                    54626
                  ],
                  [
                    67249.8,
                    54364
                  ],
                  [
                    67283.3,
                    54305.5
                  ],
                  [
                    67693.5,
                    54298.3
                  ],
                  [
                    67697.5,
                    54033.4
                  ],
                  [
                    67537.1,
                    54003.9
                  ],
                  [
                    67417.7,
                    53899
                  ],
                  [
                    67324.8,
                    53842.9
                  ],
                  [
                    67210.9,
                    53823.1
                  ],
                  [
                    67054,
                    53795
                  ],
                  [
                    67014.1,
                    53615.1
                  ],
                  [
                    66895.9,
                    53578.3
                  ],
                  [
                    66905.8,
                    53483
                  ],
                  [
                    66778,
                    53413.8
                  ],
                  [
                    66687.5,
                    53395.7
                  ],
                  [
                    66518.6,
                    53388
                  ],
                  [
                    66507.8,
                    53500.1
                  ],
                  [
                    66473.1,
                    53565.3
                  ],
                  [
                    66334.8,
                    53561.9
                  ],
                  [
                    66309.8,
                    53647.8
                  ],
                  [
                    66334.3,
                    53697.6
                  ],
                  [
                    66401.2,
                    53741.3
                  ],
                  [
                    66396.2,
                    53774
                  ],
                  [
                    66302,
                    53811
                  ],
                  [
                    66152.8,
                    53852.6
                  ],
                  [
                    66097,
                    53828.4
                  ],
                  [
                    65996.8,
                    53781.3
                  ]
                ],
                "id": 1571,
                "chat_link": "[&BCMGAAA=]"
              },
              "1572": {
                "name": "Dehwan Expanse",
                "level": 80,
                "coord": [
                  66752,
                  52998
                ],
                "bounds": [
                  [
                    66894.7,
                    53579.3
                  ],
                  [
                    66905.6,
                    53483.1
                  ],
                  [
                    66777.9,
                    53413.8
                  ],
                  [
                    66688.1,
                    53396.4
                  ],
                  [
                    66518.6,
                    53389.1
                  ],
                  [
                    66435.3,
                    53221.9
                  ],
                  [
                    66435.6,
                    53142
                  ],
                  [
                    66458,
                    53061.3
                  ],
                  [
                    66497.5,
                    53042.4
                  ],
                  [
                    66568.4,
                    52915.8
                  ],
                  [
                    66492.8,
                    52797.5
                  ],
                  [
                    66496,
                    52770.6
                  ],
                  [
                    66429.1,
                    52658.8
                  ],
                  [
                    66400.5,
                    52541.2
                  ],
                  [
                    66398,
                    52395.1
                  ],
                  [
                    66696.9,
                    52383.1
                  ],
                  [
                    66916.8,
                    52427.2
                  ],
                  [
                    67105.1,
                    52435.1
                  ],
                  [
                    67233.4,
                    52481.6
                  ],
                  [
                    67247.8,
                    52773
                  ],
                  [
                    67069.6,
                    53023.9
                  ],
                  [
                    67208.3,
                    53491.7
                  ],
                  [
                    67159.5,
                    53515.3
                  ],
                  [
                    67015,
                    53613
                  ],
                  [
                    66894.7,
                    53579.3
                  ]
                ],
                "id": 1572,
                "chat_link": "[&BCQGAAA=]"
              },
              "1576": {
                "name": "Cragged Vale",
                "level": 80,
                "coord": [
                  64024.7,
                  52819.3
                ],
                "bounds": [
                  [
                    63669.7,
                    52660.9
                  ],
                  [
                    63676.7,
                    53026.7
                  ],
                  [
                    63943.9,
                    53059.1
                  ],
                  [
                    64073.1,
                    53000.5
                  ],
                  [
                    64252.6,
                    52969.1
                  ],
                  [
                    64470.3,
                    52954.8
                  ],
                  [
                    64368.7,
                    52593.7
                  ],
                  [
                    63942.8,
                    52546.1
                  ],
                  [
                    63824.7,
                    52562.5
                  ],
                  [
                    63669.7,
                    52660.9
                  ]
                ],
                "id": 1576,
                "chat_link": "[&BCgGAAA=]"
              },
              "1583": {
                "name": "The Necropolis",
                "level": 80,
                "coord": [
                  64737.6,
                  54825.9
                ],
                "bounds": [
                  [
                    64307.7,
                    55138.9
                  ],
                  [
                    64234.5,
                    55270.3
                  ],
                  [
                    64219,
                    55518.8
                  ],
                  [
                    65091.9,
                    55514
                  ],
                  [
                    65072.9,
                    55125.3
                  ],
                  [
                    65238,
                    54948.9
                  ],
                  [
                    65223,
                    54814.1
                  ],
                  [
                    65221.1,
                    54631.2
                  ],
                  [
                    65084.6,
                    54535.8
                  ],
                  [
                    65091.2,
                    54418.9
                  ],
                  [
                    64973.5,
                    54425.4
                  ],
                  [
                    64836.2,
                    54450
                  ],
                  [
                    64650.2,
                    54345.5
                  ],
                  [
                    64557,
                    54503.2
                  ],
                  [
                    64582.2,
                    54634.7
                  ],
                  [
                    64344.8,
                    54762.4
                  ],
                  [
                    64306.2,
                    54838.7
                  ],
                  [
                    64241.8,
                    54990.4
                  ],
                  [
                    64307.7,
                    55138.9
                  ]
                ],
                "id": 1583,
                "chat_link": "[&BC8GAAA=]"
              },
              "1586": {
                "name": "Vehtendi Academy",
                "level": 80,
                "coord": [
                  66549,
                  55008.7
                ],
                "bounds": [
                  [
                    67130.6,
                    55516.6
                  ],
                  [
                    67163.3,
                    55389.7
                  ],
                  [
                    66982.9,
                    54967.6
                  ],
                  [
                    66886.5,
                    54879.7
                  ],
                  [
                    66804.3,
                    54771.6
                  ],
                  [
                    66783.7,
                    54695
                  ],
                  [
                    66712.8,
                    54696.7
                  ],
                  [
                    66494.9,
                    54630.7
                  ],
                  [
                    66457.5,
                    54721.6
                  ],
                  [
                    66322.1,
                    54787.4
                  ],
                  [
                    66081.4,
                    54826.7
                  ],
                  [
                    66114.1,
                    55052
                  ],
                  [
                    66131.9,
                    55281.8
                  ],
                  [
                    66083.3,
                    55408.6
                  ],
                  [
                    66086.3,
                    55505.1
                  ],
                  [
                    67130.6,
                    55516.6
                  ]
                ],
                "id": 1586,
                "chat_link": "[&BDIGAAA=]"
              },
              "1592": {
                "name": "Glowering Overlook",
                "level": 80,
                "coord": [
                  64011.4,
                  54986.9
                ],
                "bounds": [
                  [
                    64219.2,
                    55519.5
                  ],
                  [
                    63959,
                    55508.2
                  ],
                  [
                    63831.3,
                    55411.7
                  ],
                  [
                    63727,
                    55246
                  ],
                  [
                    63682,
                    55106.7
                  ],
                  [
                    63689.3,
                    54749.4
                  ],
                  [
                    63732,
                    54605
                  ],
                  [
                    63838.1,
                    54625.8
                  ],
                  [
                    63926.3,
                    54632.2
                  ],
                  [
                    64127.7,
                    54627.9
                  ],
                  [
                    64309.9,
                    54608.6
                  ],
                  [
                    64343.4,
                    54762.9
                  ],
                  [
                    64242.1,
                    54990.7
                  ],
                  [
                    64307.2,
                    55140.2
                  ],
                  [
                    64235.8,
                    55269
                  ],
                  [
                    64219.2,
                    55519.5
                  ]
                ],
                "id": 1592,
                "chat_link": "[&BDgGAAA=]"
              },
              "1595": {
                "name": "Zagonur Cliffs",
                "level": 80,
                "coord": [
                  67892.7,
                  53962.3
                ],
                "bounds": [
                  [
                    68450.2,
                    54220.1
                  ],
                  [
                    68451.7,
                    54368.8
                  ],
                  [
                    68443.8,
                    54505.4
                  ],
                  [
                    68412.2,
                    54602.9
                  ],
                  [
                    68319.2,
                    54555.4
                  ],
                  [
                    68125.5,
                    54610.6
                  ],
                  [
                    67944.8,
                    54560
                  ],
                  [
                    67912.6,
                    54360.6
                  ],
                  [
                    67695.4,
                    54297.8
                  ],
                  [
                    67696.7,
                    54035.4
                  ],
                  [
                    67536,
                    54002.8
                  ],
                  [
                    67418.2,
                    53899.7
                  ],
                  [
                    67324.9,
                    53842.8
                  ],
                  [
                    67210.5,
                    53823.4
                  ],
                  [
                    67055.5,
                    53796.1
                  ],
                  [
                    67013,
                    53612.8
                  ],
                  [
                    67159.5,
                    53515.6
                  ],
                  [
                    67209.9,
                    53492.3
                  ],
                  [
                    67374.1,
                    53448.4
                  ],
                  [
                    67566.9,
                    53552.6
                  ],
                  [
                    67845.2,
                    53384.8
                  ],
                  [
                    68385.1,
                    53458
                  ],
                  [
                    68400,
                    53537.4
                  ],
                  [
                    68400.8,
                    53671.4
                  ],
                  [
                    68391.9,
                    53809
                  ],
                  [
                    68384.5,
                    53920.2
                  ],
                  [
                    68424.6,
                    53968.4
                  ],
                  [
                    68442.3,
                    54092.7
                  ],
                  [
                    68450.2,
                    54220.1
                  ]
                ],
                "id": 1595,
                "chat_link": "[&BDsGAAA=]"
              }
            },
            "adventures": [],
            "id": 1255,
            "mastery_points": []
          },
          "1257": {
            "name": "Spearmarshal's Lament",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              66016,
              53702
            ],
            "map_rect": [
              [
                -58368,
                -36864
              ],
              [
                58368,
                39936
              ]
            ],
            "continent_rect": [
              [
                63616,
                52352
              ],
              [
                68480,
                55552
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1257,
            "mastery_points": []
          },
          "1260": {
            "name": "Eye of the Brandstorm",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              59968,
              43534
            ],
            "map_rect": [
              [
                -30720,
                -21504
              ],
              [
                30720,
                21504
              ]
            ],
            "continent_rect": [
              [
                57768,
                43069
              ],
              [
                60328,
                44861
              ]
            ],
            "points_of_interest": {
              "2552": {
                "name": "Sanctum of Nabkha",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60243.6,
                  44872.6
                ],
                "id": 2552,
                "chat_link": "[&BPgJAAA=]"
              },
              "2564": {
                "name": "Marifa Refugee Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58466.2,
                  44521.4
                ],
                "id": 2564,
                "chat_link": "[&BAQKAAA=]"
              },
              "2580": {
                "name": "Altar of the Six Gods",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57357.8,
                  44396.9
                ],
                "id": 2580,
                "chat_link": "[&BBQKAAA=]"
              },
              "2584": {
                "name": "Squaross Kraal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61419.8,
                  44070.3
                ],
                "id": 2584,
                "chat_link": "[&BBgKAAA=]"
              },
              "2591": {
                "name": "Amnoon Water Authority",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57948.4,
                  44841.4
                ],
                "id": 2591,
                "chat_link": "[&BB8KAAA=]"
              },
              "2592": {
                "name": "Old Amnoon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56766.8,
                  44129.4
                ],
                "id": 2592,
                "chat_link": "[&BCAKAAA=]"
              },
              "2593": {
                "name": "Tomb of the Abandoned",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57295.4,
                  43131
                ],
                "id": 2593,
                "chat_link": "[&BCEKAAA=]"
              },
              "2598": {
                "name": "The Teratohedron",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61090.9,
                  43232.2
                ],
                "id": 2598,
                "chat_link": "[&BCYKAAA=]"
              },
              "2599": {
                "name": "Tawla Rock",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56847.6,
                  43545.3
                ],
                "id": 2599,
                "chat_link": "[&BCcKAAA=]"
              },
              "2610": {
                "name": "Kusini Water Hole",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59644.3,
                  44574.9
                ],
                "id": 2610,
                "chat_link": "[&BDIKAAA=]"
              },
              "2616": {
                "name": "Temple of Atar",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59096.6,
                  42907.5
                ],
                "id": 2616,
                "chat_link": "[&BDgKAAA=]"
              },
              "2629": {
                "name": "Fortunate Strike",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  61321.9,
                  44333.2
                ],
                "id": 2629,
                "chat_link": "[&BEUKAAA=]"
              },
              "2630": {
                "name": "Seeker's Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57717.6,
                  43361.6
                ],
                "id": 2630,
                "chat_link": "[&BEYKAAA=]"
              },
              "2631": {
                "name": "Grand Sahil Casino",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57615.5,
                  44420.7
                ],
                "id": 2631,
                "chat_link": "[&BEcKAAA=]"
              },
              "2641": {
                "name": "Zephyr's Trace",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60816.8,
                  44409.3
                ],
                "id": 2641,
                "chat_link": "[&BFEKAAA=]"
              },
              "2651": {
                "name": "Altar of Silence",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59466.1,
                  43046.2
                ],
                "id": 2651,
                "chat_link": "[&BFsKAAA=]"
              },
              "2652": {
                "name": "Shattered Templar",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58722.8,
                  43579.1
                ],
                "id": 2652,
                "chat_link": "[&BFwKAAA=]"
              },
              "2656": {
                "name": "Crucible of Consecration",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60804.9,
                  43804.5
                ],
                "id": 2656,
                "chat_link": "[&BGAKAAA=]"
              },
              "2677": {
                "name": "Temple of Kormir",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60193.8,
                  43749.5
                ],
                "id": 2677,
                "chat_link": "[&BHUKAAA=]"
              },
              "2684": {
                "name": "Amnoon Cavalier Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57929.4,
                  44231.5
                ],
                "id": 2684,
                "chat_link": "[&BHwKAAA=]"
              },
              "2688": {
                "name": "Amnoon Civic Center",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57501,
                  44009.3
                ],
                "id": 2688,
                "chat_link": "[&BIAKAAA=]"
              },
              "2708": {
                "name": "Northern Way Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59350,
                  43602.6
                ],
                "id": 2708,
                "chat_link": "[&BJQKAAA=]"
              },
              "2711": {
                "name": "Amnoon Harbor",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57396.4,
                  44136.5
                ],
                "id": 2711,
                "chat_link": "[&BJcKAAA=]"
              },
              "2732": {
                "name": "Southern Way Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59647.1,
                  44390.7
                ],
                "id": 2732,
                "chat_link": "[&BKwKAAA=]"
              },
              "2742": {
                "name": "The Empty Quarter",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57450.6,
                  43675.3
                ],
                "id": 2742,
                "chat_link": "[&BLYKAAA=]"
              },
              "2751": {
                "name": "Amnoon Bazaar",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58221.6,
                  44132.8
                ],
                "id": 2751,
                "chat_link": "[&BL8KAAA=]"
              },
              "2784": {
                "name": "Amnoon Emporium",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57610.9,
                  44121.1
                ],
                "id": 2784,
                "chat_link": "[&BOAKAAA=]"
              },
              "2787": {
                "name": "Retreat of the Resolute",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  59350.6,
                  44138
                ],
                "id": 2787,
                "chat_link": "[&BOMKAAA=]"
              },
              "2789": {
                "name": "Village of Kweli",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  60180.4,
                  43386.6
                ],
                "id": 2789,
                "chat_link": "[&BOUKAAA=]"
              },
              "2793": {
                "name": "Talatat Quarry",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58136.3,
                  42986.9
                ],
                "id": 2793,
                "chat_link": "[&BOkKAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1933": {
                "name": "Amnoon Farms",
                "level": 80,
                "coord": [
                  59395.9,
                  43850.7
                ],
                "bounds": [
                  [
                    58843.8,
                    43981
                  ],
                  [
                    58959.5,
                    44059.6
                  ],
                  [
                    58978.4,
                    44136.6
                  ],
                  [
                    58939.5,
                    44187.5
                  ],
                  [
                    58871.2,
                    44269.3
                  ],
                  [
                    58998.5,
                    44302
                  ],
                  [
                    59182.4,
                    44299.5
                  ],
                  [
                    59308.9,
                    44388.2
                  ],
                  [
                    59704.1,
                    44401.6
                  ],
                  [
                    59902.2,
                    44314.5
                  ],
                  [
                    59971.2,
                    44218.2
                  ],
                  [
                    60059.4,
                    44117.3
                  ],
                  [
                    59997.6,
                    43901.7
                  ],
                  [
                    59926.4,
                    43852.2
                  ],
                  [
                    59898.8,
                    43746.8
                  ],
                  [
                    59789.6,
                    43711.4
                  ],
                  [
                    59633.5,
                    43660.7
                  ],
                  [
                    59541.3,
                    43608.7
                  ],
                  [
                    59482.2,
                    43490.7
                  ],
                  [
                    59381.6,
                    43421.8
                  ],
                  [
                    59311.3,
                    43347.8
                  ],
                  [
                    59296.1,
                    43234.6
                  ],
                  [
                    59083.5,
                    43118
                  ],
                  [
                    58979.2,
                    43187
                  ],
                  [
                    58857.2,
                    43309.6
                  ],
                  [
                    58843.8,
                    43981
                  ]
                ],
                "id": 1933,
                "chat_link": "[&BI0HAAA=]"
              }
            },
            "adventures": [],
            "id": 1260,
            "mastery_points": []
          },
          "1265": {
            "name": "The Hero of Istan",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              57168,
              61884
            ],
            "map_rect": [
              [
                -46080,
                -46080
              ],
              [
                46080,
                46080
              ]
            ],
            "continent_rect": [
              [
                55318,
                59916
              ],
              [
                59158,
                63756
              ]
            ],
            "points_of_interest": {
              "2805": {
                "name": "Freetrader Haven",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56656.7,
                  60479.4
                ],
                "id": 2805,
                "chat_link": "[&BPUKAAA=]"
              },
              "2806": {
                "name": "The Dark Leviathan",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56815.3,
                  60377.6
                ],
                "id": 2806,
                "chat_link": "[&BPYKAAA=]"
              },
              "2807": {
                "name": "Temple of Joko",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57756.5,
                  61962.9
                ],
                "id": 2807,
                "chat_link": "[&BPcKAAA=]"
              },
              "2808": {
                "name": "Mirror of the Sun",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55773.8,
                  61325.7
                ],
                "id": 2808,
                "chat_link": "[&BPgKAAA=]"
              },
              "2809": {
                "name": "Ancient Royal Docks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57317.2,
                  62471.4
                ],
                "id": 2809,
                "chat_link": "[&BPkKAAA=]"
              },
              "2811": {
                "name": "Mirror of the Earth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55635.6,
                  61060.1
                ],
                "id": 2811,
                "chat_link": "[&BPsKAAA=]"
              },
              "2812": {
                "name": "The Sun Docks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58421.2,
                  61959.3
                ],
                "id": 2812,
                "chat_link": "[&BPwKAAA=]"
              },
              "2814": {
                "name": "Broken Observation Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55891.3,
                  60419
                ],
                "id": 2814,
                "chat_link": "[&BP4KAAA=]"
              },
              "2815": {
                "name": "Stage of Sacrifice",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57894.9,
                  62189.5
                ],
                "id": 2815,
                "chat_link": "[&BP8KAAA=]"
              },
              "2816": {
                "name": "Skylight Vault",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57427.3,
                  60931
                ],
                "id": 2816,
                "chat_link": "[&BAALAAA=]"
              },
              "2817": {
                "name": "Crucible of the Apostate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58268.6,
                  61451.1
                ],
                "id": 2817,
                "chat_link": "[&BAELAAA=]"
              },
              "2818": {
                "name": "Zehlon Waterworks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55911.9,
                  61913.9
                ],
                "id": 2818,
                "chat_link": "[&BAILAAA=]"
              },
              "2819": {
                "name": "Grotto of the Defeated",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56168.9,
                  62847.9
                ],
                "id": 2819,
                "chat_link": "[&BAMLAAA=]"
              },
              "2821": {
                "name": "Clanmarshal's Promenade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57905.7,
                  61774.3
                ],
                "id": 2821,
                "chat_link": "[&BAULAAA=]"
              },
              "2823": {
                "name": "Plaza of Resurgence",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57026.3,
                  61453.7
                ],
                "id": 2823,
                "chat_link": "[&BAcLAAA=]"
              },
              "2824": {
                "name": "Jakumba's Legacy",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55948.2,
                  61578.3
                ],
                "id": 2824,
                "chat_link": "[&BAgLAAA=]"
              },
              "2827": {
                "name": "The Wobbling Skies",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56589.3,
                  60713.3
                ],
                "id": 2827,
                "chat_link": "[&BAsLAAA=]"
              },
              "2830": {
                "name": "Palawadan Dormitories",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58093.4,
                  62187.9
                ],
                "id": 2830,
                "chat_link": "[&BA4LAAA=]"
              },
              "2831": {
                "name": "Mirror of the Moon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56293.6,
                  60725.3
                ],
                "id": 2831,
                "chat_link": "[&BA8LAAA=]"
              },
              "2833": {
                "name": "The Skimming Stone",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56955.8,
                  60677.4
                ],
                "id": 2833,
                "chat_link": "[&BBELAAA=]"
              },
              "2835": {
                "name": "Mirror of the Stars",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55947.8,
                  61199.7
                ],
                "id": 2835,
                "chat_link": "[&BBMLAAA=]"
              },
              "2837": {
                "name": "Mehtani's Blade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56869.8,
                  62946.1
                ],
                "id": 2837,
                "chat_link": "[&BBULAAA=]"
              },
              "2838": {
                "name": "Chahbek Thrust",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57844.4,
                  62588.7
                ],
                "id": 2838,
                "chat_link": "[&BBYLAAA=]"
              },
              "2839": {
                "name": "Lahdok Craterlands",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56624.7,
                  61389.5
                ],
                "id": 2839,
                "chat_link": "[&BBcLAAA=]"
              },
              "2840": {
                "name": "Hall of Judgment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58097.2,
                  61964.4
                ],
                "id": 2840,
                "chat_link": "[&BBgLAAA=]"
              },
              "2843": {
                "name": "Field of the Hopeful",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56556.1,
                  62582.7
                ],
                "id": 2843,
                "chat_link": "[&BBsLAAA=]"
              },
              "2846": {
                "name": "Warden's Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57025.9,
                  61285.5
                ],
                "id": 2846,
                "chat_link": "[&BB4LAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1598": {
                "name": "Churrhir Cliffs",
                "level": 80,
                "coord": [
                  57206.2,
                  62296.3
                ],
                "bounds": [
                  [
                    56449.5,
                    61979
                  ],
                  [
                    56605.9,
                    62015.8
                  ],
                  [
                    56740.8,
                    61959
                  ],
                  [
                    56815,
                    62081.9
                  ],
                  [
                    56788.2,
                    62143.1
                  ],
                  [
                    56807.5,
                    62282
                  ],
                  [
                    56897,
                    62374.4
                  ],
                  [
                    57239.4,
                    62437.5
                  ],
                  [
                    57191.7,
                    62837.5
                  ],
                  [
                    57293,
                    62921.8
                  ],
                  [
                    58048.3,
                    63240
                  ],
                  [
                    58304.3,
                    63191.9
                  ],
                  [
                    58296,
                    62383.3
                  ],
                  [
                    57633.5,
                    62339.1
                  ],
                  [
                    57434.5,
                    62213.9
                  ],
                  [
                    57331.8,
                    62067.6
                  ],
                  [
                    57343.5,
                    61710
                  ],
                  [
                    57157.5,
                    61707
                  ],
                  [
                    56540.2,
                    61745.5
                  ],
                  [
                    56449.5,
                    61979
                  ]
                ],
                "id": 1598,
                "chat_link": "[&BD4GAAA=]"
              },
              "1602": {
                "name": "Zehlon Breach",
                "level": 80,
                "coord": [
                  55987.2,
                  61792.9
                ],
                "bounds": [
                  [
                    55559.2,
                    61580.8
                  ],
                  [
                    56125,
                    61438.6
                  ],
                  [
                    56223.7,
                    61565.3
                  ],
                  [
                    56346.8,
                    61681.7
                  ],
                  [
                    56373.6,
                    61764.4
                  ],
                  [
                    56328.1,
                    61885.2
                  ],
                  [
                    55647,
                    62357.3
                  ],
                  [
                    55621.1,
                    62070.1
                  ],
                  [
                    55660.3,
                    61792.6
                  ],
                  [
                    55559.2,
                    61580.8
                  ]
                ],
                "id": 1602,
                "chat_link": "[&BEIGAAA=]"
              },
              "1604": {
                "name": "The Astralarium",
                "level": 80,
                "coord": [
                  56015.7,
                  60830.4
                ],
                "bounds": [
                  [
                    55644.3,
                    60333.6
                  ],
                  [
                    55851.9,
                    60247.9
                  ],
                  [
                    55988.3,
                    60355.5
                  ],
                  [
                    56093.6,
                    60390.9
                  ],
                  [
                    56199,
                    60478.3
                  ],
                  [
                    56136.3,
                    60522.5
                  ],
                  [
                    56335.5,
                    60611.8
                  ],
                  [
                    56462.1,
                    60590.6
                  ],
                  [
                    56441.4,
                    60770.5
                  ],
                  [
                    56261.3,
                    60833.7
                  ],
                  [
                    56257.2,
                    60932.5
                  ],
                  [
                    56368.9,
                    61005.3
                  ],
                  [
                    56147,
                    61082
                  ],
                  [
                    56098.8,
                    61318.8
                  ],
                  [
                    56125,
                    61438.6
                  ],
                  [
                    55559.2,
                    61580.8
                  ],
                  [
                    55478.5,
                    61384.1
                  ],
                  [
                    55398.8,
                    61104.6
                  ],
                  [
                    55450.7,
                    60794.8
                  ],
                  [
                    55644.3,
                    60333.6
                  ]
                ],
                "id": 1604,
                "chat_link": "[&BEQGAAA=]"
              },
              "1605": {
                "name": "Corsair Flotilla",
                "level": 80,
                "coord": [
                  56451.7,
                  60569.7
                ],
                "bounds": [
                  [
                    55761.3,
                    60152.1
                  ],
                  [
                    55742.6,
                    60295.2
                  ],
                  [
                    55851.9,
                    60247.9
                  ],
                  [
                    55988.3,
                    60355.5
                  ],
                  [
                    56093.6,
                    60390.9
                  ],
                  [
                    56199,
                    60478.3
                  ],
                  [
                    56136.3,
                    60522.5
                  ],
                  [
                    56335.5,
                    60611.8
                  ],
                  [
                    56462.1,
                    60590.6
                  ],
                  [
                    56441.4,
                    60770.5
                  ],
                  [
                    56261.3,
                    60833.7
                  ],
                  [
                    56257.2,
                    60932.5
                  ],
                  [
                    56368.9,
                    61005.3
                  ],
                  [
                    56660.1,
                    60943.5
                  ],
                  [
                    56874.6,
                    60875
                  ],
                  [
                    57026.2,
                    60852.4
                  ],
                  [
                    57128.8,
                    60773.4
                  ],
                  [
                    57354.3,
                    60596.3
                  ],
                  [
                    57355.8,
                    60112.5
                  ],
                  [
                    56734.4,
                    60054.7
                  ],
                  [
                    55761.3,
                    60152.1
                  ]
                ],
                "id": 1605,
                "chat_link": "[&BEUGAAA=]"
              },
              "1606": {
                "name": "Chalon Docks",
                "level": 80,
                "coord": [
                  57869.2,
                  61062.8
                ],
                "bounds": [
                  [
                    57685.2,
                    60686.3
                  ],
                  [
                    58056.3,
                    60837.8
                  ],
                  [
                    58182,
                    61124.2
                  ],
                  [
                    58027.8,
                    61343.6
                  ],
                  [
                    57821.5,
                    61382.6
                  ],
                  [
                    57695.1,
                    61231.3
                  ],
                  [
                    57719.5,
                    61051.9
                  ],
                  [
                    57766.2,
                    60844.4
                  ],
                  [
                    57685.2,
                    60686.3
                  ]
                ],
                "id": 1606,
                "chat_link": "[&BEYGAAA=]"
              },
              "1609": {
                "name": "Mordant Crescent<br>Great Hall",
                "level": 80,
                "coord": [
                  57041.2,
                  61332.1
                ],
                "bounds": [
                  [
                    56846.8,
                    61456.3
                  ],
                  [
                    56841.3,
                    61203.3
                  ],
                  [
                    56916.6,
                    61113.9
                  ],
                  [
                    57159.5,
                    61112.9
                  ],
                  [
                    57242.1,
                    61206.1
                  ],
                  [
                    57237.5,
                    61443.3
                  ],
                  [
                    57147.9,
                    61563
                  ],
                  [
                    56938.1,
                    61558
                  ],
                  [
                    56846.8,
                    61456.3
                  ]
                ],
                "id": 1609,
                "chat_link": "[&BEkGAAA=]"
              },
              "1610": {
                "name": "Heretic's Arena",
                "level": 80,
                "coord": [
                  58240.1,
                  61410.8
                ],
                "bounds": [
                  [
                    58463.4,
                    61209.9
                  ],
                  [
                    58579,
                    61394.8
                  ],
                  [
                    58561.2,
                    61657.4
                  ],
                  [
                    58265.9,
                    61626.8
                  ],
                  [
                    58020.1,
                    61547.3
                  ],
                  [
                    57821.5,
                    61382.6
                  ],
                  [
                    58027.8,
                    61343.6
                  ],
                  [
                    58182,
                    61124.2
                  ],
                  [
                    58463.4,
                    61209.9
                  ]
                ],
                "id": 1610,
                "chat_link": "[&BEoGAAA=]"
              },
              "1614": {
                "name": "Champion's Dawn",
                "level": 80,
                "coord": [
                  56394.7,
                  62511.4
                ],
                "bounds": [
                  [
                    55647,
                    62357.3
                  ],
                  [
                    56328.1,
                    61885.2
                  ],
                  [
                    56333.2,
                    61972.5
                  ],
                  [
                    56549.7,
                    62088.1
                  ],
                  [
                    56637.5,
                    62235.8
                  ],
                  [
                    56644.4,
                    62329
                  ],
                  [
                    56709,
                    62358.5
                  ],
                  [
                    56781.3,
                    62616.5
                  ],
                  [
                    56639.5,
                    62802.9
                  ],
                  [
                    56499.5,
                    62739.8
                  ],
                  [
                    56417.6,
                    62788.3
                  ],
                  [
                    56423.4,
                    62927.6
                  ],
                  [
                    56345.4,
                    63143.8
                  ],
                  [
                    56114.3,
                    62837.7
                  ],
                  [
                    55851.2,
                    62588.1
                  ],
                  [
                    55647,
                    62357.3
                  ]
                ],
                "id": 1614,
                "chat_link": "[&BE4GAAA=]"
              },
              "1615": {
                "name": "Modri Caverns",
                "level": 80,
                "coord": [
                  57462.9,
                  60832.7
                ],
                "bounds": [
                  [
                    57026.2,
                    60852.4
                  ],
                  [
                    57354.3,
                    60596.3
                  ],
                  [
                    57624.9,
                    60640.3
                  ],
                  [
                    57685.2,
                    60686.3
                  ],
                  [
                    57766.2,
                    60844.4
                  ],
                  [
                    57719.5,
                    61051.9
                  ],
                  [
                    57479,
                    61025.2
                  ],
                  [
                    57331,
                    60970.8
                  ],
                  [
                    57179.6,
                    60826.8
                  ],
                  [
                    57026.2,
                    60852.4
                  ]
                ],
                "id": 1615,
                "chat_link": "[&BE8GAAA=]"
              },
              "1616": {
                "name": "Palawadan, Jewel of Istan",
                "level": 80,
                "coord": [
                  57825.9,
                  61851.8
                ],
                "bounds": [
                  [
                    58561.2,
                    61657.4
                  ],
                  [
                    58618.7,
                    61971.4
                  ],
                  [
                    58533.6,
                    62288
                  ],
                  [
                    58296,
                    62383.3
                  ],
                  [
                    57633.5,
                    62339.1
                  ],
                  [
                    57434.5,
                    62213.9
                  ],
                  [
                    57331.8,
                    62067.6
                  ],
                  [
                    57343.5,
                    61710
                  ],
                  [
                    57157.5,
                    61707
                  ],
                  [
                    57153.7,
                    61639.2
                  ],
                  [
                    57457.2,
                    61389.4
                  ],
                  [
                    57639.5,
                    61623.9
                  ],
                  [
                    57942.3,
                    61613.5
                  ],
                  [
                    58020.1,
                    61547.3
                  ],
                  [
                    58265.9,
                    61626.8
                  ],
                  [
                    58561.2,
                    61657.4
                  ]
                ],
                "id": 1616,
                "chat_link": "[&BFAGAAA=]"
              },
              "1618": {
                "name": "Issnur Bay",
                "level": 80,
                "coord": [
                  56753.7,
                  62474.1
                ],
                "bounds": [
                  [
                    58048.3,
                    63240
                  ],
                  [
                    57293,
                    62921.8
                  ],
                  [
                    57191.7,
                    62837.5
                  ],
                  [
                    57239.4,
                    62437.5
                  ],
                  [
                    56897,
                    62374.4
                  ],
                  [
                    56807.5,
                    62282
                  ],
                  [
                    56788.2,
                    62143.1
                  ],
                  [
                    56815,
                    62081.9
                  ],
                  [
                    56740.8,
                    61959
                  ],
                  [
                    56605.9,
                    62015.8
                  ],
                  [
                    56449.5,
                    61979
                  ],
                  [
                    56328.1,
                    61885.2
                  ],
                  [
                    56333.2,
                    61972.5
                  ],
                  [
                    56549.7,
                    62088.1
                  ],
                  [
                    56637.5,
                    62235.8
                  ],
                  [
                    56644.4,
                    62329
                  ],
                  [
                    56709,
                    62358.5
                  ],
                  [
                    56781.3,
                    62616.5
                  ],
                  [
                    56639.5,
                    62802.9
                  ],
                  [
                    56499.5,
                    62739.8
                  ],
                  [
                    56417.6,
                    62788.3
                  ],
                  [
                    56423.4,
                    62927.6
                  ],
                  [
                    56345.4,
                    63143.8
                  ],
                  [
                    56902.8,
                    63218.3
                  ],
                  [
                    58048.3,
                    63240
                  ]
                ],
                "id": 1618,
                "chat_link": "[&BFIGAAA=]"
              },
              "1619": {
                "name": "Sea of Istan",
                "level": 80,
                "coord": [
                  58251.8,
                  61308.5
                ],
                "bounds": [
                  [
                    58267.3,
                    60733
                  ],
                  [
                    58367.4,
                    60825.2
                  ],
                  [
                    58648.8,
                    60995.5
                  ],
                  [
                    58810.9,
                    61253.4
                  ],
                  [
                    58790.1,
                    61983.8
                  ],
                  [
                    58604.6,
                    62642.5
                  ],
                  [
                    58304.3,
                    63191.9
                  ],
                  [
                    58296,
                    62383.3
                  ],
                  [
                    58533.6,
                    62288
                  ],
                  [
                    58618.7,
                    61971.4
                  ],
                  [
                    58561.2,
                    61657.4
                  ],
                  [
                    58579,
                    61394.8
                  ],
                  [
                    58463.4,
                    61209.9
                  ],
                  [
                    58182,
                    61124.2
                  ],
                  [
                    58056.3,
                    60837.8
                  ],
                  [
                    57685.2,
                    60686.3
                  ],
                  [
                    57624.9,
                    60640.3
                  ],
                  [
                    57354.3,
                    60596.3
                  ],
                  [
                    57355.8,
                    60112.5
                  ],
                  [
                    58026,
                    60410.8
                  ],
                  [
                    58157.4,
                    60541.1
                  ],
                  [
                    58267.3,
                    60733
                  ]
                ],
                "id": 1619,
                "chat_link": "[&BFMGAAA=]"
              },
              "1623": {
                "name": "Plains of Jarin",
                "level": 80,
                "coord": [
                  57005.3,
                  61354.4
                ],
                "bounds": [
                  [
                    56368.9,
                    61005.3
                  ],
                  [
                    56147,
                    61082
                  ],
                  [
                    56098.8,
                    61318.8
                  ],
                  [
                    56125,
                    61438.6
                  ],
                  [
                    56223.7,
                    61565.3
                  ],
                  [
                    56346.8,
                    61681.7
                  ],
                  [
                    56373.6,
                    61764.4
                  ],
                  [
                    56328.1,
                    61885.2
                  ],
                  [
                    56449.5,
                    61979
                  ],
                  [
                    56540.2,
                    61745.5
                  ],
                  [
                    57157.5,
                    61707
                  ],
                  [
                    57153.7,
                    61639.2
                  ],
                  [
                    57457.9,
                    61391.3
                  ],
                  [
                    57241.5,
                    61206.4
                  ],
                  [
                    57237.5,
                    61443.3
                  ],
                  [
                    57147.9,
                    61563
                  ],
                  [
                    56938.1,
                    61558
                  ],
                  [
                    56846.8,
                    61456.3
                  ],
                  [
                    56841.3,
                    61203.3
                  ],
                  [
                    56916.6,
                    61113.9
                  ],
                  [
                    57159.5,
                    61112.9
                  ],
                  [
                    57241.1,
                    61206.8
                  ],
                  [
                    57457,
                    61391.7
                  ],
                  [
                    57639.5,
                    61623.9
                  ],
                  [
                    57942.3,
                    61613.5
                  ],
                  [
                    58020.1,
                    61547.3
                  ],
                  [
                    57821.5,
                    61382.6
                  ],
                  [
                    57695.1,
                    61231.3
                  ],
                  [
                    57719.5,
                    61051.9
                  ],
                  [
                    57479,
                    61025.2
                  ],
                  [
                    57331,
                    60970.8
                  ],
                  [
                    57179.6,
                    60826.8
                  ],
                  [
                    57026.7,
                    60852.2
                  ],
                  [
                    56874.6,
                    60875
                  ],
                  [
                    56660.1,
                    60943.5
                  ],
                  [
                    56368.9,
                    61005.3
                  ]
                ],
                "id": 1623,
                "chat_link": "[&BFcGAAA=]"
              }
            },
            "adventures": [],
            "id": 1265,
            "mastery_points": []
          },
          "1266": {
            "name": "Cave of the Sunspear Champion",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              57168,
              61884
            ],
            "map_rect": [
              [
                -46080,
                -46080
              ],
              [
                46080,
                46080
              ]
            ],
            "continent_rect": [
              [
                55318,
                59916
              ],
              [
                59158,
                63756
              ]
            ],
            "points_of_interest": {
              "2805": {
                "name": "Freetrader Haven",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56656.7,
                  60479.4
                ],
                "id": 2805,
                "chat_link": "[&BPUKAAA=]"
              },
              "2806": {
                "name": "The Dark Leviathan",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56815.3,
                  60377.6
                ],
                "id": 2806,
                "chat_link": "[&BPYKAAA=]"
              },
              "2807": {
                "name": "Temple of Joko",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57756.5,
                  61962.9
                ],
                "id": 2807,
                "chat_link": "[&BPcKAAA=]"
              },
              "2808": {
                "name": "Mirror of the Sun",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55773.8,
                  61325.7
                ],
                "id": 2808,
                "chat_link": "[&BPgKAAA=]"
              },
              "2809": {
                "name": "Ancient Royal Docks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57317.2,
                  62471.4
                ],
                "id": 2809,
                "chat_link": "[&BPkKAAA=]"
              },
              "2811": {
                "name": "Mirror of the Earth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55635.6,
                  61060.1
                ],
                "id": 2811,
                "chat_link": "[&BPsKAAA=]"
              },
              "2812": {
                "name": "The Sun Docks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58421.2,
                  61959.3
                ],
                "id": 2812,
                "chat_link": "[&BPwKAAA=]"
              },
              "2814": {
                "name": "Broken Observation Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55891.3,
                  60419
                ],
                "id": 2814,
                "chat_link": "[&BP4KAAA=]"
              },
              "2815": {
                "name": "Stage of Sacrifice",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57894.9,
                  62189.5
                ],
                "id": 2815,
                "chat_link": "[&BP8KAAA=]"
              },
              "2816": {
                "name": "Skylight Vault",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57427.3,
                  60931
                ],
                "id": 2816,
                "chat_link": "[&BAALAAA=]"
              },
              "2817": {
                "name": "Crucible of the Apostate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58268.6,
                  61451.1
                ],
                "id": 2817,
                "chat_link": "[&BAELAAA=]"
              },
              "2818": {
                "name": "Zehlon Waterworks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55911.9,
                  61913.9
                ],
                "id": 2818,
                "chat_link": "[&BAILAAA=]"
              },
              "2819": {
                "name": "Grotto of the Defeated",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56168.9,
                  62847.9
                ],
                "id": 2819,
                "chat_link": "[&BAMLAAA=]"
              },
              "2821": {
                "name": "Clanmarshal's Promenade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57905.7,
                  61774.3
                ],
                "id": 2821,
                "chat_link": "[&BAULAAA=]"
              },
              "2823": {
                "name": "Plaza of Resurgence",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57026.3,
                  61453.7
                ],
                "id": 2823,
                "chat_link": "[&BAcLAAA=]"
              },
              "2824": {
                "name": "Jakumba's Legacy",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55948.2,
                  61578.3
                ],
                "id": 2824,
                "chat_link": "[&BAgLAAA=]"
              },
              "2827": {
                "name": "The Wobbling Skies",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56589.3,
                  60713.3
                ],
                "id": 2827,
                "chat_link": "[&BAsLAAA=]"
              },
              "2830": {
                "name": "Palawadan Dormitories",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58093.4,
                  62187.9
                ],
                "id": 2830,
                "chat_link": "[&BA4LAAA=]"
              },
              "2831": {
                "name": "Mirror of the Moon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56293.6,
                  60725.3
                ],
                "id": 2831,
                "chat_link": "[&BA8LAAA=]"
              },
              "2833": {
                "name": "The Skimming Stone",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56955.8,
                  60677.4
                ],
                "id": 2833,
                "chat_link": "[&BBELAAA=]"
              },
              "2835": {
                "name": "Mirror of the Stars",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  55947.8,
                  61199.7
                ],
                "id": 2835,
                "chat_link": "[&BBMLAAA=]"
              },
              "2837": {
                "name": "Mehtani's Blade",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56869.8,
                  62946.1
                ],
                "id": 2837,
                "chat_link": "[&BBULAAA=]"
              },
              "2838": {
                "name": "Chahbek Thrust",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57844.4,
                  62588.7
                ],
                "id": 2838,
                "chat_link": "[&BBYLAAA=]"
              },
              "2839": {
                "name": "Lahdok Craterlands",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56624.7,
                  61389.5
                ],
                "id": 2839,
                "chat_link": "[&BBcLAAA=]"
              },
              "2840": {
                "name": "Hall of Judgment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  58097.2,
                  61964.4
                ],
                "id": 2840,
                "chat_link": "[&BBgLAAA=]"
              },
              "2843": {
                "name": "Field of the Hopeful",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  56556.1,
                  62582.7
                ],
                "id": 2843,
                "chat_link": "[&BBsLAAA=]"
              },
              "2846": {
                "name": "Warden's Quarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  57025.9,
                  61285.5
                ],
                "id": 2846,
                "chat_link": "[&BB4LAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1598": {
                "name": "Churrhir Cliffs",
                "level": 80,
                "coord": [
                  57206.2,
                  62296.3
                ],
                "bounds": [
                  [
                    56449.5,
                    61979
                  ],
                  [
                    56605.9,
                    62015.8
                  ],
                  [
                    56740.8,
                    61959
                  ],
                  [
                    56815,
                    62081.9
                  ],
                  [
                    56788.2,
                    62143.1
                  ],
                  [
                    56807.5,
                    62282
                  ],
                  [
                    56897,
                    62374.4
                  ],
                  [
                    57239.4,
                    62437.5
                  ],
                  [
                    57191.7,
                    62837.5
                  ],
                  [
                    57293,
                    62921.8
                  ],
                  [
                    58048.3,
                    63240
                  ],
                  [
                    58304.3,
                    63191.9
                  ],
                  [
                    58296,
                    62383.3
                  ],
                  [
                    57633.5,
                    62339.1
                  ],
                  [
                    57434.5,
                    62213.9
                  ],
                  [
                    57331.8,
                    62067.6
                  ],
                  [
                    57343.5,
                    61710
                  ],
                  [
                    57157.5,
                    61707
                  ],
                  [
                    56540.2,
                    61745.5
                  ],
                  [
                    56449.5,
                    61979
                  ]
                ],
                "id": 1598,
                "chat_link": "[&BD4GAAA=]"
              },
              "1602": {
                "name": "Zehlon Breach",
                "level": 80,
                "coord": [
                  55987.2,
                  61792.9
                ],
                "bounds": [
                  [
                    55559.2,
                    61580.8
                  ],
                  [
                    56125,
                    61438.6
                  ],
                  [
                    56223.7,
                    61565.3
                  ],
                  [
                    56346.8,
                    61681.7
                  ],
                  [
                    56373.6,
                    61764.4
                  ],
                  [
                    56328.1,
                    61885.2
                  ],
                  [
                    55647,
                    62357.3
                  ],
                  [
                    55621.1,
                    62070.1
                  ],
                  [
                    55660.3,
                    61792.6
                  ],
                  [
                    55559.2,
                    61580.8
                  ]
                ],
                "id": 1602,
                "chat_link": "[&BEIGAAA=]"
              },
              "1604": {
                "name": "The Astralarium",
                "level": 80,
                "coord": [
                  56015.7,
                  60830.4
                ],
                "bounds": [
                  [
                    55644.3,
                    60333.6
                  ],
                  [
                    55851.9,
                    60247.9
                  ],
                  [
                    55988.3,
                    60355.5
                  ],
                  [
                    56093.6,
                    60390.9
                  ],
                  [
                    56199,
                    60478.3
                  ],
                  [
                    56136.3,
                    60522.5
                  ],
                  [
                    56335.5,
                    60611.8
                  ],
                  [
                    56462.1,
                    60590.6
                  ],
                  [
                    56441.4,
                    60770.5
                  ],
                  [
                    56261.3,
                    60833.7
                  ],
                  [
                    56257.2,
                    60932.5
                  ],
                  [
                    56368.9,
                    61005.3
                  ],
                  [
                    56147,
                    61082
                  ],
                  [
                    56098.8,
                    61318.8
                  ],
                  [
                    56125,
                    61438.6
                  ],
                  [
                    55559.2,
                    61580.8
                  ],
                  [
                    55478.5,
                    61384.1
                  ],
                  [
                    55398.8,
                    61104.6
                  ],
                  [
                    55450.7,
                    60794.8
                  ],
                  [
                    55644.3,
                    60333.6
                  ]
                ],
                "id": 1604,
                "chat_link": "[&BEQGAAA=]"
              },
              "1605": {
                "name": "Corsair Flotilla",
                "level": 80,
                "coord": [
                  56451.7,
                  60569.7
                ],
                "bounds": [
                  [
                    55761.3,
                    60152.1
                  ],
                  [
                    55742.6,
                    60295.2
                  ],
                  [
                    55851.9,
                    60247.9
                  ],
                  [
                    55988.3,
                    60355.5
                  ],
                  [
                    56093.6,
                    60390.9
                  ],
                  [
                    56199,
                    60478.3
                  ],
                  [
                    56136.3,
                    60522.5
                  ],
                  [
                    56335.5,
                    60611.8
                  ],
                  [
                    56462.1,
                    60590.6
                  ],
                  [
                    56441.4,
                    60770.5
                  ],
                  [
                    56261.3,
                    60833.7
                  ],
                  [
                    56257.2,
                    60932.5
                  ],
                  [
                    56368.9,
                    61005.3
                  ],
                  [
                    56660.1,
                    60943.5
                  ],
                  [
                    56874.6,
                    60875
                  ],
                  [
                    57026.2,
                    60852.4
                  ],
                  [
                    57128.8,
                    60773.4
                  ],
                  [
                    57354.3,
                    60596.3
                  ],
                  [
                    57355.8,
                    60112.5
                  ],
                  [
                    56734.4,
                    60054.7
                  ],
                  [
                    55761.3,
                    60152.1
                  ]
                ],
                "id": 1605,
                "chat_link": "[&BEUGAAA=]"
              },
              "1606": {
                "name": "Chalon Docks",
                "level": 80,
                "coord": [
                  57869.2,
                  61062.8
                ],
                "bounds": [
                  [
                    57685.2,
                    60686.3
                  ],
                  [
                    58056.3,
                    60837.8
                  ],
                  [
                    58182,
                    61124.2
                  ],
                  [
                    58027.8,
                    61343.6
                  ],
                  [
                    57821.5,
                    61382.6
                  ],
                  [
                    57695.1,
                    61231.3
                  ],
                  [
                    57719.5,
                    61051.9
                  ],
                  [
                    57766.2,
                    60844.4
                  ],
                  [
                    57685.2,
                    60686.3
                  ]
                ],
                "id": 1606,
                "chat_link": "[&BEYGAAA=]"
              },
              "1609": {
                "name": "Mordant Crescent<br>Great Hall",
                "level": 80,
                "coord": [
                  57041.2,
                  61332.1
                ],
                "bounds": [
                  [
                    56846.8,
                    61456.3
                  ],
                  [
                    56841.3,
                    61203.3
                  ],
                  [
                    56916.6,
                    61113.9
                  ],
                  [
                    57159.5,
                    61112.9
                  ],
                  [
                    57242.1,
                    61206.1
                  ],
                  [
                    57237.5,
                    61443.3
                  ],
                  [
                    57147.9,
                    61563
                  ],
                  [
                    56938.1,
                    61558
                  ],
                  [
                    56846.8,
                    61456.3
                  ]
                ],
                "id": 1609,
                "chat_link": "[&BEkGAAA=]"
              },
              "1610": {
                "name": "Heretic's Arena",
                "level": 80,
                "coord": [
                  58240.1,
                  61410.8
                ],
                "bounds": [
                  [
                    58463.4,
                    61209.9
                  ],
                  [
                    58579,
                    61394.8
                  ],
                  [
                    58561.2,
                    61657.4
                  ],
                  [
                    58265.9,
                    61626.8
                  ],
                  [
                    58020.1,
                    61547.3
                  ],
                  [
                    57821.5,
                    61382.6
                  ],
                  [
                    58027.8,
                    61343.6
                  ],
                  [
                    58182,
                    61124.2
                  ],
                  [
                    58463.4,
                    61209.9
                  ]
                ],
                "id": 1610,
                "chat_link": "[&BEoGAAA=]"
              },
              "1614": {
                "name": "Champion's Dawn",
                "level": 80,
                "coord": [
                  56394.7,
                  62511.4
                ],
                "bounds": [
                  [
                    55647,
                    62357.3
                  ],
                  [
                    56328.1,
                    61885.2
                  ],
                  [
                    56333.2,
                    61972.5
                  ],
                  [
                    56549.7,
                    62088.1
                  ],
                  [
                    56637.5,
                    62235.8
                  ],
                  [
                    56644.4,
                    62329
                  ],
                  [
                    56709,
                    62358.5
                  ],
                  [
                    56781.3,
                    62616.5
                  ],
                  [
                    56639.5,
                    62802.9
                  ],
                  [
                    56499.5,
                    62739.8
                  ],
                  [
                    56417.6,
                    62788.3
                  ],
                  [
                    56423.4,
                    62927.6
                  ],
                  [
                    56345.4,
                    63143.8
                  ],
                  [
                    56114.3,
                    62837.7
                  ],
                  [
                    55851.2,
                    62588.1
                  ],
                  [
                    55647,
                    62357.3
                  ]
                ],
                "id": 1614,
                "chat_link": "[&BE4GAAA=]"
              },
              "1615": {
                "name": "Modri Caverns",
                "level": 80,
                "coord": [
                  57462.9,
                  60832.7
                ],
                "bounds": [
                  [
                    57026.2,
                    60852.4
                  ],
                  [
                    57354.3,
                    60596.3
                  ],
                  [
                    57624.9,
                    60640.3
                  ],
                  [
                    57685.2,
                    60686.3
                  ],
                  [
                    57766.2,
                    60844.4
                  ],
                  [
                    57719.5,
                    61051.9
                  ],
                  [
                    57479,
                    61025.2
                  ],
                  [
                    57331,
                    60970.8
                  ],
                  [
                    57179.6,
                    60826.8
                  ],
                  [
                    57026.2,
                    60852.4
                  ]
                ],
                "id": 1615,
                "chat_link": "[&BE8GAAA=]"
              },
              "1616": {
                "name": "Palawadan, Jewel of Istan",
                "level": 80,
                "coord": [
                  57825.9,
                  61851.8
                ],
                "bounds": [
                  [
                    58561.2,
                    61657.4
                  ],
                  [
                    58618.7,
                    61971.4
                  ],
                  [
                    58533.6,
                    62288
                  ],
                  [
                    58296,
                    62383.3
                  ],
                  [
                    57633.5,
                    62339.1
                  ],
                  [
                    57434.5,
                    62213.9
                  ],
                  [
                    57331.8,
                    62067.6
                  ],
                  [
                    57343.5,
                    61710
                  ],
                  [
                    57157.5,
                    61707
                  ],
                  [
                    57153.7,
                    61639.2
                  ],
                  [
                    57457.2,
                    61389.4
                  ],
                  [
                    57639.5,
                    61623.9
                  ],
                  [
                    57942.3,
                    61613.5
                  ],
                  [
                    58020.1,
                    61547.3
                  ],
                  [
                    58265.9,
                    61626.8
                  ],
                  [
                    58561.2,
                    61657.4
                  ]
                ],
                "id": 1616,
                "chat_link": "[&BFAGAAA=]"
              },
              "1618": {
                "name": "Issnur Bay",
                "level": 80,
                "coord": [
                  56753.7,
                  62474.1
                ],
                "bounds": [
                  [
                    58048.3,
                    63240
                  ],
                  [
                    57293,
                    62921.8
                  ],
                  [
                    57191.7,
                    62837.5
                  ],
                  [
                    57239.4,
                    62437.5
                  ],
                  [
                    56897,
                    62374.4
                  ],
                  [
                    56807.5,
                    62282
                  ],
                  [
                    56788.2,
                    62143.1
                  ],
                  [
                    56815,
                    62081.9
                  ],
                  [
                    56740.8,
                    61959
                  ],
                  [
                    56605.9,
                    62015.8
                  ],
                  [
                    56449.5,
                    61979
                  ],
                  [
                    56328.1,
                    61885.2
                  ],
                  [
                    56333.2,
                    61972.5
                  ],
                  [
                    56549.7,
                    62088.1
                  ],
                  [
                    56637.5,
                    62235.8
                  ],
                  [
                    56644.4,
                    62329
                  ],
                  [
                    56709,
                    62358.5
                  ],
                  [
                    56781.3,
                    62616.5
                  ],
                  [
                    56639.5,
                    62802.9
                  ],
                  [
                    56499.5,
                    62739.8
                  ],
                  [
                    56417.6,
                    62788.3
                  ],
                  [
                    56423.4,
                    62927.6
                  ],
                  [
                    56345.4,
                    63143.8
                  ],
                  [
                    56902.8,
                    63218.3
                  ],
                  [
                    58048.3,
                    63240
                  ]
                ],
                "id": 1618,
                "chat_link": "[&BFIGAAA=]"
              },
              "1619": {
                "name": "Sea of Istan",
                "level": 80,
                "coord": [
                  58251.8,
                  61308.5
                ],
                "bounds": [
                  [
                    58267.3,
                    60733
                  ],
                  [
                    58367.4,
                    60825.2
                  ],
                  [
                    58648.8,
                    60995.5
                  ],
                  [
                    58810.9,
                    61253.4
                  ],
                  [
                    58790.1,
                    61983.8
                  ],
                  [
                    58604.6,
                    62642.5
                  ],
                  [
                    58304.3,
                    63191.9
                  ],
                  [
                    58296,
                    62383.3
                  ],
                  [
                    58533.6,
                    62288
                  ],
                  [
                    58618.7,
                    61971.4
                  ],
                  [
                    58561.2,
                    61657.4
                  ],
                  [
                    58579,
                    61394.8
                  ],
                  [
                    58463.4,
                    61209.9
                  ],
                  [
                    58182,
                    61124.2
                  ],
                  [
                    58056.3,
                    60837.8
                  ],
                  [
                    57685.2,
                    60686.3
                  ],
                  [
                    57624.9,
                    60640.3
                  ],
                  [
                    57354.3,
                    60596.3
                  ],
                  [
                    57355.8,
                    60112.5
                  ],
                  [
                    58026,
                    60410.8
                  ],
                  [
                    58157.4,
                    60541.1
                  ],
                  [
                    58267.3,
                    60733
                  ]
                ],
                "id": 1619,
                "chat_link": "[&BFMGAAA=]"
              },
              "1623": {
                "name": "Plains of Jarin",
                "level": 80,
                "coord": [
                  57005.3,
                  61354.4
                ],
                "bounds": [
                  [
                    56368.9,
                    61005.3
                  ],
                  [
                    56147,
                    61082
                  ],
                  [
                    56098.8,
                    61318.8
                  ],
                  [
                    56125,
                    61438.6
                  ],
                  [
                    56223.7,
                    61565.3
                  ],
                  [
                    56346.8,
                    61681.7
                  ],
                  [
                    56373.6,
                    61764.4
                  ],
                  [
                    56328.1,
                    61885.2
                  ],
                  [
                    56449.5,
                    61979
                  ],
                  [
                    56540.2,
                    61745.5
                  ],
                  [
                    57157.5,
                    61707
                  ],
                  [
                    57153.7,
                    61639.2
                  ],
                  [
                    57457.9,
                    61391.3
                  ],
                  [
                    57241.5,
                    61206.4
                  ],
                  [
                    57237.5,
                    61443.3
                  ],
                  [
                    57147.9,
                    61563
                  ],
                  [
                    56938.1,
                    61558
                  ],
                  [
                    56846.8,
                    61456.3
                  ],
                  [
                    56841.3,
                    61203.3
                  ],
                  [
                    56916.6,
                    61113.9
                  ],
                  [
                    57159.5,
                    61112.9
                  ],
                  [
                    57241.1,
                    61206.8
                  ],
                  [
                    57457,
                    61391.7
                  ],
                  [
                    57639.5,
                    61623.9
                  ],
                  [
                    57942.3,
                    61613.5
                  ],
                  [
                    58020.1,
                    61547.3
                  ],
                  [
                    57821.5,
                    61382.6
                  ],
                  [
                    57695.1,
                    61231.3
                  ],
                  [
                    57719.5,
                    61051.9
                  ],
                  [
                    57479,
                    61025.2
                  ],
                  [
                    57331,
                    60970.8
                  ],
                  [
                    57179.6,
                    60826.8
                  ],
                  [
                    57026.7,
                    60852.2
                  ],
                  [
                    56874.6,
                    60875
                  ],
                  [
                    56660.1,
                    60943.5
                  ],
                  [
                    56368.9,
                    61005.3
                  ]
                ],
                "id": 1623,
                "chat_link": "[&BFcGAAA=]"
              }
            },
            "adventures": [],
            "id": 1266,
            "mastery_points": []
          },
          "1271": {
            "name": "Sandswept Isles",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              53768,
              57384
            ],
            "map_rect": [
              [
                -36864,
                -52224
              ],
              [
                39936,
                52224
              ]
            ],
            "continent_rect": [
              [
                51994,
                55402
              ],
              [
                55194,
                59754
              ]
            ],
            "points_of_interest": {
              "2851": {
                "name": "Communications Control",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52911.8,
                  57638
                ],
                "id": 2851,
                "chat_link": "[&BCMLAAA=]"
              },
              "2852": {
                "name": "Jemandi Market",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53240.8,
                  56371.2
                ],
                "id": 2852,
                "chat_link": "[&BCQLAAA=]"
              },
              "2853": {
                "name": "Anniogel Encampment Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  54424.7,
                  57340
                ],
                "id": 2853,
                "chat_link": "[&BCULAAA=]"
              },
              "2854": {
                "name": "Lab Sigma-05",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54404,
                  56896.5
                ],
                "id": 2854,
                "chat_link": "[&BCYLAAA=]"
              },
              "2855": {
                "name": "The Iron Whale",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53188.4,
                  56590.9
                ],
                "id": 2855,
                "chat_link": "[&BCcLAAA=]"
              },
              "2856": {
                "name": "Magistorm Gallery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54177.6,
                  57553.2
                ],
                "id": 2856,
                "chat_link": "[&BCgLAAA=]"
              },
              "2857": {
                "name": "Tunnel Access Epsilon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52913,
                  57841.9
                ],
                "id": 2857,
                "chat_link": "[&BCkLAAA=]"
              },
              "2858": {
                "name": "Tunnel Access Beta",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53453.4,
                  57788.2
                ],
                "id": 2858,
                "chat_link": "[&BCoLAAA=]"
              },
              "2859": {
                "name": "Ritual Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52755.1,
                  56663
                ],
                "id": 2859,
                "chat_link": "[&BCsLAAA=]"
              },
              "2860": {
                "name": "Ewyn's Retreat",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53529.9,
                  55969.3
                ],
                "id": 2860,
                "chat_link": "[&BCwLAAA=]"
              },
              "2861": {
                "name": "Magnetics Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54729.4,
                  58798.5
                ],
                "id": 2861,
                "chat_link": "[&BC0LAAA=]"
              },
              "2862": {
                "name": "Tunnel Access Delta",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53258.8,
                  57310
                ],
                "id": 2862,
                "chat_link": "[&BC4LAAA=]"
              },
              "2864": {
                "name": "Reserve Power Core",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54649.9,
                  57737.8
                ],
                "id": 2864,
                "chat_link": "[&BDALAAA=]"
              },
              "2865": {
                "name": "Deepwater Cooling Sink",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53687.3,
                  57883
                ],
                "id": 2865,
                "chat_link": "[&BDELAAA=]"
              },
              "2866": {
                "name": "Skycavern Burial Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54516.7,
                  55768.8
                ],
                "id": 2866,
                "chat_link": "[&BDILAAA=]"
              },
              "2867": {
                "name": "Driftwood Jetty",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53758.9,
                  56807.2
                ],
                "id": 2867,
                "chat_link": "[&BDMLAAA=]"
              },
              "2868": {
                "name": "Necrobrand Emulation Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54414.4,
                  58000.8
                ],
                "id": 2868,
                "chat_link": "[&BDQLAAA=]"
              },
              "2869": {
                "name": "Atholma Docks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52565.9,
                  56431.1
                ],
                "id": 2869,
                "chat_link": "[&BDULAAA=]"
              },
              "2870": {
                "name": "Malor's Ranch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53535.6,
                  56463.4
                ],
                "id": 2870,
                "chat_link": "[&BDYLAAA=]"
              },
              "2871": {
                "name": "Communications Array",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52831.2,
                  57539.8
                ],
                "id": 2871,
                "chat_link": "[&BDcLAAA=]"
              },
              "2872": {
                "name": "Tunnel Access Alpha",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53793.4,
                  57648.5
                ],
                "id": 2872,
                "chat_link": "[&BDgLAAA=]"
              },
              "2873": {
                "name": "Leyfinder Research Facility",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53650.5,
                  58653.2
                ],
                "id": 2873,
                "chat_link": "[&BDkLAAA=]"
              },
              "2874": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  54585.7,
                  56121.1
                ],
                "id": 2874,
                "chat_link": "[&BDoLAAA=]"
              },
              "2875": {
                "name": "Effluent Outflow Network",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53370.8,
                  58498.5
                ],
                "id": 2875,
                "chat_link": "[&BDsLAAA=]"
              },
              "2876": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  52676.2,
                  57583.9
                ],
                "id": 2876,
                "chat_link": "[&BDwLAAA=]"
              },
              "2877": {
                "name": "Olma's Legacy",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52974.7,
                  55970.4
                ],
                "id": 2877,
                "chat_link": "[&BD0LAAA=]"
              },
              "2878": {
                "name": "Greytear Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54478.7,
                  55985
                ],
                "id": 2878,
                "chat_link": "[&BD4LAAA=]"
              },
              "2879": {
                "name": "Tunnel Access Gamma",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54033.2,
                  57499
                ],
                "id": 2879,
                "chat_link": "[&BD8LAAA=]"
              },
              "2880": {
                "name": "Cerberus Watchtowers",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52677.4,
                  57756.7
                ],
                "id": 2880,
                "chat_link": "[&BEALAAA=]"
              },
              "2881": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  54623.6,
                  57694
                ],
                "id": 2881,
                "chat_link": "[&BEELAAA=]"
              },
              "2882": {
                "name": "Anniogel Landing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54386.9,
                  57286.6
                ],
                "id": 2882,
                "chat_link": "[&BEILAAA=]"
              },
              "2883": {
                "name": "Atholma Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  53327,
                  56442.8
                ],
                "id": 2883,
                "chat_link": "[&BEMLAAA=]"
              },
              "2884": {
                "name": "Portalforge Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54755.8,
                  58404.8
                ],
                "id": 2884,
                "chat_link": "[&BEQLAAA=]"
              },
              "2885": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  52786.8,
                  56400.6
                ],
                "id": 2885,
                "chat_link": "[&BEULAAA=]"
              },
              "2886": {
                "name": "Specimen Chamber",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53117.7,
                  57920.6
                ],
                "id": 2886,
                "chat_link": "[&BEYLAAA=]"
              },
              "2887": {
                "name": "Rata Primus Canal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53607.8,
                  58249.2
                ],
                "id": 2887,
                "chat_link": "[&BEcLAAA=]"
              }
            },
            "tasks": {
              "424": {
                "objective": "Help the Olmakhan slow the Inquest's expansion.",
                "level": 80,
                "coord": [
                  54414.1,
                  57417.9
                ],
                "bounds": [
                  [
                    54012.5,
                    57923
                  ],
                  [
                    53799,
                    57224.6
                  ],
                  [
                    54483.8,
                    57241.7
                  ],
                  [
                    54508.6,
                    57884.2
                  ],
                  [
                    54012.5,
                    57923
                  ]
                ],
                "id": 424,
                "chat_link": "[&BKgBAAA=]"
              },
              "425": {
                "objective": "The Hunting Grounds",
                "level": 80,
                "coord": [
                  53355.3,
                  56077
                ],
                "bounds": [
                  [
                    53449,
                    55619.4
                  ],
                  [
                    53544.9,
                    55787.3
                  ],
                  [
                    53444.7,
                    56057.8
                  ],
                  [
                    53336.2,
                    56169.6
                  ],
                  [
                    53206.8,
                    56238.7
                  ],
                  [
                    53114.4,
                    56202.9
                  ],
                  [
                    52941.3,
                    56135.5
                  ],
                  [
                    52867.8,
                    56060.8
                  ],
                  [
                    52736,
                    55959.3
                  ],
                  [
                    52707.9,
                    55805.9
                  ],
                  [
                    52807.6,
                    55719.4
                  ],
                  [
                    53449,
                    55619.4
                  ]
                ],
                "id": 425,
                "chat_link": "[&BKkBAAA=]"
              },
              "426": {
                "objective": "Atholma Farms",
                "level": 80,
                "coord": [
                  53552.1,
                  56393.4
                ],
                "bounds": [
                  [
                    53632.4,
                    56264.1
                  ],
                  [
                    53913.1,
                    56227.3
                  ],
                  [
                    54064.5,
                    56394.2
                  ],
                  [
                    54053.2,
                    56663.9
                  ],
                  [
                    53765.1,
                    56949.7
                  ],
                  [
                    53393.8,
                    56711
                  ],
                  [
                    53489.8,
                    56545.4
                  ],
                  [
                    53408.8,
                    56330.8
                  ],
                  [
                    53632.4,
                    56264.1
                  ]
                ],
                "id": 426,
                "chat_link": "[&BKoBAAA=]"
              },
              "427": {
                "objective": "Disrupt the Magnetics Lab.",
                "level": 80,
                "coord": [
                  54528.7,
                  58709.6
                ],
                "bounds": [
                  [
                    54564,
                    59050.6
                  ],
                  [
                    54514.6,
                    58803.8
                  ],
                  [
                    54508.6,
                    58611.1
                  ],
                  [
                    54942.9,
                    58624.9
                  ],
                  [
                    54848.5,
                    59071.4
                  ],
                  [
                    54564,
                    59050.6
                  ]
                ],
                "id": 427,
                "chat_link": "[&BKsBAAA=]"
              }
            },
            "skill_challenges": [],
            "sectors": {
              "1624": {
                "name": "Rata Primus",
                "level": 80,
                "coord": [
                  53687.6,
                  57882.8
                ],
                "bounds": [
                  [
                    53749.6,
                    57436.3
                  ],
                  [
                    54107.6,
                    57712.3
                  ],
                  [
                    54045.8,
                    58160.7
                  ],
                  [
                    53631.3,
                    58328.4
                  ],
                  [
                    53266.9,
                    58055.7
                  ],
                  [
                    53324.4,
                    57603.6
                  ],
                  [
                    53749.6,
                    57436.3
                  ]
                ],
                "id": 1624,
                "chat_link": "[&BFgGAAA=]"
              },
              "1625": {
                "name": "Eastern Complex",
                "level": 80,
                "coord": [
                  54076.1,
                  57901.5
                ],
                "bounds": [
                  [
                    54107.6,
                    57712.3
                  ],
                  [
                    53749.6,
                    57436.3
                  ],
                  [
                    53771.6,
                    57279.9
                  ],
                  [
                    53860.8,
                    57326.8
                  ],
                  [
                    54023.4,
                    57286.9
                  ],
                  [
                    54226.9,
                    57227.1
                  ],
                  [
                    54319,
                    57285
                  ],
                  [
                    54341.9,
                    57365.5
                  ],
                  [
                    54447.2,
                    57419.2
                  ],
                  [
                    54492.8,
                    57701.7
                  ],
                  [
                    54472.5,
                    57905.8
                  ],
                  [
                    54451.1,
                    58081.1
                  ],
                  [
                    54336.4,
                    58163
                  ],
                  [
                    54277,
                    58299.3
                  ],
                  [
                    54172.5,
                    58459.3
                  ],
                  [
                    54001.7,
                    58449.3
                  ],
                  [
                    53927.5,
                    58383
                  ],
                  [
                    53860.9,
                    58354.3
                  ],
                  [
                    53796.5,
                    58385.1
                  ],
                  [
                    53743.4,
                    58374.7
                  ],
                  [
                    53693.1,
                    58350.5
                  ],
                  [
                    53631.3,
                    58328.4
                  ],
                  [
                    54045.8,
                    58160.7
                  ],
                  [
                    54107.6,
                    57712.3
                  ]
                ],
                "id": 1625,
                "chat_link": "[&BFkGAAA=]"
              },
              "1626": {
                "name": "Atholma",
                "level": 80,
                "coord": [
                  52950.2,
                  56490
                ],
                "bounds": [
                  [
                    53339.9,
                    56357.5
                  ],
                  [
                    53415.3,
                    56366.2
                  ],
                  [
                    53421.3,
                    56408.8
                  ],
                  [
                    53396.9,
                    56504.2
                  ],
                  [
                    53488.1,
                    56549.8
                  ],
                  [
                    53502,
                    56771.5
                  ],
                  [
                    53435.8,
                    56719.2
                  ],
                  [
                    53308.3,
                    56680.8
                  ],
                  [
                    53145.2,
                    56758
                  ],
                  [
                    52942,
                    56703.5
                  ],
                  [
                    52876.4,
                    56763.3
                  ],
                  [
                    52703.6,
                    56792.4
                  ],
                  [
                    52612.4,
                    56724.7
                  ],
                  [
                    52459,
                    56724.8
                  ],
                  [
                    52261.4,
                    56624.4
                  ],
                  [
                    52240.2,
                    56538.2
                  ],
                  [
                    52235.8,
                    56366.6
                  ],
                  [
                    52403,
                    56275.2
                  ],
                  [
                    52602,
                    56226.2
                  ],
                  [
                    52779.1,
                    56182.2
                  ],
                  [
                    52896.8,
                    56217.5
                  ],
                  [
                    52996,
                    56312.8
                  ],
                  [
                    53019.5,
                    56243.1
                  ],
                  [
                    53068.8,
                    56197.4
                  ],
                  [
                    53205.6,
                    56241.8
                  ],
                  [
                    53339.9,
                    56357.5
                  ]
                ],
                "id": 1626,
                "chat_link": "[&BFoGAAA=]"
              },
              "1627": {
                "name": "The Hunting Grounds",
                "level": 80,
                "coord": [
                  53711.6,
                  55985.1
                ],
                "bounds": [
                  [
                    54689.7,
                    55664.6
                  ],
                  [
                    54780.2,
                    55734.3
                  ],
                  [
                    54655.8,
                    55831.5
                  ],
                  [
                    54478.9,
                    55970.8
                  ],
                  [
                    54477.8,
                    56021.6
                  ],
                  [
                    54540.1,
                    56035.1
                  ],
                  [
                    54628.9,
                    55995.3
                  ],
                  [
                    54690.3,
                    56044.1
                  ],
                  [
                    54675.8,
                    56226.1
                  ],
                  [
                    54625.2,
                    56368.6
                  ],
                  [
                    54405,
                    56346.8
                  ],
                  [
                    54279.2,
                    56362.3
                  ],
                  [
                    54211.1,
                    56293.1
                  ],
                  [
                    53978.1,
                    56228.8
                  ],
                  [
                    53800.8,
                    56257.9
                  ],
                  [
                    53763.4,
                    56306.9
                  ],
                  [
                    53472.4,
                    56247.3
                  ],
                  [
                    53415.3,
                    56366.2
                  ],
                  [
                    53339.9,
                    56357.5
                  ],
                  [
                    53205.6,
                    56241.8
                  ],
                  [
                    53068.8,
                    56197.4
                  ],
                  [
                    53019.5,
                    56243.1
                  ],
                  [
                    52996,
                    56312.8
                  ],
                  [
                    52896.8,
                    56217.5
                  ],
                  [
                    52779.1,
                    56182.2
                  ],
                  [
                    52660,
                    56015.2
                  ],
                  [
                    52593.6,
                    55876.4
                  ],
                  [
                    52509.4,
                    55749
                  ],
                  [
                    52557.4,
                    55710.1
                  ],
                  [
                    52926.6,
                    55681.3
                  ],
                  [
                    52998.5,
                    55747
                  ],
                  [
                    53095.6,
                    55752
                  ],
                  [
                    53216.4,
                    55717.2
                  ],
                  [
                    53315.5,
                    55620.2
                  ],
                  [
                    53433.9,
                    55608.5
                  ],
                  [
                    53513.6,
                    55647.8
                  ],
                  [
                    53654.4,
                    55693.5
                  ],
                  [
                    53797,
                    55660.3
                  ],
                  [
                    53959.2,
                    55678.8
                  ],
                  [
                    54103,
                    55749.2
                  ],
                  [
                    54200.7,
                    55763.7
                  ],
                  [
                    54480.3,
                    55649.4
                  ],
                  [
                    54689.7,
                    55664.6
                  ]
                ],
                "id": 1627,
                "chat_link": "[&BFsGAAA=]"
              },
              "1628": {
                "name": "Northern Complex Coves",
                "level": 80,
                "coord": [
                  53375,
                  57213.5
                ],
                "bounds": [
                  [
                    52713,
                    57332.3
                  ],
                  [
                    52796.3,
                    57390.8
                  ],
                  [
                    52843.1,
                    57283.4
                  ],
                  [
                    52907.3,
                    57287
                  ],
                  [
                    53021.8,
                    57316.8
                  ],
                  [
                    53156.9,
                    57289.1
                  ],
                  [
                    53262.5,
                    57301.9
                  ],
                  [
                    53364,
                    57272.2
                  ],
                  [
                    53487.6,
                    57346.1
                  ],
                  [
                    53597,
                    57291.5
                  ],
                  [
                    53702.5,
                    57310.9
                  ],
                  [
                    53771.6,
                    57279.9
                  ],
                  [
                    53860.8,
                    57326.8
                  ],
                  [
                    54023.4,
                    57286.9
                  ],
                  [
                    54226.9,
                    57227.1
                  ],
                  [
                    54161.8,
                    57153.1
                  ],
                  [
                    54067,
                    57131.4
                  ],
                  [
                    53987.4,
                    57191.8
                  ],
                  [
                    53852.4,
                    57188.8
                  ],
                  [
                    53647.4,
                    57092.3
                  ],
                  [
                    53595.5,
                    57077.8
                  ],
                  [
                    53459.6,
                    57077.7
                  ],
                  [
                    53391.9,
                    57089.3
                  ],
                  [
                    53325.1,
                    57128.4
                  ],
                  [
                    53199.6,
                    57070.9
                  ],
                  [
                    53037.9,
                    57040.8
                  ],
                  [
                    52792.5,
                    57069.1
                  ],
                  [
                    52675.7,
                    57095.8
                  ],
                  [
                    52605.9,
                    57180.2
                  ],
                  [
                    52716.8,
                    57276.4
                  ],
                  [
                    52713,
                    57332.3
                  ]
                ],
                "id": 1628,
                "chat_link": "[&BFwGAAA=]"
              },
              "1629": {
                "name": "Reserve Generator Site",
                "level": 80,
                "coord": [
                  54513.6,
                  57631.8
                ],
                "bounds": [
                  [
                    54341.9,
                    57365.5
                  ],
                  [
                    54447.2,
                    57419.2
                  ],
                  [
                    54492.8,
                    57701.7
                  ],
                  [
                    54472.5,
                    57905.8
                  ],
                  [
                    54451.1,
                    58081.1
                  ],
                  [
                    54601.5,
                    58078.3
                  ],
                  [
                    54602.4,
                    57861.9
                  ],
                  [
                    54678.8,
                    57828.4
                  ],
                  [
                    54730.5,
                    57756.8
                  ],
                  [
                    54556,
                    57493.8
                  ],
                  [
                    54557.1,
                    57434.6
                  ],
                  [
                    54523.3,
                    57351.1
                  ],
                  [
                    54416.9,
                    57282.3
                  ],
                  [
                    54319,
                    57285
                  ],
                  [
                    54341.9,
                    57365.5
                  ]
                ],
                "id": 1629,
                "chat_link": "[&BF0GAAA=]"
              },
              "1630": {
                "name": "Damos Isle",
                "level": 80,
                "coord": [
                  53336.2,
                  58559.9
                ],
                "bounds": [
                  [
                    53692.3,
                    58505
                  ],
                  [
                    53798.4,
                    58624.7
                  ],
                  [
                    53940.1,
                    58633.7
                  ],
                  [
                    53965.9,
                    58757.8
                  ],
                  [
                    53878.5,
                    58951.3
                  ],
                  [
                    53628.5,
                    59028.8
                  ],
                  [
                    53399.8,
                    59012.9
                  ],
                  [
                    53244.8,
                    58758.1
                  ],
                  [
                    53158.7,
                    58726.6
                  ],
                  [
                    52988,
                    58629.9
                  ],
                  [
                    52860.9,
                    58528.6
                  ],
                  [
                    52750.8,
                    58232.9
                  ],
                  [
                    52798.4,
                    58105.1
                  ],
                  [
                    52937.6,
                    58145.8
                  ],
                  [
                    53040,
                    58285.9
                  ],
                  [
                    53160.2,
                    58353.6
                  ],
                  [
                    53269,
                    58387.2
                  ],
                  [
                    53353.2,
                    58495.8
                  ],
                  [
                    53522,
                    58474.5
                  ],
                  [
                    53692.3,
                    58505
                  ]
                ],
                "id": 1630,
                "chat_link": "[&BF4GAAA=]"
              },
              "1631": {
                "name": "Calon Islet",
                "level": 80,
                "coord": [
                  54311.3,
                  56928.4
                ],
                "bounds": [
                  [
                    54491.3,
                    56758
                  ],
                  [
                    54568.2,
                    56901.1
                  ],
                  [
                    54532.4,
                    56998.3
                  ],
                  [
                    54482.3,
                    57040.2
                  ],
                  [
                    54250.6,
                    57060.7
                  ],
                  [
                    54063.5,
                    57025.3
                  ],
                  [
                    54041.9,
                    56928.2
                  ],
                  [
                    54080.5,
                    56849.4
                  ],
                  [
                    54290.8,
                    56795
                  ],
                  [
                    54491.3,
                    56758
                  ]
                ],
                "id": 1631,
                "chat_link": "[&BF8GAAA=]"
              },
              "1632": {
                "name": "Invariant Enclave",
                "level": 80,
                "coord": [
                  54469.6,
                  58872.9
                ],
                "bounds": [
                  [
                    55096.9,
                    58489.7
                  ],
                  [
                    55033.3,
                    59017.5
                  ],
                  [
                    54964.4,
                    59462.7
                  ],
                  [
                    54790.7,
                    59688.4
                  ],
                  [
                    54508.8,
                    59670.2
                  ],
                  [
                    54367.3,
                    59653.9
                  ],
                  [
                    54288.6,
                    59548.1
                  ],
                  [
                    54280,
                    59449.2
                  ],
                  [
                    54235.1,
                    59363.1
                  ],
                  [
                    54064.7,
                    59285.4
                  ],
                  [
                    54026.3,
                    59160
                  ],
                  [
                    54081.4,
                    58895.6
                  ],
                  [
                    54084.8,
                    58832.9
                  ],
                  [
                    54109.3,
                    58754.3
                  ],
                  [
                    54122.7,
                    58661.8
                  ],
                  [
                    54208.5,
                    58616.9
                  ],
                  [
                    54291.6,
                    58569.6
                  ],
                  [
                    54318.8,
                    58495.8
                  ],
                  [
                    54449.2,
                    58299.3
                  ],
                  [
                    54500.4,
                    58235.4
                  ],
                  [
                    54599.8,
                    58155
                  ],
                  [
                    54821,
                    58142.3
                  ],
                  [
                    54949.8,
                    58227
                  ],
                  [
                    55078.3,
                    58275.7
                  ],
                  [
                    55096.9,
                    58489.7
                  ]
                ],
                "id": 1632,
                "chat_link": "[&BGAGAAA=]"
              },
              "1635": {
                "name": "Griffonstone Buttresses",
                "level": 80,
                "coord": [
                  52664.9,
                  57700.1
                ],
                "bounds": [
                  [
                    52816.7,
                    57755.5
                  ],
                  [
                    52886.3,
                    57864.8
                  ],
                  [
                    52885.1,
                    57915.3
                  ],
                  [
                    52842,
                    57937
                  ],
                  [
                    52937.6,
                    58145.8
                  ],
                  [
                    52798.4,
                    58105.1
                  ],
                  [
                    52750.8,
                    58232.9
                  ],
                  [
                    52526.7,
                    58107.9
                  ],
                  [
                    52444.4,
                    57977.4
                  ],
                  [
                    52463.8,
                    57899.3
                  ],
                  [
                    52340.1,
                    57668.2
                  ],
                  [
                    52394.3,
                    57445.6
                  ],
                  [
                    52419.3,
                    57335.5
                  ],
                  [
                    52530.6,
                    57197.6
                  ],
                  [
                    52605.9,
                    57180.2
                  ],
                  [
                    52716.8,
                    57276.4
                  ],
                  [
                    52713,
                    57332.3
                  ],
                  [
                    52796.3,
                    57390.8
                  ],
                  [
                    52764.6,
                    57533.4
                  ],
                  [
                    52816.7,
                    57755.5
                  ]
                ],
                "id": 1635,
                "chat_link": "[&BGMGAAA=]"
              },
              "1636": {
                "name": "Sargol Sea",
                "level": 80,
                "coord": [
                  53949,
                  58779.9
                ],
                "bounds": [
                  [
                    53965.9,
                    58757.8
                  ],
                  [
                    53940.1,
                    58633.7
                  ],
                  [
                    53798.4,
                    58624.7
                  ],
                  [
                    53692.3,
                    58505
                  ],
                  [
                    53522,
                    58474.5
                  ],
                  [
                    53631.3,
                    58328.4
                  ],
                  [
                    53693.1,
                    58350.5
                  ],
                  [
                    53743.4,
                    58374.7
                  ],
                  [
                    53796.5,
                    58385.1
                  ],
                  [
                    53860.9,
                    58354.3
                  ],
                  [
                    53927.5,
                    58383
                  ],
                  [
                    54001.7,
                    58449.3
                  ],
                  [
                    54172.5,
                    58459.3
                  ],
                  [
                    54277,
                    58299.3
                  ],
                  [
                    54336.4,
                    58163
                  ],
                  [
                    54451.1,
                    58081.1
                  ],
                  [
                    54601.5,
                    58078.3
                  ],
                  [
                    54599.8,
                    58155
                  ],
                  [
                    54500.4,
                    58235.4
                  ],
                  [
                    54449.2,
                    58299.3
                  ],
                  [
                    54318.8,
                    58495.8
                  ],
                  [
                    54291.6,
                    58569.6
                  ],
                  [
                    54208.5,
                    58616.9
                  ],
                  [
                    54122.7,
                    58661.8
                  ],
                  [
                    54109.3,
                    58754.3
                  ],
                  [
                    54084.8,
                    58832.9
                  ],
                  [
                    54081.4,
                    58895.6
                  ],
                  [
                    54026.3,
                    59160
                  ],
                  [
                    54064.7,
                    59285.4
                  ],
                  [
                    54235.1,
                    59363.1
                  ],
                  [
                    54280,
                    59449.2
                  ],
                  [
                    54288.6,
                    59548.1
                  ],
                  [
                    54367.3,
                    59653.9
                  ],
                  [
                    54240.1,
                    59690.1
                  ],
                  [
                    53998.8,
                    59697.8
                  ],
                  [
                    53658,
                    59700.3
                  ],
                  [
                    53375.6,
                    59657.9
                  ],
                  [
                    53093.8,
                    59437.8
                  ],
                  [
                    52640.5,
                    58977.3
                  ],
                  [
                    53158.7,
                    58726.6
                  ],
                  [
                    53244.8,
                    58758.1
                  ],
                  [
                    53399.8,
                    59012.9
                  ],
                  [
                    53628.5,
                    59028.8
                  ],
                  [
                    53878.5,
                    58951.3
                  ],
                  [
                    53965.9,
                    58757.8
                  ]
                ],
                "id": 1636,
                "chat_link": "[&BGQGAAA=]"
              },
              "1637": {
                "name": "Strait of Panube",
                "level": 80,
                "coord": [
                  53556.6,
                  56927.5
                ],
                "bounds": [
                  [
                    53145.2,
                    56758
                  ],
                  [
                    53308.3,
                    56680.8
                  ],
                  [
                    53435.8,
                    56719.2
                  ],
                  [
                    53502,
                    56771.5
                  ],
                  [
                    53599.9,
                    56742.9
                  ],
                  [
                    53691.5,
                    56773.3
                  ],
                  [
                    53771.6,
                    56787.5
                  ],
                  [
                    53808.7,
                    56819.8
                  ],
                  [
                    53861.6,
                    56807.6
                  ],
                  [
                    53927,
                    56723
                  ],
                  [
                    53978.8,
                    56708.5
                  ],
                  [
                    54072.9,
                    56757.5
                  ],
                  [
                    54275.4,
                    56697.5
                  ],
                  [
                    54374.2,
                    56615.8
                  ],
                  [
                    54513,
                    56544.9
                  ],
                  [
                    54546,
                    56704.7
                  ],
                  [
                    54491.3,
                    56758
                  ],
                  [
                    54290.8,
                    56795
                  ],
                  [
                    54080.5,
                    56849.4
                  ],
                  [
                    54041.9,
                    56928.2
                  ],
                  [
                    54063.5,
                    57025.3
                  ],
                  [
                    54250.6,
                    57060.7
                  ],
                  [
                    54482.3,
                    57040.2
                  ],
                  [
                    54416.9,
                    57282.3
                  ],
                  [
                    54319,
                    57285
                  ],
                  [
                    54226.9,
                    57227.1
                  ],
                  [
                    54161.8,
                    57153.1
                  ],
                  [
                    54067,
                    57131.4
                  ],
                  [
                    53987.4,
                    57191.8
                  ],
                  [
                    53852.4,
                    57188.8
                  ],
                  [
                    53647.4,
                    57092.3
                  ],
                  [
                    53595.5,
                    57077.8
                  ],
                  [
                    53459.6,
                    57077.7
                  ],
                  [
                    53391.9,
                    57089.3
                  ],
                  [
                    53325.1,
                    57128.4
                  ],
                  [
                    53199.6,
                    57070.9
                  ],
                  [
                    53037.9,
                    57040.8
                  ],
                  [
                    52792.5,
                    57069.1
                  ],
                  [
                    52675.7,
                    57095.8
                  ],
                  [
                    52605.9,
                    57180.2
                  ],
                  [
                    52530.6,
                    57197.6
                  ],
                  [
                    52419.3,
                    57335.5
                  ],
                  [
                    52336.9,
                    57118.7
                  ],
                  [
                    52412.5,
                    56937.9
                  ],
                  [
                    52261.4,
                    56624.4
                  ],
                  [
                    52459,
                    56724.8
                  ],
                  [
                    52612.4,
                    56724.7
                  ],
                  [
                    52703.6,
                    56792.4
                  ],
                  [
                    52876.4,
                    56763.3
                  ],
                  [
                    52942,
                    56703.5
                  ],
                  [
                    53145.2,
                    56758
                  ]
                ],
                "id": 1637,
                "chat_link": "[&BGUGAAA=]"
              },
              "1638": {
                "name": "Chukara Sea",
                "level": 80,
                "coord": [
                  52492.4,
                  57281.3
                ],
                "bounds": [
                  [
                    52750.8,
                    58232.9
                  ],
                  [
                    52860.9,
                    58528.6
                  ],
                  [
                    52988,
                    58629.9
                  ],
                  [
                    53158.7,
                    58726.6
                  ],
                  [
                    52640.5,
                    58977.3
                  ],
                  [
                    52251.5,
                    58529.8
                  ],
                  [
                    52161.7,
                    58309
                  ],
                  [
                    52144.9,
                    57100.9
                  ],
                  [
                    52223.9,
                    55933.8
                  ],
                  [
                    52509.4,
                    55749
                  ],
                  [
                    52593.6,
                    55876.4
                  ],
                  [
                    52660,
                    56015.2
                  ],
                  [
                    52779.1,
                    56182.2
                  ],
                  [
                    52602,
                    56226.2
                  ],
                  [
                    52403,
                    56275.2
                  ],
                  [
                    52235.8,
                    56366.6
                  ],
                  [
                    52240.2,
                    56538.2
                  ],
                  [
                    52261.4,
                    56624.4
                  ],
                  [
                    52412.5,
                    56937.9
                  ],
                  [
                    52336.9,
                    57118.7
                  ],
                  [
                    52419.3,
                    57335.5
                  ],
                  [
                    52394.3,
                    57445.6
                  ],
                  [
                    52340.1,
                    57668.2
                  ],
                  [
                    52463.8,
                    57899.3
                  ],
                  [
                    52444.4,
                    57977.4
                  ],
                  [
                    52526.7,
                    58107.9
                  ],
                  [
                    52750.8,
                    58232.9
                  ]
                ],
                "id": 1638,
                "chat_link": "[&BGYGAAA=]"
              },
              "1639": {
                "name": "Western Complex",
                "level": 80,
                "coord": [
                  53209.8,
                  57731.1
                ],
                "bounds": [
                  [
                    53324.4,
                    57603.6
                  ],
                  [
                    53306,
                    57797.5
                  ],
                  [
                    53266.9,
                    58055.7
                  ],
                  [
                    53631.3,
                    58328.4
                  ],
                  [
                    53522,
                    58474.5
                  ],
                  [
                    53353.2,
                    58495.8
                  ],
                  [
                    53269,
                    58387.2
                  ],
                  [
                    53160.2,
                    58353.6
                  ],
                  [
                    53040,
                    58285.9
                  ],
                  [
                    52937.6,
                    58145.8
                  ],
                  [
                    52842,
                    57937
                  ],
                  [
                    52885.1,
                    57915.3
                  ],
                  [
                    52886.3,
                    57864.8
                  ],
                  [
                    52816.7,
                    57755.5
                  ],
                  [
                    52764.6,
                    57533.4
                  ],
                  [
                    52796.3,
                    57390.8
                  ],
                  [
                    52843.1,
                    57283.4
                  ],
                  [
                    52907.3,
                    57287
                  ],
                  [
                    53021.8,
                    57316.8
                  ],
                  [
                    53156.9,
                    57289.1
                  ],
                  [
                    53262.5,
                    57301.9
                  ],
                  [
                    53364,
                    57272.2
                  ],
                  [
                    53487.6,
                    57346.1
                  ],
                  [
                    53597,
                    57291.5
                  ],
                  [
                    53702.5,
                    57310.9
                  ],
                  [
                    53771.6,
                    57279.9
                  ],
                  [
                    53749.6,
                    57436.3
                  ],
                  [
                    53324.4,
                    57603.6
                  ]
                ],
                "id": 1639,
                "chat_link": "[&BGcGAAA=]"
              },
              "1640": {
                "name": "The Ruined Paths",
                "level": 80,
                "coord": [
                  53984.1,
                  56536.9
                ],
                "bounds": [
                  [
                    54625.2,
                    56368.6
                  ],
                  [
                    54664.8,
                    56416.9
                  ],
                  [
                    54691.4,
                    56544.3
                  ],
                  [
                    54581.3,
                    56545
                  ],
                  [
                    54513,
                    56544.9
                  ],
                  [
                    54374.2,
                    56615.8
                  ],
                  [
                    54275.4,
                    56697.5
                  ],
                  [
                    54072.9,
                    56757.5
                  ],
                  [
                    53978.8,
                    56708.5
                  ],
                  [
                    53927,
                    56723
                  ],
                  [
                    53861.6,
                    56807.6
                  ],
                  [
                    53808.7,
                    56819.8
                  ],
                  [
                    53771.6,
                    56787.5
                  ],
                  [
                    53691.5,
                    56773.3
                  ],
                  [
                    53599.9,
                    56742.9
                  ],
                  [
                    53502,
                    56771.5
                  ],
                  [
                    53488.1,
                    56549.8
                  ],
                  [
                    53396.9,
                    56504.2
                  ],
                  [
                    53421.3,
                    56408.8
                  ],
                  [
                    53415.3,
                    56366.2
                  ],
                  [
                    53472.4,
                    56247.3
                  ],
                  [
                    53763.4,
                    56306.9
                  ],
                  [
                    53800.8,
                    56257.9
                  ],
                  [
                    53978.1,
                    56228.8
                  ],
                  [
                    54211.1,
                    56293.1
                  ],
                  [
                    54279.2,
                    56362.3
                  ],
                  [
                    54405,
                    56346.8
                  ],
                  [
                    54625.2,
                    56368.6
                  ]
                ],
                "id": 1640,
                "chat_link": "[&BGgGAAA=]"
              },
              "1643": {
                "name": "Tyrulu Sea",
                "level": 80,
                "coord": [
                  54700.8,
                  56929.9
                ],
                "bounds": [
                  [
                    54780.2,
                    55734.3
                  ],
                  [
                    55072.9,
                    55924.5
                  ],
                  [
                    55153.2,
                    56060.1
                  ],
                  [
                    55123.3,
                    56991.8
                  ],
                  [
                    55110,
                    57724.7
                  ],
                  [
                    55111.6,
                    58039.6
                  ],
                  [
                    55078.3,
                    58275.7
                  ],
                  [
                    54949.8,
                    58227
                  ],
                  [
                    54821,
                    58142.3
                  ],
                  [
                    54599.8,
                    58155
                  ],
                  [
                    54602.4,
                    57861.9
                  ],
                  [
                    54678.8,
                    57828.4
                  ],
                  [
                    54730.5,
                    57756.8
                  ],
                  [
                    54556,
                    57493.8
                  ],
                  [
                    54557.1,
                    57434.6
                  ],
                  [
                    54523.3,
                    57351.1
                  ],
                  [
                    54416.9,
                    57282.3
                  ],
                  [
                    54482.3,
                    57040.2
                  ],
                  [
                    54532.4,
                    56998.3
                  ],
                  [
                    54568.2,
                    56901.1
                  ],
                  [
                    54491.3,
                    56758
                  ],
                  [
                    54546,
                    56704.7
                  ],
                  [
                    54513,
                    56544.9
                  ],
                  [
                    54691.4,
                    56544.3
                  ],
                  [
                    54664.8,
                    56416.9
                  ],
                  [
                    54625.2,
                    56368.6
                  ],
                  [
                    54675.8,
                    56226.1
                  ],
                  [
                    54690.3,
                    56044.1
                  ],
                  [
                    54628.9,
                    55995.3
                  ],
                  [
                    54540.1,
                    56035.1
                  ],
                  [
                    54477.8,
                    56021.6
                  ],
                  [
                    54478.9,
                    55970.8
                  ],
                  [
                    54655.8,
                    55831.5
                  ],
                  [
                    54780.2,
                    55734.3
                  ]
                ],
                "id": 1643,
                "chat_link": "[&BGsGAAA=]"
              }
            },
            "adventures": [],
            "id": 1271,
            "mastery_points": [
              {
                "coord": [
                  52336.8,
                  56479.8
                ],
                "id": 429,
                "region": "Desert"
              },
              {
                "coord": [
                  53004.4,
                  55936.6
                ],
                "id": 426,
                "region": "Desert"
              },
              {
                "coord": [
                  53694,
                  57863.6
                ],
                "id": 427,
                "region": "Desert"
              },
              {
                "coord": [
                  54633.8,
                  59133.3
                ],
                "id": 428,
                "region": "Desert"
              }
            ]
          },
          "1276": {
            "name": "The Test Subject",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              53768,
              57384
            ],
            "map_rect": [
              [
                -36864,
                -52224
              ],
              [
                39936,
                52224
              ]
            ],
            "continent_rect": [
              [
                51994,
                55402
              ],
              [
                55194,
                59754
              ]
            ],
            "points_of_interest": {
              "2851": {
                "name": "Communications Control",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52911.8,
                  57638
                ],
                "id": 2851,
                "chat_link": "[&BCMLAAA=]"
              },
              "2852": {
                "name": "Jemandi Market",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53240.8,
                  56371.2
                ],
                "id": 2852,
                "chat_link": "[&BCQLAAA=]"
              },
              "2854": {
                "name": "Lab Sigma-05",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54404,
                  56896.5
                ],
                "id": 2854,
                "chat_link": "[&BCYLAAA=]"
              },
              "2855": {
                "name": "The Iron Whale",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53188.4,
                  56590.9
                ],
                "id": 2855,
                "chat_link": "[&BCcLAAA=]"
              },
              "2856": {
                "name": "Magistorm Gallery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54177.6,
                  57553.2
                ],
                "id": 2856,
                "chat_link": "[&BCgLAAA=]"
              },
              "2857": {
                "name": "Tunnel Access Epsilon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52913,
                  57841.9
                ],
                "id": 2857,
                "chat_link": "[&BCkLAAA=]"
              },
              "2858": {
                "name": "Tunnel Access Beta",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53453.4,
                  57788.2
                ],
                "id": 2858,
                "chat_link": "[&BCoLAAA=]"
              },
              "2859": {
                "name": "Ritual Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52755.1,
                  56663
                ],
                "id": 2859,
                "chat_link": "[&BCsLAAA=]"
              },
              "2860": {
                "name": "Ewyn's Retreat",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53529.9,
                  55969.3
                ],
                "id": 2860,
                "chat_link": "[&BCwLAAA=]"
              },
              "2861": {
                "name": "Magnetics Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54729.4,
                  58798.5
                ],
                "id": 2861,
                "chat_link": "[&BC0LAAA=]"
              },
              "2862": {
                "name": "Tunnel Access Delta",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53258.8,
                  57310
                ],
                "id": 2862,
                "chat_link": "[&BC4LAAA=]"
              },
              "2864": {
                "name": "Reserve Power Core",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54649.9,
                  57737.8
                ],
                "id": 2864,
                "chat_link": "[&BDALAAA=]"
              },
              "2865": {
                "name": "Deepwater Cooling Sink",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53687.3,
                  57883
                ],
                "id": 2865,
                "chat_link": "[&BDELAAA=]"
              },
              "2866": {
                "name": "Skycavern Burial Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54516.7,
                  55768.8
                ],
                "id": 2866,
                "chat_link": "[&BDILAAA=]"
              },
              "2867": {
                "name": "Driftwood Jetty",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53758.9,
                  56807.2
                ],
                "id": 2867,
                "chat_link": "[&BDMLAAA=]"
              },
              "2868": {
                "name": "Necrobrand Emulation Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54414.4,
                  58000.8
                ],
                "id": 2868,
                "chat_link": "[&BDQLAAA=]"
              },
              "2869": {
                "name": "Atholma Docks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52565.9,
                  56431.1
                ],
                "id": 2869,
                "chat_link": "[&BDULAAA=]"
              },
              "2870": {
                "name": "Malor's Ranch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53535.6,
                  56463.4
                ],
                "id": 2870,
                "chat_link": "[&BDYLAAA=]"
              },
              "2871": {
                "name": "Communications Array",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52831.2,
                  57539.8
                ],
                "id": 2871,
                "chat_link": "[&BDcLAAA=]"
              },
              "2872": {
                "name": "Tunnel Access Alpha",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53793.4,
                  57648.5
                ],
                "id": 2872,
                "chat_link": "[&BDgLAAA=]"
              },
              "2873": {
                "name": "Leyfinder Research Facility",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53650.5,
                  58653.2
                ],
                "id": 2873,
                "chat_link": "[&BDkLAAA=]"
              },
              "2875": {
                "name": "Effluent Outflow Network",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53370.8,
                  58498.5
                ],
                "id": 2875,
                "chat_link": "[&BDsLAAA=]"
              },
              "2877": {
                "name": "Olma's Legacy",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52974.7,
                  55970.4
                ],
                "id": 2877,
                "chat_link": "[&BD0LAAA=]"
              },
              "2878": {
                "name": "Greytear Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54478.7,
                  55985
                ],
                "id": 2878,
                "chat_link": "[&BD4LAAA=]"
              },
              "2879": {
                "name": "Tunnel Access Gamma",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54033.2,
                  57499
                ],
                "id": 2879,
                "chat_link": "[&BD8LAAA=]"
              },
              "2880": {
                "name": "Cerberus Watchtowers",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52677.4,
                  57756.7
                ],
                "id": 2880,
                "chat_link": "[&BEALAAA=]"
              },
              "2882": {
                "name": "Anniogel Landing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54386.9,
                  57286.6
                ],
                "id": 2882,
                "chat_link": "[&BEILAAA=]"
              },
              "2884": {
                "name": "Portalforge Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  54755.8,
                  58404.8
                ],
                "id": 2884,
                "chat_link": "[&BEQLAAA=]"
              },
              "2886": {
                "name": "Specimen Chamber",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53117.7,
                  57920.6
                ],
                "id": 2886,
                "chat_link": "[&BEYLAAA=]"
              },
              "2887": {
                "name": "Rata Primus Canal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53607.8,
                  58249.2
                ],
                "id": 2887,
                "chat_link": "[&BEcLAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1624": {
                "name": "Rata Primus",
                "level": 80,
                "coord": [
                  53687.6,
                  57882.8
                ],
                "bounds": [
                  [
                    53749.6,
                    57436.3
                  ],
                  [
                    54107.6,
                    57712.3
                  ],
                  [
                    54045.8,
                    58160.7
                  ],
                  [
                    53631.3,
                    58328.4
                  ],
                  [
                    53266.9,
                    58055.7
                  ],
                  [
                    53324.4,
                    57603.6
                  ],
                  [
                    53749.6,
                    57436.3
                  ]
                ],
                "id": 1624,
                "chat_link": "[&BFgGAAA=]"
              },
              "1625": {
                "name": "Eastern Complex",
                "level": 80,
                "coord": [
                  54076.1,
                  57901.5
                ],
                "bounds": [
                  [
                    54107.6,
                    57712.3
                  ],
                  [
                    53749.6,
                    57436.3
                  ],
                  [
                    53771.6,
                    57279.9
                  ],
                  [
                    53860.8,
                    57326.8
                  ],
                  [
                    54023.4,
                    57286.9
                  ],
                  [
                    54226.9,
                    57227.1
                  ],
                  [
                    54319,
                    57285
                  ],
                  [
                    54341.9,
                    57365.5
                  ],
                  [
                    54447.2,
                    57419.2
                  ],
                  [
                    54492.8,
                    57701.7
                  ],
                  [
                    54472.5,
                    57905.8
                  ],
                  [
                    54451.1,
                    58081.1
                  ],
                  [
                    54336.4,
                    58163
                  ],
                  [
                    54277,
                    58299.3
                  ],
                  [
                    54172.5,
                    58459.3
                  ],
                  [
                    54001.7,
                    58449.3
                  ],
                  [
                    53927.5,
                    58383
                  ],
                  [
                    53860.9,
                    58354.3
                  ],
                  [
                    53796.5,
                    58385.1
                  ],
                  [
                    53743.4,
                    58374.7
                  ],
                  [
                    53693.1,
                    58350.5
                  ],
                  [
                    53631.3,
                    58328.4
                  ],
                  [
                    54045.8,
                    58160.7
                  ],
                  [
                    54107.6,
                    57712.3
                  ]
                ],
                "id": 1625,
                "chat_link": "[&BFkGAAA=]"
              },
              "1626": {
                "name": "Atholma",
                "level": 80,
                "coord": [
                  52950.2,
                  56490
                ],
                "bounds": [
                  [
                    53339.9,
                    56357.5
                  ],
                  [
                    53415.3,
                    56366.2
                  ],
                  [
                    53421.3,
                    56408.8
                  ],
                  [
                    53396.9,
                    56504.2
                  ],
                  [
                    53488.1,
                    56549.8
                  ],
                  [
                    53502,
                    56771.5
                  ],
                  [
                    53435.8,
                    56719.2
                  ],
                  [
                    53308.3,
                    56680.8
                  ],
                  [
                    53145.2,
                    56758
                  ],
                  [
                    52942,
                    56703.5
                  ],
                  [
                    52876.4,
                    56763.3
                  ],
                  [
                    52703.6,
                    56792.4
                  ],
                  [
                    52612.4,
                    56724.7
                  ],
                  [
                    52459,
                    56724.8
                  ],
                  [
                    52261.4,
                    56624.4
                  ],
                  [
                    52240.2,
                    56538.2
                  ],
                  [
                    52235.8,
                    56366.6
                  ],
                  [
                    52403,
                    56275.2
                  ],
                  [
                    52602,
                    56226.2
                  ],
                  [
                    52779.1,
                    56182.2
                  ],
                  [
                    52896.8,
                    56217.5
                  ],
                  [
                    52996,
                    56312.8
                  ],
                  [
                    53019.5,
                    56243.1
                  ],
                  [
                    53068.8,
                    56197.4
                  ],
                  [
                    53205.6,
                    56241.8
                  ],
                  [
                    53339.9,
                    56357.5
                  ]
                ],
                "id": 1626,
                "chat_link": "[&BFoGAAA=]"
              },
              "1627": {
                "name": "The Hunting Grounds",
                "level": 80,
                "coord": [
                  53711.6,
                  55985.1
                ],
                "bounds": [
                  [
                    54689.7,
                    55664.6
                  ],
                  [
                    54780.2,
                    55734.3
                  ],
                  [
                    54655.8,
                    55831.5
                  ],
                  [
                    54478.9,
                    55970.8
                  ],
                  [
                    54477.8,
                    56021.6
                  ],
                  [
                    54540.1,
                    56035.1
                  ],
                  [
                    54628.9,
                    55995.3
                  ],
                  [
                    54690.3,
                    56044.1
                  ],
                  [
                    54675.8,
                    56226.1
                  ],
                  [
                    54625.2,
                    56368.6
                  ],
                  [
                    54405,
                    56346.8
                  ],
                  [
                    54279.2,
                    56362.3
                  ],
                  [
                    54211.1,
                    56293.1
                  ],
                  [
                    53978.1,
                    56228.8
                  ],
                  [
                    53800.8,
                    56257.9
                  ],
                  [
                    53763.4,
                    56306.9
                  ],
                  [
                    53472.4,
                    56247.3
                  ],
                  [
                    53415.3,
                    56366.2
                  ],
                  [
                    53339.9,
                    56357.5
                  ],
                  [
                    53205.6,
                    56241.8
                  ],
                  [
                    53068.8,
                    56197.4
                  ],
                  [
                    53019.5,
                    56243.1
                  ],
                  [
                    52996,
                    56312.8
                  ],
                  [
                    52896.8,
                    56217.5
                  ],
                  [
                    52779.1,
                    56182.2
                  ],
                  [
                    52660,
                    56015.2
                  ],
                  [
                    52593.6,
                    55876.4
                  ],
                  [
                    52509.4,
                    55749
                  ],
                  [
                    52557.4,
                    55710.1
                  ],
                  [
                    52926.6,
                    55681.3
                  ],
                  [
                    52998.5,
                    55747
                  ],
                  [
                    53095.6,
                    55752
                  ],
                  [
                    53216.4,
                    55717.2
                  ],
                  [
                    53315.5,
                    55620.2
                  ],
                  [
                    53433.9,
                    55608.5
                  ],
                  [
                    53513.6,
                    55647.8
                  ],
                  [
                    53654.4,
                    55693.5
                  ],
                  [
                    53797,
                    55660.3
                  ],
                  [
                    53959.2,
                    55678.8
                  ],
                  [
                    54103,
                    55749.2
                  ],
                  [
                    54200.7,
                    55763.7
                  ],
                  [
                    54480.3,
                    55649.4
                  ],
                  [
                    54689.7,
                    55664.6
                  ]
                ],
                "id": 1627,
                "chat_link": "[&BFsGAAA=]"
              },
              "1628": {
                "name": "Northern Complex Coves",
                "level": 80,
                "coord": [
                  53375,
                  57213.5
                ],
                "bounds": [
                  [
                    52713,
                    57332.3
                  ],
                  [
                    52796.3,
                    57390.8
                  ],
                  [
                    52843.1,
                    57283.4
                  ],
                  [
                    52907.3,
                    57287
                  ],
                  [
                    53021.8,
                    57316.8
                  ],
                  [
                    53156.9,
                    57289.1
                  ],
                  [
                    53262.5,
                    57301.9
                  ],
                  [
                    53364,
                    57272.2
                  ],
                  [
                    53487.6,
                    57346.1
                  ],
                  [
                    53597,
                    57291.5
                  ],
                  [
                    53702.5,
                    57310.9
                  ],
                  [
                    53771.6,
                    57279.9
                  ],
                  [
                    53860.8,
                    57326.8
                  ],
                  [
                    54023.4,
                    57286.9
                  ],
                  [
                    54226.9,
                    57227.1
                  ],
                  [
                    54161.8,
                    57153.1
                  ],
                  [
                    54067,
                    57131.4
                  ],
                  [
                    53987.4,
                    57191.8
                  ],
                  [
                    53852.4,
                    57188.8
                  ],
                  [
                    53647.4,
                    57092.3
                  ],
                  [
                    53595.5,
                    57077.8
                  ],
                  [
                    53459.6,
                    57077.7
                  ],
                  [
                    53391.9,
                    57089.3
                  ],
                  [
                    53325.1,
                    57128.4
                  ],
                  [
                    53199.6,
                    57070.9
                  ],
                  [
                    53037.9,
                    57040.8
                  ],
                  [
                    52792.5,
                    57069.1
                  ],
                  [
                    52675.7,
                    57095.8
                  ],
                  [
                    52605.9,
                    57180.2
                  ],
                  [
                    52716.8,
                    57276.4
                  ],
                  [
                    52713,
                    57332.3
                  ]
                ],
                "id": 1628,
                "chat_link": "[&BFwGAAA=]"
              },
              "1629": {
                "name": "Reserve Generator Site",
                "level": 80,
                "coord": [
                  54513.6,
                  57631.8
                ],
                "bounds": [
                  [
                    54341.9,
                    57365.5
                  ],
                  [
                    54447.2,
                    57419.2
                  ],
                  [
                    54492.8,
                    57701.7
                  ],
                  [
                    54472.5,
                    57905.8
                  ],
                  [
                    54451.1,
                    58081.1
                  ],
                  [
                    54601.5,
                    58078.3
                  ],
                  [
                    54602.4,
                    57861.9
                  ],
                  [
                    54678.8,
                    57828.4
                  ],
                  [
                    54730.5,
                    57756.8
                  ],
                  [
                    54556,
                    57493.8
                  ],
                  [
                    54557.1,
                    57434.6
                  ],
                  [
                    54523.3,
                    57351.1
                  ],
                  [
                    54416.9,
                    57282.3
                  ],
                  [
                    54319,
                    57285
                  ],
                  [
                    54341.9,
                    57365.5
                  ]
                ],
                "id": 1629,
                "chat_link": "[&BF0GAAA=]"
              },
              "1630": {
                "name": "Damos Isle",
                "level": 80,
                "coord": [
                  53336.2,
                  58559.9
                ],
                "bounds": [
                  [
                    53692.3,
                    58505
                  ],
                  [
                    53798.4,
                    58624.7
                  ],
                  [
                    53940.1,
                    58633.7
                  ],
                  [
                    53965.9,
                    58757.8
                  ],
                  [
                    53878.5,
                    58951.3
                  ],
                  [
                    53628.5,
                    59028.8
                  ],
                  [
                    53399.8,
                    59012.9
                  ],
                  [
                    53244.8,
                    58758.1
                  ],
                  [
                    53158.7,
                    58726.6
                  ],
                  [
                    52988,
                    58629.9
                  ],
                  [
                    52860.9,
                    58528.6
                  ],
                  [
                    52750.8,
                    58232.9
                  ],
                  [
                    52798.4,
                    58105.1
                  ],
                  [
                    52937.6,
                    58145.8
                  ],
                  [
                    53040,
                    58285.9
                  ],
                  [
                    53160.2,
                    58353.6
                  ],
                  [
                    53269,
                    58387.2
                  ],
                  [
                    53353.2,
                    58495.8
                  ],
                  [
                    53522,
                    58474.5
                  ],
                  [
                    53692.3,
                    58505
                  ]
                ],
                "id": 1630,
                "chat_link": "[&BF4GAAA=]"
              },
              "1631": {
                "name": "Calon Islet",
                "level": 80,
                "coord": [
                  54311.3,
                  56928.4
                ],
                "bounds": [
                  [
                    54491.3,
                    56758
                  ],
                  [
                    54568.2,
                    56901.1
                  ],
                  [
                    54532.4,
                    56998.3
                  ],
                  [
                    54482.3,
                    57040.2
                  ],
                  [
                    54250.6,
                    57060.7
                  ],
                  [
                    54063.5,
                    57025.3
                  ],
                  [
                    54041.9,
                    56928.2
                  ],
                  [
                    54080.5,
                    56849.4
                  ],
                  [
                    54290.8,
                    56795
                  ],
                  [
                    54491.3,
                    56758
                  ]
                ],
                "id": 1631,
                "chat_link": "[&BF8GAAA=]"
              },
              "1632": {
                "name": "Invariant Enclave",
                "level": 80,
                "coord": [
                  54469.6,
                  58872.9
                ],
                "bounds": [
                  [
                    55096.9,
                    58489.7
                  ],
                  [
                    55033.3,
                    59017.5
                  ],
                  [
                    54964.4,
                    59462.7
                  ],
                  [
                    54790.7,
                    59688.4
                  ],
                  [
                    54508.8,
                    59670.2
                  ],
                  [
                    54367.3,
                    59653.9
                  ],
                  [
                    54288.6,
                    59548.1
                  ],
                  [
                    54280,
                    59449.2
                  ],
                  [
                    54235.1,
                    59363.1
                  ],
                  [
                    54064.7,
                    59285.4
                  ],
                  [
                    54026.3,
                    59160
                  ],
                  [
                    54081.4,
                    58895.6
                  ],
                  [
                    54084.8,
                    58832.9
                  ],
                  [
                    54109.3,
                    58754.3
                  ],
                  [
                    54122.7,
                    58661.8
                  ],
                  [
                    54208.5,
                    58616.9
                  ],
                  [
                    54291.6,
                    58569.6
                  ],
                  [
                    54318.8,
                    58495.8
                  ],
                  [
                    54449.2,
                    58299.3
                  ],
                  [
                    54500.4,
                    58235.4
                  ],
                  [
                    54599.8,
                    58155
                  ],
                  [
                    54821,
                    58142.3
                  ],
                  [
                    54949.8,
                    58227
                  ],
                  [
                    55078.3,
                    58275.7
                  ],
                  [
                    55096.9,
                    58489.7
                  ]
                ],
                "id": 1632,
                "chat_link": "[&BGAGAAA=]"
              },
              "1635": {
                "name": "Griffonstone Buttresses",
                "level": 80,
                "coord": [
                  52664.9,
                  57700.1
                ],
                "bounds": [
                  [
                    52816.7,
                    57755.5
                  ],
                  [
                    52886.3,
                    57864.8
                  ],
                  [
                    52885.1,
                    57915.3
                  ],
                  [
                    52842,
                    57937
                  ],
                  [
                    52937.6,
                    58145.8
                  ],
                  [
                    52798.4,
                    58105.1
                  ],
                  [
                    52750.8,
                    58232.9
                  ],
                  [
                    52526.7,
                    58107.9
                  ],
                  [
                    52444.4,
                    57977.4
                  ],
                  [
                    52463.8,
                    57899.3
                  ],
                  [
                    52340.1,
                    57668.2
                  ],
                  [
                    52394.3,
                    57445.6
                  ],
                  [
                    52419.3,
                    57335.5
                  ],
                  [
                    52530.6,
                    57197.6
                  ],
                  [
                    52605.9,
                    57180.2
                  ],
                  [
                    52716.8,
                    57276.4
                  ],
                  [
                    52713,
                    57332.3
                  ],
                  [
                    52796.3,
                    57390.8
                  ],
                  [
                    52764.6,
                    57533.4
                  ],
                  [
                    52816.7,
                    57755.5
                  ]
                ],
                "id": 1635,
                "chat_link": "[&BGMGAAA=]"
              },
              "1636": {
                "name": "Sargol Sea",
                "level": 80,
                "coord": [
                  53949,
                  58779.9
                ],
                "bounds": [
                  [
                    53965.9,
                    58757.8
                  ],
                  [
                    53940.1,
                    58633.7
                  ],
                  [
                    53798.4,
                    58624.7
                  ],
                  [
                    53692.3,
                    58505
                  ],
                  [
                    53522,
                    58474.5
                  ],
                  [
                    53631.3,
                    58328.4
                  ],
                  [
                    53693.1,
                    58350.5
                  ],
                  [
                    53743.4,
                    58374.7
                  ],
                  [
                    53796.5,
                    58385.1
                  ],
                  [
                    53860.9,
                    58354.3
                  ],
                  [
                    53927.5,
                    58383
                  ],
                  [
                    54001.7,
                    58449.3
                  ],
                  [
                    54172.5,
                    58459.3
                  ],
                  [
                    54277,
                    58299.3
                  ],
                  [
                    54336.4,
                    58163
                  ],
                  [
                    54451.1,
                    58081.1
                  ],
                  [
                    54601.5,
                    58078.3
                  ],
                  [
                    54599.8,
                    58155
                  ],
                  [
                    54500.4,
                    58235.4
                  ],
                  [
                    54449.2,
                    58299.3
                  ],
                  [
                    54318.8,
                    58495.8
                  ],
                  [
                    54291.6,
                    58569.6
                  ],
                  [
                    54208.5,
                    58616.9
                  ],
                  [
                    54122.7,
                    58661.8
                  ],
                  [
                    54109.3,
                    58754.3
                  ],
                  [
                    54084.8,
                    58832.9
                  ],
                  [
                    54081.4,
                    58895.6
                  ],
                  [
                    54026.3,
                    59160
                  ],
                  [
                    54064.7,
                    59285.4
                  ],
                  [
                    54235.1,
                    59363.1
                  ],
                  [
                    54280,
                    59449.2
                  ],
                  [
                    54288.6,
                    59548.1
                  ],
                  [
                    54367.3,
                    59653.9
                  ],
                  [
                    54240.1,
                    59690.1
                  ],
                  [
                    53998.8,
                    59697.8
                  ],
                  [
                    53658,
                    59700.3
                  ],
                  [
                    53375.6,
                    59657.9
                  ],
                  [
                    53093.8,
                    59437.8
                  ],
                  [
                    52640.5,
                    58977.3
                  ],
                  [
                    53158.7,
                    58726.6
                  ],
                  [
                    53244.8,
                    58758.1
                  ],
                  [
                    53399.8,
                    59012.9
                  ],
                  [
                    53628.5,
                    59028.8
                  ],
                  [
                    53878.5,
                    58951.3
                  ],
                  [
                    53965.9,
                    58757.8
                  ]
                ],
                "id": 1636,
                "chat_link": "[&BGQGAAA=]"
              },
              "1637": {
                "name": "Strait of Panube",
                "level": 80,
                "coord": [
                  53556.6,
                  56927.5
                ],
                "bounds": [
                  [
                    53145.2,
                    56758
                  ],
                  [
                    53308.3,
                    56680.8
                  ],
                  [
                    53435.8,
                    56719.2
                  ],
                  [
                    53502,
                    56771.5
                  ],
                  [
                    53599.9,
                    56742.9
                  ],
                  [
                    53691.5,
                    56773.3
                  ],
                  [
                    53771.6,
                    56787.5
                  ],
                  [
                    53808.7,
                    56819.8
                  ],
                  [
                    53861.6,
                    56807.6
                  ],
                  [
                    53927,
                    56723
                  ],
                  [
                    53978.8,
                    56708.5
                  ],
                  [
                    54072.9,
                    56757.5
                  ],
                  [
                    54275.4,
                    56697.5
                  ],
                  [
                    54374.2,
                    56615.8
                  ],
                  [
                    54513,
                    56544.9
                  ],
                  [
                    54546,
                    56704.7
                  ],
                  [
                    54491.3,
                    56758
                  ],
                  [
                    54290.8,
                    56795
                  ],
                  [
                    54080.5,
                    56849.4
                  ],
                  [
                    54041.9,
                    56928.2
                  ],
                  [
                    54063.5,
                    57025.3
                  ],
                  [
                    54250.6,
                    57060.7
                  ],
                  [
                    54482.3,
                    57040.2
                  ],
                  [
                    54416.9,
                    57282.3
                  ],
                  [
                    54319,
                    57285
                  ],
                  [
                    54226.9,
                    57227.1
                  ],
                  [
                    54161.8,
                    57153.1
                  ],
                  [
                    54067,
                    57131.4
                  ],
                  [
                    53987.4,
                    57191.8
                  ],
                  [
                    53852.4,
                    57188.8
                  ],
                  [
                    53647.4,
                    57092.3
                  ],
                  [
                    53595.5,
                    57077.8
                  ],
                  [
                    53459.6,
                    57077.7
                  ],
                  [
                    53391.9,
                    57089.3
                  ],
                  [
                    53325.1,
                    57128.4
                  ],
                  [
                    53199.6,
                    57070.9
                  ],
                  [
                    53037.9,
                    57040.8
                  ],
                  [
                    52792.5,
                    57069.1
                  ],
                  [
                    52675.7,
                    57095.8
                  ],
                  [
                    52605.9,
                    57180.2
                  ],
                  [
                    52530.6,
                    57197.6
                  ],
                  [
                    52419.3,
                    57335.5
                  ],
                  [
                    52336.9,
                    57118.7
                  ],
                  [
                    52412.5,
                    56937.9
                  ],
                  [
                    52261.4,
                    56624.4
                  ],
                  [
                    52459,
                    56724.8
                  ],
                  [
                    52612.4,
                    56724.7
                  ],
                  [
                    52703.6,
                    56792.4
                  ],
                  [
                    52876.4,
                    56763.3
                  ],
                  [
                    52942,
                    56703.5
                  ],
                  [
                    53145.2,
                    56758
                  ]
                ],
                "id": 1637,
                "chat_link": "[&BGUGAAA=]"
              },
              "1638": {
                "name": "Chukara Sea",
                "level": 80,
                "coord": [
                  52492.4,
                  57281.3
                ],
                "bounds": [
                  [
                    52750.8,
                    58232.9
                  ],
                  [
                    52860.9,
                    58528.6
                  ],
                  [
                    52988,
                    58629.9
                  ],
                  [
                    53158.7,
                    58726.6
                  ],
                  [
                    52640.5,
                    58977.3
                  ],
                  [
                    52251.5,
                    58529.8
                  ],
                  [
                    52161.7,
                    58309
                  ],
                  [
                    52144.9,
                    57100.9
                  ],
                  [
                    52223.9,
                    55933.8
                  ],
                  [
                    52509.4,
                    55749
                  ],
                  [
                    52593.6,
                    55876.4
                  ],
                  [
                    52660,
                    56015.2
                  ],
                  [
                    52779.1,
                    56182.2
                  ],
                  [
                    52602,
                    56226.2
                  ],
                  [
                    52403,
                    56275.2
                  ],
                  [
                    52235.8,
                    56366.6
                  ],
                  [
                    52240.2,
                    56538.2
                  ],
                  [
                    52261.4,
                    56624.4
                  ],
                  [
                    52412.5,
                    56937.9
                  ],
                  [
                    52336.9,
                    57118.7
                  ],
                  [
                    52419.3,
                    57335.5
                  ],
                  [
                    52394.3,
                    57445.6
                  ],
                  [
                    52340.1,
                    57668.2
                  ],
                  [
                    52463.8,
                    57899.3
                  ],
                  [
                    52444.4,
                    57977.4
                  ],
                  [
                    52526.7,
                    58107.9
                  ],
                  [
                    52750.8,
                    58232.9
                  ]
                ],
                "id": 1638,
                "chat_link": "[&BGYGAAA=]"
              },
              "1639": {
                "name": "Western Complex",
                "level": 80,
                "coord": [
                  53209.8,
                  57731.1
                ],
                "bounds": [
                  [
                    53324.4,
                    57603.6
                  ],
                  [
                    53306,
                    57797.5
                  ],
                  [
                    53266.9,
                    58055.7
                  ],
                  [
                    53631.3,
                    58328.4
                  ],
                  [
                    53522,
                    58474.5
                  ],
                  [
                    53353.2,
                    58495.8
                  ],
                  [
                    53269,
                    58387.2
                  ],
                  [
                    53160.2,
                    58353.6
                  ],
                  [
                    53040,
                    58285.9
                  ],
                  [
                    52937.6,
                    58145.8
                  ],
                  [
                    52842,
                    57937
                  ],
                  [
                    52885.1,
                    57915.3
                  ],
                  [
                    52886.3,
                    57864.8
                  ],
                  [
                    52816.7,
                    57755.5
                  ],
                  [
                    52764.6,
                    57533.4
                  ],
                  [
                    52796.3,
                    57390.8
                  ],
                  [
                    52843.1,
                    57283.4
                  ],
                  [
                    52907.3,
                    57287
                  ],
                  [
                    53021.8,
                    57316.8
                  ],
                  [
                    53156.9,
                    57289.1
                  ],
                  [
                    53262.5,
                    57301.9
                  ],
                  [
                    53364,
                    57272.2
                  ],
                  [
                    53487.6,
                    57346.1
                  ],
                  [
                    53597,
                    57291.5
                  ],
                  [
                    53702.5,
                    57310.9
                  ],
                  [
                    53771.6,
                    57279.9
                  ],
                  [
                    53749.6,
                    57436.3
                  ],
                  [
                    53324.4,
                    57603.6
                  ]
                ],
                "id": 1639,
                "chat_link": "[&BGcGAAA=]"
              },
              "1640": {
                "name": "The Ruined Paths",
                "level": 80,
                "coord": [
                  53984.1,
                  56536.9
                ],
                "bounds": [
                  [
                    54625.2,
                    56368.6
                  ],
                  [
                    54664.8,
                    56416.9
                  ],
                  [
                    54691.4,
                    56544.3
                  ],
                  [
                    54581.3,
                    56545
                  ],
                  [
                    54513,
                    56544.9
                  ],
                  [
                    54374.2,
                    56615.8
                  ],
                  [
                    54275.4,
                    56697.5
                  ],
                  [
                    54072.9,
                    56757.5
                  ],
                  [
                    53978.8,
                    56708.5
                  ],
                  [
                    53927,
                    56723
                  ],
                  [
                    53861.6,
                    56807.6
                  ],
                  [
                    53808.7,
                    56819.8
                  ],
                  [
                    53771.6,
                    56787.5
                  ],
                  [
                    53691.5,
                    56773.3
                  ],
                  [
                    53599.9,
                    56742.9
                  ],
                  [
                    53502,
                    56771.5
                  ],
                  [
                    53488.1,
                    56549.8
                  ],
                  [
                    53396.9,
                    56504.2
                  ],
                  [
                    53421.3,
                    56408.8
                  ],
                  [
                    53415.3,
                    56366.2
                  ],
                  [
                    53472.4,
                    56247.3
                  ],
                  [
                    53763.4,
                    56306.9
                  ],
                  [
                    53800.8,
                    56257.9
                  ],
                  [
                    53978.1,
                    56228.8
                  ],
                  [
                    54211.1,
                    56293.1
                  ],
                  [
                    54279.2,
                    56362.3
                  ],
                  [
                    54405,
                    56346.8
                  ],
                  [
                    54625.2,
                    56368.6
                  ]
                ],
                "id": 1640,
                "chat_link": "[&BGgGAAA=]"
              },
              "1643": {
                "name": "Tyrulu Sea",
                "level": 80,
                "coord": [
                  54700.8,
                  56929.9
                ],
                "bounds": [
                  [
                    54780.2,
                    55734.3
                  ],
                  [
                    55072.9,
                    55924.5
                  ],
                  [
                    55153.2,
                    56060.1
                  ],
                  [
                    55123.3,
                    56991.8
                  ],
                  [
                    55110,
                    57724.7
                  ],
                  [
                    55111.6,
                    58039.6
                  ],
                  [
                    55078.3,
                    58275.7
                  ],
                  [
                    54949.8,
                    58227
                  ],
                  [
                    54821,
                    58142.3
                  ],
                  [
                    54599.8,
                    58155
                  ],
                  [
                    54602.4,
                    57861.9
                  ],
                  [
                    54678.8,
                    57828.4
                  ],
                  [
                    54730.5,
                    57756.8
                  ],
                  [
                    54556,
                    57493.8
                  ],
                  [
                    54557.1,
                    57434.6
                  ],
                  [
                    54523.3,
                    57351.1
                  ],
                  [
                    54416.9,
                    57282.3
                  ],
                  [
                    54482.3,
                    57040.2
                  ],
                  [
                    54532.4,
                    56998.3
                  ],
                  [
                    54568.2,
                    56901.1
                  ],
                  [
                    54491.3,
                    56758
                  ],
                  [
                    54546,
                    56704.7
                  ],
                  [
                    54513,
                    56544.9
                  ],
                  [
                    54691.4,
                    56544.3
                  ],
                  [
                    54664.8,
                    56416.9
                  ],
                  [
                    54625.2,
                    56368.6
                  ],
                  [
                    54675.8,
                    56226.1
                  ],
                  [
                    54690.3,
                    56044.1
                  ],
                  [
                    54628.9,
                    55995.3
                  ],
                  [
                    54540.1,
                    56035.1
                  ],
                  [
                    54477.8,
                    56021.6
                  ],
                  [
                    54478.9,
                    55970.8
                  ],
                  [
                    54655.8,
                    55831.5
                  ],
                  [
                    54780.2,
                    55734.3
                  ]
                ],
                "id": 1643,
                "chat_link": "[&BGsGAAA=]"
              }
            },
            "adventures": [],
            "id": 1276,
            "mastery_points": []
          },
          "1281": {
            "name": "A Kindness Repaid",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              53768,
              57384
            ],
            "map_rect": [
              [
                -36864,
                -52224
              ],
              [
                39936,
                52224
              ]
            ],
            "continent_rect": [
              [
                51994,
                55402
              ],
              [
                55194,
                59754
              ]
            ],
            "points_of_interest": {
              "2852": {
                "name": "Jemandi Market",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53240.8,
                  56371.2
                ],
                "id": 2852,
                "chat_link": "[&BCQLAAA=]"
              },
              "2855": {
                "name": "The Iron Whale",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  53188.4,
                  56590.9
                ],
                "id": 2855,
                "chat_link": "[&BCcLAAA=]"
              },
              "2869": {
                "name": "Atholma Docks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  52565.9,
                  56431.1
                ],
                "id": 2869,
                "chat_link": "[&BDULAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1624": {
                "name": "Rata Primus",
                "level": 80,
                "coord": [
                  53687.6,
                  57882.8
                ],
                "bounds": [
                  [
                    53749.6,
                    57436.3
                  ],
                  [
                    54107.6,
                    57712.3
                  ],
                  [
                    54045.8,
                    58160.7
                  ],
                  [
                    53631.3,
                    58328.4
                  ],
                  [
                    53266.9,
                    58055.7
                  ],
                  [
                    53324.4,
                    57603.6
                  ],
                  [
                    53749.6,
                    57436.3
                  ]
                ],
                "id": 1624,
                "chat_link": "[&BFgGAAA=]"
              },
              "1625": {
                "name": "Eastern Complex",
                "level": 80,
                "coord": [
                  54076.1,
                  57901.5
                ],
                "bounds": [
                  [
                    54107.6,
                    57712.3
                  ],
                  [
                    53749.6,
                    57436.3
                  ],
                  [
                    53771.6,
                    57279.9
                  ],
                  [
                    53860.8,
                    57326.8
                  ],
                  [
                    54023.4,
                    57286.9
                  ],
                  [
                    54226.9,
                    57227.1
                  ],
                  [
                    54319,
                    57285
                  ],
                  [
                    54341.9,
                    57365.5
                  ],
                  [
                    54447.2,
                    57419.2
                  ],
                  [
                    54492.8,
                    57701.7
                  ],
                  [
                    54472.5,
                    57905.8
                  ],
                  [
                    54451.1,
                    58081.1
                  ],
                  [
                    54336.4,
                    58163
                  ],
                  [
                    54277,
                    58299.3
                  ],
                  [
                    54172.5,
                    58459.3
                  ],
                  [
                    54001.7,
                    58449.3
                  ],
                  [
                    53927.5,
                    58383
                  ],
                  [
                    53860.9,
                    58354.3
                  ],
                  [
                    53796.5,
                    58385.1
                  ],
                  [
                    53743.4,
                    58374.7
                  ],
                  [
                    53693.1,
                    58350.5
                  ],
                  [
                    53631.3,
                    58328.4
                  ],
                  [
                    54045.8,
                    58160.7
                  ],
                  [
                    54107.6,
                    57712.3
                  ]
                ],
                "id": 1625,
                "chat_link": "[&BFkGAAA=]"
              },
              "1626": {
                "name": "Atholma",
                "level": 80,
                "coord": [
                  52950.2,
                  56490
                ],
                "bounds": [
                  [
                    53339.9,
                    56357.5
                  ],
                  [
                    53415.3,
                    56366.2
                  ],
                  [
                    53421.3,
                    56408.8
                  ],
                  [
                    53396.9,
                    56504.2
                  ],
                  [
                    53488.1,
                    56549.8
                  ],
                  [
                    53502,
                    56771.5
                  ],
                  [
                    53435.8,
                    56719.2
                  ],
                  [
                    53308.3,
                    56680.8
                  ],
                  [
                    53145.2,
                    56758
                  ],
                  [
                    52942,
                    56703.5
                  ],
                  [
                    52876.4,
                    56763.3
                  ],
                  [
                    52703.6,
                    56792.4
                  ],
                  [
                    52612.4,
                    56724.7
                  ],
                  [
                    52459,
                    56724.8
                  ],
                  [
                    52261.4,
                    56624.4
                  ],
                  [
                    52240.2,
                    56538.2
                  ],
                  [
                    52235.8,
                    56366.6
                  ],
                  [
                    52403,
                    56275.2
                  ],
                  [
                    52602,
                    56226.2
                  ],
                  [
                    52779.1,
                    56182.2
                  ],
                  [
                    52896.8,
                    56217.5
                  ],
                  [
                    52996,
                    56312.8
                  ],
                  [
                    53019.5,
                    56243.1
                  ],
                  [
                    53068.8,
                    56197.4
                  ],
                  [
                    53205.6,
                    56241.8
                  ],
                  [
                    53339.9,
                    56357.5
                  ]
                ],
                "id": 1626,
                "chat_link": "[&BFoGAAA=]"
              },
              "1627": {
                "name": "The Hunting Grounds",
                "level": 80,
                "coord": [
                  53711.6,
                  55985.1
                ],
                "bounds": [
                  [
                    54689.7,
                    55664.6
                  ],
                  [
                    54780.2,
                    55734.3
                  ],
                  [
                    54655.8,
                    55831.5
                  ],
                  [
                    54478.9,
                    55970.8
                  ],
                  [
                    54477.8,
                    56021.6
                  ],
                  [
                    54540.1,
                    56035.1
                  ],
                  [
                    54628.9,
                    55995.3
                  ],
                  [
                    54690.3,
                    56044.1
                  ],
                  [
                    54675.8,
                    56226.1
                  ],
                  [
                    54625.2,
                    56368.6
                  ],
                  [
                    54405,
                    56346.8
                  ],
                  [
                    54279.2,
                    56362.3
                  ],
                  [
                    54211.1,
                    56293.1
                  ],
                  [
                    53978.1,
                    56228.8
                  ],
                  [
                    53800.8,
                    56257.9
                  ],
                  [
                    53763.4,
                    56306.9
                  ],
                  [
                    53472.4,
                    56247.3
                  ],
                  [
                    53415.3,
                    56366.2
                  ],
                  [
                    53339.9,
                    56357.5
                  ],
                  [
                    53205.6,
                    56241.8
                  ],
                  [
                    53068.8,
                    56197.4
                  ],
                  [
                    53019.5,
                    56243.1
                  ],
                  [
                    52996,
                    56312.8
                  ],
                  [
                    52896.8,
                    56217.5
                  ],
                  [
                    52779.1,
                    56182.2
                  ],
                  [
                    52660,
                    56015.2
                  ],
                  [
                    52593.6,
                    55876.4
                  ],
                  [
                    52509.4,
                    55749
                  ],
                  [
                    52557.4,
                    55710.1
                  ],
                  [
                    52926.6,
                    55681.3
                  ],
                  [
                    52998.5,
                    55747
                  ],
                  [
                    53095.6,
                    55752
                  ],
                  [
                    53216.4,
                    55717.2
                  ],
                  [
                    53315.5,
                    55620.2
                  ],
                  [
                    53433.9,
                    55608.5
                  ],
                  [
                    53513.6,
                    55647.8
                  ],
                  [
                    53654.4,
                    55693.5
                  ],
                  [
                    53797,
                    55660.3
                  ],
                  [
                    53959.2,
                    55678.8
                  ],
                  [
                    54103,
                    55749.2
                  ],
                  [
                    54200.7,
                    55763.7
                  ],
                  [
                    54480.3,
                    55649.4
                  ],
                  [
                    54689.7,
                    55664.6
                  ]
                ],
                "id": 1627,
                "chat_link": "[&BFsGAAA=]"
              },
              "1628": {
                "name": "Northern Complex Coves",
                "level": 80,
                "coord": [
                  53375,
                  57213.5
                ],
                "bounds": [
                  [
                    52713,
                    57332.3
                  ],
                  [
                    52796.3,
                    57390.8
                  ],
                  [
                    52843.1,
                    57283.4
                  ],
                  [
                    52907.3,
                    57287
                  ],
                  [
                    53021.8,
                    57316.8
                  ],
                  [
                    53156.9,
                    57289.1
                  ],
                  [
                    53262.5,
                    57301.9
                  ],
                  [
                    53364,
                    57272.2
                  ],
                  [
                    53487.6,
                    57346.1
                  ],
                  [
                    53597,
                    57291.5
                  ],
                  [
                    53702.5,
                    57310.9
                  ],
                  [
                    53771.6,
                    57279.9
                  ],
                  [
                    53860.8,
                    57326.8
                  ],
                  [
                    54023.4,
                    57286.9
                  ],
                  [
                    54226.9,
                    57227.1
                  ],
                  [
                    54161.8,
                    57153.1
                  ],
                  [
                    54067,
                    57131.4
                  ],
                  [
                    53987.4,
                    57191.8
                  ],
                  [
                    53852.4,
                    57188.8
                  ],
                  [
                    53647.4,
                    57092.3
                  ],
                  [
                    53595.5,
                    57077.8
                  ],
                  [
                    53459.6,
                    57077.7
                  ],
                  [
                    53391.9,
                    57089.3
                  ],
                  [
                    53325.1,
                    57128.4
                  ],
                  [
                    53199.6,
                    57070.9
                  ],
                  [
                    53037.9,
                    57040.8
                  ],
                  [
                    52792.5,
                    57069.1
                  ],
                  [
                    52675.7,
                    57095.8
                  ],
                  [
                    52605.9,
                    57180.2
                  ],
                  [
                    52716.8,
                    57276.4
                  ],
                  [
                    52713,
                    57332.3
                  ]
                ],
                "id": 1628,
                "chat_link": "[&BFwGAAA=]"
              },
              "1629": {
                "name": "Reserve Generator Site",
                "level": 80,
                "coord": [
                  54513.6,
                  57631.8
                ],
                "bounds": [
                  [
                    54341.9,
                    57365.5
                  ],
                  [
                    54447.2,
                    57419.2
                  ],
                  [
                    54492.8,
                    57701.7
                  ],
                  [
                    54472.5,
                    57905.8
                  ],
                  [
                    54451.1,
                    58081.1
                  ],
                  [
                    54601.5,
                    58078.3
                  ],
                  [
                    54602.4,
                    57861.9
                  ],
                  [
                    54678.8,
                    57828.4
                  ],
                  [
                    54730.5,
                    57756.8
                  ],
                  [
                    54556,
                    57493.8
                  ],
                  [
                    54557.1,
                    57434.6
                  ],
                  [
                    54523.3,
                    57351.1
                  ],
                  [
                    54416.9,
                    57282.3
                  ],
                  [
                    54319,
                    57285
                  ],
                  [
                    54341.9,
                    57365.5
                  ]
                ],
                "id": 1629,
                "chat_link": "[&BF0GAAA=]"
              },
              "1630": {
                "name": "Damos Isle",
                "level": 80,
                "coord": [
                  53336.2,
                  58559.9
                ],
                "bounds": [
                  [
                    53692.3,
                    58505
                  ],
                  [
                    53798.4,
                    58624.7
                  ],
                  [
                    53940.1,
                    58633.7
                  ],
                  [
                    53965.9,
                    58757.8
                  ],
                  [
                    53878.5,
                    58951.3
                  ],
                  [
                    53628.5,
                    59028.8
                  ],
                  [
                    53399.8,
                    59012.9
                  ],
                  [
                    53244.8,
                    58758.1
                  ],
                  [
                    53158.7,
                    58726.6
                  ],
                  [
                    52988,
                    58629.9
                  ],
                  [
                    52860.9,
                    58528.6
                  ],
                  [
                    52750.8,
                    58232.9
                  ],
                  [
                    52798.4,
                    58105.1
                  ],
                  [
                    52937.6,
                    58145.8
                  ],
                  [
                    53040,
                    58285.9
                  ],
                  [
                    53160.2,
                    58353.6
                  ],
                  [
                    53269,
                    58387.2
                  ],
                  [
                    53353.2,
                    58495.8
                  ],
                  [
                    53522,
                    58474.5
                  ],
                  [
                    53692.3,
                    58505
                  ]
                ],
                "id": 1630,
                "chat_link": "[&BF4GAAA=]"
              },
              "1631": {
                "name": "Calon Islet",
                "level": 80,
                "coord": [
                  54311.3,
                  56928.4
                ],
                "bounds": [
                  [
                    54491.3,
                    56758
                  ],
                  [
                    54568.2,
                    56901.1
                  ],
                  [
                    54532.4,
                    56998.3
                  ],
                  [
                    54482.3,
                    57040.2
                  ],
                  [
                    54250.6,
                    57060.7
                  ],
                  [
                    54063.5,
                    57025.3
                  ],
                  [
                    54041.9,
                    56928.2
                  ],
                  [
                    54080.5,
                    56849.4
                  ],
                  [
                    54290.8,
                    56795
                  ],
                  [
                    54491.3,
                    56758
                  ]
                ],
                "id": 1631,
                "chat_link": "[&BF8GAAA=]"
              },
              "1632": {
                "name": "Invariant Enclave",
                "level": 80,
                "coord": [
                  54469.6,
                  58872.9
                ],
                "bounds": [
                  [
                    55096.9,
                    58489.7
                  ],
                  [
                    55033.3,
                    59017.5
                  ],
                  [
                    54964.4,
                    59462.7
                  ],
                  [
                    54790.7,
                    59688.4
                  ],
                  [
                    54508.8,
                    59670.2
                  ],
                  [
                    54367.3,
                    59653.9
                  ],
                  [
                    54288.6,
                    59548.1
                  ],
                  [
                    54280,
                    59449.2
                  ],
                  [
                    54235.1,
                    59363.1
                  ],
                  [
                    54064.7,
                    59285.4
                  ],
                  [
                    54026.3,
                    59160
                  ],
                  [
                    54081.4,
                    58895.6
                  ],
                  [
                    54084.8,
                    58832.9
                  ],
                  [
                    54109.3,
                    58754.3
                  ],
                  [
                    54122.7,
                    58661.8
                  ],
                  [
                    54208.5,
                    58616.9
                  ],
                  [
                    54291.6,
                    58569.6
                  ],
                  [
                    54318.8,
                    58495.8
                  ],
                  [
                    54449.2,
                    58299.3
                  ],
                  [
                    54500.4,
                    58235.4
                  ],
                  [
                    54599.8,
                    58155
                  ],
                  [
                    54821,
                    58142.3
                  ],
                  [
                    54949.8,
                    58227
                  ],
                  [
                    55078.3,
                    58275.7
                  ],
                  [
                    55096.9,
                    58489.7
                  ]
                ],
                "id": 1632,
                "chat_link": "[&BGAGAAA=]"
              },
              "1635": {
                "name": "Griffonstone Buttresses",
                "level": 80,
                "coord": [
                  52664.9,
                  57700.1
                ],
                "bounds": [
                  [
                    52816.7,
                    57755.5
                  ],
                  [
                    52886.3,
                    57864.8
                  ],
                  [
                    52885.1,
                    57915.3
                  ],
                  [
                    52842,
                    57937
                  ],
                  [
                    52937.6,
                    58145.8
                  ],
                  [
                    52798.4,
                    58105.1
                  ],
                  [
                    52750.8,
                    58232.9
                  ],
                  [
                    52526.7,
                    58107.9
                  ],
                  [
                    52444.4,
                    57977.4
                  ],
                  [
                    52463.8,
                    57899.3
                  ],
                  [
                    52340.1,
                    57668.2
                  ],
                  [
                    52394.3,
                    57445.6
                  ],
                  [
                    52419.3,
                    57335.5
                  ],
                  [
                    52530.6,
                    57197.6
                  ],
                  [
                    52605.9,
                    57180.2
                  ],
                  [
                    52716.8,
                    57276.4
                  ],
                  [
                    52713,
                    57332.3
                  ],
                  [
                    52796.3,
                    57390.8
                  ],
                  [
                    52764.6,
                    57533.4
                  ],
                  [
                    52816.7,
                    57755.5
                  ]
                ],
                "id": 1635,
                "chat_link": "[&BGMGAAA=]"
              },
              "1636": {
                "name": "Sargol Sea",
                "level": 80,
                "coord": [
                  53949,
                  58779.9
                ],
                "bounds": [
                  [
                    53965.9,
                    58757.8
                  ],
                  [
                    53940.1,
                    58633.7
                  ],
                  [
                    53798.4,
                    58624.7
                  ],
                  [
                    53692.3,
                    58505
                  ],
                  [
                    53522,
                    58474.5
                  ],
                  [
                    53631.3,
                    58328.4
                  ],
                  [
                    53693.1,
                    58350.5
                  ],
                  [
                    53743.4,
                    58374.7
                  ],
                  [
                    53796.5,
                    58385.1
                  ],
                  [
                    53860.9,
                    58354.3
                  ],
                  [
                    53927.5,
                    58383
                  ],
                  [
                    54001.7,
                    58449.3
                  ],
                  [
                    54172.5,
                    58459.3
                  ],
                  [
                    54277,
                    58299.3
                  ],
                  [
                    54336.4,
                    58163
                  ],
                  [
                    54451.1,
                    58081.1
                  ],
                  [
                    54601.5,
                    58078.3
                  ],
                  [
                    54599.8,
                    58155
                  ],
                  [
                    54500.4,
                    58235.4
                  ],
                  [
                    54449.2,
                    58299.3
                  ],
                  [
                    54318.8,
                    58495.8
                  ],
                  [
                    54291.6,
                    58569.6
                  ],
                  [
                    54208.5,
                    58616.9
                  ],
                  [
                    54122.7,
                    58661.8
                  ],
                  [
                    54109.3,
                    58754.3
                  ],
                  [
                    54084.8,
                    58832.9
                  ],
                  [
                    54081.4,
                    58895.6
                  ],
                  [
                    54026.3,
                    59160
                  ],
                  [
                    54064.7,
                    59285.4
                  ],
                  [
                    54235.1,
                    59363.1
                  ],
                  [
                    54280,
                    59449.2
                  ],
                  [
                    54288.6,
                    59548.1
                  ],
                  [
                    54367.3,
                    59653.9
                  ],
                  [
                    54240.1,
                    59690.1
                  ],
                  [
                    53998.8,
                    59697.8
                  ],
                  [
                    53658,
                    59700.3
                  ],
                  [
                    53375.6,
                    59657.9
                  ],
                  [
                    53093.8,
                    59437.8
                  ],
                  [
                    52640.5,
                    58977.3
                  ],
                  [
                    53158.7,
                    58726.6
                  ],
                  [
                    53244.8,
                    58758.1
                  ],
                  [
                    53399.8,
                    59012.9
                  ],
                  [
                    53628.5,
                    59028.8
                  ],
                  [
                    53878.5,
                    58951.3
                  ],
                  [
                    53965.9,
                    58757.8
                  ]
                ],
                "id": 1636,
                "chat_link": "[&BGQGAAA=]"
              },
              "1637": {
                "name": "Strait of Panube",
                "level": 80,
                "coord": [
                  53556.6,
                  56927.5
                ],
                "bounds": [
                  [
                    53145.2,
                    56758
                  ],
                  [
                    53308.3,
                    56680.8
                  ],
                  [
                    53435.8,
                    56719.2
                  ],
                  [
                    53502,
                    56771.5
                  ],
                  [
                    53599.9,
                    56742.9
                  ],
                  [
                    53691.5,
                    56773.3
                  ],
                  [
                    53771.6,
                    56787.5
                  ],
                  [
                    53808.7,
                    56819.8
                  ],
                  [
                    53861.6,
                    56807.6
                  ],
                  [
                    53927,
                    56723
                  ],
                  [
                    53978.8,
                    56708.5
                  ],
                  [
                    54072.9,
                    56757.5
                  ],
                  [
                    54275.4,
                    56697.5
                  ],
                  [
                    54374.2,
                    56615.8
                  ],
                  [
                    54513,
                    56544.9
                  ],
                  [
                    54546,
                    56704.7
                  ],
                  [
                    54491.3,
                    56758
                  ],
                  [
                    54290.8,
                    56795
                  ],
                  [
                    54080.5,
                    56849.4
                  ],
                  [
                    54041.9,
                    56928.2
                  ],
                  [
                    54063.5,
                    57025.3
                  ],
                  [
                    54250.6,
                    57060.7
                  ],
                  [
                    54482.3,
                    57040.2
                  ],
                  [
                    54416.9,
                    57282.3
                  ],
                  [
                    54319,
                    57285
                  ],
                  [
                    54226.9,
                    57227.1
                  ],
                  [
                    54161.8,
                    57153.1
                  ],
                  [
                    54067,
                    57131.4
                  ],
                  [
                    53987.4,
                    57191.8
                  ],
                  [
                    53852.4,
                    57188.8
                  ],
                  [
                    53647.4,
                    57092.3
                  ],
                  [
                    53595.5,
                    57077.8
                  ],
                  [
                    53459.6,
                    57077.7
                  ],
                  [
                    53391.9,
                    57089.3
                  ],
                  [
                    53325.1,
                    57128.4
                  ],
                  [
                    53199.6,
                    57070.9
                  ],
                  [
                    53037.9,
                    57040.8
                  ],
                  [
                    52792.5,
                    57069.1
                  ],
                  [
                    52675.7,
                    57095.8
                  ],
                  [
                    52605.9,
                    57180.2
                  ],
                  [
                    52530.6,
                    57197.6
                  ],
                  [
                    52419.3,
                    57335.5
                  ],
                  [
                    52336.9,
                    57118.7
                  ],
                  [
                    52412.5,
                    56937.9
                  ],
                  [
                    52261.4,
                    56624.4
                  ],
                  [
                    52459,
                    56724.8
                  ],
                  [
                    52612.4,
                    56724.7
                  ],
                  [
                    52703.6,
                    56792.4
                  ],
                  [
                    52876.4,
                    56763.3
                  ],
                  [
                    52942,
                    56703.5
                  ],
                  [
                    53145.2,
                    56758
                  ]
                ],
                "id": 1637,
                "chat_link": "[&BGUGAAA=]"
              },
              "1638": {
                "name": "Chukara Sea",
                "level": 80,
                "coord": [
                  52492.4,
                  57281.3
                ],
                "bounds": [
                  [
                    52750.8,
                    58232.9
                  ],
                  [
                    52860.9,
                    58528.6
                  ],
                  [
                    52988,
                    58629.9
                  ],
                  [
                    53158.7,
                    58726.6
                  ],
                  [
                    52640.5,
                    58977.3
                  ],
                  [
                    52251.5,
                    58529.8
                  ],
                  [
                    52161.7,
                    58309
                  ],
                  [
                    52144.9,
                    57100.9
                  ],
                  [
                    52223.9,
                    55933.8
                  ],
                  [
                    52509.4,
                    55749
                  ],
                  [
                    52593.6,
                    55876.4
                  ],
                  [
                    52660,
                    56015.2
                  ],
                  [
                    52779.1,
                    56182.2
                  ],
                  [
                    52602,
                    56226.2
                  ],
                  [
                    52403,
                    56275.2
                  ],
                  [
                    52235.8,
                    56366.6
                  ],
                  [
                    52240.2,
                    56538.2
                  ],
                  [
                    52261.4,
                    56624.4
                  ],
                  [
                    52412.5,
                    56937.9
                  ],
                  [
                    52336.9,
                    57118.7
                  ],
                  [
                    52419.3,
                    57335.5
                  ],
                  [
                    52394.3,
                    57445.6
                  ],
                  [
                    52340.1,
                    57668.2
                  ],
                  [
                    52463.8,
                    57899.3
                  ],
                  [
                    52444.4,
                    57977.4
                  ],
                  [
                    52526.7,
                    58107.9
                  ],
                  [
                    52750.8,
                    58232.9
                  ]
                ],
                "id": 1638,
                "chat_link": "[&BGYGAAA=]"
              },
              "1639": {
                "name": "Western Complex",
                "level": 80,
                "coord": [
                  53209.8,
                  57731.1
                ],
                "bounds": [
                  [
                    53324.4,
                    57603.6
                  ],
                  [
                    53306,
                    57797.5
                  ],
                  [
                    53266.9,
                    58055.7
                  ],
                  [
                    53631.3,
                    58328.4
                  ],
                  [
                    53522,
                    58474.5
                  ],
                  [
                    53353.2,
                    58495.8
                  ],
                  [
                    53269,
                    58387.2
                  ],
                  [
                    53160.2,
                    58353.6
                  ],
                  [
                    53040,
                    58285.9
                  ],
                  [
                    52937.6,
                    58145.8
                  ],
                  [
                    52842,
                    57937
                  ],
                  [
                    52885.1,
                    57915.3
                  ],
                  [
                    52886.3,
                    57864.8
                  ],
                  [
                    52816.7,
                    57755.5
                  ],
                  [
                    52764.6,
                    57533.4
                  ],
                  [
                    52796.3,
                    57390.8
                  ],
                  [
                    52843.1,
                    57283.4
                  ],
                  [
                    52907.3,
                    57287
                  ],
                  [
                    53021.8,
                    57316.8
                  ],
                  [
                    53156.9,
                    57289.1
                  ],
                  [
                    53262.5,
                    57301.9
                  ],
                  [
                    53364,
                    57272.2
                  ],
                  [
                    53487.6,
                    57346.1
                  ],
                  [
                    53597,
                    57291.5
                  ],
                  [
                    53702.5,
                    57310.9
                  ],
                  [
                    53771.6,
                    57279.9
                  ],
                  [
                    53749.6,
                    57436.3
                  ],
                  [
                    53324.4,
                    57603.6
                  ]
                ],
                "id": 1639,
                "chat_link": "[&BGcGAAA=]"
              },
              "1640": {
                "name": "The Ruined Paths",
                "level": 80,
                "coord": [
                  53984.1,
                  56536.9
                ],
                "bounds": [
                  [
                    54625.2,
                    56368.6
                  ],
                  [
                    54664.8,
                    56416.9
                  ],
                  [
                    54691.4,
                    56544.3
                  ],
                  [
                    54581.3,
                    56545
                  ],
                  [
                    54513,
                    56544.9
                  ],
                  [
                    54374.2,
                    56615.8
                  ],
                  [
                    54275.4,
                    56697.5
                  ],
                  [
                    54072.9,
                    56757.5
                  ],
                  [
                    53978.8,
                    56708.5
                  ],
                  [
                    53927,
                    56723
                  ],
                  [
                    53861.6,
                    56807.6
                  ],
                  [
                    53808.7,
                    56819.8
                  ],
                  [
                    53771.6,
                    56787.5
                  ],
                  [
                    53691.5,
                    56773.3
                  ],
                  [
                    53599.9,
                    56742.9
                  ],
                  [
                    53502,
                    56771.5
                  ],
                  [
                    53488.1,
                    56549.8
                  ],
                  [
                    53396.9,
                    56504.2
                  ],
                  [
                    53421.3,
                    56408.8
                  ],
                  [
                    53415.3,
                    56366.2
                  ],
                  [
                    53472.4,
                    56247.3
                  ],
                  [
                    53763.4,
                    56306.9
                  ],
                  [
                    53800.8,
                    56257.9
                  ],
                  [
                    53978.1,
                    56228.8
                  ],
                  [
                    54211.1,
                    56293.1
                  ],
                  [
                    54279.2,
                    56362.3
                  ],
                  [
                    54405,
                    56346.8
                  ],
                  [
                    54625.2,
                    56368.6
                  ]
                ],
                "id": 1640,
                "chat_link": "[&BGgGAAA=]"
              },
              "1643": {
                "name": "Tyrulu Sea",
                "level": 80,
                "coord": [
                  54700.8,
                  56929.9
                ],
                "bounds": [
                  [
                    54780.2,
                    55734.3
                  ],
                  [
                    55072.9,
                    55924.5
                  ],
                  [
                    55153.2,
                    56060.1
                  ],
                  [
                    55123.3,
                    56991.8
                  ],
                  [
                    55110,
                    57724.7
                  ],
                  [
                    55111.6,
                    58039.6
                  ],
                  [
                    55078.3,
                    58275.7
                  ],
                  [
                    54949.8,
                    58227
                  ],
                  [
                    54821,
                    58142.3
                  ],
                  [
                    54599.8,
                    58155
                  ],
                  [
                    54602.4,
                    57861.9
                  ],
                  [
                    54678.8,
                    57828.4
                  ],
                  [
                    54730.5,
                    57756.8
                  ],
                  [
                    54556,
                    57493.8
                  ],
                  [
                    54557.1,
                    57434.6
                  ],
                  [
                    54523.3,
                    57351.1
                  ],
                  [
                    54416.9,
                    57282.3
                  ],
                  [
                    54482.3,
                    57040.2
                  ],
                  [
                    54532.4,
                    56998.3
                  ],
                  [
                    54568.2,
                    56901.1
                  ],
                  [
                    54491.3,
                    56758
                  ],
                  [
                    54546,
                    56704.7
                  ],
                  [
                    54513,
                    56544.9
                  ],
                  [
                    54691.4,
                    56544.3
                  ],
                  [
                    54664.8,
                    56416.9
                  ],
                  [
                    54625.2,
                    56368.6
                  ],
                  [
                    54675.8,
                    56226.1
                  ],
                  [
                    54690.3,
                    56044.1
                  ],
                  [
                    54628.9,
                    55995.3
                  ],
                  [
                    54540.1,
                    56035.1
                  ],
                  [
                    54477.8,
                    56021.6
                  ],
                  [
                    54478.9,
                    55970.8
                  ],
                  [
                    54655.8,
                    55831.5
                  ],
                  [
                    54780.2,
                    55734.3
                  ]
                ],
                "id": 1643,
                "chat_link": "[&BGsGAAA=]"
              }
            },
            "adventures": [],
            "id": 1281,
            "mastery_points": []
          },
          "1282": {
            "name": "Tracking the Scientist",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -15360,
                -21504
              ],
              [
                15360,
                24576
              ]
            ],
            "continent_rect": [
              [
                59686,
                40139
              ],
              [
                60966,
                42059
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1282,
            "mastery_points": []
          },
          "1288": {
            "name": "Domain of Kourna",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              65368,
              61384
            ],
            "map_rect": [
              [
                -49152,
                -55296
              ],
              [
                49152,
                58368
              ]
            ],
            "continent_rect": [
              [
                63624,
                59572
              ],
              [
                67720,
                64308
              ]
            ],
            "points_of_interest": {
              "2888": {
                "name": "Zelbahn Garrison",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64740.4,
                  61530.5
                ],
                "id": 2888,
                "chat_link": "[&BEgLAAA=]"
              },
              "2889": {
                "name": "Apizmic Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66073.9,
                  61159.7
                ],
                "id": 2889,
                "chat_link": "[&BEkLAAA=]"
              },
              "2890": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  65570.4,
                  61974.2
                ],
                "id": 2890,
                "chat_link": "[&BEoLAAA=]"
              },
              "2891": {
                "name": "Research Mainframe Access",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65236.2,
                  61155.4
                ],
                "id": 2891,
                "chat_link": "[&BEsLAAA=]"
              },
              "2892": {
                "name": "Deeprift Brood",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64057.5,
                  60558.4
                ],
                "id": 2892,
                "chat_link": "[&BEwLAAA=]"
              },
              "2894": {
                "name": "Western Allied Access",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64456.3,
                  62041.2
                ],
                "id": 2894,
                "chat_link": "[&BE4LAAA=]"
              },
              "2895": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  65365.5,
                  61519.5
                ],
                "id": 2895,
                "chat_link": "[&BE8LAAA=]"
              },
              "2896": {
                "name": "Apizmic Grounds Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  66016.1,
                  61284.5
                ],
                "id": 2896,
                "chat_link": "[&BFALAAA=]"
              },
              "2897": {
                "name": "Eastern Allied Access",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64835.4,
                  61869
                ],
                "id": 2897,
                "chat_link": "[&BFELAAA=]"
              },
              "2898": {
                "name": "Army Landing & Entry Portal",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64568.6,
                  61220.3
                ],
                "id": 2898,
                "chat_link": "[&BFILAAA=]"
              },
              "2899": {
                "name": "Loyalist Warren",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63821.2,
                  61200.5
                ],
                "id": 2899,
                "chat_link": "[&BFMLAAA=]"
              },
              "2900": {
                "name": "Corsair Cannons",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64086.8,
                  62386.2
                ],
                "id": 2900,
                "chat_link": "[&BFQLAAA=]"
              },
              "2902": {
                "name": "Bokoss Prison Ruins",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65855.7,
                  63071.2
                ],
                "id": 2902,
                "chat_link": "[&BFYLAAA=]"
              },
              "2903": {
                "name": "Allied Encampment Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64765.1,
                  61579.3
                ],
                "id": 2903,
                "chat_link": "[&BFcLAAA=]"
              },
              "2904": {
                "name": "Dunlon Springs",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65440.8,
                  59836.9
                ],
                "id": 2904,
                "chat_link": "[&BFgLAAA=]"
              },
              "2905": {
                "name": "Dejarin Ruins",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66154.8,
                  60876.8
                ],
                "id": 2905,
                "chat_link": "[&BFkLAAA=]"
              },
              "2906": {
                "name": "Research Vault Beta",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65388.3,
                  60965.1
                ],
                "id": 2906,
                "chat_link": "[&BFoLAAA=]"
              },
              "2907": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  64368.8,
                  60818.8
                ],
                "id": 2907,
                "chat_link": "[&BFsLAAA=]"
              },
              "2908": {
                "name": "Pogahn Bluffs Proving Ground",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65640.9,
                  61025
                ],
                "id": 2908,
                "chat_link": "[&BFwLAAA=]"
              },
              "2909": {
                "name": "Wreck of the Scimitar",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64198.6,
                  62681.7
                ],
                "id": 2909,
                "chat_link": "[&BF0LAAA=]"
              },
              "2910": {
                "name": "Idol of the Choya",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66020.3,
                  59982
                ],
                "id": 2910,
                "chat_link": "[&BF4LAAA=]"
              },
              "2911": {
                "name": "Barbellate Crater",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66310.7,
                  59965.6
                ],
                "id": 2911,
                "chat_link": "[&BF8LAAA=]"
              },
              "2912": {
                "name": "Gandara Main Approach",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65346.6,
                  62348.3
                ],
                "id": 2912,
                "chat_link": "[&BGALAAA=]"
              },
              "2913": {
                "name": "Gandara Western Approach",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64628.6,
                  62483.5
                ],
                "id": 2913,
                "chat_link": "[&BGELAAA=]"
              },
              "2914": {
                "name": "Secret Throughway",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64039.5,
                  60908.9
                ],
                "id": 2914,
                "chat_link": "[&BGILAAA=]"
              },
              "2915": {
                "name": "Palawa's Benevolence",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64525,
                  60650.7
                ],
                "id": 2915,
                "chat_link": "[&BGMLAAA=]"
              },
              "2916": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  65760.2,
                  63074.2
                ],
                "id": 2916,
                "chat_link": "[&BGQLAAA=]"
              },
              "2917": {
                "name": "Arkjok Kennels",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64613.4,
                  60368.9
                ],
                "id": 2917,
                "chat_link": "[&BGULAAA=]"
              },
              "2918": {
                "name": "Research Vault Alpha",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65503.4,
                  60903
                ],
                "id": 2918,
                "chat_link": "[&BGYLAAA=]"
              },
              "2919": {
                "name": "Imperial Center for Applied Pestilence",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65291,
                  63056.3
                ],
                "id": 2919,
                "chat_link": "[&BGcLAAA=]"
              },
              "2920": {
                "name": "Crocuta Vantage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65162.7,
                  60239.3
                ],
                "id": 2920,
                "chat_link": "[&BGgLAAA=]"
              }
            },
            "tasks": {
              "428": {
                "objective": "Secure the supply line from the Corsair Landing.",
                "level": 80,
                "coord": [
                  63970.2,
                  62666.5
                ],
                "bounds": [
                  [
                    63891.4,
                    62907.9
                  ],
                  [
                    64322.4,
                    62764
                  ],
                  [
                    64477,
                    62602.6
                  ],
                  [
                    64519,
                    62507.1
                  ],
                  [
                    64438.4,
                    62050.9
                  ],
                  [
                    64221.3,
                    61911.1
                  ],
                  [
                    64133.9,
                    61909.5
                  ],
                  [
                    63993.3,
                    62242.3
                  ],
                  [
                    63725.5,
                    62664.6
                  ],
                  [
                    63891.4,
                    62907.9
                  ]
                ],
                "id": 428,
                "chat_link": "[&BKwBAAA=]"
              },
              "429": {
                "objective": "Respond to the food shortage in Arkjok Farmlands.",
                "level": 80,
                "coord": [
                  64294.1,
                  60688.6
                ],
                "bounds": [
                  [
                    65245,
                    60762.3
                  ],
                  [
                    64480.9,
                    60975
                  ],
                  [
                    64050.2,
                    60901.9
                  ],
                  [
                    64162.2,
                    60729.9
                  ],
                  [
                    64263.5,
                    60514.1
                  ],
                  [
                    64449.5,
                    60333.5
                  ],
                  [
                    64823.5,
                    59899.6
                  ],
                  [
                    65189.7,
                    59828.4
                  ],
                  [
                    65245,
                    60762.3
                  ]
                ],
                "id": 429,
                "chat_link": "[&BK0BAAA=]"
              },
              "430": {
                "objective": "Help distribute incoming supplies to the allied encampment.",
                "level": 80,
                "coord": [
                  64452,
                  61814.6
                ],
                "bounds": [
                  [
                    64460.5,
                    62023.6
                  ],
                  [
                    64051.3,
                    61866.8
                  ],
                  [
                    64066,
                    61311.3
                  ],
                  [
                    64483.2,
                    61089.8
                  ],
                  [
                    64927.3,
                    60937.3
                  ],
                  [
                    65569.8,
                    60689.4
                  ],
                  [
                    65408.4,
                    61056.7
                  ],
                  [
                    65428.6,
                    61324.8
                  ],
                  [
                    65219.5,
                    61474.7
                  ],
                  [
                    64768.2,
                    61813
                  ],
                  [
                    64460.5,
                    62023.6
                  ]
                ],
                "id": 430,
                "chat_link": "[&BK4BAAA=]"
              },
              "431": {
                "objective": "Help stabilize the front line.",
                "level": 80,
                "coord": [
                  65526.4,
                  61986.8
                ],
                "bounds": [
                  [
                    64442.9,
                    62495.3
                  ],
                  [
                    64443,
                    62048.3
                  ],
                  [
                    65130.3,
                    61555.1
                  ],
                  [
                    65448.4,
                    61535.8
                  ],
                  [
                    65681.4,
                    61836.1
                  ],
                  [
                    66374.1,
                    62100.2
                  ],
                  [
                    66080.8,
                    62838
                  ],
                  [
                    65490.1,
                    62922.6
                  ],
                  [
                    65407.7,
                    62573.4
                  ],
                  [
                    65223.4,
                    62401.8
                  ],
                  [
                    65100.1,
                    62337.6
                  ],
                  [
                    64815.3,
                    62455
                  ],
                  [
                    64442.9,
                    62495.3
                  ]
                ],
                "id": 431,
                "chat_link": "[&BK8BAAA=]"
              },
              "433": {
                "objective": "Help the critically endangered heket tribe.",
                "level": 80,
                "coord": [
                  65989.6,
                  61252.6
                ],
                "bounds": [
                  [
                    66773.8,
                    61553.8
                  ],
                  [
                    66432.7,
                    62118.4
                  ],
                  [
                    66073.9,
                    61955.8
                  ],
                  [
                    65586.8,
                    61729.8
                  ],
                  [
                    65463.3,
                    61392.2
                  ],
                  [
                    65421.6,
                    61058.9
                  ],
                  [
                    65978.6,
                    59833.7
                  ],
                  [
                    66465.3,
                    59838.3
                  ],
                  [
                    66889.3,
                    60674
                  ],
                  [
                    67097.1,
                    61153.8
                  ],
                  [
                    66773.8,
                    61553.8
                  ]
                ],
                "id": 433,
                "chat_link": "[&BLEBAAA=]"
              }
            },
            "skill_challenges": [],
            "sectors": {
              "1644": {
                "name": "Front Line",
                "level": 80,
                "coord": [
                  65134.7,
                  62066.7
                ],
                "bounds": [
                  [
                    64464.6,
                    62034.8
                  ],
                  [
                    64612.8,
                    62011.1
                  ],
                  [
                    64699.6,
                    61978
                  ],
                  [
                    64859.9,
                    61823.6
                  ],
                  [
                    64915.3,
                    61749.5
                  ],
                  [
                    65140.3,
                    61736.2
                  ],
                  [
                    65202.6,
                    61722
                  ],
                  [
                    65216.8,
                    61768.4
                  ],
                  [
                    65259.8,
                    61802.7
                  ],
                  [
                    65331.8,
                    61823.5
                  ],
                  [
                    65444,
                    61831.3
                  ],
                  [
                    65541.6,
                    61805.8
                  ],
                  [
                    65575,
                    61816.9
                  ],
                  [
                    65633.5,
                    61841.5
                  ],
                  [
                    65705.9,
                    61875.6
                  ],
                  [
                    65737.1,
                    61880.5
                  ],
                  [
                    65718.9,
                    61993.5
                  ],
                  [
                    65643.2,
                    62090.3
                  ],
                  [
                    65556.6,
                    62097.8
                  ],
                  [
                    65279.3,
                    62525.3
                  ],
                  [
                    65119.6,
                    62463.3
                  ],
                  [
                    64994.8,
                    62504.6
                  ],
                  [
                    64784.1,
                    62559.5
                  ],
                  [
                    64606.4,
                    62669.5
                  ],
                  [
                    64503.3,
                    62632.7
                  ],
                  [
                    64564.2,
                    62440
                  ],
                  [
                    64526,
                    62323.8
                  ],
                  [
                    64464.6,
                    62034.8
                  ]
                ],
                "id": 1644,
                "chat_link": "[&BGwGAAA=]"
              },
              "1646": {
                "name": "Bay of Gandara",
                "level": 80,
                "coord": [
                  65108.3,
                  63327.2
                ],
                "bounds": [
                  [
                    63935.6,
                    63388.9
                  ],
                  [
                    63815.3,
                    63319.7
                  ],
                  [
                    63696.2,
                    63217.7
                  ],
                  [
                    63670.9,
                    63082.4
                  ],
                  [
                    63685.3,
                    62963.3
                  ],
                  [
                    63804.1,
                    63015.7
                  ],
                  [
                    63966,
                    62982
                  ],
                  [
                    64371.2,
                    63116
                  ],
                  [
                    64376.4,
                    63257.6
                  ],
                  [
                    64472.2,
                    63448.8
                  ],
                  [
                    64580.8,
                    63526.8
                  ],
                  [
                    64680,
                    63576.1
                  ],
                  [
                    64792.2,
                    63617.5
                  ],
                  [
                    64929.8,
                    63599.8
                  ],
                  [
                    65085,
                    63528.6
                  ],
                  [
                    65220.2,
                    63429.3
                  ],
                  [
                    65350.5,
                    63291.2
                  ],
                  [
                    65390.1,
                    63184.5
                  ],
                  [
                    65633.4,
                    63176.3
                  ],
                  [
                    65738.9,
                    63267.7
                  ],
                  [
                    66024,
                    63195.7
                  ],
                  [
                    66091.1,
                    63064.4
                  ],
                  [
                    66392.9,
                    62950.3
                  ],
                  [
                    66440.5,
                    63065.9
                  ],
                  [
                    66467.8,
                    63174.7
                  ],
                  [
                    66463.4,
                    63219.7
                  ],
                  [
                    66452.2,
                    63243.5
                  ],
                  [
                    66437.4,
                    63267.7
                  ],
                  [
                    66398.3,
                    63300.9
                  ],
                  [
                    66322.6,
                    63345.6
                  ],
                  [
                    66187.5,
                    63408.8
                  ],
                  [
                    65677.1,
                    63558.2
                  ],
                  [
                    65290.9,
                    63671.2
                  ],
                  [
                    65067,
                    63706.8
                  ],
                  [
                    64585.8,
                    63699.3
                  ],
                  [
                    64318,
                    63578.6
                  ],
                  [
                    64226.2,
                    63529.5
                  ],
                  [
                    64079,
                    63463.7
                  ],
                  [
                    63935.6,
                    63388.9
                  ]
                ],
                "id": 1646,
                "chat_link": "[&BG4GAAA=]"
              },
              "1647": {
                "name": "Allied Encampment",
                "level": 80,
                "coord": [
                  64716.1,
                  61683.3
                ],
                "bounds": [
                  [
                    64339.5,
                    62010.4
                  ],
                  [
                    64192.7,
                    61872.9
                  ],
                  [
                    64206.8,
                    61797.6
                  ],
                  [
                    64230.2,
                    61622.7
                  ],
                  [
                    64231.9,
                    61602.9
                  ],
                  [
                    64222.7,
                    61585.8
                  ],
                  [
                    64096,
                    61423.1
                  ],
                  [
                    64616.8,
                    61028.7
                  ],
                  [
                    64860.5,
                    60972
                  ],
                  [
                    65077.2,
                    61130.6
                  ],
                  [
                    65253.9,
                    61265.6
                  ],
                  [
                    65125.3,
                    61553.2
                  ],
                  [
                    65171.4,
                    61673.9
                  ],
                  [
                    65179.4,
                    61752
                  ],
                  [
                    65209,
                    61759.2
                  ],
                  [
                    65066.8,
                    61737.4
                  ],
                  [
                    65020.9,
                    61731.9
                  ],
                  [
                    64966.6,
                    61743.2
                  ],
                  [
                    64891.3,
                    61770.7
                  ],
                  [
                    64875.7,
                    61809.6
                  ],
                  [
                    64821.4,
                    61898.4
                  ],
                  [
                    64748,
                    61950.7
                  ],
                  [
                    64690.5,
                    61984.5
                  ],
                  [
                    64602.9,
                    62020.6
                  ],
                  [
                    64522.6,
                    62033.9
                  ],
                  [
                    64399.7,
                    62034.4
                  ],
                  [
                    64339.5,
                    62010.4
                  ]
                ],
                "id": 1647,
                "chat_link": "[&BG8GAAA=]"
              },
              "1648": {
                "name": "Western Front",
                "level": 80,
                "coord": [
                  64217.9,
                  62215.9
                ],
                "bounds": [
                  [
                    63935.5,
                    62409.9
                  ],
                  [
                    64509,
                    62643.1
                  ],
                  [
                    64572.2,
                    62444.1
                  ],
                  [
                    64539.9,
                    62326
                  ],
                  [
                    64471.7,
                    62021.6
                  ],
                  [
                    64350.4,
                    62019.5
                  ],
                  [
                    64201.2,
                    61861.1
                  ],
                  [
                    64078.4,
                    61993
                  ],
                  [
                    64034.8,
                    62045.4
                  ],
                  [
                    64036.8,
                    62150.7
                  ],
                  [
                    63986.9,
                    62262.8
                  ],
                  [
                    63898,
                    62413.9
                  ],
                  [
                    63935.5,
                    62409.9
                  ]
                ],
                "id": 1648,
                "chat_link": "[&BHAGAAA=]"
              },
              "1650": {
                "name": "Eastern Front",
                "level": 80,
                "coord": [
                  66009.3,
                  62501.1
                ],
                "bounds": [
                  [
                    65509.7,
                    62062.4
                  ],
                  [
                    65609.2,
                    62042.6
                  ],
                  [
                    65692.4,
                    62019.2
                  ],
                  [
                    65721,
                    61992.7
                  ],
                  [
                    65723.6,
                    61908.3
                  ],
                  [
                    65729.5,
                    61876.2
                  ],
                  [
                    65918.3,
                    61967.3
                  ],
                  [
                    66111.2,
                    62005.8
                  ],
                  [
                    66186.3,
                    62047.3
                  ],
                  [
                    66283.4,
                    62148.8
                  ],
                  [
                    66371.2,
                    62211.7
                  ],
                  [
                    66362.9,
                    62234
                  ],
                  [
                    66354.3,
                    62254.7
                  ],
                  [
                    66356.9,
                    62297.4
                  ],
                  [
                    66345.7,
                    62341.5
                  ],
                  [
                    66325.2,
                    62376.4
                  ],
                  [
                    66306,
                    62411.1
                  ],
                  [
                    66303.1,
                    62450.2
                  ],
                  [
                    66314.9,
                    62486
                  ],
                  [
                    66340.7,
                    62532.9
                  ],
                  [
                    66353,
                    62589.1
                  ],
                  [
                    66367.1,
                    62646.2
                  ],
                  [
                    66354.2,
                    62673.7
                  ],
                  [
                    66330.2,
                    62686.7
                  ],
                  [
                    66295.5,
                    62706.9
                  ],
                  [
                    66289,
                    62734.8
                  ],
                  [
                    66307.3,
                    62782.4
                  ],
                  [
                    66341.3,
                    62849.4
                  ],
                  [
                    66394.7,
                    62949.8
                  ],
                  [
                    66099.7,
                    63071.3
                  ],
                  [
                    66032.2,
                    63203.4
                  ],
                  [
                    65729.1,
                    63278
                  ],
                  [
                    65631.1,
                    63182.3
                  ],
                  [
                    65388.6,
                    63191
                  ],
                  [
                    65413,
                    62964.1
                  ],
                  [
                    65334.2,
                    62723.6
                  ],
                  [
                    65365.1,
                    62608.4
                  ],
                  [
                    65261.2,
                    62536.8
                  ],
                  [
                    65209.7,
                    62497.5
                  ],
                  [
                    65509.7,
                    62062.4
                  ]
                ],
                "id": 1650,
                "chat_link": "[&BHIGAAA=]"
              },
              "1651": {
                "name": "Arkjok Farmlands",
                "level": 80,
                "coord": [
                  64568.3,
                  60729.9
                ],
                "bounds": [
                  [
                    64101.8,
                    61424.7
                  ],
                  [
                    63988.9,
                    61369.7
                  ],
                  [
                    64056.4,
                    60840.2
                  ],
                  [
                    64448.8,
                    60337.5
                  ],
                  [
                    64583.7,
                    60125.1
                  ],
                  [
                    64699.6,
                    60181.9
                  ],
                  [
                    64900.6,
                    60368.1
                  ],
                  [
                    64973.4,
                    60590.8
                  ],
                  [
                    65016,
                    60788.6
                  ],
                  [
                    64862.9,
                    60973.6
                  ],
                  [
                    64619,
                    61028.6
                  ],
                  [
                    64101.8,
                    61424.7
                  ]
                ],
                "id": 1651,
                "chat_link": "[&BHMGAAA=]"
              },
              "1652": {
                "name": "Yohlon Bluffs",
                "level": 80,
                "coord": [
                  65090.4,
                  59976.6
                ],
                "bounds": [
                  [
                    65728.1,
                    60226.2
                  ],
                  [
                    65921.8,
                    60095.3
                  ],
                  [
                    65917.7,
                    60081.4
                  ],
                  [
                    65886.3,
                    60001.3
                  ],
                  [
                    65840.5,
                    59843.6
                  ],
                  [
                    65831.1,
                    59549.9
                  ],
                  [
                    64460.9,
                    59553.2
                  ],
                  [
                    64483.4,
                    59826
                  ],
                  [
                    64485,
                    59860.8
                  ],
                  [
                    64496,
                    59920.9
                  ],
                  [
                    64526.4,
                    60015.4
                  ],
                  [
                    64550.5,
                    60069.9
                  ],
                  [
                    64586.5,
                    60143.5
                  ],
                  [
                    64635.2,
                    60151.9
                  ],
                  [
                    64702.6,
                    60197.5
                  ],
                  [
                    65140.8,
                    59964.9
                  ],
                  [
                    65343.5,
                    60100.8
                  ],
                  [
                    65728.1,
                    60226.2
                  ]
                ],
                "id": 1652,
                "chat_link": "[&BHQGAAA=]"
              },
              "1653": {
                "name": "Dabiji Hollows",
                "level": 80,
                "coord": [
                  65404.6,
                  61362.2
                ],
                "bounds": [
                  [
                    65658.1,
                    61253.7
                  ],
                  [
                    65545.9,
                    61796.5
                  ],
                  [
                    65501.4,
                    61815.5
                  ],
                  [
                    65410.6,
                    61820.9
                  ],
                  [
                    65347.2,
                    61825.4
                  ],
                  [
                    65305.4,
                    61825.8
                  ],
                  [
                    65247.3,
                    61795.1
                  ],
                  [
                    65196.5,
                    61758.5
                  ],
                  [
                    65165.1,
                    61724.6
                  ],
                  [
                    65100.6,
                    61496
                  ],
                  [
                    65101.6,
                    61423.4
                  ],
                  [
                    65215.9,
                    61270
                  ],
                  [
                    65107.7,
                    61145.7
                  ],
                  [
                    65162.2,
                    61061.9
                  ],
                  [
                    65284.6,
                    61054.6
                  ],
                  [
                    65371.5,
                    60897.9
                  ],
                  [
                    65476.7,
                    60770.6
                  ],
                  [
                    65687,
                    60689
                  ],
                  [
                    65897.5,
                    60806.6
                  ],
                  [
                    65946.6,
                    61137.9
                  ],
                  [
                    65766.3,
                    61236
                  ],
                  [
                    65658.1,
                    61253.7
                  ]
                ],
                "id": 1653,
                "chat_link": "[&BHUGAAA=]"
              },
              "1654": {
                "name": "Veldrunner Drifts",
                "level": 80,
                "coord": [
                  66675.2,
                  60647.4
                ],
                "bounds": [
                  [
                    66674.2,
                    60304.8
                  ],
                  [
                    66784,
                    60200.5
                  ],
                  [
                    66812,
                    60231.6
                  ],
                  [
                    66853.7,
                    60263.4
                  ],
                  [
                    66907.7,
                    60296.1
                  ],
                  [
                    66956,
                    60338.8
                  ],
                  [
                    66988.3,
                    60360.2
                  ],
                  [
                    67027.3,
                    60406.5
                  ],
                  [
                    67053.4,
                    60439.8
                  ],
                  [
                    67081.8,
                    60478.6
                  ],
                  [
                    67103.3,
                    60540.2
                  ],
                  [
                    67113,
                    60596
                  ],
                  [
                    67110.7,
                    60671.5
                  ],
                  [
                    67112.6,
                    60767.7
                  ],
                  [
                    67049.9,
                    61048.9
                  ],
                  [
                    67030.1,
                    61056.4
                  ],
                  [
                    66723.2,
                    60942.6
                  ],
                  [
                    66477.1,
                    60860
                  ],
                  [
                    66303.3,
                    60887.1
                  ],
                  [
                    66201.1,
                    61011.5
                  ],
                  [
                    66127.3,
                    61132.6
                  ],
                  [
                    66016.8,
                    61191.7
                  ],
                  [
                    65949,
                    61141.2
                  ],
                  [
                    65887.9,
                    60810.5
                  ],
                  [
                    66099,
                    60430.7
                  ],
                  [
                    66112.4,
                    60424.1
                  ],
                  [
                    66674.2,
                    60304.8
                  ]
                ],
                "id": 1654,
                "chat_link": "[&BHYGAAA=]"
              },
              "1655": {
                "name": "Kodonur Crossing",
                "level": 80,
                "coord": [
                  66497.1,
                  59984
                ],
                "bounds": [
                  [
                    65840.6,
                    59842.4
                  ],
                  [
                    65832.7,
                    59565.4
                  ],
                  [
                    66548.7,
                    59527.6
                  ],
                  [
                    66597.9,
                    59769.3
                  ],
                  [
                    66607.4,
                    59787
                  ],
                  [
                    66646.9,
                    59805.4
                  ],
                  [
                    66684.5,
                    59832.6
                  ],
                  [
                    66711.4,
                    59850.7
                  ],
                  [
                    66731.6,
                    59880.9
                  ],
                  [
                    66753.4,
                    59923.4
                  ],
                  [
                    66769,
                    60005.9
                  ],
                  [
                    66770.4,
                    60053.7
                  ],
                  [
                    66771.1,
                    60085.7
                  ],
                  [
                    66771,
                    60119.4
                  ],
                  [
                    66781.5,
                    60168
                  ],
                  [
                    66787,
                    60203.1
                  ],
                  [
                    66782.4,
                    60238
                  ],
                  [
                    66675.4,
                    60308.5
                  ],
                  [
                    66096.1,
                    60436.9
                  ],
                  [
                    66008,
                    60167
                  ],
                  [
                    65901.6,
                    60086.9
                  ],
                  [
                    65867.7,
                    59989.9
                  ],
                  [
                    65840.6,
                    59842.4
                  ]
                ],
                "id": 1655,
                "chat_link": "[&BHcGAAA=]"
              },
              "1656": {
                "name": "Corsair Landing",
                "level": 80,
                "coord": [
                  63917.4,
                  62743.9
                ],
                "bounds": [
                  [
                    63668,
                    62771.9
                  ],
                  [
                    63664.1,
                    62814.7
                  ],
                  [
                    63664.5,
                    62869.4
                  ],
                  [
                    63682.7,
                    62967.3
                  ],
                  [
                    63821.7,
                    63019
                  ],
                  [
                    64002.7,
                    62977.2
                  ],
                  [
                    64391.6,
                    63128.2
                  ],
                  [
                    64433.6,
                    62854.3
                  ],
                  [
                    64459.4,
                    62809.5
                  ],
                  [
                    64608.7,
                    62666.5
                  ],
                  [
                    63936,
                    62406.3
                  ],
                  [
                    63820.4,
                    62424.1
                  ],
                  [
                    63762.6,
                    62470.7
                  ],
                  [
                    63732,
                    62571.6
                  ],
                  [
                    63729.1,
                    62610.8
                  ],
                  [
                    63727.9,
                    62648.7
                  ],
                  [
                    63716.9,
                    62680
                  ],
                  [
                    63691.8,
                    62700.6
                  ],
                  [
                    63668,
                    62771.9
                  ]
                ],
                "id": 1656,
                "chat_link": "[&BHgGAAA=]"
              },
              "1658": {
                "name": "Elon Basin",
                "level": 80,
                "coord": [
                  65368.7,
                  60595.2
                ],
                "bounds": [
                  [
                    65695.3,
                    60682.7
                  ],
                  [
                    65895.4,
                    60811.9
                  ],
                  [
                    66102,
                    60437.4
                  ],
                  [
                    66014.1,
                    60165
                  ],
                  [
                    65919.4,
                    60079
                  ],
                  [
                    65737.2,
                    60214.1
                  ],
                  [
                    65347.9,
                    60092.9
                  ],
                  [
                    65139.3,
                    59956
                  ],
                  [
                    64702.6,
                    60197.5
                  ],
                  [
                    64823.6,
                    60444
                  ],
                  [
                    64968.4,
                    60594.7
                  ],
                  [
                    65017.8,
                    60777.3
                  ],
                  [
                    64847.7,
                    60977.8
                  ],
                  [
                    65112.9,
                    61155.8
                  ],
                  [
                    65170.9,
                    61053.1
                  ],
                  [
                    65300.1,
                    61037
                  ],
                  [
                    65328.8,
                    60986.8
                  ],
                  [
                    65394.9,
                    60880.3
                  ],
                  [
                    65487.4,
                    60765.2
                  ],
                  [
                    65695.3,
                    60682.7
                  ]
                ],
                "id": 1658,
                "chat_link": "[&BHoGAAA=]"
              },
              "1659": {
                "name": "Gandara, the Moon Fortress",
                "level": 80,
                "coord": [
                  64908.7,
                  63100.9
                ],
                "bounds": [
                  [
                    64372.9,
                    63259.7
                  ],
                  [
                    64399.2,
                    63184.4
                  ],
                  [
                    64385.5,
                    63125.5
                  ],
                  [
                    64392.1,
                    63033.6
                  ],
                  [
                    64413.9,
                    62941.2
                  ],
                  [
                    64422.9,
                    62852.3
                  ],
                  [
                    64454.6,
                    62808.5
                  ],
                  [
                    64533.1,
                    62709.8
                  ],
                  [
                    64629.5,
                    62646.5
                  ],
                  [
                    65143.4,
                    62443.1
                  ],
                  [
                    65372.5,
                    62596.3
                  ],
                  [
                    65360.6,
                    62692.8
                  ],
                  [
                    65353.9,
                    62741.2
                  ],
                  [
                    65381.7,
                    62816.8
                  ],
                  [
                    65420.8,
                    62959.9
                  ],
                  [
                    65403.8,
                    63029.6
                  ],
                  [
                    65403.7,
                    63123.1
                  ],
                  [
                    65376.5,
                    63211.9
                  ],
                  [
                    65333.4,
                    63317.1
                  ],
                  [
                    65249.4,
                    63409.6
                  ],
                  [
                    65182.5,
                    63479.3
                  ],
                  [
                    65087.7,
                    63536.8
                  ],
                  [
                    64933.7,
                    63606.8
                  ],
                  [
                    64790.4,
                    63621.5
                  ],
                  [
                    64676.7,
                    63582.4
                  ],
                  [
                    64592,
                    63542.8
                  ],
                  [
                    64469.7,
                    63452.7
                  ],
                  [
                    64372.9,
                    63259.7
                  ]
                ],
                "id": 1659,
                "chat_link": "[&BHsGAAA=]"
              },
              "1660": {
                "name": "Ntouka Pond",
                "level": 80,
                "coord": [
                  63880.8,
                  60603.3
                ],
                "bounds": [
                  [
                    64585.4,
                    60139.6
                  ],
                  [
                    64507.7,
                    59947.1
                  ],
                  [
                    64464.4,
                    59560.9
                  ],
                  [
                    63887.8,
                    59541
                  ],
                  [
                    63875.3,
                    60098.5
                  ],
                  [
                    63870.9,
                    60145.6
                  ],
                  [
                    63873.3,
                    60207.2
                  ],
                  [
                    63841.4,
                    60288.2
                  ],
                  [
                    63814.1,
                    60372.7
                  ],
                  [
                    63774.8,
                    60444.7
                  ],
                  [
                    63768.8,
                    60533.9
                  ],
                  [
                    63757.4,
                    60585.8
                  ],
                  [
                    63715.6,
                    60644.7
                  ],
                  [
                    63708.3,
                    60666.4
                  ],
                  [
                    63708.6,
                    60697.7
                  ],
                  [
                    63711.2,
                    60793.1
                  ],
                  [
                    63712,
                    60833.7
                  ],
                  [
                    63713.8,
                    60852.3
                  ],
                  [
                    63723.6,
                    60874.9
                  ],
                  [
                    63746.9,
                    60936
                  ],
                  [
                    63719.8,
                    61270.6
                  ],
                  [
                    63746.9,
                    61325.3
                  ],
                  [
                    63788.1,
                    61353.9
                  ],
                  [
                    63829,
                    61359.9
                  ],
                  [
                    63995.1,
                    61370.4
                  ],
                  [
                    64060.4,
                    60840.7
                  ],
                  [
                    64585.4,
                    60139.6
                  ]
                ],
                "id": 1660,
                "chat_link": "[&BHwGAAA=]"
              },
              "1661": {
                "name": "Bitterfly Bayou",
                "level": 80,
                "coord": [
                  66386.1,
                  61553
                ],
                "bounds": [
                  [
                    65553.6,
                    61790.8
                  ],
                  [
                    65566.7,
                    61492
                  ],
                  [
                    65650.9,
                    61261.6
                  ],
                  [
                    65952.3,
                    61138.6
                  ],
                  [
                    66019.9,
                    61178.6
                  ],
                  [
                    66114.7,
                    61128.7
                  ],
                  [
                    66160.7,
                    61036.1
                  ],
                  [
                    66244.5,
                    60928
                  ],
                  [
                    66304.6,
                    60882.2
                  ],
                  [
                    66470.5,
                    60859.4
                  ],
                  [
                    66715.1,
                    60935.8
                  ],
                  [
                    67045.1,
                    61038.7
                  ],
                  [
                    67032.9,
                    61057.2
                  ],
                  [
                    66947.1,
                    61100.3
                  ],
                  [
                    66881.4,
                    61141.4
                  ],
                  [
                    66852.3,
                    61178.6
                  ],
                  [
                    66848.2,
                    61225.9
                  ],
                  [
                    66905,
                    61312.4
                  ],
                  [
                    66906.2,
                    61385.2
                  ],
                  [
                    66900.3,
                    61413
                  ],
                  [
                    66860.5,
                    61447.1
                  ],
                  [
                    66774.7,
                    61521.3
                  ],
                  [
                    66728,
                    61589.1
                  ],
                  [
                    66672.3,
                    61653.1
                  ],
                  [
                    66646.9,
                    61715.9
                  ],
                  [
                    66658.8,
                    61842
                  ],
                  [
                    66615.4,
                    61967.7
                  ],
                  [
                    66591.6,
                    62035.7
                  ],
                  [
                    66566,
                    62098.5
                  ],
                  [
                    66559.9,
                    62182.2
                  ],
                  [
                    66481.9,
                    62235.2
                  ],
                  [
                    66362.8,
                    62215.2
                  ],
                  [
                    66271.1,
                    62145.5
                  ],
                  [
                    66176.9,
                    62054.5
                  ],
                  [
                    66049.5,
                    61995.4
                  ],
                  [
                    65952.4,
                    61990.1
                  ],
                  [
                    65902.5,
                    61965.3
                  ],
                  [
                    65852.3,
                    61945.2
                  ],
                  [
                    65765.1,
                    61895.3
                  ],
                  [
                    65682.4,
                    61867.6
                  ],
                  [
                    65587.9,
                    61826.8
                  ],
                  [
                    65553.6,
                    61790.8
                  ]
                ],
                "id": 1661,
                "chat_link": "[&BH0GAAA=]"
              }
            },
            "adventures": [],
            "id": 1288,
            "mastery_points": [
              {
                "coord": [
                  65365.1,
                  61670.2
                ],
                "id": 432,
                "region": "Desert"
              },
              {
                "coord": [
                  65500.7,
                  59808
                ],
                "id": 434,
                "region": "Desert"
              },
              {
                "coord": [
                  64666.3,
                  61711.9
                ],
                "id": 430,
                "region": "Desert"
              },
              {
                "coord": [
                  64105.2,
                  60575.2
                ],
                "id": 436,
                "region": "Desert"
              },
              {
                "coord": [
                  65776.7,
                  63069.1
                ],
                "id": 435,
                "region": "Desert"
              }
            ]
          },
          "1289": {
            "name": "Seized",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              59968,
              43534
            ],
            "map_rect": [
              [
                -30720,
                -30720
              ],
              [
                30720,
                30720
              ]
            ],
            "continent_rect": [
              [
                57256,
                42304
              ],
              [
                59816,
                44864
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1931": {
                "level": 80,
                "coord": [
                  58098.4,
                  43608.1
                ],
                "bounds": [
                  [
                    57653.4,
                    44249
                  ],
                  [
                    57610.6,
                    43463
                  ],
                  [
                    57982.6,
                    43008.7
                  ],
                  [
                    58611,
                    43134
                  ],
                  [
                    58634.5,
                    44185.7
                  ],
                  [
                    57653.4,
                    44249
                  ]
                ],
                "id": 1931,
                "chat_link": "[&BIsHAAA=]"
              }
            },
            "adventures": [],
            "id": 1289,
            "mastery_points": []
          },
          "1292": {
            "name": "Be My Guest",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              59968,
              43534
            ],
            "map_rect": [
              [
                -49152,
                -55296
              ],
              [
                49152,
                58368
              ]
            ],
            "continent_rect": [
              [
                63624,
                59572
              ],
              [
                67720,
                64308
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1644": {
                "name": "Front Line",
                "level": 80,
                "coord": [
                  65134.7,
                  62066.7
                ],
                "bounds": [
                  [
                    64464.6,
                    62034.8
                  ],
                  [
                    64612.8,
                    62011.1
                  ],
                  [
                    64699.6,
                    61978
                  ],
                  [
                    64859.9,
                    61823.6
                  ],
                  [
                    64915.3,
                    61749.5
                  ],
                  [
                    65140.3,
                    61736.2
                  ],
                  [
                    65202.6,
                    61722
                  ],
                  [
                    65216.8,
                    61768.4
                  ],
                  [
                    65259.8,
                    61802.7
                  ],
                  [
                    65331.8,
                    61823.5
                  ],
                  [
                    65444,
                    61831.3
                  ],
                  [
                    65541.6,
                    61805.8
                  ],
                  [
                    65575,
                    61816.9
                  ],
                  [
                    65633.5,
                    61841.5
                  ],
                  [
                    65705.9,
                    61875.6
                  ],
                  [
                    65737.1,
                    61880.5
                  ],
                  [
                    65718.9,
                    61993.5
                  ],
                  [
                    65643.2,
                    62090.3
                  ],
                  [
                    65556.6,
                    62097.8
                  ],
                  [
                    65279.3,
                    62525.3
                  ],
                  [
                    65119.6,
                    62463.3
                  ],
                  [
                    64994.8,
                    62504.6
                  ],
                  [
                    64784.1,
                    62559.5
                  ],
                  [
                    64606.4,
                    62669.5
                  ],
                  [
                    64503.3,
                    62632.7
                  ],
                  [
                    64564.2,
                    62440
                  ],
                  [
                    64526,
                    62323.8
                  ],
                  [
                    64464.6,
                    62034.8
                  ]
                ],
                "id": 1644,
                "chat_link": "[&BGwGAAA=]"
              },
              "1646": {
                "name": "Bay of Gandara",
                "level": 80,
                "coord": [
                  65108.3,
                  63327.2
                ],
                "bounds": [
                  [
                    63935.6,
                    63388.9
                  ],
                  [
                    63815.3,
                    63319.7
                  ],
                  [
                    63696.2,
                    63217.7
                  ],
                  [
                    63670.9,
                    63082.4
                  ],
                  [
                    63685.3,
                    62963.3
                  ],
                  [
                    63804.1,
                    63015.7
                  ],
                  [
                    63966,
                    62982
                  ],
                  [
                    64371.2,
                    63116
                  ],
                  [
                    64376.4,
                    63257.6
                  ],
                  [
                    64472.2,
                    63448.8
                  ],
                  [
                    64580.8,
                    63526.8
                  ],
                  [
                    64680,
                    63576.1
                  ],
                  [
                    64792.2,
                    63617.5
                  ],
                  [
                    64929.8,
                    63599.8
                  ],
                  [
                    65085,
                    63528.6
                  ],
                  [
                    65220.2,
                    63429.3
                  ],
                  [
                    65350.5,
                    63291.2
                  ],
                  [
                    65390.1,
                    63184.5
                  ],
                  [
                    65633.4,
                    63176.3
                  ],
                  [
                    65738.9,
                    63267.7
                  ],
                  [
                    66024,
                    63195.7
                  ],
                  [
                    66091.1,
                    63064.4
                  ],
                  [
                    66392.9,
                    62950.3
                  ],
                  [
                    66440.5,
                    63065.9
                  ],
                  [
                    66467.8,
                    63174.7
                  ],
                  [
                    66463.4,
                    63219.7
                  ],
                  [
                    66452.2,
                    63243.5
                  ],
                  [
                    66437.4,
                    63267.7
                  ],
                  [
                    66398.3,
                    63300.9
                  ],
                  [
                    66322.6,
                    63345.6
                  ],
                  [
                    66187.5,
                    63408.8
                  ],
                  [
                    65677.1,
                    63558.2
                  ],
                  [
                    65290.9,
                    63671.2
                  ],
                  [
                    65067,
                    63706.8
                  ],
                  [
                    64585.8,
                    63699.3
                  ],
                  [
                    64318,
                    63578.6
                  ],
                  [
                    64226.2,
                    63529.5
                  ],
                  [
                    64079,
                    63463.7
                  ],
                  [
                    63935.6,
                    63388.9
                  ]
                ],
                "id": 1646,
                "chat_link": "[&BG4GAAA=]"
              },
              "1647": {
                "name": "Allied Encampment",
                "level": 80,
                "coord": [
                  64716.1,
                  61683.3
                ],
                "bounds": [
                  [
                    64339.5,
                    62010.4
                  ],
                  [
                    64192.7,
                    61872.9
                  ],
                  [
                    64206.8,
                    61797.6
                  ],
                  [
                    64230.2,
                    61622.7
                  ],
                  [
                    64231.9,
                    61602.9
                  ],
                  [
                    64222.7,
                    61585.8
                  ],
                  [
                    64096,
                    61423.1
                  ],
                  [
                    64616.8,
                    61028.7
                  ],
                  [
                    64860.5,
                    60972
                  ],
                  [
                    65077.2,
                    61130.6
                  ],
                  [
                    65253.9,
                    61265.6
                  ],
                  [
                    65125.3,
                    61553.2
                  ],
                  [
                    65171.4,
                    61673.9
                  ],
                  [
                    65179.4,
                    61752
                  ],
                  [
                    65209,
                    61759.2
                  ],
                  [
                    65066.8,
                    61737.4
                  ],
                  [
                    65020.9,
                    61731.9
                  ],
                  [
                    64966.6,
                    61743.2
                  ],
                  [
                    64891.3,
                    61770.7
                  ],
                  [
                    64875.7,
                    61809.6
                  ],
                  [
                    64821.4,
                    61898.4
                  ],
                  [
                    64748,
                    61950.7
                  ],
                  [
                    64690.5,
                    61984.5
                  ],
                  [
                    64602.9,
                    62020.6
                  ],
                  [
                    64522.6,
                    62033.9
                  ],
                  [
                    64399.7,
                    62034.4
                  ],
                  [
                    64339.5,
                    62010.4
                  ]
                ],
                "id": 1647,
                "chat_link": "[&BG8GAAA=]"
              },
              "1648": {
                "name": "Western Front",
                "level": 80,
                "coord": [
                  64217.9,
                  62215.9
                ],
                "bounds": [
                  [
                    63935.5,
                    62409.9
                  ],
                  [
                    64509,
                    62643.1
                  ],
                  [
                    64572.2,
                    62444.1
                  ],
                  [
                    64539.9,
                    62326
                  ],
                  [
                    64471.7,
                    62021.6
                  ],
                  [
                    64350.4,
                    62019.5
                  ],
                  [
                    64201.2,
                    61861.1
                  ],
                  [
                    64078.4,
                    61993
                  ],
                  [
                    64034.8,
                    62045.4
                  ],
                  [
                    64036.8,
                    62150.7
                  ],
                  [
                    63986.9,
                    62262.8
                  ],
                  [
                    63898,
                    62413.9
                  ],
                  [
                    63935.5,
                    62409.9
                  ]
                ],
                "id": 1648,
                "chat_link": "[&BHAGAAA=]"
              },
              "1650": {
                "name": "Eastern Front",
                "level": 80,
                "coord": [
                  66009.3,
                  62501.1
                ],
                "bounds": [
                  [
                    65509.7,
                    62062.4
                  ],
                  [
                    65609.2,
                    62042.6
                  ],
                  [
                    65692.4,
                    62019.2
                  ],
                  [
                    65721,
                    61992.7
                  ],
                  [
                    65723.6,
                    61908.3
                  ],
                  [
                    65729.5,
                    61876.2
                  ],
                  [
                    65918.3,
                    61967.3
                  ],
                  [
                    66111.2,
                    62005.8
                  ],
                  [
                    66186.3,
                    62047.3
                  ],
                  [
                    66283.4,
                    62148.8
                  ],
                  [
                    66371.2,
                    62211.7
                  ],
                  [
                    66362.9,
                    62234
                  ],
                  [
                    66354.3,
                    62254.7
                  ],
                  [
                    66356.9,
                    62297.4
                  ],
                  [
                    66345.7,
                    62341.5
                  ],
                  [
                    66325.2,
                    62376.4
                  ],
                  [
                    66306,
                    62411.1
                  ],
                  [
                    66303.1,
                    62450.2
                  ],
                  [
                    66314.9,
                    62486
                  ],
                  [
                    66340.7,
                    62532.9
                  ],
                  [
                    66353,
                    62589.1
                  ],
                  [
                    66367.1,
                    62646.2
                  ],
                  [
                    66354.2,
                    62673.7
                  ],
                  [
                    66330.2,
                    62686.7
                  ],
                  [
                    66295.5,
                    62706.9
                  ],
                  [
                    66289,
                    62734.8
                  ],
                  [
                    66307.3,
                    62782.4
                  ],
                  [
                    66341.3,
                    62849.4
                  ],
                  [
                    66394.7,
                    62949.8
                  ],
                  [
                    66099.7,
                    63071.3
                  ],
                  [
                    66032.2,
                    63203.4
                  ],
                  [
                    65729.1,
                    63278
                  ],
                  [
                    65631.1,
                    63182.3
                  ],
                  [
                    65388.6,
                    63191
                  ],
                  [
                    65413,
                    62964.1
                  ],
                  [
                    65334.2,
                    62723.6
                  ],
                  [
                    65365.1,
                    62608.4
                  ],
                  [
                    65261.2,
                    62536.8
                  ],
                  [
                    65209.7,
                    62497.5
                  ],
                  [
                    65509.7,
                    62062.4
                  ]
                ],
                "id": 1650,
                "chat_link": "[&BHIGAAA=]"
              },
              "1651": {
                "name": "Arkjok Farmlands",
                "level": 80,
                "coord": [
                  64568.3,
                  60729.9
                ],
                "bounds": [
                  [
                    64101.8,
                    61424.7
                  ],
                  [
                    63988.9,
                    61369.7
                  ],
                  [
                    64056.4,
                    60840.2
                  ],
                  [
                    64448.8,
                    60337.5
                  ],
                  [
                    64583.7,
                    60125.1
                  ],
                  [
                    64699.6,
                    60181.9
                  ],
                  [
                    64900.6,
                    60368.1
                  ],
                  [
                    64973.4,
                    60590.8
                  ],
                  [
                    65016,
                    60788.6
                  ],
                  [
                    64862.9,
                    60973.6
                  ],
                  [
                    64619,
                    61028.6
                  ],
                  [
                    64101.8,
                    61424.7
                  ]
                ],
                "id": 1651,
                "chat_link": "[&BHMGAAA=]"
              },
              "1653": {
                "name": "Dabiji Hollows",
                "level": 80,
                "coord": [
                  65404.6,
                  61362.2
                ],
                "bounds": [
                  [
                    65658.1,
                    61253.7
                  ],
                  [
                    65545.9,
                    61796.5
                  ],
                  [
                    65501.4,
                    61815.5
                  ],
                  [
                    65410.6,
                    61820.9
                  ],
                  [
                    65347.2,
                    61825.4
                  ],
                  [
                    65305.4,
                    61825.8
                  ],
                  [
                    65247.3,
                    61795.1
                  ],
                  [
                    65196.5,
                    61758.5
                  ],
                  [
                    65165.1,
                    61724.6
                  ],
                  [
                    65100.6,
                    61496
                  ],
                  [
                    65101.6,
                    61423.4
                  ],
                  [
                    65215.9,
                    61270
                  ],
                  [
                    65107.7,
                    61145.7
                  ],
                  [
                    65162.2,
                    61061.9
                  ],
                  [
                    65284.6,
                    61054.6
                  ],
                  [
                    65371.5,
                    60897.9
                  ],
                  [
                    65476.7,
                    60770.6
                  ],
                  [
                    65687,
                    60689
                  ],
                  [
                    65897.5,
                    60806.6
                  ],
                  [
                    65946.6,
                    61137.9
                  ],
                  [
                    65766.3,
                    61236
                  ],
                  [
                    65658.1,
                    61253.7
                  ]
                ],
                "id": 1653,
                "chat_link": "[&BHUGAAA=]"
              },
              "1654": {
                "name": "Veldrunner Drifts",
                "level": 80,
                "coord": [
                  66675.2,
                  60647.4
                ],
                "bounds": [
                  [
                    66674.2,
                    60304.8
                  ],
                  [
                    66784,
                    60200.5
                  ],
                  [
                    66812,
                    60231.6
                  ],
                  [
                    66853.7,
                    60263.4
                  ],
                  [
                    66907.7,
                    60296.1
                  ],
                  [
                    66956,
                    60338.8
                  ],
                  [
                    66988.3,
                    60360.2
                  ],
                  [
                    67027.3,
                    60406.5
                  ],
                  [
                    67053.4,
                    60439.8
                  ],
                  [
                    67081.8,
                    60478.6
                  ],
                  [
                    67103.3,
                    60540.2
                  ],
                  [
                    67113,
                    60596
                  ],
                  [
                    67110.7,
                    60671.5
                  ],
                  [
                    67112.6,
                    60767.7
                  ],
                  [
                    67049.9,
                    61048.9
                  ],
                  [
                    67030.1,
                    61056.4
                  ],
                  [
                    66723.2,
                    60942.6
                  ],
                  [
                    66477.1,
                    60860
                  ],
                  [
                    66303.3,
                    60887.1
                  ],
                  [
                    66201.1,
                    61011.5
                  ],
                  [
                    66127.3,
                    61132.6
                  ],
                  [
                    66016.8,
                    61191.7
                  ],
                  [
                    65949,
                    61141.2
                  ],
                  [
                    65887.9,
                    60810.5
                  ],
                  [
                    66099,
                    60430.7
                  ],
                  [
                    66112.4,
                    60424.1
                  ],
                  [
                    66674.2,
                    60304.8
                  ]
                ],
                "id": 1654,
                "chat_link": "[&BHYGAAA=]"
              },
              "1655": {
                "name": "Kodonur Crossing",
                "level": 80,
                "coord": [
                  66497.1,
                  59984
                ],
                "bounds": [
                  [
                    65840.6,
                    59842.4
                  ],
                  [
                    65832.7,
                    59565.4
                  ],
                  [
                    66548.7,
                    59527.6
                  ],
                  [
                    66597.9,
                    59769.3
                  ],
                  [
                    66607.4,
                    59787
                  ],
                  [
                    66646.9,
                    59805.4
                  ],
                  [
                    66684.5,
                    59832.6
                  ],
                  [
                    66711.4,
                    59850.7
                  ],
                  [
                    66731.6,
                    59880.9
                  ],
                  [
                    66753.4,
                    59923.4
                  ],
                  [
                    66769,
                    60005.9
                  ],
                  [
                    66770.4,
                    60053.7
                  ],
                  [
                    66771.1,
                    60085.7
                  ],
                  [
                    66771,
                    60119.4
                  ],
                  [
                    66781.5,
                    60168
                  ],
                  [
                    66787,
                    60203.1
                  ],
                  [
                    66782.4,
                    60238
                  ],
                  [
                    66675.4,
                    60308.5
                  ],
                  [
                    66096.1,
                    60436.9
                  ],
                  [
                    66008,
                    60167
                  ],
                  [
                    65901.6,
                    60086.9
                  ],
                  [
                    65867.7,
                    59989.9
                  ],
                  [
                    65840.6,
                    59842.4
                  ]
                ],
                "id": 1655,
                "chat_link": "[&BHcGAAA=]"
              },
              "1656": {
                "name": "Corsair Landing",
                "level": 80,
                "coord": [
                  63917.4,
                  62743.9
                ],
                "bounds": [
                  [
                    63668,
                    62771.9
                  ],
                  [
                    63664.1,
                    62814.7
                  ],
                  [
                    63664.5,
                    62869.4
                  ],
                  [
                    63682.7,
                    62967.3
                  ],
                  [
                    63821.7,
                    63019
                  ],
                  [
                    64002.7,
                    62977.2
                  ],
                  [
                    64391.6,
                    63128.2
                  ],
                  [
                    64433.6,
                    62854.3
                  ],
                  [
                    64459.4,
                    62809.5
                  ],
                  [
                    64608.7,
                    62666.5
                  ],
                  [
                    63936,
                    62406.3
                  ],
                  [
                    63820.4,
                    62424.1
                  ],
                  [
                    63762.6,
                    62470.7
                  ],
                  [
                    63732,
                    62571.6
                  ],
                  [
                    63729.1,
                    62610.8
                  ],
                  [
                    63727.9,
                    62648.7
                  ],
                  [
                    63716.9,
                    62680
                  ],
                  [
                    63691.8,
                    62700.6
                  ],
                  [
                    63668,
                    62771.9
                  ]
                ],
                "id": 1656,
                "chat_link": "[&BHgGAAA=]"
              },
              "1658": {
                "name": "Elon Basin",
                "level": 80,
                "coord": [
                  65368.7,
                  60595.2
                ],
                "bounds": [
                  [
                    65695.3,
                    60682.7
                  ],
                  [
                    65895.4,
                    60811.9
                  ],
                  [
                    66102,
                    60437.4
                  ],
                  [
                    66014.1,
                    60165
                  ],
                  [
                    65919.4,
                    60079
                  ],
                  [
                    65737.2,
                    60214.1
                  ],
                  [
                    65347.9,
                    60092.9
                  ],
                  [
                    65139.3,
                    59956
                  ],
                  [
                    64702.6,
                    60197.5
                  ],
                  [
                    64823.6,
                    60444
                  ],
                  [
                    64968.4,
                    60594.7
                  ],
                  [
                    65017.8,
                    60777.3
                  ],
                  [
                    64847.7,
                    60977.8
                  ],
                  [
                    65112.9,
                    61155.8
                  ],
                  [
                    65170.9,
                    61053.1
                  ],
                  [
                    65300.1,
                    61037
                  ],
                  [
                    65328.8,
                    60986.8
                  ],
                  [
                    65394.9,
                    60880.3
                  ],
                  [
                    65487.4,
                    60765.2
                  ],
                  [
                    65695.3,
                    60682.7
                  ]
                ],
                "id": 1658,
                "chat_link": "[&BHoGAAA=]"
              },
              "1659": {
                "name": "Gandara, the Moon Fortress",
                "level": 80,
                "coord": [
                  64908.7,
                  63100.9
                ],
                "bounds": [
                  [
                    64372.9,
                    63259.7
                  ],
                  [
                    64399.2,
                    63184.4
                  ],
                  [
                    64385.5,
                    63125.5
                  ],
                  [
                    64392.1,
                    63033.6
                  ],
                  [
                    64413.9,
                    62941.2
                  ],
                  [
                    64422.9,
                    62852.3
                  ],
                  [
                    64454.6,
                    62808.5
                  ],
                  [
                    64533.1,
                    62709.8
                  ],
                  [
                    64629.5,
                    62646.5
                  ],
                  [
                    65143.4,
                    62443.1
                  ],
                  [
                    65372.5,
                    62596.3
                  ],
                  [
                    65360.6,
                    62692.8
                  ],
                  [
                    65353.9,
                    62741.2
                  ],
                  [
                    65381.7,
                    62816.8
                  ],
                  [
                    65420.8,
                    62959.9
                  ],
                  [
                    65403.8,
                    63029.6
                  ],
                  [
                    65403.7,
                    63123.1
                  ],
                  [
                    65376.5,
                    63211.9
                  ],
                  [
                    65333.4,
                    63317.1
                  ],
                  [
                    65249.4,
                    63409.6
                  ],
                  [
                    65182.5,
                    63479.3
                  ],
                  [
                    65087.7,
                    63536.8
                  ],
                  [
                    64933.7,
                    63606.8
                  ],
                  [
                    64790.4,
                    63621.5
                  ],
                  [
                    64676.7,
                    63582.4
                  ],
                  [
                    64592,
                    63542.8
                  ],
                  [
                    64469.7,
                    63452.7
                  ],
                  [
                    64372.9,
                    63259.7
                  ]
                ],
                "id": 1659,
                "chat_link": "[&BHsGAAA=]"
              },
              "1660": {
                "name": "Ntouka Pond",
                "level": 80,
                "coord": [
                  63880.8,
                  60603.3
                ],
                "bounds": [
                  [
                    64585.4,
                    60139.6
                  ],
                  [
                    64507.7,
                    59947.1
                  ],
                  [
                    64464.4,
                    59560.9
                  ],
                  [
                    63887.8,
                    59541
                  ],
                  [
                    63875.3,
                    60098.5
                  ],
                  [
                    63870.9,
                    60145.6
                  ],
                  [
                    63873.3,
                    60207.2
                  ],
                  [
                    63841.4,
                    60288.2
                  ],
                  [
                    63814.1,
                    60372.7
                  ],
                  [
                    63774.8,
                    60444.7
                  ],
                  [
                    63768.8,
                    60533.9
                  ],
                  [
                    63757.4,
                    60585.8
                  ],
                  [
                    63715.6,
                    60644.7
                  ],
                  [
                    63708.3,
                    60666.4
                  ],
                  [
                    63708.6,
                    60697.7
                  ],
                  [
                    63711.2,
                    60793.1
                  ],
                  [
                    63712,
                    60833.7
                  ],
                  [
                    63713.8,
                    60852.3
                  ],
                  [
                    63723.6,
                    60874.9
                  ],
                  [
                    63746.9,
                    60936
                  ],
                  [
                    63719.8,
                    61270.6
                  ],
                  [
                    63746.9,
                    61325.3
                  ],
                  [
                    63788.1,
                    61353.9
                  ],
                  [
                    63829,
                    61359.9
                  ],
                  [
                    63995.1,
                    61370.4
                  ],
                  [
                    64060.4,
                    60840.7
                  ],
                  [
                    64585.4,
                    60139.6
                  ]
                ],
                "id": 1660,
                "chat_link": "[&BHwGAAA=]"
              },
              "1661": {
                "name": "Bitterfly Bayou",
                "level": 80,
                "coord": [
                  66386.1,
                  61553
                ],
                "bounds": [
                  [
                    65553.6,
                    61790.8
                  ],
                  [
                    65566.7,
                    61492
                  ],
                  [
                    65650.9,
                    61261.6
                  ],
                  [
                    65952.3,
                    61138.6
                  ],
                  [
                    66019.9,
                    61178.6
                  ],
                  [
                    66114.7,
                    61128.7
                  ],
                  [
                    66160.7,
                    61036.1
                  ],
                  [
                    66244.5,
                    60928
                  ],
                  [
                    66304.6,
                    60882.2
                  ],
                  [
                    66470.5,
                    60859.4
                  ],
                  [
                    66715.1,
                    60935.8
                  ],
                  [
                    67045.1,
                    61038.7
                  ],
                  [
                    67032.9,
                    61057.2
                  ],
                  [
                    66947.1,
                    61100.3
                  ],
                  [
                    66881.4,
                    61141.4
                  ],
                  [
                    66852.3,
                    61178.6
                  ],
                  [
                    66848.2,
                    61225.9
                  ],
                  [
                    66905,
                    61312.4
                  ],
                  [
                    66906.2,
                    61385.2
                  ],
                  [
                    66900.3,
                    61413
                  ],
                  [
                    66860.5,
                    61447.1
                  ],
                  [
                    66774.7,
                    61521.3
                  ],
                  [
                    66728,
                    61589.1
                  ],
                  [
                    66672.3,
                    61653.1
                  ],
                  [
                    66646.9,
                    61715.9
                  ],
                  [
                    66658.8,
                    61842
                  ],
                  [
                    66615.4,
                    61967.7
                  ],
                  [
                    66591.6,
                    62035.7
                  ],
                  [
                    66566,
                    62098.5
                  ],
                  [
                    66559.9,
                    62182.2
                  ],
                  [
                    66481.9,
                    62235.2
                  ],
                  [
                    66362.8,
                    62215.2
                  ],
                  [
                    66271.1,
                    62145.5
                  ],
                  [
                    66176.9,
                    62054.5
                  ],
                  [
                    66049.5,
                    61995.4
                  ],
                  [
                    65952.4,
                    61990.1
                  ],
                  [
                    65902.5,
                    61965.3
                  ],
                  [
                    65852.3,
                    61945.2
                  ],
                  [
                    65765.1,
                    61895.3
                  ],
                  [
                    65682.4,
                    61867.6
                  ],
                  [
                    65587.9,
                    61826.8
                  ],
                  [
                    65553.6,
                    61790.8
                  ]
                ],
                "id": 1661,
                "chat_link": "[&BH0GAAA=]"
              }
            },
            "adventures": [],
            "id": 1292,
            "mastery_points": []
          },
          "1294": {
            "name": "Sun's Refuge",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -49152,
                -36864
              ],
              [
                49152,
                39936
              ]
            ],
            "continent_rect": [
              [
                63316,
                56376
              ],
              [
                67412,
                59576
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1664": {
                "name": "???",
                "level": 80,
                "coord": [
                  65536.9,
                  57501.1
                ],
                "bounds": [
                  [
                    65372.1,
                    57439.1
                  ],
                  [
                    65451.9,
                    57300.2
                  ],
                  [
                    65530.3,
                    57279.2
                  ],
                  [
                    65616.5,
                    57323.8
                  ],
                  [
                    65670.7,
                    57402.3
                  ],
                  [
                    65741,
                    57487.7
                  ],
                  [
                    65731.6,
                    57588
                  ],
                  [
                    65687.8,
                    57659.2
                  ],
                  [
                    65593.6,
                    57654.8
                  ],
                  [
                    65381.5,
                    57699.3
                  ],
                  [
                    65345,
                    57646.1
                  ],
                  [
                    65321.2,
                    57534
                  ],
                  [
                    65372.1,
                    57439.1
                  ]
                ],
                "id": 1664,
                "chat_link": "[&BIAGAAA=]"
              },
              "1665": {
                "name": "Argon Garrison",
                "level": 80,
                "coord": [
                  65312.8,
                  58785.8
                ],
                "bounds": [
                  [
                    64995,
                    58614
                  ],
                  [
                    65158.2,
                    58562.6
                  ],
                  [
                    65321.9,
                    58536.1
                  ],
                  [
                    65662.8,
                    58577.9
                  ],
                  [
                    65841.1,
                    58935.7
                  ],
                  [
                    65399.7,
                    59197.6
                  ],
                  [
                    65139.8,
                    59114.6
                  ],
                  [
                    64983.8,
                    58748.1
                  ],
                  [
                    64995,
                    58614
                  ]
                ],
                "id": 1665,
                "chat_link": "[&BIEGAAA=]"
              },
              "1666": {
                "name": "Venta Pass",
                "level": 80,
                "coord": [
                  64498.7,
                  57764.6
                ],
                "bounds": [
                  [
                    63390.7,
                    57768
                  ],
                  [
                    63375.4,
                    57870.3
                  ],
                  [
                    63396.3,
                    58007.2
                  ],
                  [
                    63537,
                    58044
                  ],
                  [
                    63622.8,
                    58041.1
                  ],
                  [
                    63987.8,
                    58042.8
                  ],
                  [
                    64103.8,
                    58053.8
                  ],
                  [
                    64210.8,
                    58083.4
                  ],
                  [
                    64446.5,
                    58069.9
                  ],
                  [
                    64832.7,
                    57812.7
                  ],
                  [
                    64938.3,
                    57857.7
                  ],
                  [
                    65093.1,
                    57839.2
                  ],
                  [
                    65190.6,
                    57862.5
                  ],
                  [
                    65268.9,
                    57905.8
                  ],
                  [
                    65333.4,
                    57895.3
                  ],
                  [
                    65450.3,
                    57820
                  ],
                  [
                    65382.7,
                    57697.4
                  ],
                  [
                    65346.7,
                    57646.2
                  ],
                  [
                    65322.8,
                    57533.4
                  ],
                  [
                    65138.9,
                    57461.8
                  ],
                  [
                    64993.5,
                    57351.7
                  ],
                  [
                    64885.4,
                    57172.3
                  ],
                  [
                    64285.6,
                    57384.1
                  ],
                  [
                    64123.8,
                    57502.3
                  ],
                  [
                    63834.9,
                    57600.1
                  ],
                  [
                    63473.1,
                    57555.9
                  ],
                  [
                    63390.7,
                    57768
                  ]
                ],
                "id": 1666,
                "chat_link": "[&BIIGAAA=]"
              },
              "1667": {
                "name": "Wurmhaven",
                "level": 80,
                "coord": [
                  65666.7,
                  59255.6
                ],
                "bounds": [
                  [
                    66045.9,
                    59259
                  ],
                  [
                    66043.7,
                    59594.3
                  ],
                  [
                    65181.7,
                    59596.3
                  ],
                  [
                    65121.3,
                    59104
                  ],
                  [
                    65394.5,
                    59189.7
                  ],
                  [
                    65842.4,
                    58926.5
                  ],
                  [
                    66037.3,
                    59119.7
                  ],
                  [
                    66045.9,
                    59259
                  ]
                ],
                "id": 1667,
                "chat_link": "[&BIMGAAA=]"
              },
              "1668": {
                "name": "Sun's Refuge",
                "level": 80,
                "coord": [
                  63923.8,
                  58990.5
                ],
                "bounds": [
                  [
                    63617.3,
                    58516.5
                  ],
                  [
                    63694.1,
                    58559.8
                  ],
                  [
                    63748.5,
                    58664
                  ],
                  [
                    64454,
                    58758.5
                  ],
                  [
                    64406.9,
                    58871.4
                  ],
                  [
                    64378.6,
                    59035.8
                  ],
                  [
                    64423.8,
                    59631
                  ],
                  [
                    63879.7,
                    59583.4
                  ],
                  [
                    63604.8,
                    59266.7
                  ],
                  [
                    63510.1,
                    59112.6
                  ],
                  [
                    63444.4,
                    58895.8
                  ],
                  [
                    63617.3,
                    58516.5
                  ]
                ],
                "id": 1668,
                "chat_link": "[&BIQGAAA=]"
              },
              "1671": {
                "name": "Displaced Towers",
                "level": 80,
                "coord": [
                  65639.2,
                  57807.6
                ],
                "bounds": [
                  [
                    65380.2,
                    57695.9
                  ],
                  [
                    65596.6,
                    57647.9
                  ],
                  [
                    65688.5,
                    57654.5
                  ],
                  [
                    65760.6,
                    57689.1
                  ],
                  [
                    65801.4,
                    57779.7
                  ],
                  [
                    65784,
                    57863.3
                  ],
                  [
                    65708.2,
                    57972.5
                  ],
                  [
                    65640.1,
                    57986.9
                  ],
                  [
                    65584.1,
                    57965.3
                  ],
                  [
                    65448,
                    57821.3
                  ],
                  [
                    65380.2,
                    57695.9
                  ]
                ],
                "id": 1671,
                "chat_link": "[&BIcGAAA=]"
              },
              "1672": {
                "name": "Rilohn River",
                "level": 80,
                "coord": [
                  67085.7,
                  56872.3
                ],
                "bounds": [
                  [
                    67386.9,
                    56941.2
                  ],
                  [
                    67370.3,
                    56871.9
                  ],
                  [
                    67344.8,
                    56792.6
                  ],
                  [
                    67371.9,
                    56744.4
                  ],
                  [
                    67390.1,
                    56697.3
                  ],
                  [
                    67391.8,
                    56638.1
                  ],
                  [
                    67378,
                    56590.1
                  ],
                  [
                    67323.5,
                    56498
                  ],
                  [
                    67292.5,
                    56454.4
                  ],
                  [
                    67232.6,
                    56440.6
                  ],
                  [
                    67118.6,
                    56480.3
                  ],
                  [
                    66899.4,
                    56681.9
                  ],
                  [
                    66882.3,
                    56911.4
                  ],
                  [
                    66590.9,
                    56885
                  ],
                  [
                    66419.1,
                    56972.1
                  ],
                  [
                    66144.1,
                    56935.3
                  ],
                  [
                    66143.2,
                    57037.2
                  ],
                  [
                    67025.6,
                    57513
                  ],
                  [
                    67118.6,
                    57405.8
                  ],
                  [
                    67146.6,
                    57322.8
                  ],
                  [
                    67275.9,
                    57147.5
                  ],
                  [
                    67345,
                    57084.2
                  ],
                  [
                    67378.3,
                    57017.4
                  ],
                  [
                    67386.9,
                    56941.2
                  ]
                ],
                "id": 1672,
                "chat_link": "[&BIgGAAA=]"
              },
              "1673": {
                "name": "Pact Vanguard",
                "level": 80,
                "coord": [
                  64689.6,
                  59159.7
                ],
                "bounds": [
                  [
                    64987.1,
                    58748.8
                  ],
                  [
                    65144,
                    59110.8
                  ],
                  [
                    65207.8,
                    59607.5
                  ],
                  [
                    64528.8,
                    59613
                  ],
                  [
                    64421.9,
                    59625.3
                  ],
                  [
                    64374.9,
                    59034.4
                  ],
                  [
                    64406.3,
                    58849.5
                  ],
                  [
                    64446,
                    58688.3
                  ],
                  [
                    64987.1,
                    58748.8
                  ]
                ],
                "id": 1673,
                "chat_link": "[&BIkGAAA=]"
              },
              "1674": {
                "name": "Old Command Post",
                "level": 80,
                "coord": [
                  64107,
                  58293.8
                ],
                "bounds": [
                  [
                    63616.9,
                    58517.8
                  ],
                  [
                    63536.5,
                    58042.7
                  ],
                  [
                    63622.4,
                    58039.4
                  ],
                  [
                    64107.9,
                    58047.2
                  ],
                  [
                    64210.6,
                    58078.3
                  ],
                  [
                    64453.1,
                    58056.5
                  ],
                  [
                    64473,
                    58101.6
                  ],
                  [
                    64520,
                    58193.8
                  ],
                  [
                    64517.1,
                    58324.5
                  ],
                  [
                    64438.8,
                    58431.6
                  ],
                  [
                    64453.5,
                    58760.2
                  ],
                  [
                    63747.9,
                    58665.2
                  ],
                  [
                    63693.6,
                    58560.2
                  ],
                  [
                    63616.9,
                    58517.8
                  ]
                ],
                "id": 1674,
                "chat_link": "[&BIoGAAA=]"
              },
              "1675": {
                "name": "Jungle Anomaly",
                "level": 80,
                "coord": [
                  65243.8,
                  57076.6
                ],
                "bounds": [
                  [
                    65576,
                    57306
                  ],
                  [
                    65567.1,
                    56968.6
                  ],
                  [
                    65478,
                    56701.7
                  ],
                  [
                    65380.7,
                    56698.2
                  ],
                  [
                    65278.7,
                    56688.5
                  ],
                  [
                    65136.1,
                    56701.6
                  ],
                  [
                    64994,
                    56717.4
                  ],
                  [
                    64923.2,
                    56869.1
                  ],
                  [
                    64877.3,
                    57029.9
                  ],
                  [
                    64883.4,
                    57173.8
                  ],
                  [
                    64989.4,
                    57352.1
                  ],
                  [
                    65137.4,
                    57463.8
                  ],
                  [
                    65321.2,
                    57534.1
                  ],
                  [
                    65373.2,
                    57440.5
                  ],
                  [
                    65454.4,
                    57299.4
                  ],
                  [
                    65530.8,
                    57281.5
                  ],
                  [
                    65576,
                    57306
                  ]
                ],
                "id": 1675,
                "chat_link": "[&BIsGAAA=]"
              },
              "1676": {
                "name": "Ruined Procession",
                "level": 80,
                "coord": [
                  63738,
                  57097.9
                ],
                "bounds": [
                  [
                    63414.9,
                    57452.4
                  ],
                  [
                    63356.4,
                    57276
                  ],
                  [
                    63333.4,
                    57069.9
                  ],
                  [
                    63376.1,
                    56929.6
                  ],
                  [
                    63432.2,
                    56789.3
                  ],
                  [
                    63579.9,
                    56688.1
                  ],
                  [
                    63810.6,
                    56583.4
                  ],
                  [
                    64061.5,
                    56507.4
                  ],
                  [
                    63972.4,
                    56783.8
                  ],
                  [
                    63928.2,
                    57063.2
                  ],
                  [
                    64095.5,
                    57256.3
                  ],
                  [
                    64288.2,
                    57390.1
                  ],
                  [
                    64111,
                    57513
                  ],
                  [
                    63836.6,
                    57605.2
                  ],
                  [
                    63472.5,
                    57560.6
                  ],
                  [
                    63414.9,
                    57452.4
                  ]
                ],
                "id": 1676,
                "chat_link": "[&BIwGAAA=]"
              },
              "1677": {
                "name": "Crescent's Prosperity",
                "level": 80,
                "coord": [
                  65813,
                  57135.5
                ],
                "bounds": [
                  [
                    65948.2,
                    56596.8
                  ],
                  [
                    65787.2,
                    56628.6
                  ],
                  [
                    65580.1,
                    56659.4
                  ],
                  [
                    65474.9,
                    56703
                  ],
                  [
                    65561.8,
                    56971.5
                  ],
                  [
                    65572.4,
                    57309.1
                  ],
                  [
                    65615.4,
                    57328.6
                  ],
                  [
                    65735.1,
                    57492.3
                  ],
                  [
                    65726.6,
                    57586.8
                  ],
                  [
                    65683.4,
                    57658.6
                  ],
                  [
                    65753.5,
                    57696.3
                  ],
                  [
                    66061.6,
                    57504.6
                  ],
                  [
                    66103.6,
                    57198.4
                  ],
                  [
                    66147.8,
                    57032.8
                  ],
                  [
                    66149.6,
                    56937.6
                  ],
                  [
                    66106.1,
                    56864.3
                  ],
                  [
                    65948.2,
                    56596.8
                  ]
                ],
                "id": 1677,
                "chat_link": "[&BI0GAAA=]"
              },
              "1678": {
                "name": "Prosperity's Approach",
                "level": 80,
                "coord": [
                  65870.6,
                  57938.9
                ],
                "bounds": [
                  [
                    65754.6,
                    57687.7
                  ],
                  [
                    66067.9,
                    57491.3
                  ],
                  [
                    66147.8,
                    58482.9
                  ],
                  [
                    65834,
                    58295.1
                  ],
                  [
                    65709.3,
                    57971.5
                  ],
                  [
                    65782,
                    57862.9
                  ],
                  [
                    65798.4,
                    57781.1
                  ],
                  [
                    65754.6,
                    57687.7
                  ]
                ],
                "id": 1678,
                "chat_link": "[&BI4GAAA=]"
              },
              "1682": {
                "name": "Fortress of Jahai",
                "level": 80,
                "coord": [
                  66634.6,
                  57809.7
                ],
                "bounds": [
                  [
                    67026,
                    57506.3
                  ],
                  [
                    66820.9,
                    57594.7
                  ],
                  [
                    66696.7,
                    57686.7
                  ],
                  [
                    66665.1,
                    57751.9
                  ],
                  [
                    66687.3,
                    57833.6
                  ],
                  [
                    66769.7,
                    57902.9
                  ],
                  [
                    66855.5,
                    57899.4
                  ],
                  [
                    66916.1,
                    57934.8
                  ],
                  [
                    66952.6,
                    58000.8
                  ],
                  [
                    66927.9,
                    58107.5
                  ],
                  [
                    66923.2,
                    58196.9
                  ],
                  [
                    66470.3,
                    58341.9
                  ],
                  [
                    66139.6,
                    58476.6
                  ],
                  [
                    66058.5,
                    57492.1
                  ],
                  [
                    66099.1,
                    57195.4
                  ],
                  [
                    66144.6,
                    57034.3
                  ],
                  [
                    67026,
                    57506.3
                  ]
                ],
                "id": 1682,
                "chat_link": "[&BJIGAAA=]"
              },
              "1683": {
                "name": "Kodonur Temple",
                "level": 80,
                "coord": [
                  66436.2,
                  59270.3
                ],
                "bounds": [
                  [
                    66993.8,
                    59094.8
                  ],
                  [
                    66645.8,
                    59085.8
                  ],
                  [
                    66349.8,
                    58992
                  ],
                  [
                    66163.6,
                    58978.3
                  ],
                  [
                    66031.3,
                    59110.1
                  ],
                  [
                    66044.1,
                    59270.1
                  ],
                  [
                    66035.9,
                    59593
                  ],
                  [
                    66525,
                    59608.6
                  ],
                  [
                    66725.5,
                    59543.4
                  ],
                  [
                    66847.3,
                    59426.7
                  ],
                  [
                    66993.8,
                    59094.8
                  ]
                ],
                "id": 1683,
                "chat_link": "[&BJMGAAA=]"
              },
              "1684": {
                "name": "Jahai Keep",
                "level": 80,
                "coord": [
                  67003.7,
                  57920.1
                ],
                "bounds": [
                  [
                    67396,
                    57668.7
                  ],
                  [
                    67299.8,
                    57512.2
                  ],
                  [
                    67116,
                    57406.2
                  ],
                  [
                    67025.4,
                    57501.4
                  ],
                  [
                    66818.9,
                    57591.9
                  ],
                  [
                    66693.9,
                    57683.8
                  ],
                  [
                    66660.8,
                    57754.4
                  ],
                  [
                    66682.7,
                    57836.5
                  ],
                  [
                    66768.4,
                    57905.1
                  ],
                  [
                    66852.9,
                    57903.2
                  ],
                  [
                    66912.2,
                    57936.4
                  ],
                  [
                    66950.3,
                    57998.4
                  ],
                  [
                    66924.7,
                    58109.8
                  ],
                  [
                    66926.3,
                    58200.3
                  ],
                  [
                    67045.4,
                    58458.9
                  ],
                  [
                    67242.6,
                    58429.7
                  ],
                  [
                    67363.5,
                    58355.3
                  ],
                  [
                    67387,
                    58310.4
                  ],
                  [
                    67396,
                    57668.7
                  ]
                ],
                "id": 1684,
                "chat_link": "[&BJQGAAA=]"
              },
              "1685": {
                "name": "Central Brand Scar",
                "level": 80,
                "coord": [
                  65013.6,
                  58208.9
                ],
                "bounds": [
                  [
                    65659.4,
                    58586.7
                  ],
                  [
                    65322.7,
                    58541.1
                  ],
                  [
                    65161.8,
                    58566.9
                  ],
                  [
                    65001.1,
                    58618.8
                  ],
                  [
                    64989.3,
                    58753.7
                  ],
                  [
                    64445.4,
                    58691.7
                  ],
                  [
                    64442.1,
                    58509.3
                  ],
                  [
                    64437.2,
                    58429.4
                  ],
                  [
                    64511.8,
                    58327.5
                  ],
                  [
                    64517.8,
                    58194.8
                  ],
                  [
                    64438.7,
                    58050.2
                  ],
                  [
                    64828.3,
                    57812.4
                  ],
                  [
                    64937.5,
                    57856.1
                  ],
                  [
                    65092.8,
                    57837.5
                  ],
                  [
                    65191.4,
                    57862.1
                  ],
                  [
                    65268.9,
                    57903.7
                  ],
                  [
                    65336.1,
                    57891.6
                  ],
                  [
                    65458.8,
                    57810.1
                  ],
                  [
                    65588,
                    57959
                  ],
                  [
                    65643.3,
                    57975.1
                  ],
                  [
                    65659.4,
                    58586.7
                  ]
                ],
                "id": 1685,
                "chat_link": "[&BJUGAAA=]"
              },
              "1687": {
                "name": "Eastern Brand Scar",
                "level": 80,
                "coord": [
                  66143.4,
                  58663.4
                ],
                "bounds": [
                  [
                    65650.2,
                    58576
                  ],
                  [
                    65639.8,
                    57979.2
                  ],
                  [
                    65711.6,
                    57967.1
                  ],
                  [
                    65836.2,
                    58286.4
                  ],
                  [
                    66146.8,
                    58473.7
                  ],
                  [
                    66257.3,
                    58577.6
                  ],
                  [
                    66355.8,
                    58713.5
                  ],
                  [
                    66672.9,
                    58731.8
                  ],
                  [
                    66708,
                    58860.3
                  ],
                  [
                    66643.6,
                    59089.5
                  ],
                  [
                    66350,
                    58996.7
                  ],
                  [
                    66167.3,
                    58982.5
                  ],
                  [
                    66033.3,
                    59120.4
                  ],
                  [
                    65834.1,
                    58933.3
                  ],
                  [
                    65650.2,
                    58576
                  ]
                ],
                "id": 1687,
                "chat_link": "[&BJcGAAA=]"
              },
              "1688": {
                "name": "Reclaimed Chantry",
                "level": 80,
                "coord": [
                  66498.8,
                  56660.1
                ],
                "bounds": [
                  [
                    66146.6,
                    56938.8
                  ],
                  [
                    66105.2,
                    56863.8
                  ],
                  [
                    65947.3,
                    56596.8
                  ],
                  [
                    66086.1,
                    56545
                  ],
                  [
                    66221.5,
                    56427.9
                  ],
                  [
                    66397.2,
                    56400.3
                  ],
                  [
                    66657.8,
                    56401
                  ],
                  [
                    66710.9,
                    56474.4
                  ],
                  [
                    66780.3,
                    56533.7
                  ],
                  [
                    66796.8,
                    56614.3
                  ],
                  [
                    66828,
                    56657.5
                  ],
                  [
                    66907.8,
                    56666.2
                  ],
                  [
                    66884.4,
                    56917.3
                  ],
                  [
                    66592.1,
                    56890.4
                  ],
                  [
                    66419.5,
                    56974
                  ],
                  [
                    66146.6,
                    56938.8
                  ]
                ],
                "id": 1688,
                "chat_link": "[&BJgGAAA=]"
              },
              "1689": {
                "name": "Yatendi Village",
                "level": 80,
                "coord": [
                  66590.8,
                  58512.6
                ],
                "bounds": [
                  [
                    66142.4,
                    58467.4
                  ],
                  [
                    66252.1,
                    58577.4
                  ],
                  [
                    66355.6,
                    58712.3
                  ],
                  [
                    66677.3,
                    58736.3
                  ],
                  [
                    66862.8,
                    58626.8
                  ],
                  [
                    67047.5,
                    58457.4
                  ],
                  [
                    66925.1,
                    58182.8
                  ],
                  [
                    66463.7,
                    58340.4
                  ],
                  [
                    66142.4,
                    58467.4
                  ]
                ],
                "id": 1689,
                "chat_link": "[&BJkGAAA=]"
              },
              "1690": {
                "name": "Almorra's Stand",
                "level": 80,
                "coord": [
                  64494.3,
                  56785.4
                ],
                "bounds": [
                  [
                    64269.9,
                    57399.6
                  ],
                  [
                    64090.8,
                    57259.9
                  ],
                  [
                    63921.8,
                    57065.4
                  ],
                  [
                    63968.7,
                    56779.1
                  ],
                  [
                    64056.2,
                    56509
                  ],
                  [
                    64228.3,
                    56400.4
                  ],
                  [
                    64449.3,
                    56383
                  ],
                  [
                    64637.2,
                    56392.6
                  ],
                  [
                    64746.6,
                    56436.8
                  ],
                  [
                    64865.3,
                    56576.8
                  ],
                  [
                    64995.2,
                    56717.4
                  ],
                  [
                    64924.8,
                    56872.1
                  ],
                  [
                    64881,
                    57029.7
                  ],
                  [
                    64885.3,
                    57173.3
                  ],
                  [
                    64269.9,
                    57399.6
                  ]
                ],
                "id": 1690,
                "chat_link": "[&BJoGAAA=]"
              },
              "1691": {
                "name": "Shattered Cliffs",
                "level": 80,
                "coord": [
                  67027.4,
                  58762.7
                ],
                "bounds": [
                  [
                    66669.1,
                    58732.3
                  ],
                  [
                    66698.4,
                    58866.1
                  ],
                  [
                    66642.8,
                    59092
                  ],
                  [
                    66981.5,
                    59108.1
                  ],
                  [
                    67184.2,
                    59024.6
                  ],
                  [
                    67284.7,
                    58874.1
                  ],
                  [
                    67347.3,
                    58678.2
                  ],
                  [
                    67347.2,
                    58510.3
                  ],
                  [
                    67243,
                    58429.2
                  ],
                  [
                    67043.8,
                    58451.4
                  ],
                  [
                    66858.9,
                    58623
                  ],
                  [
                    66669.1,
                    58732.3
                  ]
                ],
                "id": 1691,
                "chat_link": "[&BJsGAAA=]"
              }
            },
            "adventures": [],
            "id": 1294,
            "mastery_points": []
          },
          "1295": {
            "name": "Legacy",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -49152,
                -36864
              ],
              [
                49152,
                39936
              ]
            ],
            "continent_rect": [
              [
                63316,
                56376
              ],
              [
                67412,
                59576
              ]
            ],
            "points_of_interest": {
              "2923": {
                "name": "Gaze of the Ancients",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66589.4,
                  56648.3
                ],
                "id": 2923,
                "chat_link": "[&BGsLAAA=]"
              },
              "2925": {
                "name": "Displaced Vizier's Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65626.8,
                  57826.3
                ],
                "id": 2925,
                "chat_link": "[&BG0LAAA=]"
              },
              "2928": {
                "name": "Staging Platform",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64336.2,
                  57153.9
                ],
                "id": 2928,
                "chat_link": "[&BHALAAA=]"
              },
              "2929": {
                "name": "Jahai Great Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66384.5,
                  57739.9
                ],
                "id": 2929,
                "chat_link": "[&BHELAAA=]"
              },
              "2931": {
                "name": "Ring of Judgment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66275.6,
                  57741.4
                ],
                "id": 2931,
                "chat_link": "[&BHMLAAA=]"
              },
              "2932": {
                "name": "Claw Den",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67110.8,
                  58523.5
                ],
                "id": 2932,
                "chat_link": "[&BHQLAAA=]"
              },
              "2934": {
                "name": "Riyid's Post",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67272.3,
                  56921.1
                ],
                "id": 2934,
                "chat_link": "[&BHYLAAA=]"
              },
              "2936": {
                "name": "Fortress Courtyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67150,
                  58147.1
                ],
                "id": 2936,
                "chat_link": "[&BHgLAAA=]"
              },
              "2937": {
                "name": "Sleepless Beacon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66059,
                  57882.9
                ],
                "id": 2937,
                "chat_link": "[&BHkLAAA=]"
              },
              "2938": {
                "name": "Ancestor Tree",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63760.5,
                  57103.2
                ],
                "id": 2938,
                "chat_link": "[&BHoLAAA=]"
              },
              "2940": {
                "name": "Battleground Ramparts",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64246.2,
                  56871.9
                ],
                "id": 2940,
                "chat_link": "[&BHwLAAA=]"
              },
              "2943": {
                "name": "Garrison Relay Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65475.9,
                  58660.9
                ],
                "id": 2943,
                "chat_link": "[&BH8LAAA=]"
              },
              "2944": {
                "name": "Noble's Walk",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66362.1,
                  58173
                ],
                "id": 2944,
                "chat_link": "[&BIALAAA=]"
              },
              "2946": {
                "name": "Wurmmarshal's Encampment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65581.8,
                  59151.9
                ],
                "id": 2946,
                "chat_link": "[&BIILAAA=]"
              },
              "2952": {
                "name": "Rilohn Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66545.6,
                  58255.8
                ],
                "id": 2952,
                "chat_link": "[&BIgLAAA=]"
              },
              "2953": {
                "name": "Confluence of the Elements",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66618.3,
                  59352.7
                ],
                "id": 2953,
                "chat_link": "[&BIkLAAA=]"
              },
              "2954": {
                "name": "Archon's Retreat",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66285.6,
                  57337
                ],
                "id": 2954,
                "chat_link": "[&BIoLAAA=]"
              },
              "2955": {
                "name": "Garrison Command",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65519,
                  58839
                ],
                "id": 2955,
                "chat_link": "[&BIsLAAA=]"
              },
              "2956": {
                "name": "Garrison Access Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65175.2,
                  58877.7
                ],
                "id": 2956,
                "chat_link": "[&BIwLAAA=]"
              },
              "2957": {
                "name": "Vanguard Ordinance",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64771.3,
                  59207.4
                ],
                "id": 2957,
                "chat_link": "[&BI0LAAA=]"
              },
              "2958": {
                "name": "Kormir's Reverence",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66364.8,
                  56702.1
                ],
                "id": 2958,
                "chat_link": "[&BI4LAAA=]"
              },
              "2959": {
                "name": "Mirza's Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63831.6,
                  57753.7
                ],
                "id": 2959,
                "chat_link": "[&BI8LAAA=]"
              },
              "2960": {
                "name": "Vanguard Salvage Yard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64677.9,
                  58947.8
                ],
                "id": 2960,
                "chat_link": "[&BJALAAA=]"
              },
              "2961": {
                "name": "Monument to the Return of Palawa Joko",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65476.6,
                  58044.4
                ],
                "id": 2961,
                "chat_link": "[&BJELAAA=]"
              },
              "2962": {
                "name": "Yatendi Farm",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66503.7,
                  58746.6
                ],
                "id": 2962,
                "chat_link": "[&BJILAAA=]"
              },
              "2964": {
                "name": "Crystal Cavern",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64884.1,
                  57923.3
                ],
                "id": 2964,
                "chat_link": "[&BJQLAAA=]"
              },
              "2967": {
                "name": "Wyvern Roost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65352.5,
                  57030.1
                ],
                "id": 2967,
                "chat_link": "[&BJcLAAA=]"
              },
              "2968": {
                "name": "Crescent's Town Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65870.9,
                  56800.9
                ],
                "id": 2968,
                "chat_link": "[&BJgLAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1664": {
                "name": "???",
                "level": 80,
                "coord": [
                  65536.9,
                  57501.1
                ],
                "bounds": [
                  [
                    65372.1,
                    57439.1
                  ],
                  [
                    65451.9,
                    57300.2
                  ],
                  [
                    65530.3,
                    57279.2
                  ],
                  [
                    65616.5,
                    57323.8
                  ],
                  [
                    65670.7,
                    57402.3
                  ],
                  [
                    65741,
                    57487.7
                  ],
                  [
                    65731.6,
                    57588
                  ],
                  [
                    65687.8,
                    57659.2
                  ],
                  [
                    65593.6,
                    57654.8
                  ],
                  [
                    65381.5,
                    57699.3
                  ],
                  [
                    65345,
                    57646.1
                  ],
                  [
                    65321.2,
                    57534
                  ],
                  [
                    65372.1,
                    57439.1
                  ]
                ],
                "id": 1664,
                "chat_link": "[&BIAGAAA=]"
              },
              "1665": {
                "name": "Argon Garrison",
                "level": 80,
                "coord": [
                  65312.8,
                  58785.8
                ],
                "bounds": [
                  [
                    64995,
                    58614
                  ],
                  [
                    65158.2,
                    58562.6
                  ],
                  [
                    65321.9,
                    58536.1
                  ],
                  [
                    65662.8,
                    58577.9
                  ],
                  [
                    65841.1,
                    58935.7
                  ],
                  [
                    65399.7,
                    59197.6
                  ],
                  [
                    65139.8,
                    59114.6
                  ],
                  [
                    64983.8,
                    58748.1
                  ],
                  [
                    64995,
                    58614
                  ]
                ],
                "id": 1665,
                "chat_link": "[&BIEGAAA=]"
              },
              "1666": {
                "name": "Venta Pass",
                "level": 80,
                "coord": [
                  64498.7,
                  57764.6
                ],
                "bounds": [
                  [
                    63390.7,
                    57768
                  ],
                  [
                    63375.4,
                    57870.3
                  ],
                  [
                    63396.3,
                    58007.2
                  ],
                  [
                    63537,
                    58044
                  ],
                  [
                    63622.8,
                    58041.1
                  ],
                  [
                    63987.8,
                    58042.8
                  ],
                  [
                    64103.8,
                    58053.8
                  ],
                  [
                    64210.8,
                    58083.4
                  ],
                  [
                    64446.5,
                    58069.9
                  ],
                  [
                    64832.7,
                    57812.7
                  ],
                  [
                    64938.3,
                    57857.7
                  ],
                  [
                    65093.1,
                    57839.2
                  ],
                  [
                    65190.6,
                    57862.5
                  ],
                  [
                    65268.9,
                    57905.8
                  ],
                  [
                    65333.4,
                    57895.3
                  ],
                  [
                    65450.3,
                    57820
                  ],
                  [
                    65382.7,
                    57697.4
                  ],
                  [
                    65346.7,
                    57646.2
                  ],
                  [
                    65322.8,
                    57533.4
                  ],
                  [
                    65138.9,
                    57461.8
                  ],
                  [
                    64993.5,
                    57351.7
                  ],
                  [
                    64885.4,
                    57172.3
                  ],
                  [
                    64285.6,
                    57384.1
                  ],
                  [
                    64123.8,
                    57502.3
                  ],
                  [
                    63834.9,
                    57600.1
                  ],
                  [
                    63473.1,
                    57555.9
                  ],
                  [
                    63390.7,
                    57768
                  ]
                ],
                "id": 1666,
                "chat_link": "[&BIIGAAA=]"
              },
              "1667": {
                "name": "Wurmhaven",
                "level": 80,
                "coord": [
                  65666.7,
                  59255.6
                ],
                "bounds": [
                  [
                    66045.9,
                    59259
                  ],
                  [
                    66043.7,
                    59594.3
                  ],
                  [
                    65181.7,
                    59596.3
                  ],
                  [
                    65121.3,
                    59104
                  ],
                  [
                    65394.5,
                    59189.7
                  ],
                  [
                    65842.4,
                    58926.5
                  ],
                  [
                    66037.3,
                    59119.7
                  ],
                  [
                    66045.9,
                    59259
                  ]
                ],
                "id": 1667,
                "chat_link": "[&BIMGAAA=]"
              },
              "1668": {
                "name": "Sun's Refuge",
                "level": 80,
                "coord": [
                  63923.8,
                  58990.5
                ],
                "bounds": [
                  [
                    63617.3,
                    58516.5
                  ],
                  [
                    63694.1,
                    58559.8
                  ],
                  [
                    63748.5,
                    58664
                  ],
                  [
                    64454,
                    58758.5
                  ],
                  [
                    64406.9,
                    58871.4
                  ],
                  [
                    64378.6,
                    59035.8
                  ],
                  [
                    64423.8,
                    59631
                  ],
                  [
                    63879.7,
                    59583.4
                  ],
                  [
                    63604.8,
                    59266.7
                  ],
                  [
                    63510.1,
                    59112.6
                  ],
                  [
                    63444.4,
                    58895.8
                  ],
                  [
                    63617.3,
                    58516.5
                  ]
                ],
                "id": 1668,
                "chat_link": "[&BIQGAAA=]"
              },
              "1671": {
                "name": "Displaced Towers",
                "level": 80,
                "coord": [
                  65639.2,
                  57807.6
                ],
                "bounds": [
                  [
                    65380.2,
                    57695.9
                  ],
                  [
                    65596.6,
                    57647.9
                  ],
                  [
                    65688.5,
                    57654.5
                  ],
                  [
                    65760.6,
                    57689.1
                  ],
                  [
                    65801.4,
                    57779.7
                  ],
                  [
                    65784,
                    57863.3
                  ],
                  [
                    65708.2,
                    57972.5
                  ],
                  [
                    65640.1,
                    57986.9
                  ],
                  [
                    65584.1,
                    57965.3
                  ],
                  [
                    65448,
                    57821.3
                  ],
                  [
                    65380.2,
                    57695.9
                  ]
                ],
                "id": 1671,
                "chat_link": "[&BIcGAAA=]"
              },
              "1672": {
                "name": "Rilohn River",
                "level": 80,
                "coord": [
                  67085.7,
                  56872.3
                ],
                "bounds": [
                  [
                    67386.9,
                    56941.2
                  ],
                  [
                    67370.3,
                    56871.9
                  ],
                  [
                    67344.8,
                    56792.6
                  ],
                  [
                    67371.9,
                    56744.4
                  ],
                  [
                    67390.1,
                    56697.3
                  ],
                  [
                    67391.8,
                    56638.1
                  ],
                  [
                    67378,
                    56590.1
                  ],
                  [
                    67323.5,
                    56498
                  ],
                  [
                    67292.5,
                    56454.4
                  ],
                  [
                    67232.6,
                    56440.6
                  ],
                  [
                    67118.6,
                    56480.3
                  ],
                  [
                    66899.4,
                    56681.9
                  ],
                  [
                    66882.3,
                    56911.4
                  ],
                  [
                    66590.9,
                    56885
                  ],
                  [
                    66419.1,
                    56972.1
                  ],
                  [
                    66144.1,
                    56935.3
                  ],
                  [
                    66143.2,
                    57037.2
                  ],
                  [
                    67025.6,
                    57513
                  ],
                  [
                    67118.6,
                    57405.8
                  ],
                  [
                    67146.6,
                    57322.8
                  ],
                  [
                    67275.9,
                    57147.5
                  ],
                  [
                    67345,
                    57084.2
                  ],
                  [
                    67378.3,
                    57017.4
                  ],
                  [
                    67386.9,
                    56941.2
                  ]
                ],
                "id": 1672,
                "chat_link": "[&BIgGAAA=]"
              },
              "1673": {
                "name": "Pact Vanguard",
                "level": 80,
                "coord": [
                  64689.6,
                  59159.7
                ],
                "bounds": [
                  [
                    64987.1,
                    58748.8
                  ],
                  [
                    65144,
                    59110.8
                  ],
                  [
                    65207.8,
                    59607.5
                  ],
                  [
                    64528.8,
                    59613
                  ],
                  [
                    64421.9,
                    59625.3
                  ],
                  [
                    64374.9,
                    59034.4
                  ],
                  [
                    64406.3,
                    58849.5
                  ],
                  [
                    64446,
                    58688.3
                  ],
                  [
                    64987.1,
                    58748.8
                  ]
                ],
                "id": 1673,
                "chat_link": "[&BIkGAAA=]"
              },
              "1674": {
                "name": "Old Command Post",
                "level": 80,
                "coord": [
                  64107,
                  58293.8
                ],
                "bounds": [
                  [
                    63616.9,
                    58517.8
                  ],
                  [
                    63536.5,
                    58042.7
                  ],
                  [
                    63622.4,
                    58039.4
                  ],
                  [
                    64107.9,
                    58047.2
                  ],
                  [
                    64210.6,
                    58078.3
                  ],
                  [
                    64453.1,
                    58056.5
                  ],
                  [
                    64473,
                    58101.6
                  ],
                  [
                    64520,
                    58193.8
                  ],
                  [
                    64517.1,
                    58324.5
                  ],
                  [
                    64438.8,
                    58431.6
                  ],
                  [
                    64453.5,
                    58760.2
                  ],
                  [
                    63747.9,
                    58665.2
                  ],
                  [
                    63693.6,
                    58560.2
                  ],
                  [
                    63616.9,
                    58517.8
                  ]
                ],
                "id": 1674,
                "chat_link": "[&BIoGAAA=]"
              },
              "1675": {
                "name": "Jungle Anomaly",
                "level": 80,
                "coord": [
                  65243.8,
                  57076.6
                ],
                "bounds": [
                  [
                    65576,
                    57306
                  ],
                  [
                    65567.1,
                    56968.6
                  ],
                  [
                    65478,
                    56701.7
                  ],
                  [
                    65380.7,
                    56698.2
                  ],
                  [
                    65278.7,
                    56688.5
                  ],
                  [
                    65136.1,
                    56701.6
                  ],
                  [
                    64994,
                    56717.4
                  ],
                  [
                    64923.2,
                    56869.1
                  ],
                  [
                    64877.3,
                    57029.9
                  ],
                  [
                    64883.4,
                    57173.8
                  ],
                  [
                    64989.4,
                    57352.1
                  ],
                  [
                    65137.4,
                    57463.8
                  ],
                  [
                    65321.2,
                    57534.1
                  ],
                  [
                    65373.2,
                    57440.5
                  ],
                  [
                    65454.4,
                    57299.4
                  ],
                  [
                    65530.8,
                    57281.5
                  ],
                  [
                    65576,
                    57306
                  ]
                ],
                "id": 1675,
                "chat_link": "[&BIsGAAA=]"
              },
              "1676": {
                "name": "Ruined Procession",
                "level": 80,
                "coord": [
                  63738,
                  57097.9
                ],
                "bounds": [
                  [
                    63414.9,
                    57452.4
                  ],
                  [
                    63356.4,
                    57276
                  ],
                  [
                    63333.4,
                    57069.9
                  ],
                  [
                    63376.1,
                    56929.6
                  ],
                  [
                    63432.2,
                    56789.3
                  ],
                  [
                    63579.9,
                    56688.1
                  ],
                  [
                    63810.6,
                    56583.4
                  ],
                  [
                    64061.5,
                    56507.4
                  ],
                  [
                    63972.4,
                    56783.8
                  ],
                  [
                    63928.2,
                    57063.2
                  ],
                  [
                    64095.5,
                    57256.3
                  ],
                  [
                    64288.2,
                    57390.1
                  ],
                  [
                    64111,
                    57513
                  ],
                  [
                    63836.6,
                    57605.2
                  ],
                  [
                    63472.5,
                    57560.6
                  ],
                  [
                    63414.9,
                    57452.4
                  ]
                ],
                "id": 1676,
                "chat_link": "[&BIwGAAA=]"
              },
              "1677": {
                "name": "Crescent's Prosperity",
                "level": 80,
                "coord": [
                  65813,
                  57135.5
                ],
                "bounds": [
                  [
                    65948.2,
                    56596.8
                  ],
                  [
                    65787.2,
                    56628.6
                  ],
                  [
                    65580.1,
                    56659.4
                  ],
                  [
                    65474.9,
                    56703
                  ],
                  [
                    65561.8,
                    56971.5
                  ],
                  [
                    65572.4,
                    57309.1
                  ],
                  [
                    65615.4,
                    57328.6
                  ],
                  [
                    65735.1,
                    57492.3
                  ],
                  [
                    65726.6,
                    57586.8
                  ],
                  [
                    65683.4,
                    57658.6
                  ],
                  [
                    65753.5,
                    57696.3
                  ],
                  [
                    66061.6,
                    57504.6
                  ],
                  [
                    66103.6,
                    57198.4
                  ],
                  [
                    66147.8,
                    57032.8
                  ],
                  [
                    66149.6,
                    56937.6
                  ],
                  [
                    66106.1,
                    56864.3
                  ],
                  [
                    65948.2,
                    56596.8
                  ]
                ],
                "id": 1677,
                "chat_link": "[&BI0GAAA=]"
              },
              "1678": {
                "name": "Prosperity's Approach",
                "level": 80,
                "coord": [
                  65870.6,
                  57938.9
                ],
                "bounds": [
                  [
                    65754.6,
                    57687.7
                  ],
                  [
                    66067.9,
                    57491.3
                  ],
                  [
                    66147.8,
                    58482.9
                  ],
                  [
                    65834,
                    58295.1
                  ],
                  [
                    65709.3,
                    57971.5
                  ],
                  [
                    65782,
                    57862.9
                  ],
                  [
                    65798.4,
                    57781.1
                  ],
                  [
                    65754.6,
                    57687.7
                  ]
                ],
                "id": 1678,
                "chat_link": "[&BI4GAAA=]"
              },
              "1682": {
                "name": "Fortress of Jahai",
                "level": 80,
                "coord": [
                  66634.6,
                  57809.7
                ],
                "bounds": [
                  [
                    67026,
                    57506.3
                  ],
                  [
                    66820.9,
                    57594.7
                  ],
                  [
                    66696.7,
                    57686.7
                  ],
                  [
                    66665.1,
                    57751.9
                  ],
                  [
                    66687.3,
                    57833.6
                  ],
                  [
                    66769.7,
                    57902.9
                  ],
                  [
                    66855.5,
                    57899.4
                  ],
                  [
                    66916.1,
                    57934.8
                  ],
                  [
                    66952.6,
                    58000.8
                  ],
                  [
                    66927.9,
                    58107.5
                  ],
                  [
                    66923.2,
                    58196.9
                  ],
                  [
                    66470.3,
                    58341.9
                  ],
                  [
                    66139.6,
                    58476.6
                  ],
                  [
                    66058.5,
                    57492.1
                  ],
                  [
                    66099.1,
                    57195.4
                  ],
                  [
                    66144.6,
                    57034.3
                  ],
                  [
                    67026,
                    57506.3
                  ]
                ],
                "id": 1682,
                "chat_link": "[&BJIGAAA=]"
              },
              "1683": {
                "name": "Kodonur Temple",
                "level": 80,
                "coord": [
                  66436.2,
                  59270.3
                ],
                "bounds": [
                  [
                    66993.8,
                    59094.8
                  ],
                  [
                    66645.8,
                    59085.8
                  ],
                  [
                    66349.8,
                    58992
                  ],
                  [
                    66163.6,
                    58978.3
                  ],
                  [
                    66031.3,
                    59110.1
                  ],
                  [
                    66044.1,
                    59270.1
                  ],
                  [
                    66035.9,
                    59593
                  ],
                  [
                    66525,
                    59608.6
                  ],
                  [
                    66725.5,
                    59543.4
                  ],
                  [
                    66847.3,
                    59426.7
                  ],
                  [
                    66993.8,
                    59094.8
                  ]
                ],
                "id": 1683,
                "chat_link": "[&BJMGAAA=]"
              },
              "1684": {
                "name": "Jahai Keep",
                "level": 80,
                "coord": [
                  67003.7,
                  57920.1
                ],
                "bounds": [
                  [
                    67396,
                    57668.7
                  ],
                  [
                    67299.8,
                    57512.2
                  ],
                  [
                    67116,
                    57406.2
                  ],
                  [
                    67025.4,
                    57501.4
                  ],
                  [
                    66818.9,
                    57591.9
                  ],
                  [
                    66693.9,
                    57683.8
                  ],
                  [
                    66660.8,
                    57754.4
                  ],
                  [
                    66682.7,
                    57836.5
                  ],
                  [
                    66768.4,
                    57905.1
                  ],
                  [
                    66852.9,
                    57903.2
                  ],
                  [
                    66912.2,
                    57936.4
                  ],
                  [
                    66950.3,
                    57998.4
                  ],
                  [
                    66924.7,
                    58109.8
                  ],
                  [
                    66926.3,
                    58200.3
                  ],
                  [
                    67045.4,
                    58458.9
                  ],
                  [
                    67242.6,
                    58429.7
                  ],
                  [
                    67363.5,
                    58355.3
                  ],
                  [
                    67387,
                    58310.4
                  ],
                  [
                    67396,
                    57668.7
                  ]
                ],
                "id": 1684,
                "chat_link": "[&BJQGAAA=]"
              },
              "1685": {
                "name": "Central Brand Scar",
                "level": 80,
                "coord": [
                  65013.6,
                  58208.9
                ],
                "bounds": [
                  [
                    65659.4,
                    58586.7
                  ],
                  [
                    65322.7,
                    58541.1
                  ],
                  [
                    65161.8,
                    58566.9
                  ],
                  [
                    65001.1,
                    58618.8
                  ],
                  [
                    64989.3,
                    58753.7
                  ],
                  [
                    64445.4,
                    58691.7
                  ],
                  [
                    64442.1,
                    58509.3
                  ],
                  [
                    64437.2,
                    58429.4
                  ],
                  [
                    64511.8,
                    58327.5
                  ],
                  [
                    64517.8,
                    58194.8
                  ],
                  [
                    64438.7,
                    58050.2
                  ],
                  [
                    64828.3,
                    57812.4
                  ],
                  [
                    64937.5,
                    57856.1
                  ],
                  [
                    65092.8,
                    57837.5
                  ],
                  [
                    65191.4,
                    57862.1
                  ],
                  [
                    65268.9,
                    57903.7
                  ],
                  [
                    65336.1,
                    57891.6
                  ],
                  [
                    65458.8,
                    57810.1
                  ],
                  [
                    65588,
                    57959
                  ],
                  [
                    65643.3,
                    57975.1
                  ],
                  [
                    65659.4,
                    58586.7
                  ]
                ],
                "id": 1685,
                "chat_link": "[&BJUGAAA=]"
              },
              "1687": {
                "name": "Eastern Brand Scar",
                "level": 80,
                "coord": [
                  66143.4,
                  58663.4
                ],
                "bounds": [
                  [
                    65650.2,
                    58576
                  ],
                  [
                    65639.8,
                    57979.2
                  ],
                  [
                    65711.6,
                    57967.1
                  ],
                  [
                    65836.2,
                    58286.4
                  ],
                  [
                    66146.8,
                    58473.7
                  ],
                  [
                    66257.3,
                    58577.6
                  ],
                  [
                    66355.8,
                    58713.5
                  ],
                  [
                    66672.9,
                    58731.8
                  ],
                  [
                    66708,
                    58860.3
                  ],
                  [
                    66643.6,
                    59089.5
                  ],
                  [
                    66350,
                    58996.7
                  ],
                  [
                    66167.3,
                    58982.5
                  ],
                  [
                    66033.3,
                    59120.4
                  ],
                  [
                    65834.1,
                    58933.3
                  ],
                  [
                    65650.2,
                    58576
                  ]
                ],
                "id": 1687,
                "chat_link": "[&BJcGAAA=]"
              },
              "1688": {
                "name": "Reclaimed Chantry",
                "level": 80,
                "coord": [
                  66498.8,
                  56660.1
                ],
                "bounds": [
                  [
                    66146.6,
                    56938.8
                  ],
                  [
                    66105.2,
                    56863.8
                  ],
                  [
                    65947.3,
                    56596.8
                  ],
                  [
                    66086.1,
                    56545
                  ],
                  [
                    66221.5,
                    56427.9
                  ],
                  [
                    66397.2,
                    56400.3
                  ],
                  [
                    66657.8,
                    56401
                  ],
                  [
                    66710.9,
                    56474.4
                  ],
                  [
                    66780.3,
                    56533.7
                  ],
                  [
                    66796.8,
                    56614.3
                  ],
                  [
                    66828,
                    56657.5
                  ],
                  [
                    66907.8,
                    56666.2
                  ],
                  [
                    66884.4,
                    56917.3
                  ],
                  [
                    66592.1,
                    56890.4
                  ],
                  [
                    66419.5,
                    56974
                  ],
                  [
                    66146.6,
                    56938.8
                  ]
                ],
                "id": 1688,
                "chat_link": "[&BJgGAAA=]"
              },
              "1689": {
                "name": "Yatendi Village",
                "level": 80,
                "coord": [
                  66590.8,
                  58512.6
                ],
                "bounds": [
                  [
                    66142.4,
                    58467.4
                  ],
                  [
                    66252.1,
                    58577.4
                  ],
                  [
                    66355.6,
                    58712.3
                  ],
                  [
                    66677.3,
                    58736.3
                  ],
                  [
                    66862.8,
                    58626.8
                  ],
                  [
                    67047.5,
                    58457.4
                  ],
                  [
                    66925.1,
                    58182.8
                  ],
                  [
                    66463.7,
                    58340.4
                  ],
                  [
                    66142.4,
                    58467.4
                  ]
                ],
                "id": 1689,
                "chat_link": "[&BJkGAAA=]"
              },
              "1690": {
                "name": "Almorra's Stand",
                "level": 80,
                "coord": [
                  64494.3,
                  56785.4
                ],
                "bounds": [
                  [
                    64269.9,
                    57399.6
                  ],
                  [
                    64090.8,
                    57259.9
                  ],
                  [
                    63921.8,
                    57065.4
                  ],
                  [
                    63968.7,
                    56779.1
                  ],
                  [
                    64056.2,
                    56509
                  ],
                  [
                    64228.3,
                    56400.4
                  ],
                  [
                    64449.3,
                    56383
                  ],
                  [
                    64637.2,
                    56392.6
                  ],
                  [
                    64746.6,
                    56436.8
                  ],
                  [
                    64865.3,
                    56576.8
                  ],
                  [
                    64995.2,
                    56717.4
                  ],
                  [
                    64924.8,
                    56872.1
                  ],
                  [
                    64881,
                    57029.7
                  ],
                  [
                    64885.3,
                    57173.3
                  ],
                  [
                    64269.9,
                    57399.6
                  ]
                ],
                "id": 1690,
                "chat_link": "[&BJoGAAA=]"
              },
              "1691": {
                "name": "Shattered Cliffs",
                "level": 80,
                "coord": [
                  67027.4,
                  58762.7
                ],
                "bounds": [
                  [
                    66669.1,
                    58732.3
                  ],
                  [
                    66698.4,
                    58866.1
                  ],
                  [
                    66642.8,
                    59092
                  ],
                  [
                    66981.5,
                    59108.1
                  ],
                  [
                    67184.2,
                    59024.6
                  ],
                  [
                    67284.7,
                    58874.1
                  ],
                  [
                    67347.3,
                    58678.2
                  ],
                  [
                    67347.2,
                    58510.3
                  ],
                  [
                    67243,
                    58429.2
                  ],
                  [
                    67043.8,
                    58451.4
                  ],
                  [
                    66858.9,
                    58623
                  ],
                  [
                    66669.1,
                    58732.3
                  ]
                ],
                "id": 1691,
                "chat_link": "[&BJsGAAA=]"
              }
            },
            "adventures": [],
            "id": 1295,
            "mastery_points": []
          },
          "1297": {
            "name": "A Shattered Nation",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -49152,
                -36864
              ],
              [
                49152,
                39936
              ]
            ],
            "continent_rect": [
              [
                63316,
                56376
              ],
              [
                67412,
                59576
              ]
            ],
            "points_of_interest": {
              "2923": {
                "name": "Gaze of the Ancients",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66589.4,
                  56648.3
                ],
                "id": 2923,
                "chat_link": "[&BGsLAAA=]"
              },
              "2929": {
                "name": "Jahai Great Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66384.5,
                  57739.9
                ],
                "id": 2929,
                "chat_link": "[&BHELAAA=]"
              },
              "2936": {
                "name": "Fortress Courtyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67150,
                  58147.1
                ],
                "id": 2936,
                "chat_link": "[&BHgLAAA=]"
              },
              "2954": {
                "name": "Archon's Retreat",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66285.6,
                  57337
                ],
                "id": 2954,
                "chat_link": "[&BIoLAAA=]"
              },
              "2958": {
                "name": "Kormir's Reverence",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66364.8,
                  56702.1
                ],
                "id": 2958,
                "chat_link": "[&BI4LAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1672": {
                "name": "Rilohn River",
                "level": 80,
                "coord": [
                  67085.7,
                  56872.3
                ],
                "bounds": [
                  [
                    67386.9,
                    56941.2
                  ],
                  [
                    67370.3,
                    56871.9
                  ],
                  [
                    67344.8,
                    56792.6
                  ],
                  [
                    67371.9,
                    56744.4
                  ],
                  [
                    67390.1,
                    56697.3
                  ],
                  [
                    67391.8,
                    56638.1
                  ],
                  [
                    67378,
                    56590.1
                  ],
                  [
                    67323.5,
                    56498
                  ],
                  [
                    67292.5,
                    56454.4
                  ],
                  [
                    67232.6,
                    56440.6
                  ],
                  [
                    67118.6,
                    56480.3
                  ],
                  [
                    66899.4,
                    56681.9
                  ],
                  [
                    66882.3,
                    56911.4
                  ],
                  [
                    66590.9,
                    56885
                  ],
                  [
                    66419.1,
                    56972.1
                  ],
                  [
                    66144.1,
                    56935.3
                  ],
                  [
                    66143.2,
                    57037.2
                  ],
                  [
                    67025.6,
                    57513
                  ],
                  [
                    67118.6,
                    57405.8
                  ],
                  [
                    67146.6,
                    57322.8
                  ],
                  [
                    67275.9,
                    57147.5
                  ],
                  [
                    67345,
                    57084.2
                  ],
                  [
                    67378.3,
                    57017.4
                  ],
                  [
                    67386.9,
                    56941.2
                  ]
                ],
                "id": 1672,
                "chat_link": "[&BIgGAAA=]"
              },
              "1682": {
                "name": "Fortress of Jahai",
                "level": 80,
                "coord": [
                  66634.6,
                  57809.7
                ],
                "bounds": [
                  [
                    67026,
                    57506.3
                  ],
                  [
                    66820.9,
                    57594.7
                  ],
                  [
                    66696.7,
                    57686.7
                  ],
                  [
                    66665.1,
                    57751.9
                  ],
                  [
                    66687.3,
                    57833.6
                  ],
                  [
                    66769.7,
                    57902.9
                  ],
                  [
                    66855.5,
                    57899.4
                  ],
                  [
                    66916.1,
                    57934.8
                  ],
                  [
                    66952.6,
                    58000.8
                  ],
                  [
                    66927.9,
                    58107.5
                  ],
                  [
                    66923.2,
                    58196.9
                  ],
                  [
                    66470.3,
                    58341.9
                  ],
                  [
                    66139.6,
                    58476.6
                  ],
                  [
                    66058.5,
                    57492.1
                  ],
                  [
                    66099.1,
                    57195.4
                  ],
                  [
                    66144.6,
                    57034.3
                  ],
                  [
                    67026,
                    57506.3
                  ]
                ],
                "id": 1682,
                "chat_link": "[&BJIGAAA=]"
              },
              "1684": {
                "name": "Jahai Keep",
                "level": 80,
                "coord": [
                  67003.7,
                  57920.1
                ],
                "bounds": [
                  [
                    67396,
                    57668.7
                  ],
                  [
                    67299.8,
                    57512.2
                  ],
                  [
                    67116,
                    57406.2
                  ],
                  [
                    67025.4,
                    57501.4
                  ],
                  [
                    66818.9,
                    57591.9
                  ],
                  [
                    66693.9,
                    57683.8
                  ],
                  [
                    66660.8,
                    57754.4
                  ],
                  [
                    66682.7,
                    57836.5
                  ],
                  [
                    66768.4,
                    57905.1
                  ],
                  [
                    66852.9,
                    57903.2
                  ],
                  [
                    66912.2,
                    57936.4
                  ],
                  [
                    66950.3,
                    57998.4
                  ],
                  [
                    66924.7,
                    58109.8
                  ],
                  [
                    66926.3,
                    58200.3
                  ],
                  [
                    67045.4,
                    58458.9
                  ],
                  [
                    67242.6,
                    58429.7
                  ],
                  [
                    67363.5,
                    58355.3
                  ],
                  [
                    67387,
                    58310.4
                  ],
                  [
                    67396,
                    57668.7
                  ]
                ],
                "id": 1684,
                "chat_link": "[&BJQGAAA=]"
              },
              "1688": {
                "name": "Reclaimed Chantry",
                "level": 80,
                "coord": [
                  66498.8,
                  56660.1
                ],
                "bounds": [
                  [
                    66146.6,
                    56938.8
                  ],
                  [
                    66105.2,
                    56863.8
                  ],
                  [
                    65947.3,
                    56596.8
                  ],
                  [
                    66086.1,
                    56545
                  ],
                  [
                    66221.5,
                    56427.9
                  ],
                  [
                    66397.2,
                    56400.3
                  ],
                  [
                    66657.8,
                    56401
                  ],
                  [
                    66710.9,
                    56474.4
                  ],
                  [
                    66780.3,
                    56533.7
                  ],
                  [
                    66796.8,
                    56614.3
                  ],
                  [
                    66828,
                    56657.5
                  ],
                  [
                    66907.8,
                    56666.2
                  ],
                  [
                    66884.4,
                    56917.3
                  ],
                  [
                    66592.1,
                    56890.4
                  ],
                  [
                    66419.5,
                    56974
                  ],
                  [
                    66146.6,
                    56938.8
                  ]
                ],
                "id": 1688,
                "chat_link": "[&BJgGAAA=]"
              }
            },
            "adventures": [],
            "id": 1297,
            "mastery_points": []
          },
          "1299": {
            "name": "Storm Tracking",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -49152,
                -36864
              ],
              [
                49152,
                39936
              ]
            ],
            "continent_rect": [
              [
                63316,
                56376
              ],
              [
                67412,
                59576
              ]
            ],
            "points_of_interest": {
              "2959": {
                "name": "Mirza's Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63831.6,
                  57753.7
                ],
                "id": 2959,
                "chat_link": "[&BI8LAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1664": {
                "name": "???",
                "level": 80,
                "coord": [
                  65536.9,
                  57501.1
                ],
                "bounds": [
                  [
                    65372.1,
                    57439.1
                  ],
                  [
                    65451.9,
                    57300.2
                  ],
                  [
                    65530.3,
                    57279.2
                  ],
                  [
                    65616.5,
                    57323.8
                  ],
                  [
                    65670.7,
                    57402.3
                  ],
                  [
                    65741,
                    57487.7
                  ],
                  [
                    65731.6,
                    57588
                  ],
                  [
                    65687.8,
                    57659.2
                  ],
                  [
                    65593.6,
                    57654.8
                  ],
                  [
                    65381.5,
                    57699.3
                  ],
                  [
                    65345,
                    57646.1
                  ],
                  [
                    65321.2,
                    57534
                  ],
                  [
                    65372.1,
                    57439.1
                  ]
                ],
                "id": 1664,
                "chat_link": "[&BIAGAAA=]"
              },
              "1665": {
                "name": "Argon Garrison",
                "level": 80,
                "coord": [
                  65312.8,
                  58785.8
                ],
                "bounds": [
                  [
                    64995,
                    58614
                  ],
                  [
                    65158.2,
                    58562.6
                  ],
                  [
                    65321.9,
                    58536.1
                  ],
                  [
                    65662.8,
                    58577.9
                  ],
                  [
                    65841.1,
                    58935.7
                  ],
                  [
                    65399.7,
                    59197.6
                  ],
                  [
                    65139.8,
                    59114.6
                  ],
                  [
                    64983.8,
                    58748.1
                  ],
                  [
                    64995,
                    58614
                  ]
                ],
                "id": 1665,
                "chat_link": "[&BIEGAAA=]"
              },
              "1666": {
                "name": "Venta Pass",
                "level": 80,
                "coord": [
                  64498.7,
                  57764.6
                ],
                "bounds": [
                  [
                    63390.7,
                    57768
                  ],
                  [
                    63375.4,
                    57870.3
                  ],
                  [
                    63396.3,
                    58007.2
                  ],
                  [
                    63537,
                    58044
                  ],
                  [
                    63622.8,
                    58041.1
                  ],
                  [
                    63987.8,
                    58042.8
                  ],
                  [
                    64103.8,
                    58053.8
                  ],
                  [
                    64210.8,
                    58083.4
                  ],
                  [
                    64446.5,
                    58069.9
                  ],
                  [
                    64832.7,
                    57812.7
                  ],
                  [
                    64938.3,
                    57857.7
                  ],
                  [
                    65093.1,
                    57839.2
                  ],
                  [
                    65190.6,
                    57862.5
                  ],
                  [
                    65268.9,
                    57905.8
                  ],
                  [
                    65333.4,
                    57895.3
                  ],
                  [
                    65450.3,
                    57820
                  ],
                  [
                    65382.7,
                    57697.4
                  ],
                  [
                    65346.7,
                    57646.2
                  ],
                  [
                    65322.8,
                    57533.4
                  ],
                  [
                    65138.9,
                    57461.8
                  ],
                  [
                    64993.5,
                    57351.7
                  ],
                  [
                    64885.4,
                    57172.3
                  ],
                  [
                    64285.6,
                    57384.1
                  ],
                  [
                    64123.8,
                    57502.3
                  ],
                  [
                    63834.9,
                    57600.1
                  ],
                  [
                    63473.1,
                    57555.9
                  ],
                  [
                    63390.7,
                    57768
                  ]
                ],
                "id": 1666,
                "chat_link": "[&BIIGAAA=]"
              },
              "1667": {
                "name": "Wurmhaven",
                "level": 80,
                "coord": [
                  65666.7,
                  59255.6
                ],
                "bounds": [
                  [
                    66045.9,
                    59259
                  ],
                  [
                    66043.7,
                    59594.3
                  ],
                  [
                    65181.7,
                    59596.3
                  ],
                  [
                    65121.3,
                    59104
                  ],
                  [
                    65394.5,
                    59189.7
                  ],
                  [
                    65842.4,
                    58926.5
                  ],
                  [
                    66037.3,
                    59119.7
                  ],
                  [
                    66045.9,
                    59259
                  ]
                ],
                "id": 1667,
                "chat_link": "[&BIMGAAA=]"
              },
              "1668": {
                "name": "Sun's Refuge",
                "level": 80,
                "coord": [
                  63923.8,
                  58990.5
                ],
                "bounds": [
                  [
                    63617.3,
                    58516.5
                  ],
                  [
                    63694.1,
                    58559.8
                  ],
                  [
                    63748.5,
                    58664
                  ],
                  [
                    64454,
                    58758.5
                  ],
                  [
                    64406.9,
                    58871.4
                  ],
                  [
                    64378.6,
                    59035.8
                  ],
                  [
                    64423.8,
                    59631
                  ],
                  [
                    63879.7,
                    59583.4
                  ],
                  [
                    63604.8,
                    59266.7
                  ],
                  [
                    63510.1,
                    59112.6
                  ],
                  [
                    63444.4,
                    58895.8
                  ],
                  [
                    63617.3,
                    58516.5
                  ]
                ],
                "id": 1668,
                "chat_link": "[&BIQGAAA=]"
              },
              "1671": {
                "name": "Displaced Towers",
                "level": 80,
                "coord": [
                  65639.2,
                  57807.6
                ],
                "bounds": [
                  [
                    65380.2,
                    57695.9
                  ],
                  [
                    65596.6,
                    57647.9
                  ],
                  [
                    65688.5,
                    57654.5
                  ],
                  [
                    65760.6,
                    57689.1
                  ],
                  [
                    65801.4,
                    57779.7
                  ],
                  [
                    65784,
                    57863.3
                  ],
                  [
                    65708.2,
                    57972.5
                  ],
                  [
                    65640.1,
                    57986.9
                  ],
                  [
                    65584.1,
                    57965.3
                  ],
                  [
                    65448,
                    57821.3
                  ],
                  [
                    65380.2,
                    57695.9
                  ]
                ],
                "id": 1671,
                "chat_link": "[&BIcGAAA=]"
              },
              "1672": {
                "name": "Rilohn River",
                "level": 80,
                "coord": [
                  67085.7,
                  56872.3
                ],
                "bounds": [
                  [
                    67386.9,
                    56941.2
                  ],
                  [
                    67370.3,
                    56871.9
                  ],
                  [
                    67344.8,
                    56792.6
                  ],
                  [
                    67371.9,
                    56744.4
                  ],
                  [
                    67390.1,
                    56697.3
                  ],
                  [
                    67391.8,
                    56638.1
                  ],
                  [
                    67378,
                    56590.1
                  ],
                  [
                    67323.5,
                    56498
                  ],
                  [
                    67292.5,
                    56454.4
                  ],
                  [
                    67232.6,
                    56440.6
                  ],
                  [
                    67118.6,
                    56480.3
                  ],
                  [
                    66899.4,
                    56681.9
                  ],
                  [
                    66882.3,
                    56911.4
                  ],
                  [
                    66590.9,
                    56885
                  ],
                  [
                    66419.1,
                    56972.1
                  ],
                  [
                    66144.1,
                    56935.3
                  ],
                  [
                    66143.2,
                    57037.2
                  ],
                  [
                    67025.6,
                    57513
                  ],
                  [
                    67118.6,
                    57405.8
                  ],
                  [
                    67146.6,
                    57322.8
                  ],
                  [
                    67275.9,
                    57147.5
                  ],
                  [
                    67345,
                    57084.2
                  ],
                  [
                    67378.3,
                    57017.4
                  ],
                  [
                    67386.9,
                    56941.2
                  ]
                ],
                "id": 1672,
                "chat_link": "[&BIgGAAA=]"
              },
              "1673": {
                "name": "Pact Vanguard",
                "level": 80,
                "coord": [
                  64689.6,
                  59159.7
                ],
                "bounds": [
                  [
                    64987.1,
                    58748.8
                  ],
                  [
                    65144,
                    59110.8
                  ],
                  [
                    65207.8,
                    59607.5
                  ],
                  [
                    64528.8,
                    59613
                  ],
                  [
                    64421.9,
                    59625.3
                  ],
                  [
                    64374.9,
                    59034.4
                  ],
                  [
                    64406.3,
                    58849.5
                  ],
                  [
                    64446,
                    58688.3
                  ],
                  [
                    64987.1,
                    58748.8
                  ]
                ],
                "id": 1673,
                "chat_link": "[&BIkGAAA=]"
              },
              "1674": {
                "name": "Old Command Post",
                "level": 80,
                "coord": [
                  64107,
                  58293.8
                ],
                "bounds": [
                  [
                    63616.9,
                    58517.8
                  ],
                  [
                    63536.5,
                    58042.7
                  ],
                  [
                    63622.4,
                    58039.4
                  ],
                  [
                    64107.9,
                    58047.2
                  ],
                  [
                    64210.6,
                    58078.3
                  ],
                  [
                    64453.1,
                    58056.5
                  ],
                  [
                    64473,
                    58101.6
                  ],
                  [
                    64520,
                    58193.8
                  ],
                  [
                    64517.1,
                    58324.5
                  ],
                  [
                    64438.8,
                    58431.6
                  ],
                  [
                    64453.5,
                    58760.2
                  ],
                  [
                    63747.9,
                    58665.2
                  ],
                  [
                    63693.6,
                    58560.2
                  ],
                  [
                    63616.9,
                    58517.8
                  ]
                ],
                "id": 1674,
                "chat_link": "[&BIoGAAA=]"
              },
              "1675": {
                "name": "Jungle Anomaly",
                "level": 80,
                "coord": [
                  65243.8,
                  57076.6
                ],
                "bounds": [
                  [
                    65576,
                    57306
                  ],
                  [
                    65567.1,
                    56968.6
                  ],
                  [
                    65478,
                    56701.7
                  ],
                  [
                    65380.7,
                    56698.2
                  ],
                  [
                    65278.7,
                    56688.5
                  ],
                  [
                    65136.1,
                    56701.6
                  ],
                  [
                    64994,
                    56717.4
                  ],
                  [
                    64923.2,
                    56869.1
                  ],
                  [
                    64877.3,
                    57029.9
                  ],
                  [
                    64883.4,
                    57173.8
                  ],
                  [
                    64989.4,
                    57352.1
                  ],
                  [
                    65137.4,
                    57463.8
                  ],
                  [
                    65321.2,
                    57534.1
                  ],
                  [
                    65373.2,
                    57440.5
                  ],
                  [
                    65454.4,
                    57299.4
                  ],
                  [
                    65530.8,
                    57281.5
                  ],
                  [
                    65576,
                    57306
                  ]
                ],
                "id": 1675,
                "chat_link": "[&BIsGAAA=]"
              },
              "1676": {
                "name": "Ruined Procession",
                "level": 80,
                "coord": [
                  63738,
                  57097.9
                ],
                "bounds": [
                  [
                    63414.9,
                    57452.4
                  ],
                  [
                    63356.4,
                    57276
                  ],
                  [
                    63333.4,
                    57069.9
                  ],
                  [
                    63376.1,
                    56929.6
                  ],
                  [
                    63432.2,
                    56789.3
                  ],
                  [
                    63579.9,
                    56688.1
                  ],
                  [
                    63810.6,
                    56583.4
                  ],
                  [
                    64061.5,
                    56507.4
                  ],
                  [
                    63972.4,
                    56783.8
                  ],
                  [
                    63928.2,
                    57063.2
                  ],
                  [
                    64095.5,
                    57256.3
                  ],
                  [
                    64288.2,
                    57390.1
                  ],
                  [
                    64111,
                    57513
                  ],
                  [
                    63836.6,
                    57605.2
                  ],
                  [
                    63472.5,
                    57560.6
                  ],
                  [
                    63414.9,
                    57452.4
                  ]
                ],
                "id": 1676,
                "chat_link": "[&BIwGAAA=]"
              },
              "1677": {
                "name": "Crescent's Prosperity",
                "level": 80,
                "coord": [
                  65813,
                  57135.5
                ],
                "bounds": [
                  [
                    65948.2,
                    56596.8
                  ],
                  [
                    65787.2,
                    56628.6
                  ],
                  [
                    65580.1,
                    56659.4
                  ],
                  [
                    65474.9,
                    56703
                  ],
                  [
                    65561.8,
                    56971.5
                  ],
                  [
                    65572.4,
                    57309.1
                  ],
                  [
                    65615.4,
                    57328.6
                  ],
                  [
                    65735.1,
                    57492.3
                  ],
                  [
                    65726.6,
                    57586.8
                  ],
                  [
                    65683.4,
                    57658.6
                  ],
                  [
                    65753.5,
                    57696.3
                  ],
                  [
                    66061.6,
                    57504.6
                  ],
                  [
                    66103.6,
                    57198.4
                  ],
                  [
                    66147.8,
                    57032.8
                  ],
                  [
                    66149.6,
                    56937.6
                  ],
                  [
                    66106.1,
                    56864.3
                  ],
                  [
                    65948.2,
                    56596.8
                  ]
                ],
                "id": 1677,
                "chat_link": "[&BI0GAAA=]"
              },
              "1678": {
                "name": "Prosperity's Approach",
                "level": 80,
                "coord": [
                  65870.6,
                  57938.9
                ],
                "bounds": [
                  [
                    65754.6,
                    57687.7
                  ],
                  [
                    66067.9,
                    57491.3
                  ],
                  [
                    66147.8,
                    58482.9
                  ],
                  [
                    65834,
                    58295.1
                  ],
                  [
                    65709.3,
                    57971.5
                  ],
                  [
                    65782,
                    57862.9
                  ],
                  [
                    65798.4,
                    57781.1
                  ],
                  [
                    65754.6,
                    57687.7
                  ]
                ],
                "id": 1678,
                "chat_link": "[&BI4GAAA=]"
              },
              "1682": {
                "name": "Fortress of Jahai",
                "level": 80,
                "coord": [
                  66634.6,
                  57809.7
                ],
                "bounds": [
                  [
                    67026,
                    57506.3
                  ],
                  [
                    66820.9,
                    57594.7
                  ],
                  [
                    66696.7,
                    57686.7
                  ],
                  [
                    66665.1,
                    57751.9
                  ],
                  [
                    66687.3,
                    57833.6
                  ],
                  [
                    66769.7,
                    57902.9
                  ],
                  [
                    66855.5,
                    57899.4
                  ],
                  [
                    66916.1,
                    57934.8
                  ],
                  [
                    66952.6,
                    58000.8
                  ],
                  [
                    66927.9,
                    58107.5
                  ],
                  [
                    66923.2,
                    58196.9
                  ],
                  [
                    66470.3,
                    58341.9
                  ],
                  [
                    66139.6,
                    58476.6
                  ],
                  [
                    66058.5,
                    57492.1
                  ],
                  [
                    66099.1,
                    57195.4
                  ],
                  [
                    66144.6,
                    57034.3
                  ],
                  [
                    67026,
                    57506.3
                  ]
                ],
                "id": 1682,
                "chat_link": "[&BJIGAAA=]"
              },
              "1683": {
                "name": "Kodonur Temple",
                "level": 80,
                "coord": [
                  66436.2,
                  59270.3
                ],
                "bounds": [
                  [
                    66993.8,
                    59094.8
                  ],
                  [
                    66645.8,
                    59085.8
                  ],
                  [
                    66349.8,
                    58992
                  ],
                  [
                    66163.6,
                    58978.3
                  ],
                  [
                    66031.3,
                    59110.1
                  ],
                  [
                    66044.1,
                    59270.1
                  ],
                  [
                    66035.9,
                    59593
                  ],
                  [
                    66525,
                    59608.6
                  ],
                  [
                    66725.5,
                    59543.4
                  ],
                  [
                    66847.3,
                    59426.7
                  ],
                  [
                    66993.8,
                    59094.8
                  ]
                ],
                "id": 1683,
                "chat_link": "[&BJMGAAA=]"
              },
              "1684": {
                "name": "Jahai Keep",
                "level": 80,
                "coord": [
                  67003.7,
                  57920.1
                ],
                "bounds": [
                  [
                    67396,
                    57668.7
                  ],
                  [
                    67299.8,
                    57512.2
                  ],
                  [
                    67116,
                    57406.2
                  ],
                  [
                    67025.4,
                    57501.4
                  ],
                  [
                    66818.9,
                    57591.9
                  ],
                  [
                    66693.9,
                    57683.8
                  ],
                  [
                    66660.8,
                    57754.4
                  ],
                  [
                    66682.7,
                    57836.5
                  ],
                  [
                    66768.4,
                    57905.1
                  ],
                  [
                    66852.9,
                    57903.2
                  ],
                  [
                    66912.2,
                    57936.4
                  ],
                  [
                    66950.3,
                    57998.4
                  ],
                  [
                    66924.7,
                    58109.8
                  ],
                  [
                    66926.3,
                    58200.3
                  ],
                  [
                    67045.4,
                    58458.9
                  ],
                  [
                    67242.6,
                    58429.7
                  ],
                  [
                    67363.5,
                    58355.3
                  ],
                  [
                    67387,
                    58310.4
                  ],
                  [
                    67396,
                    57668.7
                  ]
                ],
                "id": 1684,
                "chat_link": "[&BJQGAAA=]"
              },
              "1685": {
                "name": "Central Brand Scar",
                "level": 80,
                "coord": [
                  65013.6,
                  58208.9
                ],
                "bounds": [
                  [
                    65659.4,
                    58586.7
                  ],
                  [
                    65322.7,
                    58541.1
                  ],
                  [
                    65161.8,
                    58566.9
                  ],
                  [
                    65001.1,
                    58618.8
                  ],
                  [
                    64989.3,
                    58753.7
                  ],
                  [
                    64445.4,
                    58691.7
                  ],
                  [
                    64442.1,
                    58509.3
                  ],
                  [
                    64437.2,
                    58429.4
                  ],
                  [
                    64511.8,
                    58327.5
                  ],
                  [
                    64517.8,
                    58194.8
                  ],
                  [
                    64438.7,
                    58050.2
                  ],
                  [
                    64828.3,
                    57812.4
                  ],
                  [
                    64937.5,
                    57856.1
                  ],
                  [
                    65092.8,
                    57837.5
                  ],
                  [
                    65191.4,
                    57862.1
                  ],
                  [
                    65268.9,
                    57903.7
                  ],
                  [
                    65336.1,
                    57891.6
                  ],
                  [
                    65458.8,
                    57810.1
                  ],
                  [
                    65588,
                    57959
                  ],
                  [
                    65643.3,
                    57975.1
                  ],
                  [
                    65659.4,
                    58586.7
                  ]
                ],
                "id": 1685,
                "chat_link": "[&BJUGAAA=]"
              },
              "1687": {
                "name": "Eastern Brand Scar",
                "level": 80,
                "coord": [
                  66143.4,
                  58663.4
                ],
                "bounds": [
                  [
                    65650.2,
                    58576
                  ],
                  [
                    65639.8,
                    57979.2
                  ],
                  [
                    65711.6,
                    57967.1
                  ],
                  [
                    65836.2,
                    58286.4
                  ],
                  [
                    66146.8,
                    58473.7
                  ],
                  [
                    66257.3,
                    58577.6
                  ],
                  [
                    66355.8,
                    58713.5
                  ],
                  [
                    66672.9,
                    58731.8
                  ],
                  [
                    66708,
                    58860.3
                  ],
                  [
                    66643.6,
                    59089.5
                  ],
                  [
                    66350,
                    58996.7
                  ],
                  [
                    66167.3,
                    58982.5
                  ],
                  [
                    66033.3,
                    59120.4
                  ],
                  [
                    65834.1,
                    58933.3
                  ],
                  [
                    65650.2,
                    58576
                  ]
                ],
                "id": 1687,
                "chat_link": "[&BJcGAAA=]"
              },
              "1688": {
                "name": "Reclaimed Chantry",
                "level": 80,
                "coord": [
                  66498.8,
                  56660.1
                ],
                "bounds": [
                  [
                    66146.6,
                    56938.8
                  ],
                  [
                    66105.2,
                    56863.8
                  ],
                  [
                    65947.3,
                    56596.8
                  ],
                  [
                    66086.1,
                    56545
                  ],
                  [
                    66221.5,
                    56427.9
                  ],
                  [
                    66397.2,
                    56400.3
                  ],
                  [
                    66657.8,
                    56401
                  ],
                  [
                    66710.9,
                    56474.4
                  ],
                  [
                    66780.3,
                    56533.7
                  ],
                  [
                    66796.8,
                    56614.3
                  ],
                  [
                    66828,
                    56657.5
                  ],
                  [
                    66907.8,
                    56666.2
                  ],
                  [
                    66884.4,
                    56917.3
                  ],
                  [
                    66592.1,
                    56890.4
                  ],
                  [
                    66419.5,
                    56974
                  ],
                  [
                    66146.6,
                    56938.8
                  ]
                ],
                "id": 1688,
                "chat_link": "[&BJgGAAA=]"
              },
              "1689": {
                "name": "Yatendi Village",
                "level": 80,
                "coord": [
                  66590.8,
                  58512.6
                ],
                "bounds": [
                  [
                    66142.4,
                    58467.4
                  ],
                  [
                    66252.1,
                    58577.4
                  ],
                  [
                    66355.6,
                    58712.3
                  ],
                  [
                    66677.3,
                    58736.3
                  ],
                  [
                    66862.8,
                    58626.8
                  ],
                  [
                    67047.5,
                    58457.4
                  ],
                  [
                    66925.1,
                    58182.8
                  ],
                  [
                    66463.7,
                    58340.4
                  ],
                  [
                    66142.4,
                    58467.4
                  ]
                ],
                "id": 1689,
                "chat_link": "[&BJkGAAA=]"
              },
              "1690": {
                "name": "Almorra's Stand",
                "level": 80,
                "coord": [
                  64494.3,
                  56785.4
                ],
                "bounds": [
                  [
                    64269.9,
                    57399.6
                  ],
                  [
                    64090.8,
                    57259.9
                  ],
                  [
                    63921.8,
                    57065.4
                  ],
                  [
                    63968.7,
                    56779.1
                  ],
                  [
                    64056.2,
                    56509
                  ],
                  [
                    64228.3,
                    56400.4
                  ],
                  [
                    64449.3,
                    56383
                  ],
                  [
                    64637.2,
                    56392.6
                  ],
                  [
                    64746.6,
                    56436.8
                  ],
                  [
                    64865.3,
                    56576.8
                  ],
                  [
                    64995.2,
                    56717.4
                  ],
                  [
                    64924.8,
                    56872.1
                  ],
                  [
                    64881,
                    57029.7
                  ],
                  [
                    64885.3,
                    57173.3
                  ],
                  [
                    64269.9,
                    57399.6
                  ]
                ],
                "id": 1690,
                "chat_link": "[&BJoGAAA=]"
              },
              "1691": {
                "name": "Shattered Cliffs",
                "level": 80,
                "coord": [
                  67027.4,
                  58762.7
                ],
                "bounds": [
                  [
                    66669.1,
                    58732.3
                  ],
                  [
                    66698.4,
                    58866.1
                  ],
                  [
                    66642.8,
                    59092
                  ],
                  [
                    66981.5,
                    59108.1
                  ],
                  [
                    67184.2,
                    59024.6
                  ],
                  [
                    67284.7,
                    58874.1
                  ],
                  [
                    67347.3,
                    58678.2
                  ],
                  [
                    67347.2,
                    58510.3
                  ],
                  [
                    67243,
                    58429.2
                  ],
                  [
                    67043.8,
                    58451.4
                  ],
                  [
                    66858.9,
                    58623
                  ],
                  [
                    66669.1,
                    58732.3
                  ]
                ],
                "id": 1691,
                "chat_link": "[&BJsGAAA=]"
              }
            },
            "adventures": [],
            "id": 1299,
            "mastery_points": []
          },
          "1300": {
            "name": "From the Ashes—The Deadeye",
            "min_level": 0,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -49152,
                -36864
              ],
              [
                49152,
                39936
              ]
            ],
            "continent_rect": [
              [
                63316,
                56376
              ],
              [
                67412,
                59576
              ]
            ],
            "points_of_interest": {
              "2923": {
                "name": "Gaze of the Ancients",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66589.4,
                  56648.3
                ],
                "id": 2923,
                "chat_link": "[&BGsLAAA=]"
              },
              "2925": {
                "name": "Displaced Vizier's Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65626.8,
                  57826.3
                ],
                "id": 2925,
                "chat_link": "[&BG0LAAA=]"
              },
              "2928": {
                "name": "Staging Platform",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64336.2,
                  57153.9
                ],
                "id": 2928,
                "chat_link": "[&BHALAAA=]"
              },
              "2929": {
                "name": "Jahai Great Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66384.5,
                  57739.9
                ],
                "id": 2929,
                "chat_link": "[&BHELAAA=]"
              },
              "2931": {
                "name": "Ring of Judgment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66275.6,
                  57741.4
                ],
                "id": 2931,
                "chat_link": "[&BHMLAAA=]"
              },
              "2936": {
                "name": "Fortress Courtyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67150,
                  58147.1
                ],
                "id": 2936,
                "chat_link": "[&BHgLAAA=]"
              },
              "2937": {
                "name": "Sleepless Beacon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66059,
                  57882.9
                ],
                "id": 2937,
                "chat_link": "[&BHkLAAA=]"
              },
              "2938": {
                "name": "Ancestor Tree",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63760.5,
                  57103.2
                ],
                "id": 2938,
                "chat_link": "[&BHoLAAA=]"
              },
              "2940": {
                "name": "Battleground Ramparts",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64246.2,
                  56871.9
                ],
                "id": 2940,
                "chat_link": "[&BHwLAAA=]"
              },
              "2943": {
                "name": "Garrison Relay Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65475.9,
                  58660.9
                ],
                "id": 2943,
                "chat_link": "[&BH8LAAA=]"
              },
              "2944": {
                "name": "Noble's Walk",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66362.1,
                  58173
                ],
                "id": 2944,
                "chat_link": "[&BIALAAA=]"
              },
              "2946": {
                "name": "Wurmmarshal's Encampment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65581.8,
                  59151.9
                ],
                "id": 2946,
                "chat_link": "[&BIILAAA=]"
              },
              "2952": {
                "name": "Rilohn Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66545.6,
                  58255.8
                ],
                "id": 2952,
                "chat_link": "[&BIgLAAA=]"
              },
              "2953": {
                "name": "Confluence of the Elements",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66618.3,
                  59352.7
                ],
                "id": 2953,
                "chat_link": "[&BIkLAAA=]"
              },
              "2954": {
                "name": "Archon's Retreat",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66285.6,
                  57337
                ],
                "id": 2954,
                "chat_link": "[&BIoLAAA=]"
              },
              "2955": {
                "name": "Garrison Command",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65519,
                  58839
                ],
                "id": 2955,
                "chat_link": "[&BIsLAAA=]"
              },
              "2956": {
                "name": "Garrison Access Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65175.2,
                  58877.7
                ],
                "id": 2956,
                "chat_link": "[&BIwLAAA=]"
              },
              "2957": {
                "name": "Vanguard Ordinance",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64771.3,
                  59207.4
                ],
                "id": 2957,
                "chat_link": "[&BI0LAAA=]"
              },
              "2958": {
                "name": "Kormir's Reverence",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66364.8,
                  56702.1
                ],
                "id": 2958,
                "chat_link": "[&BI4LAAA=]"
              },
              "2959": {
                "name": "Mirza's Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63831.6,
                  57753.7
                ],
                "id": 2959,
                "chat_link": "[&BI8LAAA=]"
              },
              "2960": {
                "name": "Vanguard Salvage Yard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64677.9,
                  58947.8
                ],
                "id": 2960,
                "chat_link": "[&BJALAAA=]"
              },
              "2961": {
                "name": "Monument to the Return of Palawa Joko",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65476.6,
                  58044.4
                ],
                "id": 2961,
                "chat_link": "[&BJELAAA=]"
              },
              "2964": {
                "name": "Crystal Cavern",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64884.1,
                  57923.3
                ],
                "id": 2964,
                "chat_link": "[&BJQLAAA=]"
              },
              "2968": {
                "name": "Crescent's Town Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65870.9,
                  56800.9
                ],
                "id": 2968,
                "chat_link": "[&BJgLAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1664": {
                "name": "???",
                "level": 80,
                "coord": [
                  65536.9,
                  57501.1
                ],
                "bounds": [
                  [
                    65372.1,
                    57439.1
                  ],
                  [
                    65451.9,
                    57300.2
                  ],
                  [
                    65530.3,
                    57279.2
                  ],
                  [
                    65616.5,
                    57323.8
                  ],
                  [
                    65670.7,
                    57402.3
                  ],
                  [
                    65741,
                    57487.7
                  ],
                  [
                    65731.6,
                    57588
                  ],
                  [
                    65687.8,
                    57659.2
                  ],
                  [
                    65593.6,
                    57654.8
                  ],
                  [
                    65381.5,
                    57699.3
                  ],
                  [
                    65345,
                    57646.1
                  ],
                  [
                    65321.2,
                    57534
                  ],
                  [
                    65372.1,
                    57439.1
                  ]
                ],
                "id": 1664,
                "chat_link": "[&BIAGAAA=]"
              },
              "1665": {
                "name": "Argon Garrison",
                "level": 80,
                "coord": [
                  65312.8,
                  58785.8
                ],
                "bounds": [
                  [
                    64995,
                    58614
                  ],
                  [
                    65158.2,
                    58562.6
                  ],
                  [
                    65321.9,
                    58536.1
                  ],
                  [
                    65662.8,
                    58577.9
                  ],
                  [
                    65841.1,
                    58935.7
                  ],
                  [
                    65399.7,
                    59197.6
                  ],
                  [
                    65139.8,
                    59114.6
                  ],
                  [
                    64983.8,
                    58748.1
                  ],
                  [
                    64995,
                    58614
                  ]
                ],
                "id": 1665,
                "chat_link": "[&BIEGAAA=]"
              },
              "1666": {
                "name": "Venta Pass",
                "level": 80,
                "coord": [
                  64498.7,
                  57764.6
                ],
                "bounds": [
                  [
                    63390.7,
                    57768
                  ],
                  [
                    63375.4,
                    57870.3
                  ],
                  [
                    63396.3,
                    58007.2
                  ],
                  [
                    63537,
                    58044
                  ],
                  [
                    63622.8,
                    58041.1
                  ],
                  [
                    63987.8,
                    58042.8
                  ],
                  [
                    64103.8,
                    58053.8
                  ],
                  [
                    64210.8,
                    58083.4
                  ],
                  [
                    64446.5,
                    58069.9
                  ],
                  [
                    64832.7,
                    57812.7
                  ],
                  [
                    64938.3,
                    57857.7
                  ],
                  [
                    65093.1,
                    57839.2
                  ],
                  [
                    65190.6,
                    57862.5
                  ],
                  [
                    65268.9,
                    57905.8
                  ],
                  [
                    65333.4,
                    57895.3
                  ],
                  [
                    65450.3,
                    57820
                  ],
                  [
                    65382.7,
                    57697.4
                  ],
                  [
                    65346.7,
                    57646.2
                  ],
                  [
                    65322.8,
                    57533.4
                  ],
                  [
                    65138.9,
                    57461.8
                  ],
                  [
                    64993.5,
                    57351.7
                  ],
                  [
                    64885.4,
                    57172.3
                  ],
                  [
                    64285.6,
                    57384.1
                  ],
                  [
                    64123.8,
                    57502.3
                  ],
                  [
                    63834.9,
                    57600.1
                  ],
                  [
                    63473.1,
                    57555.9
                  ],
                  [
                    63390.7,
                    57768
                  ]
                ],
                "id": 1666,
                "chat_link": "[&BIIGAAA=]"
              },
              "1667": {
                "name": "Wurmhaven",
                "level": 80,
                "coord": [
                  65666.7,
                  59255.6
                ],
                "bounds": [
                  [
                    66045.9,
                    59259
                  ],
                  [
                    66043.7,
                    59594.3
                  ],
                  [
                    65181.7,
                    59596.3
                  ],
                  [
                    65121.3,
                    59104
                  ],
                  [
                    65394.5,
                    59189.7
                  ],
                  [
                    65842.4,
                    58926.5
                  ],
                  [
                    66037.3,
                    59119.7
                  ],
                  [
                    66045.9,
                    59259
                  ]
                ],
                "id": 1667,
                "chat_link": "[&BIMGAAA=]"
              },
              "1668": {
                "name": "Sun's Refuge",
                "level": 80,
                "coord": [
                  63923.8,
                  58990.5
                ],
                "bounds": [
                  [
                    63617.3,
                    58516.5
                  ],
                  [
                    63694.1,
                    58559.8
                  ],
                  [
                    63748.5,
                    58664
                  ],
                  [
                    64454,
                    58758.5
                  ],
                  [
                    64406.9,
                    58871.4
                  ],
                  [
                    64378.6,
                    59035.8
                  ],
                  [
                    64423.8,
                    59631
                  ],
                  [
                    63879.7,
                    59583.4
                  ],
                  [
                    63604.8,
                    59266.7
                  ],
                  [
                    63510.1,
                    59112.6
                  ],
                  [
                    63444.4,
                    58895.8
                  ],
                  [
                    63617.3,
                    58516.5
                  ]
                ],
                "id": 1668,
                "chat_link": "[&BIQGAAA=]"
              },
              "1671": {
                "name": "Displaced Towers",
                "level": 80,
                "coord": [
                  65639.2,
                  57807.6
                ],
                "bounds": [
                  [
                    65380.2,
                    57695.9
                  ],
                  [
                    65596.6,
                    57647.9
                  ],
                  [
                    65688.5,
                    57654.5
                  ],
                  [
                    65760.6,
                    57689.1
                  ],
                  [
                    65801.4,
                    57779.7
                  ],
                  [
                    65784,
                    57863.3
                  ],
                  [
                    65708.2,
                    57972.5
                  ],
                  [
                    65640.1,
                    57986.9
                  ],
                  [
                    65584.1,
                    57965.3
                  ],
                  [
                    65448,
                    57821.3
                  ],
                  [
                    65380.2,
                    57695.9
                  ]
                ],
                "id": 1671,
                "chat_link": "[&BIcGAAA=]"
              },
              "1673": {
                "name": "Pact Vanguard",
                "level": 80,
                "coord": [
                  64689.6,
                  59159.7
                ],
                "bounds": [
                  [
                    64987.1,
                    58748.8
                  ],
                  [
                    65144,
                    59110.8
                  ],
                  [
                    65207.8,
                    59607.5
                  ],
                  [
                    64528.8,
                    59613
                  ],
                  [
                    64421.9,
                    59625.3
                  ],
                  [
                    64374.9,
                    59034.4
                  ],
                  [
                    64406.3,
                    58849.5
                  ],
                  [
                    64446,
                    58688.3
                  ],
                  [
                    64987.1,
                    58748.8
                  ]
                ],
                "id": 1673,
                "chat_link": "[&BIkGAAA=]"
              },
              "1674": {
                "name": "Old Command Post",
                "level": 80,
                "coord": [
                  64107,
                  58293.8
                ],
                "bounds": [
                  [
                    63616.9,
                    58517.8
                  ],
                  [
                    63536.5,
                    58042.7
                  ],
                  [
                    63622.4,
                    58039.4
                  ],
                  [
                    64107.9,
                    58047.2
                  ],
                  [
                    64210.6,
                    58078.3
                  ],
                  [
                    64453.1,
                    58056.5
                  ],
                  [
                    64473,
                    58101.6
                  ],
                  [
                    64520,
                    58193.8
                  ],
                  [
                    64517.1,
                    58324.5
                  ],
                  [
                    64438.8,
                    58431.6
                  ],
                  [
                    64453.5,
                    58760.2
                  ],
                  [
                    63747.9,
                    58665.2
                  ],
                  [
                    63693.6,
                    58560.2
                  ],
                  [
                    63616.9,
                    58517.8
                  ]
                ],
                "id": 1674,
                "chat_link": "[&BIoGAAA=]"
              },
              "1675": {
                "name": "Jungle Anomaly",
                "level": 80,
                "coord": [
                  65243.8,
                  57076.6
                ],
                "bounds": [
                  [
                    65576,
                    57306
                  ],
                  [
                    65567.1,
                    56968.6
                  ],
                  [
                    65478,
                    56701.7
                  ],
                  [
                    65380.7,
                    56698.2
                  ],
                  [
                    65278.7,
                    56688.5
                  ],
                  [
                    65136.1,
                    56701.6
                  ],
                  [
                    64994,
                    56717.4
                  ],
                  [
                    64923.2,
                    56869.1
                  ],
                  [
                    64877.3,
                    57029.9
                  ],
                  [
                    64883.4,
                    57173.8
                  ],
                  [
                    64989.4,
                    57352.1
                  ],
                  [
                    65137.4,
                    57463.8
                  ],
                  [
                    65321.2,
                    57534.1
                  ],
                  [
                    65373.2,
                    57440.5
                  ],
                  [
                    65454.4,
                    57299.4
                  ],
                  [
                    65530.8,
                    57281.5
                  ],
                  [
                    65576,
                    57306
                  ]
                ],
                "id": 1675,
                "chat_link": "[&BIsGAAA=]"
              },
              "1676": {
                "name": "Ruined Procession",
                "level": 80,
                "coord": [
                  63738,
                  57097.9
                ],
                "bounds": [
                  [
                    63414.9,
                    57452.4
                  ],
                  [
                    63356.4,
                    57276
                  ],
                  [
                    63333.4,
                    57069.9
                  ],
                  [
                    63376.1,
                    56929.6
                  ],
                  [
                    63432.2,
                    56789.3
                  ],
                  [
                    63579.9,
                    56688.1
                  ],
                  [
                    63810.6,
                    56583.4
                  ],
                  [
                    64061.5,
                    56507.4
                  ],
                  [
                    63972.4,
                    56783.8
                  ],
                  [
                    63928.2,
                    57063.2
                  ],
                  [
                    64095.5,
                    57256.3
                  ],
                  [
                    64288.2,
                    57390.1
                  ],
                  [
                    64111,
                    57513
                  ],
                  [
                    63836.6,
                    57605.2
                  ],
                  [
                    63472.5,
                    57560.6
                  ],
                  [
                    63414.9,
                    57452.4
                  ]
                ],
                "id": 1676,
                "chat_link": "[&BIwGAAA=]"
              },
              "1677": {
                "name": "Crescent's Prosperity",
                "level": 80,
                "coord": [
                  65813,
                  57135.5
                ],
                "bounds": [
                  [
                    65948.2,
                    56596.8
                  ],
                  [
                    65787.2,
                    56628.6
                  ],
                  [
                    65580.1,
                    56659.4
                  ],
                  [
                    65474.9,
                    56703
                  ],
                  [
                    65561.8,
                    56971.5
                  ],
                  [
                    65572.4,
                    57309.1
                  ],
                  [
                    65615.4,
                    57328.6
                  ],
                  [
                    65735.1,
                    57492.3
                  ],
                  [
                    65726.6,
                    57586.8
                  ],
                  [
                    65683.4,
                    57658.6
                  ],
                  [
                    65753.5,
                    57696.3
                  ],
                  [
                    66061.6,
                    57504.6
                  ],
                  [
                    66103.6,
                    57198.4
                  ],
                  [
                    66147.8,
                    57032.8
                  ],
                  [
                    66149.6,
                    56937.6
                  ],
                  [
                    66106.1,
                    56864.3
                  ],
                  [
                    65948.2,
                    56596.8
                  ]
                ],
                "id": 1677,
                "chat_link": "[&BI0GAAA=]"
              },
              "1682": {
                "name": "Fortress of Jahai",
                "level": 80,
                "coord": [
                  66634.6,
                  57809.7
                ],
                "bounds": [
                  [
                    67026,
                    57506.3
                  ],
                  [
                    66820.9,
                    57594.7
                  ],
                  [
                    66696.7,
                    57686.7
                  ],
                  [
                    66665.1,
                    57751.9
                  ],
                  [
                    66687.3,
                    57833.6
                  ],
                  [
                    66769.7,
                    57902.9
                  ],
                  [
                    66855.5,
                    57899.4
                  ],
                  [
                    66916.1,
                    57934.8
                  ],
                  [
                    66952.6,
                    58000.8
                  ],
                  [
                    66927.9,
                    58107.5
                  ],
                  [
                    66923.2,
                    58196.9
                  ],
                  [
                    66470.3,
                    58341.9
                  ],
                  [
                    66139.6,
                    58476.6
                  ],
                  [
                    66058.5,
                    57492.1
                  ],
                  [
                    66099.1,
                    57195.4
                  ],
                  [
                    66144.6,
                    57034.3
                  ],
                  [
                    67026,
                    57506.3
                  ]
                ],
                "id": 1682,
                "chat_link": "[&BJIGAAA=]"
              },
              "1683": {
                "name": "Kodonur Temple",
                "level": 80,
                "coord": [
                  66436.2,
                  59270.3
                ],
                "bounds": [
                  [
                    66993.8,
                    59094.8
                  ],
                  [
                    66645.8,
                    59085.8
                  ],
                  [
                    66349.8,
                    58992
                  ],
                  [
                    66163.6,
                    58978.3
                  ],
                  [
                    66031.3,
                    59110.1
                  ],
                  [
                    66044.1,
                    59270.1
                  ],
                  [
                    66035.9,
                    59593
                  ],
                  [
                    66525,
                    59608.6
                  ],
                  [
                    66725.5,
                    59543.4
                  ],
                  [
                    66847.3,
                    59426.7
                  ],
                  [
                    66993.8,
                    59094.8
                  ]
                ],
                "id": 1683,
                "chat_link": "[&BJMGAAA=]"
              },
              "1684": {
                "name": "Jahai Keep",
                "level": 80,
                "coord": [
                  67003.7,
                  57920.1
                ],
                "bounds": [
                  [
                    67396,
                    57668.7
                  ],
                  [
                    67299.8,
                    57512.2
                  ],
                  [
                    67116,
                    57406.2
                  ],
                  [
                    67025.4,
                    57501.4
                  ],
                  [
                    66818.9,
                    57591.9
                  ],
                  [
                    66693.9,
                    57683.8
                  ],
                  [
                    66660.8,
                    57754.4
                  ],
                  [
                    66682.7,
                    57836.5
                  ],
                  [
                    66768.4,
                    57905.1
                  ],
                  [
                    66852.9,
                    57903.2
                  ],
                  [
                    66912.2,
                    57936.4
                  ],
                  [
                    66950.3,
                    57998.4
                  ],
                  [
                    66924.7,
                    58109.8
                  ],
                  [
                    66926.3,
                    58200.3
                  ],
                  [
                    67045.4,
                    58458.9
                  ],
                  [
                    67242.6,
                    58429.7
                  ],
                  [
                    67363.5,
                    58355.3
                  ],
                  [
                    67387,
                    58310.4
                  ],
                  [
                    67396,
                    57668.7
                  ]
                ],
                "id": 1684,
                "chat_link": "[&BJQGAAA=]"
              },
              "1685": {
                "name": "Central Brand Scar",
                "level": 80,
                "coord": [
                  65013.6,
                  58208.9
                ],
                "bounds": [
                  [
                    65659.4,
                    58586.7
                  ],
                  [
                    65322.7,
                    58541.1
                  ],
                  [
                    65161.8,
                    58566.9
                  ],
                  [
                    65001.1,
                    58618.8
                  ],
                  [
                    64989.3,
                    58753.7
                  ],
                  [
                    64445.4,
                    58691.7
                  ],
                  [
                    64442.1,
                    58509.3
                  ],
                  [
                    64437.2,
                    58429.4
                  ],
                  [
                    64511.8,
                    58327.5
                  ],
                  [
                    64517.8,
                    58194.8
                  ],
                  [
                    64438.7,
                    58050.2
                  ],
                  [
                    64828.3,
                    57812.4
                  ],
                  [
                    64937.5,
                    57856.1
                  ],
                  [
                    65092.8,
                    57837.5
                  ],
                  [
                    65191.4,
                    57862.1
                  ],
                  [
                    65268.9,
                    57903.7
                  ],
                  [
                    65336.1,
                    57891.6
                  ],
                  [
                    65458.8,
                    57810.1
                  ],
                  [
                    65588,
                    57959
                  ],
                  [
                    65643.3,
                    57975.1
                  ],
                  [
                    65659.4,
                    58586.7
                  ]
                ],
                "id": 1685,
                "chat_link": "[&BJUGAAA=]"
              },
              "1687": {
                "name": "Eastern Brand Scar",
                "level": 80,
                "coord": [
                  66143.4,
                  58663.4
                ],
                "bounds": [
                  [
                    65650.2,
                    58576
                  ],
                  [
                    65639.8,
                    57979.2
                  ],
                  [
                    65711.6,
                    57967.1
                  ],
                  [
                    65836.2,
                    58286.4
                  ],
                  [
                    66146.8,
                    58473.7
                  ],
                  [
                    66257.3,
                    58577.6
                  ],
                  [
                    66355.8,
                    58713.5
                  ],
                  [
                    66672.9,
                    58731.8
                  ],
                  [
                    66708,
                    58860.3
                  ],
                  [
                    66643.6,
                    59089.5
                  ],
                  [
                    66350,
                    58996.7
                  ],
                  [
                    66167.3,
                    58982.5
                  ],
                  [
                    66033.3,
                    59120.4
                  ],
                  [
                    65834.1,
                    58933.3
                  ],
                  [
                    65650.2,
                    58576
                  ]
                ],
                "id": 1687,
                "chat_link": "[&BJcGAAA=]"
              },
              "1688": {
                "name": "Reclaimed Chantry",
                "level": 80,
                "coord": [
                  66498.8,
                  56660.1
                ],
                "bounds": [
                  [
                    66146.6,
                    56938.8
                  ],
                  [
                    66105.2,
                    56863.8
                  ],
                  [
                    65947.3,
                    56596.8
                  ],
                  [
                    66086.1,
                    56545
                  ],
                  [
                    66221.5,
                    56427.9
                  ],
                  [
                    66397.2,
                    56400.3
                  ],
                  [
                    66657.8,
                    56401
                  ],
                  [
                    66710.9,
                    56474.4
                  ],
                  [
                    66780.3,
                    56533.7
                  ],
                  [
                    66796.8,
                    56614.3
                  ],
                  [
                    66828,
                    56657.5
                  ],
                  [
                    66907.8,
                    56666.2
                  ],
                  [
                    66884.4,
                    56917.3
                  ],
                  [
                    66592.1,
                    56890.4
                  ],
                  [
                    66419.5,
                    56974
                  ],
                  [
                    66146.6,
                    56938.8
                  ]
                ],
                "id": 1688,
                "chat_link": "[&BJgGAAA=]"
              },
              "1689": {
                "name": "Yatendi Village",
                "level": 80,
                "coord": [
                  66590.8,
                  58512.6
                ],
                "bounds": [
                  [
                    66142.4,
                    58467.4
                  ],
                  [
                    66252.1,
                    58577.4
                  ],
                  [
                    66355.6,
                    58712.3
                  ],
                  [
                    66677.3,
                    58736.3
                  ],
                  [
                    66862.8,
                    58626.8
                  ],
                  [
                    67047.5,
                    58457.4
                  ],
                  [
                    66925.1,
                    58182.8
                  ],
                  [
                    66463.7,
                    58340.4
                  ],
                  [
                    66142.4,
                    58467.4
                  ]
                ],
                "id": 1689,
                "chat_link": "[&BJkGAAA=]"
              },
              "1690": {
                "name": "Almorra's Stand",
                "level": 80,
                "coord": [
                  64494.3,
                  56785.4
                ],
                "bounds": [
                  [
                    64269.9,
                    57399.6
                  ],
                  [
                    64090.8,
                    57259.9
                  ],
                  [
                    63921.8,
                    57065.4
                  ],
                  [
                    63968.7,
                    56779.1
                  ],
                  [
                    64056.2,
                    56509
                  ],
                  [
                    64228.3,
                    56400.4
                  ],
                  [
                    64449.3,
                    56383
                  ],
                  [
                    64637.2,
                    56392.6
                  ],
                  [
                    64746.6,
                    56436.8
                  ],
                  [
                    64865.3,
                    56576.8
                  ],
                  [
                    64995.2,
                    56717.4
                  ],
                  [
                    64924.8,
                    56872.1
                  ],
                  [
                    64881,
                    57029.7
                  ],
                  [
                    64885.3,
                    57173.3
                  ],
                  [
                    64269.9,
                    57399.6
                  ]
                ],
                "id": 1690,
                "chat_link": "[&BJoGAAA=]"
              }
            },
            "adventures": [],
            "id": 1300,
            "mastery_points": []
          },
          "1301": {
            "name": "Jahai Bluffs",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              65151,
              58087
            ],
            "map_rect": [
              [
                -49152,
                -36864
              ],
              [
                49152,
                39936
              ]
            ],
            "continent_rect": [
              [
                63316,
                56376
              ],
              [
                67412,
                59576
              ]
            ],
            "points_of_interest": {
              "2922": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  65511.7,
                  58789.4
                ],
                "id": 2922,
                "chat_link": "[&BGoLAAA=]"
              },
              "2923": {
                "name": "Gaze of the Ancients",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66589.4,
                  56648.3
                ],
                "id": 2923,
                "chat_link": "[&BGsLAAA=]"
              },
              "2924": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  66819.4,
                  56747.9
                ],
                "id": 2924,
                "chat_link": "[&BGwLAAA=]"
              },
              "2925": {
                "name": "Displaced Vizier's Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65626.8,
                  57826.3
                ],
                "id": 2925,
                "chat_link": "[&BG0LAAA=]"
              },
              "2927": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  65519.8,
                  57802.9
                ],
                "id": 2927,
                "chat_link": "[&BG8LAAA=]"
              },
              "2928": {
                "name": "Staging Platform",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64336.2,
                  57153.9
                ],
                "id": 2928,
                "chat_link": "[&BHALAAA=]"
              },
              "2929": {
                "name": "Jahai Great Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66384.5,
                  57739.9
                ],
                "id": 2929,
                "chat_link": "[&BHELAAA=]"
              },
              "2930": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  65289,
                  57124.1
                ],
                "id": 2930,
                "chat_link": "[&BHILAAA=]"
              },
              "2931": {
                "name": "Ring of Judgment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66275.6,
                  57741.4
                ],
                "id": 2931,
                "chat_link": "[&BHMLAAA=]"
              },
              "2932": {
                "name": "Claw Den",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67110.8,
                  58523.5
                ],
                "id": 2932,
                "chat_link": "[&BHQLAAA=]"
              },
              "2934": {
                "name": "Riyid's Post",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67272.3,
                  56921.1
                ],
                "id": 2934,
                "chat_link": "[&BHYLAAA=]"
              },
              "2936": {
                "name": "Fortress Courtyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67150,
                  58147.1
                ],
                "id": 2936,
                "chat_link": "[&BHgLAAA=]"
              },
              "2937": {
                "name": "Sleepless Beacon",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66059,
                  57882.9
                ],
                "id": 2937,
                "chat_link": "[&BHkLAAA=]"
              },
              "2938": {
                "name": "Ancestor Tree",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63760.5,
                  57103.2
                ],
                "id": 2938,
                "chat_link": "[&BHoLAAA=]"
              },
              "2940": {
                "name": "Battleground Ramparts",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64246.2,
                  56871.9
                ],
                "id": 2940,
                "chat_link": "[&BHwLAAA=]"
              },
              "2942": {
                "name": "Yatendi Village Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  66572.2,
                  58608.9
                ],
                "id": 2942,
                "chat_link": "[&BH4LAAA=]"
              },
              "2943": {
                "name": "Garrison Relay Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65475.9,
                  58660.9
                ],
                "id": 2943,
                "chat_link": "[&BH8LAAA=]"
              },
              "2944": {
                "name": "Noble's Walk",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66362.1,
                  58173
                ],
                "id": 2944,
                "chat_link": "[&BIALAAA=]"
              },
              "2945": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  63808,
                  57323.1
                ],
                "id": 2945,
                "chat_link": "[&BIELAAA=]"
              },
              "2946": {
                "name": "Wurmmarshal's Encampment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65581.8,
                  59151.9
                ],
                "id": 2946,
                "chat_link": "[&BIILAAA=]"
              },
              "2947": {
                "name": "Soul's Vendetta Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  64761.5,
                  59142.4
                ],
                "id": 2947,
                "chat_link": "[&BIMLAAA=]"
              },
              "2951": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  66298.5,
                  57677.1
                ],
                "id": 2951,
                "chat_link": "[&BIcLAAA=]"
              },
              "2952": {
                "name": "Rilohn Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66545.6,
                  58255.8
                ],
                "id": 2952,
                "chat_link": "[&BIgLAAA=]"
              },
              "2953": {
                "name": "Confluence of the Elements",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66618.3,
                  59352.7
                ],
                "id": 2953,
                "chat_link": "[&BIkLAAA=]"
              },
              "2954": {
                "name": "Archon's Retreat",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66285.6,
                  57337
                ],
                "id": 2954,
                "chat_link": "[&BIoLAAA=]"
              },
              "2955": {
                "name": "Garrison Command",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65519,
                  58839
                ],
                "id": 2955,
                "chat_link": "[&BIsLAAA=]"
              },
              "2956": {
                "name": "Garrison Access Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65175.2,
                  58877.7
                ],
                "id": 2956,
                "chat_link": "[&BIwLAAA=]"
              },
              "2957": {
                "name": "Vanguard Ordinance",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64771.3,
                  59207.4
                ],
                "id": 2957,
                "chat_link": "[&BI0LAAA=]"
              },
              "2958": {
                "name": "Kormir's Reverence",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66364.8,
                  56702.1
                ],
                "id": 2958,
                "chat_link": "[&BI4LAAA=]"
              },
              "2959": {
                "name": "Mirza's Rest",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  63831.6,
                  57753.7
                ],
                "id": 2959,
                "chat_link": "[&BI8LAAA=]"
              },
              "2960": {
                "name": "Vanguard Salvage Yard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64677.9,
                  58947.8
                ],
                "id": 2960,
                "chat_link": "[&BJALAAA=]"
              },
              "2961": {
                "name": "Monument to the Return of Palawa Joko",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65476.6,
                  58044.4
                ],
                "id": 2961,
                "chat_link": "[&BJELAAA=]"
              },
              "2962": {
                "name": "Yatendi Farm",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66503.7,
                  58746.6
                ],
                "id": 2962,
                "chat_link": "[&BJILAAA=]"
              },
              "2963": {
                "name": "Venta Pass Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  63986.3,
                  57861
                ],
                "id": 2963,
                "chat_link": "[&BJMLAAA=]"
              },
              "2964": {
                "name": "Crystal Cavern",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  64884.1,
                  57923.3
                ],
                "id": 2964,
                "chat_link": "[&BJQLAAA=]"
              },
              "2966": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  66902,
                  58316.2
                ],
                "id": 2966,
                "chat_link": "[&BJYLAAA=]"
              },
              "2967": {
                "name": "Wyvern Roost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65352.5,
                  57030.1
                ],
                "id": 2967,
                "chat_link": "[&BJcLAAA=]"
              },
              "2968": {
                "name": "Crescent's Town Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  65870.9,
                  56800.9
                ],
                "id": 2968,
                "chat_link": "[&BJgLAAA=]"
              },
              "2969": {
                "name": "Reclaimed Chantry Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  66277.1,
                  56515.4
                ],
                "id": 2969,
                "chat_link": "[&BJkLAAA=]"
              }
            },
            "tasks": {
              "434": {
                "objective": "Start dialogs between the Elonian factions",
                "level": 80,
                "coord": [
                  66561.9,
                  56636.5
                ],
                "bounds": [
                  [
                    66146.6,
                    56938.8
                  ],
                  [
                    66105.2,
                    56863.8
                  ],
                  [
                    65947.3,
                    56596.8
                  ],
                  [
                    66086.1,
                    56545
                  ],
                  [
                    66221.5,
                    56427.9
                  ],
                  [
                    66397.2,
                    56400.3
                  ],
                  [
                    66657.8,
                    56401
                  ],
                  [
                    66710.9,
                    56474.4
                  ],
                  [
                    66780.3,
                    56533.7
                  ],
                  [
                    66796.8,
                    56614.3
                  ],
                  [
                    66828,
                    56657.5
                  ],
                  [
                    66907.8,
                    56666.2
                  ],
                  [
                    66884.4,
                    56917.3
                  ],
                  [
                    66592.1,
                    56890.4
                  ],
                  [
                    66419.5,
                    56974
                  ],
                  [
                    66146.6,
                    56938.8
                  ]
                ],
                "id": 434,
                "chat_link": "[&BLIBAAA=]"
              },
              "435": {
                "objective": "Prepare the Pact camp for battle.",
                "level": 80,
                "coord": [
                  64663.1,
                  59066.3
                ],
                "bounds": [
                  [
                    64987.1,
                    58748.8
                  ],
                  [
                    65144,
                    59110.8
                  ],
                  [
                    65207.8,
                    59607.5
                  ],
                  [
                    64528.8,
                    59613
                  ],
                  [
                    64421.9,
                    59625.3
                  ],
                  [
                    64374.9,
                    59034.4
                  ],
                  [
                    64406.3,
                    58849.5
                  ],
                  [
                    64446,
                    58688.3
                  ],
                  [
                    64987.1,
                    58748.8
                  ]
                ],
                "id": 435,
                "chat_link": "[&BLMBAAA=]"
              },
              "436": {
                "objective": "Help the people of Yatendi village.",
                "level": 80,
                "coord": [
                  66715.7,
                  58414.3
                ],
                "bounds": [
                  [
                    66102.4,
                    58323.8
                  ],
                  [
                    66253.4,
                    58846.9
                  ],
                  [
                    67089.4,
                    59070.3
                  ],
                  [
                    67368.8,
                    58747
                  ],
                  [
                    67212.9,
                    58465.7
                  ],
                  [
                    66876.4,
                    58094.1
                  ],
                  [
                    66102.4,
                    58323.8
                  ]
                ],
                "id": 436,
                "chat_link": "[&BLQBAAA=]"
              }
            },
            "skill_challenges": [],
            "sectors": {
              "1664": {
                "name": "???",
                "level": 80,
                "coord": [
                  65536.9,
                  57501.1
                ],
                "bounds": [
                  [
                    65372.1,
                    57439.1
                  ],
                  [
                    65451.9,
                    57300.2
                  ],
                  [
                    65530.3,
                    57279.2
                  ],
                  [
                    65616.5,
                    57323.8
                  ],
                  [
                    65670.7,
                    57402.3
                  ],
                  [
                    65741,
                    57487.7
                  ],
                  [
                    65731.6,
                    57588
                  ],
                  [
                    65687.8,
                    57659.2
                  ],
                  [
                    65593.6,
                    57654.8
                  ],
                  [
                    65381.5,
                    57699.3
                  ],
                  [
                    65345,
                    57646.1
                  ],
                  [
                    65321.2,
                    57534
                  ],
                  [
                    65372.1,
                    57439.1
                  ]
                ],
                "id": 1664,
                "chat_link": "[&BIAGAAA=]"
              },
              "1665": {
                "name": "Argon Garrison",
                "level": 80,
                "coord": [
                  65312.8,
                  58785.8
                ],
                "bounds": [
                  [
                    64995,
                    58614
                  ],
                  [
                    65158.2,
                    58562.6
                  ],
                  [
                    65321.9,
                    58536.1
                  ],
                  [
                    65662.8,
                    58577.9
                  ],
                  [
                    65841.1,
                    58935.7
                  ],
                  [
                    65399.7,
                    59197.6
                  ],
                  [
                    65139.8,
                    59114.6
                  ],
                  [
                    64983.8,
                    58748.1
                  ],
                  [
                    64995,
                    58614
                  ]
                ],
                "id": 1665,
                "chat_link": "[&BIEGAAA=]"
              },
              "1666": {
                "name": "Venta Pass",
                "level": 80,
                "coord": [
                  64498.7,
                  57764.6
                ],
                "bounds": [
                  [
                    63390.7,
                    57768
                  ],
                  [
                    63375.4,
                    57870.3
                  ],
                  [
                    63396.3,
                    58007.2
                  ],
                  [
                    63537,
                    58044
                  ],
                  [
                    63622.8,
                    58041.1
                  ],
                  [
                    63987.8,
                    58042.8
                  ],
                  [
                    64103.8,
                    58053.8
                  ],
                  [
                    64210.8,
                    58083.4
                  ],
                  [
                    64446.5,
                    58069.9
                  ],
                  [
                    64832.7,
                    57812.7
                  ],
                  [
                    64938.3,
                    57857.7
                  ],
                  [
                    65093.1,
                    57839.2
                  ],
                  [
                    65190.6,
                    57862.5
                  ],
                  [
                    65268.9,
                    57905.8
                  ],
                  [
                    65333.4,
                    57895.3
                  ],
                  [
                    65450.3,
                    57820
                  ],
                  [
                    65382.7,
                    57697.4
                  ],
                  [
                    65346.7,
                    57646.2
                  ],
                  [
                    65322.8,
                    57533.4
                  ],
                  [
                    65138.9,
                    57461.8
                  ],
                  [
                    64993.5,
                    57351.7
                  ],
                  [
                    64885.4,
                    57172.3
                  ],
                  [
                    64285.6,
                    57384.1
                  ],
                  [
                    64123.8,
                    57502.3
                  ],
                  [
                    63834.9,
                    57600.1
                  ],
                  [
                    63473.1,
                    57555.9
                  ],
                  [
                    63390.7,
                    57768
                  ]
                ],
                "id": 1666,
                "chat_link": "[&BIIGAAA=]"
              },
              "1667": {
                "name": "Wurmhaven",
                "level": 80,
                "coord": [
                  65666.7,
                  59255.6
                ],
                "bounds": [
                  [
                    66045.9,
                    59259
                  ],
                  [
                    66043.7,
                    59594.3
                  ],
                  [
                    65181.7,
                    59596.3
                  ],
                  [
                    65121.3,
                    59104
                  ],
                  [
                    65394.5,
                    59189.7
                  ],
                  [
                    65842.4,
                    58926.5
                  ],
                  [
                    66037.3,
                    59119.7
                  ],
                  [
                    66045.9,
                    59259
                  ]
                ],
                "id": 1667,
                "chat_link": "[&BIMGAAA=]"
              },
              "1668": {
                "name": "Sun's Refuge",
                "level": 80,
                "coord": [
                  63923.8,
                  58990.5
                ],
                "bounds": [
                  [
                    63617.3,
                    58516.5
                  ],
                  [
                    63694.1,
                    58559.8
                  ],
                  [
                    63748.5,
                    58664
                  ],
                  [
                    64454,
                    58758.5
                  ],
                  [
                    64406.9,
                    58871.4
                  ],
                  [
                    64378.6,
                    59035.8
                  ],
                  [
                    64423.8,
                    59631
                  ],
                  [
                    63879.7,
                    59583.4
                  ],
                  [
                    63604.8,
                    59266.7
                  ],
                  [
                    63510.1,
                    59112.6
                  ],
                  [
                    63444.4,
                    58895.8
                  ],
                  [
                    63617.3,
                    58516.5
                  ]
                ],
                "id": 1668,
                "chat_link": "[&BIQGAAA=]"
              },
              "1671": {
                "name": "Displaced Towers",
                "level": 80,
                "coord": [
                  65639.2,
                  57807.6
                ],
                "bounds": [
                  [
                    65380.2,
                    57695.9
                  ],
                  [
                    65596.6,
                    57647.9
                  ],
                  [
                    65688.5,
                    57654.5
                  ],
                  [
                    65760.6,
                    57689.1
                  ],
                  [
                    65801.4,
                    57779.7
                  ],
                  [
                    65784,
                    57863.3
                  ],
                  [
                    65708.2,
                    57972.5
                  ],
                  [
                    65640.1,
                    57986.9
                  ],
                  [
                    65584.1,
                    57965.3
                  ],
                  [
                    65448,
                    57821.3
                  ],
                  [
                    65380.2,
                    57695.9
                  ]
                ],
                "id": 1671,
                "chat_link": "[&BIcGAAA=]"
              },
              "1672": {
                "name": "Rilohn River",
                "level": 80,
                "coord": [
                  67085.7,
                  56872.3
                ],
                "bounds": [
                  [
                    67386.9,
                    56941.2
                  ],
                  [
                    67370.3,
                    56871.9
                  ],
                  [
                    67344.8,
                    56792.6
                  ],
                  [
                    67371.9,
                    56744.4
                  ],
                  [
                    67390.1,
                    56697.3
                  ],
                  [
                    67391.8,
                    56638.1
                  ],
                  [
                    67378,
                    56590.1
                  ],
                  [
                    67323.5,
                    56498
                  ],
                  [
                    67292.5,
                    56454.4
                  ],
                  [
                    67232.6,
                    56440.6
                  ],
                  [
                    67118.6,
                    56480.3
                  ],
                  [
                    66899.4,
                    56681.9
                  ],
                  [
                    66882.3,
                    56911.4
                  ],
                  [
                    66590.9,
                    56885
                  ],
                  [
                    66419.1,
                    56972.1
                  ],
                  [
                    66144.1,
                    56935.3
                  ],
                  [
                    66143.2,
                    57037.2
                  ],
                  [
                    67025.6,
                    57513
                  ],
                  [
                    67118.6,
                    57405.8
                  ],
                  [
                    67146.6,
                    57322.8
                  ],
                  [
                    67275.9,
                    57147.5
                  ],
                  [
                    67345,
                    57084.2
                  ],
                  [
                    67378.3,
                    57017.4
                  ],
                  [
                    67386.9,
                    56941.2
                  ]
                ],
                "id": 1672,
                "chat_link": "[&BIgGAAA=]"
              },
              "1673": {
                "name": "Pact Vanguard",
                "level": 80,
                "coord": [
                  64689.6,
                  59159.7
                ],
                "bounds": [
                  [
                    64987.1,
                    58748.8
                  ],
                  [
                    65144,
                    59110.8
                  ],
                  [
                    65207.8,
                    59607.5
                  ],
                  [
                    64528.8,
                    59613
                  ],
                  [
                    64421.9,
                    59625.3
                  ],
                  [
                    64374.9,
                    59034.4
                  ],
                  [
                    64406.3,
                    58849.5
                  ],
                  [
                    64446,
                    58688.3
                  ],
                  [
                    64987.1,
                    58748.8
                  ]
                ],
                "id": 1673,
                "chat_link": "[&BIkGAAA=]"
              },
              "1674": {
                "name": "Old Command Post",
                "level": 80,
                "coord": [
                  64107,
                  58293.8
                ],
                "bounds": [
                  [
                    63616.9,
                    58517.8
                  ],
                  [
                    63536.5,
                    58042.7
                  ],
                  [
                    63622.4,
                    58039.4
                  ],
                  [
                    64107.9,
                    58047.2
                  ],
                  [
                    64210.6,
                    58078.3
                  ],
                  [
                    64453.1,
                    58056.5
                  ],
                  [
                    64473,
                    58101.6
                  ],
                  [
                    64520,
                    58193.8
                  ],
                  [
                    64517.1,
                    58324.5
                  ],
                  [
                    64438.8,
                    58431.6
                  ],
                  [
                    64453.5,
                    58760.2
                  ],
                  [
                    63747.9,
                    58665.2
                  ],
                  [
                    63693.6,
                    58560.2
                  ],
                  [
                    63616.9,
                    58517.8
                  ]
                ],
                "id": 1674,
                "chat_link": "[&BIoGAAA=]"
              },
              "1675": {
                "name": "Jungle Anomaly",
                "level": 80,
                "coord": [
                  65243.8,
                  57076.6
                ],
                "bounds": [
                  [
                    65576,
                    57306
                  ],
                  [
                    65567.1,
                    56968.6
                  ],
                  [
                    65478,
                    56701.7
                  ],
                  [
                    65380.7,
                    56698.2
                  ],
                  [
                    65278.7,
                    56688.5
                  ],
                  [
                    65136.1,
                    56701.6
                  ],
                  [
                    64994,
                    56717.4
                  ],
                  [
                    64923.2,
                    56869.1
                  ],
                  [
                    64877.3,
                    57029.9
                  ],
                  [
                    64883.4,
                    57173.8
                  ],
                  [
                    64989.4,
                    57352.1
                  ],
                  [
                    65137.4,
                    57463.8
                  ],
                  [
                    65321.2,
                    57534.1
                  ],
                  [
                    65373.2,
                    57440.5
                  ],
                  [
                    65454.4,
                    57299.4
                  ],
                  [
                    65530.8,
                    57281.5
                  ],
                  [
                    65576,
                    57306
                  ]
                ],
                "id": 1675,
                "chat_link": "[&BIsGAAA=]"
              },
              "1676": {
                "name": "Ruined Procession",
                "level": 80,
                "coord": [
                  63738,
                  57097.9
                ],
                "bounds": [
                  [
                    63414.9,
                    57452.4
                  ],
                  [
                    63356.4,
                    57276
                  ],
                  [
                    63333.4,
                    57069.9
                  ],
                  [
                    63376.1,
                    56929.6
                  ],
                  [
                    63432.2,
                    56789.3
                  ],
                  [
                    63579.9,
                    56688.1
                  ],
                  [
                    63810.6,
                    56583.4
                  ],
                  [
                    64061.5,
                    56507.4
                  ],
                  [
                    63972.4,
                    56783.8
                  ],
                  [
                    63928.2,
                    57063.2
                  ],
                  [
                    64095.5,
                    57256.3
                  ],
                  [
                    64288.2,
                    57390.1
                  ],
                  [
                    64111,
                    57513
                  ],
                  [
                    63836.6,
                    57605.2
                  ],
                  [
                    63472.5,
                    57560.6
                  ],
                  [
                    63414.9,
                    57452.4
                  ]
                ],
                "id": 1676,
                "chat_link": "[&BIwGAAA=]"
              },
              "1677": {
                "name": "Crescent's Prosperity",
                "level": 80,
                "coord": [
                  65813,
                  57135.5
                ],
                "bounds": [
                  [
                    65948.2,
                    56596.8
                  ],
                  [
                    65787.2,
                    56628.6
                  ],
                  [
                    65580.1,
                    56659.4
                  ],
                  [
                    65474.9,
                    56703
                  ],
                  [
                    65561.8,
                    56971.5
                  ],
                  [
                    65572.4,
                    57309.1
                  ],
                  [
                    65615.4,
                    57328.6
                  ],
                  [
                    65735.1,
                    57492.3
                  ],
                  [
                    65726.6,
                    57586.8
                  ],
                  [
                    65683.4,
                    57658.6
                  ],
                  [
                    65753.5,
                    57696.3
                  ],
                  [
                    66061.6,
                    57504.6
                  ],
                  [
                    66103.6,
                    57198.4
                  ],
                  [
                    66147.8,
                    57032.8
                  ],
                  [
                    66149.6,
                    56937.6
                  ],
                  [
                    66106.1,
                    56864.3
                  ],
                  [
                    65948.2,
                    56596.8
                  ]
                ],
                "id": 1677,
                "chat_link": "[&BI0GAAA=]"
              },
              "1678": {
                "name": "Prosperity's Approach",
                "level": 80,
                "coord": [
                  65870.6,
                  57938.9
                ],
                "bounds": [
                  [
                    65754.6,
                    57687.7
                  ],
                  [
                    66067.9,
                    57491.3
                  ],
                  [
                    66147.8,
                    58482.9
                  ],
                  [
                    65834,
                    58295.1
                  ],
                  [
                    65709.3,
                    57971.5
                  ],
                  [
                    65782,
                    57862.9
                  ],
                  [
                    65798.4,
                    57781.1
                  ],
                  [
                    65754.6,
                    57687.7
                  ]
                ],
                "id": 1678,
                "chat_link": "[&BI4GAAA=]"
              },
              "1682": {
                "name": "Fortress of Jahai",
                "level": 80,
                "coord": [
                  66634.6,
                  57809.7
                ],
                "bounds": [
                  [
                    67026,
                    57506.3
                  ],
                  [
                    66820.9,
                    57594.7
                  ],
                  [
                    66696.7,
                    57686.7
                  ],
                  [
                    66665.1,
                    57751.9
                  ],
                  [
                    66687.3,
                    57833.6
                  ],
                  [
                    66769.7,
                    57902.9
                  ],
                  [
                    66855.5,
                    57899.4
                  ],
                  [
                    66916.1,
                    57934.8
                  ],
                  [
                    66952.6,
                    58000.8
                  ],
                  [
                    66927.9,
                    58107.5
                  ],
                  [
                    66923.2,
                    58196.9
                  ],
                  [
                    66470.3,
                    58341.9
                  ],
                  [
                    66139.6,
                    58476.6
                  ],
                  [
                    66058.5,
                    57492.1
                  ],
                  [
                    66099.1,
                    57195.4
                  ],
                  [
                    66144.6,
                    57034.3
                  ],
                  [
                    67026,
                    57506.3
                  ]
                ],
                "id": 1682,
                "chat_link": "[&BJIGAAA=]"
              },
              "1683": {
                "name": "Kodonur Temple",
                "level": 80,
                "coord": [
                  66436.2,
                  59270.3
                ],
                "bounds": [
                  [
                    66993.8,
                    59094.8
                  ],
                  [
                    66645.8,
                    59085.8
                  ],
                  [
                    66349.8,
                    58992
                  ],
                  [
                    66163.6,
                    58978.3
                  ],
                  [
                    66031.3,
                    59110.1
                  ],
                  [
                    66044.1,
                    59270.1
                  ],
                  [
                    66035.9,
                    59593
                  ],
                  [
                    66525,
                    59608.6
                  ],
                  [
                    66725.5,
                    59543.4
                  ],
                  [
                    66847.3,
                    59426.7
                  ],
                  [
                    66993.8,
                    59094.8
                  ]
                ],
                "id": 1683,
                "chat_link": "[&BJMGAAA=]"
              },
              "1684": {
                "name": "Jahai Keep",
                "level": 80,
                "coord": [
                  67003.7,
                  57920.1
                ],
                "bounds": [
                  [
                    67396,
                    57668.7
                  ],
                  [
                    67299.8,
                    57512.2
                  ],
                  [
                    67116,
                    57406.2
                  ],
                  [
                    67025.4,
                    57501.4
                  ],
                  [
                    66818.9,
                    57591.9
                  ],
                  [
                    66693.9,
                    57683.8
                  ],
                  [
                    66660.8,
                    57754.4
                  ],
                  [
                    66682.7,
                    57836.5
                  ],
                  [
                    66768.4,
                    57905.1
                  ],
                  [
                    66852.9,
                    57903.2
                  ],
                  [
                    66912.2,
                    57936.4
                  ],
                  [
                    66950.3,
                    57998.4
                  ],
                  [
                    66924.7,
                    58109.8
                  ],
                  [
                    66926.3,
                    58200.3
                  ],
                  [
                    67045.4,
                    58458.9
                  ],
                  [
                    67242.6,
                    58429.7
                  ],
                  [
                    67363.5,
                    58355.3
                  ],
                  [
                    67387,
                    58310.4
                  ],
                  [
                    67396,
                    57668.7
                  ]
                ],
                "id": 1684,
                "chat_link": "[&BJQGAAA=]"
              },
              "1685": {
                "name": "Central Brand Scar",
                "level": 80,
                "coord": [
                  65013.6,
                  58208.9
                ],
                "bounds": [
                  [
                    65659.4,
                    58586.7
                  ],
                  [
                    65322.7,
                    58541.1
                  ],
                  [
                    65161.8,
                    58566.9
                  ],
                  [
                    65001.1,
                    58618.8
                  ],
                  [
                    64989.3,
                    58753.7
                  ],
                  [
                    64445.4,
                    58691.7
                  ],
                  [
                    64442.1,
                    58509.3
                  ],
                  [
                    64437.2,
                    58429.4
                  ],
                  [
                    64511.8,
                    58327.5
                  ],
                  [
                    64517.8,
                    58194.8
                  ],
                  [
                    64438.7,
                    58050.2
                  ],
                  [
                    64828.3,
                    57812.4
                  ],
                  [
                    64937.5,
                    57856.1
                  ],
                  [
                    65092.8,
                    57837.5
                  ],
                  [
                    65191.4,
                    57862.1
                  ],
                  [
                    65268.9,
                    57903.7
                  ],
                  [
                    65336.1,
                    57891.6
                  ],
                  [
                    65458.8,
                    57810.1
                  ],
                  [
                    65588,
                    57959
                  ],
                  [
                    65643.3,
                    57975.1
                  ],
                  [
                    65659.4,
                    58586.7
                  ]
                ],
                "id": 1685,
                "chat_link": "[&BJUGAAA=]"
              },
              "1687": {
                "name": "Eastern Brand Scar",
                "level": 80,
                "coord": [
                  66143.4,
                  58663.4
                ],
                "bounds": [
                  [
                    65650.2,
                    58576
                  ],
                  [
                    65639.8,
                    57979.2
                  ],
                  [
                    65711.6,
                    57967.1
                  ],
                  [
                    65836.2,
                    58286.4
                  ],
                  [
                    66146.8,
                    58473.7
                  ],
                  [
                    66257.3,
                    58577.6
                  ],
                  [
                    66355.8,
                    58713.5
                  ],
                  [
                    66672.9,
                    58731.8
                  ],
                  [
                    66708,
                    58860.3
                  ],
                  [
                    66643.6,
                    59089.5
                  ],
                  [
                    66350,
                    58996.7
                  ],
                  [
                    66167.3,
                    58982.5
                  ],
                  [
                    66033.3,
                    59120.4
                  ],
                  [
                    65834.1,
                    58933.3
                  ],
                  [
                    65650.2,
                    58576
                  ]
                ],
                "id": 1687,
                "chat_link": "[&BJcGAAA=]"
              },
              "1688": {
                "name": "Reclaimed Chantry",
                "level": 80,
                "coord": [
                  66498.8,
                  56660.1
                ],
                "bounds": [
                  [
                    66146.6,
                    56938.8
                  ],
                  [
                    66105.2,
                    56863.8
                  ],
                  [
                    65947.3,
                    56596.8
                  ],
                  [
                    66086.1,
                    56545
                  ],
                  [
                    66221.5,
                    56427.9
                  ],
                  [
                    66397.2,
                    56400.3
                  ],
                  [
                    66657.8,
                    56401
                  ],
                  [
                    66710.9,
                    56474.4
                  ],
                  [
                    66780.3,
                    56533.7
                  ],
                  [
                    66796.8,
                    56614.3
                  ],
                  [
                    66828,
                    56657.5
                  ],
                  [
                    66907.8,
                    56666.2
                  ],
                  [
                    66884.4,
                    56917.3
                  ],
                  [
                    66592.1,
                    56890.4
                  ],
                  [
                    66419.5,
                    56974
                  ],
                  [
                    66146.6,
                    56938.8
                  ]
                ],
                "id": 1688,
                "chat_link": "[&BJgGAAA=]"
              },
              "1689": {
                "name": "Yatendi Village",
                "level": 80,
                "coord": [
                  66590.8,
                  58512.6
                ],
                "bounds": [
                  [
                    66142.4,
                    58467.4
                  ],
                  [
                    66252.1,
                    58577.4
                  ],
                  [
                    66355.6,
                    58712.3
                  ],
                  [
                    66677.3,
                    58736.3
                  ],
                  [
                    66862.8,
                    58626.8
                  ],
                  [
                    67047.5,
                    58457.4
                  ],
                  [
                    66925.1,
                    58182.8
                  ],
                  [
                    66463.7,
                    58340.4
                  ],
                  [
                    66142.4,
                    58467.4
                  ]
                ],
                "id": 1689,
                "chat_link": "[&BJkGAAA=]"
              },
              "1690": {
                "name": "Almorra's Stand",
                "level": 80,
                "coord": [
                  64494.3,
                  56785.4
                ],
                "bounds": [
                  [
                    64269.9,
                    57399.6
                  ],
                  [
                    64090.8,
                    57259.9
                  ],
                  [
                    63921.8,
                    57065.4
                  ],
                  [
                    63968.7,
                    56779.1
                  ],
                  [
                    64056.2,
                    56509
                  ],
                  [
                    64228.3,
                    56400.4
                  ],
                  [
                    64449.3,
                    56383
                  ],
                  [
                    64637.2,
                    56392.6
                  ],
                  [
                    64746.6,
                    56436.8
                  ],
                  [
                    64865.3,
                    56576.8
                  ],
                  [
                    64995.2,
                    56717.4
                  ],
                  [
                    64924.8,
                    56872.1
                  ],
                  [
                    64881,
                    57029.7
                  ],
                  [
                    64885.3,
                    57173.3
                  ],
                  [
                    64269.9,
                    57399.6
                  ]
                ],
                "id": 1690,
                "chat_link": "[&BJoGAAA=]"
              },
              "1691": {
                "name": "Shattered Cliffs",
                "level": 80,
                "coord": [
                  67027.4,
                  58762.7
                ],
                "bounds": [
                  [
                    66669.1,
                    58732.3
                  ],
                  [
                    66698.4,
                    58866.1
                  ],
                  [
                    66642.8,
                    59092
                  ],
                  [
                    66981.5,
                    59108.1
                  ],
                  [
                    67184.2,
                    59024.6
                  ],
                  [
                    67284.7,
                    58874.1
                  ],
                  [
                    67347.3,
                    58678.2
                  ],
                  [
                    67347.2,
                    58510.3
                  ],
                  [
                    67243,
                    58429.2
                  ],
                  [
                    67043.8,
                    58451.4
                  ],
                  [
                    66858.9,
                    58623
                  ],
                  [
                    66669.1,
                    58732.3
                  ]
                ],
                "id": 1691,
                "chat_link": "[&BJsGAAA=]"
              }
            },
            "adventures": [],
            "id": 1301,
            "mastery_points": [
              {
                "coord": [
                  64655.2,
                  57738.2
                ],
                "id": 440,
                "region": "Desert"
              },
              {
                "coord": [
                  66632.7,
                  57314.2
                ],
                "id": 437,
                "region": "Desert"
              },
              {
                "coord": [
                  66031.8,
                  57018.1
                ],
                "id": 444,
                "region": "Desert"
              },
              {
                "coord": [
                  66594.2,
                  58845.6
                ],
                "id": 443,
                "region": "Desert"
              },
              {
                "coord": [
                  65276,
                  58424.3
                ],
                "id": 439,
                "region": "Desert"
              }
            ]
          },
          "1302": {
            "name": "Storm Tracking",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              32768,
              16384
            ],
            "map_rect": [
              [
                -49152,
                -36864
              ],
              [
                49152,
                39936
              ]
            ],
            "continent_rect": [
              [
                63316,
                56376
              ],
              [
                67412,
                59576
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1664": {
                "name": "???",
                "level": 80,
                "coord": [
                  65536.9,
                  57501.1
                ],
                "bounds": [
                  [
                    65372.1,
                    57439.1
                  ],
                  [
                    65451.9,
                    57300.2
                  ],
                  [
                    65530.3,
                    57279.2
                  ],
                  [
                    65616.5,
                    57323.8
                  ],
                  [
                    65670.7,
                    57402.3
                  ],
                  [
                    65741,
                    57487.7
                  ],
                  [
                    65731.6,
                    57588
                  ],
                  [
                    65687.8,
                    57659.2
                  ],
                  [
                    65593.6,
                    57654.8
                  ],
                  [
                    65381.5,
                    57699.3
                  ],
                  [
                    65345,
                    57646.1
                  ],
                  [
                    65321.2,
                    57534
                  ],
                  [
                    65372.1,
                    57439.1
                  ]
                ],
                "id": 1664,
                "chat_link": "[&BIAGAAA=]"
              },
              "1665": {
                "name": "Argon Garrison",
                "level": 80,
                "coord": [
                  65312.8,
                  58785.8
                ],
                "bounds": [
                  [
                    64995,
                    58614
                  ],
                  [
                    65158.2,
                    58562.6
                  ],
                  [
                    65321.9,
                    58536.1
                  ],
                  [
                    65662.8,
                    58577.9
                  ],
                  [
                    65841.1,
                    58935.7
                  ],
                  [
                    65399.7,
                    59197.6
                  ],
                  [
                    65139.8,
                    59114.6
                  ],
                  [
                    64983.8,
                    58748.1
                  ],
                  [
                    64995,
                    58614
                  ]
                ],
                "id": 1665,
                "chat_link": "[&BIEGAAA=]"
              },
              "1666": {
                "name": "Venta Pass",
                "level": 80,
                "coord": [
                  64498.7,
                  57764.6
                ],
                "bounds": [
                  [
                    63390.7,
                    57768
                  ],
                  [
                    63375.4,
                    57870.3
                  ],
                  [
                    63396.3,
                    58007.2
                  ],
                  [
                    63537,
                    58044
                  ],
                  [
                    63622.8,
                    58041.1
                  ],
                  [
                    63987.8,
                    58042.8
                  ],
                  [
                    64103.8,
                    58053.8
                  ],
                  [
                    64210.8,
                    58083.4
                  ],
                  [
                    64446.5,
                    58069.9
                  ],
                  [
                    64832.7,
                    57812.7
                  ],
                  [
                    64938.3,
                    57857.7
                  ],
                  [
                    65093.1,
                    57839.2
                  ],
                  [
                    65190.6,
                    57862.5
                  ],
                  [
                    65268.9,
                    57905.8
                  ],
                  [
                    65333.4,
                    57895.3
                  ],
                  [
                    65450.3,
                    57820
                  ],
                  [
                    65382.7,
                    57697.4
                  ],
                  [
                    65346.7,
                    57646.2
                  ],
                  [
                    65322.8,
                    57533.4
                  ],
                  [
                    65138.9,
                    57461.8
                  ],
                  [
                    64993.5,
                    57351.7
                  ],
                  [
                    64885.4,
                    57172.3
                  ],
                  [
                    64285.6,
                    57384.1
                  ],
                  [
                    64123.8,
                    57502.3
                  ],
                  [
                    63834.9,
                    57600.1
                  ],
                  [
                    63473.1,
                    57555.9
                  ],
                  [
                    63390.7,
                    57768
                  ]
                ],
                "id": 1666,
                "chat_link": "[&BIIGAAA=]"
              },
              "1667": {
                "name": "Wurmhaven",
                "level": 80,
                "coord": [
                  65666.7,
                  59255.6
                ],
                "bounds": [
                  [
                    66045.9,
                    59259
                  ],
                  [
                    66043.7,
                    59594.3
                  ],
                  [
                    65181.7,
                    59596.3
                  ],
                  [
                    65121.3,
                    59104
                  ],
                  [
                    65394.5,
                    59189.7
                  ],
                  [
                    65842.4,
                    58926.5
                  ],
                  [
                    66037.3,
                    59119.7
                  ],
                  [
                    66045.9,
                    59259
                  ]
                ],
                "id": 1667,
                "chat_link": "[&BIMGAAA=]"
              },
              "1668": {
                "name": "Sun's Refuge",
                "level": 80,
                "coord": [
                  63923.8,
                  58990.5
                ],
                "bounds": [
                  [
                    63617.3,
                    58516.5
                  ],
                  [
                    63694.1,
                    58559.8
                  ],
                  [
                    63748.5,
                    58664
                  ],
                  [
                    64454,
                    58758.5
                  ],
                  [
                    64406.9,
                    58871.4
                  ],
                  [
                    64378.6,
                    59035.8
                  ],
                  [
                    64423.8,
                    59631
                  ],
                  [
                    63879.7,
                    59583.4
                  ],
                  [
                    63604.8,
                    59266.7
                  ],
                  [
                    63510.1,
                    59112.6
                  ],
                  [
                    63444.4,
                    58895.8
                  ],
                  [
                    63617.3,
                    58516.5
                  ]
                ],
                "id": 1668,
                "chat_link": "[&BIQGAAA=]"
              },
              "1671": {
                "name": "Displaced Towers",
                "level": 80,
                "coord": [
                  65639.2,
                  57807.6
                ],
                "bounds": [
                  [
                    65380.2,
                    57695.9
                  ],
                  [
                    65596.6,
                    57647.9
                  ],
                  [
                    65688.5,
                    57654.5
                  ],
                  [
                    65760.6,
                    57689.1
                  ],
                  [
                    65801.4,
                    57779.7
                  ],
                  [
                    65784,
                    57863.3
                  ],
                  [
                    65708.2,
                    57972.5
                  ],
                  [
                    65640.1,
                    57986.9
                  ],
                  [
                    65584.1,
                    57965.3
                  ],
                  [
                    65448,
                    57821.3
                  ],
                  [
                    65380.2,
                    57695.9
                  ]
                ],
                "id": 1671,
                "chat_link": "[&BIcGAAA=]"
              },
              "1673": {
                "name": "Pact Vanguard",
                "level": 80,
                "coord": [
                  64689.6,
                  59159.7
                ],
                "bounds": [
                  [
                    64987.1,
                    58748.8
                  ],
                  [
                    65144,
                    59110.8
                  ],
                  [
                    65207.8,
                    59607.5
                  ],
                  [
                    64528.8,
                    59613
                  ],
                  [
                    64421.9,
                    59625.3
                  ],
                  [
                    64374.9,
                    59034.4
                  ],
                  [
                    64406.3,
                    58849.5
                  ],
                  [
                    64446,
                    58688.3
                  ],
                  [
                    64987.1,
                    58748.8
                  ]
                ],
                "id": 1673,
                "chat_link": "[&BIkGAAA=]"
              },
              "1674": {
                "name": "Old Command Post",
                "level": 80,
                "coord": [
                  64107,
                  58293.8
                ],
                "bounds": [
                  [
                    63616.9,
                    58517.8
                  ],
                  [
                    63536.5,
                    58042.7
                  ],
                  [
                    63622.4,
                    58039.4
                  ],
                  [
                    64107.9,
                    58047.2
                  ],
                  [
                    64210.6,
                    58078.3
                  ],
                  [
                    64453.1,
                    58056.5
                  ],
                  [
                    64473,
                    58101.6
                  ],
                  [
                    64520,
                    58193.8
                  ],
                  [
                    64517.1,
                    58324.5
                  ],
                  [
                    64438.8,
                    58431.6
                  ],
                  [
                    64453.5,
                    58760.2
                  ],
                  [
                    63747.9,
                    58665.2
                  ],
                  [
                    63693.6,
                    58560.2
                  ],
                  [
                    63616.9,
                    58517.8
                  ]
                ],
                "id": 1674,
                "chat_link": "[&BIoGAAA=]"
              },
              "1675": {
                "name": "Jungle Anomaly",
                "level": 80,
                "coord": [
                  65243.8,
                  57076.6
                ],
                "bounds": [
                  [
                    65576,
                    57306
                  ],
                  [
                    65567.1,
                    56968.6
                  ],
                  [
                    65478,
                    56701.7
                  ],
                  [
                    65380.7,
                    56698.2
                  ],
                  [
                    65278.7,
                    56688.5
                  ],
                  [
                    65136.1,
                    56701.6
                  ],
                  [
                    64994,
                    56717.4
                  ],
                  [
                    64923.2,
                    56869.1
                  ],
                  [
                    64877.3,
                    57029.9
                  ],
                  [
                    64883.4,
                    57173.8
                  ],
                  [
                    64989.4,
                    57352.1
                  ],
                  [
                    65137.4,
                    57463.8
                  ],
                  [
                    65321.2,
                    57534.1
                  ],
                  [
                    65373.2,
                    57440.5
                  ],
                  [
                    65454.4,
                    57299.4
                  ],
                  [
                    65530.8,
                    57281.5
                  ],
                  [
                    65576,
                    57306
                  ]
                ],
                "id": 1675,
                "chat_link": "[&BIsGAAA=]"
              },
              "1676": {
                "name": "Ruined Procession",
                "level": 80,
                "coord": [
                  63738,
                  57097.9
                ],
                "bounds": [
                  [
                    63414.9,
                    57452.4
                  ],
                  [
                    63356.4,
                    57276
                  ],
                  [
                    63333.4,
                    57069.9
                  ],
                  [
                    63376.1,
                    56929.6
                  ],
                  [
                    63432.2,
                    56789.3
                  ],
                  [
                    63579.9,
                    56688.1
                  ],
                  [
                    63810.6,
                    56583.4
                  ],
                  [
                    64061.5,
                    56507.4
                  ],
                  [
                    63972.4,
                    56783.8
                  ],
                  [
                    63928.2,
                    57063.2
                  ],
                  [
                    64095.5,
                    57256.3
                  ],
                  [
                    64288.2,
                    57390.1
                  ],
                  [
                    64111,
                    57513
                  ],
                  [
                    63836.6,
                    57605.2
                  ],
                  [
                    63472.5,
                    57560.6
                  ],
                  [
                    63414.9,
                    57452.4
                  ]
                ],
                "id": 1676,
                "chat_link": "[&BIwGAAA=]"
              },
              "1677": {
                "name": "Crescent's Prosperity",
                "level": 80,
                "coord": [
                  65813,
                  57135.5
                ],
                "bounds": [
                  [
                    65948.2,
                    56596.8
                  ],
                  [
                    65787.2,
                    56628.6
                  ],
                  [
                    65580.1,
                    56659.4
                  ],
                  [
                    65474.9,
                    56703
                  ],
                  [
                    65561.8,
                    56971.5
                  ],
                  [
                    65572.4,
                    57309.1
                  ],
                  [
                    65615.4,
                    57328.6
                  ],
                  [
                    65735.1,
                    57492.3
                  ],
                  [
                    65726.6,
                    57586.8
                  ],
                  [
                    65683.4,
                    57658.6
                  ],
                  [
                    65753.5,
                    57696.3
                  ],
                  [
                    66061.6,
                    57504.6
                  ],
                  [
                    66103.6,
                    57198.4
                  ],
                  [
                    66147.8,
                    57032.8
                  ],
                  [
                    66149.6,
                    56937.6
                  ],
                  [
                    66106.1,
                    56864.3
                  ],
                  [
                    65948.2,
                    56596.8
                  ]
                ],
                "id": 1677,
                "chat_link": "[&BI0GAAA=]"
              },
              "1682": {
                "name": "Fortress of Jahai",
                "level": 80,
                "coord": [
                  66634.6,
                  57809.7
                ],
                "bounds": [
                  [
                    67026,
                    57506.3
                  ],
                  [
                    66820.9,
                    57594.7
                  ],
                  [
                    66696.7,
                    57686.7
                  ],
                  [
                    66665.1,
                    57751.9
                  ],
                  [
                    66687.3,
                    57833.6
                  ],
                  [
                    66769.7,
                    57902.9
                  ],
                  [
                    66855.5,
                    57899.4
                  ],
                  [
                    66916.1,
                    57934.8
                  ],
                  [
                    66952.6,
                    58000.8
                  ],
                  [
                    66927.9,
                    58107.5
                  ],
                  [
                    66923.2,
                    58196.9
                  ],
                  [
                    66470.3,
                    58341.9
                  ],
                  [
                    66139.6,
                    58476.6
                  ],
                  [
                    66058.5,
                    57492.1
                  ],
                  [
                    66099.1,
                    57195.4
                  ],
                  [
                    66144.6,
                    57034.3
                  ],
                  [
                    67026,
                    57506.3
                  ]
                ],
                "id": 1682,
                "chat_link": "[&BJIGAAA=]"
              },
              "1683": {
                "name": "Kodonur Temple",
                "level": 80,
                "coord": [
                  66436.2,
                  59270.3
                ],
                "bounds": [
                  [
                    66993.8,
                    59094.8
                  ],
                  [
                    66645.8,
                    59085.8
                  ],
                  [
                    66349.8,
                    58992
                  ],
                  [
                    66163.6,
                    58978.3
                  ],
                  [
                    66031.3,
                    59110.1
                  ],
                  [
                    66044.1,
                    59270.1
                  ],
                  [
                    66035.9,
                    59593
                  ],
                  [
                    66525,
                    59608.6
                  ],
                  [
                    66725.5,
                    59543.4
                  ],
                  [
                    66847.3,
                    59426.7
                  ],
                  [
                    66993.8,
                    59094.8
                  ]
                ],
                "id": 1683,
                "chat_link": "[&BJMGAAA=]"
              },
              "1684": {
                "name": "Jahai Keep",
                "level": 80,
                "coord": [
                  67003.7,
                  57920.1
                ],
                "bounds": [
                  [
                    67396,
                    57668.7
                  ],
                  [
                    67299.8,
                    57512.2
                  ],
                  [
                    67116,
                    57406.2
                  ],
                  [
                    67025.4,
                    57501.4
                  ],
                  [
                    66818.9,
                    57591.9
                  ],
                  [
                    66693.9,
                    57683.8
                  ],
                  [
                    66660.8,
                    57754.4
                  ],
                  [
                    66682.7,
                    57836.5
                  ],
                  [
                    66768.4,
                    57905.1
                  ],
                  [
                    66852.9,
                    57903.2
                  ],
                  [
                    66912.2,
                    57936.4
                  ],
                  [
                    66950.3,
                    57998.4
                  ],
                  [
                    66924.7,
                    58109.8
                  ],
                  [
                    66926.3,
                    58200.3
                  ],
                  [
                    67045.4,
                    58458.9
                  ],
                  [
                    67242.6,
                    58429.7
                  ],
                  [
                    67363.5,
                    58355.3
                  ],
                  [
                    67387,
                    58310.4
                  ],
                  [
                    67396,
                    57668.7
                  ]
                ],
                "id": 1684,
                "chat_link": "[&BJQGAAA=]"
              },
              "1685": {
                "name": "Central Brand Scar",
                "level": 80,
                "coord": [
                  65013.6,
                  58208.9
                ],
                "bounds": [
                  [
                    65659.4,
                    58586.7
                  ],
                  [
                    65322.7,
                    58541.1
                  ],
                  [
                    65161.8,
                    58566.9
                  ],
                  [
                    65001.1,
                    58618.8
                  ],
                  [
                    64989.3,
                    58753.7
                  ],
                  [
                    64445.4,
                    58691.7
                  ],
                  [
                    64442.1,
                    58509.3
                  ],
                  [
                    64437.2,
                    58429.4
                  ],
                  [
                    64511.8,
                    58327.5
                  ],
                  [
                    64517.8,
                    58194.8
                  ],
                  [
                    64438.7,
                    58050.2
                  ],
                  [
                    64828.3,
                    57812.4
                  ],
                  [
                    64937.5,
                    57856.1
                  ],
                  [
                    65092.8,
                    57837.5
                  ],
                  [
                    65191.4,
                    57862.1
                  ],
                  [
                    65268.9,
                    57903.7
                  ],
                  [
                    65336.1,
                    57891.6
                  ],
                  [
                    65458.8,
                    57810.1
                  ],
                  [
                    65588,
                    57959
                  ],
                  [
                    65643.3,
                    57975.1
                  ],
                  [
                    65659.4,
                    58586.7
                  ]
                ],
                "id": 1685,
                "chat_link": "[&BJUGAAA=]"
              },
              "1687": {
                "name": "Eastern Brand Scar",
                "level": 80,
                "coord": [
                  66143.4,
                  58663.4
                ],
                "bounds": [
                  [
                    65650.2,
                    58576
                  ],
                  [
                    65639.8,
                    57979.2
                  ],
                  [
                    65711.6,
                    57967.1
                  ],
                  [
                    65836.2,
                    58286.4
                  ],
                  [
                    66146.8,
                    58473.7
                  ],
                  [
                    66257.3,
                    58577.6
                  ],
                  [
                    66355.8,
                    58713.5
                  ],
                  [
                    66672.9,
                    58731.8
                  ],
                  [
                    66708,
                    58860.3
                  ],
                  [
                    66643.6,
                    59089.5
                  ],
                  [
                    66350,
                    58996.7
                  ],
                  [
                    66167.3,
                    58982.5
                  ],
                  [
                    66033.3,
                    59120.4
                  ],
                  [
                    65834.1,
                    58933.3
                  ],
                  [
                    65650.2,
                    58576
                  ]
                ],
                "id": 1687,
                "chat_link": "[&BJcGAAA=]"
              },
              "1688": {
                "name": "Reclaimed Chantry",
                "level": 80,
                "coord": [
                  66498.8,
                  56660.1
                ],
                "bounds": [
                  [
                    66146.6,
                    56938.8
                  ],
                  [
                    66105.2,
                    56863.8
                  ],
                  [
                    65947.3,
                    56596.8
                  ],
                  [
                    66086.1,
                    56545
                  ],
                  [
                    66221.5,
                    56427.9
                  ],
                  [
                    66397.2,
                    56400.3
                  ],
                  [
                    66657.8,
                    56401
                  ],
                  [
                    66710.9,
                    56474.4
                  ],
                  [
                    66780.3,
                    56533.7
                  ],
                  [
                    66796.8,
                    56614.3
                  ],
                  [
                    66828,
                    56657.5
                  ],
                  [
                    66907.8,
                    56666.2
                  ],
                  [
                    66884.4,
                    56917.3
                  ],
                  [
                    66592.1,
                    56890.4
                  ],
                  [
                    66419.5,
                    56974
                  ],
                  [
                    66146.6,
                    56938.8
                  ]
                ],
                "id": 1688,
                "chat_link": "[&BJgGAAA=]"
              },
              "1689": {
                "name": "Yatendi Village",
                "level": 80,
                "coord": [
                  66590.8,
                  58512.6
                ],
                "bounds": [
                  [
                    66142.4,
                    58467.4
                  ],
                  [
                    66252.1,
                    58577.4
                  ],
                  [
                    66355.6,
                    58712.3
                  ],
                  [
                    66677.3,
                    58736.3
                  ],
                  [
                    66862.8,
                    58626.8
                  ],
                  [
                    67047.5,
                    58457.4
                  ],
                  [
                    66925.1,
                    58182.8
                  ],
                  [
                    66463.7,
                    58340.4
                  ],
                  [
                    66142.4,
                    58467.4
                  ]
                ],
                "id": 1689,
                "chat_link": "[&BJkGAAA=]"
              },
              "1690": {
                "name": "Almorra's Stand",
                "level": 80,
                "coord": [
                  64494.3,
                  56785.4
                ],
                "bounds": [
                  [
                    64269.9,
                    57399.6
                  ],
                  [
                    64090.8,
                    57259.9
                  ],
                  [
                    63921.8,
                    57065.4
                  ],
                  [
                    63968.7,
                    56779.1
                  ],
                  [
                    64056.2,
                    56509
                  ],
                  [
                    64228.3,
                    56400.4
                  ],
                  [
                    64449.3,
                    56383
                  ],
                  [
                    64637.2,
                    56392.6
                  ],
                  [
                    64746.6,
                    56436.8
                  ],
                  [
                    64865.3,
                    56576.8
                  ],
                  [
                    64995.2,
                    56717.4
                  ],
                  [
                    64924.8,
                    56872.1
                  ],
                  [
                    64881,
                    57029.7
                  ],
                  [
                    64885.3,
                    57173.3
                  ],
                  [
                    64269.9,
                    57399.6
                  ]
                ],
                "id": 1690,
                "chat_link": "[&BJoGAAA=]"
              }
            },
            "adventures": [],
            "id": 1302,
            "mastery_points": []
          },
          "1317": {
            "name": "Dragonfall",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45638,
              49589
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                43968,
                48384
              ],
              [
                47424,
                51200
              ]
            ],
            "points_of_interest": {
              "3017": {
                "name": "Mist Warden Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46625.5,
                  50752.4
                ],
                "id": 3017,
                "chat_link": "[&BMkLAAA=]"
              },
              "3018": {
                "name": "Crystal Cudgel",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46039.6,
                  48694.3
                ],
                "id": 3018,
                "chat_link": "[&BMoLAAA=]"
              },
              "3019": {
                "name": "Olmakhan Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44896.5,
                  50446.8
                ],
                "id": 3019,
                "chat_link": "[&BMsLAAA=]"
              },
              "3020": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  46309.6,
                  49426.7
                ],
                "id": 3020,
                "chat_link": "[&BMwLAAA=]"
              },
              "3021": {
                "name": "Tower of the Third",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  47038.4,
                  50437.4
                ],
                "id": 3021,
                "chat_link": "[&BM0LAAA=]"
              },
              "3022": {
                "name": "Shackled Grasp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45351.8,
                  50112
                ],
                "id": 3022,
                "chat_link": "[&BM4LAAA=]"
              },
              "3023": {
                "name": "Skyscale Eyrie",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45134.5,
                  50965.3
                ],
                "id": 3023,
                "chat_link": "[&BM8LAAA=]"
              },
              "3024": {
                "name": "Grenth's Respite",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45491.8,
                  50808.3
                ],
                "id": 3024,
                "chat_link": "[&BNALAAA=]"
              },
              "3025": {
                "name": "The Underworld Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44863.7,
                  50382
                ],
                "id": 3025,
                "chat_link": "[&BNELAAA=]"
              },
              "3026": {
                "name": "Melandru's Lost Domain Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46579,
                  50768.9
                ],
                "id": 3026,
                "chat_link": "[&BNILAAA=]"
              },
              "3027": {
                "name": "Charnel Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46560.5,
                  48915.9
                ],
                "id": 3027,
                "chat_link": "[&BNMLAAA=]"
              },
              "3028": {
                "name": "Chaos Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44896.2,
                  49965.5
                ],
                "id": 3028,
                "chat_link": "[&BNQLAAA=]"
              },
              "3029": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  46758.4,
                  48817.9
                ],
                "id": 3029,
                "chat_link": "[&BNULAAA=]"
              },
              "3030": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  46844.8,
                  50313.1
                ],
                "id": 3030,
                "chat_link": "[&BNYLAAA=]"
              },
              "3032": {
                "name": "Balthazar's Folly",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44077.8,
                  49023
                ],
                "id": 3032,
                "chat_link": "[&BNgLAAA=]"
              },
              "3033": {
                "name": "Pact Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46783,
                  48753.2
                ],
                "id": 3033,
                "chat_link": "[&BNkLAAA=]"
              },
              "3034": {
                "name": "Crystal Bloom Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44421.9,
                  48964.6
                ],
                "id": 3034,
                "chat_link": "[&BNoLAAA=]"
              },
              "3035": {
                "name": "Loathsome Pulpit",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44318.2,
                  50896.4
                ],
                "id": 3035,
                "chat_link": "[&BNsLAAA=]"
              },
              "3036": {
                "name": "Ashen Steppes",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44690.2,
                  48846.7
                ],
                "id": 3036,
                "chat_link": "[&BNwLAAA=]"
              },
              "3037": {
                "name": "Wailing Basin",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44436.2,
                  50184.6
                ],
                "id": 3037,
                "chat_link": "[&BN0LAAA=]"
              },
              "3038": {
                "name": "Pact Command Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  46814,
                  48720
                ],
                "id": 3038,
                "chat_link": "[&BN4LAAA=]"
              },
              "3039": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  44860.5,
                  50817.3
                ],
                "id": 3039,
                "chat_link": "[&BN8LAAA=]"
              },
              "3040": {
                "name": "Verdance Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46972.4,
                  50212
                ],
                "id": 3040,
                "chat_link": "[&BOALAAA=]"
              },
              "3041": {
                "name": "Trail of Cinder",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  45546,
                  48869
                ],
                "id": 3041,
                "chat_link": "[&BOELAAA=]"
              },
              "3042": {
                "name": "Fire God's Precipice",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  44443.7,
                  49392.2
                ],
                "id": 3042,
                "chat_link": "[&BOILAAA=]"
              },
              "3043": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  46251.1,
                  50601.3
                ],
                "id": 3043,
                "chat_link": "[&BOMLAAA=]"
              },
              "3044": {
                "name": "Airdrome Port",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46879.5,
                  48565.9
                ],
                "id": 3044,
                "chat_link": "[&BOQLAAA=]"
              },
              "3045": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  44421.7,
                  49793.6
                ],
                "id": 3045,
                "chat_link": "[&BOULAAA=]"
              },
              "3046": {
                "name": "Burning Forest Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  44341.9,
                  48961.8
                ],
                "id": 3046,
                "chat_link": "[&BOYLAAA=]"
              },
              "3047": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  44809.1,
                  48665.3
                ],
                "id": 3047,
                "chat_link": "[&BOcLAAA=]"
              },
              "3048": {
                "name": "Verdant Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46807.9,
                  49013.7
                ],
                "id": 3048,
                "chat_link": "[&BOgLAAA=]"
              },
              "3049": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  45724.6,
                  48972
                ],
                "id": 3049,
                "chat_link": "[&BOkLAAA=]"
              },
              "3050": {
                "name": "Ember Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46485.4,
                  48705.8
                ],
                "id": 3050,
                "chat_link": "[&BOoLAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1715": {
                "name": "Mist Warden Camp",
                "level": 80,
                "coord": [
                  46687.5,
                  50864.8
                ],
                "bounds": [
                  [
                    46623.6,
                    50622.4
                  ],
                  [
                    46743.5,
                    50615.3
                  ],
                  [
                    46818.2,
                    50687.5
                  ],
                  [
                    46846.6,
                    50773.1
                  ],
                  [
                    46863,
                    50911.7
                  ],
                  [
                    46886.8,
                    51133.6
                  ],
                  [
                    46830.4,
                    51144.4
                  ],
                  [
                    46750.9,
                    51149.9
                  ],
                  [
                    46600.8,
                    51131
                  ],
                  [
                    46548,
                    50976.2
                  ],
                  [
                    46528.7,
                    50834.6
                  ],
                  [
                    46515.4,
                    50775.3
                  ],
                  [
                    46520.7,
                    50705.6
                  ],
                  [
                    46548.8,
                    50647.2
                  ],
                  [
                    46623.6,
                    50622.4
                  ]
                ],
                "id": 1715,
                "chat_link": "[&BLMGAAA=]"
              },
              "1716": {
                "name": "Umbral Battlegrounds",
                "level": 80,
                "coord": [
                  45510.3,
                  48795.9
                ],
                "bounds": [
                  [
                    45244.3,
                    49310.6
                  ],
                  [
                    45216.2,
                    49199.3
                  ],
                  [
                    45200.8,
                    48903.3
                  ],
                  [
                    45234.5,
                    48772
                  ],
                  [
                    45240.9,
                    48656.8
                  ],
                  [
                    45268.3,
                    48595.5
                  ],
                  [
                    45312.1,
                    48566.5
                  ],
                  [
                    45333.9,
                    48434.3
                  ],
                  [
                    45374.3,
                    48418.2
                  ],
                  [
                    45576,
                    48433.5
                  ],
                  [
                    45635.1,
                    48455.1
                  ],
                  [
                    45698,
                    48488.5
                  ],
                  [
                    45811.3,
                    48524.7
                  ],
                  [
                    45788.2,
                    48594.5
                  ],
                  [
                    45768.1,
                    48690
                  ],
                  [
                    45755.9,
                    48843
                  ],
                  [
                    45792.5,
                    48969.5
                  ],
                  [
                    45681.3,
                    49150.2
                  ],
                  [
                    45651.3,
                    49197.3
                  ],
                  [
                    45657.6,
                    49226
                  ],
                  [
                    45476.6,
                    49284.2
                  ],
                  [
                    45244.3,
                    49310.6
                  ]
                ],
                "id": 1716,
                "chat_link": "[&BLQGAAA=]"
              },
              "1718": {
                "name": "Olmakhan Camp",
                "level": 80,
                "coord": [
                  44928.4,
                  50424
                ],
                "bounds": [
                  [
                    44817.8,
                    50253.3
                  ],
                  [
                    44862.7,
                    50242.3
                  ],
                  [
                    44935.6,
                    50244.9
                  ],
                  [
                    45060.6,
                    50226.3
                  ],
                  [
                    45116.6,
                    50235.8
                  ],
                  [
                    45147.2,
                    50291.2
                  ],
                  [
                    45121.7,
                    50347.1
                  ],
                  [
                    45126.6,
                    50413.3
                  ],
                  [
                    45113,
                    50501.9
                  ],
                  [
                    45083.3,
                    50588.1
                  ],
                  [
                    45028.8,
                    50616.5
                  ],
                  [
                    44980,
                    50645.1
                  ],
                  [
                    44870.9,
                    50658.7
                  ],
                  [
                    44818.8,
                    50635.4
                  ],
                  [
                    44766.6,
                    50562.2
                  ],
                  [
                    44744,
                    50516.2
                  ],
                  [
                    44740.9,
                    50467.3
                  ],
                  [
                    44736.2,
                    50418.7
                  ],
                  [
                    44734.3,
                    50340.2
                  ],
                  [
                    44762,
                    50276
                  ],
                  [
                    44817.8,
                    50253.3
                  ]
                ],
                "id": 1718,
                "chat_link": "[&BLYGAAA=]"
              },
              "1719": {
                "name": "Dragon's Causeway",
                "level": 80,
                "coord": [
                  46061,
                  48909.8
                ],
                "bounds": [
                  [
                    45788.2,
                    48594.5
                  ],
                  [
                    45811.3,
                    48524.7
                  ],
                  [
                    45900.9,
                    48497.2
                  ],
                  [
                    45983.6,
                    48457.4
                  ],
                  [
                    46079.8,
                    48433.7
                  ],
                  [
                    46232.8,
                    48380.3
                  ],
                  [
                    46501.6,
                    48468.3
                  ],
                  [
                    46408.8,
                    48631.3
                  ],
                  [
                    46417.1,
                    48744.5
                  ],
                  [
                    46393.5,
                    48790.3
                  ],
                  [
                    46410.6,
                    48872.1
                  ],
                  [
                    46491.1,
                    49030.3
                  ],
                  [
                    46458.1,
                    49058.3
                  ],
                  [
                    46334.5,
                    49098.3
                  ],
                  [
                    46241.3,
                    49182.4
                  ],
                  [
                    46160.5,
                    49252.9
                  ],
                  [
                    46102.3,
                    49261.3
                  ],
                  [
                    46048.5,
                    49278
                  ],
                  [
                    45974.4,
                    49317.6
                  ],
                  [
                    45882.9,
                    49320.9
                  ],
                  [
                    45719.8,
                    49294.9
                  ],
                  [
                    45657.6,
                    49226
                  ],
                  [
                    45651.3,
                    49197.3
                  ],
                  [
                    45681.3,
                    49150.2
                  ],
                  [
                    45792.5,
                    48969.5
                  ],
                  [
                    45755.9,
                    48843
                  ],
                  [
                    45768.1,
                    48690
                  ],
                  [
                    45788.2,
                    48594.5
                  ]
                ],
                "id": 1719,
                "chat_link": "[&BLcGAAA=]"
              },
              "1723": {
                "name": "Crystal Bloom Camp",
                "level": 80,
                "coord": [
                  44256.8,
                  49041.9
                ],
                "bounds": [
                  [
                    44550,
                    49028.9
                  ],
                  [
                    44536.5,
                    49241.7
                  ],
                  [
                    44467.2,
                    49253.3
                  ],
                  [
                    44396.7,
                    49254.9
                  ],
                  [
                    44149.8,
                    49253.5
                  ],
                  [
                    44012.9,
                    49231.8
                  ],
                  [
                    43996.3,
                    49178.5
                  ],
                  [
                    44001.2,
                    49068.6
                  ],
                  [
                    44011.6,
                    49007.9
                  ],
                  [
                    44023,
                    48950.4
                  ],
                  [
                    44037.8,
                    48904.1
                  ],
                  [
                    44176.5,
                    48881.1
                  ],
                  [
                    44279.2,
                    48834.7
                  ],
                  [
                    44410.4,
                    48790.6
                  ],
                  [
                    44507.8,
                    48850.2
                  ],
                  [
                    44552.2,
                    48940.8
                  ],
                  [
                    44550,
                    49028.9
                  ]
                ],
                "id": 1723,
                "chat_link": "[&BLsGAAA=]"
              },
              "1725": {
                "name": "Pact Command",
                "level": 80,
                "coord": [
                  46849.1,
                  48825.1
                ],
                "bounds": [
                  [
                    46582.5,
                    49255.7
                  ],
                  [
                    46531.4,
                    49126.7
                  ],
                  [
                    46491.1,
                    49030.3
                  ],
                  [
                    46410.6,
                    48872.1
                  ],
                  [
                    46393.5,
                    48790.3
                  ],
                  [
                    46417.1,
                    48744.5
                  ],
                  [
                    46408.8,
                    48631.3
                  ],
                  [
                    46501.6,
                    48468.3
                  ],
                  [
                    46601.3,
                    48485.3
                  ],
                  [
                    46673.7,
                    48474
                  ],
                  [
                    46724.5,
                    48495.1
                  ],
                  [
                    46820.7,
                    48483.9
                  ],
                  [
                    46870.7,
                    48488.1
                  ],
                  [
                    46927.9,
                    48472.2
                  ],
                  [
                    47046.8,
                    48462.6
                  ],
                  [
                    47143.3,
                    48487.4
                  ],
                  [
                    47239.7,
                    48547.2
                  ],
                  [
                    47263.5,
                    48588.8
                  ],
                  [
                    47306.5,
                    48676.2
                  ],
                  [
                    47342.6,
                    48791.9
                  ],
                  [
                    47370,
                    49022.7
                  ],
                  [
                    47351.7,
                    49132.2
                  ],
                  [
                    47208.6,
                    49067.9
                  ],
                  [
                    47040,
                    49045.9
                  ],
                  [
                    46948.1,
                    49202
                  ],
                  [
                    46886.5,
                    49268.2
                  ],
                  [
                    46809.3,
                    49296.1
                  ],
                  [
                    46685,
                    49263.8
                  ],
                  [
                    46627.5,
                    49256.9
                  ],
                  [
                    46582.5,
                    49255.7
                  ]
                ],
                "id": 1725,
                "chat_link": "[&BL0GAAA=]"
              },
              "1726": {
                "name": "Virulent Wastes",
                "level": 80,
                "coord": [
                  44893.9,
                  49174.8
                ],
                "bounds": [
                  [
                    44734.9,
                    49482.1
                  ],
                  [
                    44849.8,
                    49440.6
                  ],
                  [
                    44993.2,
                    49409.5
                  ],
                  [
                    45123.1,
                    49473.2
                  ],
                  [
                    45152.5,
                    49556.3
                  ],
                  [
                    45208.8,
                    49483.3
                  ],
                  [
                    45245.4,
                    49451.4
                  ],
                  [
                    45266.8,
                    49388.2
                  ],
                  [
                    45244.3,
                    49310.6
                  ],
                  [
                    45216.2,
                    49199.3
                  ],
                  [
                    45200.8,
                    48903.3
                  ],
                  [
                    45077.8,
                    48911.2
                  ],
                  [
                    45022.1,
                    48896
                  ],
                  [
                    44971.1,
                    48870.7
                  ],
                  [
                    44899.4,
                    48880.3
                  ],
                  [
                    44793.5,
                    48847.1
                  ],
                  [
                    44680.2,
                    48833.2
                  ],
                  [
                    44593.9,
                    48797.3
                  ],
                  [
                    44507.8,
                    48850.2
                  ],
                  [
                    44552.2,
                    48940.8
                  ],
                  [
                    44550,
                    49028.9
                  ],
                  [
                    44536.5,
                    49241.7
                  ],
                  [
                    44627.5,
                    49319.4
                  ],
                  [
                    44646.3,
                    49397
                  ],
                  [
                    44652.2,
                    49457.7
                  ],
                  [
                    44734.9,
                    49482.1
                  ]
                ],
                "id": 1726,
                "chat_link": "[&BL4GAAA=]"
              },
              "1727": {
                "name": "Crystal Wing",
                "level": 80,
                "coord": [
                  47276.5,
                  49866.7
                ],
                "bounds": [
                  [
                    47382.9,
                    50271.7
                  ],
                  [
                    47342.9,
                    50276.9
                  ],
                  [
                    47256.3,
                    50221.5
                  ],
                  [
                    47148.7,
                    50081.5
                  ],
                  [
                    47146.8,
                    49482.9
                  ],
                  [
                    47205.2,
                    49429.3
                  ],
                  [
                    47253.9,
                    49405.5
                  ],
                  [
                    47366.3,
                    49393.8
                  ],
                  [
                    47385.7,
                    50237.6
                  ],
                  [
                    47382.9,
                    50271.7
                  ]
                ],
                "id": 1727,
                "chat_link": "[&BL8GAAA=]"
              },
              "1728": {
                "name": "Scorched Cliffs",
                "level": 80,
                "coord": [
                  44732.1,
                  48674.3
                ],
                "bounds": [
                  [
                    45268.3,
                    48595.5
                  ],
                  [
                    45312.1,
                    48566.5
                  ],
                  [
                    45333.9,
                    48434.3
                  ],
                  [
                    45192.6,
                    48427.5
                  ],
                  [
                    45066.3,
                    48438.5
                  ],
                  [
                    44942.4,
                    48426.2
                  ],
                  [
                    44821.6,
                    48430.7
                  ],
                  [
                    44715.8,
                    48434
                  ],
                  [
                    44596.4,
                    48453.1
                  ],
                  [
                    44515.3,
                    48441.9
                  ],
                  [
                    44438.1,
                    48464.5
                  ],
                  [
                    44368.6,
                    48435.6
                  ],
                  [
                    44261.5,
                    48473.7
                  ],
                  [
                    44017.6,
                    48751.8
                  ],
                  [
                    43986,
                    48827.4
                  ],
                  [
                    44037.8,
                    48904.1
                  ],
                  [
                    44176.5,
                    48881.1
                  ],
                  [
                    44279.2,
                    48834.7
                  ],
                  [
                    44410.4,
                    48790.6
                  ],
                  [
                    44507.8,
                    48850.2
                  ],
                  [
                    44593.9,
                    48797.3
                  ],
                  [
                    44680.2,
                    48833.2
                  ],
                  [
                    44793.5,
                    48847.1
                  ],
                  [
                    44899.4,
                    48880.3
                  ],
                  [
                    44971.1,
                    48870.7
                  ],
                  [
                    45022.1,
                    48896
                  ],
                  [
                    45077.8,
                    48911.2
                  ],
                  [
                    45200.8,
                    48903.3
                  ],
                  [
                    45234.5,
                    48772
                  ],
                  [
                    45240.9,
                    48656.8
                  ],
                  [
                    45268.3,
                    48595.5
                  ]
                ],
                "id": 1728,
                "chat_link": "[&BMAGAAA=]"
              },
              "1729": {
                "name": "Mosswood",
                "level": 80,
                "coord": [
                  46344.2,
                  50596.2
                ],
                "bounds": [
                  [
                    46601.2,
                    51130.9
                  ],
                  [
                    46530,
                    51122.6
                  ],
                  [
                    46487.4,
                    51130
                  ],
                  [
                    46420.4,
                    51131.4
                  ],
                  [
                    46369.2,
                    51122.9
                  ],
                  [
                    46310.2,
                    51078
                  ],
                  [
                    46238,
                    51046.4
                  ],
                  [
                    46155,
                    50968.6
                  ],
                  [
                    46129.4,
                    50872.4
                  ],
                  [
                    46101,
                    50701.8
                  ],
                  [
                    46078.1,
                    50617.3
                  ],
                  [
                    46083.7,
                    50532.5
                  ],
                  [
                    46018.6,
                    50470.8
                  ],
                  [
                    46009.8,
                    50426.7
                  ],
                  [
                    45998.1,
                    50362.6
                  ],
                  [
                    45995,
                    50288.3
                  ],
                  [
                    46024.4,
                    50200.2
                  ],
                  [
                    46046.9,
                    50142.6
                  ],
                  [
                    46147.5,
                    50154.7
                  ],
                  [
                    46272,
                    50087.4
                  ],
                  [
                    46333,
                    50086
                  ],
                  [
                    46427.8,
                    50043.1
                  ],
                  [
                    46564.5,
                    50026.3
                  ],
                  [
                    46631.2,
                    49989.5
                  ],
                  [
                    46685.3,
                    50292.3
                  ],
                  [
                    46673.5,
                    50473.2
                  ],
                  [
                    46743.5,
                    50615.3
                  ],
                  [
                    46623.6,
                    50622.4
                  ],
                  [
                    46548.8,
                    50647.2
                  ],
                  [
                    46520.7,
                    50705.6
                  ],
                  [
                    46515.4,
                    50775.3
                  ],
                  [
                    46528.7,
                    50834.6
                  ],
                  [
                    46548,
                    50976.2
                  ],
                  [
                    46601.2,
                    51130.9
                  ]
                ],
                "id": 1729,
                "chat_link": "[&BMEGAAA=]"
              },
              "1730": {
                "name": "Sky's Reach",
                "level": 80,
                "coord": [
                  45253.9,
                  50720.8
                ],
                "bounds": [
                  [
                    45490.5,
                    50584.2
                  ],
                  [
                    45408.1,
                    50722.2
                  ],
                  [
                    45399.5,
                    50822.9
                  ],
                  [
                    45446.8,
                    50894.7
                  ],
                  [
                    45439.5,
                    50982
                  ],
                  [
                    45437.7,
                    51089.9
                  ],
                  [
                    45397.3,
                    51090.7
                  ],
                  [
                    45314.2,
                    51102.9
                  ],
                  [
                    45216,
                    51080.9
                  ],
                  [
                    45148,
                    51076.1
                  ],
                  [
                    45091.8,
                    51106.2
                  ],
                  [
                    45037,
                    51106.8
                  ],
                  [
                    45033.9,
                    50977.4
                  ],
                  [
                    45060.7,
                    50915.2
                  ],
                  [
                    45094.3,
                    50828
                  ],
                  [
                    45134,
                    50679.6
                  ],
                  [
                    45083.3,
                    50588.1
                  ],
                  [
                    45113,
                    50501.9
                  ],
                  [
                    45126.6,
                    50413.3
                  ],
                  [
                    45121.7,
                    50347.1
                  ],
                  [
                    45147.2,
                    50291.2
                  ],
                  [
                    45202.7,
                    50304.6
                  ],
                  [
                    45263.6,
                    50319.1
                  ],
                  [
                    45309.5,
                    50388.5
                  ],
                  [
                    45383.3,
                    50416.9
                  ],
                  [
                    45446.6,
                    50418
                  ],
                  [
                    45507.5,
                    50414.3
                  ],
                  [
                    45490.5,
                    50584.2
                  ]
                ],
                "id": 1730,
                "chat_link": "[&BMIGAAA=]"
              },
              "1731": {
                "name": "Melandru's Chalice",
                "level": 80,
                "coord": [
                  47067.1,
                  50601
                ],
                "bounds": [
                  [
                    46685.3,
                    50292.3
                  ],
                  [
                    46795.4,
                    50198.5
                  ],
                  [
                    47009.2,
                    50124.5
                  ],
                  [
                    47148.7,
                    50081.5
                  ],
                  [
                    47256.3,
                    50221.5
                  ],
                  [
                    47342.9,
                    50276.9
                  ],
                  [
                    47382.9,
                    50271.9
                  ],
                  [
                    47378.8,
                    50353.8
                  ],
                  [
                    47373,
                    50463.8
                  ],
                  [
                    47357.1,
                    50759.9
                  ],
                  [
                    47340.9,
                    50912.9
                  ],
                  [
                    47279,
                    50962.7
                  ],
                  [
                    47166.4,
                    50990
                  ],
                  [
                    47052.5,
                    51044.4
                  ],
                  [
                    47008.1,
                    51072
                  ],
                  [
                    46887.1,
                    51133.1
                  ],
                  [
                    46863,
                    50911.7
                  ],
                  [
                    46846.6,
                    50773.1
                  ],
                  [
                    46818.2,
                    50687.5
                  ],
                  [
                    46743.5,
                    50615.3
                  ],
                  [
                    46673.5,
                    50473.2
                  ],
                  [
                    46685.3,
                    50292.3
                  ]
                ],
                "id": 1731,
                "chat_link": "[&BMMGAAA=]"
              },
              "1732": {
                "name": "Gnarlgrove",
                "level": 80,
                "coord": [
                  46345.8,
                  49574
                ],
                "bounds": [
                  [
                    46631.2,
                    49989.5
                  ],
                  [
                    46564.5,
                    50026.3
                  ],
                  [
                    46427.8,
                    50043.1
                  ],
                  [
                    46333,
                    50086
                  ],
                  [
                    46272,
                    50087.4
                  ],
                  [
                    46147.5,
                    50154.7
                  ],
                  [
                    46046.9,
                    50142.6
                  ],
                  [
                    46083.8,
                    49826.9
                  ],
                  [
                    46050.3,
                    49692
                  ],
                  [
                    46085.3,
                    49639.4
                  ],
                  [
                    46078.6,
                    49495.8
                  ],
                  [
                    46174.7,
                    49410.7
                  ],
                  [
                    46160.5,
                    49252.9
                  ],
                  [
                    46241.3,
                    49182.4
                  ],
                  [
                    46334.5,
                    49098.3
                  ],
                  [
                    46458.1,
                    49058.3
                  ],
                  [
                    46491.1,
                    49030.3
                  ],
                  [
                    46531.4,
                    49126.7
                  ],
                  [
                    46582.5,
                    49255.7
                  ],
                  [
                    46537.8,
                    49292.9
                  ],
                  [
                    46524.6,
                    49352.8
                  ],
                  [
                    46582,
                    49441
                  ],
                  [
                    46613.4,
                    49517.1
                  ],
                  [
                    46631.2,
                    49989.5
                  ]
                ],
                "id": 1732,
                "chat_link": "[&BMQGAAA=]"
              },
              "1733": {
                "name": "Grenth's Teeth",
                "level": 80,
                "coord": [
                  44601,
                  50834.9
                ],
                "bounds": [
                  [
                    45037,
                    51106.8
                  ],
                  [
                    44996.3,
                    51118.2
                  ],
                  [
                    44931.9,
                    51151.1
                  ],
                  [
                    44837.3,
                    51154.9
                  ],
                  [
                    44748.3,
                    51154.6
                  ],
                  [
                    44654,
                    51137.5
                  ],
                  [
                    44607.2,
                    51136.7
                  ],
                  [
                    44572.2,
                    51144.4
                  ],
                  [
                    44462,
                    51153.8
                  ],
                  [
                    44390.9,
                    51152.5
                  ],
                  [
                    44328.2,
                    51142.9
                  ],
                  [
                    44244.8,
                    51112
                  ],
                  [
                    44165.5,
                    51048.5
                  ],
                  [
                    44095.2,
                    50982.8
                  ],
                  [
                    44051.3,
                    50828.8
                  ],
                  [
                    44067.4,
                    50751.8
                  ],
                  [
                    44098.5,
                    50679
                  ],
                  [
                    44051,
                    50575.5
                  ],
                  [
                    44058.2,
                    50498.9
                  ],
                  [
                    44118.5,
                    50490.9
                  ],
                  [
                    44238.8,
                    50520.7
                  ],
                  [
                    44393.1,
                    50482
                  ],
                  [
                    44597.9,
                    50520.2
                  ],
                  [
                    44674.6,
                    50554.9
                  ],
                  [
                    44744,
                    50516.2
                  ],
                  [
                    44766.6,
                    50562.2
                  ],
                  [
                    44818.8,
                    50635.4
                  ],
                  [
                    44870.9,
                    50658.7
                  ],
                  [
                    44980,
                    50645.1
                  ],
                  [
                    45028.8,
                    50616.5
                  ],
                  [
                    45083.3,
                    50588.1
                  ],
                  [
                    45134,
                    50679.6
                  ],
                  [
                    45094.3,
                    50828
                  ],
                  [
                    45060.7,
                    50915.2
                  ],
                  [
                    45033.9,
                    50977.4
                  ],
                  [
                    45037,
                    51106.8
                  ]
                ],
                "id": 1733,
                "chat_link": "[&BMUGAAA=]"
              },
              "1734": {
                "name": "Wing's Shadow",
                "level": 80,
                "coord": [
                  44942.6,
                  49937.6
                ],
                "bounds": [
                  [
                    44652.2,
                    49457.7
                  ],
                  [
                    44734.9,
                    49482.1
                  ],
                  [
                    44849.8,
                    49440.6
                  ],
                  [
                    44993.2,
                    49409.5
                  ],
                  [
                    45123.1,
                    49473.2
                  ],
                  [
                    45152.5,
                    49556.3
                  ],
                  [
                    45161.6,
                    49947.3
                  ],
                  [
                    45131.3,
                    49985.1
                  ],
                  [
                    45127.1,
                    50028.8
                  ],
                  [
                    45123.3,
                    50072.9
                  ],
                  [
                    45087.4,
                    50120.8
                  ],
                  [
                    45125,
                    50178.8
                  ],
                  [
                    45116.6,
                    50235.8
                  ],
                  [
                    45060.6,
                    50226.3
                  ],
                  [
                    44935.6,
                    50244.9
                  ],
                  [
                    44862.7,
                    50242.3
                  ],
                  [
                    44817.8,
                    50253.3
                  ],
                  [
                    44762,
                    50276
                  ],
                  [
                    44674.8,
                    50186.2
                  ],
                  [
                    44667.4,
                    50078.3
                  ],
                  [
                    44636.5,
                    49793
                  ],
                  [
                    44652.2,
                    49457.7
                  ]
                ],
                "id": 1734,
                "chat_link": "[&BMYGAAA=]"
              },
              "1735": {
                "name": "Necrotic Coast",
                "level": 80,
                "coord": [
                  44358,
                  50209.5
                ],
                "bounds": [
                  [
                    44238.8,
                    50520.7
                  ],
                  [
                    44118.5,
                    50490.9
                  ],
                  [
                    44058.7,
                    50498.9
                  ],
                  [
                    44047.4,
                    50408
                  ],
                  [
                    44045.3,
                    50345.5
                  ],
                  [
                    44042,
                    50294.5
                  ],
                  [
                    44036.6,
                    50232.5
                  ],
                  [
                    44044,
                    50095.8
                  ],
                  [
                    43999.9,
                    50009.9
                  ],
                  [
                    44020.4,
                    49890.9
                  ],
                  [
                    44034.8,
                    49830.4
                  ],
                  [
                    44180.7,
                    49825.7
                  ],
                  [
                    44249.4,
                    49822.3
                  ],
                  [
                    44339.5,
                    49793.1
                  ],
                  [
                    44490,
                    49754.8
                  ],
                  [
                    44636.5,
                    49793
                  ],
                  [
                    44667.4,
                    50078.3
                  ],
                  [
                    44674.8,
                    50186.2
                  ],
                  [
                    44762,
                    50276
                  ],
                  [
                    44734.3,
                    50340.2
                  ],
                  [
                    44736.2,
                    50418.7
                  ],
                  [
                    44740.9,
                    50467.3
                  ],
                  [
                    44744,
                    50516.2
                  ],
                  [
                    44674.6,
                    50554.9
                  ],
                  [
                    44597.9,
                    50520.2
                  ],
                  [
                    44393.1,
                    50482
                  ],
                  [
                    44238.8,
                    50520.7
                  ]
                ],
                "id": 1735,
                "chat_link": "[&BMcGAAA=]"
              },
              "1736": {
                "name": "The Skein",
                "level": 80,
                "coord": [
                  46949.3,
                  49461.6
                ],
                "bounds": [
                  [
                    46524.6,
                    49352.8
                  ],
                  [
                    46537.8,
                    49292.9
                  ],
                  [
                    46582.5,
                    49255.7
                  ],
                  [
                    46627.5,
                    49256.9
                  ],
                  [
                    46685,
                    49263.8
                  ],
                  [
                    46809.3,
                    49296.1
                  ],
                  [
                    46886.5,
                    49268.2
                  ],
                  [
                    46948.1,
                    49202
                  ],
                  [
                    47040,
                    49045.9
                  ],
                  [
                    47208.6,
                    49067.9
                  ],
                  [
                    47351.7,
                    49132.2
                  ],
                  [
                    47361,
                    49179
                  ],
                  [
                    47363.5,
                    49238.9
                  ],
                  [
                    47367.6,
                    49331
                  ],
                  [
                    47366.3,
                    49393.8
                  ],
                  [
                    47253.9,
                    49405.5
                  ],
                  [
                    47205.2,
                    49429.3
                  ],
                  [
                    47146.8,
                    49482.9
                  ],
                  [
                    47148.7,
                    50081.5
                  ],
                  [
                    47009.2,
                    50124.5
                  ],
                  [
                    46795.4,
                    50198.5
                  ],
                  [
                    46685.3,
                    50292.3
                  ],
                  [
                    46631.2,
                    49989.5
                  ],
                  [
                    46613.4,
                    49517.1
                  ],
                  [
                    46582,
                    49441
                  ],
                  [
                    46524.6,
                    49352.8
                  ]
                ],
                "id": 1736,
                "chat_link": "[&BMgGAAA=]"
              },
              "1737": {
                "name": "Dragon's Snare",
                "level": 80,
                "coord": [
                  45594.4,
                  49873.1
                ],
                "bounds": [
                  [
                    46046.9,
                    50142.6
                  ],
                  [
                    46024.4,
                    50200.2
                  ],
                  [
                    45979.4,
                    50196.5
                  ],
                  [
                    45937.8,
                    50189.4
                  ],
                  [
                    45878.6,
                    50201.5
                  ],
                  [
                    45811.7,
                    50228.5
                  ],
                  [
                    45761.2,
                    50256.4
                  ],
                  [
                    45628.4,
                    50380.5
                  ],
                  [
                    45558,
                    50388.3
                  ],
                  [
                    45507.5,
                    50414.3
                  ],
                  [
                    45446.6,
                    50418
                  ],
                  [
                    45383.3,
                    50416.9
                  ],
                  [
                    45309.5,
                    50388.5
                  ],
                  [
                    45263.6,
                    50319.1
                  ],
                  [
                    45202.7,
                    50304.6
                  ],
                  [
                    45147.2,
                    50291.2
                  ],
                  [
                    45116.6,
                    50235.8
                  ],
                  [
                    45125,
                    50178.8
                  ],
                  [
                    45087.4,
                    50120.8
                  ],
                  [
                    45123.3,
                    50072.9
                  ],
                  [
                    45127.1,
                    50028.8
                  ],
                  [
                    45131.3,
                    49985.1
                  ],
                  [
                    45161.6,
                    49947.3
                  ],
                  [
                    45152.5,
                    49556.3
                  ],
                  [
                    45208.8,
                    49483.3
                  ],
                  [
                    45245.4,
                    49451.4
                  ],
                  [
                    45266.8,
                    49388.2
                  ],
                  [
                    45244.3,
                    49310.6
                  ],
                  [
                    45476.6,
                    49284.2
                  ],
                  [
                    45657.6,
                    49226
                  ],
                  [
                    45719.8,
                    49294.9
                  ],
                  [
                    45882.9,
                    49320.9
                  ],
                  [
                    45974.4,
                    49317.6
                  ],
                  [
                    46048.5,
                    49278
                  ],
                  [
                    46102.3,
                    49261.3
                  ],
                  [
                    46160.5,
                    49252.9
                  ],
                  [
                    46174.7,
                    49410.7
                  ],
                  [
                    46078.6,
                    49495.8
                  ],
                  [
                    46085.3,
                    49639.4
                  ],
                  [
                    46050.3,
                    49692
                  ],
                  [
                    46083.8,
                    49826.9
                  ],
                  [
                    46046.9,
                    50142.6
                  ]
                ],
                "id": 1737,
                "chat_link": "[&BMkGAAA=]"
              },
              "1738": {
                "name": "Ember Gate",
                "level": 80,
                "coord": [
                  44271.9,
                  49537.1
                ],
                "bounds": [
                  [
                    44636.5,
                    49793
                  ],
                  [
                    44490,
                    49754.8
                  ],
                  [
                    44339.5,
                    49793.1
                  ],
                  [
                    44291.5,
                    49810.9
                  ],
                  [
                    44249.4,
                    49822.3
                  ],
                  [
                    44180.7,
                    49825.7
                  ],
                  [
                    44034.7,
                    49830.4
                  ],
                  [
                    44026.4,
                    49756.8
                  ],
                  [
                    44037.1,
                    49687.2
                  ],
                  [
                    44055.5,
                    49620.6
                  ],
                  [
                    44060.1,
                    49549.5
                  ],
                  [
                    44067.2,
                    49479.3
                  ],
                  [
                    44017.5,
                    49390.7
                  ],
                  [
                    44006.3,
                    49293.4
                  ],
                  [
                    44012.5,
                    49231.8
                  ],
                  [
                    44149.8,
                    49253.5
                  ],
                  [
                    44396.7,
                    49254.9
                  ],
                  [
                    44467.2,
                    49253.3
                  ],
                  [
                    44536.5,
                    49241.7
                  ],
                  [
                    44627.5,
                    49319.4
                  ],
                  [
                    44646.3,
                    49397
                  ],
                  [
                    44652.2,
                    49457.7
                  ],
                  [
                    44636.5,
                    49793
                  ]
                ],
                "id": 1738,
                "chat_link": "[&BMoGAAA=]"
              },
              "1740": {
                "name": "Howling Gate",
                "level": 80,
                "coord": [
                  45808.4,
                  50625.6
                ],
                "bounds": [
                  [
                    45676.3,
                    50965.5
                  ],
                  [
                    45492.8,
                    51059.8
                  ],
                  [
                    45437.7,
                    51089.9
                  ],
                  [
                    45439.5,
                    50982
                  ],
                  [
                    45446.8,
                    50894.7
                  ],
                  [
                    45399.5,
                    50822.9
                  ],
                  [
                    45408.1,
                    50722.2
                  ],
                  [
                    45490.5,
                    50584.2
                  ],
                  [
                    45507.5,
                    50414.3
                  ],
                  [
                    45558,
                    50388.3
                  ],
                  [
                    45628.4,
                    50380.5
                  ],
                  [
                    45761.2,
                    50256.4
                  ],
                  [
                    45811.7,
                    50228.5
                  ],
                  [
                    45878.6,
                    50201.5
                  ],
                  [
                    45937.8,
                    50189.4
                  ],
                  [
                    45979.4,
                    50196.5
                  ],
                  [
                    46024.4,
                    50200.2
                  ],
                  [
                    45995,
                    50288.3
                  ],
                  [
                    45998.1,
                    50362.6
                  ],
                  [
                    46009.8,
                    50426.7
                  ],
                  [
                    46018.6,
                    50470.8
                  ],
                  [
                    46083.7,
                    50532.5
                  ],
                  [
                    46078.1,
                    50617.3
                  ],
                  [
                    46101,
                    50701.8
                  ],
                  [
                    46129.4,
                    50872.4
                  ],
                  [
                    46155,
                    50968.6
                  ],
                  [
                    46085.5,
                    50961.4
                  ],
                  [
                    46019.2,
                    50999.8
                  ],
                  [
                    45936.1,
                    51022
                  ],
                  [
                    45763.1,
                    50965.8
                  ],
                  [
                    45676.3,
                    50965.5
                  ]
                ],
                "id": 1740,
                "chat_link": "[&BMwGAAA=]"
              }
            },
            "adventures": [],
            "id": 1317,
            "mastery_points": [
              {
                "coord": [
                  46106.6,
                  49514.2
                ],
                "id": 461,
                "region": "Desert"
              },
              {
                "coord": [
                  44298,
                  51037.9
                ],
                "id": 460,
                "region": "Desert"
              },
              {
                "coord": [
                  44198.8,
                  48803.1
                ],
                "id": 456,
                "region": "Desert"
              },
              {
                "coord": [
                  45597.3,
                  49717.8
                ],
                "id": 462,
                "region": "Desert"
              },
              {
                "coord": [
                  45014.1,
                  51043.3
                ],
                "id": 463,
                "region": "Desert"
              },
              {
                "coord": [
                  45503.6,
                  49026.2
                ],
                "id": 459,
                "region": "Desert"
              }
            ]
          },
          "1318": {
            "name": "Dragonfall",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              45638,
              49589
            ],
            "map_rect": [
              [
                -39936,
                -33792
              ],
              [
                43008,
                33792
              ]
            ],
            "continent_rect": [
              [
                43968,
                48384
              ],
              [
                47424,
                51200
              ]
            ],
            "points_of_interest": {
              "3027": {
                "name": "Charnel Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46560.5,
                  48915.9
                ],
                "id": 3027,
                "chat_link": "[&BNMLAAA=]"
              },
              "3033": {
                "name": "Pact Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46783,
                  48753.2
                ],
                "id": 3033,
                "chat_link": "[&BNkLAAA=]"
              },
              "3044": {
                "name": "Airdrome Port",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46879.5,
                  48565.9
                ],
                "id": 3044,
                "chat_link": "[&BOQLAAA=]"
              },
              "3048": {
                "name": "Verdant Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46807.9,
                  49013.7
                ],
                "id": 3048,
                "chat_link": "[&BOgLAAA=]"
              },
              "3050": {
                "name": "Ember Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  46485.4,
                  48705.8
                ],
                "id": 3050,
                "chat_link": "[&BOoLAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1725": {
                "name": "Pact Command",
                "level": 80,
                "coord": [
                  46849.1,
                  48825.1
                ],
                "bounds": [
                  [
                    46582.5,
                    49255.7
                  ],
                  [
                    46531.4,
                    49126.7
                  ],
                  [
                    46491.1,
                    49030.3
                  ],
                  [
                    46410.6,
                    48872.1
                  ],
                  [
                    46393.5,
                    48790.3
                  ],
                  [
                    46417.1,
                    48744.5
                  ],
                  [
                    46408.8,
                    48631.3
                  ],
                  [
                    46501.6,
                    48468.3
                  ],
                  [
                    46601.3,
                    48485.3
                  ],
                  [
                    46673.7,
                    48474
                  ],
                  [
                    46724.5,
                    48495.1
                  ],
                  [
                    46820.7,
                    48483.9
                  ],
                  [
                    46870.7,
                    48488.1
                  ],
                  [
                    46927.9,
                    48472.2
                  ],
                  [
                    47046.8,
                    48462.6
                  ],
                  [
                    47143.3,
                    48487.4
                  ],
                  [
                    47239.7,
                    48547.2
                  ],
                  [
                    47263.5,
                    48588.8
                  ],
                  [
                    47306.5,
                    48676.2
                  ],
                  [
                    47342.6,
                    48791.9
                  ],
                  [
                    47370,
                    49022.7
                  ],
                  [
                    47351.7,
                    49132.2
                  ],
                  [
                    47208.6,
                    49067.9
                  ],
                  [
                    47040,
                    49045.9
                  ],
                  [
                    46948.1,
                    49202
                  ],
                  [
                    46886.5,
                    49268.2
                  ],
                  [
                    46809.3,
                    49296.1
                  ],
                  [
                    46685,
                    49263.8
                  ],
                  [
                    46627.5,
                    49256.9
                  ],
                  [
                    46582.5,
                    49255.7
                  ]
                ],
                "id": 1725,
                "chat_link": "[&BL0GAAA=]"
              }
            },
            "adventures": [],
            "id": 1318,
            "mastery_points": []
          },
          "1323": {
            "name": "The Key of Ahdashim",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              67261,
              51611
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                24576
              ]
            ],
            "continent_rect": [
              [
                66298,
                50434
              ],
              [
                68218,
                52354
              ]
            ],
            "points_of_interest": {
              "3051": {
                "name": "Earthen Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67814.4,
                  51519.2
                ],
                "id": 3051,
                "chat_link": "[&BOsLAAA=]"
              },
              "3052": {
                "name": "Gates of Ahdashim",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67262.1,
                  51803.9
                ],
                "id": 3052,
                "chat_link": "[&BOwLAAA=]"
              },
              "3054": {
                "name": "Well of Ahdashim",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67261.2,
                  51214.9
                ],
                "id": 3054,
                "chat_link": "[&BO4LAAA=]"
              },
              "3055": {
                "name": "Key's Fountain",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  67261,
                  51545.2
                ],
                "id": 3055,
                "chat_link": "[&BO8LAAA=]"
              },
              "3056": {
                "name": "Nirvana's Ascent",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  66747.9,
                  51400
                ],
                "id": 3056,
                "chat_link": "[&BPALAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1741": {
                "name": "Leystone Axis",
                "level": 80,
                "coord": [
                  67282.9,
                  51571.4
                ],
                "bounds": [
                  [
                    67029.5,
                    51760.5
                  ],
                  [
                    67012.5,
                    51575.1
                  ],
                  [
                    66994.9,
                    51398.3
                  ],
                  [
                    67141.3,
                    51442.3
                  ],
                  [
                    67380.9,
                    51436.9
                  ],
                  [
                    67561.7,
                    51402.8
                  ],
                  [
                    67574.5,
                    51549.5
                  ],
                  [
                    67505.1,
                    51789.4
                  ],
                  [
                    67345.7,
                    51787.9
                  ],
                  [
                    67029.5,
                    51760.5
                  ]
                ],
                "id": 1741,
                "chat_link": "[&BM0GAAA=]"
              },
              "1742": {
                "name": "Basalt Arena",
                "level": 80,
                "coord": [
                  67793.8,
                  51486.5
                ],
                "bounds": [
                  [
                    67505.1,
                    51789.8
                  ],
                  [
                    67575.4,
                    51549.3
                  ],
                  [
                    67508.6,
                    50855.8
                  ],
                  [
                    67913.5,
                    51146.9
                  ],
                  [
                    68068.2,
                    51367.9
                  ],
                  [
                    68073.5,
                    51590.7
                  ],
                  [
                    67931.1,
                    51797.3
                  ],
                  [
                    67774.9,
                    51794.4
                  ],
                  [
                    67505.1,
                    51789.8
                  ]
                ],
                "id": 1742,
                "chat_link": "[&BM4GAAA=]"
              },
              "1743": {
                "name": "Fractured Conservatory",
                "level": 80,
                "coord": [
                  66709.9,
                  51386.3
                ],
                "bounds": [
                  [
                    67029.7,
                    51760.5
                  ],
                  [
                    66695,
                    51876
                  ],
                  [
                    66429.1,
                    51688.5
                  ],
                  [
                    66351.5,
                    51320.7
                  ],
                  [
                    66461,
                    51141.3
                  ],
                  [
                    66700.4,
                    51046.1
                  ],
                  [
                    67017.4,
                    50859.1
                  ],
                  [
                    66995.1,
                    51398.1
                  ],
                  [
                    67029.7,
                    51760.5
                  ]
                ],
                "id": 1743,
                "chat_link": "[&BM8GAAA=]"
              },
              "1745": {
                "name": "Sovereign's Stadium",
                "level": 80,
                "coord": [
                  67260.6,
                  51125.2
                ],
                "bounds": [
                  [
                    66993.2,
                    51398
                  ],
                  [
                    67018.6,
                    50857.8
                  ],
                  [
                    67137.3,
                    50802.1
                  ],
                  [
                    67343.6,
                    50807.1
                  ],
                  [
                    67508.5,
                    50854.7
                  ],
                  [
                    67561.7,
                    51402.3
                  ],
                  [
                    67381.2,
                    51437.4
                  ],
                  [
                    67141.1,
                    51442.4
                  ],
                  [
                    66993.2,
                    51398
                  ]
                ],
                "id": 1745,
                "chat_link": "[&BNEGAAA=]"
              },
              "1746": {
                "name": "Prism Sanctuary",
                "level": 80,
                "coord": [
                  67312.9,
                  52050.4
                ],
                "bounds": [
                  [
                    66784.1,
                    52248.6
                  ],
                  [
                    66696.1,
                    51875.8
                  ],
                  [
                    67029.4,
                    51760.3
                  ],
                  [
                    67171.8,
                    51769.9
                  ],
                  [
                    67345.8,
                    51787.1
                  ],
                  [
                    67930.2,
                    51798.8
                  ],
                  [
                    67812.5,
                    52117.2
                  ],
                  [
                    67637.9,
                    52305
                  ],
                  [
                    67505.6,
                    52396.4
                  ],
                  [
                    67215.5,
                    52444.6
                  ],
                  [
                    66784.1,
                    52248.6
                  ]
                ],
                "id": 1746,
                "chat_link": "[&BNIGAAA=]"
              }
            },
            "adventures": [],
            "id": 1323,
            "mastery_points": []
          }
        },
        "id": 12
      },
      "20": {
        "name": "Ring of Fire",
        "label_coord": [
          37968,
          42384
        ],
        "continent_rect": [
          [
            50432,
            24448
          ],
          [
            56576,
            37760
          ]
        ],
        "maps": {
          "1175": {
            "name": "Ember Bay",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              39008,
              45445
            ],
            "map_rect": [
              [
                -46080,
                -46080
              ],
              [
                46080,
                46080
              ]
            ],
            "continent_rect": [
              [
                37374,
                43518
              ],
              [
                41214,
                47358
              ]
            ],
            "points_of_interest": {
              "2386": {
                "name": "Twin Skulls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37947.2,
                  45266.6
                ],
                "id": 2386,
                "chat_link": "[&BFIJAAA=]"
              },
              "2387": {
                "name": "Furnace Chamber",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  39774.9,
                  46790.2
                ],
                "id": 2387,
                "chat_link": "[&BFMJAAA=]"
              },
              "2389": {
                "name": "Scratch Gate Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  40203.4,
                  45862.7
                ],
                "id": 2389,
                "chat_link": "[&BFUJAAA=]"
              },
              "2390": {
                "name": "The Dread Shiny",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40187.4,
                  46140
                ],
                "id": 2390,
                "chat_link": "[&BFYJAAA=]"
              },
              "2391": {
                "name": "Barrier Spires",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37909.9,
                  46242.8
                ],
                "id": 2391,
                "chat_link": "[&BFcJAAA=]"
              },
              "2392": {
                "name": "Asuran Beachhead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38985.6,
                  46352.8
                ],
                "id": 2392,
                "chat_link": "[&BFgJAAA=]"
              },
              "2393": {
                "name": "Fool's Scratch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40688.8,
                  45783.4
                ],
                "id": 2393,
                "chat_link": "[&BFkJAAA=]"
              },
              "2395": {
                "name": "Magma Outlet",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  39360.3,
                  45905.4
                ],
                "id": 2395,
                "chat_link": "[&BFsJAAA=]"
              },
              "2396": {
                "name": "Osprey Aeries",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38175.4,
                  46599.3
                ],
                "id": 2396,
                "chat_link": "[&BFwJAAA=]"
              },
              "2397": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  38093.7,
                  46558
                ],
                "id": 2397,
                "chat_link": "[&BF0JAAA=]"
              },
              "2398": {
                "name": "Lava River",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  39973.9,
                  45854.6
                ],
                "id": 2398,
                "chat_link": "[&BF4JAAA=]"
              },
              "2399": {
                "name": "Promontory Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  38980.3,
                  46425.7
                ],
                "id": 2399,
                "chat_link": "[&BF8JAAA=]"
              },
              "2400": {
                "name": "Crumbling Trail Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  39809.1,
                  45114.6
                ],
                "id": 2400,
                "chat_link": "[&BGAJAAA=]"
              },
              "2401": {
                "name": "Quickk's Retreat",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  39259.8,
                  45715.8
                ],
                "id": 2401,
                "chat_link": "[&BGEJAAA=]"
              },
              "2402": {
                "name": "Ivy's Circus Spectacular",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38394.8,
                  46229.1
                ],
                "id": 2402,
                "chat_link": "[&BGIJAAA=]"
              },
              "2403": {
                "name": "Pedestal of Flames",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38865.1,
                  45953.6
                ],
                "id": 2403,
                "chat_link": "[&BGMJAAA=]"
              },
              "2404": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  38319.7,
                  46275.4
                ],
                "id": 2404,
                "chat_link": "[&BGQJAAA=]"
              },
              "2405": {
                "name": "Slag Pools",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  39817.1,
                  46185.1
                ],
                "id": 2405,
                "chat_link": "[&BGUJAAA=]"
              },
              "2408": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  38262.2,
                  45321.9
                ],
                "id": 2408,
                "chat_link": "[&BGgJAAA=]"
              },
              "2409": {
                "name": "Karka Hatchery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40612.9,
                  45170.6
                ],
                "id": 2409,
                "chat_link": "[&BGkJAAA=]"
              },
              "2410": {
                "name": "Cliffwalk Trailhead",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40088.4,
                  45230.3
                ],
                "id": 2410,
                "chat_link": "[&BGoJAAA=]"
              },
              "2412": {
                "name": "Observation Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  39620.4,
                  46391.5
                ],
                "id": 2412,
                "chat_link": "[&BGwJAAA=]"
              },
              "2414": {
                "name": "Rock Face Scratch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  40245.6,
                  45982.6
                ],
                "id": 2414,
                "chat_link": "[&BG4JAAA=]"
              },
              "2415": {
                "name": "Sloth Queen's Showground",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37944.8,
                  45786.1
                ],
                "id": 2415,
                "chat_link": "[&BG8JAAA=]"
              },
              "2416": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  38881.5,
                  46103.5
                ],
                "id": 2416,
                "chat_link": "[&BHAJAAA=]"
              },
              "2417": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  40081.7,
                  45729.8
                ],
                "id": 2417,
                "chat_link": "[&BHEJAAA=]"
              },
              "2419": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  38990.4,
                  46540.7
                ],
                "id": 2419,
                "chat_link": "[&BHMJAAA=]"
              },
              "2421": {
                "name": "Sealed Entrance",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38221.8,
                  45507.4
                ],
                "id": 2421,
                "chat_link": "[&BHUJAAA=]"
              },
              "2422": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  39406.1,
                  45368.5
                ],
                "id": 2422,
                "chat_link": "[&BHYJAAA=]"
              },
              "2423": {
                "name": "Smoosh-a-Tron",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  39605.5,
                  45386.5
                ],
                "id": 2423,
                "chat_link": "[&BHcJAAA=]"
              },
              "2424": {
                "name": "Castaway Circus Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  38284.7,
                  46256.3
                ],
                "id": 2424,
                "chat_link": "[&BHgJAAA=]"
              },
              "2425": {
                "name": "Destruction's Maw",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  39035,
                  46129.6
                ],
                "id": 2425,
                "chat_link": "[&BHkJAAA=]"
              },
              "2426": {
                "name": "Titan's Perch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38388.9,
                  45991
                ],
                "id": 2426,
                "chat_link": "[&BHoJAAA=]"
              },
              "2427": {
                "name": "Chalice of Tears",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  38453.5,
                  45592.4
                ],
                "id": 2427,
                "chat_link": "[&BHsJAAA=]"
              }
            },
            "tasks": {
              "363": {
                "objective": "Investigate the mursaat fortress",
                "level": 80,
                "coord": [
                  37865.2,
                  45616.2
                ],
                "bounds": [
                  [
                    37706.9,
                    45750.5
                  ],
                  [
                    37659.3,
                    45483.5
                  ],
                  [
                    37651.9,
                    45347.6
                  ],
                  [
                    37638.6,
                    45244.6
                  ],
                  [
                    37676.8,
                    45113.1
                  ],
                  [
                    38298.2,
                    45144
                  ],
                  [
                    38502.5,
                    45530.9
                  ],
                  [
                    37984.8,
                    45668
                  ],
                  [
                    37706.9,
                    45750.5
                  ]
                ],
                "id": 363,
                "chat_link": "[&BGsBAAA=]"
              },
              "364": {
                "objective": "Win the favor of the circus",
                "level": 80,
                "coord": [
                  38226.1,
                  46492
                ],
                "bounds": [
                  [
                    37946.4,
                    46972.7
                  ],
                  [
                    37857.6,
                    46199.7
                  ],
                  [
                    38688.8,
                    46206.6
                  ],
                  [
                    38734.4,
                    47028
                  ],
                  [
                    37946.4,
                    46972.7
                  ]
                ],
                "id": 364,
                "chat_link": "[&BGwBAAA=]"
              },
              "365": {
                "objective": "Assist the asuran researchers.",
                "level": 80,
                "coord": [
                  39606.4,
                  46353.8
                ],
                "bounds": [
                  [
                    39460.5,
                    46808.8
                  ],
                  [
                    39517.3,
                    46037.1
                  ],
                  [
                    39790.9,
                    45906.7
                  ],
                  [
                    39994.6,
                    46040.5
                  ],
                  [
                    40085.8,
                    46752.8
                  ],
                  [
                    39896.6,
                    47064.4
                  ],
                  [
                    39708.6,
                    47098.3
                  ],
                  [
                    39576.8,
                    46968.4
                  ],
                  [
                    39460.5,
                    46808.8
                  ]
                ],
                "id": 365,
                "chat_link": "[&BG0BAAA=]"
              },
              "366": {
                "objective": "Assist Scientist Vratt",
                "level": 80,
                "coord": [
                  39522.9,
                  45358.2
                ],
                "bounds": [
                  [
                    39340.4,
                    45442.1
                  ],
                  [
                    39842.1,
                    45438
                  ],
                  [
                    39340.4,
                    45442.1
                  ]
                ],
                "id": 366,
                "chat_link": "[&BG4BAAA=]"
              },
              "367": {
                "objective": "Help the skritt encampment.",
                "level": 80,
                "coord": [
                  40198.4,
                  45949.6
                ],
                "bounds": [
                  [
                    39937.3,
                    45618.1
                  ],
                  [
                    40088.2,
                    45595.7
                  ],
                  [
                    40807.9,
                    45752.5
                  ],
                  [
                    40739.2,
                    45885.7
                  ],
                  [
                    40430,
                    46151.6
                  ],
                  [
                    40076.4,
                    46202.4
                  ],
                  [
                    39951.9,
                    45928.1
                  ],
                  [
                    39937.3,
                    45618.1
                  ]
                ],
                "id": 367,
                "chat_link": "[&BG8BAAA=]"
              }
            },
            "skill_challenges": [],
            "sectors": {
              "1389": {
                "name": "Skritt Anchorage",
                "level": 80,
                "coord": [
                  40116.2,
                  46015.9
                ],
                "bounds": [
                  [
                    40251.2,
                    46204
                  ],
                  [
                    40198.2,
                    46264.6
                  ],
                  [
                    40191.2,
                    46367.5
                  ],
                  [
                    40054.5,
                    46204.2
                  ],
                  [
                    40030.9,
                    46129.3
                  ],
                  [
                    40036.4,
                    46096.4
                  ],
                  [
                    40048.5,
                    46073.4
                  ],
                  [
                    40049,
                    46041.4
                  ],
                  [
                    40056.8,
                    46005
                  ],
                  [
                    40025.3,
                    45989.1
                  ],
                  [
                    39951.9,
                    45975.9
                  ],
                  [
                    39914.1,
                    45929.4
                  ],
                  [
                    39933.4,
                    45875.2
                  ],
                  [
                    39943.8,
                    45866
                  ],
                  [
                    39940.6,
                    45845.1
                  ],
                  [
                    39949,
                    45823.5
                  ],
                  [
                    40000.1,
                    45798.3
                  ],
                  [
                    40318.2,
                    45853.2
                  ],
                  [
                    40420.5,
                    45766.3
                  ],
                  [
                    40655.6,
                    46024.2
                  ],
                  [
                    40470.4,
                    46201.3
                  ],
                  [
                    40251.2,
                    46204
                  ]
                ],
                "id": 1389,
                "chat_link": "[&BG0FAAA=]"
              },
              "1390": {
                "name": "Ashen Skerries",
                "level": 80,
                "coord": [
                  40472,
                  45467.5
                ],
                "bounds": [
                  [
                    40414.9,
                    45665.1
                  ],
                  [
                    40390.5,
                    45626.7
                  ],
                  [
                    40327.7,
                    45440.7
                  ],
                  [
                    40304.6,
                    45365.8
                  ],
                  [
                    40304.3,
                    45288.3
                  ],
                  [
                    40273.8,
                    45241
                  ],
                  [
                    40156.4,
                    45252.7
                  ],
                  [
                    40199.8,
                    45169
                  ],
                  [
                    40424.6,
                    45192.6
                  ],
                  [
                    40609.7,
                    45050.1
                  ],
                  [
                    40737.4,
                    45079.4
                  ],
                  [
                    40782.2,
                    45596.3
                  ],
                  [
                    40803.2,
                    45790.4
                  ],
                  [
                    40759.5,
                    45918.7
                  ],
                  [
                    40650.7,
                    46027.9
                  ],
                  [
                    40413.2,
                    45775
                  ],
                  [
                    40414.9,
                    45665.1
                  ]
                ],
                "id": 1390,
                "chat_link": "[&BG4FAAA=]"
              },
              "1391": {
                "name": "Fractured Caldera",
                "level": 80,
                "coord": [
                  39515,
                  45338.6
                ],
                "bounds": [
                  [
                    39082.5,
                    45590.4
                  ],
                  [
                    38903.9,
                    45636.5
                  ],
                  [
                    38843,
                    45381.4
                  ],
                  [
                    38978.3,
                    45181.7
                  ],
                  [
                    39069.6,
                    45072.3
                  ],
                  [
                    39368.5,
                    44862.8
                  ],
                  [
                    39569.3,
                    44844.7
                  ],
                  [
                    39938.4,
                    44933.6
                  ],
                  [
                    40175.1,
                    45092.7
                  ],
                  [
                    40205.1,
                    45174.7
                  ],
                  [
                    40157.3,
                    45258.7
                  ],
                  [
                    39990.5,
                    45453.4
                  ],
                  [
                    39867.9,
                    45533.4
                  ],
                  [
                    39628.6,
                    45653
                  ],
                  [
                    39569.3,
                    45679.8
                  ],
                  [
                    39267.2,
                    45728.9
                  ],
                  [
                    39140.4,
                    45677.7
                  ],
                  [
                    39082.5,
                    45590.4
                  ]
                ],
                "id": 1391,
                "chat_link": "[&BG8FAAA=]"
              },
              "1393": {
                "name": "Performance Field",
                "level": 80,
                "coord": [
                  37994.2,
                  45876.3
                ],
                "bounds": [
                  [
                    38037.3,
                    45663.3
                  ],
                  [
                    38291.1,
                    45604.2
                  ],
                  [
                    38312.1,
                    45702.5
                  ],
                  [
                    38348.2,
                    45736.7
                  ],
                  [
                    38042.2,
                    45936.9
                  ],
                  [
                    38006,
                    46195.3
                  ],
                  [
                    37883.3,
                    46106
                  ],
                  [
                    37805.1,
                    46103.9
                  ],
                  [
                    37783.2,
                    45979.4
                  ],
                  [
                    37695.8,
                    45872.8
                  ],
                  [
                    37731.7,
                    45738
                  ],
                  [
                    38037.3,
                    45663.3
                  ]
                ],
                "id": 1393,
                "chat_link": "[&BHEFAAA=]"
              },
              "1394": {
                "name": "Sopor Titanum",
                "level": 80,
                "coord": [
                  38517.1,
                  45512.5
                ],
                "bounds": [
                  [
                    38271.1,
                    45535.8
                  ],
                  [
                    38311.8,
                    45317.1
                  ],
                  [
                    38409.8,
                    45231.4
                  ],
                  [
                    38609.6,
                    45172.9
                  ],
                  [
                    38859.6,
                    45376.2
                  ],
                  [
                    38909.6,
                    45636.4
                  ],
                  [
                    38553.3,
                    45819.9
                  ],
                  [
                    38421.6,
                    45817.6
                  ],
                  [
                    38307.8,
                    45705.3
                  ],
                  [
                    38271.1,
                    45535.8
                  ]
                ],
                "id": 1394,
                "chat_link": "[&BHIFAAA=]"
              },
              "1395": {
                "name": "Basalt Rise",
                "level": 80,
                "coord": [
                  40076.7,
                  45601.6
                ],
                "bounds": [
                  [
                    40154.1,
                    45246.2
                  ],
                  [
                    40276.9,
                    45236
                  ],
                  [
                    40311.5,
                    45285.8
                  ],
                  [
                    40311.6,
                    45364.8
                  ],
                  [
                    40333.7,
                    45438.4
                  ],
                  [
                    40397.6,
                    45625.7
                  ],
                  [
                    40421.9,
                    45664.7
                  ],
                  [
                    40426.1,
                    45772.1
                  ],
                  [
                    40323.4,
                    45861.2
                  ],
                  [
                    39996.2,
                    45804.3
                  ],
                  [
                    39974.5,
                    45774.7
                  ],
                  [
                    39958.2,
                    45767.6
                  ],
                  [
                    39925.7,
                    45764.2
                  ],
                  [
                    39916.7,
                    45739
                  ],
                  [
                    39893,
                    45731.6
                  ],
                  [
                    39886.1,
                    45713
                  ],
                  [
                    39889.5,
                    45680.6
                  ],
                  [
                    39834.2,
                    45621.1
                  ],
                  [
                    39808,
                    45601.9
                  ],
                  [
                    39798,
                    45564
                  ],
                  [
                    39863.7,
                    45529.9
                  ],
                  [
                    39986.8,
                    45448.2
                  ],
                  [
                    40154.1,
                    45246.2
                  ]
                ],
                "id": 1395,
                "chat_link": "[&BHMFAAA=]"
              },
              "1396": {
                "name": "Osprey Pillars",
                "level": 80,
                "coord": [
                  38190.5,
                  46675.6
                ],
                "bounds": [
                  [
                    37935.2,
                    46718.5
                  ],
                  [
                    37939.8,
                    46558.4
                  ],
                  [
                    37839.2,
                    46382.4
                  ],
                  [
                    37801.7,
                    46098.6
                  ],
                  [
                    37883.7,
                    46100.7
                  ],
                  [
                    38368.6,
                    46429.9
                  ],
                  [
                    38669.6,
                    46683.6
                  ],
                  [
                    38736,
                    46875.2
                  ],
                  [
                    38685.1,
                    47118.6
                  ],
                  [
                    38416.3,
                    47107
                  ],
                  [
                    38050.1,
                    47050.4
                  ],
                  [
                    37960.5,
                    46983.6
                  ],
                  [
                    37935.2,
                    46718.5
                  ]
                ],
                "id": 1396,
                "chat_link": "[&BHQFAAA=]"
              },
              "1397": {
                "name": "Infernal Cape",
                "level": 80,
                "coord": [
                  39009.2,
                  46301.6
                ],
                "bounds": [
                  [
                    38833.7,
                    46230.4
                  ],
                  [
                    38760.4,
                    46367.6
                  ],
                  [
                    38851.9,
                    46400.9
                  ],
                  [
                    38900.7,
                    46566.6
                  ],
                  [
                    38964.7,
                    46668.7
                  ],
                  [
                    39031.9,
                    46650
                  ],
                  [
                    39067.6,
                    46465
                  ],
                  [
                    39138,
                    46440.4
                  ],
                  [
                    39248.9,
                    46328.4
                  ],
                  [
                    39256.1,
                    46184.4
                  ],
                  [
                    39202,
                    46012
                  ],
                  [
                    39099.7,
                    45990.5
                  ],
                  [
                    39003.7,
                    45980
                  ],
                  [
                    38904.7,
                    46063.2
                  ],
                  [
                    38873.7,
                    46175.1
                  ],
                  [
                    38833.7,
                    46230.4
                  ]
                ],
                "id": 1397,
                "chat_link": "[&BHUFAAA=]"
              },
              "1398": {
                "name": "Burning Grotto",
                "level": 80,
                "coord": [
                  39821.1,
                  46788.2
                ],
                "bounds": [
                  [
                    39497.4,
                    46358.1
                  ],
                  [
                    39742.7,
                    46359.2
                  ],
                  [
                    39976.1,
                    46454.9
                  ],
                  [
                    40102,
                    46641.8
                  ],
                  [
                    40236.3,
                    46633.9
                  ],
                  [
                    40204.2,
                    47051.6
                  ],
                  [
                    39871.4,
                    47254
                  ],
                  [
                    39647.2,
                    47205.5
                  ],
                  [
                    39524.9,
                    47128
                  ],
                  [
                    39408.9,
                    46795.2
                  ],
                  [
                    39497.4,
                    46358.1
                  ]
                ],
                "id": 1398,
                "chat_link": "[&BHYFAAA=]"
              },
              "1399": {
                "name": "Smoldering Inlet",
                "level": 80,
                "coord": [
                  39362.2,
                  45974.4
                ],
                "bounds": [
                  [
                    39196.8,
                    46014.6
                  ],
                  [
                    39091,
                    45994.9
                  ],
                  [
                    39119,
                    45875.4
                  ],
                  [
                    39268.2,
                    45721.9
                  ],
                  [
                    39508.5,
                    45685.1
                  ],
                  [
                    39506.2,
                    45836.6
                  ],
                  [
                    39591.8,
                    46010.5
                  ],
                  [
                    39554.3,
                    46157.3
                  ],
                  [
                    39535.8,
                    46261.9
                  ],
                  [
                    39250.8,
                    46185.5
                  ],
                  [
                    39196.8,
                    46014.6
                  ]
                ],
                "id": 1399,
                "chat_link": "[&BHcFAAA=]"
              },
              "1402": {
                "name": "Caliph's Steps",
                "level": 80,
                "coord": [
                  38022.4,
                  45405.4
                ],
                "bounds": [
                  [
                    37606,
                    45296.5
                  ],
                  [
                    37790.4,
                    45110.8
                  ],
                  [
                    38094.2,
                    45090.6
                  ],
                  [
                    38340.2,
                    45208.8
                  ],
                  [
                    38320.5,
                    45328.8
                  ],
                  [
                    38277.1,
                    45535.4
                  ],
                  [
                    38293.9,
                    45609
                  ],
                  [
                    38037.5,
                    45668.4
                  ],
                  [
                    37729,
                    45744.5
                  ],
                  [
                    37735.1,
                    45461.6
                  ],
                  [
                    37606,
                    45296.5
                  ]
                ],
                "id": 1402,
                "chat_link": "[&BHoFAAA=]"
              },
              "1403": {
                "name": "Shipwreck Beach",
                "level": 80,
                "coord": [
                  38384.3,
                  46028.3
                ],
                "bounds": [
                  [
                    38423.7,
                    45810.6
                  ],
                  [
                    38552.7,
                    45814.3
                  ],
                  [
                    38644.4,
                    45910.7
                  ],
                  [
                    38576.5,
                    46120.8
                  ],
                  [
                    38506.9,
                    46305.5
                  ],
                  [
                    38367,
                    46434.3
                  ],
                  [
                    38003.9,
                    46191.4
                  ],
                  [
                    38037.6,
                    45933.9
                  ],
                  [
                    38346.3,
                    45733
                  ],
                  [
                    38423.7,
                    45810.6
                  ]
                ],
                "id": 1403,
                "chat_link": "[&BHsFAAA=]"
              },
              "1404": {
                "name": "Bleeding Pulpit",
                "level": 80,
                "coord": [
                  38906.6,
                  45945.2
                ],
                "bounds": [
                  [
                    39084.1,
                    45585
                  ],
                  [
                    39143.9,
                    45671.9
                  ],
                  [
                    39273,
                    45725.8
                  ],
                  [
                    39123.2,
                    45879.9
                  ],
                  [
                    39096.6,
                    45997.1
                  ],
                  [
                    39002,
                    45990
                  ],
                  [
                    38911.8,
                    46070.2
                  ],
                  [
                    38879.1,
                    46177.3
                  ],
                  [
                    38844.1,
                    46231
                  ],
                  [
                    38800.4,
                    46210.5
                  ],
                  [
                    38778.2,
                    46144.5
                  ],
                  [
                    38566.4,
                    46130.3
                  ],
                  [
                    38642.1,
                    45917.5
                  ],
                  [
                    38544.4,
                    45816
                  ],
                  [
                    38909.6,
                    45630.4
                  ],
                  [
                    39084.1,
                    45585
                  ]
                ],
                "id": 1404,
                "chat_link": "[&BHwFAAA=]"
              },
              "1407": {
                "name": "Lava Flats",
                "level": 80,
                "coord": [
                  39892,
                  45979.4
                ],
                "bounds": [
                  [
                    39502.6,
                    45837.6
                  ],
                  [
                    39587.1,
                    46008.4
                  ],
                  [
                    39550,
                    46156.2
                  ],
                  [
                    39531.1,
                    46256.1
                  ],
                  [
                    39498.4,
                    46364.1
                  ],
                  [
                    39741.9,
                    46363.8
                  ],
                  [
                    39969.6,
                    46457.9
                  ],
                  [
                    40098.6,
                    46645.3
                  ],
                  [
                    40232.4,
                    46638.4
                  ],
                  [
                    40323.1,
                    46505.5
                  ],
                  [
                    40237.3,
                    46415.6
                  ],
                  [
                    40059.5,
                    46204.5
                  ],
                  [
                    40036.7,
                    46127.1
                  ],
                  [
                    40041.5,
                    46097.5
                  ],
                  [
                    40054.4,
                    46074.8
                  ],
                  [
                    40054.9,
                    46040.5
                  ],
                  [
                    40063.9,
                    46001.8
                  ],
                  [
                    40027.3,
                    45982
                  ],
                  [
                    39954.3,
                    45970.1
                  ],
                  [
                    39919.2,
                    45928.3
                  ],
                  [
                    39938.4,
                    45876.3
                  ],
                  [
                    39948.2,
                    45866.6
                  ],
                  [
                    39945,
                    45845.1
                  ],
                  [
                    39953.6,
                    45826
                  ],
                  [
                    40006.4,
                    45797
                  ],
                  [
                    39981.2,
                    45770.1
                  ],
                  [
                    39959.4,
                    45761.5
                  ],
                  [
                    39928.6,
                    45759.3
                  ],
                  [
                    39920.5,
                    45734.1
                  ],
                  [
                    39897.1,
                    45726.7
                  ],
                  [
                    39891.1,
                    45710.3
                  ],
                  [
                    39894.3,
                    45678.4
                  ],
                  [
                    39837,
                    45618.2
                  ],
                  [
                    39810.8,
                    45598.8
                  ],
                  [
                    39803.1,
                    45561.6
                  ],
                  [
                    39626.7,
                    45650.1
                  ],
                  [
                    39567.6,
                    45676
                  ],
                  [
                    39502.5,
                    45685.5
                  ],
                  [
                    39502.6,
                    45837.6
                  ]
                ],
                "id": 1407,
                "chat_link": "[&BH8FAAA=]"
              },
              "1408": {
                "name": "Sulfurous Deep",
                "level": 80,
                "coord": [
                  38981.1,
                  46592.3
                ],
                "bounds": [
                  [
                    39253.1,
                    46181.4
                  ],
                  [
                    39538.2,
                    46255
                  ],
                  [
                    39504,
                    46361.7
                  ],
                  [
                    39412.2,
                    46792.8
                  ],
                  [
                    39529.2,
                    47128.4
                  ],
                  [
                    39401.7,
                    47129
                  ],
                  [
                    39156,
                    46970.3
                  ],
                  [
                    39025.2,
                    46986.1
                  ],
                  [
                    38961.2,
                    47080.6
                  ],
                  [
                    38818.2,
                    47145.1
                  ],
                  [
                    38678.1,
                    47115.6
                  ],
                  [
                    38727.3,
                    46872.6
                  ],
                  [
                    38660.5,
                    46686.6
                  ],
                  [
                    38361.1,
                    46427.8
                  ],
                  [
                    38500.6,
                    46301.3
                  ],
                  [
                    38564.5,
                    46118.2
                  ],
                  [
                    38780.3,
                    46140.2
                  ],
                  [
                    38804,
                    46206.9
                  ],
                  [
                    38841.5,
                    46225.9
                  ],
                  [
                    38765.5,
                    46366.5
                  ],
                  [
                    38856.9,
                    46398.9
                  ],
                  [
                    38905.6,
                    46564
                  ],
                  [
                    38967,
                    46663.8
                  ],
                  [
                    39029.2,
                    46646.2
                  ],
                  [
                    39064.8,
                    46463
                  ],
                  [
                    39136.8,
                    46437.7
                  ],
                  [
                    39247.4,
                    46327
                  ],
                  [
                    39253.1,
                    46181.4
                  ]
                ],
                "id": 1408,
                "chat_link": "[&BIAFAAA=]"
              }
            },
            "adventures": [],
            "id": 1175,
            "mastery_points": [
              {
                "coord": [
                  40596.3,
                  45373.7
                ],
                "id": 285,
                "region": "Maguuma"
              },
              {
                "coord": [
                  37961.4,
                  45474.1
                ],
                "id": 287,
                "region": "Maguuma"
              }
            ]
          },
          "1195": {
            "name": "Draconis Mons",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              36518,
              41584
            ],
            "map_rect": [
              [
                -46080,
                -46080
              ],
              [
                46080,
                46080
              ]
            ],
            "continent_rect": [
              [
                34718,
                39284
              ],
              [
                38558,
                43124
              ]
            ],
            "points_of_interest": {
              "2488": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  36804.6,
                  42410.8
                ],
                "id": 2488,
                "chat_link": "[&BLgJAAA=]"
              },
              "2491": {
                "type": "vista",
                "floor": 2,
                "coord": [
                  36899.3,
                  41191.9
                ],
                "id": 2491,
                "chat_link": "[&BLsJAAA=]"
              },
              "2493": {
                "name": "Mariner Landing Waypoint",
                "type": "waypoint",
                "floor": 0,
                "coord": [
                  36016.2,
                  41919.2
                ],
                "id": 2493,
                "chat_link": "[&BL0JAAA=]"
              },
              "2494": {
                "name": "Eternal Pool",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36594.9,
                  42814.4
                ],
                "id": 2494,
                "chat_link": "[&BL4JAAA=]"
              },
              "2495": {
                "type": "vista",
                "floor": 2,
                "coord": [
                  36193.9,
                  41874.6
                ],
                "id": 2495,
                "chat_link": "[&BL8JAAA=]"
              },
              "2496": {
                "type": "vista",
                "floor": 0,
                "coord": [
                  36103.4,
                  41884.8
                ],
                "id": 2496,
                "chat_link": "[&BMAJAAA=]"
              },
              "2498": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  36427.7,
                  41033.6
                ],
                "id": 2498,
                "chat_link": "[&BMIJAAA=]"
              },
              "2501": {
                "name": "Druid's Grotto",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37398.9,
                  41914.3
                ],
                "id": 2501,
                "chat_link": "[&BMUJAAA=]"
              },
              "2502": {
                "name": "Golem Graveyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36327.2,
                  40956.7
                ],
                "id": 2502,
                "chat_link": "[&BMYJAAA=]"
              },
              "2505": {
                "name": "Peace Grounds",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  37613.1,
                  41663.7
                ],
                "id": 2505,
                "chat_link": "[&BMkJAAA=]"
              },
              "2509": {
                "name": "Heathen's Hold Waypoint",
                "type": "waypoint",
                "floor": 2,
                "coord": [
                  37310,
                  41714.3
                ],
                "id": 2509,
                "chat_link": "[&BM0JAAA=]"
              },
              "2510": {
                "name": "Viraddi's Salvation",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36917.3,
                  42331.1
                ],
                "id": 2510,
                "chat_link": "[&BM4JAAA=]"
              },
              "2512": {
                "name": "Scout's Clearing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36559.8,
                  42421.1
                ],
                "id": 2512,
                "chat_link": "[&BNAJAAA=]"
              },
              "2517": {
                "name": "Ancient Hollow Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  36589.4,
                  41018.7
                ],
                "id": 2517,
                "chat_link": "[&BNUJAAA=]"
              },
              "2518": {
                "name": "Nu Vault",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  36606.1,
                  41135.9
                ],
                "id": 2518,
                "chat_link": "[&BNYJAAA=]"
              }
            },
            "tasks": {
              "378": {
                "objective": "Assist the ancient golems.",
                "level": 80,
                "coord": [
                  36523.1,
                  41035.7
                ],
                "bounds": [
                  [
                    36086.8,
                    40874.3
                  ],
                  [
                    36492.2,
                    40707.2
                  ],
                  [
                    36680.4,
                    40803.4
                  ],
                  [
                    36833.1,
                    41249.8
                  ],
                  [
                    36625,
                    41472.2
                  ],
                  [
                    36154.9,
                    41363.3
                  ],
                  [
                    36086.8,
                    40874.3
                  ]
                ],
                "id": 378,
                "chat_link": "[&BHoBAAA=]"
              },
              "379": {
                "objective": "Help the Prisoners",
                "level": 80,
                "coord": [
                  37357.6,
                  41649.9
                ],
                "bounds": [
                  [
                    36898.6,
                    41505.6
                  ],
                  [
                    36761.7,
                    41181.5
                  ],
                  [
                    36761.7,
                    41072.8
                  ],
                  [
                    37255.4,
                    40965.6
                  ],
                  [
                    37255.4,
                    41461.3
                  ],
                  [
                    37182.8,
                    41618.9
                  ],
                  [
                    37048.5,
                    41594.1
                  ],
                  [
                    36898.6,
                    41505.6
                  ]
                ],
                "id": 379,
                "chat_link": "[&BHsBAAA=]"
              },
              "380": {
                "objective": "Infiltrate the Inquest.",
                "level": 80,
                "coord": [
                  36111.2,
                  41541.4
                ],
                "bounds": [
                  [
                    35954.8,
                    42013.7
                  ],
                  [
                    35839,
                    41813.1
                  ],
                  [
                    35888.4,
                    41637.3
                  ],
                  [
                    36011.1,
                    41514
                  ],
                  [
                    36141.7,
                    41469.6
                  ],
                  [
                    36188,
                    41519.4
                  ],
                  [
                    36243.4,
                    41814.3
                  ],
                  [
                    36121,
                    42022.1
                  ],
                  [
                    35954.8,
                    42013.7
                  ]
                ],
                "id": 380,
                "chat_link": "[&BHwBAAA=]"
              },
              "381": {
                "objective": "Help the scouting party.",
                "level": 80,
                "coord": [
                  36551.4,
                  42395
                ],
                "bounds": [
                  [
                    36381.9,
                    42123.9
                  ],
                  [
                    36809.8,
                    41964.9
                  ],
                  [
                    37236.4,
                    42691.1
                  ],
                  [
                    36720.5,
                    42894.2
                  ],
                  [
                    36352.5,
                    42964.2
                  ],
                  [
                    36381.9,
                    42123.9
                  ]
                ],
                "id": 381,
                "chat_link": "[&BH0BAAA=]"
              }
            },
            "skill_challenges": [],
            "sectors": {
              "1452": {
                "name": "Titan's Throat",
                "level": 80,
                "coord": [
                  36667.1,
                  41773.1
                ],
                "bounds": [
                  [
                    36491,
                    42033
                  ],
                  [
                    36344.4,
                    41801
                  ],
                  [
                    36595,
                    41536.1
                  ],
                  [
                    36803,
                    41541.7
                  ],
                  [
                    36953,
                    41747.8
                  ],
                  [
                    36816.1,
                    41979
                  ],
                  [
                    36491,
                    42033
                  ]
                ],
                "id": 1452,
                "chat_link": "[&BKwFAAA=]"
              },
              "1455": {
                "name": "Ancient Hollow",
                "level": 80,
                "coord": [
                  36787.7,
                  41139.1
                ],
                "bounds": [
                  [
                    36595.1,
                    41539
                  ],
                  [
                    36455.6,
                    41686.5
                  ],
                  [
                    35892.3,
                    40807.6
                  ],
                  [
                    36321.3,
                    40449.8
                  ],
                  [
                    37085.1,
                    40554.3
                  ],
                  [
                    37450.2,
                    40896.1
                  ],
                  [
                    37611.9,
                    41128.6
                  ],
                  [
                    36875.3,
                    41647
                  ],
                  [
                    36802.5,
                    41543.1
                  ],
                  [
                    36595.1,
                    41539
                  ]
                ],
                "id": 1455,
                "chat_link": "[&BK8FAAA=]"
              },
              "1460": {
                "name": "Savage Rise",
                "level": 80,
                "coord": [
                  36859.8,
                  42108.1
                ],
                "bounds": [
                  [
                    36553.2,
                    42959.4
                  ],
                  [
                    36172.9,
                    42751
                  ],
                  [
                    35951.7,
                    42493.4
                  ],
                  [
                    35906.3,
                    42363.3
                  ],
                  [
                    36443.3,
                    41955.1
                  ],
                  [
                    36490.8,
                    42032.7
                  ],
                  [
                    36814.6,
                    41979
                  ],
                  [
                    36956.8,
                    41749.9
                  ],
                  [
                    36874.9,
                    41646.2
                  ],
                  [
                    37612.2,
                    41128.1
                  ],
                  [
                    37610.6,
                    41464.3
                  ],
                  [
                    37775,
                    41842.1
                  ],
                  [
                    37647.5,
                    42437.6
                  ],
                  [
                    37227.8,
                    42711.6
                  ],
                  [
                    36553.2,
                    42959.4
                  ]
                ],
                "id": 1460,
                "chat_link": "[&BLQFAAA=]"
              },
              "1465": {
                "name": "Wind Rider Ledge",
                "level": 80,
                "coord": [
                  36024.6,
                  41745.5
                ],
                "bounds": [
                  [
                    36443.5,
                    41955.1
                  ],
                  [
                    35907.5,
                    42365.4
                  ],
                  [
                    35660.7,
                    42070.8
                  ],
                  [
                    35466,
                    41533.3
                  ],
                  [
                    35892.2,
                    40806.1
                  ],
                  [
                    36455.9,
                    41686.6
                  ],
                  [
                    36346.5,
                    41801.3
                  ],
                  [
                    36443.5,
                    41955.1
                  ]
                ],
                "id": 1465,
                "chat_link": "[&BLkFAAA=]"
              }
            },
            "adventures": [],
            "id": 1195,
            "mastery_points": [
              {
                "coord": [
                  37130.9,
                  42448.7
                ],
                "id": 304,
                "region": "Maguuma"
              },
              {
                "coord": [
                  36709.5,
                  41114.3
                ],
                "id": 300,
                "region": "Maguuma"
              },
              {
                "coord": [
                  36377.2,
                  41304.8
                ],
                "id": 298,
                "region": "Maguuma"
              }
            ]
          }
        },
        "id": 20
      },
      "37": {
        "name": "Cantha",
        "label_coord": [
          28750,
          101100
        ],
        "continent_rect": [
          [
            21000,
            97000
          ],
          [
            29192,
            107880
          ]
        ],
        "maps": {
            "1465": {
            "name": "Thousand Seas Pavilion",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 80,
            "label_coord": [
              21250,
              99025
            ],
            "map_rect": [
              [
                -15360,
                -15360
              ],
              [
                15360,
                15360
              ]
            ],
            "continent_rect": [
              [
                20900,
                98125
              ],
              [
                22180,
                99405
              ]
            ],
            "points_of_interest": {
              "3449": {
                "name": "Thousand Seas Pavilion Waypoint",
                "type": "waypoint",
                "floor": 80,
                "coord": [
                  21700.7,
                  99110.4
                ],
                "id": 3449,
                "chat_link": "[&BHkNAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1930": {
                "name": "Thousand Seas Pavilion",
                "level": 80,
                "coord": [
                  21488.9,
                  98897
                ],
                "bounds": [
                  [
                    20933.3,
                    99293.2
                  ],
                  [
                    20923.3,
                    99059
                  ],
                  [
                    20911.1,
                    98972
                  ],
                  [
                    21033.7,
                    98540.2
                  ],
                  [
                    21210,
                    98420.1
                  ],
                  [
                    21447.7,
                    98345.5
                  ],
                  [
                    21775.4,
                    98354.6
                  ],
                  [
                    21915.4,
                    98466.1
                  ],
                  [
                    22032,
                    98623
                  ],
                  [
                    22029.4,
                    98837.2
                  ],
                  [
                    21977.3,
                    99242.4
                  ],
                  [
                    21865.2,
                    99308
                  ],
                  [
                    21774.8,
                    99332.3
                  ],
                  [
                    21502.2,
                    99307.7
                  ],
                  [
                    21002.3,
                    99354
                  ],
                  [
                    20933.3,
                    99293.2
                  ]
                ],
                "id": 1930,
                "chat_link": "[&BIoHAAA=]"
              }
            },
            "adventures": [],
            "id": 1465,
            "mastery_points": []
          },
          "1415": {
            "name": "The Future in Jade: Power Plant",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              27000,
              99400
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                25000,
                98100
              ],
              [
                28840,
                100660
              ]
            ],
            "points_of_interest": {
              "3377": {
                "name": "Central Power Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  26066.9,
                  99380.6
                ],
                "id": 3377,
                "chat_link": "[&BDENAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1876": {
                "name": "Baedal Hill",
                "level": 80,
                "coord": [
                  26468.1,
                  98687.7
                ],
                "bounds": [
                  [
                    26105,
                    99212
                  ],
                  [
                    25971.3,
                    99212.6
                  ],
                  [
                    25973.1,
                    99120.1
                  ],
                  [
                    26014.3,
                    98985.4
                  ],
                  [
                    26038.1,
                    98922.3
                  ],
                  [
                    26076.7,
                    98869.3
                  ],
                  [
                    26184.3,
                    98738.8
                  ],
                  [
                    26240.9,
                    98693.9
                  ],
                  [
                    26301,
                    98652.4
                  ],
                  [
                    26360.3,
                    98622
                  ],
                  [
                    26498.1,
                    98606.3
                  ],
                  [
                    26622.2,
                    98605.9
                  ],
                  [
                    26622.7,
                    98318.5
                  ],
                  [
                    26555,
                    98318.8
                  ],
                  [
                    26552.3,
                    98187.3
                  ],
                  [
                    26830.3,
                    98183.6
                  ],
                  [
                    26832.5,
                    98246
                  ],
                  [
                    26917.5,
                    98246.5
                  ],
                  [
                    26913,
                    98327.9
                  ],
                  [
                    26872.4,
                    98328
                  ],
                  [
                    26868,
                    98459.2
                  ],
                  [
                    26867.1,
                    98508.1
                  ],
                  [
                    26871.4,
                    98691.2
                  ],
                  [
                    26729.4,
                    98698.6
                  ],
                  [
                    26729,
                    98744.8
                  ],
                  [
                    26638.1,
                    98729.4
                  ],
                  [
                    26524.3,
                    98754.4
                  ],
                  [
                    26425.8,
                    98814.9
                  ],
                  [
                    26420.3,
                    98874
                  ],
                  [
                    26347,
                    98877.7
                  ],
                  [
                    26267.7,
                    98966.4
                  ],
                  [
                    26174.8,
                    99079.1
                  ],
                  [
                    26104,
                    99099.6
                  ],
                  [
                    26105,
                    99212
                  ]
                ],
                "id": 1876,
                "chat_link": "[&BFQHAAA=]"
              },
              "1891": {
                "name": "Power Plant",
                "level": 80,
                "coord": [
                  25934.4,
                  99341.9
                ],
                "bounds": [
                  [
                    25743.1,
                    99533.1
                  ],
                  [
                    26102.3,
                    99529.3
                  ],
                  [
                    26105,
                    99212
                  ],
                  [
                    25971.3,
                    99212.6
                  ],
                  [
                    25750.2,
                    99222.3
                  ],
                  [
                    25743.1,
                    99533.1
                  ]
                ],
                "id": 1891,
                "chat_link": "[&BGMHAAA=]"
              },
              "1917": {
                "name": "Garden Heights",
                "level": 80,
                "coord": [
                  26112,
                  98728.1
                ],
                "bounds": [
                  [
                    26622.7,
                    98318.5
                  ],
                  [
                    26555,
                    98318.8
                  ],
                  [
                    26451,
                    98320.5
                  ],
                  [
                    26369,
                    98329.8
                  ],
                  [
                    26290.5,
                    98350.2
                  ],
                  [
                    26160.4,
                    98386.4
                  ],
                  [
                    26081.2,
                    98433.9
                  ],
                  [
                    25925,
                    98577.6
                  ],
                  [
                    25813.9,
                    98696.8
                  ],
                  [
                    25766.9,
                    98783.3
                  ],
                  [
                    25714.5,
                    98922.8
                  ],
                  [
                    25699,
                    99004.9
                  ],
                  [
                    25684.3,
                    99115.2
                  ],
                  [
                    25748.8,
                    99120.6
                  ],
                  [
                    25750.2,
                    99222.3
                  ],
                  [
                    25971.3,
                    99212.6
                  ],
                  [
                    25973.1,
                    99120.1
                  ],
                  [
                    26014.3,
                    98985.4
                  ],
                  [
                    26038.1,
                    98922.3
                  ],
                  [
                    26076.7,
                    98869.3
                  ],
                  [
                    26184.3,
                    98738.8
                  ],
                  [
                    26240.9,
                    98693.9
                  ],
                  [
                    26301,
                    98652.4
                  ],
                  [
                    26360.3,
                    98622
                  ],
                  [
                    26498.1,
                    98606.3
                  ],
                  [
                    26622.2,
                    98605.9
                  ],
                  [
                    26622.7,
                    98318.5
                  ]
                ],
                "id": 1917,
                "chat_link": "[&BH0HAAA=]"
              }
            },
            "adventures": [],
            "id": 1415,
            "mastery_points": []
          },
          "1419": {
            "name": "Isle of Reflection",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              22250,
              104696
            ],
            "map_rect": [
              [
                -21504,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                21319,
                103145
              ],
              [
                23239,
                105705
              ]
            ],
            "points_of_interest": {
              "3294": {
                "name": "Reflection Arena Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  22232,
                  105006
                ],
                "id": 3294,
                "chat_link": "[&BN4MAAA=]"
              },
              "3315": {
                "name": "Reflection Docks Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  21852.2,
                  104468
                ],
                "id": 3315,
                "chat_link": "[&BPMMAAA=]"
              },
              "3342": {
                "name": "Reflection Crystal Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  22018.7,
                  105151
                ],
                "id": 3342,
                "chat_link": "[&BA4NAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1854": {
                "level": 0,
                "coord": [
                  22374.8,
                  104740
                ],
                "bounds": [
                  [
                    23002.5,
                    104067
                  ],
                  [
                    23114.4,
                    104560
                  ],
                  [
                    23088.7,
                    105487
                  ],
                  [
                    22923.7,
                    105576
                  ],
                  [
                    21724.4,
                    105618
                  ],
                  [
                    21504.2,
                    105470
                  ],
                  [
                    21529.7,
                    104145
                  ],
                  [
                    21723.1,
                    103898
                  ],
                  [
                    22762.5,
                    103835
                  ],
                  [
                    23002.5,
                    104067
                  ]
                ],
                "id": 1854,
                "chat_link": "[&BD4HAAA=]"
              }
            },
            "id": 1419,
            "mastery_points": [],
            "adventures": []
          },
          "1420": {
            "name": "Fallout: Nika's Blade",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              27000,
              99400
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                25000,
                98100
              ],
              [
                28840,
                100660
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1916": {
                "name": "Lutgardis Plaza",
                "level": 80,
                "coord": [
                  27793.1,
                  99423.8
                ],
                "bounds": [
                  [
                    27269.4,
                    99064.4
                  ],
                  [
                    27285.7,
                    99716.5
                  ],
                  [
                    27288.8,
                    99863.8
                  ],
                  [
                    27978,
                    99867
                  ],
                  [
                    27971.1,
                    99768.2
                  ],
                  [
                    27966.6,
                    99561.8
                  ],
                  [
                    28031.1,
                    99381.5
                  ],
                  [
                    28098.6,
                    99332.4
                  ],
                  [
                    28204.3,
                    99332.3
                  ],
                  [
                    28205.4,
                    99063.2
                  ],
                  [
                    27784.5,
                    99069
                  ],
                  [
                    27433.8,
                    99064.9
                  ],
                  [
                    27269.4,
                    99064.4
                  ]
                ],
                "id": 1916,
                "chat_link": "[&BHwHAAA=]"
              },
              "1927": {
                "name": "Grub Lane",
                "level": 80,
                "coord": [
                  28324.9,
                  99439.6
                ],
                "bounds": [
                  [
                    27971.1,
                    99768.2
                  ],
                  [
                    28694.4,
                    99763.8
                  ],
                  [
                    28684.1,
                    99501.3
                  ],
                  [
                    28685.3,
                    99312
                  ],
                  [
                    28706.8,
                    99225.7
                  ],
                  [
                    28207,
                    99217.2
                  ],
                  [
                    28204.3,
                    99332.3
                  ],
                  [
                    28098.6,
                    99332.4
                  ],
                  [
                    28031.1,
                    99381.5
                  ],
                  [
                    27966.6,
                    99561.8
                  ],
                  [
                    27971.1,
                    99768.2
                  ]
                ],
                "id": 1927,
                "chat_link": "[&BIcHAAA=]"
              }
            },
            "adventures": [],
            "id": 1420,
            "mastery_points": []
          },
          "1421": {
            "name": "???",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              23150,
              101800
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                33792
              ]
            ],
            "continent_rect": [
              [
                21159,
                100457
              ],
              [
                24999,
                103145
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1421,
            "mastery_points": []
          },
          "1422": {
            "name": "Dragon's End",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              34175,
              103437
            ],
            "map_rect": [
              [
                -24576,
                -43008
              ],
              [
                27648,
                46080
              ]
            ],
            "continent_rect": [
              [
                33126,
                101838
              ],
              [
                35302,
                105550
              ]
            ],
            "points_of_interest": {
              "3212": {
                "name": "Frozen Sea Monastery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34125.1,
                  105413
                ],
                "id": 3212,
                "chat_link": "[&BIwMAAA=]"
              },
              "3216": {
                "name": "Saltspray Roost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33882.9,
                  103530
                ],
                "id": 3216,
                "chat_link": "[&BJAMAAA=]"
              },
              "3217": {
                "name": "Seaguard's Crossing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34101.7,
                  103129
                ],
                "id": 3217,
                "chat_link": "[&BJEMAAA=]"
              },
              "3218": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  33696.5,
                  103166
                ],
                "id": 3218,
                "chat_link": "[&BJIMAAA=]"
              },
              "3220": {
                "name": "Tanasen Pier",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34424.2,
                  102779
                ],
                "id": 3220,
                "chat_link": "[&BJQMAAA=]"
              },
              "3224": {
                "name": "Jade Wind's Respite",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33564.3,
                  105327
                ],
                "id": 3224,
                "chat_link": "[&BJgMAAA=]"
              },
              "3232": {
                "name": "Harvest Complex Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34181,
                  103953
                ],
                "id": 3232,
                "chat_link": "[&BKAMAAA=]"
              },
              "3233": {
                "name": "The Great Melt",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33934.5,
                  104276
                ],
                "id": 3233,
                "chat_link": "[&BKEMAAA=]"
              },
              "3234": {
                "name": "Jade Quarry Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  33825.5,
                  102383
                ],
                "id": 3234,
                "chat_link": "[&BKIMAAA=]"
              },
              "3237": {
                "name": "Harvest Temple",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34174.2,
                  104606
                ],
                "id": 3237,
                "chat_link": "[&BKUMAAA=]"
              },
              "3238": {
                "name": "Harvest Temple Observatory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34180.9,
                  103841
                ],
                "id": 3238,
                "chat_link": "[&BKYMAAA=]"
              },
              "3241": {
                "name": "Guardian's Perch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33360.8,
                  103922
                ],
                "id": 3241,
                "chat_link": "[&BKkMAAA=]"
              },
              "3252": {
                "name": "Speakers Encampment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35025.5,
                  102535
                ],
                "id": 3252,
                "chat_link": "[&BLQMAAA=]"
              },
              "3253": {
                "name": "Juno Hatchery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34878.4,
                  103940
                ],
                "id": 3253,
                "chat_link": "[&BLUMAAA=]"
              },
              "3260": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  34960.6,
                  103939
                ],
                "id": 3260,
                "chat_link": "[&BLwMAAA=]"
              },
              "3262": {
                "name": "The Great Jade Wall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35127,
                  103230
                ],
                "id": 3262,
                "chat_link": "[&BL4MAAA=]"
              },
              "3264": {
                "name": "Mine Site JS-02",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33768.6,
                  103178
                ],
                "id": 3264,
                "chat_link": "[&BMAMAAA=]"
              },
              "3266": {
                "name": "Icebrood's Desolation",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34926.8,
                  104259
                ],
                "id": 3266,
                "chat_link": "[&BMIMAAA=]"
              },
              "3268": {
                "name": "Shrine to Hanuku",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35037.6,
                  102797
                ],
                "id": 3268,
                "chat_link": "[&BMQMAAA=]"
              },
              "3278": {
                "name": "Jade Brotherhood Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33408.9,
                  104596
                ],
                "id": 3278,
                "chat_link": "[&BM4MAAA=]"
              },
              "3279": {
                "name": "Logistics District",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33561.4,
                  102213
                ],
                "id": 3279,
                "chat_link": "[&BM8MAAA=]"
              },
              "3280": {
                "name": "Font of Elders",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34432.4,
                  105132
                ],
                "id": 3280,
                "chat_link": "[&BNAMAAA=]"
              },
              "3287": {
                "name": "Emerald Bluff",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34610.3,
                  105152
                ],
                "id": 3287,
                "chat_link": "[&BNcMAAA=]"
              },
              "3288": {
                "name": "Shrine of the Serpent",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34776.4,
                  102102
                ],
                "id": 3288,
                "chat_link": "[&BNgMAAA=]"
              },
              "3289": {
                "name": "Temple of the Turtle",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34494,
                  103474
                ],
                "id": 3289,
                "chat_link": "[&BNkMAAA=]"
              },
              "3290": {
                "name": "Archemorus's Solitude",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34021,
                  105000
                ],
                "id": 3290,
                "chat_link": "[&BNoMAAA=]"
              },
              "3299": {
                "name": "Temple of the Fallen",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33450.2,
                  103787
                ],
                "id": 3299,
                "chat_link": "[&BOMMAAA=]"
              },
              "3313": {
                "name": "Frozen Sea Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34126,
                  105319
                ],
                "id": 3313,
                "chat_link": "[&BPEMAAA=]"
              },
              "3314": {
                "name": "Alua Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35007.3,
                  102169
                ],
                "id": 3314,
                "chat_link": "[&BPIMAAA=]"
              },
              "3317": {
                "name": "Miner's Folly",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34343.5,
                  103218
                ],
                "id": 3317,
                "chat_link": "[&BPUMAAA=]"
              },
              "3319": {
                "name": "Argo Crawler",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33678.8,
                  103164
                ],
                "id": 3319,
                "chat_link": "[&BPcMAAA=]"
              },
              "3320": {
                "name": "Risen's Havoc",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34705.8,
                  104812
                ],
                "id": 3320,
                "chat_link": "[&BPgMAAA=]"
              },
              "3333": {
                "name": "The Jade Expanse",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35150.9,
                  105394
                ],
                "id": 3333,
                "chat_link": "[&BAUNAAA=]"
              },
              "3336": {
                "name": "Harvest Bridge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34179.6,
                  104262
                ],
                "id": 3336,
                "chat_link": "[&BAgNAAA=]"
              },
              "3345": {
                "name": "Brotherhood Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  33392,
                  104381
                ],
                "id": 3345,
                "chat_link": "[&BBENAAA=]"
              },
              "3347": {
                "name": "The Green Grotto",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34392.3,
                  102241
                ],
                "id": 3347,
                "chat_link": "[&BBMNAAA=]"
              },
              "3352": {
                "name": "Xinrae's Wharf",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34206.6,
                  105052
                ],
                "id": 3352,
                "chat_link": "[&BBgNAAA=]"
              },
              "3355": {
                "name": "Wasteland of the Destroyer",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33385.4,
                  104172
                ],
                "id": 3355,
                "chat_link": "[&BBsNAAA=]"
              },
              "3356": {
                "name": "Kaolai Tower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34670.5,
                  102781
                ],
                "id": 3356,
                "chat_link": "[&BBwNAAA=]"
              },
              "3361": {
                "name": "Quarry Passage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34133.2,
                  102876
                ],
                "id": 3361,
                "chat_link": "[&BCENAAA=]"
              },
              "3363": {
                "name": "Chantry of the Crab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34984.3,
                  103507
                ],
                "id": 3363,
                "chat_link": "[&BCMNAAA=]"
              },
              "3367": {
                "name": "Speakers Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35030.4,
                  104634
                ],
                "id": 3367,
                "chat_link": "[&BCcNAAA=]"
              },
              "3370": {
                "name": "Branded Rise",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34175.2,
                  104095
                ],
                "id": 3370,
                "chat_link": "[&BCoNAAA=]"
              },
              "3372": {
                "name": "Residential District",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33924.6,
                  102190
                ],
                "id": 3372,
                "chat_link": "[&BCwNAAA=]"
              },
              "3373": {
                "name": "Mine Site JS-36",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34930.8,
                  103215
                ],
                "id": 3373,
                "chat_link": "[&BC0NAAA=]"
              },
              "3378": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  34125.5,
                  105376
                ],
                "id": 3378,
                "chat_link": "[&BDINAAA=]"
              },
              "3379": {
                "name": "Xunlai Jade Museum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34520.1,
                  104517
                ],
                "id": 3379,
                "chat_link": "[&BDMNAAA=]"
              },
              "3387": {
                "name": "Speakers Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  34978.6,
                  104479
                ],
                "id": 3387,
                "chat_link": "[&BDsNAAA=]"
              },
              "3389": {
                "name": "Rhea's Landing",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33579.4,
                  103433
                ],
                "id": 3389,
                "chat_link": "[&BD0NAAA=]"
              },
              "3391": {
                "name": "Brotherhood's Watch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33558.3,
                  102846
                ],
                "id": 3391,
                "chat_link": "[&BD8NAAA=]"
              },
              "3396": {
                "name": "Xiko Refugee Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34263.1,
                  102468
                ],
                "id": 3396,
                "chat_link": "[&BEQNAAA=]"
              },
              "3398": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  34464.9,
                  102301
                ],
                "id": 3398,
                "chat_link": "[&BEYNAAA=]"
              },
              "3400": {
                "name": "Sanctuary of Ione",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34911.5,
                  105056
                ],
                "id": 3400,
                "chat_link": "[&BEgNAAA=]"
              },
              "3406": {
                "name": "Mordrem's Blight",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33726.3,
                  104820
                ],
                "id": 3406,
                "chat_link": "[&BE4NAAA=]"
              },
              "3409": {
                "name": "Elora's Beach",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  35096.2,
                  104104
                ],
                "id": 3409,
                "chat_link": "[&BFENAAA=]"
              },
              "3414": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  34680.6,
                  102731
                ],
                "id": 3414,
                "chat_link": "[&BFYNAAA=]"
              },
              "3420": {
                "name": "Kuan Jun Pavilion",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  34336.5,
                  103939
                ],
                "id": 3420,
                "chat_link": "[&BFwNAAA=]"
              },
              "3426": {
                "name": "Warehouse District",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  33426,
                  102633
                ],
                "id": 3426,
                "chat_link": "[&BGINAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [
              {
                "coord": [
                  33962.2,
                  102148
                ]
              },
              {
                "coord": [
                  34441.4,
                  103193
                ]
              },
              {
                "coord": [
                  34930.7,
                  103939
                ]
              },
              {
                "coord": [
                  34331.8,
                  104188
                ]
              },
              {
                "coord": [
                  34398.8,
                  102217
                ]
              },
              {
                "coord": [
                  34132.4,
                  104279
                ]
              }
            ],
            "sectors": {
              "1849": {
                "name": "Seafarer's Enclave",
                "level": 80,
                "coord": [
                  34920.2,
                  103825
                ],
                "bounds": [
                  [
                    35165.7,
                    103247
                  ],
                  [
                    35162.1,
                    103456
                  ],
                  [
                    35104.5,
                    103575
                  ],
                  [
                    35165,
                    103795
                  ],
                  [
                    35173.1,
                    104030
                  ],
                  [
                    35212.2,
                    104215
                  ],
                  [
                    35195,
                    104371
                  ],
                  [
                    34783.7,
                    104396
                  ],
                  [
                    34728,
                    104200
                  ],
                  [
                    34656.3,
                    104032
                  ],
                  [
                    34586.8,
                    103950
                  ],
                  [
                    34630.6,
                    103763
                  ],
                  [
                    34785.5,
                    103640
                  ],
                  [
                    34785.9,
                    103453
                  ],
                  [
                    34669.2,
                    103248
                  ],
                  [
                    35165.7,
                    103247
                  ]
                ],
                "id": 1849,
                "chat_link": "[&BDkHAAA=]"
              },
              "1852": {
                "name": "Harvest Complex",
                "level": 80,
                "coord": [
                  34232,
                  104194
                ],
                "bounds": [
                  [
                    34112.3,
                    104288
                  ],
                  [
                    34001.1,
                    104348
                  ],
                  [
                    33946.4,
                    104453
                  ],
                  [
                    33675.5,
                    104328
                  ],
                  [
                    33724.2,
                    104122
                  ],
                  [
                    33729.2,
                    104016
                  ],
                  [
                    33810.4,
                    103896
                  ],
                  [
                    33857.5,
                    103880
                  ],
                  [
                    33905.5,
                    103868
                  ],
                  [
                    34100.3,
                    103868
                  ],
                  [
                    34157.2,
                    103914
                  ],
                  [
                    34469.6,
                    103919
                  ],
                  [
                    34586.8,
                    103950
                  ],
                  [
                    34656.3,
                    104032
                  ],
                  [
                    34728,
                    104200
                  ],
                  [
                    34783.7,
                    104396
                  ],
                  [
                    34796.7,
                    104515
                  ],
                  [
                    34639.8,
                    104601
                  ],
                  [
                    34423,
                    104598
                  ],
                  [
                    34397.2,
                    104455
                  ],
                  [
                    34349.4,
                    104340
                  ],
                  [
                    34254.3,
                    104289
                  ],
                  [
                    34112.3,
                    104288
                  ]
                ],
                "id": 1852,
                "chat_link": "[&BDwHAAA=]"
              },
              "1869": {
                "name": "Jade Promenade",
                "level": 80,
                "coord": [
                  34280.2,
                  103671
                ],
                "bounds": [
                  [
                    33810.4,
                    103609
                  ],
                  [
                    33810.4,
                    103896
                  ],
                  [
                    33857.5,
                    103880
                  ],
                  [
                    33905.5,
                    103868
                  ],
                  [
                    34100.3,
                    103868
                  ],
                  [
                    34157.2,
                    103914
                  ],
                  [
                    34469.6,
                    103919
                  ],
                  [
                    34586.8,
                    103950
                  ],
                  [
                    34630.6,
                    103763
                  ],
                  [
                    34785.5,
                    103640
                  ],
                  [
                    34785.9,
                    103453
                  ],
                  [
                    34669.2,
                    103248
                  ],
                  [
                    34514.7,
                    103333
                  ],
                  [
                    34372.5,
                    103375
                  ],
                  [
                    33746.9,
                    103353
                  ],
                  [
                    33810.4,
                    103609
                  ]
                ],
                "id": 1869,
                "chat_link": "[&BE0HAAA=]"
              },
              "1875": {
                "name": "Reaver's Ridge",
                "level": 80,
                "coord": [
                  34998.1,
                  102747
                ],
                "bounds": [
                  [
                    35165.7,
                    103247
                  ],
                  [
                    35169.5,
                    102982
                  ],
                  [
                    35161.7,
                    102723
                  ],
                  [
                    35154.6,
                    102449
                  ],
                  [
                    35183.3,
                    102261
                  ],
                  [
                    35046.8,
                    102255
                  ],
                  [
                    34899.7,
                    102299
                  ],
                  [
                    34905.9,
                    102668
                  ],
                  [
                    34920.5,
                    102808
                  ],
                  [
                    34887.7,
                    102933
                  ],
                  [
                    34812.8,
                    103091
                  ],
                  [
                    34669.2,
                    103248
                  ],
                  [
                    35165.7,
                    103247
                  ]
                ],
                "id": 1875,
                "chat_link": "[&BFMHAAA=]"
              },
              "1887": {
                "name": "Southern Bluff",
                "level": 80,
                "coord": [
                  34113.6,
                  105285
                ],
                "bounds": [
                  [
                    34261.5,
                    105143
                  ],
                  [
                    34111.5,
                    105143
                  ],
                  [
                    33918.5,
                    105106
                  ],
                  [
                    33731.8,
                    105320
                  ],
                  [
                    33748,
                    105444
                  ],
                  [
                    33973.4,
                    105438
                  ],
                  [
                    34303.4,
                    105436
                  ],
                  [
                    34502,
                    105425
                  ],
                  [
                    34472.5,
                    105108
                  ],
                  [
                    34261.5,
                    105143
                  ]
                ],
                "id": 1887,
                "chat_link": "[&BF8HAAA=]"
              },
              "1894": {
                "name": "The Jade Whirl",
                "level": 80,
                "coord": [
                  34176.8,
                  104554
                ],
                "bounds": [
                  [
                    34112.3,
                    104288
                  ],
                  [
                    34001.1,
                    104348
                  ],
                  [
                    33946.4,
                    104453
                  ],
                  [
                    33916.4,
                    104603
                  ],
                  [
                    33979.1,
                    104770
                  ],
                  [
                    34112.4,
                    104864
                  ],
                  [
                    34254.8,
                    104865
                  ],
                  [
                    34375.6,
                    104778
                  ],
                  [
                    34423,
                    104598
                  ],
                  [
                    34397.2,
                    104455
                  ],
                  [
                    34349.4,
                    104340
                  ],
                  [
                    34254.3,
                    104289
                  ],
                  [
                    34112.3,
                    104288
                  ]
                ],
                "id": 1894,
                "chat_link": "[&BGYHAAA=]"
              },
              "1900": {
                "name": "Silent Surf",
                "level": 80,
                "coord": [
                  34926.4,
                  104874
                ],
                "bounds": [
                  [
                    35026,
                    105402
                  ],
                  [
                    35144.5,
                    105354
                  ],
                  [
                    35183.8,
                    105255
                  ],
                  [
                    35194.8,
                    104747
                  ],
                  [
                    35158,
                    104627
                  ],
                  [
                    35174.5,
                    104535
                  ],
                  [
                    35195,
                    104371
                  ],
                  [
                    34783.7,
                    104396
                  ],
                  [
                    34796.7,
                    104515
                  ],
                  [
                    34871.7,
                    104663
                  ],
                  [
                    34883.8,
                    104779
                  ],
                  [
                    34833.4,
                    104896
                  ],
                  [
                    34675.4,
                    105037
                  ],
                  [
                    34472.5,
                    105108
                  ],
                  [
                    34502,
                    105425
                  ],
                  [
                    35026,
                    105402
                  ]
                ],
                "id": 1900,
                "chat_link": "[&BGwHAAA=]"
              },
              "1911": {
                "name": "Western Vale",
                "level": 80,
                "coord": [
                  33515.9,
                  103628
                ],
                "bounds": [
                  [
                    33810.4,
                    103609
                  ],
                  [
                    33810.4,
                    103896
                  ],
                  [
                    33729.2,
                    104016
                  ],
                  [
                    33724.2,
                    104122
                  ],
                  [
                    33675.5,
                    104328
                  ],
                  [
                    33283.2,
                    104324
                  ],
                  [
                    33245.3,
                    103852
                  ],
                  [
                    33276.8,
                    103528
                  ],
                  [
                    33272.9,
                    103397
                  ],
                  [
                    33243.3,
                    103191
                  ],
                  [
                    33237.4,
                    103104
                  ],
                  [
                    33525,
                    103088
                  ],
                  [
                    33522.1,
                    103280
                  ],
                  [
                    33635.5,
                    103335
                  ],
                  [
                    33746.9,
                    103353
                  ],
                  [
                    33810.4,
                    103609
                  ]
                ],
                "id": 1911,
                "chat_link": "[&BHcHAAA=]"
              },
              "1912": {
                "name": "Archipelagos Rim",
                "level": 80,
                "coord": [
                  34769.6,
                  102167
                ],
                "bounds": [
                  [
                    35091.2,
                    102049
                  ],
                  [
                    34671.5,
                    101998
                  ],
                  [
                    34491,
                    102015
                  ],
                  [
                    34161.1,
                    102077
                  ],
                  [
                    34157.3,
                    102203
                  ],
                  [
                    34507.5,
                    102333
                  ],
                  [
                    34732.6,
                    102329
                  ],
                  [
                    34899.7,
                    102299
                  ],
                  [
                    35046.8,
                    102255
                  ],
                  [
                    35183.3,
                    102261
                  ],
                  [
                    35161.5,
                    102112
                  ],
                  [
                    35132.2,
                    102067
                  ],
                  [
                    35091.2,
                    102049
                  ]
                ],
                "id": 1912,
                "chat_link": "[&BHgHAAA=]"
              },
              "1914": {
                "name": "Echovald Fringe",
                "level": 80,
                "coord": [
                  33581.6,
                  104830
                ],
                "bounds": [
                  [
                    33918.5,
                    105106
                  ],
                  [
                    33768.9,
                    105031
                  ],
                  [
                    33673.7,
                    104930
                  ],
                  [
                    33603.7,
                    104760
                  ],
                  [
                    33591.7,
                    104576
                  ],
                  [
                    33675.5,
                    104328
                  ],
                  [
                    33283.2,
                    104324
                  ],
                  [
                    33264.6,
                    104583
                  ],
                  [
                    33314.3,
                    105009
                  ],
                  [
                    33571.5,
                    105161
                  ],
                  [
                    33731.8,
                    105320
                  ],
                  [
                    33918.5,
                    105106
                  ]
                ],
                "id": 1914,
                "chat_link": "[&BHoHAAA=]"
              },
              "1919": {
                "name": "Outer Terrace",
                "level": 80,
                "coord": [
                  33992.2,
                  102779
                ],
                "bounds": [
                  [
                    33237.4,
                    103104
                  ],
                  [
                    33525,
                    103088
                  ],
                  [
                    33967.9,
                    102980
                  ],
                  [
                    34063.6,
                    103024
                  ],
                  [
                    34135.6,
                    103038
                  ],
                  [
                    34335.8,
                    102977
                  ],
                  [
                    34372.3,
                    102943
                  ],
                  [
                    34398.8,
                    102767
                  ],
                  [
                    34513.3,
                    102635
                  ],
                  [
                    34507.5,
                    102333
                  ],
                  [
                    34157.3,
                    102203
                  ],
                  [
                    34101.4,
                    102541
                  ],
                  [
                    34026.3,
                    102618
                  ],
                  [
                    33252.3,
                    102623
                  ],
                  [
                    33287.8,
                    102816
                  ],
                  [
                    33237.4,
                    103104
                  ]
                ],
                "id": 1919,
                "chat_link": "[&BH8HAAA=]"
              },
              "1920": {
                "name": "Xunlai Jade Quarry",
                "level": 80,
                "coord": [
                  33602.7,
                  102238
                ],
                "bounds": [
                  [
                    33267.8,
                    101966
                  ],
                  [
                    33400.3,
                    101983
                  ],
                  [
                    33607.3,
                    102023
                  ],
                  [
                    33969,
                    102075
                  ],
                  [
                    34161.1,
                    102077
                  ],
                  [
                    34157.3,
                    102203
                  ],
                  [
                    34101.4,
                    102541
                  ],
                  [
                    34026.3,
                    102618
                  ],
                  [
                    33252.3,
                    102623
                  ],
                  [
                    33280.5,
                    102478
                  ],
                  [
                    33262.5,
                    102304
                  ],
                  [
                    33175.8,
                    102184
                  ],
                  [
                    33172.9,
                    102016
                  ],
                  [
                    33267.8,
                    101966
                  ]
                ],
                "id": 1920,
                "chat_link": "[&BIAHAAA=]"
              },
              "1925": {
                "name": "Flooded Basin",
                "level": 80,
                "coord": [
                  34354.3,
                  102945
                ],
                "bounds": [
                  [
                    33522.1,
                    103280
                  ],
                  [
                    33525,
                    103088
                  ],
                  [
                    33967.9,
                    102980
                  ],
                  [
                    34063.6,
                    103024
                  ],
                  [
                    34135.6,
                    103038
                  ],
                  [
                    34335.8,
                    102977
                  ],
                  [
                    34372.3,
                    102943
                  ],
                  [
                    34398.8,
                    102767
                  ],
                  [
                    34513.3,
                    102635
                  ],
                  [
                    34507.5,
                    102333
                  ],
                  [
                    34732.6,
                    102329
                  ],
                  [
                    34899.7,
                    102299
                  ],
                  [
                    34905.9,
                    102668
                  ],
                  [
                    34920.5,
                    102808
                  ],
                  [
                    34887.7,
                    102933
                  ],
                  [
                    34812.8,
                    103091
                  ],
                  [
                    34669.2,
                    103248
                  ],
                  [
                    34514.7,
                    103333
                  ],
                  [
                    34372.5,
                    103375
                  ],
                  [
                    33746.9,
                    103353
                  ],
                  [
                    33635.5,
                    103335
                  ],
                  [
                    33522.1,
                    103280
                  ]
                ],
                "id": 1925,
                "chat_link": "[&BIUHAAA=]"
              },
              "1928": {
                "name": "Unwaking Waters",
                "level": 80,
                "coord": [
                  34217.5,
                  104798
                ],
                "bounds": [
                  [
                    34261.5,
                    105143
                  ],
                  [
                    34111.5,
                    105143
                  ],
                  [
                    33918.5,
                    105106
                  ],
                  [
                    33768.9,
                    105031
                  ],
                  [
                    33673.7,
                    104930
                  ],
                  [
                    33603.7,
                    104760
                  ],
                  [
                    33591.7,
                    104576
                  ],
                  [
                    33675.5,
                    104328
                  ],
                  [
                    33946.4,
                    104453
                  ],
                  [
                    33916.4,
                    104603
                  ],
                  [
                    33979.1,
                    104770
                  ],
                  [
                    34112.4,
                    104864
                  ],
                  [
                    34254.8,
                    104865
                  ],
                  [
                    34375.6,
                    104778
                  ],
                  [
                    34423,
                    104598
                  ],
                  [
                    34639.8,
                    104601
                  ],
                  [
                    34796.7,
                    104515
                  ],
                  [
                    34871.7,
                    104663
                  ],
                  [
                    34883.8,
                    104779
                  ],
                  [
                    34833.4,
                    104896
                  ],
                  [
                    34675.4,
                    105037
                  ],
                  [
                    34472.5,
                    105108
                  ],
                  [
                    34261.5,
                    105143
                  ]
                ],
                "id": 1928,
                "chat_link": "[&BIgHAAA=]"
              },
              "1929": {
                "name": "Mother's Lament",
                "level": 80,
                "coord": [
                  33542.4,
                  105335
                ],
                "bounds": [
                  [
                    33412.3,
                    105375
                  ],
                  [
                    33374.5,
                    105290
                  ],
                  [
                    33314.3,
                    105009
                  ],
                  [
                    33571.5,
                    105161
                  ],
                  [
                    33731.8,
                    105320
                  ],
                  [
                    33748,
                    105444
                  ],
                  [
                    33680.3,
                    105446
                  ],
                  [
                    33608.3,
                    105444
                  ],
                  [
                    33524,
                    105437
                  ],
                  [
                    33458.6,
                    105419
                  ],
                  [
                    33412.3,
                    105375
                  ]
                ],
                "id": 1929,
                "chat_link": "[&BIkHAAA=]"
              }
            },
            "adventures": [],
            "id": 1422,
            "mastery_points": [
              {
                "coord": [
                  34464.9,
                  102159
                ],
                "id": 641,
                "region": "Unknown"
              },
              {
                "coord": [
                  34116.4,
                  102333
                ],
                "id": 626,
                "region": "Unknown"
              },
              {
                "coord": [
                  34171.9,
                  103540
                ],
                "id": 632,
                "region": "Unknown"
              },
              {
                "coord": [
                  33850.5,
                  103840
                ],
                "id": 570,
                "region": "Unknown"
              },
              {
                "coord": [
                  33506.6,
                  104599
                ],
                "id": 618,
                "region": "Unknown"
              },
              {
                "coord": [
                  33400.9,
                  102751
                ],
                "id": 600,
                "region": "Unknown"
              }
            ]
          },
          "1426": {
            "name": "Isle of Reflection",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              22250,
              104696
            ],
            "map_rect": [
              [
                -21504,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                21319,
                103145
              ],
              [
                23239,
                105705
              ]
            ],
            "points_of_interest": {
              "3294": {
                "name": "Reflection Arena Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  22232,
                  105006
                ],
                "id": 3294,
                "chat_link": "[&BN4MAAA=]"
              },
              "3315": {
                "name": "Reflection Docks Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  21852.2,
                  104468
                ],
                "id": 3315,
                "chat_link": "[&BPMMAAA=]"
              },
              "3342": {
                "name": "Reflection Crystal Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  22018.7,
                  105151
                ],
                "id": 3342,
                "chat_link": "[&BA4NAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1854": {
                "level": 0,
                "coord": [
                  22374.8,
                  104740
                ],
                "bounds": [
                  [
                    23002.5,
                    104067
                  ],
                  [
                    23114.4,
                    104560
                  ],
                  [
                    23088.7,
                    105487
                  ],
                  [
                    22923.7,
                    105576
                  ],
                  [
                    21724.4,
                    105618
                  ],
                  [
                    21504.2,
                    105470
                  ],
                  [
                    21529.7,
                    104145
                  ],
                  [
                    21723.1,
                    103898
                  ],
                  [
                    22762.5,
                    103835
                  ],
                  [
                    23002.5,
                    104067
                  ]
                ],
                "id": 1854,
                "chat_link": "[&BD4HAAA=]"
              }
            },
            "id": 1426,
            "mastery_points": [],
            "adventures": []
          },
          "1427": {
            "name": "Weight of the World: Lady Joon's Estate",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              23150,
              101800
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                33792
              ]
            ],
            "continent_rect": [
              [
                21159,
                100457
              ],
              [
                24999,
                103145
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1853": {
                "name": "Eastern Wilds",
                "level": 80,
                "coord": [
                  24409.8,
                  102377
                ],
                "bounds": [
                  [
                    24283.8,
                    101769
                  ],
                  [
                    24211.6,
                    102047
                  ],
                  [
                    24152.9,
                    102179
                  ],
                  [
                    24116.7,
                    102269
                  ],
                  [
                    24027.8,
                    102411
                  ],
                  [
                    23990.4,
                    102573
                  ],
                  [
                    23945.8,
                    102784
                  ],
                  [
                    23966.9,
                    103136
                  ],
                  [
                    24933.7,
                    103135
                  ],
                  [
                    24987.8,
                    103132
                  ],
                  [
                    24989.3,
                    102962
                  ],
                  [
                    24989.9,
                    101825
                  ],
                  [
                    24624.4,
                    101823
                  ],
                  [
                    24518.2,
                    101794
                  ],
                  [
                    24408.2,
                    101821
                  ],
                  [
                    24283.8,
                    101769
                  ]
                ],
                "id": 1853,
                "chat_link": "[&BD0HAAA=]"
              },
              "1861": {
                "name": "Jaya Bluffs",
                "level": 80,
                "coord": [
                  21816.6,
                  101215
                ],
                "bounds": [
                  [
                    21307,
                    100850
                  ],
                  [
                    21324.4,
                    100947
                  ],
                  [
                    21348.6,
                    101112
                  ],
                  [
                    21374.1,
                    101197
                  ],
                  [
                    21415.8,
                    101339
                  ],
                  [
                    21475.2,
                    101401
                  ],
                  [
                    21571.7,
                    101530
                  ],
                  [
                    21627.7,
                    101606
                  ],
                  [
                    21563,
                    101652
                  ],
                  [
                    21712.8,
                    101702
                  ],
                  [
                    21886.1,
                    101817
                  ],
                  [
                    22002.6,
                    101779
                  ],
                  [
                    22147.1,
                    101785
                  ],
                  [
                    22386.5,
                    101850
                  ],
                  [
                    22495.1,
                    101854
                  ],
                  [
                    22471.8,
                    101702
                  ],
                  [
                    22446.1,
                    101668
                  ],
                  [
                    22447.1,
                    101596
                  ],
                  [
                    22147.8,
                    101463
                  ],
                  [
                    21958.1,
                    101398
                  ],
                  [
                    21873.3,
                    101352
                  ],
                  [
                    21817.1,
                    101238
                  ],
                  [
                    21847.8,
                    101149
                  ],
                  [
                    21855.3,
                    101076
                  ],
                  [
                    21824,
                    100954
                  ],
                  [
                    21840.6,
                    100836
                  ],
                  [
                    21941.8,
                    100674
                  ],
                  [
                    21992.9,
                    100461
                  ],
                  [
                    21869.9,
                    100591
                  ],
                  [
                    21818.9,
                    100585
                  ],
                  [
                    21719.4,
                    100682
                  ],
                  [
                    21668.7,
                    100662
                  ],
                  [
                    21571.2,
                    100595
                  ],
                  [
                    21437.7,
                    100653
                  ],
                  [
                    21393,
                    100768
                  ],
                  [
                    21307,
                    100850
                  ]
                ],
                "id": 1861,
                "chat_link": "[&BEUHAAA=]"
              },
              "1863": {
                "name": "Shinota Shore",
                "level": 80,
                "coord": [
                  22484.6,
                  101273
                ],
                "bounds": [
                  [
                    21868.7,
                    101351
                  ],
                  [
                    21952.8,
                    101398
                  ],
                  [
                    22145.6,
                    101464
                  ],
                  [
                    22441.9,
                    101600
                  ],
                  [
                    22441.2,
                    101669
                  ],
                  [
                    22467.3,
                    101707
                  ],
                  [
                    22488,
                    101856
                  ],
                  [
                    22643.5,
                    101832
                  ],
                  [
                    22753,
                    101782
                  ],
                  [
                    22826.4,
                    101774
                  ],
                  [
                    23009.5,
                    101766
                  ],
                  [
                    22921.3,
                    101651
                  ],
                  [
                    22895,
                    101557
                  ],
                  [
                    22816.1,
                    101441
                  ],
                  [
                    22816.3,
                    101348
                  ],
                  [
                    22853.9,
                    101275
                  ],
                  [
                    22914.3,
                    101261
                  ],
                  [
                    22868.9,
                    101106
                  ],
                  [
                    22794.1,
                    101013
                  ],
                  [
                    22772.5,
                    100938
                  ],
                  [
                    22863.6,
                    100852
                  ],
                  [
                    22956,
                    100701
                  ],
                  [
                    22942.8,
                    100461
                  ],
                  [
                    21987.2,
                    100466
                  ],
                  [
                    21937.8,
                    100669
                  ],
                  [
                    21837.2,
                    100830
                  ],
                  [
                    21819.1,
                    100955
                  ],
                  [
                    21850.8,
                    101074
                  ],
                  [
                    21839.2,
                    101147
                  ],
                  [
                    21814.6,
                    101234
                  ],
                  [
                    21868.7,
                    101351
                  ]
                ],
                "id": 1863,
                "chat_link": "[&BEcHAAA=]"
              },
              "1864": {
                "name": "Haiju Plains",
                "level": 80,
                "coord": [
                  23328.4,
                  101059
                ],
                "bounds": [
                  [
                    22935.4,
                    100461
                  ],
                  [
                    22950.1,
                    100701
                  ],
                  [
                    22856.6,
                    100849
                  ],
                  [
                    22763.1,
                    100926
                  ],
                  [
                    22787.1,
                    101010
                  ],
                  [
                    22863.9,
                    101108
                  ],
                  [
                    22909.3,
                    101260
                  ],
                  [
                    22978.6,
                    101263
                  ],
                  [
                    23069.4,
                    101256
                  ],
                  [
                    23377.6,
                    101199
                  ],
                  [
                    23448.3,
                    101201
                  ],
                  [
                    23566.3,
                    101282
                  ],
                  [
                    23704.8,
                    101458
                  ],
                  [
                    23748.3,
                    101355
                  ],
                  [
                    23776.5,
                    101277
                  ],
                  [
                    23776.8,
                    101216
                  ],
                  [
                    23797.2,
                    101061
                  ],
                  [
                    23758.5,
                    100968
                  ],
                  [
                    23749.9,
                    100857
                  ],
                  [
                    23750.8,
                    100462
                  ],
                  [
                    22935.4,
                    100461
                  ]
                ],
                "id": 1864,
                "chat_link": "[&BEgHAAA=]"
              },
              "1872": {
                "name": "Zen Daijun",
                "level": 80,
                "coord": [
                  23506.5,
                  102219
                ],
                "bounds": [
                  [
                    23009.6,
                    101754
                  ],
                  [
                    23074.5,
                    101880
                  ],
                  [
                    23126.8,
                    102135
                  ],
                  [
                    23085.9,
                    102207
                  ],
                  [
                    23113.8,
                    102288
                  ],
                  [
                    23179.3,
                    102358
                  ],
                  [
                    23194.5,
                    102447
                  ],
                  [
                    23170.1,
                    102550
                  ],
                  [
                    23119.1,
                    102606
                  ],
                  [
                    23118,
                    102685
                  ],
                  [
                    23148.8,
                    102757
                  ],
                  [
                    23119.4,
                    102887
                  ],
                  [
                    23108.6,
                    103008
                  ],
                  [
                    23115,
                    103137
                  ],
                  [
                    23975.7,
                    103137
                  ],
                  [
                    23952.7,
                    102788
                  ],
                  [
                    23997.7,
                    102574
                  ],
                  [
                    24037.4,
                    102422
                  ],
                  [
                    24124.4,
                    102278
                  ],
                  [
                    24162.7,
                    102181
                  ],
                  [
                    24217.8,
                    102059
                  ],
                  [
                    24286.6,
                    101762
                  ],
                  [
                    24029.3,
                    101732
                  ],
                  [
                    23898.6,
                    101775
                  ],
                  [
                    23828.5,
                    101820
                  ],
                  [
                    23836.9,
                    101889
                  ],
                  [
                    23802.7,
                    101957
                  ],
                  [
                    23751.4,
                    102018
                  ],
                  [
                    23698.7,
                    102049
                  ],
                  [
                    23526.7,
                    102047
                  ],
                  [
                    23435.3,
                    102015
                  ],
                  [
                    23413.2,
                    101918
                  ],
                  [
                    23366.6,
                    101874
                  ],
                  [
                    23309.8,
                    101795
                  ],
                  [
                    23208.1,
                    101778
                  ],
                  [
                    23135.5,
                    101777
                  ],
                  [
                    23060.3,
                    101769
                  ],
                  [
                    23009.6,
                    101754
                  ]
                ],
                "id": 1872,
                "chat_link": "[&BFAHAAA=]"
              },
              "1874": {
                "name": "Shing Jea Monastery",
                "level": 80,
                "coord": [
                  21799.4,
                  102129
                ],
                "bounds": [
                  [
                    21226.1,
                    101841
                  ],
                  [
                    21224.4,
                    102024
                  ],
                  [
                    21213.4,
                    102159
                  ],
                  [
                    21237.4,
                    102264
                  ],
                  [
                    21244.7,
                    102374
                  ],
                  [
                    21356.9,
                    102352
                  ],
                  [
                    21444.8,
                    102368
                  ],
                  [
                    21518.9,
                    102382
                  ],
                  [
                    21582,
                    102372
                  ],
                  [
                    21664.2,
                    102368
                  ],
                  [
                    21721.9,
                    102365
                  ],
                  [
                    21784.4,
                    102355
                  ],
                  [
                    21844.1,
                    102334
                  ],
                  [
                    21918.3,
                    102343
                  ],
                  [
                    22000.3,
                    102357
                  ],
                  [
                    22095.8,
                    102362
                  ],
                  [
                    22328,
                    102417
                  ],
                  [
                    22273.1,
                    102310
                  ],
                  [
                    22339.9,
                    102275
                  ],
                  [
                    22437.7,
                    102216
                  ],
                  [
                    22456.4,
                    102058
                  ],
                  [
                    22519.3,
                    102014
                  ],
                  [
                    22492.8,
                    101837
                  ],
                  [
                    22142.5,
                    101778
                  ],
                  [
                    22003.3,
                    101774
                  ],
                  [
                    21886.5,
                    101809
                  ],
                  [
                    21711.6,
                    101694
                  ],
                  [
                    21561.1,
                    101646
                  ],
                  [
                    21436.9,
                    101678
                  ],
                  [
                    21314.7,
                    101731
                  ],
                  [
                    21226.1,
                    101841
                  ]
                ],
                "id": 1874,
                "chat_link": "[&BFIHAAA=]"
              },
              "1877": {
                "name": "Training Grounds",
                "level": 80,
                "coord": [
                  21988.3,
                  102594
                ],
                "bounds": [
                  [
                    21918.3,
                    102341
                  ],
                  [
                    21842.6,
                    102330
                  ],
                  [
                    21784.4,
                    102352
                  ],
                  [
                    21712.9,
                    102356
                  ],
                  [
                    21727.8,
                    102395
                  ],
                  [
                    21704.4,
                    102558
                  ],
                  [
                    21782.1,
                    102739
                  ],
                  [
                    21866.3,
                    102832
                  ],
                  [
                    21910.9,
                    102926
                  ],
                  [
                    21928.7,
                    102932
                  ],
                  [
                    22037.2,
                    102920
                  ],
                  [
                    22147.3,
                    102825
                  ],
                  [
                    22237.8,
                    102743
                  ],
                  [
                    22364.5,
                    102684
                  ],
                  [
                    22398.3,
                    102644
                  ],
                  [
                    22326.8,
                    102414
                  ],
                  [
                    22098.2,
                    102359
                  ],
                  [
                    22000.6,
                    102351
                  ],
                  [
                    21918.3,
                    102341
                  ]
                ],
                "id": 1877,
                "chat_link": "[&BFUHAAA=]"
              },
              "1878": {
                "name": "Monastery Bay",
                "level": 80,
                "coord": [
                  21581.4,
                  102724
                ],
                "bounds": [
                  [
                    21248,
                    102374
                  ],
                  [
                    21356.1,
                    102350
                  ],
                  [
                    21447.2,
                    102367
                  ],
                  [
                    21520.4,
                    102372
                  ],
                  [
                    21576.4,
                    102371
                  ],
                  [
                    21666.8,
                    102363
                  ],
                  [
                    21720.5,
                    102361
                  ],
                  [
                    21730,
                    102395
                  ],
                  [
                    21712,
                    102563
                  ],
                  [
                    21794.5,
                    102741
                  ],
                  [
                    21873.8,
                    102830
                  ],
                  [
                    21916.2,
                    102927
                  ],
                  [
                    21931.5,
                    102929
                  ],
                  [
                    22036,
                    102916
                  ],
                  [
                    22054.6,
                    103139
                  ],
                  [
                    21661.7,
                    103138
                  ],
                  [
                    21389.4,
                    103137
                  ],
                  [
                    21338.3,
                    103117
                  ],
                  [
                    21321.5,
                    103068
                  ],
                  [
                    21324.5,
                    102977
                  ],
                  [
                    21298.9,
                    102900
                  ],
                  [
                    21214,
                    102709
                  ],
                  [
                    21240.7,
                    102608
                  ],
                  [
                    21248,
                    102374
                  ]
                ],
                "id": 1878,
                "chat_link": "[&BFYHAAA=]"
              },
              "1897": {
                "name": "Seitung Harbor",
                "level": 80,
                "coord": [
                  22812.6,
                  102378
                ],
                "bounds": [
                  [
                    22486,
                    101849
                  ],
                  [
                    22511.3,
                    102010
                  ],
                  [
                    22444.7,
                    102050
                  ],
                  [
                    22428.8,
                    102211
                  ],
                  [
                    22338.1,
                    102266
                  ],
                  [
                    22256.6,
                    102311
                  ],
                  [
                    22310.5,
                    102426
                  ],
                  [
                    22378.4,
                    102644
                  ],
                  [
                    22444.3,
                    102715
                  ],
                  [
                    22585.1,
                    102863
                  ],
                  [
                    22588.1,
                    103139
                  ],
                  [
                    23124.2,
                    103136
                  ],
                  [
                    23113.4,
                    103003
                  ],
                  [
                    23123.5,
                    102891
                  ],
                  [
                    23154.2,
                    102756
                  ],
                  [
                    23121.6,
                    102684
                  ],
                  [
                    23126.2,
                    102609
                  ],
                  [
                    23173.4,
                    102551
                  ],
                  [
                    23200.3,
                    102447
                  ],
                  [
                    23185.5,
                    102358
                  ],
                  [
                    23122.1,
                    102288
                  ],
                  [
                    23091,
                    102210
                  ],
                  [
                    23131.1,
                    102140
                  ],
                  [
                    23081.3,
                    101887
                  ],
                  [
                    23014.3,
                    101756
                  ],
                  [
                    22825.7,
                    101776
                  ],
                  [
                    22752,
                    101780
                  ],
                  [
                    22640.9,
                    101827
                  ],
                  [
                    22486,
                    101849
                  ]
                ],
                "id": 1897,
                "chat_link": "[&BGkHAAA=]"
              },
              "1898": {
                "name": "Daigo Ward",
                "level": 80,
                "coord": [
                  23315.2,
                  101641
                ],
                "bounds": [
                  [
                    22980.9,
                    101260
                  ],
                  [
                    22915,
                    101258
                  ],
                  [
                    22851,
                    101269
                  ],
                  [
                    22816.4,
                    101347
                  ],
                  [
                    22812.9,
                    101442
                  ],
                  [
                    22894,
                    101557
                  ],
                  [
                    22916.2,
                    101651
                  ],
                  [
                    23003.3,
                    101765
                  ],
                  [
                    23064,
                    101778
                  ],
                  [
                    23135,
                    101774
                  ],
                  [
                    23206.7,
                    101782
                  ],
                  [
                    23303.4,
                    101813
                  ],
                  [
                    23360.8,
                    101878
                  ],
                  [
                    23406.3,
                    101920
                  ],
                  [
                    23433.6,
                    102018
                  ],
                  [
                    23527.7,
                    102053
                  ],
                  [
                    23700.3,
                    102052
                  ],
                  [
                    23753.4,
                    102014
                  ],
                  [
                    23807.9,
                    101958
                  ],
                  [
                    23841,
                    101885
                  ],
                  [
                    23830.5,
                    101825
                  ],
                  [
                    23788.4,
                    101639
                  ],
                  [
                    23696.8,
                    101444
                  ],
                  [
                    23569.8,
                    101278
                  ],
                  [
                    23450.7,
                    101199
                  ],
                  [
                    23371.5,
                    101195
                  ],
                  [
                    23071.8,
                    101252
                  ],
                  [
                    22980.9,
                    101260
                  ]
                ],
                "id": 1898,
                "chat_link": "[&BGoHAAA=]"
              },
              "1903": {
                "name": "Crystal Cave",
                "level": 80,
                "coord": [
                  22315,
                  102849
                ],
                "bounds": [
                  [
                    22025.1,
                    102914
                  ],
                  [
                    22143.3,
                    102819
                  ],
                  [
                    22224.2,
                    102738
                  ],
                  [
                    22363,
                    102679
                  ],
                  [
                    22395.3,
                    102645
                  ],
                  [
                    22447.1,
                    102706
                  ],
                  [
                    22592.9,
                    102858
                  ],
                  [
                    22597.2,
                    103137
                  ],
                  [
                    22046.9,
                    103139
                  ],
                  [
                    22025.1,
                    102914
                  ]
                ],
                "id": 1903,
                "chat_link": "[&BG8HAAA=]"
              },
              "1905": {
                "name": "North Peninsula",
                "level": 80,
                "coord": [
                  24604.2,
                  101120
                ],
                "bounds": [
                  [
                    24436.7,
                    100463
                  ],
                  [
                    24398.9,
                    100763
                  ],
                  [
                    24321.4,
                    100955
                  ],
                  [
                    24239.8,
                    101178
                  ],
                  [
                    24242.4,
                    101370
                  ],
                  [
                    24269.1,
                    101539
                  ],
                  [
                    24276.8,
                    101764
                  ],
                  [
                    24406.9,
                    101817
                  ],
                  [
                    24520,
                    101800
                  ],
                  [
                    24620.3,
                    101831
                  ],
                  [
                    24988.8,
                    101828
                  ],
                  [
                    24992,
                    100610
                  ],
                  [
                    25008.4,
                    100599
                  ],
                  [
                    25007.5,
                    100473
                  ],
                  [
                    24989.3,
                    100467
                  ],
                  [
                    24949,
                    100461
                  ],
                  [
                    24436.7,
                    100463
                  ]
                ],
                "id": 1905,
                "chat_link": "[&BHEHAAA=]"
              }
            },
            "adventures": [],
            "id": 1427,
            "mastery_points": []
          },
          "1428": {
            "name": "Arborstone",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              29750,
              101210
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                29185,
                100890
              ],
              [
                33025,
                103450
              ]
            ],
            "points_of_interest": {
              "3256": {
                "name": "Collection: Siege Turtle Master Rota",
                "type": "unlock",
                "floor": 1,
                "coord": [
                  29570.2,
                  101040
                ],
                "id": 3256,
                "chat_link": "[&BLgMAAA=]",
                "icon": "https://render.guildwars2.com/file/AA564AD8701B0E24D49406EEB86740C3DE0B523D/2604920.png"
              },
              "3427": {
                "name": "Arborstone Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  29844.8,
                  101425
                ],
                "id": 3427,
                "chat_link": "[&BGMNAAA=]"
              },
              "3436": {
                "name": "Hall of Remembrance",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29534.1,
                  101209
                ],
                "id": 3436,
                "chat_link": "[&BGwNAAA=]"
              },
              "3437": {
                "name": "The Ready Room",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29802.7,
                  101476
                ],
                "id": 3437,
                "chat_link": "[&BG0NAAA=]"
              },
              "3438": {
                "name": "The Roost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29551.3,
                  101370
                ],
                "id": 3438,
                "chat_link": "[&BG4NAAA=]"
              },
              "3439": {
                "name": "Longfeather Plaza",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29764.2,
                  101315
                ],
                "id": 3439,
                "chat_link": "[&BG8NAAA=]"
              },
              "3440": {
                "name": "Singer's Fountain",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29954.9,
                  101505
                ],
                "id": 3440,
                "chat_link": "[&BHANAAA=]"
              },
              "3441": {
                "name": "Arborstone Inn",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29730.1,
                  101558
                ],
                "id": 3441,
                "chat_link": "[&BHENAAA=]"
              },
              "3442": {
                "name": "Kaga's Hearth",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29643.7,
                  101434
                ],
                "id": 3442,
                "chat_link": "[&BHINAAA=]"
              },
              "3443": {
                "name": "Quartermaster's Row",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29798.7,
                  101066
                ],
                "id": 3443,
                "chat_link": "[&BHMNAAA=]"
              },
              "3444": {
                "name": "Sanctuary of the Five",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29650.2,
                  101094
                ],
                "id": 3444,
                "chat_link": "[&BHQNAAA=]"
              },
              "3445": {
                "name": "Kestrel Archives",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29976.5,
                  101261
                ],
                "id": 3445,
                "chat_link": "[&BHUNAAA=]"
              },
              "3446": {
                "name": "The Exchange",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29928.9,
                  101348
                ],
                "id": 3446,
                "chat_link": "[&BHYNAAA=]"
              },
              "3447": {
                "name": "Club Canach",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29968.2,
                  101059
                ],
                "id": 3447,
                "chat_link": "[&BHcNAAA=]"
              },
              "3448": {
                "name": "Danika's Respite",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29385.4,
                  101056
                ],
                "id": 3448,
                "chat_link": "[&BHgNAAA=]"
              },
              "3450": {
                "name": "Club Canach Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  29851.8,
                  100973
                ],
                "id": 3450,
                "chat_link": "[&BHoNAAA=]"
              },
              "3451": {
                "type": "unlock",
                "floor": 1,
                "coord": [
                  29780.2,
                  101509
                ],
                "id": 3451,
                "chat_link": "[&BHsNAAA=]",
                "icon": "https://render.guildwars2.com/file/59EE15E692D47BF90ECF02269F7DAE6751F56FAD/2200049.png"
              }
            },
            "tasks": {},
            "skill_challenges": [
              {
                "coord": [
                  29819.2,
                  101109
                ]
              }
            ],
            "sectors": {
              "1918": {
                "name": "Zu Heltzer Historical Site",
                "level": 80,
                "coord": [
                  29871.7,
                  101484
                ],
                "bounds": [
                  [
                    29467,
                    101237
                  ],
                  [
                    29477.3,
                    101433
                  ],
                  [
                    29697.8,
                    101641
                  ],
                  [
                    29896.8,
                    101644
                  ],
                  [
                    30003.8,
                    101605
                  ],
                  [
                    30056,
                    101554
                  ],
                  [
                    30131.4,
                    101466
                  ],
                  [
                    30132.2,
                    101351
                  ],
                  [
                    30001.1,
                    101227
                  ],
                  [
                    30000.8,
                    100977
                  ],
                  [
                    30098.7,
                    100968
                  ],
                  [
                    30136,
                    100994
                  ],
                  [
                    30287.8,
                    100986
                  ],
                  [
                    30568.6,
                    100985
                  ],
                  [
                    30642.8,
                    101007
                  ],
                  [
                    30647.6,
                    101566
                  ],
                  [
                    30587,
                    102075
                  ],
                  [
                    30102.1,
                    102249
                  ],
                  [
                    29254.7,
                    102234
                  ],
                  [
                    29263.4,
                    102082
                  ],
                  [
                    29271,
                    101937
                  ],
                  [
                    29279.9,
                    101794
                  ],
                  [
                    29274.8,
                    101494
                  ],
                  [
                    29277.6,
                    101363
                  ],
                  [
                    29235.5,
                    101227
                  ],
                  [
                    29467,
                    101237
                  ]
                ],
                "id": 1918,
                "chat_link": "[&BH4HAAA=]"
              },
              "1922": {
                "name": "Arborstone",
                "level": 80,
                "coord": [
                  29753.3,
                  101304
                ],
                "bounds": [
                  [
                    29467,
                    101237
                  ],
                  [
                    29477.3,
                    101433
                  ],
                  [
                    29697.8,
                    101641
                  ],
                  [
                    29896.8,
                    101644
                  ],
                  [
                    30003.8,
                    101605
                  ],
                  [
                    30056,
                    101554
                  ],
                  [
                    30131.4,
                    101466
                  ],
                  [
                    30132.2,
                    101351
                  ],
                  [
                    30001.1,
                    101227
                  ],
                  [
                    30001.5,
                    100975
                  ],
                  [
                    29955.5,
                    100953
                  ],
                  [
                    29253.6,
                    100953
                  ],
                  [
                    29236.5,
                    100984
                  ],
                  [
                    29235.8,
                    101227
                  ],
                  [
                    29467,
                    101237
                  ]
                ],
                "id": 1922,
                "chat_link": "[&BIIHAAA=]"
              }
            },
            "adventures": [],
            "id": 1428,
            "mastery_points": []
          },
          "1429": {
            "name": "The Cycle, Reborn: Arborstone",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              29750,
              101210
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                29185,
                100890
              ],
              [
                33025,
                103450
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1922": {
                "name": "Arborstone",
                "level": 80,
                "coord": [
                  29753.3,
                  101304
                ],
                "bounds": [
                  [
                    29467,
                    101237
                  ],
                  [
                    29477.3,
                    101433
                  ],
                  [
                    29697.8,
                    101641
                  ],
                  [
                    29896.8,
                    101644
                  ],
                  [
                    30003.8,
                    101605
                  ],
                  [
                    30056,
                    101554
                  ],
                  [
                    30131.4,
                    101466
                  ],
                  [
                    30132.2,
                    101351
                  ],
                  [
                    30001.1,
                    101227
                  ],
                  [
                    30001.5,
                    100975
                  ],
                  [
                    29955.5,
                    100953
                  ],
                  [
                    29253.6,
                    100953
                  ],
                  [
                    29236.5,
                    100984
                  ],
                  [
                    29235.8,
                    101227
                  ],
                  [
                    29467,
                    101237
                  ]
                ],
                "id": 1922,
                "chat_link": "[&BIIHAAA=]"
              }
            },
            "adventures": [],
            "id": 1429,
            "mastery_points": []
          },
          "1430": {
            "name": "Claiming the Isle of Reflection",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 69,
            "label_coord": [
              22250,
              104696
            ],
            "map_rect": [
              [
                -21504,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                21319,
                103145
              ],
              [
                23239,
                105705
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1854": {
                "level": 0,
                "coord": [
                  22374.8,
                  104740
                ],
                "bounds": [
                  [
                    23002.5,
                    104067
                  ],
                  [
                    23114.4,
                    104560
                  ],
                  [
                    23088.7,
                    105487
                  ],
                  [
                    22923.7,
                    105576
                  ],
                  [
                    21724.4,
                    105618
                  ],
                  [
                    21504.2,
                    105470
                  ],
                  [
                    21529.7,
                    104145
                  ],
                  [
                    21723.1,
                    103898
                  ],
                  [
                    22762.5,
                    103835
                  ],
                  [
                    23002.5,
                    104067
                  ]
                ],
                "id": 1854,
                "chat_link": "[&BD4HAAA=]"
              }
            },
            "id": 1430,
            "mastery_points": [],
            "adventures": []
          },
          "1434": {
            "name": "Empty",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              31100,
              102360
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                29185,
                100890
              ],
              [
                33025,
                103450
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1434,
            "mastery_points": []
          },
          "1435": {
            "name": "Isle of Reflection",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              22250,
              104696
            ],
            "map_rect": [
              [
                -21504,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                21319,
                103145
              ],
              [
                23239,
                105705
              ]
            ],
            "points_of_interest": {
              "3294": {
                "name": "Reflection Arena Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  22232,
                  105006
                ],
                "id": 3294,
                "chat_link": "[&BN4MAAA=]"
              },
              "3315": {
                "name": "Reflection Docks Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  21852.2,
                  104468
                ],
                "id": 3315,
                "chat_link": "[&BPMMAAA=]"
              },
              "3342": {
                "name": "Reflection Crystal Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  22018.7,
                  105151
                ],
                "id": 3342,
                "chat_link": "[&BA4NAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1854": {
                "level": 0,
                "coord": [
                  22374.8,
                  104740
                ],
                "bounds": [
                  [
                    23002.5,
                    104067
                  ],
                  [
                    23114.4,
                    104560
                  ],
                  [
                    23088.7,
                    105487
                  ],
                  [
                    22923.7,
                    105576
                  ],
                  [
                    21724.4,
                    105618
                  ],
                  [
                    21504.2,
                    105470
                  ],
                  [
                    21529.7,
                    104145
                  ],
                  [
                    21723.1,
                    103898
                  ],
                  [
                    22762.5,
                    103835
                  ],
                  [
                    23002.5,
                    104067
                  ]
                ],
                "id": 1854,
                "chat_link": "[&BD4HAAA=]"
              }
            },
            "id": 1435,
            "mastery_points": [],
            "adventures": []
          },
          "1436": {
            "name": "Extraction Point: Command Quarters",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              29750,
              101210
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                29185,
                100890
              ],
              [
                33025,
                103450
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1922": {
                "name": "Arborstone",
                "level": 80,
                "coord": [
                  29753.3,
                  101304
                ],
                "bounds": [
                  [
                    29467,
                    101237
                  ],
                  [
                    29477.3,
                    101433
                  ],
                  [
                    29697.8,
                    101641
                  ],
                  [
                    29896.8,
                    101644
                  ],
                  [
                    30003.8,
                    101605
                  ],
                  [
                    30056,
                    101554
                  ],
                  [
                    30131.4,
                    101466
                  ],
                  [
                    30132.2,
                    101351
                  ],
                  [
                    30001.1,
                    101227
                  ],
                  [
                    30001.5,
                    100975
                  ],
                  [
                    29955.5,
                    100953
                  ],
                  [
                    29253.6,
                    100953
                  ],
                  [
                    29236.5,
                    100984
                  ],
                  [
                    29235.8,
                    101227
                  ],
                  [
                    29467,
                    101237
                  ]
                ],
                "id": 1922,
                "chat_link": "[&BIIHAAA=]"
              }
            },
            "adventures": [],
            "id": 1436,
            "mastery_points": []
          },
          "1438": {
            "name": "New Kaineng City",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              27000,
              99400
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                25000,
                98100
              ],
              [
                28840,
                100660
              ]
            ],
            "points_of_interest": {
              "3210": {
                "name": "Jade Brotherhood Hideout",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  28597.3,
                  98320.6
                ],
                "id": 3210,
                "chat_link": "[&BIoMAAA=]"
              },
              "3222": {
                "name": "Ministry Headquarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  26851.7,
                  99360.7
                ],
                "id": 3222,
                "chat_link": "[&BJYMAAA=]"
              },
              "3223": {
                "name": "Aetherblade Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  28435.6,
                  98615
                ],
                "id": 3223,
                "chat_link": "[&BJcMAAA=]"
              },
              "3225": {
                "name": "South Substation",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  26434.4,
                  100183
                ],
                "id": 3225,
                "chat_link": "[&BJkMAAA=]"
              },
              "3227": {
                "name": "Ministry of Security Headquarters",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  26085.5,
                  99945.5
                ],
                "id": 3227,
                "chat_link": "[&BJsMAAA=]"
              },
              "3229": {
                "name": "Sunjiang Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  28367.7,
                  99683
                ],
                "id": 3229,
                "chat_link": "[&BJ0MAAA=]"
              },
              "3235": {
                "name": "Tranquil Overlook",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  27862,
                  99248.8
                ],
                "id": 3235,
                "chat_link": "[&BKMMAAA=]"
              },
              "3239": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  26894.1,
                  99380.9
                ],
                "id": 3239,
                "chat_link": "[&BKcMAAA=]"
              },
              "3247": {
                "name": "Haebaragi's Tears",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  26107.8,
                  99380.5
                ],
                "id": 3247,
                "chat_link": "[&BK8MAAA=]"
              },
              "3250": {
                "name": "Ministry of Archives",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  26039,
                  100178
                ],
                "id": 3250,
                "chat_link": "[&BLIMAAA=]"
              },
              "3254": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  28252.9,
                  98693.3
                ],
                "id": 3254,
                "chat_link": "[&BLYMAAA=]"
              },
              "3255": {
                "name": "Garden of Lyssa",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  27310.9,
                  98646.8
                ],
                "id": 3255,
                "chat_link": "[&BLcMAAA=]"
              },
              "3258": {
                "name": "Nahpui Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  27772.2,
                  98280.6
                ],
                "id": 3258,
                "chat_link": "[&BLoMAAA=]"
              },
              "3270": {
                "name": "Promenade Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  25472.8,
                  99591.6
                ],
                "id": 3270,
                "chat_link": "[&BMYMAAA=]"
              },
              "3282": {
                "name": "Soo-Won's Protection",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  28387.5,
                  99559.8
                ],
                "id": 3282,
                "chat_link": "[&BNIMAAA=]"
              },
              "3291": {
                "name": "Tengu Square",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  27008.2,
                  100218
                ],
                "id": 3291,
                "chat_link": "[&BNsMAAA=]"
              },
              "3296": {
                "name": "Salvage Yard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  27965.2,
                  100356
                ],
                "id": 3296,
                "chat_link": "[&BOAMAAA=]"
              },
              "3301": {
                "name": "Jade Statuette",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  26275.1,
                  98858.4
                ],
                "id": 3301,
                "chat_link": "[&BOUMAAA=]"
              },
              "3305": {
                "name": "Jade Monument",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  25655.6,
                  99375.3
                ],
                "id": 3305,
                "chat_link": "[&BOkMAAA=]"
              },
              "3307": {
                "name": "Ancient Vault",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  28456,
                  98427.5
                ],
                "id": 3307,
                "chat_link": "[&BOsMAAA=]"
              },
              "3308": {
                "name": "Temple of Preeminence",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  26116.7,
                  98801.9
                ],
                "id": 3308,
                "chat_link": "[&BOwMAAA=]"
              },
              "3311": {
                "name": "The Old Steamshop",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  27680.9,
                  98982.8
                ],
                "id": 3311,
                "chat_link": "[&BO8MAAA=]"
              },
              "3318": {
                "name": "Isle of Hanasha",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  25220.7,
                  98516.7
                ],
                "id": 3318,
                "chat_link": "[&BPYMAAA=]"
              },
              "3323": {
                "name": "Red Duck Tea House",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  25846.3,
                  99905.9
                ],
                "id": 3323,
                "chat_link": "[&BPsMAAA=]"
              },
              "3329": {
                "name": "Reactor Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  26050.9,
                  98262.7
                ],
                "id": 3329,
                "chat_link": "[&BAENAAA=]"
              },
              "3339": {
                "name": "Tae-Jin's Estate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  26428,
                  98549.8
                ],
                "id": 3339,
                "chat_link": "[&BAsNAAA=]"
              },
              "3350": {
                "name": "Garden Heights Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  25946,
                  98633
                ],
                "id": 3350,
                "chat_link": "[&BBYNAAA=]"
              },
              "3353": {
                "name": "Ministry Ward Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  26674.2,
                  99438.3
                ],
                "id": 3353,
                "chat_link": "[&BBkNAAA=]"
              },
              "3358": {
                "name": "Brume Alley",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  26751.2,
                  100441
                ],
                "id": 3358,
                "chat_link": "[&BB4NAAA=]"
              },
              "3359": {
                "name": "Petrified Shipping Docks",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  28481.8,
                  99881.1
                ],
                "id": 3359,
                "chat_link": "[&BB8NAAA=]"
              },
              "3360": {
                "name": "Lutgardis Plaza Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  27869.7,
                  99381
                ],
                "id": 3360,
                "chat_link": "[&BCANAAA=]"
              },
              "3364": {
                "name": "Pool of Tranquility",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  25804.7,
                  99098.2
                ],
                "id": 3364,
                "chat_link": "[&BCQNAAA=]"
              },
              "3366": {
                "name": "Seung-Gi's Legacy",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  27059.5,
                  99232.3
                ],
                "id": 3366,
                "chat_link": "[&BCYNAAA=]"
              },
              "3376": {
                "name": "East Precinct",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  27736.3,
                  99318.7
                ],
                "id": 3376,
                "chat_link": "[&BDANAAA=]"
              },
              "3377": {
                "name": "Central Power Station",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  26066.9,
                  99380.6
                ],
                "id": 3377,
                "chat_link": "[&BDENAAA=]"
              },
              "3380": {
                "name": "Kaineng Fish Market",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  25480.9,
                  99474.1
                ],
                "id": 3380,
                "chat_link": "[&BDQNAAA=]"
              },
              "3381": {
                "name": "North Substation",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  26424.8,
                  98666.4
                ],
                "id": 3381,
                "chat_link": "[&BDUNAAA=]"
              },
              "3383": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  28006.9,
                  99317.2
                ],
                "id": 3383,
                "chat_link": "[&BDcNAAA=]"
              },
              "3384": {
                "name": "Misa Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  28251.3,
                  100279
                ],
                "id": 3384,
                "chat_link": "[&BDgNAAA=]"
              },
              "3386": {
                "name": "Kappa Underpass",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  27904.7,
                  100015
                ],
                "id": 3386,
                "chat_link": "[&BDoNAAA=]"
              },
              "3399": {
                "name": "Lutgardis Market",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  27435.5,
                  99204
                ],
                "id": 3399,
                "chat_link": "[&BEcNAAA=]"
              },
              "3401": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  25695.5,
                  99111
                ],
                "id": 3401,
                "chat_link": "[&BEkNAAA=]"
              },
              "3412": {
                "name": "Garden of the Celestials",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  27203,
                  99383.4
                ],
                "id": 3412,
                "chat_link": "[&BFQNAAA=]"
              },
              "3413": {
                "name": "Garden of Enlightenment",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  26105.8,
                  98668.6
                ],
                "id": 3413,
                "chat_link": "[&BFUNAAA=]"
              },
              "3418": {
                "name": "Shipwreck Graveyard",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  25490.4,
                  100403
                ],
                "id": 3418,
                "chat_link": "[&BFoNAAA=]"
              },
              "3424": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  28179.5,
                  99577
                ],
                "id": 3424,
                "chat_link": "[&BGANAAA=]"
              },
              "3425": {
                "name": "Ihn's Grace",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  26376.5,
                  100301
                ],
                "id": 3425,
                "chat_link": "[&BGENAAA=]"
              }
            },
            "tasks": {
              "441": {
                "objective": "Help the tengu of Cobble Ward restore their district.",
                "level": 80,
                "coord": [
                  27014.2,
                  100171
                ],
                "bounds": [
                  [
                    26548.9,
                    99944.6
                  ],
                  [
                    26632.5,
                    100119
                  ],
                  [
                    26754.3,
                    100400
                  ],
                  [
                    26862.7,
                    100465
                  ],
                  [
                    27182.7,
                    100486
                  ],
                  [
                    27506.9,
                    100372
                  ],
                  [
                    27400.7,
                    99761.5
                  ],
                  [
                    27360.2,
                    99671.6
                  ],
                  [
                    26732.6,
                    99596.9
                  ],
                  [
                    26695.3,
                    99710.7
                  ],
                  [
                    26548.9,
                    99944.6
                  ]
                ],
                "id": 441,
                "chat_link": "[&BLkBAAA=]"
              },
              "447": {
                "objective": "Help Xunlai Jade test and promote jade tech.",
                "level": 80,
                "coord": [
                  25993.2,
                  98645.9
                ],
                "bounds": [
                  [
                    25834,
                    98773.6
                  ],
                  [
                    25830.1,
                    98691.4
                  ],
                  [
                    25905.7,
                    98592.6
                  ],
                  [
                    25969.7,
                    98531.3
                  ],
                  [
                    26055.7,
                    98466
                  ],
                  [
                    26096.2,
                    98489.9
                  ],
                  [
                    26183.3,
                    98615.1
                  ],
                  [
                    26190.9,
                    98651.8
                  ],
                  [
                    26157.9,
                    98710.1
                  ],
                  [
                    26022.9,
                    98850.6
                  ],
                  [
                    25947.4,
                    98882.4
                  ],
                  [
                    25834,
                    98773.6
                  ]
                ],
                "id": 447,
                "chat_link": "[&BL8BAAA=]"
              },
              "449": {
                "objective": "Help the East Precinct protect Grub Lane.",
                "level": 80,
                "coord": [
                  28286.6,
                  99457.7
                ],
                "bounds": [
                  [
                    28704.6,
                    99310.7
                  ],
                  [
                    28687.1,
                    99581.2
                  ],
                  [
                    28191.5,
                    99570.5
                  ],
                  [
                    28192,
                    99456
                  ],
                  [
                    28367.1,
                    99296.8
                  ],
                  [
                    28704.6,
                    99310.7
                  ]
                ],
                "id": 449,
                "chat_link": "[&BMEBAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  26032.6,
                  99071.7
                ]
              },
              {
                "coord": [
                  28630.9,
                  99381.1
                ]
              },
              {
                "coord": [
                  28363.1,
                  98585.9
                ]
              },
              {
                "coord": [
                  26136.5,
                  100129
                ]
              },
              {
                "coord": [
                  26003.3,
                  99379.5
                ]
              },
              {
                "coord": [
                  28273.4,
                  100390
                ]
              },
              {
                "coord": [
                  27665.1,
                  98756
                ]
              },
              {
                "coord": [
                  27302.7,
                  98813
                ]
              },
              {
                "coord": [
                  25520.2,
                  100604
                ]
              }
            ],
            "sectors": {
              "1851": {
                "name": "North Lab",
                "level": 80,
                "coord": [
                  27829,
                  98572.4
                ],
                "bounds": [
                  [
                    28084,
                    98164.6
                  ],
                  [
                    28086.4,
                    98325.9
                  ],
                  [
                    28020.3,
                    98327.5
                  ],
                  [
                    28015.2,
                    98729.2
                  ],
                  [
                    27786.4,
                    98725.1
                  ],
                  [
                    27784.5,
                    99069
                  ],
                  [
                    27433.8,
                    99064.9
                  ],
                  [
                    27421.3,
                    98173
                  ],
                  [
                    28084,
                    98164.6
                  ]
                ],
                "id": 1851,
                "chat_link": "[&BDsHAAA=]"
              },
              "1857": {
                "name": "Old Kaineng",
                "level": 80,
                "coord": [
                  28414.3,
                  98537.6
                ],
                "bounds": [
                  [
                    28081,
                    98165.6
                  ],
                  [
                    28194.5,
                    98163.8
                  ],
                  [
                    28195.3,
                    98182.9
                  ],
                  [
                    28388.3,
                    98182.3
                  ],
                  [
                    28414,
                    98163.3
                  ],
                  [
                    28519.9,
                    98168.9
                  ],
                  [
                    28541.9,
                    98189.9
                  ],
                  [
                    28748.4,
                    98195.1
                  ],
                  [
                    28747.8,
                    98261.4
                  ],
                  [
                    28756.5,
                    98274.7
                  ],
                  [
                    28756.7,
                    98326.1
                  ],
                  [
                    28747.2,
                    98337.3
                  ],
                  [
                    28744.9,
                    98510.4
                  ],
                  [
                    28641.3,
                    98512.4
                  ],
                  [
                    28637.3,
                    98985.8
                  ],
                  [
                    28725.8,
                    98983.4
                  ],
                  [
                    28728.2,
                    99166.9
                  ],
                  [
                    28703.7,
                    99223.9
                  ],
                  [
                    28203.9,
                    99215.4
                  ],
                  [
                    28202.3,
                    99061.4
                  ],
                  [
                    27781.4,
                    99067.2
                  ],
                  [
                    27783.4,
                    98723.3
                  ],
                  [
                    28012.2,
                    98727.4
                  ],
                  [
                    28017.2,
                    98325.8
                  ],
                  [
                    28083.4,
                    98324.1
                  ],
                  [
                    28081,
                    98165.6
                  ]
                ],
                "id": 1857,
                "chat_link": "[&BEEHAAA=]"
              },
              "1866": {
                "name": "Gwangsan Hill",
                "level": 80,
                "coord": [
                  26354.5,
                  99968.9
                ],
                "bounds": [
                  [
                    26879.3,
                    100414
                  ],
                  [
                    26645.3,
                    100419
                  ],
                  [
                    26643.4,
                    100216
                  ],
                  [
                    26600.5,
                    100209
                  ],
                  [
                    26514.5,
                    100208
                  ],
                  [
                    26376.2,
                    100191
                  ],
                  [
                    26315.1,
                    100151
                  ],
                  [
                    26208,
                    100084
                  ],
                  [
                    26146.1,
                    100012
                  ],
                  [
                    26064.4,
                    99931.4
                  ],
                  [
                    26033.7,
                    99863.8
                  ],
                  [
                    25993.7,
                    99772
                  ],
                  [
                    25968.6,
                    99638
                  ],
                  [
                    25967.5,
                    99529.2
                  ],
                  [
                    26102.3,
                    99529.3
                  ],
                  [
                    26103.8,
                    99682.6
                  ],
                  [
                    26192.7,
                    99683.5
                  ],
                  [
                    26259.8,
                    99790.4
                  ],
                  [
                    26331,
                    99881.4
                  ],
                  [
                    26425.4,
                    99883.6
                  ],
                  [
                    26418.4,
                    99955.4
                  ],
                  [
                    26505.9,
                    100008
                  ],
                  [
                    26608.9,
                    100045
                  ],
                  [
                    26687.9,
                    100062
                  ],
                  [
                    26869.6,
                    100061
                  ],
                  [
                    26879.3,
                    100414
                  ]
                ],
                "id": 1866,
                "chat_link": "[&BEoHAAA=]"
              },
              "1876": {
                "name": "Baedal Hill",
                "level": 80,
                "coord": [
                  26468.1,
                  98687.7
                ],
                "bounds": [
                  [
                    26105,
                    99212
                  ],
                  [
                    25971.3,
                    99212.6
                  ],
                  [
                    25973.1,
                    99120.1
                  ],
                  [
                    26014.3,
                    98985.4
                  ],
                  [
                    26038.1,
                    98922.3
                  ],
                  [
                    26076.7,
                    98869.3
                  ],
                  [
                    26184.3,
                    98738.8
                  ],
                  [
                    26240.9,
                    98693.9
                  ],
                  [
                    26301,
                    98652.4
                  ],
                  [
                    26360.3,
                    98622
                  ],
                  [
                    26498.1,
                    98606.3
                  ],
                  [
                    26622.2,
                    98605.9
                  ],
                  [
                    26622.7,
                    98318.5
                  ],
                  [
                    26555,
                    98318.8
                  ],
                  [
                    26552.3,
                    98187.3
                  ],
                  [
                    26830.3,
                    98183.6
                  ],
                  [
                    26832.5,
                    98246
                  ],
                  [
                    26917.5,
                    98246.5
                  ],
                  [
                    26913,
                    98327.9
                  ],
                  [
                    26872.4,
                    98328
                  ],
                  [
                    26868,
                    98459.2
                  ],
                  [
                    26867.1,
                    98508.1
                  ],
                  [
                    26871.4,
                    98691.2
                  ],
                  [
                    26729.4,
                    98698.6
                  ],
                  [
                    26729,
                    98744.8
                  ],
                  [
                    26638.1,
                    98729.4
                  ],
                  [
                    26524.3,
                    98754.4
                  ],
                  [
                    26425.8,
                    98814.9
                  ],
                  [
                    26420.3,
                    98874
                  ],
                  [
                    26347,
                    98877.7
                  ],
                  [
                    26267.7,
                    98966.4
                  ],
                  [
                    26174.8,
                    99079.1
                  ],
                  [
                    26104,
                    99099.6
                  ],
                  [
                    26105,
                    99212
                  ]
                ],
                "id": 1876,
                "chat_link": "[&BFQHAAA=]"
              },
              "1885": {
                "name": "Soojung Heights",
                "level": 80,
                "coord": [
                  26139.9,
                  100092
                ],
                "bounds": [
                  [
                    26645.4,
                    100535
                  ],
                  [
                    26442.1,
                    100517
                  ],
                  [
                    26397.5,
                    100513
                  ],
                  [
                    26333.6,
                    100499
                  ],
                  [
                    26256.4,
                    100464
                  ],
                  [
                    26128,
                    100409
                  ],
                  [
                    26052.5,
                    100345
                  ],
                  [
                    25954,
                    100255
                  ],
                  [
                    25827.2,
                    100126
                  ],
                  [
                    25775.3,
                    100045
                  ],
                  [
                    25749.6,
                    99976.5
                  ],
                  [
                    25710.6,
                    99840.1
                  ],
                  [
                    25683.3,
                    99650.8
                  ],
                  [
                    25743,
                    99651.7
                  ],
                  [
                    25743.1,
                    99533.1
                  ],
                  [
                    25967.5,
                    99529.2
                  ],
                  [
                    25968.6,
                    99638
                  ],
                  [
                    25993.7,
                    99772
                  ],
                  [
                    26033.7,
                    99863.8
                  ],
                  [
                    26064.4,
                    99931.4
                  ],
                  [
                    26146.1,
                    100012
                  ],
                  [
                    26208,
                    100084
                  ],
                  [
                    26315.1,
                    100151
                  ],
                  [
                    26376.2,
                    100191
                  ],
                  [
                    26514.5,
                    100208
                  ],
                  [
                    26600.5,
                    100209
                  ],
                  [
                    26643.4,
                    100216
                  ],
                  [
                    26645.3,
                    100419
                  ],
                  [
                    26645.4,
                    100535
                  ]
                ],
                "id": 1885,
                "chat_link": "[&BF0HAAA=]"
              },
              "1886": {
                "name": "Kaineng Docks",
                "level": 80,
                "coord": [
                  25522.7,
                  99555.1
                ],
                "bounds": [
                  [
                    25827.2,
                    100126
                  ],
                  [
                    25010.4,
                    100121
                  ],
                  [
                    25011.3,
                    99964.4
                  ],
                  [
                    25012.2,
                    99856.2
                  ],
                  [
                    25012.4,
                    99361.6
                  ],
                  [
                    25009.7,
                    98923.8
                  ],
                  [
                    25714.5,
                    98922.8
                  ],
                  [
                    25699,
                    99004.9
                  ],
                  [
                    25684.3,
                    99115.2
                  ],
                  [
                    25748.8,
                    99120.6
                  ],
                  [
                    25750.2,
                    99222.3
                  ],
                  [
                    25743.1,
                    99533.1
                  ],
                  [
                    25743,
                    99651.7
                  ],
                  [
                    25683.3,
                    99650.8
                  ],
                  [
                    25710.6,
                    99840.1
                  ],
                  [
                    25749.6,
                    99976.5
                  ],
                  [
                    25776.3,
                    100045
                  ],
                  [
                    25827.2,
                    100126
                  ]
                ],
                "id": 1886,
                "chat_link": "[&BF4HAAA=]"
              },
              "1890": {
                "name": "Ministry Ward",
                "level": 80,
                "coord": [
                  26603.3,
                  99347.5
                ],
                "bounds": [
                  [
                    26259.8,
                    99790.4
                  ],
                  [
                    26331,
                    99881.4
                  ],
                  [
                    26425.4,
                    99883.6
                  ],
                  [
                    26418.4,
                    99955.4
                  ],
                  [
                    26505.9,
                    100008
                  ],
                  [
                    26608.9,
                    100045
                  ],
                  [
                    26687.9,
                    100062
                  ],
                  [
                    26869.6,
                    100061
                  ],
                  [
                    26953.8,
                    99956.3
                  ],
                  [
                    26951.3,
                    99864.1
                  ],
                  [
                    27078.4,
                    99716.8
                  ],
                  [
                    27285.7,
                    99716.5
                  ],
                  [
                    27269.4,
                    99064.4
                  ],
                  [
                    27094.3,
                    99062.2
                  ],
                  [
                    26973.2,
                    98954.4
                  ],
                  [
                    26971,
                    98863
                  ],
                  [
                    26885.7,
                    98796.7
                  ],
                  [
                    26871.4,
                    98691.2
                  ],
                  [
                    26729.4,
                    98698.6
                  ],
                  [
                    26729,
                    98744.8
                  ],
                  [
                    26638.1,
                    98729.4
                  ],
                  [
                    26524.3,
                    98754.4
                  ],
                  [
                    26425.8,
                    98814.9
                  ],
                  [
                    26420.3,
                    98874
                  ],
                  [
                    26347,
                    98877.7
                  ],
                  [
                    26267.7,
                    98966.4
                  ],
                  [
                    26174.8,
                    99079.1
                  ],
                  [
                    26104,
                    99099.6
                  ],
                  [
                    26105,
                    99212
                  ],
                  [
                    26102.3,
                    99529.3
                  ],
                  [
                    26103.8,
                    99682.6
                  ],
                  [
                    26192.7,
                    99683.5
                  ],
                  [
                    26259.8,
                    99790.4
                  ]
                ],
                "id": 1890,
                "chat_link": "[&BGIHAAA=]"
              },
              "1891": {
                "name": "Power Plant",
                "level": 80,
                "coord": [
                  25934.4,
                  99341.9
                ],
                "bounds": [
                  [
                    25743.1,
                    99533.1
                  ],
                  [
                    26102.3,
                    99529.3
                  ],
                  [
                    26105,
                    99212
                  ],
                  [
                    25971.3,
                    99212.6
                  ],
                  [
                    25750.2,
                    99222.3
                  ],
                  [
                    25743.1,
                    99533.1
                  ]
                ],
                "id": 1891,
                "chat_link": "[&BGMHAAA=]"
              },
              "1906": {
                "name": "Bori Ward",
                "level": 80,
                "coord": [
                  27019.3,
                  98597.7
                ],
                "bounds": [
                  [
                    27423.1,
                    98176.4
                  ],
                  [
                    26969.3,
                    98182.3
                  ],
                  [
                    26970.4,
                    98245.5
                  ],
                  [
                    26914.2,
                    98245.1
                  ],
                  [
                    26909.9,
                    98326.2
                  ],
                  [
                    26869,
                    98325.8
                  ],
                  [
                    26868,
                    98459.2
                  ],
                  [
                    26867.1,
                    98508.1
                  ],
                  [
                    26871.4,
                    98691.2
                  ],
                  [
                    26885.7,
                    98796.7
                  ],
                  [
                    26971,
                    98863
                  ],
                  [
                    26973.2,
                    98954.4
                  ],
                  [
                    27094.3,
                    99062.2
                  ],
                  [
                    27269.4,
                    99064.4
                  ],
                  [
                    27433.8,
                    99064.9
                  ],
                  [
                    27423.1,
                    98176.4
                  ]
                ],
                "id": 1906,
                "chat_link": "[&BHIHAAA=]"
              },
              "1907": {
                "name": "Cobble Ward",
                "level": 80,
                "coord": [
                  27278.3,
                  100244
                ],
                "bounds": [
                  [
                    28106.8,
                    100537
                  ],
                  [
                    27761.5,
                    100543
                  ],
                  [
                    27761,
                    100588
                  ],
                  [
                    27443.5,
                    100579
                  ],
                  [
                    27443.3,
                    100542
                  ],
                  [
                    26844.4,
                    100538
                  ],
                  [
                    26843,
                    100567
                  ],
                  [
                    26692,
                    100566
                  ],
                  [
                    26645.4,
                    100535
                  ],
                  [
                    26645.3,
                    100419
                  ],
                  [
                    26879.3,
                    100414
                  ],
                  [
                    26869.6,
                    100061
                  ],
                  [
                    26953.8,
                    99956.3
                  ],
                  [
                    26951.3,
                    99864.1
                  ],
                  [
                    27078.4,
                    99716.8
                  ],
                  [
                    27285.7,
                    99716.5
                  ],
                  [
                    27288.8,
                    99863.8
                  ],
                  [
                    27978,
                    99867
                  ],
                  [
                    27986,
                    99941.2
                  ],
                  [
                    28109.3,
                    100056
                  ],
                  [
                    28106.8,
                    100537
                  ]
                ],
                "id": 1907,
                "chat_link": "[&BHMHAAA=]"
              },
              "1908": {
                "name": "Naksi Bay",
                "level": 80,
                "coord": [
                  25623.2,
                  98442.4
                ],
                "bounds": [
                  [
                    26552.3,
                    98187.3
                  ],
                  [
                    26555,
                    98318.8
                  ],
                  [
                    26451,
                    98320.5
                  ],
                  [
                    26369,
                    98329.8
                  ],
                  [
                    26290.5,
                    98350.2
                  ],
                  [
                    26160.4,
                    98386.4
                  ],
                  [
                    26081.2,
                    98433.9
                  ],
                  [
                    25925,
                    98577.6
                  ],
                  [
                    25813.9,
                    98696.8
                  ],
                  [
                    25766.9,
                    98783.3
                  ],
                  [
                    25714.5,
                    98922.8
                  ],
                  [
                    25009.7,
                    98923.4
                  ],
                  [
                    25011.5,
                    98724.2
                  ],
                  [
                    25006.8,
                    98596.6
                  ],
                  [
                    25005.9,
                    98516
                  ],
                  [
                    25009.1,
                    98321.7
                  ],
                  [
                    25008.7,
                    98267.1
                  ],
                  [
                    25029,
                    98230.2
                  ],
                  [
                    25071.1,
                    98213.3
                  ],
                  [
                    25155.4,
                    98213.4
                  ],
                  [
                    25283.6,
                    98210.8
                  ],
                  [
                    25438.9,
                    98209.3
                  ],
                  [
                    26552.3,
                    98187.3
                  ]
                ],
                "id": 1908,
                "chat_link": "[&BHQHAAA=]"
              },
              "1915": {
                "name": "Sotdae Landing",
                "level": 80,
                "coord": [
                  25665.3,
                  100458
                ],
                "bounds": [
                  [
                    26209.3,
                    100639
                  ],
                  [
                    26065.5,
                    100639
                  ],
                  [
                    25951.4,
                    100641
                  ],
                  [
                    25815.7,
                    100645
                  ],
                  [
                    25043.3,
                    100653
                  ],
                  [
                    25023.1,
                    100646
                  ],
                  [
                    25013,
                    100625
                  ],
                  [
                    25016.6,
                    100325
                  ],
                  [
                    25013.7,
                    100225
                  ],
                  [
                    25013.3,
                    100121
                  ],
                  [
                    25827.2,
                    100126
                  ],
                  [
                    25955.3,
                    100253
                  ],
                  [
                    26054.3,
                    100344
                  ],
                  [
                    26128,
                    100409
                  ],
                  [
                    26256.4,
                    100464
                  ],
                  [
                    26259.6,
                    100566
                  ],
                  [
                    26209.3,
                    100639
                  ]
                ],
                "id": 1915,
                "chat_link": "[&BHsHAAA=]"
              },
              "1916": {
                "name": "Lutgardis Plaza",
                "level": 80,
                "coord": [
                  27793.1,
                  99423.8
                ],
                "bounds": [
                  [
                    27269.4,
                    99064.4
                  ],
                  [
                    27285.7,
                    99716.5
                  ],
                  [
                    27288.8,
                    99863.8
                  ],
                  [
                    27978,
                    99867
                  ],
                  [
                    27971.1,
                    99768.2
                  ],
                  [
                    27966.6,
                    99561.8
                  ],
                  [
                    28031.1,
                    99381.5
                  ],
                  [
                    28098.6,
                    99332.4
                  ],
                  [
                    28204.3,
                    99332.3
                  ],
                  [
                    28205.4,
                    99063.2
                  ],
                  [
                    27784.5,
                    99069
                  ],
                  [
                    27433.8,
                    99064.9
                  ],
                  [
                    27269.4,
                    99064.4
                  ]
                ],
                "id": 1916,
                "chat_link": "[&BHwHAAA=]"
              },
              "1917": {
                "name": "Garden Heights",
                "level": 80,
                "coord": [
                  26112,
                  98728.1
                ],
                "bounds": [
                  [
                    26622.7,
                    98318.5
                  ],
                  [
                    26555,
                    98318.8
                  ],
                  [
                    26451,
                    98320.5
                  ],
                  [
                    26369,
                    98329.8
                  ],
                  [
                    26290.5,
                    98350.2
                  ],
                  [
                    26160.4,
                    98386.4
                  ],
                  [
                    26081.2,
                    98433.9
                  ],
                  [
                    25925,
                    98577.6
                  ],
                  [
                    25813.9,
                    98696.8
                  ],
                  [
                    25766.9,
                    98783.3
                  ],
                  [
                    25714.5,
                    98922.8
                  ],
                  [
                    25699,
                    99004.9
                  ],
                  [
                    25684.3,
                    99115.2
                  ],
                  [
                    25748.8,
                    99120.6
                  ],
                  [
                    25750.2,
                    99222.3
                  ],
                  [
                    25971.3,
                    99212.6
                  ],
                  [
                    25973.1,
                    99120.1
                  ],
                  [
                    26014.3,
                    98985.4
                  ],
                  [
                    26038.1,
                    98922.3
                  ],
                  [
                    26076.7,
                    98869.3
                  ],
                  [
                    26184.3,
                    98738.8
                  ],
                  [
                    26240.9,
                    98693.9
                  ],
                  [
                    26301,
                    98652.4
                  ],
                  [
                    26360.3,
                    98622
                  ],
                  [
                    26498.1,
                    98606.3
                  ],
                  [
                    26622.2,
                    98605.9
                  ],
                  [
                    26622.7,
                    98318.5
                  ]
                ],
                "id": 1917,
                "chat_link": "[&BH0HAAA=]"
              },
              "1924": {
                "name": "Petrified Woods",
                "level": 80,
                "coord": [
                  28471,
                  100236
                ],
                "bounds": [
                  [
                    28706.2,
                    100584
                  ],
                  [
                    28715.5,
                    100506
                  ],
                  [
                    28696.1,
                    100369
                  ],
                  [
                    28719,
                    100266
                  ],
                  [
                    28687.9,
                    100178
                  ],
                  [
                    28710,
                    100106
                  ],
                  [
                    28752.1,
                    100048
                  ],
                  [
                    28750.1,
                    99788.7
                  ],
                  [
                    28694.4,
                    99763.8
                  ],
                  [
                    27971.1,
                    99768.2
                  ],
                  [
                    27978,
                    99867
                  ],
                  [
                    27986,
                    99941.2
                  ],
                  [
                    28109.3,
                    100056
                  ],
                  [
                    28106.8,
                    100537
                  ],
                  [
                    28335.8,
                    100548
                  ],
                  [
                    28390.4,
                    100500
                  ],
                  [
                    28461.5,
                    100524
                  ],
                  [
                    28584.3,
                    100545
                  ],
                  [
                    28594,
                    100588
                  ],
                  [
                    28706.2,
                    100584
                  ]
                ],
                "id": 1924,
                "chat_link": "[&BIQHAAA=]"
              },
              "1927": {
                "name": "Grub Lane",
                "level": 80,
                "coord": [
                  28324.9,
                  99439.6
                ],
                "bounds": [
                  [
                    27971.1,
                    99768.2
                  ],
                  [
                    28694.4,
                    99763.8
                  ],
                  [
                    28684.1,
                    99501.3
                  ],
                  [
                    28685.3,
                    99312
                  ],
                  [
                    28706.8,
                    99225.7
                  ],
                  [
                    28207,
                    99217.2
                  ],
                  [
                    28204.3,
                    99332.3
                  ],
                  [
                    28098.6,
                    99332.4
                  ],
                  [
                    28031.1,
                    99381.5
                  ],
                  [
                    27966.6,
                    99561.8
                  ],
                  [
                    27971.1,
                    99768.2
                  ]
                ],
                "id": 1927,
                "chat_link": "[&BIcHAAA=]"
              }
            },
            "adventures": [],
            "id": 1438,
            "mastery_points": [
              {
                "coord": [
                  26668.3,
                  99378.6
                ],
                "id": 656,
                "region": "Unknown"
              },
              {
                "coord": [
                  27464.2,
                  99373.4
                ],
                "id": 598,
                "region": "Unknown"
              },
              {
                "coord": [
                  27232.4,
                  99378
                ],
                "id": 588,
                "region": "Unknown"
              },
              {
                "coord": [
                  27971.3,
                  100034
                ],
                "id": 636,
                "region": "Unknown"
              },
              {
                "coord": [
                  28521.4,
                  99891.2
                ],
                "id": 655,
                "region": "Unknown"
              },
              {
                "coord": [
                  28333.7,
                  99261.2
                ],
                "id": 576,
                "region": "Unknown"
              },
              {
                "coord": [
                  27567,
                  99221.8
                ],
                "id": 549,
                "region": "Unknown"
              },
              {
                "coord": [
                  27837.8,
                  99729.1
                ],
                "id": 643,
                "region": "Unknown"
              },
              {
                "coord": [
                  25904,
                  99097.6
                ],
                "id": 602,
                "region": "Unknown"
              },
              {
                "coord": [
                  28466.2,
                  98372.5
                ],
                "id": 575,
                "region": "Unknown"
              },
              {
                "coord": [
                  25310.5,
                  100376
                ],
                "id": 660,
                "region": "Unknown"
              },
              {
                "coord": [
                  25333.8,
                  98530.2
                ],
                "id": 565,
                "region": "Unknown"
              },
              {
                "coord": [
                  25624.7,
                  99370.7
                ],
                "id": 552,
                "region": "Unknown"
              }
            ]
          },
          "1439": {
            "name": "The Only One",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              34175,
              103437
            ],
            "map_rect": [
              [
                -24576,
                -43008
              ],
              [
                27648,
                46080
              ]
            ],
            "continent_rect": [
              [
                33126,
                101838
              ],
              [
                35302,
                105550
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1849": {
                "name": "Seafarer's Enclave",
                "level": 80,
                "coord": [
                  34920.2,
                  103825
                ],
                "bounds": [
                  [
                    35165.7,
                    103247
                  ],
                  [
                    35162.1,
                    103456
                  ],
                  [
                    35104.5,
                    103575
                  ],
                  [
                    35165,
                    103795
                  ],
                  [
                    35173.1,
                    104030
                  ],
                  [
                    35212.2,
                    104215
                  ],
                  [
                    35195,
                    104371
                  ],
                  [
                    34783.7,
                    104396
                  ],
                  [
                    34728,
                    104200
                  ],
                  [
                    34656.3,
                    104032
                  ],
                  [
                    34586.8,
                    103950
                  ],
                  [
                    34630.6,
                    103763
                  ],
                  [
                    34785.5,
                    103640
                  ],
                  [
                    34785.9,
                    103453
                  ],
                  [
                    34669.2,
                    103248
                  ],
                  [
                    35165.7,
                    103247
                  ]
                ],
                "id": 1849,
                "chat_link": "[&BDkHAAA=]"
              },
              "1852": {
                "name": "Harvest Complex",
                "level": 80,
                "coord": [
                  34232,
                  104194
                ],
                "bounds": [
                  [
                    34112.3,
                    104288
                  ],
                  [
                    34001.1,
                    104348
                  ],
                  [
                    33946.4,
                    104453
                  ],
                  [
                    33675.5,
                    104328
                  ],
                  [
                    33724.2,
                    104122
                  ],
                  [
                    33729.2,
                    104016
                  ],
                  [
                    33810.4,
                    103896
                  ],
                  [
                    33857.5,
                    103880
                  ],
                  [
                    33905.5,
                    103868
                  ],
                  [
                    34100.3,
                    103868
                  ],
                  [
                    34157.2,
                    103914
                  ],
                  [
                    34469.6,
                    103919
                  ],
                  [
                    34586.8,
                    103950
                  ],
                  [
                    34656.3,
                    104032
                  ],
                  [
                    34728,
                    104200
                  ],
                  [
                    34783.7,
                    104396
                  ],
                  [
                    34796.7,
                    104515
                  ],
                  [
                    34639.8,
                    104601
                  ],
                  [
                    34423,
                    104598
                  ],
                  [
                    34397.2,
                    104455
                  ],
                  [
                    34349.4,
                    104340
                  ],
                  [
                    34254.3,
                    104289
                  ],
                  [
                    34112.3,
                    104288
                  ]
                ],
                "id": 1852,
                "chat_link": "[&BDwHAAA=]"
              },
              "1869": {
                "name": "Jade Promenade",
                "level": 80,
                "coord": [
                  34280.2,
                  103671
                ],
                "bounds": [
                  [
                    33810.4,
                    103609
                  ],
                  [
                    33810.4,
                    103896
                  ],
                  [
                    33857.5,
                    103880
                  ],
                  [
                    33905.5,
                    103868
                  ],
                  [
                    34100.3,
                    103868
                  ],
                  [
                    34157.2,
                    103914
                  ],
                  [
                    34469.6,
                    103919
                  ],
                  [
                    34586.8,
                    103950
                  ],
                  [
                    34630.6,
                    103763
                  ],
                  [
                    34785.5,
                    103640
                  ],
                  [
                    34785.9,
                    103453
                  ],
                  [
                    34669.2,
                    103248
                  ],
                  [
                    34514.7,
                    103333
                  ],
                  [
                    34372.5,
                    103375
                  ],
                  [
                    33746.9,
                    103353
                  ],
                  [
                    33810.4,
                    103609
                  ]
                ],
                "id": 1869,
                "chat_link": "[&BE0HAAA=]"
              },
              "1875": {
                "name": "Reaver's Ridge",
                "level": 80,
                "coord": [
                  34998.1,
                  102747
                ],
                "bounds": [
                  [
                    35165.7,
                    103247
                  ],
                  [
                    35169.5,
                    102982
                  ],
                  [
                    35161.7,
                    102723
                  ],
                  [
                    35154.6,
                    102449
                  ],
                  [
                    35183.3,
                    102261
                  ],
                  [
                    35046.8,
                    102255
                  ],
                  [
                    34899.7,
                    102299
                  ],
                  [
                    34905.9,
                    102668
                  ],
                  [
                    34920.5,
                    102808
                  ],
                  [
                    34887.7,
                    102933
                  ],
                  [
                    34812.8,
                    103091
                  ],
                  [
                    34669.2,
                    103248
                  ],
                  [
                    35165.7,
                    103247
                  ]
                ],
                "id": 1875,
                "chat_link": "[&BFMHAAA=]"
              },
              "1887": {
                "name": "Southern Bluff",
                "level": 80,
                "coord": [
                  34113.6,
                  105285
                ],
                "bounds": [
                  [
                    34261.5,
                    105143
                  ],
                  [
                    34111.5,
                    105143
                  ],
                  [
                    33918.5,
                    105106
                  ],
                  [
                    33731.8,
                    105320
                  ],
                  [
                    33748,
                    105444
                  ],
                  [
                    33973.4,
                    105438
                  ],
                  [
                    34303.4,
                    105436
                  ],
                  [
                    34502,
                    105425
                  ],
                  [
                    34472.5,
                    105108
                  ],
                  [
                    34261.5,
                    105143
                  ]
                ],
                "id": 1887,
                "chat_link": "[&BF8HAAA=]"
              },
              "1894": {
                "name": "The Jade Whirl",
                "level": 80,
                "coord": [
                  34176.8,
                  104554
                ],
                "bounds": [
                  [
                    34112.3,
                    104288
                  ],
                  [
                    34001.1,
                    104348
                  ],
                  [
                    33946.4,
                    104453
                  ],
                  [
                    33916.4,
                    104603
                  ],
                  [
                    33979.1,
                    104770
                  ],
                  [
                    34112.4,
                    104864
                  ],
                  [
                    34254.8,
                    104865
                  ],
                  [
                    34375.6,
                    104778
                  ],
                  [
                    34423,
                    104598
                  ],
                  [
                    34397.2,
                    104455
                  ],
                  [
                    34349.4,
                    104340
                  ],
                  [
                    34254.3,
                    104289
                  ],
                  [
                    34112.3,
                    104288
                  ]
                ],
                "id": 1894,
                "chat_link": "[&BGYHAAA=]"
              },
              "1900": {
                "name": "Silent Surf",
                "level": 80,
                "coord": [
                  34926.4,
                  104874
                ],
                "bounds": [
                  [
                    35026,
                    105402
                  ],
                  [
                    35144.5,
                    105354
                  ],
                  [
                    35183.8,
                    105255
                  ],
                  [
                    35194.8,
                    104747
                  ],
                  [
                    35158,
                    104627
                  ],
                  [
                    35174.5,
                    104535
                  ],
                  [
                    35195,
                    104371
                  ],
                  [
                    34783.7,
                    104396
                  ],
                  [
                    34796.7,
                    104515
                  ],
                  [
                    34871.7,
                    104663
                  ],
                  [
                    34883.8,
                    104779
                  ],
                  [
                    34833.4,
                    104896
                  ],
                  [
                    34675.4,
                    105037
                  ],
                  [
                    34472.5,
                    105108
                  ],
                  [
                    34502,
                    105425
                  ],
                  [
                    35026,
                    105402
                  ]
                ],
                "id": 1900,
                "chat_link": "[&BGwHAAA=]"
              },
              "1911": {
                "name": "Western Vale",
                "level": 80,
                "coord": [
                  33515.9,
                  103628
                ],
                "bounds": [
                  [
                    33810.4,
                    103609
                  ],
                  [
                    33810.4,
                    103896
                  ],
                  [
                    33729.2,
                    104016
                  ],
                  [
                    33724.2,
                    104122
                  ],
                  [
                    33675.5,
                    104328
                  ],
                  [
                    33283.2,
                    104324
                  ],
                  [
                    33245.3,
                    103852
                  ],
                  [
                    33276.8,
                    103528
                  ],
                  [
                    33272.9,
                    103397
                  ],
                  [
                    33243.3,
                    103191
                  ],
                  [
                    33237.4,
                    103104
                  ],
                  [
                    33525,
                    103088
                  ],
                  [
                    33522.1,
                    103280
                  ],
                  [
                    33635.5,
                    103335
                  ],
                  [
                    33746.9,
                    103353
                  ],
                  [
                    33810.4,
                    103609
                  ]
                ],
                "id": 1911,
                "chat_link": "[&BHcHAAA=]"
              },
              "1912": {
                "name": "Archipelagos Rim",
                "level": 80,
                "coord": [
                  34769.6,
                  102167
                ],
                "bounds": [
                  [
                    35091.2,
                    102049
                  ],
                  [
                    34671.5,
                    101998
                  ],
                  [
                    34491,
                    102015
                  ],
                  [
                    34161.1,
                    102077
                  ],
                  [
                    34157.3,
                    102203
                  ],
                  [
                    34507.5,
                    102333
                  ],
                  [
                    34732.6,
                    102329
                  ],
                  [
                    34899.7,
                    102299
                  ],
                  [
                    35046.8,
                    102255
                  ],
                  [
                    35183.3,
                    102261
                  ],
                  [
                    35161.5,
                    102112
                  ],
                  [
                    35132.2,
                    102067
                  ],
                  [
                    35091.2,
                    102049
                  ]
                ],
                "id": 1912,
                "chat_link": "[&BHgHAAA=]"
              },
              "1914": {
                "name": "Echovald Fringe",
                "level": 80,
                "coord": [
                  33581.6,
                  104830
                ],
                "bounds": [
                  [
                    33918.5,
                    105106
                  ],
                  [
                    33768.9,
                    105031
                  ],
                  [
                    33673.7,
                    104930
                  ],
                  [
                    33603.7,
                    104760
                  ],
                  [
                    33591.7,
                    104576
                  ],
                  [
                    33675.5,
                    104328
                  ],
                  [
                    33283.2,
                    104324
                  ],
                  [
                    33264.6,
                    104583
                  ],
                  [
                    33314.3,
                    105009
                  ],
                  [
                    33571.5,
                    105161
                  ],
                  [
                    33731.8,
                    105320
                  ],
                  [
                    33918.5,
                    105106
                  ]
                ],
                "id": 1914,
                "chat_link": "[&BHoHAAA=]"
              },
              "1919": {
                "name": "Outer Terrace",
                "level": 80,
                "coord": [
                  33992.2,
                  102779
                ],
                "bounds": [
                  [
                    33237.4,
                    103104
                  ],
                  [
                    33525,
                    103088
                  ],
                  [
                    33967.9,
                    102980
                  ],
                  [
                    34063.6,
                    103024
                  ],
                  [
                    34135.6,
                    103038
                  ],
                  [
                    34335.8,
                    102977
                  ],
                  [
                    34372.3,
                    102943
                  ],
                  [
                    34398.8,
                    102767
                  ],
                  [
                    34513.3,
                    102635
                  ],
                  [
                    34507.5,
                    102333
                  ],
                  [
                    34157.3,
                    102203
                  ],
                  [
                    34101.4,
                    102541
                  ],
                  [
                    34026.3,
                    102618
                  ],
                  [
                    33252.3,
                    102623
                  ],
                  [
                    33287.8,
                    102816
                  ],
                  [
                    33237.4,
                    103104
                  ]
                ],
                "id": 1919,
                "chat_link": "[&BH8HAAA=]"
              },
              "1920": {
                "name": "Xunlai Jade Quarry",
                "level": 80,
                "coord": [
                  33602.7,
                  102238
                ],
                "bounds": [
                  [
                    33267.8,
                    101966
                  ],
                  [
                    33400.3,
                    101983
                  ],
                  [
                    33607.3,
                    102023
                  ],
                  [
                    33969,
                    102075
                  ],
                  [
                    34161.1,
                    102077
                  ],
                  [
                    34157.3,
                    102203
                  ],
                  [
                    34101.4,
                    102541
                  ],
                  [
                    34026.3,
                    102618
                  ],
                  [
                    33252.3,
                    102623
                  ],
                  [
                    33280.5,
                    102478
                  ],
                  [
                    33262.5,
                    102304
                  ],
                  [
                    33175.8,
                    102184
                  ],
                  [
                    33172.9,
                    102016
                  ],
                  [
                    33267.8,
                    101966
                  ]
                ],
                "id": 1920,
                "chat_link": "[&BIAHAAA=]"
              },
              "1925": {
                "name": "Flooded Basin",
                "level": 80,
                "coord": [
                  34354.3,
                  102945
                ],
                "bounds": [
                  [
                    33522.1,
                    103280
                  ],
                  [
                    33525,
                    103088
                  ],
                  [
                    33967.9,
                    102980
                  ],
                  [
                    34063.6,
                    103024
                  ],
                  [
                    34135.6,
                    103038
                  ],
                  [
                    34335.8,
                    102977
                  ],
                  [
                    34372.3,
                    102943
                  ],
                  [
                    34398.8,
                    102767
                  ],
                  [
                    34513.3,
                    102635
                  ],
                  [
                    34507.5,
                    102333
                  ],
                  [
                    34732.6,
                    102329
                  ],
                  [
                    34899.7,
                    102299
                  ],
                  [
                    34905.9,
                    102668
                  ],
                  [
                    34920.5,
                    102808
                  ],
                  [
                    34887.7,
                    102933
                  ],
                  [
                    34812.8,
                    103091
                  ],
                  [
                    34669.2,
                    103248
                  ],
                  [
                    34514.7,
                    103333
                  ],
                  [
                    34372.5,
                    103375
                  ],
                  [
                    33746.9,
                    103353
                  ],
                  [
                    33635.5,
                    103335
                  ],
                  [
                    33522.1,
                    103280
                  ]
                ],
                "id": 1925,
                "chat_link": "[&BIUHAAA=]"
              },
              "1928": {
                "name": "Unwaking Waters",
                "level": 80,
                "coord": [
                  34217.5,
                  104798
                ],
                "bounds": [
                  [
                    34261.5,
                    105143
                  ],
                  [
                    34111.5,
                    105143
                  ],
                  [
                    33918.5,
                    105106
                  ],
                  [
                    33768.9,
                    105031
                  ],
                  [
                    33673.7,
                    104930
                  ],
                  [
                    33603.7,
                    104760
                  ],
                  [
                    33591.7,
                    104576
                  ],
                  [
                    33675.5,
                    104328
                  ],
                  [
                    33946.4,
                    104453
                  ],
                  [
                    33916.4,
                    104603
                  ],
                  [
                    33979.1,
                    104770
                  ],
                  [
                    34112.4,
                    104864
                  ],
                  [
                    34254.8,
                    104865
                  ],
                  [
                    34375.6,
                    104778
                  ],
                  [
                    34423,
                    104598
                  ],
                  [
                    34639.8,
                    104601
                  ],
                  [
                    34796.7,
                    104515
                  ],
                  [
                    34871.7,
                    104663
                  ],
                  [
                    34883.8,
                    104779
                  ],
                  [
                    34833.4,
                    104896
                  ],
                  [
                    34675.4,
                    105037
                  ],
                  [
                    34472.5,
                    105108
                  ],
                  [
                    34261.5,
                    105143
                  ]
                ],
                "id": 1928,
                "chat_link": "[&BIgHAAA=]"
              },
              "1929": {
                "name": "Mother's Lament",
                "level": 80,
                "coord": [
                  33542.4,
                  105335
                ],
                "bounds": [
                  [
                    33412.3,
                    105375
                  ],
                  [
                    33374.5,
                    105290
                  ],
                  [
                    33314.3,
                    105009
                  ],
                  [
                    33571.5,
                    105161
                  ],
                  [
                    33731.8,
                    105320
                  ],
                  [
                    33748,
                    105444
                  ],
                  [
                    33680.3,
                    105446
                  ],
                  [
                    33608.3,
                    105444
                  ],
                  [
                    33524,
                    105437
                  ],
                  [
                    33458.6,
                    105419
                  ],
                  [
                    33412.3,
                    105375
                  ]
                ],
                "id": 1929,
                "chat_link": "[&BIkHAAA=]"
              }
            },
            "adventures": [],
            "id": 1439,
            "mastery_points": []
          },
          "1440": {
            "name": "Laying to Rest",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              34175,
              103437
            ],
            "map_rect": [
              [
                -24576,
                -43008
              ],
              [
                27648,
                46080
              ]
            ],
            "continent_rect": [
              [
                33126,
                101838
              ],
              [
                35302,
                105550
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1849": {
                "name": "Seafarer's Enclave",
                "level": 80,
                "coord": [
                  34920.2,
                  103825
                ],
                "bounds": [
                  [
                    35165.7,
                    103247
                  ],
                  [
                    35162.1,
                    103456
                  ],
                  [
                    35104.5,
                    103575
                  ],
                  [
                    35165,
                    103795
                  ],
                  [
                    35173.1,
                    104030
                  ],
                  [
                    35212.2,
                    104215
                  ],
                  [
                    35195,
                    104371
                  ],
                  [
                    34783.7,
                    104396
                  ],
                  [
                    34728,
                    104200
                  ],
                  [
                    34656.3,
                    104032
                  ],
                  [
                    34586.8,
                    103950
                  ],
                  [
                    34630.6,
                    103763
                  ],
                  [
                    34785.5,
                    103640
                  ],
                  [
                    34785.9,
                    103453
                  ],
                  [
                    34669.2,
                    103248
                  ],
                  [
                    35165.7,
                    103247
                  ]
                ],
                "id": 1849,
                "chat_link": "[&BDkHAAA=]"
              },
              "1852": {
                "name": "Harvest Complex",
                "level": 80,
                "coord": [
                  34232,
                  104194
                ],
                "bounds": [
                  [
                    34112.3,
                    104288
                  ],
                  [
                    34001.1,
                    104348
                  ],
                  [
                    33946.4,
                    104453
                  ],
                  [
                    33675.5,
                    104328
                  ],
                  [
                    33724.2,
                    104122
                  ],
                  [
                    33729.2,
                    104016
                  ],
                  [
                    33810.4,
                    103896
                  ],
                  [
                    33857.5,
                    103880
                  ],
                  [
                    33905.5,
                    103868
                  ],
                  [
                    34100.3,
                    103868
                  ],
                  [
                    34157.2,
                    103914
                  ],
                  [
                    34469.6,
                    103919
                  ],
                  [
                    34586.8,
                    103950
                  ],
                  [
                    34656.3,
                    104032
                  ],
                  [
                    34728,
                    104200
                  ],
                  [
                    34783.7,
                    104396
                  ],
                  [
                    34796.7,
                    104515
                  ],
                  [
                    34639.8,
                    104601
                  ],
                  [
                    34423,
                    104598
                  ],
                  [
                    34397.2,
                    104455
                  ],
                  [
                    34349.4,
                    104340
                  ],
                  [
                    34254.3,
                    104289
                  ],
                  [
                    34112.3,
                    104288
                  ]
                ],
                "id": 1852,
                "chat_link": "[&BDwHAAA=]"
              },
              "1869": {
                "name": "Jade Promenade",
                "level": 80,
                "coord": [
                  34280.2,
                  103671
                ],
                "bounds": [
                  [
                    33810.4,
                    103609
                  ],
                  [
                    33810.4,
                    103896
                  ],
                  [
                    33857.5,
                    103880
                  ],
                  [
                    33905.5,
                    103868
                  ],
                  [
                    34100.3,
                    103868
                  ],
                  [
                    34157.2,
                    103914
                  ],
                  [
                    34469.6,
                    103919
                  ],
                  [
                    34586.8,
                    103950
                  ],
                  [
                    34630.6,
                    103763
                  ],
                  [
                    34785.5,
                    103640
                  ],
                  [
                    34785.9,
                    103453
                  ],
                  [
                    34669.2,
                    103248
                  ],
                  [
                    34514.7,
                    103333
                  ],
                  [
                    34372.5,
                    103375
                  ],
                  [
                    33746.9,
                    103353
                  ],
                  [
                    33810.4,
                    103609
                  ]
                ],
                "id": 1869,
                "chat_link": "[&BE0HAAA=]"
              },
              "1875": {
                "name": "Reaver's Ridge",
                "level": 80,
                "coord": [
                  34998.1,
                  102747
                ],
                "bounds": [
                  [
                    35165.7,
                    103247
                  ],
                  [
                    35169.5,
                    102982
                  ],
                  [
                    35161.7,
                    102723
                  ],
                  [
                    35154.6,
                    102449
                  ],
                  [
                    35183.3,
                    102261
                  ],
                  [
                    35046.8,
                    102255
                  ],
                  [
                    34899.7,
                    102299
                  ],
                  [
                    34905.9,
                    102668
                  ],
                  [
                    34920.5,
                    102808
                  ],
                  [
                    34887.7,
                    102933
                  ],
                  [
                    34812.8,
                    103091
                  ],
                  [
                    34669.2,
                    103248
                  ],
                  [
                    35165.7,
                    103247
                  ]
                ],
                "id": 1875,
                "chat_link": "[&BFMHAAA=]"
              },
              "1887": {
                "name": "Southern Bluff",
                "level": 80,
                "coord": [
                  34113.6,
                  105285
                ],
                "bounds": [
                  [
                    34261.5,
                    105143
                  ],
                  [
                    34111.5,
                    105143
                  ],
                  [
                    33918.5,
                    105106
                  ],
                  [
                    33731.8,
                    105320
                  ],
                  [
                    33748,
                    105444
                  ],
                  [
                    33973.4,
                    105438
                  ],
                  [
                    34303.4,
                    105436
                  ],
                  [
                    34502,
                    105425
                  ],
                  [
                    34472.5,
                    105108
                  ],
                  [
                    34261.5,
                    105143
                  ]
                ],
                "id": 1887,
                "chat_link": "[&BF8HAAA=]"
              },
              "1894": {
                "name": "The Jade Whirl",
                "level": 80,
                "coord": [
                  34176.8,
                  104554
                ],
                "bounds": [
                  [
                    34112.3,
                    104288
                  ],
                  [
                    34001.1,
                    104348
                  ],
                  [
                    33946.4,
                    104453
                  ],
                  [
                    33916.4,
                    104603
                  ],
                  [
                    33979.1,
                    104770
                  ],
                  [
                    34112.4,
                    104864
                  ],
                  [
                    34254.8,
                    104865
                  ],
                  [
                    34375.6,
                    104778
                  ],
                  [
                    34423,
                    104598
                  ],
                  [
                    34397.2,
                    104455
                  ],
                  [
                    34349.4,
                    104340
                  ],
                  [
                    34254.3,
                    104289
                  ],
                  [
                    34112.3,
                    104288
                  ]
                ],
                "id": 1894,
                "chat_link": "[&BGYHAAA=]"
              },
              "1900": {
                "name": "Silent Surf",
                "level": 80,
                "coord": [
                  34926.4,
                  104874
                ],
                "bounds": [
                  [
                    35026,
                    105402
                  ],
                  [
                    35144.5,
                    105354
                  ],
                  [
                    35183.8,
                    105255
                  ],
                  [
                    35194.8,
                    104747
                  ],
                  [
                    35158,
                    104627
                  ],
                  [
                    35174.5,
                    104535
                  ],
                  [
                    35195,
                    104371
                  ],
                  [
                    34783.7,
                    104396
                  ],
                  [
                    34796.7,
                    104515
                  ],
                  [
                    34871.7,
                    104663
                  ],
                  [
                    34883.8,
                    104779
                  ],
                  [
                    34833.4,
                    104896
                  ],
                  [
                    34675.4,
                    105037
                  ],
                  [
                    34472.5,
                    105108
                  ],
                  [
                    34502,
                    105425
                  ],
                  [
                    35026,
                    105402
                  ]
                ],
                "id": 1900,
                "chat_link": "[&BGwHAAA=]"
              },
              "1911": {
                "name": "Western Vale",
                "level": 80,
                "coord": [
                  33515.9,
                  103628
                ],
                "bounds": [
                  [
                    33810.4,
                    103609
                  ],
                  [
                    33810.4,
                    103896
                  ],
                  [
                    33729.2,
                    104016
                  ],
                  [
                    33724.2,
                    104122
                  ],
                  [
                    33675.5,
                    104328
                  ],
                  [
                    33283.2,
                    104324
                  ],
                  [
                    33245.3,
                    103852
                  ],
                  [
                    33276.8,
                    103528
                  ],
                  [
                    33272.9,
                    103397
                  ],
                  [
                    33243.3,
                    103191
                  ],
                  [
                    33237.4,
                    103104
                  ],
                  [
                    33525,
                    103088
                  ],
                  [
                    33522.1,
                    103280
                  ],
                  [
                    33635.5,
                    103335
                  ],
                  [
                    33746.9,
                    103353
                  ],
                  [
                    33810.4,
                    103609
                  ]
                ],
                "id": 1911,
                "chat_link": "[&BHcHAAA=]"
              },
              "1912": {
                "name": "Archipelagos Rim",
                "level": 80,
                "coord": [
                  34769.6,
                  102167
                ],
                "bounds": [
                  [
                    35091.2,
                    102049
                  ],
                  [
                    34671.5,
                    101998
                  ],
                  [
                    34491,
                    102015
                  ],
                  [
                    34161.1,
                    102077
                  ],
                  [
                    34157.3,
                    102203
                  ],
                  [
                    34507.5,
                    102333
                  ],
                  [
                    34732.6,
                    102329
                  ],
                  [
                    34899.7,
                    102299
                  ],
                  [
                    35046.8,
                    102255
                  ],
                  [
                    35183.3,
                    102261
                  ],
                  [
                    35161.5,
                    102112
                  ],
                  [
                    35132.2,
                    102067
                  ],
                  [
                    35091.2,
                    102049
                  ]
                ],
                "id": 1912,
                "chat_link": "[&BHgHAAA=]"
              },
              "1914": {
                "name": "Echovald Fringe",
                "level": 80,
                "coord": [
                  33581.6,
                  104830
                ],
                "bounds": [
                  [
                    33918.5,
                    105106
                  ],
                  [
                    33768.9,
                    105031
                  ],
                  [
                    33673.7,
                    104930
                  ],
                  [
                    33603.7,
                    104760
                  ],
                  [
                    33591.7,
                    104576
                  ],
                  [
                    33675.5,
                    104328
                  ],
                  [
                    33283.2,
                    104324
                  ],
                  [
                    33264.6,
                    104583
                  ],
                  [
                    33314.3,
                    105009
                  ],
                  [
                    33571.5,
                    105161
                  ],
                  [
                    33731.8,
                    105320
                  ],
                  [
                    33918.5,
                    105106
                  ]
                ],
                "id": 1914,
                "chat_link": "[&BHoHAAA=]"
              },
              "1919": {
                "name": "Outer Terrace",
                "level": 80,
                "coord": [
                  33992.2,
                  102779
                ],
                "bounds": [
                  [
                    33237.4,
                    103104
                  ],
                  [
                    33525,
                    103088
                  ],
                  [
                    33967.9,
                    102980
                  ],
                  [
                    34063.6,
                    103024
                  ],
                  [
                    34135.6,
                    103038
                  ],
                  [
                    34335.8,
                    102977
                  ],
                  [
                    34372.3,
                    102943
                  ],
                  [
                    34398.8,
                    102767
                  ],
                  [
                    34513.3,
                    102635
                  ],
                  [
                    34507.5,
                    102333
                  ],
                  [
                    34157.3,
                    102203
                  ],
                  [
                    34101.4,
                    102541
                  ],
                  [
                    34026.3,
                    102618
                  ],
                  [
                    33252.3,
                    102623
                  ],
                  [
                    33287.8,
                    102816
                  ],
                  [
                    33237.4,
                    103104
                  ]
                ],
                "id": 1919,
                "chat_link": "[&BH8HAAA=]"
              },
              "1920": {
                "name": "Xunlai Jade Quarry",
                "level": 80,
                "coord": [
                  33602.7,
                  102238
                ],
                "bounds": [
                  [
                    33267.8,
                    101966
                  ],
                  [
                    33400.3,
                    101983
                  ],
                  [
                    33607.3,
                    102023
                  ],
                  [
                    33969,
                    102075
                  ],
                  [
                    34161.1,
                    102077
                  ],
                  [
                    34157.3,
                    102203
                  ],
                  [
                    34101.4,
                    102541
                  ],
                  [
                    34026.3,
                    102618
                  ],
                  [
                    33252.3,
                    102623
                  ],
                  [
                    33280.5,
                    102478
                  ],
                  [
                    33262.5,
                    102304
                  ],
                  [
                    33175.8,
                    102184
                  ],
                  [
                    33172.9,
                    102016
                  ],
                  [
                    33267.8,
                    101966
                  ]
                ],
                "id": 1920,
                "chat_link": "[&BIAHAAA=]"
              },
              "1925": {
                "name": "Flooded Basin",
                "level": 80,
                "coord": [
                  34354.3,
                  102945
                ],
                "bounds": [
                  [
                    33522.1,
                    103280
                  ],
                  [
                    33525,
                    103088
                  ],
                  [
                    33967.9,
                    102980
                  ],
                  [
                    34063.6,
                    103024
                  ],
                  [
                    34135.6,
                    103038
                  ],
                  [
                    34335.8,
                    102977
                  ],
                  [
                    34372.3,
                    102943
                  ],
                  [
                    34398.8,
                    102767
                  ],
                  [
                    34513.3,
                    102635
                  ],
                  [
                    34507.5,
                    102333
                  ],
                  [
                    34732.6,
                    102329
                  ],
                  [
                    34899.7,
                    102299
                  ],
                  [
                    34905.9,
                    102668
                  ],
                  [
                    34920.5,
                    102808
                  ],
                  [
                    34887.7,
                    102933
                  ],
                  [
                    34812.8,
                    103091
                  ],
                  [
                    34669.2,
                    103248
                  ],
                  [
                    34514.7,
                    103333
                  ],
                  [
                    34372.5,
                    103375
                  ],
                  [
                    33746.9,
                    103353
                  ],
                  [
                    33635.5,
                    103335
                  ],
                  [
                    33522.1,
                    103280
                  ]
                ],
                "id": 1925,
                "chat_link": "[&BIUHAAA=]"
              },
              "1928": {
                "name": "Unwaking Waters",
                "level": 80,
                "coord": [
                  34217.5,
                  104798
                ],
                "bounds": [
                  [
                    34261.5,
                    105143
                  ],
                  [
                    34111.5,
                    105143
                  ],
                  [
                    33918.5,
                    105106
                  ],
                  [
                    33768.9,
                    105031
                  ],
                  [
                    33673.7,
                    104930
                  ],
                  [
                    33603.7,
                    104760
                  ],
                  [
                    33591.7,
                    104576
                  ],
                  [
                    33675.5,
                    104328
                  ],
                  [
                    33946.4,
                    104453
                  ],
                  [
                    33916.4,
                    104603
                  ],
                  [
                    33979.1,
                    104770
                  ],
                  [
                    34112.4,
                    104864
                  ],
                  [
                    34254.8,
                    104865
                  ],
                  [
                    34375.6,
                    104778
                  ],
                  [
                    34423,
                    104598
                  ],
                  [
                    34639.8,
                    104601
                  ],
                  [
                    34796.7,
                    104515
                  ],
                  [
                    34871.7,
                    104663
                  ],
                  [
                    34883.8,
                    104779
                  ],
                  [
                    34833.4,
                    104896
                  ],
                  [
                    34675.4,
                    105037
                  ],
                  [
                    34472.5,
                    105108
                  ],
                  [
                    34261.5,
                    105143
                  ]
                ],
                "id": 1928,
                "chat_link": "[&BIgHAAA=]"
              },
              "1929": {
                "name": "Mother's Lament",
                "level": 80,
                "coord": [
                  33542.4,
                  105335
                ],
                "bounds": [
                  [
                    33412.3,
                    105375
                  ],
                  [
                    33374.5,
                    105290
                  ],
                  [
                    33314.3,
                    105009
                  ],
                  [
                    33571.5,
                    105161
                  ],
                  [
                    33731.8,
                    105320
                  ],
                  [
                    33748,
                    105444
                  ],
                  [
                    33680.3,
                    105446
                  ],
                  [
                    33608.3,
                    105444
                  ],
                  [
                    33524,
                    105437
                  ],
                  [
                    33458.6,
                    105419
                  ],
                  [
                    33412.3,
                    105375
                  ]
                ],
                "id": 1929,
                "chat_link": "[&BIkHAAA=]"
              }
            },
            "adventures": [],
            "id": 1440,
            "mastery_points": []
          },
          "1442": {
            "name": "Seitung Province",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              23150,
              101800
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                33792
              ]
            ],
            "continent_rect": [
              [
                21159,
                100457
              ],
              [
                24999,
                103145
              ]
            ],
            "points_of_interest": {
              "3214": {
                "name": "Spirit Vestibule",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  23605.7,
                  102327
                ],
                "id": 3214,
                "chat_link": "[&BI4MAAA=]"
              },
              "3215": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  24679.3,
                  101370
                ],
                "id": 3215,
                "chat_link": "[&BI8MAAA=]"
              },
              "3221": {
                "name": "Ministry of Transit",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  23270.6,
                  101537
                ],
                "id": 3221,
                "chat_link": "[&BJUMAAA=]"
              },
              "3226": {
                "name": "Combat Arena",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  21987.9,
                  102700
                ],
                "id": 3226,
                "chat_link": "[&BJoMAAA=]"
              },
              "3228": {
                "name": "Northern Aetherblade Crash Site",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  23221.8,
                  101025
                ],
                "id": 3228,
                "chat_link": "[&BJwMAAA=]"
              },
              "3230": {
                "name": "Village Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  22949.4,
                  102166
                ],
                "id": 3230,
                "chat_link": "[&BJ4MAAA=]"
              },
              "3240": {
                "name": "Harbor Market",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  22977.5,
                  102097
                ],
                "id": 3240,
                "chat_link": "[&BKgMAAA=]"
              },
              "3242": {
                "name": "Fishing Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  22769.1,
                  102342
                ],
                "id": 3242,
                "chat_link": "[&BKoMAAA=]"
              },
              "3244": {
                "name": "Bell Passage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  22552.8,
                  101941
                ],
                "id": 3244,
                "chat_link": "[&BKwMAAA=]"
              },
              "3246": {
                "name": "Daigo Dump Site",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  23816.4,
                  101496
                ],
                "id": 3246,
                "chat_link": "[&BK4MAAA=]"
              },
              "3248": {
                "name": "Zen Daijun Temple",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  23419.4,
                  102452
                ],
                "id": 3248,
                "chat_link": "[&BLAMAAA=]"
              },
              "3261": {
                "name": "Monastery Temple",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  21628.5,
                  101935
                ],
                "id": 3261,
                "chat_link": "[&BL0MAAA=]"
              },
              "3263": {
                "name": "Monastery Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  21672.7,
                  102058
                ],
                "id": 3263,
                "chat_link": "[&BL8MAAA=]"
              },
              "3265": {
                "name": "Jade Memorial",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  22998.1,
                  101557
                ],
                "id": 3265,
                "chat_link": "[&BMEMAAA=]"
              },
              "3267": {
                "name": "Imperial Overlook",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  22337.5,
                  102114
                ],
                "id": 3267,
                "chat_link": "[&BMMMAAA=]"
              },
              "3269": {
                "name": "Aetherblade Refuge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  23189.4,
                  100848
                ],
                "id": 3269,
                "chat_link": "[&BMUMAAA=]"
              },
              "3272": {
                "name": "Seitung Prison",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  22933.9,
                  102522
                ],
                "id": 3272,
                "chat_link": "[&BMgMAAA=]"
              },
              "3273": {
                "name": "Dreary Caves",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  21743.4,
                  102725
                ],
                "id": 3273,
                "chat_link": "[&BMkMAAA=]"
              },
              "3275": {
                "name": "Royal Court",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  21391.9,
                  102164
                ],
                "id": 3275,
                "chat_link": "[&BMsMAAA=]"
              },
              "3281": {
                "name": "Sensali Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  21480.8,
                  101204
                ],
                "id": 3281,
                "chat_link": "[&BNEMAAA=]"
              },
              "3283": {
                "name": "Drizzle Cove",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  22795.8,
                  101583
                ],
                "id": 3283,
                "chat_link": "[&BNMMAAA=]"
              },
              "3302": {
                "name": "Hollow Caves",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  23748.4,
                  102533
                ],
                "id": 3302,
                "chat_link": "[&BOYMAAA=]"
              },
              "3303": {
                "name": "Aetherblade Flagship Wreckage",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  21559.5,
                  102585
                ],
                "id": 3303,
                "chat_link": "[&BOcMAAA=]"
              },
              "3304": {
                "name": "Aurene's Enclave",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  22342.2,
                  102884
                ],
                "id": 3304,
                "chat_link": "[&BOgMAAA=]"
              },
              "3310": {
                "name": "Fishing Hamlet",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  24508.8,
                  102484
                ],
                "id": 3310,
                "chat_link": "[&BO4MAAA=]"
              },
              "3316": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  22871.4,
                  102317
                ],
                "id": 3316,
                "chat_link": "[&BPQMAAA=]"
              },
              "3324": {
                "name": "Emperor's Watchtower",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  24538.9,
                  101135
                ],
                "id": 3324,
                "chat_link": "[&BPwMAAA=]"
              },
              "3325": {
                "name": "Serene Pool",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  23881.9,
                  101916
                ],
                "id": 3325,
                "chat_link": "[&BP0MAAA=]"
              },
              "3327": {
                "name": "Painter's Platform",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  22221.8,
                  102605
                ],
                "id": 3327,
                "chat_link": "[&BP8MAAA=]"
              },
              "3340": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  21757.3,
                  102267
                ],
                "id": 3340,
                "chat_link": "[&BAwNAAA=]"
              },
              "3341": {
                "name": "Shrine of Reverence",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  22337.8,
                  101667
                ],
                "id": 3341,
                "chat_link": "[&BA0NAAA=]"
              },
              "3346": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  23862.4,
                  101346
                ],
                "id": 3346,
                "chat_link": "[&BBINAAA=]"
              },
              "3354": {
                "name": "Cat Island",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  23201,
                  102945
                ],
                "id": 3354,
                "chat_link": "[&BBoNAAA=]"
              },
              "3357": {
                "name": "Western Aetherblade Crash Site",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  22476.6,
                  100981
                ],
                "id": 3357,
                "chat_link": "[&BB0NAAA=]"
              },
              "3362": {
                "name": "Town Outskirts",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  22785.4,
                  101972
                ],
                "id": 3362,
                "chat_link": "[&BCINAAA=]"
              },
              "3365": {
                "name": "Naga Domain",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  24631.8,
                  102853
                ],
                "id": 3365,
                "chat_link": "[&BCUNAAA=]"
              },
              "3388": {
                "name": "Secured Gate",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  21438.8,
                  101926
                ],
                "id": 3388,
                "chat_link": "[&BDwNAAA=]"
              },
              "3390": {
                "name": "Obstacle Course",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  21984,
                  102541
                ],
                "id": 3390,
                "chat_link": "[&BD4NAAA=]"
              },
              "3394": {
                "name": "Fish Hatchery",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  22804,
                  100657
                ],
                "id": 3394,
                "chat_link": "[&BEINAAA=]"
              },
              "3397": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  22162.3,
                  101136
                ],
                "id": 3397,
                "chat_link": "[&BEUNAAA=]"
              },
              "3405": {
                "name": "Eastern Aetherblade Crash Site",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  24099.1,
                  100799
                ],
                "id": 3405,
                "chat_link": "[&BE0NAAA=]"
              },
              "3407": {
                "name": "Provisional MinSec Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  24558.3,
                  101507
                ],
                "id": 3407,
                "chat_link": "[&BE8NAAA=]"
              },
              "3408": {
                "name": "Derelict Temple",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  24588.4,
                  101954
                ],
                "id": 3408,
                "chat_link": "[&BFANAAA=]"
              },
              "3410": {
                "name": "Joon's Mansion",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  23574.5,
                  101925
                ],
                "id": 3410,
                "chat_link": "[&BFINAAA=]"
              },
              "3416": {
                "name": "Valor Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  23316.3,
                  101929
                ],
                "id": 3416,
                "chat_link": "[&BFgNAAA=]"
              },
              "3422": {
                "name": "Sizhou Hall",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  22041.4,
                  100892
                ],
                "id": 3422,
                "chat_link": "[&BF4NAAA=]"
              },
              "3428": {
                "name": "Haiju Docks Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  23637.6,
                  100727
                ],
                "id": 3428,
                "chat_link": "[&BGQNAAA=]"
              },
              "3429": {
                "name": "Daigo Ward Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  23191.2,
                  101452
                ],
                "id": 3429,
                "chat_link": "[&BGUNAAA=]"
              },
              "3430": {
                "name": "Tengu Alpine Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  21582.2,
                  100744
                ],
                "id": 3430,
                "chat_link": "[&BGYNAAA=]"
              },
              "3435": {
                "name": "Abandoned Lighthouse",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  24655.1,
                  100700
                ],
                "id": 3435,
                "chat_link": "[&BGsNAAA=]"
              }
            },
            "tasks": {
              "442": {
                "objective": "Assist the temple in its defense.",
                "level": 80,
                "coord": [
                  22141.6,
                  100957
                ],
                "bounds": [
                  [
                    21868.7,
                    101351
                  ],
                  [
                    21952.8,
                    101398
                  ],
                  [
                    22145.6,
                    101464
                  ],
                  [
                    22441.9,
                    101600
                  ],
                  [
                    22441.2,
                    101669
                  ],
                  [
                    22467.3,
                    101707
                  ],
                  [
                    22488,
                    101856
                  ],
                  [
                    22643.5,
                    101832
                  ],
                  [
                    22753,
                    101782
                  ],
                  [
                    22826.4,
                    101774
                  ],
                  [
                    23009.5,
                    101766
                  ],
                  [
                    22921.3,
                    101651
                  ],
                  [
                    22895,
                    101557
                  ],
                  [
                    22816.1,
                    101441
                  ],
                  [
                    22816.3,
                    101348
                  ],
                  [
                    22853.9,
                    101275
                  ],
                  [
                    22914.3,
                    101261
                  ],
                  [
                    22868.9,
                    101106
                  ],
                  [
                    22794.1,
                    101013
                  ],
                  [
                    22772.5,
                    100938
                  ],
                  [
                    22863.6,
                    100852
                  ],
                  [
                    22956,
                    100701
                  ],
                  [
                    22942.8,
                    100461
                  ],
                  [
                    21987.2,
                    100466
                  ],
                  [
                    21937.8,
                    100669
                  ],
                  [
                    21837.2,
                    100830
                  ],
                  [
                    21819.1,
                    100955
                  ],
                  [
                    21850.8,
                    101074
                  ],
                  [
                    21839.2,
                    101147
                  ],
                  [
                    21814.6,
                    101234
                  ],
                  [
                    21868.7,
                    101351
                  ]
                ],
                "id": 442,
                "chat_link": "[&BLoBAAA=]"
              },
              "446": {
                "objective": "Demonstrate your fishing skills to the village fishermen.",
                "level": 80,
                "coord": [
                  24383,
                  102235
                ],
                "bounds": [
                  [
                    24050.6,
                    102324
                  ],
                  [
                    24243.6,
                    102049
                  ],
                  [
                    24683.4,
                    102228
                  ],
                  [
                    24792.1,
                    102579
                  ],
                  [
                    24173,
                    102856
                  ],
                  [
                    23916.6,
                    102735
                  ],
                  [
                    24050.6,
                    102324
                  ]
                ],
                "id": 446,
                "chat_link": "[&BL4BAAA=]"
              },
              "448": {
                "objective": "Monastery Training",
                "level": 80,
                "coord": [
                  22152.7,
                  102584
                ],
                "bounds": [
                  [
                    21920,
                    102436
                  ],
                  [
                    22128,
                    102405
                  ],
                  [
                    22295.6,
                    102436
                  ],
                  [
                    22330.8,
                    102651
                  ],
                  [
                    22092.8,
                    102818
                  ],
                  [
                    21866,
                    102819
                  ],
                  [
                    21842.6,
                    102627
                  ],
                  [
                    21920,
                    102436
                  ]
                ],
                "id": 448,
                "chat_link": "[&BMABAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  22226.2,
                  102476
                ]
              },
              {
                "coord": [
                  23730.2,
                  101104
                ]
              },
              {
                "coord": [
                  23893.3,
                  102167
                ]
              },
              {
                "coord": [
                  22559.2,
                  102221
                ]
              },
              {
                "coord": [
                  24684.9,
                  102456
                ]
              },
              {
                "coord": [
                  22029.2,
                  101971
                ]
              },
              {
                "coord": [
                  22402.9,
                  101554
                ]
              },
              {
                "coord": [
                  22792,
                  100671
                ]
              },
              {
                "coord": [
                  22935.8,
                  101724
                ]
              }
            ],
            "sectors": {
              "1853": {
                "name": "Eastern Wilds",
                "level": 80,
                "coord": [
                  24409.8,
                  102377
                ],
                "bounds": [
                  [
                    24283.8,
                    101769
                  ],
                  [
                    24211.6,
                    102047
                  ],
                  [
                    24152.9,
                    102179
                  ],
                  [
                    24116.7,
                    102269
                  ],
                  [
                    24027.8,
                    102411
                  ],
                  [
                    23990.4,
                    102573
                  ],
                  [
                    23945.8,
                    102784
                  ],
                  [
                    23966.9,
                    103136
                  ],
                  [
                    24933.7,
                    103135
                  ],
                  [
                    24987.8,
                    103132
                  ],
                  [
                    24989.3,
                    102962
                  ],
                  [
                    24989.9,
                    101825
                  ],
                  [
                    24624.4,
                    101823
                  ],
                  [
                    24518.2,
                    101794
                  ],
                  [
                    24408.2,
                    101821
                  ],
                  [
                    24283.8,
                    101769
                  ]
                ],
                "id": 1853,
                "chat_link": "[&BD0HAAA=]"
              },
              "1856": {
                "name": "Haiju Lagoon",
                "level": 80,
                "coord": [
                  23988.9,
                  101245
                ],
                "bounds": [
                  [
                    23795.8,
                    101064
                  ],
                  [
                    23772.2,
                    101214
                  ],
                  [
                    23771.9,
                    101277
                  ],
                  [
                    23744.7,
                    101353
                  ],
                  [
                    23703.9,
                    101457
                  ],
                  [
                    23778.8,
                    101638
                  ],
                  [
                    23827.2,
                    101823
                  ],
                  [
                    23901.8,
                    101778
                  ],
                  [
                    24030.5,
                    101735
                  ],
                  [
                    24280.3,
                    101767
                  ],
                  [
                    24271,
                    101534
                  ],
                  [
                    24247.4,
                    101369
                  ],
                  [
                    24246.4,
                    101180
                  ],
                  [
                    24328.7,
                    100957
                  ],
                  [
                    24406.4,
                    100759
                  ],
                  [
                    24436.1,
                    100462
                  ],
                  [
                    23746,
                    100461
                  ],
                  [
                    23746.6,
                    100857
                  ],
                  [
                    23754.2,
                    100967
                  ],
                  [
                    23795.8,
                    101064
                  ]
                ],
                "id": 1856,
                "chat_link": "[&BEAHAAA=]"
              },
              "1861": {
                "name": "Jaya Bluffs",
                "level": 80,
                "coord": [
                  21816.6,
                  101215
                ],
                "bounds": [
                  [
                    21307,
                    100850
                  ],
                  [
                    21324.4,
                    100947
                  ],
                  [
                    21348.6,
                    101112
                  ],
                  [
                    21374.1,
                    101197
                  ],
                  [
                    21415.8,
                    101339
                  ],
                  [
                    21475.2,
                    101401
                  ],
                  [
                    21571.7,
                    101530
                  ],
                  [
                    21627.7,
                    101606
                  ],
                  [
                    21563,
                    101652
                  ],
                  [
                    21712.8,
                    101702
                  ],
                  [
                    21886.1,
                    101817
                  ],
                  [
                    22002.6,
                    101779
                  ],
                  [
                    22147.1,
                    101785
                  ],
                  [
                    22386.5,
                    101850
                  ],
                  [
                    22495.1,
                    101854
                  ],
                  [
                    22471.8,
                    101702
                  ],
                  [
                    22446.1,
                    101668
                  ],
                  [
                    22447.1,
                    101596
                  ],
                  [
                    22147.8,
                    101463
                  ],
                  [
                    21958.1,
                    101398
                  ],
                  [
                    21873.3,
                    101352
                  ],
                  [
                    21817.1,
                    101238
                  ],
                  [
                    21847.8,
                    101149
                  ],
                  [
                    21855.3,
                    101076
                  ],
                  [
                    21824,
                    100954
                  ],
                  [
                    21840.6,
                    100836
                  ],
                  [
                    21941.8,
                    100674
                  ],
                  [
                    21992.9,
                    100461
                  ],
                  [
                    21869.9,
                    100591
                  ],
                  [
                    21818.9,
                    100585
                  ],
                  [
                    21719.4,
                    100682
                  ],
                  [
                    21668.7,
                    100662
                  ],
                  [
                    21571.2,
                    100595
                  ],
                  [
                    21437.7,
                    100653
                  ],
                  [
                    21393,
                    100768
                  ],
                  [
                    21307,
                    100850
                  ]
                ],
                "id": 1861,
                "chat_link": "[&BEUHAAA=]"
              },
              "1863": {
                "name": "Shinota Shore",
                "level": 80,
                "coord": [
                  22484.6,
                  101273
                ],
                "bounds": [
                  [
                    21868.7,
                    101351
                  ],
                  [
                    21952.8,
                    101398
                  ],
                  [
                    22145.6,
                    101464
                  ],
                  [
                    22441.9,
                    101600
                  ],
                  [
                    22441.2,
                    101669
                  ],
                  [
                    22467.3,
                    101707
                  ],
                  [
                    22488,
                    101856
                  ],
                  [
                    22643.5,
                    101832
                  ],
                  [
                    22753,
                    101782
                  ],
                  [
                    22826.4,
                    101774
                  ],
                  [
                    23009.5,
                    101766
                  ],
                  [
                    22921.3,
                    101651
                  ],
                  [
                    22895,
                    101557
                  ],
                  [
                    22816.1,
                    101441
                  ],
                  [
                    22816.3,
                    101348
                  ],
                  [
                    22853.9,
                    101275
                  ],
                  [
                    22914.3,
                    101261
                  ],
                  [
                    22868.9,
                    101106
                  ],
                  [
                    22794.1,
                    101013
                  ],
                  [
                    22772.5,
                    100938
                  ],
                  [
                    22863.6,
                    100852
                  ],
                  [
                    22956,
                    100701
                  ],
                  [
                    22942.8,
                    100461
                  ],
                  [
                    21987.2,
                    100466
                  ],
                  [
                    21937.8,
                    100669
                  ],
                  [
                    21837.2,
                    100830
                  ],
                  [
                    21819.1,
                    100955
                  ],
                  [
                    21850.8,
                    101074
                  ],
                  [
                    21839.2,
                    101147
                  ],
                  [
                    21814.6,
                    101234
                  ],
                  [
                    21868.7,
                    101351
                  ]
                ],
                "id": 1863,
                "chat_link": "[&BEcHAAA=]"
              },
              "1864": {
                "name": "Haiju Plains",
                "level": 80,
                "coord": [
                  23328.4,
                  101059
                ],
                "bounds": [
                  [
                    22935.4,
                    100461
                  ],
                  [
                    22950.1,
                    100701
                  ],
                  [
                    22856.6,
                    100849
                  ],
                  [
                    22763.1,
                    100926
                  ],
                  [
                    22787.1,
                    101010
                  ],
                  [
                    22863.9,
                    101108
                  ],
                  [
                    22909.3,
                    101260
                  ],
                  [
                    22978.6,
                    101263
                  ],
                  [
                    23069.4,
                    101256
                  ],
                  [
                    23377.6,
                    101199
                  ],
                  [
                    23448.3,
                    101201
                  ],
                  [
                    23566.3,
                    101282
                  ],
                  [
                    23704.8,
                    101458
                  ],
                  [
                    23748.3,
                    101355
                  ],
                  [
                    23776.5,
                    101277
                  ],
                  [
                    23776.8,
                    101216
                  ],
                  [
                    23797.2,
                    101061
                  ],
                  [
                    23758.5,
                    100968
                  ],
                  [
                    23749.9,
                    100857
                  ],
                  [
                    23750.8,
                    100462
                  ],
                  [
                    22935.4,
                    100461
                  ]
                ],
                "id": 1864,
                "chat_link": "[&BEgHAAA=]"
              },
              "1872": {
                "name": "Zen Daijun",
                "level": 80,
                "coord": [
                  23506.5,
                  102219
                ],
                "bounds": [
                  [
                    23009.6,
                    101754
                  ],
                  [
                    23074.5,
                    101880
                  ],
                  [
                    23126.8,
                    102135
                  ],
                  [
                    23085.9,
                    102207
                  ],
                  [
                    23113.8,
                    102288
                  ],
                  [
                    23179.3,
                    102358
                  ],
                  [
                    23194.5,
                    102447
                  ],
                  [
                    23170.1,
                    102550
                  ],
                  [
                    23119.1,
                    102606
                  ],
                  [
                    23118,
                    102685
                  ],
                  [
                    23148.8,
                    102757
                  ],
                  [
                    23119.4,
                    102887
                  ],
                  [
                    23108.6,
                    103008
                  ],
                  [
                    23115,
                    103137
                  ],
                  [
                    23975.7,
                    103137
                  ],
                  [
                    23952.7,
                    102788
                  ],
                  [
                    23997.7,
                    102574
                  ],
                  [
                    24037.4,
                    102422
                  ],
                  [
                    24124.4,
                    102278
                  ],
                  [
                    24162.7,
                    102181
                  ],
                  [
                    24217.8,
                    102059
                  ],
                  [
                    24286.6,
                    101762
                  ],
                  [
                    24029.3,
                    101732
                  ],
                  [
                    23898.6,
                    101775
                  ],
                  [
                    23828.5,
                    101820
                  ],
                  [
                    23836.9,
                    101889
                  ],
                  [
                    23802.7,
                    101957
                  ],
                  [
                    23751.4,
                    102018
                  ],
                  [
                    23698.7,
                    102049
                  ],
                  [
                    23526.7,
                    102047
                  ],
                  [
                    23435.3,
                    102015
                  ],
                  [
                    23413.2,
                    101918
                  ],
                  [
                    23366.6,
                    101874
                  ],
                  [
                    23309.8,
                    101795
                  ],
                  [
                    23208.1,
                    101778
                  ],
                  [
                    23135.5,
                    101777
                  ],
                  [
                    23060.3,
                    101769
                  ],
                  [
                    23009.6,
                    101754
                  ]
                ],
                "id": 1872,
                "chat_link": "[&BFAHAAA=]"
              },
              "1874": {
                "name": "Shing Jea Monastery",
                "level": 80,
                "coord": [
                  21799.4,
                  102129
                ],
                "bounds": [
                  [
                    21226.1,
                    101841
                  ],
                  [
                    21224.4,
                    102024
                  ],
                  [
                    21213.4,
                    102159
                  ],
                  [
                    21237.4,
                    102264
                  ],
                  [
                    21244.7,
                    102374
                  ],
                  [
                    21356.9,
                    102352
                  ],
                  [
                    21444.8,
                    102368
                  ],
                  [
                    21518.9,
                    102382
                  ],
                  [
                    21582,
                    102372
                  ],
                  [
                    21664.2,
                    102368
                  ],
                  [
                    21721.9,
                    102365
                  ],
                  [
                    21784.4,
                    102355
                  ],
                  [
                    21844.1,
                    102334
                  ],
                  [
                    21918.3,
                    102343
                  ],
                  [
                    22000.3,
                    102357
                  ],
                  [
                    22095.8,
                    102362
                  ],
                  [
                    22328,
                    102417
                  ],
                  [
                    22273.1,
                    102310
                  ],
                  [
                    22339.9,
                    102275
                  ],
                  [
                    22437.7,
                    102216
                  ],
                  [
                    22456.4,
                    102058
                  ],
                  [
                    22519.3,
                    102014
                  ],
                  [
                    22492.8,
                    101837
                  ],
                  [
                    22142.5,
                    101778
                  ],
                  [
                    22003.3,
                    101774
                  ],
                  [
                    21886.5,
                    101809
                  ],
                  [
                    21711.6,
                    101694
                  ],
                  [
                    21561.1,
                    101646
                  ],
                  [
                    21436.9,
                    101678
                  ],
                  [
                    21314.7,
                    101731
                  ],
                  [
                    21226.1,
                    101841
                  ]
                ],
                "id": 1874,
                "chat_link": "[&BFIHAAA=]"
              },
              "1877": {
                "name": "Training Grounds",
                "level": 80,
                "coord": [
                  21988.3,
                  102594
                ],
                "bounds": [
                  [
                    21918.3,
                    102341
                  ],
                  [
                    21842.6,
                    102330
                  ],
                  [
                    21784.4,
                    102352
                  ],
                  [
                    21712.9,
                    102356
                  ],
                  [
                    21727.8,
                    102395
                  ],
                  [
                    21704.4,
                    102558
                  ],
                  [
                    21782.1,
                    102739
                  ],
                  [
                    21866.3,
                    102832
                  ],
                  [
                    21910.9,
                    102926
                  ],
                  [
                    21928.7,
                    102932
                  ],
                  [
                    22037.2,
                    102920
                  ],
                  [
                    22147.3,
                    102825
                  ],
                  [
                    22237.8,
                    102743
                  ],
                  [
                    22364.5,
                    102684
                  ],
                  [
                    22398.3,
                    102644
                  ],
                  [
                    22326.8,
                    102414
                  ],
                  [
                    22098.2,
                    102359
                  ],
                  [
                    22000.6,
                    102351
                  ],
                  [
                    21918.3,
                    102341
                  ]
                ],
                "id": 1877,
                "chat_link": "[&BFUHAAA=]"
              },
              "1878": {
                "name": "Monastery Bay",
                "level": 80,
                "coord": [
                  21581.4,
                  102724
                ],
                "bounds": [
                  [
                    21248,
                    102374
                  ],
                  [
                    21356.1,
                    102350
                  ],
                  [
                    21447.2,
                    102367
                  ],
                  [
                    21520.4,
                    102372
                  ],
                  [
                    21576.4,
                    102371
                  ],
                  [
                    21666.8,
                    102363
                  ],
                  [
                    21720.5,
                    102361
                  ],
                  [
                    21730,
                    102395
                  ],
                  [
                    21712,
                    102563
                  ],
                  [
                    21794.5,
                    102741
                  ],
                  [
                    21873.8,
                    102830
                  ],
                  [
                    21916.2,
                    102927
                  ],
                  [
                    21931.5,
                    102929
                  ],
                  [
                    22036,
                    102916
                  ],
                  [
                    22054.6,
                    103139
                  ],
                  [
                    21661.7,
                    103138
                  ],
                  [
                    21389.4,
                    103137
                  ],
                  [
                    21338.3,
                    103117
                  ],
                  [
                    21321.5,
                    103068
                  ],
                  [
                    21324.5,
                    102977
                  ],
                  [
                    21298.9,
                    102900
                  ],
                  [
                    21214,
                    102709
                  ],
                  [
                    21240.7,
                    102608
                  ],
                  [
                    21248,
                    102374
                  ]
                ],
                "id": 1878,
                "chat_link": "[&BFYHAAA=]"
              },
              "1897": {
                "name": "Seitung Harbor",
                "level": 80,
                "coord": [
                  22812.6,
                  102378
                ],
                "bounds": [
                  [
                    22486,
                    101849
                  ],
                  [
                    22511.3,
                    102010
                  ],
                  [
                    22444.7,
                    102050
                  ],
                  [
                    22428.8,
                    102211
                  ],
                  [
                    22338.1,
                    102266
                  ],
                  [
                    22256.6,
                    102311
                  ],
                  [
                    22310.5,
                    102426
                  ],
                  [
                    22378.4,
                    102644
                  ],
                  [
                    22444.3,
                    102715
                  ],
                  [
                    22585.1,
                    102863
                  ],
                  [
                    22588.1,
                    103139
                  ],
                  [
                    23124.2,
                    103136
                  ],
                  [
                    23113.4,
                    103003
                  ],
                  [
                    23123.5,
                    102891
                  ],
                  [
                    23154.2,
                    102756
                  ],
                  [
                    23121.6,
                    102684
                  ],
                  [
                    23126.2,
                    102609
                  ],
                  [
                    23173.4,
                    102551
                  ],
                  [
                    23200.3,
                    102447
                  ],
                  [
                    23185.5,
                    102358
                  ],
                  [
                    23122.1,
                    102288
                  ],
                  [
                    23091,
                    102210
                  ],
                  [
                    23131.1,
                    102140
                  ],
                  [
                    23081.3,
                    101887
                  ],
                  [
                    23014.3,
                    101756
                  ],
                  [
                    22825.7,
                    101776
                  ],
                  [
                    22752,
                    101780
                  ],
                  [
                    22640.9,
                    101827
                  ],
                  [
                    22486,
                    101849
                  ]
                ],
                "id": 1897,
                "chat_link": "[&BGkHAAA=]"
              },
              "1898": {
                "name": "Daigo Ward",
                "level": 80,
                "coord": [
                  23315.2,
                  101641
                ],
                "bounds": [
                  [
                    22980.9,
                    101260
                  ],
                  [
                    22915,
                    101258
                  ],
                  [
                    22851,
                    101269
                  ],
                  [
                    22816.4,
                    101347
                  ],
                  [
                    22812.9,
                    101442
                  ],
                  [
                    22894,
                    101557
                  ],
                  [
                    22916.2,
                    101651
                  ],
                  [
                    23003.3,
                    101765
                  ],
                  [
                    23064,
                    101778
                  ],
                  [
                    23135,
                    101774
                  ],
                  [
                    23206.7,
                    101782
                  ],
                  [
                    23303.4,
                    101813
                  ],
                  [
                    23360.8,
                    101878
                  ],
                  [
                    23406.3,
                    101920
                  ],
                  [
                    23433.6,
                    102018
                  ],
                  [
                    23527.7,
                    102053
                  ],
                  [
                    23700.3,
                    102052
                  ],
                  [
                    23753.4,
                    102014
                  ],
                  [
                    23807.9,
                    101958
                  ],
                  [
                    23841,
                    101885
                  ],
                  [
                    23830.5,
                    101825
                  ],
                  [
                    23788.4,
                    101639
                  ],
                  [
                    23696.8,
                    101444
                  ],
                  [
                    23569.8,
                    101278
                  ],
                  [
                    23450.7,
                    101199
                  ],
                  [
                    23371.5,
                    101195
                  ],
                  [
                    23071.8,
                    101252
                  ],
                  [
                    22980.9,
                    101260
                  ]
                ],
                "id": 1898,
                "chat_link": "[&BGoHAAA=]"
              },
              "1903": {
                "name": "Crystal Cave",
                "level": 80,
                "coord": [
                  22315,
                  102849
                ],
                "bounds": [
                  [
                    22025.1,
                    102914
                  ],
                  [
                    22143.3,
                    102819
                  ],
                  [
                    22224.2,
                    102738
                  ],
                  [
                    22363,
                    102679
                  ],
                  [
                    22395.3,
                    102645
                  ],
                  [
                    22447.1,
                    102706
                  ],
                  [
                    22592.9,
                    102858
                  ],
                  [
                    22597.2,
                    103137
                  ],
                  [
                    22046.9,
                    103139
                  ],
                  [
                    22025.1,
                    102914
                  ]
                ],
                "id": 1903,
                "chat_link": "[&BG8HAAA=]"
              },
              "1905": {
                "name": "North Peninsula",
                "level": 80,
                "coord": [
                  24604.2,
                  101120
                ],
                "bounds": [
                  [
                    24436.7,
                    100463
                  ],
                  [
                    24398.9,
                    100763
                  ],
                  [
                    24321.4,
                    100955
                  ],
                  [
                    24239.8,
                    101178
                  ],
                  [
                    24242.4,
                    101370
                  ],
                  [
                    24269.1,
                    101539
                  ],
                  [
                    24276.8,
                    101764
                  ],
                  [
                    24406.9,
                    101817
                  ],
                  [
                    24520,
                    101800
                  ],
                  [
                    24620.3,
                    101831
                  ],
                  [
                    24988.8,
                    101828
                  ],
                  [
                    24992,
                    100610
                  ],
                  [
                    25008.4,
                    100599
                  ],
                  [
                    25007.5,
                    100473
                  ],
                  [
                    24989.3,
                    100467
                  ],
                  [
                    24949,
                    100461
                  ],
                  [
                    24436.7,
                    100463
                  ]
                ],
                "id": 1905,
                "chat_link": "[&BHEHAAA=]"
              }
            },
            "adventures": [],
            "id": 1442,
            "mastery_points": [
              {
                "coord": [
                  24868,
                  102138
                ],
                "id": 572,
                "region": "Unknown"
              },
              {
                "coord": [
                  21604.5,
                  101866
                ],
                "id": 648,
                "region": "Unknown"
              },
              {
                "coord": [
                  22331,
                  102983
                ],
                "id": 652,
                "region": "Unknown"
              },
              {
                "coord": [
                  23317.5,
                  101962
                ],
                "id": 574,
                "region": "Unknown"
              },
              {
                "coord": [
                  23355.2,
                  102709
                ],
                "id": 649,
                "region": "Unknown"
              },
              {
                "coord": [
                  23217.5,
                  102930
                ],
                "id": 628,
                "region": "Unknown"
              },
              {
                "coord": [
                  24710,
                  102819
                ],
                "id": 554,
                "region": "Unknown"
              },
              {
                "coord": [
                  21770.5,
                  102744
                ],
                "id": 645,
                "region": "Unknown"
              },
              {
                "coord": [
                  23890.3,
                  103024
                ],
                "id": 659,
                "region": "Unknown"
              },
              {
                "coord": [
                  21583.2,
                  100914
                ],
                "id": 573,
                "region": "Unknown"
              },
              {
                "coord": [
                  22975.8,
                  101420
                ],
                "id": 613,
                "region": "Unknown"
              },
              {
                "coord": [
                  24128.9,
                  100556
                ],
                "id": 608,
                "region": "Unknown"
              },
              {
                "coord": [
                  24538.5,
                  101176
                ],
                "id": 606,
                "region": "Unknown"
              },
              {
                "coord": [
                  22610.7,
                  101539
                ],
                "id": 639,
                "region": "Unknown"
              }
            ]
          },
          "1444": {
            "name": "Isle of Reflection",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              22250,
              104696
            ],
            "map_rect": [
              [
                -21504,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                21319,
                103145
              ],
              [
                23239,
                105705
              ]
            ],
            "points_of_interest": {
              "3294": {
                "name": "Reflection Arena Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  22232,
                  105006
                ],
                "id": 3294,
                "chat_link": "[&BN4MAAA=]"
              },
              "3315": {
                "name": "Reflection Docks Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  21852.2,
                  104468
                ],
                "id": 3315,
                "chat_link": "[&BPMMAAA=]"
              },
              "3342": {
                "name": "Reflection Crystal Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  22018.7,
                  105151
                ],
                "id": 3342,
                "chat_link": "[&BA4NAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1854": {
                "level": 0,
                "coord": [
                  22374.8,
                  104740
                ],
                "bounds": [
                  [
                    23002.5,
                    104067
                  ],
                  [
                    23114.4,
                    104560
                  ],
                  [
                    23088.7,
                    105487
                  ],
                  [
                    22923.7,
                    105576
                  ],
                  [
                    21724.4,
                    105618
                  ],
                  [
                    21504.2,
                    105470
                  ],
                  [
                    21529.7,
                    104145
                  ],
                  [
                    21723.1,
                    103898
                  ],
                  [
                    22762.5,
                    103835
                  ],
                  [
                    23002.5,
                    104067
                  ]
                ],
                "id": 1854,
                "chat_link": "[&BD4HAAA=]"
              }
            },
            "id": 1444,
            "mastery_points": [],
            "adventures": []
          },
          "1445": {
            "name": "The Future in Jade: Nahpui Lab",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              27000,
              99400
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                25000,
                98100
              ],
              [
                28840,
                100660
              ]
            ],
            "points_of_interest": {
              "3258": {
                "name": "Nahpui Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  27772.2,
                  98280.6
                ],
                "id": 3258,
                "chat_link": "[&BLoMAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1851": {
                "name": "North Lab",
                "level": 80,
                "coord": [
                  27829,
                  98572.4
                ],
                "bounds": [
                  [
                    28084,
                    98164.6
                  ],
                  [
                    28086.4,
                    98325.9
                  ],
                  [
                    28020.3,
                    98327.5
                  ],
                  [
                    28015.2,
                    98729.2
                  ],
                  [
                    27786.4,
                    98725.1
                  ],
                  [
                    27784.5,
                    99069
                  ],
                  [
                    27433.8,
                    99064.9
                  ],
                  [
                    27421.3,
                    98173
                  ],
                  [
                    28084,
                    98164.6
                  ]
                ],
                "id": 1851,
                "chat_link": "[&BDsHAAA=]"
              },
              "1857": {
                "name": "Old Kaineng",
                "level": 80,
                "coord": [
                  28414.3,
                  98537.6
                ],
                "bounds": [
                  [
                    28081,
                    98165.6
                  ],
                  [
                    28194.5,
                    98163.8
                  ],
                  [
                    28195.3,
                    98182.9
                  ],
                  [
                    28388.3,
                    98182.3
                  ],
                  [
                    28414,
                    98163.3
                  ],
                  [
                    28519.9,
                    98168.9
                  ],
                  [
                    28541.9,
                    98189.9
                  ],
                  [
                    28748.4,
                    98195.1
                  ],
                  [
                    28747.8,
                    98261.4
                  ],
                  [
                    28756.5,
                    98274.7
                  ],
                  [
                    28756.7,
                    98326.1
                  ],
                  [
                    28747.2,
                    98337.3
                  ],
                  [
                    28744.9,
                    98510.4
                  ],
                  [
                    28641.3,
                    98512.4
                  ],
                  [
                    28637.3,
                    98985.8
                  ],
                  [
                    28725.8,
                    98983.4
                  ],
                  [
                    28728.2,
                    99166.9
                  ],
                  [
                    28703.7,
                    99223.9
                  ],
                  [
                    28203.9,
                    99215.4
                  ],
                  [
                    28202.3,
                    99061.4
                  ],
                  [
                    27781.4,
                    99067.2
                  ],
                  [
                    27783.4,
                    98723.3
                  ],
                  [
                    28012.2,
                    98727.4
                  ],
                  [
                    28017.2,
                    98325.8
                  ],
                  [
                    28083.4,
                    98324.1
                  ],
                  [
                    28081,
                    98165.6
                  ]
                ],
                "id": 1857,
                "chat_link": "[&BEEHAAA=]"
              }
            },
            "adventures": [],
            "id": 1445,
            "mastery_points": []
          },
          "1448": {
            "name": "The Cycle, Reborn: The Dead End Bar",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              43968,
              27136
            ],
            "map_rect": [
              [
                -21504,
                -21504
              ],
              [
                24576,
                21504
              ]
            ],
            "continent_rect": [
              [
                43008,
                26240
              ],
              [
                44928,
                28032
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1448,
            "mastery_points": []
          },
          "1449": {
            "name": "Aurene's Sanctuary",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              23150,
              101800
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                33792
              ]
            ],
            "continent_rect": [
              [
                21159,
                100457
              ],
              [
                24999,
                103145
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1853": {
                "name": "Eastern Wilds",
                "level": 80,
                "coord": [
                  24409.8,
                  102377
                ],
                "bounds": [
                  [
                    24283.8,
                    101769
                  ],
                  [
                    24211.6,
                    102047
                  ],
                  [
                    24152.9,
                    102179
                  ],
                  [
                    24116.7,
                    102269
                  ],
                  [
                    24027.8,
                    102411
                  ],
                  [
                    23990.4,
                    102573
                  ],
                  [
                    23945.8,
                    102784
                  ],
                  [
                    23966.9,
                    103136
                  ],
                  [
                    24933.7,
                    103135
                  ],
                  [
                    24987.8,
                    103132
                  ],
                  [
                    24989.3,
                    102962
                  ],
                  [
                    24989.9,
                    101825
                  ],
                  [
                    24624.4,
                    101823
                  ],
                  [
                    24518.2,
                    101794
                  ],
                  [
                    24408.2,
                    101821
                  ],
                  [
                    24283.8,
                    101769
                  ]
                ],
                "id": 1853,
                "chat_link": "[&BD0HAAA=]"
              },
              "1861": {
                "name": "Jaya Bluffs",
                "level": 80,
                "coord": [
                  21816.6,
                  101215
                ],
                "bounds": [
                  [
                    21307,
                    100850
                  ],
                  [
                    21324.4,
                    100947
                  ],
                  [
                    21348.6,
                    101112
                  ],
                  [
                    21374.1,
                    101197
                  ],
                  [
                    21415.8,
                    101339
                  ],
                  [
                    21475.2,
                    101401
                  ],
                  [
                    21571.7,
                    101530
                  ],
                  [
                    21627.7,
                    101606
                  ],
                  [
                    21563,
                    101652
                  ],
                  [
                    21712.8,
                    101702
                  ],
                  [
                    21886.1,
                    101817
                  ],
                  [
                    22002.6,
                    101779
                  ],
                  [
                    22147.1,
                    101785
                  ],
                  [
                    22386.5,
                    101850
                  ],
                  [
                    22495.1,
                    101854
                  ],
                  [
                    22471.8,
                    101702
                  ],
                  [
                    22446.1,
                    101668
                  ],
                  [
                    22447.1,
                    101596
                  ],
                  [
                    22147.8,
                    101463
                  ],
                  [
                    21958.1,
                    101398
                  ],
                  [
                    21873.3,
                    101352
                  ],
                  [
                    21817.1,
                    101238
                  ],
                  [
                    21847.8,
                    101149
                  ],
                  [
                    21855.3,
                    101076
                  ],
                  [
                    21824,
                    100954
                  ],
                  [
                    21840.6,
                    100836
                  ],
                  [
                    21941.8,
                    100674
                  ],
                  [
                    21992.9,
                    100461
                  ],
                  [
                    21869.9,
                    100591
                  ],
                  [
                    21818.9,
                    100585
                  ],
                  [
                    21719.4,
                    100682
                  ],
                  [
                    21668.7,
                    100662
                  ],
                  [
                    21571.2,
                    100595
                  ],
                  [
                    21437.7,
                    100653
                  ],
                  [
                    21393,
                    100768
                  ],
                  [
                    21307,
                    100850
                  ]
                ],
                "id": 1861,
                "chat_link": "[&BEUHAAA=]"
              },
              "1863": {
                "name": "Shinota Shore",
                "level": 80,
                "coord": [
                  22484.6,
                  101273
                ],
                "bounds": [
                  [
                    21868.7,
                    101351
                  ],
                  [
                    21952.8,
                    101398
                  ],
                  [
                    22145.6,
                    101464
                  ],
                  [
                    22441.9,
                    101600
                  ],
                  [
                    22441.2,
                    101669
                  ],
                  [
                    22467.3,
                    101707
                  ],
                  [
                    22488,
                    101856
                  ],
                  [
                    22643.5,
                    101832
                  ],
                  [
                    22753,
                    101782
                  ],
                  [
                    22826.4,
                    101774
                  ],
                  [
                    23009.5,
                    101766
                  ],
                  [
                    22921.3,
                    101651
                  ],
                  [
                    22895,
                    101557
                  ],
                  [
                    22816.1,
                    101441
                  ],
                  [
                    22816.3,
                    101348
                  ],
                  [
                    22853.9,
                    101275
                  ],
                  [
                    22914.3,
                    101261
                  ],
                  [
                    22868.9,
                    101106
                  ],
                  [
                    22794.1,
                    101013
                  ],
                  [
                    22772.5,
                    100938
                  ],
                  [
                    22863.6,
                    100852
                  ],
                  [
                    22956,
                    100701
                  ],
                  [
                    22942.8,
                    100461
                  ],
                  [
                    21987.2,
                    100466
                  ],
                  [
                    21937.8,
                    100669
                  ],
                  [
                    21837.2,
                    100830
                  ],
                  [
                    21819.1,
                    100955
                  ],
                  [
                    21850.8,
                    101074
                  ],
                  [
                    21839.2,
                    101147
                  ],
                  [
                    21814.6,
                    101234
                  ],
                  [
                    21868.7,
                    101351
                  ]
                ],
                "id": 1863,
                "chat_link": "[&BEcHAAA=]"
              },
              "1864": {
                "name": "Haiju Plains",
                "level": 80,
                "coord": [
                  23328.4,
                  101059
                ],
                "bounds": [
                  [
                    22935.4,
                    100461
                  ],
                  [
                    22950.1,
                    100701
                  ],
                  [
                    22856.6,
                    100849
                  ],
                  [
                    22763.1,
                    100926
                  ],
                  [
                    22787.1,
                    101010
                  ],
                  [
                    22863.9,
                    101108
                  ],
                  [
                    22909.3,
                    101260
                  ],
                  [
                    22978.6,
                    101263
                  ],
                  [
                    23069.4,
                    101256
                  ],
                  [
                    23377.6,
                    101199
                  ],
                  [
                    23448.3,
                    101201
                  ],
                  [
                    23566.3,
                    101282
                  ],
                  [
                    23704.8,
                    101458
                  ],
                  [
                    23748.3,
                    101355
                  ],
                  [
                    23776.5,
                    101277
                  ],
                  [
                    23776.8,
                    101216
                  ],
                  [
                    23797.2,
                    101061
                  ],
                  [
                    23758.5,
                    100968
                  ],
                  [
                    23749.9,
                    100857
                  ],
                  [
                    23750.8,
                    100462
                  ],
                  [
                    22935.4,
                    100461
                  ]
                ],
                "id": 1864,
                "chat_link": "[&BEgHAAA=]"
              },
              "1872": {
                "name": "Zen Daijun",
                "level": 80,
                "coord": [
                  23506.5,
                  102219
                ],
                "bounds": [
                  [
                    23009.6,
                    101754
                  ],
                  [
                    23074.5,
                    101880
                  ],
                  [
                    23126.8,
                    102135
                  ],
                  [
                    23085.9,
                    102207
                  ],
                  [
                    23113.8,
                    102288
                  ],
                  [
                    23179.3,
                    102358
                  ],
                  [
                    23194.5,
                    102447
                  ],
                  [
                    23170.1,
                    102550
                  ],
                  [
                    23119.1,
                    102606
                  ],
                  [
                    23118,
                    102685
                  ],
                  [
                    23148.8,
                    102757
                  ],
                  [
                    23119.4,
                    102887
                  ],
                  [
                    23108.6,
                    103008
                  ],
                  [
                    23115,
                    103137
                  ],
                  [
                    23975.7,
                    103137
                  ],
                  [
                    23952.7,
                    102788
                  ],
                  [
                    23997.7,
                    102574
                  ],
                  [
                    24037.4,
                    102422
                  ],
                  [
                    24124.4,
                    102278
                  ],
                  [
                    24162.7,
                    102181
                  ],
                  [
                    24217.8,
                    102059
                  ],
                  [
                    24286.6,
                    101762
                  ],
                  [
                    24029.3,
                    101732
                  ],
                  [
                    23898.6,
                    101775
                  ],
                  [
                    23828.5,
                    101820
                  ],
                  [
                    23836.9,
                    101889
                  ],
                  [
                    23802.7,
                    101957
                  ],
                  [
                    23751.4,
                    102018
                  ],
                  [
                    23698.7,
                    102049
                  ],
                  [
                    23526.7,
                    102047
                  ],
                  [
                    23435.3,
                    102015
                  ],
                  [
                    23413.2,
                    101918
                  ],
                  [
                    23366.6,
                    101874
                  ],
                  [
                    23309.8,
                    101795
                  ],
                  [
                    23208.1,
                    101778
                  ],
                  [
                    23135.5,
                    101777
                  ],
                  [
                    23060.3,
                    101769
                  ],
                  [
                    23009.6,
                    101754
                  ]
                ],
                "id": 1872,
                "chat_link": "[&BFAHAAA=]"
              },
              "1874": {
                "name": "Shing Jea Monastery",
                "level": 80,
                "coord": [
                  21799.4,
                  102129
                ],
                "bounds": [
                  [
                    21226.1,
                    101841
                  ],
                  [
                    21224.4,
                    102024
                  ],
                  [
                    21213.4,
                    102159
                  ],
                  [
                    21237.4,
                    102264
                  ],
                  [
                    21244.7,
                    102374
                  ],
                  [
                    21356.9,
                    102352
                  ],
                  [
                    21444.8,
                    102368
                  ],
                  [
                    21518.9,
                    102382
                  ],
                  [
                    21582,
                    102372
                  ],
                  [
                    21664.2,
                    102368
                  ],
                  [
                    21721.9,
                    102365
                  ],
                  [
                    21784.4,
                    102355
                  ],
                  [
                    21844.1,
                    102334
                  ],
                  [
                    21918.3,
                    102343
                  ],
                  [
                    22000.3,
                    102357
                  ],
                  [
                    22095.8,
                    102362
                  ],
                  [
                    22328,
                    102417
                  ],
                  [
                    22273.1,
                    102310
                  ],
                  [
                    22339.9,
                    102275
                  ],
                  [
                    22437.7,
                    102216
                  ],
                  [
                    22456.4,
                    102058
                  ],
                  [
                    22519.3,
                    102014
                  ],
                  [
                    22492.8,
                    101837
                  ],
                  [
                    22142.5,
                    101778
                  ],
                  [
                    22003.3,
                    101774
                  ],
                  [
                    21886.5,
                    101809
                  ],
                  [
                    21711.6,
                    101694
                  ],
                  [
                    21561.1,
                    101646
                  ],
                  [
                    21436.9,
                    101678
                  ],
                  [
                    21314.7,
                    101731
                  ],
                  [
                    21226.1,
                    101841
                  ]
                ],
                "id": 1874,
                "chat_link": "[&BFIHAAA=]"
              },
              "1877": {
                "name": "Training Grounds",
                "level": 80,
                "coord": [
                  21988.3,
                  102594
                ],
                "bounds": [
                  [
                    21918.3,
                    102341
                  ],
                  [
                    21842.6,
                    102330
                  ],
                  [
                    21784.4,
                    102352
                  ],
                  [
                    21712.9,
                    102356
                  ],
                  [
                    21727.8,
                    102395
                  ],
                  [
                    21704.4,
                    102558
                  ],
                  [
                    21782.1,
                    102739
                  ],
                  [
                    21866.3,
                    102832
                  ],
                  [
                    21910.9,
                    102926
                  ],
                  [
                    21928.7,
                    102932
                  ],
                  [
                    22037.2,
                    102920
                  ],
                  [
                    22147.3,
                    102825
                  ],
                  [
                    22237.8,
                    102743
                  ],
                  [
                    22364.5,
                    102684
                  ],
                  [
                    22398.3,
                    102644
                  ],
                  [
                    22326.8,
                    102414
                  ],
                  [
                    22098.2,
                    102359
                  ],
                  [
                    22000.6,
                    102351
                  ],
                  [
                    21918.3,
                    102341
                  ]
                ],
                "id": 1877,
                "chat_link": "[&BFUHAAA=]"
              },
              "1878": {
                "name": "Monastery Bay",
                "level": 80,
                "coord": [
                  21581.4,
                  102724
                ],
                "bounds": [
                  [
                    21248,
                    102374
                  ],
                  [
                    21356.1,
                    102350
                  ],
                  [
                    21447.2,
                    102367
                  ],
                  [
                    21520.4,
                    102372
                  ],
                  [
                    21576.4,
                    102371
                  ],
                  [
                    21666.8,
                    102363
                  ],
                  [
                    21720.5,
                    102361
                  ],
                  [
                    21730,
                    102395
                  ],
                  [
                    21712,
                    102563
                  ],
                  [
                    21794.5,
                    102741
                  ],
                  [
                    21873.8,
                    102830
                  ],
                  [
                    21916.2,
                    102927
                  ],
                  [
                    21931.5,
                    102929
                  ],
                  [
                    22036,
                    102916
                  ],
                  [
                    22054.6,
                    103139
                  ],
                  [
                    21661.7,
                    103138
                  ],
                  [
                    21389.4,
                    103137
                  ],
                  [
                    21338.3,
                    103117
                  ],
                  [
                    21321.5,
                    103068
                  ],
                  [
                    21324.5,
                    102977
                  ],
                  [
                    21298.9,
                    102900
                  ],
                  [
                    21214,
                    102709
                  ],
                  [
                    21240.7,
                    102608
                  ],
                  [
                    21248,
                    102374
                  ]
                ],
                "id": 1878,
                "chat_link": "[&BFYHAAA=]"
              },
              "1897": {
                "name": "Seitung Harbor",
                "level": 80,
                "coord": [
                  22812.6,
                  102378
                ],
                "bounds": [
                  [
                    22486,
                    101849
                  ],
                  [
                    22511.3,
                    102010
                  ],
                  [
                    22444.7,
                    102050
                  ],
                  [
                    22428.8,
                    102211
                  ],
                  [
                    22338.1,
                    102266
                  ],
                  [
                    22256.6,
                    102311
                  ],
                  [
                    22310.5,
                    102426
                  ],
                  [
                    22378.4,
                    102644
                  ],
                  [
                    22444.3,
                    102715
                  ],
                  [
                    22585.1,
                    102863
                  ],
                  [
                    22588.1,
                    103139
                  ],
                  [
                    23124.2,
                    103136
                  ],
                  [
                    23113.4,
                    103003
                  ],
                  [
                    23123.5,
                    102891
                  ],
                  [
                    23154.2,
                    102756
                  ],
                  [
                    23121.6,
                    102684
                  ],
                  [
                    23126.2,
                    102609
                  ],
                  [
                    23173.4,
                    102551
                  ],
                  [
                    23200.3,
                    102447
                  ],
                  [
                    23185.5,
                    102358
                  ],
                  [
                    23122.1,
                    102288
                  ],
                  [
                    23091,
                    102210
                  ],
                  [
                    23131.1,
                    102140
                  ],
                  [
                    23081.3,
                    101887
                  ],
                  [
                    23014.3,
                    101756
                  ],
                  [
                    22825.7,
                    101776
                  ],
                  [
                    22752,
                    101780
                  ],
                  [
                    22640.9,
                    101827
                  ],
                  [
                    22486,
                    101849
                  ]
                ],
                "id": 1897,
                "chat_link": "[&BGkHAAA=]"
              },
              "1898": {
                "name": "Daigo Ward",
                "level": 80,
                "coord": [
                  23315.2,
                  101641
                ],
                "bounds": [
                  [
                    22980.9,
                    101260
                  ],
                  [
                    22915,
                    101258
                  ],
                  [
                    22851,
                    101269
                  ],
                  [
                    22816.4,
                    101347
                  ],
                  [
                    22812.9,
                    101442
                  ],
                  [
                    22894,
                    101557
                  ],
                  [
                    22916.2,
                    101651
                  ],
                  [
                    23003.3,
                    101765
                  ],
                  [
                    23064,
                    101778
                  ],
                  [
                    23135,
                    101774
                  ],
                  [
                    23206.7,
                    101782
                  ],
                  [
                    23303.4,
                    101813
                  ],
                  [
                    23360.8,
                    101878
                  ],
                  [
                    23406.3,
                    101920
                  ],
                  [
                    23433.6,
                    102018
                  ],
                  [
                    23527.7,
                    102053
                  ],
                  [
                    23700.3,
                    102052
                  ],
                  [
                    23753.4,
                    102014
                  ],
                  [
                    23807.9,
                    101958
                  ],
                  [
                    23841,
                    101885
                  ],
                  [
                    23830.5,
                    101825
                  ],
                  [
                    23788.4,
                    101639
                  ],
                  [
                    23696.8,
                    101444
                  ],
                  [
                    23569.8,
                    101278
                  ],
                  [
                    23450.7,
                    101199
                  ],
                  [
                    23371.5,
                    101195
                  ],
                  [
                    23071.8,
                    101252
                  ],
                  [
                    22980.9,
                    101260
                  ]
                ],
                "id": 1898,
                "chat_link": "[&BGoHAAA=]"
              },
              "1903": {
                "name": "Crystal Cave",
                "level": 80,
                "coord": [
                  22315,
                  102849
                ],
                "bounds": [
                  [
                    22025.1,
                    102914
                  ],
                  [
                    22143.3,
                    102819
                  ],
                  [
                    22224.2,
                    102738
                  ],
                  [
                    22363,
                    102679
                  ],
                  [
                    22395.3,
                    102645
                  ],
                  [
                    22447.1,
                    102706
                  ],
                  [
                    22592.9,
                    102858
                  ],
                  [
                    22597.2,
                    103137
                  ],
                  [
                    22046.9,
                    103139
                  ],
                  [
                    22025.1,
                    102914
                  ]
                ],
                "id": 1903,
                "chat_link": "[&BG8HAAA=]"
              },
              "1905": {
                "name": "North Peninsula",
                "level": 80,
                "coord": [
                  24604.2,
                  101120
                ],
                "bounds": [
                  [
                    24436.7,
                    100463
                  ],
                  [
                    24398.9,
                    100763
                  ],
                  [
                    24321.4,
                    100955
                  ],
                  [
                    24239.8,
                    101178
                  ],
                  [
                    24242.4,
                    101370
                  ],
                  [
                    24269.1,
                    101539
                  ],
                  [
                    24276.8,
                    101764
                  ],
                  [
                    24406.9,
                    101817
                  ],
                  [
                    24520,
                    101800
                  ],
                  [
                    24620.3,
                    101831
                  ],
                  [
                    24988.8,
                    101828
                  ],
                  [
                    24992,
                    100610
                  ],
                  [
                    25008.4,
                    100599
                  ],
                  [
                    25007.5,
                    100473
                  ],
                  [
                    24989.3,
                    100467
                  ],
                  [
                    24949,
                    100461
                  ],
                  [
                    24436.7,
                    100463
                  ]
                ],
                "id": 1905,
                "chat_link": "[&BHEHAAA=]"
              }
            },
            "adventures": [],
            "id": 1449,
            "mastery_points": []
          },
          "1452": {
            "name": "The Echovald Wilds",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              31100,
              102360
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                29185,
                100890
              ],
              [
                33025,
                103450
              ]
            ],
            "points_of_interest": {
              "3211": {
                "name": "Junkyard Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  30896.1,
                  101005
                ],
                "id": 3211,
                "chat_link": "[&BIsMAAA=]"
              },
              "3213": {
                "name": "Saprophyte's Pond",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  30437.7,
                  102350
                ],
                "id": 3213,
                "chat_link": "[&BI0MAAA=]"
              },
              "3219": {
                "name": "Yarrow's Perch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  30237.6,
                  103044
                ],
                "id": 3219,
                "chat_link": "[&BJMMAAA=]"
              },
              "3231": {
                "name": "Vasburg Armory",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  32284.2,
                  102022
                ],
                "id": 3231,
                "chat_link": "[&BJ8MAAA=]"
              },
              "3236": {
                "name": "Karstadt Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  32382.4,
                  102333
                ],
                "id": 3236,
                "chat_link": "[&BKQMAAA=]"
              },
              "3243": {
                "name": "Goa Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  31581.6,
                  102010
                ],
                "id": 3243,
                "chat_link": "[&BKsMAAA=]"
              },
              "3249": {
                "name": "Tangled Altar",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  31546.4,
                  101597
                ],
                "id": 3249,
                "chat_link": "[&BLEMAAA=]"
              },
              "3251": {
                "name": "Ingenuity Square",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  31225.2,
                  101122
                ],
                "id": 3251,
                "chat_link": "[&BLMMAAA=]"
              },
              "3259": {
                "name": "Mori Plaza",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  32822.8,
                  103177
                ],
                "id": 3259,
                "chat_link": "[&BLsMAAA=]"
              },
              "3271": {
                "name": "Mori Village Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  32842,
                  103030
                ],
                "id": 3271,
                "chat_link": "[&BMcMAAA=]"
              },
              "3274": {
                "name": "Waypoint zu Heltzer",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  30020.8,
                  102042
                ],
                "id": 3274,
                "chat_link": "[&BMoMAAA=]"
              },
              "3276": {
                "name": "Kropa Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  30311.7,
                  102714
                ],
                "id": 3276,
                "chat_link": "[&BMwMAAA=]"
              },
              "3277": {
                "name": "Court of Song",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  31289.7,
                  102979
                ],
                "id": 3277,
                "chat_link": "[&BM0MAAA=]"
              },
              "3284": {
                "name": "Qinkai Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  32675.6,
                  101324
                ],
                "id": 3284,
                "chat_link": "[&BNQMAAA=]"
              },
              "3285": {
                "name": "Aspenwood Sublevel B1",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  31720.9,
                  101874
                ],
                "id": 3285,
                "chat_link": "[&BNUMAAA=]"
              },
              "3286": {
                "name": "Dump Site 3",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  30935.5,
                  102169
                ],
                "id": 3286,
                "chat_link": "[&BNYMAAA=]"
              },
              "3292": {
                "name": "Lutgardis Ruins",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  31900.6,
                  103240
                ],
                "id": 3292,
                "chat_link": "[&BNwMAAA=]"
              },
              "3293": {
                "name": "Hermit's Dock",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  32174.1,
                  102927
                ],
                "id": 3293,
                "chat_link": "[&BN0MAAA=]"
              },
              "3297": {
                "name": "Forever Tree",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  30986.1,
                  103281
                ],
                "id": 3297,
                "chat_link": "[&BOEMAAA=]"
              },
              "3300": {
                "name": "Qinkaishi Falls",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  32804.5,
                  100971
                ],
                "id": 3300,
                "chat_link": "[&BOQMAAA=]"
              },
              "3306": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  32141.4,
                  102950
                ],
                "id": 3306,
                "chat_link": "[&BOoMAAA=]"
              },
              "3309": {
                "name": "Altrumm Mines",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29329.4,
                  101914
                ],
                "id": 3309,
                "chat_link": "[&BO0MAAA=]"
              },
              "3312": {
                "name": "Ancient Archives",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  31598.8,
                  102545
                ],
                "id": 3312,
                "chat_link": "[&BPAMAAA=]"
              },
              "3321": {
                "name": "Jade Gate Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  32767.6,
                  102107
                ],
                "id": 3321,
                "chat_link": "[&BPkMAAA=]"
              },
              "3322": {
                "name": "Wrightstone Chantry",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  30646,
                  101724
                ],
                "id": 3322,
                "chat_link": "[&BPoMAAA=]"
              },
              "3326": {
                "name": "Skygazer Cathedral",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29734.5,
                  102357
                ],
                "id": 3326,
                "chat_link": "[&BP4MAAA=]"
              },
              "3328": {
                "name": "Dump Site 2",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  31194.5,
                  102121
                ],
                "id": 3328,
                "chat_link": "[&BAANAAA=]"
              },
              "3330": {
                "name": "Aoi's Perch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  32273.4,
                  101313
                ],
                "id": 3330,
                "chat_link": "[&BAINAAA=]"
              },
              "3331": {
                "name": "Xunlai Jade Junkyard Outpost E-1",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  30800.1,
                  101955
                ],
                "id": 3331,
                "chat_link": "[&BAMNAAA=]"
              },
              "3332": {
                "name": "Qinkai Stream",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  32811.5,
                  101960
                ],
                "id": 3332,
                "chat_link": "[&BAQNAAA=]"
              },
              "3334": {
                "name": "Arianna's Perch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  31216.2,
                  102610
                ],
                "id": 3334,
                "chat_link": "[&BAYNAAA=]"
              },
              "3335": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  32838,
                  101561
                ],
                "id": 3335,
                "chat_link": "[&BAcNAAA=]"
              },
              "3337": {
                "name": "Caretaker's Camp",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  30165.2,
                  101178
                ],
                "id": 3337,
                "chat_link": "[&BAkNAAA=]"
              },
              "3338": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  30377,
                  101113
                ],
                "id": 3338,
                "chat_link": "[&BAoNAAA=]"
              },
              "3343": {
                "name": "Dreslav's Garden",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  31607.9,
                  100978
                ],
                "id": 3343,
                "chat_link": "[&BA8NAAA=]"
              },
              "3349": {
                "name": "Dump Site 1",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  31014.4,
                  101958
                ],
                "id": 3349,
                "chat_link": "[&BBUNAAA=]"
              },
              "3368": {
                "name": "Speaker's Sanctum",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29460,
                  103010
                ],
                "id": 3368,
                "chat_link": "[&BCgNAAA=]"
              },
              "3369": {
                "name": "Teleri Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  31774.8,
                  102666
                ],
                "id": 3369,
                "chat_link": "[&BCkNAAA=]"
              },
              "3371": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  31220.8,
                  101086
                ],
                "id": 3371,
                "chat_link": "[&BCsNAAA=]"
              },
              "3374": {
                "name": "Saint Anjeka's Shrine",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  30188.6,
                  103318
                ],
                "id": 3374,
                "chat_link": "[&BC4NAAA=]"
              },
              "3375": {
                "name": "Kropa Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  30345.3,
                  102683
                ],
                "id": 3375,
                "chat_link": "[&BC8NAAA=]"
              },
              "3385": {
                "name": "Aspenwood Research Facility",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  31845,
                  101754
                ],
                "id": 3385,
                "chat_link": "[&BDkNAAA=]"
              },
              "3392": {
                "name": "Temple of the Dredge",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  30523.2,
                  102867
                ],
                "id": 3392,
                "chat_link": "[&BEANAAA=]"
              },
              "3393": {
                "name": "Elder's Roost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  32516.4,
                  103181
                ],
                "id": 3393,
                "chat_link": "[&BEENAAA=]"
              },
              "3395": {
                "type": "vista",
                "floor": 1,
                "coord": [
                  29546,
                  103081
                ],
                "id": 3395,
                "chat_link": "[&BEMNAAA=]"
              },
              "3402": {
                "name": "Cylow Outpost",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  30759.9,
                  102380
                ],
                "id": 3402,
                "chat_link": "[&BEoNAAA=]"
              },
              "3403": {
                "name": "Kage's Perch",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  31166.4,
                  101368
                ],
                "id": 3403,
                "chat_link": "[&BEsNAAA=]"
              },
              "3404": {
                "name": "Memorial zu Heltzer",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  30462.9,
                  101024
                ],
                "id": 3404,
                "chat_link": "[&BEwNAAA=]"
              },
              "3411": {
                "name": "Chamber of the Spirits",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29452.2,
                  103200
                ],
                "id": 3411,
                "chat_link": "[&BFMNAAA=]"
              },
              "3415": {
                "name": "Mi-Shen's Lab",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  31345.4,
                  101059
                ],
                "id": 3415,
                "chat_link": "[&BFcNAAA=]"
              },
              "3417": {
                "name": "Valdhertz Crypts",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  32989.1,
                  102478
                ],
                "id": 3417,
                "chat_link": "[&BFkNAAA=]"
              },
              "3421": {
                "name": "Qinkai Village",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  32830.9,
                  101336
                ],
                "id": 3421,
                "chat_link": "[&BF0NAAA=]"
              },
              "3423": {
                "name": "House zu Heltzer",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  30065.4,
                  102004
                ],
                "id": 3423,
                "chat_link": "[&BF8NAAA=]"
              },
              "3431": {
                "name": "Erys Oasis",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  29824.2,
                  103266
                ],
                "id": 3431,
                "chat_link": "[&BGcNAAA=]"
              },
              "3432": {
                "name": "Aetherblade Hideout",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  30655,
                  102130
                ],
                "id": 3432,
                "chat_link": "[&BGgNAAA=]"
              },
              "3433": {
                "name": "Secret Cavern",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  31810.5,
                  102238
                ],
                "id": 3433,
                "chat_link": "[&BGkNAAA=]"
              }
            },
            "tasks": {
              "443": {
                "objective": "Infiltrate and sabotage operations in the Jade Brotherhood headquarters.",
                "level": 80,
                "coord": [
                  31174.2,
                  101304
                ],
                "bounds": [
                  [
                    31134.2,
                    101461
                  ],
                  [
                    31252,
                    101482
                  ],
                  [
                    31486.2,
                    101312
                  ],
                  [
                    31529.8,
                    101101
                  ],
                  [
                    31382.3,
                    100955
                  ],
                  [
                    31226.8,
                    100873
                  ],
                  [
                    31063.8,
                    100959
                  ],
                  [
                    30921.7,
                    101285
                  ],
                  [
                    31134.2,
                    101461
                  ]
                ],
                "id": 443,
                "chat_link": "[&BLsBAAA=]"
              },
              "444": {
                "objective": "Help out around Mori Village to gain the trust of the tengu who live there.",
                "level": 80,
                "coord": [
                  32752,
                  103075
                ],
                "bounds": [
                  [
                    33020.6,
                    103339
                  ],
                  [
                    32995.4,
                    102704
                  ],
                  [
                    32766.6,
                    102681
                  ],
                  [
                    32480.6,
                    102829
                  ],
                  [
                    32448.3,
                    103335
                  ],
                  [
                    32818.2,
                    103397
                  ],
                  [
                    33020.6,
                    103339
                  ]
                ],
                "id": 444,
                "chat_link": "[&BLwBAAA=]"
              },
              "445": {
                "objective": "Disrupt the Speakers' operations in their headquarters.",
                "level": 80,
                "coord": [
                  29673.1,
                  102889
                ],
                "bounds": [
                  [
                    29730.8,
                    102715
                  ],
                  [
                    29911,
                    102916
                  ],
                  [
                    29883.4,
                    103149
                  ],
                  [
                    29737,
                    103302
                  ],
                  [
                    29474,
                    103375
                  ],
                  [
                    29324.8,
                    103208
                  ],
                  [
                    29302.7,
                    102908
                  ],
                  [
                    29380.4,
                    102816
                  ],
                  [
                    29532.4,
                    102765
                  ],
                  [
                    29730.8,
                    102715
                  ]
                ],
                "id": 445,
                "chat_link": "[&BL0BAAA=]"
              }
            },
            "skill_challenges": [
              {
                "coord": [
                  31342.4,
                  103307
                ]
              },
              {
                "coord": [
                  29986.6,
                  102130
                ]
              },
              {
                "coord": [
                  29662.5,
                  102964
                ]
              },
              {
                "coord": [
                  30533,
                  101068
                ]
              },
              {
                "coord": [
                  32802.9,
                  103255
                ]
              },
              {
                "coord": [
                  30943.8,
                  102259
                ]
              }
            ],
            "sectors": {
              "1858": {
                "name": "Brotherhood Woodlands",
                "level": 80,
                "coord": [
                  31526.2,
                  101105
                ],
                "bounds": [
                  [
                    30642.8,
                    101007
                  ],
                  [
                    30647.6,
                    101566
                  ],
                  [
                    31655.8,
                    101500
                  ],
                  [
                    31770.9,
                    101386
                  ],
                  [
                    32139.1,
                    101232
                  ],
                  [
                    32139.1,
                    100992
                  ],
                  [
                    32062.5,
                    101016
                  ],
                  [
                    31991.4,
                    101041
                  ],
                  [
                    31915,
                    101036
                  ],
                  [
                    31827,
                    101040
                  ],
                  [
                    31746.2,
                    101005
                  ],
                  [
                    31669,
                    100983
                  ],
                  [
                    31430.8,
                    100990
                  ],
                  [
                    31315.8,
                    100987
                  ],
                  [
                    31167.4,
                    100984
                  ],
                  [
                    31009.8,
                    101016
                  ],
                  [
                    30815.5,
                    101008
                  ],
                  [
                    30642.8,
                    101007
                  ]
                ],
                "id": 1858,
                "chat_link": "[&BEIHAAA=]"
              },
              "1868": {
                "name": "Qinkaishi Basin",
                "level": 80,
                "coord": [
                  32684.8,
                  101302
                ],
                "bounds": [
                  [
                    32386,
                    101233
                  ],
                  [
                    32139.1,
                    101232
                  ],
                  [
                    32139.1,
                    100992
                  ],
                  [
                    32308.9,
                    100977
                  ],
                  [
                    32486.1,
                    100981
                  ],
                  [
                    32798.2,
                    100983
                  ],
                  [
                    32871.6,
                    100994
                  ],
                  [
                    32924.3,
                    101028
                  ],
                  [
                    32943,
                    101091
                  ],
                  [
                    32953.5,
                    101245
                  ],
                  [
                    32960,
                    101529
                  ],
                  [
                    32951,
                    101634
                  ],
                  [
                    32955.7,
                    101730
                  ],
                  [
                    32936,
                    101839
                  ],
                  [
                    32601.8,
                    101840
                  ],
                  [
                    32602.3,
                    101505
                  ],
                  [
                    32386,
                    101233
                  ]
                ],
                "id": 1868,
                "chat_link": "[&BEwHAAA=]"
              },
              "1870": {
                "name": "Xunlai Jade Junkyard",
                "level": 80,
                "coord": [
                  31158.4,
                  101979
                ],
                "bounds": [
                  [
                    30855.5,
                    102333
                  ],
                  [
                    30587,
                    102075
                  ],
                  [
                    30647.6,
                    101566
                  ],
                  [
                    31655.8,
                    101500
                  ],
                  [
                    31689.9,
                    102069
                  ],
                  [
                    31514.5,
                    102333
                  ],
                  [
                    30855.5,
                    102333
                  ]
                ],
                "id": 1870,
                "chat_link": "[&BE4HAAA=]"
              },
              "1873": {
                "name": "Lake Lutgardis",
                "level": 80,
                "coord": [
                  31898.7,
                  103255
                ],
                "bounds": [
                  [
                    32650.7,
                    102757
                  ],
                  [
                    32645,
                    103246
                  ],
                  [
                    32533.5,
                    103293
                  ],
                  [
                    32449.5,
                    103337
                  ],
                  [
                    32383,
                    103336
                  ],
                  [
                    32269.2,
                    103349
                  ],
                  [
                    32164.5,
                    103371
                  ],
                  [
                    31983.3,
                    103377
                  ],
                  [
                    31775.2,
                    103363
                  ],
                  [
                    31631.6,
                    103333
                  ],
                  [
                    31536.5,
                    103332
                  ],
                  [
                    31485,
                    103335
                  ],
                  [
                    31383.3,
                    103375
                  ],
                  [
                    31340,
                    103389
                  ],
                  [
                    31217.9,
                    103387
                  ],
                  [
                    31196.5,
                    103219
                  ],
                  [
                    31514.5,
                    103036
                  ],
                  [
                    32017.7,
                    102755
                  ],
                  [
                    32650.7,
                    102757
                  ]
                ],
                "id": 1873,
                "chat_link": "[&BFEHAAA=]"
              },
              "1880": {
                "name": "Ferndale",
                "level": 80,
                "coord": [
                  30972.6,
                  103140
                ],
                "bounds": [
                  [
                    30855.5,
                    102333
                  ],
                  [
                    30250.1,
                    102940
                  ],
                  [
                    30604,
                    103325
                  ],
                  [
                    30679.5,
                    103342
                  ],
                  [
                    30786.3,
                    103384
                  ],
                  [
                    30915.8,
                    103389
                  ],
                  [
                    30982.6,
                    103374
                  ],
                  [
                    31034.7,
                    103371
                  ],
                  [
                    31092.5,
                    103386
                  ],
                  [
                    31217.9,
                    103387
                  ],
                  [
                    31196.5,
                    103219
                  ],
                  [
                    31514.5,
                    103036
                  ],
                  [
                    31514.5,
                    102333
                  ],
                  [
                    30855.5,
                    102333
                  ]
                ],
                "id": 1880,
                "chat_link": "[&BFgHAAA=]"
              },
              "1888": {
                "name": "Saint's Vale",
                "level": 80,
                "coord": [
                  29867,
                  102452
                ],
                "bounds": [
                  [
                    29804.4,
                    102650
                  ],
                  [
                    30250.1,
                    102940
                  ],
                  [
                    30855.5,
                    102333
                  ],
                  [
                    30587,
                    102075
                  ],
                  [
                    30102.1,
                    102249
                  ],
                  [
                    29254.7,
                    102234
                  ],
                  [
                    29295.8,
                    102409
                  ],
                  [
                    29331.5,
                    102533
                  ],
                  [
                    29321.5,
                    102649
                  ],
                  [
                    29804.4,
                    102650
                  ]
                ],
                "id": 1888,
                "chat_link": "[&BGAHAAA=]"
              },
              "1896": {
                "name": "Quarry Forelands",
                "level": 80,
                "coord": [
                  32862.2,
                  102294
                ],
                "bounds": [
                  [
                    32650.7,
                    102757
                  ],
                  [
                    32305.9,
                    102069
                  ],
                  [
                    32601.8,
                    101840
                  ],
                  [
                    32936,
                    101839
                  ],
                  [
                    32943.6,
                    101958
                  ],
                  [
                    32942.8,
                    102224
                  ],
                  [
                    32953.3,
                    102289
                  ],
                  [
                    33003.4,
                    102370
                  ],
                  [
                    33016.8,
                    102432
                  ],
                  [
                    33016,
                    102481
                  ],
                  [
                    33008.7,
                    102548
                  ],
                  [
                    32968,
                    102725
                  ],
                  [
                    32650.7,
                    102757
                  ]
                ],
                "id": 1896,
                "chat_link": "[&BGgHAAA=]"
              },
              "1901": {
                "name": "Aspenwood Gulch",
                "level": 80,
                "coord": [
                  32143.9,
                  101604
                ],
                "bounds": [
                  [
                    32386,
                    101233
                  ],
                  [
                    32139.1,
                    101232
                  ],
                  [
                    31770.9,
                    101386
                  ],
                  [
                    31655.8,
                    101500
                  ],
                  [
                    31689.9,
                    102069
                  ],
                  [
                    32305.9,
                    102069
                  ],
                  [
                    32601.8,
                    101840
                  ],
                  [
                    32602.3,
                    101505
                  ],
                  [
                    32386,
                    101233
                  ]
                ],
                "id": 1901,
                "chat_link": "[&BG0HAAA=]"
              },
              "1902": {
                "name": "Warden's Folly",
                "level": 80,
                "coord": [
                  29802.4,
                  103178
                ],
                "bounds": [
                  [
                    29804.4,
                    102650
                  ],
                  [
                    30250.1,
                    102940
                  ],
                  [
                    30604,
                    103325
                  ],
                  [
                    30400.9,
                    103366
                  ],
                  [
                    30280.4,
                    103398
                  ],
                  [
                    30144.7,
                    103397
                  ],
                  [
                    29893.7,
                    103330
                  ],
                  [
                    29787.6,
                    103328
                  ],
                  [
                    29674.5,
                    103354
                  ],
                  [
                    29537.8,
                    103356
                  ],
                  [
                    29404.4,
                    103330
                  ],
                  [
                    29330.5,
                    103246
                  ],
                  [
                    29278.9,
                    103138
                  ],
                  [
                    29322.7,
                    102872
                  ],
                  [
                    29321.5,
                    102649
                  ],
                  [
                    29804.4,
                    102650
                  ]
                ],
                "id": 1902,
                "chat_link": "[&BG4HAAA=]"
              },
              "1910": {
                "name": "Mori Village",
                "level": 80,
                "coord": [
                  32844.8,
                  103152
                ],
                "bounds": [
                  [
                    32650.7,
                    102757
                  ],
                  [
                    32645,
                    103246
                  ],
                  [
                    32678.4,
                    103290
                  ],
                  [
                    32698.3,
                    103338
                  ],
                  [
                    32775.3,
                    103353
                  ],
                  [
                    32889.8,
                    103356
                  ],
                  [
                    32940.8,
                    103319
                  ],
                  [
                    32959,
                    103269
                  ],
                  [
                    32975.4,
                    103214
                  ],
                  [
                    32962.9,
                    103115
                  ],
                  [
                    32993.5,
                    102839
                  ],
                  [
                    32968,
                    102725
                  ],
                  [
                    32650.7,
                    102757
                  ]
                ],
                "id": 1910,
                "chat_link": "[&BHYHAAA=]"
              },
              "1918": {
                "name": "Zu Heltzer Historical Site",
                "level": 80,
                "coord": [
                  29871.7,
                  101484
                ],
                "bounds": [
                  [
                    29467,
                    101237
                  ],
                  [
                    29477.3,
                    101433
                  ],
                  [
                    29697.8,
                    101641
                  ],
                  [
                    29896.8,
                    101644
                  ],
                  [
                    30003.8,
                    101605
                  ],
                  [
                    30056,
                    101554
                  ],
                  [
                    30131.4,
                    101466
                  ],
                  [
                    30132.2,
                    101351
                  ],
                  [
                    30001.1,
                    101227
                  ],
                  [
                    30000.8,
                    100977
                  ],
                  [
                    30098.7,
                    100968
                  ],
                  [
                    30136,
                    100994
                  ],
                  [
                    30287.8,
                    100986
                  ],
                  [
                    30568.6,
                    100985
                  ],
                  [
                    30642.8,
                    101007
                  ],
                  [
                    30647.6,
                    101566
                  ],
                  [
                    30587,
                    102075
                  ],
                  [
                    30102.1,
                    102249
                  ],
                  [
                    29254.7,
                    102234
                  ],
                  [
                    29263.4,
                    102082
                  ],
                  [
                    29271,
                    101937
                  ],
                  [
                    29279.9,
                    101794
                  ],
                  [
                    29274.8,
                    101494
                  ],
                  [
                    29277.6,
                    101363
                  ],
                  [
                    29235.5,
                    101227
                  ],
                  [
                    29467,
                    101237
                  ]
                ],
                "id": 1918,
                "chat_link": "[&BH4HAAA=]"
              },
              "1926": {
                "name": "Melandru's Hope",
                "level": 80,
                "coord": [
                  31948.9,
                  102503
                ],
                "bounds": [
                  [
                    31514.5,
                    102333
                  ],
                  [
                    31689.9,
                    102069
                  ],
                  [
                    32305.9,
                    102069
                  ],
                  [
                    32650.7,
                    102757
                  ],
                  [
                    32017.7,
                    102755
                  ],
                  [
                    31514.5,
                    103036
                  ],
                  [
                    31514.5,
                    102333
                  ]
                ],
                "id": 1926,
                "chat_link": "[&BIYHAAA=]"
              }
            },
            "adventures": [],
            "id": 1452,
            "mastery_points": [
              {
                "coord": [
                  30253.4,
                  101834
                ],
                "id": 650,
                "region": "Unknown"
              },
              {
                "coord": [
                  30556.3,
                  102371
                ],
                "id": 657,
                "region": "Unknown"
              },
              {
                "coord": [
                  30389.2,
                  102770
                ],
                "id": 654,
                "region": "Unknown"
              },
              {
                "coord": [
                  31621.6,
                  102513
                ],
                "id": 619,
                "region": "Unknown"
              },
              {
                "coord": [
                  30646,
                  101766
                ],
                "id": 559,
                "region": "Unknown"
              },
              {
                "coord": [
                  31232,
                  102853
                ],
                "id": 590,
                "region": "Unknown"
              },
              {
                "coord": [
                  29256.3,
                  101730
                ],
                "id": 627,
                "region": "Unknown"
              },
              {
                "coord": [
                  32461.3,
                  101883
                ],
                "id": 566,
                "region": "Unknown"
              },
              {
                "coord": [
                  30462.4,
                  100992
                ],
                "id": 647,
                "region": "Unknown"
              },
              {
                "coord": [
                  32792.9,
                  103005
                ],
                "id": 560,
                "region": "Unknown"
              },
              {
                "coord": [
                  32780.1,
                  102694
                ],
                "id": 609,
                "region": "Unknown"
              },
              {
                "coord": [
                  32764.4,
                  101752
                ],
                "id": 642,
                "region": "Unknown"
              }
            ]
          },
          "1453": {
            "name": "Ministry of Security: Main Office",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              27000,
              99400
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                25000,
                98100
              ],
              [
                28840,
                100660
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1453,
            "mastery_points": []
          },
          "1454": {
            "name": "The Scenic Route: Kaineng Docks",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              9850,
              42000
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                25000,
                98100
              ],
              [
                28840,
                100660
              ]
            ],
            "points_of_interest": {
              "3305": {
                "name": "Jade Monument",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  25655.6,
                  99375.3
                ],
                "id": 3305,
                "chat_link": "[&BOkMAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1885": {
                "name": "Soojung Heights",
                "level": 80,
                "coord": [
                  26139.9,
                  100092
                ],
                "bounds": [
                  [
                    26645.4,
                    100535
                  ],
                  [
                    26442.1,
                    100517
                  ],
                  [
                    26397.5,
                    100513
                  ],
                  [
                    26333.6,
                    100499
                  ],
                  [
                    26256.4,
                    100464
                  ],
                  [
                    26128,
                    100409
                  ],
                  [
                    26052.5,
                    100345
                  ],
                  [
                    25954,
                    100255
                  ],
                  [
                    25827.2,
                    100126
                  ],
                  [
                    25775.3,
                    100045
                  ],
                  [
                    25749.6,
                    99976.5
                  ],
                  [
                    25710.6,
                    99840.1
                  ],
                  [
                    25683.3,
                    99650.8
                  ],
                  [
                    25743,
                    99651.7
                  ],
                  [
                    25743.1,
                    99533.1
                  ],
                  [
                    25967.5,
                    99529.2
                  ],
                  [
                    25968.6,
                    99638
                  ],
                  [
                    25993.7,
                    99772
                  ],
                  [
                    26033.7,
                    99863.8
                  ],
                  [
                    26064.4,
                    99931.4
                  ],
                  [
                    26146.1,
                    100012
                  ],
                  [
                    26208,
                    100084
                  ],
                  [
                    26315.1,
                    100151
                  ],
                  [
                    26376.2,
                    100191
                  ],
                  [
                    26514.5,
                    100208
                  ],
                  [
                    26600.5,
                    100209
                  ],
                  [
                    26643.4,
                    100216
                  ],
                  [
                    26645.3,
                    100419
                  ],
                  [
                    26645.4,
                    100535
                  ]
                ],
                "id": 1885,
                "chat_link": "[&BF0HAAA=]"
              },
              "1886": {
                "name": "Kaineng Docks",
                "level": 80,
                "coord": [
                  25522.7,
                  99555.1
                ],
                "bounds": [
                  [
                    25827.2,
                    100126
                  ],
                  [
                    25010.4,
                    100121
                  ],
                  [
                    25011.3,
                    99964.4
                  ],
                  [
                    25012.2,
                    99856.2
                  ],
                  [
                    25012.4,
                    99361.6
                  ],
                  [
                    25009.7,
                    98923.8
                  ],
                  [
                    25714.5,
                    98922.8
                  ],
                  [
                    25699,
                    99004.9
                  ],
                  [
                    25684.3,
                    99115.2
                  ],
                  [
                    25748.8,
                    99120.6
                  ],
                  [
                    25750.2,
                    99222.3
                  ],
                  [
                    25743.1,
                    99533.1
                  ],
                  [
                    25743,
                    99651.7
                  ],
                  [
                    25683.3,
                    99650.8
                  ],
                  [
                    25710.6,
                    99840.1
                  ],
                  [
                    25749.6,
                    99976.5
                  ],
                  [
                    25776.3,
                    100045
                  ],
                  [
                    25827.2,
                    100126
                  ]
                ],
                "id": 1886,
                "chat_link": "[&BF4HAAA=]"
              }
            },
            "adventures": [],
            "id": 1454,
            "mastery_points": []
          },
          "1456": {
            "name": "Claiming the Isle of Reflection",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 69,
            "label_coord": [
              22250,
              104696
            ],
            "map_rect": [
              [
                -21504,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                21319,
                103145
              ],
              [
                23239,
                105705
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1854": {
                "level": 0,
                "coord": [
                  22374.8,
                  104740
                ],
                "bounds": [
                  [
                    23002.5,
                    104067
                  ],
                  [
                    23114.4,
                    104560
                  ],
                  [
                    23088.7,
                    105487
                  ],
                  [
                    22923.7,
                    105576
                  ],
                  [
                    21724.4,
                    105618
                  ],
                  [
                    21504.2,
                    105470
                  ],
                  [
                    21529.7,
                    104145
                  ],
                  [
                    21723.1,
                    103898
                  ],
                  [
                    22762.5,
                    103835
                  ],
                  [
                    23002.5,
                    104067
                  ]
                ],
                "id": 1854,
                "chat_link": "[&BD4HAAA=]"
              }
            },
            "id": 1456,
            "mastery_points": [],
            "adventures": []
          },
          "1457": {
            "name": "Detention Facility",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              23150,
              101800
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                33792
              ]
            ],
            "continent_rect": [
              [
                21159,
                100457
              ],
              [
                24999,
                103145
              ]
            ],
            "points_of_interest": {
              "3272": {
                "name": "Seitung Prison",
                "type": "landmark",
                "floor": 1,
                "coord": [
                  22933.9,
                  102522
                ],
                "id": 3272,
                "chat_link": "[&BMgMAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1897": {
                "name": "Seitung Harbor",
                "level": 80,
                "coord": [
                  22812.6,
                  102378
                ],
                "bounds": [
                  [
                    22486,
                    101849
                  ],
                  [
                    22511.3,
                    102010
                  ],
                  [
                    22444.7,
                    102050
                  ],
                  [
                    22428.8,
                    102211
                  ],
                  [
                    22338.1,
                    102266
                  ],
                  [
                    22256.6,
                    102311
                  ],
                  [
                    22310.5,
                    102426
                  ],
                  [
                    22378.4,
                    102644
                  ],
                  [
                    22444.3,
                    102715
                  ],
                  [
                    22585.1,
                    102863
                  ],
                  [
                    22588.1,
                    103139
                  ],
                  [
                    23124.2,
                    103136
                  ],
                  [
                    23113.4,
                    103003
                  ],
                  [
                    23123.5,
                    102891
                  ],
                  [
                    23154.2,
                    102756
                  ],
                  [
                    23121.6,
                    102684
                  ],
                  [
                    23126.2,
                    102609
                  ],
                  [
                    23173.4,
                    102551
                  ],
                  [
                    23200.3,
                    102447
                  ],
                  [
                    23185.5,
                    102358
                  ],
                  [
                    23122.1,
                    102288
                  ],
                  [
                    23091,
                    102210
                  ],
                  [
                    23131.1,
                    102140
                  ],
                  [
                    23081.3,
                    101887
                  ],
                  [
                    23014.3,
                    101756
                  ],
                  [
                    22825.7,
                    101776
                  ],
                  [
                    22752,
                    101780
                  ],
                  [
                    22640.9,
                    101827
                  ],
                  [
                    22486,
                    101849
                  ]
                ],
                "id": 1897,
                "chat_link": "[&BGkHAAA=]"
              }
            },
            "adventures": [],
            "id": 1457,
            "mastery_points": []
          },
          "1458": {
            "name": "Aurene's Sanctuary",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              23150,
              101800
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                33792
              ]
            ],
            "continent_rect": [
              [
                21159,
                100457
              ],
              [
                24999,
                103145
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1853": {
                "name": "Eastern Wilds",
                "level": 80,
                "coord": [
                  24409.8,
                  102377
                ],
                "bounds": [
                  [
                    24283.8,
                    101769
                  ],
                  [
                    24211.6,
                    102047
                  ],
                  [
                    24152.9,
                    102179
                  ],
                  [
                    24116.7,
                    102269
                  ],
                  [
                    24027.8,
                    102411
                  ],
                  [
                    23990.4,
                    102573
                  ],
                  [
                    23945.8,
                    102784
                  ],
                  [
                    23966.9,
                    103136
                  ],
                  [
                    24933.7,
                    103135
                  ],
                  [
                    24987.8,
                    103132
                  ],
                  [
                    24989.3,
                    102962
                  ],
                  [
                    24989.9,
                    101825
                  ],
                  [
                    24624.4,
                    101823
                  ],
                  [
                    24518.2,
                    101794
                  ],
                  [
                    24408.2,
                    101821
                  ],
                  [
                    24283.8,
                    101769
                  ]
                ],
                "id": 1853,
                "chat_link": "[&BD0HAAA=]"
              },
              "1861": {
                "name": "Jaya Bluffs",
                "level": 80,
                "coord": [
                  21816.6,
                  101215
                ],
                "bounds": [
                  [
                    21307,
                    100850
                  ],
                  [
                    21324.4,
                    100947
                  ],
                  [
                    21348.6,
                    101112
                  ],
                  [
                    21374.1,
                    101197
                  ],
                  [
                    21415.8,
                    101339
                  ],
                  [
                    21475.2,
                    101401
                  ],
                  [
                    21571.7,
                    101530
                  ],
                  [
                    21627.7,
                    101606
                  ],
                  [
                    21563,
                    101652
                  ],
                  [
                    21712.8,
                    101702
                  ],
                  [
                    21886.1,
                    101817
                  ],
                  [
                    22002.6,
                    101779
                  ],
                  [
                    22147.1,
                    101785
                  ],
                  [
                    22386.5,
                    101850
                  ],
                  [
                    22495.1,
                    101854
                  ],
                  [
                    22471.8,
                    101702
                  ],
                  [
                    22446.1,
                    101668
                  ],
                  [
                    22447.1,
                    101596
                  ],
                  [
                    22147.8,
                    101463
                  ],
                  [
                    21958.1,
                    101398
                  ],
                  [
                    21873.3,
                    101352
                  ],
                  [
                    21817.1,
                    101238
                  ],
                  [
                    21847.8,
                    101149
                  ],
                  [
                    21855.3,
                    101076
                  ],
                  [
                    21824,
                    100954
                  ],
                  [
                    21840.6,
                    100836
                  ],
                  [
                    21941.8,
                    100674
                  ],
                  [
                    21992.9,
                    100461
                  ],
                  [
                    21869.9,
                    100591
                  ],
                  [
                    21818.9,
                    100585
                  ],
                  [
                    21719.4,
                    100682
                  ],
                  [
                    21668.7,
                    100662
                  ],
                  [
                    21571.2,
                    100595
                  ],
                  [
                    21437.7,
                    100653
                  ],
                  [
                    21393,
                    100768
                  ],
                  [
                    21307,
                    100850
                  ]
                ],
                "id": 1861,
                "chat_link": "[&BEUHAAA=]"
              },
              "1863": {
                "name": "Shinota Shore",
                "level": 80,
                "coord": [
                  22484.6,
                  101273
                ],
                "bounds": [
                  [
                    21868.7,
                    101351
                  ],
                  [
                    21952.8,
                    101398
                  ],
                  [
                    22145.6,
                    101464
                  ],
                  [
                    22441.9,
                    101600
                  ],
                  [
                    22441.2,
                    101669
                  ],
                  [
                    22467.3,
                    101707
                  ],
                  [
                    22488,
                    101856
                  ],
                  [
                    22643.5,
                    101832
                  ],
                  [
                    22753,
                    101782
                  ],
                  [
                    22826.4,
                    101774
                  ],
                  [
                    23009.5,
                    101766
                  ],
                  [
                    22921.3,
                    101651
                  ],
                  [
                    22895,
                    101557
                  ],
                  [
                    22816.1,
                    101441
                  ],
                  [
                    22816.3,
                    101348
                  ],
                  [
                    22853.9,
                    101275
                  ],
                  [
                    22914.3,
                    101261
                  ],
                  [
                    22868.9,
                    101106
                  ],
                  [
                    22794.1,
                    101013
                  ],
                  [
                    22772.5,
                    100938
                  ],
                  [
                    22863.6,
                    100852
                  ],
                  [
                    22956,
                    100701
                  ],
                  [
                    22942.8,
                    100461
                  ],
                  [
                    21987.2,
                    100466
                  ],
                  [
                    21937.8,
                    100669
                  ],
                  [
                    21837.2,
                    100830
                  ],
                  [
                    21819.1,
                    100955
                  ],
                  [
                    21850.8,
                    101074
                  ],
                  [
                    21839.2,
                    101147
                  ],
                  [
                    21814.6,
                    101234
                  ],
                  [
                    21868.7,
                    101351
                  ]
                ],
                "id": 1863,
                "chat_link": "[&BEcHAAA=]"
              },
              "1864": {
                "name": "Haiju Plains",
                "level": 80,
                "coord": [
                  23328.4,
                  101059
                ],
                "bounds": [
                  [
                    22935.4,
                    100461
                  ],
                  [
                    22950.1,
                    100701
                  ],
                  [
                    22856.6,
                    100849
                  ],
                  [
                    22763.1,
                    100926
                  ],
                  [
                    22787.1,
                    101010
                  ],
                  [
                    22863.9,
                    101108
                  ],
                  [
                    22909.3,
                    101260
                  ],
                  [
                    22978.6,
                    101263
                  ],
                  [
                    23069.4,
                    101256
                  ],
                  [
                    23377.6,
                    101199
                  ],
                  [
                    23448.3,
                    101201
                  ],
                  [
                    23566.3,
                    101282
                  ],
                  [
                    23704.8,
                    101458
                  ],
                  [
                    23748.3,
                    101355
                  ],
                  [
                    23776.5,
                    101277
                  ],
                  [
                    23776.8,
                    101216
                  ],
                  [
                    23797.2,
                    101061
                  ],
                  [
                    23758.5,
                    100968
                  ],
                  [
                    23749.9,
                    100857
                  ],
                  [
                    23750.8,
                    100462
                  ],
                  [
                    22935.4,
                    100461
                  ]
                ],
                "id": 1864,
                "chat_link": "[&BEgHAAA=]"
              },
              "1872": {
                "name": "Zen Daijun",
                "level": 80,
                "coord": [
                  23506.5,
                  102219
                ],
                "bounds": [
                  [
                    23009.6,
                    101754
                  ],
                  [
                    23074.5,
                    101880
                  ],
                  [
                    23126.8,
                    102135
                  ],
                  [
                    23085.9,
                    102207
                  ],
                  [
                    23113.8,
                    102288
                  ],
                  [
                    23179.3,
                    102358
                  ],
                  [
                    23194.5,
                    102447
                  ],
                  [
                    23170.1,
                    102550
                  ],
                  [
                    23119.1,
                    102606
                  ],
                  [
                    23118,
                    102685
                  ],
                  [
                    23148.8,
                    102757
                  ],
                  [
                    23119.4,
                    102887
                  ],
                  [
                    23108.6,
                    103008
                  ],
                  [
                    23115,
                    103137
                  ],
                  [
                    23975.7,
                    103137
                  ],
                  [
                    23952.7,
                    102788
                  ],
                  [
                    23997.7,
                    102574
                  ],
                  [
                    24037.4,
                    102422
                  ],
                  [
                    24124.4,
                    102278
                  ],
                  [
                    24162.7,
                    102181
                  ],
                  [
                    24217.8,
                    102059
                  ],
                  [
                    24286.6,
                    101762
                  ],
                  [
                    24029.3,
                    101732
                  ],
                  [
                    23898.6,
                    101775
                  ],
                  [
                    23828.5,
                    101820
                  ],
                  [
                    23836.9,
                    101889
                  ],
                  [
                    23802.7,
                    101957
                  ],
                  [
                    23751.4,
                    102018
                  ],
                  [
                    23698.7,
                    102049
                  ],
                  [
                    23526.7,
                    102047
                  ],
                  [
                    23435.3,
                    102015
                  ],
                  [
                    23413.2,
                    101918
                  ],
                  [
                    23366.6,
                    101874
                  ],
                  [
                    23309.8,
                    101795
                  ],
                  [
                    23208.1,
                    101778
                  ],
                  [
                    23135.5,
                    101777
                  ],
                  [
                    23060.3,
                    101769
                  ],
                  [
                    23009.6,
                    101754
                  ]
                ],
                "id": 1872,
                "chat_link": "[&BFAHAAA=]"
              },
              "1874": {
                "name": "Shing Jea Monastery",
                "level": 80,
                "coord": [
                  21799.4,
                  102129
                ],
                "bounds": [
                  [
                    21226.1,
                    101841
                  ],
                  [
                    21224.4,
                    102024
                  ],
                  [
                    21213.4,
                    102159
                  ],
                  [
                    21237.4,
                    102264
                  ],
                  [
                    21244.7,
                    102374
                  ],
                  [
                    21356.9,
                    102352
                  ],
                  [
                    21444.8,
                    102368
                  ],
                  [
                    21518.9,
                    102382
                  ],
                  [
                    21582,
                    102372
                  ],
                  [
                    21664.2,
                    102368
                  ],
                  [
                    21721.9,
                    102365
                  ],
                  [
                    21784.4,
                    102355
                  ],
                  [
                    21844.1,
                    102334
                  ],
                  [
                    21918.3,
                    102343
                  ],
                  [
                    22000.3,
                    102357
                  ],
                  [
                    22095.8,
                    102362
                  ],
                  [
                    22328,
                    102417
                  ],
                  [
                    22273.1,
                    102310
                  ],
                  [
                    22339.9,
                    102275
                  ],
                  [
                    22437.7,
                    102216
                  ],
                  [
                    22456.4,
                    102058
                  ],
                  [
                    22519.3,
                    102014
                  ],
                  [
                    22492.8,
                    101837
                  ],
                  [
                    22142.5,
                    101778
                  ],
                  [
                    22003.3,
                    101774
                  ],
                  [
                    21886.5,
                    101809
                  ],
                  [
                    21711.6,
                    101694
                  ],
                  [
                    21561.1,
                    101646
                  ],
                  [
                    21436.9,
                    101678
                  ],
                  [
                    21314.7,
                    101731
                  ],
                  [
                    21226.1,
                    101841
                  ]
                ],
                "id": 1874,
                "chat_link": "[&BFIHAAA=]"
              },
              "1877": {
                "name": "Training Grounds",
                "level": 80,
                "coord": [
                  21988.3,
                  102594
                ],
                "bounds": [
                  [
                    21918.3,
                    102341
                  ],
                  [
                    21842.6,
                    102330
                  ],
                  [
                    21784.4,
                    102352
                  ],
                  [
                    21712.9,
                    102356
                  ],
                  [
                    21727.8,
                    102395
                  ],
                  [
                    21704.4,
                    102558
                  ],
                  [
                    21782.1,
                    102739
                  ],
                  [
                    21866.3,
                    102832
                  ],
                  [
                    21910.9,
                    102926
                  ],
                  [
                    21928.7,
                    102932
                  ],
                  [
                    22037.2,
                    102920
                  ],
                  [
                    22147.3,
                    102825
                  ],
                  [
                    22237.8,
                    102743
                  ],
                  [
                    22364.5,
                    102684
                  ],
                  [
                    22398.3,
                    102644
                  ],
                  [
                    22326.8,
                    102414
                  ],
                  [
                    22098.2,
                    102359
                  ],
                  [
                    22000.6,
                    102351
                  ],
                  [
                    21918.3,
                    102341
                  ]
                ],
                "id": 1877,
                "chat_link": "[&BFUHAAA=]"
              },
              "1878": {
                "name": "Monastery Bay",
                "level": 80,
                "coord": [
                  21581.4,
                  102724
                ],
                "bounds": [
                  [
                    21248,
                    102374
                  ],
                  [
                    21356.1,
                    102350
                  ],
                  [
                    21447.2,
                    102367
                  ],
                  [
                    21520.4,
                    102372
                  ],
                  [
                    21576.4,
                    102371
                  ],
                  [
                    21666.8,
                    102363
                  ],
                  [
                    21720.5,
                    102361
                  ],
                  [
                    21730,
                    102395
                  ],
                  [
                    21712,
                    102563
                  ],
                  [
                    21794.5,
                    102741
                  ],
                  [
                    21873.8,
                    102830
                  ],
                  [
                    21916.2,
                    102927
                  ],
                  [
                    21931.5,
                    102929
                  ],
                  [
                    22036,
                    102916
                  ],
                  [
                    22054.6,
                    103139
                  ],
                  [
                    21661.7,
                    103138
                  ],
                  [
                    21389.4,
                    103137
                  ],
                  [
                    21338.3,
                    103117
                  ],
                  [
                    21321.5,
                    103068
                  ],
                  [
                    21324.5,
                    102977
                  ],
                  [
                    21298.9,
                    102900
                  ],
                  [
                    21214,
                    102709
                  ],
                  [
                    21240.7,
                    102608
                  ],
                  [
                    21248,
                    102374
                  ]
                ],
                "id": 1878,
                "chat_link": "[&BFYHAAA=]"
              },
              "1897": {
                "name": "Seitung Harbor",
                "level": 80,
                "coord": [
                  22812.6,
                  102378
                ],
                "bounds": [
                  [
                    22486,
                    101849
                  ],
                  [
                    22511.3,
                    102010
                  ],
                  [
                    22444.7,
                    102050
                  ],
                  [
                    22428.8,
                    102211
                  ],
                  [
                    22338.1,
                    102266
                  ],
                  [
                    22256.6,
                    102311
                  ],
                  [
                    22310.5,
                    102426
                  ],
                  [
                    22378.4,
                    102644
                  ],
                  [
                    22444.3,
                    102715
                  ],
                  [
                    22585.1,
                    102863
                  ],
                  [
                    22588.1,
                    103139
                  ],
                  [
                    23124.2,
                    103136
                  ],
                  [
                    23113.4,
                    103003
                  ],
                  [
                    23123.5,
                    102891
                  ],
                  [
                    23154.2,
                    102756
                  ],
                  [
                    23121.6,
                    102684
                  ],
                  [
                    23126.2,
                    102609
                  ],
                  [
                    23173.4,
                    102551
                  ],
                  [
                    23200.3,
                    102447
                  ],
                  [
                    23185.5,
                    102358
                  ],
                  [
                    23122.1,
                    102288
                  ],
                  [
                    23091,
                    102210
                  ],
                  [
                    23131.1,
                    102140
                  ],
                  [
                    23081.3,
                    101887
                  ],
                  [
                    23014.3,
                    101756
                  ],
                  [
                    22825.7,
                    101776
                  ],
                  [
                    22752,
                    101780
                  ],
                  [
                    22640.9,
                    101827
                  ],
                  [
                    22486,
                    101849
                  ]
                ],
                "id": 1897,
                "chat_link": "[&BGkHAAA=]"
              },
              "1898": {
                "name": "Daigo Ward",
                "level": 80,
                "coord": [
                  23315.2,
                  101641
                ],
                "bounds": [
                  [
                    22980.9,
                    101260
                  ],
                  [
                    22915,
                    101258
                  ],
                  [
                    22851,
                    101269
                  ],
                  [
                    22816.4,
                    101347
                  ],
                  [
                    22812.9,
                    101442
                  ],
                  [
                    22894,
                    101557
                  ],
                  [
                    22916.2,
                    101651
                  ],
                  [
                    23003.3,
                    101765
                  ],
                  [
                    23064,
                    101778
                  ],
                  [
                    23135,
                    101774
                  ],
                  [
                    23206.7,
                    101782
                  ],
                  [
                    23303.4,
                    101813
                  ],
                  [
                    23360.8,
                    101878
                  ],
                  [
                    23406.3,
                    101920
                  ],
                  [
                    23433.6,
                    102018
                  ],
                  [
                    23527.7,
                    102053
                  ],
                  [
                    23700.3,
                    102052
                  ],
                  [
                    23753.4,
                    102014
                  ],
                  [
                    23807.9,
                    101958
                  ],
                  [
                    23841,
                    101885
                  ],
                  [
                    23830.5,
                    101825
                  ],
                  [
                    23788.4,
                    101639
                  ],
                  [
                    23696.8,
                    101444
                  ],
                  [
                    23569.8,
                    101278
                  ],
                  [
                    23450.7,
                    101199
                  ],
                  [
                    23371.5,
                    101195
                  ],
                  [
                    23071.8,
                    101252
                  ],
                  [
                    22980.9,
                    101260
                  ]
                ],
                "id": 1898,
                "chat_link": "[&BGoHAAA=]"
              },
              "1903": {
                "name": "Crystal Cave",
                "level": 80,
                "coord": [
                  22315,
                  102849
                ],
                "bounds": [
                  [
                    22025.1,
                    102914
                  ],
                  [
                    22143.3,
                    102819
                  ],
                  [
                    22224.2,
                    102738
                  ],
                  [
                    22363,
                    102679
                  ],
                  [
                    22395.3,
                    102645
                  ],
                  [
                    22447.1,
                    102706
                  ],
                  [
                    22592.9,
                    102858
                  ],
                  [
                    22597.2,
                    103137
                  ],
                  [
                    22046.9,
                    103139
                  ],
                  [
                    22025.1,
                    102914
                  ]
                ],
                "id": 1903,
                "chat_link": "[&BG8HAAA=]"
              },
              "1905": {
                "name": "North Peninsula",
                "level": 80,
                "coord": [
                  24604.2,
                  101120
                ],
                "bounds": [
                  [
                    24436.7,
                    100463
                  ],
                  [
                    24398.9,
                    100763
                  ],
                  [
                    24321.4,
                    100955
                  ],
                  [
                    24239.8,
                    101178
                  ],
                  [
                    24242.4,
                    101370
                  ],
                  [
                    24269.1,
                    101539
                  ],
                  [
                    24276.8,
                    101764
                  ],
                  [
                    24406.9,
                    101817
                  ],
                  [
                    24520,
                    101800
                  ],
                  [
                    24620.3,
                    101831
                  ],
                  [
                    24988.8,
                    101828
                  ],
                  [
                    24992,
                    100610
                  ],
                  [
                    25008.4,
                    100599
                  ],
                  [
                    25007.5,
                    100473
                  ],
                  [
                    24989.3,
                    100467
                  ],
                  [
                    24949,
                    100461
                  ],
                  [
                    24436.7,
                    100463
                  ]
                ],
                "id": 1905,
                "chat_link": "[&BHEHAAA=]"
              }
            },
            "adventures": [],
            "id": 1458,
            "mastery_points": []
          },
          "1459": {
            "name": "Claiming the Isle of Reflection",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 69,
            "label_coord": [
              22250,
              104696
            ],
            "map_rect": [
              [
                -21504,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                21319,
                103145
              ],
              [
                23239,
                105705
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1854": {
                "level": 0,
                "coord": [
                  22374.8,
                  104740
                ],
                "bounds": [
                  [
                    23002.5,
                    104067
                  ],
                  [
                    23114.4,
                    104560
                  ],
                  [
                    23088.7,
                    105487
                  ],
                  [
                    22923.7,
                    105576
                  ],
                  [
                    21724.4,
                    105618
                  ],
                  [
                    21504.2,
                    105470
                  ],
                  [
                    21529.7,
                    104145
                  ],
                  [
                    21723.1,
                    103898
                  ],
                  [
                    22762.5,
                    103835
                  ],
                  [
                    23002.5,
                    104067
                  ]
                ],
                "id": 1854,
                "chat_link": "[&BD4HAAA=]"
              }
            },
            "id": 1459,
            "mastery_points": [],
            "adventures": []
          },
          "1460": {
            "name": "Empress Ihn's Court",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              23150,
              101800
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                33792
              ]
            ],
            "continent_rect": [
              [
                21159,
                100457
              ],
              [
                24999,
                103145
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1853": {
                "name": "Eastern Wilds",
                "level": 80,
                "coord": [
                  24409.8,
                  102377
                ],
                "bounds": [
                  [
                    24283.8,
                    101769
                  ],
                  [
                    24211.6,
                    102047
                  ],
                  [
                    24152.9,
                    102179
                  ],
                  [
                    24116.7,
                    102269
                  ],
                  [
                    24027.8,
                    102411
                  ],
                  [
                    23990.4,
                    102573
                  ],
                  [
                    23945.8,
                    102784
                  ],
                  [
                    23966.9,
                    103136
                  ],
                  [
                    24933.7,
                    103135
                  ],
                  [
                    24987.8,
                    103132
                  ],
                  [
                    24989.3,
                    102962
                  ],
                  [
                    24989.9,
                    101825
                  ],
                  [
                    24624.4,
                    101823
                  ],
                  [
                    24518.2,
                    101794
                  ],
                  [
                    24408.2,
                    101821
                  ],
                  [
                    24283.8,
                    101769
                  ]
                ],
                "id": 1853,
                "chat_link": "[&BD0HAAA=]"
              },
              "1861": {
                "name": "Jaya Bluffs",
                "level": 80,
                "coord": [
                  21816.6,
                  101215
                ],
                "bounds": [
                  [
                    21307,
                    100850
                  ],
                  [
                    21324.4,
                    100947
                  ],
                  [
                    21348.6,
                    101112
                  ],
                  [
                    21374.1,
                    101197
                  ],
                  [
                    21415.8,
                    101339
                  ],
                  [
                    21475.2,
                    101401
                  ],
                  [
                    21571.7,
                    101530
                  ],
                  [
                    21627.7,
                    101606
                  ],
                  [
                    21563,
                    101652
                  ],
                  [
                    21712.8,
                    101702
                  ],
                  [
                    21886.1,
                    101817
                  ],
                  [
                    22002.6,
                    101779
                  ],
                  [
                    22147.1,
                    101785
                  ],
                  [
                    22386.5,
                    101850
                  ],
                  [
                    22495.1,
                    101854
                  ],
                  [
                    22471.8,
                    101702
                  ],
                  [
                    22446.1,
                    101668
                  ],
                  [
                    22447.1,
                    101596
                  ],
                  [
                    22147.8,
                    101463
                  ],
                  [
                    21958.1,
                    101398
                  ],
                  [
                    21873.3,
                    101352
                  ],
                  [
                    21817.1,
                    101238
                  ],
                  [
                    21847.8,
                    101149
                  ],
                  [
                    21855.3,
                    101076
                  ],
                  [
                    21824,
                    100954
                  ],
                  [
                    21840.6,
                    100836
                  ],
                  [
                    21941.8,
                    100674
                  ],
                  [
                    21992.9,
                    100461
                  ],
                  [
                    21869.9,
                    100591
                  ],
                  [
                    21818.9,
                    100585
                  ],
                  [
                    21719.4,
                    100682
                  ],
                  [
                    21668.7,
                    100662
                  ],
                  [
                    21571.2,
                    100595
                  ],
                  [
                    21437.7,
                    100653
                  ],
                  [
                    21393,
                    100768
                  ],
                  [
                    21307,
                    100850
                  ]
                ],
                "id": 1861,
                "chat_link": "[&BEUHAAA=]"
              },
              "1863": {
                "name": "Shinota Shore",
                "level": 80,
                "coord": [
                  22484.6,
                  101273
                ],
                "bounds": [
                  [
                    21868.7,
                    101351
                  ],
                  [
                    21952.8,
                    101398
                  ],
                  [
                    22145.6,
                    101464
                  ],
                  [
                    22441.9,
                    101600
                  ],
                  [
                    22441.2,
                    101669
                  ],
                  [
                    22467.3,
                    101707
                  ],
                  [
                    22488,
                    101856
                  ],
                  [
                    22643.5,
                    101832
                  ],
                  [
                    22753,
                    101782
                  ],
                  [
                    22826.4,
                    101774
                  ],
                  [
                    23009.5,
                    101766
                  ],
                  [
                    22921.3,
                    101651
                  ],
                  [
                    22895,
                    101557
                  ],
                  [
                    22816.1,
                    101441
                  ],
                  [
                    22816.3,
                    101348
                  ],
                  [
                    22853.9,
                    101275
                  ],
                  [
                    22914.3,
                    101261
                  ],
                  [
                    22868.9,
                    101106
                  ],
                  [
                    22794.1,
                    101013
                  ],
                  [
                    22772.5,
                    100938
                  ],
                  [
                    22863.6,
                    100852
                  ],
                  [
                    22956,
                    100701
                  ],
                  [
                    22942.8,
                    100461
                  ],
                  [
                    21987.2,
                    100466
                  ],
                  [
                    21937.8,
                    100669
                  ],
                  [
                    21837.2,
                    100830
                  ],
                  [
                    21819.1,
                    100955
                  ],
                  [
                    21850.8,
                    101074
                  ],
                  [
                    21839.2,
                    101147
                  ],
                  [
                    21814.6,
                    101234
                  ],
                  [
                    21868.7,
                    101351
                  ]
                ],
                "id": 1863,
                "chat_link": "[&BEcHAAA=]"
              },
              "1864": {
                "name": "Haiju Plains",
                "level": 80,
                "coord": [
                  23328.4,
                  101059
                ],
                "bounds": [
                  [
                    22935.4,
                    100461
                  ],
                  [
                    22950.1,
                    100701
                  ],
                  [
                    22856.6,
                    100849
                  ],
                  [
                    22763.1,
                    100926
                  ],
                  [
                    22787.1,
                    101010
                  ],
                  [
                    22863.9,
                    101108
                  ],
                  [
                    22909.3,
                    101260
                  ],
                  [
                    22978.6,
                    101263
                  ],
                  [
                    23069.4,
                    101256
                  ],
                  [
                    23377.6,
                    101199
                  ],
                  [
                    23448.3,
                    101201
                  ],
                  [
                    23566.3,
                    101282
                  ],
                  [
                    23704.8,
                    101458
                  ],
                  [
                    23748.3,
                    101355
                  ],
                  [
                    23776.5,
                    101277
                  ],
                  [
                    23776.8,
                    101216
                  ],
                  [
                    23797.2,
                    101061
                  ],
                  [
                    23758.5,
                    100968
                  ],
                  [
                    23749.9,
                    100857
                  ],
                  [
                    23750.8,
                    100462
                  ],
                  [
                    22935.4,
                    100461
                  ]
                ],
                "id": 1864,
                "chat_link": "[&BEgHAAA=]"
              },
              "1872": {
                "name": "Zen Daijun",
                "level": 80,
                "coord": [
                  23506.5,
                  102219
                ],
                "bounds": [
                  [
                    23009.6,
                    101754
                  ],
                  [
                    23074.5,
                    101880
                  ],
                  [
                    23126.8,
                    102135
                  ],
                  [
                    23085.9,
                    102207
                  ],
                  [
                    23113.8,
                    102288
                  ],
                  [
                    23179.3,
                    102358
                  ],
                  [
                    23194.5,
                    102447
                  ],
                  [
                    23170.1,
                    102550
                  ],
                  [
                    23119.1,
                    102606
                  ],
                  [
                    23118,
                    102685
                  ],
                  [
                    23148.8,
                    102757
                  ],
                  [
                    23119.4,
                    102887
                  ],
                  [
                    23108.6,
                    103008
                  ],
                  [
                    23115,
                    103137
                  ],
                  [
                    23975.7,
                    103137
                  ],
                  [
                    23952.7,
                    102788
                  ],
                  [
                    23997.7,
                    102574
                  ],
                  [
                    24037.4,
                    102422
                  ],
                  [
                    24124.4,
                    102278
                  ],
                  [
                    24162.7,
                    102181
                  ],
                  [
                    24217.8,
                    102059
                  ],
                  [
                    24286.6,
                    101762
                  ],
                  [
                    24029.3,
                    101732
                  ],
                  [
                    23898.6,
                    101775
                  ],
                  [
                    23828.5,
                    101820
                  ],
                  [
                    23836.9,
                    101889
                  ],
                  [
                    23802.7,
                    101957
                  ],
                  [
                    23751.4,
                    102018
                  ],
                  [
                    23698.7,
                    102049
                  ],
                  [
                    23526.7,
                    102047
                  ],
                  [
                    23435.3,
                    102015
                  ],
                  [
                    23413.2,
                    101918
                  ],
                  [
                    23366.6,
                    101874
                  ],
                  [
                    23309.8,
                    101795
                  ],
                  [
                    23208.1,
                    101778
                  ],
                  [
                    23135.5,
                    101777
                  ],
                  [
                    23060.3,
                    101769
                  ],
                  [
                    23009.6,
                    101754
                  ]
                ],
                "id": 1872,
                "chat_link": "[&BFAHAAA=]"
              },
              "1874": {
                "name": "Shing Jea Monastery",
                "level": 80,
                "coord": [
                  21799.4,
                  102129
                ],
                "bounds": [
                  [
                    21226.1,
                    101841
                  ],
                  [
                    21224.4,
                    102024
                  ],
                  [
                    21213.4,
                    102159
                  ],
                  [
                    21237.4,
                    102264
                  ],
                  [
                    21244.7,
                    102374
                  ],
                  [
                    21356.9,
                    102352
                  ],
                  [
                    21444.8,
                    102368
                  ],
                  [
                    21518.9,
                    102382
                  ],
                  [
                    21582,
                    102372
                  ],
                  [
                    21664.2,
                    102368
                  ],
                  [
                    21721.9,
                    102365
                  ],
                  [
                    21784.4,
                    102355
                  ],
                  [
                    21844.1,
                    102334
                  ],
                  [
                    21918.3,
                    102343
                  ],
                  [
                    22000.3,
                    102357
                  ],
                  [
                    22095.8,
                    102362
                  ],
                  [
                    22328,
                    102417
                  ],
                  [
                    22273.1,
                    102310
                  ],
                  [
                    22339.9,
                    102275
                  ],
                  [
                    22437.7,
                    102216
                  ],
                  [
                    22456.4,
                    102058
                  ],
                  [
                    22519.3,
                    102014
                  ],
                  [
                    22492.8,
                    101837
                  ],
                  [
                    22142.5,
                    101778
                  ],
                  [
                    22003.3,
                    101774
                  ],
                  [
                    21886.5,
                    101809
                  ],
                  [
                    21711.6,
                    101694
                  ],
                  [
                    21561.1,
                    101646
                  ],
                  [
                    21436.9,
                    101678
                  ],
                  [
                    21314.7,
                    101731
                  ],
                  [
                    21226.1,
                    101841
                  ]
                ],
                "id": 1874,
                "chat_link": "[&BFIHAAA=]"
              },
              "1877": {
                "name": "Training Grounds",
                "level": 80,
                "coord": [
                  21988.3,
                  102594
                ],
                "bounds": [
                  [
                    21918.3,
                    102341
                  ],
                  [
                    21842.6,
                    102330
                  ],
                  [
                    21784.4,
                    102352
                  ],
                  [
                    21712.9,
                    102356
                  ],
                  [
                    21727.8,
                    102395
                  ],
                  [
                    21704.4,
                    102558
                  ],
                  [
                    21782.1,
                    102739
                  ],
                  [
                    21866.3,
                    102832
                  ],
                  [
                    21910.9,
                    102926
                  ],
                  [
                    21928.7,
                    102932
                  ],
                  [
                    22037.2,
                    102920
                  ],
                  [
                    22147.3,
                    102825
                  ],
                  [
                    22237.8,
                    102743
                  ],
                  [
                    22364.5,
                    102684
                  ],
                  [
                    22398.3,
                    102644
                  ],
                  [
                    22326.8,
                    102414
                  ],
                  [
                    22098.2,
                    102359
                  ],
                  [
                    22000.6,
                    102351
                  ],
                  [
                    21918.3,
                    102341
                  ]
                ],
                "id": 1877,
                "chat_link": "[&BFUHAAA=]"
              },
              "1878": {
                "name": "Monastery Bay",
                "level": 80,
                "coord": [
                  21581.4,
                  102724
                ],
                "bounds": [
                  [
                    21248,
                    102374
                  ],
                  [
                    21356.1,
                    102350
                  ],
                  [
                    21447.2,
                    102367
                  ],
                  [
                    21520.4,
                    102372
                  ],
                  [
                    21576.4,
                    102371
                  ],
                  [
                    21666.8,
                    102363
                  ],
                  [
                    21720.5,
                    102361
                  ],
                  [
                    21730,
                    102395
                  ],
                  [
                    21712,
                    102563
                  ],
                  [
                    21794.5,
                    102741
                  ],
                  [
                    21873.8,
                    102830
                  ],
                  [
                    21916.2,
                    102927
                  ],
                  [
                    21931.5,
                    102929
                  ],
                  [
                    22036,
                    102916
                  ],
                  [
                    22054.6,
                    103139
                  ],
                  [
                    21661.7,
                    103138
                  ],
                  [
                    21389.4,
                    103137
                  ],
                  [
                    21338.3,
                    103117
                  ],
                  [
                    21321.5,
                    103068
                  ],
                  [
                    21324.5,
                    102977
                  ],
                  [
                    21298.9,
                    102900
                  ],
                  [
                    21214,
                    102709
                  ],
                  [
                    21240.7,
                    102608
                  ],
                  [
                    21248,
                    102374
                  ]
                ],
                "id": 1878,
                "chat_link": "[&BFYHAAA=]"
              },
              "1897": {
                "name": "Seitung Harbor",
                "level": 80,
                "coord": [
                  22812.6,
                  102378
                ],
                "bounds": [
                  [
                    22486,
                    101849
                  ],
                  [
                    22511.3,
                    102010
                  ],
                  [
                    22444.7,
                    102050
                  ],
                  [
                    22428.8,
                    102211
                  ],
                  [
                    22338.1,
                    102266
                  ],
                  [
                    22256.6,
                    102311
                  ],
                  [
                    22310.5,
                    102426
                  ],
                  [
                    22378.4,
                    102644
                  ],
                  [
                    22444.3,
                    102715
                  ],
                  [
                    22585.1,
                    102863
                  ],
                  [
                    22588.1,
                    103139
                  ],
                  [
                    23124.2,
                    103136
                  ],
                  [
                    23113.4,
                    103003
                  ],
                  [
                    23123.5,
                    102891
                  ],
                  [
                    23154.2,
                    102756
                  ],
                  [
                    23121.6,
                    102684
                  ],
                  [
                    23126.2,
                    102609
                  ],
                  [
                    23173.4,
                    102551
                  ],
                  [
                    23200.3,
                    102447
                  ],
                  [
                    23185.5,
                    102358
                  ],
                  [
                    23122.1,
                    102288
                  ],
                  [
                    23091,
                    102210
                  ],
                  [
                    23131.1,
                    102140
                  ],
                  [
                    23081.3,
                    101887
                  ],
                  [
                    23014.3,
                    101756
                  ],
                  [
                    22825.7,
                    101776
                  ],
                  [
                    22752,
                    101780
                  ],
                  [
                    22640.9,
                    101827
                  ],
                  [
                    22486,
                    101849
                  ]
                ],
                "id": 1897,
                "chat_link": "[&BGkHAAA=]"
              },
              "1898": {
                "name": "Daigo Ward",
                "level": 80,
                "coord": [
                  23315.2,
                  101641
                ],
                "bounds": [
                  [
                    22980.9,
                    101260
                  ],
                  [
                    22915,
                    101258
                  ],
                  [
                    22851,
                    101269
                  ],
                  [
                    22816.4,
                    101347
                  ],
                  [
                    22812.9,
                    101442
                  ],
                  [
                    22894,
                    101557
                  ],
                  [
                    22916.2,
                    101651
                  ],
                  [
                    23003.3,
                    101765
                  ],
                  [
                    23064,
                    101778
                  ],
                  [
                    23135,
                    101774
                  ],
                  [
                    23206.7,
                    101782
                  ],
                  [
                    23303.4,
                    101813
                  ],
                  [
                    23360.8,
                    101878
                  ],
                  [
                    23406.3,
                    101920
                  ],
                  [
                    23433.6,
                    102018
                  ],
                  [
                    23527.7,
                    102053
                  ],
                  [
                    23700.3,
                    102052
                  ],
                  [
                    23753.4,
                    102014
                  ],
                  [
                    23807.9,
                    101958
                  ],
                  [
                    23841,
                    101885
                  ],
                  [
                    23830.5,
                    101825
                  ],
                  [
                    23788.4,
                    101639
                  ],
                  [
                    23696.8,
                    101444
                  ],
                  [
                    23569.8,
                    101278
                  ],
                  [
                    23450.7,
                    101199
                  ],
                  [
                    23371.5,
                    101195
                  ],
                  [
                    23071.8,
                    101252
                  ],
                  [
                    22980.9,
                    101260
                  ]
                ],
                "id": 1898,
                "chat_link": "[&BGoHAAA=]"
              },
              "1903": {
                "name": "Crystal Cave",
                "level": 80,
                "coord": [
                  22315,
                  102849
                ],
                "bounds": [
                  [
                    22025.1,
                    102914
                  ],
                  [
                    22143.3,
                    102819
                  ],
                  [
                    22224.2,
                    102738
                  ],
                  [
                    22363,
                    102679
                  ],
                  [
                    22395.3,
                    102645
                  ],
                  [
                    22447.1,
                    102706
                  ],
                  [
                    22592.9,
                    102858
                  ],
                  [
                    22597.2,
                    103137
                  ],
                  [
                    22046.9,
                    103139
                  ],
                  [
                    22025.1,
                    102914
                  ]
                ],
                "id": 1903,
                "chat_link": "[&BG8HAAA=]"
              },
              "1905": {
                "name": "North Peninsula",
                "level": 80,
                "coord": [
                  24604.2,
                  101120
                ],
                "bounds": [
                  [
                    24436.7,
                    100463
                  ],
                  [
                    24398.9,
                    100763
                  ],
                  [
                    24321.4,
                    100955
                  ],
                  [
                    24239.8,
                    101178
                  ],
                  [
                    24242.4,
                    101370
                  ],
                  [
                    24269.1,
                    101539
                  ],
                  [
                    24276.8,
                    101764
                  ],
                  [
                    24406.9,
                    101817
                  ],
                  [
                    24520,
                    101800
                  ],
                  [
                    24620.3,
                    101831
                  ],
                  [
                    24988.8,
                    101828
                  ],
                  [
                    24992,
                    100610
                  ],
                  [
                    25008.4,
                    100599
                  ],
                  [
                    25007.5,
                    100473
                  ],
                  [
                    24989.3,
                    100467
                  ],
                  [
                    24949,
                    100461
                  ],
                  [
                    24436.7,
                    100463
                  ]
                ],
                "id": 1905,
                "chat_link": "[&BHEHAAA=]"
              }
            },
            "adventures": [],
            "id": 1460,
            "mastery_points": []
          },
          "1461": {
            "name": "Zen Daijun Hideaway",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              23150,
              101800
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                33792
              ]
            ],
            "continent_rect": [
              [
                21159,
                100457
              ],
              [
                24999,
                103145
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {},
            "adventures": [],
            "id": 1461,
            "mastery_points": []
          },
          "1462": {
            "name": "Isle of Reflection",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              22250,
              104696
            ],
            "map_rect": [
              [
                -21504,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                21319,
                103145
              ],
              [
                23239,
                105705
              ]
            ],
            "points_of_interest": {
              "3294": {
                "name": "Reflection Arena Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  22232,
                  105006
                ],
                "id": 3294,
                "chat_link": "[&BN4MAAA=]"
              },
              "3315": {
                "name": "Reflection Docks Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  21852.2,
                  104468
                ],
                "id": 3315,
                "chat_link": "[&BPMMAAA=]"
              },
              "3342": {
                "name": "Reflection Crystal Waypoint",
                "type": "waypoint",
                "floor": 1,
                "coord": [
                  22018.7,
                  105151
                ],
                "id": 3342,
                "chat_link": "[&BA4NAAA=]"
              }
            },
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1854": {
                "level": 0,
                "coord": [
                  22374.8,
                  104740
                ],
                "bounds": [
                  [
                    23002.5,
                    104067
                  ],
                  [
                    23114.4,
                    104560
                  ],
                  [
                    23088.7,
                    105487
                  ],
                  [
                    22923.7,
                    105576
                  ],
                  [
                    21724.4,
                    105618
                  ],
                  [
                    21504.2,
                    105470
                  ],
                  [
                    21529.7,
                    104145
                  ],
                  [
                    21723.1,
                    103898
                  ],
                  [
                    22762.5,
                    103835
                  ],
                  [
                    23002.5,
                    104067
                  ]
                ],
                "id": 1854,
                "chat_link": "[&BD4HAAA=]"
              }
            },
            "id": 1462,
            "mastery_points": [],
            "adventures": []
          },
          "1463": {
            "name": "Claiming the Isle of Reflection",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 69,
            "label_coord": [
              22250,
              104696
            ],
            "map_rect": [
              [
                -21504,
                -30720
              ],
              [
                24576,
                30720
              ]
            ],
            "continent_rect": [
              [
                21319,
                103145
              ],
              [
                23239,
                105705
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1854": {
                "level": 0,
                "coord": [
                  22374.8,
                  104740
                ],
                "bounds": [
                  [
                    23002.5,
                    104067
                  ],
                  [
                    23114.4,
                    104560
                  ],
                  [
                    23088.7,
                    105487
                  ],
                  [
                    22923.7,
                    105576
                  ],
                  [
                    21724.4,
                    105618
                  ],
                  [
                    21504.2,
                    105470
                  ],
                  [
                    21529.7,
                    104145
                  ],
                  [
                    21723.1,
                    103898
                  ],
                  [
                    22762.5,
                    103835
                  ],
                  [
                    23002.5,
                    104067
                  ]
                ],
                "id": 1854,
                "chat_link": "[&BD4HAAA=]"
              }
            },
            "id": 1463,
            "mastery_points": [],
            "adventures": []
          },
          "1464": {
            "name": "Fallout: Arborstone",
            "min_level": 80,
            "max_level": 80,
            "default_floor": 1,
            "label_coord": [
              29750,
              101210
            ],
            "map_rect": [
              [
                -46080,
                -30720
              ],
              [
                46080,
                30720
              ]
            ],
            "continent_rect": [
              [
                29185,
                100890
              ],
              [
                33025,
                103450
              ]
            ],
            "points_of_interest": {},
            "tasks": {},
            "skill_challenges": [],
            "sectors": {
              "1922": {
                "name": "Arborstone",
                "level": 80,
                "coord": [
                  29753.3,
                  101304
                ],
                "bounds": [
                  [
                    29467,
                    101237
                  ],
                  [
                    29477.3,
                    101433
                  ],
                  [
                    29697.8,
                    101641
                  ],
                  [
                    29896.8,
                    101644
                  ],
                  [
                    30003.8,
                    101605
                  ],
                  [
                    30056,
                    101554
                  ],
                  [
                    30131.4,
                    101466
                  ],
                  [
                    30132.2,
                    101351
                  ],
                  [
                    30001.1,
                    101227
                  ],
                  [
                    30001.5,
                    100975
                  ],
                  [
                    29955.5,
                    100953
                  ],
                  [
                    29253.6,
                    100953
                  ],
                  [
                    29236.5,
                    100984
                  ],
                  [
                    29235.8,
                    101227
                  ],
                  [
                    29467,
                    101237
                  ]
                ],
                "id": 1922,
                "chat_link": "[&BIIHAAA=]"
              }
            },
            "adventures": [],
            "id": 1464,
            "mastery_points": []
          }
        },
        "id": 37
      }
    },
    "id": 1
}

export default value;
